/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModule) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		0: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].e;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			e: {},
/******/ 			i: moduleId,
/******/ 			l: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.e, module, module.e, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.e;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve()
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".bundle.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		return installedChunks[chunkId][2] = promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1767);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*!
	 * jQuery JavaScript Library v2.2.1
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-02-22T19:11Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.e === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.e = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			if ( obj.constructor &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
	
			// If the function hasn't returned already, we're confident that
			// |obj| is a plain object, created by {} or constructed with new Object
			return true;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE11 only
		// In IE 11 fullscreen elements inside of an iframe have
		// 100x too small dimensions (gh-1764).
		if ( document.msFullscreenElement && window.top !== window ) {
	
			// Support: IE11 only
			// Running getBoundingClientRect on a disconnected node
			// in IE throws an error.
			if ( elem.getClientRects().length ) {
				val = Math.round( elem.getBoundingClientRect()[ name ] * 100 );
			}
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					// Support: IE<11
					// option.value not trimmed (#14858)
					return jQuery.trim( elem.value );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
								jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// But now, this "simulate" function is used only for events
					// for which stopPropagation() is noop, so there is no need for that anymore.
					//
					// For the 1.x branch though, guard for "click" and "submit"
					// events is still used, but was moved to jQuery.event.stopPropagation function
					// because `originalEvent` should point to the original event for the constancy
					// with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8+
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		context = context || ( support.createHTMLDocument ?
			document.implementation.createHTMLDocument( "" ) :
			document );
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( self, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));
	


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = __webpack_require__(1654);
	


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	var _Object$create = __webpack_require__(486)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(1280)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(487);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1320), __esModule: true };


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(490);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	 * Copyright 2016, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(1765));
	var IntlMessageFormat = _interopDefault(__webpack_require__(531));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(1479));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(52));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(1469));
	
	var babelHelpers = {};
	babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	babelHelpers.classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	babelHelpers.createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	babelHelpers.defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	babelHelpers.extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	babelHelpers.inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	babelHelpers.possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	babelHelpers.toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	babelHelpers;
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	function addLocaleData() {
	    var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var bool = React.PropTypes.bool;
	var number = React.PropTypes.number;
	var string = React.PropTypes.string;
	var func = React.PropTypes.func;
	var object = React.PropTypes.object;
	var oneOf = React.PropTypes.oneOf;
	var shape = React.PropTypes.shape;
	
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: func.isRequired,
	    formatTime: func.isRequired,
	    formatRelative: func.isRequired,
	    formatNumber: func.isRequired,
	    formatPlural: func.isRequired,
	    formatMessage: func.isRequired,
	    formatHTMLMessage: func.isRequired
	};
	
	var intlShape = shape(babelHelpers['extends']({}, intlConfigPropTypes, intlFormatPropTypes, {
	    now: func.isRequired
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: oneOf(['narrow', 'short', 'long']),
	    era: oneOf(['narrow', 'short', 'long']),
	    year: oneOf(['numeric', '2-digit']),
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: oneOf(['numeric', '2-digit']),
	    hour: oneOf(['numeric', '2-digit']),
	    minute: oneOf(['numeric', '2-digit']),
	    second: oneOf(['numeric', '2-digit']),
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(obj, whitelist) {
	    var defaults = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return whitelist.reduce(function (filtered, name) {
	        if (obj.hasOwnProperty(name)) {
	            filtered[name] = obj[name];
	        } else if (defaults.hasOwnProperty(name)) {
	            filtered[name] = defaults[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : babelHelpers['typeof'](objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : babelHelpers['typeof'](objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props;
	    var state = _ref2.state;
	    var _ref2$context = _ref2.context;
	    var context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var _context$intl = context.intl;
	    var intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl;
	    var nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames));
	}
	
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var _options$intlPropName = options.intlPropName;
	    var intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName;
	    var _options$withRef = options.withRef;
	    var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        babelHelpers.inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            babelHelpers.classCallCheck(this, InjectIntl);
	
	            var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(InjectIntl).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        babelHelpers.createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, babelHelpers['extends']({}, this.props, babelHelpers.defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    babelHelpers.classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    // When no formatting options have been specified, default to outputting a
	    // time; e.g.: "9:42 AM".
	    if (Object.keys(filteredOptions).length === 0) {
	        filteredOptions = {
	            hour: 'numeric',
	            minute: 'numeric'
	        };
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var defaults = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var values = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var messages = config.messages;
	    var defaultLocale = config.defaultLocale;
	    var defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id;
	    var defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && "production" === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	var format = Object.freeze({
	    formatDate: formatDate,
	    formatTime: formatTime,
	    formatRelative: formatRelative,
	    formatNumber: formatNumber,
	    formatPlural: formatPlural,
	    formatMessage: formatMessage,
	    formatHTMLMessage: formatHTMLMessage
	});
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    babelHelpers.inherits(IntlProvider, _Component);
	
	    function IntlProvider(props, context) {
	        babelHelpers.classCallCheck(this, IntlProvider);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(IntlProvider).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = context.intl ? context.intl.now() : Date.now();
	        }
	
	        _this.state = {
	            // Creating `Intl*` formatters is expensive so these format caches
	            // memoize the `Intl*` constructors and have the same lifecycle as
	            // this IntlProvider instance.
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat),
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        };
	        return _this;
	    }
	
	    babelHelpers.createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var _context$intl = this.context.intl;
	            var intlContext = _context$intl === undefined ? {} : _context$intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = babelHelpers['extends']({}, defaultProps, filterProps(this.props, intlConfigPropNames$1, intlContext));
	
	            if (!hasLocaleData(config.locale)) {
	                var locale = config.locale;
	                var defaultLocale = config.defaultLocale;
	                var defaultFormats = config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = babelHelpers['extends']({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            return {
	                intl: babelHelpers['extends']({}, config, boundFormatFns, {
	                    now: this.state.now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	
	IntlProvider.propTypes = babelHelpers['extends']({}, intlConfigPropTypes, {
	    children: React.PropTypes.element.isRequired,
	    initialNow: React.PropTypes.any
	});
	
	var FormattedDate = function (_Component) {
	    babelHelpers.inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        babelHelpers.classCallCheck(this, FormattedDate);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedDate).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatDate = this.context.intl.formatDate;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	
	FormattedDate.propTypes = babelHelpers['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var FormattedTime = function (_Component) {
	    babelHelpers.inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        babelHelpers.classCallCheck(this, FormattedTime);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedTime).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatTime = this.context.intl.formatTime;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	
	FormattedTime.propTypes = babelHelpers['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	var FormattedRelative = function (_Component) {
	    babelHelpers.inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        babelHelpers.classCallCheck(this, FormattedRelative);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedRelative).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            var updateInterval = props.updateInterval;
	
	            // If the `updateInterval` is falsy, including `0`, then auto updates
	            // have been turned off, so we bail and skip scheduling an update.
	
	            if (!updateInterval) {
	                return;
	            }
	
	            var time = new Date(props.value).getTime();
	            var delta = time - state.now;
	            var units = props.units || selectUnits(delta);
	
	            var unitDelay = getUnitDelay(units);
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            clearTimeout(this._timer);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatRelative = this.context.intl.formatRelative;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, babelHelpers['extends']({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	
	FormattedRelative.propTypes = babelHelpers['extends']({}, relativeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    updateInterval: React.PropTypes.number,
	    initialNow: React.PropTypes.any,
	    children: React.PropTypes.func
	});
	
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	
	var FormattedNumber = function (_Component) {
	    babelHelpers.inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        babelHelpers.classCallCheck(this, FormattedNumber);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedNumber).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatNumber = this.context.intl.formatNumber;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	
	FormattedNumber.propTypes = babelHelpers['extends']({}, numberFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var FormattedPlural = function (_Component) {
	    babelHelpers.inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        babelHelpers.classCallCheck(this, FormattedPlural);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedPlural).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatPlural = this.context.intl.formatPlural;
	            var _props = this.props;
	            var value = _props.value;
	            var other = _props.other;
	            var children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	
	FormattedPlural.propTypes = babelHelpers['extends']({}, pluralFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	
	    other: React.PropTypes.node.isRequired,
	    zero: React.PropTypes.node,
	    one: React.PropTypes.node,
	    two: React.PropTypes.node,
	    few: React.PropTypes.node,
	    many: React.PropTypes.node,
	
	    children: React.PropTypes.func
	});
	
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	
	var FormattedMessage = function (_Component) {
	    babelHelpers.inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        babelHelpers.classCallCheck(this, FormattedMessage);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.context.intl.formatMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var values = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var tokenRegexp = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                (function () {
	                    // Creates a token with a random UID that should not be guessable or
	                    // conflict with other parts of the `message` string.
	                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                    var generateToken = function () {
	                        var counter = 0;
	                        return function () {
	                            return '@__ELEMENT-' + uid + '-' + (counter += 1) + '__@';
	                        };
	                    }();
	
	                    tokenRegexp = new RegExp('(@__ELEMENT-' + uid + '-\\d+__@)', 'g');
	                    tokenizedValues = {};
	                    elements = {};
	
	                    // Iterates over the `props` to keep track of any React Element
	                    // values so they can be represented by the `token` as a placeholder
	                    // when the `message` is formatted. This allows the formatted
	                    // message to then be broken-up into parts with references to the
	                    // React Elements inserted back in.
	                    Object.keys(values).forEach(function (name) {
	                        var value = values[name];
	
	                        if (React.isValidElement(value)) {
	                            var token = generateToken();
	                            tokenizedValues[name] = token;
	                            elements[token] = value;
	                        } else {
	                            tokenizedValues[name] = value;
	                        }
	                    });
	                })();
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenRegexp).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, babelHelpers.toConsumableArray(nodes));
	            }
	
	            return React.createElement.apply(undefined, [tagName, null].concat(babelHelpers.toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedMessage.propTypes = babelHelpers['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	var FormattedHTMLMessage = function (_Component) {
	    babelHelpers.inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        babelHelpers.classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedHTMLMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatHTMLMessage = this.context.intl.formatHTMLMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var rawValues = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            return React.createElement(tagName, {
	                dangerouslySetInnerHTML: {
	                    __html: formattedHTMLMessage
	                }
	            });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedHTMLMessage.propTypes = babelHelpers['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedHTMLMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	addLocaleData(defaultLocaleData);
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys__ = __webpack_require__(1281);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(490);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_localization_store_jsx__ = __webpack_require__(375);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router___default = __WEBPACK_IMPORTED_MODULE_16_react_router__ && __WEBPACK_IMPORTED_MODULE_16_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __WEBPACK_IMPORTED_MODULE_17_react_intl__ && __WEBPACK_IMPORTED_MODULE_17_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png__ = __webpack_require__(813);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png___default = __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png__ && __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3__ = __webpack_require__(806);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3___default = __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3__ && __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_images_bing_mp3___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_images_bing_mp3___default });
	/* harmony export */ exports["isEmail"] = isEmail;/* harmony export */ exports["cleanUpUrlable"] = cleanUpUrlable;/* harmony export */ exports["isTestDomain"] = isTestDomain;/* harmony export */ exports["isChrome"] = isChrome;/* harmony export */ exports["isSafari"] = isSafari;/* harmony export */ exports["isIosChrome"] = isIosChrome;/* harmony export */ exports["isMobileApp"] = isMobileApp;/* harmony export */ exports["isInRole"] = isInRole;/* harmony export */ exports["isAdmin"] = isAdmin;/* harmony export */ exports["isSystemAdmin"] = isSystemAdmin;/* harmony export */ exports["getDomainWithOutSub"] = getDomainWithOutSub;/* harmony export */ exports["getCookie"] = getCookie;/* harmony export */ exports["notifyMe"] = notifyMe;/* harmony export */ exports["ding"] = ding;/* harmony export */ exports["getUrlParameter"] = getUrlParameter;/* harmony export */ exports["getDateForUnixTicks"] = getDateForUnixTicks;/* harmony export */ exports["displayDate"] = displayDate;/* harmony export */ exports["displayTime"] = displayTime;/* harmony export */ exports["displayTimeFormatted"] = displayTimeFormatted;/* harmony export */ exports["isMilitaryTime"] = isMilitaryTime;/* harmony export */ exports["displayDateTime"] = displayDateTime;/* harmony export */ exports["displayCommentDateTime"] = displayCommentDateTime;/* harmony export */ exports["getTimestamp"] = getTimestamp;/* harmony export */ exports["extractFirstLink"] = extractFirstLink;/* harmony export */ exports["escapeRegExp"] = escapeRegExp;/* harmony export */ exports["areObjectsEqual"] = areObjectsEqual;/* harmony export */ exports["areMapsEqual"] = areMapsEqual;/* harmony export */ exports["replaceHtmlEntities"] = replaceHtmlEntities;/* harmony export */ exports["insertHtmlEntities"] = insertHtmlEntities;/* harmony export */ exports["searchForTerm"] = searchForTerm;/* harmony export */ exports["getFileType"] = getFileType;/* harmony export */ exports["getPreviewImagePathForFileType"] = getPreviewImagePathForFileType;/* harmony export */ exports["getIconClassName"] = getIconClassName;/* harmony export */ exports["splitFileLocation"] = splitFileLocation;/* harmony export */ exports["getPreviewImagePath"] = getPreviewImagePath;/* harmony export */ exports["toTitleCase"] = toTitleCase;/* harmony export */ exports["applyTheme"] = applyTheme;/* harmony export */ exports["resetTheme"] = resetTheme;/* harmony export */ exports["applyFont"] = applyFont;/* harmony export */ exports["changeCss"] = changeCss;/* harmony export */ exports["rgb2hex"] = rgb2hex;/* harmony export */ exports["updateCodeTheme"] = updateCodeTheme;/* harmony export */ exports["placeCaretAtEnd"] = placeCaretAtEnd;/* harmony export */ exports["getCaretPosition"] = getCaretPosition;/* harmony export */ exports["setSelectionRange"] = setSelectionRange;/* harmony export */ exports["setCaretPosition"] = setCaretPosition;/* harmony export */ exports["getSelectedText"] = getSelectedText;/* harmony export */ exports["isValidUsername"] = isValidUsername;/* harmony export */ exports["isMobile"] = isMobile;/* harmony export */ exports["isComment"] = isComment;/* harmony export */ exports["getDirectTeammate"] = getDirectTeammate;/* harmony export */ exports["changeColor"] = changeColor;/* harmony export */ exports["changeOpacity"] = changeOpacity;/* harmony export */ exports["getFullName"] = getFullName;/* harmony export */ exports["getDisplayName"] = getDisplayName;/* harmony export */ exports["displayUsername"] = displayUsername;/* harmony export */ exports["getWindowLocationOrigin"] = getWindowLocationOrigin;/* harmony export */ exports["fileSizeToString"] = fileSizeToString;/* harmony export */ exports["getFileUrl"] = getFileUrl;/* harmony export */ exports["getFileName"] = getFileName;/* harmony export */ exports["getWebsocketPort"] = getWebsocketPort;/* harmony export */ exports["generateId"] = generateId;/* harmony export */ exports["isBrowserFirefox"] = isBrowserFirefox;/* harmony export */ exports["isBrowserIE"] = isBrowserIE;/* harmony export */ exports["isBrowserEdge"] = isBrowserEdge;/* harmony export */ exports["getDirectChannelName"] = getDirectChannelName;/* harmony export */ exports["getUserIdFromChannelName"] = getUserIdFromChannelName;/* harmony export */ exports["isDirectChannelForUser"] = isDirectChannelForUser;/* harmony export */ exports["importSlack"] = importSlack;/* harmony export */ exports["getTeamURLFromAddressBar"] = getTeamURLFromAddressBar;/* harmony export */ exports["getTeamNameFromUrl"] = getTeamNameFromUrl;/* harmony export */ exports["getTeamURLNoOriginFromAddressBar"] = getTeamURLNoOriginFromAddressBar;/* harmony export */ exports["getShortenedTeamURL"] = getShortenedTeamURL;/* harmony export */ exports["windowWidth"] = windowWidth;/* harmony export */ exports["windowHeight"] = windowHeight;/* harmony export */ exports["openDirectChannelToUser"] = openDirectChannelToUser;/* harmony export */ exports["sortByDisplayName"] = sortByDisplayName;/* harmony export */ exports["getChannelTerm"] = getChannelTerm;/* harmony export */ exports["getPostTerm"] = getPostTerm;/* harmony export */ exports["isFeatureEnabled"] = isFeatureEnabled;/* harmony export */ exports["isSystemMessage"] = isSystemMessage;/* harmony export */ exports["fillArray"] = fillArray;/* harmony export */ exports["isFileTransfer"] = isFileTransfer;/* harmony export */ exports["clearFileInput"] = clearFileInput;/* harmony export */ exports["isPostEphemeral"] = isPostEphemeral;/* harmony export */ exports["getRootId"] = getRootId;/* harmony export */ exports["localizeMessage"] = localizeMessage;/* harmony export */ exports["getProfilePicSrcForPost"] = getProfilePicSrcForPost;'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	
	
	
	function isEmail(email) {
	    // writing a regex to match all valid email addresses is really, really hard (see http://stackoverflow.com/a/201378)
	    // so we just do a simple check and rely on a verification email to tell if it's a real address
	    return (/^.+@.+$/.test(email)
	    );
	}
	
	function cleanUpUrlable(input) {
	    var cleaned = input.trim().replace(/-/g, ' ').replace(/[^\w\s]/gi, '').toLowerCase().replace(/\s/g, '-');
	    cleaned = cleaned.replace(/-{2,}/, '-');
	    cleaned = cleaned.replace(/^\-+/, '');
	    cleaned = cleaned.replace(/\-+$/, '');
	    return cleaned;
	}
	
	function isTestDomain() {
	    if (/^localhost/.test(window.location.hostname)) {
	        return true;
	    }
	
	    if (/^dockerhost/.test(window.location.hostname)) {
	        return true;
	    }
	
	    if (/^test/.test(window.location.hostname)) {
	        return true;
	    }
	
	    if (/^127.0./.test(window.location.hostname)) {
	        return true;
	    }
	
	    if (/^192.168./.test(window.location.hostname)) {
	        return true;
	    }
	
	    if (/^10./.test(window.location.hostname)) {
	        return true;
	    }
	
	    if (/^176./.test(window.location.hostname)) {
	        return true;
	    }
	
	    return false;
	}
	
	function isChrome() {
	    if (navigator.userAgent.indexOf('Chrome') > -1) {
	        return true;
	    }
	    return false;
	}
	
	function isSafari() {
	    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
	        return true;
	    }
	    return false;
	}
	
	function isIosChrome() {
	    // https://developer.chrome.com/multidevice/user-agent
	    return navigator.userAgent.indexOf('CriOS') !== -1;
	}
	
	function isMobileApp() {
	    var userAgent = navigator.userAgent;
	
	    // the mobile app has different user agents for the native api calls and the shim, so handle them both
	    var isApi = userAgent.indexOf('Mattermost') !== -1;
	    var isShim = userAgent.indexOf('iPhone') !== -1 && userAgent.indexOf('Safari') === -1 && userAgent.indexOf('Chrome') === -1;
	
	    return isApi || isShim;
	}
	
	function isInRole(roles, inRole) {
	    var parts = roles.split(' ');
	    for (var i = 0; i < parts.length; i++) {
	        if (parts[i] === inRole) {
	            return true;
	        }
	    }
	
	    return false;
	}
	
	function isAdmin(roles) {
	    if (isInRole(roles, 'admin')) {
	        return true;
	    }
	
	    if (isInRole(roles, 'system_admin')) {
	        return true;
	    }
	
	    return false;
	}
	
	function isSystemAdmin(roles) {
	    if (isInRole(roles, 'system_admin')) {
	        return true;
	    }
	
	    return false;
	}
	
	function getDomainWithOutSub() {
	    var parts = window.location.host.split('.');
	
	    if (parts.length === 1) {
	        if (parts[0].indexOf('dockerhost') > -1) {
	            return 'dockerhost:8065';
	        }
	
	        return 'localhost:8065';
	    }
	
	    return parts[1] + '.' + parts[2];
	}
	
	function getCookie(name) {
	    var value = '; ' + document.cookie;
	    var parts = value.split('; ' + name + '=');
	    if (parts.length === 2) {
	        return parts.pop().split(';').shift();
	    }
	    return '';
	}
	
	var requestedNotificationPermission = false;
	
	function notifyMe(title, body, channel) {
	    if (!('Notification' in window)) {
	        return;
	    }
	
	    if (Notification.permission === 'granted' || Notification.permission === 'default' && !requestedNotificationPermission) {
	        requestedNotificationPermission = true;
	
	        Notification.requestPermission(function (permission) {
	            if (permission === 'granted') {
	                try {
	                    var notification = new Notification(title, { body: body, tag: body, icon: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_images_icon50x50_png___default.a });
	                    notification.onclick = function () {
	                        window.focus();
	                        if (channel) {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["browserHistory"].push(getTeamURLNoOriginFromAddressBar() + '/channels/' + channel.name);
	                        } else {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["browserHistory"].push(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/channels/town-square');
	                        }
	                    };
	                    setTimeout(function () {
	                        notification.close();
	                    }, 5000);
	                } catch (e) {
	                    console.error(e); //eslint-disable-line no-console
	                }
	            }
	        });
	    }
	}
	
	var canDing = true;
	
	function ding() {
	    if (!isBrowserFirefox() && canDing) {
	        var audio = new Audio(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_images_bing_mp3___default.a);
	        audio.play();
	        canDing = false;
	        setTimeout(function () {
	            canDing = true;
	            return;
	        }, 3000);
	    }
	}
	
	function getUrlParameter(sParam) {
	    var sPageURL = window.location.search.substring(1);
	    var sURLVariables = sPageURL.split('&');
	    for (var i = 0; i < sURLVariables.length; i++) {
	        var sParameterName = sURLVariables[i].split('=');
	        if (sParameterName[0] === sParam) {
	            return sParameterName[1];
	        }
	    }
	    return null;
	}
	
	function getDateForUnixTicks(ticks) {
	    return new Date(ticks);
	}
	
	function displayDate(ticks) {
	    var d = new Date(ticks);
	    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	    return monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
	}
	
	function displayTime(ticks, utc) {
	    var d = new Date(ticks);
	    var hours = void 0;
	    var minutes = void 0;
	    var ampm = '';
	    var timezone = '';
	
	    if (utc) {
	        hours = d.getUTCHours();
	        minutes = d.getUTCMinutes();
	        timezone = ' UTC';
	    } else {
	        hours = d.getHours();
	        minutes = d.getMinutes();
	    }
	
	    if (minutes <= 9) {
	        minutes = '0' + minutes;
	    }
	
	    var useMilitaryTime = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_DISPLAY_SETTINGS, 'use_military_time');
	    if (!useMilitaryTime) {
	        ampm = ' AM';
	        if (hours >= 12) {
	            ampm = ' PM';
	        }
	
	        hours = hours % 12;
	        if (!hours) {
	            hours = '12';
	        }
	    }
	
	    return hours + ':' + minutes + ampm + timezone;
	}
	
	function displayTimeFormatted(ticks) {
	    var useMilitaryTime = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_DISPLAY_SETTINGS, 'use_military_time');
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedTime"], {
	        value: ticks,
	        hour: 'numeric',
	        minute: 'numeric',
	        hour12: !useMilitaryTime
	    });
	}
	
	function isMilitaryTime() {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_DISPLAY_SETTINGS, 'use_military_time');
	}
	
	function displayDateTime(ticks) {
	    var seconds = Math.floor((Date.now() - ticks) / 1000);
	
	    var interval = Math.floor(seconds / 3600);
	
	    if (interval > 24) {
	        return this.displayTime(ticks);
	    }
	
	    if (interval > 1) {
	        return interval + ' hours ago';
	    }
	
	    if (interval === 1) {
	        return interval + ' hour ago';
	    }
	
	    interval = Math.floor(seconds / 60);
	    if (interval >= 2) {
	        return interval + ' minutes ago';
	    }
	
	    if (interval >= 1) {
	        return '1 minute ago';
	    }
	
	    return 'just now';
	}
	
	function displayCommentDateTime(ticks) {
	    return displayDate(ticks) + ' ' + displayTime(ticks);
	}
	
	// returns Unix timestamp in milliseconds
	function getTimestamp() {
	    return Date.now();
	}
	
	// extracts links not styled by Markdown
	function extractFirstLink(text) {
	    var pattern = /(^|[\s\n]|<br\/?>)((?:https?|ftp):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/i;
	    var inText = text;
	
	    // strip out code blocks
	    inText = inText.replace(/`[^`]*`/g, '');
	
	    // strip out inline markdown images
	    inText = inText.replace(/!\[[^\]]*\]\([^\)]*\)/g, '');
	
	    var match = pattern.exec(inText);
	    if (match) {
	        return match[0].trim();
	    }
	
	    return '';
	}
	
	function escapeRegExp(string) {
	    return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
	}
	
	// Taken from http://stackoverflow.com/questions/1068834/object-comparison-in-javascript and modified slightly
	function areObjectsEqual(x, y) {
	    var p = void 0;
	    var leftChain = [];
	    var rightChain = [];
	
	    // Remember that NaN === NaN returns false
	    // and isNaN(undefined) returns true
	    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
	        return true;
	    }
	
	    // Compare primitives and functions.
	    // Check if both arguments link to the same object.
	    // Especially useful on step when comparing prototypes
	    if (x === y) {
	        return true;
	    }
	
	    // Works in case when functions are created in constructor.
	    // Comparing dates is a common scenario. Another built-ins?
	    // We can even handle functions passed across iframes
	    if (typeof x === 'function' && typeof y === 'function' || x instanceof Date && y instanceof Date || x instanceof RegExp && y instanceof RegExp || x instanceof String && y instanceof String || x instanceof Number && y instanceof Number) {
	        return x.toString() === y.toString();
	    }
	
	    if (x instanceof /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a && y instanceof /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a) {
	        return areMapsEqual(x, y);
	    }
	
	    // At last checking prototypes as good a we can
	    if (!(x instanceof Object && y instanceof Object)) {
	        return false;
	    }
	
	    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
	        return false;
	    }
	
	    if (x.constructor !== y.constructor) {
	        return false;
	    }
	
	    if (x.prototype !== y.prototype) {
	        return false;
	    }
	
	    // Check for infinitive linking loops
	    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
	        return false;
	    }
	
	    // Quick checking of one object beeing a subset of another.
	    for (p in y) {
	        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
	            return false;
	        } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default.a.bind()(y[p]) !== /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default.a.bind()(x[p])) {
	            return false;
	        }
	    }
	
	    for (p in x) {
	        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
	            return false;
	        } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default.a.bind()(y[p]) !== /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default.a.bind()(x[p])) {
	            return false;
	        }
	
	        switch (/* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default.a.bind()(x[p])) {
	            case 'object':
	            case 'function':
	
	                leftChain.push(x);
	                rightChain.push(y);
	
	                if (!areObjectsEqual(x[p], y[p])) {
	                    return false;
	                }
	
	                leftChain.pop();
	                rightChain.pop();
	                break;
	
	            default:
	                if (x[p] !== y[p]) {
	                    return false;
	                }
	                break;
	        }
	    }
	
	    return true;
	}
	
	function areMapsEqual(a, b) {
	    if (a.size !== b.size) {
	        return false;
	    }
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(a), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	            var key = _step$value[0];
	            var value = _step$value[1];
	
	            if (!b.has(key)) {
	                return false;
	            }
	
	            if (!areObjectsEqual(value, b.get(key))) {
	                return false;
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return true;
	}
	
	function replaceHtmlEntities(text) {
	    var tagsToReplace = {
	        '&amp;': '&',
	        '&lt;': '<',
	        '&gt;': '>'
	    };
	    var newtext = text;
	    for (var tag in tagsToReplace) {
	        if ({}.hasOwnProperty.call(tagsToReplace, tag)) {
	            var regex = new RegExp(tag, 'g');
	            newtext = newtext.replace(regex, tagsToReplace[tag]);
	        }
	    }
	    return newtext;
	}
	
	function insertHtmlEntities(text) {
	    var tagsToReplace = {
	        '&': '&amp;',
	        '<': '&lt;',
	        '>': '&gt;'
	    };
	    var newtext = text;
	    for (var tag in tagsToReplace) {
	        if ({}.hasOwnProperty.call(tagsToReplace, tag)) {
	            var regex = new RegExp(tag, 'g');
	            newtext = newtext.replace(regex, tagsToReplace[tag]);
	        }
	    }
	    return newtext;
	}
	
	function searchForTerm(term) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.RECEIVED_SEARCH_TERM,
	        term: term,
	        do_search: true
	    });
	}
	
	function getFileType(extin) {
	    var ext = extin.toLowerCase();
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].IMAGE_TYPES.indexOf(ext) > -1) {
	        return 'image';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].AUDIO_TYPES.indexOf(ext) > -1) {
	        return 'audio';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].VIDEO_TYPES.indexOf(ext) > -1) {
	        return 'video';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].SPREADSHEET_TYPES.indexOf(ext) > -1) {
	        return 'spreadsheet';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].CODE_TYPES.indexOf(ext) > -1) {
	        return 'code';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].WORD_TYPES.indexOf(ext) > -1) {
	        return 'word';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PRESENTATION_TYPES.indexOf(ext) > -1) {
	        return 'presentation';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PDF_TYPES.indexOf(ext) > -1) {
	        return 'pdf';
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PATCH_TYPES.indexOf(ext) > -1) {
	        return 'patch';
	    }
	
	    return 'other';
	}
	
	function getPreviewImagePathForFileType(fileTypeIn) {
	    var fileType = fileTypeIn.toLowerCase();
	
	    var icon;
	    if (fileType in /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ICON_FROM_TYPE) {
	        icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ICON_FROM_TYPE[fileType];
	    } else {
	        icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ICON_FROM_TYPE.other;
	    }
	
	    return icon;
	}
	
	function getIconClassName(fileTypeIn) {
	    var fileType = fileTypeIn.toLowerCase();
	
	    if (fileType in /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ICON_NAME_FROM_TYPE) {
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ICON_NAME_FROM_TYPE[fileType];
	    }
	
	    return 'glyphicon-file';
	}
	
	function splitFileLocation(fileLocation) {
	    var fileSplit = fileLocation.split('.');
	
	    var ext = '';
	    if (fileSplit.length > 1) {
	        ext = fileSplit[fileSplit.length - 1];
	        fileSplit.splice(fileSplit.length - 1, 1);
	    }
	
	    var filePath = fileSplit.join('.');
	    var filename = filePath.split('/')[filePath.split('/').length - 1];
	
	    return { ext: ext, name: filename, path: filePath };
	}
	
	function getPreviewImagePath(filename) {
	    // Returns the path to a preview image that can be used to represent a file.
	    var fileInfo = splitFileLocation(filename);
	    var fileType = getFileType(fileInfo.ext);
	
	    if (fileType === 'image') {
	        return getFileUrl(fileInfo.path + '_preview.jpg');
	    }
	
	    // only images have proper previews, so just use a placeholder icon for non-images
	    return getPreviewImagePathForFileType(fileType);
	}
	
	function toTitleCase(str) {
	    function doTitleCase(txt) {
	        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	    }
	    return str.replace(/\w\S*/g, doTitleCase);
	}
	
	function applyTheme(theme) {
	    if (theme.sidebarBg) {
	        changeCss('.app__body .sidebar--left, .app__body .sidebar--left .sidebar__divider .sidebar__divider__text, .app__body .modal .settings-modal .settings-table .settings-links, .app__body .sidebar--menu', 'background:' + theme.sidebarBg, 1);
	        changeCss('body.app__body', 'scrollbar-face-color:' + theme.sidebarBg, 3);
	    }
	
	    if (theme.sidebarText) {
	        changeCss('.app__body .sidebar--left .nav-pills__container li>a, .app__body .sidebar--right, .app__body .modal .settings-modal .nav-pills>li a, .app__body .sidebar--menu', 'color:' + changeOpacity(theme.sidebarText, 0.6), 1);
	        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>a', 'color:' + theme.sidebarText, 1);
	        changeCss('.app__body .sidebar--left .nav-pills__container li>h4, .app__body .sidebar--left .add-channel-btn', 'color:' + changeOpacity(theme.sidebarText, 0.6), 1);
	        changeCss('.app__body .sidebar--left .add-channel-btn:hover, .app__body .sidebar--left .add-channel-btn:focus', 'color:' + theme.sidebarText, 1);
	        changeCss('.app__body .sidebar--left .status .offline--icon, .app__body .sidebar--left .status .offline--icon', 'fill:' + theme.sidebarText, 1);
	        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li>a', 'border-color:' + changeOpacity(theme.sidebarText, 0.2), 2);
	    }
	
	    if (theme.sidebarUnreadText) {
	        changeCss('.app__body .sidebar--left .nav-pills__container li>a.unread-title', 'color:' + theme.sidebarUnreadText + '!important;', 2);
	    }
	
	    if (theme.sidebarTextHoverBg) {
	        changeCss('.app__body .sidebar--left .nav-pills__container li>a:hover, .app__body .sidebar--left .nav-pills__container li>a:focus, .app__body .modal .settings-modal .nav-pills>li:hover a, .app__body .modal .settings-modal .nav-pills>li:focus a', 'background:' + theme.sidebarTextHoverBg, 1);
	        changeCss('@media(max-width: 768px){.app__body .modal .settings-modal .settings-table .nav>li:hover a', 'background:' + theme.sidebarTextHoverBg, 1);
	    }
	
	    if (theme.sidebarTextActiveBorder) {
	        changeCss('.app__body .sidebar--left .nav li.active a:before, .app__body .modal .settings-modal .nav-pills>li.active a:before', 'background:' + theme.sidebarTextActiveBorder, 1);
	        changeCss('.app__body .sidebar--left .sidebar__divider:before', 'background:' + changeOpacity(theme.sidebarTextActiveBorder, 0.5), 1);
	        changeCss('.app__body .sidebar--left .sidebar__divider', 'color:' + theme.sidebarTextActiveBorder, 1);
	    }
	
	    if (theme.sidebarTextActiveColor) {
	        changeCss('.app__body .sidebar--left .nav-pills__container li.active a, .app__body .sidebar--left .nav-pills__container li.active a:hover, .app__body .sidebar--left .nav-pills__container li.active a:focus, .app__body .modal .settings-modal .nav-pills>li.active a, .app__body .modal .settings-modal .nav-pills>li.active a:hover, .app__body .modal .settings-modal .nav-pills>li.active a:active', 'color:' + theme.sidebarTextActiveColor, 2);
	        changeCss('.app__body .sidebar--left .nav li.active a, .app__body .sidebar--left .nav li.active a:hover, .app__body .sidebar--left .nav li.active a:focus', 'background:' + changeOpacity(theme.sidebarTextActiveColor, 0.1), 1);
	    }
	
	    if (theme.sidebarHeaderBg) {
	        changeCss('.app__body .sidebar--left .team__header, .app__body .sidebar--menu .team__header, .app__body .post-list__timestamp > div', 'background:' + theme.sidebarHeaderBg, 1);
	        changeCss('.app__body .modal .modal-header', 'background:' + theme.sidebarHeaderBg, 1);
	        changeCss('.app__body #navbar .navbar-default', 'background:' + theme.sidebarHeaderBg, 1);
	        changeCss('@media(max-width: 768px){.app__body .search-bar__container', 'background:' + theme.sidebarHeaderBg, 1);
	        changeCss('.app__body .attachment .attachment__container', 'border-left-color:' + theme.sidebarHeaderBg, 1);
	    }
	
	    if (theme.sidebarHeaderTextColor) {
	        changeCss('.app__body .sidebar--left .team__header .header__info, .app__body .sidebar--menu .team__header .header__info, .app__body .post-list__timestamp > div', 'color:' + theme.sidebarHeaderTextColor, 1);
	        changeCss('.app__body .sidebar--left .team__header .navbar-right .dropdown__icon, .app__body .sidebar--menu .team__header .navbar-right .dropdown__icon', 'fill:' + theme.sidebarHeaderTextColor, 1);
	        changeCss('.app__body .sidebar--left .team__header .user__name, .app__body .sidebar--menu .team__header .user__name', 'color:' + changeOpacity(theme.sidebarHeaderTextColor, 0.8), 1);
	        changeCss('.app__body .sidebar--left .team__header:hover .user__name, .app__body .sidebar--menu .team__header:hover .user__name', 'color:' + theme.sidebarHeaderTextColor, 1);
	        changeCss('.app__body .modal .modal-header .modal-title, .app__body .modal .modal-header .modal-title .name, .app__body .modal .modal-header button.close', 'color:' + theme.sidebarHeaderTextColor, 1);
	        changeCss('.app__body #navbar .navbar-default .navbar-brand .heading', 'color:' + theme.sidebarHeaderTextColor, 1);
	        changeCss('.app__body #navbar .navbar-default .navbar-toggle .icon-bar, ', 'background:' + theme.sidebarHeaderTextColor, 1);
	        changeCss('@media(max-width: 768px){.app__body .search-bar__container', 'color:' + theme.sidebarHeaderTextColor, 2);
	    }
	
	    if (theme.onlineIndicator) {
	        changeCss('.app__body .sidebar--left .status .online--icon', 'fill:' + theme.onlineIndicator, 1);
	    }
	
	    if (theme.awayIndicator) {
	        changeCss('.app__body .sidebar--left .status .away--icon', 'fill:' + theme.awayIndicator, 1);
	    }
	
	    if (theme.mentionBj) {
	        changeCss('.app__body .sidebar--left .nav-pills__unread-indicator', 'background:' + theme.mentionBj, 1);
	        changeCss('.app__body .sidebar--left .badge', 'background:' + theme.mentionBj + '!important;', 1);
	    }
	
	    if (theme.mentionColor) {
	        changeCss('.app__body .sidebar--left .nav-pills__unread-indicator', 'color:' + theme.mentionColor, 2);
	        changeCss('.app__body .sidebar--left .badge', 'color:' + theme.mentionColor + '!important;', 2);
	    }
	
	    if (theme.centerChannelBg) {
	        changeCss('.app__body .app__content, .app__body .markdown__table, .app__body .markdown__table tbody tr, .app__body .suggestion-list__content, .app__body .modal .modal-content', 'background:' + theme.centerChannelBg, 1);
	        changeCss('#post-list .post-list-holder-by-time', 'background:' + theme.centerChannelBg, 1);
	        changeCss('#post-create', 'background:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .date-separator .separator__text, .app__body .new-separator .separator__text', 'background:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .post-image__details, .app__body .search-help-popover .search-autocomplete__divider span', 'background:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .sidebar--right, .app__body .dropdown-menu, .app__body .popover, .app__body .tip-overlay', 'background:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .popover.bottom>.arrow:after', 'border-bottom-color:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .popover.right>.arrow:after, .app__body .tip-overlay.tip-overlay--sidebar .arrow, .app__body .tip-overlay.tip-overlay--header .arrow', 'border-right-color:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .popover.left>.arrow:after', 'border-left-color:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .popover.top>.arrow:after, .app__body .tip-overlay.tip-overlay--chat .arrow', 'border-top-color:' + theme.centerChannelBg, 1);
	        changeCss('@media(min-width: 768px){.app__body .search-bar__container .search__form .search-bar, .app__body .form-control', 'background:' + theme.centerChannelBg, 1);
	        changeCss('.app__body .attachment__content', 'background:' + theme.centerChannelBg, 1);
	        changeCss('body.app__body', 'scrollbar-face-color:' + theme.centerChannelBg, 2);
	        changeCss('body.app__body', 'scrollbar-track-color:' + theme.centerChannelBg, 2);
	        changeCss('.app__body .post-list__new-messages-below', 'color:' + theme.centerChannelBg, 1);
	    }
	
	    if (theme.centerChannelColor) {
	        changeCss('.app__body .post-list__arrows', 'fill:' + changeOpacity(theme.centerChannelColor, 0.3), 1);
	        changeCss('.app__body .sidebar--left, .app__body .sidebar--right .sidebar--right__header, .app__body .suggestion-list__content .command', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .app__content, .app__body .post-create__container .post-create-body .btn-file, .app__body .post-create__container .post-create-footer .msg-typing, .app__body .suggestion-list__content .command, .app__body .modal .modal-content, .app__body .dropdown-menu, .app__body .popover, .app__body .mentions__name, .app__body .tip-overlay', 'color:' + theme.centerChannelColor, 1);
	        changeCss('.app__body #archive-link-home', 'background:' + changeOpacity(theme.centerChannelColor, 0.15), 1);
	        changeCss('.app__body #post-create', 'color:' + theme.centerChannelColor, 2);
	        changeCss('.app__body .mentions--top, .app__body .suggestion-list', 'box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px', 3);
	        changeCss('.app__body .mentions--top, .app__body .suggestion-list', '-webkit-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px', 2);
	        changeCss('.app__body .mentions--top, .app__body .suggestion-list', '-moz-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.2) + ' 1px -3px 12px', 1);
	        changeCss('.app__body .dropdown-menu, .app__body .popover ', 'box-shadow:' + changeOpacity(theme.centerChannelColor, 0.1) + ' 0px 6px 12px', 3);
	        changeCss('.app__body .dropdown-menu, .app__body .popover ', '-webkit-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.1) + ' 0px 6px 12px', 2);
	        changeCss('.app__body .dropdown-menu, .app__body .popover ', '-moz-box-shadow:' + changeOpacity(theme.centerChannelColor, 0.1) + ' 0px 6px 12px', 1);
	        changeCss('.app__body .post__body hr, .app__body .loading-screen .loading__content .round, .app__body .tutorial__circles .circle', 'background:' + theme.centerChannelColor, 1);
	        changeCss('.app__body .channel-header .heading', 'color:' + theme.centerChannelColor, 1);
	        changeCss('.app__body .markdown__table tbody tr:nth-child(2n)', 'background:' + changeOpacity(theme.centerChannelColor, 0.07), 1);
	        changeCss('.app__body .channel-header__info>div.dropdown .header-dropdown__icon', 'color:' + changeOpacity(theme.centerChannelColor, 0.8), 1);
	        changeCss('.app__body .channel-header #member_popover', 'color:' + changeOpacity(theme.centerChannelColor, 0.8), 1);
	        changeCss('.app__body .custom-textarea, .app__body .custom-textarea:focus, .app__body .file-preview, .app__body .post-image__details, .app__body .sidebar--right .sidebar-right__body, .app__body .markdown__table th, .app__body .markdown__table td, .app__body .suggestion-list__content, .app__body .modal .modal-content, .app__body .modal .settings-modal .settings-table .settings-content .divider-light, .app__body .webhooks__container, .app__body .dropdown-menu, .app__body .modal .modal-header, .app__body .popover', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .popover.bottom>.arrow', 'border-bottom-color:' + changeOpacity(theme.centerChannelColor, 0.25), 1);
	        changeCss('.app__body .search-help-popover .search-autocomplete__divider span', 'color:' + changeOpacity(theme.centerChannelColor, 0.7), 1);
	        changeCss('.app__body .popover.right>.arrow', 'border-right-color:' + changeOpacity(theme.centerChannelColor, 0.25), 1);
	        changeCss('.app__body .popover.left>.arrow', 'border-left-color:' + changeOpacity(theme.centerChannelColor, 0.25), 1);
	        changeCss('.app__body .popover.top>.arrow', 'border-top-color:' + changeOpacity(theme.centerChannelColor, 0.25), 1);
	        changeCss('.app__body .suggestion-list__content .command, .app__body .popover .popover-title', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .dropdown-menu .divider, .app__body .search-help-popover .search-autocomplete__divider:before', 'background:' + theme.centerChannelColor, 1);
	        changeCss('.app__body .custom-textarea', 'color:' + theme.centerChannelColor, 1);
	        changeCss('.app__body .post-image__column', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 2);
	        changeCss('.app__body .post-image__details', 'color:' + theme.centerChannelColor, 2);
	        changeCss('.app__body .post-image__column a, .app__body .post-image__column a:hover, .app__body .post-image__column a:focus', 'color:' + theme.centerChannelColor, 1);
	        changeCss('@media(min-width: 768px){.app__body .search-bar__container .search__form .search-bar, .app__body .form-control', 'color:' + theme.centerChannelColor, 2);
	        changeCss('.app__body .input-group-addon, .app__body .search-bar__container .search__form, .app__body .form-control', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .form-control:focus', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3), 1);
	        changeCss('.app__body .attachment .attachment__content', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3), 1);
	        changeCss('.app__body .channel-intro .channel-intro__content, .app__body .webhooks__container', 'background:' + changeOpacity(theme.centerChannelColor, 0.05), 1);
	        changeCss('.app__body .date-separator .separator__text', 'color:' + theme.centerChannelColor, 2);
	        changeCss('.app__body .date-separator .separator__hr, .app__body .modal-footer, .app__body .modal .custom-textarea', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .search-item-container, .app__body .post-right__container .post.post--root', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1), 1);
	        changeCss('.app__body .modal .custom-textarea:focus', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.3), 1);
	        changeCss('.app__body .channel-intro, .app__body .modal .settings-modal .settings-table .settings-content .divider-dark, .app__body hr, .app__body .modal .settings-modal .settings-table .settings-links, .app__body .modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .post.current--user .post__body, .app__body .post.post--comment.other--root.current--user .post-comment, .app__body pre, .app__body .post-right__container .post.post--root', 'background:' + changeOpacity(theme.centerChannelColor, 0.07), 1);
	        changeCss('.app__body .post.post--comment.other--root.current--user .post-comment, .app__body .more-modal__list .more-modal__row, .app__body .member-div:first-child, .app__body .member-div, .app__body .access-history__table .access__report, .app__body .activity-log__table', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.1), 2);
	        changeCss('@media(max-width: 1800px){.app__body .inner-wrap.move--left .post.post--comment.same--root', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.07), 2);
	        changeCss('.app__body .post:hover, .app__body .more-modal__list .more-modal__row:hover, .app__body .modal .settings-modal .settings-table .settings-content .section-min:hover', 'background:' + changeOpacity(theme.centerChannelColor, 0.07), 1);
	        changeCss('.app__body .date-separator.hovered--before:after, .app__body .date-separator.hovered--after:before, .app__body .new-separator.hovered--after:before, .app__body .new-separator.hovered--before:after', 'background:' + changeOpacity(theme.centerChannelColor, 0.07), 1);
	        changeCss('.app__body .suggestion-list__content .command:hover, .app__body .mentions__name:hover, .app__body .suggestion--selected, .app__body .dropdown-menu>li>a:focus, .app__body .dropdown-menu>li>a:hover, .app__body .bot-indicator', 'background:' + changeOpacity(theme.centerChannelColor, 0.15), 1);
	        changeCss('code, .app__body .form-control[disabled], .app__body .form-control[readonly], .app__body fieldset[disabled] .form-control', 'background:' + changeOpacity(theme.centerChannelColor, 0.1), 1);
	        changeCss('@media(min-width: 960px){.app__body .post.current--user:hover .post__body ', 'background: none;', 1);
	        changeCss('.app__body .sidebar--right', 'color:' + theme.centerChannelColor, 2);
	        changeCss('.app__body .search-help-popover .search-autocomplete__item:hover, .app__body .modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body', 'background:' + changeOpacity(theme.centerChannelColor, 0.05), 1);
	        changeCss('.app__body .search-help-popover .search-autocomplete__item.selected', 'background:' + changeOpacity(theme.centerChannelColor, 0.15), 1);
	        changeCss('::-webkit-scrollbar-thumb', 'background:' + changeOpacity(theme.centerChannelColor, 0.4), 1);
	        changeCss('body', 'scrollbar-arrow-color:' + theme.centerChannelColor, 4);
	        changeCss('.app__body .modal .about-modal .about-modal__logo svg, .app__body .post .post__img svg', 'fill:' + theme.centerChannelColor, 1);
	        changeCss('.app__body .scrollbar--horizontal, .app__body .scrollbar--vertical', 'background:' + changeOpacity(theme.centerChannelColor, 0.5), 2);
	        changeCss('.app__body .post-list__new-messages-below', 'background:' + changeColor(theme.centerChannelColor, 0.5), 2);
	        changeCss('.app__body .post.post--comment .post__body', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.2), 1);
	        changeCss('.app__body .post.post--comment.current--user .post__body', 'border-color:' + changeOpacity(theme.centerChannelColor, 0.13), 1);
	    }
	
	    if (theme.newMessageSeparator) {
	        changeCss('.app__body .new-separator .separator__text', 'color:' + theme.newMessageSeparator, 1);
	        changeCss('.app__body .new-separator .separator__hr', 'border-color:' + changeOpacity(theme.newMessageSeparator, 0.5), 1);
	    }
	
	    if (theme.linkColor) {
	        changeCss('.app__body a, .app__body a:focus, .app__body a:hover, .app__body .btn, .app__body .btn:focus, .app__body .btn:hover', 'color:' + theme.linkColor, 1);
	        changeCss('.app__body .post .comment-icon__container, .app__body .post .post__reply', 'fill:' + theme.linkColor, 1);
	    }
	
	    if (theme.buttonBg) {
	        changeCss('.app__body .btn.btn-primary, .app__body .tutorial__circles .circle.active', 'background:' + theme.buttonBg, 1);
	        changeCss('.app__body .btn.btn-primary:hover, .app__body .btn.btn-primary:active, .app__body .btn.btn-primary:focus', 'background:' + changeColor(theme.buttonBg, -0.25), 1);
	    }
	
	    if (theme.buttonColor) {
	        changeCss('.app__body .btn.btn-primary', 'color:' + theme.buttonColor, 2);
	    }
	
	    if (theme.mentionHighlightBg) {
	        changeCss('.app__body .mention--highlight, .app__body .search-highlight', 'background:' + theme.mentionHighlightBg, 1);
	    }
	
	    if (theme.mentionHighlightBg) {
	        changeCss('.app__body .post.post--highlight', 'background:' + changeOpacity(theme.mentionHighlightBg, 0.5), 1);
	    }
	
	    if (theme.mentionHighlightLink) {
	        changeCss('.app__body .mention--highlight .mention-link, .app__body .mention--highlight, .app__body .search-highlight', 'color:' + theme.mentionHighlightLink, 1);
	    }
	
	    if (!theme.codeTheme) {
	        theme.codeTheme = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].DEFAULT_CODE_THEME;
	    }
	    updateCodeTheme(theme.codeTheme);
	}
	
	function resetTheme() {
	    applyTheme(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].THEMES.default);
	}
	
	function applyFont(fontName) {
	    var body = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body');
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_own_keys___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FONTS)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var key = _step2.value;
	
	            var className = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FONTS[key];
	
	            if (fontName === key) {
	                if (!body.hasClass(className)) {
	                    body.addClass(className);
	                }
	            } else {
	                body.removeClass(className);
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	}
	
	function changeCss(className, classValue, classRepeat) {
	    // we need invisible container to store additional css definitions
	    var cssMainContainer = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#css-modifier-container');
	    if (cssMainContainer.length === 0) {
	        cssMainContainer = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('<div id="css-modifier-container"></div>');
	        cssMainContainer.hide();
	        cssMainContainer.appendTo(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body'));
	    }
	
	    // and we need one div for each class
	    var classContainer = cssMainContainer.find('div[data-class="' + className + classRepeat + '"]');
	    if (classContainer.length === 0) {
	        classContainer = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('<div data-class="' + className + classRepeat + '"></div>');
	        classContainer.appendTo(cssMainContainer);
	    }
	
	    // append additional style
	    classContainer.html('<style>' + className + ' {' + classValue + '}</style>');
	}
	
	function rgb2hex(rgbIn) {
	    if (/^#[0-9A-F]{6}$/i.test(rgbIn)) {
	        return rgbIn;
	    }
	
	    var rgb = rgbIn.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
	    function hex(x) {
	        return ('0' + parseInt(x, 10).toString(16)).slice(-2);
	    }
	    return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
	}
	
	function updateCodeTheme(userTheme) {
	    var cssPath = '';
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].THEME_ELEMENTS.forEach(function (element) {
	        if (element.id === 'codeTheme') {
	            element.themes.forEach(function (theme) {
	                if (userTheme === theme.id) {
	                    cssPath = theme.cssURL;
	                    return;
	                }
	            });
	        }
	    });
	    var $link = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('link.code_theme');
	    if (cssPath !== $link.attr('href')) {
	        changeCss('code.hljs', 'visibility: hidden');
	        var xmlHTTP = new XMLHttpRequest();
	        xmlHTTP.open('GET', cssPath, true);
	        xmlHTTP.onload = function onLoad() {
	            $link.attr('href', cssPath);
	            if (isBrowserFirefox()) {
	                $link.one('load', function () {
	                    changeCss('code.hljs', 'visibility: visible');
	                });
	            } else {
	                changeCss('code.hljs', 'visibility: visible');
	            }
	        };
	        xmlHTTP.send();
	    }
	}
	
	function placeCaretAtEnd(el) {
	    el.focus();
	    el.selectionStart = el.value.length;
	    el.selectionEnd = el.value.length;
	
	    return;
	}
	
	function getCaretPosition(el) {
	    if (el.selectionStart) {
	        return el.selectionStart;
	    } else if (document.selection) {
	        el.focus();
	
	        var r = document.selection.createRange();
	        if (r == null) {
	            return 0;
	        }
	
	        var re = el.createTextRange();
	        var rc = re.duplicate();
	        re.moveToBookmark(r.getBookmark());
	        rc.setEndPoint('EndToStart', re);
	
	        return rc.text.length;
	    }
	    return 0;
	}
	
	function setSelectionRange(input, selectionStart, selectionEnd) {
	    if (input.setSelectionRange) {
	        input.focus();
	        input.setSelectionRange(selectionStart, selectionEnd);
	    } else if (input.createTextRange) {
	        var range = input.createTextRange();
	        range.collapse(true);
	        range.moveEnd('character', selectionEnd);
	        range.moveStart('character', selectionStart);
	        range.select();
	    }
	}
	
	function setCaretPosition(input, pos) {
	    setSelectionRange(input, pos, pos);
	}
	
	function getSelectedText(input) {
	    var selectedText;
	    if (typeof document.selection !== 'undefined') {
	        input.focus();
	        var sel = document.selection.createRange();
	        selectedText = sel.text;
	    } else if (typeof input.selectionStart !== 'undefined') {
	        var startPos = input.selectionStart;
	        var endPos = input.selectionEnd;
	        selectedText = input.value.substring(startPos, endPos);
	    }
	
	    return selectedText;
	}
	
	function isValidUsername(name) {
	    var error = '';
	    if (!name) {
	        error = 'This field is required';
	    } else if (name.length < /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].MIN_USERNAME_LENGTH || name.length > /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH) {
	        error = 'Must be between ' + /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].MIN_USERNAME_LENGTH + ' and ' + /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH + ' characters';
	    } else if (!/^[a-z0-9\.\-\_]+$/.test(name)) {
	        error = "Must contain only letters, numbers, and the symbols '.', '-', and '_'.";
	    } else if (!/[a-z]/.test(name.charAt(0))) {
	        //eslint-disable-line no-negated-condition
	        error = 'First character must be a letter.';
	    } else {
	        for (var i = 0; i < /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].RESERVED_USERNAMES.length; i++) {
	            if (name === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].RESERVED_USERNAMES[i]) {
	                error = 'Cannot use a reserved word as a username.';
	                break;
	            }
	        }
	    }
	
	    return error;
	}
	
	function isMobile() {
	    return window.innerWidth <= 768;
	}
	
	function isComment(post) {
	    if ('root_id' in post) {
	        return post.root_id !== '' && post.root_id != null;
	    }
	    return false;
	}
	
	function getDirectTeammate(channelId) {
	    var userIds = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].get(channelId).name.split('__');
	    var curUserId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentId();
	    var teammate = {};
	
	    if (userIds.length !== 2 || userIds.indexOf(curUserId) === -1) {
	        return teammate;
	    }
	
	    for (var idx in userIds) {
	        if (userIds[idx] !== curUserId) {
	            teammate = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getProfile(userIds[idx]);
	            break;
	        }
	    }
	
	    return teammate;
	}
	
	Image.prototype.load = function imageLoad(url, progressCallback) {
	    var self = this;
	    var xmlHTTP = new XMLHttpRequest();
	    xmlHTTP.open('GET', url, true);
	    xmlHTTP.responseType = 'arraybuffer';
	    xmlHTTP.onload = function onLoad() {
	        var h = xmlHTTP.getAllResponseHeaders();
	        var m = h.match(/^Content-Type\:\s*(.*?)$/mi);
	        var mimeType = m[1] || 'image/png';
	
	        var blob = new Blob([this.response], { type: mimeType });
	        self.src = window.URL.createObjectURL(blob);
	    };
	    xmlHTTP.onprogress = function onprogress(e) {
	        parseInt(self.completedPercentage = e.loaded / e.total * 100, 10);
	        if (progressCallback) {
	            progressCallback();
	        }
	    };
	    xmlHTTP.onloadstart = function onloadstart() {
	        self.completedPercentage = 0;
	    };
	    xmlHTTP.send();
	};
	
	Image.prototype.completedPercentage = 0;
	
	function changeColor(colourIn, amt) {
	    var hex = colourIn;
	    var lum = amt;
	
	    // validate hex string
	    hex = String(hex).replace(/[^0-9a-f]/gi, '');
	    if (hex.length < 6) {
	        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	    }
	    lum = lum || 0;
	
	    // convert to decimal and change luminosity
	    var rgb = '#';
	    var c;
	    var i;
	    for (i = 0; i < 3; i++) {
	        c = parseInt(hex.substr(i * 2, 2), 16);
	        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	        rgb += ('00' + c).substr(c.length);
	    }
	
	    return rgb;
	}
	
	function changeOpacity(oldColor, opacity) {
	    var color = oldColor;
	    if (color[0] === '#') {
	        color = color.slice(1);
	    }
	
	    if (color.length === 3) {
	        var tempColor = color;
	        color = '';
	
	        color += tempColor[0] + tempColor[0];
	        color += tempColor[1] + tempColor[1];
	        color += tempColor[2] + tempColor[2];
	    }
	
	    var r = parseInt(color.substring(0, 2), 16);
	    var g = parseInt(color.substring(2, 4), 16);
	    var b = parseInt(color.substring(4, 6), 16);
	
	    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
	}
	
	function getFullName(user) {
	    if (user.first_name && user.last_name) {
	        return user.first_name + ' ' + user.last_name;
	    } else if (user.first_name) {
	        return user.first_name;
	    } else if (user.last_name) {
	        return user.last_name;
	    }
	
	    return '';
	}
	
	function getDisplayName(user) {
	    if (user.nickname && user.nickname.trim().length > 0) {
	        return user.nickname;
	    }
	    var fullName = getFullName(user);
	
	    if (fullName) {
	        return fullName;
	    }
	
	    return user.username;
	}
	
	function displayUsername(userId) {
	    var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getProfile(userId);
	    var nameFormat = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].get(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_DISPLAY_SETTINGS, 'name_format', 'false');
	
	    var username = '';
	    if (user) {
	        if (nameFormat === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.DISPLAY_PREFER_NICKNAME) {
	            username = user.nickname || getFullName(user);
	        } else if (nameFormat === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.DISPLAY_PREFER_FULL_NAME) {
	            username = getFullName(user);
	        }
	        if (!username.trim().length) {
	            username = user.username;
	        }
	    }
	
	    return username;
	}
	
	//IE10 does not set window.location.origin automatically so this must be called instead when using it
	function getWindowLocationOrigin() {
	    var windowLocationOrigin = window.location.origin;
	    if (!windowLocationOrigin) {
	        windowLocationOrigin = window.location.protocol + '//' + window.location.hostname;
	        if (window.location.port) {
	            windowLocationOrigin += ':' + window.location.port;
	        }
	    }
	    return windowLocationOrigin;
	}
	
	// Converts a file size in bytes into a human-readable string of the form '123MB'.
	function fileSizeToString(bytes) {
	    // it's unlikely that we'll have files bigger than this
	    if (bytes > 1024 * 1024 * 1024 * 1024) {
	        return Math.floor(bytes / (1024 * 1024 * 1024 * 1024)) + 'TB';
	    } else if (bytes > 1024 * 1024 * 1024) {
	        return Math.floor(bytes / (1024 * 1024 * 1024)) + 'GB';
	    } else if (bytes > 1024 * 1024) {
	        return Math.floor(bytes / (1024 * 1024)) + 'MB';
	    } else if (bytes > 1024) {
	        return Math.floor(bytes / 1024) + 'KB';
	    }
	
	    return bytes + 'B';
	}
	
	// Converts a filename (like those attached to Post objects) to a url that can be used to retrieve attachments from the server.
	function getFileUrl(filename) {
	    return getWindowLocationOrigin() + /* harmony import */__WEBPACK_IMPORTED_MODULE_14__web_client_jsx__["a"].getFilesRoute() + '/get' + filename;
	}
	
	// Gets the name of a file (including extension) from a given url or file path.
	function getFileName(path) {
	    var split = path.split('/');
	    return split[split.length - 1];
	}
	
	// Gets the websocket port to use. Configurable on the server.
	function getWebsocketPort(protocol) {
	    if (/^wss:/.test(protocol)) {
	        // wss://
	        return ':' + global.window.mm_config.WebsocketSecurePort;
	    }
	    if (/^ws:/.test(protocol)) {
	        return ':' + global.window.mm_config.WebsocketPort;
	    }
	    return '';
	}
	
	// Generates a RFC-4122 version 4 compliant globally unique identifier.
	function generateId() {
	    // implementation taken from http://stackoverflow.com/a/2117523
	    var id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	
	    id = id.replace(/[xy]/g, function replaceRandom(c) {
	        var r = Math.floor(Math.random() * 16);
	
	        var v;
	        if (c === 'x') {
	            v = r;
	        } else {
	            v = r & 0x3 | 0x8;
	        }
	
	        return v.toString(16);
	    });
	
	    return id;
	}
	
	function isBrowserFirefox() {
	    return navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	}
	
	// Checks if browser is IE10 or IE11
	function isBrowserIE() {
	    if (window.navigator && window.navigator.userAgent) {
	        var ua = window.navigator.userAgent;
	
	        return ua.indexOf('Trident/7.0') > 0 || ua.indexOf('Trident/6.0') > 0;
	    }
	
	    return false;
	}
	
	function isBrowserEdge() {
	    return window.navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('edge') > -1;
	}
	
	function getDirectChannelName(id, otherId) {
	    var handle = void 0;
	
	    if (otherId > id) {
	        handle = id + '__' + otherId;
	    } else {
	        handle = otherId + '__' + id;
	    }
	
	    return handle;
	}
	
	// Used to get the id of the other user from a DM channel
	function getUserIdFromChannelName(channel) {
	    var ids = channel.name.split('__');
	    var otherUserId = '';
	    if (ids[0] === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentId()) {
	        otherUserId = ids[1];
	    } else {
	        otherUserId = ids[0];
	    }
	
	    return otherUserId;
	}
	
	// Returns true if the given channel is a direct channel between the current user and the given one
	function isDirectChannelForUser(otherUserId, channel) {
	    return channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].DM_CHANNEL && getUserIdFromChannelName(channel) === otherUserId;
	}
	
	function importSlack(file, success, error) {
	    var formData = new FormData();
	    formData.append('file', file, file.name);
	    formData.append('filesize', file.size);
	    formData.append('importFrom', 'slack');
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_14__web_client_jsx__["a"].importSlack(formData, success, error);
	}
	
	function getTeamURLFromAddressBar() {
	    return window.location.origin + '/' + window.location.pathname.split('/')[1];
	}
	
	function getTeamNameFromUrl() {
	    return window.location.pathname.split('/')[1];
	}
	
	function getTeamURLNoOriginFromAddressBar() {
	    return '/' + window.location.pathname.split('/')[1];
	}
	
	function getShortenedTeamURL() {
	    var teamURL = getTeamURLFromAddressBar();
	    if (teamURL.length > 35) {
	        return teamURL.substring(0, 10) + '...' + teamURL.substring(teamURL.length - 12, teamURL.length) + '/';
	    }
	    return teamURL + '/';
	}
	
	function windowWidth() {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).width();
	}
	
	function windowHeight() {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).height();
	}
	
	function openDirectChannelToUser(user, successCb, errorCb) {
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13__async_client_jsx__.savePreference(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, user.id, 'true');
	
	    // if the user in another team and isn't already in the direct message
	    // list then we should add him so his name shows up correctly.
	    var profileUser = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getProfile(user.id);
	    if (!profileUser) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getDirectProfiles()[user.id] = user;
	    }
	
	    var channelName = this.getDirectChannelName(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentId(), user.id);
	    var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getByName(channelName);
	
	    if (channel) {
	        if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isFunction(successCb)) {
	            successCb(channel, true);
	        }
	    } else {
	        channel = {
	            name: channelName,
	            last_post_at: 0,
	            total_msg_count: 0,
	            type: 'D',
	            display_name: user.username,
	            teammate_id: user.id,
	            status: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getStatus(user.id)
	        };
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_14__web_client_jsx__["a"].createDirectChannel(user.id, function (data) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_14__web_client_jsx__["a"].getChannel(data.id, function (data2) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_CHANNEL,
	                    channel: data2.channel,
	                    member: data2.member
	                });
	
	                if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isFunction(successCb)) {
	                    successCb(data2.channel, false);
	                }
	            });
	        }, function () {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["browserHistory"].push(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/channels/' + channelName);
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isFunction(errorCb)) {
	                errorCb();
	            }
	        });
	    }
	}
	
	// Use when sorting multiple channels or teams by their `display_name` field
	function sortByDisplayName(a, b) {
	    var aDisplayName = '';
	    var bDisplayName = '';
	
	    if (a && a.display_name) {
	        aDisplayName = a.display_name.toLowerCase();
	    }
	    if (b && b.display_name) {
	        bDisplayName = b.display_name.toLowerCase();
	    }
	
	    if (aDisplayName < bDisplayName) {
	        return -1;
	    }
	    if (aDisplayName > bDisplayName) {
	        return 1;
	    }
	    return 0;
	}
	
	function getChannelTerm(channelType) {
	    var channelTerm = 'Channel';
	    if (channelType === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PRIVATE_CHANNEL) {
	        channelTerm = 'Group';
	    }
	
	    return channelTerm;
	}
	
	function getPostTerm(post) {
	    var postTerm = 'Post';
	    if (post.root_id) {
	        postTerm = 'Comment';
	    }
	
	    return postTerm;
	}
	
	function isFeatureEnabled(feature) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS, /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FeatureTogglePrefix + feature.label);
	}
	
	function isSystemMessage(post) {
	    return post.type && post.type.lastIndexOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].SYSTEM_MESSAGE_PREFIX) === 0;
	}
	
	function fillArray(value, length) {
	    var arr = [];
	
	    for (var i = 0; i < length; i++) {
	        arr.push(value);
	    }
	
	    return arr;
	}
	
	// Checks if a data transfer contains files not text, folders, etc..
	// Slightly modified from http://stackoverflow.com/questions/6848043/how-do-i-detect-a-file-is-being-dragged-rather-than-a-draggable-element-on-my-pa
	function isFileTransfer(files) {
	    if (isBrowserIE()) {
	        return files.types != null && files.types.contains('Files');
	    }
	
	    return files.types != null && (files.types.indexOf ? files.types.indexOf('Files') !== -1 : files.types.contains('application/x-moz-file'));
	}
	
	function clearFileInput(elm) {
	    // clear file input for all modern browsers
	    try {
	        elm.value = '';
	        if (elm.value) {
	            elm.type = 'text';
	            elm.type = 'file';
	        }
	    } catch (e) {
	        // Do nothing
	    }
	}
	
	function isPostEphemeral(post) {
	    return post.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].POST_TYPE_EPHEMERAL || post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].POST_DELETED;
	}
	
	function getRootId(post) {
	    return post.root_id === '' ? post.id : post.root_id;
	}
	
	function localizeMessage(id, defaultMessage) {
	    var translations = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_localization_store_jsx__["a"].getTranslations();
	    if (translations) {
	        var value = translations[id];
	        if (value) {
	            return value;
	        }
	    }
	
	    if (defaultMessage) {
	        return defaultMessage;
	    }
	
	    return id;
	}
	
	function getProfilePicSrcForPost(post, timestamp) {
	    var src = /* harmony import */__WEBPACK_IMPORTED_MODULE_14__web_client_jsx__["a"].getUsersRoute() + '/' + post.user_id + '/image?time=' + timestamp;
	    if (post.props && post.props.from_webhook && global.window.mm_config.EnablePostIconOverride === 'true') {
	        if (post.props.override_icon_url) {
	            src = post.props.override_icon_url;
	        } else {
	            src = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].DEFAULT_WEBHOOK_LOGO;
	        }
	    } else if (isSystemMessage(post)) {
	        src = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].SYSTEM_MESSAGE_PROFILE_IMAGE;
	    }
	
	    return src;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global    = __webpack_require__(29)
	  , core      = __webpack_require__(82)
	  , hide      = __webpack_require__(56)
	  , redefine  = __webpack_require__(63)
	  , ctx       = __webpack_require__(90)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.e = $export;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror__ = __webpack_require__(1485);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror___default = __WEBPACK_IMPORTED_MODULE_0_keymirror__ && __WEBPACK_IMPORTED_MODULE_0_keymirror__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_keymirror__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_keymirror__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_keymirror___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_keymirror___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png__ = __webpack_require__(379);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png___default = __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png__ && __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png__ = __webpack_require__(386);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png___default = __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png__ && __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_images_icons_video_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_images_icons_video_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png__ = __webpack_require__(381);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png___default = __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png__ && __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png__ = __webpack_require__(385);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png___default = __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png__ && __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png__ = __webpack_require__(384);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png___default = __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png__ && __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png__ = __webpack_require__(380);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png___default = __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png__ && __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_images_icons_code_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_images_icons_code_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png__ = __webpack_require__(387);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png___default = __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png__ && __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_images_icons_word_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_images_icons_word_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png__ = __webpack_require__(383);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png___default = __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png__ && __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png__ = __webpack_require__(382);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png___default = __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png__ && __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png__ = __webpack_require__(817);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png___default = __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png__ && __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg__ = __webpack_require__(388);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg___default = __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg__ && __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css__ = __webpack_require__(800);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css___default = __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css__ && __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png__ = __webpack_require__(822);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png___default = __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png__ && __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css__ = __webpack_require__(801);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css___default = __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css__ && __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png__ = __webpack_require__(823);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png___default = __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png__ && __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css__ = __webpack_require__(798);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css___default = __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css__ && __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png__ = __webpack_require__(820);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png___default = __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png__ && __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css__ = __webpack_require__(799);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css___default = __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css__ && __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png__ = __webpack_require__(821);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png___default = __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png__ && __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png__ = __webpack_require__(826);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png___default = __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png__ && __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png__ = __webpack_require__(825);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png___default = __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png__ && __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png__ = __webpack_require__(824);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png___default = __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png__ && __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png__ = __webpack_require__(827);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png___default = __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png__ && __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png___default });
	'use strict';
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ exports["a"] = {
	    ActionTypes: /* harmony import */__WEBPACK_IMPORTED_MODULE_0_keymirror___default.a.bind()({
	        RECEIVED_ERROR: null,
	
	        CLICK_CHANNEL: null,
	        CREATE_CHANNEL: null,
	        LEAVE_CHANNEL: null,
	        CREATE_POST: null,
	        POST_DELETED: null,
	        REMOVE_POST: null,
	
	        RECEIVED_CHANNELS: null,
	        RECEIVED_CHANNEL: null,
	        RECEIVED_MORE_CHANNELS: null,
	        RECEIVED_CHANNEL_EXTRA_INFO: null,
	
	        FOCUS_POST: null,
	        RECEIVED_POSTS: null,
	        RECEIVED_FOCUSED_POST: null,
	        RECEIVED_POST: null,
	        RECEIVED_EDIT_POST: null,
	        RECEIVED_SEARCH: null,
	        RECEIVED_SEARCH_TERM: null,
	        RECEIVED_POST_SELECTED: null,
	        RECEIVED_MENTION_DATA: null,
	        RECEIVED_ADD_MENTION: null,
	
	        RECEIVED_PROFILES_FOR_DM_LIST: null,
	        RECEIVED_PROFILES: null,
	        RECEIVED_DIRECT_PROFILES: null,
	        RECEIVED_ME: null,
	        RECEIVED_SESSIONS: null,
	        RECEIVED_AUDITS: null,
	        RECEIVED_TEAMS: null,
	        RECEIVED_STATUSES: null,
	        RECEIVED_PREFERENCE: null,
	        RECEIVED_PREFERENCES: null,
	        RECEIVED_FILE_INFO: null,
	        RECEIVED_ANALYTICS: null,
	
	        RECEIVED_INCOMING_WEBHOOKS: null,
	        RECEIVED_INCOMING_WEBHOOK: null,
	        REMOVED_INCOMING_WEBHOOK: null,
	        RECEIVED_OUTGOING_WEBHOOKS: null,
	        RECEIVED_OUTGOING_WEBHOOK: null,
	        UPDATED_OUTGOING_WEBHOOK: null,
	        REMOVED_OUTGOING_WEBHOOK: null,
	        RECEIVED_COMMANDS: null,
	        RECEIVED_COMMAND: null,
	        UPDATED_COMMAND: null,
	        REMOVED_COMMAND: null,
	
	        RECEIVED_MSG: null,
	
	        RECEIVED_MY_TEAM: null,
	
	        RECEIVED_CONFIG: null,
	        RECEIVED_LOGS: null,
	        RECEIVED_SERVER_AUDITS: null,
	        RECEIVED_SERVER_COMPLIANCE_REPORTS: null,
	        RECEIVED_ALL_TEAMS: null,
	        RECEIVED_ALL_TEAM_LISTINGS: null,
	        RECEIVED_TEAM_MEMBERS: null,
	        RECEIVED_MEMBERS_FOR_TEAM: null,
	
	        RECEIVED_LOCALE: null,
	
	        SHOW_SEARCH: null,
	
	        USER_TYPING: null,
	
	        TOGGLE_IMPORT_THEME_MODAL: null,
	        TOGGLE_INVITE_MEMBER_MODAL: null,
	        TOGGLE_DELETE_POST_MODAL: null,
	        TOGGLE_GET_POST_LINK_MODAL: null,
	        TOGGLE_GET_TEAM_INVITE_LINK_MODAL: null,
	        TOGGLE_REGISTER_APP_MODAL: null,
	        TOGGLE_GET_PUBLIC_LINK_MODAL: null,
	
	        SUGGESTION_PRETEXT_CHANGED: null,
	        SUGGESTION_RECEIVED_SUGGESTIONS: null,
	        SUGGESTION_CLEAR_SUGGESTIONS: null,
	        SUGGESTION_COMPLETE_WORD: null,
	        SUGGESTION_SELECT_NEXT: null,
	        SUGGESTION_SELECT_PREVIOUS: null
	    }),
	
	    PayloadSources: /* harmony import */__WEBPACK_IMPORTED_MODULE_0_keymirror___default.a.bind()({
	        SERVER_ACTION: null,
	        VIEW_ACTION: null
	    }),
	
	    StatTypes: /* harmony import */__WEBPACK_IMPORTED_MODULE_0_keymirror___default.a.bind()({
	        TOTAL_USERS: null,
	        TOTAL_PUBLIC_CHANNELS: null,
	        TOTAL_PRIVATE_GROUPS: null,
	        TOTAL_POSTS: null,
	        TOTAL_TEAMS: null,
	        TOTAL_FILE_POSTS: null,
	        TOTAL_HASHTAG_POSTS: null,
	        TOTAL_IHOOKS: null,
	        TOTAL_OHOOKS: null,
	        TOTAL_COMMANDS: null,
	        TOTAL_SESSIONS: null,
	        POST_PER_DAY: null,
	        USERS_WITH_POSTS_PER_DAY: null,
	        RECENTLY_ACTIVE_USERS: null,
	        NEWLY_CREATED_USERS: null
	    }),
	    STAT_MAX_ACTIVE_USERS: 20,
	    STAT_MAX_NEW_USERS: 20,
	
	    SocketEvents: {
	        POSTED: 'posted',
	        POST_EDITED: 'post_edited',
	        POST_DELETED: 'post_deleted',
	        CHANNEL_DELETED: 'channel_deleted',
	        CHANNEL_VIEWED: 'channel_viewed',
	        DIRECT_ADDED: 'direct_added',
	        NEW_USER: 'new_user',
	        USER_ADDED: 'user_added',
	        USER_REMOVED: 'user_removed',
	        TYPING: 'typing',
	        PREFERENCE_CHANGED: 'preference_changed',
	        EPHEMERAL_MESSAGE: 'ephemeral_message'
	    },
	
	    //SPECIAL_MENTIONS: ['all', 'channel'],
	    SPECIAL_MENTIONS: ['channel'],
	    CHARACTER_LIMIT: 4000,
	    IMAGE_TYPES: ['jpg', 'gif', 'bmp', 'png', 'jpeg'],
	    AUDIO_TYPES: ['mp3', 'wav', 'wma', 'm4a', 'flac', 'aac', 'ogg'],
	    VIDEO_TYPES: ['mp4', 'avi', 'webm', 'mkv', 'wmv', 'mpg', 'mov', 'flv'],
	    PRESENTATION_TYPES: ['ppt', 'pptx'],
	    SPREADSHEET_TYPES: ['xlsx', 'csv'],
	    WORD_TYPES: ['doc', 'docx'],
	    CODE_TYPES: ['as', 'applescript', 'osascript', 'scpt', 'bash', 'sh', 'zsh', 'clj', 'boot', 'cl2', 'cljc', 'cljs', 'cljs.hl', 'cljscm', 'cljx', 'hic', 'coffee', '_coffee', 'cake', 'cjsx', 'cson', 'iced', 'cpp', 'c', 'cc', 'h', 'c++', 'h++', 'hpp', 'cs', 'csharp', 'css', 'd', 'di', 'dart', 'delphi', 'dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm', 'diff', 'django', 'jinja', 'dockerfile', 'docker', 'erl', 'f90', 'f95', 'fsharp', 'fs', 'gcode', 'nc', 'go', 'groovy', 'handlebars', 'hbs', 'html.hbs', 'html.handlebars', 'hs', 'hx', 'java', 'jsp', 'js', 'jsx', 'json', 'jl', 'kt', 'ktm', 'kts', 'less', 'lisp', 'lua', 'mk', 'mak', 'md', 'mkdown', 'mkd', 'matlab', 'm', 'mm', 'objc', 'obj-c', 'ml', 'perl', 'pl', 'php', 'php3', 'php4', 'php5', 'php6', 'ps', 'ps1', 'pp', 'py', 'gyp', 'r', 'ruby', 'rb', 'gemspec', 'podspec', 'thor', 'irb', 'rs', 'scala', 'scm', 'sld', 'scss', 'st', 'sql', 'swift', 'tex', 'vbnet', 'vb', 'bas', 'vbs', 'v', 'veo', 'xml', 'html', 'xhtml', 'rss', 'atom', 'xsl', 'plist', 'yaml'],
	    PDF_TYPES: ['pdf'],
	    PATCH_TYPES: ['patch'],
	    ICON_FROM_TYPE: {
	        audio: /* harmony import */__WEBPACK_IMPORTED_MODULE_1_images_icons_audio_png___default.a,
	        video: /* harmony import */__WEBPACK_IMPORTED_MODULE_2_images_icons_video_png___default.a,
	        spreadsheet: /* harmony import */__WEBPACK_IMPORTED_MODULE_3_images_icons_excel_png___default.a,
	        presentation: /* harmony import */__WEBPACK_IMPORTED_MODULE_4_images_icons_ppt_png___default.a,
	        pdf: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_images_icons_pdf_png___default.a,
	        code: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_images_icons_code_png___default.a,
	        word: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_images_icons_word_png___default.a,
	        patch: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_images_icons_patch_png___default.a,
	        other: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_images_icons_generic_png___default.a
	    },
	    ICON_NAME_FROM_TYPE: {
	        audio: 'audio',
	        video: 'video',
	        spreadsheet: 'excel',
	        presentation: 'ppt',
	        pdf: 'pdf',
	        code: 'code',
	        word: 'word',
	        patch: 'patch',
	        other: 'generic'
	    },
	    MAX_DISPLAY_FILES: 5,
	    MAX_UPLOAD_FILES: 5,
	    MAX_FILE_SIZE: 50000000, // 50 MB
	    THUMBNAIL_WIDTH: 128,
	    THUMBNAIL_HEIGHT: 100,
	    WEB_VIDEO_WIDTH: 640,
	    WEB_VIDEO_HEIGHT: 480,
	    MOBILE_VIDEO_WIDTH: 480,
	    MOBILE_VIDEO_HEIGHT: 360,
	    DEFAULT_CHANNEL: 'town-square',
	    DEFAULT_CHANNEL_UI_NAME: 'Town Square',
	    OFFTOPIC_CHANNEL: 'off-topic',
	    OFFTOPIC_CHANNEL_UI_NAME: 'Off-Topic',
	    GITLAB_SERVICE: 'gitlab',
	    GOOGLE_SERVICE: 'google',
	    EMAIL_SERVICE: 'email',
	    LDAP_SERVICE: 'ldap',
	    USERNAME_SERVICE: 'username',
	    SIGNIN_CHANGE: 'signin_change',
	    PASSWORD_CHANGE: 'password_change',
	    SIGNIN_VERIFIED: 'verified',
	    SESSION_EXPIRED: 'expired',
	    POST_CHUNK_SIZE: 60,
	    MAX_POST_CHUNKS: 3,
	    POST_FOCUS_CONTEXT_RADIUS: 10,
	    POST_LOADING: 'loading',
	    POST_FAILED: 'failed',
	    POST_DELETED: 'deleted',
	    POST_TYPE_EPHEMERAL: 'system_ephemeral',
	    POST_TYPE_JOIN_LEAVE: 'system_join_leave',
	    SYSTEM_MESSAGE_PREFIX: 'system_',
	    SYSTEM_MESSAGE_PROFILE_NAME: 'System',
	    SYSTEM_MESSAGE_PROFILE_IMAGE: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_images_logo_compact_png___default.a,
	    RESERVED_TEAM_NAMES: ['www', 'web', 'admin', 'support', 'notify', 'test', 'demo', 'mail', 'team', 'channel', 'internal', 'localhost', 'dockerhost', 'stag', 'post', 'cluster', 'api'],
	    RESERVED_USERNAMES: ['valet', 'all', 'channel'],
	    MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    MAX_DMS: 20,
	    MAX_CHANNEL_POPOVER_COUNT: 100,
	    DM_CHANNEL: 'D',
	    OPEN_CHANNEL: 'O',
	    PRIVATE_CHANNEL: 'P',
	    INVITE_TEAM: 'I',
	    OPEN_TEAM: 'O',
	    MAX_POST_LEN: 4000,
	    EMOJI_SIZE: 16,
	    MATTERMOST_ICON_SVG: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='0 0 500 500' style='enable-background:new 0 0 500 500;' xml:space='preserve'> <style type='text/css'> .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;} </style> <g id='XMLID_1_'> <g id='XMLID_3_'> <path id='XMLID_4_' class='st0' d='M396.9,47.7l2.6,53.1c43,47.5,60,114.8,38.6,178.1c-32,94.4-137.4,144.1-235.4,110.9 S51.1,253.1,83,158.7C104.5,95.2,159.2,52,222.5,40.5l34.2-40.4C150-2.8,49.3,63.4,13.3,169.9C-31,300.6,39.1,442.5,169.9,486.7 s272.6-25.8,316.9-156.6C522.7,223.9,483.1,110.3,396.9,47.7z'/> </g> <path id='XMLID_2_' class='st0' d='M335.6,204.3l-1.8-74.2l-1.5-42.7l-1-37c0,0,0.2-17.8-0.4-22c-0.1-0.9-0.4-1.6-0.7-2.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c-0.7-1.2-1.8-2.1-3.1-2.6c-1.4-0.5-2.9-0.4-4.2,0.2c0,0-0.1,0-0.1,0 c-0.2,0.1-0.3,0.1-0.4,0.2c-0.6,0.3-1.2,0.7-1.8,1.3c-3,3-13.7,17.2-13.7,17.2l-23.2,28.8l-27.1,33l-46.5,57.8 c0,0-21.3,26.6-16.6,59.4s29.1,48.7,48,55.1c18.9,6.4,48,8.5,71.6-14.7C336.4,238.4,335.6,204.3,335.6,204.3z'/> </g> </svg>",
	    ONLINE_ICON_SVG: "<svg version='1.1'id='Layer_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#' xmlns:svg='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:cc='http://creativecommons.org/ns#' inkscape:version='0.48.4 r9939' sodipodi:docname='TRASH_1_4.svg'xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='-243 245 12 12'style='enable-background:new -243 245 12 12;' xml:space='preserve'> <sodipodi:namedview  inkscape:cx='26.358185' inkscape:zoom='1.18' bordercolor='#666666' pagecolor='#ffffff' borderopacity='1' objecttolerance='10' inkscape:cy='139.7898' gridtolerance='10' guidetolerance='10' showgrid='false' showguides='true' id='namedview6' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:guide-bbox='true' inkscape:window-width='1366' inkscape:current-layer='Layer_1' inkscape:window-height='705' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:window-x='-8'> <sodipodi:guide  position='50.036793,85.991376' orientation='1,0' id='guide2986'></sodipodi:guide> <sodipodi:guide  position='58.426196,66.216355' orientation='0,1' id='guide3047'></sodipodi:guide> </sodipodi:namedview> <g> <path class='online--icon' d='M-236,250.5C-236,250.5-236,250.5-236,250.5C-236,250.5-236,250.5-236,250.5C-236,250.5-236,250.5-236,250.5z'/> <ellipse class='online--icon' cx='-238.5' cy='248' rx='2.5' ry='2.5'/> </g> <path class='online--icon' d='M-238.9,253.8c0-0.4,0.1-0.9,0.2-1.3c-2.2-0.2-2.2-2-2.2-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5c0,0.1-0.1,0.5,0,0.6 c0.2,1.3,2.2,2.3,4.4,2.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0C-238.7,255.7-238.9,254.8-238.9,253.8z'/> <g> <g> <path class='online--icon' d='M-232.3,250.1l1.3,1.3c0,0,0,0.1,0,0.1l-4.1,4.1c0,0,0,0-0.1,0c0,0,0,0,0,0l-2.7-2.7c0,0,0-0.1,0-0.1l1.2-1.2 c0,0,0.1,0,0.1,0l1.4,1.4l2.9-2.9C-232.4,250.1-232.3,250.1-232.3,250.1z'/> </g> </g> </svg>",
	    AWAY_ICON_SVG: "<svg version='1.1'id='Layer_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#' xmlns:svg='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:cc='http://creativecommons.org/ns#' inkscape:version='0.48.4 r9939' sodipodi:docname='TRASH_1_4.svg'xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='-299 391 12 12'style='enable-background:new -299 391 12 12;' xml:space='preserve'> <sodipodi:namedview  inkscape:cx='26.358185' inkscape:zoom='1.18' bordercolor='#666666' pagecolor='#ffffff' borderopacity='1' objecttolerance='10' inkscape:cy='139.7898' gridtolerance='10' guidetolerance='10' showgrid='false' showguides='true' id='namedview6' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:guide-bbox='true' inkscape:window-width='1366' inkscape:current-layer='Layer_1' inkscape:window-height='705' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:window-x='-8'> <sodipodi:guide  position='50.036793,85.991376' orientation='1,0' id='guide2986'></sodipodi:guide> <sodipodi:guide  position='58.426196,66.216355' orientation='0,1' id='guide3047'></sodipodi:guide> </sodipodi:namedview> <g> <ellipse class='away--icon' cx='-294.6' cy='394' rx='2.5' ry='2.5'/> <path class='away--icon' d='M-293.8,399.4c0-0.4,0.1-0.7,0.2-1c-0.3,0.1-0.6,0.2-1,0.2c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0,1.4-0.1,2-0.3 C-293.3,401.5-293.8,400.5-293.8,399.4z'/> </g> <path class='away--icon' d='M-287,400c0,0.1-0.1,0.1-0.1,0.1l-4.9,0c-0.1,0-0.1-0.1-0.1-0.1v-1.6c0-0.1,0.1-0.1,0.1-0.1l4.9,0c0.1,0,0.1,0.1,0.1,0.1 V400z'/> </svg>",
	    OFFLINE_ICON_SVG: "<svg version='1.1'id='Layer_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns#' xmlns:svg='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:cc='http://creativecommons.org/ns#' inkscape:version='0.48.4 r9939' sodipodi:docname='TRASH_1_4.svg'xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='-299 391 12 12'style='enable-background:new -299 391 12 12;' xml:space='preserve'> <sodipodi:namedview  inkscape:cx='26.358185' inkscape:zoom='1.18' bordercolor='#666666' pagecolor='#ffffff' borderopacity='1' objecttolerance='10' inkscape:cy='139.7898' gridtolerance='10' guidetolerance='10' showgrid='false' showguides='true' id='namedview6' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:guide-bbox='true' inkscape:window-width='1366' inkscape:current-layer='Layer_1' inkscape:window-height='705' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:window-x='-8'> <sodipodi:guide  position='50.036793,85.991376' orientation='1,0' id='guide2986'></sodipodi:guide> <sodipodi:guide  position='58.426196,66.216355' orientation='0,1' id='guide3047'></sodipodi:guide> </sodipodi:namedview> <g> <g> <ellipse class='offline--icon' cx='-294.5' cy='394' rx='2.5' ry='2.5'/> <path class='offline--icon' d='M-294.3,399.7c0-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.2,0-0.4,0c-2.5,0-2.5-2-2.5-2s-1,0.1-1.2,0.5c-0.4,0.6-0.6,1.7-0.7,2.5 c0,0.1-0.1,0.5,0,0.6c0.2,1.3,2.2,2.3,4.4,2.4h0.1h0.1c0.3,0,0.7,0,1-0.1C-293.9,401.6-294.3,400.7-294.3,399.7z'/> </g> </g> <g> <path class='offline--icon' d='M-288.9,399.4l1.8-1.8c0.1-0.1,0.1-0.3,0-0.3l-0.7-0.7c-0.1-0.1-0.3-0.1-0.3,0l-1.8,1.8l-1.8-1.8c-0.1-0.1-0.3-0.1-0.3,0 l-0.7,0.7c-0.1,0.1-0.1,0.3,0,0.3l1.8,1.8l-1.8,1.8c-0.1,0.1-0.1,0.3,0,0.3l0.7,0.7c0.1,0.1,0.3,0.1,0.3,0l1.8-1.8l1.8,1.8 c0.1,0.1,0.3,0.1,0.3,0l0.7-0.7c0.1-0.1,0.1-0.3,0-0.3L-288.9,399.4z'/> </g> </svg>",
	    MENU_ICON: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'width='4px' height='16px' viewBox='0 0 8 32' enable-background='new 0 0 8 32' xml:space='preserve'> <g> <circle cx='4' cy='4.062' r='4'/> <circle cx='4' cy='16' r='4'/> <circle cx='4' cy='28' r='4'/> </g> </svg>",
	    COMMENT_ICON: "<svg version='1.1' id='Layer_2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'width='15px' height='15px' viewBox='1 1.5 15 15' enable-background='new 1 1.5 15 15' xml:space='preserve'> <g> <g> <path fill='#211B1B' d='M14,1.5H3c-1.104,0-2,0.896-2,2v8c0,1.104,0.896,2,2,2h1.628l1.884,3l1.866-3H14c1.104,0,2-0.896,2-2v-8 C16,2.396,15.104,1.5,14,1.5z M15,11.5c0,0.553-0.447,1-1,1H8l-1.493,2l-1.504-1.991L5,12.5H3c-0.552,0-1-0.447-1-1v-8 c0-0.552,0.448-1,1-1h11c0.553,0,1,0.448,1,1V11.5z'/> </g> </g> </svg>",
	    REPLY_ICON: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='-158 242 18 18' style='enable-background:new -158 242 18 18;' xml:space='preserve'> <path d='M-142.2,252.6c-2-3-4.8-4.7-8.3-4.8v-3.3c0-0.2-0.1-0.3-0.2-0.3s-0.3,0-0.4,0.1l-6.9,6.2c-0.1,0.1-0.1,0.2-0.1,0.3 c0,0.1,0,0.2,0.1,0.3l6.9,6.4c0.1,0.1,0.3,0.1,0.4,0.1c0.1-0.1,0.2-0.2,0.2-0.4v-3.8c4.2,0,7.4,0.4,9.6,4.4c0.1,0.1,0.2,0.2,0.3,0.2 c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.3,0.2-0.4C-140.2,257.3-140.6,255-142.2,252.6z M-150.8,252.5c-0.2,0-0.4,0.2-0.4,0.4v3.3l-6-5.5 l6-5.3v2.8c0,0.2,0.2,0.4,0.4,0.4c3.3,0,6,1.5,8,4.5c0.5,0.8,0.9,1.6,1.2,2.3C-144,252.8-147.1,252.5-150.8,252.5z'/> </svg>",
	    SCROLL_BOTTOM_ICON: "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px'viewBox='-239 239 21 23' style='enable-background:new -239 239 21 23;' xml:space='preserve'> <path d='M-239,241.4l2.4-2.4l8.1,8.2l8.1-8.2l2.4,2.4l-10.5,10.6L-239,241.4z M-228.5,257.2l8.1-8.2l2.4,2.4l-10.5,10.6l-10.5-10.6 l2.4-2.4L-228.5,257.2z'/> </svg>",
	    UPDATE_TYPING_MS: 5000,
	    THEMES: {
	        default: {
	            type: 'Organization',
	            sidebarBg: '#2071a7',
	            sidebarText: '#fff',
	            sidebarUnreadText: '#fff',
	            sidebarTextHoverBg: '#136197',
	            sidebarTextActiveBorder: '#7AB0D6',
	            sidebarTextActiveColor: '#FFFFFF',
	            sidebarHeaderBg: '#2f81b7',
	            sidebarHeaderTextColor: '#FFFFFF',
	            onlineIndicator: '#7DBE00',
	            awayIndicator: '#DCBD4E',
	            mentionBj: '#FBFBFB',
	            mentionColor: '#2071A7',
	            centerChannelBg: '#f2f4f8',
	            centerChannelColor: '#333333',
	            newMessageSeparator: '#FF8800',
	            linkColor: '#2f81b7',
	            buttonBg: '#1dacfc',
	            buttonColor: '#FFFFFF',
	            mentionHighlightBg: '#fff2bb',
	            mentionHighlightLink: '#2f81b7',
	            codeTheme: 'github',
	            image: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_images_themes_organization_png___default.a
	        },
	        mattermost: {
	            type: 'Mattermost',
	            sidebarBg: '#fafafa',
	            sidebarText: '#333333',
	            sidebarUnreadText: '#333333',
	            sidebarTextHoverBg: '#e6f2fa',
	            sidebarTextActiveBorder: '#378FD2',
	            sidebarTextActiveColor: '#111111',
	            sidebarHeaderBg: '#2389d7',
	            sidebarHeaderTextColor: '#ffffff',
	            onlineIndicator: '#7DBE00',
	            awayIndicator: '#DCBD4E',
	            mentionBj: '#2389d7',
	            mentionColor: '#ffffff',
	            centerChannelBg: '#ffffff',
	            centerChannelColor: '#333333',
	            newMessageSeparator: '#FF8800',
	            linkColor: '#2389d7',
	            buttonBg: '#2389d7',
	            buttonColor: '#FFFFFF',
	            mentionHighlightBg: '#fff2bb',
	            mentionHighlightLink: '#2f81b7',
	            codeTheme: 'github',
	            image: /* harmony import */__WEBPACK_IMPORTED_MODULE_22_images_themes_mattermost_png___default.a
	        },
	        mattermostDark: {
	            type: 'Mattermost Dark',
	            sidebarBg: '#1B2C3E',
	            sidebarText: '#fff',
	            sidebarUnreadText: '#fff',
	            sidebarTextHoverBg: '#4A5664',
	            sidebarTextActiveBorder: '#66B9A7',
	            sidebarTextActiveColor: '#FFFFFF',
	            sidebarHeaderBg: '#1B2C3E',
	            sidebarHeaderTextColor: '#FFFFFF',
	            onlineIndicator: '#55C5B2',
	            awayIndicator: '#A9A14C',
	            mentionBj: '#B74A4A',
	            mentionColor: '#FFFFFF',
	            centerChannelBg: '#2F3E4E',
	            centerChannelColor: '#DDDDDD',
	            newMessageSeparator: '#5de5da',
	            linkColor: '#A4FFEB',
	            buttonBg: '#4CBBA4',
	            buttonColor: '#FFFFFF',
	            mentionHighlightBg: '#984063',
	            mentionHighlightLink: '#A4FFEB',
	            codeTheme: 'solarized-dark',
	            image: /* harmony import */__WEBPACK_IMPORTED_MODULE_21_images_themes_mattermost_dark_png___default.a
	        },
	        windows10: {
	            type: 'Windows Dark',
	            sidebarBg: '#171717',
	            sidebarText: '#fff',
	            sidebarUnreadText: '#fff',
	            sidebarTextHoverBg: '#302e30',
	            sidebarTextActiveBorder: '#196CAF',
	            sidebarTextActiveColor: '#FFFFFF',
	            sidebarHeaderBg: '#1f1f1f',
	            sidebarHeaderTextColor: '#FFFFFF',
	            onlineIndicator: '#0177e7',
	            awayIndicator: '#A9A14C',
	            mentionBj: '#0177e7',
	            mentionColor: '#FFFFFF',
	            centerChannelBg: '#1F1F1F',
	            centerChannelColor: '#DDDDDD',
	            newMessageSeparator: '#CC992D',
	            linkColor: '#0D93FF',
	            buttonBg: '#0177e7',
	            buttonColor: '#FFFFFF',
	            mentionHighlightBg: '#784098',
	            mentionHighlightLink: '#A4FFEB',
	            codeTheme: 'monokai',
	            image: /* harmony import */__WEBPACK_IMPORTED_MODULE_23_images_themes_windows_dark_png___default.a
	        }
	    },
	    THEME_ELEMENTS: [{
	        group: 'sidebarElements',
	        id: 'sidebarBg',
	        uiName: 'Sidebar BG'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarText',
	        uiName: 'Sidebar Text'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarHeaderBg',
	        uiName: 'Sidebar Header BG'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarHeaderTextColor',
	        uiName: 'Sidebar Header Text'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarUnreadText',
	        uiName: 'Sidebar Unread Text'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarTextHoverBg',
	        uiName: 'Sidebar Text Hover BG'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarTextActiveBorder',
	        uiName: 'Sidebar Text Active Border'
	    }, {
	        group: 'sidebarElements',
	        id: 'sidebarTextActiveColor',
	        uiName: 'Sidebar Text Active Color'
	    }, {
	        group: 'sidebarElements',
	        id: 'onlineIndicator',
	        uiName: 'Online Indicator'
	    }, {
	        group: 'sidebarElements',
	        id: 'awayIndicator',
	        uiName: 'Away Indicator'
	    }, {
	        group: 'sidebarElements',
	        id: 'mentionBj',
	        uiName: 'Mention Jewel BG'
	    }, {
	        group: 'sidebarElements',
	        id: 'mentionColor',
	        uiName: 'Mention Jewel Text'
	    }, {
	        group: 'centerChannelElements',
	        id: 'centerChannelBg',
	        uiName: 'Center Channel BG'
	    }, {
	        group: 'centerChannelElements',
	        id: 'centerChannelColor',
	        uiName: 'Center Channel Text'
	    }, {
	        group: 'centerChannelElements',
	        id: 'newMessageSeparator',
	        uiName: 'New Message Separator'
	    }, {
	        group: 'centerChannelElements',
	        id: 'mentionHighlightBg',
	        uiName: 'Mention Highlight BG'
	    }, {
	        group: 'centerChannelElements',
	        id: 'mentionHighlightLink',
	        uiName: 'Mention Highlight Link'
	    }, {
	        group: 'linkAndButtonElements',
	        id: 'linkColor',
	        uiName: 'Link Color'
	    }, {
	        group: 'linkAndButtonElements',
	        id: 'buttonBg',
	        uiName: 'Button BG'
	    }, {
	        group: 'linkAndButtonElements',
	        id: 'buttonColor',
	        uiName: 'Button Text'
	    }, {
	        group: 'centerChannelElements',
	        id: 'codeTheme',
	        uiName: 'Code Theme',
	        themes: [{
	            id: 'solarized-dark',
	            uiName: 'Solarized Dark',
	            cssURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_12__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_dark_css___default.a,
	            iconURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_images_themes_code_themes_solarized_dark_png___default.a
	        }, {
	            id: 'solarized-light',
	            uiName: 'Solarized Light',
	            cssURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_14__file_name_files_code_themes_hash_ext_highlight_js_styles_solarized_light_css___default.a,
	            iconURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_images_themes_code_themes_solarized_light_png___default.a
	        }, {
	            id: 'github',
	            uiName: 'GitHub',
	            cssURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_16__file_name_files_code_themes_hash_ext_highlight_js_styles_github_css___default.a,
	            iconURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_images_themes_code_themes_github_png___default.a
	        }, {
	            id: 'monokai',
	            uiName: 'Monokai',
	            cssURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_18__file_name_files_code_themes_hash_ext_highlight_js_styles_monokai_css___default.a,
	            iconURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_images_themes_code_themes_monokai_png___default.a
	        }]
	    }],
	    DEFAULT_CODE_THEME: 'github',
	    FONTS: {
	        'Droid Serif': 'font--droid_serif',
	        'Roboto Slab': 'font--roboto_slab',
	        Lora: 'font--lora',
	        Arvo: 'font--arvo',
	        'Open Sans': 'font--open_sans',
	        Roboto: 'font--roboto',
	        'PT Sans': 'font--pt_sans',
	        Lato: 'font--lato',
	        'Source Sans Pro': 'font--source_sans_pro',
	        'Exo 2': 'font--exo_2',
	        Ubuntu: 'font--ubuntu'
	    },
	    DEFAULT_FONT: 'Open Sans',
	    Preferences: {
	        CATEGORY_DIRECT_CHANNEL_SHOW: 'direct_channel_show',
	        CATEGORY_DISPLAY_SETTINGS: 'display_settings',
	        DISPLAY_PREFER_NICKNAME: 'nickname_full_name',
	        DISPLAY_PREFER_FULL_NAME: 'full_name',
	        CATEGORY_ADVANCED_SETTINGS: 'advanced_settings',
	        TUTORIAL_STEP: 'tutorial_step',
	        CHANNEL_DISPLAY_MODE: 'channel_display_mode',
	        CHANNEL_DISPLAY_MODE_CENTERED: 'centered',
	        CHANNEL_DISPLAY_MODE_FULL_SCREEN: 'full',
	        CHANNEL_DISPLAY_MODE_DEFAULT: 'centered'
	    },
	    TutorialSteps: {
	        INTRO_SCREENS: 0,
	        POST_POPOVER: 1,
	        CHANNEL_POPOVER: 2,
	        MENU_POPOVER: 3
	    },
	    KeyCodes: {
	        UP: 38,
	        DOWN: 40,
	        LEFT: 37,
	        RIGHT: 39,
	        BACKSPACE: 8,
	        ENTER: 13,
	        ESCAPE: 27,
	        SPACE: 32,
	        TAB: 9,
	        U: 85
	    },
	    CODE_PREVIEW_MAX_FILE_SIZE: 500000, // 500 KB
	    HighlightedLanguages: {
	        actionscript: { name: 'ActionScript', extensions: ['as'] },
	        applescript: { name: 'AppleScript', extensions: ['applescript', 'osascript', 'scpt'] },
	        bash: { name: 'Bash', extensions: ['bash', 'sh', 'zsh'] },
	        clojure: { name: 'Clojure', extensions: ['clj', 'boot', 'cl2', 'cljc', 'cljs', 'cljs.hl', 'cljscm', 'cljx', 'hic'] },
	        coffeescript: { name: 'CoffeeScript', extensions: ['coffee', '_coffee', 'cake', 'cjsx', 'cson', 'iced'] },
	        cpp: { name: 'C/C++', extensions: ['cpp', 'c', 'cc', 'h', 'c++', 'h++', 'hpp'] },
	        cs: { name: 'C#', extensions: ['cs', 'csharp'] },
	        css: { name: 'CSS', extensions: ['css'] },
	        d: { name: 'D', extensions: ['d', 'di'] },
	        dart: { name: 'Dart', extensions: ['dart'] },
	        delphi: { name: 'Delphi', extensions: ['delphi', 'dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'] },
	        diff: { name: 'Diff', extensions: ['diff', 'patch'] },
	        django: { name: 'Django', extensions: ['django', 'jinja'] },
	        dockerfile: { name: 'Dockerfile', extensions: ['dockerfile', 'docker'] },
	        erlang: { name: 'Erlang', extensions: ['erl'] },
	        fortran: { name: 'Fortran', extensions: ['f90', 'f95'] },
	        fsharp: { name: 'F#', extensions: ['fsharp', 'fs'] },
	        gcode: { name: 'G-Code', extensions: ['gcode', 'nc'] },
	        go: { name: 'Go', extensions: ['go'] },
	        groovy: { name: 'Groovy', extensions: ['groovy'] },
	        handlebars: { name: 'Handlebars', extensions: ['handlebars', 'hbs', 'html.hbs', 'html.handlebars'] },
	        haskell: { name: 'Haskell', extensions: ['hs'] },
	        haxe: { name: 'Haxe', extensions: ['hx'] },
	        java: { name: 'Java', extensions: ['java', 'jsp'] },
	        javascript: { name: 'JavaScript', extensions: ['js', 'jsx'] },
	        json: { name: 'JSON', extensions: ['json'] },
	        julia: { name: 'Julia', extensions: ['jl'] },
	        kotlin: { name: 'Kotlin', extensions: ['kt', 'ktm', 'kts'] },
	        less: { name: 'Less', extensions: ['less'] },
	        lisp: { name: 'Lisp', extensions: ['lisp'] },
	        lua: { name: 'Lua', extensions: ['lua'] },
	        makefile: { name: 'Makefile', extensions: ['mk', 'mak'] },
	        markdown: { name: 'Markdown', extensions: ['md', 'mkdown', 'mkd'] },
	        matlab: { name: 'Matlab', extensions: ['matlab', 'm'] },
	        objectivec: { name: 'Objective C', extensions: ['mm', 'objc', 'obj-c'] },
	        ocaml: { name: 'OCaml', extensions: ['ml'] },
	        perl: { name: 'Perl', extensions: ['perl', 'pl'] },
	        php: { name: 'PHP', extensions: ['php', 'php3', 'php4', 'php5', 'php6'] },
	        powershell: { name: 'PowerShell', extensions: ['ps', 'ps1'] },
	        puppet: { name: 'Puppet', extensions: ['pp'] },
	        python: { name: 'Python', extensions: ['py', 'gyp'] },
	        r: { name: 'R', extensions: ['r'] },
	        ruby: { name: 'Ruby', extensions: ['ruby', 'rb', 'gemspec', 'podspec', 'thor', 'irb'] },
	        rust: { name: 'Rust', extensions: ['rs'] },
	        scala: { name: 'Scala', extensions: ['scala'] },
	        scheme: { name: 'Scheme', extensions: ['scm', 'sld'] },
	        scss: { name: 'SCSS', extensions: ['scss'] },
	        smalltalk: { name: 'Smalltalk', extensions: ['st'] },
	        sql: { name: 'SQL', extensions: ['sql'] },
	        swift: { name: 'Swift', extensions: ['swift'] },
	        tex: { name: 'TeX', extensions: ['tex'] },
	        vbnet: { name: 'VB.Net', extensions: ['vbnet', 'vb', 'bas'] },
	        vbscript: { name: 'VBScript', extensions: ['vbs'] },
	        verilog: { name: 'Verilog', extensions: ['v', 'veo'] },
	        xml: { name: 'HTML, XML', extensions: ['xml', 'html', 'xhtml', 'rss', 'atom', 'xsl', 'plist'] },
	        yaml: { name: 'YAML', extensions: ['yaml'] }
	    },
	    PostsViewJumpTypes: {
	        BOTTOM: 1,
	        POST: 2,
	        SIDEBAR_OPEN: 3
	    },
	    NotificationPrefs: {
	        MENTION: 'mention'
	    },
	    FeatureTogglePrefix: 'feature_enabled_',
	    PRE_RELEASE_FEATURES: {
	        MARKDOWN_PREVIEW: {
	            label: 'markdown_preview', // github issue: https://github.com/mattermost/platform/pull/1389
	            description: 'Show markdown preview option in message input box'
	        },
	        EMBED_PREVIEW: {
	            label: 'embed_preview',
	            description: 'Show preview snippet of links below message'
	        },
	        EMBED_TOGGLE: {
	            label: 'embed_toggle',
	            description: 'Show toggle for all embed previews'
	        }
	    },
	    OVERLAY_TIME_DELAY: 400,
	    MIN_USERNAME_LENGTH: 3,
	    MAX_USERNAME_LENGTH: 22,
	    MIN_PASSWORD_LENGTH: 5,
	    MAX_PASSWORD_LENGTH: 50,
	    TIME_SINCE_UPDATE_INTERVAL: 30000,
	    MIN_HASHTAG_LINK_LENGTH: 3,
	    EMOJI_PATH: '/static/emoji',
	    DEFAULT_WEBHOOK_LOGO: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_images_webhook_icon_jpg___default.a,
	    MHPNS: 'https://push.mattermost.com',
	    MTPNS: 'http://push-test.mattermost.com'
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_client_jsx__ = __webpack_require__(636);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var HTTP_UNAUTHORIZED = 401;
	
	var WebClientClass = function (_Client) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(WebClientClass, _Client);
	
	    function WebClientClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, WebClientClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(WebClientClass).call(this));
	
	        _this.onTeamStoreChanged = function () {
	            _this.setTeamId(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__stores_team_store_jsx__["a"].getCurrentId());
	        };
	
	        _this.track = function (category, action, label, property, value) {
	            if (global.window && global.window.analytics) {
	                global.window.analytics.track(action, { category: category, label: label, property: property, value: value });
	            }
	        };
	
	        _this.trackPage = function () {
	            if (global.window && global.window.analytics) {
	                global.window.analytics.page();
	            }
	        };
	
	        _this.handleError = function (err, res) {
	            // eslint-disable-line no-unused-vars
	            if (err.status === HTTP_UNAUTHORIZED && res.req.url !== '/api/v3/users/login') {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitUserLoggedOutEvent('/login');
	            }
	        };
	
	        _this.enableLogErrorsToConsole(true);
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_6__stores_team_store_jsx__["a"].addChangeListener(_this.onTeamStoreChanged);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(WebClientClass, [{
	        key: 'webLogin',
	
	
	        // not sure why but super.login doesn't work if using an () => arrow functions.
	        // I think this might be a webpack issue.
	        value: function webLogin(loginId, password, token, success, error) {
	            var _this2 = this;
	
	            this.login(loginId, password, token, function (data) {
	                _this2.track('api', 'api_users_login_success', '', 'login_id', loginId);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7__stores_browser_store_jsx__["a"].signalLogin();
	
	                if (success) {
	                    success(data);
	                }
	            }, function (err) {
	                _this2.track('api', 'api_users_login_fail', name, 'login_id', loginId);
	                if (error) {
	                    error(err);
	                }
	            });
	        }
	    }, {
	        key: 'webLoginByLdap',
	        value: function webLoginByLdap(loginId, password, token, success, error) {
	            var _this3 = this;
	
	            this.loginByLdap(loginId, password, token, function (data) {
	                _this3.track('api', 'api_users_login_success', '', 'login_id', loginId);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7__stores_browser_store_jsx__["a"].signalLogin();
	
	                if (success) {
	                    success(data);
	                }
	            }, function (err) {
	                _this3.track('api', 'api_users_login_fail', name, 'login_id', loginId);
	                if (error) {
	                    error(err);
	                }
	            });
	        }
	    }]);
	
	    return WebClientClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__client_client_jsx__["a"]);
	
	var WebClient = new WebClientClass();
	/* harmony default export */ exports["a"] = WebClient;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = __webpack_require__(591);
	


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	var _Object$assign = __webpack_require__(50)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __WEBPACK_IMPORTED_MODULE_2_jquery__ && __WEBPACK_IMPORTED_MODULE_2_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_jsx__ = __webpack_require__(10);
	/* harmony export */ exports["dispatchError"] = dispatchError;/* harmony export */ exports["getChannels"] = getChannels;/* harmony export */ exports["getChannel"] = getChannel;/* harmony export */ exports["updateLastViewedAt"] = updateLastViewedAt;/* harmony export */ exports["getMoreChannels"] = getMoreChannels;/* harmony export */ exports["getChannelExtraInfo"] = getChannelExtraInfo;/* harmony export */ exports["getTeamMembers"] = getTeamMembers;/* harmony export */ exports["getProfilesForDirectMessageList"] = getProfilesForDirectMessageList;/* harmony export */ exports["getProfiles"] = getProfiles;/* harmony export */ exports["getDirectProfiles"] = getDirectProfiles;/* harmony export */ exports["getSessions"] = getSessions;/* harmony export */ exports["getAudits"] = getAudits;/* harmony export */ exports["getLogs"] = getLogs;/* harmony export */ exports["getServerAudits"] = getServerAudits;/* harmony export */ exports["getComplianceReports"] = getComplianceReports;/* harmony export */ exports["getConfig"] = getConfig;/* harmony export */ exports["getAllTeams"] = getAllTeams;/* harmony export */ exports["getAllTeamListings"] = getAllTeamListings;/* harmony export */ exports["search"] = search;/* harmony export */ exports["getPostsPage"] = getPostsPage;/* harmony export */ exports["getPosts"] = getPosts;/* harmony export */ exports["getPostsBefore"] = getPostsBefore;/* harmony export */ exports["getPostsAfter"] = getPostsAfter;/* harmony export */ exports["getMe"] = getMe;/* harmony export */ exports["getStatuses"] = getStatuses;/* harmony export */ exports["getMyTeam"] = getMyTeam;/* harmony export */ exports["getAllPreferences"] = getAllPreferences;/* harmony export */ exports["savePreference"] = savePreference;/* harmony export */ exports["savePreferences"] = savePreferences;/* harmony export */ exports["getSuggestedCommands"] = getSuggestedCommands;/* harmony export */ exports["getFileInfo"] = getFileInfo;/* harmony export */ exports["getStandardAnalytics"] = getStandardAnalytics;/* harmony export */ exports["getAdvancedAnalytics"] = getAdvancedAnalytics;/* harmony export */ exports["getPostsPerDayAnalytics"] = getPostsPerDayAnalytics;/* harmony export */ exports["getUsersPerDayAnalytics"] = getUsersPerDayAnalytics;/* harmony export */ exports["getRecentAndNewUsersAnalytics"] = getRecentAndNewUsersAnalytics;/* harmony export */ exports["listIncomingHooks"] = listIncomingHooks;/* harmony export */ exports["listOutgoingHooks"] = listOutgoingHooks;/* harmony export */ exports["addIncomingHook"] = addIncomingHook;/* harmony export */ exports["addOutgoingHook"] = addOutgoingHook;/* harmony export */ exports["deleteIncomingHook"] = deleteIncomingHook;/* harmony export */ exports["deleteOutgoingHook"] = deleteOutgoingHook;/* harmony export */ exports["regenOutgoingHookToken"] = regenOutgoingHookToken;/* harmony export */ exports["listTeamCommands"] = listTeamCommands;/* harmony export */ exports["addCommand"] = addCommand;/* harmony export */ exports["deleteCommand"] = deleteCommand;/* harmony export */ exports["regenCommandToken"] = regenCommandToken;/* harmony export */ exports["getPublicLink"] = getPublicLink;'use strict';
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].ActionTypes;
	var StatTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].StatTypes;
	
	// Used to track in progress async calls
	var callTracker = {};
	
	var ASYNC_CLIENT_TIMEOUT = 5000;
	
	function dispatchError(err, method) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.RECEIVED_ERROR,
	        err: err,
	        method: method
	    });
	}
	
	function isCallInProgress(callName) {
	    if (!(callName in callTracker)) {
	        return false;
	    }
	
	    if (callTracker[callName] === 0) {
	        return false;
	    }
	
	    if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp() - callTracker[callName] > ASYNC_CLIENT_TIMEOUT) {
	        //console.log('AsyncClient call ' + callName + ' expired after more than 5 seconds');
	        return false;
	    }
	
	    return true;
	}
	
	function getChannels(checkVersion) {
	    if (isCallInProgress('getChannels')) {
	        return null;
	    }
	
	    callTracker.getChannels = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getChannels(function (data) {
	        callTracker.getChannels = 0;
	
	        if (checkVersion) {
	            var serverVersion = /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getServerVersion();
	
	            if (serverVersion !== /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__["a"].getLastServerVersion()) {
	                if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__["a"].getLastServerVersion() || /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__["a"].getLastServerVersion() === '') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__["a"].setLastServerVersion(serverVersion);
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__["a"].setLastServerVersion(serverVersion);
	                    window.location.reload(true);
	                    console.log('Detected version update refreshing the page'); //eslint-disable-line no-console
	                }
	            }
	        }
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_CHANNELS,
	            channels: data.channels,
	            members: data.members
	        });
	    }, function (err) {
	        callTracker.getChannels = 0;
	        dispatchError(err, 'getChannels');
	    });
	}
	
	function getChannel(id) {
	    if (isCallInProgress('getChannel' + id)) {
	        return;
	    }
	
	    callTracker['getChannel' + id] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getChannel(id, function (data) {
	        callTracker['getChannel' + id] = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_CHANNEL,
	            channel: data.channel,
	            member: data.member
	        });
	    }, function (err) {
	        callTracker['getChannel' + id] = 0;
	        dispatchError(err, 'getChannel');
	    });
	}
	
	function updateLastViewedAt(id) {
	    var channelId = void 0;
	    if (id) {
	        channelId = id;
	    } else {
	        channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	    }
	
	    if (channelId == null) {
	        return;
	    }
	
	    if (isCallInProgress('updateLastViewed' + channelId)) {
	        return;
	    }
	
	    callTracker['updateLastViewed' + channelId] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].updateLastViewedAt(channelId, function () {
	        callTracker.updateLastViewed = 0;
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_error_store_jsx__["a"].clearLastError();
	    }, function (err) {
	        callTracker.updateLastViewed = 0;
	        var count = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_error_store_jsx__["a"].getConnectionErrorCount();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_error_store_jsx__["a"].setConnectionErrorCount(count + 1);
	        dispatchError(err, 'updateLastViewedAt');
	    });
	}
	
	function getMoreChannels(force) {
	    if (isCallInProgress('getMoreChannels')) {
	        return;
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getMoreAll().loading || force) {
	        callTracker.getMoreChannels = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getMoreChannels(function (data) {
	            callTracker.getMoreChannels = 0;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_MORE_CHANNELS,
	                channels: data.channels,
	                members: data.members
	            });
	        }, function (err) {
	            callTracker.getMoreChannels = 0;
	            dispatchError(err, 'getMoreChannels');
	        });
	    }
	}
	
	function getChannelExtraInfo(id, memberLimit) {
	    var channelId = void 0;
	    if (id) {
	        channelId = id;
	    } else {
	        channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	    }
	
	    if (channelId != null) {
	        if (isCallInProgress('getChannelExtraInfo_' + channelId)) {
	            return;
	        }
	
	        callTracker['getChannelExtraInfo_' + channelId] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getChannelExtraInfo(channelId, memberLimit, function (data) {
	            callTracker['getChannelExtraInfo_' + channelId] = 0;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_CHANNEL_EXTRA_INFO,
	                extra_info: data
	            });
	        }, function (err) {
	            callTracker['getChannelExtraInfo_' + channelId] = 0;
	            dispatchError(err, 'getChannelExtraInfo');
	        });
	    }
	}
	
	function getTeamMembers(teamId) {
	    if (isCallInProgress('getTeamMembers')) {
	        return;
	    }
	
	    callTracker.getTeamMembers = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getTeamMembers(teamId, function (data) {
	        callTracker.getTeamMembers = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_MEMBERS_FOR_TEAM,
	            team_members: data
	        });
	    }, function (err) {
	        callTracker.getTeamMembers = 0;
	        dispatchError(err, 'getTeamMembers');
	    });
	}
	
	function getProfilesForDirectMessageList() {
	    if (isCallInProgress('getProfilesForDirectMessageList')) {
	        return;
	    }
	
	    callTracker.getProfilesForDirectMessageList = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getProfilesForDirectMessageList(function (data) {
	        callTracker.getProfilesForDirectMessageList = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_PROFILES_FOR_DM_LIST,
	            profiles: data
	        });
	    }, function (err) {
	        callTracker.getProfilesForDirectMessageList = 0;
	        dispatchError(err, 'getProfilesForDirectMessageList');
	    });
	}
	
	function getProfiles() {
	    if (isCallInProgress('getProfiles')) {
	        return;
	    }
	
	    callTracker.getProfiles = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getProfiles(function (data) {
	        callTracker.getProfiles = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_PROFILES,
	            profiles: data
	        });
	    }, function (err) {
	        callTracker.getProfiles = 0;
	        dispatchError(err, 'getProfiles');
	    });
	}
	
	function getDirectProfiles() {
	    if (isCallInProgress('getDirectProfiles')) {
	        return;
	    }
	
	    callTracker.getDirectProfiles = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getDirectProfiles(function (data) {
	        callTracker.getDirectProfiles = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_DIRECT_PROFILES,
	            profiles: data
	        });
	    }, function (err) {
	        callTracker.getDirectProfiles = 0;
	        dispatchError(err, 'getDirectProfiles');
	    });
	}
	
	function getSessions() {
	    if (isCallInProgress('getSessions')) {
	        return;
	    }
	
	    callTracker.getSessions = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getSessions(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentId(), function (data) {
	        callTracker.getSessions = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_SESSIONS,
	            sessions: data
	        });
	    }, function (err) {
	        callTracker.getSessions = 0;
	        dispatchError(err, 'getSessions');
	    });
	}
	
	function getAudits() {
	    if (isCallInProgress('getAudits')) {
	        return;
	    }
	
	    callTracker.getAudits = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAudits(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentId(), function (data) {
	        callTracker.getAudits = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_AUDITS,
	            audits: data
	        });
	    }, function (err) {
	        callTracker.getAudits = 0;
	        dispatchError(err, 'getAudits');
	    });
	}
	
	function getLogs() {
	    if (isCallInProgress('getLogs')) {
	        return;
	    }
	
	    callTracker.getLogs = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getLogs(function (data) {
	        callTracker.getLogs = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_LOGS,
	            logs: data
	        });
	    }, function (err) {
	        callTracker.getLogs = 0;
	        dispatchError(err, 'getLogs');
	    });
	}
	
	function getServerAudits() {
	    if (isCallInProgress('getServerAudits')) {
	        return;
	    }
	
	    callTracker.getServerAudits = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getServerAudits(function (data) {
	        callTracker.getServerAudits = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_SERVER_AUDITS,
	            audits: data
	        });
	    }, function (err) {
	        callTracker.getServerAudits = 0;
	        dispatchError(err, 'getServerAudits');
	    });
	}
	
	function getComplianceReports() {
	    if (isCallInProgress('getComplianceReports')) {
	        return;
	    }
	
	    callTracker.getComplianceReports = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getComplianceReports(function (data) {
	        callTracker.getComplianceReports = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_SERVER_COMPLIANCE_REPORTS,
	            complianceReports: data
	        });
	    }, function (err) {
	        callTracker.getComplianceReports = 0;
	        dispatchError(err, 'getComplianceReports');
	    });
	}
	
	function getConfig() {
	    if (isCallInProgress('getConfig')) {
	        return;
	    }
	
	    callTracker.getConfig = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getConfig(function (data) {
	        callTracker.getConfig = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_CONFIG,
	            config: data
	        });
	    }, function (err) {
	        callTracker.getConfig = 0;
	        dispatchError(err, 'getConfig');
	    });
	}
	
	function getAllTeams() {
	    if (isCallInProgress('getAllTeams')) {
	        return;
	    }
	
	    callTracker.getAllTeams = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAllTeams(function (data) {
	        callTracker.getAllTeams = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ALL_TEAMS,
	            teams: data
	        });
	    }, function (err) {
	        callTracker.getAllTeams = 0;
	        dispatchError(err, 'getAllTeams');
	    });
	}
	
	function getAllTeamListings() {
	    if (isCallInProgress('getAllTeamListings')) {
	        return;
	    }
	
	    callTracker.getAllTeamListings = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAllTeamListings(function (data) {
	        callTracker.getAllTeamListings = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ALL_TEAM_LISTINGS,
	            teams: data
	        });
	    }, function (err) {
	        callTracker.getAllTeams = 0;
	        dispatchError(err, 'getAllTeamListings');
	    });
	}
	
	function search(terms, isOrSearch) {
	    if (isCallInProgress('search_' + String(terms))) {
	        return;
	    }
	
	    callTracker['search_' + String(terms)] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].search(terms, isOrSearch, function (data) {
	        callTracker['search_' + String(terms)] = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_SEARCH,
	            results: data
	        });
	    }, function (err) {
	        callTracker['search_' + String(terms)] = 0;
	        dispatchError(err, 'search');
	    });
	}
	
	function getPostsPage(id, maxPosts) {
	    var channelId = id;
	    if (channelId == null) {
	        channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	        if (channelId == null) {
	            return;
	        }
	    }
	
	    if (isCallInProgress('getPostsPage_' + channelId)) {
	        return;
	    }
	
	    var postList = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].getAllPosts(id);
	
	    var max = maxPosts;
	    if (max == null) {
	        max = /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].POST_CHUNK_SIZE * /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].MAX_POST_CHUNKS;
	    }
	
	    // if we already have more than POST_CHUNK_SIZE posts,
	    //   let's get the amount we have but rounded up to next multiple of POST_CHUNK_SIZE,
	    //   with a max at maxPosts
	    var numPosts = Math.min(max, /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].POST_CHUNK_SIZE);
	    if (postList && postList.order.length > 0) {
	        numPosts = Math.min(max, /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].POST_CHUNK_SIZE * Math.ceil(postList.order.length / /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].POST_CHUNK_SIZE));
	    }
	
	    if (channelId != null) {
	        callTracker['getPostsPage_' + channelId] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getPostsPage(channelId, 0, numPosts, function (data) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_POSTS,
	                id: channelId,
	                before: true,
	                numRequested: numPosts,
	                post_list: data
	            });
	
	            getProfiles();
	        }, function (err) {
	            dispatchError(err, 'getPostsPage');
	        }, function () {
	            callTracker['getPostsPage_' + channelId] = 0;
	        });
	    }
	}
	
	function getPosts(id) {
	    var channelId = id;
	    if (channelId == null) {
	        channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	        if (channelId == null) {
	            return;
	        }
	    }
	
	    if (isCallInProgress('getPosts_' + channelId)) {
	        return;
	    }
	
	    var postList = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].getAllPosts(channelId);
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.isEmptyObject(postList) || postList.order.length < /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].POST_CHUNK_SIZE) {
	        getPostsPage(channelId, /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].POST_CHUNK_SIZE);
	        return;
	    }
	
	    var latestPost = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].getLatestPost(channelId);
	    var latestPostTime = 0;
	
	    if (latestPost != null && latestPost.update_at != null) {
	        latestPostTime = latestPost.create_at;
	    }
	
	    callTracker['getPosts_' + channelId] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getPosts(channelId, latestPostTime, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_POSTS,
	            id: channelId,
	            before: true,
	            numRequested: 0,
	            post_list: data
	        });
	
	        getProfiles();
	    }, function (err) {
	        dispatchError(err, 'getPosts');
	    }, function () {
	        callTracker['getPosts_' + channelId] = 0;
	    });
	}
	
	function getPostsBefore(postId, offset, numPost) {
	    var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	    if (channelId == null) {
	        return;
	    }
	
	    if (isCallInProgress('getPostsBefore_' + channelId)) {
	        return;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getPostsBefore(channelId, postId, offset, numPost, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_POSTS,
	            id: channelId,
	            before: true,
	            numRequested: numPost,
	            post_list: data
	        });
	
	        getProfiles();
	    }, function (err) {
	        dispatchError(err, 'getPostsBefore');
	    }, function () {
	        callTracker['getPostsBefore_' + channelId] = 0;
	    });
	}
	
	function getPostsAfter(postId, offset, numPost) {
	    var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	    if (channelId == null) {
	        return;
	    }
	
	    if (isCallInProgress('getPostsAfter_' + channelId)) {
	        return;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getPostsAfter(channelId, postId, offset, numPost, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_POSTS,
	            id: channelId,
	            before: false,
	            numRequested: numPost,
	            post_list: data
	        });
	
	        getProfiles();
	    }, function (err) {
	        dispatchError(err, 'getPostsAfter');
	    }, function () {
	        callTracker['getPostsAfter_' + channelId] = 0;
	    });
	}
	
	function getMe() {
	    if (isCallInProgress('getMe')) {
	        return null;
	    }
	
	    callTracker.getMe = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getMe(function (data) {
	        callTracker.getMe = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ME,
	            me: data
	        });
	
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_4_action_creators_global_actions_jsx__.newLocalizationSelected(data.locale);
	    }, function (err) {
	        callTracker.getMe = 0;
	        dispatchError(err, 'getMe');
	    });
	}
	
	function getStatuses() {
	    var preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_preference_store_jsx__["a"].getCategory(/* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
	
	    var teammateIds = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(preferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	            var name = _step$value[0];
	            var value = _step$value[1];
	
	            if (value === 'true') {
	                teammateIds.push(name);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    if (isCallInProgress('getStatuses') || teammateIds.length === 0) {
	        return;
	    }
	
	    callTracker.getStatuses = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getStatuses(teammateIds, function (data) {
	        callTracker.getStatuses = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_STATUSES,
	            statuses: data
	        });
	    }, function (err) {
	        callTracker.getStatuses = 0;
	        dispatchError(err, 'getStatuses');
	    });
	}
	
	function getMyTeam() {
	    if (isCallInProgress('getMyTeam')) {
	        return null;
	    }
	
	    callTracker.getMyTeam = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getMyTeam(function (data) {
	        callTracker.getMyTeam = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_MY_TEAM,
	            team: data
	        });
	    }, function (err) {
	        callTracker.getMyTeam = 0;
	        dispatchError(err, 'getMyTeam');
	    });
	}
	
	function getAllPreferences() {
	    if (isCallInProgress('getAllPreferences')) {
	        return;
	    }
	
	    callTracker.getAllPreferences = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAllPreferences(function (data) {
	        callTracker.getAllPreferences = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_PREFERENCES,
	            preferences: data
	        });
	    }, function (err) {
	        callTracker.getAllPreferences = 0;
	        dispatchError(err, 'getAllPreferences');
	    });
	}
	
	function savePreference(category, name, value, success, error) {
	    var preference = {
	        user_id: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentId(),
	        category: category,
	        name: name,
	        value: value
	    };
	
	    savePreferences([preference], success, error);
	}
	
	function savePreferences(preferences, success, error) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].savePreferences(preferences, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_PREFERENCES,
	            preferences: preferences
	        });
	
	        if (success) {
	            success(data);
	        }
	    }, function (err) {
	        dispatchError(err, 'savePreferences');
	
	        if (error) {
	            error();
	        }
	    });
	}
	
	function getSuggestedCommands(command, suggestionId, component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].listCommands(function (data) {
	        var matches = [];
	        data.forEach(function (cmd) {
	            if (('/' + cmd.trigger).indexOf(command) === 0) {
	                var s = '/' + cmd.trigger;
	                var hint = '';
	                if (cmd.auto_complete_hint && cmd.auto_complete_hint.length !== 0) {
	                    hint = cmd.auto_complete_hint;
	                }
	                matches.push({
	                    suggestion: s,
	                    hint: hint,
	                    description: cmd.auto_complete_desc
	                });
	            }
	        });
	
	        matches = matches.sort(function (a, b) {
	            return a.suggestion.localeCompare(b.suggestion);
	        });
	
	        // pull out the suggested commands from the returned data
	        var terms = matches.map(function (suggestion) {
	            return suggestion.suggestion;
	        });
	
	        if (terms.length > 0) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
	                id: suggestionId,
	                matchedPretext: command,
	                terms: terms,
	                items: matches,
	                component: component
	            });
	        }
	    }, function (err) {
	        dispatchError(err, 'getCommandSuggestions');
	    });
	}
	
	function getFileInfo(filename) {
	    var callName = 'getFileInfo' + filename;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getFileInfo(filename, function (data) {
	        callTracker[callName] = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_FILE_INFO,
	            filename: filename,
	            info: data
	        });
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        dispatchError(err, 'getFileInfo');
	    });
	}
	
	function getStandardAnalytics(teamId) {
	    var callName = 'getStandardAnaytics' + teamId;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAnalytics('standard', teamId, function (data) {
	        callTracker[callName] = 0;
	
	        var stats = {};
	
	        for (var index in data) {
	            if (data[index].name === 'channel_open_count') {
	                stats[StatTypes.TOTAL_PUBLIC_CHANNELS] = data[index].value;
	            }
	
	            if (data[index].name === 'channel_private_count') {
	                stats[StatTypes.TOTAL_PRIVATE_GROUPS] = data[index].value;
	            }
	
	            if (data[index].name === 'post_count') {
	                stats[StatTypes.TOTAL_POSTS] = data[index].value;
	            }
	
	            if (data[index].name === 'unique_user_count') {
	                stats[StatTypes.TOTAL_USERS] = data[index].value;
	            }
	
	            if (data[index].name === 'team_count' && teamId == null) {
	                stats[StatTypes.TOTAL_TEAMS] = data[index].value;
	            }
	        }
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ANALYTICS,
	            teamId: teamId,
	            stats: stats
	        });
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        dispatchError(err, 'getStandardAnalytics');
	    });
	}
	
	function getAdvancedAnalytics(teamId) {
	    var callName = 'getAdvancedAnalytics' + teamId;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAnalytics('extra_counts', teamId, function (data) {
	        callTracker[callName] = 0;
	
	        var stats = {};
	
	        for (var index in data) {
	            if (data[index].name === 'file_post_count') {
	                stats[StatTypes.TOTAL_FILE_POSTS] = data[index].value;
	            }
	
	            if (data[index].name === 'hashtag_post_count') {
	                stats[StatTypes.TOTAL_HASHTAG_POSTS] = data[index].value;
	            }
	
	            if (data[index].name === 'incoming_webhook_count') {
	                stats[StatTypes.TOTAL_IHOOKS] = data[index].value;
	            }
	
	            if (data[index].name === 'outgoing_webhook_count') {
	                stats[StatTypes.TOTAL_OHOOKS] = data[index].value;
	            }
	
	            if (data[index].name === 'command_count') {
	                stats[StatTypes.TOTAL_COMMANDS] = data[index].value;
	            }
	
	            if (data[index].name === 'session_count') {
	                stats[StatTypes.TOTAL_SESSIONS] = data[index].value;
	            }
	        }
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ANALYTICS,
	            teamId: teamId,
	            stats: stats
	        });
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        dispatchError(err, 'getAdvancedAnalytics');
	    });
	}
	
	function getPostsPerDayAnalytics(teamId) {
	    var callName = 'getPostsPerDayAnalytics' + teamId;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAnalytics('post_counts_day', teamId, function (data) {
	        callTracker[callName] = 0;
	
	        data.reverse();
	
	        var stats = {};
	        stats[StatTypes.POST_PER_DAY] = data;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ANALYTICS,
	            teamId: teamId,
	            stats: stats
	        });
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        dispatchError(err, 'getPostsPerDayAnalytics');
	    });
	}
	
	function getUsersPerDayAnalytics(teamId) {
	    var callName = 'getUsersPerDayAnalytics' + teamId;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getAnalytics('user_counts_with_posts_day', teamId, function (data) {
	        callTracker[callName] = 0;
	
	        data.reverse();
	
	        var stats = {};
	        stats[StatTypes.USERS_WITH_POSTS_PER_DAY] = data;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ANALYTICS,
	            teamId: teamId,
	            stats: stats
	        });
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        dispatchError(err, 'getUsersPerDayAnalytics');
	    });
	}
	
	function getRecentAndNewUsersAnalytics(teamId) {
	    var callName = 'getRecentAndNewUsersAnalytics' + teamId;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getProfilesForTeam(teamId, function (users) {
	        var stats = {};
	
	        var usersList = [];
	        for (var id in users) {
	            if (users.hasOwnProperty(id)) {
	                usersList.push(users[id]);
	            }
	        }
	
	        usersList.sort(function (a, b) {
	            if (a.last_activity_at < b.last_activity_at) {
	                return 1;
	            }
	
	            if (a.last_activity_at > b.last_activity_at) {
	                return -1;
	            }
	
	            return 0;
	        });
	
	        var recentActive = [];
	        for (var i = 0; i < usersList.length; i++) {
	            if (usersList[i].last_activity_at == null) {
	                continue;
	            }
	
	            recentActive.push(usersList[i]);
	            if (i >= /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].STAT_MAX_ACTIVE_USERS) {
	                break;
	            }
	        }
	
	        stats[StatTypes.RECENTLY_ACTIVE_USERS] = recentActive;
	
	        usersList.sort(function (a, b) {
	            if (a.create_at < b.create_at) {
	                return 1;
	            }
	
	            if (a.create_at > b.create_at) {
	                return -1;
	            }
	
	            return 0;
	        });
	
	        var newlyCreated = [];
	        for (var _i = 0; _i < usersList.length; _i++) {
	            newlyCreated.push(usersList[_i]);
	            if (_i >= /* harmony import */__WEBPACK_IMPORTED_MODULE_13__constants_jsx__["a"].STAT_MAX_NEW_USERS) {
	                break;
	            }
	        }
	
	        stats[StatTypes.NEWLY_CREATED_USERS] = newlyCreated;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_ANALYTICS,
	            teamId: teamId,
	            stats: stats
	        });
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        dispatchError(err, 'getRecentAndNewUsersAnalytics');
	    });
	}
	
	function listIncomingHooks() {
	    if (isCallInProgress('listIncomingHooks')) {
	        return;
	    }
	
	    callTracker.listIncomingHooks = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].listIncomingHooks(function (data) {
	        callTracker.listIncomingHooks = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_INCOMING_WEBHOOKS,
	            teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].teamId,
	            incomingWebhooks: data
	        });
	    }, function (err) {
	        callTracker.listIncomingHooks = 0;
	        dispatchError(err, 'getIncomingHooks');
	    });
	}
	
	function listOutgoingHooks() {
	    if (isCallInProgress('listOutgoingHooks')) {
	        return;
	    }
	
	    callTracker.listOutgoingHooks = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].listOutgoingHooks(function (data) {
	        callTracker.listOutgoingHooks = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_OUTGOING_WEBHOOKS,
	            teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].teamId,
	            outgoingWebhooks: data
	        });
	    }, function (err) {
	        callTracker.listOutgoingHooks = 0;
	        dispatchError(err, 'getOutgoingHooks');
	    });
	}
	
	function addIncomingHook(hook, success, error) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].addIncomingHook(hook, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_INCOMING_WEBHOOK,
	            incomingWebhook: data
	        });
	
	        if (success) {
	            success();
	        }
	    }, function (err) {
	        if (error) {
	            error(err);
	        } else {
	            dispatchError(err, 'addIncomingHook');
	        }
	    });
	}
	
	function addOutgoingHook(hook, success, error) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].addOutgoingHook(hook, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_OUTGOING_WEBHOOK,
	            outgoingWebhook: data
	        });
	
	        if (success) {
	            success();
	        }
	    }, function (err) {
	        if (error) {
	            error(err);
	        } else {
	            dispatchError(err, 'addOutgoingHook');
	        }
	    });
	}
	
	function deleteIncomingHook(id) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].deleteIncomingHook(id, function () {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.REMOVED_INCOMING_WEBHOOK,
	            teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].teamId,
	            id: id
	        });
	    }, function (err) {
	        dispatchError(err, 'deleteIncomingHook');
	    });
	}
	
	function deleteOutgoingHook(id) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].deleteOutgoingHook(id, function () {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.REMOVED_OUTGOING_WEBHOOK,
	            teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].teamId,
	            id: id
	        });
	    }, function (err) {
	        dispatchError(err, 'deleteOutgoingHook');
	    });
	}
	
	function regenOutgoingHookToken(id) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].regenOutgoingHookToken(id, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.UPDATED_OUTGOING_WEBHOOK,
	            outgoingWebhook: data
	        });
	    }, function (err) {
	        dispatchError(err, 'regenOutgoingHookToken');
	    });
	}
	
	function listTeamCommands() {
	    if (isCallInProgress('listTeamCommands')) {
	        return;
	    }
	
	    callTracker.listTeamCommands = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].listTeamCommands(function (data) {
	        callTracker.listTeamCommands = 0;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_COMMANDS,
	            teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].teamId,
	            commands: data
	        });
	    }, function (err) {
	        callTracker.listTeamCommands = 0;
	        dispatchError(err, 'listTeamCommands');
	    });
	}
	
	function addCommand(command, success, error) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].addCommand(command, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_COMMAND,
	            command: data
	        });
	
	        if (success) {
	            success();
	        }
	    }, function (err) {
	        if (error) {
	            error(err);
	        } else {
	            dispatchError(err, 'addCommand');
	        }
	    });
	}
	
	function deleteCommand(id) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].deleteCommand(id, function () {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.REMOVED_COMMAND,
	            teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].teamId,
	            id: id
	        });
	    }, function (err) {
	        dispatchError(err, 'deleteCommand');
	    });
	}
	
	function regenCommandToken(id) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].regenCommandToken(id, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.UPDATED_COMMAND,
	            command: data
	        });
	    }, function (err) {
	        dispatchError(err, 'regenCommandToken');
	    });
	}
	
	function getPublicLink(filename, success, error) {
	    var callName = 'getPublicLink' + filename;
	
	    if (isCallInProgress(callName)) {
	        return;
	    }
	
	    callTracker[callName] = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.getTimestamp();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3__web_client_jsx__["a"].getPublicLink(filename, function (link) {
	        callTracker[callName] = 0;
	
	        success(link);
	    }, function (err) {
	        callTracker[callName] = 0;
	
	        if (error) {
	            error(err);
	        } else {
	            dispatchError(err, 'getPublicLink');
	        }
	    });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __WEBPACK_IMPORTED_MODULE_7_events__ && __WEBPACK_IMPORTED_MODULE_7_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT_DM_LIST = 'change_dm_list';
	var CHANGE_EVENT = 'change';
	var CHANGE_EVENT_SESSIONS = 'change_sessions';
	var CHANGE_EVENT_AUDITS = 'change_audits';
	var CHANGE_EVENT_STATUSES = 'change_statuses';
	
	var Utils;
	
	var UserStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(UserStoreClass, _EventEmitter);
	
	    function UserStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserStoreClass).call(this));
	
	        _this.clear();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(UserStoreClass, [{
	        key: 'clear',
	        value: function clear() {
	            this.profiles_for_dm_list = {};
	            this.profiles = {};
	            this.direct_profiles = {};
	            this.statuses = {};
	            this.sessions = {};
	            this.audits = {};
	            this.currentUserId = '';
	            this.noAccounts = false;
	        }
	    }, {
	        key: 'emitChange',
	        value: function emitChange(userId) {
	            this.emit(CHANGE_EVENT, userId);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitDmListChange',
	        value: function emitDmListChange() {
	            this.emit(CHANGE_EVENT_DM_LIST);
	        }
	    }, {
	        key: 'addDmListChangeListener',
	        value: function addDmListChangeListener(callback) {
	            this.on(CHANGE_EVENT_DM_LIST, callback);
	        }
	    }, {
	        key: 'removeDmListChangeListener',
	        value: function removeDmListChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT_DM_LIST, callback);
	        }
	    }, {
	        key: 'emitSessionsChange',
	        value: function emitSessionsChange() {
	            this.emit(CHANGE_EVENT_SESSIONS);
	        }
	    }, {
	        key: 'addSessionsChangeListener',
	        value: function addSessionsChangeListener(callback) {
	            this.on(CHANGE_EVENT_SESSIONS, callback);
	        }
	    }, {
	        key: 'removeSessionsChangeListener',
	        value: function removeSessionsChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT_SESSIONS, callback);
	        }
	    }, {
	        key: 'emitAuditsChange',
	        value: function emitAuditsChange() {
	            this.emit(CHANGE_EVENT_AUDITS);
	        }
	    }, {
	        key: 'addAuditsChangeListener',
	        value: function addAuditsChangeListener(callback) {
	            this.on(CHANGE_EVENT_AUDITS, callback);
	        }
	    }, {
	        key: 'removeAuditsChangeListener',
	        value: function removeAuditsChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT_AUDITS, callback);
	        }
	    }, {
	        key: 'emitStatusesChange',
	        value: function emitStatusesChange() {
	            this.emit(CHANGE_EVENT_STATUSES);
	        }
	    }, {
	        key: 'addStatusesChangeListener',
	        value: function addStatusesChangeListener(callback) {
	            this.on(CHANGE_EVENT_STATUSES, callback);
	        }
	    }, {
	        key: 'removeStatusesChangeListener',
	        value: function removeStatusesChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT_STATUSES, callback);
	        }
	    }, {
	        key: 'getCurrentUser',
	        value: function getCurrentUser() {
	            return this.getProfiles()[this.currentUserId];
	        }
	    }, {
	        key: 'setCurrentUser',
	        value: function setCurrentUser(user) {
	            this.saveProfile(user);
	            this.currentUserId = user.id;
	            global.window.mm_current_user_id = this.currentUserId;
	        }
	    }, {
	        key: 'getCurrentId',
	        value: function getCurrentId() {
	            var user = this.getCurrentUser();
	
	            if (user) {
	                return user.id;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'hasProfile',
	        value: function hasProfile(userId) {
	            return this.getProfile(userId) != null;
	        }
	    }, {
	        key: 'hasTeamProfile',
	        value: function hasTeamProfile(userId) {
	            return this.getProfiles()[userId];
	        }
	    }, {
	        key: 'hasDirectProfile',
	        value: function hasDirectProfile(userId) {
	            return this.getDirectProfiles()[userId];
	        }
	    }, {
	        key: 'getProfile',
	        value: function getProfile(userId) {
	            if (userId === this.getCurrentId()) {
	                return this.getCurrentUser();
	            }
	
	            var user = this.getProfiles()[userId];
	            if (user) {
	                return user;
	            }
	
	            return this.getDirectProfiles()[userId];
	        }
	    }, {
	        key: 'getProfileByUsername',
	        value: function getProfileByUsername(username) {
	            return this.getProfilesUsernameMap()[username];
	        }
	    }, {
	        key: 'getProfilesUsernameMap',
	        value: function getProfilesUsernameMap() {
	            var profileUsernameMap = {};
	
	            var profiles = this.getProfiles();
	            for (var key in profiles) {
	                if (profiles.hasOwnProperty(key)) {
	                    var profile = profiles[key];
	                    profileUsernameMap[profile.username] = profile;
	                }
	            }
	
	            return profileUsernameMap;
	        }
	    }, {
	        key: 'getDirectProfiles',
	        value: function getDirectProfiles() {
	            return this.direct_profiles;
	        }
	    }, {
	        key: 'saveDirectProfiles',
	        value: function saveDirectProfiles(profiles) {
	            this.direct_profiles = profiles;
	        }
	    }, {
	        key: 'getProfiles',
	        value: function getProfiles() {
	            return this.profiles;
	        }
	    }, {
	        key: 'getActiveOnlyProfiles',
	        value: function getActiveOnlyProfiles(skipCurrent) {
	            var active = {};
	            var profiles = this.getProfiles();
	            var currentId = this.getCurrentId();
	
	            for (var key in profiles) {
	                if (!(profiles[key].id === currentId && skipCurrent) && profiles[key].delete_at === 0) {
	                    active[key] = profiles[key];
	                }
	            }
	
	            return active;
	        }
	    }, {
	        key: 'getActiveOnlyProfileList',
	        value: function getActiveOnlyProfileList() {
	            var profileMap = this.getActiveOnlyProfiles();
	            var profiles = [];
	            var currentId = this.getCurrentId();
	
	            for (var id in profileMap) {
	                if (profileMap.hasOwnProperty(id) && id !== currentId) {
	                    profiles.push(profileMap[id]);
	                }
	            }
	
	            return profiles;
	        }
	    }, {
	        key: 'saveProfile',
	        value: function saveProfile(profile) {
	            this.profiles[profile.id] = profile;
	        }
	    }, {
	        key: 'saveProfiles',
	        value: function saveProfiles(profiles) {
	            var currentId = this.getCurrentId();
	            var currentUser = this.profiles[currentId];
	            if (currentUser) {
	                if (currentId in this.profiles) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(this.profiles, currentId);
	                }
	
	                this.profiles = profiles;
	                this.profiles[currentId] = currentUser;
	            } else {
	                this.profiles = profiles;
	            }
	        }
	    }, {
	        key: 'getProfilesForDmList',
	        value: function getProfilesForDmList() {
	            var currentId = this.getCurrentId();
	            var profiles = [];
	
	            for (var id in this.profiles_for_dm_list) {
	                if (this.profiles_for_dm_list.hasOwnProperty(id) && id !== currentId) {
	                    var profile = this.profiles_for_dm_list[id];
	
	                    if (profile.delete_at === 0) {
	                        profiles.push(profile);
	                    }
	                }
	            }
	
	            profiles.sort(function (a, b) {
	                return a.username.localeCompare(b.username);
	            });
	
	            return profiles;
	        }
	    }, {
	        key: 'saveProfilesForDmList',
	        value: function saveProfilesForDmList(profiles) {
	            this.profiles_for_dm_list = profiles;
	        }
	    }, {
	        key: 'setSessions',
	        value: function setSessions(sessions) {
	            this.sessions = sessions;
	        }
	    }, {
	        key: 'getSessions',
	        value: function getSessions() {
	            return this.sessions;
	        }
	    }, {
	        key: 'setAudits',
	        value: function setAudits(audits) {
	            this.audits = audits;
	        }
	    }, {
	        key: 'getAudits',
	        value: function getAudits() {
	            return this.audits;
	        }
	    }, {
	        key: 'getCurrentMentionKeys',
	        value: function getCurrentMentionKeys() {
	            return this.getMentionKeys(this.getCurrentId());
	        }
	    }, {
	        key: 'getMentionKeys',
	        value: function getMentionKeys(id) {
	            var user = this.getProfile(id);
	
	            var keys = [];
	
	            if (!user || !user.notify_props) {
	                return keys;
	            }
	
	            if (user.notify_props.mention_keys) {
	                keys = keys.concat(user.notify_props.mention_keys.split(','));
	            }
	
	            if (user.notify_props.first_name === 'true' && user.first_name) {
	                keys.push(user.first_name);
	            }
	
	            if (user.notify_props.all === 'true') {
	                keys.push('@all');
	            }
	
	            if (user.notify_props.channel === 'true') {
	                keys.push('@channel');
	            }
	
	            return keys;
	        }
	    }, {
	        key: 'setStatuses',
	        value: function setStatuses(statuses) {
	            this.pSetStatuses(statuses);
	            this.emitStatusesChange();
	        }
	    }, {
	        key: 'pSetStatuses',
	        value: function pSetStatuses(statuses) {
	            this.statuses = statuses;
	        }
	    }, {
	        key: 'setStatus',
	        value: function setStatus(userId, status) {
	            var statuses = this.getStatuses();
	            statuses[userId] = status;
	            this.pSetStatuses(statuses);
	            this.emitStatusesChange();
	        }
	    }, {
	        key: 'getStatuses',
	        value: function getStatuses() {
	            return this.statuses;
	        }
	    }, {
	        key: 'getStatus',
	        value: function getStatus(id) {
	            return this.getStatuses()[id];
	        }
	    }, {
	        key: 'getNoAccounts',
	        value: function getNoAccounts() {
	            return this.noAccounts;
	        }
	    }, {
	        key: 'setNoAccounts',
	        value: function setNoAccounts(noAccounts) {
	            this.noAccounts = noAccounts;
	        }
	    }, {
	        key: 'isSystemAdminForCurrentUser',
	        value: function isSystemAdminForCurrentUser() {
	            if (!Utils) {
	                Utils = __webpack_require__(8); //eslint-disable-line global-require
	            }
	
	            var current = this.getCurrentUser();
	
	            if (current) {
	                return Utils.isAdmin(current.roles);
	            }
	
	            return false;
	        }
	    }]);
	
	    return UserStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_events___default.a);
	
	var UserStore = new UserStoreClass();
	UserStore.setMaxListeners(15);
	
	UserStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_PROFILES_FOR_DM_LIST:
	            UserStore.saveProfilesForDmList(action.profiles);
	            UserStore.emitDmListChange();
	            break;
	        case ActionTypes.RECEIVED_PROFILES:
	            UserStore.saveProfiles(action.profiles);
	            UserStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_DIRECT_PROFILES:
	            UserStore.saveDirectProfiles(action.profiles);
	            UserStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_ME:
	            UserStore.setCurrentUser(action.me);
	            UserStore.emitChange(action.me.id);
	            break;
	        case ActionTypes.RECEIVED_SESSIONS:
	            UserStore.setSessions(action.sessions);
	            UserStore.emitSessionsChange();
	            break;
	        case ActionTypes.RECEIVED_AUDITS:
	            UserStore.setAudits(action.audits);
	            UserStore.emitAuditsChange();
	            break;
	        case ActionTypes.RECEIVED_STATUSES:
	            UserStore.pSetStatuses(action.statuses);
	            UserStore.emitStatusesChange();
	            break;
	        default:
	    }
	});
	
	
	/* harmony export */ Object.defineProperty(exports, "a", {configurable: false, enumerable: true, get: function() { return UserStore; }});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.e) {
			module.e = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());
	


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* components */
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Router2 = __webpack_require__(1629);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	exports.Router = _Router3['default'];
	
	var _Link2 = __webpack_require__(578);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	exports.Link = _Link3['default'];
	
	var _IndexLink2 = __webpack_require__(1623);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	exports.IndexLink = _IndexLink3['default'];
	
	/* components (configuration) */
	
	var _IndexRedirect2 = __webpack_require__(1624);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	exports.IndexRedirect = _IndexRedirect3['default'];
	
	var _IndexRoute2 = __webpack_require__(1625);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	exports.IndexRoute = _IndexRoute3['default'];
	
	var _Redirect2 = __webpack_require__(579);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	exports.Redirect = _Redirect3['default'];
	
	var _Route2 = __webpack_require__(1627);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	exports.Route = _Route3['default'];
	
	/* mixins */
	
	var _History2 = __webpack_require__(1622);
	
	var _History3 = _interopRequireDefault(_History2);
	
	exports.History = _History3['default'];
	
	var _Lifecycle2 = __webpack_require__(1626);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	exports.Lifecycle = _Lifecycle3['default'];
	
	var _RouteContext2 = __webpack_require__(1628);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	exports.RouteContext = _RouteContext3['default'];
	
	/* utils */
	
	var _useRoutes2 = __webpack_require__(1640);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	exports.useRoutes = _useRoutes3['default'];
	
	var _RouteUtils = __webpack_require__(109);
	
	exports.createRoutes = _RouteUtils.createRoutes;
	
	var _RouterContext2 = __webpack_require__(318);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	exports.RouterContext = _RouterContext3['default'];
	
	var _RoutingContext2 = __webpack_require__(1630);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	exports.RoutingContext = _RoutingContext3['default'];
	
	var _PropTypes2 = __webpack_require__(134);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	exports.PropTypes = _PropTypes3['default'];
	
	var _match2 = __webpack_require__(1638);
	
	var _match3 = _interopRequireDefault(_match2);
	
	exports.match = _match3['default'];
	
	var _useRouterHistory2 = __webpack_require__(584);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	exports.useRouterHistory = _useRouterHistory3['default'];
	
	var _PatternUtils = __webpack_require__(153);
	
	exports.formatPattern = _PatternUtils.formatPattern;
	
	/* histories */
	
	var _browserHistory2 = __webpack_require__(1632);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	exports.browserHistory = _browserHistory3['default'];
	
	var _hashHistory2 = __webpack_require__(1636);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	exports.hashHistory = _hashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(581);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1285)
	var ieee754 = __webpack_require__(1467)
	var isArray = __webpack_require__(1309)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.foo = function () { return 42 }
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  that.write(string, encoding)
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'binary':
	        return binarySlice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var foundIndex = -1
	  for (var i = 0; byteOffset + i < arrLength; i++) {
	    if (read(arr, byteOffset + i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	      if (foundIndex === -1) foundIndex = i
	      if (i - foundIndex + 1 === valLength) return (byteOffset + foundIndex) * indexSize
	    } else {
	      if (foundIndex !== -1) i -= i - foundIndex
	      foundIndex = -1
	    }
	  }
	  return -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset >>= 0
	
	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)
	
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  if (Buffer.isBuffer(val)) {
	    // special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(this, val, byteOffset, encoding)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset, encoding)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; i++) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer, (function() { return this; }())))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	var _interopRequireWildcard = __webpack_require__(488)['default'];
	
	exports.__esModule = true;
	
	var _utilsChildrenValueInputValidation = __webpack_require__(312);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _Accordion2 = __webpack_require__(1551);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	exports.Accordion = _Accordion3['default'];
	
	var _Alert2 = __webpack_require__(1552);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	exports.Alert = _Alert3['default'];
	
	var _Badge2 = __webpack_require__(1553);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	exports.Badge = _Badge3['default'];
	
	var _Breadcrumb2 = __webpack_require__(1554);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	exports.Breadcrumb = _Breadcrumb3['default'];
	
	var _BreadcrumbItem2 = __webpack_require__(1555);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	
	var _Button2 = __webpack_require__(133);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	exports.Button = _Button3['default'];
	
	var _ButtonGroup2 = __webpack_require__(554);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	exports.ButtonGroup = _ButtonGroup3['default'];
	
	var _ButtonInput2 = __webpack_require__(1556);
	
	var _ButtonInput3 = _interopRequireDefault(_ButtonInput2);
	
	exports.ButtonInput = _ButtonInput3['default'];
	
	var _ButtonToolbar2 = __webpack_require__(1557);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	
	var _Carousel2 = __webpack_require__(1558);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	exports.Carousel = _Carousel3['default'];
	
	var _CarouselItem2 = __webpack_require__(1559);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	exports.CarouselItem = _CarouselItem3['default'];
	
	var _Col2 = __webpack_require__(555);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	exports.Col = _Col3['default'];
	
	var _CollapsibleNav2 = __webpack_require__(1560);
	
	var _CollapsibleNav3 = _interopRequireDefault(_CollapsibleNav2);
	
	exports.CollapsibleNav = _CollapsibleNav3['default'];
	
	var _Dropdown2 = __webpack_require__(227);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	exports.Dropdown = _Dropdown3['default'];
	
	var _DropdownButton2 = __webpack_require__(1561);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	exports.DropdownButton = _DropdownButton3['default'];
	
	var _Glyphicon2 = __webpack_require__(308);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	exports.Glyphicon = _Glyphicon3['default'];
	
	var _Grid2 = __webpack_require__(309);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	exports.Grid = _Grid3['default'];
	
	var _Image2 = __webpack_require__(1564);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	exports.Image = _Image3['default'];
	
	var _Input2 = __webpack_require__(1565);
	
	var _Input3 = _interopRequireDefault(_Input2);
	
	exports.Input = _Input3['default'];
	
	var _Interpolate2 = __webpack_require__(559);
	
	var _Interpolate3 = _interopRequireDefault(_Interpolate2);
	
	exports.Interpolate = _Interpolate3['default'];
	
	var _Jumbotron2 = __webpack_require__(1566);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	exports.Jumbotron = _Jumbotron3['default'];
	
	var _Label2 = __webpack_require__(1567);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	exports.Label = _Label3['default'];
	
	var _ListGroup2 = __webpack_require__(1568);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	exports.ListGroup = _ListGroup3['default'];
	
	var _ListGroupItem2 = __webpack_require__(560);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	exports.ListGroupItem = _ListGroupItem3['default'];
	
	var _MenuItem2 = __webpack_require__(1569);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	exports.MenuItem = _MenuItem3['default'];
	
	var _Modal2 = __webpack_require__(1570);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	exports.Modal = _Modal3['default'];
	
	var _ModalBody2 = __webpack_require__(561);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	exports.ModalBody = _ModalBody3['default'];
	
	var _ModalFooter2 = __webpack_require__(562);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	exports.ModalFooter = _ModalFooter3['default'];
	
	var _ModalHeader2 = __webpack_require__(563);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	exports.ModalHeader = _ModalHeader3['default'];
	
	var _ModalTitle2 = __webpack_require__(564);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	exports.ModalTitle = _ModalTitle3['default'];
	
	var _Nav2 = __webpack_require__(565);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	exports.Nav = _Nav3['default'];
	
	var _Navbar2 = __webpack_require__(1573);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	exports.Navbar = _Navbar3['default'];
	
	var _NavBrand2 = __webpack_require__(566);
	
	var _NavBrand3 = _interopRequireDefault(_NavBrand2);
	
	exports.NavBrand = _NavBrand3['default'];
	
	var _NavbarBrand2 = __webpack_require__(311);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	exports.NavbarBrand = _NavbarBrand3['default'];
	
	var _NavDropdown2 = __webpack_require__(1572);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	exports.NavDropdown = _NavDropdown3['default'];
	
	var _NavItem2 = __webpack_require__(567);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	exports.NavItem = _NavItem3['default'];
	
	var _Overlay2 = __webpack_require__(568);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	exports.Overlay = _Overlay3['default'];
	
	var _OverlayTrigger2 = __webpack_require__(1577);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	
	var _PageHeader2 = __webpack_require__(1578);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	exports.PageHeader = _PageHeader3['default'];
	
	var _PageItem2 = __webpack_require__(1579);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	exports.PageItem = _PageItem3['default'];
	
	var _Pager2 = __webpack_require__(1580);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	exports.Pager = _Pager3['default'];
	
	var _Pagination2 = __webpack_require__(1581);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	exports.Pagination = _Pagination3['default'];
	
	var _Panel2 = __webpack_require__(1583);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	exports.Panel = _Panel3['default'];
	
	var _PanelGroup2 = __webpack_require__(569);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	exports.PanelGroup = _PanelGroup3['default'];
	
	var _Popover2 = __webpack_require__(1584);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	exports.Popover = _Popover3['default'];
	
	var _ProgressBar2 = __webpack_require__(1585);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	exports.ProgressBar = _ProgressBar3['default'];
	
	var _ResponsiveEmbed2 = __webpack_require__(1586);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	
	var _Row2 = __webpack_require__(1587);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	exports.Row = _Row3['default'];
	
	var _SafeAnchor2 = __webpack_require__(108);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	exports.SafeAnchor = _SafeAnchor3['default'];
	
	var _SplitButton2 = __webpack_require__(1588);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	exports.SplitButton = _SplitButton3['default'];
	
	var _Tab2 = __webpack_require__(1590);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	exports.Tab = _Tab3['default'];
	
	var _Table2 = __webpack_require__(1591);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	exports.Table = _Table3['default'];
	
	var _Tabs2 = __webpack_require__(1592);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	exports.Tabs = _Tabs3['default'];
	
	var _Thumbnail2 = __webpack_require__(1593);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	exports.Thumbnail = _Thumbnail3['default'];
	
	var _Tooltip2 = __webpack_require__(1594);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	exports.Tooltip = _Tooltip3['default'];
	
	var _Well2 = __webpack_require__(1595);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	exports.Well = _Well3['default'];
	
	var _Collapse2 = __webpack_require__(176);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	exports.Collapse = _Collapse3['default'];
	
	var _Fade2 = __webpack_require__(307);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	exports.Fade = _Fade3['default'];
	
	var _FormControls2 = __webpack_require__(557);
	
	var _FormControls = _interopRequireWildcard(_FormControls2);
	
	exports.FormControls = _FormControls;
	var utils = {
	  bootstrapUtils: _utilsBootstrapUtils2['default'],
	  childrenValueInputValidation: _utilsChildrenValueInputValidation2['default'],
	  createChainedFunction: _utilsCreateChainedFunction2['default'],
	  ValidComponentChildren: _utilsValidComponentChildren2['default']
	};
	exports.utils = utils;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __WEBPACK_IMPORTED_MODULE_7_events__ && __WEBPACK_IMPORTED_MODULE_7_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var Utils;
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	var NotificationPrefs = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].NotificationPrefs;
	
	var CHANGE_EVENT = 'change';
	var LEAVE_EVENT = 'leave';
	var MORE_CHANGE_EVENT = 'change';
	var EXTRA_INFO_EVENT = 'extra_info';
	
	var ChannelStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(ChannelStoreClass, _EventEmitter);
	
	    function ChannelStoreClass(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelStoreClass).call(this, props));
	
	        _this.setMaxListeners(15);
	
	        _this.emitChange = _this.emitChange.bind(_this);
	        _this.addChangeListener = _this.addChangeListener.bind(_this);
	        _this.removeChangeListener = _this.removeChangeListener.bind(_this);
	        _this.emitMoreChange = _this.emitMoreChange.bind(_this);
	        _this.addMoreChangeListener = _this.addMoreChangeListener.bind(_this);
	        _this.removeMoreChangeListener = _this.removeMoreChangeListener.bind(_this);
	        _this.emitExtraInfoChange = _this.emitExtraInfoChange.bind(_this);
	        _this.addExtraInfoChangeListener = _this.addExtraInfoChangeListener.bind(_this);
	        _this.removeExtraInfoChangeListener = _this.removeExtraInfoChangeListener.bind(_this);
	        _this.emitLeave = _this.emitLeave.bind(_this);
	        _this.addLeaveListener = _this.addLeaveListener.bind(_this);
	        _this.removeLeaveListener = _this.removeLeaveListener.bind(_this);
	        _this.findFirstBy = _this.findFirstBy.bind(_this);
	        _this.get = _this.get.bind(_this);
	        _this.getMember = _this.getMember.bind(_this);
	        _this.getByName = _this.getByName.bind(_this);
	        _this.setPostMode = _this.setPostMode.bind(_this);
	        _this.getPostMode = _this.getPostMode.bind(_this);
	        _this.setUnreadCount = _this.setUnreadCount.bind(_this);
	        _this.setUnreadCounts = _this.setUnreadCounts.bind(_this);
	        _this.getUnreadCount = _this.getUnreadCount.bind(_this);
	        _this.getUnreadCounts = _this.getUnreadCounts.bind(_this);
	
	        _this.currentId = null;
	        _this.postMode = _this.POST_MODE_CHANNEL;
	        _this.channels = [];
	        _this.channelMembers = {};
	        _this.moreChannels = {};
	        _this.moreChannels.loading = true;
	        _this.extraInfos = {};
	        _this.unreadCounts = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ChannelStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitMoreChange',
	        value: function emitMoreChange() {
	            this.emit(MORE_CHANGE_EVENT);
	        }
	    }, {
	        key: 'addMoreChangeListener',
	        value: function addMoreChangeListener(callback) {
	            this.on(MORE_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeMoreChangeListener',
	        value: function removeMoreChangeListener(callback) {
	            this.removeListener(MORE_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitExtraInfoChange',
	        value: function emitExtraInfoChange() {
	            this.emit(EXTRA_INFO_EVENT);
	        }
	    }, {
	        key: 'addExtraInfoChangeListener',
	        value: function addExtraInfoChangeListener(callback) {
	            this.on(EXTRA_INFO_EVENT, callback);
	        }
	    }, {
	        key: 'removeExtraInfoChangeListener',
	        value: function removeExtraInfoChangeListener(callback) {
	            this.removeListener(EXTRA_INFO_EVENT, callback);
	        }
	    }, {
	        key: 'emitLeave',
	        value: function emitLeave(id) {
	            this.emit(LEAVE_EVENT, id);
	        }
	    }, {
	        key: 'addLeaveListener',
	        value: function addLeaveListener(callback) {
	            this.on(LEAVE_EVENT, callback);
	        }
	    }, {
	        key: 'removeLeaveListener',
	        value: function removeLeaveListener(callback) {
	            this.removeListener(LEAVE_EVENT, callback);
	        }
	    }, {
	        key: 'findFirstBy',
	        value: function findFirstBy(field, value) {
	            return this.doFindFirst(field, value, this.getChannels());
	        }
	    }, {
	        key: 'findFirstMoreBy',
	        value: function findFirstMoreBy(field, value) {
	            return this.doFindFirst(field, value, this.getMoreChannels());
	        }
	    }, {
	        key: 'doFindFirst',
	        value: function doFindFirst(field, value, channels) {
	            for (var i = 0; i < channels.length; i++) {
	                if (channels[i][field] === value) {
	                    return channels[i];
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'get',
	        value: function get(id) {
	            return this.findFirstBy('id', id);
	        }
	    }, {
	        key: 'getMember',
	        value: function getMember(id) {
	            return this.getAllMembers()[id];
	        }
	    }, {
	        key: 'getByName',
	        value: function getByName(name) {
	            return this.findFirstBy('name', name);
	        }
	    }, {
	        key: 'getMoreByName',
	        value: function getMoreByName(name) {
	            return this.findFirstMoreBy('name', name);
	        }
	    }, {
	        key: 'getAll',
	        value: function getAll() {
	            return this.getChannels();
	        }
	    }, {
	        key: 'getAllMembers',
	        value: function getAllMembers() {
	            return this.getChannelMembers();
	        }
	    }, {
	        key: 'getMoreAll',
	        value: function getMoreAll() {
	            return this.getMoreChannels();
	        }
	    }, {
	        key: 'setCurrentId',
	        value: function setCurrentId(id) {
	            this.currentId = id;
	        }
	    }, {
	        key: 'resetCounts',
	        value: function resetCounts(id) {
	            var cm = this.channelMembers;
	            for (var cmid in cm) {
	                if (cm[cmid].channel_id === id) {
	                    var c = this.get(id);
	                    if (c) {
	                        cm[cmid].msg_count = this.get(id).total_msg_count;
	                        cm[cmid].mention_count = 0;
	                        this.setUnreadCount(id);
	                    }
	                    break;
	                }
	            }
	        }
	    }, {
	        key: 'getCurrentId',
	        value: function getCurrentId() {
	            return this.currentId;
	        }
	    }, {
	        key: 'getCurrent',
	        value: function getCurrent() {
	            var currentId = this.getCurrentId();
	
	            if (currentId) {
	                return this.get(currentId);
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getCurrentMember',
	        value: function getCurrentMember() {
	            var currentId = this.getCurrentId();
	
	            if (currentId) {
	                return this.getAllMembers()[currentId];
	            }
	
	            return null;
	        }
	    }, {
	        key: 'setChannelMember',
	        value: function setChannelMember(member) {
	            var members = this.getChannelMembers();
	            members[member.channel_id] = member;
	            this.storeChannelMembers(members);
	            this.emitChange();
	        }
	    }, {
	        key: 'getCurrentExtraInfo',
	        value: function getCurrentExtraInfo() {
	            return this.getExtraInfo(this.getCurrentId());
	        }
	    }, {
	        key: 'getExtraInfo',
	        value: function getExtraInfo(channelId) {
	            var extra = null;
	
	            if (channelId) {
	                extra = this.getExtraInfos()[channelId];
	            }
	
	            if (extra) {
	                // create a defensive copy
	                extra = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(extra));
	            } else {
	                extra = { members: [] };
	            }
	
	            return extra;
	        }
	    }, {
	        key: 'pStoreChannel',
	        value: function pStoreChannel(channel) {
	            var channels = this.getChannels();
	            var found;
	
	            for (var i = 0; i < channels.length; i++) {
	                if (channels[i].id === channel.id) {
	                    channels[i] = channel;
	                    found = true;
	                    break;
	                }
	            }
	
	            if (!found) {
	                channels.push(channel);
	            }
	
	            if (!Utils) {
	                Utils = __webpack_require__(8); //eslint-disable-line global-require
	            }
	
	            channels.sort(Utils.sortByDisplayName);
	            this.storeChannels(channels);
	        }
	    }, {
	        key: 'storeChannels',
	        value: function storeChannels(channels) {
	            this.channels = channels;
	        }
	    }, {
	        key: 'getChannels',
	        value: function getChannels() {
	            return this.channels;
	        }
	    }, {
	        key: 'pStoreChannelMember',
	        value: function pStoreChannelMember(channelMember) {
	            var members = this.getChannelMembers();
	            members[channelMember.channel_id] = channelMember;
	            this.storeChannelMembers(members);
	        }
	    }, {
	        key: 'storeChannelMembers',
	        value: function storeChannelMembers(channelMembers) {
	            this.channelMembers = channelMembers;
	        }
	    }, {
	        key: 'getChannelMembers',
	        value: function getChannelMembers() {
	            return this.channelMembers;
	        }
	    }, {
	        key: 'storeMoreChannels',
	        value: function storeMoreChannels(channels) {
	            this.moreChannels = channels;
	        }
	    }, {
	        key: 'getMoreChannels',
	        value: function getMoreChannels() {
	            return this.moreChannels;
	        }
	    }, {
	        key: 'storeExtraInfos',
	        value: function storeExtraInfos(extraInfos) {
	            this.extraInfos = extraInfos;
	        }
	    }, {
	        key: 'getExtraInfos',
	        value: function getExtraInfos() {
	            return this.extraInfos;
	        }
	    }, {
	        key: 'isDefault',
	        value: function isDefault(channel) {
	            return channel.name === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].DEFAULT_CHANNEL;
	        }
	    }, {
	        key: 'setPostMode',
	        value: function setPostMode(mode) {
	            this.postMode = mode;
	        }
	    }, {
	        key: 'getPostMode',
	        value: function getPostMode() {
	            return this.postMode;
	        }
	    }, {
	        key: 'setUnreadCount',
	        value: function setUnreadCount(id) {
	            var ch = this.get(id);
	            var chMember = this.getMember(id);
	
	            var chMentionCount = chMember.mention_count;
	            var chUnreadCount = ch.total_msg_count - chMember.msg_count - chMentionCount;
	
	            if (ch.type === 'D') {
	                chMentionCount = chUnreadCount;
	                chUnreadCount = 0;
	            } else if (chMember.notify_props && chMember.notify_props.mark_unread === NotificationPrefs.MENTION) {
	                chUnreadCount = 0;
	            }
	
	            this.unreadCounts[id] = { msgs: chUnreadCount, mentions: chMentionCount };
	        }
	    }, {
	        key: 'setUnreadCounts',
	        value: function setUnreadCounts() {
	            var _this2 = this;
	
	            var channels = this.getAll();
	            channels.forEach(function (ch) {
	                _this2.setUnreadCount(ch.id);
	            });
	        }
	    }, {
	        key: 'getUnreadCount',
	        value: function getUnreadCount(id) {
	            return this.unreadCounts[id] || { msgs: 0, mentions: 0 };
	        }
	    }, {
	        key: 'getUnreadCounts',
	        value: function getUnreadCounts() {
	            return this.unreadCounts;
	        }
	    }, {
	        key: 'leaveChannel',
	        value: function leaveChannel(id) {
	            delete this.channelMembers[id];
	            var element = this.channels.indexOf(id);
	            if (element > -1) {
	                this.channels.splice(element, 1);
	            }
	        }
	    }, {
	        key: 'POST_MODE_CHANNEL',
	        get: function get() {
	            return 1;
	        }
	    }, {
	        key: 'POST_MODE_FOCUS',
	        get: function get() {
	            return 2;
	        }
	    }]);
	
	    return ChannelStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_events___default.a);
	
	var ChannelStore = new ChannelStoreClass();
	
	ChannelStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	    var currentId;
	
	    switch (action.type) {
	        case ActionTypes.CLICK_CHANNEL:
	            ChannelStore.setCurrentId(action.id);
	            ChannelStore.resetCounts(action.id);
	            ChannelStore.setPostMode(ChannelStore.POST_MODE_CHANNEL);
	            ChannelStore.emitChange();
	            break;
	
	        case ActionTypes.RECEIVED_FOCUSED_POST:
	            {
	                var post = action.post_list.posts[action.postId];
	                ChannelStore.setCurrentId(post.channel_id);
	                ChannelStore.setPostMode(ChannelStore.POST_MODE_FOCUS);
	                ChannelStore.emitChange();
	                break;
	            }
	
	        case ActionTypes.RECEIVED_CHANNELS:
	            ChannelStore.storeChannels(action.channels);
	            ChannelStore.storeChannelMembers(action.members);
	            currentId = ChannelStore.getCurrentId();
	            if (currentId && window.isActive) {
	                ChannelStore.resetCounts(currentId);
	            }
	            ChannelStore.setUnreadCounts();
	            ChannelStore.emitChange();
	            break;
	
	        case ActionTypes.RECEIVED_CHANNEL:
	            ChannelStore.pStoreChannel(action.channel);
	            if (action.member) {
	                ChannelStore.pStoreChannelMember(action.member);
	            }
	            currentId = ChannelStore.getCurrentId();
	            if (currentId && window.isActive) {
	                ChannelStore.resetCounts(currentId);
	            }
	            ChannelStore.setUnreadCount(action.channel.id);
	            ChannelStore.emitChange();
	            break;
	
	        case ActionTypes.RECEIVED_MORE_CHANNELS:
	            ChannelStore.storeMoreChannels(action.channels);
	            ChannelStore.emitMoreChange();
	            break;
	
	        case ActionTypes.RECEIVED_CHANNEL_EXTRA_INFO:
	            var extraInfos = ChannelStore.getExtraInfos();
	            extraInfos[action.extra_info.id] = action.extra_info;
	            ChannelStore.storeExtraInfos(extraInfos);
	            ChannelStore.emitExtraInfoChange();
	            break;
	
	        case ActionTypes.LEAVE_CHANNEL:
	            ChannelStore.leaveChannel(action.id);
	            ChannelStore.emitLeave(action.id);
	            break;
	
	        default:
	            break;
	    }
	});
	
	/* harmony default export */ exports["a"] = ChannelStore;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flux__ = __webpack_require__(1399);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flux___default = __WEBPACK_IMPORTED_MODULE_1_flux__ && __WEBPACK_IMPORTED_MODULE_1_flux__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_flux__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_flux__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_flux___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_flux___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var PayloadSources = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_utils_constants_jsx__["a"].PayloadSources;
	
	var AppDispatcher = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()(new /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_1_flux__.Dispatcher(), {
	    handleServerAction: function performServerAction(action) {
	        if (!action.type) {
	            console.warning('handleServerAction called with undefined action type'); // eslint-disable-line no-console
	        }
	
	        var payload = {
	            source: PayloadSources.SERVER_ACTION,
	            action: action
	        };
	        this.dispatch(payload);
	    },
	
	    handleViewAction: function performViewAction(action) {
	        if (!action.type) {
	            console.warning('handleViewAction called with undefined action type'); // eslint-disable-line no-console
	        }
	
	        var payload = {
	            source: PayloadSources.VIEW_ACTION,
	            action: action
	        };
	        this.dispatch(payload);
	    }
	});
	
	module.e = AppDispatcher;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __WEBPACK_IMPORTED_MODULE_6_events__ && __WEBPACK_IMPORTED_MODULE_6_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	
	var Utils;
	function getWindowLocationOrigin() {
	    if (!Utils) {
	        Utils = __webpack_require__(8); //eslint-disable-line global-require
	    }
	    return Utils.getWindowLocationOrigin();
	}
	
	var TeamStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamStoreClass, _EventEmitter);
	
	    function TeamStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamStoreClass).call(this));
	
	        _this.clear();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamStoreClass, [{
	        key: 'clear',
	        value: function clear() {
	            this.teams = {};
	            this.team_members = [];
	            this.members_for_team = [];
	            this.teamListings = {};
	            this.currentTeamId = '';
	        }
	    }, {
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'get',
	        value: function get(id) {
	            var c = this.getAll();
	            return c[id];
	        }
	    }, {
	        key: 'getByName',
	        value: function getByName(name) {
	            var t = this.getAll();
	
	            for (var id in t) {
	                if (t[id].name === name) {
	                    return t[id];
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getAll',
	        value: function getAll() {
	            return this.teams;
	        }
	    }, {
	        key: 'getCurrentId',
	        value: function getCurrentId() {
	            var team = this.get(this.currentTeamId);
	
	            if (team) {
	                return team.id;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getCurrent',
	        value: function getCurrent() {
	            var team = this.teams[this.currentTeamId];
	
	            if (team) {
	                return team;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getCurrentTeamUrl',
	        value: function getCurrentTeamUrl() {
	            if (this.getCurrent()) {
	                return getWindowLocationOrigin() + '/' + this.getCurrent().name;
	            }
	            return null;
	        }
	    }, {
	        key: 'getCurrentTeamRelativeUrl',
	        value: function getCurrentTeamRelativeUrl() {
	            if (this.getCurrent()) {
	                return '/' + this.getCurrent().name;
	            }
	            return null;
	        }
	    }, {
	        key: 'getCurrentInviteLink',
	        value: function getCurrentInviteLink() {
	            var current = this.getCurrent();
	
	            if (current) {
	                return getWindowLocationOrigin() + '/signup_user_complete/?id=' + current.invite_id;
	            }
	
	            return '';
	        }
	    }, {
	        key: 'saveTeam',
	        value: function saveTeam(team) {
	            this.teams[team.id] = team;
	        }
	    }, {
	        key: 'saveTeams',
	        value: function saveTeams(teams) {
	            this.teams = teams;
	        }
	    }, {
	        key: 'saveMyTeam',
	        value: function saveMyTeam(team) {
	            this.saveTeam(team);
	            this.currentTeamId = team.id;
	        }
	    }, {
	        key: 'saveTeamMembers',
	        value: function saveTeamMembers(members) {
	            this.team_members = members;
	        }
	    }, {
	        key: 'appendTeamMember',
	        value: function appendTeamMember(member) {
	            this.team_members.push(member);
	        }
	    }, {
	        key: 'getTeamMembers',
	        value: function getTeamMembers() {
	            return this.team_members;
	        }
	    }, {
	        key: 'saveMembersForTeam',
	        value: function saveMembersForTeam(members) {
	            this.members_for_team = members;
	        }
	    }, {
	        key: 'getMembersForTeam',
	        value: function getMembersForTeam() {
	            return this.members_for_team;
	        }
	    }, {
	        key: 'saveTeamListings',
	        value: function saveTeamListings(teams) {
	            this.teamListings = teams;
	        }
	    }, {
	        key: 'getTeamListings',
	        value: function getTeamListings() {
	            return this.teamListings;
	        }
	    }, {
	        key: 'isTeamAdminForCurrentTeam',
	        value: function isTeamAdminForCurrentTeam() {
	            var _this2 = this;
	
	            if (!Utils) {
	                Utils = __webpack_require__(8); //eslint-disable-line global-require
	            }
	
	            var userId = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentId();
	            var teamMembers = this.getTeamMembers();
	            var teamMember = teamMembers.find(function (m) {
	                return m.user_id === userId && m.team_id === _this2.getCurrentId();
	            });
	
	            if (teamMember) {
	                return Utils.isAdmin(teamMember.roles);
	            }
	
	            return false;
	        }
	    }]);
	
	    return TeamStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_events___default.a);
	
	var TeamStore = new TeamStoreClass();
	
	TeamStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_MY_TEAM:
	            TeamStore.saveMyTeam(action.team);
	            TeamStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_ALL_TEAMS:
	            TeamStore.saveTeams(action.teams);
	            TeamStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_TEAM_MEMBERS:
	            TeamStore.saveTeamMembers(action.team_members);
	            TeamStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_ALL_TEAM_LISTINGS:
	            TeamStore.saveTeamListings(action.teams);
	            TeamStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_MEMBERS_FOR_TEAM:
	            TeamStore.saveMembersForTeam(action.team_members);
	            TeamStore.emitChange();
	            break;
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = TeamStore;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(34);
	module.e = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _styleMaps = __webpack_require__(58);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	}
	
	function prefix(props, variant) {
	  if (props === undefined) props = {};
	
	  !(props.bsClass || '').trim() ?  false ? _invariant2['default'](false, 'A `bsClass` prop is required for this component') : _invariant2['default'](false) : undefined;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _react.PropTypes.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	exports.bsClass = bsClass;
	var bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _react.PropTypes.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = _extends({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	exports.bsStyles = bsStyles;
	var bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = existing.reduce(function (result, size) {
	    if (_styleMaps2['default'].SIZES[size] && _styleMaps2['default'].SIZES[size] !== size) {
	      result.push(_styleMaps2['default'].SIZES[size]);
	    }
	    return result.concat(size);
	  }, []);
	
	  var propType = _react.PropTypes.oneOf(values);
	
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = _extends({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	exports.bsSizes = bsSizes;
	exports['default'] = {
	
	  prefix: prefix,
	
	  getClassSet: function getClassSet(props) {
	    var classes = {};
	    var bsClassName = prefix(props);
	
	    if (bsClassName) {
	      var bsSize = undefined;
	
	      classes[bsClassName] = true;
	
	      if (props.bsSize) {
	        bsSize = _styleMaps2['default'].SIZES[props.bsSize] || bsSize;
	      }
	
	      if (bsSize) {
	        classes[prefix(props, bsSize)] = true;
	      }
	
	      if (props.bsStyle) {
	        if (props.bsStyle.indexOf(prefix(props)) === 0) {
	           false ? _warning2['default'](false, // small migration convenience, since the old method required manual prefixing
	          'bsStyle will automatically prefix custom values with the bsClass, so there is no ' + 'need to append it manually. (bsStyle: ' + props.bsStyle + ', bsClass: ' + prefix(props) + ')') : undefined;
	          classes[props.bsStyle] = true;
	        } else {
	          classes[prefix(props, props.bsStyle)] = true;
	        }
	      }
	    }
	
	    return classes;
	  },
	
	  /**
	   * Add a style variant to a Component. Mutates the propTypes of the component
	   * in order to validate the new variant.
	   */
	  addStyle: function addStyle(Component, styleVariant) {
	    bsStyles(styleVariant, Component);
	  }
	};
	var _curry = curry;
	exports._curry = _curry;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.e = invariant;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.e = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.e = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}
	


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__ = __webpack_require__(161);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__websocket_actions_jsx__ = __webpack_require__(243);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_i18n_i18n_jsx__ = __webpack_require__(190);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router___default = __WEBPACK_IMPORTED_MODULE_15_react_router__ && __WEBPACK_IMPORTED_MODULE_15_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_i18n_en_json__ = __webpack_require__(1753);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_i18n_en_json___default = __WEBPACK_IMPORTED_MODULE_16_i18n_en_json__ && __WEBPACK_IMPORTED_MODULE_16_i18n_en_json__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_i18n_en_json__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_i18n_en_json__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_i18n_en_json___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_i18n_en_json___default });
	/* harmony export */ exports["emitChannelClickEvent"] = emitChannelClickEvent;/* harmony export */ exports["emitInitialLoad"] = emitInitialLoad;/* harmony export */ exports["doFocusPost"] = doFocusPost;/* harmony export */ exports["emitPostFocusEvent"] = emitPostFocusEvent;/* harmony export */ exports["emitProfilesForDmList"] = emitProfilesForDmList;/* harmony export */ exports["emitCloseRightHandSide"] = emitCloseRightHandSide;/* harmony export */ exports["emitPostFocusRightHandSideFromSearch"] = emitPostFocusRightHandSideFromSearch;/* harmony export */ exports["emitLoadMorePostsEvent"] = emitLoadMorePostsEvent;/* harmony export */ exports["emitLoadMorePostsFocusedTopEvent"] = emitLoadMorePostsFocusedTopEvent;/* harmony export */ exports["loadMorePostsTop"] = loadMorePostsTop;/* harmony export */ exports["emitLoadMorePostsFocusedBottomEvent"] = emitLoadMorePostsFocusedBottomEvent;/* harmony export */ exports["emitPostRecievedEvent"] = emitPostRecievedEvent;/* harmony export */ exports["emitUserPostedEvent"] = emitUserPostedEvent;/* harmony export */ exports["emitPostDeletedEvent"] = emitPostDeletedEvent;/* harmony export */ exports["showDeletePostModal"] = showDeletePostModal;/* harmony export */ exports["showGetPostLinkModal"] = showGetPostLinkModal;/* harmony export */ exports["showGetPublicLinkModal"] = showGetPublicLinkModal;/* harmony export */ exports["showGetTeamInviteLinkModal"] = showGetTeamInviteLinkModal;/* harmony export */ exports["showInviteMemberModal"] = showInviteMemberModal;/* harmony export */ exports["showRegisterAppModal"] = showRegisterAppModal;/* harmony export */ exports["emitSuggestionPretextChanged"] = emitSuggestionPretextChanged;/* harmony export */ exports["emitSelectNextSuggestion"] = emitSelectNextSuggestion;/* harmony export */ exports["emitSelectPreviousSuggestion"] = emitSelectPreviousSuggestion;/* harmony export */ exports["emitCompleteWordSuggestion"] = emitCompleteWordSuggestion;/* harmony export */ exports["emitClearSuggestions"] = emitClearSuggestions;/* harmony export */ exports["emitPreferenceChangedEvent"] = emitPreferenceChangedEvent;/* harmony export */ exports["emitRemovePost"] = emitRemovePost;/* harmony export */ exports["sendEphemeralPost"] = sendEphemeralPost;/* harmony export */ exports["newLocalizationSelected"] = newLocalizationSelected;/* harmony export */ exports["loadBrowserLocale"] = loadBrowserLocale;/* harmony export */ exports["viewLoggedIn"] = viewLoggedIn;/* harmony export */ exports["emitLocalUserTypingEvent"] = emitLocalUserTypingEvent;/* harmony export */ exports["emitRemoteUserTypingEvent"] = emitRemoteUserTypingEvent;/* harmony export */ exports["emitUserLoggedOutEvent"] = emitUserLoggedOutEvent;/* harmony export */ exports["emitJoinChannelEvent"] = emitJoinChannelEvent;'use strict';
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	
	
	
	function emitChannelClickEvent(channel) {
	    var _this = this;
	
	    function userVisitedFakeChannel(chan, success, fail) {
	        var otherUserId = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getUserIdFromChannelName(chan);
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].createDirectChannel(otherUserId, function (data) {
	            success(data);
	        }, function () {
	            fail();
	        });
	    }
	    function switchToChannel(chan) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannels(true);
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannelExtraInfo(chan.id);
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.updateLastViewedAt(chan.id);
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPosts(chan.id);
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].trackPage();
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	            type: ActionTypes.CLICK_CHANNEL,
	            name: chan.name,
	            id: chan.id,
	            prev: /* harmony import */__WEBPACK_IMPORTED_MODULE_1_stores_channel_store_jsx__["a"].getCurrentId()
	        });
	    }
	
	    if (channel.fake) {
	        userVisitedFakeChannel(channel, function (data) {
	            switchToChannel(data);
	        }, function () {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/' + _this.state.currentTeam.name);
	        });
	    } else {
	        switchToChannel(channel);
	    }
	}
	
	function emitInitialLoad(callback) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].getInitialLoad(function (data) {
	        global.window.mm_config = data.client_cfg;
	        global.window.mm_license = data.license_cfg;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_user_store_jsx__["a"].setNoAccounts(data.no_accounts);
	
	        if (data.user && data.user.id) {
	            global.window.mm_user = data.user;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_ME,
	                me: data.user
	            });
	        }
	
	        if (data.preferences) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_PREFERENCES,
	                preferences: data.preferences
	            });
	        }
	
	        if (data.teams) {
	            var teams = {};
	            data.teams.forEach(function (team) {
	                teams[team.id] = team;
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_ALL_TEAMS,
	                teams: teams
	            });
	        }
	
	        if (data.team_members) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_TEAM_MEMBERS,
	                team_members: data.team_members
	            });
	        }
	
	        if (data.direct_profiles) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_DIRECT_PROFILES,
	                profiles: data.direct_profiles
	            });
	        }
	
	        if (callback) {
	            callback();
	        }
	    }, function (err) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.dispatchError(err, 'getInitialLoad');
	
	        if (callback) {
	            callback();
	        }
	    });
	}
	
	function doFocusPost(channelId, postId, data) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.RECEIVED_FOCUSED_POST,
	        postId: postId,
	        post_list: data
	    });
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannels(true);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannelExtraInfo(channelId);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPostsBefore(postId, 0, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_FOCUS_CONTEXT_RADIUS);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPostsAfter(postId, 0, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_FOCUS_CONTEXT_RADIUS);
	}
	
	function emitPostFocusEvent(postId) {
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannels(true);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].getPermalinkTmp(postId, function (data) {
	        if (!data) {
	            return;
	        }
	        var channelId = data.posts[data.order[0]].channel_id;
	        doFocusPost(channelId, postId, data);
	    }, function () {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/error?message=' + encodeURIComponent(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('permalink.error.access', 'Permalink belongs to a channel you do not have access to')));
	    });
	}
	
	function emitProfilesForDmList() {
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getProfilesForDirectMessageList();
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrentId());
	}
	
	function emitCloseRightHandSide() {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.RECEIVED_SEARCH,
	        results: null
	    });
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.RECEIVED_POST_SELECTED,
	        postId: null
	    });
	}
	
	function emitPostFocusRightHandSideFromSearch(post, isMentionSearch) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].getPost(post.channel_id, post.id, function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_POSTS,
	            id: post.channel_id,
	            numRequested: 0,
	            post_list: data
	        });
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_POST_SELECTED,
	            postId: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getRootId(post),
	            from_search: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].getSearchTerm()
	        });
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_SEARCH,
	            results: null,
	            is_mention_search: isMentionSearch
	        });
	    }, function (err) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.dispatchError(err, 'getPost');
	    });
	}
	
	function emitLoadMorePostsEvent() {
	    var id = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_stores_channel_store_jsx__["a"].getCurrentId();
	    loadMorePostsTop(id);
	}
	
	function emitLoadMorePostsFocusedTopEvent() {
	    var id = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__["a"].getFocusedPostId();
	    loadMorePostsTop(id);
	}
	
	function loadMorePostsTop(id) {
	    var earliestPostId = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__["a"].getEarliestPost(id).id;
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__["a"].requestVisibilityIncrease(id, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_CHUNK_SIZE)) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPostsBefore(earliestPostId, 0, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_CHUNK_SIZE);
	    }
	}
	
	function emitLoadMorePostsFocusedBottomEvent() {
	    var id = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__["a"].getFocusedPostId();
	    var latestPostId = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__["a"].getLatestPost(id).id;
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPostsAfter(latestPostId, 0, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_CHUNK_SIZE);
	}
	
	function emitPostRecievedEvent(post, msg) {
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_1_stores_channel_store_jsx__["a"].getCurrentId() === post.channel_id) {
	        if (window.isActive) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.updateLastViewedAt();
	        } else {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannel(post.channel_id);
	        }
	    } else if (msg && (/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrentId() === msg.team_id || msg.props.channel_type === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].DM_CHANNEL)) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannel(post.channel_id);
	    }
	
	    var websocketMessageProps = null;
	    if (msg) {
	        websocketMessageProps = msg.props;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.RECEIVED_POST,
	        post: post,
	        websocketMessageProps: websocketMessageProps
	    });
	}
	
	function emitUserPostedEvent(post) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.CREATE_POST,
	        post: post
	    });
	}
	
	function emitPostDeletedEvent(post) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: ActionTypes.POST_DELETED,
	        post: post
	    });
	}
	
	function showDeletePostModal(post) {
	    var commentCount = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.TOGGLE_DELETE_POST_MODAL,
	        value: true,
	        post: post,
	        commentCount: commentCount
	    });
	}
	
	function showGetPostLinkModal(post) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.TOGGLE_GET_POST_LINK_MODAL,
	        value: true,
	        post: post
	    });
	}
	
	function showGetPublicLinkModal(filename) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL,
	        value: true,
	        filename: filename
	    });
	}
	
	function showGetTeamInviteLinkModal() {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL,
	        value: true
	    });
	}
	
	function showInviteMemberModal() {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.TOGGLE_INVITE_MEMBER_MODAL,
	        value: true
	    });
	}
	
	function showRegisterAppModal() {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.TOGGLE_REGISTER_APP_MODAL,
	        value: true
	    });
	}
	
	function emitSuggestionPretextChanged(suggestionId, pretext) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.SUGGESTION_PRETEXT_CHANGED,
	        id: suggestionId,
	        pretext: pretext
	    });
	}
	
	function emitSelectNextSuggestion(suggestionId) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.SUGGESTION_SELECT_NEXT,
	        id: suggestionId
	    });
	}
	
	function emitSelectPreviousSuggestion(suggestionId) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: ActionTypes.SUGGESTION_SELECT_PREVIOUS,
	        id: suggestionId
	    });
	}
	
	function emitCompleteWordSuggestion(suggestionId) {
	    var term = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.SUGGESTION_COMPLETE_WORD,
	        id: suggestionId,
	        term: term
	    });
	}
	
	function emitClearSuggestions(suggestionId) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.SUGGESTION_CLEAR_SUGGESTIONS,
	        id: suggestionId
	    });
	}
	
	function emitPreferenceChangedEvent(preference) {
	    if (preference.category === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].Preferences.CATEGORY_DIRECT_CHANNEL_SHOW) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getDirectProfiles();
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.RECEIVED_PREFERENCE,
	        preference: preference
	    });
	}
	
	function emitRemovePost(post) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.REMOVE_POST,
	        post: post
	    });
	}
	
	function sendEphemeralPost(message, channelId) {
	    var timestamp = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getTimestamp();
	    var post = {
	        id: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.generateId(),
	        user_id: '0',
	        channel_id: channelId || /* harmony import */__WEBPACK_IMPORTED_MODULE_1_stores_channel_store_jsx__["a"].getCurrentId(),
	        message: message,
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_TYPE_EPHEMERAL,
	        create_at: timestamp,
	        update_at: timestamp,
	        filenames: [],
	        props: {}
	    };
	
	    emitPostRecievedEvent(post);
	}
	
	function newLocalizationSelected(locale) {
	    if (locale === 'en') {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_LOCALE,
	            locale: locale,
	            translations: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_i18n_en_json___default.a
	        });
	    } else {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].getTranslations(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_i18n_i18n_jsx__.getLanguageInfo(locale).url, function (data) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_LOCALE,
	                locale: locale,
	                translations: data
	            });
	        }, function (err) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.dispatchError(err, 'getTranslations');
	        });
	    }
	}
	
	function loadBrowserLocale() {
	    var locale = (navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : navigator.language || navigator.userLanguage).split('-')[0];
	    if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_i18n_i18n_jsx__.getLanguages()[locale]) {
	        locale = 'en';
	    }
	    return newLocalizationSelected(locale);
	}
	
	function viewLoggedIn() {
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannels();
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannelExtraInfo();
	
	    // Clear pending posts (shouldn't have pending posts if we are loading)
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_post_store_jsx__["a"].clearPendingPosts();
	}
	
	var lastTimeTypingSent = 0;
	function emitLocalUserTypingEvent(channelId, parentId) {
	    var t = Date.now();
	    if (t - lastTimeTypingSent > /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].UPDATE_TYPING_MS) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13__websocket_actions_jsx__.sendMessage({ channel_id: channelId, action: 'typing', props: { parent_id: parentId }, state: {} });
	        lastTimeTypingSent = t;
	    }
	}
	
	function emitRemoteUserTypingEvent(channelId, userId, postParentId) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	        type: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.USER_TYPING,
	        channelId: channelId,
	        userId: userId,
	        postParentId: postParentId
	    });
	}
	
	function emitUserLoggedOutEvent(redirectTo) {
	    var rURL = redirectTo && typeof redirectTo === 'string' ? redirectTo : '/';
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].logout(function () {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_stores_browser_store_jsx__["a"].signalLogout();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_stores_browser_store_jsx__["a"].clear();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].clearLastError();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__["a"].clear();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_user_store_jsx__["a"].clear();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].clear();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push(rURL);
	    }, function () {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push(rURL);
	    });
	}
	
	function emitJoinChannelEvent(channel, success, failure) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].joinChannel(channel.id, success, failure);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.e = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.e = assign;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(88);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.e = warning;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var store      = __webpack_require__(203)('wks')
	  , uid        = __webpack_require__(123)
	  , Symbol     = __webpack_require__(29).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.e = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Thank's IE8 for his funny defineProperty
	module.e = !__webpack_require__(31)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var anObject       = __webpack_require__(24)
	  , IE8_DOM_DEFINE = __webpack_require__(467)
	  , toPrimitive    = __webpack_require__(84)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(37) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	(function (module, exports) {
	  'use strict';
	
	  // Utils
	  function assert (val, msg) {
	    if (!val) throw new Error(msg || 'Assertion failed');
	  }
	
	  // Could use `inherits` module, but don't want to move from single file
	  // architecture yet.
	  function inherits (ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  }
	
	  // BN
	
	  function BN (number, base, endian) {
	    if (BN.isBN(number)) {
	      return number;
	    }
	
	    this.negative = 0;
	    this.words = null;
	    this.length = 0;
	
	    // Reduction context
	    this.red = null;
	
	    if (number !== null) {
	      if (base === 'le' || base === 'be') {
	        endian = base;
	        base = 10;
	      }
	
	      this._init(number || 0, base || 10, endian || 'be');
	    }
	  }
	  if (typeof module === 'object') {
	    module.exports = BN;
	  } else {
	    exports.BN = BN;
	  }
	
	  BN.BN = BN;
	  BN.wordSize = 26;
	
	  var Buffer;
	  try {
	    Buffer = __webpack_require__(19).Buffer;
	  } catch (e) {
	  }
	
	  BN.isBN = function isBN (num) {
	    return num !== null && typeof num === 'object' &&
	      num.constructor.name === 'BN' && Array.isArray(num.words);
	  };
	
	  BN.max = function max (left, right) {
	    if (left.cmp(right) > 0) return left;
	    return right;
	  };
	
	  BN.min = function min (left, right) {
	    if (left.cmp(right) < 0) return left;
	    return right;
	  };
	
	  BN.prototype._init = function init (number, base, endian) {
	    if (typeof number === 'number') {
	      return this._initNumber(number, base, endian);
	    }
	
	    if (typeof number === 'object') {
	      return this._initArray(number, base, endian);
	    }
	
	    if (base === 'hex') {
	      base = 16;
	    }
	    assert(base === (base | 0) && base >= 2 && base <= 36);
	
	    number = number.toString().replace(/\s+/g, '');
	    var start = 0;
	    if (number[0] === '-') {
	      start++;
	    }
	
	    if (base === 16) {
	      this._parseHex(number, start);
	    } else {
	      this._parseBase(number, base, start);
	    }
	
	    if (number[0] === '-') {
	      this.negative = 1;
	    }
	
	    this.strip();
	
	    if (endian !== 'le') return;
	
	    this._initArray(this.toArray(), base, endian);
	  };
	
	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
	    if (number < 0) {
	      this.negative = 1;
	      number = -number;
	    }
	    if (number < 0x4000000) {
	      this.words = [ number & 0x3ffffff ];
	      this.length = 1;
	    } else if (number < 0x10000000000000) {
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff
	      ];
	      this.length = 2;
	    } else {
	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff,
	        1
	      ];
	      this.length = 3;
	    }
	
	    if (endian !== 'le') return;
	
	    // Reverse the bytes
	    this._initArray(this.toArray(), base, endian);
	  };
	
	  BN.prototype._initArray = function _initArray (number, base, endian) {
	    // Perhaps a Uint8Array
	    assert(typeof number.length === 'number');
	    if (number.length <= 0) {
	      this.words = [ 0 ];
	      this.length = 1;
	      return this;
	    }
	
	    this.length = Math.ceil(number.length / 3);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }
	
	    var j, w;
	    var off = 0;
	    if (endian === 'be') {
	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    } else if (endian === 'le') {
	      for (i = 0, j = 0; i < number.length; i += 3) {
	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    }
	    return this.strip();
	  };
	
	  function parseHex (str, start, end) {
	    var r = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	
	      r <<= 4;
	
	      // 'a' - 'f'
	      if (c >= 49 && c <= 54) {
	        r |= c - 49 + 0xa;
	
	      // 'A' - 'F'
	      } else if (c >= 17 && c <= 22) {
	        r |= c - 17 + 0xa;
	
	      // '0' - '9'
	      } else {
	        r |= c & 0xf;
	      }
	    }
	    return r;
	  }
	
	  BN.prototype._parseHex = function _parseHex (number, start) {
	    // Create possibly bigger array to ensure that it fits the number
	    this.length = Math.ceil((number.length - start) / 6);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }
	
	    var j, w;
	    // Scan 24-bit chunks and add them to the number
	    var off = 0;
	    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
	      w = parseHex(number, i, i + 6);
	      this.words[j] |= (w << off) & 0x3ffffff;
	      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
	      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
	      off += 24;
	      if (off >= 26) {
	        off -= 26;
	        j++;
	      }
	    }
	    if (i + 6 !== start) {
	      w = parseHex(number, start, i + 6);
	      this.words[j] |= (w << off) & 0x3ffffff;
	      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
	    }
	    this.strip();
	  };
	
	  function parseBase (str, start, end, mul) {
	    var r = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	
	      r *= mul;
	
	      // 'a'
	      if (c >= 49) {
	        r += c - 49 + 0xa;
	
	      // 'A'
	      } else if (c >= 17) {
	        r += c - 17 + 0xa;
	
	      // '0' - '9'
	      } else {
	        r += c;
	      }
	    }
	    return r;
	  }
	
	  BN.prototype._parseBase = function _parseBase (number, base, start) {
	    // Initialize as zero
	    this.words = [ 0 ];
	    this.length = 1;
	
	    // Find length of limb in base
	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
	      limbLen++;
	    }
	    limbLen--;
	    limbPow = (limbPow / base) | 0;
	
	    var total = number.length - start;
	    var mod = total % limbLen;
	    var end = Math.min(total, total - mod) + start;
	
	    var word = 0;
	    for (var i = start; i < end; i += limbLen) {
	      word = parseBase(number, i, i + limbLen, base);
	
	      this.imuln(limbPow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }
	
	    if (mod !== 0) {
	      var pow = 1;
	      word = parseBase(number, i, number.length, base);
	
	      for (i = 0; i < mod; i++) {
	        pow *= base;
	      }
	
	      this.imuln(pow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }
	  };
	
	  BN.prototype.copy = function copy (dest) {
	    dest.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      dest.words[i] = this.words[i];
	    }
	    dest.length = this.length;
	    dest.negative = this.negative;
	    dest.red = this.red;
	  };
	
	  BN.prototype.clone = function clone () {
	    var r = new BN(null);
	    this.copy(r);
	    return r;
	  };
	
	  BN.prototype._expand = function _expand (size) {
	    while (this.length < size) {
	      this.words[this.length++] = 0;
	    }
	    return this;
	  };
	
	  // Remove leading `0` from `this`
	  BN.prototype.strip = function strip () {
	    while (this.length > 1 && this.words[this.length - 1] === 0) {
	      this.length--;
	    }
	    return this._normSign();
	  };
	
	  BN.prototype._normSign = function _normSign () {
	    // -0 = 0
	    if (this.length === 1 && this.words[0] === 0) {
	      this.negative = 0;
	    }
	    return this;
	  };
	
	  BN.prototype.inspect = function inspect () {
	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
	  };
	
	  /*
	
	  var zeros = [];
	  var groupSizes = [];
	  var groupBases = [];
	
	  var s = '';
	  var i = -1;
	  while (++i < BN.wordSize) {
	    zeros[i] = s;
	    s += '0';
	  }
	  groupSizes[0] = 0;
	  groupSizes[1] = 0;
	  groupBases[0] = 0;
	  groupBases[1] = 0;
	  var base = 2 - 1;
	  while (++base < 36 + 1) {
	    var groupSize = 0;
	    var groupBase = 1;
	    while (groupBase < (1 << BN.wordSize) / base) {
	      groupBase *= base;
	      groupSize += 1;
	    }
	    groupSizes[base] = groupSize;
	    groupBases[base] = groupBase;
	  }
	
	  */
	
	  var zeros = [
	    '',
	    '0',
	    '00',
	    '000',
	    '0000',
	    '00000',
	    '000000',
	    '0000000',
	    '00000000',
	    '000000000',
	    '0000000000',
	    '00000000000',
	    '000000000000',
	    '0000000000000',
	    '00000000000000',
	    '000000000000000',
	    '0000000000000000',
	    '00000000000000000',
	    '000000000000000000',
	    '0000000000000000000',
	    '00000000000000000000',
	    '000000000000000000000',
	    '0000000000000000000000',
	    '00000000000000000000000',
	    '000000000000000000000000',
	    '0000000000000000000000000'
	  ];
	
	  var groupSizes = [
	    0, 0,
	    25, 16, 12, 11, 10, 9, 8,
	    8, 7, 7, 7, 7, 6, 6,
	    6, 6, 6, 6, 6, 5, 5,
	    5, 5, 5, 5, 5, 5, 5,
	    5, 5, 5, 5, 5, 5, 5
	  ];
	
	  var groupBases = [
	    0, 0,
	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
	  ];
	
	  BN.prototype.toString = function toString (base, padding) {
	    base = base || 10;
	    padding = padding | 0 || 1;
	
	    var out;
	    if (base === 16 || base === 'hex') {
	      out = '';
	      var off = 0;
	      var carry = 0;
	      for (var i = 0; i < this.length; i++) {
	        var w = this.words[i];
	        var word = (((w << off) | carry) & 0xffffff).toString(16);
	        carry = (w >>> (24 - off)) & 0xffffff;
	        if (carry !== 0 || i !== this.length - 1) {
	          out = zeros[6 - word.length] + word + out;
	        } else {
	          out = word + out;
	        }
	        off += 2;
	        if (off >= 26) {
	          off -= 26;
	          i--;
	        }
	      }
	      if (carry !== 0) {
	        out = carry.toString(16) + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }
	
	    if (base === (base | 0) && base >= 2 && base <= 36) {
	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
	      var groupSize = groupSizes[base];
	      // var groupBase = Math.pow(base, groupSize);
	      var groupBase = groupBases[base];
	      out = '';
	      var c = this.clone();
	      c.negative = 0;
	      while (!c.isZero()) {
	        var r = c.modn(groupBase).toString(base);
	        c = c.idivn(groupBase);
	
	        if (!c.isZero()) {
	          out = zeros[groupSize - r.length] + r + out;
	        } else {
	          out = r + out;
	        }
	      }
	      if (this.isZero()) {
	        out = '0' + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }
	
	    assert(false, 'Base should be between 2 and 36');
	  };
	
	  BN.prototype.toNumber = function toNumber () {
	    var ret = this.words[0];
	    if (this.length === 2) {
	      ret += this.words[1] * 0x4000000;
	    } else if (this.length === 3 && this.words[2] === 0x01) {
	      // NOTE: at this stage it is known that the top bit is set
	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
	    } else if (this.length > 2) {
	      assert(false, 'Number can only safely store up to 53 bits');
	    }
	    return (this.negative !== 0) ? -ret : ret;
	  };
	
	  BN.prototype.toJSON = function toJSON () {
	    return this.toString(16);
	  };
	
	  BN.prototype.toBuffer = function toBuffer (endian, length) {
	    assert(typeof Buffer !== 'undefined');
	    return this.toArrayLike(Buffer, endian, length);
	  };
	
	  BN.prototype.toArray = function toArray (endian, length) {
	    return this.toArrayLike(Array, endian, length);
	  };
	
	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
	    var byteLength = this.byteLength();
	    var reqLength = length || Math.max(1, byteLength);
	    assert(byteLength <= reqLength, 'byte array longer than desired length');
	    assert(reqLength > 0, 'Requested array length <= 0');
	
	    this.strip();
	    var littleEndian = endian === 'le';
	    var res = new ArrayType(reqLength);
	
	    var b, i;
	    var q = this.clone();
	    if (!littleEndian) {
	      // Assume big-endian
	      for (i = 0; i < reqLength - byteLength; i++) {
	        res[i] = 0;
	      }
	
	      for (i = 0; !q.isZero(); i++) {
	        b = q.andln(0xff);
	        q.iushrn(8);
	
	        res[reqLength - i - 1] = b;
	      }
	    } else {
	      for (i = 0; !q.isZero(); i++) {
	        b = q.andln(0xff);
	        q.iushrn(8);
	
	        res[i] = b;
	      }
	
	      for (; i < reqLength; i++) {
	        res[i] = 0;
	      }
	    }
	
	    return res;
	  };
	
	  if (Math.clz32) {
	    BN.prototype._countBits = function _countBits (w) {
	      return 32 - Math.clz32(w);
	    };
	  } else {
	    BN.prototype._countBits = function _countBits (w) {
	      var t = w;
	      var r = 0;
	      if (t >= 0x1000) {
	        r += 13;
	        t >>>= 13;
	      }
	      if (t >= 0x40) {
	        r += 7;
	        t >>>= 7;
	      }
	      if (t >= 0x8) {
	        r += 4;
	        t >>>= 4;
	      }
	      if (t >= 0x02) {
	        r += 2;
	        t >>>= 2;
	      }
	      return r + t;
	    };
	  }
	
	  BN.prototype._zeroBits = function _zeroBits (w) {
	    // Short-cut
	    if (w === 0) return 26;
	
	    var t = w;
	    var r = 0;
	    if ((t & 0x1fff) === 0) {
	      r += 13;
	      t >>>= 13;
	    }
	    if ((t & 0x7f) === 0) {
	      r += 7;
	      t >>>= 7;
	    }
	    if ((t & 0xf) === 0) {
	      r += 4;
	      t >>>= 4;
	    }
	    if ((t & 0x3) === 0) {
	      r += 2;
	      t >>>= 2;
	    }
	    if ((t & 0x1) === 0) {
	      r++;
	    }
	    return r;
	  };
	
	  // Return number of used bits in a BN
	  BN.prototype.bitLength = function bitLength () {
	    var w = this.words[this.length - 1];
	    var hi = this._countBits(w);
	    return (this.length - 1) * 26 + hi;
	  };
	
	  function toBitArray (num) {
	    var w = new Array(num.bitLength());
	
	    for (var bit = 0; bit < w.length; bit++) {
	      var off = (bit / 26) | 0;
	      var wbit = bit % 26;
	
	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
	    }
	
	    return w;
	  }
	
	  // Number of trailing zero bits
	  BN.prototype.zeroBits = function zeroBits () {
	    if (this.isZero()) return 0;
	
	    var r = 0;
	    for (var i = 0; i < this.length; i++) {
	      var b = this._zeroBits(this.words[i]);
	      r += b;
	      if (b !== 26) break;
	    }
	    return r;
	  };
	
	  BN.prototype.byteLength = function byteLength () {
	    return Math.ceil(this.bitLength() / 8);
	  };
	
	  BN.prototype.toTwos = function toTwos (width) {
	    if (this.negative !== 0) {
	      return this.abs().inotn(width).iaddn(1);
	    }
	    return this.clone();
	  };
	
	  BN.prototype.fromTwos = function fromTwos (width) {
	    if (this.testn(width - 1)) {
	      return this.notn(width).iaddn(1).ineg();
	    }
	    return this.clone();
	  };
	
	  BN.prototype.isNeg = function isNeg () {
	    return this.negative !== 0;
	  };
	
	  // Return negative clone of `this`
	  BN.prototype.neg = function neg () {
	    return this.clone().ineg();
	  };
	
	  BN.prototype.ineg = function ineg () {
	    if (!this.isZero()) {
	      this.negative ^= 1;
	    }
	
	    return this;
	  };
	
	  // Or `num` with `this` in-place
	  BN.prototype.iuor = function iuor (num) {
	    while (this.length < num.length) {
	      this.words[this.length++] = 0;
	    }
	
	    for (var i = 0; i < num.length; i++) {
	      this.words[i] = this.words[i] | num.words[i];
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ior = function ior (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuor(num);
	  };
	
	  // Or `num` with `this`
	  BN.prototype.or = function or (num) {
	    if (this.length > num.length) return this.clone().ior(num);
	    return num.clone().ior(this);
	  };
	
	  BN.prototype.uor = function uor (num) {
	    if (this.length > num.length) return this.clone().iuor(num);
	    return num.clone().iuor(this);
	  };
	
	  // And `num` with `this` in-place
	  BN.prototype.iuand = function iuand (num) {
	    // b = min-length(num, this)
	    var b;
	    if (this.length > num.length) {
	      b = num;
	    } else {
	      b = this;
	    }
	
	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = this.words[i] & num.words[i];
	    }
	
	    this.length = b.length;
	
	    return this.strip();
	  };
	
	  BN.prototype.iand = function iand (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuand(num);
	  };
	
	  // And `num` with `this`
	  BN.prototype.and = function and (num) {
	    if (this.length > num.length) return this.clone().iand(num);
	    return num.clone().iand(this);
	  };
	
	  BN.prototype.uand = function uand (num) {
	    if (this.length > num.length) return this.clone().iuand(num);
	    return num.clone().iuand(this);
	  };
	
	  // Xor `num` with `this` in-place
	  BN.prototype.iuxor = function iuxor (num) {
	    // a.length > b.length
	    var a;
	    var b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = a.words[i] ^ b.words[i];
	    }
	
	    if (this !== a) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    this.length = a.length;
	
	    return this.strip();
	  };
	
	  BN.prototype.ixor = function ixor (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuxor(num);
	  };
	
	  // Xor `num` with `this`
	  BN.prototype.xor = function xor (num) {
	    if (this.length > num.length) return this.clone().ixor(num);
	    return num.clone().ixor(this);
	  };
	
	  BN.prototype.uxor = function uxor (num) {
	    if (this.length > num.length) return this.clone().iuxor(num);
	    return num.clone().iuxor(this);
	  };
	
	  // Not ``this`` with ``width`` bitwidth
	  BN.prototype.inotn = function inotn (width) {
	    assert(typeof width === 'number' && width >= 0);
	
	    var bytesNeeded = Math.ceil(width / 26) | 0;
	    var bitsLeft = width % 26;
	
	    // Extend the buffer with leading zeroes
	    this._expand(bytesNeeded);
	
	    if (bitsLeft > 0) {
	      bytesNeeded--;
	    }
	
	    // Handle complete words
	    for (var i = 0; i < bytesNeeded; i++) {
	      this.words[i] = ~this.words[i] & 0x3ffffff;
	    }
	
	    // Handle the residue
	    if (bitsLeft > 0) {
	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
	    }
	
	    // And remove leading zeroes
	    return this.strip();
	  };
	
	  BN.prototype.notn = function notn (width) {
	    return this.clone().inotn(width);
	  };
	
	  // Set `bit` of `this`
	  BN.prototype.setn = function setn (bit, val) {
	    assert(typeof bit === 'number' && bit >= 0);
	
	    var off = (bit / 26) | 0;
	    var wbit = bit % 26;
	
	    this._expand(off + 1);
	
	    if (val) {
	      this.words[off] = this.words[off] | (1 << wbit);
	    } else {
	      this.words[off] = this.words[off] & ~(1 << wbit);
	    }
	
	    return this.strip();
	  };
	
	  // Add `num` to `this` in-place
	  BN.prototype.iadd = function iadd (num) {
	    var r;
	
	    // negative + positive
	    if (this.negative !== 0 && num.negative === 0) {
	      this.negative = 0;
	      r = this.isub(num);
	      this.negative ^= 1;
	      return this._normSign();
	
	    // positive + negative
	    } else if (this.negative === 0 && num.negative !== 0) {
	      num.negative = 0;
	      r = this.isub(num);
	      num.negative = 1;
	      return r._normSign();
	    }
	
	    // a.length > b.length
	    var a, b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	
	    this.length = a.length;
	    if (carry !== 0) {
	      this.words[this.length] = carry;
	      this.length++;
	    // Copy the rest of the words
	    } else if (a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    return this;
	  };
	
	  // Add `num` to `this`
	  BN.prototype.add = function add (num) {
	    var res;
	    if (num.negative !== 0 && this.negative === 0) {
	      num.negative = 0;
	      res = this.sub(num);
	      num.negative ^= 1;
	      return res;
	    } else if (num.negative === 0 && this.negative !== 0) {
	      this.negative = 0;
	      res = num.sub(this);
	      this.negative = 1;
	      return res;
	    }
	
	    if (this.length > num.length) return this.clone().iadd(num);
	
	    return num.clone().iadd(this);
	  };
	
	  // Subtract `num` from `this` in-place
	  BN.prototype.isub = function isub (num) {
	    // this - (-num) = this + num
	    if (num.negative !== 0) {
	      num.negative = 0;
	      var r = this.iadd(num);
	      num.negative = 1;
	      return r._normSign();
	
	    // -this - num = -(this + num)
	    } else if (this.negative !== 0) {
	      this.negative = 0;
	      this.iadd(num);
	      this.negative = 1;
	      return this._normSign();
	    }
	
	    // At this point both numbers are positive
	    var cmp = this.cmp(num);
	
	    // Optimization - zeroify
	    if (cmp === 0) {
	      this.negative = 0;
	      this.length = 1;
	      this.words[0] = 0;
	      return this;
	    }
	
	    // a > b
	    var a, b;
	    if (cmp > 0) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	
	    // Copy rest of the words
	    if (carry === 0 && i < a.length && a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    this.length = Math.max(this.length, i);
	
	    if (a !== this) {
	      this.negative = 1;
	    }
	
	    return this.strip();
	  };
	
	  // Subtract `num` from `this`
	  BN.prototype.sub = function sub (num) {
	    return this.clone().isub(num);
	  };
	
	  function smallMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    var len = (self.length + num.length) | 0;
	    out.length = len;
	    len = (len - 1) | 0;
	
	    // Peel one iteration (compiler can't do it, because of code complexity)
	    var a = self.words[0] | 0;
	    var b = num.words[0] | 0;
	    var r = a * b;
	
	    var lo = r & 0x3ffffff;
	    var carry = (r / 0x4000000) | 0;
	    out.words[0] = lo;
	
	    for (var k = 1; k < len; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = carry >>> 26;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = (k - j) | 0;
	        a = self.words[i] | 0;
	        b = num.words[j] | 0;
	        r = a * b + rword;
	        ncarry += (r / 0x4000000) | 0;
	        rword = r & 0x3ffffff;
	      }
	      out.words[k] = rword | 0;
	      carry = ncarry | 0;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry | 0;
	    } else {
	      out.length--;
	    }
	
	    return out.strip();
	  }
	
	  // TODO(indutny): it may be reasonable to omit it for users who don't need
	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
	  // multiplication (like elliptic secp256k1).
	  var comb10MulTo = function comb10MulTo (self, num, out) {
	    var a = self.words;
	    var b = num.words;
	    var o = out.words;
	    var c = 0;
	    var lo;
	    var mid;
	    var hi;
	    var a0 = a[0] | 0;
	    var al0 = a0 & 0x1fff;
	    var ah0 = a0 >>> 13;
	    var a1 = a[1] | 0;
	    var al1 = a1 & 0x1fff;
	    var ah1 = a1 >>> 13;
	    var a2 = a[2] | 0;
	    var al2 = a2 & 0x1fff;
	    var ah2 = a2 >>> 13;
	    var a3 = a[3] | 0;
	    var al3 = a3 & 0x1fff;
	    var ah3 = a3 >>> 13;
	    var a4 = a[4] | 0;
	    var al4 = a4 & 0x1fff;
	    var ah4 = a4 >>> 13;
	    var a5 = a[5] | 0;
	    var al5 = a5 & 0x1fff;
	    var ah5 = a5 >>> 13;
	    var a6 = a[6] | 0;
	    var al6 = a6 & 0x1fff;
	    var ah6 = a6 >>> 13;
	    var a7 = a[7] | 0;
	    var al7 = a7 & 0x1fff;
	    var ah7 = a7 >>> 13;
	    var a8 = a[8] | 0;
	    var al8 = a8 & 0x1fff;
	    var ah8 = a8 >>> 13;
	    var a9 = a[9] | 0;
	    var al9 = a9 & 0x1fff;
	    var ah9 = a9 >>> 13;
	    var b0 = b[0] | 0;
	    var bl0 = b0 & 0x1fff;
	    var bh0 = b0 >>> 13;
	    var b1 = b[1] | 0;
	    var bl1 = b1 & 0x1fff;
	    var bh1 = b1 >>> 13;
	    var b2 = b[2] | 0;
	    var bl2 = b2 & 0x1fff;
	    var bh2 = b2 >>> 13;
	    var b3 = b[3] | 0;
	    var bl3 = b3 & 0x1fff;
	    var bh3 = b3 >>> 13;
	    var b4 = b[4] | 0;
	    var bl4 = b4 & 0x1fff;
	    var bh4 = b4 >>> 13;
	    var b5 = b[5] | 0;
	    var bl5 = b5 & 0x1fff;
	    var bh5 = b5 >>> 13;
	    var b6 = b[6] | 0;
	    var bl6 = b6 & 0x1fff;
	    var bh6 = b6 >>> 13;
	    var b7 = b[7] | 0;
	    var bl7 = b7 & 0x1fff;
	    var bh7 = b7 >>> 13;
	    var b8 = b[8] | 0;
	    var bl8 = b8 & 0x1fff;
	    var bh8 = b8 >>> 13;
	    var b9 = b[9] | 0;
	    var bl9 = b9 & 0x1fff;
	    var bh9 = b9 >>> 13;
	
	    out.negative = self.negative ^ num.negative;
	    out.length = 19;
	    /* k = 0 */
	    lo = Math.imul(al0, bl0);
	    mid = Math.imul(al0, bh0);
	    mid += Math.imul(ah0, bl0);
	    hi = Math.imul(ah0, bh0);
	    var w0 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w0 >>> 26);
	    w0 &= 0x3ffffff;
	    /* k = 1 */
	    lo = Math.imul(al1, bl0);
	    mid = Math.imul(al1, bh0);
	    mid += Math.imul(ah1, bl0);
	    hi = Math.imul(ah1, bh0);
	    lo += Math.imul(al0, bl1);
	    mid += Math.imul(al0, bh1);
	    mid += Math.imul(ah0, bl1);
	    hi += Math.imul(ah0, bh1);
	    var w1 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w1 >>> 26);
	    w1 &= 0x3ffffff;
	    /* k = 2 */
	    lo = Math.imul(al2, bl0);
	    mid = Math.imul(al2, bh0);
	    mid += Math.imul(ah2, bl0);
	    hi = Math.imul(ah2, bh0);
	    lo += Math.imul(al1, bl1);
	    mid += Math.imul(al1, bh1);
	    mid += Math.imul(ah1, bl1);
	    hi += Math.imul(ah1, bh1);
	    lo += Math.imul(al0, bl2);
	    mid += Math.imul(al0, bh2);
	    mid += Math.imul(ah0, bl2);
	    hi += Math.imul(ah0, bh2);
	    var w2 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w2 >>> 26);
	    w2 &= 0x3ffffff;
	    /* k = 3 */
	    lo = Math.imul(al3, bl0);
	    mid = Math.imul(al3, bh0);
	    mid += Math.imul(ah3, bl0);
	    hi = Math.imul(ah3, bh0);
	    lo += Math.imul(al2, bl1);
	    mid += Math.imul(al2, bh1);
	    mid += Math.imul(ah2, bl1);
	    hi += Math.imul(ah2, bh1);
	    lo += Math.imul(al1, bl2);
	    mid += Math.imul(al1, bh2);
	    mid += Math.imul(ah1, bl2);
	    hi += Math.imul(ah1, bh2);
	    lo += Math.imul(al0, bl3);
	    mid += Math.imul(al0, bh3);
	    mid += Math.imul(ah0, bl3);
	    hi += Math.imul(ah0, bh3);
	    var w3 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w3 >>> 26);
	    w3 &= 0x3ffffff;
	    /* k = 4 */
	    lo = Math.imul(al4, bl0);
	    mid = Math.imul(al4, bh0);
	    mid += Math.imul(ah4, bl0);
	    hi = Math.imul(ah4, bh0);
	    lo += Math.imul(al3, bl1);
	    mid += Math.imul(al3, bh1);
	    mid += Math.imul(ah3, bl1);
	    hi += Math.imul(ah3, bh1);
	    lo += Math.imul(al2, bl2);
	    mid += Math.imul(al2, bh2);
	    mid += Math.imul(ah2, bl2);
	    hi += Math.imul(ah2, bh2);
	    lo += Math.imul(al1, bl3);
	    mid += Math.imul(al1, bh3);
	    mid += Math.imul(ah1, bl3);
	    hi += Math.imul(ah1, bh3);
	    lo += Math.imul(al0, bl4);
	    mid += Math.imul(al0, bh4);
	    mid += Math.imul(ah0, bl4);
	    hi += Math.imul(ah0, bh4);
	    var w4 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w4 >>> 26);
	    w4 &= 0x3ffffff;
	    /* k = 5 */
	    lo = Math.imul(al5, bl0);
	    mid = Math.imul(al5, bh0);
	    mid += Math.imul(ah5, bl0);
	    hi = Math.imul(ah5, bh0);
	    lo += Math.imul(al4, bl1);
	    mid += Math.imul(al4, bh1);
	    mid += Math.imul(ah4, bl1);
	    hi += Math.imul(ah4, bh1);
	    lo += Math.imul(al3, bl2);
	    mid += Math.imul(al3, bh2);
	    mid += Math.imul(ah3, bl2);
	    hi += Math.imul(ah3, bh2);
	    lo += Math.imul(al2, bl3);
	    mid += Math.imul(al2, bh3);
	    mid += Math.imul(ah2, bl3);
	    hi += Math.imul(ah2, bh3);
	    lo += Math.imul(al1, bl4);
	    mid += Math.imul(al1, bh4);
	    mid += Math.imul(ah1, bl4);
	    hi += Math.imul(ah1, bh4);
	    lo += Math.imul(al0, bl5);
	    mid += Math.imul(al0, bh5);
	    mid += Math.imul(ah0, bl5);
	    hi += Math.imul(ah0, bh5);
	    var w5 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w5 >>> 26);
	    w5 &= 0x3ffffff;
	    /* k = 6 */
	    lo = Math.imul(al6, bl0);
	    mid = Math.imul(al6, bh0);
	    mid += Math.imul(ah6, bl0);
	    hi = Math.imul(ah6, bh0);
	    lo += Math.imul(al5, bl1);
	    mid += Math.imul(al5, bh1);
	    mid += Math.imul(ah5, bl1);
	    hi += Math.imul(ah5, bh1);
	    lo += Math.imul(al4, bl2);
	    mid += Math.imul(al4, bh2);
	    mid += Math.imul(ah4, bl2);
	    hi += Math.imul(ah4, bh2);
	    lo += Math.imul(al3, bl3);
	    mid += Math.imul(al3, bh3);
	    mid += Math.imul(ah3, bl3);
	    hi += Math.imul(ah3, bh3);
	    lo += Math.imul(al2, bl4);
	    mid += Math.imul(al2, bh4);
	    mid += Math.imul(ah2, bl4);
	    hi += Math.imul(ah2, bh4);
	    lo += Math.imul(al1, bl5);
	    mid += Math.imul(al1, bh5);
	    mid += Math.imul(ah1, bl5);
	    hi += Math.imul(ah1, bh5);
	    lo += Math.imul(al0, bl6);
	    mid += Math.imul(al0, bh6);
	    mid += Math.imul(ah0, bl6);
	    hi += Math.imul(ah0, bh6);
	    var w6 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w6 >>> 26);
	    w6 &= 0x3ffffff;
	    /* k = 7 */
	    lo = Math.imul(al7, bl0);
	    mid = Math.imul(al7, bh0);
	    mid += Math.imul(ah7, bl0);
	    hi = Math.imul(ah7, bh0);
	    lo += Math.imul(al6, bl1);
	    mid += Math.imul(al6, bh1);
	    mid += Math.imul(ah6, bl1);
	    hi += Math.imul(ah6, bh1);
	    lo += Math.imul(al5, bl2);
	    mid += Math.imul(al5, bh2);
	    mid += Math.imul(ah5, bl2);
	    hi += Math.imul(ah5, bh2);
	    lo += Math.imul(al4, bl3);
	    mid += Math.imul(al4, bh3);
	    mid += Math.imul(ah4, bl3);
	    hi += Math.imul(ah4, bh3);
	    lo += Math.imul(al3, bl4);
	    mid += Math.imul(al3, bh4);
	    mid += Math.imul(ah3, bl4);
	    hi += Math.imul(ah3, bh4);
	    lo += Math.imul(al2, bl5);
	    mid += Math.imul(al2, bh5);
	    mid += Math.imul(ah2, bl5);
	    hi += Math.imul(ah2, bh5);
	    lo += Math.imul(al1, bl6);
	    mid += Math.imul(al1, bh6);
	    mid += Math.imul(ah1, bl6);
	    hi += Math.imul(ah1, bh6);
	    lo += Math.imul(al0, bl7);
	    mid += Math.imul(al0, bh7);
	    mid += Math.imul(ah0, bl7);
	    hi += Math.imul(ah0, bh7);
	    var w7 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w7 >>> 26);
	    w7 &= 0x3ffffff;
	    /* k = 8 */
	    lo = Math.imul(al8, bl0);
	    mid = Math.imul(al8, bh0);
	    mid += Math.imul(ah8, bl0);
	    hi = Math.imul(ah8, bh0);
	    lo += Math.imul(al7, bl1);
	    mid += Math.imul(al7, bh1);
	    mid += Math.imul(ah7, bl1);
	    hi += Math.imul(ah7, bh1);
	    lo += Math.imul(al6, bl2);
	    mid += Math.imul(al6, bh2);
	    mid += Math.imul(ah6, bl2);
	    hi += Math.imul(ah6, bh2);
	    lo += Math.imul(al5, bl3);
	    mid += Math.imul(al5, bh3);
	    mid += Math.imul(ah5, bl3);
	    hi += Math.imul(ah5, bh3);
	    lo += Math.imul(al4, bl4);
	    mid += Math.imul(al4, bh4);
	    mid += Math.imul(ah4, bl4);
	    hi += Math.imul(ah4, bh4);
	    lo += Math.imul(al3, bl5);
	    mid += Math.imul(al3, bh5);
	    mid += Math.imul(ah3, bl5);
	    hi += Math.imul(ah3, bh5);
	    lo += Math.imul(al2, bl6);
	    mid += Math.imul(al2, bh6);
	    mid += Math.imul(ah2, bl6);
	    hi += Math.imul(ah2, bh6);
	    lo += Math.imul(al1, bl7);
	    mid += Math.imul(al1, bh7);
	    mid += Math.imul(ah1, bl7);
	    hi += Math.imul(ah1, bh7);
	    lo += Math.imul(al0, bl8);
	    mid += Math.imul(al0, bh8);
	    mid += Math.imul(ah0, bl8);
	    hi += Math.imul(ah0, bh8);
	    var w8 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w8 >>> 26);
	    w8 &= 0x3ffffff;
	    /* k = 9 */
	    lo = Math.imul(al9, bl0);
	    mid = Math.imul(al9, bh0);
	    mid += Math.imul(ah9, bl0);
	    hi = Math.imul(ah9, bh0);
	    lo += Math.imul(al8, bl1);
	    mid += Math.imul(al8, bh1);
	    mid += Math.imul(ah8, bl1);
	    hi += Math.imul(ah8, bh1);
	    lo += Math.imul(al7, bl2);
	    mid += Math.imul(al7, bh2);
	    mid += Math.imul(ah7, bl2);
	    hi += Math.imul(ah7, bh2);
	    lo += Math.imul(al6, bl3);
	    mid += Math.imul(al6, bh3);
	    mid += Math.imul(ah6, bl3);
	    hi += Math.imul(ah6, bh3);
	    lo += Math.imul(al5, bl4);
	    mid += Math.imul(al5, bh4);
	    mid += Math.imul(ah5, bl4);
	    hi += Math.imul(ah5, bh4);
	    lo += Math.imul(al4, bl5);
	    mid += Math.imul(al4, bh5);
	    mid += Math.imul(ah4, bl5);
	    hi += Math.imul(ah4, bh5);
	    lo += Math.imul(al3, bl6);
	    mid += Math.imul(al3, bh6);
	    mid += Math.imul(ah3, bl6);
	    hi += Math.imul(ah3, bh6);
	    lo += Math.imul(al2, bl7);
	    mid += Math.imul(al2, bh7);
	    mid += Math.imul(ah2, bl7);
	    hi += Math.imul(ah2, bh7);
	    lo += Math.imul(al1, bl8);
	    mid += Math.imul(al1, bh8);
	    mid += Math.imul(ah1, bl8);
	    hi += Math.imul(ah1, bh8);
	    lo += Math.imul(al0, bl9);
	    mid += Math.imul(al0, bh9);
	    mid += Math.imul(ah0, bl9);
	    hi += Math.imul(ah0, bh9);
	    var w9 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w9 >>> 26);
	    w9 &= 0x3ffffff;
	    /* k = 10 */
	    lo = Math.imul(al9, bl1);
	    mid = Math.imul(al9, bh1);
	    mid += Math.imul(ah9, bl1);
	    hi = Math.imul(ah9, bh1);
	    lo += Math.imul(al8, bl2);
	    mid += Math.imul(al8, bh2);
	    mid += Math.imul(ah8, bl2);
	    hi += Math.imul(ah8, bh2);
	    lo += Math.imul(al7, bl3);
	    mid += Math.imul(al7, bh3);
	    mid += Math.imul(ah7, bl3);
	    hi += Math.imul(ah7, bh3);
	    lo += Math.imul(al6, bl4);
	    mid += Math.imul(al6, bh4);
	    mid += Math.imul(ah6, bl4);
	    hi += Math.imul(ah6, bh4);
	    lo += Math.imul(al5, bl5);
	    mid += Math.imul(al5, bh5);
	    mid += Math.imul(ah5, bl5);
	    hi += Math.imul(ah5, bh5);
	    lo += Math.imul(al4, bl6);
	    mid += Math.imul(al4, bh6);
	    mid += Math.imul(ah4, bl6);
	    hi += Math.imul(ah4, bh6);
	    lo += Math.imul(al3, bl7);
	    mid += Math.imul(al3, bh7);
	    mid += Math.imul(ah3, bl7);
	    hi += Math.imul(ah3, bh7);
	    lo += Math.imul(al2, bl8);
	    mid += Math.imul(al2, bh8);
	    mid += Math.imul(ah2, bl8);
	    hi += Math.imul(ah2, bh8);
	    lo += Math.imul(al1, bl9);
	    mid += Math.imul(al1, bh9);
	    mid += Math.imul(ah1, bl9);
	    hi += Math.imul(ah1, bh9);
	    var w10 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w10 >>> 26);
	    w10 &= 0x3ffffff;
	    /* k = 11 */
	    lo = Math.imul(al9, bl2);
	    mid = Math.imul(al9, bh2);
	    mid += Math.imul(ah9, bl2);
	    hi = Math.imul(ah9, bh2);
	    lo += Math.imul(al8, bl3);
	    mid += Math.imul(al8, bh3);
	    mid += Math.imul(ah8, bl3);
	    hi += Math.imul(ah8, bh3);
	    lo += Math.imul(al7, bl4);
	    mid += Math.imul(al7, bh4);
	    mid += Math.imul(ah7, bl4);
	    hi += Math.imul(ah7, bh4);
	    lo += Math.imul(al6, bl5);
	    mid += Math.imul(al6, bh5);
	    mid += Math.imul(ah6, bl5);
	    hi += Math.imul(ah6, bh5);
	    lo += Math.imul(al5, bl6);
	    mid += Math.imul(al5, bh6);
	    mid += Math.imul(ah5, bl6);
	    hi += Math.imul(ah5, bh6);
	    lo += Math.imul(al4, bl7);
	    mid += Math.imul(al4, bh7);
	    mid += Math.imul(ah4, bl7);
	    hi += Math.imul(ah4, bh7);
	    lo += Math.imul(al3, bl8);
	    mid += Math.imul(al3, bh8);
	    mid += Math.imul(ah3, bl8);
	    hi += Math.imul(ah3, bh8);
	    lo += Math.imul(al2, bl9);
	    mid += Math.imul(al2, bh9);
	    mid += Math.imul(ah2, bl9);
	    hi += Math.imul(ah2, bh9);
	    var w11 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w11 >>> 26);
	    w11 &= 0x3ffffff;
	    /* k = 12 */
	    lo = Math.imul(al9, bl3);
	    mid = Math.imul(al9, bh3);
	    mid += Math.imul(ah9, bl3);
	    hi = Math.imul(ah9, bh3);
	    lo += Math.imul(al8, bl4);
	    mid += Math.imul(al8, bh4);
	    mid += Math.imul(ah8, bl4);
	    hi += Math.imul(ah8, bh4);
	    lo += Math.imul(al7, bl5);
	    mid += Math.imul(al7, bh5);
	    mid += Math.imul(ah7, bl5);
	    hi += Math.imul(ah7, bh5);
	    lo += Math.imul(al6, bl6);
	    mid += Math.imul(al6, bh6);
	    mid += Math.imul(ah6, bl6);
	    hi += Math.imul(ah6, bh6);
	    lo += Math.imul(al5, bl7);
	    mid += Math.imul(al5, bh7);
	    mid += Math.imul(ah5, bl7);
	    hi += Math.imul(ah5, bh7);
	    lo += Math.imul(al4, bl8);
	    mid += Math.imul(al4, bh8);
	    mid += Math.imul(ah4, bl8);
	    hi += Math.imul(ah4, bh8);
	    lo += Math.imul(al3, bl9);
	    mid += Math.imul(al3, bh9);
	    mid += Math.imul(ah3, bl9);
	    hi += Math.imul(ah3, bh9);
	    var w12 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w12 >>> 26);
	    w12 &= 0x3ffffff;
	    /* k = 13 */
	    lo = Math.imul(al9, bl4);
	    mid = Math.imul(al9, bh4);
	    mid += Math.imul(ah9, bl4);
	    hi = Math.imul(ah9, bh4);
	    lo += Math.imul(al8, bl5);
	    mid += Math.imul(al8, bh5);
	    mid += Math.imul(ah8, bl5);
	    hi += Math.imul(ah8, bh5);
	    lo += Math.imul(al7, bl6);
	    mid += Math.imul(al7, bh6);
	    mid += Math.imul(ah7, bl6);
	    hi += Math.imul(ah7, bh6);
	    lo += Math.imul(al6, bl7);
	    mid += Math.imul(al6, bh7);
	    mid += Math.imul(ah6, bl7);
	    hi += Math.imul(ah6, bh7);
	    lo += Math.imul(al5, bl8);
	    mid += Math.imul(al5, bh8);
	    mid += Math.imul(ah5, bl8);
	    hi += Math.imul(ah5, bh8);
	    lo += Math.imul(al4, bl9);
	    mid += Math.imul(al4, bh9);
	    mid += Math.imul(ah4, bl9);
	    hi += Math.imul(ah4, bh9);
	    var w13 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w13 >>> 26);
	    w13 &= 0x3ffffff;
	    /* k = 14 */
	    lo = Math.imul(al9, bl5);
	    mid = Math.imul(al9, bh5);
	    mid += Math.imul(ah9, bl5);
	    hi = Math.imul(ah9, bh5);
	    lo += Math.imul(al8, bl6);
	    mid += Math.imul(al8, bh6);
	    mid += Math.imul(ah8, bl6);
	    hi += Math.imul(ah8, bh6);
	    lo += Math.imul(al7, bl7);
	    mid += Math.imul(al7, bh7);
	    mid += Math.imul(ah7, bl7);
	    hi += Math.imul(ah7, bh7);
	    lo += Math.imul(al6, bl8);
	    mid += Math.imul(al6, bh8);
	    mid += Math.imul(ah6, bl8);
	    hi += Math.imul(ah6, bh8);
	    lo += Math.imul(al5, bl9);
	    mid += Math.imul(al5, bh9);
	    mid += Math.imul(ah5, bl9);
	    hi += Math.imul(ah5, bh9);
	    var w14 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w14 >>> 26);
	    w14 &= 0x3ffffff;
	    /* k = 15 */
	    lo = Math.imul(al9, bl6);
	    mid = Math.imul(al9, bh6);
	    mid += Math.imul(ah9, bl6);
	    hi = Math.imul(ah9, bh6);
	    lo += Math.imul(al8, bl7);
	    mid += Math.imul(al8, bh7);
	    mid += Math.imul(ah8, bl7);
	    hi += Math.imul(ah8, bh7);
	    lo += Math.imul(al7, bl8);
	    mid += Math.imul(al7, bh8);
	    mid += Math.imul(ah7, bl8);
	    hi += Math.imul(ah7, bh8);
	    lo += Math.imul(al6, bl9);
	    mid += Math.imul(al6, bh9);
	    mid += Math.imul(ah6, bl9);
	    hi += Math.imul(ah6, bh9);
	    var w15 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w15 >>> 26);
	    w15 &= 0x3ffffff;
	    /* k = 16 */
	    lo = Math.imul(al9, bl7);
	    mid = Math.imul(al9, bh7);
	    mid += Math.imul(ah9, bl7);
	    hi = Math.imul(ah9, bh7);
	    lo += Math.imul(al8, bl8);
	    mid += Math.imul(al8, bh8);
	    mid += Math.imul(ah8, bl8);
	    hi += Math.imul(ah8, bh8);
	    lo += Math.imul(al7, bl9);
	    mid += Math.imul(al7, bh9);
	    mid += Math.imul(ah7, bl9);
	    hi += Math.imul(ah7, bh9);
	    var w16 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w16 >>> 26);
	    w16 &= 0x3ffffff;
	    /* k = 17 */
	    lo = Math.imul(al9, bl8);
	    mid = Math.imul(al9, bh8);
	    mid += Math.imul(ah9, bl8);
	    hi = Math.imul(ah9, bh8);
	    lo += Math.imul(al8, bl9);
	    mid += Math.imul(al8, bh9);
	    mid += Math.imul(ah8, bl9);
	    hi += Math.imul(ah8, bh9);
	    var w17 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w17 >>> 26);
	    w17 &= 0x3ffffff;
	    /* k = 18 */
	    lo = Math.imul(al9, bl9);
	    mid = Math.imul(al9, bh9);
	    mid += Math.imul(ah9, bl9);
	    hi = Math.imul(ah9, bh9);
	    var w18 = c + lo + ((mid & 0x1fff) << 13);
	    c = hi + (mid >>> 13) + (w18 >>> 26);
	    w18 &= 0x3ffffff;
	    o[0] = w0;
	    o[1] = w1;
	    o[2] = w2;
	    o[3] = w3;
	    o[4] = w4;
	    o[5] = w5;
	    o[6] = w6;
	    o[7] = w7;
	    o[8] = w8;
	    o[9] = w9;
	    o[10] = w10;
	    o[11] = w11;
	    o[12] = w12;
	    o[13] = w13;
	    o[14] = w14;
	    o[15] = w15;
	    o[16] = w16;
	    o[17] = w17;
	    o[18] = w18;
	    if (c !== 0) {
	      o[19] = c;
	      out.length++;
	    }
	    return out;
	  };
	
	  // Polyfill comb
	  if (!Math.imul) {
	    comb10MulTo = smallMulTo;
	  }
	
	  function bigMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    out.length = self.length + num.length;
	
	    var carry = 0;
	    var hncarry = 0;
	    for (var k = 0; k < out.length - 1; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = hncarry;
	      hncarry = 0;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = k - j;
	        var a = self.words[i] | 0;
	        var b = num.words[j] | 0;
	        var r = a * b;
	
	        var lo = r & 0x3ffffff;
	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
	        lo = (lo + rword) | 0;
	        rword = lo & 0x3ffffff;
	        ncarry = (ncarry + (lo >>> 26)) | 0;
	
	        hncarry += ncarry >>> 26;
	        ncarry &= 0x3ffffff;
	      }
	      out.words[k] = rword;
	      carry = ncarry;
	      ncarry = hncarry;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry;
	    } else {
	      out.length--;
	    }
	
	    return out.strip();
	  }
	
	  function jumboMulTo (self, num, out) {
	    var fftm = new FFTM();
	    return fftm.mulp(self, num, out);
	  }
	
	  BN.prototype.mulTo = function mulTo (num, out) {
	    var res;
	    var len = this.length + num.length;
	    if (this.length === 10 && num.length === 10) {
	      res = comb10MulTo(this, num, out);
	    } else if (len < 63) {
	      res = smallMulTo(this, num, out);
	    } else if (len < 1024) {
	      res = bigMulTo(this, num, out);
	    } else {
	      res = jumboMulTo(this, num, out);
	    }
	
	    return res;
	  };
	
	  // Cooley-Tukey algorithm for FFT
	  // slightly revisited to rely on looping instead of recursion
	
	  function FFTM (x, y) {
	    this.x = x;
	    this.y = y;
	  }
	
	  FFTM.prototype.makeRBT = function makeRBT (N) {
	    var t = new Array(N);
	    var l = BN.prototype._countBits(N) - 1;
	    for (var i = 0; i < N; i++) {
	      t[i] = this.revBin(i, l, N);
	    }
	
	    return t;
	  };
	
	  // Returns binary-reversed representation of `x`
	  FFTM.prototype.revBin = function revBin (x, l, N) {
	    if (x === 0 || x === N - 1) return x;
	
	    var rb = 0;
	    for (var i = 0; i < l; i++) {
	      rb |= (x & 1) << (l - i - 1);
	      x >>= 1;
	    }
	
	    return rb;
	  };
	
	  // Performs "tweedling" phase, therefore 'emulating'
	  // behaviour of the recursive algorithm
	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
	    for (var i = 0; i < N; i++) {
	      rtws[i] = rws[rbt[i]];
	      itws[i] = iws[rbt[i]];
	    }
	  };
	
	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
	    this.permute(rbt, rws, iws, rtws, itws, N);
	
	    for (var s = 1; s < N; s <<= 1) {
	      var l = s << 1;
	
	      var rtwdf = Math.cos(2 * Math.PI / l);
	      var itwdf = Math.sin(2 * Math.PI / l);
	
	      for (var p = 0; p < N; p += l) {
	        var rtwdf_ = rtwdf;
	        var itwdf_ = itwdf;
	
	        for (var j = 0; j < s; j++) {
	          var re = rtws[p + j];
	          var ie = itws[p + j];
	
	          var ro = rtws[p + j + s];
	          var io = itws[p + j + s];
	
	          var rx = rtwdf_ * ro - itwdf_ * io;
	
	          io = rtwdf_ * io + itwdf_ * ro;
	          ro = rx;
	
	          rtws[p + j] = re + ro;
	          itws[p + j] = ie + io;
	
	          rtws[p + j + s] = re - ro;
	          itws[p + j + s] = ie - io;
	
	          /* jshint maxdepth : false */
	          if (j !== l) {
	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
	
	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
	            rtwdf_ = rx;
	          }
	        }
	      }
	    }
	  };
	
	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
	    var N = Math.max(m, n) | 1;
	    var odd = N & 1;
	    var i = 0;
	    for (N = N / 2 | 0; N; N = N >>> 1) {
	      i++;
	    }
	
	    return 1 << i + 1 + odd;
	  };
	
	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
	    if (N <= 1) return;
	
	    for (var i = 0; i < N / 2; i++) {
	      var t = rws[i];
	
	      rws[i] = rws[N - i - 1];
	      rws[N - i - 1] = t;
	
	      t = iws[i];
	
	      iws[i] = -iws[N - i - 1];
	      iws[N - i - 1] = -t;
	    }
	  };
	
	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
	    var carry = 0;
	    for (var i = 0; i < N / 2; i++) {
	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
	        Math.round(ws[2 * i] / N) +
	        carry;
	
	      ws[i] = w & 0x3ffffff;
	
	      if (w < 0x4000000) {
	        carry = 0;
	      } else {
	        carry = w / 0x4000000 | 0;
	      }
	    }
	
	    return ws;
	  };
	
	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
	    var carry = 0;
	    for (var i = 0; i < len; i++) {
	      carry = carry + (ws[i] | 0);
	
	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
	    }
	
	    // Pad with zeroes
	    for (i = 2 * len; i < N; ++i) {
	      rws[i] = 0;
	    }
	
	    assert(carry === 0);
	    assert((carry & ~0x1fff) === 0);
	  };
	
	  FFTM.prototype.stub = function stub (N) {
	    var ph = new Array(N);
	    for (var i = 0; i < N; i++) {
	      ph[i] = 0;
	    }
	
	    return ph;
	  };
	
	  FFTM.prototype.mulp = function mulp (x, y, out) {
	    var N = 2 * this.guessLen13b(x.length, y.length);
	
	    var rbt = this.makeRBT(N);
	
	    var _ = this.stub(N);
	
	    var rws = new Array(N);
	    var rwst = new Array(N);
	    var iwst = new Array(N);
	
	    var nrws = new Array(N);
	    var nrwst = new Array(N);
	    var niwst = new Array(N);
	
	    var rmws = out.words;
	    rmws.length = N;
	
	    this.convert13b(x.words, x.length, rws, N);
	    this.convert13b(y.words, y.length, nrws, N);
	
	    this.transform(rws, _, rwst, iwst, N, rbt);
	    this.transform(nrws, _, nrwst, niwst, N, rbt);
	
	    for (var i = 0; i < N; i++) {
	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
	      rwst[i] = rx;
	    }
	
	    this.conjugate(rwst, iwst, N);
	    this.transform(rwst, iwst, rmws, _, N, rbt);
	    this.conjugate(rmws, _, N);
	    this.normalize13b(rmws, N);
	
	    out.negative = x.negative ^ y.negative;
	    out.length = x.length + y.length;
	    return out.strip();
	  };
	
	  // Multiply `this` by `num`
	  BN.prototype.mul = function mul (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return this.mulTo(num, out);
	  };
	
	  // Multiply employing FFT
	  BN.prototype.mulf = function mulf (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return jumboMulTo(this, num, out);
	  };
	
	  // In-place Multiplication
	  BN.prototype.imul = function imul (num) {
	    return this.clone().mulTo(num, this);
	  };
	
	  BN.prototype.imuln = function imuln (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	
	    // Carry
	    var carry = 0;
	    for (var i = 0; i < this.length; i++) {
	      var w = (this.words[i] | 0) * num;
	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
	      carry >>= 26;
	      carry += (w / 0x4000000) | 0;
	      // NOTE: lo is 27bit maximum
	      carry += lo >>> 26;
	      this.words[i] = lo & 0x3ffffff;
	    }
	
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	
	    return this;
	  };
	
	  BN.prototype.muln = function muln (num) {
	    return this.clone().imuln(num);
	  };
	
	  // `this` * `this`
	  BN.prototype.sqr = function sqr () {
	    return this.mul(this);
	  };
	
	  // `this` * `this` in-place
	  BN.prototype.isqr = function isqr () {
	    return this.imul(this.clone());
	  };
	
	  // Math.pow(`this`, `num`)
	  BN.prototype.pow = function pow (num) {
	    var w = toBitArray(num);
	    if (w.length === 0) return new BN(1);
	
	    // Skip leading zeroes
	    var res = this;
	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
	      if (w[i] !== 0) break;
	    }
	
	    if (++i < w.length) {
	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
	        if (w[i] === 0) continue;
	
	        res = res.mul(q);
	      }
	    }
	
	    return res;
	  };
	
	  // Shift-left in-place
	  BN.prototype.iushln = function iushln (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
	    var i;
	
	    if (r !== 0) {
	      var carry = 0;
	
	      for (i = 0; i < this.length; i++) {
	        var newCarry = this.words[i] & carryMask;
	        var c = ((this.words[i] | 0) - newCarry) << r;
	        this.words[i] = c | carry;
	        carry = newCarry >>> (26 - r);
	      }
	
	      if (carry) {
	        this.words[i] = carry;
	        this.length++;
	      }
	    }
	
	    if (s !== 0) {
	      for (i = this.length - 1; i >= 0; i--) {
	        this.words[i + s] = this.words[i];
	      }
	
	      for (i = 0; i < s; i++) {
	        this.words[i] = 0;
	      }
	
	      this.length += s;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ishln = function ishln (bits) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushln(bits);
	  };
	
	  // Shift-right in-place
	  // NOTE: `hint` is a lowest bit before trailing zeroes
	  // NOTE: if `extended` is present - it will be filled with destroyed bits
	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var h;
	    if (hint) {
	      h = (hint - (hint % 26)) / 26;
	    } else {
	      h = 0;
	    }
	
	    var r = bits % 26;
	    var s = Math.min((bits - r) / 26, this.length);
	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	    var maskedWords = extended;
	
	    h -= s;
	    h = Math.max(0, h);
	
	    // Extended mode, copy masked part
	    if (maskedWords) {
	      for (var i = 0; i < s; i++) {
	        maskedWords.words[i] = this.words[i];
	      }
	      maskedWords.length = s;
	    }
	
	    if (s === 0) {
	      // No-op, we should not move anything at all
	    } else if (this.length > s) {
	      this.length -= s;
	      for (i = 0; i < this.length; i++) {
	        this.words[i] = this.words[i + s];
	      }
	    } else {
	      this.words[0] = 0;
	      this.length = 1;
	    }
	
	    var carry = 0;
	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
	      var word = this.words[i] | 0;
	      this.words[i] = (carry << (26 - r)) | (word >>> r);
	      carry = word & mask;
	    }
	
	    // Push carried bits as a mask
	    if (maskedWords && carry !== 0) {
	      maskedWords.words[maskedWords.length++] = carry;
	    }
	
	    if (this.length === 0) {
	      this.words[0] = 0;
	      this.length = 1;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushrn(bits, hint, extended);
	  };
	
	  // Shift-left
	  BN.prototype.shln = function shln (bits) {
	    return this.clone().ishln(bits);
	  };
	
	  BN.prototype.ushln = function ushln (bits) {
	    return this.clone().iushln(bits);
	  };
	
	  // Shift-right
	  BN.prototype.shrn = function shrn (bits) {
	    return this.clone().ishrn(bits);
	  };
	
	  BN.prototype.ushrn = function ushrn (bits) {
	    return this.clone().iushrn(bits);
	  };
	
	  // Test if n bit is set
	  BN.prototype.testn = function testn (bit) {
	    assert(typeof bit === 'number' && bit >= 0);
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;
	
	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) return false;
	
	    // Check bit and return
	    var w = this.words[s];
	
	    return !!(w & q);
	  };
	
	  // Return only lowers bits of number (in-place)
	  BN.prototype.imaskn = function imaskn (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	
	    assert(this.negative === 0, 'imaskn works only with positive numbers');
	
	    if (r !== 0) {
	      s++;
	    }
	    this.length = Math.min(s, this.length);
	
	    if (r !== 0) {
	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	      this.words[this.length - 1] &= mask;
	    }
	
	    return this.strip();
	  };
	
	  // Return only lowers bits of number
	  BN.prototype.maskn = function maskn (bits) {
	    return this.clone().imaskn(bits);
	  };
	
	  // Add plain number `num` to `this`
	  BN.prototype.iaddn = function iaddn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.isubn(-num);
	
	    // Possible sign change
	    if (this.negative !== 0) {
	      if (this.length === 1 && (this.words[0] | 0) < num) {
	        this.words[0] = num - (this.words[0] | 0);
	        this.negative = 0;
	        return this;
	      }
	
	      this.negative = 0;
	      this.isubn(num);
	      this.negative = 1;
	      return this;
	    }
	
	    // Add without checks
	    return this._iaddn(num);
	  };
	
	  BN.prototype._iaddn = function _iaddn (num) {
	    this.words[0] += num;
	
	    // Carry
	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
	      this.words[i] -= 0x4000000;
	      if (i === this.length - 1) {
	        this.words[i + 1] = 1;
	      } else {
	        this.words[i + 1]++;
	      }
	    }
	    this.length = Math.max(this.length, i + 1);
	
	    return this;
	  };
	
	  // Subtract plain number `num` from `this`
	  BN.prototype.isubn = function isubn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.iaddn(-num);
	
	    if (this.negative !== 0) {
	      this.negative = 0;
	      this.iaddn(num);
	      this.negative = 1;
	      return this;
	    }
	
	    this.words[0] -= num;
	
	    if (this.length === 1 && this.words[0] < 0) {
	      this.words[0] = -this.words[0];
	      this.negative = 1;
	    } else {
	      // Carry
	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
	        this.words[i] += 0x4000000;
	        this.words[i + 1] -= 1;
	      }
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.addn = function addn (num) {
	    return this.clone().iaddn(num);
	  };
	
	  BN.prototype.subn = function subn (num) {
	    return this.clone().isubn(num);
	  };
	
	  BN.prototype.iabs = function iabs () {
	    this.negative = 0;
	
	    return this;
	  };
	
	  BN.prototype.abs = function abs () {
	    return this.clone().iabs();
	  };
	
	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
	    var len = num.length + shift;
	    var i;
	
	    this._expand(len);
	
	    var w;
	    var carry = 0;
	    for (i = 0; i < num.length; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      var right = (num.words[i] | 0) * mul;
	      w -= right & 0x3ffffff;
	      carry = (w >> 26) - ((right / 0x4000000) | 0);
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	    for (; i < this.length - shift; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      carry = w >> 26;
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	
	    if (carry === 0) return this.strip();
	
	    // Subtraction overflow
	    assert(carry === -1);
	    carry = 0;
	    for (i = 0; i < this.length; i++) {
	      w = -(this.words[i] | 0) + carry;
	      carry = w >> 26;
	      this.words[i] = w & 0x3ffffff;
	    }
	    this.negative = 1;
	
	    return this.strip();
	  };
	
	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
	    var shift = this.length - num.length;
	
	    var a = this.clone();
	    var b = num;
	
	    // Normalize
	    var bhi = b.words[b.length - 1] | 0;
	    var bhiBits = this._countBits(bhi);
	    shift = 26 - bhiBits;
	    if (shift !== 0) {
	      b = b.ushln(shift);
	      a.iushln(shift);
	      bhi = b.words[b.length - 1] | 0;
	    }
	
	    // Initialize quotient
	    var m = a.length - b.length;
	    var q;
	
	    if (mode !== 'mod') {
	      q = new BN(null);
	      q.length = m + 1;
	      q.words = new Array(q.length);
	      for (var i = 0; i < q.length; i++) {
	        q.words[i] = 0;
	      }
	    }
	
	    var diff = a.clone()._ishlnsubmul(b, 1, m);
	    if (diff.negative === 0) {
	      a = diff;
	      if (q) {
	        q.words[m] = 1;
	      }
	    }
	
	    for (var j = m - 1; j >= 0; j--) {
	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
	        (a.words[b.length + j - 1] | 0);
	
	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
	      // (0x7ffffff)
	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);
	
	      a._ishlnsubmul(b, qj, j);
	      while (a.negative !== 0) {
	        qj--;
	        a.negative = 0;
	        a._ishlnsubmul(b, 1, j);
	        if (!a.isZero()) {
	          a.negative ^= 1;
	        }
	      }
	      if (q) {
	        q.words[j] = qj;
	      }
	    }
	    if (q) {
	      q.strip();
	    }
	    a.strip();
	
	    // Denormalize
	    if (mode !== 'div' && shift !== 0) {
	      a.iushrn(shift);
	    }
	
	    return {
	      div: q || null,
	      mod: a
	    };
	  };
	
	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
	  //       to `div` to request div only, or be absent to
	  //       request both div & mod
	  //       2) `positive` is true if unsigned mod is requested
	  BN.prototype.divmod = function divmod (num, mode, positive) {
	    assert(!num.isZero());
	
	    if (this.isZero()) {
	      return {
	        div: new BN(0),
	        mod: new BN(0)
	      };
	    }
	
	    var div, mod, res;
	    if (this.negative !== 0 && num.negative === 0) {
	      res = this.neg().divmod(num, mode);
	
	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }
	
	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.iadd(num);
	        }
	      }
	
	      return {
	        div: div,
	        mod: mod
	      };
	    }
	
	    if (this.negative === 0 && num.negative !== 0) {
	      res = this.divmod(num.neg(), mode);
	
	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }
	
	      return {
	        div: div,
	        mod: res.mod
	      };
	    }
	
	    if ((this.negative & num.negative) !== 0) {
	      res = this.neg().divmod(num.neg(), mode);
	
	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.isub(num);
	        }
	      }
	
	      return {
	        div: res.div,
	        mod: mod
	      };
	    }
	
	    // Both numbers are positive at this point
	
	    // Strip both numbers to approximate shift value
	    if (num.length > this.length || this.cmp(num) < 0) {
	      return {
	        div: new BN(0),
	        mod: this
	      };
	    }
	
	    // Very short reduction
	    if (num.length === 1) {
	      if (mode === 'div') {
	        return {
	          div: this.divn(num.words[0]),
	          mod: null
	        };
	      }
	
	      if (mode === 'mod') {
	        return {
	          div: null,
	          mod: new BN(this.modn(num.words[0]))
	        };
	      }
	
	      return {
	        div: this.divn(num.words[0]),
	        mod: new BN(this.modn(num.words[0]))
	      };
	    }
	
	    return this._wordDiv(num, mode);
	  };
	
	  // Find `this` / `num`
	  BN.prototype.div = function div (num) {
	    return this.divmod(num, 'div', false).div;
	  };
	
	  // Find `this` % `num`
	  BN.prototype.mod = function mod (num) {
	    return this.divmod(num, 'mod', false).mod;
	  };
	
	  BN.prototype.umod = function umod (num) {
	    return this.divmod(num, 'mod', true).mod;
	  };
	
	  // Find Round(`this` / `num`)
	  BN.prototype.divRound = function divRound (num) {
	    var dm = this.divmod(num);
	
	    // Fast case - exact division
	    if (dm.mod.isZero()) return dm.div;
	
	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
	
	    var half = num.ushrn(1);
	    var r2 = num.andln(1);
	    var cmp = mod.cmp(half);
	
	    // Round down
	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
	
	    // Round up
	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
	  };
	
	  BN.prototype.modn = function modn (num) {
	    assert(num <= 0x3ffffff);
	    var p = (1 << 26) % num;
	
	    var acc = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      acc = (p * acc + (this.words[i] | 0)) % num;
	    }
	
	    return acc;
	  };
	
	  // In-place division by number
	  BN.prototype.idivn = function idivn (num) {
	    assert(num <= 0x3ffffff);
	
	    var carry = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var w = (this.words[i] | 0) + carry * 0x4000000;
	      this.words[i] = (w / num) | 0;
	      carry = w % num;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.divn = function divn (num) {
	    return this.clone().idivn(num);
	  };
	
	  BN.prototype.egcd = function egcd (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	
	    var x = this;
	    var y = p.clone();
	
	    if (x.negative !== 0) {
	      x = x.umod(p);
	    } else {
	      x = x.clone();
	    }
	
	    // A * x + B * y = x
	    var A = new BN(1);
	    var B = new BN(0);
	
	    // C * x + D * y = y
	    var C = new BN(0);
	    var D = new BN(1);
	
	    var g = 0;
	
	    while (x.isEven() && y.isEven()) {
	      x.iushrn(1);
	      y.iushrn(1);
	      ++g;
	    }
	
	    var yp = y.clone();
	    var xp = x.clone();
	
	    while (!x.isZero()) {
	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        x.iushrn(i);
	        while (i-- > 0) {
	          if (A.isOdd() || B.isOdd()) {
	            A.iadd(yp);
	            B.isub(xp);
	          }
	
	          A.iushrn(1);
	          B.iushrn(1);
	        }
	      }
	
	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        y.iushrn(j);
	        while (j-- > 0) {
	          if (C.isOdd() || D.isOdd()) {
	            C.iadd(yp);
	            D.isub(xp);
	          }
	
	          C.iushrn(1);
	          D.iushrn(1);
	        }
	      }
	
	      if (x.cmp(y) >= 0) {
	        x.isub(y);
	        A.isub(C);
	        B.isub(D);
	      } else {
	        y.isub(x);
	        C.isub(A);
	        D.isub(B);
	      }
	    }
	
	    return {
	      a: C,
	      b: D,
	      gcd: y.iushln(g)
	    };
	  };
	
	  // This is reduced incarnation of the binary EEA
	  // above, designated to invert members of the
	  // _prime_ fields F(p) at a maximal speed
	  BN.prototype._invmp = function _invmp (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	
	    var a = this;
	    var b = p.clone();
	
	    if (a.negative !== 0) {
	      a = a.umod(p);
	    } else {
	      a = a.clone();
	    }
	
	    var x1 = new BN(1);
	    var x2 = new BN(0);
	
	    var delta = b.clone();
	
	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        a.iushrn(i);
	        while (i-- > 0) {
	          if (x1.isOdd()) {
	            x1.iadd(delta);
	          }
	
	          x1.iushrn(1);
	        }
	      }
	
	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        b.iushrn(j);
	        while (j-- > 0) {
	          if (x2.isOdd()) {
	            x2.iadd(delta);
	          }
	
	          x2.iushrn(1);
	        }
	      }
	
	      if (a.cmp(b) >= 0) {
	        a.isub(b);
	        x1.isub(x2);
	      } else {
	        b.isub(a);
	        x2.isub(x1);
	      }
	    }
	
	    var res;
	    if (a.cmpn(1) === 0) {
	      res = x1;
	    } else {
	      res = x2;
	    }
	
	    if (res.cmpn(0) < 0) {
	      res.iadd(p);
	    }
	
	    return res;
	  };
	
	  BN.prototype.gcd = function gcd (num) {
	    if (this.isZero()) return num.abs();
	    if (num.isZero()) return this.abs();
	
	    var a = this.clone();
	    var b = num.clone();
	    a.negative = 0;
	    b.negative = 0;
	
	    // Remove common factor of two
	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
	      a.iushrn(1);
	      b.iushrn(1);
	    }
	
	    do {
	      while (a.isEven()) {
	        a.iushrn(1);
	      }
	      while (b.isEven()) {
	        b.iushrn(1);
	      }
	
	      var r = a.cmp(b);
	      if (r < 0) {
	        // Swap `a` and `b` to make `a` always bigger than `b`
	        var t = a;
	        a = b;
	        b = t;
	      } else if (r === 0 || b.cmpn(1) === 0) {
	        break;
	      }
	
	      a.isub(b);
	    } while (true);
	
	    return b.iushln(shift);
	  };
	
	  // Invert number in the field F(num)
	  BN.prototype.invm = function invm (num) {
	    return this.egcd(num).a.umod(num);
	  };
	
	  BN.prototype.isEven = function isEven () {
	    return (this.words[0] & 1) === 0;
	  };
	
	  BN.prototype.isOdd = function isOdd () {
	    return (this.words[0] & 1) === 1;
	  };
	
	  // And first word and num
	  BN.prototype.andln = function andln (num) {
	    return this.words[0] & num;
	  };
	
	  // Increment at the bit position in-line
	  BN.prototype.bincn = function bincn (bit) {
	    assert(typeof bit === 'number');
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;
	
	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) {
	      this._expand(s + 1);
	      this.words[s] |= q;
	      return this;
	    }
	
	    // Add bit and propagate, if needed
	    var carry = q;
	    for (var i = s; carry !== 0 && i < this.length; i++) {
	      var w = this.words[i] | 0;
	      w += carry;
	      carry = w >>> 26;
	      w &= 0x3ffffff;
	      this.words[i] = w;
	    }
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	    return this;
	  };
	
	  BN.prototype.isZero = function isZero () {
	    return this.length === 1 && this.words[0] === 0;
	  };
	
	  BN.prototype.cmpn = function cmpn (num) {
	    var negative = num < 0;
	
	    if (this.negative !== 0 && !negative) return -1;
	    if (this.negative === 0 && negative) return 1;
	
	    this.strip();
	
	    var res;
	    if (this.length > 1) {
	      res = 1;
	    } else {
	      if (negative) {
	        num = -num;
	      }
	
	      assert(num <= 0x3ffffff, 'Number is too big');
	
	      var w = this.words[0] | 0;
	      res = w === num ? 0 : w < num ? -1 : 1;
	    }
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };
	
	  // Compare two numbers and return:
	  // 1 - if `this` > `num`
	  // 0 - if `this` == `num`
	  // -1 - if `this` < `num`
	  BN.prototype.cmp = function cmp (num) {
	    if (this.negative !== 0 && num.negative === 0) return -1;
	    if (this.negative === 0 && num.negative !== 0) return 1;
	
	    var res = this.ucmp(num);
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };
	
	  // Unsigned comparison
	  BN.prototype.ucmp = function ucmp (num) {
	    // At this point both numbers have the same sign
	    if (this.length > num.length) return 1;
	    if (this.length < num.length) return -1;
	
	    var res = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var a = this.words[i] | 0;
	      var b = num.words[i] | 0;
	
	      if (a === b) continue;
	      if (a < b) {
	        res = -1;
	      } else if (a > b) {
	        res = 1;
	      }
	      break;
	    }
	    return res;
	  };
	
	  BN.prototype.gtn = function gtn (num) {
	    return this.cmpn(num) === 1;
	  };
	
	  BN.prototype.gt = function gt (num) {
	    return this.cmp(num) === 1;
	  };
	
	  BN.prototype.gten = function gten (num) {
	    return this.cmpn(num) >= 0;
	  };
	
	  BN.prototype.gte = function gte (num) {
	    return this.cmp(num) >= 0;
	  };
	
	  BN.prototype.ltn = function ltn (num) {
	    return this.cmpn(num) === -1;
	  };
	
	  BN.prototype.lt = function lt (num) {
	    return this.cmp(num) === -1;
	  };
	
	  BN.prototype.lten = function lten (num) {
	    return this.cmpn(num) <= 0;
	  };
	
	  BN.prototype.lte = function lte (num) {
	    return this.cmp(num) <= 0;
	  };
	
	  BN.prototype.eqn = function eqn (num) {
	    return this.cmpn(num) === 0;
	  };
	
	  BN.prototype.eq = function eq (num) {
	    return this.cmp(num) === 0;
	  };
	
	  //
	  // A reduce context, could be using montgomery or something better, depending
	  // on the `m` itself.
	  //
	  BN.red = function red (num) {
	    return new Red(num);
	  };
	
	  BN.prototype.toRed = function toRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    assert(this.negative === 0, 'red works only with positives');
	    return ctx.convertTo(this)._forceRed(ctx);
	  };
	
	  BN.prototype.fromRed = function fromRed () {
	    assert(this.red, 'fromRed works only with numbers in reduction context');
	    return this.red.convertFrom(this);
	  };
	
	  BN.prototype._forceRed = function _forceRed (ctx) {
	    this.red = ctx;
	    return this;
	  };
	
	  BN.prototype.forceRed = function forceRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    return this._forceRed(ctx);
	  };
	
	  BN.prototype.redAdd = function redAdd (num) {
	    assert(this.red, 'redAdd works only with red numbers');
	    return this.red.add(this, num);
	  };
	
	  BN.prototype.redIAdd = function redIAdd (num) {
	    assert(this.red, 'redIAdd works only with red numbers');
	    return this.red.iadd(this, num);
	  };
	
	  BN.prototype.redSub = function redSub (num) {
	    assert(this.red, 'redSub works only with red numbers');
	    return this.red.sub(this, num);
	  };
	
	  BN.prototype.redISub = function redISub (num) {
	    assert(this.red, 'redISub works only with red numbers');
	    return this.red.isub(this, num);
	  };
	
	  BN.prototype.redShl = function redShl (num) {
	    assert(this.red, 'redShl works only with red numbers');
	    return this.red.shl(this, num);
	  };
	
	  BN.prototype.redMul = function redMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.mul(this, num);
	  };
	
	  BN.prototype.redIMul = function redIMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.imul(this, num);
	  };
	
	  BN.prototype.redSqr = function redSqr () {
	    assert(this.red, 'redSqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqr(this);
	  };
	
	  BN.prototype.redISqr = function redISqr () {
	    assert(this.red, 'redISqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.isqr(this);
	  };
	
	  // Square root over p
	  BN.prototype.redSqrt = function redSqrt () {
	    assert(this.red, 'redSqrt works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqrt(this);
	  };
	
	  BN.prototype.redInvm = function redInvm () {
	    assert(this.red, 'redInvm works only with red numbers');
	    this.red._verify1(this);
	    return this.red.invm(this);
	  };
	
	  // Return negative clone of `this` % `red modulo`
	  BN.prototype.redNeg = function redNeg () {
	    assert(this.red, 'redNeg works only with red numbers');
	    this.red._verify1(this);
	    return this.red.neg(this);
	  };
	
	  BN.prototype.redPow = function redPow (num) {
	    assert(this.red && !num.red, 'redPow(normalNum)');
	    this.red._verify1(this);
	    return this.red.pow(this, num);
	  };
	
	  // Prime numbers with efficient reduction
	  var primes = {
	    k256: null,
	    p224: null,
	    p192: null,
	    p25519: null
	  };
	
	  // Pseudo-Mersenne prime
	  function MPrime (name, p) {
	    // P = 2 ^ N - K
	    this.name = name;
	    this.p = new BN(p, 16);
	    this.n = this.p.bitLength();
	    this.k = new BN(1).iushln(this.n).isub(this.p);
	
	    this.tmp = this._tmp();
	  }
	
	  MPrime.prototype._tmp = function _tmp () {
	    var tmp = new BN(null);
	    tmp.words = new Array(Math.ceil(this.n / 13));
	    return tmp;
	  };
	
	  MPrime.prototype.ireduce = function ireduce (num) {
	    // Assumes that `num` is less than `P^2`
	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
	    var r = num;
	    var rlen;
	
	    do {
	      this.split(r, this.tmp);
	      r = this.imulK(r);
	      r = r.iadd(this.tmp);
	      rlen = r.bitLength();
	    } while (rlen > this.n);
	
	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
	    if (cmp === 0) {
	      r.words[0] = 0;
	      r.length = 1;
	    } else if (cmp > 0) {
	      r.isub(this.p);
	    } else {
	      r.strip();
	    }
	
	    return r;
	  };
	
	  MPrime.prototype.split = function split (input, out) {
	    input.iushrn(this.n, 0, out);
	  };
	
	  MPrime.prototype.imulK = function imulK (num) {
	    return num.imul(this.k);
	  };
	
	  function K256 () {
	    MPrime.call(
	      this,
	      'k256',
	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
	  }
	  inherits(K256, MPrime);
	
	  K256.prototype.split = function split (input, output) {
	    // 256 = 9 * 26 + 22
	    var mask = 0x3fffff;
	
	    var outLen = Math.min(input.length, 9);
	    for (var i = 0; i < outLen; i++) {
	      output.words[i] = input.words[i];
	    }
	    output.length = outLen;
	
	    if (input.length <= 9) {
	      input.words[0] = 0;
	      input.length = 1;
	      return;
	    }
	
	    // Shift by 9 limbs
	    var prev = input.words[9];
	    output.words[output.length++] = prev & mask;
	
	    for (i = 10; i < input.length; i++) {
	      var next = input.words[i] | 0;
	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
	      prev = next;
	    }
	    prev >>>= 22;
	    input.words[i - 10] = prev;
	    if (prev === 0 && input.length > 10) {
	      input.length -= 10;
	    } else {
	      input.length -= 9;
	    }
	  };
	
	  K256.prototype.imulK = function imulK (num) {
	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
	    num.words[num.length] = 0;
	    num.words[num.length + 1] = 0;
	    num.length += 2;
	
	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
	    var lo = 0;
	    for (var i = 0; i < num.length; i++) {
	      var w = num.words[i] | 0;
	      lo += w * 0x3d1;
	      num.words[i] = lo & 0x3ffffff;
	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
	    }
	
	    // Fast length reduction
	    if (num.words[num.length - 1] === 0) {
	      num.length--;
	      if (num.words[num.length - 1] === 0) {
	        num.length--;
	      }
	    }
	    return num;
	  };
	
	  function P224 () {
	    MPrime.call(
	      this,
	      'p224',
	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
	  }
	  inherits(P224, MPrime);
	
	  function P192 () {
	    MPrime.call(
	      this,
	      'p192',
	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
	  }
	  inherits(P192, MPrime);
	
	  function P25519 () {
	    // 2 ^ 255 - 19
	    MPrime.call(
	      this,
	      '25519',
	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
	  }
	  inherits(P25519, MPrime);
	
	  P25519.prototype.imulK = function imulK (num) {
	    // K = 0x13
	    var carry = 0;
	    for (var i = 0; i < num.length; i++) {
	      var hi = (num.words[i] | 0) * 0x13 + carry;
	      var lo = hi & 0x3ffffff;
	      hi >>>= 26;
	
	      num.words[i] = lo;
	      carry = hi;
	    }
	    if (carry !== 0) {
	      num.words[num.length++] = carry;
	    }
	    return num;
	  };
	
	  // Exported mostly for testing purposes, use plain name instead
	  BN._prime = function prime (name) {
	    // Cached version of prime
	    if (primes[name]) return primes[name];
	
	    var prime;
	    if (name === 'k256') {
	      prime = new K256();
	    } else if (name === 'p224') {
	      prime = new P224();
	    } else if (name === 'p192') {
	      prime = new P192();
	    } else if (name === 'p25519') {
	      prime = new P25519();
	    } else {
	      throw new Error('Unknown prime ' + name);
	    }
	    primes[name] = prime;
	
	    return prime;
	  };
	
	  //
	  // Base reduction engine
	  //
	  function Red (m) {
	    if (typeof m === 'string') {
	      var prime = BN._prime(m);
	      this.m = prime.p;
	      this.prime = prime;
	    } else {
	      assert(m.gtn(1), 'modulus must be greater than 1');
	      this.m = m;
	      this.prime = null;
	    }
	  }
	
	  Red.prototype._verify1 = function _verify1 (a) {
	    assert(a.negative === 0, 'red works only with positives');
	    assert(a.red, 'red works only with red numbers');
	  };
	
	  Red.prototype._verify2 = function _verify2 (a, b) {
	    assert((a.negative | b.negative) === 0, 'red works only with positives');
	    assert(a.red && a.red === b.red,
	      'red works only with red numbers');
	  };
	
	  Red.prototype.imod = function imod (a) {
	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
	    return a.umod(this.m)._forceRed(this);
	  };
	
	  Red.prototype.neg = function neg (a) {
	    if (a.isZero()) {
	      return a.clone();
	    }
	
	    return this.m.sub(a)._forceRed(this);
	  };
	
	  Red.prototype.add = function add (a, b) {
	    this._verify2(a, b);
	
	    var res = a.add(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res._forceRed(this);
	  };
	
	  Red.prototype.iadd = function iadd (a, b) {
	    this._verify2(a, b);
	
	    var res = a.iadd(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res;
	  };
	
	  Red.prototype.sub = function sub (a, b) {
	    this._verify2(a, b);
	
	    var res = a.sub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res._forceRed(this);
	  };
	
	  Red.prototype.isub = function isub (a, b) {
	    this._verify2(a, b);
	
	    var res = a.isub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res;
	  };
	
	  Red.prototype.shl = function shl (a, num) {
	    this._verify1(a);
	    return this.imod(a.ushln(num));
	  };
	
	  Red.prototype.imul = function imul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.imul(b));
	  };
	
	  Red.prototype.mul = function mul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.mul(b));
	  };
	
	  Red.prototype.isqr = function isqr (a) {
	    return this.imul(a, a.clone());
	  };
	
	  Red.prototype.sqr = function sqr (a) {
	    return this.mul(a, a);
	  };
	
	  Red.prototype.sqrt = function sqrt (a) {
	    if (a.isZero()) return a.clone();
	
	    var mod3 = this.m.andln(3);
	    assert(mod3 % 2 === 1);
	
	    // Fast case
	    if (mod3 === 3) {
	      var pow = this.m.add(new BN(1)).iushrn(2);
	      return this.pow(a, pow);
	    }
	
	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
	    //
	    // Find Q and S, that Q * 2 ^ S = (P - 1)
	    var q = this.m.subn(1);
	    var s = 0;
	    while (!q.isZero() && q.andln(1) === 0) {
	      s++;
	      q.iushrn(1);
	    }
	    assert(!q.isZero());
	
	    var one = new BN(1).toRed(this);
	    var nOne = one.redNeg();
	
	    // Find quadratic non-residue
	    // NOTE: Max is such because of generalized Riemann hypothesis.
	    var lpow = this.m.subn(1).iushrn(1);
	    var z = this.m.bitLength();
	    z = new BN(2 * z * z).toRed(this);
	
	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
	      z.redIAdd(nOne);
	    }
	
	    var c = this.pow(z, q);
	    var r = this.pow(a, q.addn(1).iushrn(1));
	    var t = this.pow(a, q);
	    var m = s;
	    while (t.cmp(one) !== 0) {
	      var tmp = t;
	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
	        tmp = tmp.redSqr();
	      }
	      assert(i < m);
	      var b = this.pow(c, new BN(1).iushln(m - i - 1));
	
	      r = r.redMul(b);
	      c = b.redSqr();
	      t = t.redMul(c);
	      m = i;
	    }
	
	    return r;
	  };
	
	  Red.prototype.invm = function invm (a) {
	    var inv = a._invmp(this.m);
	    if (inv.negative !== 0) {
	      inv.negative = 0;
	      return this.imod(inv).redNeg();
	    } else {
	      return this.imod(inv);
	    }
	  };
	
	  Red.prototype.pow = function pow (a, num) {
	    if (num.isZero()) return new BN(1);
	    if (num.cmpn(1) === 0) return a.clone();
	
	    var windowSize = 4;
	    var wnd = new Array(1 << windowSize);
	    wnd[0] = new BN(1).toRed(this);
	    wnd[1] = a;
	    for (var i = 2; i < wnd.length; i++) {
	      wnd[i] = this.mul(wnd[i - 1], a);
	    }
	
	    var res = wnd[0];
	    var current = 0;
	    var currentLen = 0;
	    var start = num.bitLength() % 26;
	    if (start === 0) {
	      start = 26;
	    }
	
	    for (i = num.length - 1; i >= 0; i--) {
	      var word = num.words[i];
	      for (var j = start - 1; j >= 0; j--) {
	        var bit = (word >> j) & 1;
	        if (res !== wnd[0]) {
	          res = this.sqr(res);
	        }
	
	        if (bit === 0 && current === 0) {
	          currentLen = 0;
	          continue;
	        }
	
	        current <<= 1;
	        current |= bit;
	        currentLen++;
	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
	
	        res = this.mul(res, wnd[current]);
	        currentLen = 0;
	        current = 0;
	      }
	      start = 26;
	    }
	
	    return res;
	  };
	
	  Red.prototype.convertTo = function convertTo (num) {
	    var r = num.umod(this.m);
	
	    return r === num ? r.clone() : r;
	  };
	
	  Red.prototype.convertFrom = function convertFrom (num) {
	    var res = num.clone();
	    res.red = null;
	    return res;
	  };
	
	  //
	  // Montgomery method engine
	  //
	
	  BN.mont = function mont (num) {
	    return new Mont(num);
	  };
	
	  function Mont (m) {
	    Red.call(this, m);
	
	    this.shift = this.m.bitLength();
	    if (this.shift % 26 !== 0) {
	      this.shift += 26 - (this.shift % 26);
	    }
	
	    this.r = new BN(1).iushln(this.shift);
	    this.r2 = this.imod(this.r.sqr());
	    this.rinv = this.r._invmp(this.m);
	
	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
	    this.minv = this.minv.umod(this.r);
	    this.minv = this.r.sub(this.minv);
	  }
	  inherits(Mont, Red);
	
	  Mont.prototype.convertTo = function convertTo (num) {
	    return this.imod(num.ushln(this.shift));
	  };
	
	  Mont.prototype.convertFrom = function convertFrom (num) {
	    var r = this.imod(num.mul(this.rinv));
	    r.red = null;
	    return r;
	  };
	
	  Mont.prototype.imul = function imul (a, b) {
	    if (a.isZero() || b.isZero()) {
	      a.words[0] = 0;
	      a.length = 1;
	      return a;
	    }
	
	    var t = a.imul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }
	
	    return res._forceRed(this);
	  };
	
	  Mont.prototype.mul = function mul (a, b) {
	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
	
	    var t = a.mul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }
	
	    return res._forceRed(this);
	  };
	
	  Mont.prototype.invm = function invm (a) {
	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
	    var res = this.imod(a._invmp(this.m).mul(this.r2));
	    return res._forceRed(this);
	  };
	})(typeof module === 'undefined' || module, this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1737)(module)))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.e = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events___default = __WEBPACK_IMPORTED_MODULE_10_events__ && __WEBPACK_IMPORTED_MODULE_10_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_events___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	var CHANGE_EVENT = 'change';
	
	var PreferenceStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a.bind()(PreferenceStoreClass, _EventEmitter);
	
	    function PreferenceStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PreferenceStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PreferenceStoreClass).call(this));
	
	        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
	        _this.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default.a.register(_this.handleEventPayload);
	
	        _this.preferences = new /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a.bind()(PreferenceStoreClass, [{
	        key: 'getKey',
	        value: function getKey(category, name) {
	            return category + '--' + name;
	        }
	    }, {
	        key: 'get',
	        value: function get(category, name) {
	            var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
	            var key = this.getKey(category, name);
	
	            if (!this.preferences.has(key)) {
	                return defaultValue;
	            }
	
	            return this.preferences.get(key);
	        }
	    }, {
	        key: 'getBool',
	        value: function getBool(category, name) {
	            var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	            var key = this.getKey(category, name);
	
	            if (!this.preferences.has(key)) {
	                return defaultValue;
	            }
	
	            return this.preferences.get(key) !== 'false';
	        }
	    }, {
	        key: 'getInt',
	        value: function getInt(category, name) {
	            var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
	            var key = this.getKey(category, name);
	
	            if (!this.preferences.has(key)) {
	                return defaultValue;
	            }
	
	            return parseInt(this.preferences.get(key), 10);
	        }
	    }, {
	        key: 'getCategory',
	        value: function getCategory(category) {
	            var prefix = category + '--';
	
	            var preferences = new /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(this.preferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	                    var key = _step$value[0];
	                    var value = _step$value[1];
	
	                    if (key.startsWith(prefix)) {
	                        preferences.set(key.substring(prefix.length), value);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return preferences;
	        }
	    }, {
	        key: 'setPreference',
	        value: function setPreference(category, name, value) {
	            this.preferences.set(this.getKey(category, name), value);
	        }
	    }, {
	        key: 'setPreferencesFromServer',
	        value: function setPreferencesFromServer(newPreferences) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(newPreferences), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var preference = _step2.value;
	
	                    this.setPreference(preference.category, preference.name, preference.value);
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            this.preferences.clear();
	        }
	    }, {
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'handleEventPayload',
	        value: function handleEventPayload(payload) {
	            var action = payload.action;
	
	            switch (action.type) {
	                case ActionTypes.RECEIVED_PREFERENCE:
	                    {
	                        var preference = action.preference;
	                        this.setPreference(preference.category, preference.name, preference.value);
	                        this.emitChange();
	                        break;
	                    }
	                case ActionTypes.RECEIVED_PREFERENCES:
	                    this.setPreferencesFromServer(action.preferences);
	                    this.emitChange();
	                    break;
	            }
	        }
	    }]);
	
	    return PreferenceStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_events___default.a);
	
	var PreferenceStore = new PreferenceStoreClass();
	/* harmony default export */ exports["a"] = PreferenceStore;
	global.window.PreferenceStore = PreferenceStore;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1312), __esModule: true };


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $Object = Object;
	module.e = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var LoadingScreen = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LoadingScreen, _React$Component);
	
	    function LoadingScreen(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LoadingScreen);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LoadingScreen).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LoadingScreen, [{
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                {
	                    className: 'loading-screen',
	                    style: { position: this.props.position }
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'loading__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'h3',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'loading_screen.loading',
	                            defaultMessage: 'Loading'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'round round-1' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'round round-2' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'round round-3' })
	                )
	            );
	        }
	    }]);
	
	    return LoadingScreen;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = LoadingScreen;
	
	
	LoadingScreen.defaultProps = {
	    position: 'relative'
	};
	LoadingScreen.propTypes = {
	    position: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'inherit'])
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(102)
	  , min       = Math.min;
	module.e = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var core = module.e = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	/**
	 * Maps children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapValidComponents(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      var lastIndex = index;
	      index++;
	      return func.call(context, child, lastIndex);
	    }
	
	    return child;
	  });
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachValidComponents(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.forEach(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      func.call(context, child, index);
	      index++;
	    }
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function numberOfValidComponents(children) {
	  var count = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      count++;
	    }
	  });
	
	  return count;
	}
	
	/**
	 * Determine if the Child container has one or more "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @returns {boolean}
	 */
	function hasValidComponent(children) {
	  var hasValid = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!hasValid && _react2['default'].isValidElement(child)) {
	      hasValid = true;
	    }
	  });
	
	  return hasValid;
	}
	
	function find(children, finder) {
	  var child = undefined;
	
	  forEachValidComponents(children, function (c, idx) {
	    if (!child && finder(c, idx, children)) {
	      child = c;
	    }
	  });
	
	  return child;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} findFunc.
	 * @param {*} findContext Context for findContext.
	 * @returns {array} of children that meet the findFunc return statement
	 */
	function findValidComponents(children, func, context) {
	  var index = 0;
	  var returnChildren = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (_react2['default'].isValidElement(child)) {
	      if (func.call(context, child, index)) {
	        returnChildren.push(child);
	      }
	      index++;
	    }
	  });
	
	  return returnChildren;
	}
	
	exports['default'] = {
	  map: mapValidComponents,
	  forEach: forEachValidComponents,
	  numberOf: numberOfValidComponents,
	  find: find,
	  findValidComponents: findValidComponents,
	  hasValidComponent: hasValidComponent
	};
	module.e = exports['default'];


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.e = warning;
	


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(75);
	module.e = function(it){
	  return Object(defined(it));
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1316), __esModule: true };


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1321), __esModule: true };


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.e = invariant;
	


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.e = function(it, key){
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = routerWarning;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function routerWarning(falseToWarn, message) {
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	   false ? _warning2['default'].apply(undefined, [falseToWarn, message].concat(args)) : undefined;
	}
	
	module.e = exports['default'];


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.e = ExecutionEnvironment;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var dP         = __webpack_require__(38)
	  , createDesc = __webpack_require__(101);
	module.e = __webpack_require__(37) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var elliptic = exports;
	
	elliptic.version = __webpack_require__(1755).version;
	elliptic.utils = __webpack_require__(1396);
	elliptic.rand = __webpack_require__(491);
	elliptic.hmacDRBG = __webpack_require__(1394);
	elliptic.curve = __webpack_require__(219);
	elliptic.curves = __webpack_require__(1387);
	
	// Protocols
	elliptic.ec = __webpack_require__(1388);
	elliptic.eddsa = __webpack_require__(1391);
	


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _Object$assign = __webpack_require__(50)['default'];
	
	var _Object$create = __webpack_require__(486)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	exports.__esModule = true;
	
	var constant = function constant(obj) {
	  return _Object$assign(_Object$create({
	    values: function values() {
	      var _this = this;
	
	      return _Object$keys(this).map(function (k) {
	        return _this[k];
	      });
	    }
	  }), obj);
	};
	
	var styleMaps = {
	
	  SIZES: {
	    'large': 'lg',
	    'medium': 'md',
	    'small': 'sm',
	    'xsmall': 'xs',
	    'lg': 'lg',
	    'md': 'md',
	    'sm': 'sm',
	    'xs': 'xs'
	  },
	  GRID_COLUMNS: 12
	};
	
	var Sizes = constant({
	  LARGE: 'large',
	  MEDIUM: 'medium',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	});
	
	exports.Sizes = Sizes;
	var State = constant({
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	});
	
	exports.State = State;
	var DEFAULT = 'default';
	exports.DEFAULT = DEFAULT;
	var PRIMARY = 'primary';
	exports.PRIMARY = PRIMARY;
	var LINK = 'link';
	exports.LINK = LINK;
	var INVERSE = 'inverse';
	
	exports.INVERSE = INVERSE;
	exports['default'] = styleMaps;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	'use strict';
	
	exports.__esModule = true;
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.e = exports['default'];


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(154);
	var ReactBrowserEventEmitter = __webpack_require__(230);
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactDOMFeatureFlags = __webpack_require__(592);
	var ReactElement = __webpack_require__(67);
	var ReactEmptyComponentRegistry = __webpack_require__(599);
	var ReactInstanceHandles = __webpack_require__(155);
	var ReactInstanceMap = __webpack_require__(181);
	var ReactMarkupChecksum = __webpack_require__(602);
	var ReactPerf = __webpack_require__(78);
	var ReactReconciler = __webpack_require__(135);
	var ReactUpdateQueue = __webpack_require__(326);
	var ReactUpdates = __webpack_require__(79);
	
	var assign = __webpack_require__(32);
	var emptyObject = __webpack_require__(183);
	var containsNode = __webpack_require__(614);
	var instantiateReactComponent = __webpack_require__(333);
	var invariant = __webpack_require__(26);
	var setInnerHTML = __webpack_require__(237);
	var shouldUpdateReactComponent = __webpack_require__(336);
	var validateDOMNesting = __webpack_require__(338);
	var warning = __webpack_require__(33);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.e = ReactMount;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_events___default = __WEBPACK_IMPORTED_MODULE_9_events__ && __WEBPACK_IMPORTED_MODULE_9_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	var FOCUSED_POST_CHANGE = 'focused_post_change';
	var EDIT_POST_EVENT = 'edit_post';
	var POSTS_VIEW_JUMP_EVENT = 'post_list_jump';
	var SELECTED_POST_CHANGE_EVENT = 'selected_post_change';
	
	var PostStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a.bind()(PostStoreClass, _EventEmitter);
	
	    function PostStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostStoreClass).call(this));
	
	        _this.selectedPostId = null;
	        _this.postsInfo = {};
	        _this.currentFocusedPostId = null;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a.bind()(PostStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitPostFocused',
	        value: function emitPostFocused() {
	            this.emit(FOCUSED_POST_CHANGE);
	        }
	    }, {
	        key: 'addPostFocusedListener',
	        value: function addPostFocusedListener(callback) {
	            this.on(FOCUSED_POST_CHANGE, callback);
	        }
	    }, {
	        key: 'removePostFocusedListener',
	        value: function removePostFocusedListener(callback) {
	            this.removeListener(FOCUSED_POST_CHANGE, callback);
	        }
	    }, {
	        key: 'emitEditPost',
	        value: function emitEditPost(post) {
	            this.emit(EDIT_POST_EVENT, post);
	        }
	    }, {
	        key: 'addEditPostListener',
	        value: function addEditPostListener(callback) {
	            this.on(EDIT_POST_EVENT, callback);
	        }
	    }, {
	        key: 'removeEditPostListner',
	        value: function removeEditPostListner(callback) {
	            this.removeListener(EDIT_POST_EVENT, callback);
	        }
	    }, {
	        key: 'emitPostsViewJump',
	        value: function emitPostsViewJump(type, post) {
	            this.emit(POSTS_VIEW_JUMP_EVENT, type, post);
	        }
	    }, {
	        key: 'addPostsViewJumpListener',
	        value: function addPostsViewJumpListener(callback) {
	            this.on(POSTS_VIEW_JUMP_EVENT, callback);
	        }
	    }, {
	        key: 'removePostsViewJumpListener',
	        value: function removePostsViewJumpListener(callback) {
	            this.removeListener(POSTS_VIEW_JUMP_EVENT, callback);
	        }
	    }, {
	        key: 'jumpPostsViewToBottom',
	        value: function jumpPostsViewToBottom() {
	            this.emitPostsViewJump(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].PostsViewJumpTypes.BOTTOM, null);
	        }
	    }, {
	        key: 'jumpPostsViewToPost',
	        value: function jumpPostsViewToPost(post) {
	            this.emitPostsViewJump(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].PostsViewJumpTypes.POST, post);
	        }
	    }, {
	        key: 'jumpPostsViewSidebarOpen',
	        value: function jumpPostsViewSidebarOpen() {
	            this.emitPostsViewJump(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].PostsViewJumpTypes.SIDEBAR_OPEN, null);
	        }
	
	        // All this does is makes sure the postsInfo is not null for the specified channel
	
	    }, {
	        key: 'makePostsInfo',
	        value: function makePostsInfo(id) {
	            if (!this.postsInfo.hasOwnProperty(id)) {
	                this.postsInfo[id] = {};
	            }
	        }
	    }, {
	        key: 'getPost',
	        value: function getPost(channelId, postId) {
	            var posts = this.postsInfo[channelId].postList;
	            var post = null;
	
	            if (posts.posts.hasOwnProperty(postId)) {
	                post = posts.posts[postId];
	            }
	
	            return post;
	        }
	    }, {
	        key: 'getAllPosts',
	        value: function getAllPosts(id) {
	            if (this.postsInfo.hasOwnProperty(id)) {
	                return this.postsInfo[id].postList;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getEarliestPost',
	        value: function getEarliestPost(id) {
	            if (this.postsInfo.hasOwnProperty(id)) {
	                return this.postsInfo[id].postList.posts[this.postsInfo[id].postList.order[this.postsInfo[id].postList.order.length - 1]];
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getLatestPost',
	        value: function getLatestPost(id) {
	            if (this.postsInfo.hasOwnProperty(id)) {
	                return this.postsInfo[id].postList.posts[this.postsInfo[id].postList.order[0]];
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getVisiblePosts',
	        value: function getVisiblePosts(id) {
	            if (this.postsInfo.hasOwnProperty(id) && this.postsInfo[id].hasOwnProperty('postList')) {
	                var postList = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(this.postsInfo[id].postList));
	
	                // Only limit visibility if we are not focused on a post
	                if (this.currentFocusedPostId === null) {
	                    postList.order = postList.order.slice(0, this.postsInfo[id].endVisible);
	                }
	
	                // Add pending posts
	                if (this.postsInfo[id].hasOwnProperty('pendingPosts')) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()(postList.posts, this.postsInfo[id].pendingPosts.posts);
	                    postList.order = this.postsInfo[id].pendingPosts.order.concat(postList.order);
	                }
	
	                return postList;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getVisibilityAtTop',
	        value: function getVisibilityAtTop(id) {
	            if (this.postsInfo.hasOwnProperty(id)) {
	                return this.postsInfo[id].atTop && this.postsInfo[id].endVisible >= this.postsInfo[id].postList.order.length;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getVisibilityAtBottom',
	        value: function getVisibilityAtBottom(id) {
	            if (this.postsInfo.hasOwnProperty(id)) {
	                return this.postsInfo[id].atBottom;
	            }
	
	            return false;
	        }
	
	        // Returns true if posts need to be fetched
	
	    }, {
	        key: 'requestVisibilityIncrease',
	        value: function requestVisibilityIncrease(id, ammount) {
	            var endVisible = this.postsInfo[id].endVisible;
	            var postList = this.postsInfo[id].postList;
	            if (this.getVisibilityAtTop(id)) {
	                return false;
	            }
	            this.postsInfo[id].endVisible += ammount;
	            this.emitChange();
	            return endVisible + ammount > postList.order.length;
	        }
	    }, {
	        key: 'getFocusedPostId',
	        value: function getFocusedPostId() {
	            return this.currentFocusedPostId;
	        }
	    }, {
	        key: 'storePosts',
	        value: function storePosts(id, newPosts) {
	            if (isPostListNull(newPosts)) {
	                return;
	            }
	
	            var combinedPosts = makePostListNonNull(this.getAllPosts(id));
	
	            for (var pid in newPosts.posts) {
	                if (newPosts.posts.hasOwnProperty(pid)) {
	                    var np = newPosts.posts[pid];
	                    if (np.delete_at === 0) {
	                        combinedPosts.posts[pid] = np;
	                        if (combinedPosts.order.indexOf(pid) === -1 && newPosts.order.indexOf(pid) !== -1) {
	                            combinedPosts.order.push(pid);
	                        }
	                    }
	                }
	            }
	
	            combinedPosts.order.sort(function (a, b) {
	                if (combinedPosts.posts[a].create_at > combinedPosts.posts[b].create_at) {
	                    return -1;
	                }
	                if (combinedPosts.posts[a].create_at < combinedPosts.posts[b].create_at) {
	                    return 1;
	                }
	
	                return 0;
	            });
	
	            this.makePostsInfo(id);
	            this.postsInfo[id].postList = combinedPosts;
	        }
	    }, {
	        key: 'storePost',
	        value: function storePost(post) {
	            var postList = makePostListNonNull(this.getAllPosts(post.channel_id));
	
	            if (post.pending_post_id !== '') {
	                this.removePendingPost(post.channel_id, post.pending_post_id);
	            }
	
	            post.pending_post_id = '';
	
	            postList.posts[post.id] = post;
	            if (postList.order.indexOf(post.id) === -1) {
	                postList.order.unshift(post.id);
	            }
	
	            this.makePostsInfo(post.channel_id);
	            this.postsInfo[post.channel_id].postList = postList;
	        }
	    }, {
	        key: 'storeFocusedPost',
	        value: function storeFocusedPost(postId, postList) {
	            var focusedPost = postList.posts[postId];
	            if (!focusedPost) {
	                return;
	            }
	            this.currentFocusedPostId = postId;
	            this.storePosts(postId, postList);
	        }
	    }, {
	        key: 'checkBounds',
	        value: function checkBounds(id, numRequested, postList, before) {
	            if (numRequested > postList.order.length) {
	                if (before) {
	                    this.postsInfo[id].atTop = true;
	                } else {
	                    this.postsInfo[id].atBottom = true;
	                }
	            }
	        }
	    }, {
	        key: 'clearFocusedPost',
	        value: function clearFocusedPost() {
	            if (this.currentFocusedPostId != null) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(this.postsInfo, this.currentFocusedPostId);
	                this.currentFocusedPostId = null;
	            }
	        }
	    }, {
	        key: 'clearChannelVisibility',
	        value: function clearChannelVisibility(id, atBottom) {
	            this.makePostsInfo(id);
	            this.postsInfo[id].endVisible = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].POST_CHUNK_SIZE;
	            this.postsInfo[id].atTop = false;
	            this.postsInfo[id].atBottom = atBottom;
	        }
	    }, {
	        key: 'deletePost',
	        value: function deletePost(post) {
	            var postInfo = this.postsInfo[post.channel_id];
	            if (!postInfo) {
	                // the post that has been deleted is in a channel that we haven't seen so just ignore it
	                return;
	            }
	
	            var postList = this.postsInfo[post.channel_id].postList;
	
	            if (isPostListNull(postList)) {
	                return;
	            }
	
	            if (post.id in postList.posts) {
	                // make sure to copy the post so that component state changes work properly
	                postList.posts[post.id] = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, post, {
	                    state: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].POST_DELETED,
	                    filenames: []
	                });
	            }
	        }
	    }, {
	        key: 'removePost',
	        value: function removePost(post) {
	            var channelId = post.channel_id;
	            this.makePostsInfo(channelId);
	            var postList = this.postsInfo[channelId].postList;
	            if (isPostListNull(postList)) {
	                return;
	            }
	
	            if (post.id in postList.posts) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(postList.posts, post.id);
	            }
	
	            var index = postList.order.indexOf(post.id);
	            if (index !== -1) {
	                postList.order.splice(index, 1);
	            }
	
	            for (var pid in postList.posts) {
	                if (!postList.posts.hasOwnProperty(pid)) {
	                    continue;
	                }
	
	                if (postList.posts[pid].root_id === post.id) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(postList.posts, pid);
	                    var commentIndex = postList.order.indexOf(pid);
	                    if (commentIndex !== -1) {
	                        postList.order.splice(commentIndex, 1);
	                    }
	                }
	            }
	
	            this.postsInfo[channelId].postList = postList;
	        }
	    }, {
	        key: 'getPendingPosts',
	        value: function getPendingPosts(channelId) {
	            if (this.postsInfo.hasOwnProperty(channelId)) {
	                return this.postsInfo[channelId].pendingPosts;
	            }
	
	            return null;
	        }
	    }, {
	        key: 'storePendingPost',
	        value: function storePendingPost(post) {
	            var copyPost = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(post));
	            copyPost.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].POST_LOADING;
	
	            var postList = makePostListNonNull(this.getPendingPosts(copyPost.channel_id));
	
	            postList.posts[copyPost.pending_post_id] = copyPost;
	            postList.order.unshift(copyPost.pending_post_id);
	
	            this.makePostsInfo(copyPost.channel_id);
	            this.postsInfo[copyPost.channel_id].pendingPosts = postList;
	            this.emitChange();
	        }
	    }, {
	        key: 'removePendingPost',
	        value: function removePendingPost(channelId, pendingPostId) {
	            var postList = makePostListNonNull(this.getPendingPosts(channelId));
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(postList.posts, pendingPostId);
	            var index = postList.order.indexOf(pendingPostId);
	            if (index === -1) {
	                return;
	            }
	
	            postList.order.splice(index, 1);
	
	            this.postsInfo[channelId].pendingPosts = postList;
	            this.emitChange();
	        }
	    }, {
	        key: 'clearPendingPosts',
	        value: function clearPendingPosts(channelId) {
	            if (this.postsInfo.hasOwnProperty(channelId)) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(this.postsInfo[channelId], 'pendingPosts');
	            }
	        }
	    }, {
	        key: 'updatePendingPost',
	        value: function updatePendingPost(post) {
	            var copyPost = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(post));
	            var postList = makePostListNonNull(this.getPendingPosts(copyPost.channel_id));
	
	            if (postList.order.indexOf(copyPost.pending_post_id) === -1) {
	                return;
	            }
	
	            postList.posts[copyPost.pending_post_id] = copyPost;
	            this.postsInfo[copyPost.channel_id].pendingPosts = postList;
	            this.emitChange();
	        }
	    }, {
	        key: 'storeSelectedPostId',
	        value: function storeSelectedPostId(postId) {
	            this.selectedPostId = postId;
	        }
	    }, {
	        key: 'getSelectedPostId',
	        value: function getSelectedPostId() {
	            return this.selectedPostId;
	        }
	    }, {
	        key: 'getSelectedPost',
	        value: function getSelectedPost() {
	            if (this.selectedPostId == null) {
	                return null;
	            }
	
	            for (var k in this.postsInfo) {
	                if (this.postsInfo[k].postList.posts.hasOwnProperty(this.selectedPostId)) {
	                    return this.postsInfo[k].postList.posts[this.selectedPostId];
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getSelectedPostThread',
	        value: function getSelectedPostThread() {
	            if (this.selectedPostId == null) {
	                return null;
	            }
	
	            var posts = void 0;
	            var pendingPosts = void 0;
	            for (var k in this.postsInfo) {
	                if (this.postsInfo[k].postList && this.postsInfo[k].postList.posts.hasOwnProperty(this.selectedPostId)) {
	                    posts = this.postsInfo[k].postList.posts;
	                    if (this.postsInfo[k].pendingPosts != null) {
	                        pendingPosts = this.postsInfo[k].pendingPosts.posts;
	                    }
	                }
	            }
	
	            var threadPosts = {};
	            var rootId = this.selectedPostId;
	            for (var _k in posts) {
	                if (posts[_k].root_id === rootId) {
	                    threadPosts[_k] = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(posts[_k]));
	                }
	            }
	
	            for (var _k2 in pendingPosts) {
	                if (pendingPosts[_k2].root_id === rootId) {
	                    threadPosts[_k2] = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(pendingPosts[_k2]));
	                }
	            }
	
	            return threadPosts;
	        }
	    }, {
	        key: 'emitSelectedPostChange',
	        value: function emitSelectedPostChange(fromSearch) {
	            this.emit(SELECTED_POST_CHANGE_EVENT, fromSearch);
	        }
	    }, {
	        key: 'addSelectedPostChangeListener',
	        value: function addSelectedPostChangeListener(callback) {
	            this.on(SELECTED_POST_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeSelectedPostChangeListener',
	        value: function removeSelectedPostChangeListener(callback) {
	            this.removeListener(SELECTED_POST_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'getCurrentUsersLatestPost',
	        value: function getCurrentUsersLatestPost(channelId, rootId) {
	            var userId = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getCurrentId();
	
	            var postList = makePostListNonNull(this.getAllPosts(channelId));
	            var len = postList.order.length;
	
	            var lastPost = null;
	
	            for (var i = 0; i < len; i++) {
	                var post = postList.posts[postList.order[i]];
	
	                // don't edit webhook posts or deleted posts
	                if (post.user_id !== userId || post.props && post.props.from_webhook || post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].POST_DELETED) {
	                    continue;
	                }
	
	                if (rootId) {
	                    if (post.root_id === rootId || post.id === rootId) {
	                        lastPost = post;
	                        break;
	                    }
	                } else {
	                    lastPost = post;
	                    break;
	                }
	            }
	
	            return lastPost;
	        }
	    }, {
	        key: 'getEmptyDraft',
	        value: function getEmptyDraft() {
	            return { message: '', uploadsInProgress: [], previews: [] };
	        }
	    }, {
	        key: 'storeCurrentDraft',
	        value: function storeCurrentDraft(draft) {
	            var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].getCurrentId();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].setGlobalItem('draft_' + channelId, draft);
	        }
	    }, {
	        key: 'getCurrentDraft',
	        value: function getCurrentDraft() {
	            var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].getCurrentId();
	            return this.getDraft(channelId);
	        }
	    }, {
	        key: 'storeDraft',
	        value: function storeDraft(channelId, draft) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].setGlobalItem('draft_' + channelId, draft);
	        }
	    }, {
	        key: 'getDraft',
	        value: function getDraft(channelId) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].getGlobalItem('draft_' + channelId, this.getEmptyDraft());
	        }
	    }, {
	        key: 'storeCommentDraft',
	        value: function storeCommentDraft(parentPostId, draft) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].setGlobalItem('comment_draft_' + parentPostId, draft);
	        }
	    }, {
	        key: 'getCommentDraft',
	        value: function getCommentDraft(parentPostId) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].getGlobalItem('comment_draft_' + parentPostId, this.getEmptyDraft());
	        }
	    }, {
	        key: 'clearDraftUploads',
	        value: function clearDraftUploads() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].actionOnGlobalItemsWithPrefix('draft_', function (key, value) {
	                if (value) {
	                    value.uploadsInProgress = [];
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].setGlobalItem(key, value);
	                }
	            });
	        }
	    }, {
	        key: 'clearCommentDraftUploads',
	        value: function clearCommentDraftUploads() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].actionOnGlobalItemsWithPrefix('comment_draft_', function (key, value) {
	                if (value) {
	                    value.uploadsInProgress = [];
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_browser_store_jsx__["a"].setGlobalItem(key, value);
	                }
	            });
	        }
	    }, {
	        key: 'getCommentCount',
	        value: function getCommentCount(post) {
	            var posts = this.getAllPosts(post.channel_id).posts;
	
	            var commentCount = 0;
	            for (var id in posts) {
	                if (posts.hasOwnProperty(id)) {
	                    if (posts[id].root_id === post.id) {
	                        commentCount += 1;
	                    }
	                }
	            }
	
	            return commentCount;
	        }
	    }]);
	
	    return PostStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_events___default.a);
	
	var PostStore = new PostStoreClass();
	
	PostStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_POSTS:
	            {
	                var id = PostStore.currentFocusedPostId == null ? action.id : PostStore.currentFocusedPostId;
	                PostStore.storePosts(id, makePostListNonNull(action.post_list));
	                PostStore.checkBounds(id, action.numRequested, makePostListNonNull(action.post_list), action.before);
	                PostStore.emitChange();
	                break;
	            }
	        case ActionTypes.RECEIVED_FOCUSED_POST:
	            PostStore.clearChannelVisibility(action.postId, false);
	            PostStore.storeFocusedPost(action.postId, makePostListNonNull(action.post_list));
	            PostStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_POST:
	            PostStore.storePost(action.post);
	            PostStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_EDIT_POST:
	            PostStore.emitEditPost(action);
	            PostStore.emitChange();
	            break;
	        case ActionTypes.CLICK_CHANNEL:
	            PostStore.clearFocusedPost();
	            PostStore.clearChannelVisibility(action.id, true);
	            break;
	        case ActionTypes.CREATE_POST:
	            PostStore.storePendingPost(action.post);
	            PostStore.storeDraft(action.post.channel_id, null);
	            PostStore.jumpPostsViewToBottom();
	            break;
	        case ActionTypes.POST_DELETED:
	            PostStore.deletePost(action.post);
	            PostStore.emitChange();
	            break;
	        case ActionTypes.REMOVE_POST:
	            PostStore.removePost(action.post);
	            PostStore.emitChange();
	            break;
	        case ActionTypes.RECEIVED_POST_SELECTED:
	            PostStore.storeSelectedPostId(action.postId);
	            PostStore.emitSelectedPostChange(action.from_search);
	            break;
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = PostStore;
	
	function makePostListNonNull(pl) {
	    var postList = pl;
	    if (postList == null) {
	        postList = { order: [], posts: {} };
	    }
	
	    if (postList.order == null) {
	        postList.order = [];
	    }
	
	    if (postList.posts == null) {
	        postList.posts = {};
	    }
	
	    return postList;
	}
	
	function isPostListNull(pl) {
	    if (pl == null) {
	        return true;
	    }
	
	    if (pl.posts == null) {
	        return true;
	    }
	
	    if (pl.order == null) {
	        return true;
	    }
	
	    return false;
	}

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global    = __webpack_require__(29)
	  , hide      = __webpack_require__(56)
	  , has       = __webpack_require__(53)
	  , SRC       = __webpack_require__(123)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(82).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.e = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(31)
	  , defined = __webpack_require__(75)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.e = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(163)
	  , defined = __webpack_require__(75);
	module.e = function(it){
	  return IObject(defined(it));
	};


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var cls = __webpack_require__(226)
	  , d = __webpack_require__(131)
	  , defaultSettings = __webpack_require__(1533)
	  , EventManager = __webpack_require__(1530)
	  , guid = __webpack_require__(1531)
	  , h = __webpack_require__(93);
	
	var instances = {};
	
	function Instance(element) {
	  var i = this;
	
	  i.settings = h.clone(defaultSettings);
	  i.containerWidth = null;
	  i.containerHeight = null;
	  i.contentWidth = null;
	  i.contentHeight = null;
	
	  i.isRtl = d.css(element, 'direction') === "rtl";
	  i.isNegativeScroll = (function () {
	    var originalScrollLeft = element.scrollLeft;
	    var result = null;
	    element.scrollLeft = -1;
	    result = element.scrollLeft < 0;
	    element.scrollLeft = originalScrollLeft;
	    return result;
	  })();
	  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
	  i.event = new EventManager();
	  i.ownerDocument = element.ownerDocument || document;
	
	  function focus() {
	    cls.add(element, 'ps-focus');
	  }
	
	  function blur() {
	    cls.remove(element, 'ps-focus');
	  }
	
	  i.scrollbarXRail = d.appendTo(d.e('div', 'ps-scrollbar-x-rail'), element);
	  i.scrollbarX = d.appendTo(d.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
	  i.scrollbarX.setAttribute('tabindex', 0);
	  i.event.bind(i.scrollbarX, 'focus', focus);
	  i.event.bind(i.scrollbarX, 'blur', blur);
	  i.scrollbarXActive = null;
	  i.scrollbarXWidth = null;
	  i.scrollbarXLeft = null;
	  i.scrollbarXBottom = h.toInt(d.css(i.scrollbarXRail, 'bottom'));
	  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
	  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : h.toInt(d.css(i.scrollbarXRail, 'top'));
	  i.railBorderXWidth = h.toInt(d.css(i.scrollbarXRail, 'borderLeftWidth')) + h.toInt(d.css(i.scrollbarXRail, 'borderRightWidth'));
	  // Set rail to display:block to calculate margins
	  d.css(i.scrollbarXRail, 'display', 'block');
	  i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
	  d.css(i.scrollbarXRail, 'display', '');
	  i.railXWidth = null;
	  i.railXRatio = null;
	
	  i.scrollbarYRail = d.appendTo(d.e('div', 'ps-scrollbar-y-rail'), element);
	  i.scrollbarY = d.appendTo(d.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
	  i.scrollbarY.setAttribute('tabindex', 0);
	  i.event.bind(i.scrollbarY, 'focus', focus);
	  i.event.bind(i.scrollbarY, 'blur', blur);
	  i.scrollbarYActive = null;
	  i.scrollbarYHeight = null;
	  i.scrollbarYTop = null;
	  i.scrollbarYRight = h.toInt(d.css(i.scrollbarYRail, 'right'));
	  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
	  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : h.toInt(d.css(i.scrollbarYRail, 'left'));
	  i.scrollbarYOuterWidth = i.isRtl ? h.outerWidth(i.scrollbarY) : null;
	  i.railBorderYWidth = h.toInt(d.css(i.scrollbarYRail, 'borderTopWidth')) + h.toInt(d.css(i.scrollbarYRail, 'borderBottomWidth'));
	  d.css(i.scrollbarYRail, 'display', 'block');
	  i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));
	  d.css(i.scrollbarYRail, 'display', '');
	  i.railYHeight = null;
	  i.railYRatio = null;
	}
	
	function getId(element) {
	  if (typeof element.dataset === 'undefined') {
	    return element.getAttribute('data-ps-id');
	  } else {
	    return element.dataset.psId;
	  }
	}
	
	function setId(element, id) {
	  if (typeof element.dataset === 'undefined') {
	    element.setAttribute('data-ps-id', id);
	  } else {
	    element.dataset.psId = id;
	  }
	}
	
	function removeId(element) {
	  if (typeof element.dataset === 'undefined') {
	    element.removeAttribute('data-ps-id');
	  } else {
	    delete element.dataset.psId;
	  }
	}
	
	exports.add = function (element) {
	  var newId = guid();
	  setId(element, newId);
	  instances[newId] = new Instance(element);
	  return instances[newId];
	};
	
	exports.remove = function (element) {
	  delete instances[getId(element)];
	  removeId(element);
	};
	
	exports.get = function (element) {
	  return instances[getId(element)];
	};
	


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(96);
	
	var assign = __webpack_require__(32);
	var canDefineProperty = __webpack_require__(235);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.e = ReactElement;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var pIE            = __webpack_require__(164)
	  , createDesc     = __webpack_require__(101)
	  , toIObject      = __webpack_require__(65)
	  , toPrimitive    = __webpack_require__(84)
	  , has            = __webpack_require__(53)
	  , IE8_DOM_DEFINE = __webpack_require__(467)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(37) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(53)
	  , toObject    = __webpack_require__(49)
	  , IE_PROTO    = __webpack_require__(268)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.e = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1314), __esModule: true };


/***/ },
/* 71 */
[1769, 315],
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_utils_jsx__ = __webpack_require__(8);
	'use strict';
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	function getPrefix() {
	    if (global.window.mm_current_user_id) {
	        return global.window.mm_current_user_id + '_';
	    }
	
	    console.warn('BrowserStore tried to operate without user present'); //eslint-disable-line no-console
	
	    return 'unknown_';
	}
	
	var BrowserStoreClass = function () {
	    function BrowserStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BrowserStoreClass);
	
	        this.getItem = this.getItem.bind(this);
	        this.setItem = this.setItem.bind(this);
	        this.removeItem = this.removeItem.bind(this);
	        this.setGlobalItem = this.setGlobalItem.bind(this);
	        this.getGlobalItem = this.getGlobalItem.bind(this);
	        this.removeGlobalItem = this.removeGlobalItem.bind(this);
	        this.actionOnItemsWithPrefix = this.actionOnItemsWithPrefix.bind(this);
	        this.actionOnGlobalItemsWithPrefix = this.actionOnGlobalItemsWithPrefix.bind(this);
	        this.isLocalStorageSupported = this.isLocalStorageSupported.bind(this);
	        this.getLastServerVersion = this.getLastServerVersion.bind(this);
	        this.setLastServerVersion = this.setLastServerVersion.bind(this);
	        this.clear = this.clear.bind(this);
	        this.clearAll = this.clearAll.bind(this);
	        this.checkedLocalStorageSupported = '';
	        this.signalLogout = this.signalLogout.bind(this);
	        this.isSignallingLogout = this.isSignallingLogout.bind(this);
	        this.signalLogin = this.signalLogin.bind(this);
	        this.isSignallingLogin = this.isSignallingLogin.bind(this);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BrowserStoreClass, [{
	        key: 'setItem',
	        value: function setItem(name, value) {
	            this.setGlobalItem(getPrefix() + name, value);
	        }
	    }, {
	        key: 'getItem',
	        value: function getItem(name, defaultValue) {
	            return this.getGlobalItem(getPrefix() + name, defaultValue);
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem(name) {
	            this.removeGlobalItem(getPrefix() + name);
	        }
	    }, {
	        key: 'setGlobalItem',
	        value: function setGlobalItem(name, value) {
	            try {
	                if (this.isLocalStorageSupported()) {
	                    localStorage.setItem(name, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(value));
	                } else {
	                    sessionStorage.setItem(name, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(value));
	                }
	            } catch (err) {
	                console.log('An error occurred while setting local storage, clearing all props'); //eslint-disable-line no-console
	                localStorage.clear();
	                sessionStorage.clear();
	                window.location.reload(true);
	            }
	        }
	    }, {
	        key: 'getGlobalItem',
	        value: function getGlobalItem(name, defaultValue) {
	            var result = null;
	            try {
	                if (this.isLocalStorageSupported()) {
	                    result = JSON.parse(localStorage.getItem(name));
	                } else {
	                    result = JSON.parse(sessionStorage.getItem(name));
	                }
	            } catch (err) {
	                result = null;
	            }
	
	            if (result === null && typeof defaultValue !== 'undefined') {
	                result = defaultValue;
	            }
	
	            return result;
	        }
	    }, {
	        key: 'removeGlobalItem',
	        value: function removeGlobalItem(name) {
	            if (this.isLocalStorageSupported()) {
	                localStorage.removeItem(name);
	            } else {
	                sessionStorage.removeItem(name);
	            }
	        }
	    }, {
	        key: 'getLastServerVersion',
	        value: function getLastServerVersion() {
	            return this.getGlobalItem('last_server_version');
	        }
	    }, {
	        key: 'setLastServerVersion',
	        value: function setLastServerVersion(version) {
	            this.setGlobalItem('last_server_version', version);
	        }
	    }, {
	        key: 'signalLogout',
	        value: function signalLogout() {
	            if (this.isLocalStorageSupported()) {
	                // PLT-1285 store an identifier in session storage so we can catch if the logout came from this tab on IE11
	                var logoutId = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_utils_utils_jsx__["generateId"].bind()();
	
	                sessionStorage.setItem('__logout__', logoutId);
	                localStorage.setItem('__logout__', logoutId);
	                localStorage.removeItem('__logout__');
	            }
	        }
	    }, {
	        key: 'isSignallingLogout',
	        value: function isSignallingLogout(logoutId) {
	            return logoutId === sessionStorage.getItem('__logout__');
	        }
	    }, {
	        key: 'signalLogin',
	        value: function signalLogin() {
	            if (this.isLocalStorageSupported()) {
	                // PLT-1285 store an identifier in session storage so we can catch if the logout came from this tab on IE11
	                var loginId = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_utils_utils_jsx__["generateId"].bind()();
	
	                sessionStorage.setItem('__login__', loginId);
	                localStorage.setItem('__login__', loginId);
	                localStorage.removeItem('__login__');
	            }
	        }
	    }, {
	        key: 'isSignallingLogin',
	        value: function isSignallingLogin(loginId) {
	            return loginId === sessionStorage.getItem('__login__');
	        }
	
	        /**
	         * Preforms the given action on each item that has the given prefix
	         * Signature for action is action(key, value)
	         */
	
	    }, {
	        key: 'actionOnGlobalItemsWithPrefix',
	        value: function actionOnGlobalItemsWithPrefix(prefix, action) {
	            var storage = sessionStorage;
	            if (this.isLocalStorageSupported()) {
	                storage = localStorage;
	            }
	
	            for (var key in storage) {
	                if (key.lastIndexOf(prefix, 0) === 0) {
	                    action(key, this.getGlobalItem(key));
	                }
	            }
	        }
	    }, {
	        key: 'actionOnItemsWithPrefix',
	        value: function actionOnItemsWithPrefix(prefix, action) {
	            var globalPrefix = getPrefix();
	            var globalPrefixiLen = globalPrefix.length;
	            for (var key in sessionStorage) {
	                if (key.lastIndexOf(globalPrefix + prefix, 0) === 0) {
	                    var userkey = key.substring(globalPrefixiLen);
	                    action(userkey, this.getGlobalItem(key));
	                }
	            }
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            // don't clear the logout id so IE11 can tell which tab sent a logout request
	            var logoutId = sessionStorage.getItem('__logout__');
	
	            sessionStorage.clear();
	            localStorage.clear();
	
	            if (logoutId) {
	                sessionStorage.setItem('__logout__', logoutId);
	            }
	        }
	    }, {
	        key: 'clearAll',
	        value: function clearAll() {
	            sessionStorage.clear();
	            localStorage.clear();
	        }
	    }, {
	        key: 'isLocalStorageSupported',
	        value: function isLocalStorageSupported() {
	            if (this.checkedLocalStorageSupported !== '') {
	                return this.checkedLocalStorageSupported;
	            }
	
	            try {
	                sessionStorage.setItem('__testSession__', '1');
	                sessionStorage.removeItem('__testSession__');
	
	                localStorage.setItem('__testLocal__', '1');
	                if (localStorage.getItem('__testLocal__') !== '1') {
	                    this.checkedLocalStorageSupported = false;
	                }
	                localStorage.removeItem('__testLocal__', '1');
	
	                this.checkedLocalStorageSupported = true;
	            } catch (e) {
	                this.checkedLocalStorageSupported = false;
	            }
	
	            return this.checkedLocalStorageSupported;
	        }
	    }]);
	
	    return BrowserStoreClass;
	}();
	
	var BrowserStore = new BrowserStoreClass();
	/* harmony default export */ exports["a"] = BrowserStore;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(489);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_autolinker__ = __webpack_require__(1093);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_autolinker___default = __WEBPACK_IMPORTED_MODULE_4_autolinker__ && __WEBPACK_IMPORTED_MODULE_4_autolinker__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_autolinker__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_autolinker__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_autolinker___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_autolinker___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router___default = __WEBPACK_IMPORTED_MODULE_5_react_router__ && __WEBPACK_IMPORTED_MODULE_5_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emoticons_jsx__ = __webpack_require__(376);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__markdown_jsx__ = __webpack_require__(790);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_twemoji__ = __webpack_require__(1732);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_twemoji___default = __WEBPACK_IMPORTED_MODULE_10_twemoji__ && __WEBPACK_IMPORTED_MODULE_10_twemoji__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_twemoji__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_twemoji__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_twemoji___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_twemoji___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_jsx__ = __webpack_require__(8);
	/* harmony export */ exports["formatText"] = formatText;/* harmony export */ exports["doFormatText"] = doFormatText;/* harmony export */ exports["sanitizeHtml"] = sanitizeHtml;/* harmony export */ exports["handleClick"] = handleClick;'use strict';
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	// Performs formatting of user posts including highlighting mentions and search terms and converting urls, hashtags, and
	// @mentions to links by taking a user's message and returning a string of formatted html. Also takes a number of options
	// as part of the second parameter:
	// - searchTerm - If specified, this word is highlighted in the resulting html. Defaults to nothing.
	// - mentionHighlight - Specifies whether or not to highlight mentions of the current user. Defaults to true.
	// - singleline - Specifies whether or not to remove newlines. Defaults to false.
	// - emoticons - Enables emoticon parsing. Defaults to true.
	// - markdown - Enables markdown parsing. Defaults to true.
	function formatText(text) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var output = void 0;
	
	    if (!('markdown' in options) || options.markdown) {
	        // the markdown renderer will call doFormatText as necessary
	        output = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8__markdown_jsx__.format(text, options);
	    } else {
	        output = sanitizeHtml(text);
	        output = doFormatText(output, options);
	    }
	
	    // replace newlines with spaces if necessary
	    if (options.singleline) {
	        output = replaceNewlines(output);
	    }
	
	    return output;
	}
	
	// Performs most of the actual formatting work for formatText. Not intended to be called normally.
	function doFormatText(text, options) {
	    var output = text;
	
	    var tokens = new /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
	
	    // replace important words and phrases with tokens
	    output = autolinkAtMentions(output, tokens);
	    output = autolinkEmails(output, tokens);
	    output = autolinkHashtags(output, tokens);
	
	    if (!('emoticons' in options) || options.emoticon) {
	        output = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__emoticons_jsx__.handleEmoticons(output, tokens);
	    }
	
	    if (options.searchTerm) {
	        output = highlightSearchTerm(output, tokens, options.searchTerm);
	    }
	
	    if (!('mentionHighlight' in options) || options.mentionHighlight) {
	        output = highlightCurrentMentions(output, tokens);
	    }
	
	    if (!('emoticons' in options) || options.emoticon) {
	        output = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_twemoji___default.a.parse(output, {
	            className: 'emoticon',
	            base: '',
	            folder: /* harmony import */__WEBPACK_IMPORTED_MODULE_6__constants_jsx__["a"].EMOJI_PATH,
	            callback: function callback(icon, twemojiOptions) {
	                if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__emoticons_jsx__.getEmoticonsByCodePoint().has(icon)) {
	                    // just leave the unicode characters and hope the browser can handle it
	                    return null;
	                }
	
	                return ''.concat(twemojiOptions.base, twemojiOptions.size, '/', icon, twemojiOptions.ext);
	            }
	        });
	    }
	
	    // reinsert tokens with formatted versions of the important words and phrases
	    output = replaceTokens(output, tokens);
	
	    return output;
	}
	
	function sanitizeHtml(text) {
	    var output = text;
	
	    // normal string.replace only does a single occurrance so use a regex instead
	    output = output.replace(/&/g, '&amp;');
	    output = output.replace(/</g, '&lt;');
	    output = output.replace(/>/g, '&gt;');
	    output = output.replace(/'/g, '&apos;');
	    output = output.replace(/"/g, '&quot;');
	
	    return output;
	}
	
	// Convert emails into tokens
	function autolinkEmails(text, tokens) {
	    function replaceEmailWithToken(autolinker, match) {
	        var linkText = match.getMatchedText();
	        var url = linkText;
	
	        if (match.getType() === 'email') {
	            url = 'mailto:' + url;
	        }
	
	        var index = tokens.size;
	        var alias = 'MM_EMAIL' + index;
	
	        tokens.set(alias, {
	            value: '<a class="theme" href="' + url + '">' + linkText + '</a>',
	            originalText: linkText
	        });
	
	        return alias;
	    }
	
	    // we can't just use a static autolinker because we need to set replaceFn
	    var autolinker = new /* harmony import */__WEBPACK_IMPORTED_MODULE_4_autolinker___default.a({
	        urls: false,
	        email: true,
	        phone: false,
	        twitter: false,
	        hashtag: false,
	        replaceFn: replaceEmailWithToken
	    });
	
	    return autolinker.link(text);
	}
	
	function autolinkAtMentions(text, tokens) {
	    // Return true if provided character is punctuation
	    function isPunctuation(character) {
	        var re = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]/g;
	        return re.test(character);
	    }
	
	    // Test if provided text needs to be highlighted, special mention or current user
	    function mentionExists(u) {
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_6__constants_jsx__["a"].SPECIAL_MENTIONS.indexOf(u) !== -1 || /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getProfileByUsername(u);
	    }
	
	    function addToken(username, mention) {
	        var index = tokens.size;
	        var alias = 'MM_ATMENTION' + index;
	
	        tokens.set(alias, {
	            value: '<a class=\'mention-link\' href=\'#\' data-mention=\'' + username + '\'>' + mention + '</a>',
	            originalText: mention
	        });
	        return alias;
	    }
	
	    function replaceAtMentionWithToken(fullMatch, mention, username) {
	        var usernameLower = username.toLowerCase();
	
	        if (mentionExists(usernameLower)) {
	            // Exact match
	            var alias = addToken(usernameLower, mention, '');
	            return alias;
	        }
	
	        // Not an exact match, attempt to truncate any punctuation to see if we can find a user
	        var originalUsername = usernameLower;
	
	        for (var c = usernameLower.length; c > 0; c--) {
	            if (isPunctuation(usernameLower[c - 1])) {
	                usernameLower = usernameLower.substring(0, c - 1);
	
	                if (mentionExists(usernameLower)) {
	                    var suffix = originalUsername.substr(c - 1);
	                    var _alias = addToken(usernameLower, '@' + usernameLower);
	                    return _alias + suffix;
	                }
	            } else {
	                // If the last character is not punctuation, no point in going any further
	                break;
	            }
	        }
	
	        return fullMatch;
	    }
	
	    var output = text;
	    output = output.replace(/(@([a-z0-9.\-_]*))/gi, replaceAtMentionWithToken);
	
	    return output;
	}
	
	function escapeRegex(text) {
	    return text.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	function highlightCurrentMentions(text, tokens) {
	    var output = text;
	
	    var mentionKeys = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentMentionKeys();
	
	    // look for any existing tokens which are self mentions and should be highlighted
	    var newTokens = new /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(tokens), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	            var alias = _step$value[0];
	            var token = _step$value[1];
	
	            if (mentionKeys.indexOf(token.originalText) !== -1) {
	                var index = tokens.size + newTokens.size;
	                var newAlias = 'MM_SELFMENTION' + index;
	
	                newTokens.set(newAlias, {
	                    value: '<span class=\'mention--highlight\'>' + alias + '</span>',
	                    originalText: token.originalText
	                });
	                output = output.replace(alias, newAlias);
	            }
	        }
	
	        // the new tokens are stashed in a separate map since we can't add objects to a map during iteration
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(newTokens), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var newToken = _step2.value;
	
	            tokens.set(newToken[0], newToken[1]);
	        }
	
	        // look for self mentions in the text
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    function replaceCurrentMentionWithToken(fullMatch, prefix, mention) {
	        var index = tokens.size;
	        var alias = 'MM_SELFMENTION' + index;
	
	        tokens.set(alias, {
	            value: '<span class=\'mention--highlight\'>' + mention + '</span>',
	            originalText: mention
	        });
	
	        return prefix + alias;
	    }
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentMentionKeys()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var mention = _step3.value;
	
	            if (!mention) {
	                continue;
	            }
	
	            output = output.replace(new RegExp('(^|\\W)(' + escapeRegex(mention) + ')\\b', 'gi'), replaceCurrentMentionWithToken);
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    return output;
	}
	
	function autolinkHashtags(text, tokens) {
	    var output = text;
	
	    var newTokens = new /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	        for (var _iterator4 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(tokens), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var _step4$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a.bind()(_step4.value, 2);
	
	            var alias = _step4$value[0];
	            var token = _step4$value[1];
	
	            if (token.originalText.lastIndexOf('#', 0) === 0) {
	                var index = tokens.size + newTokens.size;
	                var newAlias = 'MM_HASHTAG' + index;
	
	                newTokens.set(newAlias, {
	                    value: '<a class=\'mention-link\' href=\'#\' data-hashtag=\'' + token.originalText + '\'>' + token.originalText + '</a>',
	                    originalText: token.originalText
	                });
	
	                output = output.replace(alias, newAlias);
	            }
	        }
	
	        // the new tokens are stashed in a separate map since we can't add objects to a map during iteration
	    } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	            }
	        } finally {
	            if (_didIteratorError4) {
	                throw _iteratorError4;
	            }
	        }
	    }
	
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	        for (var _iterator5 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(newTokens), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var newToken = _step5.value;
	
	            tokens.set(newToken[0], newToken[1]);
	        }
	
	        // look for hashtags in the text
	    } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	            }
	        } finally {
	            if (_didIteratorError5) {
	                throw _iteratorError5;
	            }
	        }
	    }
	
	    function replaceHashtagWithToken(fullMatch, prefix, hashtag) {
	        var index = tokens.size;
	        var alias = 'MM_HASHTAG' + index;
	
	        var value = hashtag;
	
	        if (hashtag.length > /* harmony import */__WEBPACK_IMPORTED_MODULE_6__constants_jsx__["a"].MIN_HASHTAG_LINK_LENGTH) {
	            value = '<a class=\'mention-link\' href=\'#\' data-hashtag=\'' + hashtag + '\'>' + hashtag + '</a>';
	        }
	
	        tokens.set(alias, {
	            value: value,
	            originalText: hashtag
	        });
	
	        return prefix + alias;
	    }
	
	    return output.replace(/(^|\W)(#[a-zA-ZäöüÄÖÜß][a-zA-Z0-9äöüÄÖÜß.\-_]*)\b/g, replaceHashtagWithToken);
	}
	
	var puncStart = /^[.,()&$!\[\]{}':;\\]+/;
	var puncEnd = /[.,()&$#!\[\]{}':;\\]+$/;
	
	function parseSearchTerms(searchTerm) {
	    var terms = [];
	
	    var termString = searchTerm;
	
	    while (termString) {
	        var captured = void 0;
	
	        // check for a quoted string
	        captured = /^"(.*?)"/.exec(termString);
	        if (captured) {
	            termString = termString.substring(captured[0].length);
	            terms.push(captured[1]);
	            continue;
	        }
	
	        // check for a search flag (and don't add it to terms)
	        captured = /^(?:in|from|channel): ?\S+/.exec(termString);
	        if (captured) {
	            termString = termString.substring(captured[0].length);
	            continue;
	        }
	
	        // capture any plain text up until the next quote or search flag
	        captured = /^.+?(?=\bin|\bfrom|\bchannel|"|$)/.exec(termString);
	        if (captured) {
	            var _terms;
	
	            termString = termString.substring(captured[0].length);
	
	            // break the text up into words based on how the server splits them in SqlPostStore.SearchPosts and then discard empty terms
	            (_terms = terms).push.apply(_terms, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default.a.bind()(captured[0].split(/[ <>+\-\(\)\~\@]/).filter(function (term) {
	                return !!term;
	            })));
	            continue;
	        }
	
	        // we should never reach this point since at least one of the regexes should match something in the remaining text
	        throw new Error('Infinite loop in search term parsing: ' + termString);
	    }
	
	    // remove punctuation from each term
	    terms = terms.map(function (term) {
	        return term.replace(puncStart, '').replace(puncEnd, '');
	    });
	
	    return terms;
	}
	
	function convertSearchTermToRegex(term) {
	    var pattern = void 0;
	    if (term.endsWith('*')) {
	        pattern = '\\b' + escapeRegex(term.substring(0, term.length - 1));
	    } else {
	        pattern = '\\b' + escapeRegex(term) + '\\b';
	    }
	
	    return new RegExp(pattern, 'gi');
	}
	
	function highlightSearchTerm(text, tokens, searchTerm) {
	    var terms = parseSearchTerms(searchTerm);
	
	    if (terms.length === 0) {
	        return text;
	    }
	
	    var output = text;
	
	    function replaceSearchTermWithToken(word) {
	        var index = tokens.size;
	        var alias = 'MM_SEARCHTERM' + index;
	
	        tokens.set(alias, {
	            value: '<span class=\'search-highlight\'>' + word + '</span>',
	            originalText: word
	        });
	
	        return alias;
	    }
	
	    var _iteratorNormalCompletion6 = true;
	    var _didIteratorError6 = false;
	    var _iteratorError6 = undefined;
	
	    try {
	        for (var _iterator6 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(terms), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var term = _step6.value;
	
	            // highlight existing tokens matching search terms
	            var newTokens = new /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
	            var _iteratorNormalCompletion7 = true;
	            var _didIteratorError7 = false;
	            var _iteratorError7 = undefined;
	
	            try {
	                for (var _iterator7 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(tokens), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                    var _step7$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default.a.bind()(_step7.value, 2);
	
	                    var alias = _step7$value[0];
	                    var token = _step7$value[1];
	
	                    if (token.originalText === term.replace(/\*$/, '')) {
	                        var index = tokens.size + newTokens.size;
	                        var newAlias = 'MM_SEARCHTERM' + index;
	
	                        newTokens.set(newAlias, {
	                            value: '<span class=\'search-highlight\'>' + alias + '</span>',
	                            originalText: token.originalText
	                        });
	
	                        output = output.replace(alias, newAlias);
	                    }
	                }
	
	                // the new tokens are stashed in a separate map since we can't add objects to a map during iteration
	            } catch (err) {
	                _didIteratorError7 = true;
	                _iteratorError7 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                        _iterator7.return();
	                    }
	                } finally {
	                    if (_didIteratorError7) {
	                        throw _iteratorError7;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion8 = true;
	            var _didIteratorError8 = false;
	            var _iteratorError8 = undefined;
	
	            try {
	                for (var _iterator8 = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(newTokens), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                    var newToken = _step8.value;
	
	                    tokens.set(newToken[0], newToken[1]);
	                }
	            } catch (err) {
	                _didIteratorError8 = true;
	                _iteratorError8 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                        _iterator8.return();
	                    }
	                } finally {
	                    if (_didIteratorError8) {
	                        throw _iteratorError8;
	                    }
	                }
	            }
	
	            output = output.replace(convertSearchTermToRegex(term), replaceSearchTermWithToken);
	        }
	    } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                _iterator6.return();
	            }
	        } finally {
	            if (_didIteratorError6) {
	                throw _iteratorError6;
	            }
	        }
	    }
	
	    return output;
	}
	
	function replaceTokens(text, tokens) {
	    var output = text;
	
	    // iterate backwards through the map so that we do replacement in the opposite order that we added tokens
	    var aliases = [].concat(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default.a.bind()(tokens.keys()));
	    for (var i = aliases.length - 1; i >= 0; i--) {
	        var alias = aliases[i];
	        var token = tokens.get(alias);
	        output = output.replace(alias, token.value);
	    }
	
	    return output;
	}
	
	function replaceNewlines(text) {
	    return text.replace(/\n/g, ' ');
	}
	
	// A click handler that can be used with the results of TextFormatting.formatText to add default functionality
	// to clicked hashtags and @mentions.
	function handleClick(e) {
	    var mentionAttribute = e.target.getAttributeNode('data-mention');
	    var hashtagAttribute = e.target.getAttributeNode('data-hashtag');
	    var linkAttribute = e.target.getAttributeNode('data-link');
	
	    if (mentionAttribute) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.searchForTerm(mentionAttribute.value);
	    } else if (hashtagAttribute) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_jsx__.searchForTerm(hashtagAttribute.value);
	    } else if (linkAttribute) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_router__["browserHistory"].push(linkAttribute.value);
	    }
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toString = {}.toString;
	
	module.e = function(it){
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.e = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var fails = __webpack_require__(31);
	
	module.e = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global    = __webpack_require__(147)
	  , core      = __webpack_require__(46)
	  , ctx       = __webpack_require__(166)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.e = $export;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.e = ReactPerf;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(320);
	var PooledClass = __webpack_require__(110);
	var ReactPerf = __webpack_require__(78);
	var ReactReconciler = __webpack_require__(135);
	var Transaction = __webpack_require__(234);
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.e = ReactUpdates;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var SettingItemMax = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SettingItemMax, _React$Component);
	
	    function SettingItemMax() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SettingItemMax);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SettingItemMax).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SettingItemMax, [{
	        key: 'render',
	        value: function render() {
	            var clientError = null;
	            if (this.props.client_error) {
	                clientError = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'label',
	                        { className: 'col-sm-12 has-error' },
	                        this.props.client_error
	                    )
	                );
	            }
	
	            var serverError = null;
	            if (this.props.server_error) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'label',
	                        { className: 'col-sm-12 has-error' },
	                        this.props.server_error
	                    )
	                );
	            }
	
	            var extraInfo = null;
	            if (this.props.extraInfo) {
	                extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'setting-list__hint' },
	                    this.props.extraInfo
	                );
	            }
	
	            var submit = '';
	            if (this.props.submit) {
	                submit = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'btn btn-sm btn-primary',
	                        href: '#',
	                        onClick: this.props.submit
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                        id: 'setting_item_max.save',
	                        defaultMessage: 'Save'
	                    })
	                );
	            }
	
	            var inputs = this.props.inputs;
	            var widthClass;
	            if (this.props.width === 'full') {
	                widthClass = 'col-sm-12';
	            } else if (this.props.width === 'medium') {
	                widthClass = 'col-sm-10 col-sm-offset-2';
	            } else {
	                widthClass = 'col-sm-9 col-sm-offset-3';
	            }
	
	            var title = void 0;
	            if (this.props.title) {
	                title = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-12 section-title' },
	                    this.props.title
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'ul',
	                { className: 'section-max form-horizontal' },
	                title,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'li',
	                    { className: widthClass },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'ul',
	                        { className: 'setting-list' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'li',
	                            { className: 'setting-list-item' },
	                            inputs,
	                            extraInfo
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'li',
	                            { className: 'setting-list-item' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('hr', null),
	                            serverError,
	                            clientError,
	                            submit,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'a',
	                                {
	                                    className: 'btn btn-sm theme',
	                                    href: '#',
	                                    onClick: this.props.updateSection
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                                    id: 'setting_item_max.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingItemMax;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SettingItemMax;
	
	
	SettingItemMax.propTypes = {
	    inputs: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.array,
	    client_error: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string,
	    server_error: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string,
	    extraInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.element,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func,
	    submit: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func,
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node,
	    width: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(90)
	  , IObject  = __webpack_require__(163)
	  , toObject = __webpack_require__(49)
	  , toLength = __webpack_require__(45)
	  , asc      = __webpack_require__(1096);
	module.e = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var core = module.e = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(9)
	  , core    = __webpack_require__(82)
	  , fails   = __webpack_require__(31);
	module.e = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(34);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.e = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1315), __esModule: true };


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var store  = __webpack_require__(512)('wks')
	  , uid    = __webpack_require__(288)
	  , Symbol = __webpack_require__(147).Symbol;
	module.e = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(105),
	    isString = __webpack_require__(301),
	    support = __webpack_require__(305);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  if (support.unindexedChars && isString(value)) {
	    var index = -1,
	        length = value.length,
	        result = Object(value);
	
	    while (++index < length) {
	      result[index] = value.charAt(index);
	    }
	    return result;
	  }
	  return isObject(value) ? value : Object(value);
	}
	
	module.e = toObject;
	


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.e = emptyFunction;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var SettingItemMin = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SettingItemMin, _React$Component);
	
	    function SettingItemMin() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SettingItemMin);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SettingItemMin).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SettingItemMin, [{
	        key: 'render',
	        value: function render() {
	            var editButton = null;
	            if (!this.props.disableOpen) {
	                editButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-3 section-edit' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'a',
	                        {
	                            className: 'theme',
	                            href: '#',
	                            onClick: this.props.updateSection
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'setting_item_min.edit',
	                            defaultMessage: 'Edit'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'ul',
	                {
	                    className: 'section-min',
	                    onClick: this.props.updateSection
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-9 section-title' },
	                    this.props.title
	                ),
	                editButton,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-9 section-describe' },
	                    this.props.describe
	                )
	            );
	        }
	    }]);
	
	    return SettingItemMin;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SettingItemMin;
	
	
	SettingItemMin.propTypes = {
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node,
	    disableOpen: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func,
	    describe: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// optional / simple context binding
	var aFunction = __webpack_require__(62);
	module.e = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var Map     = __webpack_require__(482)
	  , $export = __webpack_require__(9)
	  , shared  = __webpack_require__(203)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(485)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.e = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	if(__webpack_require__(37)){
	  var LIBRARY             = __webpack_require__(116)
	    , global              = __webpack_require__(29)
	    , fails               = __webpack_require__(31)
	    , $export             = __webpack_require__(9)
	    , $typed              = __webpack_require__(204)
	    , $buffer             = __webpack_require__(275)
	    , ctx                 = __webpack_require__(90)
	    , anInstance          = __webpack_require__(99)
	    , propertyDesc        = __webpack_require__(101)
	    , hide                = __webpack_require__(56)
	    , redefineAll         = __webpack_require__(120)
	    , isInteger           = __webpack_require__(262)
	    , toInteger           = __webpack_require__(102)
	    , toLength            = __webpack_require__(45)
	    , toIndex             = __webpack_require__(122)
	    , toPrimitive         = __webpack_require__(84)
	    , has                 = __webpack_require__(53)
	    , same                = __webpack_require__(479)
	    , classof             = __webpack_require__(142)
	    , isObject            = __webpack_require__(34)
	    , toObject            = __webpack_require__(49)
	    , isArrayIter         = __webpack_require__(260)
	    , create              = __webpack_require__(117)
	    , getPrototypeOf      = __webpack_require__(69)
	    , gOPN                = __webpack_require__(118).f
	    , isIterable          = __webpack_require__(1103)
	    , getIterFn           = __webpack_require__(277)
	    , uid                 = __webpack_require__(123)
	    , wks                 = __webpack_require__(35)
	    , createArrayMethod   = __webpack_require__(81)
	    , createArrayIncludes = __webpack_require__(193)
	    , speciesConstructor  = __webpack_require__(269)
	    , ArrayIterators      = __webpack_require__(278)
	    , Iterators           = __webpack_require__(115)
	    , $iterDetect         = __webpack_require__(199)
	    , setSpecies          = __webpack_require__(121)
	    , arrayFill           = __webpack_require__(253)
	    , arrayCopyWithin     = __webpack_require__(460)
	    , $DP                 = __webpack_require__(38)
	    , $GOPD               = __webpack_require__(68)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.e = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.e = function(){ /* empty */ };


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var cls = __webpack_require__(226)
	  , d = __webpack_require__(131);
	
	exports.toInt = function (x) {
	  return parseInt(x, 10) || 0;
	};
	
	exports.clone = function (obj) {
	  if (obj === null) {
	    return null;
	  } else if (typeof obj === 'object') {
	    var result = {};
	    for (var key in obj) {
	      result[key] = this.clone(obj[key]);
	    }
	    return result;
	  } else {
	    return obj;
	  }
	};
	
	exports.extend = function (original, source) {
	  var result = this.clone(original);
	  for (var key in source) {
	    result[key] = this.clone(source[key]);
	  }
	  return result;
	};
	
	exports.isEditable = function (el) {
	  return d.matches(el, "input,[contenteditable]") ||
	         d.matches(el, "select,[contenteditable]") ||
	         d.matches(el, "textarea,[contenteditable]") ||
	         d.matches(el, "button,[contenteditable]");
	};
	
	exports.removePsClasses = function (element) {
	  var clsList = cls.list(element);
	  for (var i = 0; i < clsList.length; i++) {
	    var className = clsList[i];
	    if (className.indexOf('ps-') === 0) {
	      cls.remove(element, className);
	    }
	  }
	};
	
	exports.outerWidth = function (element) {
	  return this.toInt(d.css(element, 'width')) +
	         this.toInt(d.css(element, 'paddingLeft')) +
	         this.toInt(d.css(element, 'paddingRight')) +
	         this.toInt(d.css(element, 'borderLeftWidth')) +
	         this.toInt(d.css(element, 'borderRightWidth'));
	};
	
	exports.startScrolling = function (element, axis) {
	  cls.add(element, 'ps-in-scrolling');
	  if (typeof axis !== 'undefined') {
	    cls.add(element, 'ps-' + axis);
	  } else {
	    cls.add(element, 'ps-x');
	    cls.add(element, 'ps-y');
	  }
	};
	
	exports.stopScrolling = function (element, axis) {
	  cls.remove(element, 'ps-in-scrolling');
	  if (typeof axis !== 'undefined') {
	    cls.remove(element, 'ps-' + axis);
	  } else {
	    cls.remove(element, 'ps-x');
	    cls.remove(element, 'ps-y');
	  }
	};
	
	exports.env = {
	  isWebKit: 'WebkitAppearance' in document.documentElement.style,
	  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
	  supportsIePointer: window.navigator.msMaxTouchPoints !== null
	};
	


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var cls = __webpack_require__(226)
	  , d = __webpack_require__(131)
	  , h = __webpack_require__(93)
	  , instances = __webpack_require__(66)
	  , updateScroll = __webpack_require__(106);
	
	function getThumbSize(i, thumbSize) {
	  if (i.settings.minScrollbarLength) {
	    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
	  }
	  if (i.settings.maxScrollbarLength) {
	    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
	  }
	  return thumbSize;
	}
	
	function updateCss(element, i) {
	  var xRailOffset = {width: i.railXWidth};
	  if (i.isRtl) {
	    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
	  } else {
	    xRailOffset.left = element.scrollLeft;
	  }
	  if (i.isScrollbarXUsingBottom) {
	    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
	  } else {
	    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
	  }
	  d.css(i.scrollbarXRail, xRailOffset);
	
	  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
	  if (i.isScrollbarYUsingRight) {
	    if (i.isRtl) {
	      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
	    } else {
	      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
	    }
	  } else {
	    if (i.isRtl) {
	      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
	    } else {
	      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
	    }
	  }
	  d.css(i.scrollbarYRail, yRailOffset);
	
	  d.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
	  d.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	
	  i.containerWidth = element.clientWidth;
	  i.containerHeight = element.clientHeight;
	  i.contentWidth = element.scrollWidth;
	  i.contentHeight = element.scrollHeight;
	
	  var existingRails;
	  if (!element.contains(i.scrollbarXRail)) {
	    existingRails = d.queryChildren(element, '.ps-scrollbar-x-rail');
	    if (existingRails.length > 0) {
	      existingRails.forEach(function (rail) {
	        d.remove(rail);
	      });
	    }
	    d.appendTo(i.scrollbarXRail, element);
	  }
	  if (!element.contains(i.scrollbarYRail)) {
	    existingRails = d.queryChildren(element, '.ps-scrollbar-y-rail');
	    if (existingRails.length > 0) {
	      existingRails.forEach(function (rail) {
	        d.remove(rail);
	      });
	    }
	    d.appendTo(i.scrollbarYRail, element);
	  }
	
	  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
	    i.scrollbarXActive = true;
	    i.railXWidth = i.containerWidth - i.railXMarginWidth;
	    i.railXRatio = i.containerWidth / i.railXWidth;
	    i.scrollbarXWidth = getThumbSize(i, h.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
	    i.scrollbarXLeft = h.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
	  } else {
	    i.scrollbarXActive = false;
	  }
	
	  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
	    i.scrollbarYActive = true;
	    i.railYHeight = i.containerHeight - i.railYMarginHeight;
	    i.railYRatio = i.containerHeight / i.railYHeight;
	    i.scrollbarYHeight = getThumbSize(i, h.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
	    i.scrollbarYTop = h.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
	  } else {
	    i.scrollbarYActive = false;
	  }
	
	  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
	    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
	  }
	  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
	    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
	  }
	
	  updateCss(element, i);
	
	  if (i.scrollbarXActive) {
	    cls.add(element, 'ps-active-x');
	  } else {
	    cls.remove(element, 'ps-active-x');
	    i.scrollbarXWidth = 0;
	    i.scrollbarXLeft = 0;
	    updateScroll(element, 'left', 0);
	  }
	  if (i.scrollbarYActive) {
	    cls.add(element, 'ps-active-y');
	  } else {
	    cls.remove(element, 'ps-active-y');
	    i.scrollbarYHeight = 0;
	    i.scrollbarYTop = 0;
	    updateScroll(element, 'top', 0);
	  }
	};
	


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(238);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.e = EventConstants;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.e = ReactCurrentOwner;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This file contains a list of utility functions which are useful in other
	 * files.
	 */
	
	/**
	 * Provide an `indexOf` function which works in IE8, but defers to native if
	 * possible.
	 */
	var nativeIndexOf = Array.prototype.indexOf;
	var indexOf = function(list, elem) {
	    if (list == null) {
	        return -1;
	    }
	    if (nativeIndexOf && list.indexOf === nativeIndexOf) {
	        return list.indexOf(elem);
	    }
	    var i = 0;
	    var l = list.length;
	    for (; i < l; i++) {
	        if (list[i] === elem) {
	            return i;
	        }
	    }
	    return -1;
	};
	
	/**
	 * Return whether an element is contained in a list
	 */
	var contains = function(list, elem) {
	    return indexOf(list, elem) !== -1;
	};
	
	/**
	 * Provide a default value if a setting is undefined
	 */
	var deflt = function(setting, defaultIfUndefined) {
	    return setting === undefined ? defaultIfUndefined : setting;
	};
	
	// hyphenate and escape adapted from Facebook's React under Apache 2 license
	
	var uppercase = /([A-Z])/g;
	var hyphenate = function(str) {
	    return str.replace(uppercase, "-$1").toLowerCase();
	};
	
	var ESCAPE_LOOKUP = {
	    "&": "&amp;",
	    ">": "&gt;",
	    "<": "&lt;",
	    "\"": "&quot;",
	    "'": "&#x27;",
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	    return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escape(text) {
	    return ("" + text).replace(ESCAPE_REGEX, escaper);
	}
	
	/**
	 * A function to set the text content of a DOM element in all supported
	 * browsers. Note that we don't define this if there is no document.
	 */
	var setTextContent;
	if (typeof document !== "undefined") {
	    var testNode = document.createElement("span");
	    if ("textContent" in testNode) {
	        setTextContent = function(node, text) {
	            node.textContent = text;
	        };
	    } else {
	        setTextContent = function(node, text) {
	            node.innerText = text;
	        };
	    }
	}
	
	/**
	 * A function to clear a node.
	 */
	function clearNode(node) {
	    setTextContent(node, "");
	}
	
	module.e = {
	    contains: contains,
	    deflt: deflt,
	    escape: escape,
	    hyphenate: hyphenate,
	    indexOf: indexOf,
	    setTextContent: setTextContent,
	    clearNode: clearNode,
	};
	


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/536114ae2584664f84946b731eea6ac7.gif";

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var META     = __webpack_require__(123)('meta')
	  , isObject = __webpack_require__(34)
	  , has      = __webpack_require__(53)
	  , setDesc  = __webpack_require__(38).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(31)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.e = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.e = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.e = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var getNative = __webpack_require__(223),
	    isLength = __webpack_require__(152),
	    isObjectLike = __webpack_require__(130);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.e = isArray;
	


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.e = isObject;
	


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var instances = __webpack_require__(66);
	
	var upEvent = document.createEvent('Event')
	  , downEvent = document.createEvent('Event')
	  , leftEvent = document.createEvent('Event')
	  , rightEvent = document.createEvent('Event')
	  , yEvent = document.createEvent('Event')
	  , xEvent = document.createEvent('Event')
	  , xStartEvent = document.createEvent('Event')
	  , xEndEvent = document.createEvent('Event')
	  , yStartEvent = document.createEvent('Event')
	  , yEndEvent = document.createEvent('Event')
	  , lastTop
	  , lastLeft;
	
	upEvent.initEvent('ps-scroll-up', true, true);
	downEvent.initEvent('ps-scroll-down', true, true);
	leftEvent.initEvent('ps-scroll-left', true, true);
	rightEvent.initEvent('ps-scroll-right', true, true);
	yEvent.initEvent('ps-scroll-y', true, true);
	xEvent.initEvent('ps-scroll-x', true, true);
	xStartEvent.initEvent('ps-x-reach-start', true, true);
	xEndEvent.initEvent('ps-x-reach-end', true, true);
	yStartEvent.initEvent('ps-y-reach-start', true, true);
	yEndEvent.initEvent('ps-y-reach-end', true, true);
	
	module.e = function (element, axis, value) {
	  if (typeof element === 'undefined') {
	    throw 'You must provide an element to the update-scroll function';
	  }
	
	  if (typeof axis === 'undefined') {
	    throw 'You must provide an axis to the update-scroll function';
	  }
	
	  if (typeof value === 'undefined') {
	    throw 'You must provide a value to the update-scroll function';
	  }
	
	  if (axis === 'top' && value <= 0) {
	    element.scrollTop = value = 0; // don't allow negative scroll
	    element.dispatchEvent(yStartEvent);
	  }
	
	  if (axis === 'left' && value <= 0) {
	    element.scrollLeft = value = 0; // don't allow negative scroll
	    element.dispatchEvent(xStartEvent);
	  }
	
	  var i = instances.get(element);
	
	  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
	    element.scrollTop = value = i.contentHeight - i.containerHeight; // don't allow scroll past container
	    element.dispatchEvent(yEndEvent);
	  }
	
	  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
	    element.scrollLeft = value = i.contentWidth - i.containerWidth; // don't allow scroll past container
	    element.dispatchEvent(xEndEvent);
	  }
	
	  if (!lastTop) {
	    lastTop = element.scrollTop;
	  }
	
	  if (!lastLeft) {
	    lastLeft = element.scrollLeft;
	  }
	
	  if (axis === 'top' && value < lastTop) {
	    element.dispatchEvent(upEvent);
	  }
	
	  if (axis === 'top' && value > lastTop) {
	    element.dispatchEvent(downEvent);
	  }
	
	  if (axis === 'left' && value < lastLeft) {
	    element.dispatchEvent(leftEvent);
	  }
	
	  if (axis === 'left' && value > lastLeft) {
	    element.dispatchEvent(rightEvent);
	  }
	
	  if (axis === 'top') {
	    element.scrollTop = lastTop = value;
	    element.dispatchEvent(yEvent);
	  }
	
	  if (axis === 'left') {
	    element.scrollLeft = lastLeft = value;
	    element.dispatchEvent(xEvent);
	  }
	
	};
	


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// shim for using process in browser
	
	var process = module.e = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	/**
	 * Note: This is intended as a stop-gap for accessibility concerns that the
	 * Bootstrap CSS does not address as they have styled anchors and not buttons
	 * in many cases.
	 */
	
	var SafeAnchor = (function (_React$Component) {
	  _inherits(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props) {
	    _classCallCheck(this, SafeAnchor);
	
	    _React$Component.call(this, props);
	
	    this.handleClick = this.handleClick.bind(this);
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    if (this.props.href === undefined) {
	      event.preventDefault();
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    return _react2['default'].createElement('a', _extends({ role: this.props.href ? undefined : 'button'
	    }, this.props, {
	      onClick: _utilsCreateChainedFunction2['default'](this.props.onClick, this.handleClick),
	      href: this.props.href || '' }));
	  };
	
	  return SafeAnchor;
	})(_react2['default'].Component);
	
	exports['default'] = SafeAnchor;
	
	SafeAnchor.propTypes = {
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func
	};
	module.e = exports['default'];


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function isValidChild(object) {
	  return object == null || _react2['default'].isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      /* istanbul ignore if: error logging */
	      if (error instanceof Error)  false ? _routerWarning2['default'](false, error.message) : undefined;
	    }
	  }
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName || type.name, type.propTypes, route);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *   
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2['default'].Children.forEach(children, function (element) {
	    if (_react2['default'].isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.e = PooledClass;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.e = keyOf;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This is the ParseError class, which is the main error thrown by KaTeX
	 * functions when something has gone wrong. This is used to distinguish internal
	 * errors from errors in the expression that the user provided.
	 */
	function ParseError(message, lexer, position) {
	    var error = "KaTeX parse error: " + message;
	
	    if (lexer !== undefined && position !== undefined) {
	        // If we have the input and a position, make the error a bit fancier
	
	        // Prepend some information
	        error += " at position " + position + ": ";
	
	        // Get the input
	        var input = lexer._input;
	        // Insert a combining underscore at the correct position
	        input = input.slice(0, position) + "\u0332" +
	            input.slice(position);
	
	        // Extract some context from the input and add it to the error
	        var begin = Math.max(0, position - 15);
	        var end = position + 15;
	        error += input.slice(begin, end);
	    }
	
	    // Some hackery to make ParseError a prototype of Error
	    // See http://stackoverflow.com/a/8460753
	    var self = new Error(error);
	    self.name = "ParseError";
	    self.__proto__ = ParseError.prototype;
	
	    self.position = position;
	    return self;
	}
	
	// More hackery
	ParseError.prototype.__proto__ = Error.prototype;
	
	module.e = ParseError;
	


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __WEBPACK_IMPORTED_MODULE_6_events__ && __WEBPACK_IMPORTED_MODULE_6_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__ = __webpack_require__(72);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	var CHANGE_EVENT = 'change';
	
	var ErrorStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ErrorStoreClass, _EventEmitter);
	
	    function ErrorStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ErrorStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ErrorStoreClass).call(this));
	
	        _this.emitChange = _this.emitChange.bind(_this);
	        _this.addChangeListener = _this.addChangeListener.bind(_this);
	        _this.removeChangeListener = _this.removeChangeListener.bind(_this);
	        _this.getLastError = _this.getLastError.bind(_this);
	        _this.storeLastError = _this.storeLastError.bind(_this);
	        _this.getIgnoreEmailPreview = _this.getIgnoreEmailPreview.bind(_this);
	        _this.ignore_email_preview = false;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ErrorStoreClass, [{
	        key: 'getIgnoreEmailPreview',
	        value: function getIgnoreEmailPreview() {
	            return this.ignore_email_preview;
	        }
	    }, {
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'getLastError',
	        value: function getLastError() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__["a"].getGlobalItem('last_error');
	        }
	    }, {
	        key: 'storeLastError',
	        value: function storeLastError(error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__["a"].setGlobalItem('last_error', error);
	        }
	    }, {
	        key: 'getConnectionErrorCount',
	        value: function getConnectionErrorCount() {
	            var count = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__["a"].getGlobalItem('last_error_conn');
	
	            if (count == null) {
	                return 0;
	            }
	
	            return count;
	        }
	    }, {
	        key: 'setConnectionErrorCount',
	        value: function setConnectionErrorCount(count) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__["a"].setGlobalItem('last_error_conn', count);
	        }
	    }, {
	        key: 'clearLastError',
	        value: function clearLastError() {
	            var lastError = this.getLastError();
	            if (lastError && lastError.email_preview) {
	                this.ignore_email_preview = true;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__["a"].removeGlobalItem('last_error');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_browser_store_jsx__["a"].removeGlobalItem('last_error_conn');
	            if (lastError) {
	                this.emitChange();
	            }
	        }
	    }]);
	
	    return ErrorStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_events___default.a);
	
	var ErrorStore = new ErrorStoreClass();
	
	ErrorStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	    switch (action.type) {
	        case ActionTypes.RECEIVED_ERROR:
	            ErrorStore.storeLastError(action.err);
	            ErrorStore.emitChange();
	            break;
	
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = ErrorStore;
	window.ErrorStore = ErrorStore;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(205);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __WEBPACK_IMPORTED_MODULE_7_events__ && __WEBPACK_IMPORTED_MODULE_7_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	var ModalStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(ModalStoreClass, _EventEmitter);
	
	    function ModalStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ModalStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ModalStoreClass).call(this));
	
	        _this.addModalListener = _this.addModalListener.bind(_this);
	        _this.removeModalListener = _this.removeModalListener.bind(_this);
	
	        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
	        _this.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(_this.handleEventPayload);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ModalStoreClass, [{
	        key: 'addModalListener',
	        value: function addModalListener(action, callback) {
	            this.on(action, callback);
	        }
	    }, {
	        key: 'removeModalListener',
	        value: function removeModalListener(action, callback) {
	            this.removeListener(action, callback);
	        }
	    }, {
	        key: 'handleEventPayload',
	        value: function handleEventPayload(payload) {
	            // toggle event handlers should accept a boolean show/hide value and can accept a map of arguments
	            var _payload$action = payload.action;
	            var type = _payload$action.type;
	            var value = _payload$action.value;
	
	            var args = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default.a.bind()(_payload$action, ['type', 'value']); //eslint-disable-line no-use-before-define
	
	            switch (type) {
	                case ActionTypes.TOGGLE_IMPORT_THEME_MODAL:
	                case ActionTypes.TOGGLE_INVITE_MEMBER_MODAL:
	                case ActionTypes.TOGGLE_DELETE_POST_MODAL:
	                case ActionTypes.TOGGLE_GET_POST_LINK_MODAL:
	                case ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL:
	                case ActionTypes.TOGGLE_REGISTER_APP_MODAL:
	                case ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL:
	                    this.emit(type, value, args);
	                    break;
	            }
	        }
	    }]);
	
	    return ModalStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_events___default.a);
	
	var ModalStore = new ModalStoreClass();
	/* harmony default export */ exports["a"] = ModalStore;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = {};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = false;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(24)
	  , dPs         = __webpack_require__(472)
	  , enumBugKeys = __webpack_require__(256)
	  , IE_PROTO    = __webpack_require__(268)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(255)('iframe')
	    , i      = enumBugKeys.length
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(258).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.e = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(474)
	  , hiddenKeys = __webpack_require__(256).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(474)
	  , enumBugKeys = __webpack_require__(256);
	
	module.e = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var redefine = __webpack_require__(63);
	module.e = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var global      = __webpack_require__(29)
	  , dP          = __webpack_require__(38)
	  , DESCRIPTORS = __webpack_require__(37)
	  , SPECIES     = __webpack_require__(35)('species');
	
	module.e = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toInteger = __webpack_require__(102)
	  , max       = Math.max
	  , min       = Math.min;
	module.e = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var id = 0
	  , px = Math.random();
	module.e = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1323), __esModule: true };


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1278);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(42);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(211);
	module.e = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	module.e = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var hash = exports;
	
	hash.utils = __webpack_require__(1405);
	hash.common = __webpack_require__(1401);
	hash.sha = __webpack_require__(1404);
	hash.ripemd = __webpack_require__(1403);
	hash.hmac = __webpack_require__(1402);
	
	// Proxy hash functions to the main object
	hash.sha1 = hash.sha.sha1;
	hash.sha256 = hash.sha.sha256;
	hash.sha224 = hash.sha.sha224;
	hash.sha384 = hash.sha.sha384;
	hash.sha512 = hash.sha.sha512;
	hash.ripemd160 = hash.ripemd.ripemd160;
	


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.e = isObjectLike;
	


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var DOM = {};
	
	DOM.e = function (tagName, className) {
	  var element = document.createElement(tagName);
	  element.className = className;
	  return element;
	};
	
	DOM.appendTo = function (child, parent) {
	  parent.appendChild(child);
	  return child;
	};
	
	function cssGet(element, styleName) {
	  return window.getComputedStyle(element)[styleName];
	}
	
	function cssSet(element, styleName, styleValue) {
	  if (typeof styleValue === 'number') {
	    styleValue = styleValue.toString() + 'px';
	  }
	  element.style[styleName] = styleValue;
	  return element;
	}
	
	function cssMultiSet(element, obj) {
	  for (var key in obj) {
	    var val = obj[key];
	    if (typeof val === 'number') {
	      val = val.toString() + 'px';
	    }
	    element.style[key] = val;
	  }
	  return element;
	}
	
	DOM.css = function (element, styleNameOrObject, styleValue) {
	  if (typeof styleNameOrObject === 'object') {
	    // multiple set with object
	    return cssMultiSet(element, styleNameOrObject);
	  } else {
	    if (typeof styleValue === 'undefined') {
	      return cssGet(element, styleNameOrObject);
	    } else {
	      return cssSet(element, styleNameOrObject, styleValue);
	    }
	  }
	};
	
	DOM.matches = function (element, query) {
	  if (typeof element.matches !== 'undefined') {
	    return element.matches(query);
	  } else {
	    if (typeof element.matchesSelector !== 'undefined') {
	      return element.matchesSelector(query);
	    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
	      return element.webkitMatchesSelector(query);
	    } else if (typeof element.mozMatchesSelector !== 'undefined') {
	      return element.mozMatchesSelector(query);
	    } else if (typeof element.msMatchesSelector !== 'undefined') {
	      return element.msMatchesSelector(query);
	    }
	  }
	};
	
	DOM.remove = function (element) {
	  if (typeof element.remove !== 'undefined') {
	    element.remove();
	  } else {
	    if (element.parentNode) {
	      element.parentNode.removeChild(element);
	    }
	  }
	};
	
	DOM.queryChildren = function (element, selector) {
	  return Array.prototype.filter.call(element.childNodes, function (child) {
	    return DOM.matches(child, selector);
	  });
	};
	
	module.e = DOM;
	


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(1657);


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var types = ['button', 'reset', 'submit'];
	
	var ButtonStyles = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY, _styleMaps.LINK);
	
	var Button = _react2['default'].createClass({
	  displayName: 'Button',
	
	  propTypes: {
	    active: _react2['default'].PropTypes.bool,
	    disabled: _react2['default'].PropTypes.bool,
	    block: _react2['default'].PropTypes.bool,
	    navItem: _react2['default'].PropTypes.bool,
	    navDropdown: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    href: _react2['default'].PropTypes.string,
	    target: _react2['default'].PropTypes.string,
	    /**
	     * Defines HTML button type Attribute
	     * @type {("button"|"reset"|"submit")}
	     * @defaultValue 'button'
	     */
	    type: _react2['default'].PropTypes.oneOf(types)
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      block: false,
	      disabled: false,
	      navItem: false,
	      navDropdown: false
	    };
	  },
	
	  render: function render() {
	    var _extends2;
	
	    var classes = this.props.navDropdown ? {} : _utilsBootstrapUtils2['default'].getClassSet(this.props);
	    var renderFuncName = undefined;
	
	    var blockClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'block');
	
	    classes = _extends((_extends2 = {
	      active: this.props.active
	    }, _extends2[blockClass] = this.props.block, _extends2), classes);
	
	    if (this.props.navItem) {
	      return this.renderNavItem(classes);
	    }
	
	    renderFuncName = this.props.href || this.props.target || this.props.navDropdown ? 'renderAnchor' : 'renderButton';
	
	    return this[renderFuncName](classes);
	  },
	
	  renderAnchor: function renderAnchor(classes) {
	    var Component = this.props.componentClass || 'a';
	    var href = this.props.href || '#';
	    classes.disabled = this.props.disabled;
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        href: href,
	        className: _classnames2['default'](this.props.className, classes),
	        role: 'button' }),
	      this.props.children
	    );
	  },
	
	  renderButton: function renderButton(classes) {
	    var Component = this.props.componentClass || 'button';
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        type: this.props.type || 'button',
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  },
	
	  renderNavItem: function renderNavItem(classes) {
	    var liClasses = {
	      active: this.props.active
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: _classnames2['default'](liClasses) },
	      this.renderAnchor(classes)
	    );
	  }
	});
	
	Button.types = types;
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(ButtonStyles, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL, _styleMaps.Sizes.XSMALL], _utilsBootstrapUtils.bsClass('btn', Button)));
	module.e = exports['default'];


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = shape({
	  listen: func.isRequired,
	  pushState: func.isRequired,
	  replaceState: func.isRequired,
	  go: func.isRequired
	});
	
	exports.history = history;
	var location = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	exports.location = location;
	var component = oneOfType([func, string]);
	exports.component = component;
	var components = oneOfType([component, object]);
	exports.components = components;
	var route = oneOfType([object, element]);
	exports.route = route;
	var routes = oneOfType([route, arrayOf(route)]);
	
	exports.routes = routes;
	exports['default'] = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route
	};


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1674);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.e = ReactReconciler;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(110);
	
	var assign = __webpack_require__(32);
	var emptyFunction = __webpack_require__(88);
	var warning = __webpack_require__(33);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.e = SyntheticEvent;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.e = Duplex;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(306);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(172);
	util.inherits = __webpack_require__(27);
	/*</replacement>*/
	
	var Readable = __webpack_require__(621);
	var Writable = __webpack_require__(341);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(205);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var ModalToggleButton = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a.bind()(ModalToggleButton, _React$Component);
	
	    function ModalToggleButton(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ModalToggleButton);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ModalToggleButton).call(this, props));
	
	        _this.show = _this.show.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	
	        _this.state = {
	            show: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a.bind()(ModalToggleButton, [{
	        key: 'show',
	        value: function show(e) {
	            e.preventDefault();
	            this.setState({ show: true });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({ show: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var children = _props.children;
	            var dialogType = _props.dialogType;
	            var dialogProps = _props.dialogProps;
	            var onClick = _props.onClick;
	
	            var props = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default.a.bind()(_props, ['children', 'dialogType', 'dialogProps', 'onClick']); // eslint-disable-line no-use-before-define
	
	            // allow callers to provide an onClick which will be called before the modal is shown
	
	
	            var clickHandler = this.show;
	            if (onClick) {
	                clickHandler = function clickHandler(e) {
	                    onClick();
	
	                    _this2.show(e);
	                };
	            }
	
	            // this assumes that all modals will have a show property and an onHide event
	            var dialog = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(this.props.dialogType, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, dialogProps, {
	                show: this.state.show,
	                onHide: function onHide() {
	                    _this2.hide();
	
	                    if (dialogProps.onHide) {
	                        dialogProps.onHide();
	                    }
	                }
	            }));
	
	            // nesting the dialog in the anchor tag looks like it shouldn't work, but it does due to how react-bootstrap
	            // renders modals at the top level of the DOM instead of where you specify in the virtual DOM
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'a',
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({}, props, {
	                    href: '#',
	                    onClick: clickHandler
	                }),
	                children,
	                dialog
	            );
	        }
	    }]);
	
	    return ModalToggleButton;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ModalToggleButton;
	
	
	ModalToggleButton.propTypes = {
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.node.isRequired,
	    dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func.isRequired,
	    dialogProps: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func
	};
	
	ModalToggleButton.defaultProps = {
	    dialogProps: {}
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(205);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(489);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events___default = __WEBPACK_IMPORTED_MODULE_10_events__ && __WEBPACK_IMPORTED_MODULE_10_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_events___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes;
	
	var COMPLETE_WORD_EVENT = 'complete_word';
	var PRETEXT_CHANGED_EVENT = 'pretext_changed';
	var SUGGESTIONS_CHANGED_EVENT = 'suggestions_changed';
	
	var SuggestionStore = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a.bind()(SuggestionStore, _EventEmitter);
	
	    function SuggestionStore() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SuggestionStore);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SuggestionStore).call(this));
	
	        _this.addSuggestionsChangedListener = _this.addSuggestionsChangedListener.bind(_this);
	        _this.removeSuggestionsChangedListener = _this.removeSuggestionsChangedListener.bind(_this);
	        _this.emitSuggestionsChanged = _this.emitSuggestionsChanged.bind(_this);
	
	        _this.addPretextChangedListener = _this.addPretextChangedListener.bind(_this);
	        _this.removePretextChangedListener = _this.removePretextChangedListener.bind(_this);
	        _this.emitPretextChanged = _this.emitPretextChanged.bind(_this);
	
	        _this.addCompleteWordListener = _this.addCompleteWordListener.bind(_this);
	        _this.removeCompleteWordListener = _this.removeCompleteWordListener.bind(_this);
	        _this.emitCompleteWord = _this.emitCompleteWord.bind(_this);
	
	        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
	        _this.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_8__dispatcher_app_dispatcher_jsx___default.a.register(_this.handleEventPayload);
	
	        // this.suggestions stores the state of all SuggestionBoxes by mapping their unique identifier to an
	        // object with the following fields:
	        // pretext: the text before the cursor
	        // matchedPretext: the text before the cursor that will be replaced if an autocomplete term is selected
	        // terms: a list of strings which the previously typed text may be replaced by
	        // items: a list of objects backing the terms which may be used in rendering
	        // components: a list of react components that can be used to render their corresponding item
	        // selection: the term currently selected by the keyboard
	        _this.suggestions = new /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a.bind()(SuggestionStore, [{
	        key: 'addSuggestionsChangedListener',
	        value: function addSuggestionsChangedListener(id, callback) {
	            this.on(SUGGESTIONS_CHANGED_EVENT + id, callback);
	        }
	    }, {
	        key: 'removeSuggestionsChangedListener',
	        value: function removeSuggestionsChangedListener(id, callback) {
	            this.removeListener(SUGGESTIONS_CHANGED_EVENT + id, callback);
	        }
	    }, {
	        key: 'emitSuggestionsChanged',
	        value: function emitSuggestionsChanged(id) {
	            this.emit(SUGGESTIONS_CHANGED_EVENT + id);
	        }
	    }, {
	        key: 'addPretextChangedListener',
	        value: function addPretextChangedListener(id, callback) {
	            this.on(PRETEXT_CHANGED_EVENT + id, callback);
	        }
	    }, {
	        key: 'removePretextChangedListener',
	        value: function removePretextChangedListener(id, callback) {
	            this.removeListener(PRETEXT_CHANGED_EVENT + id, callback);
	        }
	    }, {
	        key: 'emitPretextChanged',
	        value: function emitPretextChanged(id, pretext) {
	            this.emit(PRETEXT_CHANGED_EVENT + id, pretext);
	        }
	    }, {
	        key: 'addCompleteWordListener',
	        value: function addCompleteWordListener(id, callback) {
	            this.on(COMPLETE_WORD_EVENT + id, callback);
	        }
	    }, {
	        key: 'removeCompleteWordListener',
	        value: function removeCompleteWordListener(id, callback) {
	            this.removeListener(COMPLETE_WORD_EVENT + id, callback);
	        }
	    }, {
	        key: 'emitCompleteWord',
	        value: function emitCompleteWord(id, term) {
	            this.emit(COMPLETE_WORD_EVENT + id, term);
	        }
	    }, {
	        key: 'registerSuggestionBox',
	        value: function registerSuggestionBox(id) {
	            this.suggestions.set(id, {
	                pretext: '',
	                matchedPretext: '',
	                terms: [],
	                items: [],
	                components: [],
	                selection: ''
	            });
	        }
	    }, {
	        key: 'unregisterSuggestionBox',
	        value: function unregisterSuggestionBox(id) {
	            this.suggestions.delete(id);
	        }
	    }, {
	        key: 'clearSuggestions',
	        value: function clearSuggestions(id) {
	            var suggestion = this.suggestions.get(id);
	
	            suggestion.matchedPretext = '';
	            suggestion.terms = [];
	            suggestion.items = [];
	            suggestion.components = [];
	        }
	    }, {
	        key: 'clearSelection',
	        value: function clearSelection(id) {
	            var suggestion = this.suggestions.get(id);
	
	            suggestion.selection = '';
	        }
	    }, {
	        key: 'hasSuggestions',
	        value: function hasSuggestions(id) {
	            return this.suggestions.get(id).terms.length > 0;
	        }
	    }, {
	        key: 'setPretext',
	        value: function setPretext(id, pretext) {
	            var suggestion = this.suggestions.get(id);
	
	            suggestion.pretext = pretext;
	        }
	    }, {
	        key: 'setMatchedPretext',
	        value: function setMatchedPretext(id, matchedPretext) {
	            var suggestion = this.suggestions.get(id);
	
	            suggestion.matchedPretext = matchedPretext;
	        }
	    }, {
	        key: 'addSuggestion',
	        value: function addSuggestion(id, term, item, component) {
	            var suggestion = this.suggestions.get(id);
	
	            suggestion.terms.push(term);
	            suggestion.items.push(item);
	            suggestion.components.push(component);
	        }
	    }, {
	        key: 'addSuggestions',
	        value: function addSuggestions(id, terms, items, component) {
	            var _suggestion$terms, _suggestion$items;
	
	            var suggestion = this.suggestions.get(id);
	
	            (_suggestion$terms = suggestion.terms).push.apply(_suggestion$terms, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default.a.bind()(terms));
	            (_suggestion$items = suggestion.items).push.apply(_suggestion$items, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default.a.bind()(items));
	
	            for (var i = 0; i < terms.length; i++) {
	                suggestion.components.push(component);
	            }
	        }
	
	        // make sure that if suggestions exist, then one of them is selected. return true if the selection changes.
	
	    }, {
	        key: 'ensureSelectionExists',
	        value: function ensureSelectionExists(id) {
	            var suggestion = this.suggestions.get(id);
	
	            if (suggestion.terms.length > 0) {
	                // if the current selection is no longer in the map, select the first term in the list
	                if (!suggestion.selection || suggestion.terms.indexOf(suggestion.selection) === -1) {
	                    suggestion.selection = suggestion.terms[0];
	
	                    return true;
	                }
	            } else if (suggestion.selection) {
	                suggestion.selection = '';
	
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getPretext',
	        value: function getPretext(id) {
	            return this.suggestions.get(id).pretext;
	        }
	    }, {
	        key: 'getMatchedPretext',
	        value: function getMatchedPretext(id) {
	            return this.suggestions.get(id).matchedPretext;
	        }
	    }, {
	        key: 'getItems',
	        value: function getItems(id) {
	            return this.suggestions.get(id).items;
	        }
	    }, {
	        key: 'getTerms',
	        value: function getTerms(id) {
	            return this.suggestions.get(id).terms;
	        }
	    }, {
	        key: 'getComponents',
	        value: function getComponents(id) {
	            return this.suggestions.get(id).components;
	        }
	    }, {
	        key: 'getSelection',
	        value: function getSelection(id) {
	            return this.suggestions.get(id).selection;
	        }
	    }, {
	        key: 'selectNext',
	        value: function selectNext(id) {
	            this.setSelectionByDelta(id, 1);
	        }
	    }, {
	        key: 'selectPrevious',
	        value: function selectPrevious(id) {
	            this.setSelectionByDelta(id, -1);
	        }
	    }, {
	        key: 'setSelectionByDelta',
	        value: function setSelectionByDelta(id, delta) {
	            var suggestion = this.suggestions.get(id);
	
	            var selectionIndex = suggestion.terms.indexOf(suggestion.selection);
	
	            if (selectionIndex === -1) {
	                // this should never happen since selection should always be in terms
	                throw new Error('selection is not in terms');
	            }
	
	            selectionIndex += delta;
	
	            if (selectionIndex < 0) {
	                selectionIndex = 0;
	            } else if (selectionIndex > suggestion.terms.length - 1) {
	                selectionIndex = suggestion.terms.length - 1;
	            }
	
	            suggestion.selection = suggestion.terms[selectionIndex];
	        }
	    }, {
	        key: 'handleEventPayload',
	        value: function handleEventPayload(payload) {
	            var _payload$action = payload.action;
	            var type = _payload$action.type;
	            var id = _payload$action.id;
	
	            var other = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default.a.bind()(_payload$action, ['type', 'id']); // eslint-disable-line no-use-before-define
	
	            switch (type) {
	                case ActionTypes.SUGGESTION_PRETEXT_CHANGED:
	                    this.clearSuggestions(id);
	
	                    this.setPretext(id, other.pretext);
	                    this.emitPretextChanged(id, other.pretext);
	
	                    this.ensureSelectionExists(id);
	                    this.emitSuggestionsChanged(id);
	                    break;
	                case ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS:
	                    if (this.getMatchedPretext(id) === '') {
	                        this.setMatchedPretext(id, other.matchedPretext);
	
	                        // ensure the matched pretext hasn't changed so that we don't receive suggestions for outdated pretext
	                        this.addSuggestions(id, other.terms, other.items, other.component);
	
	                        this.ensureSelectionExists(id);
	                        this.emitSuggestionsChanged(id);
	                    }
	                    break;
	                case ActionTypes.SUGGESTION_CLEAR_SUGGESTIONS:
	                    this.clearSuggestions(id);
	                    this.clearSelection(id);
	                    this.emitSuggestionsChanged(id);
	                    break;
	                case ActionTypes.SUGGESTION_SELECT_NEXT:
	                    this.selectNext(id);
	                    this.emitSuggestionsChanged(id);
	                    break;
	                case ActionTypes.SUGGESTION_SELECT_PREVIOUS:
	                    this.selectPrevious(id);
	                    this.emitSuggestionsChanged(id);
	                    break;
	                case ActionTypes.SUGGESTION_COMPLETE_WORD:
	                    this.emitCompleteWord(id, other.term || this.getSelection(id), this.getMatchedPretext(id));
	
	                    this.setPretext(id, '');
	                    this.clearSuggestions(id);
	                    this.clearSelection(id);
	                    this.emitSuggestionsChanged(id);
	                    break;
	            }
	        }
	    }]);
	
	    return SuggestionStore;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_events___default.a);
	
	/* harmony default export */ exports["a"] = new SuggestionStore();

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/904babc69163fd15f0f43929e34b05dc.png";

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(35)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(56)(ArrayProto, UNSCOPABLES, {});
	module.e = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(74)
	  , TAG = __webpack_require__(35)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.e = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ctx         = __webpack_require__(90)
	  , call        = __webpack_require__(468)
	  , isArrayIter = __webpack_require__(260)
	  , anObject    = __webpack_require__(24)
	  , toLength    = __webpack_require__(45)
	  , getIterFn   = __webpack_require__(277)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.e = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var def = __webpack_require__(38).f
	  , has = __webpack_require__(53)
	  , TAG = __webpack_require__(35)('toStringTag');
	
	module.e = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9)
	  , defined = __webpack_require__(75)
	  , fails   = __webpack_require__(31)
	  , spaces  = __webpack_require__(273)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.e = exporter;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var Transform = __webpack_require__(157).Transform
	var inherits = __webpack_require__(27)
	var StringDecoder = __webpack_require__(342).StringDecoder
	module.e = CipherBase
	inherits(CipherBase, Transform)
	function CipherBase (hashMode) {
	  Transform.call(this)
	  this.hashMode = typeof hashMode === 'string'
	  if (this.hashMode) {
	    this[hashMode] = this._finalOrDigest
	  } else {
	    this.final = this._finalOrDigest
	  }
	  this._decoder = null
	  this._encoding = null
	}
	CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	  if (typeof data === 'string') {
	    data = new Buffer(data, inputEnc)
	  }
	  var outData = this._update(data)
	  if (this.hashMode) {
	    return this
	  }
	  if (outputEnc) {
	    outData = this._toString(outData, outputEnc)
	  }
	  return outData
	}
	
	CipherBase.prototype.setAutoPadding = function () {}
	
	CipherBase.prototype.getAuthTag = function () {
	  throw new Error('trying to get auth tag in unsupported state')
	}
	
	CipherBase.prototype.setAuthTag = function () {
	  throw new Error('trying to set auth tag in unsupported state')
	}
	
	CipherBase.prototype.setAAD = function () {
	  throw new Error('trying to set aad in unsupported state')
	}
	
	CipherBase.prototype._transform = function (data, _, next) {
	  var err
	  try {
	    if (this.hashMode) {
	      this._update(data)
	    } else {
	      this.push(this._update(data))
	    }
	  } catch (e) {
	    err = e
	  } finally {
	    next(err)
	  }
	}
	CipherBase.prototype._flush = function (done) {
	  var err
	  try {
	    this.push(this._final())
	  } catch (e) {
	    err = e
	  } finally {
	    done(err)
	  }
	}
	CipherBase.prototype._finalOrDigest = function (outputEnc) {
	  var outData = this._final() || new Buffer('')
	  if (outputEnc) {
	    outData = this._toString(outData, outputEnc, true)
	  }
	  return outData
	}
	
	CipherBase.prototype._toString = function (value, enc, final) {
	  if (!this._decoder) {
	    this._decoder = new StringDecoder(enc)
	    this._encoding = enc
	  }
	  if (this._encoding !== enc) {
	    throw new Error('can\'t switch encodings')
	  }
	  var out = this._decoder.write(value)
	  if (final) {
	    out += this._decoder.end()
	  }
	  return out
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 147 */
29,
/* 148 */
115,
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var inherits = __webpack_require__(27)
	var md5 = __webpack_require__(516)
	var rmd160 = __webpack_require__(1713)
	var sha = __webpack_require__(1714)
	
	var Base = __webpack_require__(146)
	
	function HashNoConstructor(hash) {
	  Base.call(this, 'digest')
	
	  this._hash = hash
	  this.buffers = []
	}
	
	inherits(HashNoConstructor, Base)
	
	HashNoConstructor.prototype._update = function (data) {
	  this.buffers.push(data)
	}
	
	HashNoConstructor.prototype._final = function () {
	  var buf = Buffer.concat(this.buffers)
	  var r = this._hash(buf)
	  this.buffers = null
	
	  return r
	}
	
	function Hash(hash) {
	  Base.call(this, 'digest')
	
	  this._hash = hash
	}
	
	inherits(Hash, Base)
	
	Hash.prototype._update = function (data) {
	  this._hash.update(data)
	}
	
	Hash.prototype._final = function () {
	  return this._hash.digest()
	}
	
	module.e = function createHash (alg) {
	  alg = alg.toLowerCase()
	  if ('md5' === alg) return new HashNoConstructor(md5)
	  if ('rmd160' === alg || 'ripemd160' === alg) return new HashNoConstructor(rmd160)
	
	  return new Hash(sha(alg))
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.e = exports["default"];


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.e = isLength;
	


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function escapeSource(string) {
	  return escapeRegExp(string).replace(/\/+/g, '/+');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = undefined,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeSource(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/?#]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '([\\s\\S]*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '([\\s\\S]*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeSource(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	
	function matchPattern(pattern, pathname) {
	  // Make leading slashes consistent between pattern and pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	  regexpSource += '/*'; // Capture path separators
	
	  // Special-case patterns like '*' for catch-all routes.
	  var captureRemaining = tokens[tokens.length - 1] !== '*';
	
	  if (captureRemaining) {
	    // This will match newlines in the remaining path.
	    regexpSource += '([\\s\\S]*?)';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource + '$', 'i'));
	
	  var remainingPathname = undefined,
	      paramValues = undefined;
	  if (match != null) {
	    if (captureRemaining) {
	      remainingPathname = match.pop();
	      var matchedPath = match[0].substr(0, match[0].length - remainingPathname.length);
	
	      // If we didn't match the entire pathname, then make sure that the match
	      // we did get ends at a path separator (potentially the one we added
	      // above at the beginning of the path, if the actual match was empty).
	      if (remainingPathname && matchedPath.charAt(matchedPath.length - 1) !== '/') {
	        return {
	          remainingPathname: null,
	          paramNames: paramNames,
	          paramValues: null
	        };
	      }
	    } else {
	      // If this matched at all, then the match was the entire pathname.
	      remainingPathname = '';
	    }
	
	    paramValues = match.slice(1).map(function (v) {
	      return v != null ? decodeURIComponent(v) : v;
	    });
	  } else {
	    remainingPathname = paramValues = null;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: paramValues
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var _matchPattern = matchPattern(pattern, pathname);
	
	  var paramNames = _matchPattern.paramNames;
	  var paramValues = _matchPattern.paramValues;
	
	  if (paramValues != null) {
	    return paramNames.reduce(function (memo, paramName, index) {
	      memo[paramName] = paramValues[index];
	      return memo;
	    }, {});
	  }
	
	  return null;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = undefined,
	      paramName = undefined,
	      paramValue = undefined;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? _invariant2['default'](false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : _invariant2['default'](false) : undefined;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? _invariant2['default'](false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : _invariant2['default'](false) : undefined;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.e = DOMProperty;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(607);
	
	var invariant = __webpack_require__(26);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.e = ReactInstanceHandles;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// prototype class for hash functions
	function Hash (blockSize, finalSize) {
	  this._block = new Buffer(blockSize)
	  this._finalSize = finalSize
	  this._blockSize = blockSize
	  this._len = 0
	  this._s = 0
	}
	
	Hash.prototype.update = function (data, enc) {
	  if (typeof data === 'string') {
	    enc = enc || 'utf8'
	    data = new Buffer(data, enc)
	  }
	
	  var l = this._len += data.length
	  var s = this._s || 0
	  var f = 0
	  var buffer = this._block
	
	  while (s < l) {
	    var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	    var ch = (t - f)
	
	    for (var i = 0; i < ch; i++) {
	      buffer[(s % this._blockSize) + i] = data[i + f]
	    }
	
	    s += ch
	    f += ch
	
	    if ((s % this._blockSize) === 0) {
	      this._update(buffer)
	    }
	  }
	  this._s = s
	
	  return this
	}
	
	Hash.prototype.digest = function (enc) {
	  // Suppose the length of the message M, in bits, is l
	  var l = this._len * 8
	
	  // Append the bit 1 to the end of the message
	  this._block[this._len % this._blockSize] = 0x80
	
	  // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	  this._block.fill(0, this._len % this._blockSize + 1)
	
	  if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	    this._update(this._block)
	    this._block.fill(0)
	  }
	
	  // to this append the block which is equal to the number l written in binary
	  // TODO: handle case where l is > Math.pow(2, 29)
	  this._block.writeInt32BE(l, this._blockSize - 4)
	
	  var hash = this._update(this._block) || this._hash()
	
	  return enc ? hash.toString(enc) : hash
	}
	
	Hash.prototype._update = function () {
	  throw new Error('_update must be implemented by subclass')
	}
	
	module.e = Hash
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.e = Stream;
	
	var EE = __webpack_require__(40).EventEmitter;
	var inherits = __webpack_require__(27);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(1722);
	Stream.Writable = __webpack_require__(1724);
	Stream.Duplex = __webpack_require__(1720);
	Stream.Transform = __webpack_require__(1723);
	Stream.PassThrough = __webpack_require__(1721);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};
	


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var FormError = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(FormError, _React$Component);
	
	    function FormError() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FormError);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FormError).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(FormError, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.error && this.props.errors.length === 0) {
	                return null;
	            }
	
	            // look for the first truthy error to display
	            var message = this.props.error;
	
	            if (!message) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(this.props.errors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var error = _step.value;
	
	                        if (error) {
	                            message = error;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            if (!message) {
	                return null;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'form-group has-error' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    message
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        get: function get() {
	            // accepts either a single error or an array of errors
	            return {
	                error: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node,
	                errors: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node)
	            };
	        }
	    }, {
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                error: null,
	                errors: []
	            };
	        }
	    }]);
	
	    return FormError;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = FormError;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(205);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_8_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_8_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_images_load_gif___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var SpinnerButton = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(SpinnerButton, _React$Component);
	
	    function SpinnerButton() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SpinnerButton);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SpinnerButton).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(SpinnerButton, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var spinning = _props.spinning;
	            var children = _props.children;
	
	            var props = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default.a.bind()(_props, ['spinning', 'children']); // eslint-disable-line no-use-before-define
	
	            if (spinning) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', {
	                    className: 'spinner-button__gif',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_images_load_gif___default.a
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'button',
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({
	                    className: 'btn btn-primary'
	                }, props),
	                children
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                children: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node,
	                spinning: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.bool.isRequired,
	                onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func
	            };
	        }
	    }]);
	
	    return SpinnerButton;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SpinnerButton;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var id = 0;
	
	function nextId() {
	    id = id + 1;
	    return id;
	}
	
	
	
	var UserProfile = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UserProfile, _React$Component);
	
	    function UserProfile(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserProfile);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserProfile).call(this, props));
	
	        _this.uniqueId = nextId();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UserProfile, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.areObjectsEqual(nextProps.user, this.props.user)) {
	                return true;
	            }
	
	            if (nextProps.overwriteName !== this.props.overwriteName) {
	                return true;
	            }
	
	            if (nextProps.overwriteImage !== this.props.overwriteImage) {
	                return true;
	            }
	
	            if (nextProps.disablePopover !== this.props.disablePopover) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var name = '...';
	            var email = '';
	            var profileImg = '';
	            if (this.props.user) {
	                name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.displayUsername(this.props.user.id);
	                email = this.props.user.email;
	                profileImg = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].getUsersRoute() + '/' + this.props.user.id + '/image?time=' + this.props.user.update_at;
	            }
	
	            if (this.props.overwriteName) {
	                name = this.props.overwriteName;
	            }
	
	            if (this.props.overwriteImage) {
	                profileImg = this.props.overwriteImage;
	            }
	
	            if (this.props.disablePopover) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    null,
	                    name
	                );
	            }
	
	            var dataContent = [];
	            dataContent.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                className: 'user-popover__image',
	                src: profileImg,
	                height: '128',
	                width: '128',
	                key: 'user-popover-image'
	            }));
	
	            if (!global.window.mm_config.ShowEmailAddress === 'true') {
	                dataContent.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'text-nowrap',
	                        key: 'user-popover-no-email'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                        id: 'user_profile.notShared',
	                        defaultMessage: 'Email not shared'
	                    })
	                ));
	            } else {
	                dataContent.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    {
	                        'data-toggle': 'tooltip',
	                        title: email,
	                        key: 'user-popover-email'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'a',
	                        {
	                            href: 'mailto:' + email,
	                            className: 'text-nowrap text-lowercase user-popover__email'
	                        },
	                        email
	                    )
	                ));
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
	                {
	                    trigger: 'click',
	                    placement: 'right',
	                    rootClose: true,
	                    overlay: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Popover"],
	                        {
	                            title: name,
	                            id: 'user-profile-popover'
	                        },
	                        dataContent
	                    )
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'user-popover',
	                        id: 'profile_' + this.uniqueId
	                    },
	                    name
	                )
	            );
	        }
	    }]);
	
	    return UserProfile;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UserProfile;
	
	
	UserProfile.defaultProps = {
	    user: {},
	    overwriteName: '',
	    overwriteImage: '',
	    disablePopover: false
	};
	UserProfile.propTypes = {
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object,
	    overwriteName: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    overwriteImage: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    disablePopover: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __WEBPACK_IMPORTED_MODULE_6_events__ && __WEBPACK_IMPORTED_MODULE_6_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	var SEARCH_CHANGE_EVENT = 'search_change';
	var SEARCH_TERM_CHANGE_EVENT = 'search_term_change';
	var SHOW_SEARCH_EVENT = 'show_search';
	
	var SearchStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SearchStoreClass, _EventEmitter);
	
	    function SearchStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchStoreClass).call(this));
	
	        _this.searchResults = null;
	        _this.isMentionSearch = false;
	        _this.searchTerm = '';
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SearchStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitSearchChange',
	        value: function emitSearchChange() {
	            this.emit(SEARCH_CHANGE_EVENT);
	        }
	    }, {
	        key: 'addSearchChangeListener',
	        value: function addSearchChangeListener(callback) {
	            this.on(SEARCH_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeSearchChangeListener',
	        value: function removeSearchChangeListener(callback) {
	            this.removeListener(SEARCH_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitSearchTermChange',
	        value: function emitSearchTermChange(doSearch, isMentionSearch) {
	            this.emit(SEARCH_TERM_CHANGE_EVENT, doSearch, isMentionSearch);
	        }
	    }, {
	        key: 'addSearchTermChangeListener',
	        value: function addSearchTermChangeListener(callback) {
	            this.on(SEARCH_TERM_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeSearchTermChangeListener',
	        value: function removeSearchTermChangeListener(callback) {
	            this.removeListener(SEARCH_TERM_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitShowSearch',
	        value: function emitShowSearch() {
	            this.emit(SHOW_SEARCH_EVENT);
	        }
	    }, {
	        key: 'addShowSearchListener',
	        value: function addShowSearchListener(callback) {
	            this.on(SHOW_SEARCH_EVENT, callback);
	        }
	    }, {
	        key: 'removeShowSearchListener',
	        value: function removeShowSearchListener(callback) {
	            this.removeListener(SHOW_SEARCH_EVENT, callback);
	        }
	    }, {
	        key: 'getSearchResults',
	        value: function getSearchResults() {
	            return this.searchResults;
	        }
	    }, {
	        key: 'getIsMentionSearch',
	        value: function getIsMentionSearch() {
	            return this.isMentionSearch;
	        }
	    }, {
	        key: 'storeSearchTerm',
	        value: function storeSearchTerm(term) {
	            this.searchTerm = term;
	        }
	    }, {
	        key: 'getSearchTerm',
	        value: function getSearchTerm() {
	            return this.searchTerm;
	        }
	    }, {
	        key: 'storeSearchResults',
	        value: function storeSearchResults(results, isMentionSearch) {
	            this.searchResults = results;
	            this.isMentionSearch = isMentionSearch;
	        }
	    }]);
	
	    return SearchStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_events___default.a);
	
	var SearchStore = new SearchStoreClass();
	
	SearchStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_SEARCH:
	            SearchStore.storeSearchResults(action.results, action.is_mention_search);
	            SearchStore.emitSearchChange();
	            break;
	        case ActionTypes.RECEIVED_SEARCH_TERM:
	            SearchStore.storeSearchTerm(action.term);
	            SearchStore.emitSearchTermChange(action.do_search, action.is_mention_search);
	            break;
	        case ActionTypes.SHOW_SEARCH:
	            SearchStore.emitShowSearch();
	            break;
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = SearchStore;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var base = exports;
	
	base.Reporter = __webpack_require__(1087).Reporter;
	base.DecoderBuffer = __webpack_require__(455).DecoderBuffer;
	base.EncoderBuffer = __webpack_require__(455).EncoderBuffer;
	base.Node = __webpack_require__(1086);
	


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(74);
	module.e = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function xor (a, b) {
	  var length = Math.min(a.length, b.length)
	  var buffer = new Buffer(length)
	
	  for (var i = 0; i < length; ++i) {
	    buffer[i] = a[i] ^ b[i]
	  }
	
	  return buffer
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// optional / simple context binding
	var aFunction = __webpack_require__(1327);
	module.e = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Thank's IE8 for his funny defineProperty
	module.e = !__webpack_require__(168)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});


/***/ },
/* 168 */
31,
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $          = __webpack_require__(43)
	  , createDesc = __webpack_require__(286);
	module.e = __webpack_require__(167) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(506)
	  , defined = __webpack_require__(209);
	module.e = function(it){
	  return IObject(defined(it));
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $at  = __webpack_require__(1339)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(284)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var canUseDOM = __webpack_require__(127);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.e = contains;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = assert;
	
	function assert(val, msg) {
	  if (!val)
	    throw new Error(msg || 'Assertion failed');
	}
	
	assert.equal = function assertEqual(l, r, msg) {
	  if (l != r)
	    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
	};
	


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict'
	
	function oldBrowser () {
	  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
	}
	
	var crypto = global.crypto || global.msCrypto
	
	if (crypto && crypto.getRandomValues) {
	  module.e = randomBytes
	} else {
	  module.e = oldBrowser
	}
	
	function randomBytes (size, cb) {
	  // phantomjs needs to throw
	  if (size > 65536) throw new Error('requested too many random bytes')
	  // in case browserify  isn't using the Uint8Array version
	  var rawBytes = new global.Uint8Array(size)
	
	  // This will not work in older browsers.
	  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	  if (size > 0) {  // getRandomValues fails on IE if size == 0
	    crypto.getRandomValues(rawBytes)
	  }
	  // phantomjs doesn't like a buffer being passed here
	  var bytes = new Buffer(rawBytes.buffer)
	
	  if (typeof cb === 'function') {
	    return process.nextTick(function () {
	      cb(null, bytes)
	    })
	  }
	
	  return bytes
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19).Buffer, __webpack_require__(107)))

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _domHelpersStyle = __webpack_require__(217);
	
	var _domHelpersStyle2 = _interopRequireDefault(_domHelpersStyle);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOverlaysLibTransition = __webpack_require__(573);
	
	var _reactOverlaysLibTransition2 = _interopRequireDefault(_reactOverlaysLibTransition);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(178);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var capitalize = function capitalize(str) {
	  return str[0].toUpperCase() + str.substr(1);
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	var triggerBrowserReflow = function triggerBrowserReflow(node) {
	  return node.offsetHeight;
	};
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + capitalize(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt(_domHelpersStyle2['default'](elem, margins[0]), 10) + parseInt(_domHelpersStyle2['default'](elem, margins[1]), 10);
	}
	
	var Collapse = (function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    _classCallCheck(this, Collapse);
	
	    _React$Component.call(this, props, context);
	
	    this.onEnterListener = this.handleEnter.bind(this);
	    this.onEnteringListener = this.handleEntering.bind(this);
	    this.onEnteredListener = this.handleEntered.bind(this);
	    this.onExitListener = this.handleExit.bind(this);
	    this.onExitingListener = this.handleExiting.bind(this);
	  }
	
	  // Explicitly copied from Transition for doc generation.
	  // TODO: Remove duplication once #977 is resolved.
	
	  Collapse.prototype.render = function render() {
	    var enter = _utilsCreateChainedFunction2['default'](this.onEnterListener, this.props.onEnter);
	    var entering = _utilsCreateChainedFunction2['default'](this.onEnteringListener, this.props.onEntering);
	    var entered = _utilsCreateChainedFunction2['default'](this.onEnteredListener, this.props.onEntered);
	    var exit = _utilsCreateChainedFunction2['default'](this.onExitListener, this.props.onExit);
	    var exiting = _utilsCreateChainedFunction2['default'](this.onExitingListener, this.props.onExiting);
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibTransition2['default'],
	      _extends({
	        ref: 'transition'
	      }, this.props, {
	        'aria-expanded': this.props.role ? this.props['in'] : null,
	        className: _classnames2['default'](this.props.className, { width: this._dimension() === 'width' }),
	        exitedClassName: 'collapse',
	        exitingClassName: 'collapsing',
	        enteredClassName: 'collapse in',
	        enteringClassName: 'collapsing',
	        onEnter: enter,
	        onEntering: entering,
	        onEntered: entered,
	        onExit: exit,
	        onExiting: exiting,
	        onExited: this.props.onExited
	      }),
	      this.props.children
	    );
	  };
	
	  /* -- Expanding -- */
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	
	    triggerBrowserReflow(elem);
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	  Collapse.prototype._getTransitionInstance = function _getTransitionInstance() {
	    return this.refs.transition;
	  };
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + capitalize(dimension)] + 'px';
	  };
	
	  return Collapse;
	})(_react2['default'].Component);
	
	Collapse.propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * duration
	   * @private
	   */
	  duration: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.number, 'Use `timeout`.'),
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['height', 'width']), _react2['default'].PropTypes.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	Collapse.defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	exports['default'] = Collapse;
	module.e = exports['default'];


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domHelpersOwnerDocument = __webpack_require__(150);
	
	var _domHelpersOwnerDocument2 = _interopRequireDefault(_domHelpersOwnerDocument);
	
	exports['default'] = function (componentOrElement) {
	  return _domHelpersOwnerDocument2['default'](_reactDom2['default'].findDOMNode(componentOrElement));
	};
	
	module.e = exports['default'];


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = deprecated;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] != null) {
	      _warning2['default'](false, '"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	
	module.e = exports['default'];


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(587);
	var EventPluginUtils = __webpack_require__(1651);
	var ReactErrorUtils = __webpack_require__(600);
	
	var accumulateInto = __webpack_require__(609);
	var forEachAccumulated = __webpack_require__(610);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.e = EventPluginHub;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventPluginHub = __webpack_require__(179);
	
	var warning = __webpack_require__(33);
	
	var accumulateInto = __webpack_require__(609);
	var forEachAccumulated = __webpack_require__(610);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.e = EventPropagators;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.e = ReactInstanceMap;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(136);
	
	var getEventTarget = __webpack_require__(331);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.e = SyntheticUIEvent;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.e = emptyObject;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint no-unused-vars:0 */
	
	var Style = __webpack_require__(239);
	
	/**
	 * This file contains metrics regarding fonts and individual symbols. The sigma
	 * and xi variables, as well as the metricMap map contain data extracted from
	 * TeX, TeX font metrics, and the TTF files. These data are then exposed via the
	 * `metrics` variable and the getCharacterMetrics function.
	 */
	
	// These font metrics are extracted from TeX by using
	// \font\a=cmmi10
	// \showthe\fontdimenX\a
	// where X is the corresponding variable number. These correspond to the font
	// parameters of the symbol fonts. In TeX, there are actually three sets of
	// dimensions, one for each of textstyle, scriptstyle, and scriptscriptstyle,
	// but we only use the textstyle ones, and scale certain dimensions accordingly.
	// See the TeXbook, page 441.
	var sigma1 = 0.025;
	var sigma2 = 0;
	var sigma3 = 0;
	var sigma4 = 0;
	var sigma5 = 0.431;
	var sigma6 = 1;
	var sigma7 = 0;
	var sigma8 = 0.677;
	var sigma9 = 0.394;
	var sigma10 = 0.444;
	var sigma11 = 0.686;
	var sigma12 = 0.345;
	var sigma13 = 0.413;
	var sigma14 = 0.363;
	var sigma15 = 0.289;
	var sigma16 = 0.150;
	var sigma17 = 0.247;
	var sigma18 = 0.386;
	var sigma19 = 0.050;
	var sigma20 = 2.390;
	var sigma21 = 1.01;
	var sigma21Script = 0.81;
	var sigma21ScriptScript = 0.71;
	var sigma22 = 0.250;
	
	// These font metrics are extracted from TeX by using
	// \font\a=cmex10
	// \showthe\fontdimenX\a
	// where X is the corresponding variable number. These correspond to the font
	// parameters of the extension fonts (family 3). See the TeXbook, page 441.
	var xi1 = 0;
	var xi2 = 0;
	var xi3 = 0;
	var xi4 = 0;
	var xi5 = 0.431;
	var xi6 = 1;
	var xi7 = 0;
	var xi8 = 0.04;
	var xi9 = 0.111;
	var xi10 = 0.166;
	var xi11 = 0.2;
	var xi12 = 0.6;
	var xi13 = 0.1;
	
	// This value determines how large a pt is, for metrics which are defined in
	// terms of pts.
	// This value is also used in katex.less; if you change it make sure the values
	// match.
	var ptPerEm = 10.0;
	
	// The space between adjacent `|` columns in an array definition. From
	// `\showthe\doublerulesep` in LaTeX.
	var doubleRuleSep = 2.0 / ptPerEm;
	
	/**
	 * This is just a mapping from common names to real metrics
	 */
	var metrics = {
	    xHeight: sigma5,
	    quad: sigma6,
	    num1: sigma8,
	    num2: sigma9,
	    num3: sigma10,
	    denom1: sigma11,
	    denom2: sigma12,
	    sup1: sigma13,
	    sup2: sigma14,
	    sup3: sigma15,
	    sub1: sigma16,
	    sub2: sigma17,
	    supDrop: sigma18,
	    subDrop: sigma19,
	    axisHeight: sigma22,
	    defaultRuleThickness: xi8,
	    bigOpSpacing1: xi9,
	    bigOpSpacing2: xi10,
	    bigOpSpacing3: xi11,
	    bigOpSpacing4: xi12,
	    bigOpSpacing5: xi13,
	    ptPerEm: ptPerEm,
	    emPerEx: sigma5 / sigma6,
	    doubleRuleSep: doubleRuleSep,
	
	    // TODO(alpert): Missing parallel structure here. We should probably add
	    // style-specific metrics for all of these.
	    delim1: sigma20,
	    getDelim2: function(style) {
	        if (style.size === Style.TEXT.size) {
	            return sigma21;
	        } else if (style.size === Style.SCRIPT.size) {
	            return sigma21Script;
	        } else if (style.size === Style.SCRIPTSCRIPT.size) {
	            return sigma21ScriptScript;
	        }
	        throw new Error("Unexpected style size: " + style.size);
	    },
	};
	
	// This map contains a mapping from font name and character code to character
	// metrics, including height, depth, italic correction, and skew (kern from the
	// character to the corresponding \skewchar)
	// This map is generated via `make metrics`. It should not be changed manually.
	var metricMap = __webpack_require__(1748);
	
	/**
	 * This function is a convenience function for looking up information in the
	 * metricMap table. It takes a character as a string, and a style.
	 *
	 * Note: the `width` property may be undefined if fontMetricsData.js wasn't
	 * built using `Make extended_metrics`.
	 */
	var getCharacterMetrics = function(character, style) {
	    var metrics = metricMap[style][character.charCodeAt(0)];
	    if (metrics) {
	        return {
	            depth: metrics[0],
	            height: metrics[1],
	            italic: metrics[2],
	            skew: metrics[3],
	            width: metrics[4],
	        };
	    }
	};
	
	module.e = {
	    metrics: metrics,
	    getCharacterMetrics: getCharacterMetrics,
	};
	


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__channel_invite_button_jsx__ = __webpack_require__(684);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtered_user_list_jsx__ = __webpack_require__(188);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ChannelInviteModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelInviteModal, _React$Component);
	
	    function ChannelInviteModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelInviteModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelInviteModal).call(this, props));
	
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	        _this.getStateFromStores = _this.getStateFromStores.bind(_this);
	        _this.handleInviteError = _this.handleInviteError.bind(_this);
	
	        _this.state = _this.getStateFromStores();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChannelInviteModal, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!this.props.show && !nextProps.show) {
	                return false;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(this.props, nextProps)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(this.state, nextState)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var users = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getActiveOnlyProfiles();
	
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isEmptyObject(users)) {
	                return {
	                    loading: true
	                };
	            }
	
	            // make sure we have all members of this channel before rendering
	            var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrentExtraInfo();
	            if (extraInfo.member_count !== extraInfo.members.length) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_async_client_jsx__.getChannelExtraInfo(this.props.channel.id, -1);
	
	                return {
	                    loading: true
	                };
	            }
	
	            var currentUser = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser();
	            if (!currentUser) {
	                return {
	                    loading: true
	                };
	            }
	
	            var currentMember = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrentMember();
	            if (!currentMember) {
	                return {
	                    loading: true
	                };
	            }
	
	            var memberIds = extraInfo.members.map(function (user) {
	                return user.id;
	            });
	
	            var nonmembers = [];
	            for (var id in users) {
	                if (memberIds.indexOf(id) === -1) {
	                    nonmembers.push(users[id]);
	                }
	            }
	
	            nonmembers.sort(function (a, b) {
	                return a.username.localeCompare(b.username);
	            });
	
	            return {
	                nonmembers: nonmembers,
	                loading: false,
	                currentUser: currentUser,
	                currentMember: currentMember
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.show && nextProps.show) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addExtraInfoChangeListener(this.onListenerChange);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addChangeListener(this.onListenerChange);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].addChangeListener(this.onListenerChange);
	                this.onListenerChange();
	            } else if (this.props.show && !nextProps.show) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeExtraInfoChangeListener(this.onListenerChange);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeExtraInfoChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            var newState = this.getStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(this.state, newState)) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'handleInviteError',
	        value: function handleInviteError(err) {
	            if (err) {
	                this.setState({
	                    inviteError: err.message
	                });
	            } else {
	                this.setState({
	                    inviteError: null
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var inviteError = null;
	            if (this.state.inviteError) {
	                inviteError = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'label',
	                    { className: 'has-error control-label' },
	                    this.state.inviteError
	                );
	            }
	
	            var content;
	            if (this.state.loading) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__loading_screen_jsx__["a"], null);
	            } else {
	                var maxHeight = 1000;
	                if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.windowHeight() <= 1200) {
	                    maxHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.windowHeight() - 300;
	                }
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__filtered_user_list_jsx__["a"], {
	                    style: { maxHeight: maxHeight },
	                    users: this.state.nonmembers,
	                    actions: [/* harmony import */__WEBPACK_IMPORTED_MODULE_6__channel_invite_button_jsx__["a"]],
	                    actionProps: {
	                        channel: this.props.channel,
	                        onInviteError: this.handleInviteError
	                    }
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"],
	                {
	                    dialogClassName: 'more-modal',
	                    show: this.props.show,
	                    onHide: this.props.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'channel_invite.addNewMembers',
	                            defaultMessage: 'Add New Members to '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            'span',
	                            { className: 'name' },
	                            this.props.channel.display_name
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Body,
	                    null,
	                    inviteError,
	                    content
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.props.onHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'channel_invite.close',
	                            defaultMessage: 'Close'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChannelInviteModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelInviteModal;
	
	
	ChannelInviteModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var ConfirmModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ConfirmModal, _React$Component);
	
	    function ConfirmModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ConfirmModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ConfirmModal).call(this, props));
	
	        _this.handleConfirm = _this.handleConfirm.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ConfirmModal, [{
	        key: 'handleConfirm',
	        value: function handleConfirm() {
	            this.props.onConfirm();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
	                {
	                    className: 'modal-confirm',
	                    show: this.props.show,
	                    onHide: this.props.onCancel
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
	                    { closeButton: false },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Title,
	                        null,
	                        this.props.title
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
	                    null,
	                    this.props.message
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.props.onCancel
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'confirm_modal.cancel',
	                            defaultMessage: 'Cancel'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-primary',
	                            onClick: this.props.onConfirm
	                        },
	                        this.props.confirmButton
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ConfirmModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ConfirmModal;
	
	
	ConfirmModal.defaultProps = {
	    title: '',
	    message: '',
	    confirmButton: ''
	};
	ConfirmModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.bool.isRequired,
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node,
	    message: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node,
	    confirmButton: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node,
	    onConfirm: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired,
	    onCancel: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var ErrorBar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ErrorBar, _React$Component);
	
	    function ErrorBar() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ErrorBar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ErrorBar).call(this));
	
	        _this.onErrorChange = _this.onErrorChange.bind(_this);
	        _this.handleClose = _this.handleClose.bind(_this);
	
	        _this.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].getLastError();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ErrorBar, [{
	        key: 'isValidError',
	        value: function isValidError(s) {
	            if (!s) {
	                return false;
	            }
	
	            if (!s.message) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].getIgnoreEmailPreview() && global.window.mm_config.SendEmailNotifications === 'false') {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].storeLastError({ email_preview: true, message: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.localizeMessage('error_bar.preview_mode', 'Preview Mode: Email notifications have not been configured') });
	                this.onErrorChange();
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].addChangeListener(this.onErrorChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].removeChangeListener(this.onErrorChange);
	        }
	    }, {
	        key: 'onErrorChange',
	        value: function onErrorChange() {
	            var newState = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].getLastError();
	
	            if (newState) {
	                this.setState(newState);
	            } else {
	                this.setState({ message: null });
	            }
	        }
	    }, {
	        key: 'handleClose',
	        value: function handleClose(e) {
	            if (e) {
	                e.preventDefault();
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_error_store_jsx__["a"].clearLastError();
	            this.setState({ message: null });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.isValidError(this.state)) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', null);
	            }
	
	            var errClass = 'error-bar';
	
	            if (this.state.type && this.state.type === 'developer') {
	                errClass = 'error-bar-developer';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                { className: errClass },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'span',
	                    null,
	                    this.state.message
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        className: 'error-bar__close',
	                        onClick: this.handleClose
	                    },
	                    '×'
	                )
	            );
	        }
	    }]);
	
	    return ErrorBar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ErrorBar;
	
	
	/* harmony default export */ exports["a"] = ErrorBar;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_list_jsx__ = __webpack_require__(768);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["defineMessages"].bind()({
	    member: {
	        id: 'filtered_user_list.member',
	        defaultMessage: 'Member'
	    },
	    search: {
	        id: 'filtered_user_list.search',
	        defaultMessage: 'Search members'
	    },
	    anyTeam: {
	        id: 'filtered_user_list.any_team',
	        defaultMessage: 'All Users'
	    },
	    teamOnly: {
	        id: 'filtered_user_list.team_only',
	        defaultMessage: 'Members of this Team'
	    }
	});
	
	
	
	var FilteredUserList = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FilteredUserList, _React$Component);
	
	    function FilteredUserList(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FilteredUserList);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FilteredUserList).call(this, props));
	
	        _this.handleFilterChange = _this.handleFilterChange.bind(_this);
	        _this.handleListChange = _this.handleListChange.bind(_this);
	        _this.filterUsers = _this.filterUsers.bind(_this);
	
	        _this.state = {
	            filter: '',
	            users: _this.filterUsers(props.teamMembers, props.users),
	            selected: 'team'
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FilteredUserList, [{
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps) {
	            // assume the user list is immutable
	            if (this.props.users !== nextProps.users) {
	                this.setState({
	                    users: this.filterUsers(nextProps.teamMembers, nextProps.users)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.filter !== this.state.filter) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.userList)).scrollTop(0);
	            }
	        }
	    }, {
	        key: 'filterUsers',
	        value: function filterUsers(teamMembers, users) {
	            if (!teamMembers || teamMembers.length === 0) {
	                return users;
	            }
	
	            var filteredUsers = users.filter(function (user) {
	                for (var index in teamMembers) {
	                    if (teamMembers.hasOwnProperty(index) && teamMembers[index].user_id === user.id) {
	                        return true;
	                    }
	                }
	
	                return false;
	            });
	
	            return filteredUsers;
	        }
	    }, {
	        key: 'handleFilterChange',
	        value: function handleFilterChange(e) {
	            this.setState({
	                filter: e.target.value
	            });
	        }
	    }, {
	        key: 'handleListChange',
	        value: function handleListChange(e) {
	            var users = this.props.users;
	
	            if (e.target.value === 'team') {
	                users = this.filterUsers(this.props.teamMembers, this.props.users);
	            }
	
	            this.setState({
	                selected: e.target.value,
	                users: users
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            var users = this.state.users;
	
	            if (this.state.filter && this.state.filter.length > 0) {
	                (function () {
	                    var filter = _this2.state.filter.toLowerCase();
	
	                    users = users.filter(function (user) {
	                        return user.username.toLowerCase().indexOf(filter) !== -1 || user.first_name && user.first_name.toLowerCase().indexOf(filter) !== -1 || user.last_name && user.last_name.toLowerCase().indexOf(filter) !== -1 || user.nickname && user.nickname.toLowerCase().indexOf(filter) !== -1;
	                    });
	                })();
	            }
	
	            var count = void 0;
	            if (users.length === this.state.users.length) {
	                count = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                    id: 'filtered_user_list.count',
	                    defaultMessage: '{count} {count, plural, =0 {0 members} one {member} other {members}}',
	                    values: {
	                        count: users.length
	                    }
	                });
	            } else {
	                count = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                    id: 'filtered_user_list.countTotal',
	                    defaultMessage: '{count} {count, plural, =0 {0 members} one {member} other {members}} of {total} Total',
	                    values: {
	                        count: users.length,
	                        total: this.state.users.length
	                    }
	                });
	            }
	
	            var teamToggle = void 0;
	
	            var teamMembers = this.props.teamMembers;
	            if (this.props.showTeamToggle) {
	                teamMembers = [];
	
	                teamToggle = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'member-select__container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'select',
	                        {
	                            className: 'form-control',
	                            id: 'restrictList',
	                            ref: 'restrictList',
	                            defaultValue: 'team',
	                            onChange: this.handleListChange
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'option',
	                            { value: 'any' },
	                            formatMessage(holders.anyTeam)
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'option',
	                            { value: 'team' },
	                            formatMessage(holders.teamOnly)
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'span',
	                        {
	                            className: 'member-show'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'filtered_user_list.show',
	                            defaultMessage: 'Filter:'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                {
	                    className: 'filtered-user-list',
	                    style: this.props.style
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'filter-row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-6' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('input', {
	                            ref: 'filter',
	                            className: 'form-control filter-textbox',
	                            placeholder: formatMessage(holders.search),
	                            onInput: this.handleFilterChange
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-6' },
	                        teamToggle
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-12' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'span',
	                            { className: 'member-count pull-left' },
	                            count
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'userList',
	                        className: 'more-modal__list'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__user_list_jsx__["a"], {
	                        users: users,
	                        teamMembers: teamMembers,
	                        actions: this.props.actions,
	                        actionProps: this.props.actionProps
	                    })
	                )
	            );
	        }
	    }]);
	
	    return FilteredUserList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	FilteredUserList.defaultProps = {
	    users: [],
	    teamMembers: [],
	    actions: [],
	    actionProps: {},
	    showTeamToggle: false
	};
	
	FilteredUserList.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
	    users: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object),
	    teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object),
	    actions: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func),
	    actionProps: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object,
	    showTeamToggle: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    style: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"].bind()(FilteredUserList);

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif__ = __webpack_require__(828);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif___default = __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif__ && __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif__ = __webpack_require__(829);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif___default = __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif__ && __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif___default });
	/* harmony export */ exports["a"] = createMenuTip;'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].Preferences;
	
	
	
	
	
	
	
	
	var TutorialTip = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TutorialTip, _React$Component);
	
	    function TutorialTip(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TutorialTip);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TutorialTip).call(this, props));
	
	        _this.handleNext = _this.handleNext.bind(_this);
	        _this.toggle = _this.toggle.bind(_this);
	
	        _this.state = { currentScreen: 0, show: false };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TutorialTip, [{
	        key: 'toggle',
	        value: function toggle() {
	            var show = !this.state.show;
	            this.setState({ show: show });
	
	            if (!show && this.state.currentScreen >= this.props.screens.length - 1) {
	                var step = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentId(), 0);
	
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.savePreference(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentId(), (step + 1).toString());
	            }
	        }
	    }, {
	        key: 'handleNext',
	        value: function handleNext() {
	            if (this.state.currentScreen < this.props.screens.length - 1) {
	                this.setState({ currentScreen: this.state.currentScreen + 1 });
	                return;
	            }
	
	            this.toggle();
	        }
	    }, {
	        key: 'skipTutorial',
	        value: function skipTutorial(e) {
	            e.preventDefault();
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.savePreference(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentId(), '999');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var buttonText = this.state.currentScreen === this.props.screens.length - 1 ? /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                id: 'tutorial_tip.ok',
	                defaultMessage: 'Okay'
	            }) : /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                id: 'tutorial_tip.next',
	                defaultMessage: 'Next'
	            });
	
	            var dots = [];
	            if (this.props.screens.length > 1) {
	                var _loop = function _loop(i) {
	                    var className = 'circle';
	                    if (i === _this2.state.currentScreen) {
	                        className += ' active';
	                    }
	
	                    dots.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('a', {
	                        href: '#',
	                        key: 'dotactive' + i,
	                        className: className,
	                        onClick: function onClick(e) {
	                            //eslint-disable-line no-loop-func
	                            e.preventDefault();
	                            _this2.setState({ currentScreen: i });
	                        }
	                    }));
	                };
	
	                for (var i = 0; i < this.props.screens.length; i++) {
	                    _loop(i);
	                }
	            }
	
	            var tutorialGifImage = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_images_tutorialTip_gif___default.a;
	            if (this.props.overlayClass === 'tip-overlay--header' || this.props.overlayClass === 'tip-overlay--sidebar') {
	                tutorialGifImage = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_images_tutorialTipWhite_gif___default.a;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                { className: 'tip-div ' + this.props.overlayClass },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
	                    className: 'tip-button',
	                    src: tutorialGifImage,
	                    width: '35',
	                    onClick: this.toggle,
	                    ref: 'target'
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Overlay"],
	                    {
	                        show: this.state.show
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: 'tip-backdrop' })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Overlay"],
	                    {
	                        placement: this.props.placement,
	                        show: this.state.show,
	                        rootClose: true,
	                        onHide: this.toggle,
	                        target: function target() {
	                            return _this2.refs.target;
	                        }
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'tip-overlay ' + this.props.overlayClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: 'arrow' }),
	                        this.props.screens[this.state.currentScreen],
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'tutorial__footer' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'div',
	                                { className: 'tutorial__circles' },
	                                dots
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'div',
	                                { className: 'text-right' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-primary',
	                                        onClick: this.handleNext
	                                    },
	                                    buttonText
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'div',
	                                    { className: 'tip-opt' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                        id: 'tutorial_tip.seen',
	                                        defaultMessage: 'Seen this before? '
	                                    }),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            onClick: this.skipTutorial
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                            id: 'tutorial_tip.out',
	                                            defaultMessage: 'Opt out of these tips.'
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TutorialTip;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	/* harmony default export */ exports["b"] = TutorialTip;
	
	
	TutorialTip.defaultProps = {
	    overlayClass: ''
	};
	
	TutorialTip.propTypes = {
	    screens: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.array.isRequired,
	    placement: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.string.isRequired,
	    overlayClass: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.string
	};
	
	function createMenuTip(toggleFunc, onBottom) {
	    var screens = [];
	
	    screens.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	        'div',
	        null,
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	            id: 'sidebar_header.tutorial',
	            defaultMessage: '<h4>Main Menu</h4> <p>The <strong>Main Menu</strong> is where you can <strong>Invite New Members</strong>, access your <strong>Account Settings</strong> and set your <strong>Theme Color</strong>.</p> <p>Team administrators can also access their <strong>Team Settings</strong> from this menu.</p><p>System administrators will find a <strong>System Console</strong> option to administrate the entire system.</p>'
	        })
	    ));
	
	    var placement = 'right';
	    var arrow = 'left';
	    if (onBottom) {
	        placement = 'bottom';
	        arrow = 'up';
	    }
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	        'div',
	        {
	            onClick: toggleFunc
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(TutorialTip, {
	            ref: 'tip',
	            placement: placement,
	            screens: screens,
	            overlayClass: 'tip-overlay--header--' + arrow
	        })
	    );
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl___default = __WEBPACK_IMPORTED_MODULE_0_react_intl__ && __WEBPACK_IMPORTED_MODULE_0_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ = __webpack_require__(1608);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default = __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ && __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__ = __webpack_require__(1609);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es___default = __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__ && __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__ = __webpack_require__(1610);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr___default = __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__ && __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja__ = __webpack_require__(1611);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja___default = __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja__ && __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt__ = __webpack_require__(1612);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt___default = __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt__ && __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt___default });
	/* harmony export */ exports["getLanguages"] = getLanguages;/* harmony export */ exports["getLanguageInfo"] = getLanguageInfo;/* harmony export */ exports["safariFix"] = safariFix;/* harmony export */ exports["doAddLocaleData"] = doAddLocaleData;'use strict';
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	var es = __webpack_require__(802);
	var fr = __webpack_require__(803);
	var ja = __webpack_require__(804);
	var pt = __webpack_require__(805);
	
	
	
	
	
	
	
	
	var languages = {
	    en: {
	        value: 'en',
	        name: 'English',
	        url: ''
	    },
	    es: {
	        value: 'es',
	        name: 'Español (Beta)',
	        url: es
	    },
	    fr: {
	        value: 'fr',
	        name: 'Français (Beta)',
	        url: fr
	    },
	    ja: {
	        value: 'ja',
	        name: '日本語 (Beta)',
	        url: ja
	    },
	    pt: {
	        value: 'pt',
	        name: 'Portugues (Beta)',
	        url: pt
	    }
	};
	
	function getLanguages() {
	    return languages;
	}
	
	function getLanguageInfo(locale) {
	    return languages[locale];
	}
	
	function safariFix(callback) {
	    __webpack_require__.e/* nsure */(1).catch(function(err) { __webpack_require__.oe(err); }).then(function (require) {
	        __webpack_require__(630);
	        __webpack_require__(631);
	        __webpack_require__(632);
	        __webpack_require__(633);
	        __webpack_require__(634);
	        __webpack_require__(635);
	        callback();
	    }.bind(null, __webpack_require__));
	}
	
	function doAddLocaleData() {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"].bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default.a);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"].bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_es___default.a);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"].bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_3_react_intl_locale_data_fr___default.a);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"].bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_4_react_intl_locale_data_ja___default.a);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_react_intl__["addLocaleData"].bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_pt___default.a);
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __WEBPACK_IMPORTED_MODULE_6_events__ && __WEBPACK_IMPORTED_MODULE_6_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	var LOG_CHANGE_EVENT = 'log_change';
	var SERVER_AUDIT_CHANGE_EVENT = 'server_audit_change';
	var CONFIG_CHANGE_EVENT = 'config_change';
	var ALL_TEAMS_EVENT = 'all_team_change';
	var SERVER_COMPLIANCE_REPORT_CHANGE_EVENT = 'server_compliance_reports_change';
	
	var AdminStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AdminStoreClass, _EventEmitter);
	
	    function AdminStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AdminStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AdminStoreClass).call(this));
	
	        _this.logs = null;
	        _this.audits = null;
	        _this.config = null;
	        _this.teams = null;
	        _this.complianceReports = null;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AdminStoreClass, [{
	        key: 'emitLogChange',
	        value: function emitLogChange() {
	            this.emit(LOG_CHANGE_EVENT);
	        }
	    }, {
	        key: 'addLogChangeListener',
	        value: function addLogChangeListener(callback) {
	            this.on(LOG_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeLogChangeListener',
	        value: function removeLogChangeListener(callback) {
	            this.removeListener(LOG_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitAuditChange',
	        value: function emitAuditChange() {
	            this.emit(SERVER_AUDIT_CHANGE_EVENT);
	        }
	    }, {
	        key: 'addAuditChangeListener',
	        value: function addAuditChangeListener(callback) {
	            this.on(SERVER_AUDIT_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeAuditChangeListener',
	        value: function removeAuditChangeListener(callback) {
	            this.removeListener(SERVER_AUDIT_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitComplianceReportsChange',
	        value: function emitComplianceReportsChange() {
	            this.emit(SERVER_COMPLIANCE_REPORT_CHANGE_EVENT);
	        }
	    }, {
	        key: 'addComplianceReportsChangeListener',
	        value: function addComplianceReportsChangeListener(callback) {
	            this.on(SERVER_COMPLIANCE_REPORT_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeComplianceReportsChangeListener',
	        value: function removeComplianceReportsChangeListener(callback) {
	            this.removeListener(SERVER_COMPLIANCE_REPORT_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitConfigChange',
	        value: function emitConfigChange() {
	            this.emit(CONFIG_CHANGE_EVENT);
	        }
	    }, {
	        key: 'addConfigChangeListener',
	        value: function addConfigChangeListener(callback) {
	            this.on(CONFIG_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeConfigChangeListener',
	        value: function removeConfigChangeListener(callback) {
	            this.removeListener(CONFIG_CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitAllTeamsChange',
	        value: function emitAllTeamsChange() {
	            this.emit(ALL_TEAMS_EVENT);
	        }
	    }, {
	        key: 'addAllTeamsChangeListener',
	        value: function addAllTeamsChangeListener(callback) {
	            this.on(ALL_TEAMS_EVENT, callback);
	        }
	    }, {
	        key: 'removeAllTeamsChangeListener',
	        value: function removeAllTeamsChangeListener(callback) {
	            this.removeListener(ALL_TEAMS_EVENT, callback);
	        }
	    }, {
	        key: 'getLogs',
	        value: function getLogs() {
	            return this.logs;
	        }
	    }, {
	        key: 'saveLogs',
	        value: function saveLogs(logs) {
	            this.logs = logs;
	        }
	    }, {
	        key: 'getAudits',
	        value: function getAudits() {
	            return this.audits;
	        }
	    }, {
	        key: 'saveAudits',
	        value: function saveAudits(audits) {
	            this.audits = audits;
	        }
	    }, {
	        key: 'getComplianceReports',
	        value: function getComplianceReports() {
	            return this.complianceReports;
	        }
	    }, {
	        key: 'saveComplianceReports',
	        value: function saveComplianceReports(complianceReports) {
	            this.complianceReports = complianceReports;
	        }
	    }, {
	        key: 'getConfig',
	        value: function getConfig() {
	            return this.config;
	        }
	    }, {
	        key: 'saveConfig',
	        value: function saveConfig(config) {
	            this.config = config;
	        }
	    }, {
	        key: 'getAllTeams',
	        value: function getAllTeams() {
	            return this.teams;
	        }
	    }, {
	        key: 'saveAllTeams',
	        value: function saveAllTeams(teams) {
	            this.teams = teams;
	        }
	    }, {
	        key: 'getSelectedTeams',
	        value: function getSelectedTeams() {
	            var result = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_browser_store_jsx__["a"].getItem('seleted_teams');
	            if (!result) {
	                return {};
	            }
	            return result;
	        }
	    }, {
	        key: 'saveSelectedTeams',
	        value: function saveSelectedTeams(teams) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_browser_store_jsx__["a"].setItem('seleted_teams', teams);
	        }
	    }]);
	
	    return AdminStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_events___default.a);
	
	var AdminStore = new AdminStoreClass();
	
	AdminStoreClass.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_LOGS:
	            AdminStore.saveLogs(action.logs);
	            AdminStore.emitLogChange();
	            break;
	        case ActionTypes.RECEIVED_SERVER_AUDITS:
	            AdminStore.saveAudits(action.audits);
	            AdminStore.emitAuditChange();
	            break;
	        case ActionTypes.RECEIVED_SERVER_COMPLIANCE_REPORTS:
	            AdminStore.saveComplianceReports(action.complianceReports);
	            AdminStore.emitComplianceReportsChange();
	            break;
	        case ActionTypes.RECEIVED_CONFIG:
	            AdminStore.saveConfig(action.config);
	            AdminStore.emitConfigChange();
	            break;
	        case ActionTypes.RECEIVED_ALL_TEAMS:
	            AdminStore.saveAllTeams(action.teams);
	            AdminStore.emitAllTeamsChange();
	            break;
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = AdminStore;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var asn1 = exports;
	
	asn1.bignum = __webpack_require__(39);
	
	asn1.define = __webpack_require__(1085).define;
	asn1.base = __webpack_require__(162);
	asn1.constants = __webpack_require__(456);
	asn1.decoders = __webpack_require__(1089);
	asn1.encoders = __webpack_require__(1091);
	


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(65)
	  , toLength  = __webpack_require__(45)
	  , toIndex   = __webpack_require__(122);
	module.e = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var global            = __webpack_require__(29)
	  , $export           = __webpack_require__(9)
	  , redefine          = __webpack_require__(63)
	  , redefineAll       = __webpack_require__(120)
	  , meta              = __webpack_require__(100)
	  , forOf             = __webpack_require__(143)
	  , anInstance        = __webpack_require__(99)
	  , isObject          = __webpack_require__(34)
	  , fails             = __webpack_require__(31)
	  , $iterDetect       = __webpack_require__(199)
	  , setToStringTag    = __webpack_require__(144)
	  , inheritIfRequired = __webpack_require__(259);
	
	module.e = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var hide     = __webpack_require__(56)
	  , redefine = __webpack_require__(63)
	  , fails    = __webpack_require__(31)
	  , defined  = __webpack_require__(75)
	  , wks      = __webpack_require__(35);
	
	module.e = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(24);
	module.e = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.e = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(34)
	  , cof      = __webpack_require__(74)
	  , MATCH    = __webpack_require__(35)('match');
	module.e = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ITERATOR     = __webpack_require__(35)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.e = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Forced replacement prototype accessors methods
	module.e = __webpack_require__(116)|| !__webpack_require__(31)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(29)[K];
	});


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(34)
	  , anObject = __webpack_require__(24);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.e = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(90)(Function.call, __webpack_require__(68).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global = __webpack_require__(29)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.e = function(key){
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global = __webpack_require__(29)
	  , hide   = __webpack_require__(56)
	  , uid    = __webpack_require__(123)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.e = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// based on the aes implimentation in triple sec
	// https://github.com/keybase/triplesec
	
	// which is in turn based on the one from crypto-js
	// https://code.google.com/p/crypto-js/
	
	var uint_max = Math.pow(2, 32)
	function fixup_uint32 (x) {
	  var ret, x_pos
	  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x
	  return ret
	}
	function scrub_vec (v) {
	  for (var i = 0; i < v.length; v++) {
	    v[i] = 0
	  }
	  return false
	}
	
	function Global () {
	  this.SBOX = []
	  this.INV_SBOX = []
	  this.SUB_MIX = [[], [], [], []]
	  this.INV_SUB_MIX = [[], [], [], []]
	  this.init()
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
	}
	
	Global.prototype.init = function () {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i
	  d = (function () {
	    var _i, _results
	    _results = []
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1)
	      } else {
	        _results.push((i << 1) ^ 0x11b)
	      }
	    }
	    return _results
	  })()
	  x = 0
	  xi = 0
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
	    this.SBOX[x] = sx
	    this.INV_SBOX[sx] = x
	    x2 = d[x]
	    x4 = d[x2]
	    x8 = d[x4]
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100)
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8)
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16)
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24)
	    this.SUB_MIX[3][x] = t
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
	    this.INV_SUB_MIX[3][sx] = t
	    if (x === 0) {
	      x = xi = 1
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]]
	      xi ^= d[d[xi]]
	    }
	  }
	  return true
	}
	
	var G = new Global()
	
	AES.blockSize = 4 * 4
	
	AES.prototype.blockSize = AES.blockSize
	
	AES.keySize = 256 / 8
	
	AES.prototype.keySize = AES.keySize
	
	function bufferToArray (buf) {
	  var len = buf.length / 4
	  var out = new Array(len)
	  var i = -1
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4)
	  }
	  return out
	}
	function AES (key) {
	  this._key = bufferToArray(key)
	  this._doReset()
	}
	
	AES.prototype._doReset = function () {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t
	  keyWords = this._key
	  keySize = keyWords.length
	  this._nRounds = keySize + 6
	  ksRows = (this._nRounds + 1) * 4
	  this._keySchedule = []
	  for (ksRow = 0; ksRow < ksRows; ksRow++) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t)
	  }
	  this._invKeySchedule = []
	  for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	    ksRow = ksRows - invKsRow
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)]
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]]
	  }
	  return true
	}
	
	AES.prototype.encryptBlock = function (M) {
	  M = bufferToArray(new Buffer(M))
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX)
	  var buf = new Buffer(16)
	  buf.writeUInt32BE(out[0], 0)
	  buf.writeUInt32BE(out[1], 4)
	  buf.writeUInt32BE(out[2], 8)
	  buf.writeUInt32BE(out[3], 12)
	  return buf
	}
	
	AES.prototype.decryptBlock = function (M) {
	  M = bufferToArray(new Buffer(M))
	  var temp = [M[3], M[1]]
	  M[1] = temp[0]
	  M[3] = temp[1]
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX)
	  var buf = new Buffer(16)
	  buf.writeUInt32BE(out[0], 0)
	  buf.writeUInt32BE(out[3], 4)
	  buf.writeUInt32BE(out[2], 8)
	  buf.writeUInt32BE(out[1], 12)
	  return buf
	}
	
	AES.prototype.scrub = function () {
	  scrub_vec(this._keySchedule)
	  scrub_vec(this._invKeySchedule)
	  scrub_vec(this._key)
	}
	
	AES.prototype._doCryptBlock = function (M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, s0, s1, s2, s3, t0, t1, t2, t3
	
	  s0 = M[0] ^ keySchedule[0]
	  s1 = M[1] ^ keySchedule[1]
	  s2 = M[2] ^ keySchedule[2]
	  s3 = M[3] ^ keySchedule[3]
	  ksRow = 4
	  for (var round = 1; round < this._nRounds; round++) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++]
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++]
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++]
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++]
	    s0 = t0
	    s1 = t1
	    s2 = t2
	    s3 = t3
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ]
	}
	
	exports.AES = AES
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	}
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	}
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	}
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	}
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	}
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	}
	exports['aes128'] = exports['aes-128-cbc']
	exports['aes192'] = exports['aes-192-cbc']
	exports['aes256'] = exports['aes-256-cbc']
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	}
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	}
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	}
	exports['aes-128-cfb8'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB8',
	  type: 'stream'
	}
	exports['aes-192-cfb8'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB8',
	  type: 'stream'
	}
	exports['aes-256-cfb8'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB8',
	  type: 'stream'
	}
	exports['aes-128-cfb1'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB1',
	  type: 'stream'
	}
	exports['aes-192-cfb1'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB1',
	  type: 'stream'
	}
	exports['aes-256-cfb1'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB1',
	  type: 'stream'
	}
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	}
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	}
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	}
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	}
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	}
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	}
	exports['aes-128-gcm'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 12,
	  mode: 'GCM',
	  type: 'auth'
	}
	exports['aes-192-gcm'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 12,
	  mode: 'GCM',
	  type: 'auth'
	}
	exports['aes-256-gcm'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 12,
	  mode: 'GCM',
	  type: 'auth'
	}
	


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var xor = __webpack_require__(165)
	
	function incr32 (iv) {
	  var len = iv.length
	  var item
	  while (len--) {
	    item = iv.readUInt8(len)
	    if (item === 255) {
	      iv.writeUInt8(0, len)
	    } else {
	      item++
	      iv.writeUInt8(item, len)
	      break
	    }
	  }
	}
	
	function getBlock (self) {
	  var out = self._cipher.encryptBlock(self._prev)
	  incr32(self._prev)
	  return out
	}
	
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)])
	  }
	  var pad = self._cache.slice(0, chunk.length)
	  self._cache = self._cache.slice(chunk.length)
	  return xor(chunk, pad)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 209 */
75,
/* 210 */
53,
/* 211 */
34,
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var def = __webpack_require__(43).setDesc
	  , has = __webpack_require__(210)
	  , TAG = __webpack_require__(86)('toStringTag');
	
	module.e = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(209);
	module.e = function(it){
	  return Object(defined(it));
	};


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1343);
	var Iterators = __webpack_require__(148);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict'
	
	exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(175)
	exports.createHash = exports.Hash = __webpack_require__(149)
	exports.createHmac = exports.Hmac = __webpack_require__(291)
	
	var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(Object.keys(__webpack_require__(500)))
	exports.getHashes = function () {
	  return hashes
	}
	
	var p = __webpack_require__(550)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	
	var aes = __webpack_require__(1303)
	;[
	  'Cipher',
	  'createCipher',
	  'Cipheriv',
	  'createCipheriv',
	  'Decipher',
	  'createDecipher',
	  'Decipheriv',
	  'createDecipheriv',
	  'getCiphers',
	  'listCiphers'
	].forEach(function (key) {
	  exports[key] = aes[key]
	})
	
	var dh = __webpack_require__(1366)
	;[
	  'DiffieHellmanGroup',
	  'createDiffieHellmanGroup',
	  'getDiffieHellman',
	  'createDiffieHellman',
	  'DiffieHellman'
	].forEach(function (key) {
	  exports[key] = dh[key]
	})
	
	var sign = __webpack_require__(1306)
	;[
	  'createSign',
	  'Sign',
	  'createVerify',
	  'Verify'
	].forEach(function (key) {
	  exports[key] = sign[key]
	})
	
	exports.createECDH = __webpack_require__(1356)
	
	var publicEncrypt = __webpack_require__(1546)
	
	;[
	  'publicEncrypt',
	  'privateEncrypt',
	  'publicDecrypt',
	  'privateDecrypt'
	].forEach(function (key) {
	  exports[key] = publicEncrypt[key]
	})
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	;[
	  'createCredentials'
	].forEach(function (name) {
	  exports[name] = function () {
	    throw new Error([
	      'sorry, ' + name + ' is not implemented yet',
	      'we accept pull requests',
	      'https://github.com/crypto-browserify/crypto-browserify'
	    ].join('\n'))
	  }
	})
	


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var camelize = __webpack_require__(524),
	    hyphenate = __webpack_require__(1382),
	    _getComputedStyle = __webpack_require__(1377),
	    removeStyle = __webpack_require__(1378);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.e = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var curve = exports;
	
	curve.base = __webpack_require__(1383);
	curve.short = __webpack_require__(1386);
	curve.mont = __webpack_require__(1385);
	curve.edwards = __webpack_require__(1384);
	


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var md5 = __webpack_require__(516)
	module.e = EVP_BytesToKey
	function EVP_BytesToKey (password, salt, keyLen, ivLen) {
	  if (!Buffer.isBuffer(password)) {
	    password = new Buffer(password, 'binary')
	  }
	  if (salt && !Buffer.isBuffer(salt)) {
	    salt = new Buffer(salt, 'binary')
	  }
	  keyLen = keyLen / 8
	  ivLen = ivLen || 0
	  var ki = 0
	  var ii = 0
	  var key = new Buffer(keyLen)
	  var iv = new Buffer(ivLen)
	  var addmd = 0
	  var md_buf
	  var i
	  var bufs = []
	  while (true) {
	    if (addmd++ > 0) {
	      bufs.push(md_buf)
	    }
	    bufs.push(password)
	    if (salt) {
	      bufs.push(salt)
	    }
	    md_buf = md5(Buffer.concat(bufs))
	    bufs = []
	    i = 0
	    if (keyLen > 0) {
	      while (true) {
	        if (keyLen === 0) {
	          break
	        }
	        if (i === md_buf.length) {
	          break
	        }
	        key[ki++] = md_buf[i]
	        keyLen--
	        i++
	      }
	    }
	    if (ivLen > 0 && i !== md_buf.length) {
	      while (true) {
	        if (ivLen === 0) {
	          break
	        }
	        if (i === md_buf.length) {
	          break
	        }
	        iv[ii++] = md_buf[i]
	        ivLen--
	        i++
	      }
	    }
	    if (keyLen === 0 && ivLen === 0) {
	      break
	    }
	  }
	  for (i = 0; i < md_buf.length; i++) {
	    md_buf[i] = 0
	  }
	  return {
	    key: key,
	    iv: iv
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1549);
	
	var _runTransitionHook = __webpack_require__(296);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(129);
	
	var _deprecate = __webpack_require__(295);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.e = exports['default'];


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isNative = __webpack_require__(1520);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.e = getNative;
	


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseFlatten = __webpack_require__(534),
	    bindCallback = __webpack_require__(298),
	    pickByArray = __webpack_require__(544),
	    pickByCallback = __webpack_require__(545),
	    restParam = __webpack_require__(533);
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it's invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.e = pick;
	


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var asn1 = __webpack_require__(1526)
	var aesid = __webpack_require__(1756)
	var fixProc = __webpack_require__(1527)
	var ciphers = __webpack_require__(279)
	var compat = __webpack_require__(550)
	module.e = parseKeys
	
	function parseKeys (buffer) {
	  var password
	  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
	    password = buffer.passphrase
	    buffer = buffer.key
	  }
	  if (typeof buffer === 'string') {
	    buffer = new Buffer(buffer)
	  }
	
	  var stripped = fixProc(buffer, password)
	
	  var type = stripped.tag
	  var data = stripped.data
	  var subtype, ndata
	  switch (type) {
	    case 'PUBLIC KEY':
	      ndata = asn1.PublicKey.decode(data, 'der')
	      subtype = ndata.algorithm.algorithm.join('.')
	      switch (subtype) {
	        case '1.2.840.113549.1.1.1':
	          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
	        case '1.2.840.10045.2.1':
	          ndata.subjectPrivateKey = ndata.subjectPublicKey
	          return {
	            type: 'ec',
	            data: ndata
	          }
	        case '1.2.840.10040.4.1':
	          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
	          return {
	            type: 'dsa',
	            data: ndata.algorithm.params
	          }
	        default: throw new Error('unknown key id ' + subtype)
	      }
	      throw new Error('unknown key type ' + type)
	    case 'ENCRYPTED PRIVATE KEY':
	      data = asn1.EncryptedPrivateKey.decode(data, 'der')
	      data = decrypt(data, password)
	      // falls through
	    case 'PRIVATE KEY':
	      ndata = asn1.PrivateKey.decode(data, 'der')
	      subtype = ndata.algorithm.algorithm.join('.')
	      switch (subtype) {
	        case '1.2.840.113549.1.1.1':
	          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
	        case '1.2.840.10045.2.1':
	          return {
	            curve: ndata.algorithm.curve,
	            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
	          }
	        case '1.2.840.10040.4.1':
	          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
	          return {
	            type: 'dsa',
	            params: ndata.algorithm.params
	          }
	        default: throw new Error('unknown key id ' + subtype)
	      }
	      throw new Error('unknown key type ' + type)
	    case 'RSA PUBLIC KEY':
	      return asn1.RSAPublicKey.decode(data, 'der')
	    case 'RSA PRIVATE KEY':
	      return asn1.RSAPrivateKey.decode(data, 'der')
	    case 'DSA PRIVATE KEY':
	      return {
	        type: 'dsa',
	        params: asn1.DSAPrivateKey.decode(data, 'der')
	      }
	    case 'EC PRIVATE KEY':
	      data = asn1.ECPrivateKey.decode(data, 'der')
	      return {
	        curve: data.parameters.value,
	        privateKey: data.privateKey
	      }
	    default: throw new Error('unknown key type ' + type)
	  }
	}
	parseKeys.signature = asn1.signature
	function decrypt (data, password) {
	  var salt = data.algorithm.decrypt.kde.kdeparams.salt
	  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
	  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
	  var iv = data.algorithm.decrypt.cipher.iv
	  var cipherText = data.subjectPrivateKey
	  var keylen = parseInt(algo.split('-')[1], 10) / 8
	  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
	  var cipher = ciphers.createDecipheriv(algo, key, iv)
	  var out = []
	  out.push(cipher.update(cipherText))
	  out.push(cipher.final())
	  return Buffer.concat(out)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	function oldAdd(element, className) {
	  var classes = element.className.split(' ');
	  if (classes.indexOf(className) < 0) {
	    classes.push(className);
	  }
	  element.className = classes.join(' ');
	}
	
	function oldRemove(element, className) {
	  var classes = element.className.split(' ');
	  var idx = classes.indexOf(className);
	  if (idx >= 0) {
	    classes.splice(idx, 1);
	  }
	  element.className = classes.join(' ');
	}
	
	exports.add = function (element, className) {
	  if (element.classList) {
	    element.classList.add(className);
	  } else {
	    oldAdd(element, className);
	  }
	};
	
	exports.remove = function (element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else {
	    oldRemove(element, className);
	  }
	};
	
	exports.list = function (element) {
	  if (element.classList) {
	    return Array.prototype.slice.apply(element.classList);
	  } else {
	    return element.className.split(' ');
	  }
	};
	


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domHelpersActiveElement = __webpack_require__(519);
	
	var _domHelpersActiveElement2 = _interopRequireDefault(_domHelpersActiveElement);
	
	var _domHelpersQueryContains = __webpack_require__(173);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _keycode = __webpack_require__(297);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _lodashCompatCollectionFind = __webpack_require__(1487);
	
	var _lodashCompatCollectionFind2 = _interopRequireDefault(_lodashCompatCollectionFind);
	
	var _lodashCompatObjectOmit = __webpack_require__(304);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactPropTypesLibAll = __webpack_require__(229);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(316);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(623);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _ButtonGroup = __webpack_require__(554);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1562);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(556);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsCustomPropTypes = __webpack_require__(1597);
	
	var _utilsCustomPropTypes2 = _interopRequireDefault(_utilsCustomPropTypes);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var TOGGLE_REF = 'toggle-btn';
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var Dropdown = (function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    _React$Component.call(this, props);
	
	    this.Toggle = _DropdownToggle2['default'];
	
	    this.toggleOpen = this.toggleOpen.bind(this);
	    this.handleClick = this.handleClick.bind(this);
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	    this.handleClose = this.handleClose.bind(this);
	    this.extractChildren = this.extractChildren.bind(this);
	
	    this.refineMenu = this.refineMenu.bind(this);
	    this.refineToggle = this.refineToggle.bind(this);
	
	    this.childExtractors = [{
	      key: 'toggle',
	      matches: function matches(child) {
	        return child.props.bsRole === TOGGLE_ROLE;
	      },
	      refine: this.refineToggle
	    }, {
	      key: 'menu',
	      exclusive: true,
	      matches: function matches(child) {
	        return child.props.bsRole === MENU_ROLE;
	      },
	      refine: this.refineMenu
	    }];
	
	    this.state = {};
	
	    this.lastOpenEventType = null;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = _domHelpersQueryContains2['default'](_reactDom2['default'].findDOMNode(this.refs.menu), _domHelpersActiveElement2['default'](document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.open && !prevProps.open) {
	      this.focusNextOnOpen();
	    }
	
	    if (!this.props.open && prevProps.open) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _rootClasses;
	
	    var children = this.extractChildren();
	    var Component = this.props.componentClass;
	
	    var props = _lodashCompatObjectOmit2['default'](this.props, ['id', 'bsClass', 'role']);
	    var className = _utilsBootstrapUtils2['default'].prefix(this.props);
	
	    var rootClasses = (_rootClasses = {
	      open: this.props.open,
	      disabled: this.props.disabled
	    }, _rootClasses[className] = !this.props.dropup, _rootClasses.dropup = this.props.dropup, _rootClasses);
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, rootClasses)
	      }),
	      children
	    );
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen() {
	    var eventType = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventType;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open);
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick() {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen('click');
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen('keydown');
	        } else if (this.refs.menu.focusNext) {
	          this.refs.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event);
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose() {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen();
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.refs.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.refs[TOGGLE_REF]);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.extractChildren = function extractChildren() {
	    var _this = this;
	
	    var open = !!this.props.open;
	    var seen = {};
	
	    return _utilsValidComponentChildren2['default'].map(this.props.children, function (child) {
	      var extractor = _lodashCompatCollectionFind2['default'](_this.childExtractors, function (x) {
	        return x.matches(child);
	      });
	
	      if (extractor) {
	        if (seen[extractor.key]) {
	          return false;
	        }
	
	        seen[extractor.key] = extractor.exclusive;
	        child = extractor.refine(child, open);
	      }
	
	      return child;
	    });
	  };
	
	  Dropdown.prototype.refineMenu = function refineMenu(menu, open) {
	    var menuProps = {
	      ref: 'menu',
	      open: open,
	      labelledBy: this.props.id,
	      pullRight: this.props.pullRight,
	      bsClass: this.props.bsClass
	    };
	
	    menuProps.onClose = _utilsCreateChainedFunction2['default'](menu.props.onClose, this.props.onClose, this.handleClose);
	
	    menuProps.onSelect = _utilsCreateChainedFunction2['default'](menu.props.onSelect, this.props.onSelect, this.handleClose);
	
	    return _react.cloneElement(menu, menuProps, menu.props.children);
	  };
	
	  Dropdown.prototype.refineToggle = function refineToggle(toggle, open) {
	    var toggleProps = {
	      open: open,
	      id: this.props.id,
	      ref: TOGGLE_REF,
	      role: this.props.role
	    };
	
	    toggleProps.onClick = _utilsCreateChainedFunction2['default'](toggle.props.onClick, this.handleClick);
	
	    toggleProps.onKeyDown = _utilsCreateChainedFunction2['default'](toggle.props.onKeyDown, this.handleKeyDown);
	
	    return _react.cloneElement(toggle, toggleProps, toggle.props.children);
	  };
	
	  return Dropdown;
	})(_react2['default'].Component);
	
	Dropdown.Toggle = _DropdownToggle2['default'];
	
	Dropdown.TOGGLE_REF = TOGGLE_REF;
	Dropdown.TOGGLE_ROLE = TOGGLE_ROLE;
	Dropdown.MENU_ROLE = MENU_ROLE;
	
	Dropdown.defaultProps = {
	  componentClass: _ButtonGroup2['default'],
	  bsClass: 'dropdown'
	};
	
	Dropdown.propTypes = {
	
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2['default'].PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  componentClass: _reactPropTypesLibElementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle/>` or a `<Dropdown.Menu/>`.
	   * @type {node}
	   */
	  children: _reactPropTypesLibAll2['default'](_utilsCustomPropTypes2['default'].requiredRoles(TOGGLE_ROLE, MENU_ROLE), _utilsCustomPropTypes2['default'].exclusiveRoles(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * function(Object event, Any eventKey)
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	Dropdown = _uncontrollable2['default'](Dropdown, { open: 'onToggle' });
	
	Dropdown.Toggle = _DropdownToggle2['default'];
	Dropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = Dropdown;
	module.e = exports['default'];


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = undefined;
	
	  if (typeof oldname === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? _warning2['default'](false, message) : undefined;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return (function (_Component) {
	    _inherits(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      _classCallCheck(this, DeprecatedComponent);
	
	      _Component.apply(this, arguments);
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$componentWillMount;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$componentWillMount = _Component.prototype.componentWillMount).call.apply(_Component$prototype$componentWillMount, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  })(Component);
	};
	
	exports['default'] = deprecationWarning;
	module.e = exports['default'];


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = all;
	
	var _common = __webpack_require__(315);
	
	function all() {
	  for (var _len = arguments.length, propTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    propTypes[_key] = arguments[_key];
	  }
	
	  if (propTypes === undefined) {
	    throw new Error('No validations provided');
	  }
	
	  if (propTypes.some(function (propType) {
	    return typeof propType !== 'function';
	  })) {
	    throw new Error('Invalid arguments, must be functions');
	  }
	
	  if (propTypes.length === 0) {
	    throw new Error('No validations provided');
	  }
	
	  function validate(props, propName, componentName) {
	    for (var i = 0; i < propTypes.length; i++) {
	      var result = propTypes[i](props, propName, componentName);
	
	      if (result !== undefined && result !== null) {
	        return result;
	      }
	    }
	  }
	
	  return _common.createChainableTypeChecker(validate);
	}
	
	module.e = exports['default'];


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventPluginHub = __webpack_require__(179);
	var EventPluginRegistry = __webpack_require__(587);
	var ReactEventEmitterMixin = __webpack_require__(1667);
	var ReactPerf = __webpack_require__(78);
	var ViewportMetrics = __webpack_require__(608);
	
	var assign = __webpack_require__(32);
	var isEventSupported = __webpack_require__(334);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.e = ReactBrowserEventEmitter;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.e = ReactPropTypeLocationNames;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(238);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.e = ReactPropTypeLocations;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(182);
	var ViewportMetrics = __webpack_require__(608);
	
	var getEventModifierState = __webpack_require__(330);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.e = SyntheticMouseEvent;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.e = Transaction;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.e = canDefineProperty;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.e = escapeTextContentForBrowser;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.e = setInnerHTML;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.e = keyMirror;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This file contains information and classes for the various kinds of styles
	 * used in TeX. It provides a generic `Style` class, which holds information
	 * about a specific style. It then provides instances of all the different kinds
	 * of styles possible, and provides functions to move between them and get
	 * information about them.
	 */
	
	/**
	 * The main style class. Contains a unique id for the style, a size (which is
	 * the same for cramped and uncramped version of a style), a cramped flag, and a
	 * size multiplier, which gives the size difference between a style and
	 * textstyle.
	 */
	function Style(id, size, multiplier, cramped) {
	    this.id = id;
	    this.size = size;
	    this.cramped = cramped;
	    this.sizeMultiplier = multiplier;
	}
	
	/**
	 * Get the style of a superscript given a base in the current style.
	 */
	Style.prototype.sup = function() {
	    return styles[sup[this.id]];
	};
	
	/**
	 * Get the style of a subscript given a base in the current style.
	 */
	Style.prototype.sub = function() {
	    return styles[sub[this.id]];
	};
	
	/**
	 * Get the style of a fraction numerator given the fraction in the current
	 * style.
	 */
	Style.prototype.fracNum = function() {
	    return styles[fracNum[this.id]];
	};
	
	/**
	 * Get the style of a fraction denominator given the fraction in the current
	 * style.
	 */
	Style.prototype.fracDen = function() {
	    return styles[fracDen[this.id]];
	};
	
	/**
	 * Get the cramped version of a style (in particular, cramping a cramped style
	 * doesn't change the style).
	 */
	Style.prototype.cramp = function() {
	    return styles[cramp[this.id]];
	};
	
	/**
	 * HTML class name, like "displaystyle cramped"
	 */
	Style.prototype.cls = function() {
	    return sizeNames[this.size] + (this.cramped ? " cramped" : " uncramped");
	};
	
	/**
	 * HTML Reset class name, like "reset-textstyle"
	 */
	Style.prototype.reset = function() {
	    return resetNames[this.size];
	};
	
	// IDs of the different styles
	var D = 0;
	var Dc = 1;
	var T = 2;
	var Tc = 3;
	var S = 4;
	var Sc = 5;
	var SS = 6;
	var SSc = 7;
	
	// String names for the different sizes
	var sizeNames = [
	    "displaystyle textstyle",
	    "textstyle",
	    "scriptstyle",
	    "scriptscriptstyle",
	];
	
	// Reset names for the different sizes
	var resetNames = [
	    "reset-textstyle",
	    "reset-textstyle",
	    "reset-scriptstyle",
	    "reset-scriptscriptstyle",
	];
	
	// Instances of the different styles
	var styles = [
	    new Style(D, 0, 1.0, false),
	    new Style(Dc, 0, 1.0, true),
	    new Style(T, 1, 1.0, false),
	    new Style(Tc, 1, 1.0, true),
	    new Style(S, 2, 0.7, false),
	    new Style(Sc, 2, 0.7, true),
	    new Style(SS, 3, 0.5, false),
	    new Style(SSc, 3, 0.5, true),
	];
	
	// Lookup tables for switching from one style to another
	var sup = [S, Sc, S, Sc, SS, SSc, SS, SSc];
	var sub = [Sc, Sc, Sc, Sc, SSc, SSc, SSc, SSc];
	var fracNum = [T, Tc, S, Sc, SS, SSc, SS, SSc];
	var fracDen = [Tc, Tc, Sc, Sc, SSc, SSc, SSc, SSc];
	var cramp = [Dc, Dc, Tc, Tc, Sc, Sc, SSc, SSc];
	
	// We only export some of the styles. Also, we don't export the `Style` class so
	// no more styles can be generated.
	module.e = {
	    DISPLAY: styles[D],
	    TEXT: styles[T],
	    SCRIPT: styles[S],
	    SCRIPTSCRIPT: styles[SS],
	};
	


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint no-console:0 */
	/**
	 * This module contains general functions that can be used for building
	 * different kinds of domTree nodes in a consistent manner.
	 */
	
	var domTree = __webpack_require__(625);
	var fontMetrics = __webpack_require__(184);
	var symbols = __webpack_require__(241);
	var utils = __webpack_require__(97);
	
	var greekCapitals = [
	    "\\Gamma",
	    "\\Delta",
	    "\\Theta",
	    "\\Lambda",
	    "\\Xi",
	    "\\Pi",
	    "\\Sigma",
	    "\\Upsilon",
	    "\\Phi",
	    "\\Psi",
	    "\\Omega",
	];
	
	var dotlessLetters = [
	    "\u0131",   // dotless i, \imath
	    "\u0237",   // dotless j, \jmath
	];
	
	/**
	 * Makes a symbolNode after translation via the list of symbols in symbols.js.
	 * Correctly pulls out metrics for the character, and optionally takes a list of
	 * classes to be attached to the node.
	 */
	var makeSymbol = function(value, style, mode, color, classes) {
	    // Replace the value with its replaced value from symbol.js
	    if (symbols[mode][value] && symbols[mode][value].replace) {
	        value = symbols[mode][value].replace;
	    }
	
	    var metrics = fontMetrics.getCharacterMetrics(value, style);
	
	    var symbolNode;
	    if (metrics) {
	        symbolNode = new domTree.symbolNode(
	            value, metrics.height, metrics.depth, metrics.italic, metrics.skew,
	            classes);
	    } else {
	        // TODO(emily): Figure out a good way to only print this in development
	        typeof console !== "undefined" && console.warn(
	            "No character metrics for '" + value + "' in style '" +
	                style + "'");
	        symbolNode = new domTree.symbolNode(value, 0, 0, 0, 0, classes);
	    }
	
	    if (color) {
	        symbolNode.style.color = color;
	    }
	
	    return symbolNode;
	};
	
	/**
	 * Makes a symbol in Main-Regular or AMS-Regular.
	 * Used for rel, bin, open, close, inner, and punct.
	 */
	var mathsym = function(value, mode, color, classes) {
	    // Decide what font to render the symbol in by its entry in the symbols
	    // table.
	    // Have a special case for when the value = \ because the \ is used as a
	    // textord in unsupported command errors but cannot be parsed as a regular
	    // text ordinal and is therefore not present as a symbol in the symbols
	    // table for text
	    if (value === "\\" || symbols[mode][value].font === "main") {
	        return makeSymbol(value, "Main-Regular", mode, color, classes);
	    } else {
	        return makeSymbol(
	            value, "AMS-Regular", mode, color, classes.concat(["amsrm"]));
	    }
	};
	
	/**
	 * Makes a symbol in the default font for mathords and textords.
	 */
	var mathDefault = function(value, mode, color, classes, type) {
	    if (type === "mathord") {
	        return mathit(value, mode, color, classes);
	    } else if (type === "textord") {
	        return makeSymbol(
	            value, "Main-Regular", mode, color, classes.concat(["mathrm"]));
	    } else {
	        throw new Error("unexpected type: " + type + " in mathDefault");
	    }
	};
	
	/**
	 * Makes a symbol in the italic math font.
	 */
	var mathit = function(value, mode, color, classes) {
	    if (/[0-9]/.test(value.charAt(0)) ||
	            // glyphs for \imath and \jmath do not exist in Math-Italic so we
	            // need to use Main-Italic instead
	            utils.contains(dotlessLetters, value) ||
	            utils.contains(greekCapitals, value)) {
	        return makeSymbol(
	            value, "Main-Italic", mode, color, classes.concat(["mainit"]));
	    } else {
	        return makeSymbol(
	            value, "Math-Italic", mode, color, classes.concat(["mathit"]));
	    }
	};
	
	/**
	 * Makes either a mathord or textord in the correct font and color.
	 */
	var makeOrd = function(group, options, type) {
	    var mode = group.mode;
	    var value = group.value;
	    if (symbols[mode][value] && symbols[mode][value].replace) {
	        value = symbols[mode][value].replace;
	    }
	
	    var classes = ["mord"];
	    var color = options.getColor();
	
	    var font = options.font;
	    if (font) {
	        if (font === "mathit" || utils.contains(dotlessLetters, value)) {
	            return mathit(value, mode, color, classes);
	        } else {
	            var fontName = fontMap[font].fontName;
	            if (fontMetrics.getCharacterMetrics(value, fontName)) {
	                return makeSymbol(
	                    value, fontName, mode, color, classes.concat([font]));
	            } else {
	                return mathDefault(value, mode, color, classes, type);
	            }
	        }
	    } else {
	        return mathDefault(value, mode, color, classes, type);
	    }
	};
	
	/**
	 * Calculate the height, depth, and maxFontSize of an element based on its
	 * children.
	 */
	var sizeElementFromChildren = function(elem) {
	    var height = 0;
	    var depth = 0;
	    var maxFontSize = 0;
	
	    if (elem.children) {
	        for (var i = 0; i < elem.children.length; i++) {
	            if (elem.children[i].height > height) {
	                height = elem.children[i].height;
	            }
	            if (elem.children[i].depth > depth) {
	                depth = elem.children[i].depth;
	            }
	            if (elem.children[i].maxFontSize > maxFontSize) {
	                maxFontSize = elem.children[i].maxFontSize;
	            }
	        }
	    }
	
	    elem.height = height;
	    elem.depth = depth;
	    elem.maxFontSize = maxFontSize;
	};
	
	/**
	 * Makes a span with the given list of classes, list of children, and color.
	 */
	var makeSpan = function(classes, children, color) {
	    var span = new domTree.span(classes, children);
	
	    sizeElementFromChildren(span);
	
	    if (color) {
	        span.style.color = color;
	    }
	
	    return span;
	};
	
	/**
	 * Makes a document fragment with the given list of children.
	 */
	var makeFragment = function(children) {
	    var fragment = new domTree.documentFragment(children);
	
	    sizeElementFromChildren(fragment);
	
	    return fragment;
	};
	
	/**
	 * Makes an element placed in each of the vlist elements to ensure that each
	 * element has the same max font size. To do this, we create a zero-width space
	 * with the correct font size.
	 */
	var makeFontSizer = function(options, fontSize) {
	    var fontSizeInner = makeSpan([], [new domTree.symbolNode("\u200b")]);
	    fontSizeInner.style.fontSize =
	        (fontSize / options.style.sizeMultiplier) + "em";
	
	    var fontSizer = makeSpan(
	        ["fontsize-ensurer", "reset-" + options.size, "size5"],
	        [fontSizeInner]);
	
	    return fontSizer;
	};
	
	/**
	 * Makes a vertical list by stacking elements and kerns on top of each other.
	 * Allows for many different ways of specifying the positioning method.
	 *
	 * Arguments:
	 *  - children: A list of child or kern nodes to be stacked on top of each other
	 *              (i.e. the first element will be at the bottom, and the last at
	 *              the top). Element nodes are specified as
	 *                {type: "elem", elem: node}
	 *              while kern nodes are specified as
	 *                {type: "kern", size: size}
	 *  - positionType: The method by which the vlist should be positioned. Valid
	 *                  values are:
	 *                   - "individualShift": The children list only contains elem
	 *                                        nodes, and each node contains an extra
	 *                                        "shift" value of how much it should be
	 *                                        shifted (note that shifting is always
	 *                                        moving downwards). positionData is
	 *                                        ignored.
	 *                   - "top": The positionData specifies the topmost point of
	 *                            the vlist (note this is expected to be a height,
	 *                            so positive values move up)
	 *                   - "bottom": The positionData specifies the bottommost point
	 *                               of the vlist (note this is expected to be a
	 *                               depth, so positive values move down
	 *                   - "shift": The vlist will be positioned such that its
	 *                              baseline is positionData away from the baseline
	 *                              of the first child. Positive values move
	 *                              downwards.
	 *                   - "firstBaseline": The vlist will be positioned such that
	 *                                      its baseline is aligned with the
	 *                                      baseline of the first child.
	 *                                      positionData is ignored. (this is
	 *                                      equivalent to "shift" with
	 *                                      positionData=0)
	 *  - positionData: Data used in different ways depending on positionType
	 *  - options: An Options object
	 *
	 */
	var makeVList = function(children, positionType, positionData, options) {
	    var depth;
	    var currPos;
	    var i;
	    if (positionType === "individualShift") {
	        var oldChildren = children;
	        children = [oldChildren[0]];
	
	        // Add in kerns to the list of children to get each element to be
	        // shifted to the correct specified shift
	        depth = -oldChildren[0].shift - oldChildren[0].elem.depth;
	        currPos = depth;
	        for (i = 1; i < oldChildren.length; i++) {
	            var diff = -oldChildren[i].shift - currPos -
	                oldChildren[i].elem.depth;
	            var size = diff -
	                (oldChildren[i - 1].elem.height +
	                 oldChildren[i - 1].elem.depth);
	
	            currPos = currPos + diff;
	
	            children.push({type: "kern", size: size});
	            children.push(oldChildren[i]);
	        }
	    } else if (positionType === "top") {
	        // We always start at the bottom, so calculate the bottom by adding up
	        // all the sizes
	        var bottom = positionData;
	        for (i = 0; i < children.length; i++) {
	            if (children[i].type === "kern") {
	                bottom -= children[i].size;
	            } else {
	                bottom -= children[i].elem.height + children[i].elem.depth;
	            }
	        }
	        depth = bottom;
	    } else if (positionType === "bottom") {
	        depth = -positionData;
	    } else if (positionType === "shift") {
	        depth = -children[0].elem.depth - positionData;
	    } else if (positionType === "firstBaseline") {
	        depth = -children[0].elem.depth;
	    } else {
	        depth = 0;
	    }
	
	    // Make the fontSizer
	    var maxFontSize = 0;
	    for (i = 0; i < children.length; i++) {
	        if (children[i].type === "elem") {
	            maxFontSize = Math.max(maxFontSize, children[i].elem.maxFontSize);
	        }
	    }
	    var fontSizer = makeFontSizer(options, maxFontSize);
	
	    // Create a new list of actual children at the correct offsets
	    var realChildren = [];
	    currPos = depth;
	    for (i = 0; i < children.length; i++) {
	        if (children[i].type === "kern") {
	            currPos += children[i].size;
	        } else {
	            var child = children[i].elem;
	
	            var shift = -child.depth - currPos;
	            currPos += child.height + child.depth;
	
	            var childWrap = makeSpan([], [fontSizer, child]);
	            childWrap.height -= shift;
	            childWrap.depth += shift;
	            childWrap.style.top = shift + "em";
	
	            realChildren.push(childWrap);
	        }
	    }
	
	    // Add in an element at the end with no offset to fix the calculation of
	    // baselines in some browsers (namely IE, sometimes safari)
	    var baselineFix = makeSpan(
	        ["baseline-fix"], [fontSizer, new domTree.symbolNode("\u200b")]);
	    realChildren.push(baselineFix);
	
	    var vlist = makeSpan(["vlist"], realChildren);
	    // Fix the final height and depth, in case there were kerns at the ends
	    // since the makeSpan calculation won't take that in to account.
	    vlist.height = Math.max(currPos, vlist.height);
	    vlist.depth = Math.max(-depth, vlist.depth);
	    return vlist;
	};
	
	// A table of size -> font size for the different sizing functions
	var sizingMultiplier = {
	    size1: 0.5,
	    size2: 0.7,
	    size3: 0.8,
	    size4: 0.9,
	    size5: 1.0,
	    size6: 1.2,
	    size7: 1.44,
	    size8: 1.73,
	    size9: 2.07,
	    size10: 2.49,
	};
	
	// A map of spacing functions to their attributes, like size and corresponding
	// CSS class
	var spacingFunctions = {
	    "\\qquad": {
	        size: "2em",
	        className: "qquad",
	    },
	    "\\quad": {
	        size: "1em",
	        className: "quad",
	    },
	    "\\enspace": {
	        size: "0.5em",
	        className: "enspace",
	    },
	    "\\;": {
	        size: "0.277778em",
	        className: "thickspace",
	    },
	    "\\:": {
	        size: "0.22222em",
	        className: "mediumspace",
	    },
	    "\\,": {
	        size: "0.16667em",
	        className: "thinspace",
	    },
	    "\\!": {
	        size: "-0.16667em",
	        className: "negativethinspace",
	    },
	};
	
	/**
	 * Maps TeX font commands to objects containing:
	 * - variant: string used for "mathvariant" attribute in buildMathML.js
	 * - fontName: the "style" parameter to fontMetrics.getCharacterMetrics
	 */
	// A map between tex font commands an MathML mathvariant attribute values
	var fontMap = {
	    // styles
	    "mathbf": {
	        variant: "bold",
	        fontName: "Main-Bold",
	    },
	    "mathrm": {
	        variant: "normal",
	        fontName: "Main-Regular",
	    },
	
	    // "mathit" is missing because it requires the use of two fonts: Main-Italic
	    // and Math-Italic.  This is handled by a special case in makeOrd which ends
	    // up calling mathit.
	
	    // families
	    "mathbb": {
	        variant: "double-struck",
	        fontName: "AMS-Regular",
	    },
	    "mathcal": {
	        variant: "script",
	        fontName: "Caligraphic-Regular",
	    },
	    "mathfrak": {
	        variant: "fraktur",
	        fontName: "Fraktur-Regular",
	    },
	    "mathscr": {
	        variant: "script",
	        fontName: "Script-Regular",
	    },
	    "mathsf": {
	        variant: "sans-serif",
	        fontName: "SansSerif-Regular",
	    },
	    "mathtt": {
	        variant: "monospace",
	        fontName: "Typewriter-Regular",
	    },
	};
	
	module.e = {
	    fontMap: fontMap,
	    makeSymbol: makeSymbol,
	    mathsym: mathsym,
	    makeSpan: makeSpan,
	    makeFragment: makeFragment,
	    makeVList: makeVList,
	    makeOrd: makeOrd,
	    sizingMultiplier: sizingMultiplier,
	    spacingFunctions: spacingFunctions,
	};
	


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This file holds a list of all no-argument functions and single-character
	 * symbols (like 'a' or ';').
	 *
	 * For each of the symbols, there are three properties they can have:
	 * - font (required): the font to be used for this symbol. Either "main" (the
	     normal font), or "ams" (the ams fonts).
	 * - group (required): the ParseNode group type the symbol should have (i.e.
	     "textord", "mathord", etc).
	     See https://github.com/Khan/KaTeX/wiki/Examining-TeX#group-types
	 * - replace: the character that this symbol or function should be
	 *   replaced with (i.e. "\phi" has a replace value of "\u03d5", the phi
	 *   character in the main font).
	 *
	 * The outermost map in the table indicates what mode the symbols should be
	 * accepted in (e.g. "math" or "text").
	 */
	
	module.e = {
	    math: {},
	    text: {},
	};
	
	function defineSymbol(mode, font, group, replace, name) {
	    module.e[mode][name] = {
	        font: font,
	        group: group,
	        replace: replace,
	    };
	}
	
	// Some abbreviations for commonly used strings.
	// This helps minify the code, and also spotting typos using jshint.
	
	// modes:
	var math = "math";
	var text = "text";
	
	// fonts:
	var main = "main";
	var ams = "ams";
	
	// groups:
	var accent = "accent";
	var bin = "bin";
	var close = "close";
	var inner = "inner";
	var mathord = "mathord";
	var op = "op";
	var open = "open";
	var punct = "punct";
	var rel = "rel";
	var spacing = "spacing";
	var textord = "textord";
	
	// Now comes the symbol table
	
	// Relation Symbols
	defineSymbol(math, main, rel, "\u2261", "\\equiv");
	defineSymbol(math, main, rel, "\u227a", "\\prec");
	defineSymbol(math, main, rel, "\u227b", "\\succ");
	defineSymbol(math, main, rel, "\u223c", "\\sim");
	defineSymbol(math, main, rel, "\u22a5", "\\perp");
	defineSymbol(math, main, rel, "\u2aaf", "\\preceq");
	defineSymbol(math, main, rel, "\u2ab0", "\\succeq");
	defineSymbol(math, main, rel, "\u2243", "\\simeq");
	defineSymbol(math, main, rel, "\u2223", "\\mid");
	defineSymbol(math, main, rel, "\u226a", "\\ll");
	defineSymbol(math, main, rel, "\u226b", "\\gg");
	defineSymbol(math, main, rel, "\u224d", "\\asymp");
	defineSymbol(math, main, rel, "\u2225", "\\parallel");
	defineSymbol(math, main, rel, "\u22c8", "\\bowtie");
	defineSymbol(math, main, rel, "\u2323", "\\smile");
	defineSymbol(math, main, rel, "\u2291", "\\sqsubseteq");
	defineSymbol(math, main, rel, "\u2292", "\\sqsupseteq");
	defineSymbol(math, main, rel, "\u2250", "\\doteq");
	defineSymbol(math, main, rel, "\u2322", "\\frown");
	defineSymbol(math, main, rel, "\u220b", "\\ni");
	defineSymbol(math, main, rel, "\u221d", "\\propto");
	defineSymbol(math, main, rel, "\u22a2", "\\vdash");
	defineSymbol(math, main, rel, "\u22a3", "\\dashv");
	defineSymbol(math, main, rel, "\u220b", "\\owns");
	
	// Punctuation
	defineSymbol(math, main, punct, "\u002e", "\\ldotp");
	defineSymbol(math, main, punct, "\u22c5", "\\cdotp");
	
	// Misc Symbols
	defineSymbol(math, main, textord, "\u0023", "\\#");
	defineSymbol(math, main, textord, "\u0026", "\\&");
	defineSymbol(math, main, textord, "\u2135", "\\aleph");
	defineSymbol(math, main, textord, "\u2200", "\\forall");
	defineSymbol(math, main, textord, "\u210f", "\\hbar");
	defineSymbol(math, main, textord, "\u2203", "\\exists");
	defineSymbol(math, main, textord, "\u2207", "\\nabla");
	defineSymbol(math, main, textord, "\u266d", "\\flat");
	defineSymbol(math, main, textord, "\u2113", "\\ell");
	defineSymbol(math, main, textord, "\u266e", "\\natural");
	defineSymbol(math, main, textord, "\u2663", "\\clubsuit");
	defineSymbol(math, main, textord, "\u2118", "\\wp");
	defineSymbol(math, main, textord, "\u266f", "\\sharp");
	defineSymbol(math, main, textord, "\u2662", "\\diamondsuit");
	defineSymbol(math, main, textord, "\u211c", "\\Re");
	defineSymbol(math, main, textord, "\u2661", "\\heartsuit");
	defineSymbol(math, main, textord, "\u2111", "\\Im");
	defineSymbol(math, main, textord, "\u2660", "\\spadesuit");
	
	// Math and Text
	defineSymbol(math, main, textord, "\u2020", "\\dag");
	defineSymbol(math, main, textord, "\u2021", "\\ddag");
	
	// Large Delimiters
	defineSymbol(math, main, close, "\u23b1", "\\rmoustache");
	defineSymbol(math, main, open, "\u23b0", "\\lmoustache");
	defineSymbol(math, main, close, "\u27ef", "\\rgroup");
	defineSymbol(math, main, open, "\u27ee", "\\lgroup");
	
	// Binary Operators
	defineSymbol(math, main, bin, "\u2213", "\\mp");
	defineSymbol(math, main, bin, "\u2296", "\\ominus");
	defineSymbol(math, main, bin, "\u228e", "\\uplus");
	defineSymbol(math, main, bin, "\u2293", "\\sqcap");
	defineSymbol(math, main, bin, "\u2217", "\\ast");
	defineSymbol(math, main, bin, "\u2294", "\\sqcup");
	defineSymbol(math, main, bin, "\u25ef", "\\bigcirc");
	defineSymbol(math, main, bin, "\u2219", "\\bullet");
	defineSymbol(math, main, bin, "\u2021", "\\ddagger");
	defineSymbol(math, main, bin, "\u2240", "\\wr");
	defineSymbol(math, main, bin, "\u2a3f", "\\amalg");
	
	// Arrow Symbols
	defineSymbol(math, main, rel, "\u27f5", "\\longleftarrow");
	defineSymbol(math, main, rel, "\u21d0", "\\Leftarrow");
	defineSymbol(math, main, rel, "\u27f8", "\\Longleftarrow");
	defineSymbol(math, main, rel, "\u27f6", "\\longrightarrow");
	defineSymbol(math, main, rel, "\u21d2", "\\Rightarrow");
	defineSymbol(math, main, rel, "\u27f9", "\\Longrightarrow");
	defineSymbol(math, main, rel, "\u2194", "\\leftrightarrow");
	defineSymbol(math, main, rel, "\u27f7", "\\longleftrightarrow");
	defineSymbol(math, main, rel, "\u21d4", "\\Leftrightarrow");
	defineSymbol(math, main, rel, "\u27fa", "\\Longleftrightarrow");
	defineSymbol(math, main, rel, "\u21a6", "\\mapsto");
	defineSymbol(math, main, rel, "\u27fc", "\\longmapsto");
	defineSymbol(math, main, rel, "\u2197", "\\nearrow");
	defineSymbol(math, main, rel, "\u21a9", "\\hookleftarrow");
	defineSymbol(math, main, rel, "\u21aa", "\\hookrightarrow");
	defineSymbol(math, main, rel, "\u2198", "\\searrow");
	defineSymbol(math, main, rel, "\u21bc", "\\leftharpoonup");
	defineSymbol(math, main, rel, "\u21c0", "\\rightharpoonup");
	defineSymbol(math, main, rel, "\u2199", "\\swarrow");
	defineSymbol(math, main, rel, "\u21bd", "\\leftharpoondown");
	defineSymbol(math, main, rel, "\u21c1", "\\rightharpoondown");
	defineSymbol(math, main, rel, "\u2196", "\\nwarrow");
	defineSymbol(math, main, rel, "\u21cc", "\\rightleftharpoons");
	
	// AMS Negated Binary Relations
	defineSymbol(math, ams, rel, "\u226e", "\\nless");
	defineSymbol(math, ams, rel, "\ue010", "\\nleqslant");
	defineSymbol(math, ams, rel, "\ue011", "\\nleqq");
	defineSymbol(math, ams, rel, "\u2a87", "\\lneq");
	defineSymbol(math, ams, rel, "\u2268", "\\lneqq");
	defineSymbol(math, ams, rel, "\ue00c", "\\lvertneqq");
	defineSymbol(math, ams, rel, "\u22e6", "\\lnsim");
	defineSymbol(math, ams, rel, "\u2a89", "\\lnapprox");
	defineSymbol(math, ams, rel, "\u2280", "\\nprec");
	defineSymbol(math, ams, rel, "\u22e0", "\\npreceq");
	defineSymbol(math, ams, rel, "\u22e8", "\\precnsim");
	defineSymbol(math, ams, rel, "\u2ab9", "\\precnapprox");
	defineSymbol(math, ams, rel, "\u2241", "\\nsim");
	defineSymbol(math, ams, rel, "\ue006", "\\nshortmid");
	defineSymbol(math, ams, rel, "\u2224", "\\nmid");
	defineSymbol(math, ams, rel, "\u22ac", "\\nvdash");
	defineSymbol(math, ams, rel, "\u22ad", "\\nvDash");
	defineSymbol(math, ams, rel, "\u22ea", "\\ntriangleleft");
	defineSymbol(math, ams, rel, "\u22ec", "\\ntrianglelefteq");
	defineSymbol(math, ams, rel, "\u228a", "\\subsetneq");
	defineSymbol(math, ams, rel, "\ue01a", "\\varsubsetneq");
	defineSymbol(math, ams, rel, "\u2acb", "\\subsetneqq");
	defineSymbol(math, ams, rel, "\ue017", "\\varsubsetneqq");
	defineSymbol(math, ams, rel, "\u226f", "\\ngtr");
	defineSymbol(math, ams, rel, "\ue00f", "\\ngeqslant");
	defineSymbol(math, ams, rel, "\ue00e", "\\ngeqq");
	defineSymbol(math, ams, rel, "\u2a88", "\\gneq");
	defineSymbol(math, ams, rel, "\u2269", "\\gneqq");
	defineSymbol(math, ams, rel, "\ue00d", "\\gvertneqq");
	defineSymbol(math, ams, rel, "\u22e7", "\\gnsim");
	defineSymbol(math, ams, rel, "\u2a8a", "\\gnapprox");
	defineSymbol(math, ams, rel, "\u2281", "\\nsucc");
	defineSymbol(math, ams, rel, "\u22e1", "\\nsucceq");
	defineSymbol(math, ams, rel, "\u22e9", "\\succnsim");
	defineSymbol(math, ams, rel, "\u2aba", "\\succnapprox");
	defineSymbol(math, ams, rel, "\u2246", "\\ncong");
	defineSymbol(math, ams, rel, "\ue007", "\\nshortparallel");
	defineSymbol(math, ams, rel, "\u2226", "\\nparallel");
	defineSymbol(math, ams, rel, "\u22af", "\\nVDash");
	defineSymbol(math, ams, rel, "\u22eb", "\\ntriangleright");
	defineSymbol(math, ams, rel, "\u22ed", "\\ntrianglerighteq");
	defineSymbol(math, ams, rel, "\ue018", "\\nsupseteqq");
	defineSymbol(math, ams, rel, "\u228b", "\\supsetneq");
	defineSymbol(math, ams, rel, "\ue01b", "\\varsupsetneq");
	defineSymbol(math, ams, rel, "\u2acc", "\\supsetneqq");
	defineSymbol(math, ams, rel, "\ue019", "\\varsupsetneqq");
	defineSymbol(math, ams, rel, "\u22ae", "\\nVdash");
	defineSymbol(math, ams, rel, "\u2ab5", "\\precneqq");
	defineSymbol(math, ams, rel, "\u2ab6", "\\succneqq");
	defineSymbol(math, ams, rel, "\ue016", "\\nsubseteqq");
	defineSymbol(math, ams, bin, "\u22b4", "\\unlhd");
	defineSymbol(math, ams, bin, "\u22b5", "\\unrhd");
	
	// AMS Negated Arrows
	defineSymbol(math, ams, rel, "\u219a", "\\nleftarrow");
	defineSymbol(math, ams, rel, "\u219b", "\\nrightarrow");
	defineSymbol(math, ams, rel, "\u21cd", "\\nLeftarrow");
	defineSymbol(math, ams, rel, "\u21cf", "\\nRightarrow");
	defineSymbol(math, ams, rel, "\u21ae", "\\nleftrightarrow");
	defineSymbol(math, ams, rel, "\u21ce", "\\nLeftrightarrow");
	
	// AMS Misc
	defineSymbol(math, ams, rel, "\u25b3", "\\vartriangle");
	defineSymbol(math, ams, textord, "\u210f", "\\hslash");
	defineSymbol(math, ams, textord, "\u25bd", "\\triangledown");
	defineSymbol(math, ams, textord, "\u25ca", "\\lozenge");
	defineSymbol(math, ams, textord, "\u24c8", "\\circledS");
	defineSymbol(math, ams, textord, "\u00ae", "\\circledR");
	defineSymbol(math, ams, textord, "\u2221", "\\measuredangle");
	defineSymbol(math, ams, textord, "\u2204", "\\nexists");
	defineSymbol(math, ams, textord, "\u2127", "\\mho");
	defineSymbol(math, ams, textord, "\u2132", "\\Finv");
	defineSymbol(math, ams, textord, "\u2141", "\\Game");
	defineSymbol(math, ams, textord, "\u006b", "\\Bbbk");
	defineSymbol(math, ams, textord, "\u2035", "\\backprime");
	defineSymbol(math, ams, textord, "\u25b2", "\\blacktriangle");
	defineSymbol(math, ams, textord, "\u25bc", "\\blacktriangledown");
	defineSymbol(math, ams, textord, "\u25a0", "\\blacksquare");
	defineSymbol(math, ams, textord, "\u29eb", "\\blacklozenge");
	defineSymbol(math, ams, textord, "\u2605", "\\bigstar");
	defineSymbol(math, ams, textord, "\u2222", "\\sphericalangle");
	defineSymbol(math, ams, textord, "\u2201", "\\complement");
	defineSymbol(math, ams, textord, "\u00f0", "\\eth");
	defineSymbol(math, ams, textord, "\u2571", "\\diagup");
	defineSymbol(math, ams, textord, "\u2572", "\\diagdown");
	defineSymbol(math, ams, textord, "\u25a1", "\\square");
	defineSymbol(math, ams, textord, "\u25a1", "\\Box");
	defineSymbol(math, ams, textord, "\u25ca", "\\Diamond");
	defineSymbol(math, ams, textord, "\u00a5", "\\yen");
	defineSymbol(math, ams, textord, "\u2713", "\\checkmark");
	
	// AMS Hebrew
	defineSymbol(math, ams, textord, "\u2136", "\\beth");
	defineSymbol(math, ams, textord, "\u2138", "\\daleth");
	defineSymbol(math, ams, textord, "\u2137", "\\gimel");
	
	// AMS Greek
	defineSymbol(math, ams, textord, "\u03dd", "\\digamma");
	defineSymbol(math, ams, textord, "\u03f0", "\\varkappa");
	
	// AMS Delimiters
	defineSymbol(math, ams, open, "\u250c", "\\ulcorner");
	defineSymbol(math, ams, close, "\u2510", "\\urcorner");
	defineSymbol(math, ams, open, "\u2514", "\\llcorner");
	defineSymbol(math, ams, close, "\u2518", "\\lrcorner");
	
	// AMS Binary Relations
	defineSymbol(math, ams, rel, "\u2266", "\\leqq");
	defineSymbol(math, ams, rel, "\u2a7d", "\\leqslant");
	defineSymbol(math, ams, rel, "\u2a95", "\\eqslantless");
	defineSymbol(math, ams, rel, "\u2272", "\\lesssim");
	defineSymbol(math, ams, rel, "\u2a85", "\\lessapprox");
	defineSymbol(math, ams, rel, "\u224a", "\\approxeq");
	defineSymbol(math, ams, bin, "\u22d6", "\\lessdot");
	defineSymbol(math, ams, rel, "\u22d8", "\\lll");
	defineSymbol(math, ams, rel, "\u2276", "\\lessgtr");
	defineSymbol(math, ams, rel, "\u22da", "\\lesseqgtr");
	defineSymbol(math, ams, rel, "\u2a8b", "\\lesseqqgtr");
	defineSymbol(math, ams, rel, "\u2251", "\\doteqdot");
	defineSymbol(math, ams, rel, "\u2253", "\\risingdotseq");
	defineSymbol(math, ams, rel, "\u2252", "\\fallingdotseq");
	defineSymbol(math, ams, rel, "\u223d", "\\backsim");
	defineSymbol(math, ams, rel, "\u22cd", "\\backsimeq");
	defineSymbol(math, ams, rel, "\u2ac5", "\\subseteqq");
	defineSymbol(math, ams, rel, "\u22d0", "\\Subset");
	defineSymbol(math, ams, rel, "\u228f", "\\sqsubset");
	defineSymbol(math, ams, rel, "\u227c", "\\preccurlyeq");
	defineSymbol(math, ams, rel, "\u22de", "\\curlyeqprec");
	defineSymbol(math, ams, rel, "\u227e", "\\precsim");
	defineSymbol(math, ams, rel, "\u2ab7", "\\precapprox");
	defineSymbol(math, ams, rel, "\u22b2", "\\vartriangleleft");
	defineSymbol(math, ams, rel, "\u22b4", "\\trianglelefteq");
	defineSymbol(math, ams, rel, "\u22a8", "\\vDash");
	defineSymbol(math, ams, rel, "\u22aa", "\\Vvdash");
	defineSymbol(math, ams, rel, "\u2323", "\\smallsmile");
	defineSymbol(math, ams, rel, "\u2322", "\\smallfrown");
	defineSymbol(math, ams, rel, "\u224f", "\\bumpeq");
	defineSymbol(math, ams, rel, "\u224e", "\\Bumpeq");
	defineSymbol(math, ams, rel, "\u2267", "\\geqq");
	defineSymbol(math, ams, rel, "\u2a7e", "\\geqslant");
	defineSymbol(math, ams, rel, "\u2a96", "\\eqslantgtr");
	defineSymbol(math, ams, rel, "\u2273", "\\gtrsim");
	defineSymbol(math, ams, rel, "\u2a86", "\\gtrapprox");
	defineSymbol(math, ams, bin, "\u22d7", "\\gtrdot");
	defineSymbol(math, ams, rel, "\u22d9", "\\ggg");
	defineSymbol(math, ams, rel, "\u2277", "\\gtrless");
	defineSymbol(math, ams, rel, "\u22db", "\\gtreqless");
	defineSymbol(math, ams, rel, "\u2a8c", "\\gtreqqless");
	defineSymbol(math, ams, rel, "\u2256", "\\eqcirc");
	defineSymbol(math, ams, rel, "\u2257", "\\circeq");
	defineSymbol(math, ams, rel, "\u225c", "\\triangleq");
	defineSymbol(math, ams, rel, "\u223c", "\\thicksim");
	defineSymbol(math, ams, rel, "\u2248", "\\thickapprox");
	defineSymbol(math, ams, rel, "\u2ac6", "\\supseteqq");
	defineSymbol(math, ams, rel, "\u22d1", "\\Supset");
	defineSymbol(math, ams, rel, "\u2290", "\\sqsupset");
	defineSymbol(math, ams, rel, "\u227d", "\\succcurlyeq");
	defineSymbol(math, ams, rel, "\u22df", "\\curlyeqsucc");
	defineSymbol(math, ams, rel, "\u227f", "\\succsim");
	defineSymbol(math, ams, rel, "\u2ab8", "\\succapprox");
	defineSymbol(math, ams, rel, "\u22b3", "\\vartriangleright");
	defineSymbol(math, ams, rel, "\u22b5", "\\trianglerighteq");
	defineSymbol(math, ams, rel, "\u22a9", "\\Vdash");
	defineSymbol(math, ams, rel, "\u2223", "\\shortmid");
	defineSymbol(math, ams, rel, "\u2225", "\\shortparallel");
	defineSymbol(math, ams, rel, "\u226c", "\\between");
	defineSymbol(math, ams, rel, "\u22d4", "\\pitchfork");
	defineSymbol(math, ams, rel, "\u221d", "\\varpropto");
	defineSymbol(math, ams, rel, "\u25c0", "\\blacktriangleleft");
	defineSymbol(math, ams, rel, "\u2234", "\\therefore");
	defineSymbol(math, ams, rel, "\u220d", "\\backepsilon");
	defineSymbol(math, ams, rel, "\u25b6", "\\blacktriangleright");
	defineSymbol(math, ams, rel, "\u2235", "\\because");
	defineSymbol(math, ams, rel, "\u22d8", "\\llless");
	defineSymbol(math, ams, rel, "\u22d9", "\\gggtr");
	defineSymbol(math, ams, bin, "\u22b2", "\\lhd");
	defineSymbol(math, ams, bin, "\u22b3", "\\rhd");
	defineSymbol(math, ams, rel, "\u2242", "\\eqsim");
	defineSymbol(math, main, rel, "\u22c8", "\\Join");
	defineSymbol(math, ams, rel, "\u2251", "\\Doteq");
	
	// AMS Binary Operators
	defineSymbol(math, ams, bin, "\u2214", "\\dotplus");
	defineSymbol(math, ams, bin, "\u2216", "\\smallsetminus");
	defineSymbol(math, ams, bin, "\u22d2", "\\Cap");
	defineSymbol(math, ams, bin, "\u22d3", "\\Cup");
	defineSymbol(math, ams, bin, "\u2a5e", "\\doublebarwedge");
	defineSymbol(math, ams, bin, "\u229f", "\\boxminus");
	defineSymbol(math, ams, bin, "\u229e", "\\boxplus");
	defineSymbol(math, ams, bin, "\u22c7", "\\divideontimes");
	defineSymbol(math, ams, bin, "\u22c9", "\\ltimes");
	defineSymbol(math, ams, bin, "\u22ca", "\\rtimes");
	defineSymbol(math, ams, bin, "\u22cb", "\\leftthreetimes");
	defineSymbol(math, ams, bin, "\u22cc", "\\rightthreetimes");
	defineSymbol(math, ams, bin, "\u22cf", "\\curlywedge");
	defineSymbol(math, ams, bin, "\u22ce", "\\curlyvee");
	defineSymbol(math, ams, bin, "\u229d", "\\circleddash");
	defineSymbol(math, ams, bin, "\u229b", "\\circledast");
	defineSymbol(math, ams, bin, "\u22c5", "\\centerdot");
	defineSymbol(math, ams, bin, "\u22ba", "\\intercal");
	defineSymbol(math, ams, bin, "\u22d2", "\\doublecap");
	defineSymbol(math, ams, bin, "\u22d3", "\\doublecup");
	defineSymbol(math, ams, bin, "\u22a0", "\\boxtimes");
	
	// AMS Arrows
	defineSymbol(math, ams, rel, "\u21e2", "\\dashrightarrow");
	defineSymbol(math, ams, rel, "\u21e0", "\\dashleftarrow");
	defineSymbol(math, ams, rel, "\u21c7", "\\leftleftarrows");
	defineSymbol(math, ams, rel, "\u21c6", "\\leftrightarrows");
	defineSymbol(math, ams, rel, "\u21da", "\\Lleftarrow");
	defineSymbol(math, ams, rel, "\u219e", "\\twoheadleftarrow");
	defineSymbol(math, ams, rel, "\u21a2", "\\leftarrowtail");
	defineSymbol(math, ams, rel, "\u21ab", "\\looparrowleft");
	defineSymbol(math, ams, rel, "\u21cb", "\\leftrightharpoons");
	defineSymbol(math, ams, rel, "\u21b6", "\\curvearrowleft");
	defineSymbol(math, ams, rel, "\u21ba", "\\circlearrowleft");
	defineSymbol(math, ams, rel, "\u21b0", "\\Lsh");
	defineSymbol(math, ams, rel, "\u21c8", "\\upuparrows");
	defineSymbol(math, ams, rel, "\u21bf", "\\upharpoonleft");
	defineSymbol(math, ams, rel, "\u21c3", "\\downharpoonleft");
	defineSymbol(math, ams, rel, "\u22b8", "\\multimap");
	defineSymbol(math, ams, rel, "\u21ad", "\\leftrightsquigarrow");
	defineSymbol(math, ams, rel, "\u21c9", "\\rightrightarrows");
	defineSymbol(math, ams, rel, "\u21c4", "\\rightleftarrows");
	defineSymbol(math, ams, rel, "\u21a0", "\\twoheadrightarrow");
	defineSymbol(math, ams, rel, "\u21a3", "\\rightarrowtail");
	defineSymbol(math, ams, rel, "\u21ac", "\\looparrowright");
	defineSymbol(math, ams, rel, "\u21b7", "\\curvearrowright");
	defineSymbol(math, ams, rel, "\u21bb", "\\circlearrowright");
	defineSymbol(math, ams, rel, "\u21b1", "\\Rsh");
	defineSymbol(math, ams, rel, "\u21ca", "\\downdownarrows");
	defineSymbol(math, ams, rel, "\u21be", "\\upharpoonright");
	defineSymbol(math, ams, rel, "\u21c2", "\\downharpoonright");
	defineSymbol(math, ams, rel, "\u21dd", "\\rightsquigarrow");
	defineSymbol(math, ams, rel, "\u21dd", "\\leadsto");
	defineSymbol(math, ams, rel, "\u21db", "\\Rrightarrow");
	defineSymbol(math, ams, rel, "\u21be", "\\restriction");
	
	defineSymbol(math, main, textord, "\u2018", "`");
	defineSymbol(math, main, textord, "$", "\\$");
	defineSymbol(math, main, textord, "%", "\\%");
	defineSymbol(math, main, textord, "_", "\\_");
	defineSymbol(math, main, textord, "\u2220", "\\angle");
	defineSymbol(math, main, textord, "\u221e", "\\infty");
	defineSymbol(math, main, textord, "\u2032", "\\prime");
	defineSymbol(math, main, textord, "\u25b3", "\\triangle");
	defineSymbol(math, main, textord, "\u0393", "\\Gamma");
	defineSymbol(math, main, textord, "\u0394", "\\Delta");
	defineSymbol(math, main, textord, "\u0398", "\\Theta");
	defineSymbol(math, main, textord, "\u039b", "\\Lambda");
	defineSymbol(math, main, textord, "\u039e", "\\Xi");
	defineSymbol(math, main, textord, "\u03a0", "\\Pi");
	defineSymbol(math, main, textord, "\u03a3", "\\Sigma");
	defineSymbol(math, main, textord, "\u03a5", "\\Upsilon");
	defineSymbol(math, main, textord, "\u03a6", "\\Phi");
	defineSymbol(math, main, textord, "\u03a8", "\\Psi");
	defineSymbol(math, main, textord, "\u03a9", "\\Omega");
	defineSymbol(math, main, textord, "\u00ac", "\\neg");
	defineSymbol(math, main, textord, "\u00ac", "\\lnot");
	defineSymbol(math, main, textord, "\u22a4", "\\top");
	defineSymbol(math, main, textord, "\u22a5", "\\bot");
	defineSymbol(math, main, textord, "\u2205", "\\emptyset");
	defineSymbol(math, ams, textord, "\u2205", "\\varnothing");
	defineSymbol(math, main, mathord, "\u03b1", "\\alpha");
	defineSymbol(math, main, mathord, "\u03b2", "\\beta");
	defineSymbol(math, main, mathord, "\u03b3", "\\gamma");
	defineSymbol(math, main, mathord, "\u03b4", "\\delta");
	defineSymbol(math, main, mathord, "\u03f5", "\\epsilon");
	defineSymbol(math, main, mathord, "\u03b6", "\\zeta");
	defineSymbol(math, main, mathord, "\u03b7", "\\eta");
	defineSymbol(math, main, mathord, "\u03b8", "\\theta");
	defineSymbol(math, main, mathord, "\u03b9", "\\iota");
	defineSymbol(math, main, mathord, "\u03ba", "\\kappa");
	defineSymbol(math, main, mathord, "\u03bb", "\\lambda");
	defineSymbol(math, main, mathord, "\u03bc", "\\mu");
	defineSymbol(math, main, mathord, "\u03bd", "\\nu");
	defineSymbol(math, main, mathord, "\u03be", "\\xi");
	defineSymbol(math, main, mathord, "o", "\\omicron");
	defineSymbol(math, main, mathord, "\u03c0", "\\pi");
	defineSymbol(math, main, mathord, "\u03c1", "\\rho");
	defineSymbol(math, main, mathord, "\u03c3", "\\sigma");
	defineSymbol(math, main, mathord, "\u03c4", "\\tau");
	defineSymbol(math, main, mathord, "\u03c5", "\\upsilon");
	defineSymbol(math, main, mathord, "\u03d5", "\\phi");
	defineSymbol(math, main, mathord, "\u03c7", "\\chi");
	defineSymbol(math, main, mathord, "\u03c8", "\\psi");
	defineSymbol(math, main, mathord, "\u03c9", "\\omega");
	defineSymbol(math, main, mathord, "\u03b5", "\\varepsilon");
	defineSymbol(math, main, mathord, "\u03d1", "\\vartheta");
	defineSymbol(math, main, mathord, "\u03d6", "\\varpi");
	defineSymbol(math, main, mathord, "\u03f1", "\\varrho");
	defineSymbol(math, main, mathord, "\u03c2", "\\varsigma");
	defineSymbol(math, main, mathord, "\u03c6", "\\varphi");
	defineSymbol(math, main, bin, "\u2217", "*");
	defineSymbol(math, main, bin, "+", "+");
	defineSymbol(math, main, bin, "\u2212", "-");
	defineSymbol(math, main, bin, "\u22c5", "\\cdot");
	defineSymbol(math, main, bin, "\u2218", "\\circ");
	defineSymbol(math, main, bin, "\u00f7", "\\div");
	defineSymbol(math, main, bin, "\u00b1", "\\pm");
	defineSymbol(math, main, bin, "\u00d7", "\\times");
	defineSymbol(math, main, bin, "\u2229", "\\cap");
	defineSymbol(math, main, bin, "\u222a", "\\cup");
	defineSymbol(math, main, bin, "\u2216", "\\setminus");
	defineSymbol(math, main, bin, "\u2227", "\\land");
	defineSymbol(math, main, bin, "\u2228", "\\lor");
	defineSymbol(math, main, bin, "\u2227", "\\wedge");
	defineSymbol(math, main, bin, "\u2228", "\\vee");
	defineSymbol(math, main, textord, "\u221a", "\\surd");
	defineSymbol(math, main, open, "(", "(");
	defineSymbol(math, main, open, "[", "[");
	defineSymbol(math, main, open, "\u27e8", "\\langle");
	defineSymbol(math, main, open, "\u2223", "\\lvert");
	defineSymbol(math, main, open, "\u2225", "\\lVert");
	defineSymbol(math, main, close, ")", ")");
	defineSymbol(math, main, close, "]", "]");
	defineSymbol(math, main, close, "?", "?");
	defineSymbol(math, main, close, "!", "!");
	defineSymbol(math, main, close, "\u27e9", "\\rangle");
	defineSymbol(math, main, close, "\u2223", "\\rvert");
	defineSymbol(math, main, close, "\u2225", "\\rVert");
	defineSymbol(math, main, rel, "=", "=");
	defineSymbol(math, main, rel, "<", "<");
	defineSymbol(math, main, rel, ">", ">");
	defineSymbol(math, main, rel, ":", ":");
	defineSymbol(math, main, rel, "\u2248", "\\approx");
	defineSymbol(math, main, rel, "\u2245", "\\cong");
	defineSymbol(math, main, rel, "\u2265", "\\ge");
	defineSymbol(math, main, rel, "\u2265", "\\geq");
	defineSymbol(math, main, rel, "\u2190", "\\gets");
	defineSymbol(math, main, rel, ">", "\\gt");
	defineSymbol(math, main, rel, "\u2208", "\\in");
	defineSymbol(math, main, rel, "\u2209", "\\notin");
	defineSymbol(math, main, rel, "\u2282", "\\subset");
	defineSymbol(math, main, rel, "\u2283", "\\supset");
	defineSymbol(math, main, rel, "\u2286", "\\subseteq");
	defineSymbol(math, main, rel, "\u2287", "\\supseteq");
	defineSymbol(math, ams, rel, "\u2288", "\\nsubseteq");
	defineSymbol(math, ams, rel, "\u2289", "\\nsupseteq");
	defineSymbol(math, main, rel, "\u22a8", "\\models");
	defineSymbol(math, main, rel, "\u2190", "\\leftarrow");
	defineSymbol(math, main, rel, "\u2264", "\\le");
	defineSymbol(math, main, rel, "\u2264", "\\leq");
	defineSymbol(math, main, rel, "<", "\\lt");
	defineSymbol(math, main, rel, "\u2260", "\\ne");
	defineSymbol(math, main, rel, "\u2260", "\\neq");
	defineSymbol(math, main, rel, "\u2192", "\\rightarrow");
	defineSymbol(math, main, rel, "\u2192", "\\to");
	defineSymbol(math, ams, rel, "\u2271", "\\ngeq");
	defineSymbol(math, ams, rel, "\u2270", "\\nleq");
	defineSymbol(math, main, spacing, null, "\\!");
	defineSymbol(math, main, spacing, "\u00a0", "\\ ");
	defineSymbol(math, main, spacing, "\u00a0", "~");
	defineSymbol(math, main, spacing, null, "\\,");
	defineSymbol(math, main, spacing, null, "\\:");
	defineSymbol(math, main, spacing, null, "\\;");
	defineSymbol(math, main, spacing, null, "\\enspace");
	defineSymbol(math, main, spacing, null, "\\qquad");
	defineSymbol(math, main, spacing, null, "\\quad");
	defineSymbol(math, main, spacing, "\u00a0", "\\space");
	defineSymbol(math, main, punct, ",", ",");
	defineSymbol(math, main, punct, ";", ";");
	defineSymbol(math, main, punct, ":", "\\colon");
	defineSymbol(math, ams, bin, "\u22bc", "\\barwedge");
	defineSymbol(math, ams, bin, "\u22bb", "\\veebar");
	defineSymbol(math, main, bin, "\u2299", "\\odot");
	defineSymbol(math, main, bin, "\u2295", "\\oplus");
	defineSymbol(math, main, bin, "\u2297", "\\otimes");
	defineSymbol(math, main, textord, "\u2202", "\\partial");
	defineSymbol(math, main, bin, "\u2298", "\\oslash");
	defineSymbol(math, ams, bin, "\u229a", "\\circledcirc");
	defineSymbol(math, ams, bin, "\u22a1", "\\boxdot");
	defineSymbol(math, main, bin, "\u25b3", "\\bigtriangleup");
	defineSymbol(math, main, bin, "\u25bd", "\\bigtriangledown");
	defineSymbol(math, main, bin, "\u2020", "\\dagger");
	defineSymbol(math, main, bin, "\u22c4", "\\diamond");
	defineSymbol(math, main, bin, "\u22c6", "\\star");
	defineSymbol(math, main, bin, "\u25c3", "\\triangleleft");
	defineSymbol(math, main, bin, "\u25b9", "\\triangleright");
	defineSymbol(math, main, open, "{", "\\{");
	defineSymbol(math, main, close, "}", "\\}");
	defineSymbol(math, main, open, "{", "\\lbrace");
	defineSymbol(math, main, close, "}", "\\rbrace");
	defineSymbol(math, main, open, "[", "\\lbrack");
	defineSymbol(math, main, close, "]", "\\rbrack");
	defineSymbol(math, main, open, "\u230a", "\\lfloor");
	defineSymbol(math, main, close, "\u230b", "\\rfloor");
	defineSymbol(math, main, open, "\u2308", "\\lceil");
	defineSymbol(math, main, close, "\u2309", "\\rceil");
	defineSymbol(math, main, textord, "\\", "\\backslash");
	defineSymbol(math, main, textord, "\u2223", "|");
	defineSymbol(math, main, textord, "\u2223", "\\vert");
	defineSymbol(math, main, textord, "\u2225", "\\|");
	defineSymbol(math, main, textord, "\u2225", "\\Vert");
	defineSymbol(math, main, rel, "\u2191", "\\uparrow");
	defineSymbol(math, main, rel, "\u21d1", "\\Uparrow");
	defineSymbol(math, main, rel, "\u2193", "\\downarrow");
	defineSymbol(math, main, rel, "\u21d3", "\\Downarrow");
	defineSymbol(math, main, rel, "\u2195", "\\updownarrow");
	defineSymbol(math, main, rel, "\u21d5", "\\Updownarrow");
	defineSymbol(math, math, op, "\u2210", "\\coprod");
	defineSymbol(math, math, op, "\u22c1", "\\bigvee");
	defineSymbol(math, math, op, "\u22c0", "\\bigwedge");
	defineSymbol(math, math, op, "\u2a04", "\\biguplus");
	defineSymbol(math, math, op, "\u22c2", "\\bigcap");
	defineSymbol(math, math, op, "\u22c3", "\\bigcup");
	defineSymbol(math, math, op, "\u222b", "\\int");
	defineSymbol(math, math, op, "\u222b", "\\intop");
	defineSymbol(math, math, op, "\u222c", "\\iint");
	defineSymbol(math, math, op, "\u222d", "\\iiint");
	defineSymbol(math, math, op, "\u220f", "\\prod");
	defineSymbol(math, math, op, "\u2211", "\\sum");
	defineSymbol(math, math, op, "\u2a02", "\\bigotimes");
	defineSymbol(math, math, op, "\u2a01", "\\bigoplus");
	defineSymbol(math, math, op, "\u2a00", "\\bigodot");
	defineSymbol(math, math, op, "\u222e", "\\oint");
	defineSymbol(math, math, op, "\u2a06", "\\bigsqcup");
	defineSymbol(math, math, op, "\u222b", "\\smallint");
	defineSymbol(math, main, inner, "\u2026", "\\ldots");
	defineSymbol(math, main, inner, "\u22ef", "\\cdots");
	defineSymbol(math, main, inner, "\u22f1", "\\ddots");
	defineSymbol(math, main, textord, "\u22ee", "\\vdots");
	defineSymbol(math, main, accent, "\u00b4", "\\acute");
	defineSymbol(math, main, accent, "\u0060", "\\grave");
	defineSymbol(math, main, accent, "\u00a8", "\\ddot");
	defineSymbol(math, main, accent, "\u007e", "\\tilde");
	defineSymbol(math, main, accent, "\u00af", "\\bar");
	defineSymbol(math, main, accent, "\u02d8", "\\breve");
	defineSymbol(math, main, accent, "\u02c7", "\\check");
	defineSymbol(math, main, accent, "\u005e", "\\hat");
	defineSymbol(math, main, accent, "\u20d7", "\\vec");
	defineSymbol(math, main, accent, "\u02d9", "\\dot");
	defineSymbol(math, main, mathord, "\u0131", "\\imath");
	defineSymbol(math, main, mathord, "\u0237", "\\jmath");
	
	defineSymbol(text, main, spacing, "\u00a0", "\\ ");
	defineSymbol(text, main, spacing, "\u00a0", " ");
	defineSymbol(text, main, spacing, "\u00a0", "~");
	
	// There are lots of symbols which are the same, so we add them in afterwards.
	var i;
	var ch;
	
	// All of these are textords in math mode
	var mathTextSymbols = "0123456789/@.\"";
	for (i = 0; i < mathTextSymbols.length; i++) {
	    ch = mathTextSymbols.charAt(i);
	    defineSymbol(math, main, textord, ch, ch);
	}
	
	// All of these are textords in text mode
	var textSymbols = "0123456789`!@*()-=+[]'\";:?/.,";
	for (i = 0; i < textSymbols.length; i++) {
	    ch = textSymbols.charAt(i);
	    defineSymbol(text, main, textord, ch, ch);
	}
	
	// All of these are textords in text mode, and mathords in math mode
	var letters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	for (i = 0; i < letters.length; i++) {
	    ch = letters.charAt(i);
	    defineSymbol(math, main, mathord, ch, ch);
	    defineSymbol(text, main, textord, ch, ch);
	}
	


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.e = function(list, options) {
		if(typeof DEBUG !== "undefined" && DEBUG) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __WEBPACK_IMPORTED_MODULE_1_jquery__ && __WEBPACK_IMPORTED_MODULE_1_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_notification_store_jsx__ = __webpack_require__(786);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router___default = __WEBPACK_IMPORTED_MODULE_14_react_router__ && __WEBPACK_IMPORTED_MODULE_14_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_router___default });
	/* harmony export */ exports["initialize"] = initialize;/* harmony export */ exports["sendMessage"] = sendMessage;/* harmony export */ exports["close"] = close;'use strict';
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	 //eslint-disable-line no-unused-vars
	
	
	
	
	
	
	
	var SocketEvents = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].SocketEvents;
	
	
	
	var MAX_WEBSOCKET_FAILS = 7;
	var WEBSOCKET_RETRY_TIME = 3000;
	
	var conn = null;
	var connectFailCount = 0;
	var pastFirstInit = false;
	var manuallyClosed = false;
	
	function initialize() {
	    if (window.WebSocket && !conn) {
	        var protocol = 'ws://';
	        if (window.location.protocol === 'https:') {
	            protocol = 'wss://';
	        }
	
	        var connUrl = protocol + location.host + (/:\d+/.test(location.host) ? '' : /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.getWebsocketPort(protocol)) + /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].getUsersRoute() + '/websocket';
	
	        if (connectFailCount === 0) {
	            console.log('websocket connecting to ' + connUrl); //eslint-disable-line no-console
	        }
	
	        manuallyClosed = false;
	
	        conn = new WebSocket(connUrl);
	
	        conn.onopen = function () {
	            if (connectFailCount > 0) {
	                console.log('websocket re-established connection'); //eslint-disable-line no-console
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannels();
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getPosts(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId());
	            }
	
	            if (pastFirstInit) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_error_store_jsx__["a"].clearLastError();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_error_store_jsx__["a"].emitChange();
	            }
	
	            pastFirstInit = true;
	            connectFailCount = 0;
	        };
	
	        conn.onclose = function () {
	            conn = null;
	
	            if (connectFailCount === 0) {
	                console.log('websocket closed'); //eslint-disable-line no-console
	            }
	
	            if (manuallyClosed) {
	                return;
	            }
	
	            connectFailCount = connectFailCount + 1;
	
	            if (connectFailCount > MAX_WEBSOCKET_FAILS) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_error_store_jsx__["a"].storeLastError({ message: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.socketError', 'Please check connection, Mattermost unreachable. If issue persists, ask administrator to check WebSocket port.') });
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_error_store_jsx__["a"].setConnectionErrorCount(connectFailCount);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_error_store_jsx__["a"].emitChange();
	
	            setTimeout(function () {
	                initialize();
	            }, WEBSOCKET_RETRY_TIME);
	        };
	
	        conn.onerror = function (evt) {
	            if (connectFailCount <= 1) {
	                console.log('websocket error'); //eslint-disable-line no-console
	                console.log(evt); //eslint-disable-line no-console
	            }
	        };
	
	        conn.onmessage = function (evt) {
	            var msg = JSON.parse(evt.data);
	            handleMessage(msg);
	        };
	    }
	}
	
	function handleMessage(msg) {
	    // Let the store know we are online. This probably shouldn't be here.
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_user_store_jsx__["a"].setStatus(msg.user_id, 'online');
	
	    switch (msg.action) {
	        case SocketEvents.POSTED:
	        case SocketEvents.EPHEMERAL_MESSAGE:
	            handleNewPostEvent(msg);
	            break;
	
	        case SocketEvents.POST_EDITED:
	            handlePostEditEvent(msg);
	            break;
	
	        case SocketEvents.POST_DELETED:
	            handlePostDeleteEvent(msg);
	            break;
	
	        case SocketEvents.NEW_USER:
	            handleNewUserEvent();
	            break;
	
	        case SocketEvents.USER_ADDED:
	            handleUserAddedEvent(msg);
	            break;
	
	        case SocketEvents.USER_REMOVED:
	            handleUserRemovedEvent(msg);
	            break;
	
	        case SocketEvents.CHANNEL_VIEWED:
	            handleChannelViewedEvent(msg);
	            break;
	
	        case SocketEvents.CHANNEL_DELETED:
	            handleChannelDeletedEvent(msg);
	            break;
	
	        case SocketEvents.DIRECT_ADDED:
	            handleDirectAddedEvent(msg);
	            break;
	
	        case SocketEvents.PREFERENCE_CHANGED:
	            handlePreferenceChangedEvent(msg);
	            break;
	
	        case SocketEvents.TYPING:
	            handleUserTypingEvent(msg);
	            break;
	
	        default:
	    }
	}
	
	function sendMessage(msg) {
	    if (conn && conn.readyState === WebSocket.OPEN) {
	        var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_team_store_jsx__["a"].getCurrentId();
	        if (teamId && teamId.length > 0) {
	            msg.team_id = teamId;
	        }
	
	        conn.send(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(msg));
	    } else if (!conn || conn.readyState === WebSocket.Closed) {
	        conn = null;
	        initialize();
	    }
	}
	
	function close() {
	    manuallyClosed = true;
	    connectFailCount = 0;
	    if (conn && conn.readyState === WebSocket.OPEN) {
	        conn.close();
	    }
	}
	
	function handleNewPostEvent(msg) {
	    var post = JSON.parse(msg.props.post);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.emitPostRecievedEvent(post, msg);
	}
	
	function handlePostEditEvent(msg) {
	    // Store post
	    var post = JSON.parse(msg.props.post);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_stores_post_store_jsx__["a"].storePost(post);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_stores_post_store_jsx__["a"].emitChange();
	
	    // Update channel state
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId() === msg.channel_id) {
	        if (window.isActive) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.updateLastViewedAt();
	        }
	    }
	}
	
	function handlePostDeleteEvent(msg) {
	    var post = JSON.parse(msg.props.post);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.emitPostDeletedEvent(post);
	}
	
	function handleNewUserEvent() {
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getProfiles();
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getDirectProfiles();
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannelExtraInfo();
	}
	
	function handleDirectAddedEvent(msg) {
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannel(msg.channel_id);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getDirectProfiles();
	}
	
	function handleUserAddedEvent(msg) {
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId() === msg.channel_id) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannelExtraInfo();
	    }
	
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_team_store_jsx__["a"].getCurrentId() === msg.team_id && /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_user_store_jsx__["a"].getCurrentId() === msg.user_id) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannel(msg.channel_id);
	    }
	}
	
	function handleUserRemovedEvent(msg) {
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_user_store_jsx__["a"].getCurrentId() === msg.user_id) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannels();
	
	        if (msg.props.remover_id !== msg.user_id && msg.channel_id === /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId() && /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.bind()('#removed_from_channel').length > 0) {
	            var sentState = {};
	            sentState.channelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrent().display_name;
	            sentState.remover = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_user_store_jsx__["a"].getProfile(msg.props.remover_id).username;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_browser_store_jsx__["a"].setItem('channel-removed-state', sentState);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.bind()('#removed_from_channel').modal('show');
	        }
	    } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId() === msg.channel_id) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannelExtraInfo();
	    }
	}
	
	function handleChannelViewedEvent(msg) {
	    // Useful for when multiple devices have the app open to different channels
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_team_store_jsx__["a"].getCurrentId() === msg.team_id && /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId() !== msg.channel_id && /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_user_store_jsx__["a"].getCurrentId() === msg.user_id) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannel(msg.channel_id);
	    }
	}
	
	function handleChannelDeletedEvent(msg) {
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].getCurrentId() === msg.channel_id) {
	        var teamUrl = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_team_store_jsx__["a"].getCurrentTeamRelativeUrl();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_router__["browserHistory"].push(teamUrl + '/channels/' + /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].DEFAULT_CHANNEL);
	    }
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getChannels();
	}
	
	function handlePreferenceChangedEvent(msg) {
	    var preference = JSON.parse(msg.props.preference);
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.emitPreferenceChangedEvent(preference);
	}
	
	function handleUserTypingEvent(msg) {
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_3_stores_team_store_jsx__["a"].getCurrentId() === msg.team_id) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.emitRemoteUserTypingEvent(msg.channel_id, msg.user_id, msg.props.parent_id);
	    }
	}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var BackstageHeader = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(BackstageHeader, _React$Component);
	
	    function BackstageHeader() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BackstageHeader);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(BackstageHeader).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BackstageHeader, [{
	        key: 'render',
	        value: function render() {
	            var children = [];
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(this.props.children, function (child, index) {
	                if (index !== 0) {
	                    children.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'span',
	                        {
	                            key: 'divider' + index,
	                            className: 'backstage-header__divider'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('i', { className: 'fa fa-angle-right' })
	                    ));
	                }
	
	                children.push(child);
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-header' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'h1',
	                    null,
	                    children
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node
	            };
	        }
	    }]);
	
	    return BackstageHeader;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = BackstageHeader;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_loading_screen_jsx__ = __webpack_require__(44);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var InstalledIntegrations = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InstalledIntegrations, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(InstalledIntegrations, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node,
	                header: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                addLink: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
	                addText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                emptyText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                loading: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool.isRequired
	            };
	        }
	    }]);
	
	    function InstalledIntegrations(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledIntegrations);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledIntegrations).call(this, props));
	
	        _this.updateFilter = _this.updateFilter.bind(_this);
	
	        _this.state = {
	            filter: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(InstalledIntegrations, [{
	        key: 'updateFilter',
	        value: function updateFilter(e) {
	            this.setState({
	                filter: e.target.value
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var filter = this.state.filter.toLowerCase();
	
	            var children = void 0;
	
	            if (this.props.loading) {
	                children = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_components_loading_screen_jsx__["a"], null);
	            } else {
	                children = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(this.props.children, function (child) {
	                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, { filter: filter });
	                });
	
	                if (children.length === 0) {
	                    children = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'span',
	                        { className: 'backstage-list__item backstage-list_empty' },
	                        this.props.emptyText
	                    );
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-content' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'installed-integrations' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'backstage-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'h1',
	                            null,
	                            this.props.header
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                            {
	                                className: 'add-integrations-link',
	                                to: this.props.addLink
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-primary'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'span',
	                                    null,
	                                    this.props.addText
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'backstage-filters' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'backstage-filter__search' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('i', { className: 'fa fa-search' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                type: 'search',
	                                className: 'form-control',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.localizeMessage('installed_integrations.search', 'Search Integrations'),
	                                value: this.state.filter,
	                                onChange: this.updateFilter,
	                                style: { flexGrow: 0, flexShrink: 0 }
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'backstage-list' },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InstalledIntegrations;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledIntegrations;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    error: {
	        id: 'edit_channel_header_modal.error',
	        defaultMessage: 'This channel header is too long, please enter a shorter one'
	    }
	});
	
	
	
	var EditChannelHeaderModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(EditChannelHeaderModal, _React$Component);
	
	    function EditChannelHeaderModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EditChannelHeaderModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EditChannelHeaderModal).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.onShow = _this.onShow.bind(_this);
	        _this.onHide = _this.onHide.bind(_this);
	
	        _this.state = {
	            header: props.channel.header,
	            serverError: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(EditChannelHeaderModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.show) {
	                this.onShow();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.channel.header !== nextProps.channel.header) {
	                this.setState({
	                    header: nextProps.channel.header
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.show && !prevProps.show) {
	                this.onShow();
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            this.setState({
	                header: e.target.value
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].updateChannelHeader(this.props.channel.id, this.state.header, function (channel) {
	                _this2.setState({ serverError: '' });
	                _this2.onHide();
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes.RECEIVED_CHANNEL,
	                    channel: channel
	                });
	            }, function (err) {
	                if (err.id === 'api.context.invalid_param.app_error') {
	                    _this2.setState({ serverError: _this2.props.intl.formatMessage(holders.error) });
	                } else {
	                    _this2.setState({ serverError: err.message });
	                }
	            });
	        }
	    }, {
	        key: 'onShow',
	        value: function onShow() {
	            var textarea = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.textarea);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.placeCaretAtEnd(textarea);
	        }
	    }, {
	        key: 'onHide',
	        value: function onHide() {
	            this.setState({
	                serverError: '',
	                header: this.props.channel.header
	            });
	
	            this.props.onHide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_header_modal.title',
	                            defaultMessage: 'Edit Header for {channel}',
	                            values: {
	                                channel: this.props.channel.display_name
	                            }
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_header_modal.description',
	                            defaultMessage: 'Edit the text appearing next to the channel name in the channel header.'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('textarea', {
	                        ref: 'textarea',
	                        className: 'form-control no-resize',
	                        rows: '6',
	                        id: 'edit_header',
	                        maxLength: '1024',
	                        value: this.state.header,
	                        onChange: this.handleChange
	                    }),
	                    serverError
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.onHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_header_modal.cancel',
	                            defaultMessage: 'Cancel'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-primary',
	                            onClick: this.handleSubmit
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_header_modal.save',
	                            defaultMessage: 'Save'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EditChannelHeaderModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	EditChannelHeaderModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(EditChannelHeaderModal);

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_image_jsx__ = __webpack_require__(782);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__file_attachment_jsx__ = __webpack_require__(701);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var FileAttachmentList = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FileAttachmentList, _React$Component);
	
	    function FileAttachmentList(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FileAttachmentList);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FileAttachmentList).call(this, props));
	
	        _this.handleImageClick = _this.handleImageClick.bind(_this);
	
	        _this.state = { showPreviewModal: false, startImgId: 0 };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FileAttachmentList, [{
	        key: 'handleImageClick',
	        value: function handleImageClick(indexClicked) {
	            this.setState({ showPreviewModal: true, startImgId: indexClicked });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var filenames = this.props.filenames;
	
	            var postFiles = [];
	            for (var i = 0; i < filenames.length && i < /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].MAX_DISPLAY_FILES; i++) {
	                postFiles.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__file_attachment_jsx__["a"], {
	                    key: 'file_attachment_' + i,
	                    filename: filenames[i],
	                    index: i,
	                    handleImageClick: this.handleImageClick
	                }));
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'post-image__columns' },
	                    postFiles
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__view_image_jsx__["a"], {
	                    show: this.state.showPreviewModal,
	                    onModalDismissed: function onModalDismissed() {
	                        return _this2.setState({ showPreviewModal: false });
	                    },
	                    channelId: this.props.channelId,
	                    userId: this.props.userId,
	                    startId: this.state.startImgId,
	                    filenames: filenames
	                })
	            );
	        }
	    }]);
	
	    return FileAttachmentList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = FileAttachmentList;
	
	
	FileAttachmentList.propTypes = {
	
	    // a list of file pathes displayed by this
	    filenames: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string).isRequired,
	
	    // the channel that this is part of
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string,
	
	    // the user that owns the post that this is attached to
	    userId: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl___default = __WEBPACK_IMPORTED_MODULE_1_react_intl__ && __WEBPACK_IMPORTED_MODULE_1_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __WEBPACK_IMPORTED_MODULE_2_react__ && __WEBPACK_IMPORTED_MODULE_2_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router___default = __WEBPACK_IMPORTED_MODULE_3_react_router__ && __WEBPACK_IMPORTED_MODULE_3_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_react_router___default });
	/* harmony export */ exports["a"] = FileInfoPreview;'use strict';
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_react_intl__["defineMessages"].bind()({
	    type: {
	        id: 'file_info_preview.type',
	        defaultMessage: 'File type '
	    },
	    size: {
	        id: 'file_info_preview.size',
	        defaultMessage: 'Size '
	    }
	});
	
	function FileInfoPreview(_ref) {
	    var filename = _ref.filename;
	    var fileUrl = _ref.fileUrl;
	    var fileInfo = _ref.fileInfo;
	    var formatMessage = _ref.formatMessage;
	
	    // non-image files include a section providing details about the file
	    var infoParts = [];
	
	    if (fileInfo.extension !== '') {
	        infoParts.push(formatMessage(holders.type) + fileInfo.extension.toUpperCase());
	    }
	
	    infoParts.push(formatMessage(holders.size) + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0_utils_utils_jsx__.fileSizeToString(fileInfo.size));
	
	    var infoString = infoParts.join(', ');
	
	    var name = decodeURIComponent(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0_utils_utils_jsx__.getFileName(filename));
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
	        'div',
	        { className: 'file-details__container' },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_3_react_router__["Link"],
	            {
	                className: 'file-details__preview',
	                to: fileUrl,
	                target: '_blank'
	            },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'file-details__preview-helper' }),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0_utils_utils_jsx__.getPreviewImagePath(filename) })
	        ),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
	            'div',
	            { className: 'file-details' },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
	                'div',
	                { className: 'file-details__name' },
	                name
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
	                'div',
	                { className: 'file-details__info' },
	                infoString
	            )
	        )
	    );
	}
	
	FileInfoPreview.propTypes = {
	    filename: /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
	    fileUrl: /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.string.isRequired,
	    fileInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.object.isRequired,
	    formatMessage: /* harmony import */__WEBPACK_IMPORTED_MODULE_2_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var GetLinkModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(GetLinkModal, _React$Component);
	
	    function GetLinkModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, GetLinkModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(GetLinkModal).call(this, props));
	
	        _this.onHide = _this.onHide.bind(_this);
	
	        _this.copyLink = _this.copyLink.bind(_this);
	
	        _this.state = {
	            copiedLink: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(GetLinkModal, [{
	        key: 'onHide',
	        value: function onHide() {
	            this.setState({ copiedLink: false });
	
	            this.props.onHide();
	        }
	    }, {
	        key: 'copyLink',
	        value: function copyLink() {
	            var copyTextarea = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.textarea));
	            copyTextarea.select();
	
	            try {
	                var successful = document.execCommand('copy');
	                if (successful) {
	                    this.setState({ copiedLink: true });
	                } else {
	                    this.setState({ copiedLink: false });
	                }
	            } catch (err) {
	                this.setState({ copiedLink: false });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var helpText = null;
	            if (this.props.helpText) {
	                helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'p',
	                    null,
	                    this.props.helpText,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	                );
	            }
	
	            var copyLink = null;
	            if (document.queryCommandSupported('copy')) {
	                copyLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'button',
	                    {
	                        'data-copy-btn': 'true',
	                        type: 'button',
	                        className: 'btn btn-primary pull-left',
	                        onClick: this.copyLink
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                        id: 'get_link.copy',
	                        defaultMessage: 'Copy Link'
	                    })
	                );
	            }
	
	            var linkText = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('textarea', {
	                className: 'form-control no-resize min-height',
	                readOnly: 'true',
	                ref: 'textarea',
	                value: this.props.link
	            });
	
	            var copyLinkConfirm = null;
	            if (this.state.copiedLink) {
	                copyLinkConfirm = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'p',
	                    { className: 'alert alert-success alert--confirm' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                        id: 'get_link.clipboard',
	                        defaultMessage: ' Link copied to clipboard.'
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'h4',
	                        { className: 'modal-title' },
	                        this.props.title
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Body,
	                    null,
	                    helpText,
	                    linkText
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.onHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'get_link.close',
	                            defaultMessage: 'Close'
	                        })
	                    ),
	                    copyLink,
	                    copyLinkConfirm
	                )
	            );
	        }
	    }]);
	
	    return GetLinkModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = GetLinkModal;
	
	
	GetLinkModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired,
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string.isRequired,
	    helpText: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    link: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string.isRequired
	};
	
	GetLinkModal.defaultProps = {
	    helpText: null
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_search_store_jsx__ = __webpack_require__(161);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__suggestion_suggestion_box_jsx__ = __webpack_require__(370);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__suggestion_search_channel_provider_jsx__ = __webpack_require__(755);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__suggestion_search_suggestion_list_jsx__ = __webpack_require__(756);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__suggestion_search_user_provider_jsx__ = __webpack_require__(757);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __WEBPACK_IMPORTED_MODULE_17_react_intl__ && __WEBPACK_IMPORTED_MODULE_17_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __WEBPACK_IMPORTED_MODULE_19_react__ && __WEBPACK_IMPORTED_MODULE_19_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].ActionTypes;
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["defineMessages"].bind()({
	    search: {
	        id: 'search_bar.search',
	        defaultMessage: 'Search'
	    }
	});
	
	
	
	var SearchBar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SearchBar, _React$Component);
	
	    function SearchBar() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchBar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchBar).call(this));
	
	        _this.mounted = false;
	
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	        _this.handleUserInput = _this.handleUserInput.bind(_this);
	        _this.handleUserFocus = _this.handleUserFocus.bind(_this);
	        _this.handleUserBlur = _this.handleUserBlur.bind(_this);
	        _this.performSearch = _this.performSearch.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        var state = _this.getSearchTermStateFromStores();
	        state.focused = false;
	        _this.state = state;
	
	        _this.suggestionProviders = [new /* harmony import */__WEBPACK_IMPORTED_MODULE_12__suggestion_search_channel_provider_jsx__["a"](), new /* harmony import */__WEBPACK_IMPORTED_MODULE_14__suggestion_search_user_provider_jsx__["a"]()];
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SearchBar, [{
	        key: 'getSearchTermStateFromStores',
	        value: function getSearchTermStateFromStores() {
	            var term = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_search_store_jsx__["a"].getSearchTerm() || '';
	            return {
	                searchTerm: term
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_search_store_jsx__["a"].addSearchTermChangeListener(this.onListenerChange);
	            this.mounted = true;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_search_store_jsx__["a"].removeSearchTermChangeListener(this.onListenerChange);
	            this.mounted = false;
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange(doSearch, isMentionSearch) {
	            if (this.mounted) {
	                var newState = this.getSearchTermStateFromStores();
	                if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.areObjectsEqual(newState, this.state)) {
	                    this.setState(newState);
	                }
	                if (doSearch) {
	                    this.performSearch(newState.searchTerm, isMentionSearch);
	                }
	            }
	        }
	    }, {
	        key: 'clearFocus',
	        value: function clearFocus() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.search-bar__container').removeClass('focused');
	        }
	    }, {
	        key: 'handleClose',
	        value: function handleClose(e) {
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH,
	                results: null
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH_TERM,
	                term: null,
	                do_search: false,
	                is_mention_search: false
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_POST_SELECTED,
	                postId: null
	            });
	        }
	    }, {
	        key: 'handleUserInput',
	        value: function handleUserInput(text) {
	            var term = text;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_search_store_jsx__["a"].storeSearchTerm(term);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_search_store_jsx__["a"].emitSearchTermChange(false);
	            this.setState({ searchTerm: term });
	        }
	    }, {
	        key: 'handleUserBlur',
	        value: function handleUserBlur() {
	            this.setState({ focused: false });
	        }
	    }, {
	        key: 'handleUserFocus',
	        value: function handleUserFocus() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.search-bar__container').addClass('focused');
	
	            this.setState({ focused: true });
	        }
	    }, {
	        key: 'performSearch',
	        value: function performSearch(terms, isMentionSearch) {
	            var _this2 = this;
	
	            if (terms.length) {
	                this.setState({ isSearching: true });
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].search(terms, isMentionSearch, function (data) {
	                    _this2.setState({ isSearching: false });
	                    if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.isMobile()) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this2.refs.search).value = '';
	                    }
	
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                        type: ActionTypes.RECEIVED_SEARCH,
	                        results: data,
	                        is_mention_search: isMentionSearch
	                    });
	                }, function (err) {
	                    _this2.setState({ isSearching: false });
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.dispatchError(err, 'search');
	                });
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            e.preventDefault();
	            this.performSearch(this.state.searchTerm.trim());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isSearching = null;
	            if (this.state.isSearching) {
	                isSearching = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', { className: 'glyphicon glyphicon-refresh glyphicon-refresh-animate' });
	            }
	
	            var helpClass = 'search-help-popover';
	            if (!this.state.searchTerm && this.state.focused) {
	                helpClass += ' visible';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'sidebar__collapse',
	                        onClick: this.handleClose
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', { className: 'fa fa-angle-left' })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'span',
	                    {
	                        className: 'search__clear',
	                        onClick: this.clearFocus
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'search_bar.cancel',
	                        defaultMessage: 'Cancel'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'form',
	                    {
	                        role: 'form',
	                        className: 'search__form',
	                        onSubmit: this.handleSubmit,
	                        style: { overflow: 'visible' },
	                        autoComplete: 'off'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('span', { className: 'glyphicon glyphicon-search sidebar__search-icon' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__suggestion_suggestion_box_jsx__["a"], {
	                        ref: 'search',
	                        className: 'form-control search-bar',
	                        placeholder: this.props.intl.formatMessage(holders.search),
	                        value: this.state.searchTerm,
	                        onFocus: this.handleUserFocus,
	                        onBlur: this.handleUserBlur,
	                        onUserInput: this.handleUserInput,
	                        listComponent: /* harmony import */__WEBPACK_IMPORTED_MODULE_13__suggestion_search_suggestion_list_jsx__["a"],
	                        providers: this.suggestionProviders,
	                        type: 'search'
	                    }),
	                    isSearching,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_bootstrap__["Popover"],
	                        {
	                            id: 'searchbar-help-popup',
	                            placement: 'bottom',
	                            className: helpClass
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedHTMLMessage"], {
	                            id: 'search_bar.usage',
	                            defaultMessage: '<h4>Search Options</h4><ul><li><span>Use </span><b>"quotation marks"</b><span> to search for phrases</span></li><li><span>Use </span><b>from:</b><span> to find posts from specific users and </span><b>in:</b><span> to find posts in specific channels</span></li></ul>'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchBar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);
	
	SearchBar.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["injectIntl"].bind()(SearchBar);

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__suggestion_at_mention_provider_jsx__ = __webpack_require__(752);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__suggestion_command_provider_jsx__ = __webpack_require__(753);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__suggestion_emoticon_provider_jsx__ = __webpack_require__(754);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__suggestion_suggestion_list_jsx__ = __webpack_require__(371);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__suggestion_suggestion_box_jsx__ = __webpack_require__(370);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __WEBPACK_IMPORTED_MODULE_15_react_intl__ && __WEBPACK_IMPORTED_MODULE_15_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __WEBPACK_IMPORTED_MODULE_16_react__ && __WEBPACK_IMPORTED_MODULE_16_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var PreReleaseFeatures = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__["a"].PRE_RELEASE_FEATURES;
	
	
	
	var Textbox = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Textbox, _React$Component);
	
	    function Textbox(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Textbox);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Textbox).call(this, props));
	
	        _this.focus = _this.focus.bind(_this);
	        _this.getStateFromStores = _this.getStateFromStores.bind(_this);
	        _this.onRecievedError = _this.onRecievedError.bind(_this);
	        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	        _this.handleHeightChange = _this.handleHeightChange.bind(_this);
	        _this.showPreview = _this.showPreview.bind(_this);
	
	        _this.state = {
	            connection: ''
	        };
	
	        _this.suggestionProviders = [new /* harmony import */__WEBPACK_IMPORTED_MODULE_6__suggestion_at_mention_provider_jsx__["a"](), new /* harmony import */__WEBPACK_IMPORTED_MODULE_8__suggestion_emoticon_provider_jsx__["a"]()];
	        if (props.supportsCommands) {
	            _this.suggestionProviders.push(new /* harmony import */__WEBPACK_IMPORTED_MODULE_7__suggestion_command_provider_jsx__["a"]());
	        }
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Textbox, [{
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var error = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__["a"].getLastError();
	
	            if (error) {
	                return { message: error.message };
	            }
	
	            return { message: null };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__["a"].addChangeListener(this.onRecievedError);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__["a"].removeChangeListener(this.onRecievedError);
	        }
	    }, {
	        key: 'onRecievedError',
	        value: function onRecievedError() {
	            var errorCount = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__["a"].getConnectionErrorCount();
	
	            if (errorCount > 1) {
	                this.setState({ connection: 'bad-connection' });
	            } else {
	                this.setState({ connection: '' });
	            }
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            this.props.onKeyPress(e);
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            if (this.props.onKeyDown) {
	                this.props.onKeyDown(e);
	            }
	        }
	    }, {
	        key: 'handleHeightChange',
	        value: function handleHeightChange(height) {
	            var textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this.refs.message.getTextbox());
	            var wrapper = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this.refs.wrapper);
	
	            var maxHeight = parseInt(textbox.css('max-height'), 10);
	
	            // move over attachment icon to compensate for the scrollbar
	            if (height > maxHeight) {
	                wrapper.closest('.post-body__cell').addClass('scroll');
	            } else {
	                wrapper.closest('.post-body__cell').removeClass('scroll');
	            }
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.refs.message.getTextbox().focus();
	        }
	    }, {
	        key: 'showPreview',
	        value: function showPreview(e) {
	            e.preventDefault();
	            e.target.blur();
	            this.setState({ preview: !this.state.preview });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var hasText = this.props.messageText.length > 0;
	
	            var previewLink = null;
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isFeatureEnabled(PreReleaseFeatures.MARKDOWN_PREVIEW)) {
	                previewLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'a',
	                    {
	                        onClick: this.showPreview,
	                        className: 'textbox-preview-link'
	                    },
	                    this.state.preview ? /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.edit',
	                        defaultMessage: 'Edit message'
	                    }) : /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.preview',
	                        defaultMessage: 'Preview'
	                    })
	                );
	            }
	
	            var helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                {
	                    style: { visibility: hasText ? 'visible' : 'hidden', opacity: hasText ? '0.3' : '0' },
	                    className: 'help__format-text'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'b',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.bold',
	                        defaultMessage: '**bold**'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'i',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.italic',
	                        defaultMessage: '_italic_'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'span',
	                    null,
	                    '~~',
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'strike',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'textbox.strike',
	                            defaultMessage: 'strike'
	                        })
	                    ),
	                    '~~ '
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'code',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.inlinecode',
	                        defaultMessage: '`inline code`'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'code',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.preformatted',
	                        defaultMessage: '```preformatted```'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'textbox.quote',
	                        defaultMessage: '>quote'
	                    })
	                )
	            );
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                {
	                    ref: 'wrapper',
	                    className: 'textarea-wrapper'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__suggestion_suggestion_box_jsx__["a"], {
	                    id: this.props.id,
	                    ref: 'message',
	                    className: 'form-control custom-textarea ' + this.state.connection,
	                    type: 'textarea',
	                    spellCheck: 'true',
	                    maxLength: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__["a"].MAX_POST_LEN,
	                    placeholder: this.props.createMessage,
	                    value: this.props.messageText,
	                    onUserInput: this.props.onUserInput,
	                    onKeyPress: this.handleKeyPress,
	                    onKeyDown: this.handleKeyDown,
	                    onHeightChange: this.handleHeightChange,
	                    style: { visibility: this.state.preview ? 'hidden' : 'visible' },
	                    listComponent: /* harmony import */__WEBPACK_IMPORTED_MODULE_9__suggestion_suggestion_list_jsx__["a"],
	                    providers: this.suggestionProviders,
	                    channelId: this.props.channelId
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', {
	                    ref: 'preview',
	                    className: 'form-control custom-textarea textbox-preview-area',
	                    style: { display: this.state.preview ? 'block' : 'none' },
	                    dangerouslySetInnerHTML: { __html: this.state.preview ? /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_text_formatting_jsx__.formatText(this.props.messageText) : '' }
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'help__text' },
	                    helpText,
	                    previewLink,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'a',
	                        {
	                            target: '_blank',
	                            href: 'http://docs.mattermost.com/help/getting-started/messaging-basics.html',
	                            className: 'textbox-help-link'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'textbox.help',
	                            defaultMessage: 'Help'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Textbox;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Textbox;
	
	
	Textbox.defaultProps = {
	    supportsCommands: true
	};
	
	Textbox.propTypes = {
	    id: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.string.isRequired,
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.string,
	    messageText: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.string.isRequired,
	    onUserInput: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func.isRequired,
	    onKeyPress: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func.isRequired,
	    createMessage: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.string.isRequired,
	    onKeyDown: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func,
	    supportsCommands: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.bool.isRequired
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events___default = __WEBPACK_IMPORTED_MODULE_8_events__ && __WEBPACK_IMPORTED_MODULE_8_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_events___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'changed';
	
	var IntegrationStore = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(IntegrationStore, _EventEmitter);
	
	    function IntegrationStore() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, IntegrationStore);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(IntegrationStore).call(this));
	
	        _this.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(_this.handleEventPayload.bind(_this));
	
	        _this.incomingWebhooks = new /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
	
	        _this.outgoingWebhooks = new /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
	
	        _this.commands = new /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(IntegrationStore, [{
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'hasReceivedIncomingWebhooks',
	        value: function hasReceivedIncomingWebhooks(teamId) {
	            return this.incomingWebhooks.has(teamId);
	        }
	    }, {
	        key: 'getIncomingWebhooks',
	        value: function getIncomingWebhooks(teamId) {
	            return this.incomingWebhooks.get(teamId) || [];
	        }
	    }, {
	        key: 'setIncomingWebhooks',
	        value: function setIncomingWebhooks(teamId, incomingWebhooks) {
	            this.incomingWebhooks.set(teamId, incomingWebhooks);
	        }
	    }, {
	        key: 'addIncomingWebhook',
	        value: function addIncomingWebhook(incomingWebhook) {
	            var teamId = incomingWebhook.team_id;
	            var incomingWebhooks = this.getIncomingWebhooks(teamId);
	
	            incomingWebhooks.push(incomingWebhook);
	
	            this.setIncomingWebhooks(teamId, incomingWebhooks);
	        }
	    }, {
	        key: 'removeIncomingWebhook',
	        value: function removeIncomingWebhook(teamId, id) {
	            var incomingWebhooks = this.getIncomingWebhooks(teamId);
	
	            incomingWebhooks = incomingWebhooks.filter(function (incomingWebhook) {
	                return incomingWebhook.id !== id;
	            });
	
	            this.setIncomingWebhooks(teamId, incomingWebhooks);
	        }
	    }, {
	        key: 'hasReceivedOutgoingWebhooks',
	        value: function hasReceivedOutgoingWebhooks(teamId) {
	            return this.outgoingWebhooks.has(teamId);
	        }
	    }, {
	        key: 'getOutgoingWebhooks',
	        value: function getOutgoingWebhooks(teamId) {
	            return this.outgoingWebhooks.get(teamId) || [];
	        }
	    }, {
	        key: 'setOutgoingWebhooks',
	        value: function setOutgoingWebhooks(teamId, outgoingWebhooks) {
	            this.outgoingWebhooks.set(teamId, outgoingWebhooks);
	        }
	    }, {
	        key: 'addOutgoingWebhook',
	        value: function addOutgoingWebhook(outgoingWebhook) {
	            var teamId = outgoingWebhook.team_id;
	            var outgoingWebhooks = this.getOutgoingWebhooks(teamId);
	
	            outgoingWebhooks.push(outgoingWebhook);
	
	            this.setOutgoingWebhooks(teamId, outgoingWebhooks);
	        }
	    }, {
	        key: 'updateOutgoingWebhook',
	        value: function updateOutgoingWebhook(outgoingWebhook) {
	            var teamId = outgoingWebhook.team_id;
	            var outgoingWebhooks = this.getOutgoingWebhooks(teamId);
	
	            for (var i = 0; i < outgoingWebhooks.length; i++) {
	                if (outgoingWebhooks[i].id === outgoingWebhook.id) {
	                    outgoingWebhooks[i] = outgoingWebhook;
	                    break;
	                }
	            }
	
	            this.setOutgoingWebhooks(teamId, outgoingWebhooks);
	        }
	    }, {
	        key: 'removeOutgoingWebhook',
	        value: function removeOutgoingWebhook(teamId, id) {
	            var outgoingWebhooks = this.getOutgoingWebhooks(teamId);
	
	            outgoingWebhooks = outgoingWebhooks.filter(function (outgoingWebhook) {
	                return outgoingWebhook.id !== id;
	            });
	
	            this.setOutgoingWebhooks(teamId, outgoingWebhooks);
	        }
	    }, {
	        key: 'hasReceivedCommands',
	        value: function hasReceivedCommands(teamId) {
	            return this.commands.has(teamId);
	        }
	    }, {
	        key: 'getCommands',
	        value: function getCommands(teamId) {
	            return this.commands.get(teamId) || [];
	        }
	    }, {
	        key: 'setCommands',
	        value: function setCommands(teamId, commands) {
	            this.commands.set(teamId, commands);
	        }
	    }, {
	        key: 'addCommand',
	        value: function addCommand(command) {
	            var teamId = command.team_id;
	            var commands = this.getCommands(teamId);
	
	            commands.push(command);
	
	            this.setCommands(teamId, commands);
	        }
	    }, {
	        key: 'updateCommand',
	        value: function updateCommand(command) {
	            var teamId = command.team_id;
	            var commands = this.getCommands(teamId);
	
	            for (var i = 0; i < commands.length; i++) {
	                if (commands[i].id === command.id) {
	                    commands[i] = command;
	                    break;
	                }
	            }
	
	            this.setCommands(teamId, commands);
	        }
	    }, {
	        key: 'removeCommand',
	        value: function removeCommand(teamId, id) {
	            var commands = this.getCommands(teamId);
	
	            commands = commands.filter(function (command) {
	                return command.id !== id;
	            });
	
	            this.setCommands(teamId, commands);
	        }
	    }, {
	        key: 'handleEventPayload',
	        value: function handleEventPayload(payload) {
	            var action = payload.action;
	
	            switch (action.type) {
	                case ActionTypes.RECEIVED_INCOMING_WEBHOOKS:
	                    this.setIncomingWebhooks(action.teamId, action.incomingWebhooks);
	                    this.emitChange();
	                    break;
	                case ActionTypes.RECEIVED_INCOMING_WEBHOOK:
	                    this.addIncomingWebhook(action.incomingWebhook);
	                    this.emitChange();
	                    break;
	                case ActionTypes.REMOVED_INCOMING_WEBHOOK:
	                    this.removeIncomingWebhook(action.teamId, action.id);
	                    this.emitChange();
	                    break;
	                case ActionTypes.RECEIVED_OUTGOING_WEBHOOKS:
	                    this.setOutgoingWebhooks(action.teamId, action.outgoingWebhooks);
	                    this.emitChange();
	                    break;
	                case ActionTypes.RECEIVED_OUTGOING_WEBHOOK:
	                    this.addOutgoingWebhook(action.outgoingWebhook);
	                    this.emitChange();
	                    break;
	                case ActionTypes.UPDATED_OUTGOING_WEBHOOK:
	                    this.updateOutgoingWebhook(action.outgoingWebhook);
	                    this.emitChange();
	                    break;
	                case ActionTypes.REMOVED_OUTGOING_WEBHOOK:
	                    this.removeOutgoingWebhook(action.teamId, action.id);
	                    this.emitChange();
	                    break;
	                case ActionTypes.RECEIVED_COMMANDS:
	                    this.setCommands(action.teamId, action.commands);
	                    this.emitChange();
	                    break;
	                case ActionTypes.RECEIVED_COMMAND:
	                    this.addCommand(action.command);
	                    this.emitChange();
	                    break;
	                case ActionTypes.UPDATED_COMMAND:
	                    this.updateCommand(action.command);
	                    this.emitChange();
	                    break;
	                case ActionTypes.REMOVED_COMMAND:
	                    this.removeCommand(action.teamId, action.id);
	                    this.emitChange();
	                    break;
	            }
	        }
	    }]);
	
	    return IntegrationStore;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_events___default.a);
	
	/* harmony default export */ exports["a"] = new IntegrationStore();

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(49)
	  , toIndex  = __webpack_require__(122)
	  , toLength = __webpack_require__(45);
	module.e = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $defineProperty = __webpack_require__(38)
	  , createDesc      = __webpack_require__(101);
	
	module.e = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(34)
	  , document = __webpack_require__(29).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.e = function(it){
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// IE 8- don't enum bug keys
	module.e = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var MATCH = __webpack_require__(35)('match');
	module.e = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(29).document && document.documentElement;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject       = __webpack_require__(34)
	  , setPrototypeOf = __webpack_require__(202).set;
	module.e = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// check on default Array iterator
	var Iterators  = __webpack_require__(115)
	  , ITERATOR   = __webpack_require__(35)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.e = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(74);
	module.e = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(34)
	  , floor    = Math.floor;
	module.e = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var create         = __webpack_require__(117)
	  , descriptor     = __webpack_require__(101)
	  , setToStringTag = __webpack_require__(144)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(56)(IteratorPrototype, __webpack_require__(35)('iterator'), function(){ return this; });
	
	module.e = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var LIBRARY        = __webpack_require__(116)
	  , $export        = __webpack_require__(9)
	  , redefine       = __webpack_require__(63)
	  , hide           = __webpack_require__(56)
	  , has            = __webpack_require__(53)
	  , Iterators      = __webpack_require__(115)
	  , $iterCreate    = __webpack_require__(263)
	  , setToStringTag = __webpack_require__(144)
	  , getPrototypeOf = __webpack_require__(69)
	  , ITERATOR       = __webpack_require__(35)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.e = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.e = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.28 Math.sign(x)
	module.e = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global    = __webpack_require__(29)
	  , macrotask = __webpack_require__(274).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(74)(process) == 'process';
	
	module.e = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var shared = __webpack_require__(203)('keys')
	  , uid    = __webpack_require__(123);
	module.e = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(24)
	  , aFunction = __webpack_require__(62)
	  , SPECIES   = __webpack_require__(35)('species');
	module.e = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toInteger = __webpack_require__(102)
	  , defined   = __webpack_require__(75);
	// true  -> String#at
	// false -> String#codePointAt
	module.e = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(198)
	  , defined  = __webpack_require__(75);
	
	module.e = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var toInteger = __webpack_require__(102)
	  , defined   = __webpack_require__(75);
	
	module.e = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ctx                = __webpack_require__(90)
	  , invoke             = __webpack_require__(197)
	  , html               = __webpack_require__(258)
	  , cel                = __webpack_require__(255)
	  , global             = __webpack_require__(29)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(74)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.e = {
	  set:   setTask,
	  clear: clearTask
	};


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var global         = __webpack_require__(29)
	  , DESCRIPTORS    = __webpack_require__(37)
	  , LIBRARY        = __webpack_require__(116)
	  , $typed         = __webpack_require__(204)
	  , hide           = __webpack_require__(56)
	  , redefineAll    = __webpack_require__(120)
	  , fails          = __webpack_require__(31)
	  , anInstance     = __webpack_require__(99)
	  , toInteger      = __webpack_require__(102)
	  , toLength       = __webpack_require__(45)
	  , gOPN           = __webpack_require__(118).f
	  , dP             = __webpack_require__(38).f
	  , arrayFill      = __webpack_require__(253)
	  , setToStringTag = __webpack_require__(144)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , parseInt       = global.parseInt
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , min            = Math.min
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global         = __webpack_require__(29)
	  , core           = __webpack_require__(82)
	  , LIBRARY        = __webpack_require__(116)
	  , wksExt         = __webpack_require__(481)
	  , defineProperty = __webpack_require__(38).f;
	module.e = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var classof   = __webpack_require__(142)
	  , ITERATOR  = __webpack_require__(35)('iterator')
	  , Iterators = __webpack_require__(115);
	module.e = __webpack_require__(82).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var addToUnscopables = __webpack_require__(141)
	  , step             = __webpack_require__(469)
	  , Iterators        = __webpack_require__(115)
	  , toIObject        = __webpack_require__(65);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.e = __webpack_require__(264)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ciphers = __webpack_require__(1301)
	exports.createCipher = exports.Cipher = ciphers.createCipher
	exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
	var deciphers = __webpack_require__(1300)
	exports.createDecipher = exports.Decipher = deciphers.createDecipher
	exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
	var modes = __webpack_require__(207)
	function getCiphers () {
	  return Object.keys(modes)
	}
	exports.listCiphers = exports.getCiphers = getCiphers
	


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var bn = __webpack_require__(39);
	var randomBytes = __webpack_require__(175);
	module.e = crt;
	function blind(priv) {
	  var r = getr(priv);
	  var blinder = r.toRed(bn.mont(priv.modulus))
	  .redPow(new bn(priv.publicExponent)).fromRed();
	  return {
	    blinder: blinder,
	    unblinder:r.invm(priv.modulus)
	  };
	}
	function crt(msg, priv) {
	  var blinds = blind(priv);
	  var len = priv.modulus.byteLength();
	  var mod = bn.mont(priv.modulus);
	  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
	  var c1 = blinded.toRed(bn.mont(priv.prime1));
	  var c2 = blinded.toRed(bn.mont(priv.prime2));
	  var qinv = priv.coefficient;
	  var p = priv.prime1;
	  var q = priv.prime2;
	  var m1 = c1.redPow(priv.exponent1);
	  var m2 = c2.redPow(priv.exponent2);
	  m1 = m1.fromRed();
	  m2 = m2.fromRed();
	  var h = m1.isub(m2).imul(qinv).umod(p);
	  h.imul(q);
	  m2.iadd(h);
	  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
	}
	crt.getr = getr;
	function getr(priv) {
	  var len = priv.modulus.byteLength();
	  var r = new bn(randomBytes(len));
	  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
	    r = new bn(randomBytes(len));
	  }
	  return r;
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(282)
	  , TAG = __webpack_require__(86)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.e = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 282 */
74,
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ctx         = __webpack_require__(166)
	  , call        = __webpack_require__(508)
	  , isArrayIter = __webpack_require__(507)
	  , anObject    = __webpack_require__(126)
	  , toLength    = __webpack_require__(515)
	  , getIterFn   = __webpack_require__(289);
	module.e = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var LIBRARY        = __webpack_require__(510)
	  , $export        = __webpack_require__(77)
	  , redefine       = __webpack_require__(287)
	  , hide           = __webpack_require__(169)
	  , has            = __webpack_require__(210)
	  , Iterators      = __webpack_require__(148)
	  , $iterCreate    = __webpack_require__(1332)
	  , setToStringTag = __webpack_require__(212)
	  , getProto       = __webpack_require__(43).getProto
	  , ITERATOR       = __webpack_require__(86)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.e = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(77)
	  , core    = __webpack_require__(46)
	  , fails   = __webpack_require__(168);
	module.e = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};


/***/ },
/* 286 */
101,
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(169);


/***/ },
/* 288 */
123,
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var classof   = __webpack_require__(281)
	  , ITERATOR  = __webpack_require__(86)('iterator')
	  , Iterators = __webpack_require__(148);
	module.e = __webpack_require__(46).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var createHash = __webpack_require__(149);
	var inherits = __webpack_require__(27)
	
	var Transform = __webpack_require__(157).Transform
	
	var ZEROS = new Buffer(128)
	ZEROS.fill(0)
	
	function Hmac(alg, key) {
	  Transform.call(this)
	  alg = alg.toLowerCase()
	  if (typeof key === 'string') {
	    key = new Buffer(key)
	  }
	
	  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64
	
	  this._alg = alg
	  this._key = key
	
	  if (key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	inherits(Hmac, Transform)
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	
	  return this
	}
	
	Hmac.prototype._transform = function (data, _, next) {
	  this._hash.update(data)
	
	  next()
	}
	
	Hmac.prototype._flush = function (next) {
	  this.push(this.digest())
	
	  next()
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	module.e = function createHmac(alg, key) {
	  return new Hmac(alg, key)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.utils = __webpack_require__(1365);
	exports.Cipher = __webpack_require__(1362);
	exports.DES = __webpack_require__(1363);
	exports.CBC = __webpack_require__(1361);
	exports.EDE = __webpack_require__(1364);
	


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var canUseDOM = __webpack_require__(127);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.e = on;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.e = exports['default'];


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.e = exports['default'];


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.e = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'right click': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 33,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}
	


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var identity = __webpack_require__(548);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.e = bindCallback;
	


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var getLength = __webpack_require__(539),
	    isLength = __webpack_require__(152);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.e = isArrayLike;
	


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isArrayLike = __webpack_require__(299),
	    isObjectLike = __webpack_require__(130);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.e = isArguments;
	


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObjectLike = __webpack_require__(130);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.e = isString;
	


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var getNative = __webpack_require__(223),
	    isArrayLike = __webpack_require__(299),
	    isObject = __webpack_require__(105),
	    shimKeys = __webpack_require__(1519),
	    support = __webpack_require__(305);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object == 'function' ? support.enumPrototypes : isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.e = keys;
	


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var arrayEach = __webpack_require__(1489),
	    isArguments = __webpack_require__(300),
	    isArray = __webpack_require__(104),
	    isFunction = __webpack_require__(547),
	    isIndex = __webpack_require__(541),
	    isLength = __webpack_require__(152),
	    isObject = __webpack_require__(105),
	    isString = __webpack_require__(301),
	    support = __webpack_require__(305);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/** Used to fix the JScript `[[DontEnum]]` bug. */
	var shadowProps = [
	  'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	  'toLocaleString', 'toString', 'valueOf'
	];
	
	/** Used for native method references. */
	var errorProto = Error.prototype,
	    objectProto = Object.prototype,
	    stringProto = String.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to avoid iterating over non-enumerable properties in IE < 9. */
	var nonEnumProps = {};
	nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
	nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
	nonEnumProps[objectTag] = { 'constructor': true };
	
	arrayEach(shadowProps, function(key) {
	  for (var tag in nonEnumProps) {
	    if (hasOwnProperty.call(nonEnumProps, tag)) {
	      var props = nonEnumProps[tag];
	      props[key] = hasOwnProperty.call(props, key);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
	      isProto = proto === object,
	      result = Array(length),
	      skipIndexes = length > 0,
	      skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
	      skipProto = support.enumPrototypes && isFunction(object);
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  // lodash skips the `constructor` property when it infers it's iterating
	  // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
	  // attribute of an existing property and the `constructor` property of a
	  // prototype defaults to non-enumerable.
	  for (var key in object) {
	    if (!(skipProto && key == 'prototype') &&
	        !(skipErrorProps && (key == 'message' || key == 'name')) &&
	        !(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  if (support.nonEnumShadows && object !== objectProto) {
	    var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
	        nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
	
	    if (tag == objectTag) {
	      proto = objectProto;
	    }
	    length = shadowProps.length;
	    while (length--) {
	      key = shadowProps[length];
	      var nonEnum = nonEnums[key];
	      if (!(isProto && nonEnum) &&
	          (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
	        result.push(key);
	      }
	    }
	  }
	  return result;
	}
	
	module.e = keysIn;
	


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var arrayMap = __webpack_require__(1490),
	    baseDifference = __webpack_require__(1494),
	    baseFlatten = __webpack_require__(534),
	    bindCallback = __webpack_require__(298),
	    keysIn = __webpack_require__(303),
	    pickByArray = __webpack_require__(544),
	    pickByCallback = __webpack_require__(545),
	    restParam = __webpack_require__(533);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.e = omit;
	


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/** Used for native method references. */
	var arrayProto = Array.prototype,
	    errorProto = Error.prototype,
	    objectProto = Object.prototype;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/**
	 * An object environment feature flags.
	 *
	 * @static
	 * @memberOf _
	 * @type Object
	 */
	var support = {};
	
	(function(x) {
	  var Ctor = function() { this.x = x; },
	      object = { '0': x, 'length': x },
	      props = [];
	
	  Ctor.prototype = { 'valueOf': x, 'y': x };
	  for (var key in new Ctor) { props.push(key); }
	
	  /**
	   * Detect if `name` or `message` properties of `Error.prototype` are
	   * enumerable by default (IE < 9, Safari < 5.1).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
	    propertyIsEnumerable.call(errorProto, 'name');
	
	  /**
	   * Detect if `prototype` properties are enumerable by default.
	   *
	   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	   * (if the prototype or a property on the prototype has been set)
	   * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
	   * property to `true`.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
	
	  /**
	   * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	   *
	   * In IE < 9 an object's own properties, shadowing non-enumerable ones,
	   * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.nonEnumShadows = !/valueOf/.test(props);
	
	  /**
	   * Detect if own properties are iterated after inherited properties (IE < 9).
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.ownLast = props[0] != 'x';
	
	  /**
	   * Detect if `Array#shift` and `Array#splice` augment array-like objects
	   * correctly.
	   *
	   * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
	   * `shift()` and `splice()` functions that fail to remove the last element,
	   * `value[0]`, of array-like objects even though the "length" property is
	   * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
	   * while `splice()` is buggy regardless of mode in IE < 9.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
	
	  /**
	   * Detect lack of support for accessing string characters by index.
	   *
	   * IE < 8 can't access characters by index. IE 8 can only access characters
	   * by index on string literals, not string objects.
	   *
	   * @memberOf _.support
	   * @type boolean
	   */
	  support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	}(1, 0));
	
	module.e = support;
	


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.e = nextTick;
	} else {
	  module.e = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactOverlaysLibTransition = __webpack_require__(573);
	
	var _reactOverlaysLibTransition2 = _interopRequireDefault(_reactOverlaysLibTransition);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(178);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var Fade = (function (_React$Component) {
	  _inherits(Fade, _React$Component);
	
	  function Fade() {
	    _classCallCheck(this, Fade);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  // Explicitly copied from Transition for doc generation.
	  // TODO: Remove duplication once #977 is resolved.
	
	  Fade.prototype.render = function render() {
	    var timeout = this.props.timeout || this.props.duration;
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibTransition2['default'],
	      _extends({}, this.props, {
	        timeout: timeout,
	        className: _classnames2['default'](this.props.className, 'fade'),
	        enteredClassName: 'in',
	        enteringClassName: 'in'
	      }),
	      this.props.children
	    );
	  };
	
	  return Fade;
	})(_react2['default'].Component);
	
	Fade.propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * duration
	   * @private
	   */
	  duration: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.number, 'Use `timeout`.'),
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	Fade.defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	exports['default'] = Fade;
	module.e = exports['default'];


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Glyphicon = _react2['default'].createClass({
	  displayName: 'Glyphicon',
	
	  propTypes: {
	    /**
	     * bootstrap className
	     * @private
	     */
	    bsClass: _react2['default'].PropTypes.string,
	    /**
	     * An icon name. See e.g. http://getbootstrap.com/components/#glyphicons
	     */
	    glyph: _react2['default'].PropTypes.string.isRequired,
	    /**
	     * Adds 'form-control-feedback' class
	     * @private
	     */
	    formControlFeedback: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'glyphicon',
	      formControlFeedback: false
	    };
	  },
	
	  render: function render() {
	    var _classNames;
	
	    var className = _classnames2['default'](this.props.className, (_classNames = {}, _classNames[this.props.bsClass] = true, _classNames['glyphicon-' + this.props.glyph] = true, _classNames['form-control-feedback'] = this.props.formControlFeedback, _classNames));
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: className }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Glyphicon;
	module.e = exports['default'];


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Grid = _react2['default'].createClass({
	  displayName: 'Grid',
	
	  propTypes: {
	    /**
	     * Turn any fixed-width grid layout into a full-width layout by this property.
	     *
	     * Adds `container-fluid` class.
	     */
	    fluid: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div',
	      fluid: false
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	    var className = this.props.fluid ? 'container-fluid' : 'container';
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, className) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Grid;
	module.e = exports['default'];


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormGroup = __webpack_require__(558);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _Glyphicon = __webpack_require__(308);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var InputBase = (function (_React$Component) {
	  _inherits(InputBase, _React$Component);
	
	  function InputBase() {
	    _classCallCheck(this, InputBase);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  InputBase.prototype.getInputDOMNode = function getInputDOMNode() {
	    return this.refs.input;
	  };
	
	  InputBase.prototype.getValue = function getValue() {
	    if (this.props.type === 'static') {
	      return this.props.value;
	    } else if (this.props.type) {
	      if (this.props.type === 'select' && this.props.multiple) {
	        return this.getSelectedOptions();
	      }
	      return this.getInputDOMNode().value;
	    }
	    throw new Error('Cannot use getValue without specifying input type.');
	  };
	
	  InputBase.prototype.getChecked = function getChecked() {
	    return this.getInputDOMNode().checked;
	  };
	
	  InputBase.prototype.getSelectedOptions = function getSelectedOptions() {
	    var values = [];
	
	    Array.prototype.forEach.call(this.getInputDOMNode().getElementsByTagName('option'), function (option) {
	      if (option.selected) {
	        var value = option.getAttribute('value') || option.innerHtml;
	        values.push(value);
	      }
	    });
	
	    return values;
	  };
	
	  InputBase.prototype.isCheckboxOrRadio = function isCheckboxOrRadio() {
	    return this.props.type === 'checkbox' || this.props.type === 'radio';
	  };
	
	  InputBase.prototype.isFile = function isFile() {
	    return this.props.type === 'file';
	  };
	
	  InputBase.prototype.renderInputGroup = function renderInputGroup(children) {
	    var addonBefore = this.props.addonBefore ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-addon', key: 'addonBefore' },
	      this.props.addonBefore
	    ) : null;
	
	    var addonAfter = this.props.addonAfter ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-addon', key: 'addonAfter' },
	      this.props.addonAfter
	    ) : null;
	
	    var buttonBefore = this.props.buttonBefore ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-btn' },
	      this.props.buttonBefore
	    ) : null;
	
	    var buttonAfter = this.props.buttonAfter ? _react2['default'].createElement(
	      'span',
	      { className: 'input-group-btn' },
	      this.props.buttonAfter
	    ) : null;
	
	    var inputGroupClassName = undefined;
	    switch (this.props.bsSize) {
	      case 'small':
	        inputGroupClassName = 'input-group-sm';break;
	      case 'large':
	        inputGroupClassName = 'input-group-lg';break;
	      default:
	    }
	
	    return addonBefore || addonAfter || buttonBefore || buttonAfter ? _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](inputGroupClassName, 'input-group'), key: 'input-group' },
	      addonBefore,
	      buttonBefore,
	      children,
	      addonAfter,
	      buttonAfter
	    ) : children;
	  };
	
	  InputBase.prototype.renderIcon = function renderIcon() {
	    if (this.props.hasFeedback) {
	      if (this.props.feedbackIcon) {
	        return _react2['default'].cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
	      }
	
	      switch (this.props.bsStyle) {
	        case 'success':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'ok', key: 'icon' });
	        case 'warning':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'warning-sign', key: 'icon' });
	        case 'error':
	          return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'remove', key: 'icon' });
	        default:
	          return _react2['default'].createElement('span', { className: 'form-control-feedback', key: 'icon' });
	      }
	    } else {
	      return null;
	    }
	  };
	
	  InputBase.prototype.renderHelp = function renderHelp() {
	    return this.props.help ? _react2['default'].createElement(
	      'span',
	      { className: 'help-block', key: 'help' },
	      this.props.help
	    ) : null;
	  };
	
	  InputBase.prototype.renderCheckboxAndRadioWrapper = function renderCheckboxAndRadioWrapper(children) {
	    var classes = {
	      'checkbox': this.props.type === 'checkbox',
	      'radio': this.props.type === 'radio'
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](classes), key: 'checkboxRadioWrapper' },
	      children
	    );
	  };
	
	  InputBase.prototype.renderWrapper = function renderWrapper(children) {
	    return this.props.wrapperClassName ? _react2['default'].createElement(
	      'div',
	      { className: this.props.wrapperClassName, key: 'wrapper' },
	      children
	    ) : children;
	  };
	
	  InputBase.prototype.renderLabel = function renderLabel(children) {
	    var classes = {
	      'control-label': !this.isCheckboxOrRadio()
	    };
	    classes[this.props.labelClassName] = this.props.labelClassName;
	
	    return this.props.label ? _react2['default'].createElement(
	      'label',
	      { htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
	      children,
	      this.props.label
	    ) : children;
	  };
	
	  InputBase.prototype.renderInput = function renderInput() {
	    if (!this.props.type) {
	      return this.props.children;
	    }
	
	    switch (this.props.type) {
	      case 'select':
	        return _react2['default'].createElement(
	          'select',
	          _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control'), ref: 'input', key: 'input' }),
	          this.props.children
	        );
	      case 'textarea':
	        return _react2['default'].createElement('textarea', _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control'), ref: 'input', key: 'input' }));
	      case 'static':
	        return _react2['default'].createElement(
	          'p',
	          _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control-static'), ref: 'input', key: 'input' }),
	          this.props.value
	        );
	      default:
	        var className = this.isCheckboxOrRadio() || this.isFile() ? '' : 'form-control';
	        return _react2['default'].createElement('input', _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), ref: 'input', key: 'input' }));
	    }
	  };
	
	  InputBase.prototype.renderFormGroup = function renderFormGroup(children) {
	    return _react2['default'].createElement(
	      _FormGroup2['default'],
	      this.props,
	      children
	    );
	  };
	
	  InputBase.prototype.renderChildren = function renderChildren() {
	    return !this.isCheckboxOrRadio() ? [this.renderLabel(), this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderIcon(), this.renderHelp()])] : this.renderWrapper([this.renderCheckboxAndRadioWrapper(this.renderLabel(this.renderInput())), this.renderHelp()]);
	  };
	
	  InputBase.prototype.render = function render() {
	    var children = this.renderChildren();
	    return this.renderFormGroup(children);
	  };
	
	  return InputBase;
	})(_react2['default'].Component);
	
	InputBase.propTypes = {
	  type: _react2['default'].PropTypes.string,
	  label: _react2['default'].PropTypes.node,
	  help: _react2['default'].PropTypes.node,
	  addonBefore: _react2['default'].PropTypes.node,
	  addonAfter: _react2['default'].PropTypes.node,
	  buttonBefore: _react2['default'].PropTypes.node,
	  buttonAfter: _react2['default'].PropTypes.node,
	  bsSize: _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']),
	  bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  hasFeedback: _react2['default'].PropTypes.bool,
	  feedbackIcon: _react2['default'].PropTypes.node,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  groupClassName: _react2['default'].PropTypes.string,
	  wrapperClassName: _react2['default'].PropTypes.string,
	  labelClassName: _react2['default'].PropTypes.string,
	  multiple: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  value: _react2['default'].PropTypes.any
	};
	
	InputBase.defaultProps = {
	  disabled: false,
	  hasFeedback: false,
	  multiple: false
	};
	
	exports['default'] = InputBase;
	module.e = exports['default'];


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var NavbarBrand = (function (_React$Component) {
	  _inherits(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    _classCallCheck(this, NavbarBrand);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children']);
	
	    var _context$$bs_navbar_bsClass = this.context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	
	    var brandClasses = _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: _classnames2['default'](children.props.className, className, brandClasses)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, props, { className: _classnames2['default'](className, brandClasses) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	})(_react2['default'].Component);
	
	NavbarBrand.contextTypes = {
	  $bs_navbar_bsClass: _react2['default'].PropTypes.string
	};
	
	exports['default'] = NavbarBrand;
	module.e = exports['default'];


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	exports['default'] = valueValidation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTypesLibSinglePropFrom = __webpack_require__(1621);
	
	var _reactPropTypesLibSinglePropFrom2 = _interopRequireDefault(_reactPropTypesLibSinglePropFrom);
	
	function valueValidation(props, propName, componentName) {
	  var error = _reactPropTypesLibSinglePropFrom2['default']('children', 'value')(props, propName, componentName);
	
	  if (!error) {
	    error = _react2['default'].PropTypes.node(props, propName, componentName);
	  }
	
	  return error;
	}
	
	module.e = exports['default'];


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getContainer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2['default'].findDOMNode(container) || defaultContainer;
	}
	
	module.e = exports['default'];


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _common = __webpack_require__(576);
	
	/**
	 * Checks whether a prop provides a DOM element
	 *
	 * The element can be provided in two forms:
	 * - Directly passed
	 * - Or passed an object that has a `render` method
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	
	function validate(props, propName, componentName) {
	  if (typeof props[propName] !== 'object' || typeof props[propName].render !== 'function' && props[propName].nodeType !== 1) {
	    return new Error(_common.errMsg(props, propName, componentName, ', expected a DOM element or an object that has a `render` method'));
	  }
	}
	
	exports['default'] = _common.createChainableTypeChecker(validate);
	module.e = exports['default'];


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.errMsg = errMsg;
	exports.createChainableTypeChecker = createChainableTypeChecker;
	
	function errMsg(props, propName, componentName, msgContinuation) {
	  return 'Invalid prop \'' + propName + '\' of value \'' + props[propName] + '\'' + (' supplied to \'' + componentName + '\'' + msgContinuation);
	}
	
	/**
	 * Create chain-able isRequired validator
	 *
	 * Largely copied directly from:
	 *  https://github.com/facebook/react/blob/0.11-stable/src/core/ReactPropTypes.js#L94
	 */
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName) {
	    componentName = componentName || '<<anonymous>>';
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required prop \'' + propName + '\' was not specified in \'' + componentName + '\'.');
	      }
	    } else {
	      return validate(props, propName, componentName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isRequiredForA11y;
	
	function isRequiredForA11y(propType) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] == null) {
	      return new Error("The prop '" + propName + "' is required to make '" + componentName + "' accessible" + " for users using assistive technologies such as screen readers");
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	
	module.e = exports["default"];


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(583);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1635);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = _react2['default'].createClass({
	  displayName: 'RouterContext',
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2['default'].createElement
	    };
	  },
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? _routerWarning2['default'](false, '`<RouterContext>` expects a `router` rather than a `history`') : undefined;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = _deprecateObjectProperties2['default'](location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = _getRouteParams2['default'](route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if (_RouteUtils.isReactChildren(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (element.hasOwnProperty(prop)) props[prop] = element[prop];
	          }
	        }
	
	        if (typeof components === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (components.hasOwnProperty(key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2['default'].isValidElement(element)) ?  false ? _invariant2['default'](false, 'The root route must render a single element') : _invariant2['default'](false) : undefined;
	
	    return element;
	  }
	
	});
	
	exports['default'] = RouterContext;
	module.e = exports['default'];


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = createTransitionManager;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _historyLibActions = __webpack_require__(151);
	
	var _computeChangedRoutes2 = __webpack_require__(1633);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1631);
	
	var _isActive2 = __webpack_require__(1637);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1634);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1639);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = undefined;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? _routerWarning2['default'](false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : undefined;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return _isActive3['default'](location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _historyLibActions.REPLACE);
	  }
	
	  var partialNextState = undefined;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      _matchRoutes2['default'](routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = _computeChangedRoutes3['default'](state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    _TransitionUtils.runLeaveHooks(leaveRoutes);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    _TransitionUtils.runEnterHooks(enterRoutes, nextState, function (error, redirectInfo) {
	      if (error) {
	        callback(error);
	      } else if (redirectInfo) {
	        callback(null, createLocationFromRedirectInfo(redirectInfo));
	      } else {
	        // TODO: Fetch components after state is updated.
	        _getComponents2['default'](nextState, function (error, components) {
	          if (error) {
	            callback(error);
	          } else {
	            // TODO: Make match a pure function and have some other API
	            // for "match and update state".
	            callback(null, null, state = _extends({}, nextState, { components: components }));
	          }
	        });
	      }
	    });
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = {};
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    _matchRoutes2['default'](routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes(_computeChangedRoutes3['default'](state, partialNextState).leaveRoutes);
	
	      var result = undefined;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = undefined;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = undefined,
	      unlistenBeforeUnload = undefined;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and must return either a) a prompt message to show
	   * the user, to make sure they want to leave the page or b) false, to prevent
	   * the transition.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? _routerWarning2['default'](false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : undefined;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? _routerWarning2['default'](false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : undefined;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	module.e = exports['default'];


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(110);
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.e = CallbackQueue;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(154);
	var ReactPerf = __webpack_require__(78);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1697);
	var warning = __webpack_require__(33);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.e = DOMPropertyOperations;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(606);
	var ReactPropTypeLocations = __webpack_require__(232);
	
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.e = LinkedValueUtils;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(325);
	var ReactMount = __webpack_require__(60);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.e = ReactComponentBrowserEnvironment;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.e = ReactComponentEnvironment;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(586);
	var DOMPropertyOperations = __webpack_require__(321);
	var ReactMount = __webpack_require__(60);
	var ReactPerf = __webpack_require__(78);
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.e = ReactDOMIDOperations;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactElement = __webpack_require__(67);
	var ReactInstanceMap = __webpack_require__(181);
	var ReactUpdates = __webpack_require__(79);
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.e = ReactUpdateQueue;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.e = '0.14.7';


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactInstanceMap = __webpack_require__(181);
	var ReactMount = __webpack_require__(60);
	
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.e = findDOMNode;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.e = getEventCharCode;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.e = getEventModifierState;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.e = getEventTarget;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.e = getIteratorFn;


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(1658);
	var ReactEmptyComponent = __webpack_require__(598);
	var ReactNativeComponent = __webpack_require__(604);
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.e = instantiateReactComponent;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.e = isEventSupported;


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	var escapeTextContentForBrowser = __webpack_require__(236);
	var setInnerHTML = __webpack_require__(237);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.e = setTextContent;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.e = shouldUpdateReactComponent;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactElement = __webpack_require__(67);
	var ReactInstanceHandles = __webpack_require__(155);
	
	var getIteratorFn = __webpack_require__(332);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.e = traverseAllChildren;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(32);
	var emptyFunction = __webpack_require__(88);
	var warning = __webpack_require__(33);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.e = validateDOMNesting;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.e = shallowEqual;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.e = Transform;
	
	var Duplex = __webpack_require__(137);
	
	/*<replacement>*/
	var util = __webpack_require__(172);
	util.inherits = __webpack_require__(27);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er) {
	      done(stream, er);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	function done(stream, er) {
	  if (er) return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	module.e = Writable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(306);
	/*</replacement>*/
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(19).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(172);
	util.inherits = __webpack_require__(27);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1735)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(157);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(40).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(19).Buffer;
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	var Duplex;
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(137);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // create the two objects needed to store the corked requests
	  // they are not a linked list, as no new elements are inserted in there
	  this.corkedRequestsFree = new CorkedRequest(this);
	  this.corkedRequestsFree.next = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function writableStateGetBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	  } catch (_) {}
	})();
	
	var Duplex;
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(137);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) processNextTick(cb, er);else cb(er);
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	        afterWrite(stream, state, finished, cb);
	      }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    state.corkedRequestsFree = holder.next;
	    holder.next = null;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	
	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107), __webpack_require__(343).setImmediate))

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(19).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}
	


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var nextTick = __webpack_require__(107).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(343).setImmediate, __webpack_require__(343).clearImmediate))

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var AboutBuildModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AboutBuildModal, _React$Component);
	
	    function AboutBuildModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AboutBuildModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AboutBuildModal).call(this, props));
	
	        _this.doHide = _this.doHide.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AboutBuildModal, [{
	        key: 'doHide',
	        value: function doHide() {
	            this.props.onModalDismissed();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var config = global.window.mm_config;
	            var license = global.window.mm_license;
	            var mattermostLogo = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].MATTERMOST_ICON_SVG;
	
	            var title = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                id: 'about.teamEditiont0',
	                defaultMessage: 'Team Edition'
	            });
	
	            var subTitle = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                id: 'about.teamEditionSt',
	                defaultMessage: 'All your team communication in one place, instantly searchable and accessible anywhere.'
	            });
	
	            var learnMore = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                    id: 'about.teamEditionLearn',
	                    defaultMessage: 'Join the Mattermost community at '
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'a',
	                    {
	                        target: '_blank',
	                        href: 'http://www.mattermost.org/'
	                    },
	                    'mattermost.org'
	                )
	            );
	
	            var licensee = void 0;
	            if (config.BuildEnterpriseReady === 'true') {
	                title = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                    id: 'about.teamEditiont1',
	                    defaultMessage: 'Enterprise Edition'
	                });
	
	                subTitle = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                    id: 'about.enterpriseEditionSt',
	                    defaultMessage: 'Modern enterprise communication from behind your firewall.'
	                });
	
	                learnMore = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'about.enterpriseEditionLearn',
	                        defaultMessage: 'Learn more about Enterprise Edition at '
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'a',
	                        {
	                            target: '_blank',
	                            href: 'http://about.mattermost.com/'
	                        },
	                        'about.mattermost.com'
	                    )
	                );
	
	                if (license.IsLicensed === 'true') {
	                    title = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'about.enterpriseEditione1',
	                        defaultMessage: 'Enterprise Edition'
	                    });
	                    licensee = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'about.licensed',
	                            defaultMessage: 'Licensed by:'
	                        }),
	                        ' ',
	                        license.Company
	                    );
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
	                {
	                    dialogClassName: 'about-modal',
	                    show: this.props.show,
	                    onHide: this.doHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'about.title',
	                            defaultMessage: 'About Mattermost'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'about-modal__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            { className: 'about-modal__logo' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', {
	                                className: 'icon',
	                                dangerouslySetInnerHTML: { __html: mattermostLogo }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'h3',
	                                { className: 'about-modal__title' },
	                                'Mattermost',
	                                ' ',
	                                title
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'p',
	                                { className: 'about-modal__subtitle padding-bottom' },
	                                subTitle
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'div',
	                                { className: 'form-group less' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                    'div',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                        id: 'about.version',
	                                        defaultMessage: 'Version:'
	                                    }),
	                                    ' ',
	                                    config.Version,
	                                    ' (',
	                                    config.BuildNumber,
	                                    ')'
	                                )
	                            ),
	                            licensee
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'about-modal__footer' },
	                        learnMore,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group about-modal__copyright' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'about.copyright',
	                                defaultMessage: 'Copyright 2016 Mattermost, Inc. All rights reserved'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'about-modal__hash form-group padding-top x2' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'about.hash',
	                                defaultMessage: 'Build Hash:'
	                            }),
	                            ' ',
	                            config.BuildHash
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'about.date',
	                                defaultMessage: 'Build Date:'
	                            }),
	                            ' ',
	                            config.BuildDate
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AboutBuildModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AboutBuildModal;
	
	
	AboutBuildModal.defaultProps = {
	    show: false
	};
	
	AboutBuildModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.bool.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdown_setting_jsx__ = __webpack_require__(647);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var CONNECTION_SECURITY_HELP_TEXT = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	    'div',
	    { className: 'help-text' },
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	        'table',
	        {
	            className: 'table table-bordered table-margin--none',
	            cellPadding: '5'
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	            'tbody',
	            null,
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'tr',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'td',
	                    { className: 'help-text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.connectionSecurityNone',
	                        defaultMessage: 'None'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'td',
	                    { className: 'help-text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.connectionSecurityNoneDescription',
	                        defaultMessage: 'Mattermost will connect over an unsecure connection.'
	                    })
	                )
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'tr',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'td',
	                    { className: 'help-text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.connectionSecurityTls',
	                        defaultMessage: 'TLS'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'td',
	                    { className: 'help-text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.connectionSecurityTlsDescription',
	                        defaultMessage: 'Encrypts the communication between Mattermost and your server.'
	                    })
	                )
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'tr',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'td',
	                    { className: 'help-text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.connectionSecurityStart',
	                        defaultMessage: 'STARTTLS'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'td',
	                    { className: 'help-text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.connectionSecurityStartDescription',
	                        defaultMessage: 'Takes an existing insecure connection and attempts to upgrade it to a secure connection using TLS.'
	                    })
	                )
	            )
	        )
	    )
	);
	
	var ConnectionSecurityDropdownSetting = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ConnectionSecurityDropdownSetting, _React$Component);
	
	    function ConnectionSecurityDropdownSetting() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ConnectionSecurityDropdownSetting);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ConnectionSecurityDropdownSetting).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ConnectionSecurityDropdownSetting, [{
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__dropdown_setting_jsx__["a"], {
	                values: [{ value: '', text: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.localizeMessage('admin.connectionSecurityNone', 'None') }, { value: 'TLS', text: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.localizeMessage('admin.connectionSecurityTls', 'TLS (Recommended)') }, { value: 'STARTTLS', text: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.localizeMessage('admin.connectionSecurityStart') }],
	                label: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                    id: 'admin.connectionSecurityTitle',
	                    defaultMessage: 'Connection Security:'
	                }),
	                currentValue: this.props.currentValue,
	                handleChange: this.props.handleChange,
	                isDisabled: this.props.isDisabled,
	                helpText: CONNECTION_SECURITY_HELP_TEXT,
	                margin: 'small'
	            });
	        }
	    }]);
	
	    return ConnectionSecurityDropdownSetting;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ConnectionSecurityDropdownSetting;
	
	ConnectionSecurityDropdownSetting.defaultProps = {};
	
	ConnectionSecurityDropdownSetting.propTypes = {
	    currentValue: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
	    handleChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
	    isDisabled: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool.isRequired
	};

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var SelectTeamModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SelectTeamModal, _React$Component);
	
	    function SelectTeamModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SelectTeamModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SelectTeamModal).call(this, props));
	
	        _this.doSubmit = _this.doSubmit.bind(_this);
	        _this.doCancel = _this.doCancel.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SelectTeamModal, [{
	        key: 'doSubmit',
	        value: function doSubmit(e) {
	            e.preventDefault();
	            this.props.onModalSubmit(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.team).value);
	        }
	    }, {
	        key: 'doCancel',
	        value: function doCancel() {
	            this.props.onModalDismissed();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.teams == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null);
	            }
	
	            var options = [];
	
	            for (var key in this.props.teams) {
	                if (this.props.teams.hasOwnProperty(key)) {
	                    var team = this.props.teams[key];
	                    options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'option',
	                        {
	                            key: 'opt_' + team.id,
	                            value: team.id
	                        },
	                        team.name
	                    ));
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.doCancel
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'admin.select_team.selectTeam',
	                            defaultMessage: 'Select Team'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'form',
	                    {
	                        role: 'form',
	                        className: 'form-horizontal'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-12' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                    'select',
	                                    {
	                                        ref: 'team',
	                                        size: '10',
	                                        className: 'form-control'
	                                    },
	                                    options
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-default',
	                                onClick: this.doCancel
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'admin.select_team.close',
	                                defaultMessage: 'Close'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'button',
	                            {
	                                onClick: this.doSubmit,
	                                type: 'submit',
	                                className: 'btn btn-primary',
	                                tabIndex: '2'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'admin.select_team.select',
	                                defaultMessage: 'Select'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectTeamModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SelectTeamModal;
	
	
	SelectTeamModal.defaultProps = {
	    show: false
	};
	
	SelectTeamModal.propTypes = {
	    teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.bool.isRequired,
	    onModalSubmit: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func
	};

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var Setting = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Setting, _React$Component);
	
	    function Setting() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Setting);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Setting).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Setting, [{
	        key: 'render',
	        value: function render() {
	            var marginClass = '';
	            if (this.props.margin === 'small') {
	                marginClass = ' form-group--small';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'form-group' + marginClass },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'label',
	                    {
	                        className: 'control-label col-sm-4'
	                    },
	                    this.props.label
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-8' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Setting;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Setting;
	
	Setting.defaultProps = {};
	
	Setting.propTypes = {
	    label: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	    margin: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.oneOf(['', 'small'])
	};

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__(502);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __WEBPACK_IMPORTED_MODULE_9_chart_js__ && __WEBPACK_IMPORTED_MODULE_9_chart_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_chart_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_chart_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_chart_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_chart_js___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var LineChart = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LineChart, _React$Component);
	
	    function LineChart(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LineChart);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LineChart).call(this, props));
	
	        _this.initChart = _this.initChart.bind(_this);
	        _this.chart = null;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LineChart, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initChart();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.areObjectsEqual(prevProps.data, this.props.data) || !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.areObjectsEqual(prevProps.options, this.props.options)) {
	                if (this.chart) {
	                    this.chart.destroy();
	                }
	                this.initChart();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.chart) {
	                this.chart.destroy();
	            }
	        }
	    }, {
	        key: 'initChart',
	        value: function initChart() {
	            if (!this.refs.canvas) {
	                return;
	            }
	            var el = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.canvas);
	            var ctx = el.getContext('2d');
	            this.chart = new /* harmony import */__WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(ctx).Line(this.props.data, this.props.options || {}); //eslint-disable-line new-cap
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = void 0;
	            if (this.props.data == null) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                    id: 'analytics.chart.loading',
	                    defaultMessage: 'Loading...'
	                });
	            } else if (this.props.data.labels.length === 0) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h5',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                        id: 'analytics.chart.meaningful',
	                        defaultMessage: 'Not enough data for a meaningful representation.'
	                    })
	                );
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('canvas', {
	                    ref: 'canvas',
	                    width: this.props.width,
	                    height: this.props.height
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'total-count by-day' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'title' },
	                        this.props.title
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'content' },
	                        content
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LineChart;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = LineChart;
	
	
	LineChart.propTypes = {
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node.isRequired,
	    width: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	    height: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	    data: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object,
	    options: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object
	};

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var StatisticCount = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(StatisticCount, _React$Component);
	
	    function StatisticCount() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, StatisticCount);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(StatisticCount).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(StatisticCount, [{
	        key: 'render',
	        value: function render() {
	            var loading = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                id: 'analytics.chart.loading',
	                defaultMessage: 'Loading...'
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'col-sm-3' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'total-count' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'title' },
	                        this.props.title,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', { className: 'fa ' + this.props.icon })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'content' },
	                        this.props.count == null ? loading : this.props.count
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StatisticCount;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = StatisticCount;
	
	
	StatisticCount.propTypes = {
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node.isRequired,
	    icon: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
	    count: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.number
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__line_chart_jsx__ = __webpack_require__(348);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__doughnut_chart_jsx__ = __webpack_require__(664);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__ = __webpack_require__(349);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__ = __webpack_require__(374);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	/* unused harmony export formatChannelDoughtnutData *//* unused harmony export formatPostDoughtnutData *//* harmony export */ exports["a"] = formatPostsPerDayData;/* harmony export */ exports["b"] = formatUsersWithPostsPerDayData;'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var StatTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].StatTypes;
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["defineMessages"].bind()({
	    analyticsPublicChannels: {
	        id: 'analytics.system.publicChannels',
	        defaultMessage: 'Public Channels'
	    },
	    analyticsPrivateGroups: {
	        id: 'analytics.system.privateGroups',
	        defaultMessage: 'Private Groups'
	    },
	    analyticsFilePosts: {
	        id: 'analytics.system.totalFilePosts',
	        defaultMessage: 'Posts with Files'
	    },
	    analyticsHashtagPosts: {
	        id: 'analytics.system.totalHashtagPosts',
	        defaultMessage: 'Posts with Hashtags'
	    },
	    analyticsTextPosts: {
	        id: 'analytics.system.textPosts',
	        defaultMessage: 'Posts with Text-only'
	    }
	});
	
	
	
	var SystemAnalytics = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SystemAnalytics, _React$Component);
	
	    function SystemAnalytics(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SystemAnalytics);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SystemAnalytics).call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	
	        _this.state = { stats: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].getAllSystem() };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SystemAnalytics, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].addChangeListener(this.onChange);
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getStandardAnalytics();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPostsPerDayAnalytics();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getUsersPerDayAnalytics();
	
	            if (global.window.mm_license.IsLicensed === 'true') {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getAdvancedAnalytics();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].removeChangeListener(this.onChange);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(nextState.stats, this.state.stats)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.setState({ stats: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].getAllSystem() });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stats = this.state.stats;
	
	            var advancedCounts = void 0;
	            var advancedGraphs = void 0;
	            if (global.window.mm_license.IsLicensed === 'true') {
	                advancedCounts = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalSessions',
	                            defaultMessage: 'Total Sessions'
	                        }),
	                        icon: 'fa-signal',
	                        count: stats[StatTypes.TOTAL_SESSIONS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalCommands',
	                            defaultMessage: 'Total Commands'
	                        }),
	                        icon: 'fa-terminal',
	                        count: stats[StatTypes.TOTAL_COMMANDS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalIncomingWebhooks',
	                            defaultMessage: 'Incoming Webhooks'
	                        }),
	                        icon: 'fa-arrow-down',
	                        count: stats[StatTypes.TOTAL_IHOOKS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalOutgoingWebhooks',
	                            defaultMessage: 'Outgoing Webhooks'
	                        }),
	                        icon: 'fa-arrow-up',
	                        count: stats[StatTypes.TOTAL_OHOOKS]
	                    })
	                );
	
	                var channelTypeData = formatChannelDoughtnutData(stats[StatTypes.TOTAL_PUBLIC_CHANNELS], stats[StatTypes.TOTAL_PRIVATE_GROUPS], this.props.intl);
	                var postTypeData = formatPostDoughtnutData(stats[StatTypes.TOTAL_FILE_POSTS], stats[StatTypes.TOTAL_HASHTAG_POSTS], stats[StatTypes.TOTAL_POSTS], this.props.intl);
	
	                advancedGraphs = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__doughnut_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.channelTypes',
	                            defaultMessage: 'Channel Types'
	                        }),
	                        data: channelTypeData,
	                        width: '300',
	                        height: '225'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__doughnut_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.postTypes',
	                            defaultMessage: 'Posts, Files and Hashtags'
	                        }),
	                        data: postTypeData,
	                        width: '300',
	                        height: '225'
	                    })
	                );
	            }
	
	            var postCountsDay = formatPostsPerDayData(stats[StatTypes.POST_PER_DAY]);
	            var userCountsWithPostsDay = formatUsersWithPostsPerDayData(stats[StatTypes.USERS_WITH_POSTS_PER_DAY]);
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed team_statistics' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'analytics.system.title',
	                        defaultMessage: 'System Statistics'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalUsers',
	                            defaultMessage: 'Total Users'
	                        }),
	                        icon: 'fa-user',
	                        count: stats[StatTypes.TOTAL_USERS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalTeams',
	                            defaultMessage: 'Total Teams'
	                        }),
	                        icon: 'fa-users',
	                        count: stats[StatTypes.TOTAL_TEAMS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalPosts',
	                            defaultMessage: 'Total Posts'
	                        }),
	                        icon: 'fa-comment',
	                        count: stats[StatTypes.TOTAL_POSTS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalChannels',
	                            defaultMessage: 'Total Channels'
	                        }),
	                        icon: 'fa-globe',
	                        count: stats[StatTypes.TOTAL_PUBLIC_CHANNELS] + stats[StatTypes.TOTAL_PRIVATE_GROUPS]
	                    })
	                ),
	                advancedCounts,
	                advancedGraphs,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__line_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.totalPosts',
	                            defaultMessage: 'Total Posts'
	                        }),
	                        data: postCountsDay,
	                        width: '740',
	                        height: '225'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__line_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'analytics.system.activeUsers',
	                            defaultMessage: 'Active Users With Posts'
	                        }),
	                        data: userCountsWithPostsDay,
	                        width: '740',
	                        height: '225'
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SystemAnalytics;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	SystemAnalytics.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["intlShape"].isRequired,
	    team: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["c"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["injectIntl"].bind()(SystemAnalytics);
	
	function formatChannelDoughtnutData(totalPublic, totalPrivate, intl) {
	    var formatMessage = intl.formatMessage;
	
	    var channelTypeData = [{
	        value: totalPublic,
	        color: '#46BFBD',
	        highlight: '#5AD3D1',
	        label: formatMessage(holders.analyticsPublicChannels)
	    }, {
	        value: totalPrivate,
	        color: '#FDB45C',
	        highlight: '#FFC870',
	        label: formatMessage(holders.analyticsPrivateGroups)
	    }];
	
	    return channelTypeData;
	}
	
	function formatPostDoughtnutData(filePosts, hashtagPosts, totalPosts, intl) {
	    var formatMessage = intl.formatMessage;
	
	    var postTypeData = [{
	        value: filePosts,
	        color: '#46BFBD',
	        highlight: '#5AD3D1',
	        label: formatMessage(holders.analyticsFilePosts)
	    }, {
	        value: hashtagPosts,
	        color: '#F7464A',
	        highlight: '#FF5A5E',
	        label: formatMessage(holders.analyticsHashtagPosts)
	    }, {
	        value: totalPosts - filePosts - hashtagPosts,
	        color: '#FDB45C',
	        highlight: '#FFC870',
	        label: formatMessage(holders.analyticsTextPosts)
	    }];
	
	    return postTypeData;
	}
	
	function formatPostsPerDayData(data) {
	    var chartData = {
	        labels: [],
	        datasets: [{
	            fillColor: 'rgba(151,187,205,0.2)',
	            strokeColor: 'rgba(151,187,205,1)',
	            pointColor: 'rgba(151,187,205,1)',
	            pointStrokeColor: '#fff',
	            pointHighlightFill: '#fff',
	            pointHighlightStroke: 'rgba(151,187,205,1)',
	            data: []
	        }]
	    };
	
	    for (var index in data) {
	        if (data[index]) {
	            var row = data[index];
	            chartData.labels.push(row.name);
	            chartData.datasets[0].data.push(row.value);
	        }
	    }
	
	    return chartData;
	}
	
	function formatUsersWithPostsPerDayData(data) {
	    var chartData = {
	        labels: [],
	        datasets: [{
	            fillColor: 'rgba(151,187,205,0.2)',
	            strokeColor: 'rgba(151,187,205,1)',
	            pointColor: 'rgba(151,187,205,1)',
	            pointStrokeColor: '#fff',
	            pointHighlightFill: '#fff',
	            pointHighlightStroke: 'rgba(151,187,205,1)',
	            data: []
	        }]
	    };
	
	    for (var index in data) {
	        if (data[index]) {
	            var row = data[index];
	            chartData.labels.push(row.name);
	            chartData.datasets[0].data.push(row.value);
	        }
	    }
	
	    return chartData;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	/* unused harmony export formatAuditInfo */'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["defineMessages"].bind()({
	    sessionRevoked: {
	        id: 'audit_table.sessionRevoked',
	        defaultMessage: 'The session with id {sessionId} was revoked'
	    },
	    channelCreated: {
	        id: 'audit_table.channelCreated',
	        defaultMessage: 'Created the {channelName} channel/group'
	    },
	    establishedDM: {
	        id: 'audit_table.establishedDM',
	        defaultMessage: 'Established a direct message channel with {username}'
	    },
	    nameUpdated: {
	        id: 'audit_table.nameUpdated',
	        defaultMessage: 'Updated the {channelName} channel/group name'
	    },
	    headerUpdated: {
	        id: 'audit_table.headerUpdated',
	        defaultMessage: 'Updated the {channelName} channel/group header'
	    },
	    channelDeleted: {
	        id: 'audit_table.channelDeleted',
	        defaultMessage: 'Deleted the channel/group with the URL {url}'
	    },
	    userAdded: {
	        id: 'audit_table.userAdded',
	        defaultMessage: 'Added {username} to the {channelName} channel/group'
	    },
	    userRemoved: {
	        id: 'audit_table.userRemoved',
	        defaultMessage: 'Removed {username} to the {channelName} channel/group'
	    },
	    attemptedRegisterApp: {
	        id: 'audit_table.attemptedRegisterApp',
	        defaultMessage: 'Attempted to register a new OAuth Application with ID {id}'
	    },
	    attemptedAllowOAuthAccess: {
	        id: 'audit_table.attemptedAllowOAuthAccess',
	        defaultMessage: 'Attempted to allow a new OAuth service access'
	    },
	    successfullOAuthAccess: {
	        id: 'audit_table.successfullOAuthAccess',
	        defaultMessage: 'Successfully gave a new OAuth service access'
	    },
	    failedOAuthAccess: {
	        id: 'audit_table.failedOAuthAccess',
	        defaultMessage: 'Failed to allow a new OAuth service access - the redirect URI did not match the previously registered callback'
	    },
	    attemptedOAuthToken: {
	        id: 'audit_table.attemptedOAuthToken',
	        defaultMessage: 'Attempted to get an OAuth access token'
	    },
	    successfullOAuthToken: {
	        id: 'audit_table.successfullOAuthToken',
	        defaultMessage: 'Successfully added a new OAuth service'
	    },
	    oauthTokenFailed: {
	        id: 'audit_table.oauthTokenFailed',
	        defaultMessage: 'Failed to get an OAuth access token - {token}'
	    },
	    attemptedLogin: {
	        id: 'audit_table.attemptedLogin',
	        defaultMessage: 'Attempted to login'
	    },
	    successfullLogin: {
	        id: 'audit_table.successfullLogin',
	        defaultMessage: 'Successfully logged in'
	    },
	    failedLogin: {
	        id: 'audit_table.failedLogin',
	        defaultMessage: 'FAILED login attempt'
	    },
	    updatePicture: {
	        id: 'audit_table.updatePicture',
	        defaultMessage: 'Updated your profile picture'
	    },
	    updateGeneral: {
	        id: 'audit_table.updateGeneral',
	        defaultMessage: 'Updated the general settings of your account'
	    },
	    attemptedPassword: {
	        id: 'audit_table.attemptedPassword',
	        defaultMessage: 'Attempted to change password'
	    },
	    successfullPassword: {
	        id: 'audit_table.successfullPassword',
	        defaultMessage: 'Successfully changed password'
	    },
	    failedPassword: {
	        id: 'audit_table.failedPassword',
	        defaultMessage: 'Failed to change password - tried to update user password who was logged in through oauth'
	    },
	    updatedRol: {
	        id: 'audit_table.updatedRol',
	        defaultMessage: 'Updated user role(s) to '
	    },
	    member: {
	        id: 'audit_table.member',
	        defaultMessage: 'member'
	    },
	    accountActive: {
	        id: 'audit_table.accountActive',
	        defaultMessage: 'Account made active'
	    },
	    accountInactive: {
	        id: 'audit_table.accountInactive',
	        defaultMessage: 'Account made inactive'
	    },
	    by: {
	        id: 'audit_table.by',
	        defaultMessage: ' by {username}'
	    },
	    byAdmin: {
	        id: 'audit_table.byAdmin',
	        defaultMessage: ' by an admin'
	    },
	    sentEmail: {
	        id: 'audit_table.sentEmail',
	        defaultMessage: 'Sent an email to {email} to reset your password'
	    },
	    attemptedReset: {
	        id: 'audit_table.attemptedReset',
	        defaultMessage: 'Attempted to reset password'
	    },
	    successfullReset: {
	        id: 'audit_table.successfullReset',
	        defaultMessage: 'Successfully reset password'
	    },
	    updateGlobalNotifications: {
	        id: 'audit_table.updateGlobalNotifications',
	        defaultMessage: 'Updated your global notification settings'
	    },
	    attemptedWebhookCreate: {
	        id: 'audit_table.attemptedWebhookCreate',
	        defaultMessage: 'Attempted to create a webhook'
	    },
	    succcessfullWebhookCreate: {
	        id: 'audit_table.successfullWebhookCreate',
	        defaultMessage: 'Successfully created a webhook'
	    },
	    failedWebhookCreate: {
	        id: 'audit_table.failedWebhookCreate',
	        defaultMessage: 'Failed to create a webhook - bad channel permissions'
	    },
	    attemptedWebhookDelete: {
	        id: 'audit_table.attemptedWebhookDelete',
	        defaultMessage: 'Attempted to delete a webhook'
	    },
	    successfullWebhookDelete: {
	        id: 'audit_table.successfullWebhookDelete',
	        defaultMessage: 'Successfully deleted a webhook'
	    },
	    failedWebhookDelete: {
	        id: 'audit_table.failedWebhookDelete',
	        defaultMessage: 'Failed to delete a webhook - inappropriate conditions'
	    },
	    logout: {
	        id: 'audit_table.logout',
	        defaultMessage: 'Logged out of your account'
	    },
	    verified: {
	        id: 'audit_table.verified',
	        defaultMessage: 'Sucessfully verified your email address'
	    },
	    revokedAll: {
	        id: 'audit_table.revokedAll',
	        defaultMessage: 'Revoked all current sessions for the team'
	    },
	    loginAttempt: {
	        id: 'audit_table.loginAttempt',
	        defaultMessage: ' (Login attempt)'
	    },
	    loginFailure: {
	        id: 'audit_table.loginFailure',
	        defaultMessage: ' (Login failure)'
	    },
	    attemptedLicenseAdd: {
	        id: 'audit_table.attemptedLicenseAdd',
	        defaultMessage: 'Attempted to add new license'
	    },
	    successfullLicenseAdd: {
	        id: 'audit_table.successfullLicenseAdd',
	        defaultMessage: 'Successfully added new license'
	    },
	    failedExpiredLicenseAdd: {
	        id: 'audit_table.failedExpiredLicenseAdd',
	        defaultMessage: 'Failed to add a new license as it has either expired or not yet been started'
	    },
	    failedInvalidLicenseAdd: {
	        id: 'audit_table.failedInvalidLicenseAdd',
	        defaultMessage: 'Failed to add an invalid license'
	    },
	    licenseRemoved: {
	        id: 'audit_table.licenseRemoved',
	        defaultMessage: 'Successfully removed a license'
	    }
	});
	
	
	
	var AuditTable = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AuditTable, _React$Component);
	
	    function AuditTable() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AuditTable);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AuditTable).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AuditTable, [{
	        key: 'render',
	        value: function render() {
	            var accessList = [];
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            for (var i = 0; i < this.props.audits.length; i++) {
	                var audit = this.props.audits[i];
	                var auditInfo = formatAuditInfo(audit, formatMessage);
	
	                var uContent = void 0;
	                if (this.props.showUserId) {
	                    var profile = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getProfile(auditInfo.userId);
	                    if (profile) {
	                        uContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'td',
	                            { className: 'word-break--all' },
	                            profile.email
	                        );
	                    } else {
	                        uContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'td',
	                            { className: 'word-break--all' },
	                            auditInfo.userId
	                        );
	                    }
	                }
	
	                var iContent = void 0;
	                if (this.props.showIp) {
	                    iContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'td',
	                        { className: 'word-break--all' },
	                        auditInfo.ip
	                    );
	                }
	
	                var sContent = void 0;
	                if (this.props.showSession) {
	                    sContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'td',
	                        { className: 'word-break--all' },
	                        auditInfo.sessionId
	                    );
	                }
	
	                var descStyle = {};
	                if (auditInfo.desc.toLowerCase().indexOf('fail') !== -1) {
	                    descStyle.color = 'red';
	                }
	
	                accessList[i] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'tr',
	                    { key: audit.id },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'td',
	                        { className: 'word-break--all' },
	                        auditInfo.timestamp
	                    ),
	                    uContent,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'td',
	                        {
	                            className: 'word-break--all',
	                            style: descStyle
	                        },
	                        auditInfo.desc
	                    ),
	                    iContent,
	                    sContent
	                );
	            }
	
	            var userIdContent = void 0;
	            if (this.props.showUserId) {
	                userIdContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'th',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'audit_table.userId',
	                        defaultMessage: 'User ID'
	                    })
	                );
	            }
	
	            var ipContent = void 0;
	            if (this.props.showIp) {
	                ipContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'th',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'audit_table.ip',
	                        defaultMessage: 'IP Address'
	                    })
	                );
	            }
	
	            var sessionContent = void 0;
	            if (this.props.showSession) {
	                sessionContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'th',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'audit_table.session',
	                        defaultMessage: 'Session ID'
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'table',
	                { className: 'table' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'thead',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'tr',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'th',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'audit_table.timestamp',
	                                defaultMessage: 'Timestamp'
	                            })
	                        ),
	                        userIdContent,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'th',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'audit_table.action',
	                                defaultMessage: 'Action'
	                            })
	                        ),
	                        ipContent,
	                        sessionContent
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'tbody',
	                    null,
	                    accessList
	                )
	            );
	        }
	    }]);
	
	    return AuditTable;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	AuditTable.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
	    audits: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.array.isRequired,
	    showUserId: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    showIp: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    showSession: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"].bind()(AuditTable);
	
	function formatAuditInfo(audit, formatMessage) {
	    var actionURL = audit.action.replace(/\/api\/v[1-9]/, '');
	    var auditDesc = '';
	
	    if (actionURL.indexOf('/channels') === 0) {
	        var channelInfo = audit.extra_info.split(' ');
	        var channelNameField = channelInfo[0].split('=');
	
	        var channelURL = '';
	        var channelObj = void 0;
	        var channelName = '';
	        if (channelNameField.indexOf('name') >= 0) {
	            channelURL = channelNameField[channelNameField.indexOf('name') + 1];
	            channelObj = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getByName(channelURL);
	            if (channelObj) {
	                channelName = channelObj.display_name;
	            } else {
	                channelName = channelURL;
	            }
	        }
	
	        switch (actionURL) {
	            case '/channels/create':
	                auditDesc = formatMessage(holders.channelCreated, { channelName: channelName });
	                break;
	            case '/channels/create_direct':
	                auditDesc = formatMessage(holders.establishedDM, { username: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getDirectTeammate(channelObj.id).username });
	                break;
	            case '/channels/update':
	                auditDesc = formatMessage(holders.nameUpdated, { channelName: channelName });
	                break;
	            case '/channels/update_desc': // support the old path
	            case '/channels/update_header':
	                auditDesc = formatMessage(holders.headerUpdated, { channelName: channelName });
	                break;
	            default:
	                {
	                    var userIdField = [];
	                    var userId = '';
	                    var username = '';
	
	                    if (channelInfo[1]) {
	                        userIdField = channelInfo[1].split('=');
	
	                        if (userIdField.indexOf('user_id') >= 0) {
	                            userId = userIdField[userIdField.indexOf('user_id') + 1];
	                            username = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getProfile(userId).username;
	                        }
	                    }
	
	                    if (/\/channels\/[A-Za-z0-9]+\/delete/.test(actionURL)) {
	                        auditDesc = formatMessage(holders.channelDeleted, { url: channelURL });
	                    } else if (/\/channels\/[A-Za-z0-9]+\/add/.test(actionURL)) {
	                        auditDesc = formatMessage(holders.userAdded, { username: username, channelName: channelName });
	                    } else if (/\/channels\/[A-Za-z0-9]+\/remove/.test(actionURL)) {
	                        auditDesc = formatMessage(holders.userRemoved, { username: username, channelName: channelName });
	                    }
	
	                    break;
	                }
	        }
	    } else if (actionURL.indexOf('/oauth') === 0) {
	        var oauthInfo = audit.extra_info.split(' ');
	
	        switch (actionURL) {
	            case '/oauth/register':
	                {
	                    var clientIdField = oauthInfo[0].split('=');
	
	                    if (clientIdField[0] === 'client_id') {
	                        auditDesc = formatMessage(holders.attemptedRegisterApp, { id: clientIdField[1] });
	                    }
	
	                    break;
	                }
	            case '/oauth/allow':
	                if (oauthInfo[0] === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedAllowOAuthAccess);
	                } else if (oauthInfo[0] === 'success') {
	                    auditDesc = formatMessage(holders.successfullOAuthAccess);
	                } else if (oauthInfo[0] === 'fail - redirect_uri did not match registered callback') {
	                    auditDesc = formatMessage(holders.failedOAuthAccess);
	                }
	
	                break;
	            case '/oauth/access_token':
	                if (oauthInfo[0] === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedOAuthToken);
	                } else if (oauthInfo[0] === 'success') {
	                    auditDesc = formatMessage(holders.successfullOAuthToken);
	                } else {
	                    var oauthTokenFailure = oauthInfo[0].split('-');
	
	                    if (oauthTokenFailure[0].trim() === 'fail' && oauthTokenFailure[1]) {
	                        auditDesc = formatMessage(oauthTokenFailure, { token: oauthTokenFailure[1].trim() });
	                    }
	                }
	
	                break;
	            default:
	                break;
	        }
	    } else if (actionURL.indexOf('/users') === 0) {
	        var userInfo = audit.extra_info.split(' ');
	
	        switch (actionURL) {
	            case '/users/login':
	                if (userInfo[0] === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedLogin);
	                } else if (userInfo[0] === 'success') {
	                    auditDesc = formatMessage(holders.successfullLogin);
	                } else if (userInfo[0]) {
	                    auditDesc = formatMessage(holders.failedLogin);
	                }
	
	                break;
	            case '/users/revoke_session':
	                auditDesc = formatMessage(holders.sessionRevoked, { sessionId: userInfo[0].split('=')[1] });
	                break;
	            case '/users/newimage':
	                auditDesc = formatMessage(holders.updatePicture);
	                break;
	            case '/users/update':
	                auditDesc = formatMessage(holders.updateGeneral);
	                break;
	            case '/users/newpassword':
	                if (userInfo[0] === 'attempted') {
	                    auditDesc = formatMessage(holders.attemptedPassword);
	                } else if (userInfo[0] === 'completed') {
	                    auditDesc = formatMessage(holders.successfullPassword);
	                } else if (userInfo[0] === 'failed - tried to update user password who was logged in through oauth') {
	                    auditDesc = formatMessage(holders.failedPassword);
	                }
	
	                break;
	            case '/users/update_roles':
	                {
	                    var userRoles = userInfo[0].split('=')[1];
	
	                    auditDesc = formatMessage(holders.updatedRol);
	                    if (userRoles.trim()) {
	                        auditDesc += userRoles;
	                    } else {
	                        auditDesc += formatMessage(holders.member);
	                    }
	
	                    break;
	                }
	            case '/users/update_active':
	                {
	                    var updateType = userInfo[0].split('=')[0];
	                    var updateField = userInfo[0].split('=')[1];
	
	                    /* Either describes account activation/deactivation or a revoked session as part of an account deactivation */
	                    if (updateType === 'active') {
	                        if (updateField === 'true') {
	                            auditDesc = formatMessage(holders.accountActive);
	                        } else if (updateField === 'false') {
	                            auditDesc = formatMessage(holders.accountInactive);
	                        }
	
	                        var actingUserInfo = userInfo[1].split('=');
	                        if (actingUserInfo[0] === 'session_user') {
	                            var actingUser = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getProfile(actingUserInfo[1]);
	                            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentUser();
	                            if (user && actingUser && /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.isSystemAdmin(user.roles)) {
	                                auditDesc += formatMessage(holders.by, { username: actingUser.username });
	                            } else if (user && actingUser) {
	                                auditDesc += formatMessage(holders.byAdmin);
	                            }
	                        }
	                    } else if (updateType === 'session_id') {
	                        auditDesc = formatMessage(holders.sessionRevoked, { sessionId: updateField });
	                    }
	
	                    break;
	                }
	            case '/users/send_password_reset':
	                auditDesc = formatMessage(holders.sentEmail, { email: userInfo[0].split('=')[1] });
	                break;
	            case '/users/reset_password':
	                if (userInfo[0] === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedReset);
	                } else if (userInfo[0] === 'success') {
	                    auditDesc = formatMessage(holders.successfullReset);
	                }
	
	                break;
	            case '/users/update_notify':
	                auditDesc = formatMessage(holders.updateGlobalNotifications);
	                break;
	            default:
	                break;
	        }
	    } else if (actionURL.indexOf('/hooks') === 0) {
	        var webhookInfo = audit.extra_info;
	
	        switch (actionURL) {
	            case '/hooks/incoming/create':
	                if (webhookInfo === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedWebhookCreate);
	                } else if (webhookInfo === 'success') {
	                    auditDesc = formatMessage(holders.succcessfullWebhookCreate);
	                } else if (webhookInfo === 'fail - bad channel permissions') {
	                    auditDesc = formatMessage(holders.failedWebhookCreate);
	                }
	
	                break;
	            case '/hooks/incoming/delete':
	                if (webhookInfo === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedWebhookDelete);
	                } else if (webhookInfo === 'success') {
	                    auditDesc = formatMessage(holders.successfullWebhookDelete);
	                } else if (webhookInfo === 'fail - inappropriate conditions') {
	                    auditDesc = formatMessage(holders.failedWebhookDelete);
	                }
	
	                break;
	            default:
	                break;
	        }
	    } else if (actionURL.indexOf('/license') === 0) {
	        var licenseInfo = audit.extra_info;
	
	        switch (actionURL) {
	            case '/license/add':
	                if (licenseInfo === 'attempt') {
	                    auditDesc = formatMessage(holders.attemptedLicenseAdd);
	                } else if (licenseInfo === 'success') {
	                    auditDesc = formatMessage(holders.successfullLicenseAdd);
	                } else if (licenseInfo === 'failed - expired or non-started license') {
	                    auditDesc = formatMessage(holders.failedExpiredLicenseAdd);
	                } else if (licenseInfo === 'failed - invalid license') {
	                    auditDesc = formatMessage(holders.failedInvalidLicenseAdd);
	                }
	
	                break;
	            case '/license/remove':
	                auditDesc = formatMessage(holders.licenseRemoved);
	                break;
	            default:
	                break;
	        }
	    } else if (actionURL.indexOf('/admin/download_compliance_report') === 0) {
	        auditDesc = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.toTitleCase(audit.extra_info);
	    } else {
	        switch (actionURL) {
	            case '/logout':
	                auditDesc = formatMessage(holders.logout);
	                break;
	            case '/verify_email':
	                auditDesc = formatMessage(holders.verified);
	                break;
	            default:
	                break;
	        }
	    }
	
	    /* If all else fails... */
	    if (!auditDesc) {
	        /* Currently not called anywhere */
	        if (audit.extra_info.indexOf('revoked_all=') >= 0) {
	            auditDesc = formatMessage(holders.revokedAll);
	        } else {
	            var actionDesc = '';
	            if (actionURL && actionURL.lastIndexOf('/') !== -1) {
	                actionDesc = actionURL.substring(actionURL.lastIndexOf('/') + 1).replace('_', ' ');
	                actionDesc = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.toTitleCase(actionDesc);
	            }
	
	            var extraInfoDesc = '';
	            if (audit.extra_info) {
	                extraInfoDesc = audit.extra_info;
	
	                if (extraInfoDesc.indexOf('=') !== -1) {
	                    extraInfoDesc = extraInfoDesc.substring(extraInfoDesc.indexOf('=') + 1);
	                }
	            }
	            auditDesc = actionDesc + ' ' + extraInfoDesc;
	        }
	    }
	
	    var date = new Date(audit.create_at);
	    var auditInfo = {};
	    auditInfo.timestamp = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        'div',
	        null,
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedDate"], {
	            value: date,
	            day: '2-digit',
	            month: 'short',
	            year: 'numeric'
	        }),
	        ' - ',
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedTime"], {
	            value: date,
	            hour: '2-digit',
	            minute: '2-digit'
	        })
	    );
	    auditInfo.userId = audit.user_id;
	    auditInfo.desc = auditDesc;
	    auditInfo.ip = audit.ip_address;
	    auditInfo.sessionId = audit.session_id;
	
	    return auditInfo;
	}

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__(1287);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __WEBPACK_IMPORTED_MODULE_6_bootstrap__ && __WEBPACK_IMPORTED_MODULE_6_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_bar_jsx__ = __webpack_require__(250);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__message_wrapper_jsx__ = __webpack_require__(362);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__popover_list_members_jsx__ = __webpack_require__(722);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__edit_channel_header_modal_jsx__ = __webpack_require__(246);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__edit_channel_purpose_modal_jsx__ = __webpack_require__(358);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__channel_info_modal_jsx__ = __webpack_require__(353);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channel_invite_modal_jsx__ = __webpack_require__(185);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__channel_members_modal_jsx__ = __webpack_require__(354);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__channel_notifications_modal_jsx__ = __webpack_require__(355);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__delete_channel_modal_jsx__ = __webpack_require__(357);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rename_channel_modal_jsx__ = __webpack_require__(368);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_stores_search_store_jsx__ = __webpack_require__(161);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_intl___default = __WEBPACK_IMPORTED_MODULE_30_react_intl__ && __WEBPACK_IMPORTED_MODULE_30_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_30_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_30_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_30_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_30_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router___default = __WEBPACK_IMPORTED_MODULE_31_react_router__ && __WEBPACK_IMPORTED_MODULE_31_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_31_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_31_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_31_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_31_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_32_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_32_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_32_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_32_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_32_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_32_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react___default = __WEBPACK_IMPORTED_MODULE_33_react__ && __WEBPACK_IMPORTED_MODULE_33_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_33_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_33_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_33_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_33_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_29_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	var ChannelHeader = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelHeader, _React$Component);
	
	    function ChannelHeader(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelHeader);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelHeader).call(this, props));
	
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	        _this.handleLeave = _this.handleLeave.bind(_this);
	        _this.searchMentions = _this.searchMentions.bind(_this);
	        _this.showRenameChannelModal = _this.showRenameChannelModal.bind(_this);
	        _this.hideRenameChannelModal = _this.hideRenameChannelModal.bind(_this);
	
	        var state = _this.getStateFromStores();
	        state.showEditChannelPurposeModal = false;
	        state.showMembersModal = false;
	        state.showRenameChannelModal = false;
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChannelHeader, [{
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].getExtraInfo(this.props.channelId);
	
	            return {
	                channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].get(this.props.channelId),
	                memberChannel: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].getMember(this.props.channelId),
	                users: extraInfo.members,
	                userCount: extraInfo.member_count,
	                currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_user_store_jsx__["a"].getCurrentUser()
	            };
	        }
	    }, {
	        key: 'validState',
	        value: function validState() {
	            if (!this.state.channel || !this.state.memberChannel || !this.state.users || !this.state.userCount || !this.state.currentUser) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].addChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].addExtraInfoChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_22_stores_search_store_jsx__["a"].addSearchChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_23_stores_preference_store_jsx__["a"].addChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_user_store_jsx__["a"].addChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.sidebar--left .dropdown-menu').perfectScrollbar();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].removeExtraInfoChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_22_stores_search_store_jsx__["a"].removeSearchChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_23_stores_preference_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_user_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            var newState = this.getStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_25_utils_utils_jsx__.areObjectsEqual(newState, this.state)) {
	                this.setState(newState);
	            }
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.channel-header__info .description').popover({ placement: 'bottom', trigger: 'hover', html: true, delay: { show: 500, hide: 500 } });
	        }
	    }, {
	        key: 'handleLeave',
	        value: function handleLeave() {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_utils_web_client_jsx__["a"].leaveChannel(this.state.channel.id, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	                    type: ActionTypes.LEAVE_CHANNEL,
	                    id: _this2.state.channel.id
	                });
	
	                var townsquare = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].getByName('town-square');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_31_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_25_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/channels/' + townsquare.name);
	            }, function (err) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_27_utils_async_client_jsx__.dispatchError(err, 'handleLeave');
	            });
	        }
	    }, {
	        key: 'searchMentions',
	        value: function searchMentions(e) {
	            e.preventDefault();
	
	            var user = this.state.currentUser;
	
	            var terms = '';
	            if (user.notify_props && user.notify_props.mention_keys) {
	                var termKeys = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_user_store_jsx__["a"].getMentionKeys(user.id);
	
	                if (user.notify_props.all === 'true' && termKeys.indexOf('@all') !== -1) {
	                    termKeys.splice(termKeys.indexOf('@all'), 1);
	                }
	
	                if (user.notify_props.channel === 'true' && termKeys.indexOf('@channel') !== -1) {
	                    termKeys.splice(termKeys.indexOf('@channel'), 1);
	                }
	                terms = termKeys.join(' ');
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH_TERM,
	                term: terms,
	                do_search: true,
	                is_mention_search: true
	            });
	        }
	    }, {
	        key: 'showRenameChannelModal',
	        value: function showRenameChannelModal(e) {
	            e.preventDefault();
	
	            this.setState({
	                showRenameChannelModal: true
	            });
	        }
	    }, {
	        key: 'hideRenameChannelModal',
	        value: function hideRenameChannelModal() {
	            this.setState({
	                showRenameChannelModal: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (!this.validState()) {
	                return null;
	            }
	
	            var channel = this.state.channel;
	            var recentMentionsTooltip = /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_32_react_bootstrap__["Tooltip"],
	                { id: 'recentMentionsTooltip' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                    id: 'channel_header.recentMentions',
	                    defaultMessage: 'Recent Mentions'
	                })
	            );
	            var popoverContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_32_react_bootstrap__["Popover"],
	                {
	                    id: 'hader-popover',
	                    bStyle: 'info',
	                    bSize: 'large',
	                    placement: 'bottom',
	                    className: 'description',
	                    onMouseOver: function onMouseOver() {
	                        return _this3.refs.headerOverlay.show();
	                    },
	                    onMouseOut: function onMouseOut() {
	                        return _this3.refs.headerOverlay.hide();
	                    }
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__message_wrapper_jsx__["a"], {
	                    message: channel.header
	                })
	            );
	            var channelTitle = channel.display_name;
	            var currentId = this.state.currentUser.id;
	            var isAdmin = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_25_utils_utils_jsx__.isAdmin(this.state.memberChannel.roles) || /* harmony import */__WEBPACK_IMPORTED_MODULE_21_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	            var isDirect = this.state.channel.type === 'D';
	
	            if (isDirect) {
	                if (this.state.users.length > 1) {
	                    var contact = void 0;
	                    if (this.state.users[0].id === currentId) {
	                        contact = this.state.users[1];
	                    } else {
	                        contact = this.state.users[0];
	                    }
	                    channelTitle = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_25_utils_utils_jsx__.displayUsername(contact.id);
	                }
	            }
	
	            var channelTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                id: 'channel_header.channel',
	                defaultMessage: 'Channel'
	            });
	            if (channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_29_utils_constants_jsx__["a"].PRIVATE_CHANNEL) {
	                channelTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                    id: 'channel_header.group',
	                    defaultMessage: 'Group'
	                });
	            }
	
	            var popoverListMembers = void 0;
	            if (!isDirect) {
	                popoverListMembers = /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__popover_list_members_jsx__["a"], {
	                    channel: channel,
	                    members: this.state.users,
	                    memberCount: this.state.userCount
	                });
	            }
	
	            var dropdownContents = [];
	            if (isDirect) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'edit_header_direct',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__["a"],
	                        {
	                            role: 'menuitem',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_10__edit_channel_header_modal_jsx__["a"],
	                            dialogProps: { channel: channel }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                            id: 'channel_header.channelHeader',
	                            defaultMessage: 'Set Channel Header...'
	                        })
	                    )
	                ));
	            } else {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'view_info',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__["a"],
	                        {
	                            role: 'menuitem',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_12__channel_info_modal_jsx__["a"],
	                            dialogProps: { channel: channel }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                            id: 'channel_header.viewInfo',
	                            defaultMessage: 'View Info'
	                        })
	                    )
	                ));
	
	                if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].isDefault(channel)) {
	                    dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        'li',
	                        {
	                            key: 'add_members',
	                            role: 'presentation'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__["a"],
	                            {
	                                role: 'menuitem',
	                                dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_13__channel_invite_modal_jsx__["a"],
	                                dialogProps: { channel: channel, currentUser: this.state.currentUser }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                                id: 'chanel_header.addMembers',
	                                defaultMessage: 'Add Members'
	                            })
	                        )
	                    ));
	
	                    if (isAdmin) {
	                        dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                            'li',
	                            {
	                                key: 'manage_members',
	                                role: 'presentation'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                'a',
	                                {
	                                    role: 'menuitem',
	                                    href: '#',
	                                    onClick: function onClick() {
	                                        return _this3.setState({ showMembersModal: true });
	                                    }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                                    id: 'channel_header.manageMembers',
	                                    defaultMessage: 'Manage Members'
	                                })
	                            )
	                        ));
	                    }
	                }
	
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'set_channel_header',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__["a"],
	                        {
	                            role: 'menuitem',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_10__edit_channel_header_modal_jsx__["a"],
	                            dialogProps: { channel: channel }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                            id: 'channel_header.setHeader',
	                            defaultMessage: 'Set {term} Header...',
	                            values: {
	                                term: channelTerm
	                            }
	                        })
	                    )
	                ));
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'set_channel_purpose',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: function onClick() {
	                                return _this3.setState({ showEditChannelPurposeModal: true });
	                            }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                            id: 'channel_header.setPurpose',
	                            defaultMessage: 'Set {term} Purpose...',
	                            values: {
	                                term: channelTerm
	                            }
	                        })
	                    )
	                ));
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'notification_preferences',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__["a"],
	                        {
	                            role: 'menuitem',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_15__channel_notifications_modal_jsx__["a"],
	                            dialogProps: {
	                                channel: channel,
	                                channelMember: this.state.memberChannel,
	                                currentUser: this.state.currentUser
	                            }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                            id: 'channel_header.notificationPreferences',
	                            defaultMessage: 'Notification Preferences'
	                        })
	                    )
	                ));
	
	                if (isAdmin) {
	                    dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        'li',
	                        {
	                            key: 'rename_channel',
	                            role: 'presentation'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                            'a',
	                            {
	                                role: 'menuitem',
	                                href: '#',
	                                onClick: this.showRenameChannelModal
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                                id: 'channel_header.rename',
	                                defaultMessage: 'Rename {term}...',
	                                values: {
	                                    term: channelTerm
	                                }
	                            })
	                        )
	                    ));
	
	                    if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].isDefault(channel)) {
	                        dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                            'li',
	                            {
	                                key: 'delete_channel',
	                                role: 'presentation'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18__toggle_modal_button_jsx__["a"],
	                                {
	                                    role: 'menuitem',
	                                    dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_16__delete_channel_modal_jsx__["a"],
	                                    dialogProps: { channel: channel }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                                    id: 'channel_header.delete',
	                                    defaultMessage: 'Delete {term}...',
	                                    values: {
	                                        term: channelTerm
	                                    }
	                                })
	                            )
	                        ));
	                    }
	                }
	
	                if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_channel_store_jsx__["a"].isDefault(channel)) {
	                    dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        'li',
	                        {
	                            key: 'leave_channel',
	                            role: 'presentation'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                            'a',
	                            {
	                                role: 'menuitem',
	                                href: '#',
	                                onClick: this.handleLeave
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react_intl__["FormattedMessage"], {
	                                id: 'channel_header.leave',
	                                defaultMessage: 'Leave {term}',
	                                values: {
	                                    term: channelTerm
	                                }
	                            })
	                        )
	                    ));
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                'div',
	                {
	                    id: 'channel-header',
	                    className: 'channel-header'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                    'table',
	                    { className: 'channel-header alt' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                        'tbody',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                            'tr',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                'th',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                    'div',
	                                    { className: 'channel-header__info' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                        'div',
	                                        { className: 'dropdown' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                            'a',
	                                            {
	                                                href: '#',
	                                                className: 'dropdown-toggle theme',
	                                                type: 'button',
	                                                id: 'channel_header_dropdown',
	                                                'data-toggle': 'dropdown',
	                                                'aria-expanded': 'true'
	                                            },
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                                'strong',
	                                                { className: 'heading' },
	                                                channelTitle,
	                                                ' '
	                                            ),
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement('span', { className: 'glyphicon glyphicon-chevron-down header-dropdown__icon' })
	                                        ),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                            'ul',
	                                            {
	                                                className: 'dropdown-menu',
	                                                role: 'menu',
	                                                'aria-labelledby': 'channel_header_dropdown'
	                                            },
	                                            dropdownContents
	                                        )
	                                    ),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_32_react_bootstrap__["OverlayTrigger"],
	                                        {
	                                            trigger: 'click',
	                                            placement: 'bottom',
	                                            overlay: popoverContent,
	                                            ref: 'headerOverlay'
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement('div', {
	                                            onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_26_utils_text_formatting_jsx__.handleClick,
	                                            className: 'description',
	                                            dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_26_utils_text_formatting_jsx__.formatText(channel.header, { singleline: true, mentionHighlight: false }) }
	                                        })
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                'th',
	                                null,
	                                popoverListMembers
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                'th',
	                                { className: 'search-bar__container' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__search_bar_jsx__["a"], null)
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                'th',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                    'div',
	                                    { className: 'dropdown channel-header__links' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_32_react_bootstrap__["OverlayTrigger"],
	                                        {
	                                            delayShow: /* harmony import */__WEBPACK_IMPORTED_MODULE_29_utils_constants_jsx__["a"].OVERLAY_TIME_DELAY,
	                                            placement: 'bottom',
	                                            overlay: recentMentionsTooltip
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
	                                            'a',
	                                            {
	                                                href: '#',
	                                                type: 'button',
	                                                onClick: this.searchMentions
	                                            },
	                                            '@'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__edit_channel_purpose_modal_jsx__["a"], {
	                    show: this.state.showEditChannelPurposeModal,
	                    onModalDismissed: function onModalDismissed() {
	                        return _this3.setState({ showEditChannelPurposeModal: false });
	                    },
	                    channel: channel
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__channel_members_modal_jsx__["a"], {
	                    show: this.state.showMembersModal,
	                    onModalDismissed: function onModalDismissed() {
	                        return _this3.setState({ showMembersModal: false });
	                    },
	                    channel: channel
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17__rename_channel_modal_jsx__["a"], {
	                    show: this.state.showRenameChannelModal,
	                    onHide: this.hideRenameChannelModal,
	                    channel: channel
	                })
	            );
	        }
	    }]);
	
	    return ChannelHeader;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelHeader;
	
	
	ChannelHeader.propTypes = {
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_33_react___default.a.PropTypes.string.isRequired
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var ChannelInfoModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelInfoModal, _React$Component);
	
	    function ChannelInfoModal() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelInfoModal);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelInfoModal).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChannelInfoModal, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (nextProps.show !== this.props.show) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.areObjectsEqual(nextProps.channel, this.props.channel)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var channel = this.props.channel;
	            if (!channel) {
	                var notFound = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('channel_info.notFound', 'No Channel Found');
	
	                channel = {
	                    display_name: notFound,
	                    name: notFound,
	                    purpose: notFound,
	                    id: notFound
	                };
	            }
	
	            var channelURL = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.getTeamURLFromAddressBar() + '/channels/' + channel.name;
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.props.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
	                    { closeButtton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Title,
	                        null,
	                        channel.display_name
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
	                    { ref: 'modalBody' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        { className: 'row form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-3 info__label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'channel_info.name',
	                                defaultMessage: 'Channel Name:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-9' },
	                            channel.display_name
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        { className: 'row form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-3 info__label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'channel_info.url',
	                                defaultMessage: 'Channel URL:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-9' },
	                            channelURL
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        { className: 'row form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-3 info__label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'channel_info.id',
	                                defaultMessage: 'Channel ID:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-9' },
	                            channel.id
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        { className: 'row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-3 info__label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'channel_info.purpose',
	                                defaultMessage: 'Channel Purpose:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-9' },
	                            channel.purpose
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.props.onHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'channel_info.close',
	                            defaultMessage: 'Close'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChannelInfoModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelInfoModal;
	
	
	ChannelInfoModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filtered_user_list_jsx__ = __webpack_require__(188);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__channel_invite_modal_jsx__ = __webpack_require__(185);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ChannelMembersModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelMembersModal, _React$Component);
	
	    function ChannelMembersModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelMembersModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelMembersModal).call(this, props));
	
	        _this.getStateFromStores = _this.getStateFromStores.bind(_this);
	        _this.onChange = _this.onChange.bind(_this);
	        _this.handleRemove = _this.handleRemove.bind(_this);
	
	        _this.createRemoveMemberButton = _this.createRemoveMemberButton.bind(_this);
	
	        // the rest of the state gets populated when the modal is shown
	        _this.state = {
	            showInviteModal: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChannelMembersModal, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(this.props, nextProps)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(this.state, nextState)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrentExtraInfo();
	            var profiles = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getActiveOnlyProfiles();
	
	            if (extraInfo.member_count !== extraInfo.members.length) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannelExtraInfo(this.props.channel.id, -1);
	
	                return {
	                    loading: true
	                };
	            }
	
	            var memberList = extraInfo.members.map(function (member) {
	                return profiles[member.id];
	            });
	
	            function compareByUsername(a, b) {
	                if (a.username < b.username) {
	                    return -1;
	                } else if (a.username > b.username) {
	                    return 1;
	                }
	
	                return 0;
	            }
	
	            memberList.sort(compareByUsername);
	
	            return {
	                memberList: memberList,
	                loading: false
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.show && nextProps.show) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addExtraInfoChangeListener(this.onChange);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addChangeListener(this.onChange);
	
	                this.onChange();
	            } else if (this.props.show && !nextProps.show) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeExtraInfoChangeListener(this.onChange);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeChangeListener(this.onChange);
	            }
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            var newState = this.getStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(this.state, newState)) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'handleRemove',
	        value: function handleRemove(user) {
	            var _this2 = this;
	
	            var userId = user.id;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_web_client_jsx__["a"].removeChannelMember(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrentId(), userId, function () {
	                var memberList = _this2.state.memberList.slice();
	                for (var i = 0; i < memberList.length; i++) {
	                    if (userId === memberList[i].id) {
	                        memberList.splice(i, 1);
	                        break;
	                    }
	                }
	
	                _this2.setState({ memberList: memberList });
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getChannelExtraInfo();
	            }, function (err) {
	                _this2.setState({ inviteError: err.message });
	            });
	        }
	    }, {
	        key: 'createRemoveMemberButton',
	        value: function createRemoveMemberButton(_ref) {
	            var user = _ref.user;
	
	            if (user.id === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentId()) {
	                return null;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                'button',
	                {
	                    type: 'button',
	                    className: 'btn btn-primary btn-message',
	                    onClick: this.handleRemove.bind(this, user)
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                    id: 'channel_members_modal.remove',
	                    defaultMessage: 'Remove'
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var content = void 0;
	            if (this.state.loading) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__["a"], null);
	            } else {
	                var maxHeight = 1000;
	                if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.windowHeight() <= 1200) {
	                    maxHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.windowHeight() - 300;
	                }
	
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__filtered_user_list_jsx__["a"], {
	                    style: { maxHeight: maxHeight },
	                    users: this.state.memberList,
	                    actions: [this.createRemoveMemberButton]
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"],
	                    {
	                        dialogClassName: 'more-modal',
	                        show: this.props.show,
	                        onHide: this.props.onModalDismissed
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Header,
	                        { closeButton: true },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Title,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                                'span',
	                                { className: 'name' },
	                                this.props.channel.display_name
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'channel_memebers_modal.members',
	                                defaultMessage: ' Members'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'btn btn-md btn-primary',
	                                href: '#',
	                                onClick: function onClick() {
	                                    _this3.setState({ showInviteModal: true });
	                                    _this3.props.onModalDismissed();
	                                }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'channel_members_modal.addNew',
	                                defaultMessage: ' Add New Members'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Body,
	                        {
	                            ref: 'modalBody'
	                        },
	                        content
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["Modal"].Footer,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-default',
	                                onClick: this.props.onModalDismissed
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'channel_members_modal.close',
	                                defaultMessage: 'Close'
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__channel_invite_modal_jsx__["a"], {
	                    show: this.state.showInviteModal,
	                    onHide: function onHide() {
	                        return _this3.setState({ showInviteModal: false });
	                    },
	                    channel: this.props.channel
	                })
	            );
	        }
	    }]);
	
	    return ChannelMembersModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelMembersModal;
	
	
	ChannelMembersModal.defaultProps = {
	    show: false
	};
	
	ChannelMembersModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.bool.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ChannelNotificationsModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelNotificationsModal, _React$Component);
	
	    function ChannelNotificationsModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelNotificationsModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelNotificationsModal).call(this, props));
	
	        _this.updateSection = _this.updateSection.bind(_this);
	
	        _this.handleSubmitNotifyLevel = _this.handleSubmitNotifyLevel.bind(_this);
	        _this.handleUpdateNotifyLevel = _this.handleUpdateNotifyLevel.bind(_this);
	        _this.createNotifyLevelSection = _this.createNotifyLevelSection.bind(_this);
	
	        _this.handleSubmitMarkUnreadLevel = _this.handleSubmitMarkUnreadLevel.bind(_this);
	        _this.handleUpdateMarkUnreadLevel = _this.handleUpdateMarkUnreadLevel.bind(_this);
	        _this.createMarkUnreadLevelSection = _this.createMarkUnreadLevelSection.bind(_this);
	
	        _this.state = {
	            activeSection: '',
	            notifyLevel: '',
	            unreadLevel: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChannelNotificationsModal, [{
	        key: 'updateSection',
	        value: function updateSection(section) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            this.setState({ activeSection: section });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.show && nextProps.show) {
	                this.setState({
	                    notifyLevel: nextProps.channelMember.notify_props.desktop,
	                    unreadLevel: nextProps.channelMember.notify_props.mark_unread
	                });
	            }
	        }
	    }, {
	        key: 'handleSubmitNotifyLevel',
	        value: function handleSubmitNotifyLevel() {
	            var _this2 = this;
	
	            var channelId = this.props.channel.id;
	            var notifyLevel = this.state.notifyLevel;
	
	            if (this.props.channelMember.notify_props.desktop === notifyLevel) {
	                this.updateSection('');
	                return;
	            }
	
	            var data = {};
	            data.channel_id = channelId;
	            data.user_id = this.props.currentUser.id;
	            data.desktop = notifyLevel;
	
	            //TODO: This should be moved to event_helpers
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].updateChannelNotifyProps(data, function () {
	                // YUCK
	                var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].getMember(channelId);
	                member.notify_props.desktop = notifyLevel;
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].setChannelMember(member);
	                _this2.updateSection('');
	            }, function (err) {
	                _this2.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleUpdateNotifyLevel',
	        value: function handleUpdateNotifyLevel(notifyLevel) {
	            this.setState({ notifyLevel: notifyLevel });
	        }
	    }, {
	        key: 'createNotifyLevelSection',
	        value: function createNotifyLevelSection(serverError) {
	            var _this3 = this;
	
	            // Get glabal user setting for notifications
	            var globalNotifyLevel = this.props.currentUser.notify_props.desktop;
	            var globalNotifyLevelName = void 0;
	            if (globalNotifyLevel === 'all') {
	                globalNotifyLevelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'channel_notifications.allActivity',
	                    defaultMessage: 'For all activity'
	                });
	            } else if (globalNotifyLevel === 'mention') {
	                globalNotifyLevelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'channel_notifications.onlyMentions',
	                    defaultMessage: 'Only for mentions'
	                });
	            } else {
	                globalNotifyLevelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'channel_notifications.never',
	                    defaultMessage: 'Never'
	                });
	            }
	
	            var sendDesktop = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                id: 'channel_notifications.sendDesktop',
	                defaultMessage: 'Send desktop notifications'
	            });
	
	            var notificationLevel = this.state.notifyLevel;
	
	            if (this.state.activeSection === 'desktop') {
	                var notifyActive = [false, false, false, false];
	                if (notificationLevel === 'default') {
	                    notifyActive[0] = true;
	                } else if (notificationLevel === 'all') {
	                    notifyActive[1] = true;
	                } else if (notificationLevel === 'mention') {
	                    notifyActive[2] = true;
	                } else {
	                    notifyActive[3] = true;
	                }
	
	                var inputs = [];
	
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { key: 'channel-notification-level-radio' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: notifyActive[0],
	                                onChange: this.handleUpdateNotifyLevel.bind(this, 'default')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'channel_notifications.globalDefault',
	                                defaultMessage: 'Global default ({notifyLevel})',
	                                values: {
	                                    notifyLevel: globalNotifyLevelName
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: notifyActive[1],
	                                onChange: this.handleUpdateNotifyLevel.bind(this, 'all')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.allActivity' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: notifyActive[2],
	                                onChange: this.handleUpdateNotifyLevel.bind(this, 'mention')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.onlyMentions' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: notifyActive[3],
	                                onChange: this.handleUpdateNotifyLevel.bind(this, 'none')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.never' })
	                        )
	                    )
	                ));
	
	                var handleUpdateSection = function updateSection(e) {
	                    this.updateSection('');
	                    this.onListenerChange();
	                    e.preventDefault();
	                }.bind(this);
	
	                var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'channel_notifications.override',
	                        defaultMessage: 'Selecting an option other than "Default" will override the global notification settings. Desktop notifications are available on Firefox, Safari, and Chrome.'
	                    })
	                );
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: sendDesktop,
	                    inputs: inputs,
	                    submit: this.handleSubmitNotifyLevel,
	                    server_error: serverError,
	                    updateSection: handleUpdateSection,
	                    extraInfo: extraInfo
	                });
	            }
	
	            var describe;
	            if (notificationLevel === 'default') {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'channel_notifications.globalDefault',
	                    values: {
	                        notifyLevel: globalNotifyLevelName
	                    }
	                });
	            } else if (notificationLevel === 'mention') {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.onlyMentions' });
	            } else if (notificationLevel === 'all') {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.allActivity' });
	            } else {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.never' });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                title: sendDesktop,
	                describe: describe,
	                updateSection: function updateSection() {
	                    _this3.updateSection('desktop');
	                }
	            });
	        }
	    }, {
	        key: 'handleSubmitMarkUnreadLevel',
	        value: function handleSubmitMarkUnreadLevel() {
	            var _this4 = this;
	
	            var channelId = this.props.channel.id;
	            var markUnreadLevel = this.state.unreadLevel;
	
	            if (this.props.channelMember.notify_props.mark_unread === markUnreadLevel) {
	                this.updateSection('');
	                return;
	            }
	
	            var data = {
	                channel_id: channelId,
	                user_id: this.props.currentUser.id,
	                mark_unread: markUnreadLevel
	            };
	
	            //TODO: This should be fixed, moved to event_helpers
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].updateChannelNotifyProps(data, function () {
	                // Yuck...
	                var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].getMember(channelId);
	                member.notify_props.mark_unread = markUnreadLevel;
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].setChannelMember(member);
	                _this4.updateSection('');
	            }, function (err) {
	                _this4.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleUpdateMarkUnreadLevel',
	        value: function handleUpdateMarkUnreadLevel(unreadLevel) {
	            this.setState({ unreadLevel: unreadLevel });
	        }
	    }, {
	        key: 'createMarkUnreadLevelSection',
	        value: function createMarkUnreadLevelSection(serverError) {
	            var content = void 0;
	
	            var markUnread = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                id: 'channel_notifications.markUnread',
	                defaultMessage: 'Mark Channel Unread'
	            });
	            if (this.state.activeSection === 'markUnreadLevel') {
	                var inputs = [/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { key: 'channel-notification-unread-radio' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: this.state.unreadLevel === 'all',
	                                onChange: this.handleUpdateMarkUnreadLevel.bind(this, 'all')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'channel_notifications.allUnread',
	                                defaultMessage: 'For all unread messages'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: this.state.unreadLevel === 'mention',
	                                onChange: this.handleUpdateMarkUnreadLevel.bind(this, 'mention')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.onlyMentions' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    )
	                )];
	
	                var handleUpdateSection = function handleUpdateSection(e) {
	                    this.updateSection('');
	                    this.onListenerChange();
	                    e.preventDefault();
	                }.bind(this);
	
	                var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'channel_notifications.unreadInfo',
	                        defaultMessage: 'The channel name is bolded in the sidebar when there are unread messages. Selecting "Only for mentions" will bold the channel only when you are mentioned.'
	                    })
	                );
	
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: markUnread,
	                    inputs: inputs,
	                    submit: this.handleSubmitMarkUnreadLevel,
	                    server_error: serverError,
	                    updateSection: handleUpdateSection,
	                    extraInfo: extraInfo
	                });
	            } else {
	                var describe = void 0;
	
	                if (!this.state.unreadLevel || this.state.unreadLevel === 'all') {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'channel_notifications.allUnread',
	                        defaultMessage: 'For all unread messages'
	                    });
	                } else {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], { id: 'channel_notifications.onlyMentions' });
	                }
	
	                var _handleUpdateSection = function handleUpdateSection(e) {
	                    this.updateSection('markUnreadLevel');
	                    e.preventDefault();
	                }.bind(this);
	
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: markUnread,
	                    describe: describe,
	                    updateSection: _handleUpdateSection
	                });
	            }
	
	            return content;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    dialogClassName: 'settings-modal',
	                    onHide: this.props.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'channel_notifications.preferences',
	                            defaultMessage: 'Notification Preferences for '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'span',
	                            { className: 'name' },
	                            this.props.channel.display_name
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'settings-table' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'div',
	                            { className: 'settings-content' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                                'div',
	                                {
	                                    ref: 'wrapper',
	                                    className: 'user-settings'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                                this.createNotifyLevelSection(serverError),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-light' }),
	                                this.createMarkUnreadLevelSection(serverError),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-dark' })
	                            )
	                        )
	                    ),
	                    serverError
	                )
	            );
	        }
	    }]);
	
	    return ChannelNotificationsModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelNotificationsModal;
	
	
	ChannelNotificationsModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired,
	    channelMember: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var ChannelSelect = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelSelect, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ChannelSelect, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                onChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func,
	                value: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string
	            };
	        }
	    }]);
	
	    function ChannelSelect(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelSelect);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelSelect).call(this, props));
	
	        _this.handleChannelChange = _this.handleChannelChange.bind(_this);
	
	        _this.state = {
	            channels: []
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ChannelSelect, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                channels: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getAll()
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].addChangeListener(this.handleChannelChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].removeChangeListener(this.handleChannelChange);
	        }
	    }, {
	        key: 'handleChannelChange',
	        value: function handleChannelChange() {
	            this.setState({
	                channels: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getAll()
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var options = [/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'option',
	                {
	                    key: '',
	                    value: ''
	                },
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('channel_select.placeholder', '--- Select a channel ---')
	            )];
	
	            this.state.channels.forEach(function (channel) {
	                if (channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].OPEN_CHANNEL) {
	                    options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'option',
	                        {
	                            key: channel.id,
	                            value: channel.id
	                        },
	                        channel.display_name
	                    ));
	                }
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'select',
	                {
	                    className: 'form-control',
	                    value: this.props.value,
	                    onChange: this.props.onChange
	                },
	                options
	            );
	        }
	    }]);
	
	    return ChannelSelect;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelSelect;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router___default = __WEBPACK_IMPORTED_MODULE_11_react_router__ && __WEBPACK_IMPORTED_MODULE_11_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var DeleteChannelModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(DeleteChannelModal, _React$Component);
	
	    function DeleteChannelModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DeleteChannelModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(DeleteChannelModal).call(this, props));
	
	        _this.handleDelete = _this.handleDelete.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(DeleteChannelModal, [{
	        key: 'handleDelete',
	        value: function handleDelete() {
	            if (this.props.channel.id.length !== 26) {
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_router__["browserHistory"].push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentTeamRelativeUrl() + '/channels/town-square');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].deleteChannel(this.props.channel.id, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_async_client_jsx__.getChannels(true);
	            }, function (err) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_async_client_jsx__.dispatchError(err, 'handleDelete');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var channelTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                id: 'delete_channel.channel',
	                defaultMessage: 'channel'
	            });
	            if (this.props.channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].PRIVATE_CHANNEL) {
	                channelTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'delete_channel.group',
	                    defaultMessage: 'group'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.props.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'h4',
	                        { className: 'modal-title' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'delete_channel.confirm',
	                            defaultMessage: 'Confirm DELETE Channel'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'delete_channel.question',
	                        defaultMessage: 'Are you sure you wish to delete the {display_name} {term}?',
	                        values: {
	                            display_name: this.props.channel.display_name,
	                            term: channelTerm
	                        }
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.props.onHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'delete_channel.cancel',
	                            defaultMessage: 'Cancel'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-danger',
	                            'data-dismiss': 'modal',
	                            onClick: this.handleDelete
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'delete_channel.del',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeleteChannelModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = DeleteChannelModal;
	
	
	DeleteChannelModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    error: {
	        id: 'edit_channel_purpose_modal.error',
	        defaultMessage: 'This channel purpose is too long, please enter a shorter one'
	    }
	});
	
	
	
	var EditChannelPurposeModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(EditChannelPurposeModal, _React$Component);
	
	    function EditChannelPurposeModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EditChannelPurposeModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EditChannelPurposeModal).call(this, props));
	
	        _this.handleHide = _this.handleHide.bind(_this);
	        _this.handleSave = _this.handleSave.bind(_this);
	
	        _this.state = { serverError: '' };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(EditChannelPurposeModal, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.show) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.purpose)).focus();
	            }
	        }
	    }, {
	        key: 'handleHide',
	        value: function handleHide() {
	            this.setState({ serverError: '' });
	
	            if (this.props.onModalDismissed) {
	                this.props.onModalDismissed();
	            }
	        }
	    }, {
	        key: 'handleSave',
	        value: function handleSave() {
	            var _this2 = this;
	
	            if (!this.props.channel) {
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].updateChannelPurpose(this.props.channel.id, /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.purpose).value.trim(), function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.getChannel(_this2.props.channel.id);
	
	                _this2.handleHide();
	            }, function (err) {
	                if (err.id === 'api.context.invalid_param.app_error') {
	                    _this2.setState({ serverError: _this2.props.intl.formatMessage(holders.error) });
	                } else {
	                    _this2.setState({ serverError: err.message });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.show) {
	                return null;
	            }
	
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var title = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                'span',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'edit_channel_purpose_modal.title1',
	                    defaultMessage: 'Edit Purpose'
	                })
	            );
	            if (this.props.channel.display_name) {
	                title = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'edit_channel_purpose_modal.title2',
	                        defaultMessage: 'Edit Purpose for '
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'span',
	                        { className: 'name' },
	                        this.props.channel.display_name
	                    )
	                );
	            }
	
	            var channelType = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                id: 'edit_channel_purpose_modal.channel',
	                defaultMessage: 'Channel'
	            });
	            if (this.props.channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].PRIVATE_CHANNEL) {
	                channelType = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'edit_channel_purpose_modal.group',
	                    defaultMessage: 'Group'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"],
	                {
	                    className: 'modal-edit-channel-purpose',
	                    ref: 'modal',
	                    show: this.props.show,
	                    onHide: this.handleHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Title,
	                        null,
	                        title
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_purpose_modal.body',
	                            defaultMessage: 'Describe how this {type} should be used. This text appears in the channel list in the "More..." menu and helps others decide whether to join.',
	                            values: {
	                                type: channelType
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('textarea', {
	                        ref: 'purpose',
	                        className: 'form-control no-resize',
	                        rows: '6',
	                        maxLength: '128',
	                        defaultValue: this.props.channel.purpose
	                    }),
	                    serverError
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.handleHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_purpose_modal.cancel',
	                            defaultMessage: 'Cancel'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-primary',
	                            onClick: this.handleSave
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'edit_channel_purpose_modal.save',
	                            defaultMessage: 'Save'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EditChannelPurposeModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = EditChannelPurposeModal;
	
	
	EditChannelPurposeModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.bool.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(EditChannelPurposeModal);

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_8_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_8_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_images_load_gif___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var FilePreview = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FilePreview, _React$Component);
	
	    function FilePreview(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FilePreview);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FilePreview).call(this, props));
	
	        _this.handleRemove = _this.handleRemove.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FilePreview, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.uploadsInProgress.length > 0) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs[this.props.uploadsInProgress[0]]).scrollIntoView();
	            }
	        }
	    }, {
	        key: 'handleRemove',
	        value: function handleRemove(e) {
	            var previewDiv = e.target.parentNode.parentNode;
	
	            if (previewDiv.hasAttribute('data-filename')) {
	                this.props.onRemove(previewDiv.getAttribute('data-filename'));
	            } else if (previewDiv.hasAttribute('data-client-id')) {
	                this.props.onRemove(previewDiv.getAttribute('data-client-id'));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var previews = [];
	            this.props.files.forEach(function (fullFilename) {
	                var filename = fullFilename;
	                var originalFilename = filename;
	                var filenameSplit = filename.split('.');
	                var ext = filenameSplit[filenameSplit.length - 1];
	                var type = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.getFileType(ext);
	
	                filename = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.getFileUrl(filename);
	
	                if (type === 'image') {
	                    previews.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        {
	                            key: filename,
	                            className: 'file-preview',
	                            'data-filename': originalFilename
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', {
	                            className: 'file-preview__image',
	                            src: filename
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'file-preview__remove',
	                                onClick: _this2.handleRemove
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'glyphicon glyphicon-remove' })
	                        )
	                    ));
	                } else {
	                    previews.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        {
	                            key: filename,
	                            className: 'file-preview custom-file',
	                            'data-filename': originalFilename
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'file-icon ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.getIconClassName(type) }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'file-preview__remove',
	                                onClick: _this2.handleRemove
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'glyphicon glyphicon-remove' })
	                        )
	                    ));
	                }
	            });
	
	            this.props.uploadsInProgress.forEach(function (clientId) {
	                previews.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: clientId,
	                        key: clientId,
	                        className: 'file-preview',
	                        'data-client-id': clientId
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', {
	                        className: 'spinner',
	                        src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_images_load_gif___default.a
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'a',
	                        {
	                            className: 'file-preview__remove',
	                            onClick: _this2.handleRemove
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'glyphicon glyphicon-remove' })
	                    )
	                ));
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                { className: 'file-preview__container' },
	                previews
	            );
	        }
	    }]);
	
	    return FilePreview;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = FilePreview;
	
	
	FilePreview.defaultProps = {
	    files: [],
	    uploadsInProgress: []
	};
	FilePreview.propTypes = {
	    onRemove: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired,
	    files: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.array,
	    uploadsInProgress: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.array
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __WEBPACK_IMPORTED_MODULE_7_jquery__ && __WEBPACK_IMPORTED_MODULE_7_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js__ = __webpack_require__(1738);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js___default = __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js__ && __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_jquery_dragster_jquery_dragster_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __WEBPACK_IMPORTED_MODULE_9_react_dom__ && __WEBPACK_IMPORTED_MODULE_9_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl___default = __WEBPACK_IMPORTED_MODULE_14_react_intl__ && __WEBPACK_IMPORTED_MODULE_14_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["defineMessages"].bind()({
	    limited: {
	        id: 'file_upload.limited',
	        defaultMessage: 'Uploads limited to {count} files maximum. Please use additional posts for more files.'
	    },
	    filesAbove: {
	        id: 'file_upload.filesAbove',
	        defaultMessage: 'Files above {max}MB could not be uploaded: {filenames}'
	    },
	    fileAbove: {
	        id: 'file_upload.fileAbove',
	        defaultMessage: 'File above {max}MB could not be uploaded: {filename}'
	    },
	    pasted: {
	        id: 'file_upload.pasted',
	        defaultMessage: 'Image Pasted at '
	    }
	});
	
	
	
	var FileUpload = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(FileUpload, _React$Component);
	
	    function FileUpload(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FileUpload);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FileUpload).call(this, props));
	
	        _this.uploadFiles = _this.uploadFiles.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleDrop = _this.handleDrop.bind(_this);
	        _this.cancelUpload = _this.cancelUpload.bind(_this);
	        _this.pasteUpload = _this.pasteUpload.bind(_this);
	        _this.keyUpload = _this.keyUpload.bind(_this);
	
	        _this.state = {
	            requests: {}
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(FileUpload, [{
	        key: 'fileUploadSuccess',
	        value: function fileUploadSuccess(channelId, data) {
	            this.props.onFileUpload(data.filenames, data.client_ids, channelId);
	
	            var requests = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, this.state.requests);
	            for (var j = 0; j < data.client_ids.length; j++) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(requests, data.client_ids[j]);
	            }
	            this.setState({ requests: requests });
	        }
	    }, {
	        key: 'fileUploadFail',
	        value: function fileUploadFail(clientId, channelId, err) {
	            this.props.onUploadError(err, clientId, channelId);
	        }
	    }, {
	        key: 'uploadFiles',
	        value: function uploadFiles(files) {
	            // clear any existing errors
	            this.props.onUploadError(null);
	
	            var channelId = this.props.channelId || /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__["a"].getCurrentId();
	
	            var uploadsRemaining = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_UPLOAD_FILES - this.props.getFileCount(channelId);
	            var numUploads = 0;
	
	            // keep track of how many files have been too large
	            var tooLargeFiles = [];
	
	            for (var i = 0; i < files.length && numUploads < uploadsRemaining; i++) {
	                if (files[i].size > /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_FILE_SIZE) {
	                    tooLargeFiles.push(files[i]);
	                    continue;
	                }
	
	                // generate a unique id that can be used by other components to refer back to this upload
	                var clientId = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.generateId();
	
	                var request = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].uploadFile(files[i], files[i].name, channelId, clientId, this.fileUploadSuccess.bind(this, channelId), this.fileUploadFail.bind(this, clientId, channelId));
	
	                var requests = this.state.requests;
	                requests[clientId] = request;
	                this.setState({ requests: requests });
	
	                this.props.onUploadStart([clientId], channelId);
	
	                numUploads += 1;
	            }
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            if (files.length > uploadsRemaining) {
	                this.props.onUploadError(formatMessage(holders.limited, { count: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_UPLOAD_FILES }));
	            } else if (tooLargeFiles.length > 1) {
	                var tooLargeFilenames = tooLargeFiles.map(function (file) {
	                    return file.name;
	                }).join(', ');
	
	                this.props.onUploadError(formatMessage(holders.filesAbove, { max: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_FILE_SIZE / 1000000, filenames: tooLargeFilenames }));
	            } else if (tooLargeFiles.length > 0) {
	                this.props.onUploadError(formatMessage(holders.fileAbove, { max: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_FILE_SIZE / 1000000, filename: tooLargeFiles[0].name }));
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            if (e.target.files.length > 0) {
	                this.uploadFiles(e.target.files);
	
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.clearFileInput(e.target);
	            }
	        }
	    }, {
	        key: 'handleDrop',
	        value: function handleDrop(e) {
	            this.props.onUploadError(null);
	
	            var files = e.originalEvent.dataTransfer.files;
	
	            if (typeof files !== 'string' && files.length) {
	                this.uploadFiles(files);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var self = this;
	            if (this.props.postType === 'post') {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.row.main').dragster({
	                    enter: function enter(dragsterEvent, e) {
	                        var files = e.originalEvent.dataTransfer;
	
	                        if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isFileTransfer(files)) {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.center-file-overlay').removeClass('hidden');
	                        }
	                    },
	                    leave: function leave(dragsterEvent, e) {
	                        var files = e.originalEvent.dataTransfer;
	
	                        if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isFileTransfer(files)) {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.center-file-overlay').addClass('hidden');
	                        }
	                    },
	                    drop: function drop(dragsterEvent, e) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.center-file-overlay').addClass('hidden');
	                        self.handleDrop(e);
	                    }
	                });
	            } else if (this.props.postType === 'comment') {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.post-right__container').dragster({
	                    enter: function enter(dragsterEvent, e) {
	                        var files = e.originalEvent.dataTransfer;
	
	                        if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isFileTransfer(files)) {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.right-file-overlay').removeClass('hidden');
	                        }
	                    },
	                    leave: function leave(dragsterEvent, e) {
	                        var files = e.originalEvent.dataTransfer;
	
	                        if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isFileTransfer(files)) {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.right-file-overlay').addClass('hidden');
	                        }
	                    },
	                    drop: function drop(dragsterEvent, e) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.right-file-overlay').addClass('hidden');
	                        self.handleDrop(e);
	                    }
	                });
	            }
	
	            document.addEventListener('paste', this.pasteUpload);
	            document.addEventListener('keydown', this.keyUpload);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var target = void 0;
	            if (this.props.postType === 'post') {
	                target = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.row.main');
	            } else {
	                target = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.post-right__container');
	            }
	
	            document.removeEventListener('paste', this.pasteUpload);
	            document.removeEventListener('keydown', this.keyUpload);
	
	            // jquery-dragster doesn't provide a function to unregister itself so do it manually
	            target.off('dragenter dragleave dragover drop dragster:enter dragster:leave dragster:over dragster:drop');
	        }
	    }, {
	        key: 'pasteUpload',
	        value: function pasteUpload(e) {
	            var inputDiv = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this.refs.input);
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            if (!e.clipboardData) {
	                return;
	            }
	
	            var textarea = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()(inputDiv.parentNode.parentNode).find('.custom-textarea')[0];
	
	            if (textarea !== e.target && !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.contains(textarea, e.target)) {
	                return;
	            }
	
	            this.props.onUploadError(null);
	
	            // This looks redundant, but must be done this way due to
	            // setState being an asynchronous call
	            var items = e.clipboardData.items;
	            var numItems = 0;
	            if (items) {
	                for (var _i = 0; _i < items.length; _i++) {
	                    if (items[_i].type.indexOf('image') !== -1) {
	                        var testExt = items[_i].type.split('/')[1].toLowerCase();
	
	                        if (/* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].IMAGE_TYPES.indexOf(testExt) < 0) {
	                            continue;
	                        }
	
	                        numItems++;
	                    }
	                }
	
	                var numToUpload = Math.min(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_UPLOAD_FILES - this.props.getFileCount(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__["a"].getCurrentId()), numItems);
	
	                if (numItems > numToUpload) {
	                    this.props.onUploadError(formatMessage(holders.limited, { count: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].MAX_UPLOAD_FILES }));
	                }
	
	                for (var i = 0; i < items.length && i < numToUpload; i++) {
	                    if (items[i].type.indexOf('image') !== -1) {
	                        var file = items[i].getAsFile();
	
	                        var ext = items[i].type.split('/')[1].toLowerCase();
	
	                        if (/* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].IMAGE_TYPES.indexOf(ext) < 0) {
	                            continue;
	                        }
	                        var channelId = this.props.channelId || /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__["a"].getCurrentId();
	
	                        // generate a unique id that can be used by other components to refer back to this file upload
	                        var clientId = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.generateId();
	
	                        var d = new Date();
	                        var hour;
	                        if (d.getHours() < 10) {
	                            hour = '0' + d.getHours();
	                        } else {
	                            hour = String(d.getHours());
	                        }
	                        var min;
	                        if (d.getMinutes() < 10) {
	                            min = '0' + d.getMinutes();
	                        } else {
	                            min = String(d.getMinutes());
	                        }
	
	                        var name = formatMessage(holders.pasted) + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + hour + '-' + min + '.' + ext;
	
	                        var request = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].uploadFile(file, name, channelId, clientId, this.fileUploadSuccess.bind(this, channelId), this.fileUploadFail.bind(this, clientId));
	
	                        var requests = this.state.requests;
	                        requests[clientId] = request;
	                        this.setState({ requests: requests });
	
	                        this.props.onUploadStart([clientId], channelId);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'keyUpload',
	        value: function keyUpload(e) {
	            if ((e.ctrlKey || e.metaKey) && e.keyCode === /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].KeyCodes.U) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()(this.refs.input).focus().trigger('click');
	            }
	        }
	    }, {
	        key: 'cancelUpload',
	        value: function cancelUpload(clientId) {
	            var requests = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, this.state.requests);
	            var request = requests[clientId];
	
	            if (request) {
	                request.abort();
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(requests, clientId);
	                this.setState({ requests: requests });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var multiple = true;
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isMobileApp()) {
	                // iOS WebViews don't upload videos properly in multiple mode
	                multiple = false;
	            }
	
	            var accept = '';
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isIosChrome()) {
	                // iOS Chrome can't upload videos at all
	                accept = 'image/*';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                'span',
	                {
	                    ref: 'input',
	                    className: 'btn btn-file'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('i', { className: 'glyphicon glyphicon-paperclip' })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('input', {
	                    ref: 'fileInput',
	                    type: 'file',
	                    onChange: this.handleChange,
	                    onClick: this.props.onClick,
	                    multiple: multiple,
	                    accept: accept
	                })
	            );
	        }
	    }]);
	
	    return FileUpload;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	FileUpload.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["intlShape"].isRequired,
	    onUploadError: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    getFileCount: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    onFileUpload: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    onUploadStart: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    onTextDrop: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.string,
	    postType: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.string
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["injectIntl"].bind()(FileUpload, { withRef: true });

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png__ = __webpack_require__(810);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png___default = __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png__ && __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png__ = __webpack_require__(816);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png___default = __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png__ && __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var FileUploadOverlay = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FileUploadOverlay, _React$Component);
	
	    function FileUploadOverlay() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FileUploadOverlay);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FileUploadOverlay).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FileUploadOverlay, [{
	        key: 'render',
	        value: function render() {
	            var overlayClass = 'file-overlay hidden';
	            if (this.props.overlayType === 'right') {
	                overlayClass += ' right-file-overlay';
	            } else if (this.props.overlayType === 'center') {
	                overlayClass += ' center-file-overlay';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: overlayClass },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'overlay__indent' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'overlay__circle' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', {
	                            className: 'overlay__files',
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_images_filesOverlay_png___default.a,
	                            alt: 'Files'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'span',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', { className: 'fa fa-upload' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                                id: 'upload_overlay.info',
	                                defaultMessage: 'Drop a file to upload it.'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', {
	                            className: 'overlay__logo',
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_images_logoWhite_png___default.a,
	                            width: '100',
	                            alt: 'Logo'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FileUploadOverlay;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = FileUploadOverlay;
	
	
	FileUploadOverlay.propTypes = {
	    overlayType: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string
	};

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var MessageWrapper = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(MessageWrapper, _React$Component);
	
	    function MessageWrapper(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MessageWrapper);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MessageWrapper).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(MessageWrapper, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.message) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_text_formatting_jsx__.formatText(this.props.message, this.props.options) } });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null);
	        }
	    }]);
	
	    return MessageWrapper;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = MessageWrapper;
	
	
	MessageWrapper.defaultProps = {
	    message: ''
	};
	MessageWrapper.propTypes = {
	    message: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string,
	    options: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object
	};

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_user_typing_store_jsx__ = __webpack_require__(787);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var MsgTyping = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(MsgTyping, _React$Component);
	
	    function MsgTyping(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MsgTyping);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MsgTyping).call(this, props));
	
	        _this.onTypingChange = _this.onTypingChange.bind(_this);
	        _this.updateTypingText = _this.updateTypingText.bind(_this);
	        _this.componentWillReceiveProps = _this.componentWillReceiveProps.bind(_this);
	
	        _this.state = {
	            text: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(MsgTyping, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_typing_store_jsx__["a"].addChangeListener(this.onTypingChange);
	            this.onTypingChange();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_typing_store_jsx__["a"].removeChangeListener(this.onTypingChange);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.channelId !== nextProps.channelId) {
	                this.updateTypingText(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_typing_store_jsx__["a"].getUsersTyping(nextProps.channelId, nextProps.parentId));
	            }
	        }
	    }, {
	        key: 'onTypingChange',
	        value: function onTypingChange() {
	            this.updateTypingText(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_typing_store_jsx__["a"].getUsersTyping(this.props.channelId, this.props.parentId));
	        }
	    }, {
	        key: 'updateTypingText',
	        value: function updateTypingText(typingUsers) {
	            var text = '';
	            var users = {};
	            var numUsers = 0;
	            if (typingUsers) {
	                users = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(typingUsers);
	                numUsers = users.length;
	            }
	
	            switch (numUsers) {
	                case 0:
	                    text = '';
	                    break;
	                case 1:
	                    text = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                        id: 'msg_typing.isTyping',
	                        defaultMessage: '{user} is typing...',
	                        values: {
	                            user: users[0]
	                        }
	                    });
	                    break;
	                default:
	                    {
	                        var last = users.pop();
	                        text = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'msg_typing.areTyping',
	                            defaultMessage: '{users} and {last} are typing...',
	                            values: {
	                                users: users.join(', '),
	                                last: last
	                            }
	                        });
	                        break;
	                    }
	            }
	
	            this.setState({ text: text });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'span',
	                { className: 'msg-typing' },
	                this.state.text
	            );
	        }
	    }]);
	
	    return MsgTyping;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	MsgTyping.propTypes = {
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string,
	    parentId: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string
	};
	
	/* harmony default export */ exports["a"] = MsgTyping;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__new_channel_modal_jsx__ = __webpack_require__(717);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__change_url_modal_jsx__ = __webpack_require__(683);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router___default = __WEBPACK_IMPORTED_MODULE_11_react_router__ && __WEBPACK_IMPORTED_MODULE_11_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].ActionTypes;
	
	var SHOW_NEW_CHANNEL = 1;
	var SHOW_EDIT_URL = 2;
	var SHOW_EDIT_URL_THEN_COMPLETE = 3;
	var messages = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    channel: {
	        id: 'channel_flow.channel',
	        defaultMessage: 'Channel'
	    },
	    group: {
	        id: 'channel_flow.group',
	        defaultMessage: 'Group'
	    },
	    change: {
	        id: 'channel_flow.changeUrlTitle',
	        defaultMessage: 'Change {term} URL'
	    },
	    set: {
	        id: 'channel_flow.set_url_title',
	        defaultMessage: 'Set {term} URL'
	    },
	    create: {
	        id: 'channel_flow.create',
	        defaultMessage: 'Create {term}'
	    },
	    changeUrlDescription: {
	        id: 'channel_flow.changeUrlDescription',
	        defaultMessage: 'Some characters are not allowed in URLs and may be removed.'
	    }
	});
	
	
	
	var NewChannelFlow = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NewChannelFlow, _React$Component);
	
	    function NewChannelFlow(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NewChannelFlow);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NewChannelFlow).call(this, props));
	
	        _this.doSubmit = _this.doSubmit.bind(_this);
	        _this.typeSwitched = _this.typeSwitched.bind(_this);
	        _this.urlChangeRequested = _this.urlChangeRequested.bind(_this);
	        _this.urlChangeSubmitted = _this.urlChangeSubmitted.bind(_this);
	        _this.urlChangeDismissed = _this.urlChangeDismissed.bind(_this);
	        _this.channelDataChanged = _this.channelDataChanged.bind(_this);
	
	        _this.state = {
	            serverError: '',
	            channelType: 'O',
	            flowState: SHOW_NEW_CHANNEL,
	            channelDisplayName: '',
	            channelName: '',
	            channelPurpose: '',
	            nameModified: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NewChannelFlow, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // If we are being shown, grab channel type from props and clear
	            if (nextProps.show === true && this.props.show === false) {
	                this.setState({
	                    serverError: '',
	                    channelType: nextProps.channelType,
	                    flowState: SHOW_NEW_CHANNEL,
	                    channelDisplayName: '',
	                    channelName: '',
	                    channelPurpose: '',
	                    nameModified: false
	                });
	            }
	        }
	    }, {
	        key: 'doSubmit',
	        value: function doSubmit() {
	            var _this2 = this;
	
	            if (!this.state.channelDisplayName) {
	                this.setState({ serverError: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('channel_flow.invalidName', 'Invalid Channel Name') });
	                return;
	            }
	
	            if (this.state.channelName < 2) {
	                this.setState({ flowState: SHOW_EDIT_URL_THEN_COMPLETE });
	                return;
	            }
	
	            var cu = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser();
	            var channel = {
	                team_id: cu.team_id,
	                name: this.state.channelName,
	                display_name: this.state.channelDisplayName,
	                purpose: this.state.channelPurpose,
	                type: this.state.channelType
	            };
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].createChannel(channel, function (data) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].getChannel(data.id, function (data2) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                        type: ActionTypes.RECEIVED_CHANNEL,
	                        channel: data2.channel,
	                        member: data2.member
	                    });
	
	                    _this2.props.onModalDismissed();
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/channels/' + data2.channel.name);
	                });
	            }, function (err) {
	                if (err.id === 'model.channel.is_valid.2_or_more.app_error') {
	                    _this2.setState({ flowState: SHOW_EDIT_URL_THEN_COMPLETE });
	                }
	                if (err.id === 'store.sql_channel.update.exists.app_error') {
	                    _this2.setState({ serverError: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('channel_flow.alreadyExist', 'A channel with that URL already exists') });
	                    return;
	                }
	                _this2.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'typeSwitched',
	        value: function typeSwitched() {
	            if (this.state.channelType === 'P') {
	                this.setState({ channelType: 'O' });
	            } else {
	                this.setState({ channelType: 'P' });
	            }
	        }
	    }, {
	        key: 'urlChangeRequested',
	        value: function urlChangeRequested() {
	            this.setState({ flowState: SHOW_EDIT_URL });
	        }
	    }, {
	        key: 'urlChangeSubmitted',
	        value: function urlChangeSubmitted(newURL) {
	            if (this.state.flowState === SHOW_EDIT_URL_THEN_COMPLETE) {
	                this.setState({ channelName: newURL, nameModified: true }, this.doSubmit);
	            } else {
	                this.setState({ flowState: SHOW_NEW_CHANNEL, serverError: '', channelName: newURL, nameModified: true });
	            }
	        }
	    }, {
	        key: 'urlChangeDismissed',
	        value: function urlChangeDismissed() {
	            this.setState({ flowState: SHOW_NEW_CHANNEL });
	        }
	    }, {
	        key: 'channelDataChanged',
	        value: function channelDataChanged(data) {
	            this.setState({
	                channelDisplayName: data.displayName,
	                channelPurpose: data.purpose
	            });
	            if (!this.state.nameModified) {
	                this.setState({ channelName: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.cleanUpUrlable(data.displayName.trim()) });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var channelData = {
	                name: this.state.channelName,
	                displayName: this.state.channelDisplayName,
	                purpose: this.state.channelPurpose
	            };
	
	            var showChannelModal = false;
	            var showGroupModal = false;
	            var showChangeURLModal = false;
	
	            var changeURLTitle = '';
	            var changeURLSubmitButtonText = '';
	            var channelTerm = '';
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            // Only listen to flow state if we are being shown
	
	            if (this.props.show) {
	                switch (this.state.flowState) {
	                    case SHOW_NEW_CHANNEL:
	                        if (this.state.channelType === 'O') {
	                            showChannelModal = true;
	                            channelTerm = formatMessage(messages.channel);
	                        } else {
	                            showGroupModal = true;
	                            channelTerm = formatMessage(messages.group);
	                        }
	                        break;
	                    case SHOW_EDIT_URL:
	                        showChangeURLModal = true;
	                        changeURLTitle = formatMessage(messages.change, { term: channelTerm });
	                        changeURLSubmitButtonText = formatMessage(messages.change, { term: channelTerm });
	                        break;
	                    case SHOW_EDIT_URL_THEN_COMPLETE:
	                        showChangeURLModal = true;
	                        changeURLTitle = formatMessage(messages.set, { term: channelTerm });
	                        changeURLSubmitButtonText = formatMessage(messages.create, { term: channelTerm });
	                        break;
	                }
	            }
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'span',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__new_channel_modal_jsx__["a"], {
	                    show: showChannelModal,
	                    channelType: 'O',
	                    channelData: channelData,
	                    serverError: this.state.serverError,
	                    onSubmitChannel: this.doSubmit,
	                    onModalDismissed: this.props.onModalDismissed,
	                    onTypeSwitched: this.typeSwitched,
	                    onChangeURLPressed: this.urlChangeRequested,
	                    onDataChanged: this.channelDataChanged
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__new_channel_modal_jsx__["a"], {
	                    show: showGroupModal,
	                    channelType: 'P',
	                    channelData: channelData,
	                    serverError: this.state.serverError,
	                    onSubmitChannel: this.doSubmit,
	                    onModalDismissed: this.props.onModalDismissed,
	                    onTypeSwitched: this.typeSwitched,
	                    onChangeURLPressed: this.urlChangeRequested,
	                    onDataChanged: this.channelDataChanged
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__change_url_modal_jsx__["a"], {
	                    show: showChangeURLModal,
	                    title: changeURLTitle,
	                    description: formatMessage(messages.changeUrlDescription),
	                    urlLabel: channelTerm + ' URL',
	                    submitButtonText: changeURLSubmitButtonText,
	                    currentURL: this.state.channelName,
	                    serverError: this.state.serverError,
	                    onModalSubmit: this.urlChangeSubmitted,
	                    onModalDismissed: this.urlChangeDismissed
	                })
	            );
	        }
	    }]);
	
	    return NewChannelFlow;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	NewChannelFlow.defaultProps = {
	    show: false,
	    channelType: 'O'
	};
	
	NewChannelFlow.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool.isRequired,
	    channelType: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.string.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(NewChannelFlow);

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__post_attachment_list_jsx__ = __webpack_require__(725);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__post_attachment_oembed_jsx__ = __webpack_require__(726);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__post_image_jsx__ = __webpack_require__(730);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__youtube_video_jsx__ = __webpack_require__(784);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__providers_json__ = __webpack_require__(1752);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__providers_json___default = __WEBPACK_IMPORTED_MODULE_10__providers_json__ && __WEBPACK_IMPORTED_MODULE_10__providers_json__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10__providers_json__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10__providers_json__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10__providers_json___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10__providers_json___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	var PostBodyAdditionalContent = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostBodyAdditionalContent, _React$Component);
	
	    function PostBodyAdditionalContent(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostBodyAdditionalContent);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostBodyAdditionalContent).call(this, props));
	
	        _this.getSlackAttachment = _this.getSlackAttachment.bind(_this);
	        _this.getOEmbedProvider = _this.getOEmbedProvider.bind(_this);
	        _this.generateEmbed = _this.generateEmbed.bind(_this);
	        _this.toggleEmbedVisibility = _this.toggleEmbedVisibility.bind(_this);
	
	        _this.state = {
	            embedVisible: true
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostBodyAdditionalContent, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(nextProps.post, this.props.post)) {
	                return true;
	            }
	            if (nextState.embedVisible !== this.state.embedVisible) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'toggleEmbedVisibility',
	        value: function toggleEmbedVisibility() {
	            this.setState({ embedVisible: !this.state.embedVisible });
	        }
	    }, {
	        key: 'getSlackAttachment',
	        value: function getSlackAttachment() {
	            var attachments = [];
	            if (this.props.post.props && this.props.post.props.attachments) {
	                attachments = this.props.post.props.attachments;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__post_attachment_list_jsx__["a"], {
	                attachments: attachments
	            });
	        }
	    }, {
	        key: 'getOEmbedProvider',
	        value: function getOEmbedProvider(link) {
	            for (var i = 0; i < /* harmony import */__WEBPACK_IMPORTED_MODULE_10__providers_json___default.a.length; i++) {
	                for (var j = 0; j < /* harmony import */__WEBPACK_IMPORTED_MODULE_10__providers_json___default.a[i].patterns.length; j++) {
	                    if (link.match(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__providers_json___default.a[i].patterns[j])) {
	                        return /* harmony import */__WEBPACK_IMPORTED_MODULE_10__providers_json___default.a[i];
	                    }
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'generateEmbed',
	        value: function generateEmbed() {
	            if (this.props.post.type === 'slack_attachment') {
	                return this.getSlackAttachment();
	            }
	
	            var link = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.extractFirstLink(this.props.post.message);
	            if (!link) {
	                return null;
	            }
	
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isFeatureEnabled(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].PRE_RELEASE_FEATURES.EMBED_PREVIEW)) {
	                var provider = this.getOEmbedProvider(link);
	
	                if (provider) {
	                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__post_attachment_oembed_jsx__["a"], {
	                        provider: provider,
	                        link: link
	                    });
	                }
	            }
	
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_8__youtube_video_jsx__["a"].isYoutubeLink(link)) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__youtube_video_jsx__["a"], {
	                    channelId: this.props.post.channel_id,
	                    link: link
	                });
	            }
	
	            for (var i = 0; i < /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].IMAGE_TYPES.length; i++) {
	                var imageType = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].IMAGE_TYPES[i];
	                var suffix = link.substring(link.length - (imageType.length + 1));
	                if (suffix === '.' + imageType || suffix === '=' + imageType) {
	                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__post_image_jsx__["a"], {
	                        channelId: this.props.post.channel_id,
	                        link: link
	                    });
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var generateEmbed = this.generateEmbed();
	
	            if (generateEmbed) {
	                var toggle = void 0;
	                if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isFeatureEnabled(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].PRE_RELEASE_FEATURES.EMBED_TOGGLE)) {
	                    toggle = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('a', { className: 'post__embed-visibility',
	                        'data-expanded': this.state.embedVisible,
	                        'aria-label': 'Toggle Embed Visibility',
	                        onClick: this.toggleEmbedVisibility
	                    });
	                }
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    null,
	                    toggle,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'post__embed-container',
	                            hidden: !this.state.embedVisible
	                        },
	                        generateEmbed
	                    )
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return PostBodyAdditionalContent;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostBodyAdditionalContent;
	
	
	PostBodyAdditionalContent.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	var PostDeletedModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostDeletedModal, _React$Component);
	
	    function PostDeletedModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostDeletedModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostDeletedModal).call(this, props));
	
	        _this.handleHide = _this.handleHide.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostDeletedModal, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            return nextProps.show !== this.props.show;
	        }
	    }, {
	        key: 'handleHide',
	        value: function handleHide(e) {
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH,
	                results: null
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH_TERM,
	                term: null,
	                do_search: false,
	                is_mention_search: false
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_POST_SELECTED,
	                postId: null
	            });
	
	            this.props.onHide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.handleHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'post_delete.notPosted',
	                            defaultMessage: 'Comment could not be posted'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'post_delete.someone',
	                            defaultMessage: 'Someone deleted the message on which you tried to post a comment.'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-primary',
	                            onClick: this.handleHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'post_delete.okay',
	                            defaultMessage: 'Okay'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostDeletedModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostDeletedModal;
	
	
	PostDeletedModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __WEBPACK_IMPORTED_MODULE_7_jquery__ && __WEBPACK_IMPORTED_MODULE_7_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__post_jsx__ = __webpack_require__(723);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__floating_timestamp_jsx__ = __webpack_require__(702);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_channel_intro_messages_jsx__ = __webpack_require__(788);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_delayed_action_jsx__ = __webpack_require__(789);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __WEBPACK_IMPORTED_MODULE_17_react_intl__ && __WEBPACK_IMPORTED_MODULE_17_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __WEBPACK_IMPORTED_MODULE_18_react__ && __WEBPACK_IMPORTED_MODULE_18_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_dom___default = __WEBPACK_IMPORTED_MODULE_19_react_dom__ && __WEBPACK_IMPORTED_MODULE_19_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_react_dom___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].Preferences;
	
	
	
	
	
	
	var PostsView = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(PostsView, _React$Component);
	
	    function PostsView(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostsView);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostsView).call(this, props));
	
	        _this.updateState = _this.updateState.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleScrollStop = _this.handleScrollStop.bind(_this);
	        _this.isAtBottom = _this.isAtBottom.bind(_this);
	        _this.loadMorePostsTop = _this.loadMorePostsTop.bind(_this);
	        _this.loadMorePostsBottom = _this.loadMorePostsBottom.bind(_this);
	        _this.createPosts = _this.createPosts.bind(_this);
	        _this.updateScrolling = _this.updateScrolling.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	        _this.scrollToBottomAnimated = _this.scrollToBottomAnimated.bind(_this);
	        _this.onUserChange = _this.onUserChange.bind(_this);
	
	        _this.jumpToPostNode = null;
	        _this.wasAtBottom = true;
	        _this.scrollHeight = 0;
	
	        _this.scrollStopAction = new /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_delayed_action_jsx__["a"](_this.handleScrollStop);
	
	        var profiles = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getProfiles();
	        if (props.channel && props.channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].DM_CHANNEL) {
	            profiles = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, profiles, /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getDirectProfiles());
	        }
	
	        _this.state = {
	            displayNameType: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, 'name_format', 'false'),
	            centerPosts: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === Preferences.CHANNEL_DISPLAY_MODE_CENTERED,
	            isScrolling: false,
	            topPostId: null,
	            currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getCurrentUser(),
	            profiles: profiles
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(PostsView, [{
	        key: 'updateState',
	        value: function updateState() {
	            this.setState({
	                displayNameType: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, 'name_format', 'false'),
	                centerPosts: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === Preferences.CHANNEL_DISPLAY_MODE_CENTERED
	            });
	        }
	    }, {
	        key: 'onUserChange',
	        value: function onUserChange() {
	            var profiles = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getProfiles();
	            if (this.props.channel && this.props.channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].DM_CHANNEL) {
	                profiles = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, profiles, /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getDirectProfiles());
	            }
	            this.setState({ currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getCurrentUser(), profiles: JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(profiles)) });
	        }
	    }, {
	        key: 'isAtBottom',
	        value: function isAtBottom() {
	            // consider the view to be at the bottom if it's within this many pixels of the bottom
	            var atBottomMargin = 10;
	
	            return this.refs.postlist.clientHeight + this.refs.postlist.scrollTop >= this.refs.postlist.scrollHeight - atBottomMargin;
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll() {
	            // HACK FOR RHS -- REMOVE WHEN RHS DIES
	            var childNodes = this.refs.postlistcontent.childNodes;
	            for (var i = 0; i < childNodes.length; i++) {
	                // If the node is 1/3 down the page
	                if (childNodes[i].offsetTop > this.refs.postlist.scrollTop + this.refs.postlist.offsetHeight / 3) {
	                    this.jumpToPostNode = childNodes[i];
	                    break;
	                }
	            }
	            this.wasAtBottom = this.isAtBottom();
	            if (!this.jumpToPostNode && childNodes.length > 0) {
	                this.jumpToPostNode = childNodes[childNodes.length - 1];
	            }
	
	            // --- --------
	
	            this.props.postViewScrolled(this.isAtBottom());
	            this.prevScrollHeight = this.refs.postlist.scrollHeight;
	            this.prevOffsetTop = this.jumpToPostNode.offsetTop;
	
	            this.updateFloatingTimestamp();
	
	            if (!this.state.isScrolling) {
	                this.setState({
	                    isScrolling: true
	                });
	            }
	
	            this.scrollStopAction.fireAfter(2000);
	        }
	    }, {
	        key: 'handleScrollStop',
	        value: function handleScrollStop() {
	            this.setState({
	                isScrolling: false
	            });
	        }
	    }, {
	        key: 'updateFloatingTimestamp',
	        value: function updateFloatingTimestamp() {
	            // skip this in non-mobile view since that's when the timestamp is visible
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()(window).width() > 768) {
	                return;
	            }
	
	            if (this.props.postList) {
	                // iterate through posts starting at the bottom since users are more likely to be viewing newer posts
	                for (var i = 0; i < this.props.postList.order.length; i++) {
	                    var id = this.props.postList.order[i];
	                    var element = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react_dom___default.a.findDOMNode(this.refs[id]);
	
	                    if (!element || element.offsetTop + element.clientHeight <= this.refs.postlist.scrollTop) {
	                        // this post is off the top of the screen so the last one is at the top of the screen
	                        var topPostId = void 0;
	
	                        if (i > 0) {
	                            topPostId = this.props.postList.order[i - 1];
	                        } else {
	                            // the first post we look at should always be on the screen, but handle that case anyway
	                            topPostId = id;
	                        }
	
	                        if (topPostId !== this.state.topPostId) {
	                            this.setState({
	                                topPostId: topPostId
	                            });
	                        }
	
	                        break;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'loadMorePostsTop',
	        value: function loadMorePostsTop() {
	            this.props.loadMorePostsTopClicked();
	        }
	    }, {
	        key: 'loadMorePostsBottom',
	        value: function loadMorePostsBottom() {
	            this.props.loadMorePostsBottomClicked();
	        }
	    }, {
	        key: 'createPosts',
	        value: function createPosts(posts, order) {
	            var _this2 = this;
	
	            var postCtls = [];
	            var previousPostDay = new Date(0);
	            var userId = this.state.currentUser.id;
	            var profiles = this.state.profiles || {};
	
	            var renderedLastViewed = false;
	
	            var _loop = function _loop(i) {
	                var post = posts[order[i]];
	                var parentPost = posts[post.parent_id];
	                var prevPost = posts[order[i + 1]];
	                var postUserId = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isSystemMessage(post) ? '' : post.user_id;
	
	                // If the post is a comment whose parent has been deleted, don't add it to the list.
	                if (parentPost && parentPost.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].POST_DELETED) {
	                    return 'continue';
	                }
	
	                var sameUser = false;
	                var sameRoot = false;
	                var hideProfilePic = false;
	
	                if (prevPost) {
	                    var postIsComment = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isComment(post);
	                    var prevPostIsComment = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isComment(prevPost);
	                    var postFromWebhook = Boolean(post.props && post.props.from_webhook);
	                    var prevPostFromWebhook = Boolean(prevPost.props && prevPost.props.from_webhook);
	                    var prevPostUserId = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isSystemMessage(prevPost) ? '' : prevPost.user_id;
	
	                    // consider posts from the same user if:
	                    //     the previous post was made by the same user as the current post,
	                    //     the previous post was made within 5 minutes of the current post,
	                    //     the current post is not from a webhook
	                    //     the previous post is not from a webhook
	                    if (prevPostUserId === postUserId && post.create_at - prevPost.create_at <= 1000 * 60 * 5 && !postFromWebhook && !prevPostFromWebhook) {
	                        sameUser = true;
	                    }
	
	                    // consider posts from the same root if:
	                    //     the current post is a comment,
	                    //     the current post has the same root as the previous post
	                    if (postIsComment && (prevPost.id === post.root_id || prevPost.root_id === post.root_id)) {
	                        sameRoot = true;
	                    }
	
	                    // consider posts from the same root if:
	                    //     the current post is not a comment,
	                    //     the previous post is not a comment,
	                    //     the previous post is from the same user
	                    if (!postIsComment && !prevPostIsComment && sameUser) {
	                        sameRoot = true;
	                    }
	
	                    // hide the profile pic if:
	                    //     the previous post was made by the same user as the current post,
	                    //     the previous post is not a comment,
	                    //     the current post is not a comment,
	                    //     the previous post is not from a webhook
	                    //     the current post is not from a webhook
	                    if (prevPostUserId === postUserId && !prevPostIsComment && !postIsComment && !prevPostFromWebhook && !postFromWebhook) {
	                        hideProfilePic = true;
	                    }
	                }
	
	                // check if it's the last comment in a consecutive string of comments on the same post
	                // it is the last comment if it is last post in the channel or the next post has a different root post
	                var isLastComment = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isComment(post) && (i === 0 || posts[order[i - 1]].root_id !== post.root_id);
	
	                var keyPrefix = post.id ? post.id : i;
	
	                var shouldHighlight = _this2.props.postsToHighlight && _this2.props.postsToHighlight.hasOwnProperty(post.id);
	
	                var profile = void 0;
	                if (userId === post.user_id) {
	                    profile = _this2.state.currentUser;
	                } else {
	                    profile = profiles[post.user_id];
	                }
	
	                var postCtl = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__post_jsx__["a"], {
	                    key: keyPrefix + 'postKey',
	                    ref: post.id,
	                    sameUser: sameUser,
	                    sameRoot: sameRoot,
	                    post: post,
	                    parentPost: parentPost,
	                    posts: posts,
	                    hideProfilePic: hideProfilePic,
	                    isLastComment: isLastComment,
	                    shouldHighlight: shouldHighlight,
	                    onClick: function onClick() {
	                        return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__.emitPostFocusEvent(post.id);
	                    } //eslint-disable-line no-loop-func
	                    , displayNameType: _this2.state.displayNameType,
	                    user: profile,
	                    currentUser: _this2.state.currentUser,
	                    center: _this2.state.centerPosts
	                });
	
	                var currentPostDay = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.getDateForUnixTicks(post.create_at);
	                if (currentPostDay.toDateString() !== previousPostDay.toDateString()) {
	                    postCtls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        {
	                            key: currentPostDay.toDateString(),
	                            className: 'date-separator'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('hr', { className: 'separator__hr' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            { className: 'separator__text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedDate"], {
	                                value: currentPostDay,
	                                weekday: 'short',
	                                month: 'short',
	                                day: '2-digit',
	                                year: 'numeric'
	                            })
	                        )
	                    ));
	                }
	
	                if (postUserId !== userId && _this2.props.messageSeparatorTime !== 0 && post.create_at > _this2.props.messageSeparatorTime && !renderedLastViewed) {
	                    renderedLastViewed = true;
	
	                    // Temporary fix to solve ie11 rendering issue
	                    var newSeparatorId = '';
	                    if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isBrowserIE()) {
	                        newSeparatorId = 'new_message_' + post.id;
	                    }
	                    postCtls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        {
	                            id: newSeparatorId,
	                            key: 'unviewed',
	                            ref: 'newMessageSeparator',
	                            className: 'new-separator'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('hr', {
	                            className: 'separator__hr'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            { className: 'separator__text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'posts_view.newMsg',
	                                defaultMessage: 'New Messages'
	                            })
	                        )
	                    ));
	                }
	                postCtls.push(postCtl);
	                previousPostDay = currentPostDay;
	            };
	
	            for (var i = order.length - 1; i >= 0; i--) {
	                var _ret = _loop(i);
	
	                if (_ret === 'continue') continue;
	            }
	
	            return postCtls;
	        }
	    }, {
	        key: 'updateScrolling',
	        value: function updateScrolling() {
	            var _this3 = this;
	
	            if (this.props.scrollType === PostsView.SCROLL_TYPE_BOTTOM) {
	                this.scrollToBottom();
	            } else if (this.props.scrollType === PostsView.SCROLL_TYPE_NEW_MESSAGE) {
	                window.setTimeout(window.requestAnimationFrame(function () {
	                    // If separator exists scroll to it. Otherwise scroll to bottom.
	                    if (_this3.refs.newMessageSeparator) {
	                        var objDiv = _this3.refs.postlist;
	                        objDiv.scrollTop = _this3.refs.newMessageSeparator.offsetTop; //scrolls node to top of Div
	                    } else if (_this3.refs.postlist) {
	                            _this3.refs.postlist.scrollTop = _this3.refs.postlist.scrollHeight;
	                        }
	                }), 0);
	            } else if (this.props.scrollType === PostsView.SCROLL_TYPE_POST && this.props.scrollPostId) {
	                window.requestAnimationFrame(function () {
	                    var postNode = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react_dom___default.a.findDOMNode(_this3.refs[_this3.props.scrollPostId]);
	                    if (postNode == null) {
	                        return;
	                    }
	                    postNode.scrollIntoView();
	                    if (_this3.refs.postlist.scrollTop === postNode.offsetTop) {
	                        _this3.refs.postlist.scrollTop -= _this3.refs.postlist.offsetHeight / 3;
	                    } else {
	                        _this3.refs.postlist.scrollTop -= _this3.refs.postlist.offsetHeight / 3 + (_this3.refs.postlist.scrollTop - postNode.offsetTop);
	                    }
	                });
	            } else if (this.props.scrollType === PostsView.SCROLL_TYPE_SIDEBAR_OPEN) {
	                // If we are at the bottom then stay there
	                if (this.wasAtBottom) {
	                    this.refs.postlist.scrollTop = this.refs.postlist.scrollHeight;
	                } else {
	                    window.requestAnimationFrame(function () {
	                        _this3.jumpToPostNode.scrollIntoView();
	                        if (_this3.refs.postlist.scrollTop === _this3.jumpToPostNode.offsetTop) {
	                            _this3.refs.postlist.scrollTop -= _this3.refs.postlist.offsetHeight / 3;
	                        } else {
	                            _this3.refs.postlist.scrollTop -= _this3.refs.postlist.offsetHeight / 3 + (_this3.refs.postlist.scrollTop - _this3.jumpToPostNode.offsetTop);
	                        }
	                    });
	                }
	            } else if (this.refs.postlist.scrollHeight !== this.prevScrollHeight) {
	                window.requestAnimationFrame(function () {
	                    // Only need to jump if we added posts to the top.
	                    if (_this3.jumpToPostNode && _this3.jumpToPostNode.offsetTop !== _this3.prevOffsetTop) {
	                        _this3.refs.postlist.scrollTop += _this3.refs.postlist.scrollHeight - _this3.prevScrollHeight;
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.updateScrolling();
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            var _this4 = this;
	
	            window.requestAnimationFrame(function () {
	                _this4.refs.postlist.scrollTop = _this4.refs.postlist.scrollHeight;
	            });
	        }
	    }, {
	        key: 'scrollToBottomAnimated',
	        value: function scrollToBottomAnimated() {
	            var postList = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()(this.refs.postlist);
	            postList.animate({ scrollTop: this.refs.postlist.scrollHeight }, '500');
	        }
	    }, {
	        key: 'getArchivesIntroMessage',
	        value: function getArchivesIntroMessage() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                'div',
	                { className: 'channel-intro' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'h4',
	                    { className: 'channel-intro__title' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'post_focus_view.beginning',
	                        defaultMessage: 'Beginning of Channel Archives'
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.postList != null) {
	                this.updateScrolling();
	            }
	
	            if (this.props.isActive) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].addChangeListener(this.updateState);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].addChangeListener(this.onUserChange);
	            }
	
	            if (this.props.channel) {
	                this.introText = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_channel_intro_messages_jsx__["a"].bind()(this.props.channel);
	            } else {
	                this.introText = this.getArchivesIntroMessage();
	            }
	
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	            this.scrollStopAction.cancel();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].removeChangeListener(this.updateState);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChange);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.postList != null) {
	                this.updateScrolling();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.isActive && nextProps.isActive) {
	                this.updateState();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].addChangeListener(this.updateState);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].addChangeListener(this.onUserChange);
	            } else if (this.props.isActive && !nextProps.isActive) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].removeChangeListener(this.updateState);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChange);
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (this.props.isActive !== nextProps.isActive) {
	                return true;
	            }
	            if (this.props.postList !== nextProps.postList) {
	                return true;
	            }
	            if (this.props.scrollPostId !== nextProps.scrollPostId) {
	                return true;
	            }
	            if (this.props.scrollType !== nextProps.scrollType && nextProps.scrollType !== PostsView.SCROLL_TYPE_FREE) {
	                return true;
	            }
	            if (this.props.messageSeparatorTime !== nextProps.messageSeparatorTime) {
	                return true;
	            }
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.areObjectsEqual(this.props.postList, nextProps.postList)) {
	                return true;
	            }
	            if (nextState.displayNameType !== this.state.displayNameType) {
	                return true;
	            }
	            if (this.state.topPostId !== nextState.topPostId) {
	                return true;
	            }
	            if (this.state.isScrolling !== nextState.isScrolling) {
	                return true;
	            }
	            if (this.state.centerPosts !== nextState.centerPosts) {
	                return true;
	            }
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.areObjectsEqual(this.state.profiles, nextState.profiles)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var posts = [];
	            var order = [];
	            var moreMessagesTop = void 0;
	            var moreMessagesBottom = void 0;
	            var postElements = void 0;
	            var activeClass = 'inactive';
	            if (this.props.postList != null) {
	                posts = this.props.postList.posts;
	                order = this.props.postList.order;
	
	                // Create intro message or top loadmore link
	                if (this.props.showMoreMessagesTop) {
	                    moreMessagesTop = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            ref: 'loadmoretop',
	                            className: 'more-messages-text theme',
	                            href: '#',
	                            onClick: this.loadMorePostsTop
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'posts_view.loadMore',
	                            defaultMessage: 'Load more messages'
	                        })
	                    );
	                } else {
	                    moreMessagesTop = this.introText;
	                }
	
	                // Give option to load more posts at bottom if nessisary
	                if (this.props.showMoreMessagesBottom) {
	                    moreMessagesBottom = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            ref: 'loadmorebottom',
	                            className: 'more-messages-text theme',
	                            href: '#',
	                            onClick: this.loadMorePostsBottom
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], { id: 'posts_view.loadMore' })
	                    );
	                } else {
	                    moreMessagesBottom = null;
	                }
	
	                // Create post elements
	                postElements = this.createPosts(posts, order);
	
	                // Show ourselves if we are marked active
	                if (this.props.isActive) {
	                    activeClass = '';
	                }
	            }
	
	            var topPostCreateAt = 0;
	            if (this.state.topPostId && this.props.postList.posts[this.state.topPostId]) {
	                topPostCreateAt = this.props.postList.posts[this.state.topPostId].create_at;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                'div',
	                { className: activeClass },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__floating_timestamp_jsx__["a"], {
	                    isScrolling: this.state.isScrolling,
	                    isMobile: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()(window).width() > 768,
	                    createAt: topPostCreateAt
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(ScrollToBottomArrows, {
	                    isScrolling: this.state.isScrolling,
	                    atBottom: this.wasAtBottom,
	                    onClick: this.scrollToBottomAnimated
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'postlist',
	                        className: 'post-list-holder-by-time',
	                        onScroll: this.handleScroll
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'post-list__table' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            {
	                                ref: 'postlistcontent',
	                                className: 'post-list__content'
	                            },
	                            moreMessagesTop,
	                            postElements,
	                            moreMessagesBottom
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: 'SCROLL_TYPE_FREE',
	        get: function get() {
	            return 1;
	        }
	    }, {
	        key: 'SCROLL_TYPE_BOTTOM',
	        get: function get() {
	            return 2;
	        }
	    }, {
	        key: 'SCROLL_TYPE_SIDEBAR_OPEN',
	        get: function get() {
	            return 3;
	        }
	    }, {
	        key: 'SCROLL_TYPE_NEW_MESSAGE',
	        get: function get() {
	            return 4;
	        }
	    }, {
	        key: 'SCROLL_TYPE_POST',
	        get: function get() {
	            return 5;
	        }
	    }]);
	
	    return PostsView;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostsView;
	
	PostsView.defaultProps = {};
	
	PostsView.propTypes = {
	    isActive: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool,
	    postList: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.object,
	    scrollPostId: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.number,
	    postViewScrolled: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    loadMorePostsTopClicked: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    loadMorePostsBottomClicked: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    showMoreMessagesTop: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool,
	    showMoreMessagesBottom: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.object,
	    messageSeparatorTime: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.number,
	    postsToHighlight: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.object
	};
	
	function ScrollToBottomArrows(_ref) {
	    var isScrolling = _ref.isScrolling;
	    var atBottom = _ref.atBottom;
	    var onClick = _ref.onClick;
	
	    // only show on mobile
	    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()(window).width() > 768) {
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('noscript', null);
	    }
	
	    var className = 'post-list__arrows';
	    if (isScrolling && !atBottom) {
	        className += ' scrolling';
	    }
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	        'div',
	        {
	            className: className,
	            onClick: onClick
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].SCROLL_BOTTOM_ICON } })
	    );
	}
	
	ScrollToBottomArrows.propTypes = {
	    isScrolling: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool.isRequired,
	    atBottom: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool.isRequired,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["defineMessages"].bind()({
	    required: {
	        id: 'rename_channel.required',
	        defaultMessage: 'This field is required'
	    },
	    maxLength: {
	        id: 'rename_channel.maxLength',
	        defaultMessage: 'This field must be less than 22 characters'
	    },
	    lowercase: {
	        id: 'rename_channel.lowercase',
	        defaultMessage: 'Must be lowercase alphanumeric characters'
	    },
	    handle: {
	        id: 'rename_channel.handle',
	        defaultMessage: 'Handle'
	    },
	    defaultError: {
	        id: 'rename_channel.defaultError',
	        defaultMessage: ' - Cannot be changed for the default channel'
	    },
	    displayNameHolder: {
	        id: 'rename_channel.displayNameHolder',
	        defaultMessage: 'Enter display name'
	    },
	    handleHolder: {
	        id: 'rename_channel.handleHolder',
	        defaultMessage: 'lowercase alphanumeric&#39;s only'
	    }
	});
	
	
	
	var RenameChannelModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(RenameChannelModal, _React$Component);
	
	    function RenameChannelModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RenameChannelModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RenameChannelModal).call(this, props));
	
	        _this.handleShow = _this.handleShow.bind(_this);
	        _this.handleHide = _this.handleHide.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleCancel = _this.handleCancel.bind(_this);
	
	        _this.onNameChange = _this.onNameChange.bind(_this);
	        _this.onDisplayNameChange = _this.onDisplayNameChange.bind(_this);
	        _this.displayNameKeyUp = _this.displayNameKeyUp.bind(_this);
	
	        _this.state = {
	            displayName: props.channel.display_name,
	            channelName: props.channel.name,
	            serverError: '',
	            nameError: '',
	            displayNameError: '',
	            invalid: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(RenameChannelModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.areObjectsEqual(nextProps.channel, this.props.channel)) {
	                this.setState({
	                    displayName: nextProps.channel.display_name,
	                    channelName: nextProps.channel.name
	                });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!nextProps.show && !this.props.show) {
	                return false;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.areObjectsEqual(nextState, this.state)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.areObjectsEqual(nextProps, this.props)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!prevProps.show && this.props.show) {
	                this.handleShow();
	            }
	        }
	    }, {
	        key: 'handleShow',
	        value: function handleShow() {
	            var textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.displayName);
	            textbox.focus();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.placeCaretAtEnd(textbox);
	        }
	    }, {
	        key: 'handleHide',
	        value: function handleHide(e) {
	            if (e) {
	                e.preventDefault();
	            }
	
	            this.props.onHide();
	
	            this.setState({
	                serverError: '',
	                nameError: '',
	                displayNameError: '',
	                invalid: false
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, this.props.channel);
	            var oldName = channel.name;
	            var oldDisplayName = channel.displayName;
	            var state = { serverError: '' };
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            channel.display_name = this.state.displayName.trim();
	            if (!channel.display_name) {
	                state.displayNameError = formatMessage(holders.required);
	                state.invalid = true;
	            } else if (channel.display_name.length > 22) {
	                state.displayNameError = formatMessage(holders.maxLength);
	                state.invalid = true;
	            } else {
	                state.displayNameError = '';
	            }
	
	            channel.name = this.state.channelName.trim();
	            if (!channel.name) {
	                state.nameError = formatMessage(holders.required);
	                state.invalid = true;
	            } else if (channel.name.length > 22) {
	                state.nameError = formatMessage(holders.maxLength);
	                state.invalid = true;
	            } else {
	                var cleanedName = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.cleanUpUrlable(channel.name);
	                if (cleanedName === channel.name) {
	                    state.nameError = '';
	                } else {
	                    state.nameError = formatMessage(holders.lowercase);
	                    state.invalid = true;
	                }
	            }
	
	            this.setState(state);
	
	            if (state.invalid || oldName === channel.name && oldDisplayName === channel.display_name) {
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].updateChannel(channel, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.getChannel(channel.id);
	
	                _this2.handleHide();
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    invalid: true
	                });
	            });
	        }
	    }, {
	        key: 'handleCancel',
	        value: function handleCancel(e) {
	            this.setState({
	                displayName: this.props.channel.display_name,
	                channelName: this.props.channel.name
	            });
	
	            this.handleHide(e);
	        }
	    }, {
	        key: 'onNameChange',
	        value: function onNameChange() {
	            this.setState({ channelName: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.channelName).value });
	        }
	    }, {
	        key: 'onDisplayNameChange',
	        value: function onDisplayNameChange() {
	            this.setState({ displayName: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.displayName).value });
	        }
	    }, {
	        key: 'displayNameKeyUp',
	        value: function displayNameKeyUp() {
	            if (this.state.channelName !== /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].DEFAULT_CHANNEL) {
	                var displayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.displayName).value.trim();
	                var channelName = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.cleanUpUrlable(displayName);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.channelName).value = channelName;
	                this.setState({ channelName: channelName });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var displayNameError = null;
	            var displayNameClass = 'form-group';
	            if (this.state.displayNameError) {
	                displayNameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.displayNameError
	                );
	                displayNameClass += ' has-error';
	            }
	
	            var nameError = null;
	            var nameClass = 'form-group';
	            if (this.state.nameError) {
	                nameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.nameError
	                );
	                nameClass += ' has-error';
	            }
	
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            var handleInputLabel = formatMessage(holders.handle);
	            var handleInputClass = 'form-control';
	            var readOnlyHandleInput = false;
	            if (this.state.channelName === /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].DEFAULT_CHANNEL) {
	                handleInputLabel += formatMessage(holders.defaultError);
	                readOnlyHandleInput = true;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.handleCancel
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'rename_channel.title',
	                            defaultMessage: 'Rename Channel'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'form',
	                    { role: 'form' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Body,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: displayNameClass },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'label',
	                                { className: 'control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'rename_channel.displayName',
	                                    defaultMessage: 'Display Name'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                onKeyUp: this.displayNameKeyUp,
	                                onChange: this.onDisplayNameChange,
	                                type: 'text',
	                                ref: 'displayName',
	                                id: 'display_name',
	                                className: 'form-control',
	                                placeholder: formatMessage(holders.displayNameHolder),
	                                value: this.state.displayName,
	                                maxLength: '64'
	                            }),
	                            displayNameError
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: nameClass },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'label',
	                                { className: 'control-label' },
	                                handleInputLabel
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                onChange: this.onNameChange,
	                                type: 'text',
	                                className: handleInputClass,
	                                ref: 'channelName',
	                                placeholder: formatMessage(holders.handleHolder),
	                                value: this.state.channelName,
	                                maxLength: '64',
	                                readOnly: readOnlyHandleInput
	                            }),
	                            nameError
	                        ),
	                        serverError
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Footer,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-default',
	                                onClick: this.handleCancel
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'rename_channel.cancel',
	                                defaultMessage: 'Cancel'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'button',
	                            {
	                                onClick: this.handleSubmit,
	                                type: 'submit',
	                                className: 'btn btn-primary'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'rename_channel.save',
	                                defaultMessage: 'Save'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RenameChannelModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = RenameChannelModal;
	
	
	RenameChannelModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"].bind()(RenameChannelModal);

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var SettingsSidebar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SettingsSidebar, _React$Component);
	
	    function SettingsSidebar(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SettingsSidebar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SettingsSidebar).call(this, props));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SettingsSidebar, [{
	        key: 'handleClick',
	        value: function handleClick(tab, e) {
	            e.preventDefault();
	            this.props.updateTab(tab.name);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).closest('.settings-modal').addClass('display--content');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isBrowserFirefox()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .settings-table .nav').addClass('position--top');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var tabList = this.props.tabs.map(function makeTab(tab) {
	                var key = tab.name + '_li';
	                var className = '';
	                if (this.props.activeTab === tab.name) {
	                    className = 'active';
	                }
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'li',
	                    {
	                        key: key,
	                        className: className
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handleClick.bind(null, tab)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: tab.icon }),
	                        tab.uiName
	                    )
	                );
	            }.bind(this));
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'ul',
	                    { className: 'nav nav-pills nav-stacked' },
	                    tabList
	                )
	            );
	        }
	    }]);
	
	    return SettingsSidebar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SettingsSidebar;
	
	
	SettingsSidebar.propTypes = {
	    tabs: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.shape({
	        name: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	        uiName: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	        icon: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired
	    })).isRequired,
	    activeTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __WEBPACK_IMPORTED_MODULE_8_jquery__ && __WEBPACK_IMPORTED_MODULE_8_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __WEBPACK_IMPORTED_MODULE_9_react_dom__ && __WEBPACK_IMPORTED_MODULE_9_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__ = __webpack_require__(139);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize__ = __webpack_require__(1641);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize___default = __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize__ && __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var KeyCodes = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].KeyCodes;
	
	
	
	var SuggestionBox = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a.bind()(SuggestionBox, _React$Component);
	
	    function SuggestionBox(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SuggestionBox);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SuggestionBox).call(this, props));
	
	        _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleCompleteWord = _this.handleCompleteWord.bind(_this);
	        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	        _this.handlePretextChanged = _this.handlePretextChanged.bind(_this);
	
	        _this.suggestionId = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.generateId();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a.bind()(SuggestionBox, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].registerSuggestionBox(this.suggestionId);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()(document).on('click', this.handleDocumentClick);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].addCompleteWordListener(this.suggestionId, this.handleCompleteWord);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].addPretextChangedListener(this.suggestionId, this.handlePretextChanged);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].removeCompleteWordListener(this.suggestionId, this.handleCompleteWord);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].removePretextChangedListener(this.suggestionId, this.handlePretextChanged);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].unregisterSuggestionBox(this.suggestionId);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()(document).off('click', this.handleDocumentClick);
	        }
	    }, {
	        key: 'getTextbox',
	        value: function getTextbox() {
	            // this is to support old code that looks at the input/textarea DOM nodes
	            var textbox = this.refs.textbox;
	
	            if (!(textbox instanceof HTMLElement)) {
	                textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(textbox);
	            }
	
	            return textbox;
	        }
	    }, {
	        key: 'handleDocumentClick',
	        value: function handleDocumentClick(e) {
	            var container = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this));
	            if (!(container.is(e.target) || container.has(e.target).length > 0)) {
	                // we can't just use blur for this because it fires and hides the children before
	                // their click handlers can be called
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitClearSuggestions(this.suggestionId);
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            var textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this.refs.textbox);
	            var caret = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.getCaretPosition(textbox);
	            var pretext = textbox.value.substring(0, caret);
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitSuggestionPretextChanged(this.suggestionId, pretext);
	
	            if (this.props.onUserInput) {
	                this.props.onUserInput(textbox.value);
	            }
	
	            if (this.props.onChange) {
	                this.props.onChange(e);
	            }
	        }
	    }, {
	        key: 'handleCompleteWord',
	        value: function handleCompleteWord(term) {
	            var textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this.refs.textbox);
	            var caret = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.getCaretPosition(textbox);
	
	            var text = this.props.value;
	            var prefix = text.substring(0, caret - /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].getMatchedPretext(this.suggestionId).length);
	            var suffix = text.substring(caret);
	
	            if (this.props.onUserInput) {
	                this.props.onUserInput(prefix + term + ' ' + suffix);
	            }
	
	            // set the caret position after the next rendering
	            window.requestAnimationFrame(function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.setCaretPosition(textbox, prefix.length + term.length + 1);
	            });
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_suggestion_store_jsx__["a"].hasSuggestions(this.suggestionId)) {
	                if (e.which === KeyCodes.UP) {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitSelectPreviousSuggestion(this.suggestionId);
	                    e.preventDefault();
	                } else if (e.which === KeyCodes.DOWN) {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitSelectNextSuggestion(this.suggestionId);
	                    e.preventDefault();
	                } else if (e.which === KeyCodes.ENTER || e.which === KeyCodes.TAB) {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitCompleteWordSuggestion(this.suggestionId);
	                    e.preventDefault();
	                } else if (e.which === KeyCodes.ESCAPE) {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitClearSuggestions(this.suggestionId);
	                } else if (this.props.onKeyDown) {
	                    this.props.onKeyDown(e);
	                }
	            } else if (this.props.onKeyDown) {
	                this.props.onKeyDown(e);
	            }
	        }
	    }, {
	        key: 'handlePretextChanged',
	        value: function handlePretextChanged(pretext) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default.a.bind()(this.props.providers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var provider = _step.value;
	
	                    provider.handlePretextChanged(this.suggestionId, pretext);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var newProps = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.bind()({}, this.props, {
	                onChange: this.handleChange,
	                onKeyDown: this.handleKeyDown
	            });
	
	            var textbox = null;
	            if (this.props.type === 'input') {
	                textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('input', /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({
	                    ref: 'textbox',
	                    type: 'text'
	                }, newProps));
	            } else if (this.props.type === 'search') {
	                textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('input', /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({
	                    ref: 'textbox',
	                    type: 'search'
	                }, newProps));
	            } else if (this.props.type === 'textarea') {
	                textbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_textarea_autosize___default.a, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({
	                    id: this.suggestionId,
	                    ref: 'textbox'
	                }, newProps));
	            }
	
	            var SuggestionListComponent = this.props.listComponent;
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                'div',
	                null,
	                textbox,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(SuggestionListComponent, { suggestionId: this.suggestionId })
	            );
	        }
	    }]);
	
	    return SuggestionBox;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SuggestionBox;
	
	
	SuggestionBox.defaultProps = {
	    type: 'input'
	};
	
	SuggestionBox.propTypes = {
	    listComponent: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func.isRequired,
	    type: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.oneOf(['input', 'textarea', 'search']).isRequired,
	    value: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.string.isRequired,
	    onUserInput: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    providers: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.object),
	
	    // explicitly name any input event handlers we override and need to manually call
	    onChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    onKeyDown: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func,
	    onHeightChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__ = __webpack_require__(139);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var SuggestionList = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SuggestionList, _React$Component);
	
	    function SuggestionList(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SuggestionList);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SuggestionList).call(this, props));
	
	        _this.getContent = _this.getContent.bind(_this);
	
	        _this.handleItemClick = _this.handleItemClick.bind(_this);
	        _this.handleSuggestionsChanged = _this.handleSuggestionsChanged.bind(_this);
	
	        _this.scrollToItem = _this.scrollToItem.bind(_this);
	
	        _this.state = {
	            items: [],
	            terms: [],
	            components: [],
	            selection: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SuggestionList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__["a"].addSuggestionsChangedListener(this.props.suggestionId, this.handleSuggestionsChanged);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__["a"].removeSuggestionsChangedListener(this.props.suggestionId, this.handleSuggestionsChanged);
	        }
	    }, {
	        key: 'getContent',
	        value: function getContent() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.content));
	        }
	    }, {
	        key: 'handleItemClick',
	        value: function handleItemClick(term, e) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__.emitCompleteWordSuggestion(this.props.suggestionId, term);
	
	            e.preventDefault();
	        }
	    }, {
	        key: 'handleSuggestionsChanged',
	        value: function handleSuggestionsChanged() {
	            var _this2 = this;
	
	            var selection = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__["a"].getSelection(this.props.suggestionId);
	
	            this.setState({
	                items: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__["a"].getItems(this.props.suggestionId),
	                terms: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__["a"].getTerms(this.props.suggestionId),
	                components: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_suggestion_store_jsx__["a"].getComponents(this.props.suggestionId),
	                selection: selection
	            });
	
	            if (selection) {
	                window.requestAnimationFrame(function () {
	                    return _this2.scrollToItem(_this2.state.selection);
	                });
	            }
	        }
	    }, {
	        key: 'scrollToItem',
	        value: function scrollToItem(term) {
	            var content = this.getContent();
	            var visibleContentHeight = content[0].clientHeight;
	            var actualContentHeight = content[0].scrollHeight;
	
	            if (visibleContentHeight < actualContentHeight) {
	                var contentTop = content.scrollTop();
	                var contentTopPadding = parseInt(content.css('padding-top'), 10);
	                var contentBottomPadding = parseInt(content.css('padding-top'), 10);
	
	                var item = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs[term]));
	                var itemTop = item[0].offsetTop - parseInt(item.css('margin-top'), 10);
	                var itemBottomMargin = parseInt(item.css('margin-bottom'), 10) + parseInt(item.css('padding-bottom'), 10);
	                var itemBottom = item[0].offsetTop + item.height() + itemBottomMargin;
	
	                if (itemTop - contentTopPadding < contentTop) {
	                    // the item is off the top of the visible space
	                    content.scrollTop(itemTop - contentTopPadding);
	                } else if (itemBottom + contentTopPadding + contentBottomPadding > contentTop + visibleContentHeight) {
	                    // the item has gone off the bottom of the visible space
	                    content.scrollTop(itemBottom - visibleContentHeight + contentTopPadding + contentBottomPadding);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.items.length === 0) {
	                return null;
	            }
	
	            var items = [];
	            for (var i = 0; i < this.state.items.length; i++) {
	                var item = this.state.items[i];
	                var term = this.state.terms[i];
	                var isSelection = term === this.state.selection;
	
	                // ReactComponent names need to be upper case when used in JSX
	                var Component = this.state.components[i];
	
	                items.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Component, {
	                    key: term,
	                    ref: term,
	                    item: item,
	                    term: term,
	                    isSelection: isSelection,
	                    onClick: this.handleItemClick.bind(this, term)
	                }));
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                { className: 'suggestion-list suggestion-list--top' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'content',
	                        className: 'suggestion-list__content suggestion-list__content--top'
	                    },
	                    items
	                )
	            );
	        }
	    }]);
	
	    return SuggestionList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SuggestionList;
	
	
	SuggestionList.propTypes = {
	    suggestionId: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string.isRequired
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__member_list_team_jsx__ = __webpack_require__(711);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var TeamMembersModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamMembersModal, _React$Component);
	
	    function TeamMembersModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamMembersModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamMembersModal).call(this, props));
	
	        _this.teamChanged = _this.teamChanged.bind(_this);
	
	        _this.state = {
	            team: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrent()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamMembersModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.show) {
	                this.onShow();
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].addChangeListener(this.teamChanged);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].removeChangeListener(this.teamChanged);
	        }
	    }, {
	        key: 'teamChanged',
	        value: function teamChanged() {
	            this.setState({ team: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrent() });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var teamDisplayName = '';
	            if (this.state.team) {
	                teamDisplayName = this.state.team.display_name;
	            }
	
	            var maxHeight = 1000;
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.windowHeight() <= 1200) {
	                maxHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.windowHeight() - 300;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"],
	                {
	                    dialogClassName: 'more-modal',
	                    show: this.props.show,
	                    onHide: this.props.onHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'team_member_modal.members',
	                            defaultMessage: '{team} Members',
	                            values: {
	                                team: teamDisplayName
	                            }
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__member_list_team_jsx__["a"], { style: { maxHeight: maxHeight } })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.props.onHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'team_member_modal.close',
	                            defaultMessage: 'Close'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeamMembersModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TeamMembersModal;
	
	
	TeamMembersModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__confirm_modal_jsx__ = __webpack_require__(186);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_settings_jsx__ = __webpack_require__(774);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__settings_sidebar_jsx__ = __webpack_require__(369);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["defineMessages"].bind()({
	    general: {
	        id: 'user.settings.modal.general',
	        defaultMessage: 'General'
	    },
	    security: {
	        id: 'user.settings.modal.security',
	        defaultMessage: 'Security'
	    },
	    notifications: {
	        id: 'user.settings.modal.notifications',
	        defaultMessage: 'Notifications'
	    },
	    developer: {
	        id: 'user.settings.modal.developer',
	        defaultMessage: 'Developer'
	    },
	    display: {
	        id: 'user.settings.modal.display',
	        defaultMessage: 'Display'
	    },
	    advanced: {
	        id: 'user.settings.modal.advanced',
	        defaultMessage: 'Advanced'
	    },
	    confirmTitle: {
	        id: 'user.settings.modal.confirmTitle',
	        defaultMessage: 'Discard Changes?'
	    },
	    confirmMsg: {
	        id: 'user.settings.modal.confirmMsg',
	        defaultMessage: 'You have unsaved changes, are you sure you want to discard them?'
	    },
	    confirmBtns: {
	        id: 'user.settings.modal.confirmBtns',
	        defaultMessage: 'Yes, Discard'
	    }
	});
	
	
	
	var UserSettingsModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UserSettingsModal, _React$Component);
	
	    function UserSettingsModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserSettingsModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserSettingsModal).call(this, props));
	
	        _this.handleHide = _this.handleHide.bind(_this);
	        _this.handleHidden = _this.handleHidden.bind(_this);
	        _this.handleCollapse = _this.handleCollapse.bind(_this);
	        _this.handleConfirm = _this.handleConfirm.bind(_this);
	        _this.handleCancelConfirmation = _this.handleCancelConfirmation.bind(_this);
	
	        _this.deactivateTab = _this.deactivateTab.bind(_this);
	        _this.closeModal = _this.closeModal.bind(_this);
	        _this.collapseModal = _this.collapseModal.bind(_this);
	
	        _this.updateTab = _this.updateTab.bind(_this);
	        _this.updateSection = _this.updateSection.bind(_this);
	        _this.onUserChanged = _this.onUserChanged.bind(_this);
	
	        _this.state = {
	            active_tab: 'general',
	            active_section: '',
	            showConfirmModal: false,
	            enforceFocus: true,
	            currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser()
	        };
	
	        _this.requireConfirm = false;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UserSettingsModal, [{
	        key: 'onUserChanged',
	        value: function onUserChanged() {
	            this.setState({ currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser() });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].addChangeListener(this.onUserChanged);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChanged);
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').perfectScrollbar();
	            }
	        }
	
	        // Called when the close button is pressed on the main modal
	
	    }, {
	        key: 'handleHide',
	        value: function handleHide() {
	            var _this2 = this;
	
	            if (this.requireConfirm) {
	                this.afterConfirm = function () {
	                    return _this2.handleHide();
	                };
	                this.showConfirmModal();
	
	                return;
	            }
	
	            this.deactivateTab();
	            this.props.onModalDismissed();
	            return;
	        }
	
	        // called after the dialog is fully hidden and faded out
	
	    }, {
	        key: 'handleHidden',
	        value: function handleHidden() {
	            this.setState({
	                active_tab: 'general',
	                active_section: ''
	            });
	        }
	
	        // Called to hide the settings pane when on mobile
	
	    }, {
	        key: 'handleCollapse',
	        value: function handleCollapse() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.modalBody)).closest('.modal-dialog').removeClass('display--content');
	
	            this.deactivateTab();
	
	            this.setState({
	                active_tab: '',
	                active_section: ''
	            });
	        }
	    }, {
	        key: 'handleConfirm',
	        value: function handleConfirm() {
	            this.setState({
	                showConfirmModal: false,
	                enforceFocus: true
	            });
	
	            this.requireConfirm = false;
	
	            if (this.afterConfirm) {
	                this.afterConfirm();
	                this.afterConfirm = null;
	            }
	        }
	    }, {
	        key: 'handleCancelConfirmation',
	        value: function handleCancelConfirmation() {
	            this.setState({
	                showConfirmModal: false,
	                enforceFocus: true
	            });
	
	            this.afterConfirm = null;
	        }
	    }, {
	        key: 'showConfirmModal',
	        value: function showConfirmModal(afterConfirm) {
	            this.setState({
	                showConfirmModal: true,
	                enforceFocus: false
	            });
	
	            if (afterConfirm) {
	                this.afterConfirm = afterConfirm;
	            }
	        }
	
	        // Called to let settings tab perform cleanup before being closed
	
	    }, {
	        key: 'deactivateTab',
	        value: function deactivateTab() {
	            var activeTab = this.refs.userSettings.getActiveTab();
	            if (activeTab && activeTab.deactivate) {
	                activeTab.deactivate();
	            }
	        }
	
	        // Called by settings tabs when their close button is pressed
	
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            if (this.requireConfirm) {
	                this.showConfirmModal(this.closeModal);
	            } else {
	                this.handleHide();
	            }
	        }
	
	        // Called by settings tabs when their back button is pressed
	
	    }, {
	        key: 'collapseModal',
	        value: function collapseModal() {
	            if (this.requireConfirm) {
	                this.showConfirmModal(this.collapseModal);
	            } else {
	                this.handleCollapse();
	            }
	        }
	    }, {
	        key: 'updateTab',
	        value: function updateTab(tab, skipConfirm) {
	            var _this3 = this;
	
	            if (!skipConfirm && this.requireConfirm) {
	                this.showConfirmModal(function () {
	                    return _this3.updateTab(tab, true);
	                });
	            } else {
	                this.deactivateTab();
	
	                this.setState({
	                    active_tab: tab,
	                    active_section: ''
	                });
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            }
	        }
	    }, {
	        key: 'updateSection',
	        value: function updateSection(section, skipConfirm) {
	            var _this4 = this;
	
	            if (!skipConfirm && this.requireConfirm) {
	                this.showConfirmModal(function () {
	                    return _this4.updateSection(section, true);
	                });
	            } else {
	                this.setState({ active_section: section });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            if (this.state.currentUser == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', null);
	            }
	            var tabs = [];
	
	            tabs.push({ name: 'general', uiName: formatMessage(holders.general), icon: 'glyphicon glyphicon-cog' });
	            tabs.push({ name: 'security', uiName: formatMessage(holders.security), icon: 'glyphicon glyphicon-lock' });
	            tabs.push({ name: 'notifications', uiName: formatMessage(holders.notifications), icon: 'glyphicon glyphicon-exclamation-sign' });
	            if (global.window.mm_config.EnableOAuthServiceProvider === 'true') {
	                tabs.push({ name: 'developer', uiName: formatMessage(holders.developer), icon: 'glyphicon glyphicon-th' });
	            }
	
	            tabs.push({ name: 'display', uiName: formatMessage(holders.display), icon: 'glyphicon glyphicon-eye-open' });
	            tabs.push({ name: 'advanced', uiName: formatMessage(holders.advanced), icon: 'glyphicon glyphicon-list-alt' });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"],
	                {
	                    dialogClassName: 'settings-modal',
	                    show: this.props.show,
	                    onHide: this.handleHide,
	                    onExited: this.handleHidden,
	                    enforceFocus: this.state.enforceFocus
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.modal.title',
	                            defaultMessage: 'Account Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Modal"].Body,
	                    { ref: 'modalBody' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'settings-table' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'settings-links' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__settings_sidebar_jsx__["a"], {
	                                tabs: tabs,
	                                activeTab: this.state.active_tab,
	                                updateTab: this.updateTab
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'settings-content minimize-settings' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__user_settings_jsx__["a"], {
	                                ref: 'userSettings',
	                                activeTab: this.state.active_tab,
	                                activeSection: this.state.active_section,
	                                updateSection: this.updateSection,
	                                updateTab: this.updateTab,
	                                closeModal: this.closeModal,
	                                collapseModal: this.collapseModal,
	                                setEnforceFocus: function setEnforceFocus(enforceFocus) {
	                                    return _this5.setState({ enforceFocus: enforceFocus });
	                                },
	                                setRequireConfirm: function setRequireConfirm(requireConfirm) {
	                                    _this5.requireConfirm = requireConfirm;
	                                    return;
	                                }
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__confirm_modal_jsx__["a"], {
	                    title: formatMessage(holders.confirmTitle),
	                    message: formatMessage(holders.confirmMsg),
	                    confirmButton: formatMessage(holders.confirmBtns),
	                    show: this.state.showConfirmModal,
	                    onConfirm: this.handleConfirm,
	                    onCancel: this.handleCancelConfirmation
	                })
	            );
	        }
	    }]);
	
	    return UserSettingsModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	UserSettingsModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["injectIntl"].bind()(UserSettingsModal);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __WEBPACK_IMPORTED_MODULE_7_events__ && __WEBPACK_IMPORTED_MODULE_7_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	
	var AnalyticsStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(AnalyticsStoreClass, _EventEmitter);
	
	    function AnalyticsStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AnalyticsStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AnalyticsStoreClass).call(this));
	
	        _this.systemStats = {};
	        _this.teamStats = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(AnalyticsStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'getAllSystem',
	        value: function getAllSystem() {
	            return JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(this.systemStats));
	        }
	    }, {
	        key: 'getAllTeam',
	        value: function getAllTeam(id) {
	            if (id in this.teamStats) {
	                return JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(this.teamStats[id]));
	            }
	
	            return {};
	        }
	    }, {
	        key: 'storeSystemStats',
	        value: function storeSystemStats(newStats) {
	            for (var stat in newStats) {
	                if (!newStats.hasOwnProperty(stat)) {
	                    continue;
	                }
	                this.systemStats[stat] = newStats[stat];
	            }
	        }
	    }, {
	        key: 'storeTeamStats',
	        value: function storeTeamStats(id, newStats) {
	            if (!(id in this.teamStats)) {
	                this.teamStats[id] = {};
	            }
	
	            for (var stat in newStats) {
	                if (!newStats.hasOwnProperty(stat)) {
	                    continue;
	                }
	                this.teamStats[id][stat] = newStats[stat];
	            }
	        }
	    }]);
	
	    return AnalyticsStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_events___default.a);
	
	var AnalyticsStore = new AnalyticsStoreClass();
	
	AnalyticsStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_ANALYTICS:
	            if (action.teamId == null) {
	                AnalyticsStore.storeSystemStats(action.stats);
	            } else {
	                AnalyticsStore.storeTeamStats(action.teamId, action.stats);
	            }
	            AnalyticsStore.emitChange();
	            break;
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = AnalyticsStore;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __WEBPACK_IMPORTED_MODULE_6_events__ && __WEBPACK_IMPORTED_MODULE_6_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	
	var LocalizationStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LocalizationStoreClass, _EventEmitter);
	
	    function LocalizationStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LocalizationStoreClass);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LocalizationStoreClass).call(this));
	
	        _this.currentLocale = 'en';
	        _this.currentTranslations = null;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LocalizationStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'setCurrentLocale',
	        value: function setCurrentLocale(locale, translations) {
	            this.currentLocale = locale;
	            this.currentTranslations = translations;
	        }
	    }, {
	        key: 'getLocale',
	        value: function getLocale() {
	            return this.currentLocale;
	        }
	    }, {
	        key: 'getTranslations',
	        value: function getTranslations() {
	            return this.currentTranslations;
	        }
	    }]);
	
	    return LocalizationStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_events___default.a);
	
	var LocalizationStore = new LocalizationStoreClass();
	LocalizationStore.setMaxListeners(0);
	
	LocalizationStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_LOCALE:
	            LocalizationStore.setCurrentLocale(action.locale, action.translations);
	            LocalizationStore.emitChange();
	            break;
	        default:
	    }
	});
	
	/* harmony default export */ exports["a"] = LocalizationStore;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(1282);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __WEBPACK_IMPORTED_MODULE_3_jquery__ && __WEBPACK_IMPORTED_MODULE_3_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emoji_json__ = __webpack_require__(1757);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emoji_json___default = __WEBPACK_IMPORTED_MODULE_5__emoji_json__ && __WEBPACK_IMPORTED_MODULE_5__emoji_json__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__emoji_json__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__emoji_json__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__emoji_json___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__emoji_json___default });
	/* harmony export */ exports["getEmoticonsByName"] = getEmoticonsByName;/* harmony export */ exports["getEmoticonsByCodePoint"] = getEmoticonsByCodePoint;/* harmony export */ exports["handleEmoticons"] = handleEmoticons;/* harmony export */ exports["getImagePathForEmoticon"] = getImagePathForEmoticon;'use strict';
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var emoticonPatterns = {
	    slightly_smiling_face: /(^|\s)(:-?\))(?=$|\s)/g, // :)
	    wink: /(^|\s)(;-?\))(?=$|\s)/g, // ;)
	    open_mouth: /(^|\s)(:o)(?=$|\s)/gi, // :o
	    scream: /(^|\s)(:-o)(?=$|\s)/gi, // :-o
	    smirk: /(^|\s)(:-?])(?=$|\s)/g, // :]
	    grinning: /(^|\s)(:-?d)(?=$|\s)/gi, // :D
	    stuck_out_tongue_closed_eyes: /(^|\s)(x-d)(?=$|\s)/gi, // x-d
	    stuck_out_tongue: /(^|\s)(:-?p)(?=$|\s)/gi, // :p
	    rage: /(^|\s)(:-?[\[@])(?=$|\s)/g, // :@
	    slightly_frowning_face: /(^|\s)(:-?\()(?=$|\s)/g, // :(
	    cry: /(^|\s)(:['’]-?\(|:&#x27;\(|:&#39;\()(?=$|\s)/g, // :`(
	    confused: /(^|\s)(:-?\/)(?=$|\s)/g, // :/
	    confounded: /(^|\s)(:-?s)(?=$|\s)/gi, // :s
	    neutral_face: /(^|\s)(:-?\|)(?=$|\s)/g, // :|
	    flushed: /(^|\s)(:-?\$)(?=$|\s)/g, // :$
	    mask: /(^|\s)(:-x)(?=$|\s)/gi, // :-x
	    heart: /(^|\s)(<3|&lt;3)(?=$|\s)/g, // <3
	    broken_heart: /(^|\s)(<\/3|&lt;&#x2F;3)(?=$|\s)/g, // </3
	    thumbsup: /(^|\s)(:\+1:)(?=$|\s)/g, // :+1:
	    thumbsdown: /(^|\s)(:\-1:)(?=$|\s)/g // :-1:
	};
	
	var emoticonsByName = void 0;
	var emoticonsByCodePoint = void 0;
	
	function initializeEmoticons() {
	    emoticonsByName = new /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
	    emoticonsByCodePoint = new /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__emoji_json___default.a), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var emoji = _step.value;
	
	            var unicode = emoji.emoji;
	
	            var filename = '';
	            if (unicode) {
	                // this is a unicode emoji so the character code determines the file name
	                var codepoint = '';
	
	                for (var i = 0; i < unicode.length; i += 2) {
	                    var code = fixedCharCodeAt(unicode, i);
	
	                    // ignore variation selector characters
	                    if (code >= 0xfe00 && code <= 0xfe0f) {
	                        continue;
	                    }
	
	                    // some emoji (such as country flags) span multiple unicode characters
	                    if (i !== 0) {
	                        codepoint += '-';
	                    }
	
	                    codepoint += pad(code.toString(16));
	                }
	
	                filename = codepoint;
	                emoticonsByCodePoint.add(codepoint);
	            } else {
	                // this isn't a unicode emoji so the first alias determines the file name
	                filename = emoji.aliases[0];
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(emoji.aliases), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var alias = _step2.value;
	
	                    emoticonsByName.set(alias, {
	                        alias: alias,
	                        path: getImagePathForEmoticon(filename)
	                    });
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	// Pads a hexadecimal number with zeroes to be at least 4 digits long
	function pad(n) {
	    if (n.length >= 4) {
	        return n;
	    }
	
	    // http://stackoverflow.com/questions/10073699/pad-a-number-with-leading-zeros-in-javascript
	    return ('0000' + n).slice(-4);
	}
	
	// Gets the unicode character code of a character starting at the given index in the string
	// Adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
	function fixedCharCodeAt(str) {
	    var idx = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	    // ex. fixedCharCodeAt('\uD800\uDC00', 0); // 65536
	    // ex. fixedCharCodeAt('\uD800\uDC00', 1); // false
	    var code = str.charCodeAt(idx);
	
	    // High surrogate (could change last hex to 0xDB7F to treat high
	    // private surrogates as single characters)
	    if (code >= 0xD800 && code <= 0xDBFF) {
	        var hi = code;
	        var low = str.charCodeAt(idx + 1);
	
	        if (isNaN(low)) {
	            console.log('High surrogate not followed by low surrogate in fixedCharCodeAt()'); // eslint-disable-line
	        }
	
	        return (hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;
	    }
	
	    if (code >= 0xDC00 && code <= 0xDFFF) {
	        // Low surrogate
	        // We return false to allow loops to skip this iteration since should have
	        // already handled high surrogate above in the previous iteration
	        return false;
	    }
	
	    return code;
	}
	
	function getEmoticonsByName() {
	    if (!emoticonsByName) {
	        initializeEmoticons();
	    }
	
	    return emoticonsByName;
	}
	
	function getEmoticonsByCodePoint() {
	    if (!emoticonsByCodePoint) {
	        initializeEmoticons();
	    }
	
	    return emoticonsByCodePoint;
	}
	
	function handleEmoticons(text, tokens) {
	    var output = text;
	
	    function replaceEmoticonWithToken(fullMatch, prefix, matchText, name) {
	        if (getEmoticonsByName().has(name)) {
	            var index = tokens.size;
	            var alias = 'MM_EMOTICON' + index;
	            var path = getEmoticonsByName().get(name).path;
	
	            tokens.set(alias, {
	                value: '<img align="absmiddle" alt="' + matchText + '" class="emoticon" src="' + path + '" title="' + matchText + '" />',
	                originalText: fullMatch
	            });
	
	            return prefix + alias;
	        }
	
	        return fullMatch;
	    }
	
	    output = output.replace(/(^|\s)(:([a-zA-Z0-9_-]+):)(?=$|\s)/g, function (fullMatch, prefix, matchText, name) {
	        return replaceEmoticonWithToken(fullMatch, prefix, matchText, name);
	    });
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.each(emoticonPatterns, function (name, pattern) {
	        // this might look a bit funny, but since the name isn't contained in the actual match
	        // like with the named emoticons, we need to add it in manually
	        output = output.replace(pattern, function (fullMatch, prefix, matchText) {
	            return replaceEmoticonWithToken(fullMatch, prefix, matchText, name);
	        });
	    });
	
	    return output;
	}
	
	function getImagePathForEmoticon(name) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_4__constants_jsx__["a"].EMOJI_PATH + '/' + name + '.png';
	}

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js__ = __webpack_require__(1406);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default = __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js__ && __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js__ = __webpack_require__(1407);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js___default = __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js__ && __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js__ = __webpack_require__(1408);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js___default = __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js__ && __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js__ = __webpack_require__(1409);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js___default = __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js__ && __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js__ = __webpack_require__(1410);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js___default = __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js__ && __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js__ = __webpack_require__(1411);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js___default = __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js__ && __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js__ = __webpack_require__(1412);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js___default = __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js__ && __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js__ = __webpack_require__(1413);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js___default = __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js__ && __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js__ = __webpack_require__(1414);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js___default = __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js__ && __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js__ = __webpack_require__(1415);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js___default = __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js__ && __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js__ = __webpack_require__(1416);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js___default = __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js__ && __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js__ = __webpack_require__(1417);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js___default = __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js__ && __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js__ = __webpack_require__(1418);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js___default = __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js__ && __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js__ = __webpack_require__(1419);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js___default = __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js__ && __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js__ = __webpack_require__(1420);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js___default = __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js__ && __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js__ = __webpack_require__(1421);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js___default = __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js__ && __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js__ = __webpack_require__(1422);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js___default = __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js__ && __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js__ = __webpack_require__(1423);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js___default = __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js__ && __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js__ = __webpack_require__(1424);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js___default = __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js__ && __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js__ = __webpack_require__(1425);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js___default = __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js__ && __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js__ = __webpack_require__(1426);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js___default = __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js__ && __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js__ = __webpack_require__(1427);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js___default = __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js__ && __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js__ = __webpack_require__(1428);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js___default = __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js__ && __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js__ = __webpack_require__(1429);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js___default = __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js__ && __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js__ = __webpack_require__(1430);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js___default = __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js__ && __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js__ = __webpack_require__(1431);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js___default = __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js__ && __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js__ = __webpack_require__(1432);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js___default = __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js__ && __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js__ = __webpack_require__(1433);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js___default = __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js__ && __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js__ = __webpack_require__(1434);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js___default = __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js__ && __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js__ = __webpack_require__(1435);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js___default = __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js__ && __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js__ = __webpack_require__(1436);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js___default = __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js__ && __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js__ = __webpack_require__(1437);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js___default = __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js__ && __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js__ = __webpack_require__(1438);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js___default = __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js__ && __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js__ = __webpack_require__(1439);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js___default = __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js__ && __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js__ = __webpack_require__(1440);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js___default = __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js__ && __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js__ = __webpack_require__(1441);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js___default = __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js__ && __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js__ = __webpack_require__(1442);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js___default = __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js__ && __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js__ = __webpack_require__(1443);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js___default = __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js__ && __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js__ = __webpack_require__(1444);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js___default = __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js__ && __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js__ = __webpack_require__(1445);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js___default = __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js__ && __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js__ = __webpack_require__(1446);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js___default = __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js__ && __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js__ = __webpack_require__(1447);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js___default = __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js__ && __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js__ = __webpack_require__(1448);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js___default = __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js__ && __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js__ = __webpack_require__(1449);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js___default = __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js__ && __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js__ = __webpack_require__(1450);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js___default = __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js__ && __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js__ = __webpack_require__(1451);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js___default = __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js__ && __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js__ = __webpack_require__(1452);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js___default = __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js__ && __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js__ = __webpack_require__(1453);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js___default = __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js__ && __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js__ = __webpack_require__(1454);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js___default = __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js__ && __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js__ = __webpack_require__(1455);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js___default = __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js__ && __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js__ = __webpack_require__(1456);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js___default = __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js__ && __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js__ = __webpack_require__(1457);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js___default = __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js__ && __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js__ = __webpack_require__(1458);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js___default = __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js__ && __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js__ = __webpack_require__(1459);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js___default = __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js__ && __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js__ = __webpack_require__(1460);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js___default = __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js__ && __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js__ = __webpack_require__(1461);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js___default = __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js__ && __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js__ = __webpack_require__(1462);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js___default = __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js__ && __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js___default });
	/* harmony export */ exports["formatCode"] = formatCode;/* harmony export */ exports["getLang"] = getLang;'use strict';
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('actionscript', /* harmony import */__WEBPACK_IMPORTED_MODULE_4_highlight_js_lib_languages_actionscript_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('applescript', /* harmony import */__WEBPACK_IMPORTED_MODULE_5_highlight_js_lib_languages_applescript_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('bash', /* harmony import */__WEBPACK_IMPORTED_MODULE_6_highlight_js_lib_languages_bash_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('clojure', /* harmony import */__WEBPACK_IMPORTED_MODULE_7_highlight_js_lib_languages_clojure_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('coffeescript', /* harmony import */__WEBPACK_IMPORTED_MODULE_8_highlight_js_lib_languages_coffeescript_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('cpp', /* harmony import */__WEBPACK_IMPORTED_MODULE_9_highlight_js_lib_languages_cpp_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('cs', /* harmony import */__WEBPACK_IMPORTED_MODULE_10_highlight_js_lib_languages_cs_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('css', /* harmony import */__WEBPACK_IMPORTED_MODULE_11_highlight_js_lib_languages_css_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('d', /* harmony import */__WEBPACK_IMPORTED_MODULE_12_highlight_js_lib_languages_d_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('dart', /* harmony import */__WEBPACK_IMPORTED_MODULE_13_highlight_js_lib_languages_dart_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('delphi', /* harmony import */__WEBPACK_IMPORTED_MODULE_14_highlight_js_lib_languages_delphi_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('diff', /* harmony import */__WEBPACK_IMPORTED_MODULE_15_highlight_js_lib_languages_diff_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('django', /* harmony import */__WEBPACK_IMPORTED_MODULE_16_highlight_js_lib_languages_django_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('dockerfile', /* harmony import */__WEBPACK_IMPORTED_MODULE_17_highlight_js_lib_languages_dockerfile_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('erlang', /* harmony import */__WEBPACK_IMPORTED_MODULE_18_highlight_js_lib_languages_erlang_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('fortran', /* harmony import */__WEBPACK_IMPORTED_MODULE_19_highlight_js_lib_languages_fortran_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('fsharp', /* harmony import */__WEBPACK_IMPORTED_MODULE_20_highlight_js_lib_languages_fsharp_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('gcode', /* harmony import */__WEBPACK_IMPORTED_MODULE_21_highlight_js_lib_languages_gcode_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('go', /* harmony import */__WEBPACK_IMPORTED_MODULE_22_highlight_js_lib_languages_go_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('groovy', /* harmony import */__WEBPACK_IMPORTED_MODULE_23_highlight_js_lib_languages_groovy_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('handlebars', /* harmony import */__WEBPACK_IMPORTED_MODULE_24_highlight_js_lib_languages_handlebars_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('haskell', /* harmony import */__WEBPACK_IMPORTED_MODULE_25_highlight_js_lib_languages_haskell_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('haxe', /* harmony import */__WEBPACK_IMPORTED_MODULE_26_highlight_js_lib_languages_haxe_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('java', /* harmony import */__WEBPACK_IMPORTED_MODULE_27_highlight_js_lib_languages_java_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('javascript', /* harmony import */__WEBPACK_IMPORTED_MODULE_28_highlight_js_lib_languages_javascript_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('json', /* harmony import */__WEBPACK_IMPORTED_MODULE_29_highlight_js_lib_languages_json_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('julia', /* harmony import */__WEBPACK_IMPORTED_MODULE_30_highlight_js_lib_languages_julia_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('kotlin', /* harmony import */__WEBPACK_IMPORTED_MODULE_31_highlight_js_lib_languages_kotlin_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('less', /* harmony import */__WEBPACK_IMPORTED_MODULE_32_highlight_js_lib_languages_less_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('lisp', /* harmony import */__WEBPACK_IMPORTED_MODULE_33_highlight_js_lib_languages_lisp_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('lua', /* harmony import */__WEBPACK_IMPORTED_MODULE_34_highlight_js_lib_languages_lua_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('makefile', /* harmony import */__WEBPACK_IMPORTED_MODULE_35_highlight_js_lib_languages_makefile_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('markdown', /* harmony import */__WEBPACK_IMPORTED_MODULE_36_highlight_js_lib_languages_markdown_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('matlab', /* harmony import */__WEBPACK_IMPORTED_MODULE_37_highlight_js_lib_languages_matlab_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('objectivec', /* harmony import */__WEBPACK_IMPORTED_MODULE_38_highlight_js_lib_languages_objectivec_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('ocaml', /* harmony import */__WEBPACK_IMPORTED_MODULE_39_highlight_js_lib_languages_ocaml_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('perl', /* harmony import */__WEBPACK_IMPORTED_MODULE_40_highlight_js_lib_languages_perl_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('php', /* harmony import */__WEBPACK_IMPORTED_MODULE_41_highlight_js_lib_languages_php_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('powershell', /* harmony import */__WEBPACK_IMPORTED_MODULE_42_highlight_js_lib_languages_powershell_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('puppet', /* harmony import */__WEBPACK_IMPORTED_MODULE_43_highlight_js_lib_languages_puppet_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('python', /* harmony import */__WEBPACK_IMPORTED_MODULE_44_highlight_js_lib_languages_python_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('r', /* harmony import */__WEBPACK_IMPORTED_MODULE_45_highlight_js_lib_languages_r_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('ruby', /* harmony import */__WEBPACK_IMPORTED_MODULE_46_highlight_js_lib_languages_ruby_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('rust', /* harmony import */__WEBPACK_IMPORTED_MODULE_47_highlight_js_lib_languages_rust_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('scala', /* harmony import */__WEBPACK_IMPORTED_MODULE_48_highlight_js_lib_languages_scala_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('scheme', /* harmony import */__WEBPACK_IMPORTED_MODULE_49_highlight_js_lib_languages_scheme_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('scss', /* harmony import */__WEBPACK_IMPORTED_MODULE_50_highlight_js_lib_languages_scss_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('smalltalk', /* harmony import */__WEBPACK_IMPORTED_MODULE_51_highlight_js_lib_languages_smalltalk_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('sql', /* harmony import */__WEBPACK_IMPORTED_MODULE_52_highlight_js_lib_languages_sql_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('swift', /* harmony import */__WEBPACK_IMPORTED_MODULE_53_highlight_js_lib_languages_swift_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('tex', /* harmony import */__WEBPACK_IMPORTED_MODULE_54_highlight_js_lib_languages_tex_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('vbnet', /* harmony import */__WEBPACK_IMPORTED_MODULE_55_highlight_js_lib_languages_vbnet_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('vbscript', /* harmony import */__WEBPACK_IMPORTED_MODULE_56_highlight_js_lib_languages_vbscript_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('verilog', /* harmony import */__WEBPACK_IMPORTED_MODULE_57_highlight_js_lib_languages_verilog_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('xml', /* harmony import */__WEBPACK_IMPORTED_MODULE_58_highlight_js_lib_languages_xml_js___default.a);
	/* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.registerLanguage('yaml', /* harmony import */__WEBPACK_IMPORTED_MODULE_59_highlight_js_lib_languages_yaml_js___default.a);
	
	var HighlightedLanguages = /* harmony import */__WEBPACK_IMPORTED_MODULE_2__constants_jsx__["a"].HighlightedLanguages;
	
	function formatCode(lang, data, filename) {
	    var language = lang.toLowerCase() || '';
	    var contents = void 0;
	    var header = '';
	
	    if (HighlightedLanguages[language]) {
	        var name = HighlightedLanguages[language].name;
	
	        if (filename) {
	            var fname = decodeURIComponent(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__utils_jsx__.getFileName(filename));
	            name = fname + ' - ' + name;
	        }
	
	        header = '<span class="post-code__language">' + name + '</span>';
	
	        try {
	            contents = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_highlight_js_lib_highlight_js___default.a.highlight(language, data).value;
	        } catch (e) {
	            contents = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_1__text_formatting_jsx__.sanitizeHtml(data);
	        }
	    } else {
	        contents = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_1__text_formatting_jsx__.sanitizeHtml(data);
	    }
	
	    var className = 'post-code';
	    if (!language) {
	        // wrap when no language is specified
	        className += ' post-code--wrap';
	    }
	
	    if (filename) {
	        // add line numbers when viewing a code file preview
	        var lines = data.match(/\r\n|\r|\n|$/g).length;
	        var strlines = '';
	        for (var i = 1; i <= lines; i++) {
	            if (strlines) {
	                strlines += '\n' + i;
	            } else {
	                strlines += i;
	            }
	        }
	
	        contents = '<table>' + '<tbody>' + '<tr>' + '<td class="post-code__lineno">' + strlines + '</td>' + '<td>' + contents + '</td>' + '</tr>' + '</tbody>' + '</table>';
	    }
	
	    return '<div class="' + className + '">' + header + '<pre>' + '<code class="hljs">' + contents + '</code>' + '</pre>' + '</div>';
	}
	
	function getLang(filename) {
	    var fileInfo = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__utils_jsx__.splitFileLocation(filename);
	    var ext = fileInfo.ext;
	    if (!ext) {
	        return null;
	    }
	
	    ext = ext.toLowerCase();
	    for (var key in HighlightedLanguages) {
	        if (HighlightedLanguages[key].extensions.find(function (x) {
	            return x === ext;
	        })) {
	            return key;
	        }
	    }
	    return null;
	}

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, "/*!\n * Bootstrap Colorpicker\n * http://mjolnic.github.io/bootstrap-colorpicker/\n *\n * Originally written by (c) 2012 Stefan Petre\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0.txt\n *\n */.colorpicker-saturation{float:left;width:100px;height:100px;cursor:crosshair;background-image:url(" + __webpack_require__(833) + ")}.colorpicker-saturation i{position:absolute;top:0;left:0;display:block;width:5px;height:5px;margin:-4px 0 0 -4px;border:1px solid #000;border-radius:5px}.colorpicker-saturation i b{display:block;width:5px;height:5px;border:1px solid #fff;border-radius:5px}.colorpicker-alpha,.colorpicker-hue{float:left;width:15px;height:100px;margin-bottom:4px;margin-left:4px;cursor:row-resize}.colorpicker-alpha i,.colorpicker-hue i{position:absolute;top:0;left:0;display:block;width:100%;height:1px;margin-top:-1px;background:#000;border-top:1px solid #fff}.colorpicker-hue{background-image:url(" + __webpack_require__(832) + ")}.colorpicker-alpha{display:none;background-image:url(" + __webpack_require__(389) + ")}.colorpicker-alpha,.colorpicker-hue,.colorpicker-saturation{background-size:contain}.colorpicker{top:0;left:0;z-index:2500;min-width:130px;padding:4px;margin-top:1px;border-radius:4px;*zoom:1}.colorpicker:after,.colorpicker:before{display:table;line-height:0;content:\"\"}.colorpicker:after{clear:both}.colorpicker:before{top:-7px;left:6px;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-left:7px solid transparent;border-bottom-color:rgba(0,0,0,.2)}.colorpicker:after,.colorpicker:before{position:absolute;display:inline-block;content:''}.colorpicker:after{top:-6px;left:7px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.colorpicker div{position:relative}.colorpicker.colorpicker-with-alpha{min-width:140px}.colorpicker.colorpicker-with-alpha .colorpicker-alpha{display:block}.colorpicker-color{height:10px;margin-top:5px;clear:both;background-image:url(" + __webpack_require__(389) + ");background-position:0 100%}.colorpicker-color div{height:10px}.colorpicker-selectors{display:none;height:10px;margin-top:5px;clear:both}.colorpicker-selectors i{float:left;width:10px;height:10px;cursor:pointer}.colorpicker-selectors i+i{margin-left:3px}.colorpicker-element .add-on i,.colorpicker-element .input-group-addon i{display:inline-block;width:16px;height:16px;vertical-align:text-top;cursor:pointer}.colorpicker.colorpicker-inline{position:relative;z-index:auto;display:inline-block;float:none}.colorpicker.colorpicker-horizontal{width:110px;height:auto;min-width:110px}.colorpicker.colorpicker-horizontal .colorpicker-saturation{margin-bottom:4px}.colorpicker.colorpicker-horizontal .colorpicker-color{width:100px}.colorpicker.colorpicker-horizontal .colorpicker-alpha,.colorpicker.colorpicker-horizontal .colorpicker-hue{float:left;width:100px;height:15px;margin-bottom:4px;margin-left:0;cursor:col-resize}.colorpicker.colorpicker-horizontal .colorpicker-alpha i,.colorpicker.colorpicker-horizontal .colorpicker-hue i{position:absolute;top:0;left:0;display:block;width:1px;height:15px;margin-top:0;background:#fff;border:none}.colorpicker.colorpicker-horizontal .colorpicker-hue{background-image:url(" + __webpack_require__(831) + ")}.colorpicker.colorpicker-horizontal .colorpicker-alpha{background-image:url(" + __webpack_require__(830) + ")}.colorpicker.colorpicker-hidden{display:none}.colorpicker.colorpicker-visible{display:block}.colorpicker-inline.colorpicker-visible{display:inline-block}.colorpicker-right:before{right:6px;left:auto}.colorpicker-right:after{right:7px;left:auto}", ""]);
	
	// exports


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2f51bb59fe7f4afe1f614e8ad431f4c6.png";

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b45481f508ec8b25036b2491d3c89305.png";

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fa44c89ddfe141733a9b014159b16a6e.png";

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1a8791e49cc0ebcc96186ebc554cfc16.png";

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d663a5d3e4b08213cb00f5bfafecf160.png";

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d54040ed5db8aec295180831de77c504.png";

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9f2f4cdae93ebe73045aec37eb210fda.png";

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/60b86f79c18e1fdf64073ce34dbc5903.png";

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/409e5045b5864ba9254118f19cedbecf.png";

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a2fe8019aff86724e29afa309075c758.jpg";

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/10f4b956ec4d7e11c2b0c1cc11e18db1.png";

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f4769f9bdb7466be65088239c12046d1.eot";

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ecb4713bb62fda1fb9e9e69630e57221.eot";

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b67eca89250a6e89649de74b033cfaf4.eot";

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d8ff5effbd42e45b79308e4697eb35a2.eot";

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/dc7b7052df5ca6a318a5853041d7d0f2.eot";

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/300373ada70571cef7d998aa13c84dff.eot";

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/32b3bc76e4343273f2bcbe8ebb26aaa9.eot";

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cb3625efa7f7697e0609b1ee54353306.eot";

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9f916e330c478bbfa2a0dd6614042046.eot";

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f6fcf1b0a50cefee0e260d54c9065592.eot";

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d3a58dfe7ce7dbd2cc4ac083014ca3d3.eot";

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/0e0cb81cc307681279d3d385feeac121.eot";

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b3f58c6e846275e3b9b833ebd967c8c0.eot";

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7f56ddfac4fa25c9f79723f36f25c000.eot";

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c2d63580d81c479093aef738f033ca1b.eot";

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2c60cccfd1ba82b468fe8d10db132492.eot";

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9b465e02aa07dcf410500658d3685a1d.eot";

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4962318b9c0bf07295fbd7d1fc75abb6.eot";

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5b597628905a58ef42c0e5dbe0a69659.eot";

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/84f7e2d25307ce8b0f69e1b7182e2d5c.eot";

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/14dba844f5bae6aa2820faedbad05f28.eot";

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/771ec2117ba107c0bf2dacafa25be069.eot";

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/79f6b7a43be2ec8f8fa11383221f1063.eot";

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b621bf8337f8ee6b4cf4204a73f52058.eot";

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4376f45e4563c694f88b2f9e8b1ea924.eot";

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ea0a12de72e2dc18d04a6ae232138462.eot";

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/357d675366cce0fbb6ca5e1474ae489c.eot";

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9a599f54797d2ae5a61a3243b4e816fb.eot";

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ce26ce4629f1e78f666544143a88c286.eot";

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ca4e3b468e0d24ae948b162e83fc225d.eot";

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/60449ee63020f7a26f19a5454ee34c47.eot";

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d09461e773d7a194502246db31c3c1df.eot";

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2291980bac6d45447c902cfa41da6314.eot";

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/957287ebc80dcf9381c25b1c0d0ae51e.eot";

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b07fc5b16bb5ecf336f31a8e993c9865.eot";

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/98255d04bb0ce821171ea055fdfcc53f.eot";

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1eac23416f1697416da6bded9c98814a.eot";

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f9017268842230e60b41aca18d467093.eot";

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/12369512b60e0f4612d7809df69256f8.eot";

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/60d11b4890158055d028f36174adf42e.eot";

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5e286765680010ae333a29e4f2af0b98.eot";

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7af21db5e594c39284a629ba7a5b0c7d.eot";

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/bf0b1e598480a7c8f4cc8dc9b80b5e51.eot";

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d37fe4e3fa1f2c4530f247749d350e87.eot";

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b1e318d8bbdae23d5177d0549e0a3197.eot";

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d327af9dd35a53c14450188dbfba1153.eot";

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/14cb181fa8c5e47182cc689981de5fa1.eot";

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b49aef936d34dd80e5736fae725d6f28.eot";

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/17e7e980c29c007c8cafc36bd418fec9.eot";

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/672c96197e82b9e38e0feb8267cf10d8.eot";

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3c3fce5eb8b64ba21d19eaa6d40ff339.eot";

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a0ba2817318bda0e08e59e2f07416112.eot";

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2b4454d6e2f687619cbd307e75102078.eot";

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/dc81eae9effb44e3651c8f6fd9513818.eot";

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d327c2105b014c15a277a56f54927e2e.eot";

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2702ac35e78692e600011ed1c85ef060.eot";

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/31ec4506469620df9b5295998a4bfead.eot";

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/031026c46bba0e8de61c6efabd9b263a.eot";

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a3319b736d9c1594add4dd56dcb002bf.eot";

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cf8394e808472179776070c3aa4d8169.eot";

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5438d9d464a3973d450201211780eeb7.eot";

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1f5c2abfeea0beaf96c20fcada9ef082.eot";

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1a6c0d68e798835afb71c745092d80f5.eot";

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5a3cee2bf91471f8b0356195afde026c.eot";

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b2e94149f3405c883c9af607c80bf42c.eot";

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27);
	var Reporter = __webpack_require__(162).Reporter;
	var Buffer = __webpack_require__(19).Buffer;
	
	function DecoderBuffer(base, options) {
	  Reporter.call(this, options);
	  if (!Buffer.isBuffer(base)) {
	    this.error('Input not Buffer');
	    return;
	  }
	
	  this.base = base;
	  this.offset = 0;
	  this.length = base.length;
	}
	inherits(DecoderBuffer, Reporter);
	exports.DecoderBuffer = DecoderBuffer;
	
	DecoderBuffer.prototype.save = function save() {
	  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
	};
	
	DecoderBuffer.prototype.restore = function restore(save) {
	  // Return skipped data
	  var res = new DecoderBuffer(this.base);
	  res.offset = save.offset;
	  res.length = this.offset;
	
	  this.offset = save.offset;
	  Reporter.prototype.restore.call(this, save.reporter);
	
	  return res;
	};
	
	DecoderBuffer.prototype.isEmpty = function isEmpty() {
	  return this.offset === this.length;
	};
	
	DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
	  if (this.offset + 1 <= this.length)
	    return this.base.readUInt8(this.offset++, true);
	  else
	    return this.error(fail || 'DecoderBuffer overrun');
	}
	
	DecoderBuffer.prototype.skip = function skip(bytes, fail) {
	  if (!(this.offset + bytes <= this.length))
	    return this.error(fail || 'DecoderBuffer overrun');
	
	  var res = new DecoderBuffer(this.base);
	
	  // Share reporter state
	  res._reporterState = this._reporterState;
	
	  res.offset = this.offset;
	  res.length = this.offset + bytes;
	  this.offset += bytes;
	  return res;
	}
	
	DecoderBuffer.prototype.raw = function raw(save) {
	  return this.base.slice(save ? save.offset : this.offset, this.length);
	}
	
	function EncoderBuffer(value, reporter) {
	  if (Array.isArray(value)) {
	    this.length = 0;
	    this.value = value.map(function(item) {
	      if (!(item instanceof EncoderBuffer))
	        item = new EncoderBuffer(item, reporter);
	      this.length += item.length;
	      return item;
	    }, this);
	  } else if (typeof value === 'number') {
	    if (!(0 <= value && value <= 0xff))
	      return reporter.error('non-byte EncoderBuffer value');
	    this.value = value;
	    this.length = 1;
	  } else if (typeof value === 'string') {
	    this.value = value;
	    this.length = Buffer.byteLength(value);
	  } else if (Buffer.isBuffer(value)) {
	    this.value = value;
	    this.length = value.length;
	  } else {
	    return reporter.error('Unsupported type: ' + typeof value);
	  }
	}
	exports.EncoderBuffer = EncoderBuffer;
	
	EncoderBuffer.prototype.join = function join(out, offset) {
	  if (!out)
	    out = new Buffer(this.length);
	  if (!offset)
	    offset = 0;
	
	  if (this.length === 0)
	    return out;
	
	  if (Array.isArray(this.value)) {
	    this.value.forEach(function(item) {
	      item.join(out, offset);
	      offset += item.length;
	    });
	  } else {
	    if (typeof this.value === 'number')
	      out[offset] = this.value;
	    else if (typeof this.value === 'string')
	      out.write(this.value, offset);
	    else if (Buffer.isBuffer(this.value))
	      this.value.copy(out, offset);
	    offset += this.length;
	  }
	
	  return out;
	};
	


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var constants = exports;
	
	// Helper
	constants._reverse = function reverse(map) {
	  var res = {};
	
	  Object.keys(map).forEach(function(key) {
	    // Convert key to integer if it is stringified
	    if ((key | 0) == key)
	      key = key | 0;
	
	    var value = map[key];
	    res[value] = key;
	  });
	
	  return res;
	};
	
	constants.der = __webpack_require__(1088);
	


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27);
	
	var asn1 = __webpack_require__(192);
	var base = asn1.base;
	var bignum = asn1.bignum;
	
	// Import DER constants
	var der = asn1.constants.der;
	
	function DERDecoder(entity) {
	  this.enc = 'der';
	  this.name = entity.name;
	  this.entity = entity;
	
	  // Construct base tree
	  this.tree = new DERNode();
	  this.tree._init(entity.body);
	};
	module.e = DERDecoder;
	
	DERDecoder.prototype.decode = function decode(data, options) {
	  if (!(data instanceof base.DecoderBuffer))
	    data = new base.DecoderBuffer(data, options);
	
	  return this.tree._decode(data, options);
	};
	
	// Tree methods
	
	function DERNode(parent) {
	  base.Node.call(this, 'der', parent);
	}
	inherits(DERNode, base.Node);
	
	DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
	  if (buffer.isEmpty())
	    return false;
	
	  var state = buffer.save();
	  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
	  if (buffer.isError(decodedTag))
	    return decodedTag;
	
	  buffer.restore(state);
	
	  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
	    (decodedTag.tagStr + 'of') === tag || any;
	};
	
	DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
	  var decodedTag = derDecodeTag(buffer,
	                                'Failed to decode tag of "' + tag + '"');
	  if (buffer.isError(decodedTag))
	    return decodedTag;
	
	  var len = derDecodeLen(buffer,
	                         decodedTag.primitive,
	                         'Failed to get length of "' + tag + '"');
	
	  // Failure
	  if (buffer.isError(len))
	    return len;
	
	  if (!any &&
	      decodedTag.tag !== tag &&
	      decodedTag.tagStr !== tag &&
	      decodedTag.tagStr + 'of' !== tag) {
	    return buffer.error('Failed to match tag: "' + tag + '"');
	  }
	
	  if (decodedTag.primitive || len !== null)
	    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
	
	  // Indefinite length... find END tag
	  var state = buffer.save();
	  var res = this._skipUntilEnd(
	      buffer,
	      'Failed to skip indefinite length body: "' + this.tag + '"');
	  if (buffer.isError(res))
	    return res;
	
	  len = buffer.offset - state.offset;
	  buffer.restore(state);
	  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
	};
	
	DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
	  while (true) {
	    var tag = derDecodeTag(buffer, fail);
	    if (buffer.isError(tag))
	      return tag;
	    var len = derDecodeLen(buffer, tag.primitive, fail);
	    if (buffer.isError(len))
	      return len;
	
	    var res;
	    if (tag.primitive || len !== null)
	      res = buffer.skip(len)
	    else
	      res = this._skipUntilEnd(buffer, fail);
	
	    // Failure
	    if (buffer.isError(res))
	      return res;
	
	    if (tag.tagStr === 'end')
	      break;
	  }
	};
	
	DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder) {
	  var result = [];
	  while (!buffer.isEmpty()) {
	    var possibleEnd = this._peekTag(buffer, 'end');
	    if (buffer.isError(possibleEnd))
	      return possibleEnd;
	
	    var res = decoder.decode(buffer, 'der');
	    if (buffer.isError(res) && possibleEnd)
	      break;
	    result.push(res);
	  }
	  return result;
	};
	
	DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
	  if (tag === 'bitstr') {
	    var unused = buffer.readUInt8();
	    if (buffer.isError(unused))
	      return unused;
	    return { unused: unused, data: buffer.raw() };
	  } else if (tag === 'bmpstr') {
	    var raw = buffer.raw();
	    if (raw.length % 2 === 1)
	      return buffer.error('Decoding of string type: bmpstr length mismatch');
	
	    var str = '';
	    for (var i = 0; i < raw.length / 2; i++) {
	      str += String.fromCharCode(raw.readUInt16BE(i * 2));
	    }
	    return str;
	  } else if (tag === 'numstr') {
	    var numstr = buffer.raw().toString('ascii');
	    if (!this._isNumstr(numstr)) {
	      return buffer.error('Decoding of string type: ' +
	                          'numstr unsupported characters');
	    }
	    return numstr;
	  } else if (tag === 'octstr') {
	    return buffer.raw();
	  } else if (tag === 'printstr') {
	    var printstr = buffer.raw().toString('ascii');
	    if (!this._isPrintstr(printstr)) {
	      return buffer.error('Decoding of string type: ' +
	                          'printstr unsupported characters');
	    }
	    return printstr;
	  } else if (/str$/.test(tag)) {
	    return buffer.raw().toString();
	  } else {
	    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
	  }
	};
	
	DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
	  var result;
	  var identifiers = [];
	  var ident = 0;
	  while (!buffer.isEmpty()) {
	    var subident = buffer.readUInt8();
	    ident <<= 7;
	    ident |= subident & 0x7f;
	    if ((subident & 0x80) === 0) {
	      identifiers.push(ident);
	      ident = 0;
	    }
	  }
	  if (subident & 0x80)
	    identifiers.push(ident);
	
	  var first = (identifiers[0] / 40) | 0;
	  var second = identifiers[0] % 40;
	
	  if (relative)
	    result = identifiers;
	  else
	    result = [first, second].concat(identifiers.slice(1));
	
	  if (values) {
	    var tmp = values[result.join(' ')];
	    if (tmp === undefined)
	      tmp = values[result.join('.')];
	    if (tmp !== undefined)
	      result = tmp;
	  }
	
	  return result;
	};
	
	DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
	  var str = buffer.raw().toString();
	  if (tag === 'gentime') {
	    var year = str.slice(0, 4) | 0;
	    var mon = str.slice(4, 6) | 0;
	    var day = str.slice(6, 8) | 0;
	    var hour = str.slice(8, 10) | 0;
	    var min = str.slice(10, 12) | 0;
	    var sec = str.slice(12, 14) | 0;
	  } else if (tag === 'utctime') {
	    var year = str.slice(0, 2) | 0;
	    var mon = str.slice(2, 4) | 0;
	    var day = str.slice(4, 6) | 0;
	    var hour = str.slice(6, 8) | 0;
	    var min = str.slice(8, 10) | 0;
	    var sec = str.slice(10, 12) | 0;
	    if (year < 70)
	      year = 2000 + year;
	    else
	      year = 1900 + year;
	  } else {
	    return buffer.error('Decoding ' + tag + ' time is not supported yet');
	  }
	
	  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
	};
	
	DERNode.prototype._decodeNull = function decodeNull(buffer) {
	  return null;
	};
	
	DERNode.prototype._decodeBool = function decodeBool(buffer) {
	  var res = buffer.readUInt8();
	  if (buffer.isError(res))
	    return res;
	  else
	    return res !== 0;
	};
	
	DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
	  // Bigint, return as it is (assume big endian)
	  var raw = buffer.raw();
	  var res = new bignum(raw);
	
	  if (values)
	    res = values[res.toString(10)] || res;
	
	  return res;
	};
	
	DERNode.prototype._use = function use(entity, obj) {
	  if (typeof entity === 'function')
	    entity = entity(obj);
	  return entity._getDecoder('der').tree;
	};
	
	// Utility methods
	
	function derDecodeTag(buf, fail) {
	  var tag = buf.readUInt8(fail);
	  if (buf.isError(tag))
	    return tag;
	
	  var cls = der.tagClass[tag >> 6];
	  var primitive = (tag & 0x20) === 0;
	
	  // Multi-octet tag - load
	  if ((tag & 0x1f) === 0x1f) {
	    var oct = tag;
	    tag = 0;
	    while ((oct & 0x80) === 0x80) {
	      oct = buf.readUInt8(fail);
	      if (buf.isError(oct))
	        return oct;
	
	      tag <<= 7;
	      tag |= oct & 0x7f;
	    }
	  } else {
	    tag &= 0x1f;
	  }
	  var tagStr = der.tag[tag];
	
	  return {
	    cls: cls,
	    primitive: primitive,
	    tag: tag,
	    tagStr: tagStr
	  };
	}
	
	function derDecodeLen(buf, primitive, fail) {
	  var len = buf.readUInt8(fail);
	  if (buf.isError(len))
	    return len;
	
	  // Indefinite form
	  if (!primitive && len === 0x80)
	    return null;
	
	  // Definite form
	  if ((len & 0x80) === 0) {
	    // Short form
	    return len;
	  }
	
	  // Long form
	  var num = len & 0x7f;
	  if (num >= 4)
	    return buf.error('length octect is too long');
	
	  len = 0;
	  for (var i = 0; i < num; i++) {
	    len <<= 8;
	    var j = buf.readUInt8(fail);
	    if (buf.isError(j))
	      return j;
	    len |= j;
	  }
	
	  return len;
	}
	


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27);
	var Buffer = __webpack_require__(19).Buffer;
	
	var asn1 = __webpack_require__(192);
	var base = asn1.base;
	
	// Import DER constants
	var der = asn1.constants.der;
	
	function DEREncoder(entity) {
	  this.enc = 'der';
	  this.name = entity.name;
	  this.entity = entity;
	
	  // Construct base tree
	  this.tree = new DERNode();
	  this.tree._init(entity.body);
	};
	module.e = DEREncoder;
	
	DEREncoder.prototype.encode = function encode(data, reporter) {
	  return this.tree._encode(data, reporter).join();
	};
	
	// Tree methods
	
	function DERNode(parent) {
	  base.Node.call(this, 'der', parent);
	}
	inherits(DERNode, base.Node);
	
	DERNode.prototype._encodeComposite = function encodeComposite(tag,
	                                                              primitive,
	                                                              cls,
	                                                              content) {
	  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);
	
	  // Short form
	  if (content.length < 0x80) {
	    var header = new Buffer(2);
	    header[0] = encodedTag;
	    header[1] = content.length;
	    return this._createEncoderBuffer([ header, content ]);
	  }
	
	  // Long form
	  // Count octets required to store length
	  var lenOctets = 1;
	  for (var i = content.length; i >= 0x100; i >>= 8)
	    lenOctets++;
	
	  var header = new Buffer(1 + 1 + lenOctets);
	  header[0] = encodedTag;
	  header[1] = 0x80 | lenOctets;
	
	  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
	    header[i] = j & 0xff;
	
	  return this._createEncoderBuffer([ header, content ]);
	};
	
	DERNode.prototype._encodeStr = function encodeStr(str, tag) {
	  if (tag === 'bitstr') {
	    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
	  } else if (tag === 'bmpstr') {
	    var buf = new Buffer(str.length * 2);
	    for (var i = 0; i < str.length; i++) {
	      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
	    }
	    return this._createEncoderBuffer(buf);
	  } else if (tag === 'numstr') {
	    if (!this._isNumstr(str)) {
	      return this.reporter.error('Encoding of string type: numstr supports ' +
	                                 'only digits and space');
	    }
	    return this._createEncoderBuffer(str);
	  } else if (tag === 'printstr') {
	    if (!this._isPrintstr(str)) {
	      return this.reporter.error('Encoding of string type: printstr supports ' +
	                                 'only latin upper and lower case letters, ' +
	                                 'digits, space, apostrophe, left and rigth ' +
	                                 'parenthesis, plus sign, comma, hyphen, ' +
	                                 'dot, slash, colon, equal sign, ' +
	                                 'question mark');
	    }
	    return this._createEncoderBuffer(str);
	  } else if (/str$/.test(tag)) {
	    return this._createEncoderBuffer(str);
	  } else {
	    return this.reporter.error('Encoding of string type: ' + tag +
	                               ' unsupported');
	  }
	};
	
	DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
	  if (typeof id === 'string') {
	    if (!values)
	      return this.reporter.error('string objid given, but no values map found');
	    if (!values.hasOwnProperty(id))
	      return this.reporter.error('objid not found in values map');
	    id = values[id].split(/[\s\.]+/g);
	    for (var i = 0; i < id.length; i++)
	      id[i] |= 0;
	  } else if (Array.isArray(id)) {
	    id = id.slice();
	    for (var i = 0; i < id.length; i++)
	      id[i] |= 0;
	  }
	
	  if (!Array.isArray(id)) {
	    return this.reporter.error('objid() should be either array or string, ' +
	                               'got: ' + JSON.stringify(id));
	  }
	
	  if (!relative) {
	    if (id[1] >= 40)
	      return this.reporter.error('Second objid identifier OOB');
	    id.splice(0, 2, id[0] * 40 + id[1]);
	  }
	
	  // Count number of octets
	  var size = 0;
	  for (var i = 0; i < id.length; i++) {
	    var ident = id[i];
	    for (size++; ident >= 0x80; ident >>= 7)
	      size++;
	  }
	
	  var objid = new Buffer(size);
	  var offset = objid.length - 1;
	  for (var i = id.length - 1; i >= 0; i--) {
	    var ident = id[i];
	    objid[offset--] = ident & 0x7f;
	    while ((ident >>= 7) > 0)
	      objid[offset--] = 0x80 | (ident & 0x7f);
	  }
	
	  return this._createEncoderBuffer(objid);
	};
	
	function two(num) {
	  if (num < 10)
	    return '0' + num;
	  else
	    return num;
	}
	
	DERNode.prototype._encodeTime = function encodeTime(time, tag) {
	  var str;
	  var date = new Date(time);
	
	  if (tag === 'gentime') {
	    str = [
	      two(date.getFullYear()),
	      two(date.getUTCMonth() + 1),
	      two(date.getUTCDate()),
	      two(date.getUTCHours()),
	      two(date.getUTCMinutes()),
	      two(date.getUTCSeconds()),
	      'Z'
	    ].join('');
	  } else if (tag === 'utctime') {
	    str = [
	      two(date.getFullYear() % 100),
	      two(date.getUTCMonth() + 1),
	      two(date.getUTCDate()),
	      two(date.getUTCHours()),
	      two(date.getUTCMinutes()),
	      two(date.getUTCSeconds()),
	      'Z'
	    ].join('');
	  } else {
	    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
	  }
	
	  return this._encodeStr(str, 'octstr');
	};
	
	DERNode.prototype._encodeNull = function encodeNull() {
	  return this._createEncoderBuffer('');
	};
	
	DERNode.prototype._encodeInt = function encodeInt(num, values) {
	  if (typeof num === 'string') {
	    if (!values)
	      return this.reporter.error('String int or enum given, but no values map');
	    if (!values.hasOwnProperty(num)) {
	      return this.reporter.error('Values map doesn\'t contain: ' +
	                                 JSON.stringify(num));
	    }
	    num = values[num];
	  }
	
	  // Bignum, assume big endian
	  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
	    var numArray = num.toArray();
	    if (!num.sign && numArray[0] & 0x80) {
	      numArray.unshift(0);
	    }
	    num = new Buffer(numArray);
	  }
	
	  if (Buffer.isBuffer(num)) {
	    var size = num.length;
	    if (num.length === 0)
	      size++;
	
	    var out = new Buffer(size);
	    num.copy(out);
	    if (num.length === 0)
	      out[0] = 0
	    return this._createEncoderBuffer(out);
	  }
	
	  if (num < 0x80)
	    return this._createEncoderBuffer(num);
	
	  if (num < 0x100)
	    return this._createEncoderBuffer([0, num]);
	
	  var size = 1;
	  for (var i = num; i >= 0x100; i >>= 8)
	    size++;
	
	  var out = new Array(size);
	  for (var i = out.length - 1; i >= 0; i--) {
	    out[i] = num & 0xff;
	    num >>= 8;
	  }
	  if(out[0] & 0x80) {
	    out.unshift(0);
	  }
	
	  return this._createEncoderBuffer(new Buffer(out));
	};
	
	DERNode.prototype._encodeBool = function encodeBool(value) {
	  return this._createEncoderBuffer(value ? 0xff : 0);
	};
	
	DERNode.prototype._use = function use(entity, obj) {
	  if (typeof entity === 'function')
	    entity = entity(obj);
	  return entity._getEncoder('der').tree;
	};
	
	DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
	  var state = this._baseState;
	  var i;
	  if (state['default'] === null)
	    return false;
	
	  var data = dataBuffer.join();
	  if (state.defaultBuffer === undefined)
	    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
	
	  if (data.length !== state.defaultBuffer.length)
	    return false;
	
	  for (i=0; i < data.length; i++)
	    if (data[i] !== state.defaultBuffer[i])
	      return false;
	
	  return true;
	};
	
	// Utility methods
	
	function encodeTag(tag, primitive, cls, reporter) {
	  var res;
	
	  if (tag === 'seqof')
	    tag = 'seq';
	  else if (tag === 'setof')
	    tag = 'set';
	
	  if (der.tagByName.hasOwnProperty(tag))
	    res = der.tagByName[tag];
	  else if (typeof tag === 'number' && (tag | 0) === tag)
	    res = tag;
	  else
	    return reporter.error('Unknown tag: ' + tag);
	
	  if (res >= 0x1f)
	    return reporter.error('Multi-octet tag encoding unsupported');
	
	  if (!primitive)
	    res |= 0x20;
	
	  res |= (der.tagClassByName[cls || 'universal'] << 6);
	
	  return res;
	}
	


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var cof = __webpack_require__(74);
	module.e = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(49)
	  , toIndex  = __webpack_require__(122)
	  , toLength = __webpack_require__(45);
	
	module.e = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var forOf = __webpack_require__(143);
	
	module.e = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};
	


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var aFunction = __webpack_require__(62)
	  , toObject  = __webpack_require__(49)
	  , IObject   = __webpack_require__(163)
	  , toLength  = __webpack_require__(45);
	
	module.e = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var aFunction  = __webpack_require__(62)
	  , isObject   = __webpack_require__(34)
	  , invoke     = __webpack_require__(197)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.e = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var dP          = __webpack_require__(38).f
	  , create      = __webpack_require__(117)
	  , hide        = __webpack_require__(56)
	  , redefineAll = __webpack_require__(120)
	  , ctx         = __webpack_require__(90)
	  , anInstance  = __webpack_require__(99)
	  , defined     = __webpack_require__(75)
	  , forOf       = __webpack_require__(143)
	  , $iterDefine = __webpack_require__(264)
	  , step        = __webpack_require__(469)
	  , setSpecies  = __webpack_require__(121)
	  , DESCRIPTORS = __webpack_require__(37)
	  , fastKey     = __webpack_require__(100).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.e = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(142)
	  , from    = __webpack_require__(461);
	module.e = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var redefineAll       = __webpack_require__(120)
	  , getWeak           = __webpack_require__(100).getWeak
	  , anObject          = __webpack_require__(24)
	  , isObject          = __webpack_require__(34)
	  , anInstance        = __webpack_require__(99)
	  , forOf             = __webpack_require__(143)
	  , createArrayMethod = __webpack_require__(81)
	  , $has              = __webpack_require__(53)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.e = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = !__webpack_require__(37) && !__webpack_require__(31)(function(){
	  return Object.defineProperty(__webpack_require__(255)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(24);
	module.e = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(done, value){
	  return {value: value, done: !!done};
	};


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.20 Math.log1p(x)
	module.e = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(119)
	  , gOPS     = __webpack_require__(201)
	  , pIE      = __webpack_require__(164)
	  , toObject = __webpack_require__(49)
	  , IObject  = __webpack_require__(163)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.e = !$assign || __webpack_require__(31)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var dP       = __webpack_require__(38)
	  , anObject = __webpack_require__(24)
	  , getKeys  = __webpack_require__(119);
	
	module.e = __webpack_require__(37) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(65)
	  , gOPN      = __webpack_require__(118).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.e.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};
	


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var has          = __webpack_require__(53)
	  , toIObject    = __webpack_require__(65)
	  , arrayIndexOf = __webpack_require__(193)(false)
	  , IE_PROTO     = __webpack_require__(268)('IE_PROTO');
	
	module.e = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var getKeys   = __webpack_require__(119)
	  , toIObject = __webpack_require__(65)
	  , isEnum    = __webpack_require__(164).f;
	module.e = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(118)
	  , gOPS     = __webpack_require__(201)
	  , anObject = __webpack_require__(24)
	  , Reflect  = __webpack_require__(29).Reflect;
	module.e = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $parseFloat = __webpack_require__(29).parseFloat
	  , $trim       = __webpack_require__(145).trim;
	
	module.e = 1 / $parseFloat(__webpack_require__(273) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $parseInt = __webpack_require__(29).parseInt
	  , $trim     = __webpack_require__(145).trim
	  , ws        = __webpack_require__(273)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.e = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.2.9 SameValue(x, y)
	module.e = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(45)
	  , repeat   = __webpack_require__(272)
	  , defined  = __webpack_require__(75);
	
	module.e = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};
	


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports.f = __webpack_require__(35);


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var strong = __webpack_require__(464);
	
	// 23.1 Map Objects
	module.e = __webpack_require__(194)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(37) && /./g.flags != 'g')__webpack_require__(38).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(196)
	});


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var strong = __webpack_require__(464);
	
	// 23.2 Set Objects
	module.e = __webpack_require__(194)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var each         = __webpack_require__(81)(0)
	  , redefine     = __webpack_require__(63)
	  , meta         = __webpack_require__(100)
	  , assign       = __webpack_require__(471)
	  , weak         = __webpack_require__(466)
	  , isObject     = __webpack_require__(34)
	  , has          = __webpack_require__(53)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.e = __webpack_require__(194)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1317), __esModule: true };


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1318), __esModule: true };


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj["default"] = obj;
	    return newObj;
	  }
	};
	
	exports.__esModule = true;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(1277);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	var _Symbol = __webpack_require__(1283)["default"];
	
	exports["default"] = function (obj) {
	  return obj && obj.constructor === _Symbol ? "symbol" : typeof obj;
	};
	
	exports.__esModule = true;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var r;
	
	module.e = function rand(len) {
	  if (!r)
	    r = new Rand(null);
	
	  return r.generate(len);
	};
	
	function Rand(rand) {
	  this.rand = rand;
	}
	module.e.Rand = Rand;
	
	Rand.prototype.generate = function generate(len) {
	  return this._rand(len);
	};
	
	if (typeof window === 'object') {
	  if (window.crypto && window.crypto.getRandomValues) {
	    // Modern browsers
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      window.crypto.getRandomValues(arr);
	      return arr;
	    };
	  } else if (window.msCrypto && window.msCrypto.getRandomValues) {
	    // IE
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      window.msCrypto.getRandomValues(arr);
	      return arr;
	    };
	  } else {
	    // Old junk
	    Rand.prototype._rand = function() {
	      throw new Error('Not implemented yet');
	    };
	  }
	} else {
	  // Node.js or Web worker
	  try {
	    var crypto = __webpack_require__(215);
	
	    Rand.prototype._rand = function _rand(n) {
	      return crypto.randomBytes(n);
	    };
	  } catch (e) {
	    // Emulate crypto API using randy
	    Rand.prototype._rand = function _rand(n) {
	      var res = new Uint8Array(n);
	      for (var i = 0; i < res.length; i++)
	        res[i] = this.rand.getByte();
	      return res;
	    };
	  }
	}
	


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var aes = __webpack_require__(206)
	var Transform = __webpack_require__(146)
	var inherits = __webpack_require__(27)
	var GHASH = __webpack_require__(1302)
	var xor = __webpack_require__(165)
	inherits(StreamCipher, Transform)
	module.e = StreamCipher
	
	function StreamCipher (mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv)
	  }
	  Transform.call(this)
	  this._finID = Buffer.concat([iv, new Buffer([0, 0, 0, 1])])
	  iv = Buffer.concat([iv, new Buffer([0, 0, 0, 2])])
	  this._cipher = new aes.AES(key)
	  this._prev = new Buffer(iv.length)
	  this._cache = new Buffer('')
	  this._secCache = new Buffer('')
	  this._decrypt = decrypt
	  this._alen = 0
	  this._len = 0
	  iv.copy(this._prev)
	  this._mode = mode
	  var h = new Buffer(4)
	  h.fill(0)
	  this._ghash = new GHASH(this._cipher.encryptBlock(h))
	  this._authTag = null
	  this._called = false
	}
	StreamCipher.prototype._update = function (chunk) {
	  if (!this._called && this._alen) {
	    var rump = 16 - (this._alen % 16)
	    if (rump < 16) {
	      rump = new Buffer(rump)
	      rump.fill(0)
	      this._ghash.update(rump)
	    }
	  }
	  this._called = true
	  var out = this._mode.encrypt(this, chunk)
	  if (this._decrypt) {
	    this._ghash.update(chunk)
	  } else {
	    this._ghash.update(out)
	  }
	  this._len += chunk.length
	  return out
	}
	StreamCipher.prototype._final = function () {
	  if (this._decrypt && !this._authTag) {
	    throw new Error('Unsupported state or unable to authenticate data')
	  }
	  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
	  if (this._decrypt) {
	    if (xorTest(tag, this._authTag)) {
	      throw new Error('Unsupported state or unable to authenticate data')
	    }
	  } else {
	    this._authTag = tag
	  }
	  this._cipher.scrub()
	}
	StreamCipher.prototype.getAuthTag = function getAuthTag () {
	  if (!this._decrypt && Buffer.isBuffer(this._authTag)) {
	    return this._authTag
	  } else {
	    throw new Error('Attempting to get auth tag in unsupported state')
	  }
	}
	StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
	  if (this._decrypt) {
	    this._authTag = tag
	  } else {
	    throw new Error('Attempting to set auth tag in unsupported state')
	  }
	}
	StreamCipher.prototype.setAAD = function setAAD (buf) {
	  if (!this._called) {
	    this._ghash.update(buf)
	    this._alen += buf.length
	  } else {
	    throw new Error('Attempting to set AAD in unsupported state')
	  }
	}
	function xorTest (a, b) {
	  var out = 0
	  if (a.length !== b.length) {
	    out++
	  }
	  var len = Math.min(a.length, b.length)
	  var i = -1
	  while (++i < len) {
	    out += (a[i] ^ b[i])
	  }
	  return out
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var xor = __webpack_require__(165)
	
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev)
	
	  self._prev = self._cipher.encryptBlock(data)
	  return self._prev
	}
	
	exports.decrypt = function (self, block) {
	  var pad = self._prev
	
	  self._prev = block
	  var out = self._cipher.decryptBlock(block)
	
	  return xor(out, pad)
	}
	


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var xor = __webpack_require__(165)
	
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('')
	  var len
	
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev)
	      self._prev = new Buffer('')
	    }
	
	    if (self._cache.length <= data.length) {
	      len = self._cache.length
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
	      data = data.slice(len)
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
	      break
	    }
	  }
	
	  return out
	}
	function encryptStart (self, data, decrypt) {
	  var len = data.length
	  var out = xor(data, self._cache)
	  self._cache = self._cache.slice(len)
	  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
	  return out
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	function encryptByte (self, byteParam, decrypt) {
	  var pad
	  var i = -1
	  var len = 8
	  var out = 0
	  var bit, value
	  while (++i < len) {
	    pad = self._cipher.encryptBlock(self._prev)
	    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
	    value = pad[0] ^ bit
	    out += ((value & 0x80) >> (i % 8))
	    self._prev = shiftIn(self._prev, decrypt ? bit : value)
	  }
	  return out
	}
	exports.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length
	  var out = new Buffer(len)
	  var i = -1
	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt)
	  }
	  return out
	}
	function shiftIn (buffer, value) {
	  var len = buffer.length
	  var i = -1
	  var out = new Buffer(buffer.length)
	  buffer = Buffer.concat([buffer, new Buffer([value])])
	  while (++i < len) {
	    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
	  }
	  return out
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	function encryptByte (self, byteParam, decrypt) {
	  var pad = self._cipher.encryptBlock(self._prev)
	  var out = pad[0] ^ byteParam
	  self._prev = Buffer.concat([self._prev.slice(1), new Buffer([decrypt ? byteParam : out])])
	  return out
	}
	exports.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length
	  var out = new Buffer(len)
	  var i = -1
	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt)
	  }
	  return out
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block)
	}
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block)
	}
	


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var xor = __webpack_require__(165)
	
	function getBlock (self) {
	  self._prev = self._cipher.encryptBlock(self._prev)
	  return self._prev
	}
	
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)])
	  }
	
	  var pad = self._cache.slice(0, chunk.length)
	  self._cache = self._cache.slice(chunk.length)
	  return xor(chunk, pad)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var aes = __webpack_require__(206)
	var Transform = __webpack_require__(146)
	var inherits = __webpack_require__(27)
	
	inherits(StreamCipher, Transform)
	module.e = StreamCipher
	function StreamCipher (mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv)
	  }
	  Transform.call(this)
	  this._cipher = new aes.AES(key)
	  this._prev = new Buffer(iv.length)
	  this._cache = new Buffer('')
	  this._secCache = new Buffer('')
	  this._decrypt = decrypt
	  iv.copy(this._prev)
	  this._mode = mode
	}
	StreamCipher.prototype._update = function (chunk) {
	  return this._mode.encrypt(this, chunk, this._decrypt)
	}
	StreamCipher.prototype._final = function () {
	  this._cipher.scrub()
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict'
	exports['RSA-SHA224'] = exports.sha224WithRSAEncryption = {
	  sign: 'rsa',
	  hash: 'sha224',
	  id: new Buffer('302d300d06096086480165030402040500041c', 'hex')
	}
	exports['RSA-SHA256'] = exports.sha256WithRSAEncryption = {
	  sign: 'rsa',
	  hash: 'sha256',
	  id: new Buffer('3031300d060960864801650304020105000420', 'hex')
	}
	exports['RSA-SHA384'] = exports.sha384WithRSAEncryption = {
	  sign: 'rsa',
	  hash: 'sha384',
	  id: new Buffer('3041300d060960864801650304020205000430', 'hex')
	}
	exports['RSA-SHA512'] = exports.sha512WithRSAEncryption = {
	  sign: 'rsa',
	  hash: 'sha512',
	  id: new Buffer('3051300d060960864801650304020305000440', 'hex')
	}
	exports['RSA-SHA1'] = {
	  sign: 'rsa',
	  hash: 'sha1',
	  id: new Buffer('3021300906052b0e03021a05000414', 'hex')
	}
	exports['ecdsa-with-SHA1'] = {
	  sign: 'ecdsa',
	  hash: 'sha1',
	  id: new Buffer('', 'hex')
	}
	
	exports.DSA = exports['DSA-SHA1'] = exports['DSA-SHA'] = {
	  sign: 'dsa',
	  hash: 'sha1',
	  id: new Buffer('', 'hex')
	}
	exports['DSA-SHA224'] = exports['DSA-WITH-SHA224'] = {
	  sign: 'dsa',
	  hash: 'sha224',
	  id: new Buffer('', 'hex')
	}
	exports['DSA-SHA256'] = exports['DSA-WITH-SHA256'] = {
	  sign: 'dsa',
	  hash: 'sha256',
	  id: new Buffer('', 'hex')
	}
	exports['DSA-SHA384'] = exports['DSA-WITH-SHA384'] = {
	  sign: 'dsa',
	  hash: 'sha384',
	  id: new Buffer('', 'hex')
	}
	exports['DSA-SHA512'] = exports['DSA-WITH-SHA512'] = {
	  sign: 'dsa',
	  hash: 'sha512',
	  id: new Buffer('', 'hex')
	}
	exports['DSA-RIPEMD160'] = {
	  sign: 'dsa',
	  hash: 'rmd160',
	  id: new Buffer('', 'hex')
	}
	exports['RSA-RIPEMD160'] = exports.ripemd160WithRSA = {
	  sign: 'rsa',
	  hash: 'rmd160',
	  id: new Buffer('3021300906052b2403020105000414', 'hex')
	}
	exports['RSA-MD5'] = exports.md5WithRSAEncryption = {
	  sign: 'rsa',
	  hash: 'md5',
	  id: new Buffer('3020300c06082a864886f70d020505000410', 'hex')
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict'
	exports['1.3.132.0.10'] = 'secp256k1'
	
	exports['1.3.132.0.33'] = 'p224'
	
	exports['1.2.840.10045.3.1.1'] = 'p192'
	
	exports['1.2.840.10045.3.1.7'] = 'p256'
	
	exports['1.3.132.0.34'] = 'p384'
	
	exports['1.3.132.0.35'] = 'p521'
	


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*!
	 * Chart.js
	 * http://chartjs.org/
	 * Version: 1.0.2
	 *
	 * Copyright 2015 Nick Downie
	 * Released under the MIT license
	 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
	 */
	
	
	(function(){
	
		"use strict";
	
		//Declare root variable - window in the browser, global on the server
		var root = this,
			previous = root.Chart;
	
		//Occupy the global variable of Chart, and create a simple base class
		var Chart = function(context){
			var chart = this;
			this.canvas = context.canvas;
	
			this.ctx = context;
	
			//Variables global to the chart
			var computeDimension = function(element,dimension)
			{
				if (element['offset'+dimension])
				{
					return element['offset'+dimension];
				}
				else
				{
					return document.defaultView.getComputedStyle(element).getPropertyValue(dimension);
				}
			}
	
			var width = this.width = computeDimension(context.canvas,'Width');
			var height = this.height = computeDimension(context.canvas,'Height');
	
			// Firefox requires this to work correctly
			context.canvas.width  = width;
			context.canvas.height = height;
	
			var width = this.width = context.canvas.width;
			var height = this.height = context.canvas.height;
			this.aspectRatio = this.width / this.height;
			//High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
			helpers.retinaScale(this);
	
			return this;
		};
		//Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				// Boolean - Whether to animate the chart
				animation: true,
	
				// Number - Number of animation steps
				animationSteps: 60,
	
				// String - Animation easing effect
				animationEasing: "easeOutQuart",
	
				// Boolean - If we should show the scale at all
				showScale: true,
	
				// Boolean - If we want to override with a hard coded scale
				scaleOverride: false,
	
				// ** Required if scaleOverride is true **
				// Number - The number of steps in a hard coded scale
				scaleSteps: null,
				// Number - The value jump in the hard coded scale
				scaleStepWidth: null,
				// Number - The scale starting value
				scaleStartValue: null,
	
				// String - Colour of the scale line
				scaleLineColor: "rgba(0,0,0,.1)",
	
				// Number - Pixel width of the scale line
				scaleLineWidth: 1,
	
				// Boolean - Whether to show labels on the scale
				scaleShowLabels: true,
	
				// Interpolated JS string - can access value
				scaleLabel: "<%=value%>",
	
				// Boolean - Whether the scale should stick to integers, and not show any floats even if drawing space is there
				scaleIntegersOnly: true,
	
				// Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
				scaleBeginAtZero: false,
	
				// String - Scale label font declaration for the scale label
				scaleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	
				// Number - Scale label font size in pixels
				scaleFontSize: 12,
	
				// String - Scale label font weight style
				scaleFontStyle: "normal",
	
				// String - Scale label font colour
				scaleFontColor: "#666",
	
				// Boolean - whether or not the chart should be responsive and resize when the browser does.
				responsive: false,
	
				// Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
				maintainAspectRatio: true,
	
				// Boolean - Determines whether to draw tooltips on the canvas or not - attaches events to touchmove & mousemove
				showTooltips: true,
	
				// Boolean - Determines whether to draw built-in tooltip or call custom tooltip function
				customTooltips: false,
	
				// Array - Array of string names to attach tooltip events
				tooltipEvents: ["mousemove", "touchstart", "touchmove", "mouseout"],
	
				// String - Tooltip background colour
				tooltipFillColor: "rgba(0,0,0,0.8)",
	
				// String - Tooltip label font declaration for the scale label
				tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	
				// Number - Tooltip label font size in pixels
				tooltipFontSize: 14,
	
				// String - Tooltip font weight style
				tooltipFontStyle: "normal",
	
				// String - Tooltip label font colour
				tooltipFontColor: "#fff",
	
				// String - Tooltip title font declaration for the scale label
				tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	
				// Number - Tooltip title font size in pixels
				tooltipTitleFontSize: 14,
	
				// String - Tooltip title font weight style
				tooltipTitleFontStyle: "bold",
	
				// String - Tooltip title font colour
				tooltipTitleFontColor: "#fff",
	
				// Number - pixel width of padding around tooltip text
				tooltipYPadding: 6,
	
				// Number - pixel width of padding around tooltip text
				tooltipXPadding: 6,
	
				// Number - Size of the caret on the tooltip
				tooltipCaretSize: 8,
	
				// Number - Pixel radius of the tooltip border
				tooltipCornerRadius: 6,
	
				// Number - Pixel offset from point x to tooltip edge
				tooltipXOffset: 10,
	
				// String - Template string for single tooltips
				tooltipTemplate: "<%if (label){%><%=label%>: <%}%><%= value %>",
	
				// String - Template string for single tooltips
				multiTooltipTemplate: "<%= value %>",
	
				// String - Colour behind the legend colour block
				multiTooltipKeyBackground: '#fff',
	
				// Function - Will fire on animation progression.
				onAnimationProgress: function(){},
	
				// Function - Will fire on animation completion.
				onAnimationComplete: function(){}
	
			}
		};
	
		//Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		//Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
			//-- Basic js utility methods
		var each = helpers.each = function(loopable,callback,self){
				var additionalArgs = Array.prototype.slice.call(arguments, 3);
				// Check to see if null or undefined firstly.
				if (loopable){
					if (loopable.length === +loopable.length){
						var i;
						for (i=0; i<loopable.length; i++){
							callback.apply(self,[loopable[i], i].concat(additionalArgs));
						}
					}
					else{
						for (var item in loopable){
							callback.apply(self,[loopable[item],item].concat(additionalArgs));
						}
					}
				}
			},
			clone = helpers.clone = function(obj){
				var objClone = {};
				each(obj,function(value,key){
					if (obj.hasOwnProperty(key)) objClone[key] = value;
				});
				return objClone;
			},
			extend = helpers.extend = function(base){
				each(Array.prototype.slice.call(arguments,1), function(extensionObject) {
					each(extensionObject,function(value,key){
						if (extensionObject.hasOwnProperty(key)) base[key] = value;
					});
				});
				return base;
			},
			merge = helpers.merge = function(base,master){
				//Merge properties in left object over to a shallow clone of object right.
				var args = Array.prototype.slice.call(arguments,0);
				args.unshift({});
				return extend.apply(null, args);
			},
			indexOf = helpers.indexOf = function(arrayToSearch, item){
				if (Array.prototype.indexOf) {
					return arrayToSearch.indexOf(item);
				}
				else{
					for (var i = 0; i < arrayToSearch.length; i++) {
						if (arrayToSearch[i] === item) return i;
					}
					return -1;
				}
			},
			where = helpers.where = function(collection, filterCallback){
				var filtered = [];
	
				helpers.each(collection, function(item){
					if (filterCallback(item)){
						filtered.push(item);
					}
				});
	
				return filtered;
			},
			findNextWhere = helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex){
				// Default to start of the array
				if (!startIndex){
					startIndex = -1;
				}
				for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
					var currentItem = arrayToSearch[i];
					if (filterCallback(currentItem)){
						return currentItem;
					}
				}
			},
			findPreviousWhere = helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex){
				// Default to end of the array
				if (!startIndex){
					startIndex = arrayToSearch.length;
				}
				for (var i = startIndex - 1; i >= 0; i--) {
					var currentItem = arrayToSearch[i];
					if (filterCallback(currentItem)){
						return currentItem;
					}
				}
			},
			inherits = helpers.inherits = function(extensions){
				//Basic javascript inheritance based on the model created in Backbone.js
				var parent = this;
				var ChartElement = (extensions && extensions.hasOwnProperty("constructor")) ? extensions.constructor : function(){ return parent.apply(this, arguments); };
	
				var Surrogate = function(){ this.constructor = ChartElement;};
				Surrogate.prototype = parent.prototype;
				ChartElement.prototype = new Surrogate();
	
				ChartElement.extend = inherits;
	
				if (extensions) extend(ChartElement.prototype, extensions);
	
				ChartElement.__super__ = parent.prototype;
	
				return ChartElement;
			},
			noop = helpers.noop = function(){},
			uid = helpers.uid = (function(){
				var id=0;
				return function(){
					return "chart-" + id++;
				};
			})(),
			warn = helpers.warn = function(str){
				//Method for warning of errors
				if (window.console && typeof window.console.warn == "function") console.warn(str);
			},
			amd = helpers.amd = ("function" == 'function' && __webpack_require__(1762)),
			//-- Math methods
			isNumber = helpers.isNumber = function(n){
				return !isNaN(parseFloat(n)) && isFinite(n);
			},
			max = helpers.max = function(array){
				return Math.max.apply( Math, array );
			},
			min = helpers.min = function(array){
				return Math.min.apply( Math, array );
			},
			cap = helpers.cap = function(valueToCap,maxValue,minValue){
				if(isNumber(maxValue)) {
					if( valueToCap > maxValue ) {
						return maxValue;
					}
				}
				else if(isNumber(minValue)){
					if ( valueToCap < minValue ){
						return minValue;
					}
				}
				return valueToCap;
			},
			getDecimalPlaces = helpers.getDecimalPlaces = function(num){
				if (num%1!==0 && isNumber(num)){
					return num.toString().split(".")[1].length;
				}
				else {
					return 0;
				}
			},
			toRadians = helpers.radians = function(degrees){
				return degrees * (Math.PI/180);
			},
			// Gets the angle from vertical upright to the point about a centre.
			getAngleFromPoint = helpers.getAngleFromPoint = function(centrePoint, anglePoint){
				var distanceFromXCenter = anglePoint.x - centrePoint.x,
					distanceFromYCenter = anglePoint.y - centrePoint.y,
					radialDistanceFromCenter = Math.sqrt( distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
	
				var angle = Math.PI * 2 + Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
				//If the segment is in the top left quadrant, we need to add another rotation to the angle
				if (distanceFromXCenter < 0 && distanceFromYCenter < 0){
					angle += Math.PI*2;
				}
	
				return {
					angle: angle,
					distance: radialDistanceFromCenter
				};
			},
			aliasPixel = helpers.aliasPixel = function(pixelWidth){
				return (pixelWidth % 2 === 0) ? 0 : 0.5;
			},
			splineCurve = helpers.splineCurve = function(FirstPoint,MiddlePoint,AfterPoint,t){
				//Props to Rob Spencer at scaled innovation for his post on splining between points
				//http://scaledinnovation.com/analytics/splines/aboutSplines.html
				var d01=Math.sqrt(Math.pow(MiddlePoint.x-FirstPoint.x,2)+Math.pow(MiddlePoint.y-FirstPoint.y,2)),
					d12=Math.sqrt(Math.pow(AfterPoint.x-MiddlePoint.x,2)+Math.pow(AfterPoint.y-MiddlePoint.y,2)),
					fa=t*d01/(d01+d12),// scaling factor for triangle Ta
					fb=t*d12/(d01+d12);
				return {
					inner : {
						x : MiddlePoint.x-fa*(AfterPoint.x-FirstPoint.x),
						y : MiddlePoint.y-fa*(AfterPoint.y-FirstPoint.y)
					},
					outer : {
						x: MiddlePoint.x+fb*(AfterPoint.x-FirstPoint.x),
						y : MiddlePoint.y+fb*(AfterPoint.y-FirstPoint.y)
					}
				};
			},
			calculateOrderOfMagnitude = helpers.calculateOrderOfMagnitude = function(val){
				return Math.floor(Math.log(val) / Math.LN10);
			},
			calculateScaleRange = helpers.calculateScaleRange = function(valuesArray, drawingSize, textSize, startFromZero, integersOnly){
	
				//Set a minimum step of two - a point at the top of the graph, and a point at the base
				var minSteps = 2,
					maxSteps = Math.floor(drawingSize/(textSize * 1.5)),
					skipFitting = (minSteps >= maxSteps);
	
				var maxValue = max(valuesArray),
					minValue = min(valuesArray);
	
				// We need some degree of seperation here to calculate the scales if all the values are the same
				// Adding/minusing 0.5 will give us a range of 1.
				if (maxValue === minValue){
					maxValue += 0.5;
					// So we don't end up with a graph with a negative start value if we've said always start from zero
					if (minValue >= 0.5 && !startFromZero){
						minValue -= 0.5;
					}
					else{
						// Make up a whole number above the values
						maxValue += 0.5;
					}
				}
	
				var	valueRange = Math.abs(maxValue - minValue),
					rangeOrderOfMagnitude = calculateOrderOfMagnitude(valueRange),
					graphMax = Math.ceil(maxValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
					graphMin = (startFromZero) ? 0 : Math.floor(minValue / (1 * Math.pow(10, rangeOrderOfMagnitude))) * Math.pow(10, rangeOrderOfMagnitude),
					graphRange = graphMax - graphMin,
					stepValue = Math.pow(10, rangeOrderOfMagnitude),
					numberOfSteps = Math.round(graphRange / stepValue);
	
				//If we have more space on the graph we'll use it to give more definition to the data
				while((numberOfSteps > maxSteps || (numberOfSteps * 2) < maxSteps) && !skipFitting) {
					if(numberOfSteps > maxSteps){
						stepValue *=2;
						numberOfSteps = Math.round(graphRange/stepValue);
						// Don't ever deal with a decimal number of steps - cancel fitting and just use the minimum number of steps.
						if (numberOfSteps % 1 !== 0){
							skipFitting = true;
						}
					}
					//We can fit in double the amount of scale points on the scale
					else{
						//If user has declared ints only, and the step value isn't a decimal
						if (integersOnly && rangeOrderOfMagnitude >= 0){
							//If the user has said integers only, we need to check that making the scale more granular wouldn't make it a float
							if(stepValue/2 % 1 === 0){
								stepValue /=2;
								numberOfSteps = Math.round(graphRange/stepValue);
							}
							//If it would make it a float break out of the loop
							else{
								break;
							}
						}
						//If the scale doesn't have to be an int, make the scale more granular anyway.
						else{
							stepValue /=2;
							numberOfSteps = Math.round(graphRange/stepValue);
						}
	
					}
				}
	
				if (skipFitting){
					numberOfSteps = minSteps;
					stepValue = graphRange / numberOfSteps;
				}
	
				return {
					steps : numberOfSteps,
					stepValue : stepValue,
					min : graphMin,
					max	: graphMin + (numberOfSteps * stepValue)
				};
	
			},
			/* jshint ignore:start */
			// Blows up jshint errors based on the new Function constructor
			//Templating methods
			//Javascript micro templating by John Resig - source at http://ejohn.org/blog/javascript-micro-templating/
			template = helpers.template = function(templateString, valuesObject){
	
				// If templateString is function rather than string-template - call the function for valuesObject
	
				if(templateString instanceof Function){
				 	return templateString(valuesObject);
			 	}
	
				var cache = {};
				function tmpl(str, data){
					// Figure out if we're getting a template, or if we need to
					// load the template - and be sure to cache the result.
					var fn = !/\W/.test(str) ?
					cache[str] = cache[str] :
	
					// Generate a reusable function that will serve as a template
					// generator (and which will be cached).
					new Function("obj",
						"var p=[],print=function(){p.push.apply(p,arguments);};" +
	
						// Introduce the data as local variables using with(){}
						"with(obj){p.push('" +
	
						// Convert the template into pure JavaScript
						str
							.replace(/[\r\t\n]/g, " ")
							.split("<%").join("\t")
							.replace(/((^|%>)[^\t]*)'/g, "$1\r")
							.replace(/\t=(.*?)%>/g, "',$1,'")
							.split("\t").join("');")
							.split("%>").join("p.push('")
							.split("\r").join("\\'") +
						"');}return p.join('');"
					);
	
					// Provide some basic currying to the user
					return data ? fn( data ) : fn;
				}
				return tmpl(templateString,valuesObject);
			},
			/* jshint ignore:end */
			generateLabels = helpers.generateLabels = function(templateString,numberOfSteps,graphMin,stepValue){
				var labelsArray = new Array(numberOfSteps);
				if (labelTemplateString){
					each(labelsArray,function(val,index){
						labelsArray[index] = template(templateString,{value: (graphMin + (stepValue*(index+1)))});
					});
				}
				return labelsArray;
			},
			//--Animation methods
			//Easing functions adapted from Robert Penner's easing equations
			//http://www.robertpenner.com/easing/
			easingEffects = helpers.easingEffects = {
				linear: function (t) {
					return t;
				},
				easeInQuad: function (t) {
					return t * t;
				},
				easeOutQuad: function (t) {
					return -1 * t * (t - 2);
				},
				easeInOutQuad: function (t) {
					if ((t /= 1 / 2) < 1) return 1 / 2 * t * t;
					return -1 / 2 * ((--t) * (t - 2) - 1);
				},
				easeInCubic: function (t) {
					return t * t * t;
				},
				easeOutCubic: function (t) {
					return 1 * ((t = t / 1 - 1) * t * t + 1);
				},
				easeInOutCubic: function (t) {
					if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t;
					return 1 / 2 * ((t -= 2) * t * t + 2);
				},
				easeInQuart: function (t) {
					return t * t * t * t;
				},
				easeOutQuart: function (t) {
					return -1 * ((t = t / 1 - 1) * t * t * t - 1);
				},
				easeInOutQuart: function (t) {
					if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t * t;
					return -1 / 2 * ((t -= 2) * t * t * t - 2);
				},
				easeInQuint: function (t) {
					return 1 * (t /= 1) * t * t * t * t;
				},
				easeOutQuint: function (t) {
					return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
				},
				easeInOutQuint: function (t) {
					if ((t /= 1 / 2) < 1) return 1 / 2 * t * t * t * t * t;
					return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
				},
				easeInSine: function (t) {
					return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
				},
				easeOutSine: function (t) {
					return 1 * Math.sin(t / 1 * (Math.PI / 2));
				},
				easeInOutSine: function (t) {
					return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
				},
				easeInExpo: function (t) {
					return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
				},
				easeOutExpo: function (t) {
					return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
				},
				easeInOutExpo: function (t) {
					if (t === 0) return 0;
					if (t === 1) return 1;
					if ((t /= 1 / 2) < 1) return 1 / 2 * Math.pow(2, 10 * (t - 1));
					return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
				},
				easeInCirc: function (t) {
					if (t >= 1) return t;
					return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
				},
				easeOutCirc: function (t) {
					return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
				},
				easeInOutCirc: function (t) {
					if ((t /= 1 / 2) < 1) return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
					return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
				},
				easeInElastic: function (t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0) return 0;
					if ((t /= 1) == 1) return 1;
					if (!p) p = 1 * 0.3;
					if (a < Math.abs(1)) {
						a = 1;
						s = p / 4;
					} else s = p / (2 * Math.PI) * Math.asin(1 / a);
					return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				},
				easeOutElastic: function (t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0) return 0;
					if ((t /= 1) == 1) return 1;
					if (!p) p = 1 * 0.3;
					if (a < Math.abs(1)) {
						a = 1;
						s = p / 4;
					} else s = p / (2 * Math.PI) * Math.asin(1 / a);
					return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
				},
				easeInOutElastic: function (t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0) return 0;
					if ((t /= 1 / 2) == 2) return 1;
					if (!p) p = 1 * (0.3 * 1.5);
					if (a < Math.abs(1)) {
						a = 1;
						s = p / 4;
					} else s = p / (2 * Math.PI) * Math.asin(1 / a);
					if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
					return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
				},
				easeInBack: function (t) {
					var s = 1.70158;
					return 1 * (t /= 1) * t * ((s + 1) * t - s);
				},
				easeOutBack: function (t) {
					var s = 1.70158;
					return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
				},
				easeInOutBack: function (t) {
					var s = 1.70158;
					if ((t /= 1 / 2) < 1) return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
					return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
				},
				easeInBounce: function (t) {
					return 1 - easingEffects.easeOutBounce(1 - t);
				},
				easeOutBounce: function (t) {
					if ((t /= 1) < (1 / 2.75)) {
						return 1 * (7.5625 * t * t);
					} else if (t < (2 / 2.75)) {
						return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
					} else if (t < (2.5 / 2.75)) {
						return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
					} else {
						return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
					}
				},
				easeInOutBounce: function (t) {
					if (t < 1 / 2) return easingEffects.easeInBounce(t * 2) * 0.5;
					return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
				}
			},
			//Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
			requestAnimFrame = helpers.requestAnimFrame = (function(){
				return window.requestAnimationFrame ||
					window.webkitRequestAnimationFrame ||
					window.mozRequestAnimationFrame ||
					window.oRequestAnimationFrame ||
					window.msRequestAnimationFrame ||
					function(callback) {
						return window.setTimeout(callback, 1000 / 60);
					};
			})(),
			cancelAnimFrame = helpers.cancelAnimFrame = (function(){
				return window.cancelAnimationFrame ||
					window.webkitCancelAnimationFrame ||
					window.mozCancelAnimationFrame ||
					window.oCancelAnimationFrame ||
					window.msCancelAnimationFrame ||
					function(callback) {
						return window.clearTimeout(callback, 1000 / 60);
					};
			})(),
			animationLoop = helpers.animationLoop = function(callback,totalSteps,easingString,onProgress,onComplete,chartInstance){
	
				var currentStep = 0,
					easingFunction = easingEffects[easingString] || easingEffects.linear;
	
				var animationFrame = function(){
					currentStep++;
					var stepDecimal = currentStep/totalSteps;
					var easeDecimal = easingFunction(stepDecimal);
	
					callback.call(chartInstance,easeDecimal,stepDecimal, currentStep);
					onProgress.call(chartInstance,easeDecimal,stepDecimal);
					if (currentStep < totalSteps){
						chartInstance.animationFrame = requestAnimFrame(animationFrame);
					} else{
						onComplete.apply(chartInstance);
					}
				};
				requestAnimFrame(animationFrame);
			},
			//-- DOM methods
			getRelativePosition = helpers.getRelativePosition = function(evt){
				var mouseX, mouseY;
				var e = evt.originalEvent || evt,
					canvas = evt.currentTarget || evt.srcElement,
					boundingRect = canvas.getBoundingClientRect();
	
				if (e.touches){
					mouseX = e.touches[0].clientX - boundingRect.left;
					mouseY = e.touches[0].clientY - boundingRect.top;
	
				}
				else{
					mouseX = e.clientX - boundingRect.left;
					mouseY = e.clientY - boundingRect.top;
				}
	
				return {
					x : mouseX,
					y : mouseY
				};
	
			},
			addEvent = helpers.addEvent = function(node,eventType,method){
				if (node.addEventListener){
					node.addEventListener(eventType,method);
				} else if (node.attachEvent){
					node.attachEvent("on"+eventType, method);
				} else {
					node["on"+eventType] = method;
				}
			},
			removeEvent = helpers.removeEvent = function(node, eventType, handler){
				if (node.removeEventListener){
					node.removeEventListener(eventType, handler, false);
				} else if (node.detachEvent){
					node.detachEvent("on"+eventType,handler);
				} else{
					node["on" + eventType] = noop;
				}
			},
			bindEvents = helpers.bindEvents = function(chartInstance, arrayOfEvents, handler){
				// Create the events object if it's not already present
				if (!chartInstance.events) chartInstance.events = {};
	
				each(arrayOfEvents,function(eventName){
					chartInstance.events[eventName] = function(){
						handler.apply(chartInstance, arguments);
					};
					addEvent(chartInstance.chart.canvas,eventName,chartInstance.events[eventName]);
				});
			},
			unbindEvents = helpers.unbindEvents = function (chartInstance, arrayOfEvents) {
				each(arrayOfEvents, function(handler,eventName){
					removeEvent(chartInstance.chart.canvas, eventName, handler);
				});
			},
			getMaximumWidth = helpers.getMaximumWidth = function(domNode){
				var container = domNode.parentNode;
				// TODO = check cross browser stuff with this.
				return container.clientWidth;
			},
			getMaximumHeight = helpers.getMaximumHeight = function(domNode){
				var container = domNode.parentNode;
				// TODO = check cross browser stuff with this.
				return container.clientHeight;
			},
			getMaximumSize = helpers.getMaximumSize = helpers.getMaximumWidth, // legacy support
			retinaScale = helpers.retinaScale = function(chart){
				var ctx = chart.ctx,
					width = chart.canvas.width,
					height = chart.canvas.height;
	
				if (window.devicePixelRatio) {
					ctx.canvas.style.width = width + "px";
					ctx.canvas.style.height = height + "px";
					ctx.canvas.height = height * window.devicePixelRatio;
					ctx.canvas.width = width * window.devicePixelRatio;
					ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
				}
			},
			//-- Canvas methods
			clear = helpers.clear = function(chart){
				chart.ctx.clearRect(0,0,chart.width,chart.height);
			},
			fontString = helpers.fontString = function(pixelSize,fontStyle,fontFamily){
				return fontStyle + " " + pixelSize+"px " + fontFamily;
			},
			longestText = helpers.longestText = function(ctx,font,arrayOfStrings){
				ctx.font = font;
				var longest = 0;
				each(arrayOfStrings,function(string){
					var textWidth = ctx.measureText(string).width;
					longest = (textWidth > longest) ? textWidth : longest;
				});
				return longest;
			},
			drawRoundedRectangle = helpers.drawRoundedRectangle = function(ctx,x,y,width,height,radius){
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
			};
	
	
		//Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		//Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		Chart.Type = function(data,options,chart){
			this.options = options;
			this.chart = chart;
			this.id = uid();
			//Add the chart instance to the global namespace
			Chart.instances[this.id] = this;
	
			// Initialize is always called when a chart type is created
			// By default it is a no op, but it should be extended
			if (options.responsive){
				this.resize();
			}
			this.initialize.call(this,data);
		};
	
		//Core methods that'll be a part of every chart type
		extend(Chart.Type.prototype,{
			initialize : function(){return this;},
			clear : function(){
				clear(this.chart);
				return this;
			},
			stop : function(){
				// Stops any current animation loop occuring
				cancelAnimFrame(this.animationFrame);
				return this;
			},
			resize : function(callback){
				this.stop();
				var canvas = this.chart.canvas,
					newWidth = getMaximumWidth(this.chart.canvas),
					newHeight = this.options.maintainAspectRatio ? newWidth / this.chart.aspectRatio : getMaximumHeight(this.chart.canvas);
	
				canvas.width = this.chart.width = newWidth;
				canvas.height = this.chart.height = newHeight;
	
				retinaScale(this.chart);
	
				if (typeof callback === "function"){
					callback.apply(this, Array.prototype.slice.call(arguments, 1));
				}
				return this;
			},
			reflow : noop,
			render : function(reflow){
				if (reflow){
					this.reflow();
				}
				if (this.options.animation && !reflow){
					helpers.animationLoop(
						this.draw,
						this.options.animationSteps,
						this.options.animationEasing,
						this.options.onAnimationProgress,
						this.options.onAnimationComplete,
						this
					);
				}
				else{
					this.draw();
					this.options.onAnimationComplete.call(this);
				}
				return this;
			},
			generateLegend : function(){
				return template(this.options.legendTemplate,this);
			},
			destroy : function(){
				this.clear();
				unbindEvents(this, this.events);
				var canvas = this.chart.canvas;
	
				// Reset canvas height/width attributes starts a fresh with the canvas context
				canvas.width = this.chart.width;
				canvas.height = this.chart.height;
	
				// < IE9 doesn't support removeProperty
				if (canvas.style.removeProperty) {
					canvas.style.removeProperty('width');
					canvas.style.removeProperty('height');
				} else {
					canvas.style.removeAttribute('width');
					canvas.style.removeAttribute('height');
				}
	
				delete Chart.instances[this.id];
			},
			showTooltip : function(ChartElements, forceRedraw){
				// Only redraw the chart if we've actually changed what we're hovering on.
				if (typeof this.activeElements === 'undefined') this.activeElements = [];
	
				var isChanged = (function(Elements){
					var changed = false;
	
					if (Elements.length !== this.activeElements.length){
						changed = true;
						return changed;
					}
	
					each(Elements, function(element, index){
						if (element !== this.activeElements[index]){
							changed = true;
						}
					}, this);
					return changed;
				}).call(this, ChartElements);
	
				if (!isChanged && !forceRedraw){
					return;
				}
				else{
					this.activeElements = ChartElements;
				}
				this.draw();
				if(this.options.customTooltips){
					this.options.customTooltips(false);
				}
				if (ChartElements.length > 0){
					// If we have multiple datasets, show a MultiTooltip for all of the data points at that index
					if (this.datasets && this.datasets.length > 1) {
						var dataArray,
							dataIndex;
	
						for (var i = this.datasets.length - 1; i >= 0; i--) {
							dataArray = this.datasets[i].points || this.datasets[i].bars || this.datasets[i].segments;
							dataIndex = indexOf(dataArray, ChartElements[0]);
							if (dataIndex !== -1){
								break;
							}
						}
						var tooltipLabels = [],
							tooltipColors = [],
							medianPosition = (function(index) {
	
								// Get all the points at that particular index
								var Elements = [],
									dataCollection,
									xPositions = [],
									yPositions = [],
									xMax,
									yMax,
									xMin,
									yMin;
								helpers.each(this.datasets, function(dataset){
									dataCollection = dataset.points || dataset.bars || dataset.segments;
									if (dataCollection[dataIndex] && dataCollection[dataIndex].hasValue()){
										Elements.push(dataCollection[dataIndex]);
									}
								});
	
								helpers.each(Elements, function(element) {
									xPositions.push(element.x);
									yPositions.push(element.y);
	
	
									//Include any colour information about the element
									tooltipLabels.push(helpers.template(this.options.multiTooltipTemplate, element));
									tooltipColors.push({
										fill: element._saved.fillColor || element.fillColor,
										stroke: element._saved.strokeColor || element.strokeColor
									});
	
								}, this);
	
								yMin = min(yPositions);
								yMax = max(yPositions);
	
								xMin = min(xPositions);
								xMax = max(xPositions);
	
								return {
									x: (xMin > this.chart.width/2) ? xMin : xMax,
									y: (yMin + yMax)/2
								};
							}).call(this, dataIndex);
	
						new Chart.MultiTooltip({
							x: medianPosition.x,
							y: medianPosition.y,
							xPadding: this.options.tooltipXPadding,
							yPadding: this.options.tooltipYPadding,
							xOffset: this.options.tooltipXOffset,
							fillColor: this.options.tooltipFillColor,
							textColor: this.options.tooltipFontColor,
							fontFamily: this.options.tooltipFontFamily,
							fontStyle: this.options.tooltipFontStyle,
							fontSize: this.options.tooltipFontSize,
							titleTextColor: this.options.tooltipTitleFontColor,
							titleFontFamily: this.options.tooltipTitleFontFamily,
							titleFontStyle: this.options.tooltipTitleFontStyle,
							titleFontSize: this.options.tooltipTitleFontSize,
							cornerRadius: this.options.tooltipCornerRadius,
							labels: tooltipLabels,
							legendColors: tooltipColors,
							legendColorBackground : this.options.multiTooltipKeyBackground,
							title: ChartElements[0].label,
							chart: this.chart,
							ctx: this.chart.ctx,
							custom: this.options.customTooltips
						}).draw();
	
					} else {
						each(ChartElements, function(Element) {
							var tooltipPosition = Element.tooltipPosition();
							new Chart.Tooltip({
								x: Math.round(tooltipPosition.x),
								y: Math.round(tooltipPosition.y),
								xPadding: this.options.tooltipXPadding,
								yPadding: this.options.tooltipYPadding,
								fillColor: this.options.tooltipFillColor,
								textColor: this.options.tooltipFontColor,
								fontFamily: this.options.tooltipFontFamily,
								fontStyle: this.options.tooltipFontStyle,
								fontSize: this.options.tooltipFontSize,
								caretHeight: this.options.tooltipCaretSize,
								cornerRadius: this.options.tooltipCornerRadius,
								text: template(this.options.tooltipTemplate, Element),
								chart: this.chart,
								custom: this.options.customTooltips
							}).draw();
						}, this);
					}
				}
				return this;
			},
			toBase64Image : function(){
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			}
		});
	
		Chart.Type.extend = function(extensions){
	
			var parent = this;
	
			var ChartType = function(){
				return parent.apply(this,arguments);
			};
	
			//Copy the prototype object of the this class
			ChartType.prototype = clone(parent.prototype);
			//Now overwrite some of the properties in the base class with the new extensions
			extend(ChartType.prototype, extensions);
	
			ChartType.extend = Chart.Type.extend;
	
			if (extensions.name || parent.prototype.name){
	
				var chartName = extensions.name || parent.prototype.name;
				//Assign any potential default values of the new chart type
	
				//If none are defined, we'll use a clone of the chart type this is being extended from.
				//I.e. if we extend a line chart, we'll use the defaults from the line chart if our new chart
				//doesn't define some defaults of their own.
	
				var baseDefaults = (Chart.defaults[parent.prototype.name]) ? clone(Chart.defaults[parent.prototype.name]) : {};
	
				Chart.defaults[chartName] = extend(baseDefaults,extensions.defaults);
	
				Chart.types[chartName] = ChartType;
	
				//Register this new chart type in the Chart prototype
				Chart.prototype[chartName] = function(data,options){
					var config = merge(Chart.defaults.global, Chart.defaults[chartName], options || {});
					return new ChartType(data,config,this);
				};
			} else{
				warn("Name not provided for this chart, so it hasn't been registered");
			}
			return parent;
		};
	
		Chart.Element = function(configuration){
			extend(this,configuration);
			this.initialize.apply(this,arguments);
			this.save();
		};
		extend(Chart.Element.prototype,{
			initialize : function(){},
			restore : function(props){
				if (!props){
					extend(this,this._saved);
				} else {
					each(props,function(key){
						this[key] = this._saved[key];
					},this);
				}
				return this;
			},
			save : function(){
				this._saved = clone(this);
				delete this._saved._saved;
				return this;
			},
			update : function(newProps){
				each(newProps,function(value,key){
					this._saved[key] = this[key];
					this[key] = value;
				},this);
				return this;
			},
			transition : function(props,ease){
				each(props,function(value,key){
					this[key] = ((value - this._saved[key]) * ease) + this._saved[key];
				},this);
				return this;
			},
			tooltipPosition : function(){
				return {
					x : this.x,
					y : this.y
				};
			},
			hasValue: function(){
				return isNumber(this.value);
			}
		});
	
		Chart.Element.extend = inherits;
	
	
		Chart.Point = Chart.Element.extend({
			display: true,
			inRange: function(chartX,chartY){
				var hitDetectionRange = this.hitDetectionRadius + this.radius;
				return ((Math.pow(chartX-this.x, 2)+Math.pow(chartY-this.y, 2)) < Math.pow(hitDetectionRange,2));
			},
			draw : function(){
				if (this.display){
					var ctx = this.ctx;
					ctx.beginPath();
	
					ctx.arc(this.x, this.y, this.radius, 0, Math.PI*2);
					ctx.closePath();
	
					ctx.strokeStyle = this.strokeColor;
					ctx.lineWidth = this.strokeWidth;
	
					ctx.fillStyle = this.fillColor;
	
					ctx.fill();
					ctx.stroke();
				}
	
	
				//Quick debug for bezier curve splining
				//Highlights control points and the line between them.
				//Handy for dev - stripped in the min version.
	
				// ctx.save();
				// ctx.fillStyle = "black";
				// ctx.strokeStyle = "black"
				// ctx.beginPath();
				// ctx.arc(this.controlPoints.inner.x,this.controlPoints.inner.y, 2, 0, Math.PI*2);
				// ctx.fill();
	
				// ctx.beginPath();
				// ctx.arc(this.controlPoints.outer.x,this.controlPoints.outer.y, 2, 0, Math.PI*2);
				// ctx.fill();
	
				// ctx.moveTo(this.controlPoints.inner.x,this.controlPoints.inner.y);
				// ctx.lineTo(this.x, this.y);
				// ctx.lineTo(this.controlPoints.outer.x,this.controlPoints.outer.y);
				// ctx.stroke();
	
				// ctx.restore();
	
	
	
			}
		});
	
		Chart.Arc = Chart.Element.extend({
			inRange : function(chartX,chartY){
	
				var pointRelativePosition = helpers.getAngleFromPoint(this, {
					x: chartX,
					y: chartY
				});
	
				//Check if within the range of the open/close angle
				var betweenAngles = (pointRelativePosition.angle >= this.startAngle && pointRelativePosition.angle <= this.endAngle),
					withinRadius = (pointRelativePosition.distance >= this.innerRadius && pointRelativePosition.distance <= this.outerRadius);
	
				return (betweenAngles && withinRadius);
				//Ensure within the outside of the arc centre, but inside arc outer
			},
			tooltipPosition : function(){
				var centreAngle = this.startAngle + ((this.endAngle - this.startAngle) / 2),
					rangeFromCentre = (this.outerRadius - this.innerRadius) / 2 + this.innerRadius;
				return {
					x : this.x + (Math.cos(centreAngle) * rangeFromCentre),
					y : this.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw : function(animationPercent){
	
				var easingDecimal = animationPercent || 1;
	
				var ctx = this.ctx;
	
				ctx.beginPath();
	
				ctx.arc(this.x, this.y, this.outerRadius, this.startAngle, this.endAngle);
	
				ctx.arc(this.x, this.y, this.innerRadius, this.endAngle, this.startAngle, true);
	
				ctx.closePath();
				ctx.strokeStyle = this.strokeColor;
				ctx.lineWidth = this.strokeWidth;
	
				ctx.fillStyle = this.fillColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (this.showStroke){
					ctx.stroke();
				}
			}
		});
	
		Chart.Rectangle = Chart.Element.extend({
			draw : function(){
				var ctx = this.ctx,
					halfWidth = this.width/2,
					leftX = this.x - halfWidth,
					rightX = this.x + halfWidth,
					top = this.base - (this.base - this.y),
					halfStroke = this.strokeWidth / 2;
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (this.showStroke){
					leftX += halfStroke;
					rightX -= halfStroke;
					top += halfStroke;
				}
	
				ctx.beginPath();
	
				ctx.fillStyle = this.fillColor;
				ctx.strokeStyle = this.strokeColor;
				ctx.lineWidth = this.strokeWidth;
	
				// It'd be nice to keep this class totally generic to any rectangle
				// and simply specify which border to miss out.
				ctx.moveTo(leftX, this.base);
				ctx.lineTo(leftX, top);
				ctx.lineTo(rightX, top);
				ctx.lineTo(rightX, this.base);
				ctx.fill();
				if (this.showStroke){
					ctx.stroke();
				}
			},
			height : function(){
				return this.base - this.y;
			},
			inRange : function(chartX,chartY){
				return (chartX >= this.x - this.width/2 && chartX <= this.x + this.width/2) && (chartY >= this.y && chartY <= this.base);
			}
		});
	
		Chart.Tooltip = Chart.Element.extend({
			draw : function(){
	
				var ctx = this.chart.ctx;
	
				ctx.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
	
				this.xAlign = "center";
				this.yAlign = "above";
	
				//Distance between the actual element.y position and the start of the tooltip caret
				var caretPadding = this.caretPadding = 2;
	
				var tooltipWidth = ctx.measureText(this.text).width + 2*this.xPadding,
					tooltipRectHeight = this.fontSize + 2*this.yPadding,
					tooltipHeight = tooltipRectHeight + this.caretHeight + caretPadding;
	
				if (this.x + tooltipWidth/2 >this.chart.width){
					this.xAlign = "left";
				} else if (this.x - tooltipWidth/2 < 0){
					this.xAlign = "right";
				}
	
				if (this.y - tooltipHeight < 0){
					this.yAlign = "below";
				}
	
	
				var tooltipX = this.x - tooltipWidth/2,
					tooltipY = this.y - tooltipHeight;
	
				ctx.fillStyle = this.fillColor;
	
				// Custom Tooltips
				if(this.custom){
					this.custom(this);
				}
				else{
					switch(this.yAlign)
					{
					case "above":
						//Draw a caret above the x/y
						ctx.beginPath();
						ctx.moveTo(this.x,this.y - caretPadding);
						ctx.lineTo(this.x + this.caretHeight, this.y - (caretPadding + this.caretHeight));
						ctx.lineTo(this.x - this.caretHeight, this.y - (caretPadding + this.caretHeight));
						ctx.closePath();
						ctx.fill();
						break;
					case "below":
						tooltipY = this.y + caretPadding + this.caretHeight;
						//Draw a caret below the x/y
						ctx.beginPath();
						ctx.moveTo(this.x, this.y + caretPadding);
						ctx.lineTo(this.x + this.caretHeight, this.y + caretPadding + this.caretHeight);
						ctx.lineTo(this.x - this.caretHeight, this.y + caretPadding + this.caretHeight);
						ctx.closePath();
						ctx.fill();
						break;
					}
	
					switch(this.xAlign)
					{
					case "left":
						tooltipX = this.x - tooltipWidth + (this.cornerRadius + this.caretHeight);
						break;
					case "right":
						tooltipX = this.x - (this.cornerRadius + this.caretHeight);
						break;
					}
	
					drawRoundedRectangle(ctx,tooltipX,tooltipY,tooltipWidth,tooltipRectHeight,this.cornerRadius);
	
					ctx.fill();
	
					ctx.fillStyle = this.textColor;
					ctx.textAlign = "center";
					ctx.textBaseline = "middle";
					ctx.fillText(this.text, tooltipX + tooltipWidth/2, tooltipY + tooltipRectHeight/2);
				}
			}
		});
	
		Chart.MultiTooltip = Chart.Element.extend({
			initialize : function(){
				this.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
	
				this.titleFont = fontString(this.titleFontSize,this.titleFontStyle,this.titleFontFamily);
	
				this.height = (this.labels.length * this.fontSize) + ((this.labels.length-1) * (this.fontSize/2)) + (this.yPadding*2) + this.titleFontSize *1.5;
	
				this.ctx.font = this.titleFont;
	
				var titleWidth = this.ctx.measureText(this.title).width,
					//Label has a legend square as well so account for this.
					labelWidth = longestText(this.ctx,this.font,this.labels) + this.fontSize + 3,
					longestTextWidth = max([labelWidth,titleWidth]);
	
				this.width = longestTextWidth + (this.xPadding*2);
	
	
				var halfHeight = this.height/2;
	
				//Check to ensure the height will fit on the canvas
				if (this.y - halfHeight < 0 ){
					this.y = halfHeight;
				} else if (this.y + halfHeight > this.chart.height){
					this.y = this.chart.height - halfHeight;
				}
	
				//Decide whether to align left or right based on position on canvas
				if (this.x > this.chart.width/2){
					this.x -= this.xOffset + this.width;
				} else {
					this.x += this.xOffset;
				}
	
	
			},
			getLineHeight : function(index){
				var baseLineHeight = this.y - (this.height/2) + this.yPadding,
					afterTitleIndex = index-1;
	
				//If the index is zero, we're getting the title
				if (index === 0){
					return baseLineHeight + this.titleFontSize/2;
				} else{
					return baseLineHeight + ((this.fontSize*1.5*afterTitleIndex) + this.fontSize/2) + this.titleFontSize * 1.5;
				}
	
			},
			draw : function(){
				// Custom Tooltips
				if(this.custom){
					this.custom(this);
				}
				else{
					drawRoundedRectangle(this.ctx,this.x,this.y - this.height/2,this.width,this.height,this.cornerRadius);
					var ctx = this.ctx;
					ctx.fillStyle = this.fillColor;
					ctx.fill();
					ctx.closePath();
	
					ctx.textAlign = "left";
					ctx.textBaseline = "middle";
					ctx.fillStyle = this.titleTextColor;
					ctx.font = this.titleFont;
	
					ctx.fillText(this.title,this.x + this.xPadding, this.getLineHeight(0));
	
					ctx.font = this.font;
					helpers.each(this.labels,function(label,index){
						ctx.fillStyle = this.textColor;
						ctx.fillText(label,this.x + this.xPadding + this.fontSize + 3, this.getLineHeight(index + 1));
	
						//A bit gnarly, but clearing this rectangle breaks when using explorercanvas (clears whole canvas)
						//ctx.clearRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
						//Instead we'll make a white filled block to put the legendColour palette over.
	
						ctx.fillStyle = this.legendColorBackground;
						ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
	
						ctx.fillStyle = this.legendColors[index].fill;
						ctx.fillRect(this.x + this.xPadding, this.getLineHeight(index + 1) - this.fontSize/2, this.fontSize, this.fontSize);
	
	
					},this);
				}
			}
		});
	
		Chart.Scale = Chart.Element.extend({
			initialize : function(){
				this.fit();
			},
			buildYLabels : function(){
				this.yLabels = [];
	
				var stepDecimalPlaces = getDecimalPlaces(this.stepValue);
	
				for (var i=0; i<=this.steps; i++){
					this.yLabels.push(template(this.templateString,{value:(this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces)}));
				}
				this.yLabelWidth = (this.display && this.showLabels) ? longestText(this.ctx,this.font,this.yLabels) : 0;
			},
			addXLabel : function(label){
				this.xLabels.push(label);
				this.valuesCount++;
				this.fit();
			},
			removeXLabel : function(){
				this.xLabels.shift();
				this.valuesCount--;
				this.fit();
			},
			// Fitting loop to rotate x Labels and figure out what fits there, and also calculate how many Y steps to use
			fit: function(){
				// First we need the width of the yLabels, assuming the xLabels aren't rotated
	
				// To do that we need the base line at the top and base of the chart, assuming there is no x label rotation
				this.startPoint = (this.display) ? this.fontSize : 0;
				this.endPoint = (this.display) ? this.height - (this.fontSize * 1.5) - 5 : this.height; // -5 to pad labels
	
				// Apply padding settings to the start and end point.
				this.startPoint += this.padding;
				this.endPoint -= this.padding;
	
				// Cache the starting height, so can determine if we need to recalculate the scale yAxis
				var cachedHeight = this.endPoint - this.startPoint,
					cachedYLabelWidth;
	
				// Build the current yLabels so we have an idea of what size they'll be to start
				/*
				 *	This sets what is returned from calculateScaleRange as static properties of this class:
				 *
					this.steps;
					this.stepValue;
					this.min;
					this.max;
				 *
				 */
				this.calculateYRange(cachedHeight);
	
				// With these properties set we can now build the array of yLabels
				// and also the width of the largest yLabel
				this.buildYLabels();
	
				this.calculateXLabelRotation();
	
				while((cachedHeight > this.endPoint - this.startPoint)){
					cachedHeight = this.endPoint - this.startPoint;
					cachedYLabelWidth = this.yLabelWidth;
	
					this.calculateYRange(cachedHeight);
					this.buildYLabels();
	
					// Only go through the xLabel loop again if the yLabel width has changed
					if (cachedYLabelWidth < this.yLabelWidth){
						this.calculateXLabelRotation();
					}
				}
	
			},
			calculateXLabelRotation : function(){
				//Get the width of each grid by calculating the difference
				//between x offsets between 0 and 1.
	
				this.ctx.font = this.font;
	
				var firstWidth = this.ctx.measureText(this.xLabels[0]).width,
					lastWidth = this.ctx.measureText(this.xLabels[this.xLabels.length - 1]).width,
					firstRotated,
					lastRotated;
	
	
				this.xScalePaddingRight = lastWidth/2 + 3;
				this.xScalePaddingLeft = (firstWidth/2 > this.yLabelWidth + 10) ? firstWidth/2 : this.yLabelWidth + 10;
	
				this.xLabelRotation = 0;
				if (this.display){
					var originalLabelWidth = longestText(this.ctx,this.font,this.xLabels),
						cosRotation,
						firstRotatedWidth;
					this.xLabelWidth = originalLabelWidth;
					//Allow 3 pixels x2 padding either side for label readability
					var xGridWidth = Math.floor(this.calculateX(1) - this.calculateX(0)) - 6;
	
					//Max label rotate should be 90 - also act as a loop counter
					while ((this.xLabelWidth > xGridWidth && this.xLabelRotation === 0) || (this.xLabelWidth > xGridWidth && this.xLabelRotation <= 90 && this.xLabelRotation > 0)){
						cosRotation = Math.cos(toRadians(this.xLabelRotation));
	
						firstRotated = cosRotation * firstWidth;
						lastRotated = cosRotation * lastWidth;
	
						// We're right aligning the text now.
						if (firstRotated + this.fontSize / 2 > this.yLabelWidth + 8){
							this.xScalePaddingLeft = firstRotated + this.fontSize / 2;
						}
						this.xScalePaddingRight = this.fontSize/2;
	
	
						this.xLabelRotation++;
						this.xLabelWidth = cosRotation * originalLabelWidth;
	
					}
					if (this.xLabelRotation > 0){
						this.endPoint -= Math.sin(toRadians(this.xLabelRotation))*originalLabelWidth + 3;
					}
				}
				else{
					this.xLabelWidth = 0;
					this.xScalePaddingRight = this.padding;
					this.xScalePaddingLeft = this.padding;
				}
	
			},
			// Needs to be overidden in each Chart type
			// Otherwise we need to pass all the data into the scale class
			calculateYRange: noop,
			drawingArea: function(){
				return this.startPoint - this.endPoint;
			},
			calculateY : function(value){
				var scalingFactor = this.drawingArea() / (this.min - this.max);
				return this.endPoint - (scalingFactor * (value - this.min));
			},
			calculateX : function(index){
				var isRotated = (this.xLabelRotation > 0),
					// innerWidth = (this.offsetGridLines) ? this.width - offsetLeft - this.padding : this.width - (offsetLeft + halfLabelWidth * 2) - this.padding,
					innerWidth = this.width - (this.xScalePaddingLeft + this.xScalePaddingRight),
					valueWidth = innerWidth/Math.max((this.valuesCount - ((this.offsetGridLines) ? 0 : 1)), 1),
					valueOffset = (valueWidth * index) + this.xScalePaddingLeft;
	
				if (this.offsetGridLines){
					valueOffset += (valueWidth/2);
				}
	
				return Math.round(valueOffset);
			},
			update : function(newProps){
				helpers.extend(this, newProps);
				this.fit();
			},
			draw : function(){
				var ctx = this.ctx,
					yLabelGap = (this.endPoint - this.startPoint) / this.steps,
					xStart = Math.round(this.xScalePaddingLeft);
				if (this.display){
					ctx.fillStyle = this.textColor;
					ctx.font = this.font;
					each(this.yLabels,function(labelString,index){
						var yLabelCenter = this.endPoint - (yLabelGap * index),
							linePositionY = Math.round(yLabelCenter),
							drawHorizontalLine = this.showHorizontalLines;
	
						ctx.textAlign = "right";
						ctx.textBaseline = "middle";
						if (this.showLabels){
							ctx.fillText(labelString,xStart - 10,yLabelCenter);
						}
	
						// This is X axis, so draw it
						if (index === 0 && !drawHorizontalLine){
							drawHorizontalLine = true;
						}
	
						if (drawHorizontalLine){
							ctx.beginPath();
						}
	
						if (index > 0){
							// This is a grid line in the centre, so drop that
							ctx.lineWidth = this.gridLineWidth;
							ctx.strokeStyle = this.gridLineColor;
						} else {
							// This is the first line on the scale
							ctx.lineWidth = this.lineWidth;
							ctx.strokeStyle = this.lineColor;
						}
	
						linePositionY += helpers.aliasPixel(ctx.lineWidth);
	
						if(drawHorizontalLine){
							ctx.moveTo(xStart, linePositionY);
							ctx.lineTo(this.width, linePositionY);
							ctx.stroke();
							ctx.closePath();
						}
	
						ctx.lineWidth = this.lineWidth;
						ctx.strokeStyle = this.lineColor;
						ctx.beginPath();
						ctx.moveTo(xStart - 5, linePositionY);
						ctx.lineTo(xStart, linePositionY);
						ctx.stroke();
						ctx.closePath();
	
					},this);
	
					each(this.xLabels,function(label,index){
						var xPos = this.calculateX(index) + aliasPixel(this.lineWidth),
							// Check to see if line/bar here and decide where to place the line
							linePos = this.calculateX(index - (this.offsetGridLines ? 0.5 : 0)) + aliasPixel(this.lineWidth),
							isRotated = (this.xLabelRotation > 0),
							drawVerticalLine = this.showVerticalLines;
	
						// This is Y axis, so draw it
						if (index === 0 && !drawVerticalLine){
							drawVerticalLine = true;
						}
	
						if (drawVerticalLine){
							ctx.beginPath();
						}
	
						if (index > 0){
							// This is a grid line in the centre, so drop that
							ctx.lineWidth = this.gridLineWidth;
							ctx.strokeStyle = this.gridLineColor;
						} else {
							// This is the first line on the scale
							ctx.lineWidth = this.lineWidth;
							ctx.strokeStyle = this.lineColor;
						}
	
						if (drawVerticalLine){
							ctx.moveTo(linePos,this.endPoint);
							ctx.lineTo(linePos,this.startPoint - 3);
							ctx.stroke();
							ctx.closePath();
						}
	
	
						ctx.lineWidth = this.lineWidth;
						ctx.strokeStyle = this.lineColor;
	
	
						// Small lines at the bottom of the base grid line
						ctx.beginPath();
						ctx.moveTo(linePos,this.endPoint);
						ctx.lineTo(linePos,this.endPoint + 5);
						ctx.stroke();
						ctx.closePath();
	
						ctx.save();
						ctx.translate(xPos,(isRotated) ? this.endPoint + 12 : this.endPoint + 8);
						ctx.rotate(toRadians(this.xLabelRotation)*-1);
						ctx.font = this.font;
						ctx.textAlign = (isRotated) ? "right" : "center";
						ctx.textBaseline = (isRotated) ? "middle" : "top";
						ctx.fillText(label, 0, 0);
						ctx.restore();
					},this);
	
				}
			}
	
		});
	
		Chart.RadialScale = Chart.Element.extend({
			initialize: function(){
				this.size = min([this.height, this.width]);
				this.drawingArea = (this.display) ? (this.size/2) - (this.fontSize/2 + this.backdropPaddingY) : (this.size/2);
			},
			calculateCenterOffset: function(value){
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = this.drawingArea / (this.max - this.min);
	
				return (value - this.min) * scalingFactor;
			},
			update : function(){
				if (!this.lineArc){
					this.setScaleSize();
				} else {
					this.drawingArea = (this.display) ? (this.size/2) - (this.fontSize/2 + this.backdropPaddingY) : (this.size/2);
				}
				this.buildYLabels();
			},
			buildYLabels: function(){
				this.yLabels = [];
	
				var stepDecimalPlaces = getDecimalPlaces(this.stepValue);
	
				for (var i=0; i<=this.steps; i++){
					this.yLabels.push(template(this.templateString,{value:(this.min + (i * this.stepValue)).toFixed(stepDecimalPlaces)}));
				}
			},
			getCircumference : function(){
				return ((Math.PI*2) / this.valuesCount);
			},
			setScaleSize: function(){
				/*
				 * Right, this is really confusing and there is a lot of maths going on here
				 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
				 *
				 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
				 *
				 * Solution:
				 *
				 * We assume the radius of the polygon is half the size of the canvas at first
				 * at each index we check if the text overlaps.
				 *
				 * Where it does, we store that angle and that index.
				 *
				 * After finding the largest index and angle we calculate how much we need to remove
				 * from the shape radius to move the point inwards by that x.
				 *
				 * We average the left and right distances to get the maximum shape radius that can fit in the box
				 * along with labels.
				 *
				 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
				 * on each side, removing that from the size, halving it and adding the left x protrusion width.
				 *
				 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
				 * and position it in the most space efficient manner
				 *
				 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
				 */
	
	
				// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
				// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
				var largestPossibleRadius = min([(this.height/2 - this.pointLabelFontSize - 5), this.width/2]),
					pointPosition,
					i,
					textWidth,
					halfTextWidth,
					furthestRight = this.width,
					furthestRightIndex,
					furthestRightAngle,
					furthestLeft = 0,
					furthestLeftIndex,
					furthestLeftAngle,
					xProtrusionLeft,
					xProtrusionRight,
					radiusReductionRight,
					radiusReductionLeft,
					maxWidthRadius;
				this.ctx.font = fontString(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily);
				for (i=0;i<this.valuesCount;i++){
					// 5px to space the text slightly out - similar to what we do in the draw function.
					pointPosition = this.getPointPosition(i, largestPossibleRadius);
					textWidth = this.ctx.measureText(template(this.templateString, { value: this.labels[i] })).width + 5;
					if (i === 0 || i === this.valuesCount/2){
						// If we're at index zero, or exactly the middle, we're at exactly the top/bottom
						// of the radar chart, so text will be aligned centrally, so we'll half it and compare
						// w/left and right text sizes
						halfTextWidth = textWidth/2;
						if (pointPosition.x + halfTextWidth > furthestRight) {
							furthestRight = pointPosition.x + halfTextWidth;
							furthestRightIndex = i;
						}
						if (pointPosition.x - halfTextWidth < furthestLeft) {
							furthestLeft = pointPosition.x - halfTextWidth;
							furthestLeftIndex = i;
						}
					}
					else if (i < this.valuesCount/2) {
						// Less than half the values means we'll left align the text
						if (pointPosition.x + textWidth > furthestRight) {
							furthestRight = pointPosition.x + textWidth;
							furthestRightIndex = i;
						}
					}
					else if (i > this.valuesCount/2){
						// More than half the values means we'll right align the text
						if (pointPosition.x - textWidth < furthestLeft) {
							furthestLeft = pointPosition.x - textWidth;
							furthestLeftIndex = i;
						}
					}
				}
	
				xProtrusionLeft = furthestLeft;
	
				xProtrusionRight = Math.ceil(furthestRight - this.width);
	
				furthestRightAngle = this.getIndexAngle(furthestRightIndex);
	
				furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);
	
				radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI/2);
	
				radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI/2);
	
				// Ensure we actually need to reduce the size of the chart
				radiusReductionRight = (isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
				radiusReductionLeft = (isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;
	
				this.drawingArea = largestPossibleRadius - (radiusReductionLeft + radiusReductionRight)/2;
	
				//this.drawingArea = min([maxWidthRadius, (this.height - (2 * (this.pointLabelFontSize + 5)))/2])
				this.setCenterPoint(radiusReductionLeft, radiusReductionRight);
	
			},
			setCenterPoint: function(leftMovement, rightMovement){
	
				var maxRight = this.width - rightMovement - this.drawingArea,
					maxLeft = leftMovement + this.drawingArea;
	
				this.xCenter = (maxLeft + maxRight)/2;
				// Always vertically in the centre as the text height doesn't change
				this.yCenter = (this.height/2);
			},
	
			getIndexAngle : function(index){
				var angleMultiplier = (Math.PI * 2) / this.valuesCount;
				// Start from the top instead of right, so remove a quarter of the circle
	
				return index * angleMultiplier - (Math.PI/2);
			},
			getPointPosition : function(index, distanceFromCenter){
				var thisAngle = this.getIndexAngle(index);
				return {
					x : (Math.cos(thisAngle) * distanceFromCenter) + this.xCenter,
					y : (Math.sin(thisAngle) * distanceFromCenter) + this.yCenter
				};
			},
			draw: function(){
				if (this.display){
					var ctx = this.ctx;
					each(this.yLabels, function(label, index){
						// Don't draw a centre value
						if (index > 0){
							var yCenterOffset = index * (this.drawingArea/this.steps),
								yHeight = this.yCenter - yCenterOffset,
								pointPosition;
	
							// Draw circular lines around the scale
							if (this.lineWidth > 0){
								ctx.strokeStyle = this.lineColor;
								ctx.lineWidth = this.lineWidth;
	
								if(this.lineArc){
									ctx.beginPath();
									ctx.arc(this.xCenter, this.yCenter, yCenterOffset, 0, Math.PI*2);
									ctx.closePath();
									ctx.stroke();
								} else{
									ctx.beginPath();
									for (var i=0;i<this.valuesCount;i++)
									{
										pointPosition = this.getPointPosition(i, this.calculateCenterOffset(this.min + (index * this.stepValue)));
										if (i === 0){
											ctx.moveTo(pointPosition.x, pointPosition.y);
										} else {
											ctx.lineTo(pointPosition.x, pointPosition.y);
										}
									}
									ctx.closePath();
									ctx.stroke();
								}
							}
							if(this.showLabels){
								ctx.font = fontString(this.fontSize,this.fontStyle,this.fontFamily);
								if (this.showLabelBackdrop){
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = this.backdropColor;
									ctx.fillRect(
										this.xCenter - labelWidth/2 - this.backdropPaddingX,
										yHeight - this.fontSize/2 - this.backdropPaddingY,
										labelWidth + this.backdropPaddingX*2,
										this.fontSize + this.backdropPaddingY*2
									);
								}
								ctx.textAlign = 'center';
								ctx.textBaseline = "middle";
								ctx.fillStyle = this.fontColor;
								ctx.fillText(label, this.xCenter, yHeight);
							}
						}
					}, this);
	
					if (!this.lineArc){
						ctx.lineWidth = this.angleLineWidth;
						ctx.strokeStyle = this.angleLineColor;
						for (var i = this.valuesCount - 1; i >= 0; i--) {
							if (this.angleLineWidth > 0){
								var outerPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max));
								ctx.beginPath();
								ctx.moveTo(this.xCenter, this.yCenter);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.stroke();
								ctx.closePath();
							}
							// Extra 3px out for some label spacing
							var pointLabelPosition = this.getPointPosition(i, this.calculateCenterOffset(this.max) + 5);
							ctx.font = fontString(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily);
							ctx.fillStyle = this.pointLabelFontColor;
	
							var labelsCount = this.labels.length,
								halfLabelsCount = this.labels.length/2,
								quarterLabelsCount = halfLabelsCount/2,
								upperHalf = (i < quarterLabelsCount || i > labelsCount - quarterLabelsCount),
								exactQuarter = (i === quarterLabelsCount || i === labelsCount - quarterLabelsCount);
							if (i === 0){
								ctx.textAlign = 'center';
							} else if(i === halfLabelsCount){
								ctx.textAlign = 'center';
							} else if (i < halfLabelsCount){
								ctx.textAlign = 'left';
							} else {
								ctx.textAlign = 'right';
							}
	
							// Set the correct text baseline based on outer positioning
							if (exactQuarter){
								ctx.textBaseline = 'middle';
							} else if (upperHalf){
								ctx.textBaseline = 'bottom';
							} else {
								ctx.textBaseline = 'top';
							}
	
							ctx.fillText(this.labels[i], pointLabelPosition.x, pointLabelPosition.y);
						}
					}
				}
			}
		});
	
		// Attach global event to resize each chart instance when the browser resizes
		helpers.addEvent(window, "resize", (function(){
			// Basic debounce of resize function so it doesn't hurt performance when resizing browser.
			var timeout;
			return function(){
				clearTimeout(timeout);
				timeout = setTimeout(function(){
					each(Chart.instances,function(instance){
						// If the responsive flag is set in the chart instance config
						// Cascade the resize event down to the chart.
						if (instance.options.responsive){
							instance.resize(instance.render, true);
						}
					});
				}, 50);
			};
		})());
	
	
		if (amd) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
				return Chart;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === 'object' && module.e) {
			module.e = Chart;
		}
	
		root.Chart = Chart;
	
		Chart.noConflict = function(){
			root.Chart = previous;
			return Chart;
		};
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			helpers = Chart.helpers;
	
	
		var defaultConfig = {
			//Boolean - Whether the scale should start at zero, or an order of magnitude down from the lowest value
			scaleBeginAtZero : true,
	
			//Boolean - Whether grid lines are shown across the chart
			scaleShowGridLines : true,
	
			//String - Colour of the grid lines
			scaleGridLineColor : "rgba(0,0,0,.05)",
	
			//Number - Width of the grid lines
			scaleGridLineWidth : 1,
	
			//Boolean - Whether to show horizontal lines (except X axis)
			scaleShowHorizontalLines: true,
	
			//Boolean - Whether to show vertical lines (except Y axis)
			scaleShowVerticalLines: true,
	
			//Boolean - If there is a stroke on each bar
			barShowStroke : true,
	
			//Number - Pixel width of the bar stroke
			barStrokeWidth : 2,
	
			//Number - Spacing between each of the X value sets
			barValueSpacing : 5,
	
			//Number - Spacing between data sets within X values
			barDatasetSpacing : 1,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].fillColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"
	
		};
	
	
		Chart.Type.extend({
			name: "Bar",
			defaults : defaultConfig,
			initialize:  function(data){
	
				//Expose options as a scope variable here so we can access it in the ScaleClass
				var options = this.options;
	
				this.ScaleClass = Chart.Scale.extend({
					offsetGridLines : true,
					calculateBarX : function(datasetCount, datasetIndex, barIndex){
						//Reusable method for calculating the xPosition of a given bar based on datasetIndex & width of the bar
						var xWidth = this.calculateBaseWidth(),
							xAbsolute = this.calculateX(barIndex) - (xWidth/2),
							barWidth = this.calculateBarWidth(datasetCount);
	
						return xAbsolute + (barWidth * datasetIndex) + (datasetIndex * options.barDatasetSpacing) + barWidth/2;
					},
					calculateBaseWidth : function(){
						return (this.calculateX(1) - this.calculateX(0)) - (2*options.barValueSpacing);
					},
					calculateBarWidth : function(datasetCount){
						//The padding between datasets is to the right of each bar, providing that there are more than 1 dataset
						var baseWidth = this.calculateBaseWidth() - ((datasetCount - 1) * options.barDatasetSpacing);
	
						return (baseWidth / datasetCount);
					}
				});
	
				this.datasets = [];
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activeBars = (evt.type !== 'mouseout') ? this.getBarsAtEvent(evt) : [];
	
						this.eachBars(function(bar){
							bar.restore(['fillColor', 'strokeColor']);
						});
						helpers.each(activeBars, function(activeBar){
							activeBar.fillColor = activeBar.highlightFill;
							activeBar.strokeColor = activeBar.highlightStroke;
						});
						this.showTooltip(activeBars);
					});
				}
	
				//Declare the extension of the default point, to cater for the options passed in to the constructor
				this.BarClass = Chart.Rectangle.extend({
					strokeWidth : this.options.barStrokeWidth,
					showStroke : this.options.barShowStroke,
					ctx : this.chart.ctx
				});
	
				//Iterate through each of the datasets, and build this into a property of the chart
				helpers.each(data.datasets,function(dataset,datasetIndex){
	
					var datasetObject = {
						label : dataset.label || null,
						fillColor : dataset.fillColor,
						strokeColor : dataset.strokeColor,
						bars : []
					};
	
					this.datasets.push(datasetObject);
	
					helpers.each(dataset.data,function(dataPoint,index){
						//Add a new point for each piece of data, passing any required data to draw.
						datasetObject.bars.push(new this.BarClass({
							value : dataPoint,
							label : data.labels[index],
							datasetLabel: dataset.label,
							strokeColor : dataset.strokeColor,
							fillColor : dataset.fillColor,
							highlightFill : dataset.highlightFill || dataset.fillColor,
							highlightStroke : dataset.highlightStroke || dataset.strokeColor
						}));
					},this);
	
				},this);
	
				this.buildScale(data.labels);
	
				this.BarClass.prototype.base = this.scale.endPoint;
	
				this.eachBars(function(bar, index, datasetIndex){
					helpers.extend(bar, {
						width : this.scale.calculateBarWidth(this.datasets.length),
						x: this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
						y: this.scale.endPoint
					});
					bar.save();
				}, this);
	
				this.render();
			},
			update : function(){
				this.scale.update();
				// Reset any highlight colours before updating.
				helpers.each(this.activeElements, function(activeElement){
					activeElement.restore(['fillColor', 'strokeColor']);
				});
	
				this.eachBars(function(bar){
					bar.save();
				});
				this.render();
			},
			eachBars : function(callback){
				helpers.each(this.datasets,function(dataset, datasetIndex){
					helpers.each(dataset.bars, callback, this, datasetIndex);
				},this);
			},
			getBarsAtEvent : function(e){
				var barsArray = [],
					eventPosition = helpers.getRelativePosition(e),
					datasetIterator = function(dataset){
						barsArray.push(dataset.bars[barIndex]);
					},
					barIndex;
	
				for (var datasetIndex = 0; datasetIndex < this.datasets.length; datasetIndex++) {
					for (barIndex = 0; barIndex < this.datasets[datasetIndex].bars.length; barIndex++) {
						if (this.datasets[datasetIndex].bars[barIndex].inRange(eventPosition.x,eventPosition.y)){
							helpers.each(this.datasets, datasetIterator);
							return barsArray;
						}
					}
				}
	
				return barsArray;
			},
			buildScale : function(labels){
				var self = this;
	
				var dataTotal = function(){
					var values = [];
					self.eachBars(function(bar){
						values.push(bar.value);
					});
					return values;
				};
	
				var scaleOptions = {
					templateString : this.options.scaleLabel,
					height : this.chart.height,
					width : this.chart.width,
					ctx : this.chart.ctx,
					textColor : this.options.scaleFontColor,
					fontSize : this.options.scaleFontSize,
					fontStyle : this.options.scaleFontStyle,
					fontFamily : this.options.scaleFontFamily,
					valuesCount : labels.length,
					beginAtZero : this.options.scaleBeginAtZero,
					integersOnly : this.options.scaleIntegersOnly,
					calculateYRange: function(currentHeight){
						var updatedRanges = helpers.calculateScaleRange(
							dataTotal(),
							currentHeight,
							this.fontSize,
							this.beginAtZero,
							this.integersOnly
						);
						helpers.extend(this, updatedRanges);
					},
					xLabels : labels,
					font : helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
					lineWidth : this.options.scaleLineWidth,
					lineColor : this.options.scaleLineColor,
					showHorizontalLines : this.options.scaleShowHorizontalLines,
					showVerticalLines : this.options.scaleShowVerticalLines,
					gridLineWidth : (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
					gridLineColor : (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : "rgba(0,0,0,0)",
					padding : (this.options.showScale) ? 0 : (this.options.barShowStroke) ? this.options.barStrokeWidth : 0,
					showLabels : this.options.scaleShowLabels,
					display : this.options.showScale
				};
	
				if (this.options.scaleOverride){
					helpers.extend(scaleOptions, {
						calculateYRange: helpers.noop,
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					});
				}
	
				this.scale = new this.ScaleClass(scaleOptions);
			},
			addData : function(valuesArray,label){
				//Map the values array for each of the datasets
				helpers.each(valuesArray,function(value,datasetIndex){
					//Add a new point for each piece of data, passing any required data to draw.
					this.datasets[datasetIndex].bars.push(new this.BarClass({
						value : value,
						label : label,
						x: this.scale.calculateBarX(this.datasets.length, datasetIndex, this.scale.valuesCount+1),
						y: this.scale.endPoint,
						width : this.scale.calculateBarWidth(this.datasets.length),
						base : this.scale.endPoint,
						strokeColor : this.datasets[datasetIndex].strokeColor,
						fillColor : this.datasets[datasetIndex].fillColor
					}));
				},this);
	
				this.scale.addXLabel(label);
				//Then re-render the chart.
				this.update();
			},
			removeData : function(){
				this.scale.removeXLabel();
				//Then re-render the chart.
				helpers.each(this.datasets,function(dataset){
					dataset.bars.shift();
				},this);
				this.update();
			},
			reflow : function(){
				helpers.extend(this.BarClass.prototype,{
					y: this.scale.endPoint,
					base : this.scale.endPoint
				});
				var newScaleProps = helpers.extend({
					height : this.chart.height,
					width : this.chart.width
				});
				this.scale.update(newScaleProps);
			},
			draw : function(ease){
				var easingDecimal = ease || 1;
				this.clear();
	
				var ctx = this.chart.ctx;
	
				this.scale.draw(easingDecimal);
	
				//Draw all the bars for each dataset
				helpers.each(this.datasets,function(dataset,datasetIndex){
					helpers.each(dataset.bars,function(bar,index){
						if (bar.hasValue()){
							bar.base = this.scale.endPoint;
							//Transition then draw
							bar.transition({
								x : this.scale.calculateBarX(this.datasets.length, datasetIndex, index),
								y : this.scale.calculateY(bar.value),
								width : this.scale.calculateBarWidth(this.datasets.length)
							}, easingDecimal).draw();
						}
					},this);
	
				},this);
			}
		});
	
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			//Cache a local reference to Chart.helpers
			helpers = Chart.helpers;
	
		var defaultConfig = {
			//Boolean - Whether we should show a stroke on each segment
			segmentShowStroke : true,
	
			//String - The colour of each segment stroke
			segmentStrokeColor : "#fff",
	
			//Number - The width of each segment stroke
			segmentStrokeWidth : 2,
	
			//The percentage of the chart that we cut out of the middle.
			percentageInnerCutout : 50,
	
			//Number - Amount of animation steps
			animationSteps : 100,
	
			//String - Animation easing effect
			animationEasing : "easeOutBounce",
	
			//Boolean - Whether we animate the rotation of the Doughnut
			animateRotate : true,
	
			//Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale : false,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"
	
		};
	
	
		Chart.Type.extend({
			//Passing in a name registers this chart in the Chart namespace
			name: "Doughnut",
			//Providing a defaults will also register the deafults in the chart namespace
			defaults : defaultConfig,
			//Initialize is fired when the chart is initialized - Data is passed in as a parameter
			//Config is automatically merged by the core of Chart.js, and is available at this.options
			initialize:  function(data){
	
				//Declare segments as a static property to prevent inheriting across the Chart type prototype
				this.segments = [];
				this.outerRadius = (helpers.min([this.chart.width,this.chart.height]) -	this.options.segmentStrokeWidth/2)/2;
	
				this.SegmentArc = Chart.Arc.extend({
					ctx : this.chart.ctx,
					x : this.chart.width/2,
					y : this.chart.height/2
				});
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : [];
	
						helpers.each(this.segments,function(segment){
							segment.restore(["fillColor"]);
						});
						helpers.each(activeSegments,function(activeSegment){
							activeSegment.fillColor = activeSegment.highlightColor;
						});
						this.showTooltip(activeSegments);
					});
				}
				this.calculateTotal(data);
	
				helpers.each(data,function(datapoint, index){
					this.addData(datapoint, index, true);
				},this);
	
				this.render();
			},
			getSegmentsAtEvent : function(e){
				var segmentsArray = [];
	
				var location = helpers.getRelativePosition(e);
	
				helpers.each(this.segments,function(segment){
					if (segment.inRange(location.x,location.y)) segmentsArray.push(segment);
				},this);
				return segmentsArray;
			},
			addData : function(segment, atIndex, silent){
				var index = atIndex || this.segments.length;
				this.segments.splice(index, 0, new this.SegmentArc({
					value : segment.value,
					outerRadius : (this.options.animateScale) ? 0 : this.outerRadius,
					innerRadius : (this.options.animateScale) ? 0 : (this.outerRadius/100) * this.options.percentageInnerCutout,
					fillColor : segment.color,
					highlightColor : segment.highlight || segment.color,
					showStroke : this.options.segmentShowStroke,
					strokeWidth : this.options.segmentStrokeWidth,
					strokeColor : this.options.segmentStrokeColor,
					startAngle : Math.PI * 1.5,
					circumference : (this.options.animateRotate) ? 0 : this.calculateCircumference(segment.value),
					label : segment.label
				}));
				if (!silent){
					this.reflow();
					this.update();
				}
			},
			calculateCircumference : function(value){
				return (Math.PI*2)*(Math.abs(value) / this.total);
			},
			calculateTotal : function(data){
				this.total = 0;
				helpers.each(data,function(segment){
					this.total += Math.abs(segment.value);
				},this);
			},
			update : function(){
				this.calculateTotal(this.segments);
	
				// Reset any highlight colours before updating.
				helpers.each(this.activeElements, function(activeElement){
					activeElement.restore(['fillColor']);
				});
	
				helpers.each(this.segments,function(segment){
					segment.save();
				});
				this.render();
			},
	
			removeData: function(atIndex){
				var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length-1;
				this.segments.splice(indexToDelete, 1);
				this.reflow();
				this.update();
			},
	
			reflow : function(){
				helpers.extend(this.SegmentArc.prototype,{
					x : this.chart.width/2,
					y : this.chart.height/2
				});
				this.outerRadius = (helpers.min([this.chart.width,this.chart.height]) -	this.options.segmentStrokeWidth/2)/2;
				helpers.each(this.segments, function(segment){
					segment.update({
						outerRadius : this.outerRadius,
						innerRadius : (this.outerRadius/100) * this.options.percentageInnerCutout
					});
				}, this);
			},
			draw : function(easeDecimal){
				var animDecimal = (easeDecimal) ? easeDecimal : 1;
				this.clear();
				helpers.each(this.segments,function(segment,index){
					segment.transition({
						circumference : this.calculateCircumference(segment.value),
						outerRadius : this.outerRadius,
						innerRadius : (this.outerRadius/100) * this.options.percentageInnerCutout
					},animDecimal);
	
					segment.endAngle = segment.startAngle + segment.circumference;
	
					segment.draw();
					if (index === 0){
						segment.startAngle = Math.PI * 1.5;
					}
					//Check to see if it's the last segment, if not get the next and update the start angle
					if (index < this.segments.length-1){
						this.segments[index+1].startAngle = segment.endAngle;
					}
				},this);
	
			}
		});
	
		Chart.types.Doughnut.extend({
			name : "Pie",
			defaults : helpers.merge(defaultConfig,{percentageInnerCutout : 0})
		});
	
	}).call(this);
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			helpers = Chart.helpers;
	
		var defaultConfig = {
	
			///Boolean - Whether grid lines are shown across the chart
			scaleShowGridLines : true,
	
			//String - Colour of the grid lines
			scaleGridLineColor : "rgba(0,0,0,.05)",
	
			//Number - Width of the grid lines
			scaleGridLineWidth : 1,
	
			//Boolean - Whether to show horizontal lines (except X axis)
			scaleShowHorizontalLines: true,
	
			//Boolean - Whether to show vertical lines (except Y axis)
			scaleShowVerticalLines: true,
	
			//Boolean - Whether the line is curved between points
			bezierCurve : true,
	
			//Number - Tension of the bezier curve between points
			bezierCurveTension : 0.4,
	
			//Boolean - Whether to show a dot for each point
			pointDot : true,
	
			//Number - Radius of each point dot in pixels
			pointDotRadius : 4,
	
			//Number - Pixel width of point dot stroke
			pointDotStrokeWidth : 1,
	
			//Number - amount extra to add to the radius to cater for hit detection outside the drawn point
			pointHitDetectionRadius : 20,
	
			//Boolean - Whether to show a stroke for datasets
			datasetStroke : true,
	
			//Number - Pixel width of dataset stroke
			datasetStrokeWidth : 2,
	
			//Boolean - Whether to fill the dataset with a colour
			datasetFill : true,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"
	
		};
	
	
		Chart.Type.extend({
			name: "Line",
			defaults : defaultConfig,
			initialize:  function(data){
				//Declare the extension of the default point, to cater for the options passed in to the constructor
				this.PointClass = Chart.Point.extend({
					strokeWidth : this.options.pointDotStrokeWidth,
					radius : this.options.pointDotRadius,
					display: this.options.pointDot,
					hitDetectionRadius : this.options.pointHitDetectionRadius,
					ctx : this.chart.ctx,
					inRange : function(mouseX){
						return (Math.pow(mouseX-this.x, 2) < Math.pow(this.radius + this.hitDetectionRadius,2));
					}
				});
	
				this.datasets = [];
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activePoints = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : [];
						this.eachPoints(function(point){
							point.restore(['fillColor', 'strokeColor']);
						});
						helpers.each(activePoints, function(activePoint){
							activePoint.fillColor = activePoint.highlightFill;
							activePoint.strokeColor = activePoint.highlightStroke;
						});
						this.showTooltip(activePoints);
					});
				}
	
				//Iterate through each of the datasets, and build this into a property of the chart
				helpers.each(data.datasets,function(dataset){
	
					var datasetObject = {
						label : dataset.label || null,
						fillColor : dataset.fillColor,
						strokeColor : dataset.strokeColor,
						pointColor : dataset.pointColor,
						pointStrokeColor : dataset.pointStrokeColor,
						points : []
					};
	
					this.datasets.push(datasetObject);
	
	
					helpers.each(dataset.data,function(dataPoint,index){
						//Add a new point for each piece of data, passing any required data to draw.
						datasetObject.points.push(new this.PointClass({
							value : dataPoint,
							label : data.labels[index],
							datasetLabel: dataset.label,
							strokeColor : dataset.pointStrokeColor,
							fillColor : dataset.pointColor,
							highlightFill : dataset.pointHighlightFill || dataset.pointColor,
							highlightStroke : dataset.pointHighlightStroke || dataset.pointStrokeColor
						}));
					},this);
	
					this.buildScale(data.labels);
	
	
					this.eachPoints(function(point, index){
						helpers.extend(point, {
							x: this.scale.calculateX(index),
							y: this.scale.endPoint
						});
						point.save();
					}, this);
	
				},this);
	
	
				this.render();
			},
			update : function(){
				this.scale.update();
				// Reset any highlight colours before updating.
				helpers.each(this.activeElements, function(activeElement){
					activeElement.restore(['fillColor', 'strokeColor']);
				});
				this.eachPoints(function(point){
					point.save();
				});
				this.render();
			},
			eachPoints : function(callback){
				helpers.each(this.datasets,function(dataset){
					helpers.each(dataset.points,callback,this);
				},this);
			},
			getPointsAtEvent : function(e){
				var pointsArray = [],
					eventPosition = helpers.getRelativePosition(e);
				helpers.each(this.datasets,function(dataset){
					helpers.each(dataset.points,function(point){
						if (point.inRange(eventPosition.x,eventPosition.y)) pointsArray.push(point);
					});
				},this);
				return pointsArray;
			},
			buildScale : function(labels){
				var self = this;
	
				var dataTotal = function(){
					var values = [];
					self.eachPoints(function(point){
						values.push(point.value);
					});
	
					return values;
				};
	
				var scaleOptions = {
					templateString : this.options.scaleLabel,
					height : this.chart.height,
					width : this.chart.width,
					ctx : this.chart.ctx,
					textColor : this.options.scaleFontColor,
					fontSize : this.options.scaleFontSize,
					fontStyle : this.options.scaleFontStyle,
					fontFamily : this.options.scaleFontFamily,
					valuesCount : labels.length,
					beginAtZero : this.options.scaleBeginAtZero,
					integersOnly : this.options.scaleIntegersOnly,
					calculateYRange : function(currentHeight){
						var updatedRanges = helpers.calculateScaleRange(
							dataTotal(),
							currentHeight,
							this.fontSize,
							this.beginAtZero,
							this.integersOnly
						);
						helpers.extend(this, updatedRanges);
					},
					xLabels : labels,
					font : helpers.fontString(this.options.scaleFontSize, this.options.scaleFontStyle, this.options.scaleFontFamily),
					lineWidth : this.options.scaleLineWidth,
					lineColor : this.options.scaleLineColor,
					showHorizontalLines : this.options.scaleShowHorizontalLines,
					showVerticalLines : this.options.scaleShowVerticalLines,
					gridLineWidth : (this.options.scaleShowGridLines) ? this.options.scaleGridLineWidth : 0,
					gridLineColor : (this.options.scaleShowGridLines) ? this.options.scaleGridLineColor : "rgba(0,0,0,0)",
					padding: (this.options.showScale) ? 0 : this.options.pointDotRadius + this.options.pointDotStrokeWidth,
					showLabels : this.options.scaleShowLabels,
					display : this.options.showScale
				};
	
				if (this.options.scaleOverride){
					helpers.extend(scaleOptions, {
						calculateYRange: helpers.noop,
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					});
				}
	
	
				this.scale = new Chart.Scale(scaleOptions);
			},
			addData : function(valuesArray,label){
				//Map the values array for each of the datasets
	
				helpers.each(valuesArray,function(value,datasetIndex){
					//Add a new point for each piece of data, passing any required data to draw.
					this.datasets[datasetIndex].points.push(new this.PointClass({
						value : value,
						label : label,
						x: this.scale.calculateX(this.scale.valuesCount+1),
						y: this.scale.endPoint,
						strokeColor : this.datasets[datasetIndex].pointStrokeColor,
						fillColor : this.datasets[datasetIndex].pointColor
					}));
				},this);
	
				this.scale.addXLabel(label);
				//Then re-render the chart.
				this.update();
			},
			removeData : function(){
				this.scale.removeXLabel();
				//Then re-render the chart.
				helpers.each(this.datasets,function(dataset){
					dataset.points.shift();
				},this);
				this.update();
			},
			reflow : function(){
				var newScaleProps = helpers.extend({
					height : this.chart.height,
					width : this.chart.width
				});
				this.scale.update(newScaleProps);
			},
			draw : function(ease){
				var easingDecimal = ease || 1;
				this.clear();
	
				var ctx = this.chart.ctx;
	
				// Some helper methods for getting the next/prev points
				var hasValue = function(item){
					return item.value !== null;
				},
				nextPoint = function(point, collection, index){
					return helpers.findNextWhere(collection, hasValue, index) || point;
				},
				previousPoint = function(point, collection, index){
					return helpers.findPreviousWhere(collection, hasValue, index) || point;
				};
	
				this.scale.draw(easingDecimal);
	
	
				helpers.each(this.datasets,function(dataset){
					var pointsWithValues = helpers.where(dataset.points, hasValue);
	
					//Transition each point first so that the line and point drawing isn't out of sync
					//We can use this extra loop to calculate the control points of this dataset also in this loop
	
					helpers.each(dataset.points, function(point, index){
						if (point.hasValue()){
							point.transition({
								y : this.scale.calculateY(point.value),
								x : this.scale.calculateX(index)
							}, easingDecimal);
						}
					},this);
	
	
					// Control points need to be calculated in a seperate loop, because we need to know the current x/y of the point
					// This would cause issues when there is no animation, because the y of the next point would be 0, so beziers would be skewed
					if (this.options.bezierCurve){
						helpers.each(pointsWithValues, function(point, index){
							var tension = (index > 0 && index < pointsWithValues.length - 1) ? this.options.bezierCurveTension : 0;
							point.controlPoints = helpers.splineCurve(
								previousPoint(point, pointsWithValues, index),
								point,
								nextPoint(point, pointsWithValues, index),
								tension
							);
	
							// Prevent the bezier going outside of the bounds of the graph
	
							// Cap puter bezier handles to the upper/lower scale bounds
							if (point.controlPoints.outer.y > this.scale.endPoint){
								point.controlPoints.outer.y = this.scale.endPoint;
							}
							else if (point.controlPoints.outer.y < this.scale.startPoint){
								point.controlPoints.outer.y = this.scale.startPoint;
							}
	
							// Cap inner bezier handles to the upper/lower scale bounds
							if (point.controlPoints.inner.y > this.scale.endPoint){
								point.controlPoints.inner.y = this.scale.endPoint;
							}
							else if (point.controlPoints.inner.y < this.scale.startPoint){
								point.controlPoints.inner.y = this.scale.startPoint;
							}
						},this);
					}
	
	
					//Draw the line between all the points
					ctx.lineWidth = this.options.datasetStrokeWidth;
					ctx.strokeStyle = dataset.strokeColor;
					ctx.beginPath();
	
					helpers.each(pointsWithValues, function(point, index){
						if (index === 0){
							ctx.moveTo(point.x, point.y);
						}
						else{
							if(this.options.bezierCurve){
								var previous = previousPoint(point, pointsWithValues, index);
	
								ctx.bezierCurveTo(
									previous.controlPoints.outer.x,
									previous.controlPoints.outer.y,
									point.controlPoints.inner.x,
									point.controlPoints.inner.y,
									point.x,
									point.y
								);
							}
							else{
								ctx.lineTo(point.x,point.y);
							}
						}
					}, this);
	
					ctx.stroke();
	
					if (this.options.datasetFill && pointsWithValues.length > 0){
						//Round off the line by going to the base of the chart, back to the start, then fill.
						ctx.lineTo(pointsWithValues[pointsWithValues.length - 1].x, this.scale.endPoint);
						ctx.lineTo(pointsWithValues[0].x, this.scale.endPoint);
						ctx.fillStyle = dataset.fillColor;
						ctx.closePath();
						ctx.fill();
					}
	
					//Now draw the points over the line
					//A little inefficient double looping, but better than the line
					//lagging behind the point positions
					helpers.each(pointsWithValues,function(point){
						point.draw();
					});
				},this);
			}
		});
	
	
	}).call(this);
	
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			//Cache a local reference to Chart.helpers
			helpers = Chart.helpers;
	
		var defaultConfig = {
			//Boolean - Show a backdrop to the scale label
			scaleShowLabelBackdrop : true,
	
			//String - The colour of the label backdrop
			scaleBackdropColor : "rgba(255,255,255,0.75)",
	
			// Boolean - Whether the scale should begin at zero
			scaleBeginAtZero : true,
	
			//Number - The backdrop padding above & below the label in pixels
			scaleBackdropPaddingY : 2,
	
			//Number - The backdrop padding to the side of the label in pixels
			scaleBackdropPaddingX : 2,
	
			//Boolean - Show line for each value in the scale
			scaleShowLine : true,
	
			//Boolean - Stroke a line around each segment in the chart
			segmentShowStroke : true,
	
			//String - The colour of the stroke on each segement.
			segmentStrokeColor : "#fff",
	
			//Number - The width of the stroke value in pixels
			segmentStrokeWidth : 2,
	
			//Number - Amount of animation steps
			animationSteps : 100,
	
			//String - Animation easing effect.
			animationEasing : "easeOutBounce",
	
			//Boolean - Whether to animate the rotation of the chart
			animateRotate : true,
	
			//Boolean - Whether to animate scaling the chart from the centre
			animateScale : false,
	
			//String - A legend template
			legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"
		};
	
	
		Chart.Type.extend({
			//Passing in a name registers this chart in the Chart namespace
			name: "PolarArea",
			//Providing a defaults will also register the deafults in the chart namespace
			defaults : defaultConfig,
			//Initialize is fired when the chart is initialized - Data is passed in as a parameter
			//Config is automatically merged by the core of Chart.js, and is available at this.options
			initialize:  function(data){
				this.segments = [];
				//Declare segment class as a chart instance specific class, so it can share props for this instance
				this.SegmentArc = Chart.Arc.extend({
					showStroke : this.options.segmentShowStroke,
					strokeWidth : this.options.segmentStrokeWidth,
					strokeColor : this.options.segmentStrokeColor,
					ctx : this.chart.ctx,
					innerRadius : 0,
					x : this.chart.width/2,
					y : this.chart.height/2
				});
				this.scale = new Chart.RadialScale({
					display: this.options.showScale,
					fontStyle: this.options.scaleFontStyle,
					fontSize: this.options.scaleFontSize,
					fontFamily: this.options.scaleFontFamily,
					fontColor: this.options.scaleFontColor,
					showLabels: this.options.scaleShowLabels,
					showLabelBackdrop: this.options.scaleShowLabelBackdrop,
					backdropColor: this.options.scaleBackdropColor,
					backdropPaddingY : this.options.scaleBackdropPaddingY,
					backdropPaddingX: this.options.scaleBackdropPaddingX,
					lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
					lineColor: this.options.scaleLineColor,
					lineArc: true,
					width: this.chart.width,
					height: this.chart.height,
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2,
					ctx : this.chart.ctx,
					templateString: this.options.scaleLabel,
					valuesCount: data.length
				});
	
				this.updateScaleRange(data);
	
				this.scale.update();
	
				helpers.each(data,function(segment,index){
					this.addData(segment,index,true);
				},this);
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activeSegments = (evt.type !== 'mouseout') ? this.getSegmentsAtEvent(evt) : [];
						helpers.each(this.segments,function(segment){
							segment.restore(["fillColor"]);
						});
						helpers.each(activeSegments,function(activeSegment){
							activeSegment.fillColor = activeSegment.highlightColor;
						});
						this.showTooltip(activeSegments);
					});
				}
	
				this.render();
			},
			getSegmentsAtEvent : function(e){
				var segmentsArray = [];
	
				var location = helpers.getRelativePosition(e);
	
				helpers.each(this.segments,function(segment){
					if (segment.inRange(location.x,location.y)) segmentsArray.push(segment);
				},this);
				return segmentsArray;
			},
			addData : function(segment, atIndex, silent){
				var index = atIndex || this.segments.length;
	
				this.segments.splice(index, 0, new this.SegmentArc({
					fillColor: segment.color,
					highlightColor: segment.highlight || segment.color,
					label: segment.label,
					value: segment.value,
					outerRadius: (this.options.animateScale) ? 0 : this.scale.calculateCenterOffset(segment.value),
					circumference: (this.options.animateRotate) ? 0 : this.scale.getCircumference(),
					startAngle: Math.PI * 1.5
				}));
				if (!silent){
					this.reflow();
					this.update();
				}
			},
			removeData: function(atIndex){
				var indexToDelete = (helpers.isNumber(atIndex)) ? atIndex : this.segments.length-1;
				this.segments.splice(indexToDelete, 1);
				this.reflow();
				this.update();
			},
			calculateTotal: function(data){
				this.total = 0;
				helpers.each(data,function(segment){
					this.total += segment.value;
				},this);
				this.scale.valuesCount = this.segments.length;
			},
			updateScaleRange: function(datapoints){
				var valuesArray = [];
				helpers.each(datapoints,function(segment){
					valuesArray.push(segment.value);
				});
	
				var scaleSizes = (this.options.scaleOverride) ?
					{
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					} :
					helpers.calculateScaleRange(
						valuesArray,
						helpers.min([this.chart.width, this.chart.height])/2,
						this.options.scaleFontSize,
						this.options.scaleBeginAtZero,
						this.options.scaleIntegersOnly
					);
	
				helpers.extend(
					this.scale,
					scaleSizes,
					{
						size: helpers.min([this.chart.width, this.chart.height]),
						xCenter: this.chart.width/2,
						yCenter: this.chart.height/2
					}
				);
	
			},
			update : function(){
				this.calculateTotal(this.segments);
	
				helpers.each(this.segments,function(segment){
					segment.save();
				});
				
				this.reflow();
				this.render();
			},
			reflow : function(){
				helpers.extend(this.SegmentArc.prototype,{
					x : this.chart.width/2,
					y : this.chart.height/2
				});
				this.updateScaleRange(this.segments);
				this.scale.update();
	
				helpers.extend(this.scale,{
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2
				});
	
				helpers.each(this.segments, function(segment){
					segment.update({
						outerRadius : this.scale.calculateCenterOffset(segment.value)
					});
				}, this);
	
			},
			draw : function(ease){
				var easingDecimal = ease || 1;
				//Clear & draw the canvas
				this.clear();
				helpers.each(this.segments,function(segment, index){
					segment.transition({
						circumference : this.scale.getCircumference(),
						outerRadius : this.scale.calculateCenterOffset(segment.value)
					},easingDecimal);
	
					segment.endAngle = segment.startAngle + segment.circumference;
	
					// If we've removed the first segment we need to set the first one to
					// start at the top.
					if (index === 0){
						segment.startAngle = Math.PI * 1.5;
					}
	
					//Check to see if it's the last segment, if not get the next and update the start angle
					if (index < this.segments.length - 1){
						this.segments[index+1].startAngle = segment.endAngle;
					}
					segment.draw();
				}, this);
				this.scale.draw();
			}
		});
	
	}).call(this);
	(function(){
		"use strict";
	
		var root = this,
			Chart = root.Chart,
			helpers = Chart.helpers;
	
	
	
		Chart.Type.extend({
			name: "Radar",
			defaults:{
				//Boolean - Whether to show lines for each scale point
				scaleShowLine : true,
	
				//Boolean - Whether we show the angle lines out of the radar
				angleShowLineOut : true,
	
				//Boolean - Whether to show labels on the scale
				scaleShowLabels : false,
	
				// Boolean - Whether the scale should begin at zero
				scaleBeginAtZero : true,
	
				//String - Colour of the angle line
				angleLineColor : "rgba(0,0,0,.1)",
	
				//Number - Pixel width of the angle line
				angleLineWidth : 1,
	
				//String - Point label font declaration
				pointLabelFontFamily : "'Arial'",
	
				//String - Point label font weight
				pointLabelFontStyle : "normal",
	
				//Number - Point label font size in pixels
				pointLabelFontSize : 10,
	
				//String - Point label font colour
				pointLabelFontColor : "#666",
	
				//Boolean - Whether to show a dot for each point
				pointDot : true,
	
				//Number - Radius of each point dot in pixels
				pointDotRadius : 3,
	
				//Number - Pixel width of point dot stroke
				pointDotStrokeWidth : 1,
	
				//Number - amount extra to add to the radius to cater for hit detection outside the drawn point
				pointHitDetectionRadius : 20,
	
				//Boolean - Whether to show a stroke for datasets
				datasetStroke : true,
	
				//Number - Pixel width of dataset stroke
				datasetStrokeWidth : 2,
	
				//Boolean - Whether to fill the dataset with a colour
				datasetFill : true,
	
				//String - A legend template
				legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"
	
			},
	
			initialize: function(data){
				this.PointClass = Chart.Point.extend({
					strokeWidth : this.options.pointDotStrokeWidth,
					radius : this.options.pointDotRadius,
					display: this.options.pointDot,
					hitDetectionRadius : this.options.pointHitDetectionRadius,
					ctx : this.chart.ctx
				});
	
				this.datasets = [];
	
				this.buildScale(data);
	
				//Set up tooltip events on the chart
				if (this.options.showTooltips){
					helpers.bindEvents(this, this.options.tooltipEvents, function(evt){
						var activePointsCollection = (evt.type !== 'mouseout') ? this.getPointsAtEvent(evt) : [];
	
						this.eachPoints(function(point){
							point.restore(['fillColor', 'strokeColor']);
						});
						helpers.each(activePointsCollection, function(activePoint){
							activePoint.fillColor = activePoint.highlightFill;
							activePoint.strokeColor = activePoint.highlightStroke;
						});
	
						this.showTooltip(activePointsCollection);
					});
				}
	
				//Iterate through each of the datasets, and build this into a property of the chart
				helpers.each(data.datasets,function(dataset){
	
					var datasetObject = {
						label: dataset.label || null,
						fillColor : dataset.fillColor,
						strokeColor : dataset.strokeColor,
						pointColor : dataset.pointColor,
						pointStrokeColor : dataset.pointStrokeColor,
						points : []
					};
	
					this.datasets.push(datasetObject);
	
					helpers.each(dataset.data,function(dataPoint,index){
						//Add a new point for each piece of data, passing any required data to draw.
						var pointPosition;
						if (!this.scale.animation){
							pointPosition = this.scale.getPointPosition(index, this.scale.calculateCenterOffset(dataPoint));
						}
						datasetObject.points.push(new this.PointClass({
							value : dataPoint,
							label : data.labels[index],
							datasetLabel: dataset.label,
							x: (this.options.animation) ? this.scale.xCenter : pointPosition.x,
							y: (this.options.animation) ? this.scale.yCenter : pointPosition.y,
							strokeColor : dataset.pointStrokeColor,
							fillColor : dataset.pointColor,
							highlightFill : dataset.pointHighlightFill || dataset.pointColor,
							highlightStroke : dataset.pointHighlightStroke || dataset.pointStrokeColor
						}));
					},this);
	
				},this);
	
				this.render();
			},
			eachPoints : function(callback){
				helpers.each(this.datasets,function(dataset){
					helpers.each(dataset.points,callback,this);
				},this);
			},
	
			getPointsAtEvent : function(evt){
				var mousePosition = helpers.getRelativePosition(evt),
					fromCenter = helpers.getAngleFromPoint({
						x: this.scale.xCenter,
						y: this.scale.yCenter
					}, mousePosition);
	
				var anglePerIndex = (Math.PI * 2) /this.scale.valuesCount,
					pointIndex = Math.round((fromCenter.angle - Math.PI * 1.5) / anglePerIndex),
					activePointsCollection = [];
	
				// If we're at the top, make the pointIndex 0 to get the first of the array.
				if (pointIndex >= this.scale.valuesCount || pointIndex < 0){
					pointIndex = 0;
				}
	
				if (fromCenter.distance <= this.scale.drawingArea){
					helpers.each(this.datasets, function(dataset){
						activePointsCollection.push(dataset.points[pointIndex]);
					});
				}
	
				return activePointsCollection;
			},
	
			buildScale : function(data){
				this.scale = new Chart.RadialScale({
					display: this.options.showScale,
					fontStyle: this.options.scaleFontStyle,
					fontSize: this.options.scaleFontSize,
					fontFamily: this.options.scaleFontFamily,
					fontColor: this.options.scaleFontColor,
					showLabels: this.options.scaleShowLabels,
					showLabelBackdrop: this.options.scaleShowLabelBackdrop,
					backdropColor: this.options.scaleBackdropColor,
					backdropPaddingY : this.options.scaleBackdropPaddingY,
					backdropPaddingX: this.options.scaleBackdropPaddingX,
					lineWidth: (this.options.scaleShowLine) ? this.options.scaleLineWidth : 0,
					lineColor: this.options.scaleLineColor,
					angleLineColor : this.options.angleLineColor,
					angleLineWidth : (this.options.angleShowLineOut) ? this.options.angleLineWidth : 0,
					// Point labels at the edge of each line
					pointLabelFontColor : this.options.pointLabelFontColor,
					pointLabelFontSize : this.options.pointLabelFontSize,
					pointLabelFontFamily : this.options.pointLabelFontFamily,
					pointLabelFontStyle : this.options.pointLabelFontStyle,
					height : this.chart.height,
					width: this.chart.width,
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2,
					ctx : this.chart.ctx,
					templateString: this.options.scaleLabel,
					labels: data.labels,
					valuesCount: data.datasets[0].data.length
				});
	
				this.scale.setScaleSize();
				this.updateScaleRange(data.datasets);
				this.scale.buildYLabels();
			},
			updateScaleRange: function(datasets){
				var valuesArray = (function(){
					var totalDataArray = [];
					helpers.each(datasets,function(dataset){
						if (dataset.data){
							totalDataArray = totalDataArray.concat(dataset.data);
						}
						else {
							helpers.each(dataset.points, function(point){
								totalDataArray.push(point.value);
							});
						}
					});
					return totalDataArray;
				})();
	
	
				var scaleSizes = (this.options.scaleOverride) ?
					{
						steps: this.options.scaleSteps,
						stepValue: this.options.scaleStepWidth,
						min: this.options.scaleStartValue,
						max: this.options.scaleStartValue + (this.options.scaleSteps * this.options.scaleStepWidth)
					} :
					helpers.calculateScaleRange(
						valuesArray,
						helpers.min([this.chart.width, this.chart.height])/2,
						this.options.scaleFontSize,
						this.options.scaleBeginAtZero,
						this.options.scaleIntegersOnly
					);
	
				helpers.extend(
					this.scale,
					scaleSizes
				);
	
			},
			addData : function(valuesArray,label){
				//Map the values array for each of the datasets
				this.scale.valuesCount++;
				helpers.each(valuesArray,function(value,datasetIndex){
					var pointPosition = this.scale.getPointPosition(this.scale.valuesCount, this.scale.calculateCenterOffset(value));
					this.datasets[datasetIndex].points.push(new this.PointClass({
						value : value,
						label : label,
						x: pointPosition.x,
						y: pointPosition.y,
						strokeColor : this.datasets[datasetIndex].pointStrokeColor,
						fillColor : this.datasets[datasetIndex].pointColor
					}));
				},this);
	
				this.scale.labels.push(label);
	
				this.reflow();
	
				this.update();
			},
			removeData : function(){
				this.scale.valuesCount--;
				this.scale.labels.shift();
				helpers.each(this.datasets,function(dataset){
					dataset.points.shift();
				},this);
				this.reflow();
				this.update();
			},
			update : function(){
				this.eachPoints(function(point){
					point.save();
				});
				this.reflow();
				this.render();
			},
			reflow: function(){
				helpers.extend(this.scale, {
					width : this.chart.width,
					height: this.chart.height,
					size : helpers.min([this.chart.width, this.chart.height]),
					xCenter: this.chart.width/2,
					yCenter: this.chart.height/2
				});
				this.updateScaleRange(this.datasets);
				this.scale.setScaleSize();
				this.scale.buildYLabels();
			},
			draw : function(ease){
				var easeDecimal = ease || 1,
					ctx = this.chart.ctx;
				this.clear();
				this.scale.draw();
	
				helpers.each(this.datasets,function(dataset){
	
					//Transition each point first so that the line and point drawing isn't out of sync
					helpers.each(dataset.points,function(point,index){
						if (point.hasValue()){
							point.transition(this.scale.getPointPosition(index, this.scale.calculateCenterOffset(point.value)), easeDecimal);
						}
					},this);
	
	
	
					//Draw the line between all the points
					ctx.lineWidth = this.options.datasetStrokeWidth;
					ctx.strokeStyle = dataset.strokeColor;
					ctx.beginPath();
					helpers.each(dataset.points,function(point,index){
						if (index === 0){
							ctx.moveTo(point.x,point.y);
						}
						else{
							ctx.lineTo(point.x,point.y);
						}
					},this);
					ctx.closePath();
					ctx.stroke();
	
					ctx.fillStyle = dataset.fillColor;
					ctx.fill();
	
					//Now draw the points over the line
					//A little inefficient double looping, but better than the line
					//lagging behind the point positions
					helpers.each(dataset.points,function(point){
						if (point.hasValue()){
							point.draw();
						}
					});
	
				},this);
	
			}
	
		});
	
	
	
	
	
	}).call(this);


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $            = __webpack_require__(43)
	  , hide         = __webpack_require__(169)
	  , redefineAll  = __webpack_require__(511)
	  , ctx          = __webpack_require__(166)
	  , strictNew    = __webpack_require__(513)
	  , defined      = __webpack_require__(209)
	  , forOf        = __webpack_require__(283)
	  , $iterDefine  = __webpack_require__(284)
	  , step         = __webpack_require__(509)
	  , ID           = __webpack_require__(288)('id')
	  , $has         = __webpack_require__(210)
	  , isObject     = __webpack_require__(211)
	  , setSpecies   = __webpack_require__(1338)
	  , DESCRIPTORS  = __webpack_require__(167)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.e = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(283)
	  , classof = __webpack_require__(281);
	module.e = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $              = __webpack_require__(43)
	  , global         = __webpack_require__(147)
	  , $export        = __webpack_require__(77)
	  , fails          = __webpack_require__(168)
	  , hide           = __webpack_require__(169)
	  , redefineAll    = __webpack_require__(511)
	  , forOf          = __webpack_require__(283)
	  , strictNew      = __webpack_require__(513)
	  , isObject       = __webpack_require__(211)
	  , setToStringTag = __webpack_require__(212)
	  , DESCRIPTORS    = __webpack_require__(167);
	
	module.e = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(282);
	module.e = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// check on default Array iterator
	var Iterators  = __webpack_require__(148)
	  , ITERATOR   = __webpack_require__(86)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.e = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(126);
	module.e = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 509 */
469,
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = true;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var redefine = __webpack_require__(287);
	module.e = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global = __webpack_require__(147)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.e = function(key){
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};


/***/ },
/* 514 */
102,
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(514)
	  , min       = Math.min;
	module.e = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(1357);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.e = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var randomBytes = __webpack_require__(175);
	module.e = findPrime;
	findPrime.simpleSieve = simpleSieve;
	findPrime.fermatTest = fermatTest;
	var BN = __webpack_require__(39);
	var TWENTYFOUR = new BN(24);
	var MillerRabin = __webpack_require__(549);
	var millerRabin = new MillerRabin();
	var ONE = new BN(1);
	var TWO = new BN(2);
	var FIVE = new BN(5);
	var SIXTEEN = new BN(16);
	var EIGHT = new BN(8);
	var TEN = new BN(10);
	var THREE = new BN(3);
	var SEVEN = new BN(7);
	var ELEVEN = new BN(11);
	var FOUR = new BN(4);
	var TWELVE = new BN(12);
	var primes = null;
	
	function _getPrimes() {
	  if (primes !== null)
	    return primes;
	
	  var limit = 0x100000;
	  var res = [];
	  res[0] = 2;
	  for (var i = 1, k = 3; k < limit; k += 2) {
	    var sqrt = Math.ceil(Math.sqrt(k));
	    for (var j = 0; j < i && res[j] <= sqrt; j++)
	      if (k % res[j] === 0)
	        break;
	
	    if (i !== j && res[j] <= sqrt)
	      continue;
	
	    res[i++] = k;
	  }
	  primes = res;
	  return res;
	}
	
	function simpleSieve(p) {
	  var primes = _getPrimes();
	
	  for (var i = 0; i < primes.length; i++)
	    if (p.modn(primes[i]) === 0) {
	      if (p.cmpn(primes[i]) === 0) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	
	  return true;
	}
	
	function fermatTest(p) {
	  var red = BN.mont(p);
	  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
	}
	
	function findPrime(bits, gen) {
	  if (bits < 16) {
	    // this is what openssl does
	    if (gen === 2 || gen === 5) {
	      return new BN([0x8c, 0x7b]);
	    } else {
	      return new BN([0x8c, 0x27]);
	    }
	  }
	  gen = new BN(gen);
	
	  var num, n2;
	
	  while (true) {
	    num = new BN(randomBytes(Math.ceil(bits / 8)));
	    while (num.bitLength() > bits) {
	      num.ishrn(1);
	    }
	    if (num.isEven()) {
	      num.iadd(ONE);
	    }
	    if (!num.testn(1)) {
	      num.iadd(TWO);
	    }
	    if (!gen.cmp(TWO)) {
	      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
	        num.iadd(FOUR);
	      }
	    } else if (!gen.cmp(FIVE)) {
	      while (num.mod(TEN).cmp(THREE)) {
	        num.iadd(FOUR);
	      }
	    }
	    n2 = num.shrn(1);
	    if (simpleSieve(n2) && simpleSieve(num) &&
	      fermatTest(n2) && fermatTest(num) &&
	      millerRabin.test(n2) && millerRabin.test(num)) {
	      return num;
	    }
	  }
	
	}
	


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var prefix = __webpack_require__(1545)
	var toCamelCase = __webpack_require__(1729)
	var cache = { 'float': 'cssFloat' }
	var addPxToStyle = __webpack_require__(1084)
	
	function style (element, property, value) {
	  var camel = cache[property]
	  if (typeof camel === 'undefined') {
	    camel = detect(property)
	  }
	
	  // may be false if CSS prop is unsupported
	  if (camel) {
	    if (value === undefined) {
	      return element.style[camel]
	    }
	
	    element.style[camel] = addPxToStyle(camel, value)
	  }
	}
	
	function each (element, properties) {
	  for (var k in properties) {
	    if (properties.hasOwnProperty(k)) {
	      style(element, k, properties[k])
	    }
	  }
	}
	
	function detect (cssProp) {
	  var camel = toCamelCase(cssProp)
	  var result = prefix(camel)
	  cache[camel] = cache[cssProp] = cache[result] = result
	  return result
	}
	
	function set () {
	  if (arguments.length === 2) {
	    each(arguments[0], arguments[1])
	  } else {
	    style(arguments[0], arguments[1], arguments[2])
	  }
	}
	
	module.e = set
	module.e.set = set
	
	module.e.get = function (element, properties) {
	  if (Array.isArray(properties)) {
	    return properties.reduce(function (obj, prop) {
	      obj[prop] = style(element, prop || '')
	      return obj
	    }, {})
	  } else {
	    return style(element, properties || '')
	  }
	}
	


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var babelHelpers = __webpack_require__(218);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(150);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.e = exports['default'];


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	module.e = function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1;
	};


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var canUseDOM = __webpack_require__(127);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.e = off;


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var contains = __webpack_require__(173),
	    getWindow = __webpack_require__(216),
	    ownerDocument = __webpack_require__(150);
	
	module.e = function offset(node) {
	  var doc = ownerDocument(node),
	      win = getWindow(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!contains(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  if (box.width || box.height) {
	
	    box = {
	      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	      width: (box.width == null ? node.offsetWidth : box.width) || 0,
	      height: (box.height == null ? node.offsetHeight : box.height) || 0
	    };
	  }
	
	  return box;
	};


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var getWindow = __webpack_require__(216);
	
	module.e = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(1380);
	var msPattern = /^-ms-/;
	
	module.e = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var canUseDOM = __webpack_require__(127);
	
	var size;
	
	module.e = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(221);
	
	var _DOMUtils = __webpack_require__(294);
	
	var _createHistory = __webpack_require__(529);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.e = exports['default'];


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(151);
	
	var _PathUtils = __webpack_require__(129);
	
	var _ExecutionEnvironment = __webpack_require__(221);
	
	var _DOMUtils = __webpack_require__(294);
	
	var _DOMStateStorage = __webpack_require__(526);
	
	var _createDOMHistory = __webpack_require__(527);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.e = exports['default'];


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(1358);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(129);
	
	var _AsyncUtils = __webpack_require__(1463);
	
	var _Actions = __webpack_require__(151);
	
	var _createLocation2 = __webpack_require__(1465);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(296);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(295);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.e = exports['default'];


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(221);
	
	var _PathUtils = __webpack_require__(129);
	
	var _runTransitionHook = __webpack_require__(296);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(295);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.e = exports['default'];


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(1478)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1763);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.e = IntlMessageFormat;
	exports['default'] = exports;
	


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.e = restParam;
	


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var arrayPush = __webpack_require__(1491),
	    isArguments = __webpack_require__(300),
	    isArray = __webpack_require__(104),
	    isArrayLike = __webpack_require__(299),
	    isObjectLike = __webpack_require__(130);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.e = baseFlatten;
	


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var createBaseFor = __webpack_require__(1511);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.e = baseFor;
	


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toObject = __webpack_require__(87);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  object = toObject(object);
	  if (pathKey !== undefined && pathKey in object) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = toObject(object)[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.e = baseGet;
	


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseIsEqualDeep = __webpack_require__(1501),
	    isObject = __webpack_require__(105),
	    isObjectLike = __webpack_require__(130);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.e = baseIsEqual;
	


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toObject = __webpack_require__(87);
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : toObject(object)[key];
	  };
	}
	
	module.e = baseProperty;
	


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseProperty = __webpack_require__(538);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.e = getLength;
	


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	var isHostObject = (function() {
	  try {
	    Object({ 'toString': 0 } + '');
	  } catch(e) {
	    return function() { return false; };
	  }
	  return function(value) {
	    // IE < 9 presents many host objects as `Object` objects that can coerce
	    // to strings despite having improperly defined `toString` methods.
	    return typeof value.toString != 'function' && typeof (value + '') == 'string';
	  };
	}());
	
	module.e = isHostObject;
	


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.e = isIndex;
	


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isArray = __webpack_require__(104),
	    toObject = __webpack_require__(87);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.e = isKey;
	


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(105);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.e = isStrictComparable;
	


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toObject = __webpack_require__(87);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.e = pickByArray;
	


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseForIn = __webpack_require__(1498);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.e = pickByCallback;
	


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseToString = __webpack_require__(1507),
	    isArray = __webpack_require__(104);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.e = toPath;
	


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(105);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.e = isFunction;
	


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.e = identity;
	


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var bn = __webpack_require__(39);
	var brorand = __webpack_require__(491);
	
	function MillerRabin(rand) {
	  this.rand = rand || new brorand.Rand();
	}
	module.e = MillerRabin;
	
	MillerRabin.create = function create(rand) {
	  return new MillerRabin(rand);
	};
	
	MillerRabin.prototype._rand = function _rand(n) {
	  var len = n.bitLength();
	  var buf = this.rand.generate(Math.ceil(len / 8));
	
	  // Set low bits
	  buf[0] |= 3;
	
	  // Mask high bits
	  var mask = len & 0x7;
	  if (mask !== 0)
	    buf[buf.length - 1] >>= 7 - mask;
	
	  return new bn(buf);
	}
	
	MillerRabin.prototype.test = function test(n, k, cb) {
	  var len = n.bitLength();
	  var red = bn.mont(n);
	  var rone = new bn(1).toRed(red);
	
	  if (!k)
	    k = Math.max(1, (len / 48) | 0);
	
	  // Find d and s, (n - 1) = (2 ^ s) * d;
	  var n1 = n.subn(1);
	  var n2 = n1.subn(1);
	  for (var s = 0; !n1.testn(s); s++) {}
	  var d = n.shrn(s);
	
	  var rn1 = n1.toRed(red);
	
	  var prime = true;
	  for (; k > 0; k--) {
	    var a = this._rand(n2);
	    if (cb)
	      cb(a);
	
	    var x = a.toRed(red).redPow(d);
	    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
	      continue;
	
	    for (var i = 1; i < s; i++) {
	      x = x.redSqr();
	
	      if (x.cmp(rone) === 0)
	        return false;
	      if (x.cmp(rn1) === 0)
	        break;
	    }
	
	    if (i === s)
	      return false;
	  }
	
	  return prime;
	};
	
	MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
	  var len = n.bitLength();
	  var red = bn.mont(n);
	  var rone = new bn(1).toRed(red);
	
	  if (!k)
	    k = Math.max(1, (len / 48) | 0);
	
	  // Find d and s, (n - 1) = (2 ^ s) * d;
	  var n1 = n.subn(1);
	  var n2 = n1.subn(1);
	  for (var s = 0; !n1.testn(s); s++) {}
	  var d = n.shrn(s);
	
	  var rn1 = n1.toRed(red);
	
	  for (; k > 0; k--) {
	    var a = this._rand(n2);
	
	    var g = n.gcd(a);
	    if (g.cmpn(1) !== 0)
	      return g;
	
	    var x = a.toRed(red).redPow(d);
	    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
	      continue;
	
	    for (var i = 1; i < s; i++) {
	      x = x.redSqr();
	
	      if (x.cmp(rone) === 0)
	        return x.fromRed().subn(1).gcd(n);
	      if (x.cmp(rn1) === 0)
	        break;
	    }
	
	    if (i === s) {
	      x = x.redSqr();
	      return x.fromRed().subn(1).gcd(n);
	    }
	  }
	
	  return false;
	};
	


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var createHmac = __webpack_require__(291)
	var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
	
	exports.pbkdf2 = pbkdf2
	function pbkdf2 (password, salt, iterations, keylen, digest, callback) {
	  if (typeof digest === 'function') {
	    callback = digest
	    digest = undefined
	  }
	
	  if (typeof callback !== 'function') {
	    throw new Error('No callback provided to pbkdf2')
	  }
	
	  var result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	  setTimeout(function () {
	    callback(undefined, result)
	  })
	}
	
	exports.pbkdf2Sync = pbkdf2Sync
	function pbkdf2Sync (password, salt, iterations, keylen, digest) {
	  if (typeof iterations !== 'number') {
	    throw new TypeError('Iterations not a number')
	  }
	
	  if (iterations < 0) {
	    throw new TypeError('Bad iterations')
	  }
	
	  if (typeof keylen !== 'number') {
	    throw new TypeError('Key length not a number')
	  }
	
	  if (keylen < 0 || keylen > MAX_ALLOC) {
	    throw new TypeError('Bad key length')
	  }
	
	  digest = digest || 'sha1'
	
	  if (!Buffer.isBuffer(password)) password = new Buffer(password, 'binary')
	  if (!Buffer.isBuffer(salt)) salt = new Buffer(salt, 'binary')
	
	  var hLen
	  var l = 1
	  var DK = new Buffer(keylen)
	  var block1 = new Buffer(salt.length + 4)
	  salt.copy(block1, 0, 0, salt.length)
	
	  var r
	  var T
	
	  for (var i = 1; i <= l; i++) {
	    block1.writeUInt32BE(i, salt.length)
	    var U = createHmac(digest, password).update(block1).digest()
	
	    if (!hLen) {
	      hLen = U.length
	      T = new Buffer(hLen)
	      l = Math.ceil(keylen / hLen)
	      r = keylen - (l - 1) * hLen
	    }
	
	    U.copy(T, 0, 0, hLen)
	
	    for (var j = 1; j < iterations; j++) {
	      U = createHmac(digest, password).update(U).digest()
	
	      for (var k = 0; k < hLen; k++) {
	        T[k] ^= U[k]
	      }
	    }
	
	    var destPos = (i - 1) * hLen
	    var len = (i === l ? r : hLen)
	    T.copy(DK, destPos, 0, len)
	  }
	
	  return DK
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var createHash = __webpack_require__(149);
	module.e = function (seed, len) {
	  var t = new Buffer('');
	  var  i = 0, c;
	  while (t.length < len) {
	    c = i2ops(i++);
	    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
	  }
	  return t.slice(0, len);
	};
	
	function i2ops(c) {
	  var out = new Buffer(4);
	  out.writeUInt32BE(c,0);
	  return out;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var bn = __webpack_require__(39);
	function withPublic(paddedMsg, key) {
	  return new Buffer(paddedMsg
	    .toRed(bn.mont(key.modulus))
	    .redPow(new bn(key.publicExponent))
	    .fromRed()
	    .toArray());
	}
	
	module.e = withPublic;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function xor(a, b) {
	  var len = a.length;
	  var i = -1;
	  while (++i < len) {
	    a[i] ^= b[i];
	  }
	  return a
	};


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibAll = __webpack_require__(229);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _Button = __webpack_require__(133);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var ButtonGroup = _react2['default'].createClass({
	  displayName: 'ButtonGroup',
	
	  propTypes: {
	    vertical: _react2['default'].PropTypes.bool,
	    justified: _react2['default'].PropTypes.bool,
	    /**
	     * Display block buttons, only useful when used with the "vertical" prop.
	     * @type {bool}
	     */
	    block: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (props) {
	      if (props.block && !props.vertical) {
	        return new Error('The block property requires the vertical property to be set to have any effect');
	      }
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      block: false,
	      justified: false,
	      vertical: false
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = !this.props.vertical;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'vertical')] = this.props.vertical;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'justified')] = this.props.justified;
	
	    // this is annoying, since the class is `btn-block` not `btn-group-block`
	    classes[_utilsBootstrapUtils2['default'].prefix(_Button2['default'].defaultProps, 'block')] = this.props.block;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('btn-group', ButtonGroup);
	module.e = exports['default'];


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styleMaps = __webpack_require__(58);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Col = _react2['default'].createClass({
	  displayName: 'Col',
	
	  propTypes: {
	    /**
	     * The number of columns you wish to span
	     *
	     * for Extra small devices Phones (<768px)
	     *
	     * class-prefix `col-xs-`
	     */
	    xs: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Small devices Tablets (≥768px)
	     *
	     * class-prefix `col-sm-`
	     */
	    sm: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Medium devices Desktops (≥992px)
	     *
	     * class-prefix `col-md-`
	     */
	    md: _react2['default'].PropTypes.number,
	    /**
	     * The number of columns you wish to span
	     *
	     * for Large devices Desktops (≥1200px)
	     *
	     * class-prefix `col-lg-`
	     */
	    lg: _react2['default'].PropTypes.number,
	    /**
	     * Hide column
	     *
	     * on Extra small devices Phones
	     *
	     * adds class `hidden-xs`
	     */
	    xsHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Small devices Tablets
	     *
	     * adds class `hidden-sm`
	     */
	    smHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Medium devices Desktops
	     *
	     * adds class `hidden-md`
	     */
	    mdHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Hide column
	     *
	     * on Large devices Desktops
	     *
	     * adds class `hidden-lg`
	     */
	    lgHidden: _react2['default'].PropTypes.bool,
	    /**
	     * Move columns to the right
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-offset-`
	     */
	    xsOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-offset-`
	     */
	    smOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-offset-`
	     */
	    mdOffset: _react2['default'].PropTypes.number,
	    /**
	     * Move columns to the right
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-offset-`
	     */
	    lgOffset: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-push-`
	     */
	    xsPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-push-`
	     */
	    smPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-push-`
	     */
	    mdPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the right
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-push-`
	     */
	    lgPush: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Extra small devices Phones
	     *
	     * class-prefix `col-xs-pull-`
	     */
	    xsPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Small devices Tablets
	     *
	     * class-prefix `col-sm-pull-`
	     */
	    smPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Medium devices Desktops
	     *
	     * class-prefix `col-md-pull-`
	     */
	    mdPull: _react2['default'].PropTypes.number,
	    /**
	     * Change the order of grid columns to the left
	     *
	     * for Large devices Desktops
	     *
	     * class-prefix `col-lg-pull-`
	     */
	    lgPull: _react2['default'].PropTypes.number,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ComponentClass = this.props.componentClass;
	    var classes = {};
	
	    _Object$keys(_styleMaps2['default'].SIZES).forEach(function (key) {
	      var size = _styleMaps2['default'].SIZES[key];
	      var prop = size;
	      var classPart = size + '-';
	
	      if (_this.props[prop]) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      classes['hidden-' + size] = _this.props[size + 'Hidden'];
	
	      prop = size + 'Offset';
	      classPart = size + '-offset-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      prop = size + 'Push';
	      classPart = size + '-push-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	
	      prop = size + 'Pull';
	      classPart = size + '-pull-';
	      if (_this.props[prop] >= 0) {
	        classes['col-' + classPart + _this.props[prop]] = true;
	      }
	    }, this);
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Col;
	module.e = exports['default'];


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(133);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var CARET = _react2['default'].createElement(
	  'span',
	  null,
	  ' ',
	  _react2['default'].createElement('span', { className: 'caret' })
	);
	
	var DropdownToggle = (function (_React$Component) {
	  _inherits(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    _classCallCheck(this, DropdownToggle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var caret = this.props.noCaret ? null : CARET;
	
	    var classes = {
	      'dropdown-toggle': true
	    };
	
	    var Component = this.props.useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	
	    return _react2['default'].createElement(
	      Component,
	      _extends({}, this.props, {
	        className: _classnames2['default'](classes, this.props.className),
	        type: 'button',
	        'aria-haspopup': true,
	        'aria-expanded': this.props.open }),
	      this.props.children || this.props.title,
	      caret
	    );
	  };
	
	  return DropdownToggle;
	})(_react2['default'].Component);
	
	exports['default'] = DropdownToggle;
	
	DropdownToggle.defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	DropdownToggle.propTypes = {
	  bsRole: _react2['default'].PropTypes.string,
	  noCaret: _react2['default'].PropTypes.bool,
	  open: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.string,
	  useAnchor: _react2['default'].PropTypes.bool
	};
	
	DropdownToggle.isToggle = true;
	DropdownToggle.titleProp = 'title';
	DropdownToggle.onClickProp = 'onClick';
	module.e = exports['default'];


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _Static2 = __webpack_require__(1563);
	
	var _Static3 = _interopRequireDefault(_Static2);
	
	exports.Static = _Static3['default'];


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var FormGroup = (function (_React$Component) {
	  _inherits(FormGroup, _React$Component);
	
	  function FormGroup() {
	    _classCallCheck(this, FormGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  FormGroup.prototype.render = function render() {
	    var classes = {
	      'form-group': !this.props.standalone,
	      'form-group-lg': !this.props.standalone && this.props.bsSize === 'large',
	      'form-group-sm': !this.props.standalone && this.props.bsSize === 'small',
	      'has-feedback': this.props.hasFeedback,
	      'has-success': this.props.bsStyle === 'success',
	      'has-warning': this.props.bsStyle === 'warning',
	      'has-error': this.props.bsStyle === 'error'
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](classes, this.props.groupClassName) },
	      this.props.children
	    );
	  };
	
	  return FormGroup;
	})(_react2['default'].Component);
	
	FormGroup.defaultProps = {
	  hasFeedback: false,
	  standalone: false
	};
	
	FormGroup.propTypes = {
	  standalone: _react2['default'].PropTypes.bool,
	  hasFeedback: _react2['default'].PropTypes.bool,
	  bsSize: function bsSize(props) {
	    if (props.standalone && props.bsSize !== undefined) {
	      return new Error('bsSize will not be used when `standalone` is set.');
	    }
	
	    return _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']).apply(null, arguments);
	  },
	  bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  groupClassName: _react2['default'].PropTypes.string
	};
	
	exports['default'] = FormGroup;
	module.e = exports['default'];


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://www.npmjs.org/package/react-interpolate-component
	// TODO: Drop this in favor of es6 string interpolation
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var REGEXP = /\%\((.+?)\)s/;
	
	var Interpolate = _react2['default'].createClass({
	  displayName: 'Interpolate',
	
	  propTypes: {
	    component: _react2['default'].PropTypes.node,
	    format: _react2['default'].PropTypes.string,
	    unsafe: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'span',
	      unsafe: false
	    };
	  },
	
	  render: function render() {
	    var format = _utilsValidComponentChildren2['default'].hasValidComponent(this.props.children) || typeof this.props.children === 'string' ? this.props.children : this.props.format;
	    var parent = this.props.component;
	    var unsafe = this.props.unsafe === true;
	    var props = _extends({}, this.props);
	
	    delete props.children;
	    delete props.format;
	    delete props.component;
	    delete props.unsafe;
	
	    if (unsafe) {
	      var content = format.split(REGEXP).reduce(function (memo, match, index) {
	        var html = undefined;
	
	        if (index % 2 === 0) {
	          html = match;
	        } else {
	          html = props[match];
	          delete props[match];
	        }
	
	        if (_react2['default'].isValidElement(html)) {
	          throw new Error('cannot interpolate a React component into unsafe text');
	        }
	
	        memo += html;
	
	        return memo;
	      }, '');
	
	      props.dangerouslySetInnerHTML = { __html: content };
	
	      return _react2['default'].createElement(parent, props);
	    }
	    var kids = format.split(REGEXP).reduce(function (memo, match, index) {
	      var child = undefined;
	
	      if (index % 2 === 0) {
	        if (match.length === 0) {
	          return memo;
	        }
	
	        child = match;
	      } else {
	        child = props[match];
	        delete props[match];
	      }
	
	      memo.push(child);
	
	      return memo;
	    }, []);
	
	    return _react2['default'].createElement(parent, props, kids);
	  }
	});
	
	exports['default'] = Interpolate;
	module.e = exports['default'];


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ListGroupItem = (function (_React$Component) {
	  _inherits(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    _classCallCheck(this, ListGroupItem);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ListGroupItem.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes.active = this.props.active;
	    classes.disabled = this.props.disabled;
	
	    if (this.props.href) {
	      return this.renderAnchor(classes);
	    } else if (this.props.onClick) {
	      return this.renderButton(classes);
	    } else if (this.props.listItem) {
	      return this.renderLi(classes);
	    }
	
	    return this.renderSpan(classes);
	  };
	
	  ListGroupItem.prototype.renderLi = function renderLi(classes) {
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderAnchor = function renderAnchor(classes) {
	    return _react2['default'].createElement(
	      'a',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderButton = function renderButton(classes) {
	    return _react2['default'].createElement(
	      'button',
	      _extends({
	        type: 'button'
	      }, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderSpan = function renderSpan(classes) {
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.header ? this.renderStructuredContent() : this.props.children
	    );
	  };
	
	  ListGroupItem.prototype.renderStructuredContent = function renderStructuredContent() {
	    var header = undefined;
	    var headingClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'heading');
	
	    if (_react2['default'].isValidElement(this.props.header)) {
	      header = _react.cloneElement(this.props.header, {
	        key: 'header',
	        className: _classnames2['default'](this.props.header.props.className, headingClass)
	      });
	    } else {
	      header = _react2['default'].createElement(
	        'h4',
	        { key: 'header', className: headingClass },
	        this.props.header
	      );
	    }
	
	    var content = _react2['default'].createElement(
	      'p',
	      { key: 'content', className: _utilsBootstrapUtils2['default'].prefix(this.props, 'text') },
	      this.props.children
	    );
	
	    return [header, content];
	  };
	
	  return ListGroupItem;
	})(_react2['default'].Component);
	
	ListGroupItem.propTypes = {
	  className: _react2['default'].PropTypes.string,
	  active: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.node,
	  listItem: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any,
	  href: _react2['default'].PropTypes.string,
	  target: _react2['default'].PropTypes.string
	};
	
	ListGroupItem.defaultTypes = {
	  listItem: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _utilsBootstrapUtils.bsClass('list-group-item', ListGroupItem));
	module.e = exports['default'];


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var ModalBody = (function (_React$Component) {
	  _inherits(ModalBody, _React$Component);
	
	  function ModalBody() {
	    _classCallCheck(this, ModalBody);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalBody.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'body')) }),
	      this.props.children
	    );
	  };
	
	  return ModalBody;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalBody);
	module.e = exports['default'];


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var ModalFooter = (function (_React$Component) {
	  _inherits(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    _classCallCheck(this, ModalFooter);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalFooter.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'footer')) }),
	      this.props.children
	    );
	  };
	
	  return ModalFooter;
	})(_react2['default'].Component);
	
	ModalFooter.propTypes = {
	  /**
	   * A css class applied to the Component
	   */
	  bsClass: _react2['default'].PropTypes.string
	};
	
	ModalFooter.defaultProps = {
	  bsClass: 'modal'
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalFooter);
	module.e = exports['default'];


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var ModalHeader = (function (_React$Component) {
	  _inherits(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    _classCallCheck(this, ModalHeader);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props;
	    var label = _props['aria-label'];
	
	    var props = _objectWithoutProperties(_props, ['aria-label']);
	
	    var onHide = _utilsCreateChainedFunction2['default'](this.context.$bs_onModalHide, this.props.onHide);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'header'))
	      }),
	      this.props.closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: onHide },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '×'
	        )
	      ),
	      this.props.children
	    );
	  };
	
	  return ModalHeader;
	})(_react2['default'].Component);
	
	ModalHeader.propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close button.
	   * It is used for Assistive Technology when the label text is not readable.
	   */
	  'aria-label': _react2['default'].PropTypes.string,
	
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside a Modal component, the onHide will automatically
	   * be propagated up to the parent Modal `onHide`.
	   */
	  onHide: _react2['default'].PropTypes.func
	};
	
	ModalHeader.contextTypes = {
	  '$bs_onModalHide': _react2['default'].PropTypes.func
	};
	
	ModalHeader.defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalHeader);
	module.e = exports['default'];


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var ModalTitle = (function (_React$Component) {
	  _inherits(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    _classCallCheck(this, ModalTitle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ModalTitle.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'h4',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].prefix(this.props, 'title')) }),
	      this.props.children
	    );
	  };
	
	  return ModalTitle;
	})(_react2['default'].Component);
	
	exports['default'] = _utilsBootstrapUtils.bsClass('modal', ModalTitle);
	module.e = exports['default'];


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibAll = __webpack_require__(229);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(178);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _Collapse = __webpack_require__(176);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var Nav = (function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav() {
	    _classCallCheck(this, Nav);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Nav.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var ulClassName = _props.ulClassName;
	    var id = _props.id;
	    var ulId = _props.ulId;
	
	    var isNavbar = this.props.navbar != null ? this.props.navbar : this.context.$bs_navbar;
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'stacked')] = this.props.stacked;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'justified')] = this.props.justified;
	
	    if (isNavbar) {
	      var bsClass = this.context.$bs_navbar_bsClass || 'navbar';
	      var navbarRight = this.props.right != null ? this.props.right : this.props.pullRight;
	
	      classes[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'nav')] = true;
	      classes[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'right')] = navbarRight;
	      classes[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'left')] = this.props.pullLeft;
	    } else {
	      classes['pull-right'] = this.props.pullRight;
	      classes['pull-left'] = this.props.pullLeft;
	    }
	
	    var list = _react2['default'].createElement(
	      'ul',
	      _extends({ ref: 'ul'
	      }, this.props, {
	        id: ulId || id,
	        role: this.props.bsStyle === 'tabs' ? 'tablist' : null,
	        className: _classnames2['default'](className, ulClassName, classes)
	      }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderNavItem, this)
	    );
	
	    // TODO remove in 0.29
	    if (this.context.$bs_deprecated_navbar && this.props.collapsible) {
	      list = _react2['default'].createElement(
	        _Collapse2['default'],
	        {
	          'in': this.props.expanded,
	          className: isNavbar ? 'navbar-collapse' : void 0
	        },
	        _react2['default'].createElement(
	          'div',
	          null,
	          list
	        )
	      );
	    }
	
	    return list;
	  };
	
	  Nav.prototype.getChildActiveProp = function getChildActiveProp(child) {
	    if (child.props.active) {
	      return true;
	    }
	    if (this.props.activeKey != null) {
	      if (child.props.eventKey === this.props.activeKey) {
	        return true;
	      }
	    }
	    if (this.props.activeHref != null) {
	      if (child.props.href === this.props.activeHref) {
	        return true;
	      }
	    }
	
	    return child.props.active;
	  };
	
	  Nav.prototype.renderNavItem = function renderNavItem(child, index) {
	    return _react.cloneElement(child, {
	      role: this.props.bsStyle === 'tabs' ? 'tab' : null,
	      active: this.getChildActiveProp(child),
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      key: child.key ? child.key : index,
	      navItem: true
	    });
	  };
	
	  return Nav;
	})(_react2['default'].Component);
	
	Nav.propTypes = {
	  activeHref: _react2['default'].PropTypes.string,
	  activeKey: _react2['default'].PropTypes.any,
	
	  stacked: _react2['default'].PropTypes.bool,
	  justified: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (_ref) {
	    var justified = _ref.justified;
	    var navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * CSS classes for the wrapper `nav` element
	   */
	  className: _react2['default'].PropTypes.string,
	  /**
	   * HTML id for the wrapper `nav` element
	   */
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  /**
	   * CSS classes for the inner `ul` element
	   *
	   * @deprecated
	   */
	  ulClassName: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.string, 'The wrapping `<nav>` has been removed you can use `className` now'),
	  /**
	   * HTML id for the inner `ul` element
	   *
	   * @deprecated
	   */
	
	  ulId: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.string, 'The wrapping `<nav>` has been removed you can use `id` now'),
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2['default'].PropTypes.bool,
	  eventKey: _react2['default'].PropTypes.any,
	  pullRight: _react2['default'].PropTypes.bool,
	  pullLeft: _react2['default'].PropTypes.bool,
	
	  right: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use the `pullRight` prop instead'),
	
	  /**
	   * @private
	   */
	  expanded: _react2['default'].PropTypes.bool,
	
	  /**
	   * @private
	   */
	  collapsible: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use `Navbar.Collapse` instead, to create collapsible Navbars')
	};
	
	Nav.contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.bool,
	  $bs_navbar_bsClass: _react2['default'].PropTypes.string,
	
	  $bs_deprecated_navbar: _react2['default'].PropTypes.bool
	};
	
	Nav.defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('nav', _utilsBootstrapUtils.bsStyles(['tabs', 'pills'], Nav));
	module.e = exports['default'];


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _NavbarBrand = __webpack_require__(311);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _utilsDeprecationWarning = __webpack_require__(228);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(_NavbarBrand2['default'], {
	  message: 'The `NavBrand` component has been renamed to: `NavbarBrand`. ' + 'Please use that component instead; this alias will be removed in an upcoming release'
	});
	module.e = exports['default'];


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var NavItem = _react2['default'].createClass({
	  displayName: 'NavItem',
	
	  propTypes: {
	    linkId: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func,
	    active: _react2['default'].PropTypes.bool,
	    disabled: _react2['default'].PropTypes.bool,
	    href: _react2['default'].PropTypes.string,
	    onClick: _react2['default'].PropTypes.func,
	    role: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.node,
	    eventKey: _react2['default'].PropTypes.any,
	    target: _react2['default'].PropTypes.string,
	    'aria-controls': _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var role = _props.role;
	    var linkId = _props.linkId;
	    var disabled = _props.disabled;
	    var active = _props.active;
	    var href = _props.href;
	    var onClick = _props.onClick;
	    var title = _props.title;
	    var target = _props.target;
	    var children = _props.children;
	    var tabIndex = _props.tabIndex;
	    var ariaControls = _props['aria-controls'];
	
	    var props = _objectWithoutProperties(_props, ['role', 'linkId', 'disabled', 'active', 'href', 'onClick', 'title', 'target', 'children', 'tabIndex', 'aria-controls']);
	
	    var classes = {
	      active: active,
	      disabled: disabled
	    };
	    var linkProps = {
	      role: role,
	      href: href,
	      onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick),
	      title: title,
	      target: target,
	      tabIndex: tabIndex,
	      id: linkId
	    };
	
	    if (!role && href === '#') {
	      linkProps.role = 'button';
	    } else if (role === 'tab') {
	      linkProps['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, props, { role: 'presentation', className: _classnames2['default'](props.className, classes) }),
	      _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, linkProps, { 'aria-controls': ariaControls }),
	        children
	      )
	    );
	  },
	
	  handleClick: function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, this.props.href, this.props.target);
	      }
	    }
	  }
	});
	
	exports['default'] = NavItem;
	module.e = exports['default'];
	//eslint-disable-line


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint react/prop-types: [2, {ignore: ["container", "containerPadding", "target", "placement", "children"] }] */
	/* These properties are validated in 'Portal' and 'Position' components */
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOverlaysLibOverlay = __webpack_require__(1615);
	
	var _reactOverlaysLibOverlay2 = _interopRequireDefault(_reactOverlaysLibOverlay);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Fade = __webpack_require__(307);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Overlay = (function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props;
	    var child = _props.children;
	    var transition = _props.animation;
	
	    var props = _objectWithoutProperties(_props, ['children', 'animation']);
	
	    if (transition === true) {
	      transition = _Fade2['default'];
	    }
	
	    if (transition === false) {
	      transition = null;
	    }
	
	    if (!transition) {
	      child = _react.cloneElement(child, {
	        className: _classnames2['default']('in', child.props.className)
	      });
	    }
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibOverlay2['default'],
	      _extends({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	})(_react2['default'].Component);
	
	Overlay.propTypes = _extends({}, _reactOverlaysLibOverlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Use animation
	   */
	  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _reactPropTypesLibElementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func
	});
	
	Overlay.defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false
	};
	
	exports['default'] = Overlay;
	module.e = exports['default'];


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var PanelGroup = _react2['default'].createClass({
	  displayName: 'PanelGroup',
	
	  propTypes: {
	    accordion: _react2['default'].PropTypes.bool,
	    activeKey: _react2['default'].PropTypes.any,
	    className: _react2['default'].PropTypes.string,
	    children: _react2['default'].PropTypes.node,
	    defaultActiveKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      accordion: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var defaultActiveKey = this.props.defaultActiveKey;
	
	    return {
	      activeKey: defaultActiveKey
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    if (this.props.accordion) {
	      props.role = 'tablist';
	    }
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, { className: _classnames2['default'](className, classes), onSelect: null }),
	      _utilsValidComponentChildren2['default'].map(props.children, this.renderPanel)
	    );
	  },
	
	  renderPanel: function renderPanel(child, index) {
	    var activeKey = this.props.activeKey != null ? this.props.activeKey : this.state.activeKey;
	
	    var props = {
	      bsStyle: child.props.bsStyle || this.props.bsStyle,
	      key: child.key ? child.key : index,
	      ref: child.ref
	    };
	
	    if (this.props.accordion) {
	      props.headerRole = 'tab';
	      props.panelRole = 'tabpanel';
	      props.collapsible = true;
	      props.expanded = child.props.eventKey === activeKey;
	      props.onSelect = this.handleSelect;
	    }
	
	    return _react.cloneElement(child, props);
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleSelect: function handleSelect(e, key) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this._isChanging = true;
	      this.props.onSelect(key);
	      this._isChanging = false;
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({
	      activeKey: key
	    });
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('panel-group', PanelGroup);
	module.e = exports['default'];


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.e = exports['default'];


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactPropTypesLibMountable = __webpack_require__(314);
	
	var _reactPropTypesLibMountable2 = _interopRequireDefault(_reactPropTypesLibMountable);
	
	var _utilsOwnerDocument = __webpack_require__(177);
	
	var _utilsOwnerDocument2 = _interopRequireDefault(_utilsOwnerDocument);
	
	var _utilsGetContainer = __webpack_require__(313);
	
	var _utilsGetContainer2 = _interopRequireDefault(_utilsGetContainer);
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2['default'].createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2['default'].PropTypes.oneOfType([_reactPropTypesLibMountable2['default'], _react2['default'].PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = _utilsGetContainer2['default'](nextProps.container, _utilsOwnerDocument2['default'](this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = _utilsGetContainer2['default'](this.props.container, _utilsOwnerDocument2['default'](this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2['default'].Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2['default'].unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	
	  render: function render() {
	    return null;
	  },
	
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      if (this._overlayInstance.getWrappedDOMNode) {
	        return this._overlayInstance.getWrappedDOMNode();
	      } else {
	        return _reactDom2['default'].findDOMNode(this._overlayInstance);
	      }
	    }
	
	    return null;
	  }
	
	});
	
	exports['default'] = Portal;
	module.e = exports['default'];


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsAddEventListener = __webpack_require__(574);
	
	var _utilsAddEventListener2 = _interopRequireDefault(_utilsAddEventListener);
	
	var _utilsCreateChainedFunction = __webpack_require__(1618);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsOwnerDocument = __webpack_require__(177);
	
	var _utilsOwnerDocument2 = _interopRequireDefault(_utilsOwnerDocument);
	
	// TODO: Consider using an ES6 symbol here, once we use babel-runtime.
	var CLICK_WAS_INSIDE = '__click_was_inside';
	
	var counter = 0;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	function getSuppressRootClose() {
	  var id = CLICK_WAS_INSIDE + '_' + counter++;
	  return {
	    id: id,
	    suppressRootClose: function suppressRootClose(event) {
	      // Tag the native event to prevent the root close logic on document click.
	      // This seems safer than using event.nativeEvent.stopImmediatePropagation(),
	      // which is only supported in IE >= 9.
	      event.nativeEvent[id] = true;
	    }
	  };
	}
	
	var RootCloseWrapper = (function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    _React$Component.call(this, props);
	
	    this.handleDocumentClick = this.handleDocumentClick.bind(this);
	    this.handleDocumentKeyUp = this.handleDocumentKeyUp.bind(this);
	
	    var _getSuppressRootClose = getSuppressRootClose();
	
	    var id = _getSuppressRootClose.id;
	    var suppressRootClose = _getSuppressRootClose.suppressRootClose;
	
	    this._suppressRootId = id;
	
	    this._suppressRootCloseHandler = suppressRootClose;
	  }
	
	  RootCloseWrapper.prototype.bindRootCloseHandlers = function bindRootCloseHandlers() {
	    var doc = _utilsOwnerDocument2['default'](this);
	
	    this._onDocumentClickListener = _utilsAddEventListener2['default'](doc, 'click', this.handleDocumentClick);
	
	    this._onDocumentKeyupListener = _utilsAddEventListener2['default'](doc, 'keyup', this.handleDocumentKeyUp);
	  };
	
	  RootCloseWrapper.prototype.handleDocumentClick = function handleDocumentClick(e) {
	    // This is now the native event.
	    if (e[this._suppressRootId]) {
	      return;
	    }
	
	    if (isModifiedEvent(e) || !isLeftClickEvent(e)) {
	      return;
	    }
	
	    this.props.onRootClose();
	  };
	
	  RootCloseWrapper.prototype.handleDocumentKeyUp = function handleDocumentKeyUp(e) {
	    if (e.keyCode === 27) {
	      this.props.onRootClose();
	    }
	  };
	
	  RootCloseWrapper.prototype.unbindRootCloseHandlers = function unbindRootCloseHandlers() {
	    if (this._onDocumentClickListener) {
	      this._onDocumentClickListener.remove();
	    }
	
	    if (this._onDocumentKeyupListener) {
	      this._onDocumentKeyupListener.remove();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    this.bindRootCloseHandlers();
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    var _props = this.props;
	    var noWrap = _props.noWrap;
	    var children = _props.children;
	
	    var child = _react2['default'].Children.only(children);
	
	    if (noWrap) {
	      return _react2['default'].cloneElement(child, {
	        onClick: _utilsCreateChainedFunction2['default'](this._suppressRootCloseHandler, child.props.onClick)
	      });
	    }
	
	    // Wrap the child in a new element, so the child won't have to handle
	    // potentially combining multiple onClick listeners.
	    return _react2['default'].createElement(
	      'div',
	      { onClick: this._suppressRootCloseHandler },
	      child
	    );
	  };
	
	  RootCloseWrapper.prototype.getWrappedDOMNode = function getWrappedDOMNode() {
	    // We can't use a ref to identify the wrapped child, since we might be
	    // stealing the ref from the owner, but we know exactly the DOM structure
	    // that will be rendered, so we can just do this to get the child's DOM
	    // node for doing size calculations in OverlayMixin.
	    var node = _reactDom2['default'].findDOMNode(this);
	    return this.props.noWrap ? node : node.firstChild;
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unbindRootCloseHandlers();
	  };
	
	  return RootCloseWrapper;
	})(_react2['default'].Component);
	
	exports['default'] = RootCloseWrapper;
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  onRootClose: _react2['default'].PropTypes.func.isRequired,
	
	  /**
	   * Passes the suppress click handler directly to the child component instead
	   * of placing it on a wrapping div. Only use when you can be sure the child
	   * properly handle the click event.
	   */
	  noWrap: _react2['default'].PropTypes.bool
	};
	module.e = exports['default'];


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domHelpersTransitionProperties = __webpack_require__(1379);
	
	var _domHelpersTransitionProperties2 = _interopRequireDefault(_domHelpersTransitionProperties);
	
	var _domHelpersEventsOn = __webpack_require__(293);
	
	var _domHelpersEventsOn2 = _interopRequireDefault(_domHelpersEventsOn);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var transitionEndEvent = _domHelpersTransitionProperties2['default'].end;
	
	var UNMOUNTED = 0;
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 1;
	exports.EXITED = EXITED;
	var ENTERING = 2;
	exports.ENTERING = ENTERING;
	var ENTERED = 3;
	exports.ENTERED = ENTERED;
	var EXITING = 4;
	
	exports.EXITING = EXITING;
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecyle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = (function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    _React$Component.call(this, props, context);
	
	    var initialStatus = undefined;
	    if (props['in']) {
	      // Start enter transition in componentDidMount.
	      initialStatus = props.transitionAppear ? EXITED : ENTERED;
	    } else {
	      initialStatus = props.unmountOnExit ? UNMOUNTED : EXITED;
	    }
	    this.state = { status: initialStatus };
	
	    this.nextCallback = null;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.transitionAppear && this.props['in']) {
	      this.performEnter(this.props);
	    }
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps['in'] && this.props.unmountOnExit) {
	      if (this.state.status === UNMOUNTED) {
	        // Start enter transition in componentDidUpdate.
	        this.setState({ status: EXITED });
	      }
	    } else {
	      this._needsUpdate = true;
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    var status = this.state.status;
	
	    if (this.props.unmountOnExit && status === EXITED) {
	      // EXITED is always a transitional state to either ENTERING or UNMOUNTED
	      // when using unmountOnExit.
	      if (this.props['in']) {
	        this.performEnter(this.props);
	      } else {
	        this.setState({ status: UNMOUNTED });
	      }
	
	      return;
	    }
	
	    // guard ensures we are only responding to prop changes
	    if (this._needsUpdate) {
	      this._needsUpdate = false;
	
	      if (this.props['in']) {
	        if (status === EXITING) {
	          this.performEnter(this.props);
	        } else if (status === EXITED) {
	          this.performEnter(this.props);
	        }
	        // Otherwise we're already entering or entered.
	      } else {
	          if (status === ENTERING || status === ENTERED) {
	            this.performExit(this.props);
	          }
	          // Otherwise we're already exited or exiting.
	        }
	    }
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.performEnter = function performEnter(props) {
	    var _this = this;
	
	    this.cancelNextCallback();
	    var node = _reactDom2['default'].findDOMNode(this);
	
	    // Not this.props, because we might be about to receive new props.
	    props.onEnter(node);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this.props.onEntering(node);
	
	      _this.onTransitionEnd(node, function () {
	        _this.safeSetState({ status: ENTERED }, function () {
	          _this.props.onEntered(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(props) {
	    var _this2 = this;
	
	    this.cancelNextCallback();
	    var node = _reactDom2['default'].findDOMNode(this);
	
	    // Not this.props, because we might be about to receive new props.
	    props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this2.props.onExiting(node);
	
	      _this2.onTransitionEnd(node, function () {
	        _this2.safeSetState({ status: EXITED }, function () {
	          _this2.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    this.setState(nextState, this.setNextCallback(callback));
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this3 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this3.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      _domHelpersEventsOn2['default'](node, transitionEndEvent, this.nextCallback);
	      setTimeout(this.nextCallback, this.props.timeout);
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	
	    var childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = undefined;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, _extends({}, childProps, {
	      className: _classnames2['default'](child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	})(_react2['default'].Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2['default'].PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2['default'].PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2['default'].PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2['default'].PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  'in': false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports['default'] = Transition;


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domHelpersEventsOn = __webpack_require__(293);
	
	var _domHelpersEventsOn2 = _interopRequireDefault(_domHelpersEventsOn);
	
	var _domHelpersEventsOff = __webpack_require__(521);
	
	var _domHelpersEventsOff2 = _interopRequireDefault(_domHelpersEventsOff);
	
	exports['default'] = function (node, event, handler) {
	  _domHelpersEventsOn2['default'](node, event, handler);
	  return {
	    remove: function remove() {
	      _domHelpersEventsOff2['default'](node, event, handler);
	    }
	  };
	};
	
	module.e = exports['default'];


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isOverflowing;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domHelpersQueryIsWindow = __webpack_require__(216);
	
	var _domHelpersQueryIsWindow2 = _interopRequireDefault(_domHelpersQueryIsWindow);
	
	var _domHelpersOwnerDocument = __webpack_require__(150);
	
	var _domHelpersOwnerDocument2 = _interopRequireDefault(_domHelpersOwnerDocument);
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = _domHelpersOwnerDocument2['default'](node);
	  var win = _domHelpersQueryIsWindow2['default'](doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = _domHelpersQueryIsWindow2['default'](container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	
	module.e = exports['default'];


/***/ },
/* 576 */
315,
/* 577 */
[1769, 576],
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2['default'].createClass({
	  displayName: 'Link',
	
	  contextTypes: {
	    router: object
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      className: '',
	      style: {}
	    };
	  },
	
	  handleClick: function handleClick(event) {
	    var allowTransition = true;
	
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    if (event.defaultPrevented === true) allowTransition = false;
	
	    // If target prop is set (e.g. to "_blank") let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) {
	      if (!allowTransition) event.preventDefault();
	
	      return;
	    }
	
	    event.preventDefault();
	
	    if (allowTransition) {
	      var _props = this.props;
	      var to = _props.to;
	      var query = _props.query;
	      var hash = _props.hash;
	      var state = _props.state;
	
	      var _location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	      this.context.router.push(_location);
	    }
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? _routerWarning2['default'](!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : undefined;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	    if (router) {
	      var _location2 = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(_location2);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(_location2, onlyActiveOnIndex)) {
	          if (activeClassName) props.className += props.className === '' ? activeClassName : ' ' + activeClassName;
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2['default'].createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	
	});
	
	exports['default'] = Link;
	module.e = exports['default'];


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _PatternUtils = __webpack_require__(153);
	
	var _PropTypes = __webpack_require__(134);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	var Redirect = _react2['default'].createClass({
	  displayName: 'Redirect',
	
	  statics: {
	
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = _RouteUtils.createRouteFromReactElement(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	        var pathname = undefined;
	        if (route.to.charAt(0) === '/') {
	          pathname = _PatternUtils.formatPattern(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = _PatternUtils.formatPattern(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _PropTypes.falsy,
	    children: _PropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<Redirect> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = Redirect;
	module.e = exports['default'];


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecateObjectProperties = __webpack_require__(583);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = _deprecateObjectProperties2['default'](history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createMemoryHistory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibUseQueries = __webpack_require__(222);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _historyLibUseBasename = __webpack_require__(530);
	
	var _historyLibUseBasename2 = _interopRequireDefault(_historyLibUseBasename);
	
	var _historyLibCreateMemoryHistory = __webpack_require__(1466);
	
	var _historyLibCreateMemoryHistory2 = _interopRequireDefault(_historyLibCreateMemoryHistory);
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = _historyLibCreateMemoryHistory2['default'](options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = _historyLibUseQueries2['default'](_historyLibUseBasename2['default'](createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	
	module.e = exports['default'];


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _useRouterHistory = __webpack_require__(584);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = function (createHistory) {
	  var history = undefined;
	  if (canUseDOM) history = _useRouterHistory2['default'](createHistory)();
	  return history;
	};
	
	module.e = exports['default'];


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*eslint no-empty: 0*/
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = deprecateObjectProperties;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var useMembrane = false;
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', { get: function get() {
	        return true;
	      } }).x) {
	      useMembrane = true;
	    }
	  } catch (e) {}
	}
	
	// wraps an object in a membrane to warn about deprecated property access
	
	function deprecateObjectProperties(object, message) {
	  if (!useMembrane) return object;
	
	  var membrane = {};
	
	  var _loop = function (prop) {
	    if (typeof object[prop] === 'function') {
	      membrane[prop] = function () {
	         false ? _routerWarning2['default'](false, message) : undefined;
	        return object[prop].apply(object, arguments);
	      };
	    } else {
	      Object.defineProperty(membrane, prop, {
	        configurable: false,
	        enumerable: false,
	        get: function get() {
	           false ? _routerWarning2['default'](false, message) : undefined;
	          return object[prop];
	        }
	      });
	    }
	  };
	
	  for (var prop in object) {
	    _loop(prop);
	  }
	
	  return membrane;
	}
	
	module.e = exports['default'];


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = useRouterHistory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibUseQueries = __webpack_require__(222);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _historyLibUseBasename = __webpack_require__(530);
	
	var _historyLibUseBasename2 = _interopRequireDefault(_historyLibUseBasename);
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = _historyLibUseQueries2['default'](_historyLibUseBasename2['default'](createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	
	module.e = exports['default'];


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.e = CSSProperty;


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(1648);
	var ReactMultiChildUpdateTypes = __webpack_require__(603);
	var ReactPerf = __webpack_require__(78);
	
	var setInnerHTML = __webpack_require__(237);
	var setTextContent = __webpack_require__(335);
	var invariant = __webpack_require__(26);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.e = DOMChildrenOperations;


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.e = EventPluginRegistry;


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(110);
	var ReactElement = __webpack_require__(67);
	
	var emptyFunction = __webpack_require__(88);
	var traverseAllChildren = __webpack_require__(337);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.e = ReactChildren;


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(590);
	var ReactElement = __webpack_require__(67);
	var ReactPropTypeLocations = __webpack_require__(232);
	var ReactPropTypeLocationNames = __webpack_require__(231);
	var ReactNoopUpdateQueue = __webpack_require__(605);
	
	var assign = __webpack_require__(32);
	var emptyObject = __webpack_require__(183);
	var invariant = __webpack_require__(26);
	var keyMirror = __webpack_require__(238);
	var keyOf = __webpack_require__(111);
	var warning = __webpack_require__(33);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.e = ReactClass;


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(605);
	
	var canDefineProperty = __webpack_require__(235);
	var emptyObject = __webpack_require__(183);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.e = ReactComponent;


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactDOMTextComponent = __webpack_require__(594);
	var ReactDefaultInjection = __webpack_require__(596);
	var ReactInstanceHandles = __webpack_require__(155);
	var ReactMount = __webpack_require__(60);
	var ReactPerf = __webpack_require__(78);
	var ReactReconciler = __webpack_require__(135);
	var ReactUpdates = __webpack_require__(79);
	var ReactVersion = __webpack_require__(327);
	
	var findDOMNode = __webpack_require__(328);
	var renderSubtreeIntoContainer = __webpack_require__(1698);
	var warning = __webpack_require__(33);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.e = React;


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.e = ReactDOMFeatureFlags;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(322);
	var ReactMount = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(79);
	
	var assign = __webpack_require__(32);
	var warning = __webpack_require__(33);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.e = ReactDOMSelect;


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(586);
	var DOMPropertyOperations = __webpack_require__(321);
	var ReactComponentBrowserEnvironment = __webpack_require__(323);
	var ReactMount = __webpack_require__(60);
	
	var assign = __webpack_require__(32);
	var escapeTextContentForBrowser = __webpack_require__(236);
	var setTextContent = __webpack_require__(335);
	var validateDOMNesting = __webpack_require__(338);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.e = ReactDOMTextComponent;


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(79);
	var Transaction = __webpack_require__(234);
	
	var assign = __webpack_require__(32);
	var emptyFunction = __webpack_require__(88);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.e = ReactDefaultBatchingStrategy;


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(1644);
	var ChangeEventPlugin = __webpack_require__(1646);
	var ClientReactRootIndex = __webpack_require__(1647);
	var DefaultEventPluginOrder = __webpack_require__(1649);
	var EnterLeaveEventPlugin = __webpack_require__(1650);
	var ExecutionEnvironment = __webpack_require__(55);
	var HTMLDOMPropertyConfig = __webpack_require__(1653);
	var ReactBrowserComponentMixin = __webpack_require__(1655);
	var ReactComponentBrowserEnvironment = __webpack_require__(323);
	var ReactDefaultBatchingStrategy = __webpack_require__(595);
	var ReactDOMComponent = __webpack_require__(1660);
	var ReactDOMTextComponent = __webpack_require__(594);
	var ReactEventListener = __webpack_require__(1668);
	var ReactInjection = __webpack_require__(1669);
	var ReactInstanceHandles = __webpack_require__(155);
	var ReactMount = __webpack_require__(60);
	var ReactReconcileTransaction = __webpack_require__(1673);
	var SelectEventPlugin = __webpack_require__(1679);
	var ServerReactRootIndex = __webpack_require__(1680);
	var SimpleEventPlugin = __webpack_require__(1681);
	var SVGDOMPropertyConfig = __webpack_require__(1678);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.e = {
	  inject: inject
	};


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(67);
	var ReactPropTypeLocations = __webpack_require__(232);
	var ReactPropTypeLocationNames = __webpack_require__(231);
	var ReactCurrentOwner = __webpack_require__(96);
	
	var canDefineProperty = __webpack_require__(235);
	var getIteratorFn = __webpack_require__(332);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.e = ReactElementValidator;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(67);
	var ReactEmptyComponentRegistry = __webpack_require__(599);
	var ReactReconciler = __webpack_require__(135);
	
	var assign = __webpack_require__(32);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.e = ReactEmptyComponent;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.e = ReactEmptyComponentRegistry;


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.e = ReactErrorUtils;


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1664);
	
	var containsNode = __webpack_require__(614);
	var focusNode = __webpack_require__(615);
	var getActiveElement = __webpack_require__(616);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.e = ReactInputSelection;


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1690);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.e = ReactMarkupChecksum;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(238);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.e = ReactMultiChildUpdateTypes;


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.e = ReactNativeComponent;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(33);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.e = ReactNoopUpdateQueue;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(67);
	var ReactPropTypeLocationNames = __webpack_require__(231);
	
	var emptyFunction = __webpack_require__(88);
	var getIteratorFn = __webpack_require__(332);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.e = ReactPropTypes;


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.e = ReactRootIndex;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.e = ViewportMetrics;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.e = accumulateInto;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.e = forEachAccumulated;


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.e = getTextContentAccessor;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.e = isTextInputElement;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(88);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.e = EventListener;


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(1708);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.e = containsNode;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.e = focusNode;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.e = getActiveElement;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.e = getMarkupWrap;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(27)
	var Hash = __webpack_require__(156)
	
	var K = [
	  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	]
	
	var W = new Array(64)
	
	function Sha256 () {
	  this.init()
	
	  this._w = W // new Array(64)
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha256, Hash)
	
	Sha256.prototype.init = function () {
	  this._a = 0x6a09e667
	  this._b = 0xbb67ae85
	  this._c = 0x3c6ef372
	  this._d = 0xa54ff53a
	  this._e = 0x510e527f
	  this._f = 0x9b05688c
	  this._g = 0x1f83d9ab
	  this._h = 0x5be0cd19
	
	  return this
	}
	
	function ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}
	
	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}
	
	function sigma0 (x) {
	  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
	}
	
	function sigma1 (x) {
	  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
	}
	
	function gamma0 (x) {
	  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
	}
	
	function gamma1 (x) {
	  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
	}
	
	Sha256.prototype._update = function (M) {
	  var W = this._w
	
	  var a = this._a | 0
	  var b = this._b | 0
	  var c = this._c | 0
	  var d = this._d | 0
	  var e = this._e | 0
	  var f = this._f | 0
	  var g = this._g | 0
	  var h = this._h | 0
	
	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
	  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0
	
	  for (var j = 0; j < 64; ++j) {
	    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
	    var T2 = (sigma0(a) + maj(a, b, c)) | 0
	
	    h = g
	    g = f
	    f = e
	    e = (d + T1) | 0
	    d = c
	    c = b
	    b = a
	    a = (T1 + T2) | 0
	  }
	
	  this._a = (a + this._a) | 0
	  this._b = (b + this._b) | 0
	  this._c = (c + this._c) | 0
	  this._d = (d + this._d) | 0
	  this._e = (e + this._e) | 0
	  this._f = (f + this._f) | 0
	  this._g = (g + this._g) | 0
	  this._h = (h + this._h) | 0
	}
	
	Sha256.prototype._hash = function () {
	  var H = new Buffer(32)
	
	  H.writeInt32BE(this._a, 0)
	  H.writeInt32BE(this._b, 4)
	  H.writeInt32BE(this._c, 8)
	  H.writeInt32BE(this._d, 12)
	  H.writeInt32BE(this._e, 16)
	  H.writeInt32BE(this._f, 20)
	  H.writeInt32BE(this._g, 24)
	  H.writeInt32BE(this._h, 28)
	
	  return H
	}
	
	module.e = Sha256
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27)
	var Hash = __webpack_require__(156)
	
	var K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	]
	
	var W = new Array(160)
	
	function Sha512 () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 128, 112)
	}
	
	inherits(Sha512, Hash)
	
	Sha512.prototype.init = function () {
	  this._ah = 0x6a09e667
	  this._bh = 0xbb67ae85
	  this._ch = 0x3c6ef372
	  this._dh = 0xa54ff53a
	  this._eh = 0x510e527f
	  this._fh = 0x9b05688c
	  this._gh = 0x1f83d9ab
	  this._hh = 0x5be0cd19
	
	  this._al = 0xf3bcc908
	  this._bl = 0x84caa73b
	  this._cl = 0xfe94f82b
	  this._dl = 0x5f1d36f1
	  this._el = 0xade682d1
	  this._fl = 0x2b3e6c1f
	  this._gl = 0xfb41bd6b
	  this._hl = 0x137e2179
	
	  return this
	}
	
	function Ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}
	
	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}
	
	function sigma0 (x, xl) {
	  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
	}
	
	function sigma1 (x, xl) {
	  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
	}
	
	function Gamma0 (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
	}
	
	function Gamma0l (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
	}
	
	function Gamma1 (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
	}
	
	function Gamma1l (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
	}
	
	function getCarry (a, b) {
	  return (a >>> 0) < (b >>> 0) ? 1 : 0
	}
	
	Sha512.prototype._update = function (M) {
	  var W = this._w
	
	  var ah = this._ah | 0
	  var bh = this._bh | 0
	  var ch = this._ch | 0
	  var dh = this._dh | 0
	  var eh = this._eh | 0
	  var fh = this._fh | 0
	  var gh = this._gh | 0
	  var hh = this._hh | 0
	
	  var al = this._al | 0
	  var bl = this._bl | 0
	  var cl = this._cl | 0
	  var dl = this._dl | 0
	  var el = this._el | 0
	  var fl = this._fl | 0
	  var gl = this._gl | 0
	  var hl = this._hl | 0
	
	  for (var i = 0; i < 32; i += 2) {
	    W[i] = M.readInt32BE(i * 4)
	    W[i + 1] = M.readInt32BE(i * 4 + 4)
	  }
	  for (; i < 160; i += 2) {
	    var xh = W[i - 15 * 2]
	    var xl = W[i - 15 * 2 + 1]
	    var gamma0 = Gamma0(xh, xl)
	    var gamma0l = Gamma0l(xl, xh)
	
	    xh = W[i - 2 * 2]
	    xl = W[i - 2 * 2 + 1]
	    var gamma1 = Gamma1(xh, xl)
	    var gamma1l = Gamma1l(xl, xh)
	
	    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	    var Wi7h = W[i - 7 * 2]
	    var Wi7l = W[i - 7 * 2 + 1]
	
	    var Wi16h = W[i - 16 * 2]
	    var Wi16l = W[i - 16 * 2 + 1]
	
	    var Wil = (gamma0l + Wi7l) | 0
	    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
	    Wil = (Wil + gamma1l) | 0
	    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
	    Wil = (Wil + Wi16l) | 0
	    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0
	
	    W[i] = Wih
	    W[i + 1] = Wil
	  }
	
	  for (var j = 0; j < 160; j += 2) {
	    Wih = W[j]
	    Wil = W[j + 1]
	
	    var majh = maj(ah, bh, ch)
	    var majl = maj(al, bl, cl)
	
	    var sigma0h = sigma0(ah, al)
	    var sigma0l = sigma0(al, ah)
	    var sigma1h = sigma1(eh, el)
	    var sigma1l = sigma1(el, eh)
	
	    // t1 = h + sigma1 + ch + K[j] + W[j]
	    var Kih = K[j]
	    var Kil = K[j + 1]
	
	    var chh = Ch(eh, fh, gh)
	    var chl = Ch(el, fl, gl)
	
	    var t1l = (hl + sigma1l) | 0
	    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
	    t1l = (t1l + chl) | 0
	    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
	    t1l = (t1l + Kil) | 0
	    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
	    t1l = (t1l + Wil) | 0
	    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0
	
	    // t2 = sigma0 + maj
	    var t2l = (sigma0l + majl) | 0
	    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0
	
	    hh = gh
	    hl = gl
	    gh = fh
	    gl = fl
	    fh = eh
	    fl = el
	    el = (dl + t1l) | 0
	    eh = (dh + t1h + getCarry(el, dl)) | 0
	    dh = ch
	    dl = cl
	    ch = bh
	    cl = bl
	    bh = ah
	    bl = al
	    al = (t1l + t2l) | 0
	    ah = (t1h + t2h + getCarry(al, t1l)) | 0
	  }
	
	  this._al = (this._al + al) | 0
	  this._bl = (this._bl + bl) | 0
	  this._cl = (this._cl + cl) | 0
	  this._dl = (this._dl + dl) | 0
	  this._el = (this._el + el) | 0
	  this._fl = (this._fl + fl) | 0
	  this._gl = (this._gl + gl) | 0
	  this._hl = (this._hl + hl) | 0
	
	  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
	  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
	  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
	  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
	  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
	  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
	  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
	  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
	}
	
	Sha512.prototype._hash = function () {
	  var H = new Buffer(64)
	
	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset)
	    H.writeInt32BE(l, offset + 4)
	  }
	
	  writeInt64BE(this._ah, this._al, 0)
	  writeInt64BE(this._bh, this._bl, 8)
	  writeInt64BE(this._ch, this._cl, 16)
	  writeInt64BE(this._dh, this._dl, 24)
	  writeInt64BE(this._eh, this._el, 32)
	  writeInt64BE(this._fh, this._fl, 40)
	  writeInt64BE(this._gh, this._gl, 48)
	  writeInt64BE(this._hh, this._hl, 56)
	
	  return H
	}
	
	module.e = Sha512
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.e = PassThrough;
	
	var Transform = __webpack_require__(340);
	
	/*<replacement>*/
	var util = __webpack_require__(172);
	util.inherits = __webpack_require__(27);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = Readable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(306);
	/*</replacement>*/
	
	/*<replacement>*/
	var isArray = __webpack_require__(1719);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(19).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(40);
	
	/*<replacement>*/
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(157);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(40).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(19).Buffer;
	
	/*<replacement>*/
	var util = __webpack_require__(172);
	util.inherits = __webpack_require__(27);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1766);
	var debug = undefined;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var Duplex;
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(137);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(342).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	var Duplex;
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(137);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options && typeof options.read === 'function') this._read = options.read;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	
	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }
	
	      if (!addToFront) state.reading = false;
	
	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	          if (state.needReadable) emitReadable(stream);
	        }
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(342).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended) return 0;
	
	  if (state.objectMode) return n === 0 ? 0 : 1;
	
	  if (n === null || isNaN(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
	  }
	
	  if (n <= 0) return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else {
	      return state.length;
	    }
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended) state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var _i = 0; _i < len; _i++) {
	      dests[_i].emit('unpipe', this);
	    }return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1) return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && !this._readableState.endEmitted) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function (ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0) return null;
	
	  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode) ret = '';else ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}
	
	module.e = isObject;
	


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1733);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.e = exports['default'];


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This is a module for storing settings passed into KaTeX. It correctly handles
	 * default settings.
	 */
	
	/**
	 * Helper function for getting a default value if the value is undefined
	 */
	function get(option, defaultValue) {
	    return option === undefined ? defaultValue : option;
	}
	
	/**
	 * The main Settings object
	 *
	 * The current options stored are:
	 *  - displayMode: Whether the expression should be typeset by default in
	 *                 textstyle or displaystyle (default false)
	 */
	function Settings(options) {
	    // allow null options
	    options = options || {};
	    this.displayMode = get(options.displayMode, false);
	    this.throwOnError = get(options.throwOnError, true);
	    this.errorColor = get(options.errorColor, "#cc0000");
	}
	
	module.e = Settings;
	


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * These objects store the data about the DOM nodes we create, as well as some
	 * extra data. They can then be transformed into real DOM nodes with the
	 * `toNode` function or HTML markup using `toMarkup`. They are useful for both
	 * storing extra properties on the nodes, as well as providing a way to easily
	 * work with the DOM.
	 *
	 * Similar functions for working with MathML nodes exist in mathMLTree.js.
	 */
	
	var utils = __webpack_require__(97);
	
	/**
	 * Create an HTML className based on a list of classes. In addition to joining
	 * with spaces, we also remove null or empty classes.
	 */
	var createClass = function(classes) {
	    classes = classes.slice();
	    for (var i = classes.length - 1; i >= 0; i--) {
	        if (!classes[i]) {
	            classes.splice(i, 1);
	        }
	    }
	
	    return classes.join(" ");
	};
	
	/**
	 * This node represents a span node, with a className, a list of children, and
	 * an inline style. It also contains information about its height, depth, and
	 * maxFontSize.
	 */
	function span(classes, children, height, depth, maxFontSize, style) {
	    this.classes = classes || [];
	    this.children = children || [];
	    this.height = height || 0;
	    this.depth = depth || 0;
	    this.maxFontSize = maxFontSize || 0;
	    this.style = style || {};
	    this.attributes = {};
	}
	
	/**
	 * Sets an arbitrary attribute on the span. Warning: use this wisely. Not all
	 * browsers support attributes the same, and having too many custom attributes
	 * is probably bad.
	 */
	span.prototype.setAttribute = function(attribute, value) {
	    this.attributes[attribute] = value;
	};
	
	/**
	 * Convert the span into an HTML node
	 */
	span.prototype.toNode = function() {
	    var span = document.createElement("span");
	
	    // Apply the class
	    span.className = createClass(this.classes);
	
	    // Apply inline styles
	    for (var style in this.style) {
	        if (Object.prototype.hasOwnProperty.call(this.style, style)) {
	            span.style[style] = this.style[style];
	        }
	    }
	
	    // Apply attributes
	    for (var attr in this.attributes) {
	        if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
	            span.setAttribute(attr, this.attributes[attr]);
	        }
	    }
	
	    // Append the children, also as HTML nodes
	    for (var i = 0; i < this.children.length; i++) {
	        span.appendChild(this.children[i].toNode());
	    }
	
	    return span;
	};
	
	/**
	 * Convert the span into an HTML markup string
	 */
	span.prototype.toMarkup = function() {
	    var markup = "<span";
	
	    // Add the class
	    if (this.classes.length) {
	        markup += " class=\"";
	        markup += utils.escape(createClass(this.classes));
	        markup += "\"";
	    }
	
	    var styles = "";
	
	    // Add the styles, after hyphenation
	    for (var style in this.style) {
	        if (this.style.hasOwnProperty(style)) {
	            styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
	        }
	    }
	
	    if (styles) {
	        markup += " style=\"" + utils.escape(styles) + "\"";
	    }
	
	    // Add the attributes
	    for (var attr in this.attributes) {
	        if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
	            markup += " " + attr + "=\"";
	            markup += utils.escape(this.attributes[attr]);
	            markup += "\"";
	        }
	    }
	
	    markup += ">";
	
	    // Add the markup of the children, also as markup
	    for (var i = 0; i < this.children.length; i++) {
	        markup += this.children[i].toMarkup();
	    }
	
	    markup += "</span>";
	
	    return markup;
	};
	
	/**
	 * This node represents a document fragment, which contains elements, but when
	 * placed into the DOM doesn't have any representation itself. Thus, it only
	 * contains children and doesn't have any HTML properties. It also keeps track
	 * of a height, depth, and maxFontSize.
	 */
	function documentFragment(children, height, depth, maxFontSize) {
	    this.children = children || [];
	    this.height = height || 0;
	    this.depth = depth || 0;
	    this.maxFontSize = maxFontSize || 0;
	}
	
	/**
	 * Convert the fragment into a node
	 */
	documentFragment.prototype.toNode = function() {
	    // Create a fragment
	    var frag = document.createDocumentFragment();
	
	    // Append the children
	    for (var i = 0; i < this.children.length; i++) {
	        frag.appendChild(this.children[i].toNode());
	    }
	
	    return frag;
	};
	
	/**
	 * Convert the fragment into HTML markup
	 */
	documentFragment.prototype.toMarkup = function() {
	    var markup = "";
	
	    // Simply concatenate the markup for the children together
	    for (var i = 0; i < this.children.length; i++) {
	        markup += this.children[i].toMarkup();
	    }
	
	    return markup;
	};
	
	/**
	 * A symbol node contains information about a single symbol. It either renders
	 * to a single text node, or a span with a single text node in it, depending on
	 * whether it has CSS classes, styles, or needs italic correction.
	 */
	function symbolNode(value, height, depth, italic, skew, classes, style) {
	    this.value = value || "";
	    this.height = height || 0;
	    this.depth = depth || 0;
	    this.italic = italic || 0;
	    this.skew = skew || 0;
	    this.classes = classes || [];
	    this.style = style || {};
	    this.maxFontSize = 0;
	}
	
	/**
	 * Creates a text node or span from a symbol node. Note that a span is only
	 * created if it is needed.
	 */
	symbolNode.prototype.toNode = function() {
	    var node = document.createTextNode(this.value);
	    var span = null;
	
	    if (this.italic > 0) {
	        span = document.createElement("span");
	        span.style.marginRight = this.italic + "em";
	    }
	
	    if (this.classes.length > 0) {
	        span = span || document.createElement("span");
	        span.className = createClass(this.classes);
	    }
	
	    for (var style in this.style) {
	        if (this.style.hasOwnProperty(style)) {
	            span = span || document.createElement("span");
	            span.style[style] = this.style[style];
	        }
	    }
	
	    if (span) {
	        span.appendChild(node);
	        return span;
	    } else {
	        return node;
	    }
	};
	
	/**
	 * Creates markup for a symbol node.
	 */
	symbolNode.prototype.toMarkup = function() {
	    // TODO(alpert): More duplication than I'd like from
	    // span.prototype.toMarkup and symbolNode.prototype.toNode...
	    var needsSpan = false;
	
	    var markup = "<span";
	
	    if (this.classes.length) {
	        needsSpan = true;
	        markup += " class=\"";
	        markup += utils.escape(createClass(this.classes));
	        markup += "\"";
	    }
	
	    var styles = "";
	
	    if (this.italic > 0) {
	        styles += "margin-right:" + this.italic + "em;";
	    }
	    for (var style in this.style) {
	        if (this.style.hasOwnProperty(style)) {
	            styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
	        }
	    }
	
	    if (styles) {
	        needsSpan = true;
	        markup += " style=\"" + utils.escape(styles) + "\"";
	    }
	
	    var escaped = utils.escape(this.value);
	    if (needsSpan) {
	        markup += ">";
	        markup += escaped;
	        markup += "</span>";
	        return markup;
	    } else {
	        return escaped;
	    }
	};
	
	module.e = {
	    span: span,
	    documentFragment: documentFragment,
	    symbolNode: symbolNode,
	};
	


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * The resulting parse tree nodes of the parse tree.
	 */
	function ParseNode(type, value, mode) {
	    this.type = type;
	    this.value = value;
	    this.mode = mode;
	}
	
	module.e = {
	    ParseNode: ParseNode,
	};
	
	


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __WEBPACK_IMPORTED_MODULE_1_jquery__ && __WEBPACK_IMPORTED_MODULE_1_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css__ = __webpack_require__(1758);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css___default = __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css__ && __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_bootstrap_colorpicker_dist_css_bootstrap_colorpicker_css___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css__ = __webpack_require__(1760);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css___default = __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css__ && __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_google_fonts_google_fonts_css___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss__ = __webpack_require__(1759);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss___default = __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss__ && __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_sass_styles_scss___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_sass_styles_scss___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_root_jsx__ = __webpack_require__(739);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_logged_in_jsx__ = __webpack_require__(708);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_header_footer_template_jsx__ = __webpack_require__(706);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_needs_team_jsx__ = __webpack_require__(716);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_password_reset_send_link_jsx__ = __webpack_require__(720);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_password_reset_form_jsx__ = __webpack_require__(719);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_channel_view_jsx__ = __webpack_require__(685);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_permalink_view_jsx__ = __webpack_require__(721);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_sidebar_jsx__ = __webpack_require__(747);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_action_creators_websocket_actions_jsx__ = __webpack_require__(243);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_signup_user_complete_jsx__ = __webpack_require__(751);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_should_verify_email_jsx__ = __webpack_require__(746);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_do_verify_email_jsx__ = __webpack_require__(698);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_admin_console_admin_controller_jsx__ = __webpack_require__(639);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_tutorial_tutorial_view_jsx__ = __webpack_require__(766);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__ = __webpack_require__(672);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__ = __webpack_require__(674);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_backstage_integrations_jsx__ = __webpack_require__(682);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_backstage_installed_incoming_webhooks_jsx__ = __webpack_require__(678);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_backstage_installed_outgoing_webhooks_jsx__ = __webpack_require__(680);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_backstage_installed_commands_jsx__ = __webpack_require__(676);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_backstage_add_incoming_webhook_jsx__ = __webpack_require__(669);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_backstage_add_outgoing_webhook_jsx__ = __webpack_require__(670);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_backstage_add_command_jsx__ = __webpack_require__(668);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_error_page_jsx__ = __webpack_require__(700);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_claim_claim_jsx__ = __webpack_require__(686);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_claim_components_email_to_oauth_jsx__ = __webpack_require__(688);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_components_claim_components_oauth_to_email_jsx__ = __webpack_require__(690);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_components_claim_components_ldap_to_email_jsx__ = __webpack_require__(689);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_components_claim_components_email_to_ldap_jsx__ = __webpack_require__(687);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_components_login_login_jsx__ = __webpack_require__(710);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_components_select_team_select_team_jsx__ = __webpack_require__(743);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_create_team_create_team_jsx__ = __webpack_require__(696);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_create_team_components_display_name_jsx__ = __webpack_require__(694);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_create_team_components_team_url_jsx__ = __webpack_require__(695);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_i18n_i18n_jsx__ = __webpack_require__(190);
	'use strict';
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	__webpack_require__(1528)(/* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_41__utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var notFoundParams = {
	    title: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_21_utils_utils_jsx__.localizeMessage('error.not_found.title', 'Page not found'),
	    message: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_21_utils_utils_jsx__.localizeMessage('error.not_found.message', 'The page you where trying to reach does not exist'),
	    link: '/',
	    linkmessage: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_21_utils_utils_jsx__.localizeMessage('error.not_found.link_message', 'Back to Mattermost')
	};
	
	// This is for anything that needs to be done for ALL react components.
	// This runs before we start to render anything.
	function preRenderSetup(callwhendone) {
	    window.onerror = function (msg, url, line, column, stack) {
	        var l = {};
	        l.level = 'ERROR';
	        l.message = 'msg: ' + msg + ' row: ' + line + ' col: ' + column + ' stack: ' + stack + ' url: ' + url;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
	            url: '/api/v3/admin/log_client',
	            dataType: 'json',
	            contentType: 'application/json',
	            type: 'POST',
	            data: /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(l)
	        });
	
	        if (window.mm_config && window.mm_config.EnableDeveloper === 'true') {
	            window.ErrorStore.storeLastError({ type: 'developer', message: 'DEVELOPER MODE: A javascript error has occured.  Please use the javascript console to capture and report the error (row: ' + line + ' col: ' + column + ').' });
	            window.ErrorStore.emitChange();
	        }
	    };
	
	    var d1 = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Deferred(); //eslint-disable-line new-cap
	
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_24_action_creators_global_actions_jsx__.emitInitialLoad(function () {
	        d1.resolve();
	    });
	
	    // Make sure the websockets close
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.bind()(window).on('beforeunload', function () {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_action_creators_websocket_actions_jsx__.close();
	    });
	
	    function afterIntl() {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_52_i18n_i18n_jsx__.doAddLocaleData();
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.when(d1).done(function () {
	            callwhendone();
	        });
	    }
	
	    if (global.Intl) {
	        afterIntl();
	    } else {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_52_i18n_i18n_jsx__.safariFix(afterIntl);
	    }
	}
	
	function preLoggedIn(nextState, replace, callback) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_error_store_jsx__["a"].clearLastError();
	    callback();
	}
	
	function preNeedsTeam(nextState, replace, callback) {
	    // First check to make sure you're in the current team
	    // for the current url.
	    var teamName = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_21_utils_utils_jsx__.getTeamNameFromUrl();
	    var team = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].getByName(teamName);
	    var oldTeamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].getCurrentId();
	
	    if (!team) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"].push('/');
	        return;
	    }
	
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_24_action_creators_global_actions_jsx__.emitCloseRightHandSide();
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].saveMyTeam(team);
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].emitChange();
	
	    // If the old team id is null then we will already have the direct
	    // profiles from initial load
	    if (oldTeamId != null) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_17_utils_async_client_jsx__.getDirectProfiles();
	    }
	
	    var d1 = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Deferred(); //eslint-disable-line new-cap
	    var d2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Deferred(); //eslint-disable-line new-cap
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_22_utils_web_client_jsx__["a"].getChannels(function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_CHANNELS,
	            channels: data.channels,
	            members: data.members
	        });
	
	        d1.resolve();
	    }, function (err) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_17_utils_async_client_jsx__.dispatchError(err, 'getChannels');
	        d1.resolve();
	    });
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_22_utils_web_client_jsx__["a"].getProfiles(function (data) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_40__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	            type: ActionTypes.RECEIVED_PROFILES,
	            profiles: data
	        });
	
	        d2.resolve();
	    }, function (err) {
	        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_17_utils_async_client_jsx__.dispatchError(err, 'getProfiles');
	        d2.resolve();
	    });
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.when(d1, d2).done(function () {
	        callback();
	    });
	}
	
	function onPermalinkEnter(nextState) {
	    var postId = nextState.params.postid;
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_24_action_creators_global_actions_jsx__.emitPostFocusEvent(postId);
	}
	
	function onChannelEnter(nextState, replace, callback) {
	    doChannelChange(nextState, replace, callback);
	}
	
	function doChannelChange(state, replace, callback) {
	    var channel = void 0;
	    if (state.location.query.fakechannel) {
	        channel = JSON.parse(state.location.query.fakechannel);
	    } else {
	        channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getByName(state.params.channel);
	        if (!channel) {
	            channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getMoreByName(state.params.channel);
	        }
	        if (!channel) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_22_utils_web_client_jsx__["a"].joinChannelByName(state.params.channel, function (data) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_24_action_creators_global_actions_jsx__.emitChannelClickEvent(data);
	                callback();
	            }, function () {
	                if (state.params.team) {
	                    replace('/' + state.params.team + '/channels/town-square');
	                } else {
	                    replace('/');
	                }
	                callback();
	            });
	            return;
	        }
	    }
	    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_24_action_creators_global_actions_jsx__.emitChannelClickEvent(channel);
	    callback();
	}
	
	function renderRootComponent() {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.render(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Router"],
	        {
	            history: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"]
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	            {
	                path: '/',
	                component: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_components_root_jsx__["a"]
	            },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                path: 'error',
	                component: /* harmony import */__WEBPACK_IMPORTED_MODULE_39_components_error_page_jsx__["a"]
	            }),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                { component: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_components_header_footer_template_jsx__["a"] },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'login',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_47_components_login_login_jsx__["a"]
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'reset_password',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_components_password_reset_send_link_jsx__["a"]
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'reset_password_complete',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_components_password_reset_form_jsx__["a"]
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                    {
	                        path: 'claim',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_42_components_claim_claim_jsx__["a"]
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'oauth_to_email',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_44_components_claim_components_oauth_to_email_jsx__["a"]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'email_to_oauth',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_43_components_claim_components_email_to_oauth_jsx__["a"]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'email_to_ldap',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_46_components_claim_components_email_to_ldap_jsx__["a"]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'ldap_to_email',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_45_components_claim_components_ldap_to_email_jsx__["a"]
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'signup_user_complete',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_25_components_signup_user_complete_jsx__["a"]
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'should_verify_email',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_26_components_should_verify_email_jsx__["a"]
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'do_verify_email',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_27_components_do_verify_email_jsx__["a"]
	                })
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                {
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_components_logged_in_jsx__["a"],
	                    onEnter: preLoggedIn
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                    { component: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_components_header_footer_template_jsx__["a"] },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'select_team',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_48_components_select_team_select_team_jsx__["a"]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                        {
	                            path: 'create_team',
	                            component: /* harmony import */__WEBPACK_IMPORTED_MODULE_49_components_create_team_create_team_jsx__["a"]
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["IndexRoute"], { component: /* harmony import */__WEBPACK_IMPORTED_MODULE_50_components_create_team_components_display_name_jsx__["a"] }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                            path: 'display_name',
	                            component: /* harmony import */__WEBPACK_IMPORTED_MODULE_50_components_create_team_components_display_name_jsx__["a"]
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                            path: 'team_url',
	                            component: /* harmony import */__WEBPACK_IMPORTED_MODULE_51_components_create_team_components_team_url_jsx__["a"]
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                    path: 'admin_console',
	                    component: /* harmony import */__WEBPACK_IMPORTED_MODULE_28_components_admin_console_admin_controller_jsx__["a"]
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                    {
	                        path: ':team',
	                        component: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_components_needs_team_jsx__["a"],
	                        onEnter: preNeedsTeam
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["IndexRedirect"], { to: 'channels/town-square' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'channels/:channel',
	                        onEnter: onChannelEnter,
	                        components: {
	                            sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_components_sidebar_jsx__["a"],
	                            center: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_components_channel_view_jsx__["a"]
	                        }
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'pl/:postid',
	                        onEnter: onPermalinkEnter,
	                        components: {
	                            sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_components_sidebar_jsx__["a"],
	                            center: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_components_permalink_view_jsx__["a"]
	                        }
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                        path: 'tutorial',
	                        components: {
	                            sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_components_sidebar_jsx__["a"],
	                            center: /* harmony import */__WEBPACK_IMPORTED_MODULE_29_components_tutorial_tutorial_view_jsx__["a"]
	                        }
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                        { path: 'settings/integrations' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["IndexRoute"], {
	                            components: {
	                                navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                center: /* harmony import */__WEBPACK_IMPORTED_MODULE_32_components_backstage_integrations_jsx__["a"]
	                            }
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                            { path: 'incoming_webhooks' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["IndexRoute"], {
	                                components: {
	                                    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_33_components_backstage_installed_incoming_webhooks_jsx__["a"]
	                                }
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                                path: 'add',
	                                components: {
	                                    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_36_components_backstage_add_incoming_webhook_jsx__["a"]
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                            { path: 'outgoing_webhooks' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["IndexRoute"], {
	                                components: {
	                                    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_34_components_backstage_installed_outgoing_webhooks_jsx__["a"]
	                                }
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                                path: 'add',
	                                components: {
	                                    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_37_components_backstage_add_outgoing_webhook_jsx__["a"]
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"],
	                            { path: 'commands' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["IndexRoute"], {
	                                components: {
	                                    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_35_components_backstage_installed_commands_jsx__["a"]
	                                }
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Route"], {
	                                path: 'add',
	                                components: {
	                                    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_backstage_backstage_navbar_jsx__["a"],
	                                    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_backstage_backstage_sidebar_jsx__["a"],
	                                    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_38_components_backstage_add_command_jsx__["a"]
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Redirect"], {
	                            from: '*',
	                            to: '/error',
	                            query: notFoundParams
	                        })
	                    )
	                )
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Redirect"], {
	                from: '*',
	                to: '/error',
	                query: notFoundParams
	            })
	        )
	    ), document.getElementById('root'));
	}
	
	global.window.setup_root = function () {
	    // Do the pre-render setup and call renderRootComponent when done
	    preRenderSetup(renderRootComponent);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 628 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint max-len: 0 */
	
	"use strict";
	
	var _Object$defineProperty = __webpack_require__(487)["default"];
	
	__webpack_require__(1275);
	
	__webpack_require__(1276);
	
	// Should be removed in the next major release:
	
	__webpack_require__(1094);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	function define(O, key, value) {
	  O[key] || _Object$defineProperty(O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent__ = __webpack_require__(1726);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent___default = __WEBPACK_IMPORTED_MODULE_2_superagent__ && __WEBPACK_IMPORTED_MODULE_2_superagent__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_superagent__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_superagent__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_superagent___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_superagent___default });
	'use strict';
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var HEADER_X_VERSION_ID = 'x-version-id';
	var HEADER_TOKEN = 'token';
	var HEADER_BEARER = 'BEARER';
	var HEADER_AUTH = 'Authorization';
	
	var Client = function () {
	    function Client() {
	        var _this = this;
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Client);
	
	        this.setUrl = function (url) {
	            _this.url = url;
	        };
	
	        this.setTeamId = function (id) {
	            _this.teamId = id;
	        };
	
	        this.getTeamId = function () {
	            if (_this.teamId === '') {
	                console.error('You are trying to use a route that requires a team_id, but you have not called setTeamId() in client.jsx'); // eslint-disable-line no-console
	            }
	
	            return _this.teamId;
	        };
	
	        this.getServerVersion = function () {
	            return _this.serverVersion;
	        };
	
	        this.setTranslations = function (messages) {
	            _this.translations = messages;
	        };
	
	        this.enableLogErrorsToConsole = function (enabled) {
	            _this.logToConsole = enabled;
	        };
	
	        this.useHeaderToken = function () {
	            _this.useToken = true;
	            if (_this.token !== '') {
	                _this.defaultHeaders[HEADER_AUTH] = HEADER_BEARER + ' ' + _this.token;
	            }
	        };
	
	        this.track = function (category, action, label, property, value) {// eslint-disable-line no-unused-vars
	            // NO-OP for inherited classes to override
	        };
	
	        this.trackPage = function () {
	            // NO-OP for inherited classes to override
	        };
	
	        this.handleError = function (err, res) {// eslint-disable-line no-unused-vars
	            // NO-OP for inherited classes to override
	        };
	
	        this.handleResponse = function (methodName, successCallback, errorCallback, err, res) {
	            if (res && res.header) {
	                _this.serverVersion = res.header[HEADER_X_VERSION_ID];
	                if (res.header[HEADER_X_VERSION_ID]) {
	                    _this.serverVersion = res.header[HEADER_X_VERSION_ID];
	                }
	            }
	
	            if (err) {
	                // test to make sure it looks like a server JSON error response
	                var e = null;
	                if (res && res.body && res.body.id) {
	                    e = res.body;
	                }
	
	                var msg = '';
	
	                if (e) {
	                    msg = 'method=' + methodName + ' msg=' + e.message + ' detail=' + e.detailed_error + ' rid=' + e.request_id;
	                } else {
	                    msg = 'method=' + methodName + ' status=' + err.status + ' statusCode=' + err.statusCode + ' err=' + err;
	
	                    if (err.status === 0 || !err.status) {
	                        e = { message: _this.translations.connectionError };
	                    } else {
	                        e = { message: _this.translations.unknownError + ' (' + err.status + ')' };
	                    }
	                }
	
	                if (_this.logToConsole) {
	                    console.error(msg); // eslint-disable-line no-console
	                    console.error(e); // eslint-disable-line no-console
	                }
	
	                _this.track('api', 'api_weberror', methodName, 'message', msg);
	
	                _this.handleError(err, res);
	
	                if (errorCallback) {
	                    errorCallback(e, err, res);
	                    return;
	                }
	            }
	
	            if (successCallback) {
	                successCallback(res.body, res);
	            }
	        };
	
	        this.getTranslations = function (url, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(url).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getTranslations', success, error));
	        };
	
	        this.getClientConfig = function (success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getAdminRoute() + '/client_props').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getClientConfig', success, error));
	        };
	
	        this.getComplianceReports = function (success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getAdminRoute() + '/compliance_reports').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getComplianceReports', success, error));
	        };
	
	        this.uploadBrandImage = function (image, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/upload_brand_image').set(_this.defaultHeaders).accept('application/json').attach('image', image, image.name).end(_this.handleResponse.bind(_this, 'uploadBrandImage', success, error));
	        };
	
	        this.saveComplianceReports = function (job, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/save_compliance_report').set(_this.defaultHeaders).type('application/json').accept('application/json').send(job).end(_this.handleResponse.bind(_this, 'saveComplianceReports', success, error));
	        };
	
	        this.getLogs = function (success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getAdminRoute() + '/logs').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getLogs', success, error));
	        };
	
	        this.getServerAudits = function (success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getAdminRoute() + '/audits').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getServerAudits', success, error));
	        };
	
	        this.getConfig = function (success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getAdminRoute() + '/config').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getConfig', success, error));
	        };
	
	        this.getAnalytics = function (name, teamId, success, error) {
	            var url = _this.getAdminRoute() + '/analytics/';
	            if (teamId == null) {
	                url += name;
	            } else {
	                url += teamId + '/' + name;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(url).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getAnalytics', success, error));
	        };
	
	        this.getTeamAnalytics = function (teamId, name, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getAdminRoute() + '/analytics/' + teamId + '/' + name).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getTeamAnalytics', success, error));
	        };
	
	        this.saveConfig = function (config, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/save_config').set(_this.defaultHeaders).type('application/json').accept('application/json').send(config).end(_this.handleResponse.bind(_this, 'saveConfig', success, error));
	        };
	
	        this.testEmail = function (config, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/test_email').set(_this.defaultHeaders).type('application/json').accept('application/json').send(config).end(_this.handleResponse.bind(_this, 'testEmail', success, error));
	        };
	
	        this.logClientError = function (msg) {
	            var l = {};
	            l.level = 'ERROR';
	            l.message = msg;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/log_client').set(_this.defaultHeaders).type('application/json').accept('application/json').send(l).end(_this.handleResponse.bind(_this, 'logClientError', null, null));
	        };
	
	        this.getClientLicenceConfig = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getLicenseRoute() + '/client_config').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getClientLicenceConfig', success, error));
	        };
	
	        this.removeLicenseFile = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getLicenseRoute() + '/remove').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'removeLicenseFile', success, error));
	        };
	
	        this.uploadLicenseFile = function (license, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getLicenseRoute() + '/add').set(_this.defaultHeaders).accept('application/json').attach('license', license, license.name).end(_this.handleResponse.bind(_this, 'uploadLicenseFile', success, error));
	
	            _this.track('api', 'api_license_upload');
	        };
	
	        this.importSlack = function (fileData, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamNeededRoute() + '/import_team').set(_this.defaultHeaders).accept('application/octet-stream').send(fileData).end(_this.handleResponse.bind(_this, 'importSlack', success, error));
	        };
	
	        this.exportTeam = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamsRoute() + '/export_team').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'exportTeam', success, error));
	        };
	
	        this.signupTeam = function (email, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamsRoute() + '/signup').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ email: email }).end(_this.handleResponse.bind(_this, 'signupTeam', success, error));
	
	            _this.track('api', 'api_teams_signup');
	        };
	
	        this.adminResetMfa = function (userId, success, error) {
	            var data = {};
	            data.user_id = userId;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/reset_mfa').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'adminResetMfa', success, error));
	        };
	
	        this.adminResetPassword = function (userId, newPassword, success, error) {
	            var data = {};
	            data.new_password = newPassword;
	            data.user_id = userId;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getAdminRoute() + '/reset_password').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'adminResetPassword', success, error));
	
	            _this.track('api', 'api_admin_reset_password');
	        };
	
	        this.createTeamFromSignup = function (teamSignup, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamsRoute() + '/create_from_signup').set(_this.defaultHeaders).type('application/json').accept('application/json').send(teamSignup).end(_this.handleResponse.bind(_this, 'createTeamFromSignup', success, error));
	        };
	
	        this.findTeamByName = function (teamName, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamsRoute() + '/find_team_by_name').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ name: teamName }).end(_this.handleResponse.bind(_this, 'findTeamByName', success, error));
	        };
	
	        this.createTeam = function (team, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamsRoute() + '/create').set(_this.defaultHeaders).type('application/json').accept('application/json').send(team).end(_this.handleResponse.bind(_this, 'createTeam', success, error));
	
	            _this.track('api', 'api_users_create', '', 'email', team.name);
	        };
	
	        this.updateTeam = function (team, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamNeededRoute() + '/update').set(_this.defaultHeaders).type('application/json').accept('application/json').send(team).end(_this.handleResponse.bind(_this, 'updateTeam', success, error));
	
	            _this.track('api', 'api_teams_update_name');
	        };
	
	        this.getAllTeams = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamsRoute() + '/all').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getAllTeams', success, error));
	        };
	
	        this.getAllTeamListings = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamsRoute() + '/all_team_listings').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getAllTeamListings', success, error));
	        };
	
	        this.getMyTeam = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamNeededRoute() + '/me').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getMyTeam', success, error));
	        };
	
	        this.getTeamMembers = function (teamId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamsRoute() + '/members/' + teamId).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getTeamMembers', success, error));
	        };
	
	        this.inviteMembers = function (data, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamNeededRoute() + '/invite_members').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'inviteMembers', success, error));
	
	            _this.track('api', 'api_teams_invite_members');
	        };
	
	        this.addUserToTeam = function (userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamNeededRoute() + '/add_user_to_team').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(_this.handleResponse.bind(_this, 'addUserToTeam', success, error));
	
	            _this.track('api', 'api_teams_invite_members');
	        };
	
	        this.addUserToTeamFromInvite = function (data, hash, inviteId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamsRoute() + '/add_user_to_team_from_invite').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ hash: hash, data: data, invite_id: inviteId }).end(_this.handleResponse.bind(_this, 'addUserToTeam', success, error));
	
	            _this.track('api', 'api_teams_invite_members');
	        };
	
	        this.getInviteInfo = function (inviteId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamsRoute() + '/get_invite_info').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ invite_id: inviteId }).end(_this.handleResponse.bind(_this, 'getInviteInfo', success, error));
	        };
	
	        this.createUser = function (user, success, error) {
	            _this.createUserWithInvite(user, null, null, null, success, error);
	        };
	
	        this.createUserWithInvite = function (user, data, emailHash, inviteId, success, error) {
	            var url = _this.getUsersRoute() + '/create';
	
	            url += '?d=' + encodeURIComponent(data);
	
	            if (emailHash) {
	                url += '&h=' + encodeURIComponent(emailHash);
	            }
	
	            if (inviteId) {
	                url += '&iid=' + encodeURIComponent(inviteId);
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(url).set(_this.defaultHeaders).type('application/json').accept('application/json').send(user).end(_this.handleResponse.bind(_this, 'createUser', success, error));
	
	            _this.track('api', 'api_users_create', '', 'email', user.email);
	        };
	
	        this.updateUser = function (user, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/update').set(_this.defaultHeaders).type('application/json').accept('application/json').send(user).end(_this.handleResponse.bind(_this, 'updateUser', success, error));
	
	            _this.track('api', 'api_users_update');
	        };
	
	        this.updatePassword = function (userId, currentPassword, newPassword, success, error) {
	            var data = {};
	            data.user_id = userId;
	            data.current_password = currentPassword;
	            data.new_password = newPassword;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/newpassword').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updatePassword', success, error));
	
	            _this.track('api', 'api_users_newpassword');
	        };
	
	        this.updateUserNotifyProps = function (notifyProps, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/update_notify').set(_this.defaultHeaders).type('application/json').accept('application/json').send(notifyProps).end(_this.handleResponse.bind(_this, 'updateUserNotifyProps', success, error));
	        };
	
	        this.updateRoles = function (teamId, userId, newRoles, success, error) {
	            var data = {
	                team_id: teamId,
	                user_id: userId,
	                new_roles: newRoles
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/update_roles').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updateRoles', success, error));
	
	            _this.track('api', 'api_users_update_roles');
	        };
	
	        this.updateActive = function (userId, active, success, error) {
	            var data = {};
	            data.user_id = userId;
	            data.active = '' + active;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/update_active').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updateActive', success, error));
	
	            _this.track('api', 'api_users_update_roles');
	        };
	
	        this.sendPasswordReset = function (email, success, error) {
	            var data = {};
	            data.email = email;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/send_password_reset').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'sendPasswordReset', success, error));
	
	            _this.track('api', 'api_users_send_password_reset');
	        };
	
	        this.resetPassword = function (code, newPassword, success, error) {
	            var data = {};
	            data.new_password = newPassword;
	            data.code = code;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/reset_password').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'resetPassword', success, error));
	
	            _this.track('api', 'api_users_reset_password');
	        };
	
	        this.emailToOAuth = function (email, password, service, success, error) {
	            var data = {};
	            data.password = password;
	            data.email = email;
	            data.service = service;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/claim/email_to_oauth').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'emailToOAuth', success, error));
	
	            _this.track('api', 'api_users_email_to_oauth');
	        };
	
	        this.oauthToEmail = function (email, password, success, error) {
	            var data = {};
	            data.password = password;
	            data.email = email;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/claim/oauth_to_email').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'oauthToEmail', success, error));
	
	            _this.track('api', 'api_users_oauth_to_email');
	        };
	
	        this.emailToLdap = function (email, password, ldapId, ldapPassword, success, error) {
	            var data = {};
	            data.email_password = password;
	            data.email = email;
	            data.ldap_id = ldapId;
	            data.ldap_password = ldapPassword;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/claim/email_to_ldap').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'emailToLdap', success, error));
	
	            _this.track('api', 'api_users_email_to_ldap');
	        };
	
	        this.ldapToEmail = function (email, emailPassword, ldapPassword, success, error) {
	            var data = {};
	            data.email = email;
	            data.ldap_password = ldapPassword;
	            data.email_password = emailPassword;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/claim/ldap_to_email').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'ldapToEmail', success, error));
	
	            _this.track('api', 'api_users_oauth_to_email');
	        };
	
	        this.getInitialLoad = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUsersRoute() + '/initial_load').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getInitialLoad', success, error));
	        };
	
	        this.getMe = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUsersRoute() + '/me').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getMe', success, error));
	        };
	
	        this.login = function (loginId, password, mfaToken, success, error) {
	            _this.doLogin({ login_id: loginId, password: password, token: mfaToken }, success, error);
	
	            _this.track('api', 'api_users_login', '', 'login_id', loginId);
	        };
	
	        this.loginById = function (id, password, mfaToken, success, error) {
	            _this.doLogin({ id: id, password: password, token: mfaToken }, success, error);
	
	            _this.track('api', 'api_users_login', '', 'id', id);
	        };
	
	        this.loginByLdap = function (loginId, password, mfaToken, success, error) {
	            _this.doLogin({ login_id: loginId, password: password, token: mfaToken, ldap_only: 'true' }, success, error);
	
	            _this.track('api', 'api_users_login', '', 'login_id', loginId);
	        };
	
	        this.doLogin = function (outgoingData, success, error) {
	            var outer = _this; // eslint-disable-line consistent-this
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/login').set(_this.defaultHeaders).type('application/json').accept('application/json').send(outgoingData).end(_this.handleResponse.bind(_this, 'login', function (data, res) {
	                if (res && res.header) {
	                    outer.token = res.header[HEADER_TOKEN];
	
	                    if (outer.useToken) {
	                        outer.defaultHeaders[HEADER_AUTH] = HEADER_BEARER + ' ' + outer.token;
	                    }
	                }
	
	                if (success) {
	                    success(data, res);
	                }
	            }, error));
	        };
	
	        this.logout = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/logout').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'logout', success, error));
	
	            _this.track('api', 'api_users_logout');
	        };
	
	        this.checkMfa = function (loginId, success, error) {
	            var data = {
	                login_id: loginId
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/mfa').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'checkMfa', success, error));
	
	            _this.track('api', 'api_users_oauth_to_email');
	        };
	
	        this.revokeSession = function (altId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/revoke_session').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ id: altId }).end(_this.handleResponse.bind(_this, 'revokeSession', success, error));
	        };
	
	        this.getSessions = function (userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUserNeededRoute(userId) + '/sessions').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getSessions', success, error));
	        };
	
	        this.getAudits = function (userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUserNeededRoute(userId) + '/audits').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getAudits', success, error));
	        };
	
	        this.getDirectProfiles = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUsersRoute() + '/direct_profiles').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getDirectProfiles', success, error));
	        };
	
	        this.getProfiles = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUsersRoute() + '/profiles/' + _this.getTeamId()).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getProfiles', success, error));
	        };
	
	        this.getProfilesForTeam = function (teamId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUsersRoute() + '/profiles/' + teamId).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getProfilesForTeam', success, error));
	        };
	
	        this.getProfilesForDirectMessageList = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getUsersRoute() + '/profiles_for_dm_list/' + _this.getTeamId()).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getProfilesForDirectMessageList', success, error));
	        };
	
	        this.getStatuses = function (ids, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/status').set(_this.defaultHeaders).type('application/json').accept('application/json').send(ids).end(_this.handleResponse.bind(_this, 'getStatuses', success, error));
	        };
	
	        this.verifyEmail = function (uid, hid, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/verify_email').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ uid: uid, hid: hid }).end(_this.handleResponse.bind(_this, 'verifyEmail', success, error));
	        };
	
	        this.resendVerification = function (email, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/resend_verification').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ email: email }).end(_this.handleResponse.bind(_this, 'resendVerification', success, error));
	        };
	
	        this.updateMfa = function (token, activate, success, error) {
	            var data = {};
	            data.activate = activate;
	            data.token = token;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/update_mfa').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updateMfa', success, error));
	        };
	
	        this.uploadProfileImage = function (image, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getUsersRoute() + '/newimage').set(_this.defaultHeaders).attach('image', image, image.name).accept('application/json').end(_this.handleResponse.bind(_this, 'uploadProfileImage', success, error));
	        };
	
	        this.createChannel = function (channel, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelsRoute() + '/create').set(_this.defaultHeaders).type('application/json').accept('application/json').send(channel).end(_this.handleResponse.bind(_this, 'createChannel', success, error));
	
	            _this.track('api', 'api_channels_create', channel.type, 'name', channel.name);
	        };
	
	        this.createDirectChannel = function (userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelsRoute() + '/create_direct').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(_this.handleResponse.bind(_this, 'createDirectChannel', success, error));
	        };
	
	        this.updateChannel = function (channel, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelsRoute() + '/update').set(_this.defaultHeaders).type('application/json').accept('application/json').send(channel).end(_this.handleResponse.bind(_this, 'updateChannel', success, error));
	
	            _this.track('api', 'api_channels_update');
	        };
	
	        this.updateChannelHeader = function (channelId, header, success, error) {
	            var data = {
	                channel_id: channelId,
	                channel_header: header
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelsRoute() + '/update_header').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updateChannel', success, error));
	
	            _this.track('api', 'api_channels_header');
	        };
	
	        this.updateChannelPurpose = function (channelId, purpose, success, error) {
	            var data = {
	                channel_id: channelId,
	                channel_purpose: purpose
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelsRoute() + '/update_purpose').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updateChannelPurpose', success, error));
	
	            _this.track('api', 'api_channels_purpose');
	        };
	
	        this.updateChannelNotifyProps = function (data, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelsRoute() + '/update_notify_props').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'updateChannelNotifyProps', success, error));
	        };
	
	        this.leaveChannel = function (channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/leave').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'leaveChannel', success, error));
	
	            _this.track('api', 'api_channels_leave');
	        };
	
	        this.joinChannel = function (channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/join').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'joinChannel', success, error));
	
	            _this.track('api', 'api_channels_join');
	        };
	
	        this.joinChannelByName = function (name, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNameRoute(name) + '/join').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'joinChannelByName', success, error));
	
	            _this.track('api', 'api_channels_join_name');
	        };
	
	        this.deleteChannel = function (channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/delete').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'deleteChannel', success, error));
	
	            _this.track('api', 'api_channels_delete');
	        };
	
	        this.updateLastViewedAt = function (channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/update_last_viewed_at').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'updateLastViewedAt', success, error));
	        };
	
	        this.getChannels = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getChannelsRoute() + '/').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getChannels', success, error));
	        };
	
	        this.getChannel = function (channelId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getChannelNeededRoute(channelId) + '/').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getChannel', success, error));
	
	            _this.track('api', 'api_channel_get');
	        };
	
	        this.getMoreChannels = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getChannelsRoute() + '/more').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getMoreChannels', success, error));
	        };
	
	        this.getChannelCounts = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getChannelsRoute() + '/counts').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getChannelCounts', success, error));
	        };
	
	        this.getChannelExtraInfo = function (channelId, memberLimit, success, error) {
	            var url = _this.getChannelNeededRoute(channelId) + '/extra_info';
	            if (memberLimit) {
	                url += '/' + memberLimit;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(url).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getChannelExtraInfo', success, error));
	        };
	
	        this.addChannelMember = function (channelId, userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/add').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(_this.handleResponse.bind(_this, 'addChannelMember', success, error));
	
	            _this.track('api', 'api_channels_add_member');
	        };
	
	        this.removeChannelMember = function (channelId, userId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/remove').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ user_id: userId }).end(_this.handleResponse.bind(_this, 'removeChannelMember', success, error));
	
	            _this.track('api', 'api_channels_remove_member');
	        };
	
	        this.listCommands = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getCommandsRoute() + '/list').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'listCommands', success, error));
	        };
	
	        this.executeCommand = function (channelId, command, suggest, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getCommandsRoute() + '/execute').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ channelId: channelId, command: command, suggest: '' + suggest }).end(_this.handleResponse.bind(_this, 'executeCommand', success, error));
	        };
	
	        this.addCommand = function (command, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getCommandsRoute() + '/create').set(_this.defaultHeaders).type('application/json').accept('application/json').send(command).end(_this.handleResponse.bind(_this, 'addCommand', success, error));
	        };
	
	        this.deleteCommand = function (commandId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getCommandsRoute() + '/delete').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ id: commandId }).end(_this.handleResponse.bind(_this, 'deleteCommand', success, error));
	        };
	
	        this.listTeamCommands = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getCommandsRoute() + '/list_team_commands').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'listTeamCommands', success, error));
	        };
	
	        this.regenCommandToken = function (commandId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getCommandsRoute() + '/regen_token').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ id: commandId }).end(_this.handleResponse.bind(_this, 'regenCommandToken', success, error));
	        };
	
	        this.createPost = function (post, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getPostsRoute(post.channel_id) + '/create').set(_this.defaultHeaders).type('application/json').accept('application/json').send(post).end(_this.handleResponse.bind(_this, 'createPost', success, error));
	
	            _this.track('api', 'api_posts_create', post.channel_id, 'length', post.message.length);
	        };
	
	        this.getPermalinkTmp = function (postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamNeededRoute() + '/pltmp/' + postId).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPermalinkTmp', success, error));
	        };
	
	        this.getPostById = function (postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getTeamNeededRoute() + '/posts/' + postId).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPostById', success, error));
	        };
	
	        this.getPost = function (channelId, postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getChannelNeededRoute(channelId) + '/posts/' + postId + '/get').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPost', success, error));
	        };
	
	        this.updatePost = function (post, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getPostsRoute(post.channel_id) + '/update').set(_this.defaultHeaders).type('application/json').accept('application/json').send(post).end(_this.handleResponse.bind(_this, 'updatePost', success, error));
	
	            _this.track('api', 'api_posts_update');
	        };
	
	        this.deletePost = function (channelId, postId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getChannelNeededRoute(channelId) + '/posts/' + postId + '/delete').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'deletePost', success, error));
	
	            _this.track('api', 'api_posts_delete');
	        };
	
	        this.search = function (terms, isOrSearch, success, error) {
	            var data = {};
	            data.terms = terms;
	            data.is_or_search = isOrSearch;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getTeamNeededRoute() + '/posts/search').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'search', success, error));
	
	            _this.track('api', 'api_posts_search');
	        };
	
	        this.getPostsPage = function (channelId, offset, limit, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getPostsRoute(channelId) + '/page/' + offset + '/' + limit).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPostsPage', success, error));
	        };
	
	        this.getPosts = function (channelId, since, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getPostsRoute(channelId) + '/since/' + since).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPosts', success, error));
	        };
	
	        this.getPostsBefore = function (channelId, postId, offset, numPost, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getPostsRoute(channelId) + '/' + postId + '/before/' + offset + '/' + numPost).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPostsBefore', success, error));
	        };
	
	        this.getPostsAfter = function (channelId, postId, offset, numPost, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getPostsRoute(channelId) + '/' + postId + '/after/' + offset + '/' + numPost).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPostsAfter', success, error));
	        };
	
	        this.getFileInfo = function (filename, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getFilesRoute() + '/get_info' + filename).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getFileInfo', success, error));
	        };
	
	        this.getPublicLink = function (filename, success, error) {
	            var data = {
	                filename: filename
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getFilesRoute() + '/get_public_link').set(_this.defaultHeaders).type('application/json').accept('application/json').send(data).end(_this.handleResponse.bind(_this, 'getPublicLink', success, error));
	        };
	
	        this.uploadFile = function (file, filename, channelId, clientId, success, error) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getFilesRoute() + '/upload').set(_this.defaultHeaders).attach('files', file, filename).field('channel_id', channelId).field('client_ids', clientId).accept('application/json').end(_this.handleResponse.bind(_this, 'uploadFile', success, error));
	        };
	
	        this.registerOAuthApp = function (app, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getOAuthRoute() + '/register').set(_this.defaultHeaders).type('application/json').accept('application/json').send(app).end(_this.handleResponse.bind(_this, 'registerOAuthApp', success, error));
	
	            _this.track('api', 'api_apps_register');
	        };
	
	        this.allowOAuth2 = function (responseType, clientId, redirectUri, state, scope, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getOAuthRoute() + '/allow').set(_this.defaultHeaders).type('application/json').accept('application/json').query({ response_type: responseType }).query({ client_id: clientId }).query({ redirect_uri: redirectUri }).query({ scope: scope }).query({ state: state }).end(_this.handleResponse.bind(_this, 'allowOAuth2', success, error));
	        };
	
	        this.addIncomingHook = function (hook, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getHooksRoute() + '/incoming/create').set(_this.defaultHeaders).type('application/json').accept('application/json').send(hook).end(_this.handleResponse.bind(_this, 'addIncomingHook', success, error));
	        };
	
	        this.deleteIncomingHook = function (hookId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getHooksRoute() + '/incoming/delete').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ id: hookId }).end(_this.handleResponse.bind(_this, 'deleteIncomingHook', success, error));
	        };
	
	        this.listIncomingHooks = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getHooksRoute() + '/incoming/list').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'listIncomingHooks', success, error));
	        };
	
	        this.addOutgoingHook = function (hook, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getHooksRoute() + '/outgoing/create').set(_this.defaultHeaders).type('application/json').accept('application/json').send(hook).end(_this.handleResponse.bind(_this, 'addOutgoingHook', success, error));
	        };
	
	        this.deleteOutgoingHook = function (hookId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getHooksRoute() + '/outgoing/delete').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ id: hookId }).end(_this.handleResponse.bind(_this, 'deleteOutgoingHook', success, error));
	        };
	
	        this.listOutgoingHooks = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getHooksRoute() + '/outgoing/list').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'listOutgoingHooks', success, error));
	        };
	
	        this.regenOutgoingHookToken = function (hookId, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getHooksRoute() + '/outgoing/regen_token').set(_this.defaultHeaders).type('application/json').accept('application/json').send({ id: hookId }).end(_this.handleResponse.bind(_this, 'regenOutgoingHookToken', success, error));
	        };
	
	        this.getAllPreferences = function (success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getBaseRoute() + '/preferences/').set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getAllPreferences', success, error));
	        };
	
	        this.savePreferences = function (preferences, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(_this.getBaseRoute() + '/preferences/save').set(_this.defaultHeaders).type('application/json').accept('application/json').send(preferences).end(_this.handleResponse.bind(_this, 'savePreferences', success, error));
	        };
	
	        this.getPreferenceCategory = function (category, success, error) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get(_this.getBaseRoute() + '/preferences/' + category).set(_this.defaultHeaders).type('application/json').accept('application/json').end(_this.handleResponse.bind(_this, 'getPreferenceCategory', success, error));
	        };
	
	        this.teamId = '';
	        this.serverVersion = '';
	        this.logToConsole = false;
	        this.useToken = false;
	        this.token = '';
	        this.url = '';
	        this.urlVersion = '/api/v3';
	        this.defaultHeaders = {
	            'X-Requested-With': 'XMLHttpRequest'
	        };
	
	        this.translations = {
	            connectionError: 'There appears to be a problem with your internet connection.',
	            unknownError: 'We received an unexpected status code from the server.'
	        };
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default.a.bind()(Client, [{
	        key: 'getBaseRoute',
	        value: function getBaseRoute() {
	            return '' + this.url + this.urlVersion;
	        }
	    }, {
	        key: 'getAdminRoute',
	        value: function getAdminRoute() {
	            return '' + this.url + this.urlVersion + '/admin';
	        }
	    }, {
	        key: 'getLicenseRoute',
	        value: function getLicenseRoute() {
	            return '' + this.url + this.urlVersion + '/license';
	        }
	    }, {
	        key: 'getTeamsRoute',
	        value: function getTeamsRoute() {
	            return '' + this.url + this.urlVersion + '/teams';
	        }
	    }, {
	        key: 'getTeamNeededRoute',
	        value: function getTeamNeededRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId();
	        }
	    }, {
	        key: 'getChannelsRoute',
	        value: function getChannelsRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels';
	        }
	    }, {
	        key: 'getChannelNameRoute',
	        value: function getChannelNameRoute(channelName) {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels/name/' + channelName;
	        }
	    }, {
	        key: 'getChannelNeededRoute',
	        value: function getChannelNeededRoute(channelId) {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels/' + channelId;
	        }
	    }, {
	        key: 'getCommandsRoute',
	        value: function getCommandsRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/commands';
	        }
	    }, {
	        key: 'getHooksRoute',
	        value: function getHooksRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/hooks';
	        }
	    }, {
	        key: 'getPostsRoute',
	        value: function getPostsRoute(channelId) {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/channels/' + channelId + '/posts';
	        }
	    }, {
	        key: 'getUsersRoute',
	        value: function getUsersRoute() {
	            return '' + this.url + this.urlVersion + '/users';
	        }
	    }, {
	        key: 'getFilesRoute',
	        value: function getFilesRoute() {
	            return '' + this.url + this.urlVersion + '/teams/' + this.getTeamId() + '/files';
	        }
	    }, {
	        key: 'getOAuthRoute',
	        value: function getOAuthRoute() {
	            return '' + this.url + this.urlVersion + '/oauth';
	        }
	    }, {
	        key: 'getUserNeededRoute',
	        value: function getUserNeededRoute(userId) {
	            return '' + this.url + this.urlVersion + '/users/' + userId;
	        }
	
	        // General / Admin / Licensing Routes Section
	
	        // Team Routes Section
	
	        // User Routes Setions
	
	        // Channel Routes Section
	
	        // Routes for Commands
	
	        // Routes for Posts
	
	        // This is a temporary route to get around a problem with the permissions system that
	        // will be fixed in 3.1 or 3.2
	
	
	        // Routes for Files
	
	        // Routes for OAuth
	
	        // Routes for Hooks
	
	        //Routes for Prefrecnes
	
	    }]);
	
	    return Client;
	}();
	
	/* harmony default export */ exports["a"] = Client;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__audit_table_jsx__ = __webpack_require__(351);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var AccessHistoryModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AccessHistoryModal, _React$Component);
	
	    function AccessHistoryModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AccessHistoryModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AccessHistoryModal).call(this, props));
	
	        _this.onAuditChange = _this.onAuditChange.bind(_this);
	        _this.onShow = _this.onShow.bind(_this);
	        _this.onHide = _this.onHide.bind(_this);
	
	        var state = _this.getStateFromStoresForAudits();
	        state.moreInfo = [];
	
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AccessHistoryModal, [{
	        key: 'getStateFromStoresForAudits',
	        value: function getStateFromStoresForAudits() {
	            return {
	                audits: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getAudits()
	            };
	        }
	    }, {
	        key: 'onShow',
	        value: function onShow() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getAudits();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.modal-body').perfectScrollbar();
	            }
	        }
	    }, {
	        key: 'onHide',
	        value: function onHide() {
	            this.setState({ moreInfo: [] });
	            this.props.onHide();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].addAuditsChangeListener(this.onAuditChange);
	
	            if (this.props.show) {
	                this.onShow();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.show && !prevProps.show) {
	                this.onShow();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].removeAuditsChangeListener(this.onAuditChange);
	        }
	    }, {
	        key: 'onAuditChange',
	        value: function onAuditChange() {
	            var newState = this.getStateFromStoresForAudits();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(newState.audits, this.state.audits)) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content;
	            if (this.state.audits.loading) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__loading_screen_jsx__["a"], null);
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__audit_table_jsx__["a"], {
	                    audits: this.state.audits,
	                    showIp: true,
	                    showSession: true
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.onHide,
	                    bsSize: 'large'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'access_history.title',
	                            defaultMessage: 'Access History'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
	                    { ref: 'modalBody' },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return AccessHistoryModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	AccessHistoryModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["injectIntl"].bind()(AccessHistoryModal);

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActivityLogModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ActivityLogModal, _React$Component);
	
	    function ActivityLogModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ActivityLogModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ActivityLogModal).call(this, props));
	
	        _this.submitRevoke = _this.submitRevoke.bind(_this);
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	        _this.handleMoreInfo = _this.handleMoreInfo.bind(_this);
	        _this.onHide = _this.onHide.bind(_this);
	        _this.onShow = _this.onShow.bind(_this);
	
	        var state = _this.getStateFromStores();
	        state.moreInfo = [];
	
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ActivityLogModal, [{
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            return {
	                sessions: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].getSessions(),
	                serverError: null,
	                clientError: null
	            };
	        }
	    }, {
	        key: 'submitRevoke',
	        value: function submitRevoke(altId, e) {
	            e.preventDefault();
	            var modalContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).closest('.modal-content');
	            modalContent.addClass('animation--highlight');
	            setTimeout(function () {
	                modalContent.removeClass('animation--highlight');
	            }, 1500);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].revokeSession(altId, function handleRevokeSuccess() {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getSessions();
	            }, function handleRevokeError(err) {
	                var state = this.getStateFromStores();
	                state.serverError = err;
	                this.setState(state);
	            }.bind(this));
	        }
	    }, {
	        key: 'onShow',
	        value: function onShow() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getSessions();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.modal-body').perfectScrollbar();
	            }
	        }
	    }, {
	        key: 'onHide',
	        value: function onHide() {
	            this.setState({ moreInfo: [] });
	            this.props.onHide();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].addSessionsChangeListener(this.onListenerChange);
	
	            if (this.props.show) {
	                this.onShow();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.show && !prevProps.show) {
	                this.onShow();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].removeSessionsChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            var newState = this.getStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(newState.sessions, this.state.sessions)) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'handleMoreInfo',
	        value: function handleMoreInfo(index) {
	            var newMoreInfo = this.state.moreInfo;
	            newMoreInfo[index] = true;
	            this.setState({ moreInfo: newMoreInfo });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var activityList = [];
	
	            for (var i = 0; i < this.state.sessions.length; i++) {
	                var currentSession = this.state.sessions[i];
	                var lastAccessTime = new Date(currentSession.last_activity_at);
	                var firstAccessTime = new Date(currentSession.create_at);
	                var devicePlatform = currentSession.props.platform;
	                var devicePicture = '';
	
	                if (currentSession.props.platform === 'Windows') {
	                    devicePicture = 'fa fa-windows';
	                } else if (currentSession.device_id && currentSession.device_id.indexOf('apple:') === 0) {
	                    devicePicture = 'fa fa-apple';
	                    devicePlatform = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'activity_log_modal.iphoneNativeApp',
	                        defaultMessage: 'iPhone Native App'
	                    });
	                } else if (currentSession.device_id && currentSession.device_id.indexOf('android:') === 0) {
	                    devicePlatform = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'activity_log_modal.androidNativeApp',
	                        defaultMessage: 'Android Native App'
	                    });
	                    devicePicture = 'fa fa-android';
	                } else if (currentSession.props.platform === 'Macintosh' || currentSession.props.platform === 'iPhone') {
	                    devicePicture = 'fa fa-apple';
	                } else if (currentSession.props.platform === 'Linux') {
	                    if (currentSession.props.os.indexOf('Android') >= 0) {
	                        devicePlatform = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'activity_log_modal.android',
	                            defaultMessage: 'Android'
	                        });
	                        devicePicture = 'fa fa-android';
	                    } else {
	                        devicePicture = 'fa fa-linux';
	                    }
	                }
	
	                var moreInfo = void 0;
	                if (this.state.moreInfo[i]) {
	                    moreInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'activity_log.firstTime',
	                                defaultMessage: 'First time active: {date}, {time}',
	                                values: {
	                                    date: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedDate"], {
	                                        value: firstAccessTime,
	                                        day: '2-digit',
	                                        month: 'long',
	                                        year: 'numeric'
	                                    }),
	                                    time: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedTime"], {
	                                        value: firstAccessTime,
	                                        hour: '2-digit',
	                                        minute: '2-digit'
	                                    })
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'activity_log.os',
	                                defaultMessage: 'OS: {os}',
	                                values: {
	                                    os: currentSession.props.os
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'activity_log.browser',
	                                defaultMessage: 'Browser: {browser}',
	                                values: {
	                                    browser: currentSession.props.browser
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'activity_log.sessionId',
	                                defaultMessage: 'Session ID: {id}',
	                                values: {
	                                    id: currentSession.id
	                                }
	                            })
	                        )
	                    );
	                } else {
	                    moreInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            className: 'theme',
	                            href: '#',
	                            onClick: this.handleMoreInfo.bind(this, i)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'activity_log.moreInfo',
	                            defaultMessage: 'More info'
	                        })
	                    );
	                }
	
	                activityList[i] = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'activityLogEntryKey' + i,
	                        className: 'activity-log__table'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'activity-log__report' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'report__platform' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('i', { className: devicePicture }),
	                            devicePlatform
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'report__info' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'activity_log.lastActivity',
	                                    defaultMessage: 'Last activity: {date}, {time}',
	                                    values: {
	                                        date: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedDate"], {
	                                            value: lastAccessTime,
	                                            day: '2-digit',
	                                            month: 'long',
	                                            year: 'numeric'
	                                        }),
	                                        time: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedTime"], {
	                                            value: lastAccessTime,
	                                            hour: '2-digit',
	                                            minute: '2-digit'
	                                        })
	                                    }
	                                })
	                            ),
	                            moreInfo
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'activity-log__action' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'button',
	                            {
	                                onClick: this.submitRevoke.bind(this, currentSession.id),
	                                className: 'btn btn-primary'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'activity_log.logout',
	                                defaultMessage: 'Logout'
	                            })
	                        )
	                    )
	                );
	            }
	
	            var content = void 0;
	            if (this.state.sessions.loading) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__loading_screen_jsx__["a"], null);
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'form',
	                    { role: 'form' },
	                    activityList
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.onHide,
	                    bsSize: 'large'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'activity_log.activeSessions',
	                            defaultMessage: 'Active Sessions'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Body,
	                    { ref: 'modalBody' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'p',
	                        { className: 'session-help-text' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'activity_log.sessionsDescription',
	                            defaultMessage: 'Sessions are created when you log in to a new browser on a device. Sessions let you use Mattermost without having to log in again for a time period specified by the System Admin. If you want to log out sooner, use the \'Logout\' button below to end a session.'
	                        })
	                    ),
	                    content
	                )
	            );
	        }
	    }]);
	
	    return ActivityLogModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ActivityLogModal;
	
	
	ActivityLogModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.bool.isRequired,
	    onHide: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__admin_sidebar_jsx__ = __webpack_require__(641);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__ = __webpack_require__(191);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__email_settings_jsx__ = __webpack_require__(648);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__log_settings_jsx__ = __webpack_require__(654);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__logs_jsx__ = __webpack_require__(655);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__audits_jsx__ = __webpack_require__(643);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__image_settings_jsx__ = __webpack_require__(650);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__privacy_settings_jsx__ = __webpack_require__(656);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rate_settings_jsx__ = __webpack_require__(657);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__gitlab_settings_jsx__ = __webpack_require__(649);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sql_settings_jsx__ = __webpack_require__(660);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__team_settings_jsx__ = __webpack_require__(661);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__service_settings_jsx__ = __webpack_require__(659);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__legal_and_support_settings_jsx__ = __webpack_require__(652);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__team_users_jsx__ = __webpack_require__(662);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__analytics_team_analytics_jsx__ = __webpack_require__(666);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ldap_settings_jsx__ = __webpack_require__(651);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__compliance_settings_jsx__ = __webpack_require__(646);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__license_settings_jsx__ = __webpack_require__(653);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__analytics_system_analytics_jsx__ = __webpack_require__(350);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react___default = __WEBPACK_IMPORTED_MODULE_30_react__ && __WEBPACK_IMPORTED_MODULE_30_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_30_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_30_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_30_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_30_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var AdminController = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(AdminController, _React$Component);
	
	    function AdminController(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AdminController);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AdminController).call(this, props));
	
	        _this.selectTab = _this.selectTab.bind(_this);
	        _this.removeSelectedTeam = _this.removeSelectedTeam.bind(_this);
	        _this.addSelectedTeam = _this.addSelectedTeam.bind(_this);
	        _this.onConfigListenerChange = _this.onConfigListenerChange.bind(_this);
	        _this.onAllTeamsListenerChange = _this.onAllTeamsListenerChange.bind(_this);
	
	        var selectedTeams = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams();
	        if (selectedTeams == null) {
	            selectedTeams = {};
	            selectedTeams[/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].getCurrentId()] = 'true';
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].saveSelectedTeams(selectedTeams);
	        }
	
	        _this.state = {
	            config: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getConfig(),
	            teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAllTeams(),
	            selectedTeams: selectedTeams,
	            selected: props.tab || 'system_analytics',
	            selectedTeam: props.teamId || null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(AdminController, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].addConfigChangeListener(this.onConfigListenerChange);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getConfig();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].addAllTeamsChangeListener(this.onAllTeamsListenerChange);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getAllTeams();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('[data-toggle="tooltip"]').tooltip();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('[data-toggle="popover"]').popover();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].removeConfigChangeListener(this.onConfigListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].removeAllTeamsChangeListener(this.onAllTeamsListenerChange);
	        }
	    }, {
	        key: 'onConfigListenerChange',
	        value: function onConfigListenerChange() {
	            this.setState({
	                config: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getConfig(),
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAllTeams(),
	                selectedTeams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams(),
	                selected: this.state.selected,
	                selectedTeam: this.state.selectedTeam
	            });
	        }
	    }, {
	        key: 'onAllTeamsListenerChange',
	        value: function onAllTeamsListenerChange() {
	            this.setState({
	                config: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getConfig(),
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAllTeams(),
	                selectedTeams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams(),
	                selected: this.state.selected,
	                selectedTeam: this.state.selectedTeam
	
	            });
	        }
	    }, {
	        key: 'selectTab',
	        value: function selectTab(tab, teamId) {
	            this.setState({
	                config: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getConfig(),
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAllTeams(),
	                selectedTeams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams(),
	                selected: tab,
	                selectedTeam: teamId
	            });
	        }
	    }, {
	        key: 'removeSelectedTeam',
	        value: function removeSelectedTeam(teamId) {
	            var selectedTeams = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(selectedTeams, teamId);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].saveSelectedTeams(selectedTeams);
	
	            this.setState({
	                config: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getConfig(),
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAllTeams(),
	                selectedTeams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams(),
	                selected: this.state.selected,
	                selectedTeam: this.state.selectedTeam
	            });
	        }
	    }, {
	        key: 'addSelectedTeam',
	        value: function addSelectedTeam(teamId) {
	            var selectedTeams = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams();
	            selectedTeams[teamId] = 'true';
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].saveSelectedTeams(selectedTeams);
	
	            this.setState({
	                config: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getConfig(),
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAllTeams(),
	                selectedTeams: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getSelectedTeams(),
	                selected: this.state.selected,
	                selectedTeam: this.state.selectedTeam
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__loading_screen_jsx__["a"], null);
	
	            if (this.state.config != null) {
	                if (this.state.selected === 'email_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__email_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'log_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13__log_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'logs') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__logs_jsx__["a"], null);
	                } else if (this.state.selected === 'audits') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15__audits_jsx__["a"], null);
	                } else if (this.state.selected === 'image_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16__image_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'privacy_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17__privacy_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'rate_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18__rate_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'gitlab_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_19__gitlab_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'sql_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_20__sql_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'team_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_21__team_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'service_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_22__service_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'legal_and_support_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_23__legal_and_support_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'ldap_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_26__ldap_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'compliance_settings') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_27__compliance_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'license') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_28__license_settings_jsx__["a"], { config: this.state.config });
	                } else if (this.state.selected === 'team_users') {
	                    if (this.state.teams) {
	                        tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_24__team_users_jsx__["a"], { team: this.state.teams[this.state.selectedTeam] });
	                    }
	                } else if (this.state.selected === 'team_analytics') {
	                    if (this.state.teams) {
	                        tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25__analytics_team_analytics_jsx__["a"], { team: this.state.teams[this.state.selectedTeam] });
	                    }
	                } else if (this.state.selected === 'system_analytics') {
	                    tab = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_29__analytics_system_analytics_jsx__["c"], null);
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
	                'div',
	                {
	                    id: 'admin_controller',
	                    className: 'admin-controller'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('div', {
	                    className: 'sidebar--menu',
	                    id: 'sidebar-menu'
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__admin_sidebar_jsx__["a"], {
	                    selected: this.state.selected,
	                    selectedTeam: this.state.selectedTeam,
	                    selectTab: this.selectTab,
	                    teams: this.state.teams,
	                    selectedTeams: this.state.selectedTeams,
	                    removeSelectedTeam: this.removeSelectedTeam,
	                    addSelectedTeam: this.addSelectedTeam
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
	                    'div',
	                    { className: 'inner-wrap channel__wrap' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement('div', { className: 'row header' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
	                        'div',
	                        { className: 'row main' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.createElement(
	                            'div',
	                            {
	                                id: 'app-content',
	                                className: 'app__content admin'
	                            },
	                            tab
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AdminController;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AdminController;
	
	
	AdminController.defaultProps = {};
	
	AdminController.propTypes = {
	    tab: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.PropTypes.string,
	    teamId: /* harmony import */__WEBPACK_IMPORTED_MODULE_30_react___default.a.PropTypes.string
	};

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router___default = __WEBPACK_IMPORTED_MODULE_11_react_router__ && __WEBPACK_IMPORTED_MODULE_11_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var AdminNavbarDropdown = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AdminNavbarDropdown, _React$Component);
	
	    function AdminNavbarDropdown(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AdminNavbarDropdown);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AdminNavbarDropdown).call(this, props));
	
	        _this.blockToggle = false;
	        _this.onTeamChange = _this.onTeamChange.bind(_this);
	
	        _this.state = {
	            teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getAll(),
	            teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getTeamMembers()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AdminNavbarDropdown, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.dropdown)).on('hide.bs.dropdown', function () {
	                _this2.blockToggle = true;
	                setTimeout(function () {
	                    _this2.blockToggle = false;
	                }, 100);
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].addChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.dropdown)).off('hide.bs.dropdown');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].removeChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'onTeamChange',
	        value: function onTeamChange() {
	            this.setState({
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getAll(),
	                teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getTeamMembers()
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var teams = [];
	
	            if (this.state.teamMembers && this.state.teamMembers.length > 0) {
	                teams.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('li', {
	                    key: 'teamDiv',
	                    className: 'divider'
	                }));
	
	                for (var index in this.state.teamMembers) {
	                    if (this.state.teamMembers.hasOwnProperty(index)) {
	                        var teamMember = this.state.teamMembers[index];
	                        var team = this.state.teams[teamMember.team_id];
	                        teams.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'li',
	                            { key: 'team_' + team.name },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_router__["Link"],
	                                {
	                                    to: '/' + team.name + '/channels/town-square'
	                                },
	                                team.display_name
	                            )
	                        ));
	                    }
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                'ul',
	                { className: 'nav navbar-nav navbar-right' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'li',
	                    {
	                        ref: 'dropdown',
	                        className: 'dropdown'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            className: 'dropdown-toggle',
	                            'data-toggle': 'dropdown',
	                            role: 'button',
	                            'aria-expanded': 'false'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('span', {
	                            className: 'dropdown__icon',
	                            dangerouslySetInnerHTML: { __html: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].MENU_ICON }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'ul',
	                        {
	                            className: 'dropdown-menu',
	                            role: 'menu'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_router__["Link"],
	                                {
	                                    to: '/select_team'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.nav.switch',
	                                    defaultMessage: 'Switch to {display_name}',
	                                    values: {
	                                        display_name: global.window.mm_config.SiteName
	                                    }
	                                })
	                            )
	                        ),
	                        teams,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('li', {
	                            key: 'teamDiv',
	                            className: 'divider'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_action_creators_global_actions_jsx__.emitUserLoggedOutEvent
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.nav.logout',
	                                    defaultMessage: 'Logout'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AdminNavbarDropdown;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AdminNavbarDropdown;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __WEBPACK_IMPORTED_MODULE_7_jquery__ && __WEBPACK_IMPORTED_MODULE_7_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__admin_sidebar_header_jsx__ = __webpack_require__(642);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__select_team_modal_jsx__ = __webpack_require__(346);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var AdminSidebar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(AdminSidebar, _React$Component);
	
	    function AdminSidebar(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AdminSidebar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AdminSidebar).call(this, props));
	
	        _this.isSelected = _this.isSelected.bind(_this);
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.removeTeam = _this.removeTeam.bind(_this);
	
	        _this.showTeamSelect = _this.showTeamSelect.bind(_this);
	        _this.teamSelectedModal = _this.teamSelectedModal.bind(_this);
	        _this.teamSelectedModalDismissed = _this.teamSelectedModalDismissed.bind(_this);
	
	        _this.state = {
	            showSelectModal: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(AdminSidebar, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.sidebar--left .nav-pills__container').perfectScrollbar();
	            }
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick(name, teamId, e) {
	            e.preventDefault();
	            this.props.selectTab(name, teamId);
	        }
	    }, {
	        key: 'isSelected',
	        value: function isSelected(name, teamId) {
	            if (this.props.selected === name) {
	                if (name === 'team_users' || name === 'team_analytics') {
	                    if (this.props.selectedTeam != null && this.props.selectedTeam === teamId) {
	                        return 'active';
	                    }
	                } else {
	                    return 'active';
	                }
	            }
	
	            return '';
	        }
	    }, {
	        key: 'removeTeam',
	        value: function removeTeam(teamId, e) {
	            e.preventDefault();
	            e.stopPropagation();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default.a.bind()(this.props.selectedTeams, teamId);
	            this.props.removeSelectedTeam(teamId);
	
	            if (this.props.selected === 'team_users') {
	                if (this.props.selectedTeam != null && this.props.selectedTeam === teamId) {
	                    this.props.selectTab('service_settings', null);
	                }
	            }
	        }
	    }, {
	        key: 'showTeamSelect',
	        value: function showTeamSelect(e) {
	            e.preventDefault();
	            this.setState({ showSelectModal: true });
	        }
	    }, {
	        key: 'teamSelectedModal',
	        value: function teamSelectedModal(teamId) {
	            this.setState({ showSelectModal: false });
	            this.props.addSelectedTeam(teamId);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'teamSelectedModalDismissed',
	        value: function teamSelectedModalDismissed() {
	            this.setState({ showSelectModal: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var count = '*';
	            var teams = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                id: 'admin.sidebar.loading',
	                defaultMessage: 'Loading'
	            });
	            var removeTooltip = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Tooltip"],
	                { id: 'remove-team-tooltip' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'admin.sidebar.rmTeamSidebar',
	                    defaultMessage: 'Remove team from sidebar menu'
	                })
	            );
	            var addTeamTooltip = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Tooltip"],
	                { id: 'add-team-tooltip' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'admin.sidebar.addTeamSidebar',
	                    defaultMessage: 'Add team from sidebar menu'
	                })
	            );
	
	            if (this.props.teams != null) {
	                count = '' + /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(this.props.teams).length;
	
	                teams = [];
	                for (var key in this.props.selectedTeams) {
	                    if (this.props.selectedTeams.hasOwnProperty(key)) {
	                        var team = this.props.teams[key];
	
	                        if (team != null) {
	                            teams.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                {
	                                    key: 'team_' + team.id,
	                                    className: 'nav nav__sub-menu'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            onClick: this.handleClick.bind(this, 'team_users', team.id),
	                                            className: 'nav__sub-menu-item ' + this.isSelected('team_users', team.id) + ' ' + this.isSelected('team_analytics', team.id)
	                                        },
	                                        team.name,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["OverlayTrigger"],
	                                            {
	                                                delayShow: 1000,
	                                                placement: 'top',
	                                                overlay: removeTooltip
	                                            },
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                                'span',
	                                                {
	                                                    className: 'menu-icon--right menu__close',
	                                                    onClick: this.removeTeam.bind(this, team.id),
	                                                    style: { cursor: 'pointer' }
	                                                },
	                                                '×'
	                                            )
	                                        )
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'ul',
	                                        { className: 'nav nav__inner-menu' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'li',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                                'a',
	                                                {
	                                                    href: '#',
	                                                    className: this.isSelected('team_users', team.id),
	                                                    onClick: this.handleClick.bind(this, 'team_users', team.id)
	                                                },
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                                    id: 'admin.sidebar.users',
	                                                    defaultMessage: '- Users'
	                                                })
	                                            )
	                                        ),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'li',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                                'a',
	                                                {
	                                                    href: '#',
	                                                    className: this.isSelected('team_analytics', team.id),
	                                                    onClick: this.handleClick.bind(this, 'team_analytics', team.id)
	                                                },
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                                    id: 'admin.sidebar.statistics',
	                                                    defaultMessage: '- Statistics'
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            ));
	                        }
	                    }
	                }
	            }
	
	            var ldapSettings = void 0;
	            var complianceSettings = void 0;
	            var licenseSettings = void 0;
	            if (global.window.mm_config.BuildEnterpriseReady === 'true') {
	                if (global.window.mm_license.IsLicensed === 'true') {
	                    if (global.window.mm_license.LDAP === 'true') {
	                        ldapSettings = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    className: this.isSelected('ldap_settings'),
	                                    onClick: this.handleClick.bind(this, 'ldap_settings', null)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sidebar.ldap',
	                                    defaultMessage: 'LDAP Settings'
	                                })
	                            )
	                        );
	                    }
	
	                    if (global.window.mm_license.Compliance === 'true') {
	                        complianceSettings = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    className: this.isSelected('compliance_settings'),
	                                    onClick: this.handleClick.bind(this, 'compliance_settings', null)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sidebar.compliance',
	                                    defaultMessage: 'Compliance Settings'
	                                })
	                            )
	                        );
	                    }
	                }
	
	                licenseSettings = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            className: this.isSelected('license'),
	                            onClick: this.handleClick.bind(this, 'license', null)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'admin.sidebar.license',
	                            defaultMessage: 'Edition and License'
	                        })
	                    )
	                );
	            }
	
	            var audits = void 0;
	            if (global.window.mm_license.IsLicensed === 'true') {
	                audits = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            className: this.isSelected('audits'),
	                            onClick: this.handleClick.bind(this, 'audits', null)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'admin.sidebar.audits',
	                            defaultMessage: 'Compliance and Auditing'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { className: 'sidebar--left sidebar--collapsable' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__admin_sidebar_header_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'nav-pills__container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'ul',
	                        { className: 'nav nav-pills nav-stacked' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'h4',
	                                        null,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', { className: 'icon fa fa-gear' }),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'span',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                                id: 'admin.sidebar.reports',
	                                                defaultMessage: 'SITE REPORTS'
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu padded' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('system_analytics'),
	                                            onClick: this.handleClick.bind(this, 'system_analytics', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.view_statistics',
	                                            defaultMessage: 'View Statistics'
	                                        })
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'h4',
	                                        null,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', { className: 'icon fa fa-gear' }),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'span',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                                id: 'admin.sidebar.settings',
	                                                defaultMessage: 'SETTINGS'
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu padded' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('service_settings'),
	                                            onClick: this.handleClick.bind(this, 'service_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.service',
	                                            defaultMessage: 'Service Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('team_settings'),
	                                            onClick: this.handleClick.bind(this, 'team_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.team',
	                                            defaultMessage: 'Team Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('sql_settings'),
	                                            onClick: this.handleClick.bind(this, 'sql_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.sql',
	                                            defaultMessage: 'SQL Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('email_settings'),
	                                            onClick: this.handleClick.bind(this, 'email_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.email',
	                                            defaultMessage: 'Email Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('image_settings'),
	                                            onClick: this.handleClick.bind(this, 'image_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.file',
	                                            defaultMessage: 'File Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('log_settings'),
	                                            onClick: this.handleClick.bind(this, 'log_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.log',
	                                            defaultMessage: 'Log Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('rate_settings'),
	                                            onClick: this.handleClick.bind(this, 'rate_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.rate_limit',
	                                            defaultMessage: 'Rate Limit Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('privacy_settings'),
	                                            onClick: this.handleClick.bind(this, 'privacy_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.privacy',
	                                            defaultMessage: 'Privacy Settings'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('gitlab_settings'),
	                                            onClick: this.handleClick.bind(this, 'gitlab_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.gitlab',
	                                            defaultMessage: 'GitLab Settings'
	                                        })
	                                    )
	                                ),
	                                ldapSettings,
	                                complianceSettings,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('legal_and_support_settings'),
	                                            onClick: this.handleClick.bind(this, 'legal_and_support_settings', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.support',
	                                            defaultMessage: 'Legal and Support Settings'
	                                        })
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'h4',
	                                        null,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', { className: 'icon fa fa-gear' }),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'span',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                                id: 'admin.sidebar.teams',
	                                                defaultMessage: 'TEAMS ({count})',
	                                                values: {
	                                                    count: count
	                                                }
	                                            })
	                                        ),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'span',
	                                            { className: 'menu-icon--right' },
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["OverlayTrigger"],
	                                                {
	                                                    delayShow: 1000,
	                                                    placement: 'top',
	                                                    overlay: addTeamTooltip
	                                                },
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                                    'a',
	                                                    {
	                                                        href: '#',
	                                                        onClick: this.showTeamSelect
	                                                    },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('i', {
	                                                        className: 'fa fa-plus'
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu padded' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    teams
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'h4',
	                                        null,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', { className: 'icon fa fa-gear' }),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                            'span',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                                id: 'admin.sidebar.other',
	                                                defaultMessage: 'OTHER'
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'ul',
	                                { className: 'nav nav__sub-menu padded' },
	                                licenseSettings,
	                                audits,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: this.isSelected('logs'),
	                                            onClick: this.handleClick.bind(this, 'logs', null)
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                            id: 'admin.sidebar.logs',
	                                            defaultMessage: 'Logs'
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__select_team_modal_jsx__["a"], {
	                    teams: this.props.teams,
	                    show: this.state.showSelectModal,
	                    onModalSubmit: this.teamSelectedModal,
	                    onModalDismissed: this.teamSelectedModalDismissed
	                })
	            );
	        }
	    }]);
	
	    return AdminSidebar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AdminSidebar;
	
	
	AdminSidebar.propTypes = {
	    teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object,
	    selectedTeams: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object,
	    removeSelectedTeam: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func,
	    addSelectedTeam: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func,
	    selected: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    selectedTeam: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    selectTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin_navbar_dropdown_jsx__ = __webpack_require__(640);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var SidebarHeader = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SidebarHeader, _React$Component);
	
	    function SidebarHeader(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SidebarHeader);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SidebarHeader).call(this, props));
	
	        _this.toggleDropdown = _this.toggleDropdown.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SidebarHeader, [{
	        key: 'toggleDropdown',
	        value: function toggleDropdown(e) {
	            e.preventDefault();
	
	            if (this.refs.dropdown.blockToggle) {
	                this.refs.dropdown.blockToggle = false;
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.team__header').find('.dropdown-toggle').dropdown('toggle');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser();
	            var profilePicture = null;
	
	            if (!me) {
	                return null;
	            }
	
	            if (me.last_picture_update) {
	                profilePicture = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
	                    className: 'user__picture',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].getUsersRoute() + '/' + me.id + '/image?time=' + me.update_at
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'team__header theme' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        onClick: this.toggleDropdown
	                    },
	                    profilePicture,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'header__info' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'user__name' },
	                            '@' + me.username
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'team__name' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.sidebarHeader.systemConsole',
	                                defaultMessage: 'System Console'
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__admin_navbar_dropdown_jsx__["a"], { ref: 'dropdown' })
	            );
	        }
	    }]);
	
	    return SidebarHeader;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SidebarHeader;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audit_table_jsx__ = __webpack_require__(351);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__compliance_reports_jsx__ = __webpack_require__(645);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__ = __webpack_require__(191);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Audits = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Audits, _React$Component);
	
	    function Audits(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Audits);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Audits).call(this, props));
	
	        _this.onAuditListenerChange = _this.onAuditListenerChange.bind(_this);
	        _this.reload = _this.reload.bind(_this);
	
	        _this.state = {
	            audits: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAudits()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Audits, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].addAuditChangeListener(this.onAuditListenerChange);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.getServerAudits();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].removeAuditChangeListener(this.onAuditListenerChange);
	        }
	    }, {
	        key: 'onAuditListenerChange',
	        value: function onAuditListenerChange() {
	            this.setState({
	                audits: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].getAudits()
	            });
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_admin_store_jsx__["a"].saveAudits(null);
	            this.setState({
	                audits: null
	            });
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.getServerAudits();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = null;
	
	            if (global.window.mm_license.IsLicensed !== 'true') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', null);
	            }
	
	            if (this.state.audits === null) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__loading_screen_jsx__["a"], null);
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { style: { margin: '10px' } },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__audit_table_jsx__["a"], {
	                        audits: this.state.audits,
	                        showUserId: true,
	                        showIp: true,
	                        showSession: true
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__compliance_reports_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'panel audit-panel' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'h3',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.audits.title',
	                            defaultMessage: 'User Activity Logs'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'submit',
	                                className: 'btn btn-link pull-right',
	                                onClick: this.reload
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i', { className: 'fa fa-refresh' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.audits.reload',
	                                defaultMessage: 'Reload User Activity Logs'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'audit-panel__table' },
	                        content
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Audits;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Audits;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setting_jsx__ = __webpack_require__(347);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var BooleanSetting = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(BooleanSetting, _React$Component);
	
	    function BooleanSetting() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BooleanSetting);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(BooleanSetting).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BooleanSetting, [{
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6__setting_jsx__["a"],
	                { label: this.props.label },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'label',
	                    { className: 'radio-inline' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                        type: 'radio',
	                        value: 'true',
	                        checked: this.props.currentValue,
	                        onChange: this.props.handleChange,
	                        disabled: this.props.isDisabled
	                    }),
	                    this.props.trueText
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'label',
	                    { className: 'radio-inline' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                        type: 'radio',
	                        value: 'false',
	                        checked: !this.props.currentValue,
	                        onChange: this.props.handleChange,
	                        disabled: this.props.isDisabled
	                    }),
	                    this.props.falseText
	                ),
	                this.props.helpText
	            );
	        }
	    }]);
	
	    return BooleanSetting;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = BooleanSetting;
	
	BooleanSetting.defaultProps = {
	    trueText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	        id: 'admin.ldap.true',
	        defaultMessage: 'true'
	    }),
	    falseText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	        id: 'admin.ldap.false',
	        defaultMessage: 'false'
	    })
	};
	
	BooleanSetting.propTypes = {
	    label: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	    currentValue: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool.isRequired,
	    trueText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node,
	    falseText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node,
	    isDisabled: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool.isRequired,
	    handleChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
	    helpText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired
	};

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stores_admin_store_jsx__ = __webpack_require__(191);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __WEBPACK_IMPORTED_MODULE_14_react_dom__ && __WEBPACK_IMPORTED_MODULE_14_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_dom___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ComplianceReports = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ComplianceReports, _React$Component);
	
	    function ComplianceReports(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ComplianceReports);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ComplianceReports).call(this, props));
	
	        _this.onComplianceReportsListenerChange = _this.onComplianceReportsListenerChange.bind(_this);
	        _this.reload = _this.reload.bind(_this);
	        _this.runReport = _this.runReport.bind(_this);
	        _this.getDateTime = _this.getDateTime.bind(_this);
	
	        _this.state = {
	            reports: /* harmony import */__WEBPACK_IMPORTED_MODULE_8__stores_admin_store_jsx__["a"].getComplianceReports(),
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ComplianceReports, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8__stores_admin_store_jsx__["a"].addComplianceReportsChangeListener(this.onComplianceReportsListenerChange);
	
	            if (global.window.mm_license.IsLicensed !== 'true' || global.window.mm_config.EnableCompliance !== 'true') {
	                return;
	            }
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_async_client_jsx__.getComplianceReports();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8__stores_admin_store_jsx__["a"].removeComplianceReportsChangeListener(this.onComplianceReportsListenerChange);
	        }
	    }, {
	        key: 'onComplianceReportsListenerChange',
	        value: function onComplianceReportsListenerChange() {
	            this.setState({
	                reports: /* harmony import */__WEBPACK_IMPORTED_MODULE_8__stores_admin_store_jsx__["a"].getComplianceReports()
	            });
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8__stores_admin_store_jsx__["a"].saveComplianceReports(null);
	            this.setState({
	                reports: null,
	                serverError: null
	            });
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11__utils_async_client_jsx__.getComplianceReports();
	        }
	    }, {
	        key: 'runReport',
	        value: function runReport(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#run-button').button('loading');
	
	            var job = {};
	            job.desc = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(this.refs.desc).value;
	            job.emails = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(this.refs.emails).value;
	            job.keywords = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(this.refs.keywords).value;
	            job.start_at = Date.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(this.refs.from).value);
	            job.end_at = Date.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(this.refs.to).value);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].saveComplianceReports(job, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(_this2.refs.emails).value = '';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(_this2.refs.keywords).value = '';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(_this2.refs.desc).value = '';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(_this2.refs.from).value = '';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_dom___default.a.findDOMNode(_this2.refs.to).value = '';
	                _this2.reload();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#run-button').button('reset');
	            }, function (err) {
	                _this2.setState({ serverError: err.message });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#run-button').button('reset');
	            });
	        }
	    }, {
	        key: 'getDateTime',
	        value: function getDateTime(millis) {
	            var date = new Date(millis);
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'span',
	                { style: { whiteSpace: 'nowrap' } },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedDate"], {
	                    value: date,
	                    day: '2-digit',
	                    month: 'short',
	                    year: 'numeric'
	                }),
	                ' - ',
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedTime"], {
	                    value: date,
	                    hour: '2-digit',
	                    minute: '2-digit'
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = null;
	
	            if (global.window.mm_license.IsLicensed !== 'true' || global.window.mm_config.EnableCompliance !== 'true') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', null);
	            }
	
	            if (this.state.reports === null) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__["a"], null);
	            } else {
	                var list = [];
	
	                for (var i = 0; i < this.state.reports.length; i++) {
	                    var report = this.state.reports[i];
	
	                    var params = '';
	                    if (report.type === 'adhoc') {
	                        params = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'span',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.from',
	                                defaultMessage: 'From:'
	                            }),
	                            ' ',
	                            this.getDateTime(report.start_at),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('br', null),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.to',
	                                defaultMessage: 'To:'
	                            }),
	                            ' ',
	                            this.getDateTime(report.end_at),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('br', null),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.emails',
	                                defaultMessage: 'Emails:'
	                            }),
	                            ' ',
	                            report.emails,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('br', null),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.keywords',
	                                defaultMessage: 'Keywords:'
	                            }),
	                            ' ',
	                            report.keywords
	                        );
	                    }
	
	                    var download = '';
	                    if (report.status === 'finished') {
	                        download = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'a',
	                            { href: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].getAdminRoute() + '/download_compliance_report/' + report.id },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_table.download',
	                                defaultMessage: 'Download'
	                            })
	                        );
	                    }
	
	                    var status = report.status;
	                    if (report.status === 'finished') {
	                        status = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'span',
	                            { style: { color: 'green' } },
	                            report.status
	                        );
	                    }
	
	                    if (report.status === 'failed') {
	                        status = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'span',
	                            { style: { color: 'red' } },
	                            report.status
	                        );
	                    }
	
	                    var user = report.user_id;
	                    var profile = /* harmony import */__WEBPACK_IMPORTED_MODULE_9__stores_user_store_jsx__["a"].getProfile(report.user_id);
	                    if (profile) {
	                        user = profile.email;
	                    }
	
	                    list[i] = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'tr',
	                        { key: report.id },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            { style: { whiteSpace: 'nowrap' } },
	                            download
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            null,
	                            this.getDateTime(report.create_at)
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            null,
	                            status
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            null,
	                            report.count
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            null,
	                            report.type
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            { style: { whiteSpace: 'nowrap' } },
	                            report.desc
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            null,
	                            user
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'td',
	                            { style: { whiteSpace: 'nowrap' } },
	                            params
	                        )
	                    );
	                }
	
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { style: { margin: '10px' } },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'table',
	                        { className: 'table' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'thead',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'tr',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('th', null),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.timestamp',
	                                        defaultMessage: 'Timestamp'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.status',
	                                        defaultMessage: 'Status'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.records',
	                                        defaultMessage: 'Records'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.type',
	                                        defaultMessage: 'Type'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.desc',
	                                        defaultMessage: 'Description'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.userId',
	                                        defaultMessage: 'Requested By'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'th',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'admin.compliance_table.params',
	                                        defaultMessage: 'Params'
	                                    })
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'tbody',
	                            null,
	                            list
	                        )
	                    )
	                );
	            }
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'form-group has-error',
	                        style: { marginTop: '10px' }
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { className: 'panel compliance-panel' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'admin.compliance_reports.title',
	                        defaultMessage: 'Compliance Reports'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-6 col-md-4 form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.desc',
	                                defaultMessage: 'Job Name:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            id: 'desc',
	                            ref: 'desc',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__utils_utils_jsx__.localizeMessage('admin.compliance_reports.desc_placeholder', 'E.g. "Audit 445 for HR"')
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-3 col-md-2 form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.from',
	                                defaultMessage: 'From:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            id: 'from',
	                            ref: 'from',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__utils_utils_jsx__.localizeMessage('admin.compliance_reports.from_placeholder', 'E.g. "2016-03-11"')
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-3 col-md-2 form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.to',
	                                defaultMessage: 'To:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            id: 'to',
	                            ref: 'to',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__utils_utils_jsx__.localizeMessage('admin.compliance_reports.to_placeholder', 'E.g. "2016-03-15"')
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-6 col-md-4 form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.emails',
	                                defaultMessage: 'Emails:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            id: 'emails',
	                            ref: 'emails',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__utils_utils_jsx__.localizeMessage('admin.compliance_reports.emails_placeholder', 'E.g. "bill@example.com, bob@example.com"')
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-6 col-md-4 form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance_reports.keywords',
	                                defaultMessage: 'Keywords:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            id: 'keywords',
	                            ref: 'keywords',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__utils_utils_jsx__.localizeMessage('admin.compliance_reports.keywords_placeholder', 'E.g. "shorting stock"')
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'clearfix' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'button',
	                        {
	                            id: 'run-button',
	                            type: 'submit',
	                            className: 'btn btn-primary',
	                            onClick: this.runReport
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'admin.compliance_reports.run',
	                            defaultMessage: 'Run Compliance Report'
	                        })
	                    )
	                ),
	                serverError,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'text-right' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-link',
	                            onClick: this.reload
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('i', { className: 'fa fa-refresh' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'admin.compliance_reports.reload',
	                            defaultMessage: 'Reload Completed Compliance Reports'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'compliance-panel__table' },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return ComplianceReports;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ComplianceReports;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __WEBPACK_IMPORTED_MODULE_11_react_dom__ && __WEBPACK_IMPORTED_MODULE_11_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_dom___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var ComplianceSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ComplianceSettings, _React$Component);
	
	    function ComplianceSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ComplianceSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ComplianceSettings).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleEnable = _this.handleEnable.bind(_this);
	        _this.handleDisable = _this.handleDisable.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null,
	            enable: _this.props.config.ComplianceSettings.Enable
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ComplianceSettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            this.setState({ saveNeeded: true });
	        }
	    }, {
	        key: 'handleEnable',
	        value: function handleEnable() {
	            this.setState({ saveNeeded: true, enable: true });
	        }
	    }, {
	        key: 'handleDisable',
	        value: function handleDisable() {
	            this.setState({ saveNeeded: true, enable: false });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            var oldEnable = config.ComplianceSettings.Enable;
	            config.ComplianceSettings.Enable = this.refs.Enable.checked;
	            config.ComplianceSettings.Directory = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.refs.Directory).value;
	            config.ComplianceSettings.EnableDaily = this.refs.EnableDaily.checked;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                if (oldEnable !== config.ComplianceSettings.Enable) {
	                    window.location.reload();
	                }
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var licenseEnabled = global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.Compliance === 'true';
	
	            var bannerContent = void 0;
	            if (!licenseEnabled) {
	                bannerContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'banner warning' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'banner__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                            id: 'admin.compliance.noLicense',
	                            defaultMessage: '<h4 class="banner__heading">Note:</h4><p>Compliance is an enterprise feature. Your current license does not support Compliance. Click <a href="http://mattermost.com"target="_blank">here</a> for information and pricing on enterprise licenses.</p>'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                bannerContent,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.compliance.title',
	                        defaultMessage: 'Compliance Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Enable'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance.enableTitle',
	                                defaultMessage: 'Enable Compliance:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Enable',
	                                    value: 'true',
	                                    ref: 'Enable',
	                                    defaultChecked: this.props.config.ComplianceSettings.Enable,
	                                    onChange: this.handleEnable,
	                                    disabled: !licenseEnabled
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Enable',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ComplianceSettings.Enable,
	                                    onChange: this.handleDisable
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.enableDesc',
	                                    defaultMessage: 'When true, Mattermost allows compliance reporting'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Directory'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance.directoryTitle',
	                                defaultMessage: 'Compliance Directory Location:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'Directory',
	                                ref: 'Directory',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8__utils_utils_jsx__.localizeMessage('admin.compliance.directoryExample', 'Ex "./data/"'),
	                                defaultValue: this.props.config.ComplianceSettings.Directory,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.directoryDescription',
	                                    defaultMessage: 'Directory to which compliance reports are written. If blank, will be set to ./data/.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableDaily'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.compliance.enableDailyTitle',
	                                defaultMessage: 'Enable Daily Report:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableDaily',
	                                    value: 'true',
	                                    ref: 'EnableDaily',
	                                    defaultChecked: this.props.config.ComplianceSettings.EnableDaily,
	                                    onChange: this.handleChange,
	                                    disabled: !this.state.enable
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableDaily',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ComplianceSettings.EnableDaily,
	                                    disabled: !this.state.enable
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.enableDailyDesc',
	                                    defaultMessage: 'When true, Mattermost will generate a daily compliance report.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8__utils_utils_jsx__.localizeMessage('admin.compliance.saving', 'Saving Config...')
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.compliance.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ComplianceSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ComplianceSettings;
	
	
	ComplianceSettings.propTypes = {
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_jsx__ = __webpack_require__(347);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var DropdownSetting = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(DropdownSetting, _React$Component);
	
	    function DropdownSetting() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DropdownSetting);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(DropdownSetting).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(DropdownSetting, [{
	        key: 'render',
	        value: function render() {
	            var options = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(this.props.values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = _step.value;
	                    var value = _step$value.value;
	                    var text = _step$value.text;
	
	                    options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'option',
	                        {
	                            value: value,
	                            key: value
	                        },
	                        text
	                    ));
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_jsx__["a"],
	                {
	                    label: this.props.label,
	                    margin: this.props.margin
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'select',
	                    {
	                        className: 'form-control',
	                        value: this.props.currentValue,
	                        onChange: this.props.handleChange,
	                        disabled: this.props.isDisabled
	                    },
	                    options
	                ),
	                this.props.helpText
	            );
	        }
	    }]);
	
	    return DropdownSetting;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = DropdownSetting;
	
	DropdownSetting.defaultProps = {};
	
	DropdownSetting.propTypes = {
	    values: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.array.isRequired,
	    label: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node.isRequired,
	    currentValue: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
	    handleChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
	    isDisabled: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool.isRequired,
	    helpText: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.node.isRequired,
	    margin: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.oneOf(['', 'small'])
	};

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_crypto__ = __webpack_require__(215);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_crypto___default = __WEBPACK_IMPORTED_MODULE_9_crypto__ && __WEBPACK_IMPORTED_MODULE_9_crypto__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_crypto__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_crypto__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_crypto___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_crypto___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__connection_security_dropdown_setting_jsx__ = __webpack_require__(345);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["defineMessages"].bind()({
	    notificationDisplayExample: {
	        id: 'admin.email.notificationDisplayExample',
	        defaultMessage: 'Ex: "Mattermost Notification", "System", "No-Reply"'
	    },
	    notificationEmailExample: {
	        id: 'admin.email.notificationEmailExample',
	        defaultMessage: 'Ex: "mattermost@yourcompany.com", "admin@yourcompany.com"'
	    },
	    smtpUsernameExample: {
	        id: 'admin.email.smtpUsernameExample',
	        defaultMessage: 'Ex: "admin@yourcompany.com", "AKIADTOVBGERKLCBV"'
	    },
	    smtpPasswordExample: {
	        id: 'admin.email.smtpPasswordExample',
	        defaultMessage: 'Ex: "yourpassword", "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'
	    },
	    smtpServerExample: {
	        id: 'admin.email.smtpServerExample',
	        defaultMessage: 'Ex: "smtp.yourcompany.com", "email-smtp.us-east-1.amazonaws.com"'
	    },
	    smtpPortExample: {
	        id: 'admin.email.smtpPortExample',
	        defaultMessage: 'Ex: "25", "465"'
	    },
	    inviteSaltExample: {
	        id: 'admin.email.inviteSaltExample',
	        defaultMessage: 'Ex "bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo"'
	    },
	    passwordSaltExample: {
	        id: 'admin.email.passwordSaltExample',
	        defaultMessage: 'Ex "bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo"'
	    },
	    testing: {
	        id: 'admin.email.testing',
	        defaultMessage: 'Testing...'
	    },
	    saving: {
	        id: 'admin.email.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var EmailSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(EmailSettings, _React$Component);
	
	    function EmailSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EmailSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EmailSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleTestConnection = _this.handleTestConnection.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.buildConfig = _this.buildConfig.bind(_this);
	        _this.handleGenerateInvite = _this.handleGenerateInvite.bind(_this);
	        _this.handleGenerateReset = _this.handleGenerateReset.bind(_this);
	        _this.handleSendPushNotificationsChange = _this.handleSendPushNotificationsChange.bind(_this);
	        _this.handlePushServerChange = _this.handlePushServerChange.bind(_this);
	        _this.handleAgreeChange = _this.handleAgreeChange.bind(_this);
	
	        var sendNotificationValue = void 0;
	        var agree = false;
	        if (!props.config.EmailSettings.SendPushNotifications) {
	            sendNotificationValue = 'off';
	        } else if (props.config.EmailSettings.PushNotificationServer === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MHPNS && global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.MHPNS === 'true') {
	            sendNotificationValue = 'mhpns';
	            agree = true;
	        } else if (props.config.EmailSettings.PushNotificationServer === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MTPNS) {
	            sendNotificationValue = 'mtpns';
	        } else {
	            sendNotificationValue = 'self';
	        }
	
	        var pushNotificationServer = _this.props.config.EmailSettings.PushNotificationServer;
	        if (sendNotificationValue === 'mtpns') {
	            pushNotificationServer = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MTPNS;
	        } else if (sendNotificationValue === 'mhpns') {
	            pushNotificationServer = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MHPNS;
	        }
	
	        _this.state = {
	            sendEmailNotifications: _this.props.config.EmailSettings.SendEmailNotifications,
	            sendPushNotifications: _this.props.config.EmailSettings.SendPushNotifications,
	            saveNeeded: false,
	            serverError: null,
	            emailSuccess: null,
	            emailFail: null,
	            pushNotificationContents: _this.props.config.EmailSettings.PushNotificationContents,
	            connectionSecurity: _this.props.config.EmailSettings.ConnectionSecurity,
	            sendNotificationValue: sendNotificationValue,
	            pushNotificationServer: pushNotificationServer,
	            agree: agree
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(EmailSettings, [{
	        key: 'handleChange',
	        value: function handleChange(action) {
	            var s = { saveNeeded: true };
	
	            if (action === 'sendEmailNotifications_true') {
	                s.sendEmailNotifications = true;
	            }
	
	            if (action === 'sendEmailNotifications_false') {
	                s.sendEmailNotifications = false;
	            }
	
	            if (action === 'sendPushNotifications_true') {
	                s.sendPushNotifications = true;
	            }
	
	            if (action === 'sendPushNotifications_false') {
	                s.sendPushNotifications = false;
	            }
	
	            this.setState(s);
	        }
	    }, {
	        key: 'buildConfig',
	        value: function buildConfig() {
	            var config = this.props.config;
	            config.EmailSettings.EnableSignUpWithEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.allowSignUpWithEmail).checked;
	            config.EmailSettings.EnableSignInWithEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.allowSignInWithEmail).checked;
	            config.EmailSettings.EnableSignInWithUsername = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.allowSignInWithUsername).checked;
	            config.EmailSettings.SendEmailNotifications = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.sendEmailNotifications).checked;
	            config.EmailSettings.RequireEmailVerification = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.requireEmailVerification).checked;
	            config.EmailSettings.FeedbackName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.feedbackName).value.trim();
	            config.EmailSettings.FeedbackEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.feedbackEmail).value.trim();
	            config.EmailSettings.SMTPServer = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SMTPServer).value.trim();
	            config.EmailSettings.SMTPPort = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SMTPPort).value.trim();
	            config.EmailSettings.SMTPUsername = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SMTPUsername).value.trim();
	            config.EmailSettings.SMTPPassword = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SMTPPassword).value.trim();
	            config.EmailSettings.ConnectionSecurity = this.state.connectionSecurity.trim();
	
	            config.EmailSettings.InviteSalt = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.InviteSalt).value.trim();
	            if (config.EmailSettings.InviteSalt === '') {
	                config.EmailSettings.InviteSalt = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.InviteSalt).value = config.EmailSettings.InviteSalt;
	            }
	
	            config.EmailSettings.PasswordResetSalt = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PasswordResetSalt).value.trim();
	            if (config.EmailSettings.PasswordResetSalt === '') {
	                config.EmailSettings.PasswordResetSalt = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PasswordResetSalt).value = config.EmailSettings.PasswordResetSalt;
	            }
	
	            var sendPushNotifications = this.refs.sendPushNotifications.value;
	            if (sendPushNotifications === 'off') {
	                config.EmailSettings.SendPushNotifications = false;
	            } else {
	                config.EmailSettings.SendPushNotifications = true;
	            }
	
	            if (this.refs.PushNotificationServer) {
	                config.EmailSettings.PushNotificationServer = this.refs.PushNotificationServer.value.trim();
	            }
	
	            if (this.refs.PushNotificationContents) {
	                config.EmailSettings.PushNotificationContents = this.refs.PushNotificationContents.value;
	            }
	
	            return config;
	        }
	    }, {
	        key: 'handleSendPushNotificationsChange',
	        value: function handleSendPushNotificationsChange(e) {
	            var sendNotificationValue = e.target.value;
	            var pushNotificationServer = this.state.pushNotificationServer;
	            if (sendNotificationValue === 'mtpns') {
	                pushNotificationServer = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MTPNS;
	            } else if (sendNotificationValue === 'mhpns') {
	                pushNotificationServer = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MHPNS;
	            }
	            this.setState({ saveNeeded: true, sendNotificationValue: sendNotificationValue, pushNotificationServer: pushNotificationServer, agree: false });
	        }
	    }, {
	        key: 'handlePushServerChange',
	        value: function handlePushServerChange(e) {
	            this.setState({ saveNeeded: true, pushNotificationServer: e.target.value });
	        }
	    }, {
	        key: 'handleAgreeChange',
	        value: function handleAgreeChange(e) {
	            this.setState({ agree: e.target.checked });
	        }
	    }, {
	        key: 'handleGenerateInvite',
	        value: function handleGenerateInvite(e) {
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.InviteSalt).value = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'handleGenerateReset',
	        value: function handleGenerateReset(e) {
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PasswordResetSalt).value = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'handleTestConnection',
	        value: function handleTestConnection(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#connection-button').button('loading');
	
	            var config = this.buildConfig();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].testEmail(config, function () {
	                _this2.setState({
	                    sendEmailNotifications: config.EmailSettings.SendEmailNotifications,
	                    serverError: null,
	                    saveNeeded: true,
	                    emailSuccess: true,
	                    emailFail: null
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#connection-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    sendEmailNotifications: config.EmailSettings.SendEmailNotifications,
	                    serverError: null,
	                    saveNeeded: true,
	                    emailSuccess: null,
	                    emailFail: err.message + ' - ' + err.detailed_error
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#connection-button').button('reset');
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.buildConfig();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this3.setState({
	                    sendEmailNotifications: config.EmailSettings.SendEmailNotifications,
	                    serverError: null,
	                    saveNeeded: false,
	                    emailSuccess: null,
	                    emailFail: null
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this3.setState({
	                    sendEmailNotifications: config.EmailSettings.SendEmailNotifications,
	                    serverError: err.message,
	                    saveNeeded: true,
	                    emailSuccess: null,
	                    emailFail: null
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var emailSuccess = '';
	            if (this.state.emailSuccess) {
	                emailSuccess = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'alert alert-success' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'admin.email.emailSuccess',
	                        defaultMessage: 'No errors were reported while sending an email.  Please check your inbox to make sure.'
	                    })
	                );
	            }
	
	            var emailFail = '';
	            if (this.state.emailFail) {
	                emailSuccess = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'alert alert-warning' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('i', { className: 'fa fa-warning' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'admin.email.emailFail',
	                        defaultMessage: 'Connection unsuccessful: {error}',
	                        values: {
	                            error: this.state.emailFail
	                        }
	                    })
	                );
	            }
	
	            var mhpnsOption = void 0;
	            if (global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.MHPNS === 'true') {
	                mhpnsOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'option',
	                    { value: 'mhpns' },
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.mhpns', 'Use encrypted, production-quality HPNS connection to iOS and Android apps')
	                );
	            }
	
	            var disableSave = !this.state.saveNeeded;
	
	            var tosCheckbox = void 0;
	            if (this.state.sendNotificationValue === 'mhpns') {
	                tosCheckbox = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4'
	                        },
	                        ''
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                            type: 'checkbox',
	                            ref: 'agree',
	                            checked: this.state.agree,
	                            onChange: this.handleAgreeChange
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                            id: 'admin.email.agreeHPNS',
	                            defaultMessage: ' I understand and accept the Mattermost Hosted Push Notification Service <a href="https://about.mattermost.com/hpns-terms/" target="_blank">Terms of Service</a> and <a href="https://about.mattermost.com/hpns-privacy/" target="_blank">Privacy Policy</a>.'
	                        })
	                    )
	                );
	
	                disableSave = disableSave || !this.state.agree;
	            }
	
	            var sendHelpText = void 0;
	            var pushServerHelpText = void 0;
	            if (this.state.sendNotificationValue === 'off') {
	                sendHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                    id: 'admin.email.pushOffHelp',
	                    defaultMessage: 'Please see <a href="http://docs.mattermost.com/deployment/push.html#push-notifications-and-mobile-devices" target="_blank">documentation on push notifications</a> to learn more about setup options.'
	                });
	            } else if (this.state.sendNotificationValue === 'mhpns') {
	                pushServerHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                    id: 'admin.email.mhpnsHelp',
	                    defaultMessage: 'Download <a href="https://itunes.apple.com/us/app/mattermost/id984966508?mt=8" target="_blank">Mattermost iOS app</a> from iTunes. Download <a href="https://play.google.com/store/apps/details?id=com.mattermost.mattermost&hl=en" target="_blank">Mattermost Android app</a> from Google Play. Learn more about the <a href="http://docs.mattermost.com/deployment/push.html#hosted-push-notifications-service-hpns" target="_blank">Mattermost Hosted Push Notification Service</a>.'
	                });
	            } else if (this.state.sendNotificationValue === 'mtpns') {
	                pushServerHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                    id: 'admin.email.mtpnsHelp',
	                    defaultMessage: 'Download <a href="https://itunes.apple.com/us/app/mattermost/id984966508?mt=8" target="_blank">Mattermost iOS app</a> from iTunes. Download <a href="https://play.google.com/store/apps/details?id=com.mattermost.mattermost&hl=en" target="_blank">Mattermost Android app</a> from Google Play. Learn more about the <a href="http://docs.mattermost.com/deployment/push.html#test-push-notifications-service-tpns" target="_blank">Mattermost Test Push Notification Service</a>.'
	                });
	            } else {
	                pushServerHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                    id: 'admin.email.easHelp',
	                    defaultMessage: 'Learn more about compiling and deploying your own mobile apps from an <a href="http://docs.mattermost.com/deployment/push.html#enterprise-app-store-eas" target="_blank">Enterprise App Store</a>.'
	                });
	            }
	
	            var sendPushNotifications = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                { className: 'form-group' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'label',
	                    {
	                        className: 'control-label col-sm-4',
	                        htmlFor: 'sendPushNotifications'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'admin.email.pushTitle',
	                        defaultMessage: 'Send Push Notifications: '
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-8' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'select',
	                        {
	                            className: 'form-control',
	                            id: 'sendPushNotifications',
	                            ref: 'sendPushNotifications',
	                            value: this.state.sendNotificationValue,
	                            onChange: this.handleSendPushNotificationsChange
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'option',
	                            { value: 'off' },
	                            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.pushOff', 'Do not send push notifications')
	                        ),
	                        mhpnsOption,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'option',
	                            { value: 'mtpns' },
	                            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.mtpns', 'Use iOS and Android apps on iTunes and Google Play with TPNS')
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'option',
	                            { value: 'self' },
	                            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.selfPush', 'Manually enter Push Notification Service location')
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'p',
	                        { className: 'help-text' },
	                        sendHelpText
	                    )
	                )
	            );
	
	            var pushNotificationServer = void 0;
	            var pushNotificationContent = void 0;
	            if (this.state.sendNotificationValue !== 'off') {
	                pushNotificationServer = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'PushNotificationServer'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'admin.email.pushServerTitle',
	                            defaultMessage: 'Push Notification Server:'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            id: 'PushNotificationServer',
	                            ref: 'PushNotificationServer',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.pushServerEx', 'E.g.: "http://push-test.mattermost.com"'),
	                            value: this.state.pushNotificationServer,
	                            onChange: this.handlePushServerChange,
	                            disabled: this.state.sendNotificationValue !== 'self'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text' },
	                            pushServerHelpText
	                        )
	                    )
	                );
	
	                pushNotificationContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'pushNotificationContents'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'admin.email.pushContentTitle',
	                            defaultMessage: 'Push Notification Contents:'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'select',
	                            {
	                                className: 'form-control',
	                                id: 'pushNotificationContents',
	                                ref: 'PushNotificationContents',
	                                defaultValue: this.props.config.EmailSettings.PushNotificationContents,
	                                onChange: this.handleChange.bind(this, 'pushNotificationContents')
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'option',
	                                { value: 'generic' },
	                                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.genericPushNotification', 'Send generic description with user and channel names')
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'option',
	                                { value: 'full' },
	                                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('admin.email.fullPushNotification', 'Send full message snippet')
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                                id: 'admin.email.pushContentDesc',
	                                defaultMessage: 'Selecting "Send generic description with user and channel names" provides push notifications with generic messages, including names of users and channels but no specific details from the message text.<br /><br /> Selecting "Send full message snippet" sends excerpts from messages triggering notifications with specifics and may include confidential information sent in messages. If your Push Notification Service is outside your firewall, it is HIGHLY RECOMMENDED this option only be used with an "https" protocol to encrypt the connection.'
	                            })
	                        )
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'admin.email.emailSettings',
	                        defaultMessage: 'Email Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'allowSignUpWithEmail'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.allowSignupTitle',
	                                defaultMessage: 'Allow Sign Up With Email: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'allowSignUpWithEmail',
	                                    value: 'true',
	                                    ref: 'allowSignUpWithEmail',
	                                    defaultChecked: this.props.config.EmailSettings.EnableSignUpWithEmail,
	                                    onChange: this.handleChange.bind(this, 'allowSignUpWithEmail_true')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'allowSignUpWithEmail',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.EmailSettings.EnableSignUpWithEmail,
	                                    onChange: this.handleChange.bind(this, 'allowSignUpWithEmail_false')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.allowSignupDescription',
	                                    defaultMessage: 'When true, Mattermost allows team creation and account signup using email and password.  This value should be false only when you want to limit signup to a single-sign-on service like OAuth or LDAP.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'allowSignInWithEmail'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.allowEmailSignInTitle',
	                                defaultMessage: 'Allow Sign In With Email: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'allowSignInWithEmail',
	                                    value: 'true',
	                                    ref: 'allowSignInWithEmail',
	                                    defaultChecked: this.props.config.EmailSettings.EnableSignInWithEmail,
	                                    onChange: this.handleChange.bind(this, 'allowSignInWithEmail_true')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'allowSignInWithEmail',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.EmailSettings.EnableSignInWithEmail,
	                                    onChange: this.handleChange.bind(this, 'allowSignInWithEmail_false')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.allowEmailSignInDescription',
	                                    defaultMessage: 'When true, Mattermost allows users to sign in using their email and password.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'allowSignInWithUsername'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.allowUsernameSignInTitle',
	                                defaultMessage: 'Allow Sign In With Username: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'allowSignInWithUsername',
	                                    value: 'true',
	                                    ref: 'allowSignInWithUsername',
	                                    defaultChecked: this.props.config.EmailSettings.EnableSignInWithUsername,
	                                    onChange: this.handleChange.bind(this, 'allowSignInWithUsername_true')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'allowSignInWithUsername',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.EmailSettings.EnableSignInWithUsername,
	                                    onChange: this.handleChange.bind(this, 'allowSignInWithUsername_false')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.allowUsernameSignInDescription',
	                                    defaultMessage: 'When true, Mattermost allows users to sign in using their username and password.  This setting is typically only used when email verification is disabled.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'sendEmailNotifications'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.notificationsTitle',
	                                defaultMessage: 'Send Email Notifications: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'sendEmailNotifications',
	                                    value: 'true',
	                                    ref: 'sendEmailNotifications',
	                                    defaultChecked: this.props.config.EmailSettings.SendEmailNotifications,
	                                    onChange: this.handleChange.bind(this, 'sendEmailNotifications_true')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'sendEmailNotifications',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.EmailSettings.SendEmailNotifications,
	                                    onChange: this.handleChange.bind(this, 'sendEmailNotifications_false')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedHTMLMessage"], {
	                                    id: 'admin.email.notificationsDescription',
	                                    defaultMessage: 'Typically set to true in production. When true, Mattermost attempts to send email notifications. Developers may set this field to false to skip email setup for faster development.<br />Setting this to true removes the Preview Mode banner (requires logging out and logging back in after setting is changed).'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'requireEmailVerification'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.requireVerificationTitle',
	                                defaultMessage: 'Require Email Verification: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'requireEmailVerification',
	                                    value: 'true',
	                                    ref: 'requireEmailVerification',
	                                    defaultChecked: this.props.config.EmailSettings.RequireEmailVerification,
	                                    onChange: this.handleChange.bind(this, 'requireEmailVerification_true'),
	                                    disabled: !this.state.sendEmailNotifications
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'requireEmailVerification',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.EmailSettings.RequireEmailVerification,
	                                    onChange: this.handleChange.bind(this, 'requireEmailVerification_false'),
	                                    disabled: !this.state.sendEmailNotifications
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.requireVerificationDescription',
	                                    defaultMessage: 'Typically set to true in production. When true, Mattermost requires email verification after account creation prior to allowing login. Developers may set this field to false so skip sending verification emails for faster development.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'feedbackName'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.notificationDisplayTitle',
	                                defaultMessage: 'Notification Display Name:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'feedbackName',
	                                ref: 'feedbackName',
	                                placeholder: formatMessage(holders.notificationDisplayExample),
	                                defaultValue: this.props.config.EmailSettings.FeedbackName,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.notificationDisplayDescription',
	                                    defaultMessage: 'Display name on email account used when sending notification emails from Mattermost.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'feedbackEmail'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.notificationEmailTitle',
	                                defaultMessage: 'Notification Email Address:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'email',
	                                className: 'form-control',
	                                id: 'feedbackEmail',
	                                ref: 'feedbackEmail',
	                                placeholder: formatMessage(holders.notificationEmailExample),
	                                defaultValue: this.props.config.EmailSettings.FeedbackEmail,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.notificationEmailDescription',
	                                    defaultMessage: 'Email address displayed on email account used when sending notification emails from Mattermost.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SMTPUsername'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.smtpUsernameTitle',
	                                defaultMessage: 'SMTP Username:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SMTPUsername',
	                                ref: 'SMTPUsername',
	                                placeholder: formatMessage(holders.smtpUsernameExample),
	                                defaultValue: this.props.config.EmailSettings.SMTPUsername,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.smtpUsernameDescription',
	                                    defaultMessage: ' Obtain this credential from administrator setting up your email server.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SMTPPassword'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.smtpPasswordTitle',
	                                defaultMessage: 'SMTP Password:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SMTPPassword',
	                                ref: 'SMTPPassword',
	                                placeholder: formatMessage(holders.smtpPasswordExample),
	                                defaultValue: this.props.config.EmailSettings.SMTPPassword,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.smtpPasswordDescription',
	                                    defaultMessage: ' Obtain this credential from administrator setting up your email server.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SMTPServer'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.smtpServerTitle',
	                                defaultMessage: 'SMTP Server:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SMTPServer',
	                                ref: 'SMTPServer',
	                                placeholder: formatMessage(holders.smtpServerExample),
	                                defaultValue: this.props.config.EmailSettings.SMTPServer,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.smtpServerDescription',
	                                    defaultMessage: 'Location of SMTP email server.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SMTPPort'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.smtpPortTitle',
	                                defaultMessage: 'SMTP Port:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SMTPPort',
	                                ref: 'SMTPPort',
	                                placeholder: formatMessage(holders.smtpPortExample),
	                                defaultValue: this.props.config.EmailSettings.SMTPPort,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.smtpPortDescription',
	                                    defaultMessage: 'Port of SMTP email server.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__connection_security_dropdown_setting_jsx__["a"], {
	                        currentValue: this.state.connectionSecurity,
	                        handleChange: function handleChange(e) {
	                            return _this4.setState({ connectionSecurity: e.target.value, saveNeeded: true });
	                        },
	                        isDisabled: !this.state.sendEmailNotifications
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-offset-4 col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-default',
	                                        onClick: this.handleTestConnection,
	                                        disabled: !this.state.sendEmailNotifications,
	                                        id: 'connection-button',
	                                        'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.testing)
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'admin.email.connectionSecurityTest',
	                                        defaultMessage: 'Test Connection'
	                                    })
	                                ),
	                                emailSuccess,
	                                emailFail
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'InviteSalt'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.inviteSaltTitle',
	                                defaultMessage: 'Invite Salt:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'InviteSalt',
	                                ref: 'InviteSalt',
	                                placeholder: formatMessage(holders.inviteSaltExample),
	                                defaultValue: this.props.config.EmailSettings.InviteSalt,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.inviteSaltDescription',
	                                    defaultMessage: '32-character salt added to signing of email invites. Randomly generated on install. Click "Re-Generate" to create new salt.'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-default',
	                                        onClick: this.handleGenerateInvite,
	                                        disabled: !this.state.sendEmailNotifications
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'admin.email.regenerate',
	                                        defaultMessage: 'Re-Generate'
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'PasswordResetSalt'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'admin.email.passwordSaltTitle',
	                                defaultMessage: 'Password Reset Salt:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'PasswordResetSalt',
	                                ref: 'PasswordResetSalt',
	                                placeholder: formatMessage(holders.passwordSaltExample),
	                                defaultValue: this.props.config.EmailSettings.PasswordResetSalt,
	                                onChange: this.handleChange,
	                                disabled: !this.state.sendEmailNotifications
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.passwordSaltDescription',
	                                    defaultMessage: '32-character salt added to signing of password reset emails. Randomly generated on install. Click "Re-Generate" to create new salt.'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-default',
	                                        onClick: this.handleGenerateReset,
	                                        disabled: !this.state.sendEmailNotifications
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'admin.email.regenerate',
	                                        defaultMessage: 'Re-Generate'
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    sendPushNotifications,
	                    tosCheckbox,
	                    pushNotificationServer,
	                    pushNotificationContent,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: disableSave,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'admin.email.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmailSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	EmailSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"].bind()(EmailSettings);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    clientIdExample: {
	        id: 'admin.gitlab.clientIdExample',
	        defaultMessage: 'Ex "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'
	    },
	    clientSecretExample: {
	        id: 'admin.gitlab.clientSecretExample',
	        defaultMessage: 'Ex "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'
	    },
	    authExample: {
	        id: 'admin.gitlab.authExample',
	        defaultMessage: 'Ex ""'
	    },
	    tokenExample: {
	        id: 'admin.gitlab.tokenExample',
	        defaultMessage: 'Ex ""'
	    },
	    userExample: {
	        id: 'admin.gitlab.userExample',
	        defaultMessage: 'Ex ""'
	    },
	    saving: {
	        id: 'admin.gitlab.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var GitLabSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(GitLabSettings, _React$Component);
	
	    function GitLabSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, GitLabSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(GitLabSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            Enable: _this.props.config.GitLabSettings.Enable,
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(GitLabSettings, [{
	        key: 'handleChange',
	        value: function handleChange(action) {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	
	            if (action === 'EnableTrue') {
	                s.Enable = true;
	            }
	
	            if (action === 'EnableFalse') {
	                s.Enable = false;
	            }
	
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.GitLabSettings.Enable = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.Enable).checked;
	            config.GitLabSettings.Secret = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.Secret).value.trim();
	            config.GitLabSettings.Id = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.Id).value.trim();
	            config.GitLabSettings.AuthEndpoint = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AuthEndpoint).value.trim();
	            config.GitLabSettings.TokenEndpoint = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.TokenEndpoint).value.trim();
	            config.GitLabSettings.UserApiEndpoint = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.UserApiEndpoint).value.trim();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.gitlab.settingsTitle',
	                        defaultMessage: 'GitLab Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Enable'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.gitlab.enableTitle',
	                                defaultMessage: 'Enable Sign Up With GitLab: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Enable',
	                                    value: 'true',
	                                    ref: 'Enable',
	                                    defaultChecked: this.props.config.GitLabSettings.Enable,
	                                    onChange: this.handleChange.bind(this, 'EnableTrue')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Enable',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.GitLabSettings.Enable,
	                                    onChange: this.handleChange.bind(this, 'EnableFalse')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.enableDescription',
	                                    defaultMessage: 'When true, Mattermost allows team creation and account signup using GitLab OAuth.'
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null)
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                                    id: 'admin.gitlab.EnableHtmlDesc',
	                                    defaultMessage: '<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs "<your-mattermost-url>/login/gitlab/complete" (example: http://localhost:8065/login/gitlab/complete) and "<your-mattermost-url>/signup/gitlab/complete". </li><li>Then use "Secret" and "Id" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Id'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.gitlab.clientIdTitle',
	                                defaultMessage: 'Id:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'Id',
	                                ref: 'Id',
	                                placeholder: formatMessage(holders.clientIdExample),
	                                defaultValue: this.props.config.GitLabSettings.Id,
	                                onChange: this.handleChange,
	                                disabled: !this.state.Enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.clientIdDescription',
	                                    defaultMessage: 'Obtain this value via the instructions above for logging into GitLab'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Secret'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.gitlab.clientSecretTitle',
	                                defaultMessage: 'Secret:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'Secret',
	                                ref: 'Secret',
	                                placeholder: formatMessage(holders.clientSecretExample),
	                                defaultValue: this.props.config.GitLabSettings.Secret,
	                                onChange: this.handleChange,
	                                disabled: !this.state.Enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitab.clientSecretDescription',
	                                    defaultMessage: 'Obtain this value via the instructions above for logging into GitLab.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AuthEndpoint'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.gitlab.authTitle',
	                                defaultMessage: 'Auth Endpoint:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AuthEndpoint',
	                                ref: 'AuthEndpoint',
	                                placeholder: formatMessage(holders.authExample),
	                                defaultValue: this.props.config.GitLabSettings.AuthEndpoint,
	                                onChange: this.handleChange,
	                                disabled: !this.state.Enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.authDescription',
	                                    defaultMessage: 'Enter https://<your-gitlab-url>/oauth/authorize (example https://example.com:3000/oauth/authorize).   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'TokenEndpoint'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.gitlab.tokenTitle',
	                                defaultMessage: 'Token Endpoint:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'TokenEndpoint',
	                                ref: 'TokenEndpoint',
	                                placeholder: formatMessage(holders.tokenExample),
	                                defaultValue: this.props.config.GitLabSettings.TokenEndpoint,
	                                onChange: this.handleChange,
	                                disabled: !this.state.Enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.tokenDescription',
	                                    defaultMessage: 'Enter https://<your-gitlab-url>/oauth/token.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'UserApiEndpoint'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.gitlab.userTitle',
	                                defaultMessage: 'User API Endpoint:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'UserApiEndpoint',
	                                ref: 'UserApiEndpoint',
	                                placeholder: formatMessage(holders.userExample),
	                                defaultValue: this.props.config.GitLabSettings.UserApiEndpoint,
	                                onChange: this.handleChange,
	                                disabled: !this.state.Enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.userDescription',
	                                    defaultMessage: 'Enter https://<your-gitlab-url>/api/v3/user.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.gitlab.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GitLabSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	//config.GitLabSettings.Scope = ReactDOM.findDOMNode(this.refs.Scope).value.trim();
	//  <div className='form-group'>
	//     <label
	//         className='control-label col-sm-4'
	//         htmlFor='Scope'
	//     >
	//         {'Scope:'}
	//     </label>
	//     <div className='col-sm-8'>
	//         <input
	//             type='text'
	//             className='form-control'
	//             id='Scope'
	//             ref='Scope'
	//             placeholder='Not currently used by GitLab. Please leave blank'
	//             defaultValue={this.props.config.GitLabSettings.Scope}
	//             onChange={this.handleChange}
	//             disabled={!this.state.Allow}
	//         />
	//         <p className='help-text'>{'This field is not yet used by GitLab OAuth. Other OAuth providers may use this field to specify the scope of account data from OAuth provider that is sent to Mattermost.'}</p>
	//     </div>
	// </div>
	
	GitLabSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(GitLabSettings);

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_crypto__ = __webpack_require__(215);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_crypto___default = __WEBPACK_IMPORTED_MODULE_9_crypto__ && __WEBPACK_IMPORTED_MODULE_9_crypto__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_crypto__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_crypto__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_crypto___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_crypto___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    storeLocal: {
	        id: 'admin.image.storeLocal',
	        defaultMessage: 'Local File System'
	    },
	    storeAmazonS3: {
	        id: 'admin.image.storeAmazonS3',
	        defaultMessage: 'Amazon S3'
	    },
	    localExample: {
	        id: 'admin.image.localExample',
	        defaultMessage: 'Ex "./data/"'
	    },
	    amazonS3IdExample: {
	        id: 'admin.image.amazonS3IdExample',
	        defaultMessage: 'Ex "AKIADTOVBGERKLCBV"'
	    },
	    amazonS3SecretExample: {
	        id: 'admin.image.amazonS3SecretExample',
	        defaultMessage: 'Ex "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'
	    },
	    amazonS3BucketExample: {
	        id: 'admin.image.amazonS3BucketExample',
	        defaultMessage: 'Ex "mattermost-media"'
	    },
	    amazonS3RegionExample: {
	        id: 'admin.image.amazonS3RegionExample',
	        defaultMessage: 'Ex "us-east-1"'
	    },
	    thumbWidthExample: {
	        id: 'admin.image.thumbWidthExample',
	        defaultMessage: 'Ex "120"'
	    },
	    thumbHeightExample: {
	        id: 'admin.image.thumbHeightExample',
	        defaultMessage: 'Ex "100"'
	    },
	    previewWidthExample: {
	        id: 'admin.image.previewWidthExample',
	        defaultMessage: 'Ex "1024"'
	    },
	    previewHeightExample: {
	        id: 'admin.image.previewHeightExample',
	        defaultMessage: 'Ex "0"'
	    },
	    profileWidthExample: {
	        id: 'admin.image.profileWidthExample',
	        defaultMessage: 'Ex "1024"'
	    },
	    profileHeightExample: {
	        id: 'admin.image.profileHeightExample',
	        defaultMessage: 'Ex "0"'
	    },
	    publicLinkExample: {
	        id: 'admin.image.publicLinkExample',
	        defaultMessage: 'Ex "gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6"'
	    },
	    saving: {
	        id: 'admin.image.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var FileSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FileSettings, _React$Component);
	
	    function FileSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FileSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FileSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleGenerate = _this.handleGenerate.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null,
	            DriverName: _this.props.config.FileSettings.DriverName
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FileSettings, [{
	        key: 'handleChange',
	        value: function handleChange(action) {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	
	            if (action === 'DriverName') {
	                s.DriverName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.DriverName).value;
	            }
	
	            this.setState(s);
	        }
	    }, {
	        key: 'handleGenerate',
	        value: function handleGenerate(e) {
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PublicLinkSalt).value = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.FileSettings.DriverName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.DriverName).value;
	            config.FileSettings.Directory = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.Directory).value;
	            config.FileSettings.AmazonS3AccessKeyId = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AmazonS3AccessKeyId).value;
	            config.FileSettings.AmazonS3SecretAccessKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AmazonS3SecretAccessKey).value;
	            config.FileSettings.AmazonS3Bucket = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AmazonS3Bucket).value;
	            config.FileSettings.AmazonS3Region = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AmazonS3Region).value;
	            config.FileSettings.EnablePublicLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnablePublicLink).checked;
	
	            config.FileSettings.PublicLinkSalt = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PublicLinkSalt).value.trim();
	
	            if (config.FileSettings.PublicLinkSalt === '') {
	                config.FileSettings.PublicLinkSalt = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PublicLinkSalt).value = config.FileSettings.PublicLinkSalt;
	            }
	
	            var thumbnailWidth = 120;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ThumbnailWidth).value, 10))) {
	                thumbnailWidth = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ThumbnailWidth).value, 10);
	            }
	            config.FileSettings.ThumbnailWidth = thumbnailWidth;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ThumbnailWidth).value = thumbnailWidth;
	
	            var thumbnailHeight = 100;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ThumbnailHeight).value, 10))) {
	                thumbnailHeight = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ThumbnailHeight).value, 10);
	            }
	            config.FileSettings.ThumbnailHeight = thumbnailHeight;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ThumbnailHeight).value = thumbnailHeight;
	
	            var previewWidth = 1024;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PreviewWidth).value, 10))) {
	                previewWidth = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PreviewWidth).value, 10);
	            }
	            config.FileSettings.PreviewWidth = previewWidth;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PreviewWidth).value = previewWidth;
	
	            var previewHeight = 0;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PreviewHeight).value, 10))) {
	                previewHeight = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PreviewHeight).value, 10);
	            }
	            config.FileSettings.PreviewHeight = previewHeight;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PreviewHeight).value = previewHeight;
	
	            var profileWidth = 128;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ProfileWidth).value, 10))) {
	                profileWidth = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ProfileWidth).value, 10);
	            }
	            config.FileSettings.ProfileWidth = profileWidth;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ProfileWidth).value = profileWidth;
	
	            var profileHeight = 128;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ProfileHeight).value, 10))) {
	                profileHeight = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ProfileHeight).value, 10);
	            }
	            config.FileSettings.ProfileHeight = profileHeight;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ProfileHeight).value = profileHeight;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var enableFile = false;
	            var enableS3 = false;
	
	            if (this.state.DriverName === 'local') {
	                enableFile = true;
	            }
	
	            if (this.state.DriverName === 'amazons3') {
	                enableS3 = true;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'admin.image.fileSettings',
	                        defaultMessage: 'File Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'DriverName'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.storeTitle',
	                                defaultMessage: 'Store Files In:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'select',
	                                {
	                                    className: 'form-control',
	                                    id: 'DriverName',
	                                    ref: 'DriverName',
	                                    defaultValue: this.props.config.FileSettings.DriverName,
	                                    onChange: this.handleChange.bind(this, 'DriverName')
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'option',
	                                    { value: 'local' },
	                                    formatMessage(holders.storeLocal)
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'option',
	                                    { value: 'amazons3' },
	                                    formatMessage(holders.storeAmazonS3)
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Directory'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.localTitle',
	                                defaultMessage: 'Local Directory Location:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'Directory',
	                                ref: 'Directory',
	                                placeholder: formatMessage(holders.localExample),
	                                defaultValue: this.props.config.FileSettings.Directory,
	                                onChange: this.handleChange,
	                                disabled: !enableFile
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.localDescription',
	                                    defaultMessage: 'Directory to which image files are written. If blank, will be set to ./data/.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AmazonS3AccessKeyId'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.amazonS3IdTitle',
	                                defaultMessage: 'Amazon S3 Access Key Id:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AmazonS3AccessKeyId',
	                                ref: 'AmazonS3AccessKeyId',
	                                placeholder: formatMessage(holders.amazonS3IdExample),
	                                defaultValue: this.props.config.FileSettings.AmazonS3AccessKeyId,
	                                onChange: this.handleChange,
	                                disabled: !enableS3
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.amazonS3IdDescription',
	                                    defaultMessage: 'Obtain this credential from your Amazon EC2 administrator.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AmazonS3SecretAccessKey'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.amazonS3SecretTitle',
	                                defaultMessage: 'Amazon S3 Secret Access Key:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AmazonS3SecretAccessKey',
	                                ref: 'AmazonS3SecretAccessKey',
	                                placeholder: formatMessage(holders.amazonS3SecretExample),
	                                defaultValue: this.props.config.FileSettings.AmazonS3SecretAccessKey,
	                                onChange: this.handleChange,
	                                disabled: !enableS3
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.amazonS3SecretDescription',
	                                    defaultMessage: 'Obtain this credential from your Amazon EC2 administrator.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AmazonS3Bucket'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.amazonS3BucketTitle',
	                                defaultMessage: 'Amazon S3 Bucket:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AmazonS3Bucket',
	                                ref: 'AmazonS3Bucket',
	                                placeholder: formatMessage(holders.amazonS3BucketExample),
	                                defaultValue: this.props.config.FileSettings.AmazonS3Bucket,
	                                onChange: this.handleChange,
	                                disabled: !enableS3
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.amazonS3BucketDescription',
	                                    defaultMessage: 'Name you selected for your S3 bucket in AWS.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AmazonS3Region'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.amazonS3RegionTitle',
	                                defaultMessage: 'Amazon S3 Region:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AmazonS3Region',
	                                ref: 'AmazonS3Region',
	                                placeholder: formatMessage(holders.amazonS3RegionExample),
	                                defaultValue: this.props.config.FileSettings.AmazonS3Region,
	                                onChange: this.handleChange,
	                                disabled: !enableS3
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.amazonS3RegionDescription',
	                                    defaultMessage: 'AWS region you selected for creating your S3 bucket.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ThumbnailWidth'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.thumbWidthTitle',
	                                defaultMessage: 'Thumbnail Width:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'ThumbnailWidth',
	                                ref: 'ThumbnailWidth',
	                                placeholder: formatMessage(holders.thumbWidthExample),
	                                defaultValue: this.props.config.FileSettings.ThumbnailWidth,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.thumbWidthDescription',
	                                    defaultMessage: 'Width of thumbnails generated from uploaded images. Updating this value changes how thumbnail images render in future, but does not change images created in the past.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ThumbnailHeight'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.thumbHeightTitle',
	                                defaultMessage: 'Thumbnail Height:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'ThumbnailHeight',
	                                ref: 'ThumbnailHeight',
	                                placeholder: formatMessage(holders.thumbHeightExample),
	                                defaultValue: this.props.config.FileSettings.ThumbnailHeight,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.thumbHeightDescription',
	                                    defaultMessage: 'Height of thumbnails generated from uploaded images. Updating this value changes how thumbnail images render in future, but does not change images created in the past.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'PreviewWidth'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.previewWidthTitle',
	                                defaultMessage: 'Preview Width:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'PreviewWidth',
	                                ref: 'PreviewWidth',
	                                placeholder: formatMessage(holders.previewWidthExample),
	                                defaultValue: this.props.config.FileSettings.PreviewWidth,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.previewWidthDescription',
	                                    defaultMessage: 'Maximum width of preview image. Updating this value changes how preview images render in future, but does not change images created in the past.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'PreviewHeight'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.previewHeightTitle',
	                                defaultMessage: 'Preview Height:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'PreviewHeight',
	                                ref: 'PreviewHeight',
	                                placeholder: formatMessage(holders.previewHeightExample),
	                                defaultValue: this.props.config.FileSettings.PreviewHeight,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.previewHeightDescription',
	                                    defaultMessage: 'Maximum height of preview image ("0": Sets to auto-size). Updating this value changes how preview images render in future, but does not change images created in the past.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ProfileWidth'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.profileWidthTitle',
	                                defaultMessage: 'Profile Width:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'ProfileWidth',
	                                ref: 'ProfileWidth',
	                                placeholder: formatMessage(holders.profileWidthExample),
	                                defaultValue: this.props.config.FileSettings.ProfileWidth,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.profileWidthDescription',
	                                    defaultMessage: 'Width of profile picture.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ProfileHeight'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.profileHeightTitle',
	                                defaultMessage: 'Profile Height:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'ProfileHeight',
	                                ref: 'ProfileHeight',
	                                placeholder: formatMessage(holders.profileHeightExample),
	                                defaultValue: this.props.config.FileSettings.ProfileHeight,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.profileHeightDescription',
	                                    defaultMessage: 'Height of profile picture.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnablePublicLink'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.shareTitle',
	                                defaultMessage: 'Share Public File Link: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnablePublicLink',
	                                    value: 'true',
	                                    ref: 'EnablePublicLink',
	                                    defaultChecked: this.props.config.FileSettings.EnablePublicLink,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnablePublicLink',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.FileSettings.EnablePublicLink,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.shareDescription',
	                                    defaultMessage: 'Allow users to share public links to files and images.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'PublicLinkSalt'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.image.publicLinkTitle',
	                                defaultMessage: 'Public Link Salt:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'PublicLinkSalt',
	                                ref: 'PublicLinkSalt',
	                                placeholder: formatMessage(holders.publicLinkExample),
	                                defaultValue: this.props.config.FileSettings.PublicLinkSalt,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.publicLinkDescription',
	                                    defaultMessage: '32-character salt added to signing of public image links. Randomly generated on install. Click "Re-Generate" to create new salt.'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-default',
	                                        onClick: this.handleGenerate
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'admin.image.regenerate',
	                                        defaultMessage: 'Re-Generate'
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.image.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FileSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	FileSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(FileSettings);

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__connection_security_dropdown_setting_jsx__ = __webpack_require__(345);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__boolean_setting_jsx__ = __webpack_require__(644);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var DEFAULT_LDAP_PORT = 389;
	var DEFAULT_QUERY_TIMEOUT = 60;
	
	
	
	var LdapSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LdapSettings, _React$Component);
	
	    function LdapSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LdapSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LdapSettings).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleEnable = _this.handleEnable.bind(_this);
	        _this.handleDisable = _this.handleDisable.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null,
	            enable: _this.props.config.LdapSettings.Enable,
	            connectionSecurity: _this.props.config.LdapSettings.ConnectionSecurity,
	            skipCertificateVerification: _this.props.config.LdapSettings.SkipCertificateVerification
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LdapSettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            this.setState({ saveNeeded: true });
	        }
	    }, {
	        key: 'handleEnable',
	        value: function handleEnable() {
	            this.setState({ saveNeeded: true, enable: true });
	        }
	    }, {
	        key: 'handleDisable',
	        value: function handleDisable() {
	            this.setState({ saveNeeded: true, enable: false });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.LdapSettings.Enable = this.refs.Enable.checked;
	            config.LdapSettings.LdapServer = this.refs.LdapServer.value.trim();
	
	            var LdapPort = DEFAULT_LDAP_PORT;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.LdapPort).value, 10))) {
	                LdapPort = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.LdapPort).value, 10);
	            }
	            config.LdapSettings.LdapPort = LdapPort;
	
	            config.LdapSettings.BaseDN = this.refs.BaseDN.value.trim();
	            config.LdapSettings.BindUsername = this.refs.BindUsername.value.trim();
	            config.LdapSettings.BindPassword = this.refs.BindPassword.value.trim();
	            config.LdapSettings.FirstNameAttribute = this.refs.FirstNameAttribute.value.trim();
	            config.LdapSettings.LastNameAttribute = this.refs.LastNameAttribute.value.trim();
	            config.LdapSettings.NicknameAttribute = this.refs.NicknameAttribute.value.trim();
	            config.LdapSettings.EmailAttribute = this.refs.EmailAttribute.value.trim();
	            config.LdapSettings.UsernameAttribute = this.refs.UsernameAttribute.value.trim();
	            config.LdapSettings.IdAttribute = this.refs.IdAttribute.value.trim();
	            config.LdapSettings.UserFilter = this.refs.UserFilter.value.trim();
	            config.LdapSettings.ConnectionSecurity = this.state.connectionSecurity.trim();
	            config.LdapSettings.SkipCertificateVerification = this.state.skipCertificateVerification;
	            config.LdapSettings.LoginFieldName = this.refs.LoginFieldName.value.trim();
	
	            var QueryTimeout = DEFAULT_QUERY_TIMEOUT;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.QueryTimeout).value, 10))) {
	                QueryTimeout = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.QueryTimeout).value, 10);
	            }
	            config.LdapSettings.QueryTimeout = QueryTimeout;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var licenseEnabled = global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.LDAP === 'true';
	
	            var bannerContent = void 0;
	            if (licenseEnabled) {
	                bannerContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'banner' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'banner__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'h4',
	                            { className: 'banner__heading' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.bannerHeading',
	                                defaultMessage: 'Note:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.bannerDesc',
	                                defaultMessage: 'If a user attribute changes on the LDAP server it will be updated the next time the user enters their credentials to log in to Mattermost. This includes if a user is made inactive or removed from an LDAP server. Synchronization with LDAP servers is planned in a future release.'
	                            })
	                        )
	                    )
	                );
	            } else {
	                bannerContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'banner warning' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'banner__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                            id: 'admin.ldap.noLicense',
	                            defaultMessage: '<h4 class="banner__heading">Note:</h4><p>LDAP is an enterprise feature. Your current license does not support LDAP. Click <a href="http://mattermost.com"target="_blank">here</a> for information and pricing on enterprise licenses.</p>'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                bannerContent,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'admin.ldap.title',
	                        defaultMessage: 'LDAP Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Enable'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.enableTitle',
	                                defaultMessage: 'Enable Login With LDAP:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Enable',
	                                    value: 'true',
	                                    ref: 'Enable',
	                                    defaultChecked: this.props.config.LdapSettings.Enable,
	                                    onChange: this.handleEnable,
	                                    disabled: !licenseEnabled
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Enable',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.LdapSettings.Enable,
	                                    onChange: this.handleDisable
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.enableDesc',
	                                    defaultMessage: 'When true, Mattermost allows login using LDAP'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'LdapServer'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.serverTitle',
	                                defaultMessage: 'LDAP Server:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'LdapServer',
	                                ref: 'LdapServer',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.serverEx', 'Ex "10.0.0.23"'),
	                                defaultValue: this.props.config.LdapSettings.LdapServer,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.serverDesc',
	                                    defaultMessage: 'The domain or IP address of LDAP server.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'LdapPort'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.portTitle',
	                                defaultMessage: 'LDAP Port:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'number',
	                                className: 'form-control',
	                                id: 'LdapPort',
	                                ref: 'LdapPort',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.portEx', 'Ex "389"'),
	                                defaultValue: this.props.config.LdapSettings.LdapPort,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.portDesc',
	                                    defaultMessage: 'The port Mattermost will use to connect to the LDAP server. Default is 389.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__connection_security_dropdown_setting_jsx__["a"], {
	                        currentValue: this.state.connectionSecurity,
	                        handleChange: function handleChange(e) {
	                            return _this3.setState({ connectionSecurity: e.target.value, saveNeeded: true });
	                        },
	                        isDisabled: !this.state.enable
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'BaseDN'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.baseTitle',
	                                defaultMessage: 'BaseDN:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'BaseDN',
	                                ref: 'BaseDN',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.baseEx', 'Ex "ou=Unit Name,dc=corp,dc=example,dc=com"'),
	                                defaultValue: this.props.config.LdapSettings.BaseDN,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.baseDesc',
	                                    defaultMessage: 'The Base DN is the Distinguished Name of the location where Mattermost should start its search for users in the LDAP tree.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'BindUsername'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.bindUserTitle',
	                                defaultMessage: 'Bind Username:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'BindUsername',
	                                ref: 'BindUsername',
	                                placeholder: '',
	                                defaultValue: this.props.config.LdapSettings.BindUsername,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.bindUserDesc',
	                                    defaultMessage: 'The username used to perform the LDAP search. This should typically be an account created specifically for use with Mattermost. It should have access limited to read the portion of the LDAP tree specified in the BaseDN field.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'BindPassword'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.bindPwdTitle',
	                                defaultMessage: 'Bind Password:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'password',
	                                className: 'form-control',
	                                id: 'BindPassword',
	                                ref: 'BindPassword',
	                                placeholder: '',
	                                defaultValue: this.props.config.LdapSettings.BindPassword,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.bindPwdDesc',
	                                    defaultMessage: 'Password of the user given in "Bind Username".'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'UserFilter'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.userFilterTitle',
	                                defaultMessage: 'User Filter:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'UserFilter',
	                                ref: 'UserFilter',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.userFilterEx', 'Ex. "(objectClass=user)"'),
	                                defaultValue: this.props.config.LdapSettings.UserFilter,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.userFilterDisc',
	                                    defaultMessage: 'Optionally enter an LDAP Filter to use when searching for user objects. Only the users selected by the query will be able to access Mattermost. For Active Directory, the query to filter out disabled users is (&(objectCategory=Person)(!(UserAccountControl:1.2.840.113556.1.4.803:=2))).'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'FirstNameAttribute'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.firstnameAttrTitle',
	                                defaultMessage: 'First Name Attrubute'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'FirstNameAttribute',
	                                ref: 'FirstNameAttribute',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.firstnameAttrEx', 'Ex "givenName"'),
	                                defaultValue: this.props.config.LdapSettings.FirstNameAttribute,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.firstnameAttrDesc',
	                                    defaultMessage: 'The attribute in the LDAP server that will be used to populate the first name of users in Mattermost.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'LastNameAttribute'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.lastnameAttrTitle',
	                                defaultMessage: 'Last Name Attribute:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'LastNameAttribute',
	                                ref: 'LastNameAttribute',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.lastnameAttrEx', 'Ex "sn"'),
	                                defaultValue: this.props.config.LdapSettings.LastNameAttribute,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.lastnameAttrDesc',
	                                    defaultMessage: 'The attribute in the LDAP server that will be used to populate the last name of users in Mattermost.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'NicknameAttribute'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.nicknameAttrTitle',
	                                defaultMessage: 'Nickname Attribute:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'NicknameAttribute',
	                                ref: 'NicknameAttribute',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.nicknameAttrEx', 'Ex "nickname"'),
	                                defaultValue: this.props.config.LdapSettings.NicknameAttribute,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.nicknameAttrDesc',
	                                    defaultMessage: '(Optional) The attribute in the LDAP server that will be used to populate the nickname of users in Mattermost.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EmailAttribute'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.emailAttrTitle',
	                                defaultMessage: 'Email Attribute:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'EmailAttribute',
	                                ref: 'EmailAttribute',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.emailAttrEx', 'Ex "mail" or "userPrincipalName"'),
	                                defaultValue: this.props.config.LdapSettings.EmailAttribute,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.emailAttrDesc',
	                                    defaultMessage: 'The attribute in the LDAP server that will be used to populate the email addresses of users in Mattermost.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'UsernameAttribute'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.usernameAttrTitle',
	                                defaultMessage: 'Username Attribute:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'UsernameAttribute',
	                                ref: 'UsernameAttribute',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.usernameAttrEx', 'Ex "sAMAccountName"'),
	                                defaultValue: this.props.config.LdapSettings.UsernameAttribute,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.uernameAttrDesc',
	                                    defaultMessage: 'The attribute in the LDAP server that will be used to populate the username field in Mattermost. This may be the same as the ID Attribute.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'IdAttribute'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.idAttrTitle',
	                                defaultMessage: 'Id Attribute: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'IdAttribute',
	                                ref: 'IdAttribute',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.idAttrEx', 'Ex "sAMAccountName"'),
	                                defaultValue: this.props.config.LdapSettings.IdAttribute,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.idAttrDesc',
	                                    defaultMessage: 'The attribute in the LDAP server that will be used as a unique identifier in Mattermost. It should be an LDAP attribute with a value that does not change, such as username or uid. If a user’s Id Attribute changes, it will create a new Mattermost account unassociated with their old one. This is the value used to log in to Mattermost in the "LDAP Username" field on the sign in page. Normally this attribute is the same as the “Username Attribute” field above. If your team typically uses domain\\\\username to sign in to other services with LDAP, you may choose to put domain\\\\username in this field to maintain consistency between sites.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__boolean_setting_jsx__["a"], {
	                        label: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.ldap.skipCertificateVerification',
	                            defaultMessage: 'Skip Certificate Verification'
	                        }),
	                        currentValue: this.state.skipCertificateVerification,
	                        isDisabled: !this.state.enable,
	                        handleChange: function handleChange(e) {
	                            return _this3.setState({ skipCertificateVerification: e.target.value.trim() === 'true', saveNeeded: true });
	                        },
	                        helpText: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.skipCertificateVerificationDesc',
	                                defaultMessage: 'Skips the certificate verification step for TLS or STARTTLS connections. Not recommended for production environments where TLS is required. For testing only.'
	                            })
	                        )
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'QueryTimeout'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.queryTitle',
	                                defaultMessage: 'Query Timeout (seconds):'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'number',
	                                className: 'form-control',
	                                id: 'QueryTimeout',
	                                ref: 'QueryTimeout',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.queryEx', 'Ex "60"'),
	                                defaultValue: this.props.config.LdapSettings.QueryTimeout,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.queryDesc',
	                                    defaultMessage: 'The timeout value for queries to the LDAP server. Increase if you are getting timeout errors caused by a slow LDAP server.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'LoginFieldName'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.ldap.loginNameTitle',
	                                defaultMessage: 'Login Field Name:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'LoginFieldName',
	                                ref: 'LoginFieldName',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.loginNameEx', 'Ex "LDAP Username"'),
	                                defaultValue: this.props.config.LdapSettings.LoginFieldName,
	                                onChange: this.handleChange,
	                                disabled: !this.state.enable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.loginNameDesc',
	                                    defaultMessage: 'The placeholder text that appears in the login field on the login page. Defaults to "LDAP Username".'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.ldap.saving', 'Saving Config...')
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.ldap.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LdapSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	LdapSettings.defaultProps = {};
	
	LdapSettings.propTypes = {
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = LdapSettings;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    saving: {
	        id: 'admin.support.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var LegalAndSupportSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LegalAndSupportSettings, _React$Component);
	
	    function LegalAndSupportSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LegalAndSupportSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LegalAndSupportSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LegalAndSupportSettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	
	            config.SupportSettings.TermsOfServiceLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.TermsOfServiceLink).value.trim();
	            config.SupportSettings.PrivacyPolicyLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PrivacyPolicyLink).value.trim();
	            config.SupportSettings.AboutLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AboutLink).value.trim();
	            config.SupportSettings.HelpLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.HelpLink).value.trim();
	            config.SupportSettings.ReportAProblemLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ReportAProblemLink).value.trim();
	            config.SupportSettings.SupportEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SupportEmail).value.trim();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'banner' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'banner__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'h4',
	                            { className: 'banner__heading' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.noteTitle',
	                                defaultMessage: 'Note:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.noteDescription',
	                                defaultMessage: 'If linking to an external site, URLs should begin with http:// or https://.'
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.support.title',
	                        defaultMessage: 'Legal and Support Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'TermsOfServiceLink'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.termsTitle',
	                                defaultMessage: 'Terms of Service link:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'TermsOfServiceLink',
	                                ref: 'TermsOfServiceLink',
	                                defaultValue: this.props.config.SupportSettings.TermsOfServiceLink,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.termsDesc',
	                                    defaultMessage: 'Link to Terms of Service available to users on desktop and on mobile. Leaving this blank will hide the option to display a notice.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'PrivacyPolicyLink'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.privacyTitle',
	                                defaultMessage: 'Privacy Policy link:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'PrivacyPolicyLink',
	                                ref: 'PrivacyPolicyLink',
	                                defaultValue: this.props.config.SupportSettings.PrivacyPolicyLink,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.privacyDesc',
	                                    defaultMessage: 'Link to Privacy Policy available to users on desktop and on mobile. Leaving this blank will hide the option to display a notice.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AboutLink'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.aboutTitle',
	                                defaultMessage: 'About link:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AboutLink',
	                                ref: 'AboutLink',
	                                defaultValue: this.props.config.SupportSettings.AboutLink,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.aboutDesc',
	                                    defaultMessage: 'Link to About page for more information on your Mattermost deployment, for example its purpose and audience within your organization. Defaults to Mattermost information page.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'HelpLink'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.helpTitle',
	                                defaultMessage: 'Help link:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'HelpLink',
	                                ref: 'HelpLink',
	                                defaultValue: this.props.config.SupportSettings.HelpLink,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.helpDesc',
	                                    defaultMessage: 'Link to help documentation from team site main menu. Typically not changed unless your organization chooses to create custom documentation.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ReportAProblemLink'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.problemTitle',
	                                defaultMessage: 'Report a Problem link:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'ReportAProblemLink',
	                                ref: 'ReportAProblemLink',
	                                defaultValue: this.props.config.SupportSettings.ReportAProblemLink,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.problemDesc',
	                                    defaultMessage: 'Link to help documentation from team site main menu. By default this points to the peer-to-peer troubleshooting forum where users can search for, find and request help with technical issues.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SupportEmail'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.support.emailTitle',
	                                defaultMessage: 'Support email:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SupportEmail',
	                                ref: 'SupportEmail',
	                                defaultValue: this.props.config.SupportSettings.SupportEmail,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.emailHelp',
	                                    defaultMessage: 'Email shown during tutorial for end users to ask support questions.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + this.props.intl.formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.support.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LegalAndSupportSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	LegalAndSupportSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(LegalAndSupportSettings);

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    removing: {
	        id: 'admin.license.removing',
	        defaultMessage: 'Removing License...'
	    },
	    uploading: {
	        id: 'admin.license.uploading',
	        defaultMessage: 'Uploading License...'
	    }
	});
	
	
	
	var LicenseSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LicenseSettings, _React$Component);
	
	    function LicenseSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LicenseSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LicenseSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleRemove = _this.handleRemove.bind(_this);
	
	        _this.state = {
	            fileSelected: false,
	            fileName: null,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LicenseSettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            var element = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileInput));
	            if (element.prop('files').length > 0) {
	                this.setState({ fileSelected: true, fileName: element.prop('files')[0].name });
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var element = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileInput));
	            if (element.prop('files').length === 0) {
	                return;
	            }
	            var file = element.prop('files')[0];
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('loading');
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].uploadLicenseFile(file, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.clearFileInput(element[0]);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('reset');
	                _this2.setState({ fileSelected: false, fileName: null, serverError: null });
	                window.location.reload(true);
	            }, function (error) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.clearFileInput(element[0]);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('reset');
	                _this2.setState({ fileSelected: false, fileName: null, serverError: error.message });
	            });
	        }
	    }, {
	        key: 'handleRemove',
	        value: function handleRemove(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#remove-button').button('loading');
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].removeLicenseFile(function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#remove-button').button('reset');
	                _this3.setState({ fileSelected: false, fileName: null, serverError: null });
	                window.location.reload(true);
	            }, function (error) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#remove-button').button('reset');
	                _this3.setState({ fileSelected: false, fileName: null, serverError: error.message });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var btnClass = 'btn';
	            if (this.state.fileSelected) {
	                btnClass = 'btn btn-primary';
	            }
	
	            var edition = void 0;
	            var licenseType = void 0;
	            var licenseKey = void 0;
	
	            var issued = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.displayDate(parseInt(global.window.mm_license.IssuedAt, 10)) + ' ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.displayTime(parseInt(global.window.mm_license.IssuedAt, 10), true);
	            var startsAt = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.displayDate(parseInt(global.window.mm_license.StartsAt, 10));
	            var expiresAt = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.displayDate(parseInt(global.window.mm_license.ExpiresAt, 10));
	
	            if (global.window.mm_license.IsLicensed === 'true') {
	                // Note: DO NOT LOCALISE THESE STRINGS. Legally we can not since the license is in English.
	                edition = 'Mattermost Enterprise Edition. Enterprise features on this server have been unlocked with a license key and a valid subscription.';
	                licenseType = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'p',
	                        null,
	                        'This software is offered under a commercial license.\n\nSee ENTERPRISE-EDITION-LICENSE.txt in your root install directory for details. See NOTICE.txt for information about open source software used in this system.\n\nYour subscription details are as follows:'
	                    ),
	                    'Name: ' + global.window.mm_license.Name,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    'Company or organization name: ' + global.window.mm_license.Company,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    'Number of users: ' + global.window.mm_license.Users,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    'License issued: ' + issued,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    'Start date of license: ' + startsAt,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    'Expiry date of license: ' + expiresAt,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    'See also ',
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'a',
	                        { href: 'https://about.mattermost.com/enterprise-edition-terms/' },
	                        'Enterprise Edition Terms of Service'
	                    ),
	                    ' and ',
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'a',
	                        { href: 'https://about.mattermost.com/privacy/' },
	                        'Privacy Policy.'
	                    )
	                );
	
	                licenseKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-8' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'button',
	                        {
	                            className: 'btn btn-danger',
	                            onClick: this.handleRemove,
	                            id: 'remove-button',
	                            'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + this.props.intl.formatMessage(holders.removing)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.license.keyRemove',
	                            defaultMessage: 'Remove Enterprise License and Downgrade Server'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'p',
	                        { className: 'help-text' },
	                        'If you migrate servers you may need to remove your license key to install it elsewhere. You can remove the key here, which will revert functionality to that of Team Edition.'
	                    )
	                );
	            } else {
	                // Note: DO NOT LOCALISE THESE STRINGS. Legally we can not since the license is in English.
	                edition = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'p',
	                    null,
	                    'Mattermost Enterprise Edition. Unlock enterprise features in this software through the purchase of a subscription from ',
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'a',
	                        {
	                            target: '_blank',
	                            href: 'https://mattermost.com/'
	                        },
	                        'https://mattermost.com/'
	                    )
	                );
	
	                licenseType = 'This software is offered under a commercial license.\n\nSee ENTERPRISE-EDITION-LICENSE.txt in your root install directory for details. See NOTICE.txt for information about open source software used in this system.';
	
	                var fileName = void 0;
	                if (this.state.fileName) {
	                    fileName = this.state.fileName;
	                } else {
	                    fileName = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.license.noFile',
	                        defaultMessage: 'No file uploaded'
	                    });
	                }
	
	                licenseKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-8' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'file__upload' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'button',
	                            { className: 'btn btn-primary' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.license.choose',
	                                defaultMessage: 'Choose File'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                            ref: 'fileInput',
	                            type: 'file',
	                            accept: '.mattermost-license',
	                            onChange: this.handleChange
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'button',
	                        {
	                            className: btnClass,
	                            disabled: !this.state.fileSelected,
	                            onClick: this.handleSubmit,
	                            id: 'upload-button',
	                            'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + this.props.intl.formatMessage(holders.uploading)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.license.upload',
	                            defaultMessage: 'Upload'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'help-text no-margin' },
	                        fileName
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    serverError,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'p',
	                        { className: 'help-text no-margin' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                            id: 'admin.license.uploadDesc',
	                            defaultMessage: 'Upload a license key for Mattermost Enterprise Edition to upgrade this server. <a href="http://mattermost.com" target="_blank">Visit us online</a> to learn more about the benefits of Enterprise Edition or to purchase a key.'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.license.title',
	                        defaultMessage: 'Edition and License'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.license.edition',
	                                defaultMessage: 'Edition: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            edition
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.license.type',
	                                defaultMessage: 'License: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            licenseType
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.license.key',
	                                defaultMessage: 'License Key: '
	                            })
	                        ),
	                        licenseKey
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LicenseSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	LicenseSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(LicenseSettings);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    locationPlaceholder: {
	        id: 'admin.log.locationPlaceholder',
	        defaultMessage: 'Enter your file location'
	    },
	    formatPlaceholder: {
	        id: 'admin.log.formatPlaceholder',
	        defaultMessage: 'Enter your file format'
	    },
	    saving: {
	        id: 'admin.log.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var LogSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LogSettings, _React$Component);
	
	    function LogSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LogSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LogSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            consoleEnable: _this.props.config.LogSettings.EnableConsole,
	            fileEnable: _this.props.config.LogSettings.EnableFile,
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LogSettings, [{
	        key: 'handleChange',
	        value: function handleChange(action) {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	
	            if (action === 'console_true') {
	                s.consoleEnable = true;
	            }
	
	            if (action === 'console_false') {
	                s.consoleEnable = false;
	            }
	
	            if (action === 'file_true') {
	                s.fileEnable = true;
	            }
	
	            if (action === 'file_false') {
	                s.fileEnable = false;
	            }
	
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.LogSettings.EnableConsole = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.consoleEnable).checked;
	            config.LogSettings.ConsoleLevel = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.consoleLevel).value;
	            config.LogSettings.EnableFile = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileEnable).checked;
	            config.LogSettings.FileLevel = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileLevel).value;
	            config.LogSettings.FileLocation = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileLocation).value.trim();
	            config.LogSettings.FileFormat = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileFormat).value.trim();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    consoleEnable: config.LogSettings.EnableConsole,
	                    fileEnable: config.LogSettings.EnableFile,
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    consoleEnable: config.LogSettings.EnableConsole,
	                    fileEnable: config.LogSettings.EnableFile,
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.log.logSettings',
	                        defaultMessage: 'Log Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'consoleEnable'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.log.consoleTitle',
	                                defaultMessage: 'Log To The Console: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'consoleEnable',
	                                    value: 'true',
	                                    ref: 'consoleEnable',
	                                    defaultChecked: this.props.config.LogSettings.EnableConsole,
	                                    onChange: this.handleChange.bind(this, 'console_true')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'consoleEnable',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.LogSettings.EnableConsole,
	                                    onChange: this.handleChange.bind(this, 'console_false')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.consoleDescription',
	                                    defaultMessage: 'Typically set to false in production. Developers may set this field to true to output log messages to console based on the console level option.  If true, server writes messages to the standard output stream (stdout).'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'consoleLevel'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.log.levelTitle',
	                                defaultMessage: 'Console Log Level:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'select',
	                                {
	                                    className: 'form-control',
	                                    id: 'consoleLevel',
	                                    ref: 'consoleLevel',
	                                    defaultValue: this.props.config.LogSettings.consoleLevel,
	                                    onChange: this.handleChange,
	                                    disabled: !this.state.consoleEnable
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'DEBUG' },
	                                    'DEBUG'
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'INFO' },
	                                    'INFO'
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'ERROR' },
	                                    'ERROR'
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.levelDescription',
	                                    defaultMessage: 'This setting determines the level of detail at which log events are written to the console. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.log.fileTitle',
	                                defaultMessage: 'Log To File: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'fileEnable',
	                                    ref: 'fileEnable',
	                                    value: 'true',
	                                    defaultChecked: this.props.config.LogSettings.EnableFile,
	                                    onChange: this.handleChange.bind(this, 'file_true')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'fileEnable',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.LogSettings.EnableFile,
	                                    onChange: this.handleChange.bind(this, 'file_false')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.fileDescription',
	                                    defaultMessage: 'Typically set to true in production.  When true, log files are written to the log file specified in file location field below.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'fileLevel'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.log.fileLevelTitle',
	                                defaultMessage: 'File Log Level:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'select',
	                                {
	                                    className: 'form-control',
	                                    id: 'fileLevel',
	                                    ref: 'fileLevel',
	                                    defaultValue: this.props.config.LogSettings.FileLevel,
	                                    onChange: this.handleChange,
	                                    disabled: !this.state.fileEnable
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'DEBUG' },
	                                    'DEBUG'
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'INFO' },
	                                    'INFO'
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'ERROR' },
	                                    'ERROR'
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.fileLevelDescription',
	                                    defaultMessage: 'This setting determines the level of detail at which log events are written to the log file. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'fileLocation'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.log.locationTitle',
	                                defaultMessage: 'File Location:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'fileLocation',
	                                ref: 'fileLocation',
	                                placeholder: formatMessage(holders.locationPlaceholder),
	                                defaultValue: this.props.config.LogSettings.FileLocation,
	                                onChange: this.handleChange,
	                                disabled: !this.state.fileEnable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.locationDescription',
	                                    defaultMessage: 'File to which log files are written. If blank, will be set to ./logs/mattermost, which writes logs to mattermost.log. Log rotation is enabled and every 10,000 lines of log information is written to new files stored in the same directory, for example mattermost.2015-09-23.001, mattermost.2015-09-23.002, and so forth.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'fileFormat'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.log.formatTitle',
	                                defaultMessage: 'File Format:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'fileFormat',
	                                ref: 'fileFormat',
	                                placeholder: formatMessage(holders.formatPlaceholder),
	                                defaultValue: this.props.config.LogSettings.FileFormat,
	                                onChange: this.handleChange,
	                                disabled: !this.state.fileEnable
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.formatDescription',
	                                    defaultMessage: 'Format of log message output. If blank will be set to "[%D %T] [%L] %M", where:'
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'div',
	                                    { className: 'help-text' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'table',
	                                        {
	                                            className: 'table table-bordered',
	                                            cellPadding: '5'
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                            'tbody',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                'tr',
	                                                null,
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    '%T'
	                                                ),
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                                        id: 'admin.log.formatTime',
	                                                        defaultMessage: 'Time (15:04:05 MST)'
	                                                    })
	                                                )
	                                            ),
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                'tr',
	                                                null,
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    '%D'
	                                                ),
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                                        id: 'admin.log.formatDateLong',
	                                                        defaultMessage: 'Date (2006/01/02)'
	                                                    })
	                                                )
	                                            ),
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                'tr',
	                                                null,
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    '%d'
	                                                ),
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                                        id: 'admin.log.formatDateShort',
	                                                        defaultMessage: 'Date (01/02/06)'
	                                                    })
	                                                )
	                                            ),
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                'tr',
	                                                null,
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    '%L'
	                                                ),
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                                        id: 'admin.log.formatLevel',
	                                                        defaultMessage: 'Level (DEBG, INFO, EROR)'
	                                                    })
	                                                )
	                                            ),
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                'tr',
	                                                null,
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    '%S'
	                                                ),
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                                        id: 'admin.log.formatSource',
	                                                        defaultMessage: 'Source'
	                                                    })
	                                                )
	                                            ),
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                'tr',
	                                                null,
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    '%M'
	                                                ),
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                                    'td',
	                                                    { className: 'help-text' },
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                                        id: 'admin.log.formatMessage',
	                                                        defaultMessage: 'Message'
	                                                    })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.log.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LogSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	LogSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(LogSettings);

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_admin_store_jsx__ = __webpack_require__(191);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var Logs = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Logs, _React$Component);
	
	    function Logs(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Logs);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Logs).call(this, props));
	
	        _this.onLogListenerChange = _this.onLogListenerChange.bind(_this);
	        _this.reload = _this.reload.bind(_this);
	
	        _this.state = {
	            logs: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_admin_store_jsx__["a"].getLogs()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Logs, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_admin_store_jsx__["a"].addLogChangeListener(this.onLogListenerChange);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.getLogs();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_admin_store_jsx__["a"].removeLogChangeListener(this.onLogListenerChange);
	        }
	    }, {
	        key: 'onLogListenerChange',
	        value: function onLogListenerChange() {
	            this.setState({
	                logs: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_admin_store_jsx__["a"].getLogs()
	            });
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_admin_store_jsx__["a"].saveLogs(null);
	            this.setState({
	                logs: null
	            });
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.getLogs();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = null;
	
	            if (this.state.logs === null) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__["a"], null);
	            } else {
	                content = [];
	
	                for (var i = 0; i < this.state.logs.length; i++) {
	                    var style = {
	                        whiteSpace: 'nowrap',
	                        fontFamily: 'monospace'
	                    };
	
	                    if (this.state.logs[i].indexOf('[EROR]') > 0) {
	                        style.color = 'red';
	                    }
	
	                    content.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', { key: 'br_' + i }));
	                    content.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'span',
	                        {
	                            key: 'log_' + i,
	                            style: style
	                        },
	                        this.state.logs[i]
	                    ));
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                { className: 'panel' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.logs.title',
	                        defaultMessage: 'Server Logs'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'button',
	                    {
	                        type: 'submit',
	                        className: 'btn btn-primary',
	                        onClick: this.reload
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'admin.logs.reload',
	                        defaultMessage: 'Reload'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'log__panel' },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return Logs;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Logs;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    saving: {
	        id: 'admin.privacy.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var PrivacySettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PrivacySettings, _React$Component);
	
	    function PrivacySettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PrivacySettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PrivacySettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PrivacySettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.PrivacySettings.ShowEmailAddress = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ShowEmailAddress).checked;
	            config.PrivacySettings.ShowFullName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ShowFullName).checked;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.privacy.title',
	                        defaultMessage: 'Privacy Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ShowEmailAddress'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.privacy.showEmailTitle',
	                                defaultMessage: 'Show Email Address: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'ShowEmailAddress',
	                                    value: 'true',
	                                    ref: 'ShowEmailAddress',
	                                    defaultChecked: this.props.config.PrivacySettings.ShowEmailAddress,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'ShowEmailAddress',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.PrivacySettings.ShowEmailAddress,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.showEmailDescription',
	                                    defaultMessage: 'When false, hides email address of users from other users in the user interface, including team owners and team administrators. Used when system is set up for managing teams where some users choose to keep their contact information private.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ShowFullName'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.privacy.showFullNameTitle',
	                                defaultMessage: 'Show Full Name: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'ShowFullName',
	                                    value: 'true',
	                                    ref: 'ShowFullName',
	                                    defaultChecked: this.props.config.PrivacySettings.ShowFullName,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'ShowFullName',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.PrivacySettings.ShowFullName,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.showFullNameDescription',
	                                    defaultMessage: 'When false, hides full name of users from other users, including team owners and team administrators. Username is shown in place of full name.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + this.props.intl.formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.privacy.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PrivacySettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	PrivacySettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(PrivacySettings);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    queriesExample: {
	        id: 'admin.rate.queriesExample',
	        defaultMessage: 'Ex "10"'
	    },
	    memoryExample: {
	        id: 'admin.rate.memoryExample',
	        defaultMessage: 'Ex "10000"'
	    },
	    httpHeaderExample: {
	        id: 'admin.rate.httpHeaderExample',
	        defaultMessage: 'Ex "X-Real-IP", "X-Forwarded-For"'
	    },
	    saving: {
	        id: 'admin.rate.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var RateSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(RateSettings, _React$Component);
	
	    function RateSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RateSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RateSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            EnableRateLimiter: _this.props.config.RateLimitSettings.EnableRateLimiter,
	            VaryByRemoteAddr: _this.props.config.RateLimitSettings.VaryByRemoteAddr,
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(RateSettings, [{
	        key: 'handleChange',
	        value: function handleChange(action) {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	
	            if (action === 'EnableRateLimiterTrue') {
	                s.EnableRateLimiter = true;
	            }
	
	            if (action === 'EnableRateLimiterFalse') {
	                s.EnableRateLimiter = false;
	            }
	
	            if (action === 'VaryByRemoteAddrTrue') {
	                s.VaryByRemoteAddr = true;
	            }
	
	            if (action === 'VaryByRemoteAddrFalse') {
	                s.VaryByRemoteAddr = false;
	            }
	
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.RateLimitSettings.EnableRateLimiter = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableRateLimiter).checked;
	            config.RateLimitSettings.VaryByRemoteAddr = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.VaryByRemoteAddr).checked;
	            config.RateLimitSettings.VaryByHeader = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.VaryByHeader).value.trim();
	
	            var PerSec = 10;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PerSec).value, 10))) {
	                PerSec = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PerSec).value, 10);
	            }
	            config.RateLimitSettings.PerSec = PerSec;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.PerSec).value = PerSec;
	
	            var MemoryStoreSize = 10000;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MemoryStoreSize).value, 10))) {
	                MemoryStoreSize = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MemoryStoreSize).value, 10);
	            }
	            config.RateLimitSettings.MemoryStoreSize = MemoryStoreSize;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MemoryStoreSize).value = MemoryStoreSize;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'banner' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'banner__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'h4',
	                            { className: 'banner__heading' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.noteTitle',
	                                defaultMessage: 'Note:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.noteDescription',
	                                defaultMessage: 'Changing properties in this section will require a server restart before taking effect.'
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.rate.title',
	                        defaultMessage: 'Rate Limit Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableRateLimiter'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.enableLimiterTitle',
	                                defaultMessage: 'Enable Rate Limiter: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableRateLimiter',
	                                    value: 'true',
	                                    ref: 'EnableRateLimiter',
	                                    defaultChecked: this.props.config.RateLimitSettings.EnableRateLimiter,
	                                    onChange: this.handleChange.bind(this, 'EnableRateLimiterTrue')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableRateLimiter',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.RateLimitSettings.EnableRateLimiter,
	                                    onChange: this.handleChange.bind(this, 'EnableRateLimiterFalse')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.enableLimiterDescription',
	                                    defaultMessage: 'When true, APIs are throttled at rates specified below.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'PerSec'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.queriesTitle',
	                                defaultMessage: 'Number Of Queries Per Second:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'PerSec',
	                                ref: 'PerSec',
	                                placeholder: formatMessage(holders.queriesExample),
	                                defaultValue: this.props.config.RateLimitSettings.PerSec,
	                                onChange: this.handleChange,
	                                disabled: !this.state.EnableRateLimiter
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.queriesDescription',
	                                    defaultMessage: 'Throttles API at this number of requests per second.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'MemoryStoreSize'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.memoryTitle',
	                                defaultMessage: 'Memory Store Size:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'MemoryStoreSize',
	                                ref: 'MemoryStoreSize',
	                                placeholder: formatMessage(holders.memoryExample),
	                                defaultValue: this.props.config.RateLimitSettings.MemoryStoreSize,
	                                onChange: this.handleChange,
	                                disabled: !this.state.EnableRateLimiter
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.memoryDescription',
	                                    defaultMessage: 'Maximum number of users sessions connected to the system as determined by "Vary By Remote Address" and "Vary By Header" settings below.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'VaryByRemoteAddr'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.remoteTitle',
	                                defaultMessage: 'Vary By Remote Address: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'VaryByRemoteAddr',
	                                    value: 'true',
	                                    ref: 'VaryByRemoteAddr',
	                                    defaultChecked: this.props.config.RateLimitSettings.VaryByRemoteAddr,
	                                    onChange: this.handleChange.bind(this, 'VaryByRemoteAddrTrue'),
	                                    disabled: !this.state.EnableRateLimiter
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'VaryByRemoteAddr',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.RateLimitSettings.VaryByRemoteAddr,
	                                    onChange: this.handleChange.bind(this, 'VaryByRemoteAddrFalse'),
	                                    disabled: !this.state.EnableRateLimiter
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.remoteDescription',
	                                    defaultMessage: 'When true, rate limit API access by IP address.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'VaryByHeader'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.rate.httpHeaderTitle',
	                                defaultMessage: 'Vary By HTTP Header:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'VaryByHeader',
	                                ref: 'VaryByHeader',
	                                placeholder: formatMessage(holders.httpHeaderExample),
	                                defaultValue: this.props.config.RateLimitSettings.VaryByHeader,
	                                onChange: this.handleChange,
	                                disabled: !this.state.EnableRateLimiter || this.state.VaryByRemoteAddr
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.httpHeaderDescription',
	                                    defaultMessage: 'When filled in, vary rate limiting by HTTP header field specified (e.g. when configuring NGINX set to "X-Real-IP", when configuring AmazonELB set to "X-Forwarded-For").'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.rate.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RateSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	RateSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(RateSettings);

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    submit: {
	        id: 'admin.reset_password.submit',
	        defaultMessage: 'Please enter at least {chars} characters.'
	    }
	});
	
	
	
	var ResetPasswordModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ResetPasswordModal, _React$Component);
	
	    function ResetPasswordModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ResetPasswordModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ResetPasswordModal).call(this, props));
	
	        _this.doSubmit = _this.doSubmit.bind(_this);
	        _this.doCancel = _this.doCancel.bind(_this);
	
	        _this.state = {
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ResetPasswordModal, [{
	        key: 'doSubmit',
	        value: function doSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var password = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.password).value;
	
	            if (!password || password.length < /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH) {
	                this.setState({ serverError: this.props.intl.formatMessage(holders.submit, { chars: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH }) });
	                return;
	            }
	
	            this.setState({ serverError: null });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].adminResetPassword(this.props.user.id, password, function () {
	                _this2.props.onModalSubmit(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this2.refs.password).value);
	            }, function (err) {
	                _this2.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'doCancel',
	        value: function doCancel() {
	            this.setState({ serverError: null });
	            this.props.onModalDismissed();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var user = this.props.user;
	            if (user == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null);
	            }
	
	            var urlClass = 'input-group input-group--limit';
	            var serverError = null;
	
	            if (this.state.serverError) {
	                urlClass += ' has-error';
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'p',
	                        { className: 'input__help error' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var title = void 0;
	            if (user.auth_service) {
	                title = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                    id: 'admin.reset_password.titleSwitch',
	                    defaultMessage: 'Switch Account to Email/Password'
	                });
	            } else {
	                title = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                    id: 'admin.reset_password.titleReset',
	                    defaultMessage: 'Reset Password'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.doCancel
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Title,
	                        null,
	                        title
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        role: 'form',
	                        className: 'form-horizontal'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Body,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-10' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'div',
	                                    { className: urlClass },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'span',
	                                        {
	                                            'data-toggle': 'tooltip',
	                                            title: 'New Password',
	                                            className: 'input-group-addon'
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                            id: 'admin.reset_password.newPassword',
	                                            defaultMessage: 'New Password'
	                                        })
	                                    ),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                        type: 'password',
	                                        ref: 'password',
	                                        className: 'form-control',
	                                        maxLength: '22',
	                                        autoFocus: true,
	                                        tabIndex: '1'
	                                    })
	                                ),
	                                serverError
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Modal"].Footer,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-default',
	                                onClick: this.doCancel
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.reset_password.close',
	                                defaultMessage: 'Close'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'button',
	                            {
	                                onClick: this.doSubmit,
	                                type: 'submit',
	                                className: 'btn btn-primary',
	                                tabIndex: '2'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.reset_password.select',
	                                defaultMessage: 'Select'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResetPasswordModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	ResetPasswordModal.defaultProps = {
	    show: false
	};
	
	ResetPasswordModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object,
	    team: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.bool.isRequired,
	    onModalSubmit: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(ResetPasswordModal);

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var DefaultSessionLength = 30;
	var DefaultMaximumLoginAttempts = 10;
	var DefaultSessionCacheInMinutes = 10;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    listenExample: {
	        id: 'admin.service.listenExample',
	        defaultMessage: 'Ex ":8065"'
	    },
	    attemptExample: {
	        id: 'admin.service.attemptExample',
	        defaultMessage: 'Ex "10"'
	    },
	    segmentExample: {
	        id: 'admin.service.segmentExample',
	        defaultMessage: 'Ex "g3fgGOXJAQ43QV7rAh6iwQCkV4cA1Gs"'
	    },
	    googleExample: {
	        id: 'admin.service.googleExample',
	        defaultMessage: 'Ex "7rAh6iwQCkV4cA1Gsg3fgGOXJAQ43QV"'
	    },
	    sessionDaysEx: {
	        id: 'admin.service.sessionDaysEx',
	        defaultMessage: 'Ex "30"'
	    },
	    corsExample: {
	        id: 'admin.service.corsEx',
	        defaultMessage: 'http://example.com'
	    },
	    saving: {
	        id: 'admin.service.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var ServiceSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ServiceSettings, _React$Component);
	
	    function ServiceSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ServiceSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ServiceSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ServiceSettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.ServiceSettings.ListenAddress = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ListenAddress).value.trim();
	            if (config.ServiceSettings.ListenAddress === '') {
	                config.ServiceSettings.ListenAddress = ':8065';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.ListenAddress).value = config.ServiceSettings.ListenAddress;
	            }
	
	            config.ServiceSettings.SegmentDeveloperKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SegmentDeveloperKey).value.trim();
	            config.ServiceSettings.GoogleDeveloperKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.GoogleDeveloperKey).value.trim();
	            config.ServiceSettings.EnableIncomingWebhooks = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableIncomingWebhooks).checked;
	            config.ServiceSettings.EnableOutgoingWebhooks = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableOutgoingWebhooks).checked;
	            config.ServiceSettings.EnablePostUsernameOverride = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnablePostUsernameOverride).checked;
	            config.ServiceSettings.EnablePostIconOverride = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnablePostIconOverride).checked;
	            config.ServiceSettings.EnableTesting = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableTesting).checked;
	            config.ServiceSettings.EnableDeveloper = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableDeveloper).checked;
	            config.ServiceSettings.EnableSecurityFixAlert = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableSecurityFixAlert).checked;
	            config.ServiceSettings.EnableInsecureOutgoingConnections = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableInsecureOutgoingConnections).checked;
	            config.ServiceSettings.EnableCommands = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableCommands).checked;
	            config.ServiceSettings.EnableOnlyAdminIntegrations = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableOnlyAdminIntegrations).checked;
	
	            if (this.refs.EnableMultifactorAuthentication) {
	                config.ServiceSettings.EnableMultifactorAuthentication = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.EnableMultifactorAuthentication).checked;
	            }
	
	            //config.ServiceSettings.EnableOAuthServiceProvider = ReactDOM.findDOMNode(this.refs.EnableOAuthServiceProvider).checked;
	
	            var MaximumLoginAttempts = DefaultMaximumLoginAttempts;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaximumLoginAttempts).value, 10))) {
	                MaximumLoginAttempts = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaximumLoginAttempts).value, 10);
	            }
	            if (MaximumLoginAttempts < 1) {
	                MaximumLoginAttempts = 1;
	            }
	            config.ServiceSettings.MaximumLoginAttempts = MaximumLoginAttempts;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaximumLoginAttempts).value = MaximumLoginAttempts;
	
	            var SessionLengthWebInDays = DefaultSessionLength;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthWebInDays).value, 10))) {
	                SessionLengthWebInDays = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthWebInDays).value, 10);
	            }
	            if (SessionLengthWebInDays < 1) {
	                SessionLengthWebInDays = 1;
	            }
	            config.ServiceSettings.SessionLengthWebInDays = SessionLengthWebInDays;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthWebInDays).value = SessionLengthWebInDays;
	
	            var SessionLengthMobileInDays = DefaultSessionLength;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthMobileInDays).value, 10))) {
	                SessionLengthMobileInDays = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthMobileInDays).value, 10);
	            }
	            if (SessionLengthMobileInDays < 1) {
	                SessionLengthMobileInDays = 1;
	            }
	            config.ServiceSettings.SessionLengthMobileInDays = SessionLengthMobileInDays;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthMobileInDays).value = SessionLengthMobileInDays;
	
	            var SessionLengthSSOInDays = DefaultSessionLength;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthSSOInDays).value, 10))) {
	                SessionLengthSSOInDays = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthSSOInDays).value, 10);
	            }
	            if (SessionLengthSSOInDays < 1) {
	                SessionLengthSSOInDays = 1;
	            }
	            config.ServiceSettings.SessionLengthSSOInDays = SessionLengthSSOInDays;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionLengthSSOInDays).value = SessionLengthSSOInDays;
	
	            var SessionCacheInMinutes = DefaultSessionCacheInMinutes;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionCacheInMinutes).value, 10))) {
	                SessionCacheInMinutes = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionCacheInMinutes).value, 10);
	            }
	            if (SessionCacheInMinutes < -1) {
	                SessionCacheInMinutes = -1;
	            }
	            config.ServiceSettings.SessionCacheInMinutes = SessionCacheInMinutes;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.SessionCacheInMinutes).value = SessionCacheInMinutes;
	
	            config.ServiceSettings.AllowCorsFrom = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AllowCorsFrom).value.trim();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var mfaSetting = void 0;
	            if (global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.MFA === 'true') {
	                mfaSetting = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'EnableMultifactorAuthentication'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.service.mfaTitle',
	                            defaultMessage: 'Enable Multi-factor Authentication:'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'radio-inline' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'radio',
	                                name: 'EnableMultifactorAuthentication',
	                                value: 'true',
	                                ref: 'EnableMultifactorAuthentication',
	                                defaultChecked: this.props.config.ServiceSettings.EnableMultifactorAuthentication,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.true',
	                                defaultMessage: 'true'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'radio-inline' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'radio',
	                                name: 'EnableMultifactorAuthentication',
	                                value: 'false',
	                                defaultChecked: !this.props.config.ServiceSettings.EnableMultifactorAuthentication,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.false',
	                                defaultMessage: 'false'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.mfaDesc',
	                                defaultMessage: 'When true, users will be given the option to add multi-factor authentication to their account. They will need a smartphone and an authenticator app such as Google Authenticator.'
	                            })
	                        )
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.service.title',
	                        defaultMessage: 'Service Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'ListenAddress'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.listenAddress',
	                                defaultMessage: 'Listen Address:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'ListenAddress',
	                                ref: 'ListenAddress',
	                                placeholder: formatMessage(holders.listenExample),
	                                defaultValue: this.props.config.ServiceSettings.ListenAddress,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.listenDescription',
	                                    defaultMessage: 'The address to which to bind and listen. Entering ":8065" will bind to all interfaces or you can choose one like "127.0.0.1:8065".  Changing this will require a server restart before taking effect.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'MaximumLoginAttempts'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.attemptTitle',
	                                defaultMessage: 'Maximum Login Attempts:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'MaximumLoginAttempts',
	                                ref: 'MaximumLoginAttempts',
	                                placeholder: formatMessage(holders.attemptExample),
	                                defaultValue: this.props.config.ServiceSettings.MaximumLoginAttempts,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.attemptDescription',
	                                    defaultMessage: 'Login attempts allowed before user is locked out and required to reset password via email.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SegmentDeveloperKey'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.segmentTitle',
	                                defaultMessage: 'Segment Developer Key:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SegmentDeveloperKey',
	                                ref: 'SegmentDeveloperKey',
	                                placeholder: formatMessage(holders.segmentExample),
	                                defaultValue: this.props.config.ServiceSettings.SegmentDeveloperKey,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.segmentDescription',
	                                    defaultMessage: 'For users running a SaaS services, sign up for a key at Segment.com to track metrics.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'GoogleDeveloperKey'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.googleTitle',
	                                defaultMessage: 'Google Developer Key:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'GoogleDeveloperKey',
	                                ref: 'GoogleDeveloperKey',
	                                placeholder: formatMessage(holders.googleExample),
	                                defaultValue: this.props.config.ServiceSettings.GoogleDeveloperKey,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                                    id: 'admin.service.googleDescription',
	                                    defaultMessage: 'Set this key to enable embedding of YouTube video previews based on hyperlinks appearing in messages or comments. Instructions to obtain a key available at <a href="https://www.youtube.com/watch?v=Im69kzhpR3I" target="_blank">https://www.youtube.com/watch?v=Im69kzhpR3I</a>. Leaving the field blank disables the automatic generation of YouTube video previews from links.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableIncomingWebhooks'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.webhooksTitle',
	                                defaultMessage: 'Enable Incoming Webhooks: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableIncomingWebhooks',
	                                    value: 'true',
	                                    ref: 'EnableIncomingWebhooks',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableIncomingWebhooks,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableIncomingWebhooks',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableIncomingWebhooks,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.webhooksDescription',
	                                    defaultMessage: 'When true, incoming webhooks will be allowed. To help combat phishing attacks, all posts from webhooks will be labelled by a BOT tag.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableOutgoingWebhooks'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.outWebhooksTitle',
	                                defaultMessage: 'Enable Outgoing Webhooks: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableOutgoingWebhooks',
	                                    value: 'true',
	                                    ref: 'EnableOutgoingWebhooks',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableOutgoingWebhooks,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableOutgoingWebhooks',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableOutgoingWebhooks,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.outWebhooksDesc',
	                                    defaultMessage: 'When true, outgoing webhooks will be allowed.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableCommands'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.cmdsTitle',
	                                defaultMessage: 'Enable Slash Commands: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableCommands',
	                                    value: 'true',
	                                    ref: 'EnableCommands',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableCommands,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableCommands',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableCommands,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.cmdsDesc',
	                                    defaultMessage: 'When true, user created slash commands will be allowed.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableOnlyAdminIntegrations'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.integrationAdmin',
	                                defaultMessage: 'Enable Integrations for Admin Only: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableOnlyAdminIntegrations',
	                                    value: 'true',
	                                    ref: 'EnableOnlyAdminIntegrations',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableOnlyAdminIntegrations,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableOnlyAdminIntegrations',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableOnlyAdminIntegrations,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.integrationAdminDesc',
	                                    defaultMessage: 'When true, user created integrations can only be created by admins.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnablePostUsernameOverride'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.overrideTitle',
	                                defaultMessage: 'Enable Overriding Usernames from Webhooks and Slash Commands: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnablePostUsernameOverride',
	                                    value: 'true',
	                                    ref: 'EnablePostUsernameOverride',
	                                    defaultChecked: this.props.config.ServiceSettings.EnablePostUsernameOverride,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnablePostUsernameOverride',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnablePostUsernameOverride,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.overrideDescription',
	                                    defaultMessage: 'When true, webhooks and slash commands will be allowed to change the username they are posting as. Note, combined with allowing icon overriding, this could open users up to phishing attacks.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnablePostIconOverride'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.iconTitle',
	                                defaultMessage: 'Enable Overriding Icon from Webhooks and Slash Commands: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnablePostIconOverride',
	                                    value: 'true',
	                                    ref: 'EnablePostIconOverride',
	                                    defaultChecked: this.props.config.ServiceSettings.EnablePostIconOverride,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnablePostIconOverride',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnablePostIconOverride,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.iconDescription',
	                                    defaultMessage: 'When true, webhooks and slash commands will be allowed to change the icon they post with. Note, combined with allowing username overriding, this could open users up to phishing attacks.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableTesting'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.testingTitle',
	                                defaultMessage: 'Enable Testing: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableTesting',
	                                    value: 'true',
	                                    ref: 'EnableTesting',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableTesting,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableTesting',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableTesting,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.testingDescription',
	                                    defaultMessage: '(Developer Option) When true, /loadtest slash command is enabled to load test accounts and test data. Changing this will require a server restart before taking effect.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableDeveloper'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.developerTitle',
	                                defaultMessage: 'Enable Developer Mode: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableDeveloper',
	                                    value: 'true',
	                                    ref: 'EnableDeveloper',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableDeveloper,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableDeveloper',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableDeveloper,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.developerDesc',
	                                    defaultMessage: '(Developer Option) When true, extra information around errors will be displayed in the UI.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableSecurityFixAlert'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.securityTitle',
	                                defaultMessage: 'Enable Security Alerts: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableSecurityFixAlert',
	                                    value: 'true',
	                                    ref: 'EnableSecurityFixAlert',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableSecurityFixAlert,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableSecurityFixAlert',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableSecurityFixAlert,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.securityDesc',
	                                    defaultMessage: 'When true, System Administrators are notified by email if a relevant security fix alert has been announced in the last 12 hours. Requires email to be enabled.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableInsecureOutgoingConnections'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.insecureTlsTitle',
	                                defaultMessage: 'Enable Insecure Outgoing Connections: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableInsecureOutgoingConnections',
	                                    value: 'true',
	                                    ref: 'EnableInsecureOutgoingConnections',
	                                    defaultChecked: this.props.config.ServiceSettings.EnableInsecureOutgoingConnections,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableInsecureOutgoingConnections',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.ServiceSettings.EnableInsecureOutgoingConnections,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.insecureTlsDesc',
	                                    defaultMessage: 'When true, any outgoing HTTPS requests will accept unverified, self-signed certificates. For example, outgoing webhooks to a server with a self-signed TLS certificate, using any domain, will be allowed. Note that this makes these connections susceptible to man-in-the-middle attacks.'
	                                })
	                            )
	                        )
	                    ),
	                    mfaSetting,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AllowCorsFrom'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.corsTitle',
	                                defaultMessage: 'Allow Cross-origin Requests from:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AllowCorsFrom',
	                                ref: 'AllowCorsFrom',
	                                placeholder: formatMessage(holders.corsExample),
	                                defaultValue: this.props.config.ServiceSettings.AllowCorsFrom,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.corsDescription',
	                                    defaultMessage: 'Enable HTTP Cross origin request from a specific domain. Use "*" if you want to allow CORS from any domain or leave it blank to disable it.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SessionLengthWebInDays'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.webSessionDays',
	                                defaultMessage: 'Session Length for Web in Days:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SessionLengthWebInDays',
	                                ref: 'SessionLengthWebInDays',
	                                placeholder: formatMessage(holders.sessionDaysEx),
	                                defaultValue: this.props.config.ServiceSettings.SessionLengthWebInDays,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.webSessionDaysDesc',
	                                    defaultMessage: 'The web session will expire after the number of days specified and will require a user to login again.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SessionLengthMobileInDays'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.mobileSessionDays',
	                                defaultMessage: 'Session Length for Mobile Device in Days:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SessionLengthMobileInDays',
	                                ref: 'SessionLengthMobileInDays',
	                                placeholder: formatMessage(holders.sessionDaysEx),
	                                defaultValue: this.props.config.ServiceSettings.SessionLengthMobileInDays,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.mobileSessionDaysDesc',
	                                    defaultMessage: 'The native mobile session will expire after the number of days specified and will require a user to login again.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SessionLengthSSOInDays'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.ssoSessionDays',
	                                defaultMessage: 'Session Length for SSO in Days:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SessionLengthSSOInDays',
	                                ref: 'SessionLengthSSOInDays',
	                                placeholder: formatMessage(holders.sessionDaysEx),
	                                defaultValue: this.props.config.ServiceSettings.SessionLengthSSOInDays,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.ssoSessionDaysDesc',
	                                    defaultMessage: 'The SSO session will expire after the number of days specified and will require a user to login again.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SessionCacheInMinutes'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.service.sessionCache',
	                                defaultMessage: 'Session Cache in Minutes:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SessionCacheInMinutes',
	                                ref: 'SessionCacheInMinutes',
	                                placeholder: formatMessage(holders.sessionDaysEx),
	                                defaultValue: this.props.config.ServiceSettings.SessionCacheInMinutes,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.sessionCacheDesc',
	                                    defaultMessage: 'The number of minutes to cache a session in memory.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.service.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ServiceSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	// <div className='form-group'>
	//     <label
	//         className='control-label col-sm-4'
	//         htmlFor='EnableOAuthServiceProvider'
	//     >
	//         {'Enable OAuth Service Provider: '}
	//     </label>
	//     <div className='col-sm-8'>
	//         <label className='radio-inline'>
	//             <input
	//                 type='radio'
	//                 name='EnableOAuthServiceProvider'
	//                 value='true'
	//                 ref='EnableOAuthServiceProvider'
	//                 defaultChecked={this.props.config.ServiceSettings.EnableOAuthServiceProvider}
	//                 onChange={this.handleChange}
	//             />
	//                 {'true'}
	//         </label>
	//         <label className='radio-inline'>
	//             <input
	//                 type='radio'
	//                 name='EnableOAuthServiceProvider'
	//                 value='false'
	//                 defaultChecked={!this.props.config.ServiceSettings.EnableOAuthServiceProvider}
	//                 onChange={this.handleChange}
	//             />
	//                 {'false'}
	//         </label>
	//         <p className='help-text'>{'When enabled Mattermost will act as an OAuth2 Provider.  Changing this will require a server restart before taking effect.'}</p>
	//     </div>
	// </div>
	
	ServiceSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(ServiceSettings);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_crypto__ = __webpack_require__(215);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_crypto___default = __WEBPACK_IMPORTED_MODULE_9_crypto__ && __WEBPACK_IMPORTED_MODULE_9_crypto__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_crypto__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_crypto__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_crypto___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_crypto___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    warning: {
	        id: 'admin.sql.warning',
	        defaultMessage: 'Warning: re-generating this salt may cause some columns in the database to return empty results.'
	    },
	    maxConnectionsExample: {
	        id: 'admin.sql.maxConnectionsExample',
	        defaultMessage: 'Ex "10"'
	    },
	    maxOpenExample: {
	        id: 'admin.sql.maxOpenExample',
	        defaultMessage: 'Ex "10"'
	    },
	    keyExample: {
	        id: 'admin.sql.keyExample',
	        defaultMessage: 'Ex "gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6"'
	    },
	    saving: {
	        id: 'admin.sql.saving',
	        defaultMessage: 'Saving Config...'
	    }
	});
	
	
	
	var SqlSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SqlSettings, _React$Component);
	
	    function SqlSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SqlSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SqlSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleGenerate = _this.handleGenerate.bind(_this);
	
	        _this.state = {
	            saveNeeded: false,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SqlSettings, [{
	        key: 'handleChange',
	        value: function handleChange() {
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.SqlSettings.Trace = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.Trace).checked;
	            config.SqlSettings.AtRestEncryptKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AtRestEncryptKey).value.trim();
	
	            if (config.SqlSettings.AtRestEncryptKey === '') {
	                config.SqlSettings.AtRestEncryptKey = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AtRestEncryptKey).value = config.SqlSettings.AtRestEncryptKey;
	            }
	
	            var MaxOpenConns = 10;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaxOpenConns).value, 10))) {
	                MaxOpenConns = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaxOpenConns).value, 10);
	            }
	            config.SqlSettings.MaxOpenConns = MaxOpenConns;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaxOpenConns).value = MaxOpenConns;
	
	            var MaxIdleConns = 10;
	            if (!isNaN(parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaxIdleConns).value, 10))) {
	                MaxIdleConns = parseInt(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaxIdleConns).value, 10);
	            }
	            config.SqlSettings.MaxIdleConns = MaxIdleConns;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.MaxIdleConns).value = MaxIdleConns;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getConfig();
	                _this2.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this2.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'handleGenerate',
	        value: function handleGenerate(e) {
	            e.preventDefault();
	
	            var cfm = global.window.confirm(this.props.intl.formatMessage(holders.warning));
	            if (cfm === false) {
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.AtRestEncryptKey).value = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_crypto___default.a.randomBytes(256).toString('base64').substring(0, 32);
	            var s = { saveNeeded: true, serverError: this.state.serverError };
	            this.setState(s);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var dataSource = '**********' + this.props.config.SqlSettings.DataSource.substring(this.props.config.SqlSettings.DataSource.indexOf('@'));
	
	            var dataSourceReplicas = '';
	            this.props.config.SqlSettings.DataSourceReplicas.forEach(function (replica) {
	                dataSourceReplicas += '[**********' + replica.substring(replica.indexOf('@')) + '] ';
	            });
	
	            if (this.props.config.SqlSettings.DataSourceReplicas.length === 0) {
	                dataSourceReplicas = 'none';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'banner' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'banner__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'h4',
	                            { className: 'banner__heading' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.noteTitle',
	                                defaultMessage: 'Note:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.noteDescription',
	                                defaultMessage: 'Changing properties in this section will require a server restart before taking effect.'
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'admin.sql.title',
	                        defaultMessage: 'SQL Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'DriverName'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.driverName',
	                                defaultMessage: 'Driver Name:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                this.props.config.SqlSettings.DriverName
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'DataSource'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.dataSource',
	                                defaultMessage: 'Data Source:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                dataSource
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'DataSourceReplicas'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.replicas',
	                                defaultMessage: 'Data Source Replicas:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                dataSourceReplicas
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'MaxIdleConns'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.maxConnectionsTitle',
	                                defaultMessage: 'Maximum Idle Connections:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'MaxIdleConns',
	                                ref: 'MaxIdleConns',
	                                placeholder: formatMessage(holders.maxConnectionsExample),
	                                defaultValue: this.props.config.SqlSettings.MaxIdleConns,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.maxConnectionsDescription',
	                                    defaultMessage: 'Maximum number of idle connections held open to the database.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'MaxOpenConns'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.maxOpenTitle',
	                                defaultMessage: 'Maximum Open Connections:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'MaxOpenConns',
	                                ref: 'MaxOpenConns',
	                                placeholder: formatMessage(holders.maxOpenExample),
	                                defaultValue: this.props.config.SqlSettings.MaxOpenConns,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.maxOpenDescription',
	                                    defaultMessage: 'Maximum number of open connections held open to the database.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'AtRestEncryptKey'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.keyTitle',
	                                defaultMessage: 'At Rest Encrypt Key:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'AtRestEncryptKey',
	                                ref: 'AtRestEncryptKey',
	                                placeholder: formatMessage(holders.keyExample),
	                                defaultValue: this.props.config.SqlSettings.AtRestEncryptKey,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.keyDescription',
	                                    defaultMessage: '32-character salt available to encrypt and decrypt sensitive fields in database.'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'div',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-default',
	                                        onClick: this.handleGenerate
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'admin.sql.regenerate',
	                                        defaultMessage: 'Re-Generate'
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'Trace'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'admin.sql.traceTitle',
	                                defaultMessage: 'Trace: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Trace',
	                                    value: 'true',
	                                    ref: 'Trace',
	                                    defaultChecked: this.props.config.SqlSettings.Trace,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'Trace',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.SqlSettings.Trace,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.traceDescription',
	                                    defaultMessage: '(Development Mode) When true, executing SQL statements are written to the log.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'admin.sql.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SqlSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	SqlSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(SqlSettings);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    siteNameExample: {
	        id: 'admin.team.siteNameExample',
	        defaultMessage: 'Ex "Mattermost"'
	    },
	    maxUsersExample: {
	        id: 'admin.team.maxUsersExample',
	        defaultMessage: 'Ex "25"'
	    },
	    restrictExample: {
	        id: 'admin.team.restrictExample',
	        defaultMessage: 'Ex "corp.mattermost.com, mattermost.org"'
	    },
	    saving: {
	        id: 'admin.team.saving',
	        defaultMessage: 'Saving Config...'
	    },
	    restrictDirectMessageAny: {
	        id: 'admin.team.restrict_direct_message_any',
	        defaultMessage: 'Any user on the Mattermost server'
	    },
	    restrictDirectMessageTeam: {
	        id: 'admin.team.restrict_direct_message_team',
	        defaultMessage: 'Any member of the team'
	    }
	});
	
	
	
	var ENABLE_BRAND_ACTION = 'enable_brand_action';
	var DISABLE_BRAND_ACTION = 'disable_brand_action';
	
	var TeamSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamSettings, _React$Component);
	
	    function TeamSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamSettings).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleImageChange = _this.handleImageChange.bind(_this);
	        _this.handleImageSubmit = _this.handleImageSubmit.bind(_this);
	
	        _this.uploading = false;
	        _this.timestamp = 0;
	
	        _this.state = {
	            saveNeeded: false,
	            brandImageExists: false,
	            enableCustomBrand: _this.props.config.TeamSettings.EnableCustomBrand,
	            restrictDirectMessage: _this.props.config.TeamSettings.RestrictDirectMessage,
	            serverError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamSettings, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            if (global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.CustomBrand === 'true') {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.get(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].getAdminRoute() + '/get_brand_image').done(function () {
	                    return _this2.setState({ brandImageExists: true });
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _this3 = this;
	
	            if (this.refs.image) {
	                (function () {
	                    var reader = new FileReader();
	
	                    var img = _this3.refs.image;
	                    reader.onload = function (e) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(img).attr('src', e.target.result);
	                    };
	
	                    reader.readAsDataURL(_this3.state.brandImage);
	                })();
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(action) {
	            var s = { saveNeeded: true };
	
	            if (action === ENABLE_BRAND_ACTION) {
	                s.enableCustomBrand = true;
	            }
	
	            if (action === DISABLE_BRAND_ACTION) {
	                s.enableCustomBrand = false;
	            }
	
	            this.setState(s);
	        }
	    }, {
	        key: 'handleImageChange',
	        value: function handleImageChange() {
	            var element = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this.refs.fileInput);
	            if (element.prop('files').length > 0) {
	                this.setState({ fileSelected: true, brandImage: element.prop('files')[0] });
	            }
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('reset');
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this4 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('loading');
	
	            var config = this.props.config;
	            config.TeamSettings.SiteName = this.refs.SiteName.value.trim();
	            config.TeamSettings.RestrictCreationToDomains = this.refs.RestrictCreationToDomains.value.trim();
	            config.TeamSettings.EnableTeamCreation = this.refs.EnableTeamCreation.checked;
	            config.TeamSettings.EnableUserCreation = this.refs.EnableUserCreation.checked;
	            config.TeamSettings.EnableOpenServer = this.refs.EnableOpenServer.checked;
	            config.TeamSettings.RestrictTeamNames = this.refs.RestrictTeamNames.checked;
	            config.TeamSettings.RestrictDirectMessage = this.refs.RestrictDirectMessage.value.trim();
	
	            if (this.refs.EnableCustomBrand) {
	                config.TeamSettings.EnableCustomBrand = this.refs.EnableCustomBrand.checked;
	            }
	
	            if (this.refs.CustomBrandText) {
	                config.TeamSettings.CustomBrandText = this.refs.CustomBrandText.value;
	            }
	
	            var MaxUsersPerTeam = 50;
	            if (!isNaN(parseInt(this.refs.MaxUsersPerTeam.value, 10))) {
	                MaxUsersPerTeam = parseInt(this.refs.MaxUsersPerTeam.value, 10);
	            }
	            config.TeamSettings.MaxUsersPerTeam = MaxUsersPerTeam;
	            this.refs.MaxUsersPerTeam.value = MaxUsersPerTeam;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].saveConfig(config, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.getConfig();
	                _this4.setState({
	                    serverError: null,
	                    saveNeeded: false
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            }, function (err) {
	                _this4.setState({
	                    serverError: err.message,
	                    saveNeeded: true
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#save-button').button('reset');
	            });
	        }
	    }, {
	        key: 'handleImageSubmit',
	        value: function handleImageSubmit(e) {
	            var _this5 = this;
	
	            e.preventDefault();
	
	            if (!this.state.brandImage) {
	                return;
	            }
	
	            if (this.uploading) {
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('loading');
	            this.uploading = true;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].uploadBrandImage(this.state.brandImage, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('complete');
	                _this5.timestamp = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTimestamp();
	                _this5.setState({ brandImageExists: true, brandImage: null });
	                _this5.uploading = false;
	            }, function (err) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#upload-button').button('reset');
	                _this5.uploading = false;
	                _this5.setState({ serverImageError: err.message });
	            });
	        }
	    }, {
	        key: 'createBrandSettings',
	        value: function createBrandSettings() {
	            var btnClass = 'btn';
	            if (this.state.fileSelected) {
	                btnClass = 'btn btn-primary';
	            }
	
	            var serverImageError = '';
	            if (this.state.serverImageError) {
	                serverImageError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverImageError
	                    )
	                );
	            }
	
	            var uploadImage = void 0;
	            var uploadText = void 0;
	            if (this.state.enableCustomBrand) {
	                var img = void 0;
	                if (this.state.brandImage) {
	                    img = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
	                        ref: 'image',
	                        className: 'brand-img',
	                        src: ''
	                    });
	                } else if (this.state.brandImageExists) {
	                    img = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
	                        className: 'brand-img',
	                        src: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].getAdminRoute() + '/get_brand_image?t=' + this.timestamp
	                    });
	                } else {
	                    img = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.team.noBrandImage',
	                            defaultMessage: 'No brand image uploaded'
	                        })
	                    );
	                }
	
	                uploadImage = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'CustomBrandImage'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.team.brandImageTitle',
	                            defaultMessage: 'Custom Brand Image:'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        img
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', { className: 'col-sm-4' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'file__upload' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                { className: 'btn btn-default' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.chooseImage',
	                                    defaultMessage: 'Choose New Image'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                ref: 'fileInput',
	                                type: 'file',
	                                accept: '.jpg,.png,.bmp',
	                                onChange: this.handleImageChange
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'button',
	                            {
	                                className: btnClass,
	                                disabled: !this.state.fileSelected,
	                                onClick: this.handleImageSubmit,
	                                id: 'upload-button',
	                                'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.team.uploading', 'Uploading..'),
	                                'data-complete-text': '<span class=\'glyphicon glyphicon-ok\'></span> ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('admin.team.uploaded', 'Uploaded!')
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.upload',
	                                defaultMessage: 'Upload'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                        serverImageError,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text no-margin' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                                id: 'admin.team.uploadDesc',
	                                defaultMessage: 'Customize your user experience by adding a custom image to your login screen. See examples at <a href="http://docs.mattermost.com/administration/config-settings.html#custom-branding" target="_blank">docs.mattermost.com/administration/config-settings.html#custom-branding</a>.'
	                            })
	                        )
	                    )
	                );
	
	                uploadText = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'CustomBrandText'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.team.brandTextTitle',
	                            defaultMessage: 'Custom Brand Text:'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'textarea',
	                            {
	                                type: 'text',
	                                rows: '5',
	                                maxLength: '1024',
	                                className: 'form-control admin-textarea',
	                                id: 'CustomBrandText',
	                                ref: 'CustomBrandText',
	                                onChange: this.handleChange
	                            },
	                            this.props.config.TeamSettings.CustomBrandText
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.brandTextDescription',
	                                defaultMessage: 'The custom branding Markdown-formatted text you would like to appear below your custom brand image on your login sreen.'
	                            })
	                        )
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'EnableCustomBrand'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.team.brandTitle',
	                            defaultMessage: 'Enable Custom Branding: '
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'radio-inline' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'radio',
	                                name: 'EnableCustomBrand',
	                                value: 'true',
	                                ref: 'EnableCustomBrand',
	                                defaultChecked: this.props.config.TeamSettings.EnableCustomBrand,
	                                onChange: this.handleChange.bind(this, ENABLE_BRAND_ACTION)
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.true',
	                                defaultMessage: 'true'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'radio-inline' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'radio',
	                                name: 'EnableCustomBrand',
	                                value: 'false',
	                                defaultChecked: !this.props.config.TeamSettings.EnableCustomBrand,
	                                onChange: this.handleChange.bind(this, DISABLE_BRAND_ACTION)
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.false',
	                                defaultMessage: 'false'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'p',
	                            { className: 'help-text' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.brandDesc',
	                                defaultMessage: 'Enable custom branding to show an image of your choice, uploaded below, and some help text, written below, on the login page.'
	                            })
	                        )
	                    )
	                ),
	                uploadImage,
	                uploadText
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var saveClass = 'btn';
	            if (this.state.saveNeeded) {
	                saveClass = 'btn btn-primary';
	            }
	
	            var brand = void 0;
	            if (global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.CustomBrand === 'true') {
	                brand = this.createBrandSettings();
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.team.title',
	                        defaultMessage: 'Team Settings'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'SiteName'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.siteNameTitle',
	                                defaultMessage: 'Site Name:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'SiteName',
	                                ref: 'SiteName',
	                                placeholder: formatMessage(holders.siteNameExample),
	                                defaultValue: this.props.config.TeamSettings.SiteName,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.siteNameDescription',
	                                    defaultMessage: 'Name of service shown in login screens and UI.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'MaxUsersPerTeam'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.maxUsersTitle',
	                                defaultMessage: 'Max Users Per Team:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'MaxUsersPerTeam',
	                                ref: 'MaxUsersPerTeam',
	                                placeholder: formatMessage(holders.maxUsersExample),
	                                defaultValue: this.props.config.TeamSettings.MaxUsersPerTeam,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.maxUsersDescription',
	                                    defaultMessage: 'Maximum total number of users per team, including both active and inactive users.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableTeamCreation'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.teamCreationTitle',
	                                defaultMessage: 'Enable Team Creation: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableTeamCreation',
	                                    value: 'true',
	                                    ref: 'EnableTeamCreation',
	                                    defaultChecked: this.props.config.TeamSettings.EnableTeamCreation,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableTeamCreation',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.TeamSettings.EnableTeamCreation,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.teamCreationDescription',
	                                    defaultMessage: 'When false, the ability to create teams is disabled. The create team button displays error when pressed.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableUserCreation'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.userCreationTitle',
	                                defaultMessage: 'Enable User Creation: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableUserCreation',
	                                    value: 'true',
	                                    ref: 'EnableUserCreation',
	                                    defaultChecked: this.props.config.TeamSettings.EnableUserCreation,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableUserCreation',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.TeamSettings.EnableUserCreation,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.userCreationDescription',
	                                    defaultMessage: 'When false, the ability to create accounts is disabled. The create account button displays error when pressed.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'EnableOpenServer'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.openServerTitle',
	                                defaultMessage: 'Enable Open Server: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableOpenServer',
	                                    value: 'true',
	                                    ref: 'EnableOpenServer',
	                                    defaultChecked: this.props.config.TeamSettings.EnableOpenServer,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'EnableOpenServer',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.TeamSettings.EnableOpenServer,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.openServerDescription',
	                                    defaultMessage: 'When true, anyone can signup for a user account on this server without the need to be invited.'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'RestrictCreationToDomains'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.restrictTitle',
	                                defaultMessage: 'Restrict Creation To Domains:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                type: 'text',
	                                className: 'form-control',
	                                id: 'RestrictCreationToDomains',
	                                ref: 'RestrictCreationToDomains',
	                                placeholder: formatMessage(holders.restrictExample),
	                                defaultValue: this.props.config.TeamSettings.RestrictCreationToDomains,
	                                onChange: this.handleChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.restrictDescription',
	                                    defaultMessage: 'Teams and user accounts can only be created from a specific domain (e.g. "mattermost.org") or list of comma-separated domains (e.g. "corp.mattermost.com, mattermost.org").'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'RestrictTeamNames'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.restrictNameTitle',
	                                defaultMessage: 'Restrict Team Names: '
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'RestrictTeamNames',
	                                    value: 'true',
	                                    ref: 'RestrictTeamNames',
	                                    defaultChecked: this.props.config.TeamSettings.RestrictTeamNames,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.true',
	                                    defaultMessage: 'true'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'radio-inline' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'radio',
	                                    name: 'RestrictTeamNames',
	                                    value: 'false',
	                                    defaultChecked: !this.props.config.TeamSettings.RestrictTeamNames,
	                                    onChange: this.handleChange
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.false',
	                                    defaultMessage: 'false'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.restrictNameDesc',
	                                    defaultMessage: 'When true, You cannot create a team name with reserved words like www, admin, support, test, channel, etc'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            {
	                                className: 'control-label col-sm-4',
	                                htmlFor: 'restrictDirectMessage'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'admin.team.restrictDirectMessage',
	                                defaultMessage: 'Enable users to open Direct Message channels with:'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-8' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'select',
	                                {
	                                    className: 'form-control',
	                                    id: 'restrictDirectMessage',
	                                    ref: 'RestrictDirectMessage',
	                                    defaultValue: this.props.config.TeamSettings.RestrictDirectMessage,
	                                    onChange: this.handleChange.bind(this, 'restrictDirectMessage')
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'any' },
	                                    formatMessage(holders.restrictDirectMessageAny)
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'option',
	                                    { value: 'team' },
	                                    formatMessage(holders.restrictDirectMessageTeam)
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                { className: 'help-text' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                                    id: 'admin.team.restrictDirectMessageDesc',
	                                    defaultMessage: '"Any user on the Mattermost server" enables users to open a Direct Message channel with any user on the server, even if they are not on any teams together. "Any member of the team" limits the ability to open Direct Message channels to only users who are in the same team.'
	                                })
	                            )
	                        )
	                    ),
	                    brand,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            serverError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    disabled: !this.state.saveNeeded,
	                                    type: 'submit',
	                                    className: saveClass,
	                                    onClick: this.handleSubmit,
	                                    id: 'save-button',
	                                    'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + formatMessage(holders.saving)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'admin.team.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeamSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	TeamSettings.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    config: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(TeamSettings);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_item_jsx__ = __webpack_require__(663);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reset_password_modal_jsx__ = __webpack_require__(658);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var UserList = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UserList, _React$Component);
	
	    function UserList(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserList);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserList).call(this, props));
	
	        _this.getTeamProfiles = _this.getTeamProfiles.bind(_this);
	        _this.getCurrentTeamProfiles = _this.getCurrentTeamProfiles.bind(_this);
	        _this.doPasswordReset = _this.doPasswordReset.bind(_this);
	        _this.doPasswordResetDismiss = _this.doPasswordResetDismiss.bind(_this);
	        _this.doPasswordResetSubmit = _this.doPasswordResetSubmit.bind(_this);
	        _this.getTeamMemberForUser = _this.getTeamMemberForUser.bind(_this);
	
	        _this.state = {
	            teamId: props.team.id,
	            users: null,
	            teamMembers: null,
	            serverError: null,
	            showPasswordModal: false,
	            user: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UserList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getCurrentTeamProfiles();
	        }
	    }, {
	        key: 'getCurrentTeamProfiles',
	        value: function getCurrentTeamProfiles() {
	            this.getTeamProfiles(this.props.team.id);
	        }
	    }, {
	        key: 'getTeamProfiles',
	        value: function getTeamProfiles(teamId) {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].getTeamMembers(teamId, function (data) {
	                _this2.setState({
	                    teamMembers: data
	                });
	            }, function (err) {
	                _this2.setState({
	                    teamMembers: null,
	                    serverError: err.message
	                });
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].getProfilesForTeam(teamId, function (users) {
	                var memberList = [];
	                for (var id in users) {
	                    if (users.hasOwnProperty(id)) {
	                        memberList.push(users[id]);
	                    }
	                }
	
	                memberList.sort(function (a, b) {
	                    if (a.username < b.username) {
	                        return -1;
	                    }
	
	                    if (a.username > b.username) {
	                        return 1;
	                    }
	
	                    return 0;
	                });
	
	                _this2.setState({
	                    users: memberList
	                });
	            }, function (err) {
	                _this2.setState({
	                    users: null,
	                    serverError: err.message
	                });
	            });
	        }
	    }, {
	        key: 'doPasswordReset',
	        value: function doPasswordReset(user) {
	            this.setState({
	                showPasswordModal: true,
	                user: user
	            });
	        }
	    }, {
	        key: 'doPasswordResetDismiss',
	        value: function doPasswordResetDismiss() {
	            this.setState({
	                showPasswordModal: false,
	                user: null
	            });
	        }
	    }, {
	        key: 'doPasswordResetSubmit',
	        value: function doPasswordResetSubmit() {
	            this.getCurrentTeamProfiles();
	            this.setState({
	                showPasswordModal: false,
	                user: null
	            });
	        }
	    }, {
	        key: 'getTeamMemberForUser',
	        value: function getTeamMemberForUser(userId) {
	            if (this.state.teamMembers) {
	                for (var index in this.state.teamMembers) {
	                    if (this.state.teamMembers.hasOwnProperty(index)) {
	                        var teamMember = this.state.teamMembers[index];
	
	                        if (teamMember.user_id === userId) {
	                            return teamMember;
	                        }
	                    }
	                }
	            }
	
	            return null;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            this.getTeamProfiles(newProps.team.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var serverError = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            if (this.state.users == null || this.state.teamMembers == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'wrapper--fixed' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'h3',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'admin.userList.title',
	                            defaultMessage: 'Users for {team}',
	                            values: {
	                                team: this.props.team.name
	                            }
	                        })
	                    ),
	                    serverError,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__["a"], null)
	                );
	            }
	
	            var memberList = this.state.users.map(function (user) {
	                var teamMember = _this3.getTeamMemberForUser(user.id);
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__user_item_jsx__["a"], {
	                    team: _this3.props.team,
	                    key: 'user_' + user.id,
	                    user: user,
	                    teamMember: teamMember,
	                    refreshProfiles: _this3.getCurrentTeamProfiles,
	                    doPasswordReset: _this3.doPasswordReset
	                });
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'admin.userList.title2',
	                        defaultMessage: 'Users for {team} ({count})',
	                        values: {
	                            team: this.props.team.name,
	                            count: this.state.users.length
	                        }
	                    })
	                ),
	                serverError,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'form',
	                    {
	                        className: 'form-horizontal',
	                        role: 'form'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'more-modal__list member-list-holder' },
	                        memberList
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__reset_password_modal_jsx__["a"], {
	                    user: this.state.user,
	                    show: this.state.showPasswordModal,
	                    team: this.props.team,
	                    onModalSubmit: this.doPasswordResetSubmit,
	                    onModalDismissed: this.doPasswordResetDismiss
	                })
	            );
	        }
	    }]);
	
	    return UserList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UserList;
	
	
	UserList.propTypes = {
	    team: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object
	};

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__confirm_modal_jsx__ = __webpack_require__(186);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router___default = __WEBPACK_IMPORTED_MODULE_12_react_router__ && __WEBPACK_IMPORTED_MODULE_12_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	var UserItem = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UserItem, _React$Component);
	
	    function UserItem(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserItem);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserItem).call(this, props));
	
	        _this.handleMakeMember = _this.handleMakeMember.bind(_this);
	        _this.handleMakeActive = _this.handleMakeActive.bind(_this);
	        _this.handleMakeNotActive = _this.handleMakeNotActive.bind(_this);
	        _this.handleMakeAdmin = _this.handleMakeAdmin.bind(_this);
	        _this.handleMakeSystemAdmin = _this.handleMakeSystemAdmin.bind(_this);
	        _this.handleResetPassword = _this.handleResetPassword.bind(_this);
	        _this.handleResetMfa = _this.handleResetMfa.bind(_this);
	        _this.handleDemote = _this.handleDemote.bind(_this);
	        _this.handleDemoteSubmit = _this.handleDemoteSubmit.bind(_this);
	        _this.handleDemoteCancel = _this.handleDemoteCancel.bind(_this);
	
	        _this.state = {
	            serverError: null,
	            showDemoteModal: false,
	            user: null,
	            role: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UserItem, [{
	        key: 'handleMakeMember',
	        value: function handleMakeMember(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser();
	            if (this.props.user.id === me.id) {
	                this.handleDemote(this.props.user, '');
	            } else {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].updateRoles(this.props.team.id, this.props.user.id, '', function () {
	                    _this2.props.refreshProfiles();
	                }, function (err) {
	                    _this2.setState({ serverError: err.message });
	                });
	            }
	        }
	    }, {
	        key: 'handleMakeActive',
	        value: function handleMakeActive(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].updateActive(this.props.user.id, true, function () {
	                _this3.props.refreshProfiles();
	            }, function (err) {
	                _this3.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleMakeNotActive',
	        value: function handleMakeNotActive(e) {
	            var _this4 = this;
	
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].updateActive(this.props.user.id, false, function () {
	                _this4.props.refreshProfiles();
	            }, function (err) {
	                _this4.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleMakeAdmin',
	        value: function handleMakeAdmin(e) {
	            var _this5 = this;
	
	            e.preventDefault();
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser();
	            if (this.props.user.id === me.id) {
	                this.handleDemote(this.props.user, 'admin');
	            } else {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].updateRoles(this.props.team.id, this.props.user.id, 'admin', function () {
	                    _this5.props.refreshProfiles();
	                }, function (err) {
	                    _this5.setState({ serverError: err.message });
	                });
	            }
	        }
	    }, {
	        key: 'handleMakeSystemAdmin',
	        value: function handleMakeSystemAdmin(e) {
	            var _this6 = this;
	
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].updateRoles(this.props.team.id, this.props.user.id, 'system_admin', function () {
	                _this6.props.refreshProfiles();
	            }, function (err) {
	                _this6.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleResetPassword',
	        value: function handleResetPassword(e) {
	            e.preventDefault();
	            this.props.doPasswordReset(this.props.user);
	        }
	    }, {
	        key: 'handleResetMfa',
	        value: function handleResetMfa(e) {
	            var _this7 = this;
	
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].adminResetMfa(this.props.user.id, function () {
	                _this7.props.refreshProfiles();
	            }, function (err) {
	                _this7.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleDemote',
	        value: function handleDemote(user, role) {
	            this.setState({
	                serverError: this.state.serverError,
	                showDemoteModal: true,
	                user: user,
	                role: role
	            });
	        }
	    }, {
	        key: 'handleDemoteCancel',
	        value: function handleDemoteCancel() {
	            this.setState({
	                serverError: null,
	                showDemoteModal: false,
	                user: null,
	                role: null
	            });
	        }
	    }, {
	        key: 'handleDemoteSubmit',
	        value: function handleDemoteSubmit() {
	            var _this8 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].updateRoles(this.props.team.id, this.props.user.id, this.state.role, function () {
	                _this8.props.refreshProfiles();
	
	                _this8.setState({
	                    serverError: null,
	                    showDemoteModal: false,
	                    user: null,
	                    role: null
	                });
	
	                var teamUrl = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].getCurrentTeamUrl();
	                if (teamUrl) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push(teamUrl);
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push('/');
	                }
	            }, function (err) {
	                _this8.setState({
	                    serverError: err.message
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'label',
	                        { className: 'has-error control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var teamMember = this.props.teamMember;
	            var user = this.props.user;
	            var currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                id: 'admin.user_item.member',
	                defaultMessage: 'Member'
	            });
	
	            if (teamMember.roles.length > 0 && /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isAdmin(teamMember.roles)) {
	                currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.teamAdmin',
	                    defaultMessage: 'Team Admin'
	                });
	            }
	
	            if (user.roles.length > 0 && /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isSystemAdmin(user.roles)) {
	                currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.systemAdmin',
	                    defaultMessage: 'System Admin'
	                });
	            }
	
	            var email = user.email;
	            var showMakeMember = teamMember.roles === 'admin' || user.roles === 'system_admin';
	            var showMakeAdmin = teamMember.roles === '' && user.roles !== 'system_admin';
	            var showMakeSystemAdmin = user.roles === '' || user.roles === 'admin';
	            var showMakeActive = false;
	            var showMakeNotActive = user.roles !== 'system_admin';
	            var mfaEnabled = global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.MFA === 'true' && global.window.mm_config.EnableMultifactorAuthentication === 'true';
	            var showMfaReset = mfaEnabled && user.mfa_active;
	
	            if (user.delete_at > 0) {
	                currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'admin.user_item.inactive',
	                    defaultMessage: 'Inactive'
	                });
	                showMakeMember = false;
	                showMakeAdmin = false;
	                showMakeSystemAdmin = false;
	                showMakeActive = true;
	                showMakeNotActive = false;
	            }
	
	            var makeSystemAdmin = null;
	            if (showMakeSystemAdmin) {
	                makeSystemAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeSystemAdmin
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.makeSysAdmin',
	                            defaultMessage: 'Make System Admin'
	                        })
	                    )
	                );
	            }
	
	            var makeAdmin = null;
	            if (showMakeAdmin) {
	                makeAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeAdmin
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.makeTeamAdmin',
	                            defaultMessage: 'Make Team Admin'
	                        })
	                    )
	                );
	            }
	
	            var makeMember = null;
	            if (showMakeMember) {
	                makeMember = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeMember
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.makeMember',
	                            defaultMessage: 'Make Member'
	                        })
	                    )
	                );
	            }
	
	            var makeActive = null;
	            if (showMakeActive) {
	                makeActive = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeActive
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.makeActive',
	                            defaultMessage: 'Make Active'
	                        })
	                    )
	                );
	            }
	
	            var makeNotActive = null;
	            if (showMakeNotActive) {
	                makeNotActive = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeNotActive
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.makeInactive',
	                            defaultMessage: 'Make Inactive'
	                        })
	                    )
	                );
	            }
	
	            var mfaReset = null;
	            if (showMfaReset) {
	                mfaReset = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleResetMfa
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.resetMfa',
	                            defaultMessage: 'Remove MFA'
	                        })
	                    )
	                );
	            }
	
	            var mfaActiveText = void 0;
	            if (mfaEnabled) {
	                if (user.mfa_active) {
	                    mfaActiveText = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                        id: 'admin.user_item.mfaYes',
	                        defaultMessage: ', <strong>MFA</strong>: Yes'
	                    });
	                } else {
	                    mfaActiveText = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                        id: 'admin.user_item.mfaNo',
	                        defaultMessage: ', <strong>MFA</strong>: No'
	                    });
	                }
	            }
	
	            var authServiceText = void 0;
	            var passwordReset = void 0;
	            if (user.auth_service) {
	                authServiceText = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                    id: 'admin.user_item.authServiceNotEmail',
	                    defaultMessage: ', <strong>Sign-in Method:</strong> {service}',
	                    values: {
	                        service: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.toTitleCase(user.auth_service)
	                    }
	                });
	
	                passwordReset = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleResetPassword
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.switchToEmail',
	                            defaultMessage: 'Switch to Email/Password'
	                        })
	                    )
	                );
	            } else {
	                authServiceText = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                    id: 'admin.user_item.authServiceEmail',
	                    defaultMessage: ', <strong>Sign-in Method:</strong> Email'
	                });
	
	                passwordReset = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleResetPassword
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'admin.user_item.resetPwd',
	                            defaultMessage: 'Reset Password'
	                        })
	                    )
	                );
	            }
	
	            if (global.window.mm_config.EnableSignInWithEmail !== 'true') {
	                passwordReset = null;
	            }
	
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser();
	            var makeDemoteModal = null;
	            if (this.props.user.id === me.id) {
	                var title = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'admin.user_item.confirmDemoteRoleTitle',
	                    defaultMessage: 'Confirm demotion from System Admin role'
	                });
	
	                var message = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'admin.user_item.confirmDemoteDescription',
	                        defaultMessage: 'If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you\'ll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'admin.user_item.confirmDemotionCmd',
	                        defaultMessage: 'platform -assign_role -team_name="yourteam" -email="name@yourcompany.com" -role="system_admin"'
	                    }),
	                    serverError
	                );
	
	                var confirmButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                    id: 'admin.user_item.confirmDemotion',
	                    defaultMessage: 'Confirm Demotion'
	                });
	
	                makeDemoteModal = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__confirm_modal_jsx__["a"], {
	                    show: this.state.showDemoteModal,
	                    title: title,
	                    message: message,
	                    confirmButton: confirmButton,
	                    onConfirm: this.handleDemoteSubmit,
	                    onCancel: this.handleDemoteCancel
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                { className: 'more-modal__row' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
	                    className: 'more-modal__image pull-left',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].getUsersRoute() + '/' + user.id + '/image?time=' + user.update_at,
	                    height: '36',
	                    width: '36'
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'more-modal__details' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'more-modal__name' },
	                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.getDisplayName(user)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'more-modal__description' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                            id: 'admin.user_item.emailTitle',
	                            defaultMessage: '<strong>Email:</strong> {email}',
	                            values: {
	                                email: email
	                            }
	                        }),
	                        authServiceText,
	                        mfaActiveText
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'more-modal__actions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'dropdown member-drop' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                className: 'dropdown-toggle theme',
	                                type: 'button',
	                                'data-toggle': 'dropdown',
	                                'aria-expanded': 'true'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'span',
	                                null,
	                                currentRoles,
	                                ' '
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span', { className: 'caret' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'ul',
	                            {
	                                className: 'dropdown-menu member-menu',
	                                role: 'menu'
	                            },
	                            makeAdmin,
	                            makeMember,
	                            makeActive,
	                            makeNotActive,
	                            makeSystemAdmin,
	                            mfaReset,
	                            passwordReset
	                        )
	                    )
	                ),
	                makeDemoteModal,
	                serverError
	            );
	        }
	    }]);
	
	    return UserItem;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UserItem;
	
	
	UserItem.propTypes = {
	    team: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object.isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object.isRequired,
	    teamMember: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object.isRequired,
	    refreshProfiles: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.func.isRequired,
	    doPasswordReset: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.func.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js__ = __webpack_require__(502);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_chart_js___default = __WEBPACK_IMPORTED_MODULE_9_chart_js__ && __WEBPACK_IMPORTED_MODULE_9_chart_js__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_chart_js__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_chart_js__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_chart_js___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_chart_js___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var DoughnutChart = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(DoughnutChart, _React$Component);
	
	    function DoughnutChart(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DoughnutChart);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(DoughnutChart).call(this, props));
	
	        _this.initChart = _this.initChart.bind(_this);
	        _this.chart = null;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(DoughnutChart, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.initChart();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.areObjectsEqual(prevProps.data, this.props.data) || !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.areObjectsEqual(prevProps.options, this.props.options)) {
	                if (this.chart) {
	                    this.chart.destroy();
	                }
	                this.initChart();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.chart) {
	                this.chart.destroy();
	            }
	        }
	    }, {
	        key: 'initChart',
	        value: function initChart() {
	            if (!this.refs.canvas) {
	                return;
	            }
	            var el = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.canvas);
	            var ctx = el.getContext('2d');
	            this.chart = new /* harmony import */__WEBPACK_IMPORTED_MODULE_9_chart_js___default.a(ctx).Doughnut(this.props.data, this.props.options || {}); //eslint-disable-line new-cap
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = void 0;
	            if (this.props.data == null) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                    id: 'analytics.chart.loading',
	                    defaultMessage: 'Loading...'
	                });
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('canvas', {
	                    ref: 'canvas',
	                    width: this.props.width,
	                    height: this.props.height
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'total-count' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'title' },
	                        this.props.title
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'content' },
	                        content
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DoughnutChart;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = DoughnutChart;
	
	
	DoughnutChart.propTypes = {
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node,
	    width: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string,
	    height: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string,
	    data: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.array,
	    options: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object
	};

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var TableChart = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TableChart, _React$Component);
	
	    function TableChart() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TableChart);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TableChart).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TableChart, [{
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'total-count recent-active-users' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'title' },
	                        this.props.title
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'table',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'tbody',
	                                null,
	                                this.props.data.map(function (item) {
	                                    var tooltip = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Tooltip"],
	                                        { id: 'tip-table-entry-' + item.name },
	                                        item.tip
	                                    );
	
	                                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                        'tr',
	                                        { key: 'table-entry-' + item.name },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                            'td',
	                                            null,
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["OverlayTrigger"],
	                                                {
	                                                    delayShow: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_constants_jsx__["a"].OVERLAY_TIME_DELAY,
	                                                    placement: 'top',
	                                                    overlay: tooltip
	                                                },
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                                    'time',
	                                                    null,
	                                                    item.name
	                                                )
	                                            )
	                                        ),
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                            'td',
	                                            null,
	                                            item.value
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TableChart;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TableChart;
	
	
	TableChart.propTypes = {
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.node,
	    data: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.array
	};

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__line_chart_jsx__ = __webpack_require__(348);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__statistic_count_jsx__ = __webpack_require__(349);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__table_chart_jsx__ = __webpack_require__(665);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__ = __webpack_require__(374);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__system_analytics_jsx__ = __webpack_require__(350);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	/* unused harmony export formatRecentUsersData *//* unused harmony export formatNewUsersData */'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var StatTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].StatTypes;
	
	
	
	
	
	
	var TeamAnalytics = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamAnalytics, _React$Component);
	
	    function TeamAnalytics(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamAnalytics);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamAnalytics).call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	
	        _this.state = { stats: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].getAllTeam(_this.props.team.id) };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamAnalytics, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].addChangeListener(this.onChange);
	
	            this.getData(this.props.team.id);
	        }
	    }, {
	        key: 'getData',
	        value: function getData(id) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getStandardAnalytics(id);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getPostsPerDayAnalytics(id);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getUsersPerDayAnalytics(id);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getRecentAndNewUsersAnalytics(id);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].removeChangeListener(this.onChange);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.getData(nextProps.team.id);
	            this.setState({ stats: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].getAllTeam(nextProps.team.id) });
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(nextState.stats, this.state.stats)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(nextProps.team, this.props.team)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.setState({ stats: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_analytics_store_jsx__["a"].getAllTeam(this.props.team.id) });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stats = this.state.stats;
	            var postCountsDay = /* harmony import */__WEBPACK_IMPORTED_MODULE_12__system_analytics_jsx__["a"].bind()(stats[StatTypes.POST_PER_DAY]);
	            var userCountsWithPostsDay = /* harmony import */__WEBPACK_IMPORTED_MODULE_12__system_analytics_jsx__["b"].bind()(stats[StatTypes.USERS_WITH_POSTS_PER_DAY]);
	            var recentActiveUsers = formatRecentUsersData(stats[StatTypes.RECENTLY_ACTIVE_USERS]);
	            var newlyCreatedUsers = formatNewUsersData(stats[StatTypes.NEWLY_CREATED_USERS]);
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                { className: 'wrapper--fixed team_statistics' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'analytics.team.title',
	                        defaultMessage: 'Team Statistics for {team}',
	                        values: {
	                            team: this.props.team.name
	                        }
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.totalUsers',
	                            defaultMessage: 'Total Users'
	                        }),
	                        icon: 'fa-user',
	                        count: stats[StatTypes.TOTAL_USERS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.publicChannels',
	                            defaultMessage: 'Public Channels'
	                        }),
	                        icon: 'fa-users',
	                        count: stats[StatTypes.TOTAL_PUBLIC_CHANNELS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.privateGroups',
	                            defaultMessage: 'Private Groups'
	                        }),
	                        icon: 'fa-globe',
	                        count: stats[StatTypes.TOTAL_PRIVATE_GROUPS]
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__statistic_count_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.totalPosts',
	                            defaultMessage: 'Total Posts'
	                        }),
	                        icon: 'fa-comment',
	                        count: stats[StatTypes.TOTAL_POSTS]
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__line_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.totalPosts',
	                            defaultMessage: 'Total Posts'
	                        }),
	                        data: postCountsDay,
	                        width: '740',
	                        height: '225'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__line_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.activeUsers',
	                            defaultMessage: 'Active Users With Posts'
	                        }),
	                        data: userCountsWithPostsDay,
	                        width: '740',
	                        height: '225'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__table_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.recentUsers',
	                            defaultMessage: 'Recent Active Users'
	                        }),
	                        data: recentActiveUsers
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__table_chart_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'analytics.team.newlyCreated',
	                            defaultMessage: 'Newly Created Users'
	                        }),
	                        data: newlyCreatedUsers
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TeamAnalytics;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	TeamAnalytics.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["intlShape"].isRequired,
	    team: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["injectIntl"].bind()(TeamAnalytics);
	
	function formatRecentUsersData(data) {
	    if (data == null) {
	        return [];
	    }
	
	    var formattedData = data.map(function (user) {
	        var item = {};
	        item.name = user.username;
	        item.value = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedDate"], {
	            value: user.last_activity_at,
	            day: 'numeric',
	            month: 'long',
	            year: 'numeric',
	            hour12: true,
	            hour: '2-digit',
	            minute: '2-digit'
	        });
	        item.tip = user.email;
	
	        return item;
	    });
	
	    return formattedData;
	}
	
	function formatNewUsersData(data) {
	    if (data == null) {
	        return [];
	    }
	
	    var formattedData = data.map(function (user) {
	        var item = {};
	        item.name = user.username;
	        item.value = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedDate"], {
	            value: user.create_at,
	            day: 'numeric',
	            month: 'long',
	            year: 'numeric',
	            hour12: true,
	            hour: '2-digit',
	            minute: '2-digit'
	        });
	        item.tip = user.email;
	
	        return item;
	    });
	
	    return formattedData;
	}

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__file_info_preview_jsx__ = __webpack_require__(248);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var AudioVideoPreview = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AudioVideoPreview, _React$Component);
	
	    function AudioVideoPreview(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AudioVideoPreview);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AudioVideoPreview).call(this, props));
	
	        _this.handleFileInfoChanged = _this.handleFileInfoChanged.bind(_this);
	        _this.handleLoadError = _this.handleLoadError.bind(_this);
	
	        _this.stop = _this.stop.bind(_this);
	
	        _this.state = {
	            canPlay: true
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AudioVideoPreview, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.handleFileInfoChanged(this.props.fileInfo);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.refs.source) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.source)).one('error', this.handleLoadError);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.fileUrl !== nextProps.fileUrl) {
	                this.handleFileInfoChanged(nextProps.fileInfo);
	            }
	        }
	    }, {
	        key: 'handleFileInfoChanged',
	        value: function handleFileInfoChanged(fileInfo) {
	            var video = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.video);
	            if (!video) {
	                video = document.createElement('video');
	            }
	
	            var canPlayType = video.canPlayType(fileInfo.mime_type);
	
	            this.setState({
	                canPlay: canPlayType === 'probably' || canPlayType === 'maybe'
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.refs.source) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.source)).one('error', this.handleLoadError);
	            }
	        }
	    }, {
	        key: 'handleLoadError',
	        value: function handleLoadError() {
	            this.setState({
	                canPlay: false
	            });
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            if (this.refs.video) {
	                var video = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.video);
	                video.pause();
	                video.currentTime = 0;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.canPlay) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__file_info_preview_jsx__["a"], {
	                    filename: this.props.filename,
	                    fileUrl: this.props.fileUrl,
	                    fileInfo: this.props.fileInfo,
	                    formatMessage: this.props.formatMessage
	                });
	            }
	
	            var width = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].WEB_VIDEO_WIDTH;
	            var height = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].WEB_VIDEO_HEIGHT;
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.isMobile()) {
	                width = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].MOBILE_VIDEO_WIDTH;
	                height = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].MOBILE_VIDEO_HEIGHT;
	            }
	
	            // add a key to the video to prevent React from using an old video source while a new one is loading
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'video',
	                {
	                    key: this.props.filename,
	                    ref: 'video',
	                    style: { maxHeight: this.props.maxHeight },
	                    'data-setup': '{}',
	                    controls: 'controls',
	                    width: width,
	                    height: height
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('source', {
	                    ref: 'source',
	                    src: this.props.fileUrl
	                })
	            );
	        }
	    }]);
	
	    return AudioVideoPreview;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AudioVideoPreview;
	
	
	AudioVideoPreview.propTypes = {
	    filename: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string.isRequired,
	    fileUrl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string.isRequired,
	    fileInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired,
	    maxHeight: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.oneOfType([/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string, /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.number]).isRequired,
	    formatMessage: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__backstage_header_jsx__ = __webpack_require__(244);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_form_error_jsx__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_spinner_button_jsx__ = __webpack_require__(159);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var REQUEST_POST = 'P';
	var REQUEST_GET = 'G';
	
	var AddCommand = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AddCommand, _React$Component);
	
	    function AddCommand(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AddCommand);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AddCommand).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.updateDisplayName = _this.updateDisplayName.bind(_this);
	        _this.updateDescription = _this.updateDescription.bind(_this);
	        _this.updateTrigger = _this.updateTrigger.bind(_this);
	        _this.updateUrl = _this.updateUrl.bind(_this);
	        _this.updateMethod = _this.updateMethod.bind(_this);
	        _this.updateUsername = _this.updateUsername.bind(_this);
	        _this.updateIconUrl = _this.updateIconUrl.bind(_this);
	        _this.updateAutocomplete = _this.updateAutocomplete.bind(_this);
	        _this.updateAutocompleteHint = _this.updateAutocompleteHint.bind(_this);
	        _this.updateAutocompleteDescription = _this.updateAutocompleteDescription.bind(_this);
	
	        _this.state = {
	            displayName: '',
	            description: '',
	            trigger: '',
	            url: '',
	            method: REQUEST_POST,
	            username: '',
	            iconUrl: '',
	            autocomplete: false,
	            autocompleteHint: '',
	            autocompleteDescription: '',
	            saving: false,
	            serverError: '',
	            clientError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AddCommand, [{
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (this.state.saving) {
	                return;
	            }
	
	            this.setState({
	                saving: true,
	                serverError: '',
	                clientError: ''
	            });
	
	            var command = {
	                display_name: this.state.displayName,
	                description: this.state.description,
	                trigger: this.state.trigger.trim(),
	                url: this.state.url.trim(),
	                method: this.state.method,
	                username: this.state.username,
	                icon_url: this.state.iconUrl,
	                auto_complete: this.state.autocomplete
	            };
	
	            if (command.auto_complete) {
	                command.auto_complete_desc = this.state.autocompleteDescription;
	                command.auto_complete_hint = this.state.autocompleteHint;
	            }
	
	            if (!command.trigger) {
	                this.setState({
	                    saving: false,
	                    clientError: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'add_command.triggerRequired',
	                        defaultMessage: 'A trigger word is required'
	                    })
	                });
	
	                return;
	            }
	
	            if (!command.url) {
	                this.setState({
	                    saving: false,
	                    clientError: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'add_command.urlRequired',
	                        defaultMessage: 'A request URL is required'
	                    })
	                });
	
	                return;
	            }
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.addCommand(command, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"].push('/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/commands');
	            }, function (err) {
	                _this2.setState({
	                    saving: false,
	                    serverError: err.message
	                });
	            });
	        }
	    }, {
	        key: 'updateDisplayName',
	        value: function updateDisplayName(e) {
	            this.setState({
	                displayName: e.target.value
	            });
	        }
	    }, {
	        key: 'updateDescription',
	        value: function updateDescription(e) {
	            this.setState({
	                description: e.target.value
	            });
	        }
	    }, {
	        key: 'updateTrigger',
	        value: function updateTrigger(e) {
	            this.setState({
	                trigger: e.target.value
	            });
	        }
	    }, {
	        key: 'updateUrl',
	        value: function updateUrl(e) {
	            this.setState({
	                url: e.target.value
	            });
	        }
	    }, {
	        key: 'updateMethod',
	        value: function updateMethod(e) {
	            this.setState({
	                method: e.target.value
	            });
	        }
	    }, {
	        key: 'updateUsername',
	        value: function updateUsername(e) {
	            this.setState({
	                username: e.target.value
	            });
	        }
	    }, {
	        key: 'updateIconUrl',
	        value: function updateIconUrl(e) {
	            this.setState({
	                iconUrl: e.target.value
	            });
	        }
	    }, {
	        key: 'updateAutocomplete',
	        value: function updateAutocomplete(e) {
	            this.setState({
	                autocomplete: e.target.checked
	            });
	        }
	    }, {
	        key: 'updateAutocompleteHint',
	        value: function updateAutocompleteHint(e) {
	            this.setState({
	                autocompleteHint: e.target.value
	            });
	        }
	    }, {
	        key: 'updateAutocompleteDescription',
	        value: function updateAutocompleteDescription(e) {
	            this.setState({
	                autocompleteDescription: e.target.value
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var autocompleteFields = null;
	            if (this.state.autocomplete) {
	                autocompleteFields = [/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'autocompleteHint',
	                        className: 'form-group'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'autocompleteHint'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'add_command.autocompleteHint',
	                            defaultMessage: 'Autocomplete Hint'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'col-md-5 col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                            id: 'autocompleteHint',
	                            type: 'text',
	                            maxLength: '1024',
	                            className: 'form-control',
	                            value: this.state.autocompleteHint,
	                            onChange: this.updateAutocompleteHint,
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.autocompleteHint.placeholder', 'Example: [Patient Name]')
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form__help' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'add_command.autocompleteDescription.help',
	                                defaultMessage: 'Optional hint in the autocomplete list about command parameters'
	                            })
	                        )
	                    )
	                ), /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'autocompleteDescription',
	                        className: 'form-group'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'label',
	                        {
	                            className: 'control-label col-sm-4',
	                            htmlFor: 'autocompleteDescription'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'add_command.autocompleteDescription',
	                            defaultMessage: 'Autocomplete Description'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'col-md-5 col-sm-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                            id: 'description',
	                            type: 'text',
	                            maxLength: '128',
	                            className: 'form-control',
	                            value: this.state.autocompleteDescription,
	                            onChange: this.updateAutocompleteDescription,
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.autocompleteDescription.placeholder', 'Example: "Returns search results for patient records"')
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form__help' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                id: 'add_command.autocompleteDescription.help',
	                                defaultMessage: 'Optional short description of slash command for the autocomplete list.'
	                            })
	                        )
	                    )
	                )];
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-content row' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9__backstage_header_jsx__["a"],
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                        { to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/commands' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                            id: 'installed_command.header',
	                            defaultMessage: 'Slash Commands'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'add_command.header',
	                        defaultMessage: 'Add'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'backstage-form' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'displayName'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.displayName',
	                                    defaultMessage: 'Display Name'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'displayName',
	                                    type: 'text',
	                                    maxLength: '64',
	                                    className: 'form-control',
	                                    value: this.state.displayName,
	                                    onChange: this.updateDisplayName
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'description'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.description',
	                                    defaultMessage: 'Description'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'description',
	                                    type: 'text',
	                                    maxLength: '128',
	                                    className: 'form-control',
	                                    value: this.state.description,
	                                    onChange: this.updateDescription
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'trigger'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.trigger',
	                                    defaultMessage: 'Command Trigger Word'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'trigger',
	                                    type: 'text',
	                                    maxLength: '128',
	                                    className: 'form-control',
	                                    value: this.state.trigger,
	                                    onChange: this.updateTrigger,
	                                    placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.trigger.placeholder', 'Command trigger e.g. "hello" not including the slash')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.trigger.help1',
	                                        defaultMessage: 'Examples: /patient, /client /employee'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.trigger.help2',
	                                        defaultMessage: 'Reserved: /echo, /join, /logout, /me, /shrug'
	                                    })
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'url'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.url',
	                                    defaultMessage: 'Request URL'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'url',
	                                    type: 'text',
	                                    maxLength: '1024',
	                                    className: 'form-control',
	                                    value: this.state.url,
	                                    onChange: this.updateUrl,
	                                    placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.url.placeholder', 'Must start with http:// or https://')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.url.help',
	                                        defaultMessage: 'The callback URL to receive the HTTP POST or GET event request when the slash command is run.'
	                                    })
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'method'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.method',
	                                    defaultMessage: 'Request Method'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'select',
	                                    {
	                                        id: 'method',
	                                        className: 'form-control',
	                                        value: this.state.method,
	                                        onChange: this.updateMethod
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                        'option',
	                                        { value: REQUEST_POST },
	                                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.method.post', 'POST')
	                                    ),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                        'option',
	                                        { value: REQUEST_GET },
	                                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.method.get', 'GET')
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.method.help',
	                                        defaultMessage: 'The type of command request issued to the Request URL.'
	                                    })
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'username'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.username',
	                                    defaultMessage: 'Response Username'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'username',
	                                    type: 'text',
	                                    maxLength: '64',
	                                    className: 'form-control',
	                                    value: this.state.username,
	                                    onChange: this.updateUsername,
	                                    placholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.username.placeholder', 'Username')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.username.help',
	                                        defaultMessage: 'Choose a username override for responses for this slash command. Usernames can consist of up to 22 characters consisting of lowercase letters, numbers and the symbols "-", "_", and ".".'
	                                    })
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'iconUrl'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.iconUrl',
	                                    defaultMessage: 'Response Icon'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'iconUrl',
	                                    type: 'text',
	                                    maxLength: '1024',
	                                    className: 'form-control',
	                                    value: this.state.iconUrl,
	                                    onChange: this.updateIconUrl,
	                                    placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('add_command.iconUrl.placeholder', 'https://www.example.com/myicon.png')
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.iconUrl.help',
	                                        defaultMessage: 'Choose a profile picture override for the post responses to this slash command. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.'
	                                    })
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group padding-bottom' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-12' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'checkbox' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                        type: 'checkbox',
	                                        checked: this.state.autocomplete,
	                                        onChange: this.updateAutocomplete
	                                    }),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.autocomplete',
	                                        defaultMessage: 'Autocomplete'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                    'div',
	                                    { className: 'form__help' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                        id: 'add_command.autocomplete.help',
	                                        defaultMessage: 'Show this command in the autocomplete list'
	                                    })
	                                )
	                            )
	                        ),
	                        autocompleteFields,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'backstage-form__footer' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_components_form_error_jsx__["a"], { errors: [this.state.serverError, this.state.clientError] }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                                {
	                                    className: 'btn btn-sm',
	                                    to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/commands'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_components_spinner_button_jsx__["a"],
	                                {
	                                    className: 'btn btn-primary',
	                                    type: 'submit',
	                                    spinning: this.state.saving,
	                                    onClick: this.handleSubmit
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'add_command.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddCommand;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AddCommand;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__backstage_header_jsx__ = __webpack_require__(244);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_channel_select_jsx__ = __webpack_require__(356);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_error_jsx__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_spinner_button_jsx__ = __webpack_require__(159);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var AddIncomingWebhook = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(AddIncomingWebhook, _React$Component);
	
	    function AddIncomingWebhook(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AddIncomingWebhook);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AddIncomingWebhook).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.updateDisplayName = _this.updateDisplayName.bind(_this);
	        _this.updateDescription = _this.updateDescription.bind(_this);
	        _this.updateChannelId = _this.updateChannelId.bind(_this);
	
	        _this.state = {
	            displayName: '',
	            description: '',
	            channelId: '',
	            saving: false,
	            serverError: '',
	            clientError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(AddIncomingWebhook, [{
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (this.state.saving) {
	                return;
	            }
	
	            this.setState({
	                saving: true,
	                serverError: '',
	                clientError: ''
	            });
	
	            if (!this.state.channelId) {
	                this.setState({
	                    saving: false,
	                    clientError: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'add_incoming_webhook.channelRequired',
	                        defaultMessage: 'A valid channel is required'
	                    })
	                });
	
	                return;
	            }
	
	            var hook = {
	                channel_id: this.state.channelId,
	                display_name: this.state.displayName,
	                description: this.state.description
	            };
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.addIncomingHook(hook, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"].push('/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/incoming_webhooks');
	            }, function (err) {
	                _this2.setState({
	                    saving: false,
	                    serverError: err.message
	                });
	            });
	        }
	    }, {
	        key: 'updateDisplayName',
	        value: function updateDisplayName(e) {
	            this.setState({
	                displayName: e.target.value
	            });
	        }
	    }, {
	        key: 'updateDescription',
	        value: function updateDescription(e) {
	            this.setState({
	                description: e.target.value
	            });
	        }
	    }, {
	        key: 'updateChannelId',
	        value: function updateChannelId(e) {
	            this.setState({
	                channelId: e.target.value
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-content' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9__backstage_header_jsx__["a"],
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                        { to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/incoming_webhooks' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'installed_incoming_webhooks.header',
	                            defaultMessage: 'Incoming Webhooks'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'add_incoming_webhook.header',
	                        defaultMessage: 'Add'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'backstage-form' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'displayName'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'add_incoming_webhook.displayName',
	                                    defaultMessage: 'Display Name'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'displayName',
	                                    type: 'text',
	                                    maxLength: '64',
	                                    className: 'form-control',
	                                    value: this.state.displayName,
	                                    onChange: this.updateDisplayName
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'description'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'add_incoming_webhook.description',
	                                    defaultMessage: 'Description'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', {
	                                    id: 'description',
	                                    type: 'text',
	                                    maxLength: '128',
	                                    className: 'form-control',
	                                    value: this.state.description,
	                                    onChange: this.updateDescription
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'channelId'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'add_incoming_webhook.channel',
	                                    defaultMessage: 'Channel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_components_channel_select_jsx__["a"], {
	                                    id: 'channelId',
	                                    value: this.state.channelId,
	                                    onChange: this.updateChannelId
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { className: 'backstage-form__footer' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_components_form_error_jsx__["a"], { errors: [this.state.serverError, this.state.clientError] }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                                {
	                                    className: 'btn btn-sm',
	                                    to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/incoming_webhooks'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'add_incoming_webhook.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_components_spinner_button_jsx__["a"],
	                                {
	                                    className: 'btn btn-primary',
	                                    type: 'submit',
	                                    spinning: this.state.saving,
	                                    onClick: this.handleSubmit
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                    id: 'add_incoming_webhook.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddIncomingWebhook;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AddIncomingWebhook;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router___default = __WEBPACK_IMPORTED_MODULE_8_react_router__ && __WEBPACK_IMPORTED_MODULE_8_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__backstage_header_jsx__ = __webpack_require__(244);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_channel_select_jsx__ = __webpack_require__(356);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_form_error_jsx__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_spinner_button_jsx__ = __webpack_require__(159);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var AddOutgoingWebhook = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(AddOutgoingWebhook, _React$Component);
	
	    function AddOutgoingWebhook(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AddOutgoingWebhook);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AddOutgoingWebhook).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.updateDisplayName = _this.updateDisplayName.bind(_this);
	        _this.updateDescription = _this.updateDescription.bind(_this);
	        _this.updateChannelId = _this.updateChannelId.bind(_this);
	        _this.updateTriggerWords = _this.updateTriggerWords.bind(_this);
	        _this.updateCallbackUrls = _this.updateCallbackUrls.bind(_this);
	
	        _this.state = {
	            displayName: '',
	            description: '',
	            channelId: '',
	            triggerWords: '',
	            callbackUrls: '',
	            saving: false,
	            serverError: '',
	            clientError: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(AddOutgoingWebhook, [{
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (this.state.saving) {
	                return;
	            }
	
	            this.setState({
	                saving: true,
	                serverError: '',
	                clientError: ''
	            });
	
	            var triggerWords = [];
	            if (this.state.triggerWords) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(this.state.triggerWords.split('\n')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var triggerWord = _step.value;
	
	                        triggerWord = triggerWord.trim();
	
	                        if (triggerWord.length > 0) {
	                            triggerWords.push(triggerWord);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            if (!this.state.channelId && triggerWords.length === 0) {
	                this.setState({
	                    saving: false,
	                    clientError: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'add_outgoing_webhook.triggerWordsOrChannelRequired',
	                        defaultMessage: 'A valid channel or a list of trigger words is required'
	                    })
	                });
	
	                return;
	            }
	
	            var callbackUrls = [];
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(this.state.callbackUrls.split('\n')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var callbackUrl = _step2.value;
	
	                    callbackUrl = callbackUrl.trim();
	
	                    if (callbackUrl.length > 0) {
	                        callbackUrls.push(callbackUrl);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            if (callbackUrls.length === 0) {
	                this.setState({
	                    saving: false,
	                    clientError: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'add_outgoing_webhook.callbackUrlsRequired',
	                        defaultMessage: 'One or more callback URLs are required'
	                    })
	                });
	
	                return;
	            }
	
	            var hook = {
	                channel_id: this.state.channelId,
	                trigger_words: triggerWords,
	                callback_urls: callbackUrls,
	                display_name: this.state.displayName,
	                description: this.state.description
	            };
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.addOutgoingHook(hook, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["browserHistory"].push('/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/outgoing_webhooks');
	            }, function (err) {
	                _this2.setState({
	                    saving: false,
	                    serverError: err.message
	                });
	            });
	        }
	    }, {
	        key: 'updateDisplayName',
	        value: function updateDisplayName(e) {
	            this.setState({
	                displayName: e.target.value
	            });
	        }
	    }, {
	        key: 'updateDescription',
	        value: function updateDescription(e) {
	            this.setState({
	                description: e.target.value
	            });
	        }
	    }, {
	        key: 'updateChannelId',
	        value: function updateChannelId(e) {
	            this.setState({
	                channelId: e.target.value
	            });
	        }
	    }, {
	        key: 'updateTriggerWords',
	        value: function updateTriggerWords(e) {
	            this.setState({
	                triggerWords: e.target.value
	            });
	        }
	    }, {
	        key: 'updateCallbackUrls',
	        value: function updateCallbackUrls(e) {
	            this.setState({
	                callbackUrls: e.target.value
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'backstage-content' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10__backstage_header_jsx__["a"],
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                        { to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/outgoing_webhooks' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'installed_outgoing_webhooks.header',
	                            defaultMessage: 'Outgoing Webhooks'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'add_outgoing_webhook.header',
	                        defaultMessage: 'Add'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'backstage-form' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'form',
	                        { className: 'form-horizontal' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'displayName'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.displayName',
	                                    defaultMessage: 'Display Name'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
	                                    id: 'displayName',
	                                    type: 'text',
	                                    maxLength: '64',
	                                    className: 'form-control',
	                                    value: this.state.displayName,
	                                    onChange: this.updateDisplayName
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'description'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.description',
	                                    defaultMessage: 'Description'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
	                                    id: 'description',
	                                    type: 'text',
	                                    maxLength: '128',
	                                    className: 'form-control',
	                                    value: this.state.description,
	                                    onChange: this.updateDescription
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'channelId'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.channel',
	                                    defaultMessage: 'Channel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_components_channel_select_jsx__["a"], {
	                                    id: 'channelId',
	                                    value: this.state.channelId,
	                                    onChange: this.updateChannelId
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'triggerWords'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.triggerWords',
	                                    defaultMessage: 'Trigger Words (One Per Line)'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('textarea', {
	                                    id: 'triggerWords',
	                                    rows: '3',
	                                    maxLength: '1000',
	                                    className: 'form-control',
	                                    value: this.state.triggerWords,
	                                    onChange: this.updateTriggerWords
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'label',
	                                {
	                                    className: 'control-label col-sm-4',
	                                    htmlFor: 'callbackUrls'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.callbackUrls',
	                                    defaultMessage: 'Callback URLs (One Per Line)'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'div',
	                                { className: 'col-md-5 col-sm-8' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('textarea', {
	                                    id: 'callbackUrls',
	                                    rows: '3',
	                                    maxLength: '1000',
	                                    className: 'form-control',
	                                    value: this.state.callbackUrls,
	                                    onChange: this.updateCallbackUrls
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            { className: 'backstage-form__footer' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_components_form_error_jsx__["a"], { errors: [this.state.serverError, this.state.clientError] }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                                {
	                                    className: 'btn btn-sm',
	                                    to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/outgoing_webhooks'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_components_spinner_button_jsx__["a"],
	                                {
	                                    className: 'btn btn-primary',
	                                    type: 'submit',
	                                    spinning: this.state.saving,
	                                    onClick: this.handleSubmit
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'add_outgoing_webhook.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddOutgoingWebhook;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = AddOutgoingWebhook;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router___default = __WEBPACK_IMPORTED_MODULE_6_react_router__ && __WEBPACK_IMPORTED_MODULE_6_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var BackstageCategory = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(BackstageCategory, _React$Component);
	
	    function BackstageCategory() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BackstageCategory);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(BackstageCategory).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BackstageCategory, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var name = _props.name;
	            var title = _props.title;
	            var icon = _props.icon;
	            var parentLink = _props.parentLink;
	            var children = _props.children;
	
	
	            var link = parentLink + '/' + name;
	
	            var clonedChildren = null;
	            if (children.length > 0 && this.context.router.isActive(link)) {
	                clonedChildren = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'ul',
	                    { className: 'sections' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, function (child) {
	                        if (!child) {
	                            return child;
	                        }
	
	                        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, {
	                            parentLink: link
	                        });
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'li',
	                { className: 'backstage-sidebar__category' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
	                    {
	                        to: link,
	                        className: 'category-title',
	                        activeClassName: 'category-title--active'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('i', { className: 'fa ' + icon }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'span',
	                        { className: 'category-title__text' },
	                        title
	                    )
	                ),
	                clonedChildren
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                name: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
	                title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                icon: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
	                parentLink: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
	                children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element)
	            };
	        }
	    }, {
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                parentLink: '',
	                children: []
	            };
	        }
	    }, {
	        key: 'contextTypes',
	        get: function get() {
	            return {
	                router: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired
	            };
	        }
	    }]);
	
	    return BackstageCategory;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = BackstageCategory;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router___default = __WEBPACK_IMPORTED_MODULE_9_react_router__ && __WEBPACK_IMPORTED_MODULE_9_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var BackstageNavbar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(BackstageNavbar, _React$Component);
	
	    function BackstageNavbar(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BackstageNavbar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(BackstageNavbar).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        _this.state = {
	            team: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getCurrent()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BackstageNavbar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].addChangeListener(this.handleChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').addClass('backstage');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].removeChangeListener(this.handleChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').removeClass('backstage');
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange() {
	            this.setState({
	                team: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getCurrent()
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.team) {
	                return null;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'backstage-navbar row' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_router__["Link"],
	                    {
	                        className: 'backstage-navbar__back',
	                        to: '/' + this.state.team.name + '/channels/town-square'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', { className: 'fa fa-angle-left' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'backstage_navbar.backToMattermost',
	                            defaultMessage: 'Back to {siteName}',
	                            values: {
	                                siteName: global.window.mm_config.SiteName
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BackstageNavbar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = BackstageNavbar;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router___default = __WEBPACK_IMPORTED_MODULE_6_react_router__ && __WEBPACK_IMPORTED_MODULE_6_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var BackstageSection = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(BackstageSection, _React$Component);
	
	    function BackstageSection() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BackstageSection);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(BackstageSection).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BackstageSection, [{
	        key: 'getLink',
	        value: function getLink() {
	            return this.props.parentLink + '/' + this.props.name;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var title = _props.title;
	            var subsection = _props.subsection;
	            var children = _props.children;
	
	
	            var link = this.getLink();
	
	            var clonedChildren = null;
	            if (children.length > 0) {
	                clonedChildren = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'ul',
	                    { className: 'subsections' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, function (child) {
	                        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, {
	                            parentLink: link,
	                            subsection: true
	                        });
	                    })
	                );
	            }
	
	            var className = 'section';
	            if (subsection) {
	                className = 'subsection';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'li',
	                { className: className },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
	                    {
	                        className: className + '-title',
	                        activeClassName: className + '-title--active',
	                        onClick: this.handleClick,
	                        to: link
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'span',
	                        { className: className + '-title__text' },
	                        title
	                    )
	                ),
	                clonedChildren
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                name: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
	                title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                parentLink: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
	                subsection: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool,
	                children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element)
	            };
	        }
	    }, {
	        key: 'defaultProps',
	        get: function get() {
	            return {
	                parentLink: '',
	                subsection: false,
	                children: []
	            };
	        }
	    }, {
	        key: 'contextTypes',
	        get: function get() {
	            return {
	                router: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired
	            };
	        }
	    }]);
	
	    return BackstageSection;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = BackstageSection;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__backstage_category_jsx__ = __webpack_require__(671);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__backstage_section_jsx__ = __webpack_require__(673);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var BackstageSidebar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(BackstageSidebar, _React$Component);
	
	    function BackstageSidebar() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, BackstageSidebar);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(BackstageSidebar).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(BackstageSidebar, [{
	        key: 'render',
	        value: function render() {
	            var incomingWebhooks = null;
	            if (window.mm_config.EnableIncomingWebhooks === 'true') {
	                incomingWebhooks = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__backstage_section_jsx__["a"], {
	                    name: 'incoming_webhooks',
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'backstage_sidebar.integrations.incoming_webhooks',
	                        defaultMessage: 'Incoming Webhooks'
	                    })
	                });
	            }
	
	            var outgoingWebhooks = null;
	            if (window.mm_config.EnableOutgoingWebhooks === 'true') {
	                outgoingWebhooks = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__backstage_section_jsx__["a"], {
	                    name: 'outgoing_webhooks',
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'backstage_sidebar.integrations.outgoing_webhooks',
	                        defaultMessage: 'Outgoing Webhooks'
	                    })
	                });
	            }
	
	            var commands = null;
	            if (window.mm_config.EnableCommands === 'true') {
	                commands = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__backstage_section_jsx__["a"], {
	                    name: 'commands',
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'backstage_sidebar.integrations.commands',
	                        defaultMessage: 'Slash Commands'
	                    })
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-sidebar' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'ul',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7__backstage_category_jsx__["a"],
	                        {
	                            name: 'integrations',
	                            parentLink: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.getTeamNameFromUrl() + '/settings',
	                            icon: 'fa-link',
	                            title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'backstage_sidebar.integrations',
	                                defaultMessage: 'Integrations'
	                            })
	                        },
	                        incomingWebhooks,
	                        outgoingWebhooks,
	                        commands
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BackstageSidebar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = BackstageSidebar;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var InstalledCommand = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InstalledCommand, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(InstalledCommand, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                command: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	                onRegenToken: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
	                onDelete: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
	                filter: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string
	            };
	        }
	    }]);
	
	    function InstalledCommand(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledCommand);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledCommand).call(this, props));
	
	        _this.handleRegenToken = _this.handleRegenToken.bind(_this);
	        _this.handleDelete = _this.handleDelete.bind(_this);
	
	        _this.matchesFilter = _this.matchesFilter.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(InstalledCommand, [{
	        key: 'handleRegenToken',
	        value: function handleRegenToken(e) {
	            e.preventDefault();
	
	            this.props.onRegenToken(this.props.command);
	        }
	    }, {
	        key: 'handleDelete',
	        value: function handleDelete(e) {
	            e.preventDefault();
	
	            this.props.onDelete(this.props.command);
	        }
	    }, {
	        key: 'matchesFilter',
	        value: function matchesFilter(command, filter) {
	            if (!filter) {
	                return true;
	            }
	
	            return command.display_name.toLowerCase().indexOf(filter) !== -1 || command.description.toLowerCase().indexOf(filter) !== -1 || command.trigger.toLowerCase().indexOf(filter) !== -1;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var command = this.props.command;
	
	            if (!this.matchesFilter(command, this.props.filter)) {
	                return null;
	            }
	
	            var name = void 0;
	            if (command.display_name) {
	                name = command.display_name;
	            } else {
	                name = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                    id: 'installed_integraions.unnamed_command',
	                    defaultMessage: 'Unnamed Slash Command'
	                });
	            }
	
	            var description = null;
	            if (command.description) {
	                description = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details__row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'span',
	                        { className: 'item-details__description' },
	                        command.description
	                    )
	                );
	            }
	
	            var trigger = '- /' + command.trigger;
	            if (command.auto_complete && command.auto_complete_hint) {
	                trigger += ' ' + command.auto_complete_hint;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-list__item' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__name' },
	                            name
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__trigger' },
	                            trigger
	                        )
	                    ),
	                    description,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__token' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                id: 'installed_integrations.token',
	                                defaultMessage: 'Token: {token}',
	                                values: {
	                                    token: command.token
	                                }
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__creation' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                id: 'installed_integrations.creation',
	                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
	                                values: {
	                                    creator: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.displayUsername(command.creator_id),
	                                    createAt: command.create_at
	                                }
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'item-actions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handleRegenToken
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'installed_integrations.regenToken',
	                            defaultMessage: 'Regen Token'
	                        })
	                    ),
	                    ' - ',
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handleDelete
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'installed_integrations.delete',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InstalledCommand;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledCommand;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__ = __webpack_require__(252);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__installed_command_jsx__ = __webpack_require__(675);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__installed_integrations_jsx__ = __webpack_require__(245);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	var InstalledCommands = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InstalledCommands, _React$Component);
	
	    function InstalledCommands(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledCommands);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledCommands).call(this, props));
	
	        _this.handleIntegrationChange = _this.handleIntegrationChange.bind(_this);
	
	        _this.regenCommandToken = _this.regenCommandToken.bind(_this);
	        _this.deleteCommand = _this.deleteCommand.bind(_this);
	
	        var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentId();
	
	        _this.state = {
	            commands: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].getCommands(teamId),
	            loading: !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].hasReceivedCommands(teamId)
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(InstalledCommands, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].addChangeListener(this.handleIntegrationChange);
	
	            if (window.mm_config.EnableCommands === 'true') {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.listTeamCommands();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].removeChangeListener(this.handleIntegrationChange);
	        }
	    }, {
	        key: 'handleIntegrationChange',
	        value: function handleIntegrationChange() {
	            var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentId();
	
	            this.setState({
	                commands: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].getCommands(teamId),
	                loading: !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].hasReceivedCommands(teamId)
	            });
	        }
	    }, {
	        key: 'regenCommandToken',
	        value: function regenCommandToken(command) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.regenCommandToken(command.id);
	        }
	    }, {
	        key: 'deleteCommand',
	        value: function deleteCommand(command) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.deleteCommand(command.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var commands = this.state.commands.map(function (command) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__installed_command_jsx__["a"], {
	                    key: command.id,
	                    command: command,
	                    onRegenToken: _this2.regenCommandToken,
	                    onDelete: _this2.deleteCommand
	                });
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12__installed_integrations_jsx__["a"],
	                {
	                    header: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_commands.header',
	                        defaultMessage: 'Installed Slash Commands'
	                    }),
	                    addText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_commands.add',
	                        defaultMessage: 'Add Slash Command'
	                    }),
	                    addLink: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/commands/add',
	                    emptyText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_commands.empty',
	                        defaultMessage: 'No slash commands found'
	                    }),
	                    loading: this.state.loading
	                },
	                commands
	            );
	        }
	    }]);
	
	    return InstalledCommands;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledCommands;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var InstalledIncomingWebhook = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InstalledIncomingWebhook, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(InstalledIncomingWebhook, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                incomingWebhook: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	                onDelete: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired,
	                filter: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string
	            };
	        }
	    }]);
	
	    function InstalledIncomingWebhook(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledIncomingWebhook);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledIncomingWebhook).call(this, props));
	
	        _this.handleDelete = _this.handleDelete.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(InstalledIncomingWebhook, [{
	        key: 'handleDelete',
	        value: function handleDelete(e) {
	            e.preventDefault();
	
	            this.props.onDelete(this.props.incomingWebhook);
	        }
	    }, {
	        key: 'matchesFilter',
	        value: function matchesFilter(incomingWebhook, channel, filter) {
	            if (!filter) {
	                return true;
	            }
	
	            if (incomingWebhook.display_name.toLowerCase().indexOf(filter) !== -1 || incomingWebhook.description.toLowerCase().indexOf(filter) !== -1) {
	                return true;
	            }
	
	            if (incomingWebhook.channel_id) {
	                if (channel && channel.name.toLowerCase().indexOf(filter) !== -1) {
	                    return true;
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var incomingWebhook = this.props.incomingWebhook;
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].get(incomingWebhook.channel_id);
	
	            if (!this.matchesFilter(incomingWebhook, channel, this.props.filter)) {
	                return null;
	            }
	
	            var displayName = void 0;
	            if (incomingWebhook.display_name) {
	                displayName = incomingWebhook.display_name;
	            } else if (channel) {
	                displayName = channel.display_name;
	            } else {
	                displayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                    id: 'installed_incoming_webhooks.unknown_channel',
	                    defaultMessage: 'A Private Webhook'
	                });
	            }
	
	            var description = null;
	            if (incomingWebhook.description) {
	                description = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details__row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'span',
	                        { className: 'item-details__description' },
	                        incomingWebhook.description
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-list__item' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__name' },
	                            displayName
	                        )
	                    ),
	                    description,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__url' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'installed_integrations.url',
	                                defaultMessage: 'URL: {url}',
	                                values: {
	                                    url: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getWindowLocationOrigin() + '/hooks/' + incomingWebhook.id
	                                }
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'tem-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__creation' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'installed_integrations.creation',
	                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
	                                values: {
	                                    creator: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.displayUsername(incomingWebhook.user_id),
	                                    createAt: incomingWebhook.create_at
	                                }
	                            })
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'item-actions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handleDelete
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'installed_integrations.delete',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InstalledIncomingWebhook;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledIncomingWebhook;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__ = __webpack_require__(252);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__installed_incoming_webhook_jsx__ = __webpack_require__(677);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__installed_integrations_jsx__ = __webpack_require__(245);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	var InstalledIncomingWebhooks = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InstalledIncomingWebhooks, _React$Component);
	
	    function InstalledIncomingWebhooks(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledIncomingWebhooks);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledIncomingWebhooks).call(this, props));
	
	        _this.handleIntegrationChange = _this.handleIntegrationChange.bind(_this);
	
	        _this.deleteIncomingWebhook = _this.deleteIncomingWebhook.bind(_this);
	
	        var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentId();
	
	        _this.state = {
	            incomingWebhooks: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].getIncomingWebhooks(teamId),
	            loading: !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].hasReceivedIncomingWebhooks(teamId)
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(InstalledIncomingWebhooks, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].addChangeListener(this.handleIntegrationChange);
	
	            if (window.mm_config.EnableIncomingWebhooks === 'true') {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.listIncomingHooks();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].removeChangeListener(this.handleIntegrationChange);
	        }
	    }, {
	        key: 'handleIntegrationChange',
	        value: function handleIntegrationChange() {
	            var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentId();
	
	            this.setState({
	                incomingWebhooks: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].getIncomingWebhooks(teamId),
	                loading: !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].hasReceivedIncomingWebhooks(teamId)
	            });
	        }
	    }, {
	        key: 'deleteIncomingWebhook',
	        value: function deleteIncomingWebhook(incomingWebhook) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.deleteIncomingHook(incomingWebhook.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var incomingWebhooks = this.state.incomingWebhooks.map(function (incomingWebhook) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__installed_incoming_webhook_jsx__["a"], {
	                    key: incomingWebhook.id,
	                    incomingWebhook: incomingWebhook,
	                    onDelete: _this2.deleteIncomingWebhook
	                });
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12__installed_integrations_jsx__["a"],
	                {
	                    header: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_incoming_webhooks.header',
	                        defaultMessage: 'Installed Incoming Webhooks'
	                    }),
	                    addText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_incoming_webhooks.add',
	                        defaultMessage: 'Add Incoming Webhook'
	                    }),
	                    addLink: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/incoming_webhooks/add',
	                    emptyText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_incoming_webhooks.empty',
	                        defaultMessage: 'No incoming webhooks found'
	                    }),
	                    loading: this.state.loading
	                },
	                incomingWebhooks
	            );
	        }
	    }]);
	
	    return InstalledIncomingWebhooks;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledIncomingWebhooks;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var InstalledOutgoingWebhook = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(InstalledOutgoingWebhook, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(InstalledOutgoingWebhook, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                outgoingWebhook: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
	                onRegenToken: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
	                onDelete: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired,
	                filter: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string
	            };
	        }
	    }]);
	
	    function InstalledOutgoingWebhook(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledOutgoingWebhook);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledOutgoingWebhook).call(this, props));
	
	        _this.handleRegenToken = _this.handleRegenToken.bind(_this);
	        _this.handleDelete = _this.handleDelete.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(InstalledOutgoingWebhook, [{
	        key: 'handleRegenToken',
	        value: function handleRegenToken(e) {
	            e.preventDefault();
	
	            this.props.onRegenToken(this.props.outgoingWebhook);
	        }
	    }, {
	        key: 'handleDelete',
	        value: function handleDelete(e) {
	            e.preventDefault();
	
	            this.props.onDelete(this.props.outgoingWebhook);
	        }
	    }, {
	        key: 'matchesFilter',
	        value: function matchesFilter(outgoingWebhook, channel, filter) {
	            if (!filter) {
	                return true;
	            }
	
	            if (outgoingWebhook.display_name.toLowerCase().indexOf(filter) !== -1 || outgoingWebhook.description.toLowerCase().indexOf(filter) !== -1) {
	                return true;
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(outgoingWebhook.trigger_words), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var trigger = _step.value;
	
	                    if (trigger.toLowerCase().indexOf(filter) !== -1) {
	                        return true;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (channel) {
	                if (channel && channel.name.toLowerCase().indexOf(filter) !== -1) {
	                    return true;
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var outgoingWebhook = this.props.outgoingWebhook;
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].get(outgoingWebhook.channel_id);
	
	            if (!this.matchesFilter(outgoingWebhook, channel, this.props.filter)) {
	                return null;
	            }
	
	            var displayName = void 0;
	            if (outgoingWebhook.display_name) {
	                displayName = outgoingWebhook.display_name;
	            } else if (channel) {
	                displayName = channel.display_name;
	            } else {
	                displayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                    id: 'installed_outgoing_webhooks.unknown_channel',
	                    defaultMessage: 'A Private Webhook'
	                });
	            }
	
	            var description = null;
	            if (outgoingWebhook.description) {
	                description = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details__row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'span',
	                        { className: 'item-details__description' },
	                        outgoingWebhook.description
	                    )
	                );
	            }
	
	            var triggerWords = null;
	            if (outgoingWebhook.trigger_words && outgoingWebhook.trigger_words.length > 0) {
	                triggerWords = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details__row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'span',
	                        { className: 'item-details__trigger-words' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'installed_integrations.triggerWords',
	                            defaultMessage: 'Trigger Words: {triggerWords}',
	                            values: {
	                                triggerWords: outgoingWebhook.trigger_words.join(', ')
	                            }
	                        })
	                    )
	                );
	            }
	
	            var urls = [];
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default.a.bind()(outgoingWebhook.callback_urls), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var url = _step2.value;
	
	                    urls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        {
	                            key: url,
	                            className: 'item-details__url'
	                        },
	                        url
	                    ));
	                    urls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br', {
	                        key: 'BR' + url
	                    }));
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'backstage-list__item' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'item-details' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__name' },
	                            displayName
	                        )
	                    ),
	                    description,
	                    triggerWords,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__token' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'installed_integrations.token',
	                                defaultMessage: 'Token: {token}',
	                                values: {
	                                    token: outgoingWebhook.token
	                                }
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__creation' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'installed_integrations.creation',
	                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
	                                values: {
	                                    creator: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.displayUsername(outgoingWebhook.creator_id),
	                                    createAt: outgoingWebhook.create_at
	                                }
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'item-details__row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'span',
	                            { className: 'item-details__urls' },
	                            urls
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'item-actions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handleRegenToken
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'installed_integrations.regenToken',
	                            defaultMessage: 'Regen Token'
	                        })
	                    ),
	                    ' - ',
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handleDelete
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'installed_integrations.delete',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InstalledOutgoingWebhook;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledOutgoingWebhook;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__ = __webpack_require__(252);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__installed_outgoing_webhook_jsx__ = __webpack_require__(679);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__installed_integrations_jsx__ = __webpack_require__(245);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	var InstalledOutgoingWebhooks = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InstalledOutgoingWebhooks, _React$Component);
	
	    function InstalledOutgoingWebhooks(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InstalledOutgoingWebhooks);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InstalledOutgoingWebhooks).call(this, props));
	
	        _this.handleIntegrationChange = _this.handleIntegrationChange.bind(_this);
	
	        _this.regenOutgoingWebhookToken = _this.regenOutgoingWebhookToken.bind(_this);
	        _this.deleteOutgoingWebhook = _this.deleteOutgoingWebhook.bind(_this);
	
	        var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentId();
	
	        _this.state = {
	            outgoingWebhooks: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].getOutgoingWebhooks(teamId),
	            loading: !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].hasReceivedOutgoingWebhooks(teamId)
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(InstalledOutgoingWebhooks, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].addChangeListener(this.handleIntegrationChange);
	
	            if (window.mm_config.EnableOutgoingWebhooks === 'true') {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.listOutgoingHooks();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].removeChangeListener(this.handleIntegrationChange);
	        }
	    }, {
	        key: 'handleIntegrationChange',
	        value: function handleIntegrationChange() {
	            var teamId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getCurrentId();
	
	            this.setState({
	                outgoingWebhooks: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].getOutgoingWebhooks(teamId),
	                loading: !/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_integration_store_jsx__["a"].hasReceivedOutgoingWebhooks(teamId)
	            });
	        }
	    }, {
	        key: 'regenOutgoingWebhookToken',
	        value: function regenOutgoingWebhookToken(outgoingWebhook) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.regenOutgoingHookToken(outgoingWebhook.id);
	        }
	    }, {
	        key: 'deleteOutgoingWebhook',
	        value: function deleteOutgoingWebhook(outgoingWebhook) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.deleteOutgoingHook(outgoingWebhook.id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var outgoingWebhooks = this.state.outgoingWebhooks.map(function (outgoingWebhook) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__installed_outgoing_webhook_jsx__["a"], {
	                    key: outgoingWebhook.id,
	                    outgoingWebhook: outgoingWebhook,
	                    onRegenToken: _this2.regenOutgoingWebhookToken,
	                    onDelete: _this2.deleteOutgoingWebhook
	                });
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12__installed_integrations_jsx__["a"],
	                {
	                    header: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_outgoing_webhooks.header',
	                        defaultMessage: 'Installed Outgoing Webhooks'
	                    }),
	                    addText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_outgoing_webhooks.add',
	                        defaultMessage: 'Add Outgoing Webhook'
	                    }),
	                    addLink: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/outgoing_webhooks/add',
	                    emptyText: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                        id: 'installed_outgoing_webhooks.empty',
	                        defaultMessage: 'No outgoing webhooks found'
	                    }),
	                    loading: this.state.loading
	                },
	                outgoingWebhooks
	            );
	        }
	    }]);
	
	    return InstalledOutgoingWebhooks;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = InstalledOutgoingWebhooks;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router___default = __WEBPACK_IMPORTED_MODULE_6_react_router__ && __WEBPACK_IMPORTED_MODULE_6_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var IntegrationOption = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(IntegrationOption, _React$Component);
	
	    function IntegrationOption() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, IntegrationOption);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(IntegrationOption).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(IntegrationOption, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var image = _props.image;
	            var title = _props.title;
	            var description = _props.description;
	            var link = _props.link;
	
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_router__["Link"],
	                {
	                    to: link,
	                    className: 'integration-option'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
	                    className: 'integration-option__image',
	                    src: image
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'integration-option__title' },
	                    title
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'integration-option__description' },
	                    description
	                )
	            );
	        }
	    }], [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                image: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired,
	                title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                description: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node.isRequired,
	                link: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired
	            };
	        }
	    }]);
	
	    return IntegrationOption;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = IntegrationOption;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integration_option_jsx__ = __webpack_require__(681);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg__ = __webpack_require__(388);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg___default = __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg__ && __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var Integrations = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Integrations, _React$Component);
	
	    function Integrations() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Integrations);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Integrations).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Integrations, [{
	        key: 'render',
	        value: function render() {
	            var options = [];
	
	            if (window.mm_config.EnableIncomingWebhooks === 'true') {
	                options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__integration_option_jsx__["a"], {
	                    key: 'incomingWebhook',
	                    image: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg___default.a,
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'integrations.incomingWebhook.title',
	                        defaultMessage: 'Incoming Webhook'
	                    }),
	                    description: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'integrations.incomingWebhook.description',
	                        defaultMessage: 'Incoming webhooks allow external integrations to send messages'
	                    }),
	                    link: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/incoming_webhooks'
	                }));
	            }
	
	            if (window.mm_config.EnableOutgoingWebhooks === 'true') {
	                options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__integration_option_jsx__["a"], {
	                    key: 'outgoingWebhook',
	                    image: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg___default.a,
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'integrations.outgoingWebhook.title',
	                        defaultMessage: 'Outgoing Webhook'
	                    }),
	                    description: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'integrations.outgoingWebhook.description',
	                        defaultMessage: 'Outgoing webhooks allow external integrations to receive and respond to messages'
	                    }),
	                    link: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/outgoing_webhooks'
	                }));
	            }
	
	            if (window.mm_config.EnableCommands === 'true') {
	                options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__integration_option_jsx__["a"], {
	                    key: 'command',
	                    image: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_images_webhook_icon_jpg___default.a,
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'integrations.command.title',
	                        defaultMessage: 'Slash Command'
	                    }),
	                    description: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'integrations.command.description',
	                        defaultMessage: 'Slash commands send events to an external integration'
	                    }),
	                    link: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations/commands'
	                }));
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'backstage-content row' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'backstage-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'h1',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'integrations.header',
	                            defaultMessage: 'Integrations'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    null,
	                    options
	                )
	            );
	        }
	    }]);
	
	    return Integrations;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Integrations;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var ChangeUrlModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChangeUrlModal, _React$Component);
	
	    function ChangeUrlModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChangeUrlModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChangeUrlModal).call(this, props));
	
	        _this.onURLChanged = _this.onURLChanged.bind(_this);
	        _this.doSubmit = _this.doSubmit.bind(_this);
	        _this.doCancel = _this.doCancel.bind(_this);
	
	        _this.state = {
	            currentURL: props.currentURL,
	            urlError: '',
	            userEdit: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChangeUrlModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // This check prevents the url being deleted when we re-render
	            // because of user status check
	            if (!this.state.userEdit) {
	                this.setState({
	                    currentURL: nextProps.currentURL
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.show === true && prevProps.show === false) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.urlinput).select();
	            }
	        }
	    }, {
	        key: 'onURLChanged',
	        value: function onURLChanged(e) {
	            var url = e.target.value.trim();
	            this.setState({ currentURL: url.replace(/[^A-Za-z0-9-_]/g, '').toLowerCase(), userEdit: true });
	        }
	    }, {
	        key: 'getURLError',
	        value: function getURLError(url) {
	            var error = []; //eslint-disable-line prefer-const
	            if (url.length < 2) {
	                error.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'span',
	                    { key: 'error1' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'change_url.longer',
	                        defaultMessage: 'Must be longer than two characters'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	                ));
	            }
	            if (url.charAt(0) === '-' || url.charAt(0) === '_') {
	                error.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'span',
	                    { key: 'error2' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'change_url.startWithLetter',
	                        defaultMessage: 'Must start with a letter or number'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	                ));
	            }
	            if (url.length > 1 && (url.charAt(url.length - 1) === '-' || url.charAt(url.length - 1) === '_')) {
	                error.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'span',
	                    { key: 'error3' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'change_url.endWithLetter',
	                        defaultMessage: 'Must end with a letter or number'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	                ));
	            }
	            if (url.indexOf('__') > -1) {
	                error.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'span',
	                    { key: 'error4' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'change_url.noUnderscore',
	                        defaultMessage: 'Can not contain two underscores in a row.'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	                ));
	            }
	
	            // In case of error we don't detect
	            if (error.length === 0) {
	                error.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'span',
	                    { key: 'errorlast' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'change_url.invalidUrl',
	                        defaultMessage: 'Invalid URL'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	                ));
	            }
	            return error;
	        }
	    }, {
	        key: 'doSubmit',
	        value: function doSubmit(e) {
	            e.preventDefault();
	
	            var url = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.urlinput).value;
	            var cleanedURL = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.cleanUpUrlable(url);
	            if (cleanedURL !== url || url.length < 2 || url.indexOf('__') > -1) {
	                this.setState({ urlError: this.getURLError(url) });
	                return;
	            }
	            this.setState({ urlError: '', userEdit: false });
	            this.props.onModalSubmit(url);
	        }
	    }, {
	        key: 'doCancel',
	        value: function doCancel() {
	            this.setState({ urlError: '', userEdit: false });
	            this.props.onModalDismissed();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var urlClass = 'input-group input-group--limit';
	            var urlError = null;
	            var serverError = null;
	
	            if (this.state.urlError) {
	                urlClass += ' has-error';
	                urlError = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'p',
	                    { className: 'input__help error' },
	                    this.state.urlError
	                );
	            }
	
	            if (this.props.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'p',
	                        { className: 'input__help error' },
	                        this.props.serverError
	                    )
	                );
	            }
	
	            var fullTeamUrl = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getTeamURLFromAddressBar();
	            var teamURL = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getShortenedTeamURL();
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.doCancel
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Title,
	                        null,
	                        this.props.title
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'form',
	                    {
	                        role: 'form',
	                        className: 'form-horizontal'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Body,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-intro' },
	                            this.props.description
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-2 form__label control-label' },
	                                this.props.urlLabel
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-10' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                    'div',
	                                    { className: urlClass },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                        'span',
	                                        {
	                                            'data-toggle': 'tooltip',
	                                            title: fullTeamUrl,
	                                            className: 'input-group-addon'
	                                        },
	                                        teamURL
	                                    ),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('input', {
	                                        type: 'text',
	                                        ref: 'urlinput',
	                                        className: 'form-control',
	                                        maxLength: '22',
	                                        onChange: this.onURLChanged,
	                                        value: this.state.currentURL,
	                                        autoFocus: true,
	                                        tabIndex: '1'
	                                    })
	                                ),
	                                urlError,
	                                serverError
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["Modal"].Footer,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-default',
	                                onClick: this.doCancel
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'change_url.close',
	                                defaultMessage: 'Close'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'button',
	                            {
	                                onClick: this.doSubmit,
	                                type: 'submit',
	                                className: 'btn btn-primary',
	                                tabIndex: '2'
	                            },
	                            this.props.submitButtonText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChangeUrlModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChangeUrlModal;
	
	
	ChangeUrlModal.defaultProps = {
	    show: false,
	    title: 'Change URL',
	    desciption: '',
	    urlLabel: 'URL',
	    submitButtonText: 'Save',
	    currentURL: '',
	    serverError: ''
	};
	
	ChangeUrlModal.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool.isRequired,
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    description: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    urlLabel: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    submitButtonText: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    currentURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    onModalSubmit: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_spinner_button_jsx__ = __webpack_require__(159);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var ChannelInviteButton = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelInviteButton, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ChannelInviteButton, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                user: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	                channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	                onInviteError: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func.isRequired
	            };
	        }
	    }]);
	
	    function ChannelInviteButton(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelInviteButton);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelInviteButton).call(this, props));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	
	        _this.state = {
	            addingUser: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ChannelInviteButton, [{
	        key: 'handleClick',
	        value: function handleClick() {
	            var _this2 = this;
	
	            if (this.state.addingUser) {
	                return;
	            }
	
	            this.setState({
	                addingUser: true
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].addChannelMember(this.props.channel.id, this.props.user.id, function () {
	                _this2.setState({
	                    addingUser: false
	                });
	
	                _this2.props.onInviteError(null);
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.getChannelExtraInfo();
	            }, function (err) {
	                _this2.setState({
	                    addingUser: false
	                });
	
	                _this2.props.onInviteError(err);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_components_spinner_button_jsx__["a"],
	                {
	                    className: 'btn btn-sm btn-primary',
	                    onClick: this.handleClick,
	                    spinning: this.state.addingUser
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('i', { className: 'glyphicon glyphicon-envelope' }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                    id: 'channel_invite.add',
	                    defaultMessage: ' Add'
	                })
	            );
	        }
	    }]);
	
	    return ChannelInviteButton;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelInviteButton;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_channel_header_jsx__ = __webpack_require__(352);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_file_upload_overlay_jsx__ = __webpack_require__(361);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_create_post_jsx__ = __webpack_require__(693);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_posts_view_container_jsx__ = __webpack_require__(732);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ChannelView = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ChannelView, _React$Component);
	
	    function ChannelView(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ChannelView);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ChannelView).call(this, props));
	
	        _this.getStateFromStores = _this.getStateFromStores.bind(_this);
	        _this.isStateValid = _this.isStateValid.bind(_this);
	        _this.updateState = _this.updateState.bind(_this);
	
	        _this.state = _this.getStateFromStores(props);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ChannelView, [{
	        key: 'getStateFromStores',
	        value: function getStateFromStores(props) {
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_channel_store_jsx__["a"].getByName(props.params.channel);
	            var channelId = channel ? channel.id : '';
	            return {
	                channelId: channelId
	            };
	        }
	    }, {
	        key: 'isStateValid',
	        value: function isStateValid() {
	            return this.state.channelId !== '';
	        }
	    }, {
	        key: 'updateState',
	        value: function updateState() {
	            this.setState(this.getStateFromStores(this.props));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_channel_store_jsx__["a"].addChangeListener(this.updateState);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').addClass('app__body');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_channel_store_jsx__["a"].removeChangeListener(this.updateState);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').removeClass('app__body');
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState(this.getStateFromStores(nextProps));
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(nextProps.params, this.props.params)) {
	                return true;
	            }
	
	            if (nextState.channelId !== this.state.channelId) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                {
	                    id: 'app-content',
	                    className: 'app__content'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_components_file_upload_overlay_jsx__["a"], { overlayType: 'center' }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_components_channel_header_jsx__["a"], {
	                    channelId: this.state.channelId
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_components_posts_view_container_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'post-create__container',
	                        id: 'post-create'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_components_create_post_jsx__["a"], null)
	                )
	            );
	        }
	    }]);
	
	    return ChannelView;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ChannelView;
	
	ChannelView.defaultProps = {};
	
	ChannelView.propTypes = {
	    params: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_logo_png__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_logo_png___default = __WEBPACK_IMPORTED_MODULE_8_images_logo_png__ && __WEBPACK_IMPORTED_MODULE_8_images_logo_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_images_logo_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_images_logo_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_images_logo_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_images_logo_png___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var Claim = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Claim, _React$Component);
	
	    function Claim(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Claim);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Claim).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Claim, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                email: this.props.location.query.email,
	                newType: this.props.location.query.new_type,
	                oldType: this.props.location.query.old_type
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                        { to: '/' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'web.header.back'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
	                            className: 'signup-team-logo',
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_images_logo_png___default.a
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { id: 'claim' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(this.props.children, {
	                                currentType: this.state.oldType,
	                                newType: this.state.newType,
	                                email: this.state.email
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Claim;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Claim;
	
	
	Claim.defaultProps = {};
	Claim.propTypes = {
	    location: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.node
	};

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var EmailToLDAP = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(EmailToLDAP, _React$Component);
	
	    function EmailToLDAP(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EmailToLDAP);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EmailToLDAP).call(this, props));
	
	        _this.submit = _this.submit.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(EmailToLDAP, [{
	        key: 'submit',
	        value: function submit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var state = {};
	
	            var password = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.emailpassword).value.trim();
	            if (!password) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_ldap.pwdError', 'Please enter your password.');
	                this.setState(state);
	                return;
	            }
	
	            var ldapId = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.ldapid).value.trim();
	            if (!ldapId) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_ldap.ldapIdError', 'Please enter your LDAP ID.');
	                this.setState(state);
	                return;
	            }
	
	            var ldapPassword = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.ldappassword).value.trim();
	            if (!ldapPassword) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_ldap.ldapPasswordError', 'Please enter your LDAP password.');
	                this.setState(state);
	                return;
	            }
	
	            state.error = null;
	            this.setState(state);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].emailToLdap(this.props.email, password, ldapId, ldapPassword, function (data) {
	                if (data.follow_link) {
	                    window.location.href = data.follow_link;
	                }
	            }, function (error) {
	                _this2.setState({ error: error });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var formClass = 'form-group';
	            if (error) {
	                formClass += ' has-error';
	            }
	
	            var loginPlaceholder = void 0;
	            if (global.window.mm_config.LdapLoginFieldName) {
	                loginPlaceholder = global.window.mm_config.LdapLoginFieldName;
	            } else {
	                loginPlaceholder = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_ldap.ldapId', 'LDAP ID');
	            }
	
	            var passwordPlaceholder = void 0;
	            if (global.window.mm_config.LdapPasswordFieldName) {
	                passwordPlaceholder = global.window.mm_config.LdapPasswordFieldName;
	            } else {
	                passwordPlaceholder = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_ldap.ldapPwd', 'LDAP Password');
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'claim.email_to_ldap.title',
	                        defaultMessage: 'Switch Email/Password Account to LDAP'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'form',
	                    { onSubmit: this.submit },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_ldap.ssoType',
	                            defaultMessage: 'Upon claiming your account, you will only be able to login with LDAP'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_ldap.ssoNote',
	                            defaultMessage: 'You must already have a valid LDAP account'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_ldap.enterPwd',
	                            defaultMessage: 'Enter the password for your {site} email account',
	                            values: {
	                                site: global.window.mm_config.SiteName
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                        type: 'text',
	                        style: { display: 'none' },
	                        name: 'fakeusernameremembered'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'emailPassword',
	                            ref: 'emailpassword',
	                            autoComplete: 'off',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_ldap.pwd', 'Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_ldap.enterLdapPwd',
	                            defaultMessage: 'Enter the ID and password for your LDAP account'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            name: 'ldapId',
	                            ref: 'ldapid',
	                            autoComplete: 'off',
	                            placeholder: loginPlaceholder,
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'ldapPassword',
	                            ref: 'ldappassword',
	                            autoComplete: 'off',
	                            placeholder: passwordPlaceholder,
	                            spellCheck: 'false'
	                        })
	                    ),
	                    error,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-primary'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_ldap.switchTo',
	                            defaultMessage: 'Switch account to LDAP'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmailToLDAP;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = EmailToLDAP;
	
	
	EmailToLDAP.defaultProps = {};
	EmailToLDAP.propTypes = {
	    email: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var EmailToOAuth = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(EmailToOAuth, _React$Component);
	
	    function EmailToOAuth(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EmailToOAuth);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EmailToOAuth).call(this, props));
	
	        _this.submit = _this.submit.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(EmailToOAuth, [{
	        key: 'submit',
	        value: function submit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var state = {};
	
	            var password = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.password).value.trim();
	            if (!password) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_oauth.pwdError', 'Please enter your password.');
	                this.setState(state);
	                return;
	            }
	
	            state.error = null;
	            this.setState(state);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].emailToOAuth(this.props.email, password, this.props.newType, function (data) {
	                if (data.follow_link) {
	                    window.location.href = data.follow_link;
	                }
	            }, function (error) {
	                _this2.setState({ error: error });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var formClass = 'form-group';
	            if (error) {
	                formClass += ' has-error';
	            }
	
	            var uiType = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.toTitleCase(this.props.newType) + ' SSO';
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'claim.email_to_oauth.title',
	                        defaultMessage: 'Switch Email/Password Account to {uiType}',
	                        values: {
	                            uiType: uiType
	                        }
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'form',
	                    { onSubmit: this.submit },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_oauth.ssoType',
	                            defaultMessage: 'Upon claiming your account, you will only be able to login with {type} SSO',
	                            values: {
	                                type: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.toTitleCase(this.props.newType)
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_oauth.ssoNote',
	                            defaultMessage: 'You must already have a valid {type} account',
	                            values: {
	                                type: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.toTitleCase(this.props.newType)
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_oauth.enterPwd',
	                            defaultMessage: 'Enter the password for your {site} account',
	                            values: {
	                                site: global.window.mm_config.SiteName
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'password',
	                            ref: 'password',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.email_to_oauth.pwd', 'Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    error,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-primary'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.email_to_oauth.switchTo',
	                            defaultMessage: 'Switch account to {uiType}',
	                            values: {
	                                uiType: uiType
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmailToOAuth;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = EmailToOAuth;
	
	
	EmailToOAuth.defaultProps = {};
	EmailToOAuth.propTypes = {
	    newType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string,
	    email: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var LDAPToEmail = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LDAPToEmail, _React$Component);
	
	    function LDAPToEmail(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LDAPToEmail);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LDAPToEmail).call(this, props));
	
	        _this.submit = _this.submit.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LDAPToEmail, [{
	        key: 'submit',
	        value: function submit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var state = {};
	
	            var password = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.password).value.trim();
	            if (!password) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.ldap_to_email.pwdError', 'Please enter your password.');
	                this.setState(state);
	                return;
	            }
	
	            var confirmPassword = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.passwordconfirm).value.trim();
	            if (!confirmPassword || password !== confirmPassword) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.ldap_to_email.pwdNotMatch', 'Passwords do not match.');
	                this.setState(state);
	                return;
	            }
	
	            var ldapPassword = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.ldappassword).value.trim();
	            if (!ldapPassword) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.ldap_to_email.ldapPasswordError', 'Please enter your LDAP password.');
	                this.setState(state);
	                return;
	            }
	
	            state.error = null;
	            this.setState(state);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].ldapToEmail(this.props.email, password, ldapPassword, function (data) {
	                if (data.follow_link) {
	                    window.location.href = data.follow_link;
	                }
	            }, function (error) {
	                _this2.setState({ error: error });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var formClass = 'form-group';
	            if (error) {
	                formClass += ' has-error';
	            }
	
	            var passwordPlaceholder = void 0;
	            if (global.window.mm_config.LdapPasswordFieldName) {
	                passwordPlaceholder = global.window.mm_config.LdapPasswordFieldName;
	            } else {
	                passwordPlaceholder = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.ldap_to_email.ldapPwd', 'LDAP Password');
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'claim.ldap_to_email.title',
	                        defaultMessage: 'Switch LDAP Account to Email/Password'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'form',
	                    { onSubmit: this.submit },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.ldap_to_email.ssoType',
	                            defaultMessage: 'Upon claiming your account, you will only be able to login with your email and password'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.ldap_to_email.email',
	                            defaultMessage: 'You will use the email {email} to login',
	                            values: {
	                                email: this.props.email
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.ldap_to_email.enterLdapPwd',
	                            defaultMessage: 'Enter your {ldapPassword} for your {site} email account',
	                            values: {
	                                ldapPassword: passwordPlaceholder,
	                                site: global.window.mm_config.SiteName
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'ldapPassword',
	                            ref: 'ldappassword',
	                            placeholder: passwordPlaceholder,
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.ldap_to_email.enterPwd',
	                            defaultMessage: 'Enter a new password for your email account'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'password',
	                            ref: 'password',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.ldap_to_email.pwd', 'Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'passwordconfirm',
	                            ref: 'passwordconfirm',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.ldap_to_email.confirm', 'Confirm Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    error,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-primary'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.ldap_to_email.switchTo',
	                            defaultMessage: 'Switch account to email/password'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LDAPToEmail;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = LDAPToEmail;
	
	
	LDAPToEmail.defaultProps = {};
	LDAPToEmail.propTypes = {
	    email: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router___default = __WEBPACK_IMPORTED_MODULE_10_react_router__ && __WEBPACK_IMPORTED_MODULE_10_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var OAuthToEmail = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(OAuthToEmail, _React$Component);
	
	    function OAuthToEmail(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, OAuthToEmail);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(OAuthToEmail).call(this, props));
	
	        _this.submit = _this.submit.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(OAuthToEmail, [{
	        key: 'submit',
	        value: function submit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var state = {};
	
	            var password = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.password).value.trim();
	            if (!password) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.oauth_to_email.enterPwd', 'Please enter a password.');
	                this.setState(state);
	                return;
	            }
	
	            var confirmPassword = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.passwordconfirm).value.trim();
	            if (!confirmPassword || password !== confirmPassword) {
	                state.error = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.oauth_to_email.pwdNotMatch', 'Password do not match.');
	                this.setState(state);
	                return;
	            }
	
	            state.error = null;
	            this.setState(state);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].oauthToEmail(this.props.email, password, function (data) {
	                if (data.follow_link) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_router__["browserHistory"].push(data.follow_link);
	                }
	            }, function (error) {
	                _this2.setState({ error: error });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var formClass = 'form-group';
	            if (error) {
	                formClass += ' has-error';
	            }
	
	            var uiType = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.toTitleCase(this.props.currentType) + ' SSO';
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'claim.oauth_to_email.title',
	                        defaultMessage: 'Switch {type} Account to Email',
	                        values: {
	                            type: uiType
	                        }
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'form',
	                    { onSubmit: this.submit },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.oauth_to_email.description',
	                            defaultMessage: 'Upon changing your account type, you will only be able to login with your email and password.'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.oauth_to_email.enterNewPwd',
	                            defaultMessage: 'Enter a new password for your {site} account',
	                            values: {
	                                site: global.window.mm_config.SiteName
	                            }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'password',
	                            ref: 'password',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.oauth_to_email.newPwd', 'New Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: formClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'passwordconfirm',
	                            ref: 'passwordconfirm',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('claim.oauth_to_email.confirm', 'Confirm Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    error,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-primary'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'claim.oauth_to_email.switchTo',
	                            defaultMessage: 'Switch {type} to email and password',
	                            values: {
	                                type: uiType
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OAuthToEmail;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = OAuthToEmail;
	
	
	OAuthToEmail.defaultProps = {};
	OAuthToEmail.propTypes = {
	    currentType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string,
	    email: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_syntax_hightlighting_jsx__ = __webpack_require__(377);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__file_info_preview_jsx__ = __webpack_require__(248);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var CodePreview = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(CodePreview, _React$Component);
	
	    function CodePreview(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CodePreview);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(CodePreview).call(this, props));
	
	        _this.updateStateFromProps = _this.updateStateFromProps.bind(_this);
	        _this.handleReceivedError = _this.handleReceivedError.bind(_this);
	        _this.handleReceivedCode = _this.handleReceivedCode.bind(_this);
	
	        _this.state = {
	            code: '',
	            lang: '',
	            loading: true,
	            success: true
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(CodePreview, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.updateStateFromProps(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.fileUrl !== nextProps.fileUrl) {
	                this.updateStateFromProps(nextProps);
	            }
	        }
	    }, {
	        key: 'updateStateFromProps',
	        value: function updateStateFromProps(props) {
	            var usedLanguage = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_syntax_hightlighting_jsx__.getLang(props.filename);
	
	            if (!usedLanguage || props.fileInfo.size > /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].CODE_PREVIEW_MAX_FILE_SIZE) {
	                this.setState({ code: '', lang: '', loading: false, success: false });
	                return;
	            }
	
	            this.setState({ code: '', lang: usedLanguage, loading: true });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
	                async: true,
	                url: props.fileUrl,
	                type: 'GET',
	                error: this.handleReceivedError,
	                success: this.handleReceivedCode
	            });
	        }
	    }, {
	        key: 'handleReceivedCode',
	        value: function handleReceivedCode(data) {
	            var parsed = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_syntax_hightlighting_jsx__.formatCode(this.state.lang, data, this.props.filename);
	            this.setState({ code: parsed, loading: false, success: true });
	        }
	    }, {
	        key: 'handleReceivedError',
	        value: function handleReceivedError() {
	            this.setState({ loading: false, success: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.loading) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'view-image__loading' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                        className: 'loader-image',
	                        src: '/static/images/load.gif'
	                    })
	                );
	            }
	
	            if (!this.state.success) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__file_info_preview_jsx__["a"], {
	                    filename: this.props.filename,
	                    fileUrl: this.props.fileUrl,
	                    fileInfo: this.props.fileInfo,
	                    formatMessage: this.props.formatMessage
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.code } });
	        }
	    }], [{
	        key: 'support',
	        value: function support(filename) {
	            return typeof /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_syntax_hightlighting_jsx__.getLang(filename) !== 'undefined';
	        }
	    }]);
	
	    return CodePreview;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = CodePreview;
	
	
	CodePreview.propTypes = {
	    filename: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string.isRequired,
	    fileUrl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string.isRequired,
	    fileInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object.isRequired,
	    formatMessage: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__post_deleted_modal_jsx__ = __webpack_require__(366);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__textbox_jsx__ = __webpack_require__(251);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__msg_typing_jsx__ = __webpack_require__(363);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__file_upload_jsx__ = __webpack_require__(360);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__file_preview_jsx__ = __webpack_require__(359);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_intl___default = __WEBPACK_IMPORTED_MODULE_22_react_intl__ && __WEBPACK_IMPORTED_MODULE_22_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_22_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_22_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_22_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_22_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __WEBPACK_IMPORTED_MODULE_23_react__ && __WEBPACK_IMPORTED_MODULE_23_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_23_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_23_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_23_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_23_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].ActionTypes;
	var KeyCodes = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].KeyCodes;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["defineMessages"].bind()({
	    commentLength: {
	        id: 'create_comment.commentLength',
	        defaultMessage: 'Comment length must be less than {max} characters.'
	    },
	    comment: {
	        id: 'create_comment.comment',
	        defaultMessage: 'Add Comment'
	    },
	    addComment: {
	        id: 'create_comment.addComment',
	        defaultMessage: 'Add a comment...'
	    },
	    commentTitle: {
	        id: 'create_comment.commentTitle',
	        defaultMessage: 'Comment'
	    }
	});
	
	
	
	var CreateComment = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(CreateComment, _React$Component);
	
	    function CreateComment(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CreateComment);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(CreateComment).call(this, props));
	
	        _this.lastTime = 0;
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.commentMsgKeyPress = _this.commentMsgKeyPress.bind(_this);
	        _this.handleUserInput = _this.handleUserInput.bind(_this);
	        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	        _this.handleUploadClick = _this.handleUploadClick.bind(_this);
	        _this.handleUploadStart = _this.handleUploadStart.bind(_this);
	        _this.handleFileUploadComplete = _this.handleFileUploadComplete.bind(_this);
	        _this.handleUploadError = _this.handleUploadError.bind(_this);
	        _this.removePreview = _this.removePreview.bind(_this);
	        _this.getFileCount = _this.getFileCount.bind(_this);
	        _this.onPreferenceChange = _this.onPreferenceChange.bind(_this);
	        _this.focusTextbox = _this.focusTextbox.bind(_this);
	        _this.showPostDeletedModal = _this.showPostDeletedModal.bind(_this);
	        _this.hidePostDeletedModal = _this.hidePostDeletedModal.bind(_this);
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].clearCommentDraftUploads();
	
	        var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(_this.props.rootId);
	        _this.state = {
	            messageText: draft.message,
	            uploadsInProgress: draft.uploadsInProgress,
	            previews: draft.previews,
	            submitting: false,
	            ctrlSend: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
	            showPostDeletedModal: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(CreateComment, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].addChangeListener(this.onPreferenceChange);
	            this.focusTextbox();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].removeChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'onPreferenceChange',
	        value: function onPreferenceChange() {
	            this.setState({
	                ctrlSend: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter')
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.uploadsInProgress < this.state.uploadsInProgress) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.post-right__scroll').scrollTop(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.post-right__scroll')[0].scrollHeight);
	            }
	
	            if (prevProps.rootId !== this.props.rootId) {
	                this.focusTextbox();
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (this.state.uploadsInProgress.length > 0) {
	                return;
	            }
	
	            if (this.state.submitting) {
	                return;
	            }
	
	            var post = {};
	            post.filenames = [];
	            post.message = this.state.messageText;
	
	            if (post.message.trim().length === 0 && this.state.previews.length === 0) {
	                return;
	            }
	
	            if (post.message.length > /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].CHARACTER_LIMIT) {
	                this.setState({ postError: this.props.intl.formatMessage(holders.commentLength, { max: /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].CHARACTER_LIMIT }) });
	                return;
	            }
	
	            var userId = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentId();
	
	            post.channel_id = this.props.channelId;
	            post.root_id = this.props.rootId;
	            post.parent_id = this.props.rootId;
	            post.filenames = this.state.previews;
	            var time = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_19_utils_utils_jsx__.getTimestamp();
	            post.pending_post_id = userId + ':' + time;
	            post.user_id = userId;
	            post.create_at = time;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storePendingPost(post);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storeCommentDraft(this.props.rootId, null);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].createPost(post, function (data) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.getPosts(_this2.props.channelId);
	
	                var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].get(_this2.props.channelId);
	                var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].getMember(_this2.props.channelId);
	                member.msg_count = channel.total_msg_count;
	                member.last_viewed_at = Date.now();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_channel_store_jsx__["a"].setChannelMember(member);
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_POST,
	                    post: data
	                });
	            }, function (err) {
	                if (err.id === 'api.post.create_post.root_id.app_error') {
	                    _this2.showPostDeletedModal();
	
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].removePendingPost(post.channel_id, post.pending_post_id);
	                } else {
	                    post.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].POST_FAILED;
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].updatePendingPost(post);
	                }
	
	                _this2.setState({
	                    submitting: false
	                });
	            });
	
	            this.setState({
	                messageText: '',
	                submitting: false,
	                postError: null,
	                previews: [],
	                serverError: null
	            });
	        }
	    }, {
	        key: 'commentMsgKeyPress',
	        value: function commentMsgKeyPress(e) {
	            if (this.state.ctrlSend && e.ctrlKey || !this.state.ctrlSend) {
	                if (e.which === KeyCodes.ENTER && !e.shiftKey && !e.altKey) {
	                    e.preventDefault();
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.textbox).blur();
	                    this.handleSubmit(e);
	                }
	            }
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_20_action_creators_global_actions_jsx__.emitLocalUserTypingEvent(this.props.channelId, this.props.rootId);
	        }
	    }, {
	        key: 'handleUserInput',
	        value: function handleUserInput(messageText) {
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(this.props.rootId);
	            draft.message = messageText;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storeCommentDraft(this.props.rootId, draft);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.post-right__scroll').parent().scrollTop(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.post-right__scroll')[0].scrollHeight);
	            this.setState({ messageText: messageText });
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            if (this.state.ctrlSend && e.keyCode === KeyCodes.ENTER && e.ctrlKey === true) {
	                this.commentMsgKeyPress(e);
	                return;
	            }
	
	            if (e.keyCode === KeyCodes.UP && this.state.messageText === '') {
	                e.preventDefault();
	
	                var lastPost = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCurrentUsersLatestPost(this.props.channelId, this.props.rootId);
	                if (!lastPost) {
	                    return;
	                }
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	                    type: ActionTypes.RECEIVED_EDIT_POST,
	                    refocusId: '#reply_textbox',
	                    title: this.props.intl.formatMessage(holders.commentTitle),
	                    message: lastPost.message,
	                    postId: lastPost.id,
	                    channelId: lastPost.channel_id,
	                    comments: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentCount(lastPost)
	                });
	            }
	        }
	    }, {
	        key: 'handleUploadClick',
	        value: function handleUploadClick() {
	            this.focusTextbox();
	        }
	    }, {
	        key: 'handleUploadStart',
	        value: function handleUploadStart(clientIds) {
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(this.props.rootId);
	
	            draft.uploadsInProgress = draft.uploadsInProgress.concat(clientIds);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storeCommentDraft(this.props.rootId, draft);
	
	            this.setState({ uploadsInProgress: draft.uploadsInProgress });
	
	            // this is a bit redundant with the code that sets focus when the file input is clicked,
	            // but this also resets the focus after a drag and drop
	            this.focusTextbox();
	        }
	    }, {
	        key: 'handleFileUploadComplete',
	        value: function handleFileUploadComplete(filenames, clientIds) {
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(this.props.rootId);
	
	            // remove each finished file from uploads
	            for (var i = 0; i < clientIds.length; i++) {
	                var index = draft.uploadsInProgress.indexOf(clientIds[i]);
	
	                if (index !== -1) {
	                    draft.uploadsInProgress.splice(index, 1);
	                }
	            }
	
	            draft.previews = draft.previews.concat(filenames);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storeCommentDraft(this.props.rootId, draft);
	
	            this.setState({ uploadsInProgress: draft.uploadsInProgress, previews: draft.previews });
	        }
	    }, {
	        key: 'handleUploadError',
	        value: function handleUploadError(err, clientId) {
	            if (clientId === -1) {
	                this.setState({ serverError: err });
	            } else {
	                var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(this.props.rootId);
	
	                var index = draft.uploadsInProgress.indexOf(clientId);
	                if (index !== -1) {
	                    draft.uploadsInProgress.splice(index, 1);
	                }
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storeCommentDraft(this.props.rootId, draft);
	
	                this.setState({ uploadsInProgress: draft.uploadsInProgress, serverError: err });
	            }
	        }
	    }, {
	        key: 'removePreview',
	        value: function removePreview(id) {
	            var previews = this.state.previews;
	            var uploadsInProgress = this.state.uploadsInProgress;
	
	            // id can either be the path of an uploaded file or the client id of an in progress upload
	            var index = previews.indexOf(id);
	            if (index === -1) {
	                index = uploadsInProgress.indexOf(id);
	
	                if (index !== -1) {
	                    uploadsInProgress.splice(index, 1);
	                    this.refs.fileUpload.getWrappedInstance().cancelUpload(id);
	                }
	            } else {
	                previews.splice(index, 1);
	            }
	
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(this.props.rootId);
	            draft.previews = previews;
	            draft.uploadsInProgress = uploadsInProgress;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].storeCommentDraft(this.props.rootId, draft);
	
	            this.setState({ previews: previews, uploadsInProgress: uploadsInProgress });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (newProps.rootId !== this.props.rootId) {
	                var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getCommentDraft(newProps.rootId);
	                this.setState({ messageText: draft.message, uploadsInProgress: draft.uploadsInProgress, previews: draft.previews });
	            }
	        }
	    }, {
	        key: 'getFileCount',
	        value: function getFileCount() {
	            return this.state.previews.length + this.state.uploadsInProgress.length;
	        }
	    }, {
	        key: 'focusTextbox',
	        value: function focusTextbox() {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_19_utils_utils_jsx__.isMobile()) {
	                this.refs.textbox.focus();
	            }
	        }
	    }, {
	        key: 'showPostDeletedModal',
	        value: function showPostDeletedModal() {
	            this.setState({
	                showPostDeletedModal: true
	            });
	        }
	    }, {
	        key: 'hidePostDeletedModal',
	        value: function hidePostDeletedModal() {
	            this.setState({
	                showPostDeletedModal: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var postError = null;
	            if (this.state.postError) {
	                postError = /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.postError
	                );
	            }
	
	            var preview = null;
	            if (this.state.previews.length > 0 || this.state.uploadsInProgress.length > 0) {
	                preview = /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18__file_preview_jsx__["a"], {
	                    files: this.state.previews,
	                    onRemove: this.removePreview,
	                    uploadsInProgress: this.state.uploadsInProgress
	                });
	            }
	
	            var postFooterClassName = 'post-create-footer';
	            if (postError) {
	                postFooterClassName += ' has-error';
	            }
	
	            var uploadsInProgressText = null;
	            if (this.state.uploadsInProgress.length > 0) {
	                uploadsInProgressText = /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                    'span',
	                    { className: 'pull-right post-right-comments-upload-in-progress' },
	                    this.state.uploadsInProgress.length === 1 ? /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["FormattedMessage"], {
	                        id: 'create_comment.file',
	                        defaultMessage: 'File uploading'
	                    }) : /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["FormattedMessage"], {
	                        id: 'create_comment.files',
	                        defaultMessage: 'Files uploading'
	                    })
	                );
	            }
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                'form',
	                { onSubmit: this.handleSubmit },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                    'div',
	                    { className: 'post-create' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                        'div',
	                        {
	                            id: this.props.rootId,
	                            className: 'post-create-body comment-create-body'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                            'div',
	                            { className: 'post-body__cell' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15__textbox_jsx__["a"], {
	                                onUserInput: this.handleUserInput,
	                                onKeyPress: this.commentMsgKeyPress,
	                                onKeyDown: this.handleKeyDown,
	                                messageText: this.state.messageText,
	                                createMessage: formatMessage(holders.addComment),
	                                initialText: '',
	                                supportsCommands: false,
	                                id: 'reply_textbox',
	                                ref: 'textbox'
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17__file_upload_jsx__["a"], {
	                                ref: 'fileUpload',
	                                getFileCount: this.getFileCount,
	                                onClick: this.handleUploadClick,
	                                onUploadStart: this.handleUploadStart,
	                                onFileUpload: this.handleFileUploadComplete,
	                                onUploadError: this.handleUploadError,
	                                postType: 'comment',
	                                channelId: this.props.channelId
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16__msg_typing_jsx__["a"], {
	                        channelId: this.props.channelId,
	                        parentId: this.props.rootId
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(
	                        'div',
	                        { className: postFooterClassName },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement('input', {
	                            type: 'button',
	                            className: 'btn btn-primary comment-btn pull-right',
	                            value: formatMessage(holders.comment),
	                            onClick: this.handleSubmit
	                        }),
	                        uploadsInProgressText,
	                        preview,
	                        postError,
	                        serverError
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__post_deleted_modal_jsx__["a"], {
	                    show: this.state.showPostDeletedModal,
	                    onHide: this.hidePostDeletedModal
	                })
	            );
	        }
	    }]);
	
	    return CreateComment;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);
	
	CreateComment.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["intlShape"].isRequired,
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.PropTypes.string.isRequired,
	    rootId: /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react___default.a.PropTypes.string.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["injectIntl"].bind()(CreateComment);

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__msg_typing_jsx__ = __webpack_require__(363);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__textbox_jsx__ = __webpack_require__(251);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__file_upload_jsx__ = __webpack_require__(360);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__file_preview_jsx__ = __webpack_require__(359);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__post_deleted_modal_jsx__ = __webpack_require__(366);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tutorial_tutorial_tip_jsx__ = __webpack_require__(189);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_intl___default = __WEBPACK_IMPORTED_MODULE_22_react_intl__ && __WEBPACK_IMPORTED_MODULE_22_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_22_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_22_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_22_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_22_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router___default = __WEBPACK_IMPORTED_MODULE_23_react_router__ && __WEBPACK_IMPORTED_MODULE_23_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_23_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_23_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_23_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_23_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react___default = __WEBPACK_IMPORTED_MODULE_24_react__ && __WEBPACK_IMPORTED_MODULE_24_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_24_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_24_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_24_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_24_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].Preferences;
	var TutorialSteps = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].TutorialSteps;
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].ActionTypes;
	var KeyCodes = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].KeyCodes;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["defineMessages"].bind()({
	    comment: {
	        id: 'create_post.comment',
	        defaultMessage: 'Comment'
	    },
	    post: {
	        id: 'create_post.post',
	        defaultMessage: 'Post'
	    },
	    write: {
	        id: 'create_post.write',
	        defaultMessage: 'Write a message...'
	    }
	});
	
	
	
	var CreatePost = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(CreatePost, _React$Component);
	
	    function CreatePost(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CreatePost);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(CreatePost).call(this, props));
	
	        _this.lastTime = 0;
	
	        _this.getCurrentDraft = _this.getCurrentDraft.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.postMsgKeyPress = _this.postMsgKeyPress.bind(_this);
	        _this.handleUserInput = _this.handleUserInput.bind(_this);
	        _this.handleUploadClick = _this.handleUploadClick.bind(_this);
	        _this.handleUploadStart = _this.handleUploadStart.bind(_this);
	        _this.handleFileUploadComplete = _this.handleFileUploadComplete.bind(_this);
	        _this.handleUploadError = _this.handleUploadError.bind(_this);
	        _this.removePreview = _this.removePreview.bind(_this);
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onPreferenceChange = _this.onPreferenceChange.bind(_this);
	        _this.getFileCount = _this.getFileCount.bind(_this);
	        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	        _this.sendMessage = _this.sendMessage.bind(_this);
	        _this.focusTextbox = _this.focusTextbox.bind(_this);
	        _this.showPostDeletedModal = _this.showPostDeletedModal.bind(_this);
	        _this.hidePostDeletedModal = _this.hidePostDeletedModal.bind(_this);
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].clearDraftUploads();
	
	        var draft = _this.getCurrentDraft();
	
	        _this.state = {
	            channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_channel_store_jsx__["a"].getCurrentId(),
	            messageText: draft.messageText,
	            uploadsInProgress: draft.uploadsInProgress,
	            previews: draft.previews,
	            submitting: false,
	            initialText: draft.messageText,
	            ctrlSend: false,
	            centerTextbox: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === Preferences.CHANNEL_DISPLAY_MODE_CENTERED,
	            showTutorialTip: false,
	            showPostDeletedModal: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(CreatePost, [{
	        key: 'getCurrentDraft',
	        value: function getCurrentDraft() {
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getCurrentDraft();
	            var safeDraft = { previews: [], messageText: '', uploadsInProgress: [] };
	
	            if (draft) {
	                if (draft.message) {
	                    safeDraft.messageText = draft.message;
	                }
	                if (draft.previews) {
	                    safeDraft.previews = draft.previews;
	                }
	                if (draft.uploadsInProgress) {
	                    safeDraft.uploadsInProgress = draft.uploadsInProgress;
	                }
	            }
	
	            return safeDraft;
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (this.state.uploadsInProgress.length > 0 || this.state.submitting) {
	                return;
	            }
	
	            var post = {};
	            post.filenames = [];
	            post.message = this.state.messageText;
	
	            if (post.message.trim().length === 0 && this.state.previews.length === 0) {
	                return;
	            }
	
	            if (post.message.length > /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].CHARACTER_LIMIT) {
	                this.setState({ postError: 'Post length must be less than ' + /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].CHARACTER_LIMIT + ' characters.' });
	                return;
	            }
	
	            this.setState({ submitting: true, serverError: null });
	
	            if (post.message.indexOf('/') === 0) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_web_client_jsx__["a"].executeCommand(this.state.channelId, post.message, false, function (data) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].storeDraft(_this2.state.channelId, null);
	                    _this2.setState({ messageText: '', submitting: false, postError: null, previews: [], serverError: null });
	
	                    if (data.goto_location && data.goto_location.length > 0) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_23_react_router__["browserHistory"].push(data.goto_location);
	                    }
	                }, function (err) {
	                    if (err.sendMessage) {
	                        _this2.sendMessage(post);
	                    } else {
	                        var state = {};
	                        state.serverError = err.message;
	                        state.submitting = false;
	                        _this2.setState(state);
	                    }
	                });
	            } else {
	                this.sendMessage(post);
	            }
	        }
	    }, {
	        key: 'sendMessage',
	        value: function sendMessage(post) {
	            var _this3 = this;
	
	            post.channel_id = this.state.channelId;
	            post.filenames = this.state.previews;
	
	            var time = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_16_utils_utils_jsx__.getTimestamp();
	            var userId = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getCurrentId();
	            post.pending_post_id = userId + ':' + time;
	            post.user_id = userId;
	            post.create_at = time;
	            post.parent_id = this.state.parentId;
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_action_creators_global_actions_jsx__.emitUserPostedEvent(post);
	            this.setState({ messageText: '', submitting: false, postError: null, previews: [], serverError: null });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_web_client_jsx__["a"].createPost(post, function () {
	                // DO nothing. Websockets will handle this.
	            }, function (err) {
	                if (err.id === 'api.post.create_post.root_id.app_error') {
	                    // this should never actually happen since you can't reply from this textbox
	                    _this3.showPostDeletedModal();
	
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].removePendingPost(post.pending_post_id);
	                } else {
	                    post.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_utils_constants_jsx__["a"].POST_FAILED;
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].updatePendingPost(post);
	                }
	
	                _this3.setState({
	                    submitting: false
	                });
	            });
	        }
	    }, {
	        key: 'focusTextbox',
	        value: function focusTextbox() {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_16_utils_utils_jsx__.isMobile()) {
	                this.refs.textbox.focus();
	            }
	        }
	    }, {
	        key: 'postMsgKeyPress',
	        value: function postMsgKeyPress(e) {
	            if (this.state.ctrlSend && e.ctrlKey || !this.state.ctrlSend) {
	                if (e.which === KeyCodes.ENTER && !e.shiftKey && !e.altKey) {
	                    e.preventDefault();
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.textbox).blur();
	                    this.handleSubmit(e);
	                }
	            }
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_action_creators_global_actions_jsx__.emitLocalUserTypingEvent(this.state.channelId, '');
	        }
	    }, {
	        key: 'handleUserInput',
	        value: function handleUserInput(messageText) {
	            this.setState({ messageText: messageText });
	
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getCurrentDraft();
	            draft.message = messageText;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].storeCurrentDraft(draft);
	        }
	    }, {
	        key: 'handleUploadClick',
	        value: function handleUploadClick() {
	            this.focusTextbox();
	        }
	    }, {
	        key: 'handleUploadStart',
	        value: function handleUploadStart(clientIds, channelId) {
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getDraft(channelId);
	
	            draft.uploadsInProgress = draft.uploadsInProgress.concat(clientIds);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].storeDraft(channelId, draft);
	
	            this.setState({ uploadsInProgress: draft.uploadsInProgress });
	
	            // this is a bit redundant with the code that sets focus when the file input is clicked,
	            // but this also resets the focus after a drag and drop
	            this.focusTextbox();
	        }
	    }, {
	        key: 'handleFileUploadComplete',
	        value: function handleFileUploadComplete(filenames, clientIds, channelId) {
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getDraft(channelId);
	
	            // remove each finished file from uploads
	            for (var i = 0; i < clientIds.length; i++) {
	                var index = draft.uploadsInProgress.indexOf(clientIds[i]);
	
	                if (index !== -1) {
	                    draft.uploadsInProgress.splice(index, 1);
	                }
	            }
	
	            draft.previews = draft.previews.concat(filenames);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].storeDraft(channelId, draft);
	
	            if (channelId === this.state.channelId) {
	                this.setState({ uploadsInProgress: draft.uploadsInProgress, previews: draft.previews });
	            }
	        }
	    }, {
	        key: 'handleUploadError',
	        value: function handleUploadError(err, clientId, channelId) {
	            var message = err;
	            if (message && typeof message !== 'string') {
	                // err is an AppError from the server
	                message = err.message;
	            }
	
	            if (clientId !== -1) {
	                var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getDraft(channelId);
	
	                var index = draft.uploadsInProgress.indexOf(clientId);
	                if (index !== -1) {
	                    draft.uploadsInProgress.splice(index, 1);
	                }
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].storeDraft(channelId, draft);
	
	                if (channelId === this.state.channelId) {
	                    this.setState({ uploadsInProgress: draft.uploadsInProgress });
	                }
	            }
	
	            this.setState({ serverError: message });
	        }
	    }, {
	        key: 'removePreview',
	        value: function removePreview(id) {
	            var previews = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()([], this.state.previews);
	            var uploadsInProgress = this.state.uploadsInProgress;
	
	            // id can either be the path of an uploaded file or the client id of an in progress upload
	            var index = previews.indexOf(id);
	            if (index === -1) {
	                index = uploadsInProgress.indexOf(id);
	
	                if (index !== -1) {
	                    uploadsInProgress.splice(index, 1);
	                    this.refs.fileUpload.getWrappedInstance().cancelUpload(id);
	                }
	            } else {
	                previews.splice(index, 1);
	            }
	
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getCurrentDraft();
	            draft.previews = previews;
	            draft.uploadsInProgress = uploadsInProgress;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].storeCurrentDraft(draft);
	
	            this.setState({ previews: previews, uploadsInProgress: uploadsInProgress });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var tutorialStep = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getCurrentId(), 999);
	
	            // wait to load these since they may have changed since the component was constructed (particularly in the case of skipping the tutorial)
	            this.setState({
	                ctrlSend: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].getBool(Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
	                centerTextbox: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === Preferences.CHANNEL_DISPLAY_MODE_CENTERED,
	                showTutorialTip: tutorialStep === TutorialSteps.POST_POPOVER
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_channel_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].addChangeListener(this.onPreferenceChange);
	
	            this.focusTextbox();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevState.channelId !== this.state.channelId) {
	                this.focusTextbox();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_channel_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].removeChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_channel_store_jsx__["a"].getCurrentId();
	            if (this.state.channelId !== channelId) {
	                var draft = this.getCurrentDraft();
	
	                this.setState({ channelId: channelId, messageText: draft.messageText, initialText: draft.messageText, submitting: false, serverError: null, postError: null, previews: draft.previews, uploadsInProgress: draft.uploadsInProgress });
	            }
	        }
	    }, {
	        key: 'onPreferenceChange',
	        value: function onPreferenceChange() {
	            var tutorialStep = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getCurrentId(), 999);
	            this.setState({
	                showTutorialTip: tutorialStep === TutorialSteps.POST_POPOVER,
	                ctrlSend: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].getBool(Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
	                centerTextbox: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT) === Preferences.CHANNEL_DISPLAY_MODE_CENTERED
	            });
	        }
	    }, {
	        key: 'getFileCount',
	        value: function getFileCount(channelId) {
	            if (channelId === this.state.channelId) {
	                return this.state.previews.length + this.state.uploadsInProgress.length;
	            }
	
	            var draft = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getDraft(channelId);
	            return draft.previews.length + draft.uploadsInProgress.length;
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            if (this.state.ctrlSend && e.keyCode === KeyCodes.ENTER && e.ctrlKey === true) {
	                this.postMsgKeyPress(e);
	                return;
	            }
	
	            if (e.keyCode === KeyCodes.UP && this.state.messageText === '') {
	                e.preventDefault();
	
	                var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_channel_store_jsx__["a"].getCurrentId();
	                var lastPost = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getCurrentUsersLatestPost(channelId);
	                if (!lastPost) {
	                    return;
	                }
	                var formatMessage = this.props.intl.formatMessage;
	
	                var type = lastPost.root_id && lastPost.root_id.length > 0 ? formatMessage(holders.comment) : formatMessage(holders.post);
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	                    type: ActionTypes.RECEIVED_EDIT_POST,
	                    refocusId: '#post_textbox',
	                    title: type,
	                    message: lastPost.message,
	                    postId: lastPost.id,
	                    channelId: lastPost.channel_id,
	                    comments: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_post_store_jsx__["a"].getCommentCount(lastPost)
	                });
	            }
	        }
	    }, {
	        key: 'showPostDeletedModal',
	        value: function showPostDeletedModal() {
	            this.setState({
	                showPostDeletedModal: true
	            });
	        }
	    }, {
	        key: 'hidePostDeletedModal',
	        value: function hidePostDeletedModal() {
	            this.setState({
	                showPostDeletedModal: false
	            });
	        }
	    }, {
	        key: 'createTutorialTip',
	        value: function createTutorialTip() {
	            var screens = [];
	
	            screens.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["FormattedHTMLMessage"], {
	                    id: 'create_post.tutorialTip',
	                    defaultMessage: '<h4>Sending Messages</h4><p>Type here to write a message and press <strong>Enter</strong> to post it.</p><p>Click the <strong>Attachment</strong> button to upload an image or a file.</p>'
	                })
	            ));
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__tutorial_tutorial_tip_jsx__["b"], {
	                placement: 'top',
	                screens: screens,
	                overlayClass: 'tip-overlay--chat'
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                    'div',
	                    { className: 'has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var postError = null;
	            if (this.state.postError) {
	                postError = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.postError
	                );
	            }
	
	            var preview = null;
	            if (this.state.previews.length > 0 || this.state.uploadsInProgress.length > 0) {
	                preview = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__file_preview_jsx__["a"], {
	                    files: this.state.previews,
	                    onRemove: this.removePreview,
	                    uploadsInProgress: this.state.uploadsInProgress
	                });
	            }
	
	            var postFooterClassName = 'post-create-footer';
	            if (postError) {
	                postFooterClassName += ' has-error';
	            }
	
	            var tutorialTip = null;
	            if (this.state.showTutorialTip) {
	                tutorialTip = this.createTutorialTip();
	            }
	
	            var centerClass = '';
	            if (this.state.centerTextbox) {
	                centerClass = 'center';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                'form',
	                {
	                    id: 'create_post',
	                    ref: 'topDiv',
	                    role: 'form',
	                    className: centerClass,
	                    onSubmit: this.handleSubmit
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                    'div',
	                    { className: 'post-create' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                        'div',
	                        { className: 'post-create-body' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                            'div',
	                            { className: 'post-body__cell' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__textbox_jsx__["a"], {
	                                onUserInput: this.handleUserInput,
	                                onKeyPress: this.postMsgKeyPress,
	                                onKeyDown: this.handleKeyDown,
	                                messageText: this.state.messageText,
	                                createMessage: this.props.intl.formatMessage(holders.write),
	                                channelId: this.state.channelId,
	                                id: 'post_textbox',
	                                ref: 'textbox'
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__file_upload_jsx__["a"], {
	                                ref: 'fileUpload',
	                                getFileCount: this.getFileCount,
	                                onClick: this.handleUploadClick,
	                                onUploadStart: this.handleUploadStart,
	                                onFileUpload: this.handleFileUploadComplete,
	                                onUploadError: this.handleUploadError,
	                                postType: 'post',
	                                channelId: ''
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'send-button theme',
	                                onClick: this.handleSubmit
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement('i', { className: 'fa fa-paper-plane' })
	                        ),
	                        tutorialTip
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(
	                        'div',
	                        { className: postFooterClassName },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__msg_typing_jsx__["a"], {
	                            channelId: this.state.channelId,
	                            parentId: ''
	                        }),
	                        preview,
	                        postError,
	                        serverError
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__post_deleted_modal_jsx__["a"], {
	                    show: this.state.showPostDeletedModal,
	                    onHide: this.hidePostDeletedModal
	                })
	            );
	        }
	    }]);
	
	    return CreatePost;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_react___default.a.Component);
	
	CreatePost.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_22_react_intl__["injectIntl"].bind()(CreatePost);

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router___default = __WEBPACK_IMPORTED_MODULE_8_react_router__ && __WEBPACK_IMPORTED_MODULE_8_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_logo_png__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_logo_png___default = __WEBPACK_IMPORTED_MODULE_10_images_logo_png__ && __WEBPACK_IMPORTED_MODULE_10_images_logo_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_images_logo_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_images_logo_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_images_logo_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_images_logo_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    required: {
	        id: 'create_team.display_name.required',
	        defaultMessage: 'This field is required'
	    },
	    charLength: {
	        id: 'create_team.display_name.charLength',
	        defaultMessage: 'Name must be 4 or more characters up to a maximum of 15'
	    }
	});
	
	
	
	var TeamSignupDisplayNamePage = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamSignupDisplayNamePage, _React$Component);
	
	    function TeamSignupDisplayNamePage(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamSignupDisplayNamePage);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamSignupDisplayNamePage).call(this, props));
	
	        _this.submitNext = _this.submitNext.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamSignupDisplayNamePage, [{
	        key: 'submitNext',
	        value: function submitNext(e) {
	            e.preventDefault();
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var displayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.name).value.trim();
	            if (!displayName) {
	                this.setState({ nameError: formatMessage(holders.required) });
	                return;
	            } else if (displayName.length < 4 || displayName.length > 15) {
	                this.setState({ nameError: formatMessage(holders.charLength) });
	                return;
	            }
	
	            this.props.state.wizard = 'team_url';
	            this.props.state.team.display_name = displayName;
	            this.props.state.team.name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.cleanUpUrlable(displayName);
	            this.props.updateParent(this.props.state);
	        }
	    }, {
	        key: 'handleFocus',
	        value: function handleFocus(e) {
	            e.preventDefault();
	            e.currentTarget.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].track('signup', 'signup_team_02_name');
	
	            var nameError = null;
	            var nameDivClass = 'form-group';
	            if (this.state.nameError) {
	                nameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.nameError
	                );
	                nameDivClass += ' has-error';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'form',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img', {
	                        className: 'signup-team-logo',
	                        src: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_images_logo_png___default.a
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'h2',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'create_team.display_name.teamName',
	                            defaultMessage: 'Team Name'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: nameDivClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'row' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-9' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                    type: 'text',
	                                    ref: 'name',
	                                    className: 'form-control',
	                                    placeholder: '',
	                                    maxLength: '128',
	                                    defaultValue: this.props.state.team.display_name,
	                                    autoFocus: true,
	                                    onFocus: this.handleFocus,
	                                    spellCheck: 'false'
	                                })
	                            )
	                        ),
	                        nameError
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'create_team.display_name.nameHelp',
	                            defaultMessage: 'Name your team in any language. Your team name shows in menus and headings.'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-primary margin--extra',
	                            onClick: this.submitNext
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'create_team.display_name.next',
	                            defaultMessage: 'Next'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('i', { className: 'glyphicon glyphicon-chevron-right' })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'margin--extra' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                            { to: '/select_team' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'create_team.display_name.back',
	                                defaultMessage: 'Back to previous step'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeamSignupDisplayNamePage;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	TeamSignupDisplayNamePage.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    state: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object,
	    updateParent: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.func
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(TeamSignupDisplayNamePage);

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __WEBPACK_IMPORTED_MODULE_7_react_dom__ && __WEBPACK_IMPORTED_MODULE_7_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router___default = __WEBPACK_IMPORTED_MODULE_14_react_router__ && __WEBPACK_IMPORTED_MODULE_14_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __WEBPACK_IMPORTED_MODULE_15_react_intl__ && __WEBPACK_IMPORTED_MODULE_15_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_logo_png__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_logo_png___default = __WEBPACK_IMPORTED_MODULE_16_images_logo_png__ && __WEBPACK_IMPORTED_MODULE_16_images_logo_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_images_logo_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_images_logo_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_images_logo_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_images_logo_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __WEBPACK_IMPORTED_MODULE_17_react__ && __WEBPACK_IMPORTED_MODULE_17_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["defineMessages"].bind()({
	    required: {
	        id: 'create_team.team_url.required',
	        defaultMessage: 'This field is required'
	    },
	    regex: {
	        id: 'create_team.team_url.regex',
	        defaultMessage: "Use only lower case letters, numbers and dashes. Must start with a letter and can't end in a dash."
	    },
	    charLength: {
	        id: 'create_team.team_url.charLength',
	        defaultMessage: 'Name must be 4 or more characters up to a maximum of 15'
	    },
	    taken: {
	        id: 'create_team.team_url.taken',
	        defaultMessage: 'URL is taken or contains a reserved word'
	    },
	    unavailable: {
	        id: 'create_team.team_url.unavailable',
	        defaultMessage: 'This URL is unavailable. Please try another.'
	    }
	});
	
	
	
	var TeamUrl = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(TeamUrl, _React$Component);
	
	    function TeamUrl(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamUrl);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamUrl).call(this, props));
	
	        _this.submitBack = _this.submitBack.bind(_this);
	        _this.submitNext = _this.submitNext.bind(_this);
	        _this.handleFocus = _this.handleFocus.bind(_this);
	
	        _this.state = { nameError: '' };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(TeamUrl, [{
	        key: 'submitBack',
	        value: function submitBack(e) {
	            e.preventDefault();
	            this.props.state.wizard = 'display_name';
	            this.props.updateParent(this.props.state);
	        }
	    }, {
	        key: 'submitNext',
	        value: function submitNext(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var name = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.name).value.trim();
	            if (!name) {
	                this.setState({ nameError: formatMessage(holders.required) });
	                return;
	            }
	
	            var cleanedName = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.cleanUpUrlable(name);
	
	            var urlRegex = /^[a-z]+([a-z\-0-9]+|(__)?)[a-z0-9]+$/g;
	            if (cleanedName !== name || !urlRegex.test(name)) {
	                this.setState({ nameError: formatMessage(holders.regex) });
	                return;
	            } else if (cleanedName.length < 4 || cleanedName.length > 15) {
	                this.setState({ nameError: formatMessage(holders.charLength) });
	                return;
	            }
	
	            if (global.window.mm_config.RestrictTeamNames === 'true') {
	                for (var index = 0; index < /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].RESERVED_TEAM_NAMES.length; index++) {
	                    if (cleanedName.indexOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].RESERVED_TEAM_NAMES[index]) === 0) {
	                        this.setState({ nameError: formatMessage(holders.taken) });
	                        return;
	                    }
	                }
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#finish-button').button('loading');
	            var teamSignup = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(this.props.state));
	            teamSignup.team.type = 'O';
	            teamSignup.team.name = name;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].findTeamByName(name, function (findTeam) {
	                if (findTeam) {
	                    _this2.setState({ nameError: formatMessage(holders.unavailable) });
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#finish-button').button('reset');
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].createTeam(teamSignup.team, function (team) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].track('signup', 'signup_team_08_complete');
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#sign-up-button').button('reset');
	                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getDirectProfiles();
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].saveTeam(team);
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].appendTeamMember({ team_id: team.id, user_id: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getCurrentId(), roles: 'admin' });
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].emitChange();
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_router__["browserHistory"].push('/' + team.name + '/channels/town-square');
	                    }, function (err) {
	                        _this2.setState({ nameError: err.message });
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#finish-button').button('reset');
	                    });
	
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#finish-button').button('reset');
	                }
	            }, function (err) {
	                _this2.setState({ nameError: err.message });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#finish-button').button('reset');
	            });
	        }
	    }, {
	        key: 'handleFocus',
	        value: function handleFocus(e) {
	            e.preventDefault();
	
	            e.currentTarget.select();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('body').tooltip({ selector: '[data-toggle=tooltip]', trigger: 'hover click' });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].track('signup', 'signup_team_03_url');
	
	            var nameError = null;
	            var nameDivClass = 'form-group';
	            if (this.state.nameError) {
	                nameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.nameError
	                );
	                nameDivClass += ' has-error';
	            }
	
	            var title = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getWindowLocationOrigin() + '/';
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'form',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('img', {
	                        className: 'signup-team-logo',
	                        src: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_images_logo_png___default.a
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'h2',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'create_team.team_url.teamUrl',
	                            defaultMessage: 'Team URL'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { className: nameDivClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'row' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-11' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                    'div',
	                                    { className: 'input-group input-group--limit' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                        'span',
	                                        {
	                                            'data-toggle': 'tooltip',
	                                            title: title,
	                                            className: 'input-group-addon'
	                                        },
	                                        title
	                                    ),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                        type: 'text',
	                                        ref: 'name',
	                                        className: 'form-control',
	                                        placeholder: '',
	                                        maxLength: '128',
	                                        defaultValue: this.props.state.team.name,
	                                        autoFocus: true,
	                                        onFocus: this.handleFocus,
	                                        spellCheck: 'false'
	                                    })
	                                )
	                            )
	                        ),
	                        nameError
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'create_team.team_url.webAddress',
	                            defaultMessage: 'Choose the web address of your new team:'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'ul',
	                        { className: 'color--light' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedHTMLMessage"], {
	                            id: 'create_team.team_url.hint',
	                            defaultMessage: '<li>Short and memorable is best</li> <li>Use lowercase letters, numbers and dashes</li> <li>Must start with a letter and can\'t end in a dash</li>'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            id: 'finish-button',
	                            className: 'btn btn-primary margin--extra',
	                            onClick: this.submitNext
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'create_team.team_url.finish',
	                            defaultMessage: 'Finish'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { className: 'margin--extra' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                onClick: this.submitBack
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'create_team.team_url.back',
	                                defaultMessage: 'Back to previous step'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeamUrl;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);
	
	TeamUrl.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["intlShape"].isRequired,
	    state: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.object,
	    updateParent: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.func
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["injectIntl"].bind()(TeamUrl);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_error_bar_jsx__ = __webpack_require__(187);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var CreateTeam = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(CreateTeam, _React$Component);
	
	    function CreateTeam(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CreateTeam);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(CreateTeam).call(this, props));
	
	        _this.submit = _this.submit.bind(_this);
	        _this.updateParent = _this.updateParent.bind(_this);
	
	        var state = {};
	        state.team = {};
	        state.wizard = 'display_name';
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(CreateTeam, [{
	        key: 'submit',
	        value: function submit() {
	            // todo fill in
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"].push('/create_team/display_name');
	        }
	    }, {
	        key: 'updateParent',
	        value: function updateParent(state) {
	            this.setState(state);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"].push('/create_team/' + state.wizard);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_components_error_bar_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                        { to: '/select_team' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'web.header.back'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'h1',
	                            null,
	                            global.window.mm_config.SiteName
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'h4',
	                            { className: 'color--light' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'web.root.singup_info'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'signup__content' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(this.props.children, {
	                                state: this.state,
	                                updateParent: this.updateParent
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateTeam;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = CreateTeam;
	
	
	CreateTeam.propTypes = {
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.node
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl___default = __WEBPACK_IMPORTED_MODULE_14_react_intl__ && __WEBPACK_IMPORTED_MODULE_14_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	var DeletePostModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(DeletePostModal, _React$Component);
	
	    function DeletePostModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DeletePostModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(DeletePostModal).call(this, props));
	
	        _this.handleDelete = _this.handleDelete.bind(_this);
	        _this.handleToggle = _this.handleToggle.bind(_this);
	        _this.handleHide = _this.handleHide.bind(_this);
	
	        _this.state = {
	            show: false,
	            post: null,
	            commentCount: 0,
	            error: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(DeletePostModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_modal_store_jsx__["a"].addModalListener(ActionTypes.TOGGLE_DELETE_POST_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_modal_store_jsx__["a"].removeModalListener(ActionTypes.TOGGLE_DELETE_POST_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this2 = this;
	
	            if (this.state.show && !prevState.show) {
	                setTimeout(function () {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this2.refs.deletePostBtn)).focus();
	                }, 0);
	            }
	        }
	    }, {
	        key: 'handleDelete',
	        value: function handleDelete() {
	            var _this3 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].deletePost(this.state.post.channel_id, this.state.post.id, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].deletePost(_this3.state.post);
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getPosts(_this3.state.post.channel_id);
	
	                if (_this3.state.post.id === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].getSelectedPostId()) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                        type: ActionTypes.RECEIVED_POST_SELECTED,
	                        postId: null
	                    });
	                }
	            }, function (err) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.dispatchError(err, 'deletePost');
	            });
	
	            this.handleHide();
	        }
	    }, {
	        key: 'handleToggle',
	        value: function handleToggle(value, args) {
	            this.setState({
	                show: value,
	                post: args.post,
	                commentCount: args.commentCount,
	                error: ''
	            });
	        }
	    }, {
	        key: 'handleHide',
	        value: function handleHide() {
	            this.setState({ show: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.post) {
	                return null;
	            }
	
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var commentWarning = '';
	            if (this.state.commentCount > 0) {
	                commentWarning = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                    id: 'delete_post.warning',
	                    defaultMessage: 'This post has {count} comment(s) on it.',
	                    values: {
	                        count: this.state.commentCount
	                    }
	                });
	            }
	
	            var postTerm = this.state.post.root_id ? /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                id: 'delete_post.comment',
	                defaultMessage: 'Comment'
	            }) : /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                id: 'delete_post.post',
	                defaultMessage: 'Post'
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
	                {
	                    show: this.state.show,
	                    onHide: this.handleHide
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'delete_post.confirm',
	                            defaultMessage: 'Confirm {term} Delete',
	                            values: {
	                                term: postTerm
	                            }
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'delete_post.question',
	                        defaultMessage: 'Are you sure you want to delete this {term}?',
	                        values: {
	                            term: postTerm
	                        }
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('br', null),
	                    commentWarning,
	                    error
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.handleHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'delete_post.cancel',
	                            defaultMessage: 'Cancel'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'button',
	                        {
	                            ref: 'deletePostBtn',
	                            type: 'button',
	                            className: 'btn btn-danger',
	                            onClick: this.handleDelete
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'delete_post.del',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeletePostModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = DeletePostModal;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router___default = __WEBPACK_IMPORTED_MODULE_8_react_router__ && __WEBPACK_IMPORTED_MODULE_8_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var DoVerifyEmail = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(DoVerifyEmail, _React$Component);
	
	    function DoVerifyEmail(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DoVerifyEmail);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(DoVerifyEmail).call(this, props));
	
	        _this.state = {
	            verifyStatus: 'pending',
	            serverError: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(DoVerifyEmail, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var uid = this.props.location.query.uid;
	            var hid = this.props.location.query.hid;
	            var email = this.props.location.query.email;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].verifyEmail(uid, hid, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["browserHistory"].push('/login?extra=verified&email=' + email);
	            }, function (err) {
	                _this2.setState({ verifyStatus: 'failure', serverError: err.message });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.verifyStatus !== 'failure') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__loading_screen_jsx__["a"], null);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                        { to: '/' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'web.header.back'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'h3',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                                id: 'email_verify.almost',
	                                defaultMessage: '{siteName}: You are almost done',
	                                values: {
	                                    siteName: global.window.mm_config.SiteName
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                'p',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], { id: 'email_verify.verifyFailed' })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                'p',
	                                { className: 'alert alert-danger' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-times' }),
	                                this.state.serverError
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DoVerifyEmail;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = DoVerifyEmail;
	
	
	DoVerifyEmail.defaultProps = {};
	DoVerifyEmail.propTypes = {
	    location: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __WEBPACK_IMPORTED_MODULE_7_react_dom__ && __WEBPACK_IMPORTED_MODULE_7_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__textbox_jsx__ = __webpack_require__(251);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl___default = __WEBPACK_IMPORTED_MODULE_16_react_intl__ && __WEBPACK_IMPORTED_MODULE_16_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __WEBPACK_IMPORTED_MODULE_17_react__ && __WEBPACK_IMPORTED_MODULE_17_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var KeyCodes = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__["a"].KeyCodes;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["defineMessages"].bind()({
	    editPost: {
	        id: 'edit_post.editPost',
	        defaultMessage: 'Edit the post...'
	    }
	});
	
	
	
	var EditPostModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(EditPostModal, _React$Component);
	
	    function EditPostModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EditPostModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EditPostModal).call(this, props));
	
	        _this.handleEdit = _this.handleEdit.bind(_this);
	        _this.handleEditInput = _this.handleEditInput.bind(_this);
	        _this.handleEditKeyPress = _this.handleEditKeyPress.bind(_this);
	        _this.handleEditPostEvent = _this.handleEditPostEvent.bind(_this);
	        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	        _this.onPreferenceChange = _this.onPreferenceChange.bind(_this);
	
	        _this.state = { editText: '', originalText: '', title: '', post_id: '', channel_id: '', comments: 0, refocusId: '' };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(EditPostModal, [{
	        key: 'handleEdit',
	        value: function handleEdit() {
	            var updatedPost = {};
	            updatedPost.message = this.state.editText.trim();
	
	            if (updatedPost.message === this.state.originalText.trim()) {
	                // no changes so just close the modal
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#edit_post').modal('hide');
	                return;
	            }
	
	            if (updatedPost.message.length === 0) {
	                var tempState = this.state;
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(tempState, 'editText');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_browser_store_jsx__["a"].setItem('edit_state_transfer', tempState);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#edit_post').modal('hide');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__.showDeletePostModal(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].getPost(this.state.channel_id, this.state.post_id), this.state.comments);
	                return;
	            }
	
	            updatedPost.id = this.state.post_id;
	            updatedPost.channel_id = this.state.channel_id;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].updatePost(updatedPost, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.getPosts(updatedPost.channel_id);
	                window.scrollTo(0, 0);
	            }, function (err) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.dispatchError(err, 'updatePost');
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('#edit_post').modal('hide');
	        }
	    }, {
	        key: 'handleEditInput',
	        value: function handleEditInput(editMessage) {
	            this.setState({ editText: editMessage });
	        }
	    }, {
	        key: 'handleEditKeyPress',
	        value: function handleEditKeyPress(e) {
	            if (!this.state.ctrlSend && e.which === KeyCodes.ENTER && !e.shiftKey && !e.altKey) {
	                e.preventDefault();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.editbox).blur();
	                this.handleEdit(e);
	            }
	        }
	    }, {
	        key: 'handleEditPostEvent',
	        value: function handleEditPostEvent(options) {
	            this.setState({
	                editText: options.message || '',
	                originalText: options.message || '',
	                title: options.title || '',
	                post_id: options.postId || '',
	                channel_id: options.channelId || '',
	                comments: options.comments || 0,
	                refocusId: options.refocusId || ''
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.modal)).modal('show');
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            if (this.state.ctrlSend && e.keyCode === KeyCodes.ENTER && e.ctrlKey === true) {
	                this.handleEdit(e);
	            }
	        }
	    }, {
	        key: 'onPreferenceChange',
	        value: function onPreferenceChange() {
	            this.setState({
	                ctrlSend: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].getBool(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter')
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var self = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.modal)).on('hidden.bs.modal', function () {
	                self.setState({ editText: '', originalText: '', title: '', channel_id: '', post_id: '', comments: 0, refocusId: '', error: '' });
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.modal)).on('show.bs.modal', function (e) {
	                var button = e.relatedTarget;
	                if (!button) {
	                    return;
	                }
	                self.setState({
	                    editText: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-message'),
	                    originalText: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-message'),
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-title'),
	                    channel_id: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-channelid'),
	                    post_id: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-postid'),
	                    comments: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-comments'),
	                    refocusId: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(button).attr('data-refocusid')
	                });
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.modal)).on('shown.bs.modal', function () {
	                self.refs.editbox.focus();
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs.modal)).on('hide.bs.modal', function () {
	                if (self.state.refocusId !== '') {
	                    setTimeout(function () {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(self.state.refocusId).get(0).focus();
	                    });
	                }
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].addEditPostListener(this.handleEditPostEvent);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].addChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_post_store_jsx__["a"].removeEditPostListner(this.handleEditPostEvent);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_preference_store_jsx__["a"].removeChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                'div',
	                { className: 'form-group' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null)
	            );
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                'div',
	                {
	                    className: 'modal fade edit-modal',
	                    ref: 'modal',
	                    id: 'edit_post',
	                    role: 'dialog',
	                    tabIndex: '-1',
	                    'aria-hidden': 'true'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-dialog modal-push-down' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { className: 'modal-content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-header' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'close',
	                                    'data-dismiss': 'modal',
	                                    'aria-label': 'Close',
	                                    onClick: this.handleEditClose
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                    'span',
	                                    { 'aria-hidden': 'true' },
	                                    '×'
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'h4',
	                                { className: 'modal-title' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'edit_post.edit',
	                                    defaultMessage: 'Edit {title}',
	                                    values: {
	                                        title: this.state.title
	                                    }
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'edit-modal-body modal-body' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__textbox_jsx__["a"], {
	                                onUserInput: this.handleEditInput,
	                                onKeyPress: this.handleEditKeyPress,
	                                onKeyDown: this.handleKeyDown,
	                                messageText: this.state.editText,
	                                createMessage: this.props.intl.formatMessage(holders.editPost),
	                                supportsCommands: false,
	                                id: 'edit_textbox',
	                                ref: 'editbox'
	                            }),
	                            error
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-footer' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-default',
	                                    'data-dismiss': 'modal'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'edit_post.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-primary',
	                                    onClick: this.handleEdit
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'edit_post.save',
	                                    defaultMessage: 'Save'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EditPostModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);
	
	EditPostModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["injectIntl"].bind()(EditPostModal);

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var ErrorPage = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ErrorPage, _React$Component);
	
	    function ErrorPage() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ErrorPage);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ErrorPage).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ErrorPage, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').attr('class', 'sticky error');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').attr('class', '');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var title = this.props.location.query.title;
	            if (!title || title === '') {
	                title = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('error.generic.title', 'Error');
	            }
	
	            var message = this.props.location.query.message;
	            if (!message || message === '') {
	                message = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('error.generic.message', 'An error has occoured.');
	            }
	
	            var link = this.props.location.query.link;
	            if (!link || link === '') {
	                link = '/';
	            }
	
	            var linkMessage = this.props.location.query.linkmessage;
	            if (!linkMessage || linkMessage === '') {
	                linkMessage = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('error.generic.link_message', 'Back to Mattermost');
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'container-fluid' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'error__container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        { className: 'error__icon' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', { className: 'fa fa-exclamation-triangle' })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'h2',
	                        null,
	                        title
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'p',
	                        null,
	                        message
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"],
	                        { to: link },
	                        linkMessage
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ErrorPage;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ErrorPage;
	
	
	ErrorPage.defaultProps = {};
	ErrorPage.propTypes = {
	    location: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object
	};

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    download: {
	        id: 'file_attachment.download',
	        defaultMessage: 'Download'
	    }
	});
	
	
	
	var FileAttachment = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FileAttachment, _React$Component);
	
	    function FileAttachment(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FileAttachment);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FileAttachment).call(this, props));
	
	        _this.loadFiles = _this.loadFiles.bind(_this);
	        _this.addBackgroundImage = _this.addBackgroundImage.bind(_this);
	
	        _this.canSetState = false;
	        _this.state = { fileSize: -1 };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FileAttachment, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadFiles();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.filename !== prevProps.filename) {
	                this.loadFiles();
	            }
	        }
	    }, {
	        key: 'loadFiles',
	        value: function loadFiles() {
	            this.canSetState = true;
	
	            var filename = this.props.filename;
	
	            if (filename) {
	                var fileInfo = this.getFileInfoFromName(filename);
	                var type = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getFileType(fileInfo.ext);
	
	                if (type === 'image') {
	                    var self = this; // Need this reference since we use the given "this"
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('<img/>').attr('src', fileInfo.path + '_thumb.jpg').load(function loadWrapper(path, name) {
	                        return function loader() {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).remove();
	                            if (name in self.refs) {
	                                var imgDiv = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(self.refs[name]);
	
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(imgDiv).removeClass('post-image__load');
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(imgDiv).addClass('post-image');
	
	                                var width = this.width || /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).width();
	                                var height = this.height || /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).height();
	
	                                if (width < /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].THUMBNAIL_WIDTH && height < /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].THUMBNAIL_HEIGHT) {
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(imgDiv).addClass('small');
	                                } else {
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(imgDiv).addClass('normal');
	                                }
	
	                                self.addBackgroundImage(name, path);
	                            }
	                        };
	                    }(fileInfo.path, filename));
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // keep track of when this component is mounted so that we can asynchronously change state without worrying about whether or not we're mounted
	            this.canSetState = false;
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.areObjectsEqual(nextProps, this.props)) {
	                return true;
	            }
	
	            // the only time this object should update is when it receives an updated file size which we can usually handle without re-rendering
	            if (nextState.fileSize !== this.state.fileSize) {
	                if (this.refs.fileSize) {
	                    // update the UI element to display the file size without re-rendering the whole component
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.fileSize).innerHTML = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.fileSizeToString(nextState.fileSize);
	
	                    return false;
	                }
	
	                // we can't find the element that should hold the file size so we must not have rendered yet
	                return true;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'getFileInfoFromName',
	        value: function getFileInfoFromName(name) {
	            var fileInfo = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.splitFileLocation(name);
	
	            fileInfo.path = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getWindowLocationOrigin() + /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].getFilesRoute() + '/get' + fileInfo.path;
	
	            return fileInfo;
	        }
	    }, {
	        key: 'addBackgroundImage',
	        value: function addBackgroundImage(name, path) {
	            var fileUrl = path;
	
	            if (name in this.refs) {
	                if (!path) {
	                    fileUrl = this.getFileInfoFromName(name).path;
	                }
	
	                var imgDiv = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs[name]);
	                var re1 = new RegExp(' ', 'g');
	                var re2 = new RegExp('\\(', 'g');
	                var re3 = new RegExp('\\)', 'g');
	                var url = fileUrl.replace(re1, '%20').replace(re2, '%28').replace(re3, '%29');
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(imgDiv).css('background-image', 'url(' + url + '_thumb.jpg)');
	            }
	        }
	    }, {
	        key: 'removeBackgroundImage',
	        value: function removeBackgroundImage(name) {
	            if (name in this.refs) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs[name])).css('background-image', 'initial');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var filename = this.props.filename;
	
	            var fileInfo = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.splitFileLocation(filename);
	            var fileUrl = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getFileUrl(filename);
	            var type = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getFileType(fileInfo.ext);
	
	            var thumbnail;
	            if (type === 'image') {
	                thumbnail = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', {
	                    ref: filename,
	                    className: 'post-image__load'
	                });
	            } else {
	                thumbnail = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div', { className: 'file-icon ' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getIconClassName(type) });
	            }
	
	            var fileSizeString = '';
	            if (this.state.fileSize < 0) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].getFileInfo(filename, function success(data) {
	                    if (this.canSetState) {
	                        this.setState({ fileSize: parseInt(data.size, 10) });
	                    }
	                }.bind(this), function error() {
	                    // Do nothing
	                });
	            } else {
	                    fileSizeString = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.fileSizeToString(this.state.fileSize);
	                }
	
	            var filenameString = decodeURIComponent(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getFileName(filename));
	            var trimmedFilename;
	            if (filenameString.length > 35) {
	                trimmedFilename = filenameString.substring(0, Math.min(35, filenameString.length)) + '...';
	            } else {
	                trimmedFilename = filenameString;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                {
	                    className: 'post-image__column',
	                    key: filename
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'a',
	                    { className: 'post-image__thumbnail',
	                        href: '#',
	                        onClick: function onClick() {
	                            return _this2.props.handleImageClick(_this2.props.index);
	                        }
	                    },
	                    thumbnail
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'post-image__details' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'a',
	                        {
	                            href: fileUrl,
	                            download: filenameString,
	                            'data-toggle': 'tooltip',
	                            title: this.props.intl.formatMessage(holders.download) + ' \"' + filenameString + '\"',
	                            className: 'post-image__name',
	                            target: '_blank'
	                        },
	                        trimmedFilename
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'a',
	                            {
	                                href: fileUrl,
	                                download: filenameString,
	                                className: 'post-image__download',
	                                target: '_blank'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('span', {
	                                className: 'fa fa-download'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'span',
	                            { className: 'post-image__type' },
	                            fileInfo.ext.toUpperCase()
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'span',
	                            { className: 'post-image__size' },
	                            fileSizeString
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FileAttachment;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	FileAttachment.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired,
	
	    // a list of file pathes displayed by the parent FileAttachmentList
	    filename: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.string.isRequired,
	
	    // the index of this attachment preview in the parent FileAttachmentList
	    index: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.number.isRequired,
	
	    // handler for when the thumbnail is clicked passed the index above
	    handleImageClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.func
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(FileAttachment);

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var FloatingTimestamp = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(FloatingTimestamp, _React$Component);
	
	    function FloatingTimestamp(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FloatingTimestamp);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FloatingTimestamp).call(this, props));
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(FloatingTimestamp, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.isMobile) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('noscript', null);
	            }
	
	            if (this.props.createAt === 0) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('noscript', null);
	            }
	
	            var dateString = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedDate"], {
	                value: this.props.createAt,
	                weekday: 'short',
	                day: '2-digit',
	                month: 'short',
	                year: 'numeric'
	            });
	
	            var className = 'post-list__timestamp';
	            if (this.props.isScrolling) {
	                className += ' scrolling';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: className },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'span',
	                        null,
	                        dateString
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FloatingTimestamp;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = FloatingTimestamp;
	
	
	FloatingTimestamp.propTypes = {
	    isScrolling: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool.isRequired,
	    isMobile: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool,
	    createAt: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.number
	};

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_link_modal_jsx__ = __webpack_require__(249);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var GetPostLinkModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(GetPostLinkModal, _React$Component);
	
	    function GetPostLinkModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, GetPostLinkModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(GetPostLinkModal).call(this, props));
	
	        _this.handleToggle = _this.handleToggle.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	
	        _this.state = {
	            show: false,
	            post: {}
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(GetPostLinkModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].addModalListener(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_POST_LINK_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].removeModalListener(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_POST_LINK_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'handleToggle',
	        value: function handleToggle(value, args) {
	            this.setState({
	                show: value,
	                post: args.post
	            });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__get_link_modal_jsx__["a"], {
	                show: this.state.show,
	                onHide: this.hide,
	                title: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('get_post_link_modal.title', 'Copy Permalink'),
	                helpText: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('get_post_link_modal.help', 'The link below allows authorized users to see your post.'),
	                link: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/pl/' + this.state.post.id
	            });
	        }
	    }]);
	
	    return GetPostLinkModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = GetPostLinkModal;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__get_link_modal_jsx__ = __webpack_require__(249);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var GetPublicLinkModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(GetPublicLinkModal, _React$Component);
	
	    function GetPublicLinkModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, GetPublicLinkModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(GetPublicLinkModal).call(this, props));
	
	        _this.handlePublicLink = _this.handlePublicLink.bind(_this);
	        _this.handleToggle = _this.handleToggle.bind(_this);
	        _this.hide = _this.hide.bind(_this);
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	
	        _this.state = {
	            show: false,
	            filename: '',
	            link: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(GetPublicLinkModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_modal_store_jsx__["a"].addModalListener(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (this.state.show && !prevState.show) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.getPublicLink(this.state.filename, this.handlePublicLink);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_modal_store_jsx__["a"].removeModalListener(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'handlePublicLink',
	        value: function handlePublicLink(link) {
	            this.setState({
	                link: link
	            });
	        }
	    }, {
	        key: 'handleToggle',
	        value: function handleToggle(value, args) {
	            this.setState({
	                show: value,
	                filename: args.filename,
	                link: ''
	            });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.setState({
	                show: false
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__get_link_modal_jsx__["a"], {
	                show: this.state.show,
	                onHide: this.hide,
	                title: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('get_public_link_modal.title', 'Copy Public Link'),
	                helpText: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('get_public_link_modal.help', 'The link below allows anyone to see this file without being registered on this server.'),
	                link: this.state.link
	            });
	        }
	    }]);
	
	    return GetPublicLinkModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = GetPublicLinkModal;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_link_modal_jsx__ = __webpack_require__(249);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var GetTeamInviteLinkModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(GetTeamInviteLinkModal, _React$Component);
	
	    function GetTeamInviteLinkModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, GetTeamInviteLinkModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(GetTeamInviteLinkModal).call(this, props));
	
	        _this.handleToggle = _this.handleToggle.bind(_this);
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	
	        _this.state = {
	            show: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(GetTeamInviteLinkModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].addModalListener(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].removeModalListener(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL, this.handleToggle);
	        }
	    }, {
	        key: 'handleToggle',
	        value: function handleToggle(value) {
	            this.setState({
	                show: value
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var helpText = void 0;
	            if (global.window.mm_config.EnableUserCreation === 'true') {
	                helpText = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('get_team_invite_link_modal.help', 'Send teammates the link below for them to sign-up to this team site. The Team Invite Link can be shared with multiple teammates as it does not change unless it\'s regenerated in Team Settings by a Team Admin.');
	            } else {
	                helpText = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('get_team_invite_link_modal.helpDisabled', 'User creation has been disabled for your team. Please ask your team administrator for details.');
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__get_link_modal_jsx__["a"], {
	                show: this.state.show,
	                onHide: function onHide() {
	                    return _this2.setState({ show: false });
	                },
	                title: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.localizeMessage('get_team_invite_link_modal.title', 'Team Invite Link'),
	                helpText: helpText,
	                link: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getCurrentInviteLink()
	            });
	        }
	    }]);
	
	    return GetTeamInviteLinkModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = GetTeamInviteLinkModal;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var NotLoggedIn = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NotLoggedIn, _React$Component);
	
	    function NotLoggedIn() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NotLoggedIn);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NotLoggedIn).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NotLoggedIn, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').addClass('sticky');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#root').addClass('container-fluid');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').removeClass('sticky');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#root').removeClass('container-fluid');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                { className: 'inner-wrap' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'row content' },
	                    this.props.children,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'footer-push' })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'row footer' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'footer-pane col-xs-12' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'span',
	                                { className: 'pull-right footer-site-name' },
	                                global.window.mm_config.SiteName
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'span',
	                                { className: 'pull-right footer-link copyright' },
	                                '© 2015 Mattermost, Inc.'
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'a',
	                                {
	                                    id: 'help_link',
	                                    className: 'pull-right footer-link',
	                                    target: '_blank',
	                                    href: global.window.mm_config.HelpLink,
	                                    rel: 'noreferrer'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: 'web.footer.help' })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'a',
	                                {
	                                    id: 'terms_link',
	                                    className: 'pull-right footer-link',
	                                    target: '_blank',
	                                    href: global.window.mm_config.TermsOfServiceLink,
	                                    rel: 'noreferrer'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: 'web.footer.terms' })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'a',
	                                {
	                                    id: 'privacy_link',
	                                    className: 'pull-right footer-link',
	                                    target: '_blank',
	                                    href: global.window.mm_config.PrivacyPolicyLink,
	                                    rel: 'noreferrer'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: 'web.footer.privacy' })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'a',
	                                {
	                                    id: 'about_link',
	                                    className: 'pull-right footer-link',
	                                    target: '_blank',
	                                    href: global.window.mm_config.AboutLink,
	                                    rel: 'noreferrer'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], { id: 'web.footer.about' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NotLoggedIn;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = NotLoggedIn;
	
	
	NotLoggedIn.defaultProps = {};
	
	NotLoggedIn.propTypes = {
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__confirm_modal_jsx__ = __webpack_require__(186);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __WEBPACK_IMPORTED_MODULE_15_react_intl__ && __WEBPACK_IMPORTED_MODULE_15_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __WEBPACK_IMPORTED_MODULE_17_react__ && __WEBPACK_IMPORTED_MODULE_17_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["defineMessages"].bind()({
	    emailError: {
	        id: 'invite_member.emailError',
	        defaultMessage: 'Please enter a valid email address'
	    },
	    firstname: {
	        id: 'invite_member.firstname',
	        defaultMessage: 'First name'
	    },
	    lastname: {
	        id: 'invite_member.lastname',
	        defaultMessage: 'Last name'
	    },
	    modalTitle: {
	        id: 'invite_member.modalTitle',
	        defaultMessage: 'Discard Invitations?'
	    },
	    modalMessage: {
	        id: 'invite_member.modalMessage',
	        defaultMessage: 'You have unsent invitations, are you sure you want to discard them?'
	    },
	    modalButton: {
	        id: 'invite_member.modalButton',
	        defaultMessage: 'Yes, Discard'
	    }
	});
	
	
	
	var InviteMemberModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(InviteMemberModal, _React$Component);
	
	    function InviteMemberModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, InviteMemberModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(InviteMemberModal).call(this, props));
	
	        _this.teamChange = _this.teamChange.bind(_this);
	        _this.handleToggle = _this.handleToggle.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleHide = _this.handleHide.bind(_this);
	        _this.addInviteFields = _this.addInviteFields.bind(_this);
	        _this.clearFields = _this.clearFields.bind(_this);
	        _this.removeInviteFields = _this.removeInviteFields.bind(_this);
	        _this.showGetTeamInviteLinkModal = _this.showGetTeamInviteLinkModal.bind(_this);
	
	        var team = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_team_store_jsx__["a"].getCurrent();
	
	        _this.state = {
	            show: false,
	            inviteIds: [0],
	            idCount: 0,
	            emailErrors: {},
	            firstNameErrors: {},
	            lastNameErrors: {},
	            emailEnabled: global.window.mm_config.SendEmailNotifications === 'true',
	            userCreationEnabled: global.window.mm_config.EnableUserCreation === 'true',
	            showConfirmModal: false,
	            isSendingEmails: false,
	            teamType: team ? team.type : null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(InviteMemberModal, [{
	        key: 'teamChange',
	        value: function teamChange() {
	            var team = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_team_store_jsx__["a"].getCurrent();
	            var teamType = team ? team.type : null;
	            this.setState({
	                teamType: teamType
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_modal_store_jsx__["a"].addModalListener(ActionTypes.TOGGLE_INVITE_MEMBER_MODAL, this.handleToggle);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_team_store_jsx__["a"].addChangeListener(this.teamChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_modal_store_jsx__["a"].removeModalListener(ActionTypes.TOGGLE_INVITE_MEMBER_MODAL, this.handleToggle);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_team_store_jsx__["a"].removeChangeListener(this.teamChange);
	        }
	    }, {
	        key: 'handleToggle',
	        value: function handleToggle(value) {
	            this.setState({
	                show: value
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            var _this2 = this;
	
	            if (!this.state.emailEnabled) {
	                return;
	            }
	
	            var inviteIds = this.state.inviteIds;
	            var count = inviteIds.length;
	            var invites = [];
	            var emailErrors = this.state.emailErrors;
	            var firstNameErrors = this.state.firstNameErrors;
	            var lastNameErrors = this.state.lastNameErrors;
	            var valid = true;
	
	            for (var i = 0; i < count; i++) {
	                var index = inviteIds[i];
	                var invite = {};
	                invite.email = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['email' + index]).value.trim();
	                if (!invite.email || !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isEmail(invite.email)) {
	                    emailErrors[index] = this.props.intl.formatMessage(holders.emailError);
	                    valid = false;
	                } else {
	                    emailErrors[index] = '';
	                }
	
	                invite.firstName = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['first_name' + index]).value.trim();
	
	                invite.lastName = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['last_name' + index]).value.trim();
	
	                invites.push(invite);
	            }
	
	            this.setState({ emailErrors: emailErrors, firstNameErrors: firstNameErrors, lastNameErrors: lastNameErrors });
	
	            if (!valid || invites.length === 0) {
	                return;
	            }
	
	            var data = {};
	            data.invites = invites;
	
	            this.setState({ isSendingEmails: true });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].inviteMembers(data, function () {
	                _this2.handleHide(false);
	                _this2.setState({ isSendingEmails: false });
	            }, function (err) {
	                if (err.id === 'api.team.invite_members.already.app_error') {
	                    emailErrors[err.detailed_error] = err.message;
	                    _this2.setState({ emailErrors: emailErrors });
	                } else {
	                    _this2.setState({ serverError: err.message });
	                }
	
	                _this2.setState({ isSendingEmails: false });
	            });
	        }
	    }, {
	        key: 'handleHide',
	        value: function handleHide(requireConfirm) {
	            if (requireConfirm) {
	                var notEmpty = false;
	                for (var i = 0; i < this.state.inviteIds.length; i++) {
	                    var index = this.state.inviteIds[i];
	                    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['email' + index]).value.trim() !== '') {
	                        notEmpty = true;
	                        break;
	                    }
	                }
	
	                if (notEmpty) {
	                    this.setState({
	                        showConfirmModal: true
	                    });
	
	                    return;
	                }
	            }
	
	            this.clearFields();
	
	            this.setState({
	                show: false,
	                showConfirmModal: false
	            });
	        }
	    }, {
	        key: 'addInviteFields',
	        value: function addInviteFields() {
	            var count = this.state.idCount + 1;
	            var inviteIds = this.state.inviteIds;
	            inviteIds.push(count);
	            this.setState({ inviteIds: inviteIds, idCount: count });
	        }
	    }, {
	        key: 'clearFields',
	        value: function clearFields() {
	            var inviteIds = this.state.inviteIds;
	
	            for (var i = 0; i < inviteIds.length; i++) {
	                var index = inviteIds[i];
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['email' + index]).value = '';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['first_name' + index]).value = '';
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs['last_name' + index]).value = '';
	            }
	
	            this.setState({
	                inviteIds: [0],
	                idCount: 0,
	                emailErrors: {},
	                firstNameErrors: {},
	                lastNameErrors: {}
	            });
	        }
	    }, {
	        key: 'removeInviteFields',
	        value: function removeInviteFields(index) {
	            var count = this.state.idCount;
	            var inviteIds = this.state.inviteIds;
	            var i = inviteIds.indexOf(index);
	            if (i > -1) {
	                inviteIds.splice(i, 1);
	            }
	            if (!inviteIds.length) {
	                inviteIds.push(++count);
	            }
	            this.setState({ inviteIds: inviteIds, idCount: count });
	        }
	    }, {
	        key: 'showGetTeamInviteLinkModal',
	        value: function showGetTeamInviteLinkModal() {
	            this.handleHide(false);
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_action_creators_global_actions_jsx__.showGetTeamInviteLinkModal();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var currentUser = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentUser();
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            if (currentUser != null && this.state.teamType != null) {
	                var inviteSections = [];
	                var inviteIds = this.state.inviteIds;
	                for (var i = 0; i < inviteIds.length; i++) {
	                    var index = inviteIds[i];
	                    var emailError = null;
	                    if (this.state.emailErrors[index]) {
	                        emailError = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            this.state.emailErrors[index]
	                        );
	                    }
	                    var firstNameError = null;
	                    if (this.state.firstNameErrors[index]) {
	                        firstNameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            this.state.firstNameErrors[index]
	                        );
	                    }
	                    var lastNameError = null;
	                    if (this.state.lastNameErrors[index]) {
	                        lastNameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            this.state.lastNameErrors[index]
	                        );
	                    }
	
	                    var removeButton = null;
	                    if (index) {
	                        removeButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-link remove__member',
	                                    onClick: this.removeInviteFields.bind(this, index)
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('span', { className: 'fa fa-trash' })
	                            )
	                        );
	                    }
	                    var emailClass = 'form-group invite';
	                    if (emailError) {
	                        emailClass += ' has-error';
	                    }
	
	                    var nameFields = null;
	
	                    var firstNameClass = 'form-group';
	                    if (firstNameError) {
	                        firstNameClass += ' has-error';
	                    }
	                    var lastNameClass = 'form-group';
	                    if (lastNameError) {
	                        lastNameClass += ' has-error';
	                    }
	                    nameFields = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { className: 'row--invite' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'div',
	                                { className: firstNameClass },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                    type: 'text',
	                                    className: 'form-control',
	                                    ref: 'first_name' + index,
	                                    placeholder: formatMessage(holders.firstname),
	                                    maxLength: '64',
	                                    disabled: !this.state.emailEnabled || !this.state.userCreationEnabled,
	                                    spellCheck: 'false'
	                                }),
	                                firstNameError
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-6' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'div',
	                                { className: lastNameClass },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                    type: 'text',
	                                    className: 'form-control',
	                                    ref: 'last_name' + index,
	                                    placeholder: formatMessage(holders.lastname),
	                                    maxLength: '64',
	                                    disabled: !this.state.emailEnabled || !this.state.userCreationEnabled,
	                                    spellCheck: 'false'
	                                }),
	                                lastNameError
	                            )
	                        )
	                    );
	
	                    inviteSections[index] = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { key: 'key' + index },
	                        removeButton,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: emailClass },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                onKeyUp: this.displayNameKeyUp,
	                                type: 'text',
	                                ref: 'email' + index,
	                                className: 'form-control',
	                                placeholder: 'email@domain.com',
	                                maxLength: '64',
	                                disabled: !this.state.emailEnabled || !this.state.userCreationEnabled,
	                                spellCheck: 'false'
	                            }),
	                            emailError
	                        ),
	                        nameFields
	                    );
	                }
	
	                var serverError = null;
	                if (this.state.serverError) {
	                    serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group has-error' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'control-label' },
	                            this.state.serverError
	                        )
	                    );
	                }
	
	                var content = null;
	                var sendButton = null;
	
	                var defaultChannelName = '';
	                if (/* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__["a"].getByName(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].DEFAULT_CHANNEL)) {
	                    defaultChannelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_channel_store_jsx__["a"].getByName(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].DEFAULT_CHANNEL).display_name;
	                }
	
	                if (this.state.emailEnabled && this.state.userCreationEnabled) {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        null,
	                        serverError,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-default',
	                                onClick: this.addInviteFields
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'invite_member.addAnother',
	                                defaultMessage: 'Add another'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'span',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedHTMLMessage"], {
	                                id: 'invite_member.autoJoin',
	                                defaultMessage: 'People invited automatically join the <strong>{channel}</strong> channel.',
	                                values: {
	                                    channel: defaultChannelName
	                                }
	                            })
	                        )
	                    );
	
	                    var sendButtonLabel = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'invite_member.send',
	                        defaultMessage: 'Send Invitation'
	                    });
	                    if (this.state.isSendingEmails) {
	                        sendButtonLabel = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'span',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('i', { className: 'fa fa-spinner fa-spin' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'invite_member.sending',
	                                defaultMessage: ' Sending'
	                            })
	                        );
	                    } else if (this.state.inviteIds.length > 1) {
	                        sendButtonLabel = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'invite_member.send2',
	                            defaultMessage: 'Send Invitations'
	                        });
	                    }
	
	                    sendButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'button',
	                        {
	                            onClick: this.handleSubmit,
	                            type: 'button',
	                            className: 'btn btn-primary',
	                            disabled: this.state.isSendingEmails
	                        },
	                        sendButtonLabel
	                    );
	                } else if (this.state.userCreationEnabled) {
	                    var teamInviteLink = null;
	                    if (currentUser && this.state.teamType === 'O') {
	                        var link = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                onClick: this.showGetTeamInviteLinkModal
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'invite_member.inviteLink',
	                                defaultMessage: 'Team Invite Link'
	                            })
	                        );
	
	                        teamInviteLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'invite_member.teamInviteLink',
	                                defaultMessage: 'You can also invite people using the {link}.',
	                                values: {
	                                    link: link
	                                }
	                            })
	                        );
	                    }
	
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'invite_member.content',
	                                defaultMessage: 'Email is currently disabled for your team, and email invitations cannot be sent. Contact your system administrator to enable email and email invitations.'
	                            })
	                        ),
	                        teamInviteLink
	                    );
	                } else {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'invite_member.disabled',
	                                defaultMessage: 'User creation has been disabled for your team. Please ask your team administrator for details.'
	                            })
	                        )
	                    );
	                }
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Modal"],
	                        {
	                            dialogClassName: 'modal-invite-member',
	                            show: this.state.show,
	                            onHide: this.handleHide.bind(this, true),
	                            enforceFocus: !this.state.showConfirmModal,
	                            backdrop: this.state.isSendingEmails ? 'static' : true
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Modal"].Header,
	                            { closeButton: !this.state.isSendingEmails },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Modal"].Title,
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                    id: 'invite_member.newMember',
	                                    defaultMessage: 'Invite New Member'
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Modal"].Body,
	                            { ref: 'modalBody' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'form',
	                                { role: 'form' },
	                                inviteSections
	                            ),
	                            content
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["Modal"].Footer,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-default',
	                                    onClick: this.handleHide.bind(this, true),
	                                    disabled: this.state.isSendingEmails
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                    id: 'invite_member.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            sendButton
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__confirm_modal_jsx__["a"], {
	                        title: formatMessage(holders.modalTitle),
	                        message: formatMessage(holders.modalMessage),
	                        confirmButton: formatMessage(holders.modalButton),
	                        show: this.state.showConfirmModal,
	                        onConfirm: this.handleHide.bind(this, false),
	                        onCancel: function onCancel() {
	                            return _this3.setState({ showConfirmModal: false });
	                        }
	                    })
	                );
	            }
	
	            return null;
	        }
	    }]);
	
	    return InviteMemberModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);
	
	InviteMemberModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["injectIntl"].bind()(InviteMemberModal);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_action_creators_websocket_actions_jsx__ = __webpack_require__(243);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router___default = __WEBPACK_IMPORTED_MODULE_14_react_router__ && __WEBPACK_IMPORTED_MODULE_14_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var CLIENT_STATUS_INTERVAL = 30000;
	var BACKSPACE_CHAR = 8;
	
	
	
	var LoggedIn = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LoggedIn, _React$Component);
	
	    function LoggedIn(params) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LoggedIn);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LoggedIn).call(this, params));
	
	        _this.onUserChanged = _this.onUserChanged.bind(_this);
	        _this.setupUser = _this.setupUser.bind(_this);
	
	        _this.state = {
	            user: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentUser()
	        };
	
	        if (_this.state.user) {
	            _this.setupUser(_this.state.user);
	        }
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LoggedIn, [{
	        key: 'isValidState',
	        value: function isValidState() {
	            return this.state.user != null;
	        }
	    }, {
	        key: 'setupUser',
	        value: function setupUser(user) {
	            // Update segment indentify
	            if (global.window.mm_config.SegmentDeveloperKey != null && global.window.mm_config.SegmentDeveloperKey !== '') {
	                global.window.analytics.identify(user.id, {
	                    name: user.nickname,
	                    email: user.email,
	                    createdAt: user.create_at,
	                    username: user.username,
	                    id: user.id
	                });
	            }
	
	            // Update CSS classes to match user theme
	            if (user) {
	                if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isPlainObject(user.theme_props) && !/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isEmptyObject(user.theme_props)) {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.applyTheme(user.theme_props);
	                } else {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.applyTheme(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].THEMES.default);
	                }
	            }
	        }
	    }, {
	        key: 'onUserChanged',
	        value: function onUserChanged() {
	            // Grab the current user
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentUser();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(this.state.user, user)) {
	                this.setupUser(user);
	                this.setState({
	                    user: user
	                });
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Listen for user
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].addChangeListener(this.onUserChanged);
	
	            // Initalize websockets
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_websocket_actions_jsx__.initialize();
	
	            // Get all statuses regularally. (Soon to be switched to websocket)
	            this.intervalId = setInterval(function () {
	                return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_async_client_jsx__.getStatuses();
	            }, CLIENT_STATUS_INTERVAL);
	
	            // Force logout of all tabs if one tab is logged out
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).bind('storage', function (e) {
	                // when one tab on a browser logs out, it sets __logout__ in localStorage to trigger other tabs to log out
	                if (e.originalEvent.key === '__logout__' && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
	                    // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
	                    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].isSignallingLogout(e.originalEvent.newValue)) {
	                        return;
	                    }
	
	                    console.log('detected logout from a different tab'); //eslint-disable-line no-console
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_router__["browserHistory"].push('/');
	                }
	
	                if (e.originalEvent.key === '__login__' && e.originalEvent.storageArea === localStorage && e.originalEvent.newValue) {
	                    // make sure it isn't this tab that is sending the logout signal (only necessary for IE11)
	                    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].isSignallingLogin(e.originalEvent.newValue)) {
	                        return;
	                    }
	
	                    console.log('detected login from a different tab'); //eslint-disable-line no-console
	                    location.reload();
	                }
	            });
	
	            // Because current CSS requires the root tag to have specific stuff
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#root').attr('class', 'channel-view');
	
	            // ???
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').on('mouseenter mouseleave', '.post', function mouseOver(ev) {
	                if (ev.type === 'mouseenter') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').prev('.date-separator, .new-separator').addClass('hovered--after');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').next('.date-separator, .new-separator').addClass('hovered--before');
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').prev('.date-separator, .new-separator').removeClass('hovered--after');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').next('.date-separator, .new-separator').removeClass('hovered--before');
	                }
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').on('mouseenter mouseleave', '.search-item__container .post', function mouseOver(ev) {
	                if (ev.type === 'mouseenter') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).closest('.search-item__container').find('.date-separator').addClass('hovered--after');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).closest('.search-item__container').next('div').find('.date-separator').addClass('hovered--before');
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).closest('.search-item__container').find('.date-separator').removeClass('hovered--after');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).closest('.search-item__container').next('div').find('.date-separator').removeClass('hovered--before');
	                }
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').on('mouseenter mouseleave', '.post.post--comment.same--root', function mouseOver(ev) {
	                if (ev.type === 'mouseenter') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').prev('.date-separator, .new-separator').addClass('hovered--comment');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').next('.date-separator, .new-separator').addClass('hovered--comment');
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').prev('.date-separator, .new-separator').removeClass('hovered--comment');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).parent('div').next('.date-separator, .new-separator').removeClass('hovered--comment');
	                }
	            });
	
	            // Device tracking setup
	            var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	            if (iOS) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').addClass('ios');
	            }
	
	            // if preferences have already been stored in local storage do not wait until preference store change is fired and handled in channel.jsx
	            var selectedFont = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].get(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].Preferences.CATEGORY_DISPLAY_SETTINGS, 'selected_font', /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].DEFAULT_FONT);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.applyFont(selectedFont);
	
	            // Pervent backspace from navigating back a page
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).on('keydown.preventBackspace', function (e) {
	                if (e.which === BACKSPACE_CHAR && !/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).is('input, textarea')) {
	                    e.preventDefault();
	                }
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#root').attr('class', '');
	            clearInterval(this.intervalId);
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_websocket_actions_jsx__.close();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChanged);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').off('click.userpopover');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').off('mouseenter mouseleave', '.post');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').off('mouseenter mouseleave', '.post.post--comment.same--root');
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.modal').off('show.bs.modal');
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).off('keydown.preventBackspace');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.isValidState()) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_components_loading_screen_jsx__["a"], null);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.cloneElement(this.props.children, {
	                user: this.state.user
	            });
	        }
	    }]);
	
	    return LoggedIn;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = LoggedIn;
	
	
	LoggedIn.propTypes = {
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.object
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var LoginMfa = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(LoginMfa, _React$Component);
	
	    function LoginMfa(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, LoginMfa);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(LoginMfa).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	        _this.state = {
	            serverError: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(LoginMfa, [{
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            e.preventDefault();
	            var state = {};
	
	            var token = this.refs.token.value.trim().replace(/\s/g, '');
	            if (!token) {
	                state.serverError = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('login_mfa.tokenReq', 'Please enter an MFA token');
	                this.setState(state);
	                return;
	            }
	
	            state.serverError = '';
	            this.setState(state);
	
	            this.props.submit(this.props.loginId, this.props.password, token);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = void 0;
	            var errorClass = '';
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.serverError
	                );
	                errorClass = ' has-error';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'form',
	                { onSubmit: this.handleSubmit },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'signup__email-container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'login_mfa.enterToken',
	                            defaultMessage: 'To complete the sign in process, please enter a token from your smartphone\'s authenticator'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' + errorClass },
	                        serverError
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' + errorClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', {
	                            type: 'text',
	                            className: 'form-control',
	                            name: 'token',
	                            ref: 'token',
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.localizeMessage('login_mfa.token', 'MFA Token'),
	                            spellCheck: 'false',
	                            autoComplete: 'off',
	                            autoFocus: true
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'submit',
	                                className: 'btn btn-primary'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'login_mfa.submit',
	                                defaultMessage: 'Submit'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginMfa;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = LoginMfa;
	
	LoginMfa.defaultProps = {};
	
	LoginMfa.propTypes = {
	    loginId: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	    password: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	    submit: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_mfa_jsx__ = __webpack_require__(709);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_error_bar_jsx__ = __webpack_require__(187);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_error_jsx__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl___default = __WEBPACK_IMPORTED_MODULE_14_react_intl__ && __WEBPACK_IMPORTED_MODULE_14_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router___default = __WEBPACK_IMPORTED_MODULE_15_react_router__ && __WEBPACK_IMPORTED_MODULE_15_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __WEBPACK_IMPORTED_MODULE_16_react__ && __WEBPACK_IMPORTED_MODULE_16_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_logo_png__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_logo_png___default = __WEBPACK_IMPORTED_MODULE_17_images_logo_png__ && __WEBPACK_IMPORTED_MODULE_17_images_logo_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_images_logo_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_images_logo_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_images_logo_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_images_logo_png___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Login = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Login, _React$Component);
	
	    function Login(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Login);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Login).call(this, props));
	
	        _this.preSubmit = _this.preSubmit.bind(_this);
	        _this.submit = _this.submit.bind(_this);
	        _this.finishSignin = _this.finishSignin.bind(_this);
	
	        _this.handleLoginIdChange = _this.handleLoginIdChange.bind(_this);
	        _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
	
	        _this.state = {
	            loginId: '', // the browser will set a default for this
	            password: '',
	            showMfa: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Login, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.title = global.window.mm_config.SiteName;
	
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentUser()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/select_team');
	            }
	        }
	    }, {
	        key: 'preSubmit',
	        value: function preSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var loginId = this.state.loginId.trim();
	            var password = this.state.password.trim();
	
	            if (global.window.mm_config.EnableMultifactorAuthentication === 'true') {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].checkMfa(loginId, function (data) {
	                    if (data.mfa_required === 'true') {
	                        _this2.setState({ showMfa: true });
	                    } else {
	                        _this2.submit(loginId, password, '');
	                    }
	                }, function (err) {
	                    _this2.setState({ serverError: err.message });
	                });
	            } else {
	                this.submit(loginId, password, '');
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit(loginId, password, token) {
	            var _this3 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].webLogin(loginId, password, token, function () {
	                _this3.setState({ serverError: null });
	                _this3.finishSignin();
	            }, function (err) {
	                if (err.id === 'api.user.login.not_verified.app_error') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/should_verify_email?&email=' + encodeURIComponent(loginId));
	                    return;
	                } else if (err.id === 'store.sql_user.get_for_login.app_error' || err.id === 'ent.ldap.do_login.user_not_registered.app_error') {
	                    _this3.setState({
	                        showMfa: false,
	                        serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.userNotFound',
	                            defaultMessage: 'We couldn\'t find an account matching your login credentials.'
	                        })
	                    });
	                } else if (err.id === 'api.user.check_user_password.invalid.app_error' || err.id === 'ent.ldap.do_login.invalid_password.app_error') {
	                    _this3.setState({
	                        showMfa: false,
	                        serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.invalidPassword',
	                            defaultMessage: 'Your password is incorrect.'
	                        })
	                    });
	                } else {
	                    _this3.setState({ showMfa: false, serverError: err.message });
	                }
	            });
	        }
	    }, {
	        key: 'finishSignin',
	        value: function finishSignin() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitInitialLoad(function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/select_team');
	            });
	        }
	    }, {
	        key: 'handleLoginIdChange',
	        value: function handleLoginIdChange(e) {
	            this.setState({
	                loginId: e.target.value
	            });
	        }
	    }, {
	        key: 'handlePasswordChange',
	        value: function handlePasswordChange(e) {
	            this.setState({
	                password: e.target.value
	            });
	        }
	    }, {
	        key: 'createCustomLogin',
	        value: function createCustomLogin() {
	            if (global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.CustomBrand === 'true' && global.window.mm_config.EnableCustomBrand === 'true') {
	                var text = global.window.mm_config.CustomBrandText || '';
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
	                        src: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].getAdminRoute() + '/get_brand_image'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p', { dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_text_formatting_jsx__.formatText(text) } })
	                );
	            }
	
	            return null;
	        }
	    }, {
	        key: 'createLoginPlaceholder',
	        value: function createLoginPlaceholder(emailSigninEnabled, usernameSigninEnabled, ldapEnabled) {
	            var loginPlaceholders = [];
	            if (emailSigninEnabled) {
	                loginPlaceholders.push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('login.email', 'Email'));
	            }
	
	            if (usernameSigninEnabled) {
	                loginPlaceholders.push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('login.username', 'Username'));
	            }
	
	            if (ldapEnabled) {
	                if (global.window.mm_config.LdapLoginFieldName) {
	                    loginPlaceholders.push(global.window.mm_config.LdapLoginFieldName);
	                } else {
	                    loginPlaceholders.push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('login.ldap_username', 'LDAP Username'));
	                }
	            }
	
	            if (loginPlaceholders.length >= 2) {
	                return loginPlaceholders.slice(0, loginPlaceholders.length - 1).join(', ') + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('login.placeholderOr', ' or ') + loginPlaceholders[loginPlaceholders.length - 1];
	            } else if (loginPlaceholders.length === 1) {
	                return loginPlaceholders[0];
	            }
	
	            return '';
	        }
	    }, {
	        key: 'createLoginOptions',
	        value: function createLoginOptions() {
	            var extraParam = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getUrlParameter('extra');
	            var extraBox = '';
	            if (extraParam) {
	                if (extraParam === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].SIGNIN_CHANGE) {
	                    extraBox = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.changed',
	                            defaultMessage: ' Sign-in method changed successfully'
	                        })
	                    );
	                } else if (extraParam === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].SIGNIN_VERIFIED) {
	                    extraBox = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.verified',
	                            defaultMessage: ' Email Verified'
	                        })
	                    );
	                } else if (extraParam === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].SESSION_EXPIRED) {
	                    extraBox = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'alert alert-warning' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i', { className: 'fa fa-exclamation-triangle' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.session_expired',
	                            defaultMessage: ' Your session has expired. Please login again.'
	                        })
	                    );
	                } else if (extraParam === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].PASSWORD_CHANGE) {
	                    extraBox = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.passwordChanged',
	                            defaultMessage: ' Password updated successfully'
	                        })
	                    );
	                }
	            }
	
	            var loginControls = [];
	
	            var ldapEnabled = global.window.mm_config.EnableLdap === 'true';
	            var gitlabSigninEnabled = global.window.mm_config.EnableSignUpWithGitLab === 'true';
	            var googleSigninEnabled = global.window.mm_config.EnableSignUpWithGoogle === 'true';
	            var usernameSigninEnabled = global.window.mm_config.EnableSignInWithUsername === 'true';
	            var emailSigninEnabled = global.window.mm_config.EnableSignInWithEmail === 'true';
	
	            if (emailSigninEnabled || usernameSigninEnabled || ldapEnabled) {
	                var errorClass = '';
	                if (this.state.serverError) {
	                    errorClass = ' has-error';
	                }
	
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'form',
	                    {
	                        key: 'loginBoxes',
	                        onSubmit: this.preSubmit
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'signup__email-container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_components_form_error_jsx__["a"], { error: this.state.serverError }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' + errorClass },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                name: 'loginId',
	                                value: this.state.loginId,
	                                onChange: this.handleLoginIdChange,
	                                placeholder: this.createLoginPlaceholder(emailSigninEnabled, usernameSigninEnabled, ldapEnabled),
	                                spellCheck: 'false'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' + errorClass },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                type: 'password',
	                                className: 'form-control',
	                                name: 'password',
	                                value: this.state.password,
	                                onChange: this.handlePasswordChange,
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.localizeMessage('login.password', 'Password'),
	                                spellCheck: 'false'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: 'btn btn-primary',
	                                    disabled: !this.state.loginId || !this.state.password
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                    id: 'login.signIn',
	                                    defaultMessage: 'Sign in'
	                                })
	                            )
	                        )
	                    )
	                ));
	            }
	
	            if (global.window.mm_config.EnableOpenServer === 'true') {
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { key: 'signup' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.noAccount',
	                            defaultMessage: 'Don\'t have an account? '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["Link"],
	                            {
	                                to: '/signup_user_complete',
	                                className: 'signup-team-login'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'login.create',
	                                defaultMessage: 'Create one now'
	                            })
	                        )
	                    )
	                ));
	            }
	
	            if (usernameSigninEnabled || emailSigninEnabled) {
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'forgotPassword',
	                        className: 'form-group'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["Link"],
	                        { to: '/reset_password' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.forgot',
	                            defaultMessage: 'I forgot my password'
	                        })
	                    )
	                ));
	            }
	
	            if ((emailSigninEnabled || usernameSigninEnabled || ldapEnabled) && (gitlabSigninEnabled || googleSigninEnabled)) {
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'divider',
	                        className: 'or__container'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'login.or',
	                        defaultMessage: 'or'
	                    })
	                ));
	
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'h5',
	                    { key: 'oauthHeader' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'login.signInWith',
	                        defaultMessage: 'Sign in with:'
	                    })
	                ));
	            }
	
	            if (gitlabSigninEnabled) {
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'btn btn-custom-login gitlab',
	                        key: 'gitlab',
	                        href: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].getOAuthRoute() + '/gitlab/login'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span', { className: 'icon' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.gitlab',
	                            defaultMessage: 'GitLab'
	                        })
	                    )
	                ));
	            }
	
	            if (googleSigninEnabled) {
	                loginControls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["Link"],
	                    {
	                        className: 'btn btn-custom-login google',
	                        key: 'google',
	                        to: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].getOAuthRoute() + '/google/login'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span', { className: 'icon' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.google',
	                            defaultMessage: 'Google Apps'
	                        })
	                    )
	                ));
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                null,
	                extraBox,
	                loginControls
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = void 0;
	            var customContent = void 0;
	            var customClass = void 0;
	            if (this.state.showMfa) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__components_login_mfa_jsx__["a"], {
	                    loginId: this.state.loginId,
	                    password: this.state.password,
	                    submit: this.submit
	                });
	            } else {
	                content = this.createLoginOptions();
	                customContent = this.createCustomLogin();
	                if (customContent) {
	                    customClass = 'branded';
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_components_error_bar_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container ' + customClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'signup__markdown' },
	                            customContent
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
	                            className: 'signup-team-logo',
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_images_logo_png___default.a
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'signup__content' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'h1',
	                                null,
	                                global.window.mm_config.SiteName
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'h4',
	                                { className: 'color--light' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                    id: 'web.root.singup_info'
	                                })
	                            ),
	                            content
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Login;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Login;
	
	
	Login.defaultProps = {};
	Login.propTypes = {
	    params: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.object.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtered_user_list_jsx__ = __webpack_require__(188);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team_members_dropdown_jsx__ = __webpack_require__(761);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var MemberListTeam = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(MemberListTeam, _React$Component);
	
	    function MemberListTeam(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MemberListTeam);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MemberListTeam).call(this, props));
	
	        _this.getUsers = _this.getUsers.bind(_this);
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onTeamChange = _this.onTeamChange.bind(_this);
	
	        _this.state = {
	            users: _this.getUsers(),
	            teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].getMembersForTeam()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(MemberListTeam, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].addChangeListener(this.onTeamChange);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].getCurrentId());
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].removeChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'getUsers',
	        value: function getUsers() {
	            var profiles = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getProfiles();
	            var users = [];
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(profiles)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var id = _step.value;
	
	                    users.push(profiles[id]);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            users.sort(function (a, b) {
	                return a.username.localeCompare(b.username);
	            });
	
	            return users;
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.setState({
	                users: this.getUsers()
	            });
	        }
	    }, {
	        key: 'onTeamChange',
	        value: function onTeamChange() {
	            this.setState({
	                teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].getMembersForTeam()
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__filtered_user_list_jsx__["a"], {
	                style: this.props.style,
	                users: this.state.users,
	                teamMembers: this.state.teamMembers,
	                actions: [/* harmony import */__WEBPACK_IMPORTED_MODULE_8__team_members_dropdown_jsx__["a"]]
	            });
	        }
	    }]);
	
	    return MemberListTeam;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = MemberListTeam;
	
	
	MemberListTeam.propTypes = {
	    style: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object
	};

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__new_channel_flow_jsx__ = __webpack_require__(364);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router___default = __WEBPACK_IMPORTED_MODULE_13_react_router__ && __WEBPACK_IMPORTED_MODULE_13_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dom___default = __WEBPACK_IMPORTED_MODULE_15_react_dom__ && __WEBPACK_IMPORTED_MODULE_15_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_17_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_17_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_images_load_gif___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function getStateFromStores() {
	    return {
	        channels: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].getMoreAll(),
	        serverError: null
	    };
	}
	
	var MoreChannels = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(MoreChannels, _React$Component);
	
	    function MoreChannels(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MoreChannels);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MoreChannels).call(this, props));
	
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	        _this.handleJoin = _this.handleJoin.bind(_this);
	        _this.handleNewChannel = _this.handleNewChannel.bind(_this);
	        _this.createChannelRow = _this.createChannelRow.bind(_this);
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	
	        var initState = getStateFromStores();
	        initState.channelType = '';
	        initState.joiningChannel = -1;
	        initState.showNewChannelModal = false;
	        _this.state = initState;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(MoreChannels, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].addMoreChangeListener(this.onListenerChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_dom___default.a.findDOMNode(this.refs.modal)).on('shown.bs.modal', function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_async_client_jsx__.getMoreChannels(true);
	            });
	
	            var self = this;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_dom___default.a.findDOMNode(this.refs.modal)).on('show.bs.modal', function (e) {
	                var button = e.relatedTarget;
	                self.setState({ channelType: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(button).attr('data-channeltype') });
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].removeMoreChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            var newState = getStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(newState.channels, this.state.channels)) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'handleJoin',
	        value: function handleJoin(channel, channelIndex) {
	            var _this2 = this;
	
	            this.setState({ joiningChannel: channelIndex });
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitJoinChannelEvent(channel, function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_dom___default.a.findDOMNode(_this2.refs.modal)).modal('hide');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/channels/' + channel.name);
	                _this2.setState({ joiningChannel: -1 });
	            }, function (err) {
	                _this2.setState({ joiningChannel: -1, serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleNewChannel',
	        value: function handleNewChannel() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_dom___default.a.findDOMNode(this.refs.modal)).modal('hide');
	            this.setState({ showNewChannelModal: true });
	        }
	    }, {
	        key: 'createChannelRow',
	        value: function createChannelRow(channel, index) {
	            var joinButton = void 0;
	            if (this.state.joiningChannel === index) {
	                joinButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('img', {
	                    className: 'join-channel-loading-gif',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_images_load_gif___default.a
	                });
	            } else {
	                joinButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'button',
	                    {
	                        onClick: this.handleJoin.bind(self, channel, index),
	                        className: 'btn btn-primary'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'more_channels.join',
	                        defaultMessage: 'Join'
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                {
	                    className: 'more-modal__row',
	                    key: channel.id
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'more-modal__details' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'p',
	                        { className: 'more-modal__name' },
	                        channel.display_name
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'p',
	                        { className: 'more-modal__description' },
	                        channel.purpose
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'more-modal__actions' },
	                    joinButton
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var maxHeight = 1000;
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.windowHeight() <= 1200) {
	                maxHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.windowHeight() - 300;
	            }
	
	            var serverError;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var moreChannels;
	
	            if (this.state.channels != null) {
	                var channels = this.state.channels;
	                if (channels.loading) {
	                    moreChannels = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__loading_screen_jsx__["a"], null);
	                } else if (channels.length) {
	                    moreChannels = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'more-modal__list' },
	                        channels.map(this.createChannelRow)
	                    );
	                } else {
	                    moreChannels = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'no-channel-message' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'p',
	                            { className: 'primary-message' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'more_channels.noMore',
	                                defaultMessage: 'No more channels to join'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'p',
	                            { className: 'secondary-message' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                id: 'more_channels.createClick',
	                                defaultMessage: 'Click \'Create New Channel\' to make a new one'
	                            })
	                        )
	                    );
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                {
	                    className: 'modal fade more-channel__modal',
	                    id: 'more_channels',
	                    ref: 'modal',
	                    tabIndex: '-1',
	                    role: 'dialog',
	                    'aria-hidden': 'true'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-dialog' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'modal-content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-header' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'close',
	                                    'data-dismiss': 'modal'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'span',
	                                    { 'aria-hidden': 'true' },
	                                    '×'
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'span',
	                                    { className: 'sr-only' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'more_channels.close',
	                                        defaultMessage: 'Close'
	                                    })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'h4',
	                                { className: 'modal-title' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'more_channels.title',
	                                    defaultMessage: 'More Channels'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-primary channel-create-btn',
	                                    onClick: this.handleNewChannel
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'more_channels.create',
	                                    defaultMessage: 'Create New Channel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__new_channel_flow_jsx__["a"], {
	                                show: this.state.showNewChannelModal,
	                                channelType: this.state.channelType,
	                                onModalDismissed: function onModalDismissed() {
	                                    return _this3.setState({ showNewChannelModal: false });
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'modal-body',
	                                style: { maxHeight: maxHeight }
	                            },
	                            moreChannels,
	                            serverError
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-footer' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-default',
	                                    'data-dismiss': 'modal'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                    id: 'more_channels.close',
	                                    defaultMessage: 'Close'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MoreChannels;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = MoreChannels;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filtered_user_list_jsx__ = __webpack_require__(188);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router___default = __WEBPACK_IMPORTED_MODULE_12_react_router__ && __WEBPACK_IMPORTED_MODULE_12_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_spinner_button_jsx__ = __webpack_require__(159);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var MoreDirectChannels = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(MoreDirectChannels, _React$Component);
	
	    function MoreDirectChannels(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MoreDirectChannels);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MoreDirectChannels).call(this, props));
	
	        _this.handleHide = _this.handleHide.bind(_this);
	        _this.handleOnEnter = _this.handleOnEnter.bind(_this);
	        _this.handleShowDirectChannel = _this.handleShowDirectChannel.bind(_this);
	        _this.handleUserChange = _this.handleUserChange.bind(_this);
	        _this.onTeamChange = _this.onTeamChange.bind(_this);
	        _this.createJoinDirectChannelButton = _this.createJoinDirectChannelButton.bind(_this);
	
	        _this.state = {
	            users: null,
	            teamMembers: null,
	            loadingDMChannel: -1
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(MoreDirectChannels, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].addDmListChangeListener(this.handleUserChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].addChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].removeDmListChangeListener(this.handleUserChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].removeChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (nextProps.show !== this.props.show) {
	                return true;
	            }
	
	            if (nextProps.onModalDismissed.toString() !== this.props.onModalDismissed.toString()) {
	                return true;
	            }
	
	            if (nextState.loadingDMChannel !== this.state.loadingDMChannel) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(nextState.users, this.state.users)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(nextState.teamMembers, this.state.teamMembers)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'handleHide',
	        value: function handleHide() {
	            if (this.props.onModalDismissed) {
	                this.props.onModalDismissed();
	            }
	        }
	    }, {
	        key: 'handleOnEnter',
	        value: function handleOnEnter() {
	            this.setState({
	                users: null,
	                teamMembers: null
	            });
	        }
	    }, {
	        key: 'handleOnEntered',
	        value: function handleOnEntered() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__.emitProfilesForDmList();
	        }
	    }, {
	        key: 'handleShowDirectChannel',
	        value: function handleShowDirectChannel(teammate, e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (this.state.loadingDMChannel !== -1) {
	                return;
	            }
	
	            this.setState({ loadingDMChannel: teammate.id });
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.openDirectChannelToUser(teammate, function (channel) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/channels/' + channel.name);
	                _this2.setState({ loadingDMChannel: -1 });
	                _this2.handleHide();
	            }, function () {
	                _this2.setState({ loadingDMChannel: -1 });
	            });
	        }
	    }, {
	        key: 'handleUserChange',
	        value: function handleUserChange() {
	            this.setState({
	                users: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getProfilesForDmList()
	            });
	        }
	    }, {
	        key: 'onTeamChange',
	        value: function onTeamChange() {
	            this.setState({
	                teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].getMembersForTeam()
	            });
	        }
	    }, {
	        key: 'createJoinDirectChannelButton',
	        value: function createJoinDirectChannelButton(_ref) {
	            var user = _ref.user;
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_components_spinner_button_jsx__["a"],
	                {
	                    className: 'btn btm-sm btn-primary',
	                    spinning: this.state.loadingDMChannel === user.id,
	                    onClick: this.handleShowDirectChannel.bind(this, user)
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'more_direct_channels.message',
	                    defaultMessage: 'Message'
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var maxHeight = 1000;
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.windowHeight() <= 1200) {
	                maxHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.windowHeight() - 300;
	            }
	
	            var body = null;
	            if (this.state.users == null || this.state.teamMembers == null) {
	                body = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_components_loading_screen_jsx__["a"], null);
	            } else {
	                var showTeamToggle = false;
	                if (global.window.mm_config.RestrictDirectMessage === 'any') {
	                    showTeamToggle = true;
	                }
	
	                body = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__filtered_user_list_jsx__["a"], {
	                    style: { maxHeight: maxHeight },
	                    users: this.state.users,
	                    teamMembers: this.state.teamMembers,
	                    actions: [this.createJoinDirectChannelButton],
	                    showTeamToggle: showTeamToggle
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"],
	                {
	                    dialogClassName: 'more-modal more-direct-channels',
	                    show: this.props.show,
	                    onHide: this.handleHide,
	                    onEnter: this.handleOnEnter,
	                    onEntered: this.handleOnEntered
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Header,
	                    { closeButton: true },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Title,
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'more_direct_channels.title',
	                            defaultMessage: 'Direct Messages'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Body,
	                    null,
	                    body
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["Modal"].Footer,
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: this.handleHide
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'more_direct_channels.close',
	                            defaultMessage: 'Close'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MoreDirectChannels;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = MoreDirectChannels;
	
	
	MoreDirectChannels.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.bool.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.PropTypes.func
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__edit_channel_header_modal_jsx__ = __webpack_require__(246);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__edit_channel_purpose_modal_jsx__ = __webpack_require__(358);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__message_wrapper_jsx__ = __webpack_require__(362);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notify_counts_jsx__ = __webpack_require__(718);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__channel_info_modal_jsx__ = __webpack_require__(353);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__channel_invite_modal_jsx__ = __webpack_require__(185);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__channel_members_modal_jsx__ = __webpack_require__(354);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channel_notifications_modal_jsx__ = __webpack_require__(355);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__delete_channel_modal_jsx__ = __webpack_require__(357);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rename_channel_modal_jsx__ = __webpack_require__(368);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__toggle_modal_button_jsx__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_intl___default = __WEBPACK_IMPORTED_MODULE_25_react_intl__ && __WEBPACK_IMPORTED_MODULE_25_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_25_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_25_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_25_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_25_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_26_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_26_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_router___default = __WEBPACK_IMPORTED_MODULE_27_react_router__ && __WEBPACK_IMPORTED_MODULE_27_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_27_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_27_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_27_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_27_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __WEBPACK_IMPORTED_MODULE_28_react__ && __WEBPACK_IMPORTED_MODULE_28_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_28_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_28_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_28_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_28_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_23_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	
	
	
	var Navbar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Navbar, _React$Component);
	
	    function Navbar(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Navbar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Navbar).call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.handleLeave = _this.handleLeave.bind(_this);
	        _this.showSearch = _this.showSearch.bind(_this);
	
	        _this.showEditChannelHeaderModal = _this.showEditChannelHeaderModal.bind(_this);
	        _this.showRenameChannelModal = _this.showRenameChannelModal.bind(_this);
	        _this.hideRenameChannelModal = _this.hideRenameChannelModal.bind(_this);
	        _this.isStateValid = _this.isStateValid.bind(_this);
	
	        _this.createCollapseButtons = _this.createCollapseButtons.bind(_this);
	        _this.createDropdown = _this.createDropdown.bind(_this);
	
	        var state = _this.getStateFromStores();
	        state.showEditChannelPurposeModal = false;
	        state.showEditChannelHeaderModal = false;
	        state.showMembersModal = false;
	        state.showRenameChannelModal = false;
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Navbar, [{
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            return {
	                channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getCurrent(),
	                member: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getCurrentMember(),
	                users: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getCurrentExtraInfo().members,
	                currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_user_store_jsx__["a"].getCurrentUser()
	            };
	        }
	    }, {
	        key: 'isStateValid',
	        value: function isStateValid() {
	            return this.state.channel && this.state.member && this.state.users && this.state.currentUser;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].addExtraInfoChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.inner-wrap').click(this.hideSidebars);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].removeExtraInfoChangeListener(this.onChange);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            e.preventDefault();
	        }
	    }, {
	        key: 'handleLeave',
	        value: function handleLeave() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_utils_web_client_jsx__["a"].leaveChannel(this.state.channel.id, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_21_utils_async_client_jsx__.getChannels(true);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_27_react_router__["browserHistory"].push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/channels/town-square');
	            }, function (err) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_21_utils_async_client_jsx__.dispatchError(err, 'handleLeave');
	            });
	        }
	    }, {
	        key: 'hideSidebars',
	        value: function hideSidebars(e) {
	            var windowWidth = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).outerWidth();
	            if (windowWidth <= 768) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_SEARCH,
	                    results: null
	                });
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_POST_SELECTED,
	                    postId: null
	                });
	
	                if (e.target.className !== 'navbar-toggle' && e.target.className !== 'icon-bar') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .inner-wrap').removeClass('move--right move--left move--left-small');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--left').removeClass('move--right');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--right').removeClass('move--left');
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--menu').removeClass('move--left');
	                }
	            }
	        }
	    }, {
	        key: 'toggleLeftSidebar',
	        value: function toggleLeftSidebar() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .inner-wrap').toggleClass('move--right');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--left').toggleClass('move--right');
	        }
	    }, {
	        key: 'toggleRightSidebar',
	        value: function toggleRightSidebar() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .inner-wrap').toggleClass('move--left-small');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--menu').toggleClass('move--left');
	        }
	    }, {
	        key: 'showSearch',
	        value: function showSearch() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_24__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.SHOW_SEARCH
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.setState(this.getStateFromStores());
	        }
	    }, {
	        key: 'showEditChannelHeaderModal',
	        value: function showEditChannelHeaderModal() {
	            // this can't be done using a ToggleModalButton because we can't use one inside an OverlayTrigger
	            if (this.refs.headerOverlay) {
	                this.refs.headerOverlay.hide();
	            }
	
	            this.setState({
	                showEditChannelHeaderModal: true
	            });
	        }
	    }, {
	        key: 'showRenameChannelModal',
	        value: function showRenameChannelModal(e) {
	            e.preventDefault();
	
	            this.setState({
	                showRenameChannelModal: true
	            });
	        }
	    }, {
	        key: 'hideRenameChannelModal',
	        value: function hideRenameChannelModal() {
	            this.setState({
	                showRenameChannelModal: false
	            });
	        }
	    }, {
	        key: 'createDropdown',
	        value: function createDropdown(channel, channelTitle, isAdmin, isDirect, popoverContent) {
	            var _this2 = this;
	
	            if (channel) {
	                var viewInfoOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16__toggle_modal_button_jsx__["a"],
	                        {
	                            role: 'menuitem',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_10__channel_info_modal_jsx__["a"],
	                            dialogProps: { channel: channel }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                            id: 'navbar.viewInfo',
	                            defaultMessage: 'View Info'
	                        })
	                    )
	                );
	
	                var setChannelHeaderOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.showEditChannelHeaderModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                            id: 'navbar.setHeader',
	                            defaultMessage: 'Set Channel Header...'
	                        })
	                    )
	                );
	
	                var setChannelPurposeOption = null;
	                if (!isDirect) {
	                    setChannelPurposeOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'li',
	                        { role: 'presentation' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'a',
	                            {
	                                role: 'menuitem',
	                                href: '#',
	                                onClick: function onClick() {
	                                    return _this2.setState({ showEditChannelPurposeModal: true });
	                                }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                id: 'navbar.setPurpose',
	                                defaultMessage: 'Set Channel Purpose...'
	                            })
	                        )
	                    );
	                }
	
	                var addMembersOption;
	                var leaveChannelOption;
	                if (!isDirect && !/* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].isDefault(channel)) {
	                    addMembersOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'li',
	                        { role: 'presentation' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16__toggle_modal_button_jsx__["a"],
	                            {
	                                role: 'menuitem',
	                                dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_11__channel_invite_modal_jsx__["a"],
	                                dialogProps: { channel: channel, currentUser: this.state.currentUser }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                id: 'navbar.addMembers',
	                                defaultMessage: 'Add Members'
	                            })
	                        )
	                    );
	
	                    leaveChannelOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'li',
	                        { role: 'presentation' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'a',
	                            {
	                                role: 'menuitem',
	                                href: '#',
	                                onClick: this.handleLeave
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                id: 'navbar.leave',
	                                defaultMessage: 'Leave Channel'
	                            })
	                        )
	                    );
	                }
	
	                var manageMembersOption;
	                var renameChannelOption;
	                var deleteChannelOption;
	                if (!isDirect && isAdmin) {
	                    if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].isDefault(channel)) {
	                        manageMembersOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'li',
	                            { role: 'presentation' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                'a',
	                                {
	                                    role: 'menuitem',
	                                    href: '#',
	                                    onClick: function onClick() {
	                                        return _this2.setState({ showMembersModal: true });
	                                    }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                    id: 'navbar.manageMembers',
	                                    defaultMessage: 'Manage Members'
	                                })
	                            )
	                        );
	
	                        deleteChannelOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'li',
	                            { role: 'presentation' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16__toggle_modal_button_jsx__["a"],
	                                {
	                                    role: 'menuitem',
	                                    dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_14__delete_channel_modal_jsx__["a"],
	                                    dialogProps: { channel: channel }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                    id: 'navbar.delete',
	                                    defaultMessage: 'Delete Channel...'
	                                })
	                            )
	                        );
	                    }
	
	                    renameChannelOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'li',
	                        { role: 'presentation' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'a',
	                            {
	                                role: 'menuitem',
	                                href: '#',
	                                onClick: this.showRenameChannelModal
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                id: 'navbar.rename',
	                                defaultMessage: 'Rename Channel...'
	                            })
	                        )
	                    );
	                }
	
	                var notificationPreferenceOption;
	                if (!isDirect) {
	                    notificationPreferenceOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'li',
	                        { role: 'presentation' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16__toggle_modal_button_jsx__["a"],
	                            {
	                                role: 'menuitem',
	                                dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_13__channel_notifications_modal_jsx__["a"],
	                                dialogProps: {
	                                    channel: channel,
	                                    channelMember: this.state.member,
	                                    currentUser: this.state.currentUser
	                                }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                id: 'navbar.preferences',
	                                defaultMessage: 'Notification Preferences'
	                            })
	                        )
	                    );
	                }
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'div',
	                    { className: 'navbar-brand' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'div',
	                        { className: 'dropdown' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["OverlayTrigger"],
	                            {
	                                ref: 'headerOverlay',
	                                trigger: 'click',
	                                placement: 'bottom',
	                                overlay: popoverContent,
	                                className: 'description',
	                                rootClose: true
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('div', { className: 'description info-popover' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                className: 'dropdown-toggle theme',
	                                type: 'button',
	                                'data-toggle': 'dropdown',
	                                'aria-expanded': 'true'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                'span',
	                                { className: 'heading' },
	                                channelTitle,
	                                ' '
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'glyphicon glyphicon-chevron-down header-dropdown__icon' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'ul',
	                            {
	                                className: 'dropdown-menu',
	                                role: 'menu'
	                            },
	                            viewInfoOption,
	                            addMembersOption,
	                            manageMembersOption,
	                            setChannelHeaderOption,
	                            setChannelPurposeOption,
	                            notificationPreferenceOption,
	                            renameChannelOption,
	                            deleteChannelOption,
	                            leaveChannelOption
	                        )
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'div',
	                { className: 'navbar-brand' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_27_react_router__["Link"],
	                    {
	                        to: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/channels/town-square',
	                        className: 'heading'
	                    },
	                    channelTitle
	                )
	            );
	        }
	    }, {
	        key: 'createCollapseButtons',
	        value: function createCollapseButtons(currentId) {
	            var buttons = [];
	            if (currentId == null) {
	                buttons.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'button',
	                    {
	                        key: 'navbar-toggle-collapse',
	                        type: 'button',
	                        className: 'navbar-toggle',
	                        'data-toggle': 'collapse',
	                        'data-target': '#navbar-collapse-1'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                            id: 'navbar.toggle1',
	                            defaultMessage: 'Toggle sidebar'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'icon-bar' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'icon-bar' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'icon-bar' })
	                ));
	            } else {
	                buttons.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'button',
	                    {
	                        key: 'navbar-toggle-sidebar',
	                        type: 'button',
	                        className: 'navbar-toggle',
	                        'data-toggle': 'collapse',
	                        'data-target': '#sidebar-nav',
	                        onClick: this.toggleLeftSidebar
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                            id: 'navbar.toggle2',
	                            defaultMessage: 'Toggle sidebar'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'icon-bar' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'icon-bar' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'icon-bar' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__notify_counts_jsx__["a"], null)
	                ));
	
	                buttons.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'button',
	                    {
	                        key: 'navbar-toggle-menu',
	                        type: 'button',
	                        className: 'navbar-toggle menu-toggle pull-right',
	                        'data-toggle': 'collapse',
	                        'data-target': '#sidebar-nav',
	                        onClick: this.toggleRightSidebar
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: /* harmony import */__WEBPACK_IMPORTED_MODULE_23_utils_constants_jsx__["a"].MENU_ICON } })
	                ));
	            }
	
	            return buttons;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (!this.isStateValid()) {
	                return null;
	            }
	
	            var currentId = this.state.currentUser.id;
	            var channel = this.state.channel;
	            var channelTitle = this.props.teamDisplayName;
	            var popoverContent;
	            var isAdmin = false;
	            var isDirect = false;
	
	            var editChannelHeaderModal = null;
	            var editChannelPurposeModal = null;
	            var renameChannelModal = null;
	            var channelMembersModal = null;
	
	            if (channel) {
	                popoverContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["Popover"],
	                    {
	                        bsStyle: 'info',
	                        placement: 'bottom',
	                        id: 'header-popover'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__message_wrapper_jsx__["a"], {
	                        message: channel.header,
	                        options: { singleline: true, mentionHighlight: false }
	                    })
	                );
	
	                isAdmin = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_22_utils_utils_jsx__.isAdmin(this.state.member.roles) || /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	
	                if (channel.type === 'O') {
	                    channelTitle = channel.display_name;
	                } else if (channel.type === 'P') {
	                    channelTitle = channel.display_name;
	                } else if (channel.type === 'D') {
	                    isDirect = true;
	                    if (this.state.users.length > 1) {
	                        var p = void 0;
	                        if (this.state.users[0].id === currentId) {
	                            p = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_user_store_jsx__["a"].getProfile(this.state.users[1].id);
	                        } else {
	                            p = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_stores_user_store_jsx__["a"].getProfile(this.state.users[0].id);
	                        }
	                        if (p != null) {
	                            channelTitle = p.username;
	                        }
	                    }
	                }
	
	                if (channel.header.length === 0) {
	                    var link = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.showEditChannelHeaderModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                            id: 'navbar.click',
	                            defaultMessage: 'Click here'
	                        })
	                    );
	                    popoverContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["Popover"],
	                        {
	                            bsStyle: 'info',
	                            placement: 'bottom',
	                            id: 'header-popover'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                id: 'navbar.noHeader',
	                                defaultMessage: 'No channel header yet.{newline}{link} to add one.',
	                                values: {
	                                    newline: /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('br', null),
	                                    link: link
	                                }
	                            })
	                        )
	                    );
	                }
	
	                editChannelHeaderModal = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__edit_channel_header_modal_jsx__["a"], {
	                    show: this.state.showEditChannelHeaderModal,
	                    onHide: function onHide() {
	                        return _this3.setState({ showEditChannelHeaderModal: false });
	                    },
	                    channel: channel
	                });
	
	                editChannelPurposeModal = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__edit_channel_purpose_modal_jsx__["a"], {
	                    show: this.state.showEditChannelPurposeModal,
	                    onModalDismissed: function onModalDismissed() {
	                        return _this3.setState({ showEditChannelPurposeModal: false });
	                    },
	                    channel: channel
	                });
	
	                renameChannelModal = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15__rename_channel_modal_jsx__["a"], {
	                    show: this.state.showRenameChannelModal,
	                    onHide: this.hideRenameChannelModal,
	                    channel: channel
	                });
	
	                channelMembersModal = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__channel_members_modal_jsx__["a"], {
	                    show: this.state.showMembersModal,
	                    onModalDismissed: function onModalDismissed() {
	                        return _this3.setState({ showMembersModal: false });
	                    },
	                    channel: channel
	                });
	            }
	
	            var collapseButtons = this.createCollapseButtons(currentId);
	
	            var searchButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'button',
	                {
	                    type: 'button',
	                    className: 'navbar-toggle pull-right',
	                    onClick: this.showSearch
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', { className: 'glyphicon glyphicon-search icon--white' })
	            );
	
	            var channelMenuDropdown = this.createDropdown(channel, channelTitle, isAdmin, isDirect, popoverContent);
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'nav',
	                    {
	                        className: 'navbar navbar-default navbar-fixed-top',
	                        role: 'navigation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'div',
	                        { className: 'container-fluid theme' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'div',
	                            { className: 'navbar-header' },
	                            collapseButtons,
	                            searchButton,
	                            channelMenuDropdown
	                        )
	                    )
	                ),
	                editChannelHeaderModal,
	                editChannelPurposeModal,
	                renameChannelModal,
	                channelMembersModal
	            );
	        }
	    }]);
	
	    return Navbar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Navbar;
	
	
	Navbar.defaultProps = {
	    teamDisplayName: ''
	};
	Navbar.propTypes = {
	    teamDisplayName: /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.PropTypes.string
	};

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__about_build_modal_jsx__ = __webpack_require__(344);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__team_members_modal_jsx__ = __webpack_require__(372);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toggle_modal_button_jsx__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__user_settings_user_settings_modal_jsx__ = __webpack_require__(373);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl___default = __WEBPACK_IMPORTED_MODULE_16_react_intl__ && __WEBPACK_IMPORTED_MODULE_16_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router___default = __WEBPACK_IMPORTED_MODULE_17_react_router__ && __WEBPACK_IMPORTED_MODULE_17_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __WEBPACK_IMPORTED_MODULE_18_react__ && __WEBPACK_IMPORTED_MODULE_18_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var NavbarDropdown = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NavbarDropdown, _React$Component);
	
	    function NavbarDropdown(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NavbarDropdown);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NavbarDropdown).call(this, props));
	
	        _this.blockToggle = false;
	
	        _this.handleAboutModal = _this.handleAboutModal.bind(_this);
	        _this.aboutModalDismissed = _this.aboutModalDismissed.bind(_this);
	        _this.onTeamChange = _this.onTeamChange.bind(_this);
	
	        _this.state = {
	            showUserSettingsModal: false,
	            showAboutModal: false,
	            teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].getAll(),
	            teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].getTeamMembers()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NavbarDropdown, [{
	        key: 'handleAboutModal',
	        value: function handleAboutModal() {
	            this.setState({ showAboutModal: true });
	        }
	    }, {
	        key: 'aboutModalDismissed',
	        value: function aboutModalDismissed() {
	            this.setState({ showAboutModal: false });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.dropdown)).on('hide.bs.dropdown', function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.sidebar--left .dropdown-menu').scrollTop(0);
	                _this2.blockToggle = true;
	                setTimeout(function () {
	                    _this2.blockToggle = false;
	                }, 100);
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].addChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'onTeamChange',
	        value: function onTeamChange() {
	            this.setState({
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].getAll(),
	                teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].getTeamMembers()
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.dropdown)).off('hide.bs.dropdown');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].removeChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var teamLink = '';
	            var inviteLink = '';
	            var manageLink = '';
	            var sysAdminLink = '';
	            var adminDivider = '';
	            var currentUser = this.props.currentUser;
	            var isAdmin = false;
	            var isSystemAdmin = false;
	            var teamSettings = null;
	            var integrationsLink = null;
	
	            if (currentUser != null) {
	                isAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	                isSystemAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	
	                inviteLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.showInviteMemberModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.inviteMember',
	                            defaultMessage: 'Invite New Member'
	                        })
	                    )
	                );
	
	                if (this.props.teamType === /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__["a"].OPEN_TEAM && global.window.mm_config.EnableUserCreation === 'true') {
	                    teamLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'li',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.showGetTeamInviteLinkModal
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                id: 'navbar_dropdown.teamLink',
	                                defaultMessage: 'Get Team Invite Link'
	                            })
	                        )
	                    );
	                }
	            }
	
	            if (isAdmin) {
	                manageLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13__toggle_modal_button_jsx__["a"],
	                        { dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_12__team_members_modal_jsx__["a"] },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.manageMembers',
	                            defaultMessage: 'Manage Members'
	                        })
	                    )
	                );
	
	                adminDivider = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('li', { className: 'divider' });
	
	                teamSettings = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            'data-toggle': 'modal',
	                            'data-target': '#team_settings'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.teamSettings',
	                            defaultMessage: 'Team Settings'
	                        })
	                    )
	                );
	            }
	
	            var integrationsEnabled = window.mm_config.EnableIncomingWebhooks === 'true' || window.mm_config.EnableOutgoingWebhooks === 'true' || window.mm_config.EnableCommands === 'true';
	            if (integrationsEnabled && (isAdmin || window.EnableOnlyAdminIntegrations !== 'true')) {
	                integrationsLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_router__["Link"],
	                        { to: '/' + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getTeamNameFromUrl() + '/settings/integrations' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.integrations',
	                            defaultMessage: 'Integrations'
	                        })
	                    )
	                );
	            }
	
	            if (isSystemAdmin) {
	                sysAdminLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_router__["Link"],
	                        {
	                            to: '/admin_console'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.console',
	                            defaultMessage: 'System Console'
	                        })
	                    )
	                );
	            }
	
	            var teams = [];
	
	            if (global.window.mm_config.EnableTeamCreation === 'true') {
	                teams.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    { key: 'newTeam_li' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_router__["Link"],
	                        {
	                            key: 'newTeam_a',
	                            to: '/create_team'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.create',
	                            defaultMessage: 'Create a New Team'
	                        })
	                    )
	                ));
	            }
	
	            if (this.state.teamMembers && this.state.teamMembers.length > 1) {
	                teams.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('li', {
	                    key: 'teamDiv',
	                    className: 'divider'
	                }));
	
	                for (var index in this.state.teamMembers) {
	                    if (this.state.teamMembers.hasOwnProperty(index)) {
	                        var teamMember = this.state.teamMembers[index];
	                        var team = this.state.teams[teamMember.team_id];
	
	                        if (team.name !== this.props.teamName) {
	                            teams.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'li',
	                                { key: 'team_' + team.name },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_router__["Link"],
	                                    {
	                                        to: '/' + team.name + '/channels/town-square'
	                                    },
	                                    team.display_name
	                                )
	                            ));
	                        }
	                    }
	                }
	            }
	
	            var helpLink = null;
	            if (global.window.mm_config.HelpLink) {
	                helpLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_router__["Link"],
	                        {
	                            target: '_blank',
	                            to: global.window.mm_config.HelpLink,
	                            rel: 'noreferrer'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.help',
	                            defaultMessage: 'Help'
	                        })
	                    )
	                );
	            }
	
	            var reportLink = null;
	            if (global.window.mm_config.ReportAProblemLink) {
	                reportLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_router__["Link"],
	                        {
	                            target: '_blank',
	                            to: global.window.mm_config.ReportAProblemLink,
	                            rel: 'noreferrer'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.report',
	                            defaultMessage: 'Report a Problem'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                'ul',
	                { className: 'nav navbar-nav navbar-right' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    {
	                        ref: 'dropdown',
	                        className: 'dropdown'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            className: 'dropdown-toggle',
	                            'data-toggle': 'dropdown',
	                            role: 'button',
	                            'aria-expanded': 'false'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('span', {
	                            className: 'dropdown__icon',
	                            dangerouslySetInnerHTML: { __html: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__["a"].MENU_ICON }
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'ul',
	                        {
	                            className: 'dropdown-menu',
	                            role: 'menu'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: function onClick() {
	                                        return _this3.setState({ showUserSettingsModal: true });
	                                    }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'navbar_dropdown.accountSettings',
	                                    defaultMessage: 'Account Settings'
	                                })
	                            )
	                        ),
	                        inviteLink,
	                        teamLink,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitUserLoggedOutEvent
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'navbar_dropdown.logout',
	                                    defaultMessage: 'Logout'
	                                })
	                            )
	                        ),
	                        adminDivider,
	                        teamSettings,
	                        integrationsLink,
	                        manageLink,
	                        sysAdminLink,
	                        teams,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('li', { className: 'divider' }),
	                        helpLink,
	                        reportLink,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: this.handleAboutModal
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'navbar_dropdown.about',
	                                    defaultMessage: 'About Mattermost'
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__user_settings_user_settings_modal_jsx__["a"], {
	                            show: this.state.showUserSettingsModal,
	                            onModalDismissed: function onModalDismissed() {
	                                return _this3.setState({ showUserSettingsModal: false });
	                            }
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__about_build_modal_jsx__["a"], {
	                            show: this.state.showAboutModal,
	                            onModalDismissed: this.aboutModalDismissed
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NavbarDropdown;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = NavbarDropdown;
	
	
	NavbarDropdown.defaultProps = {
	    teamType: ''
	};
	NavbarDropdown.propTypes = {
	    teamType: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    teamDisplayName: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    teamName: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.object
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __WEBPACK_IMPORTED_MODULE_7_react_router__ && __WEBPACK_IMPORTED_MODULE_7_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_error_bar_jsx__ = __webpack_require__(187);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_sidebar_right_jsx__ = __webpack_require__(749);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_sidebar_right_menu_jsx__ = __webpack_require__(750);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_navbar_jsx__ = __webpack_require__(714);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_get_post_link_modal_jsx__ = __webpack_require__(703);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_get_public_link_modal_jsx__ = __webpack_require__(704);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_get_team_invite_link_modal_jsx__ = __webpack_require__(705);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_edit_post_modal_jsx__ = __webpack_require__(699);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_delete_post_modal_jsx__ = __webpack_require__(697);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_more_channels_jsx__ = __webpack_require__(712);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_team_settings_modal_jsx__ = __webpack_require__(763);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_removed_from_channel_modal_jsx__ = __webpack_require__(734);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_register_app_modal_jsx__ = __webpack_require__(733);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_user_settings_import_theme_modal_jsx__ = __webpack_require__(771);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_invite_member_modal_jsx__ = __webpack_require__(707);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_admin_console_select_team_modal_jsx__ = __webpack_require__(346);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var TutorialSteps = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__["a"].TutorialSteps;
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_constants_jsx__["a"].Preferences;
	
	
	
	
	
	
	// Modals
	
	
	
	
	
	
	
	
	
	
	
	
	
	var NeedsTeam = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NeedsTeam, _React$Component);
	
	    function NeedsTeam(params) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NeedsTeam);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NeedsTeam).call(this, params));
	
	        _this.onChanged = _this.onChanged.bind(_this);
	
	        _this.state = {
	            team: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].getCurrent()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NeedsTeam, [{
	        key: 'onChanged',
	        value: function onChanged() {
	            this.setState({
	                team: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].getCurrent()
	            });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Go to tutorial if we are first arriving
	            var tutorialStep = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentId(), 999);
	            if (tutorialStep <= TutorialSteps.INTRO_SCREENS) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/tutorial');
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].addChangeListener(this.onChanged);
	
	            // Emit view action
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_action_creators_global_actions_jsx__.viewLoggedIn();
	
	            // Set up tracking for whether the window is active
	            window.isActive = true;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(window).on('focus', function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.updateLastViewedAt();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_channel_store_jsx__["a"].resetCounts(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_channel_store_jsx__["a"].getCurrentId());
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_channel_store_jsx__["a"].emitChange();
	                window.isActive = true;
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(window).on('blur', function () {
	                window.isActive = false;
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].removeChangeListener(this.onChanged);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(window).off('focus');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(window).off('blur');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = [];
	            if (this.props.children) {
	                content = this.props.children;
	            } else {
	                content.push(this.props.navbar);
	                content.push(this.props.sidebar);
	                content.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'inner-wrap',
	                        className: 'inner-wrap channel__wrap'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'row header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                            'div',
	                            { id: 'navbar' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_components_navbar_jsx__["a"], null)
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                        'div',
	                        { className: 'row main' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(this.props.center, {
	                            user: this.props.user,
	                            team: this.state.team
	                        })
	                    )
	                ));
	            }
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'channel-view' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_components_error_bar_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                    'div',
	                    { className: 'container-fluid' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_components_sidebar_right_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_components_sidebar_right_menu_jsx__["a"], null),
	                    content,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_20_components_get_post_link_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_21_components_get_public_link_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_22_components_get_team_invite_link_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_30_components_invite_member_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_29_components_user_settings_import_theme_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_26_components_team_settings_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_components_more_channels_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_23_components_edit_post_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_components_delete_post_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_27_components_removed_from_channel_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_components_register_app_modal_jsx__["a"], null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_31_components_admin_console_select_team_modal_jsx__["a"], null)
	                )
	            );
	        }
	    }]);
	
	    return NeedsTeam;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = NeedsTeam;
	
	
	NeedsTeam.propTypes = {
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.oneOfType([/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element), /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element]),
	    navbar: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element,
	    sidebar: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element,
	    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.element,
	    params: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object
	};

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["defineMessages"].bind()({
	    nameEx: {
	        id: 'channel_modal.nameEx',
	        defaultMessage: 'E.g.: "Bugs", "Marketing", "客户支持"'
	    }
	});
	
	
	
	var NewChannelModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NewChannelModal, _React$Component);
	
	    function NewChannelModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NewChannelModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NewChannelModal).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        _this.state = {
	            displayNameError: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NewChannelModal, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.show === true && this.props.show === false) {
	                this.setState({
	                    displayNameError: ''
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.isBrowserIE()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').addClass('browser--ie');
	            }
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            e.preventDefault();
	
	            var displayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.display_name).value.trim();
	            if (displayName.length < 1) {
	                this.setState({ displayNameError: true });
	                return;
	            }
	
	            this.props.onSubmitChannel();
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange() {
	            var newData = {
	                displayName: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.display_name).value,
	                purpose: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.channel_purpose).value
	            };
	            this.props.onDataChanged(newData);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var displayNameError = null;
	            var serverError = null;
	            var displayNameClass = 'form-group';
	
	            if (this.state.displayNameError) {
	                displayNameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'p',
	                    { className: 'input__help error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'channel_modal.displayNameError',
	                        defaultMessage: 'This field is required'
	                    }),
	                    this.state.displayNameError
	                );
	                displayNameClass += ' has-error';
	            }
	
	            if (this.props.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'p',
	                        { className: 'input__help error' },
	                        this.props.serverError
	                    )
	                );
	            }
	
	            var channelTerm = '';
	            var channelSwitchText = '';
	            switch (this.props.channelType) {
	                case 'P':
	                    channelTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'channel_modal.group',
	                        defaultMessage: 'Group'
	                    });
	                    channelSwitchText = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'modal-intro' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'channel_modal.privateGroup1',
	                            defaultMessage: 'Create a new private group with restricted membership. '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                onClick: this.props.onTypeSwitched
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'channel_modal.publicChannel1',
	                                defaultMessage: 'Create a public channel'
	                            })
	                        )
	                    );
	                    break;
	                case 'O':
	                    channelTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'channel_modal.channel',
	                        defaultMessage: 'Channel'
	                    });
	                    channelSwitchText = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'modal-intro' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'channel_modal.publicChannel2',
	                            defaultMessage: 'Create a new public channel anyone can join. '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                onClick: this.props.onTypeSwitched
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'channel_modal.privateGroup2',
	                                defaultMessage: 'Create a private group'
	                            })
	                        )
	                    );
	                    break;
	            }
	
	            var prettyTeamURL = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.getShortenedTeamURL();
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'span',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"],
	                    {
	                        show: this.props.show,
	                        bsSize: 'large',
	                        onHide: this.props.onModalDismissed
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Header,
	                        { closeButton: true },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Title,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'channel_modal.modalTitle',
	                                defaultMessage: 'New '
	                            }),
	                            channelTerm
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'form',
	                        {
	                            role: 'form',
	                            className: 'form-horizontal'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Body,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                null,
	                                channelSwitchText
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: displayNameClass },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'label',
	                                    { className: 'col-sm-3 form__label control-label' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                        id: 'channel_modal.name',
	                                        defaultMessage: 'Name'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'div',
	                                    { className: 'col-sm-9' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                        onChange: this.handleChange,
	                                        type: 'text',
	                                        ref: 'display_name',
	                                        className: 'form-control',
	                                        placeholder: this.props.intl.formatMessage(holders.nameEx),
	                                        maxLength: '22',
	                                        value: this.props.channelData.displayName,
	                                        autoFocus: true,
	                                        tabIndex: '1'
	                                    }),
	                                    displayNameError,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'p',
	                                        { className: 'input__help dark' },
	                                        'URL: ' + prettyTeamURL + this.props.channelData.name + ' (',
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                            'a',
	                                            {
	                                                href: '#',
	                                                onClick: this.props.onChangeURLPressed
	                                            },
	                                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                                id: 'channel_modal.edit',
	                                                defaultMessage: 'Edit'
	                                            })
	                                        ),
	                                        ')'
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'form-group less' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'div',
	                                    { className: 'col-sm-3' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'label',
	                                        { className: 'form__label control-label' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                            id: 'channel_modal.purpose',
	                                            defaultMessage: 'Purpose'
	                                        })
	                                    ),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'label',
	                                        { className: 'form__label light' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                            id: 'channel_modal.optional',
	                                            defaultMessage: '(optional)'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'div',
	                                    { className: 'col-sm-9' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('textarea', {
	                                        className: 'form-control no-resize',
	                                        ref: 'channel_purpose',
	                                        rows: '4',
	                                        placeholder: this.props.intl.formatMessage({ id: 'channel_modal.purpose' }),
	                                        maxLength: '128',
	                                        value: this.props.channelData.purpose,
	                                        onChange: this.handleChange,
	                                        tabIndex: '2'
	                                    }),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'p',
	                                        { className: 'input__help' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                            id: 'channel_modal.descriptionHelp',
	                                            defaultMessage: 'Describe how this {term} should be used.',
	                                            values: {
	                                                term: channelTerm
	                                            }
	                                        })
	                                    ),
	                                    serverError
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["Modal"].Footer,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-default',
	                                    onClick: this.props.onModalDismissed
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                    id: 'channel_modal.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    onClick: this.handleSubmit,
	                                    type: 'submit',
	                                    className: 'btn btn-primary',
	                                    tabIndex: '3'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                    id: 'channel_modal.createNew',
	                                    defaultMessage: 'Create New '
	                                }),
	                                channelTerm
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewChannelModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	NewChannelModal.defaultProps = {
	    show: false,
	    channelType: 'O',
	    serverError: ''
	};
	NewChannelModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.bool.isRequired,
	    channelType: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string.isRequired,
	    channelData: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired,
	    serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string,
	    onSubmitChannel: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired,
	    onTypeSwitched: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired,
	    onChangeURLPressed: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired,
	    onDataChanged: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"].bind()(NewChannelModal);

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	function getCountsStateFromStores() {
	    var count = 0;
	    var channels = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getAll();
	    var members = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getAllMembers();
	
	    channels.forEach(function (channel) {
	        var channelMember = members[channel.id];
	        if (channelMember == null) {
	            return;
	        }
	
	        if (channel.type === 'D') {
	            count += channel.total_msg_count - channelMember.msg_count;
	        } else if (channelMember.mention_count > 0) {
	            count += channelMember.mention_count;
	        } else if (channelMember.notify_props.mark_unread !== 'mention' && channel.total_msg_count - channelMember.msg_count > 0) {
	            count += 1;
	        }
	    });
	
	    return { count: count };
	}
	
	
	
	var NotifyCounts = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NotifyCounts, _React$Component);
	
	    function NotifyCounts(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NotifyCounts);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NotifyCounts).call(this, props));
	
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	
	        _this.state = getCountsStateFromStores();
	        _this.mounted = false;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NotifyCounts, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.mounted = true;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].addChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.mounted = false;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            if (this.mounted) {
	                var newState = getCountsStateFromStores();
	                if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.areObjectsEqual(newState, this.state)) {
	                    this.setState(newState);
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.count) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'span',
	                    { className: 'badge badge-notify' },
	                    this.state.count
	                );
	            }
	            return null;
	        }
	    }]);
	
	    return NotifyCounts;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = NotifyCounts;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router___default = __WEBPACK_IMPORTED_MODULE_10_react_router__ && __WEBPACK_IMPORTED_MODULE_10_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var PasswordResetForm = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PasswordResetForm, _React$Component);
	
	    function PasswordResetForm(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PasswordResetForm);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PasswordResetForm).call(this, props));
	
	        _this.handlePasswordReset = _this.handlePasswordReset.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PasswordResetForm, [{
	        key: 'handlePasswordReset',
	        value: function handlePasswordReset(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var password = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.password).value.trim();
	            if (!password || password.length < /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH) {
	                this.setState({
	                    error: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'password_form.error',
	                        defaultMessage: 'Please enter at least {chars} characters.',
	                        chars: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH
	                    })
	                });
	                return;
	            }
	
	            this.setState({
	                error: null
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].resetPassword(this.props.location.query.code, password, function () {
	                _this2.setState({ error: null });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_router__["browserHistory"].push('/login?extra=' + /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].PASSWORD_CHANGE);
	            }, function (err) {
	                _this2.setState({ error: err.message });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var formClass = 'form-group';
	            if (error) {
	                formClass += ' has-error';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-team__container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'h3',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'password_form.title',
	                            defaultMessage: 'Password Reset'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'form',
	                        { onSubmit: this.handlePasswordReset },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'p',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'password_form.enter',
	                                defaultMessage: 'Enter a new password for your {siteName} account.',
	                                values: {
	                                    siteName: global.window.mm_config.SiteName
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: formClass },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
	                                type: 'password',
	                                className: 'form-control',
	                                name: 'password',
	                                ref: 'password',
	                                placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.localizeMessage('password_form.pwd', 'Password'),
	                                spellCheck: 'false'
	                            })
	                        ),
	                        error,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'submit',
	                                className: 'btn btn-primary'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'password_form.change',
	                                defaultMessage: 'Change my password'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PasswordResetForm;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	PasswordResetForm.defaultProps = {};
	PasswordResetForm.propTypes = {
	    params: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object.isRequired,
	    location: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.PropTypes.object.isRequired
	};
	
	/* harmony default export */ exports["a"] = PasswordResetForm;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router___default = __WEBPACK_IMPORTED_MODULE_11_react_router__ && __WEBPACK_IMPORTED_MODULE_11_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var PasswordResetSendLink = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PasswordResetSendLink, _React$Component);
	
	    function PasswordResetSendLink(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PasswordResetSendLink);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PasswordResetSendLink).call(this, props));
	
	        _this.handleSendLink = _this.handleSendLink.bind(_this);
	
	        _this.state = {
	            error: '',
	            updateText: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PasswordResetSendLink, [{
	        key: 'handleSendLink',
	        value: function handleSendLink(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var email = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.email).value.trim().toLowerCase();
	            if (!email || !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.isEmail(email)) {
	                this.setState({
	                    error: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'password_send.error',
	                        defaultMessage: 'Please enter a valid email address.'
	                    })
	                });
	                return;
	            }
	
	            // End of error checking clear error
	            this.setState({
	                error: ''
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].sendPasswordReset(email, function () {
	                _this2.setState({
	                    error: null,
	                    updateText: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'reset-form alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedHTMLMessage"], {
	                            id: 'password_send.link',
	                            defaultMessage: '<p>A password reset link has been sent to <b>{email}</b></p>',
	                            values: {
	                                email: email
	                            }
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'password_send.checkInbox',
	                            defaultMessage: 'Please check your inbox.'
	                        })
	                    )
	                });
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this2.refs.reset_form)).hide();
	            }, function (err) {
	                _this2.setState({
	                    error: err.message,
	                    update_text: null
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var error = null;
	            if (this.state.error) {
	                error = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.error
	                    )
	                );
	            }
	
	            var formClass = 'form-group';
	            if (error) {
	                formClass += ' has-error';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_router__["Link"],
	                        { to: '/' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'web.header.back'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'h3',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'password_send.title',
	                                defaultMessage: 'Password Reset'
	                            })
	                        ),
	                        this.state.updateText,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'form',
	                            {
	                                onSubmit: this.handleSendLink,
	                                ref: 'reset_form'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'p',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'password_send.description',
	                                    defaultMessage: 'To reset your password, enter the email address you used to sign up'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: formClass },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    type: 'email',
	                                    className: 'form-control',
	                                    name: 'email',
	                                    ref: 'email',
	                                    placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.localizeMessage('password_send.email', 'Email'),
	                                    spellCheck: 'false'
	                                })
	                            ),
	                            error,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: 'btn btn-primary'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'password_send.reset',
	                                    defaultMessage: 'Reset my password'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PasswordResetSendLink;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	PasswordResetSendLink.defaultProps = {};
	PasswordResetSendLink.propTypes = {
	    params: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired
	};
	
	/* harmony default export */ exports["a"] = PasswordResetSendLink;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_channel_header_jsx__ = __webpack_require__(352);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_post_focus_view_jsx__ = __webpack_require__(728);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router___default = __WEBPACK_IMPORTED_MODULE_11_react_router__ && __WEBPACK_IMPORTED_MODULE_11_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var PermalinkView = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PermalinkView, _React$Component);
	
	    function PermalinkView(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PermalinkView);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PermalinkView).call(this, props));
	
	        _this.getStateFromStores = _this.getStateFromStores.bind(_this);
	        _this.isStateValid = _this.isStateValid.bind(_this);
	        _this.updateState = _this.updateState.bind(_this);
	
	        _this.state = _this.getStateFromStores(props);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PermalinkView, [{
	        key: 'getStateFromStores',
	        value: function getStateFromStores(props) {
	            var postId = props.params.postid;
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrent();
	            var channelId = channel ? channel.id : '';
	            var channelName = channel ? channel.name : '';
	            var team = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].getCurrent();
	            var teamName = team ? team.name : '';
	            return {
	                channelId: channelId,
	                channelName: channelName,
	                teamName: teamName,
	                postId: postId
	            };
	        }
	    }, {
	        key: 'isStateValid',
	        value: function isStateValid() {
	            return this.state.channelId !== '' && this.state.teamName;
	        }
	    }, {
	        key: 'updateState',
	        value: function updateState() {
	            this.setState(this.getStateFromStores(this.props));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addChangeListener(this.updateState);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].addChangeListener(this.updateState);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').addClass('app__body');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeChangeListener(this.updateState);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].removeChangeListener(this.updateState);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('body').removeClass('app__body');
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState(this.getStateFromStores(nextProps));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.isStateValid()) {
	                return null;
	            }
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                {
	                    id: 'app-content',
	                    className: 'app__content'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_components_channel_header_jsx__["a"], {
	                    channelId: this.state.channelId
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_components_post_focus_view_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    {
	                        id: 'archive-link-home'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_router__["Link"],
	                        {
	                            to: '/' + this.state.teamName + '/channels/' + this.state.channelName
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'center_panel.recent',
	                            defaultMessage: 'Click here to jump to recent messages. '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('i', { className: 'fa fa-arrow-down' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PermalinkView;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PermalinkView;
	
	
	PermalinkView.propTypes = {
	    params: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router___default = __WEBPACK_IMPORTED_MODULE_12_react_router__ && __WEBPACK_IMPORTED_MODULE_12_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var PopoverListMembers = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PopoverListMembers, _React$Component);
	
	    function PopoverListMembers(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PopoverListMembers);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PopoverListMembers).call(this, props));
	
	        _this.handleShowDirectChannel = _this.handleShowDirectChannel.bind(_this);
	        _this.closePopover = _this.closePopover.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PopoverListMembers, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.member-list__popover .popover-content').perfectScrollbar();
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ showPopover: false });
	        }
	    }, {
	        key: 'handleShowDirectChannel',
	        value: function handleShowDirectChannel(teammate, e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.openDirectChannelToUser(teammate, function (channel, channelAlreadyExisted) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/channels/' + channel.name);
	                if (channelAlreadyExisted) {
	                    _this2.closePopover();
	                }
	            }, function () {
	                _this2.closePopover();
	            });
	        }
	    }, {
	        key: 'closePopover',
	        value: function closePopover() {
	            this.setState({ showPopover: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var popoverHtml = [];
	            var members = this.props.members;
	            var teamMembers = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].getProfilesUsernameMap();
	            var currentUserId = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].getCurrentId();
	
	            if (members && teamMembers) {
	                members.sort(function (a, b) {
	                    var aName = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.displayUsername(a.id);
	                    var bName = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.displayUsername(b.id);
	
	                    return aName.localeCompare(bName);
	                });
	
	                members.forEach(function (m, i) {
	                    var button = '';
	                    if (currentUserId !== m.id && _this3.props.channel.type !== 'D') {
	                        button = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                className: 'btn-message',
	                                onClick: function onClick(e) {
	                                    return _this3.handleShowDirectChannel(m, e);
	                                }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'members_popover.msg',
	                                defaultMessage: 'Message'
	                            })
	                        );
	                    }
	
	                    var name = '';
	                    if (teamMembers[m.username]) {
	                        name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.displayUsername(teamMembers[m.username].id);
	                    }
	
	                    if (name) {
	                        popoverHtml.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'more-modal__row',
	                                key: 'popover-member-' + i
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
	                                className: 'more-modal__image',
	                                width: '26px',
	                                height: '26px',
	                                src: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].getUsersRoute() + '/' + m.id + '/image?time=' + m.update_at
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                { className: 'more-modal__details' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'div',
	                                    {
	                                        className: 'more-modal__name'
	                                    },
	                                    name
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                {
	                                    className: 'more-modal__actions'
	                                },
	                                button
	                            )
	                        ));
	                    }
	                });
	            }
	
	            var count = this.props.memberCount;
	            var countText = '-';
	
	            // fall back to checking the length of the member list if the count isn't set
	            if (!count && members) {
	                count = members.length;
	            }
	
	            if (count > /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].MAX_CHANNEL_POPOVER_COUNT) {
	                countText = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].MAX_CHANNEL_POPOVER_COUNT + '+';
	            } else if (count > 0) {
	                countText = count.toString();
	            }
	
	            var title = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                id: 'members_popover.title',
	                defaultMessage: 'Members'
	            });
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    {
	                        id: 'member_popover',
	                        ref: 'member_popover_target',
	                        onClick: function onClick(e) {
	                            return _this3.setState({ popoverTarget: e.target, showPopover: !_this3.state.showPopover });
	                        }
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        null,
	                        countText,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', {
	                            className: 'fa fa-user',
	                            'aria-hidden': 'true'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Overlay"],
	                    {
	                        rootClose: true,
	                        onHide: this.closePopover,
	                        show: this.state.showPopover,
	                        target: function target() {
	                            return _this3.state.popoverTarget;
	                        },
	                        placement: 'bottom'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Popover"],
	                        {
	                            ref: 'memebersPopover',
	                            title: title,
	                            className: 'member-list__popover',
	                            id: 'member-list-popover'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'more-modal__list' },
	                            popoverHtml
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PopoverListMembers;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PopoverListMembers;
	
	
	PopoverListMembers.propTypes = {
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired,
	    members: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.array.isRequired,
	    memberCount: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.number
	};

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__post_header_jsx__ = __webpack_require__(729);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__post_body_jsx__ = __webpack_require__(727);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	
	var Post = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Post, _React$Component);
	
	    function Post(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Post);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Post).call(this, props));
	
	        _this.handleCommentClick = _this.handleCommentClick.bind(_this);
	        _this.forceUpdateInfo = _this.forceUpdateInfo.bind(_this);
	        _this.retryPost = _this.retryPost.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Post, [{
	        key: 'handleCommentClick',
	        value: function handleCommentClick(e) {
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_POST_SELECTED,
	                postId: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getRootId(this.props.post)
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH,
	                results: null
	            });
	        }
	    }, {
	        key: 'forceUpdateInfo',
	        value: function forceUpdateInfo() {
	            this.refs.info.forceUpdate();
	            this.refs.header.forceUpdate();
	        }
	    }, {
	        key: 'retryPost',
	        value: function retryPost(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var post = this.props.post;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].createPost(post, function (data) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getPosts();
	
	                var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].get(post.channel_id);
	                var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].getMember(post.channel_id);
	                member.msg_count = channel.total_msg_count;
	                member.last_viewed_at = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getTimestamp();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].setChannelMember(member);
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_POST,
	                    post: data
	                });
	            }, function () {
	                post.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_FAILED;
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_post_store_jsx__["a"].updatePendingPost(post);
	                _this2.forceUpdate();
	            });
	
	            post.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].POST_LOADING;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_post_store_jsx__["a"].updatePendingPost(post);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(nextProps.post, this.props.post)) {
	                return true;
	            }
	
	            if (nextProps.sameRoot !== this.props.sameRoot) {
	                return true;
	            }
	
	            if (nextProps.sameUser !== this.props.sameUser) {
	                return true;
	            }
	
	            if (nextProps.displayNameType !== this.props.displayNameType) {
	                return true;
	            }
	
	            if (this.getCommentCount(nextProps) !== this.getCommentCount(this.props)) {
	                return true;
	            }
	
	            if (nextProps.shouldHighlight !== this.props.shouldHighlight) {
	                return true;
	            }
	
	            if (nextProps.center !== this.props.center) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(nextProps.user, this.props.user)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'getCommentCount',
	        value: function getCommentCount(props) {
	            var post = props.post;
	            var parentPost = props.parentPost;
	            var posts = props.posts;
	
	            var commentCount = 0;
	            var commentRootId = void 0;
	            if (parentPost) {
	                commentRootId = post.root_id;
	            } else {
	                commentRootId = post.id;
	            }
	            for (var postId in posts) {
	                if (posts[postId].root_id === commentRootId) {
	                    commentCount += 1;
	                }
	            }
	
	            return commentCount;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	            var parentPost = this.props.parentPost;
	            var posts = this.props.posts;
	            var mattermostLogo = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].MATTERMOST_ICON_SVG;
	
	            if (!post.props) {
	                post.props = {};
	            }
	
	            var type = 'Post';
	            if (post.root_id && post.root_id.length > 0) {
	                type = 'Comment';
	            }
	
	            var commentCount = this.getCommentCount(this.props);
	
	            var rootUser = void 0;
	            if (this.props.sameRoot) {
	                rootUser = 'same--root';
	            } else {
	                rootUser = 'other--root';
	            }
	
	            var postType = '';
	            if (type !== 'Post') {
	                postType = 'post--comment';
	            } else if (commentCount > 0) {
	                postType = 'post--root';
	            }
	
	            var currentUserCss = '';
	            if (this.props.currentUser.id === post.user_id && !post.props.from_webhook && !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.isSystemMessage(post)) {
	                currentUserCss = 'current--user';
	            }
	
	            var timestamp = 0;
	            if (!this.props.user || this.props.user.update_at == null) {
	                timestamp = this.props.currentUser.update_at;
	            } else {
	                timestamp = this.props.user.update_at;
	            }
	
	            var sameUserClass = '';
	            if (this.props.sameUser) {
	                sameUserClass = 'same--user';
	            }
	
	            var shouldHighlightClass = '';
	            if (this.props.shouldHighlight) {
	                shouldHighlightClass = 'post--highlight';
	            }
	
	            var systemMessageClass = '';
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.isSystemMessage(post)) {
	                systemMessageClass = 'post--system';
	            }
	
	            var profilePic = null;
	            if (!this.props.hideProfilePic) {
	                profilePic = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('img', {
	                    src: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.getProfilePicSrcForPost(post, timestamp),
	                    height: '36',
	                    width: '36'
	                });
	
	                if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.isSystemMessage(post)) {
	                    profilePic = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('span', {
	                        className: 'icon',
	                        dangerouslySetInnerHTML: { __html: mattermostLogo }
	                    });
	                }
	            }
	
	            var centerClass = '';
	            if (this.props.center) {
	                centerClass = 'center';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    {
	                        id: 'post_' + post.id,
	                        className: 'post ' + sameUserClass + ' ' + rootUser + ' ' + postType + ' ' + currentUserCss + ' ' + shouldHighlightClass + ' ' + systemMessageClass
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'post__content ' + centerClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'post__img' },
	                            profilePic
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__post_header_jsx__["a"], {
	                                ref: 'header',
	                                post: post,
	                                sameRoot: this.props.sameRoot,
	                                commentCount: commentCount,
	                                handleCommentClick: this.handleCommentClick,
	                                isLastComment: this.props.isLastComment,
	                                sameUser: this.props.sameUser,
	                                user: this.props.user,
	                                currentUser: this.props.currentUser
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__post_body_jsx__["a"], {
	                                post: post,
	                                sameRoot: this.props.sameRoot,
	                                parentPost: parentPost,
	                                posts: posts,
	                                handleCommentClick: this.handleCommentClick,
	                                retryPost: this.retryPost
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Post;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Post;
	
	
	Post.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object.isRequired,
	    posts: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    parentPost: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    sameUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    sameRoot: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    hideProfilePic: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    isLastComment: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    shouldHighlight: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    displayNameType: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.string,
	    hasProfiles: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object.isRequired,
	    center: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool
	};

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["defineMessages"].bind()({
	    collapse: {
	        id: 'post_attachment.collapse',
	        defaultMessage: '▲ collapse text'
	    },
	    more: {
	        id: 'post_attachment.more',
	        defaultMessage: '▼ read more'
	    }
	});
	
	
	
	var PostAttachment = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostAttachment, _React$Component);
	
	    function PostAttachment(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostAttachment);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostAttachment).call(this, props));
	
	        _this.getFieldsTable = _this.getFieldsTable.bind(_this);
	        _this.getInitState = _this.getInitState.bind(_this);
	        _this.shouldCollapse = _this.shouldCollapse.bind(_this);
	        _this.toggleCollapseState = _this.toggleCollapseState.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostAttachment, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this.refs.attachment).on('click', '.attachment-link-more', this.toggleCollapseState);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this.refs.attachment).off('click', '.attachment-link-more', this.toggleCollapseState);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState(this.getInitState());
	        }
	    }, {
	        key: 'getInitState',
	        value: function getInitState() {
	            var shouldCollapse = this.shouldCollapse();
	            var text = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_text_formatting_jsx__.formatText(this.props.attachment.text || '');
	            var uncollapsedText = text + (shouldCollapse ? '<a class="attachment-link-more" href="#">' + this.props.intl.formatMessage(holders.collapse) + '</a>' : '');
	            var collapsedText = shouldCollapse ? this.getCollapsedText() : text;
	
	            return {
	                shouldCollapse: shouldCollapse,
	                collapsedText: collapsedText,
	                uncollapsedText: uncollapsedText,
	                text: shouldCollapse ? collapsedText : uncollapsedText,
	                collapsed: shouldCollapse
	            };
	        }
	    }, {
	        key: 'toggleCollapseState',
	        value: function toggleCollapseState(e) {
	            e.preventDefault();
	
	            var state = this.state;
	            state.text = state.collapsed ? state.uncollapsedText : state.collapsedText;
	            state.collapsed = !state.collapsed;
	            this.setState(state);
	        }
	    }, {
	        key: 'shouldCollapse',
	        value: function shouldCollapse() {
	            var text = this.props.attachment.text || '';
	            return (text.match(/\n/g) || []).length >= 5 || text.length > 700;
	        }
	    }, {
	        key: 'getCollapsedText',
	        value: function getCollapsedText() {
	            var text = this.props.attachment.text || '';
	            if ((text.match(/\n/g) || []).length >= 5) {
	                text = text.split('\n').splice(0, 5).join('\n');
	            } else if (text.length > 700) {
	                text = text.substr(0, 700);
	            }
	
	            return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_text_formatting_jsx__.formatText(text) + ('<a class="attachment-link-more" href="#">' + this.props.intl.formatMessage(holders.more) + '</a>');
	        }
	    }, {
	        key: 'getFieldsTable',
	        value: function getFieldsTable() {
	            var fields = this.props.attachment.fields;
	            if (!fields || !fields.length) {
	                return '';
	            }
	
	            var fieldTables = [];
	
	            var headerCols = [];
	            var bodyCols = [];
	            var rowPos = 0;
	            var lastWasLong = false;
	            var nrTables = 0;
	
	            fields.forEach(function (field, i) {
	                if (rowPos === 2 || !(field.short === true) || lastWasLong) {
	                    fieldTables.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'table',
	                        {
	                            className: 'attachment___fields',
	                            key: 'attachment__table__' + nrTables
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'thead',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'tr',
	                                null,
	                                headerCols
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'tbody',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'tr',
	                                null,
	                                bodyCols
	                            )
	                        )
	                    ));
	                    headerCols = [];
	                    bodyCols = [];
	                    rowPos = 0;
	                    nrTables += 1;
	                    lastWasLong = false;
	                }
	                headerCols.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'th',
	                    {
	                        className: 'attachment___field-caption',
	                        key: 'attachment__field-caption-' + i + '__' + nrTables,
	                        width: '50%'
	                    },
	                    field.title
	                ));
	                bodyCols.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('td', {
	                    className: 'attachment___field',
	                    key: 'attachment__field-' + i + '__' + nrTables,
	                    dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_text_formatting_jsx__.formatText(field.value || '') }
	                }));
	                rowPos += 1;
	                lastWasLong = !(field.short === true);
	            });
	            if (headerCols.length > 0) {
	                // Flush last fields
	                fieldTables.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'table',
	                    {
	                        className: 'attachment___fields',
	                        key: 'attachment__table__' + nrTables
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'thead',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'tr',
	                            null,
	                            headerCols
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'tbody',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'tr',
	                            null,
	                            bodyCols
	                        )
	                    )
	                ));
	            }
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                null,
	                fieldTables
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var data = this.props.attachment;
	
	            var preText = void 0;
	            if (data.pretext) {
	                preText = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
	                    className: 'attachment__thumb-pretext',
	                    dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_text_formatting_jsx__.formatText(data.pretext) }
	                });
	            }
	
	            var author = [];
	            if (data.author_name || data.author_icon) {
	                if (data.author_icon) {
	                    author.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', {
	                        className: 'attachment__author-icon',
	                        src: data.author_icon,
	                        key: 'attachment__author-icon',
	                        height: '14',
	                        width: '14'
	                    }));
	                }
	                if (data.author_name) {
	                    author.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'span',
	                        {
	                            className: 'attachment__author-name',
	                            key: 'attachment__author-name'
	                        },
	                        data.author_name
	                    ));
	                }
	            }
	            if (data.author_link) {
	                author = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'a',
	                    {
	                        href: data.author_link,
	                        target: '_blank'
	                    },
	                    author
	                );
	            }
	
	            var title = void 0;
	            if (data.title) {
	                if (data.title_link) {
	                    title = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'h1',
	                        {
	                            className: 'attachment__title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'attachment__title-link',
	                                href: data.title_link,
	                                target: '_blank'
	                            },
	                            data.title
	                        )
	                    );
	                } else {
	                    title = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'h1',
	                        {
	                            className: 'attachment__title'
	                        },
	                        data.title
	                    );
	                }
	            }
	
	            var text = void 0;
	            if (data.text) {
	                text = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
	                    className: 'attachment__text',
	                    dangerouslySetInnerHTML: { __html: this.state.text }
	                });
	            }
	
	            var image = void 0;
	            if (data.image_url) {
	                image = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', {
	                    className: 'attachment__image',
	                    src: data.image_url
	                });
	            }
	
	            var thumb = void 0;
	            if (data.thumb_url) {
	                thumb = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'attachment__thumb-container'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', {
	                        src: data.thumb_url
	                    })
	                );
	            }
	
	            var fields = this.getFieldsTable();
	
	            var useBorderStyle = void 0;
	            if (data.color && data.color[0] === '#') {
	                useBorderStyle = { borderLeftColor: data.color };
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                {
	                    className: 'attachment',
	                    ref: 'attachment'
	                },
	                preText,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'attachment__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        {
	                            className: useBorderStyle ? 'clearfix attachment__container' : 'clearfix attachment__container attachment__container--' + data.color,
	                            style: useBorderStyle
	                        },
	                        author,
	                        title,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'div',
	                                {
	                                    className: thumb ? 'attachment__body' : 'attachment__body attachment__body--no_thumb'
	                                },
	                                text,
	                                image,
	                                fields
	                            ),
	                            thumb,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { style: { clear: 'both' } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostAttachment;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	PostAttachment.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired,
	    attachment: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"].bind()(PostAttachment);

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__post_attachment_jsx__ = __webpack_require__(724);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var PostAttachmentList = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostAttachmentList, _React$Component);
	
	    function PostAttachmentList() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostAttachmentList);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostAttachmentList).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostAttachmentList, [{
	        key: 'render',
	        value: function render() {
	            var content = [];
	            this.props.attachments.forEach(function (attachment, i) {
	                content.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__post_attachment_jsx__["a"], {
	                    attachment: attachment,
	                    key: 'att_' + i
	                }));
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                { className: 'attachment_list' },
	                content
	            );
	        }
	    }]);
	
	    return PostAttachmentList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostAttachmentList;
	
	
	PostAttachmentList.propTypes = {
	    attachments: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.array.isRequired
	};

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var PostAttachmentOEmbed = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostAttachmentOEmbed, _React$Component);
	
	    function PostAttachmentOEmbed(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostAttachmentOEmbed);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostAttachmentOEmbed).call(this, props));
	
	        _this.fetchData = _this.fetchData.bind(_this);
	
	        _this.isLoading = false;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostAttachmentOEmbed, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({ data: {} });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.link !== this.props.link) {
	                this.isLoading = false;
	                this.fetchData(nextProps.link);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.fetchData(this.props.link);
	        }
	    }, {
	        key: 'fetchData',
	        value: function fetchData(link) {
	            var _this2 = this;
	
	            if (!this.isLoading) {
	                this.isLoading = true;
	                var url = 'https://noembed.com/embed?nowrap=on';
	                url += '&url=' + encodeURIComponent(link);
	                url += '&maxheight=' + this.props.provider.height;
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
	                    url: url,
	                    dataType: 'jsonp',
	                    success: function success(result) {
	                        _this2.isLoading = false;
	                        if (result.error) {
	                            _this2.setState({ data: {} });
	                        } else {
	                            _this2.setState({ data: result });
	                        }
	                    },
	                    error: function error() {
	                        _this2.setState({ data: {} });
	                    }
	                });
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var data = {};
	            var content = void 0;
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.isEmptyObject(this.state.data)) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { style: { height: this.props.provider.height } });
	            } else {
	                data = this.state.data;
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
	                    style: { height: this.props.provider.height },
	                    dangerouslySetInnerHTML: { __html: data.html }
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                {
	                    className: 'attachment attachment--oembed',
	                    ref: 'attachment'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'attachment__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'clearfix attachment__container'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'h1',
	                            {
	                                className: 'attachment__title'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'a',
	                                {
	                                    className: 'attachment__title-link',
	                                    href: data.url,
	                                    target: '_blank'
	                                },
	                                data.title
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                                'div',
	                                {
	                                    className: 'attachment__body attachment__body--no_thumb'
	                                },
	                                content
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostAttachmentOEmbed;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostAttachmentOEmbed;
	
	
	PostAttachmentOEmbed.propTypes = {
	    link: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
	    provider: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__file_attachment_list_jsx__ = __webpack_require__(247);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__post_body_additional_content_jsx__ = __webpack_require__(365);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_12_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_12_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_images_load_gif___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var PostBody = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostBody, _React$Component);
	
	    function PostBody() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostBody);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostBody).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostBody, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.areObjectsEqual(nextProps.post, this.props.post)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.areObjectsEqual(nextProps.parentPost, this.props.parentPost)) {
	                return true;
	            }
	
	            if (nextProps.retryPost.toString() !== this.props.retryPost.toString()) {
	                return true;
	            }
	
	            if (nextProps.handleCommentClick.toString() !== this.props.handleCommentClick.toString()) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	            var filenames = this.props.post.filenames;
	            var parentPost = this.props.parentPost;
	
	            var comment = '';
	            var postClass = '';
	
	            if (parentPost) {
	                var profile = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].getProfile(parentPost.user_id);
	
	                var apostrophe = '';
	                var name = '...';
	                if (profile != null) {
	                    var username = profile.username;
	                    if (parentPost.props && parentPost.props.from_webhook && parentPost.props.override_username && global.window.mm_config.EnablePostUsernameOverride === 'true') {
	                        username = parentPost.props.override_username;
	                    }
	
	                    if (username.slice(-1) === 's') {
	                        apostrophe = '\'';
	                    } else {
	                        apostrophe = '\'s';
	                    }
	                    name = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            className: 'theme',
	                            onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.searchForTerm.bind(null, username)
	                        },
	                        username
	                    );
	                }
	
	                var _message = '';
	                if (parentPost.message) {
	                    _message = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.replaceHtmlEntities(parentPost.message);
	                } else if (parentPost.filenames.length) {
	                    _message = parentPost.filenames[0].split('/').pop();
	
	                    if (parentPost.filenames.length === 2) {
	                        _message += /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.localizeMessage('post_body.plusOne', ' plus 1 other file');
	                    } else if (parentPost.filenames.length > 2) {
	                        _message += /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.localizeMessage('post_body.plusMore', ' plus {count} other files').replace('{count}', (parentPost.filenames.length - 1).toString());
	                    }
	                }
	
	                comment = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'post__link' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'post_body.commentedOn',
	                            defaultMessage: 'Commented on {name}{apostrophe} message: ',
	                            values: {
	                                name: name,
	                                apostrophe: apostrophe
	                            }
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'theme',
	                                onClick: this.props.handleCommentClick
	                            },
	                            _message
	                        )
	                    )
	                );
	            }
	
	            var loading = void 0;
	            if (post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].POST_FAILED) {
	                postClass += ' post--fail';
	                loading = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'theme post-retry pull-right',
	                        href: '#',
	                        onClick: this.props.retryPost
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                        id: 'post_body.retry',
	                        defaultMessage: 'Retry'
	                    })
	                );
	            } else if (post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].POST_LOADING) {
	                postClass += ' post-waiting';
	                loading = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
	                    className: 'post-loading-gif pull-right',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_images_load_gif___default.a
	                });
	            }
	
	            var fileAttachmentHolder = '';
	            if (filenames && filenames.length > 0) {
	                fileAttachmentHolder = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__file_attachment_list_jsx__["a"], {
	                    filenames: filenames,
	                    channelId: post.channel_id,
	                    userId: post.user_id
	                });
	            }
	
	            var message = void 0;
	            var additionalContent = null;
	            if (this.props.post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].POST_DELETED) {
	                message = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'post_body.deleted',
	                    defaultMessage: '(message deleted)'
	                });
	            } else {
	                message = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', {
	                    onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_text_formatting_jsx__.handleClick,
	                    dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_text_formatting_jsx__.formatText(this.props.post.message) }
	                });
	
	                additionalContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__post_body_additional_content_jsx__["a"], { post: this.props.post });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                null,
	                comment,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'post__body' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        {
	                            key: post.id + '_message',
	                            id: post.id + '_message',
	                            className: postClass
	                        },
	                        loading,
	                        message
	                    ),
	                    fileAttachmentHolder,
	                    additionalContent
	                )
	            );
	        }
	    }]);
	
	    return PostBody;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostBody;
	
	
	PostBody.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired,
	    parentPost: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object,
	    retryPost: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired,
	    handleCommentClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__posts_view_jsx__ = __webpack_require__(367);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var PostFocusView = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostFocusView, _React$Component);
	
	    function PostFocusView(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostFocusView);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostFocusView).call(this, props));
	
	        _this.onChannelChange = _this.onChannelChange.bind(_this);
	        _this.onPostsChange = _this.onPostsChange.bind(_this);
	        _this.handlePostsViewScroll = _this.handlePostsViewScroll.bind(_this);
	        _this.loadMorePostsTop = _this.loadMorePostsTop.bind(_this);
	        _this.loadMorePostsBottom = _this.loadMorePostsBottom.bind(_this);
	
	        var focusedPostId = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getFocusedPostId();
	
	        _this.state = {
	            scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_5__posts_view_jsx__["a"].SCROLL_TYPE_POST,
	            currentChannel: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId().slice(),
	            scrollPostId: focusedPostId,
	            postList: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getVisiblePosts(focusedPostId),
	            atTop: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getVisibilityAtTop(focusedPostId),
	            atBottom: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getVisibilityAtBottom(focusedPostId)
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostFocusView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].addChangeListener(this.onChannelChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].addChangeListener(this.onPostsChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].removeChangeListener(this.onChannelChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].removeChangeListener(this.onPostsChange);
	        }
	    }, {
	        key: 'onChannelChange',
	        value: function onChannelChange() {
	            var currentChannel = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getCurrentId();
	            if (this.state.currentChannel !== currentChannel) {
	                this.setState({
	                    currentChannel: currentChannel.slice(),
	                    scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_5__posts_view_jsx__["a"].SCROLL_TYPE_POST
	                });
	            }
	        }
	    }, {
	        key: 'onPostsChange',
	        value: function onPostsChange() {
	            var focusedPostId = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getFocusedPostId();
	            if (focusedPostId == null) {
	                return;
	            }
	
	            this.setState({
	                scrollPostId: focusedPostId,
	                postList: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getVisiblePosts(focusedPostId),
	                atTop: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getVisibilityAtTop(focusedPostId),
	                atBottom: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_post_store_jsx__["a"].getVisibilityAtBottom(focusedPostId)
	            });
	        }
	    }, {
	        key: 'handlePostsViewScroll',
	        value: function handlePostsViewScroll() {
	            this.setState({ scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_5__posts_view_jsx__["a"].SCROLL_TYPE_FREE });
	        }
	    }, {
	        key: 'loadMorePostsTop',
	        value: function loadMorePostsTop() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitLoadMorePostsFocusedTopEvent();
	        }
	    }, {
	        key: 'loadMorePostsBottom',
	        value: function loadMorePostsBottom() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitLoadMorePostsFocusedBottomEvent();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var postsToHighlight = {};
	            postsToHighlight[this.state.scrollPostId] = true;
	
	            if (!this.state.postList) {
	                return null;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                { id: 'post-list' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__posts_view_jsx__["a"], {
	                    key: 'postfocusview',
	                    isActive: true,
	                    postList: this.state.postList,
	                    scrollType: this.state.scrollType,
	                    scrollPostId: this.state.scrollPostId,
	                    postViewScrolled: this.handlePostsViewScroll,
	                    loadMorePostsTopClicked: this.loadMorePostsTop,
	                    loadMorePostsBottomClicked: this.loadMorePostsBottom,
	                    showMoreMessagesTop: !this.state.atTop,
	                    showMoreMessagesBottom: !this.state.atBottom,
	                    messageSeparatorTime: 0,
	                    postsToHighlight: postsToHighlight
	                })
	            );
	        }
	    }]);
	
	    return PostFocusView;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostFocusView;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_profile_jsx__ = __webpack_require__(160);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__post_info_jsx__ = __webpack_require__(731);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var PostHeader = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostHeader, _React$Component);
	
	    function PostHeader(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostHeader);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostHeader).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostHeader, [{
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	
	            var userProfile = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__user_profile_jsx__["a"], { user: this.props.user });
	            var botIndicator = void 0;
	
	            if (post.props && post.props.from_webhook) {
	                if (post.props.override_username && global.window.mm_config.EnablePostUsernameOverride === 'true') {
	                    userProfile = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__user_profile_jsx__["a"], {
	                        user: this.props.user,
	                        overwriteName: post.props.override_username,
	                        disablePopover: true
	                    });
	                }
	
	                botIndicator = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'li',
	                    { className: 'col col__name bot-indicator' },
	                    'BOT'
	                );
	            } else if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_utils_utils_jsx__.isSystemMessage(post)) {
	                userProfile = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__user_profile_jsx__["a"], {
	                    user: {},
	                    overwriteName: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].SYSTEM_MESSAGE_PROFILE_NAME,
	                    overwriteImage: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].SYSTEM_MESSAGE_PROFILE_IMAGE,
	                    disablePopover: true
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'ul',
	                { className: 'post__header' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'li',
	                    { className: 'col col__name' },
	                    userProfile
	                ),
	                botIndicator,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'li',
	                    { className: 'col' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__post_info_jsx__["a"], {
	                        post: post,
	                        commentCount: this.props.commentCount,
	                        handleCommentClick: this.props.handleCommentClick,
	                        allowReply: 'true',
	                        isLastComment: this.props.isLastComment,
	                        sameUser: this.props.sameUser,
	                        currentUser: this.props.currentUser
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PostHeader;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostHeader;
	
	
	PostHeader.defaultProps = {
	    post: null,
	    commentCount: 0,
	    isLastComment: false,
	    sameUser: false
	};
	PostHeader.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object.isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object.isRequired,
	    commentCount: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.number.isRequired,
	    isLastComment: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool.isRequired,
	    handleCommentClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired,
	    sameUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	var PostImageEmbed = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostImageEmbed, _React$Component);
	
	    function PostImageEmbed(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostImageEmbed);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostImageEmbed).call(this, props));
	
	        _this.handleLoadComplete = _this.handleLoadComplete.bind(_this);
	        _this.handleLoadError = _this.handleLoadError.bind(_this);
	
	        _this.state = {
	            loaded: false,
	            errored: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostImageEmbed, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.loadImg(this.props.link);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.link !== this.props.link) {
	                this.setState({
	                    loaded: false,
	                    errored: false
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!this.state.loaded && prevProps.link !== this.props.link) {
	                this.loadImg(this.props.link);
	            }
	        }
	    }, {
	        key: 'loadImg',
	        value: function loadImg(src) {
	            var img = new Image();
	            img.onload = this.handleLoadComplete;
	            img.onerror = this.handleLoadError;
	            img.src = src;
	        }
	    }, {
	        key: 'handleLoadComplete',
	        value: function handleLoadComplete() {
	            this.setState({
	                loaded: true
	            });
	        }
	    }, {
	        key: 'handleLoadError',
	        value: function handleLoadError() {
	            this.setState({
	                errored: true,
	                loaded: true
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.errored) {
	                return null;
	            }
	
	            if (!this.state.loaded) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
	                    className: 'img-div placeholder',
	                    height: '500px'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
	                className: 'img-div',
	                src: this.props.link
	            });
	        }
	    }]);
	
	    return PostImageEmbed;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostImageEmbed;
	
	
	PostImageEmbed.propTypes = {
	    link: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string.isRequired
	};

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__time_since_jsx__ = __webpack_require__(764);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var PostInfo = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PostInfo, _React$Component);
	
	    function PostInfo(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostInfo);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostInfo).call(this, props));
	
	        _this.dropdownPosition = _this.dropdownPosition.bind(_this);
	        _this.handlePermalink = _this.handlePermalink.bind(_this);
	        _this.removePost = _this.removePost.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PostInfo, [{
	        key: 'dropdownPosition',
	        value: function dropdownPosition(e) {
	            var position = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#post-list').height() - /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).offset().top;
	            var dropdown = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).closest('.col__reply').find('.dropdown-menu');
	            if (position < dropdown.height()) {
	                dropdown.addClass('bottom');
	            }
	        }
	    }, {
	        key: 'createDropdown',
	        value: function createDropdown() {
	            var post = this.props.post;
	            var isOwner = this.props.currentUser.id === post.user_id;
	            var isAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	
	            if (post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].POST_FAILED || post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].POST_LOADING || /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isPostEphemeral(post)) {
	                return '';
	            }
	
	            var type = 'Post';
	            if (post.root_id && post.root_id.length > 0) {
	                type = 'Comment';
	            }
	
	            var dropdownContents = [];
	            var dataComments = 0;
	            if (type === 'Post') {
	                dataComments = this.props.commentCount;
	            }
	
	            if (this.props.allowReply === 'true') {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'replyLink',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            className: 'link__reply theme',
	                            href: '#',
	                            onClick: this.props.handleCommentClick
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'post_info.reply',
	                            defaultMessage: 'Reply'
	                        })
	                    )
	                ));
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isMobile()) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'copyLink',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handlePermalink
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'post_info.permalink',
	                            defaultMessage: 'Permalink'
	                        })
	                    )
	                ));
	            }
	
	            if (isOwner || isAdmin) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'deletePost',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            role: 'menuitem',
	                            onClick: function onClick() {
	                                return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.showDeletePostModal(post, dataComments);
	                            }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'post_info.del',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                ));
	            }
	
	            if (isOwner) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'editPost',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            role: 'menuitem',
	                            'data-toggle': 'modal',
	                            'data-target': '#edit_post',
	                            'data-refocusid': '#post_textbox',
	                            'data-title': type,
	                            'data-message': post.message,
	                            'data-postid': post.id,
	                            'data-channelid': post.channel_id,
	                            'data-comments': dataComments
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'post_info.edit',
	                            defaultMessage: 'Edit'
	                        })
	                    )
	                ));
	            }
	
	            if (dropdownContents.length === 0) {
	                return '';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('a', {
	                    href: '#',
	                    className: 'dropdown-toggle post__dropdown theme',
	                    type: 'button',
	                    'data-toggle': 'dropdown',
	                    'aria-expanded': 'false',
	                    onClick: this.dropdownPosition
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'ul',
	                    {
	                        className: 'dropdown-menu',
	                        role: 'menu'
	                    },
	                    dropdownContents
	                )
	            );
	        }
	    }, {
	        key: 'handlePermalink',
	        value: function handlePermalink(e) {
	            e.preventDefault();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.showGetPostLinkModal(this.props.post);
	        }
	    }, {
	        key: 'removePost',
	        value: function removePost() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitRemovePost(this.props.post);
	        }
	    }, {
	        key: 'createRemovePostButton',
	        value: function createRemovePostButton(post) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isPostEphemeral(post)) {
	                return null;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'a',
	                {
	                    href: '#',
	                    className: 'post__remove theme',
	                    type: 'button',
	                    onClick: this.removePost
	                },
	                '×'
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	            var comments = '';
	            var showCommentClass = '';
	            var commentCountText = this.props.commentCount;
	
	            if (this.props.commentCount >= 1) {
	                showCommentClass = ' icon--show';
	            } else {
	                commentCountText = '';
	            }
	
	            if (post.state !== /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].POST_FAILED && post.state !== /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].POST_LOADING && !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isPostEphemeral(post)) {
	                comments = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        className: 'comment-icon__container' + showCommentClass,
	                        onClick: this.props.handleCommentClick
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', {
	                        className: 'comment-icon',
	                        dangerouslySetInnerHTML: { __html: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].REPLY_ICON }
	                    }),
	                    commentCountText
	                );
	            }
	
	            var dropdown = this.createDropdown();
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'ul',
	                { className: 'post__header--info' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    { className: 'col' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__time_since_jsx__["a"], {
	                        eventTime: post.create_at,
	                        sameUser: this.props.sameUser
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    { className: 'col col__reply' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'dropdown',
	                            ref: 'dotMenu'
	                        },
	                        dropdown
	                    ),
	                    comments,
	                    this.createRemovePostButton(post)
	                )
	            );
	        }
	    }]);
	
	    return PostInfo;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostInfo;
	
	
	PostInfo.defaultProps = {
	    post: null,
	    commentCount: 0,
	    isLastComment: false,
	    allowReply: false,
	    sameUser: false
	};
	PostInfo.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired,
	    commentCount: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.number.isRequired,
	    isLastComment: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.bool.isRequired,
	    allowReply: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string.isRequired,
	    handleCommentClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired,
	    sameUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.bool.isRequired,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__ = __webpack_require__(367);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var MAXIMUM_CACHED_VIEWS = 3;
	
	var PostsViewContainer = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(PostsViewContainer, _React$Component);
	
	    function PostsViewContainer() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PostsViewContainer);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PostsViewContainer).call(this));
	
	        _this.onChannelChange = _this.onChannelChange.bind(_this);
	        _this.onChannelLeave = _this.onChannelLeave.bind(_this);
	        _this.onPostsChange = _this.onPostsChange.bind(_this);
	        _this.handlePostsViewScroll = _this.handlePostsViewScroll.bind(_this);
	        _this.loadMorePostsTop = _this.loadMorePostsTop.bind(_this);
	        _this.handlePostsViewJumpRequest = _this.handlePostsViewJumpRequest.bind(_this);
	
	        var currentChannelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrentId();
	        var state = {
	            scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_BOTTOM,
	            scrollPost: null
	        };
	        if (currentChannelId) {
	            var lastViewed = Date.now();
	            var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getMember(currentChannelId);
	            if (member) {
	                lastViewed = member.last_viewed_at;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()(state, {
	                currentChannelIndex: 0,
	                channels: [currentChannelId],
	                postLists: [_this.getChannelPosts(currentChannelId)],
	                atTop: [/* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].getVisibilityAtTop(currentChannelId)],
	                currentLastViewed: lastViewed
	            });
	        } else {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()(state, {
	                currentChannelIndex: null,
	                channels: [],
	                postLists: [],
	                atTop: [],
	                currentLastViewed: Date.now()
	            });
	        }
	
	        state.showInviteModal = false;
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(PostsViewContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addChangeListener(this.onChannelChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addLeaveListener(this.onChannelLeave);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].addChangeListener(this.onPostsChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].addPostsViewJumpListener(this.handlePostsViewJumpRequest);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('body').addClass('app__body');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeChangeListener(this.onChannelChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeLeaveListener(this.onChannelLeave);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].removeChangeListener(this.onPostsChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].removePostsViewJumpListener(this.handlePostsViewJumpRequest);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('body').removeClass('app__body');
	        }
	    }, {
	        key: 'handlePostsViewJumpRequest',
	        value: function handlePostsViewJumpRequest(type, post) {
	            switch (type) {
	                case /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PostsViewJumpTypes.BOTTOM:
	                    this.setState({ scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_BOTTOM });
	                    break;
	                case /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PostsViewJumpTypes.POST:
	                    this.setState({
	                        scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_POST,
	                        scrollPost: post
	                    });
	                    break;
	                case /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PostsViewJumpTypes.SIDEBAR_OPEN:
	                    this.setState({ scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_SIDEBAR_OPEN });
	                    break;
	            }
	        }
	    }, {
	        key: 'onChannelChange',
	        value: function onChannelChange() {
	            var postLists = this.state.postLists.slice();
	            var atTop = this.state.atTop.slice();
	            var channels = this.state.channels.slice();
	            var channelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getCurrentId();
	
	            // Has the channel really changed?
	            if (channelId === channels[this.state.currentChannelIndex]) {
	                return;
	            }
	
	            var lastViewed = Number.MAX_VALUE;
	            var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].getMember(channelId);
	            if (member != null) {
	                lastViewed = member.last_viewed_at;
	            }
	
	            var newIndex = channels.indexOf(channelId);
	            if (newIndex === -1) {
	                if (channels.length >= MAXIMUM_CACHED_VIEWS) {
	                    channels.shift();
	                    atTop.shift();
	                    postLists.shift();
	                }
	
	                newIndex = channels.length;
	                channels.push(channelId);
	                atTop[newIndex] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].getVisibilityAtTop(channelId);
	            }
	
	            // make sure we have the latest posts from the store
	            postLists[newIndex] = this.getChannelPosts(channelId);
	
	            this.setState({
	                currentChannelIndex: newIndex,
	                currentLastViewed: lastViewed,
	                scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_NEW_MESSAGE,
	                channels: channels,
	                postLists: postLists,
	                atTop: atTop });
	        }
	    }, {
	        key: 'onChannelLeave',
	        value: function onChannelLeave(id) {
	            var postLists = this.state.postLists.slice();
	            var channels = this.state.channels.slice();
	            var atTop = this.state.atTop.slice();
	            var index = channels.indexOf(id);
	            if (index !== -1) {
	                postLists.splice(index, 1);
	                channels.splice(index, 1);
	                atTop.splice(index, 1);
	            }
	            this.setState({ channels: channels, postLists: postLists, atTop: atTop });
	        }
	    }, {
	        key: 'onPostsChange',
	        value: function onPostsChange() {
	            var channels = this.state.channels;
	            var postLists = this.state.postLists.slice();
	            var atTop = this.state.atTop.slice();
	            var currentChannelId = channels[this.state.currentChannelIndex];
	            var newPostsView = this.getChannelPosts(currentChannelId);
	
	            postLists[this.state.currentChannelIndex] = newPostsView;
	            atTop[this.state.currentChannelIndex] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].getVisibilityAtTop(currentChannelId);
	            this.setState({ postLists: postLists, atTop: atTop });
	        }
	    }, {
	        key: 'getChannelPosts',
	        value: function getChannelPosts(id) {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_post_store_jsx__["a"].getVisiblePosts(id);
	        }
	    }, {
	        key: 'loadMorePostsTop',
	        value: function loadMorePostsTop() {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.emitLoadMorePostsEvent();
	        }
	    }, {
	        key: 'handlePostsViewScroll',
	        value: function handlePostsViewScroll(atBottom) {
	            if (atBottom) {
	                this.setState({ scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_BOTTOM });
	            } else {
	                this.setState({ scrollType: /* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"].SCROLL_TYPE_FREE });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var postLists = this.state.postLists;
	            var channels = this.state.channels;
	            var currentChannelId = channels[this.state.currentChannelIndex];
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].get(currentChannelId);
	
	            if (!channel) {
	                return null;
	            }
	
	            var postListCtls = [];
	            for (var i = 0; i < channels.length; i++) {
	                var isActive = channels[i] === currentChannelId;
	                postListCtls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__posts_view_jsx__["a"], {
	                    key: 'postsviewkey' + channels[i],
	                    isActive: isActive,
	                    postList: postLists[i],
	                    scrollType: this.state.scrollType,
	                    scrollPostId: this.state.scrollPost,
	                    postViewScrolled: this.handlePostsViewScroll,
	                    loadMorePostsTopClicked: this.loadMorePostsTop,
	                    loadMorePostsBottomClicked: function loadMorePostsBottomClicked() {
	                        // Do Nothing
	                    },
	                    showMoreMessagesTop: !this.state.atTop[this.state.currentChannelIndex],
	                    showMoreMessagesBottom: false,
	                    channel: channel,
	                    messageSeparatorTime: this.state.currentLastViewed
	                }));
	                if (!postLists[i] && isActive) {
	                    postListCtls.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__loading_screen_jsx__["a"], {
	                        position: 'absolute',
	                        key: 'loading'
	                    }));
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { id: 'post-list' },
	                postListCtls
	            );
	        }
	    }]);
	
	    return PostsViewContainer;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PostsViewContainer;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].ActionTypes;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    required: {
	        id: 'register_app.required',
	        defaultMessage: 'Required'
	    },
	    optional: {
	        id: 'register_app.optional',
	        defaultMessage: 'Optional'
	    }
	});
	
	
	
	var RegisterAppModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(RegisterAppModal, _React$Component);
	
	    function RegisterAppModal() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RegisterAppModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RegisterAppModal).call(this));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.onHide = _this.onHide.bind(_this);
	        _this.save = _this.save.bind(_this);
	        _this.updateShow = _this.updateShow.bind(_this);
	
	        _this.state = {
	            clientId: '',
	            clientSecret: '',
	            saved: false,
	            show: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(RegisterAppModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].addModalListener(ActionTypes.TOGGLE_REGISTER_APP_MODAL, this.updateShow);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].removeModalListener(ActionTypes.TOGGLE_REGISTER_APP_MODAL, this.updateShow);
	        }
	    }, {
	        key: 'updateShow',
	        value: function updateShow(show) {
	            if (!show) {
	                if (this.state.clientId !== '' && !this.state.saved) {
	                    return;
	                }
	
	                this.setState({
	                    clientId: '',
	                    clientSecret: '',
	                    saved: false,
	                    homepageError: null,
	                    callbackError: null,
	                    serverError: null,
	                    nameError: null
	                });
	            }
	
	            this.setState({ show: show });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var state = this.state;
	            state.serverError = null;
	
	            var app = {};
	
	            var name = this.refs.name.value;
	            if (!name || name.length === 0) {
	                state.nameError = true;
	                this.setState(state);
	                return;
	            }
	            state.nameError = null;
	            app.name = name;
	
	            var homepage = this.refs.homepage.value;
	            if (!homepage || homepage.length === 0) {
	                state.homepageError = true;
	                this.setState(state);
	                return;
	            }
	            state.homepageError = null;
	            app.homepage = homepage;
	
	            var desc = this.refs.desc.value;
	            app.description = desc;
	
	            var rawCallbacks = this.refs.callback.value.trim();
	            if (!rawCallbacks || rawCallbacks.length === 0) {
	                state.callbackError = true;
	                this.setState(state);
	                return;
	            }
	            state.callbackError = null;
	            app.callback_urls = rawCallbacks.split('\n');
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].registerOAuthApp(app, function (data) {
	                state.clientId = data.id;
	                state.clientSecret = data.client_secret;
	                _this2.setState(state);
	            }, function (err) {
	                state.serverError = err.message;
	                _this2.setState(state);
	            });
	        }
	    }, {
	        key: 'onHide',
	        value: function onHide(e) {
	            if (!this.state.saved && this.state.clientId !== '') {
	                e.preventDefault();
	                return;
	            }
	
	            this.setState({ clientId: '', clientSecret: '', saved: false });
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            this.setState({ saved: this.refs.save.checked });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var nameError;
	            if (this.state.nameError) {
	                nameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.nameError',
	                            defaultMessage: 'Application name must be filled in.'
	                        })
	                    )
	                );
	            }
	            var homepageError;
	            if (this.state.homepageError) {
	                homepageError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.homepageError',
	                            defaultMessage: 'Homepage must be filled in.'
	                        })
	                    )
	                );
	            }
	            var callbackError;
	            if (this.state.callbackError) {
	                callbackError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.callbackError',
	                            defaultMessage: 'At least one callback URL must be filled in.'
	                        })
	                    )
	                );
	            }
	            var serverError;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var body = '';
	            var footer = '';
	            if (this.state.clientId === '') {
	                body = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'settings-modal' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'form-horizontal user-settings' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'h4',
	                            { className: 'padding-bottom x3' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'register_app.title',
	                                defaultMessage: 'Register a New Application'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'row' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'register_app.name',
	                                    defaultMessage: 'Application Name'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    ref: 'name',
	                                    className: 'form-control',
	                                    type: 'text',
	                                    placeholder: formatMessage(holders.required)
	                                }),
	                                nameError
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'row padding-top x2' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'register_app.homepage',
	                                    defaultMessage: 'Homepage URL'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    ref: 'homepage',
	                                    className: 'form-control',
	                                    type: 'text',
	                                    placeholder: formatMessage(holders.required)
	                                }),
	                                homepageError
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'row padding-top x2' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'register_app.description',
	                                    defaultMessage: 'Description'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                    ref: 'desc',
	                                    className: 'form-control',
	                                    type: 'text',
	                                    placeholder: formatMessage(holders.optional)
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'row padding-top padding-bottom x2' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-4 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                    id: 'register_app.callback',
	                                    defaultMessage: 'Callback URL'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('textarea', {
	                                    ref: 'callback',
	                                    className: 'form-control',
	                                    type: 'text',
	                                    placeholder: formatMessage(holders.required),
	                                    rows: '5'
	                                }),
	                                callbackError
	                            )
	                        ),
	                        serverError
	                    )
	                );
	
	                footer = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-default',
	                            onClick: function onClick() {
	                                return _this3.updateShow(false);
	                            }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.cancel',
	                            defaultMessage: 'Cancel'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'button',
	                        {
	                            onClick: this.handleSubmit,
	                            type: 'submit',
	                            className: 'btn btn-primary',
	                            tabIndex: '3'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.register',
	                            defaultMessage: 'Register'
	                        })
	                    )
	                );
	            } else {
	                var btnClass = ' disabled';
	                if (this.state.saved) {
	                    btnClass = '';
	                }
	
	                body = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'form-horizontal user-settings' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'h4',
	                        { className: 'padding-bottom x3' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.credentialsTitle',
	                            defaultMessage: 'Your Application Credentials'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-4 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'register_app.clientId',
	                                defaultMessage: 'Client ID'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                value: this.state.clientId,
	                                readOnly: 'true'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'row padding-top x2' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-4 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'register_app.clientSecret',
	                                defaultMessage: 'Client Secret'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                value: this.state.clientSecret,
	                                readOnly: 'true'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'strong',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                            id: 'register_app.credentialsDescription',
	                            defaultMessage: 'Save these somewhere SAFE and SECURE. Treat your Client ID as your app\'s username and your Client Secret as the app\'s password.'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'checkbox' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                ref: 'save',
	                                type: 'checkbox',
	                                checked: this.state.saved,
	                                onChange: this.save
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'register_app.credentialsSave',
	                                defaultMessage: 'I have saved both my Client Id and Client Secret somewhere safe'
	                            })
	                        )
	                    )
	                );
	
	                footer = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'btn btn-sm btn-primary pull-right' + btnClass,
	                        href: '#',
	                        onClick: function onClick(e) {
	                            e.preventDefault();
	                            _this3.updateShow(false);
	                        }
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'register_app.close',
	                        defaultMessage: 'Close'
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'span',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"],
	                    {
	                        show: this.state.show,
	                        onHide: function onHide() {
	                            return _this3.updateShow(false);
	                        }
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Header,
	                        { closeButton: true },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Title,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'register_app.dev',
	                                defaultMessage: 'Developer Applications'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'form',
	                        {
	                            role: 'form',
	                            className: 'form-horizontal'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Body,
	                            null,
	                            body
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["Modal"].Footer,
	                            null,
	                            footer
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RegisterAppModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	RegisterAppModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(RegisterAppModal);

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router___default = __WEBPACK_IMPORTED_MODULE_12_react_router__ && __WEBPACK_IMPORTED_MODULE_12_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var RemovedFromChannelModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(RemovedFromChannelModal, _React$Component);
	
	    function RemovedFromChannelModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RemovedFromChannelModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RemovedFromChannelModal).call(this, props));
	
	        _this.handleShow = _this.handleShow.bind(_this);
	        _this.handleClose = _this.handleClose.bind(_this);
	
	        _this.state = {
	            channelName: '',
	            remover: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(RemovedFromChannelModal, [{
	        key: 'handleShow',
	        value: function handleShow() {
	            var newState = {};
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].getItem('channel-removed-state')) {
	                newState = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].getItem('channel-removed-state');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].removeItem('channel-removed-state');
	            }
	
	            var townSquare = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getByName('town-square');
	            setTimeout(function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_router__["browserHistory"].push(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.getTeamURLNoOriginFromAddressBar() + '/channels/' + townSquare.name);
	            }, 1);
	
	            this.setState(newState);
	        }
	    }, {
	        key: 'handleClose',
	        value: function handleClose() {
	            this.setState({ channelName: '', remover: '' });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this)).on('show.bs.modal', this.handleShow);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this)).on('hidden.bs.modal', this.handleClose);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this)).off('show.bs.modal', this.handleShow);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this)).off('hidden.bs.modal', this.handleClose);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var currentUser = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getCurrentUser();
	
	            var channelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                id: 'removed_channel.channelName',
	                defaultMessage: 'the channel'
	            });
	            if (this.state.channelName) {
	                channelName = this.state.channelName;
	            }
	
	            var remover = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                id: 'removed_channel.someone',
	                defaultMessage: 'Someone'
	            });
	            if (this.state.remover) {
	                remover = this.state.remover;
	            }
	
	            if (currentUser != null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'modal fade',
	                        ref: 'modal',
	                        id: 'removed_from_channel',
	                        tabIndex: '-1',
	                        role: 'dialog',
	                        'aria-hidden': 'true'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'modal-dialog' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-content' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                { className: 'modal-header' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'close',
	                                        'data-dismiss': 'modal',
	                                        'aria-label': 'Close'
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'span',
	                                        { 'aria-hidden': 'true' },
	                                        '×'
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'h4',
	                                    { className: 'modal-title' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'removed_channel.from',
	                                        defaultMessage: 'Removed from '
	                                    }),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                        'span',
	                                        { className: 'name' },
	                                        channelName
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                { className: 'modal-body' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'p',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'removed_channel.remover',
	                                        defaultMessage: '{remover} removed you from {channel}',
	                                        values: {
	                                            remover: remover,
	                                            channel: channelName
	                                        }
	                                    })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                { className: 'modal-footer' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        type: 'button',
	                                        className: 'btn btn-primary',
	                                        'data-dismiss': 'modal'
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'removed_channel.okay',
	                                        defaultMessage: 'Okay'
	                                    })
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', null);
	        }
	    }]);
	
	    return RemovedFromChannelModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = RemovedFromChannelModal;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_profile_jsx__ = __webpack_require__(160);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__file_attachment_list_jsx__ = __webpack_require__(247);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_intl___default = __WEBPACK_IMPORTED_MODULE_18_react_intl__ && __WEBPACK_IMPORTED_MODULE_18_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_19_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_19_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_images_load_gif___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __WEBPACK_IMPORTED_MODULE_20_react__ && __WEBPACK_IMPORTED_MODULE_20_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_20_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_20_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_20_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_20_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	
	
	var RhsComment = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(RhsComment, _React$Component);
	
	    function RhsComment(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RhsComment);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RhsComment).call(this, props));
	
	        _this.retryComment = _this.retryComment.bind(_this);
	        _this.handlePermalink = _this.handlePermalink.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(RhsComment, [{
	        key: 'retryComment',
	        value: function retryComment(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var post = this.props.post;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_web_client_jsx__["a"].createPost(post, function (data) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_16_utils_async_client_jsx__.getPosts(post.channel_id);
	
	                var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].get(post.channel_id);
	                var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].getMember(post.channel_id);
	                member.msg_count = channel.total_msg_count;
	                member.last_viewed_at = new Date().getTime();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_channel_store_jsx__["a"].setChannelMember(member);
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_POST,
	                    post: data
	                });
	            }, function () {
	                post.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED;
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_post_store_jsx__["a"].updatePendingPost(post);
	                _this2.forceUpdate();
	            });
	
	            post.state = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_post_store_jsx__["a"].updatePendingPost(post);
	            this.forceUpdate();
	        }
	    }, {
	        key: 'handlePermalink',
	        value: function handlePermalink(e) {
	            e.preventDefault();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.showGetPostLinkModal(this.props.post);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.areObjectsEqual(nextProps.post, this.props.post)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'createDropdown',
	        value: function createDropdown() {
	            var post = this.props.post;
	
	            if (post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED || post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING || post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_DELETED) {
	                return '';
	            }
	
	            var isOwner = this.props.currentUser.id === post.user_id;
	            var isAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	
	            var dropdownContents = [];
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isMobile()) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'rhs-root-permalink',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handlePermalink
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_intl__["FormattedMessage"], {
	                            id: 'rhs_comment.permalink',
	                            defaultMessage: 'Permalink'
	                        })
	                    )
	                ));
	            }
	
	            if (isOwner) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'li',
	                    {
	                        role: 'presentation',
	                        key: 'edit-button'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            role: 'menuitem',
	                            'data-toggle': 'modal',
	                            'data-target': '#edit_post',
	                            'data-refocusid': '#reply_textbox',
	                            'data-title': /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.localizeMessage('rhs_comment.comment', 'Comment'),
	                            'data-message': post.message,
	                            'data-postid': post.id,
	                            'data-channelid': post.channel_id
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_intl__["FormattedMessage"], {
	                            id: 'rhs_comment.edit',
	                            defaultMessage: 'Edit'
	                        })
	                    )
	                ));
	            }
	
	            if (isOwner || isAdmin) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'li',
	                    {
	                        role: 'presentation',
	                        key: 'delete-button'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            role: 'menuitem',
	                            onClick: function onClick() {
	                                return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_action_creators_global_actions_jsx__.showDeletePostModal(post, 0);
	                            }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_intl__["FormattedMessage"], {
	                            id: 'rhs_comment.del',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                ));
	            }
	
	            if (dropdownContents.length === 0) {
	                return '';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                'div',
	                { className: 'dropdown' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('a', {
	                    href: '#',
	                    className: 'post__dropdown dropdown-toggle',
	                    type: 'button',
	                    'data-toggle': 'dropdown',
	                    'aria-expanded': 'false'
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'ul',
	                    {
	                        className: 'dropdown-menu',
	                        role: 'menu'
	                    },
	                    dropdownContents
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	
	            var currentUserCss = '';
	            if (this.props.currentUser === post.user_id) {
	                currentUserCss = 'current--user';
	            }
	
	            var timestamp = this.props.currentUser.update_at;
	
	            var loading = void 0;
	            var postClass = '';
	            var message = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('div', {
	                ref: 'message_holder',
	                onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_text_formatting_jsx__.handleClick,
	                dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_text_formatting_jsx__.formatText(post.message) }
	            });
	
	            if (post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED) {
	                postClass += ' post-fail';
	                loading = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'theme post-retry pull-right',
	                        href: '#',
	                        onClick: this.retryComment
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_intl__["FormattedMessage"], {
	                        id: 'rhs_comment.retry',
	                        defaultMessage: 'Retry'
	                    })
	                );
	            } else if (post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING) {
	                postClass += ' post-waiting';
	                loading = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
	                    className: 'post-loading-gif pull-right',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_images_load_gif___default.a
	                });
	            } else if (this.props.post.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_DELETED) {
	                message = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_intl__["FormattedMessage"], {
	                    id: 'post_body.deleted',
	                    defaultMessage: '(message deleted)'
	                });
	            }
	
	            var dropdown = this.createDropdown();
	
	            var fileAttachment;
	            if (post.filenames && post.filenames.length > 0) {
	                fileAttachment = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__file_attachment_list_jsx__["a"], {
	                    filenames: post.filenames,
	                    channelId: post.channel_id,
	                    userId: post.user_id
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                'div',
	                { className: 'post ' + currentUserCss },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'div',
	                    { className: 'post__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                        'div',
	                        { className: 'post__img' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('img', {
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_utils_web_client_jsx__["a"].getUsersRoute() + '/' + post.user_id + '/image?time=' + timestamp,
	                            height: '36',
	                            width: '36'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                            'ul',
	                            { className: 'post__header' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                'li',
	                                { className: 'col__name' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                    'strong',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__user_profile_jsx__["a"], { user: this.props.user })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                'li',
	                                { className: 'col' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                    'time',
	                                    { className: 'post__time' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_intl__["FormattedDate"], {
	                                        value: post.create_at,
	                                        day: 'numeric',
	                                        month: 'long',
	                                        year: 'numeric',
	                                        hour12: !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.isMilitaryTime(),
	                                        hour: '2-digit',
	                                        minute: '2-digit'
	                                    })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                'li',
	                                { className: 'col col__reply' },
	                                dropdown
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                            'div',
	                            { className: 'post__body' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                'div',
	                                { className: postClass },
	                                loading,
	                                message
	                            ),
	                            fileAttachment
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RhsComment;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = RhsComment;
	
	
	RhsComment.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.PropTypes.object,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.PropTypes.object.isRequired,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	var RhsHeaderPost = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(RhsHeaderPost, _React$Component);
	
	    function RhsHeaderPost(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RhsHeaderPost);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RhsHeaderPost).call(this, props));
	
	        _this.handleClose = _this.handleClose.bind(_this);
	        _this.handleBack = _this.handleBack.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(RhsHeaderPost, [{
	        key: 'handleClose',
	        value: function handleClose(e) {
	            e.preventDefault();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__.emitCloseRightHandSide();
	        }
	    }, {
	        key: 'handleBack',
	        value: function handleBack(e) {
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH_TERM,
	                term: this.props.fromSearch,
	                do_search: true,
	                is_mention_search: this.props.isMentionSearch
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_POST_SELECTED,
	                postId: null
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var back = void 0;
	            if (this.props.fromSearch) {
	                back = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        onClick: this.handleBack,
	                        className: 'sidebar--right__back'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-chevron-left' })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                { className: 'sidebar--right__header' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'span',
	                    { className: 'sidebar--right__title' },
	                    back,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                        id: 'rhs_header.details',
	                        defaultMessage: 'Message Details'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'sidebar--right__close',
	                        'aria-label': 'Close',
	                        onClick: this.handleClose
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-sign-out' })
	                )
	            );
	        }
	    }]);
	
	    return RhsHeaderPost;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = RhsHeaderPost;
	
	
	RhsHeaderPost.defaultProps = {
	    isMentionSearch: false,
	    fromSearch: ''
	};
	RhsHeaderPost.propTypes = {
	    isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    fromSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string
	};

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_profile_jsx__ = __webpack_require__(160);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__file_attachment_list_jsx__ = __webpack_require__(247);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__post_body_additional_content_jsx__ = __webpack_require__(365);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __WEBPACK_IMPORTED_MODULE_15_react_intl__ && __WEBPACK_IMPORTED_MODULE_15_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __WEBPACK_IMPORTED_MODULE_16_react__ && __WEBPACK_IMPORTED_MODULE_16_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var RhsRootPost = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(RhsRootPost, _React$Component);
	
	    function RhsRootPost(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RhsRootPost);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RhsRootPost).call(this, props));
	
	        _this.handlePermalink = _this.handlePermalink.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(RhsRootPost, [{
	        key: 'handlePermalink',
	        value: function handlePermalink(e) {
	            e.preventDefault();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_action_creators_global_actions_jsx__.showGetPostLinkModal(this.props.post);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.areObjectsEqual(nextProps.post, this.props.post)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var post = this.props.post;
	            var user = this.props.user;
	            var isOwner = this.props.currentUser.id === post.user_id;
	            var isAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	            var timestamp = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getProfile(post.user_id).update_at;
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].get(post.channel_id);
	
	            var type = 'Post';
	            if (post.root_id.length > 0) {
	                type = 'Comment';
	            }
	
	            var userCss = '';
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentId() === post.user_id) {
	                userCss = 'current--user';
	            }
	
	            var systemMessageClass = '';
	            if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.isSystemMessage(post)) {
	                systemMessageClass = 'post--system';
	            }
	
	            var channelName;
	            if (channel) {
	                if (channel.type === 'D') {
	                    channelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                        id: 'rhs_root.direct',
	                        defaultMessage: 'Direct Message'
	                    });
	                } else {
	                    channelName = channel.display_name;
	                }
	            }
	
	            var dropdownContents = [];
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.isMobile()) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'rhs-root-permalink',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: this.handlePermalink
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'rhs_root.permalink',
	                            defaultMessage: 'Permalink'
	                        })
	                    )
	                ));
	            }
	
	            if (isOwner) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'rhs-root-edit',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            role: 'menuitem',
	                            'data-toggle': 'modal',
	                            'data-target': '#edit_post',
	                            'data-refocusid': '#reply_textbox',
	                            'data-title': type,
	                            'data-message': post.message,
	                            'data-postid': post.id,
	                            'data-channelid': post.channel_id
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'rhs_root.edit',
	                            defaultMessage: 'Edit'
	                        })
	                    )
	                ));
	            }
	
	            if (isOwner || isAdmin) {
	                dropdownContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'li',
	                    {
	                        key: 'rhs-root-delete',
	                        role: 'presentation'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            role: 'menuitem',
	                            onClick: function onClick() {
	                                return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_action_creators_global_actions_jsx__.showDeletePostModal(post, _this2.props.commentCount);
	                            }
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'rhs_root.del',
	                            defaultMessage: 'Delete'
	                        })
	                    )
	                ));
	            }
	
	            var rootOptions = '';
	            if (dropdownContents.length > 0) {
	                rootOptions = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'dropdown' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('a', {
	                        href: '#',
	                        className: 'post__dropdown dropdown-toggle',
	                        type: 'button',
	                        'data-toggle': 'dropdown',
	                        'aria-expanded': 'false'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'ul',
	                        {
	                            className: 'dropdown-menu',
	                            role: 'menu'
	                        },
	                        dropdownContents
	                    )
	                );
	            }
	
	            var fileAttachment;
	            if (post.filenames && post.filenames.length > 0) {
	                fileAttachment = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__file_attachment_list_jsx__["a"], {
	                    filenames: post.filenames,
	                    channelId: post.channel_id,
	                    userId: post.user_id
	                });
	            }
	
	            var userProfile = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__user_profile_jsx__["a"], { user: user });
	            var botIndicator = void 0;
	
	            if (post.props && post.props.from_webhook) {
	                if (post.props.override_username && global.window.mm_config.EnablePostUsernameOverride === 'true') {
	                    userProfile = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__user_profile_jsx__["a"], {
	                        user: user,
	                        overwriteName: post.props.override_username,
	                        disablePopover: true
	                    });
	                }
	
	                botIndicator = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'li',
	                    { className: 'col col__name bot-indicator' },
	                    'BOT'
	                );
	            } else if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.isSystemMessage(post)) {
	                userProfile = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__user_profile_jsx__["a"], {
	                    user: {},
	                    overwriteName: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__["a"].SYSTEM_MESSAGE_PROFILE_NAME,
	                    overwriteImage: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__["a"].SYSTEM_MESSAGE_PROFILE_IMAGE,
	                    disablePopover: true
	                });
	            }
	
	            var profilePic = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
	                className: 'post-profile-img',
	                src: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.getProfilePicSrcForPost(post, timestamp),
	                height: '36',
	                width: '36'
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                { className: 'post post--root ' + userCss + ' ' + systemMessageClass },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'post-right-channel__name' },
	                    channelName
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'post__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'post__img' },
	                        profilePic
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'ul',
	                            { className: 'post__header' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'li',
	                                { className: 'col__name' },
	                                userProfile
	                            ),
	                            botIndicator,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'li',
	                                { className: 'col' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                    'time',
	                                    { className: 'post__time' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedDate"], {
	                                        value: post.create_at,
	                                        day: 'numeric',
	                                        month: 'long',
	                                        year: 'numeric',
	                                        hour12: !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.isMilitaryTime(),
	                                        hour: '2-digit',
	                                        minute: '2-digit'
	                                    })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'li',
	                                { className: 'col col__reply' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                    'div',
	                                    null,
	                                    rootOptions
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'post__body' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', {
	                                ref: 'message_holder',
	                                onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_text_formatting_jsx__.handleClick,
	                                dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_text_formatting_jsx__.formatText(post.message) }
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__post_body_additional_content_jsx__["a"], {
	                                post: post
	                            }),
	                            fileAttachment
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RhsRootPost;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = RhsRootPost;
	
	
	RhsRootPost.defaultProps = {
	    commentCount: 0
	};
	RhsRootPost.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.object.isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.object.isRequired,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.object.isRequired,
	    commentCount: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.number
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __WEBPACK_IMPORTED_MODULE_7_jquery__ && __WEBPACK_IMPORTED_MODULE_7_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search_bar_jsx__ = __webpack_require__(250);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__create_comment_jsx__ = __webpack_require__(692);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rhs_header_post_jsx__ = __webpack_require__(736);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rhs_root_post_jsx__ = __webpack_require__(737);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rhs_comment_jsx__ = __webpack_require__(735);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__file_upload_overlay_jsx__ = __webpack_require__(361);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars__ = __webpack_require__(1603);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars___default = __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars__ && __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __WEBPACK_IMPORTED_MODULE_20_react__ && __WEBPACK_IMPORTED_MODULE_20_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_20_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_20_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_20_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_20_react___default });
	/* unused harmony export renderThumbHorizontal *//* unused harmony export renderThumbVertical */'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function renderThumbHorizontal(props) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('div', /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default.a.bind()({}, props, {
	        className: 'scrollbar--horizontal'
	    }));
	}
	
	function renderThumbVertical(props) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('div', /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default.a.bind()({}, props, {
	        className: 'scrollbar--vertical'
	    }));
	}
	
	var RhsThread = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(RhsThread, _React$Component);
	
	    function RhsThread(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, RhsThread);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(RhsThread).call(this, props));
	
	        _this.mounted = false;
	
	        _this.onPostChange = _this.onPostChange.bind(_this);
	        _this.onUserChange = _this.onUserChange.bind(_this);
	        _this.forceUpdateInfo = _this.forceUpdateInfo.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        var state = _this.getPosts();
	        state.windowWidth = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.windowWidth();
	        state.windowHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.windowHeight();
	        state.profiles = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getProfiles()));
	
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(RhsThread, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].addSelectedPostChangeListener(this.onPostChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].addChangeListener(this.onPostChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].addChangeListener(this.forceUpdateInfo);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].addChangeListener(this.onUserChange);
	
	            this.scrollToBottom();
	            window.addEventListener('resize', this.handleResize);
	
	            this.mounted = true;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].removeSelectedPostChangeListener(this.onPostChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].removeChangeListener(this.onPostChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_preference_store_jsx__["a"].removeChangeListener(this.forceUpdateInfo);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChange);
	
	            window.removeEventListener('resize', this.handleResize);
	
	            this.mounted = false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var prevPostsArray = prevState.postsArray || [];
	            var curPostsArray = this.state.postsArray || [];
	
	            if (prevPostsArray.length >= curPostsArray.length) {
	                return;
	            }
	
	            var curLastPost = curPostsArray[curPostsArray.length - 1];
	
	            if (curLastPost.user_id === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentId()) {
	                this.scrollToBottom();
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(nextState.postsArray, this.state.postsArray)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(nextState.selected, this.state.selected)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(nextState.profiles, this.state.profiles)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'forceUpdateInfo',
	        value: function forceUpdateInfo() {
	            if (this.state.postList) {
	                for (var postId in this.state.postList.posts) {
	                    if (this.refs[postId]) {
	                        this.refs[postId].forceUpdate();
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState({
	                windowWidth: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.windowWidth(),
	                windowHeight: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.windowHeight()
	            });
	        }
	    }, {
	        key: 'onPostChange',
	        value: function onPostChange() {
	            if (this.mounted) {
	                this.setState(this.getPosts());
	            }
	        }
	    }, {
	        key: 'getPosts',
	        value: function getPosts() {
	            var selected = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].getSelectedPost();
	            var posts = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_post_store_jsx__["a"].getSelectedPostThread();
	
	            var postsArray = [];
	
	            for (var id in posts) {
	                if (posts.hasOwnProperty(id)) {
	                    var cpost = posts[id];
	                    if (cpost.root_id === selected.id) {
	                        postsArray.push(cpost);
	                    }
	                }
	            }
	
	            // sort failed posts to bottom, followed by pending, and then regular posts
	            postsArray.sort(function (a, b) {
	                if ((a.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING || a.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED) && b.state !== /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING && b.state !== /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED) {
	                    return 1;
	                }
	                if (a.state !== /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING && a.state !== /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED && (b.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING || b.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED)) {
	                    return -1;
	                }
	
	                if (a.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING && b.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED) {
	                    return -1;
	                }
	                if (a.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_FAILED && b.state === /* harmony import */__WEBPACK_IMPORTED_MODULE_17_utils_constants_jsx__["a"].POST_LOADING) {
	                    return 1;
	                }
	
	                if (a.create_at < b.create_at) {
	                    return -1;
	                }
	                if (a.create_at > b.create_at) {
	                    return 1;
	                }
	                return 0;
	            });
	
	            return { postsArray: postsArray, selected: selected };
	        }
	    }, {
	        key: 'onUserChange',
	        value: function onUserChange() {
	            var profiles = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getProfiles()));
	            this.setState({ profiles: profiles });
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.post-right__scroll')[0]) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.post-right__scroll').parent().scrollTop(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.bind()('.post-right__scroll')[0].scrollHeight);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var postsArray = this.state.postsArray;
	            var selected = this.state.selected;
	            var profiles = this.state.profiles || {};
	
	            if (postsArray == null || selected == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement('div', null);
	            }
	
	            var currentId = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentId();
	            var searchForm;
	            if (currentId != null) {
	                searchForm = /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__search_bar_jsx__["a"], null);
	            }
	
	            var profile = void 0;
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentId() === selected.user_id) {
	                profile = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentUser();
	            } else {
	                profile = profiles[selected.user_id];
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                'div',
	                { className: 'post-right__container' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_18__file_upload_overlay_jsx__["a"], { overlayType: 'right' }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'div',
	                    { className: 'search-bar__container sidebar--right__search-header' },
	                    searchForm
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                    'div',
	                    { className: 'sidebar-right__body' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__rhs_header_post_jsx__["a"], {
	                        fromSearch: this.props.fromSearch,
	                        isMentionSearch: this.props.isMentionSearch
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react_custom_scrollbars___default.a,
	                        {
	                            autoHide: true,
	                            autoHideTimeout: 500,
	                            autoHideDuration: 500,
	                            renderThumbHorizontal: renderThumbHorizontal,
	                            renderThumbVertical: renderThumbVertical
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                            'div',
	                            { className: 'post-right__scroll' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15__rhs_root_post_jsx__["a"], {
	                                ref: selected.id,
	                                post: selected,
	                                commentCount: postsArray.length,
	                                user: profile,
	                                currentUser: this.props.currentUser
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                'div',
	                                { className: 'post-right-comments-container' },
	                                postsArray.map(function (comPost) {
	                                    var p = void 0;
	                                    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentId() === comPost.user_id) {
	                                        p = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentUser();
	                                    } else {
	                                        p = profiles[comPost.user_id];
	                                    }
	                                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16__rhs_comment_jsx__["a"], {
	                                        ref: comPost.id,
	                                        key: comPost.id + 'commentKey',
	                                        post: comPost,
	                                        user: p,
	                                        currentUser: _this2.props.currentUser
	                                    });
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(
	                                'div',
	                                { className: 'post-create__container' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13__create_comment_jsx__["a"], {
	                                    channelId: selected.channel_id,
	                                    rootId: selected.id
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RhsThread;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = RhsThread;
	
	
	RhsThread.defaultProps = {
	    fromSearch: '',
	    isMentionSearch: false
	};
	
	RhsThread.propTypes = {
	    fromSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.PropTypes.string,
	    isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.PropTypes.bool,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_localization_store_jsx__ = __webpack_require__(375);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fastclick__ = __webpack_require__(1397);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fastclick___default = __WEBPACK_IMPORTED_MODULE_9_fastclick__ && __WEBPACK_IMPORTED_MODULE_9_fastclick__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_fastclick__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_fastclick__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_fastclick___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_fastclick___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router___default = __WEBPACK_IMPORTED_MODULE_10_react_router__ && __WEBPACK_IMPORTED_MODULE_10_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__ = __webpack_require__(16);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	//import $ from 'jquery';
	//import Client from 'utils/web_client.jsx';
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Root = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(Root, _React$Component);
	
	    function Root(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Root);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Root).call(this, props));
	
	        _this.state = {
	            locale: 'en',
	            translations: null
	        };
	
	        _this.localizationChanged = _this.localizationChanged.bind(_this);
	        _this.redirectIfNecessary = _this.redirectIfNecessary.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(Root, [{
	        key: 'localizationChanged',
	        value: function localizationChanged() {
	            this.setState({ locale: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_localization_store_jsx__["a"].getLocale(), translations: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_localization_store_jsx__["a"].getTranslations() });
	        }
	    }, {
	        key: 'redirectIfNecessary',
	        value: function redirectIfNecessary(props) {
	            if (props.location.pathname === '/') {
	                if (/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getNoAccounts()) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_router__["browserHistory"].push('/signup_user_complete');
	                } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentUser()) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_router__["browserHistory"].push('/select_team');
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_router__["browserHistory"].push('/login');
	                }
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            this.redirectIfNecessary(newProps);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // Setup localization listener
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_localization_store_jsx__["a"].addChangeListener(this.localizationChanged);
	
	            // Ya....
	            /*eslint-disable */
	            if (window.mm_config.SegmentDeveloperKey != null && window.mm_config.SegmentDeveloperKey !== "") {
	                !function () {
	                    var analytics = global.window.analytics = global.window.analytics || [];if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
	                        analytics.invoked = !0;analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "group", "track", "ready", "alias", "page", "once", "off", "on"];analytics.factory = function (t) {
	                            return function () {
	                                var e = Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics;
	                            };
	                        };for (var t = 0; t < analytics.methods.length; t++) {
	                            var e = analytics.methods[t];analytics[e] = analytics.factory(e);
	                        }analytics.load = function (t) {
	                            var e = document.createElement("script");e.type = "text/javascript";e.async = !0;e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";var n = document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e, n);
	                        };analytics.SNIPPET_VERSION = "3.0.1";
	                        analytics.load(window.mm_config.SegmentDeveloperKey);
	                        analytics.page();
	                    }
	                }();
	            }
	            /*eslint-enable */
	
	            // Fastclick
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_fastclick___default.a.attach(document.body);
	
	            // Get our localizaiton
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_action_creators_global_actions_jsx__.loadBrowserLocale();
	
	            // Redirect if Necessary
	            this.redirectIfNecessary(this.props);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_localization_store_jsx__["a"].removeChangeListener(this.localizationChanged);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.translations == null || this.props.children == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', null);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["IntlProvider"],
	                {
	                    locale: this.state.locale,
	                    messages: this.state.translations,
	                    key: this.state.locale
	                },
	                this.props.children
	            );
	        }
	    }]);
	
	    return Root;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Root;
	
	Root.defaultProps = {};
	
	Root.propTypes = {
	    children: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __WEBPACK_IMPORTED_MODULE_8_jquery__ && __WEBPACK_IMPORTED_MODULE_8_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_search_store_jsx__ = __webpack_require__(161);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search_bar_jsx__ = __webpack_require__(250);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__search_results_header_jsx__ = __webpack_require__(741);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__search_results_item_jsx__ = __webpack_require__(742);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl___default = __WEBPACK_IMPORTED_MODULE_16_react_intl__ && __WEBPACK_IMPORTED_MODULE_16_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __WEBPACK_IMPORTED_MODULE_17_react__ && __WEBPACK_IMPORTED_MODULE_17_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	function getStateFromStores() {
	    var results = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_search_store_jsx__["a"].getSearchResults();
	
	    var channels = new /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
	
	    if (results && results.order) {
	        var channelIds = results.order.map(function (postId) {
	            return results.posts[postId].channel_id;
	        });
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default.a.bind()(channelIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var id = _step.value;
	
	                if (channels.has(id)) {
	                    continue;
	                }
	
	                channels.set(id, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].get(id));
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	
	    return {
	        results: results,
	        channels: channels
	    };
	}
	
	
	
	var SearchResults = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(SearchResults, _React$Component);
	
	    function SearchResults(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchResults);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchResults).call(this, props));
	
	        _this.mounted = false;
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onUserChange = _this.onUserChange.bind(_this);
	        _this.resize = _this.resize.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        var state = getStateFromStores();
	        state.windowWidth = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.windowWidth();
	        state.windowHeight = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.windowHeight();
	        state.profiles = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getProfiles()));
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(SearchResults, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.mounted = true;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_search_store_jsx__["a"].addSearchChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].addChangeListener(this.onUserChange);
	            this.resize();
	            window.addEventListener('resize', this.handleResize);
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()('.sidebar--right .search-items-container').perfectScrollbar();
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.areObjectsEqual(this.props, nextProps)) {
	                return true;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.areObjectsEqual(this.state, nextState)) {
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.resize();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_search_store_jsx__["a"].removeSearchChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_channel_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChange);
	            this.mounted = false;
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState({
	                windowWidth: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.windowWidth(),
	                windowHeight: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.windowHeight()
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            if (this.mounted) {
	                this.setState(getStateFromStores());
	            }
	        }
	    }, {
	        key: 'onUserChange',
	        value: function onUserChange() {
	            this.setState({ profiles: JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getProfiles())) });
	        }
	    }, {
	        key: 'resize',
	        value: function resize() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()('#search-items-container').scrollTop(0);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var results = this.state.results;
	            var currentId = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentId();
	            var searchForm = null;
	            if (currentId) {
	                searchForm = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__search_bar_jsx__["a"], null);
	            }
	            var noResults = !results || !results.order || !results.order.length;
	            var searchTerm = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_search_store_jsx__["a"].getSearchTerm();
	            var profiles = this.state.profiles || {};
	
	            var ctls = null;
	
	            if (!searchTerm && noResults) {
	                ctls = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'sidebar--right__subheader' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedHTMLMessage"], {
	                        id: 'search_results.usage',
	                        defaultMessage: '<ul><li>Use <b>"quotation marks"</b> to search for phrases</li><li>Use <b>from:</b> to find posts from specific users and <b>in:</b> to find posts in specific channels</li></ul>'
	                    })
	                );
	            } else if (noResults) {
	                ctls = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'sidebar--right__subheader' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'h4',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'search_results.noResults',
	                            defaultMessage: 'NO RESULTS'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedHTMLMessage"], {
	                        id: 'search_results.because',
	                        defaultMessage: '<ul> <li>If you\'re searching a partial phrase (ex. searching "rea", looking for "reach" or "reaction"), append a * to your search term</li> <li>Due to the volume of results, two letter searches and common words like "this", "a" and "is" won\'t appear in search results</li> </ul>'
	                    })
	                );
	            } else {
	                ctls = results.order.map(function mymap(id) {
	                    var post = results.posts[id];
	                    var profile = void 0;
	                    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentId() === post.user_id) {
	                        profile = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_user_store_jsx__["a"].getCurrentUser();
	                    } else {
	                        profile = profiles[post.user_id];
	                    }
	                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15__search_results_item_jsx__["a"], {
	                        key: post.id,
	                        channel: this.state.channels.get(post.channel_id),
	                        post: post,
	                        user: profile,
	                        term: searchTerm,
	                        isMentionSearch: this.props.isMentionSearch
	                    });
	                }, this);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                'div',
	                { className: 'sidebar--right__content' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'search-bar__container sidebar--right__search-header' },
	                    searchForm
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'sidebar-right__body' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__search_results_header_jsx__["a"], { isMentionSearch: this.props.isMentionSearch }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            id: 'search-items-container',
	                            className: 'search-items-container'
	                        },
	                        ctls
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchResults;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SearchResults;
	
	
	SearchResults.propTypes = {
	    isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.bool
	};

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	var SearchResultsHeader = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SearchResultsHeader, _React$Component);
	
	    function SearchResultsHeader(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchResultsHeader);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchResultsHeader).call(this, props));
	
	        _this.handleClose = _this.handleClose.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SearchResultsHeader, [{
	        key: 'handleClose',
	        value: function handleClose(e) {
	            e.preventDefault();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH,
	                results: null
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_SEARCH_TERM,
	                term: null,
	                do_search: false,
	                is_mention_search: false
	            });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                type: ActionTypes.RECEIVED_POST_SELECTED,
	                postId: null
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var title = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                id: 'search_header.results',
	                defaultMessage: 'Search Results'
	            });
	
	            if (this.props.isMentionSearch) {
	                title = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                    id: 'search_header.title2',
	                    defaultMessage: 'Recent Mentions'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                { className: 'sidebar--right__header' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'span',
	                    { className: 'sidebar--right__title' },
	                    title
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'sidebar--right__close',
	                        'aria-label': 'Close',
	                        title: 'Close',
	                        onClick: this.handleClose
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i', { className: 'fa fa-sign-out' })
	                )
	            );
	        }
	    }]);
	
	    return SearchResultsHeader;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SearchResultsHeader;
	
	
	SearchResultsHeader.propTypes = {
	    isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.bool
	};

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_profile_jsx__ = __webpack_require__(160);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router___default = __WEBPACK_IMPORTED_MODULE_15_react_router__ && __WEBPACK_IMPORTED_MODULE_15_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	
	
	var SearchResultsItem = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SearchResultsItem, _React$Component);
	
	    function SearchResultsItem(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchResultsItem);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchResultsItem).call(this, props));
	
	        _this.handleFocusRHSClick = _this.handleFocusRHSClick.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SearchResultsItem, [{
	        key: 'hideSidebar',
	        value: function hideSidebar() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.inner-wrap, .sidebar--right').removeClass('move--left');
	        }
	    }, {
	        key: 'handleFocusRHSClick',
	        value: function handleFocusRHSClick(e) {
	            e.preventDefault();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitPostFocusRightHandSideFromSearch(this.props.post, this.props.isMentionSearch);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var channelName = null;
	            var channel = this.props.channel;
	            var timestamp = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser().update_at;
	            var user = this.props.user || {};
	            var post = this.props.post;
	
	            if (channel) {
	                channelName = channel.display_name;
	                if (channel.type === 'D') {
	                    channelName = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'search_item.direct',
	                        defaultMessage: 'Direct Message'
	                    });
	                }
	            }
	
	            var formattingOptions = {
	                searchTerm: this.props.term,
	                mentionHighlight: this.props.isMentionSearch
	            };
	
	            var overrideUsername = void 0;
	            var disableProfilePopover = false;
	            if (post.props && post.props.from_webhook && post.props.override_username && global.window.mm_config.EnablePostUsernameOverride === 'true') {
	                overrideUsername = post.props.override_username;
	                disableProfilePopover = true;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                { className: 'search-item__container' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'date-separator' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('hr', { className: 'separator__hr' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'separator__text' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedDate"], {
	                            value: post.create_at,
	                            day: 'numeric',
	                            month: 'long',
	                            year: 'numeric'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'post'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'search-channel__name' },
	                        channelName
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'post__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'post__img' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('img', {
	                                src: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.getProfilePicSrcForPost(post, timestamp),
	                                height: '36',
	                                width: '36'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'ul',
	                                { className: 'post__header' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'li',
	                                    { className: 'col__name' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                        'strong',
	                                        null,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__user_profile_jsx__["a"], {
	                                            user: user,
	                                            overwriteName: overrideUsername,
	                                            disablePopover: disableProfilePopover
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'li',
	                                    { className: 'col' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                        'time',
	                                        { className: 'search-item-time' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedDate"], {
	                                            value: post.create_at,
	                                            hour12: !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isMilitaryTime(),
	                                            hour: '2-digit',
	                                            minute: '2-digit'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            onClick: function onClick() {
	                                                if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isMobile()) {
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                                                        type: ActionTypes.RECEIVED_SEARCH,
	                                                        results: null
	                                                    });
	
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                                                        type: ActionTypes.RECEIVED_SEARCH_TERM,
	                                                        term: null,
	                                                        do_search: false,
	                                                        is_mention_search: false
	                                                    });
	
	                                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                                                        type: ActionTypes.RECEIVED_POST_SELECTED,
	                                                        postId: null
	                                                    });
	
	                                                    _this2.hideSidebar();
	                                                }
	                                                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/' + window.location.pathname.split('/')[1] + '/pl/' + post.id);
	                                            },
	                                            className: 'search-item__jump'
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                            id: 'search_item.jump',
	                                            defaultMessage: 'Jump'
	                                        })
	                                    )
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'li',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            href: '#',
	                                            className: 'comment-icon__container search-item__comment',
	                                            onClick: this.handleFocusRHSClick
	                                        },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('span', {
	                                            className: 'comment-icon',
	                                            dangerouslySetInnerHTML: { __html: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].REPLY_ICON }
	                                        })
	                                    )
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'div',
	                                { className: 'search-item-snippet' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('span', {
	                                    onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_text_formatting_jsx__.handleClick,
	                                    dangerouslySetInnerHTML: { __html: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_text_formatting_jsx__.formatText(post.message, formattingOptions) }
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchResultsItem;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SearchResultsItem;
	
	
	SearchResultsItem.propTypes = {
	    post: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    channel: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.bool,
	    term: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.string
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_error_bar_jsx__ = __webpack_require__(187);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router___default = __WEBPACK_IMPORTED_MODULE_13_react_router__ && __WEBPACK_IMPORTED_MODULE_13_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl___default = __WEBPACK_IMPORTED_MODULE_14_react_intl__ && __WEBPACK_IMPORTED_MODULE_14_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __WEBPACK_IMPORTED_MODULE_15_react__ && __WEBPACK_IMPORTED_MODULE_15_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_logo_png__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_logo_png___default = __WEBPACK_IMPORTED_MODULE_16_images_logo_png__ && __WEBPACK_IMPORTED_MODULE_16_images_logo_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_images_logo_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_images_logo_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_images_logo_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_images_logo_png___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var SelectTeam = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(SelectTeam, _React$Component);
	
	    function SelectTeam(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SelectTeam);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SelectTeam).call(this, props));
	
	        _this.onTeamChange = _this.onTeamChange.bind(_this);
	
	        var state = _this.getStateFromStores(false);
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(SelectTeam, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].addChangeListener(this.onTeamChange);
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getAllTeamListings();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].removeChangeListener(this.onTeamChange);
	        }
	    }, {
	        key: 'onTeamChange',
	        value: function onTeamChange() {
	            this.setState(this.getStateFromStores(true));
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores(loaded) {
	            return {
	                teams: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getAll(),
	                teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getTeamMembers(),
	                teamListings: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_team_store_jsx__["a"].getTeamListings(),
	                loaded: loaded
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content;
	
	            var teamContents = [];
	            var isAlreadyMember = new /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
	
	            for (var index in this.state.teamMembers) {
	                if (this.state.teamMembers.hasOwnProperty(index)) {
	                    var teamMember = this.state.teamMembers[index];
	                    var team = this.state.teams[teamMember.team_id];
	                    isAlreadyMember[teamMember.team_id] = true;
	                    teamContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'team_' + team.name,
	                            className: 'signup-team-dir'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["Link"],
	                            {
	                                to: '/' + team.name + '/channels/town-square'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                                'span',
	                                { className: 'signup-team-dir__name' },
	                                team.display_name
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('span', {
	                                className: 'glyphicon glyphicon-menu-right right signup-team-dir__arrow',
	                                'aria-hidden': 'true'
	                            })
	                        )
	                    ));
	                }
	            }
	
	            if (!teamContents || teamContents.length === 0) {
	                teamContents = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-team-dir-err' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_team.no_teams',
	                            defaultMessage: 'You do not appear to be a member of any team.  Please ask your administrator for an invite, join an open team if one exists or possibly create a new team.'
	                        })
	                    )
	                );
	            }
	
	            content = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                'div',
	                { className: 'signup__content' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'h4',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'signup_team.choose',
	                        defaultMessage: 'Teams you are a member of:'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-team-all' },
	                    teamContents
	                )
	            );
	
	            var openTeamContents = [];
	
	            for (var id in this.state.teamListings) {
	                if (this.state.teamListings.hasOwnProperty(id) && !isAlreadyMember[id]) {
	                    var openTeam = this.state.teamListings[id];
	                    openTeamContents.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'team_' + openTeam.name,
	                            className: 'signup-team-dir'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["Link"],
	                            {
	                                to: '/signup_user_complete/?id=' + openTeam.invite_id
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                                'span',
	                                { className: 'signup-team-dir__name' },
	                                openTeam.display_name
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('span', {
	                                className: 'glyphicon glyphicon-menu-right right signup-team-dir__arrow',
	                                'aria-hidden': 'true'
	                            })
	                        )
	                    ));
	                }
	            }
	
	            var openContent;
	            if (openTeamContents.length > 0) {
	                openContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'signup__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'h4',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_team.join_open',
	                            defaultMessage: 'Open teams you can join: '
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team-all' },
	                        openTeamContents
	                    )
	                );
	            }
	
	            if (!this.state.loaded) {
	                openContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_components_loading_screen_jsx__["a"], null);
	            }
	
	            var isSystemAdmin = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.isSystemAdmin(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_user_store_jsx__["a"].getCurrentUser().roles);
	
	            var teamSignUp = void 0;
	            if (isSystemAdmin || global.window.mm_config.EnableTeamCreation === 'true' && !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.isMobileApp()) {
	                teamSignUp = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'margin--extra' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["Link"],
	                        {
	                            to: '/create_team',
	                            className: 'signup-team-login'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.createTeam',
	                            defaultMessage: 'Create a new team'
	                        })
	                    )
	                );
	            }
	
	            var adminConsoleLink = void 0;
	            if (isSystemAdmin) {
	                adminConsoleLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'margin--extra' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["Link"],
	                        {
	                            to: '/admin_console',
	                            className: 'signup-team-login'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.console',
	                            defaultMessage: 'System Console'
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_components_error_bar_jsx__["a"], null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.emitUserLoggedOutEvent
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'navbar_dropdown.logout'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement('img', {
	                            className: 'signup-team-logo',
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_images_logo_png___default.a
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            'h1',
	                            null,
	                            global.window.mm_config.SiteName
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(
	                            'h4',
	                            { className: 'color--light' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'web.root.singup_info'
	                            })
	                        ),
	                        content,
	                        openContent,
	                        teamSignUp,
	                        adminConsoleLink
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectTeam;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SelectTeam;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_8_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_8_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_images_load_gif___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var SettingPicture = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SettingPicture, _React$Component);
	
	    function SettingPicture(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SettingPicture);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SettingPicture).call(this, props));
	
	        _this.setPicture = _this.setPicture.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SettingPicture, [{
	        key: 'setPicture',
	        value: function setPicture(file) {
	            if (file) {
	                var reader = new FileReader();
	
	                var img = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.image);
	                reader.onload = function load(e) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(img).attr('src', e.target.result);
	                };
	
	                reader.readAsDataURL(file);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.picture) {
	                this.setPicture(nextProps.picture);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var clientError = null;
	            if (this.props.client_error) {
	                clientError = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.props.client_error
	                    )
	                );
	            }
	            var serverError = null;
	            if (this.props.server_error) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.props.server_error
	                    )
	                );
	            }
	
	            var img = null;
	            if (this.props.picture) {
	                img = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                    ref: 'image',
	                    className: 'profile-img rounded',
	                    src: ''
	                });
	            } else {
	                img = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                    ref: 'image',
	                    className: 'profile-img rounded',
	                    src: this.props.src
	                });
	            }
	
	            var confirmButton;
	            if (this.props.loadingPicture) {
	                confirmButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                    className: 'spinner',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_images_load_gif___default.a
	                });
	            } else {
	                var confirmButtonClass = 'btn btn-sm';
	                if (this.props.submitActive) {
	                    confirmButtonClass += ' btn-primary';
	                } else {
	                    confirmButtonClass += ' btn-inactive disabled';
	                }
	
	                confirmButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'a',
	                    {
	                        className: confirmButtonClass,
	                        onClick: this.props.submit
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                        id: 'setting_picture.save',
	                        defaultMessage: 'Save'
	                    })
	                );
	            }
	            var helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                id: 'setting_picture.help',
	                defaultMessage: 'Upload a profile picture in either JPG or PNG format, at least {width}px in width and {height}px height.',
	                values: {
	                    width: global.window.mm_config.ProfileWidth,
	                    height: global.window.mm_config.ProfileHeight
	                }
	            });
	
	            var self = this;
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'ul',
	                { className: 'section-max' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'li',
	                    { className: 'col-xs-12 section-title' },
	                    this.props.title
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'li',
	                    { className: 'col-xs-offset-3 col-xs-8' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'ul',
	                        { className: 'setting-list' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'li',
	                            { className: 'setting-list-item' },
	                            img
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'li',
	                            { className: 'setting-list-item' },
	                            helpText
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'li',
	                            { className: 'setting-list-item' },
	                            serverError,
	                            clientError,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                'span',
	                                { className: 'btn btn-sm btn-primary btn-file sel-btn' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                    id: 'setting_picture.select',
	                                    defaultMessage: 'Select'
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('input', {
	                                    ref: 'input',
	                                    accept: '.jpg,.png,.bmp',
	                                    type: 'file',
	                                    onChange: this.props.pictureChange
	                                })
	                            ),
	                            confirmButton,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                                'a',
	                                {
	                                    className: 'btn btn-sm theme',
	                                    href: '#',
	                                    onClick: self.props.updateSection
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                    id: 'setting_picture.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingPicture;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SettingPicture;
	
	
	SettingPicture.propTypes = {
	    client_error: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    server_error: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    picture: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object,
	    loadingPicture: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    submitActive: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    submit: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func,
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    pictureChange: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var SettingsUpload = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SettingsUpload, _React$Component);
	
	    function SettingsUpload(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SettingsUpload);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SettingsUpload).call(this, props));
	
	        _this.doFileSelect = _this.doFileSelect.bind(_this);
	        _this.doSubmit = _this.doSubmit.bind(_this);
	
	        _this.state = {
	            clientError: _this.props.clientError,
	            serverError: _this.props.serverError,
	            filename: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SettingsUpload, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            this.setState({
	                clientError: this.props.clientError,
	                serverError: this.props.serverError
	            });
	        }
	    }, {
	        key: 'doFileSelect',
	        value: function doFileSelect(e) {
	            e.preventDefault();
	            var filename = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).val();
	            if (filename.substring(3, 11) === 'fakepath') {
	                filename = filename.substring(12);
	            }
	            this.setState({
	                clientError: '',
	                serverError: '',
	                filename: filename
	            });
	        }
	    }, {
	        key: 'doSubmit',
	        value: function doSubmit(e) {
	            e.preventDefault();
	            var inputnode = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.uploadinput);
	            if (inputnode.files && inputnode.files[0]) {
	                this.props.submit(inputnode.files[0]);
	            } else {
	                this.setState({ clientError: true });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var clientError = null;
	            if (this.state.clientError) {
	                clientError = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'file-status' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                        id: 'setting_upload.noFile',
	                        defaultMessage: 'No file selected.'
	                    })
	                );
	            }
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'file-status' },
	                    this.state.serverError
	                );
	            }
	            var fileNameText = null;
	            var submitButtonClass = 'btn btn-sm btn-primary disabled';
	            if (this.state.filename) {
	                fileNameText = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'file-status file-name' },
	                    this.state.filename
	                );
	                submitButtonClass = 'btn btn-sm btn-primary';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'ul',
	                { className: 'section-max' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-12 section-title' },
	                    this.props.title
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-offset-3 col-sm-9' },
	                    this.props.helpText
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'li',
	                    { className: 'col-sm-offset-3 col-sm-9' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'ul',
	                        { className: 'setting-list' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'li',
	                            { className: 'setting-list-item' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'span',
	                                { className: 'btn btn-sm btn-primary btn-file sel-btn' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                    id: 'setting_upload.select',
	                                    defaultMessage: 'Select file'
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('input', {
	                                    ref: 'uploadinput',
	                                    accept: this.props.fileTypesAccepted,
	                                    type: 'file',
	                                    onChange: this.doFileSelect
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'a',
	                                {
	                                    className: submitButtonClass,
	                                    onClick: this.doSubmit
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                    id: 'setting_upload.import',
	                                    defaultMessage: 'Import'
	                                })
	                            ),
	                            fileNameText,
	                            serverError,
	                            clientError
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsUpload;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SettingsUpload;
	
	
	SettingsUpload.propTypes = {
	    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string.isRequired,
	    submit: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func.isRequired,
	    fileTypesAccepted: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string.isRequired,
	    clientError: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string,
	    serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.string,
	    helpText: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object
	};

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router___default = __WEBPACK_IMPORTED_MODULE_8_react_router__ && __WEBPACK_IMPORTED_MODULE_8_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var ShouldVerifyEmail = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ShouldVerifyEmail, _React$Component);
	
	    function ShouldVerifyEmail(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ShouldVerifyEmail);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ShouldVerifyEmail).call(this, props));
	
	        _this.handleResend = _this.handleResend.bind(_this);
	
	        _this.state = {
	            resendStatus: 'none'
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ShouldVerifyEmail, [{
	        key: 'handleResend',
	        value: function handleResend() {
	            var _this2 = this;
	
	            var email = this.props.location.query.email;
	
	            this.setState({ resendStatus: 'sending' });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].resendVerification(email, function () {
	                _this2.setState({ resendStatus: 'success' });
	            }, function () {
	                _this2.setState({ resendStatus: 'failure' });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var resendConfirm = '';
	            if (this.state.resendStatus === 'success') {
	                resendConfirm = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        { className: 'alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'email_verify.sent',
	                            defaultMessage: ' Verification email sent.'
	                        })
	                    )
	                );
	            }
	
	            if (this.state.resendStatus === 'failure') {
	                resendConfirm = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        { className: 'alert alert-danger' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'fa fa-times' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], { id: 'email_verify.failed' })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                        { to: '/' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'web.header.back'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'h3',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                                id: 'email_verify.almost',
	                                defaultMessage: '{siteName}: You are almost done',
	                                values: {
	                                    siteName: global.window.mm_config.SiteName
	                                }
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'p',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                                    id: 'email_verify.notVerifiedBody',
	                                    defaultMessage: 'Please verify your email address. Check your inbox for an email.'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'button',
	                                {
	                                    onClick: this.handleResend,
	                                    className: 'btn btn-primary'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                                    id: 'email_verify.resend',
	                                    defaultMessage: 'Resend Email'
	                                })
	                            ),
	                            resendConfirm
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ShouldVerifyEmail;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ShouldVerifyEmail;
	
	
	ShouldVerifyEmail.defaultProps = {};
	ShouldVerifyEmail.propTypes = {
	    location: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __WEBPACK_IMPORTED_MODULE_11_jquery__ && __WEBPACK_IMPORTED_MODULE_11_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __WEBPACK_IMPORTED_MODULE_12_react_dom__ && __WEBPACK_IMPORTED_MODULE_12_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__new_channel_flow_jsx__ = __webpack_require__(364);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__more_direct_channels_jsx__ = __webpack_require__(713);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sidebar_header_jsx__ = __webpack_require__(748);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__unread_channel_indicator_jsx__ = __webpack_require__(767);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tutorial_tutorial_tip_jsx__ = __webpack_require__(189);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_intl___default = __WEBPACK_IMPORTED_MODULE_25_react_intl__ && __WEBPACK_IMPORTED_MODULE_25_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_25_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_25_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_25_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_25_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_26_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_26_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_26_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_27_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_27_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_27_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_27_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_27_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_27_images_load_gif___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __WEBPACK_IMPORTED_MODULE_28_react__ && __WEBPACK_IMPORTED_MODULE_28_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_28_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_28_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_28_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_28_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_router___default = __WEBPACK_IMPORTED_MODULE_29_react_router__ && __WEBPACK_IMPORTED_MODULE_29_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_29_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_29_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_29_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_29_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png__ = __webpack_require__(808);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png___default = __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png__ && __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png__ = __webpack_require__(809);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png___default = __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png__ && __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].Preferences;
	var TutorialSteps = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].TutorialSteps;
	
	
	
	
	
	
	
	
	
	
	var Sidebar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default.a.bind()(Sidebar, _React$Component);
	
	    function Sidebar(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default.a.bind()(this, Sidebar);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(Sidebar).call(this, props));
	
	        _this.badgesActive = false;
	        _this.firstUnreadChannel = null;
	        _this.lastUnreadChannel = null;
	
	        _this.getStateFromStores = _this.getStateFromStores.bind(_this);
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onScroll = _this.onScroll.bind(_this);
	        _this.updateUnreadIndicators = _this.updateUnreadIndicators.bind(_this);
	        _this.handleLeaveDirectChannel = _this.handleLeaveDirectChannel.bind(_this);
	
	        _this.showMoreChannelsModal = _this.showMoreChannelsModal.bind(_this);
	        _this.showNewChannelModal = _this.showNewChannelModal.bind(_this);
	        _this.hideNewChannelModal = _this.hideNewChannelModal.bind(_this);
	        _this.showMoreDirectChannelsModal = _this.showMoreDirectChannelsModal.bind(_this);
	        _this.hideMoreDirectChannelsModal = _this.hideMoreDirectChannelsModal.bind(_this);
	
	        _this.createChannelElement = _this.createChannelElement.bind(_this);
	        _this.updateTitle = _this.updateTitle.bind(_this);
	
	        _this.isLeaving = new /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();
	
	        var state = _this.getStateFromStores();
	        state.newChannelModalType = '';
	        state.showDirectChannelsModal = false;
	        state.loadingDMChannel = -1;
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default.a.bind()(Sidebar, [{
	        key: 'getTotalUnreadCount',
	        value: function getTotalUnreadCount() {
	            var msgs = 0;
	            var mentions = 0;
	            var unreadCounts = this.state.unreadCounts;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default.a.bind()(unreadCounts).forEach(function (chId) {
	                msgs += unreadCounts[chId].msgs;
	                mentions += unreadCounts[chId].mentions;
	            });
	
	            return { msgs: msgs, mentions: mentions };
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var members = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getAllMembers();
	            var currentChannelId = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getCurrentId();
	            var currentUserId = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getCurrentId();
	
	            var channels = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.bind()([], /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getAll());
	            channels.sort(function (a, b) {
	                return a.display_name.localeCompare(b.display_name);
	            });
	
	            var publicChannels = channels.filter(function (channel) {
	                return channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].OPEN_CHANNEL;
	            });
	            var privateChannels = channels.filter(function (channel) {
	                return channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].PRIVATE_CHANNEL;
	            });
	
	            var preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_stores_preference_store_jsx__["a"].getCategory(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].Preferences.CATEGORY_DIRECT_CHANNEL_SHOW);
	
	            var directChannels = [];
	            var directNonTeamChannels = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(preferences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	                    var name = _step$value[0];
	                    var value = _step$value[1];
	
	                    if (value !== 'true') {
	                        continue;
	                    }
	
	                    var teammateId = name;
	
	                    var directChannel = channels.find(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__.isDirectChannelForUser.bind(null, teammateId));
	
	                    // a direct channel doesn't exist yet so create a fake one
	                    if (directChannel == null) {
	                        directChannel = {
	                            name: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__.getDirectChannelName(currentUserId, teammateId),
	                            last_post_at: 0,
	                            total_msg_count: 0,
	                            type: /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].DM_CHANNEL,
	                            fake: true
	                        };
	                    } else {
	                        directChannel = JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(directChannel));
	                    }
	
	                    directChannel.display_name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__.displayUsername(teammateId);
	                    directChannel.teammate_id = teammateId;
	                    directChannel.status = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getStatus(teammateId);
	
	                    if (/* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].hasTeamProfile(teammateId)) {
	                        directChannels.push(directChannel);
	                    } else {
	                        directNonTeamChannels.push(directChannel);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            directChannels.sort(this.sortChannelsByDisplayName);
	            directNonTeamChannels.sort(this.sortChannelsByDisplayName);
	
	            var tutorialStep = /* harmony import */__WEBPACK_IMPORTED_MODULE_21_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getCurrentId(), 999);
	
	            return {
	                activeId: currentChannelId,
	                members: members,
	                publicChannels: publicChannels,
	                privateChannels: privateChannels,
	                directChannels: directChannels,
	                directNonTeamChannels: directNonTeamChannels,
	                unreadCounts: JSON.parse(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getUnreadCounts())),
	                showTutorialTip: tutorialStep === TutorialSteps.CHANNEL_POPOVER,
	                currentTeam: /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].getCurrent(),
	                currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].getCurrentUser(),
	                townSquare: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getByName(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].DEFAULT_CHANNEL),
	                offTopic: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getByName(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].OFFTOPIC_CHANNEL)
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].addStatusesChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].addChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_21_stores_preference_store_jsx__["a"].addChangeListener(this.onChange);
	
	            this.updateTitle();
	            this.updateUnreadIndicators();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__.areObjectsEqual(nextState, this.state)) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            this.updateTitle();
	            this.updateUnreadIndicators();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()('.sidebar--left .nav-pills__container').perfectScrollbar();
	            }
	
	            // close the LHS on mobile when you change channels
	            if (this.state.activeId !== prevState.activeId) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()('.app__body .inner-wrap').removeClass('move--right');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()('.app__body .sidebar--left').removeClass('move--right');
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_stores_user_store_jsx__["a"].removeStatusesChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_20_stores_team_store_jsx__["a"].removeChangeListener(this.onChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_21_stores_preference_store_jsx__["a"].removeChangeListener(this.onChange);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            this.setState(this.getStateFromStores());
	        }
	    }, {
	        key: 'updateTitle',
	        value: function updateTitle() {
	            var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_stores_channel_store_jsx__["a"].getCurrent();
	            if (channel && this.state.currentTeam) {
	                var currentSiteName = '';
	                if (global.window.mm_config.SiteName != null) {
	                    currentSiteName = global.window.mm_config.SiteName;
	                }
	
	                var currentChannelName = channel.display_name;
	                if (channel.type === 'D') {
	                    var teammate = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_23_utils_utils_jsx__.getDirectTeammate(channel.id);
	                    if (teammate != null) {
	                        currentChannelName = teammate.username;
	                    }
	                }
	
	                var unread = this.getTotalUnreadCount();
	                var mentionTitle = unread.mentions > 0 ? '(' + unread.mentions + ') ' : '';
	                var unreadTitle = unread.msgs > 0 ? '* ' : '';
	                document.title = mentionTitle + unreadTitle + currentChannelName + ' - ' + this.state.currentTeam.display_name + ' ' + currentSiteName;
	            }
	        }
	    }, {
	        key: 'onScroll',
	        value: function onScroll() {
	            this.updateUnreadIndicators();
	        }
	    }, {
	        key: 'updateUnreadIndicators',
	        value: function updateUnreadIndicators() {
	            var container = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.refs.container));
	
	            var showTopUnread = false;
	            var showBottomUnread = false;
	
	            if (this.firstUnreadChannel) {
	                var firstUnreadElement = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.refs[this.firstUnreadChannel]));
	
	                if (firstUnreadElement.position().top + firstUnreadElement.height() < 0) {
	                    showTopUnread = true;
	                }
	            }
	
	            if (this.lastUnreadChannel) {
	                var lastUnreadElement = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.refs[this.lastUnreadChannel]));
	
	                if (lastUnreadElement.position().top > container.height()) {
	                    showBottomUnread = true;
	                }
	            }
	
	            this.setState({
	                showTopUnread: showTopUnread,
	                showBottomUnread: showBottomUnread
	            });
	        }
	    }, {
	        key: 'handleLeaveDirectChannel',
	        value: function handleLeaveDirectChannel(e, channel) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            if (!this.isLeaving.get(channel.id)) {
	                this.isLeaving.set(channel.id, true);
	
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_22_utils_async_client_jsx__.savePreference(/* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].Preferences.CATEGORY_DIRECT_CHANNEL_SHOW, channel.teammate_id, 'false', function () {
	                    _this2.isLeaving.set(channel.id, false);
	                }, function () {
	                    _this2.isLeaving.set(channel.id, false);
	                });
	
	                this.setState(this.getStateFromStores());
	            }
	
	            if (channel.id === this.state.activeId) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_29_react_router__["browserHistory"].push('/' + this.state.currentTeam.name + '/channels/town-square');
	            }
	        }
	    }, {
	        key: 'sortChannelsByDisplayName',
	        value: function sortChannelsByDisplayName(a, b) {
	            return a.display_name.localeCompare(b.display_name);
	        }
	    }, {
	        key: 'showMoreChannelsModal',
	        value: function showMoreChannelsModal() {
	            // manually show the modal because using data-toggle messes with keyboard focus when the modal is dismissed
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.bind()('#more_channels').modal({ 'data-channeltype': 'O' }).modal('show');
	        }
	    }, {
	        key: 'showNewChannelModal',
	        value: function showNewChannelModal(type) {
	            this.setState({ newChannelModalType: type });
	        }
	    }, {
	        key: 'hideNewChannelModal',
	        value: function hideNewChannelModal() {
	            this.setState({ newChannelModalType: '' });
	        }
	    }, {
	        key: 'showMoreDirectChannelsModal',
	        value: function showMoreDirectChannelsModal() {
	            this.setState({ showDirectChannelsModal: true });
	        }
	    }, {
	        key: 'hideMoreDirectChannelsModal',
	        value: function hideMoreDirectChannelsModal() {
	            this.setState({ showDirectChannelsModal: false });
	        }
	    }, {
	        key: 'createTutorialTip',
	        value: function createTutorialTip() {
	            var screens = [];
	
	            var townSquareDisplayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].DEFAULT_CHANNEL_UI_NAME;
	            if (this.state.townSquare) {
	                townSquareDisplayName = this.state.townSquare.display_name;
	            }
	
	            var offTopicDisplayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].OFFTOPIC_CHANNEL_UI_NAME;
	            if (this.state.offTopic) {
	                offTopicDisplayName = this.state.offTopic.display_name;
	            }
	
	            screens.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedHTMLMessage"], {
	                    id: 'sidebar.tutorialScreen1',
	                    defaultMessage: '<h4>Channels</h4><p><strong>Channels</strong> organize conversations across different topics. They’re open to everyone on your team. To send private communications use <strong>Direct Messages</strong> for a single person or <strong>Private Groups</strong> for multiple people.</p>'
	                })
	            ));
	
	            screens.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedHTMLMessage"], {
	                    id: 'sidebar.tutorialScreen2',
	                    defaultMessage: '<h4>"{townsquare}" and "{offtopic}" channels</h4> <p>Here are two public channels to start:</p> <p><strong>{townsquare}</strong> is a place for team-wide communication. Everyone in your team is a member of this channel.</p> <p><strong>{offtopic}</strong> is a place for fun and humor outside of work-related channels. You and your team can decide what other channels to create.</p>',
	                    values: {
	                        townsquare: townSquareDisplayName,
	                        offtopic: offTopicDisplayName
	                    }
	                })
	            ));
	
	            screens.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedHTMLMessage"], {
	                    id: 'sidebar.tutorialScreen3',
	                    defaultMessage: '<h4>Creating and Joining Channels</h4> <p>Click <strong>"More..."</strong> to create a new channel or join an existing one.</p> <p>You can also create a new channel or private group by clicking the <strong>"+" symbol</strong> next to the channel or private group header.</p>'
	                })
	            ));
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17__tutorial_tutorial_tip_jsx__["b"], {
	                placement: 'right',
	                screens: screens,
	                overlayClass: 'tip-overlay--sidebar'
	            });
	        }
	    }, {
	        key: 'createChannelElement',
	        value: function createChannelElement(channel, index, arr, handleClose) {
	            var members = this.state.members;
	            var activeId = this.state.activeId;
	            var channelMember = members[channel.id];
	            var unreadCount = this.state.unreadCounts[channel.id] || { msgs: 0, mentions: 0 };
	            var msgCount = void 0;
	
	            var linkClass = '';
	            if (channel.id === activeId) {
	                linkClass = 'active';
	            }
	
	            var rowClass = 'sidebar-channel';
	
	            var unread = false;
	            if (channelMember) {
	                msgCount = unreadCount.msgs + unreadCount.mentions;
	                unread = msgCount > 0 || channelMember.mention_count > 0;
	            }
	
	            if (unread) {
	                rowClass += ' unread-title';
	
	                if (channel.id !== activeId) {
	                    if (!this.firstUnreadChannel) {
	                        this.firstUnreadChannel = channel.name;
	                    }
	                    this.lastUnreadChannel = channel.name;
	                }
	            }
	
	            var badge = null;
	            if (channelMember) {
	                if (unreadCount.mentions) {
	                    badge = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'span',
	                        { className: 'badge pull-right small' },
	                        unreadCount.mentions
	                    );
	                    this.badgesActive = true;
	                }
	            } else if (this.state.loadingDMChannel === index && channel.type === 'D') {
	                badge = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('img', {
	                    className: 'channel-loading-gif pull-right',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_27_images_load_gif___default.a
	                });
	            }
	
	            if (msgCount > 0) {
	                rowClass += ' has-badge';
	            }
	
	            // set up status icon for direct message channels
	            var status = null;
	            if (channel.type === 'D') {
	                var statusIcon = '';
	                if (channel.status === 'online') {
	                    statusIcon = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].ONLINE_ICON_SVG;
	                } else if (channel.status === 'away') {
	                    statusIcon = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].AWAY_ICON_SVG;
	                } else {
	                    statusIcon = /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].OFFLINE_ICON_SVG;
	                }
	                status = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('span', {
	                    className: 'status',
	                    dangerouslySetInnerHTML: { __html: statusIcon }
	                });
	            }
	
	            var icon = null;
	            if (channel.type === 'O') {
	                icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'div',
	                    { className: 'status' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('i', { className: 'fa fa-globe' })
	                );
	            } else if (channel.type === 'P') {
	                icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'div',
	                    { className: 'status' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('i', { className: 'fa fa-lock' })
	                );
	            }
	
	            var closeButton = null;
	            var removeTooltip = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["Tooltip"],
	                { id: 'remove-dm-tooltip' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                    id: 'sidebar.removeList',
	                    defaultMessage: 'Remove from list'
	                })
	            );
	            if (handleClose && !badge) {
	                closeButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["OverlayTrigger"],
	                    {
	                        delayShow: 1000,
	                        placement: 'top',
	                        overlay: removeTooltip
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'span',
	                        {
	                            onClick: function onClick(e) {
	                                return handleClose(e, channel);
	                            },
	                            className: 'btn-close'
	                        },
	                        '×'
	                    )
	                );
	
	                rowClass += ' has-close';
	            }
	
	            var tutorialTip = null;
	            if (this.state.showTutorialTip && channel.name === /* harmony import */__WEBPACK_IMPORTED_MODULE_24_utils_constants_jsx__["a"].DEFAULT_CHANNEL) {
	                tutorialTip = this.createTutorialTip();
	            }
	
	            var link = '';
	            if (channel.fake) {
	                link = '/' + this.state.currentTeam.name + '/channels/' + channel.name + '?fakechannel=' + encodeURIComponent(/* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a.bind()(channel));
	            } else {
	                link = '/' + this.state.currentTeam.name + '/channels/' + channel.name;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'li',
	                {
	                    key: channel.name,
	                    ref: channel.name,
	                    className: linkClass
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_29_react_router__["Link"],
	                    {
	                        to: link,
	                        className: rowClass
	                    },
	                    icon,
	                    status,
	                    channel.display_name,
	                    badge,
	                    closeButton
	                ),
	                tutorialTip
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            // Check if we have all info needed to render
	            if (this.state.currentTeam == null || this.state.currentUser == null) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement('div', null);
	            }
	
	            this.lastBadgesActive = this.badgesActive;
	            this.badgesActive = false;
	
	            // keep track of the first and last unread channels so we can use them to set the unread indicators
	            this.firstUnreadChannel = null;
	            this.lastUnreadChannel = null;
	
	            // create elements for all 3 types of channels
	            var publicChannelItems = this.state.publicChannels.map(this.createChannelElement);
	
	            var privateChannelItems = this.state.privateChannels.map(this.createChannelElement);
	
	            var directMessageItems = this.state.directChannels.map(function (channel, index, arr) {
	                return _this3.createChannelElement(channel, index, arr, _this3.handleLeaveDirectChannel);
	            });
	
	            var directMessageNonTeamItems = this.state.directNonTeamChannels.map(function (channel, index, arr) {
	                return _this3.createChannelElement(channel, index, arr, _this3.handleLeaveDirectChannel);
	            });
	
	            var directDivider = void 0;
	            if (directMessageNonTeamItems.length !== 0) {
	                directDivider = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'div',
	                    { className: 'sidebar__divider' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'div',
	                        { className: 'sidebar__divider__text' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                            id: 'sidebar.otherMembers',
	                            defaultMessage: 'Outside this team'
	                        })
	                    )
	                );
	            }
	
	            // update the favicon to show if there are any notifications
	            if (this.lastBadgesActive !== this.badgesActive) {
	                var link = document.createElement('link');
	                link.type = 'image/x-icon';
	                link.rel = 'shortcut icon';
	                link.id = 'favicon';
	                if (this.badgesActive) {
	                    link.href = /* harmony import */__WEBPACK_IMPORTED_MODULE_31_images_favicon_redfavicon_16x16_png___default.a;
	                } else {
	                    link.href = /* harmony import */__WEBPACK_IMPORTED_MODULE_30_images_favicon_favicon_16x16_png___default.a;
	                }
	                var head = document.getElementsByTagName('head')[0];
	                var oldLink = document.getElementById('favicon');
	                if (oldLink) {
	                    head.removeChild(oldLink);
	                }
	                head.appendChild(link);
	            }
	
	            var directMessageMore = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'li',
	                { key: 'more' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        onClick: this.showMoreDirectChannelsModal
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                        id: 'sidebar.more',
	                        defaultMessage: 'More'
	                    })
	                )
	            );
	
	            var showChannelModal = false;
	            if (this.state.newChannelModalType !== '') {
	                showChannelModal = true;
	            }
	
	            var createChannelTootlip = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["Tooltip"],
	                { id: 'new-channel-tooltip' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                    id: 'sidebar.createChannel',
	                    defaultMessage: 'Create new channel'
	                })
	            );
	            var createGroupTootlip = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["Tooltip"],
	                { id: 'new-group-tooltip' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                    id: 'sidebar.createGroup',
	                    defaultMessage: 'Create new group'
	                })
	            );
	
	            var above = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                id: 'sidebar.unreadAbove',
	                defaultMessage: 'Unread post(s) above'
	            });
	
	            var below = /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                id: 'sidebar.unreadBelow',
	                defaultMessage: 'Unread post(s) below'
	            });
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                'div',
	                {
	                    className: 'sidebar--left',
	                    id: 'sidebar-left',
	                    key: 'sidebar-left'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13__new_channel_flow_jsx__["a"], {
	                    show: showChannelModal,
	                    channelType: this.state.newChannelModalType,
	                    onModalDismissed: this.hideNewChannelModal
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__more_direct_channels_jsx__["a"], {
	                    show: this.state.showDirectChannelsModal,
	                    onModalDismissed: this.hideMoreDirectChannelsModal
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15__sidebar_header_jsx__["a"], {
	                    teamDisplayName: this.state.currentTeam.display_name,
	                    teamName: this.state.currentTeam.name,
	                    teamType: this.state.currentTeam.type,
	                    currentUser: this.state.currentUser
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16__unread_channel_indicator_jsx__["a"], {
	                    show: this.state.showTopUnread,
	                    extraClass: 'nav-pills__unread-indicator-top',
	                    text: above
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16__unread_channel_indicator_jsx__["a"], {
	                    show: this.state.showBottomUnread,
	                    extraClass: 'nav-pills__unread-indicator-bottom',
	                    text: below
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'container',
	                        className: 'nav-pills__container',
	                        onScroll: this.onScroll
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'ul',
	                        { className: 'nav nav-pills nav-stacked' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                'h4',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar.channels',
	                                    defaultMessage: 'Channels'
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["OverlayTrigger"],
	                                    {
	                                        delayShow: 500,
	                                        placement: 'top',
	                                        overlay: createChannelTootlip
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            className: 'add-channel-btn',
	                                            href: '#',
	                                            onClick: this.showNewChannelModal.bind(this, 'O')
	                                        },
	                                        '+'
	                                    )
	                                )
	                            )
	                        ),
	                        publicChannelItems,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    className: 'nav-more',
	                                    onClick: this.showMoreChannelsModal
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar.moreElips',
	                                    defaultMessage: 'More...'
	                                })
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'ul',
	                        { className: 'nav nav-pills nav-stacked' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                'h4',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar.pg',
	                                    defaultMessage: 'Private Groups'
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_26_react_bootstrap__["OverlayTrigger"],
	                                    {
	                                        delayShow: 500,
	                                        placement: 'top',
	                                        overlay: createGroupTootlip
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                        'a',
	                                        {
	                                            className: 'add-channel-btn',
	                                            href: '#',
	                                            onClick: this.showNewChannelModal.bind(this, 'P')
	                                        },
	                                        '+'
	                                    )
	                                )
	                            )
	                        ),
	                        privateChannelItems
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                        'ul',
	                        { className: 'nav nav-pills nav-stacked' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(
	                                'h4',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_25_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar.direct',
	                                    defaultMessage: 'Direct Messages'
	                                })
	                            )
	                        ),
	                        directMessageItems,
	                        directDivider,
	                        directMessageNonTeamItems,
	                        directMessageMore
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Sidebar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = Sidebar;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbar_dropdown_jsx__ = __webpack_require__(715);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_tutorial_tutorial_tip_jsx__ = __webpack_require__(189);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].Preferences;
	var TutorialSteps = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].TutorialSteps;
	
	
	
	
	
	
	
	var SidebarHeader = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SidebarHeader, _React$Component);
	
	    function SidebarHeader(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SidebarHeader);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SidebarHeader).call(this, props));
	
	        _this.toggleDropdown = _this.toggleDropdown.bind(_this);
	        _this.onPreferenceChange = _this.onPreferenceChange.bind(_this);
	
	        _this.state = _this.getStateFromStores();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SidebarHeader, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__["a"].addChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__["a"].removeChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var tutorialStep = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, this.props.currentUser.id, 999);
	
	            return { showTutorialTip: tutorialStep === TutorialSteps.MENU_POPOVER && !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.isMobile() };
	        }
	    }, {
	        key: 'onPreferenceChange',
	        value: function onPreferenceChange() {
	            this.setState(this.getStateFromStores());
	        }
	    }, {
	        key: 'toggleDropdown',
	        value: function toggleDropdown(e) {
	            e.preventDefault();
	            if (this.refs.dropdown.blockToggle) {
	                this.refs.dropdown.blockToggle = false;
	                return;
	            }
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.team__header').find('.dropdown-toggle').dropdown('toggle');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var me = this.props.currentUser;
	            var profilePicture = null;
	
	            if (!me) {
	                return null;
	            }
	
	            if (me.last_picture_update) {
	                profilePicture = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('img', {
	                    className: 'user__picture',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].getUsersRoute() + '/' + me.id + '/image?time=' + me.update_at
	                });
	            }
	
	            var tutorialTip = null;
	            if (this.state.showTutorialTip) {
	                tutorialTip = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_components_tutorial_tutorial_tip_jsx__["a"].bind()(this.toggleDropdown);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { className: 'team__header theme' },
	                tutorialTip,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        onClick: this.toggleDropdown
	                    },
	                    profilePicture,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'div',
	                        { className: 'header__info' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            'div',
	                            { className: 'user__name' },
	                            '@' + me.username
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["OverlayTrigger"],
	                            {
	                                trigger: ['hover', 'focus'],
	                                delayShow: 1000,
	                                placement: 'bottom',
	                                overlay: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["Tooltip"],
	                                    { id: 'team-name__tooltip' },
	                                    this.props.teamDisplayName
	                                ),
	                                ref: 'descriptionOverlay'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                                'div',
	                                { className: 'team__name' },
	                                this.props.teamDisplayName
	                            )
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__navbar_dropdown_jsx__["a"], {
	                    ref: 'dropdown',
	                    teamType: this.props.teamType,
	                    teamDisplayName: this.props.teamDisplayName,
	                    teamName: this.props.teamName,
	                    currentUser: this.props.currentUser
	                })
	            );
	        }
	    }]);
	
	    return SidebarHeader;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SidebarHeader;
	
	
	SidebarHeader.defaultProps = {
	    teamDisplayName: '',
	    teamType: ''
	};
	SidebarHeader.propTypes = {
	    teamDisplayName: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    teamName: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    teamType: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object
	};

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__search_results_jsx__ = __webpack_require__(740);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rhs_thread_jsx__ = __webpack_require__(738);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__ = __webpack_require__(161);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	var SIDEBAR_SCROLL_DELAY = 500;
	
	
	
	var SidebarRight = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SidebarRight, _React$Component);
	
	    function SidebarRight(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SidebarRight);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SidebarRight).call(this, props));
	
	        _this.plScrolledToBottom = true;
	
	        _this.onSelectedChange = _this.onSelectedChange.bind(_this);
	        _this.onSearchChange = _this.onSearchChange.bind(_this);
	        _this.onUserChange = _this.onUserChange.bind(_this);
	        _this.onShowSearch = _this.onShowSearch.bind(_this);
	
	        _this.doStrangeThings = _this.doStrangeThings.bind(_this);
	
	        _this.state = {
	            searchVisible: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].getSearchResults() !== null,
	            isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].getIsMentionSearch(),
	            postRightVisible: !!/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].getSelectedPost(),
	            fromSearch: false,
	            currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser()
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SidebarRight, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].addSearchChangeListener(this.onSearchChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].addSelectedPostChangeListener(this.onSelectedChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].addShowSearchListener(this.onShowSearch);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].addChangeListener(this.onUserChange);
	            this.doStrangeThings();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].removeSearchChangeListener(this.onSearchChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].removeSelectedPostChangeListener(this.onSelectedChange);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].removeShowSearchListener(this.onShowSearch);
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].removeChangeListener(this.onUserChange);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.areObjectsEqual(nextState, this.state);
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            var isOpen = this.state.searchVisible || this.state.postRightVisible;
	            var willOpen = nextState.searchVisible || nextState.postRightVisible;
	
	            if (!isOpen && willOpen) {
	                setTimeout(function () {
	                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].jumpPostsViewSidebarOpen();
	                }, SIDEBAR_SCROLL_DELAY);
	            }
	        }
	    }, {
	        key: 'doStrangeThings',
	        value: function doStrangeThings() {
	            // We should have a better way to do this stuff
	            // Hence the function name.
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .inner-wrap').removeClass('.move--right');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .inner-wrap').addClass('move--left');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--left').removeClass('move--right');
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--right').addClass('move--left');
	
	            //$('.sidebar--right').prepend('<div class="sidebar__overlay"></div>');
	            if (!this.state.searchVisible && !this.state.postRightVisible) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .inner-wrap').removeClass('move--left').removeClass('move--right');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.app__body .sidebar--right').removeClass('move--left');
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', null);
	            }
	
	            /*setTimeout(() => {
	                $('.sidebar__overlay').fadeOut('200', () => {
	                    $('.sidebar__overlay').remove();
	                });
	                }, 500);*/
	            return null;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.doStrangeThings();
	        }
	    }, {
	        key: 'onSelectedChange',
	        value: function onSelectedChange(fromSearch) {
	            this.setState({
	                postRightVisible: !!/* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_post_store_jsx__["a"].getSelectedPost(),
	                fromSearch: fromSearch
	            });
	        }
	    }, {
	        key: 'onSearchChange',
	        value: function onSearchChange() {
	            this.setState({
	                searchVisible: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].getSearchResults() !== null,
	                isMentionSearch: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_search_store_jsx__["a"].getIsMentionSearch()
	            });
	        }
	    }, {
	        key: 'onUserChange',
	        value: function onUserChange() {
	            this.setState({
	                currentUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser()
	            });
	        }
	    }, {
	        key: 'onShowSearch',
	        value: function onShowSearch() {
	            if (!this.state.searchVisible) {
	                this.setState({
	                    searchVisible: true
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var content = null;
	
	            if (this.state.searchVisible) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__search_results_jsx__["a"], { isMentionSearch: this.state.isMentionSearch });
	            } else if (this.state.postRightVisible) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__rhs_thread_jsx__["a"], {
	                    fromSearch: this.state.fromSearch,
	                    isMentionSearch: this.state.isMentionSearch,
	                    currentUser: this.state.currentUser
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                'div',
	                {
	                    className: 'sidebar--right',
	                    id: 'sidebar-right'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'sidebar-right-container' },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return SidebarRight;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SidebarRight;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__team_members_modal_jsx__ = __webpack_require__(372);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toggle_modal_button_jsx__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_settings_user_settings_modal_jsx__ = __webpack_require__(373);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__about_build_modal_jsx__ = __webpack_require__(344);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __WEBPACK_IMPORTED_MODULE_15_react_intl__ && __WEBPACK_IMPORTED_MODULE_15_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_router___default = __WEBPACK_IMPORTED_MODULE_16_react_router__ && __WEBPACK_IMPORTED_MODULE_16_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_tutorial_tutorial_tip_jsx__ = __webpack_require__(189);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __WEBPACK_IMPORTED_MODULE_18_react__ && __WEBPACK_IMPORTED_MODULE_18_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__["a"].Preferences;
	var TutorialSteps = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_constants_jsx__["a"].TutorialSteps;
	
	
	
	
	
	
	
	
	var SidebarRightMenu = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(SidebarRightMenu, _React$Component);
	
	    function SidebarRightMenu(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SidebarRightMenu);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SidebarRightMenu).call(this, props));
	
	        _this.onPreferenceChange = _this.onPreferenceChange.bind(_this);
	        _this.handleAboutModal = _this.handleAboutModal.bind(_this);
	        _this.aboutModalDismissed = _this.aboutModalDismissed.bind(_this);
	
	        var state = _this.getStateFromStores();
	        state.showUserSettingsModal = false;
	        state.showAboutModal = false;
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	
	        _this.state = state;
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(SidebarRightMenu, [{
	        key: 'handleAboutModal',
	        value: function handleAboutModal() {
	            this.setState({ showAboutModal: true });
	        }
	    }, {
	        key: 'aboutModalDismissed',
	        value: function aboutModalDismissed() {
	            this.setState({ showAboutModal: false });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].addChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].removeChangeListener(this.onPreferenceChange);
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var tutorialStep = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentId(), 999);
	
	            return { showTutorialTip: tutorialStep === TutorialSteps.MENU_POPOVER && /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isMobile() };
	        }
	    }, {
	        key: 'onPreferenceChange',
	        value: function onPreferenceChange() {
	            this.setState(this.getStateFromStores());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var teamLink = '';
	            var inviteLink = '';
	            var teamSettingsLink = '';
	            var manageLink = '';
	            var consoleLink = '';
	            var currentUser = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentUser();
	            var isAdmin = false;
	            var isSystemAdmin = false;
	
	            if (currentUser != null) {
	                isAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].isTeamAdminForCurrentTeam() || /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	                isSystemAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].isSystemAdminForCurrentUser();
	
	                inviteLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.showInviteMemberModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-user-plus' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'sidebar_right_menu.inviteNew',
	                            defaultMessage: 'Invite New Member'
	                        })
	                    )
	                );
	
	                if (this.props.teamType === 'O') {
	                    teamLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'li',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'a',
	                            {
	                                href: '#',
	                                onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.showGetTeamInviteLinkModal
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'glyphicon glyphicon-link' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'sidebar_right_menu.teamLink',
	                                defaultMessage: 'Get Team Invite Link'
	                            })
	                        )
	                    );
	                }
	            }
	
	            if (isAdmin) {
	                teamSettingsLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            'data-toggle': 'modal',
	                            'data-target': '#team_settings'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-globe' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'sidebar_right_menu.teamSettings',
	                            defaultMessage: 'Team Settings'
	                        })
	                    )
	                );
	                manageLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6__toggle_modal_button_jsx__["a"],
	                        { dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_5__team_members_modal_jsx__["a"] },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-users' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'sidebar_right_menu.manageMembers',
	                            defaultMessage: 'Manage Members'
	                        })
	                    )
	                );
	            }
	
	            if (isSystemAdmin && !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_13_utils_utils_jsx__.isMobile()) {
	                consoleLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["Link"],
	                        {
	                            to: '/admin_console'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-wrench' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'sidebar_right_menu.console',
	                            defaultMessage: 'System Console'
	                        })
	                    )
	                );
	            }
	
	            var siteName = '';
	            if (global.window.mm_config.SiteName != null) {
	                siteName = global.window.mm_config.SiteName;
	            }
	            var teamDisplayName = siteName;
	            if (this.props.teamDisplayName) {
	                teamDisplayName = this.props.teamDisplayName;
	            }
	
	            var helpLink = null;
	            if (global.window.mm_config.HelpLink) {
	                helpLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["Link"],
	                        {
	                            target: '_blank',
	                            to: global.window.mm_config.HelpLink,
	                            rel: 'noreferrer'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-question' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'sidebar_right_menu.help',
	                            defaultMessage: 'Help'
	                        })
	                    )
	                );
	            }
	
	            var reportLink = null;
	            if (global.window.mm_config.ReportAProblemLink) {
	                reportLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'li',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["Link"],
	                        {
	                            target: '_blank',
	                            to: global.window.mm_config.ReportAProblemLink,
	                            rel: 'noreferrer'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-phone' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'sidebar_right_menu.report',
	                            defaultMessage: 'Report a Problem'
	                        })
	                    )
	                );
	            }
	
	            var tutorialTip = null;
	            if (this.state.showTutorialTip) {
	                tutorialTip = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_components_tutorial_tutorial_tip_jsx__["a"].bind()(function (e) {
	                    return e.preventDefault();
	                }, true);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                'div',
	                {
	                    className: 'sidebar--menu',
	                    id: 'sidebar-menu'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { className: 'team__header theme' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["Link"],
	                        {
	                            className: 'team__name',
	                            to: '/channels/town-square'
	                        },
	                        teamDisplayName
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { className: 'nav-pills__container' },
	                    tutorialTip,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'ul',
	                        { className: 'nav nav-pills nav-stacked' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: function onClick() {
	                                        return _this2.setState({ showUserSettingsModal: true });
	                                    }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-cog' }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar_right_menu.accountSettings',
	                                    defaultMessage: 'Account Settings'
	                                })
	                            )
	                        ),
	                        teamSettingsLink,
	                        inviteLink,
	                        teamLink,
	                        manageLink,
	                        consoleLink,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_router__["Link"],
	                                { to: '/select_team' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-exchange' }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar_right_menu.switch_team',
	                                    defaultMessage: 'Switch Team'
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('li', { className: 'divider' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_action_creators_global_actions_jsx__.emitUserLoggedOutEvent
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-sign-out' }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                    id: 'sidebar_right_menu.logout',
	                                    defaultMessage: 'Logout'
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('li', { className: 'divider' }),
	                        helpLink,
	                        reportLink,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'li',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'a',
	                                {
	                                    href: '#',
	                                    onClick: this.handleAboutModal
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'fa fa-info' }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                    id: 'navbar_dropdown.about',
	                                    defaultMessage: 'About Mattermost'
	                                })
	                            )
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__user_settings_user_settings_modal_jsx__["a"], {
	                    show: this.state.showUserSettingsModal,
	                    onModalDismissed: function onModalDismissed() {
	                        return _this2.setState({ showUserSettingsModal: false });
	                    }
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__about_build_modal_jsx__["a"], {
	                    show: this.state.showAboutModal,
	                    onModalDismissed: this.aboutModalDismissed
	                })
	            );
	        }
	    }]);
	
	    return SidebarRightMenu;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SidebarRightMenu;
	
	
	SidebarRightMenu.propTypes = {
	    teamType: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    teamDisplayName: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_error_jsx__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_loading_screen_jsx__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl___default = __WEBPACK_IMPORTED_MODULE_14_react_intl__ && __WEBPACK_IMPORTED_MODULE_14_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router___default = __WEBPACK_IMPORTED_MODULE_15_react_router__ && __WEBPACK_IMPORTED_MODULE_15_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __WEBPACK_IMPORTED_MODULE_16_react__ && __WEBPACK_IMPORTED_MODULE_16_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_dom___default = __WEBPACK_IMPORTED_MODULE_17_react_dom__ && __WEBPACK_IMPORTED_MODULE_17_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_logo_png__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_images_logo_png___default = __WEBPACK_IMPORTED_MODULE_18_images_logo_png__ && __WEBPACK_IMPORTED_MODULE_18_images_logo_png__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_images_logo_png__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_images_logo_png__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_images_logo_png___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_images_logo_png___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var SignupUserComplete = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(SignupUserComplete, _React$Component);
	
	    function SignupUserComplete(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SignupUserComplete);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SignupUserComplete).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleLdapSignup = _this.handleLdapSignup.bind(_this);
	
	        _this.handleLdapIdChange = _this.handleLdapIdChange.bind(_this);
	        _this.handleLdapPasswordChange = _this.handleLdapPasswordChange.bind(_this);
	
	        _this.state = {
	            data: '',
	            hash: '',
	            usedBefore: false,
	            email: '',
	            teamDisplayName: '',
	            teamName: '',
	            teamId: '',
	            openServer: false,
	            loading: true,
	            inviteId: '',
	            ldapId: '',
	            ldapPassword: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(SignupUserComplete, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var data = this.props.location.query.d;
	            var hash = this.props.location.query.h;
	            var inviteId = this.props.location.query.id;
	            var usedBefore = false;
	            var email = '';
	            var teamDisplayName = '';
	            var teamName = '';
	            var teamId = '';
	            var openServer = false;
	            var loading = true;
	
	            if (inviteId && inviteId.length > 0 || hash && hash.length > 0) {
	                // if we are already logged in then attempt to just join the team
	                if (/* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser()) {
	                    loading = true;
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].addUserToTeamFromInvite(data, hash, inviteId, function () {
	                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitInitialLoad(function () {
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/select_team');
	                        });
	                    }, function (err) {
	                        _this2.setState({
	                            noOpenServerError: true,
	                            serverError: err.message,
	                            loading: false
	                        });
	                    });
	                } else if (hash) {
	                    // If we have a hash in the url then we are attempting to access a private team
	                    var parsedData = JSON.parse(data);
	                    usedBefore = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].getGlobalItem(hash);
	                    email = parsedData.email;
	                    teamDisplayName = parsedData.display_name;
	                    teamName = parsedData.name;
	                    teamId = parsedData.id;
	                    loading = false;
	                } else {
	                    loading = true;
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].getInviteInfo(inviteId, function (inviteData) {
	                        if (!inviteData) {
	                            return;
	                        }
	
	                        _this2.setState({
	                            serverError: null,
	                            teamDisplayName: inviteData.display_name,
	                            teamName: inviteData.name,
	                            teamId: inviteData.id,
	                            loading: false
	                        });
	                    }, function () {
	                        _this2.setState({
	                            noOpenServerError: true,
	                            loading: false,
	                            serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'signup_user_completed.invalid_invite',
	                                defaultMessage: 'The invite link was invalid.  Please speak with your Administrator to receive an invitation.'
	                            })
	                        });
	                    });
	
	                    data = '';
	                    hash = '';
	                }
	            } else if (global.window.mm_config.EnableOpenServer === 'true' || /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getNoAccounts()) {
	                // If this is the first account then let them create an account anyway.
	                // The server will verify it's the first account before allowing creation.
	                // Of if the server is open then we don't care.
	                openServer = true;
	                loading = false;
	            } else {
	                loading = false;
	                this.setState({
	                    noOpenServerError: true,
	                    serverError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'signup_user_completed.no_open_server',
	                        defaultMessage: 'This server does not allow open signups.  Please speak with your Administrator to receive an invitation.'
	                    }),
	                    loading: false
	                });
	            }
	
	            this.setState({
	                data: data,
	                hash: hash,
	                usedBefore: usedBefore,
	                email: email,
	                teamDisplayName: teamDisplayName,
	                teamName: teamName,
	                teamId: teamId,
	                openServer: openServer,
	                inviteId: inviteId,
	                loading: loading
	            });
	        }
	    }, {
	        key: 'handleLdapSignup',
	        value: function handleLdapSignup(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	
	            this.setState({ ldapError: '' });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].webLoginByLdap(this.state.ldapId, this.state.ldapPassword, null, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitInitialLoad(function () {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/select_team');
	                });
	            }, function (err) {
	                if (err.id === 'ent.ldap.do_login.user_not_registered.app_error' || err.id === 'ent.ldap.do_login.user_filtered.app_error') {
	                    _this3.setState({
	                        ldapError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.userNotFound',
	                            defaultMessage: 'We couldn\'t find an account matching your login credentials.'
	                        })
	                    });
	                } else if (err.id === 'ent.ldap.do_login.invalid_password.app_error') {
	                    _this3.setState({
	                        ldapError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'login.invalidPassword',
	                            defaultMessage: 'Your password is incorrect.'
	                        })
	                    });
	                } else {
	                    _this3.setState({ ldapError: err.message });
	                }
	            });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this4 = this;
	
	            e.preventDefault();
	
	            var providedEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_dom___default.a.findDOMNode(this.refs.email).value.trim();
	            if (!providedEmail) {
	                this.setState({
	                    nameError: '',
	                    emailError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], { id: 'signup_user_completed.required' }),
	                    passwordError: '',
	                    serverError: ''
	                });
	                return;
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isEmail(providedEmail)) {
	                this.setState({
	                    nameError: '',
	                    emailError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], { id: 'signup_user_completed.validEmail' }),
	                    passwordError: '',
	                    serverError: ''
	                });
	                return;
	            }
	
	            var providedUsername = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_dom___default.a.findDOMNode(this.refs.name).value.trim().toLowerCase();
	            if (!providedUsername) {
	                this.setState({
	                    nameError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], { id: 'signup_user_completed.required' }),
	                    emailError: '',
	                    passwordError: '',
	                    serverError: ''
	                });
	                return;
	            }
	
	            var usernameError = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.isValidUsername(providedUsername);
	            if (usernameError === 'Cannot use a reserved word as a username.') {
	                this.setState({
	                    nameError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], { id: 'signup_user_completed.reserved' }),
	                    emailError: '',
	                    passwordError: '',
	                    serverError: ''
	                });
	                return;
	            } else if (usernameError) {
	                this.setState({
	                    nameError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'signup_user_completed.usernameLength',
	                        values: {
	                            min: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MIN_USERNAME_LENGTH,
	                            max: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH
	                        }
	                    }),
	                    emailError: '',
	                    passwordError: '',
	                    serverError: ''
	                });
	                return;
	            }
	
	            var providedPassword = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_dom___default.a.findDOMNode(this.refs.password).value.trim();
	            if (!providedPassword || providedPassword.length < /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH) {
	                this.setState({
	                    nameError: '',
	                    emailError: '',
	                    passwordError: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'signup_user_completed.passwordLength',
	                        values: {
	                            min: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH
	                        }
	                    }),
	                    serverError: ''
	                });
	                return;
	            }
	
	            this.setState({
	                nameError: '',
	                emailError: '',
	                passwordError: '',
	                serverError: ''
	            });
	
	            var user = {
	                email: providedEmail,
	                username: providedUsername,
	                password: providedPassword,
	                allow_marketing: true
	            };
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].createUserWithInvite(user, this.state.data, this.state.hash, this.state.inviteId, function (data) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].track('signup', 'signup_user_02_complete');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].loginById(data.id, user.password, '', function () {
	                    if (_this4.state.hash > 0) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_browser_store_jsx__["a"].setGlobalItem(_this4.state.hash, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a.bind()({ usedBefore: true }));
	                    }
	
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.emitInitialLoad(function () {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/select_team');
	                    });
	                }, function (err) {
	                    if (err.id === 'api.user.login.not_verified.app_error') {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["browserHistory"].push('/should_verify_email?email=' + encodeURIComponent(user.email) + '&teamname=' + encodeURIComponent(_this4.state.teamName));
	                    } else {
	                        _this4.setState({ serverError: err.message });
	                    }
	                });
	            }, function (err) {
	                _this4.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleLdapIdChange',
	        value: function handleLdapIdChange(e) {
	            e.preventDefault();
	
	            this.setState({
	                ldapId: e.target.value
	            });
	        }
	    }, {
	        key: 'handleLdapPasswordChange',
	        value: function handleLdapPasswordChange(e) {
	            e.preventDefault();
	
	            this.setState({
	                ldapPassword: e.target.value
	            });
	        }
	    }, {
	        key: 'renderLdapLogin',
	        value: function renderLdapLogin() {
	            var ldapIdPlaceholder = void 0;
	            if (global.window.mm_config.LdapLoginFieldName) {
	                ldapIdPlaceholder = global.window.mm_config.LdapLoginFieldName;
	            } else {
	                ldapIdPlaceholder = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.localizeMessage('login.ldap_username', 'LDAP Username');
	            }
	
	            var errorClass = '';
	            if (this.state.ldapError) {
	                errorClass += ' has-error';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'form',
	                {
	                    onSubmit: this.handleLdapSignup
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'signup__email-container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_components_form_error_jsx__["a"], { error: this.state.ldapError }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' + errorClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                            className: 'form-control',
	                            name: 'ldapId',
	                            value: this.state.ldapId,
	                            onChange: this.handleLdapIdChange,
	                            placeholder: ldapIdPlaceholder,
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' + errorClass },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                            type: 'password',
	                            className: 'form-control',
	                            name: 'password',
	                            value: this.state.ldapPassword,
	                            onChange: this.handleLdapPasswordChange,
	                            placeholder: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_utils_jsx__.localizeMessage('login.password', 'Password'),
	                            spellCheck: 'false'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'form-group' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'button',
	                            {
	                                type: 'submit',
	                                className: 'btn btn-primary',
	                                disabled: !this.state.ldapId || !this.state.ldapPassword
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'login.signIn',
	                                defaultMessage: 'Sign in'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].track('signup', 'signup_user_01_welcome');
	
	            // If we have been used then just display a message
	            if (this.state.usedBefore) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'signup_user_completed.expired',
	                        defaultMessage: 'You\'ve already completed the signup process for this invitation or this invitation has expired.'
	                    })
	                );
	            }
	
	            if (this.state.loading) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_components_loading_screen_jsx__["a"], null);
	            }
	
	            // set up error labels
	            var emailError = null;
	            var emailHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'span',
	                { className: 'help-block' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                    id: 'signup_user_completed.emailHelp',
	                    defaultMessage: 'Valid email required for sign-up'
	                })
	            );
	            var emailDivStyle = 'form-group';
	            if (this.state.emailError) {
	                emailError = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.emailError
	                );
	                emailHelpText = '';
	                emailDivStyle += ' has-error';
	            }
	
	            var nameError = null;
	            var nameHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'span',
	                { className: 'help-block' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                    id: 'signup_user_completed.userHelp',
	                    defaultMessage: 'Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols \'.\', \'-\' and \'_\'',
	                    values: {
	                        min: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MIN_USERNAME_LENGTH,
	                        max: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH
	                    }
	                })
	            );
	            var nameDivStyle = 'form-group';
	            if (this.state.nameError) {
	                nameError = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.nameError
	                );
	                nameHelpText = '';
	                nameDivStyle += ' has-error';
	            }
	
	            var passwordError = null;
	            var passwordDivStyle = 'form-group';
	            if (this.state.passwordError) {
	                passwordError = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    this.state.passwordError
	                );
	                passwordDivStyle += ' has-error';
	            }
	
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'form-group has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'label',
	                        { className: 'control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            // set up the email entry and hide it if an email was provided
	            var yourEmailIs = '';
	            if (this.state.email) {
	                yourEmailIs = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedHTMLMessage"], {
	                    id: 'signup_user_completed.emailIs',
	                    defaultMessage: 'Your email address is <strong>{email}</strong>. You\'ll use this address to sign in to {siteName}.',
	                    values: {
	                        email: this.state.email,
	                        siteName: global.window.mm_config.SiteName
	                    }
	                });
	            }
	
	            var emailContainerStyle = 'margin--extra';
	            if (this.state.email) {
	                emailContainerStyle = 'hidden';
	            }
	
	            var email = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                { className: emailContainerStyle },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'h5',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'strong',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_user_completed.whatis',
	                            defaultMessage: 'What\'s your email address?'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: emailDivStyle },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                        type: 'email',
	                        ref: 'email',
	                        className: 'form-control',
	                        defaultValue: this.state.email,
	                        placeholder: '',
	                        maxLength: '128',
	                        autoFocus: true,
	                        spellCheck: 'false'
	                    }),
	                    emailError,
	                    emailHelpText
	                )
	            );
	
	            var signupMessage = [];
	            if (global.window.mm_config.EnableSignUpWithGitLab === 'true') {
	                signupMessage.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'btn btn-custom-login gitlab',
	                        key: 'gitlab',
	                        href: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].getOAuthRoute() + '/gitlab/signup' + window.location.search
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span', { className: 'icon' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_user_completed.gitlab',
	                            defaultMessage: 'with GitLab'
	                        })
	                    )
	                ));
	            }
	
	            if (global.window.mm_config.EnableSignUpWithGoogle === 'true') {
	                signupMessage.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'btn btn-custom-login google',
	                        key: 'google',
	                        href: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].getOAuthRoute() + '/google/signup' + window.location.search + '&team=' + encodeURIComponent(this.state.teamName)
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span', { className: 'icon' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_user_completed.google',
	                            defaultMessage: 'with Google'
	                        })
	                    )
	                ));
	            }
	
	            var ldapSignup = void 0;
	            if (global.window.mm_config.EnableLdap === 'true' && global.window.mm_license.IsLicensed === 'true' && global.window.mm_license.LDAP) {
	                ldapSignup = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'inner__content' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'h5',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'strong',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'signup_user_completed.withLdap',
	                                defaultMessage: 'With your LDAP credentials'
	                            })
	                        )
	                    ),
	                    this.renderLdapLogin()
	                );
	            }
	
	            var emailSignup = void 0;
	            if (global.window.mm_config.EnableSignUpWithEmail === 'true') {
	                emailSignup = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'form',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'inner__content' },
	                        email,
	                        yourEmailIs,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'margin--extra' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'h5',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                    'strong',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                        id: 'signup_user_completed.chooseUser',
	                                        defaultMessage: 'Choose your username'
	                                    })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'div',
	                                { className: nameDivStyle },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                    type: 'text',
	                                    ref: 'name',
	                                    className: 'form-control',
	                                    placeholder: '',
	                                    maxLength: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH,
	                                    spellCheck: 'false'
	                                }),
	                                nameError,
	                                nameHelpText
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'margin--extra' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'h5',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                    'strong',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                        id: 'signup_user_completed.choosePwd',
	                                        defaultMessage: 'Choose your password'
	                                    })
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'div',
	                                { className: passwordDivStyle },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                    type: 'password',
	                                    ref: 'password',
	                                    className: 'form-control',
	                                    placeholder: '',
	                                    maxLength: '128',
	                                    spellCheck: 'false'
	                                }),
	                                passwordError
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'p',
	                            { className: 'margin--extra' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    onClick: this.handleSubmit,
	                                    className: 'btn-primary btn'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                    id: 'signup_user_completed.create',
	                                    defaultMessage: 'Create Account'
	                                })
	                            )
	                        )
	                    )
	                );
	            }
	
	            if (signupMessage.length > 0 && (emailSignup || ldapSignup)) {
	                signupMessage = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    null,
	                    signupMessage,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'or__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_user_completed.or',
	                            defaultMessage: 'or'
	                        })
	                    )
	                );
	            }
	
	            if (ldapSignup && emailSignup) {
	                ldapSignup = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    null,
	                    ldapSignup,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'or__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'signup_user_completed.or',
	                            defaultMessage: 'or'
	                        })
	                    )
	                );
	            }
	
	            var terms = null;
	            if (!this.state.noOpenServerError && (emailSignup || ldapSignup)) {
	                terms = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'p',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedHTMLMessage"], {
	                        id: 'create_team.agreement',
	                        defaultMessage: 'By proceeding to create your account and use {siteName}, you agree to our <a href=\'/static/help/terms.html\'>Terms of Service</a> and <a href=\'/static/help/privacy.html\'>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.',
	                        values: {
	                            siteName: global.window.mm_config.SiteName
	                        }
	                    })
	                );
	            }
	
	            if (signupMessage.length === 0 && !emailSignup && !ldapSignup) {
	                emailSignup = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                        id: 'signup_user_completed.none',
	                        defaultMessage: 'No user creation method has been enabled.  Please contact an administrator for access.'
	                    })
	                );
	            }
	
	            if (this.state.noOpenServerError) {
	                signupMessage = null;
	                emailSignup = null;
	                ldapSignup = null;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'signup-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_router__["Link"],
	                        { to: '/' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('span', { className: 'fa fa-chevron-left' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                            id: 'web.header.back'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'col-sm-12' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'signup-team__container padding--less' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('img', {
	                            className: 'signup-team-logo',
	                            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_images_logo_png___default.a
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'h1',
	                            null,
	                            global.window.mm_config.SiteName
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'h4',
	                            { className: 'color--light' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'web.root.singup_info'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'h4',
	                            { className: 'color--light' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_intl__["FormattedMessage"], {
	                                id: 'signup_user_completed.lets',
	                                defaultMessage: 'Let\'s create your account'
	                            })
	                        ),
	                        signupMessage,
	                        ldapSignup,
	                        emailSignup,
	                        serverError,
	                        terms
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SignupUserComplete;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = SignupUserComplete;
	
	
	SignupUserComplete.defaultProps = {};
	SignupUserComplete.propTypes = {
	    location: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.object
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__ = __webpack_require__(139);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var MaxUserSuggestions = 40;
	
	
	
	var AtMentionSuggestion = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(AtMentionSuggestion, _React$Component);
	
	    function AtMentionSuggestion() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AtMentionSuggestion);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AtMentionSuggestion).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(AtMentionSuggestion, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var item = _props.item;
	            var isSelection = _props.isSelection;
	            var onClick = _props.onClick;
	
	
	            var username = void 0;
	            var description = void 0;
	            var icon = void 0;
	            if (item.username === 'all') {
	                username = 'all';
	                description = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'suggestion.mention.all',
	                    defaultMessage: 'Notifies everyone in the team'
	                });
	                icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('i', { className: 'mention__image fa fa-users fa-2x' });
	            } else if (item.username === 'channel') {
	                username = 'channel';
	                description = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'suggestion.mention.channel',
	                    defaultMessage: 'Notifies everyone in the channel'
	                });
	                icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('i', { className: 'mention__image fa fa-users fa-2x' });
	            } else {
	                username = item.username;
	                description = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.getFullName(item);
	                icon = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('img', {
	                    className: 'mention__image',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].getUsersRoute() + '/' + item.id + '/image?time=' + item.update_at
	                });
	            }
	
	            var className = 'mentions__name';
	            if (isSelection) {
	                className += ' suggestion--selected';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                'div',
	                {
	                    className: className,
	                    onClick: onClick
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'pull-left' },
	                    icon
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'pull-left mention--align' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'span',
	                        null,
	                        '@' + username
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'span',
	                        { className: 'mention__fullname' },
	                        description
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AtMentionSuggestion;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	AtMentionSuggestion.propTypes = {
	    item: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired,
	    isSelection: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.bool,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.func
	};
	
	var AtMentionProvider = function () {
	    function AtMentionProvider() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AtMentionProvider);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(AtMentionProvider, [{
	        key: 'handlePretextChanged',
	        value: function handlePretextChanged(suggestionId, pretext) {
	            var captured = /@([a-z0-9\-\._]*)$/i.exec(pretext);
	            if (captured) {
	                var usernamePrefix = captured[1];
	
	                var users = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getActiveOnlyProfiles(true);
	                var filtered = [];
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(users)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var id = _step.value;
	
	                        var user = users[id];
	
	                        if (user.username.startsWith(usernamePrefix) && user.delete_at <= 0) {
	                            filtered.push(user);
	                        }
	
	                        if (filtered.length >= MaxUserSuggestions) {
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                if (!pretext.startsWith('/msg')) {
	                    // add dummy users to represent the @channel special mention when not using the /msg command
	                    if ('channel'.startsWith(usernamePrefix)) {
	                        filtered.push({ username: 'channel' });
	                    }
	                }
	
	                filtered = filtered.sort(function (a, b) {
	                    return a.username.localeCompare(b.username);
	                });
	
	                var mentions = filtered.map(function (user) {
	                    return '@' + user.username;
	                });
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].setMatchedPretext(suggestionId, captured[0]);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].addSuggestions(suggestionId, mentions, filtered, AtMentionSuggestion);
	            }
	        }
	    }]);
	
	    return AtMentionProvider;
	}();
	
	/* harmony default export */ exports["a"] = AtMentionProvider;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var CommandSuggestion = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(CommandSuggestion, _React$Component);
	
	    function CommandSuggestion() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CommandSuggestion);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(CommandSuggestion).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(CommandSuggestion, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var item = _props.item;
	            var isSelection = _props.isSelection;
	            var onClick = _props.onClick;
	
	
	            var className = 'command';
	            if (isSelection) {
	                className += ' suggestion--selected';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                {
	                    className: className,
	                    onClick: onClick
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'command__title' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'string',
	                        null,
	                        item.suggestion,
	                        ' ',
	                        item.hint
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'command__desc' },
	                    item.description
	                )
	            );
	        }
	    }]);
	
	    return CommandSuggestion;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	CommandSuggestion.propTypes = {
	    item: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.object.isRequired,
	    isSelection: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func
	};
	
	var CommandProvider = function () {
	    function CommandProvider() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CommandProvider);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(CommandProvider, [{
	        key: 'handlePretextChanged',
	        value: function handlePretextChanged(suggestionId, pretext) {
	            if (pretext.startsWith('/')) {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_async_client_jsx__.getSuggestedCommands(pretext, suggestionId, CommandSuggestion);
	            }
	        }
	    }]);
	
	    return CommandProvider;
	}();
	
	/* harmony default export */ exports["a"] = CommandProvider;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__ = __webpack_require__(139);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_emoticons_jsx__ = __webpack_require__(376);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var MAX_EMOTICON_SUGGESTIONS = 40;
	
	
	
	var EmoticonSuggestion = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(EmoticonSuggestion, _React$Component);
	
	    function EmoticonSuggestion() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EmoticonSuggestion);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(EmoticonSuggestion).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(EmoticonSuggestion, [{
	        key: 'render',
	        value: function render() {
	            var text = this.props.term;
	            var emoticon = this.props.item;
	
	            var className = 'emoticon-suggestion';
	            if (this.props.isSelection) {
	                className += ' suggestion--selected';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                {
	                    className: className,
	                    onClick: this.props.onClick
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'pull-left' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                        alt: text,
	                        className: 'emoticon-suggestion__image',
	                        src: emoticon.path,
	                        title: text
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'pull-left' },
	                    text
	                )
	            );
	        }
	    }]);
	
	    return EmoticonSuggestion;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	EmoticonSuggestion.propTypes = {
	    item: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.object.isRequired,
	    term: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string.isRequired,
	    isSelection: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func
	};
	
	var EmoticonProvider = function () {
	    function EmoticonProvider() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, EmoticonProvider);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(EmoticonProvider, [{
	        key: 'handlePretextChanged',
	        value: function handlePretextChanged(suggestionId, pretext) {
	            var captured = /(?:^|\s)(:([a-zA-Z0-9_+\-]*))$/g.exec(pretext);
	            if (captured) {
	                (function () {
	                    var text = captured[1];
	                    var partialName = captured[2];
	
	                    var matched = [];
	
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_emoticons_jsx__.getEmoticonsByName()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	                            var name = _step$value[0];
	                            var emoticon = _step$value[1];
	
	                            if (name.indexOf(partialName) !== -1) {
	                                matched.push(emoticon);
	
	                                if (matched.length >= MAX_EMOTICON_SUGGESTIONS) {
	                                    break;
	                                }
	                            }
	                        }
	
	                        // sort the emoticons so that emoticons starting with the entered text come first
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    matched.sort(function (a, b) {
	                        var aPrefix = a.alias.startsWith(partialName);
	                        var bPrefix = b.alias.startsWith(partialName);
	
	                        if (aPrefix === bPrefix) {
	                            return a.alias.localeCompare(b.alias);
	                        } else if (aPrefix) {
	                            return -1;
	                        }
	
	                        return 1;
	                    });
	
	                    var terms = matched.map(function (emoticon) {
	                        return ':' + emoticon.alias + ':';
	                    });
	
	                    if (terms.length > 0) {
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].setMatchedPretext(suggestionId, text);
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].addSuggestions(suggestionId, terms, matched, EmoticonSuggestion);
	
	                        // force the selection to be cleared since the order of elements may have changed
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].clearSelection(suggestionId);
	                    }
	                })();
	            }
	        }
	    }]);
	
	    return EmoticonProvider;
	}();
	
	/* harmony default export */ exports["a"] = EmoticonProvider;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_suggestion_store_jsx__ = __webpack_require__(139);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var SearchChannelSuggestion = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(SearchChannelSuggestion, _React$Component);
	
	    function SearchChannelSuggestion() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchChannelSuggestion);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchChannelSuggestion).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(SearchChannelSuggestion, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var item = _props.item;
	            var isSelection = _props.isSelection;
	            var onClick = _props.onClick;
	
	
	            var className = 'search-autocomplete__item';
	            if (isSelection) {
	                className += ' selected';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                {
	                    onClick: onClick,
	                    className: className
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa fa-plus-square' }),
	                item.name
	            );
	        }
	    }]);
	
	    return SearchChannelSuggestion;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	SearchChannelSuggestion.propTypes = {
	    item: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired,
	    isSelection: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.bool,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func
	};
	
	var SearchChannelProvider = function () {
	    function SearchChannelProvider() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchChannelProvider);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(SearchChannelProvider, [{
	        key: 'handlePretextChanged',
	        value: function handlePretextChanged(suggestionId, pretext) {
	            var captured = /\b(?:in|channel):\s*(\S*)$/i.exec(pretext);
	            if (captured) {
	                var channelPrefix = captured[1];
	
	                var channels = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_channel_store_jsx__["a"].getAll();
	                var publicChannels = [];
	                var privateChannels = [];
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(channels)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var id = _step.value;
	
	                        var channel = channels[id];
	
	                        // don't show direct channels
	                        if (channel.type !== /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].DM_CHANNEL && channel.name.startsWith(channelPrefix)) {
	                            if (channel.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_constants_jsx__["a"].OPEN_CHANNEL) {
	                                publicChannels.push(channel);
	                            } else {
	                                privateChannels.push(channel);
	                            }
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                publicChannels.sort(function (a, b) {
	                    return a.name.localeCompare(b.name);
	                });
	                var publicChannelNames = publicChannels.map(function (channel) {
	                    return channel.name;
	                });
	
	                privateChannels.sort(function (a, b) {
	                    return a.name.localeCompare(b.name);
	                });
	                var privateChannelNames = privateChannels.map(function (channel) {
	                    return channel.name;
	                });
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_suggestion_store_jsx__["a"].setMatchedPretext(suggestionId, channelPrefix);
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_suggestion_store_jsx__["a"].addSuggestions(suggestionId, publicChannelNames, publicChannels, SearchChannelSuggestion);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_suggestion_store_jsx__["a"].addSuggestions(suggestionId, privateChannelNames, privateChannels, SearchChannelSuggestion);
	            }
	        }
	    }]);
	
	    return SearchChannelProvider;
	}();
	
	/* harmony default export */ exports["a"] = SearchChannelProvider;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __WEBPACK_IMPORTED_MODULE_8_react_dom__ && __WEBPACK_IMPORTED_MODULE_8_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__suggestion_list_jsx__ = __webpack_require__(371);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_bootstrap___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var SearchSuggestionList = function (_SuggestionList) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(SearchSuggestionList, _SuggestionList);
	
	    function SearchSuggestionList() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchSuggestionList);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchSuggestionList).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(SearchSuggestionList, [{
	        key: 'getContent',
	        value: function getContent() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs.popover)).find('.popover-content');
	        }
	    }, {
	        key: 'renderChannelDivider',
	        value: function renderChannelDivider(type) {
	            var text = void 0;
	            if (type === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].OPEN_CHANNEL) {
	                text = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'suggestion.search.public',
	                    defaultMessage: 'Public Channels'
	                });
	            } else {
	                text = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'suggestion.search.private',
	                    defaultMessage: 'Private Groups'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                {
	                    key: type + '-divider',
	                    className: 'search-autocomplete__divider'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'span',
	                    null,
	                    text
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.items.length === 0) {
	                return null;
	            }
	
	            var items = [];
	            for (var i = 0; i < this.state.items.length; i++) {
	                var item = this.state.items[i];
	                var term = this.state.terms[i];
	                var isSelection = term === this.state.selection;
	
	                // ReactComponent names need to be upper case when used in JSX
	                var Component = this.state.components[i];
	
	                // temporary hack to add dividers between public and private channels in the search suggestion list
	                if (i === 0 || item.type !== this.state.items[i - 1].type) {
	                    if (item.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].OPEN_CHANNEL) {
	                        items.push(this.renderChannelDivider(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].OPEN_CHANNEL));
	                    } else if (item.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].PRIVATE_CHANNEL) {
	                        items.push(this.renderChannelDivider(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_constants_jsx__["a"].PRIVATE_CHANNEL));
	                    }
	                }
	
	                items.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, {
	                    key: term,
	                    ref: term,
	                    item: item,
	                    isSelection: isSelection,
	                    onClick: this.handleItemClick.bind(this, term)
	                }));
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["Popover"],
	                {
	                    ref: 'popover',
	                    id: 'search-autocomplete__popover',
	                    className: 'search-help-popover autocomplete visible',
	                    placement: 'bottom'
	                },
	                items
	            );
	        }
	    }]);
	
	    return SearchSuggestionList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__suggestion_list_jsx__["a"]);
	
	/* harmony default export */ exports["a"] = SearchSuggestionList;
	
	
	SearchSuggestionList.propTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({}, /* harmony import */__WEBPACK_IMPORTED_MODULE_10__suggestion_list_jsx__["a"].propTypes);

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__ = __webpack_require__(139);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var SearchUserSuggestion = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(SearchUserSuggestion, _React$Component);
	
	    function SearchUserSuggestion() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchUserSuggestion);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SearchUserSuggestion).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(SearchUserSuggestion, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var item = _props.item;
	            var isSelection = _props.isSelection;
	            var onClick = _props.onClick;
	
	
	            var className = 'search-autocomplete__item';
	            if (isSelection) {
	                className += ' selected';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                {
	                    className: className,
	                    onClick: onClick
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
	                    className: 'profile-img rounded',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].getUsersRoute() + '/' + item.id + '/image?time=' + item.update_at
	                }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa fa-plus-square' }),
	                item.username
	            );
	        }
	    }]);
	
	    return SearchUserSuggestion;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	SearchUserSuggestion.propTypes = {
	    item: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired,
	    isSelection: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.bool,
	    onClick: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func
	};
	
	var SearchUserProvider = function () {
	    function SearchUserProvider() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SearchUserProvider);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default.a.bind()(SearchUserProvider, [{
	        key: 'handlePretextChanged',
	        value: function handlePretextChanged(suggestionId, pretext) {
	            var captured = /\bfrom:\s*(\S*)$/i.exec(pretext);
	            if (captured) {
	                var usernamePrefix = captured[1];
	
	                var users = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_stores_user_store_jsx__["a"].getProfiles();
	                var filtered = [];
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(users)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var id = _step.value;
	
	                        var user = users[id];
	
	                        if (user.username.startsWith(usernamePrefix)) {
	                            filtered.push(user);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                filtered = filtered.sort(function (a, b) {
	                    return a.username.localeCompare(b.username);
	                });
	
	                var usernames = filtered.map(function (user) {
	                    return user.username;
	                });
	
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].setMatchedPretext(suggestionId, usernamePrefix);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_suggestion_store_jsx__["a"].addSuggestions(suggestionId, usernames, filtered, SearchUserSuggestion);
	            }
	        }
	    }]);
	
	    return SearchUserProvider;
	}();
	
	/* harmony default export */ exports["a"] = SearchUserProvider;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __WEBPACK_IMPORTED_MODULE_6_react_intl__ && __WEBPACK_IMPORTED_MODULE_6_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router___default = __WEBPACK_IMPORTED_MODULE_8_react_router__ && __WEBPACK_IMPORTED_MODULE_8_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	var TeamExportTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamExportTab, _React$Component);
	
	    function TeamExportTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamExportTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamExportTab).call(this, props));
	
	        _this.state = { status: 'request', link: '', err: '' };
	
	        _this.onExportSuccess = _this.onExportSuccess.bind(_this);
	        _this.onExportFailure = _this.onExportFailure.bind(_this);
	        _this.doExport = _this.doExport.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamExportTab, [{
	        key: 'onExportSuccess',
	        value: function onExportSuccess(data) {
	            this.setState({ status: 'ready', link: data.link, err: '' });
	        }
	    }, {
	        key: 'onExportFailure',
	        value: function onExportFailure(e) {
	            this.setState({ status: 'failure', link: '', err: e.message });
	        }
	    }, {
	        key: 'doExport',
	        value: function doExport() {
	            if (this.state.status === 'in-progress') {
	                return;
	            }
	            this.setState({ status: 'in-progress' });
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_web_client_jsx__["a"].exportTeam(this.onExportSuccess, this.onExportFailure);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var messageSection = '';
	            switch (this.state.status) {
	                case 'request':
	                    messageSection = '';
	                    break;
	                case 'in-progress':
	                    messageSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        { className: 'confirm-import alert alert-warning' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'fa fa-spinner fa-pulse' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'team_export_tab.exporting',
	                            defaultMessage: ' Exporting...'
	                        })
	                    );
	                    break;
	                case 'ready':
	                    messageSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        { className: 'confirm-import alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'team_export_tab.ready',
	                            defaultMessage: ' Ready for '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                            {
	                                to: this.state.link,
	                                download: true
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                id: 'team_export_tab.download',
	                                defaultMessage: 'download'
	                            })
	                        )
	                    );
	                    break;
	                case 'failure':
	                    messageSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        { className: 'confirm-import alert alert-warning' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('i', { className: 'fa fa-warning' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'team_export_tab.unable',
	                            defaultMessage: ' Unable to export: {error}',
	                            values: {
	                                error: this.state.err
	                            }
	                        })
	                    );
	                    break;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                {
	                    ref: 'wrapper',
	                    className: 'user-settings'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h3',
	                    { className: 'tab-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                        id: 'team_export_tab.export',
	                        defaultMessage: 'Export'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'ul',
	                    { className: 'section-max' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'li',
	                        { className: 'col-xs-12 section-title' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                            id: 'team_export_tab.exportTeam',
	                            defaultMessage: 'Export your team'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'li',
	                        { className: 'col-xs-offset-3 col-xs-8' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'ul',
	                            { className: 'setting-list' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'li',
	                                { className: 'setting-list-item' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                    'a',
	                                    {
	                                        className: 'btn btn-sm btn-primary btn-file sel-btn',
	                                        href: '#',
	                                        onClick: this.doExport
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"], {
	                                        id: 'team_export_tab.export',
	                                        defaultMessage: 'Export'
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: 'divider-dark' }),
	                messageSection
	            );
	        }
	    }]);
	
	    return TeamExportTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TeamExportTab;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __WEBPACK_IMPORTED_MODULE_11_react_intl__ && __WEBPACK_IMPORTED_MODULE_11_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __WEBPACK_IMPORTED_MODULE_12_react__ && __WEBPACK_IMPORTED_MODULE_12_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["defineMessages"].bind()({
	    dirDisabled: {
	        id: 'general_tab.dirDisabled',
	        defaultMessage: 'Team Directory has been disabled.  Please ask a System Admin to enable the Team Directory in the System Console team settings.'
	    },
	    required: {
	        id: 'general_tab.required',
	        defaultMessage: 'This field is required'
	    },
	    chooseName: {
	        id: 'general_tab.chooseName',
	        defaultMessage: 'Please choose a new name for your team'
	    },
	    includeDirTitle: {
	        id: 'general_tab.includeDirTitle',
	        defaultMessage: 'Include this team in the Team Directory'
	    },
	    yes: {
	        id: 'general_tab.yes',
	        defaultMessage: 'Yes'
	    },
	    no: {
	        id: 'general_tab.no',
	        defaultMessage: 'No'
	    },
	    dirOff: {
	        id: 'general_tab.dirOff',
	        defaultMessage: 'Team directory is turned off for this system.'
	    },
	    openInviteTitle: {
	        id: 'general_tab.openInviteTitle',
	        defaultMessage: 'Allow anyone to join this team'
	    },
	    codeTitle: {
	        id: 'general_tab.codeTitle',
	        defaultMessage: 'Invite Code'
	    },
	    codeDesc: {
	        id: 'general_tab.codeDesc',
	        defaultMessage: "Click 'Edit' to regenerate Invite Code."
	    },
	    teamNameInfo: {
	        id: 'general_tab.teamNameInfo',
	        defaultMessage: 'Set the name of the team as it appears on your sign-in screen and at the top of the left-hand sidebar.'
	    }
	});
	
	
	
	var GeneralTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(GeneralTab, _React$Component);
	
	    function GeneralTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, GeneralTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(GeneralTab).call(this, props));
	
	        _this.updateSection = _this.updateSection.bind(_this);
	        _this.handleNameSubmit = _this.handleNameSubmit.bind(_this);
	        _this.handleInviteIdSubmit = _this.handleInviteIdSubmit.bind(_this);
	        _this.handleOpenInviteSubmit = _this.handleOpenInviteSubmit.bind(_this);
	        _this.handleClose = _this.handleClose.bind(_this);
	        _this.onUpdateNameSection = _this.onUpdateNameSection.bind(_this);
	        _this.updateName = _this.updateName.bind(_this);
	        _this.onUpdateInviteIdSection = _this.onUpdateInviteIdSection.bind(_this);
	        _this.updateInviteId = _this.updateInviteId.bind(_this);
	        _this.onUpdateOpenInviteSection = _this.onUpdateOpenInviteSection.bind(_this);
	        _this.handleOpenInviteRadio = _this.handleOpenInviteRadio.bind(_this);
	        _this.handleGenerateInviteId = _this.handleGenerateInviteId.bind(_this);
	
	        _this.state = _this.setupInitialState(props);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(GeneralTab, [{
	        key: 'updateSection',
	        value: function updateSection(section) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            this.setState(this.setupInitialState(this.props));
	            this.props.updateSection(section);
	        }
	    }, {
	        key: 'setupInitialState',
	        value: function setupInitialState(props) {
	            var team = props.team;
	
	            return {
	                name: team.display_name,
	                invite_id: team.invite_id,
	                allow_open_invite: team.allow_open_invite,
	                serverError: '',
	                clientError: ''
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                name: nextProps.team.display_name,
	                invite_id: nextProps.team.invite_id,
	                allow_open_invite: nextProps.team.allow_open_invite
	            });
	        }
	    }, {
	        key: 'handleGenerateInviteId',
	        value: function handleGenerateInviteId(e) {
	            e.preventDefault();
	
	            var newId = '';
	            for (var i = 0; i < 32; i++) {
	                newId += Math.floor(Math.random() * 16).toString(16);
	            }
	
	            this.setState({ invite_id: newId });
	        }
	    }, {
	        key: 'handleOpenInviteRadio',
	        value: function handleOpenInviteRadio(openInvite) {
	            this.setState({ allow_open_invite: openInvite });
	        }
	    }, {
	        key: 'handleOpenInviteSubmit',
	        value: function handleOpenInviteSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var state = { serverError: '', clientError: '' };
	
	            var data = this.props.team;
	            data.allow_open_invite = this.state.allow_open_invite;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].updateTeam(data, function (team) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].saveTeam(team);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].emitChange();
	                _this2.updateSection('');
	            }, function (err) {
	                state.serverError = err.message;
	                _this2.setState(state);
	            });
	        }
	    }, {
	        key: 'handleNameSubmit',
	        value: function handleNameSubmit(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	
	            var state = { serverError: '', clientError: '' };
	            var valid = true;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var name = this.state.name.trim();
	            if (!name) {
	                state.clientError = formatMessage(holders.required);
	                valid = false;
	            } else if (name === this.props.team.display_name) {
	                state.clientError = formatMessage(holders.chooseName);
	                valid = false;
	            } else {
	                state.clientError = '';
	            }
	
	            this.setState(state);
	
	            if (!valid) {
	                return;
	            }
	
	            var data = this.props.team;
	            data.display_name = this.state.name;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].updateTeam(data, function (team) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].saveTeam(team);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].emitChange();
	                _this3.updateSection('');
	            }, function (err) {
	                state.serverError = err.message;
	                _this3.setState(state);
	            });
	        }
	    }, {
	        key: 'handleInviteIdSubmit',
	        value: function handleInviteIdSubmit(e) {
	            var _this4 = this;
	
	            e.preventDefault();
	
	            var state = { serverError: '', clientError: '' };
	            var valid = true;
	
	            var inviteId = this.state.invite_id.trim();
	            if (inviteId) {
	                state.clientError = '';
	            } else {
	                state.clientError = this.props.intl.fromatMessage(holders.required);
	                valid = false;
	            }
	
	            this.setState(state);
	
	            if (!valid) {
	                return;
	            }
	
	            var data = this.props.team;
	            data.invite_id = this.state.invite_id;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].updateTeam(data, function (team) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].saveTeam(team);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_team_store_jsx__["a"].emitChange();
	                _this4.updateSection('');
	            }, function (err) {
	                state.serverError = err.message;
	                _this4.setState(state);
	            });
	        }
	    }, {
	        key: 'handleClose',
	        value: function handleClose() {
	            this.updateSection('');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#team_settings').on('hidden.bs.modal', this.handleClose);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#team_settings').off('hidden.bs.modal', this.handleClose);
	        }
	    }, {
	        key: 'onUpdateNameSection',
	        value: function onUpdateNameSection(e) {
	            e.preventDefault();
	            if (this.props.activeSection === 'name') {
	                this.updateSection('');
	            } else {
	                this.updateSection('name');
	            }
	        }
	    }, {
	        key: 'onUpdateInviteIdSection',
	        value: function onUpdateInviteIdSection(e) {
	            e.preventDefault();
	            if (this.props.activeSection === 'invite_id') {
	                this.updateSection('');
	            } else {
	                this.updateSection('invite_id');
	            }
	        }
	    }, {
	        key: 'onUpdateOpenInviteSection',
	        value: function onUpdateOpenInviteSection(e) {
	            e.preventDefault();
	            if (this.props.activeSection === 'open_invite') {
	                this.updateSection('');
	            } else {
	                this.updateSection('open_invite');
	            }
	        }
	    }, {
	        key: 'updateName',
	        value: function updateName(e) {
	            e.preventDefault();
	            this.setState({ name: e.target.value });
	        }
	    }, {
	        key: 'updateInviteId',
	        value: function updateInviteId(e) {
	            e.preventDefault();
	            this.setState({ invite_id: e.target.value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var clientError = null;
	            var serverError = null;
	            if (this.state.clientError) {
	                clientError = this.state.clientError;
	            }
	            if (this.state.serverError) {
	                serverError = this.state.serverError;
	            }
	
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            var openInviteSection = void 0;
	            if (this.props.activeSection === 'open_invite') {
	                var inputs = [/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { key: 'userOpenInviteOptions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                name: 'userOpenInviteOptions',
	                                type: 'radio',
	                                defaultChecked: this.state.allow_open_invite,
	                                onChange: this.handleOpenInviteRadio.bind(this, true)
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'general_tab.yes',
	                                defaultMessage: 'Yes'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                name: 'userOpenInviteOptions',
	                                type: 'radio',
	                                defaultChecked: !this.state.allow_open_invite,
	                                onChange: this.handleOpenInviteRadio.bind(this, false)
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                id: 'general_tab.no',
	                                defaultMessage: 'No'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'general_tab.openInviteDesc',
	                            defaultMessage: 'When allowed, a link to this team will be including on the landing page allowing anyone with an account to join this team.'
	                        })
	                    )
	                )];
	
	                openInviteSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.openInviteTitle),
	                    inputs: inputs,
	                    submit: this.handleOpenInviteSubmit,
	                    server_error: serverError,
	                    updateSection: this.onUpdateOpenInviteSection
	                });
	            } else {
	                var _describe = '';
	                if (this.state.allow_open_invite === true) {
	                    _describe = formatMessage(holders.yes);
	                } else {
	                    _describe = formatMessage(holders.no);
	                }
	
	                openInviteSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.openInviteTitle),
	                    describe: _describe,
	                    updateSection: this.onUpdateOpenInviteSection
	                });
	            }
	
	            var inviteSection = void 0;
	
	            if (this.props.activeSection === 'invite_id') {
	                var _inputs = [];
	
	                _inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { key: 'teamInviteSetting' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'row' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('label', { className: 'col-sm-5 control-label visible-xs-block' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-12' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                onChange: this.updateInviteId,
	                                value: this.state.invite_id,
	                                maxLength: '32'
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                                'div',
	                                { className: 'padding-top x2' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                                    'a',
	                                    {
	                                        href: '#',
	                                        onClick: this.handleGenerateInviteId
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                                        id: 'general_tab.regenerate',
	                                        defaultMessage: 'Re-Generate'
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'setting-list__hint' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'general_tab.codeLongDesc',
	                            defaultMessage: 'The Invite Code is used as part of the URL in the team invitation link created by **Get Team Invite Link** in the main menu. Regenerating creates a new team invitation link and invalidates the previous link.'
	                        })
	                    )
	                ));
	
	                inviteSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.codeTitle),
	                    inputs: _inputs,
	                    submit: this.handleInviteIdSubmit,
	                    server_error: serverError,
	                    client_error: clientError,
	                    updateSection: this.onUpdateInviteIdSection
	                });
	            } else {
	                inviteSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.codeTitle),
	                    describe: formatMessage(holders.codeDesc),
	                    updateSection: this.onUpdateInviteIdSection
	                });
	            }
	
	            var nameSection = void 0;
	
	            if (this.props.activeSection === 'name') {
	                var _inputs2 = [];
	
	                var teamNameLabel = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                    id: 'general_tab.teamName',
	                    defaultMessage: 'Team Name'
	                });
	                if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.isMobile()) {
	                    teamNameLabel = '';
	                }
	
	                _inputs2.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'teamNameSetting',
	                        className: 'form-group'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'label',
	                        { className: 'col-sm-5 control-label' },
	                        teamNameLabel
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-7' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('input', {
	                            className: 'form-control',
	                            type: 'text',
	                            maxLength: '22',
	                            onChange: this.updateName,
	                            value: this.state.name
	                        })
	                    )
	                ));
	
	                var nameExtraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'span',
	                    null,
	                    formatMessage(holders.teamNameInfo)
	                );
	
	                nameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_max_jsx__["a"], {
	                    title: formatMessage({ id: 'general_tab.teamName' }),
	                    inputs: _inputs2,
	                    submit: this.handleNameSubmit,
	                    server_error: serverError,
	                    client_error: clientError,
	                    updateSection: this.onUpdateNameSection,
	                    extraInfo: nameExtraInfo
	                });
	            } else {
	                var describe = this.state.name;
	
	                nameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__setting_item_min_jsx__["a"], {
	                    title: formatMessage({ id: 'general_tab.teamName' }),
	                    describe: describe,
	                    updateSection: this.onUpdateNameSection
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('i', { className: 'fa fa-angle-left' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'general_tab.title',
	                            defaultMessage: 'General Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'wrapper',
	                        className: 'user-settings'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"], {
	                            id: 'general_tab.title',
	                            defaultMessage: 'General Settings'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    nameSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-light' }),
	                    openInviteSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-light' }),
	                    inviteSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', { className: 'divider-dark' })
	                )
	            );
	        }
	    }]);
	
	    return GeneralTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
	
	GeneralTab.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["intlShape"].isRequired,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.func.isRequired,
	    team: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.object.isRequired,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_react___default.a.PropTypes.string.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react_intl__["injectIntl"].bind()(GeneralTab);

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setting_upload_jsx__ = __webpack_require__(745);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["defineMessages"].bind()({
	    importSlack: {
	        id: 'team_import_tab.importSlack',
	        defaultMessage: 'Import from Slack (Beta)'
	    }
	});
	
	
	
	var TeamImportTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamImportTab, _React$Component);
	
	    function TeamImportTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamImportTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamImportTab).call(this, props));
	
	        _this.onImportFailure = _this.onImportFailure.bind(_this);
	        _this.onImportSuccess = _this.onImportSuccess.bind(_this);
	        _this.doImportSlack = _this.doImportSlack.bind(_this);
	
	        _this.state = {
	            status: 'ready',
	            link: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamImportTab, [{
	        key: 'onImportFailure',
	        value: function onImportFailure() {
	            this.setState({ status: 'fail', link: '' });
	        }
	    }, {
	        key: 'onImportSuccess',
	        value: function onImportSuccess(data, res) {
	            this.setState({ status: 'done', link: 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(res.text) });
	        }
	    }, {
	        key: 'doImportSlack',
	        value: function doImportSlack(file) {
	            this.setState({ status: 'in-progress', link: '' });
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_5_utils_utils_jsx__.importSlack(file, this.onImportSuccess, this.onImportFailure);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var uploadHelpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedHTMLMessage"], {
	                    id: 'team_import_tab.importHelp',
	                    defaultMessage: '<p>To import a team from Slack go to Slack > Team Settings > Import/Export Data > Export > Start Export. Slack does not allow you to export files, images, private groups or direct messages stored in Slack. Therefore, Slack import to Mattermost only supports importing of text messages in your Slack team\'s public channels.</p><p>The Slack import to Mattermost is in \'Beta\'. Slack bot posts do not yet import and Slack @mentions are not currently supported.</p>'
	                })
	            );
	
	            var uploadSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__setting_upload_jsx__["a"], {
	                title: formatMessage(holders.importSlack),
	                submit: this.doImportSlack,
	                helpText: uploadHelpText,
	                fileTypesAccepted: '.zip'
	            });
	
	            var messageSection;
	            switch (this.state.status) {
	
	                case 'ready':
	                    messageSection = '';
	                    break;
	                case 'in-progress':
	                    messageSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'p',
	                        { className: 'confirm-import alert alert-warning' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i', { className: 'fa fa-spinner fa-pulse' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'team_import_tab.importing',
	                            defaultMessage: ' Importing...'
	                        })
	                    );
	                    break;
	                case 'done':
	                    messageSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'p',
	                        { className: 'confirm-import alert alert-success' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i', { className: 'fa fa-check' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'team_import_tab.successful',
	                            defaultMessage: ' Import successful: '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'a',
	                            {
	                                href: this.state.link,
	                                download: 'MattermostImportSummary.txt'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                id: 'team_import_tab.summary',
	                                defaultMessage: 'View Summary'
	                            })
	                        )
	                    );
	                    break;
	                case 'fail':
	                    messageSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'p',
	                        { className: 'confirm-import alert alert-warning' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i', { className: 'fa fa-warning' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'team_import_tab.failure',
	                            defaultMessage: ' Import failure: '
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'a',
	                            {
	                                href: this.state.link,
	                                download: 'MattermostImportSummary.txt'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                                id: 'team_import_tab.summary',
	                                defaultMessage: 'View Summary'
	                            })
	                        )
	                    );
	                    break;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'button',
	                        { type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i', { className: 'fa fa-angle-left' })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'team_import_tab.import',
	                            defaultMessage: 'Import'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'wrapper',
	                        className: 'user-settings'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"], {
	                            id: 'team_import_tab.import',
	                            defaultMessage: 'Import'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    uploadSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    messageSection
	                )
	            );
	        }
	    }]);
	
	    return TeamImportTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	TeamImportTab.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["injectIntl"].bind()(TeamImportTab);

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__confirm_modal_jsx__ = __webpack_require__(186);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router___default = __WEBPACK_IMPORTED_MODULE_14_react_router__ && __WEBPACK_IMPORTED_MODULE_14_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var TeamMembersDropdown = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamMembersDropdown, _React$Component);
	
	    function TeamMembersDropdown(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamMembersDropdown);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamMembersDropdown).call(this, props));
	
	        _this.handleMakeMember = _this.handleMakeMember.bind(_this);
	        _this.handleMakeActive = _this.handleMakeActive.bind(_this);
	        _this.handleMakeNotActive = _this.handleMakeNotActive.bind(_this);
	        _this.handleMakeAdmin = _this.handleMakeAdmin.bind(_this);
	        _this.handleDemote = _this.handleDemote.bind(_this);
	        _this.handleDemoteSubmit = _this.handleDemoteSubmit.bind(_this);
	        _this.handleDemoteCancel = _this.handleDemoteCancel.bind(_this);
	
	        _this.state = {
	            serverError: null,
	            showDemoteModal: false,
	            user: null,
	            role: null
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamMembersDropdown, [{
	        key: 'handleMakeMember',
	        value: function handleMakeMember() {
	            var _this2 = this;
	
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentUser();
	            if (this.props.user.id === me.id) {
	                this.handleDemote(this.props.user, '');
	            } else {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].updateRoles(this.props.teamMember.team_id, this.props.user.id, '', function () {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentId());
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getProfiles();
	                }, function (err) {
	                    _this2.setState({ serverError: err.message });
	                });
	            }
	        }
	    }, {
	        key: 'handleMakeActive',
	        value: function handleMakeActive() {
	            var _this3 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].updateActive(this.props.user.id, true, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentId());
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getProfiles();
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getChannelExtraInfo(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getCurrentId());
	            }, function (err) {
	                _this3.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleMakeNotActive',
	        value: function handleMakeNotActive() {
	            var _this4 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].updateActive(this.props.user.id, false, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentId());
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getProfiles();
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getChannelExtraInfo(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getCurrentId());
	            }, function (err) {
	                _this4.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleMakeAdmin',
	        value: function handleMakeAdmin() {
	            var _this5 = this;
	
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentUser();
	            if (this.props.user.id === me.id) {
	                this.handleDemote(this.props.user, 'admin');
	            } else {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].updateRoles(this.props.teamMember.team_id, this.props.user.id, 'admin', function () {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentId());
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getProfiles();
	                }, function (err) {
	                    _this5.setState({ serverError: err.message });
	                });
	            }
	        }
	    }, {
	        key: 'handleDemote',
	        value: function handleDemote(user, role, newRole) {
	            this.setState({
	                serverError: this.state.serverError,
	                showDemoteModal: true,
	                user: user,
	                role: role,
	                newRole: newRole
	            });
	        }
	    }, {
	        key: 'handleDemoteCancel',
	        value: function handleDemoteCancel() {
	            this.setState({
	                serverError: null,
	                showDemoteModal: false,
	                user: null,
	                role: null,
	                newRole: null
	            });
	        }
	    }, {
	        key: 'handleDemoteSubmit',
	        value: function handleDemoteSubmit() {
	            var _this6 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_web_client_jsx__["a"].updateRoles(this.props.teamMember.team_id, this.props.user.id, this.state.newRole, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getTeamMembers(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentId());
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_async_client_jsx__.getProfiles();
	
	                var teamUrl = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_team_store_jsx__["a"].getCurrentTeamUrl();
	                if (teamUrl) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_router__["browserHistory"].push(teamUrl);
	                } else {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react_router__["browserHistory"].push('/');
	                }
	            }, function (err) {
	                _this6.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    { className: 'has-error' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'label',
	                        { className: 'has-error control-label' },
	                        this.state.serverError
	                    )
	                );
	            }
	
	            var teamMember = this.props.teamMember;
	            var user = this.props.user;
	            var currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                id: 'team_members_dropdown.member',
	                defaultMessage: 'Member'
	            });
	
	            if (teamMember.roles.length > 0 && /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.isAdmin(teamMember.roles)) {
	                currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.teamAdmin',
	                    defaultMessage: 'Team Admin'
	                });
	            }
	
	            if (user.roles.length > 0 && /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.isSystemAdmin(user.roles)) {
	                currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.systemAdmin',
	                    defaultMessage: 'System Admin'
	                });
	            }
	
	            var showMakeMember = teamMember.roles === 'admin' || user.roles === 'system_admin';
	            var showMakeAdmin = teamMember.roles === '' && user.roles !== 'system_admin';
	            var showMakeActive = false;
	            var showMakeNotActive = user.roles !== 'system_admin';
	
	            if (user.delete_at > 0) {
	                currentRoles = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.inactive',
	                    defaultMessage: 'Inactive'
	                });
	                showMakeMember = false;
	                showMakeAdmin = false;
	                showMakeActive = true;
	                showMakeNotActive = false;
	            }
	
	            var makeAdmin = null;
	            if (showMakeAdmin) {
	                makeAdmin = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeAdmin
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'team_members_dropdown.makeAdmin',
	                            defaultMessage: 'Make Team Admin'
	                        })
	                    )
	                );
	            }
	
	            var makeMember = null;
	            if (showMakeMember) {
	                makeMember = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'li',
	                    { role: 'presentation' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'a',
	                        {
	                            role: 'menuitem',
	                            href: '#',
	                            onClick: this.handleMakeMember
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                            id: 'team_members_dropdown.makeMember',
	                            defaultMessage: 'Make Member'
	                        })
	                    )
	                );
	            }
	
	            var makeActive = null;
	            if (showMakeActive) {
	                // makeActive = (
	                //     <li role='presentation'>
	                //         <a
	                //             role='menuitem'
	                //             href='#'
	                //             onClick={this.handleMakeActive}
	                //         >
	                //             <FormattedMessage
	                //                 id='team_members_dropdown.makeActive'
	                //                 defaultMessage='Make Active'
	                //             />
	                //         </a>
	                //     </li>
	                // );
	            }
	
	            var makeNotActive = null;
	            if (showMakeNotActive) {
	                // makeNotActive = (
	                //     <li role='presentation'>
	                //         <a
	                //             role='menuitem'
	                //             href='#'
	                //             onClick={this.handleMakeNotActive}
	                //         >
	                //             <FormattedMessage
	                //                 id='team_members_dropdown.makeInactive'
	                //                 defaultMessage='Make Inactive'
	                //             />
	                //         </a>
	                //     </li>
	                // );
	            }
	            var me = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentUser();
	            var makeDemoteModal = null;
	            if (this.props.user.id === me.id) {
	                var title = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.confirmDemoteRoleTitle',
	                    defaultMessage: 'Confirm demotion from System Admin role'
	                });
	
	                var message = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'team_members_dropdown.confirmDemoteDescription',
	                        defaultMessage: 'If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you\'ll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.'
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'team_members_dropdown.confirmDemotionCmd',
	                        defaultMessage: 'platform -assign_role -team_name="yourteam" -email="name@yourcompany.com" -role="system_admin"'
	                    }),
	                    serverError
	                );
	
	                var confirmButton = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                    id: 'team_members_dropdown.confirmDemotion',
	                    defaultMessage: 'Confirm Demotion'
	                });
	
	                makeDemoteModal = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__confirm_modal_jsx__["a"], {
	                    show: this.state.showDemoteModal,
	                    title: title,
	                    message: message,
	                    confirmButton: confirmButton,
	                    onConfirm: this.handleDemoteSubmit,
	                    onCancel: this.handleDemoteCancel
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                'div',
	                { className: 'dropdown member-drop' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'a',
	                    {
	                        href: '#',
	                        className: 'dropdown-toggle theme',
	                        type: 'button',
	                        'data-toggle': 'dropdown',
	                        'aria-expanded': 'true'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                        'span',
	                        null,
	                        currentRoles,
	                        ' '
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('span', { className: 'fa fa-chevron-down' })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'ul',
	                    {
	                        className: 'dropdown-menu member-menu',
	                        role: 'menu'
	                    },
	                    makeAdmin,
	                    makeMember,
	                    makeActive,
	                    makeNotActive
	                ),
	                makeDemoteModal,
	                serverError
	            );
	        }
	    }]);
	
	    return TeamMembersDropdown;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TeamMembersDropdown;
	
	
	TeamMembersDropdown.propTypes = {
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired,
	    teamMember: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.object.isRequired
	};

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__team_import_tab_jsx__ = __webpack_require__(760);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__team_export_tab_jsx__ = __webpack_require__(758);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team_general_tab_jsx__ = __webpack_require__(759);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var TeamSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamSettings, _React$Component);
	
	    function TeamSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamSettings).call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	
	        _this.state = { team: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_team_store_jsx__["a"].getCurrent() };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamSettings, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_team_store_jsx__["a"].addChangeListener(this.onChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_team_store_jsx__["a"].removeChangeListener(this.onChange);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            var team = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_team_store_jsx__["a"].getCurrent();
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.areObjectsEqual(this.state.team, team)) {
	                this.setState({ team: team });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.team) {
	                return null;
	            }
	            var result;
	            switch (this.props.activeTab) {
	                case 'general':
	                    result = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__team_general_tab_jsx__["a"], {
	                            team: this.state.team,
	                            activeSection: this.props.activeSection,
	                            updateSection: this.props.updateSection
	                        })
	                    );
	                    break;
	                case 'import':
	                    result = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__team_import_tab_jsx__["a"], {
	                            team: this.state.team,
	                            activeSection: this.props.activeSection,
	                            updateSection: this.props.updateSection
	                        })
	                    );
	                    break;
	                case 'export':
	                    result = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__team_export_tab_jsx__["a"], null)
	                    );
	                    break;
	                default:
	                    result = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div', null);
	                    break;
	            }
	            return result;
	        }
	    }]);
	
	    return TeamSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TeamSettings;
	
	
	TeamSettings.defaultProps = {
	    activeTab: '',
	    activeSection: ''
	};
	
	TeamSettings.propTypes = {
	    activeTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string.isRequired,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.string.isRequired,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings_sidebar_jsx__ = __webpack_require__(369);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team_settings_jsx__ = __webpack_require__(762);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __WEBPACK_IMPORTED_MODULE_11_react__ && __WEBPACK_IMPORTED_MODULE_11_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["defineMessages"].bind()({
	    generalTab: {
	        id: 'team_settings_modal.generalTab',
	        defaultMessage: 'General'
	    },
	    importTab: {
	        id: 'team_settings_modal.importTab',
	        defaultMessage: 'Import'
	    },
	    exportTab: {
	        id: 'team_settings_modal.exportTab',
	        defaultMessage: 'Export'
	    }
	});
	
	
	
	var TeamSettingsModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TeamSettingsModal, _React$Component);
	
	    function TeamSettingsModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TeamSettingsModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TeamSettingsModal).call(this, props));
	
	        _this.updateTab = _this.updateTab.bind(_this);
	        _this.updateSection = _this.updateSection.bind(_this);
	
	        _this.state = {
	            activeTab: 'general',
	            activeSection: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TeamSettingsModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var modal = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.modal));
	
	            modal.on('click', '.modal-back', function handleBackClick() {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).closest('.modal-dialog').removeClass('display--content');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(this).closest('.modal-dialog').find('.settings-table .nav li.active').removeClass('active');
	            });
	            modal.on('click', '.modal-header .close', function () {
	                setTimeout(function () {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.modal-dialog.display--content').removeClass('display--content');
	                }, 500);
	            });
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .settings-content').perfectScrollbar();
	            }
	        }
	    }, {
	        key: 'updateTab',
	        value: function updateTab(tab) {
	            this.setState({ activeTab: tab, activeSection: '' });
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.isMobile()) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            }
	        }
	    }, {
	        key: 'updateSection',
	        value: function updateSection(section) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            this.setState({ activeSection: section });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var tabs = [];
	            tabs.push({ name: 'general', uiName: formatMessage(holders.generalTab), icon: 'glyphicon glyphicon-cog' });
	            tabs.push({ name: 'import', uiName: formatMessage(holders.importTab), icon: 'glyphicon glyphicon-upload' });
	
	            // To enable export uncomment this line
	            //tabs.push({name: 'export', uiName: formatMessage(holders.exportTab), icon: 'glyphicon glyphicon-download'});
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                'div',
	                {
	                    className: 'modal fade',
	                    ref: 'modal',
	                    id: 'team_settings',
	                    role: 'dialog',
	                    tabIndex: '-1',
	                    'aria-hidden': 'true'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-dialog settings-modal' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                        'div',
	                        { className: 'modal-content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-header' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'close',
	                                    'data-dismiss': 'modal',
	                                    'aria-label': 'Close'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'span',
	                                    { 'aria-hidden': 'true' },
	                                    '×'
	                                )
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'h4',
	                                {
	                                    className: 'modal-title',
	                                    ref: 'title'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                                    id: 'team_settings_modal.title',
	                                    defaultMessage: 'Team Settings'
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-body settings-modal__body' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                'div',
	                                { className: 'settings-table' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'div',
	                                    { className: 'settings-links' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__settings_sidebar_jsx__["a"], {
	                                        tabs: tabs,
	                                        activeTab: this.state.activeTab,
	                                        updateTab: this.updateTab
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
	                                    'div',
	                                    { className: 'settings-content minimize-settings' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__team_settings_jsx__["a"], {
	                                        activeTab: this.state.activeTab,
	                                        activeSection: this.state.activeSection,
	                                        updateSection: this.updateSection
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TeamSettingsModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);
	
	TeamSettingsModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["injectIntl"].bind()(TeamSettingsModal);

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __WEBPACK_IMPORTED_MODULE_7_react_intl__ && __WEBPACK_IMPORTED_MODULE_7_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin___default = __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin__ && __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var TimeSince = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TimeSince, _React$Component);
	
	    function TimeSince(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TimeSince);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TimeSince).call(this, props));
	
	        _this.shouldComponentUpdate = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_addons_pure_render_mixin___default.a.shouldComponentUpdate.bind(_this);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TimeSince, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.intervalId = setInterval(function () {
	                _this2.forceUpdate();
	            }, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_constants_jsx__["a"].TIME_SINCE_UPDATE_INTERVAL);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.intervalId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.sameUser) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'time',
	                    { className: 'post__time' },
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.displayTimeFormatted(this.props.eventTime)
	                );
	            }
	
	            var tooltip = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Tooltip"],
	                { id: 'time-since-tooltip-' + this.props.eventTime },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedDate"], {
	                    value: this.props.eventTime,
	                    month: 'long',
	                    day: 'numeric',
	                    year: 'numeric',
	                    hour12: !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.isMilitaryTime(),
	                    hour: 'numeric',
	                    minute: '2-digit'
	                })
	            );
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
	                {
	                    delayShow: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_utils_constants_jsx__["a"].OVERLAY_TIME_DELAY,
	                    placement: 'top',
	                    overlay: tooltip
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'time',
	                    { className: 'post__time' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedRelative"], { value: this.props.eventTime })
	                )
	            );
	        }
	    }]);
	
	    return TimeSince;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TimeSince;
	
	
	TimeSince.defaultProps = {
	    eventTime: 0,
	    sameUser: false
	};
	
	TimeSince.propTypes = {
	    eventTime: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.number.isRequired,
	    sameUser: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.bool
	};

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __WEBPACK_IMPORTED_MODULE_12_react_intl__ && __WEBPACK_IMPORTED_MODULE_12_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_12_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_12_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_12_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router___default = __WEBPACK_IMPORTED_MODULE_13_react_router__ && __WEBPACK_IMPORTED_MODULE_13_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].Preferences;
	
	var NUM_SCREENS = 3;
	
	
	
	var TutorialIntroScreens = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TutorialIntroScreens, _React$Component);
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(TutorialIntroScreens, null, [{
	        key: 'propTypes',
	        get: function get() {
	            return {
	                townSquare: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	                offTopic: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object
	            };
	        }
	    }]);
	
	    function TutorialIntroScreens(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TutorialIntroScreens);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TutorialIntroScreens).call(this, props));
	
	        _this.handleNext = _this.handleNext.bind(_this);
	        _this.createScreen = _this.createScreen.bind(_this);
	        _this.createCircles = _this.createCircles.bind(_this);
	
	        _this.state = { currentScreen: 0 };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(TutorialIntroScreens, [{
	        key: 'handleNext',
	        value: function handleNext() {
	            if (this.state.currentScreen < 2) {
	                this.setState({ currentScreen: this.state.currentScreen + 1 });
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].push(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/channels/town-square');
	
	            var step = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_preference_store_jsx__["a"].getInt(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentId(), 0);
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.savePreference(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentId(), (step + 1).toString());
	        }
	    }, {
	        key: 'skipTutorial',
	        value: function skipTutorial(e) {
	            e.preventDefault();
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.savePreference(Preferences.TUTORIAL_STEP, /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentId(), '999');
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_router__["browserHistory"].push(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrentTeamUrl() + '/channels/town-square');
	        }
	    }, {
	        key: 'createScreen',
	        value: function createScreen() {
	            switch (this.state.currentScreen) {
	                case 0:
	                    return this.createScreenOne();
	                case 1:
	                    return this.createScreenTwo();
	                case 2:
	                    return this.createScreenThree();
	            }
	            return null;
	        }
	    }, {
	        key: 'createScreenOne',
	        value: function createScreenOne() {
	            var circles = this.createCircles();
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedHTMLMessage"], {
	                    id: 'tutorial_intro.screenOne',
	                    defaultMessage: '<h3>Welcome to:</h3> <h1>Mattermost</h1> <p>Your team communication all in one place, instantly searchable and available anywhere</p> <p>Keep your team connected to help them achieve what matters most.</p>'
	                }),
	                circles
	            );
	        }
	    }, {
	        key: 'createScreenTwo',
	        value: function createScreenTwo() {
	            var circles = this.createCircles();
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedHTMLMessage"], {
	                    id: 'tutorial_intro.screenTwo',
	                    defaultMessage: '<h3>How Mattermost works:</h3> <p>Communication happens in public discussion channels, private groups and direct messages.</p> <p>Everything is archived and searchable from any web-enabled desktop, laptop or phone.</p>'
	                }),
	                circles
	            );
	        }
	    }, {
	        key: 'createScreenThree',
	        value: function createScreenThree() {
	            var team = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_team_store_jsx__["a"].getCurrent();
	            var inviteModalLink = void 0;
	
	            if (team.type === /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].INVITE_TEAM) {
	                inviteModalLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'intro-links',
	                        href: '#',
	                        onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__.showInviteMemberModal
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'tutorial_intro.invite',
	                        defaultMessage: 'Invite teammates'
	                    })
	                );
	            } else {
	                inviteModalLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'a',
	                    {
	                        className: 'intro-links',
	                        href: '#',
	                        onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_action_creators_global_actions_jsx__.showGetTeamInviteLinkModal
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'tutorial_intro.teamInvite',
	                        defaultMessage: 'Invite teammates'
	                    })
	                );
	            }
	
	            var circles = this.createCircles();
	
	            var supportInfo = null;
	            if (global.window.mm_config.SupportEmail) {
	                supportInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'p',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'tutorial_intro.support',
	                        defaultMessage: 'Need anything, just email us at '
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'a',
	                        {
	                            href: 'mailto:' + global.window.mm_config.SupportEmail,
	                            target: '_blank'
	                        },
	                        global.window.mm_config.SupportEmail
	                    ),
	                    '.'
	                );
	            }
	
	            var townSquareDisplayName = /* harmony import */__WEBPACK_IMPORTED_MODULE_11_utils_constants_jsx__["a"].DEFAULT_CHANNEL_UI_NAME;
	            if (this.props.townSquare) {
	                townSquareDisplayName = this.props.townSquare.display_name;
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'h3',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'tutorial_intro.allSet',
	                        defaultMessage: 'You’re all set'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'p',
	                    null,
	                    inviteModalLink,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                        id: 'tutorial_intro.whenReady',
	                        defaultMessage: ' when you’re ready.'
	                    })
	                ),
	                supportInfo,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                    id: 'tutorial_intro.end',
	                    defaultMessage: 'Click “Next” to enter {channel}. This is the first channel teammates see when they sign up. Use it for posting updates everyone needs to know.',
	                    values: {
	                        channel: townSquareDisplayName
	                    }
	                }),
	                circles
	            );
	        }
	    }, {
	        key: 'createCircles',
	        value: function createCircles() {
	            var _this2 = this;
	
	            var circles = [];
	
	            var _loop = function _loop(i) {
	                var className = 'circle';
	                if (i === _this2.state.currentScreen) {
	                    className += ' active';
	                }
	
	                circles.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('a', {
	                    href: '#',
	                    key: 'circle' + i,
	                    className: className,
	                    onClick: function onClick(e) {
	                        //eslint-disable-line no-loop-func
	                        e.preventDefault();
	                        _this2.setState({ currentScreen: i });
	                    }
	                }));
	            };
	
	            for (var i = 0; i < NUM_SCREENS; i++) {
	                _loop(i);
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                { className: 'tutorial__circles' },
	                circles
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var height = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.windowHeight() - 100;
	            var screen = this.createScreen();
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                {
	                    className: 'tutorials__scroll',
	                    style: { height: height }
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'tutorial-steps__container' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'tutorial__content' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'tutorial__steps' },
	                            screen,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'div',
	                                { className: 'tutorial__footer' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-primary',
	                                        tabIndex: '1',
	                                        onClick: this.handleNext
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'tutorial_intro.next',
	                                        defaultMessage: 'Next'
	                                    })
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'a',
	                                    {
	                                        className: 'tutorial-skip',
	                                        href: '#',
	                                        onClick: this.skipTutorial
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"], {
	                                        id: 'tutorial_intro.skip',
	                                        defaultMessage: 'Skip tutorial'
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TutorialIntroScreens;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TutorialIntroScreens;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tutorial_intro_screens_jsx__ = __webpack_require__(765);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __WEBPACK_IMPORTED_MODULE_8_jquery__ && __WEBPACK_IMPORTED_MODULE_8_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var TutorialView = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(TutorialView, _React$Component);
	
	    function TutorialView(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, TutorialView);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(TutorialView).call(this, props));
	
	        _this.handleChannelChange = _this.handleChannelChange.bind(_this);
	
	        _this.state = {
	            townSquare: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getByName(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].DEFAULT_CHANNEL)
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(TutorialView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].addChangeListener(this.handleChannelChange);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()('body').addClass('app__body');
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].removeChangeListener(this.handleChannelChange);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()('body').removeClass('app__body');
	        }
	    }, {
	        key: 'handleChannelChange',
	        value: function handleChannelChange() {
	            this.setState({
	                townSquare: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getByName(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].DEFAULT_CHANNEL)
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                {
	                    id: 'app-content',
	                    className: 'app__content'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__tutorial_intro_screens_jsx__["a"], {
	                    townSquare: this.state.townSquare
	                })
	            );
	        }
	    }]);
	
	    return TutorialView;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = TutorialView;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	// Indicator for the left sidebar which indicate if there's unread posts in a channel that is not shown
	// because it is either above or below the screen
	
	
	var UnreadChannelIndicator = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UnreadChannelIndicator, _React$Component);
	
	    function UnreadChannelIndicator() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UnreadChannelIndicator);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UnreadChannelIndicator).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UnreadChannelIndicator, [{
	        key: 'render',
	        value: function render() {
	            var displayValue = 'none';
	            if (this.props.show) {
	                displayValue = 'block';
	            }
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                {
	                    className: 'nav-pills__unread-indicator ' + this.props.extraClass,
	                    style: { display: displayValue }
	                },
	                this.props.text
	            );
	        }
	    }]);
	
	    return UnreadChannelIndicator;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UnreadChannelIndicator;
	
	
	UnreadChannelIndicator.defaultProps = {
	    show: false,
	    extraClass: '',
	    text: ''
	};
	UnreadChannelIndicator.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.bool,
	    extraClass: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.string,
	    text: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object
	};

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_list_row_jsx__ = __webpack_require__(769);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	var UserList = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UserList, _React$Component);
	
	    function UserList() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserList);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserList).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UserList, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var users = this.props.users;
	
	            var content = void 0;
	            if (users.length > 0) {
	                content = users.map(function (user) {
	                    var teamMember;
	                    for (var index in _this2.props.teamMembers) {
	                        if (_this2.props.teamMembers[index].user_id === user.id) {
	                            teamMember = _this2.props.teamMembers[index];
	                        }
	                    }
	
	                    return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__user_list_row_jsx__["a"], {
	                        key: user.id,
	                        user: user,
	                        teamMember: teamMember,
	                        actions: _this2.props.actions,
	                        actionProps: _this2.props.actionProps
	                    });
	                });
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'no-users-found',
	                        className: 'no-channel-message'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'p',
	                        { className: 'primary-message' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'user_list.notFound',
	                            defaultMessage: 'No users found :('
	                        })
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                content
	            );
	        }
	    }]);
	
	    return UserList;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UserList;
	
	
	UserList.defaultProps = {
	    users: [],
	    teamMembers: [],
	    actions: [],
	    actionProps: {}
	};
	
	UserList.propTypes = {
	    users: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object),
	    teamMembers: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object),
	    actions: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.func),
	    actionProps: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.object
	};

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __WEBPACK_IMPORTED_MODULE_5_react__ && __WEBPACK_IMPORTED_MODULE_5_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react___default });
	/* harmony export */ exports["a"] = UserListRow;'use strict';
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	function UserListRow(_ref) {
	    var user = _ref.user;
	    var teamMember = _ref.teamMember;
	    var actions = _ref.actions;
	    var actionProps = _ref.actionProps;
	
	    var nameFormat = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_stores_preference_store_jsx__["a"].get(/* harmony import */__WEBPACK_IMPORTED_MODULE_1_utils_constants_jsx__["a"].Preferences.CATEGORY_DISPLAY_SETTINGS, 'name_format', '');
	
	    var name = user.username;
	    if (user.nickname && nameFormat === /* harmony import */__WEBPACK_IMPORTED_MODULE_1_utils_constants_jsx__["a"].Preferences.DISPLAY_PREFER_NICKNAME) {
	        name = user.nickname + ' (@' + user.username + ')';
	    } else if ((user.first_name || user.last_name) && (nameFormat === /* harmony import */__WEBPACK_IMPORTED_MODULE_1_utils_constants_jsx__["a"].Preferences.DISPLAY_PREFER_NICKNAME || nameFormat === /* harmony import */__WEBPACK_IMPORTED_MODULE_1_utils_constants_jsx__["a"].Preferences.DISPLAY_PREFER_FULL_NAME)) {
	        name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_3_utils_utils_jsx__.getFullName(user) + ' (@' + user.username + ')';
	    }
	
	    var buttons = actions.map(function (Action, index) {
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Action, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default.a.bind()({
	            key: index.toString(),
	            user: user,
	            teamMember: teamMember
	        }, actionProps));
	    });
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	        'div',
	        {
	            key: user.id,
	            className: 'more-modal__row'
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', {
	            className: 'more-modal__image',
	            width: '38',
	            height: '38',
	            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_4_utils_web_client_jsx__["a"].getUsersRoute() + '/' + user.id + '/image?time=' + user.update_at
	        }),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	            'div',
	            {
	                className: 'more-modal__details'
	            },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'more-modal__name' },
	                name
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	                'div',
	                { className: 'more-modal__description' },
	                user.email
	            )
	        ),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
	            'div',
	            {
	                className: 'more-modal__actions'
	            },
	            buttons
	        )
	    );
	}
	
	UserListRow.defaultProps = {
	    teamMember: {
	        team_id: '',
	        roles: ''
	    },
	    actions: [],
	    actionProps: {}
	};
	
	UserListRow.propTypes = {
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	    teamMember: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object.isRequired,
	    actions: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.arrayOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.func),
	    actionProps: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react___default.a.PropTypes.object
	};

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker__ = __webpack_require__(1286);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker___default = __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker__ && __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_bootstrap_colorpicker___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var messages = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["defineMessages"].bind()({
	    sidebarBg: {
	        id: 'user.settings.custom_theme.sidebarBg',
	        defaultMessage: 'Sidebar BG'
	    },
	    sidebarText: {
	        id: 'user.settings.custom_theme.sidebarText',
	        defaultMessage: 'Sidebar Text'
	    },
	    sidebarHeaderBg: {
	        id: 'user.settings.custom_theme.sidebarHeaderBg',
	        defaultMessage: 'Sidebar Header BG'
	    },
	    sidebarHeaderTextColor: {
	        id: 'user.settings.custom_theme.sidebarHeaderTextColor',
	        defaultMessage: 'Sidebar Header Text'
	    },
	    sidebarUnreadText: {
	        id: 'user.settings.custom_theme.sidebarUnreadText',
	        defaultMessage: 'Sidebar Unread Text'
	    },
	    sidebarTextHoverBg: {
	        id: 'user.settings.custom_theme.sidebarTextHoverBg',
	        defaultMessage: 'Sidebar Text Hover BG'
	    },
	    sidebarTextActiveBorder: {
	        id: 'user.settings.custom_theme.sidebarTextActiveBorder',
	        defaultMessage: 'Sidebar Text Active Border'
	    },
	    sidebarTextActiveColor: {
	        id: 'user.settings.custom_theme.sidebarTextActiveColor',
	        defaultMessage: 'Sidebar Text Active Color'
	    },
	    onlineIndicator: {
	        id: 'user.settings.custom_theme.onlineIndicator',
	        defaultMessage: 'Online Indicator'
	    },
	    awayIndicator: {
	        id: 'user.settings.custom_theme.awayIndicator',
	        defaultMessage: 'Away Indicator'
	    },
	    mentionBj: {
	        id: 'user.settings.custom_theme.mentionBj',
	        defaultMessage: 'Mention Jewel BG'
	    },
	    mentionColor: {
	        id: 'user.settings.custom_theme.mentionColor',
	        defaultMessage: 'Mention Jewel Text'
	    },
	    centerChannelBg: {
	        id: 'user.settings.custom_theme.centerChannelBg',
	        defaultMessage: 'Center Channel BG'
	    },
	    centerChannelColor: {
	        id: 'user.settings.custom_theme.centerChannelColor',
	        defaultMessage: 'Center Channel Text'
	    },
	    newMessageSeparator: {
	        id: 'user.settings.custom_theme.newMessageSeparator',
	        defaultMessage: 'New Message Separator'
	    },
	    linkColor: {
	        id: 'user.settings.custom_theme.linkColor',
	        defaultMessage: 'Link Color'
	    },
	    buttonBg: {
	        id: 'user.settings.custom_theme.buttonBg',
	        defaultMessage: 'Button BG'
	    },
	    buttonColor: {
	        id: 'user.settings.custom_theme.buttonColor',
	        defaultMessage: 'Button Text'
	    },
	    mentionHighlightBg: {
	        id: 'user.settings.custom_theme.mentionHighlightBg',
	        defaultMessage: 'Mention Highlight BG'
	    },
	    mentionHighlightLink: {
	        id: 'user.settings.custom_theme.mentionHighlightLink',
	        defaultMessage: 'Mention Highlight Link'
	    },
	    codeTheme: {
	        id: 'user.settings.custom_theme.codeTheme',
	        defaultMessage: 'Code Theme'
	    }
	});
	
	
	
	var CustomThemeChooser = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(CustomThemeChooser, _React$Component);
	
	    function CustomThemeChooser(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, CustomThemeChooser);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(CustomThemeChooser).call(this, props));
	
	        _this.onPickerChange = _this.onPickerChange.bind(_this);
	        _this.onInputChange = _this.onInputChange.bind(_this);
	        _this.pasteBoxChange = _this.pasteBoxChange.bind(_this);
	        _this.toggleContent = _this.toggleContent.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(CustomThemeChooser, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.color-picker').colorpicker({
	                format: 'hex'
	            });
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.color-picker').on('changeColor', this.onPickerChange);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var theme = this.props.theme;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].THEME_ELEMENTS.forEach(function (element) {
	                if (theme.hasOwnProperty(element.id) && element.id !== 'codeTheme') {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#' + element.id).data('colorpicker').color.setColor(theme[element.id]);
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('#' + element.id).colorpicker('update');
	                }
	            });
	        }
	    }, {
	        key: 'onPickerChange',
	        value: function onPickerChange(e) {
	            var theme = this.props.theme;
	            theme[e.target.id] = e.color.toHex();
	            theme.type = 'custom';
	            this.props.updateTheme(theme);
	        }
	    }, {
	        key: 'onInputChange',
	        value: function onInputChange(e) {
	            var theme = this.props.theme;
	            theme[e.target.parentNode.id] = e.target.value;
	            theme.type = 'custom';
	            this.props.updateTheme(theme);
	        }
	    }, {
	        key: 'pasteBoxChange',
	        value: function pasteBoxChange(e) {
	            var text = e.target.value;
	
	            if (text.length === 0) {
	                return;
	            }
	
	            var colors = text.split(',');
	
	            var theme = { type: 'custom' };
	            var index = 0;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].THEME_ELEMENTS.forEach(function (element) {
	                if (index < colors.length - 1) {
	                    theme[element.id] = colors[index];
	                }
	                index++;
	            });
	            theme.codeTheme = colors[colors.length - 1];
	
	            this.props.updateTheme(theme);
	        }
	    }, {
	        key: 'toggleContent',
	        value: function toggleContent(e) {
	            e.stopPropagation();
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).hasClass('theme-elements__header')) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).next().slideToggle();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).toggleClass('open');
	            } else {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).closest('.theme-elements__header').next().slideToggle();
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(e.target).closest('.theme-elements__header').toggleClass('open');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var theme = this.props.theme;
	
	            var sidebarElements = [];
	            var centerChannelElements = [];
	            var linkAndButtonElements = [];
	            var colors = '';
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].THEME_ELEMENTS.forEach(function (element, index) {
	                if (element.id === 'codeTheme') {
	                    var popoverContent;
	
	                    (function () {
	                        var codeThemeOptions = [];
	                        var codeThemeURL = '';
	
	                        element.themes.forEach(function (codeTheme, codeThemeIndex) {
	                            if (codeTheme.id === theme[element.id]) {
	                                codeThemeURL = codeTheme.iconURL;
	                            }
	                            codeThemeOptions.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'option',
	                                {
	                                    key: 'code-theme-key' + codeThemeIndex,
	                                    value: codeTheme.id
	                                },
	                                codeTheme.uiName
	                            ));
	                        });
	
	                        popoverContent = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["Popover"],
	                            {
	                                bsStyle: 'info',
	                                id: 'code-popover',
	                                className: 'code-popover'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
	                                width: '200',
	                                src: codeThemeURL
	                            })
	                        );
	
	
	                        centerChannelElements.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'col-sm-6 form-group',
	                                key: 'custom-theme-key' + index
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'label',
	                                { className: 'custom-label' },
	                                formatMessage(messages[element.id])
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'div',
	                                {
	                                    className: 'input-group theme-group group--code dropdown',
	                                    id: element.id
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    'select',
	                                    {
	                                        className: 'form-control',
	                                        type: 'text',
	                                        value: theme[element.id],
	                                        onChange: _this2.onInputChange
	                                    },
	                                    codeThemeOptions
	                                ),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["OverlayTrigger"],
	                                    {
	                                        placement: 'top',
	                                        overlay: popoverContent,
	                                        ref: 'headerOverlay'
	                                    },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                        'span',
	                                        { className: 'input-group-addon' },
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('img', {
	                                            src: codeThemeURL
	                                        })
	                                    )
	                                )
	                            )
	                        ));
	                    })();
	                } else if (element.group === 'centerChannelElements') {
	                    centerChannelElements.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'col-sm-6 form-group element',
	                            key: 'custom-theme-key' + index
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'custom-label' },
	                            formatMessage(messages[element.id])
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'input-group color-picker',
	                                id: element.id
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                value: theme[element.id],
	                                onChange: _this2.onInputChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', null)
	                            )
	                        )
	                    ));
	
	                    colors += theme[element.id] + ',';
	                } else if (element.group === 'sidebarElements') {
	                    sidebarElements.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'col-sm-6 form-group element',
	                            key: 'custom-theme-key' + index
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'custom-label' },
	                            formatMessage(messages[element.id])
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'input-group color-picker',
	                                id: element.id
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                value: theme[element.id],
	                                onChange: _this2.onInputChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', null)
	                            )
	                        )
	                    ));
	
	                    colors += theme[element.id] + ',';
	                } else {
	                    linkAndButtonElements.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'col-sm-6 form-group element',
	                            key: 'custom-theme-key' + index
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'label',
	                            { className: 'custom-label' },
	                            formatMessage(messages[element.id])
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'input-group color-picker',
	                                id: element.id
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                value: theme[element.id],
	                                onChange: _this2.onInputChange
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                                'span',
	                                { className: 'input-group-addon' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', null)
	                            )
	                        )
	                    ));
	
	                    colors += theme[element.id] + ',';
	                }
	            });
	
	            colors += theme.codeTheme;
	
	            var pasteBox = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'col-sm-12' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'label',
	                    { className: 'custom-label' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.custom_theme.copyPaste',
	                        defaultMessage: 'Copy and paste to share theme colors:'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', {
	                    type: 'text',
	                    className: 'form-control',
	                    value: colors,
	                    onChange: this.pasteBoxChange
	                })
	            );
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { className: 'appearance-section padding-top' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'theme-elements row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'theme-elements__header',
	                            onClick: this.toggleContent
	                        },
	                        'Sidebar Styles',
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'header__icon' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa-plus' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa-minus' })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'theme-elements__body' },
	                        sidebarElements
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'theme-elements row' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'theme-elements__header',
	                            onClick: this.toggleContent
	                        },
	                        'Center Channel Styles',
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'header__icon' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa-plus' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa-minus' })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'theme-elements__body' },
	                        centerChannelElements
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'theme-elements row form-group' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'theme-elements__header',
	                            onClick: this.toggleContent
	                        },
	                        'Link and Button Styles',
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                            'div',
	                            { className: 'header__icon' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa-plus' }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('i', { className: 'fa fa-minus' })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'div',
	                        { className: 'theme-elements__body' },
	                        linkAndButtonElements
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'row' },
	                    pasteBox
	                )
	            );
	        }
	    }]);
	
	    return CustomThemeChooser;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	CustomThemeChooser.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["intlShape"].isRequired,
	    theme: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired,
	    updateTheme: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["injectIntl"].bind()(CustomThemeChooser);

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __WEBPACK_IMPORTED_MODULE_5_react_dom__ && __WEBPACK_IMPORTED_MODULE_5_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["defineMessages"].bind()({
	    submitError: {
	        id: 'user.settings.import_theme.submitError',
	        defaultMessage: 'Invalid format, please try copying and pasting in again.'
	    }
	});
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].ActionTypes;
	
	
	
	var ImportThemeModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ImportThemeModal, _React$Component);
	
	    function ImportThemeModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ImportThemeModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ImportThemeModal).call(this, props));
	
	        _this.updateShow = _this.updateShow.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	
	        _this.state = {
	            inputError: '',
	            show: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ImportThemeModal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].addModalListener(ActionTypes.TOGGLE_IMPORT_THEME_MODAL, this.updateShow);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_modal_store_jsx__["a"].removeModalListener(ActionTypes.TOGGLE_IMPORT_THEME_MODAL, this.updateShow);
	        }
	    }, {
	        key: 'updateShow',
	        value: function updateShow(show) {
	            this.setState({ show: show });
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var text = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.refs.input).value;
	
	            if (!this.isInputValid(text)) {
	                this.setState({ inputError: this.props.intl.formatMessage(holders.submitError) });
	                return;
	            }
	
	            var colors = text.split(',');
	            var theme = { type: 'custom' };
	
	            theme.sidebarBg = colors[0];
	            theme.sidebarText = colors[5];
	            theme.sidebarUnreadText = colors[5];
	            theme.sidebarTextHoverBg = colors[4];
	            theme.sidebarTextActiveBorder = colors[2];
	            theme.sidebarTextActiveColor = colors[3];
	            theme.sidebarHeaderBg = colors[1];
	            theme.sidebarHeaderTextColor = colors[5];
	            theme.onlineIndicator = colors[6];
	            theme.awayIndicator = '#E0B333';
	            theme.mentionBj = colors[7];
	            theme.mentionColor = '#ffffff';
	            theme.centerChannelBg = '#ffffff';
	            theme.centerChannelColor = '#333333';
	            theme.newMessageSeparator = '#F80';
	            theme.linkColor = '#2389d7';
	            theme.buttonBg = '#26a970';
	            theme.buttonColor = '#ffffff';
	            theme.mentionHighlightBg = '#fff2bb';
	            theme.mentionHighlightLink = '#2f81b7';
	            theme.codeTheme = 'github';
	
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].getCurrentUser();
	            user.theme_props = theme;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_utils_web_client_jsx__["a"].updateUser(user, function (data) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_11__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_ME,
	                    me: data
	                });
	
	                _this2.setState({ show: false });
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.applyTheme(theme);
	            }, function (err) {
	                var state = _this2.getStateFromStores();
	                state.serverError = err;
	                _this2.setState(state);
	            });
	        }
	    }, {
	        key: 'isInputValid',
	        value: function isInputValid(text) {
	            if (text.length === 0) {
	                return false;
	            }
	
	            if (text.indexOf(' ') !== -1) {
	                return false;
	            }
	
	            if (text.length > 0 && text.indexOf(',') === -1) {
	                return false;
	            }
	
	            if (text.length > 0) {
	                var colors = text.split(',');
	
	                if (colors.length !== 8) {
	                    return false;
	                }
	
	                for (var i = 0; i < colors.length; i++) {
	                    if (colors[i].length !== 7 && colors[i].length !== 4) {
	                        return false;
	                    }
	
	                    if (colors[i].charAt(0) !== '#') {
	                        return false;
	                    }
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            if (this.isInputValid(e.target.value)) {
	                this.setState({ inputError: null });
	            } else {
	                this.setState({ inputError: this.props.intl.formatMessage(holders.submitError) });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'span',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"],
	                    {
	                        show: this.state.show,
	                        onHide: function onHide() {
	                            return _this3.setState({ show: false });
	                        }
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Header,
	                        { closeButton: true },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Title,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.import_theme.importHeader',
	                                defaultMessage: 'Import Slack Theme'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'form',
	                        {
	                            role: 'form',
	                            className: 'form-horizontal'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Body,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'p',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.import_theme.importBody',
	                                    defaultMessage: 'To import a theme, go to a Slack team and look for “Preferences -> Sidebar Theme”. Open the custom theme option, copy the theme color values and paste them here:'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'div',
	                                { className: 'form-group less' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                    'div',
	                                    { className: 'col-sm-9' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                        ref: 'input',
	                                        type: 'text',
	                                        className: 'form-control',
	                                        onChange: this.handleChange
	                                    }),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                        'div',
	                                        { className: 'input__help' },
	                                        this.state.inputError
	                                    )
	                                )
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["Modal"].Footer,
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    className: 'btn btn-default',
	                                    onClick: function onClick() {
	                                        return _this3.setState({ show: false });
	                                    }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.import_theme.cancel',
	                                    defaultMessage: 'Cancel'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'button',
	                                {
	                                    onClick: this.handleSubmit,
	                                    type: 'submit',
	                                    className: 'btn btn-primary',
	                                    tabIndex: '3'
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.import_theme.submit',
	                                    defaultMessage: 'Submit'
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ImportThemeModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	ImportThemeModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["intlShape"].isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["injectIntl"].bind()(ImportThemeModal);

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_i18n_jsx__ = __webpack_require__(190);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __WEBPACK_IMPORTED_MODULE_10_react__ && __WEBPACK_IMPORTED_MODULE_10_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Spinpunch, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var ManageLanguage = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ManageLanguage, _React$Component);
	
	    function ManageLanguage(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ManageLanguage);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ManageLanguage).call(this, props));
	
	        _this.setupInitialState = _this.setupInitialState.bind(_this);
	        _this.setLanguage = _this.setLanguage.bind(_this);
	        _this.changeLanguage = _this.changeLanguage.bind(_this);
	        _this.submitUser = _this.submitUser.bind(_this);
	        _this.state = _this.setupInitialState(props);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ManageLanguage, [{
	        key: 'setupInitialState',
	        value: function setupInitialState(props) {
	            var user = props.user;
	            return {
	                locale: user.locale
	            };
	        }
	    }, {
	        key: 'setLanguage',
	        value: function setLanguage(e) {
	            this.setState({ locale: e.target.value });
	        }
	    }, {
	        key: 'changeLanguage',
	        value: function changeLanguage(e) {
	            e.preventDefault();
	
	            var user = this.props.user;
	            var locale = this.state.locale;
	
	            user.locale = locale;
	
	            this.submitUser(user);
	        }
	    }, {
	        key: 'submitUser',
	        value: function submitUser(user) {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_web_client_jsx__["a"].updateUser(user, function () {
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_action_creators_global_actions_jsx__.newLocalizationSelected(user.locale);
	            }, function (err) {
	                var serverError = void 0;
	                if (err.message) {
	                    serverError = err.message;
	                } else {
	                    serverError = err;
	                }
	                _this2.setState({ serverError: serverError });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var serverError = void 0;
	            if (this.state.serverError) {
	                serverError = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'label',
	                    { className: 'has-error' },
	                    this.state.serverError
	                );
	            }
	
	            var options = [];
	            var languages = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_i18n_i18n_jsx__.getLanguages();
	            for (var key in languages) {
	                if (languages.hasOwnProperty(key)) {
	                    var lang = languages[key];
	                    options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'option',
	                        {
	                            key: lang.value,
	                            value: lang.value
	                        },
	                        lang.name
	                    ));
	                }
	            }
	
	            var input = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                'div',
	                { key: 'changeLanguage' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br', null),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'label',
	                    { className: 'control-label' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.languages.change',
	                        defaultMessage: 'Change interface language'
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                    'div',
	                    { className: 'padding-top' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
	                        'select',
	                        {
	                            ref: 'language',
	                            className: 'form-control',
	                            value: this.state.locale,
	                            onChange: this.setLanguage
	                        },
	                        options
	                    ),
	                    serverError
	                )
	            );
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__setting_item_max_jsx__["a"], {
	                title: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.display.language',
	                    defaultMessage: 'Language'
	                }),
	                width: 'medium',
	                submit: this.changeLanguage,
	                inputs: [input],
	                updateSection: this.props.updateSection
	            });
	        }
	    }]);
	
	    return ManageLanguage;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ManageLanguage;
	
	
	ManageLanguage.propTypes = {
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.object.isRequired,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __WEBPACK_IMPORTED_MODULE_8_react__ && __WEBPACK_IMPORTED_MODULE_8_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl___default = __WEBPACK_IMPORTED_MODULE_9_react_intl__ && __WEBPACK_IMPORTED_MODULE_9_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react_intl___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	var PremadeThemeChooser = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(PremadeThemeChooser, _React$Component);
	
	    function PremadeThemeChooser(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, PremadeThemeChooser);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(PremadeThemeChooser).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(PremadeThemeChooser, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var theme = this.props.theme;
	
	            var premadeThemes = [];
	            for (var k in /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].THEMES) {
	                if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].THEMES.hasOwnProperty(k)) {
	                    (function () {
	                        var premadeTheme = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.extend(true, {}, /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].THEMES[k]);
	
	                        var activeClass = '';
	                        if (premadeTheme.type === theme.type) {
	                            activeClass = 'active';
	                        }
	
	                        premadeThemes.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'col-xs-6 col-sm-3 premade-themes',
	                                key: 'premade-theme-key' + k
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                'div',
	                                {
	                                    className: activeClass,
	                                    onClick: function onClick() {
	                                        return _this2.props.updateTheme(premadeTheme);
	                                    }
	                                },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                    'label',
	                                    null,
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img', {
	                                        className: 'img-responsive',
	                                        src: premadeTheme.image
	                                    }),
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                                        'div',
	                                        { className: 'theme-label' },
	                                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.toTitleCase(premadeTheme.type)
	                                    )
	                                )
	                            )
	                        ));
	                    })();
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                'div',
	                { className: 'row appearance-section' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'clearfix' },
	                    premadeThemes
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                    'div',
	                    { className: 'clearfix' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-12 padding-bottom x2' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
	                            'a',
	                            {
	                                href: 'http://docs.mattermost.com/help/settings/theme-colors.html#custom-theme-examples',
	                                target: '_blank'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.display.theme.otherThemes',
	                                defaultMessage: 'See other themes'
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PremadeThemeChooser;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = PremadeThemeChooser;
	
	
	PremadeThemeChooser.propTypes = {
	    theme: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.object.isRequired,
	    updateTheme: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_settings_notifications_jsx__ = __webpack_require__(779);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_settings_security_jsx__ = __webpack_require__(780);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_settings_general_jsx__ = __webpack_require__(778);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_settings_developer_jsx__ = __webpack_require__(776);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_settings_display_jsx__ = __webpack_require__(777);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_settings_advanced_jsx__ = __webpack_require__(775);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __WEBPACK_IMPORTED_MODULE_13_react__ && __WEBPACK_IMPORTED_MODULE_13_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	var UserSettings = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(UserSettings, _React$Component);
	
	    function UserSettings(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserSettings);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserSettings).call(this, props));
	
	        _this.getActiveTab = _this.getActiveTab.bind(_this);
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	
	        _this.state = { user: /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentUser() };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(UserSettings, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].addChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'getActiveTab',
	        value: function getActiveTab() {
	            return this.refs.activeTab;
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_user_store_jsx__["a"].getCurrentUser();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_utils_jsx__.areObjectsEqual(this.state.user, user)) {
	                this.setState({ user: user });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.activeTab === 'general') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__user_settings_general_jsx__["a"], {
	                        ref: 'activeTab',
	                        user: this.state.user,
	                        activeSection: this.props.activeSection,
	                        updateSection: this.props.updateSection,
	                        updateTab: this.props.updateTab,
	                        closeModal: this.props.closeModal,
	                        collapseModal: this.props.collapseModal
	                    })
	                );
	            } else if (this.props.activeTab === 'security') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__user_settings_security_jsx__["a"], {
	                        ref: 'activeTab',
	                        user: this.state.user,
	                        activeSection: this.props.activeSection,
	                        updateSection: this.props.updateSection,
	                        updateTab: this.props.updateTab,
	                        closeModal: this.props.closeModal,
	                        collapseModal: this.props.collapseModal,
	                        setEnforceFocus: this.props.setEnforceFocus
	                    })
	                );
	            } else if (this.props.activeTab === 'notifications') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__user_settings_notifications_jsx__["a"], {
	                        ref: 'activeTab',
	                        user: this.state.user,
	                        activeSection: this.props.activeSection,
	                        updateSection: this.props.updateSection,
	                        updateTab: this.props.updateTab,
	                        closeModal: this.props.closeModal,
	                        collapseModal: this.props.collapseModal
	                    })
	                );
	            } else if (this.props.activeTab === 'developer') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__user_settings_developer_jsx__["a"], {
	                        ref: 'activeTab',
	                        activeSection: this.props.activeSection,
	                        updateSection: this.props.updateSection,
	                        closeModal: this.props.closeModal,
	                        collapseModal: this.props.collapseModal
	                    })
	                );
	            } else if (this.props.activeTab === 'display') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__user_settings_display_jsx__["a"], {
	                        ref: 'activeTab',
	                        user: this.state.user,
	                        activeSection: this.props.activeSection,
	                        updateSection: this.props.updateSection,
	                        updateTab: this.props.updateTab,
	                        closeModal: this.props.closeModal,
	                        collapseModal: this.props.collapseModal,
	                        setEnforceFocus: this.props.setEnforceFocus,
	                        setRequireConfirm: this.props.setRequireConfirm
	                    })
	                );
	            } else if (this.props.activeTab === 'advanced') {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__user_settings_advanced_jsx__["a"], {
	                        ref: 'activeTab',
	                        user: this.state.user,
	                        activeSection: this.props.activeSection,
	                        updateSection: this.props.updateSection,
	                        updateTab: this.props.updateTab,
	                        closeModal: this.props.closeModal,
	                        collapseModal: this.props.collapseModal
	                    })
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement('div', null);
	        }
	    }]);
	
	    return UserSettings;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UserSettings;
	
	
	UserSettings.propTypes = {
	    activeTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.string,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired,
	    setEnforceFocus: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired,
	    setRequireConfirm: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __WEBPACK_IMPORTED_MODULE_8_jquery__ && __WEBPACK_IMPORTED_MODULE_8_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __WEBPACK_IMPORTED_MODULE_15_react_intl__ && __WEBPACK_IMPORTED_MODULE_15_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __WEBPACK_IMPORTED_MODULE_16_react__ && __WEBPACK_IMPORTED_MODULE_16_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react___default });
	'use strict';
	
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	var PreReleaseFeatures = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].PRE_RELEASE_FEATURES;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["defineMessages"].bind()({
	    sendTitle: {
	        id: 'user.settings.advance.sendTitle',
	        defaultMessage: 'Send messages on Ctrl + Enter'
	    },
	    on: {
	        id: 'user.settings.advance.on',
	        defaultMessage: 'On'
	    },
	    off: {
	        id: 'user.settings.advance.off',
	        defaultMessage: 'Off'
	    },
	    preReleaseTitle: {
	        id: 'user.settings.advance.preReleaseTitle',
	        defaultMessage: 'Preview pre-release features'
	    },
	    feature: {
	        id: 'user.settings.advance.feature',
	        defaultMessage: ' Feature '
	    },
	    features: {
	        id: 'user.settings.advance.features',
	        defaultMessage: ' Features '
	    },
	    enabled: {
	        id: 'user.settings.advance.enabled',
	        defaultMessage: 'enabled'
	    },
	    MARKDOWN_PREVIEW: {
	        id: 'user.settings.advance.markdown_preview',
	        defaultMessage: 'Show markdown preview option in message input box'
	    },
	    EMBED_PREVIEW: {
	        id: 'user.settings.advance.embed_preview',
	        defaultMessage: 'Show preview snippet of links below message'
	    },
	    EMBED_TOGGLE: {
	        id: 'user.settings.advance.embed_toggle',
	        defaultMessage: 'Show toggle for all embed previews'
	    }
	});
	
	
	
	var AdvancedSettingsDisplay = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default.a.bind()(AdvancedSettingsDisplay, _React$Component);
	
	    function AdvancedSettingsDisplay(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, AdvancedSettingsDisplay);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(AdvancedSettingsDisplay).call(this, props));
	
	        _this.updateSection = _this.updateSection.bind(_this);
	        _this.updateSetting = _this.updateSetting.bind(_this);
	        _this.toggleFeature = _this.toggleFeature.bind(_this);
	        _this.saveEnabledFeatures = _this.saveEnabledFeatures.bind(_this);
	
	        var preReleaseFeaturesKeys = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default.a.bind()(PreReleaseFeatures);
	        var advancedSettings = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_preference_store_jsx__["a"].getCategory(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS);
	        var settings = {
	            send_on_ctrl_enter: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_preference_store_jsx__["a"].get(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter', 'false')
	        };
	
	        var enabledFeatures = 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(advancedSettings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _step$value = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default.a.bind()(_step.value, 2);
	
	                var name = _step$value[0];
	                var value = _step$value[1];
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default.a.bind()(preReleaseFeaturesKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var key = _step2.value;
	
	                        var feature = PreReleaseFeatures[key];
	
	                        if (name === /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FeatureTogglePrefix + feature.label) {
	                            settings[name] = value;
	
	                            if (value === 'true') {
	                                enabledFeatures += 1;
	                            }
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        _this.state = { preReleaseFeatures: PreReleaseFeatures, settings: settings, preReleaseFeaturesKeys: preReleaseFeaturesKeys, enabledFeatures: enabledFeatures };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default.a.bind()(AdvancedSettingsDisplay, [{
	        key: 'updateSetting',
	        value: function updateSetting(setting, value) {
	            var settings = this.state.settings;
	            settings[setting] = value;
	            this.setState(settings);
	        }
	    }, {
	        key: 'toggleFeature',
	        value: function toggleFeature(feature, checked) {
	            var _this2 = this;
	
	            var settings = this.state.settings;
	            settings[/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FeatureTogglePrefix + feature] = String(checked);
	
	            var enabledFeatures = 0;
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default.a.bind()(this.state.settings).forEach(function (setting) {
	                if (setting.lastIndexOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FeatureTogglePrefix) === 0 && _this2.state.settings[setting] === 'true') {
	                    enabledFeatures++;
	                }
	            });
	
	            this.setState({ settings: settings, enabledFeatures: enabledFeatures });
	        }
	    }, {
	        key: 'saveEnabledFeatures',
	        value: function saveEnabledFeatures() {
	            var features = [];
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default.a.bind()(this.state.settings).forEach(function (setting) {
	                if (setting.lastIndexOf(/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FeatureTogglePrefix) === 0) {
	                    features.push(setting);
	                }
	            });
	
	            this.handleSubmit(features);
	        }
	    }, {
	        key: 'handleSubmit',
	        value: function handleSubmit(settings) {
	            var _this3 = this;
	
	            var preferences = [];
	            var userId = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_stores_user_store_jsx__["a"].getCurrentId();
	
	            // this should be refactored so we can actually be certain about what type everything is
	            (Array.isArray(settings) ? settings : [settings]).forEach(function (setting) {
	                preferences.push({
	                    user_id: userId,
	                    category: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].Preferences.CATEGORY_ADVANCED_SETTINGS,
	                    name: setting,
	                    value: _this3.state.settings[setting]
	                });
	            });
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_async_client_jsx__.savePreferences(preferences, function () {
	                _this3.updateSection('');
	            }, function (err) {
	                _this3.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'updateSection',
	        value: function updateSection(section) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            this.props.updateSection(section);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var serverError = this.state.serverError || null;
	            var formatMessage = this.props.intl.formatMessage;
	
	            var ctrlSendSection = void 0;
	
	            if (this.props.activeSection === 'advancedCtrlSend') {
	                var ctrlSendActive = [this.state.settings.send_on_ctrl_enter === 'true', this.state.settings.send_on_ctrl_enter === 'false'];
	
	                var inputs = [/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { key: 'ctrlSendSetting' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: ctrlSendActive[0],
	                                onChange: this.updateSetting.bind(this, 'send_on_ctrl_enter', 'true')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.advance.on',
	                                defaultMessage: 'On'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: ctrlSendActive[1],
	                                onChange: this.updateSetting.bind(this, 'send_on_ctrl_enter', 'false')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.advance.off',
	                                defaultMessage: 'Off'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.advance.sendDesc',
	                            defaultMessage: 'If enabled \'Enter\' inserts a new line and \'Ctrl + Enter\' submits the message.'
	                        })
	                    )
	                )];
	
	                ctrlSendSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.sendTitle),
	                    inputs: inputs,
	                    submit: function submit() {
	                        return _this4.handleSubmit('send_on_ctrl_enter');
	                    },
	                    server_error: serverError,
	                    updateSection: function updateSection(e) {
	                        _this4.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                ctrlSendSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.sendTitle),
	                    describe: this.state.settings.send_on_ctrl_enter === 'true' ? formatMessage(holders.on) : formatMessage(holders.off),
	                    updateSection: function updateSection() {
	                        return _this4.props.updateSection('advancedCtrlSend');
	                    }
	                });
	            }
	
	            var previewFeaturesSection = void 0;
	            var previewFeaturesSectionDivider = void 0;
	            if (this.state.preReleaseFeaturesKeys.length > 0) {
	                previewFeaturesSectionDivider = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', { className: 'divider-light' });
	
	                if (this.props.activeSection === 'advancedPreviewFeatures') {
	                    (function () {
	                        var inputs = [];
	
	                        _this4.state.preReleaseFeaturesKeys.forEach(function (key) {
	                            var feature = _this4.state.preReleaseFeatures[key];
	                            inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                'div',
	                                { key: 'advancedPreviewFeatures_' + feature.label },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                    'div',
	                                    { className: 'checkbox' },
	                                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                                        'label',
	                                        null,
	                                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('input', {
	                                            type: 'checkbox',
	                                            checked: _this4.state.settings[/* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_constants_jsx__["a"].FeatureTogglePrefix + feature.label] === 'true',
	                                            onChange: function onChange(e) {
	                                                _this4.toggleFeature(feature.label, e.target.checked);
	                                            }
	                                        }),
	                                        formatMessage(holders[key])
	                                    )
	                                )
	                            ));
	                        });
	
	                        inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { key: 'advancedPreviewFeatures_helptext' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('br', null),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.advance.preReleaseDesc',
	                                defaultMessage: 'Check any pre-released features you\'d like to preview.  You may also need to refresh the page before the setting will take effect.'
	                            })
	                        ));
	
	                        previewFeaturesSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__setting_item_max_jsx__["a"], {
	                            title: formatMessage(holders.preReleaseTitle),
	                            inputs: inputs,
	                            submit: _this4.saveEnabledFeatures,
	                            server_error: serverError,
	                            updateSection: function updateSection(e) {
	                                _this4.updateSection('');
	                                e.preventDefault();
	                            }
	                        });
	                    })();
	                } else {
	                    previewFeaturesSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__setting_item_min_jsx__["a"], {
	                        title: formatMessage(holders.preReleaseTitle),
	                        describe: this.state.enabledFeatures + (this.state.enabledFeatures === 1 ? formatMessage(holders.feature) : formatMessage(holders.features)) + formatMessage(holders.enabled),
	                        updateSection: function updateSection() {
	                            return _this4.props.updateSection('advancedPreviewFeatures');
	                        }
	                    });
	                }
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close',
	                            onClick: this.props.closeModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('i', {
	                                className: 'fa fa-angle-left',
	                                onClick: this.props.collapseModal
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.advance.title',
	                            defaultMessage: 'Advanced Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                    'div',
	                    { className: 'user-settings' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.advance.title',
	                            defaultMessage: 'Advanced Settings'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    ctrlSendSection,
	                    previewFeaturesSectionDivider,
	                    previewFeaturesSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div', { className: 'divider-dark' })
	                )
	            );
	        }
	    }]);
	
	    return AdvancedSettingsDisplay;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);
	
	AdvancedSettingsDisplay.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["intlShape"].isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.object,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.string,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_15_react_intl__["injectIntl"].bind()(AdvancedSettingsDisplay);

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __WEBPACK_IMPORTED_MODULE_8_react_intl__ && __WEBPACK_IMPORTED_MODULE_8_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["defineMessages"].bind()({
	    applicationsPreview: {
	        id: 'user.settings.developer.applicationsPreview',
	        defaultMessage: 'Applications (Preview)'
	    },
	    thirdParty: {
	        id: 'user.settings.developer.thirdParty',
	        defaultMessage: 'Open to register a new third-party application'
	    }
	});
	
	
	
	var DeveloperTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(DeveloperTab, _React$Component);
	
	    function DeveloperTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DeveloperTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(DeveloperTab).call(this, props));
	
	        _this.register = _this.register.bind(_this);
	
	        _this.state = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(DeveloperTab, [{
	        key: 'register',
	        value: function register() {
	            this.props.closeModal();
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__.showRegisterAppModal();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var appSection;
	            var self = this;
	            var formatMessage = this.props.intl.formatMessage;
	
	            if (this.props.activeSection === 'app') {
	                var inputs = [];
	
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'registerbtn',
	                        className: 'form-group'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'div',
	                        { className: 'col-sm-7' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'btn btn-sm btn-primary',
	                                onClick: this.register
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.developer.register',
	                                defaultMessage: 'Register New Application'
	                            })
	                        )
	                    )
	                ));
	
	                appSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_6__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.applicationsPreview),
	                    inputs: inputs,
	                    updateSection: function updateSection(e) {
	                        self.props.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                appSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.applicationsPreview),
	                    describe: formatMessage(holders.thirdParty),
	                    updateSection: function updateSection() {
	                        self.props.updateSection('app');
	                    }
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close',
	                            onClick: this.props.closeModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', {
	                                className: 'fa fa-angle-left',
	                                onClick: this.props.collapseModal
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.developer.title',
	                            defaultMessage: 'Developer Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'div',
	                    { className: 'user-settings' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.developer.title',
	                            defaultMessage: 'Developer Settings'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    appSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('div', { className: 'divider-dark' })
	                )
	            );
	        }
	    }]);
	
	    return DeveloperTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
	
	DeveloperTab.defaultProps = {
	    activeSection: ''
	};
	DeveloperTab.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["intlShape"].isRequired,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.string,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_intl__["injectIntl"].bind()(DeveloperTab);

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__manage_languages_jsx__ = __webpack_require__(772);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_settings_theme_jsx__ = __webpack_require__(781);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_i18n_i18n_jsx__ = __webpack_require__(190);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __WEBPACK_IMPORTED_MODULE_17_react_intl__ && __WEBPACK_IMPORTED_MODULE_17_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __WEBPACK_IMPORTED_MODULE_18_react__ && __WEBPACK_IMPORTED_MODULE_18_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var Preferences = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].Preferences;
	
	
	
	function getDisplayStateFromStores() {
	    return {
	        militaryTime: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, 'use_military_time', 'false'),
	        nameFormat: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, 'name_format', 'username'),
	        selectedFont: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, 'selected_font', /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].DEFAULT_FONT),
	        channelDisplayMode: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_preference_store_jsx__["a"].get(Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.CHANNEL_DISPLAY_MODE, Preferences.CHANNEL_DISPLAY_MODE_DEFAULT)
	    };
	}
	
	
	
	var UserSettingsDisplay = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(UserSettingsDisplay, _React$Component);
	
	    function UserSettingsDisplay(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserSettingsDisplay);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserSettingsDisplay).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleClockRadio = _this.handleClockRadio.bind(_this);
	        _this.handleNameRadio = _this.handleNameRadio.bind(_this);
	        _this.handleFont = _this.handleFont.bind(_this);
	        _this.updateSection = _this.updateSection.bind(_this);
	        _this.updateState = _this.updateState.bind(_this);
	        _this.deactivate = _this.deactivate.bind(_this);
	
	        _this.state = getDisplayStateFromStores();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(UserSettingsDisplay, [{
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            var _this2 = this;
	
	            var userId = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_user_store_jsx__["a"].getCurrentId();
	
	            var timePreference = {
	                user_id: userId,
	                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
	                name: 'use_military_time',
	                value: this.state.militaryTime
	            };
	            var namePreference = {
	                user_id: userId,
	                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
	                name: 'name_format',
	                value: this.state.nameFormat
	            };
	            var fontPreference = {
	                user_id: userId,
	                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
	                name: 'selected_font',
	                value: this.state.selectedFont
	            };
	            var channelDisplayModePreference = {
	                user_id: userId,
	                category: Preferences.CATEGORY_DISPLAY_SETTINGS,
	                name: Preferences.CHANNEL_DISPLAY_MODE,
	                value: this.state.channelDisplayMode
	            };
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.savePreferences([timePreference, namePreference, fontPreference, channelDisplayModePreference], function () {
	                _this2.updateSection('');
	            }, function (err) {
	                _this2.setState({ serverError: err.message });
	            });
	        }
	    }, {
	        key: 'handleClockRadio',
	        value: function handleClockRadio(militaryTime) {
	            this.setState({ militaryTime: militaryTime });
	        }
	    }, {
	        key: 'handleNameRadio',
	        value: function handleNameRadio(nameFormat) {
	            this.setState({ nameFormat: nameFormat });
	        }
	    }, {
	        key: 'handleChannelDisplayModeRadio',
	        value: function handleChannelDisplayModeRadio(channelDisplayMode) {
	            this.setState({ channelDisplayMode: channelDisplayMode });
	        }
	    }, {
	        key: 'handleFont',
	        value: function handleFont(selectedFont) {
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.applyFont(selectedFont);
	            this.setState({ selectedFont: selectedFont });
	        }
	    }, {
	        key: 'updateSection',
	        value: function updateSection(section) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            this.updateState();
	            this.props.updateSection(section);
	        }
	    }, {
	        key: 'updateState',
	        value: function updateState() {
	            var newState = getDisplayStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_utils_jsx__.areObjectsEqual(newState, this.state)) {
	                this.handleFont(newState.selectedFont);
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'deactivate',
	        value: function deactivate() {
	            this.updateState();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var serverError = this.state.serverError || null;
	            var clockSection = void 0;
	            var nameFormatSection = void 0;
	            var channelDisplayModeSection = void 0;
	            var fontSection = void 0;
	            var languagesSection = void 0;
	
	            if (this.props.activeSection === 'clock') {
	                var clockFormat = [false, false];
	                if (this.state.militaryTime === 'true') {
	                    clockFormat[1] = true;
	                } else {
	                    clockFormat[0] = true;
	                }
	
	                var handleUpdateClockSection = function handleUpdateClockSection(e) {
	                    _this3.updateSection('');
	                    e.preventDefault();
	                };
	
	                var inputs = [/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { key: 'userDisplayClockOptions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: clockFormat[0],
	                                onChange: this.handleClockRadio.bind(this, 'false')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.display.normalClock',
	                                defaultMessage: '12-hour clock (example: 4:00 PM)'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: clockFormat[1],
	                                onChange: this.handleClockRadio.bind(this, 'true')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.display.militaryClock',
	                                defaultMessage: '24-hour clock (example: 16:00)'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.preferTime',
	                            defaultMessage: 'Select how you prefer time displayed.'
	                        })
	                    )
	                )];
	
	                clockSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.clockDisplay',
	                        defaultMessage: 'Clock Display'
	                    }),
	                    inputs: inputs,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: handleUpdateClockSection
	                });
	            } else {
	                var describe = void 0;
	                if (this.state.militaryTime === 'true') {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.militaryClock',
	                        defaultMessage: '24-hour clock (example: 16:00)'
	                    });
	                } else {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.normalClock',
	                        defaultMessage: '12-hour clock (example: 4:00 PM)'
	                    });
	                }
	
	                var _handleUpdateClockSection = function _handleUpdateClockSection() {
	                    _this3.props.updateSection('clock');
	                };
	
	                clockSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.clockDisplay',
	                        defaultMessage: 'Clock Display'
	                    }),
	                    describe: describe,
	                    updateSection: _handleUpdateClockSection
	                });
	            }
	
	            var showUsername = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                id: 'user.settings.display.showUsername',
	                defaultMessage: 'Show username (default)'
	            });
	            var showNickname = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                id: 'user.settings.display.showNickname',
	                defaultMessage: 'Show nickname if one exists, otherwise show first and last name'
	            });
	            var showFullName = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                id: 'user.settings.display.showFullname',
	                defaultMessage: 'Show first and last name'
	            });
	            if (this.props.activeSection === 'name_format') {
	                var nameFormat = [false, false, false];
	                if (this.state.nameFormat === 'nickname_full_name') {
	                    nameFormat[0] = true;
	                } else if (this.state.nameFormat === 'full_name') {
	                    nameFormat[2] = true;
	                } else {
	                    nameFormat[1] = true;
	                }
	
	                var _inputs = [/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { key: 'userDisplayNameOptions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: nameFormat[1],
	                                onChange: this.handleNameRadio.bind(this, 'username')
	                            }),
	                            showUsername
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: nameFormat[0],
	                                onChange: this.handleNameRadio.bind(this, 'nickname_full_name')
	                            }),
	                            showNickname
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: nameFormat[2],
	                                onChange: this.handleNameRadio.bind(this, 'full_name')
	                            }),
	                            showFullName
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.nameOptsDesc',
	                            defaultMessage: 'Set how to display other user\'s names in posts and the Direct Messages list.'
	                        })
	                    )
	                )];
	
	                nameFormatSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.teammateDisplay',
	                        defaultMessage: 'Teammate Name Display'
	                    }),
	                    inputs: _inputs,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: function updateSection(e) {
	                        _this3.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                var _describe = void 0;
	                if (this.state.nameFormat === 'username') {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.showUsername',
	                        defaultMessage: 'Show username (default)'
	                    });
	                } else if (this.state.nameFormat === 'full_name') {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.showFullname',
	                        defaultMessage: 'Show first and last name'
	                    });
	                } else {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.showNickname',
	                        defaultMessage: 'Show nickname if one exists, otherwise show first and last name'
	                    });
	                }
	
	                nameFormatSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.teammateDisplay',
	                        defaultMessage: 'Teammate Name Display'
	                    }),
	                    describe: _describe,
	                    updateSection: function updateSection() {
	                        _this3.props.updateSection('name_format');
	                    }
	                });
	            }
	
	            if (this.props.activeSection === Preferences.CHANNEL_DISPLAY_MODE) {
	                var channelDisplayMode = [false, false];
	                if (this.state.channelDisplayMode === Preferences.CHANNEL_DISPLAY_MODE_CENTERED) {
	                    channelDisplayMode[0] = true;
	                } else {
	                    channelDisplayMode[1] = true;
	                }
	
	                var _inputs2 = [/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { key: 'userDisplayNameOptions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: channelDisplayMode[0],
	                                onChange: this.handleChannelDisplayModeRadio.bind(this, Preferences.CHANNEL_DISPLAY_MODE_CENTERED)
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.display.fixedWidthCentered',
	                                defaultMessage: 'Fixed width, centered'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: channelDisplayMode[1],
	                                onChange: this.handleChannelDisplayModeRadio.bind(this, Preferences.CHANNEL_DISPLAY_MODE_FULL_SCREEN)
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.display.fullScreen',
	                                defaultMessage: 'Full width'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.channeldisplaymode',
	                            defaultMessage: 'Select how text in a channel is displayed.'
	                        })
	                    )
	                )];
	
	                channelDisplayModeSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.channelDisplayTitle',
	                        defaultMessage: 'Channel Display Mode'
	                    }),
	                    inputs: _inputs2,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: function updateSection(e) {
	                        _this3.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                var _describe2 = void 0;
	                if (this.state.channelDisplayMode === Preferences.CHANNEL_DISPLAY_MODE_CENTERED) {
	                    _describe2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.fixedWidthCentered',
	                        defaultMessage: 'Fixed width, centered'
	                    });
	                } else {
	                    _describe2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.fullScreen',
	                        defaultMessage: 'Full width'
	                    });
	                }
	
	                channelDisplayModeSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.channelDisplayTitle',
	                        defaultMessage: 'Channel Display Mode'
	                    }),
	                    describe: _describe2,
	                    updateSection: function updateSection() {
	                        _this3.props.updateSection(Preferences.CHANNEL_DISPLAY_MODE);
	                    }
	                });
	            }
	
	            if (this.props.activeSection === 'font') {
	                (function () {
	                    var options = [];
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].FONTS).forEach(function (fontName, idx) {
	                        var className = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].FONTS[fontName];
	                        options.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'option',
	                            {
	                                key: 'font_' + idx,
	                                value: fontName,
	                                className: className
	                            },
	                            fontName
	                        ));
	                    });
	
	                    var inputs = [/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        { key: 'userDisplayNameOptions' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            {
	                                className: 'dropdown'
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'select',
	                                {
	                                    className: 'form-control',
	                                    type: 'text',
	                                    value: _this3.state.selectedFont,
	                                    onChange: function onChange(e) {
	                                        return _this3.handleFont(e.target.value);
	                                    }
	                                },
	                                options
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.display.fontDesc',
	                                defaultMessage: 'Select the font displayed in the Mattermost user interface.'
	                            })
	                        )
	                    )];
	
	                    fontSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                        title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.fontTitle',
	                            defaultMessage: 'Display Font'
	                        }),
	                        inputs: inputs,
	                        submit: _this3.handleSubmit,
	                        server_error: serverError,
	                        updateSection: function updateSection(e) {
	                            _this3.updateSection('');
	                            e.preventDefault();
	                        }
	                    });
	                })();
	            } else {
	                fontSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.fontTitle',
	                        defaultMessage: 'Display Font'
	                    }),
	                    describe: this.state.selectedFont,
	                    updateSection: function updateSection() {
	                        _this3.props.updateSection('font');
	                    }
	                });
	            }
	
	            if (this.props.activeSection === 'languages') {
	                languagesSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__manage_languages_jsx__["a"], {
	                    user: this.props.user,
	                    updateSection: function updateSection(e) {
	                        _this3.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                var locale = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_i18n_i18n_jsx__.getLanguageInfo(this.props.user.locale).name;
	
	                languagesSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.display.language',
	                        defaultMessage: 'Language'
	                    }),
	                    width: 'medium',
	                    describe: locale,
	                    updateSection: function updateSection() {
	                        _this3.updateSection('languages');
	                    }
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close',
	                            onClick: this.props.closeModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', {
	                                className: 'fa fa-angle-left',
	                                onClick: this.props.collapseModal
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.title',
	                            defaultMessage: 'Display Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { className: 'user-settings' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.title',
	                            defaultMessage: 'Display Settings'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__user_settings_theme_jsx__["a"], {
	                        selected: this.props.activeSection === 'theme',
	                        updateSection: this.updateSection,
	                        setRequireConfirm: this.props.setRequireConfirm,
	                        setEnforceFocus: this.props.setEnforceFocus
	                    }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    fontSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    clockSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    nameFormatSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    channelDisplayModeSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    languagesSection
	                )
	            );
	        }
	    }]);
	
	    return UserSettingsDisplay;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = UserSettingsDisplay;
	
	
	UserSettingsDisplay.propTypes = {
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.object,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    setRequireConfirm: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    setEnforceFocus: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired
	};

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__setting_picture_jsx__ = __webpack_require__(744);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl___default = __WEBPACK_IMPORTED_MODULE_16_react_intl__ && __WEBPACK_IMPORTED_MODULE_16_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __WEBPACK_IMPORTED_MODULE_17_react__ && __WEBPACK_IMPORTED_MODULE_17_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["defineMessages"].bind()({
	    usernameReserved: {
	        id: 'user.settings.general.usernameReserved',
	        defaultMessage: 'This username is reserved, please choose a new one.'
	    },
	    usernameRestrictions: {
	        id: 'user.settings.general.usernameRestrictions',
	        defaultMessage: "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-', and '_'."
	    },
	    validEmail: {
	        id: 'user.settings.general.validEmail',
	        defaultMessage: 'Please enter a valid email address'
	    },
	    emailMatch: {
	        id: 'user.settings.general.emailMatch',
	        defaultMessage: 'The new emails you entered do not match.'
	    },
	    checkEmail: {
	        id: 'user.settings.general.checkEmail',
	        defaultMessage: 'Check your email at {email} to verify the address.'
	    },
	    validImage: {
	        id: 'user.settings.general.validImage',
	        defaultMessage: 'Only JPG or PNG images may be used for profile pictures'
	    },
	    imageTooLarge: {
	        id: 'user.settings.general.imageTooLarge',
	        defaultMessage: 'Unable to upload profile image. File is too large.'
	    },
	    uploadImage: {
	        id: 'user.settings.general.uploadImage',
	        defaultMessage: "Click 'Edit' to upload an image."
	    },
	    fullName: {
	        id: 'user.settings.general.fullName',
	        defaultMessage: 'Full Name'
	    },
	    nickname: {
	        id: 'user.settings.general.nickname',
	        defaultMessage: 'Nickname'
	    },
	    username: {
	        id: 'user.settings.general.username',
	        defaultMessage: 'Username'
	    },
	    profilePicture: {
	        id: 'user.settings.general.profilePicture',
	        defaultMessage: 'Profile Picture'
	    },
	    close: {
	        id: 'user.settings.general.close',
	        defaultMessage: 'Close'
	    }
	});
	
	
	
	var UserSettingsGeneralTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(UserSettingsGeneralTab, _React$Component);
	
	    function UserSettingsGeneralTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserSettingsGeneralTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserSettingsGeneralTab).call(this, props));
	
	        _this.submitActive = false;
	
	        _this.submitUsername = _this.submitUsername.bind(_this);
	        _this.submitNickname = _this.submitNickname.bind(_this);
	        _this.submitName = _this.submitName.bind(_this);
	        _this.submitEmail = _this.submitEmail.bind(_this);
	        _this.submitUser = _this.submitUser.bind(_this);
	        _this.submitPicture = _this.submitPicture.bind(_this);
	
	        _this.updateUsername = _this.updateUsername.bind(_this);
	        _this.updateFirstName = _this.updateFirstName.bind(_this);
	        _this.updateLastName = _this.updateLastName.bind(_this);
	        _this.updateNickname = _this.updateNickname.bind(_this);
	        _this.updateEmail = _this.updateEmail.bind(_this);
	        _this.updateConfirmEmail = _this.updateConfirmEmail.bind(_this);
	        _this.updatePicture = _this.updatePicture.bind(_this);
	        _this.updateSection = _this.updateSection.bind(_this);
	
	        _this.state = _this.setupInitialState(props);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(UserSettingsGeneralTab, [{
	        key: 'submitUsername',
	        value: function submitUsername(e) {
	            e.preventDefault();
	
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, this.props.user);
	            var username = this.state.username.trim().toLowerCase();
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var usernameError = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.isValidUsername(username);
	            if (usernameError === 'Cannot use a reserved word as a username.') {
	                this.setState({ clientError: formatMessage(holders.usernameReserved) });
	                return;
	            } else if (usernameError) {
	                this.setState({ clientError: formatMessage(holders.usernameRestrictions, { min: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MIN_USERNAME_LENGTH, max: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH }) });
	                return;
	            }
	
	            if (user.username === username) {
	                this.updateSection('');
	                return;
	            }
	
	            user.username = username;
	
	            this.submitUser(user, false);
	        }
	    }, {
	        key: 'submitNickname',
	        value: function submitNickname(e) {
	            e.preventDefault();
	
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, this.props.user);
	            var nickname = this.state.nickname.trim();
	
	            if (user.nickname === nickname) {
	                this.updateSection('');
	                return;
	            }
	
	            user.nickname = nickname;
	
	            this.submitUser(user, false);
	        }
	    }, {
	        key: 'submitName',
	        value: function submitName(e) {
	            e.preventDefault();
	
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, this.props.user);
	            var firstName = this.state.firstName.trim();
	            var lastName = this.state.lastName.trim();
	
	            if (user.first_name === firstName && user.last_name === lastName) {
	                this.updateSection('');
	                return;
	            }
	
	            user.first_name = firstName;
	            user.last_name = lastName;
	
	            this.submitUser(user, false);
	        }
	    }, {
	        key: 'submitEmail',
	        value: function submitEmail(e) {
	            e.preventDefault();
	
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, this.props.user);
	            var email = this.state.email.trim().toLowerCase();
	            var confirmEmail = this.state.confirmEmail.trim().toLowerCase();
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            if (email === '' || !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.isEmail(email)) {
	                this.setState({ emailError: formatMessage(holders.validEmail), clientError: '', serverError: '' });
	                return;
	            }
	
	            if (email !== confirmEmail) {
	                this.setState({ emailError: formatMessage(holders.emailMatch), clientError: '', serverError: '' });
	                return;
	            }
	
	            if (user.email === email) {
	                this.updateSection('');
	                return;
	            }
	
	            user.email = email;
	            this.submitUser(user, true);
	        }
	    }, {
	        key: 'submitUser',
	        value: function submitUser(user, emailUpdated) {
	            var _this2 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].updateUser(user, function () {
	                _this2.updateSection('');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__.getMe();
	                var verificationEnabled = global.window.mm_config.SendEmailNotifications === 'true' && global.window.mm_config.RequireEmailVerification === 'true' && emailUpdated;
	
	                if (verificationEnabled) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__["a"].storeLastError({ message: _this2.props.intl.formatMessage(holders.checkEmail, { email: user.email }) });
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_11_stores_error_store_jsx__["a"].emitChange();
	                    _this2.setState({ emailChangeInProgress: true });
	                }
	            }, function (err) {
	                var serverError = void 0;
	                if (err.message) {
	                    serverError = err.message;
	                } else {
	                    serverError = err;
	                }
	                _this2.setState({ serverError: serverError, emailError: '', clientError: '' });
	            });
	        }
	    }, {
	        key: 'submitPicture',
	        value: function submitPicture(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	
	            if (!this.state.picture) {
	                return;
	            }
	
	            if (!this.submitActive) {
	                return;
	            }
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            var picture = this.state.picture;
	
	            if (picture.type !== 'image/jpeg' && picture.type !== 'image/png') {
	                this.setState({ clientError: formatMessage(holders.validImage) });
	                return;
	            } else if (picture.size > /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MAX_FILE_SIZE) {
	                this.setState({ clientError: formatMessage(holders.imageTooLarge) });
	                return;
	            }
	
	            this.setState({ loadingPicture: true });
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].uploadProfileImage(picture, function () {
	                _this3.updateSection('');
	                _this3.submitActive = false;
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__.getMe();
	            }, function (err) {
	                var state = _this3.setupInitialState(_this3.props);
	                state.serverError = err.message;
	                _this3.setState(state);
	            });
	        }
	    }, {
	        key: 'updateUsername',
	        value: function updateUsername(e) {
	            this.setState({ username: e.target.value });
	        }
	    }, {
	        key: 'updateFirstName',
	        value: function updateFirstName(e) {
	            this.setState({ firstName: e.target.value });
	        }
	    }, {
	        key: 'updateLastName',
	        value: function updateLastName(e) {
	            this.setState({ lastName: e.target.value });
	        }
	    }, {
	        key: 'updateNickname',
	        value: function updateNickname(e) {
	            this.setState({ nickname: e.target.value });
	        }
	    }, {
	        key: 'updateEmail',
	        value: function updateEmail(e) {
	            this.setState({ email: e.target.value });
	        }
	    }, {
	        key: 'updateConfirmEmail',
	        value: function updateConfirmEmail(e) {
	            this.setState({ confirmEmail: e.target.value });
	        }
	    }, {
	        key: 'updatePicture',
	        value: function updatePicture(e) {
	            if (e.target.files && e.target.files[0]) {
	                this.setState({ picture: e.target.files[0] });
	
	                this.submitActive = true;
	                this.setState({ clientError: null });
	            } else {
	                this.setState({ picture: null });
	            }
	        }
	    }, {
	        key: 'updateSection',
	        value: function updateSection(section) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	            var emailChangeInProgress = this.state.emailChangeInProgress;
	            this.setState(/* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, this.setupInitialState(this.props), { emailChangeInProgress: emailChangeInProgress, clientError: '', serverError: '', emailError: '' }));
	            this.submitActive = false;
	            this.props.updateSection(section);
	        }
	    }, {
	        key: 'setupInitialState',
	        value: function setupInitialState(props) {
	            var user = props.user;
	
	            return { username: user.username, firstName: user.first_name, lastName: user.last_name, nickname: user.nickname,
	                email: user.email, confirmEmail: '', picture: null, loadingPicture: false, emailChangeInProgress: false };
	        }
	    }, {
	        key: 'createEmailSection',
	        value: function createEmailSection() {
	            var _this4 = this;
	
	            var emailSection = void 0;
	
	            if (this.props.activeSection === 'email') {
	                var emailEnabled = global.window.mm_config.SendEmailNotifications === 'true';
	                var emailVerificationEnabled = global.window.mm_config.RequireEmailVerification === 'true';
	                var inputs = [];
	
	                var helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.general.emailHelp1',
	                    defaultMessage: 'Email is used for sign-in, notifications, and password reset. Email requires verification if changed.'
	                });
	
	                if (!emailEnabled) {
	                    helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { className: 'setting-list__hint text-danger' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.emailHelp2',
	                            defaultMessage: 'Email has been disabled by your system administrator. No notification emails will be sent until it is enabled.'
	                        })
	                    );
	                } else if (!emailVerificationEnabled) {
	                    helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.emailHelp3',
	                        defaultMessage: 'Email is used for sign-in, notifications, and password reset.'
	                    });
	                } else if (this.state.emailChangeInProgress) {
	                    var newEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser().email;
	                    if (newEmail) {
	                        helpText = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.emailHelp4',
	                            defaultMessage: 'A verification email was sent to {email}.',
	                            values: {
	                                email: newEmail
	                            }
	                        });
	                    }
	                }
	
	                var submit = null;
	
	                if (this.props.user.auth_service === '') {
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { key: 'emailSetting' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-5 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.general.primaryEmail',
	                                    defaultMessage: 'Primary Email'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                    className: 'form-control',
	                                    type: 'text',
	                                    onChange: this.updateEmail,
	                                    value: this.state.email
	                                })
	                            )
	                        )
	                    ));
	
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        { key: 'confirmEmailSetting' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-5 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.general.confirmEmail',
	                                    defaultMessage: 'Confirm Email'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                    className: 'form-control',
	                                    type: 'text',
	                                    onChange: this.updateConfirmEmail,
	                                    value: this.state.confirmEmail
	                                })
	                            )
	                        ),
	                        helpText
	                    ));
	
	                    submit = this.submitEmail;
	                } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].GITLAB_SERVICE) {
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'oauthEmailInfo',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'setting-list__hint' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.general.emailGitlabCantUpdate',
	                                defaultMessage: 'Login occurs through GitLab. Email cannot be updated. Email address used for notifications is {email}.',
	                                values: {
	                                    email: this.state.email
	                                }
	                            })
	                        ),
	                        helpText
	                    ));
	                } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].LDAP_SERVICE) {
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'oauthEmailInfo',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'setting-list__hint' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.general.emailLdapCantUpdate',
	                                defaultMessage: 'Login occurs through LDAP. Email cannot be updated. Email address used for notifications is {email}.',
	                                values: {
	                                    email: this.state.email
	                                }
	                            })
	                        ),
	                        helpText
	                    ));
	                }
	
	                emailSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.email',
	                        defaultMessage: 'Email'
	                    }),
	                    inputs: inputs,
	                    submit: submit,
	                    server_error: this.state.serverError,
	                    client_error: this.state.emailError,
	                    updateSection: function updateSection(e) {
	                        _this4.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                var describe = '';
	                if (this.props.user.auth_service === '') {
	                    if (this.state.emailChangeInProgress) {
	                        var _newEmail = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser().email;
	                        if (_newEmail) {
	                            describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedHTMLMessage"], {
	                                id: 'user.settings.general.newAddress',
	                                defaultMessage: 'New Address: {email}<br />Check your email to verify the above address.',
	                                values: {
	                                    email: _newEmail
	                                }
	                            });
	                        } else {
	                            describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.general.checkEmailNoAddress',
	                                defaultMessage: 'Check your email to verify your new address'
	                            });
	                        }
	                    } else {
	                        describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser().email;
	                    }
	                } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].GITLAB_SERVICE) {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.loginGitlab',
	                        defaultMessage: 'Login done through GitLab ({email})',
	                        values: {
	                            email: this.state.email
	                        }
	                    });
	                } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].LDAP_SERVICE) {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.loginLdap',
	                        defaultMessage: 'Login done through LDAP ({email})',
	                        values: {
	                            email: this.state.email
	                        }
	                    });
	                }
	
	                emailSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.email',
	                        defaultMessage: 'Email'
	                    }),
	                    describe: describe,
	                    updateSection: function updateSection() {
	                        _this4.updateSection('email');
	                    }
	                });
	            }
	
	            return emailSection;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var user = this.props.user;
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            var clientError = null;
	            if (this.state.clientError) {
	                clientError = this.state.clientError;
	            }
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = this.state.serverError;
	            }
	
	            var nameSection = void 0;
	            var inputs = [];
	
	            if (this.props.activeSection === 'name') {
	                var extraInfo = void 0;
	                var submit = null;
	                if (this.props.user.auth_service === '') {
	                    var notifClick = function notifClick(e) {
	                        e.preventDefault();
	                        this.updateSection('');
	                        this.props.updateTab('notifications');
	                    };
	
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'firstNameSetting',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.general.firstName',
	                                defaultMessage: 'First Name'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                onChange: this.updateFirstName,
	                                value: this.state.firstName
	                            })
	                        )
	                    ));
	
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'lastNameSetting',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.general.lastName',
	                                defaultMessage: 'Last Name'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                onChange: this.updateLastName,
	                                value: this.state.lastName
	                            })
	                        )
	                    ));
	
	                    var notifLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            onClick: notifClick.bind(this)
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.notificationsLink',
	                            defaultMessage: 'Notifications'
	                        })
	                    );
	
	                    extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.notificationsExtra',
	                            defaultMessage: 'By default, you will receive mention notifications when someone types your first name. Go to {notify} settings to change this default.',
	                            values: {
	                                notify: notifLink
	                            }
	                        })
	                    );
	
	                    submit = this.submitName;
	                } else {
	                    extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.field_handled_externally',
	                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so though your login provider.'
	                        })
	                    );
	                }
	
	                nameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.fullName),
	                    inputs: inputs,
	                    submit: submit,
	                    server_error: serverError,
	                    client_error: clientError,
	                    updateSection: function updateSection(e) {
	                        _this5.updateSection('');
	                        e.preventDefault();
	                    },
	                    extraInfo: extraInfo
	                });
	            } else {
	                var describe = '';
	
	                if (user.first_name && user.last_name) {
	                    describe = user.first_name + ' ' + user.last_name;
	                } else if (user.first_name) {
	                    describe = user.first_name;
	                } else if (user.last_name) {
	                    describe = user.last_name;
	                } else {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.emptyName',
	                        defaultMessage: 'Click \'Edit\' to add your full name'
	                    });
	                }
	
	                nameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.fullName),
	                    describe: describe,
	                    updateSection: function updateSection() {
	                        _this5.updateSection('name');
	                    }
	                });
	            }
	
	            var nicknameSection = void 0;
	            if (this.props.activeSection === 'nickname') {
	                var _extraInfo = void 0;
	                var _submit = null;
	                if (this.props.user.auth_service === 'ldap' && global.window.mm_config.NicknameAttributeSet) {
	                    _extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.field_handled_externally',
	                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so though your login provider.'
	                        })
	                    );
	                } else {
	                    var nicknameLabel = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.nickname',
	                        defaultMessage: 'Nickname'
	                    });
	                    if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.isMobile()) {
	                        nicknameLabel = '';
	                    }
	
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'nicknameSetting',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            nicknameLabel
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'text',
	                                onChange: this.updateNickname,
	                                value: this.state.nickname
	                            })
	                        )
	                    ));
	
	                    _extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.nicknameExtra',
	                            defaultMessage: 'Use Nickname for a name you might be called that is different from your first name and username. This is most often used when two or more people have similar sounding names and usernames.'
	                        })
	                    );
	
	                    _submit = this.submitNickname;
	                }
	
	                nicknameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.nickname),
	                    inputs: inputs,
	                    submit: _submit,
	                    server_error: serverError,
	                    client_error: clientError,
	                    updateSection: function updateSection(e) {
	                        _this5.updateSection('');
	                        e.preventDefault();
	                    },
	                    extraInfo: _extraInfo
	                });
	            } else {
	                var _describe = '';
	                if (user.nickname) {
	                    _describe = user.nickname;
	                } else {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.emptyNickname',
	                        defaultMessage: 'Click \'Edit\' to add a nickname'
	                    });
	                }
	
	                nicknameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.nickname),
	                    describe: _describe,
	                    updateSection: function updateSection() {
	                        _this5.updateSection('nickname');
	                    }
	                });
	            }
	
	            var usernameSection = void 0;
	            if (this.props.activeSection === 'username') {
	                var _extraInfo2 = void 0;
	                var _submit2 = null;
	                if (this.props.user.auth_service === '') {
	                    var usernameLabel = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.username',
	                        defaultMessage: 'Username'
	                    });
	                    if (/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.isMobile()) {
	                        usernameLabel = '';
	                    }
	
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'usernameSetting',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            usernameLabel
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('input', {
	                                maxLength: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_constants_jsx__["a"].MAX_USERNAME_LENGTH,
	                                className: 'form-control',
	                                type: 'text',
	                                onChange: this.updateUsername,
	                                value: this.state.username
	                            })
	                        )
	                    ));
	
	                    _extraInfo2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.usernameInfo',
	                            defaultMessage: 'Pick something easy for teammates to recognize and recall.'
	                        })
	                    );
	
	                    _submit2 = this.submitUsername;
	                } else {
	                    _extraInfo2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.field_handled_externally',
	                            defaultMessage: 'This field is handled through your login provider. If you want to change it, you need to do so though your login provider.'
	                        })
	                    );
	                }
	
	                usernameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.username),
	                    inputs: inputs,
	                    submit: _submit2,
	                    server_error: serverError,
	                    client_error: clientError,
	                    updateSection: function updateSection(e) {
	                        _this5.updateSection('');
	                        e.preventDefault();
	                    },
	                    extraInfo: _extraInfo2
	                });
	            } else {
	                usernameSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.username),
	                    describe: /* harmony import */__WEBPACK_IMPORTED_MODULE_10_stores_user_store_jsx__["a"].getCurrentUser().username,
	                    updateSection: function updateSection() {
	                        _this5.updateSection('username');
	                    }
	                });
	            }
	
	            var emailSection = this.createEmailSection();
	
	            var pictureSection = void 0;
	            if (this.props.activeSection === 'picture') {
	                pictureSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__setting_picture_jsx__["a"], {
	                    title: formatMessage(holders.profilePicture),
	                    submit: this.submitPicture,
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_12_utils_web_client_jsx__["a"].getUsersRoute() + '/' + user.id + '/image?time=' + user.last_picture_update,
	                    server_error: serverError,
	                    client_error: clientError,
	                    updateSection: function updateSection(e) {
	                        _this5.updateSection('');
	                        e.preventDefault();
	                    },
	                    picture: this.state.picture,
	                    pictureChange: this.updatePicture,
	                    submitActive: this.submitActive,
	                    loadingPicture: this.state.loadingPicture
	                });
	            } else {
	                var minMessage = formatMessage(holders.uploadImage);
	                if (user.last_picture_update) {
	                    minMessage = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.general.imageUpdated',
	                        defaultMessage: 'Image last updated {date}',
	                        values: {
	                            date: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedDate"], {
	                                value: new Date(user.last_picture_update),
	                                day: '2-digit',
	                                month: 'short',
	                                year: 'numeric'
	                            })
	                        }
	                    });
	                }
	                pictureSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.profilePicture),
	                    describe: minMessage,
	                    updateSection: function updateSection() {
	                        _this5.updateSection('picture');
	                    }
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': formatMessage(holders.close),
	                            onClick: this.props.closeModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('i', {
	                                className: 'fa fa-angle-left',
	                                onClick: this.props.collapseModal
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.title',
	                            defaultMessage: 'General Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                    'div',
	                    { className: 'user-settings' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.general.title',
	                            defaultMessage: 'General Settings'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    nameSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: 'divider-light' }),
	                    usernameSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: 'divider-light' }),
	                    nicknameSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: 'divider-light' }),
	                    emailSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: 'divider-light' }),
	                    pictureSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div', { className: 'divider-dark' })
	                )
	            );
	        }
	    }]);
	
	    return UserSettingsGeneralTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);
	
	UserSettingsGeneralTab.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["intlShape"].isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.object.isRequired,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.func.isRequired,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.func.isRequired,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.string.isRequired,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["injectIntl"].bind()(UserSettingsGeneralTab);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __WEBPACK_IMPORTED_MODULE_6_react_dom__ && __WEBPACK_IMPORTED_MODULE_6_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl___default = __WEBPACK_IMPORTED_MODULE_13_react_intl__ && __WEBPACK_IMPORTED_MODULE_13_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __WEBPACK_IMPORTED_MODULE_14_react__ && __WEBPACK_IMPORTED_MODULE_14_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_14_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_14_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_14_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_14_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function getNotificationsStateFromStores() {
	    var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].getCurrentUser();
	    var soundNeeded = !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.isBrowserFirefox();
	
	    var sound = 'true';
	    if (user.notify_props && user.notify_props.desktop_sound) {
	        sound = user.notify_props.desktop_sound;
	    }
	    var desktop = 'default';
	    if (user.notify_props && user.notify_props.desktop) {
	        desktop = user.notify_props.desktop;
	    }
	    var email = 'true';
	    if (user.notify_props && user.notify_props.email) {
	        email = user.notify_props.email;
	    }
	
	    var usernameKey = false;
	    var mentionKey = false;
	    var customKeys = '';
	    var firstNameKey = false;
	    var allKey = false;
	    var channelKey = false;
	
	    if (user.notify_props) {
	        if (user.notify_props.mention_keys) {
	            var keys = user.notify_props.mention_keys.split(',');
	
	            if (keys.indexOf(user.username) === -1) {
	                usernameKey = false;
	            } else {
	                usernameKey = true;
	                keys.splice(keys.indexOf(user.username), 1);
	            }
	
	            if (keys.indexOf('@' + user.username) === -1) {
	                mentionKey = false;
	            } else {
	                mentionKey = true;
	                keys.splice(keys.indexOf('@' + user.username), 1);
	            }
	
	            customKeys = keys.join(',');
	        }
	
	        if (user.notify_props.first_name) {
	            firstNameKey = user.notify_props.first_name === 'true';
	        }
	
	        if (user.notify_props.all) {
	            allKey = user.notify_props.all === 'true';
	        }
	
	        if (user.notify_props.channel) {
	            channelKey = user.notify_props.channel === 'true';
	        }
	    }
	
	    return { notifyLevel: desktop, enableEmail: email, soundNeeded: soundNeeded, enableSound: sound,
	        usernameKey: usernameKey, mentionKey: mentionKey, customKeys: customKeys, customKeysChecked: customKeys.length > 0,
	        firstNameKey: firstNameKey, allKey: allKey, channelKey: channelKey };
	}
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["defineMessages"].bind()({
	    desktop: {
	        id: 'user.settings.notifications.desktop',
	        defaultMessage: 'Send desktop notifications'
	    },
	    desktopSounds: {
	        id: 'user.settings.notifications.desktopSounds',
	        defaultMessage: 'Desktop notification sounds'
	    },
	    emailNotifications: {
	        id: 'user.settings.notifications.emailNotifications',
	        defaultMessage: 'Email notifications'
	    },
	    wordsTrigger: {
	        id: 'user.settings.notifications.wordsTrigger',
	        defaultMessage: 'Words that trigger mentions'
	    },
	    close: {
	        id: 'user.settings.notifications.close',
	        defaultMessage: 'Close'
	    }
	});
	
	
	
	var NotificationsTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NotificationsTab, _React$Component);
	
	    function NotificationsTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NotificationsTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NotificationsTab).call(this, props));
	
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleCancel = _this.handleCancel.bind(_this);
	        _this.updateSection = _this.updateSection.bind(_this);
	        _this.updateState = _this.updateState.bind(_this);
	        _this.onListenerChange = _this.onListenerChange.bind(_this);
	        _this.handleNotifyRadio = _this.handleNotifyRadio.bind(_this);
	        _this.handleEmailRadio = _this.handleEmailRadio.bind(_this);
	        _this.handleSoundRadio = _this.handleSoundRadio.bind(_this);
	        _this.updateUsernameKey = _this.updateUsernameKey.bind(_this);
	        _this.updateMentionKey = _this.updateMentionKey.bind(_this);
	        _this.updateFirstNameKey = _this.updateFirstNameKey.bind(_this);
	        _this.updateAllKey = _this.updateAllKey.bind(_this);
	        _this.updateChannelKey = _this.updateChannelKey.bind(_this);
	        _this.updateCustomMentionKeys = _this.updateCustomMentionKeys.bind(_this);
	        _this.onCustomChange = _this.onCustomChange.bind(_this);
	
	        _this.state = getNotificationsStateFromStores();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NotificationsTab, [{
	        key: 'handleSubmit',
	        value: function handleSubmit() {
	            var data = {};
	            data.user_id = this.props.user.id;
	            data.email = this.state.enableEmail;
	            data.desktop_sound = this.state.enableSound;
	            data.desktop = this.state.notifyLevel;
	
	            var mentionKeys = [];
	            if (this.state.usernameKey) {
	                mentionKeys.push(this.props.user.username);
	            }
	            if (this.state.mentionKey) {
	                mentionKeys.push('@' + this.props.user.username);
	            }
	
	            var stringKeys = mentionKeys.join(',');
	            if (this.state.customKeys.length > 0 && this.state.customKeysChecked) {
	                stringKeys += ',' + this.state.customKeys;
	            }
	
	            data.mention_keys = stringKeys;
	            data.first_name = this.state.firstNameKey.toString();
	            data.all = this.state.allKey.toString();
	            data.channel = this.state.channelKey.toString();
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_web_client_jsx__["a"].updateUserNotifyProps(data, function success() {
	                this.props.updateSection('');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_11_utils_async_client_jsx__.getMe();
	            }.bind(this), function failure(err) {
	                this.setState({ serverError: err.message });
	            }.bind(this));
	        }
	    }, {
	        key: 'handleCancel',
	        value: function handleCancel(e) {
	            this.updateState();
	            this.props.updateSection('');
	            e.preventDefault();
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	        }
	    }, {
	        key: 'updateSection',
	        value: function updateSection(section) {
	            this.updateState();
	            this.props.updateSection(section);
	        }
	    }, {
	        key: 'updateState',
	        value: function updateState() {
	            var newState = getNotificationsStateFromStores();
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_12_utils_utils_jsx__.areObjectsEqual(newState, this.state)) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].addChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_stores_user_store_jsx__["a"].removeChangeListener(this.onListenerChange);
	        }
	    }, {
	        key: 'onListenerChange',
	        value: function onListenerChange() {
	            this.updateState();
	        }
	    }, {
	        key: 'handleNotifyRadio',
	        value: function handleNotifyRadio(notifyLevel) {
	            this.setState({ notifyLevel: notifyLevel });
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.wrapper).focus();
	        }
	    }, {
	        key: 'handleEmailRadio',
	        value: function handleEmailRadio(enableEmail) {
	            this.setState({ enableEmail: enableEmail });
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.wrapper).focus();
	        }
	    }, {
	        key: 'handleSoundRadio',
	        value: function handleSoundRadio(enableSound) {
	            this.setState({ enableSound: enableSound });
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.wrapper).focus();
	        }
	    }, {
	        key: 'updateUsernameKey',
	        value: function updateUsernameKey(val) {
	            this.setState({ usernameKey: val });
	        }
	    }, {
	        key: 'updateMentionKey',
	        value: function updateMentionKey(val) {
	            this.setState({ mentionKey: val });
	        }
	    }, {
	        key: 'updateFirstNameKey',
	        value: function updateFirstNameKey(val) {
	            this.setState({ firstNameKey: val });
	        }
	    }, {
	        key: 'updateAllKey',
	        value: function updateAllKey(val) {
	            this.setState({ allKey: val });
	        }
	    }, {
	        key: 'updateChannelKey',
	        value: function updateChannelKey(val) {
	            this.setState({ channelKey: val });
	        }
	    }, {
	        key: 'updateCustomMentionKeys',
	        value: function updateCustomMentionKeys() {
	            var checked = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.customcheck).checked;
	
	            if (checked) {
	                var text = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.custommentions).value;
	
	                // remove all spaces and split string into individual keys
	                this.setState({ customKeys: text.replace(/ /g, ''), customKeysChecked: true });
	            } else {
	                this.setState({ customKeys: '', customKeysChecked: false });
	            }
	        }
	    }, {
	        key: 'onCustomChange',
	        value: function onCustomChange() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.customcheck).checked = true;
	            this.updateCustomMentionKeys();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.props.intl.formatMessage;
	
	            var serverError = null;
	            if (this.state.serverError) {
	                serverError = this.state.serverError;
	            }
	
	            var user = this.props.user;
	
	            var desktopSection;
	            var handleUpdateDesktopSection;
	            if (this.props.activeSection === 'desktop') {
	                var notifyActive = [false, false, false];
	                if (this.state.notifyLevel === 'mention') {
	                    notifyActive[1] = true;
	                } else if (this.state.notifyLevel === 'none') {
	                    notifyActive[2] = true;
	                } else {
	                    notifyActive[0] = true;
	                }
	
	                var inputs = [];
	
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationLevelOption' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', { type: 'radio',
	                                checked: notifyActive[0],
	                                onChange: this.handleNotifyRadio.bind(this, 'all')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notification.allActivity',
	                                defaultMessage: 'For all activity'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: notifyActive[1],
	                                onChange: this.handleNotifyRadio.bind(this, 'mention')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.onlyMentions',
	                                defaultMessage: 'Only for mentions and direct messages'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: notifyActive[2],
	                                onChange: this.handleNotifyRadio.bind(this, 'none')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.never',
	                                defaultMessage: 'Never'
	                            })
	                        )
	                    )
	                ));
	
	                var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.info',
	                        defaultMessage: 'Desktop notifications are available on Firefox, Safari, Chrome, Internet Explorer, and Edge.'
	                    })
	                );
	
	                desktopSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.desktop),
	                    extraInfo: extraInfo,
	                    inputs: inputs,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: this.handleCancel
	                });
	            } else {
	                var describe = '';
	                if (this.state.notifyLevel === 'mention') {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.onlyMentions',
	                        defaultMessage: 'Only for mentions and direct messages'
	                    });
	                } else if (this.state.notifyLevel === 'none') {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.never',
	                        defaultMessage: 'Never'
	                    });
	                } else {
	                    describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notification.allActivity',
	                        defaultMessage: 'For all activity'
	                    });
	                }
	
	                handleUpdateDesktopSection = function updateDesktopSection() {
	                    this.props.updateSection('desktop');
	                }.bind(this);
	
	                desktopSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.desktop),
	                    describe: describe,
	                    updateSection: handleUpdateDesktopSection
	                });
	            }
	
	            var soundSection;
	            var handleUpdateSoundSection;
	            if (this.props.activeSection === 'sound' && this.state.soundNeeded) {
	                var soundActive = [false, false];
	                if (this.state.enableSound === 'false') {
	                    soundActive[1] = true;
	                } else {
	                    soundActive[0] = true;
	                }
	
	                var _inputs = [];
	
	                _inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationSoundOptions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: soundActive[0],
	                                onChange: this.handleSoundRadio.bind(this, 'true')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.on',
	                                defaultMessage: 'On'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: soundActive[1],
	                                onChange: this.handleSoundRadio.bind(this, 'false')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.off',
	                                defaultMessage: 'Off'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null)
	                    )
	                ));
	
	                var _extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.sounds_info',
	                        defaultMessage: 'Desktop notifications sounds are available on Firefox, Safari, Chrome, Internet Explorer, and Edge.'
	                    })
	                );
	
	                soundSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.desktopSounds),
	                    extraInfo: _extraInfo,
	                    inputs: _inputs,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: this.handleCancel
	                });
	            } else {
	                var _describe = '';
	                if (!this.state.soundNeeded) {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notification.soundConfig',
	                        defaultMessage: 'Please configure notification sounds in your browser settings'
	                    });
	                } else if (this.state.enableSound === 'false') {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.off',
	                        defaultMessage: 'Off'
	                    });
	                } else {
	                    _describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.on',
	                        defaultMessage: 'On'
	                    });
	                }
	
	                handleUpdateSoundSection = function updateSoundSection() {
	                    this.props.updateSection('sound');
	                }.bind(this);
	
	                soundSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.desktopSounds),
	                    describe: _describe,
	                    updateSection: handleUpdateSoundSection,
	                    disableOpen: !this.state.soundNeeded
	                });
	            }
	
	            var emailSection;
	            var handleUpdateEmailSection;
	            if (this.props.activeSection === 'email') {
	                var emailActive = [false, false];
	                if (this.state.enableEmail === 'false') {
	                    emailActive[1] = true;
	                } else {
	                    emailActive[0] = true;
	                }
	
	                var _inputs2 = [];
	
	                _inputs2.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationEmailOptions' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: emailActive[0],
	                                onChange: this.handleEmailRadio.bind(this, 'true')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.on',
	                                defaultMessage: 'On'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'radio' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'radio',
	                                checked: emailActive[1],
	                                onChange: this.handleEmailRadio.bind(this, 'false')
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.off',
	                                defaultMessage: 'Off'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null)
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('br', null),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.notifications.emailInfo',
	                            defaultMessage: 'Email notifications are sent for mentions and direct messages after you’ve been offline for more than 60 seconds or away from {siteName} for more than 5 minutes.',
	                            values: {
	                                siteName: global.window.mm_config.SiteName
	                            }
	                        })
	                    )
	                ));
	
	                emailSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.emailNotifications),
	                    inputs: _inputs2,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: this.handleCancel
	                });
	            } else {
	                var _describe2 = '';
	                if (this.state.enableEmail === 'false') {
	                    _describe2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.off',
	                        defaultMessage: 'Off'
	                    });
	                } else {
	                    _describe2 = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.on',
	                        defaultMessage: 'On'
	                    });
	                }
	
	                handleUpdateEmailSection = function updateEmailSection() {
	                    this.props.updateSection('email');
	                }.bind(this);
	
	                emailSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.emailNotifications),
	                    describe: _describe2,
	                    updateSection: handleUpdateEmailSection
	                });
	            }
	
	            var keysSection;
	            var handleUpdateKeysSection;
	            if (this.props.activeSection === 'keys') {
	                var _inputs3 = [];
	
	                var handleUpdateFirstNameKey = void 0;
	                var handleUpdateUsernameKey = void 0;
	                var handleUpdateMentionKey = void 0;
	                var handleUpdateAllKey = void 0;
	                var handleUpdateChannelKey = void 0;
	
	                if (user.first_name) {
	                    handleUpdateFirstNameKey = function handleFirstNameKeyChange(e) {
	                        this.updateFirstNameKey(e.target.checked);
	                    }.bind(this);
	                    _inputs3.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { key: 'userNotificationFirstNameOption' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'checkbox' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                                'label',
	                                null,
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                    type: 'checkbox',
	                                    checked: this.state.firstNameKey,
	                                    onChange: handleUpdateFirstNameKey
	                                }),
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.notifications.sensitiveName',
	                                    defaultMessage: 'Your case sensitive first name "{first_name}"',
	                                    values: {
	                                        first_name: user.first_name
	                                    }
	                                })
	                            )
	                        )
	                    ));
	                }
	
	                handleUpdateUsernameKey = function handleUsernameKeyChange(e) {
	                    this.updateUsernameKey(e.target.checked);
	                }.bind(this);
	                _inputs3.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationUsernameOption' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'checkbox' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'checkbox',
	                                checked: this.state.usernameKey,
	                                onChange: handleUpdateUsernameKey
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.sensitiveUsername',
	                                defaultMessage: 'Your non-case sensitive username "{username}"',
	                                values: {
	                                    username: user.username
	                                }
	                            })
	                        )
	                    )
	                ));
	
	                handleUpdateMentionKey = function handleMentionKeyChange(e) {
	                    this.updateMentionKey(e.target.checked);
	                }.bind(this);
	                _inputs3.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationMentionOption' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'checkbox' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'checkbox',
	                                checked: this.state.mentionKey,
	                                onChange: handleUpdateMentionKey
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.usernameMention',
	                                defaultMessage: 'Your username mentioned "@{username}"',
	                                values: {
	                                    username: user.username
	                                }
	                            })
	                        )
	                    )
	                ));
	
	                handleUpdateAllKey = function handleAllKeyChange(e) {
	                    this.updateAllKey(e.target.checked);
	                }.bind(this);
	                _inputs3.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationAllOption' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'checkbox hidden' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'checkbox',
	                                checked: this.state.allKey,
	                                onChange: handleUpdateAllKey
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.teamWide',
	                                defaultMessage: 'Team-wide mentions "@all"'
	                            })
	                        )
	                    )
	                ));
	
	                handleUpdateChannelKey = function handleChannelKeyChange(e) {
	                    this.updateChannelKey(e.target.checked);
	                }.bind(this);
	                _inputs3.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationChannelOption' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'checkbox' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                type: 'checkbox',
	                                checked: this.state.channelKey,
	                                onChange: handleUpdateChannelKey
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.channelWide',
	                                defaultMessage: 'Channel-wide mentions "@channel"'
	                            })
	                        )
	                    )
	                ));
	
	                _inputs3.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { key: 'userNotificationCustomOption' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'div',
	                        { className: 'checkbox' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'label',
	                            null,
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                                ref: 'customcheck',
	                                type: 'checkbox',
	                                checked: this.state.customKeysChecked,
	                                onChange: this.updateCustomMentionKeys
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.notifications.sensitiveWords',
	                                defaultMessage: 'Other non-case sensitive words, separated by commas:'
	                            })
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('input', {
	                        ref: 'custommentions',
	                        className: 'form-control mentions-input',
	                        type: 'text',
	                        defaultValue: this.state.customKeys,
	                        onChange: this.onCustomChange
	                    })
	                ));
	
	                keysSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: formatMessage(holders.wordsTrigger),
	                    inputs: _inputs3,
	                    submit: this.handleSubmit,
	                    server_error: serverError,
	                    updateSection: this.handleCancel
	                });
	            } else {
	                var keys = [];
	                if (this.state.firstNameKey) {
	                    keys.push(user.first_name);
	                }
	                if (this.state.usernameKey) {
	                    keys.push(user.username);
	                }
	                if (this.state.mentionKey) {
	                    keys.push('@' + user.username);
	                }
	
	                // if (this.state.allKey) {
	                //     keys.push('@all');
	                // }
	
	                if (this.state.channelKey) {
	                    keys.push('@channel');
	                }
	                if (this.state.customKeys.length > 0) {
	                    keys = keys.concat(this.state.customKeys.split(','));
	                }
	
	                var _describe3 = '';
	                for (var i = 0; i < keys.length; i++) {
	                    _describe3 += '"' + keys[i] + '", ';
	                }
	
	                if (_describe3.length > 0) {
	                    _describe3 = _describe3.substring(0, _describe3.length - 2);
	                } else {
	                    _describe3 = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.notifications.noWords',
	                        defaultMessage: 'No words configured'
	                    });
	                }
	
	                handleUpdateKeysSection = function updateKeysSection() {
	                    this.props.updateSection('keys');
	                }.bind(this);
	
	                keysSection = /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.wordsTrigger),
	                    describe: _describe3,
	                    updateSection: handleUpdateKeysSection
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': formatMessage(holders.close),
	                            onClick: this.props.closeModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('i', {
	                                className: 'fa fa-angle-left',
	                                onClick: this.props.collapseModal
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.notifications.title',
	                            defaultMessage: 'Notification Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                    'div',
	                    {
	                        ref: 'wrapper',
	                        className: 'user-settings'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.notifications.header',
	                            defaultMessage: 'Notifications'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    desktopSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', { className: 'divider-light' }),
	                    soundSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', { className: 'divider-light' }),
	                    emailSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', { className: 'divider-light' }),
	                    keysSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement('div', { className: 'divider-dark' })
	                )
	            );
	        }
	    }]);
	
	    return NotificationsTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);
	
	NotificationsTab.defaultProps = {
	    user: null,
	    activeSection: '',
	    activeTab: ''
	};
	NotificationsTab.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["intlShape"].isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.object,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.func,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.func,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.string,
	    activeTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.string,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_14_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_react_intl__["injectIntl"].bind()(NotificationsTab);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__access_history_modal_jsx__ = __webpack_require__(637);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__activity_log_modal_jsx__ = __webpack_require__(638);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__toggle_modal_button_jsx__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_team_store_jsx__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __WEBPACK_IMPORTED_MODULE_17_react_intl__ && __WEBPACK_IMPORTED_MODULE_17_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router___default = __WEBPACK_IMPORTED_MODULE_18_react_router__ && __WEBPACK_IMPORTED_MODULE_18_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react_router___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __WEBPACK_IMPORTED_MODULE_19_react__ && __WEBPACK_IMPORTED_MODULE_19_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_19_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_19_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_19_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_19_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["defineMessages"].bind()({
	    currentPasswordError: {
	        id: 'user.settings.security.currentPasswordError',
	        defaultMessage: 'Please enter your current password'
	    },
	    passwordLengthError: {
	        id: 'user.settings.security.passwordLengthError',
	        defaultMessage: 'New passwords must be at least {chars} characters'
	    },
	    passwordMatchError: {
	        id: 'user.settings.security.passwordMatchError',
	        defaultMessage: 'The new passwords you entered do not match'
	    },
	    method: {
	        id: 'user.settings.security.method',
	        defaultMessage: 'Sign-in Method'
	    },
	    close: {
	        id: 'user.settings.security.close',
	        defaultMessage: 'Close'
	    }
	});
	
	
	
	var SecurityTab = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(SecurityTab, _React$Component);
	
	    function SecurityTab(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, SecurityTab);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(SecurityTab).call(this, props));
	
	        _this.submitPassword = _this.submitPassword.bind(_this);
	        _this.activateMfa = _this.activateMfa.bind(_this);
	        _this.deactivateMfa = _this.deactivateMfa.bind(_this);
	        _this.updateCurrentPassword = _this.updateCurrentPassword.bind(_this);
	        _this.updateNewPassword = _this.updateNewPassword.bind(_this);
	        _this.updateConfirmPassword = _this.updateConfirmPassword.bind(_this);
	        _this.updateMfaToken = _this.updateMfaToken.bind(_this);
	        _this.getDefaultState = _this.getDefaultState.bind(_this);
	        _this.createPasswordSection = _this.createPasswordSection.bind(_this);
	        _this.createSignInSection = _this.createSignInSection.bind(_this);
	        _this.showQrCode = _this.showQrCode.bind(_this);
	
	        _this.state = _this.getDefaultState();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(SecurityTab, [{
	        key: 'getDefaultState',
	        value: function getDefaultState() {
	            return {
	                currentPassword: '',
	                newPassword: '',
	                confirmPassword: '',
	                authService: this.props.user.auth_service,
	                mfaShowQr: false,
	                mfaToken: ''
	            };
	        }
	    }, {
	        key: 'submitPassword',
	        value: function submitPassword(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var user = this.props.user;
	            var currentPassword = this.state.currentPassword;
	            var newPassword = this.state.newPassword;
	            var confirmPassword = this.state.confirmPassword;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	            if (currentPassword === '') {
	                this.setState({ passwordError: formatMessage(holders.currentPasswordError), serverError: '' });
	                return;
	            }
	
	            if (newPassword.length < /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH) {
	                this.setState({ passwordError: formatMessage(holders.passwordLengthError, { chars: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].MIN_PASSWORD_LENGTH }), serverError: '' });
	                return;
	            }
	
	            if (newPassword !== confirmPassword) {
	                var defaultState = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()(this.getDefaultState(), { passwordError: formatMessage(holders.passwordMatchError), serverError: '' });
	                this.setState(defaultState);
	                return;
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_web_client_jsx__["a"].updatePassword(user.id, currentPassword, newPassword, function () {
	                _this2.props.updateSection('');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__.getMe();
	                _this2.setState(_this2.getDefaultState());
	            }, function (err) {
	                var state = _this2.getDefaultState();
	                if (err.message) {
	                    state.serverError = err.message;
	                } else {
	                    state.serverError = err;
	                }
	                state.passwordError = '';
	                _this2.setState(state);
	            });
	        }
	    }, {
	        key: 'activateMfa',
	        value: function activateMfa() {
	            var _this3 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_web_client_jsx__["a"].updateMfa(this.state.mfaToken, true, function () {
	                _this3.props.updateSection('');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__.getMe();
	                _this3.setState(_this3.getDefaultState());
	            }, function (err) {
	                var state = _this3.getDefaultState();
	                if (err.message) {
	                    state.serverError = err.message;
	                } else {
	                    state.serverError = err;
	                }
	                state.mfaError = '';
	                _this3.setState(state);
	            });
	        }
	    }, {
	        key: 'deactivateMfa',
	        value: function deactivateMfa() {
	            var _this4 = this;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_web_client_jsx__["a"].updateMfa('', false, function () {
	                _this4.props.updateSection('');
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_14_utils_async_client_jsx__.getMe();
	                _this4.setState(_this4.getDefaultState());
	            }, function (err) {
	                var state = _this4.getDefaultState();
	                if (err.message) {
	                    state.serverError = err.message;
	                } else {
	                    state.serverError = err;
	                }
	                state.mfaError = '';
	                _this4.setState(state);
	            });
	        }
	    }, {
	        key: 'updateCurrentPassword',
	        value: function updateCurrentPassword(e) {
	            this.setState({ currentPassword: e.target.value });
	        }
	    }, {
	        key: 'updateNewPassword',
	        value: function updateNewPassword(e) {
	            this.setState({ newPassword: e.target.value });
	        }
	    }, {
	        key: 'updateConfirmPassword',
	        value: function updateConfirmPassword(e) {
	            this.setState({ confirmPassword: e.target.value });
	        }
	    }, {
	        key: 'updateMfaToken',
	        value: function updateMfaToken(e) {
	            this.setState({ mfaToken: e.target.value });
	        }
	    }, {
	        key: 'showQrCode',
	        value: function showQrCode(e) {
	            e.preventDefault();
	            this.setState({ mfaShowQr: true });
	        }
	    }, {
	        key: 'createMfaSection',
	        value: function createMfaSection() {
	            var updateSectionStatus = void 0;
	            var submit = void 0;
	
	            if (this.props.activeSection === 'mfa') {
	                var content = void 0;
	                var extraInfo = void 0;
	                if (this.props.user.mfa_active) {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        { key: 'mfaQrCode' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'btn btn-primary',
	                                href: '#',
	                                onClick: this.deactivateMfa
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.mfa.remove',
	                                defaultMessage: 'Remove MFA from your account'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)
	                    );
	
	                    extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.mfa.removeHelp',
	                            defaultMessage: 'Removing multi-factor authentication will make your account more vulnerable to attacks.'
	                        })
	                    );
	                } else if (this.state.mfaShowQr) {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        { key: 'mfaButton' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-5 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.mfa.qrCode',
	                                    defaultMessage: 'Bar Code'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('img', {
	                                    className: 'qr-code-img',
	                                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_utils_web_client_jsx__["a"].getUsersRoute() + '/generate_mfa_qr?time=' + this.props.user.update_at
	                                })
	                            )
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'form-group' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                                'label',
	                                { className: 'col-sm-5 control-label' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                    id: 'user.settings.mfa.enterToken',
	                                    defaultMessage: 'Token (numbers only)'
	                                })
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                                'div',
	                                { className: 'col-sm-7' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('input', {
	                                    className: 'form-control',
	                                    type: 'number',
	                                    autoFocus: true,
	                                    onChange: this.updateMfaToken,
	                                    value: this.state.mfaToken
	                                })
	                            )
	                        )
	                    );
	
	                    extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.mfa.addHelpQr',
	                            defaultMessage: 'Please scan the QR code with the Google Authenticator app on your smartphone and fill in the token with one provided by the app.'
	                        })
	                    );
	
	                    submit = this.activateMfa;
	                } else {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        { key: 'mfaQrCode' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'a',
	                            {
	                                className: 'btn btn-primary',
	                                href: '#',
	                                onClick: this.showQrCode
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.mfa.add',
	                                defaultMessage: 'Add MFA to your account'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)
	                    );
	
	                    extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'span',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedHTMLMessage"], {
	                            id: 'user.settings.mfa.addHelp',
	                            defaultMessage: 'You can require a smartphone-based token, in addition to your password, to sign into Mattermost.<br/><br/>To enable, download Google Authenticator from <a target=\'_blank\' href=\'https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8\'>iTunes</a> or <a target=\'_blank\' href=\'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en\'>Google Play</a> for your phone, then<br/><br/>1. Click the <strong>Add MFA to your account</strong> button above.<br/>2. Use Google Authenticator to scan the QR code that appears.<br/>3. Type in the Token generated by Google Authenticator and click <strong>Save</strong>.<br/><br/>When logging in, you will be asked to enter a token from Google Authenticator in addition to your regular credentials.'
	                        })
	                    );
	                }
	
	                var inputs = [];
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'div',
	                    {
	                        key: 'mfaSetting',
	                        className: 'form-group'
	                    },
	                    content
	                ));
	
	                updateSectionStatus = function resetSection(e) {
	                    this.props.updateSection('');
	                    this.setState({ mfaToken: '', mfaShowQr: false, mfaError: null });
	                    e.preventDefault();
	                }.bind(this);
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.localizeMessage('user.settings.mfa.title', 'Multi-factor Authentication'),
	                    inputs: inputs,
	                    extraInfo: extraInfo,
	                    submit: submit,
	                    server_error: this.state.serverError,
	                    client_error: this.state.mfaError,
	                    updateSection: updateSectionStatus
	                });
	            }
	
	            var describe = void 0;
	            if (this.props.user.mfa_active) {
	                describe = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.localizeMessage('user.settings.security.active', 'Active');
	            } else {
	                describe = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.localizeMessage('user.settings.security.inactive', 'Inactive');
	            }
	
	            updateSectionStatus = function updateSection() {
	                this.props.updateSection('mfa');
	            }.bind(this);
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                title: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.localizeMessage('user.settings.mfa.title', 'Multi-factor Authentication'),
	                describe: describe,
	                updateSection: updateSectionStatus
	            });
	        }
	    }, {
	        key: 'createPasswordSection',
	        value: function createPasswordSection() {
	            var updateSectionStatus = void 0;
	
	            if (this.props.activeSection === 'password') {
	                var inputs = [];
	                var submit = void 0;
	
	                if (this.props.user.auth_service === '') {
	                    submit = this.submitPassword;
	
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'currentPasswordUpdateForm',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.currentPassword',
	                                defaultMessage: 'Current Password'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'password',
	                                onChange: this.updateCurrentPassword,
	                                value: this.state.currentPassword
	                            })
	                        )
	                    ));
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'newPasswordUpdateForm',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.newPassword',
	                                defaultMessage: 'New Password'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'password',
	                                onChange: this.updateNewPassword,
	                                value: this.state.newPassword
	                            })
	                        )
	                    ));
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'retypeNewPasswordUpdateForm',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'label',
	                            { className: 'col-sm-5 control-label' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.retypePassword',
	                                defaultMessage: 'Retype New Password'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'col-sm-7' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('input', {
	                                className: 'form-control',
	                                type: 'password',
	                                onChange: this.updateConfirmPassword,
	                                value: this.state.confirmPassword
	                            })
	                        )
	                    ));
	                } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].GITLAB_SERVICE) {
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'oauthEmailInfo',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'setting-list__hint' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.passwordGitlabCantUpdate',
	                                defaultMessage: 'Login occurs through GitLab. Password cannot be updated.'
	                            })
	                        )
	                    ));
	                } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].LDAP_SERVICE) {
	                    inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        {
	                            key: 'oauthEmailInfo',
	                            className: 'form-group'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'setting-list__hint' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.passwordLdapCantUpdate',
	                                defaultMessage: 'Login occurs through LDAP. Password cannot be updated.'
	                            })
	                        )
	                    ));
	                }
	
	                updateSectionStatus = function resetSection(e) {
	                    this.props.updateSection('');
	                    this.setState({ currentPassword: '', newPassword: '', confirmPassword: '', serverError: null, passwordError: null });
	                    e.preventDefault();
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('.settings-modal .modal-body').scrollTop(0).perfectScrollbar('update');
	                }.bind(this);
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.security.password',
	                        defaultMessage: 'Password'
	                    }),
	                    inputs: inputs,
	                    submit: submit,
	                    server_error: this.state.serverError,
	                    client_error: this.state.passwordError,
	                    updateSection: updateSectionStatus
	                });
	            }
	
	            var describe = void 0;
	
	            if (this.props.user.auth_service === '') {
	                var d = new Date(this.props.user.last_password_update);
	                var hours12 = !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.isMilitaryTime();
	
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.security.lastUpdated',
	                    defaultMessage: 'Last updated {date} at {time}',
	                    values: {
	                        date: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedDate"], {
	                            value: d,
	                            day: '2-digit',
	                            month: 'short',
	                            year: 'numeric'
	                        }),
	                        time: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedTime"], {
	                            value: d,
	                            hour12: hours12,
	                            hour: '2-digit',
	                            minute: '2-digit'
	                        })
	                    }
	                });
	            } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].GITLAB_SERVICE) {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.security.loginGitlab',
	                    defaultMessage: 'Login done through Gitlab'
	                });
	            } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].LDAP_SERVICE) {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.security.loginLdap',
	                    defaultMessage: 'Login done through LDAP'
	                });
	            }
	
	            updateSectionStatus = function updateSection() {
	                this.props.updateSection('password');
	            }.bind(this);
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                title: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.security.password',
	                    defaultMessage: 'Password'
	                }),
	                describe: describe,
	                updateSection: updateSectionStatus
	            });
	        }
	    }, {
	        key: 'createSignInSection',
	        value: function createSignInSection() {
	            var updateSectionStatus = void 0;
	            var user = this.props.user;
	
	            if (this.props.activeSection === 'signin') {
	                var teamName = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_team_store_jsx__["a"].getCurrent().name;
	
	                var emailOption = void 0;
	                if (global.window.mm_config.EnableSignUpWithEmail === 'true' && user.auth_service !== '') {
	                    var link = void 0;
	                    if (user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].LDAP_SERVICE) {
	                        link = '/claim/ldap_to_email?email=' + encodeURIComponent(user.email);
	                    } else {
	                        link = '/claim/oauth_to_email?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service;
	                    }
	
	                    emailOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_router__["Link"],
	                            {
	                                className: 'btn btn-primary',
	                                to: link
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.switchEmail',
	                                defaultMessage: 'Switch to using email and password'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)
	                    );
	                }
	
	                var gitlabOption = void 0;
	                if (global.window.mm_config.EnableSignUpWithGitLab === 'true' && user.auth_service === '') {
	                    gitlabOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_router__["Link"],
	                            {
	                                className: 'btn btn-primary',
	                                to: '/claim/email_to_oauth?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service + '&new_type=' + /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].GITLAB_SERVICE
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.switchGitlab',
	                                defaultMessage: 'Switch to using GitLab SSO'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)
	                    );
	                }
	
	                var googleOption = void 0;
	                if (global.window.mm_config.EnableSignUpWithGoogle === 'true' && user.auth_service === '') {
	                    googleOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_router__["Link"],
	                            {
	                                className: 'btn btn-primary',
	                                to: '/' + teamName + '/claim/email_to_oauth?email=' + encodeURIComponent(user.email) + '&old_type=' + user.auth_service + '&new_type=' + /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].GOOGLE_SERVICE
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.switchGoogle',
	                                defaultMessage: 'Switch to using Google SSO'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)
	                    );
	                }
	
	                var ldapOption = void 0;
	                if (global.window.mm_config.EnableLdap === 'true' && user.auth_service === '') {
	                    ldapOption = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'div',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react_router__["Link"],
	                            {
	                                className: 'btn btn-primary',
	                                to: '/claim/email_to_ldap?email=' + encodeURIComponent(user.email)
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                                id: 'user.settings.security.switchLdap',
	                                defaultMessage: 'Switch to using LDAP'
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null)
	                    );
	                }
	
	                var inputs = [];
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'div',
	                    { key: 'userSignInOption' },
	                    emailOption,
	                    gitlabOption,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null),
	                    ldapOption,
	                    googleOption
	                ));
	
	                updateSectionStatus = function updateSection(e) {
	                    this.props.updateSection('');
	                    this.setState({ serverError: null });
	                    e.preventDefault();
	                }.bind(this);
	
	                var extraInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'span',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                        id: 'user.settings.security.oneSignin',
	                        defaultMessage: 'You may only have one sign-in method at a time. Switching sign-in method will send an email notifying you if the change was successful.'
	                    })
	                );
	
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__setting_item_max_jsx__["a"], {
	                    title: this.props.intl.formatMessage(holders.method),
	                    extraInfo: extraInfo,
	                    inputs: inputs,
	                    server_error: this.state.serverError,
	                    updateSection: updateSectionStatus
	                });
	            }
	
	            updateSectionStatus = function updateSection() {
	                this.props.updateSection('signin');
	            }.bind(this);
	
	            var describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                id: 'user.settings.security.emailPwd',
	                defaultMessage: 'Email and Password'
	            });
	            if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].GITLAB_SERVICE) {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.security.gitlab',
	                    defaultMessage: 'GitLab SSO'
	                });
	            } else if (this.props.user.auth_service === /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].LDAP_SERVICE) {
	                describe = /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                    id: 'user.settings.security.ldap',
	                    defaultMessage: 'LDAP'
	                });
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_7__setting_item_min_jsx__["a"], {
	                title: this.props.intl.formatMessage(holders.method),
	                describe: describe,
	                updateSection: updateSectionStatus
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var passwordSection = this.createPasswordSection();
	
	            var numMethods = 0;
	            numMethods = global.window.mm_config.EnableSignUpWithGitLab === 'true' ? numMethods + 1 : numMethods;
	            numMethods = global.window.mm_config.EnableSignUpWithGoogle === 'true' ? numMethods + 1 : numMethods;
	            numMethods = global.window.mm_config.EnableLdap === 'true' ? numMethods + 1 : numMethods;
	
	            var signInSection = void 0;
	            if (global.window.mm_config.EnableSignUpWithEmail === 'true' && numMethods > 0) {
	                signInSection = this.createSignInSection();
	            }
	
	            var mfaSection = void 0;
	            if (global.window.mm_config.EnableMultifactorAuthentication === 'true' && global.window.mm_license.IsLicensed === 'true') {
	                mfaSection = this.createMfaSection();
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'close',
	                            'data-dismiss': 'modal',
	                            'aria-label': this.props.intl.formatMessage(holders.close),
	                            onClick: this.props.closeModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'span',
	                            { 'aria-hidden': 'true' },
	                            '×'
	                        )
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'h4',
	                        {
	                            className: 'modal-title',
	                            ref: 'title'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                            'div',
	                            { className: 'modal-back' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('i', {
	                                className: 'fa fa-angle-left',
	                                onClick: this.props.collapseModal
	                            })
	                        ),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.security.title',
	                            defaultMessage: 'Security Settings'
	                        })
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                    'div',
	                    { className: 'user-settings' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'h3',
	                        { className: 'tab-header' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.security.title',
	                            defaultMessage: 'Security Settings'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: 'divider-dark first' }),
	                    passwordSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: 'divider-light' }),
	                    mfaSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: 'divider-light' }),
	                    signInSection,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('div', { className: 'divider-dark' }),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11__toggle_modal_button_jsx__["a"],
	                        {
	                            className: 'security-links theme',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_9__access_history_modal_jsx__["a"]
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('i', { className: 'fa fa-clock-o' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.security.viewHistory',
	                            defaultMessage: 'View Access History'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        'b',
	                        null,
	                        ' '
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_11__toggle_modal_button_jsx__["a"],
	                        {
	                            className: 'security-links theme',
	                            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_10__activity_log_modal_jsx__["a"]
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement('i', { className: 'fa fa-clock-o' }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.security.logoutActiveSessions',
	                            defaultMessage: 'View and Logout of Active Sessions'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SecurityTab;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);
	
	SecurityTab.defaultProps = {
	    user: {},
	    activeSection: ''
	};
	SecurityTab.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["intlShape"].isRequired,
	    user: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.object,
	    activeSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.string,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.func,
	    updateTab: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.func,
	    closeModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.func.isRequired,
	    collapseModal: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.func.isRequired,
	    setEnforceFocus: /* harmony import */__WEBPACK_IMPORTED_MODULE_19_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["injectIntl"].bind()(SecurityTab);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __WEBPACK_IMPORTED_MODULE_6_jquery__ && __WEBPACK_IMPORTED_MODULE_6_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __WEBPACK_IMPORTED_MODULE_7_react_dom__ && __WEBPACK_IMPORTED_MODULE_7_react_dom__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react_dom__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react_dom__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react_dom___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react_dom___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__custom_theme_chooser_jsx__ = __webpack_require__(770);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__premade_theme_chooser_jsx__ = __webpack_require__(773);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__setting_item_min_jsx__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__setting_item_max_jsx__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __WEBPACK_IMPORTED_MODULE_17_react_intl__ && __WEBPACK_IMPORTED_MODULE_17_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __WEBPACK_IMPORTED_MODULE_18_react__ && __WEBPACK_IMPORTED_MODULE_18_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].ActionTypes;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["defineMessages"].bind()({
	    themeTitle: {
	        id: 'user.settings.display.theme.title',
	        defaultMessage: 'Theme'
	    },
	    themeDescribe: {
	        id: 'user.settings.display.theme.describe',
	        defaultMessage: 'Open to manage your theme'
	    }
	});
	
	
	
	var ThemeSetting = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(ThemeSetting, _React$Component);
	
	    function ThemeSetting(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ThemeSetting);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ThemeSetting).call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	        _this.submitTheme = _this.submitTheme.bind(_this);
	        _this.updateTheme = _this.updateTheme.bind(_this);
	        _this.resetFields = _this.resetFields.bind(_this);
	        _this.handleImportModal = _this.handleImportModal.bind(_this);
	
	        _this.state = _this.getStateFromStores();
	
	        _this.originalTheme = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, _this.state.theme);
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(ThemeSetting, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].addChangeListener(this.onChange);
	
	            if (this.props.selected) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs[this.state.theme])).addClass('active-border');
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.selected) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('.color-btn').removeClass('active-border');
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.refs[this.state.theme])).addClass('active-border');
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.selected && !nextProps.selected) {
	                this.resetFields();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].removeChangeListener(this.onChange);
	
	            if (this.props.selected) {
	                var state = this.getStateFromStores();
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.applyTheme(state.theme);
	            }
	        }
	    }, {
	        key: 'getStateFromStores',
	        value: function getStateFromStores() {
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getCurrentUser();
	            var theme = null;
	
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.isPlainObject(user.theme_props) && !/* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.isEmptyObject(user.theme_props)) {
	                theme = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, user.theme_props);
	            } else {
	                theme = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.extend(true, {}, /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].THEMES.default);
	            }
	
	            var type = 'premade';
	            if (theme.type === 'custom') {
	                type = 'custom';
	            }
	
	            if (!theme.codeTheme) {
	                theme.codeTheme = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_utils_constants_jsx__["a"].DEFAULT_CODE_THEME;
	            }
	
	            return { theme: theme, type: type };
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            var newState = this.getStateFromStores();
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.areObjectsEqual(this.state, newState)) {
	                this.setState(newState);
	            }
	
	            this.props.setEnforceFocus(true);
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_6_jquery___default.a.bind()('.ps-container.modal-body').scrollTop(0);
	        }
	    }, {
	        key: 'submitTheme',
	        value: function submitTheme(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_12_stores_user_store_jsx__["a"].getCurrentUser();
	            user.theme_props = this.state.theme;
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_14_utils_web_client_jsx__["a"].updateUser(user, function (data) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default.a.handleServerAction({
	                    type: ActionTypes.RECEIVED_ME,
	                    me: data
	                });
	
	                _this2.props.setRequireConfirm(false);
	                _this2.originalTheme = /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a.bind()({}, _this2.state.theme);
	                _this2.scrollToTop();
	                _this2.props.updateSection('');
	            }, function (err) {
	                var state = _this2.getStateFromStores();
	                state.serverError = err;
	                _this2.setState(state);
	            });
	        }
	    }, {
	        key: 'updateTheme',
	        value: function updateTheme(theme) {
	            var themeChanged = this.state.theme.length === theme.length;
	            if (!themeChanged) {
	                for (var field in theme) {
	                    if (theme.hasOwnProperty(field)) {
	                        if (this.state.theme[field] !== theme[field]) {
	                            themeChanged = true;
	                            break;
	                        }
	                    }
	                }
	            }
	
	            this.props.setRequireConfirm(themeChanged);
	
	            this.setState({ theme: theme });
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.applyTheme(theme);
	        }
	    }, {
	        key: 'updateType',
	        value: function updateType(type) {
	            this.setState({ type: type });
	        }
	    }, {
	        key: 'resetFields',
	        value: function resetFields() {
	            var state = this.getStateFromStores();
	            state.serverError = null;
	            this.setState(state);
	            this.scrollToTop();
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_15_utils_utils_jsx__.applyTheme(state.theme);
	
	            this.props.setRequireConfirm(false);
	        }
	    }, {
	        key: 'handleImportModal',
	        value: function handleImportModal() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13__dispatcher_app_dispatcher_jsx___default.a.handleViewAction({
	                type: ActionTypes.TOGGLE_IMPORT_THEME_MODAL,
	                value: true
	            });
	
	            this.props.setEnforceFocus(false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var formatMessage = this.props.intl.formatMessage;
	
	
	            var serverError;
	            if (this.state.serverError) {
	                serverError = this.state.serverError;
	            }
	
	            var displayCustom = this.state.type === 'custom';
	
	            var custom = void 0;
	            var premade = void 0;
	            if (displayCustom) {
	                custom = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { key: 'customThemeChooser' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_8__custom_theme_chooser_jsx__["a"], {
	                        theme: this.state.theme,
	                        updateTheme: this.updateTheme
	                    })
	                );
	            } else {
	                premade = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { key: 'premadeThemeChooser' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__premade_theme_chooser_jsx__["a"], {
	                        theme: this.state.theme,
	                        updateTheme: this.updateTheme
	                    })
	                );
	            }
	
	            var themeUI = void 0;
	            if (this.props.selected) {
	                var inputs = [];
	
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'radio',
	                        key: 'premadeThemeColorLabel'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'label',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', { type: 'radio',
	                            checked: !displayCustom,
	                            onChange: this.updateType.bind(this, 'premade')
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.theme.themeColors',
	                            defaultMessage: 'Theme Colors'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null)
	                ));
	
	                inputs.push(premade);
	
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'radio',
	                        key: 'customThemeColorLabel'
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'label',
	                        null,
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('input', { type: 'radio',
	                            checked: displayCustom,
	                            onChange: this.updateType.bind(this, 'custom')
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.theme.customTheme',
	                            defaultMessage: 'Custom Theme'
	                        })
	                    )
	                ));
	
	                inputs.push(custom);
	
	                inputs.push(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'div',
	                    { key: 'importSlackThemeButton' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('br', null),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'a',
	                        {
	                            className: 'theme',
	                            onClick: this.handleImportModal
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"], {
	                            id: 'user.settings.display.theme.import',
	                            defaultMessage: 'Import theme colors from Slack'
	                        })
	                    )
	                ));
	
	                themeUI = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__setting_item_max_jsx__["a"], {
	                    inputs: inputs,
	                    submit: this.submitTheme,
	                    server_error: serverError,
	                    width: 'full',
	                    updateSection: function updateSection(e) {
	                        _this3.props.updateSection('');
	                        e.preventDefault();
	                    }
	                });
	            } else {
	                themeUI = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10__setting_item_min_jsx__["a"], {
	                    title: formatMessage(holders.themeTitle),
	                    describe: formatMessage(holders.themeDescribe),
	                    updateSection: function updateSection() {
	                        _this3.props.updateSection('theme');
	                    }
	                });
	            }
	
	            return themeUI;
	        }
	    }]);
	
	    return ThemeSetting;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ThemeSetting;
	
	
	ThemeSetting.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["intlShape"].isRequired,
	    selected: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool.isRequired,
	    updateSection: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    setRequireConfirm: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    setEnforceFocus: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_intl__["injectIntl"].bind()(ThemeSetting);

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__audio_video_preview_jsx__ = __webpack_require__(667);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__code_preview_jsx__ = __webpack_require__(691);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__file_info_preview_jsx__ = __webpack_require__(248);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__ = __webpack_require__(785);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_image_popover_bar_jsx__ = __webpack_require__(783);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_load_gif__ = __webpack_require__(98);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_load_gif___default = __WEBPACK_IMPORTED_MODULE_15_images_load_gif__ && __WEBPACK_IMPORTED_MODULE_15_images_load_gif__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_15_images_load_gif__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_15_images_load_gif__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_15_images_load_gif___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_15_images_load_gif___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl___default = __WEBPACK_IMPORTED_MODULE_16_react_intl__ && __WEBPACK_IMPORTED_MODULE_16_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_16_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_16_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_16_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_bootstrap___default = __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__ && __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_17_react_bootstrap___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_17_react_bootstrap___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __WEBPACK_IMPORTED_MODULE_18_react__ && __WEBPACK_IMPORTED_MODULE_18_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_18_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_18_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_18_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_18_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var KeyCodes = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].KeyCodes;
	
	var holders = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["defineMessages"].bind()({
	    loading: {
	        id: 'view_image.loading',
	        defaultMessage: 'Loading '
	    }
	});
	
	
	
	var ViewImageModal = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ViewImageModal, _React$Component);
	
	    function ViewImageModal(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ViewImageModal);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ViewImageModal).call(this, props));
	
	        _this.showImage = _this.showImage.bind(_this);
	        _this.loadImage = _this.loadImage.bind(_this);
	
	        _this.handleNext = _this.handleNext.bind(_this);
	        _this.handlePrev = _this.handlePrev.bind(_this);
	        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	
	        _this.onModalShown = _this.onModalShown.bind(_this);
	        _this.onModalHidden = _this.onModalHidden.bind(_this);
	
	        _this.onFileStoreChange = _this.onFileStoreChange.bind(_this);
	
	        _this.handleGetPublicLink = _this.handleGetPublicLink.bind(_this);
	        _this.onMouseEnterImage = _this.onMouseEnterImage.bind(_this);
	        _this.onMouseLeaveImage = _this.onMouseLeaveImage.bind(_this);
	
	        _this.state = {
	            imgId: _this.props.startId,
	            fileInfo: null,
	            imgHeight: '100%',
	            loaded: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.fillArray(false, _this.props.filenames.length),
	            progress: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.fillArray(0, _this.props.filenames.length),
	            showFooter: false
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ViewImageModal, [{
	        key: 'handleNext',
	        value: function handleNext(e) {
	            if (e) {
	                e.stopPropagation();
	            }
	            var id = this.state.imgId + 1;
	            if (id > this.props.filenames.length - 1) {
	                id = 0;
	            }
	            this.showImage(id);
	        }
	    }, {
	        key: 'handlePrev',
	        value: function handlePrev(e) {
	            if (e) {
	                e.stopPropagation();
	            }
	            var id = this.state.imgId - 1;
	            if (id < 0) {
	                id = this.props.filenames.length - 1;
	            }
	            this.showImage(id);
	        }
	    }, {
	        key: 'handleKeyPress',
	        value: function handleKeyPress(e) {
	            if (e.keyCode === KeyCodes.RIGHT) {
	                this.handleNext();
	            } else if (e.keyCode === KeyCodes.LEFT) {
	                this.handlePrev();
	            }
	        }
	    }, {
	        key: 'onModalShown',
	        value: function onModalShown(nextProps) {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).on('keyup', this.handleKeyPress);
	
	            this.showImage(nextProps.startId);
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__["a"].addChangeListener(this.onFileStoreChange);
	        }
	    }, {
	        key: 'onModalHidden',
	        value: function onModalHidden() {
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).off('keyup', this.handleKeyPress);
	
	            if (this.refs.video) {
	                this.refs.video.stop();
	            }
	
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__["a"].removeChangeListener(this.onFileStoreChange);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.show === true && this.props.show === false) {
	                this.onModalShown(nextProps);
	            } else if (nextProps.show === false && this.props.show === true) {
	                this.onModalHidden();
	            }
	
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.areObjectsEqual(this.props.filenames, nextProps.filenames)) {
	                this.setState({
	                    loaded: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.fillArray(false, nextProps.filenames.length),
	                    progress: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.fillArray(0, nextProps.filenames.length)
	                });
	            }
	        }
	    }, {
	        key: 'onFileStoreChange',
	        value: function onFileStoreChange(filename) {
	            var id = this.props.filenames.indexOf(filename);
	
	            if (id !== -1) {
	                if (id === this.state.imgId) {
	                    this.setState({
	                        fileInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__["a"].getInfo(filename)
	                    });
	                }
	
	                if (!this.state.loaded[id]) {
	                    this.loadImage(id, filename);
	                }
	            }
	        }
	    }, {
	        key: 'showImage',
	        value: function showImage(id) {
	            this.setState({ imgId: id });
	
	            var imgHeight = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.bind()(window).height() - 100;
	            this.setState({ imgHeight: imgHeight });
	
	            var filename = this.props.filenames[id];
	
	            if (!/* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__["a"].hasInfo(filename)) {
	                // the image will actually be loaded once we know what we need to load
	                /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_6_utils_async_client_jsx__.getFileInfo(filename);
	                return;
	            }
	
	            this.setState({
	                fileInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__["a"].getInfo(filename)
	            });
	
	            if (!this.state.loaded[id]) {
	                this.loadImage(id, filename);
	            }
	        }
	    }, {
	        key: 'loadImage',
	        value: function loadImage(id, filename) {
	            var _this2 = this;
	
	            var fileInfo = /* harmony import */__WEBPACK_IMPORTED_MODULE_13_stores_file_store_jsx__["a"].getInfo(filename);
	            var fileType = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getFileType(fileInfo.extension);
	
	            if (fileType === 'image') {
	                (function () {
	                    var previewUrl = void 0;
	                    if (fileInfo.has_image_preview) {
	                        previewUrl = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getPreviewImagePath(filename);
	                    } else {
	                        // some images (eg animated gifs) just show the file itself and not a preview
	                        previewUrl = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getFileUrl(filename);
	                    }
	
	                    var img = new Image();
	                    img.load(previewUrl, function () {
	                        var progress = _this2.state.progress;
	                        progress[id] = img.completedPercentage;
	                        _this2.setState({ progress: progress });
	                    });
	                    img.onload = function () {
	                        var loaded = _this2.state.loaded;
	                        loaded[id] = true;
	                        _this2.setState({ loaded: loaded });
	                    };
	                })();
	            } else {
	                // there's nothing to load for non-image files
	                var loaded = this.state.loaded;
	                loaded[id] = true;
	                this.setState({ loaded: loaded });
	            }
	        }
	    }, {
	        key: 'handleGetPublicLink',
	        value: function handleGetPublicLink() {
	            this.props.onModalDismissed();
	
	            /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__.showGetPublicLinkModal(this.props.filenames[this.state.imgId]);
	        }
	    }, {
	        key: 'onMouseEnterImage',
	        value: function onMouseEnterImage() {
	            this.setState({ showFooter: true });
	        }
	    }, {
	        key: 'onMouseLeaveImage',
	        value: function onMouseLeaveImage() {
	            this.setState({ showFooter: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.filenames.length < 1 || this.props.filenames.length - 1 < this.state.imgId) {
	                return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', null);
	            }
	
	            var filename = this.props.filenames[this.state.imgId];
	            var fileUrl = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getFileUrl(filename);
	
	            var content;
	            if (this.state.loaded[this.state.imgId]) {
	                // this.state.fileInfo is for the current image and we shoudl have it before we load the image
	                var fileInfo = this.state.fileInfo;
	                var fileType = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getFileType(fileInfo.extension);
	
	                if (fileType === 'image') {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(ImagePreview, {
	                        filename: filename,
	                        fileUrl: fileUrl,
	                        fileInfo: fileInfo,
	                        maxHeight: this.state.imgHeight
	                    });
	                } else if (fileType === 'video' || fileType === 'audio') {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_9__audio_video_preview_jsx__["a"], {
	                        filename: filename,
	                        fileUrl: fileUrl,
	                        fileInfo: this.state.fileInfo,
	                        maxHeight: this.state.imgHeight,
	                        formatMessage: this.props.intl.formatMessage
	                    });
	                } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_11__code_preview_jsx__["a"].support(filename)) {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_11__code_preview_jsx__["a"], {
	                        filename: filename,
	                        fileUrl: fileUrl,
	                        fileInfo: fileInfo,
	                        formatMessage: this.props.intl.formatMessage
	                    });
	                } else {
	                    content = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_12__file_info_preview_jsx__["a"], {
	                        filename: filename,
	                        fileUrl: fileUrl,
	                        fileInfo: fileInfo,
	                        formatMessage: this.props.intl.formatMessage
	                    });
	                }
	            } else {
	                // display a progress indicator when the preview for an image is still loading
	                var progress = Math.floor(this.state.progress[this.state.imgId]);
	
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(LoadingImagePreview, {
	                    progress: progress,
	                    loading: this.props.intl.formatMessage(holders.loading)
	                });
	            }
	
	            var leftArrow = null;
	            var rightArrow = null;
	            if (this.props.filenames.length > 1) {
	                leftArrow = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'a',
	                    {
	                        ref: 'previewArrowLeft',
	                        className: 'modal-prev-bar',
	                        href: '#',
	                        onClick: this.handlePrev
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'image-control image-prev' })
	                );
	
	                rightArrow = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    'a',
	                    {
	                        ref: 'previewArrowRight',
	                        className: 'modal-next-bar',
	                        href: '#',
	                        onClick: this.handleNext
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('i', { className: 'image-control image-next' })
	                );
	            }
	
	            var closeButtonClass = 'modal-close';
	            if (this.state.showFooter) {
	                closeButtonClass += ' modal-close--show';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_bootstrap__["Modal"],
	                {
	                    show: this.props.show,
	                    onHide: this.props.onModalDismissed,
	                    className: 'modal-image',
	                    dialogClassName: 'modal-image'
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_17_react_bootstrap__["Modal"].Body,
	                    {
	                        modalClassName: 'modal-image__body',
	                        onClick: this.props.onModalDismissed
	                    },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                        'div',
	                        {
	                            className: 'modal-image__wrapper',
	                            onClick: this.props.onModalDismissed
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                            'div',
	                            {
	                                onMouseEnter: this.onMouseEnterImage,
	                                onMouseLeave: this.onMouseLeaveImage,
	                                onClick: function onClick(e) {
	                                    return e.stopPropagation();
	                                }
	                            },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('div', {
	                                className: closeButtonClass,
	                                onClick: this.props.onModalDismissed
	                            }),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	                                'div',
	                                { className: 'modal-image__content' },
	                                content
	                            ),
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_14__view_image_popover_bar_jsx__["a"], {
	                                show: this.state.showFooter,
	                                fileId: this.state.imgId,
	                                totalFiles: this.props.filenames.length,
	                                filename: name,
	                                fileURL: fileUrl,
	                                onGetPublicLink: this.handleGetPublicLink
	                            })
	                        )
	                    ),
	                    leftArrow,
	                    rightArrow
	                )
	            );
	        }
	    }]);
	
	    return ViewImageModal;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);
	
	ViewImageModal.defaultProps = {
	    show: false,
	    filenames: [],
	    channelId: '',
	    userId: '',
	    startId: 0
	};
	ViewImageModal.propTypes = {
	    intl: /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["intlShape"].isRequired,
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.bool.isRequired,
	    onModalDismissed: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.func.isRequired,
	    filenames: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.array,
	    modalId: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    userId: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string,
	    startId: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.number
	};
	
	function LoadingImagePreview(_ref) {
	    var progress = _ref.progress;
	    var loading = _ref.loading;
	
	    var progressView = null;
	    if (progress) {
	        progressView = /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	            'span',
	            { className: 'loader-percent' },
	            loading + progress + '%'
	        );
	    }
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	        'div',
	        { className: 'view-image__loading' },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('img', {
	            className: 'loader-image',
	            src: /* harmony import */__WEBPACK_IMPORTED_MODULE_15_images_load_gif___default.a
	        }),
	        progressView
	    );
	}
	
	LoadingImagePreview.propTypes = {
	    progress: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.number,
	    loading: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string
	};
	
	function ImagePreview(_ref2) {
	    var filename = _ref2.filename;
	    var fileUrl = _ref2.fileUrl;
	    var fileInfo = _ref2.fileInfo;
	    var maxHeight = _ref2.maxHeight;
	
	    var previewUrl = void 0;
	    if (fileInfo.has_preview_image) {
	        previewUrl = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8_utils_utils_jsx__.getPreviewImagePath(filename);
	    } else {
	        previewUrl = fileUrl;
	    }
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
	        'a',
	        {
	            href: fileUrl,
	            target: '_blank',
	            download: true
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement('img', {
	            style: { maxHeight: maxHeight },
	            src: previewUrl
	        })
	    );
	}
	
	ImagePreview.propTypes = {
	    filename: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string.isRequired,
	    fileUrl: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.string.isRequired,
	    fileInfo: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.object.isRequired,
	    maxHeight: /* harmony import */__WEBPACK_IMPORTED_MODULE_18_react___default.a.PropTypes.number.isRequired
	};
	
	/* harmony default export */ exports["a"] = /* harmony import */__WEBPACK_IMPORTED_MODULE_16_react_intl__["injectIntl"].bind()(ViewImageModal);

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __WEBPACK_IMPORTED_MODULE_5_react_intl__ && __WEBPACK_IMPORTED_MODULE_5_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_react_intl___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __WEBPACK_IMPORTED_MODULE_6_react__ && __WEBPACK_IMPORTED_MODULE_6_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_react___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ViewImagePopoverBar = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(ViewImagePopoverBar, _React$Component);
	
	    function ViewImagePopoverBar() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, ViewImagePopoverBar);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(ViewImagePopoverBar).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(ViewImagePopoverBar, [{
	        key: 'render',
	        value: function render() {
	            var publicLink = '';
	            if (global.window.mm_config.EnablePublicLink === 'true') {
	                publicLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'a',
	                        {
	                            href: '#',
	                            className: 'public-link text',
	                            'data-title': 'Public Image',
	                            onClick: this.props.onGetPublicLink
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'view_image_popover.publicLink',
	                            defaultMessage: 'Get Public Link'
	                        })
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'span',
	                        { className: 'text' },
	                        ' | '
	                    )
	                );
	            }
	
	            var footerClass = 'modal-button-bar';
	            if (this.props.show) {
	                footerClass += ' footer--show';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                'div',
	                {
	                    ref: 'imageFooter',
	                    className: footerClass
	                },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'span',
	                    { className: 'pull-left text' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                        id: 'view_image_popover.file',
	                        defaultMessage: 'File {count} of {total}',
	                        values: {
	                            count: this.props.fileId + 1,
	                            total: this.props.totalFiles
	                        }
	                    })
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                    'div',
	                    { className: 'image-links' },
	                    publicLink,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
	                        'a',
	                        {
	                            href: this.props.fileURL,
	                            download: this.props.filename,
	                            className: 'text',
	                            target: '_blank'
	                        },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"], {
	                            id: 'view_image_popover.download',
	                            defaultMessage: 'Download'
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ViewImagePopoverBar;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = ViewImagePopoverBar;
	
	ViewImagePopoverBar.defaultProps = {
	    show: false,
	    imgId: 0,
	    totalFiles: 0,
	    filename: '',
	    fileURL: ''
	};
	
	ViewImagePopoverBar.propTypes = {
	    show: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.bool.isRequired,
	    fileId: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.number.isRequired,
	    totalFiles: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.number.isRequired,
	    filename: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
	    fileURL: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.string.isRequired,
	    onGetPublicLink: /* harmony import */__WEBPACK_IMPORTED_MODULE_6_react___default.a.PropTypes.func.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __WEBPACK_IMPORTED_MODULE_5_jquery__ && __WEBPACK_IMPORTED_MODULE_5_jquery__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_jquery__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_jquery___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_jquery___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __WEBPACK_IMPORTED_MODULE_7_react__ && __WEBPACK_IMPORTED_MODULE_7_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_7_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_7_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_7_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_7_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router___default = __WEBPACK_IMPORTED_MODULE_8_react_router__ && __WEBPACK_IMPORTED_MODULE_8_react_router__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_react_router__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_react_router___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_react_router___default });
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	var ytRegex = /(?:http|https):\/\/(?:www\.)?(?:(?:youtube\.com\/(?:(?:v\/)|(\/u\/\w\/)|(?:(?:watch|embed\/watch)(?:\/|.*v=))|(?:embed\/)|(?:user\/[^\/]+\/u\/[0-9]\/)))|(?:youtu\.be\/))([^#\&\?]*)/;
	
	
	
	
	var YoutubeVideo = function (_React$Component) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(YoutubeVideo, _React$Component);
	
	    function YoutubeVideo(props) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, YoutubeVideo);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(YoutubeVideo).call(this, props));
	
	        _this.updateStateFromProps = _this.updateStateFromProps.bind(_this);
	        _this.handleReceivedMetadata = _this.handleReceivedMetadata.bind(_this);
	
	        _this.play = _this.play.bind(_this);
	        _this.stop = _this.stop.bind(_this);
	        _this.stopOnChannelChange = _this.stopOnChannelChange.bind(_this);
	
	        _this.state = {
	            playing: false,
	            title: ''
	        };
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(YoutubeVideo, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.updateStateFromProps(this.props);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.updateStateFromProps(nextProps);
	        }
	    }, {
	        key: 'updateStateFromProps',
	        value: function updateStateFromProps(props) {
	            var link = props.link;
	
	            var match = link.trim().match(ytRegex);
	            if (!match || match[2].length !== 11) {
	                return;
	            }
	
	            this.setState({
	                videoId: match[2],
	                time: this.handleYoutubeTime(link)
	            });
	        }
	    }, {
	        key: 'handleYoutubeTime',
	        value: function handleYoutubeTime(link) {
	            var timeRegex = /[\\?&]t=([0-9hms]+)/;
	
	            var time = link.match(timeRegex);
	            if (!time || !time[1]) {
	                return '';
	            }
	
	            var hours = time[1].match(/([0-9]+)h/);
	            var minutes = time[1].match(/([0-9]+)m/);
	            var seconds = time[1].match(/([0-9]+)s/);
	
	            var ticks = 0;
	
	            if (hours && hours[1]) {
	                ticks += parseInt(hours[1], 10) * 3600;
	            }
	
	            if (minutes && minutes[1]) {
	                ticks += parseInt(minutes[1], 10) * 60;
	            }
	
	            if (seconds && seconds[1]) {
	                ticks += parseInt(seconds[1], 10);
	            }
	
	            return '&start=' + ticks.toString();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (global.window.mm_config.GoogleDeveloperKey) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
	                    async: true,
	                    url: 'https://www.googleapis.com/youtube/v3/videos',
	                    type: 'GET',
	                    data: { part: 'snippet', id: this.state.videoId, key: global.window.mm_config.GoogleDeveloperKey },
	                    success: this.handleReceivedMetadata
	                });
	            }
	        }
	    }, {
	        key: 'handleReceivedMetadata',
	        value: function handleReceivedMetadata(data) {
	            if (!data.items.length || !data.items[0].snippet) {
	                return null;
	            }
	            var metadata = data.items[0].snippet;
	            this.setState({
	                receivedYoutubeData: true,
	                title: metadata.title
	            });
	            return null;
	        }
	    }, {
	        key: 'play',
	        value: function play() {
	            this.setState({ playing: true });
	
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getCurrentId() === this.props.channelId) {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].addChangeListener(this.stopOnChannelChange);
	            }
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this.setState({ playing: false });
	        }
	    }, {
	        key: 'stopOnChannelChange',
	        value: function stopOnChannelChange() {
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_6_stores_channel_store_jsx__["a"].getCurrentId() !== this.props.channelId) {
	                this.stop();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var header = 'Youtube';
	            if (this.state.title) {
	                header = header + ' - ';
	            }
	
	            var content = void 0;
	            if (this.state.playing) {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('iframe', {
	                    src: 'https://www.youtube.com/embed/' + this.state.videoId + '?autoplay=1&autohide=1&border=0&wmode=opaque&fs=1&enablejsapi=1' + this.state.time,
	                    width: '480px',
	                    height: '360px',
	                    type: 'text/html',
	                    frameBorder: '0',
	                    allowFullScreen: 'allowfullscreen'
	                });
	            } else {
	                content = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    { className: 'embed-responsive embed-responsive-4by3 video-div__placeholder' },
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'div',
	                        { className: 'video-thumbnail__container' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', {
	                            className: 'video-thumbnail',
	                            src: 'https://i.ytimg.com/vi/' + this.state.videoId + '/hqdefault.jpg'
	                        }),
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            'div',
	                            { className: 'block' },
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                                'span',
	                                { className: 'play-button' },
	                                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', null)
	                            )
	                        )
	                    )
	                );
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                'div',
	                null,
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'h4',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'span',
	                        { className: 'video-type' },
	                        header
	                    ),
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                        'span',
	                        { className: 'video-title' },
	                        /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                            /* harmony import */__WEBPACK_IMPORTED_MODULE_8_react_router__["Link"],
	                            { to: this.props.link },
	                            this.state.title
	                        )
	                    )
	                ),
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
	                    'div',
	                    {
	                        className: 'video-div embed-responsive-item',
	                        onClick: this.play
	                    },
	                    content
	                )
	            );
	        }
	    }], [{
	        key: 'isYoutubeLink',
	        value: function isYoutubeLink(link) {
	            return link.trim().match(ytRegex);
	        }
	    }]);
	
	    return YoutubeVideo;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
	
	/* harmony default export */ exports["a"] = YoutubeVideo;
	
	
	YoutubeVideo.propTypes = {
	    channelId: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired,
	    link: /* harmony import */__WEBPACK_IMPORTED_MODULE_7_react___default.a.PropTypes.string.isRequired
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events___default = __WEBPACK_IMPORTED_MODULE_8_events__ && __WEBPACK_IMPORTED_MODULE_8_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_events___default });
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'changed';
	
	var FileStore = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(FileStore, _EventEmitter);
	
	    function FileStore() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, FileStore);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(FileStore).call(this));
	
	        _this.handleEventPayload = _this.handleEventPayload.bind(_this);
	        _this.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(_this.handleEventPayload);
	
	        _this.fileInfo = new /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(FileStore, [{
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'emitChange',
	        value: function emitChange(filename) {
	            this.emit(CHANGE_EVENT, filename);
	        }
	    }, {
	        key: 'hasInfo',
	        value: function hasInfo(filename) {
	            return this.fileInfo.has(filename);
	        }
	    }, {
	        key: 'getInfo',
	        value: function getInfo(filename) {
	            return this.fileInfo.get(filename);
	        }
	    }, {
	        key: 'setInfo',
	        value: function setInfo(filename, info) {
	            this.fileInfo.set(filename, info);
	        }
	    }, {
	        key: 'handleEventPayload',
	        value: function handleEventPayload(payload) {
	            var action = payload.action;
	
	            switch (action.type) {
	                case ActionTypes.RECEIVED_FILE_INFO:
	                    this.setInfo(action.filename, action.info);
	                    this.emitChange(action.filename);
	                    break;
	            }
	        }
	    }]);
	
	    return FileStore;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_events___default.a);
	
	/* harmony default export */ exports["a"] = new FileStore();

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __WEBPACK_IMPORTED_MODULE_6_events__ && __WEBPACK_IMPORTED_MODULE_6_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__ = __webpack_require__(8);
	'use strict';
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	
	var NotificationStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default.a.bind()(NotificationStoreClass, _EventEmitter);
	
	    function NotificationStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default.a.bind()(this, NotificationStoreClass);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(NotificationStoreClass).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default.a.bind()(NotificationStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'handleRecievedPost',
	        value: function handleRecievedPost(post, msgProps) {
	            // Send desktop notification
	            if ((/* harmony import */__WEBPACK_IMPORTED_MODULE_8__user_store_jsx__["a"].getCurrentId() !== post.user_id || post.props.from_webhook === 'true') && !/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.isSystemMessage(post)) {
	                var mentions = [];
	                if (msgProps.mentions) {
	                    mentions = JSON.parse(msgProps.mentions);
	                }
	
	                var channel = /* harmony import */__WEBPACK_IMPORTED_MODULE_9__channel_store_jsx__["a"].get(post.channel_id);
	                var user = /* harmony import */__WEBPACK_IMPORTED_MODULE_8__user_store_jsx__["a"].getCurrentUser();
	                var member = /* harmony import */__WEBPACK_IMPORTED_MODULE_9__channel_store_jsx__["a"].getMember(post.channel_id);
	
	                var notifyLevel = member && member.notify_props ? member.notify_props.desktop : 'default';
	                if (notifyLevel === 'default') {
	                    notifyLevel = user.notify_props.desktop;
	                }
	
	                if (notifyLevel === 'none') {
	                    return;
	                } else if (notifyLevel === 'mention' && mentions.indexOf(user.id) === -1 && msgProps.channel_type !== /* harmony import */__WEBPACK_IMPORTED_MODULE_7_utils_constants_jsx__["a"].DM_CHANNEL) {
	                    return;
	                }
	
	                var username = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.someone', 'Someone');
	                if (post.props.override_username && global.window.mm_config.EnablePostUsernameOverride === 'true') {
	                    username = post.props.override_username;
	                } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_8__user_store_jsx__["a"].hasProfile(post.user_id)) {
	                    username = /* harmony import */__WEBPACK_IMPORTED_MODULE_8__user_store_jsx__["a"].getProfile(post.user_id).username;
	                }
	
	                var title = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.posted', 'Posted');
	                if (channel) {
	                    title = channel.display_name;
	                }
	
	                var notifyText = post.message.replace(/\n+/g, ' ');
	                if (notifyText.length > 50) {
	                    notifyText = notifyText.substring(0, 49) + '...';
	                }
	
	                if (notifyText.length === 0) {
	                    if (msgProps.image) {
	                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.notifyMe(title, username + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.uploadedImage', ' uploaded an image'), channel);
	                    } else if (msgProps.otherFile) {
	                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.notifyMe(title, username + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.uploadedFile', ' uploaded a file'), channel);
	                    } else {
	                        /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.notifyMe(title, username + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.something', ' did something new'), channel);
	                    }
	                } else {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.notifyMe(title, username + /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.localizeMessage('channel_loader.wrote', ' wrote: ') + notifyText, channel);
	                }
	                if (!user.notify_props || user.notify_props.desktop_sound === 'true') {
	                    /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_10_utils_utils_jsx__.ding();
	                }
	            }
	        }
	    }]);
	
	    return NotificationStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_6_events___default.a);
	
	var NotificationStore = new NotificationStoreClass();
	
	NotificationStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_5__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_POST:
	            NotificationStore.handleRecievedPost(action.post, action.websocketMessageProps);
	            NotificationStore.emitChange();
	            break;
	    }
	});
	
	/* unused harmony default export */ var _unused_webpack_default_export = NotificationStore;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default = __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__ && __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events___default = __WEBPACK_IMPORTED_MODULE_8_events__ && __WEBPACK_IMPORTED_MODULE_8_events__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_8_events__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_8_events__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_8_events___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_8_events___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__ = __webpack_require__(10);
	'use strict';
	
	
	
	
	
	
	
	// Copyright (c) 2016 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	var ActionTypes = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].ActionTypes;
	
	var CHANGE_EVENT = 'change';
	
	var UserTypingStoreClass = function (_EventEmitter) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default.a.bind()(UserTypingStoreClass, _EventEmitter);
	
	    function UserTypingStoreClass() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default.a.bind()(this, UserTypingStoreClass);
	
	        // All typeing users by channel
	        // this.typingUsers.[channelId+postParentId].user if present then user us typing
	        // Value is timeout to remove user
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(UserTypingStoreClass).call(this));
	
	        _this.typingUsers = {};
	        return _this;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default.a.bind()(UserTypingStoreClass, [{
	        key: 'emitChange',
	        value: function emitChange() {
	            this.emit(CHANGE_EVENT);
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'nameFromId',
	        value: function nameFromId(userId) {
	            var name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.localizeMessage('msg_typing.someone', 'Someone');
	            if (/* harmony import */__WEBPACK_IMPORTED_MODULE_7_stores_user_store_jsx__["a"].hasProfile(userId)) {
	                name = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_9_utils_utils_jsx__.displayUsername(userId);
	            }
	            return name;
	        }
	    }, {
	        key: 'userTyping',
	        value: function userTyping(channelId, userId, postParentId) {
	            var _this2 = this;
	
	            var name = this.nameFromId(userId);
	
	            // Key representing a location where users can type
	            var loc = channelId + postParentId;
	
	            // Create entry
	            if (!this.typingUsers[loc]) {
	                this.typingUsers[loc] = {};
	            }
	
	            // If we already have this user, clear it's timeout to be deleted
	            if (this.typingUsers[loc][name]) {
	                clearTimeout(this.typingUsers[loc][name].timeout);
	            }
	
	            // Set the user and a timeout to remove it
	            this.typingUsers[loc][name] = setTimeout(function () {
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(_this2.typingUsers[loc], name);
	                if (_this2.typingUsers[loc] === {}) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(_this2.typingUsers, loc);
	                }
	                _this2.emitChange();
	            }, /* harmony import */__WEBPACK_IMPORTED_MODULE_10_utils_constants_jsx__["a"].UPDATE_TYPING_MS);
	            this.emitChange();
	        }
	    }, {
	        key: 'getUsersTyping',
	        value: function getUsersTyping(channelId, postParentId) {
	            // Key representing a location where users can type
	            var loc = channelId + postParentId;
	
	            return this.typingUsers[loc];
	        }
	    }, {
	        key: 'userPosted',
	        value: function userPosted(userId, channelId, postParentId) {
	            var name = this.nameFromId(userId);
	            var loc = channelId + postParentId;
	
	            if (this.typingUsers[loc]) {
	                clearTimeout(this.typingUsers[loc][name]);
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(this.typingUsers[loc], name);
	                if (this.typingUsers[loc] === {}) {
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_reflect_delete_property___default.a.bind()(this.typingUsers, loc);
	                }
	                this.emitChange();
	            }
	        }
	    }]);
	
	    return UserTypingStoreClass;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_8_events___default.a);
	
	var UserTypingStore = new UserTypingStoreClass();
	
	UserTypingStore.dispatchToken = /* harmony import */__WEBPACK_IMPORTED_MODULE_6__dispatcher_app_dispatcher_jsx___default.a.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.type) {
	        case ActionTypes.RECEIVED_POST:
	            UserTypingStore.userPosted(action.post.user_id, action.post.channel_id, action.post.parent_id);
	            break;
	        case ActionTypes.USER_TYPING:
	            UserTypingStore.userTyping(action.channelId, action.userId, action.postParentId);
	            break;
	    }
	});
	
	/* harmony default export */ exports["a"] = UserTypingStore;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_jsx__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_channel_invite_modal_jsx__ = __webpack_require__(185);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_edit_channel_header_modal_jsx__ = __webpack_require__(246);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_toggle_modal_button_jsx__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_user_profile_jsx__ = __webpack_require__(160);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __WEBPACK_IMPORTED_MODULE_9_react__ && __WEBPACK_IMPORTED_MODULE_9_react__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_react__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_react__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_react___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_react___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl___default = __WEBPACK_IMPORTED_MODULE_10_react_intl__ && __WEBPACK_IMPORTED_MODULE_10_react_intl__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_react_intl__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_react_intl___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_react_intl___default });
	/* harmony export */ exports["a"] = createChannelIntroMessage;/* unused harmony export createDMIntroMessage *//* unused harmony export createOffTopicIntroMessage *//* unused harmony export createDefaultIntroMessage *//* unused harmony export createStandardIntroMessage */'use strict';
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function createChannelIntroMessage(channel) {
	    if (channel.type === 'D') {
	        return createDMIntroMessage(channel);
	    } else if (/* harmony import */__WEBPACK_IMPORTED_MODULE_5_stores_channel_store_jsx__["a"].isDefault(channel)) {
	        return createDefaultIntroMessage(channel);
	    } else if (channel.name === /* harmony import */__WEBPACK_IMPORTED_MODULE_6_utils_constants_jsx__["a"].OFFTOPIC_CHANNEL) {
	        return createOffTopicIntroMessage(channel);
	    } else if (channel.type === 'O' || channel.type === 'P') {
	        return createStandardIntroMessage(channel);
	    }
	    return null;
	}
	
	function createDMIntroMessage(channel) {
	    var teammate = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__utils_jsx__.getDirectTeammate(channel.id);
	
	    if (teammate) {
	        var teammateName = teammate.username;
	        if (teammate.nickname.length > 0) {
	            teammateName = teammate.nickname;
	        }
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	            'div',
	            { className: 'channel-intro' },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                { className: 'post-profile-img__container channel-intro-img' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('img', {
	                    className: 'post-profile-img',
	                    src: /* harmony import */__WEBPACK_IMPORTED_MODULE_8_utils_web_client_jsx__["a"].getUsersRoute() + '/' + teammate.id + '/image?time=' + teammate.update_at,
	                    height: '50',
	                    width: '50'
	                })
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'div',
	                { className: 'channel-intro-profile' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                    'strong',
	                    null,
	                    /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_4_components_user_profile_jsx__["a"], { user: teammate })
	                )
	            ),
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	                'p',
	                { className: 'channel-intro-text' },
	                /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                    id: 'intro_messages.DM',
	                    defaultMessage: 'This is the start of your direct message history with {teammate}.<br />Direct messages and files shared here are not shown to people outside this area.',
	                    values: {
	                        teammate: teammateName
	                    }
	                })
	            ),
	            createSetHeaderButton(channel)
	        );
	    }
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        'div',
	        { className: 'channel-intro' },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	            'p',
	            { className: 'channel-intro-text' },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                id: 'intro_messages.teammate',
	                defaultMessage: 'This is the start of your direct message history with this teammate. Direct messages and files shared here are not shown to people outside this area.'
	            })
	        )
	    );
	}
	
	function createOffTopicIntroMessage(channel) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        'div',
	        { className: 'channel-intro' },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	            id: 'intro_messages.offTopic',
	            defaultMessage: '<h4 class="channel-intro__title">Beginning of {display_name}</h4><p class="channel-intro__content">This is the start of {display_name}, a channel for non-work-related conversations.<br/></p>',
	            values: {
	                display_name: channel.display_name
	            }
	        }),
	        createSetHeaderButton(channel),
	        createInviteChannelMemberButton(channel, 'channel')
	    );
	}
	
	function createDefaultIntroMessage(channel) {
	    var inviteModalLink = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        'a',
	        {
	            className: 'intro-links',
	            href: '#',
	            onClick: /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7_action_creators_global_actions_jsx__.showGetTeamInviteLinkModal
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-user-plus' }),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.inviteOthers',
	            defaultMessage: 'Invite others to this team'
	        })
	    );
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        'div',
	        { className: 'channel-intro' },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	            id: 'intro_messages.default',
	            defaultMessage: '<h4 class=\'channel-intro__title\'>Beginning of {display_name}</h4><p class=\'channel-intro__content\'><strong>Welcome to {display_name}!</strong><br/><br/>This is the first channel teammates see when they sign up - use it for posting updates everyone needs to know.</p>',
	            values: {
	                display_name: channel.display_name
	            }
	        }),
	        inviteModalLink,
	        createSetHeaderButton(channel),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	    );
	}
	
	function createStandardIntroMessage(channel) {
	    var uiName = channel.display_name;
	    var creatorName = '';
	
	    var uiType;
	    var memberMessage;
	    if (channel.type === 'P') {
	        uiType = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.group',
	            defaultMessage: 'private group'
	        });
	        memberMessage = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.onlyInvited',
	            defaultMessage: ' Only invited members can see this private group.'
	        });
	    } else {
	        uiType = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.channel',
	            defaultMessage: 'channel'
	        });
	        memberMessage = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.anyMember',
	            defaultMessage: ' Any member can join and read this channel.'
	        });
	    }
	
	    var date = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedDate"], {
	        value: channel.create_at,
	        month: 'long',
	        day: '2-digit',
	        year: 'numeric'
	    });
	
	    var createMessage;
	    if (creatorName === '') {
	        createMessage = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.noCreator',
	            defaultMessage: 'This is the start of the {name} {type}, created on {date}.',
	            values: {
	                name: uiName,
	                type: uiType,
	                date: date
	            }
	        });
	    } else {
	        createMessage = /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	            'span',
	            null,
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedHTMLMessage"], {
	                id: 'intro_messages.creator',
	                defaultMessage: 'This is the start of the <strong>{name}</strong> {type}, created by <strong>{creator}</strong> on <strong>{date}</strong>',
	                values: {
	                    name: uiName,
	                    type: uiType,
	                    date: date,
	                    creator: creatorName
	                }
	            })
	        );
	    }
	
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        'div',
	        { className: 'channel-intro' },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	            'h4',
	            { className: 'channel-intro__title' },
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	                id: 'intro_messages.beginning',
	                defaultMessage: 'Beginning of {name}',
	                values: {
	                    name: uiName
	                }
	            })
	        ),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	            'p',
	            { className: 'channel-intro__content' },
	            createMessage,
	            memberMessage,
	            /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br', null)
	        ),
	        createSetHeaderButton(channel),
	        createInviteChannelMemberButton(channel, uiType)
	    );
	}
	
	function createInviteChannelMemberButton(channel, uiType) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_components_toggle_modal_button_jsx__["a"],
	        {
	            className: 'intro-links',
	            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_1_components_channel_invite_modal_jsx__["a"],
	            dialogProps: { channel: channel }
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-user-plus' }),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.invite',
	            defaultMessage: 'Invite others to this {type}',
	            values: {
	                type: uiType
	            }
	        })
	    );
	}
	
	function createSetHeaderButton(channel) {
	    return /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_3_components_toggle_modal_button_jsx__["a"],
	        {
	            className: 'intro-links',
	            dialogType: /* harmony import */__WEBPACK_IMPORTED_MODULE_2_components_edit_channel_header_modal_jsx__["a"],
	            dialogProps: { channel: channel }
	        },
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('i', { className: 'fa fa-pencil' }),
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(/* harmony import */__WEBPACK_IMPORTED_MODULE_10_react_intl__["FormattedMessage"], {
	            id: 'intro_messages.setHeader',
	            defaultMessage: 'Set a Header'
	        })
	    );
	}

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default });
	"use strict";
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	var DelayedAction = function () {
	    function DelayedAction(action) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default.a.bind()(this, DelayedAction);
	
	        this.action = action;
	
	        this.timer = -1;
	
	        // bind fire since it doesn't get passed the correct this value with setTimeout
	        this.fire = this.fire.bind(this);
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default.a.bind()(DelayedAction, [{
	        key: "fire",
	        value: function fire() {
	            this.action();
	
	            this.timer = -1;
	        }
	    }, {
	        key: "fireAfter",
	        value: function fireAfter(timeout) {
	            if (this.timer >= 0) {
	                window.clearTimeout(this.timer);
	            }
	
	            this.timer = window.setTimeout(this.fire, timeout);
	        }
	    }, {
	        key: "cancel",
	        value: function cancel() {
	            window.clearTimeout(this.timer);
	        }
	    }]);
	
	    return DelayedAction;
	}();
	
	/* harmony default export */ exports["a"] = DelayedAction;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__ = __webpack_require__(1284);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__ && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__text_formatting_jsx__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__syntax_hightlighting_jsx__ = __webpack_require__(377);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_marked__ = __webpack_require__(1524);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_marked___default = __WEBPACK_IMPORTED_MODULE_9_marked__ && __WEBPACK_IMPORTED_MODULE_9_marked__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_9_marked__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_9_marked__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_9_marked___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_9_marked___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_katex__ = __webpack_require__(1739);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_katex___default = __WEBPACK_IMPORTED_MODULE_10_katex__ && __WEBPACK_IMPORTED_MODULE_10_katex__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_10_katex__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_10_katex__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_10_katex___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_10_katex___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css__ = __webpack_require__(1761);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css___default = __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css__ && __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_11_katex_dist_katex_min_css___default });
	/* harmony export */ exports["format"] = format;'use strict';
	
	
	
	
	
	
	
	
	// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
	// See License.txt for license information.
	
	
	
	
	
	
	
	
	function markdownImageLoaded(image) {
	    image.style.height = 'auto';
	}
	window.markdownImageLoaded = markdownImageLoaded;
	
	var MattermostInlineLexer = function (_marked$InlineLexer) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(MattermostInlineLexer, _marked$InlineLexer);
	
	    function MattermostInlineLexer(links, options) {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MattermostInlineLexer);
	
	        var _this = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostInlineLexer).call(this, links, options));
	
	        _this.rules = /* harmony import */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.bind()({}, _this.rules);
	
	        // modified version of the regex that allows for links starting with www and those surrounded by parentheses
	        // the original is /^[\s\S]+?(?=[\\<!\[_*`~]|https?:\/\/| {2,}\n|$)/
	        _this.rules.text = /^[\s\S]+?(?=[\\<!\[_*`~]|https?:\/\/|www\.|\(| {2,}\n|$)/;
	
	        // modified version of the regex that allows links starting with www and those surrounded by parentheses
	        // the original is /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/
	        _this.rules.url = /^(\(?(?:https?:\/\/|www\.)[^\s<.][^\s<]*[^<.,:;"'\]\s])/;
	
	        // modified version of the regex that allows <links> starting with www.
	        // the original is /^<([^ >]+(@|:\/)[^ >]+)>/
	        _this.rules.autolink = /^<((?:[^ >]+(@|:\/)|www\.)[^ >]+)>/;
	        return _this;
	    }
	
	    return MattermostInlineLexer;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_marked___default.a.InlineLexer);
	
	var MattermostParser = function (_marked$Parser) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(MattermostParser, _marked$Parser);
	
	    function MattermostParser() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MattermostParser);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostParser).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default.a.bind()(MattermostParser, [{
	        key: 'parse',
	        value: function parse(src) {
	            this.inline = new MattermostInlineLexer(src.links, this.options, this.renderer);
	            this.tokens = src.reverse();
	
	            var out = '';
	            while (this.next()) {
	                out += this.tok();
	            }
	
	            return out;
	        }
	    }]);
	
	    return MattermostParser;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_marked___default.a.Parser);
	
	var MattermostMarkdownRenderer = function (_marked$Renderer) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(MattermostMarkdownRenderer, _marked$Renderer);
	
	    function MattermostMarkdownRenderer(options) {
	        var formattingOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MattermostMarkdownRenderer);
	
	        var _this3 = /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostMarkdownRenderer).call(this, options));
	
	        _this3.heading = _this3.heading.bind(_this3);
	        _this3.paragraph = _this3.paragraph.bind(_this3);
	        _this3.text = _this3.text.bind(_this3);
	
	        _this3.formattingOptions = formattingOptions;
	        return _this3;
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default.a.bind()(MattermostMarkdownRenderer, [{
	        key: 'code',
	        value: function code(_code, language) {
	            var usedLanguage = language || '';
	            usedLanguage = usedLanguage.toLowerCase();
	
	            if (usedLanguage === 'tex' || usedLanguage === 'latex') {
	                try {
	                    var html = /* harmony import */__WEBPACK_IMPORTED_MODULE_10_katex___default.a.renderToString(_code, { throwOnError: false, displayMode: true });
	
	                    return '<div class="post-body--code tex">' + html + '</div>';
	                } catch (e) {
	                    // fall through if latex parsing fails and handle below
	                }
	            }
	
	            // treat html as xml to prevent injection attacks
	            if (usedLanguage === 'html') {
	                usedLanguage = 'xml';
	            }
	
	            return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_8__syntax_hightlighting_jsx__.formatCode(usedLanguage, _code);
	        }
	    }, {
	        key: 'codespan',
	        value: function codespan(text) {
	            return '<span class="codespan__pre-wrap">' + /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostMarkdownRenderer.prototype), 'codespan', this).call(this, text) + '</span>';
	        }
	    }, {
	        key: 'br',
	        value: function br() {
	            if (this.formattingOptions.singleline) {
	                return ' ';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostMarkdownRenderer.prototype), 'br', this).call(this);
	        }
	    }, {
	        key: 'image',
	        value: function image(href, title, text) {
	            var out = '<img src="' + href + '" alt="' + text + '"';
	            if (title) {
	                out += ' title="' + title + '"';
	            }
	            out += ' onload="window.markdownImageLoaded(this)" onerror="window.markdownImageLoaded(this)" class="markdown-inline-img"';
	            out += this.options.xhtml ? '/>' : '>';
	            return out;
	        }
	    }, {
	        key: 'heading',
	        value: function heading(text, level, raw) {
	            var id = '' + this.options.headerPrefix + raw.toLowerCase().replace(/[^\w]+/g, '-');
	            return '<h' + level + ' id="' + id + '" class="markdown__heading">' + text + '</h' + level + '>';
	        }
	    }, {
	        key: 'link',
	        value: function link(href, title, text) {
	            var outHref = href;
	            var outText = text;
	            var prefix = '';
	            var suffix = '';
	
	            // some links like https://en.wikipedia.org/wiki/Rendering_(computer_graphics) contain brackets
	            // and we try our best to differentiate those from ones just wrapped in brackets when autolinking
	            if (outHref.startsWith('(') && outHref.endsWith(')') && text === outHref) {
	                prefix = '(';
	                suffix = ')';
	                outText = text.substring(1, text.length - 1);
	                outHref = outHref.substring(1, outHref.length - 1);
	            }
	
	            try {
	                var unescaped = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
	
	                if (unescaped.indexOf('javascript:') === 0 || unescaped.indexOf('vbscript:') === 0 || unescaped.indexOf('data:') === 0) {
	                    // eslint-disable-line no-script-url
	                    return '';
	                }
	            } catch (e) {
	                return '';
	            }
	
	            if (!/[a-z+.-]+:/i.test(outHref)) {
	                outHref = 'http://' + outHref;
	            }
	
	            var output = '<a class="theme markdown__link" ';
	
	            // special case for links that are inside the app
	            if (outHref.startsWith(global.location.origin)) {
	                output += 'data-link="' + outHref.substring(global.location.origin.length) + '"';
	            } else {
	                output += 'href="' + outHref + '" target="_blank" rel="noreferrer"';
	            }
	
	            if (title) {
	                output += ' title="' + title + '"';
	            }
	
	            output += '>' + outText + '</a>';
	
	            return prefix + output + suffix;
	        }
	    }, {
	        key: 'paragraph',
	        value: function paragraph(text) {
	            if (this.formattingOptions.singleline) {
	                return '<p class="markdown__paragraph-inline">' + text + '</p>';
	            }
	
	            return /* harmony import */__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_get___default.a.bind()(/* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostMarkdownRenderer.prototype), 'paragraph', this).call(this, text);
	        }
	    }, {
	        key: 'table',
	        value: function table(header, body) {
	            return '<div class="table-responsive"><table class="markdown__table"><thead>' + header + '</thead><tbody>' + body + '</tbody></table></div>';
	        }
	    }, {
	        key: 'listitem',
	        value: function listitem(text) {
	            var taskListReg = /^\[([ |xX])\] /;
	            var isTaskList = taskListReg.exec(text);
	
	            if (isTaskList) {
	                return '<li class="list-item--task-list">' + ('<input type="checkbox" disabled="disabled" ' + (isTaskList[1] === ' ' ? '' : 'checked="checked" ') + '/> ') + text.replace(taskListReg, '') + '</li>';
	            }
	            return '<li>' + text + '</li>';
	        }
	    }, {
	        key: 'text',
	        value: function text(txt) {
	            return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_7__text_formatting_jsx__.doFormatText(txt, this.formattingOptions);
	        }
	    }]);
	
	    return MattermostMarkdownRenderer;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_marked___default.a.Renderer);
	
	var MattermostLexer = function (_marked$Lexer) {
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default.a.bind()(MattermostLexer, _marked$Lexer);
	
	    function MattermostLexer() {
	        /* harmony import */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default.a.bind()(this, MattermostLexer);
	
	        return /* harmony import */__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default.a.bind()(this, /* harmony import */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a.bind()(MattermostLexer).apply(this, arguments));
	    }
	
	    /* harmony import */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default.a.bind()(MattermostLexer, [{
	        key: 'token',
	        value: function token(originalSrc, top, bq) {
	            var src = originalSrc.replace(/^ +$/gm, '');
	
	            while (src) {
	                // newline
	                var cap = this.rules.newline.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    if (cap[0].length > 1) {
	                        this.tokens.push({
	                            type: 'space'
	                        });
	                    }
	                }
	
	                // code
	                cap = this.rules.code.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    cap = cap[0].replace(/^ {4}/gm, '');
	                    this.tokens.push({
	                        type: 'code',
	                        text: this.options.pedantic ? cap : cap.replace(/\n+$/, '')
	                    });
	                    continue;
	                }
	
	                // fences (gfm)
	                cap = this.rules.fences.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: 'code',
	                        lang: cap[2],
	                        text: cap[3] || ''
	                    });
	                    continue;
	                }
	
	                // heading
	                cap = this.rules.heading.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: 'heading',
	                        depth: cap[1].length,
	                        text: cap[2]
	                    });
	                    continue;
	                }
	
	                // table no leading pipe (gfm)
	                cap = this.rules.nptable.exec(src);
	                if (top && cap) {
	                    src = src.substring(cap[0].length);
	
	                    var item = {
	                        type: 'table',
	                        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	                        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	                        cells: cap[3].replace(/\n$/, '').split('\n')
	                    };
	
	                    for (var i = 0; i < item.align.length; i++) {
	                        if (/^ *-+: *$/.test(item.align[i])) {
	                            item.align[i] = 'right';
	                        } else if (/^ *:-+: *$/.test(item.align[i])) {
	                            item.align[i] = 'center';
	                        } else if (/^ *:-+ *$/.test(item.align[i])) {
	                            item.align[i] = 'left';
	                        } else {
	                            item.align[i] = null;
	                        }
	                    }
	
	                    for (var _i = 0; _i < item.cells.length; _i++) {
	                        item.cells[_i] = item.cells[_i].split(/ *\| */);
	                    }
	
	                    this.tokens.push(item);
	
	                    continue;
	                }
	
	                // lheading
	                cap = this.rules.lheading.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: 'heading',
	                        depth: cap[2] === '=' ? 1 : 2,
	                        text: cap[1]
	                    });
	                    continue;
	                }
	
	                // hr
	                cap = this.rules.hr.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: 'hr'
	                    });
	                    continue;
	                }
	
	                // blockquote
	                cap = this.rules.blockquote.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	
	                    this.tokens.push({
	                        type: 'blockquote_start'
	                    });
	
	                    cap = cap[0].replace(/^ *> ?/gm, '');
	
	                    // Pass `top` to keep the current
	                    // "toplevel" state. This is exactly
	                    // how markdown.pl works.
	                    this.token(cap, top, true);
	
	                    this.tokens.push({
	                        type: 'blockquote_end'
	                    });
	
	                    continue;
	                }
	
	                // list
	                cap = this.rules.list.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    var bull = cap[2];
	
	                    this.tokens.push({
	                        type: 'list_start',
	                        ordered: bull.length > 1
	                    });
	
	                    // Get each top-level item.
	                    cap = cap[0].match(this.rules.item);
	
	                    var next = false;
	                    var l = cap.length;
	                    var _i2 = 0;
	
	                    for (; _i2 < l; _i2++) {
	                        var _item = cap[_i2];
	
	                        // Remove the list item's bullet
	                        // so it is seen as the next token.
	                        var space = _item.length;
	                        _item = _item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	                        // Outdent whatever the
	                        // list item contains. Hacky.
	                        if (~_item.indexOf('\n ')) {
	                            space -= _item.length;
	                            _item = this.options.pedantic ? _item.replace(/^ {1,4}/gm, '') : _item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '');
	                        }
	
	                        // Determine whether the next list item belongs here.
	                        // Backpedal if it does not belong in this list.
	                        if (this.options.smartLists && _i2 !== l - 1) {
	                            var b = this.rules.bullet.exec(cap[_i2 + 1])[0];
	                            if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	                                src = cap.slice(_i2 + 1).join('\n') + src;
	                                _i2 = l - 1;
	                            }
	                        }
	
	                        // Determine whether item is loose or not.
	                        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	                        // for discount behavior.
	                        var loose = next || /\n\n(?!\s*$)/.test(_item);
	                        if (_i2 !== l - 1) {
	                            next = _item.charAt(_item.length - 1) === '\n';
	                            if (!loose) {
	                                loose = next;
	                            }
	                        }
	
	                        this.tokens.push({
	                            type: loose ? 'loose_item_start' : 'list_item_start'
	                        });
	
	                        // Recurse.
	                        this.token(_item, false, bq);
	
	                        this.tokens.push({
	                            type: 'list_item_end'
	                        });
	                    }
	
	                    this.tokens.push({
	                        type: 'list_end'
	                    });
	
	                    continue;
	                }
	
	                // html
	                cap = this.rules.html.exec(src);
	                if (cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: this.options.sanitize ? 'paragraph' : 'html',
	                        pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	                        text: cap[0]
	                    });
	                    continue;
	                }
	
	                // def
	                cap = this.rules.def.exec(src);
	                if (!bq && top && cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.links[cap[1].toLowerCase()] = {
	                        href: cap[2],
	                        title: cap[3]
	                    };
	                    continue;
	                }
	
	                // table (gfm)
	                cap = this.rules.table.exec(src);
	                if (top && cap) {
	                    src = src.substring(cap[0].length);
	
	                    var _item2 = {
	                        type: 'table',
	                        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	                        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	                        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	                    };
	
	                    for (var _i3 = 0; _i3 < _item2.align.length; _i3++) {
	                        if (/^ *-+: *$/.test(_item2.align[_i3])) {
	                            _item2.align[_i3] = 'right';
	                        } else if (/^ *:-+: *$/.test(_item2.align[_i3])) {
	                            _item2.align[_i3] = 'center';
	                        } else if (/^ *:-+ *$/.test(_item2.align[_i3])) {
	                            _item2.align[_i3] = 'left';
	                        } else {
	                            _item2.align[_i3] = null;
	                        }
	                    }
	
	                    for (var _i4 = 0; _i4 < _item2.cells.length; _i4++) {
	                        _item2.cells[_i4] = _item2.cells[_i4].replace(/^ *\| *| *\| *$/g, '').split(/ *\| */);
	                    }
	
	                    this.tokens.push(_item2);
	
	                    continue;
	                }
	
	                // top-level paragraph
	                cap = this.rules.paragraph.exec(src);
	                if (top && cap) {
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: 'paragraph',
	                        text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
	                    });
	                    continue;
	                }
	
	                // text
	                cap = this.rules.text.exec(src);
	                if (cap) {
	                    // Top-level should never reach here.
	                    src = src.substring(cap[0].length);
	                    this.tokens.push({
	                        type: 'text',
	                        text: cap[0]
	                    });
	                    continue;
	                }
	
	                if (src) {
	                    throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	                }
	            }
	
	            return this.tokens;
	        }
	    }]);
	
	    return MattermostLexer;
	}(/* harmony import */__WEBPACK_IMPORTED_MODULE_9_marked___default.a.Lexer);
	
	function format(text, options) {
	    var markdownOptions = {
	        renderer: new MattermostMarkdownRenderer(null, options),
	        sanitize: true,
	        gfm: true,
	        tables: true
	    };
	
	    var tokens = new MattermostLexer(markdownOptions).lex(text);
	
	    return new MattermostParser(markdownOptions).parse(tokens);
	}
	
	// Marked helper functions that should probably just be exported
	
	function unescape(html) {
	    return html.replace(/&([#\w]+);/g, function (_, m) {
	        var n = m.toLowerCase();
	        if (n === 'colon') {
	            return ':';
	        } else if (n.charAt(0) === '#') {
	            return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
	        }
	        return '';
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, "/*!\n * Bootstrap v3.3.6 (http://getbootstrap.com)\n * Copyright 2011-2015 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}legend{padding:0;border:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:transparent!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(390) + ");src:url(" + __webpack_require__(390) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(837) + ") format('woff2'),url(" + __webpack_require__(836) + ") format('woff'),url(" + __webpack_require__(835) + ") format('truetype'),url(" + __webpack_require__(834) + "#glyphicons_halflingsregular) format('svg')}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:'\\2014   \\A0'}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:''}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:'\\A0   \\2014'}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:transparent;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:.6s ease-in-out left;transition:.6s ease-in-out left}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),all and (transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000',endColorstr='#00000000',GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000',endColorstr='#80000000',GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:'\\2039'}.carousel-control .icon-next:before{content:'\\203A'}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, "/*!\n *  Font Awesome 4.5.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(839) + ");src:url(" + __webpack_require__(838) + "?#iefix&v=4.5.0) format('embedded-opentype'),url(" + __webpack_require__(842) + ") format('woff2'),url(" + __webpack_require__(843) + ") format('woff'),url(" + __webpack_require__(841) + ") format('truetype'),url(" + __webpack_require__(840) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);-webkit-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}", ""]);
	
	// exports


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, "/*!\n * Jasny Bootstrap v3.1.3 (http://jasny.github.io/bootstrap)\n * Copyright 2012-2014 Arnold Daniels\n * Licensed under Apache-2.0 (https://github.com/jasny/bootstrap/blob/master/LICENSE)\n */.container-smooth{max-width:1170px}@media (min-width:1px){.container-smooth{width:auto}}.btn-labeled{padding-top:0;padding-bottom:0}.btn-label{position:relative;left:-12px;display:inline-block;padding:6px 12px;background:transparent;background:rgba(0,0,0,.15);border-radius:3px 0 0 3px}.btn-label.btn-label-right{right:-12px;left:auto;border-radius:0 3px 3px 0}.btn-lg .btn-label{left:-16px;padding:10px 16px;border-radius:5px 0 0 5px}.btn-lg .btn-label.btn-label-right{right:-16px;left:auto;border-radius:0 5px 5px 0}.btn-sm .btn-label{left:-10px;padding:5px 10px;border-radius:2px 0 0 2px}.btn-sm .btn-label.btn-label-right{right:-10px;left:auto;border-radius:0 2px 2px 0}.btn-xs .btn-label{left:-5px;padding:1px 5px;border-radius:2px 0 0 2px}.btn-xs .btn-label.btn-label-right{right:-5px;left:auto;border-radius:0 2px 2px 0}.nav-tabs-bottom{border-top:1px solid #ddd;border-bottom:0}.nav-tabs-bottom>li{margin-top:-1px;margin-bottom:0}.nav-tabs-bottom>li>a{border-radius:0 0 4px 4px}.nav-tabs-bottom>li.active>a,.nav-tabs-bottom>li.active>a:focus,.nav-tabs-bottom>li.active>a:hover,.nav-tabs-bottom>li>a:focus,.nav-tabs-bottom>li>a:hover{border:1px solid #ddd;border-top-color:transparent}.nav-tabs-left{border-right:1px solid #ddd;border-bottom:0}.nav-tabs-left>li{float:none;margin-right:-1px;margin-bottom:0}.nav-tabs-left>li>a{margin-right:0;margin-bottom:2px;border-radius:4px 0 0 4px}.nav-tabs-left>li.active>a,.nav-tabs-left>li.active>a:focus,.nav-tabs-left>li.active>a:hover,.nav-tabs-left>li>a:focus,.nav-tabs-left>li>a:hover{border:1px solid #ddd;border-right-color:transparent}.row>.nav-tabs-left{position:relative;z-index:1;padding-right:0;padding-left:15px;margin-right:-1px}.nav-tabs-right,.row>.nav-tabs-left+.tab-content{border-left:1px solid #ddd}.nav-tabs-right{border-bottom:0}.nav-tabs-right>li{float:none;margin-bottom:0;margin-left:-1px}.nav-tabs-right>li>a{margin-bottom:2px;margin-left:0;border-radius:0 4px 4px 0}.nav-tabs-right>li.active>a,.nav-tabs-right>li.active>a:focus,.nav-tabs-right>li.active>a:hover,.nav-tabs-right>li>a:focus,.nav-tabs-right>li>a:hover{border:1px solid #ddd;border-left-color:transparent}.row>.nav-tabs-right{padding-right:15px;padding-left:0}.navbar-offcanvas,.navmenu{width:300px;height:auto;border-style:solid;border-width:1px;border-radius:4px}.navbar-offcanvas,.navmenu-fixed-left,.navmenu-fixed-right{position:fixed;top:0;bottom:0;z-index:1050;overflow-y:auto;border-radius:0}.navbar-offcanvas.navmenu-fixed-left,.navmenu-fixed-left{right:auto;left:0;border-width:0 1px 0 0}.navbar-offcanvas,.navmenu-fixed-right{right:0;left:auto;border-width:0 0 0 1px}.navmenu-nav{margin-bottom:10px}.navmenu-nav.dropdown-menu{position:static;float:none;padding-top:0;margin:0;border:none;border-radius:0;box-shadow:none}.navbar-offcanvas .navbar-nav{margin:0}@media (min-width:768px){.navbar-offcanvas{width:auto;border-top:0;box-shadow:none}.navbar-offcanvas.offcanvas{position:static;display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-offcanvas .navbar-nav.navbar-left:first-child{margin-left:-15px}.navbar-offcanvas .navbar-nav.navbar-right:last-child{margin-right:-15px}.navbar-offcanvas .navmenu-brand{display:none}}.navmenu-brand{display:block;padding:10px 15px;margin:10px 0;font-size:18px;line-height:20px}.navmenu-brand:focus,.navmenu-brand:hover{text-decoration:none}.navbar-default .navbar-offcanvas,.navmenu-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-brand,.navmenu-default .navmenu-brand{color:#777}.navbar-default .navbar-offcanvas .navmenu-brand:focus,.navbar-default .navbar-offcanvas .navmenu-brand:hover,.navmenu-default .navmenu-brand:focus,.navmenu-default .navmenu-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-offcanvas .navmenu-text,.navmenu-default .navmenu-text{color:#777}.navbar-default .navbar-offcanvas .navmenu-nav>.dropdown>a:focus .caret,.navbar-default .navbar-offcanvas .navmenu-nav>.dropdown>a:hover .caret,.navmenu-default .navmenu-nav>.dropdown>a:focus .caret,.navmenu-default .navmenu-nav>.dropdown>a:hover .caret{border-top-color:#333;border-bottom-color:#333}.navbar-default .navbar-offcanvas .navmenu-nav>.open>a,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:hover,.navmenu-default .navmenu-nav>.open>a,.navmenu-default .navmenu-nav>.open>a:focus,.navmenu-default .navmenu-nav>.open>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-nav>.open>a .caret,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:focus .caret,.navbar-default .navbar-offcanvas .navmenu-nav>.open>a:hover .caret,.navmenu-default .navmenu-nav>.open>a .caret,.navmenu-default .navmenu-nav>.open>a:focus .caret,.navmenu-default .navmenu-nav>.open>a:hover .caret{border-top-color:#555;border-bottom-color:#555}.navbar-default .navbar-offcanvas .navmenu-nav>.dropdown>a .caret,.navmenu-default .navmenu-nav>.dropdown>a .caret{border-top-color:#777;border-bottom-color:#777}.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu,.navmenu-default .navmenu-nav.dropdown-menu{background-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.divider,.navmenu-default .navmenu-nav.dropdown-menu>.divider{background-color:#f8f8f8}.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a,.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:hover,.navmenu-default .navmenu-nav.dropdown-menu>.active>a,.navmenu-default .navmenu-nav.dropdown-menu>.active>a:focus,.navmenu-default .navmenu-nav.dropdown-menu>.active>a:hover{background-color:#d7d7d7}.navbar-default .navbar-offcanvas .navmenu-nav>li>a,.navmenu-default .navmenu-nav>li>a{color:#777}.navbar-default .navbar-offcanvas .navmenu-nav>li>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>li>a:hover,.navmenu-default .navmenu-nav>li>a:focus,.navmenu-default .navmenu-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-offcanvas .navmenu-nav>.active>a,.navbar-default .navbar-offcanvas .navmenu-nav>.active>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>.active>a:hover,.navmenu-default .navmenu-nav>.active>a,.navmenu-default .navmenu-nav>.active>a:focus,.navmenu-default .navmenu-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-offcanvas .navmenu-nav>.disabled>a,.navbar-default .navbar-offcanvas .navmenu-nav>.disabled>a:focus,.navbar-default .navbar-offcanvas .navmenu-nav>.disabled>a:hover,.navmenu-default .navmenu-nav>.disabled>a,.navmenu-default .navmenu-nav>.disabled>a:focus,.navmenu-default .navmenu-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-inverse .navbar-offcanvas,.navmenu-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-brand,.navmenu-inverse .navmenu-brand{color:#999}.navbar-inverse .navbar-offcanvas .navmenu-brand:focus,.navbar-inverse .navbar-offcanvas .navmenu-brand:hover,.navmenu-inverse .navmenu-brand:focus,.navmenu-inverse .navmenu-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-offcanvas .navmenu-text,.navmenu-inverse .navmenu-text{color:#999}.navbar-inverse .navbar-offcanvas .navmenu-nav>.dropdown>a:focus .caret,.navbar-inverse .navbar-offcanvas .navmenu-nav>.dropdown>a:hover .caret,.navmenu-inverse .navmenu-nav>.dropdown>a:focus .caret,.navmenu-inverse .navmenu-nav>.dropdown>a:hover .caret{border-top-color:#fff;border-bottom-color:#fff}.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:hover,.navmenu-inverse .navmenu-nav>.open>a,.navmenu-inverse .navmenu-nav>.open>a:focus,.navmenu-inverse .navmenu-nav>.open>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a .caret,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:focus .caret,.navbar-inverse .navbar-offcanvas .navmenu-nav>.open>a:hover .caret,.navmenu-inverse .navmenu-nav>.open>a .caret,.navmenu-inverse .navmenu-nav>.open>a:focus .caret,.navmenu-inverse .navmenu-nav>.open>a:hover .caret{border-top-color:#fff;border-bottom-color:#fff}.navbar-inverse .navbar-offcanvas .navmenu-nav>.dropdown>a .caret,.navmenu-inverse .navmenu-nav>.dropdown>a .caret{border-top-color:#999;border-bottom-color:#999}.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu,.navmenu-inverse .navmenu-nav.dropdown-menu{background-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.divider,.navmenu-inverse .navmenu-nav.dropdown-menu>.divider{background-color:#222}.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a,.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav.dropdown-menu>.active>a:hover,.navmenu-inverse .navmenu-nav.dropdown-menu>.active>a,.navmenu-inverse .navmenu-nav.dropdown-menu>.active>a:focus,.navmenu-inverse .navmenu-nav.dropdown-menu>.active>a:hover{background-color:#000}.navbar-inverse .navbar-offcanvas .navmenu-nav>li>a,.navmenu-inverse .navmenu-nav>li>a{color:#999}.navbar-inverse .navbar-offcanvas .navmenu-nav>li>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>li>a:hover,.navmenu-inverse .navmenu-nav>li>a:focus,.navmenu-inverse .navmenu-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-offcanvas .navmenu-nav>.active>a,.navbar-inverse .navbar-offcanvas .navmenu-nav>.active>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>.active>a:hover,.navmenu-inverse .navmenu-nav>.active>a,.navmenu-inverse .navmenu-nav>.active>a:focus,.navmenu-inverse .navmenu-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-offcanvas .navmenu-nav>.disabled>a,.navbar-inverse .navbar-offcanvas .navmenu-nav>.disabled>a:focus,.navbar-inverse .navbar-offcanvas .navmenu-nav>.disabled>a:hover,.navmenu-inverse .navmenu-nav>.disabled>a,.navmenu-inverse .navmenu-nav>.disabled>a:focus,.navmenu-inverse .navmenu-nav>.disabled>a:hover{color:#444;background-color:transparent}.alert-fixed-bottom,.alert-fixed-top{position:fixed;left:0;z-index:1035;width:100%;margin:0;border-radius:0}@media (min-width:992px){.alert-fixed-bottom,.alert-fixed-top{left:50%;width:992px;margin-left:-496px}}.alert-fixed-top{top:0;border-width:0 0 1px}@media (min-width:992px){.alert-fixed-top{border-width:0 1px 1px;border-bottom-right-radius:4px;border-bottom-left-radius:4px}}.alert-fixed-bottom{bottom:0;border-width:1px 0 0}@media (min-width:992px){.alert-fixed-bottom{border-width:1px 1px 0;border-top-left-radius:4px;border-top-right-radius:4px}}.offcanvas{display:none}.offcanvas.in{display:block}@media (max-width:767px){.offcanvas-xs{display:none}.offcanvas-xs.in{display:block}}@media (max-width:991px){.offcanvas-sm{display:none}.offcanvas-sm.in{display:block}}@media (max-width:1199px){.offcanvas-md{display:none}.offcanvas-md.in{display:block}}.offcanvas-lg{display:none}.offcanvas-lg.in{display:block}.canvas-sliding{-webkit-transition:top .35s,left .35s,bottom .35s,right .35s;transition:top .35s,left .35s,bottom .35s,right .35s}.offcanvas-clone{position:absolute!important;top:auto!important;right:0!important;bottom:0!important;left:auto!important;width:0!important;height:0!important;padding:0!important;margin:0!important;overflow:hidden!important;border:none!important;opacity:0!important}.table.rowlink td:not(.rowlink-skip),.table .rowlink td:not(.rowlink-skip){cursor:pointer}.table.rowlink td:not(.rowlink-skip) a,.table .rowlink td:not(.rowlink-skip) a{font:inherit;color:inherit;text-decoration:inherit}.table-hover.rowlink tr:hover td,.table-hover .rowlink tr:hover td{background-color:#cfcfcf}.btn-file{position:relative;overflow:hidden;vertical-align:middle}.btn-file>input{position:absolute;top:0;right:0;width:100%;height:100%;margin:0;font-size:23px;cursor:pointer;filter:alpha(opacity=0);opacity:0;direction:ltr}.fileinput{display:inline-block;margin-bottom:9px}.fileinput .form-control{display:inline-block;padding-top:7px;padding-bottom:5px;margin-bottom:0;vertical-align:middle;cursor:text}.fileinput .thumbnail{display:inline-block;margin-bottom:5px;overflow:hidden;text-align:center;vertical-align:middle}.fileinput .thumbnail>img{max-height:100%}.fileinput .btn{vertical-align:middle}.fileinput-exists .fileinput-new,.fileinput-new .fileinput-exists{display:none}.fileinput-inline .fileinput-controls{display:inline}.fileinput-filename{display:inline-block;overflow:hidden;vertical-align:middle}.form-control .fileinput-filename{vertical-align:bottom}.fileinput.input-group{display:table}.fileinput.input-group>*{position:relative;z-index:2}.fileinput.input-group>.btn-file{z-index:1}.fileinput-new.input-group .btn-file,.fileinput-new .input-group .btn-file{border-radius:0 4px 4px 0}.fileinput-new.input-group .btn-file.btn-sm,.fileinput-new .input-group .btn-file.btn-sm,.fileinput-new.input-group .btn-file.btn-xs,.fileinput-new .input-group .btn-file.btn-xs{border-radius:0 3px 3px 0}.fileinput-new.input-group .btn-file.btn-lg,.fileinput-new .input-group .btn-file.btn-lg{border-radius:0 6px 6px 0}.form-group.has-warning .fileinput .fileinput-preview{color:#8a6d3b}.form-group.has-warning .fileinput .thumbnail{border-color:#faebcc}.form-group.has-error .fileinput .fileinput-preview{color:#a94442}.form-group.has-error .fileinput .thumbnail{border-color:#ebccd1}.form-group.has-success .fileinput .fileinput-preview{color:#3c763d}.form-group.has-success .fileinput .thumbnail{border-color:#d6e9c6}.input-group-addon:not(:first-child){border-left:0}", ""]);
	
	// exports


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, ".ps-container{-ms-touch-action:none;touch-action:none;overflow:hidden!important;-ms-overflow-style:none}@supports (-ms-overflow-style:none){.ps-container{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps-container{overflow:auto!important}}.ps-container.ps-active-x>.ps-scrollbar-x-rail,.ps-container.ps-active-y>.ps-scrollbar-y-rail{display:block;background-color:transparent}.ps-container.ps-in-scrolling{pointer-events:none}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999}.ps-container>.ps-scrollbar-x-rail{display:none;position:absolute;border-radius:4px;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;bottom:3px;height:8px}.ps-container>.ps-scrollbar-x-rail>.ps-scrollbar-x{position:absolute;background-color:#aaa;border-radius:4px;-webkit-transition:background-color .2s linear;transition:background-color .2s linear;bottom:0;height:8px}.ps-container>.ps-scrollbar-y-rail{display:none;position:absolute;border-radius:4px;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;right:3px;width:8px}.ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{position:absolute;background-color:#aaa;border-radius:4px;-webkit-transition:background-color .2s linear;transition:background-color .2s linear;right:0;width:8px}.ps-container:hover.ps-in-scrolling{pointer-events:none}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999}.ps-container:hover>.ps-scrollbar-x-rail,.ps-container:hover>.ps-scrollbar-y-rail{opacity:.6}.ps-container:hover>.ps-scrollbar-x-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{background-color:#999}.ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{background-color:#999}", ""]);
	
	// exports


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	exports.i(__webpack_require__(791), "");
	exports.i(__webpack_require__(793), "");
	exports.i(__webpack_require__(794), "");
	exports.i(__webpack_require__(792), "");
	exports.i(__webpack_require__(378), "");
	
	// module
	exports.push([module.i, ".suggestion-list{box-shadow:1px -3px 12px rgba(0,0,0,.175)}.signup-team__container .has-error .control-label:before{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0)}@keyframes spin{0%{transform:scale(1) rotate(0deg)}to{transform:scale(1) rotate(1turn)}}@keyframes highlight{0%{background:rgba(255,255,0,.5)}to{background:none}}b,strong{font-weight:600}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Open Sans,sans-serif}.word-break--all{word-break:break-all}body,html{height:100%}body{background:#f5f5f5;position:relative;width:100%}.sticky{background:#fff}.sticky>.container-fluid{overflow:auto}.sticky .inner-wrap>.row.content{margin-bottom:-89px;min-height:100%}.inner-wrap{height:100%}.container-fluid,.inner-wrap>.row.main{height:100%;position:relative}.container-fluid{*zoom:1}.container-fluid:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.channel-view{overflow:hidden;*zoom:1;height:100%;position:relative}img{max-width:100%}img.rounded{border-radius:100%}.app__body .modal .about-modal .modal-header{background:transparent;border:none;color:inherit;padding:20px 25px 0}.app__body .modal .about-modal .modal-header .close{color:inherit;font-weight:400;right:15px}.app__body .modal .about-modal .modal-header .modal-title{color:inherit;font-size:16px}.app__body .modal .about-modal .modal-body{padding:20px 25px 5px}.app__body .modal .about-modal .about-modal__content{overflow:hidden;*zoom:1;display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;padding:1em 0 3em}.app__body .modal .about-modal .about-modal__copyright{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;margin-top:.5em}.app__body .modal .about-modal .about-modal__footer{font-size:13.5px}.app__body .modal .about-modal .about-modal__title{line-height:1.5;margin:0 0 10px}.app__body .modal .about-modal .about-modal__subtitle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.app__body .modal .about-modal .about-modal__hash{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);opacity:.4;font-size:.75em;text-align:right}.app__body .modal .about-modal .about-modal__hash p:first-child{float:left}.app__body .modal .about-modal .about-modal__logo{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9;padding:0 40px 0 20px}.app__body .modal .about-modal .about-modal__logo svg{height:125px;width:125px}.app__body .modal .about-modal .about-modal__logo path{fill:inherit}.access-history__table{display:table;line-height:1.6;padding-top:15px;width:100%}.access-history__table:first-child{padding:0}.access-history__table>div{display:table-cell;vertical-align:top}.access-history__table .access__date{font-size:15px;font-weight:600;width:190px}.access-history__table .access__report{border-bottom:1px solid #ddd;padding-bottom:15px}.access-history__table .report__info{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.animation--highlight:before{animation:highlight 1.5s ease;content:'';height:100%;left:0;position:absolute;top:0;width:100%}.activity-log__table{border-top:1px solid rgba(0,0,0,.15);display:table;line-height:1.8;padding:15px 0;width:100%}.activity-log__table:first-child{border:none;padding-top:0}.activity-log__table>div{display:table-cell;vertical-align:top}.activity-log__table .activity-log__report{width:80%}.activity-log__table .activity-log__action{text-align:right}.activity-log__table .report__platform{font-size:15px;font-weight:600}.activity-log__table .report__platform .fa{margin-right:6px}.activity-log__table .report__info{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.session-help-text{padding:0 0 20px}.admin-controller>div{height:100%}.admin-controller .inner-wrap{position:absolute;width:100%}.admin-controller h3{border-bottom:1px solid rgba(0,0,0,.1);font-weight:600;margin:1em 0;padding-bottom:.5em}.admin-controller .form-control{background-color:#fff;border:1px solid rgba(0,0,0,.15)}.admin-controller .form-control:focus{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);border-color:#66afe9;outline:0}.admin-controller .table.table-margin--none{margin-bottom:0}.admin-controller .sidebar--left.sidebar--collapsable{background:#333}.admin-controller .sidebar--left.sidebar--collapsable .team__header{background:transparent;margin-bottom:5px}.admin-controller .sidebar--left.sidebar--collapsable .nav li{padding:0;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.admin-controller .sidebar--left.sidebar--collapsable .nav li .icon{width:17px}.admin-controller .sidebar--left.sidebar--collapsable .nav li.divider,.admin-controller .sidebar--left.sidebar--collapsable .nav li>a:focus,.admin-controller .sidebar--left.sidebar--collapsable .nav li>a:hover{background:rgba(0,0,0,.1)}.admin-controller .sidebar--left.sidebar--collapsable .nav li>a.active{background-color:transparent}.admin-controller .sidebar--left.sidebar--collapsable .nav li>h4{background:hsla(0,0%,100%,.15);color:#fff;margin:1px 0 0;padding:10px}.admin-controller .sidebar--left.sidebar--collapsable .nav li>h4 .menu-icon--right{right:12px;top:6px}.admin-controller .sidebar--left.sidebar--collapsable .nav .menu-icon--right{font-size:18px;font-weight:600;height:20px;line-height:20px;position:absolute;right:10px;text-align:center;top:3px;width:20px}.admin-controller .sidebar--left.sidebar--collapsable .nav .menu-icon--right .fa{color:#fff;font-size:13px;position:relative;right:-2px}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu{-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:auto;background:#111}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu.padded{padding:5px 0}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu li>a{background:transparent;color:#bbb;font-size:13px;padding:5px 35px 5px 15px}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu li>a:hover{color:#4ba1e2}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu li>a.active{color:#fff;font-weight:600}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu li .nav-more{background:transparent;color:#bbb;cursor:pointer;display:block;font-size:13px;padding:5px 15px}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__sub-menu li .nav-more:hover{color:#4ba1e2}.admin-controller .sidebar--left.sidebar--collapsable .nav.nav__inner-menu li>a{padding-left:20px}.admin-controller .log__panel{background-color:#fff;border:1px solid #ddd;height:800px;margin-top:10px;overflow:scroll;padding:5px;width:100%}.admin-controller .app__content{color:#333}.admin-controller .app__content.admin{background-color:#f1f1f1;min-height:600px;overflow:auto;padding:0 40px 20px}.admin-controller .app__content .wrapper--fixed{max-width:800px}.admin-controller .app__content .form-horizontal{margin-top:40px}.admin-controller .app__content .form-horizontal .control-label{font-weight:600;padding-right:0;text-align:left}.admin-controller .app__content .form-horizontal .form-group{margin-bottom:25px}.admin-controller .app__content .form-horizontal .form-group.form-group--small{margin-bottom:10px}.admin-controller .app__content .form-horizontal .file__upload{display:inline-block;margin:0 10px 10px 0;position:relative}.admin-controller .app__content .form-horizontal .file__upload input{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;height:100%;left:0;position:absolute;top:0;width:100%;z-index:5}.admin-controller .app__content .form-horizontal .help-text{color:#777;margin:10px 0 0 15px}.admin-controller .app__content .form-horizontal .help-text.no-margin{margin:0}.admin-controller .app__content .form-horizontal .help-text.no-margin--top{margin-top:0}.admin-controller .app__content .form-horizontal .help-text ol,.admin-controller .app__content .form-horizontal .help-text ul{padding-left:23px}.admin-controller .app__content .form-horizontal .help-text .help-link{margin-right:5px}.admin-controller .app__content .form-horizontal .help-text .btn{font-size:13px}.admin-controller .app__content .form-horizontal .alert{display:inline-block;margin:1em 0 0;padding:5px 7px;position:relative;top:1px}.admin-controller .app__content .form-horizontal .alert .fa{margin-right:5px}.admin-controller .app__content .banner{background:#fff;border:1px solid #ddd;font-size:.95em;margin:2em 0;padding:.7em 1.5em}.admin-controller .app__content .banner .banner__heading{font-size:1.5em}.admin-controller .app__content .banner .banner__content{width:80%}.admin-controller .app__content .banner.warning{background:#e60000}.admin-controller .app__content .popover{border-radius:3px;font-size:.95em;width:100%}.admin-controller .app__content .panel{background-color:transparent;border:none}.admin-controller .app__content .panel-default>.panel-heading{background-color:transparent;padding:10px 0}.admin-controller .app__content .panel-default .panel-body{padding:30px 0 10px}.admin-controller .app__content .panel-group{margin-bottom:50px}.admin-controller .app__content .panel-title{font-size:24px;line-height:1.5}.admin-controller .app__content .panel-title a{overflow:hidden;*zoom:1;display:block;text-decoration:none}.admin-controller .app__content .panel-title a.collapsed .fa-minus{display:none}.admin-controller .app__content .panel-title a.collapsed .fa-plus{display:inline-block}.admin-controller .app__content .panel-title a .fa{color:#aaa;float:right;font-size:18px;margin-top:8px}.admin-controller .app__content .panel-title a .fa-plus{display:none}.admin-controller .member-list-holder{background:#fff;margin-bottom:4em;overflow:visible;padding:5px 0}.admin-controller .member-list-holder .more-modal__row:last-child{border:none}.brand-img{margin-bottom:1.5em;max-width:150px}body.backstage{height:auto;overflow:auto}body.backstage .inner-wrap{-webkit-transform:translateX(0);transform:translateX(0);margin-right:0!important}body.backstage .inner-wrap:before,body.backstage .navbar,body.backstage .sidebar--menu,body.backstage .sidebar--right{display:none}.backstage-content{background-color:#f5f5f5;height:100%;margin:46px auto;max-width:960px;padding-left:135px}.backstage-navbar{background:#fff;border-bottom:1px solid rgba(0,0,0,.15);padding:10px 20px;z-index:10}.backstage-navbar__back{color:inherit;text-decoration:none}.backstage-navbar__back .fa{font-size:1.1em;font-weight:700;margin-right:7px}.backstage-navbar__back:active,.backstage-navbar__back:hover{color:inherit}.backstage-sidebar{height:100%;left:0;padding:50px 20px;position:absolute;width:260px;z-index:5}.backstage-sidebar ul{list-style:none;padding:0}.backstage-sidebar__category{border:1px solid rgba(0,0,0,.15)}.backstage-sidebar__category .category-title{display:block;line-height:36px;padding:0 10px;position:relative}.backstage-sidebar__category .category-title--active{color:#000}.backstage-sidebar__category .category-title__text{left:2em;position:absolute}.backstage-sidebar__category .sections{background:#fff;border-top:1px solid rgba(0,0,0,.15)}.backstage-sidebar__category .section-title,.backstage-sidebar__category .subsection-title{display:block;font-size:.95em;line-height:29px;padding-left:2em;text-decoration:none}.backstage-sidebar__category .subsection-title{padding-left:3em}.backstage-sidebar__category .section-title--active,.backstage-sidebar__category .subsection-title--active{background-color:#2389d7;color:#fff;font-weight:600}.backstage__sidebar__category+.backstage__sidebar__category{border-top-width:0}.backstage-header__divider{margin:0 10px;color:rgba(0,0,0,.3)}.backstage-header{overflow:hidden;*zoom:1;margin-bottom:20px;width:100%}.backstage-header h1{float:left;font-size:20px;margin:5px 0}.backstage-header .add-integrations-link{float:right}.backstage-filters{display:flex;flex-direction:row;width:100%}.backstage-filters .backstage-filters__sort{flex-grow:1;flex-shrink:0;line-height:30px}.backstage-filters .backstage-filters__sort .filter-sort{text-decoration:none}.backstage-filters .backstage-filters__sort .filter-sort.filter-sort--active{color:inherit;cursor:default}.backstage-filters .backstage-filters__sort .divider{margin-left:8px;margin-right:8px}.backstage-filters .backstage-filter__search{flex-grow:0;flex-shrink:0;position:relative;width:270px}.backstage-filters .backstage-filter__search .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);opacity:.4;left:11px;position:absolute;top:11px}.backstage-filters .backstage-filter__search input{background:#fff;border-bottom:none;padding-left:30px}.backstage-list{background-color:#fff;border:1px solid rgba(0,0,0,.15);padding:5px 15px;min-height:50px}.backstage-list__item{border-bottom:1px solid rgba(0,0,0,.15);display:flex;padding:20px 15px}.backstage-list__item:last-child{border:none}.backstage-list__item .item-details{color:rgba(0,0,0,.5);flex-grow:1;flex-shrink:1;overflow:hidden;text-overflow:ellipsis}.backstage-list__item .item-details__row+.item-details__row{overflow:hidden;*zoom:1;text-overflow:ellipsis}.backstage-list__item .item-details__name{color:#000;font-weight:600}.backstage-list__item .item-details__trigger{margin-left:6px}.backstage-list__item .item-details__creation,.backstage-list__item .item-details__description,.backstage-list__item .item-details__token,.backstage-list__item .item-details__trigger-words,.backstage-list__item .item-details__url{display:inline-block;margin-top:10px;vertical-align:top}.backstage-list__item .item-details__creation:empty,.backstage-list__item .item-details__description:empty,.backstage-list__item .item-details__token:empty,.backstage-list__item .item-details__trigger-words:empty,.backstage-list__item .item-details__url:empty{display:none}.backstage-list__item .item-details__trigger-words{white-space:nowrap}.backstage-list__item .item-actions{flex-grow:0;flex-shrink:0;padding-left:20px}.backstage-form{background-color:#fff;border:1px solid rgba(0,0,0,.15);padding:40px 30px 30px}.backstage-form label{font-weight:400}.backstage-form .checkbox input,.backstage-form .radio input{height:16px;margin:0 5px 0 0;position:relative;top:2px;width:16px}.backstage-form .form-control{background:#fff}.backstage-form .form-control:focus{border-color:#2389d7}.backstage-form .form__help{color:rgba(0,0,0,.5);font-size:.95em;margin-top:1em}.backstage-form .form__help+.form__help{margin-top:.4em}.backstage-form__footer{border-top:1px solid rgba(0,0,0,.15);margin-top:2.5em;padding-top:1.8em;text-align:right}.backstage-form__footer .has-error{float:left;margin:0}.integration-option{background-color:#fff;border:1px solid rgba(0,0,0,.15);display:inline-block;height:210px;margin:0 0 20px 30px;padding:20px;text-align:center;vertical-align:top;width:250px}.integration-option:first-child{margin-left:0}.integration-option:hover{color:default;text-decoration:none}.integration-option__image{height:80px;width:80px}.integration-option__title{color:#000;margin-bottom:10px}.integration-option__description{color:rgba(0,0,0,.5)}.audit-panel__table,.compliance-panel__table{background-color:#fff;border:1px solid #ddd;margin-top:10px;max-height:70vh;min-height:100px;overflow:auto;padding:5px;width:100%}.audit-panel .row>.form-group,.compliance-panel .row>.form-group{padding-left:0}.audit-panel .row>.form-group:first-child,.compliance-panel .row>.form-group:first-child{padding-left:15px}.audit-panel .row label,.compliance-panel .row label{font-weight:600}.audit-panel .fa-refresh,.compliance-panel .fa-refresh{margin-right:5px}.compliance-panel{margin-bottom:3em}.docs__page{line-height:1.7;padding-bottom:20px}.docs__page>div{margin:0 auto;max-width:100%;padding:0 15px;width:1170px}.docs__page h1.markdown__heading{border-bottom:1px solid #ddd;margin:1em 0;padding-bottom:1rem}body.error .container-fluid{display:table;height:90%}body.error .error__container{color:#555;display:table-cell;margin:0 auto;max-width:800px;padding:5em 0;text-align:left;vertical-align:top}body.error .error__icon{color:#ccc;font-size:4em}body.error h2{font-size:1.5em;font-weight:600;margin:.8em 0 .5em}body.error p{font-size:1.2em}.loading-screen{display:table;height:100%;padding:60px;text-align:center;width:100%}.loading-screen .loading__content{display:table-cell;font-size:0;vertical-align:middle}.loading-screen .loading__content h3{display:inline-block;font-size:16px;font-weight:400;margin:0 .2em}.loading-screen .loading__content .round{-webkit-animation:move .75s infinite linear;animation:move .75s infinite linear;border-radius:10px;background-color:#444;display:inline-block;height:4px;margin:0 2px;opacity:.1;width:4px}.loading-screen .loading__content .round-1{-webkit-animation-delay:.2s;animation-delay:.2s}.loading-screen .loading__content .round-2{-webkit-animation-delay:.4s;animation-delay:.4s}.loading-screen .loading__content .round-3{-webkit-animation-delay:.6s;animation-delay:.6s}@-webkit-keyframes move{0%{opacity:1}to{opacity:.1}}@keyframes move{0%{opacity:1}to{opacity:.1}}@media print{*{background:transparent!important;color:#000!important;text-shadow:none!important}.app__content,.post-list__content,.post-list__table{display:block}a:not(.mention-link),a:not(.mention-link):visited{text-decoration:underline}a[href^=http]:after{content:\" <\" attr(href) \"> \"}.date-separator,.post,blockquote,code,img,pre,tr{page-break-inside:avoid}.post__header{page-break-after:avoid}thead{display:table-header-group}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}#archive-link-home,#channel-header,#post-create,#post-list .more-messages-text,#sidebar-left,#sidebar-right,.attachment__content,.channel-intro,.post-image__thumbnail,.post.post--system,.post .post__content>div.post__img,.post .post__header .col__reply,.post__body .img-div{display:none}#channel_view,#post-list,#post-list .post-list-holder-by-time{overflow:visible;overflow-y:visible}#app-content{margin-left:0}#channel_view .inner-wrap.move--left{margin-right:0}.post-image__columns>div:first-child:before{content:'Attachments:';display:block;font-weight:700}.post-image__column{width:inherit;display:inline;height:inherit;background:transparent;border-color:transparent;border:0 none}.post-image__details{width:100%;border:0 none}.post-image__details .post-image__name:before{content:'['}.post-image__details .post-image__name:after{content:\": \" attr(href) \"]\"}.post-image__details .post-image__name+div{display:none}.date-separator .separator__hr,.new-separator .separator__hr{top:1.7em}}.user-settings{min-height:300px}.user-settings .table-responsive{max-height:300px;max-width:560px}.modal .settings-modal{width:800px}.modal .settings-modal .modal-back{font-size:27px;font-weight:400;height:40px;left:0;line-height:32px;position:absolute;text-align:center;top:12px;width:50px}.modal .settings-modal .modal-back .fa{height:100%;left:0;line-height:inherit;position:absolute;width:100%}.modal .settings-modal .modal-body{margin:0 auto;min-height:calc(100% - 62px);padding:0}.modal .settings-modal li{list-style:none}.modal .settings-modal label{font-weight:600}.modal .settings-modal .no-padding--left{padding-left:0}.modal .settings-modal .profile-img{height:128px;width:128px}.modal .settings-modal .settings-table{display:table;margin:0 auto;max-width:1000px;table-layout:fixed;width:100%}.modal .settings-modal .settings-table>div{display:table-cell;vertical-align:top}.modal .settings-modal .settings-table .nav{position:fixed;width:179px}.modal .settings-modal .settings-table .nav.position--top{top:57px}.modal .settings-modal .settings-table .security-links{margin-right:20px}.modal .settings-modal .settings-table .security-links .fa{margin-right:6px}.modal .settings-modal .settings-table .settings-links{width:180px}.modal .settings-modal .settings-table .settings-content{padding:0 20px 30px}.modal .settings-modal .settings-table .settings-content .modal-header{display:none}.modal .settings-modal .settings-table .settings-content .section-min{padding:1em 0;margin-bottom:0;cursor:pointer;position:relative;overflow:hidden;*zoom:1}.modal .settings-modal .settings-table .settings-content .section-min:hover{background:#f9f9f9}.modal .settings-modal .settings-table .settings-content .section-min:hover .fa{display:inline-block}.modal .settings-modal .settings-table .settings-content .section-min:hover .section-edit{text-decoration:underline}.modal .settings-modal .settings-table .settings-content .section-max{overflow:hidden;*zoom:1;background:rgba(0,0,0,.05);margin-bottom:0;padding:1em 0 1.3em}.modal .settings-modal .settings-table .settings-content .section-max .section-title{margin-bottom:10px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-group .input-group-addon{padding:4px 5px;width:40px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-group img{border:1px solid rgba(0,0,0,.15);width:29px}.modal .settings-modal .settings-table .settings-content .appearance-section .group--code select{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding-right:25px}.modal .settings-modal .settings-table .settings-content .appearance-section .group--code select::ms-expand{display:none}.modal .settings-modal .settings-table .settings-content .appearance-section .group--code:before{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:'\\F0D7';display:inline-block;font:normal normal normal 14px/1 FontAwesome;pointer-events:none;position:absolute;right:50px;text-rendering:auto;top:11px;z-index:5}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes{margin-bottom:10px}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes .theme-label{font-weight:400;margin-top:5px}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes img{border:3px solid transparent}.modal .settings-modal .settings-table .settings-content .appearance-section .premade-themes .active img{border-color:#2389d7}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements{padding-left:15px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements .element{margin-right:10px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements .element:nth-child(2n){margin-right:0}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header{border-bottom:1px solid #ccc;cursor:pointer;font-size:.96429em;font-weight:600;margin:10px 20px 0 0;padding:5px 0 10px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header .fa-minus{display:none}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header.open .fa-minus{display:inline-block}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header.open .fa-plus{display:none}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__header .header__icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;float:right}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body{border-radius:0 0 3px 3px;*zoom:1;background-color:hsla(0,0%,100%,.05);display:none;margin:0 20px 0 0;padding:20px 0 0 20px}.modal .settings-modal .settings-table .settings-content .appearance-section .theme-elements__body:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.modal .settings-modal .settings-table .settings-content .appearance-section .custom-label{font-size:12px;font-weight:400;margin-bottom:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.modal .settings-modal .settings-table .settings-content .appearance-section .input-group-addon{background:transparent}.modal .settings-modal .settings-table .settings-content .appearance-section .radio label{font-weight:600}.modal .settings-modal .settings-table .settings-content .section-title{font-weight:600;margin-bottom:5px;padding-right:50px}.modal .settings-modal .settings-table .settings-content .section-edit{margin-bottom:5px;text-align:right}.modal .settings-modal .settings-table .settings-content .section-edit .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;display:none;font-size:12px;margin-right:5px}.modal .settings-modal .settings-table .settings-content .section-edit .fa.fa-chevron-down{margin-right:0;position:relative;top:-1px}.modal .settings-modal .settings-table .settings-content .section-describe{overflow:hidden;*zoom:1;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;text-overflow:ellipsis;white-space:pre}.modal .settings-modal .settings-table .settings-content .divider-dark{border-bottom:1px solid #aaa}.modal .settings-modal .settings-table .settings-content .divider-light{border-bottom:1px solid #d3d3d3}.modal .settings-modal .settings-table .settings-content .setting-list{list-style-type:none;padding:0}.modal .settings-modal .settings-table .settings-content .setting-list__hint{margin-top:20px}.modal .settings-modal .settings-table .settings-content .mentions-input{margin-top:10px}.modal .settings-modal .settings-table .settings-content .setting-list-item{margin-top:7px}.modal .settings-modal .settings-table .settings-content .has-error{color:#a94442}.modal .settings-modal .settings-table .settings-content .file-status{color:#555;font-size:13px;margin-top:8px}.modal .settings-modal .settings-table .settings-content .confirm-import{margin:10px 0;padding:4px 10px}.modal .nav-pills>li{margin:0}.modal .nav-pills>li a{border-radius:0;color:#777;padding:8px 5px 8px 15px}.modal .nav-pills>li .glyphicon{top:2px;width:25px}.modal .nav-pills>li:hover a{background-color:rgba(0,0,0,.1)}.modal .nav-pills>li.active a{background-color:#e1e1e1;color:#111}.modal .nav-pills>li.active a:before{background:#000;content:'';height:100%;left:0;position:absolute;top:0;width:5px}.modal .nav-pills>li.active a,.modal .nav-pills>li.active a:focus,.modal .nav-pills>li.active a:hover{background-color:rgba(0,0,0,.1);border-radius:0;font-weight:400;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap}.modal h3{font-size:1.42857em}.channel-settings{padding:0 10px}.tab-header{margin-bottom:1em}.setting-name{color:grey;font-weight:500}.sel-btn{margin-right:5px}.member-div{border-bottom:1px solid #d3d3d3;margin:0;padding:2px;position:relative;width:100%}.member-div:first-child{border-top:1px solid #d3d3d3}.member-div .post-profile-img{border-radius:50px;margin-right:8px}.member-drop .fa,.member-role .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;font-size:12px;margin-right:5px}.member-drop .member-menu,.member-role .member-menu{right:110%;top:-50%}.member-invite{position:absolute;right:10px;top:7px}.member-menu{left:auto;right:0}.member-list{overflow-x:visible;width:100%}.member-page{padding-top:50px}.active-border{border:1px solid red}.color-btn{margin:4px}.no-resize{resize:none}.signup-header{background:#f5f5f5;line-height:33px;padding:0 1em .2em;width:100%}.signup-header .fa{margin-right:5px}.signup-team__container{margin:0 auto;max-width:380px;padding:100px 0 50px;position:relative}.signup-team__container.branded{display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;max-width:900px}.signup-team__container.branded .signup__markdown{-webkit-flex:1.3 0 0;flex:1.3 0 0;padding-right:80px}.signup-team__container.branded .signup__markdown p{color:gray}.signup-team__container.branded .signup__content{-webkit-flex:1 0 0;flex:1 0 0}.signup-team__container.padding--less{padding-top:50px}.signup-team__container .form-control:focus{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.signup-team__container h1,.signup-team__container h2,.signup-team__container h3,.signup-team__container h4,.signup-team__container h5,.signup-team__container h6,.signup-team__container p{line-height:1.3}.signup-team__container h1{font-weight:600}.signup-team__container h2{font-size:2.14286em;font-weight:600;letter-spacing:-.5px;margin-bottom:.8em}.signup-team__container h3{font-size:1.5em;font-weight:600;margin:0 0 1.3em}.signup-team__container h4{font-size:1.42857em;font-weight:600;margin-bottom:1em}.signup-team__container h5{font-size:1.14286em}.signup-team__container hr{margin:2em 0}.signup-team__container p{color:#555;line-height:1.5;margin-bottom:1em}.signup-team__container .input-group.input-group--limit{table-layout:fixed;width:100%}.signup-team__container .input-group.input-group--limit .tooltip-inner{word-wrap:break-word}.signup-team__container .input-group.input-group--limit .form-control{display:table-cell;text-align:left;width:100%}.signup-team__container .input-group.input-group--limit .input-group-addon{display:table-cell;overflow:hidden;text-align:left;text-overflow:ellipsis;width:50%}.signup-team__container .inner__content{margin:30px 0 20px}.signup-team__container .block--gray{border-radius:3px;background:#f2f2f2;display:inline-block;font-weight:600;padding:.85em 1.2em}.signup-team__container form{margin-bottom:.8em}.signup-team__container .signup-team-confirm__container{padding:100px 0}.signup-team__container .signup-team-logo{display:none;margin:0 0 2em;width:210px}.signup-team__container .signup-team-login{font-weight:600;padding-bottom:10px}.signup-team__container .signup-team__name{font-size:2.2em;font-weight:600;margin:.5em 0 0}.signup-team__container .signup-team__subdomain{font-size:1.5em;font-weight:300;margin:.2em 0 1.2em;text-transform:uppercase}.signup-team__container .form-control{height:2.71429em}.signup-team__container .or__container{background:#ddd;height:1px;margin:2em 0;margin:2.5em 0 2.5em -1rem;text-align:left}.signup-team__container .or__container span{background:#fff;display:inline-block;font-size:1.14286em;font-weight:600;line-height:20px;position:relative;text-align:center;top:-10px;width:40px}.signup-team__container ul{margin-bottom:0;padding-left:18px}.signup-team__container .btn{font-size:1em;font-weight:600;margin-right:5px;padding:.5em 1.07143em}.signup-team__container .btn .fa{font-size:17px;margin-right:8px}.signup-team__container .btn .icon{background-size:100% 100%;display:inline-block;height:18px;margin-right:8px;width:18px}.signup-team__container .btn.btn-custom-login{border-radius:2px;color:#fff;display:block;height:40px;line-height:34px;margin:1em 0;min-width:200px;padding:0 1em;width:200px}.signup-team__container .btn.btn-custom-login.gitlab{background:#548}.signup-team__container .btn.btn-custom-login.gitlab:hover{background:#403366}.signup-team__container .btn.btn-custom-login.gitlab span{vertical-align:middle}.signup-team__container .btn.btn-custom-login.gitlab .icon{background-image:url(" + __webpack_require__(811) + ")}.signup-team__container .btn.btn-custom-login.google{background:#dd4b39}.signup-team__container .btn.btn-custom-login.google:hover{background:#c23321}.signup-team__container .btn.btn-custom-login.google span{vertical-align:middle}.signup-team__container .btn.btn-custom-login.google .icon{background-image:url(" + __webpack_require__(812) + ")}.signup-team__container .btn.btn-custom-login.ldap{background:#dd4b39}.signup-team__container .btn.btn-custom-login.ldap:hover{background:#c23321}.signup-team__container .btn.btn-custom-login.ldap span{vertical-align:middle}.signup-team__container .btn.btn-custom-login.email{background:#2389d7}.signup-team__container .btn.btn-custom-login.email:hover{background:#1c6dab}.signup-team__container .btn.btn-custom-login.email span{vertical-align:middle}.signup-team__container .btn.btn-custom-login.btn-full{padding-left:35px;text-align:left;width:100%}.signup-team__container .btn.btn-default{color:#444}.signup-team__container .btn .glyphicon.glyphicon-ok,.signup-team__container .btn .glyphicon.glyphicon-refresh{font-size:.9em;left:-2px;margin-right:.5em}.signup-team__container .btn .glyphicon.glyphicon-chevron-right{font-size:.8em;right:-2px;top:0}.signup-team__container .btn .glyphicon.glyphicon-chevron-left{font-size:.8em;left:-2px;top:0}.signup-team__container .has-error .control-label{border-radius:3px;background:#f2f2f2;color:#999;font-size:14px;font-weight:400;margin:1em 0 0;padding:.7em 1em;width:100%}.signup-team__container .has-error .control-label:before{color:#aaa;content:'\\F071';margin-right:4px}.signup-team__container .reset-form{border-radius:3px;font-size:.95em;position:relative}.signup-team__container .reset-form p{color:inherit}.signup-team__container h1.margin--top-none,.signup-team__container h2.margin--top-none,.signup-team__container h3.margin--top-none,.signup-team__container h4.margin--top-none,.signup-team__container h5.margin--top-none,.signup-team__container h6.margin--top-none{margin-top:0}.signup-team__container h1.margin--bottom-none,.signup-team__container h2.margin--bottom-none,.signup-team__container h3.margin--bottom-none,.signup-team__container h4.margin--bottom-none,.signup-team__container h5.margin--bottom-none,.signup-team__container h6.margin--bottom-none{margin-bottom:0}.signup-team__container h1.margin--less,.signup-team__container h2.margin--less,.signup-team__container h3.margin--less,.signup-team__container h4.margin--less,.signup-team__container h5.margin--less,.signup-team__container h6.margin--less{margin-bottom:.3em}.signup-team__container h1.sub-heading,.signup-team__container h2.sub-heading,.signup-team__container h3.sub-heading,.signup-team__container h4.sub-heading,.signup-team__container h5.sub-heading,.signup-team__container h6.sub-heading{font-weight:400;margin-bottom:0}.signup-team__container h1.color--light,.signup-team__container h2.color--light,.signup-team__container h3.color--light,.signup-team__container h4.color--light,.signup-team__container h5.color--light,.signup-team__container h6.color--light{font-weight:300}.signup-team__container p.margin--extra{margin-bottom:1.5em}.signup-team__container p.margin--less{margin-bottom:.3em}.signup-team__container p.black,.signup-team__container p .black{color:#000}.signup-team__container .color--light{color:#777}.signup-team__container .margin--extra{margin-top:2.5em}.signup-team__container .margin--extra-2x{margin-top:5em}.signup-team-all{border-radius:2px;border:1px solid #ddd;margin:0 0 20px}.signup-team-all .signup-team-dir{background:#fafafa;border-top:1px solid #d5d5d5}.signup-team-all .signup-team-dir:first-child{border:none}.signup-team-all .signup-team-dir a{color:inherit;display:block;font-size:1.1em;height:3.5em;line-height:3.5em;padding:0 15px}.signup-team-all .signup-team-dir-err{background:#fafafa;border-top:1px solid #d5d5d5;color:inherit;padding:5px 15px}.signup-team-all .signup-team-dir-err:first-child{border:none}.signup-team-all .signup-team-dir__name{float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:90%}.signup-team-all .signup-team-dir__arrow{color:#999;float:right;font-size:.9em;line-height:3.5em}.authorize-box{margin:100px auto;width:500px;height:280px;border:1px solid #000}.authorize-inner{padding:20px}.authorize-btn{margin-right:6px}.verify_panel{margin:60px auto auto;max-width:380px}.team_statistics .total-count{border-radius:3px;background:#fff;border:1px solid rgba(0,0,0,.15);margin:1em 0;text-align:center;width:100%}.team_statistics .total-count .title{border-bottom:1px solid rgba(0,0,0,.15);font-size:13px;font-weight:400;padding:7px 10px;text-align:left}.team_statistics .total-count .title .fa{color:#555;float:right;font-size:16px;margin:0}.team_statistics .total-count .content{color:#555;font-size:30px;font-weight:600;overflow:auto;padding:.3em 0 .35em}.team_statistics .total-count--day{background:#fff;border:1px solid rgba(0,0,0,.15);clear:both;height:275px;margin:10px;padding:5px 10px 10px;width:760px}.team_statistics .total-count--day>div{font-size:18px;font-weight:300}.team_statistics .recent-active-users table{table-layout:fixed;width:100%}.team_statistics .recent-active-users .content{max-height:400px;overflow:auto;padding:0}.team_statistics .recent-active-users tr:first-child td{border-top:none}.team_statistics .recent-active-users tr td{overflow:hidden;*zoom:1;border-left:1px solid rgba(0,0,0,.15);border-top:1px solid rgba(0,0,0,.15);font-size:13px;font-weight:400;padding:5px 5px 6px;text-overflow:ellipsis;white-space:nowrap}.team_statistics .recent-active-users tr td:first-child{border-left:none}.alert{border-radius:1px;padding:8px 12px}.alert--confirm{display:inline-block;float:left;margin:1px 0 0 10px;padding:4px 10px}.btn{-webkit-transition:all .25s ease-in;-webkit-transition-delay:0s;transition:all .25s ease-in false;border-radius:1px}.btn.btn-primary{background:#2389d7;border-color:transparent}.btn.btn-primary:active,.btn.btn-primary:focus,.btn.btn-primary:hover{background:#1c6dab}.app__body .btn.btn-danger,.app__body .btn.btn-danger:active,.app__body .btn.btn-danger:focus,.app__body .btn.btn-danger:hover,.btn.btn-danger,.btn.btn-danger:active,.btn.btn-danger:focus,.btn.btn-danger:hover{color:#fff}.btn.btn-inactive{background:rgba(0,0,0,.15);border-color:transparent;color:#fff}.dropdown-menu.colorpicker{z-index:2500}.dropdown-menu .divider{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=15);opacity:.15}.dropdown-menu>li>a,.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:inherit}.emoticon{background-size:contain;display:inline-block;height:1.5em;margin-bottom:.25em;width:1.5em}.emoticon-suggestion{overflow:hidden;*zoom:1;cursor:pointer;font-size:13px;height:30px;line-height:30px;width:100%}.emoticon-suggestion__image{height:20px;margin:6px 6px 0 5px;padding:0;text-align:center;vertical-align:top;width:20px}.error-bar{background-color:#1f7bc1;color:#fff;padding:5px 30px;position:absolute;text-align:center;top:0;width:100%;z-index:9999}.error-bar a.error-bar__close{font-family:Open Sans,sans-serif;font-size:20px;font-weight:600;padding:0 10px;position:absolute;right:0;top:0}.error-bar a.error-bar__close,.error-bar a.error-bar__close:hover{color:#fff;text-decoration:none}.error-bar-developer{background-color:#b0171f;color:#fff;padding:5px 30px;position:absolute;text-align:center;top:0;width:100%;z-index:9999}.error-bar-developer a.error-bar__close{color:#fff;font-family:Open Sans,sans-serif;font-size:20px;font-weight:600;padding:0 10px;position:absolute;right:0;text-decoration:none;top:0}.error-bar-developer a.error-bar__close:hover{color:#fff;text-decoration:none}.file-preview__container{height:100px;margin:1px 0 10px;max-height:100px;overflow-x:auto;overflow-y:hidden;position:relative;white-space:nowrap;width:100%}.file-preview{overflow:hidden;*zoom:1;border:1px solid rgba(0,0,0,.15);display:inline-block;height:100px;margin:0 0 0 10px;position:relative;width:120px}.file-preview:hover .file-preview__remove:after{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.file-preview:first-child{margin-left:0}.file-preview .spinner{height:32px;left:50%;margin-left:-16px;margin-top:-16px;position:absolute;top:50%;width:32px}.file-preview__image{display:block;height:auto;max-width:100%}.file-preview__remove,.file-preview__remove:after{height:100%;left:0;position:absolute;top:0;width:100%}.file-preview__remove:after{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);background:rgba(0,0,0,.4);content:'';opacity:0}.file-preview__remove i{color:#fff;cursor:pointer;opacity:inherit;position:absolute;right:5px;text-shadow:0 0 3px rgba(0,0,0,.7);top:5px;z-index:5}.image-comment{background-position:0 0;background-repeat:no-repeat;height:300px;width:300px}.file-icon{height:100%;width:100%}.file-icon.audio{background-image:url(" + __webpack_require__(379) + ")}.file-icon.audio,.file-icon.video{background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.video{background-image:url(" + __webpack_require__(386) + ")}.file-icon.ppt{background-image:url(" + __webpack_require__(385) + ")}.file-icon.generic,.file-icon.ppt{background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.generic{background-image:url(" + __webpack_require__(382) + ")}.file-icon.code{background-image:url(" + __webpack_require__(380) + ")}.file-icon.code,.file-icon.excel{background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.excel{background-image:url(" + __webpack_require__(381) + ")}.file-icon.word{background-image:url(" + __webpack_require__(387) + ")}.file-icon.pdf,.file-icon.word{background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.pdf{background-image:url(" + __webpack_require__(384) + ")}.file-icon.patch{background-image:url(" + __webpack_require__(383) + ")}.file-icon.image,.file-icon.patch{background-size:60px auto;background-color:#fff;background-position:50%;background-repeat:no-repeat}.file-icon.image{background-image:url(" + __webpack_require__(814) + ")}.post-image__column{border:1px solid rgba(0,0,0,.2);float:left;height:100px;margin:5px 10px 5px 0;position:relative;width:240px}.post-image__load{background-position:50%;background-size:20px 20px}.post-image,.post-image__load{background-repeat:no-repeat;height:100%;width:100%}.post-image{background-color:#fff;overflow:hidden;position:relative;text-align:center}.post-image.small{background-position:50%}.post-image.normal{background-position:0 0}.post-image .spinner .file__loading{left:50%;margin-left:-16px;margin-top:-16px;position:absolute;top:50%}.post-image .file__loaded{max-width:initial}.post-image .file__loaded.landscape,.post-image .file__loaded.quadrat{height:100px}.post-image .file__loaded.portrait{width:120px}.post-image__thumbnail{cursor:-webkit- zoom-in;cursor:zoom- zoom-in;float:left;height:100%;width:50%}.post-image__details{overflow:hidden;*zoom:1;background:#fff;border-left:1px solid rgba(0,0,0,.15);color:rgba(0,0,0,.8);float:left;font-size:13px;height:100%;padding:7px;width:50%;word-break:break-word}.post-image__details .post-image__name{display:block;margin-bottom:3px}.post-image__details .post-image__download{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;cursor:pointer;display:inline-block;padding-right:7px}.post-image__details .post-image__size,.post-image__details .post-image__type{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.post-image__details .post-image__size{margin-left:4px}.file-details__container{display:-webkit-flex;display:flex;background:#fff}.file-details__container .file-details{height:270px;padding:14px;text-align:left;vertical-align:top;width:320px}.file-details__container .file-details .file-details__name{color:rgba(0,0,0,.9);font-size:16px;margin:5px 0;word-break:break-word}.file-details__container .file-details .file-details__info{color:rgba(0,0,0,.5)}.file-details__container .file-details__preview{border-right:1px solid rgba(0,0,0,.15);height:270px;vertical-align:center;width:320px}.file-details__container .file-details__preview .file-details__preview-helper{display:inline-block;height:100%;vertical-align:middle}.file-playback__controls{-webkit-transition:opacity .6s false;-webkit-transition-delay:0s;transition:opacity .6s false false;bottom:0;cursor:pointer;font-size:22px;position:absolute;right:5px;transition:opacity .6s;z-index:2}.file-playback__controls.stop{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0}.view-image__loading{background:#000;min-height:100px}.form-control{border-radius:1px}.form-control:focus{box-shadow:none}.form-control.no-padding{line-height:32px;padding:0}.form-control.no-resize{resize:none}.form-control[disabled],.form-control [readonly],fieldset[disabled] .form-control{background:hsla(0,0%,100%,.1);color:inherit;cursor:auto}.admin-textarea{resize:none}a{color:#2389d7;cursor:pointer;text-decoration:none;word-break:break-word}a:focus,a:hover{color:#1c6dab}.text-danger,.text-danger:focus,.text-danger:hover{color:#d37777}.mention{border-radius:3px;background:#2389d7;color:#fff;padding-bottom:2px;position:relative;z-index:10}.mentions__name{cursor:pointer;font-size:13px;height:36px;line-height:36px;padding:2px;position:relative;white-space:nowrap;width:100%;z-index:101}.mentions__name .mention-align{overflow:hidden;*zoom:1;text-overflow:ellipsis;width:calc(100% - 50px)}.mention__image{border-radius:32px;display:block;font-size:20px;height:32px;line-height:36px;margin-right:6px;text-align:center;width:32px}.mention__image .mention--align{display:inline-block;max-width:80%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mention__fullname{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;padding-left:10px}.mention--highlight{background-color:#ff0}.app__body.browser--ie .modal .modal-dialog{-webkit-transform:translateY(0);transform:translateY(0)}.app__body .modal-body{max-height:calc(90vh - 62px);overflow:auto;padding:20px 15px}.app__body .edit-modal-body{overflow:visible}.app__body .edit-modal-body .custom-textarea{max-height:60vh;min-height:8em}.app__body .edit-modal-body .suggestion-list__content{max-height:150px}.app__body .more-table{margin:0;table-layout:fixed}.app__body .modal{color:rgba(0,0,0,.9);width:100%}.app__body .modal.modal-image .modal-backdrop.in{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.app__body .modal .custom-textarea{border-color:rgba(0,0,0,.15);color:inherit}.app__body .modal .custom-textarea:focus{border-color:rgba(0,0,0,.15);box-shadow:none}.app__body .modal .btn{font-size:13px}.app__body .modal .btn.btn-default{background:transparent;border:none}.app__body .modal .info__label{font-weight:600;padding-right:0;text-align:right}.app__body .modal .team-member-list{width:100%}.app__body .modal .remove__member{color:inherit;float:right;font-size:20px;line-height:0;padding:6px}.app__body .modal .remove__member:hover{color:#e56565}.app__body .modal .modal-dialog{margin-left:auto;margin-right:auto;max-width:95%}.app__body .modal .modal-push-down{margin-top:5%}.app__body .modal .modal-next-bar{height:100%;position:absolute;right:0;top:0}.app__body .modal .modal-header{border-radius:0;overflow:hidden;*zoom:1;background:#2389d7;border:1px solid rgba(0,0,0,.15);color:#fff;min-height:56px;padding:15px 15px 11px}.app__body .modal .modal-header .modal-title{color:#f5f5f5;float:left;font-size:17px;line-height:27px}.app__body .modal .modal-header .modal-title .name{color:#fff;font-weight:600}.app__body .modal .modal-header .modal-action{margin:0;padding:0}.app__body .modal .modal-header .close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;-webkit-transition:all .25s ease-in;-webkit-transition-delay:0s;transition:all .25s ease-in false;color:#fff;height:30px;line-height:30px;position:absolute;right:10px;width:30px;z-index:5}.app__body .modal .modal-header .close:hover{background:rgba(0,0,0,.1)}.app__body .modal .modal-header .close span{font-family:Open Sans,sans-serif;line-height:10px}.app__body .modal .modal-header .btn.btn-primary{float:right;margin:-4px 25px 0 0;position:relative}.app__body .modal .modal-header .btn.btn-primary i{margin-right:5px}.app__body .modal .no-channel-message{padding:2em 1em;text-align:center}.app__body .modal .no-channel-message .primary-message{font-size:1.25em}.app__body .modal .no-channel-message .secondary-message{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;margin:1em 0 0}.app__body .modal .modal-content{border-radius:0;box-shadow:none}.app__body .modal .modal-chevron-icon{font-size:120%;top:50%}.app__body .modal .modal-prev-bar{height:100%;left:0;position:absolute;top:0}.app__body .modal.more-channel__modal .modal-body{padding:0}.app__body .modal .modal-image{height:100%;margin:0 auto;max-width:100%;position:relative;width:100%}.app__body .modal .modal-image .modal-body{overflow:hidden;*zoom:1;display:table;height:100%;max-height:100%;table-layout:fixed;width:100%}.app__body .modal .modal-image .modal-image__content{max-height:85vh;max-width:90vw;overflow-x:hidden;overflow-y:visible}.app__body .modal .modal-image .modal-image__wrapper{border-radius:3px;display:table-cell;max-width:90%;position:relative;text-align:center;vertical-align:middle;width:100%}.app__body .modal .modal-image .modal-image__wrapper:hover{border-radius:3px 3px 0 0}.app__body .modal .modal-image .modal-image__wrapper.default{height:80%;width:100%}.app__body .modal .modal-image .modal-image__wrapper audio,.app__body .modal .modal-image .modal-image__wrapper canvas,.app__body .modal .modal-image .modal-image__wrapper progress,.app__body .modal .modal-image .modal-image__wrapper video{display:block;height:auto;max-width:100%}.app__body .modal .modal-image .modal-image__wrapper .modal-close{-webkit-transition:opacity .6s false;-webkit-transition-delay:0s;transition:opacity .6s false false;background-size:100% 100%;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;background-image:url(" + __webpack_require__(807) + ");cursor:pointer;height:37px;position:absolute;right:-13px;top:-13px;transition:opacity .6s;width:37px;z-index:9999}.app__body .modal .modal-image .modal-image__wrapper .modal-close.modal-close--show{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .modal .modal-image .modal-image__wrapper>div{display:inline-block;min-height:100px;min-width:320px;position:relative}.app__body .modal .modal-image .modal-image__wrapper code{min-height:130px;min-width:330px}.app__body .modal .modal-image .modal-image__wrapper code,.app__body .modal .modal-image .modal-image__wrapper pre{display:inline-block}.app__body .modal .modal-image .modal-image__wrapper .post-body--code{max-height:calc(100vh - 80px);max-width:calc(100vw - 80px);overflow:auto}.app__body .modal .modal-image .modal-image__wrapper img{max-height:100%;max-width:100%}.app__body .modal .modal-image .modal-image__wrapper .spinner .file__loading{left:50%;margin-left:-16px;margin-top:-16px;position:absolute;top:50%;z-index:2}.app__body .modal .modal-image .modal-content{background:transparent;border:none;box-shadow:none;height:100%;padding:0;width:100%}.app__body .modal .modal-image .modal-image__body{display:table-cell;height:100%;overflow:visible;padding:0;position:relative;text-align:center;vertical-align:middle}.app__body .modal .modal-image .image-control{background:url(" + __webpack_require__(819) + ") 0 no-repeat;float:left;height:45px;margin-top:-23px;position:relative;top:50%;width:50px}.app__body .modal .modal-image .image-control.image-next{background:url(" + __webpack_require__(818) + ") 0 no-repeat;float:right}.app__body .modal .modal-image .loader-image{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.app__body .modal .modal-image .loader-percent{bottom:0;color:rgba(0,0,0,.5);height:20px;left:0;margin:auto;position:absolute;right:0;top:55px}.app__body .modal .modal-image .modal-button-bar{-webkit-transition:opacity .6s false;-webkit-transition-delay:0s;transition:opacity .6s false false;border-radius:0 0 3px 3px;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;background-color:#000;bottom:-40px;left:0;line-height:40px;max-width:90vw;padding:0 10px;position:absolute;right:0}.app__body .modal .modal-image .modal-button-bar.footer--show{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .modal .modal-image .modal-button-bar .image-links a,.app__body .modal .modal-image .modal-button-bar .image-links span{float:right}.app__body .modal .modal-image .modal-button-bar .text{bottom:0;color:#fff;margin-left:5px;vertical-align:middle}.app__body .modal .modal-image .modal-button-bar .public-link{margin-right:5px}.app__body .invite{margin-right:40px}.app__body .row--invite{overflow:hidden;*zoom:1;margin-right:40px}.app__body .row--invite .col-sm-6{padding:0 0 0 15px}.app__body .row--invite .col-sm-6:first-child{padding-left:0}.app__body .more-modal .user-list{margin-top:10px;overflow-x:hidden;overflow-y:auto;position:relative}.app__body .more-modal .modal-body{overflow-x:hidden;padding:10px 0 20px}.app__body .more-modal .filter-row{overflow:hidden;*zoom:1;margin:10px 0}.app__body .more-modal .member-count{margin-top:5px}.app__body .more-modal .member-count,.app__body .more-modal .member-show{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;float:right}.app__body .more-modal .member-show{margin-right:3px;margin-top:12px}.app__body .more-modal .member-select__container .member-count{margin:12px 0 0 3px}.app__body .more-modal .member-select__container select{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;float:right;margin:5px 5px 0 2px;width:auto}.app__body .more-modal .more-purpose{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7}.more-modal__list{display:flex;flex-direction:column;overflow:auto}.popover .more-modal__list{font-size:.95em}.popover .more-modal__list .more-modal__row{padding:5px 10px}.popover .more-modal__list .more-modal__name{font-weight:400}.more-modal__list .more-modal__image{border-radius:60px;flex-grow:0;flex-shrink:0;margin-right:8px}.more-modal__list .more-modal__details{flex-grow:1;flex-shrink:1;overflow:hidden;text-overflow:ellipsis}.more-modal__list .more-modal__actions{flex-grow:0;flex-shrink:0;padding-left:20px}.more-modal__list .more-modal__name{font-size:.95em;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.more-modal__list .more-modal__description{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.more-modal__list .more-modal__row{border-bottom:1px solid rgba(0,0,0,.15);display:flex;padding:8px 15px}.more-modal__list p{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;font-size:.9em;margin:5px 0;overflow:hidden;text-overflow:ellipsis}.filtered-user-list{display:flex;flex-direction:column}.filtered-user-list .filter-row{flex-grow:0;flex-shrink:0}.filtered-user-list .user-list{flex-grow:1;flex-shrink:1}.prompt{background:#fff;border:1px solid rgba(0,0,0,.15);margin:50px auto;max-width:90%;padding:1em 2em 0;width:600px}.prompt .prompt__heading{display:table;font-size:1.42857em;line-height:normal;margin:1em 0;width:100%}.prompt .prompt__heading>div{display:table-cell;vertical-align:top}.prompt .prompt__heading img{margin-right:15px}.prompt .prompt__allow{font-size:1.71429em;margin:1em 0}.prompt .prompt__buttons{border-top:1px solid rgba(0,0,0,.5);padding:1.5em 0;text-align:right}.popover{border-radius:1px;color:#404040}.popover.bottom>.arrow:after,.popover.left>.arrow:after,.popover.right>.arrow:after,.popover.top>.arrow:after{border-color:transparent}.popover .popover-title{background:rgba(0,0,0,.05);max-width:100%;overflow:hidden;padding:8px 10px;text-overflow:ellipsis}.popover .popover-content p:last-child{margin-bottom:5px}.channel-header__info .popover-content{max-height:250px;overflow:auto}.user-popover{cursor:pointer;display:inline-block}.code-popover .popover-content{padding:5px}.user-popover__image{border-radius:128px;margin:0 0 10px}.user-popover__email{display:block;max-width:200px;overflow:hidden;text-overflow:ellipsis}.search-help-popover{-webkit-transition:opacity .3s ease-in;-webkit-transition-delay:0s;transition:opacity .3s ease-in false;font-size:.92857em;max-width:none;top:36px;visibility:hidden;width:100%}.search-help-popover.autocomplete{display:block}.search-help-popover.autocomplete .popover-content{padding:10px;position:relative}.search-help-popover .search-autocomplete__divider{line-height:21px;margin:10px 0 5px;position:relative}.search-help-popover .search-autocomplete__divider:first-child{margin-top:5px}.search-help-popover .search-autocomplete__divider>span{background:#fff;display:inline-block;padding-right:10px;position:relative;z-index:5}.search-help-popover .search-autocomplete__divider:before{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background:rgba(0,0,0,.5);content:'';height:1px;left:0;position:absolute;top:10px;width:100%}.search-help-popover .search-autocomplete__item{border-radius:2px;cursor:pointer;margin:3px 0 0 5px;overflow:hidden;padding:6px 8px;text-overflow:ellipsis;white-space:nowrap}.search-help-popover .search-autocomplete__item:hover{background:rgba(0,0,0,.1)}.search-help-popover .search-autocomplete__item.selected{background:rgba(0,0,0,.2)}.search-help-popover .search-autocomplete__item .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;margin-right:5px}.search-help-popover .search-autocomplete__item .profile-img{height:16px;margin-right:6px;margin-top:-1px;width:16px}.search-help-popover.bottom>.arrow{border-width:9px;left:30px;top:-18px}.search-help-popover .popover-content{max-height:500px;overflow:auto;padding:3px 13px}.search-help-popover h4{font-size:1em}.search-help-popover ul{padding-left:17px}.search-help-popover ul span{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.search-help-popover ul b,.search-help-popover ul strong{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.search-help-popover .tooltip-inner{max-width:100%}.search-help-popover.visible{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;visibility:visible}.member-list__popover{max-width:initial}.member-list__popover .popover-content{max-height:350px;padding:0;position:relative;width:260px}.member-list__popover .popover-content .text-nowrap{font-size:13px;line-height:26px;overflow:hidden;padding:6px 10px;width:100%}.member-list__popover .popover-content .more__name{margin-left:6px;max-width:140px;overflow:hidden;text-overflow:ellipsis}::-webkit-scrollbar{height:8px;width:8px}::-webkit-scrollbar-track{background:rgba(0,0,0,.1)}::-webkit-scrollbar-thumb{border-radius:2px;background:rgba(0,0,0,.4)}body{scrollbar-3dlight-color:#7d7e94;scrollbar-arrow-color:#c1c1d1;scrollbar-darkshadow-color:#2d2c4d;scrollbar-face-color:rgba(0,0,0,.1);scrollbar-highlight-color:#7d7e94;scrollbar-shadow-color:#2d2c4d;scrollbar-track-color:rgba(0,0,0,.1)}.scrollbar--horizontal,.scrollbar--vertical{border-radius:2px;background-color:rgba(0,0,0,.5)}.channel-header .search-bar__container{padding:0 9px 0 3px}.search-bar__container{-webkit-flex:0 0 56px;flex:0 0 56px;padding:12px 8px 0 0}.glyphicon-refresh-animate{-webkit-animation:spin .7s infinite linear;animation:spin .7s infinite linear}.search__clear{-webkit-transition:all .2s linear;-webkit-transition-delay:0s;transition:all .2s linear false;-webkit-transform:translateX(60px);transform:translateX(60px);cursor:pointer;display:none;line-height:45px;margin-right:13px;position:absolute;right:0;z-index:5}.search-item-snippet{overflow:hidden;*zoom:1;text-overflow:ellipsis}.search-item-snippet ol,.search-item-snippet ul{padding-left:20px}.sidebar__collapse{-webkit-transition:all .2s linear;-webkit-transition-delay:0s;transition:all .2s linear false;-webkit-transform:translateX(0);transform:translateX(0);cursor:pointer;display:none;fill:#fff;font-size:35px;left:0;line-height:40px;padding-left:1px;position:absolute;text-align:center;width:49px;z-index:5}.sidebar__search-icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;color:rgba(0,0,0,.5);display:none;font-size:14px;margin-left:10px;position:absolute;top:15px}.search__form{position:relative}.search-bar__container .search__form{border-radius:2px;border:1px solid rgba(0,0,0,.15);margin:0;width:300px}.sidebar--right .search__form{width:100%}.search__form .search-bar{box-shadow:none;height:40px;padding-right:30px}.search-bar__container .search__form .search-bar{border:none;height:30px}.search__form .glyphicon-refresh-animate{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;position:absolute;right:27px;top:27px}.search-bar__container .search__form .glyphicon-refresh-animate{right:7px;top:8px}.search-items-container{-webkit-flex:1 1 auto;flex:1 1 auto;-webkit-overflow-scrolling:touch;height:calc(100% - 56px);overflow:auto;padding-top:10px;position:relative}.search-results-header{border-bottom:1px solid #ddd;color:#999;font-size:1em;font-weight:400;height:44px;line-height:44px;padding:0 10px;text-transform:uppercase}.search-item__container .post{margin:0;padding:0 1em 1em}.search-item__container .post:first-child{border:none}.search-item__container .post .search-channel__name{font-weight:600;margin:0 0 10px}.search-item__jump{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;font-size:13px;position:absolute;right:0;top:0}.search-item__jump:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.search-item__comment{margin-right:35px;position:absolute;right:0;top:0}.search-item-time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;font-size:.9em}.search-results-none{padding:10px}.search-highlight{background-color:#ff0}.suggestion-list{width:100%;z-index:100}.suggestion-list--top{position:absolute;bottom:100%}.suggestion-list__content{background-color:#fff;border:1px solid #ddd;max-height:292px;overflow-x:hidden;overflow-y:scroll;width:100%}.suggestion-list__content .command{border-bottom:1px solid rgba(0,0,0,.15);font-size:.95em;line-height:24px;padding:5px 10px 8px;position:relative;width:100%;z-index:101}.suggestion-list__content .command .command__desc{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;line-height:normal;margin-left:5px}.suggestion-list__content--top{bottom:0;position:absolute}.tooltip .tooltip-inner{font-size:13px;font-weight:500;padding:3px 10px 4px;word-break:break-word}.tip-backdrop{background:rgba(0,0,0,.5);height:100%;left:0;position:absolute;top:0;width:100%;z-index:999}.tip-overlay{border-radius:3px;background-color:#fff;max-width:90%;padding:20px;position:absolute;width:350px;z-index:1000}.tip-overlay .arrow{border:10px solid transparent;display:block;height:0;position:absolute;width:0}.tip-overlay.tip-overlay--sidebar{margin:50px 0 0 10px;max-width:75%;min-height:330px}.tip-overlay.tip-overlay--sidebar .tutorial__footer{bottom:20px;left:0;padding:0 20px;position:absolute;width:100%}.tip-overlay.tip-overlay--sidebar .arrow{border-left-width:0;border-right-color:#fff;left:-10px;margin-top:-10px;top:80px}.tip-overlay.tip-overlay--header--left{margin:10px 0 0 10px}.tip-overlay.tip-overlay--header--left .arrow{border-left-width:0;border-right-color:#fff;left:-10px;top:15px}.tip-overlay.tip-overlay--header--bottom{margin-top:-10px}.tip-overlay.tip-overlay--header--bottom .arrow{border-top-width:0;border-bottom-color:#fff;top:-10px;left:50%;margin-left:-10px}.tip-overlay.tip-overlay--chat{margin-top:-10px}.tip-overlay.tip-overlay--chat .arrow{border-bottom-width:0;border-top-color:#fff;bottom:-10px;left:50%;margin-left:-10px}.tip-overlay h4{font-size:1.14286em;font-weight:600;margin:5px 0 15px}.tip-overlay p{font-size:13px;line-height:1.6}.tip-overlay p strong{font-weight:600}.tip-overlay .btn{border-radius:3px;background:rgba(0,0,0,.3);border:none;color:#fff;margin:10px 0}.tip-overlay .btn:active,.tip-overlay .btn:focus,.tip-overlay .btn:hover{background:rgba(0,0,0,.4);border:none;color:#fff}.tip-overlay .tip-opt{font-size:12px}.tip-overlay .tip-opt span{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9}.tip-overlay .tutorial__circles{margin:1.5em 0 -1.7em -4px}.tip-overlay .tutorial__circles .circle{height:7px;margin:0 4px;width:7px}.tip-button{cursor:pointer;position:relative;right:-10px;top:-10px;z-index:998}.tip-div{position:absolute;right:0;top:0}.tip-div.tip-overlay--header{right:2px;top:21px}.tip-div.tip-overlay--header .tip-button,.tip-div.tip-overlay--sidebar{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.tip-div.tip-overlay--sidebar{left:0;top:-9px}.tutorial-steps__container{display:table;height:100%;text-align:center;width:100%}.tutorial-steps__container .tutorial__content{display:table-cell;padding:20px 40px 40px;vertical-align:middle}.tutorial-steps__container .tutorial__content .tutorial__steps{display:inline-block;margin-bottom:50px;max-width:310px;min-height:370px;position:relative;text-align:left}.tutorial-steps__container .tutorial__footer{bottom:0;position:absolute}.tutorial-steps__container h1{font-size:2.85714em;font-weight:600;margin:-20px 0 30px}.tutorial-steps__container h3{font-size:1.71429em;font-weight:600;margin-bottom:30px}.tutorial-steps__container .tutorial__circles{bottom:40px;position:absolute}.tutorial-steps__container .tutorial-skip{margin-left:13px}.tutorial__circles{margin:2em 0}.tutorial__circles .circle{border-radius:9px;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background:#000;display:inline-block;height:9px;margin:0 5px;width:9px}.tutorial__circles .circle.active{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;background:#2389d7}.video-div{margin-bottom:8px;max-width:480px;position:relative}.video-div .video-thumbnail{height:auto;max-width:100%}.video-div .block{background-color:rgba(0,0,0,.5);border-radius:10px;height:150px;left:50%;margin:-75px 0 0 -100px;position:absolute;top:50%;width:200px}.video-type{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;font-size:15px;margin:0;padding:0}.video-title{font-size:15px;margin-top:3px}.play-button{border-radius:14px;border:4px solid hsla(0,0%,100%,.4);height:100px;position:absolute;right:51px;top:26px;width:100px}.play-button span{border-bottom:36px solid transparent;border-left:60px solid hsla(0,0%,100%,.4);border-top:36px solid transparent;height:0;left:20px;position:absolute;top:10px;width:0}.img-div{-moz-force-broken-image-icon:1;border-radius:5px;margin-bottom:8px;max-height:500px;max-width:450px;position:relative}.img-div.placeholder{height:500px}.inner-wrap.move--left .search-bar__container,.inner-wrap.move--right .search-bar__container{display:none}.app__content{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;background:#fff;height:100%;margin-left:220px;padding-top:50px;position:relative}.channel__wrap .app__content{padding-top:0}#post-create{background:#fff;width:100%;z-index:3}#archive-link-home,#post-create{-webkit-flex:0 0 auto;flex:0 0 auto}#archive-link-home{cursor:pointer;font-size:13px}#archive-link-home .fa{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;font-size:11px}#archive-link-home a{color:inherit;display:block;padding:10px 20px;width:100%}.delete-message-text{margin-top:10px}.footer-pane{background:#f5f5f5;padding-bottom:1em}.footer-pane .footer-link{padding:0 1.5em}.footer-pane .footer-link.copyright{color:rgba(0,0,0,.5);padding-right:0}.footer-pane .footer-site-name{font-size:14px;font-weight:700;padding:1.5em 0 1em;text-transform:uppercase}.footer,.footer-pane,.footer-push{height:89px}.form-horizontal .modal-intro{margin:-10px 0 30px}.form-horizontal .form__label{font-size:1.1em;font-weight:600;padding-right:3px;text-align:left}.form-horizontal .form__label.light{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;font-size:1.05em;font-style:italic;font-weight:400;padding-top:2px}.form-horizontal .input__help{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;color:inherit;margin:10px 0 0 10px;word-break:break-word}.form-horizontal .input__help.dark{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.form-horizontal .input__help.error{color:#c32121}.form-horizontal .form-control{font-weight:400}.form-horizontal .form-group{margin-bottom:25px}.form-horizontal .form-group.less{margin-bottom:10px}.help-block{color:rgba(0,0,0,.5);font-size:.95em;margin:10px 0 0}.form-group.form-group--small{margin-bottom:10px}.padding-top{padding-top:7px}.padding-top.x2{padding-top:14px}.padding-top.x3{padding-top:21px}.padding-bottom{padding-bottom:7px}.padding-bottom.x2{padding-bottom:14px}.padding-bottom.x3{padding-bottom:21px}.padding-bottom .control-label{font-weight:600}.padding-bottom .control-label.text-left{text-align:left}.channel-header{-webkit-flex:0 0 56px;flex:0 0 56px}.row.header{position:relative}.channel__wrap .row.header{display:none}.header-dropdown__icon{color:inherit;font-size:11px;top:3px}.channel-header__info{display:table;table-layout:fixed;width:100%}.channel-header__info>div{display:block;white-space:nowrap;word-break:break-word}.channel-header__info>div.dropdown{float:left;max-width:100%;padding-right:1em}.channel-header__info>div.dropdown .header-dropdown__icon{color:rgba(0,0,0,.5)}.channel-header__info>div.dropdown a{text-decoration:none}.channel-header__info>div.dropdown .modal{white-space:normal}.channel-header__info>div.description{margin-top:2px;max-height:45px;overflow:hidden;text-overflow:ellipsis}.channel-header__info>div.description .markdown-inline-img{max-height:45px}.channel-header__info>div.popover{white-space:normal}.channel-intro{border-bottom:1px solid rgba(0,0,0,.15);margin:0 18px 35px;padding:0 0 5px}.channel-intro .intro-links{display:inline-block;margin:0 1.5em 10px 0}.channel-intro .intro-links .fa{margin-right:5px}.channel-intro .channel-intro-profile{margin-left:63px;margin-top:5px}.channel-intro .channel-intro-profile .user-popover{max-width:calc(100% - 100px);overflow:hidden;text-overflow:ellipsis}.channel-intro .channel-intro-img{float:left}.channel-intro .channel-intro-img img{border-radius:100px}.channel-intro .channel-intro__title{font-size:20px;font-weight:600;margin-bottom:15px}.channel-intro .channel-intro__content{border-radius:3px;background:#f5f5f5;padding:10px 15px}.channel-intro .channel-intro-text{margin-top:35px;word-break:break-all}.sidebar--left .team__header,.sidebar--menu .team__header{*zoom:1;padding:9px 10px;position:relative}.sidebar--left .team__header:after,.sidebar--menu .team__header:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.sidebar--left .team__header:before,.sidebar--menu .team__header:before{-webkit-transition:all .05s linear;-webkit-transition-delay:0s;transition:all .05s linear false;background:none;content:'';height:100%;left:0;position:absolute;top:0;width:100%}.sidebar--left .team__header:hover:before,.sidebar--menu .team__header:hover:before{background:rgba(0,0,0,.1)}.sidebar--left .team__header:hover a,.sidebar--menu .team__header:hover a{text-decoration:none}.sidebar--left .team__header:hover .user__name,.sidebar--menu .team__header:hover .user__name{color:#fff}.sidebar--left .team__header:hover .navbar-right .dropdown-toggle,.sidebar--menu .team__header:hover .navbar-right .dropdown-toggle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.sidebar--left .team__header .navbar-right,.sidebar--menu .team__header .navbar-right{font-size:.85em;position:absolute;right:22px;top:10px;z-index:5}.sidebar--left .team__header .navbar-right .dropdown-toggle,.sidebar--menu .team__header .navbar-right .dropdown-toggle{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;-webkit-transition:all .1s linear;-webkit-transition-delay:0s;transition:all .1s linear false;padding:10px}.sidebar--left .team__header .navbar-right .dropdown-menu a,.sidebar--menu .team__header .navbar-right .dropdown-menu a{overflow:hidden;padding:3px 20px;text-overflow:ellipsis}.sidebar--left .team__header .navbar-right .dropdown__icon,.sidebar--menu .team__header .navbar-right .dropdown__icon{fill:#fff}.sidebar--left .team__header .user__picture,.sidebar--menu .team__header .user__picture{border-radius:36px;float:left;height:36px;margin-right:6px;width:36px}.sidebar--left .team__header .header__info,.sidebar--menu .team__header .header__info{overflow:hidden;*zoom:1;color:#fff;padding-left:2px;position:relative;z-index:1}.sidebar--left .team__header .team__name,.sidebar--left .team__header .user__name,.sidebar--menu .team__header .team__name,.sidebar--menu .team__header .user__name{display:block;font-size:16px;font-weight:600;max-width:85%;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.sidebar--left .team__header .team__name,.sidebar--menu .team__header .team__name{float:left;line-height:22px;margin-top:-2px}.sidebar--left .team__header .user__name,.sidebar--menu .team__header .user__name{-webkit-transition:all .1s linear;-webkit-transition-delay:0s;transition:all .1s linear false;color:hsla(0,0%,100%,.8);font-size:14px;font-weight:400;line-height:18px}.sidebar--left .team__header>.nav>li>a,.sidebar--menu .team__header>.nav>li>a{background:none;float:right;padding:2px}.sidebar--left .team__header>.nav>li .dropdown-toggle,.sidebar--menu .team__header>.nav>li .dropdown-toggle{color:#fff;font-size:1em;line-height:1.8}.sidebar--left .search__clear,.sidebar--menu .search__clear{display:none}#navbar .navbar-default .navbar-toggle.menu-toggle{padding:0 1em}.channel-header{border-left:none;font-size:14px;line-height:56px;width:100%}.channel-header #member_popover{color:#999;cursor:pointer;width:50px}.channel-header #member_popover .fa{font-size:16px;margin-left:4px}.channel-header.alt{margin:0}.channel-header.alt th{font-weight:400!important}.channel-header.alt td{border:none}.channel-header th{text-align:center}.channel-header th:first-child{border-left:none;padding-left:15px;padding-right:1em;text-align:left!important;width:100%}.channel-header th:last-child{width:8.9%}.channel-header td{font-size:13px;padding:5px 25px!important;text-align:center!important}.channel-header td:first-child{text-align:left!important}.channel-header .heading{color:#555;display:inline-block;font-size:1.3em;font-weight:600;margin:0 4px 0 0;max-width:100%;overflow:hidden;text-overflow:ellipsis;vertical-align:middle}.channel-header .caret{margin-top:3px}.channel-header .more{color:#81848b;display:inline-block;font-size:13px;text-transform:capitalize;vertical-align:top}.channel-header .disabled{color:#999}.channel-header__navbar{font-size:16px}.channel-header__navbar .heading{margin-right:3px}.channel-header__navbar .header-dropdown__icon{top:1px}.app__body .channel-header__links{font-family:Open Sans,sans-serif;font-size:22px;height:30px;line-height:26px;margin-right:9px;width:24px}.channel__wrap.move--left .app__body .channel-header__links{position:absolute;right:-400px;top:14px}.app__body .channel-header__links>a{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;-webkit-transition:all .1s ease-in;-webkit-transition-delay:0s;transition:all .1s ease-in false;color:inherit;text-decoration:none}.app__body .channel-header__links>a:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .channel-header__links>a:focus{color:inherit}.markdown__heading{font-weight:700;line-height:1.5}.markdown__paragraph-inline{display:inline}.markdown__paragraph-inline+.markdown__paragraph-inline{margin-left:4px}#post-list .markdown-inline-img{-moz-force-broken-image-icon:1;height:500px;max-height:500px}.post-code{overflow-x:auto;overflow-y:hidden;position:relative}.post-code pre{border:1px solid hsla(0,0%,87%,.2);border-radius:.25em;margin:5px 0;padding:0;text-align:left}.post-code code{border:none;white-space:pre}.post-code td{padding:0 .5em;vertical-align:top}.post-code:hover .post-code__language{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.post-code--wrap code{white-space:pre-wrap}.post-code__language{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transform:translateZ(0);transform:translateZ(0);background:#21586d;border-radius:0 .25em;color:#fff;padding:4px 10px 5px;position:absolute;right:0;top:0;-webkit-transition:opacity .6s;transition:opacity .6s;z-index:5}.post-code__lineno{border-right:1px solid #aaa;color:#aaa;margin-right:.5em;text-align:right;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.post__body hr{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=20);opacity:.2;background-color:#e7e7e7;border:0 none;height:4px;margin:15px 0 16px;padding:0}.post__body .codespan__pre-wrap code{white-space:pre-wrap}.markdown__table{background:#fff;margin:5px 0 10px}.markdown__table td,.markdown__table th{border:1px solid #ddd;padding:6px 13px}.markdown__table tbody tr{background:#fff}.markdown__table tbody tr:nth-child(2n){background-color:#f8f8f8}blockquote{border:none;font-size:16px;margin-bottom:0;padding:10px 10px 10px 38px;position:relative}blockquote:before{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6;content:'\\F10D';display:inline-block;font-family:FontAwesome;font-size:20px;font-style:normal;font-weight:400;left:8px;position:absolute;text-decoration:inherit;top:5px}pre{margin:5px 0;padding:0}code,pre{color:inherit}code{background:#fff}.nav>li>a:focus,.nav>li>a:hover{background:transparent}#navbar input{margin:0 5px 0 2px}#navbar .navbar-default{background:#2389d7;border:none;min-height:45px;position:absolute}#navbar .navbar-default .navbar-nav>li>a{height:45px;padding:0 1.3em}#navbar .navbar-default .navbar-nav>li>a i{line-height:45px}#navbar .navbar-default .navbar-toggle{border-color:transparent;border-radius:0;fill:#fff;float:left;height:44px;line-height:48px;margin:0;padding:0 10px;width:43px;z-index:5}#navbar .navbar-default .navbar-toggle .icon-bar{background:#fff;width:21px}#navbar .navbar-default .navbar-toggle .glyphicon-search{top:-1px}#navbar .navbar-default .navbar-toggle .icon--white{color:#fff}#navbar .navbar-default .navbar-toggle:active,#navbar .navbar-default .navbar-toggle:focus,#navbar .navbar-default .navbar-toggle:hover{background:inherit}#navbar .navbar-default .navbar-brand{float:none;font-size:16px;height:45px;line-height:45px;padding:0 .5em}#navbar .navbar-default .navbar-brand .heading{color:#fff;display:inline-block;font-weight:600;margin-right:5px;max-width:calc(100% - 200px);overflow:hidden;vertical-align:top}#navbar .navbar-default .navbar-brand .header-dropdown__icon{top:1px}#navbar .navbar-default .navbar-brand .dropdown-toggle{color:#fff}#navbar .navbar-default .navbar-brand .description{color:#fff;display:inline-block;margin-right:.5em}#navbar .navbar-default .navbar-brand .description.info-popover{background-size:100% 100%;background-image:url(" + __webpack_require__(815) + ");cursor:pointer;height:19px;position:relative;top:-1px;vertical-align:middle;width:19px}#navbar .sidebar-channel{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#navbar .sidebar-channel span{margin-left:2px;white-space:nowrap}#navbar .channel-create-btn{margin-right:15px}#navbar .more-channel-table{border:1px solid #dbdbdc;width:100%}#navbar .more-channel-table td{padding:7px}#navbar .more-channel-table button{width:110px}.badge-notify{background:#e56565;left:4px;position:absolute;top:3px;z-index:100}.custom-textarea{background:transparent;border:1px solid #ccc;height:auto;line-height:20px;min-height:36px;overflow-x:hidden;resize:none;white-space:pre-wrap;word-wrap:break-word}.custom-textarea:focus{border-color:#ccc;box-shadow:none}.bad-connection{background:#ffffac!important;color:#d04444!important}.textarea-div{border:0;color:transparent;height:auto;left:1px;line-height:20px;min-height:36px;position:absolute;top:0;white-space:pre-wrap;word-break:break-word;word-wrap:normal}body.ios .textarea-div{-webkit-overflow-scrolling:auto;padding:7px 17px 7px 15px}.textarea-div::-webkit-scrollbar{display:none}.textarea-wrapper{min-height:36px;position:relative}.textarea-wrapper .textbox-preview-area{box-shadow:none;left:0;position:absolute;top:0;white-space:normal;z-index:2}.textarea-wrapper .help__text{bottom:-23px;cursor:pointer;font-size:13px;position:absolute;right:0;text-align:right;z-index:3}.textarea-wrapper .textbox-preview-link{margin-right:8px}.help__format-text{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:all .5s ease;-webkit-transition-delay:.5s;transition:all .5s ease .5s;display:inline-block;font-size:.85em;margin-right:10px;vertical-align:bottom;white-space:nowrap}.help__format-text b,.help__format-text code,.help__format-text i{margin-right:3px}.help__format-text .textbox-preview-link{cursor:pointer;font-size:13px;margin-left:15px}.date-separator,.new-separator{height:2em;margin:0;position:relative;text-align:center;z-index:0}.date-separator:after,.date-separator:before,.new-separator:after,.new-separator:before{content:'';display:none;height:1em;left:0;position:absolute;width:100%}.date-separator:before,.new-separator:before{bottom:0}.date-separator:after,.new-separator:after{top:0}.date-separator.hovered--after:before,.date-separator.hovered--before:after,.new-separator.hovered--after:before,.new-separator.hovered--before:after{background:#f5f5f5;display:block}.date-separator .separator__hr,.new-separator .separator__hr{border-color:#ccc;margin:0;position:relative;top:1em;z-index:5}.date-separator .separator__text,.new-separator .separator__text{border-radius:50px;background:#fff;color:#555;display:inline-block;font-size:13px;font-weight:700;line-height:2em;padding:0 1em;position:relative;z-index:5}.new-separator .separator__hr{border-color:#ffaf53}.new-separator .separator__text{color:#f80;font-weight:400}.file-overlay{color:#fff;font-size:1.42857em;font-weight:600;height:100%;left:0;position:absolute;text-align:center;top:0;width:100%;z-index:6}.file-overlay .overlay__indent{overflow:hidden;*zoom:1;background-color:rgba(0,0,0,.6);height:100%;position:relative}.file-overlay.right-file-overlay{font-size:1.28571em}.file-overlay.right-file-overlay .overlay__circle{height:300px;margin:-150px 0 0 -150px;width:300px}.file-overlay.right-file-overlay .overlay__files{margin:60px auto 15px;width:150px}.file-overlay .overlay__circle{border-radius:500px;background:rgba(0,0,0,.7);height:370px;left:50%;margin:-185px 0 0 -185px;pointer-events:none;position:absolute;top:50%;width:370px}.file-overlay .overlay__files{display:block;margin:75px auto 20px}.file-overlay .overlay__logo{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=30);opacity:.3;bottom:30px;left:50%;margin-left:-50px;position:absolute}.file-overlay .fa{display:inline-block;font-size:1.1em;margin-right:8px}#post-list{-webkit-flex:1 1 auto;flex:1 1 auto;height:100%;overflow-y:hidden;position:relative}#post-list .inactive{display:none}#post-list .post-list-holder-by-time{-webkit-overflow-scrolling:touch;background:#fff;height:100%;overflow-y:scroll;padding:1em 0 0;position:absolute;width:100%}#post-list .post-list-holder-by-time.active{display:inline}#post-list .more-messages-text{border:none;display:block;font-size:13px;margin:5px 0 10px;outline:none;text-align:center}.post-list__timestamp{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:all .6s ease;-webkit-transition-delay:0s;transition:all .6s ease false;-webkit-transform:translateY(-45px);transform:translateY(-45px);display:none;left:0;position:absolute;text-align:center;top:8px;width:100%;z-index:50}.post-list__timestamp.scrolling{-webkit-transform:translateY(0);transform:translateY(0);filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.post-list__timestamp>div{border-radius:3px;-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:auto;background:#2389d7;color:#fff;display:inline-block;font-size:12px;line-height:25px;padding:0 8px;text-align:center}.post-list__arrows{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;-webkit-transition:all .6s false;-webkit-transition-delay:0s;transition:all .6s false false;background-repeat:no-repeat;bottom:0;display:none;fill:#444;height:40px;left:9px;position:absolute;text-align:center;width:40px;z-index:50}.post-list__arrows svg{color:inherit;height:28px;width:28px}.post-list__arrows.scrolling{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1;display:block}.post-create__container form{margin:0 auto;padding:.5em 15px 0;width:100%}.post-create__container .center{max-width:1028px}.post-create__container .post-create-body{padding:0 0 2px;position:relative}.post-create__container .post-create-body .post-body__cell{position:relative;vertical-align:top}.post-create__container .post-create-body .post-body__cell.scroll .btn-file{right:15px}.post-create__container .post-create-body .post-body__cell.scroll .custom-textarea{padding-right:43px}.post-create__container .post-create-body .send-button{-webkit-transition:all .15s false;-webkit-transition-delay:0s;transition:all .15s false false;cursor:pointer;display:none;font-size:18px;height:37px;line-height:37px;padding-right:4px;text-align:center;vertical-align:bottom;width:45px}.post-create__container .post-create-body .send-button:active{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=75);opacity:.75}.post-create__container .post-create-body .custom-textarea{bottom:0;line-height:1.5;max-height:162px!important;padding-right:28px;padding-top:8px}.post-create__container .post-create-body .textarea-div{line-height:1.5;max-height:163px!important;overflow:auto;padding-right:30px;padding-top:8px}.post-create__container .post-create-body .btn-file{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;-webkit-transition:all .15s false;-webkit-transition-delay:0s;transition:all .15s false false;color:#444;font-size:16px;padding:7px 9px 6px;position:absolute;right:0;top:1px}.post-create__container .post-create-body .btn-file:active,.post-create__container .post-create-body .btn-file:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=90);opacity:.9;box-shadow:none}.post-create__container .post-create-body textarea{box-shadow:none}.post-create__container .post-create-footer{overflow:hidden;*zoom:1;font-size:13px;padding:3px 0 0}.post-create__container .post-create-footer .control-label{font-weight:400;margin-bottom:0;position:relative;top:-5px}.post-create__container .msg-typing{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;display:block;font-size:.95em;height:20px;margin-bottom:5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post-list__table{display:table;height:100%;min-height:100%;table-layout:fixed;width:100%}.post-list__table .post-list__content{display:table-cell;vertical-align:bottom}.post-list__table .post-list__content .dropdown-menu.bottom{bottom:25px;top:auto}.post{*zoom:1;max-width:100%;padding:8px .5em 0 1em;position:relative;word-wrap:break-word}.post:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.post:hover .comment-icon__container,.post:hover .dropdown,.post:hover .permalink-icon,.post:hover .post__remove,.post:hover .post__reply{visibility:visible}.post.post--highlight{background-color:beige}.post p{font-size:.97em;line-height:1.6em;margin:0;white-space:pre-wrap}.post p:last-child{margin-bottom:.5em}.post .post__header--info{padding:0}.post span p:last-child{margin-bottom:.5em}.post.post--root .comment-icon__container{visibility:visible}.post.post--comment .post__body{padding-left:7px;border-left:4px solid rgba(0,0,0,.3)}.post.same--root.same--user{padding:0 .5em 0 1em}.post.same--root.same--user:hover .post__time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.post.same--root.same--user .post__header{height:0;margin:0}.post.same--root.same--user .post__header .col__name{display:none}.post.same--root.same--user .post__header .col__reply{top:6px}.post.same--root.post--comment .post__img img,.post.same--root.post--comment .post__link{display:none}.post.other--root .comment-icon__container.icon--show{visibility:visible}.post.other--root.post--comment .popover{margin-top:84px}.post.other--root.post--comment .popover>.arrow{top:21px!important}.post.other--root.post--comment .post__header .col__reply{top:53px}.post .post__content{display:table;margin:0 auto;padding:0 5px;position:relative;table-layout:fixed;width:100%}.post .post__content>div{display:table-cell;vertical-align:top}.post .center{max-width:1000px}.post .post__header{list-style:none;margin-bottom:2px;padding:0}.post .post__header li{display:inline-block;vertical-align:top}.post .post__header .col__name{font-weight:600;margin-right:7px}.post .post__header .col__name .user-popover{overflow:hidden;*zoom:1;max-width:200px;text-overflow:ellipsis;white-space:nowrap}.post .post__header .col__reply{position:absolute;right:10px;top:30px;white-space:nowrap;width:65px}.post .post__header .permalink-popover{min-width:0}.post .post__header .permalink-popover .popover-content{padding:5px}.post .post__header .permalink-popover .btn,.post .post__header .permalink-popover .form-control{font-size:13px;height:30px;line-height:30px;padding:0 8px}.post .post__img{width:46px}.post .post__img svg{height:36px;width:36px}.post .post__img path{fill:inherit}.post .post__img img{border-radius:50px;height:36px;vertical-align:inherit;width:36px}.post .post__embed-container{-webkit-transition:max-height .5 ease;-webkit-transition-delay:0s;transition:max-height .5 ease false;display:block;max-height:1000px;overflow:hidden}.post .post__embed-container[hidden]{max-height:0}.post .dropdown{display:inline-block;margin-right:5px;top:-1px;visibility:hidden}.post .dropdown .dropdown-menu{left:auto;min-width:130px;padding:2px 0;right:0}.post .dropdown .dropdown-menu li{display:block}.post .dropdown .dropdown-menu a{padding:5px 15px}.post .post__dropdown:after{content:'[...]';position:relative;top:-1px}.post .post__remove{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5;color:inherit;display:inline-block;font-family:Open Sans,sans-serif;font-size:20px;font-weight:600;height:20px;line-height:20px;position:relative;right:15px;text-decoration:none;top:-5px;vertical-align:top;visibility:hidden;width:20px}.post .post__remove:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8}.post .post__body{*zoom:1;padding:.2em .5em;width:calc(100% - 75px);word-wrap:break-word}.post .post__body:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.post .post__body p{margin:0 0 .4em}.post .post__body p+p{margin-top:1.4em}.post .post__body li>p{margin-top:10px}.post .post__body img{max-height:400px}.post .post__body ol,.post .post__body ul{margin-bottom:.4em}.post .post__body ol p,.post .post__body ul p{margin-bottom:0}.post .post__body ol li ol,.post .post__body ol li ul,.post .post__body ul li ol,.post .post__body ul li ul{padding:10px 0 0 20px}.post .post__body ol li.list-item--task-list ol,.post .post__body ol li.list-item--task-list ul,.post .post__body ul li.list-item--task-list ol,.post .post__body ul li.list-item--task-list ul{margin-left:20px}.post .post__body ol li.list-item--task-list ul,.post .post__body ul li.list-item--task-list ul{padding-left:0}.post .post__body ol li:not(.list-item--task-list) li.list-item--task-list,.post .post__body ol li:not(.list-item--task-list) li.list-item--task-list~li,.post .post__body ul li:not(.list-item--task-list) li.list-item--task-list,.post .post__body ul li:not(.list-item--task-list) li.list-item--task-list~li{margin-left:-20px}.post .post__body ol li input[type=checkbox]:disabled,.post .post__body ul li input[type=checkbox]:disabled{cursor:default;vertical-align:top}.post .post__body ul li.list-item--task-list,.post .post__body ul li.list-item--task-list~li{list-style-type:none}.post .post__body ul li.list-item--task-list~li:not(.list-item--task-list){text-indent:3px}.post .post__body ul li.list-item--task-list~li:not(.list-item--task-list):before{content:'\\2022';margin-right:8px}.post .post__link{font-size:13px;margin:2px 0 5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .post__link a{font-weight:700}.post .post__embed-visibility{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;cursor:pointer;display:inline-block;font:normal normal normal 14px/1 FontAwesome;margin:5px 0 10px;text-rendering:auto}.post .post__embed-visibility:hover{text-decoration:none}.post .post__embed-visibility:before{content:'\\F065';font-size:14px}.post .post__embed-visibility[data-expanded=true]:before{content:'\\F066'}.post .post__time{font-size:.9em}.post.post--system .post__body,.post .post__time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=60);opacity:.6}.post .post-loading-gif{height:10px;margin-top:6px;width:10px}.post .post-fail{color:#d58a8a}.post .post-waiting{color:#999}.post .permalink-icon{color:#2389d7;display:inline-block;visibility:hidden}.post .post__reply{display:inline-block;margin-right:6px;visibility:hidden}.post .post__reply svg{fill:inherit;position:relative;top:3px;width:18px}.post .comment-icon__container{display:inline-block;fill:#2389d7;visibility:hidden}.post .comment-icon__container:focus{outline:none}.post .comment-icon__container.icon--visible{visibility:visible}.post .comment-icon__container svg{height:17px;width:17px}.post .comment-icon__container .comment-icon{display:inline-block;fill:inherit;margin-right:3px;position:relative;top:2px}.post .comment-icon__container path{fill:inherit}.post .web-embed-data{border-radius:2px;background:rgba(0,0,0,.05);height:50px;overflow:hidden;padding:2px 0 0 10px;text-overflow:ellipsis}.post .web-embed-data .embed-title{color:#555;font-weight:600;margin:3px 0 1px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .web-embed-data .embed-description{color:#888;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.post .web-embed-data .embed-link{display:none}.bot-indicator{border-radius:2px;font-family:inherit;font-size:11px;font-weight:600;margin:0 0 0 -4px;padding:2px 4px}.attachment .attachment__content{border-radius:4px;border-style:solid;border-width:1px;margin:0 0 5px;padding:2px 5px}.attachment .attachment__thumb-pretext{background:transparent;border:none;margin-left:5px}.attachment .attachment__container{border-left-style:solid;border-left-width:4px;padding:2px 0 2px 10px}.attachment .attachment__container.attachment__container--good{border-left-color:#00c100}.attachment .attachment__container.attachment__container--warning{border-left-color:#dede01}.attachment .attachment__container.attachment__container--danger{border-left-color:#e40303}.attachment .attachment__body{float:left;overflow-x:auto;overflow-y:hidden;padding-right:5px;width:80%}.attachment .attachment__body.attachment__body--no_thumb{width:100%}.attachment .attachment__text p:last-of-type{display:inline-block}.attachment .attachment__title{font-size:16px;height:22px;line-height:16px;margin:5px 0;padding:0}.attachment .attachment__title a{font-size:16px}.attachment .attachment__author-icon{border-radius:50px;height:14px;margin-right:5px;width:14px}.attachment .attachment__image{margin-bottom:1em;max-width:100%}.attachment .attachment__thumb-container{float:right;width:20%}.attachment .attachment__thumb-container img{max-height:75px;max-width:100%}.attachment .attachment___fields{width:100%}.attachment .attachment___fields .attachment___field-caption{font-weight:700}.attachment .attachment___fields .attachment___field p{margin:0}.permalink-text{overflow:hidden}.permalink-popover{margin-left:50px!important;min-width:320px}.post-right__container{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;height:100%}.post-right__container .post-right-root-message{padding:1em 1em 0}.post-right__container .post-right-comments-container{position:relative}.post-right__container .post-right-comments-container .post:first-child{padding-top:15px}.post-right__container .help_format_text{bottom:-63px;right:auto}.post-right__container .post.post--root{border-bottom:1px solid #ddd;padding-bottom:1.2em}.post-right__container .post.post--root .post__body{background:transparent!important}.post-right__container .post .post__header .col__reply{text-align:right;top:0}.post-right__container .post .post__body{width:100%}.post-right__container hr{border:none;margin-bottom:0}.post-right__container .post-create__container{width:100%}.post-right__container .post-create__container .textarea-wrapper{min-height:100px}.post-right__container .post-create__container .btn{margin-bottom:10px}.post-right__container .post-create__container .custom-textarea{min-height:100px}.post-right__container .post-create__container .msg-typing{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;display:block;float:left;font-size:13px;height:20px;line-height:20px;margin-top:3px;max-width:230px;min-width:1px}.post-right__container .post-create__container .post-create-footer{padding:5px 0 10px;width:100%}.post-right__container .post-create__container .post-right-comments-upload-in-progress{color:#a8adb7;margin-right:10px;padding:6px 0}.post-right-header{border-bottom:1px solid #ddd;color:#999;font-size:1em;font-weight:400;height:39px;padding:10px 10px 0 15px;text-transform:uppercase}.post-right-root-container{border-bottom:1px solid #ddd;padding:5px 10px}.post-right-root-container ul{margin-bottom:2px;padding-left:0}.post-right-channel__name{font-weight:600;margin:0 0 15px}.post-right-root-container li{display:inline;list-style-type:none;padding-right:3px}.post-right-root-time{color:#a8adb7}.post-right-create-comment-container{bottom:0;left:0;margin-bottom:18px;padding:5px;position:absolute;width:100%}.post-right__scroll{-webkit-flex:1 1 auto;flex:1 1 auto;-webkit-overflow-scrolling:touch;overflow:auto;position:relative}.post-right__scroll .file-preview__container{margin-top:5px}.post-right-comment-time{color:#a8adb7}.sidebar--left{border-right:1px solid #ddd;height:100%;left:0;position:absolute;width:220px;z-index:5}.sidebar--left.sidebar--padded{padding-top:44px}.sidebar--left .sidebar__divider{color:#fff;font-size:.9em;height:20px;line-height:20px;margin:5px 0 6px;position:relative;z-index:0}.sidebar--left .sidebar__divider:before{background:rgba(0,0,0,.15);content:'';height:1px;position:absolute;top:10px;width:100%}.sidebar--left .sidebar__divider .sidebar__divider__text{background:#2389d7;float:right;padding:0 10px;position:relative;z-index:1}.sidebar--left .dropdown-menu{max-height:400px;max-width:200px;overflow-x:hidden;overflow-y:auto;width:200px}.sidebar--left .search__form{display:none;margin:0;padding:1em 1em 0}.sidebar--left .badge{background-color:#2389d7;position:absolute;right:10px;top:5px}.sidebar--left .status{display:inline-block;margin-right:6px;position:relative;top:1px;width:12px}.sidebar--left .status svg{max-height:14px}.sidebar--left .status ellipse,.sidebar--left .status i,.sidebar--left .status path{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.sidebar--left .status ellipse.away--icon,.sidebar--left .status ellipse.online--icon,.sidebar--left .status i.away--icon,.sidebar--left .status i.online--icon,.sidebar--left .status path.away--icon,.sidebar--left .status path.online--icon{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.sidebar--left .status .fa-lock{margin-left:1px}.sidebar--left .status .fa-globe{position:relative;top:-1px}.sidebar--left .nav-pills__container{-webkit-overflow-scrolling:touch;height:calc(100% - 80px);overflow:auto;position:relative}.sidebar--left .nav-pills__unread-indicator{border-radius:50px;background:#2389d7;color:#fff;font-size:13.5px;left:0;margin:0 auto;padding:3px 0 4px;position:absolute;right:0;text-align:center;width:72%;z-index:1}.sidebar--left .nav-pills__unread-indicator-top{top:66px}.sidebar--left .nav-pills__unread-indicator-bottom{bottom:20px}.sidebar--left .nav.nav-stacked>li+li{margin:0}.sidebar--left .nav li>h4{color:#aaa;font-size:1em;font-weight:400;letter-spacing:-.3px;margin:1.1em 0 .5em;padding:0 10px 0 15px;text-transform:uppercase}.sidebar--left .nav li>a{border-radius:0;line-height:1.5;overflow:hidden;padding:3px 10px 3px 25px;text-overflow:ellipsis;white-space:nowrap}.sidebar--left .nav li>a.has-badge,.sidebar--left .nav li>a.has-close{padding-right:30px}.sidebar--left .nav li>a.has-close:hover .btn-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;display:block}.sidebar--left .nav li>a.has-close .btn-close{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;display:none;font-family:Open Sans,sans-serif;font-size:20px;font-weight:600;position:absolute;right:15px;top:-1px}.sidebar--left .nav li>a.has-close .btn-close:hover{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.sidebar--left .nav li>a.nav-more{text-decoration:underline}.sidebar--left .nav li>a.unread-title{font-weight:600}.sidebar--left .nav li.active a:before{background:#000;content:'';height:100%;left:0;position:absolute;top:0;width:5px}.sidebar--left .nav li.active a,.sidebar--left .nav li.active a:focus,.sidebar--left .nav li.active a:hover{background-color:rgba(0,0,0,.1);border-radius:0;font-weight:400;position:relative}.sidebar--left .modal-title{line-height:2em}.sidebar--left .add-channel-btn{color:#aaa;float:right;font-size:22px;font-weight:700;line-height:18px;margin:-2px 0 0;outline:none;padding:0 5px;text-decoration:none}.sidebar--left .add-channel-btn:hover{color:#666}.channel-loading-gif{height:15px;margin-top:2px;width:15px}.join-channel-loading-gif{height:25px;margin-left:10px;margin-top:5px;width:25px}.sidebar--menu{background:#fafafa;border-right:1px solid #ddd;display:none;height:100%;padding:0 0 2em;position:absolute;right:0;width:220px}.sidebar--menu .nav-pills__container{padding-top:5px}.sidebar--menu .team__header{*zoom:1;display:none;padding:0 15px}.sidebar--menu .team__header:after{content:\" \";display:block;height:0;clear:both;overflow:hidden;visibility:hidden}.sidebar--menu .team__header a{color:#fff}.sidebar--menu .team__header .navbar-right{font-size:.85em;margin:16px -5px 0}.sidebar--menu .team__header .navbar-right .dropdown-toggle{padding:0 10px}.sidebar--menu .team__header .navbar-right .dropdown-menu li a{color:#555;padding:3 20px}.sidebar--menu .team__header .navbar-right .dropdown__icon{background-size:100% 100%;display:inline-block;height:16px;width:4px}.sidebar--menu .team__header .team__name{float:left;font-size:1.2em;font-weight:600;line-height:50px;max-width:80%;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.sidebar--menu .nav>li>a{background:none!important;color:inherit;font-size:15px;line-height:40px;padding:0 15px}.sidebar--menu .nav>li>a .fa,.sidebar--menu .nav>li>a .glyphicon{left:-5px;position:relative;text-align:center;width:25px}.sidebar--right{-webkit-transform:translateX(400px);transform:translateX(400px);background:#fff;height:100%;padding:0;position:fixed;right:0;width:400px}.sidebar--right .post-body img{max-height:200px}.sidebar--right .post .post__content{padding:0}.sidebar--right .post .post__header .col__name .user-popover{max-width:130px}.sidebar--right .post-create__container form{padding:.5em 15px 0}.sidebar--right .help__format-text{display:none}.sidebar--right .sidebar--right__content{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;height:100%}.sidebar--right .sidebar--right__back{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);opacity:.8;color:inherit;display:inline-block;font-size:13px;margin:0 0 0 -14px;text-align:center;width:30px}.sidebar--right .sidebar-right__body{border-radius:2px 0 0 0;display:-webkit-flex;display:flex;-webkit-flex:1 1 auto;flex:1 1 auto;-webkit-flex-direction:column;flex-direction:column;border-left:1px solid #ddd;border-top:1px solid #ddd;height:calc(100% - 56px)}.sidebar--right .sidebar__overlay{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=10);opacity:.1;background-color:#ff0;height:100%;pointer-events:none;position:absolute;width:100%;z-index:5}.sidebar--right .input-group{word-break:break-word}.sidebar--right .sidebar--right__close{-webkit-transition:all .2s ease-in;-webkit-transition-delay:0s;transition:all .2s ease-in false;background:none;border:none;float:right;font-size:22px;height:22px;line-height:0;margin:11px 0 0;opacity:.5;outline:none;width:22px}.sidebar--right .sidebar--right__close:active,.sidebar--right .sidebar--right__close:hover{opacity:.8}.sidebar--right .sidebar--right__close i{position:relative;top:-2px}.sidebar--right .sidebar--right__header{-webkit-flex:0 0 44px;flex:0 0 44px;border-bottom:1px solid #ddd;color:inherit;font-size:1em;height:44px;line-height:44px;padding:0 1em;text-transform:uppercase}.sidebar--right .sidebar--right__subheader{font-size:1em;padding:1em 1em 0}.sidebar--right .sidebar--right__subheader h4{font-size:1em}.sidebar--right .sidebar--right__subheader ul{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=70);opacity:.7;padding:10px 0 0 30px}.sidebar--right .sidebar--right__subheader li{font-size:.95em;padding-bottom:10px}.sidebar--right .suggestion-list__content{max-height:120px}.sidebar-right-container{height:100%}.webhooks__container{border-radius:3px;background:rgba(0,0,0,.1);border:1px solid;margin-top:10px;padding:0 13px 15px}.webhook__item{font-size:13px;position:relative}.webhook__item:last-child .divider-light:last-child{display:none}.webhook__item .webhook__remove{color:#e05f5d;font-size:22px;font-weight:700;height:30px;position:absolute;right:-7px;text-align:center;text-decoration:none;top:8px;width:30px}.webhook__item .webhook__url{padding-right:20px}@media screen and (max-width:1800px){.inner-wrap.move--left .date-separator.hovered--comment:after,.inner-wrap.move--left .date-separator.hovered--comment:before,.inner-wrap.move--left .new-separator.hovered--comment:after,.inner-wrap.move--left .new-separator.hovered--comment:before{background:none}}@media screen and (max-width:1440px){.inner-wrap.move--left .help__format-text{display:none}.date-separator.hovered--comment:after,.date-separator.hovered--comment:before,.new-separator.hovered--comment:after,.new-separator.hovered--comment:before{background:none!important}}@media screen and (max-width:1258px){.backstage-content{margin:46px 46px 46px 150px}}@media screen and (max-width:1140px){.tip-overlay.tip-overlay--chat{margin:-10px 0 0 -10px}.tip-overlay.tip-overlay--chat .arrow{left:auto;right:15px}.inner-wrap.move--left .file-overlay{font-size:1.28571em}.inner-wrap.move--left .file-overlay .overlay__circle{height:300px;margin:-150px 0 0 -150px;width:300px}.inner-wrap.move--left .file-overlay .overlay__files{margin:60px auto 15px;width:150px}}@media (min-width:992px){.modal-lg{width:700px}}@media screen and (max-width:960px){.signup-team__container.branded{display:block;margin:0 auto;max-width:380px}.signup-team__container.branded .signup__markdown{display:none}.sidebar--right{-webkit-transition:all .5s ease;-webkit-transition-delay:0s;transition:all .5s ease false;-webkit-transform:translateX(100%);transform:translateX(100%);z-index:5}.sidebar--right.move--left{-webkit-transform:translateX(0)!important;transform:translateX(0)!important}.sidebar--right.move--left .search-bar__container{padding-right:8px}.backstage-content{margin:30px;max-width:100%;padding:0}.backstage-sidebar{height:auto;padding:30px 15px 0;position:relative;width:100%}.help__format-text{display:none}.inner-wrap.move--left,.inner-wrap:not(.move--left){margin-right:0!important}.inner-wrap.move--left .channel-header__links{position:relative;right:auto;top:auto}}@media screen and (min-width:768px){.second-bar{display:none}.sidebar--right.move--left{-webkit-transform:translateX(0);transform:translateX(0)}.inner-wrap.move--left{margin-right:400px}.post.same--root.same--user .post__time{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=0);opacity:0;font-size:11px;left:-4px;line-height:37px;position:absolute;text-rendering:auto;top:-2px}}@media screen and (max-width:768px){.backstage-filters{display:block}.backstage-filters .backstage-filter__search{border-bottom:1px solid rgba(0,0,0,.15);margin:10px 0;width:100%}.audit-panel .row>.form-group,.compliance-panel .row>.form-group{padding-left:15px}.user-popover{pointer-events:none}.signup-team__container{font-size:1em}.sidebar--left .team__header .user__picture,.sidebar--menu .team__header .user__picture{display:none}.date-separator.hovered--after:before,.date-separator.hovered--before:after,.new-separator.hovered--after:before,.new-separator.hovered--before:after{background:none!important}.channel-intro{margin:0 15px 35px}.post .post__dropdown{display:inline-block;height:20px;line-height:9px;text-align:center;text-decoration:none;width:20px}.post .post__dropdown:after{content:'...';font-size:20px;top:-3px}.post .post__content{padding:0 10px 0 0}.post .post__header{margin-bottom:0}.post .post__header .col__reply{top:0;width:65px}.post .post__header .col__name{pointer-events:none}.post .post__header .col__name .user-popover{max-width:130px}.post .comment-icon__container{display:none;visibility:visible}.post .comment-icon__container.icon--show{display:inline-block}.post-list__content .post:hover{background:transparent}.post-list__content .post .comment-icon__container,.post .dropdown,.post .post__reply{visibility:visible}.post .post__body{width:100%}.post .post__reply{float:right;margin-right:20px}.post .post__reply svg{top:1px}.post.other--root.post--comment .post__header .col__reply{top:0}.post.other--root .post__reply.post__reply--hide{visibility:hidden}.post.same--root.same--user .post__time{display:none}.post.same--root.same--user .post__header{height:auto;margin-top:5px}.post.same--root.same--user .post__header .col__name{display:inline-block}.post .post__img{width:40px}.post .post__img img{height:32px;width:32px}.post-image__column{height:95px;width:200px}.textarea-wrapper .textbox-help-link,.textarea-wrapper .textbox-preview-link{display:none}.form-control.min-height{min-height:100px}.img-div{max-width:100%}.tip-div{left:15px;right:auto}.tip-overlay.tip-overlay--chat{margin-left:10px}.tip-overlay.tip-overlay--chat .arrow{left:32px}.file-details__container{display:block}.file-details__container .file-details__preview{border-bottom:1px solid #ddd;border-right:none;display:block;height:150px;width:100%}.file-details__container .file-details__preview img{height:64px;width:64px}.file-details__container .file-details{height:auto;width:100%}.search-help-popover.visible{visibility:hidden}.modal-direct-channels .member-count{display:block;float:none;margin-top:10px}.file-overlay{font-size:1.28571em}.file-overlay.center-file-overlay .overlay__indent{margin-left:0}.file-overlay .overlay__circle{height:300px;margin:-150px 0 0 -150px;width:300px}.file-overlay .overlay__files{margin:60px auto 15px;width:150px}.date-separator.hovered--after:before,.date-separator.hovered--before:after,.new-separator.hovered--after:before,.new-separator.hovered--before:after{background:none}.post-list__timestamp{display:block}.signup-team__container{font-size:.9em;margin-bottom:30px;padding:30px 0}.signup-team__container .signup-team__name{font-size:2em}.signup-team__container .btn.btn-full{padding-left:10px}.signup-team__container .btn .fa,.signup-team__container .btn .icon{margin-right:6px}.row--invite .col-sm-6{padding:0}.app__body .modal .info__label{padding-bottom:5px;text-align:left}.app__body .modal .modal-image .modal-button-bar{line-height:30px;padding:5px}.app__body .modal .modal-image .image-wrapper>div{font-size:12px;min-width:250px}.app__body .modal .modal-image .image-wrapper .modal-close,.app__body .modal .modal-image .modal-button-bar{filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);opacity:1}.app__body .modal .modal-header .modal-action{margin-top:10px}.app__body .modal .modal-header button.close{font-size:27px;font-weight:400}.app__body .modal .modal-header .modal-title{float:none;max-width:90%}.app__body .modal .modal-header .btn.btn-primary{display:block;float:none;margin:10px 0 6px;width:100%}.app__body .modal .settings-modal.display--content .modal-header{display:none}.app__body .modal .settings-modal.display--content .settings-table,.app__body .modal .settings-modal.display--content .settings-table .settings-content.minimize-settings{display:block}.app__body .modal .settings-modal.display--content .settings-table .settings-content .section-min:hover{background:none}.app__body .modal .settings-modal.display--content .settings-table .settings-content .no-padding--left{padding-left:15px}.app__body .modal .settings-modal.display--content .settings-table .settings-links{display:none}.app__body .modal .settings-modal.display--content .settings-table .modal-header{display:block;position:absolute;top:0;width:100%;z-index:5}.app__body .modal .settings-modal.display--content .settings-table .modal-header .modal-title{text-align:center;width:100%}.app__body .modal .settings-modal.display--content .settings-table .user-settings .divider-dark.first,.app__body .modal .settings-modal.display--content .settings-table .user-settings .tab-header{display:none}.app__body .modal .settings-modal .settings-table{padding:0}.app__body .modal .settings-modal .settings-table .nav{position:relative;top:auto;width:100%}.app__body .modal .settings-modal .settings-table .nav.position--top{top:auto}.app__body .modal .settings-modal .settings-table .settings-content .section-edit{position:absolute;top:14px;right:0;padding-right:0}.app__body .modal .settings-modal .settings-table .settings-content .section-edit .fa{display:inline-block}.app__body .modal .settings-modal .settings-table .settings-content.minimize-settings{padding:0;display:none}.app__body .modal .settings-modal .settings-table .settings-content.minimize-settings .user-settings{padding:70px 20px 30px}.app__body .modal .settings-modal .settings-table .settings-content .section-min:hover{background:none!important}.app__body .modal .settings-modal .settings-table .nav>li>a{border-top:1px solid #ddd;font-size:1.1em;line-height:2.7;color:#555}.app__body .modal .settings-modal .settings-table .nav>li>a .glyphicon{margin-left:7px}.post-right__container .post-create__container{padding:0 1em}.post-right__container .post-create__container .msg-typing{display:none}.post-create__container form{padding:.5em 0}.post-create__container .post-create-footer{padding:0 1em}.post-create__container .post-create-footer .msg-typing{display:none}.post-create__container .post-create-footer .control-label{top:0}.post-create__container .post-create-body{display:table;width:100%}.post-create__container .post-create-body .post-body__cell{display:table-cell;padding-left:45px}.sidebar--right .post-create__container .post-create-body .post-body__cell{padding-left:0}.app__content .post-create__container .post-create-body .btn-file{width:45px;padding:0;line-height:36px;bottom:-2px;left:0;top:auto}.post-create__container .post-create-body .send-button{display:table-cell}.file-preview__container{margin:5px 0 0}.file-preview{margin-top:0}.file-preview__remove{background:rgba(0,0,0,.5);height:28px;left:auto;right:0;text-align:center;top:0;width:28px}.file-preview__remove:after{display:none}.file-preview__remove i{font-size:16px;line-height:29px;position:relative;right:auto;top:auto}#navbar .navbar-default .navbar-header{float:none;margin:0 -15px}#navbar .navbar-default .navbar-header .dropdown__icon{background-size:100% 100%;display:inline-block;height:16px;width:4px}#navbar .navbar-default .navbar-toggle{display:block}#navbar .navbar-default .navbar-brand{white-space:nowrap}body.white .inner-wrap>.row.content{margin-bottom:-185px}.footer,.footer-pane,.footer-push{height:187px}.footer-pane .footer-link{line-height:1.7;padding:0;text-align:right;width:100%}.footer-pane .footer-link.copyright{width:100%}.search__clear{display:block}.search-bar__container{-webkit-flex:0 0 44px;flex:0 0 44px;background:#2389d7;color:#fff;padding:0}.search-bar__container.focused .search__form,.search-bar__container.focused .sidebar__collapse{-webkit-transform:translateX(-45px);transform:translateX(-45px)}.search-bar__container.focused .search__form{padding-left:55px;padding-right:24px}.search-bar__container.focused .search__clear,.search-bar__container .search__form{-webkit-transform:translateX(0);transform:translateX(0)}.search-bar__container .search__form{-webkit-transition:all .2s linear;-webkit-transition-delay:0s;transition:all .2s linear false;border:none;height:45px;padding:7px 20px 0 49px;position:relative}.search-bar__container .search__form .glyphicon-refresh-animate{color:#000;right:33px;top:15px}.search-bar__container .search__form .form-control{border-radius:3px;background:#fff;border:none;color:rgba(0,0,0,.5);padding:0 10px 0 31px}.sidebar--menu{-webkit-transition:-webkit-transform .5s ease;-webkit-transition-delay:0s;transition:transform .5s ease false;-webkit-transform:translate3d(290px,0,0);transform:translate3d(290px,0,0);border:none;display:block;width:290px}.sidebar--menu.move--left{-webkit-transform:translateZ(0);transform:translateZ(0)}.sidebar--left{-webkit-transition:-webkit-transform .5s ease;-webkit-transition-delay:0s;transition:transform .5s ease false;-webkit-transform:translate3d(-290px,0,0);transform:translate3d(-290px,0,0);width:290px;border:none}.sidebar--left.sidebar--padded{padding-top:0}.sidebar--left.move--right{-webkit-transform:translateZ(0);transform:translateZ(0)}.sidebar--left>div{padding-bottom:70px}.sidebar--left .nav-pills__unread-indicator-bottom{bottom:10px}.sidebar--left .badge{top:13px}.sidebar--left .team__header{overflow:hidden;*zoom:1;pointer-events:none}.sidebar--left .team__header .user__name{display:none}.sidebar--left .team__header .team__name{margin:10px 0}.sidebar--left .team__header .navbar-right{display:none}.sidebar--left .search__form{display:block}.sidebar--left .nav li.dropdown.open{padding-bottom:25px}.sidebar--left .nav li.dropdown.open ul{clear:both;background:#fff;border-radius:3px;top:5px;position:relative}.sidebar--left .nav li.dropdown.open ul li a{line-height:30px}.sidebar--left .nav li h4{margin:16px 0 8px}.sidebar--left .nav li>a{font-size:15px;margin:0;line-height:2.5}.sidebar--left .nav li>a:focus,.sidebar--left .nav li>a:hover{background:transparent}.sidebar--left .nav li>a.has-close .btn-close{width:40px;text-align:center;right:0;display:block;filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=50);opacity:.5}.sidebar--right{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);right:0;width:100%;z-index:5}.sidebar--right .sidebar__collapse,.sidebar--right .sidebar__search-icon{display:block}.sidebar--right .sidebar--right__close{display:none}.search-items-container,.sidebar--right .sidebar-right__body{height:calc(100% - 44px)}.inner-wrap{-webkit-transition:all .5s ease;-webkit-transition-delay:0s;transition:all .5s ease false}.app__body .inner-wrap:before{background-color:transparent;content:'';height:100%;left:-15px;position:absolute;top:0;transition:background-color .5s ease,z-index 0s ease .5s;width:calc(100% + 30px);z-index:0}.inner-wrap.move--right{-webkit-transform:translate3d(290px,0,0);transform:translate3d(290px,0,0)}.inner-wrap.move--right:before{background-color:rgba(0,0,0,.4);transition:background-color .5s ease;z-index:9999}.inner-wrap.move--left-small{-webkit-transform:translate3d(-290px,0,0);transform:translate3d(-290px,0,0)}.inner-wrap.move--left-small:before{background-color:rgba(0,0,0,.4);transition:background-color .5s ease;z-index:9999}.inner-wrap.move--left{margin:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.integration-option{height:auto;margin-left:0;width:100%}.app__content{margin:0}.app__content,.channel__wrap .app__content{padding-top:45px}.app__content #channel-header{display:none}.channel__wrap .row.header{display:block}.post-comments{padding:9px 21px 10px 10px!important}}@media screen and (max-width:640px){.app__body .modal .about-modal .about-modal__content{display:block}.app__body .modal .about-modal .about-modal__hash p{word-break:break-all}.app__body .modal .about-modal .about-modal__hash p:first-child{float:none}.app__body .modal .about-modal .about-modal__logo{float:none;padding:0;text-align:center;width:100%}.app__body .modal .about-modal .about-modal__logo svg{height:100px;width:100px}.app__body .modal .about-modal .about-modal__logo+div{padding:2em 0 0}.access-history__table>div{display:block}.access-history__table .access__report{margin:0 0 15px 15px}.access-history__table .access__date div{margin-bottom:15px}.activity-log__table>div{display:block}.activity-log__table .activity-log__report{width:100%}.activity-log__table .activity-log__action{margin-top:10px;text-align:left}}@media screen and (max-width:480px){.backstage-header h1{float:none;margin-bottom:15px}.backstage-header .add-integrations-link{float:none}.backstage-list__item{display:block}.backstage-list__item .actions,.backstage-list__item .item-actions{margin-top:15px;padding:0}.app__body .modal .settings-modal.display--content .modal-body{max-height:90%}.app__body .modal .settings-modal .modal-body{max-height:70%}.app__body .modal .settings-modal .settings-table .security-links{display:block;margin-bottom:10px}.app__body .modal .settings-modal .settings-table .security-links:last-child{margin-bottom:0}.tip-overlay.tip-overlay--sidebar{min-height:350px}.member-div{padding:8px 0}.member-div .member-drop,.member-div .member-role{margin:0 0 0 44px;padding:5px 0;position:relative;right:0;top:0}.member-div .open>.dropdown-menu{left:0;right:auto}.sidebar--left{-webkit-transform:translate3d(-260px,0,0);transform:translate3d(-260px,0,0);width:260px}.inner-wrap.move--right{-webkit-transform:translate3d(260px,0,0);transform:translate3d(260px,0,0)}}@media screen and (max-height:640px){.signup-team__container{padding:30px 0;margin-bottom:30px;font-size:.9em}.signup-team__container .signup-team__name{font-size:2em}}", ""]);
	
	// exports


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, "@font-face{font-family:Open Sans;font-style:normal;font-weight:300;src:url(" + __webpack_require__(416) + ");src:local('Open Sans Light'),local('OpenSans-Light'),url(" + __webpack_require__(416) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(947) + ") format('woff2'),url(" + __webpack_require__(946) + ") format('woff'),url(" + __webpack_require__(945) + ") format('truetype'),url(" + __webpack_require__(944) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:italic;font-weight:300;src:url(" + __webpack_require__(417) + ");src:local('Open Sans Light Italic'),local('OpenSansLight-Italic'),url(" + __webpack_require__(417) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(951) + ") format('woff2'),url(" + __webpack_require__(950) + ") format('woff'),url(" + __webpack_require__(949) + ") format('truetype'),url(" + __webpack_require__(948) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:normal;font-weight:400;src:url(" + __webpack_require__(425) + ");src:local('Open Sans'),local('OpenSans'),url(" + __webpack_require__(425) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(983) + ") format('woff2'),url(" + __webpack_require__(982) + ") format('woff'),url(" + __webpack_require__(981) + ") format('truetype'),url(" + __webpack_require__(980) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:italic;font-weight:400;src:url(" + __webpack_require__(424) + ");src:local('Open Sans Italic'),local('OpenSans-Italic'),url(" + __webpack_require__(424) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(979) + ") format('woff2'),url(" + __webpack_require__(978) + ") format('woff'),url(" + __webpack_require__(977) + ") format('truetype'),url(" + __webpack_require__(976) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:normal;font-weight:600;src:url(" + __webpack_require__(418) + ");src:local('Open Sans Semibold'),local('OpenSans-Semibold'),url(" + __webpack_require__(418) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(955) + ") format('woff2'),url(" + __webpack_require__(954) + ") format('woff'),url(" + __webpack_require__(953) + ") format('truetype'),url(" + __webpack_require__(952) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:italic;font-weight:600;src:url(" + __webpack_require__(419) + ");src:local('Open Sans Semibold Italic'),local('OpenSans-SemiboldItalic'),url(" + __webpack_require__(419) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(959) + ") format('woff2'),url(" + __webpack_require__(958) + ") format('woff'),url(" + __webpack_require__(957) + ") format('truetype'),url(" + __webpack_require__(956) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:normal;font-weight:700;src:url(" + __webpack_require__(420) + ");src:local('Open Sans Bold'),local('OpenSans-Bold'),url(" + __webpack_require__(420) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(963) + ") format('woff2'),url(" + __webpack_require__(962) + ") format('woff'),url(" + __webpack_require__(961) + ") format('truetype'),url(" + __webpack_require__(960) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:italic;font-weight:700;src:url(" + __webpack_require__(421) + ");src:local('Open Sans Bold Italic'),local('OpenSans-BoldItalic'),url(" + __webpack_require__(421) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(967) + ") format('woff2'),url(" + __webpack_require__(966) + ") format('woff'),url(" + __webpack_require__(965) + ") format('truetype'),url(" + __webpack_require__(964) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:normal;font-weight:800;src:url(" + __webpack_require__(422) + ");src:local('Open Sans Extrabold'),local('OpenSans-Extrabold'),url(" + __webpack_require__(422) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(971) + ") format('woff2'),url(" + __webpack_require__(970) + ") format('woff'),url(" + __webpack_require__(969) + ") format('truetype'),url(" + __webpack_require__(968) + "#OpenSans) format('svg')}@font-face{font-family:Open Sans;font-style:italic;font-weight:800;src:url(" + __webpack_require__(423) + ");src:local('Open Sans Extrabold Italic'),local('OpenSans-ExtraboldItalic'),url(" + __webpack_require__(423) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(975) + ") format('woff2'),url(" + __webpack_require__(974) + ") format('woff'),url(" + __webpack_require__(973) + ") format('truetype'),url(" + __webpack_require__(972) + "#OpenSans) format('svg')}@font-face{font-family:Lato;font-weight:400;font-style:normal;src:url(" + __webpack_require__(394) + ");src:local('Lato Regular'),local('Lato-regular'),url(" + __webpack_require__(394) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(859) + ") format('woff2'),url(" + __webpack_require__(858) + ") format('woff'),url(" + __webpack_require__(857) + ") format('truetype'),url(" + __webpack_require__(856) + "#Lato) format('svg')}@font-face{font-family:Lato;font-weight:400;font-style:italic;src:url(" + __webpack_require__(412) + ");src:url(" + __webpack_require__(412) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(931) + ") format('woff2'),url(" + __webpack_require__(930) + ") format('woff'),url(" + __webpack_require__(929) + ") format('truetype'),url(" + __webpack_require__(928) + "#latoitalic) format('svg')}@font-face{font-family:Lato;font-style:normal;font-weight:700;src:url(" + __webpack_require__(410) + ");src:url(" + __webpack_require__(410) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(923) + ") format('woff2'),url(" + __webpack_require__(922) + ") format('woff'),url(" + __webpack_require__(921) + ") format('truetype'),url(" + __webpack_require__(920) + "#latobold) format('svg')}@font-face{font-family:Lato;font-style:italic;font-weight:700;src:url(" + __webpack_require__(411) + ");src:url(" + __webpack_require__(411) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(927) + ") format('woff2'),url(" + __webpack_require__(926) + ") format('woff'),url(" + __webpack_require__(925) + ") format('truetype'),url(" + __webpack_require__(924) + "#latobold_italic) format('svg')}@font-face{font-family:Droid Serif;font-weight:400;font-style:normal;src:url(" + __webpack_require__(392) + ");src:local('Droid Serif'),local('Droid-Serif-regular'),url(" + __webpack_require__(392) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(851) + ") format('woff2'),url(" + __webpack_require__(850) + ") format('woff'),url(" + __webpack_require__(849) + ") format('truetype'),url(" + __webpack_require__(848) + "#DroidSerif) format('svg')}@font-face{font-family:Droid Serif;font-weight:400;font-style:italic;src:url(" + __webpack_require__(406) + ");src:url(" + __webpack_require__(406) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(907) + ") format('woff2'),url(" + __webpack_require__(906) + ") format('woff'),url(" + __webpack_require__(905) + ") format('truetype'),url(" + __webpack_require__(904) + "#droid_serifitalic) format('svg')}@font-face{font-family:Droid Serif;font-weight:700;font-style:normal;src:url(" + __webpack_require__(404) + ");src:url(" + __webpack_require__(404) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(899) + ") format('woff2'),url(" + __webpack_require__(898) + ") format('woff'),url(" + __webpack_require__(897) + ") format('truetype'),url(" + __webpack_require__(896) + "#droid_serifbold) format('svg')}@font-face{font-family:Droid Serif;font-weight:700;font-style:italic;src:url(" + __webpack_require__(405) + ");src:url(" + __webpack_require__(405) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(903) + ") format('woff2'),url(" + __webpack_require__(902) + ") format('woff'),url(" + __webpack_require__(901) + ") format('truetype'),url(" + __webpack_require__(900) + "#droid_serifbold_italic) format('svg')}@font-face{font-family:Lora;font-weight:400;font-style:normal;src:url(" + __webpack_require__(395) + ");src:local('Lora'),local('Lora-regular'),url(" + __webpack_require__(395) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(863) + ") format('woff2'),url(" + __webpack_require__(862) + ") format('woff'),url(" + __webpack_require__(861) + ") format('truetype'),url(" + __webpack_require__(860) + "#Lora) format('svg')}@font-face{font-family:Lora;font-weight:400;font-style:italic;src:url(" + __webpack_require__(415) + ");src:url(" + __webpack_require__(415) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(943) + ") format('woff2'),url(" + __webpack_require__(942) + ") format('woff'),url(" + __webpack_require__(941) + ") format('truetype'),url(" + __webpack_require__(940) + "#loraitalic) format('svg')}@font-face{font-family:Lora;font-weight:700;font-style:normal;src:url(" + __webpack_require__(413) + ");src:url(" + __webpack_require__(413) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(935) + ") format('woff2'),url(" + __webpack_require__(934) + ") format('woff'),url(" + __webpack_require__(933) + ") format('truetype'),url(" + __webpack_require__(932) + "#lorabold) format('svg')}@font-face{font-family:Lora;font-weight:700;font-style:italic;src:url(" + __webpack_require__(414) + ");src:url(" + __webpack_require__(414) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(939) + ") format('woff2'),url(" + __webpack_require__(938) + ") format('woff'),url(" + __webpack_require__(937) + ") format('truetype'),url(" + __webpack_require__(936) + "#lorabold_italic) format('svg')}@font-face{font-family:Arvo;font-weight:400;font-style:normal;src:url(" + __webpack_require__(391) + ");src:local('Arvo'),local('Arvo-regular'),url(" + __webpack_require__(391) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(847) + ") format('woff2'),url(" + __webpack_require__(846) + ") format('woff'),url(" + __webpack_require__(845) + ") format('truetype'),url(" + __webpack_require__(844) + "#Arvo) format('svg')}@font-face{font-family:Arvo;font-weight:400;font-style:italic;src:url(" + __webpack_require__(403) + ");src:url(" + __webpack_require__(403) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(895) + ") format('woff2'),url(" + __webpack_require__(894) + ") format('woff'),url(" + __webpack_require__(893) + ") format('truetype'),url(" + __webpack_require__(892) + "#arvoitalic) format('svg')}@font-face{font-family:Arvo;font-weight:700;font-style:normal;src:url(" + __webpack_require__(401) + ");src:url(" + __webpack_require__(401) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(887) + ") format('woff2'),url(" + __webpack_require__(886) + ") format('woff'),url(" + __webpack_require__(885) + ") format('truetype'),url(" + __webpack_require__(884) + "#arvobold) format('svg')}@font-face{font-family:Arvo;font-weight:700;font-style:italic;src:url(" + __webpack_require__(402) + ");src:url(" + __webpack_require__(402) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(891) + ") format('woff2'),url(" + __webpack_require__(890) + ") format('woff'),url(" + __webpack_require__(889) + ") format('truetype'),url(" + __webpack_require__(888) + "#arvobold_italic) format('svg')}@font-face{font-family:Roboto;font-weight:400;font-style:normal;src:url(" + __webpack_require__(398) + ");src:local('Roboto'),local('Roboto-regular'),url(" + __webpack_require__(398) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(875) + ") format('woff2'),url(" + __webpack_require__(874) + ") format('woff'),url(" + __webpack_require__(873) + ") format('truetype'),url(" + __webpack_require__(872) + "#Roboto) format('svg')}@font-face{font-family:Roboto;font-weight:400;font-style:italic;src:url(" + __webpack_require__(431) + ");src:url(" + __webpack_require__(431) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1007) + ") format('woff2'),url(" + __webpack_require__(1006) + ") format('woff'),url(" + __webpack_require__(1005) + ") format('truetype'),url(" + __webpack_require__(1004) + "#robotoitalic) format('svg')}@font-face{font-family:Roboto;font-weight:700;font-style:normal;src:url(" + __webpack_require__(429) + ");src:url(" + __webpack_require__(429) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(999) + ") format('woff2'),url(" + __webpack_require__(998) + ") format('woff'),url(" + __webpack_require__(997) + ") format('truetype'),url(" + __webpack_require__(996) + "#robotobold) format('svg')}@font-face{font-family:Roboto;font-weight:700;font-style:italic;src:url(" + __webpack_require__(430) + ");src:url(" + __webpack_require__(430) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1003) + ") format('woff2'),url(" + __webpack_require__(1002) + ") format('woff'),url(" + __webpack_require__(1001) + ") format('truetype'),url(" + __webpack_require__(1000) + "#robotobold_italic) format('svg')}@font-face{font-family:PT Sans;font-weight:400;font-style:normal;src:url(" + __webpack_require__(396) + ");src:local('PT Sans'),local('PT-Sans-regular'),url(" + __webpack_require__(396) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(867) + ") format('woff2'),url(" + __webpack_require__(866) + ") format('woff'),url(" + __webpack_require__(865) + ") format('truetype'),url(" + __webpack_require__(864) + "#PTSans) format('svg')}@font-face{font-family:PT Sans;font-weight:400;font-style:italic;src:url(" + __webpack_require__(428) + ");src:url(" + __webpack_require__(428) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(995) + ") format('woff2'),url(" + __webpack_require__(994) + ") format('woff'),url(" + __webpack_require__(993) + ") format('truetype'),url(" + __webpack_require__(992) + "#pt_sansitalic) format('svg')}@font-face{font-family:PT Sans;font-weight:700;font-style:normal;src:url(" + __webpack_require__(426) + ");src:url(" + __webpack_require__(426) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(987) + ") format('woff2'),url(" + __webpack_require__(986) + ") format('woff'),url(" + __webpack_require__(985) + ") format('truetype'),url(" + __webpack_require__(984) + "#pt_sansbold) format('svg')}@font-face{font-family:PT Sans;font-weight:700;font-style:italic;src:url(" + __webpack_require__(427) + ");src:url(" + __webpack_require__(427) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(991) + ") format('woff2'),url(" + __webpack_require__(990) + ") format('woff'),url(" + __webpack_require__(989) + ") format('truetype'),url(" + __webpack_require__(988) + "#pt_sansbold_italic) format('svg')}@font-face{font-family:Source Sans Pro;font-weight:400;font-style:normal;src:url(" + __webpack_require__(399) + ");src:local('Source Sans Pro'),local('Source-Sans-Pro-regular'),url(" + __webpack_require__(399) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(879) + ") format('woff2'),url(" + __webpack_require__(878) + ") format('woff'),url(" + __webpack_require__(877) + ") format('truetype'),url(" + __webpack_require__(876) + "#SourceSansPro) format('svg')}@font-face{font-family:Source Sans Pro;font-weight:400;font-style:italic;src:url(" + __webpack_require__(435) + ");src:url(" + __webpack_require__(435) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1023) + ") format('woff2'),url(" + __webpack_require__(1022) + ") format('woff'),url(" + __webpack_require__(1021) + ") format('truetype'),url(" + __webpack_require__(1020) + "#source_sans_proitalic) format('svg')}@font-face{font-family:Source Sans Pro;font-weight:700;font-style:normal;src:url(" + __webpack_require__(433) + ");src:url(" + __webpack_require__(433) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1015) + ") format('woff2'),url(" + __webpack_require__(1014) + ") format('woff'),url(" + __webpack_require__(1013) + ") format('truetype'),url(" + __webpack_require__(1012) + "#source_sans_probold) format('svg')}@font-face{font-family:Source Sans Pro;font-weight:700;font-style:italic;src:url(" + __webpack_require__(434) + ");src:url(" + __webpack_require__(434) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1019) + ") format('woff2'),url(" + __webpack_require__(1018) + ") format('woff'),url(" + __webpack_require__(1017) + ") format('truetype'),url(" + __webpack_require__(1016) + "#source_sans_probold_italic) format('svg')}@font-face{font-family:Exo\\ 2;font-weight:400;font-style:normal;src:url(" + __webpack_require__(393) + ");src:local('Exo 2'),local('Exo-2-regular'),url(" + __webpack_require__(393) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(855) + ") format('woff2'),url(" + __webpack_require__(854) + ") format('woff'),url(" + __webpack_require__(853) + ") format('truetype'),url(" + __webpack_require__(852) + "#Exo2) format('svg')}@font-face{font-family:Exo\\ 2;font-weight:400;font-style:italic;src:url(" + __webpack_require__(409) + ");src:url(" + __webpack_require__(409) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(919) + ") format('woff2'),url(" + __webpack_require__(918) + ") format('woff'),url(" + __webpack_require__(917) + ") format('truetype'),url(" + __webpack_require__(916) + "#exo_2italic) format('svg')}@font-face{font-family:Exo\\ 2;font-weight:700;font-style:normal;src:url(" + __webpack_require__(407) + ");src:url(" + __webpack_require__(407) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(911) + ") format('woff2'),url(" + __webpack_require__(910) + ") format('woff'),url(" + __webpack_require__(909) + ") format('truetype'),url(" + __webpack_require__(908) + "#exo_2bold) format('svg')}@font-face{font-family:Exo\\ 2;font-weight:700;font-style:italic;src:url(" + __webpack_require__(408) + ");src:url(" + __webpack_require__(408) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(915) + ") format('woff2'),url(" + __webpack_require__(914) + ") format('woff'),url(" + __webpack_require__(913) + ") format('truetype'),url(" + __webpack_require__(912) + "#exo_2bold_italic) format('svg')}@font-face{font-family:Ubuntu;font-weight:400;font-style:normal;src:url(" + __webpack_require__(400) + ");src:local('Ubuntu'),local('Ubuntu-regular'),url(" + __webpack_require__(400) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(883) + ") format('woff2'),url(" + __webpack_require__(882) + ") format('woff'),url(" + __webpack_require__(881) + ") format('truetype'),url(" + __webpack_require__(880) + "#Ubuntu) format('svg')}@font-face{font-family:Ubuntu;font-weight:400;font-style:italic;src:url(" + __webpack_require__(438) + ");src:url(" + __webpack_require__(438) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1035) + ") format('woff2'),url(" + __webpack_require__(1034) + ") format('woff'),url(" + __webpack_require__(1033) + ") format('truetype'),url(" + __webpack_require__(1032) + "#ubuntuitalic) format('svg')}@font-face{font-family:Ubuntu;font-weight:700;font-style:normal;src:url(" + __webpack_require__(436) + ");src:url(" + __webpack_require__(436) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1027) + ") format('woff2'),url(" + __webpack_require__(1026) + ") format('woff'),url(" + __webpack_require__(1025) + ") format('truetype'),url(" + __webpack_require__(1024) + "#ubuntubold) format('svg')}@font-face{font-family:Ubuntu;font-weight:700;font-style:italic;src:url(" + __webpack_require__(437) + ");src:url(" + __webpack_require__(437) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1031) + ") format('woff2'),url(" + __webpack_require__(1030) + ") format('woff'),url(" + __webpack_require__(1029) + ") format('truetype'),url(" + __webpack_require__(1028) + "#ubuntubold_italic) format('svg')}@font-face{font-family:Roboto Slab;font-weight:400;font-style:normal;src:url(" + __webpack_require__(397) + ");src:local('Roboto Slab Regular'),local('Roboto-Slab-regular'),url(" + __webpack_require__(397) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(871) + ") format('woff2'),url(" + __webpack_require__(870) + ") format('woff'),url(" + __webpack_require__(869) + ") format('truetype'),url(" + __webpack_require__(868) + "#RobotoSlab) format('svg')}@font-face{font-family:Roboto Slab;font-weight:700;font-style:normal;src:url(" + __webpack_require__(432) + ");src:url(" + __webpack_require__(432) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(1011) + ") format('woff2'),url(" + __webpack_require__(1010) + ") format('woff'),url(" + __webpack_require__(1009) + ") format('truetype'),url(" + __webpack_require__(1008) + "#roboto_slabbold) format('svg')}.app__body.font--open_sans{font-family:Open Sans,'sans-serif'}.app__body.font--droid_serif{font-family:Droid Serif,'serif'}.app__body.font--roboto_slab{font-family:Roboto Slab,'serif'}.app__body.font--lora{font-family:Lora,'serif'}.app__body.font--arvo{font-family:Arvo,'serif'}.app__body.font--roboto{font-family:Roboto,'sans-serif'}.app__body.font--pt_sans{font-family:PT Sans,'sans-serif'}.app__body.font--lato{font-family:Lato,'sans-serif'}.app__body.font--source_sans_pro{font-family:Source Sans Pro,'sans-serif'}.app__body.font--exo_2{font-family:Exo\\ 2,'sans-serif'}.app__body.font--ubuntu{font-family:Ubuntu,'sans-serif'}", ""]);
	
	// exports


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.e = __webpack_require__(103)();
	// imports
	
	
	// module
	exports.push([module.i, "@font-face{font-family:KaTeX_AMS;src:url(" + __webpack_require__(439) + ");src:url(" + __webpack_require__(439) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1038) + ") format('woff2'),url(" + __webpack_require__(1037) + ") format('woff'),url(" + __webpack_require__(1036) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Caligraphic;src:url(" + __webpack_require__(440) + ");src:url(" + __webpack_require__(440) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1041) + ") format('woff2'),url(" + __webpack_require__(1040) + ") format('woff'),url(" + __webpack_require__(1039) + ") format('ttf');font-weight:700;font-style:normal}@font-face{font-family:KaTeX_Caligraphic;src:url(" + __webpack_require__(441) + ");src:url(" + __webpack_require__(441) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1044) + ") format('woff2'),url(" + __webpack_require__(1043) + ") format('woff'),url(" + __webpack_require__(1042) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Fraktur;src:url(" + __webpack_require__(442) + ");src:url(" + __webpack_require__(442) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1047) + ") format('woff2'),url(" + __webpack_require__(1046) + ") format('woff'),url(" + __webpack_require__(1045) + ") format('ttf');font-weight:700;font-style:normal}@font-face{font-family:KaTeX_Fraktur;src:url(" + __webpack_require__(443) + ");src:url(" + __webpack_require__(443) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1050) + ") format('woff2'),url(" + __webpack_require__(1049) + ") format('woff'),url(" + __webpack_require__(1048) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Main;src:url(" + __webpack_require__(444) + ");src:url(" + __webpack_require__(444) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1053) + ") format('woff2'),url(" + __webpack_require__(1052) + ") format('woff'),url(" + __webpack_require__(1051) + ") format('ttf');font-weight:700;font-style:normal}@font-face{font-family:KaTeX_Main;src:url(" + __webpack_require__(445) + ");src:url(" + __webpack_require__(445) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1056) + ") format('woff2'),url(" + __webpack_require__(1055) + ") format('woff'),url(" + __webpack_require__(1054) + ") format('ttf');font-weight:400;font-style:italic}@font-face{font-family:KaTeX_Main;src:url(" + __webpack_require__(446) + ");src:url(" + __webpack_require__(446) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1059) + ") format('woff2'),url(" + __webpack_require__(1058) + ") format('woff'),url(" + __webpack_require__(1057) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Math;src:url(" + __webpack_require__(447) + ");src:url(" + __webpack_require__(447) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1062) + ") format('woff2'),url(" + __webpack_require__(1061) + ") format('woff'),url(" + __webpack_require__(1060) + ") format('ttf');font-weight:400;font-style:italic}@font-face{font-family:KaTeX_SansSerif;src:url(" + __webpack_require__(448) + ");src:url(" + __webpack_require__(448) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1065) + ") format('woff2'),url(" + __webpack_require__(1064) + ") format('woff'),url(" + __webpack_require__(1063) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Script;src:url(" + __webpack_require__(449) + ");src:url(" + __webpack_require__(449) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1068) + ") format('woff2'),url(" + __webpack_require__(1067) + ") format('woff'),url(" + __webpack_require__(1066) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size1;src:url(" + __webpack_require__(450) + ");src:url(" + __webpack_require__(450) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1071) + ") format('woff2'),url(" + __webpack_require__(1070) + ") format('woff'),url(" + __webpack_require__(1069) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size2;src:url(" + __webpack_require__(451) + ");src:url(" + __webpack_require__(451) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1074) + ") format('woff2'),url(" + __webpack_require__(1073) + ") format('woff'),url(" + __webpack_require__(1072) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size3;src:url(" + __webpack_require__(452) + ");src:url(" + __webpack_require__(452) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1077) + ") format('woff2'),url(" + __webpack_require__(1076) + ") format('woff'),url(" + __webpack_require__(1075) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Size4;src:url(" + __webpack_require__(453) + ");src:url(" + __webpack_require__(453) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1080) + ") format('woff2'),url(" + __webpack_require__(1079) + ") format('woff'),url(" + __webpack_require__(1078) + ") format('ttf');font-weight:400;font-style:normal}@font-face{font-family:KaTeX_Typewriter;src:url(" + __webpack_require__(454) + ");src:url(" + __webpack_require__(454) + "#iefix) format('embedded-opentype'),url(" + __webpack_require__(1083) + ") format('woff2'),url(" + __webpack_require__(1082) + ") format('woff'),url(" + __webpack_require__(1081) + ") format('ttf');font-weight:400;font-style:normal}.katex-display{display:block;margin:1em 0;text-align:center}.katex-display>.katex{display:inline-block;text-align:initial}.katex{font:400 1.21em KaTeX_Main;line-height:1.2;white-space:nowrap;text-indent:0}.katex .katex-html{display:inline-block}.katex .katex-mathml{position:absolute;clip:rect(1px,1px,1px,1px);padding:0;border:0;height:1px;width:1px;overflow:hidden}.katex .base,.katex .strut{display:inline-block}.katex .mathit{font-family:KaTeX_Math;font-style:italic}.katex .mathbf{font-family:KaTeX_Main;font-weight:700}.katex .amsrm,.katex .mathbb{font-family:KaTeX_AMS}.katex .mathcal{font-family:KaTeX_Caligraphic}.katex .mathfrak{font-family:KaTeX_Fraktur}.katex .mathtt{font-family:KaTeX_Typewriter}.katex .mathscr{font-family:KaTeX_Script}.katex .mathsf{font-family:KaTeX_SansSerif}.katex .mainit{font-family:KaTeX_Main;font-style:italic}.katex .textstyle>.mord+.mop{margin-left:.16667em}.katex .textstyle>.mord+.mbin{margin-left:.22222em}.katex .textstyle>.mord+.mrel{margin-left:.27778em}.katex .textstyle>.mop+.mop,.katex .textstyle>.mop+.mord,.katex .textstyle>.mord+.minner{margin-left:.16667em}.katex .textstyle>.mop+.mrel{margin-left:.27778em}.katex .textstyle>.mop+.minner{margin-left:.16667em}.katex .textstyle>.mbin+.minner,.katex .textstyle>.mbin+.mop,.katex .textstyle>.mbin+.mopen,.katex .textstyle>.mbin+.mord{margin-left:.22222em}.katex .textstyle>.mrel+.minner,.katex .textstyle>.mrel+.mop,.katex .textstyle>.mrel+.mopen,.katex .textstyle>.mrel+.mord{margin-left:.27778em}.katex .textstyle>.mclose+.mop{margin-left:.16667em}.katex .textstyle>.mclose+.mbin{margin-left:.22222em}.katex .textstyle>.mclose+.mrel{margin-left:.27778em}.katex .textstyle>.mclose+.minner,.katex .textstyle>.minner+.mop,.katex .textstyle>.minner+.mord,.katex .textstyle>.mpunct+.mclose,.katex .textstyle>.mpunct+.minner,.katex .textstyle>.mpunct+.mop,.katex .textstyle>.mpunct+.mopen,.katex .textstyle>.mpunct+.mord,.katex .textstyle>.mpunct+.mpunct,.katex .textstyle>.mpunct+.mrel{margin-left:.16667em}.katex .textstyle>.minner+.mbin{margin-left:.22222em}.katex .textstyle>.minner+.mrel{margin-left:.27778em}.katex .mclose+.mop,.katex .minner+.mop,.katex .mop+.mop,.katex .mop+.mord,.katex .mord+.mop,.katex .textstyle>.minner+.minner,.katex .textstyle>.minner+.mopen,.katex .textstyle>.minner+.mpunct{margin-left:.16667em}.katex .reset-textstyle.textstyle{font-size:1em}.katex .reset-textstyle.scriptstyle{font-size:.7em}.katex .reset-textstyle.scriptscriptstyle{font-size:.5em}.katex .reset-scriptstyle.textstyle{font-size:1.42857em}.katex .reset-scriptstyle.scriptstyle{font-size:1em}.katex .reset-scriptstyle.scriptscriptstyle{font-size:.71429em}.katex .reset-scriptscriptstyle.textstyle{font-size:2em}.katex .reset-scriptscriptstyle.scriptstyle{font-size:1.4em}.katex .reset-scriptscriptstyle.scriptscriptstyle{font-size:1em}.katex .style-wrap{position:relative}.katex .vlist{display:inline-block}.katex .vlist>span{display:block;height:0;position:relative}.katex .vlist>span>span{display:inline-block}.katex .vlist .baseline-fix{display:inline-table;table-layout:fixed}.katex .msupsub{text-align:left}.katex .mfrac>span>span{text-align:center}.katex .mfrac .frac-line{width:100%}.katex .mfrac .frac-line:before{border-bottom-style:solid;border-bottom-width:1px;content:\"\";display:block}.katex .mfrac .frac-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:\"\";display:block;margin-top:-1px}.katex .mspace{display:inline-block}.katex .mspace.negativethinspace{margin-left:-.16667em}.katex .mspace.thinspace{width:.16667em}.katex .mspace.mediumspace{width:.22222em}.katex .mspace.thickspace{width:.27778em}.katex .mspace.enspace{width:.5em}.katex .mspace.quad{width:1em}.katex .mspace.qquad{width:2em}.katex .llap,.katex .rlap{width:0;position:relative}.katex .llap>.inner,.katex .rlap>.inner{position:absolute}.katex .llap>.fix,.katex .rlap>.fix{display:inline-block}.katex .llap>.inner{right:0}.katex .rlap>.inner{left:0}.katex .katex-logo .a{font-size:.75em;margin-left:-.32em;position:relative;top:-.2em}.katex .katex-logo .t{margin-left:-.23em}.katex .katex-logo .e{margin-left:-.1667em;position:relative;top:.2155em}.katex .katex-logo .x{margin-left:-.125em}.katex .rule{display:inline-block;border:0 solid;position:relative}.katex .overline .overline-line{width:100%}.katex .overline .overline-line:before{border-bottom-style:solid;border-bottom-width:1px;content:\"\";display:block}.katex .overline .overline-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:\"\";display:block;margin-top:-1px}.katex .sqrt>.sqrt-sign{position:relative}.katex .sqrt .sqrt-line{width:100%}.katex .sqrt .sqrt-line:before{border-bottom-style:solid;border-bottom-width:1px;content:\"\";display:block}.katex .sqrt .sqrt-line:after{border-bottom-style:solid;border-bottom-width:.04em;content:\"\";display:block;margin-top:-1px}.katex .sqrt>.root{margin-left:.27777778em;margin-right:-.55555556em}.katex .fontsize-ensurer,.katex .sizing{display:inline-block}.katex .fontsize-ensurer.reset-size1.size1,.katex .sizing.reset-size1.size1{font-size:1em}.katex .fontsize-ensurer.reset-size1.size2,.katex .sizing.reset-size1.size2{font-size:1.4em}.katex .fontsize-ensurer.reset-size1.size3,.katex .sizing.reset-size1.size3{font-size:1.6em}.katex .fontsize-ensurer.reset-size1.size4,.katex .sizing.reset-size1.size4{font-size:1.8em}.katex .fontsize-ensurer.reset-size1.size5,.katex .sizing.reset-size1.size5{font-size:2em}.katex .fontsize-ensurer.reset-size1.size6,.katex .sizing.reset-size1.size6{font-size:2.4em}.katex .fontsize-ensurer.reset-size1.size7,.katex .sizing.reset-size1.size7{font-size:2.88em}.katex .fontsize-ensurer.reset-size1.size8,.katex .sizing.reset-size1.size8{font-size:3.46em}.katex .fontsize-ensurer.reset-size1.size9,.katex .sizing.reset-size1.size9{font-size:4.14em}.katex .fontsize-ensurer.reset-size1.size10,.katex .sizing.reset-size1.size10{font-size:4.98em}.katex .fontsize-ensurer.reset-size2.size1,.katex .sizing.reset-size2.size1{font-size:.71428571em}.katex .fontsize-ensurer.reset-size2.size2,.katex .sizing.reset-size2.size2{font-size:1em}.katex .fontsize-ensurer.reset-size2.size3,.katex .sizing.reset-size2.size3{font-size:1.14285714em}.katex .fontsize-ensurer.reset-size2.size4,.katex .sizing.reset-size2.size4{font-size:1.28571429em}.katex .fontsize-ensurer.reset-size2.size5,.katex .sizing.reset-size2.size5{font-size:1.42857143em}.katex .fontsize-ensurer.reset-size2.size6,.katex .sizing.reset-size2.size6{font-size:1.71428571em}.katex .fontsize-ensurer.reset-size2.size7,.katex .sizing.reset-size2.size7{font-size:2.05714286em}.katex .fontsize-ensurer.reset-size2.size8,.katex .sizing.reset-size2.size8{font-size:2.47142857em}.katex .fontsize-ensurer.reset-size2.size9,.katex .sizing.reset-size2.size9{font-size:2.95714286em}.katex .fontsize-ensurer.reset-size2.size10,.katex .sizing.reset-size2.size10{font-size:3.55714286em}.katex .fontsize-ensurer.reset-size3.size1,.katex .sizing.reset-size3.size1{font-size:.625em}.katex .fontsize-ensurer.reset-size3.size2,.katex .sizing.reset-size3.size2{font-size:.875em}.katex .fontsize-ensurer.reset-size3.size3,.katex .sizing.reset-size3.size3{font-size:1em}.katex .fontsize-ensurer.reset-size3.size4,.katex .sizing.reset-size3.size4{font-size:1.125em}.katex .fontsize-ensurer.reset-size3.size5,.katex .sizing.reset-size3.size5{font-size:1.25em}.katex .fontsize-ensurer.reset-size3.size6,.katex .sizing.reset-size3.size6{font-size:1.5em}.katex .fontsize-ensurer.reset-size3.size7,.katex .sizing.reset-size3.size7{font-size:1.8em}.katex .fontsize-ensurer.reset-size3.size8,.katex .sizing.reset-size3.size8{font-size:2.1625em}.katex .fontsize-ensurer.reset-size3.size9,.katex .sizing.reset-size3.size9{font-size:2.5875em}.katex .fontsize-ensurer.reset-size3.size10,.katex .sizing.reset-size3.size10{font-size:3.1125em}.katex .fontsize-ensurer.reset-size4.size1,.katex .sizing.reset-size4.size1{font-size:.55555556em}.katex .fontsize-ensurer.reset-size4.size2,.katex .sizing.reset-size4.size2{font-size:.77777778em}.katex .fontsize-ensurer.reset-size4.size3,.katex .sizing.reset-size4.size3{font-size:.88888889em}.katex .fontsize-ensurer.reset-size4.size4,.katex .sizing.reset-size4.size4{font-size:1em}.katex .fontsize-ensurer.reset-size4.size5,.katex .sizing.reset-size4.size5{font-size:1.11111111em}.katex .fontsize-ensurer.reset-size4.size6,.katex .sizing.reset-size4.size6{font-size:1.33333333em}.katex .fontsize-ensurer.reset-size4.size7,.katex .sizing.reset-size4.size7{font-size:1.6em}.katex .fontsize-ensurer.reset-size4.size8,.katex .sizing.reset-size4.size8{font-size:1.92222222em}.katex .fontsize-ensurer.reset-size4.size9,.katex .sizing.reset-size4.size9{font-size:2.3em}.katex .fontsize-ensurer.reset-size4.size10,.katex .sizing.reset-size4.size10{font-size:2.76666667em}.katex .fontsize-ensurer.reset-size5.size1,.katex .sizing.reset-size5.size1{font-size:.5em}.katex .fontsize-ensurer.reset-size5.size2,.katex .sizing.reset-size5.size2{font-size:.7em}.katex .fontsize-ensurer.reset-size5.size3,.katex .sizing.reset-size5.size3{font-size:.8em}.katex .fontsize-ensurer.reset-size5.size4,.katex .sizing.reset-size5.size4{font-size:.9em}.katex .fontsize-ensurer.reset-size5.size5,.katex .sizing.reset-size5.size5{font-size:1em}.katex .fontsize-ensurer.reset-size5.size6,.katex .sizing.reset-size5.size6{font-size:1.2em}.katex .fontsize-ensurer.reset-size5.size7,.katex .sizing.reset-size5.size7{font-size:1.44em}.katex .fontsize-ensurer.reset-size5.size8,.katex .sizing.reset-size5.size8{font-size:1.73em}.katex .fontsize-ensurer.reset-size5.size9,.katex .sizing.reset-size5.size9{font-size:2.07em}.katex .fontsize-ensurer.reset-size5.size10,.katex .sizing.reset-size5.size10{font-size:2.49em}.katex .fontsize-ensurer.reset-size6.size1,.katex .sizing.reset-size6.size1{font-size:.41666667em}.katex .fontsize-ensurer.reset-size6.size2,.katex .sizing.reset-size6.size2{font-size:.58333333em}.katex .fontsize-ensurer.reset-size6.size3,.katex .sizing.reset-size6.size3{font-size:.66666667em}.katex .fontsize-ensurer.reset-size6.size4,.katex .sizing.reset-size6.size4{font-size:.75em}.katex .fontsize-ensurer.reset-size6.size5,.katex .sizing.reset-size6.size5{font-size:.83333333em}.katex .fontsize-ensurer.reset-size6.size6,.katex .sizing.reset-size6.size6{font-size:1em}.katex .fontsize-ensurer.reset-size6.size7,.katex .sizing.reset-size6.size7{font-size:1.2em}.katex .fontsize-ensurer.reset-size6.size8,.katex .sizing.reset-size6.size8{font-size:1.44166667em}.katex .fontsize-ensurer.reset-size6.size9,.katex .sizing.reset-size6.size9{font-size:1.725em}.katex .fontsize-ensurer.reset-size6.size10,.katex .sizing.reset-size6.size10{font-size:2.075em}.katex .fontsize-ensurer.reset-size7.size1,.katex .sizing.reset-size7.size1{font-size:.34722222em}.katex .fontsize-ensurer.reset-size7.size2,.katex .sizing.reset-size7.size2{font-size:.48611111em}.katex .fontsize-ensurer.reset-size7.size3,.katex .sizing.reset-size7.size3{font-size:.55555556em}.katex .fontsize-ensurer.reset-size7.size4,.katex .sizing.reset-size7.size4{font-size:.625em}.katex .fontsize-ensurer.reset-size7.size5,.katex .sizing.reset-size7.size5{font-size:.69444444em}.katex .fontsize-ensurer.reset-size7.size6,.katex .sizing.reset-size7.size6{font-size:.83333333em}.katex .fontsize-ensurer.reset-size7.size7,.katex .sizing.reset-size7.size7{font-size:1em}.katex .fontsize-ensurer.reset-size7.size8,.katex .sizing.reset-size7.size8{font-size:1.20138889em}.katex .fontsize-ensurer.reset-size7.size9,.katex .sizing.reset-size7.size9{font-size:1.4375em}.katex .fontsize-ensurer.reset-size7.size10,.katex .sizing.reset-size7.size10{font-size:1.72916667em}.katex .fontsize-ensurer.reset-size8.size1,.katex .sizing.reset-size8.size1{font-size:.28901734em}.katex .fontsize-ensurer.reset-size8.size2,.katex .sizing.reset-size8.size2{font-size:.40462428em}.katex .fontsize-ensurer.reset-size8.size3,.katex .sizing.reset-size8.size3{font-size:.46242775em}.katex .fontsize-ensurer.reset-size8.size4,.katex .sizing.reset-size8.size4{font-size:.52023121em}.katex .fontsize-ensurer.reset-size8.size5,.katex .sizing.reset-size8.size5{font-size:.57803468em}.katex .fontsize-ensurer.reset-size8.size6,.katex .sizing.reset-size8.size6{font-size:.69364162em}.katex .fontsize-ensurer.reset-size8.size7,.katex .sizing.reset-size8.size7{font-size:.83236994em}.katex .fontsize-ensurer.reset-size8.size8,.katex .sizing.reset-size8.size8{font-size:1em}.katex .fontsize-ensurer.reset-size8.size9,.katex .sizing.reset-size8.size9{font-size:1.19653179em}.katex .fontsize-ensurer.reset-size8.size10,.katex .sizing.reset-size8.size10{font-size:1.43930636em}.katex .fontsize-ensurer.reset-size9.size1,.katex .sizing.reset-size9.size1{font-size:.24154589em}.katex .fontsize-ensurer.reset-size9.size2,.katex .sizing.reset-size9.size2{font-size:.33816425em}.katex .fontsize-ensurer.reset-size9.size3,.katex .sizing.reset-size9.size3{font-size:.38647343em}.katex .fontsize-ensurer.reset-size9.size4,.katex .sizing.reset-size9.size4{font-size:.43478261em}.katex .fontsize-ensurer.reset-size9.size5,.katex .sizing.reset-size9.size5{font-size:.48309179em}.katex .fontsize-ensurer.reset-size9.size6,.katex .sizing.reset-size9.size6{font-size:.57971014em}.katex .fontsize-ensurer.reset-size9.size7,.katex .sizing.reset-size9.size7{font-size:.69565217em}.katex .fontsize-ensurer.reset-size9.size8,.katex .sizing.reset-size9.size8{font-size:.83574879em}.katex .fontsize-ensurer.reset-size9.size9,.katex .sizing.reset-size9.size9{font-size:1em}.katex .fontsize-ensurer.reset-size9.size10,.katex .sizing.reset-size9.size10{font-size:1.20289855em}.katex .fontsize-ensurer.reset-size10.size1,.katex .sizing.reset-size10.size1{font-size:.20080321em}.katex .fontsize-ensurer.reset-size10.size2,.katex .sizing.reset-size10.size2{font-size:.2811245em}.katex .fontsize-ensurer.reset-size10.size3,.katex .sizing.reset-size10.size3{font-size:.32128514em}.katex .fontsize-ensurer.reset-size10.size4,.katex .sizing.reset-size10.size4{font-size:.36144578em}.katex .fontsize-ensurer.reset-size10.size5,.katex .sizing.reset-size10.size5{font-size:.40160643em}.katex .fontsize-ensurer.reset-size10.size6,.katex .sizing.reset-size10.size6{font-size:.48192771em}.katex .fontsize-ensurer.reset-size10.size7,.katex .sizing.reset-size10.size7{font-size:.57831325em}.katex .fontsize-ensurer.reset-size10.size8,.katex .sizing.reset-size10.size8{font-size:.69477912em}.katex .fontsize-ensurer.reset-size10.size9,.katex .sizing.reset-size10.size9{font-size:.8313253em}.katex .fontsize-ensurer.reset-size10.size10,.katex .sizing.reset-size10.size10{font-size:1em}.katex .delimsizing.size1{font-family:KaTeX_Size1}.katex .delimsizing.size2{font-family:KaTeX_Size2}.katex .delimsizing.size3{font-family:KaTeX_Size3}.katex .delimsizing.size4{font-family:KaTeX_Size4}.katex .delimsizing.mult .delim-size1>span{font-family:KaTeX_Size1}.katex .delimsizing.mult .delim-size4>span{font-family:KaTeX_Size4}.katex .nulldelimiter{display:inline-block;width:.12em}.katex .op-symbol{position:relative}.katex .op-symbol.small-op{font-family:KaTeX_Size1}.katex .op-symbol.large-op{font-family:KaTeX_Size2}.katex .accent>.vlist>span,.katex .op-limits>.vlist>span{text-align:center}.katex .accent .accent-body>span{width:0}.katex .accent .accent-body.accent-vec>span{position:relative;left:.326em}.katex .mtable .vertical-separator{display:inline-block;margin:0 -.025em;border-right:.05em solid #000}.katex .mtable .arraycolsep{display:inline-block}.katex .mtable .col-align-c>.vlist{text-align:center}.katex .mtable .col-align-l>.vlist{text-align:left}.katex .mtable .col-align-r>.vlist{text-align:right}", ""]);
	
	// exports


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/code_themes/bf6c14925e66edb1526b6c9489b3c042.css";

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/code_themes/ad2b15c2189d3cdedbd68a1668bd1a52.css";

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/code_themes/82ff075b2124d9b007ac4caf40f8d3a9.css";

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/code_themes/5a0ca255fce9de83dde16a0f27d788fe.css";

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "i18n/es.json";

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "i18n/fr.json";

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "i18n/ja.json";

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "i18n/pt.json";

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3812df668bb0144f7ae51853b202315b.mp3";

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/31f48873f1db920ffaa8392fa691489c.png";

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/10ee7f4daf66060a2af9c5eef914b4c8.png";

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/34968cb653551c7689bc4ba6ff198b38.png";

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f3cc4da1ae9371150a3cb56bd469e561.png";

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f78b8bf800e4836d75ce79d947a235c4.png";

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/60f86d6c4bad5436cccc5a11c840cffa.png";

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3bd6cf3a8572f449b570c44dce84c141.png";

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8a0b9aa58d323f8f9b8232c8713a1bb1.png";

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8c3660ab56c20ba9b6247613dac25f75.png";

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/68746b3bb6851d8ffae0782619c48a42.png";

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a10c21ab23e285118a371f522e273d5e.png";

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/31f15875975aab69085470aabbfec802.png";

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/84b76dee6b27b795e89e3649078a11c2.png";

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/46278561af0c5b433188c1620955f3fa.png";

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8aa43f3d86f2b882e53a69b42c08a8d6.png";

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2e6c12717289353fe54c922871edd5d0.png";

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/61b7e84911498a766585c4f0f30286b1.png";

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5420aa17c2d4e734e2483c128d37c5f4.png";

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4d8cfba5f653537e664e7323c378c1ea.png";

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d45c85a1b699c5b615e12fea526abe22.png";

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2c554b007e26c48d995a1afce86f131b.png";

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f89e113dbd8096fa76dd9ecca67ea57c.gif";

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f5a93efd142cd455d2f3d2b6cfa0e17e.gif";

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/58fc83686953e32bce2b1e8d87438abc.png";

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/df1e75c9de8c1b5b68f7144463afdb87.png";

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/de10f7b98e37a57ee81149a71d2c6106.png";

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/512a83ac26d1574e25d742fe81cf531b.png";

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/89889688147bd7575d6327160d64e760.svg";

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/448c34a56d699c29117adc64c43affeb.woff2";

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/32400f4e08932a94d8bfd2422702c446.eot";

/***/ },
/* 839 */
838,
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f775f9cca88e21d45bebe185b27c0e5b.svg";

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a3de2170e4e9df77161ea5d3f31b2668.ttf";

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/db812d8a70a4e88e888744c1c9a27e89.woff2";

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a35720c2fed2c7f043bc7e4ffb45e073.woff";

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c2f16a7697c008e18b3ed60ff7175700.svg";

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b4e6b7907220d9dee4ae33df62d857f9.ttf";

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/aa6046ead6b3601362aa0ca0181c90ec.woff";

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ac6c346562073164218697af1c958b41.woff2";

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/dbdada8a05903efb735499ff8041646c.svg";

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fac81293480e4f9d78a70170fbf4a247.ttf";

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/72630b9c92958cb89d64ff53eea32ed6.woff";

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e927014d4206932acb84fba1539d35b9.woff2";

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8a50ed1854b409cb1ff1f6f59904808f.svg";

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e4de5763f8725a1a7a925619a7463d28.ttf";

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/deaf3cbbf0bc72ac8f31a4ae8ce4d449.woff";

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f4e4df3b50e2e46951a121807128f021.woff2";

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ee3a1c8ce9d9ae2f5373fd4339b83be8.svg";

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c45152a20fcaa8ae5d5611e947399dcc.ttf";

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/692b2ac094cb0b2679dadd8cba568087.woff";

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2fdbf25c9ba247df7b74fbb0137c4bca.woff2";

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/96ef3385b153bf8a229acba1e0b11c86.svg";

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cdc199d94df8c6f619361a11c2572a6f.ttf";

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4ff9d2f033693b9cc7a2b865b726d89b.woff";

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4f7de5e8df3072a0596eb15b52b18c09.woff2";

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8804e999c31b24dd8b6f93573499e9ac.svg";

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/bdaa3af5fac5daaf6c7937297d4093b1.ttf";

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b4f5232f477d5115a1f9068c5795bc51.woff";

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b7921919221261eef6a34af96ee9e0ce.woff2";

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6b8300d4d1a71ca3aaa6829983f51930.svg";

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6df82e44663218e011f03873489c55ce.ttf";

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a6255f721c377c8b015e53b133d9d41d.woff";

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cc0d00cc5090502dd2d40e9d389b676c.woff2";

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3d3a53586bd78d1069ae4b89a3b9aa98.svg";

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/38861cba61c66739c1452c3a71e39852.ttf";

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f94d5e5102359961c44a1da1b58d37c9.woff";

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f84cb1bf9be983133497000554605b4d.woff2";

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a82ffb7d69f509e29239eb879ccae1bc.svg";

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f2d83436dcf3f53375518292e917643c.ttf";

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6b3f2ce73ef8c947a59806ed20fd7983.woff";

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/00bfa19cecc3900646c108e4ac706488.woff2";

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7636fcc7d6938be98c93f966041fe512.svg";

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/725b5e2f8b7e0bfac66edad5c2291b86.ttf";

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/df8a048ddd79927beef259c899afdfa8.woff";

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5ad8c32e52e253d7a798ee15f749c2ef.woff2";

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/12c72cb0c052c87aa9f970bfdae98332.svg";

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/0b13353aa9a371484d5533eb592b2a00.ttf";

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cc62032273590baeb92688b6253c0b40.woff";

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/43771aa476e152cfc85a289c24548078.woff2";

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5a7c131ecba69871990fd45f4441838b.svg";

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/488f84d463293dc2eb5f5c9f32c63ef9.ttf";

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a4f2e9f2207d231d73105934962f68f8.woff";

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/305738de444e252db265b3d67b43631c.woff2";

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f0352a98742d340524e3d801cc4fc4e0.svg";

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5657ceb46ad169c959f4e822ce9d0339.ttf";

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f7f25d7a9cf13e9f7c22813c6469828c.woff";

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/35705ffae1ea0b1e1b40cce71d3c2e34.woff2";

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a1250f756f16a26415785a5cfa98c243.svg";

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/56eccfca8894d9ee17af76a238df8ba1.ttf";

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/472569191124a681943ffe6000d2da83.woff";

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3e3fc789993391c39226c6d1547ac48b.woff2";

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/dbdbad894daaf6b5c74bf81799510258.svg";

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3242e1c7686e5cd82a62a3fc45b0897a.ttf";

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/56e3b5460fe62edf71a95733aa4f1b51.woff";

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e50514828ba5dcf8f009bd4a3a3f6240.woff2";

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/125959bc93b18a90585687796de936ac.svg";

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c68e09d8ed08a656b7f2301f027dd633.ttf";

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/decc436ab86983151d0ca1aad23608b1.woff";

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a9d352b7be98d4a984e1600f26aca943.woff2";

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9d371cdbbc31547290d2fb1556f3b776.svg";

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fd23c7c7d61d0cdd3b99e011d9c4b351.ttf";

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/63118a17527998a97fefdbf75156ddfa.woff";

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4513bf6ac5b7aa7de8c316862b77ed90.woff2";

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/84a567805c43eb7aaa45a875679623be.svg";

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/20cf7f28a52fb3560694989e49fff18d.ttf";

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d5e0f00c53ed07c71009edbe0969ea6a.woff";

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/81485255a1951a3f1e224bde09c2b0e9.woff2";

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e8a3b53d15d6cf71f2b5ca66f7f0b1d2.svg";

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4e66171dd4b05faee07acf3bb452d5fe.ttf";

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7b9f530286537a83baf5da5e092373ae.woff";

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d8f88ddaf3e24f81f90d0c05dbc2c3ec.woff2";

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7f39c87d3e823593bf5d726649b95d63.svg";

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fa7198d1c47e0a6cf5b35f0036be2304.ttf";

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6b4af324e4a0d0f7ac19a69a2f456ebe.woff";

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/354e2a9c5d9499a3c38e8236ac4a385b.woff2";

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/58684a28ed082407e98028f5157649fb.svg";

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a79615e6aee228b3b80f03740299d0e4.ttf";

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/856cfffc39823b116dca73b92cb42c83.woff";

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8a0cfaa7540378dc2bc6e883120d10f5.woff2";

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1c94ec6d3a4473f28e22f8e324a9c2bb.svg";

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5fbd0d2f9eee986804831e49dd47e6d2.ttf";

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b5155aba93d3421fdfae50286bcb65a9.woff";

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1af0df96de71843e298802c8b4b02f58.woff2";

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a6dedde9baed7bfa25db3e7e79c0da8a.svg";

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3f1caafd2160a93b4fa256214b87d0a2.ttf";

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/21c7068dd26771b89d0057c35dc4e1f3.woff";

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e0017a48de1bc6a593c18a44cb5a3c10.woff2";

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/4ce76b361cf1ea90ac8d3561b24e1abd.svg";

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ec8cb4a20f5cbcbafa1bf768be080221.ttf";

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/27a8a9d5484937bedc8463eb37169f44.woff";

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/041d66101e96d2bfd2c6a3244a319b3d.woff2";

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/60c2fa4c085b81fb77e919b9c42405f8.svg";

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8053f28741c5aac359329cc31b07cec3.ttf";

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/339a8b547519ee5774a1f358e25f55cd.woff";

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/0545316ef329fef4528b757739d42f57.woff2";

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/41ef8e5d0ac53654511397e6f165eb0f.svg";

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1bf71be111189e76987a4bb9b3115cb7.ttf";

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3b3cbaef084e27f7fa05d9fe31afb287.woff";

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ea284cc760cad1896d4c917f1e546210.woff2";

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b348357e35677da79b5ca21270e2633d.svg";

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6943fb6fd4200f3d073469325c6acdc9.ttf";

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9c9017a313819aa54e959ffe8e7d27ea.woff";

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3ea4cffdf67ebf2ad373fb96b903065d.woff2";

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/400ab808e8b3ba053d41d8dc72ea3aff.svg";

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/33f225b8f5f7d6b34a0926f58f96c1e9.ttf";

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2418db91905ed032bf3a30ee72dd6a1a.woff";

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/aa22ff6fd92ecdf402f09a8180354751.woff2";

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7350876ed9eaf44d9555c8d5674d2790.svg";

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/73f7301a9cd7a086295401eefe0c998f.ttf";

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cc62fb5c139ff4ec74ef7b3474dcc7f2.woff";

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ca4d226c2c041ce9d9e946e7f7eb297e.woff2";

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/99c9f24dd717e50a36d02452c1b33c56.svg";

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/50145685042b4df07a1fd19957275b81.ttf";

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/0d8fa9d9810a6543e922ee3d90abac25.woff";

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7a1d4327518eab8c5600f4fdc520efcd.woff2";

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/04b273bca14cbdba6b0bf4d721d16ead.svg";

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/78b08a68d05d5fabb0b8effd51bf6ade.ttf";

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8642dbfe531a38f6ab836f629ff93485.woff";

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fba8b2a7052485cec44b825aaeb05d71.woff2";

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c13d9e6d9d5e10ed78910f16eb619c61.svg";

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8bac22ed4fd7c8a30536be18e2984f84.ttf";

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b40092f742715ad203dbbfaa37602688.woff";

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b91b03551cbc5aec3c2970794722f055.woff2";

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6be75e80b3b60ec7e673921a73771514.svg";

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/73d6bb0d4f596a91992e6be32e82e3bc.ttf";

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/51c4ab203f9003ce49cc9e66b05c4968.woff";

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7789cb285e0fdd866795f0fb8f19264f.woff2";

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3e2b2e91221492e315c4e7970065a287.svg";

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c7dcce084c445260a266f92db56f5517.ttf";

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7aee35e0d937a1fa3456645603d200e6.woff";

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f01a4402103c9ef9350607c0f739b49d.woff2";

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d9bee607e42329e3ae452342fd8500fb.svg";

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/629a55a7e793da068dc580d184cc0e31.ttf";

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/60bdb28dc8230486c5b0e868c82fb5dc.woff";

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/6fd1f924cd0bea5d5f74a1365e12184d.woff2";

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/efaa9297a40717c11e1a80d69d644a82.svg";

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3af1a4bc6f37abf65d55733ca3b00fb5.ttf";

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2fd678253c92cb6106e0e950d7755b46.woff";

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f9880e5300a543347a7fe12a1df5b7f6.woff2";

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/180f9bc88d17e8e3008d3ae0b1647352.svg";

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/16e5d6ec516605c4ff3cf11dd499cb8b.ttf";

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d683fe38bb4ac3b68b2710aa5bcea599.woff";

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/297503ad160b1708cf1bd8fb2317c93a.woff2";

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d405d45777abcddfe4a6c16e33a833b7.svg";

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b883f281e9c4fad4b3ed885fa6d22cd3.ttf";

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/70837a30c4831208f720dc37cc943559.woff";

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b73f1eaffe1fdfc8cd8d8f401b4cc430.woff2";

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/59a324fb171b6ff236a026deddb76f99.svg";

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/828aad60ddeeb5284c7b44b2b2fc8b08.ttf";

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/25c854816d934ae1347ebaecee300101.woff";

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d31183120d7262f65868ae174ffcfca6.woff2";

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/df03f91fa20b1d58eb050847874d239c.svg";

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a83fcae129a2ab50415c8983b21ad106.ttf";

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b55d98414ffc341f17213f9265752107.woff";

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/cb86c375a267c9ad600d23e8c106aa28.woff2";

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/df074a3edc140ecac8a9cbbc071996ec.svg";

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d1e288052505a7ab669af9fcd047c702.ttf";

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1cf3817fc76fd10bb7575fb24b735bfc.woff";

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c53079e87cee487b72404af42eba464f.woff2";

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/47f27005d8d00cd698341651a80a4fbf.svg";

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/b6546a34104443ae01b3d8487020be75.ttf";

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e62b15856e5b20ec6e72d58d6de73c62.woff";

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f35d8e4ee162608c945e268e28f8e26b.woff2";

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5ad338aa2cb9441489093cfde11c7c87.svg";

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/73fc97b6fca9afd9f0c340c088994c17.ttf";

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ab89aabdfbdecd55f65a0ec0002ed51b.woff";

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a063da22077696cff8bd062cebff4861.woff2";

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/bf84244fa360c5536855bd84e8a847ae.svg";

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8ea137703f3f465be8753ab7b6874090.ttf";

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ce7f978c8bc5375bee01f2323dc13f23.woff";

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/df45c7958012996d251a01b4183a2882.woff2";

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f352997c2a5cfe95ad2d5b7bc830b737.svg";

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c212e0222b20dcb1847ccd32ee419a1c.ttf";

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/10ae960040dc8f73f6c28c4a165febcf.woff";

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9c17430457e2c00260d4b79d44cb774a.woff2";

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/dc2c39658a399a2df4e4ea4dd0c72f9b.svg";

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/61224cba8a7238881ecaeca7b38f3fe3.ttf";

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/76841b75cf2367fb787f4f4314d75ad0.woff";

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1778883365bad5f95d001fc21b12ce40.woff2";

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9e18325bfc99f6e6fe5c72ac29c75e65.svg";

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f2d52b1e74574ab35ea7d4d4eeb7c9e7.ttf";

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ed1a5e5ed1d44d3983ea7978b054f96d.woff";

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/74659a83f763e9d83776b5a16efa4cda.woff2";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/02cb2a430a03d197123e89303f461e5f.svg";

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/0b7704568b9e23476f76bf7cc36f8b3c.ttf";

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/384584b419e10268a898fb43091a6eb0.woff";

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ecf7159d16b224a343f6bdf1c978aec0.woff2";

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/9971d2707241bb6c19cb1141e3b35d76.ttf";

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e78f217c38267703d444fb8f3940a431.woff";

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f4c3270b2710ca9e0d537bea35ca5f06.woff2";

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/743b42a3ace84553402144b6b186eb99.ttf";

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/bac61997af03ef4747cd73b3757749ca.woff";

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a2e0522575c10759bcf3332c5db0260f.woff2";

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/244db27f9e25edd519486604c233902f.ttf";

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/a64e134208e4b556aa9adfd286aa46ab.woff";

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/479a68ec912f41b8a28b1b1f3000b889.woff2";

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ad26cc83c0ff84ac3afc867f58848783.ttf";

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/0a0aa194aa39cc284a3d8826cd23cfa9.woff";

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8e5f883e14f473f6be1dfa8c51bf277b.woff2";

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d459632ec35250277328388039edc45d.ttf";

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/f980ca72a0d0876d0451f9e8d7b25c02.woff";

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/ae2b6f4374a0e6ad9f7cfd75b3b68fd3.woff2";

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e69b9513bba6b6a563bad05e8a0de80c.ttf";

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d8a629d21894b90448b5f42f457c2060.woff";

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/83f8b326ade537b52c54593f448e980e.woff2";

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/1b226149c7920e96e4c47faf0ff73d8c.ttf";

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8dd42e02d20082db960018b6488338f7.woff";

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/07510ed019e317ee10bb5a26012e1069.woff2";

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/d9162dfe8f36db18b8d4ef7ffa75692d.ttf";

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2dffc87573a6d6dd440e801b5cce5c8e.woff";

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/bd65225294e9ad1114ded0a8bde4d38b.woff2";

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/55fbb3ac09b79fc554f78b4fa51d9bf4.ttf";

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/da586018a5f1b55beb343d53bf804007.woff";

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/afeebb76a0201bf468f5e0b1a9622c09.woff2";

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8075d14aa49687aad5e147668cc3402a.ttf";

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/48c7df6f4d3d4df25748a666d0520b5c.woff";

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/7d5fa3e2a370f59774cd189cf6ca2e59.woff2";

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/abb12fc254db7db04627ecccf005eba6.ttf";

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5acb381b12b66ca6afef5d9edb948672.woff";

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/c472b57029cc804912e0380dcbf72491.woff2";

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8cc60fd5985fceea2e8c7cbadb731eaf.ttf";

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/bdd0d5e034ab4a8641bd05736d5ed84f.woff";

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/feed6c70fde629d6eb61e1ed2bb93537.woff2";

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/5976fffdaa1b8e6eed853f3dc3ba1330.ttf";

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/fd67fb35731da39667ae210a98c60ef4.woff";

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8a86a0afd5a0b172bdc93be1e3d53866.woff2";

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/e929f5d97ac36718e3a66218f45925d8.ttf";

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/943c94f89c864bae86f603aee2bf83ea.woff";

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/2c1ea03043d76fc65767eb60aa6e0015.woff2";

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/81ab95e4bae239656034b9e6e62dcaaf.ttf";

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/68537743d23b63655387918e39fe65c1.woff";

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/680d35e3c073a84a91283a283e47fb0c.woff2";

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/29017475281a903951aa79c83e38caf7.ttf";

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/3e9e27f043e770a8690883e26599133f.woff";

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	module.e = __webpack_require__.p + "files/8a6d8ed89749165e1f09044215edb958.woff2";

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* The following list is defined in React's core */
	var IS_UNITLESS = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	module.e = function(name, value) {
	  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
	    return value + 'px';
	  } else {
	    return value;
	  }
	};


/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var asn1 = __webpack_require__(192);
	var inherits = __webpack_require__(27);
	
	var api = exports;
	
	api.define = function define(name, body) {
	  return new Entity(name, body);
	};
	
	function Entity(name, body) {
	  this.name = name;
	  this.body = body;
	
	  this.decoders = {};
	  this.encoders = {};
	};
	
	Entity.prototype._createNamed = function createNamed(base) {
	  var named;
	  try {
	    named = __webpack_require__(1736).runInThisContext(
	      '(function ' + this.name + '(entity) {\n' +
	      '  this._initNamed(entity);\n' +
	      '})'
	    );
	  } catch (e) {
	    named = function (entity) {
	      this._initNamed(entity);
	    };
	  }
	  inherits(named, base);
	  named.prototype._initNamed = function initnamed(entity) {
	    base.call(this, entity);
	  };
	
	  return new named(this);
	};
	
	Entity.prototype._getDecoder = function _getDecoder(enc) {
	  enc = enc || 'der';
	  // Lazily create decoder
	  if (!this.decoders.hasOwnProperty(enc))
	    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
	  return this.decoders[enc];
	};
	
	Entity.prototype.decode = function decode(data, enc, options) {
	  return this._getDecoder(enc).decode(data, options);
	};
	
	Entity.prototype._getEncoder = function _getEncoder(enc) {
	  enc = enc || 'der';
	  // Lazily create encoder
	  if (!this.encoders.hasOwnProperty(enc))
	    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
	  return this.encoders[enc];
	};
	
	Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
	  return this._getEncoder(enc).encode(data, reporter);
	};
	


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var Reporter = __webpack_require__(162).Reporter;
	var EncoderBuffer = __webpack_require__(162).EncoderBuffer;
	var DecoderBuffer = __webpack_require__(162).DecoderBuffer;
	var assert = __webpack_require__(174);
	
	// Supported tags
	var tags = [
	  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
	  'gentime', 'utctime', 'null_', 'enum', 'int',
	  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
	  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
	];
	
	// Public methods list
	var methods = [
	  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
	  'any', 'contains'
	].concat(tags);
	
	// Overrided methods list
	var overrided = [
	  '_peekTag', '_decodeTag', '_use',
	  '_decodeStr', '_decodeObjid', '_decodeTime',
	  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',
	
	  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
	  '_encodeNull', '_encodeInt', '_encodeBool'
	];
	
	function Node(enc, parent) {
	  var state = {};
	  this._baseState = state;
	
	  state.enc = enc;
	
	  state.parent = parent || null;
	  state.children = null;
	
	  // State
	  state.tag = null;
	  state.args = null;
	  state.reverseArgs = null;
	  state.choice = null;
	  state.optional = false;
	  state.any = false;
	  state.obj = false;
	  state.use = null;
	  state.useDecoder = null;
	  state.key = null;
	  state['default'] = null;
	  state.explicit = null;
	  state.implicit = null;
	  state.contains = null;
	
	  // Should create new instance on each method
	  if (!state.parent) {
	    state.children = [];
	    this._wrap();
	  }
	}
	module.e = Node;
	
	var stateProps = [
	  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
	  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
	  'implicit'
	];
	
	Node.prototype.clone = function clone() {
	  var state = this._baseState;
	  var cstate = {};
	  stateProps.forEach(function(prop) {
	    cstate[prop] = state[prop];
	  });
	  var res = new this.constructor(cstate.parent);
	  res._baseState = cstate;
	  return res;
	};
	
	Node.prototype._wrap = function wrap() {
	  var state = this._baseState;
	  methods.forEach(function(method) {
	    this[method] = function _wrappedMethod() {
	      var clone = new this.constructor(this);
	      state.children.push(clone);
	      return clone[method].apply(clone, arguments);
	    };
	  }, this);
	};
	
	Node.prototype._init = function init(body) {
	  var state = this._baseState;
	
	  assert(state.parent === null);
	  body.call(this);
	
	  // Filter children
	  state.children = state.children.filter(function(child) {
	    return child._baseState.parent === this;
	  }, this);
	  assert.equal(state.children.length, 1, 'Root node can have only one child');
	};
	
	Node.prototype._useArgs = function useArgs(args) {
	  var state = this._baseState;
	
	  // Filter children and args
	  var children = args.filter(function(arg) {
	    return arg instanceof this.constructor;
	  }, this);
	  args = args.filter(function(arg) {
	    return !(arg instanceof this.constructor);
	  }, this);
	
	  if (children.length !== 0) {
	    assert(state.children === null);
	    state.children = children;
	
	    // Replace parent to maintain backward link
	    children.forEach(function(child) {
	      child._baseState.parent = this;
	    }, this);
	  }
	  if (args.length !== 0) {
	    assert(state.args === null);
	    state.args = args;
	    state.reverseArgs = args.map(function(arg) {
	      if (typeof arg !== 'object' || arg.constructor !== Object)
	        return arg;
	
	      var res = {};
	      Object.keys(arg).forEach(function(key) {
	        if (key == (key | 0))
	          key |= 0;
	        var value = arg[key];
	        res[value] = key;
	      });
	      return res;
	    });
	  }
	};
	
	//
	// Overrided methods
	//
	
	overrided.forEach(function(method) {
	  Node.prototype[method] = function _overrided() {
	    var state = this._baseState;
	    throw new Error(method + ' not implemented for encoding: ' + state.enc);
	  };
	});
	
	//
	// Public methods
	//
	
	tags.forEach(function(tag) {
	  Node.prototype[tag] = function _tagMethod() {
	    var state = this._baseState;
	    var args = Array.prototype.slice.call(arguments);
	
	    assert(state.tag === null);
	    state.tag = tag;
	
	    this._useArgs(args);
	
	    return this;
	  };
	});
	
	Node.prototype.use = function use(item) {
	  var state = this._baseState;
	
	  assert(state.use === null);
	  state.use = item;
	
	  return this;
	};
	
	Node.prototype.optional = function optional() {
	  var state = this._baseState;
	
	  state.optional = true;
	
	  return this;
	};
	
	Node.prototype.def = function def(val) {
	  var state = this._baseState;
	
	  assert(state['default'] === null);
	  state['default'] = val;
	  state.optional = true;
	
	  return this;
	};
	
	Node.prototype.explicit = function explicit(num) {
	  var state = this._baseState;
	
	  assert(state.explicit === null && state.implicit === null);
	  state.explicit = num;
	
	  return this;
	};
	
	Node.prototype.implicit = function implicit(num) {
	  var state = this._baseState;
	
	  assert(state.explicit === null && state.implicit === null);
	  state.implicit = num;
	
	  return this;
	};
	
	Node.prototype.obj = function obj() {
	  var state = this._baseState;
	  var args = Array.prototype.slice.call(arguments);
	
	  state.obj = true;
	
	  if (args.length !== 0)
	    this._useArgs(args);
	
	  return this;
	};
	
	Node.prototype.key = function key(newKey) {
	  var state = this._baseState;
	
	  assert(state.key === null);
	  state.key = newKey;
	
	  return this;
	};
	
	Node.prototype.any = function any() {
	  var state = this._baseState;
	
	  state.any = true;
	
	  return this;
	};
	
	Node.prototype.choice = function choice(obj) {
	  var state = this._baseState;
	
	  assert(state.choice === null);
	  state.choice = obj;
	  this._useArgs(Object.keys(obj).map(function(key) {
	    return obj[key];
	  }));
	
	  return this;
	};
	
	Node.prototype.contains = function contains(item) {
	  var state = this._baseState;
	
	  assert(state.use === null);
	  state.contains = item;
	
	  return this;
	};
	
	//
	// Decoding
	//
	
	Node.prototype._decode = function decode(input) {
	  var state = this._baseState;
	
	  // Decode root node
	  if (state.parent === null)
	    return input.wrapResult(state.children[0]._decode(input));
	
	  var result = state['default'];
	  var present = true;
	
	  var prevKey;
	  if (state.key !== null)
	    prevKey = input.enterKey(state.key);
	
	  // Check if tag is there
	  if (state.optional) {
	    var tag = null;
	    if (state.explicit !== null)
	      tag = state.explicit;
	    else if (state.implicit !== null)
	      tag = state.implicit;
	    else if (state.tag !== null)
	      tag = state.tag;
	
	    if (tag === null && !state.any) {
	      // Trial and Error
	      var save = input.save();
	      try {
	        if (state.choice === null)
	          this._decodeGeneric(state.tag, input);
	        else
	          this._decodeChoice(input);
	        present = true;
	      } catch (e) {
	        present = false;
	      }
	      input.restore(save);
	    } else {
	      present = this._peekTag(input, tag, state.any);
	
	      if (input.isError(present))
	        return present;
	    }
	  }
	
	  // Push object on stack
	  var prevObj;
	  if (state.obj && present)
	    prevObj = input.enterObject();
	
	  if (present) {
	    // Unwrap explicit values
	    if (state.explicit !== null) {
	      var explicit = this._decodeTag(input, state.explicit);
	      if (input.isError(explicit))
	        return explicit;
	      input = explicit;
	    }
	
	    // Unwrap implicit and normal values
	    if (state.use === null && state.choice === null) {
	      if (state.any)
	        var save = input.save();
	      var body = this._decodeTag(
	        input,
	        state.implicit !== null ? state.implicit : state.tag,
	        state.any
	      );
	      if (input.isError(body))
	        return body;
	
	      if (state.any)
	        result = input.raw(save);
	      else
	        input = body;
	    }
	
	    // Select proper method for tag
	    if (state.any)
	      result = result;
	    else if (state.choice === null)
	      result = this._decodeGeneric(state.tag, input);
	    else
	      result = this._decodeChoice(input);
	
	    if (input.isError(result))
	      return result;
	
	    // Decode children
	    if (!state.any && state.choice === null && state.children !== null) {
	      state.children.forEach(function decodeChildren(child) {
	        // NOTE: We are ignoring errors here, to let parser continue with other
	        // parts of encoded data
	        child._decode(input);
	      });
	    }
	
	    // Decode contained/encoded by schema, only in bit or octet strings
	    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
	      var data = new DecoderBuffer(result);
	      result = this._getUse(state.contains, input._reporterState.obj)._decode(data);
	    }
	  }
	
	  // Pop object
	  if (state.obj && present)
	    result = input.leaveObject(prevObj);
	
	  // Set key
	  if (state.key !== null && (result !== null || present === true))
	    input.leaveKey(prevKey, state.key, result);
	
	  return result;
	};
	
	Node.prototype._decodeGeneric = function decodeGeneric(tag, input) {
	  var state = this._baseState;
	
	  if (tag === 'seq' || tag === 'set')
	    return null;
	  if (tag === 'seqof' || tag === 'setof')
	    return this._decodeList(input, tag, state.args[0]);
	  else if (/str$/.test(tag))
	    return this._decodeStr(input, tag);
	  else if (tag === 'objid' && state.args)
	    return this._decodeObjid(input, state.args[0], state.args[1]);
	  else if (tag === 'objid')
	    return this._decodeObjid(input, null, null);
	  else if (tag === 'gentime' || tag === 'utctime')
	    return this._decodeTime(input, tag);
	  else if (tag === 'null_')
	    return this._decodeNull(input);
	  else if (tag === 'bool')
	    return this._decodeBool(input);
	  else if (tag === 'int' || tag === 'enum')
	    return this._decodeInt(input, state.args && state.args[0]);
	  else if (state.use !== null)
	    return this._getUse(state.use, input._reporterState.obj)._decode(input);
	  else
	    return input.error('unknown tag: ' + tag);
	};
	
	Node.prototype._getUse = function _getUse(entity, obj) {
	
	  var state = this._baseState;
	  // Create altered use decoder if implicit is set
	  state.useDecoder = this._use(entity, obj);
	  assert(state.useDecoder._baseState.parent === null);
	  state.useDecoder = state.useDecoder._baseState.children[0];
	  if (state.implicit !== state.useDecoder._baseState.implicit) {
	    state.useDecoder = state.useDecoder.clone();
	    state.useDecoder._baseState.implicit = state.implicit;
	  }
	  return state.useDecoder;
	};
	
	Node.prototype._decodeChoice = function decodeChoice(input) {
	  var state = this._baseState;
	  var result = null;
	  var match = false;
	
	  Object.keys(state.choice).some(function(key) {
	    var save = input.save();
	    var node = state.choice[key];
	    try {
	      var value = node._decode(input);
	      if (input.isError(value))
	        return false;
	
	      result = { type: key, value: value };
	      match = true;
	    } catch (e) {
	      input.restore(save);
	      return false;
	    }
	    return true;
	  }, this);
	
	  if (!match)
	    return input.error('Choice not matched');
	
	  return result;
	};
	
	//
	// Encoding
	//
	
	Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
	  return new EncoderBuffer(data, this.reporter);
	};
	
	Node.prototype._encode = function encode(data, reporter, parent) {
	  var state = this._baseState;
	  if (state['default'] !== null && state['default'] === data)
	    return;
	
	  var result = this._encodeValue(data, reporter, parent);
	  if (result === undefined)
	    return;
	
	  if (this._skipDefault(result, reporter, parent))
	    return;
	
	  return result;
	};
	
	Node.prototype._encodeValue = function encode(data, reporter, parent) {
	  var state = this._baseState;
	
	  // Decode root node
	  if (state.parent === null)
	    return state.children[0]._encode(data, reporter || new Reporter());
	
	  var result = null;
	
	  // Set reporter to share it with a child class
	  this.reporter = reporter;
	
	  // Check if data is there
	  if (state.optional && data === undefined) {
	    if (state['default'] !== null)
	      data = state['default']
	    else
	      return;
	  }
	
	  // Encode children first
	  var content = null;
	  var primitive = false;
	  if (state.any) {
	    // Anything that was given is translated to buffer
	    result = this._createEncoderBuffer(data);
	  } else if (state.choice) {
	    result = this._encodeChoice(data, reporter);
	  } else if (state.contains) {
	    content = this._getUse(state.contains, parent)._encode(data, reporter);
	    primitive = true;
	  } else if (state.children) {
	    content = state.children.map(function(child) {
	      if (child._baseState.tag === 'null_')
	        return child._encode(null, reporter, data);
	
	      if (child._baseState.key === null)
	        return reporter.error('Child should have a key');
	      var prevKey = reporter.enterKey(child._baseState.key);
	
	      if (typeof data !== 'object')
	        return reporter.error('Child expected, but input is not object');
	
	      var res = child._encode(data[child._baseState.key], reporter, data);
	      reporter.leaveKey(prevKey);
	
	      return res;
	    }, this).filter(function(child) {
	      return child;
	    });
	    content = this._createEncoderBuffer(content);
	  } else {
	    if (state.tag === 'seqof' || state.tag === 'setof') {
	      // TODO(indutny): this should be thrown on DSL level
	      if (!(state.args && state.args.length === 1))
	        return reporter.error('Too many args for : ' + state.tag);
	
	      if (!Array.isArray(data))
	        return reporter.error('seqof/setof, but data is not Array');
	
	      var child = this.clone();
	      child._baseState.implicit = null;
	      content = this._createEncoderBuffer(data.map(function(item) {
	        var state = this._baseState;
	
	        return this._getUse(state.args[0], data)._encode(item, reporter);
	      }, child));
	    } else if (state.use !== null) {
	      result = this._getUse(state.use, parent)._encode(data, reporter);
	    } else {
	      content = this._encodePrimitive(state.tag, data);
	      primitive = true;
	    }
	  }
	
	  // Encode data itself
	  var result;
	  if (!state.any && state.choice === null) {
	    var tag = state.implicit !== null ? state.implicit : state.tag;
	    var cls = state.implicit === null ? 'universal' : 'context';
	
	    if (tag === null) {
	      if (state.use === null)
	        reporter.error('Tag could be ommited only for .use()');
	    } else {
	      if (state.use === null)
	        result = this._encodeComposite(tag, primitive, cls, content);
	    }
	  }
	
	  // Wrap in explicit
	  if (state.explicit !== null)
	    result = this._encodeComposite(state.explicit, false, 'context', result);
	
	  return result;
	};
	
	Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
	  var state = this._baseState;
	
	  var node = state.choice[data.type];
	  if (!node) {
	    assert(
	        false,
	        data.type + ' not found in ' +
	            JSON.stringify(Object.keys(state.choice)));
	  }
	  return node._encode(data.value, reporter);
	};
	
	Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
	  var state = this._baseState;
	
	  if (/str$/.test(tag))
	    return this._encodeStr(data, tag);
	  else if (tag === 'objid' && state.args)
	    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
	  else if (tag === 'objid')
	    return this._encodeObjid(data, null, null);
	  else if (tag === 'gentime' || tag === 'utctime')
	    return this._encodeTime(data, tag);
	  else if (tag === 'null_')
	    return this._encodeNull();
	  else if (tag === 'int' || tag === 'enum')
	    return this._encodeInt(data, state.args && state.reverseArgs[0]);
	  else if (tag === 'bool')
	    return this._encodeBool(data);
	  else
	    throw new Error('Unsupported tag: ' + tag);
	};
	
	Node.prototype._isNumstr = function isNumstr(str) {
	  return /^[0-9 ]*$/.test(str);
	};
	
	Node.prototype._isPrintstr = function isPrintstr(str) {
	  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
	};
	


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27);
	
	function Reporter(options) {
	  this._reporterState = {
	    obj: null,
	    path: [],
	    options: options || {},
	    errors: []
	  };
	}
	exports.Reporter = Reporter;
	
	Reporter.prototype.isError = function isError(obj) {
	  return obj instanceof ReporterError;
	};
	
	Reporter.prototype.save = function save() {
	  var state = this._reporterState;
	
	  return { obj: state.obj, pathLen: state.path.length };
	};
	
	Reporter.prototype.restore = function restore(data) {
	  var state = this._reporterState;
	
	  state.obj = data.obj;
	  state.path = state.path.slice(0, data.pathLen);
	};
	
	Reporter.prototype.enterKey = function enterKey(key) {
	  return this._reporterState.path.push(key);
	};
	
	Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
	  var state = this._reporterState;
	
	  state.path = state.path.slice(0, index - 1);
	  if (state.obj !== null)
	    state.obj[key] = value;
	};
	
	Reporter.prototype.enterObject = function enterObject() {
	  var state = this._reporterState;
	
	  var prev = state.obj;
	  state.obj = {};
	  return prev;
	};
	
	Reporter.prototype.leaveObject = function leaveObject(prev) {
	  var state = this._reporterState;
	
	  var now = state.obj;
	  state.obj = prev;
	  return now;
	};
	
	Reporter.prototype.error = function error(msg) {
	  var err;
	  var state = this._reporterState;
	
	  var inherited = msg instanceof ReporterError;
	  if (inherited) {
	    err = msg;
	  } else {
	    err = new ReporterError(state.path.map(function(elem) {
	      return '[' + JSON.stringify(elem) + ']';
	    }).join(''), msg.message || msg, msg.stack);
	  }
	
	  if (!state.options.partial)
	    throw err;
	
	  if (!inherited)
	    state.errors.push(err);
	
	  return err;
	};
	
	Reporter.prototype.wrapResult = function wrapResult(result) {
	  var state = this._reporterState;
	  if (!state.options.partial)
	    return result;
	
	  return {
	    result: this.isError(result) ? null : result,
	    errors: state.errors
	  };
	};
	
	function ReporterError(path, msg) {
	  this.path = path;
	  this.rethrow(msg);
	};
	inherits(ReporterError, Error);
	
	ReporterError.prototype.rethrow = function rethrow(msg) {
	  this.message = msg + ' at: ' + (this.path || '(shallow)');
	  Error.captureStackTrace(this, ReporterError);
	
	  return this;
	};
	


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var constants = __webpack_require__(456);
	
	exports.tagClass = {
	  0: 'universal',
	  1: 'application',
	  2: 'context',
	  3: 'private'
	};
	exports.tagClassByName = constants._reverse(exports.tagClass);
	
	exports.tag = {
	  0x00: 'end',
	  0x01: 'bool',
	  0x02: 'int',
	  0x03: 'bitstr',
	  0x04: 'octstr',
	  0x05: 'null_',
	  0x06: 'objid',
	  0x07: 'objDesc',
	  0x08: 'external',
	  0x09: 'real',
	  0x0a: 'enum',
	  0x0b: 'embed',
	  0x0c: 'utf8str',
	  0x0d: 'relativeOid',
	  0x10: 'seq',
	  0x11: 'set',
	  0x12: 'numstr',
	  0x13: 'printstr',
	  0x14: 't61str',
	  0x15: 'videostr',
	  0x16: 'ia5str',
	  0x17: 'utctime',
	  0x18: 'gentime',
	  0x19: 'graphstr',
	  0x1a: 'iso646str',
	  0x1b: 'genstr',
	  0x1c: 'unistr',
	  0x1d: 'charstr',
	  0x1e: 'bmpstr'
	};
	exports.tagByName = constants._reverse(exports.tag);
	


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var decoders = exports;
	
	decoders.der = __webpack_require__(457);
	decoders.pem = __webpack_require__(1090);
	


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27);
	var Buffer = __webpack_require__(19).Buffer;
	
	var DERDecoder = __webpack_require__(457);
	
	function PEMDecoder(entity) {
	  DERDecoder.call(this, entity);
	  this.enc = 'pem';
	};
	inherits(PEMDecoder, DERDecoder);
	module.e = PEMDecoder;
	
	PEMDecoder.prototype.decode = function decode(data, options) {
	  var lines = data.toString().split(/[\r\n]+/g);
	
	  var label = options.label.toUpperCase();
	
	  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
	  var start = -1;
	  var end = -1;
	  for (var i = 0; i < lines.length; i++) {
	    var match = lines[i].match(re);
	    if (match === null)
	      continue;
	
	    if (match[2] !== label)
	      continue;
	
	    if (start === -1) {
	      if (match[1] !== 'BEGIN')
	        break;
	      start = i;
	    } else {
	      if (match[1] !== 'END')
	        break;
	      end = i;
	      break;
	    }
	  }
	  if (start === -1 || end === -1)
	    throw new Error('PEM section not found for: ' + label);
	
	  var base64 = lines.slice(start + 1, end).join('');
	  // Remove excessive symbols
	  base64.replace(/[^a-z0-9\+\/=]+/gi, '');
	
	  var input = new Buffer(base64, 'base64');
	  return DERDecoder.prototype.decode.call(this, input, options);
	};
	


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var encoders = exports;
	
	encoders.der = __webpack_require__(458);
	encoders.pem = __webpack_require__(1092);
	


/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27);
	
	var DEREncoder = __webpack_require__(458);
	
	function PEMEncoder(entity) {
	  DEREncoder.call(this, entity);
	  this.enc = 'pem';
	};
	inherits(PEMEncoder, DEREncoder);
	module.e = PEMEncoder;
	
	PEMEncoder.prototype.encode = function encode(data, options) {
	  var buf = DEREncoder.prototype.encode.call(this, data);
	
	  var p = buf.toString('base64');
	  var out = [ '-----BEGIN ' + options.label + '-----' ];
	  for (var i = 0; i < p.length; i += 64)
	    out.push(p.slice(i, i + 64));
	  out.push('-----END ' + options.label + '-----');
	  return out.join('\n');
	};
	


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*!
	 * Autolinker.js
	 * 0.26.0
	 *
	 * Copyright(c) 2016 Gregory Jacobs <greg@greg-jacobs.com>
	 * MIT License
	 *
	 * https://github.com/gregjacobs/Autolinker.js
	 */
	;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.Autolinker = factory();
	  }
	}(this, function() {
	/**
	 * @class Autolinker
	 * @extends Object
	 *
	 * Utility class used to process a given string of text, and wrap the matches in
	 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
	 *
	 * Any of the configuration options may be provided in an Object (map) provided
	 * to the Autolinker constructor, which will configure how the {@link #link link()}
	 * method will process the links.
	 *
	 * For example:
	 *
	 *     var autolinker = new Autolinker( {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *
	 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * The {@link #static-link static link()} method may also be used to inline
	 * options into a single call, which may be more convenient for one-off uses.
	 * For example:
	 *
	 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * ## Custom Replacements of Links
	 *
	 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
	 * may be provided to fully customize the output of Autolinker. This function is
	 * called once for each URL/Email/Phone#/Twitter Handle/Hashtag match that is
	 * encountered.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Twitter Handles, and Hashtags
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( autolinker, match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
	 *                         var tag = autolinker.getTagBuilder().build( match );  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
	 *                         tag.setAttr( 'rel', 'nofollow' );
	 *                         tag.addClass( 'external-link' );
	 *
	 *                         return tag;
	 *
	 *                     } else {
	 *                         return true;  // let Autolinker perform its normal anchor tag replacement
	 *                     }
	 *
	 *                 case 'email' :
	 *                     var email = match.getEmail();
	 *                     console.log( "email: ", email );
	 *
	 *                     if( email === "my@own.address" ) {
	 *                         return false;  // don't auto-link this particular email address; leave as-is
	 *                     } else {
	 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
	 *                     }
	 *
	 *                 case 'phone' :
	 *                     var phoneNumber = match.getPhoneNumber();
	 *                     console.log( phoneNumber );
	 *
	 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
	 *
	 *                 case 'twitter' :
	 *                     var twitterHandle = match.getTwitterHandle();
	 *                     console.log( twitterHandle );
	 *
	 *                     return '<a href="http://newplace.to.link.twitter.handles.to/">' + twitterHandle + '</a>';
	 *
	 *                 case 'hashtag' :
	 *                     var hashtag = match.getHashtag();
	 *                     console.log( hashtag );
	 *
	 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
	 *             }
	 *         }
	 *     } );
	 *
	 *
	 * The function may return the following values:
	 *
	 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
	 *   would.
	 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
	 * - Any String: If a string is returned from the function, the string will be
	 *   used directly as the replacement HTML for the match.
	 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
	 *   an HTML tag before writing out its HTML text.
	 *
	 * @constructor
	 * @param {Object} [cfg] The configuration options for the Autolinker instance,
	 *   specified in an Object (map).
	 */
	var Autolinker = function( cfg ) {
		cfg = cfg || {};
	
		this.version = Autolinker.version;
	
		this.urls = this.normalizeUrlsCfg( cfg.urls );
		this.email = typeof cfg.email === 'boolean' ? cfg.email : true;
		this.twitter = typeof cfg.twitter === 'boolean' ? cfg.twitter : true;
		this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : true;
		this.hashtag = cfg.hashtag || false;
		this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : true;
		this.stripPrefix = typeof cfg.stripPrefix === 'boolean' ? cfg.stripPrefix : true;
	
		// Validate the value of the `hashtag` cfg.
		var hashtag = this.hashtag;
		if( hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram' ) {
			throw new Error( "invalid `hashtag` cfg - see docs" );
		}
	
		this.truncate = this.normalizeTruncateCfg( cfg.truncate );
		this.className = cfg.className || '';
		this.replaceFn = cfg.replaceFn || null;
	
		this.htmlParser = null;
		this.matchers = null;
		this.tagBuilder = null;
	};
	
	
	
	/**
	 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
	 * and Hashtags found in the given chunk of HTML. Does not link URLs found
	 * within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * Example:
	 *
	 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
	 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
	 *
	 * @static
	 * @param {String} textOrHtml The HTML or text to find matches within (depending
	 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter},
	 *   and {@link #hashtag} options are enabled).
	 * @param {Object} [options] Any of the configuration options for the Autolinker
	 *   class, specified in an Object (map). See the class description for an
	 *   example call.
	 * @return {String} The HTML text, with matches automatically linked.
	 */
	Autolinker.link = function( textOrHtml, options ) {
		var autolinker = new Autolinker( options );
		return autolinker.link( textOrHtml );
	};
	
	
	/**
	 * @static
	 * @property {String} version (readonly)
	 *
	 * The Autolinker version number in the form major.minor.patch
	 *
	 * Ex: 0.25.1
	 */
	Autolinker.version = '0.26.0';
	
	
	Autolinker.prototype = {
		constructor : Autolinker,  // fix constructor property
	
		/**
		 * @cfg {Boolean/Object} [urls=true]
		 *
		 * `true` if URLs should be automatically linked, `false` if they should not
		 * be.
		 *
		 * This option also accepts an Object form with 3 properties, to allow for
		 * more customization of what exactly gets linked. All default to `true`:
		 *
		 * @param {Boolean} schemeMatches `true` to match URLs found prefixed with a
		 *   scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
		 *   `false` to prevent these types of matches.
		 * @param {Boolean} wwwMatches `true` to match urls found prefixed with
		 *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
		 *   matches. Note that if the URL had a prefixed scheme, and
		 *   `schemeMatches` is true, it will still be linked.
		 * @param {Boolean} tldMatches `true` to match URLs with known top level
		 *   domains (.com, .net, etc.) that are not prefixed with a scheme or
		 *   `'www.'`. This option attempts to match anything that looks like a URL
		 *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
		 *   to prevent these types of matches.
		 */
	
		/**
		 * @cfg {Boolean} [email=true]
		 *
		 * `true` if email addresses should be automatically linked, `false` if they
		 * should not be.
		 */
	
		/**
		 * @cfg {Boolean} [twitter=true]
		 *
		 * `true` if Twitter handles ("@example") should be automatically linked,
		 * `false` if they should not be.
		 */
	
		/**
		 * @cfg {Boolean} [phone=true]
		 *
		 * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
		 * `false` if they should not be.
		 */
	
		/**
		 * @cfg {Boolean/String} [hashtag=false]
		 *
		 * A string for the service name to have hashtags (ex: "#myHashtag")
		 * auto-linked to. The currently-supported values are:
		 *
		 * - 'twitter'
		 * - 'facebook'
		 * - 'instagram'
		 *
		 * Pass `false` to skip auto-linking of hashtags.
		 */
	
		/**
		 * @cfg {Boolean} [newWindow=true]
		 *
		 * `true` if the links should open in a new window, `false` otherwise.
		 */
	
		/**
		 * @cfg {Boolean} [stripPrefix=true]
		 *
		 * `true` if 'http://' or 'https://' and/or the 'www.' should be stripped
		 * from the beginning of URL links' text, `false` otherwise.
		 */
	
		/**
		 * @cfg {Number/Object} [truncate=0]
		 *
		 * ## Number Form
		 *
		 * A number for how many characters matched text should be truncated to
		 * inside the text of a link. If the matched text is over this number of
		 * characters, it will be truncated to this length by adding a two period
		 * ellipsis ('..') to the end of the string.
		 *
		 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
		 * truncated to 25 characters might look something like this:
		 * 'yahoo.com/some/long/pat..'
		 *
		 * Example Usage:
		 *
		 *     truncate: 25
		 *
		 *
		 *  Defaults to `0` for "no truncation."
		 *
		 *
		 * ## Object Form
		 *
		 * An Object may also be provided with two properties: `length` (Number) and
		 * `location` (String). `location` may be one of the following: 'end'
		 * (default), 'middle', or 'smart'.
		 *
		 * Example Usage:
		 *
		 *     truncate: { length: 25, location: 'middle' }
		 *
		 * @cfg {Number} [truncate.length=0] How many characters to allow before
		 *   truncation will occur. Defaults to `0` for "no truncation."
		 * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
		 *
		 * - 'end' (default): will truncate up to the number of characters, and then
		 *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
		 * - 'middle': will truncate and add the ellipsis in the middle. Ex:
		 *   'yahoo.com/s..th/to/a/file'
		 * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
		 *   parts first (such as the 'www.', then URL scheme, hash, etc.),
		 *   attempting to make the URL human-readable before looking for a good
		 *   point to insert the ellipsis if it is still too long. Ex:
		 *   'yahoo.com/some..to/a/file'. For more details, see
		 *   {@link Autolinker.truncate.TruncateSmart}.
		 */
	
		/**
		 * @cfg {String} className
		 *
		 * A CSS class name to add to the generated links. This class will be added
		 * to all links, as well as this class plus match suffixes for styling
		 * url/email/phone/twitter/hashtag links differently.
		 *
		 * For example, if this config is provided as "myLink", then:
		 *
		 * - URL links will have the CSS classes: "myLink myLink-url"
		 * - Email links will have the CSS classes: "myLink myLink-email", and
		 * - Twitter links will have the CSS classes: "myLink myLink-twitter"
		 * - Phone links will have the CSS classes: "myLink myLink-phone"
		 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
		 */
	
		/**
		 * @cfg {Function} replaceFn
		 *
		 * A function to individually process each match found in the input string.
		 *
		 * See the class's description for usage.
		 *
		 * This function is called with the following parameters:
		 *
		 * @cfg {Autolinker} replaceFn.autolinker The Autolinker instance, which may
		 *   be used to retrieve child objects from (such as the instance's
		 *   {@link #getTagBuilder tag builder}).
		 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
		 *   can be used to retrieve information about the match that the `replaceFn`
		 *   is currently processing. See {@link Autolinker.match.Match} subclasses
		 *   for details.
		 */
	
	
		/**
		 * @property {String} version (readonly)
		 *
		 * The Autolinker version number in the form major.minor.patch
		 *
		 * Ex: 0.25.1
		 */
	
		/**
		 * @private
		 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
		 *
		 * The HtmlParser instance used to skip over HTML tags, while finding text
		 * nodes to process. This is lazily instantiated in the {@link #getHtmlParser}
		 * method.
		 */
	
		/**
		 * @private
		 * @property {Autolinker.matcher.Matcher[]} matchers
		 *
		 * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
		 * instance.
		 *
		 * This is lazily created in {@link #getMatchers}.
		 */
	
		/**
		 * @private
		 * @property {Autolinker.AnchorTagBuilder} tagBuilder
		 *
		 * The AnchorTagBuilder instance used to build match replacement anchor tags.
		 * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
		 */
	
	
		/**
		 * Normalizes the {@link #urls} config into an Object with 3 properties:
		 * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
		 *
		 * See {@link #urls} config for details.
		 *
		 * @private
		 * @param {Boolean/Object} urls
		 * @return {Object}
		 */
		normalizeUrlsCfg : function( urls ) {
			if( urls == null ) urls = true;  // default to `true`
	
			if( typeof urls === 'boolean' ) {
				return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };
	
			} else {  // object form
				return {
					schemeMatches : typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
					wwwMatches    : typeof urls.wwwMatches === 'boolean'    ? urls.wwwMatches    : true,
					tldMatches    : typeof urls.tldMatches === 'boolean'    ? urls.tldMatches    : true
				};
			}
		},
	
	
		/**
		 * Normalizes the {@link #truncate} config into an Object with 2 properties:
		 * `length` (Number), and `location` (String).
		 *
		 * See {@link #truncate} config for details.
		 *
		 * @private
		 * @param {Number/Object} truncate
		 * @return {Object}
		 */
		normalizeTruncateCfg : function( truncate ) {
			if( typeof truncate === 'number' ) {
				return { length: truncate, location: 'end' };
	
			} else {  // object, or undefined/null
				return Autolinker.Util.defaults( truncate || {}, {
					length   : Number.POSITIVE_INFINITY,
					location : 'end'
				} );
			}
		},
	
	
		/**
		 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
		 * numbers, username handles, and hashtags (depending on the configuration
		 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
		 * objects describing those matches.
		 *
		 * This method is used by the {@link #link} method, but can also be used to
		 * simply do parsing of the input in order to discover what kinds of links
		 * there are and how many.
		 *
		 * @param {String} textOrHtml The HTML or text to find matches within
		 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
		 *   {@link #twitter}, and {@link #hashtag} options are enabled).
		 * @return {Autolinker.match.Match[]} The array of Matches found in the
		 *   given input `textOrHtml`.
		 */
		parse : function( textOrHtml ) {
			var htmlParser = this.getHtmlParser(),
			    htmlNodes = htmlParser.parse( textOrHtml ),
			    anchorTagStackCount = 0,  // used to only process text around anchor tags, and any inner text/html they may have;
			    matches = [];
	
			// Find all matches within the `textOrHtml` (but not matches that are
			// already nested within <a> tags)
			for( var i = 0, len = htmlNodes.length; i < len; i++ ) {
				var node = htmlNodes[ i ],
				    nodeType = node.getType();
	
				if( nodeType === 'element' && node.getTagName() === 'a' ) {  // Process HTML anchor element nodes in the input `textOrHtml` to find out when we're within an <a> tag
					if( !node.isClosing() ) {  // it's the start <a> tag
						anchorTagStackCount++;
					} else {  // it's the end </a> tag
						anchorTagStackCount = Math.max( anchorTagStackCount - 1, 0 );  // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
					}
	
				} else if( nodeType === 'text' && anchorTagStackCount === 0 ) {  // Process text nodes that are not within an <a> tag
					var textNodeMatches = this.parseText( node.getText(), node.getOffset() );
	
					matches.push.apply( matches, textNodeMatches );
				}
			}
	
	
			// After we have found all matches, remove subsequent matches that
			// overlap with a previous match. This can happen for instance with URLs,
			// where the url 'google.com/#link' would match '#link' as a hashtag.
			matches = this.compactMatches( matches );
	
			// And finally, remove matches for match types that have been turned
			// off. We needed to have all match types turned on initially so that
			// things like hashtags could be filtered out if they were really just
			// part of a URL match (for instance, as a named anchor).
			matches = this.removeUnwantedMatches( matches );
	
			return matches;
		},
	
	
		/**
		 * After we have found all matches, we need to remove subsequent matches
		 * that overlap with a previous match. This can happen for instance with
		 * URLs, where the url 'google.com/#link' would match '#link' as a hashtag.
		 *
		 * @private
		 * @param {Autolinker.match.Match[]} matches
		 * @return {Autolinker.match.Match[]}
		 */
		compactMatches : function( matches ) {
			// First, the matches need to be sorted in order of offset
			matches.sort( function( a, b ) { return a.getOffset() - b.getOffset(); } );
	
			for( var i = 0; i < matches.length - 1; i++ ) {
				var match = matches[ i ],
				    endIdx = match.getOffset() + match.getMatchedText().length;
	
				// Remove subsequent matches that overlap with the current match
				while( i + 1 < matches.length && matches[ i + 1 ].getOffset() <= endIdx ) {
					matches.splice( i + 1, 1 );
				}
			}
	
			return matches;
		},
	
	
		/**
		 * Removes matches for matchers that were turned off in the options. For
		 * example, if {@link #hashtag hashtags} were not to be matched, we'll
		 * remove them from the `matches` array here.
		 *
		 * @private
		 * @param {Autolinker.match.Match[]} matches The array of matches to remove
		 *   the unwanted matches from. Note: this array is mutated for the
		 *   removals.
		 * @return {Autolinker.match.Match[]} The mutated input `matches` array.
		 */
		removeUnwantedMatches : function( matches ) {
			var remove = Autolinker.Util.remove;
	
			if( !this.hashtag ) remove( matches, function( match ) { return match.getType() === 'hashtag'; } );
			if( !this.email )   remove( matches, function( match ) { return match.getType() === 'email'; } );
			if( !this.phone )   remove( matches, function( match ) { return match.getType() === 'phone'; } );
			if( !this.twitter ) remove( matches, function( match ) { return match.getType() === 'twitter'; } );
			if( !this.urls.schemeMatches ) {
				remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'scheme'; } );
			}
			if( !this.urls.wwwMatches ) {
				remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'www'; } );
			}
			if( !this.urls.tldMatches ) {
				remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; } );
			}
	
			return matches;
		},
	
	
		/**
		 * Parses the input `text` looking for URLs, email addresses, phone
		 * numbers, username handles, and hashtags (depending on the configuration
		 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
		 * objects describing those matches.
		 *
		 * This method processes a **non-HTML string**, and is used to parse and
		 * match within the text nodes of an HTML string. This method is used
		 * internally by {@link #parse}.
		 *
		 * @private
		 * @param {String} text The text to find matches within (depending on if the
		 *   {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter}, and
		 *   {@link #hashtag} options are enabled). This must be a non-HTML string.
		 * @param {Number} [offset=0] The offset of the text node within the
		 *   original string. This is used when parsing with the {@link #parse}
		 *   method to generate correct offsets within the {@link Autolinker.match.Match}
		 *   instances, but may be omitted if calling this method publicly.
		 * @return {Autolinker.match.Match[]} The array of Matches found in the
		 *   given input `text`.
		 */
		parseText : function( text, offset ) {
			offset = offset || 0;
			var matchers = this.getMatchers(),
			    matches = [];
	
			for( var i = 0, numMatchers = matchers.length; i < numMatchers; i++ ) {
				var textMatches = matchers[ i ].parseMatches( text );
	
				// Correct the offset of each of the matches. They are originally
				// the offset of the match within the provided text node, but we
				// need to correct them to be relative to the original HTML input
				// string (i.e. the one provided to #parse).
				for( var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++ ) {
					textMatches[ j ].setOffset( offset + textMatches[ j ].getOffset() );
				}
	
				matches.push.apply( matches, textMatches );
			}
			return matches;
		},
	
	
		/**
		 * Automatically links URLs, Email addresses, Phone numbers, Twitter
		 * handles, and Hashtags found in the given chunk of HTML. Does not link
		 * URLs found within HTML tags.
		 *
		 * For instance, if given the text: `You should go to http://www.yahoo.com`,
		 * then the result will be `You should go to
		 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
		 *
		 * This method finds the text around any HTML elements in the input
		 * `textOrHtml`, which will be the text that is processed. Any original HTML
		 * elements will be left as-is, as well as the text that is already wrapped
		 * in anchor (&lt;a&gt;) tags.
		 *
		 * @param {String} textOrHtml The HTML or text to autolink matches within
		 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
		 *   {@link #twitter}, and {@link #hashtag} options are enabled).
		 * @return {String} The HTML, with matches automatically linked.
		 */
		link : function( textOrHtml ) {
			if( !textOrHtml ) { return ""; }  // handle `null` and `undefined`
	
			var matches = this.parse( textOrHtml ),
				newHtml = [],
				lastIndex = 0;
	
			for( var i = 0, len = matches.length; i < len; i++ ) {
				var match = matches[ i ];
	
				newHtml.push( textOrHtml.substring( lastIndex, match.getOffset() ) );
				newHtml.push( this.createMatchReturnVal( match ) );
	
				lastIndex = match.getOffset() + match.getMatchedText().length;
			}
			newHtml.push( textOrHtml.substring( lastIndex ) );  // handle the text after the last match
	
			return newHtml.join( '' );
		},
	
	
		/**
		 * Creates the return string value for a given match in the input string.
		 *
		 * This method handles the {@link #replaceFn}, if one was provided.
		 *
		 * @private
		 * @param {Autolinker.match.Match} match The Match object that represents
		 *   the match.
		 * @return {String} The string that the `match` should be replaced with.
		 *   This is usually the anchor tag string, but may be the `matchStr` itself
		 *   if the match is not to be replaced.
		 */
		createMatchReturnVal : function( match ) {
			// Handle a custom `replaceFn` being provided
			var replaceFnResult;
			if( this.replaceFn ) {
				replaceFnResult = this.replaceFn.call( this, this, match );  // Autolinker instance is the context, and the first arg
			}
	
			if( typeof replaceFnResult === 'string' ) {
				return replaceFnResult;  // `replaceFn` returned a string, use that
	
			} else if( replaceFnResult === false ) {
				return match.getMatchedText();  // no replacement for the match
	
			} else if( replaceFnResult instanceof Autolinker.HtmlTag ) {
				return replaceFnResult.toAnchorString();
	
			} else {  // replaceFnResult === true, or no/unknown return value from function
				// Perform Autolinker's default anchor tag generation
				var anchorTag = match.buildTag();  // returns an Autolinker.HtmlTag instance
	
				return anchorTag.toAnchorString();
			}
		},
	
	
		/**
		 * Lazily instantiates and returns the {@link #htmlParser} instance for this
		 * Autolinker instance.
		 *
		 * @protected
		 * @return {Autolinker.htmlParser.HtmlParser}
		 */
		getHtmlParser : function() {
			var htmlParser = this.htmlParser;
	
			if( !htmlParser ) {
				htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
			}
	
			return htmlParser;
		},
	
	
		/**
		 * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
		 * instances for this Autolinker instance.
		 *
		 * @protected
		 * @return {Autolinker.matcher.Matcher[]}
		 */
		getMatchers : function() {
			if( !this.matchers ) {
				var matchersNs = Autolinker.matcher,
				    tagBuilder = this.getTagBuilder();
	
				var matchers = [
					new matchersNs.Hashtag( { tagBuilder: tagBuilder, serviceName: this.hashtag } ),
					new matchersNs.Email( { tagBuilder: tagBuilder } ),
					new matchersNs.Phone( { tagBuilder: tagBuilder } ),
					new matchersNs.Twitter( { tagBuilder: tagBuilder } ),
					new matchersNs.Url( { tagBuilder: tagBuilder, stripPrefix: this.stripPrefix } )
				];
	
				return ( this.matchers = matchers );
	
			} else {
				return this.matchers;
			}
		},
	
	
		/**
		 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
		 * if it does not yet exist.
		 *
		 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
		 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
		 *
		 *     var html = Autolinker.link( "Test google.com", {
		 *         replaceFn : function( autolinker, match ) {
		 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
		 *             tag.setAttr( 'rel', 'nofollow' );
		 *
		 *             return tag;
		 *         }
		 *     } );
		 *
		 *     // generated html:
		 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
		 *
		 * @return {Autolinker.AnchorTagBuilder}
		 */
		getTagBuilder : function() {
			var tagBuilder = this.tagBuilder;
	
			if( !tagBuilder ) {
				tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder( {
					newWindow   : this.newWindow,
					truncate    : this.truncate,
					className   : this.className
				} );
			}
	
			return tagBuilder;
		}
	
	};
	
	
	// Autolinker Namespaces
	
	Autolinker.match = {};
	Autolinker.matcher = {};
	Autolinker.htmlParser = {};
	Autolinker.truncate = {};
	
	/*global Autolinker */
	/*jshint eqnull:true, boss:true */
	/**
	 * @class Autolinker.Util
	 * @singleton
	 *
	 * A few utility methods for Autolinker.
	 */
	Autolinker.Util = {
	
		/**
		 * @property {Function} abstractMethod
		 *
		 * A function object which represents an abstract method.
		 */
		abstractMethod : function() { throw "abstract"; },
	
	
		/**
		 * @private
		 * @property {RegExp} trimRegex
		 *
		 * The regular expression used to trim the leading and trailing whitespace
		 * from a string.
		 */
		trimRegex : /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
	
		/**
		 * Assigns (shallow copies) the properties of `src` onto `dest`.
		 *
		 * @param {Object} dest The destination object.
		 * @param {Object} src The source object.
		 * @return {Object} The destination object (`dest`)
		 */
		assign : function( dest, src ) {
			for( var prop in src ) {
				if( src.hasOwnProperty( prop ) ) {
					dest[ prop ] = src[ prop ];
				}
			}
	
			return dest;
		},
	
	
		/**
		 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
		 * corresponding property on `dest` === `undefined`.
		 *
		 * @param {Object} dest The destination object.
		 * @param {Object} src The source object.
		 * @return {Object} The destination object (`dest`)
		 */
		defaults : function( dest, src ) {
			for( var prop in src ) {
				if( src.hasOwnProperty( prop ) && dest[ prop ] === undefined ) {
					dest[ prop ] = src[ prop ];
				}
			}
	
			return dest;
		},
	
	
		/**
		 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
		 *
		 * @param {Function} superclass The constructor function for the superclass.
		 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
		 *   special property `constructor`, which will be used as the new subclass's constructor function.
		 * @return {Function} The new subclass function.
		 */
		extend : function( superclass, protoProps ) {
			var superclassProto = superclass.prototype;
	
			var F = function() {};
			F.prototype = superclassProto;
	
			var subclass;
			if( protoProps.hasOwnProperty( 'constructor' ) ) {
				subclass = protoProps.constructor;
			} else {
				subclass = function() { superclassProto.constructor.apply( this, arguments ); };
			}
	
			var subclassProto = subclass.prototype = new F();  // set up prototype chain
			subclassProto.constructor = subclass;  // fix constructor property
			subclassProto.superclass = superclassProto;
	
			delete protoProps.constructor;  // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
			Autolinker.Util.assign( subclassProto, protoProps );
	
			return subclass;
		},
	
	
		/**
		 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
		 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
		 * `len`, the string will be returned unchanged.
		 *
		 * @param {String} str The string to truncate and add an ellipsis to.
		 * @param {Number} truncateLen The length to truncate the string at.
		 * @param {String} [ellipsisChars=..] The ellipsis character(s) to add to the end of `str`
		 *   when truncated. Defaults to '..'
		 */
		ellipsis : function( str, truncateLen, ellipsisChars ) {
			if( str.length > truncateLen ) {
				ellipsisChars = ( ellipsisChars == null ) ? '..' : ellipsisChars;
				str = str.substring( 0, truncateLen - ellipsisChars.length ) + ellipsisChars;
			}
			return str;
		},
	
	
		/**
		 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
		 *
		 * @param {Array} arr The array to find an element of.
		 * @param {*} element The element to find in the array, and return the index of.
		 * @return {Number} The index of the `element`, or -1 if it was not found.
		 */
		indexOf : function( arr, element ) {
			if( Array.prototype.indexOf ) {
				return arr.indexOf( element );
	
			} else {
				for( var i = 0, len = arr.length; i < len; i++ ) {
					if( arr[ i ] === element ) return i;
				}
				return -1;
			}
		},
	
	
		/**
		 * Removes array elements based on a filtering function. Mutates the input
		 * array.
		 *
		 * Using this instead of the ES5 Array.prototype.filter() function, to allow
		 * Autolinker compatibility with IE8, and also to prevent creating many new
		 * arrays in memory for filtering.
		 *
		 * @param {Array} arr The array to remove elements from. This array is
		 *   mutated.
		 * @param {Function} fn A function which should return `true` to
		 *   remove an element.
		 * @return {Array} The mutated input `arr`.
		 */
		remove : function( arr, fn ) {
			for( var i = arr.length - 1; i >= 0; i-- ) {
				if( fn( arr[ i ] ) === true ) {
					arr.splice( i, 1 );
				}
			}
		},
	
	
		/**
		 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
		 * with a regular expression that contains capturing parenthesis.
		 *
		 * For example:
		 *
		 *     // Modern browsers:
		 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
		 *
		 *     // Old IE (including IE8):
		 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
		 *
		 * This method emulates the functionality of modern browsers for the old IE case.
		 *
		 * @param {String} str The string to split.
		 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
		 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
		 *   description of this method.
		 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
		 *   Note #2: for simplicity's sake, the regular expression does not need
		 *   to contain capturing parenthesis - it will be assumed that any match has them.
		 * @return {String[]} The split array of strings, with the splitting character(s) included.
		 */
		splitAndCapture : function( str, splitRegex ) {
			if( !splitRegex.global ) throw new Error( "`splitRegex` must have the 'g' flag set" );
	
			var result = [],
			    lastIdx = 0,
			    match;
	
			while( match = splitRegex.exec( str ) ) {
				result.push( str.substring( lastIdx, match.index ) );
				result.push( match[ 0 ] );  // push the splitting char(s)
	
				lastIdx = match.index + match[ 0 ].length;
			}
			result.push( str.substring( lastIdx ) );
	
			return result;
		},
	
	
		/**
		 * Trims the leading and trailing whitespace from a string.
		 *
		 * @param {String} str The string to trim.
		 * @return {String}
		 */
		trim : function( str ) {
			return str.replace( this.trimRegex, '' );
		}
	
	};
	/*global Autolinker */
	/*jshint boss:true */
	/**
	 * @class Autolinker.HtmlTag
	 * @extends Object
	 *
	 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
	 *
	 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
	 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
	 *
	 * ## Examples
	 *
	 * Example instantiation:
	 *
	 *     var tag = new Autolinker.HtmlTag( {
	 *         tagName : 'a',
	 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
	 *         innerHtml : 'Google'
	 *     } );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *     // Individual accessor methods
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *
	 * Using mutator methods (which may be used in combination with instantiation config properties):
	 *
	 *     var tag = new Autolinker.HtmlTag();
	 *     tag.setTagName( 'a' );
	 *     tag.setAttr( 'href', 'http://google.com' );
	 *     tag.addClass( 'external-link' );
	 *     tag.setInnerHtml( 'Google' );
	 *
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *
	 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 *
	 * ## Example use with a new tag for the replacement
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = new Autolinker.HtmlTag( {
	 *                 tagName : 'button',
	 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
	 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
	 *             } );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
	 */
	Autolinker.HtmlTag = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {String} tagName
		 *
		 * The tag name. Ex: 'a', 'button', etc.
		 *
		 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
		 * is executed.
		 */
	
		/**
		 * @cfg {Object.<String, String>} attrs
		 *
		 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
		 * values are the attribute values.
		 */
	
		/**
		 * @cfg {String} innerHtml
		 *
		 * The inner HTML for the tag.
		 *
		 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
		 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
		 * if you prefer, but this one is recommended.
		 */
	
		/**
		 * @cfg {String} innerHTML
		 *
		 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
		 * for acronym names.
		 */
	
	
		/**
		 * @protected
		 * @property {RegExp} whitespaceRegex
		 *
		 * Regular expression used to match whitespace in a string of CSS classes.
		 */
		whitespaceRegex : /\s+/,
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
	
			this.innerHtml = this.innerHtml || this.innerHTML;  // accept either the camelCased form or the fully capitalized acronym
		},
	
	
		/**
		 * Sets the tag name that will be used to generate the tag with.
		 *
		 * @param {String} tagName
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setTagName : function( tagName ) {
			this.tagName = tagName;
			return this;
		},
	
	
		/**
		 * Retrieves the tag name.
		 *
		 * @return {String}
		 */
		getTagName : function() {
			return this.tagName || "";
		},
	
	
		/**
		 * Sets an attribute on the HtmlTag.
		 *
		 * @param {String} attrName The attribute name to set.
		 * @param {String} attrValue The attribute value to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setAttr : function( attrName, attrValue ) {
			var tagAttrs = this.getAttrs();
			tagAttrs[ attrName ] = attrValue;
	
			return this;
		},
	
	
		/**
		 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
		 *
		 * @param {String} attrName The attribute name to retrieve.
		 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
		 */
		getAttr : function( attrName ) {
			return this.getAttrs()[ attrName ];
		},
	
	
		/**
		 * Sets one or more attributes on the HtmlTag.
		 *
		 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setAttrs : function( attrs ) {
			var tagAttrs = this.getAttrs();
			Autolinker.Util.assign( tagAttrs, attrs );
	
			return this;
		},
	
	
		/**
		 * Retrieves the attributes Object (map) for the HtmlTag.
		 *
		 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
		 */
		getAttrs : function() {
			return this.attrs || ( this.attrs = {} );
		},
	
	
		/**
		 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setClass : function( cssClass ) {
			return this.setAttr( 'class', cssClass );
		},
	
	
		/**
		 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to add.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		addClass : function( cssClass ) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
			    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
			    newClasses = cssClass.split( whitespaceRegex ),
			    newClass;
	
			while( newClass = newClasses.shift() ) {
				if( indexOf( classes, newClass ) === -1 ) {
					classes.push( newClass );
				}
			}
	
			this.getAttrs()[ 'class' ] = classes.join( " " );
			return this;
		},
	
	
		/**
		 * Convenience method to remove one or more CSS classes from the HtmlTag.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to remove.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		removeClass : function( cssClass ) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
			    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
			    removeClasses = cssClass.split( whitespaceRegex ),
			    removeClass;
	
			while( classes.length && ( removeClass = removeClasses.shift() ) ) {
				var idx = indexOf( classes, removeClass );
				if( idx !== -1 ) {
					classes.splice( idx, 1 );
				}
			}
	
			this.getAttrs()[ 'class' ] = classes.join( " " );
			return this;
		},
	
	
		/**
		 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
		 * there are multiple.
		 *
		 * @return {String}
		 */
		getClass : function() {
			return this.getAttrs()[ 'class' ] || "";
		},
	
	
		/**
		 * Convenience method to check if the tag has a CSS class or not.
		 *
		 * @param {String} cssClass The CSS class to check for.
		 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
		 */
		hasClass : function( cssClass ) {
			return ( ' ' + this.getClass() + ' ' ).indexOf( ' ' + cssClass + ' ' ) !== -1;
		},
	
	
		/**
		 * Sets the inner HTML for the tag.
		 *
		 * @param {String} html The inner HTML to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setInnerHtml : function( html ) {
			this.innerHtml = html;
	
			return this;
		},
	
	
		/**
		 * Retrieves the inner HTML for the tag.
		 *
		 * @return {String}
		 */
		getInnerHtml : function() {
			return this.innerHtml || "";
		},
	
	
		/**
		 * Override of superclass method used to generate the HTML string for the tag.
		 *
		 * @return {String}
		 */
		toAnchorString : function() {
			var tagName = this.getTagName(),
			    attrsStr = this.buildAttrsStr();
	
			attrsStr = ( attrsStr ) ? ' ' + attrsStr : '';  // prepend a space if there are actually attributes
	
			return [ '<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>' ].join( "" );
		},
	
	
		/**
		 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
		 * the stringified HtmlTag.
		 *
		 * @protected
		 * @return {String} Example return: `attr1="value1" attr2="value2"`
		 */
		buildAttrsStr : function() {
			if( !this.attrs ) return "";  // no `attrs` Object (map) has been set, return empty string
	
			var attrs = this.getAttrs(),
			    attrsArr = [];
	
			for( var prop in attrs ) {
				if( attrs.hasOwnProperty( prop ) ) {
					attrsArr.push( prop + '="' + attrs[ prop ] + '"' );
				}
			}
			return attrsArr.join( " " );
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.RegexLib
	 * @singleton
	 *
	 * Builds and stores a library of the common regular expressions used by the
	 * Autolinker utility.
	 *
	 * Other regular expressions may exist ad-hoc, but these are generally the
	 * regular expressions that are shared between source files.
	 */
	Autolinker.RegexLib = (function() {
	
		/**
		 * The string form of a regular expression that would match all of the
		 * alphabetic ("letter") chars in the unicode character set when placed in a
		 * RegExp character class (`[]`). This includes all international alphabetic
		 * characters.
		 *
		 * These would be the characters matched by unicode regex engines `\p{L}`
		 * escape ("all letters").
		 *
		 * Taken from the XRegExp library: http://xregexp.com/
		 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
		 *
		 * @private
		 * @type {String}
		 */
		var alphaCharsStr = 'A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
	
		/**
		 * The string form of a regular expression that would match all of the
		 * decimal number chars in the unicode character set when placed in a RegExp
		 * character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `\p{Nd}`
		 * escape ("all decimal numbers")
		 *
		 * Taken from the XRegExp library: http://xregexp.com/
		 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
		 *
		 * @private
		 * @type {String}
		 */
		var decimalNumbersStr = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
	
	
		// See documentation below
		var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;
	
	
		// See documentation below
		var domainNameRegex = new RegExp( '[' + alphaNumericCharsStr + '.\\-]*[' + alphaNumericCharsStr + '\\-]' );
	
	
		// See documentation below
		var tldRegex = /(?:travelersinsurance|sandvikcoromant|kerryproperties|cancerresearch|weatherchannel|kerrylogistics|spreadbetting|international|wolterskluwer|lifeinsurance|construction|pamperedchef|scholarships|versicherung|bridgestone|creditunion|kerryhotels|investments|productions|blackfriday|enterprises|lamborghini|photography|motorcycles|williamhill|playstation|contractors|barclaycard|accountants|redumbrella|engineering|management|telefonica|protection|consulting|tatamotors|creditcard|vlaanderen|schaeffler|associates|properties|foundation|republican|bnpparibas|boehringer|eurovision|extraspace|industries|immobilien|university|technology|volkswagen|healthcare|restaurant|cuisinella|vistaprint|apartments|accountant|travelers|homedepot|institute|vacations|furniture|fresenius|insurance|christmas|bloomberg|solutions|barcelona|firestone|financial|kuokgroup|fairwinds|community|passagens|goldpoint|equipment|lifestyle|yodobashi|aquarelle|marketing|analytics|education|amsterdam|statefarm|melbourne|allfinanz|directory|microsoft|stockholm|montblanc|accenture|lancaster|landrover|everbank|istanbul|graphics|grainger|ipiranga|softbank|attorney|pharmacy|saarland|catering|airforce|yokohama|mortgage|frontier|mutuelle|stcgroup|memorial|pictures|football|symantec|cipriani|ventures|telecity|cityeats|verisign|flsmidth|boutique|cleaning|firmdale|clinique|clothing|redstone|infiniti|deloitte|feedback|services|broadway|plumbing|commbank|training|barclays|exchange|computer|brussels|software|delivery|barefoot|builders|business|bargains|engineer|holdings|download|security|helsinki|lighting|movistar|discount|hdfcbank|supplies|marriott|property|diamonds|capetown|partners|democrat|jpmorgan|bradesco|budapest|rexroth|zuerich|shriram|academy|science|support|youtube|singles|surgery|alibaba|statoil|dentist|schwarz|android|cruises|cricket|digital|markets|starhub|systems|courses|coupons|netbank|country|domains|corsica|network|neustar|realtor|lincoln|limited|schmidt|yamaxun|cooking|contact|auction|spiegel|liaison|leclerc|latrobe|lasalle|abogado|compare|lanxess|exposed|express|company|cologne|college|avianca|lacaixa|fashion|recipes|ferrero|komatsu|storage|wanggou|clubmed|sandvik|fishing|fitness|bauhaus|kitchen|flights|florist|flowers|watches|weather|temasek|samsung|bentley|forsale|channel|theater|frogans|theatre|okinawa|website|tickets|jewelry|gallery|tiffany|iselect|shiksha|brother|organic|wedding|genting|toshiba|origins|philips|hyundai|hotmail|hoteles|hosting|rentals|windows|cartier|bugatti|holiday|careers|whoswho|hitachi|panerai|caravan|reviews|guitars|capital|trading|hamburg|hangout|finance|stream|family|abbott|health|review|travel|report|hermes|hiphop|gratis|career|toyota|hockey|dating|repair|google|social|soccer|reisen|global|otsuka|giving|unicom|casino|photos|center|broker|rocher|orange|bostik|garden|insure|ryukyu|bharti|safety|physio|sakura|oracle|online|jaguar|gallup|piaget|tienda|futbol|pictet|joburg|webcam|berlin|office|juegos|kaufen|chanel|chrome|xihuan|church|tennis|circle|kinder|flickr|bayern|claims|clinic|viajes|nowruz|xperia|norton|yachts|studio|coffee|camera|sanofi|nissan|author|expert|events|comsec|lawyer|tattoo|viking|estate|villas|condos|realty|yandex|energy|emerck|virgin|vision|durban|living|school|coupon|london|taobao|natura|taipei|nagoya|luxury|walter|aramco|sydney|madrid|credit|maison|makeup|schule|market|anquan|direct|design|swatch|suzuki|alsace|vuelos|dental|alipay|voyage|shouji|voting|airtel|mutual|degree|supply|agency|museum|mobily|dealer|monash|select|mormon|active|moscow|racing|datsun|quebec|nissay|rodeo|email|gifts|works|photo|chloe|edeka|cheap|earth|vista|tushu|koeln|glass|shoes|globo|tunes|gmail|nokia|space|kyoto|black|ricoh|seven|lamer|sener|epson|cisco|praxi|trust|citic|crown|shell|lease|green|legal|lexus|ninja|tatar|gripe|nikon|group|video|wales|autos|gucci|party|nexus|guide|linde|adult|parts|amica|lixil|boats|azure|loans|locus|cymru|lotte|lotto|stada|click|poker|quest|dabur|lupin|nadex|paris|faith|dance|canon|place|gives|trade|skype|rocks|mango|cloud|boots|smile|final|swiss|homes|honda|media|horse|cards|deals|watch|bosch|house|pizza|miami|osaka|tours|total|xerox|coach|sucks|style|delta|toray|iinet|tools|money|codes|beats|tokyo|salon|archi|movie|baidu|study|actor|yahoo|store|apple|world|forex|today|bible|tmall|tirol|irish|tires|forum|reise|vegas|vodka|sharp|omega|weber|jetzt|audio|promo|build|bingo|chase|gallo|drive|dubai|rehab|press|solar|sale|beer|bbva|bank|band|auto|sapo|sarl|saxo|audi|asia|arte|arpa|army|yoga|ally|zara|scor|scot|sexy|seat|zero|seek|aero|adac|zone|aarp|maif|meet|meme|menu|surf|mini|mobi|mtpc|porn|desi|star|ltda|name|talk|navy|love|loan|live|link|news|limo|like|spot|life|nico|lidl|lgbt|land|taxi|team|tech|kred|kpmg|sony|song|kiwi|kddi|jprs|jobs|sohu|java|itau|tips|info|immo|icbc|hsbc|town|host|page|toys|here|help|pars|haus|guru|guge|tube|goog|golf|gold|sncf|gmbh|gift|ggee|gent|gbiz|game|vana|pics|fund|ford|ping|pink|fish|film|fast|farm|play|fans|fail|plus|skin|pohl|fage|moda|post|erni|dvag|prod|doha|prof|docs|viva|diet|luxe|site|dell|sina|dclk|show|qpon|date|vote|cyou|voto|read|coop|cool|wang|club|city|chat|cern|cash|reit|rent|casa|cars|care|camp|rest|call|cafe|weir|wien|rich|wiki|buzz|wine|book|bond|room|work|rsvp|shia|ruhr|blue|bing|shaw|bike|safe|xbox|best|pwc|mtn|lds|aig|boo|fyi|nra|nrw|ntt|car|gal|obi|zip|aeg|vin|how|one|ong|onl|dad|ooo|bet|esq|org|htc|bar|uol|ibm|ovh|gdn|ice|icu|uno|gea|ifm|bot|top|wtf|lol|day|pet|eus|wtc|ubs|tvs|aco|ing|ltd|ink|tab|abb|afl|cat|int|pid|pin|bid|cba|gle|com|cbn|ads|man|wed|ceb|gmo|sky|ist|gmx|tui|mba|fan|ski|iwc|app|pro|med|ceo|jcb|jcp|goo|dev|men|aaa|meo|pub|jlc|bom|jll|gop|jmp|mil|got|gov|win|jot|mma|joy|trv|red|cfa|cfd|bio|moe|moi|mom|ren|biz|aws|xin|bbc|dnp|buy|kfh|mov|thd|xyz|fit|kia|rio|rip|kim|dog|vet|nyc|bcg|mtr|bcn|bms|bmw|run|bzh|rwe|tel|stc|axa|kpn|fly|krd|cab|bnl|foo|crs|eat|tci|sap|srl|nec|sas|net|cal|sbs|sfr|sca|scb|csc|edu|new|xxx|hiv|fox|wme|ngo|nhk|vip|sex|frl|lat|yun|law|you|tax|soy|sew|om|ac|hu|se|sc|sg|sh|sb|sa|rw|ru|rs|ro|re|qa|py|si|pw|pt|ps|sj|sk|pr|pn|pm|pl|sl|sm|pk|sn|ph|so|pg|pf|pe|pa|zw|nz|nu|nr|np|no|nl|ni|ng|nf|sr|ne|st|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|su|mn|mm|ml|mk|mh|mg|me|sv|md|mc|sx|sy|ma|ly|lv|sz|lu|lt|ls|lr|lk|li|lc|lb|la|tc|kz|td|ky|kw|kr|kp|kn|km|ki|kh|tf|tg|th|kg|ke|jp|jo|jm|je|it|is|ir|tj|tk|tl|tm|iq|tn|to|io|in|im|il|ie|ad|sd|ht|hr|hn|hm|tr|hk|gy|gw|gu|gt|gs|gr|gq|tt|gp|gn|gm|gl|tv|gi|tw|tz|ua|gh|ug|uk|gg|gf|ge|gd|us|uy|uz|va|gb|ga|vc|ve|fr|fo|fm|fk|fj|vg|vi|fi|eu|et|es|er|eg|ee|ec|dz|do|dm|dk|vn|dj|de|cz|cy|cx|cw|vu|cv|cu|cr|co|cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|wf|bz|by|bw|bv|bt|bs|br|bo|bn|bm|bj|bi|ws|bh|bg|bf|be|bd|bb|ba|az|ax|aw|au|at|as|ye|ar|aq|ao|am|al|yt|ai|za|ag|af|ae|zm|id)\b/;
	
	
		return {
	
			/**
			 * The string form of a regular expression that would match all of the
			 * letters and decimal number chars in the unicode character set when placed
			 * in a RegExp character class (`[]`).
			 *
			 * These would be the characters matched by unicode regex engines `[\p{L}\p{Nd}]`
			 * escape ("all letters and decimal numbers")
			 *
			 * @property {String} alphaNumericCharsStr
			 */
			alphaNumericCharsStr : alphaNumericCharsStr,
	
			/**
			 * A regular expression to match domain names of a URL or email address.
			 * Ex: 'google', 'yahoo', 'some-other-company', etc.
			 *
			 * @property {RegExp} domainNameRegex
			 */
			domainNameRegex : domainNameRegex,
	
			/**
			 * A regular expression to match top level domains (TLDs) for a URL or
			 * email address. Ex: 'com', 'org', 'net', etc.
			 *
			 * @property {RegExp} tldRegex
			 */
			tldRegex : tldRegex
	
		};
	
	
	}() );
	/*global Autolinker */
	/*jshint sub:true */
	/**
	 * @protected
	 * @class Autolinker.AnchorTagBuilder
	 * @extends Object
	 *
	 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
	 * found.
	 *
	 * Normally this class is instantiated, configured, and used internally by an
	 * {@link Autolinker} instance, but may actually be retrieved in a {@link Autolinker#replaceFn replaceFn}
	 * to create {@link Autolinker.HtmlTag HtmlTag} instances which may be modified
	 * before returning from the {@link Autolinker#replaceFn replaceFn}. For
	 * example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 */
	Autolinker.AnchorTagBuilder = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Boolean} newWindow
		 * @inheritdoc Autolinker#newWindow
		 */
	
		/**
		 * @cfg {Object} truncate
		 * @inheritdoc Autolinker#truncate
		 */
	
		/**
		 * @cfg {String} className
		 * @inheritdoc Autolinker#className
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
		},
	
	
		/**
		 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
		 * matched text, via its `match` object.
		 *
		 * @param {Autolinker.match.Match} match The Match instance to generate an
		 *   anchor tag from.
		 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
		 */
		build : function( match ) {
			return new Autolinker.HtmlTag( {
				tagName   : 'a',
				attrs     : this.createAttrs( match.getType(), match.getAnchorHref() ),
				innerHtml : this.processAnchorText( match.getAnchorText() )
			} );
		},
	
	
		/**
		 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
		 *   tag being generated.
		 *
		 * @protected
		 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
		 *   match that an anchor tag is being generated for.
		 * @param {String} anchorHref The href for the anchor tag.
		 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
		 */
		createAttrs : function( matchType, anchorHref ) {
			var attrs = {
				'href' : anchorHref  // we'll always have the `href` attribute
			};
	
			var cssClass = this.createCssClass( matchType );
			if( cssClass ) {
				attrs[ 'class' ] = cssClass;
			}
			if( this.newWindow ) {
				attrs[ 'target' ] = "_blank";
				attrs[ 'rel' ] = "noopener noreferrer";
			}
	
			return attrs;
		},
	
	
		/**
		 * Creates the CSS class that will be used for a given anchor tag, based on
		 * the `matchType` and the {@link #className} config.
		 *
		 * @private
		 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
		 *   match that an anchor tag is being generated for.
		 * @return {String} The CSS class string for the link. Example return:
		 *   "myLink myLink-url". If no {@link #className} was configured, returns
		 *   an empty string.
		 */
		createCssClass : function( matchType ) {
			var className = this.className;
	
			if( !className )
				return "";
			else
				return className + " " + className + "-" + matchType;  // ex: "myLink myLink-url", "myLink myLink-email", "myLink myLink-phone", "myLink myLink-twitter", or "myLink myLink-hashtag"
		},
	
	
		/**
		 * Processes the `anchorText` by truncating the text according to the
		 * {@link #truncate} config.
		 *
		 * @private
		 * @param {String} anchorText The anchor tag's text (i.e. what will be
		 *   displayed).
		 * @return {String} The processed `anchorText`.
		 */
		processAnchorText : function( anchorText ) {
			anchorText = this.doTruncate( anchorText );
	
			return anchorText;
		},
	
	
		/**
		 * Performs the truncation of the `anchorText` based on the {@link #truncate}
		 * option. If the `anchorText` is longer than the length specified by the
		 * {@link #truncate} option, the truncation is performed based on the
		 * `location` property. See {@link #truncate} for details.
		 *
		 * @private
		 * @param {String} anchorText The anchor tag's text (i.e. what will be
		 *   displayed).
		 * @return {String} The truncated anchor text.
		 */
		doTruncate : function( anchorText ) {
			var truncate = this.truncate;
			if( !truncate || !truncate.length ) return anchorText;
	
			var truncateLength = truncate.length,
				truncateLocation = truncate.location;
	
			if( truncateLocation === 'smart' ) {
				return Autolinker.truncate.TruncateSmart( anchorText, truncateLength, '..' );
	
			} else if( truncateLocation === 'middle' ) {
				return Autolinker.truncate.TruncateMiddle( anchorText, truncateLength, '..' );
	
			} else {
				return Autolinker.truncate.TruncateEnd( anchorText, truncateLength, '..' );
			}
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.HtmlParser
	 * @extends Object
	 *
	 * An HTML parser implementation which simply walks an HTML string and returns an array of
	 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
	 *
	 * Autolinker uses this to only link URLs/emails/Twitter handles within text nodes, effectively ignoring / "walking
	 * around" HTML tags.
	 */
	Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend( Object, {
	
		/**
		 * @private
		 * @property {RegExp} htmlRegex
		 *
		 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
		 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
		 *
		 * Capturing groups:
		 *
		 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
		 * 2. If it is an end tag, this group will have the '/'.
		 * 3. If it is a comment tag, this group will hold the comment text (i.e.
		 *    the text inside the `&lt;!--` and `--&gt;`.
		 * 4. The tag name for all tags (other than the &lt;!DOCTYPE&gt; tag)
		 */
		htmlRegex : (function() {
			var commentTagRegex = /!--([\s\S]+?)--/,
			    tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
			    attrNameRegex = /[^\s\0"'>\/=\x01-\x1F\x7F]+/,   // the unicode range accounts for excluding control chars, and the delete char
			    attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, // double quoted, single quoted, or unquoted attribute values
			    nameEqualsValueRegex = attrNameRegex.source + '(?:\\s*=\\s*' + attrValueRegex.source + ')?';  // optional '=[value]'
	
			return new RegExp( [
				// for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
				'(?:',
					'<(!DOCTYPE)',  // *** Capturing Group 1 - If it's a doctype tag
	
						// Zero or more attributes following the tag name
						'(?:',
							'\\s+',  // one or more whitespace chars before an attribute
	
							// Either:
							// A. attr="value", or
							// B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
							'(?:', nameEqualsValueRegex, '|', attrValueRegex.source + ')',
						')*',
					'>',
				')',
	
				'|',
	
				// All other HTML tags (i.e. tags that are not <!DOCTYPE>)
				'(?:',
					'<(/)?',  // Beginning of a tag or comment. Either '<' for a start tag, or '</' for an end tag.
					          // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.
	
						'(?:',
							commentTagRegex.source,  // *** Capturing Group 3 - A Comment Tag's Text
	
							'|',
	
							'(?:',
	
								// *** Capturing Group 4 - The tag name
								'(' + tagNameRegex.source + ')',
	
								// Zero or more attributes following the tag name
								'(?:',
									'\\s*',                // any number of whitespace chars before an attribute
									nameEqualsValueRegex,  // attr="value" (with optional ="value" part)
								')*',
	
								'\\s*/?',  // any trailing spaces and optional '/' before the closing '>'
	
							')',
						')',
					'>',
				')'
			].join( "" ), 'gi' );
		} )(),
	
		/**
		 * @private
		 * @property {RegExp} htmlCharacterEntitiesRegex
		 *
		 * The regular expression that matches common HTML character entities.
		 *
		 * Ignoring &amp; as it could be part of a query string -- handling it separately.
		 */
		htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,
	
	
		/**
		 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
		 * to represent the HTML structure of the input string.
		 *
		 * @param {String} html The HTML to parse.
		 * @return {Autolinker.htmlParser.HtmlNode[]}
		 */
		parse : function( html ) {
			var htmlRegex = this.htmlRegex,
			    currentResult,
			    lastIndex = 0,
			    textAndEntityNodes,
			    nodes = [];  // will be the result of the method
	
			while( ( currentResult = htmlRegex.exec( html ) ) !== null ) {
				var tagText = currentResult[ 0 ],
				    commentText = currentResult[ 3 ], // if we've matched a comment
				    tagName = currentResult[ 1 ] || currentResult[ 4 ],  // The <!DOCTYPE> tag (ex: "!DOCTYPE"), or another tag (ex: "a" or "img")
				    isClosingTag = !!currentResult[ 2 ],
				    offset = currentResult.index,
				    inBetweenTagsText = html.substring( lastIndex, offset );
	
				// Push TextNodes and EntityNodes for any text found between tags
				if( inBetweenTagsText ) {
					textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, inBetweenTagsText );
					nodes.push.apply( nodes, textAndEntityNodes );
				}
	
				// Push the CommentNode or ElementNode
				if( commentText ) {
					nodes.push( this.createCommentNode( offset, tagText, commentText ) );
				} else {
					nodes.push( this.createElementNode( offset, tagText, tagName, isClosingTag ) );
				}
	
				lastIndex = offset + tagText.length;
			}
	
			// Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
			if( lastIndex < html.length ) {
				var text = html.substring( lastIndex );
	
				// Push TextNodes and EntityNodes for any text found between tags
				if( text ) {
					textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, text );
					nodes.push.apply( nodes, textAndEntityNodes );
				}
			}
	
			return nodes;
		},
	
	
		/**
		 * Parses text and HTML entity nodes from a given string. The input string
		 * should not have any HTML tags (elements) within it.
		 *
		 * @private
		 * @param {Number} offset The offset of the text node match within the
		 *   original HTML string.
		 * @param {String} text The string of text to parse. This is from an HTML
		 *   text node.
		 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
		 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
		 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
		 */
		parseTextAndEntityNodes : function( offset, text ) {
			var nodes = [],
			    textAndEntityTokens = Autolinker.Util.splitAndCapture( text, this.htmlCharacterEntitiesRegex );  // split at HTML entities, but include the HTML entities in the results array
	
			// Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
			// For example: an input `text` of "Test &quot;this&quot; today" would turn into the
			//   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
			for( var i = 0, len = textAndEntityTokens.length; i < len; i += 2 ) {
				var textToken = textAndEntityTokens[ i ],
				    entityToken = textAndEntityTokens[ i + 1 ];
	
				if( textToken ) {
					nodes.push( this.createTextNode( offset, textToken ) );
					offset += textToken.length;
				}
				if( entityToken ) {
					nodes.push( this.createEntityNode( offset, entityToken ) );
					offset += entityToken.length;
				}
			}
			return nodes;
		},
	
	
		/**
		 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} tagText The full text of the tag (comment) that was
		 *   matched, including its &lt;!-- and --&gt;.
		 * @param {String} commentText The full text of the comment that was matched.
		 */
		createCommentNode : function( offset, tagText, commentText ) {
			return new Autolinker.htmlParser.CommentNode( {
				offset : offset,
				text   : tagText,
				comment: Autolinker.Util.trim( commentText )
			} );
		},
	
	
		/**
		 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} tagText The full text of the tag (element) that was
		 *   matched, including its attributes.
		 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
		 *   be passed to this method as "img".
		 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
		 *   otherwise.
		 * @return {Autolinker.htmlParser.ElementNode}
		 */
		createElementNode : function( offset, tagText, tagName, isClosingTag ) {
			return new Autolinker.htmlParser.ElementNode( {
				offset  : offset,
				text    : tagText,
				tagName : tagName.toLowerCase(),
				closing : isClosingTag
			} );
		},
	
	
		/**
		 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} text The text that was matched for the HTML entity (such
		 *   as '&amp;nbsp;').
		 * @return {Autolinker.htmlParser.EntityNode}
		 */
		createEntityNode : function( offset, text ) {
			return new Autolinker.htmlParser.EntityNode( { offset: offset, text: text } );
		},
	
	
		/**
		 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
		 *
		 * @private
		 * @param {Number} offset The offset of the match within the original HTML
		 *   string.
		 * @param {String} text The text that was matched.
		 * @return {Autolinker.htmlParser.TextNode}
		 */
		createTextNode : function( offset, text ) {
			return new Autolinker.htmlParser.TextNode( { offset: offset, text: text } );
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML node found in an input string. An HTML node is one of the
	 * following:
	 *
	 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
	 *    HTML tags.
	 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
	 *    HTML comments.
	 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
	 *    outside or within HTML tags.
	 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
	 *    one of the known HTML entities that Autolinker looks for. This includes
	 *    common ones such as &amp;quot; and &amp;nbsp;
	 */
	Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Number} offset (required)
		 *
		 * The offset of the HTML node in the original text that was parsed.
		 */
		offset : undefined,
	
		/**
		 * @cfg {String} text (required)
		 *
		 * The text that was matched for the HtmlNode.
		 *
		 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
		 *   this will be the tag's text.
		 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
		 *   this will be the comment's text.
		 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
		 *   will be the text itself.
		 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
		 *   this will be the text of the HTML entity.
		 */
		text : undefined,
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 * specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
	
			if( this.offset == null ) throw new Error( '`offset` cfg required' );
			if( this.text == null ) throw new Error( '`text` cfg required' );
		},
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @abstract
		 * @return {String}
		 */
		getType : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Retrieves the {@link #offset} of the HtmlNode. This is the offset of the
		 * HTML node in the original string that was parsed.
		 *
		 * @return {Number}
		 */
		getOffset : function() {
			return this.offset;
		},
	
	
		/**
		 * Retrieves the {@link #text} for the HtmlNode.
		 *
		 * @return {String}
		 */
		getText : function() {
			return this.text;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.CommentNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML comment node that has been parsed by the
	 * {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.CommentNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * @cfg {String} comment (required)
		 *
		 * The text inside the comment tag. This text is stripped of any leading or
		 * trailing whitespace.
		 */
		comment : '',
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'comment';
		},
	
	
		/**
		 * Returns the comment inside the comment tag.
		 *
		 * @return {String}
		 */
		getComment : function() {
			return this.comment;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.ElementNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.ElementNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * @cfg {String} tagName (required)
		 *
		 * The name of the tag that was matched.
		 */
		tagName : '',
	
		/**
		 * @cfg {Boolean} closing (required)
		 *
		 * `true` if the element (tag) is a closing tag, `false` if its an opening
		 * tag.
		 */
		closing : false,
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'element';
		},
	
	
		/**
		 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
		 * returns "img".
		 *
		 * @return {String}
		 */
		getTagName : function() {
			return this.tagName;
		},
	
	
		/**
		 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
		 * returns `false`, while &lt;/div&gt; returns `true`.
		 *
		 * @return {Boolean}
		 */
		isClosing : function() {
			return this.closing;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.EntityNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
	 * method.
	 *
	 * Note that this class will only be returned from the HtmlParser for the set of
	 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.EntityNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'entity';
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.TextNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.TextNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'text';
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.match.Match
	 *
	 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
	 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, and Twitter Handles
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( autolinker, match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                 case 'email' :
	 *                     console.log( "email: ", match.getEmail() );
	 *
	 *                 case 'twitter' :
	 *                     console.log( "twitter: ", match.getTwitterHandle() );
	 *             }
	 *         }
	 *     } );
	 *
	 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
	 */
	Autolinker.match.Match = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
		 *
		 * Reference to the AnchorTagBuilder instance to use to generate an anchor
		 * tag for the Match.
		 */
	
		/**
		 * @cfg {String} matchedText (required)
		 *
		 * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
		 */
	
		/**
		 * @cfg {Number} offset (required)
		 *
		 * The offset of where the match was made in the input string.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			if( cfg.tagBuilder == null ) throw new Error( '`tagBuilder` cfg required' );
			if( cfg.matchedText == null ) throw new Error( '`matchedText` cfg required' );
			if( cfg.offset == null ) throw new Error( '`offset` cfg required' );
	
			this.tagBuilder = cfg.tagBuilder;
			this.matchedText = cfg.matchedText;
			this.offset = cfg.offset;
		},
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @abstract
		 * @return {String}
		 */
		getType : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Returns the original text that was matched.
		 *
		 * @return {String}
		 */
		getMatchedText : function() {
			return this.matchedText;
		},
	
	
		/**
		 * Sets the {@link #offset} of where the match was made in the input string.
		 *
		 * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
		 * and will therefore set an original offset that is relative to the HTML
		 * text node itself. However, we want this offset to be relative to the full
		 * HTML input string, and thus if using {@link Autolinker#parse} (rather
		 * than calling a {@link Autolinker.matcher.Matcher} directly), then this
		 * offset is corrected after the Matcher itself has done its job.
		 *
		 * @param {Number} offset
		 */
		setOffset : function( offset ) {
			this.offset = offset;
		},
	
	
		/**
		 * Returns the offset of where the match was made in the input string. This
		 * is the 0-based index of the match.
		 *
		 * @return {Number}
		 */
		getOffset : function() {
			return this.offset;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @abstract
		 * @return {String}
		 */
		getAnchorHref : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @abstract
		 * @return {String}
		 */
		getAnchorText : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
		 * Match.
		 *
		 * This can be used to easily generate anchor tags from matches, and either
		 * return their HTML string, or modify them before doing so.
		 *
		 * Example Usage:
		 *
		 *     var tag = match.buildTag();
		 *     tag.addClass( 'cordova-link' );
		 *     tag.setAttr( 'target', '_system' );
		 *
		 *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
		 */
		buildTag : function() {
			return this.tagBuilder.build( this );
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Email
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Email match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Email = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} email (required)
		 *
		 * The email address that was matched.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( !cfg.email ) throw new Error( '`email` cfg required' );
	
			this.email = cfg.email;
		},
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'email';
		},
	
	
		/**
		 * Returns the email address that was matched.
		 *
		 * @return {String}
		 */
		getEmail : function() {
			return this.email;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'mailto:' + this.email;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return this.email;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Hashtag
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Hashtag match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	Autolinker.match.Hashtag = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} serviceName
		 *
		 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
		 * for available values.
		 */
	
		/**
		 * @cfg {String} hashtag (required)
		 *
		 * The Hashtag that was matched, without the '#'.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			// TODO: if( !serviceName ) throw new Error( '`serviceName` cfg required' );
			if( !cfg.hashtag ) throw new Error( '`hashtag` cfg required' );
	
			this.serviceName = cfg.serviceName;
			this.hashtag = cfg.hashtag;
		},
	
	
		/**
		 * Returns the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'hashtag';
		},
	
	
		/**
		 * Returns the configured {@link #serviceName} to point the Hashtag to.
		 * Ex: 'facebook', 'twitter'.
		 *
		 * @return {String}
		 */
		getServiceName : function() {
			return this.serviceName;
		},
	
	
		/**
		 * Returns the matched hashtag, without the '#' character.
		 *
		 * @return {String}
		 */
		getHashtag : function() {
			return this.hashtag;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			var serviceName = this.serviceName,
			    hashtag = this.hashtag;
	
			switch( serviceName ) {
				case 'twitter' :
					return 'https://twitter.com/hashtag/' + hashtag;
				case 'facebook' :
					return 'https://www.facebook.com/hashtag/' + hashtag;
				case 'instagram' :
					return 'https://instagram.com/explore/tags/' + hashtag;
	
				default :  // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
					throw new Error( 'Unknown service name to point hashtag to: ', serviceName );
			}
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return '#' + this.hashtag;
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Phone
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Phone number match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	Autolinker.match.Phone = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @protected
		 * @property {String} number (required)
		 *
		 * The phone number that was matched, without any delimiter characters.
		 *
		 * Note: This is a string to allow for prefixed 0's.
		 */
	
		/**
		 * @protected
		 * @property  {Boolean} plusSign (required)
		 *
		 * `true` if the matched phone number started with a '+' sign. We'll include
		 * it in the `tel:` URL if so, as this is needed for international numbers.
		 *
		 * Ex: '+1 (123) 456 7879'
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( !cfg.number ) throw new Error( '`number` cfg required' );
			if( cfg.plusSign == null ) throw new Error( '`plusSign` cfg required' );
	
			this.number = cfg.number;
			this.plusSign = cfg.plusSign;
		},
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'phone';
		},
	
	
		/**
		 * Returns the phone number that was matched as a string, without any
		 * delimiter characters.
		 *
		 * Note: This is a string to allow for prefixed 0's.
		 *
		 * @return {String}
		 */
		getNumber: function() {
			return this.number;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'tel:' + ( this.plusSign ? '+' : '' ) + this.number;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return this.matchedText;
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Twitter
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Twitter match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Twitter = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} twitterHandle (required)
		 *
		 * The Twitter handle that was matched, without the '@' character.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( !cfg.twitterHandle ) throw new Error( '`twitterHandle` cfg required' );
	
			this.twitterHandle = cfg.twitterHandle;
		},
	
	
		/**
		 * Returns the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'twitter';
		},
	
	
		/**
		 * Returns the twitter handle, without the '@' character.
		 *
		 * @return {String}
		 */
		getTwitterHandle : function() {
			return this.twitterHandle;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'https://twitter.com/' + this.twitterHandle;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return '@' + this.twitterHandle;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Url
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Url match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Url = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} url (required)
		 *
		 * The url that was matched.
		 */
	
		/**
		 * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
		 *
		 * The type of URL match that this class represents. This helps to determine
		 * if the match was made in the original text with a prefixed scheme (ex:
		 * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
		 * was matched by a known top-level domain (ex: 'google.com').
		 */
	
		/**
		 * @cfg {Boolean} protocolUrlMatch (required)
		 *
		 * `true` if the URL is a match which already has a protocol (i.e.
		 * 'http://'), `false` if the match was from a 'www' or known TLD match.
		 */
	
		/**
		 * @cfg {Boolean} protocolRelativeMatch (required)
		 *
		 * `true` if the URL is a protocol-relative match. A protocol-relative match
		 * is a URL that starts with '//', and will be either http:// or https://
		 * based on the protocol that the site is loaded under.
		 */
	
		/**
		 * @cfg {Boolean} stripPrefix (required)
		 * @inheritdoc Autolinker#cfg-stripPrefix
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.match.Match.prototype.constructor.call( this, cfg );
	
			if( cfg.urlMatchType !== 'scheme' && cfg.urlMatchType !== 'www' && cfg.urlMatchType !== 'tld' ) throw new Error( '`urlMatchType` cfg must be one of: "scheme", "www", or "tld"' );
			if( !cfg.url ) throw new Error( '`url` cfg required' );
			if( cfg.protocolUrlMatch == null ) throw new Error( '`protocolUrlMatch` cfg required' );
			if( cfg.protocolRelativeMatch == null ) throw new Error( '`protocolRelativeMatch` cfg required' );
			if( cfg.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
	
			this.urlMatchType = cfg.urlMatchType;
			this.url = cfg.url;
			this.protocolUrlMatch = cfg.protocolUrlMatch;
			this.protocolRelativeMatch = cfg.protocolRelativeMatch;
			this.stripPrefix = cfg.stripPrefix;
		},
	
	
		/**
		 * @private
		 * @property {RegExp} urlPrefixRegex
		 *
		 * A regular expression used to remove the 'http://' or 'https://' and/or the 'www.' from URLs.
		 */
		urlPrefixRegex: /^(https?:\/\/)?(www\.)?/i,
	
		/**
		 * @private
		 * @property {RegExp} protocolRelativeRegex
		 *
		 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
		 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
		 */
		protocolRelativeRegex : /^\/\//,
	
		/**
		 * @private
		 * @property {Boolean} protocolPrepended
		 *
		 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
		 * {@link #url} did not have a protocol)
		 */
		protocolPrepended : false,
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'url';
		},
	
	
		/**
		 * Returns a string name for the type of URL match that this class
		 * represents.
		 *
		 * This helps to determine if the match was made in the original text with a
		 * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
		 * 'www.google.com'), or was matched by a known top-level domain (ex:
		 * 'google.com').
		 *
		 * @return {"scheme"/"www"/"tld"}
		 */
		getUrlMatchType : function() {
			return this.urlMatchType;
		},
	
	
		/**
		 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
		 * match was missing a protocol.
		 *
		 * @return {String}
		 */
		getUrl : function() {
			var url = this.url;
	
			// if the url string doesn't begin with a protocol, assume 'http://'
			if( !this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended ) {
				url = this.url = 'http://' + url;
	
				this.protocolPrepended = true;
			}
	
			return url;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			var url = this.getUrl();
	
			return url.replace( /&amp;/g, '&' );  // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			var anchorText = this.getMatchedText();
	
			if( this.protocolRelativeMatch ) {
				// Strip off any protocol-relative '//' from the anchor text
				anchorText = this.stripProtocolRelativePrefix( anchorText );
			}
			if( this.stripPrefix ) {
				anchorText = this.stripUrlPrefix( anchorText );
			}
			anchorText = this.removeTrailingSlash( anchorText );  // remove trailing slash, if there is one
	
			return anchorText;
		},
	
	
		// ---------------------------------------
	
		// Utility Functionality
	
		/**
		 * Strips the URL prefix (such as "http://" or "https://") from the given text.
		 *
		 * @private
		 * @param {String} text The text of the anchor that is being generated, for which to strip off the
		 *   url prefix (such as stripping off "http://")
		 * @return {String} The `anchorText`, with the prefix stripped.
		 */
		stripUrlPrefix : function( text ) {
			return text.replace( this.urlPrefixRegex, '' );
		},
	
	
		/**
		 * Strips any protocol-relative '//' from the anchor text.
		 *
		 * @private
		 * @param {String} text The text of the anchor that is being generated, for which to strip off the
		 *   protocol-relative prefix (such as stripping off "//")
		 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
		 */
		stripProtocolRelativePrefix : function( text ) {
			return text.replace( this.protocolRelativeRegex, '' );
		},
	
	
		/**
		 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
		 *
		 * @private
		 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
		 *   slash ('/') that may exist.
		 * @return {String} The `anchorText`, with the trailing slash removed.
		 */
		removeTrailingSlash : function( anchorText ) {
			if( anchorText.charAt( anchorText.length - 1 ) === '/' ) {
				anchorText = anchorText.slice( 0, -1 );
			}
			return anchorText;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.matcher.Matcher
	 *
	 * An abstract class and interface for individual matchers to find matches in
	 * an input string with linkified versions of them.
	 *
	 * Note that Matchers do not take HTML into account - they must be fed the text
	 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
	 */
	Autolinker.matcher.Matcher = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
		 *
		 * Reference to the AnchorTagBuilder instance to use to generate HTML tags
		 * for {@link Autolinker.match.Match Matches}.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Matcher
		 *   instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			if( !cfg.tagBuilder ) throw new Error( '`tagBuilder` cfg required' );
	
			this.tagBuilder = cfg.tagBuilder;
		},
	
	
		/**
		 * Parses the input `text` and returns the array of {@link Autolinker.match.Match Matches}
		 * for the matcher.
		 *
		 * @abstract
		 * @param {String} text The text to scan and replace matches in.
		 * @return {Autolinker.match.Match[]}
		 */
		parseMatches : Autolinker.Util.abstractMethod
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Email
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find email matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
	 */
	Autolinker.matcher.Email = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * The regular expression to match email addresses. Example match:
		 *
		 *     person@place.com
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : (function() {
			var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr,
			    emailRegex = new RegExp( '[' + alphaNumericChars + '\\-\\_;:&=+$.,]+@' ),  // something@ for email addresses (a.k.a. local-part)
				domainNameRegex = Autolinker.RegexLib.domainNameRegex,
				tldRegex = Autolinker.RegexLib.tldRegex;  // match our known top level domains (TLDs)
	
			return new RegExp( [
				emailRegex.source,
				domainNameRegex.source,
				'\\.', tldRegex.source   // '.com', '.net', etc
			].join( "" ), 'gi' );
		} )(),
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var matchedText = match[ 0 ];
	
				matches.push( new Autolinker.match.Email( {
					tagBuilder  : tagBuilder,
					matchedText : matchedText,
					offset      : match.index,
					email       : matchedText
				} ) );
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Hashtag
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find Hashtag matches in an input string.
	 */
	Autolinker.matcher.Hashtag = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * @cfg {String} serviceName
		 *
		 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
		 * for available values.
		 */
	
	
		/**
		 * The regular expression to match Hashtags. Example match:
		 *
		 *     #asdf
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : new RegExp( '#[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,139}', 'g' ),
	
		/**
		 * The regular expression to use to check the character before a username match to
		 * make sure we didn't accidentally match an email address.
		 *
		 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
		 *
		 * @private
		 * @property {RegExp} nonWordCharRegex
		 */
		nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 *   specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );
	
			this.serviceName = cfg.serviceName;
		},
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    nonWordCharRegex = this.nonWordCharRegex,
			    serviceName = this.serviceName,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var offset = match.index,
				    prevChar = text.charAt( offset - 1 );
	
				// If we found the match at the beginning of the string, or we found the match
				// and there is a whitespace char in front of it (meaning it is not a '#' char
				// in the middle of a word), then it is a hashtag match.
				if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
					var matchedText = match[ 0 ],
					    hashtag = match[ 0 ].slice( 1 );  // strip off the '#' character at the beginning
	
					matches.push( new Autolinker.match.Hashtag( {
						tagBuilder  : tagBuilder,
						matchedText : matchedText,
						offset      : offset,
						serviceName : serviceName,
						hashtag     : hashtag
					} ) );
				}
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Phone
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find Phone number matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
	 * details.
	 */
	Autolinker.matcher.Phone = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * The regular expression to match Phone numbers. Example match:
		 *
		 *     (123) 456-7890
		 *
		 * This regular expression has the following capturing groups:
		 *
		 * 1. The prefixed '+' sign, if there is one.
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : /(?:(\+)?\d{1,3}[-\040.])?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]\d{4}/g,  // ex: (123) 456-7890, 123 456 7890, 123-456-7890, etc.
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				// Remove non-numeric values from phone number string
				var matchedText = match[ 0 ],
				    cleanNumber = matchedText.replace( /\D/g, '' ),  // strip out non-digit characters
				    plusSign = !!match[ 1 ];  // match[ 1 ] is the prefixed plus sign, if there is one
	
				matches.push( new Autolinker.match.Phone( {
					tagBuilder  : tagBuilder,
					matchedText : matchedText,
					offset      : match.index,
					number      : cleanNumber,
					plusSign    : plusSign
				} ) );
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Twitter
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find/replace username matches in an input string.
	 */
	Autolinker.matcher.Twitter = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * The regular expression to match username handles. Example match:
		 *
		 *     @asdf
		 *
		 * @private
		 * @property {RegExp} matcherRegex
		 */
		matcherRegex : new RegExp( '@[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,20}', 'g' ),
	
		/**
		 * The regular expression to use to check the character before a username match to
		 * make sure we didn't accidentally match an email address.
		 *
		 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
		 *
		 * @private
		 * @property {RegExp} nonWordCharRegex
		 */
		nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    nonWordCharRegex = this.nonWordCharRegex,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var offset = match.index,
				    prevChar = text.charAt( offset - 1 );
	
				// If we found the match at the beginning of the string, or we found the match
				// and there is a whitespace char in front of it (meaning it is not an email
				// address), then it is a username match.
				if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
					var matchedText = match[ 0 ],
					    twitterHandle = match[ 0 ].slice( 1 );  // strip off the '@' character at the beginning
	
					matches.push( new Autolinker.match.Twitter( {
						tagBuilder    : tagBuilder,
						matchedText   : matchedText,
						offset        : offset,
						twitterHandle : twitterHandle
					} ) );
				}
			}
	
			return matches;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.matcher.Url
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find URL matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
	 */
	Autolinker.matcher.Url = Autolinker.Util.extend( Autolinker.matcher.Matcher, {
	
		/**
		 * @cfg {Boolean} stripPrefix (required)
		 * @inheritdoc Autolinker#stripPrefix
		 */
	
	
		/**
		 * @private
		 * @property {RegExp} matcherRegex
		 *
		 * The regular expression to match URLs with an optional scheme, port
		 * number, path, query string, and hash anchor.
		 *
		 * Example matches:
		 *
		 *     http://google.com
		 *     www.google.com
		 *     google.com/path/to/file?q1=1&q2=2#myAnchor
		 *
		 *
		 * This regular expression will have the following capturing groups:
		 *
		 * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
		 *     This is used to match scheme URLs with just a single word, such as
		 *     'http://localhost', where we won't double check that the domain name
		 *     has at least one dot ('.') in it.
		 * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
		 *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
		 *     'http://', 'ftp:', etc.)
		 * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
		 *     URL. Will be an empty string if it is not a protocol-relative match.
		 *     We need to know the character before the '//' in order to determine
		 *     if it is a valid match or the // was in a string we don't want to
		 *     auto-link.
		 * 4.  Group that matches a known TLD (top level domain), when a scheme
		 *     or 'www.'-prefixed domain is not matched.
		 * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
		 *     URL. Will be an empty string if it is not a protocol-relative match.
		 *     See #3 for more info.
		 */
		matcherRegex : (function() {
			var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/,  // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
			    wwwRegex = /(?:www\.)/,                  // starting with 'www.'
			    domainNameRegex = Autolinker.RegexLib.domainNameRegex,
			    tldRegex = Autolinker.RegexLib.tldRegex,  // match our known top level domains (TLDs)
			    alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr,
	
			    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
			    // http://blog.codinghorror.com/the-problem-with-urls/
			    urlSuffixRegex = new RegExp( '[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]?!:,.;]*[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]]' );
	
			return new RegExp( [
				'(?:', // parens to cover match for scheme (optional), and domain
					'(',  // *** Capturing group $1, for a scheme-prefixed url (ex: http://google.com)
						schemeRegex.source,
						domainNameRegex.source,
					')',
	
					'|',
	
					'(',  // *** Capturing group $2, for a 'www.' prefixed url (ex: www.google.com)
						'(//)?',  // *** Capturing group $3 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
						wwwRegex.source,
						domainNameRegex.source,
					')',
	
					'|',
	
					'(',  // *** Capturing group $4, for known a TLD url (ex: google.com)
						'(//)?',  // *** Capturing group $5 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
						domainNameRegex.source + '\\.',
						tldRegex.source,
					')',
				')',
	
				'(?:' + urlSuffixRegex.source + ')?'  // match for path, query string, and/or hash anchor - optional
			].join( "" ), 'gi' );
		} )(),
	
	
		/**
		 * A regular expression to use to check the character before a protocol-relative
		 * URL match. We don't want to match a protocol-relative URL if it is part
		 * of another word.
		 *
		 * For example, we want to match something like "Go to: //google.com",
		 * but we don't want to match something like "abc//google.com"
		 *
		 * This regular expression is used to test the character before the '//'.
		 *
		 * @private
		 * @type {RegExp} wordCharRegExp
		 */
		wordCharRegExp : /\w/,
	
	
		/**
		 * The regular expression to match opening parenthesis in a URL match.
		 *
		 * This is to determine if we have unbalanced parenthesis in the URL, and to
		 * drop the final parenthesis that was matched if so.
		 *
		 * Ex: The text "(check out: wikipedia.com/something_(disambiguation))"
		 * should only autolink the inner "wikipedia.com/something_(disambiguation)"
		 * part, so if we find that we have unbalanced parenthesis, we will drop the
		 * last one for the match.
		 *
		 * @private
		 * @property {RegExp}
		 */
		openParensRe : /\(/g,
	
		/**
		 * The regular expression to match closing parenthesis in a URL match. See
		 * {@link #openParensRe} for more information.
		 *
		 * @private
		 * @property {RegExp}
		 */
		closeParensRe : /\)/g,
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 *   specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );
	
			this.stripPrefix = cfg.stripPrefix;
	
			if( this.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
		},
	
	
		/**
		 * @inheritdoc
		 */
		parseMatches : function( text ) {
			var matcherRegex = this.matcherRegex,
			    stripPrefix = this.stripPrefix,
			    tagBuilder = this.tagBuilder,
			    matches = [],
			    match;
	
			while( ( match = matcherRegex.exec( text ) ) !== null ) {
				var matchStr = match[ 0 ],
				    schemeUrlMatch = match[ 1 ],
				    wwwUrlMatch = match[ 2 ],
				    wwwProtocolRelativeMatch = match[ 3 ],
				    //tldUrlMatch = match[ 4 ],  -- not needed at the moment
				    tldProtocolRelativeMatch = match[ 5 ],
				    offset = match.index,
				    protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch,
					prevChar = text.charAt( offset - 1 );
	
				if( !Autolinker.matcher.UrlMatchValidator.isValid( matchStr, schemeUrlMatch ) ) {
					continue;
				}
	
				// If the match is preceded by an '@' character, then it is either
				// an email address or a username. Skip these types of matches.
				if( offset > 0 && prevChar === '@' ) {
					continue;
				}
	
				// If it's a protocol-relative '//' match, but the character before the '//'
				// was a word character (i.e. a letter/number), then we found the '//' in the
				// middle of another word (such as "asdf//asdf.com"). In this case, skip the
				// match.
				if( offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test( prevChar ) ) {
					continue;
				}
	
				// Handle a closing parenthesis at the end of the match, and exclude
				// it if there is not a matching open parenthesis in the match
				// itself.
				if( this.matchHasUnbalancedClosingParen( matchStr ) ) {
					matchStr = matchStr.substr( 0, matchStr.length - 1 );  // remove the trailing ")"
				} else {
					// Handle an invalid character after the TLD
					var pos = this.matchHasInvalidCharAfterTld( matchStr, schemeUrlMatch );
					if( pos > -1 ) {
						matchStr = matchStr.substr( 0, pos ); // remove the trailing invalid chars
					}
				}
	
				var urlMatchType = schemeUrlMatch ? 'scheme' : ( wwwUrlMatch ? 'www' : 'tld' ),
				    protocolUrlMatch = !!schemeUrlMatch;
	
				matches.push( new Autolinker.match.Url( {
					tagBuilder            : tagBuilder,
					matchedText           : matchStr,
					offset                : offset,
					urlMatchType          : urlMatchType,
					url                   : matchStr,
					protocolUrlMatch      : protocolUrlMatch,
					protocolRelativeMatch : !!protocolRelativeMatch,
					stripPrefix           : stripPrefix
				} ) );
			}
	
			return matches;
		},
	
	
		/**
		 * Determines if a match found has an unmatched closing parenthesis. If so,
		 * this parenthesis will be removed from the match itself, and appended
		 * after the generated anchor tag.
		 *
		 * A match may have an extra closing parenthesis at the end of the match
		 * because the regular expression must include parenthesis for URLs such as
		 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
		 *
		 * However, an extra parenthesis *will* be included when the URL itself is
		 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
		 * In this case, the last closing parenthesis should *not* be part of the
		 * URL itself, and this method will return `true`.
		 *
		 * @private
		 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
		 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
		 *   the end of the `matchStr`, `false` otherwise.
		 */
		matchHasUnbalancedClosingParen : function( matchStr ) {
			var lastChar = matchStr.charAt( matchStr.length - 1 );
	
			if( lastChar === ')' ) {
				var openParensMatch = matchStr.match( this.openParensRe ),
				    closeParensMatch = matchStr.match( this.closeParensRe ),
				    numOpenParens = ( openParensMatch && openParensMatch.length ) || 0,
				    numCloseParens = ( closeParensMatch && closeParensMatch.length ) || 0;
	
				if( numOpenParens < numCloseParens ) {
					return true;
				}
			}
	
			return false;
		},
	
	
		/**
		 * Determine if there's an invalid character after the TLD in a URL. Valid
		 * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
		 * check.
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} schemeUrlMatch The match URL string for a scheme
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Number} the position where the invalid character was found. If
		 *   no such character was found, returns -1
		 */
		matchHasInvalidCharAfterTld : function( urlMatch, schemeUrlMatch ) {
			if( !urlMatch ) {
				return -1;
			}
	
			var offset = 0;
			if ( schemeUrlMatch ) {
				offset = urlMatch.indexOf(':');
				urlMatch = urlMatch.slice(offset);
			}
	
			var re = /^((.?\/\/)?[A-Za-z0-9\u00C0-\u017F\.\-]*[A-Za-z0-9\u00C0-\u017F\-]\.[A-Za-z]+)/;
			var res = re.exec( urlMatch );
			if ( res === null ) {
				return -1;
			}
	
			offset += res[1].length;
			urlMatch = urlMatch.slice(res[1].length);
			if (/^[^.A-Za-z:\/?#]/.test(urlMatch)) {
				return offset;
			}
	
			return -1;
		}
	
	} );
	/*global Autolinker */
	/*jshint scripturl:true */
	/**
	 * @private
	 * @class Autolinker.matcher.UrlMatchValidator
	 * @singleton
	 *
	 * Used by Autolinker to filter out false URL positives from the
	 * {@link Autolinker.matcher.Url UrlMatcher}.
	 *
	 * Due to the limitations of regular expressions (including the missing feature
	 * of look-behinds in JS regular expressions), we cannot always determine the
	 * validity of a given match. This class applies a bit of additional logic to
	 * filter out any false positives that have been matched by the
	 * {@link Autolinker.matcher.Url UrlMatcher}.
	 */
	Autolinker.matcher.UrlMatchValidator = {
	
		/**
		 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
		 *
		 * @private
		 * @property {RegExp} hasFullProtocolRegex
		 */
		hasFullProtocolRegex : /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,
	
		/**
		 * Regex to find the URI scheme, such as 'mailto:'.
		 *
		 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
		 *
		 * @private
		 * @property {RegExp} uriSchemeRegex
		 */
		uriSchemeRegex : /^[A-Za-z][-.+A-Za-z0-9]*:/,
	
		/**
		 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
		 *
		 * @private
		 * @property {RegExp} hasWordCharAfterProtocolRegex
		 */
		hasWordCharAfterProtocolRegex : /:[^\s]*?[A-Za-z\u00C0-\u017F]/,
	
	
		/**
		 * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
		 * is valid. Will return `false` for:
		 *
		 * 1) URL matches which do not have at least have one period ('.') in the
		 *    domain name (effectively skipping over matches like "abc:def").
		 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
		 * 2) URL matches which do not have at least one word character in the
		 *    domain name (effectively skipping over matches like "git:1.0").
		 * 3) A protocol-relative url match (a URL beginning with '//') whose
		 *    previous character is a word character (effectively skipping over
		 *    strings like "abc//google.com")
		 *
		 * Otherwise, returns `true`.
		 *
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Boolean} `true` if the match given is valid and should be
		 *   processed, or `false` if the match is invalid and/or should just not be
		 *   processed.
		 */
		isValid : function( urlMatch, protocolUrlMatch ) {
			if(
				( protocolUrlMatch && !this.isValidUriScheme( protocolUrlMatch ) ) ||
				this.urlMatchDoesNotHaveProtocolOrDot( urlMatch, protocolUrlMatch ) ||    // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
				this.urlMatchDoesNotHaveAtLeastOneWordChar( urlMatch, protocolUrlMatch )  // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
			) {
				return false;
			}
	
			return true;
		},
	
	
		/**
		 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
		 * `false` if the scheme is 'javascript:' or 'vbscript:'
		 *
		 * @private
		 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
		 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
		 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
		 */
		isValidUriScheme : function( uriSchemeMatch ) {
			var uriScheme = uriSchemeMatch.match( this.uriSchemeRegex )[ 0 ].toLowerCase();
	
			return ( uriScheme !== 'javascript:' && uriScheme !== 'vbscript:' );
		},
	
	
		/**
		 * Determines if a URL match does not have either:
		 *
		 * a) a full protocol (i.e. 'http://'), or
		 * b) at least one dot ('.') in the domain name (for a non-full-protocol
		 *    match).
		 *
		 * Either situation is considered an invalid URL (ex: 'git:d' does not have
		 * either the '://' part, or at least one dot in the domain name. If the
		 * match was 'git:abc.com', we would consider this valid.)
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Boolean} `true` if the URL match does not have a full protocol,
		 *   or at least one dot ('.') in a non-full-protocol match.
		 */
		urlMatchDoesNotHaveProtocolOrDot : function( urlMatch, protocolUrlMatch ) {
			return ( !!urlMatch && ( !protocolUrlMatch || !this.hasFullProtocolRegex.test( protocolUrlMatch ) ) && urlMatch.indexOf( '.' ) === -1 );
		},
	
	
		/**
		 * Determines if a URL match does not have at least one word character after
		 * the protocol (i.e. in the domain name).
		 *
		 * At least one letter character must exist in the domain name after a
		 * protocol match. Ex: skip over something like "git:1.0"
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
		 *   have a protocol in the URL string, in order to check for a word
		 *   character after the protocol separator (':').
		 * @return {Boolean} `true` if the URL match does not have at least one word
		 *   character in it after the protocol, `false` otherwise.
		 */
		urlMatchDoesNotHaveAtLeastOneWordChar : function( urlMatch, protocolUrlMatch ) {
			if( urlMatch && protocolUrlMatch ) {
				return !this.hasWordCharAfterProtocolRegex.test( urlMatch );
			} else {
				return false;
			}
		}
	
	};
	/*global Autolinker */
	/**
	 * A truncation feature where the ellipsis will be placed at the end of the URL.
	 *
	 * @param {String} anchorText
	 * @param {Number} truncateLen The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	Autolinker.truncate.TruncateEnd = function(anchorText, truncateLen, ellipsisChars){
		return Autolinker.Util.ellipsis( anchorText, truncateLen, ellipsisChars );
	};
	
	/*global Autolinker */
	/**
	 * Date: 2015-10-05
	 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
	 *
	 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
	 *
	 * @param {String} url             A URL.
	 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	Autolinker.truncate.TruncateMiddle = function(url, truncateLen, ellipsisChars){
	  if (url.length <= truncateLen) {
	    return url;
	  }
	  var availableLength = truncateLen - ellipsisChars.length;
	  var end = "";
	  if (availableLength > 0) {
	    end = url.substr((-1)*Math.floor(availableLength/2));
	  }
	  return (url.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, truncateLen);
	};
	
	/*global Autolinker */
	/**
	 * Date: 2015-10-05
	 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
	 *
	 * A truncation feature, where the ellipsis will be placed at a section within
	 * the URL making it still somewhat human readable.
	 *
	 * @param {String} url						 A URL.
	 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	Autolinker.truncate.TruncateSmart = function(url, truncateLen, ellipsisChars){
		var parse_url = function(url){ // Functionality inspired by PHP function of same name
			var urlObj = {};
			var urlSub = url;
			var match = urlSub.match(/^([a-z]+):\/\//i);
			if (match) {
				urlObj.scheme = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
			if (match) {
				urlObj.host = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
			if (match) {
				urlObj.path = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
			if (match) {
				urlObj.query = match[1];
				urlSub = urlSub.substr(match[0].length);
			}
			match = urlSub.match(/^#(.*?)$/i);
			if (match) {
				urlObj.fragment = match[1];
				//urlSub = urlSub.substr(match[0].length);  -- not used. Uncomment if adding another block.
			}
			return urlObj;
		};
	
		var buildUrl = function(urlObj){
			var url = "";
			if (urlObj.scheme && urlObj.host) {
				url += urlObj.scheme + "://";
			}
			if (urlObj.host) {
				url += urlObj.host;
			}
			if (urlObj.path) {
				url += "/" + urlObj.path;
			}
			if (urlObj.query) {
				url += "?" + urlObj.query;
			}
			if (urlObj.fragment) {
				url += "#" + urlObj.fragment;
			}
			return url;
		};
	
		var buildSegment = function(segment, remainingAvailableLength){
			var remainingAvailableLengthHalf = remainingAvailableLength/ 2,
					startOffset = Math.ceil(remainingAvailableLengthHalf),
					endOffset = (-1)*Math.floor(remainingAvailableLengthHalf),
					end = "";
			if (endOffset < 0) {
				end = segment.substr(endOffset);
			}
			return segment.substr(0, startOffset) + ellipsisChars + end;
		};
		if (url.length <= truncateLen) {
			return url;
		}
		var availableLength = truncateLen - ellipsisChars.length;
		var urlObj = parse_url(url);
		// Clean up the URL
		if (urlObj.query) {
			var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
			if (matchQuery) {
				// Malformed URL; two or more "?". Removed any content behind the 2nd.
				urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
				url = buildUrl(urlObj);
			}
		}
		if (url.length <= truncateLen) {
			return url;
		}
		if (urlObj.host) {
			urlObj.host = urlObj.host.replace(/^www\./, "");
			url = buildUrl(urlObj);
		}
		if (url.length <= truncateLen) {
			return url;
		}
		// Process and build the URL
		var str = "";
		if (urlObj.host) {
			str += urlObj.host;
		}
		if (str.length >= availableLength) {
			if (urlObj.host.length == truncateLen) {
				return (urlObj.host.substr(0, (truncateLen - ellipsisChars.length)) + ellipsisChars).substr(0, truncateLen);
			}
			return buildSegment(str, availableLength).substr(0, truncateLen);
		}
		var pathAndQuery = "";
		if (urlObj.path) {
			pathAndQuery += "/" + urlObj.path;
		}
		if (urlObj.query) {
			pathAndQuery += "?" + urlObj.query;
		}
		if (pathAndQuery) {
			if ((str+pathAndQuery).length >= availableLength) {
				if ((str+pathAndQuery).length == truncateLen) {
					return (str + pathAndQuery).substr(0, truncateLen);
				}
				var remainingAvailableLength = availableLength - str.length;
				return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, truncateLen);
			} else {
				str += pathAndQuery;
			}
		}
		if (urlObj.fragment) {
			var fragment = "#"+urlObj.fragment;
			if ((str+fragment).length >= availableLength) {
				if ((str+fragment).length == truncateLen) {
					return (str + fragment).substr(0, truncateLen);
				}
				var remainingAvailableLength2 = availableLength - str.length;
				return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, truncateLen);
			} else {
				str += fragment;
			}
		}
		if (urlObj.scheme && urlObj.host) {
			var scheme = urlObj.scheme + "://";
			if ((str+scheme).length < availableLength) {
				return (scheme + str).substr(0, truncateLen);
			}
		}
		if (str.length <= truncateLen) {
			return str;
		}
		var end = "";
		if (availableLength > 0) {
			end = str.substr((-1)*Math.floor(availableLength/2));
		}
		return (str.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, truncateLen);
	};
	
	return Autolinker;
	}));
	


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1104);
	module.e = __webpack_require__(82).RegExp.escape;


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(34)
	  , isArray  = __webpack_require__(261)
	  , SPECIES  = __webpack_require__(35)('species');
	
	module.e = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1095);
	
	module.e = function(original, length){
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var anObject    = __webpack_require__(24)
	  , toPrimitive = __webpack_require__(84)
	  , NUMBER      = 'number';
	
	module.e = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(119)
	  , gOPS    = __webpack_require__(201)
	  , pIE     = __webpack_require__(164);
	module.e = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var getKeys   = __webpack_require__(119)
	  , toIObject = __webpack_require__(65);
	module.e = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var path      = __webpack_require__(1101)
	  , invoke    = __webpack_require__(197)
	  , aFunction = __webpack_require__(62);
	module.e = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(29);


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var classof   = __webpack_require__(142)
	  , ITERATOR  = __webpack_require__(35)('iterator')
	  , Iterators = __webpack_require__(115);
	module.e = __webpack_require__(82).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(9)
	  , $re     = __webpack_require__(1102)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});
	


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(460)});
	
	__webpack_require__(141)('copyWithin');


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $every  = __webpack_require__(81)(4);
	
	$export($export.P + $export.F * !__webpack_require__(76)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {fill: __webpack_require__(253)});
	
	__webpack_require__(141)('fill');


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $filter = __webpack_require__(81)(2);
	
	$export($export.P + $export.F * !__webpack_require__(76)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(81)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(141)(KEY);


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(81)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(141)(KEY);


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export  = __webpack_require__(9)
	  , $forEach = __webpack_require__(81)(0)
	  , STRICT   = __webpack_require__(76)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var ctx            = __webpack_require__(90)
	  , $export        = __webpack_require__(9)
	  , toObject       = __webpack_require__(49)
	  , call           = __webpack_require__(468)
	  , isArrayIter    = __webpack_require__(260)
	  , toLength       = __webpack_require__(45)
	  , createProperty = __webpack_require__(254)
	  , getIterFn      = __webpack_require__(277);
	
	$export($export.S + $export.F * !__webpack_require__(199)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});
	


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export       = __webpack_require__(9)
	  , $indexOf      = __webpack_require__(193)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(76)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(261)});


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(65)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(163) != Object || !__webpack_require__(76)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export       = __webpack_require__(9)
	  , toIObject     = __webpack_require__(65)
	  , toInteger     = __webpack_require__(102)
	  , toLength      = __webpack_require__(45)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(76)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $map    = __webpack_require__(81)(1);
	
	$export($export.P + $export.F * !__webpack_require__(76)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export        = __webpack_require__(9)
	  , createProperty = __webpack_require__(254);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(31)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(462);
	
	$export($export.P + $export.F * !__webpack_require__(76)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(462);
	
	$export($export.P + $export.F * !__webpack_require__(76)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export    = __webpack_require__(9)
	  , html       = __webpack_require__(258)
	  , cof        = __webpack_require__(74)
	  , toIndex    = __webpack_require__(122)
	  , toLength   = __webpack_require__(45)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(31)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $some   = __webpack_require__(81)(3);
	
	$export($export.P + $export.F * !__webpack_require__(76)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(62)
	  , toObject  = __webpack_require__(49)
	  , fails     = __webpack_require__(31)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(76)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(121)('Array');


/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});


/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(31)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});


/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export     = __webpack_require__(9)
	  , toObject    = __webpack_require__(49)
	  , toPrimitive = __webpack_require__(84);
	
	$export($export.P + $export.F * __webpack_require__(31)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var TO_PRIMITIVE = __webpack_require__(35)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(56)(proto, TO_PRIMITIVE, __webpack_require__(1097));


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(63)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Function', {bind: __webpack_require__(463)});


/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var isObject       = __webpack_require__(34)
	  , getPrototypeOf = __webpack_require__(69)
	  , HAS_INSTANCE   = __webpack_require__(35)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(38).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});


/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var dP         = __webpack_require__(38).f
	  , createDesc = __webpack_require__(101)
	  , has        = __webpack_require__(53)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(37) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(9)
	  , log1p   = __webpack_require__(470)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(9)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(9)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(9)
	  , sign    = __webpack_require__(266);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(9)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(9)
	  , $expm1  = __webpack_require__(265);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(9)
	  , sign      = __webpack_require__(266)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(9)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(9)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(31)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(470)});


/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {sign: __webpack_require__(266)});


/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(265)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(31)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(265)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var global            = __webpack_require__(29)
	  , has               = __webpack_require__(53)
	  , cof               = __webpack_require__(74)
	  , inheritIfRequired = __webpack_require__(259)
	  , toPrimitive       = __webpack_require__(84)
	  , fails             = __webpack_require__(31)
	  , gOPN              = __webpack_require__(118).f
	  , gOPD              = __webpack_require__(68).f
	  , dP                = __webpack_require__(38).f
	  , $trim             = __webpack_require__(145).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(117)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(37) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(63)(global, NUMBER, $Number);
	}


/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});


/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(9)
	  , _isFinite = __webpack_require__(29).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(262)});


/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(9)
	  , isInteger = __webpack_require__(262)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(477);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(478);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});


/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export      = __webpack_require__(9)
	  , anInstance   = __webpack_require__(99)
	  , toInteger    = __webpack_require__(102)
	  , aNumberValue = __webpack_require__(459)
	  , repeat       = __webpack_require__(272)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(31)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export      = __webpack_require__(9)
	  , $fails       = __webpack_require__(31)
	  , aNumberValue = __webpack_require__(459)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(9);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(471)});


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(117)});


/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(37), 'Object', {defineProperties: __webpack_require__(472)});


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(37), 'Object', {defineProperty: __webpack_require__(38).f});


/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(34)
	  , meta     = __webpack_require__(100).onFreeze;
	
	__webpack_require__(83)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(65)
	  , $getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	__webpack_require__(83)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(83)('getOwnPropertyNames', function(){
	  return __webpack_require__(473).f;
	});


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(49)
	  , $getPrototypeOf = __webpack_require__(69);
	
	__webpack_require__(83)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(34);
	
	__webpack_require__(83)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(34);
	
	__webpack_require__(83)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(34);
	
	__webpack_require__(83)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {is: __webpack_require__(479)});


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(49)
	  , $keys    = __webpack_require__(119);
	
	__webpack_require__(83)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(34)
	  , meta     = __webpack_require__(100).onFreeze;
	
	__webpack_require__(83)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(34)
	  , meta     = __webpack_require__(100).onFreeze;
	
	__webpack_require__(83)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(202).set});


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(142)
	  , test    = {};
	test[__webpack_require__(35)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(63)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(477);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(478);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var LIBRARY            = __webpack_require__(116)
	  , global             = __webpack_require__(29)
	  , ctx                = __webpack_require__(90)
	  , classof            = __webpack_require__(142)
	  , $export            = __webpack_require__(9)
	  , isObject           = __webpack_require__(34)
	  , anObject           = __webpack_require__(24)
	  , aFunction          = __webpack_require__(62)
	  , anInstance         = __webpack_require__(99)
	  , forOf              = __webpack_require__(143)
	  , setProto           = __webpack_require__(202).set
	  , speciesConstructor = __webpack_require__(269)
	  , task               = __webpack_require__(274).set
	  , microtask          = __webpack_require__(267)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(35)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(120)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(144)($Promise, PROMISE);
	__webpack_require__(121)(PROMISE);
	Wrapper = __webpack_require__(82)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(199)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});


/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(62)
	  , anObject  = __webpack_require__(24)
	  , _apply    = Function.apply;
	
	$export($export.S, 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(aFunction(target), thisArgument, anObject(argumentsList));
	  }
	});


/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export   = __webpack_require__(9)
	  , create    = __webpack_require__(117)
	  , aFunction = __webpack_require__(62)
	  , anObject  = __webpack_require__(24)
	  , isObject  = __webpack_require__(34)
	  , bind      = __webpack_require__(463);
	
	// MS Edge supports only 2 arguments
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	$export($export.S + $export.F * __webpack_require__(31)(function(){
	  function F(){}
	  return !(Reflect.construct(function(){}, [], F) instanceof F);
	}), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(38)
	  , $export     = __webpack_require__(9)
	  , anObject    = __webpack_require__(24)
	  , toPrimitive = __webpack_require__(84);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(31)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});


/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(9)
	  , gOPD     = __webpack_require__(68).f
	  , anObject = __webpack_require__(24);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(24);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(263)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(68)
	  , $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(24);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(9)
	  , getProto = __webpack_require__(69)
	  , anObject = __webpack_require__(24);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(68)
	  , getPrototypeOf = __webpack_require__(69)
	  , has            = __webpack_require__(53)
	  , $export        = __webpack_require__(9)
	  , isObject       = __webpack_require__(34)
	  , anObject       = __webpack_require__(24);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(9)
	  , anObject      = __webpack_require__(24)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(476)});


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(9)
	  , anObject           = __webpack_require__(24)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(9)
	  , setProto = __webpack_require__(202);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(38)
	  , gOPD           = __webpack_require__(68)
	  , getPrototypeOf = __webpack_require__(69)
	  , has            = __webpack_require__(53)
	  , $export        = __webpack_require__(9)
	  , createDesc     = __webpack_require__(101)
	  , anObject       = __webpack_require__(24)
	  , isObject       = __webpack_require__(34);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});


/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var global            = __webpack_require__(29)
	  , inheritIfRequired = __webpack_require__(259)
	  , dP                = __webpack_require__(38).f
	  , gOPN              = __webpack_require__(118).f
	  , isRegExp          = __webpack_require__(198)
	  , $flags            = __webpack_require__(196)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(37) && (!CORRECT_NEW || __webpack_require__(31)(function(){
	  re2[__webpack_require__(35)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(63)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(121)('RegExp');


/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// @@match logic
	__webpack_require__(195)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// @@replace logic
	__webpack_require__(195)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// @@search logic
	__webpack_require__(195)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// @@split logic
	__webpack_require__(195)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(198)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	__webpack_require__(483);
	var anObject    = __webpack_require__(24)
	  , $flags      = __webpack_require__(196)
	  , DESCRIPTORS = __webpack_require__(37)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(63)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(31)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}


/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(64)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(64)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});


/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(64)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(64)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(270)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(9)
	  , toLength  = __webpack_require__(45)
	  , context   = __webpack_require__(271)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(257)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(64)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(64)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(64)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export        = __webpack_require__(9)
	  , toIndex        = __webpack_require__(122)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(9)
	  , context  = __webpack_require__(271)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(257)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(64)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $at  = __webpack_require__(270)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(264)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});


/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(64)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(65)
	  , toLength  = __webpack_require__(45);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(272)
	});


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(64)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(9)
	  , toLength    = __webpack_require__(45)
	  , context     = __webpack_require__(271)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(257)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(64)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(64)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(64)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(145)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(29)
	  , has            = __webpack_require__(53)
	  , DESCRIPTORS    = __webpack_require__(37)
	  , $export        = __webpack_require__(9)
	  , redefine       = __webpack_require__(63)
	  , META           = __webpack_require__(100).KEY
	  , $fails         = __webpack_require__(31)
	  , shared         = __webpack_require__(203)
	  , setToStringTag = __webpack_require__(144)
	  , uid            = __webpack_require__(123)
	  , wks            = __webpack_require__(35)
	  , wksExt         = __webpack_require__(481)
	  , wksDefine      = __webpack_require__(276)
	  , keyOf          = __webpack_require__(1099)
	  , enumKeys       = __webpack_require__(1098)
	  , isArray        = __webpack_require__(261)
	  , anObject       = __webpack_require__(24)
	  , toIObject      = __webpack_require__(65)
	  , toPrimitive    = __webpack_require__(84)
	  , createDesc     = __webpack_require__(101)
	  , _create        = __webpack_require__(117)
	  , gOPNExt        = __webpack_require__(473)
	  , $GOPD          = __webpack_require__(68)
	  , $DP            = __webpack_require__(38)
	  , $keys          = __webpack_require__(119)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(118).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(164).f  = $propertyIsEnumerable;
	  __webpack_require__(201).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(116)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export      = __webpack_require__(9)
	  , $typed       = __webpack_require__(204)
	  , buffer       = __webpack_require__(275)
	  , anObject     = __webpack_require__(24)
	  , toIndex      = __webpack_require__(122)
	  , toLength     = __webpack_require__(45)
	  , isObject     = __webpack_require__(34)
	  , TYPED_ARRAY  = __webpack_require__(35)('typed_array')
	  , ArrayBuffer  = __webpack_require__(29).ArrayBuffer
	  , speciesConstructor = __webpack_require__(269)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(31)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(121)(ARRAY_BUFFER);


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9);
	$export($export.G + $export.W + $export.F * !__webpack_require__(204).ABV, {
	  DataView: __webpack_require__(275).DataView
	});


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(92)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var weak = __webpack_require__(466);
	
	// 23.4 WeakSet Objects
	__webpack_require__(194)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(9)
	  , $includes = __webpack_require__(193)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(141)('includes');


/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(9)
	  , microtask = __webpack_require__(267)()
	  , process   = __webpack_require__(29).process
	  , isNode    = __webpack_require__(74)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(9)
	  , cof     = __webpack_require__(74);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(465)('Map')});


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(49)
	  , aFunction       = __webpack_require__(62)
	  , $defineProperty = __webpack_require__(38);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(37) && $export($export.P + __webpack_require__(200), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});


/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(49)
	  , aFunction       = __webpack_require__(62)
	  , $defineProperty = __webpack_require__(38);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(37) && $export($export.P + __webpack_require__(200), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(9)
	  , $entries = __webpack_require__(475)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(9)
	  , ownKeys        = __webpack_require__(476)
	  , toIObject      = __webpack_require__(65)
	  , gOPD           = __webpack_require__(68)
	  , createProperty = __webpack_require__(254);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key, D;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(49)
	  , toPrimitive              = __webpack_require__(84)
	  , getPrototypeOf           = __webpack_require__(69)
	  , getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(37) && $export($export.P + __webpack_require__(200), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(49)
	  , toPrimitive              = __webpack_require__(84)
	  , getPrototypeOf           = __webpack_require__(69)
	  , getOwnPropertyDescriptor = __webpack_require__(68).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(37) && $export($export.P + __webpack_require__(200), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(9)
	  , $values = __webpack_require__(475)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(9)
	  , global      = __webpack_require__(29)
	  , core        = __webpack_require__(82)
	  , microtask   = __webpack_require__(267)()
	  , OBSERVABLE  = __webpack_require__(35)('observable')
	  , aFunction   = __webpack_require__(62)
	  , anObject    = __webpack_require__(24)
	  , anInstance  = __webpack_require__(99)
	  , redefineAll = __webpack_require__(120)
	  , hide        = __webpack_require__(56)
	  , forOf       = __webpack_require__(143)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(121)('Observable');


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata                  = __webpack_require__(91)
	  , anObject                  = __webpack_require__(24)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});


/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata               = __webpack_require__(91)
	  , anObject               = __webpack_require__(24)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});


/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var Set                     = __webpack_require__(484)
	  , from                    = __webpack_require__(461)
	  , metadata                = __webpack_require__(91)
	  , anObject                = __webpack_require__(24)
	  , getPrototypeOf          = __webpack_require__(69)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata               = __webpack_require__(91)
	  , anObject               = __webpack_require__(24)
	  , getPrototypeOf         = __webpack_require__(69)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});


/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata                = __webpack_require__(91)
	  , anObject                = __webpack_require__(24)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata               = __webpack_require__(91)
	  , anObject               = __webpack_require__(24)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata               = __webpack_require__(91)
	  , anObject               = __webpack_require__(24)
	  , getPrototypeOf         = __webpack_require__(69)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata               = __webpack_require__(91)
	  , anObject               = __webpack_require__(24)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var metadata                  = __webpack_require__(91)
	  , anObject                  = __webpack_require__(24)
	  , aFunction                 = __webpack_require__(62)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(465)('Set')});


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(270)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(9)
	  , defined     = __webpack_require__(75)
	  , toLength    = __webpack_require__(45)
	  , isRegExp    = __webpack_require__(198)
	  , getFlags    = __webpack_require__(196)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(263)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(480);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(480);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(145)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(145)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(276)('asyncIterator');


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(276)('observable');


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(9);
	
	$export($export.S, 'System', {global: __webpack_require__(29)});


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $iterators    = __webpack_require__(278)
	  , redefine      = __webpack_require__(63)
	  , global        = __webpack_require__(29)
	  , hide          = __webpack_require__(56)
	  , Iterators     = __webpack_require__(115)
	  , wks           = __webpack_require__(35)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $export = __webpack_require__(9)
	  , $task   = __webpack_require__(274);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(29)
	  , $export    = __webpack_require__(9)
	  , invoke     = __webpack_require__(197)
	  , partial    = __webpack_require__(1100)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1224);
	__webpack_require__(1163);
	__webpack_require__(1165);
	__webpack_require__(1164);
	__webpack_require__(1167);
	__webpack_require__(1169);
	__webpack_require__(1174);
	__webpack_require__(1168);
	__webpack_require__(1166);
	__webpack_require__(1176);
	__webpack_require__(1175);
	__webpack_require__(1171);
	__webpack_require__(1172);
	__webpack_require__(1170);
	__webpack_require__(1162);
	__webpack_require__(1173);
	__webpack_require__(1177);
	__webpack_require__(1178);
	__webpack_require__(1130);
	__webpack_require__(1132);
	__webpack_require__(1131);
	__webpack_require__(1180);
	__webpack_require__(1179);
	__webpack_require__(1150);
	__webpack_require__(1160);
	__webpack_require__(1161);
	__webpack_require__(1151);
	__webpack_require__(1152);
	__webpack_require__(1153);
	__webpack_require__(1154);
	__webpack_require__(1155);
	__webpack_require__(1156);
	__webpack_require__(1157);
	__webpack_require__(1158);
	__webpack_require__(1159);
	__webpack_require__(1133);
	__webpack_require__(1134);
	__webpack_require__(1135);
	__webpack_require__(1136);
	__webpack_require__(1137);
	__webpack_require__(1138);
	__webpack_require__(1139);
	__webpack_require__(1140);
	__webpack_require__(1141);
	__webpack_require__(1142);
	__webpack_require__(1143);
	__webpack_require__(1144);
	__webpack_require__(1145);
	__webpack_require__(1146);
	__webpack_require__(1147);
	__webpack_require__(1148);
	__webpack_require__(1149);
	__webpack_require__(1211);
	__webpack_require__(1216);
	__webpack_require__(1223);
	__webpack_require__(1214);
	__webpack_require__(1206);
	__webpack_require__(1207);
	__webpack_require__(1212);
	__webpack_require__(1217);
	__webpack_require__(1219);
	__webpack_require__(1202);
	__webpack_require__(1203);
	__webpack_require__(1204);
	__webpack_require__(1205);
	__webpack_require__(1208);
	__webpack_require__(1209);
	__webpack_require__(1210);
	__webpack_require__(1213);
	__webpack_require__(1215);
	__webpack_require__(1218);
	__webpack_require__(1220);
	__webpack_require__(1221);
	__webpack_require__(1222);
	__webpack_require__(1125);
	__webpack_require__(1127);
	__webpack_require__(1126);
	__webpack_require__(1129);
	__webpack_require__(1128);
	__webpack_require__(1114);
	__webpack_require__(1112);
	__webpack_require__(1118);
	__webpack_require__(1115);
	__webpack_require__(1121);
	__webpack_require__(1123);
	__webpack_require__(1111);
	__webpack_require__(1117);
	__webpack_require__(1108);
	__webpack_require__(1122);
	__webpack_require__(1106);
	__webpack_require__(1120);
	__webpack_require__(1119);
	__webpack_require__(1113);
	__webpack_require__(1116);
	__webpack_require__(1105);
	__webpack_require__(1107);
	__webpack_require__(1110);
	__webpack_require__(1109);
	__webpack_require__(1124);
	__webpack_require__(278);
	__webpack_require__(1196);
	__webpack_require__(1201);
	__webpack_require__(483);
	__webpack_require__(1197);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1200);
	__webpack_require__(1181);
	__webpack_require__(482);
	__webpack_require__(484);
	__webpack_require__(485);
	__webpack_require__(1236);
	__webpack_require__(1225);
	__webpack_require__(1226);
	__webpack_require__(1231);
	__webpack_require__(1234);
	__webpack_require__(1235);
	__webpack_require__(1229);
	__webpack_require__(1232);
	__webpack_require__(1230);
	__webpack_require__(1233);
	__webpack_require__(1227);
	__webpack_require__(1228);
	__webpack_require__(1182);
	__webpack_require__(1183);
	__webpack_require__(1184);
	__webpack_require__(1185);
	__webpack_require__(1186);
	__webpack_require__(1189);
	__webpack_require__(1187);
	__webpack_require__(1188);
	__webpack_require__(1190);
	__webpack_require__(1191);
	__webpack_require__(1192);
	__webpack_require__(1193);
	__webpack_require__(1195);
	__webpack_require__(1194);
	__webpack_require__(1237);
	__webpack_require__(1263);
	__webpack_require__(1266);
	__webpack_require__(1265);
	__webpack_require__(1267);
	__webpack_require__(1268);
	__webpack_require__(1264);
	__webpack_require__(1269);
	__webpack_require__(1270);
	__webpack_require__(1248);
	__webpack_require__(1251);
	__webpack_require__(1247);
	__webpack_require__(1245);
	__webpack_require__(1246);
	__webpack_require__(1249);
	__webpack_require__(1250);
	__webpack_require__(1240);
	__webpack_require__(1262);
	__webpack_require__(1271);
	__webpack_require__(1239);
	__webpack_require__(1241);
	__webpack_require__(1243);
	__webpack_require__(1242);
	__webpack_require__(1244);
	__webpack_require__(1253);
	__webpack_require__(1254);
	__webpack_require__(1256);
	__webpack_require__(1255);
	__webpack_require__(1258);
	__webpack_require__(1257);
	__webpack_require__(1259);
	__webpack_require__(1260);
	__webpack_require__(1261);
	__webpack_require__(1238);
	__webpack_require__(1252);
	__webpack_require__(1274);
	__webpack_require__(1273);
	__webpack_require__(1272);
	module.e = __webpack_require__(82);


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.e = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.e : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(107)))

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1311), __esModule: true };


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1313), __esModule: true };


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1319), __esModule: true };


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1322), __esModule: true };


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1324), __esModule: true };


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1325), __esModule: true };


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = { "default": __webpack_require__(1326), __esModule: true };


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	var _Object$getOwnPropertyDescriptor = __webpack_require__(1279)["default"];
	
	exports["default"] = function get(_x, _x2, _x3) {
	  var _again = true;
	
	  _function: while (_again) {
	    var object = _x,
	        property = _x2,
	        receiver = _x3;
	    _again = false;
	    if (object === null) object = Function.prototype;
	
	    var desc = _Object$getOwnPropertyDescriptor(object, property);
	
	    if (desc === undefined) {
	      var parent = Object.getPrototypeOf(object);
	
	      if (parent === null) {
	        return undefined;
	      } else {
	        _x = parent;
	        _x2 = property;
	        _x3 = receiver;
	        _again = true;
	        desc = parent = undefined;
	        continue _function;
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;
	
	      if (getter === undefined) {
	        return undefined;
	      }
	
	      return getter.call(receiver);
	    }
	  }
	};
	
	exports.__esModule = true;


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict'
	
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	function init () {
	  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	  for (var i = 0, len = code.length; i < len; ++i) {
	    lookup[i] = code[i]
	    revLookup[code.charCodeAt(i)] = i
	  }
	
	  revLookup['-'.charCodeAt(0)] = 62
	  revLookup['_'.charCodeAt(0)] = 63
	}
	
	init()
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	
	  // base64 is 4/3 + up to two characters of the original data
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}
	


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*!
	 * Bootstrap Colorpicker
	 * http://mjolnic.github.io/bootstrap-colorpicker/
	 *
	 * Originally written by (c) 2012 Stefan Petre
	 * Licensed under the Apache License v2.0
	 * http://www.apache.org/licenses/LICENSE-2.0.txt
	 *
	 * @todo Update DOCS
	 */
	
	(function(factory) {
	    "use strict";
	    if (true) {
	      module.e = factory(__webpack_provided_window_dot_jQuery);
	    } else if (typeof define === 'function' && define.amd) {
	      define(['jquery'], factory);
	    } else if (window.jQuery && !window.jQuery.fn.colorpicker) {
	      factory(window.jQuery);
	    }
	  }
	  (function($) {
	    'use strict';
	
	    // Color object
	    var Color = function(val, customColors) {
	      this.value = {
	        h: 0,
	        s: 0,
	        b: 0,
	        a: 1
	      };
	      this.origFormat = null; // original string format
	      if (customColors) {
	        $.extend(this.colors, customColors);
	      }
	      if (val) {
	        if (val.toLowerCase !== undefined) {
	          // cast to string
	          val = val + '';
	          this.setColor(val);
	        } else if (val.h !== undefined) {
	          this.value = val;
	        }
	      }
	    };
	
	    Color.prototype = {
	      constructor: Color,
	      // 140 predefined colors from the HTML Colors spec
	      colors: {
	        "aliceblue": "#f0f8ff",
	        "antiquewhite": "#faebd7",
	        "aqua": "#00ffff",
	        "aquamarine": "#7fffd4",
	        "azure": "#f0ffff",
	        "beige": "#f5f5dc",
	        "bisque": "#ffe4c4",
	        "black": "#000000",
	        "blanchedalmond": "#ffebcd",
	        "blue": "#0000ff",
	        "blueviolet": "#8a2be2",
	        "brown": "#a52a2a",
	        "burlywood": "#deb887",
	        "cadetblue": "#5f9ea0",
	        "chartreuse": "#7fff00",
	        "chocolate": "#d2691e",
	        "coral": "#ff7f50",
	        "cornflowerblue": "#6495ed",
	        "cornsilk": "#fff8dc",
	        "crimson": "#dc143c",
	        "cyan": "#00ffff",
	        "darkblue": "#00008b",
	        "darkcyan": "#008b8b",
	        "darkgoldenrod": "#b8860b",
	        "darkgray": "#a9a9a9",
	        "darkgreen": "#006400",
	        "darkkhaki": "#bdb76b",
	        "darkmagenta": "#8b008b",
	        "darkolivegreen": "#556b2f",
	        "darkorange": "#ff8c00",
	        "darkorchid": "#9932cc",
	        "darkred": "#8b0000",
	        "darksalmon": "#e9967a",
	        "darkseagreen": "#8fbc8f",
	        "darkslateblue": "#483d8b",
	        "darkslategray": "#2f4f4f",
	        "darkturquoise": "#00ced1",
	        "darkviolet": "#9400d3",
	        "deeppink": "#ff1493",
	        "deepskyblue": "#00bfff",
	        "dimgray": "#696969",
	        "dodgerblue": "#1e90ff",
	        "firebrick": "#b22222",
	        "floralwhite": "#fffaf0",
	        "forestgreen": "#228b22",
	        "fuchsia": "#ff00ff",
	        "gainsboro": "#dcdcdc",
	        "ghostwhite": "#f8f8ff",
	        "gold": "#ffd700",
	        "goldenrod": "#daa520",
	        "gray": "#808080",
	        "green": "#008000",
	        "greenyellow": "#adff2f",
	        "honeydew": "#f0fff0",
	        "hotpink": "#ff69b4",
	        "indianred": "#cd5c5c",
	        "indigo": "#4b0082",
	        "ivory": "#fffff0",
	        "khaki": "#f0e68c",
	        "lavender": "#e6e6fa",
	        "lavenderblush": "#fff0f5",
	        "lawngreen": "#7cfc00",
	        "lemonchiffon": "#fffacd",
	        "lightblue": "#add8e6",
	        "lightcoral": "#f08080",
	        "lightcyan": "#e0ffff",
	        "lightgoldenrodyellow": "#fafad2",
	        "lightgrey": "#d3d3d3",
	        "lightgreen": "#90ee90",
	        "lightpink": "#ffb6c1",
	        "lightsalmon": "#ffa07a",
	        "lightseagreen": "#20b2aa",
	        "lightskyblue": "#87cefa",
	        "lightslategray": "#778899",
	        "lightsteelblue": "#b0c4de",
	        "lightyellow": "#ffffe0",
	        "lime": "#00ff00",
	        "limegreen": "#32cd32",
	        "linen": "#faf0e6",
	        "magenta": "#ff00ff",
	        "maroon": "#800000",
	        "mediumaquamarine": "#66cdaa",
	        "mediumblue": "#0000cd",
	        "mediumorchid": "#ba55d3",
	        "mediumpurple": "#9370d8",
	        "mediumseagreen": "#3cb371",
	        "mediumslateblue": "#7b68ee",
	        "mediumspringgreen": "#00fa9a",
	        "mediumturquoise": "#48d1cc",
	        "mediumvioletred": "#c71585",
	        "midnightblue": "#191970",
	        "mintcream": "#f5fffa",
	        "mistyrose": "#ffe4e1",
	        "moccasin": "#ffe4b5",
	        "navajowhite": "#ffdead",
	        "navy": "#000080",
	        "oldlace": "#fdf5e6",
	        "olive": "#808000",
	        "olivedrab": "#6b8e23",
	        "orange": "#ffa500",
	        "orangered": "#ff4500",
	        "orchid": "#da70d6",
	        "palegoldenrod": "#eee8aa",
	        "palegreen": "#98fb98",
	        "paleturquoise": "#afeeee",
	        "palevioletred": "#d87093",
	        "papayawhip": "#ffefd5",
	        "peachpuff": "#ffdab9",
	        "peru": "#cd853f",
	        "pink": "#ffc0cb",
	        "plum": "#dda0dd",
	        "powderblue": "#b0e0e6",
	        "purple": "#800080",
	        "red": "#ff0000",
	        "rosybrown": "#bc8f8f",
	        "royalblue": "#4169e1",
	        "saddlebrown": "#8b4513",
	        "salmon": "#fa8072",
	        "sandybrown": "#f4a460",
	        "seagreen": "#2e8b57",
	        "seashell": "#fff5ee",
	        "sienna": "#a0522d",
	        "silver": "#c0c0c0",
	        "skyblue": "#87ceeb",
	        "slateblue": "#6a5acd",
	        "slategray": "#708090",
	        "snow": "#fffafa",
	        "springgreen": "#00ff7f",
	        "steelblue": "#4682b4",
	        "tan": "#d2b48c",
	        "teal": "#008080",
	        "thistle": "#d8bfd8",
	        "tomato": "#ff6347",
	        "turquoise": "#40e0d0",
	        "violet": "#ee82ee",
	        "wheat": "#f5deb3",
	        "white": "#ffffff",
	        "whitesmoke": "#f5f5f5",
	        "yellow": "#ffff00",
	        "yellowgreen": "#9acd32",
	        "transparent": "transparent"
	      },
	      _sanitizeNumber: function(val) {
	        if (typeof val === 'number') {
	          return val;
	        }
	        if (isNaN(val) || (val === null) || (val === '') || (val === undefined)) {
	          return 1;
	        }
	        if (val.toLowerCase !== undefined) {
	          return parseFloat(val);
	        }
	        return 1;
	      },
	      isTransparent: function(strVal) {
	        if (!strVal) {
	          return false;
	        }
	        strVal = strVal.toLowerCase().trim();
	        return (strVal === 'transparent') || (strVal.match(/#?00000000/)) || (strVal.match(/(rgba|hsla)\(0,0,0,0?\.?0\)/));
	      },
	      rgbaIsTransparent: function(rgba) {
	        return ((rgba.r === 0) && (rgba.g === 0) && (rgba.b === 0) && (rgba.a === 0));
	      },
	      //parse a string to HSB
	      setColor: function(strVal) {
	        strVal = strVal.toLowerCase().trim();
	        if (strVal) {
	          if (this.isTransparent(strVal)) {
	            this.value = {
	              h: 0,
	              s: 0,
	              b: 0,
	              a: 0
	            };
	          } else {
	            this.value = this.stringToHSB(strVal) || {
	              h: 0,
	              s: 0,
	              b: 0,
	              a: 1
	            }; // if parser fails, defaults to black
	          }
	        }
	      },
	      stringToHSB: function(strVal) {
	        strVal = strVal.toLowerCase();
	        var alias;
	        if (typeof this.colors[strVal] !== 'undefined') {
	          strVal = this.colors[strVal];
	          alias = 'alias';
	        }
	        var that = this,
	          result = false;
	        $.each(this.stringParsers, function(i, parser) {
	          var match = parser.re.exec(strVal),
	            values = match && parser.parse.apply(that, [match]),
	            format = alias || parser.format || 'rgba';
	          if (values) {
	            if (format.match(/hsla?/)) {
	              result = that.RGBtoHSB.apply(that, that.HSLtoRGB.apply(that, values));
	            } else {
	              result = that.RGBtoHSB.apply(that, values);
	            }
	            that.origFormat = format;
	            return false;
	          }
	          return true;
	        });
	        return result;
	      },
	      setHue: function(h) {
	        this.value.h = 1 - h;
	      },
	      setSaturation: function(s) {
	        this.value.s = s;
	      },
	      setBrightness: function(b) {
	        this.value.b = 1 - b;
	      },
	      setAlpha: function(a) {
	        this.value.a = parseInt((1 - a) * 100, 10) / 100;
	      },
	      toRGB: function(h, s, b, a) {
	        if (!h) {
	          h = this.value.h;
	          s = this.value.s;
	          b = this.value.b;
	        }
	        h *= 360;
	        var R, G, B, X, C;
	        h = (h % 360) / 60;
	        C = b * s;
	        X = C * (1 - Math.abs(h % 2 - 1));
	        R = G = B = b - C;
	
	        h = ~~h;
	        R += [C, X, 0, 0, X, C][h];
	        G += [X, C, C, X, 0, 0][h];
	        B += [0, 0, X, C, C, X][h];
	        return {
	          r: Math.round(R * 255),
	          g: Math.round(G * 255),
	          b: Math.round(B * 255),
	          a: a || this.value.a
	        };
	      },
	      toHex: function(h, s, b, a) {
	        var rgb = this.toRGB(h, s, b, a);
	        if (this.rgbaIsTransparent(rgb)) {
	          return 'transparent';
	        }
	        return '#' + ((1 << 24) | (parseInt(rgb.r) << 16) | (parseInt(rgb.g) << 8) | parseInt(rgb.b)).toString(16).substr(1);
	      },
	      toHSL: function(h, s, b, a) {
	        h = h || this.value.h;
	        s = s || this.value.s;
	        b = b || this.value.b;
	        a = a || this.value.a;
	
	        var H = h,
	          L = (2 - s) * b,
	          S = s * b;
	        if (L > 0 && L <= 1) {
	          S /= L;
	        } else {
	          S /= 2 - L;
	        }
	        L /= 2;
	        if (S > 1) {
	          S = 1;
	        }
	        return {
	          h: isNaN(H) ? 0 : H,
	          s: isNaN(S) ? 0 : S,
	          l: isNaN(L) ? 0 : L,
	          a: isNaN(a) ? 0 : a
	        };
	      },
	      toAlias: function(r, g, b, a) {
	        var rgb = this.toHex(r, g, b, a);
	        for (var alias in this.colors) {
	          if (this.colors[alias] === rgb) {
	            return alias;
	          }
	        }
	        return false;
	      },
	      RGBtoHSB: function(r, g, b, a) {
	        r /= 255;
	        g /= 255;
	        b /= 255;
	
	        var H, S, V, C;
	        V = Math.max(r, g, b);
	        C = V - Math.min(r, g, b);
	        H = (C === 0 ? null :
	          V === r ? (g - b) / C :
	          V === g ? (b - r) / C + 2 :
	          (r - g) / C + 4
	        );
	        H = ((H + 360) % 6) * 60 / 360;
	        S = C === 0 ? 0 : C / V;
	        return {
	          h: this._sanitizeNumber(H),
	          s: S,
	          b: V,
	          a: this._sanitizeNumber(a)
	        };
	      },
	      HueToRGB: function(p, q, h) {
	        if (h < 0) {
	          h += 1;
	        } else if (h > 1) {
	          h -= 1;
	        }
	        if ((h * 6) < 1) {
	          return p + (q - p) * h * 6;
	        } else if ((h * 2) < 1) {
	          return q;
	        } else if ((h * 3) < 2) {
	          return p + (q - p) * ((2 / 3) - h) * 6;
	        } else {
	          return p;
	        }
	      },
	      HSLtoRGB: function(h, s, l, a) {
	        if (s < 0) {
	          s = 0;
	        }
	        var q;
	        if (l <= 0.5) {
	          q = l * (1 + s);
	        } else {
	          q = l + s - (l * s);
	        }
	
	        var p = 2 * l - q;
	
	        var tr = h + (1 / 3);
	        var tg = h;
	        var tb = h - (1 / 3);
	
	        var r = Math.round(this.HueToRGB(p, q, tr) * 255);
	        var g = Math.round(this.HueToRGB(p, q, tg) * 255);
	        var b = Math.round(this.HueToRGB(p, q, tb) * 255);
	        return [r, g, b, this._sanitizeNumber(a)];
	      },
	      toString: function(format) {
	        format = format || 'rgba';
	        var c = false;
	        switch (format) {
	          case 'rgb':
	            {
	              c = this.toRGB();
	              if (this.rgbaIsTransparent(c)) {
	                return 'transparent';
	              }
	              return 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')';
	            }
	            break;
	          case 'rgba':
	            {
	              c = this.toRGB();
	              return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + c.a + ')';
	            }
	            break;
	          case 'hsl':
	            {
	              c = this.toHSL();
	              return 'hsl(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%)';
	            }
	            break;
	          case 'hsla':
	            {
	              c = this.toHSL();
	              return 'hsla(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%,' + c.a + ')';
	            }
	            break;
	          case 'hex':
	            {
	              return this.toHex();
	            }
	            break;
	          case 'alias':
	            return this.toAlias() || this.toHex();
	          default:
	            {
	              return c;
	            }
	            break;
	        }
	      },
	      // a set of RE's that can match strings and generate color tuples.
	      // from John Resig color plugin
	      // https://github.com/jquery/jquery-color/
	      stringParsers: [{
	        re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
	        format: 'rgb',
	        parse: function(execResult) {
	          return [
	            execResult[1],
	            execResult[2],
	            execResult[3],
	            1
	          ];
	        }
	      }, {
	        re: /rgb\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*?\)/,
	        format: 'rgb',
	        parse: function(execResult) {
	          return [
	            2.55 * execResult[1],
	            2.55 * execResult[2],
	            2.55 * execResult[3],
	            1
	          ];
	        }
	      }, {
	        re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	        format: 'rgba',
	        parse: function(execResult) {
	          return [
	            execResult[1],
	            execResult[2],
	            execResult[3],
	            execResult[4]
	          ];
	        }
	      }, {
	        re: /rgba\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	        format: 'rgba',
	        parse: function(execResult) {
	          return [
	            2.55 * execResult[1],
	            2.55 * execResult[2],
	            2.55 * execResult[3],
	            execResult[4]
	          ];
	        }
	      }, {
	        re: /hsl\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*?\)/,
	        format: 'hsl',
	        parse: function(execResult) {
	          return [
	            execResult[1] / 360,
	            execResult[2] / 100,
	            execResult[3] / 100,
	            execResult[4]
	          ];
	        }
	      }, {
	        re: /hsla\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	        format: 'hsla',
	        parse: function(execResult) {
	          return [
	            execResult[1] / 360,
	            execResult[2] / 100,
	            execResult[3] / 100,
	            execResult[4]
	          ];
	        }
	      }, {
	        re: /#?([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
	        format: 'hex',
	        parse: function(execResult) {
	          return [
	            parseInt(execResult[1], 16),
	            parseInt(execResult[2], 16),
	            parseInt(execResult[3], 16),
	            1
	          ];
	        }
	      }, {
	        re: /#?([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
	        format: 'hex',
	        parse: function(execResult) {
	          return [
	            parseInt(execResult[1] + execResult[1], 16),
	            parseInt(execResult[2] + execResult[2], 16),
	            parseInt(execResult[3] + execResult[3], 16),
	            1
	          ];
	        }
	      }],
	      colorNameToHex: function(name) {
	        if (typeof this.colors[name.toLowerCase()] !== 'undefined') {
	          return this.colors[name.toLowerCase()];
	        }
	        return false;
	      }
	    };
	
	
	    var defaults = {
	      horizontal: false, // horizontal mode layout ?
	      inline: false, //forces to show the colorpicker as an inline element
	      color: false, //forces a color
	      format: false, //forces a format
	      input: 'input', // children input selector
	      container: false, // container selector
	      component: '.add-on, .input-group-addon', // children component selector
	      sliders: {
	        saturation: {
	          maxLeft: 100,
	          maxTop: 100,
	          callLeft: 'setSaturation',
	          callTop: 'setBrightness'
	        },
	        hue: {
	          maxLeft: 0,
	          maxTop: 100,
	          callLeft: false,
	          callTop: 'setHue'
	        },
	        alpha: {
	          maxLeft: 0,
	          maxTop: 100,
	          callLeft: false,
	          callTop: 'setAlpha'
	        }
	      },
	      slidersHorz: {
	        saturation: {
	          maxLeft: 100,
	          maxTop: 100,
	          callLeft: 'setSaturation',
	          callTop: 'setBrightness'
	        },
	        hue: {
	          maxLeft: 100,
	          maxTop: 0,
	          callLeft: 'setHue',
	          callTop: false
	        },
	        alpha: {
	          maxLeft: 100,
	          maxTop: 0,
	          callLeft: 'setAlpha',
	          callTop: false
	        }
	      },
	      template: '<div class="colorpicker dropdown-menu">' +
	        '<div class="colorpicker-saturation"><i><b></b></i></div>' +
	        '<div class="colorpicker-hue"><i></i></div>' +
	        '<div class="colorpicker-alpha"><i></i></div>' +
	        '<div class="colorpicker-color"><div /></div>' +
	        '<div class="colorpicker-selectors"></div>' +
	        '</div>',
	      align: 'right',
	      customClass: null,
	      colorSelectors: null
	    };
	
	    var Colorpicker = function(element, options) {
	      this.element = $(element).addClass('colorpicker-element');
	      this.options = $.extend(true, {}, defaults, this.element.data(), options);
	      this.component = this.options.component;
	      this.component = (this.component !== false) ? this.element.find(this.component) : false;
	      if (this.component && (this.component.length === 0)) {
	        this.component = false;
	      }
	      this.container = (this.options.container === true) ? this.element : this.options.container;
	      this.container = (this.container !== false) ? $(this.container) : false;
	
	      // Is the element an input? Should we search inside for any input?
	      this.input = this.element.is('input') ? this.element : (this.options.input ?
	        this.element.find(this.options.input) : false);
	      if (this.input && (this.input.length === 0)) {
	        this.input = false;
	      }
	      // Set HSB color
	      this.color = new Color(this.options.color !== false ? this.options.color : this.getValue(), this.options.colorSelectors);
	      this.format = this.options.format !== false ? this.options.format : this.color.origFormat;
	
	      // Setup picker
	      this.picker = $(this.options.template);
	      if (this.options.customClass) {
	        this.picker.addClass(this.options.customClass);
	      }
	      if (this.options.inline) {
	        this.picker.addClass('colorpicker-inline colorpicker-visible');
	      } else {
	        this.picker.addClass('colorpicker-hidden');
	      }
	      if (this.options.horizontal) {
	        this.picker.addClass('colorpicker-horizontal');
	      }
	      if (this.format === 'rgba' || this.format === 'hsla' || this.options.format === false) {
	        this.picker.addClass('colorpicker-with-alpha');
	      }
	      if (this.options.align === 'right') {
	        this.picker.addClass('colorpicker-right');
	      }
	      if (this.options.colorSelectors) {
	        var colorpicker = this;
	        $.each(this.options.colorSelectors, function(name, color) {
	          var $btn = $('<i />').css('background-color', color).data('class', name);
	          $btn.click(function() {
	            colorpicker.setValue($(this).css('background-color'));
	          });
	          colorpicker.picker.find('.colorpicker-selectors').append($btn);
	        });
	        this.picker.find('.colorpicker-selectors').show();
	      }
	      this.picker.on('mousedown.colorpicker touchstart.colorpicker', $.proxy(this.mousedown, this));
	      this.picker.appendTo(this.container ? this.container : $('body'));
	
	      // Bind events
	      if (this.input !== false) {
	        this.input.on({
	          'keyup.colorpicker': $.proxy(this.keyup, this)
	        });
	        this.input.on({
	          'change.colorpicker': $.proxy(this.change, this)
	        });
	        if (this.component === false) {
	          this.element.on({
	            'focus.colorpicker': $.proxy(this.show, this)
	          });
	        }
	        if (this.options.inline === false) {
	          this.element.on({
	            'focusout.colorpicker': $.proxy(this.hide, this)
	          });
	        }
	      }
	
	      if (this.component !== false) {
	        this.component.on({
	          'click.colorpicker': $.proxy(this.show, this)
	        });
	      }
	
	      if ((this.input === false) && (this.component === false)) {
	        this.element.on({
	          'click.colorpicker': $.proxy(this.show, this)
	        });
	      }
	
	      // for HTML5 input[type='color']
	      if ((this.input !== false) && (this.component !== false) && (this.input.attr('type') === 'color')) {
	
	        this.input.on({
	          'click.colorpicker': $.proxy(this.show, this),
	          'focus.colorpicker': $.proxy(this.show, this)
	        });
	      }
	      this.update();
	
	      $($.proxy(function() {
	        this.element.trigger('create');
	      }, this));
	    };
	
	    Colorpicker.Color = Color;
	
	    Colorpicker.prototype = {
	      constructor: Colorpicker,
	      destroy: function() {
	        this.picker.remove();
	        this.element.removeData('colorpicker').off('.colorpicker');
	        if (this.input !== false) {
	          this.input.off('.colorpicker');
	        }
	        if (this.component !== false) {
	          this.component.off('.colorpicker');
	        }
	        this.element.removeClass('colorpicker-element');
	        this.element.trigger({
	          type: 'destroy'
	        });
	      },
	      reposition: function() {
	        if (this.options.inline !== false || this.options.container) {
	          return false;
	        }
	        var type = this.container && this.container[0] !== document.body ? 'position' : 'offset';
	        var element = this.component || this.element;
	        var offset = element[type]();
	        if (this.options.align === 'right') {
	          offset.left -= this.picker.outerWidth() - element.outerWidth();
	        }
	        this.picker.css({
	          top: offset.top + element.outerHeight(),
	          left: offset.left
	        });
	      },
	      show: function(e) {
	        if (this.isDisabled()) {
	          return false;
	        }
	        this.picker.addClass('colorpicker-visible').removeClass('colorpicker-hidden');
	        this.reposition();
	        $(window).on('resize.colorpicker', $.proxy(this.reposition, this));
	        if (e && (!this.hasInput() || this.input.attr('type') === 'color')) {
	          if (e.stopPropagation && e.preventDefault) {
	            e.stopPropagation();
	            e.preventDefault();
	          }
	        }
	        if (this.options.inline === false) {
	          $(window.document).on({
	            'mousedown.colorpicker': $.proxy(this.hide, this)
	          });
	        }
	        this.element.trigger({
	          type: 'showPicker',
	          color: this.color
	        });
	      },
	      hide: function() {
	        this.picker.addClass('colorpicker-hidden').removeClass('colorpicker-visible');
	        $(window).off('resize.colorpicker', this.reposition);
	        $(document).off({
	          'mousedown.colorpicker': this.hide
	        });
	        this.update();
	        this.element.trigger({
	          type: 'hidePicker',
	          color: this.color
	        });
	      },
	      updateData: function(val) {
	        val = val || this.color.toString(this.format);
	        this.element.data('color', val);
	        return val;
	      },
	      updateInput: function(val) {
	        val = val || this.color.toString(this.format);
	        if (this.input !== false) {
	          if (this.options.colorSelectors) {
	            var color = new Color(val, this.options.colorSelectors);
	            var alias = color.toAlias();
	            if (typeof this.options.colorSelectors[alias] !== 'undefined') {
	              val = alias;
	            }
	          }
	          this.input.prop('value', val);
	        }
	        return val;
	      },
	      updatePicker: function(val) {
	        if (val !== undefined) {
	          this.color = new Color(val, this.options.colorSelectors);
	        }
	        var sl = (this.options.horizontal === false) ? this.options.sliders : this.options.slidersHorz;
	        var icns = this.picker.find('i');
	        if (icns.length === 0) {
	          return;
	        }
	        if (this.options.horizontal === false) {
	          sl = this.options.sliders;
	          icns.eq(1).css('top', sl.hue.maxTop * (1 - this.color.value.h)).end()
	            .eq(2).css('top', sl.alpha.maxTop * (1 - this.color.value.a));
	        } else {
	          sl = this.options.slidersHorz;
	          icns.eq(1).css('left', sl.hue.maxLeft * (1 - this.color.value.h)).end()
	            .eq(2).css('left', sl.alpha.maxLeft * (1 - this.color.value.a));
	        }
	        icns.eq(0).css({
	          'top': sl.saturation.maxTop - this.color.value.b * sl.saturation.maxTop,
	          'left': this.color.value.s * sl.saturation.maxLeft
	        });
	        this.picker.find('.colorpicker-saturation').css('backgroundColor', this.color.toHex(this.color.value.h, 1, 1, 1));
	        this.picker.find('.colorpicker-alpha').css('backgroundColor', this.color.toHex());
	        this.picker.find('.colorpicker-color, .colorpicker-color div').css('backgroundColor', this.color.toString(this.format));
	        return val;
	      },
	      updateComponent: function(val) {
	        val = val || this.color.toString(this.format);
	        if (this.component !== false) {
	          var icn = this.component.find('i').eq(0);
	          if (icn.length > 0) {
	            icn.css({
	              'backgroundColor': val
	            });
	          } else {
	            this.component.css({
	              'backgroundColor': val
	            });
	          }
	        }
	        return val;
	      },
	      update: function(force) {
	        var val;
	        if ((this.getValue(false) !== false) || (force === true)) {
	          // Update input/data only if the current value is not empty
	          val = this.updateComponent();
	          this.updateInput(val);
	          this.updateData(val);
	          this.updatePicker(); // only update picker if value is not empty
	        }
	        return val;
	
	      },
	      setValue: function(val) { // set color manually
	        this.color = new Color(val, this.options.colorSelectors);
	        this.update(true);
	        this.element.trigger({
	          type: 'changeColor',
	          color: this.color,
	          value: val
	        });
	      },
	      getValue: function(defaultValue) {
	        defaultValue = (defaultValue === undefined) ? '#000000' : defaultValue;
	        var val;
	        if (this.hasInput()) {
	          val = this.input.val();
	        } else {
	          val = this.element.data('color');
	        }
	        if ((val === undefined) || (val === '') || (val === null)) {
	          // if not defined or empty, return default
	          val = defaultValue;
	        }
	        return val;
	      },
	      hasInput: function() {
	        return (this.input !== false);
	      },
	      isDisabled: function() {
	        if (this.hasInput()) {
	          return (this.input.prop('disabled') === true);
	        }
	        return false;
	      },
	      disable: function() {
	        if (this.hasInput()) {
	          this.input.prop('disabled', true);
	          this.element.trigger({
	            type: 'disable',
	            color: this.color,
	            value: this.getValue()
	          });
	          return true;
	        }
	        return false;
	      },
	      enable: function() {
	        if (this.hasInput()) {
	          this.input.prop('disabled', false);
	          this.element.trigger({
	            type: 'enable',
	            color: this.color,
	            value: this.getValue()
	          });
	          return true;
	        }
	        return false;
	      },
	      currentSlider: null,
	      mousePointer: {
	        left: 0,
	        top: 0
	      },
	      mousedown: function(e) {
	        if (!e.pageX && !e.pageY && e.originalEvent) {
	          e.pageX = e.originalEvent.touches[0].pageX;
	          e.pageY = e.originalEvent.touches[0].pageY;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	
	        var target = $(e.target);
	
	        //detect the slider and set the limits and callbacks
	        var zone = target.closest('div');
	        var sl = this.options.horizontal ? this.options.slidersHorz : this.options.sliders;
	        if (!zone.is('.colorpicker')) {
	          if (zone.is('.colorpicker-saturation')) {
	            this.currentSlider = $.extend({}, sl.saturation);
	          } else if (zone.is('.colorpicker-hue')) {
	            this.currentSlider = $.extend({}, sl.hue);
	          } else if (zone.is('.colorpicker-alpha')) {
	            this.currentSlider = $.extend({}, sl.alpha);
	          } else {
	            return false;
	          }
	          var offset = zone.offset();
	          //reference to guide's style
	          this.currentSlider.guide = zone.find('i')[0].style;
	          this.currentSlider.left = e.pageX - offset.left;
	          this.currentSlider.top = e.pageY - offset.top;
	          this.mousePointer = {
	            left: e.pageX,
	            top: e.pageY
	          };
	          //trigger mousemove to move the guide to the current position
	          $(document).on({
	            'mousemove.colorpicker': $.proxy(this.mousemove, this),
	            'touchmove.colorpicker': $.proxy(this.mousemove, this),
	            'mouseup.colorpicker': $.proxy(this.mouseup, this),
	            'touchend.colorpicker': $.proxy(this.mouseup, this)
	          }).trigger('mousemove');
	        }
	        return false;
	      },
	      mousemove: function(e) {
	        if (!e.pageX && !e.pageY && e.originalEvent) {
	          e.pageX = e.originalEvent.touches[0].pageX;
	          e.pageY = e.originalEvent.touches[0].pageY;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	        var left = Math.max(
	          0,
	          Math.min(
	            this.currentSlider.maxLeft,
	            this.currentSlider.left + ((e.pageX || this.mousePointer.left) - this.mousePointer.left)
	          )
	        );
	        var top = Math.max(
	          0,
	          Math.min(
	            this.currentSlider.maxTop,
	            this.currentSlider.top + ((e.pageY || this.mousePointer.top) - this.mousePointer.top)
	          )
	        );
	        this.currentSlider.guide.left = left + 'px';
	        this.currentSlider.guide.top = top + 'px';
	        if (this.currentSlider.callLeft) {
	          this.color[this.currentSlider.callLeft].call(this.color, left / this.currentSlider.maxLeft);
	        }
	        if (this.currentSlider.callTop) {
	          this.color[this.currentSlider.callTop].call(this.color, top / this.currentSlider.maxTop);
	        }
	        // Change format dynamically
	        // Only occurs if user choose the dynamic format by
	        // setting option format to false
	        if (this.currentSlider.callTop === 'setAlpha' && this.options.format === false) {
	
	          // Converting from hex / rgb to rgba
	          if (this.color.value.a !== 1) {
	            this.format = 'rgba';
	            this.color.origFormat = 'rgba';
	          }
	
	          // Converting from rgba to hex
	          else {
	            this.format = 'hex';
	            this.color.origFormat = 'hex';
	          }
	        }
	        this.update(true);
	
	        this.element.trigger({
	          type: 'changeColor',
	          color: this.color
	        });
	        return false;
	      },
	      mouseup: function(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        $(document).off({
	          'mousemove.colorpicker': this.mousemove,
	          'touchmove.colorpicker': this.mousemove,
	          'mouseup.colorpicker': this.mouseup,
	          'touchend.colorpicker': this.mouseup
	        });
	        return false;
	      },
	      change: function(e) {
	        this.keyup(e);
	      },
	      keyup: function(e) {
	        if ((e.keyCode === 38)) {
	          if (this.color.value.a < 1) {
	            this.color.value.a = Math.round((this.color.value.a + 0.01) * 100) / 100;
	          }
	          this.update(true);
	        } else if ((e.keyCode === 40)) {
	          if (this.color.value.a > 0) {
	            this.color.value.a = Math.round((this.color.value.a - 0.01) * 100) / 100;
	          }
	          this.update(true);
	        } else {
	          this.color = new Color(this.input.val(), this.options.colorSelectors);
	          // Change format dynamically
	          // Only occurs if user choose the dynamic format by
	          // setting option format to false
	          if (this.color.origFormat && this.options.format === false) {
	            this.format = this.color.origFormat;
	          }
	          if (this.getValue(false) !== false) {
	            this.updateData();
	            this.updateComponent();
	            this.updatePicker();
	          }
	        }
	        this.element.trigger({
	          type: 'changeColor',
	          color: this.color,
	          value: this.input.val()
	        });
	      }
	    };
	
	    $.colorpicker = Colorpicker;
	
	    $.fn.colorpicker = function(option) {
	      var pickerArgs = arguments,
	        rv;
	
	      var $returnValue = this.each(function() {
	        var $this = $(this),
	          inst = $this.data('colorpicker'),
	          options = ((typeof option === 'object') ? option : {});
	        if ((!inst) && (typeof option !== 'string')) {
	          $this.data('colorpicker', new Colorpicker(this, options));
	        } else {
	          if (typeof option === 'string') {
	            rv = inst[option].apply(inst, Array.prototype.slice.call(pickerArgs, 1));
	          }
	        }
	      });
	      if (option === 'getValue') {
	        return rv;
	      }
	      return $returnValue;
	    };
	
	    $.fn.colorpicker.constructor = Colorpicker;
	
	  }));
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
	__webpack_require__(1299)
	__webpack_require__(1289)
	__webpack_require__(1290)
	__webpack_require__(1291)
	__webpack_require__(1292)
	__webpack_require__(1293)
	__webpack_require__(1294)
	__webpack_require__(1298)
	__webpack_require__(1295)
	__webpack_require__(1296)
	__webpack_require__(1297)
	__webpack_require__(1288)


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.6
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.6'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.6
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.6'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.6
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.6'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target)
	      if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"]') || $(e.target).is('input[type="checkbox"]'))) e.preventDefault()
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.6
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.6'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.6
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.6'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	


/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.6
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.6'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	


/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.6
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.6'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.6
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.6'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	


/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.6
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.6'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.6
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.6'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.6
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.6'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      that.$element
	        .removeAttr('aria-describedby')
	        .trigger('hidden.bs.' + that.type)
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	


/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.6
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	


/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var aes = __webpack_require__(206)
	var Transform = __webpack_require__(146)
	var inherits = __webpack_require__(27)
	var modes = __webpack_require__(207)
	var StreamCipher = __webpack_require__(499)
	var AuthCipher = __webpack_require__(492)
	var ebtk = __webpack_require__(220)
	
	inherits(Decipher, Transform)
	function Decipher (mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv)
	  }
	  Transform.call(this)
	  this._cache = new Splitter()
	  this._last = void 0
	  this._cipher = new aes.AES(key)
	  this._prev = new Buffer(iv.length)
	  iv.copy(this._prev)
	  this._mode = mode
	  this._autopadding = true
	}
	Decipher.prototype._update = function (data) {
	  this._cache.add(data)
	  var chunk
	  var thing
	  var out = []
	  while ((chunk = this._cache.get(this._autopadding))) {
	    thing = this._mode.decrypt(this, chunk)
	    out.push(thing)
	  }
	  return Buffer.concat(out)
	}
	Decipher.prototype._final = function () {
	  var chunk = this._cache.flush()
	  if (this._autopadding) {
	    return unpad(this._mode.decrypt(this, chunk))
	  } else if (chunk) {
	    throw new Error('data not multiple of block length')
	  }
	}
	Decipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo
	  return this
	}
	function Splitter () {
	  if (!(this instanceof Splitter)) {
	    return new Splitter()
	  }
	  this.cache = new Buffer('')
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data])
	}
	
	Splitter.prototype.get = function (autoPadding) {
	  var out
	  if (autoPadding) {
	    if (this.cache.length > 16) {
	      out = this.cache.slice(0, 16)
	      this.cache = this.cache.slice(16)
	      return out
	    }
	  } else {
	    if (this.cache.length >= 16) {
	      out = this.cache.slice(0, 16)
	      this.cache = this.cache.slice(16)
	      return out
	    }
	  }
	  return null
	}
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache
	  }
	}
	function unpad (last) {
	  var padded = last[15]
	  var i = -1
	  while (++i < padded) {
	    if (last[(i + (16 - padded))] !== padded) {
	      throw new Error('unable to decrypt data')
	    }
	  }
	  if (padded === 16) {
	    return
	  }
	  return last.slice(0, 16 - padded)
	}
	
	var modelist = {
	  ECB: __webpack_require__(497),
	  CBC: __webpack_require__(493),
	  CFB: __webpack_require__(494),
	  CFB8: __webpack_require__(496),
	  CFB1: __webpack_require__(495),
	  OFB: __webpack_require__(498),
	  CTR: __webpack_require__(208),
	  GCM: __webpack_require__(208)
	}
	
	function createDecipheriv (suite, password, iv) {
	  var config = modes[suite.toLowerCase()]
	  if (!config) {
	    throw new TypeError('invalid suite type')
	  }
	  if (typeof iv === 'string') {
	    iv = new Buffer(iv)
	  }
	  if (typeof password === 'string') {
	    password = new Buffer(password)
	  }
	  if (password.length !== config.key / 8) {
	    throw new TypeError('invalid key length ' + password.length)
	  }
	  if (iv.length !== config.iv) {
	    throw new TypeError('invalid iv length ' + iv.length)
	  }
	  if (config.type === 'stream') {
	    return new StreamCipher(modelist[config.mode], password, iv, true)
	  } else if (config.type === 'auth') {
	    return new AuthCipher(modelist[config.mode], password, iv, true)
	  }
	  return new Decipher(modelist[config.mode], password, iv)
	}
	
	function createDecipher (suite, password) {
	  var config = modes[suite.toLowerCase()]
	  if (!config) {
	    throw new TypeError('invalid suite type')
	  }
	  var keys = ebtk(password, false, config.key, config.iv)
	  return createDecipheriv(suite, keys.key, keys.iv)
	}
	exports.createDecipher = createDecipher
	exports.createDecipheriv = createDecipheriv
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var aes = __webpack_require__(206)
	var Transform = __webpack_require__(146)
	var inherits = __webpack_require__(27)
	var modes = __webpack_require__(207)
	var ebtk = __webpack_require__(220)
	var StreamCipher = __webpack_require__(499)
	var AuthCipher = __webpack_require__(492)
	inherits(Cipher, Transform)
	function Cipher (mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv)
	  }
	  Transform.call(this)
	  this._cache = new Splitter()
	  this._cipher = new aes.AES(key)
	  this._prev = new Buffer(iv.length)
	  iv.copy(this._prev)
	  this._mode = mode
	  this._autopadding = true
	}
	Cipher.prototype._update = function (data) {
	  this._cache.add(data)
	  var chunk
	  var thing
	  var out = []
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk)
	    out.push(thing)
	  }
	  return Buffer.concat(out)
	}
	Cipher.prototype._final = function () {
	  var chunk = this._cache.flush()
	  if (this._autopadding) {
	    chunk = this._mode.encrypt(this, chunk)
	    this._cipher.scrub()
	    return chunk
	  } else if (chunk.toString('hex') !== '10101010101010101010101010101010') {
	    this._cipher.scrub()
	    throw new Error('data not multiple of block length')
	  }
	}
	Cipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo
	  return this
	}
	
	function Splitter () {
	  if (!(this instanceof Splitter)) {
	    return new Splitter()
	  }
	  this.cache = new Buffer('')
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data])
	}
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16)
	    this.cache = this.cache.slice(16)
	    return out
	  }
	  return null
	}
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length
	  var padBuff = new Buffer(len)
	
	  var i = -1
	  while (++i < len) {
	    padBuff.writeUInt8(len, i)
	  }
	  var out = Buffer.concat([this.cache, padBuff])
	  return out
	}
	var modelist = {
	  ECB: __webpack_require__(497),
	  CBC: __webpack_require__(493),
	  CFB: __webpack_require__(494),
	  CFB8: __webpack_require__(496),
	  CFB1: __webpack_require__(495),
	  OFB: __webpack_require__(498),
	  CTR: __webpack_require__(208),
	  GCM: __webpack_require__(208)
	}
	
	function createCipheriv (suite, password, iv) {
	  var config = modes[suite.toLowerCase()]
	  if (!config) {
	    throw new TypeError('invalid suite type')
	  }
	  if (typeof iv === 'string') {
	    iv = new Buffer(iv)
	  }
	  if (typeof password === 'string') {
	    password = new Buffer(password)
	  }
	  if (password.length !== config.key / 8) {
	    throw new TypeError('invalid key length ' + password.length)
	  }
	  if (iv.length !== config.iv) {
	    throw new TypeError('invalid iv length ' + iv.length)
	  }
	  if (config.type === 'stream') {
	    return new StreamCipher(modelist[config.mode], password, iv)
	  } else if (config.type === 'auth') {
	    return new AuthCipher(modelist[config.mode], password, iv)
	  }
	  return new Cipher(modelist[config.mode], password, iv)
	}
	function createCipher (suite, password) {
	  var config = modes[suite.toLowerCase()]
	  if (!config) {
	    throw new TypeError('invalid suite type')
	  }
	  var keys = ebtk(password, false, config.key, config.iv)
	  return createCipheriv(suite, keys.key, keys.iv)
	}
	
	exports.createCipheriv = createCipheriv
	exports.createCipher = createCipher
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var zeros = new Buffer(16)
	zeros.fill(0)
	module.e = GHASH
	function GHASH (key) {
	  this.h = key
	  this.state = new Buffer(16)
	  this.state.fill(0)
	  this.cache = new Buffer('')
	}
	// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
	// by Juho Vähä-Herttua
	GHASH.prototype.ghash = function (block) {
	  var i = -1
	  while (++i < block.length) {
	    this.state[i] ^= block[i]
	  }
	  this._multiply()
	}
	
	GHASH.prototype._multiply = function () {
	  var Vi = toArray(this.h)
	  var Zi = [0, 0, 0, 0]
	  var j, xi, lsb_Vi
	  var i = -1
	  while (++i < 128) {
	    xi = (this.state[~~(i / 8)] & (1 << (7 - i % 8))) !== 0
	    if (xi) {
	      // Z_i+1 = Z_i ^ V_i
	      Zi = xor(Zi, Vi)
	    }
	
	    // Store the value of LSB(V_i)
	    lsb_Vi = (Vi[3] & 1) !== 0
	
	    // V_i+1 = V_i >> 1
	    for (j = 3; j > 0; j--) {
	      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
	    }
	    Vi[0] = Vi[0] >>> 1
	
	    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
	    if (lsb_Vi) {
	      Vi[0] = Vi[0] ^ (0xe1 << 24)
	    }
	  }
	  this.state = fromArray(Zi)
	}
	GHASH.prototype.update = function (buf) {
	  this.cache = Buffer.concat([this.cache, buf])
	  var chunk
	  while (this.cache.length >= 16) {
	    chunk = this.cache.slice(0, 16)
	    this.cache = this.cache.slice(16)
	    this.ghash(chunk)
	  }
	}
	GHASH.prototype.final = function (abl, bl) {
	  if (this.cache.length) {
	    this.ghash(Buffer.concat([this.cache, zeros], 16))
	  }
	  this.ghash(fromArray([
	    0, abl,
	    0, bl
	  ]))
	  return this.state
	}
	
	function toArray (buf) {
	  return [
	    buf.readUInt32BE(0),
	    buf.readUInt32BE(4),
	    buf.readUInt32BE(8),
	    buf.readUInt32BE(12)
	  ]
	}
	function fromArray (out) {
	  out = out.map(fixup_uint32)
	  var buf = new Buffer(16)
	  buf.writeUInt32BE(out[0], 0)
	  buf.writeUInt32BE(out[1], 4)
	  buf.writeUInt32BE(out[2], 8)
	  buf.writeUInt32BE(out[3], 12)
	  return buf
	}
	var uint_max = Math.pow(2, 32)
	function fixup_uint32 (x) {
	  var ret, x_pos
	  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x
	  return ret
	}
	function xor (a, b) {
	  return [
	    a[0] ^ b[0],
	    a[1] ^ b[1],
	    a[2] ^ b[2],
	    a[3] ^ b[3]
	  ]
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ebtk = __webpack_require__(220)
	var aes = __webpack_require__(279)
	var DES = __webpack_require__(1304)
	var desModes = __webpack_require__(1305)
	var aesModes = __webpack_require__(207)
	function createCipher (suite, password) {
	  var keyLen, ivLen
	  suite = suite.toLowerCase()
	  if (aesModes[suite]) {
	    keyLen = aesModes[suite].key
	    ivLen = aesModes[suite].iv
	  } else if (desModes[suite]) {
	    keyLen = desModes[suite].key * 8
	    ivLen = desModes[suite].iv
	  } else {
	    throw new TypeError('invalid suite type')
	  }
	  var keys = ebtk(password, false, keyLen, ivLen)
	  return createCipheriv(suite, keys.key, keys.iv)
	}
	function createDecipher (suite, password) {
	  var keyLen, ivLen
	  suite = suite.toLowerCase()
	  if (aesModes[suite]) {
	    keyLen = aesModes[suite].key
	    ivLen = aesModes[suite].iv
	  } else if (desModes[suite]) {
	    keyLen = desModes[suite].key * 8
	    ivLen = desModes[suite].iv
	  } else {
	    throw new TypeError('invalid suite type')
	  }
	  var keys = ebtk(password, false, keyLen, ivLen)
	  return createDecipheriv(suite, keys.key, keys.iv)
	}
	
	function createCipheriv (suite, key, iv) {
	  suite = suite.toLowerCase()
	  if (aesModes[suite]) {
	    return aes.createCipheriv(suite, key, iv)
	  } else if (desModes[suite]) {
	    return new DES({
	      key: key,
	      iv: iv,
	      mode: suite
	    })
	  } else {
	    throw new TypeError('invalid suite type')
	  }
	}
	function createDecipheriv (suite, key, iv) {
	  suite = suite.toLowerCase()
	  if (aesModes[suite]) {
	    return aes.createDecipheriv(suite, key, iv)
	  } else if (desModes[suite]) {
	    return new DES({
	      key: key,
	      iv: iv,
	      mode: suite,
	      decrypt: true
	    })
	  } else {
	    throw new TypeError('invalid suite type')
	  }
	}
	exports.createCipher = exports.Cipher = createCipher
	exports.createCipheriv = exports.Cipheriv = createCipheriv
	exports.createDecipher = exports.Decipher = createDecipher
	exports.createDecipheriv = exports.Decipheriv = createDecipheriv
	function getCiphers () {
	  return Object.keys(desModes).concat(aes.getCiphers())
	}
	exports.listCiphers = exports.getCiphers = getCiphers
	


/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var CipherBase = __webpack_require__(146)
	var des = __webpack_require__(292)
	var inherits = __webpack_require__(27)
	
	var modes = {
	  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
	  'des-ede3': des.EDE,
	  'des-ede-cbc': des.CBC.instantiate(des.EDE),
	  'des-ede': des.EDE,
	  'des-cbc': des.CBC.instantiate(des.DES),
	  'des-ecb': des.DES
	}
	modes.des = modes['des-cbc']
	modes.des3 = modes['des-ede3-cbc']
	module.e = DES
	inherits(DES, CipherBase)
	function DES (opts) {
	  CipherBase.call(this)
	  var modeName = opts.mode.toLowerCase()
	  var mode = modes[modeName]
	  var type
	  if (opts.decrypt) {
	    type = 'decrypt'
	  } else {
	    type = 'encrypt'
	  }
	  var key = opts.key
	  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
	    key = Buffer.concat([key, key.slice(0, 8)])
	  }
	  var iv = opts.iv
	  this._des = mode.create({
	    key: key,
	    iv: iv,
	    type: type
	  })
	}
	DES.prototype._update = function (data) {
	  return new Buffer(this._des.update(data))
	}
	DES.prototype._final = function () {
	  return new Buffer(this._des.final())
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports['des-ecb'] = {
	  key: 8,
	  iv: 0
	}
	exports['des-cbc'] = exports.des = {
	  key: 8,
	  iv: 8
	}
	exports['des-ede3-cbc'] = exports.des3 = {
	  key: 24,
	  iv: 8
	}
	exports['des-ede3'] = {
	  key: 24,
	  iv: 0
	}
	exports['des-ede-cbc'] = {
	  key: 16,
	  iv: 8
	}
	exports['des-ede'] = {
	  key: 16,
	  iv: 0
	}
	


/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var _algos = __webpack_require__(500)
	var createHash = __webpack_require__(149)
	var inherits = __webpack_require__(27)
	var sign = __webpack_require__(1307)
	var stream = __webpack_require__(157)
	var verify = __webpack_require__(1308)
	
	var algos = {}
	Object.keys(_algos).forEach(function (key) {
	  algos[key] = algos[key.toLowerCase()] = _algos[key]
	})
	
	function Sign (algorithm) {
	  stream.Writable.call(this)
	
	  var data = algos[algorithm]
	  if (!data) {
	    throw new Error('Unknown message digest')
	  }
	
	  this._hashType = data.hash
	  this._hash = createHash(data.hash)
	  this._tag = data.id
	  this._signType = data.sign
	}
	inherits(Sign, stream.Writable)
	
	Sign.prototype._write = function _write (data, _, done) {
	  this._hash.update(data)
	  done()
	}
	
	Sign.prototype.update = function update (data, enc) {
	  if (typeof data === 'string') {
	    data = new Buffer(data, enc)
	  }
	
	  this._hash.update(data)
	  return this
	}
	
	Sign.prototype.sign = function signMethod (key, enc) {
	  this.end()
	  var hash = this._hash.digest()
	  var sig = sign(Buffer.concat([this._tag, hash]), key, this._hashType, this._signType)
	
	  return enc ? sig.toString(enc) : sig
	}
	
	function Verify (algorithm) {
	  stream.Writable.call(this)
	
	  var data = algos[algorithm]
	  if (!data) {
	    throw new Error('Unknown message digest')
	  }
	
	  this._hash = createHash(data.hash)
	  this._tag = data.id
	  this._signType = data.sign
	}
	inherits(Verify, stream.Writable)
	
	Verify.prototype._write = function _write (data, _, done) {
	  this._hash.update(data)
	
	  done()
	}
	
	Verify.prototype.update = function update (data, enc) {
	  if (typeof data === 'string') {
	    data = new Buffer(data, enc)
	  }
	
	  this._hash.update(data)
	  return this
	}
	
	Verify.prototype.verify = function verifyMethod (key, sig, enc) {
	  if (typeof sig === 'string') {
	    sig = new Buffer(sig, enc)
	  }
	
	  this.end()
	  var hash = this._hash.digest()
	
	  return verify(sig, Buffer.concat([this._tag, hash]), key, this._signType)
	}
	
	function createSign (algorithm) {
	  return new Sign(algorithm)
	}
	
	function createVerify (algorithm) {
	  return new Verify(algorithm)
	}
	
	module.e = {
	  Sign: createSign,
	  Verify: createVerify,
	  createSign: createSign,
	  createVerify: createVerify
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
	var createHmac = __webpack_require__(291)
	var crt = __webpack_require__(280)
	var curves = __webpack_require__(501)
	var elliptic = __webpack_require__(57)
	var parseKeys = __webpack_require__(225)
	
	var BN = __webpack_require__(39)
	var EC = elliptic.ec
	
	function sign (hash, key, hashType, signType) {
	  var priv = parseKeys(key)
	  if (priv.curve) {
	    if (signType !== 'ecdsa') throw new Error('wrong private key type')
	
	    return ecSign(hash, priv)
	  } else if (priv.type === 'dsa') {
	    if (signType !== 'dsa') {
	      throw new Error('wrong private key type')
	    }
	    return dsaSign(hash, priv, hashType)
	  } else {
	    if (signType !== 'rsa') throw new Error('wrong private key type')
	  }
	
	  var len = priv.modulus.byteLength()
	  var pad = [ 0, 1 ]
	  while (hash.length + pad.length + 1 < len) {
	    pad.push(0xff)
	  }
	  pad.push(0x00)
	  var i = -1
	  while (++i < hash.length) {
	    pad.push(hash[i])
	  }
	
	  var out = crt(pad, priv)
	  return out
	}
	
	function ecSign (hash, priv) {
	  var curveId = curves[priv.curve.join('.')]
	  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))
	
	  var curve = new EC(curveId)
	  var key = curve.genKeyPair()
	
	  key._importPrivate(priv.privateKey)
	  var out = key.sign(hash)
	
	  return new Buffer(out.toDER())
	}
	
	function dsaSign (hash, priv, algo) {
	  var x = priv.params.priv_key
	  var p = priv.params.p
	  var q = priv.params.q
	  var g = priv.params.g
	  var r = new BN(0)
	  var k
	  var H = bits2int(hash, q).mod(q)
	  var s = false
	  var kv = getKey(x, q, hash, algo)
	  while (s === false) {
	    k = makeKey(q, kv, algo)
	    r = makeR(g, k, p, q)
	    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
	    if (!s.cmpn(0)) {
	      s = false
	      r = new BN(0)
	    }
	  }
	  return toDER(r, s)
	}
	
	function toDER (r, s) {
	  r = r.toArray()
	  s = s.toArray()
	
	  // Pad values
	  if (r[0] & 0x80) {
	    r = [ 0 ].concat(r)
	  }
	  // Pad values
	  if (s[0] & 0x80) {
	    s = [0].concat(s)
	  }
	
	  var total = r.length + s.length + 4
	  var res = [ 0x30, total, 0x02, r.length ]
	  res = res.concat(r, [ 0x02, s.length ], s)
	  return new Buffer(res)
	}
	
	function getKey (x, q, hash, algo) {
	  x = new Buffer(x.toArray())
	  if (x.length < q.byteLength()) {
	    var zeros = new Buffer(q.byteLength() - x.length)
	    zeros.fill(0)
	    x = Buffer.concat([zeros, x])
	  }
	  var hlen = hash.length
	  var hbits = bits2octets(hash, q)
	  var v = new Buffer(hlen)
	  v.fill(1)
	  var k = new Buffer(hlen)
	  k.fill(0)
	  k = createHmac(algo, k)
	    .update(v)
	    .update(new Buffer([0]))
	    .update(x)
	    .update(hbits)
	    .digest()
	  v = createHmac(algo, k)
	    .update(v)
	    .digest()
	  k = createHmac(algo, k)
	    .update(v)
	    .update(new Buffer([1]))
	    .update(x)
	    .update(hbits)
	    .digest()
	  v = createHmac(algo, k)
	    .update(v)
	    .digest()
	  return {
	    k: k,
	    v: v
	  }
	}
	
	function bits2int (obits, q) {
	  var bits = new BN(obits)
	  var shift = (obits.length << 3) - q.bitLength()
	  if (shift > 0) {
	    bits.ishrn(shift)
	  }
	  return bits
	}
	
	function bits2octets (bits, q) {
	  bits = bits2int(bits, q)
	  bits = bits.mod(q)
	  var out = new Buffer(bits.toArray())
	  if (out.length < q.byteLength()) {
	    var zeros = new Buffer(q.byteLength() - out.length)
	    zeros.fill(0)
	    out = Buffer.concat([zeros, out])
	  }
	  return out
	}
	
	function makeKey (q, kv, algo) {
	  var t, k
	
	  do {
	    t = new Buffer('')
	
	    while (t.length * 8 < q.bitLength()) {
	      kv.v = createHmac(algo, kv.k)
	        .update(kv.v)
	        .digest()
	      t = Buffer.concat([t, kv.v])
	    }
	
	    k = bits2int(t, q)
	    kv.k = createHmac(algo, kv.k)
	      .update(kv.v)
	      .update(new Buffer([0]))
	      .digest()
	    kv.v = createHmac(algo, kv.k)
	      .update(kv.v)
	      .digest()
	  } while (k.cmp(q) !== -1)
	
	  return k
	}
	
	function makeR (g, k, p, q) {
	  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
	}
	
	module.e = sign
	module.e.getKey = getKey
	module.e.makeKey = makeKey
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
	var curves = __webpack_require__(501)
	var elliptic = __webpack_require__(57)
	var parseKeys = __webpack_require__(225)
	
	var BN = __webpack_require__(39)
	var EC = elliptic.ec
	
	function verify (sig, hash, key, signType) {
	  var pub = parseKeys(key)
	  if (pub.type === 'ec') {
	    if (signType !== 'ecdsa') {
	      throw new Error('wrong public key type')
	    }
	    return ecVerify(sig, hash, pub)
	  } else if (pub.type === 'dsa') {
	    if (signType !== 'dsa') {
	      throw new Error('wrong public key type')
	    }
	    return dsaVerify(sig, hash, pub)
	  } else {
	    if (signType !== 'rsa') {
	      throw new Error('wrong public key type')
	    }
	  }
	  var len = pub.modulus.byteLength()
	  var pad = [ 1 ]
	  var padNum = 0
	  while (hash.length + pad.length + 2 < len) {
	    pad.push(0xff)
	    padNum++
	  }
	  pad.push(0x00)
	  var i = -1
	  while (++i < hash.length) {
	    pad.push(hash[i])
	  }
	  pad = new Buffer(pad)
	  var red = BN.mont(pub.modulus)
	  sig = new BN(sig).toRed(red)
	
	  sig = sig.redPow(new BN(pub.publicExponent))
	
	  sig = new Buffer(sig.fromRed().toArray())
	  var out = 0
	  if (padNum < 8) {
	    out = 1
	  }
	  len = Math.min(sig.length, pad.length)
	  if (sig.length !== pad.length) {
	    out = 1
	  }
	
	  i = -1
	  while (++i < len) {
	    out |= (sig[i] ^ pad[i])
	  }
	  return out === 0
	}
	
	function ecVerify (sig, hash, pub) {
	  var curveId = curves[pub.data.algorithm.curve.join('.')]
	  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))
	
	  var curve = new EC(curveId)
	  var pubkey = pub.data.subjectPrivateKey.data
	
	  return curve.verify(hash, sig, pubkey)
	}
	
	function dsaVerify (sig, hash, pub) {
	  var p = pub.data.p
	  var q = pub.data.q
	  var g = pub.data.g
	  var y = pub.data.pub_key
	  var unpacked = parseKeys.signature.decode(sig, 'der')
	  var s = unpacked.s
	  var r = unpacked.r
	  checkValue(s, q)
	  checkValue(r, q)
	  var montp = BN.mont(p)
	  var w = s.invm(q)
	  var v = g.toRed(montp)
	    .redPow(new BN(hash).mul(w).mod(q))
	    .fromRed()
	    .mul(
	      y.toRed(montp)
	        .redPow(r.mul(w).mod(q))
	        .fromRed()
	  ).mod(p).mod(q)
	  return !v.cmp(r)
	}
	
	function checkValue (b, q) {
	  if (b.cmpn(0) <= 0) {
	    throw new Error('invalid sig')
	  }
	  if (b.cmp(q) >= q) {
	    throw new Error('invalid sig')
	  }
	}
	
	module.e = verify
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toString = {}.toString;
	
	module.e = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};
	


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.e = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};
	


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(171);
	__webpack_require__(1342);
	module.e = __webpack_require__(46).Array.from;


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(214);
	__webpack_require__(171);
	module.e = __webpack_require__(1340);


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(214);
	__webpack_require__(171);
	module.e = __webpack_require__(1341);


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var core = __webpack_require__(46);
	module.e = function stringify(it){ // eslint-disable-line no-unused-vars
	  return (core.JSON && core.JSON.stringify || JSON.stringify).apply(JSON, arguments);
	};


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(290);
	__webpack_require__(171);
	__webpack_require__(214);
	__webpack_require__(1344);
	__webpack_require__(1354);
	module.e = __webpack_require__(46).Map;


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1345);
	module.e = __webpack_require__(46).Object.assign;


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $ = __webpack_require__(43);
	module.e = function create(P, D){
	  return $.create(P, D);
	};


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $ = __webpack_require__(43);
	module.e = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $ = __webpack_require__(43);
	__webpack_require__(1346);
	module.e = function getOwnPropertyDescriptor(it, key){
	  return $.getDesc(it, key);
	};


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1347);
	module.e = __webpack_require__(46).Object.getPrototypeOf;


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1348);
	module.e = __webpack_require__(46).Object.keys;


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1349);
	module.e = __webpack_require__(46).Object.setPrototypeOf;


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1350);
	module.e = __webpack_require__(46).Reflect.deleteProperty;


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1351);
	module.e = __webpack_require__(46).Reflect.ownKeys;


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(290);
	__webpack_require__(171);
	__webpack_require__(214);
	__webpack_require__(1352);
	__webpack_require__(1355);
	module.e = __webpack_require__(46).Set;


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	__webpack_require__(1353);
	__webpack_require__(290);
	module.e = __webpack_require__(46).Symbol;


/***/ },
/* 1327 */
62,
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(){ /* empty */ };


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(43);
	module.e = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(170)
	  , getNames  = __webpack_require__(43).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.e.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(282);
	module.e = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var $              = __webpack_require__(43)
	  , descriptor     = __webpack_require__(286)
	  , setToStringTag = __webpack_require__(212)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(169)(IteratorPrototype, __webpack_require__(86)('iterator'), function(){ return this; });
	
	module.e = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var ITERATOR     = __webpack_require__(86)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.e = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var $         = __webpack_require__(43)
	  , toIObject = __webpack_require__(170);
	module.e = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(43)
	  , toObject = __webpack_require__(213)
	  , IObject  = __webpack_require__(506);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.e = __webpack_require__(168)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// all object keys, includes non-enumerable and symbols
	var $        = __webpack_require__(43)
	  , anObject = __webpack_require__(126)
	  , Reflect  = __webpack_require__(147).Reflect;
	module.e = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = $.getNames(anObject(it))
	    , getSymbols = $.getSymbols;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(43).getDesc
	  , isObject = __webpack_require__(211)
	  , anObject = __webpack_require__(126);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.e = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(166)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var core        = __webpack_require__(46)
	  , $           = __webpack_require__(43)
	  , DESCRIPTORS = __webpack_require__(167)
	  , SPECIES     = __webpack_require__(86)('species');
	
	module.e = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toInteger = __webpack_require__(514)
	  , defined   = __webpack_require__(209);
	// true  -> String#at
	// false -> String#codePointAt
	module.e = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var anObject = __webpack_require__(126)
	  , get      = __webpack_require__(289);
	module.e = __webpack_require__(46).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var classof   = __webpack_require__(281)
	  , ITERATOR  = __webpack_require__(86)('iterator')
	  , Iterators = __webpack_require__(148);
	module.e = __webpack_require__(46).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var ctx         = __webpack_require__(166)
	  , $export     = __webpack_require__(77)
	  , toObject    = __webpack_require__(213)
	  , call        = __webpack_require__(508)
	  , isArrayIter = __webpack_require__(507)
	  , toLength    = __webpack_require__(515)
	  , getIterFn   = __webpack_require__(289);
	$export($export.S + $export.F * !__webpack_require__(1333)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});
	


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var addToUnscopables = __webpack_require__(1328)
	  , step             = __webpack_require__(509)
	  , Iterators        = __webpack_require__(148)
	  , toIObject        = __webpack_require__(170);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.e = __webpack_require__(284)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var strong = __webpack_require__(503);
	
	// 23.1 Map Objects
	__webpack_require__(505)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(77);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(1335)});


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(170);
	
	__webpack_require__(285)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(213);
	
	__webpack_require__(285)('getPrototypeOf', function($getPrototypeOf){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(213);
	
	__webpack_require__(285)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(77);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1337).set});


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(77)
	  , getDesc  = __webpack_require__(43).getDesc
	  , anObject = __webpack_require__(126);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = getDesc(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(77);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(1336)});


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var strong = __webpack_require__(503);
	
	// 23.2 Set Objects
	__webpack_require__(505)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(43)
	  , global         = __webpack_require__(147)
	  , has            = __webpack_require__(210)
	  , DESCRIPTORS    = __webpack_require__(167)
	  , $export        = __webpack_require__(77)
	  , redefine       = __webpack_require__(287)
	  , $fails         = __webpack_require__(168)
	  , shared         = __webpack_require__(512)
	  , setToStringTag = __webpack_require__(212)
	  , uid            = __webpack_require__(288)
	  , wks            = __webpack_require__(86)
	  , keyOf          = __webpack_require__(1334)
	  , $names         = __webpack_require__(1330)
	  , enumKeys       = __webpack_require__(1329)
	  , isArray        = __webpack_require__(1331)
	  , anObject       = __webpack_require__(126)
	  , toIObject      = __webpack_require__(170)
	  , createDesc     = __webpack_require__(286)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(510)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(77);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(504)('Map')});


/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(77);
	
	$export($export.P, 'Set', {toJSON: __webpack_require__(504)('Set')});


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var elliptic = __webpack_require__(57);
	var BN = __webpack_require__(39);
	
	module.e = function createECDH(curve) {
		return new ECDH(curve);
	};
	
	var aliases = {
		secp256k1: {
			name: 'secp256k1',
			byteLength: 32
		},
		secp224r1: {
			name: 'p224',
			byteLength: 28
		},
		prime256v1: {
			name: 'p256',
			byteLength: 32
		},
		prime192v1: {
			name: 'p192',
			byteLength: 24
		},
		ed25519: {
			name: 'ed25519',
			byteLength: 32
		},
		secp384r1: {
			name: 'p384',
			byteLength: 48
		},
		secp521r1: {
			name: 'p521',
			byteLength: 66
		}
	};
	
	aliases.p224 = aliases.secp224r1;
	aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
	aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
	aliases.p384 = aliases.secp384r1;
	aliases.p521 = aliases.secp521r1;
	
	function ECDH(curve) {
		this.curveType = aliases[curve];
		if (!this.curveType ) {
			this.curveType = {
				name: curve
			};
		}
		this.curve = new elliptic.ec(this.curveType.name);
		this.keys = void 0;
	}
	
	ECDH.prototype.generateKeys = function (enc, format) {
		this.keys = this.curve.genKeyPair();
		return this.getPublicKey(enc, format);
	};
	
	ECDH.prototype.computeSecret = function (other, inenc, enc) {
		inenc = inenc || 'utf8';
		if (!Buffer.isBuffer(other)) {
			other = new Buffer(other, inenc);
		}
		var otherPub = this.curve.keyFromPublic(other).getPublic();
		var out = otherPub.mul(this.keys.getPrivate()).getX();
		return formatReturnValue(out, enc, this.curveType.byteLength);
	};
	
	ECDH.prototype.getPublicKey = function (enc, format) {
		var key = this.keys.getPublic(format === 'compressed', true);
		if (format === 'hybrid') {
			if (key[key.length - 1] % 2) {
				key[0] = 7;
			} else {
				key [0] = 6;
			}
		}
		return formatReturnValue(key, enc);
	};
	
	ECDH.prototype.getPrivateKey = function (enc) {
		return formatReturnValue(this.keys.getPrivate(), enc);
	};
	
	ECDH.prototype.setPublicKey = function (pub, enc) {
		enc = enc || 'utf8';
		if (!Buffer.isBuffer(pub)) {
			pub = new Buffer(pub, enc);
		}
		this.keys._importPublic(pub);
		return this;
	};
	
	ECDH.prototype.setPrivateKey = function (priv, enc) {
		enc = enc || 'utf8';
		if (!Buffer.isBuffer(priv)) {
			priv = new Buffer(priv, enc);
		}
		var _priv = new BN(priv);
		_priv = _priv.toString(16);
		this.keys._importPrivate(_priv);
		return this;
	};
	
	function formatReturnValue(bn, enc, len) {
		if (!Array.isArray(bn)) {
			bn = bn.toArray();
		}
		var buf = new Buffer(bn);
		if (len && buf.length < len) {
			var zeros = new Buffer(len - buf.length);
			zeros.fill(0);
			buf = Buffer.concat([zeros, buf]);
		}
		if (!enc) {
			return buf;
		} else {
			return buf.toString(enc);
		}
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	exports.hash = hash;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1360);
	var isArguments = __webpack_require__(1359);
	
	var deepEqual = module.e = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.e = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports = module.e = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var assert = __webpack_require__(174);
	var inherits = __webpack_require__(27);
	
	var proto = {};
	
	function CBCState(iv) {
	  assert.equal(iv.length, 8, 'Invalid IV length');
	
	  this.iv = new Array(8);
	  for (var i = 0; i < this.iv.length; i++)
	    this.iv[i] = iv[i];
	}
	
	function instantiate(Base) {
	  function CBC(options) {
	    Base.call(this, options);
	    this._cbcInit();
	  }
	  inherits(CBC, Base);
	
	  var keys = Object.keys(proto);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    CBC.prototype[key] = proto[key];
	  }
	
	  CBC.create = function create(options) {
	    return new CBC(options);
	  };
	
	  return CBC;
	}
	
	exports.instantiate = instantiate;
	
	proto._cbcInit = function _cbcInit() {
	  var state = new CBCState(this.options.iv);
	  this._cbcState = state;
	};
	
	proto._update = function _update(inp, inOff, out, outOff) {
	  var state = this._cbcState;
	  var superProto = this.constructor.super_.prototype;
	
	  var iv = state.iv;
	  if (this.type === 'encrypt') {
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] ^= inp[inOff + i];
	
	    superProto._update.call(this, iv, 0, out, outOff);
	
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] = out[outOff + i];
	  } else {
	    superProto._update.call(this, inp, inOff, out, outOff);
	
	    for (var i = 0; i < this.blockSize; i++)
	      out[outOff + i] ^= iv[i];
	
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] = inp[inOff + i];
	  }
	};
	


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var assert = __webpack_require__(174);
	
	function Cipher(options) {
	  this.options = options;
	
	  this.type = this.options.type;
	  this.blockSize = 8;
	  this._init();
	
	  this.buffer = new Array(this.blockSize);
	  this.bufferOff = 0;
	}
	module.e = Cipher;
	
	Cipher.prototype._init = function _init() {
	  // Might be overrided
	};
	
	Cipher.prototype.update = function update(data) {
	  if (data.length === 0)
	    return [];
	
	  if (this.type === 'decrypt')
	    return this._updateDecrypt(data);
	  else
	    return this._updateEncrypt(data);
	};
	
	Cipher.prototype._buffer = function _buffer(data, off) {
	  // Append data to buffer
	  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
	  for (var i = 0; i < min; i++)
	    this.buffer[this.bufferOff + i] = data[off + i];
	  this.bufferOff += min;
	
	  // Shift next
	  return min;
	};
	
	Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
	  this._update(this.buffer, 0, out, off);
	  this.bufferOff = 0;
	  return this.blockSize;
	};
	
	Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
	  var inputOff = 0;
	  var outputOff = 0;
	
	  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
	  var out = new Array(count * this.blockSize);
	
	  if (this.bufferOff !== 0) {
	    inputOff += this._buffer(data, inputOff);
	
	    if (this.bufferOff === this.buffer.length)
	      outputOff += this._flushBuffer(out, outputOff);
	  }
	
	  // Write blocks
	  var max = data.length - ((data.length - inputOff) % this.blockSize);
	  for (; inputOff < max; inputOff += this.blockSize) {
	    this._update(data, inputOff, out, outputOff);
	    outputOff += this.blockSize;
	  }
	
	  // Queue rest
	  for (; inputOff < data.length; inputOff++, this.bufferOff++)
	    this.buffer[this.bufferOff] = data[inputOff];
	
	  return out;
	};
	
	Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
	  var inputOff = 0;
	  var outputOff = 0;
	
	  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
	  var out = new Array(count * this.blockSize);
	
	  // TODO(indutny): optimize it, this is far from optimal
	  for (; count > 0; count--) {
	    inputOff += this._buffer(data, inputOff);
	    outputOff += this._flushBuffer(out, outputOff);
	  }
	
	  // Buffer rest of the input
	  inputOff += this._buffer(data, inputOff);
	
	  return out;
	};
	
	Cipher.prototype.final = function final(buffer) {
	  var first;
	  if (buffer)
	    first = this.update(buffer);
	
	  var last;
	  if (this.type === 'encrypt')
	    last = this._finalEncrypt();
	  else
	    last = this._finalDecrypt();
	
	  if (first)
	    return first.concat(last);
	  else
	    return last;
	};
	
	Cipher.prototype._pad = function _pad(buffer, off) {
	  if (off === 0)
	    return false;
	
	  while (off < buffer.length)
	    buffer[off++] = 0;
	
	  return true;
	};
	
	Cipher.prototype._finalEncrypt = function _finalEncrypt() {
	  if (!this._pad(this.buffer, this.bufferOff))
	    return [];
	
	  var out = new Array(this.blockSize);
	  this._update(this.buffer, 0, out, 0);
	  return out;
	};
	
	Cipher.prototype._unpad = function _unpad(buffer) {
	  return buffer;
	};
	
	Cipher.prototype._finalDecrypt = function _finalDecrypt() {
	  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
	  var out = new Array(this.blockSize);
	  this._flushBuffer(out, 0);
	
	  return this._unpad(out);
	};
	


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var assert = __webpack_require__(174);
	var inherits = __webpack_require__(27);
	
	var des = __webpack_require__(292);
	var utils = des.utils;
	var Cipher = des.Cipher;
	
	function DESState() {
	  this.tmp = new Array(2);
	  this.keys = null;
	}
	
	function DES(options) {
	  Cipher.call(this, options);
	
	  var state = new DESState();
	  this._desState = state;
	
	  this.deriveKeys(state, options.key);
	}
	inherits(DES, Cipher);
	module.e = DES;
	
	DES.create = function create(options) {
	  return new DES(options);
	};
	
	var shiftTable = [
	  1, 1, 2, 2, 2, 2, 2, 2,
	  1, 2, 2, 2, 2, 2, 2, 1
	];
	
	DES.prototype.deriveKeys = function deriveKeys(state, key) {
	  state.keys = new Array(16 * 2);
	
	  assert.equal(key.length, this.blockSize, 'Invalid key length');
	
	  var kL = utils.readUInt32BE(key, 0);
	  var kR = utils.readUInt32BE(key, 4);
	
	  utils.pc1(kL, kR, state.tmp, 0);
	  kL = state.tmp[0];
	  kR = state.tmp[1];
	  for (var i = 0; i < state.keys.length; i += 2) {
	    var shift = shiftTable[i >>> 1];
	    kL = utils.r28shl(kL, shift);
	    kR = utils.r28shl(kR, shift);
	    utils.pc2(kL, kR, state.keys, i);
	  }
	};
	
	DES.prototype._update = function _update(inp, inOff, out, outOff) {
	  var state = this._desState;
	
	  var l = utils.readUInt32BE(inp, inOff);
	  var r = utils.readUInt32BE(inp, inOff + 4);
	
	  // Initial Permutation
	  utils.ip(l, r, state.tmp, 0);
	  l = state.tmp[0];
	  r = state.tmp[1];
	
	  if (this.type === 'encrypt')
	    this._encrypt(state, l, r, state.tmp, 0);
	  else
	    this._decrypt(state, l, r, state.tmp, 0);
	
	  l = state.tmp[0];
	  r = state.tmp[1];
	
	  utils.writeUInt32BE(out, l, outOff);
	  utils.writeUInt32BE(out, r, outOff + 4);
	};
	
	DES.prototype._pad = function _pad(buffer, off) {
	  var value = buffer.length - off;
	  for (var i = off; i < buffer.length; i++)
	    buffer[i] = value;
	
	  return true;
	};
	
	DES.prototype._unpad = function _unpad(buffer) {
	  var pad = buffer[buffer.length - 1];
	  for (var i = buffer.length - pad; i < buffer.length; i++)
	    assert.equal(buffer[i], pad);
	
	  return buffer.slice(0, buffer.length - pad);
	};
	
	DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
	  var l = lStart;
	  var r = rStart;
	
	  // Apply f() x16 times
	  for (var i = 0; i < state.keys.length; i += 2) {
	    var keyL = state.keys[i];
	    var keyR = state.keys[i + 1];
	
	    // f(r, k)
	    utils.expand(r, state.tmp, 0);
	
	    keyL ^= state.tmp[0];
	    keyR ^= state.tmp[1];
	    var s = utils.substitute(keyL, keyR);
	    var f = utils.permute(s);
	
	    var t = r;
	    r = (l ^ f) >>> 0;
	    l = t;
	  }
	
	  // Reverse Initial Permutation
	  utils.rip(r, l, out, off);
	};
	
	DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
	  var l = rStart;
	  var r = lStart;
	
	  // Apply f() x16 times
	  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
	    var keyL = state.keys[i];
	    var keyR = state.keys[i + 1];
	
	    // f(r, k)
	    utils.expand(l, state.tmp, 0);
	
	    keyL ^= state.tmp[0];
	    keyR ^= state.tmp[1];
	    var s = utils.substitute(keyL, keyR);
	    var f = utils.permute(s);
	
	    var t = l;
	    l = (r ^ f) >>> 0;
	    r = t;
	  }
	
	  // Reverse Initial Permutation
	  utils.rip(l, r, out, off);
	};
	


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var assert = __webpack_require__(174);
	var inherits = __webpack_require__(27);
	
	var des = __webpack_require__(292);
	var Cipher = des.Cipher;
	var DES = des.DES;
	
	function EDEState(type, key) {
	  assert.equal(key.length, 24, 'Invalid key length');
	
	  var k1 = key.slice(0, 8);
	  var k2 = key.slice(8, 16);
	  var k3 = key.slice(16, 24);
	
	  if (type === 'encrypt') {
	    this.ciphers = [
	      DES.create({ type: 'encrypt', key: k1 }),
	      DES.create({ type: 'decrypt', key: k2 }),
	      DES.create({ type: 'encrypt', key: k3 })
	    ];
	  } else {
	    this.ciphers = [
	      DES.create({ type: 'decrypt', key: k3 }),
	      DES.create({ type: 'encrypt', key: k2 }),
	      DES.create({ type: 'decrypt', key: k1 })
	    ];
	  }
	}
	
	function EDE(options) {
	  Cipher.call(this, options);
	
	  var state = new EDEState(this.type, this.options.key);
	  this._edeState = state;
	}
	inherits(EDE, Cipher);
	
	module.e = EDE;
	
	EDE.create = function create(options) {
	  return new EDE(options);
	};
	
	EDE.prototype._update = function _update(inp, inOff, out, outOff) {
	  var state = this._edeState;
	
	  state.ciphers[0]._update(inp, inOff, out, outOff);
	  state.ciphers[1]._update(out, outOff, out, outOff);
	  state.ciphers[2]._update(out, outOff, out, outOff);
	};
	
	EDE.prototype._pad = DES.prototype._pad;
	EDE.prototype._unpad = DES.prototype._unpad;
	


/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.readUInt32BE = function readUInt32BE(bytes, off) {
	  var res =  (bytes[0 + off] << 24) |
	             (bytes[1 + off] << 16) |
	             (bytes[2 + off] << 8) |
	             bytes[3 + off];
	  return res >>> 0;
	};
	
	exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
	  bytes[0 + off] = value >>> 24;
	  bytes[1 + off] = (value >>> 16) & 0xff;
	  bytes[2 + off] = (value >>> 8) & 0xff;
	  bytes[3 + off] = value & 0xff;
	};
	
	exports.ip = function ip(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  for (var i = 6; i >= 0; i -= 2) {
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inR >>> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inL >>> (j + i)) & 1;
	    }
	  }
	
	  for (var i = 6; i >= 0; i -= 2) {
	    for (var j = 1; j <= 25; j += 8) {
	      outR <<= 1;
	      outR |= (inR >>> (j + i)) & 1;
	    }
	    for (var j = 1; j <= 25; j += 8) {
	      outR <<= 1;
	      outR |= (inL >>> (j + i)) & 1;
	    }
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.rip = function rip(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  for (var i = 0; i < 4; i++) {
	    for (var j = 24; j >= 0; j -= 8) {
	      outL <<= 1;
	      outL |= (inR >>> (j + i)) & 1;
	      outL <<= 1;
	      outL |= (inL >>> (j + i)) & 1;
	    }
	  }
	  for (var i = 4; i < 8; i++) {
	    for (var j = 24; j >= 0; j -= 8) {
	      outR <<= 1;
	      outR |= (inR >>> (j + i)) & 1;
	      outR <<= 1;
	      outR |= (inL >>> (j + i)) & 1;
	    }
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.pc1 = function pc1(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  // 7, 15, 23, 31, 39, 47, 55, 63
	  // 6, 14, 22, 30, 39, 47, 55, 63
	  // 5, 13, 21, 29, 39, 47, 55, 63
	  // 4, 12, 20, 28
	  for (var i = 7; i >= 5; i--) {
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inR >> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inL >> (j + i)) & 1;
	    }
	  }
	  for (var j = 0; j <= 24; j += 8) {
	    outL <<= 1;
	    outL |= (inR >> (j + i)) & 1;
	  }
	
	  // 1, 9, 17, 25, 33, 41, 49, 57
	  // 2, 10, 18, 26, 34, 42, 50, 58
	  // 3, 11, 19, 27, 35, 43, 51, 59
	  // 36, 44, 52, 60
	  for (var i = 1; i <= 3; i++) {
	    for (var j = 0; j <= 24; j += 8) {
	      outR <<= 1;
	      outR |= (inR >> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outR <<= 1;
	      outR |= (inL >> (j + i)) & 1;
	    }
	  }
	  for (var j = 0; j <= 24; j += 8) {
	    outR <<= 1;
	    outR |= (inL >> (j + i)) & 1;
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.r28shl = function r28shl(num, shift) {
	  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
	};
	
	var pc2table = [
	  // inL => outL
	  14, 11, 17, 4, 27, 23, 25, 0,
	  13, 22, 7, 18, 5, 9, 16, 24,
	  2, 20, 12, 21, 1, 8, 15, 26,
	
	  // inR => outR
	  15, 4, 25, 19, 9, 1, 26, 16,
	  5, 11, 23, 8, 12, 7, 17, 0,
	  22, 3, 10, 14, 6, 20, 27, 24
	];
	
	exports.pc2 = function pc2(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  var len = pc2table.length >>> 1;
	  for (var i = 0; i < len; i++) {
	    outL <<= 1;
	    outL |= (inL >>> pc2table[i]) & 0x1;
	  }
	  for (var i = len; i < pc2table.length; i++) {
	    outR <<= 1;
	    outR |= (inR >>> pc2table[i]) & 0x1;
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.expand = function expand(r, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  outL = ((r & 1) << 5) | (r >>> 27);
	  for (var i = 23; i >= 15; i -= 4) {
	    outL <<= 6;
	    outL |= (r >>> i) & 0x3f;
	  }
	  for (var i = 11; i >= 3; i -= 4) {
	    outR |= (r >>> i) & 0x3f;
	    outR <<= 6;
	  }
	  outR |= ((r & 0x1f) << 1) | (r >>> 31);
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	var sTable = [
	  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
	  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
	  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
	  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,
	
	  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
	  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
	  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
	  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,
	
	  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
	  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
	  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
	  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,
	
	  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
	  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
	  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
	  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,
	
	  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
	  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
	  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
	  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,
	
	  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
	  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
	  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
	  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,
	
	  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
	  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
	  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
	  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,
	
	  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
	  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
	  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
	  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
	];
	
	exports.substitute = function substitute(inL, inR) {
	  var out = 0;
	  for (var i = 0; i < 4; i++) {
	    var b = (inL >>> (18 - i * 6)) & 0x3f;
	    var sb = sTable[i * 0x40 + b];
	
	    out <<= 4;
	    out |= sb;
	  }
	  for (var i = 0; i < 4; i++) {
	    var b = (inR >>> (18 - i * 6)) & 0x3f;
	    var sb = sTable[4 * 0x40 + i * 0x40 + b];
	
	    out <<= 4;
	    out |= sb;
	  }
	  return out >>> 0;
	};
	
	var permuteTable = [
	  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
	  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
	];
	
	exports.permute = function permute(num) {
	  var out = 0;
	  for (var i = 0; i < permuteTable.length; i++) {
	    out <<= 1;
	    out |= (num >>> permuteTable[i]) & 0x1;
	  }
	  return out >>> 0;
	};
	
	exports.padSplit = function padSplit(num, size, group) {
	  var str = num.toString(2);
	  while (str.length < size)
	    str = '0' + str;
	
	  var out = [];
	  for (var i = 0; i < size; i += group)
	    out.push(str.slice(i, i + group));
	  return out.join(' ');
	};
	


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var generatePrime = __webpack_require__(517)
	var primes = __webpack_require__(1754)
	
	var DH = __webpack_require__(1367)
	
	function getDiffieHellman (mod) {
	  var prime = new Buffer(primes[mod].prime, 'hex')
	  var gen = new Buffer(primes[mod].gen, 'hex')
	
	  return new DH(prime, gen)
	}
	
	var ENCODINGS = {
	  'binary': true, 'hex': true, 'base64': true
	}
	
	function createDiffieHellman (prime, enc, generator, genc) {
	  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
	    return createDiffieHellman(prime, 'binary', enc, generator)
	  }
	
	  enc = enc || 'binary'
	  genc = genc || 'binary'
	  generator = generator || new Buffer([2])
	
	  if (!Buffer.isBuffer(generator)) {
	    generator = new Buffer(generator, genc)
	  }
	
	  if (typeof prime === 'number') {
	    return new DH(generatePrime(prime, generator), generator, true)
	  }
	
	  if (!Buffer.isBuffer(prime)) {
	    prime = new Buffer(prime, enc)
	  }
	
	  return new DH(prime, generator, true)
	}
	
	exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
	exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var BN = __webpack_require__(39);
	var MillerRabin = __webpack_require__(549);
	var millerRabin = new MillerRabin();
	var TWENTYFOUR = new BN(24);
	var ELEVEN = new BN(11);
	var TEN = new BN(10);
	var THREE = new BN(3);
	var SEVEN = new BN(7);
	var primes = __webpack_require__(517);
	var randomBytes = __webpack_require__(175);
	module.e = DH;
	
	function setPublicKey(pub, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(pub)) {
	    pub = new Buffer(pub, enc);
	  }
	  this._pub = new BN(pub);
	  return this;
	}
	
	function setPrivateKey(priv, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(priv)) {
	    priv = new Buffer(priv, enc);
	  }
	  this._priv = new BN(priv);
	  return this;
	}
	
	var primeCache = {};
	function checkPrime(prime, generator) {
	  var gen = generator.toString('hex');
	  var hex = [gen, prime.toString(16)].join('_');
	  if (hex in primeCache) {
	    return primeCache[hex];
	  }
	  var error = 0;
	
	  if (prime.isEven() ||
	    !primes.simpleSieve ||
	    !primes.fermatTest(prime) ||
	    !millerRabin.test(prime)) {
	    //not a prime so +1
	    error += 1;
	
	    if (gen === '02' || gen === '05') {
	      // we'd be able to check the generator
	      // it would fail so +8
	      error += 8;
	    } else {
	      //we wouldn't be able to test the generator
	      // so +4
	      error += 4;
	    }
	    primeCache[hex] = error;
	    return error;
	  }
	  if (!millerRabin.test(prime.shrn(1))) {
	    //not a safe prime
	    error += 2;
	  }
	  var rem;
	  switch (gen) {
	    case '02':
	      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
	        // unsuidable generator
	        error += 8;
	      }
	      break;
	    case '05':
	      rem = prime.mod(TEN);
	      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
	        // prime mod 10 needs to equal 3 or 7
	        error += 8;
	      }
	      break;
	    default:
	      error += 4;
	  }
	  primeCache[hex] = error;
	  return error;
	}
	
	function DH(prime, generator, malleable) {
	  this.setGenerator(generator);
	  this.__prime = new BN(prime);
	  this._prime = BN.mont(this.__prime);
	  this._primeLen = prime.length;
	  this._pub = undefined;
	  this._priv = undefined;
	  this._primeCode = undefined;
	  if (malleable) {
	    this.setPublicKey = setPublicKey;
	    this.setPrivateKey = setPrivateKey;
	  } else {
	    this._primeCode = 8;
	  }
	}
	Object.defineProperty(DH.prototype, 'verifyError', {
	  enumerable: true,
	  get: function () {
	    if (typeof this._primeCode !== 'number') {
	      this._primeCode = checkPrime(this.__prime, this.__gen);
	    }
	    return this._primeCode;
	  }
	});
	DH.prototype.generateKeys = function () {
	  if (!this._priv) {
	    this._priv = new BN(randomBytes(this._primeLen));
	  }
	  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
	  return this.getPublicKey();
	};
	
	DH.prototype.computeSecret = function (other) {
	  other = new BN(other);
	  other = other.toRed(this._prime);
	  var secret = other.redPow(this._priv).fromRed();
	  var out = new Buffer(secret.toArray());
	  var prime = this.getPrime();
	  if (out.length < prime.length) {
	    var front = new Buffer(prime.length - out.length);
	    front.fill(0);
	    out = Buffer.concat([front, out]);
	  }
	  return out;
	};
	
	DH.prototype.getPublicKey = function getPublicKey(enc) {
	  return formatReturnValue(this._pub, enc);
	};
	
	DH.prototype.getPrivateKey = function getPrivateKey(enc) {
	  return formatReturnValue(this._priv, enc);
	};
	
	DH.prototype.getPrime = function (enc) {
	  return formatReturnValue(this.__prime, enc);
	};
	
	DH.prototype.getGenerator = function (enc) {
	  return formatReturnValue(this._gen, enc);
	};
	
	DH.prototype.setGenerator = function (gen, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(gen)) {
	    gen = new Buffer(gen, enc);
	  }
	  this.__gen = gen;
	  this._gen = new BN(gen);
	  return this;
	};
	
	function formatReturnValue(bn, enc) {
	  var buf = new Buffer(bn.toArray());
	  if (!enc) {
	    return buf;
	  } else {
	    return buf.toString(enc);
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var hasClass = __webpack_require__(520);
	
	module.e = function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!hasClass(element)) element.className = element.className + ' ' + className;
	};


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = {
	  addClass: __webpack_require__(1368),
	  removeClass: __webpack_require__(1370),
	  hasClass: __webpack_require__(520)
	};


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var contains = __webpack_require__(173),
	    qsa = __webpack_require__(1375);
	
	module.e = function (selector, handler) {
	  return function (e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = qsa(top, selector);
	
	    if (matches.some(function (match) {
	      return contains(match, target);
	    })) handler.call(this, e);
	  };
	};


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var on = __webpack_require__(293),
	    off = __webpack_require__(521),
	    filter = __webpack_require__(1371);
	
	module.e = { on: on, off: off, filter: filter };


/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var babelHelpers = __webpack_require__(218);
	
	exports.__esModule = true;
	exports['default'] = offsetParent;
	
	var _ownerDocument = __webpack_require__(150);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	var _style = __webpack_require__(217);
	
	var _style2 = babelHelpers.interopRequireDefault(_style);
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument2['default'])(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style2['default'])(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.e = exports['default'];


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var babelHelpers = __webpack_require__(218);
	
	exports.__esModule = true;
	exports['default'] = position;
	
	var _offset = __webpack_require__(522);
	
	var _offset2 = babelHelpers.interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(1373);
	
	var _offsetParent2 = babelHelpers.interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(523);
	
	var _scrollTop2 = babelHelpers.interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__(1376);
	
	var _scrollLeft2 = babelHelpers.interopRequireDefault(_scrollLeft);
	
	var _style = __webpack_require__(217);
	
	var _style2 = babelHelpers.interopRequireDefault(_style);
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = { top: 0, left: 0 },
	      offset;
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	  if ((0, _style2['default'])(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent2['default'])(node);
	    offset = (0, _offset2['default'])(node);
	
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2['default'])(offsetParent);
	
	    parentOffset.top += parseInt((0, _style2['default'])(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2['default'])(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style2['default'])(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2['default'])(offsetParent) || 0;
	  }
	
	  // Subtract parent offsets and node margins
	  return babelHelpers._extends({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style2['default'])(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style2['default'])(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.e = exports['default'];


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	//     Zepto.js
	//     (c) 2010-2015 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/,
	    toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	module.e = function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	};


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var getWindow = __webpack_require__(216);
	
	module.e = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var babelHelpers = __webpack_require__(218);
	
	var _utilCamelizeStyle = __webpack_require__(524);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.e = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var canUseDOM = __webpack_require__(127);
	
	var has = Object.prototype.hasOwnProperty,
	    transform = 'transform',
	    transition = {},
	    transitionTiming,
	    transitionDuration,
	    transitionProperty,
	    transitionDelay;
	
	if (canUseDOM) {
	  transition = getTransitionProperties();
	
	  transform = transition.prefix + transform;
	
	  transitionProperty = transition.prefix + 'transition-property';
	  transitionDuration = transition.prefix + 'transition-duration';
	  transitionDelay = transition.prefix + 'transition-delay';
	  transitionTiming = transition.prefix + 'transition-timing-function';
	}
	
	module.e = {
	  transform: transform,
	  end: transition.end,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	function getTransitionProperties() {
	  var endEvent,
	      prefix = '',
	      transitions = {
	    O: 'otransitionend',
	    Moz: 'transitionend',
	    Webkit: 'webkitTransitionEnd',
	    ms: 'MSTransitionEnd'
	  };
	
	  var element = document.createElement('div');
	
	  for (var vendor in transitions) if (has.call(transitions, vendor)) {
	    if (element.style[vendor + 'TransitionProperty'] !== undefined) {
	      prefix = '-' + vendor.toLowerCase() + '-';
	      endEvent = transitions[vendor];
	      break;
	    }
	  }
	
	  if (!endEvent && element.style.transitionProperty !== undefined) endEvent = 'transitionend';
	
	  return { end: endEvent, prefix: prefix };
	}


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.e = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.e = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};


/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(1381);
	var msPattern = /^ms-/;
	
	module.e = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var BN = __webpack_require__(39);
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var getNAF = utils.getNAF;
	var getJSF = utils.getJSF;
	var assert = utils.assert;
	
	function BaseCurve(type, conf) {
	  this.type = type;
	  this.p = new BN(conf.p, 16);
	
	  // Use Montgomery, when there is no fast reduction for the prime
	  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
	
	  // Useful for many curves
	  this.zero = new BN(0).toRed(this.red);
	  this.one = new BN(1).toRed(this.red);
	  this.two = new BN(2).toRed(this.red);
	
	  // Curve configuration, optional
	  this.n = conf.n && new BN(conf.n, 16);
	  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
	
	  // Temporary arrays
	  this._wnafT1 = new Array(4);
	  this._wnafT2 = new Array(4);
	  this._wnafT3 = new Array(4);
	  this._wnafT4 = new Array(4);
	}
	module.e = BaseCurve;
	
	BaseCurve.prototype.point = function point() {
	  throw new Error('Not implemented');
	};
	
	BaseCurve.prototype.validate = function validate() {
	  throw new Error('Not implemented');
	};
	
	BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
	  assert(p.precomputed);
	  var doubles = p._getDoubles();
	
	  var naf = getNAF(k, 1);
	  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
	  I /= 3;
	
	  // Translate into more windowed form
	  var repr = [];
	  for (var j = 0; j < naf.length; j += doubles.step) {
	    var nafW = 0;
	    for (var k = j + doubles.step - 1; k >= j; k--)
	      nafW = (nafW << 1) + naf[k];
	    repr.push(nafW);
	  }
	
	  var a = this.jpoint(null, null, null);
	  var b = this.jpoint(null, null, null);
	  for (var i = I; i > 0; i--) {
	    for (var j = 0; j < repr.length; j++) {
	      var nafW = repr[j];
	      if (nafW === i)
	        b = b.mixedAdd(doubles.points[j]);
	      else if (nafW === -i)
	        b = b.mixedAdd(doubles.points[j].neg());
	    }
	    a = a.add(b);
	  }
	  return a.toP();
	};
	
	BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
	  var w = 4;
	
	  // Precompute window
	  var nafPoints = p._getNAFPoints(w);
	  w = nafPoints.wnd;
	  var wnd = nafPoints.points;
	
	  // Get NAF form
	  var naf = getNAF(k, w);
	
	  // Add `this`*(N+1) for every w-NAF index
	  var acc = this.jpoint(null, null, null);
	  for (var i = naf.length - 1; i >= 0; i--) {
	    // Count zeroes
	    for (var k = 0; i >= 0 && naf[i] === 0; i--)
	      k++;
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	
	    if (i < 0)
	      break;
	    var z = naf[i];
	    assert(z !== 0);
	    if (p.type === 'affine') {
	      // J +- P
	      if (z > 0)
	        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
	    } else {
	      // J +- J
	      if (z > 0)
	        acc = acc.add(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.add(wnd[(-z - 1) >> 1].neg());
	    }
	  }
	  return p.type === 'affine' ? acc.toP() : acc;
	};
	
	BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
	                                                       points,
	                                                       coeffs,
	                                                       len) {
	  var wndWidth = this._wnafT1;
	  var wnd = this._wnafT2;
	  var naf = this._wnafT3;
	
	  // Fill all arrays
	  var max = 0;
	  for (var i = 0; i < len; i++) {
	    var p = points[i];
	    var nafPoints = p._getNAFPoints(defW);
	    wndWidth[i] = nafPoints.wnd;
	    wnd[i] = nafPoints.points;
	  }
	
	  // Comb small window NAFs
	  for (var i = len - 1; i >= 1; i -= 2) {
	    var a = i - 1;
	    var b = i;
	    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
	      naf[a] = getNAF(coeffs[a], wndWidth[a]);
	      naf[b] = getNAF(coeffs[b], wndWidth[b]);
	      max = Math.max(naf[a].length, max);
	      max = Math.max(naf[b].length, max);
	      continue;
	    }
	
	    var comb = [
	      points[a], /* 1 */
	      null, /* 3 */
	      null, /* 5 */
	      points[b] /* 7 */
	    ];
	
	    // Try to avoid Projective points, if possible
	    if (points[a].y.cmp(points[b].y) === 0) {
	      comb[1] = points[a].add(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].add(points[b].neg());
	    } else {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    }
	
	    var index = [
	      -3, /* -1 -1 */
	      -1, /* -1 0 */
	      -5, /* -1 1 */
	      -7, /* 0 -1 */
	      0, /* 0 0 */
	      7, /* 0 1 */
	      5, /* 1 -1 */
	      1, /* 1 0 */
	      3  /* 1 1 */
	    ];
	
	    var jsf = getJSF(coeffs[a], coeffs[b]);
	    max = Math.max(jsf[0].length, max);
	    naf[a] = new Array(max);
	    naf[b] = new Array(max);
	    for (var j = 0; j < max; j++) {
	      var ja = jsf[0][j] | 0;
	      var jb = jsf[1][j] | 0;
	
	      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
	      naf[b][j] = 0;
	      wnd[a] = comb;
	    }
	  }
	
	  var acc = this.jpoint(null, null, null);
	  var tmp = this._wnafT4;
	  for (var i = max; i >= 0; i--) {
	    var k = 0;
	
	    while (i >= 0) {
	      var zero = true;
	      for (var j = 0; j < len; j++) {
	        tmp[j] = naf[j][i] | 0;
	        if (tmp[j] !== 0)
	          zero = false;
	      }
	      if (!zero)
	        break;
	      k++;
	      i--;
	    }
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	    if (i < 0)
	      break;
	
	    for (var j = 0; j < len; j++) {
	      var z = tmp[j];
	      var p;
	      if (z === 0)
	        continue;
	      else if (z > 0)
	        p = wnd[j][(z - 1) >> 1];
	      else if (z < 0)
	        p = wnd[j][(-z - 1) >> 1].neg();
	
	      if (p.type === 'affine')
	        acc = acc.mixedAdd(p);
	      else
	        acc = acc.add(p);
	    }
	  }
	  // Zeroify references
	  for (var i = 0; i < len; i++)
	    wnd[i] = null;
	  return acc.toP();
	};
	
	function BasePoint(curve, type) {
	  this.curve = curve;
	  this.type = type;
	  this.precomputed = null;
	}
	BaseCurve.BasePoint = BasePoint;
	
	BasePoint.prototype.eq = function eq(/*other*/) {
	  throw new Error('Not implemented');
	};
	
	BasePoint.prototype.validate = function validate() {
	  return this.curve.validate(this);
	};
	
	BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  bytes = utils.toArray(bytes, enc);
	
	  var len = this.p.byteLength();
	  if (bytes[0] === 0x04 && bytes.length - 1 === 2 * len) {
	    return this.point(bytes.slice(1, 1 + len),
	                      bytes.slice(1 + len, 1 + 2 * len));
	  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
	              bytes.length - 1 === len) {
	    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
	  }
	  throw new Error('Unknown point format');
	};
	
	BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
	  return this.encode(enc, true);
	};
	
	BasePoint.prototype._encode = function _encode(compact) {
	  var len = this.curve.p.byteLength();
	  var x = this.getX().toArray('be', len);
	
	  if (compact)
	    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);
	
	  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
	};
	
	BasePoint.prototype.encode = function encode(enc, compact) {
	  return utils.encode(this._encode(compact), enc);
	};
	
	BasePoint.prototype.precompute = function precompute(power) {
	  if (this.precomputed)
	    return this;
	
	  var precomputed = {
	    doubles: null,
	    naf: null,
	    beta: null
	  };
	  precomputed.naf = this._getNAFPoints(8);
	  precomputed.doubles = this._getDoubles(4, power);
	  precomputed.beta = this._getBeta();
	  this.precomputed = precomputed;
	
	  return this;
	};
	
	BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
	  if (!this.precomputed)
	    return false;
	
	  var doubles = this.precomputed.doubles;
	  if (!doubles)
	    return false;
	
	  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
	};
	
	BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
	  if (this.precomputed && this.precomputed.doubles)
	    return this.precomputed.doubles;
	
	  var doubles = [ this ];
	  var acc = this;
	  for (var i = 0; i < power; i += step) {
	    for (var j = 0; j < step; j++)
	      acc = acc.dbl();
	    doubles.push(acc);
	  }
	  return {
	    step: step,
	    points: doubles
	  };
	};
	
	BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
	  if (this.precomputed && this.precomputed.naf)
	    return this.precomputed.naf;
	
	  var res = [ this ];
	  var max = (1 << wnd) - 1;
	  var dbl = max === 1 ? null : this.dbl();
	  for (var i = 1; i < max; i++)
	    res[i] = res[i - 1].add(dbl);
	  return {
	    wnd: wnd,
	    points: res
	  };
	};
	
	BasePoint.prototype._getBeta = function _getBeta() {
	  return null;
	};
	
	BasePoint.prototype.dblp = function dblp(k) {
	  var r = this;
	  for (var i = 0; i < k; i++)
	    r = r.dbl();
	  return r;
	};
	


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var curve = __webpack_require__(219);
	var elliptic = __webpack_require__(57);
	var BN = __webpack_require__(39);
	var inherits = __webpack_require__(27);
	var Base = curve.base;
	
	var assert = elliptic.utils.assert;
	
	function EdwardsCurve(conf) {
	  // NOTE: Important as we are creating point in Base.call()
	  this.twisted = (conf.a | 0) !== 1;
	  this.mOneA = this.twisted && (conf.a | 0) === -1;
	  this.extended = this.mOneA;
	
	  Base.call(this, 'edwards', conf);
	
	  this.a = new BN(conf.a, 16).umod(this.red.m);
	  this.a = this.a.toRed(this.red);
	  this.c = new BN(conf.c, 16).toRed(this.red);
	  this.c2 = this.c.redSqr();
	  this.d = new BN(conf.d, 16).toRed(this.red);
	  this.dd = this.d.redAdd(this.d);
	
	  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
	  this.oneC = (conf.c | 0) === 1;
	}
	inherits(EdwardsCurve, Base);
	module.e = EdwardsCurve;
	
	EdwardsCurve.prototype._mulA = function _mulA(num) {
	  if (this.mOneA)
	    return num.redNeg();
	  else
	    return this.a.redMul(num);
	};
	
	EdwardsCurve.prototype._mulC = function _mulC(num) {
	  if (this.oneC)
	    return num;
	  else
	    return this.c.redMul(num);
	};
	
	// Just for compatibility with Short curve
	EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
	  return this.point(x, y, z, t);
	};
	
	EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);
	
	  var x2 = x.redSqr();
	  var rhs = this.c2.redSub(this.a.redMul(x2));
	  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
	
	  var y2 = rhs.redMul(lhs.redInvm());
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');
	
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();
	
	  return this.point(x, y);
	};
	
	EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
	  y = new BN(y, 16);
	  if (!y.red)
	    y = y.toRed(this.red);
	
	  // x^2 = (y^2 - 1) / (d y^2 + 1)
	  var y2 = y.redSqr();
	  var lhs = y2.redSub(this.one);
	  var rhs = y2.redMul(this.d).redAdd(this.one);
	  var x2 = lhs.redMul(rhs.redInvm());
	
	  if (x2.cmp(this.zero) === 0) {
	    if (odd)
	      throw new Error('invalid point');
	    else
	      return this.point(this.zero, y);
	  }
	
	  var x = x2.redSqrt();
	  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');
	
	  if (x.isOdd() !== odd)
	    x = x.redNeg();
	
	  return this.point(x, y);
	};
	
	EdwardsCurve.prototype.validate = function validate(point) {
	  if (point.isInfinity())
	    return true;
	
	  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
	  point.normalize();
	
	  var x2 = point.x.redSqr();
	  var y2 = point.y.redSqr();
	  var lhs = x2.redMul(this.a).redAdd(y2);
	  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
	
	  return lhs.cmp(rhs) === 0;
	};
	
	function Point(curve, x, y, z, t) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.zero;
	    this.y = this.curve.one;
	    this.z = this.curve.one;
	    this.t = this.curve.zero;
	    this.zOne = true;
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    this.z = z ? new BN(z, 16) : this.curve.one;
	    this.t = t && new BN(t, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	    if (this.t && !this.t.red)
	      this.t = this.t.toRed(this.curve.red);
	    this.zOne = this.z === this.curve.one;
	
	    // Use extended coordinates
	    if (this.curve.extended && !this.t) {
	      this.t = this.x.redMul(this.y);
	      if (!this.zOne)
	        this.t = this.t.redMul(this.z.redInvm());
	    }
	  }
	}
	inherits(Point, Base.BasePoint);
	
	EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};
	
	EdwardsCurve.prototype.point = function point(x, y, z, t) {
	  return new Point(this, x, y, z, t);
	};
	
	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1], obj[2]);
	};
	
	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};
	
	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.x.cmpn(0) === 0 &&
	         this.y.cmp(this.z) === 0;
	};
	
	Point.prototype._extDbl = function _extDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #doubling-dbl-2008-hwcd
	  // 4M + 4S
	
	  // A = X1^2
	  var a = this.x.redSqr();
	  // B = Y1^2
	  var b = this.y.redSqr();
	  // C = 2 * Z1^2
	  var c = this.z.redSqr();
	  c = c.redIAdd(c);
	  // D = a * A
	  var d = this.curve._mulA(a);
	  // E = (X1 + Y1)^2 - A - B
	  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
	  // G = D + B
	  var g = d.redAdd(b);
	  // F = G - C
	  var f = g.redSub(c);
	  // H = D - B
	  var h = d.redSub(b);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};
	
	Point.prototype._projDbl = function _projDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #doubling-dbl-2008-bbjlp
	  //     #doubling-dbl-2007-bl
	  // and others
	  // Generally 3M + 4S or 2M + 4S
	
	  // B = (X1 + Y1)^2
	  var b = this.x.redAdd(this.y).redSqr();
	  // C = X1^2
	  var c = this.x.redSqr();
	  // D = Y1^2
	  var d = this.y.redSqr();
	
	  var nx;
	  var ny;
	  var nz;
	  if (this.curve.twisted) {
	    // E = a * C
	    var e = this.curve._mulA(c);
	    // F = E + D
	    var f = e.redAdd(d);
	    if (this.zOne) {
	      // X3 = (B - C - D) * (F - 2)
	      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F^2 - 2 * F
	      nz = f.redSqr().redSub(f).redSub(f);
	    } else {
	      // H = Z1^2
	      var h = this.z.redSqr();
	      // J = F - 2 * H
	      var j = f.redSub(h).redISub(h);
	      // X3 = (B-C-D)*J
	      nx = b.redSub(c).redISub(d).redMul(j);
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F * J
	      nz = f.redMul(j);
	    }
	  } else {
	    // E = C + D
	    var e = c.redAdd(d);
	    // H = (c * Z1)^2
	    var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
	    // J = E - 2 * H
	    var j = e.redSub(h).redSub(h);
	    // X3 = c * (B - E) * J
	    nx = this.curve._mulC(b.redISub(e)).redMul(j);
	    // Y3 = c * E * (C - D)
	    ny = this.curve._mulC(e).redMul(c.redISub(d));
	    // Z3 = E * J
	    nz = e.redMul(j);
	  }
	  return this.curve.point(nx, ny, nz);
	};
	
	Point.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;
	
	  // Double in extended coordinates
	  if (this.curve.extended)
	    return this._extDbl();
	  else
	    return this._projDbl();
	};
	
	Point.prototype._extAdd = function _extAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #addition-add-2008-hwcd-3
	  // 8M
	
	  // A = (Y1 - X1) * (Y2 - X2)
	  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
	  // B = (Y1 + X1) * (Y2 + X2)
	  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
	  // C = T1 * k * T2
	  var c = this.t.redMul(this.curve.dd).redMul(p.t);
	  // D = Z1 * 2 * Z2
	  var d = this.z.redMul(p.z.redAdd(p.z));
	  // E = B - A
	  var e = b.redSub(a);
	  // F = D - C
	  var f = d.redSub(c);
	  // G = D + C
	  var g = d.redAdd(c);
	  // H = B + A
	  var h = b.redAdd(a);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};
	
	Point.prototype._projAdd = function _projAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #addition-add-2008-bbjlp
	  //     #addition-add-2007-bl
	  // 10M + 1S
	
	  // A = Z1 * Z2
	  var a = this.z.redMul(p.z);
	  // B = A^2
	  var b = a.redSqr();
	  // C = X1 * X2
	  var c = this.x.redMul(p.x);
	  // D = Y1 * Y2
	  var d = this.y.redMul(p.y);
	  // E = d * C * D
	  var e = this.curve.d.redMul(c).redMul(d);
	  // F = B - E
	  var f = b.redSub(e);
	  // G = B + E
	  var g = b.redAdd(e);
	  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
	  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
	  var nx = a.redMul(f).redMul(tmp);
	  var ny;
	  var nz;
	  if (this.curve.twisted) {
	    // Y3 = A * G * (D - a * C)
	    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
	    // Z3 = F * G
	    nz = f.redMul(g);
	  } else {
	    // Y3 = A * G * (D - C)
	    ny = a.redMul(g).redMul(d.redSub(c));
	    // Z3 = c * F * G
	    nz = this.curve._mulC(f).redMul(g);
	  }
	  return this.curve.point(nx, ny, nz);
	};
	
	Point.prototype.add = function add(p) {
	  if (this.isInfinity())
	    return p;
	  if (p.isInfinity())
	    return this;
	
	  if (this.curve.extended)
	    return this._extAdd(p);
	  else
	    return this._projAdd(p);
	};
	
	Point.prototype.mul = function mul(k) {
	  if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else
	    return this.curve._wnafMul(this, k);
	};
	
	Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2);
	};
	
	Point.prototype.normalize = function normalize() {
	  if (this.zOne)
	    return this;
	
	  // Normalize coordinates
	  var zi = this.z.redInvm();
	  this.x = this.x.redMul(zi);
	  this.y = this.y.redMul(zi);
	  if (this.t)
	    this.t = this.t.redMul(zi);
	  this.z = this.curve.one;
	  this.zOne = true;
	  return this;
	};
	
	Point.prototype.neg = function neg() {
	  return this.curve.point(this.x.redNeg(),
	                          this.y,
	                          this.z,
	                          this.t && this.t.redNeg());
	};
	
	Point.prototype.getX = function getX() {
	  this.normalize();
	  return this.x.fromRed();
	};
	
	Point.prototype.getY = function getY() {
	  this.normalize();
	  return this.y.fromRed();
	};
	
	Point.prototype.eq = function eq(other) {
	  return this === other ||
	         this.getX().cmp(other.getX()) === 0 &&
	         this.getY().cmp(other.getY()) === 0;
	};
	
	// Compatibility with BaseCurve
	Point.prototype.toP = Point.prototype.normalize;
	Point.prototype.mixedAdd = Point.prototype.add;
	


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var curve = __webpack_require__(219);
	var BN = __webpack_require__(39);
	var inherits = __webpack_require__(27);
	var Base = curve.base;
	
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	
	function MontCurve(conf) {
	  Base.call(this, 'mont', conf);
	
	  this.a = new BN(conf.a, 16).toRed(this.red);
	  this.b = new BN(conf.b, 16).toRed(this.red);
	  this.i4 = new BN(4).toRed(this.red).redInvm();
	  this.two = new BN(2).toRed(this.red);
	  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
	}
	inherits(MontCurve, Base);
	module.e = MontCurve;
	
	MontCurve.prototype.validate = function validate(point) {
	  var x = point.normalize().x;
	  var x2 = x.redSqr();
	  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
	  var y = rhs.redSqrt();
	
	  return y.redSqr().cmp(rhs) === 0;
	};
	
	function Point(curve, x, z) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && z === null) {
	    this.x = this.curve.one;
	    this.z = this.curve.zero;
	  } else {
	    this.x = new BN(x, 16);
	    this.z = new BN(z, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	  }
	}
	inherits(Point, Base.BasePoint);
	
	MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  return this.point(utils.toArray(bytes, enc), 1);
	};
	
	MontCurve.prototype.point = function point(x, z) {
	  return new Point(this, x, z);
	};
	
	MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};
	
	Point.prototype.precompute = function precompute() {
	  // No-op
	};
	
	Point.prototype._encode = function _encode() {
	  return this.getX().toArray('be', this.curve.p.byteLength());
	};
	
	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1] || curve.one);
	};
	
	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};
	
	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};
	
	Point.prototype.dbl = function dbl() {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
	  // 2M + 2S + 4A
	
	  // A = X1 + Z1
	  var a = this.x.redAdd(this.z);
	  // AA = A^2
	  var aa = a.redSqr();
	  // B = X1 - Z1
	  var b = this.x.redSub(this.z);
	  // BB = B^2
	  var bb = b.redSqr();
	  // C = AA - BB
	  var c = aa.redSub(bb);
	  // X3 = AA * BB
	  var nx = aa.redMul(bb);
	  // Z3 = C * (BB + A24 * C)
	  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
	  return this.curve.point(nx, nz);
	};
	
	Point.prototype.add = function add() {
	  throw new Error('Not supported on Montgomery curve');
	};
	
	Point.prototype.diffAdd = function diffAdd(p, diff) {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
	  // 4M + 2S + 6A
	
	  // A = X2 + Z2
	  var a = this.x.redAdd(this.z);
	  // B = X2 - Z2
	  var b = this.x.redSub(this.z);
	  // C = X3 + Z3
	  var c = p.x.redAdd(p.z);
	  // D = X3 - Z3
	  var d = p.x.redSub(p.z);
	  // DA = D * A
	  var da = d.redMul(a);
	  // CB = C * B
	  var cb = c.redMul(b);
	  // X5 = Z1 * (DA + CB)^2
	  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
	  // Z5 = X1 * (DA - CB)^2
	  var nz = diff.x.redMul(da.redISub(cb).redSqr());
	  return this.curve.point(nx, nz);
	};
	
	Point.prototype.mul = function mul(k) {
	  var t = k.clone();
	  var a = this; // (N / 2) * Q + Q
	  var b = this.curve.point(null, null); // (N / 2) * Q
	  var c = this; // Q
	
	  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
	    bits.push(t.andln(1));
	
	  for (var i = bits.length - 1; i >= 0; i--) {
	    if (bits[i] === 0) {
	      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
	      a = a.diffAdd(b, c);
	      // N * Q = 2 * ((N / 2) * Q + Q))
	      b = b.dbl();
	    } else {
	      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
	      b = a.diffAdd(b, c);
	      // N * Q + Q = 2 * ((N / 2) * Q + Q)
	      a = a.dbl();
	    }
	  }
	  return b;
	};
	
	Point.prototype.mulAdd = function mulAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};
	
	Point.prototype.eq = function eq(other) {
	  return this.getX().cmp(other.getX()) === 0;
	};
	
	Point.prototype.normalize = function normalize() {
	  this.x = this.x.redMul(this.z.redInvm());
	  this.z = this.curve.one;
	  return this;
	};
	
	Point.prototype.getX = function getX() {
	  // Normalize coordinates
	  this.normalize();
	
	  return this.x.fromRed();
	};
	


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var curve = __webpack_require__(219);
	var elliptic = __webpack_require__(57);
	var BN = __webpack_require__(39);
	var inherits = __webpack_require__(27);
	var Base = curve.base;
	
	var assert = elliptic.utils.assert;
	
	function ShortCurve(conf) {
	  Base.call(this, 'short', conf);
	
	  this.a = new BN(conf.a, 16).toRed(this.red);
	  this.b = new BN(conf.b, 16).toRed(this.red);
	  this.tinv = this.two.redInvm();
	
	  this.zeroA = this.a.fromRed().cmpn(0) === 0;
	  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
	
	  // If the curve is endomorphic, precalculate beta and lambda
	  this.endo = this._getEndomorphism(conf);
	  this._endoWnafT1 = new Array(4);
	  this._endoWnafT2 = new Array(4);
	}
	inherits(ShortCurve, Base);
	module.e = ShortCurve;
	
	ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
	  // No efficient endomorphism
	  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
	    return;
	
	  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
	  var beta;
	  var lambda;
	  if (conf.beta) {
	    beta = new BN(conf.beta, 16).toRed(this.red);
	  } else {
	    var betas = this._getEndoRoots(this.p);
	    // Choose the smallest beta
	    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
	    beta = beta.toRed(this.red);
	  }
	  if (conf.lambda) {
	    lambda = new BN(conf.lambda, 16);
	  } else {
	    // Choose the lambda that is matching selected beta
	    var lambdas = this._getEndoRoots(this.n);
	    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
	      lambda = lambdas[0];
	    } else {
	      lambda = lambdas[1];
	      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
	    }
	  }
	
	  // Get basis vectors, used for balanced length-two representation
	  var basis;
	  if (conf.basis) {
	    basis = conf.basis.map(function(vec) {
	      return {
	        a: new BN(vec.a, 16),
	        b: new BN(vec.b, 16)
	      };
	    });
	  } else {
	    basis = this._getEndoBasis(lambda);
	  }
	
	  return {
	    beta: beta,
	    lambda: lambda,
	    basis: basis
	  };
	};
	
	ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
	  // Find roots of for x^2 + x + 1 in F
	  // Root = (-1 +- Sqrt(-3)) / 2
	  //
	  var red = num === this.p ? this.red : BN.mont(num);
	  var tinv = new BN(2).toRed(red).redInvm();
	  var ntinv = tinv.redNeg();
	
	  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
	
	  var l1 = ntinv.redAdd(s).fromRed();
	  var l2 = ntinv.redSub(s).fromRed();
	  return [ l1, l2 ];
	};
	
	ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
	  // aprxSqrt >= sqrt(this.n)
	  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
	
	  // 3.74
	  // Run EGCD, until r(L + 1) < aprxSqrt
	  var u = lambda;
	  var v = this.n.clone();
	  var x1 = new BN(1);
	  var y1 = new BN(0);
	  var x2 = new BN(0);
	  var y2 = new BN(1);
	
	  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
	  var a0;
	  var b0;
	  // First vector
	  var a1;
	  var b1;
	  // Second vector
	  var a2;
	  var b2;
	
	  var prevR;
	  var i = 0;
	  var r;
	  var x;
	  while (u.cmpn(0) !== 0) {
	    var q = v.div(u);
	    r = v.sub(q.mul(u));
	    x = x2.sub(q.mul(x1));
	    var y = y2.sub(q.mul(y1));
	
	    if (!a1 && r.cmp(aprxSqrt) < 0) {
	      a0 = prevR.neg();
	      b0 = x1;
	      a1 = r.neg();
	      b1 = x;
	    } else if (a1 && ++i === 2) {
	      break;
	    }
	    prevR = r;
	
	    v = u;
	    u = r;
	    x2 = x1;
	    x1 = x;
	    y2 = y1;
	    y1 = y;
	  }
	  a2 = r.neg();
	  b2 = x;
	
	  var len1 = a1.sqr().add(b1.sqr());
	  var len2 = a2.sqr().add(b2.sqr());
	  if (len2.cmp(len1) >= 0) {
	    a2 = a0;
	    b2 = b0;
	  }
	
	  // Normalize signs
	  if (a1.negative) {
	    a1 = a1.neg();
	    b1 = b1.neg();
	  }
	  if (a2.negative) {
	    a2 = a2.neg();
	    b2 = b2.neg();
	  }
	
	  return [
	    { a: a1, b: b1 },
	    { a: a2, b: b2 }
	  ];
	};
	
	ShortCurve.prototype._endoSplit = function _endoSplit(k) {
	  var basis = this.endo.basis;
	  var v1 = basis[0];
	  var v2 = basis[1];
	
	  var c1 = v2.b.mul(k).divRound(this.n);
	  var c2 = v1.b.neg().mul(k).divRound(this.n);
	
	  var p1 = c1.mul(v1.a);
	  var p2 = c2.mul(v2.a);
	  var q1 = c1.mul(v1.b);
	  var q2 = c2.mul(v2.b);
	
	  // Calculate answer
	  var k1 = k.sub(p1).sub(p2);
	  var k2 = q1.add(q2).neg();
	  return { k1: k1, k2: k2 };
	};
	
	ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);
	
	  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');
	
	  // XXX Is there any way to tell if the number is odd without converting it
	  // to non-red form?
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();
	
	  return this.point(x, y);
	};
	
	ShortCurve.prototype.validate = function validate(point) {
	  if (point.inf)
	    return true;
	
	  var x = point.x;
	  var y = point.y;
	
	  var ax = this.a.redMul(x);
	  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
	  return y.redSqr().redISub(rhs).cmpn(0) === 0;
	};
	
	ShortCurve.prototype._endoWnafMulAdd =
	    function _endoWnafMulAdd(points, coeffs) {
	  var npoints = this._endoWnafT1;
	  var ncoeffs = this._endoWnafT2;
	  for (var i = 0; i < points.length; i++) {
	    var split = this._endoSplit(coeffs[i]);
	    var p = points[i];
	    var beta = p._getBeta();
	
	    if (split.k1.negative) {
	      split.k1.ineg();
	      p = p.neg(true);
	    }
	    if (split.k2.negative) {
	      split.k2.ineg();
	      beta = beta.neg(true);
	    }
	
	    npoints[i * 2] = p;
	    npoints[i * 2 + 1] = beta;
	    ncoeffs[i * 2] = split.k1;
	    ncoeffs[i * 2 + 1] = split.k2;
	  }
	  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2);
	
	  // Clean-up references to points and coefficients
	  for (var j = 0; j < i * 2; j++) {
	    npoints[j] = null;
	    ncoeffs[j] = null;
	  }
	  return res;
	};
	
	function Point(curve, x, y, isRed) {
	  Base.BasePoint.call(this, curve, 'affine');
	  if (x === null && y === null) {
	    this.x = null;
	    this.y = null;
	    this.inf = true;
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    // Force redgomery representation when loading from JSON
	    if (isRed) {
	      this.x.forceRed(this.curve.red);
	      this.y.forceRed(this.curve.red);
	    }
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    this.inf = false;
	  }
	}
	inherits(Point, Base.BasePoint);
	
	ShortCurve.prototype.point = function point(x, y, isRed) {
	  return new Point(this, x, y, isRed);
	};
	
	ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
	  return Point.fromJSON(this, obj, red);
	};
	
	Point.prototype._getBeta = function _getBeta() {
	  if (!this.curve.endo)
	    return;
	
	  var pre = this.precomputed;
	  if (pre && pre.beta)
	    return pre.beta;
	
	  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
	  if (pre) {
	    var curve = this.curve;
	    var endoMul = function(p) {
	      return curve.point(p.x.redMul(curve.endo.beta), p.y);
	    };
	    pre.beta = beta;
	    beta.precomputed = {
	      beta: null,
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(endoMul)
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(endoMul)
	      }
	    };
	  }
	  return beta;
	};
	
	Point.prototype.toJSON = function toJSON() {
	  if (!this.precomputed)
	    return [ this.x, this.y ];
	
	  return [ this.x, this.y, this.precomputed && {
	    doubles: this.precomputed.doubles && {
	      step: this.precomputed.doubles.step,
	      points: this.precomputed.doubles.points.slice(1)
	    },
	    naf: this.precomputed.naf && {
	      wnd: this.precomputed.naf.wnd,
	      points: this.precomputed.naf.points.slice(1)
	    }
	  } ];
	};
	
	Point.fromJSON = function fromJSON(curve, obj, red) {
	  if (typeof obj === 'string')
	    obj = JSON.parse(obj);
	  var res = curve.point(obj[0], obj[1], red);
	  if (!obj[2])
	    return res;
	
	  function obj2point(obj) {
	    return curve.point(obj[0], obj[1], red);
	  }
	
	  var pre = obj[2];
	  res.precomputed = {
	    beta: null,
	    doubles: pre.doubles && {
	      step: pre.doubles.step,
	      points: [ res ].concat(pre.doubles.points.map(obj2point))
	    },
	    naf: pre.naf && {
	      wnd: pre.naf.wnd,
	      points: [ res ].concat(pre.naf.points.map(obj2point))
	    }
	  };
	  return res;
	};
	
	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
	};
	
	Point.prototype.isInfinity = function isInfinity() {
	  return this.inf;
	};
	
	Point.prototype.add = function add(p) {
	  // O + P = P
	  if (this.inf)
	    return p;
	
	  // P + O = P
	  if (p.inf)
	    return this;
	
	  // P + P = 2P
	  if (this.eq(p))
	    return this.dbl();
	
	  // P + (-P) = O
	  if (this.neg().eq(p))
	    return this.curve.point(null, null);
	
	  // P + Q = O
	  if (this.x.cmp(p.x) === 0)
	    return this.curve.point(null, null);
	
	  var c = this.y.redSub(p.y);
	  if (c.cmpn(0) !== 0)
	    c = c.redMul(this.x.redSub(p.x).redInvm());
	  var nx = c.redSqr().redISub(this.x).redISub(p.x);
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};
	
	Point.prototype.dbl = function dbl() {
	  if (this.inf)
	    return this;
	
	  // 2P = O
	  var ys1 = this.y.redAdd(this.y);
	  if (ys1.cmpn(0) === 0)
	    return this.curve.point(null, null);
	
	  var a = this.curve.a;
	
	  var x2 = this.x.redSqr();
	  var dyinv = ys1.redInvm();
	  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
	
	  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};
	
	Point.prototype.getX = function getX() {
	  return this.x.fromRed();
	};
	
	Point.prototype.getY = function getY() {
	  return this.y.fromRed();
	};
	
	Point.prototype.mul = function mul(k) {
	  k = new BN(k, 16);
	
	  if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else if (this.curve.endo)
	    return this.curve._endoWnafMulAdd([ this ], [ k ]);
	  else
	    return this.curve._wnafMul(this, k);
	};
	
	Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2);
	};
	
	Point.prototype.eq = function eq(p) {
	  return this === p ||
	         this.inf === p.inf &&
	             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
	};
	
	Point.prototype.neg = function neg(_precompute) {
	  if (this.inf)
	    return this;
	
	  var res = this.curve.point(this.x, this.y.redNeg());
	  if (_precompute && this.precomputed) {
	    var pre = this.precomputed;
	    var negate = function(p) {
	      return p.neg();
	    };
	    res.precomputed = {
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(negate)
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(negate)
	      }
	    };
	  }
	  return res;
	};
	
	Point.prototype.toJ = function toJ() {
	  if (this.inf)
	    return this.curve.jpoint(null, null, null);
	
	  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
	  return res;
	};
	
	function JPoint(curve, x, y, z) {
	  Base.BasePoint.call(this, curve, 'jacobian');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.one;
	    this.y = this.curve.one;
	    this.z = new BN(0);
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    this.z = new BN(z, 16);
	  }
	  if (!this.x.red)
	    this.x = this.x.toRed(this.curve.red);
	  if (!this.y.red)
	    this.y = this.y.toRed(this.curve.red);
	  if (!this.z.red)
	    this.z = this.z.toRed(this.curve.red);
	
	  this.zOne = this.z === this.curve.one;
	}
	inherits(JPoint, Base.BasePoint);
	
	ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
	  return new JPoint(this, x, y, z);
	};
	
	JPoint.prototype.toP = function toP() {
	  if (this.isInfinity())
	    return this.curve.point(null, null);
	
	  var zinv = this.z.redInvm();
	  var zinv2 = zinv.redSqr();
	  var ax = this.x.redMul(zinv2);
	  var ay = this.y.redMul(zinv2).redMul(zinv);
	
	  return this.curve.point(ax, ay);
	};
	
	JPoint.prototype.neg = function neg() {
	  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
	};
	
	JPoint.prototype.add = function add(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p;
	
	  // P + O = P
	  if (p.isInfinity())
	    return this;
	
	  // 12M + 4S + 7A
	  var pz2 = p.z.redSqr();
	  var z2 = this.z.redSqr();
	  var u1 = this.x.redMul(pz2);
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y.redMul(pz2.redMul(p.z));
	  var s2 = p.y.redMul(z2.redMul(this.z));
	
	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }
	
	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);
	
	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(p.z).redMul(h);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.mixedAdd = function mixedAdd(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p.toJ();
	
	  // P + O = P
	  if (p.isInfinity())
	    return this;
	
	  // 8M + 3S + 7A
	  var z2 = this.z.redSqr();
	  var u1 = this.x;
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y;
	  var s2 = p.y.redMul(z2).redMul(this.z);
	
	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }
	
	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);
	
	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(h);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.dblp = function dblp(pow) {
	  if (pow === 0)
	    return this;
	  if (this.isInfinity())
	    return this;
	  if (!pow)
	    return this.dbl();
	
	  if (this.curve.zeroA || this.curve.threeA) {
	    var r = this;
	    for (var i = 0; i < pow; i++)
	      r = r.dbl();
	    return r;
	  }
	
	  // 1M + 2S + 1A + N * (4S + 5M + 8A)
	  // N = 1 => 6M + 6S + 9A
	  var a = this.curve.a;
	  var tinv = this.curve.tinv;
	
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();
	
	  // Reuse results
	  var jyd = jy.redAdd(jy);
	  for (var i = 0; i < pow; i++) {
	    var jx2 = jx.redSqr();
	    var jyd2 = jyd.redSqr();
	    var jyd4 = jyd2.redSqr();
	    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
	
	    var t1 = jx.redMul(jyd2);
	    var nx = c.redSqr().redISub(t1.redAdd(t1));
	    var t2 = t1.redISub(nx);
	    var dny = c.redMul(t2);
	    dny = dny.redIAdd(dny).redISub(jyd4);
	    var nz = jyd.redMul(jz);
	    if (i + 1 < pow)
	      jz4 = jz4.redMul(jyd4);
	
	    jx = nx;
	    jz = nz;
	    jyd = dny;
	  }
	
	  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
	};
	
	JPoint.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;
	
	  if (this.curve.zeroA)
	    return this._zeroDbl();
	  else if (this.curve.threeA)
	    return this._threeDbl();
	  else
	    return this._dbl();
	};
	
	JPoint.prototype._zeroDbl = function _zeroDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 14A
	
	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a; a = 0
	    var m = xx.redAdd(xx).redIAdd(xx);
	    // T = M ^ 2 - 2*S
	    var t = m.redSqr().redISub(s).redISub(s);
	
	    // 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2*Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-dbl-2009-l
	    // 2M + 5S + 13A
	
	    // A = X1^2
	    var a = this.x.redSqr();
	    // B = Y1^2
	    var b = this.y.redSqr();
	    // C = B^2
	    var c = b.redSqr();
	    // D = 2 * ((X1 + B)^2 - A - C)
	    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
	    d = d.redIAdd(d);
	    // E = 3 * A
	    var e = a.redAdd(a).redIAdd(a);
	    // F = E^2
	    var f = e.redSqr();
	
	    // 8 * C
	    var c8 = c.redIAdd(c);
	    c8 = c8.redIAdd(c8);
	    c8 = c8.redIAdd(c8);
	
	    // X3 = F - 2 * D
	    nx = f.redISub(d).redISub(d);
	    // Y3 = E * (D - X3) - 8 * C
	    ny = e.redMul(d.redISub(nx)).redISub(c8);
	    // Z3 = 2 * Y1 * Z1
	    nz = this.y.redMul(this.z);
	    nz = nz.redIAdd(nz);
	  }
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype._threeDbl = function _threeDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 15A
	
	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a
	    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
	    // T = M^2 - 2 * S
	    var t = m.redSqr().redISub(s).redISub(s);
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2 * Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
	    // 3M + 5S
	
	    // delta = Z1^2
	    var delta = this.z.redSqr();
	    // gamma = Y1^2
	    var gamma = this.y.redSqr();
	    // beta = X1 * gamma
	    var beta = this.x.redMul(gamma);
	    // alpha = 3 * (X1 - delta) * (X1 + delta)
	    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
	    alpha = alpha.redAdd(alpha).redIAdd(alpha);
	    // X3 = alpha^2 - 8 * beta
	    var beta4 = beta.redIAdd(beta);
	    beta4 = beta4.redIAdd(beta4);
	    var beta8 = beta4.redAdd(beta4);
	    nx = alpha.redSqr().redISub(beta8);
	    // Z3 = (Y1 + Z1)^2 - gamma - delta
	    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
	    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
	    var ggamma8 = gamma.redSqr();
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
	  }
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype._dbl = function _dbl() {
	  var a = this.curve.a;
	
	  // 4M + 6S + 10A
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();
	
	  var jx2 = jx.redSqr();
	  var jy2 = jy.redSqr();
	
	  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
	
	  var jxd4 = jx.redAdd(jx);
	  jxd4 = jxd4.redIAdd(jxd4);
	  var t1 = jxd4.redMul(jy2);
	  var nx = c.redSqr().redISub(t1.redAdd(t1));
	  var t2 = t1.redISub(nx);
	
	  var jyd8 = jy2.redSqr();
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  var ny = c.redMul(t2).redISub(jyd8);
	  var nz = jy.redAdd(jy).redMul(jz);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.trpl = function trpl() {
	  if (!this.curve.zeroA)
	    return this.dbl().add(this);
	
	  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
	  // 5M + 10S + ...
	
	  // XX = X1^2
	  var xx = this.x.redSqr();
	  // YY = Y1^2
	  var yy = this.y.redSqr();
	  // ZZ = Z1^2
	  var zz = this.z.redSqr();
	  // YYYY = YY^2
	  var yyyy = yy.redSqr();
	  // M = 3 * XX + a * ZZ2; a = 0
	  var m = xx.redAdd(xx).redIAdd(xx);
	  // MM = M^2
	  var mm = m.redSqr();
	  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
	  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	  e = e.redIAdd(e);
	  e = e.redAdd(e).redIAdd(e);
	  e = e.redISub(mm);
	  // EE = E^2
	  var ee = e.redSqr();
	  // T = 16*YYYY
	  var t = yyyy.redIAdd(yyyy);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  // U = (M + E)^2 - MM - EE - T
	  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
	  // X3 = 4 * (X1 * EE - 4 * YY * U)
	  var yyu4 = yy.redMul(u);
	  yyu4 = yyu4.redIAdd(yyu4);
	  yyu4 = yyu4.redIAdd(yyu4);
	  var nx = this.x.redMul(ee).redISub(yyu4);
	  nx = nx.redIAdd(nx);
	  nx = nx.redIAdd(nx);
	  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
	  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  // Z3 = (Z1 + E)^2 - ZZ - EE
	  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.mul = function mul(k, kbase) {
	  k = new BN(k, kbase);
	
	  return this.curve._wnafMul(this, k);
	};
	
	JPoint.prototype.eq = function eq(p) {
	  if (p.type === 'affine')
	    return this.eq(p.toJ());
	
	  if (this === p)
	    return true;
	
	  // x1 * z2^2 == x2 * z1^2
	  var z2 = this.z.redSqr();
	  var pz2 = p.z.redSqr();
	  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
	    return false;
	
	  // y1 * z2^3 == y2 * z1^3
	  var z3 = z2.redMul(this.z);
	  var pz3 = pz2.redMul(p.z);
	  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
	};
	
	JPoint.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC JPoint Infinity>';
	  return '<EC JPoint x: ' + this.x.toString(16, 2) +
	      ' y: ' + this.y.toString(16, 2) +
	      ' z: ' + this.z.toString(16, 2) + '>';
	};
	
	JPoint.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};
	


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var curves = exports;
	
	var hash = __webpack_require__(128);
	var elliptic = __webpack_require__(57);
	
	var assert = elliptic.utils.assert;
	
	function PresetCurve(options) {
	  if (options.type === 'short')
	    this.curve = new elliptic.curve.short(options);
	  else if (options.type === 'edwards')
	    this.curve = new elliptic.curve.edwards(options);
	  else
	    this.curve = new elliptic.curve.mont(options);
	  this.g = this.curve.g;
	  this.n = this.curve.n;
	  this.hash = options.hash;
	
	  assert(this.g.validate(), 'Invalid curve');
	  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
	}
	curves.PresetCurve = PresetCurve;
	
	function defineCurve(name, options) {
	  Object.defineProperty(curves, name, {
	    configurable: true,
	    enumerable: true,
	    get: function() {
	      var curve = new PresetCurve(options);
	      Object.defineProperty(curves, name, {
	        configurable: true,
	        enumerable: true,
	        value: curve
	      });
	      return curve;
	    }
	  });
	}
	
	defineCurve('p192', {
	  type: 'short',
	  prime: 'p192',
	  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
	  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
	  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
	    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
	  ]
	});
	
	defineCurve('p224', {
	  type: 'short',
	  prime: 'p224',
	  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
	  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
	  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
	    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
	  ]
	});
	
	defineCurve('p256', {
	  type: 'short',
	  prime: null,
	  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
	  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
	  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
	  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
	    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
	  ]
	});
	
	defineCurve('p384', {
	  type: 'short',
	  prime: null,
	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'fffffffe ffffffff 00000000 00000000 ffffffff',
	  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'fffffffe ffffffff 00000000 00000000 fffffffc',
	  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
	     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
	  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
	     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
	  hash: hash.sha384,
	  gRed: false,
	  g: [
	    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
	    '5502f25d bf55296c 3a545e38 72760ab7',
	    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
	    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
	  ]
	});
	
	defineCurve('p521', {
	  type: 'short',
	  prime: null,
	  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff',
	  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff fffffffc',
	  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
	     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
	     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
	  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
	     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
	  hash: hash.sha512,
	  gRed: false,
	  g: [
	    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
	    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
	    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
	    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
	    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
	    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
	  ]
	});
	
	defineCurve('curve25519', {
	  type: 'mont',
	  prime: 'p25519',
	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	  a: '76d06',
	  b: '0',
	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '9'
	  ]
	});
	
	defineCurve('ed25519', {
	  type: 'edwards',
	  prime: 'p25519',
	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	  a: '-1',
	  c: '1',
	  // -121665 * (121666^(-1)) (mod P)
	  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
	
	    // 4/5
	    '6666666666666666666666666666666666666666666666666666666666666658'
	  ]
	});
	
	var pre;
	try {
	  pre = __webpack_require__(1395);
	} catch (e) {
	  pre = undefined;
	}
	
	defineCurve('secp256k1', {
	  type: 'short',
	  prime: 'k256',
	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
	  a: '0',
	  b: '7',
	  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
	  h: '1',
	  hash: hash.sha256,
	
	  // Precomputed endomorphism
	  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
	  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
	  basis: [
	    {
	      a: '3086d221a7d46bcde86c90e49284eb15',
	      b: '-e4437ed6010e88286f547fa90abfe4c3'
	    },
	    {
	      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
	      b: '3086d221a7d46bcde86c90e49284eb15'
	    }
	  ],
	
	  gRed: false,
	  g: [
	    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
	    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
	    pre
	  ]
	});
	


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var BN = __webpack_require__(39);
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var assert = utils.assert;
	
	var KeyPair = __webpack_require__(1389);
	var Signature = __webpack_require__(1390);
	
	function EC(options) {
	  if (!(this instanceof EC))
	    return new EC(options);
	
	  // Shortcut `elliptic.ec(curve-name)`
	  if (typeof options === 'string') {
	    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);
	
	    options = elliptic.curves[options];
	  }
	
	  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
	  if (options instanceof elliptic.curves.PresetCurve)
	    options = { curve: options };
	
	  this.curve = options.curve.curve;
	  this.n = this.curve.n;
	  this.nh = this.n.ushrn(1);
	  this.g = this.curve.g;
	
	  // Point on curve
	  this.g = options.curve.g;
	  this.g.precompute(options.curve.n.bitLength() + 1);
	
	  // Hash for function for DRBG
	  this.hash = options.hash || options.curve.hash;
	}
	module.e = EC;
	
	EC.prototype.keyPair = function keyPair(options) {
	  return new KeyPair(this, options);
	};
	
	EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
	  return KeyPair.fromPrivate(this, priv, enc);
	};
	
	EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
	  return KeyPair.fromPublic(this, pub, enc);
	};
	
	EC.prototype.genKeyPair = function genKeyPair(options) {
	  if (!options)
	    options = {};
	
	  // Instantiate Hmac_DRBG
	  var drbg = new elliptic.hmacDRBG({
	    hash: this.hash,
	    pers: options.pers,
	    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
	    nonce: this.n.toArray()
	  });
	
	  var bytes = this.n.byteLength();
	  var ns2 = this.n.sub(new BN(2));
	  do {
	    var priv = new BN(drbg.generate(bytes));
	    if (priv.cmp(ns2) > 0)
	      continue;
	
	    priv.iaddn(1);
	    return this.keyFromPrivate(priv);
	  } while (true);
	};
	
	EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
	  var delta = msg.byteLength() * 8 - this.n.bitLength();
	  if (delta > 0)
	    msg = msg.ushrn(delta);
	  if (!truncOnly && msg.cmp(this.n) >= 0)
	    return msg.sub(this.n);
	  else
	    return msg;
	};
	
	EC.prototype.sign = function sign(msg, key, enc, options) {
	  if (typeof enc === 'object') {
	    options = enc;
	    enc = null;
	  }
	  if (!options)
	    options = {};
	
	  key = this.keyFromPrivate(key, enc);
	  msg = this._truncateToN(new BN(msg, 16));
	
	  // Zero-extend key to provide enough entropy
	  var bytes = this.n.byteLength();
	  var bkey = key.getPrivate().toArray('be', bytes);
	
	  // Zero-extend nonce to have the same byte size as N
	  var nonce = msg.toArray('be', bytes);
	
	  // Instantiate Hmac_DRBG
	  var drbg = new elliptic.hmacDRBG({
	    hash: this.hash,
	    entropy: bkey,
	    nonce: nonce,
	    pers: options.pers,
	    persEnc: options.persEnc
	  });
	
	  // Number of bytes to generate
	  var ns1 = this.n.sub(new BN(1));
	
	  for (var iter = 0; true; iter++) {
	    var k = options.k ?
	        options.k(iter) :
	        new BN(drbg.generate(this.n.byteLength()));
	    k = this._truncateToN(k, true);
	    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
	      continue;
	
	    var kp = this.g.mul(k);
	    if (kp.isInfinity())
	      continue;
	
	    var kpX = kp.getX();
	    var r = kpX.umod(this.n);
	    if (r.cmpn(0) === 0)
	      continue;
	
	    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
	    s = s.umod(this.n);
	    if (s.cmpn(0) === 0)
	      continue;
	
	    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
	                        (kpX.cmp(r) !== 0 ? 2 : 0);
	
	    // Use complement of `s`, if it is > `n / 2`
	    if (options.canonical && s.cmp(this.nh) > 0) {
	      s = this.n.sub(s);
	      recoveryParam ^= 1;
	    }
	
	    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
	  }
	};
	
	EC.prototype.verify = function verify(msg, signature, key, enc) {
	  msg = this._truncateToN(new BN(msg, 16));
	  key = this.keyFromPublic(key, enc);
	  signature = new Signature(signature, 'hex');
	
	  // Perform primitive values validation
	  var r = signature.r;
	  var s = signature.s;
	  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
	    return false;
	  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
	    return false;
	
	  // Validate signature
	  var sinv = s.invm(this.n);
	  var u1 = sinv.mul(msg).umod(this.n);
	  var u2 = sinv.mul(r).umod(this.n);
	
	  var p = this.g.mulAdd(u1, key.getPublic(), u2);
	  if (p.isInfinity())
	    return false;
	
	  return p.getX().umod(this.n).cmp(r) === 0;
	};
	
	EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
	  assert((3 & j) === j, 'The recovery param is more than two bits');
	  signature = new Signature(signature, enc);
	
	  var n = this.n;
	  var e = new BN(msg);
	  var r = signature.r;
	  var s = signature.s;
	
	  // A set LSB signifies that the y-coordinate is odd
	  var isYOdd = j & 1;
	  var isSecondKey = j >> 1;
	  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
	    throw new Error('Unable to find sencond key candinate');
	
	  // 1.1. Let x = r + jn.
	  if (isSecondKey)
	    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
	  else
	    r = this.curve.pointFromX(r, isYOdd);
	
	  var eNeg = n.sub(e);
	
	  // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)
	  var rInv = signature.r.invm(n);
	  return this.g.mulAdd(eNeg, r, s).mul(rInv);
	};
	
	EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
	  signature = new Signature(signature, enc);
	  if (signature.recoveryParam !== null)
	    return signature.recoveryParam;
	
	  for (var i = 0; i < 4; i++) {
	    var Qprime;
	    try {
	      Qprime = this.recoverPubKey(e, signature, i);
	    } catch (e) {
	      continue;
	    }
	
	    if (Qprime.eq(Q))
	      return i;
	  }
	  throw new Error('Unable to find valid recovery factor');
	};
	


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var BN = __webpack_require__(39);
	
	function KeyPair(ec, options) {
	  this.ec = ec;
	  this.priv = null;
	  this.pub = null;
	
	  // KeyPair(ec, { priv: ..., pub: ... })
	  if (options.priv)
	    this._importPrivate(options.priv, options.privEnc);
	  if (options.pub)
	    this._importPublic(options.pub, options.pubEnc);
	}
	module.e = KeyPair;
	
	KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
	  if (pub instanceof KeyPair)
	    return pub;
	
	  return new KeyPair(ec, {
	    pub: pub,
	    pubEnc: enc
	  });
	};
	
	KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
	  if (priv instanceof KeyPair)
	    return priv;
	
	  return new KeyPair(ec, {
	    priv: priv,
	    privEnc: enc
	  });
	};
	
	KeyPair.prototype.validate = function validate() {
	  var pub = this.getPublic();
	
	  if (pub.isInfinity())
	    return { result: false, reason: 'Invalid public key' };
	  if (!pub.validate())
	    return { result: false, reason: 'Public key is not a point' };
	  if (!pub.mul(this.ec.curve.n).isInfinity())
	    return { result: false, reason: 'Public key * N != O' };
	
	  return { result: true, reason: null };
	};
	
	KeyPair.prototype.getPublic = function getPublic(compact, enc) {
	  // compact is optional argument
	  if (typeof compact === 'string') {
	    enc = compact;
	    compact = null;
	  }
	
	  if (!this.pub)
	    this.pub = this.ec.g.mul(this.priv);
	
	  if (!enc)
	    return this.pub;
	
	  return this.pub.encode(enc, compact);
	};
	
	KeyPair.prototype.getPrivate = function getPrivate(enc) {
	  if (enc === 'hex')
	    return this.priv.toString(16, 2);
	  else
	    return this.priv;
	};
	
	KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
	  this.priv = new BN(key, enc || 16);
	
	  // Ensure that the priv won't be bigger than n, otherwise we may fail
	  // in fixed multiplication method
	  this.priv = this.priv.umod(this.ec.curve.n);
	};
	
	KeyPair.prototype._importPublic = function _importPublic(key, enc) {
	  if (key.x || key.y) {
	    this.pub = this.ec.curve.point(key.x, key.y);
	    return;
	  }
	  this.pub = this.ec.curve.decodePoint(key, enc);
	};
	
	// ECDH
	KeyPair.prototype.derive = function derive(pub) {
	  return pub.mul(this.priv).getX();
	};
	
	// ECDSA
	KeyPair.prototype.sign = function sign(msg, enc, options) {
	  return this.ec.sign(msg, this, enc, options);
	};
	
	KeyPair.prototype.verify = function verify(msg, signature) {
	  return this.ec.verify(msg, signature, this);
	};
	
	KeyPair.prototype.inspect = function inspect() {
	  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
	         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
	};
	


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var BN = __webpack_require__(39);
	
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var assert = utils.assert;
	
	function Signature(options, enc) {
	  if (options instanceof Signature)
	    return options;
	
	  if (this._importDER(options, enc))
	    return;
	
	  assert(options.r && options.s, 'Signature without r or s');
	  this.r = new BN(options.r, 16);
	  this.s = new BN(options.s, 16);
	  if (options.recoveryParam === undefined)
	    this.recoveryParam = null;
	  else
	    this.recoveryParam = options.recoveryParam;
	}
	module.e = Signature;
	
	function Position() {
	  this.place = 0;
	}
	
	function getLength(buf, p) {
	  var initial = buf[p.place++];
	  if (!(initial & 0x80)) {
	    return initial;
	  }
	  var octetLen = initial & 0xf;
	  var val = 0;
	  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
	    val <<= 8;
	    val |= buf[off];
	  }
	  p.place = off;
	  return val;
	}
	
	function rmPadding(buf) {
	  var i = 0;
	  var len = buf.length - 1;
	  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
	    i++;
	  }
	  if (i === 0) {
	    return buf;
	  }
	  return buf.slice(i);
	}
	
	Signature.prototype._importDER = function _importDER(data, enc) {
	  data = utils.toArray(data, enc);
	  var p = new Position();
	  if (data[p.place++] !== 0x30) {
	    return false;
	  }
	  var len = getLength(data, p);
	  if ((len + p.place) !== data.length) {
	    return false;
	  }
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var rlen = getLength(data, p);
	  var r = data.slice(p.place, rlen + p.place);
	  p.place += rlen;
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var slen = getLength(data, p);
	  if (data.length !== slen + p.place) {
	    return false;
	  }
	  var s = data.slice(p.place, slen + p.place);
	  if (r[0] === 0 && (r[1] & 0x80)) {
	    r = r.slice(1);
	  }
	  if (s[0] === 0 && (s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	
	  this.r = new BN(r);
	  this.s = new BN(s);
	  this.recoveryParam = null;
	
	  return true;
	};
	
	function constructLength(arr, len) {
	  if (len < 0x80) {
	    arr.push(len);
	    return;
	  }
	  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
	  arr.push(octets | 0x80);
	  while (--octets) {
	    arr.push((len >>> (octets << 3)) & 0xff);
	  }
	  arr.push(len);
	}
	
	Signature.prototype.toDER = function toDER(enc) {
	  var r = this.r.toArray();
	  var s = this.s.toArray();
	
	  // Pad values
	  if (r[0] & 0x80)
	    r = [ 0 ].concat(r);
	  // Pad values
	  if (s[0] & 0x80)
	    s = [ 0 ].concat(s);
	
	  r = rmPadding(r);
	  s = rmPadding(s);
	
	  while (!s[0] && !(s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	  var arr = [ 0x02 ];
	  constructLength(arr, r.length);
	  arr = arr.concat(r);
	  arr.push(0x02);
	  constructLength(arr, s.length);
	  var backHalf = arr.concat(s);
	  var res = [ 0x30 ];
	  constructLength(res, backHalf.length);
	  res = res.concat(backHalf);
	  return utils.encode(res, enc);
	};
	


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var hash = __webpack_require__(128);
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var assert = utils.assert;
	var parseBytes = utils.parseBytes;
	var KeyPair = __webpack_require__(1392);
	var Signature = __webpack_require__(1393);
	
	function EDDSA(curve) {
	  assert(curve === 'ed25519', 'only tested with ed25519 so far');
	
	  if (!(this instanceof EDDSA))
	    return new EDDSA(curve);
	
	  var curve = elliptic.curves[curve].curve;
	  this.curve = curve;
	  this.g = curve.g;
	  this.g.precompute(curve.n.bitLength() + 1);
	
	  this.pointClass = curve.point().constructor;
	  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
	  this.hash = hash.sha512;
	}
	
	module.e = EDDSA;
	
	/**
	* @param {Array|String} message - message bytes
	* @param {Array|String|KeyPair} secret - secret bytes or a keypair
	* @returns {Signature} - signature
	*/
	EDDSA.prototype.sign = function sign(message, secret) {
	  message = parseBytes(message);
	  var key = this.keyFromSecret(secret);
	  var r = this.hashInt(key.messagePrefix(), message);
	  var R = this.g.mul(r);
	  var Rencoded = this.encodePoint(R);
	  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
	               .mul(key.priv());
	  var S = r.add(s_).umod(this.curve.n);
	  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
	};
	
	/**
	* @param {Array} message - message bytes
	* @param {Array|String|Signature} sig - sig bytes
	* @param {Array|String|Point|KeyPair} pub - public key
	* @returns {Boolean} - true if public key matches sig of message
	*/
	EDDSA.prototype.verify = function verify(message, sig, pub) {
	  message = parseBytes(message);
	  sig = this.makeSignature(sig);
	  var key = this.keyFromPublic(pub);
	  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
	  var SG = this.g.mul(sig.S());
	  var RplusAh = sig.R().add(key.pub().mul(h));
	  return RplusAh.eq(SG);
	};
	
	EDDSA.prototype.hashInt = function hashInt() {
	  var hash = this.hash();
	  for (var i = 0; i < arguments.length; i++)
	    hash.update(arguments[i]);
	  return utils.intFromLE(hash.digest()).umod(this.curve.n);
	};
	
	EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
	  return KeyPair.fromPublic(this, pub);
	};
	
	EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
	  return KeyPair.fromSecret(this, secret);
	};
	
	EDDSA.prototype.makeSignature = function makeSignature(sig) {
	  if (sig instanceof Signature)
	    return sig;
	  return new Signature(this, sig);
	};
	
	/**
	* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
	*
	* EDDSA defines methods for encoding and decoding points and integers. These are
	* helper convenience methods, that pass along to utility functions implied
	* parameters.
	*
	*/
	EDDSA.prototype.encodePoint = function encodePoint(point) {
	  var enc = point.getY().toArray('le', this.encodingLength);
	  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
	  return enc;
	};
	
	EDDSA.prototype.decodePoint = function decodePoint(bytes) {
	  bytes = utils.parseBytes(bytes);
	
	  var lastIx = bytes.length - 1;
	  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
	  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
	
	  var y = utils.intFromLE(normed);
	  return this.curve.pointFromY(y, xIsOdd);
	};
	
	EDDSA.prototype.encodeInt = function encodeInt(num) {
	  return num.toArray('le', this.encodingLength);
	};
	
	EDDSA.prototype.decodeInt = function decodeInt(bytes) {
	  return utils.intFromLE(bytes);
	};
	
	EDDSA.prototype.isPoint = function isPoint(val) {
	  return val instanceof this.pointClass;
	};
	


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var assert = utils.assert;
	var parseBytes = utils.parseBytes;
	var cachedProperty = utils.cachedProperty;
	
	/**
	* @param {EDDSA} eddsa - instance
	* @param {Object} params - public/private key parameters
	*
	* @param {Array<Byte>} [params.secret] - secret seed bytes
	* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
	* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
	*
	*/
	function KeyPair(eddsa, params) {
	  this.eddsa = eddsa;
	  this._secret = parseBytes(params.secret);
	  if (eddsa.isPoint(params.pub))
	    this._pub = params.pub;
	  else
	    this._pubBytes = parseBytes(params.pub);
	}
	
	KeyPair.fromPublic = function fromPublic(eddsa, pub) {
	  if (pub instanceof KeyPair)
	    return pub;
	  return new KeyPair(eddsa, { pub: pub });
	};
	
	KeyPair.fromSecret = function fromSecret(eddsa, secret) {
	  if (secret instanceof KeyPair)
	    return secret;
	  return new KeyPair(eddsa, { secret: secret });
	};
	
	KeyPair.prototype.secret = function secret() {
	  return this._secret;
	};
	
	cachedProperty(KeyPair, function pubBytes() {
	  return this.eddsa.encodePoint(this.pub());
	});
	
	cachedProperty(KeyPair, function pub() {
	  if (this._pubBytes)
	    return this.eddsa.decodePoint(this._pubBytes);
	  return this.eddsa.g.mul(this.priv());
	});
	
	cachedProperty(KeyPair, function privBytes() {
	  var eddsa = this.eddsa;
	  var hash = this.hash();
	  var lastIx = eddsa.encodingLength - 1;
	
	  var a = hash.slice(0, eddsa.encodingLength);
	  a[0] &= 248;
	  a[lastIx] &= 127;
	  a[lastIx] |= 64;
	
	  return a;
	});
	
	cachedProperty(KeyPair, function priv() {
	  return this.eddsa.decodeInt(this.privBytes());
	});
	
	cachedProperty(KeyPair, function hash() {
	  return this.eddsa.hash().update(this.secret()).digest();
	});
	
	cachedProperty(KeyPair, function messagePrefix() {
	  return this.hash().slice(this.eddsa.encodingLength);
	});
	
	KeyPair.prototype.sign = function sign(message) {
	  assert(this._secret, 'KeyPair can only verify');
	  return this.eddsa.sign(message, this);
	};
	
	KeyPair.prototype.verify = function verify(message, sig) {
	  return this.eddsa.verify(message, sig, this);
	};
	
	KeyPair.prototype.getSecret = function getSecret(enc) {
	  assert(this._secret, 'KeyPair is public only');
	  return utils.encode(this.secret(), enc);
	};
	
	KeyPair.prototype.getPublic = function getPublic(enc) {
	  return utils.encode(this.pubBytes(), enc);
	};
	
	module.e = KeyPair;
	


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var BN = __webpack_require__(39);
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var assert = utils.assert;
	var cachedProperty = utils.cachedProperty;
	var parseBytes = utils.parseBytes;
	
	/**
	* @param {EDDSA} eddsa - eddsa instance
	* @param {Array<Bytes>|Object} sig -
	* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
	* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
	* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
	* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
	*/
	function Signature(eddsa, sig) {
	  this.eddsa = eddsa;
	
	  if (typeof sig !== 'object')
	    sig = parseBytes(sig);
	
	  if (Array.isArray(sig)) {
	    sig = {
	      R: sig.slice(0, eddsa.encodingLength),
	      S: sig.slice(eddsa.encodingLength)
	    };
	  }
	
	  assert(sig.R && sig.S, 'Signature without R or S');
	
	  if (eddsa.isPoint(sig.R))
	    this._R = sig.R;
	  if (sig.S instanceof BN)
	    this._S = sig.S;
	
	  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
	  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
	}
	
	cachedProperty(Signature, function S() {
	  return this.eddsa.decodeInt(this.Sencoded());
	});
	
	cachedProperty(Signature, function R() {
	  return this.eddsa.decodePoint(this.Rencoded());
	});
	
	cachedProperty(Signature, function Rencoded() {
	  return this.eddsa.encodePoint(this.R());
	});
	
	cachedProperty(Signature, function Sencoded() {
	  return this.eddsa.encodeInt(this.S());
	});
	
	Signature.prototype.toBytes = function toBytes() {
	  return this.Rencoded().concat(this.Sencoded());
	};
	
	Signature.prototype.toHex = function toHex() {
	  return utils.encode(this.toBytes(), 'hex').toUpperCase();
	};
	
	module.e = Signature;
	


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var hash = __webpack_require__(128);
	var elliptic = __webpack_require__(57);
	var utils = elliptic.utils;
	var assert = utils.assert;
	
	function HmacDRBG(options) {
	  if (!(this instanceof HmacDRBG))
	    return new HmacDRBG(options);
	  this.hash = options.hash;
	  this.predResist = !!options.predResist;
	
	  this.outLen = this.hash.outSize;
	  this.minEntropy = options.minEntropy || this.hash.hmacStrength;
	
	  this.reseed = null;
	  this.reseedInterval = null;
	  this.K = null;
	  this.V = null;
	
	  var entropy = utils.toArray(options.entropy, options.entropyEnc);
	  var nonce = utils.toArray(options.nonce, options.nonceEnc);
	  var pers = utils.toArray(options.pers, options.persEnc);
	  assert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	  this._init(entropy, nonce, pers);
	}
	module.e = HmacDRBG;
	
	HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
	  var seed = entropy.concat(nonce).concat(pers);
	
	  this.K = new Array(this.outLen / 8);
	  this.V = new Array(this.outLen / 8);
	  for (var i = 0; i < this.V.length; i++) {
	    this.K[i] = 0x00;
	    this.V[i] = 0x01;
	  }
	
	  this._update(seed);
	  this.reseed = 1;
	  this.reseedInterval = 0x1000000000000;  // 2^48
	};
	
	HmacDRBG.prototype._hmac = function hmac() {
	  return new hash.hmac(this.hash, this.K);
	};
	
	HmacDRBG.prototype._update = function update(seed) {
	  var kmac = this._hmac()
	                 .update(this.V)
	                 .update([ 0x00 ]);
	  if (seed)
	    kmac = kmac.update(seed);
	  this.K = kmac.digest();
	  this.V = this._hmac().update(this.V).digest();
	  if (!seed)
	    return;
	
	  this.K = this._hmac()
	               .update(this.V)
	               .update([ 0x01 ])
	               .update(seed)
	               .digest();
	  this.V = this._hmac().update(this.V).digest();
	};
	
	HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
	  // Optional entropy enc
	  if (typeof entropyEnc !== 'string') {
	    addEnc = add;
	    add = entropyEnc;
	    entropyEnc = null;
	  }
	
	  entropy = utils.toBuffer(entropy, entropyEnc);
	  add = utils.toBuffer(add, addEnc);
	
	  assert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	
	  this._update(entropy.concat(add || []));
	  this.reseed = 1;
	};
	
	HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
	  if (this.reseed > this.reseedInterval)
	    throw new Error('Reseed is required');
	
	  // Optional encoding
	  if (typeof enc !== 'string') {
	    addEnc = add;
	    add = enc;
	    enc = null;
	  }
	
	  // Optional additional data
	  if (add) {
	    add = utils.toArray(add, addEnc);
	    this._update(add);
	  }
	
	  var temp = [];
	  while (temp.length < len) {
	    this.V = this._hmac().update(this.V).digest();
	    temp = temp.concat(this.V);
	  }
	
	  var res = temp.slice(0, len);
	  this._update(add);
	  this.reseed++;
	  return utils.encode(res, enc);
	};
	


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = {
	  doubles: {
	    step: 4,
	    points: [
	      [
	        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
	        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
	      ],
	      [
	        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
	        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
	      ],
	      [
	        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
	        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
	      ],
	      [
	        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
	        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
	      ],
	      [
	        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
	        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
	      ],
	      [
	        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
	        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
	      ],
	      [
	        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
	        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
	      ],
	      [
	        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
	        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
	      ],
	      [
	        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
	        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
	      ],
	      [
	        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
	        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
	      ],
	      [
	        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
	        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
	      ],
	      [
	        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
	        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
	      ],
	      [
	        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
	        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
	      ],
	      [
	        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
	        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
	      ],
	      [
	        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
	        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
	      ],
	      [
	        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
	        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
	      ],
	      [
	        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
	        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
	      ],
	      [
	        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
	        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
	      ],
	      [
	        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
	        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
	      ],
	      [
	        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
	        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
	      ],
	      [
	        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
	        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
	      ],
	      [
	        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
	        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
	      ],
	      [
	        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
	        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
	      ],
	      [
	        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
	        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
	      ],
	      [
	        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
	        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
	      ],
	      [
	        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
	        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
	      ],
	      [
	        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
	        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
	      ],
	      [
	        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
	        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
	      ],
	      [
	        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
	        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
	      ],
	      [
	        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
	        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
	      ],
	      [
	        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
	        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
	      ],
	      [
	        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
	        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
	      ],
	      [
	        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
	        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
	      ],
	      [
	        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
	        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
	      ],
	      [
	        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
	        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
	      ],
	      [
	        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
	        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
	      ],
	      [
	        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
	        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
	      ],
	      [
	        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
	        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
	      ],
	      [
	        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
	        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
	      ],
	      [
	        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
	        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
	      ],
	      [
	        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
	        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
	      ],
	      [
	        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
	        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
	      ],
	      [
	        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
	        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
	      ],
	      [
	        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
	        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
	      ],
	      [
	        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
	        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
	      ],
	      [
	        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
	        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
	      ],
	      [
	        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
	        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
	      ],
	      [
	        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
	        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
	      ],
	      [
	        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
	        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
	      ],
	      [
	        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
	        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
	      ],
	      [
	        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
	        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
	      ],
	      [
	        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
	        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
	      ],
	      [
	        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
	        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
	      ],
	      [
	        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
	        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
	      ],
	      [
	        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
	        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
	      ],
	      [
	        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
	        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
	      ],
	      [
	        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
	        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
	      ],
	      [
	        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
	        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
	      ],
	      [
	        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
	        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
	      ],
	      [
	        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
	        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
	      ],
	      [
	        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
	        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
	      ],
	      [
	        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
	        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
	      ],
	      [
	        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
	        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
	      ],
	      [
	        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
	        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
	      ],
	      [
	        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
	        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
	      ]
	    ]
	  },
	  naf: {
	    wnd: 7,
	    points: [
	      [
	        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
	        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
	      ],
	      [
	        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
	        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
	      ],
	      [
	        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
	        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
	      ],
	      [
	        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
	        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
	      ],
	      [
	        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
	        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
	      ],
	      [
	        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
	        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
	      ],
	      [
	        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
	        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
	      ],
	      [
	        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
	        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
	      ],
	      [
	        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
	        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
	      ],
	      [
	        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
	        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
	      ],
	      [
	        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
	        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
	      ],
	      [
	        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
	        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
	      ],
	      [
	        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
	        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
	      ],
	      [
	        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
	        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
	      ],
	      [
	        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
	        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
	      ],
	      [
	        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
	        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
	      ],
	      [
	        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
	        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
	      ],
	      [
	        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
	        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
	      ],
	      [
	        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
	        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
	      ],
	      [
	        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
	        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
	      ],
	      [
	        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
	        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
	      ],
	      [
	        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
	        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
	      ],
	      [
	        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
	        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
	      ],
	      [
	        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
	        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
	      ],
	      [
	        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
	        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
	      ],
	      [
	        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
	        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
	      ],
	      [
	        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
	        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
	      ],
	      [
	        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
	        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
	      ],
	      [
	        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
	        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
	      ],
	      [
	        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
	        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
	      ],
	      [
	        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
	        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
	      ],
	      [
	        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
	        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
	      ],
	      [
	        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
	        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
	      ],
	      [
	        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
	        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
	      ],
	      [
	        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
	        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
	      ],
	      [
	        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
	        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
	      ],
	      [
	        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
	        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
	      ],
	      [
	        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
	        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
	      ],
	      [
	        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
	        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
	      ],
	      [
	        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
	        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
	      ],
	      [
	        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
	        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
	      ],
	      [
	        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
	        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
	      ],
	      [
	        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
	        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
	      ],
	      [
	        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
	        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
	      ],
	      [
	        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
	        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
	      ],
	      [
	        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
	        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
	      ],
	      [
	        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
	        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
	      ],
	      [
	        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
	        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
	      ],
	      [
	        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
	        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
	      ],
	      [
	        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
	        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
	      ],
	      [
	        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
	        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
	      ],
	      [
	        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
	        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
	      ],
	      [
	        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
	        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
	      ],
	      [
	        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
	        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
	      ],
	      [
	        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
	        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
	      ],
	      [
	        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
	        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
	      ],
	      [
	        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
	        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
	      ],
	      [
	        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
	        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
	      ],
	      [
	        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
	        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
	      ],
	      [
	        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
	        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
	      ],
	      [
	        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
	        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
	      ],
	      [
	        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
	        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
	      ],
	      [
	        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
	        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
	      ],
	      [
	        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
	        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
	      ],
	      [
	        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
	        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
	      ],
	      [
	        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
	        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
	      ],
	      [
	        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
	        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
	      ],
	      [
	        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
	        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
	      ],
	      [
	        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
	        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
	      ],
	      [
	        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
	        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
	      ],
	      [
	        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
	        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
	      ],
	      [
	        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
	        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
	      ],
	      [
	        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
	        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
	      ],
	      [
	        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
	        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
	      ],
	      [
	        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
	        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
	      ],
	      [
	        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
	        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
	      ],
	      [
	        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
	        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
	      ],
	      [
	        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
	        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
	      ],
	      [
	        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
	        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
	      ],
	      [
	        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
	        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
	      ],
	      [
	        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
	        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
	      ],
	      [
	        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
	        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
	      ],
	      [
	        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
	        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
	      ],
	      [
	        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
	        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
	      ],
	      [
	        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
	        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
	      ],
	      [
	        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
	        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
	      ],
	      [
	        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
	        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
	      ],
	      [
	        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
	        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
	      ],
	      [
	        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
	        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
	      ],
	      [
	        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
	        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
	      ],
	      [
	        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
	        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
	      ],
	      [
	        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
	        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
	      ],
	      [
	        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
	        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
	      ],
	      [
	        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
	        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
	      ],
	      [
	        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
	        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
	      ],
	      [
	        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
	        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
	      ],
	      [
	        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
	        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
	      ],
	      [
	        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
	        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
	      ],
	      [
	        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
	        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
	      ],
	      [
	        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
	        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
	      ],
	      [
	        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
	        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
	      ],
	      [
	        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
	        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
	      ],
	      [
	        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
	        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
	      ],
	      [
	        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
	        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
	      ],
	      [
	        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
	        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
	      ],
	      [
	        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
	        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
	      ],
	      [
	        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
	        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
	      ],
	      [
	        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
	        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
	      ],
	      [
	        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
	        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
	      ],
	      [
	        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
	        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
	      ],
	      [
	        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
	        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
	      ],
	      [
	        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
	        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
	      ],
	      [
	        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
	        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
	      ],
	      [
	        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
	        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
	      ],
	      [
	        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
	        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
	      ],
	      [
	        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
	        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
	      ],
	      [
	        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
	        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
	      ],
	      [
	        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
	        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
	      ],
	      [
	        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
	        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
	      ],
	      [
	        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
	        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
	      ],
	      [
	        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
	        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
	      ],
	      [
	        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
	        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
	      ],
	      [
	        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
	        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
	      ],
	      [
	        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
	        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
	      ],
	      [
	        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
	        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
	      ],
	      [
	        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
	        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
	      ],
	      [
	        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
	        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
	      ]
	    ]
	  }
	};
	


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var utils = exports;
	var BN = __webpack_require__(39);
	
	utils.assert = function assert(val, msg) {
	  if (!val)
	    throw new Error(msg || 'Assertion failed');
	};
	
	function toArray(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg !== 'string') {
	    for (var i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	    return res;
	  }
	  if (!enc) {
	    for (var i = 0; i < msg.length; i++) {
	      var c = msg.charCodeAt(i);
	      var hi = c >> 8;
	      var lo = c & 0xff;
	      if (hi)
	        res.push(hi, lo);
	      else
	        res.push(lo);
	    }
	  } else if (enc === 'hex') {
	    msg = msg.replace(/[^a-z0-9]+/ig, '');
	    if (msg.length % 2 !== 0)
	      msg = '0' + msg;
	    for (var i = 0; i < msg.length; i += 2)
	      res.push(parseInt(msg[i] + msg[i + 1], 16));
	  }
	  return res;
	}
	utils.toArray = toArray;
	
	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	utils.zero2 = zero2;
	
	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	utils.toHex = toHex;
	
	utils.encode = function encode(arr, enc) {
	  if (enc === 'hex')
	    return toHex(arr);
	  else
	    return arr;
	};
	
	// Represent num in a w-NAF form
	function getNAF(num, w) {
	  var naf = [];
	  var ws = 1 << (w + 1);
	  var k = num.clone();
	  while (k.cmpn(1) >= 0) {
	    var z;
	    if (k.isOdd()) {
	      var mod = k.andln(ws - 1);
	      if (mod > (ws >> 1) - 1)
	        z = (ws >> 1) - mod;
	      else
	        z = mod;
	      k.isubn(z);
	    } else {
	      z = 0;
	    }
	    naf.push(z);
	
	    // Optimization, shift by word if possible
	    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
	    for (var i = 1; i < shift; i++)
	      naf.push(0);
	    k.iushrn(shift);
	  }
	
	  return naf;
	}
	utils.getNAF = getNAF;
	
	// Represent k1, k2 in a Joint Sparse Form
	function getJSF(k1, k2) {
	  var jsf = [
	    [],
	    []
	  ];
	
	  k1 = k1.clone();
	  k2 = k2.clone();
	  var d1 = 0;
	  var d2 = 0;
	  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
	
	    // First phase
	    var m14 = (k1.andln(3) + d1) & 3;
	    var m24 = (k2.andln(3) + d2) & 3;
	    if (m14 === 3)
	      m14 = -1;
	    if (m24 === 3)
	      m24 = -1;
	    var u1;
	    if ((m14 & 1) === 0) {
	      u1 = 0;
	    } else {
	      var m8 = (k1.andln(7) + d1) & 7;
	      if ((m8 === 3 || m8 === 5) && m24 === 2)
	        u1 = -m14;
	      else
	        u1 = m14;
	    }
	    jsf[0].push(u1);
	
	    var u2;
	    if ((m24 & 1) === 0) {
	      u2 = 0;
	    } else {
	      var m8 = (k2.andln(7) + d2) & 7;
	      if ((m8 === 3 || m8 === 5) && m14 === 2)
	        u2 = -m24;
	      else
	        u2 = m24;
	    }
	    jsf[1].push(u2);
	
	    // Second phase
	    if (2 * d1 === u1 + 1)
	      d1 = 1 - d1;
	    if (2 * d2 === u2 + 1)
	      d2 = 1 - d2;
	    k1.iushrn(1);
	    k2.iushrn(1);
	  }
	
	  return jsf;
	}
	utils.getJSF = getJSF;
	
	function cachedProperty(obj, computer) {
	  var name = computer.name;
	  var key = '_' + name;
	  obj.prototype[name] = function cachedProperty() {
	    return this[key] !== undefined ? this[key] :
	           this[key] = computer.call(this);
	  };
	}
	utils.cachedProperty = cachedProperty;
	
	function parseBytes(bytes) {
	  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
	                                     bytes;
	}
	utils.parseBytes = parseBytes;
	
	function intFromLE(bytes) {
	  return new BN(bytes, 'hex', 'le');
	}
	utils.intFromLE = intFromLE;
	
	


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	;(function () {
		'use strict';
	
		/**
		 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
		 *
		 * @codingstandard ftlabs-jsv2
		 * @copyright The Financial Times Limited [All Rights Reserved]
		 * @license MIT License (see LICENSE.txt)
		 */
	
		/*jslint browser:true, node:true*/
		/*global define, Event, Node*/
	
	
		/**
		 * Instantiate fast-clicking listeners on the specified layer.
		 *
		 * @constructor
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		function FastClick(layer, options) {
			var oldOnClick;
	
			options = options || {};
	
			/**
			 * Whether a click is currently being tracked.
			 *
			 * @type boolean
			 */
			this.trackingClick = false;
	
	
			/**
			 * Timestamp for when click tracking started.
			 *
			 * @type number
			 */
			this.trackingClickStart = 0;
	
	
			/**
			 * The element being tracked for a click.
			 *
			 * @type EventTarget
			 */
			this.targetElement = null;
	
	
			/**
			 * X-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartX = 0;
	
	
			/**
			 * Y-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartY = 0;
	
	
			/**
			 * ID of the last touch, retrieved from Touch.identifier.
			 *
			 * @type number
			 */
			this.lastTouchIdentifier = 0;
	
	
			/**
			 * Touchmove boundary, beyond which a click will be cancelled.
			 *
			 * @type number
			 */
			this.touchBoundary = options.touchBoundary || 10;
	
	
			/**
			 * The FastClick layer.
			 *
			 * @type Element
			 */
			this.layer = layer;
	
			/**
			 * The minimum time between tap(touchstart and touchend) events
			 *
			 * @type number
			 */
			this.tapDelay = options.tapDelay || 200;
	
			/**
			 * The maximum time for a tap
			 *
			 * @type number
			 */
			this.tapTimeout = options.tapTimeout || 700;
	
			if (FastClick.notNeeded(layer)) {
				return;
			}
	
			// Some old versions of Android don't have Function.prototype.bind
			function bind(method, context) {
				return function() { return method.apply(context, arguments); };
			}
	
	
			var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
			var context = this;
			for (var i = 0, l = methods.length; i < l; i++) {
				context[methods[i]] = bind(context[methods[i]], context);
			}
	
			// Set up event handlers as required
			if (deviceIsAndroid) {
				layer.addEventListener('mouseover', this.onMouse, true);
				layer.addEventListener('mousedown', this.onMouse, true);
				layer.addEventListener('mouseup', this.onMouse, true);
			}
	
			layer.addEventListener('click', this.onClick, true);
			layer.addEventListener('touchstart', this.onTouchStart, false);
			layer.addEventListener('touchmove', this.onTouchMove, false);
			layer.addEventListener('touchend', this.onTouchEnd, false);
			layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
			// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
			// layer when they are cancelled.
			if (!Event.prototype.stopImmediatePropagation) {
				layer.removeEventListener = function(type, callback, capture) {
					var rmv = Node.prototype.removeEventListener;
					if (type === 'click') {
						rmv.call(layer, type, callback.hijacked || callback, capture);
					} else {
						rmv.call(layer, type, callback, capture);
					}
				};
	
				layer.addEventListener = function(type, callback, capture) {
					var adv = Node.prototype.addEventListener;
					if (type === 'click') {
						adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
					} else {
						adv.call(layer, type, callback, capture);
					}
				};
			}
	
			// If a handler is already declared in the element's onclick attribute, it will be fired before
			// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
			// adding it as listener.
			if (typeof layer.onclick === 'function') {
	
				// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
				// - the old one won't work if passed to addEventListener directly.
				oldOnClick = layer.onclick;
				layer.addEventListener('click', function(event) {
					oldOnClick(event);
				}, false);
				layer.onclick = null;
			}
		}
	
		/**
		* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
		*
		* @type boolean
		*/
		var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
		/**
		 * Android requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS 4 requires an exception for select elements.
		 *
		 * @type boolean
		 */
		var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
		/**
		 * iOS 6.0-7.* requires the target element to be manually derived
		 *
		 * @type boolean
		 */
		var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);
	
		/**
		 * BlackBerry requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
		/**
		 * Determine whether a given element requires a native click.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element needs a native click
		 */
		FastClick.prototype.needsClick = function(target) {
			switch (target.nodeName.toLowerCase()) {
	
			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}
	
				break;
			case 'input':
	
				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if ((deviceIsIOS && target.type === 'file') || target.disabled) {
					return true;
				}
	
				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
			}
	
			return (/\bneedsclick\b/).test(target.className);
		};
	
	
		/**
		 * Determine whether a given element requires a call to focus to simulate click into element.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
		 */
		FastClick.prototype.needsFocus = function(target) {
			switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
				case 'button':
				case 'checkbox':
				case 'file':
				case 'image':
				case 'radio':
				case 'submit':
					return false;
				}
	
				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/).test(target.className);
			}
		};
	
	
		/**
		 * Send a click event to the specified element.
		 *
		 * @param {EventTarget|Element} targetElement
		 * @param {Event} event
		 */
		FastClick.prototype.sendClick = function(targetElement, event) {
			var clickEvent, touch;
	
			// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
			if (document.activeElement && document.activeElement !== targetElement) {
				document.activeElement.blur();
			}
	
			touch = event.changedTouches[0];
	
			// Synthesise a click event, with an extra attribute so it can be tracked
			clickEvent = document.createEvent('MouseEvents');
			clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
			clickEvent.forwardedTouchEvent = true;
			targetElement.dispatchEvent(clickEvent);
		};
	
		FastClick.prototype.determineEventType = function(targetElement) {
	
			//Issue #159: Android Chrome Select Box does not open with a synthetic click event
			if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
				return 'mousedown';
			}
	
			return 'click';
		};
	
	
		/**
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.focus = function(targetElement) {
			var length;
	
			// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
			if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
				length = targetElement.value.length;
				targetElement.setSelectionRange(length, length);
			} else {
				targetElement.focus();
			}
		};
	
	
		/**
		 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
		 *
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.updateScrollParent = function(targetElement) {
			var scrollParent, parentElement;
	
			scrollParent = targetElement.fastClickScrollParent;
	
			// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
			// target element was moved to another parent.
			if (!scrollParent || !scrollParent.contains(targetElement)) {
				parentElement = targetElement;
				do {
					if (parentElement.scrollHeight > parentElement.offsetHeight) {
						scrollParent = parentElement;
						targetElement.fastClickScrollParent = parentElement;
						break;
					}
	
					parentElement = parentElement.parentElement;
				} while (parentElement);
			}
	
			// Always update the scroll top tracker if possible.
			if (scrollParent) {
				scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
			}
		};
	
	
		/**
		 * @param {EventTarget} targetElement
		 * @returns {Element|EventTarget}
		 */
		FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
			// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
			if (eventTarget.nodeType === Node.TEXT_NODE) {
				return eventTarget.parentNode;
			}
	
			return eventTarget;
		};
	
	
		/**
		 * On touch start, record the position and scroll offset.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchStart = function(event) {
			var targetElement, touch, selection;
	
			// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
			if (event.targetTouches.length > 1) {
				return true;
			}
	
			targetElement = this.getTargetElementFromEventTarget(event.target);
			touch = event.targetTouches[0];
	
			if (deviceIsIOS) {
	
				// Only trusted events will deselect text on iOS (issue #49)
				selection = window.getSelection();
				if (selection.rangeCount && !selection.isCollapsed) {
					return true;
				}
	
				if (!deviceIsIOS4) {
	
					// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
					// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
					// with the same identifier as the touch event that previously triggered the click that triggered the alert.
					// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
					// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
					// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
					// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
					// random integers, it's safe to to continue if the identifier is 0 here.
					if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
						event.preventDefault();
						return false;
					}
	
					this.lastTouchIdentifier = touch.identifier;
	
					// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
					// 1) the user does a fling scroll on the scrollable layer
					// 2) the user stops the fling scroll with another tap
					// then the event.target of the last 'touchend' event will be the element that was under the user's finger
					// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
					// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
					this.updateScrollParent(targetElement);
				}
			}
	
			this.trackingClick = true;
			this.trackingClickStart = event.timeStamp;
			this.targetElement = targetElement;
	
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				event.preventDefault();
			}
	
			return true;
		};
	
	
		/**
		 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.touchHasMoved = function(event) {
			var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
			if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Update the last position.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchMove = function(event) {
			if (!this.trackingClick) {
				return true;
			}
	
			// If the touch has moved, cancel the click tracking
			if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
				this.trackingClick = false;
				this.targetElement = null;
			}
	
			return true;
		};
	
	
		/**
		 * Attempt to find the labelled control for the given label element.
		 *
		 * @param {EventTarget|HTMLLabelElement} labelElement
		 * @returns {Element|null}
		 */
		FastClick.prototype.findControl = function(labelElement) {
	
			// Fast path for newer browsers supporting the HTML5 control attribute
			if (labelElement.control !== undefined) {
				return labelElement.control;
			}
	
			// All browsers under test that support touch events also support the HTML5 htmlFor attribute
			if (labelElement.htmlFor) {
				return document.getElementById(labelElement.htmlFor);
			}
	
			// If no for attribute exists, attempt to retrieve the first labellable descendant element
			// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
			return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
		};
	
	
		/**
		 * On touch end, determine whether to send a click event at once.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchEnd = function(event) {
			var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
			if (!this.trackingClick) {
				return true;
			}
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				this.cancelNextClick = true;
				return true;
			}
	
			if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
				return true;
			}
	
			// Reset to prevent wrong click cancel on input (issue #156).
			this.cancelNextClick = false;
	
			this.lastClickTime = event.timeStamp;
	
			trackingClickStart = this.trackingClickStart;
			this.trackingClick = false;
			this.trackingClickStart = 0;
	
			// On some iOS devices, the targetElement supplied with the event is invalid if the layer
			// is performing a transition or scroll, and has to be re-detected manually. Note that
			// for this to function correctly, it must be called *after* the event target is checked!
			// See issue #57; also filed as rdar://13048589 .
			if (deviceIsIOSWithBadTarget) {
				touch = event.changedTouches[0];
	
				// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
				targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
				targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
			}
	
			targetTagName = targetElement.tagName.toLowerCase();
			if (targetTagName === 'label') {
				forElement = this.findControl(targetElement);
				if (forElement) {
					this.focus(targetElement);
					if (deviceIsAndroid) {
						return false;
					}
	
					targetElement = forElement;
				}
			} else if (this.needsFocus(targetElement)) {
	
				// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
				// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
				if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
					this.targetElement = null;
					return false;
				}
	
				this.focus(targetElement);
				this.sendClick(targetElement, event);
	
				// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
				// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
				if (!deviceIsIOS || targetTagName !== 'select') {
					this.targetElement = null;
					event.preventDefault();
				}
	
				return false;
			}
	
			if (deviceIsIOS && !deviceIsIOS4) {
	
				// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
				// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
				scrollParent = targetElement.fastClickScrollParent;
				if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
					return true;
				}
			}
	
			// Prevent the actual click from going though - unless the target node is marked as requiring
			// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
			if (!this.needsClick(targetElement)) {
				event.preventDefault();
				this.sendClick(targetElement, event);
			}
	
			return false;
		};
	
	
		/**
		 * On touch cancel, stop tracking the click.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.onTouchCancel = function() {
			this.trackingClick = false;
			this.targetElement = null;
		};
	
	
		/**
		 * Determine mouse events which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onMouse = function(event) {
	
			// If a target element was never set (because a touch event was never fired) allow the event
			if (!this.targetElement) {
				return true;
			}
	
			if (event.forwardedTouchEvent) {
				return true;
			}
	
			// Programmatically generated events targeting a specific element should be permitted
			if (!event.cancelable) {
				return true;
			}
	
			// Derive and check the target element to see whether the mouse event needs to be permitted;
			// unless explicitly enabled, prevent non-touch click events from triggering actions,
			// to prevent ghost/doubleclicks.
			if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
				// Prevent any user-added listeners declared on FastClick element from being fired.
				if (event.stopImmediatePropagation) {
					event.stopImmediatePropagation();
				} else {
	
					// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
					event.propagationStopped = true;
				}
	
				// Cancel the event
				event.stopPropagation();
				event.preventDefault();
	
				return false;
			}
	
			// If the mouse event is permitted, return true for the action to go through.
			return true;
		};
	
	
		/**
		 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
		 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
		 * an actual click which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onClick = function(event) {
			var permitted;
	
			// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
			if (this.trackingClick) {
				this.targetElement = null;
				this.trackingClick = false;
				return true;
			}
	
			// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
			if (event.target.type === 'submit' && event.detail === 0) {
				return true;
			}
	
			permitted = this.onMouse(event);
	
			// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
			if (!permitted) {
				this.targetElement = null;
			}
	
			// If clicks are permitted, return true for the action to go through.
			return permitted;
		};
	
	
		/**
		 * Remove all FastClick's event listeners.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.destroy = function() {
			var layer = this.layer;
	
			if (deviceIsAndroid) {
				layer.removeEventListener('mouseover', this.onMouse, true);
				layer.removeEventListener('mousedown', this.onMouse, true);
				layer.removeEventListener('mouseup', this.onMouse, true);
			}
	
			layer.removeEventListener('click', this.onClick, true);
			layer.removeEventListener('touchstart', this.onTouchStart, false);
			layer.removeEventListener('touchmove', this.onTouchMove, false);
			layer.removeEventListener('touchend', this.onTouchEnd, false);
			layer.removeEventListener('touchcancel', this.onTouchCancel, false);
		};
	
	
		/**
		 * Check whether FastClick is needed.
		 *
		 * @param {Element} layer The layer to listen on
		 */
		FastClick.notNeeded = function(layer) {
			var metaViewport;
			var chromeVersion;
			var blackberryVersion;
			var firefoxVersion;
	
			// Devices that don't support touch don't need FastClick
			if (typeof window.ontouchstart === 'undefined') {
				return true;
			}
	
			// Chrome version - zero for other browsers
			chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (chromeVersion) {
	
				if (deviceIsAndroid) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// Chrome 32 and above with width=device-width or less don't need FastClick
						if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
	
				// Chrome desktop doesn't need FastClick (issue #15)
				} else {
					return true;
				}
			}
	
			if (deviceIsBlackBerry10) {
				blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
				// BlackBerry 10.3+ does not require Fastclick library.
				// https://github.com/ftlabs/fastclick/issues/251
				if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// user-scalable=no eliminates click delay.
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// width=device-width (or less than device-width) eliminates click delay.
						if (document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
				}
			}
	
			// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
			if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			// Firefox version - zero for other browsers
			firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (firefoxVersion >= 27) {
				// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
				metaViewport = document.querySelector('meta[name=viewport]');
				if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
					return true;
				}
			}
	
			// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
			// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
			if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Factory method for creating a FastClick object
		 *
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		FastClick.attach = function(layer, options) {
			return new FastClick(layer, options);
		};
	
	
		if (true) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return FastClick;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = FastClick.attach;
			module.exports.FastClick = FastClick;
		} else {
			window.FastClick = FastClick;
		}
	}());
	


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.e = invariant;


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.e.Dispatcher = __webpack_require__(1400);
	


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(1398);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.e = Dispatcher;


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var hash = __webpack_require__(128);
	var utils = hash.utils;
	var assert = utils.assert;
	
	function BlockHash() {
	  this.pending = null;
	  this.pendingTotal = 0;
	  this.blockSize = this.constructor.blockSize;
	  this.outSize = this.constructor.outSize;
	  this.hmacStrength = this.constructor.hmacStrength;
	  this.padLength = this.constructor.padLength / 8;
	  this.endian = 'big';
	
	  this._delta8 = this.blockSize / 8;
	  this._delta32 = this.blockSize / 32;
	}
	exports.BlockHash = BlockHash;
	
	BlockHash.prototype.update = function update(msg, enc) {
	  // Convert message to array, pad it, and join into 32bit blocks
	  msg = utils.toArray(msg, enc);
	  if (!this.pending)
	    this.pending = msg;
	  else
	    this.pending = this.pending.concat(msg);
	  this.pendingTotal += msg.length;
	
	  // Enough data, try updating
	  if (this.pending.length >= this._delta8) {
	    msg = this.pending;
	
	    // Process pending data in blocks
	    var r = msg.length % this._delta8;
	    this.pending = msg.slice(msg.length - r, msg.length);
	    if (this.pending.length === 0)
	      this.pending = null;
	
	    msg = utils.join32(msg, 0, msg.length - r, this.endian);
	    for (var i = 0; i < msg.length; i += this._delta32)
	      this._update(msg, i, i + this._delta32);
	  }
	
	  return this;
	};
	
	BlockHash.prototype.digest = function digest(enc) {
	  this.update(this._pad());
	  assert(this.pending === null);
	
	  return this._digest(enc);
	};
	
	BlockHash.prototype._pad = function pad() {
	  var len = this.pendingTotal;
	  var bytes = this._delta8;
	  var k = bytes - ((len + this.padLength) % bytes);
	  var res = new Array(k + this.padLength);
	  res[0] = 0x80;
	  for (var i = 1; i < k; i++)
	    res[i] = 0;
	
	  // Append length
	  len <<= 3;
	  if (this.endian === 'big') {
	    for (var t = 8; t < this.padLength; t++)
	      res[i++] = 0;
	
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = len & 0xff;
	  } else {
	    res[i++] = len & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	
	    for (var t = 8; t < this.padLength; t++)
	      res[i++] = 0;
	  }
	
	  return res;
	};
	


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var hmac = exports;
	
	var hash = __webpack_require__(128);
	var utils = hash.utils;
	var assert = utils.assert;
	
	function Hmac(hash, key, enc) {
	  if (!(this instanceof Hmac))
	    return new Hmac(hash, key, enc);
	  this.Hash = hash;
	  this.blockSize = hash.blockSize / 8;
	  this.outSize = hash.outSize / 8;
	  this.inner = null;
	  this.outer = null;
	
	  this._init(utils.toArray(key, enc));
	}
	module.e = Hmac;
	
	Hmac.prototype._init = function init(key) {
	  // Shorten key, if needed
	  if (key.length > this.blockSize)
	    key = new this.Hash().update(key).digest();
	  assert(key.length <= this.blockSize);
	
	  // Add padding to key
	  for (var i = key.length; i < this.blockSize; i++)
	    key.push(0);
	
	  for (var i = 0; i < key.length; i++)
	    key[i] ^= 0x36;
	  this.inner = new this.Hash().update(key);
	
	  // 0x36 ^ 0x5c = 0x6a
	  for (var i = 0; i < key.length; i++)
	    key[i] ^= 0x6a;
	  this.outer = new this.Hash().update(key);
	};
	
	Hmac.prototype.update = function update(msg, enc) {
	  this.inner.update(msg, enc);
	  return this;
	};
	
	Hmac.prototype.digest = function digest(enc) {
	  this.outer.update(this.inner.digest());
	  return this.outer.digest(enc);
	};
	


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var hash = __webpack_require__(128);
	var utils = hash.utils;
	
	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_3 = utils.sum32_3;
	var sum32_4 = utils.sum32_4;
	var BlockHash = hash.common.BlockHash;
	
	function RIPEMD160() {
	  if (!(this instanceof RIPEMD160))
	    return new RIPEMD160();
	
	  BlockHash.call(this);
	
	  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
	  this.endian = 'little';
	}
	utils.inherits(RIPEMD160, BlockHash);
	exports.ripemd160 = RIPEMD160;
	
	RIPEMD160.blockSize = 512;
	RIPEMD160.outSize = 160;
	RIPEMD160.hmacStrength = 192;
	RIPEMD160.padLength = 64;
	
	RIPEMD160.prototype._update = function update(msg, start) {
	  var A = this.h[0];
	  var B = this.h[1];
	  var C = this.h[2];
	  var D = this.h[3];
	  var E = this.h[4];
	  var Ah = A;
	  var Bh = B;
	  var Ch = C;
	  var Dh = D;
	  var Eh = E;
	  for (var j = 0; j < 80; j++) {
	    var T = sum32(
	      rotl32(
	        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
	        s[j]),
	      E);
	    A = E;
	    E = D;
	    D = rotl32(C, 10);
	    C = B;
	    B = T;
	    T = sum32(
	      rotl32(
	        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
	        sh[j]),
	      Eh);
	    Ah = Eh;
	    Eh = Dh;
	    Dh = rotl32(Ch, 10);
	    Ch = Bh;
	    Bh = T;
	  }
	  T = sum32_3(this.h[1], C, Dh);
	  this.h[1] = sum32_3(this.h[2], D, Eh);
	  this.h[2] = sum32_3(this.h[3], E, Ah);
	  this.h[3] = sum32_3(this.h[4], A, Bh);
	  this.h[4] = sum32_3(this.h[0], B, Ch);
	  this.h[0] = T;
	};
	
	RIPEMD160.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'little');
	  else
	    return utils.split32(this.h, 'little');
	};
	
	function f(j, x, y, z) {
	  if (j <= 15)
	    return x ^ y ^ z;
	  else if (j <= 31)
	    return (x & y) | ((~x) & z);
	  else if (j <= 47)
	    return (x | (~y)) ^ z;
	  else if (j <= 63)
	    return (x & z) | (y & (~z));
	  else
	    return x ^ (y | (~z));
	}
	
	function K(j) {
	  if (j <= 15)
	    return 0x00000000;
	  else if (j <= 31)
	    return 0x5a827999;
	  else if (j <= 47)
	    return 0x6ed9eba1;
	  else if (j <= 63)
	    return 0x8f1bbcdc;
	  else
	    return 0xa953fd4e;
	}
	
	function Kh(j) {
	  if (j <= 15)
	    return 0x50a28be6;
	  else if (j <= 31)
	    return 0x5c4dd124;
	  else if (j <= 47)
	    return 0x6d703ef3;
	  else if (j <= 63)
	    return 0x7a6d76e9;
	  else
	    return 0x00000000;
	}
	
	var r = [
	  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	];
	
	var rh = [
	  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	];
	
	var s = [
	  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	];
	
	var sh = [
	  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	];
	


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var hash = __webpack_require__(128);
	var utils = hash.utils;
	var assert = utils.assert;
	
	var rotr32 = utils.rotr32;
	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_4 = utils.sum32_4;
	var sum32_5 = utils.sum32_5;
	var rotr64_hi = utils.rotr64_hi;
	var rotr64_lo = utils.rotr64_lo;
	var shr64_hi = utils.shr64_hi;
	var shr64_lo = utils.shr64_lo;
	var sum64 = utils.sum64;
	var sum64_hi = utils.sum64_hi;
	var sum64_lo = utils.sum64_lo;
	var sum64_4_hi = utils.sum64_4_hi;
	var sum64_4_lo = utils.sum64_4_lo;
	var sum64_5_hi = utils.sum64_5_hi;
	var sum64_5_lo = utils.sum64_5_lo;
	var BlockHash = hash.common.BlockHash;
	
	var sha256_K = [
	  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
	  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
	  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
	  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
	  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
	  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
	  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
	  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
	  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
	  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
	  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
	  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
	  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
	  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
	  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
	  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
	];
	
	var sha512_K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	];
	
	var sha1_K = [
	  0x5A827999, 0x6ED9EBA1,
	  0x8F1BBCDC, 0xCA62C1D6
	];
	
	function SHA256() {
	  if (!(this instanceof SHA256))
	    return new SHA256();
	
	  BlockHash.call(this);
	  this.h = [ 0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
	             0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19 ];
	  this.k = sha256_K;
	  this.W = new Array(64);
	}
	utils.inherits(SHA256, BlockHash);
	exports.sha256 = SHA256;
	
	SHA256.blockSize = 512;
	SHA256.outSize = 256;
	SHA256.hmacStrength = 192;
	SHA256.padLength = 64;
	
	SHA256.prototype._update = function _update(msg, start) {
	  var W = this.W;
	
	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i++)
	    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
	
	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	  var f = this.h[5];
	  var g = this.h[6];
	  var h = this.h[7];
	
	  assert(this.k.length === W.length);
	  for (var i = 0; i < W.length; i++) {
	    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
	    var T2 = sum32(s0_256(a), maj32(a, b, c));
	    h = g;
	    g = f;
	    f = e;
	    e = sum32(d, T1);
	    d = c;
	    c = b;
	    b = a;
	    a = sum32(T1, T2);
	  }
	
	  this.h[0] = sum32(this.h[0], a);
	  this.h[1] = sum32(this.h[1], b);
	  this.h[2] = sum32(this.h[2], c);
	  this.h[3] = sum32(this.h[3], d);
	  this.h[4] = sum32(this.h[4], e);
	  this.h[5] = sum32(this.h[5], f);
	  this.h[6] = sum32(this.h[6], g);
	  this.h[7] = sum32(this.h[7], h);
	};
	
	SHA256.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};
	
	function SHA224() {
	  if (!(this instanceof SHA224))
	    return new SHA224();
	
	  SHA256.call(this);
	  this.h = [ 0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	             0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
	}
	utils.inherits(SHA224, SHA256);
	exports.sha224 = SHA224;
	
	SHA224.blockSize = 512;
	SHA224.outSize = 224;
	SHA224.hmacStrength = 192;
	SHA224.padLength = 64;
	
	SHA224.prototype._digest = function digest(enc) {
	  // Just truncate output
	  if (enc === 'hex')
	    return utils.toHex32(this.h.slice(0, 7), 'big');
	  else
	    return utils.split32(this.h.slice(0, 7), 'big');
	};
	
	function SHA512() {
	  if (!(this instanceof SHA512))
	    return new SHA512();
	
	  BlockHash.call(this);
	  this.h = [ 0x6a09e667, 0xf3bcc908,
	             0xbb67ae85, 0x84caa73b,
	             0x3c6ef372, 0xfe94f82b,
	             0xa54ff53a, 0x5f1d36f1,
	             0x510e527f, 0xade682d1,
	             0x9b05688c, 0x2b3e6c1f,
	             0x1f83d9ab, 0xfb41bd6b,
	             0x5be0cd19, 0x137e2179 ];
	  this.k = sha512_K;
	  this.W = new Array(160);
	}
	utils.inherits(SHA512, BlockHash);
	exports.sha512 = SHA512;
	
	SHA512.blockSize = 1024;
	SHA512.outSize = 512;
	SHA512.hmacStrength = 192;
	SHA512.padLength = 128;
	
	SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
	  var W = this.W;
	
	  // 32 x 32bit words
	  for (var i = 0; i < 32; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i += 2) {
	    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
	    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
	    var c1_hi = W[i - 14];  // i - 7
	    var c1_lo = W[i - 13];
	    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
	    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
	    var c3_hi = W[i - 32];  // i - 16
	    var c3_lo = W[i - 31];
	
	    W[i] = sum64_4_hi(c0_hi, c0_lo,
	                      c1_hi, c1_lo,
	                      c2_hi, c2_lo,
	                      c3_hi, c3_lo);
	    W[i + 1] = sum64_4_lo(c0_hi, c0_lo,
	                          c1_hi, c1_lo,
	                          c2_hi, c2_lo,
	                          c3_hi, c3_lo);
	  }
	};
	
	SHA512.prototype._update = function _update(msg, start) {
	  this._prepareBlock(msg, start);
	
	  var W = this.W;
	
	  var ah = this.h[0];
	  var al = this.h[1];
	  var bh = this.h[2];
	  var bl = this.h[3];
	  var ch = this.h[4];
	  var cl = this.h[5];
	  var dh = this.h[6];
	  var dl = this.h[7];
	  var eh = this.h[8];
	  var el = this.h[9];
	  var fh = this.h[10];
	  var fl = this.h[11];
	  var gh = this.h[12];
	  var gl = this.h[13];
	  var hh = this.h[14];
	  var hl = this.h[15];
	
	  assert(this.k.length === W.length);
	  for (var i = 0; i < W.length; i += 2) {
	    var c0_hi = hh;
	    var c0_lo = hl;
	    var c1_hi = s1_512_hi(eh, el);
	    var c1_lo = s1_512_lo(eh, el);
	    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
	    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
	    var c3_hi = this.k[i];
	    var c3_lo = this.k[i + 1];
	    var c4_hi = W[i];
	    var c4_lo = W[i + 1];
	
	    var T1_hi = sum64_5_hi(c0_hi, c0_lo,
	                           c1_hi, c1_lo,
	                           c2_hi, c2_lo,
	                           c3_hi, c3_lo,
	                           c4_hi, c4_lo);
	    var T1_lo = sum64_5_lo(c0_hi, c0_lo,
	                           c1_hi, c1_lo,
	                           c2_hi, c2_lo,
	                           c3_hi, c3_lo,
	                           c4_hi, c4_lo);
	
	    var c0_hi = s0_512_hi(ah, al);
	    var c0_lo = s0_512_lo(ah, al);
	    var c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
	    var c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
	
	    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
	    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
	
	    hh = gh;
	    hl = gl;
	
	    gh = fh;
	    gl = fl;
	
	    fh = eh;
	    fl = el;
	
	    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
	    el = sum64_lo(dl, dl, T1_hi, T1_lo);
	
	    dh = ch;
	    dl = cl;
	
	    ch = bh;
	    cl = bl;
	
	    bh = ah;
	    bl = al;
	
	    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
	    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
	  }
	
	  sum64(this.h, 0, ah, al);
	  sum64(this.h, 2, bh, bl);
	  sum64(this.h, 4, ch, cl);
	  sum64(this.h, 6, dh, dl);
	  sum64(this.h, 8, eh, el);
	  sum64(this.h, 10, fh, fl);
	  sum64(this.h, 12, gh, gl);
	  sum64(this.h, 14, hh, hl);
	};
	
	SHA512.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};
	
	function SHA384() {
	  if (!(this instanceof SHA384))
	    return new SHA384();
	
	  SHA512.call(this);
	  this.h = [ 0xcbbb9d5d, 0xc1059ed8,
	             0x629a292a, 0x367cd507,
	             0x9159015a, 0x3070dd17,
	             0x152fecd8, 0xf70e5939,
	             0x67332667, 0xffc00b31,
	             0x8eb44a87, 0x68581511,
	             0xdb0c2e0d, 0x64f98fa7,
	             0x47b5481d, 0xbefa4fa4 ];
	}
	utils.inherits(SHA384, SHA512);
	exports.sha384 = SHA384;
	
	SHA384.blockSize = 1024;
	SHA384.outSize = 384;
	SHA384.hmacStrength = 192;
	SHA384.padLength = 128;
	
	SHA384.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h.slice(0, 12), 'big');
	  else
	    return utils.split32(this.h.slice(0, 12), 'big');
	};
	
	function SHA1() {
	  if (!(this instanceof SHA1))
	    return new SHA1();
	
	  BlockHash.call(this);
	  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe,
	             0x10325476, 0xc3d2e1f0 ];
	  this.W = new Array(80);
	}
	
	utils.inherits(SHA1, BlockHash);
	exports.sha1 = SHA1;
	
	SHA1.blockSize = 512;
	SHA1.outSize = 160;
	SHA1.hmacStrength = 80;
	SHA1.padLength = 64;
	
	SHA1.prototype._update = function _update(msg, start) {
	  var W = this.W;
	
	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];
	
	  for(; i < W.length; i++)
	    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	
	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	
	  for (var i = 0; i < W.length; i++) {
	    var s = ~~(i / 20);
	    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
	    e = d;
	    d = c;
	    c = rotl32(b, 30);
	    b = a;
	    a = t;
	  }
	
	  this.h[0] = sum32(this.h[0], a);
	  this.h[1] = sum32(this.h[1], b);
	  this.h[2] = sum32(this.h[2], c);
	  this.h[3] = sum32(this.h[3], d);
	  this.h[4] = sum32(this.h[4], e);
	};
	
	SHA1.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};
	
	function ch32(x, y, z) {
	  return (x & y) ^ ((~x) & z);
	}
	
	function maj32(x, y, z) {
	  return (x & y) ^ (x & z) ^ (y & z);
	}
	
	function p32(x, y, z) {
	  return x ^ y ^ z;
	}
	
	function s0_256(x) {
	  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
	}
	
	function s1_256(x) {
	  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
	}
	
	function g0_256(x) {
	  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
	}
	
	function g1_256(x) {
	  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
	}
	
	function ft_1(s, x, y, z) {
	  if (s === 0)
	    return ch32(x, y, z);
	  if (s === 1 || s === 3)
	    return p32(x, y, z);
	  if (s === 2)
	    return maj32(x, y, z);
	}
	
	function ch64_hi(xh, xl, yh, yl, zh, zl) {
	  var r = (xh & yh) ^ ((~xh) & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function ch64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ ((~xl) & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function maj64_hi(xh, xl, yh, yl, zh, zl) {
	  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function maj64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 28);
	  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
	  var c2_hi = rotr64_hi(xl, xh, 7);  // 39
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 28);
	  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
	  var c2_lo = rotr64_lo(xl, xh, 7);  // 39
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 14);
	  var c1_hi = rotr64_hi(xh, xl, 18);
	  var c2_hi = rotr64_hi(xl, xh, 9);  // 41
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 14);
	  var c1_lo = rotr64_lo(xh, xl, 18);
	  var c2_lo = rotr64_lo(xl, xh, 9);  // 41
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 1);
	  var c1_hi = rotr64_hi(xh, xl, 8);
	  var c2_hi = shr64_hi(xh, xl, 7);
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 1);
	  var c1_lo = rotr64_lo(xh, xl, 8);
	  var c2_lo = shr64_lo(xh, xl, 7);
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 19);
	  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
	  var c2_hi = shr64_hi(xh, xl, 6);
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 19);
	  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
	  var c2_lo = shr64_lo(xh, xl, 6);
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var utils = exports;
	var inherits = __webpack_require__(27);
	
	function toArray(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg === 'string') {
	    if (!enc) {
	      for (var i = 0; i < msg.length; i++) {
	        var c = msg.charCodeAt(i);
	        var hi = c >> 8;
	        var lo = c & 0xff;
	        if (hi)
	          res.push(hi, lo);
	        else
	          res.push(lo);
	      }
	    } else if (enc === 'hex') {
	      msg = msg.replace(/[^a-z0-9]+/ig, '');
	      if (msg.length % 2 !== 0)
	        msg = '0' + msg;
	      for (var i = 0; i < msg.length; i += 2)
	        res.push(parseInt(msg[i] + msg[i + 1], 16));
	    }
	  } else {
	    for (var i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	  }
	  return res;
	}
	utils.toArray = toArray;
	
	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	utils.toHex = toHex;
	
	function htonl(w) {
	  var res = (w >>> 24) |
	            ((w >>> 8) & 0xff00) |
	            ((w << 8) & 0xff0000) |
	            ((w & 0xff) << 24);
	  return res >>> 0;
	}
	utils.htonl = htonl;
	
	function toHex32(msg, endian) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++) {
	    var w = msg[i];
	    if (endian === 'little')
	      w = htonl(w);
	    res += zero8(w.toString(16));
	  }
	  return res;
	}
	utils.toHex32 = toHex32;
	
	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	utils.zero2 = zero2;
	
	function zero8(word) {
	  if (word.length === 7)
	    return '0' + word;
	  else if (word.length === 6)
	    return '00' + word;
	  else if (word.length === 5)
	    return '000' + word;
	  else if (word.length === 4)
	    return '0000' + word;
	  else if (word.length === 3)
	    return '00000' + word;
	  else if (word.length === 2)
	    return '000000' + word;
	  else if (word.length === 1)
	    return '0000000' + word;
	  else
	    return word;
	}
	utils.zero8 = zero8;
	
	function join32(msg, start, end, endian) {
	  var len = end - start;
	  assert(len % 4 === 0);
	  var res = new Array(len / 4);
	  for (var i = 0, k = start; i < res.length; i++, k += 4) {
	    var w;
	    if (endian === 'big')
	      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
	    else
	      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
	    res[i] = w >>> 0;
	  }
	  return res;
	}
	utils.join32 = join32;
	
	function split32(msg, endian) {
	  var res = new Array(msg.length * 4);
	  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
	    var m = msg[i];
	    if (endian === 'big') {
	      res[k] = m >>> 24;
	      res[k + 1] = (m >>> 16) & 0xff;
	      res[k + 2] = (m >>> 8) & 0xff;
	      res[k + 3] = m & 0xff;
	    } else {
	      res[k + 3] = m >>> 24;
	      res[k + 2] = (m >>> 16) & 0xff;
	      res[k + 1] = (m >>> 8) & 0xff;
	      res[k] = m & 0xff;
	    }
	  }
	  return res;
	}
	utils.split32 = split32;
	
	function rotr32(w, b) {
	  return (w >>> b) | (w << (32 - b));
	}
	utils.rotr32 = rotr32;
	
	function rotl32(w, b) {
	  return (w << b) | (w >>> (32 - b));
	}
	utils.rotl32 = rotl32;
	
	function sum32(a, b) {
	  return (a + b) >>> 0;
	}
	utils.sum32 = sum32;
	
	function sum32_3(a, b, c) {
	  return (a + b + c) >>> 0;
	}
	utils.sum32_3 = sum32_3;
	
	function sum32_4(a, b, c, d) {
	  return (a + b + c + d) >>> 0;
	}
	utils.sum32_4 = sum32_4;
	
	function sum32_5(a, b, c, d, e) {
	  return (a + b + c + d + e) >>> 0;
	}
	utils.sum32_5 = sum32_5;
	
	function assert(cond, msg) {
	  if (!cond)
	    throw new Error(msg || 'Assertion failed');
	}
	utils.assert = assert;
	
	utils.inherits = inherits;
	
	function sum64(buf, pos, ah, al) {
	  var bh = buf[pos];
	  var bl = buf[pos + 1];
	
	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  buf[pos] = hi >>> 0;
	  buf[pos + 1] = lo;
	}
	exports.sum64 = sum64;
	
	function sum64_hi(ah, al, bh, bl) {
	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  return hi >>> 0;
	};
	exports.sum64_hi = sum64_hi;
	
	function sum64_lo(ah, al, bh, bl) {
	  var lo = al + bl;
	  return lo >>> 0;
	};
	exports.sum64_lo = sum64_lo;
	
	function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;
	
	  var hi = ah + bh + ch + dh + carry;
	  return hi >>> 0;
	};
	exports.sum64_4_hi = sum64_4_hi;
	
	function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
	  var lo = al + bl + cl + dl;
	  return lo >>> 0;
	};
	exports.sum64_4_lo = sum64_4_lo;
	
	function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;
	  lo = (lo + el) >>> 0;
	  carry += lo < el ? 1 : 0;
	
	  var hi = ah + bh + ch + dh + eh + carry;
	  return hi >>> 0;
	};
	exports.sum64_5_hi = sum64_5_hi;
	
	function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var lo = al + bl + cl + dl + el;
	
	  return lo >>> 0;
	};
	exports.sum64_5_lo = sum64_5_lo;
	
	function rotr64_hi(ah, al, num) {
	  var r = (al << (32 - num)) | (ah >>> num);
	  return r >>> 0;
	};
	exports.rotr64_hi = rotr64_hi;
	
	function rotr64_lo(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	};
	exports.rotr64_lo = rotr64_lo;
	
	function shr64_hi(ah, al, num) {
	  return ah >>> num;
	};
	exports.shr64_hi = shr64_hi;
	
	function shr64_lo(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	};
	exports.shr64_lo = shr64_lo;
	


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Syntax highlighting with language autodetection.
	https://highlightjs.org/
	*/
	
	(function(factory) {
	
	  // Find the global object for export to both the browser and web workers.
	  var globalObject = typeof window == 'object' && window ||
	                     typeof self == 'object' && self;
	
	  // Setup highlight.js for different environments. First is Node.js or
	  // CommonJS.
	  if(true) {
	    factory(exports);
	  } else if(globalObject) {
	    // Export hljs globally even when using AMD for cases when this script
	    // is loaded with others that may still expect a global hljs.
	    globalObject.hljs = factory({});
	
	    // Finally register the global hljs with AMD.
	    if(typeof define === 'function' && define.amd) {
	      define([], function() {
	        return globalObject.hljs;
	      });
	    }
	  }
	
	}(function(hljs) {
	
	  /* Utility functions */
	
	  function escape(value) {
	    return value.replace(/&/gm, '&amp;').replace(/</gm, '&lt;').replace(/>/gm, '&gt;');
	  }
	
	  function tag(node) {
	    return node.nodeName.toLowerCase();
	  }
	
	  function testRe(re, lexeme) {
	    var match = re && re.exec(lexeme);
	    return match && match.index == 0;
	  }
	
	  function isNotHighlighted(language) {
	    return (/^(no-?highlight|plain|text)$/i).test(language);
	  }
	
	  function blockLanguage(block) {
	    var i, match, length,
	        classes = block.className + ' ';
	
	    classes += block.parentNode ? block.parentNode.className : '';
	
	    // language-* takes precedence over non-prefixed class names.
	    match = (/\blang(?:uage)?-([\w-]+)\b/i).exec(classes);
	    if (match) {
	      return getLanguage(match[1]) ? match[1] : 'no-highlight';
	    }
	
	    classes = classes.split(/\s+/);
	    for (i = 0, length = classes.length; i < length; i++) {
	      if (getLanguage(classes[i]) || isNotHighlighted(classes[i])) {
	        return classes[i];
	      }
	    }
	  }
	
	  function inherit(parent, obj) {
	    var result = {}, key;
	    for (key in parent)
	      result[key] = parent[key];
	    if (obj)
	      for (key in obj)
	        result[key] = obj[key];
	    return result;
	  }
	
	  /* Stream merging */
	
	  function nodeStream(node) {
	    var result = [];
	    (function _nodeStream(node, offset) {
	      for (var child = node.firstChild; child; child = child.nextSibling) {
	        if (child.nodeType == 3)
	          offset += child.nodeValue.length;
	        else if (child.nodeType == 1) {
	          result.push({
	            event: 'start',
	            offset: offset,
	            node: child
	          });
	          offset = _nodeStream(child, offset);
	          // Prevent void elements from having an end tag that would actually
	          // double them in the output. There are more void elements in HTML
	          // but we list only those realistically expected in code display.
	          if (!tag(child).match(/br|hr|img|input/)) {
	            result.push({
	              event: 'stop',
	              offset: offset,
	              node: child
	            });
	          }
	        }
	      }
	      return offset;
	    })(node, 0);
	    return result;
	  }
	
	  function mergeStreams(original, highlighted, value) {
	    var processed = 0;
	    var result = '';
	    var nodeStack = [];
	
	    function selectStream() {
	      if (!original.length || !highlighted.length) {
	        return original.length ? original : highlighted;
	      }
	      if (original[0].offset != highlighted[0].offset) {
	        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
	      }
	
	      /*
	      To avoid starting the stream just before it should stop the order is
	      ensured that original always starts first and closes last:
	
	      if (event1 == 'start' && event2 == 'start')
	        return original;
	      if (event1 == 'start' && event2 == 'stop')
	        return highlighted;
	      if (event1 == 'stop' && event2 == 'start')
	        return original;
	      if (event1 == 'stop' && event2 == 'stop')
	        return highlighted;
	
	      ... which is collapsed to:
	      */
	      return highlighted[0].event == 'start' ? original : highlighted;
	    }
	
	    function open(node) {
	      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value) + '"';}
	      result += '<' + tag(node) + Array.prototype.map.call(node.attributes, attr_str).join('') + '>';
	    }
	
	    function close(node) {
	      result += '</' + tag(node) + '>';
	    }
	
	    function render(event) {
	      (event.event == 'start' ? open : close)(event.node);
	    }
	
	    while (original.length || highlighted.length) {
	      var stream = selectStream();
	      result += escape(value.substr(processed, stream[0].offset - processed));
	      processed = stream[0].offset;
	      if (stream == original) {
	        /*
	        On any opening or closing tag of the original markup we first close
	        the entire highlighted node stack, then render the original tag along
	        with all the following original tags at the same offset and then
	        reopen all the tags on the highlighted stack.
	        */
	        nodeStack.reverse().forEach(close);
	        do {
	          render(stream.splice(0, 1)[0]);
	          stream = selectStream();
	        } while (stream == original && stream.length && stream[0].offset == processed);
	        nodeStack.reverse().forEach(open);
	      } else {
	        if (stream[0].event == 'start') {
	          nodeStack.push(stream[0].node);
	        } else {
	          nodeStack.pop();
	        }
	        render(stream.splice(0, 1)[0]);
	      }
	    }
	    return result + escape(value.substr(processed));
	  }
	
	  /* Initialization */
	
	  function compileLanguage(language) {
	
	    function reStr(re) {
	        return (re && re.source) || re;
	    }
	
	    function langRe(value, global) {
	      return new RegExp(
	        reStr(value),
	        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
	      );
	    }
	
	    function compileMode(mode, parent) {
	      if (mode.compiled)
	        return;
	      mode.compiled = true;
	
	      mode.keywords = mode.keywords || mode.beginKeywords;
	      if (mode.keywords) {
	        var compiled_keywords = {};
	
	        var flatten = function(className, str) {
	          if (language.case_insensitive) {
	            str = str.toLowerCase();
	          }
	          str.split(' ').forEach(function(kw) {
	            var pair = kw.split('|');
	            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
	          });
	        };
	
	        if (typeof mode.keywords == 'string') { // string
	          flatten('keyword', mode.keywords);
	        } else {
	          Object.keys(mode.keywords).forEach(function (className) {
	            flatten(className, mode.keywords[className]);
	          });
	        }
	        mode.keywords = compiled_keywords;
	      }
	      mode.lexemesRe = langRe(mode.lexemes || /\b\w+\b/, true);
	
	      if (parent) {
	        if (mode.beginKeywords) {
	          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
	        }
	        if (!mode.begin)
	          mode.begin = /\B|\b/;
	        mode.beginRe = langRe(mode.begin);
	        if (!mode.end && !mode.endsWithParent)
	          mode.end = /\B|\b/;
	        if (mode.end)
	          mode.endRe = langRe(mode.end);
	        mode.terminator_end = reStr(mode.end) || '';
	        if (mode.endsWithParent && parent.terminator_end)
	          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
	      }
	      if (mode.illegal)
	        mode.illegalRe = langRe(mode.illegal);
	      if (mode.relevance === undefined)
	        mode.relevance = 1;
	      if (!mode.contains) {
	        mode.contains = [];
	      }
	      var expanded_contains = [];
	      mode.contains.forEach(function(c) {
	        if (c.variants) {
	          c.variants.forEach(function(v) {expanded_contains.push(inherit(c, v));});
	        } else {
	          expanded_contains.push(c == 'self' ? mode : c);
	        }
	      });
	      mode.contains = expanded_contains;
	      mode.contains.forEach(function(c) {compileMode(c, mode);});
	
	      if (mode.starts) {
	        compileMode(mode.starts, parent);
	      }
	
	      var terminators =
	        mode.contains.map(function(c) {
	          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
	        })
	        .concat([mode.terminator_end, mode.illegal])
	        .map(reStr)
	        .filter(Boolean);
	      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
	    }
	
	    compileMode(language);
	  }
	
	  /*
	  Core highlighting function. Accepts a language name, or an alias, and a
	  string with the code to highlight. Returns an object with the following
	  properties:
	
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	
	  */
	  function highlight(name, value, ignore_illegals, continuation) {
	
	    function subMode(lexeme, mode) {
	      for (var i = 0; i < mode.contains.length; i++) {
	        if (testRe(mode.contains[i].beginRe, lexeme)) {
	          return mode.contains[i];
	        }
	      }
	    }
	
	    function endOfMode(mode, lexeme) {
	      if (testRe(mode.endRe, lexeme)) {
	        while (mode.endsParent && mode.parent) {
	          mode = mode.parent;
	        }
	        return mode;
	      }
	      if (mode.endsWithParent) {
	        return endOfMode(mode.parent, lexeme);
	      }
	    }
	
	    function isIllegal(lexeme, mode) {
	      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
	    }
	
	    function keywordMatch(mode, match) {
	      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
	      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
	    }
	
	    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
	      var classPrefix = noPrefix ? '' : options.classPrefix,
	          openSpan    = '<span class="' + classPrefix,
	          closeSpan   = leaveOpen ? '' : '</span>';
	
	      openSpan += classname + '">';
	
	      return openSpan + insideSpan + closeSpan;
	    }
	
	    function processKeywords() {
	      if (!top.keywords)
	        return escape(mode_buffer);
	      var result = '';
	      var last_index = 0;
	      top.lexemesRe.lastIndex = 0;
	      var match = top.lexemesRe.exec(mode_buffer);
	      while (match) {
	        result += escape(mode_buffer.substr(last_index, match.index - last_index));
	        var keyword_match = keywordMatch(top, match);
	        if (keyword_match) {
	          relevance += keyword_match[1];
	          result += buildSpan(keyword_match[0], escape(match[0]));
	        } else {
	          result += escape(match[0]);
	        }
	        last_index = top.lexemesRe.lastIndex;
	        match = top.lexemesRe.exec(mode_buffer);
	      }
	      return result + escape(mode_buffer.substr(last_index));
	    }
	
	    function processSubLanguage() {
	      var explicit = typeof top.subLanguage == 'string';
	      if (explicit && !languages[top.subLanguage]) {
	        return escape(mode_buffer);
	      }
	
	      var result = explicit ?
	                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
	                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);
	
	      // Counting embedded language score towards the host language may be disabled
	      // with zeroing the containing mode relevance. Usecase in point is Markdown that
	      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
	      // score.
	      if (top.relevance > 0) {
	        relevance += result.relevance;
	      }
	      if (explicit) {
	        continuations[top.subLanguage] = result.top;
	      }
	      return buildSpan(result.language, result.value, false, true);
	    }
	
	    function processBuffer() {
	      result += (top.subLanguage !== undefined ? processSubLanguage() : processKeywords());
	      mode_buffer = '';
	    }
	
	    function startNewMode(mode, lexeme) {
	      result += mode.className? buildSpan(mode.className, '', true): '';
	      top = Object.create(mode, {parent: {value: top}});
	    }
	
	    function processLexeme(buffer, lexeme) {
	
	      mode_buffer += buffer;
	
	      if (lexeme === undefined) {
	        processBuffer();
	        return 0;
	      }
	
	      var new_mode = subMode(lexeme, top);
	      if (new_mode) {
	        if (new_mode.skip) {
	          mode_buffer += lexeme;
	        } else {
	          if (new_mode.excludeBegin) {
	            mode_buffer += lexeme;
	          }
	          processBuffer();
	          if (!new_mode.returnBegin && !new_mode.excludeBegin) {
	            mode_buffer = lexeme;
	          }
	        }
	        startNewMode(new_mode, lexeme);
	        return new_mode.returnBegin ? 0 : lexeme.length;
	      }
	
	      var end_mode = endOfMode(top, lexeme);
	      if (end_mode) {
	        var origin = top;
	        if (origin.skip) {
	          mode_buffer += lexeme;
	        } else {
	          if (!(origin.returnEnd || origin.excludeEnd)) {
	            mode_buffer += lexeme;
	          }
	          processBuffer();
	          if (origin.excludeEnd) {
	            mode_buffer = lexeme;
	          }
	        }
	        do {
	          if (top.className) {
	            result += '</span>';
	          }
	          if (!top.skip) {
	            relevance += top.relevance;
	          }
	          top = top.parent;
	        } while (top != end_mode.parent);
	        if (end_mode.starts) {
	          startNewMode(end_mode.starts, '');
	        }
	        return origin.returnEnd ? 0 : lexeme.length;
	      }
	
	      if (isIllegal(lexeme, top))
	        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
	
	      /*
	      Parser should not reach this point as all types of lexemes should be caught
	      earlier, but if it does due to some bug make sure it advances at least one
	      character forward to prevent infinite looping.
	      */
	      mode_buffer += lexeme;
	      return lexeme.length || 1;
	    }
	
	    var language = getLanguage(name);
	    if (!language) {
	      throw new Error('Unknown language: "' + name + '"');
	    }
	
	    compileLanguage(language);
	    var top = continuation || language;
	    var continuations = {}; // keep continuations for sub-languages
	    var result = '', current;
	    for(current = top; current != language; current = current.parent) {
	      if (current.className) {
	        result = buildSpan(current.className, '', true) + result;
	      }
	    }
	    var mode_buffer = '';
	    var relevance = 0;
	    try {
	      var match, count, index = 0;
	      while (true) {
	        top.terminators.lastIndex = index;
	        match = top.terminators.exec(value);
	        if (!match)
	          break;
	        count = processLexeme(value.substr(index, match.index - index), match[0]);
	        index = match.index + count;
	      }
	      processLexeme(value.substr(index));
	      for(current = top; current.parent; current = current.parent) { // close dangling modes
	        if (current.className) {
	          result += '</span>';
	        }
	      }
	      return {
	        relevance: relevance,
	        value: result,
	        language: name,
	        top: top
	      };
	    } catch (e) {
	      if (e.message.indexOf('Illegal') != -1) {
	        return {
	          relevance: 0,
	          value: escape(value)
	        };
	      } else {
	        throw e;
	      }
	    }
	  }
	
	  /*
	  Highlighting with language detection. Accepts a string with the code to
	  highlight. Returns an object with the following properties:
	
	  - language (detected language)
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	  - second_best (object with the same structure for second-best heuristically
	    detected language, may be absent)
	
	  */
	  function highlightAuto(text, languageSubset) {
	    languageSubset = languageSubset || options.languages || Object.keys(languages);
	    var result = {
	      relevance: 0,
	      value: escape(text)
	    };
	    var second_best = result;
	    languageSubset.forEach(function(name) {
	      if (!getLanguage(name)) {
	        return;
	      }
	      var current = highlight(name, text, false);
	      current.language = name;
	      if (current.relevance > second_best.relevance) {
	        second_best = current;
	      }
	      if (current.relevance > result.relevance) {
	        second_best = result;
	        result = current;
	      }
	    });
	    if (second_best.language) {
	      result.second_best = second_best;
	    }
	    return result;
	  }
	
	  /*
	  Post-processing of the highlighted markup:
	
	  - replace TABs with something more useful
	  - replace real line-breaks with '<br>' for non-pre containers
	
	  */
	  function fixMarkup(value) {
	    if (options.tabReplace) {
	      value = value.replace(/^((<[^>]+>|\t)+)/gm, function(match, p1 /*..., offset, s*/) {
	        return p1.replace(/\t/g, options.tabReplace);
	      });
	    }
	    if (options.useBR) {
	      value = value.replace(/\n/g, '<br>');
	    }
	    return value;
	  }
	
	  function buildClassName(prevClassName, currentLang, resultLang) {
	    var language = currentLang ? aliases[currentLang] : resultLang,
	        result   = [prevClassName.trim()];
	
	    if (!prevClassName.match(/\bhljs\b/)) {
	      result.push('hljs');
	    }
	
	    if (prevClassName.indexOf(language) === -1) {
	      result.push(language);
	    }
	
	    return result.join(' ').trim();
	  }
	
	  /*
	  Applies highlighting to a DOM node containing code. Accepts a DOM node and
	  two optional parameters for fixMarkup.
	  */
	  function highlightBlock(block) {
	    var language = blockLanguage(block);
	    if (isNotHighlighted(language))
	        return;
	
	    var node;
	    if (options.useBR) {
	      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
	    } else {
	      node = block;
	    }
	    var text = node.textContent;
	    var result = language ? highlight(language, text, true) : highlightAuto(text);
	
	    var originalStream = nodeStream(node);
	    if (originalStream.length) {
	      var resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      resultNode.innerHTML = result.value;
	      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
	    }
	    result.value = fixMarkup(result.value);
	
	    block.innerHTML = result.value;
	    block.className = buildClassName(block.className, language, result.language);
	    block.result = {
	      language: result.language,
	      re: result.relevance
	    };
	    if (result.second_best) {
	      block.second_best = {
	        language: result.second_best.language,
	        re: result.second_best.relevance
	      };
	    }
	  }
	
	  var options = {
	    classPrefix: 'hljs-',
	    tabReplace: null,
	    useBR: false,
	    languages: undefined
	  };
	
	  /*
	  Updates highlight.js global options with values passed in the form of an object.
	  */
	  function configure(user_options) {
	    options = inherit(options, user_options);
	  }
	
	  /*
	  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
	  */
	  function initHighlighting() {
	    if (initHighlighting.called)
	      return;
	    initHighlighting.called = true;
	
	    var blocks = document.querySelectorAll('pre code');
	    Array.prototype.forEach.call(blocks, highlightBlock);
	  }
	
	  /*
	  Attaches highlighting to the page load event.
	  */
	  function initHighlightingOnLoad() {
	    addEventListener('DOMContentLoaded', initHighlighting, false);
	    addEventListener('load', initHighlighting, false);
	  }
	
	  var languages = {};
	  var aliases = {};
	
	  function registerLanguage(name, language) {
	    var lang = languages[name] = language(hljs);
	    if (lang.aliases) {
	      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
	    }
	  }
	
	  function listLanguages() {
	    return Object.keys(languages);
	  }
	
	  function getLanguage(name) {
	    name = (name || '').toLowerCase();
	    return languages[name] || languages[aliases[name]];
	  }
	
	  /* Interface definition */
	
	  hljs.highlight = highlight;
	  hljs.highlightAuto = highlightAuto;
	  hljs.fixMarkup = fixMarkup;
	  hljs.highlightBlock = highlightBlock;
	  hljs.configure = configure;
	  hljs.initHighlighting = initHighlighting;
	  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
	  hljs.registerLanguage = registerLanguage;
	  hljs.listLanguages = listLanguages;
	  hljs.getLanguage = getLanguage;
	  hljs.inherit = inherit;
	
	  // Common regexps
	  hljs.IDENT_RE = '[a-zA-Z]\\w*';
	  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
	  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
	  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
	  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
	  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
	
	  // Common modes
	  hljs.BACKSLASH_ESCAPE = {
	    begin: '\\\\[\\s\\S]', relevance: 0
	  };
	  hljs.APOS_STRING_MODE = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.QUOTE_STRING_MODE = {
	    className: 'string',
	    begin: '"', end: '"',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.PHRASAL_WORDS_MODE = {
	    begin: /\b(a|an|the|are|I|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|like)\b/
	  };
	  hljs.COMMENT = function (begin, end, inherits) {
	    var mode = hljs.inherit(
	      {
	        className: 'comment',
	        begin: begin, end: end,
	        contains: []
	      },
	      inherits || {}
	    );
	    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
	    mode.contains.push({
	      className: 'doctag',
	      begin: "(?:TODO|FIXME|NOTE|BUG|XXX):",
	      relevance: 0
	    });
	    return mode;
	  };
	  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
	  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
	  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
	  hljs.NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE,
	    relevance: 0
	  };
	  hljs.C_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.C_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.BINARY_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.BINARY_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.CSS_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE + '(' +
	      '%|em|ex|ch|rem'  +
	      '|vw|vh|vmin|vmax' +
	      '|cm|mm|in|pt|pc|px' +
	      '|deg|grad|rad|turn' +
	      '|s|ms' +
	      '|Hz|kHz' +
	      '|dpi|dpcm|dppx' +
	      ')?',
	    relevance: 0
	  };
	  hljs.REGEXP_MODE = {
	    className: 'regexp',
	    begin: /\//, end: /\/[gimuy]*/,
	    illegal: /\n/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      {
	        begin: /\[/, end: /\]/,
	        relevance: 0,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  hljs.TITLE_MODE = {
	    className: 'title',
	    begin: hljs.IDENT_RE,
	    relevance: 0
	  };
	  hljs.UNDERSCORE_TITLE_MODE = {
	    className: 'title',
	    begin: hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	  hljs.METHOD_GUARD = {
	    // excludes method names from keyword processing
	    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	
	  return hljs;
	}));
	


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
	  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';
	
	  var AS3_REST_ARG_MODE = {
	    className: 'rest_arg',
	    begin: '[.]{3}', end: IDENT_RE,
	    relevance: 10
	  };
	
	  return {
	    aliases: ['as'],
	    keywords: {
	      keyword: 'as break case catch class const continue default delete do dynamic each ' +
	        'else extends final finally for function get if implements import in include ' +
	        'instanceof interface internal is namespace native new override package private ' +
	        'protected public return set static super switch this throw try typeof use var void ' +
	        'while with',
	      literal: 'true false null undefined'
	    },
	    contains: [
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'package', end: '{',
	        contains: [hljs.TITLE_MODE]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.TITLE_MODE
	        ]
	      },
	      {
	        className: 'meta',
	        beginKeywords: 'import include', end: ';',
	        keywords: {'meta-keyword': 'import include'}
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
	        illegal: '\\S',
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              AS3_REST_ARG_MODE
	            ]
	          },
	          {
	            begin: ':\\s*' + IDENT_FUNC_RETURN_TYPE_RE
	          }
	        ]
	      },
	      hljs.METHOD_GUARD
	    ],
	    illegal: /#/
	  };
	};


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: ''});
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    contains: ['self', hljs.C_NUMBER_MODE, STRING]
	  };
	  var COMMENT_MODE_1 = hljs.COMMENT('--', '$');
	  var COMMENT_MODE_2 = hljs.COMMENT(
	    '\\(\\*',
	    '\\*\\)',
	    {
	      contains: ['self', COMMENT_MODE_1] //allow nesting
	    }
	  );
	  var COMMENTS = [
	    COMMENT_MODE_1,
	    COMMENT_MODE_2,
	    hljs.HASH_COMMENT_MODE
	  ];
	
	  return {
	    aliases: ['osascript'],
	    keywords: {
	      keyword:
	        'about above after against and around as at back before beginning ' +
	        'behind below beneath beside between but by considering ' +
	        'contain contains continue copy div does eighth else end equal ' +
	        'equals error every exit fifth first for fourth from front ' +
	        'get given global if ignoring in into is it its last local me ' +
	        'middle mod my ninth not of on onto or over prop property put ref ' +
	        'reference repeat returning script second set seventh since ' +
	        'sixth some tell tenth that the|0 then third through thru ' +
	        'timeout times to transaction try until where while whose with ' +
	        'without',
	      literal:
	        'AppleScript false linefeed return pi quote result space tab true',
	      built_in:
	        'alias application boolean class constant date file integer list ' +
	        'number real record string text ' +
	        'activate beep count delay launch log offset read round ' +
	        'run say summarize write ' +
	        'character characters contents day frontmost id item length ' +
	        'month name paragraph paragraphs rest reverse running time version ' +
	        'weekday word words year'
	    },
	    contains: [
	      STRING,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'built_in',
	        begin:
	          '\\b(clipboard info|the clipboard|info for|list (disks|folder)|' +
	          'mount volume|path to|(close|open for) access|(get|set) eof|' +
	          'current date|do shell script|get volume settings|random number|' +
	          'set volume|system attribute|system info|time to GMT|' +
	          '(load|run|store) script|scripting components|' +
	          'ASCII (character|number)|localized string|' +
	          'choose (application|color|file|file name|' +
	          'folder|from list|remote application|URL)|' +
	          'display (alert|dialog))\\b|^\\s*return\\b'
	      },
	      {
	        className: 'literal',
	        begin:
	          '\\b(text item delimiters|current application|missing value)\\b'
	      },
	      {
	        className: 'keyword',
	        begin:
	          '\\b(apart from|aside from|instead of|out of|greater than|' +
	          "isn't|(doesn't|does not) (equal|come before|come after|contain)|" +
	          '(greater|less) than( or equal)?|(starts?|ends|begins?) with|' +
	          'contained by|comes (before|after)|a (ref|reference)|POSIX file|' +
	          'POSIX path|(date|time) string|quoted form)\\b'
	      },
	      {
	        beginKeywords: 'on',
	        illegal: '[${=;\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      }
	    ].concat(COMMENTS),
	    illegal: '//|->|=>|\\[\\['
	  };
	};


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d#@][\w\d_]*/},
	      {begin: /\$\{(.*?)}/}
	    ]
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$\(/, end: /\)/,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  var APOS_STRING = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	
	  return {
	    aliases: ['sh', 'zsh'],
	    lexemes: /-?[a-z\.]+/,
	    keywords: {
	      keyword:
	        'if then else elif fi for while in do done case esac function',
	      literal:
	        'true false',
	      built_in:
	        // Shell built-ins
	        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
	        'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' +
	        'trap umask unset ' +
	        // Bash built-ins
	        'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' +
	        'read readarray source type typeset ulimit unalias ' +
	        // Shell modifiers
	        'set shopt ' +
	        // Zsh built-ins
	        'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' +
	        'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' +
	        'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' +
	        'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' +
	        'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' +
	        'zpty zregexparse zsocket zstyle ztcp',
	      _:
	        '-ne -eq -lt -gt -f -d -e -s -l -a' // relevance booster
	    },
	    contains: [
	      {
	        className: 'meta',
	        begin: /^#![^\n]+sh\s*$/,
	        relevance: 10
	      },
	      {
	        className: 'function',
	        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
	        returnBegin: true,
	        contains: [hljs.inherit(hljs.TITLE_MODE, {begin: /\w[\w\d_]*/})],
	        relevance: 0
	      },
	      hljs.HASH_COMMENT_MODE,
	      QUOTE_STRING,
	      APOS_STRING,
	      VAR
	    ]
	  };
	};


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var keywords = {
	    'builtin-name':
	      // Clojure keywords
	      'def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem '+
	      'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? '+
	      'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? '+
	      'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? '+
	      'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . '+
	      'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last '+
	      'drop-while while intern condp case reduced cycle split-at split-with repeat replicate '+
	      'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext '+
	      'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends '+
	      'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler '+
	      'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter '+
	      'monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or '+
	      'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert '+
	      'peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast '+
	      'sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import '+
	      'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! '+
	      'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger '+
	      'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline '+
	      'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking '+
	      'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! '+
	      'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! '+
	      'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty '+
	      'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list '+
	      'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer '+
	      'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate '+
	      'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta '+
	      'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
	   };
	
	  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
	  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
	  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';
	
	  var SYMBOL = {
	    begin: SYMBOL_RE,
	    relevance: 0
	  };
	  var NUMBER = {
	    className: 'number', begin: SIMPLE_NUMBER_RE,
	    relevance: 0
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';',
	    '$',
	    {
	      relevance: 0
	    }
	  );
	  var LITERAL = {
	    className: 'literal',
	    begin: /\b(true|false|nil)\b/
	  };
	  var COLLECTION = {
	    begin: '[\\[\\{]', end: '[\\]\\}]'
	  };
	  var HINT = {
	    className: 'comment',
	    begin: '\\^' + SYMBOL_RE
	  };
	  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
	  var KEY = {
	    className: 'symbol',
	    begin: '[:]' + SYMBOL_RE
	  };
	  var LIST = {
	    begin: '\\(', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  var NAME = {
	    keywords: keywords,
	    lexemes: SYMBOL_RE,
	    className: 'name', begin: SYMBOL_RE,
	    starts: BODY
	  };
	  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];
	
	  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
	  BODY.contains = DEFAULT_CONTAINS;
	  COLLECTION.contains = DEFAULT_CONTAINS;
	
	  return {
	    aliases: ['clj'],
	    illegal: /\S/,
	    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
	  }
	};


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var KEYWORDS = {
	    keyword:
	      // JS keywords
	      'in if for while finally new do return else break catch instanceof throw try this ' +
	      'switch continue typeof delete debugger super ' +
	      // Coffee keywords
	      'then unless until loop of by when and or is isnt not',
	    literal:
	      // JS literals
	      'true false null undefined ' +
	      // Coffee literals
	      'yes no on off',
	    built_in:
	      'npm require console print module global window document'
	  };
	  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
	  var SUBST = {
	    className: 'subst',
	    begin: /#\{/, end: /}/,
	    keywords: KEYWORDS
	  };
	  var EXPRESSIONS = [
	    hljs.BINARY_NUMBER_MODE,
	    hljs.inherit(hljs.C_NUMBER_MODE, {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
	    {
	      className: 'string',
	      variants: [
	        {
	          begin: /'''/, end: /'''/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /'/, end: /'/,
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: /"""/, end: /"""/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        },
	        {
	          begin: /"/, end: /"/,
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	        }
	      ]
	    },
	    {
	      className: 'regexp',
	      variants: [
	        {
	          begin: '///', end: '///',
	          contains: [SUBST, hljs.HASH_COMMENT_MODE]
	        },
	        {
	          begin: '//[gim]*',
	          relevance: 0
	        },
	        {
	          // regex can't start with space to parse x / 2 / 3 as two divisions
	          // regex can't start with *, and it supports an "illegal" in the main mode
	          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
	        }
	      ]
	    },
	    {
	      begin: '@' + JS_IDENT_RE // relevance booster
	    },
	    {
	      begin: '`', end: '`',
	      excludeBegin: true, excludeEnd: true,
	      subLanguage: 'javascript'
	    }
	  ];
	  SUBST.contains = EXPRESSIONS;
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
	  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
	  var PARAMS = {
	    className: 'params',
	    begin: '\\([^\\(]', returnBegin: true,
	    /* We need another contained nameless mode to not have every nested
	    pair of parens to be called "params" */
	    contains: [{
	      begin: /\(/, end: /\)/,
	      keywords: KEYWORDS,
	      contains: ['self'].concat(EXPRESSIONS)
	    }]
	  };
	
	  return {
	    aliases: ['coffee', 'cson', 'iced'],
	    keywords: KEYWORDS,
	    illegal: /\/\*/,
	    contains: EXPRESSIONS.concat([
	      hljs.COMMENT('###', '###'),
	      hljs.HASH_COMMENT_MODE,
	      {
	        className: 'function',
	        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
	        returnBegin: true,
	        contains: [TITLE, PARAMS]
	      },
	      {
	        // anonymous function start
	        begin: /[:\(,=]\s*/,
	        relevance: 0,
	        contains: [
	          {
	            className: 'function',
	            begin: PARAMS_RE, end: '[-=]>',
	            returnBegin: true,
	            contains: [PARAMS]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class',
	        end: '$',
	        illegal: /[:="\[\]]/,
	        contains: [
	          {
	            beginKeywords: 'extends',
	            endsWithParent: true,
	            illegal: /[:="\[\]]/,
	            contains: [TITLE]
	          },
	          TITLE
	        ]
	      },
	      {
	        begin: JS_IDENT_RE + ':', end: ':',
	        returnBegin: true, returnEnd: true,
	        relevance: 0
	      }
	    ])
	  };
	};


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var CPP_PRIMATIVE_TYPES = {
	    className: 'keyword',
	    begin: '\\b[a-z\\d_]*_t\\b'
	  };
	
	  var STRINGS = {
	    className: 'string',
	    variants: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
	      {
	        begin: '(u8?|U)?R"', end: '"',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '\'\\\\?.', end: '\'',
	        illegal: '.'
	      }
	    ]
	  };
	
	  var NUMBERS = {
	    className: 'number',
	    variants: [
	      { begin: '\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)' },
	      { begin: hljs.C_NUMBER_RE }
	    ],
	    relevance: 0
	  };
	
	  var PREPROCESSOR =       {
	    className: 'meta',
	    begin: '#', end: '$',
	    keywords: {'meta-keyword': 'if else elif endif define undef warning error line ' +
	                  'pragma ifdef ifndef'},
	    contains: [
	      {
	        begin: /\\\n/, relevance: 0
	      },
	      {
	        beginKeywords: 'include', end: '$',
	        keywords: {'meta-keyword': 'include'},
	        contains: [
	          hljs.inherit(STRINGS, {className: 'meta-string'}),
	          {
	            className: 'meta-string',
	            begin: '<', end: '>',
	            illegal: '\\n',
	          }
	        ]
	      },
	      STRINGS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE
	    ]
	  };
	
	  var FUNCTION_TITLE = hljs.IDENT_RE + '\\s*\\(';
	
	  var CPP_KEYWORDS = {
	    keyword: 'int float while private char catch export virtual operator sizeof ' +
	      'dynamic_cast|10 typedef const_cast|10 const struct for static_cast|10 union namespace ' +
	      'unsigned long volatile static protected bool template mutable if public friend ' +
	      'do goto auto void enum else break extern using class asm case typeid ' +
	      'short reinterpret_cast|10 default double register explicit signed typename try this ' +
	      'switch continue inline delete alignof constexpr decltype ' +
	      'noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary ' +
	      'atomic_bool atomic_char atomic_schar ' +
	      'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' +
	      'atomic_ullong',
	    built_in: 'std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' +
	      'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' +
	      'unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos ' +
	      'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' +
	      'fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' +
	      'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' +
	      'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' +
	      'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' +
	      'vfprintf vprintf vsprintf endl initializer_list unique_ptr',
	    literal: 'true false nullptr NULL'
	  };
	
	  return {
	    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp'],
	    keywords: CPP_KEYWORDS,
	    illegal: '</',
	    contains: [
	      CPP_PRIMATIVE_TYPES,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBERS,
	      STRINGS,
	      PREPROCESSOR,
	      {
	        begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<', end: '>',
	        keywords: CPP_KEYWORDS,
	        contains: ['self', CPP_PRIMATIVE_TYPES]
	      },
	      {
	        begin: hljs.IDENT_RE + '::',
	        keywords: CPP_KEYWORDS
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...) or else if(...)' from
	        // being recognized as a function definition
	        beginKeywords: 'new throw return else',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + hljs.IDENT_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
	        returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: CPP_KEYWORDS,
	        illegal: /[^\w\s\*&]/,
	        contains: [
	          {
	            begin: FUNCTION_TITLE, returnBegin: true,
	            contains: [hljs.TITLE_MODE],
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: CPP_KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRINGS,
	              NUMBERS
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          PREPROCESSOR
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var KEYWORDS =
	    // Normal keywords.
	    'abstract as base bool break byte case catch char checked const continue decimal dynamic ' +
	    'default delegate do double else enum event explicit extern false finally fixed float ' +
	    'for foreach goto if implicit in int interface internal is lock long null when ' +
	    'object operator out override params private protected public readonly ref sbyte ' +
	    'sealed short sizeof stackalloc static string struct switch this true try typeof ' +
	    'uint ulong unchecked unsafe ushort using virtual volatile void while async ' +
	    'protected public private internal ' +
	    // Contextual keywords.
	    'ascending descending from get group into join let orderby partial select set value var ' +
	    'where yield';
	  var GENERIC_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '>)?';
	  return {
	    aliases: ['csharp'],
	    keywords: KEYWORDS,
	    illegal: /::/,
	    contains: [
	      hljs.COMMENT(
	        '///',
	        '$',
	        {
	          returnBegin: true,
	          contains: [
	            {
	              className: 'doctag',
	              variants: [
	                {
	                  begin: '///', relevance: 0
	                },
	                {
	                  begin: '<!--|-->'
	                },
	                {
	                  begin: '</?', end: '>'
	                }
	              ]
	            }
	          ]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$',
	        keywords: {'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'}
	      },
	      {
	        className: 'string',
	        begin: '@"', end: '"',
	        contains: [{begin: '""'}]
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        beginKeywords: 'class interface', end: /[{;=]/,
	        illegal: /[^\s:]/,
	        contains: [
	          hljs.TITLE_MODE,
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: /[{;=]/,
	        illegal: /[^\s:]/,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '[a-zA-Z](\\.?\\w)*'}),
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...)' from being
	        // recognized as a function definition
	        beginKeywords: 'new return throw await',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
	            contains: [hljs.TITLE_MODE],
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
	  var RULE = {
	    begin: /[A-Z\_\.\-]+\s*:/, returnBegin: true, end: ';', endsWithParent: true,
	    contains: [
	      {
	        className: 'attribute',
	        begin: /\S/, end: ':', excludeEnd: true,
	        starts: {
	          endsWithParent: true, excludeEnd: true,
	          contains: [
	            {
	              begin: /[\w-]+\(/, returnBegin: true,
	              contains: [
	                {
	                  className: 'built_in',
	                  begin: /[\w-]+/
	                },
	                {
	                  begin: /\(/, end: /\)/,
	                  contains: [
	                    hljs.APOS_STRING_MODE,
	                    hljs.QUOTE_STRING_MODE
	                  ]
	                }
	              ]
	            },
	            hljs.CSS_NUMBER_MODE,
	            hljs.QUOTE_STRING_MODE,
	            hljs.APOS_STRING_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            {
	              className: 'number', begin: '#[0-9A-Fa-f]+'
	            },
	            {
	              className: 'meta', begin: '!important'
	            }
	          ]
	        }
	      }
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    illegal: /[=\/|'\$]/,
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'selector-id', begin: /#[A-Za-z0-9_-]+/
	      },
	      {
	        className: 'selector-class', begin: /\.[A-Za-z0-9_-]+/
	      },
	      {
	        className: 'selector-attr',
	        begin: /\[/, end: /\]/,
	        illegal: '$'
	      },
	      {
	        className: 'selector-pseudo',
	        begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
	      },
	      {
	        begin: '@(font-face|page)',
	        lexemes: '[a-z-]+',
	        keywords: 'font-face page'
	      },
	      {
	        begin: '@', end: '[{;]', // at_rule eating first "{" is a good thing
	                                 // because it doesn’t let it to be parsed as
	                                 // a rule set but instead drops parser into
	                                 // the default mode which is how it should be.
	        contains: [
	          {
	            className: 'keyword',
	            begin: /\S+/
	          },
	          {
	            begin: /\s/, endsWithParent: true, excludeEnd: true,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE,
	              hljs.CSS_NUMBER_MODE
	            ]
	          }
	        ]
	      },
	      {
	        className: 'selector-tag', begin: IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '{', end: '}',
	        illegal: /\S/,
	        contains: [
	          hljs.C_BLOCK_COMMENT_MODE,
	          RULE,
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = /**
	 * Known issues:
	 *
	 * - invalid hex string literals will be recognized as a double quoted strings
	 *   but 'x' at the beginning of string will not be matched
	 *
	 * - delimited string literals are not checked for matching end delimiter
	 *   (not possible to do with js regexp)
	 *
	 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
	 *   also, content of token string is not validated to contain only valid D tokens
	 *
	 * - special token sequence rule is not strictly following D grammar (anything following #line
	 *   up to the end of line is matched as special token sequence)
	 */
	
	function(hljs) {
	  /**
	   * Language keywords
	   *
	   * @type {Object}
	   */
	  var D_KEYWORDS = {
	    keyword:
	      'abstract alias align asm assert auto body break byte case cast catch class ' +
	      'const continue debug default delete deprecated do else enum export extern final ' +
	      'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' +
	      'interface invariant is lazy macro mixin module new nothrow out override package ' +
	      'pragma private protected public pure ref return scope shared static struct ' +
	      'super switch synchronized template this throw try typedef typeid typeof union ' +
	      'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' +
	      '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
	    built_in:
	      'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' +
	      'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' +
	      'wstring',
	    literal:
	      'false null true'
	  };
	
	  /**
	   * Number literal regexps
	   *
	   * @type {String}
	   */
	  var decimal_integer_re = '(0|[1-9][\\d_]*)',
	    decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)',
	    binary_integer_re = '0[bB][01_]+',
	    hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)',
	    hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re,
	
	    decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')',
	    decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' +
	                '\\d+\\.' + decimal_integer_nosus_re + decimal_integer_nosus_re + '|' +
	                '\\.' + decimal_integer_re + decimal_exponent_re + '?' +
	              ')',
	    hexadecimal_float_re = '(0[xX](' +
	                  hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|'+
	                  '\\.?' + hexadecimal_digits_re +
	                 ')[pP][+-]?' + decimal_integer_nosus_re + ')',
	
	    integer_re = '(' +
	      decimal_integer_re + '|' +
	      binary_integer_re  + '|' +
	       hexadecimal_integer_re   +
	    ')',
	
	    float_re = '(' +
	      hexadecimal_float_re + '|' +
	      decimal_float_re  +
	    ')';
	
	  /**
	   * Escape sequence supported in D string and character literals
	   *
	   * @type {String}
	   */
	  var escape_sequence_re = '\\\\(' +
	              '[\'"\\?\\\\abfnrtv]|' +  // common escapes
	              'u[\\dA-Fa-f]{4}|' +     // four hex digit unicode codepoint
	              '[0-7]{1,3}|' +       // one to three octal digit ascii char code
	              'x[\\dA-Fa-f]{2}|' +    // two hex digit ascii char code
	              'U[\\dA-Fa-f]{8}' +      // eight hex digit unicode codepoint
	              ')|' +
	              '&[a-zA-Z\\d]{2,};';      // named character entity
	
	  /**
	   * D integer number literals
	   *
	   * @type {Object}
	   */
	  var D_INTEGER_MODE = {
	    className: 'number',
	      begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
	      relevance: 0
	  };
	
	  /**
	   * [D_FLOAT_MODE description]
	   * @type {Object}
	   */
	  var D_FLOAT_MODE = {
	    className: 'number',
	    begin: '\\b(' +
	        float_re + '([fF]|L|i|[fF]i|Li)?|' +
	        integer_re + '(i|[fF]i|Li)' +
	      ')',
	    relevance: 0
	  };
	
	  /**
	   * D character literal
	   *
	   * @type {Object}
	   */
	  var D_CHARACTER_MODE = {
	    className: 'string',
	    begin: '\'(' + escape_sequence_re + '|.)', end: '\'',
	    illegal: '.'
	  };
	
	  /**
	   * D string escape sequence
	   *
	   * @type {Object}
	   */
	  var D_ESCAPE_SEQUENCE = {
	    begin: escape_sequence_re,
	    relevance: 0
	  };
	
	  /**
	   * D double quoted string literal
	   *
	   * @type {Object}
	   */
	  var D_STRING_MODE = {
	    className: 'string',
	    begin: '"',
	    contains: [D_ESCAPE_SEQUENCE],
	    end: '"[cwd]?'
	  };
	
	  /**
	   * D wysiwyg and delimited string literals
	   *
	   * @type {Object}
	   */
	  var D_WYSIWYG_DELIMITED_STRING_MODE = {
	    className: 'string',
	    begin: '[rq]"',
	    end: '"[cwd]?',
	    relevance: 5
	  };
	
	  /**
	   * D alternate wysiwyg string literal
	   *
	   * @type {Object}
	   */
	  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
	    className: 'string',
	    begin: '`',
	    end: '`[cwd]?'
	  };
	
	  /**
	   * D hexadecimal string literal
	   *
	   * @type {Object}
	   */
	  var D_HEX_STRING_MODE = {
	    className: 'string',
	    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
	    relevance: 10
	  };
	
	  /**
	   * D delimited string literal
	   *
	   * @type {Object}
	   */
	  var D_TOKEN_STRING_MODE = {
	    className: 'string',
	    begin: 'q"\\{',
	    end: '\\}"'
	  };
	
	  /**
	   * Hashbang support
	   *
	   * @type {Object}
	   */
	  var D_HASHBANG_MODE = {
	    className: 'meta',
	    begin: '^#!',
	    end: '$',
	    relevance: 5
	  };
	
	  /**
	   * D special token sequence
	   *
	   * @type {Object}
	   */
	  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
	    className: 'meta',
	    begin: '#(line)',
	    end: '$',
	    relevance: 5
	  };
	
	  /**
	   * D attributes
	   *
	   * @type {Object}
	   */
	  var D_ATTRIBUTE_MODE = {
	    className: 'keyword',
	    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
	  };
	
	  /**
	   * D nesting comment
	   *
	   * @type {Object}
	   */
	  var D_NESTING_COMMENT_MODE = hljs.COMMENT(
	    '\\/\\+',
	    '\\+\\/',
	    {
	      contains: ['self'],
	      relevance: 10
	    }
	  );
	
	  return {
	    lexemes: hljs.UNDERSCORE_IDENT_RE,
	    keywords: D_KEYWORDS,
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        D_NESTING_COMMENT_MODE,
	        D_HEX_STRING_MODE,
	        D_STRING_MODE,
	        D_WYSIWYG_DELIMITED_STRING_MODE,
	        D_ALTERNATE_WYSIWYG_STRING_MODE,
	        D_TOKEN_STRING_MODE,
	        D_FLOAT_MODE,
	        D_INTEGER_MODE,
	        D_CHARACTER_MODE,
	        D_HASHBANG_MODE,
	        D_SPECIAL_TOKEN_SEQUENCE_MODE,
	        D_ATTRIBUTE_MODE
	    ]
	  };
	};


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function (hljs) {
	  var SUBST = {
	    className: 'subst',
	    begin: '\\$\\{', end: '}',
	    keywords: 'true false null this is new super'
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {
	        begin: 'r\'\'\'', end: '\'\'\''
	      },
	      {
	        begin: 'r"""', end: '"""'
	      },
	      {
	        begin: 'r\'', end: '\'',
	        illegal: '\\n'
	      },
	      {
	        begin: 'r"', end: '"',
	        illegal: '\\n'
	      },
	      {
	        begin: '\'\'\'', end: '\'\'\'',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '"""', end: '"""',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '\'', end: '\'',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        begin: '"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      }
	    ]
	  };
	  SUBST.contains = [
	    hljs.C_NUMBER_MODE, STRING
	  ];
	
	  var KEYWORDS = {
	    keyword: 'assert async await break case catch class const continue default do else enum extends false final ' +
	      'finally for if in is new null rethrow return super switch sync this throw true try var void while with yield ' +
	      'abstract as dynamic export external factory get implements import library operator part set static typedef',
	    built_in:
	      // dart:core
	      'print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set ' +
	      'Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num ' +
	      // dart:html
	      'document window querySelector querySelectorAll Element ElementList'
	  };
	
	  return {
	    keywords: KEYWORDS,
	    contains: [
	      STRING,
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          subLanguage: 'markdown'
	        }
	      ),
	      hljs.COMMENT(
	        '///',
	        '$',
	        {
	          subLanguage: 'markdown'
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta', begin: '@[A-Za-z]+'
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      }
	    ]
	  }
	};


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var KEYWORDS =
	    'exports register file shl array record property for mod while set ally label uses raise not ' +
	    'stored class safecall var interface or private static exit index inherited to else stdcall ' +
	    'override shr asm far resourcestring finalization packed virtual out and protected library do ' +
	    'xorwrite goto near function end div overload object unit begin string on inline repeat until ' +
	    'destructor write message program with read initialization except default nil if case cdecl in ' +
	    'downto threadvar of try pascal const external constructor type public then implementation ' +
	    'finally published procedure';
	  var COMMENT_MODES = [
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.COMMENT(
	      /\{/,
	      /\}/,
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT(
	      /\(\*/,
	      /\*\)/,
	      {
	        relevance: 10
	      }
	    )
	  ];
	  var STRING = {
	    className: 'string',
	    begin: /'/, end: /'/,
	    contains: [{begin: /''/}]
	  };
	  var CHAR_STRING = {
	    className: 'string', begin: /(#\d+)+/
	  };
	  var CLASS = {
	    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(', returnBegin: true,
	    contains: [
	      hljs.TITLE_MODE
	    ]
	  };
	  var FUNCTION = {
	    className: 'function',
	    beginKeywords: 'function constructor destructor procedure', end: /[:;]/,
	    keywords: 'function constructor|10 destructor|10 procedure|10',
	    contains: [
	      hljs.TITLE_MODE,
	      {
	        className: 'params',
	        begin: /\(/, end: /\)/,
	        keywords: KEYWORDS,
	        contains: [STRING, CHAR_STRING]
	      }
	    ].concat(COMMENT_MODES)
	  };
	  return {
	    aliases: ['dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'],
	    case_insensitive: true,
	    keywords: KEYWORDS,
	    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
	    contains: [
	      STRING, CHAR_STRING,
	      hljs.NUMBER_MODE,
	      CLASS,
	      FUNCTION
	    ].concat(COMMENT_MODES)
	  };
	};


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['patch'],
	    contains: [
	      {
	        className: 'meta',
	        relevance: 10,
	        variants: [
	          {begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},
	          {begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/},
	          {begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/}
	        ]
	      },
	      {
	        className: 'comment',
	        variants: [
	          {begin: /Index: /, end: /$/},
	          {begin: /=====/, end: /=====$/},
	          {begin: /^\-\-\-/, end: /$/},
	          {begin: /^\*{3} /, end: /$/},
	          {begin: /^\+\+\+/, end: /$/},
	          {begin: /\*{5}/, end: /\*{5}$/}
	        ]
	      },
	      {
	        className: 'addition',
	        begin: '^\\+', end: '$'
	      },
	      {
	        className: 'deletion',
	        begin: '^\\-', end: '$'
	      },
	      {
	        className: 'addition',
	        begin: '^\\!', end: '$'
	      }
	    ]
	  };
	};


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var FILTER = {
	    begin: /\|[A-Za-z]+:?/,
	    keywords: {
	      name:
	        'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' +
	        'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' +
	        'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' +
	        'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' +
	        'dictsortreversed default_if_none pluralize lower join center default ' +
	        'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' +
	        'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' +
	        'localtime utc timezone'
	    },
	    contains: [
	      hljs.QUOTE_STRING_MODE,
	      hljs.APOS_STRING_MODE
	    ]
	  };
	
	  return {
	    aliases: ['jinja'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	      hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
	      hljs.COMMENT(/\{#/, /#}/),
	      {
	        className: 'template-tag',
	        begin: /\{%/, end: /%}/,
	        contains: [
	          {
	            className: 'name',
	            begin: /\w+/,
	            keywords: {
	              name:
	                'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' +
	                'endfor ifnotequal endifnotequal widthratio extends include spaceless ' +
	                'endspaceless regroup ifequal endifequal ssi now with cycle url filter ' +
	                'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' +
	                'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' +
	                'plural get_current_language language get_available_languages ' +
	                'get_current_language_bidi get_language_info get_language_info_list localize ' +
	                'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' +
	                'verbatim'
	            },
	            starts: {
	              endsWithParent: true,
	              keywords: 'in by as',
	              contains: [FILTER],
	              relevance: 0
	            }
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{\{/, end: /}}/,
	        contains: [FILTER]
	      }
	    ]
	  };
	};


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['docker'],
	    case_insensitive: true,
	    keywords: 'from maintainer cmd expose add copy entrypoint volume user workdir onbuild run env label',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        keywords: 'run cmd entrypoint volume add copy workdir onbuild label',
	        begin: /^ *(onbuild +)?(run|cmd|entrypoint|volume|add|copy|workdir|label) +/,
	        starts: {
	          end: /[^\\]\n/,
	          subLanguage: 'bash'
	        }
	      },
	      {
	        keywords: 'from maintainer expose env user onbuild',
	        begin: /^ *(onbuild +)?(from|maintainer|expose|env|user|onbuild) +/, end: /[^\\]\n/,
	        contains: [
	          hljs.APOS_STRING_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.NUMBER_MODE,
	          hljs.HASH_COMMENT_MODE
	        ]
	      }
	    ]
	  }
	};


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
	  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
	  var ERLANG_RESERVED = {
	    keyword:
	      'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' +
	      'let not of orelse|10 query receive rem try when xor',
	    literal:
	      'false true'
	  };
	
	  var COMMENT = hljs.COMMENT('%', '$');
	  var NUMBER = {
	    className: 'number',
	    begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
	    relevance: 0
	  };
	  var NAMED_FUN = {
	    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
	  };
	  var FUNCTION_CALL = {
	    begin: FUNCTION_NAME_RE + '\\(', end: '\\)',
	    returnBegin: true,
	    relevance: 0,
	    contains: [
	      {
	        begin: FUNCTION_NAME_RE, relevance: 0
	      },
	      {
	        begin: '\\(', end: '\\)', endsWithParent: true,
	        returnEnd: true,
	        relevance: 0
	        // "contains" defined later
	      }
	    ]
	  };
	  var TUPLE = {
	    begin: '{', end: '}',
	    relevance: 0
	    // "contains" defined later
	  };
	  var VAR1 = {
	    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
	    relevance: 0
	  };
	  var VAR2 = {
	    begin: '[A-Z][a-zA-Z0-9_]*',
	    relevance: 0
	  };
	  var RECORD_ACCESS = {
	    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0,
	    returnBegin: true,
	    contains: [
	      {
	        begin: '#' + hljs.UNDERSCORE_IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '{', end: '}',
	        relevance: 0
	        // "contains" defined later
	      }
	    ]
	  };
	
	  var BLOCK_STATEMENTS = {
	    beginKeywords: 'fun receive if try case', end: 'end',
	    keywords: ERLANG_RESERVED
	  };
	  BLOCK_STATEMENTS.contains = [
	    COMMENT,
	    NAMED_FUN,
	    hljs.inherit(hljs.APOS_STRING_MODE, {className: ''}),
	    BLOCK_STATEMENTS,
	    FUNCTION_CALL,
	    hljs.QUOTE_STRING_MODE,
	    NUMBER,
	    TUPLE,
	    VAR1, VAR2,
	    RECORD_ACCESS
	  ];
	
	  var BASIC_MODES = [
	    COMMENT,
	    NAMED_FUN,
	    BLOCK_STATEMENTS,
	    FUNCTION_CALL,
	    hljs.QUOTE_STRING_MODE,
	    NUMBER,
	    TUPLE,
	    VAR1, VAR2,
	    RECORD_ACCESS
	  ];
	  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
	  TUPLE.contains = BASIC_MODES;
	  RECORD_ACCESS.contains[1].contains = BASIC_MODES;
	
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)',
	    contains: BASIC_MODES
	  };
	  return {
	    aliases: ['erl'],
	    keywords: ERLANG_RESERVED,
	    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
	    contains: [
	      {
	        className: 'function',
	        begin: '^' + BASIC_ATOM_RE + '\\s*\\(', end: '->',
	        returnBegin: true,
	        illegal: '\\(|#|//|/\\*|\\\\|:|;',
	        contains: [
	          PARAMS,
	          hljs.inherit(hljs.TITLE_MODE, {begin: BASIC_ATOM_RE})
	        ],
	        starts: {
	          end: ';|\\.',
	          keywords: ERLANG_RESERVED,
	          contains: BASIC_MODES
	        }
	      },
	      COMMENT,
	      {
	        begin: '^-', end: '\\.',
	        relevance: 0,
	        excludeEnd: true,
	        returnBegin: true,
	        lexemes: '-' + hljs.IDENT_RE,
	        keywords:
	          '-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn ' +
	          '-import -include -include_lib -compile -define -else -endif -file -behaviour ' +
	          '-behavior -spec',
	        contains: [PARAMS]
	      },
	      NUMBER,
	      hljs.QUOTE_STRING_MODE,
	      RECORD_ACCESS,
	      VAR1, VAR2,
	      TUPLE,
	      {begin: /\.$/} // relevance booster
	    ]
	  };
	};


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)'
	  };
	
	  var F_KEYWORDS = {
	    literal: '.False. .True.',
	    keyword: 'kind do while private call intrinsic where elsewhere ' +
	      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
	      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
	      'goto save else use module select case ' +
	      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
	      'continue format pause cycle exit ' +
	      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
	      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
	      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
	      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
	      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
	      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
	      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
	      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
	      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
	      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
	      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
	      'integer real character complex logical dimension allocatable|10 parameter ' +
	      'external implicit|10 none double precision assign intent optional pointer ' +
	      'target in out common equivalence data',
	    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
	      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
	      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
	      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
	      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
	      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
	      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
	      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
	      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
	      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
	      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
	      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
	      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
	      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
	      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
	      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
	      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
	      'num_images parity popcnt poppar shifta shiftl shiftr this_image'
	  };
	  return {
	    case_insensitive: true,
	    aliases: ['f90', 'f95'],
	    keywords: F_KEYWORDS,
	    illegal: /\/\*/,
	    contains: [
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
	      {
	        className: 'function',
	        beginKeywords: 'subroutine function program',
	        illegal: '[${=\\n]',
	        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
	      },
	      hljs.COMMENT('!', '$', {relevance: 0}),
	      {
	        className: 'number',
	        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
	        relevance: 0
	      }
	    ]
	  };
	};


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var TYPEPARAM = {
	    begin: '<', end: '>',
	    contains: [
	      hljs.inherit(hljs.TITLE_MODE, {begin: /'[a-zA-Z0-9_]+/})
	    ]
	  };
	
	  return {
	    aliases: ['fs'],
	    keywords:
	      'abstract and as assert base begin class default delegate do done ' +
	      'downcast downto elif else end exception extern false finally for ' +
	      'fun function global if in inherit inline interface internal lazy let ' +
	      'match member module mutable namespace new null of open or ' +
	      'override private public rec return sig static struct then to ' +
	      'true try type upcast use val void when while with yield',
	    illegal: /\/\*/,
	    contains: [
	      {
	        // monad builder keywords (matches before non-bang kws)
	        className: 'keyword',
	        begin: /\b(yield|return|let|do)!/
	      },
	      {
	        className: 'string',
	        begin: '@"', end: '"',
	        contains: [{begin: '""'}]
	      },
	      {
	        className: 'string',
	        begin: '"""', end: '"""'
	      },
	      hljs.COMMENT('\\(\\*', '\\*\\)'),
	      {
	        className: 'class',
	        beginKeywords: 'type', end: '\\(|=|$', excludeEnd: true,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          TYPEPARAM
	        ]
	      },
	      {
	        className: 'meta',
	        begin: '\\[<', end: '>\\]',
	        relevance: 10
	      },
	      {
	        className: 'symbol',
	        begin: '\\B(\'[A-Za-z])\\b',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	    var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
	    var GCODE_CLOSE_RE = '\\%';
	    var GCODE_KEYWORDS =
	      'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' +
	      'EQ LT GT NE GE LE OR XOR';
	    var GCODE_START = {
	        className: 'meta',
	        begin: '([O])([0-9]+)'
	    };
	    var GCODE_CODE = [
	        hljs.C_LINE_COMMENT_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        hljs.COMMENT(/\(/, /\)/),
	        hljs.inherit(hljs.C_NUMBER_MODE, {begin: '([-+]?([0-9]*\\.?[0-9]+\\.?))|' + hljs.C_NUMBER_RE}),
	        hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	        hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	        {
	            className: 'name',
	            begin: '([G])([0-9]+\\.?[0-9]?)'
	        },
	        {
	            className: 'name',
	            begin: '([M])([0-9]+\\.?[0-9]?)'
	        },
	        {
	            className: 'attr',
	            begin: '(VC|VS|#)',
	            end: '(\\d+)'
	        },
	        {
	            className: 'attr',
	            begin: '(VZOFX|VZOFY|VZOFZ)'
	        },
	        {
	            className: 'built_in',
	            begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
	            end: '([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])'
	        },
	        {
	            className: 'symbol',
	            variants: [
	                {
	                    begin: 'N', end: '\\d+',
	                    illegal: '\\W'
	                }
	            ]
	        }
	    ];
	
	    return {
	        aliases: ['nc'],
	        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
	        // However, most prefer all uppercase and uppercase is customary.
	        case_insensitive: true,
	        lexemes: GCODE_IDENT_RE,
	        keywords: GCODE_KEYWORDS,
	        contains: [
	            {
	                className: 'meta',
	                begin: GCODE_CLOSE_RE
	            },
	            GCODE_START
	        ].concat(GCODE_CODE)
	    };
	};


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var GO_KEYWORDS = {
	    keyword:
	      'break default func interface select case map struct chan else goto package switch ' +
	      'const fallthrough if range type continue for import return var go defer ' +
	      'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' +
	      'uint16 uint32 uint64 int uint uintptr rune',
	    literal:
	       'true false iota nil',
	    built_in:
	      'append cap close complex copy imag len make new panic print println real recover delete'
	  };
	  return {
	    aliases: ['golang'],
	    keywords: GO_KEYWORDS,
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: '\'', end: '[^\\\\]\''
	      },
	      {
	        className: 'string',
	        begin: '`', end: '`'
	      },
	      {
	        className: 'number',
	        begin: hljs.C_NUMBER_RE + '[dflsi]?',
	        relevance: 0
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	    return {
	        keywords: {
	            literal : 'true false null',
	            keyword:
	            'byte short char int long boolean float double void ' +
	            // groovy specific keywords
	            'def as in assert trait ' +
	            // common keywords with Java
	            'super this abstract static volatile transient public private protected synchronized final ' +
	            'class interface enum if else for while switch case break default continue ' +
	            'throw throws try catch finally implements extends new import package return instanceof'
	        },
	
	        contains: [
	            hljs.COMMENT(
	                '/\\*\\*',
	                '\\*/',
	                {
	                    relevance : 0,
	                    contains : [
	                      {
	                          // eat up @'s in emails to prevent them to be recognized as doctags
	                          begin: /\w+@/, relevance: 0
	                      },
	                      {
	                          className : 'doctag',
	                          begin : '@[A-Za-z]+'
	                      }
	                    ]
	                }
	            ),
	            hljs.C_LINE_COMMENT_MODE,
	            hljs.C_BLOCK_COMMENT_MODE,
	            {
	                className: 'string',
	                begin: '"""', end: '"""'
	            },
	            {
	                className: 'string',
	                begin: "'''", end: "'''"
	            },
	            {
	                className: 'string',
	                begin: "\\$/", end: "/\\$",
	                relevance: 10
	            },
	            hljs.APOS_STRING_MODE,
	            {
	                className: 'regexp',
	                begin: /~?\/[^\/\n]+\//,
	                contains: [
	                    hljs.BACKSLASH_ESCAPE
	                ]
	            },
	            hljs.QUOTE_STRING_MODE,
	            {
	                className: 'meta',
	                begin: "^#!/usr/bin/env", end: '$',
	                illegal: '\n'
	            },
	            hljs.BINARY_NUMBER_MODE,
	            {
	                className: 'class',
	                beginKeywords: 'class interface trait enum', end: '{',
	                illegal: ':',
	                contains: [
	                    {beginKeywords: 'extends implements'},
	                    hljs.UNDERSCORE_TITLE_MODE,
	                ]
	            },
	            hljs.C_NUMBER_MODE,
	            {
	                className: 'meta', begin: '@[A-Za-z]+'
	            },
	            {
	                // highlight map keys and named parameters as strings
	                className: 'string', begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
	            },
	            {
	                // catch middle element of the ternary operator
	                // to avoid highlight it as a label, named parameter, or map key
	                begin: /\?/, end: /\:/
	            },
	            {
	                // highlight labeled statements
	                className: 'symbol', begin: '^\\s*[A-Za-z0-9_$]+:',
	                relevance: 0
	            },
	        ],
	        illegal: /#|<\//
	    }
	};


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var BUILT_INS = {'builtin-name': 'each in with if else unless bindattr action collection debugger log outlet template unbound view yield'};
	  return {
	    aliases: ['hbs', 'html.hbs', 'html.handlebars'],
	    case_insensitive: true,
	    subLanguage: 'xml',
	    contains: [
	    hljs.COMMENT('{{!(--)?', '(--)?}}'),
	      {
	        className: 'template-tag',
	        begin: /\{\{[#\/]/, end: /\}\}/,
	        contains: [
	          {
	            className: 'name',
	            begin: /[a-zA-Z\.-]+/,
	            keywords: BUILT_INS,
	            starts: {
	              endsWithParent: true, relevance: 0,
	              contains: [
	                hljs.QUOTE_STRING_MODE
	              ]
	            }
	          }
	        ]
	      },
	      {
	        className: 'template-variable',
	        begin: /\{\{/, end: /\}\}/,
	        keywords: BUILT_INS
	      }
	    ]
	  };
	};


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var COMMENT = {
	    variants: [
	      hljs.COMMENT('--', '$'),
	      hljs.COMMENT(
	        '{-',
	        '-}',
	        {
	          contains: ['self']
	        }
	      )
	    ]
	  };
	
	  var PRAGMA = {
	    className: 'meta',
	    begin: '{-#', end: '#-}'
	  };
	
	  var PREPROCESSOR = {
	    className: 'meta',
	    begin: '^#', end: '$'
	  };
	
	  var CONSTRUCTOR = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
	    relevance: 0
	  };
	
	  var LIST = {
	    begin: '\\(', end: '\\)',
	    illegal: '"',
	    contains: [
	      PRAGMA,
	      PREPROCESSOR,
	      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
	      hljs.inherit(hljs.TITLE_MODE, {begin: '[_a-z][\\w\']*'}),
	      COMMENT
	    ]
	  };
	
	  var RECORD = {
	    begin: '{', end: '}',
	    contains: LIST.contains
	  };
	
	  return {
	    aliases: ['hs'],
	    keywords:
	      'let in if then else case of where do module import hiding ' +
	      'qualified type data newtype deriving class instance as default ' +
	      'infix infixl infixr foreign export ccall stdcall cplusplus ' +
	      'jvm dotnet safe unsafe family forall mdo proc rec',
	    contains: [
	
	      // Top-level constructions.
	
	      {
	        beginKeywords: 'module', end: 'where',
	        keywords: 'module where',
	        contains: [LIST, COMMENT],
	        illegal: '\\W\\.|;'
	      },
	      {
	        begin: '\\bimport\\b', end: '$',
	        keywords: 'import qualified as hiding',
	        contains: [LIST, COMMENT],
	        illegal: '\\W\\.|;'
	      },
	
	      {
	        className: 'class',
	        begin: '^(\\s*)?(class|instance)\\b', end: 'where',
	        keywords: 'class family instance where',
	        contains: [CONSTRUCTOR, LIST, COMMENT]
	      },
	      {
	        className: 'class',
	        begin: '\\b(data|(new)?type)\\b', end: '$',
	        keywords: 'data family type newtype deriving',
	        contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD, COMMENT]
	      },
	      {
	        beginKeywords: 'default', end: '$',
	        contains: [CONSTRUCTOR, LIST, COMMENT]
	      },
	      {
	        beginKeywords: 'infix infixl infixr', end: '$',
	        contains: [hljs.C_NUMBER_MODE, COMMENT]
	      },
	      {
	        begin: '\\bforeign\\b', end: '$',
	        keywords: 'foreign import export ccall stdcall cplusplus jvm ' +
	                  'dotnet safe unsafe',
	        contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE, COMMENT]
	      },
	      {
	        className: 'meta',
	        begin: '#!\\/usr\\/bin\\/env\ runhaskell', end: '$'
	      },
	
	      // "Whitespaces".
	
	      PRAGMA,
	      PREPROCESSOR,
	
	      // Literals and names.
	
	      // TODO: characters.
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_NUMBER_MODE,
	      CONSTRUCTOR,
	      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
	
	      COMMENT,
	
	      {begin: '->|<-'} // No markup, relevance booster
	    ]
	  };
	};


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
	  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';
	
	  return {
	    aliases: ['hx'],
	    keywords: {
	      keyword: 'break callback case cast catch class continue default do dynamic else enum extends extern ' +
	    'for function here if implements import in inline interface never new override package private ' +
	    'public return static super switch this throw trace try typedef untyped using var while',
	      literal: 'true false null'
	    },
	    contains: [
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        contains: [
	          {
	            beginKeywords: 'extends implements'
	          },
	          hljs.TITLE_MODE
	        ]
	      },
	      {
	        className: 'meta',
	        begin: '#', end: '$',
	        keywords: {'meta-keyword': 'if else elseif end error'}
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
	        illegal: '\\S',
	        contains: [
	          hljs.TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          {
	            begin: ':\\s*' + IDENT_FUNC_RETURN_TYPE_RE
	          }
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var GENERIC_IDENT_RE = hljs.UNDERSCORE_IDENT_RE + '(<' + hljs.UNDERSCORE_IDENT_RE + '(\\s*,\\s*' + hljs.UNDERSCORE_IDENT_RE + ')*>)?';
	  var KEYWORDS =
	    'false synchronized int abstract float private char boolean static null if const ' +
	    'for true while long strictfp finally protected import native final void ' +
	    'enum else break transient catch instanceof byte super volatile case assert short ' +
	    'package default double public try this switch continue throws protected public private';
	
	  // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
	  var JAVA_NUMBER_RE = '\\b' +
	    '(' +
	      '0[bB]([01]+[01_]+[01]+|[01]+)' + // 0b...
	      '|' +
	      '0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)' + // 0x...
	      '|' +
	      '(' +
	        '([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?' +
	        '|' +
	        '\\.([\\d]+[\\d_]+[\\d]+|[\\d]+)' +
	      ')' +
	      '([eE][-+]?\\d+)?' + // octal, decimal, float
	    ')' +
	    '[lLfF]?';
	  var JAVA_NUMBER_MODE = {
	    className: 'number',
	    begin: JAVA_NUMBER_RE,
	    relevance: 0
	  };
	
	  return {
	    aliases: ['jsp'],
	    keywords: KEYWORDS,
	    illegal: /<\/|#/,
	    contains: [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [
	            {
	              // eat up @'s in emails to prevent them to be recognized as doctags
	              begin: /\w+@/, relevance: 0
	            },
	            {
	              className : 'doctag',
	              begin : '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: /[{;=]/, excludeEnd: true,
	        keywords: 'class interface',
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        // Expression keywords prevent 'keyword Name(...)' from being
	        // recognized as a function definition
	        beginKeywords: 'new throw return else',
	        relevance: 0
	      },
	      {
	        className: 'function',
	        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        contains: [
	          {
	            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
	            relevance: 0,
	            contains: [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: KEYWORDS,
	            relevance: 0,
	            contains: [
	              hljs.APOS_STRING_MODE,
	              hljs.QUOTE_STRING_MODE,
	              hljs.C_NUMBER_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      JAVA_NUMBER_MODE,
	      {
	        className: 'meta', begin: '@[A-Za-z]+'
	      }
	    ]
	  };
	};


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['js', 'jsx'],
	    keywords: {
	      keyword:
	        'in of if for while finally var new function do return void else break catch ' +
	        'instanceof with throw case default try this switch continue typeof delete ' +
	        'let yield const export super debugger as async await static ' +
	        // ECMAScript 6 modules import
	        'import from as'
	      ,
	      literal:
	        'true false null undefined NaN Infinity',
	      built_in:
	        'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	        'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	        'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	        'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	        'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	        'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	        'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
	        'Promise'
	    },
	    contains: [
	      {
	        className: 'meta',
	        relevance: 10,
	        begin: /^\s*['"]use (strict|asm)['"]/
	      },
	      {
	        className: 'meta',
	        begin: /^#!/, end: /$/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      { // template string
	        className: 'string',
	        begin: '`', end: '`',
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            begin: '\\$\\{', end: '\\}'
	          }
	        ]
	      },
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b(0[bB][01]+)' },
	          { begin: '\\b(0[oO][0-7]+)' },
	          { begin: hljs.C_NUMBER_RE }
	        ],
	        relevance: 0
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE,
	          { // E4X / JSX
	            begin: /</, end: /(\/\w+|\w+\/)>/,
	            subLanguage: 'xml',
	            contains: [
	              {begin: /<\w+\/>/, skip: true},
	              {begin: /<\w+/, end: /(\/\w+|\w+\/)>/, skip: true, contains: ['self']}
	            ]
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /\{/, excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            contains: [
	              hljs.C_LINE_COMMENT_MODE,
	              hljs.C_BLOCK_COMMENT_MODE
	            ]
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
	      },
	      hljs.METHOD_GUARD,
	      { // ES6 class
	        className: 'class',
	        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'constructor', end: /\{/, excludeEnd: true
	      }
	    ],
	    illegal: /#(?!!)/
	  };
	};


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var LITERALS = {literal: 'true false null'};
	  var TYPES = [
	    hljs.QUOTE_STRING_MODE,
	    hljs.C_NUMBER_MODE
	  ];
	  var VALUE_CONTAINER = {
	    end: ',', endsWithParent: true, excludeEnd: true,
	    contains: TYPES,
	    keywords: LITERALS
	  };
	  var OBJECT = {
	    begin: '{', end: '}',
	    contains: [
	      {
	        className: 'attr',
	        begin: /"/, end: /"/,
	        contains: [hljs.BACKSLASH_ESCAPE],
	        illegal: '\\n',
	      },
	      hljs.inherit(VALUE_CONTAINER, {begin: /:/})
	    ],
	    illegal: '\\S'
	  };
	  var ARRAY = {
	    begin: '\\[', end: '\\]',
	    contains: [hljs.inherit(VALUE_CONTAINER)], // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
	    illegal: '\\S'
	  };
	  TYPES.splice(TYPES.length, 0, OBJECT, ARRAY);
	  return {
	    contains: TYPES,
	    keywords: LITERALS,
	    illegal: '\\S'
	  };
	};


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  // Since there are numerous special names in Julia, it is too much trouble
	  // to maintain them by hand. Hence these names (i.e. keywords, literals and
	  // built-ins) are automatically generated from Julia (v0.3.0 and v0.4.1)
	  // itself through following scripts for each.
	
	  var KEYWORDS = {
	    // # keyword generator
	    // println("in")
	    // for kw in Base.REPLCompletions.complete_keyword("")
	    //     println(kw)
	    // end
	    keyword:
	      'in abstract baremodule begin bitstype break catch ccall const continue do else elseif end export ' +
	      'finally for function global if immutable import importall let local macro module quote return try type ' +
	      'typealias using while',
	
	    // # literal generator
	    // println("true")
	    // println("false")
	    // for name in Base.REPLCompletions.completions("", 0)[1]
	    //     try
	    //         s = symbol(name)
	    //         v = eval(s)
	    //         if !isa(v, Function) &&
	    //            !isa(v, DataType) &&
	    //            !isa(v, IntrinsicFunction) &&
	    //            !issubtype(typeof(v), Tuple) &&
	    //            !isa(v, Union) &&
	    //            !isa(v, Module) &&
	    //            !isa(v, TypeConstructor) &&
	    //            !isa(v, TypeVar) &&
	    //            !isa(v, Colon)
	    //             println(name)
	    //         end
	    //     end
	    // end
	    literal:
	      // v0.3
	      'true false ARGS CPU_CORES C_NULL DL_LOAD_PATH DevNull ENDIAN_BOM ENV I|0 Inf Inf16 Inf32 ' +
	      'InsertionSort JULIA_HOME LOAD_PATH MS_ASYNC MS_INVALIDATE MS_SYNC MergeSort NaN NaN16 NaN32 OS_NAME QuickSort ' +
	      'RTLD_DEEPBIND RTLD_FIRST RTLD_GLOBAL RTLD_LAZY RTLD_LOCAL RTLD_NODELETE RTLD_NOLOAD RTLD_NOW RoundDown ' +
	      'RoundFromZero RoundNearest RoundToZero RoundUp STDERR STDIN STDOUT VERSION WORD_SIZE catalan cglobal e|0 eu|0 ' +
	      'eulergamma golden im nothing pi γ π φ ' +
	      // v0.4 (diff)
	      'Inf64 NaN64 RoundNearestTiesAway RoundNearestTiesUp ',
	
	    // # built_in generator:
	    // for name in Base.REPLCompletions.completions("", 0)[1]
	    //     try
	    //         v = eval(symbol(name))
	    //         if isa(v, DataType) || isa(v, TypeConstructor) || isa(v, TypeVar)
	    //             println(name)
	    //         end
	    //     end
	    // end
	    built_in:
	      // v0.3
	      'ANY ASCIIString AbstractArray AbstractRNG AbstractSparseArray Any ArgumentError Array Associative Base64Pipe ' +
	      'Bidiagonal BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError Box CFILE Cchar Cdouble Cfloat Char ' +
	      'CharString Cint Clong Clonglong ClusterManager Cmd Coff_t Colon Complex Complex128 Complex32 Complex64 ' +
	      'Condition Cptrdiff_t Cshort Csize_t Cssize_t Cuchar Cuint Culong Culonglong Cushort Cwchar_t DArray DataType ' +
	      'DenseArray Diagonal Dict DimensionMismatch DirectIndexString Display DivideError DomainError EOFError ' +
	      'EachLine Enumerate ErrorException Exception Expr Factorization FileMonitor FileOffset Filter Float16 Float32 ' +
	      'Float64 FloatRange FloatingPoint Function GetfieldNode GotoNode Hermitian IO IOBuffer IOStream IPv4 IPv6 ' +
	      'InexactError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException IntrinsicFunction KeyError ' +
	      'LabelNode LambdaStaticData LineNumberNode LoadError LocalProcess MIME MathConst MemoryError MersenneTwister ' +
	      'Method MethodError MethodTable Module NTuple NewvarNode Nothing Number ObjectIdDict OrdinalRange ' +
	      'OverflowError ParseError PollingFileWatcher ProcessExitedException ProcessGroup Ptr QuoteNode Range Range1 ' +
	      'Ranges Rational RawFD Real Regex RegexMatch RemoteRef RepString RevString RopeString RoundingMode Set ' +
	      'SharedArray Signed SparseMatrixCSC StackOverflowError Stat StatStruct StepRange String SubArray SubString ' +
	      'SymTridiagonal Symbol SymbolNode Symmetric SystemError Task TextDisplay Timer TmStruct TopNode Triangular ' +
	      'Tridiagonal Type TypeConstructor TypeError TypeName TypeVar UTF16String UTF32String UTF8String UdpSocket ' +
	      'Uint Uint128 Uint16 Uint32 Uint64 Uint8 UndefRefError UndefVarError UniformScaling UnionType UnitRange ' +
	      'Unsigned Vararg VersionNumber WString WeakKeyDict WeakRef Woodbury Zip ' +
	      // v0.4 (diff)
	      'AbstractChannel AbstractFloat AbstractString AssertionError Base64DecodePipe Base64EncodePipe BufferStream ' +
	      'CapturedException CartesianIndex CartesianRange Channel Cintmax_t CompositeException Cstring Cuintmax_t ' +
	      'Cwstring Date DateTime Dims Enum GenSym GlobalRef HTML InitError InvalidStateException Irrational LinSpace ' +
	      'LowerTriangular NullException Nullable OutOfMemoryError Pair PartialQuickSort Pipe RandomDevice ' +
	      'ReadOnlyMemoryError ReentrantLock Ref RemoteException SegmentationFault SerializationState SimpleVector ' +
	      'TCPSocket Text Tuple UDPSocket UInt UInt128 UInt16 UInt32 UInt64 UInt8 UnicodeError Union UpperTriangular ' +
	      'Val Void WorkerConfig AbstractMatrix AbstractSparseMatrix AbstractSparseVector AbstractVecOrMat AbstractVector ' +
	      'DenseMatrix DenseVecOrMat DenseVector Matrix SharedMatrix SharedVector StridedArray StridedMatrix ' +
	      'StridedVecOrMat StridedVector VecOrMat Vector '
	  };
	
	  // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
	  var VARIABLE_NAME_RE = '[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*';
	
	  // placeholder for recursive self-reference
	  var DEFAULT = { lexemes: VARIABLE_NAME_RE, keywords: KEYWORDS, illegal: /<\// };
	
	  var TYPE_ANNOTATION = {
	    className: 'type',
	    begin: /::/
	  };
	
	  var SUBTYPE = {
	    className: 'type',
	    begin: /<:/
	  };
	
	  // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
	  var NUMBER = {
	    className: 'number',
	    // supported numeric literals:
	    //  * binary literal (e.g. 0x10)
	    //  * octal literal (e.g. 0o76543210)
	    //  * hexadecimal literal (e.g. 0xfedcba876543210)
	    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
	    //  * decimal literal (e.g. 9876543210, 100_000_000)
	    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
	    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
	    relevance: 0
	  };
	
	  var CHAR = {
	    className: 'string',
	    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
	  };
	
	  var INTERPOLATION = {
	    className: 'subst',
	    begin: /\$\(/, end: /\)/,
	    keywords: KEYWORDS
	  };
	
	  var INTERPOLATED_VARIABLE = {
	    className: 'variable',
	    begin: '\\$' + VARIABLE_NAME_RE
	  };
	
	  // TODO: neatly escape normal code in string literal
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
	    variants: [
	      { begin: /\w*"""/, end: /"""\w*/, relevance: 10 },
	      { begin: /\w*"/, end: /"\w*/ }
	    ]
	  };
	
	  var COMMAND = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
	    begin: '`', end: '`'
	  };
	
	  var MACROCALL = {
	    className: 'meta',
	    begin: '@' + VARIABLE_NAME_RE
	  };
	
	  var COMMENT = {
	    className: 'comment',
	    variants: [
	      { begin: '#=', end: '=#', relevance: 10 },
	      { begin: '#', end: '$' }
	    ]
	  };
	
	  DEFAULT.contains = [
	    NUMBER,
	    CHAR,
	    TYPE_ANNOTATION,
	    SUBTYPE,
	    STRING,
	    COMMAND,
	    MACROCALL,
	    COMMENT,
	    hljs.HASH_COMMENT_MODE
	  ];
	  INTERPOLATION.contains = DEFAULT.contains;
	
	  return DEFAULT;
	};


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function (hljs) {
	  var KEYWORDS = 'val var get set class trait object open private protected public ' +
	    'final enum if else do while for when break continue throw try catch finally ' +
	    'import package is as in return fun override default companion reified inline volatile transient native ' +
	    'Byte Short Char Int Long Boolean Float Double Void Unit Nothing';
	
	  return {
	    keywords: {
	      keyword: KEYWORDS,
	      literal: 'true false null'
	    },
	    contains : [
	      hljs.COMMENT(
	        '/\\*\\*',
	        '\\*/',
	        {
	          relevance : 0,
	          contains : [{
	            className : 'doctag',
	            begin : '@[A-Za-z]+'
	          }]
	        }
	      ),
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'type',
	        begin: /</, end: />/,
	        returnBegin: true,
	        excludeEnd: false,
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'fun', end: '[(]|$',
	        returnBegin: true,
	        excludeEnd: true,
	        keywords: KEYWORDS,
	        illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
	        relevance: 5,
	        contains: [
	          {
	            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
	            relevance: 0,
	            contains: [hljs.UNDERSCORE_TITLE_MODE]
	          },
	          {
	            className: 'type',
	            begin: /</, end: />/, keywords: 'reified',
	            relevance: 0
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            keywords: KEYWORDS,
	            relevance: 0,
	            illegal: /\([^\(,\s:]+,/,
	            contains: [
	              {
	                className: 'type',
	                begin: /:\s*/, end: /\s*[=\)]/, excludeBegin: true, returnEnd: true,
	                relevance: 0
	              }
	            ]
	          },
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class trait', end: /[:\{(]|$/,
	        excludeEnd: true,
	        illegal: 'extends implements',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'type',
	            begin: /</, end: />/, excludeBegin: true, excludeEnd: true,
	            relevance: 0
	          },
	          {
	            className: 'type',
	            begin: /[,:]\s*/, end: /[<\(,]|$/, excludeBegin: true, returnEnd: true
	          }
	        ]
	      },
	      {
	        className: 'variable', beginKeywords: 'var val', end: /\s*[=:$]/, excludeEnd: true
	      },
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'meta',
	        begin: "^#!/usr/bin/env", end: '$',
	        illegal: '\n'
	      },
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var IDENT_RE        = '[\\w-]+'; // yes, Less identifiers may begin with a digit
	  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@{' + IDENT_RE + '})';
	
	  /* Generic Modes */
	
	  var RULES = [], VALUE = []; // forward def. for recursive modes
	
	  var STRING_MODE = function(c) { return {
	    // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
	    className: 'string', begin: '~?' + c + '.*?' + c
	  };};
	
	  var IDENT_MODE = function(name, begin, relevance) { return {
	    className: name, begin: begin, relevance: relevance
	  };};
	
	  var PARENS_MODE = {
	    // used only to properly balance nested parens inside mixin call, def. arg list
	    begin: '\\(', end: '\\)', contains: VALUE, relevance: 0
	  };
	
	  // generic Less highlighter (used almost everywhere except selectors):
	  VALUE.push(
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    STRING_MODE("'"),
	    STRING_MODE('"'),
	    hljs.CSS_NUMBER_MODE, // fixme: it does not include dot for numbers like .5em :(
	    {
	      begin: '(url|data-uri)\\(',
	      starts: {className: 'string', end: '[\\)\\n]', excludeEnd: true}
	    },
	    IDENT_MODE('number', '#[0-9A-Fa-f]+\\b'),
	    PARENS_MODE,
	    IDENT_MODE('variable', '@@?' + IDENT_RE, 10),
	    IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),
	    IDENT_MODE('built_in', '~?`[^`]*?`'), // inline javascript (or whatever host language) *multiline* string
	    { // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
	      className: 'attribute', begin: IDENT_RE + '\\s*:', end: ':', returnBegin: true, excludeEnd: true
	    },
	    {
	      className: 'meta',
	      begin: '!important'
	    }
	  );
	
	  var VALUE_WITH_RULESETS = VALUE.concat({
	    begin: '{', end: '}', contains: RULES
	  });
	
	  var MIXIN_GUARD_MODE = {
	    beginKeywords: 'when', endsWithParent: true,
	    contains: [{beginKeywords: 'and not'}].concat(VALUE) // using this form to override VALUE’s 'function' match
	  };
	
	  /* Rule-Level Modes */
	
	  var RULE_MODE = {
	    className: 'attribute',
	    begin: INTERP_IDENT_RE, end: ':', excludeEnd: true,
	    contains: [hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE],
	    illegal: /\S/,
	    starts: {end: '[;}]', returnEnd: true, contains: VALUE, illegal: '[<=$]'}
	  };
	
	  var AT_RULE_MODE = {
	    className: 'keyword',
	    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
	    starts: {end: '[;{}]', returnEnd: true, contains: VALUE, relevance: 0}
	  };
	
	  // variable definitions and calls
	  var VAR_RULE_MODE = {
	    className: 'variable',
	    variants: [
	      // using more strict pattern for higher relevance to increase chances of Less detection.
	      // this is *the only* Less specific statement used in most of the sources, so...
	      // (we’ll still often loose to the css-parser unless there's '//' comment,
	      // simply because 1 variable just can't beat 99 properties :)
	      {begin: '@' + IDENT_RE + '\\s*:', relevance: 15},
	      {begin: '@' + IDENT_RE}
	    ],
	    starts: {end: '[;}]', returnEnd: true, contains: VALUE_WITH_RULESETS}
	  };
	
	  var SELECTOR_MODE = {
	    // first parse unambiguous selectors (i.e. those not starting with tag)
	    // then fall into the scary lookahead-discriminator variant.
	    // this mode also handles mixin definitions and calls
	    variants: [{
	      begin: '[\\.#:&\\[]', end: '[;{}]'  // mixin calls end with ';'
	      }, {
	      begin: INTERP_IDENT_RE + '[^;]*{',
	      end: '{'
	    }],
	    returnBegin: true,
	    returnEnd:   true,
	    illegal: '[<=\'$"]',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      MIXIN_GUARD_MODE,
	      IDENT_MODE('keyword',  'all\\b'),
	      IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),     // otherwise it’s identified as tag
	      IDENT_MODE('selector-tag',  INTERP_IDENT_RE + '%?', 0), // '%' for more consistent coloring of @keyframes "tags"
	      IDENT_MODE('selector-id', '#' + INTERP_IDENT_RE),
	      IDENT_MODE('selector-class', '\\.' + INTERP_IDENT_RE, 0),
	      IDENT_MODE('selector-tag',  '&', 0),
	      {className: 'selector-attr', begin: '\\[', end: '\\]'},
	      {begin: '\\(', end: '\\)', contains: VALUE_WITH_RULESETS}, // argument list of parametric mixins
	      {begin: '!important'} // eat !important after mixin call or it will be colored as tag
	    ]
	  };
	
	  RULES.push(
	    hljs.C_LINE_COMMENT_MODE,
	    hljs.C_BLOCK_COMMENT_MODE,
	    AT_RULE_MODE,
	    VAR_RULE_MODE,
	    SELECTOR_MODE,
	    RULE_MODE
	  );
	
	  return {
	    case_insensitive: true,
	    illegal: '[=>\'/<($"]',
	    contains: RULES
	  };
	};


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var LISP_IDENT_RE = '[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*';
	  var MEC_RE = '\\|[^]*?\\|';
	  var LISP_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?';
	  var SHEBANG = {
	    className: 'meta',
	    begin: '^#!', end: '$'
	  };
	  var LITERAL = {
	    className: 'literal',
	    begin: '\\b(t{1}|nil)\\b'
	  };
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      {begin: LISP_SIMPLE_NUMBER_RE, relevance: 0},
	      {begin: '#(b|B)[0-1]+(/[0-1]+)?'},
	      {begin: '#(o|O)[0-7]+(/[0-7]+)?'},
	      {begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'},
	      {begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE, end: '\\)'}
	    ]
	  };
	  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
	  var COMMENT = hljs.COMMENT(
	    ';', '$',
	    {
	      relevance: 0
	    }
	  );
	  var VARIABLE = {
	    begin: '\\*', end: '\\*'
	  };
	  var KEYWORD = {
	    className: 'symbol',
	    begin: '[:&]' + LISP_IDENT_RE
	  };
	  var IDENT = {
	    begin: LISP_IDENT_RE,
	    relevance: 0
	  };
	  var MEC = {
	    begin: MEC_RE
	  };
	  var QUOTED_LIST = {
	    begin: '\\(', end: '\\)',
	    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
	  };
	  var QUOTED = {
	    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
	    variants: [
	      {
	        begin: '[\'`]\\(', end: '\\)'
	      },
	      {
	        begin: '\\(quote ', end: '\\)',
	        keywords: {name: 'quote'}
	      },
	      {
	        begin: '\'' + MEC_RE
	      }
	    ]
	  };
	  var QUOTED_ATOM = {
	    variants: [
	      {begin: '\'' + LISP_IDENT_RE},
	      {begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'}
	    ]
	  };
	  var LIST = {
	    begin: '\\(\\s*', end: '\\)'
	  };
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	  LIST.contains = [
	    {
	      className: 'name',
	      variants: [
	        {begin: LISP_IDENT_RE},
	        {begin: MEC_RE}
	      ]
	    },
	    BODY
	  ];
	  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];
	
	  return {
	    illegal: /\S/,
	    contains: [
	      NUMBER,
	      SHEBANG,
	      LITERAL,
	      STRING,
	      COMMENT,
	      QUOTED,
	      QUOTED_ATOM,
	      LIST,
	      IDENT
	    ]
	  };
	};


/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var OPENING_LONG_BRACKET = '\\[=*\\[';
	  var CLOSING_LONG_BRACKET = '\\]=*\\]';
	  var LONG_BRACKETS = {
	    begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
	    contains: ['self']
	  };
	  var COMMENTS = [
	    hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'),
	    hljs.COMMENT(
	      '--' + OPENING_LONG_BRACKET,
	      CLOSING_LONG_BRACKET,
	      {
	        contains: [LONG_BRACKETS],
	        relevance: 10
	      }
	    )
	  ];
	  return {
	    lexemes: hljs.UNDERSCORE_IDENT_RE,
	    keywords: {
	      keyword:
	        'and break do else elseif end false for if in local nil not or repeat return then ' +
	        'true until while',
	      built_in:
	        '_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load ' +
	        'loadfile loadstring module next pairs pcall print rawequal rawget rawset require ' +
	        'select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug ' +
	        'io math os package string table'
	    },
	    contains: COMMENTS.concat([
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '\\)',
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
	          {
	            className: 'params',
	            begin: '\\(', endsWithParent: true,
	            contains: COMMENTS
	          }
	        ].concat(COMMENTS)
	      },
	      hljs.C_NUMBER_MODE,
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
	        contains: [LONG_BRACKETS],
	        relevance: 5
	      }
	    ])
	  };
	};


/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var VARIABLE = {
	    className: 'variable',
	    begin: /\$\(/, end: /\)/,
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  return {
	    aliases: ['mk', 'mak'],
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: /^\w+\s*\W*=/, returnBegin: true,
	        relevance: 0,
	        starts: {
	          end: /\s*\W*=/, excludeEnd: true,
	          starts: {
	            end: /$/,
	            relevance: 0,
	            contains: [
	              VARIABLE
	            ]
	          }
	        }
	      },
	      {
	        className: 'section',
	        begin: /^[\w]+:\s*$/
	      },
	      {
	        className: 'meta',
	        begin: /^\.PHONY:/, end: /$/,
	        keywords: {'meta-keyword': '.PHONY'}, lexemes: /[\.\w]+/
	      },
	      {
	        begin: /^\t+/, end: /$/,
	        relevance: 0,
	        contains: [
	          hljs.QUOTE_STRING_MODE,
	          VARIABLE
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['md', 'mkdown', 'mkd'],
	    contains: [
	      // highlight headers
	      {
	        className: 'section',
	        variants: [
	          { begin: '^#{1,6}', end: '$' },
	          { begin: '^.+?\\n[=-]{2,}$' }
	        ]
	      },
	      // inline html
	      {
	        begin: '<', end: '>',
	        subLanguage: 'xml',
	        relevance: 0
	      },
	      // lists (indicators only)
	      {
	        className: 'bullet',
	        begin: '^([*+-]|(\\d+\\.))\\s+'
	      },
	      // strong segments
	      {
	        className: 'strong',
	        begin: '[*_]{2}.+?[*_]{2}'
	      },
	      // emphasis segments
	      {
	        className: 'emphasis',
	        variants: [
	          { begin: '\\*.+?\\*' },
	          { begin: '_.+?_'
	          , relevance: 0
	          }
	        ]
	      },
	      // blockquotes
	      {
	        className: 'quote',
	        begin: '^>\\s+', end: '$'
	      },
	      // code snippets
	      {
	        className: 'code',
	        variants: [
	          { begin: '`.+?`' },
	          { begin: '^( {4}|\t)', end: '$'
	          , relevance: 0
	          }
	        ]
	      },
	      // horizontal rules
	      {
	        begin: '^[-\\*]{3,}', end: '$'
	      },
	      // using links - title and link
	      {
	        begin: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'string',
	            begin: '\\[', end: '\\]',
	            excludeBegin: true,
	            returnEnd: true,
	            relevance: 0
	          },
	          {
	            className: 'link',
	            begin: '\\]\\(', end: '\\)',
	            excludeBegin: true, excludeEnd: true
	          },
	          {
	            className: 'symbol',
	            begin: '\\]\\[', end: '\\]',
	            excludeBegin: true, excludeEnd: true
	          }
	        ],
	        relevance: 10
	      },
	      {
	        begin: '^\\[\.+\\]:',
	        returnBegin: true,
	        contains: [
	          {
	            className: 'symbol',
	            begin: '\\[', end: '\\]:',
	            excludeBegin: true, excludeEnd: true,
	            starts: {
	              className: 'link',
	              end: '$'
	            }
	          }
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var COMMON_CONTAINS = [
	    hljs.C_NUMBER_MODE,
	    {
	      className: 'string',
	      begin: '\'', end: '\'',
	      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	    }
	  ];
	  var TRANSPOSE = {
	    relevance: 0,
	    contains: [
	      {
	        begin: /'['\.]*/
	      }
	    ]
	  };
	
	  return {
	    keywords: {
	      keyword:
	        'break case catch classdef continue else elseif end enumerated events for function ' +
	        'global if methods otherwise parfor persistent properties return spmd switch try while',
	      built_in:
	        'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' +
	        'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' +
	        'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' +
	        'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' +
	        'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' +
	        'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' +
	        'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' +
	        'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' +
	        'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' +
	        'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' +
	        'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' +
	        'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan ' +
	        'isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal ' +
	        'rosser toeplitz vander wilkinson'
	    },
	    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
	    contains: [
	      {
	        className: 'function',
	        beginKeywords: 'function', end: '$',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            variants: [
	              {begin: '\\(', end: '\\)'},
	              {begin: '\\[', end: '\\]'}
	            ]
	          }
	        ]
	      },
	      {
	        begin: /[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,
	        returnBegin: true,
	        relevance: 0,
	        contains: [
	          {begin: /[a-zA-Z_][a-zA-Z_0-9]*/, relevance: 0},
	          TRANSPOSE.contains[0]
	        ]
	      },
	      {
	        begin: '\\[', end: '\\]',
	        contains: COMMON_CONTAINS,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      {
	        begin: '\\{', end: /}/,
	        contains: COMMON_CONTAINS,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      {
	        // transpose operators at the end of a function call
	        begin: /\)/,
	        relevance: 0,
	        starts: TRANSPOSE
	      },
	      hljs.COMMENT('^\\s*\\%\\{\\s*$', '^\\s*\\%\\}\\s*$'),
	      hljs.COMMENT('\\%', '$')
	    ].concat(COMMON_CONTAINS)
	  };
	};


/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var API_CLASS = {
	    className: 'built_in',
	    begin: '(AV|CA|CF|CG|CI|MK|MP|NS|UI|XC)\\w+',
	  };
	  var OBJC_KEYWORDS = {
	    keyword:
	      'int float while char export sizeof typedef const struct for union ' +
	      'unsigned long volatile static bool mutable if do return goto void ' +
	      'enum else break extern asm case short default double register explicit ' +
	      'signed typename this switch continue wchar_t inline readonly assign ' +
	      'readwrite self @synchronized id typeof ' +
	      'nonatomic super unichar IBOutlet IBAction strong weak copy ' +
	      'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' +
	      '@private @protected @public @try @property @end @throw @catch @finally ' +
	      '@autoreleasepool @synthesize @dynamic @selector @optional @required',
	    literal:
	      'false true FALSE TRUE nil YES NO NULL',
	    built_in:
	      'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
	  };
	  var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
	  var CLASS_KEYWORDS = '@interface @class @protocol @implementation';
	  return {
	    aliases: ['mm', 'objc', 'obj-c'],
	    keywords: OBJC_KEYWORDS,
	    lexemes: LEXEMES,
	    illegal: '</',
	    contains: [
	      API_CLASS,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_NUMBER_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'string',
	        variants: [
	          {
	            begin: '@"', end: '"',
	            illegal: '\\n',
	            contains: [hljs.BACKSLASH_ESCAPE]
	          },
	          {
	            begin: '\'', end: '[^\\\\]\'',
	            illegal: '[^\\\\][^\']'
	          }
	        ]
	      },
	      {
	        className: 'meta',
	        begin: '#',
	        end: '$',
	        contains: [
	          {
	            className: 'meta-string',
	            variants: [
	              { begin: '\"', end: '\"' },
	              { begin: '<', end: '>' }
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        begin: '(' + CLASS_KEYWORDS.split(' ').join('|') + ')\\b', end: '({|$)', excludeEnd: true,
	        keywords: CLASS_KEYWORDS, lexemes: LEXEMES,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        begin: '\\.'+hljs.UNDERSCORE_IDENT_RE,
	        relevance: 0
	      }
	    ]
	  };
	};


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  /* missing support for heredoc-like string (OCaml 4.0.2+) */
	  return {
	    aliases: ['ml'],
	    keywords: {
	      keyword:
	        'and as assert asr begin class constraint do done downto else end ' +
	        'exception external for fun function functor if in include ' +
	        'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' +
	        'mod module mutable new object of open! open or private rec sig struct ' +
	        'then to try type val! val virtual when while with ' +
	        /* camlp4 */
	        'parser value',
	      built_in:
	        /* built-in types */
	        'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' +
	        /* (some) types in Pervasives */
	        'in_channel out_channel ref',
	      literal:
	        'true false'
	    },
	    illegal: /\/\/|>>/,
	    lexemes: '[a-z_]\\w*!?',
	    contains: [
	      {
	        className: 'literal',
	        begin: '\\[(\\|\\|)?\\]|\\(\\)',
	        relevance: 0
	      },
	      hljs.COMMENT(
	        '\\(\\*',
	        '\\*\\)',
	        {
	          contains: ['self']
	        }
	      ),
	      { /* type variable */
	        className: 'symbol',
	        begin: '\'[A-Za-z_](?!\')[\\w\']*'
	        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
	      },
	      { /* polymorphic variant */
	        className: 'type',
	        begin: '`[A-Z][\\w\']*'
	      },
	      { /* module or constructor */
	        className: 'type',
	        begin: '\\b[A-Z][\\w\']*',
	        relevance: 0
	      },
	      { /* don't color identifiers, but safely catch all identifiers with '*/
	        begin: '[a-z_]\\w*\'[\\w\']*', relevance: 0
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
	      {
	        className: 'number',
	        begin:
	          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
	          '0[oO][0-7_]+[Lln]?|' +
	          '0[bB][01_]+[Lln]?|' +
	          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
	        relevance: 0
	      },
	      {
	        begin: /[-=]>/ // relevance booster
	      }
	    ]
	  }
	};


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var PERL_KEYWORDS = 'getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ' +
	    'ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime ' +
	    'readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qq' +
	    'fileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent ' +
	    'shutdown dump chomp connect getsockname die socketpair close flock exists index shmget' +
	    'sub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr ' +
	    'unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 ' +
	    'getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline ' +
	    'endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand ' +
	    'mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink ' +
	    'getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr ' +
	    'untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link ' +
	    'getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller ' +
	    'lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and ' +
	    'sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 ' +
	    'chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach ' +
	    'tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedir' +
	    'ioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe ' +
	    'atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when';
	  var SUBST = {
	    className: 'subst',
	    begin: '[$@]\\{', end: '\\}',
	    keywords: PERL_KEYWORDS
	  };
	  var METHOD = {
	    begin: '->{', end: '}'
	    // contains defined later
	  };
	  var VAR = {
	    variants: [
	      {begin: /\$\d/},
	      {begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},
	      {begin: /[\$%@][^\s\w{]/, relevance: 0}
	    ]
	  };
	  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
	  var PERL_DEFAULT_CONTAINS = [
	    VAR,
	    hljs.HASH_COMMENT_MODE,
	    hljs.COMMENT(
	      '^\\=\\w',
	      '\\=cut',
	      {
	        endsWithParent: true
	      }
	    ),
	    METHOD,
	    {
	      className: 'string',
	      contains: STRING_CONTAINS,
	      variants: [
	        {
	          begin: 'q[qwxr]?\\s*\\(', end: '\\)',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\[', end: '\\]',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\{', end: '\\}',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\|', end: '\\|',
	          relevance: 5
	        },
	        {
	          begin: 'q[qwxr]?\\s*\\<', end: '\\>',
	          relevance: 5
	        },
	        {
	          begin: 'qw\\s+q', end: 'q',
	          relevance: 5
	        },
	        {
	          begin: '\'', end: '\'',
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: '"', end: '"'
	        },
	        {
	          begin: '`', end: '`',
	          contains: [hljs.BACKSLASH_ESCAPE]
	        },
	        {
	          begin: '{\\w+}',
	          contains: [],
	          relevance: 0
	        },
	        {
	          begin: '\-?\\w+\\s*\\=\\>',
	          contains: [],
	          relevance: 0
	        }
	      ]
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    { // regexp container
	      begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
	      keywords: 'split return print reverse grep',
	      relevance: 0,
	      contains: [
	        hljs.HASH_COMMENT_MODE,
	        {
	          className: 'regexp',
	          begin: '(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*',
	          relevance: 10
	        },
	        {
	          className: 'regexp',
	          begin: '(m|qr)?/', end: '/[a-z]*',
	          contains: [hljs.BACKSLASH_ESCAPE],
	          relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
	        }
	      ]
	    },
	    {
	      className: 'function',
	      beginKeywords: 'sub', end: '(\\s*\\(.*?\\))?[;{]', excludeEnd: true,
	      relevance: 5,
	      contains: [hljs.TITLE_MODE]
	    },
	    {
	      begin: '-\\w\\b',
	      relevance: 0
	    },
	    {
	      begin: "^__DATA__$",
	      end: "^__END__$",
	      subLanguage: 'mojolicious',
	      contains: [
	        {
	            begin: "^@@.*",
	            end: "$",
	            className: "comment"
	        }
	      ]
	    }
	  ];
	  SUBST.contains = PERL_DEFAULT_CONTAINS;
	  METHOD.contains = PERL_DEFAULT_CONTAINS;
	
	  return {
	    aliases: ['pl'],
	    keywords: PERL_KEYWORDS,
	    contains: PERL_DEFAULT_CONTAINS
	  };
	};


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var VARIABLE = {
	    begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*'
	  };
	  var PREPROCESSOR = {
	    className: 'meta', begin: /<\?(php)?|\?>/
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
	    variants: [
	      {
	        begin: 'b"', end: '"'
	      },
	      {
	        begin: 'b\'', end: '\''
	      },
	      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
	    ]
	  };
	  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
	  return {
	    aliases: ['php3', 'php4', 'php5', 'php6'],
	    case_insensitive: true,
	    keywords:
	      'and include_once list abstract global private echo interface as static endswitch ' +
	      'array null if endwhile or const for endforeach self var while isset public ' +
	      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
	      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
	      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
	      'enddeclare final try switch continue endfor endif declare unset true false ' +
	      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
	      'yield finally',
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.COMMENT('//', '$', {contains: [PREPROCESSOR]}),
	      hljs.COMMENT(
	        '/\\*',
	        '\\*/',
	        {
	          contains: [
	            {
	              className: 'doctag',
	              begin: '@[A-Za-z]+'
	            }
	          ]
	        }
	      ),
	      hljs.COMMENT(
	        '__halt_compiler.+?;',
	        false,
	        {
	          endsWithParent: true,
	          keywords: '__halt_compiler',
	          lexemes: hljs.UNDERSCORE_IDENT_RE
	        }
	      ),
	      {
	        className: 'string',
	        begin: /<<<['"]?\w+['"]?$/, end: /^\w+;?$/,
	        contains: [
	          hljs.BACKSLASH_ESCAPE,
	          {
	            className: 'subst',
	            variants: [
	              {begin: /\$\w+/},
	              {begin: /\{\$/, end: /\}/}
	            ]
	          }
	        ]
	      },
	      PREPROCESSOR,
	      VARIABLE,
	      {
	        // swallow composed identifiers to avoid parsing them as keywords
	        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
	        illegal: '\\$|\\[|%',
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          {
	            className: 'params',
	            begin: '\\(', end: '\\)',
	            contains: [
	              'self',
	              VARIABLE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              STRING,
	              NUMBER
	            ]
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'class interface', end: '{', excludeEnd: true,
	        illegal: /[:\(\$"]/,
	        contains: [
	          {beginKeywords: 'extends implements'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'namespace', end: ';',
	        illegal: /[\.']/,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        beginKeywords: 'use', end: ';',
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        begin: '=>' // No markup, just a relevance booster
	      },
	      STRING,
	      NUMBER
	    ]
	  };
	};


/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var backtickEscape = {
	    begin: '`[\\s\\S]',
	    relevance: 0
	  };
	  var VAR = {
	    className: 'variable',
	    variants: [
	      {begin: /\$[\w\d][\w\d_:]*/}
	    ]
	  };
	  var LITERAL = {
	    className: 'literal',
	    begin: /\$(null|true|false)\b/
	  };
	  var QUOTE_STRING = {
	    className: 'string',
	    begin: /"/, end: /"/,
	    contains: [
	      backtickEscape,
	      VAR,
	      {
	        className: 'variable',
	        begin: /\$[A-z]/, end: /[^A-z]/
	      }
	    ]
	  };
	  var APOS_STRING = {
	    className: 'string',
	    begin: /'/, end: /'/
	  };
	
	  return {
	    aliases: ['ps'],
	    lexemes: /-?[A-z\.\-]+/,
	    case_insensitive: true,
	    keywords: {
	      keyword: 'if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch',
	      built_in: 'Add-Content Add-History Add-Member Add-PSSnapin Clear-Content Clear-Item Clear-Item Property Clear-Variable Compare-Object ConvertFrom-SecureString Convert-Path ConvertTo-Html ConvertTo-SecureString Copy-Item Copy-ItemProperty Export-Alias Export-Clixml Export-Console Export-Csv ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-Content Get-Credential Get-Culture Get-Date Get-EventLog Get-ExecutionPolicy Get-Help Get-History Get-Host Get-Item Get-ItemProperty Get-Location Get-Member Get-PfxCertificate Get-Process Get-PSDrive Get-PSProvider Get-PSSnapin Get-Service Get-TraceSource Get-UICulture Get-Unique Get-Variable Get-WmiObject Group-Object Import-Alias Import-Clixml Import-Csv Invoke-Expression Invoke-History Invoke-Item Join-Path Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Item New-ItemProperty New-Object New-PSDrive New-Service New-TimeSpan New-Variable Out-Default Out-File Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Remove-Item Remove-ItemProperty Remove-PSDrive Remove-PSSnapin Remove-Variable Rename-Item Rename-ItemProperty Resolve-Path Restart-Service Resume-Service Select-Object Select-String Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-Location Set-PSDebug Set-Service Set-TraceSource Set-Variable Sort-Object Split-Path Start-Service Start-Sleep Start-Transcript Stop-Process Stop-Service Stop-Transcript Suspend-Service Tee-Object Test-Path Trace-Command Update-FormatData Update-TypeData Where-Object Write-Debug Write-Error Write-Host Write-Output Write-Progress Write-Verbose Write-Warning',
	      nomarkup: '-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace'
	    },
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      hljs.NUMBER_MODE,
	      QUOTE_STRING,
	      APOS_STRING,
	      LITERAL,
	      VAR
	    ]
	  };
	};


/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	
	  var PUPPET_KEYWORDS = {
	    keyword:
	    /* language keywords */
	      'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
	    literal:
	    /* metaparameters */
	      'alias audit before loglevel noop require subscribe tag ' +
	    /* normal attributes */
	      'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' +
	      'en_address ip_address realname command environment hour monute month monthday special target weekday '+
	      'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' +
	      'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' +
	      'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid '+
	      'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' +
	      'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' +
	      'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' +
	      'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' +
	      'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' +
	      'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' +
	      'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' +
	      'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' +
	      'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' +
	      'sslverify mounted',
	    built_in:
	    /* core facts */
	      'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' +
	      'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces '+
	      'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' +
	      'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' +
	      'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' +
	      'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease '+
	      'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion '+
	      'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced '+
	      'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime '+
	      'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
	  };
	
	  var COMMENT = hljs.COMMENT('#', '$');
	
	  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';
	
	  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE});
	
	  var VARIABLE = {className: 'variable', begin: '\\$' + IDENT_RE};
	
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/}
	    ]
	  };
	
	  return {
	    aliases: ['pp'],
	    contains: [
	      COMMENT,
	      VARIABLE,
	      STRING,
	      {
	        beginKeywords: 'class', end: '\\{|;',
	        illegal: /=/,
	        contains: [TITLE, COMMENT]
	      },
	      {
	        beginKeywords: 'define', end: /\{/,
	        contains: [
	          {
	            className: 'section', begin: hljs.IDENT_RE, endsParent: true
	          }
	        ]
	      },
	      {
	        begin: hljs.IDENT_RE + '\\s+\\{', returnBegin: true,
	        end: /\S/,
	        contains: [
	          {
	            className: 'keyword',
	            begin: hljs.IDENT_RE
	          },
	          {
	            begin: /\{/, end: /\}/,
	            keywords: PUPPET_KEYWORDS,
	            relevance: 0,
	            contains: [
	              STRING,
	              COMMENT,
	              {
	                begin:'[a-zA-Z_]+\\s*=>',
	                returnBegin: true, end: '=>',
	                contains: [
	                  {
	                    className: 'attr',
	                    begin: hljs.IDENT_RE,
	                  }
	                ]
	              },
	              {
	                className: 'number',
	                begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	                relevance: 0
	              },
	              VARIABLE
	            ]
	          }
	        ],
	        relevance: 0
	      }
	    ]
	  }
	};


/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var PROMPT = {
	    className: 'meta',  begin: /^(>>>|\.\.\.) /
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE],
	    variants: [
	      {
	        begin: /(u|b)?r?'''/, end: /'''/,
	        contains: [PROMPT],
	        relevance: 10
	      },
	      {
	        begin: /(u|b)?r?"""/, end: /"""/,
	        contains: [PROMPT],
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)'/, end: /'/,
	        relevance: 10
	      },
	      {
	        begin: /(u|r|ur)"/, end: /"/,
	        relevance: 10
	      },
	      {
	        begin: /(b|br)'/, end: /'/
	      },
	      {
	        begin: /(b|br)"/, end: /"/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE
	    ]
	  };
	  var NUMBER = {
	    className: 'number', relevance: 0,
	    variants: [
	      {begin: hljs.BINARY_NUMBER_RE + '[lLjJ]?'},
	      {begin: '\\b(0o[0-7]+)[lLjJ]?'},
	      {begin: hljs.C_NUMBER_RE + '[lLjJ]?'}
	    ]
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: /\(/, end: /\)/,
	    contains: ['self', PROMPT, NUMBER, STRING]
	  };
	  return {
	    aliases: ['py', 'gyp'],
	    keywords: {
	      keyword:
	        'and elif is global as in if from raise for except finally print import pass return ' +
	        'exec else break not with class assert yield try while continue del or def lambda ' +
	        'async await nonlocal|10 None True False',
	      built_in:
	        'Ellipsis NotImplemented'
	    },
	    illegal: /(<\/|->|\?)/,
	    contains: [
	      PROMPT,
	      NUMBER,
	      STRING,
	      hljs.HASH_COMMENT_MODE,
	      {
	        variants: [
	          {className: 'function', beginKeywords: 'def', relevance: 10},
	          {className: 'class', beginKeywords: 'class'}
	        ],
	        end: /:/,
	        illegal: /[${=;\n,]/,
	        contains: [
	          hljs.UNDERSCORE_TITLE_MODE,
	          PARAMS,
	          {
	            begin: /->/, endsWithParent: true,
	            keywords: 'None'
	          }
	        ]
	      },
	      {
	        className: 'meta',
	        begin: /^[\t ]*@/, end: /$/
	      },
	      {
	        begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
	      }
	    ]
	  };
	};


/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var IDENT_RE = '([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*';
	
	  return {
	    contains: [
	      hljs.HASH_COMMENT_MODE,
	      {
	        begin: IDENT_RE,
	        lexemes: IDENT_RE,
	        keywords: {
	          keyword:
	            'function if in break next repeat else for return switch while try tryCatch ' +
	            'stop warning require library attach detach source setMethod setGeneric ' +
	            'setGroupGeneric setClass ...',
	          literal:
	            'NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 ' +
	            'NA_complex_|10'
	        },
	        relevance: 0
	      },
	      {
	        // hex value
	        className: 'number',
	        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
	        relevance: 0
	      },
	      {
	        // explicit integer
	        className: 'number',
	        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
	        relevance: 0
	      },
	      {
	        // number with trailing decimal
	        className: 'number',
	        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
	        relevance: 0
	      },
	      {
	        // number
	        className: 'number',
	        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	      {
	        // number with leading decimal
	        className: 'number',
	        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
	        relevance: 0
	      },
	
	      {
	        // escaped identifier
	        begin: '`',
	        end: '`',
	        relevance: 0
	      },
	
	      {
	        className: 'string',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        variants: [
	          {begin: '"', end: '"'},
	          {begin: "'", end: "'"}
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var RUBY_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
	  var RUBY_KEYWORDS =
	    'and false then defined module in return redo if BEGIN retry end for true self when ' +
	    'next until do begin unless END rescue nil else break undef not super class case ' +
	    'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor';
	  var YARDOCTAG = {
	    className: 'doctag',
	    begin: '@[A-Za-z]+'
	  };
	  var IRB_OBJECT = {
	    begin: '#<', end: '>'
	  };
	  var COMMENT_MODES = [
	    hljs.COMMENT(
	      '#',
	      '$',
	      {
	        contains: [YARDOCTAG]
	      }
	    ),
	    hljs.COMMENT(
	      '^\\=begin',
	      '^\\=end',
	      {
	        contains: [YARDOCTAG],
	        relevance: 10
	      }
	    ),
	    hljs.COMMENT('^__END__', '\\n$')
	  ];
	  var SUBST = {
	    className: 'subst',
	    begin: '#\\{', end: '}',
	    keywords: RUBY_KEYWORDS
	  };
	  var STRING = {
	    className: 'string',
	    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/},
	      {begin: /`/, end: /`/},
	      {begin: '%[qQwWx]?\\(', end: '\\)'},
	      {begin: '%[qQwWx]?\\[', end: '\\]'},
	      {begin: '%[qQwWx]?{', end: '}'},
	      {begin: '%[qQwWx]?<', end: '>'},
	      {begin: '%[qQwWx]?/', end: '/'},
	      {begin: '%[qQwWx]?%', end: '%'},
	      {begin: '%[qQwWx]?-', end: '-'},
	      {begin: '%[qQwWx]?\\|', end: '\\|'},
	      {
	        // \B in the beginning suppresses recognition of ?-sequences where ?
	        // is the last character of a preceding identifier, as in: `func?4`
	        begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
	      }
	    ]
	  };
	  var PARAMS = {
	    className: 'params',
	    begin: '\\(', end: '\\)', endsParent: true,
	    keywords: RUBY_KEYWORDS
	  };
	
	  var RUBY_DEFAULT_CONTAINS = [
	    STRING,
	    IRB_OBJECT,
	    {
	      className: 'class',
	      beginKeywords: 'class module', end: '$|;',
	      illegal: /=/,
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
	        {
	          begin: '<\\s*',
	          contains: [{
	            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
	          }]
	        }
	      ].concat(COMMENT_MODES)
	    },
	    {
	      className: 'function',
	      beginKeywords: 'def', end: '$|;',
	      contains: [
	        hljs.inherit(hljs.TITLE_MODE, {begin: RUBY_METHOD_RE}),
	        PARAMS
	      ].concat(COMMENT_MODES)
	    },
	    {
	      className: 'symbol',
	      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
	      relevance: 0
	    },
	    {
	      className: 'symbol',
	      begin: ':',
	      contains: [STRING, {begin: RUBY_METHOD_RE}],
	      relevance: 0
	    },
	    {
	      className: 'number',
	      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
	      relevance: 0
	    },
	    {
	      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))' // variables
	    },
	    { // regexp container
	      begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
	      contains: [
	        IRB_OBJECT,
	        {
	          className: 'regexp',
	          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
	          illegal: /\n/,
	          variants: [
	            {begin: '/', end: '/[a-z]*'},
	            {begin: '%r{', end: '}[a-z]*'},
	            {begin: '%r\\(', end: '\\)[a-z]*'},
	            {begin: '%r!', end: '![a-z]*'},
	            {begin: '%r\\[', end: '\\][a-z]*'}
	          ]
	        }
	      ].concat(COMMENT_MODES),
	      relevance: 0
	    }
	  ].concat(COMMENT_MODES);
	
	  SUBST.contains = RUBY_DEFAULT_CONTAINS;
	  PARAMS.contains = RUBY_DEFAULT_CONTAINS;
	
	  var SIMPLE_PROMPT = "[>?]>";
	  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
	  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";
	
	  var IRB_DEFAULT = [
	    {
	      begin: /^\s*=>/,
	      starts: {
	        end: '$', contains: RUBY_DEFAULT_CONTAINS
	      }
	    },
	    {
	      className: 'meta',
	      begin: '^('+SIMPLE_PROMPT+"|"+DEFAULT_PROMPT+'|'+RVM_PROMPT+')',
	      starts: {
	        end: '$', contains: RUBY_DEFAULT_CONTAINS
	      }
	    }
	  ];
	
	  return {
	    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
	    keywords: RUBY_KEYWORDS,
	    illegal: /\/\*/,
	    contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
	  };
	};


/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var NUM_SUFFIX = '([uif](8|16|32|64|size))\?';
	  var BLOCK_COMMENT = hljs.inherit(hljs.C_BLOCK_COMMENT_MODE);
	  BLOCK_COMMENT.contains.push('self');
	  var BUILTINS =
	    // prelude
	    'Copy Send Sized Sync Drop Fn FnMut FnOnce drop Box ToOwned Clone ' +
	    'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' +
	    'Extend IntoIterator DoubleEndedIterator ExactSizeIterator Option ' +
	    'Result SliceConcatExt String ToString Vec ' +
	    // macros
	    'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' +
	    'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' +
	    'include_bin! include_str! line! local_data_key! module_path! ' +
	    'option_env! print! println! select! stringify! try! unimplemented! ' +
	    'unreachable! vec! write! writeln! macro_rules!';
	  return {
	    aliases: ['rs'],
	    keywords: {
	      keyword:
	        'alignof as be box break const continue crate do else enum extern ' +
	        'false fn for if impl in let loop match mod mut offsetof once priv ' +
	        'proc pub pure ref return self Self sizeof static struct super trait true ' +
	        'type typeof unsafe unsized use virtual while where yield ' +
	        'int i8 i16 i32 i64 ' +
	        'uint u8 u32 u64 ' +
	        'float f32 f64 ' +
	        'str char bool',
	      literal:
	        'true false Some None Ok Err',
	      built_in:
	        BUILTINS
	    },
	    lexemes: hljs.IDENT_RE + '!?',
	    illegal: '</',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      BLOCK_COMMENT,
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {begin: /b?"/, illegal: null}),
	      {
	        className: 'string',
	        variants: [
	           { begin: /r(#*)".*?"\1(?!#)/ },
	           { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
	        ]
	      },
	      {
	        className: 'symbol',
	        begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
	      },
	      {
	        className: 'number',
	        variants: [
	          { begin: '\\b0b([01_]+)' + NUM_SUFFIX },
	          { begin: '\\b0o([0-7_]+)' + NUM_SUFFIX },
	          { begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX },
	          { begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' +
	                   NUM_SUFFIX
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'fn', end: '(\\(|<)', excludeEnd: true,
	        contains: [hljs.UNDERSCORE_TITLE_MODE]
	      },
	      {
	        className: 'meta',
	        begin: '#\\!?\\[', end: '\\]',
	        contains: [
	          {
	            className: 'meta-string',
	            begin: /"/, end: /"/
	          }
	        ]
	      },
	      {
	        className: 'class',
	        beginKeywords: 'type', end: ';',
	        contains: [
	          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
	        ],
	        illegal: '\\S'
	      },
	      {
	        className: 'class',
	        beginKeywords: 'trait enum struct', end: '{',
	        contains: [
	          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
	        ],
	        illegal: '[\\w\\d]'
	      },
	      {
	        begin: hljs.IDENT_RE + '::',
	        keywords: {built_in: BUILTINS}
	      },
	      {
	        begin: '->'
	      }
	    ]
	  };
	};


/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	
	  var ANNOTATION = { className: 'meta', begin: '@[A-Za-z]+' };
	
	  // used in strings for escaping/interpolation/substitution
	  var SUBST = {
	    className: 'subst',
	    variants: [
	      {begin: '\\$[A-Za-z0-9_]+'},
	      {begin: '\\${', end: '}'}
	    ]
	  };
	
	  var STRING = {
	    className: 'string',
	    variants: [
	      {
	        begin: '"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE]
	      },
	      {
	        begin: '"""', end: '"""',
	        relevance: 10
	      },
	      {
	        begin: '[a-z]+"', end: '"',
	        illegal: '\\n',
	        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
	      },
	      {
	        className: 'string',
	        begin: '[a-z]+"""', end: '"""',
	        contains: [SUBST],
	        relevance: 10
	      }
	    ]
	
	  };
	
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '\'\\w[\\w\\d_]*(?!\')'
	  };
	
	  var TYPE = {
	    className: 'type',
	    begin: '\\b[A-Z][A-Za-z0-9_]*',
	    relevance: 0
	  };
	
	  var NAME = {
	    className: 'title',
	    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
	    relevance: 0
	  };
	
	  var CLASS = {
	    className: 'class',
	    beginKeywords: 'class object trait type',
	    end: /[:={\[\n;]/,
	    excludeEnd: true,
	    contains: [
	      {
	        beginKeywords: 'extends with',
	        relevance: 10
	      },
	      {
	        begin: /\[/,
	        end: /\]/,
	        excludeBegin: true,
	        excludeEnd: true,
	        relevance: 0,
	        contains: [TYPE]
	      },
	      {
	        className: 'params',
	        begin: /\(/,
	        end: /\)/,
	        excludeBegin: true,
	        excludeEnd: true,
	        relevance: 0,
	        contains: [TYPE]
	      },
	      NAME
	    ]
	  };
	
	  var METHOD = {
	    className: 'function',
	    beginKeywords: 'def',
	    end: /[:={\[(\n;]/,
	    excludeEnd: true,
	    contains: [NAME]
	  };
	
	  return {
	    keywords: {
	      literal: 'true false null',
	      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
	    },
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      STRING,
	      SYMBOL,
	      TYPE,
	      METHOD,
	      CLASS,
	      hljs.C_NUMBER_MODE,
	      ANNOTATION
	    ]
	  };
	};


/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
	  var SCHEME_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+([./]\\d+)?';
	  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
	  var BUILTINS = {
	    'builtin-name':
	      'case-lambda call/cc class define-class exit-handler field import ' +
	      'inherit init-field interface let*-values let-values let/ec mixin ' +
	      'opt-lambda override protect provide public rename require ' +
	      'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' +
	      'when with-syntax and begin call-with-current-continuation ' +
	      'call-with-input-file call-with-output-file case cond define ' +
	      'define-syntax delay do dynamic-wind else for-each if lambda let let* ' +
	      'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' +
	      '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' +
	      'boolean? caar cadr call-with-input-file call-with-output-file ' +
	      'call-with-values car cdddar cddddr cdr ceiling char->integer ' +
	      'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' +
	      'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' +
	      'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' +
	      'char? close-input-port close-output-port complex? cons cos ' +
	      'current-input-port current-output-port denominator display eof-object? ' +
	      'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' +
	      'force gcd imag-part inexact->exact inexact? input-port? integer->char ' +
	      'integer? interaction-environment lcm length list list->string ' +
	      'list->vector list-ref list-tail list? load log magnitude make-polar ' +
	      'make-rectangular make-string make-vector max member memq memv min ' +
	      'modulo negative? newline not null-environment null? number->string ' +
	      'number? numerator odd? open-input-file open-output-file output-port? ' +
	      'pair? peek-char port? positive? procedure? quasiquote quote quotient ' +
	      'rational? rationalize read read-char real-part real? remainder reverse ' +
	      'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' +
	      'string->list string->number string->symbol string-append string-ci<=? ' +
	      'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' +
	      'string-fill! string-length string-ref string-set! string<=? string<? ' +
	      'string=? string>=? string>? string? substring symbol->string symbol? ' +
	      'tan transcript-off transcript-on truncate values vector ' +
	      'vector->list vector-fill! vector-length vector-ref vector-set! ' +
	      'with-input-from-file with-output-to-file write write-char zero?'
	  };
	
	  var SHEBANG = {
	    className: 'meta',
	    begin: '^#!',
	    end: '$'
	  };
	
	  var LITERAL = {
	    className: 'literal',
	    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
	  };
	
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      { begin: SCHEME_SIMPLE_NUMBER_RE, relevance: 0 },
	      { begin: SCHEME_COMPLEX_NUMBER_RE, relevance: 0 },
	      { begin: '#b[0-1]+(/[0-1]+)?' },
	      { begin: '#o[0-7]+(/[0-7]+)?' },
	      { begin: '#x[0-9a-f]+(/[0-9a-f]+)?' }
	    ]
	  };
	
	  var STRING = hljs.QUOTE_STRING_MODE;
	
	  var REGULAR_EXPRESSION = {
	    className: 'regexp',
	    begin: '#[pr]x"',
	    end: '[^\\\\]"'
	  };
	
	  var COMMENT_MODES = [
	    hljs.COMMENT(
	      ';',
	      '$',
	      {
	        relevance: 0
	      }
	    ),
	    hljs.COMMENT('#\\|', '\\|#')
	  ];
	
	  var IDENT = {
	    begin: SCHEME_IDENT_RE,
	    relevance: 0
	  };
	
	  var QUOTED_IDENT = {
	    className: 'symbol',
	    begin: '\'' + SCHEME_IDENT_RE
	  };
	
	  var BODY = {
	    endsWithParent: true,
	    relevance: 0
	  };
	
	  var QUOTED_LIST = {
	    begin: /'/,
	    contains: [
	      {
	        begin: '\\(', end: '\\)',
	        contains: ['self', LITERAL, STRING, NUMBER, IDENT, QUOTED_IDENT]
	      }
	    ]
	  };
	
	  var NAME = {
	    className: 'name',
	    begin: SCHEME_IDENT_RE,
	    lexemes: SCHEME_IDENT_RE,
	    keywords: BUILTINS
	  };
	
	  var LAMBDA = {
	    begin: /lambda/, endsWithParent: true, returnBegin: true,
	    contains: [
	      NAME,
	      {
	        begin: /\(/, end: /\)/, endsParent: true,
	        contains: [IDENT],
	      }
	    ]
	  };
	
	  var LIST = {
	    variants: [
	      { begin: '\\(', end: '\\)' },
	      { begin: '\\[', end: '\\]' }
	    ],
	    contains: [LAMBDA, NAME, BODY]
	  };
	
	  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES);
	
	  return {
	    illegal: /\S/,
	    contains: [SHEBANG, NUMBER, STRING, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES)
	  };
	};


/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
	  var VARIABLE = {
	    className: 'variable',
	    begin: '(\\$' + IDENT_RE + ')\\b'
	  };
	  var HEXCOLOR = {
	    className: 'number', begin: '#[0-9A-Fa-f]+'
	  };
	  var DEF_INTERNALS = {
	    className: 'attribute',
	    begin: '[A-Z\\_\\.\\-]+', end: ':',
	    excludeEnd: true,
	    illegal: '[^\\s]',
	    starts: {
	      endsWithParent: true, excludeEnd: true,
	      contains: [
	        HEXCOLOR,
	        hljs.CSS_NUMBER_MODE,
	        hljs.QUOTE_STRING_MODE,
	        hljs.APOS_STRING_MODE,
	        hljs.C_BLOCK_COMMENT_MODE,
	        {
	          className: 'meta', begin: '!important'
	        }
	      ]
	    }
	  };
	  return {
	    case_insensitive: true,
	    illegal: '[=/|\']',
	    contains: [
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      {
	        className: 'selector-id', begin: '\\#[A-Za-z0-9_-]+',
	        relevance: 0
	      },
	      {
	        className: 'selector-class', begin: '\\.[A-Za-z0-9_-]+',
	        relevance: 0
	      },
	      {
	        className: 'selector-attr', begin: '\\[', end: '\\]',
	        illegal: '$'
	      },
	      {
	        className: 'selector-tag', // begin: IDENT_RE, end: '[,|\\s]'
	        begin: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
	        relevance: 0
	      },
	      {
	        begin: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
	      },
	      {
	        begin: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
	      },
	      VARIABLE,
	      {
	        className: 'attribute',
	        begin: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
	        illegal: '[^\\s]'
	      },
	      {
	        begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
	      },
	      {
	        begin: ':', end: ';',
	        contains: [
	          VARIABLE,
	          HEXCOLOR,
	          hljs.CSS_NUMBER_MODE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          {
	            className: 'meta', begin: '!important'
	          }
	        ]
	      },
	      {
	        begin: '@', end: '[{;]',
	        keywords: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
	        contains: [
	          VARIABLE,
	          hljs.QUOTE_STRING_MODE,
	          hljs.APOS_STRING_MODE,
	          HEXCOLOR,
	          hljs.CSS_NUMBER_MODE,
	          {
	            begin: '\\s[A-Za-z0-9_.-]+',
	            relevance: 0
	          }
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
	  var CHAR = {
	    className: 'string',
	    begin: '\\$.{1}'
	  };
	  var SYMBOL = {
	    className: 'symbol',
	    begin: '#' + hljs.UNDERSCORE_IDENT_RE
	  };
	  return {
	    aliases: ['st'],
	    keywords: 'self super nil true false thisContext', // only 6
	    contains: [
	      hljs.COMMENT('"', '"'),
	      hljs.APOS_STRING_MODE,
	      {
	        className: 'type',
	        begin: '\\b[A-Z][A-Za-z0-9_]*',
	        relevance: 0
	      },
	      {
	        begin: VAR_IDENT_RE + ':',
	        relevance: 0
	      },
	      hljs.C_NUMBER_MODE,
	      SYMBOL,
	      CHAR,
	      {
	        // This looks more complicated than needed to avoid combinatorial
	        // explosion under V8. It effectively means `| var1 var2 ... |` with
	        // whitespace adjacent to `|` being optional.
	        begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
	        returnBegin: true, end: /\|/,
	        illegal: /\S/,
	        contains: [{begin: '(\\|[ ]*)?' + VAR_IDENT_RE}]
	      },
	      {
	        begin: '\\#\\(', end: '\\)',
	        contains: [
	          hljs.APOS_STRING_MODE,
	          CHAR,
	          hljs.C_NUMBER_MODE,
	          SYMBOL
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var COMMENT_MODE = hljs.COMMENT('--', '$');
	  return {
	    case_insensitive: true,
	    illegal: /[<>{}*]/,
	    contains: [
	      {
	        beginKeywords:
	          'begin end start commit rollback savepoint lock alter create drop rename call ' +
	          'delete do handler insert load replace select truncate update set show pragma grant ' +
	          'merge describe use explain help declare prepare execute deallocate release ' +
	          'unlock purge reset change stop analyze cache flush optimize repair kill ' +
	          'install uninstall checksum restore check backup revoke',
	        end: /;/, endsWithParent: true,
	        keywords: {
	          keyword:
	            'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' +
	            'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' +
	            'allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply ' +
	            'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' +
	            'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' +
	            'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' +
	            'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' +
	            'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' +
	            'buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel ' +
	            'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' +
	            'char_length character_length characters characterset charindex charset charsetform charsetid check ' +
	            'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' +
	            'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' +
	            'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' +
	            'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' +
	            'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' +
	            'consider consistent constant constraint constraints constructor container content contents context ' +
	            'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' +
	            'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' +
	            'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' +
	            'cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add ' +
	            'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' +
	            'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' +
	            'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' +
	            'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' +
	            'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' +
	            'deterministic diagnostics difference dimension direct_load directory disable disable_all ' +
	            'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' +
	            'do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable ' +
	            'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' +
	            'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' +
	            'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' +
	            'execu execut execute exempt exists exit exp expire explain export export_set extended extent external ' +
	            'external_1 external_2 externally extract failed failed_login_attempts failover failure far fast ' +
	            'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' +
	            'finish first first_value fixed flash_cache flashback floor flush following follows for forall force ' +
	            'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' +
	            'ftp full function general generated get get_format get_lock getdate getutcdate global global_name ' +
	            'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' +
	            'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' +
	            'hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified ' +
	            'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' +
	            'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' +
	            'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' +
	            'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' +
	            'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' +
	            'keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase ' +
	            'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' +
	            'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' +
	            'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' +
	            'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime ' +
	            'managed management manual map mapping mask master master_pos_wait match matched materialized max ' +
	            'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' +
	            'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' +
	            'minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month ' +
	            'months mount move movement multiset mutex name name_const names nan national native natural nav nchar ' +
	            'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' +
	            'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' +
	            'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' +
	            'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' +
	            'noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe ' +
	            'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' +
	            'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' +
	            'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' +
	            'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' +
	            'out outer outfile outline output over overflow overriding package pad parallel parallel_enable ' +
	            'parameters parent parse partial partition partitions pascal passing password password_grace_time ' +
	            'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' +
	            'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' +
	            'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' +
	            'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' +
	            'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' +
	            'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' +
	            'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' +
	            'quotename radians raise rand range rank raw read reads readsize rebuild record records ' +
	            'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' +
	            'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' +
	            'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' +
	            'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' +
	            'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' +
	            'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' +
	            'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' +
	            'sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select ' +
	            'self sequence sequential serializable server servererror session session_user sessions_per_user set ' +
	            'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' +
	            'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' +
	            'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' +
	            'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' +
	            'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' +
	            'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' +
	            'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' +
	            'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' +
	            'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' +
	            'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' +
	            'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' +
	            'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo ' +
	            'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' +
	            'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' +
	            'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' +
	            'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' +
	            'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' +
	            'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot ' +
	            'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' +
	            'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' +
	            'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' +
	            'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' +
	            'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' +
	            'wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped ' +
	            'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' +
	            'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
	          literal:
	            'true false null',
	          built_in:
	            'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number ' +
	            'numeric real record serial serial8 smallint text varchar varying void'
	        },
	        contains: [
	          {
	            className: 'string',
	            begin: '\'', end: '\'',
	            contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
	          },
	          {
	            className: 'string',
	            begin: '"', end: '"',
	            contains: [hljs.BACKSLASH_ESCAPE, {begin: '""'}]
	          },
	          {
	            className: 'string',
	            begin: '`', end: '`',
	            contains: [hljs.BACKSLASH_ESCAPE]
	          },
	          hljs.C_NUMBER_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          COMMENT_MODE
	        ]
	      },
	      hljs.C_BLOCK_COMMENT_MODE,
	      COMMENT_MODE
	    ]
	  };
	};


/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var SWIFT_KEYWORDS = {
	      keyword: '__COLUMN__ __FILE__ __FUNCTION__ __LINE__ as as! as? associativity ' +
	        'break case catch class continue convenience default defer deinit didSet do ' +
	        'dynamic dynamicType else enum extension fallthrough false final for func ' +
	        'get guard if import in indirect infix init inout internal is lazy left let ' +
	        'mutating nil none nonmutating operator optional override postfix precedence ' +
	        'prefix private protocol Protocol public repeat required rethrows return ' +
	        'right self Self set static struct subscript super switch throw throws true ' +
	        'try try! try? Type typealias unowned var weak where while willSet',
	      literal: 'true false nil',
	      built_in: 'abs advance alignof alignofValue anyGenerator assert assertionFailure ' +
	        'bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC ' +
	        'bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros ' +
	        'debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords ' +
	        'enumerate equal fatalError filter find getBridgedObjectiveCType getVaList ' +
	        'indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC ' +
	        'isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare ' +
	        'map max maxElement min minElement numericCast overlaps partition posix ' +
	        'precondition preconditionFailure print println quickSort readLine reduce reflect ' +
	        'reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split ' +
	        'startsWith stride strideof strideofValue swap toString transcode ' +
	        'underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap ' +
	        'unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer ' +
	        'withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers ' +
	        'withUnsafePointer withUnsafePointers withVaList zip'
	    };
	
	  var TYPE = {
	    className: 'type',
	    begin: '\\b[A-Z][\\w\']*',
	    relevance: 0
	  };
	  var BLOCK_COMMENT = hljs.COMMENT(
	    '/\\*',
	    '\\*/',
	    {
	      contains: ['self']
	    }
	  );
	  var SUBST = {
	    className: 'subst',
	    begin: /\\\(/, end: '\\)',
	    keywords: SWIFT_KEYWORDS,
	    contains: [] // assigned later
	  };
	  var NUMBERS = {
	      className: 'number',
	      begin: '\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b',
	      relevance: 0
	  };
	  var QUOTE_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
	    contains: [SUBST, hljs.BACKSLASH_ESCAPE]
	  });
	  SUBST.contains = [NUMBERS];
	
	  return {
	    keywords: SWIFT_KEYWORDS,
	    contains: [
	      QUOTE_STRING_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      BLOCK_COMMENT,
	      TYPE,
	      NUMBERS,
	      {
	        className: 'function',
	        beginKeywords: 'func', end: '{', excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {
	            begin: /[A-Za-z$_][0-9A-Za-z$_]*/,
	            illegal: /\(/
	          }),
	          {
	            begin: /</, end: />/,
	            illegal: />/
	          },
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/, endsParent: true,
	            keywords: SWIFT_KEYWORDS,
	            contains: [
	              'self',
	              NUMBERS,
	              QUOTE_STRING_MODE,
	              hljs.C_BLOCK_COMMENT_MODE,
	              {begin: ':'} // relevance booster
	            ],
	            illegal: /["']/
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        className: 'class',
	        beginKeywords: 'struct protocol class extension enum',
	        keywords: SWIFT_KEYWORDS,
	        end: '\\{',
	        excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/})
	        ]
	      },
	      {
	        className: 'meta', // @attributes
	        begin: '(@warn_unused_result|@exported|@lazy|@noescape|' +
	                  '@NSCopying|@NSManaged|@objc|@convention|@required|' +
	                  '@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|' +
	                  '@infix|@prefix|@postfix|@autoclosure|@testable|@available|' +
	                  '@nonobjc|@NSApplicationMain|@UIApplicationMain)'
	
	      },
	      {
	        beginKeywords: 'import', end: /$/,
	        contains: [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT]
	      }
	    ]
	  };
	};


/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var COMMAND = {
	    className: 'tag',
	    begin: /\\/,
	    relevance: 0,
	    contains: [
	      {
	        className: 'name',
	        variants: [
	          {begin: /[a-zA-Zа-яА-я]+[*]?/},
	          {begin: /[^a-zA-Zа-яА-я0-9]/}
	        ],
	        starts: {
	          endsWithParent: true,
	          relevance: 0,
	          contains: [
	            {
	              className: 'string', // because it looks like attributes in HTML tags
	              variants: [
	                {begin: /\[/, end: /\]/},
	                {begin: /\{/, end: /\}/}
	              ]
	            },
	            {
	              begin: /\s*=\s*/, endsWithParent: true,
	              relevance: 0,
	              contains: [
	                {
	                  className: 'number',
	                  begin: /-?\d*\.?\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?/
	                }
	              ]
	            }
	          ]
	        }
	      }
	    ]
	  };
	
	  return {
	    contains: [
	      COMMAND,
	      {
	        className: 'formula',
	        contains: [COMMAND],
	        relevance: 0,
	        variants: [
	          {begin: /\$\$/, end: /\$\$/},
	          {begin: /\$/, end: /\$/}
	        ]
	      },
	      hljs.COMMENT(
	        '%',
	        '$',
	        {
	          relevance: 0
	        }
	      )
	    ]
	  };
	};


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['vb'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval ' + /* a-b */
	        'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
	        'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
	        'get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue ' + /* g-i */
	        'join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass ' + /* j-m */
	        'namespace narrowing new next not notinheritable notoverridable ' + /* n */
	        'of off on operator option optional or order orelse overloads overridable overrides ' + /* o */
	        'paramarray partial preserve private property protected public ' + /* p */
	        'raiseevent readonly redim rem removehandler resume return ' + /* r */
	        'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
	        'take text then throw to try unicode until using when where while widening with withevents writeonly xor', /* t-x */
	      built_in:
	        'boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype ' +  /* b-c */
	        'date decimal directcast double gettype getxmlnamespace iif integer long object ' + /* d-o */
	        'sbyte short single string trycast typeof uinteger ulong ushort', /* s-u */
	      literal:
	        'true false nothing'
	    },
	    illegal: '//|{|}|endif|gosub|variant|wend', /* reserved deprecated keywords */
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
	      hljs.COMMENT(
	        '\'',
	        '$',
	        {
	          returnBegin: true,
	          contains: [
	            {
	              className: 'doctag',
	              begin: '\'\'\'|<!--|-->',
	              contains: [hljs.PHRASAL_WORDS_MODE]
	            },
	            {
	              className: 'doctag',
	              begin: '</?', end: '>',
	              contains: [hljs.PHRASAL_WORDS_MODE]
	            }
	          ]
	        }
	      ),
	      hljs.C_NUMBER_MODE,
	      {
	        className: 'meta',
	        begin: '#', end: '$',
	        keywords: {'meta-keyword': 'if else elseif end region externalsource'}
	      }
	    ]
	  };
	};


/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['vbs'],
	    case_insensitive: true,
	    keywords: {
	      keyword:
	        'call class const dim do loop erase execute executeglobal exit for each next function ' +
	        'if then else on error option explicit new private property let get public randomize ' +
	        'redim rem select case set stop sub while wend with end to elseif is or xor and not ' +
	        'class_initialize class_terminate default preserve in me byval byref step resume goto',
	      built_in:
	        'lcase month vartype instrrev ubound setlocale getobject rgb getref string ' +
	        'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' +
	        'conversions csng timevalue second year space abs clng timeserial fixs len asc ' +
	        'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' +
	        'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' +
	        'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' +
	        'strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion ' +
	        'scriptengine split scriptengineminorversion cint sin datepart ltrim sqr ' +
	        'scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw ' +
	        'chrw regexp server response request cstr err',
	      literal:
	        'true false null nothing empty'
	    },
	    illegal: '//',
	    contains: [
	      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
	      hljs.COMMENT(
	        /'/,
	        /$/,
	        {
	          relevance: 0
	        }
	      ),
	      hljs.C_NUMBER_MODE
	    ]
	  };
	};


/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  return {
	    aliases: ['v'],
	    case_insensitive: false,
	    keywords: {
	      keyword:
	        'always and assign begin buf bufif0 bufif1 case casex casez cmos deassign ' +
	        'default defparam disable edge else end endcase endfunction endmodule ' +
	        'endprimitive endspecify endtable endtask event for force forever fork ' +
	        'function if ifnone initial inout input join macromodule module nand ' +
	        'negedge nmos nor not notif0 notif1 or output parameter pmos posedge ' +
	        'primitive pulldown pullup rcmos release repeat rnmos rpmos rtran ' +
	        'rtranif0 rtranif1 specify specparam table task timescale tran ' +
	        'tranif0 tranif1 wait while xnor xor ' +
	        // types
	        'highz0 highz1 integer large medium pull0 pull1 real realtime reg ' +
	        'scalared signed small strong0 strong1 supply0 supply0 supply1 supply1 ' +
	        'time tri tri0 tri1 triand trior trireg vectored wand weak0 weak1 wire wor'
	    },
	    contains: [
	      hljs.C_BLOCK_COMMENT_MODE,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.QUOTE_STRING_MODE,
	      {
	        className: 'number',
	        begin: '(\\b((\\d\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F\_]+))|(\\B((\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F\_]+))|(\\b([0-9xzXZ\_])+)',
	        contains: [hljs.BACKSLASH_ESCAPE],
	        relevance: 0
	      },
	      /* parameters to instances */
	      {
	        className: 'variable',
	        begin: '#\\((?!parameter).+\\)'
	      }
	    ]
	  }; // return
	};


/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var XML_IDENT_RE = '[A-Za-z0-9\\._:-]+';
	  var TAG_INTERNALS = {
	    endsWithParent: true,
	    illegal: /</,
	    relevance: 0,
	    contains: [
	      {
	        className: 'attr',
	        begin: XML_IDENT_RE,
	        relevance: 0
	      },
	      {
	        begin: '=',
	        relevance: 0,
	        contains: [
	          {
	            className: 'string',
	            variants: [
	              {begin: /"/, end: /"/},
	              {begin: /'/, end: /'/},
	              {begin: /[^\s\/>]+/}
	            ]
	          }
	        ]
	      }
	    ]
	  };
	  return {
	    aliases: ['html', 'xhtml', 'rss', 'atom', 'xsl', 'plist'],
	    case_insensitive: true,
	    contains: [
	      {
	        className: 'meta',
	        begin: '<!DOCTYPE', end: '>',
	        relevance: 10,
	        contains: [{begin: '\\[', end: '\\]'}]
	      },
	      hljs.COMMENT(
	        '<!--',
	        '-->',
	        {
	          relevance: 10
	        }
	      ),
	      {
	        begin: '<\\!\\[CDATA\\[', end: '\\]\\]>',
	        relevance: 10
	      },
	      {
	        begin: /<\?(php)?/, end: /\?>/,
	        subLanguage: 'php',
	        contains: [{begin: '/\\*', end: '\\*/', skip: true}]
	      },
	      {
	        className: 'tag',
	        /*
	        The lookahead pattern (?=...) ensures that 'begin' only matches
	        '<style' as a single word, followed by a whitespace or an
	        ending braket. The '$' is needed for the lexeme to be recognized
	        by hljs.subMode() that tests lexemes outside the stream.
	        */
	        begin: '<style(?=\\s|>|$)', end: '>',
	        keywords: {name: 'style'},
	        contains: [TAG_INTERNALS],
	        starts: {
	          end: '</style>', returnEnd: true,
	          subLanguage: ['css', 'xml']
	        }
	      },
	      {
	        className: 'tag',
	        // See the comment in the <style tag about the lookahead pattern
	        begin: '<script(?=\\s|>|$)', end: '>',
	        keywords: {name: 'script'},
	        contains: [TAG_INTERNALS],
	        starts: {
	          end: '\<\/script\>', returnEnd: true,
	          subLanguage: ['actionscript', 'javascript', 'handlebars', 'xml']
	        }
	      },
	      {
	        className: 'meta',
	        variants: [
	          {begin: /<\?xml/, end: /\?>/, relevance: 10},
	          {begin: /<\?\w+/, end: /\?>/}
	        ]
	      },
	      {
	        className: 'tag',
	        begin: '</?', end: '/?>',
	        contains: [
	          {
	            className: 'name', begin: /[^\/><\s]+/, relevance: 0
	          },
	          TAG_INTERNALS
	        ]
	      }
	    ]
	  };
	};


/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(hljs) {
	  var LITERALS = {literal: '{ } true false yes no Yes No True False null'};
	
	  var keyPrefix = '^[ \\-]*';
	  var keyName =  '[a-zA-Z_][\\w\\-]*';
	  var KEY = {
	    className: 'attr',
	    variants: [
	      { begin: keyPrefix + keyName + ":"},
	      { begin: keyPrefix + '"' + keyName + '"' + ":"},
	      { begin: keyPrefix + "'" + keyName + "'" + ":"}
	    ]
	  };
	
	  var TEMPLATE_VARIABLES = {
	    className: 'template-variable',
	    variants: [
	      { begin: '\{\{', end: '\}\}' }, // jinja templates Ansible
	      { begin: '%\{', end: '\}' } // Ruby i18n
	    ]
	  };
	  var STRING = {
	    className: 'string',
	    relevance: 0,
	    variants: [
	      {begin: /'/, end: /'/},
	      {begin: /"/, end: /"/}
	    ],
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      TEMPLATE_VARIABLES
	    ]
	  };
	
	  return {
	    case_insensitive: true,
	    aliases: ['yml', 'YAML', 'yaml'],
	    contains: [
	      KEY,
	      {
	        className: 'meta',
	        begin: '^---\s*$',
	        relevance: 10
	      },
	      { // multi line string
	        className: 'string',
	        begin: '[\\|>] *$',
	        returnEnd: true,
	        contains: STRING.contains,
	        // very simple termination: next hash key
	        end: KEY.variants[0].begin
	      },
	      { // Ruby/Rails erb
	        begin: '<%[%=-]?', end: '[%-]?%>',
	        subLanguage: 'ruby',
	        excludeBegin: true,
	        excludeEnd: true,
	        relevance: 0
	      },
	      { // data type
	        className: 'type',
	        begin: '!!' + hljs.UNDERSCORE_IDENT_RE,
	      },
	      { // fragment id &ref
	        className: 'meta',
	        begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$',
	      },
	      { // fragment reference *ref
	        className: 'meta',
	        begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
	      },
	      { // array listing
	        className: 'bullet',
	        begin: '^ *-',
	        relevance: 0
	      },
	      STRING,
	      hljs.HASH_COMMENT_MODE,
	      hljs.C_NUMBER_MODE
	    ],
	    keywords: LITERALS
	  };
	};


/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(151);
	
	var _PathUtils = __webpack_require__(129);
	
	var _ExecutionEnvironment = __webpack_require__(221);
	
	var _DOMUtils = __webpack_require__(294);
	
	var _DOMStateStorage = __webpack_require__(526);
	
	var _createDOMHistory = __webpack_require__(527);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    historyState = historyState || window.history.state || {};
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.e = exports['default'];


/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(151);
	
	var _PathUtils = __webpack_require__(129);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.e = exports['default'];


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(129);
	
	var _Actions = __webpack_require__(151);
	
	var _createHistory = __webpack_require__(529);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.e = exports['default'];


/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}
	


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	var indexOf = [].indexOf;
	
	module.e = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};


/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports = module.e = __webpack_require__(1471)['default'];
	exports['default'] = exports;
	


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	var src$es5$$ = __webpack_require__(1470);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports = module.e = __webpack_require__(1473)['default'];
	exports['default'] = exports;
	


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map


/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(532), src$es5$$ = __webpack_require__(1477), src$compiler$$ = __webpack_require__(1474), intl$messageformat$parser$$ = __webpack_require__(1472);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(532);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map


/***/ },
/* 1478 */
[1768, 1475, 1476],
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(1484)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1764);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.e = IntlRelativeFormat;
	exports['default'] = exports;
	


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(531), src$diff$$ = __webpack_require__(1481), src$es5$$ = __webpack_require__(1483);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map


/***/ },
/* 1484 */
[1768, 1480, 1482],
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.e = keyMirror;
	


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.e = last;
	


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseEach = __webpack_require__(1495),
	    createFind = __webpack_require__(1513);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.e = find;
	


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var cachePush = __webpack_require__(1509),
	    getNative = __webpack_require__(223);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.e = SetCache;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.e = arrayEach;
	


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.e = arrayMap;
	


/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.e = arrayPush;
	


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.e = arraySome;
	


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseMatches = __webpack_require__(1503),
	    baseMatchesProperty = __webpack_require__(1504),
	    bindCallback = __webpack_require__(298),
	    identity = __webpack_require__(548),
	    property = __webpack_require__(1523);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.e = baseCallback;
	


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseIndexOf = __webpack_require__(1500),
	    cacheIndexOf = __webpack_require__(1508),
	    createCache = __webpack_require__(1512);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.e = baseDifference;
	


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseForOwn = __webpack_require__(1499),
	    createBaseEach = __webpack_require__(1510);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.e = baseEach;
	


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.e = baseFind;
	


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.e = baseFindIndex;
	


/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseFor = __webpack_require__(535),
	    keysIn = __webpack_require__(303);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.e = baseForIn;
	


/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseFor = __webpack_require__(535),
	    keys = __webpack_require__(302);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.e = baseForOwn;
	


/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var indexOfNaN = __webpack_require__(1518);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.e = baseIndexOf;
	


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var equalArrays = __webpack_require__(1514),
	    equalByTag = __webpack_require__(1515),
	    equalObjects = __webpack_require__(1516),
	    isArray = __webpack_require__(104),
	    isHostObject = __webpack_require__(540),
	    isTypedArray = __webpack_require__(1521);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.e = baseIsEqualDeep;
	


/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseIsEqual = __webpack_require__(537),
	    toObject = __webpack_require__(87);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.e = baseIsMatch;
	


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseIsMatch = __webpack_require__(1502),
	    getMatchData = __webpack_require__(1517),
	    toObject = __webpack_require__(87);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      object = toObject(object);
	      return object[key] === value && (value !== undefined || (key in object));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.e = baseMatches;
	


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseGet = __webpack_require__(536),
	    baseIsEqual = __webpack_require__(537),
	    baseSlice = __webpack_require__(1506),
	    isArray = __webpack_require__(104),
	    isKey = __webpack_require__(542),
	    isStrictComparable = __webpack_require__(543),
	    last = __webpack_require__(1486),
	    toObject = __webpack_require__(87),
	    toPath = __webpack_require__(546);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.e = baseMatchesProperty;
	


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseGet = __webpack_require__(536),
	    toPath = __webpack_require__(546);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.e = basePropertyDeep;
	


/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.e = baseSlice;
	


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.e = baseToString;
	


/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(105);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.e = cacheIndexOf;
	


/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isObject = __webpack_require__(105);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.e = cachePush;
	


/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var getLength = __webpack_require__(539),
	    isLength = __webpack_require__(152),
	    toObject = __webpack_require__(87);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.e = createBaseEach;
	


/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var toObject = __webpack_require__(87);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.e = createBaseFor;
	


/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var SetCache = __webpack_require__(1488),
	    getNative = __webpack_require__(223);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.e = createCache;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseCallback = __webpack_require__(1493),
	    baseFind = __webpack_require__(1496),
	    baseFindIndex = __webpack_require__(1497),
	    isArray = __webpack_require__(104);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.e = createFind;
	


/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var arraySome = __webpack_require__(1492);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.e = equalArrays;
	


/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.e = equalByTag;
	


/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var keys = __webpack_require__(302);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.e = equalObjects;
	


/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isStrictComparable = __webpack_require__(543),
	    pairs = __webpack_require__(1522);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.e = getMatchData;
	


/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.e = indexOfNaN;
	


/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isArguments = __webpack_require__(300),
	    isArray = __webpack_require__(104),
	    isIndex = __webpack_require__(541),
	    isLength = __webpack_require__(152),
	    isString = __webpack_require__(301),
	    keysIn = __webpack_require__(303);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object) || isString(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.e = shimKeys;
	


/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isFunction = __webpack_require__(547),
	    isHostObject = __webpack_require__(540),
	    isObjectLike = __webpack_require__(130);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	}
	
	module.e = isNative;
	


/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var isLength = __webpack_require__(152),
	    isObjectLike = __webpack_require__(130);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.e = isTypedArray;
	


/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var keys = __webpack_require__(302),
	    toObject = __webpack_require__(87);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.e = pairs;
	


/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var baseProperty = __webpack_require__(538),
	    basePropertyDeep = __webpack_require__(1505),
	    isKey = __webpack_require__(542);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.e = property;
	


/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 */
	
	;(function() {
	
	/**
	 * Block-Level Grammar
	 */
	
	var block = {
	  newline: /^\n+/,
	  code: /^( {4}[^\n]+\n*)+/,
	  fences: noop,
	  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
	  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	  nptable: noop,
	  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
	  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
	  table: noop,
	  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
	  text: /^[^\n]+/
	};
	
	block.bullet = /(?:[*+-]|\d+\.)/;
	block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	block.item = replace(block.item, 'gm')
	  (/bull/g, block.bullet)
	  ();
	
	block.list = replace(block.list)
	  (/bull/g, block.bullet)
	  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
	  ('def', '\\n+(?=' + block.def.source + ')')
	  ();
	
	block.blockquote = replace(block.blockquote)
	  ('def', block.def)
	  ();
	
	block._tag = '(?!(?:'
	  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
	  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
	  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';
	
	block.html = replace(block.html)
	  ('comment', /<!--[\s\S]*?-->/)
	  ('closed', /<(tag)[\s\S]+?<\/\1>/)
	  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
	  (/tag/g, block._tag)
	  ();
	
	block.paragraph = replace(block.paragraph)
	  ('hr', block.hr)
	  ('heading', block.heading)
	  ('lheading', block.lheading)
	  ('blockquote', block.blockquote)
	  ('tag', '<' + block._tag)
	  ('def', block.def)
	  ();
	
	/**
	 * Normal Block Grammar
	 */
	
	block.normal = merge({}, block);
	
	/**
	 * GFM Block Grammar
	 */
	
	block.gfm = merge({}, block.normal, {
	  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
	  paragraph: /^/,
	  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	});
	
	block.gfm.paragraph = replace(block.paragraph)
	  ('(?!', '(?!'
	    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
	    + block.list.source.replace('\\1', '\\3') + '|')
	  ();
	
	/**
	 * GFM + Tables Block Grammar
	 */
	
	block.tables = merge({}, block.gfm, {
	  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	});
	
	/**
	 * Block Lexer
	 */
	
	function Lexer(options) {
	  this.tokens = [];
	  this.tokens.links = {};
	  this.options = options || marked.defaults;
	  this.rules = block.normal;
	
	  if (this.options.gfm) {
	    if (this.options.tables) {
	      this.rules = block.tables;
	    } else {
	      this.rules = block.gfm;
	    }
	  }
	}
	
	/**
	 * Expose Block Rules
	 */
	
	Lexer.rules = block;
	
	/**
	 * Static Lex Method
	 */
	
	Lexer.lex = function(src, options) {
	  var lexer = new Lexer(options);
	  return lexer.lex(src);
	};
	
	/**
	 * Preprocessing
	 */
	
	Lexer.prototype.lex = function(src) {
	  src = src
	    .replace(/\r\n|\r/g, '\n')
	    .replace(/\t/g, '    ')
	    .replace(/\u00a0/g, ' ')
	    .replace(/\u2424/g, '\n');
	
	  return this.token(src, true);
	};
	
	/**
	 * Lexing
	 */
	
	Lexer.prototype.token = function(src, top, bq) {
	  var src = src.replace(/^ +$/gm, '')
	    , next
	    , loose
	    , cap
	    , bull
	    , b
	    , item
	    , space
	    , i
	    , l;
	
	  while (src) {
	    // newline
	    if (cap = this.rules.newline.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[0].length > 1) {
	        this.tokens.push({
	          type: 'space'
	        });
	      }
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      cap = cap[0].replace(/^ {4}/gm, '');
	      this.tokens.push({
	        type: 'code',
	        text: !this.options.pedantic
	          ? cap.replace(/\n+$/, '')
	          : cap
	      });
	      continue;
	    }
	
	    // fences (gfm)
	    if (cap = this.rules.fences.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'code',
	        lang: cap[2],
	        text: cap[3] || ''
	      });
	      continue;
	    }
	
	    // heading
	    if (cap = this.rules.heading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[1].length,
	        text: cap[2]
	      });
	      continue;
	    }
	
	    // table no leading pipe (gfm)
	    if (top && (cap = this.rules.nptable.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i].split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // lheading
	    if (cap = this.rules.lheading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[2] === '=' ? 1 : 2,
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // hr
	    if (cap = this.rules.hr.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'hr'
	      });
	      continue;
	    }
	
	    // blockquote
	    if (cap = this.rules.blockquote.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      this.tokens.push({
	        type: 'blockquote_start'
	      });
	
	      cap = cap[0].replace(/^ *> ?/gm, '');
	
	      // Pass `top` to keep the current
	      // "toplevel" state. This is exactly
	      // how markdown.pl works.
	      this.token(cap, top, true);
	
	      this.tokens.push({
	        type: 'blockquote_end'
	      });
	
	      continue;
	    }
	
	    // list
	    if (cap = this.rules.list.exec(src)) {
	      src = src.substring(cap[0].length);
	      bull = cap[2];
	
	      this.tokens.push({
	        type: 'list_start',
	        ordered: bull.length > 1
	      });
	
	      // Get each top-level item.
	      cap = cap[0].match(this.rules.item);
	
	      next = false;
	      l = cap.length;
	      i = 0;
	
	      for (; i < l; i++) {
	        item = cap[i];
	
	        // Remove the list item's bullet
	        // so it is seen as the next token.
	        space = item.length;
	        item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	        // Outdent whatever the
	        // list item contains. Hacky.
	        if (~item.indexOf('\n ')) {
	          space -= item.length;
	          item = !this.options.pedantic
	            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
	            : item.replace(/^ {1,4}/gm, '');
	        }
	
	        // Determine whether the next list item belongs here.
	        // Backpedal if it does not belong in this list.
	        if (this.options.smartLists && i !== l - 1) {
	          b = block.bullet.exec(cap[i + 1])[0];
	          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	            src = cap.slice(i + 1).join('\n') + src;
	            i = l - 1;
	          }
	        }
	
	        // Determine whether item is loose or not.
	        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	        // for discount behavior.
	        loose = next || /\n\n(?!\s*$)/.test(item);
	        if (i !== l - 1) {
	          next = item.charAt(item.length - 1) === '\n';
	          if (!loose) loose = next;
	        }
	
	        this.tokens.push({
	          type: loose
	            ? 'loose_item_start'
	            : 'list_item_start'
	        });
	
	        // Recurse.
	        this.token(item, false, bq);
	
	        this.tokens.push({
	          type: 'list_item_end'
	        });
	      }
	
	      this.tokens.push({
	        type: 'list_end'
	      });
	
	      continue;
	    }
	
	    // html
	    if (cap = this.rules.html.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: this.options.sanitize
	          ? 'paragraph'
	          : 'html',
	        pre: !this.options.sanitizer
	          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	        text: cap[0]
	      });
	      continue;
	    }
	
	    // def
	    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.links[cap[1].toLowerCase()] = {
	        href: cap[2],
	        title: cap[3]
	      };
	      continue;
	    }
	
	    // table (gfm)
	    if (top && (cap = this.rules.table.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i]
	          .replace(/^ *\| *| *\| *$/g, '')
	          .split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // top-level paragraph
	    if (top && (cap = this.rules.paragraph.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'paragraph',
	        text: cap[1].charAt(cap[1].length - 1) === '\n'
	          ? cap[1].slice(0, -1)
	          : cap[1]
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      // Top-level should never reach here.
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'text',
	        text: cap[0]
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new
	        Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return this.tokens;
	};
	
	/**
	 * Inline-Level Grammar
	 */
	
	var inline = {
	  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	  autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
	  url: noop,
	  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
	  link: /^!?\[(inside)\]\(href\)/,
	  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
	  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
	  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
	  br: /^ {2,}\n(?!\s*$)/,
	  del: noop,
	  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
	};
	
	inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
	inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	inline.link = replace(inline.link)
	  ('inside', inline._inside)
	  ('href', inline._href)
	  ();
	
	inline.reflink = replace(inline.reflink)
	  ('inside', inline._inside)
	  ();
	
	/**
	 * Normal Inline Grammar
	 */
	
	inline.normal = merge({}, inline);
	
	/**
	 * Pedantic Inline Grammar
	 */
	
	inline.pedantic = merge({}, inline.normal, {
	  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	});
	
	/**
	 * GFM Inline Grammar
	 */
	
	inline.gfm = merge({}, inline.normal, {
	  escape: replace(inline.escape)('])', '~|])')(),
	  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
	  del: /^~~(?=\S)([\s\S]*?\S)~~/,
	  text: replace(inline.text)
	    (']|', '~]|')
	    ('|', '|https?://|')
	    ()
	});
	
	/**
	 * GFM + Line Breaks Inline Grammar
	 */
	
	inline.breaks = merge({}, inline.gfm, {
	  br: replace(inline.br)('{2,}', '*')(),
	  text: replace(inline.gfm.text)('{2,}', '*')()
	});
	
	/**
	 * Inline Lexer & Compiler
	 */
	
	function InlineLexer(links, options) {
	  this.options = options || marked.defaults;
	  this.links = links;
	  this.rules = inline.normal;
	  this.renderer = this.options.renderer || new Renderer;
	  this.renderer.options = this.options;
	
	  if (!this.links) {
	    throw new
	      Error('Tokens array requires a `links` property.');
	  }
	
	  if (this.options.gfm) {
	    if (this.options.breaks) {
	      this.rules = inline.breaks;
	    } else {
	      this.rules = inline.gfm;
	    }
	  } else if (this.options.pedantic) {
	    this.rules = inline.pedantic;
	  }
	}
	
	/**
	 * Expose Inline Rules
	 */
	
	InlineLexer.rules = inline;
	
	/**
	 * Static Lexing/Compiling Method
	 */
	
	InlineLexer.output = function(src, links, options) {
	  var inline = new InlineLexer(links, options);
	  return inline.output(src);
	};
	
	/**
	 * Lexing/Compiling
	 */
	
	InlineLexer.prototype.output = function(src) {
	  var link
	    , text
	    , href
	    , cap
	    , tokens = [];
	
	  while (src) {
	    // escape
	    if (cap = this.rules.escape.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      tokens.push({
	        type: 'text',
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // autolink
	    if (cap = this.rules.autolink.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = cap[1].charAt(6) === ':'
	          ? this.mangle(cap[1].substring(7))
	          : this.mangle(cap[1]);
	        href = this.mangle('mailto:') + text;
	      } else {
	        text = escape(cap[1]);
	        href = text;
	      }
	
	      tokens.push({
	        type: 'link',
	        text: text,
	        title: null,
	        href: href
	      });
	      continue;
	    }
	
	    // url (gfm)
	    if (!this.inLink && (cap = this.rules.url.exec(src))) {
	      src = src.substring(cap[0].length);
	      text = escape(cap[1]);
	      href = text;
	
	      tokens.push({
	        type: 'link',
	        text: text,
	        title: null,
	        href: href
	      });
	      continue;
	    }
	
	    // tag
	    if (cap = this.rules.tag.exec(src)) {
	      if (!this.inLink && /^<a /i.test(cap[0])) {
	        this.inLink = true;
	      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	        this.inLink = false;
	      }
	      src = src.substring(cap[0].length);
	
	      if (this.options.sanitize) {
	        if (this.options.sanitizer) {
	          tokens.push({
	            type: 'text',
	            text: this.options.sanitizer(cap[0])
	          });
	        } else {
	          tokens.push({
	            type: 'text',
	            text: escape(cap[0])
	          });
	        }
	      } else {
	        tokens.push({
	          type: 'text',
	          text: cap[0]
	        });
	      }
	      continue;
	    }
	
	    // link
	    if (cap = this.rules.link.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.inLink = true;
	      tokens.push({
	        type: 'preformatted',
	        text: this.outputLink(cap, {
	          href: cap[2],
	          title: cap[3]
	        })
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // reflink, nolink
	    if ((cap = this.rules.reflink.exec(src))
	        || (cap = this.rules.nolink.exec(src))) {
	      src = src.substring(cap[0].length);
	      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	      link = this.links[link.toLowerCase()];
	      if (!link || !link.href) {
	        tokens.push({
	          type: 'text',
	          text: cap[0].charAt(0)
	        });
	        src = cap[0].substring(1) + src;
	        continue;
	      }
	      this.inLink = true;
	      tokens.push({
	        type: 'preformatted',
	        text: this.outputLink(cap, link)
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // strong
	    if (cap = this.rules.strong.exec(src)) {
	      src = src.substring(cap[0].length);
	      tokens.push({
	        type: 'strong',
	        text: this.output(cap[2] || cap[1])
	      });
	      continue;
	    }
	
	    // em
	    if (cap = this.rules.em.exec(src)) {
	      src = src.substring(cap[0].length);
	      tokens.push({
	        type: 'em',
	        text: this.output(cap[2] || cap[1])
	      });
	      continue;
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      tokens.push({
	        type: 'code',
	        text: escape(cap[2], true)
	      });
	      continue;
	    }
	
	    // br
	    if (cap = this.rules.br.exec(src)) {
	      src = src.substring(cap[0].length);
	      tokens.push({
	        type: 'br'
	      });
	      continue;
	    }
	
	    // del (gfm)
	    if (cap = this.rules.del.exec(src)) {
	      src = src.substring(cap[0].length);
	      tokens.push({
	        type: 'del',
	        text: this.output(cap[1])
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      src = src.substring(cap[0].length);
	      tokens.push({
	        type: 'text',
	        text: escape(this.smartypants(cap[0]))
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new
	        Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  // combine adjacent text tokens into one
	  tokens = tokens.reduce(function(arr, token) {
	    if (arr.length > 0) {
	      var prevToken = arr[arr.length - 1];
	
	      if (prevToken.type === 'text' && token.type === 'text') {
	        prevToken.text += token.text;
	      } else {
	        arr.push(token);
	      }
	
	      return arr;
	    } else {
	      return [token];
	    }
	  }, []);
	
	  return this.renderTokens(tokens);
	};
	
	InlineLexer.prototype.renderTokens = function(tokens) {
	  var out = '';
	
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    switch(token.type) {
	      case 'text':
	        out += this.renderer.text(token.text);
	        break;
	      case 'link':
	        out += this.renderer.link(token.href, token.title, token.text);
	        break;
	      case 'preformatted':
	        out += token.text;
	        break;
	      case 'strong':
	        out += this.renderer.strong(token.text);
	        break;
	      case 'em':
	        out += this.renderer.em(token.text);
	        break;
	      case 'code':
	        out += this.renderer.codespan(token.text);
	        break;
	      case 'br':
	        out += this.renderer.br();
	        break;
	      case 'del':
	        out += this.renderer.del(token.text);
	        break;
	      default:
	        console.log('unrecognized inline token type ' + token.type);
	    }
	  }
	
	  return out;
	};
	
	/**
	 * Compile Link
	 */
	
	InlineLexer.prototype.outputLink = function(cap, link) {
	  var href = escape(link.href)
	    , title = link.title ? escape(link.title) : null;
	
	  return cap[0].charAt(0) !== '!'
	    ? this.renderer.link(href, title, this.output(cap[1]))
	    : this.renderer.image(href, title, escape(cap[1]));
	};
	
	/**
	 * Smartypants Transformations
	 */
	
	InlineLexer.prototype.smartypants = function(text) {
	  if (!this.options.smartypants) return text;
	  return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
	    // closing doubles
	    .replace(/"/g, '\u201d')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	};
	
	/**
	 * Mangle Links
	 */
	
	InlineLexer.prototype.mangle = function(text) {
	  if (!this.options.mangle) return text;
	  var out = ''
	    , l = text.length
	    , i = 0
	    , ch;
	
	  for (; i < l; i++) {
	    ch = text.charCodeAt(i);
	    if (Math.random() > 0.5) {
	      ch = 'x' + ch.toString(16);
	    }
	    out += '&#' + ch + ';';
	  }
	
	  return out;
	};
	
	/**
	 * Renderer
	 */
	
	function Renderer(options) {
	  this.options = options || {};
	}
	
	Renderer.prototype.code = function(code, lang, escaped) {
	  if (this.options.highlight) {
	    var out = this.options.highlight(code, lang);
	    if (out != null && out !== code) {
	      escaped = true;
	      code = out;
	    }
	  }
	
	  if (!lang) {
	    return '<pre><code>'
	      + (escaped ? code : escape(code, true))
	      + '\n</code></pre>';
	  }
	
	  return '<pre><code class="'
	    + this.options.langPrefix
	    + escape(lang, true)
	    + '">'
	    + (escaped ? code : escape(code, true))
	    + '\n</code></pre>\n';
	};
	
	Renderer.prototype.blockquote = function(quote) {
	  return '<blockquote>\n' + quote + '</blockquote>\n';
	};
	
	Renderer.prototype.html = function(html) {
	  return html;
	};
	
	Renderer.prototype.heading = function(text, level, raw) {
	  return '<h'
	    + level
	    + ' id="'
	    + this.options.headerPrefix
	    + raw.toLowerCase().replace(/[^\w]+/g, '-')
	    + '">'
	    + text
	    + '</h'
	    + level
	    + '>\n';
	};
	
	Renderer.prototype.hr = function() {
	  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	};
	
	Renderer.prototype.list = function(body, ordered) {
	  var type = ordered ? 'ol' : 'ul';
	  return '<' + type + '>\n' + body + '</' + type + '>\n';
	};
	
	Renderer.prototype.listitem = function(text) {
	  return '<li>' + text + '</li>\n';
	};
	
	Renderer.prototype.paragraph = function(text) {
	  return '<p>' + text + '</p>\n';
	};
	
	Renderer.prototype.table = function(header, body) {
	  return '<table>\n'
	    + '<thead>\n'
	    + header
	    + '</thead>\n'
	    + '<tbody>\n'
	    + body
	    + '</tbody>\n'
	    + '</table>\n';
	};
	
	Renderer.prototype.tablerow = function(content) {
	  return '<tr>\n' + content + '</tr>\n';
	};
	
	Renderer.prototype.tablecell = function(content, flags) {
	  var type = flags.header ? 'th' : 'td';
	  var tag = flags.align
	    ? '<' + type + ' style="text-align:' + flags.align + '">'
	    : '<' + type + '>';
	  return tag + content + '</' + type + '>\n';
	};
	
	// span level renderer
	Renderer.prototype.strong = function(text) {
	  return '<strong>' + text + '</strong>';
	};
	
	Renderer.prototype.em = function(text) {
	  return '<em>' + text + '</em>';
	};
	
	Renderer.prototype.codespan = function(text) {
	  return '<code>' + text + '</code>';
	};
	
	Renderer.prototype.br = function() {
	  return this.options.xhtml ? '<br/>' : '<br>';
	};
	
	Renderer.prototype.del = function(text) {
	  return '<del>' + text + '</del>';
	};
	
	Renderer.prototype.link = function(href, title, text) {
	  if (this.options.sanitize) {
	    try {
	      var prot = decodeURIComponent(unescape(href))
	        .replace(/[^\w:]/g, '')
	        .toLowerCase();
	    } catch (e) {
	      return '';
	    }
	    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
	      return '';
	    }
	  }
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	Renderer.prototype.image = function(href, title, text) {
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	Renderer.prototype.text = function(text) {
	  return text;
	};
	
	/**
	 * Parsing & Compiling
	 */
	
	function Parser(options) {
	  this.tokens = [];
	  this.token = null;
	  this.options = options || marked.defaults;
	  this.options.renderer = this.options.renderer || new Renderer;
	  this.renderer = this.options.renderer;
	  this.renderer.options = this.options;
	}
	
	/**
	 * Static Parse Method
	 */
	
	Parser.parse = function(src, options, renderer) {
	  var parser = new Parser(options, renderer);
	  return parser.parse(src);
	};
	
	/**
	 * Parse Loop
	 */
	
	Parser.prototype.parse = function(src) {
	  this.inline = new InlineLexer(src.links, this.options, this.renderer);
	  this.tokens = src.reverse();
	
	  var out = '';
	  while (this.next()) {
	    out += this.tok();
	  }
	
	  return out;
	};
	
	/**
	 * Next Token
	 */
	
	Parser.prototype.next = function() {
	  return this.token = this.tokens.pop();
	};
	
	/**
	 * Preview Next Token
	 */
	
	Parser.prototype.peek = function() {
	  return this.tokens[this.tokens.length - 1] || 0;
	};
	
	/**
	 * Parse Text Tokens
	 */
	
	Parser.prototype.parseText = function() {
	  var body = this.token.text;
	
	  while (this.peek().type === 'text') {
	    body += '\n' + this.next().text;
	  }
	
	  return this.inline.output(body);
	};
	
	/**
	 * Parse Current Token
	 */
	
	Parser.prototype.tok = function() {
	  switch (this.token.type) {
	    case 'space': {
	      return '';
	    }
	    case 'hr': {
	      return this.renderer.hr();
	    }
	    case 'heading': {
	      return this.renderer.heading(
	        this.inline.output(this.token.text),
	        this.token.depth,
	        this.token.text);
	    }
	    case 'code': {
	      return this.renderer.code(this.token.text,
	        this.token.lang,
	        this.token.escaped);
	    }
	    case 'table': {
	      var header = ''
	        , body = ''
	        , i
	        , row
	        , cell
	        , flags
	        , j;
	
	      // header
	      cell = '';
	      for (i = 0; i < this.token.header.length; i++) {
	        flags = { header: true, align: this.token.align[i] };
	        cell += this.renderer.tablecell(
	          this.inline.output(this.token.header[i]),
	          { header: true, align: this.token.align[i] }
	        );
	      }
	      header += this.renderer.tablerow(cell);
	
	      for (i = 0; i < this.token.cells.length; i++) {
	        row = this.token.cells[i];
	
	        cell = '';
	        for (j = 0; j < row.length; j++) {
	          cell += this.renderer.tablecell(
	            this.inline.output(row[j]),
	            { header: false, align: this.token.align[j] }
	          );
	        }
	
	        body += this.renderer.tablerow(cell);
	      }
	      return this.renderer.table(header, body);
	    }
	    case 'blockquote_start': {
	      var body = '';
	
	      while (this.next().type !== 'blockquote_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.blockquote(body);
	    }
	    case 'list_start': {
	      var body = ''
	        , ordered = this.token.ordered;
	
	      while (this.next().type !== 'list_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.list(body, ordered);
	    }
	    case 'list_item_start': {
	      var body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.token.type === 'text'
	          ? this.parseText()
	          : this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'loose_item_start': {
	      var body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'html': {
	      var html = !this.token.pre && !this.options.pedantic
	        ? this.inline.output(this.token.text)
	        : this.token.text;
	      return this.renderer.html(html);
	    }
	    case 'paragraph': {
	      return this.renderer.paragraph(this.inline.output(this.token.text));
	    }
	    case 'text': {
	      return this.renderer.paragraph(this.parseText());
	    }
	  }
	};
	
	/**
	 * Helpers
	 */
	
	function escape(html, encode) {
	  return html
	    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#39;');
	}
	
	function unescape(html) {
	  return html.replace(/&([#\w]+);/g, function(_, n) {
	    n = n.toLowerCase();
	    if (n === 'colon') return ':';
	    if (n.charAt(0) === '#') {
	      return n.charAt(1) === 'x'
	        ? String.fromCharCode(parseInt(n.substring(2), 16))
	        : String.fromCharCode(+n.substring(1));
	    }
	    return '';
	  });
	}
	
	function replace(regex, opt) {
	  regex = regex.source;
	  opt = opt || '';
	  return function self(name, val) {
	    if (!name) return new RegExp(regex, opt);
	    val = val.source || val;
	    val = val.replace(/(^|[^\[])\^/g, '$1');
	    regex = regex.replace(name, val);
	    return self;
	  };
	}
	
	function noop() {}
	noop.exec = noop;
	
	function merge(obj) {
	  var i = 1
	    , target
	    , key;
	
	  for (; i < arguments.length; i++) {
	    target = arguments[i];
	    for (key in target) {
	      if (Object.prototype.hasOwnProperty.call(target, key)) {
	        obj[key] = target[key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	
	/**
	 * Marked
	 */
	
	function marked(src, opt, callback) {
	  if (callback || typeof opt === 'function') {
	    if (!callback) {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	
	    var highlight = opt.highlight
	      , tokens
	      , pending
	      , i = 0;
	
	    try {
	      tokens = Lexer.lex(src, opt)
	    } catch (e) {
	      return callback(e);
	    }
	
	    pending = tokens.length;
	
	    var done = function(err) {
	      if (err) {
	        opt.highlight = highlight;
	        return callback(err);
	      }
	
	      var out;
	
	      try {
	        out = Parser.parse(tokens, opt);
	      } catch (e) {
	        err = e;
	      }
	
	      opt.highlight = highlight;
	
	      return err
	        ? callback(err)
	        : callback(null, out);
	    };
	
	    if (!highlight || highlight.length < 3) {
	      return done();
	    }
	
	    delete opt.highlight;
	
	    if (!pending) return done();
	
	    for (; i < tokens.length; i++) {
	      (function(token) {
	        if (token.type !== 'code') {
	          return --pending || done();
	        }
	        return highlight(token.text, token.lang, function(err, code) {
	          if (err) return done(err);
	          if (code == null || code === token.text) {
	            return --pending || done();
	          }
	          token.text = code;
	          token.escaped = true;
	          --pending || done();
	        });
	      })(tokens[i]);
	    }
	
	    return;
	  }
	  try {
	    if (opt) opt = merge({}, marked.defaults, opt);
	    return Parser.parse(Lexer.lex(src, opt), opt);
	  } catch (e) {
	    e.message += '\nPlease report this to https://github.com/chjj/marked.';
	    if ((opt || marked.defaults).silent) {
	      return '<p>An error occured:</p><pre>'
	        + escape(e.message + '', true)
	        + '</pre>';
	    }
	    throw e;
	  }
	}
	
	/**
	 * Options
	 */
	
	marked.options =
	marked.setOptions = function(opt) {
	  merge(marked.defaults, opt);
	  return marked;
	};
	
	marked.defaults = {
	  gfm: true,
	  tables: true,
	  breaks: false,
	  pedantic: false,
	  sanitize: false,
	  sanitizer: null,
	  mangle: true,
	  smartLists: false,
	  silent: false,
	  highlight: null,
	  langPrefix: 'lang-',
	  smartypants: false,
	  headerPrefix: '',
	  renderer: new Renderer,
	  xhtml: false
	};
	
	/**
	 * Expose
	 */
	
	marked.Parser = Parser;
	marked.parser = Parser.parse;
	
	marked.Renderer = Renderer;
	
	marked.Lexer = Lexer;
	marked.lexer = Lexer.lex;
	
	marked.InlineLexer = InlineLexer;
	marked.inlineLexer = InlineLexer.output;
	
	marked.parse = marked;
	
	if (true) {
	  module.e = marked;
	} else if (typeof define === 'function' && define.amd) {
	  define(function() { return marked; });
	} else {
	  this.marked = marked;
	}
	
	}).call(function() {
	  return this || (typeof window !== 'undefined' ? window : global);
	}());
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/** @flow */
	
	"use strict";
	
	function getRelocatable(re) {
	  // In the future, this could use a WeakMap instead of an expando.
	  if (!re.__matchAtRelocatable) {
	    // Disjunctions are the lowest-precedence operator, so we can make any
	    // pattern match the empty string by appending `|()` to it:
	    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-patterns
	    var source = re.source + "|()";
	
	    // We always make the new regex global.
	    var flags = "g" + (re.ignoreCase ? "i" : "") + (re.multiline ? "m" : "") + (re.unicode ? "u" : "")
	    // sticky (/.../y) doesn't make sense in conjunction with our relocation
	    // logic, so we ignore it here.
	    ;
	
	    re.__matchAtRelocatable = new RegExp(source, flags);
	  }
	  return re.__matchAtRelocatable;
	}
	
	function matchAt(re, str, pos) {
	  if (re.global || re.sticky) {
	    throw new Error("matchAt(...): Only non-global regexes are supported");
	  }
	  var reloc = getRelocatable(re);
	  reloc.lastIndex = pos;
	  var match = reloc.exec(str);
	  // Last capturing group is our sentinel that indicates whether the regex
	  // matched at the given location.
	  if (match[match.length - 1] == null) {
	    // Original regex matched.
	    match.length = match.length - 1;
	    return match;
	  } else {
	    return null;
	  }
	}
	
	module.e = matchAt;


/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
	// Fedor, you are amazing.
	
	var asn1 = __webpack_require__(192)
	
	var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('modulus').int(),
	    this.key('publicExponent').int(),
	    this.key('privateExponent').int(),
	    this.key('prime1').int(),
	    this.key('prime2').int(),
	    this.key('exponent1').int(),
	    this.key('exponent2').int(),
	    this.key('coefficient').int()
	  )
	})
	exports.RSAPrivateKey = RSAPrivateKey
	
	var RSAPublicKey = asn1.define('RSAPublicKey', function () {
	  this.seq().obj(
	    this.key('modulus').int(),
	    this.key('publicExponent').int()
	  )
	})
	exports.RSAPublicKey = RSAPublicKey
	
	var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
	  this.seq().obj(
	    this.key('algorithm').use(AlgorithmIdentifier),
	    this.key('subjectPublicKey').bitstr()
	  )
	})
	exports.PublicKey = PublicKey
	
	var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
	  this.seq().obj(
	    this.key('algorithm').objid(),
	    this.key('none').null_().optional(),
	    this.key('curve').objid().optional(),
	    this.key('params').seq().obj(
	      this.key('p').int(),
	      this.key('q').int(),
	      this.key('g').int()
	    ).optional()
	  )
	})
	
	var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('algorithm').use(AlgorithmIdentifier),
	    this.key('subjectPrivateKey').octstr()
	  )
	})
	exports.PrivateKey = PrivateKeyInfo
	var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
	  this.seq().obj(
	    this.key('algorithm').seq().obj(
	      this.key('id').objid(),
	      this.key('decrypt').seq().obj(
	        this.key('kde').seq().obj(
	          this.key('id').objid(),
	          this.key('kdeparams').seq().obj(
	            this.key('salt').octstr(),
	            this.key('iters').int()
	          )
	        ),
	        this.key('cipher').seq().obj(
	          this.key('algo').objid(),
	          this.key('iv').octstr()
	        )
	      )
	    ),
	    this.key('subjectPrivateKey').octstr()
	  )
	})
	
	exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo
	
	var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('p').int(),
	    this.key('q').int(),
	    this.key('g').int(),
	    this.key('pub_key').int(),
	    this.key('priv_key').int()
	  )
	})
	exports.DSAPrivateKey = DSAPrivateKey
	
	exports.DSAparam = asn1.define('DSAparam', function () {
	  this.int()
	})
	var ECPrivateKey = asn1.define('ECPrivateKey', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('privateKey').octstr(),
	    this.key('parameters').optional().explicit(0).use(ECParameters),
	    this.key('publicKey').optional().explicit(1).bitstr()
	  )
	})
	exports.ECPrivateKey = ECPrivateKey
	var ECParameters = asn1.define('ECParameters', function () {
	  this.choice({
	    namedCurve: this.objid()
	  })
	})
	
	exports.signature = asn1.define('signature', function () {
	  this.seq().obj(
	    this.key('r').int(),
	    this.key('s').int()
	  )
	})
	


/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// adapted from https://github.com/apatil/pemstrip
	var findProc = /Proc-Type: 4,ENCRYPTED\r?\nDEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\r?\n\r?\n([0-9A-z\n\r\+\/\=]+)\r?\n/m
	var startRegex = /^-----BEGIN (.*) KEY-----\r?\n/m
	var fullRegex = /^-----BEGIN (.*) KEY-----\r?\n([0-9A-z\n\r\+\/\=]+)\r?\n-----END \1 KEY-----$/m
	var evp = __webpack_require__(220)
	var ciphers = __webpack_require__(279)
	module.e = function (okey, password) {
	  var key = okey.toString()
	  var match = key.match(findProc)
	  var decrypted
	  if (!match) {
	    var match2 = key.match(fullRegex)
	    decrypted = new Buffer(match2[2].replace(/\r?\n/g, ''), 'base64')
	  } else {
	    var suite = 'aes' + match[1]
	    var iv = new Buffer(match[2], 'hex')
	    var cipherText = new Buffer(match[3].replace(/\r?\n/g, ''), 'base64')
	    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
	    var out = []
	    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
	    out.push(cipher.update(cipherText))
	    out.push(cipher.final())
	    decrypted = Buffer.concat(out)
	  }
	  var tag = key.match(startRegex)[1] + ' KEY'
	  return {
	    tag: tag,
	    data: decrypted
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = __webpack_require__(1529);
	


/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var ps = __webpack_require__(1532)
	  , psInstances = __webpack_require__(66);
	
	function mountJQuery(jQuery) {
	  jQuery.fn.perfectScrollbar = function (settingOrCommand) {
	    return this.each(function () {
	      if (typeof settingOrCommand === 'object' ||
	          typeof settingOrCommand === 'undefined') {
	        // If it's an object or none, initialize.
	        var settings = settingOrCommand;
	
	        if (!psInstances.get(this)) {
	          ps.initialize(this, settings);
	        }
	      } else {
	        // Unless, it may be a command.
	        var command = settingOrCommand;
	
	        if (command === 'update') {
	          ps.update(this);
	        } else if (command === 'destroy') {
	          ps.destroy(this);
	        }
	      }
	
	      return jQuery(this);
	    });
	  };
	}
	
	if (true) {
	  // AMD. Register as an anonymous module.
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mountJQuery), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.e = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	  var jq = window.jQuery ? window.jQuery : window.$;
	  if (typeof jq !== 'undefined') {
	    mountJQuery(jq);
	  }
	}
	
	module.e = mountJQuery;
	


/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var EventElement = function (element) {
	  this.element = element;
	  this.events = {};
	};
	
	EventElement.prototype.bind = function (eventName, handler) {
	  if (typeof this.events[eventName] === 'undefined') {
	    this.events[eventName] = [];
	  }
	  this.events[eventName].push(handler);
	  this.element.addEventListener(eventName, handler, false);
	};
	
	EventElement.prototype.unbind = function (eventName, handler) {
	  var isHandlerProvided = (typeof handler !== 'undefined');
	  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
	    if (isHandlerProvided && hdlr !== handler) {
	      return true;
	    }
	    this.element.removeEventListener(eventName, hdlr, false);
	    return false;
	  }, this);
	};
	
	EventElement.prototype.unbindAll = function () {
	  for (var name in this.events) {
	    this.unbind(name);
	  }
	};
	
	var EventManager = function () {
	  this.eventElements = [];
	};
	
	EventManager.prototype.eventElement = function (element) {
	  var ee = this.eventElements.filter(function (eventElement) {
	    return eventElement.element === element;
	  })[0];
	  if (typeof ee === 'undefined') {
	    ee = new EventElement(element);
	    this.eventElements.push(ee);
	  }
	  return ee;
	};
	
	EventManager.prototype.bind = function (element, eventName, handler) {
	  this.eventElement(element).bind(eventName, handler);
	};
	
	EventManager.prototype.unbind = function (element, eventName, handler) {
	  this.eventElement(element).unbind(eventName, handler);
	};
	
	EventManager.prototype.unbindAll = function () {
	  for (var i = 0; i < this.eventElements.length; i++) {
	    this.eventElements[i].unbindAll();
	  }
	};
	
	EventManager.prototype.once = function (element, eventName, handler) {
	  var ee = this.eventElement(element);
	  var onceHandler = function (e) {
	    ee.unbind(eventName, onceHandler);
	    handler(e);
	  };
	  ee.bind(eventName, onceHandler);
	};
	
	module.e = EventManager;
	


/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = (function () {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000)
	               .toString(16)
	               .substring(1);
	  }
	  return function () {
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
	           s4() + '-' + s4() + s4() + s4();
	  };
	})();
	


/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var destroy = __webpack_require__(1534)
	  , initialize = __webpack_require__(1542)
	  , update = __webpack_require__(1543);
	
	module.e = {
	  initialize: initialize,
	  update: update,
	  destroy: destroy
	};
	


/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	module.e = {
	  maxScrollbarLength: null,
	  minScrollbarLength: null,
	  scrollXMarginOffset: 0,
	  scrollYMarginOffset: 0,
	  stopPropagationOnClick: true,
	  suppressScrollX: false,
	  suppressScrollY: false,
	  swipePropagation: true,
	  useBothWheelAxes: false,
	  useKeyboard: true,
	  useSelectionScroll: false,
	  wheelPropagation: false,
	  wheelSpeed: 1,
	  theme: 'default'
	};
	


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var d = __webpack_require__(131)
	  , h = __webpack_require__(93)
	  , instances = __webpack_require__(66);
	
	module.e = function (element) {
	  var i = instances.get(element);
	
	  if (!i) {
	    return;
	  }
	
	  i.event.unbindAll();
	  d.remove(i.scrollbarX);
	  d.remove(i.scrollbarY);
	  d.remove(i.scrollbarXRail);
	  d.remove(i.scrollbarYRail);
	  h.removePsClasses(element);
	
	  instances.remove(element);
	};
	


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var h = __webpack_require__(93)
	  , instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	function bindClickRailHandler(element, i) {
	  function pageOffset(el) {
	    return el.getBoundingClientRect();
	  }
	  var stopPropagation = window.Event.prototype.stopPropagation.bind;
	
	  if (i.settings.stopPropagationOnClick) {
	    i.event.bind(i.scrollbarY, 'click', stopPropagation);
	  }
	  i.event.bind(i.scrollbarYRail, 'click', function (e) {
	    var halfOfScrollbarLength = h.toInt(i.scrollbarYHeight / 2);
	    var positionTop = i.railYRatio * (e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top - halfOfScrollbarLength);
	    var maxPositionTop = i.railYRatio * (i.railYHeight - i.scrollbarYHeight);
	    var positionRatio = positionTop / maxPositionTop;
	
	    if (positionRatio < 0) {
	      positionRatio = 0;
	    } else if (positionRatio > 1) {
	      positionRatio = 1;
	    }
	
	    updateScroll(element, 'top', (i.contentHeight - i.containerHeight) * positionRatio);
	    updateGeometry(element);
	
	    e.stopPropagation();
	  });
	
	  if (i.settings.stopPropagationOnClick) {
	    i.event.bind(i.scrollbarX, 'click', stopPropagation);
	  }
	  i.event.bind(i.scrollbarXRail, 'click', function (e) {
	    var halfOfScrollbarLength = h.toInt(i.scrollbarXWidth / 2);
	    var positionLeft = i.railXRatio * (e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left - halfOfScrollbarLength);
	    var maxPositionLeft = i.railXRatio * (i.railXWidth - i.scrollbarXWidth);
	    var positionRatio = positionLeft / maxPositionLeft;
	
	    if (positionRatio < 0) {
	      positionRatio = 0;
	    } else if (positionRatio > 1) {
	      positionRatio = 1;
	    }
	
	    updateScroll(element, 'left', ((i.contentWidth - i.containerWidth) * positionRatio) - i.negativeScrollAdjustment);
	    updateGeometry(element);
	
	    e.stopPropagation();
	  });
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	  bindClickRailHandler(element, i);
	};
	


/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var d = __webpack_require__(131)
	  , h = __webpack_require__(93)
	  , instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	function bindMouseScrollXHandler(element, i) {
	  var currentLeft = null;
	  var currentPageX = null;
	
	  function updateScrollLeft(deltaX) {
	    var newLeft = currentLeft + (deltaX * i.railXRatio);
	    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));
	
	    if (newLeft < 0) {
	      i.scrollbarXLeft = 0;
	    } else if (newLeft > maxLeft) {
	      i.scrollbarXLeft = maxLeft;
	    } else {
	      i.scrollbarXLeft = newLeft;
	    }
	
	    var scrollLeft = h.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
	    updateScroll(element, 'left', scrollLeft);
	  }
	
	  var mouseMoveHandler = function (e) {
	    updateScrollLeft(e.pageX - currentPageX);
	    updateGeometry(element);
	    e.stopPropagation();
	    e.preventDefault();
	  };
	
	  var mouseUpHandler = function () {
	    h.stopScrolling(element, 'x');
	    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	  };
	
	  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
	    currentPageX = e.pageX;
	    currentLeft = h.toInt(d.css(i.scrollbarX, 'left')) * i.railXRatio;
	    h.startScrolling(element, 'x');
	
	    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
	
	    e.stopPropagation();
	    e.preventDefault();
	  });
	}
	
	function bindMouseScrollYHandler(element, i) {
	  var currentTop = null;
	  var currentPageY = null;
	
	  function updateScrollTop(deltaY) {
	    var newTop = currentTop + (deltaY * i.railYRatio);
	    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));
	
	    if (newTop < 0) {
	      i.scrollbarYTop = 0;
	    } else if (newTop > maxTop) {
	      i.scrollbarYTop = maxTop;
	    } else {
	      i.scrollbarYTop = newTop;
	    }
	
	    var scrollTop = h.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
	    updateScroll(element, 'top', scrollTop);
	  }
	
	  var mouseMoveHandler = function (e) {
	    updateScrollTop(e.pageY - currentPageY);
	    updateGeometry(element);
	    e.stopPropagation();
	    e.preventDefault();
	  };
	
	  var mouseUpHandler = function () {
	    h.stopScrolling(element, 'y');
	    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	  };
	
	  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
	    currentPageY = e.pageY;
	    currentTop = h.toInt(d.css(i.scrollbarY, 'top')) * i.railYRatio;
	    h.startScrolling(element, 'y');
	
	    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
	
	    e.stopPropagation();
	    e.preventDefault();
	  });
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	  bindMouseScrollXHandler(element, i);
	  bindMouseScrollYHandler(element, i);
	};
	


/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var h = __webpack_require__(93)
	  , d = __webpack_require__(131)
	  , instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	function bindKeyboardHandler(element, i) {
	  var hovered = false;
	  i.event.bind(element, 'mouseenter', function () {
	    hovered = true;
	  });
	  i.event.bind(element, 'mouseleave', function () {
	    hovered = false;
	  });
	
	  var shouldPrevent = false;
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = element.scrollTop;
	    if (deltaX === 0) {
	      if (!i.scrollbarYActive) {
	        return false;
	      }
	      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	
	    var scrollLeft = element.scrollLeft;
	    if (deltaY === 0) {
	      if (!i.scrollbarXActive) {
	        return false;
	      }
	      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	    return true;
	  }
	
	  i.event.bind(i.ownerDocument, 'keydown', function (e) {
	    if (e.isDefaultPrevented && e.isDefaultPrevented()) {
	      return;
	    }
	
	    var focused = d.matches(i.scrollbarX, ':focus') ||
	                  d.matches(i.scrollbarY, ':focus');
	
	    if (!hovered && !focused) {
	      return;
	    }
	
	    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
	    if (activeElement) {
	      // go deeper if element is a webcomponent
	      while (activeElement.shadowRoot) {
	        activeElement = activeElement.shadowRoot.activeElement;
	      }
	      if (h.isEditable(activeElement)) {
	        return;
	      }
	    }
	
	    var deltaX = 0;
	    var deltaY = 0;
	
	    switch (e.which) {
	    case 37: // left
	      deltaX = -30;
	      break;
	    case 38: // up
	      deltaY = 30;
	      break;
	    case 39: // right
	      deltaX = 30;
	      break;
	    case 40: // down
	      deltaY = -30;
	      break;
	    case 33: // page up
	      deltaY = 90;
	      break;
	    case 32: // space bar
	      if (e.shiftKey) {
	        deltaY = 90;
	      } else {
	        deltaY = -90;
	      }
	      break;
	    case 34: // page down
	      deltaY = -90;
	      break;
	    case 35: // end
	      if (e.ctrlKey) {
	        deltaY = -i.contentHeight;
	      } else {
	        deltaY = -i.containerHeight;
	      }
	      break;
	    case 36: // home
	      if (e.ctrlKey) {
	        deltaY = element.scrollTop;
	      } else {
	        deltaY = i.containerHeight;
	      }
	      break;
	    default:
	      return;
	    }
	
	    updateScroll(element, 'top', element.scrollTop - deltaY);
	    updateScroll(element, 'left', element.scrollLeft + deltaX);
	    updateGeometry(element);
	
	    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
	    if (shouldPrevent) {
	      e.preventDefault();
	    }
	  });
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	  bindKeyboardHandler(element, i);
	};
	


/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	function bindMouseWheelHandler(element, i) {
	  var shouldPrevent = false;
	
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = element.scrollTop;
	    if (deltaX === 0) {
	      if (!i.scrollbarYActive) {
	        return false;
	      }
	      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	
	    var scrollLeft = element.scrollLeft;
	    if (deltaY === 0) {
	      if (!i.scrollbarXActive) {
	        return false;
	      }
	      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	    return true;
	  }
	
	  function getDeltaFromEvent(e) {
	    var deltaX = e.deltaX;
	    var deltaY = -1 * e.deltaY;
	
	    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
	      // OS X Safari
	      deltaX = -1 * e.wheelDeltaX / 6;
	      deltaY = e.wheelDeltaY / 6;
	    }
	
	    if (e.deltaMode && e.deltaMode === 1) {
	      // Firefox in deltaMode 1: Line scrolling
	      deltaX *= 10;
	      deltaY *= 10;
	    }
	
	    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
	      // IE in some mouse drivers
	      deltaX = 0;
	      deltaY = e.wheelDelta;
	    }
	
	    return [deltaX, deltaY];
	  }
	
	  function shouldBeConsumedByTextarea(deltaX, deltaY) {
	    var hoveredTextarea = element.querySelector('textarea:hover');
	    if (hoveredTextarea) {
	      var maxScrollTop = hoveredTextarea.scrollHeight - hoveredTextarea.clientHeight;
	      if (maxScrollTop > 0) {
	        if (!(hoveredTextarea.scrollTop === 0 && deltaY > 0) &&
	            !(hoveredTextarea.scrollTop === maxScrollTop && deltaY < 0)) {
	          return true;
	        }
	      }
	      var maxScrollLeft = hoveredTextarea.scrollLeft - hoveredTextarea.clientWidth;
	      if (maxScrollLeft > 0) {
	        if (!(hoveredTextarea.scrollLeft === 0 && deltaX < 0) &&
	            !(hoveredTextarea.scrollLeft === maxScrollLeft && deltaX > 0)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  function mousewheelHandler(e) {
	    var delta = getDeltaFromEvent(e);
	
	    var deltaX = delta[0];
	    var deltaY = delta[1];
	
	    if (shouldBeConsumedByTextarea(deltaX, deltaY)) {
	      return;
	    }
	
	    shouldPrevent = false;
	    if (!i.settings.useBothWheelAxes) {
	      // deltaX will only be used for horizontal scrolling and deltaY will
	      // only be used for vertical scrolling - this is the default
	      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
	      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
	    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
	      // only vertical scrollbar is active and useBothWheelAxes option is
	      // active, so let's scroll vertical bar using both mouse wheel axes
	      if (deltaY) {
	        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
	      } else {
	        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
	      }
	      shouldPrevent = true;
	    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
	      // useBothWheelAxes and only horizontal bar is active, so use both
	      // wheel axes for horizontal bar
	      if (deltaX) {
	        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
	      } else {
	        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
	      }
	      shouldPrevent = true;
	    }
	
	    updateGeometry(element);
	
	    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
	    if (shouldPrevent) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }
	
	  if (typeof window.onwheel !== "undefined") {
	    i.event.bind(element, 'wheel', mousewheelHandler);
	  } else if (typeof window.onmousewheel !== "undefined") {
	    i.event.bind(element, 'mousewheel', mousewheelHandler);
	  }
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	  bindMouseWheelHandler(element, i);
	};
	


/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94);
	
	function bindNativeScrollHandler(element, i) {
	  i.event.bind(element, 'scroll', function () {
	    updateGeometry(element);
	  });
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	  bindNativeScrollHandler(element, i);
	};
	


/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var h = __webpack_require__(93)
	  , instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	function bindSelectionHandler(element, i) {
	  function getRangeNode() {
	    var selection = window.getSelection ? window.getSelection() :
	                    document.getSelection ? document.getSelection() : '';
	    if (selection.toString().length === 0) {
	      return null;
	    } else {
	      return selection.getRangeAt(0).commonAncestorContainer;
	    }
	  }
	
	  var scrollingLoop = null;
	  var scrollDiff = {top: 0, left: 0};
	  function startScrolling() {
	    if (!scrollingLoop) {
	      scrollingLoop = setInterval(function () {
	        if (!instances.get(element)) {
	          clearInterval(scrollingLoop);
	          return;
	        }
	
	        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
	        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
	        updateGeometry(element);
	      }, 50); // every .1 sec
	    }
	  }
	  function stopScrolling() {
	    if (scrollingLoop) {
	      clearInterval(scrollingLoop);
	      scrollingLoop = null;
	    }
	    h.stopScrolling(element);
	  }
	
	  var isSelected = false;
	  i.event.bind(i.ownerDocument, 'selectionchange', function () {
	    if (element.contains(getRangeNode())) {
	      isSelected = true;
	    } else {
	      isSelected = false;
	      stopScrolling();
	    }
	  });
	  i.event.bind(window, 'mouseup', function () {
	    if (isSelected) {
	      isSelected = false;
	      stopScrolling();
	    }
	  });
	
	  i.event.bind(window, 'mousemove', function (e) {
	    if (isSelected) {
	      var mousePosition = {x: e.pageX, y: e.pageY};
	      var containerGeometry = {
	        left: element.offsetLeft,
	        right: element.offsetLeft + element.offsetWidth,
	        top: element.offsetTop,
	        bottom: element.offsetTop + element.offsetHeight
	      };
	
	      if (mousePosition.x < containerGeometry.left + 3) {
	        scrollDiff.left = -5;
	        h.startScrolling(element, 'x');
	      } else if (mousePosition.x > containerGeometry.right - 3) {
	        scrollDiff.left = 5;
	        h.startScrolling(element, 'x');
	      } else {
	        scrollDiff.left = 0;
	      }
	
	      if (mousePosition.y < containerGeometry.top + 3) {
	        if (containerGeometry.top + 3 - mousePosition.y < 5) {
	          scrollDiff.top = -5;
	        } else {
	          scrollDiff.top = -20;
	        }
	        h.startScrolling(element, 'y');
	      } else if (mousePosition.y > containerGeometry.bottom - 3) {
	        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
	          scrollDiff.top = 5;
	        } else {
	          scrollDiff.top = 20;
	        }
	        h.startScrolling(element, 'y');
	      } else {
	        scrollDiff.top = 0;
	      }
	
	      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
	        stopScrolling();
	      } else {
	        startScrolling();
	      }
	    }
	  });
	}
	
	module.e = function (element) {
	  var i = instances.get(element);
	  bindSelectionHandler(element, i);
	};
	


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = element.scrollTop;
	    var scrollLeft = element.scrollLeft;
	    var magnitudeX = Math.abs(deltaX);
	    var magnitudeY = Math.abs(deltaY);
	
	    if (magnitudeY > magnitudeX) {
	      // user is perhaps trying to swipe up/down the page
	
	      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
	          ((deltaY > 0) && (scrollTop === 0))) {
	        return !i.settings.swipePropagation;
	      }
	    } else if (magnitudeX > magnitudeY) {
	      // user is perhaps trying to swipe left/right across the page
	
	      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
	          ((deltaX > 0) && (scrollLeft === 0))) {
	        return !i.settings.swipePropagation;
	      }
	    }
	
	    return true;
	  }
	
	  function applyTouchMove(differenceX, differenceY) {
	    updateScroll(element, 'top', element.scrollTop - differenceY);
	    updateScroll(element, 'left', element.scrollLeft - differenceX);
	
	    updateGeometry(element);
	  }
	
	  var startOffset = {};
	  var startTime = 0;
	  var speed = {};
	  var easingLoop = null;
	  var inGlobalTouch = false;
	  var inLocalTouch = false;
	
	  function globalTouchStart() {
	    inGlobalTouch = true;
	  }
	  function globalTouchEnd() {
	    inGlobalTouch = false;
	  }
	
	  function getTouch(e) {
	    if (e.targetTouches) {
	      return e.targetTouches[0];
	    } else {
	      // Maybe IE pointer
	      return e;
	    }
	  }
	  function shouldHandle(e) {
	    if (e.targetTouches && e.targetTouches.length === 1) {
	      return true;
	    }
	    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
	      return true;
	    }
	    return false;
	  }
	  function touchStart(e) {
	    if (shouldHandle(e)) {
	      inLocalTouch = true;
	
	      var touch = getTouch(e);
	
	      startOffset.pageX = touch.pageX;
	      startOffset.pageY = touch.pageY;
	
	      startTime = (new Date()).getTime();
	
	      if (easingLoop !== null) {
	        clearInterval(easingLoop);
	      }
	
	      e.stopPropagation();
	    }
	  }
	  function touchMove(e) {
	    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
	      var touch = getTouch(e);
	
	      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};
	
	      var differenceX = currentOffset.pageX - startOffset.pageX;
	      var differenceY = currentOffset.pageY - startOffset.pageY;
	
	      applyTouchMove(differenceX, differenceY);
	      startOffset = currentOffset;
	
	      var currentTime = (new Date()).getTime();
	
	      var timeGap = currentTime - startTime;
	      if (timeGap > 0) {
	        speed.x = differenceX / timeGap;
	        speed.y = differenceY / timeGap;
	        startTime = currentTime;
	      }
	
	      if (shouldPreventDefault(differenceX, differenceY)) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	    }
	  }
	  function touchEnd() {
	    if (!inGlobalTouch && inLocalTouch) {
	      inLocalTouch = false;
	
	      clearInterval(easingLoop);
	      easingLoop = setInterval(function () {
	        if (!instances.get(element)) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        applyTouchMove(speed.x * 30, speed.y * 30);
	
	        speed.x *= 0.8;
	        speed.y *= 0.8;
	      }, 10);
	    }
	  }
	
	  if (supportsTouch) {
	    i.event.bind(window, 'touchstart', globalTouchStart);
	    i.event.bind(window, 'touchend', globalTouchEnd);
	    i.event.bind(element, 'touchstart', touchStart);
	    i.event.bind(element, 'touchmove', touchMove);
	    i.event.bind(element, 'touchend', touchEnd);
	  }
	
	  if (supportsIePointer) {
	    if (window.PointerEvent) {
	      i.event.bind(window, 'pointerdown', globalTouchStart);
	      i.event.bind(window, 'pointerup', globalTouchEnd);
	      i.event.bind(element, 'pointerdown', touchStart);
	      i.event.bind(element, 'pointermove', touchMove);
	      i.event.bind(element, 'pointerup', touchEnd);
	    } else if (window.MSPointerEvent) {
	      i.event.bind(window, 'MSPointerDown', globalTouchStart);
	      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
	      i.event.bind(element, 'MSPointerDown', touchStart);
	      i.event.bind(element, 'MSPointerMove', touchMove);
	      i.event.bind(element, 'MSPointerUp', touchEnd);
	    }
	  }
	}
	
	module.e = function (element, supportsTouch, supportsIePointer) {
	  var i = instances.get(element);
	  bindTouchHandler(element, i, supportsTouch, supportsIePointer);
	};
	


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var cls = __webpack_require__(226)
	  , h = __webpack_require__(93)
	  , instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94);
	
	// Handlers
	var clickRailHandler = __webpack_require__(1535)
	  , dragScrollbarHandler = __webpack_require__(1536)
	  , keyboardHandler = __webpack_require__(1537)
	  , mouseWheelHandler = __webpack_require__(1538)
	  , nativeScrollHandler = __webpack_require__(1539)
	  , selectionHandler = __webpack_require__(1540)
	  , touchHandler = __webpack_require__(1541);
	
	module.e = function (element, userSettings) {
	  userSettings = typeof userSettings === 'object' ? userSettings : {};
	
	  cls.add(element, 'ps-container');
	
	  // Create a plugin instance.
	  var i = instances.add(element);
	
	  i.settings = h.extend(i.settings, userSettings);
	  cls.add(element, 'ps-theme-' + i.settings.theme);
	
	  clickRailHandler(element);
	  dragScrollbarHandler(element);
	  mouseWheelHandler(element);
	  nativeScrollHandler(element);
	
	  if (i.settings.useSelectionScroll) {
	    selectionHandler(element);
	  }
	
	  if (h.env.supportsTouch || h.env.supportsIePointer) {
	    touchHandler(element, h.env.supportsTouch, h.env.supportsIePointer);
	  }
	  if (i.settings.useKeyboard) {
	    keyboardHandler(element);
	  }
	
	  updateGeometry(element);
	};
	


/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var d = __webpack_require__(131)
	  , h = __webpack_require__(93)
	  , instances = __webpack_require__(66)
	  , updateGeometry = __webpack_require__(94)
	  , updateScroll = __webpack_require__(106);
	
	module.e = function (element) {
	  var i = instances.get(element);
	
	  if (!i) {
	    return;
	  }
	
	  // Recalcuate negative scrollLeft adjustment
	  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
	
	  // Recalculate rail margins
	  d.css(i.scrollbarXRail, 'display', 'block');
	  d.css(i.scrollbarYRail, 'display', 'block');
	  i.railXMarginWidth = h.toInt(d.css(i.scrollbarXRail, 'marginLeft')) + h.toInt(d.css(i.scrollbarXRail, 'marginRight'));
	  i.railYMarginHeight = h.toInt(d.css(i.scrollbarYRail, 'marginTop')) + h.toInt(d.css(i.scrollbarYRail, 'marginBottom'));
	
	  // Hide scrollbars not to affect scrollWidth and scrollHeight
	  d.css(i.scrollbarXRail, 'display', 'none');
	  d.css(i.scrollbarYRail, 'display', 'none');
	
	  updateGeometry(element);
	
	  // Update top/left scroll to trigger events
	  updateScroll(element, 'top', element.scrollTop);
	  updateScroll(element, 'left', element.scrollLeft);
	
	  d.css(i.scrollbarXRail, 'display', '');
	  d.css(i.scrollbarYRail, 'display', '');
	};
	


/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.e = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.e = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.e = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.e = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var div = null
	var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]
	
	module.e = function prefixStyle (prop) {
	  // re-use a dummy div
	  if (!div) {
	    div = document.createElement('div')
	  }
	
	  var style = div.style
	
	  // prop exists without prefix
	  if (prop in style) {
	    return prop
	  }
	
	  // borderRadius -> BorderRadius
	  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)
	
	  // find the vendor-prefixed prop
	  for (var i = prefixes.length; i >= 0; i--) {
	    var name = prefixes[i] + titleCase
	    // e.g. WebkitBorderRadius or webkitBorderRadius
	    if (name in style) {
	      return name
	    }
	  }
	
	  return false
	}
	


/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	exports.publicEncrypt = __webpack_require__(1548);
	exports.privateDecrypt = __webpack_require__(1547);
	
	exports.privateEncrypt = function privateEncrypt(key, buf) {
	  return exports.publicEncrypt(key, buf, true);
	};
	
	exports.publicDecrypt = function publicDecrypt(key, buf) {
	  return exports.privateDecrypt(key, buf, true);
	};


/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var parseKeys = __webpack_require__(225);
	var mgf = __webpack_require__(551);
	var xor = __webpack_require__(553);
	var bn = __webpack_require__(39);
	var crt = __webpack_require__(280);
	var createHash = __webpack_require__(149);
	var withPublic = __webpack_require__(552);
	module.e = function privateDecrypt(private_key, enc, reverse) {
	  var padding;
	  if (private_key.padding) {
	    padding = private_key.padding;
	  } else if (reverse) {
	    padding = 1;
	  } else {
	    padding = 4;
	  }
	  
	  var key = parseKeys(private_key);
	  var k = key.modulus.byteLength();
	  if (enc.length > k || new bn(enc).cmp(key.modulus) >= 0) {
	    throw new Error('decryption error');
	  }
	  var msg;
	  if (reverse) {
	    msg = withPublic(new bn(enc), key);
	  } else {
	    msg = crt(enc, key);
	  }
	  var zBuffer = new Buffer(k - msg.length);
	  zBuffer.fill(0);
	  msg = Buffer.concat([zBuffer, msg], k);
	  if (padding === 4) {
	    return oaep(key, msg);
	  } else if (padding === 1) {
	    return pkcs1(key, msg, reverse);
	  } else if (padding === 3) {
	    return msg;
	  } else {
	    throw new Error('unknown padding');
	  }
	};
	
	function oaep(key, msg){
	  var n = key.modulus;
	  var k = key.modulus.byteLength();
	  var mLen = msg.length;
	  var iHash = createHash('sha1').update(new Buffer('')).digest();
	  var hLen = iHash.length;
	  var hLen2 = 2 * hLen;
	  if (msg[0] !== 0) {
	    throw new Error('decryption error');
	  }
	  var maskedSeed = msg.slice(1, hLen + 1);
	  var maskedDb =  msg.slice(hLen + 1);
	  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
	  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
	  if (compare(iHash, db.slice(0, hLen))) {
	    throw new Error('decryption error');
	  }
	  var i = hLen;
	  while (db[i] === 0) {
	    i++;
	  }
	  if (db[i++] !== 1) {
	    throw new Error('decryption error');
	  }
	  return db.slice(i);
	}
	
	function pkcs1(key, msg, reverse){
	  var p1 = msg.slice(0, 2);
	  var i = 2;
	  var status = 0;
	  while (msg[i++] !== 0) {
	    if (i >= msg.length) {
	      status++;
	      break;
	    }
	  }
	  var ps = msg.slice(2, i - 1);
	  var p2 = msg.slice(i - 1, i);
	
	  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)){
	    status++;
	  }
	  if (ps.length < 8) {
	    status++;
	  }
	  if (status) {
	    throw new Error('decryption error');
	  }
	  return  msg.slice(i);
	}
	function compare(a, b){
	  a = new Buffer(a);
	  b = new Buffer(b);
	  var dif = 0;
	  var len = a.length;
	  if (a.length !== b.length) {
	    dif++;
	    len = Math.min(a.length, b.length);
	  }
	  var i = -1;
	  while (++i < len) {
	    dif += (a[i] ^ b[i]);
	  }
	  return dif;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var parseKeys = __webpack_require__(225);
	var randomBytes = __webpack_require__(175);
	var createHash = __webpack_require__(149);
	var mgf = __webpack_require__(551);
	var xor = __webpack_require__(553);
	var bn = __webpack_require__(39);
	var withPublic = __webpack_require__(552);
	var crt = __webpack_require__(280);
	
	var constants = {
	  RSA_PKCS1_OAEP_PADDING: 4,
	  RSA_PKCS1_PADDIN: 1,
	  RSA_NO_PADDING: 3
	};
	
	module.e = function publicEncrypt(public_key, msg, reverse) {
	  var padding;
	  if (public_key.padding) {
	    padding = public_key.padding;
	  } else if (reverse) {
	    padding = 1;
	  } else {
	    padding = 4;
	  }
	  var key = parseKeys(public_key);
	  var paddedMsg;
	  if (padding === 4) {
	    paddedMsg = oaep(key, msg);
	  } else if (padding === 1) {
	    paddedMsg = pkcs1(key, msg, reverse);
	  } else if (padding === 3) {
	    paddedMsg = new bn(msg);
	    if (paddedMsg.cmp(key.modulus) >= 0) {
	      throw new Error('data too long for modulus');
	    }
	  } else {
	    throw new Error('unknown padding');
	  }
	  if (reverse) {
	    return crt(paddedMsg, key);
	  } else {
	    return withPublic(paddedMsg, key);
	  }
	};
	
	function oaep(key, msg){
	  var k = key.modulus.byteLength();
	  var mLen = msg.length;
	  var iHash = createHash('sha1').update(new Buffer('')).digest();
	  var hLen = iHash.length;
	  var hLen2 = 2 * hLen;
	  if (mLen > k - hLen2 - 2) {
	    throw new Error('message too long');
	  }
	  var ps = new Buffer(k - mLen - hLen2 - 2);
	  ps.fill(0);
	  var dblen = k - hLen - 1;
	  var seed = randomBytes(hLen);
	  var maskedDb = xor(Buffer.concat([iHash, ps, new Buffer([1]), msg], dblen), mgf(seed, dblen));
	  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
	  return new bn(Buffer.concat([new Buffer([0]), maskedSeed, maskedDb], k));
	}
	function pkcs1(key, msg, reverse){
	  var mLen = msg.length;
	  var k = key.modulus.byteLength();
	  if (mLen > k - 11) {
	    throw new Error('message too long');
	  }
	  var ps;
	  if (reverse) {
	    ps = new Buffer(k - mLen - 3);
	    ps.fill(0xff);
	  } else {
	    ps = nonZero(k - mLen - 3);
	  }
	  return new bn(Buffer.concat([new Buffer([0, reverse?1:2]), ps, new Buffer([0]), msg], k));
	}
	function nonZero(len, crypto) {
	  var out = new Buffer(len);
	  var i = 0;
	  var cache = randomBytes(len*2);
	  var cur = 0;
	  var num;
	  while (i < len) {
	    if (cur === cache.length) {
	      cache = randomBytes(len*2);
	      cur = 0;
	    }
	    num = cache[cur++];
	    if (num) {
	      out[i++] = num;
	    }
	  }
	  return out;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	var strictUriEncode = __webpack_require__(1725);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};
	


/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var now = __webpack_require__(1544)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.e = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.e.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.e.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(569);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	var Accordion = _react2['default'].createClass({
	  displayName: 'Accordion',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      _extends({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Accordion;
	module.e = exports['default'];


/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var Alert = _react2['default'].createClass({
	  displayName: 'Alert',
	
	  propTypes: {
	    onDismiss: _react2['default'].PropTypes.func,
	    dismissAfter: _react2['default'].PropTypes.number,
	    closeLabel: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeLabel: 'Close Alert'
	    };
	  },
	
	  renderDismissButton: function renderDismissButton() {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: this.props.onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1' },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '×'
	      )
	    );
	  },
	
	  renderSrOnlyDismissButton: function renderSrOnlyDismissButton() {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: this.props.onDismiss },
	      this.props.closeLabel
	    );
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	    var isDismissable = !!this.props.onDismiss;
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'dismissable')] = isDismissable;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { role: 'alert', className: _classnames2['default'](this.props.className, classes) }),
	      isDismissable ? this.renderDismissButton() : null,
	      this.props.children,
	      isDismissable ? this.renderSrOnlyDismissButton() : null
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.dismissAfter && this.props.onDismiss) {
	      this.dismissTimer = setTimeout(this.props.onDismiss, this.props.dismissAfter);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.dismissTimer);
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _styleMaps.State.INFO, _utilsBootstrapUtils.bsClass('alert', Alert));
	module.e = exports['default'];


/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var Badge = _react2['default'].createClass({
	  displayName: 'Badge',
	
	  propTypes: {
	    pullRight: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      pullRight: false,
	      bsClass: 'badge'
	    };
	  },
	
	  hasContent: function hasContent() {
	    return _utilsValidComponentChildren2['default'].hasValidComponent(this.props.children) || _react2['default'].Children.count(this.props.children) > 1 || typeof this.props.children === 'string' || typeof this.props.children === 'number';
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {
	      'pull-right': this.props.pullRight
	    }, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = this.hasContent(), _classes);
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Badge;
	module.e = exports['default'];


/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var Breadcrumb = _react2['default'].createClass({
	  displayName: 'Breadcrumb',
	
	  propTypes: {
	    /**
	     * bootstrap className
	     * @private
	     */
	    bsClass: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'breadcrumb'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return _react2['default'].createElement(
	      'ol',
	      _extends({}, props, {
	        role: 'navigation',
	        'aria-label': 'breadcrumbs',
	        className: _classnames2['default'](className, this.props.bsClass) }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderBreadcrumbItem)
	    );
	  },
	
	  renderBreadcrumbItem: function renderBreadcrumbItem(child, index) {
	    return _react.cloneElement(child, { key: child.key || index });
	  }
	});
	
	exports['default'] = Breadcrumb;
	module.e = exports['default'];


/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var BreadcrumbItem = _react2['default'].createClass({
	  displayName: 'BreadcrumbItem',
	
	  propTypes: {
	    /**
	     * If set to true, renders `span` instead of `a`
	     */
	    active: _react2['default'].PropTypes.bool,
	    /**
	     * HTML id for the wrapper `li` element
	     */
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    /**
	     * HTML id for the inner `a` element
	     */
	    linkId: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    /**
	     * `href` attribute for the inner `a` element
	     */
	    href: _react2['default'].PropTypes.string,
	    /**
	     * `title` attribute for the inner `a` element
	     */
	    title: _react2['default'].PropTypes.node,
	    /**
	     * `target` attribute for the inner `a` element
	     */
	    target: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var className = _props.className;
	    var id = _props.id;
	    var linkId = _props.linkId;
	    var children = _props.children;
	    var href = _props.href;
	    var title = _props.title;
	    var target = _props.target;
	
	    var props = _objectWithoutProperties(_props, ['active', 'className', 'id', 'linkId', 'children', 'href', 'title', 'target']);
	
	    var linkProps = {
	      href: href,
	      title: title,
	      target: target,
	      id: linkId
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { id: id, className: _classnames2['default'](className, { active: active }) },
	      active ? _react2['default'].createElement(
	        'span',
	        props,
	        children
	      ) : _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, props, linkProps),
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = BreadcrumbItem;
	module.e = exports['default'];


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(133);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormGroup = __webpack_require__(558);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _InputBase2 = __webpack_require__(310);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsChildrenValueInputValidation = __webpack_require__(312);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var ButtonInput = (function (_InputBase) {
	  _inherits(ButtonInput, _InputBase);
	
	  function ButtonInput() {
	    _classCallCheck(this, ButtonInput);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  ButtonInput.prototype.renderFormGroup = function renderFormGroup(children) {
	    var _props = this.props;
	    var bsStyle = _props.bsStyle;
	    var value = _props.value;
	
	    var other = _objectWithoutProperties(_props, ['bsStyle', 'value']);
	
	    return _react2['default'].createElement(
	      _FormGroup2['default'],
	      other,
	      children
	    );
	  };
	
	  ButtonInput.prototype.renderInput = function renderInput() {
	    var _props2 = this.props;
	    var children = _props2.children;
	    var value = _props2.value;
	
	    var other = _objectWithoutProperties(_props2, ['children', 'value']);
	
	    var val = children ? children : value;
	    return _react2['default'].createElement(_Button2['default'], _extends({}, other, { componentClass: 'input', ref: 'input', key: 'input', value: val }));
	  };
	
	  return ButtonInput;
	})(_InputBase3['default']);
	
	ButtonInput.types = _Button2['default'].types;
	
	ButtonInput.defaultProps = {
	  type: 'button'
	};
	
	ButtonInput.propTypes = {
	  type: _react2['default'].PropTypes.oneOf(ButtonInput.types),
	  bsStyle: function bsStyle() {
	    // defer to Button propTypes of bsStyle
	    return null;
	  },
	  children: _utilsChildrenValueInputValidation2['default'],
	  value: _utilsChildrenValueInputValidation2['default']
	};
	
	exports['default'] = ButtonInput;
	module.e = exports['default'];


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _Button = __webpack_require__(133);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var ButtonToolbar = _react2['default'].createClass({
	  displayName: 'ButtonToolbar',
	
	  propTypes: {
	    bsSize: _Button2['default'].propTypes.bsSize
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'btn-toolbar'
	    };
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        role: 'toolbar',
	        className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = ButtonToolbar;
	module.e = exports['default'];


/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _Glyphicon = __webpack_require__(308);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var Carousel = _react2['default'].createClass({
	  displayName: 'Carousel',
	
	  propTypes: {
	    slide: _react2['default'].PropTypes.bool,
	    indicators: _react2['default'].PropTypes.bool,
	    interval: _react2['default'].PropTypes.number,
	    controls: _react2['default'].PropTypes.bool,
	    pauseOnHover: _react2['default'].PropTypes.bool,
	    wrap: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    onSlideEnd: _react2['default'].PropTypes.func,
	    activeIndex: _react2['default'].PropTypes.number,
	    defaultActiveIndex: _react2['default'].PropTypes.number,
	    direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	    prevIcon: _react2['default'].PropTypes.node,
	    nextIcon: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'carousel',
	      slide: true,
	      interval: 5000,
	      pauseOnHover: true,
	      wrap: true,
	      indicators: true,
	      controls: true,
	      prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	      nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' })
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      activeIndex: this.props.defaultActiveIndex == null ? 0 : this.props.defaultActiveIndex,
	      previousActiveIndex: null,
	      direction: null
	    };
	  },
	
	  getDirection: function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.waitForNext();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  },
	
	  next: function next(e) {
	    if (e) {
	      e.preventDefault();
	    }
	
	    var index = this.getActiveIndex() + 1;
	    var count = _utilsValidComponentChildren2['default'].numberOf(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.handleSelect(index, 'next');
	  },
	
	  prev: function prev(e) {
	    if (e) {
	      e.preventDefault();
	    }
	
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _utilsValidComponentChildren2['default'].numberOf(this.props.children) - 1;
	    }
	
	    this.handleSelect(index, 'prev');
	  },
	
	  pause: function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  },
	
	  play: function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  },
	
	  waitForNext: function waitForNext() {
	    if (!this.isPaused && this.props.slide && this.props.interval && this.props.activeIndex == null) {
	      this.timeout = setTimeout(this.next, this.props.interval);
	    }
	  },
	
	  handleMouseOver: function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	
	  handleMouseOut: function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = true, _classes.slide = this.props.slide, _classes);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut }),
	      this.props.indicators ? this.renderIndicators() : null,
	      _react2['default'].createElement(
	        'div',
	        {
	          ref: 'inner',
	          className: _utilsBootstrapUtils2['default'].prefix(this.props, 'inner')
	        },
	        _utilsValidComponentChildren2['default'].map(this.props.children, this.renderItem)
	      ),
	      this.props.controls ? this.renderControls() : null
	    );
	  },
	
	  renderPrev: function renderPrev() {
	    var classes = 'left ' + _utilsBootstrapUtils2['default'].prefix(this.props, 'control');
	
	    return _react2['default'].createElement(
	      'a',
	      { className: classes, href: '#prev', key: 0, onClick: this.prev },
	      this.props.prevIcon
	    );
	  },
	
	  renderNext: function renderNext() {
	    var classes = 'right ' + _utilsBootstrapUtils2['default'].prefix(this.props, 'control');
	
	    return _react2['default'].createElement(
	      'a',
	      { className: classes, href: '#next', key: 1, onClick: this.next },
	      this.props.nextIcon
	    );
	  },
	
	  renderControls: function renderControls() {
	    if (!this.props.wrap) {
	      var activeIndex = this.getActiveIndex();
	      var count = _utilsValidComponentChildren2['default'].numberOf(this.props.children);
	
	      return [activeIndex !== 0 ? this.renderPrev() : null, activeIndex !== count - 1 ? this.renderNext() : null];
	    }
	
	    return [this.renderPrev(), this.renderNext()];
	  },
	
	  renderIndicator: function renderIndicator(child, index) {
	    var className = index === this.getActiveIndex() ? 'active' : null;
	
	    return _react2['default'].createElement('li', {
	      key: index,
	      className: className,
	      onClick: this.handleSelect.bind(this, index, null) });
	  },
	
	  renderIndicators: function renderIndicators() {
	    var _this = this;
	
	    var indicators = [];
	    _utilsValidComponentChildren2['default'].forEach(this.props.children, function (child, index) {
	      indicators.push(_this.renderIndicator(child, index),
	
	      // Force whitespace between indicator elements, bootstrap
	      // requires this for correct spacing of elements.
	      ' ');
	    }, this);
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'indicators') },
	      indicators
	    );
	  },
	
	  getActiveIndex: function getActiveIndex() {
	    return this.props.activeIndex != null ? this.props.activeIndex : this.state.activeIndex;
	  },
	
	  handleItemAnimateOutEnd: function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  },
	
	  renderItem: function renderItem(child, index) {
	    var activeIndex = this.getActiveIndex();
	    var isActive = index === activeIndex;
	    var isPreviousActive = this.state.previousActiveIndex != null && this.state.previousActiveIndex === index && this.props.slide;
	
	    return _react.cloneElement(child, {
	      active: isActive,
	      ref: child.ref,
	      key: child.key ? child.key : index,
	      index: index,
	      animateOut: isPreviousActive,
	      animateIn: isActive && this.state.previousActiveIndex != null && this.props.slide,
	      direction: this.state.direction,
	      onAnimateOutEnd: isPreviousActive ? this.handleItemAnimateOutEnd : null
	    });
	  },
	
	  handleSelect: function handleSelect(index, direction) {
	    clearTimeout(this.timeout);
	
	    if (this.isMounted()) {
	      var previousActiveIndex = this.getActiveIndex();
	      direction = direction || this.getDirection(previousActiveIndex, index);
	
	      if (this.props.onSelect) {
	        this.props.onSelect(index, direction);
	      }
	
	      if (this.props.activeIndex == null && index !== previousActiveIndex) {
	        if (this.state.previousActiveIndex != null) {
	          // If currently animating don't activate the new index.
	          // TODO: look into queuing this canceled call and
	          // animating after the current animation has ended.
	          return;
	        }
	
	        this.setState({
	          activeIndex: index,
	          previousActiveIndex: previousActiveIndex,
	          direction: direction
	        });
	      }
	    }
	  }
	});
	
	exports['default'] = Carousel;
	module.e = exports['default'];


/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsTransitionEvents = __webpack_require__(570);
	
	var _utilsTransitionEvents2 = _interopRequireDefault(_utilsTransitionEvents);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var CarouselItem = _react2['default'].createClass({
	  displayName: 'CarouselItem',
	
	  propTypes: {
	    direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	    onAnimateOutEnd: _react2['default'].PropTypes.func,
	    active: _react2['default'].PropTypes.bool,
	    animateIn: _react2['default'].PropTypes.bool,
	    animateOut: _react2['default'].PropTypes.bool,
	    caption: _react2['default'].PropTypes.node,
	    index: _react2['default'].PropTypes.number
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      direction: null
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsStyle: 'carousel',
	      active: false,
	      animateIn: false,
	      animateOut: false
	    };
	  },
	
	  handleAnimateOutEnd: function handleAnimateOutEnd() {
	    if (this.props.onAnimateOutEnd && this.isMounted()) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({
	        direction: null
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (!this.props.active && prevProps.active) {
	      _utilsTransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (this.props.active !== prevProps.active) {
	      setTimeout(this.startAnimation, 20);
	    }
	  },
	
	  startAnimation: function startAnimation() {
	    if (!this.isMounted()) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  },
	
	  render: function render() {
	    var classes = {
	      item: true,
	      active: this.props.active && !this.props.animateIn || this.props.animateOut,
	      next: this.props.active && this.props.animateIn && this.props.direction === 'next',
	      prev: this.props.active && this.props.animateIn && this.props.direction === 'prev'
	    };
	
	    if (this.state.direction && (this.props.animateIn || this.props.animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children,
	      this.props.caption ? this.renderCaption() : null
	    );
	  },
	
	  renderCaption: function renderCaption() {
	    var classes = _utilsBootstrapUtils2['default'].prefix(this.props, 'caption');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      this.props.caption
	    );
	  }
	});
	
	exports['default'] = CarouselItem;
	module.e = exports['default'];


/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(176);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDeprecationWarning = __webpack_require__(228);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var CollapsibleNav = _react2['default'].createClass({
	  displayName: 'CollapsibleNav',
	
	  propTypes: {
	    onSelect: _react2['default'].PropTypes.func,
	    activeHref: _react2['default'].PropTypes.string,
	    activeKey: _react2['default'].PropTypes.any,
	    collapsible: _react2['default'].PropTypes.bool,
	    expanded: _react2['default'].PropTypes.bool,
	    eventKey: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      collapsible: false,
	      expanded: false
	    };
	  },
	
	  render: function render() {
	    /*
	     * this.props.collapsible is set in NavBar when an eventKey is supplied.
	     */
	    var classes = this.props.collapsible ? 'navbar-collapse' : null;
	    var renderChildren = this.props.collapsible ? this.renderCollapsibleNavChildren : this.renderChildren;
	
	    var nav = _react2['default'].createElement(
	      'div',
	      { eventKey: this.props.eventKey, className: _classnames2['default'](this.props.className, classes) },
	      _utilsValidComponentChildren2['default'].map(this.props.children, renderChildren)
	    );
	
	    if (this.props.collapsible) {
	      return _react2['default'].createElement(
	        _Collapse2['default'],
	        { 'in': this.props.expanded },
	        nav
	      );
	    }
	    return nav;
	  },
	
	  getChildActiveProp: function getChildActiveProp(child) {
	    if (child.props.active) {
	      return true;
	    }
	    if (this.props.activeKey != null) {
	      if (child.props.eventKey === this.props.activeKey) {
	        return true;
	      }
	    }
	    if (this.props.activeHref != null) {
	      if (child.props.href === this.props.activeHref) {
	        return true;
	      }
	    }
	
	    return child.props.active;
	  },
	
	  renderChildren: function renderChildren(child, index) {
	    var key = child.key ? child.key : index;
	    return _react.cloneElement(child, {
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      ref: 'nocollapse_' + key,
	      key: key,
	      navItem: true
	    });
	  },
	
	  renderCollapsibleNavChildren: function renderCollapsibleNavChildren(child, index) {
	    var key = child.key ? child.key : index;
	    return _react.cloneElement(child, {
	      active: this.getChildActiveProp(child),
	      activeKey: this.props.activeKey,
	      activeHref: this.props.activeHref,
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      ref: 'collapsible_' + key,
	      key: key,
	      navItem: true
	    });
	  }
	});
	
	exports['default'] = _utilsDeprecationWarning2['default'].wrapper(CollapsibleNav, 'CollapsibleNav', 'Navbar.Collapse', 'http://react-bootstrap.github.io/components.html#navbars');
	module.e = exports['default'];


/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(227);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _lodashCompatObjectOmit = __webpack_require__(304);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _lodashCompatObjectPick = __webpack_require__(224);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _Button = __webpack_require__(133);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var DropdownButton = (function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    _classCallCheck(this, DropdownButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props;
	    var bsStyle = _props.bsStyle;
	    var bsSize = _props.bsSize;
	    var disabled = _props.disabled;
	    var _props2 = this.props;
	    var title = _props2.title;
	    var children = _props2.children;
	
	    var props = _objectWithoutProperties(_props2, ['title', 'children']);
	
	    var dropdownProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	    var toggleProps = _lodashCompatObjectOmit2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      _extends({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        _extends({}, toggleProps, {
	          disabled: disabled
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	})(_react2['default'].Component);
	
	DropdownButton.propTypes = _extends({
	  disabled: _react2['default'].PropTypes.bool,
	  bsStyle: _Button2['default'].propTypes.bsStyle,
	  bsSize: _Button2['default'].propTypes.bsSize,
	
	  /**
	   * When used with the `title` prop, the noCaret option will not render a caret icon, in the toggle element.
	   */
	  noCaret: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.node.isRequired
	
	}, _Dropdown2['default'].propTypes);
	
	DropdownButton.defaultProps = {
	  disabled: false,
	  pullRight: false,
	  dropup: false,
	  navItem: false,
	  noCaret: false
	};
	
	exports['default'] = DropdownButton;
	module.e = exports['default'];


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _keycode = __webpack_require__(297);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactOverlaysLibRootCloseWrapper = __webpack_require__(572);
	
	var _reactOverlaysLibRootCloseWrapper2 = _interopRequireDefault(_reactOverlaysLibRootCloseWrapper);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var DropdownMenu = (function (_React$Component) {
	  _inherits(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    _React$Component.call(this, props);
	
	    this.focusNext = this.focusNext.bind(this);
	    this.focusPrevious = this.focusPrevious.bind(this);
	    this.getFocusableMenuItems = this.getFocusableMenuItems.bind(this);
	    this.getItemsAndActiveIndex = this.getItemsAndActiveIndex.bind(this);
	
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	  }
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event);
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveIndex = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveIndex.items;
	    var activeItemIndex = _getItemsAndActiveIndex.activeItemIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    if (activeItemIndex === items.length - 1) {
	      items[0].focus();
	      return;
	    }
	
	    items[activeItemIndex + 1].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveIndex2 = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveIndex2.items;
	    var activeItemIndex = _getItemsAndActiveIndex2.activeItemIndex;
	
	    if (activeItemIndex === 0) {
	      items[items.length - 1].focus();
	      return;
	    }
	
	    items[activeItemIndex - 1].focus();
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeElement = document.activeElement;
	    var activeItemIndex = items.indexOf(activeElement);
	
	    return { items: items, activeItemIndex: activeItemIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var menuNode = _reactDom2['default'].findDOMNode(this);
	
	    if (menuNode === undefined) {
	      return [];
	    }
	
	    return [].slice.call(menuNode.querySelectorAll('[tabIndex="-1"]'), 0);
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _classes,
	        _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var onSelect = _props.onSelect;
	    var pullRight = _props.pullRight;
	    var className = _props.className;
	    var labelledBy = _props.labelledBy;
	    var open = _props.open;
	    var onClose = _props.onClose;
	
	    var props = _objectWithoutProperties(_props, ['children', 'onSelect', 'pullRight', 'className', 'labelledBy', 'open', 'onClose']);
	
	    var items = _utilsValidComponentChildren2['default'].map(children, function (child) {
	      var childProps = child.props || {};
	
	      return _react2['default'].cloneElement(child, {
	        onKeyDown: _utilsCreateChainedFunction2['default'](childProps.onKeyDown, _this.handleKeyDown),
	        onSelect: _utilsCreateChainedFunction2['default'](childProps.onSelect, onSelect)
	      }, childProps.children);
	    });
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'menu')] = true, _classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'menu-right')] = pullRight, _classes);
	
	    var list = _react2['default'].createElement(
	      'ul',
	      _extends({
	        className: _classnames2['default'](className, classes),
	        role: 'menu',
	        'aria-labelledby': labelledBy
	      }, props),
	      items
	    );
	
	    if (open) {
	      list = _react2['default'].createElement(
	        _reactOverlaysLibRootCloseWrapper2['default'],
	        { noWrap: true, onRootClose: onClose },
	        list
	      );
	    }
	
	    return list;
	  };
	
	  return DropdownMenu;
	})(_react2['default'].Component);
	
	DropdownMenu.defaultProps = {
	  bsRole: 'menu',
	  bsClass: 'dropdown',
	  pullRight: false
	};
	
	DropdownMenu.propTypes = {
	  open: _react2['default'].PropTypes.bool,
	  pullRight: _react2['default'].PropTypes.bool,
	  onClose: _react2['default'].PropTypes.func,
	  labelledBy: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  onSelect: _react2['default'].PropTypes.func
	};
	
	exports['default'] = DropdownMenu;
	module.e = exports['default'];


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InputBase2 = __webpack_require__(310);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _utilsChildrenValueInputValidation = __webpack_require__(312);
	
	var _utilsChildrenValueInputValidation2 = _interopRequireDefault(_utilsChildrenValueInputValidation);
	
	var Static = (function (_InputBase) {
	  _inherits(Static, _InputBase);
	
	  function Static() {
	    _classCallCheck(this, Static);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  Static.prototype.getValue = function getValue() {
	    var _props = this.props;
	    var children = _props.children;
	    var value = _props.value;
	
	    return children ? children : value;
	  };
	
	  Static.prototype.renderInput = function renderInput() {
	    return _react2['default'].createElement(
	      'p',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'form-control-static'), ref: 'input', key: 'input' }),
	      this.getValue()
	    );
	  };
	
	  return Static;
	})(_InputBase3['default']);
	
	Static.propTypes = {
	  value: _utilsChildrenValueInputValidation2['default'],
	  children: _utilsChildrenValueInputValidation2['default']
	};
	
	exports['default'] = Static;
	module.e = exports['default'];


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Image = _react2['default'].createClass({
	  displayName: 'Image',
	
	  propTypes: {
	
	    /**
	     * Sets image as responsive image
	     */
	    responsive: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as rounded
	     */
	    rounded: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as circle
	     */
	    circle: _react2['default'].PropTypes.bool,
	
	    /**
	     * Sets image shape as thumbnail
	     */
	    thumbnail: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      responsive: false,
	      rounded: false,
	      circle: false,
	      thumbnail: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'img-responsive': this.props.responsive,
	      'img-rounded': this.props.rounded,
	      'img-circle': this.props.circle,
	      'img-thumbnail': this.props.thumbnail
	    };
	
	    return _react2['default'].createElement('img', _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }));
	  }
	});
	
	exports['default'] = Image;
	module.e = exports['default'];


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	var _interopRequireWildcard = __webpack_require__(488)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputBase2 = __webpack_require__(310);
	
	var _InputBase3 = _interopRequireDefault(_InputBase2);
	
	var _FormControls = __webpack_require__(557);
	
	var FormControls = _interopRequireWildcard(_FormControls);
	
	var _utilsDeprecationWarning = __webpack_require__(228);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var Input = (function (_InputBase) {
	  _inherits(Input, _InputBase);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    _InputBase.apply(this, arguments);
	  }
	
	  Input.prototype.render = function render() {
	    if (this.props.type === 'static') {
	      _utilsDeprecationWarning2['default']('Input type=static', 'FormControls.Static');
	      return _react2['default'].createElement(FormControls.Static, this.props);
	    }
	
	    return _InputBase.prototype.render.call(this);
	  };
	
	  return Input;
	})(_InputBase3['default']);
	
	Input.propTypes = {
	  type: _react2['default'].PropTypes.string
	};
	
	exports['default'] = Input;
	module.e = exports['default'];


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Jumbotron = _react2['default'].createClass({
	  displayName: 'Jumbotron',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return { componentClass: 'div' };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'jumbotron') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Jumbotron;
	module.e = exports['default'];


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var Label = (function (_React$Component) {
	  _inherits(Label, _React$Component);
	
	  function Label() {
	    _classCallCheck(this, _Label);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Label.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'span',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  };
	
	  var _Label = Label;
	  Label = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY), _styleMaps.DEFAULT)(Label) || Label;
	  Label = _utilsBootstrapUtils.bsClass('label')(Label) || Label;
	  return Label;
	})(_react2['default'].Component);
	
	exports['default'] = Label;
	module.e = exports['default'];


/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ListGroupItem = __webpack_require__(560);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var ListGroup = (function (_React$Component) {
	  _inherits(ListGroup, _React$Component);
	
	  function ListGroup() {
	    _classCallCheck(this, ListGroup);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _this = this;
	
	    var items = _utilsValidComponentChildren2['default'].map(this.props.children, function (item, index) {
	      return _react.cloneElement(item, { key: item.key ? item.key : index });
	    });
	
	    if (this.areCustomChildren(items)) {
	      var Component = this.props.componentClass;
	      return _react2['default'].createElement(
	        Component,
	        _extends({}, this.props, {
	          className: _classnames2['default'](this.props.className, 'list-group') }),
	        items
	      );
	    }
	
	    var shouldRenderDiv = false;
	
	    if (!this.props.children) {
	      shouldRenderDiv = true;
	    } else {
	      _utilsValidComponentChildren2['default'].forEach(this.props.children, function (child) {
	        if (_this.isAnchorOrButton(child.props)) {
	          shouldRenderDiv = true;
	        }
	      });
	    }
	
	    return shouldRenderDiv ? this.renderDiv(items) : this.renderUL(items);
	  };
	
	  ListGroup.prototype.isAnchorOrButton = function isAnchorOrButton(props) {
	    return props.href || props.onClick;
	  };
	
	  ListGroup.prototype.areCustomChildren = function areCustomChildren(children) {
	    var customChildren = false;
	
	    _utilsValidComponentChildren2['default'].forEach(children, function (child) {
	      if (child.type !== _ListGroupItem2['default']) {
	        customChildren = true;
	      }
	    }, this);
	
	    return customChildren;
	  };
	
	  ListGroup.prototype.renderUL = function renderUL(items) {
	    var listItems = _utilsValidComponentChildren2['default'].map(items, function (item) {
	      return _react.cloneElement(item, { listItem: true });
	    });
	
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'list-group') }),
	      listItems
	    );
	  };
	
	  ListGroup.prototype.renderDiv = function renderDiv(items) {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'list-group') }),
	      items
	    );
	  };
	
	  return ListGroup;
	})(_react2['default'].Component);
	
	ListGroup.defaultProps = {
	  componentClass: 'div'
	};
	
	ListGroup.propTypes = {
	  className: _react2['default'].PropTypes.string,
	  /**
	   * The element for ListGroup if children are
	   * user-defined custom components.
	   * @type {("ul"|"div")}
	   */
	  componentClass: _react2['default'].PropTypes.oneOf(['ul', 'div']),
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])
	};
	
	exports['default'] = ListGroup;
	module.e = exports['default'];


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibAll = __webpack_require__(229);
	
	var _reactPropTypesLibAll2 = _interopRequireDefault(_reactPropTypesLibAll);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var MenuItem = (function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    _React$Component.call(this, props);
	
	    this.handleClick = this.handleClick.bind(this);
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    if (!this.props.href || this.props.disabled) {
	      event.preventDefault();
	    }
	
	    if (this.props.disabled) {
	      return;
	    }
	
	    if (this.props.onSelect) {
	      this.props.onSelect(event, this.props.eventKey);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var headerClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'header');
	
	    if (this.props.divider) {
	      return _react2['default'].createElement('li', { role: 'separator', className: 'divider' });
	    }
	
	    if (this.props.header) {
	      return _react2['default'].createElement(
	        'li',
	        { role: 'heading', className: headerClass },
	        this.props.children
	      );
	    }
	
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	    var onClick = _props.onClick;
	
	    var props = _objectWithoutProperties(_props, ['className', 'style', 'onClick']);
	
	    var classes = {
	      disabled: this.props.disabled,
	      active: this.props.active
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { role: 'presentation',
	        className: _classnames2['default'](className, classes),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], _extends({}, props, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: _utilsCreateChainedFunction2['default'](onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	})(_react2['default'].Component);
	
	MenuItem.propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  divider: _reactPropTypesLibAll2['default'](_react2['default'].PropTypes.bool, function (props) {
	    if (props.divider && props.children) {
	      return new Error('Children will not be rendered for dividers');
	    }
	  }),
	  eventKey: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.bool,
	  href: _react2['default'].PropTypes.string,
	  target: _react2['default'].PropTypes.string,
	  title: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  onKeyDown: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])
	};
	
	MenuItem.defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	exports['default'] = _utilsBootstrapUtils.bsClass('dropdown', MenuItem);
	module.e = exports['default'];


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	/* eslint-disable react/prop-types */
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var _domHelpersUtilScrollbarSize = __webpack_require__(525);
	
	var _domHelpersUtilScrollbarSize2 = _interopRequireDefault(_domHelpersUtilScrollbarSize);
	
	var _domHelpersUtilInDOM = __webpack_require__(127);
	
	var _domHelpersUtilInDOM2 = _interopRequireDefault(_domHelpersUtilInDOM);
	
	var _domHelpersOwnerDocument = __webpack_require__(150);
	
	var _domHelpersOwnerDocument2 = _interopRequireDefault(_domHelpersOwnerDocument);
	
	var _domHelpersEvents = __webpack_require__(1372);
	
	var _domHelpersEvents2 = _interopRequireDefault(_domHelpersEvents);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Fade = __webpack_require__(307);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalDialog = __webpack_require__(1571);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalBody = __webpack_require__(561);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalHeader = __webpack_require__(563);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(564);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _ModalFooter = __webpack_require__(562);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _reactOverlaysLibModal = __webpack_require__(1613);
	
	var _reactOverlaysLibModal2 = _interopRequireDefault(_reactOverlaysLibModal);
	
	var _reactOverlaysLibUtilsIsOverflowing = __webpack_require__(575);
	
	var _reactOverlaysLibUtilsIsOverflowing2 = _interopRequireDefault(_reactOverlaysLibUtilsIsOverflowing);
	
	var _lodashCompatObjectPick = __webpack_require__(224);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var Modal = _react2['default'].createClass({
	  displayName: 'Modal',
	
	  propTypes: _extends({}, _reactOverlaysLibModal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	    /**
	     * Include a backdrop component. Specify 'static' for a backdrop that doesn't trigger an "onHide" when clicked.
	     */
	    backdrop: _react2['default'].PropTypes.oneOf(['static', true, false]),
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2['default'].PropTypes.bool,
	
	    /**
	     * Open and close the Modal with a slide and fade animation.
	     */
	    animation: _react2['default'].PropTypes.bool,
	
	    /**
	     * A Component type that provides the modal content Markup. This is a useful prop when you want to use your own
	     * styles and markup to create a custom modal component.
	     */
	    dialogComponent: _reactPropTypesLibElementType2['default'],
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and replace it to the last focused element when it closes.
	     * Generally this should never be set to false as it makes the Modal less accessible to assistive technologies, like screen-readers.
	     */
	    autoFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     * Consider leaving the default value here, as it is necessary to make the Modal work well with assistive technologies,
	     * such as screen readers.
	     */
	    enforceFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * Hide this from automatic props documentation generation.
	     * @private
	     */
	    bsStyle: _react2['default'].PropTypes.string,
	
	    /**
	     * When `true` The modal will show itself.
	     */
	    show: _react2['default'].PropTypes.bool,
	
	    /**
	     * A callback fired when the header closeButton or non-static backdrop is
	     * clicked. Required if either are specified.
	     */
	    onHide: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2['default'].PropTypes.func
	  }),
	
	  childContextTypes: {
	    '$bs_onModalHide': _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return _extends({}, _reactOverlaysLibModal2['default'].defaultProps, {
	      bsClass: 'modal',
	      animation: true,
	      dialogComponent: _ModalDialog2['default']
	    });
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      modalStyles: {}
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_onModalHide: this.props.onHide
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _domHelpersEvents2['default'].off(window, 'resize', this.handleWindowResize);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var dialogClassName = _props.dialogClassName;
	    var animation = _props.animation;
	
	    var props = _objectWithoutProperties(_props, ['className', 'children', 'dialogClassName', 'animation']);
	
	    var modalStyles = this.state.modalStyles;
	
	    var inClass = { 'in': props.show && !animation };
	    var Dialog = props.dialogComponent;
	
	    var parentProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_reactOverlaysLibModal2['default'].propTypes).concat(['onExit', 'onExiting', 'onEnter', 'onEntered']) // the rest are fired in _onHide() and _onShow()
	    );
	
	    var modal = _react2['default'].createElement(
	      Dialog,
	      _extends({
	        key: 'modal',
	        ref: function (ref) {
	          return _this._modal = ref;
	        }
	      }, props, {
	        style: modalStyles,
	        className: _classnames2['default'](className, inClass),
	        dialogClassName: dialogClassName,
	        onClick: props.backdrop === true ? this.handleDialogClick : null
	      }),
	      this.props.children
	    );
	
	    return _react2['default'].createElement(
	      _reactOverlaysLibModal2['default'],
	      _extends({}, parentProps, {
	        show: props.show,
	        ref: function (ref) {
	          _this._wrapper = ref && ref.refs.modal;
	          _this._backdrop = ref && ref.refs.backdrop;
	        },
	        onEntering: this._onShow,
	        onExited: this._onHide,
	        backdropClassName: _classnames2['default'](_utilsBootstrapUtils2['default'].prefix(props, 'backdrop'), inClass),
	        containerClassName: _utilsBootstrapUtils2['default'].prefix(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      modal
	    );
	  },
	
	  _onShow: function _onShow() {
	    _domHelpersEvents2['default'].on(window, 'resize', this.handleWindowResize);
	
	    this.setState(this._getStyles());
	
	    if (this.props.onEntering) {
	      var _props2;
	
	      (_props2 = this.props).onEntering.apply(_props2, arguments);
	    }
	  },
	
	  _onHide: function _onHide() {
	    _domHelpersEvents2['default'].off(window, 'resize', this.handleWindowResize);
	
	    if (this.props.onExited) {
	      var _props3;
	
	      (_props3 = this.props).onExited.apply(_props3, arguments);
	    }
	  },
	
	  handleDialogClick: function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  },
	
	  handleWindowResize: function handleWindowResize() {
	    this.setState(this._getStyles());
	  },
	
	  _getStyles: function _getStyles() {
	    if (!_domHelpersUtilInDOM2['default']) {
	      return {};
	    }
	
	    var node = _reactDom2['default'].findDOMNode(this._modal);
	    var doc = _domHelpersOwnerDocument2['default'](node);
	
	    var scrollHt = node.scrollHeight;
	    var bodyIsOverflowing = _reactOverlaysLibUtilsIsOverflowing2['default'](_reactDom2['default'].findDOMNode(this.props.container || doc.body));
	    var modalIsOverflowing = scrollHt > doc.documentElement.clientHeight;
	
	    return {
	      modalStyles: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? _domHelpersUtilScrollbarSize2['default']() : void 0,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? _domHelpersUtilScrollbarSize2['default']() : void 0
	      }
	    };
	  }
	});
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], _utilsBootstrapUtils.bsClass('modal', Modal));
	module.e = exports['default'];


/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint-disable react/prop-types */
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var ModalDialog = _react2['default'].createClass({
	  displayName: 'ModalDialog',
	
	  propTypes: {
	    /**
	     * A css class to apply to the Modal dialog DOM node.
	     */
	    dialogClassName: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var modalStyle = _extends({
	      display: 'block'
	    }, this.props.style);
	    var prefix = _utilsBootstrapUtils2['default'].prefix(this.props);
	    var dialogClasses = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    delete dialogClasses[prefix];
	    dialogClasses[_utilsBootstrapUtils2['default'].prefix(this.props, 'dialog')] = true;
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        title: null,
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: _classnames2['default'](this.props.className, prefix)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: _classnames2['default'](this.props.dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'content'), role: 'document' },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL], _utilsBootstrapUtils.bsClass('modal', ModalDialog));
	module.e = exports['default'];


/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(227);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var NavDropdown = (function (_React$Component) {
	  _inherits(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    _classCallCheck(this, NavDropdown);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  NavDropdown.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	    var noCaret = _props.noCaret;
	
	    var props = _objectWithoutProperties(_props, ['children', 'title', 'noCaret']);
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      _extends({}, props, { componentClass: 'li' }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        {
	          useAnchor: true,
	          disabled: props.disabled,
	          noCaret: noCaret
	        },
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return NavDropdown;
	})(_react2['default'].Component);
	
	NavDropdown.propTypes = _extends({
	  noCaret: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.node.isRequired
	}, _Dropdown2['default'].propTypes);
	
	exports['default'] = NavDropdown;
	module.e = exports['default'];


/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint react/no-multi-comp: 0 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(623);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(178);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _utilsDeprecationWarning = __webpack_require__(228);
	
	var _utilsDeprecationWarning2 = _interopRequireDefault(_utilsDeprecationWarning);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _Grid = __webpack_require__(309);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _deprecatedNavbar = __webpack_require__(1596);
	
	var _deprecatedNavbar2 = _interopRequireDefault(_deprecatedNavbar);
	
	var _NavbarBrand = __webpack_require__(311);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarHeader = __webpack_require__(1575);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(1576);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _NavbarCollapse = __webpack_require__(1574);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var has = function has(obj, key) {
	  return obj && ({}).hasOwnProperty.call(obj, key);
	};
	
	function shouldRenderOldNavbar(component) {
	  var props = component.props;
	  return has(props, 'brand') || has(props, 'toggleButton') || has(props, 'toggleNavKey') || has(props, 'navExpanded') || has(props, 'defaultNavExpanded') ||
	  // this should be safe b/c the new version requires wrapping in a Header
	  _utilsValidComponentChildren2['default'].findValidComponents(props.children, function (child) {
	    return child.props.bsRole === 'brand';
	  }).length > 0;
	}
	
	var Navbar = _react2['default'].createClass({
	  displayName: 'Navbar',
	
	  propTypes: {
	    /**
	     * Create a fixed navbar along the top of the screen, that scrolls with the page
	     */
	    fixedTop: _react2['default'].PropTypes.bool,
	    /**
	     * Create a fixed navbar along the bottom of the screen, that scrolls with the page
	     */
	    fixedBottom: _react2['default'].PropTypes.bool,
	    /**
	     * Create a full-width navbar that scrolls away with the page
	     */
	    staticTop: _react2['default'].PropTypes.bool,
	    /**
	     * An alternative dark visual style for the Navbar
	     */
	    inverse: _react2['default'].PropTypes.bool,
	    /**
	     * Allow the Navbar to fluidly adjust to the page or container width, instead of at the
	     * predefined screen breakpoints
	     */
	    fluid: _react2['default'].PropTypes.bool,
	
	    /**
	     * Set a custom element for this component.
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    /**
	     * A callback fired when the `<Navbar>` body collapses or expands.
	     * Fired when a `<Navbar.Toggle>` is clicked and called with the new `navExpanded` boolean value.
	     *
	     * @controllable navExpanded
	     */
	    onToggle: _react2['default'].PropTypes.func,
	
	    /**
	     * Explicitly set the visiblity of the navbar body
	     *
	     * @controllable onToggle
	     */
	    expanded: _react2['default'].PropTypes.bool,
	
	    /**
	     * @deprecated
	     */
	    navExpanded: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.bool, 'Use `expanded` and `defaultExpanded` instead.')
	  },
	
	  childContextTypes: {
	    $bs_navbar: _react.PropTypes.bool,
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_onToggle: _react.PropTypes.func,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'nav',
	      fixedTop: false,
	      fixedBottom: false,
	      staticTop: false,
	      inverse: false,
	      fluid: false
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_navbar: true,
	      $bs_navbar_bsClass: this.props.bsClass,
	      $bs_navbar_onToggle: this.handleToggle,
	      $bs_navbar_expanded: this.props.expanded
	    };
	  },
	
	  handleToggle: function handleToggle() {
	    this.props.onToggle(!this.props.expanded);
	  },
	
	  isNavExpanded: function isNavExpanded() {
	    return !!this.props.expanded;
	  },
	
	  render: function render() {
	    if (shouldRenderOldNavbar(this)) {
	      _utilsDeprecationWarning2['default']({ message: 'Rendering a deprecated version of the Navbar due to the use of deprecated ' + 'props. Please use the new Navbar api, and remove `toggleButton`, ' + '`toggleNavKey`, `brand`, `navExpanded`, `defaultNavExpanded` props or the ' + 'use of the `<NavBrand>` component outside of a `<Navbar.Header>`. \n\n' + 'for more details see: http://react-bootstrap.github.io/components.html#navbars'
	      });
	
	      return _react2['default'].createElement(_deprecatedNavbar2['default'], this.props);
	    }
	
	    var _props = this.props;
	    var fixedTop = _props.fixedTop;
	    var fixedBottom = _props.fixedBottom;
	    var staticTop = _props.staticTop;
	    var inverse = _props.inverse;
	    var ComponentClass = _props.componentClass;
	    var fluid = _props.fluid;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'componentClass', 'fluid', 'className', 'children']);
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	    if (props.role === undefined && ComponentClass !== 'nav') {
	      props.role = 'navigation';
	    }
	
	    if (inverse) {
	      props.bsStyle = _styleMaps.INVERSE;
	    }
	
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-top')] = fixedTop;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-bottom')] = fixedBottom;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'static-top')] = staticTop;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](className, classes) }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  }
	});
	
	var NAVBAR_STATES = [_styleMaps.DEFAULT, _styleMaps.INVERSE];
	
	Navbar = _utilsBootstrapUtils.bsStyles(NAVBAR_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('navbar', _uncontrollable2['default'](Navbar, { expanded: 'onToggle' })));
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var wrapper = function wrapper(_ref, _ref2) {
	    var Tag = _ref.componentClass;
	    var className = _ref.className;
	
	    var props = _objectWithoutProperties(_ref, ['componentClass', 'className']);
	
	    var _classNames;
	
	    var _ref2$$bs_navbar_bsClass = _ref2.$bs_navbar_bsClass;
	    var bsClass = _ref2$$bs_navbar_bsClass === undefined ? 'navbar' : _ref2$$bs_navbar_bsClass;
	    return _react2['default'].createElement(Tag, _extends({}, props, {
	      className: _classnames2['default'](className, _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, suffix), (_classNames = {}, _classNames[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'right')] = props.pullRight, _classNames[_utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'left')] = props.pullLeft, _classNames))
	    }));
	  };
	
	  wrapper.displayName = displayName;
	
	  wrapper.propTypes = {
	    componentClass: _reactPropTypesLibElementType2['default'],
	    pullRight: _react2['default'].PropTypes.bool,
	    pullLeft: _react2['default'].PropTypes.bool
	  };
	  wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  wrapper.contextTypes = {
	    $bs_navbar_bsClass: _react.PropTypes.string
	  };
	
	  return wrapper;
	}
	
	Navbar.Brand = _NavbarBrand2['default'];
	Navbar.Header = _NavbarHeader2['default'];
	Navbar.Toggle = _NavbarToggle2['default'];
	Navbar.Collapse = _NavbarCollapse2['default'];
	
	Navbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	Navbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	Navbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	exports['default'] = Navbar;
	module.e = exports['default'];


/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _Collapse = __webpack_require__(176);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var NavbarCollapse = _react2['default'].createClass({
	  displayName: 'NavbarCollapse',
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_expanded: _react.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    var _context = this.context;
	    var _context$$bs_navbar_bsClass = _context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	    var expanded = _context.$bs_navbar_expanded;
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      _extends({ 'in': expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'collapse') },
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = NavbarCollapse;
	module.e = exports['default'];


/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var NavbarHeader = _react2['default'].createClass({
	  displayName: 'NavbarHeader',
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    var _context$$bs_navbar_bsClass = this.context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'header') },
	      children
	    );
	  }
	});
	
	exports['default'] = NavbarHeader;
	module.e = exports['default'];


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var NavbarToggle = _react2['default'].createClass({
	  displayName: 'NavbarToggle',
	
	  propTypes: {
	    /**
	     * The toggle content, if left empty it will render the default toggle (seen above).
	     */
	    children: _react.PropTypes.node
	  },
	
	  contextTypes: {
	    $bs_navbar_bsClass: _react.PropTypes.string,
	    $bs_navbar_onToggle: _react.PropTypes.func
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    var _context = this.context;
	    var _context$$bs_navbar_bsClass = _context.$bs_navbar_bsClass;
	    var bsClass = _context$$bs_navbar_bsClass === undefined ? 'navbar' : _context$$bs_navbar_bsClass;
	    var onToggle = _context.$bs_navbar_onToggle;
	
	    return _react2['default'].createElement(
	      'button',
	      { type: 'button',
	        onClick: onToggle,
	        className: _utilsBootstrapUtils2['default'].prefix({ bsClass: bsClass }, 'toggle')
	      },
	      children || [_react2['default'].createElement(
	        'span',
	        { className: 'sr-only', key: 0 },
	        'Toggle navigation'
	      ), _react2['default'].createElement('span', { className: 'icon-bar', key: 1 }), _react2['default'].createElement('span', { className: 'icon-bar', key: 2 }), _react2['default'].createElement('span', { className: 'icon-bar', key: 3 })]
	    );
	  }
	});
	
	exports['default'] = NavbarToggle;
	module.e = exports['default'];


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint-disable react/prop-types */
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _domHelpersQueryContains = __webpack_require__(173);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _lodashCompatObjectPick = __webpack_require__(224);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(568);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var OverlayTrigger = _react2['default'].createClass({
	  displayName: 'OverlayTrigger',
	
	  propTypes: _extends({}, _Overlay2['default'].propTypes, {
	
	    /**
	    * Specify which action or actions trigger Overlay visibility
	    */
	    trigger: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']), _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']))]),
	
	    /**
	     * A millisecond delay amount to show and hide the Overlay once triggered
	     */
	    delay: _react2['default'].PropTypes.number,
	    /**
	     * A millisecond delay amount before showing the Overlay once triggered.
	     */
	    delayShow: _react2['default'].PropTypes.number,
	    /**
	     * A millisecond delay amount before hiding the Overlay once triggered.
	     */
	    delayHide: _react2['default'].PropTypes.number,
	
	    /**
	     * The initial visibility state of the Overlay, for more nuanced visibility controll consider
	     * using the Overlay component directly.
	     */
	    defaultOverlayShown: _react2['default'].PropTypes.bool,
	
	    /**
	     * An element or text to overlay next to the target.
	     */
	    overlay: _react2['default'].PropTypes.node.isRequired,
	
	    /**
	     * @private
	     */
	    onBlur: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onClick: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onFocus: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onMouseEnter: _react2['default'].PropTypes.func,
	    /**
	     * @private
	     */
	    onMouseLeave: _react2['default'].PropTypes.func,
	
	    // override specific overlay props
	    /**
	     * @private
	     */
	    target: function target() {},
	    /**
	    * @private
	    */
	    onHide: function onHide() {},
	    /**
	     * @private
	     */
	    show: function show() {}
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultOverlayShown: false,
	      trigger: ['hover', 'focus']
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isOverlayShown: this.props.defaultOverlayShown
	    };
	  },
	
	  show: function show() {
	    this.setState({
	      isOverlayShown: true
	    });
	  },
	
	  hide: function hide() {
	    this.setState({
	      isOverlayShown: false
	    });
	  },
	
	  toggle: function toggle() {
	    if (this.state.isOverlayShown) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.handleMouseOver = this.handleMouseOverOut.bind(null, this.handleDelayedShow);
	    this.handleMouseOut = this.handleMouseOverOut.bind(null, this.handleDelayedHide);
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  },
	
	  renderOverlay: function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this._mountNode) {
	      this.renderOverlay();
	    }
	  },
	
	  getOverlayTarget: function getOverlayTarget() {
	    return _reactDom2['default'].findDOMNode(this);
	  },
	
	  getOverlay: function getOverlay() {
	    var overlayProps = _extends({}, _lodashCompatObjectPick2['default'](this.props, _Object$keys(_Overlay2['default'].propTypes)), {
	      show: this.state.isOverlayShown,
	      onHide: this.hide,
	      target: this.getOverlayTarget,
	      onExit: this.props.onExit,
	      onExiting: this.props.onExiting,
	      onExited: this.props.onExited,
	      onEnter: this.props.onEnter,
	      onEntering: this.props.onEntering,
	      onEntered: this.props.onEntered
	    });
	
	    var overlay = _react.cloneElement(this.props.overlay, {
	      placement: overlayProps.placement,
	      container: overlayProps.container
	    });
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      overlayProps,
	      overlay
	    );
	  },
	
	  render: function render() {
	    var trigger = _react2['default'].Children.only(this.props.children);
	    var triggerProps = trigger.props;
	
	    var props = {
	      'aria-describedby': this.props.overlay.props.id
	    };
	
	    // create in render otherwise owner is lost...
	    this._overlay = this.getOverlay();
	
	    props.onClick = _utilsCreateChainedFunction2['default'](triggerProps.onClick, this.props.onClick);
	
	    if (isOneOf('click', this.props.trigger)) {
	      props.onClick = _utilsCreateChainedFunction2['default'](this.toggle, props.onClick);
	    }
	
	    if (isOneOf('hover', this.props.trigger)) {
	       false ? _warning2['default'](!(this.props.trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibilty of the overlay to just mouse users. ' + 'Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.') : undefined;
	
	      props.onMouseOver = _utilsCreateChainedFunction2['default'](this.handleMouseOver, this.props.onMouseOver, triggerProps.onMouseOver);
	      props.onMouseOut = _utilsCreateChainedFunction2['default'](this.handleMouseOut, this.props.onMouseOut, triggerProps.onMouseOut);
	    }
	
	    if (isOneOf('focus', this.props.trigger)) {
	      props.onFocus = _utilsCreateChainedFunction2['default'](this.handleDelayedShow, this.props.onFocus, triggerProps.onFocus);
	      props.onBlur = _utilsCreateChainedFunction2['default'](this.handleDelayedHide, this.props.onBlur, triggerProps.onBlur);
	    }
	
	    return _react.cloneElement(trigger, props);
	  },
	
	  handleDelayedShow: function handleDelayedShow() {
	    var _this = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.isOverlayShown || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this._hoverShowDelay = null;
	      _this.show();
	    }, delay);
	  },
	
	  handleDelayedHide: function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.isOverlayShown || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  },
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker moving
	  // from one child element to another.
	  handleMouseOverOut: function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !_domHelpersQueryContains2['default'](target, related)) {
	      handler(e);
	    }
	  }
	
	});
	
	exports['default'] = OverlayTrigger;
	module.e = exports['default'];


/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var PageHeader = _react2['default'].createClass({
	  displayName: 'PageHeader',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'page-header') }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = PageHeader;
	module.e = exports['default'];


/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var PageItem = _react2['default'].createClass({
	  displayName: 'PageItem',
	
	  propTypes: {
	    href: _react2['default'].PropTypes.string,
	    target: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.string,
	    disabled: _react2['default'].PropTypes.bool,
	    previous: _react2['default'].PropTypes.bool,
	    next: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    eventKey: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      previous: false,
	      next: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'disabled': this.props.disabled,
	      'previous': this.props.previous,
	      'next': this.props.next
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, classes) }),
	      _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        {
	          href: this.props.href,
	          title: this.props.title,
	          target: this.props.target,
	          onClick: this.handleSelect },
	        this.props.children
	      )
	    );
	  },
	
	  handleSelect: function handleSelect(e) {
	    if (this.props.onSelect || this.props.disabled) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, this.props.href, this.props.target);
	      }
	    }
	  }
	});
	
	exports['default'] = PageItem;
	module.e = exports['default'];


/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var Pager = _react2['default'].createClass({
	  displayName: 'Pager',
	
	  propTypes: {
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'pager') }),
	      _utilsValidComponentChildren2['default'].map(this.props.children, this.renderPageItem)
	    );
	  },
	
	  renderPageItem: function renderPageItem(child, index) {
	    return _react.cloneElement(child, {
	      onSelect: _utilsCreateChainedFunction2['default'](child.props.onSelect, this.props.onSelect),
	      key: child.key ? child.key : index
	    });
	  }
	});
	
	exports['default'] = Pager;
	module.e = exports['default'];


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _PaginationButton = __webpack_require__(1582);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var Pagination = _react2['default'].createClass({
	  displayName: 'Pagination',
	
	  propTypes: {
	    activePage: _react2['default'].PropTypes.number,
	    items: _react2['default'].PropTypes.number,
	    maxButtons: _react2['default'].PropTypes.number,
	    /**
	     * When `true`, will display the first and the last button page
	     */
	    boundaryLinks: _react2['default'].PropTypes.bool,
	    /**
	     * When `true`, will display the default node value ('&hellip;').
	     * Otherwise, will display provided node (when specified).
	     */
	    ellipsis: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&laquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    first: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&raquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    last: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&lsaquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    prev: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    /**
	     * When `true`, will display the default node value ('&rsaquo;').
	     * Otherwise, will display provided node (when specified).
	     */
	    next: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	    onSelect: _react2['default'].PropTypes.func,
	    /**
	     * You can use a custom element for the buttons
	     */
	    buttonComponentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activePage: 1,
	      items: 1,
	      maxButtons: 0,
	      first: false,
	      last: false,
	      prev: false,
	      next: false,
	      ellipsis: true,
	      boundaryLinks: false,
	      buttonComponentClass: _SafeAnchor2['default'],
	      bsClass: 'pagination'
	    };
	  },
	
	  renderPageButtons: function renderPageButtons() {
	    var pageButtons = [];
	    var startPage = undefined,
	        endPage = undefined,
	        hasHiddenPagesAfter = undefined;
	    var _props = this.props;
	    var maxButtons = _props.maxButtons;
	    var activePage = _props.activePage;
	    var items = _props.items;
	    var onSelect = _props.onSelect;
	    var ellipsis = _props.ellipsis;
	    var buttonComponentClass = _props.buttonComponentClass;
	    var boundaryLinks = _props.boundaryLinks;
	
	    if (maxButtons) {
	      var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
	      startPage = hiddenPagesBefore > 1 ? hiddenPagesBefore : 1;
	      hasHiddenPagesAfter = startPage + maxButtons <= items;
	
	      if (!hasHiddenPagesAfter) {
	        endPage = items;
	        startPage = items - maxButtons + 1;
	        if (startPage < 1) {
	          startPage = 1;
	        }
	      } else {
	        endPage = startPage + maxButtons - 1;
	      }
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: pagenumber,
	          eventKey: pagenumber,
	          active: pagenumber === activePage,
	          onSelect: onSelect,
	          buttonComponentClass: buttonComponentClass },
	        pagenumber
	      ));
	    }
	
	    if (boundaryLinks && ellipsis && startPage !== 1) {
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsisFirst',
	          disabled: true,
	          buttonComponentClass: buttonComponentClass },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          this.props.ellipsis === true ? '…' : this.props.ellipsis
	        )
	      ));
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 1,
	          eventKey: 1,
	          active: false,
	          onSelect: onSelect,
	          buttonComponentClass: buttonComponentClass },
	        '1'
	      ));
	    }
	
	    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsis',
	          disabled: true,
	          buttonComponentClass: buttonComponentClass },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          this.props.ellipsis === true ? '…' : this.props.ellipsis
	        )
	      ));
	
	      if (boundaryLinks && endPage !== items) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          {
	            key: items,
	            eventKey: items,
	            active: false,
	            onSelect: onSelect,
	            buttonComponentClass: buttonComponentClass },
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  },
	
	  renderPrev: function renderPrev() {
	    if (!this.props.prev) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'prev',
	        eventKey: this.props.activePage - 1,
	        disabled: this.props.activePage === 1,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Previous' },
	        this.props.prev === true ? '‹' : this.props.prev
	      )
	    );
	  },
	
	  renderNext: function renderNext() {
	    if (!this.props.next) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'next',
	        eventKey: this.props.activePage + 1,
	        disabled: this.props.activePage >= this.props.items,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Next' },
	        this.props.next === true ? '›' : this.props.next
	      )
	    );
	  },
	
	  renderFirst: function renderFirst() {
	    if (!this.props.first) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'first',
	        eventKey: 1,
	        disabled: this.props.activePage === 1,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'First' },
	        this.props.first === true ? '«' : this.props.first
	      )
	    );
	  },
	
	  renderLast: function renderLast() {
	    if (!this.props.last) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _PaginationButton2['default'],
	      {
	        key: 'last',
	        eventKey: this.props.items,
	        disabled: this.props.activePage >= this.props.items,
	        onSelect: this.props.onSelect,
	        buttonComponentClass: this.props.buttonComponentClass },
	      _react2['default'].createElement(
	        'span',
	        { 'aria-label': 'Last' },
	        this.props.last === true ? '»' : this.props.last
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'ul',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].getClassSet(this.props)) }),
	      this.renderFirst(),
	      this.renderPrev(),
	      this.renderPageButtons(),
	      this.renderNext(),
	      this.renderLast()
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('pagination', Pagination);
	module.e = exports['default'];


/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsCreateSelectedEvent = __webpack_require__(1599);
	
	var _utilsCreateSelectedEvent2 = _interopRequireDefault(_utilsCreateSelectedEvent);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var PaginationButton = _react2['default'].createClass({
	  displayName: 'PaginationButton',
	
	  propTypes: {
	    className: _react2['default'].PropTypes.string,
	    eventKey: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    onSelect: _react2['default'].PropTypes.func,
	    disabled: _react2['default'].PropTypes.bool,
	    active: _react2['default'].PropTypes.bool,
	    /**
	     * You can use a custom element for this component
	     */
	    buttonComponentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  handleClick: function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    if (this.props.onSelect) {
	      var selectedEvent = _utilsCreateSelectedEvent2['default'](this.props.eventKey);
	      this.props.onSelect(event, selectedEvent);
	    }
	  },
	
	  render: function render() {
	    var classes = {
	      active: this.props.active,
	      disabled: this.props.disabled
	    };
	
	    var _props = this.props;
	    var className = _props.className;
	
	    var anchorProps = _objectWithoutProperties(_props, ['className']);
	
	    var ButtonComponentClass = this.props.buttonComponentClass;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: _classnames2['default'](className, classes) },
	      _react2['default'].createElement(ButtonComponentClass, _extends({}, anchorProps, {
	        onClick: this.handleClick }))
	    );
	  }
	});
	
	exports['default'] = PaginationButton;
	module.e = exports['default'];


/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var _Collapse = __webpack_require__(176);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var Panel = _react2['default'].createClass({
	  displayName: 'Panel',
	
	  propTypes: {
	    collapsible: _react2['default'].PropTypes.bool,
	    onSelect: _react2['default'].PropTypes.func,
	    header: _react2['default'].PropTypes.node,
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    footer: _react2['default'].PropTypes.node,
	    defaultExpanded: _react2['default'].PropTypes.bool,
	    expanded: _react2['default'].PropTypes.bool,
	    eventKey: _react2['default'].PropTypes.any,
	    headerRole: _react2['default'].PropTypes.string,
	    panelRole: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultExpanded: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      expanded: this.props.defaultExpanded
	    };
	  },
	
	  handleSelect: function handleSelect(e) {
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(e, this.props.eventKey);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.handleToggle();
	    }
	  },
	
	  handleToggle: function handleToggle() {
	    this.setState({ expanded: !this.state.expanded });
	  },
	
	  isExpanded: function isExpanded() {
	    return this.props.expanded != null ? this.props.expanded : this.state.expanded;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var headerRole = _props.headerRole;
	    var panelRole = _props.panelRole;
	
	    var props = _objectWithoutProperties(_props, ['headerRole', 'panelRole']);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: _classnames2['default'](this.props.className, _utilsBootstrapUtils2['default'].getClassSet(this.props)),
	        id: this.props.collapsible ? null : this.props.id, onSelect: null }),
	      this.renderHeading(headerRole),
	      this.props.collapsible ? this.renderCollapsibleBody(panelRole) : this.renderBody(),
	      this.renderFooter()
	    );
	  },
	
	  renderCollapsibleBody: function renderCollapsibleBody(panelRole) {
	    var props = {
	      className: _utilsBootstrapUtils2['default'].prefix(this.props, 'collapse'),
	      id: this.props.id,
	      ref: 'panel',
	      'aria-hidden': !this.isExpanded()
	    };
	    if (panelRole) {
	      props.role = panelRole;
	    }
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      { 'in': this.isExpanded() },
	      _react2['default'].createElement(
	        'div',
	        props,
	        this.renderBody()
	      )
	    );
	  },
	
	  renderBody: function renderBody() {
	    var _this = this;
	
	    var allChildren = this.props.children;
	    var bodyElements = [];
	    var panelBodyChildren = [];
	    var bodyClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'body');
	
	    function getProps() {
	      return { key: bodyElements.length };
	    }
	
	    function addPanelChild(child) {
	      bodyElements.push(_react.cloneElement(child, getProps()));
	    }
	
	    function addPanelBody(children) {
	      bodyElements.push(_react2['default'].createElement(
	        'div',
	        _extends({ className: bodyClass }, getProps()),
	        children
	      ));
	    }
	
	    function maybeRenderPanelBody() {
	      if (panelBodyChildren.length === 0) {
	        return;
	      }
	
	      addPanelBody(panelBodyChildren);
	      panelBodyChildren = [];
	    }
	
	    // Handle edge cases where we should not iterate through children.
	    if (!Array.isArray(allChildren) || allChildren.length === 0) {
	      if (this.shouldRenderFill(allChildren)) {
	        addPanelChild(allChildren);
	      } else {
	        addPanelBody(allChildren);
	      }
	    } else {
	      allChildren.forEach(function (child) {
	        if (_this.shouldRenderFill(child)) {
	          maybeRenderPanelBody();
	
	          // Separately add the filled element.
	          addPanelChild(child);
	        } else {
	          panelBodyChildren.push(child);
	        }
	      });
	
	      maybeRenderPanelBody();
	    }
	
	    return bodyElements;
	  },
	
	  shouldRenderFill: function shouldRenderFill(child) {
	    return _react2['default'].isValidElement(child) && child.props.fill != null;
	  },
	
	  renderHeading: function renderHeading(headerRole) {
	    var header = this.props.header;
	
	    if (!header) {
	      return null;
	    }
	
	    if (!_react2['default'].isValidElement(header) || Array.isArray(header)) {
	      header = this.props.collapsible ? this.renderCollapsibleTitle(header, headerRole) : header;
	    } else {
	      var className = _classnames2['default'](_utilsBootstrapUtils2['default'].prefix(this.props, 'title'), header.props.className);
	
	      if (this.props.collapsible) {
	        header = _react.cloneElement(header, {
	          className: className,
	          children: this.renderAnchor(header.props.children, headerRole)
	        });
	      } else {
	        header = _react.cloneElement(header, { className: className });
	      }
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'heading') },
	      header
	    );
	  },
	
	  renderAnchor: function renderAnchor(header, headerRole) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        href: '#' + (this.props.id || ''),
	        'aria-controls': this.props.collapsible ? this.props.id : null,
	        className: this.isExpanded() ? null : 'collapsed',
	        'aria-expanded': this.isExpanded(),
	        'aria-selected': this.isExpanded(),
	        onClick: this.handleSelect,
	        role: headerRole },
	      header
	    );
	  },
	
	  renderCollapsibleTitle: function renderCollapsibleTitle(header, headerRole) {
	    return _react2['default'].createElement(
	      'h4',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'title'), role: 'presentation' },
	      this.renderAnchor(header, headerRole)
	    );
	  },
	
	  renderFooter: function renderFooter() {
	    if (!this.props.footer) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'footer') },
	      this.props.footer
	    );
	  }
	});
	
	var PANEL_STATES = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY);
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(PANEL_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('panel', Panel));
	module.e = exports['default'];


/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(316);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var Popover = _react2['default'].createClass({
	  displayName: 'Popover',
	
	  propTypes: {
	
	    /**
	     * An html id attribute, necessary for accessibility
	     * @type {string}
	     * @required
	     */
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Sets the direction the Popover is positioned towards.
	     */
	    placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The "left" position value for the Popover.
	     */
	    positionLeft: _react2['default'].PropTypes.number,
	    /**
	     * The "top" position value for the Popover.
	     */
	    positionTop: _react2['default'].PropTypes.number,
	    /**
	     * The "left" position value for the Popover arrow.
	     */
	    arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * The "top" position value for the Popover arrow.
	     */
	    arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * Title text
	     */
	    title: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placement: 'right',
	      bsClass: 'popover'
	    };
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = true, _classes[this.props.placement] = true, _classes);
	
	    var style = _extends({
	      'left': this.props.positionLeft,
	      'top': this.props.positionTop,
	      'display': 'block'
	    }, this.props.style);
	
	    // eslint-disable-line react/prop-types
	    var arrowStyle = {
	      'left': this.props.arrowOffsetLeft,
	      'top': this.props.arrowOffsetTop
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({ role: 'tooltip' }, this.props, { className: _classnames2['default'](this.props.className, classes), style: style, title: null }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      this.props.title ? this.renderTitle() : null,
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'content') },
	        this.props.children
	      )
	    );
	  },
	
	  renderTitle: function renderTitle() {
	    return _react2['default'].createElement(
	      'h3',
	      { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'title') },
	      this.props.title
	    );
	  }
	});
	
	exports['default'] = Popover;
	module.e = exports['default'];
	// we don't want to expose the `style` property


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Interpolate = __webpack_require__(559);
	
	var _Interpolate2 = _interopRequireDefault(_Interpolate);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	/**
	 * Custom propTypes checker
	 */
	function onlyProgressBar(props, propName, componentName) {
	  if (props[propName]) {
	    var _ret = (function () {
	      var error = undefined,
	          childIdentifier = undefined;
	
	      _react2['default'].Children.forEach(props[propName], function (child) {
	        if (child.type !== ProgressBar) {
	          //eslint-disable-line
	          childIdentifier = child.type.displayName ? child.type.displayName : child.type;
	          error = new Error('Children of ' + componentName + ' can contain only ProgressBar components. Found ' + childIdentifier);
	        }
	      });
	
	      return {
	        v: error
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  }
	}
	
	var ProgressBar = (function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ProgressBar.prototype.getPercentage = function getPercentage(now, min, max) {
	    var roundPrecision = 1000;
	    return Math.round((now - min) / (max - min) * 100 * roundPrecision) / roundPrecision;
	  };
	
	  ProgressBar.prototype.render = function render() {
	    if (this.props.isChild) {
	      return this.renderProgressBar();
	    }
	
	    var content = undefined;
	
	    if (this.props.children) {
	      content = _utilsValidComponentChildren2['default'].map(this.props.children, this.renderChildBar);
	    } else {
	      content = this.renderProgressBar();
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        className: _classnames2['default'](this.props.className, 'progress'),
	        min: null,
	        max: null,
	        label: null,
	        'aria-valuetext': null
	      }),
	      content
	    );
	  };
	
	  ProgressBar.prototype.renderChildBar = function renderChildBar(child, index) {
	    return _react.cloneElement(child, {
	      isChild: true,
	      key: child.key ? child.key : index
	    });
	  };
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar() {
	    var _classNames;
	
	    var _props = this.props;
	    var className = _props.className;
	    var label = _props.label;
	    var now = _props.now;
	    var min = _props.min;
	    var max = _props.max;
	
	    var props = _objectWithoutProperties(_props, ['className', 'label', 'now', 'min', 'max']);
	
	    var percentage = this.getPercentage(now, min, max);
	
	    if (typeof label === 'string') {
	      label = this.renderLabel(percentage);
	    }
	
	    if (this.props.srOnly) {
	      label = _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      );
	    }
	
	    var classes = _classnames2['default'](className, _utilsBootstrapUtils2['default'].getClassSet(this.props), (_classNames = {
	      active: this.props.active
	    }, _classNames[_utilsBootstrapUtils2['default'].prefix(this.props, 'striped')] = this.props.active || this.props.striped, _classNames));
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, props, {
	        className: classes,
	        role: 'progressbar',
	        style: { width: percentage + '%' },
	        'aria-valuenow': this.props.now,
	        'aria-valuemin': this.props.min,
	        'aria-valuemax': this.props.max }),
	      label
	    );
	  };
	
	  ProgressBar.prototype.renderLabel = function renderLabel(percentage) {
	    var InterpolateClass = this.props.interpolateClass || _Interpolate2['default'];
	
	    return _react2['default'].createElement(
	      InterpolateClass,
	      {
	        now: this.props.now,
	        min: this.props.min,
	        max: this.props.max,
	        percent: percentage,
	        bsStyle: this.props.bsStyle },
	      this.props.label
	    );
	  };
	
	  return ProgressBar;
	})(_react2['default'].Component);
	
	ProgressBar.propTypes = _extends({}, ProgressBar.propTypes, {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	  className: _react2['default'].PropTypes.string,
	  interpolateClass: _react.PropTypes.node,
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	});
	
	ProgressBar.defaultProps = _extends({}, ProgressBar.defaultProps, {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	});
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(_styleMaps.State.values(), _utilsBootstrapUtils.bsClass('progress-bar', ProgressBar));
	module.e = exports['default'];


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var ResponsiveEmbed = (function (_React$Component) {
	  _inherits(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    _classCallCheck(this, ResponsiveEmbed);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _props = this.props;
	    var bsClass = _props.bsClass;
	    var className = _props.className;
	    var a16by9 = _props.a16by9;
	    var a4by3 = _props.a4by3;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['bsClass', 'className', 'a16by9', 'a4by3', 'children']);
	
	     false ? _warning2['default'](!(!a16by9 && !a4by3), '`a16by9` or `a4by3` attribute must be set.') : undefined;
	     false ? _warning2['default'](!(a16by9 && a4by3), 'Either `a16by9` or `a4by3` attribute can be set. Not both.') : undefined;
	
	    var aspectRatio = {
	      'embed-responsive-16by9': a16by9,
	      'embed-responsive-4by3': a4by3
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: _classnames2['default'](bsClass, aspectRatio) },
	      _react.cloneElement(children, _extends({}, props, {
	        className: _classnames2['default'](className, 'embed-responsive-item')
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	})(_react2['default'].Component);
	
	ResponsiveEmbed.defaultProps = {
	  bsClass: 'embed-responsive',
	  a16by9: false,
	  a4by3: false
	};
	
	ResponsiveEmbed.propTypes = {
	  /**
	   * bootstrap className
	   * @private
	   */
	  bsClass: _react.PropTypes.string,
	  /**
	   * This component accepts only one child element
	   */
	  children: _react.PropTypes.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _react.PropTypes.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _react.PropTypes.bool
	};
	
	exports['default'] = ResponsiveEmbed;
	module.e = exports['default'];


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var Row = _react2['default'].createClass({
	  displayName: 'Row',
	
	  propTypes: {
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default']
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentClass: 'div'
	    };
	  },
	
	  render: function render() {
	    var ComponentClass = this.props.componentClass;
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, 'row') }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Row;
	module.e = exports['default'];


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(133);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(227);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1589);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _lodashCompatObjectOmit = __webpack_require__(304);
	
	var _lodashCompatObjectOmit2 = _interopRequireDefault(_lodashCompatObjectOmit);
	
	var _lodashCompatObjectPick = __webpack_require__(224);
	
	var _lodashCompatObjectPick2 = _interopRequireDefault(_lodashCompatObjectPick);
	
	var SplitButton = (function (_React$Component) {
	  _inherits(SplitButton, _React$Component);
	
	  function SplitButton() {
	    _classCallCheck(this, SplitButton);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	    var onClick = _props.onClick;
	    var target = _props.target;
	    var href = _props.href;
	    var toggleLabel = _props.toggleLabel;
	    var bsSize = _props.bsSize;
	    var bsStyle = _props.bsStyle;
	
	    var props = _objectWithoutProperties(_props, ['children', 'title', 'onClick', 'target', 'href', 'toggleLabel', 'bsSize', 'bsStyle']);
	
	    var disabled = props.disabled;
	
	    var dropdownProps = _lodashCompatObjectPick2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	    var buttonProps = _lodashCompatObjectOmit2['default'](props, _Object$keys(_Dropdown2['default'].ControlledComponent.propTypes));
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      dropdownProps,
	      _react2['default'].createElement(
	        _Button2['default'],
	        _extends({}, buttonProps, {
	          onClick: onClick,
	          bsStyle: bsStyle,
	          bsSize: bsSize,
	          disabled: disabled,
	          target: target,
	          href: href
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsStyle: bsStyle,
	        bsSize: bsSize,
	        disabled: disabled
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	})(_react2['default'].Component);
	
	SplitButton.propTypes = _extends({}, _Dropdown2['default'].propTypes, {
	  bsStyle: _Button2['default'].propTypes.bsStyle,
	
	  /**
	   * @private
	   */
	  onClick: function onClick() {},
	  target: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  /**
	   * The content of the split button.
	   */
	  title: _react2['default'].PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2['default'].PropTypes.string
	});
	
	SplitButton.defaultProps = {
	  disabled: false,
	  dropup: false,
	  pullRight: false
	};
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.e = exports['default'];


/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(556);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var SplitToggle = (function (_React$Component) {
	  _inherits(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    _classCallCheck(this, SplitToggle);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], _extends({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	})(_react2['default'].Component);
	
	exports['default'] = SplitToggle;
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	module.e = exports['default'];


/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsTransitionEvents = __webpack_require__(570);
	
	var _utilsTransitionEvents2 = _interopRequireDefault(_utilsTransitionEvents);
	
	var Tab = _react2['default'].createClass({
	  displayName: 'Tab',
	
	  propTypes: {
	    /**
	     * @private
	     */
	    active: _react2['default'].PropTypes.bool,
	    animation: _react2['default'].PropTypes.bool,
	    /**
	     * It is used by 'Tabs' - parent component
	     * @private
	     */
	    onAnimateOutEnd: _react2['default'].PropTypes.func,
	    disabled: _react2['default'].PropTypes.bool,
	    title: _react2['default'].PropTypes.node,
	    /**
	     * tabClassName is used as className for the associated NavItem
	     */
	    tabClassName: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tab',
	      animation: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      animateIn: false,
	      animateOut: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.animation) {
	      if (!this.state.animateIn && nextProps.active && !this.props.active) {
	        this.setState({
	          animateIn: true
	        });
	      } else if (!this.state.animateOut && !nextProps.active && this.props.active) {
	        this.setState({
	          animateOut: true
	        });
	      }
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.animateIn) {
	      setTimeout(this.startAnimateIn, 0);
	    }
	    if (this.state.animateOut) {
	      _utilsTransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.stopAnimateOut);
	    }
	  },
	
	  startAnimateIn: function startAnimateIn() {
	    if (this.isMounted()) {
	      this.setState({
	        animateIn: false
	      });
	    }
	  },
	
	  stopAnimateOut: function stopAnimateOut() {
	    if (this.isMounted()) {
	      this.setState({
	        animateOut: false
	      });
	
	      if (this.props.onAnimateOutEnd) {
	        this.props.onAnimateOutEnd();
	      }
	    }
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'pane')] = true, _classes['fade'] = true, _classes['active'] = this.props.active || this.state.animateOut, _classes['in'] = this.props.active && !this.state.animateIn, _classes);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, {
	        title: undefined,
	        role: 'tabpanel',
	        'aria-hidden': !this.props.active,
	        className: _classnames2['default'](this.props.className, classes)
	      }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Tab;
	module.e = exports['default'];


/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Table = _react2['default'].createClass({
	  displayName: 'Table',
	
	  propTypes: {
	    striped: _react2['default'].PropTypes.bool,
	    bordered: _react2['default'].PropTypes.bool,
	    condensed: _react2['default'].PropTypes.bool,
	    hover: _react2['default'].PropTypes.bool,
	    responsive: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bordered: false,
	      condensed: false,
	      hover: false,
	      responsive: false,
	      striped: false
	    };
	  },
	
	  render: function render() {
	    var classes = {
	      'table': true,
	      'table-striped': this.props.striped,
	      'table-bordered': this.props.bordered,
	      'table-condensed': this.props.condensed,
	      'table-hover': this.props.hover
	    };
	    var table = _react2['default'].createElement(
	      'table',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	
	    return this.props.responsive ? _react2['default'].createElement(
	      'div',
	      { className: 'table-responsive' },
	      table
	    ) : table;
	  }
	});
	
	exports['default'] = Table;
	module.e = exports['default'];


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _Object$keys = __webpack_require__(51)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Col = __webpack_require__(555);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Nav = __webpack_require__(565);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(567);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _styleMaps = __webpack_require__(58);
	
	var _styleMaps2 = _interopRequireDefault(_styleMaps);
	
	var _keycode = __webpack_require__(297);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var paneId = function paneId(props, child) {
	  return child.props.id ? child.props.id : props.id && props.id + '___pane___' + child.props.eventKey;
	};
	var tabId = function tabId(props, child) {
	  return child.props.id ? child.props.id + '___tab' : props.id && props.id + '___tab___' + child.props.eventKey;
	};
	
	var findChild = _utilsValidComponentChildren2['default'].find;
	
	function getDefaultActiveKeyFromChildren(children) {
	  var defaultActiveKey = undefined;
	
	  _utilsValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	function move(children, currentKey, keys, moveNext) {
	  var lastIdx = keys.length - 1;
	  var stopAt = keys[moveNext ? Math.max(lastIdx, 0) : 0];
	  var nextKey = currentKey;
	
	  function getNext() {
	    var idx = keys.indexOf(nextKey);
	    nextKey = moveNext ? keys[Math.min(lastIdx, idx + 1)] : keys[Math.max(0, idx - 1)];
	
	    return findChild(children, function (_child) {
	      return _child.props.eventKey === nextKey;
	    });
	  }
	
	  var next = getNext();
	
	  while (next.props.eventKey !== stopAt && next.props.disabled) {
	    next = getNext();
	  }
	
	  return next.props.disabled ? currentKey : next.props.eventKey;
	}
	
	var Tabs = _react2['default'].createClass({
	  displayName: 'Tabs',
	
	  propTypes: {
	    activeKey: _react2['default'].PropTypes.any,
	    defaultActiveKey: _react2['default'].PropTypes.any,
	    /**
	     * Navigation style for tabs
	     *
	     * If not specified, it will be treated as `'tabs'` when vertically
	     * positioned and `'pills'` when horizontally positioned.
	     */
	    bsStyle: _react2['default'].PropTypes.oneOf(['tabs', 'pills']),
	    animation: _react2['default'].PropTypes.bool,
	    id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    onSelect: _react2['default'].PropTypes.func,
	    position: _react2['default'].PropTypes.oneOf(['top', 'left', 'right']),
	    /**
	     * Number of grid columns for the tabs if horizontally positioned
	     *
	     * This accepts either a single width or a mapping of size to width.
	     */
	    tabWidth: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.object]),
	    /**
	     * Number of grid columns for the panes if horizontally positioned
	     *
	     * This accepts either a single width or a mapping of size to width. If not
	     * specified, it will be treated as `styleMaps.GRID_COLUMNS` minus
	     * `tabWidth`.
	     */
	    paneWidth: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.object]),
	    /**
	     * Render without clearfix if horizontally positioned
	     */
	    standalone: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tab',
	      animation: true,
	      tabWidth: 2,
	      position: 'top',
	      standalone: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var defaultActiveKey = this.props.defaultActiveKey != null ? this.props.defaultActiveKey : getDefaultActiveKeyFromChildren(this.props.children);
	
	    return {
	      activeKey: defaultActiveKey,
	      previousActiveKey: null
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this = this;
	
	    if (nextProps.activeKey != null && nextProps.activeKey !== this.props.activeKey) {
	      (function () {
	        // check if the 'previousActiveKey' child still exists
	        var previousActiveKey = _this.props.activeKey;
	        _react2['default'].Children.forEach(nextProps.children, function (child) {
	          if (_react2['default'].isValidElement(child)) {
	            if (child.props.eventKey === previousActiveKey) {
	              _this.setState({
	                previousActiveKey: previousActiveKey
	              });
	              return;
	            }
	          }
	        });
	      })();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var tabs = this._tabs;
	    var tabIdx = this._eventKeys().indexOf(this.getActiveKey());
	
	    if (this._needsRefocus) {
	      this._needsRefocus = false;
	      if (tabs && tabIdx !== -1) {
	        var tabNode = _reactDom2['default'].findDOMNode(tabs[tabIdx]);
	
	        if (tabNode) {
	          tabNode.firstChild.focus();
	        }
	      }
	    }
	  },
	
	  handlePaneAnimateOutEnd: function handlePaneAnimateOutEnd() {
	    this.setState({
	      previousActiveKey: null
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var id = _props.id;
	    var className = _props.className;
	    var style = _props.style;
	    var position = _props.position;
	    var bsStyle = _props.bsStyle;
	    var tabWidth = _props.tabWidth;
	    var paneWidth = _props.paneWidth;
	    var standalone = _props.standalone;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['id', 'className', 'style', 'position', 'bsStyle', 'tabWidth', 'paneWidth', 'standalone', 'children']);
	
	    var isHorizontal = position === 'left' || position === 'right';
	
	    if (bsStyle == null) {
	      bsStyle = isHorizontal ? 'pills' : 'tabs';
	    }
	
	    var containerProps = { id: id, className: className, style: style };
	
	    var tabsProps = _extends({}, props, {
	      bsStyle: bsStyle,
	      bsClass: undefined,
	      stacked: isHorizontal,
	      activeKey: this.getActiveKey(),
	      onSelect: this.handleSelect,
	      ref: 'tabs',
	      role: 'tablist'
	    });
	    var childTabs = _utilsValidComponentChildren2['default'].map(children, this.renderTab);
	
	    var panesProps = {
	      className: _utilsBootstrapUtils2['default'].prefix(this.props, 'content'),
	      ref: 'panes'
	    };
	    var childPanes = _utilsValidComponentChildren2['default'].map(children, this.renderPane);
	
	    if (isHorizontal) {
	      if (!standalone) {
	        containerProps.className = _classnames2['default'](containerProps.className, 'clearfix');
	      }
	
	      var _getColProps = this.getColProps({ tabWidth: tabWidth, paneWidth: paneWidth });
	
	      var tabsColProps = _getColProps.tabsColProps;
	      var panesColProps = _getColProps.panesColProps;
	
	      var tabs = _react2['default'].createElement(
	        _Col2['default'],
	        _extends({ componentClass: _Nav2['default'] }, tabsProps, tabsColProps),
	        childTabs
	      );
	      var panes = _react2['default'].createElement(
	        _Col2['default'],
	        _extends({}, panesProps, panesColProps),
	        childPanes
	      );
	
	      if (position === 'left') {
	        return _react2['default'].createElement(
	          'div',
	          containerProps,
	          tabs,
	          panes
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        containerProps,
	        panes,
	        tabs
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      containerProps,
	      _react2['default'].createElement(
	        _Nav2['default'],
	        tabsProps,
	        childTabs
	      ),
	      _react2['default'].createElement(
	        'div',
	        panesProps,
	        childPanes
	      )
	    );
	  },
	
	  getActiveKey: function getActiveKey() {
	    return this.props.activeKey !== undefined ? this.props.activeKey : this.state.activeKey;
	  },
	
	  renderPane: function renderPane(child, index) {
	    var previousActiveKey = this.state.previousActiveKey;
	
	    var shouldPaneBeSetActive = child.props.eventKey === this.getActiveKey();
	    var thereIsNoActivePane = previousActiveKey == null;
	
	    var paneIsAlreadyActive = previousActiveKey != null && child.props.eventKey === previousActiveKey;
	
	    return _react.cloneElement(child, {
	      active: shouldPaneBeSetActive && (thereIsNoActivePane || !this.props.animation),
	      id: paneId(this.props, child),
	      'aria-labelledby': tabId(this.props, child),
	      key: child.key ? child.key : index,
	      animation: this.props.animation,
	      onAnimateOutEnd: paneIsAlreadyActive ? this.handlePaneAnimateOutEnd : null
	    });
	  },
	
	  renderTab: function renderTab(child, index) {
	    var _this2 = this;
	
	    if (child.props.title == null) {
	      return null;
	    }
	
	    var _child$props = child.props;
	    var eventKey = _child$props.eventKey;
	    var title = _child$props.title;
	    var disabled = _child$props.disabled;
	    var onKeyDown = _child$props.onKeyDown;
	    var tabClassName = _child$props.tabClassName;
	    var _child$props$tabIndex = _child$props.tabIndex;
	    var tabIndex = _child$props$tabIndex === undefined ? 0 : _child$props$tabIndex;
	
	    var isActive = this.getActiveKey() === eventKey;
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        linkId: tabId(this.props, child),
	        ref: function (ref) {
	          return (_this2._tabs || (_this2._tabs = []))[index] = ref;
	        },
	        'aria-controls': paneId(this.props, child),
	        onKeyDown: _utilsCreateChainedFunction2['default'](this.handleKeyDown, onKeyDown),
	        eventKey: eventKey,
	        tabIndex: isActive ? tabIndex : -1,
	        disabled: disabled,
	        className: tabClassName },
	      title
	    );
	  },
	
	  getColProps: function getColProps(_ref) {
	    var tabWidth = _ref.tabWidth;
	    var paneWidth = _ref.paneWidth;
	
	    var tabsColProps = undefined;
	    if (tabWidth instanceof Object) {
	      tabsColProps = tabWidth;
	    } else {
	      tabsColProps = { xs: tabWidth };
	    }
	
	    var panesColProps = undefined;
	    if (paneWidth == null) {
	      panesColProps = {};
	      _Object$keys(tabsColProps).forEach(function (size) {
	        panesColProps[size] = _styleMaps2['default'].GRID_COLUMNS - tabsColProps[size];
	      });
	    } else if (paneWidth instanceof Object) {
	      panesColProps = paneWidth;
	    } else {
	      panesColProps = { xs: paneWidth };
	    }
	
	    return { tabsColProps: tabsColProps, panesColProps: panesColProps };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleSelect: function handleSelect(selectedKey) {
	    if (this.props.onSelect) {
	      this._isChanging = true;
	      this.props.onSelect(selectedKey);
	      this._isChanging = false;
	      return;
	    }
	
	    // if there is no external handler, then use embedded one
	    var previousActiveKey = this.getActiveKey();
	    if (selectedKey !== previousActiveKey) {
	      this.setState({
	        activeKey: selectedKey,
	        previousActiveKey: previousActiveKey
	      });
	    }
	  },
	
	  handleKeyDown: function handleKeyDown(event) {
	    var keys = this._eventKeys();
	    var currentKey = this.getActiveKey() || keys[0];
	    var next = undefined;
	
	    switch (event.keyCode) {
	
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        next = move(this.props.children, currentKey, keys, false);
	
	        if (next && next !== currentKey) {
	          event.preventDefault();
	          this.handleSelect(next);
	          this._needsRefocus = true;
	        }
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        next = move(this.props.children, currentKey, keys, true);
	
	        if (next && next !== currentKey) {
	          event.preventDefault();
	          this.handleSelect(next);
	          this._needsRefocus = true;
	        }
	        break;
	      default:
	    }
	  },
	
	  _eventKeys: function _eventKeys() {
	    var keys = [];
	
	    _utilsValidComponentChildren2['default'].forEach(this.props.children, function (_ref2) {
	      var eventKey = _ref2.props.eventKey;
	      return keys.push(eventKey);
	    });
	
	    return keys;
	  }
	});
	
	exports['default'] = Tabs;
	module.e = exports['default'];


/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SafeAnchor = __webpack_require__(108);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var Thumbnail = _react2['default'].createClass({
	  displayName: 'Thumbnail',
	
	  propTypes: {
	    alt: _react2['default'].PropTypes.string,
	    href: _react2['default'].PropTypes.string,
	    src: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    if (this.props.href) {
	      return _react2['default'].createElement(
	        _SafeAnchor2['default'],
	        _extends({}, this.props, { href: this.props.href, className: _classnames2['default'](this.props.className, classes) }),
	        _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt })
	      );
	    }
	
	    if (this.props.children) {
	      return _react2['default'].createElement(
	        'div',
	        _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	        _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'caption' },
	          this.props.children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      _react2['default'].createElement('img', { src: this.props.src, alt: this.props.alt })
	    );
	  }
	});
	
	exports['default'] = _utilsBootstrapUtils.bsClass('thumbnail', Thumbnail);
	module.e = exports['default'];


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _reactPropTypesLibIsRequiredForA11y = __webpack_require__(316);
	
	var _reactPropTypesLibIsRequiredForA11y2 = _interopRequireDefault(_reactPropTypesLibIsRequiredForA11y);
	
	var Tooltip = _react2['default'].createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    /**
	     * An html id attribute, necessary for accessibility
	     * @type {string}
	     * @required
	     */
	    id: _reactPropTypesLibIsRequiredForA11y2['default'](_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	    /**
	     * Sets the direction the Tooltip is positioned towards.
	     */
	    placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The "left" position value for the Tooltip.
	     */
	    positionLeft: _react2['default'].PropTypes.number,
	    /**
	     * The "top" position value for the Tooltip.
	     */
	    positionTop: _react2['default'].PropTypes.number,
	    /**
	     * The "left" position value for the Tooltip arrow.
	     */
	    arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * The "top" position value for the Tooltip arrow.
	     */
	    arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	    /**
	     * Title text
	     */
	    title: _react2['default'].PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      bsClass: 'tooltip',
	      placement: 'right'
	    };
	  },
	
	  render: function render() {
	    var _classes;
	
	    var classes = (_classes = {}, _classes[_utilsBootstrapUtils2['default'].prefix(this.props)] = true, _classes[this.props.placement] = true, _classes);
	
	    var style = _extends({
	      'left': this.props.positionLeft,
	      'top': this.props.positionTop
	    }, this.props.style);
	
	    var arrowStyle = {
	      'left': this.props.arrowOffsetLeft,
	      'top': this.props.arrowOffsetTop
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({ role: 'tooltip' }, this.props, { className: _classnames2['default'](this.props.className, classes), style: style }),
	      _react2['default'].createElement('div', { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: _utilsBootstrapUtils2['default'].prefix(this.props, 'inner') },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = Tooltip;
	module.e = exports['default'];


/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _inherits = __webpack_require__(2)['default'];
	
	var _classCallCheck = __webpack_require__(30)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var Well = (function (_React$Component) {
	  _inherits(Well, _React$Component);
	
	  function Well() {
	    _classCallCheck(this, _Well);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  Well.prototype.render = function render() {
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({}, this.props, { className: _classnames2['default'](this.props.className, classes) }),
	      this.props.children
	    );
	  };
	
	  var _Well = Well;
	  Well = _utilsBootstrapUtils.bsSizes([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL])(Well) || Well;
	  Well = _utilsBootstrapUtils.bsClass('well')(Well) || Well;
	  return Well;
	})(_react2['default'].Component);
	
	exports['default'] = Well;
	module.e = exports['default'];


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(36)['default'];
	
	var _extends = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPropTypesLibDeprecated = __webpack_require__(178);
	
	var _reactPropTypesLibDeprecated2 = _interopRequireDefault(_reactPropTypesLibDeprecated);
	
	var _reactPropTypesLibElementType = __webpack_require__(71);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Grid = __webpack_require__(309);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavBrand = __webpack_require__(566);
	
	var _NavBrand2 = _interopRequireDefault(_NavBrand);
	
	var _utilsBootstrapUtils = __webpack_require__(25);
	
	var _utilsBootstrapUtils2 = _interopRequireDefault(_utilsBootstrapUtils);
	
	var _styleMaps = __webpack_require__(58);
	
	var _utilsCreateChainedFunction = __webpack_require__(59);
	
	var _utilsCreateChainedFunction2 = _interopRequireDefault(_utilsCreateChainedFunction);
	
	var _utilsValidComponentChildren = __webpack_require__(47);
	
	var _utilsValidComponentChildren2 = _interopRequireDefault(_utilsValidComponentChildren);
	
	var Navbar = _react2['default'].createClass({
	  displayName: 'Navbar',
	
	  propTypes: {
	    fixedTop: _react2['default'].PropTypes.bool,
	    fixedBottom: _react2['default'].PropTypes.bool,
	    staticTop: _react2['default'].PropTypes.bool,
	    inverse: _react2['default'].PropTypes.bool,
	    fluid: _react2['default'].PropTypes.bool,
	    role: _react2['default'].PropTypes.string,
	    /**
	     * You can use a custom element for this component
	     */
	    componentClass: _reactPropTypesLibElementType2['default'],
	    brand: _reactPropTypesLibDeprecated2['default'](_react2['default'].PropTypes.node, 'Use the `NavBrand` component.'),
	    toggleButton: _react2['default'].PropTypes.node,
	    toggleNavKey: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	    onToggle: _react2['default'].PropTypes.func,
	    navExpanded: _react2['default'].PropTypes.bool,
	    defaultNavExpanded: _react2['default'].PropTypes.bool
	  },
	
	  // TODO Remove in 0.29
	  childContextTypes: {
	    $bs_deprecated_navbar: _react2['default'].PropTypes.bool
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      $bs_deprecated_navbar: true
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      role: 'navigation',
	      componentClass: 'nav',
	      fixedTop: false,
	      fixedBottom: false,
	      staticTop: false,
	      inverse: false,
	      fluid: false,
	      defaultNavExpanded: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      navExpanded: this.props.defaultNavExpanded
	    };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    // Defer any updates to this component during the `onSelect` handler.
	    return !this._isChanging;
	  },
	
	  handleToggle: function handleToggle() {
	    if (this.props.onToggle) {
	      this._isChanging = true;
	      this.props.onToggle();
	      this._isChanging = false;
	    }
	
	    this.setState({
	      navExpanded: !this.state.navExpanded
	    });
	  },
	
	  isNavExpanded: function isNavExpanded() {
	    return this.props.navExpanded != null ? this.props.navExpanded : this.state.navExpanded;
	  },
	
	  hasNavBrandChild: function hasNavBrandChild() {
	    return _utilsValidComponentChildren2['default'].findValidComponents(this.props.children, function (child) {
	      return child.props.bsRole === 'brand';
	    }).length > 0;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var brand = _props.brand;
	    var toggleButton = _props.toggleButton;
	    var toggleNavKey = _props.toggleNavKey;
	    var fixedTop = _props.fixedTop;
	    var fixedBottom = _props.fixedBottom;
	    var staticTop = _props.staticTop;
	    var inverse = _props.inverse;
	    var ComponentClass = _props.componentClass;
	    var fluid = _props.fluid;
	    var className = _props.className;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['brand', 'toggleButton', 'toggleNavKey', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'componentClass', 'fluid', 'className', 'children']);
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	    if (props.role === undefined && ComponentClass !== 'nav') {
	      props.role = 'navigation';
	    }
	
	    var classes = _utilsBootstrapUtils2['default'].getClassSet(this.props);
	
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-top')] = this.props.fixedTop;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'fixed-bottom')] = this.props.fixedBottom;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, 'static-top')] = this.props.staticTop;
	
	    // handle built-in styles manually to provide the convenience `inverse` prop
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, _styleMaps.INVERSE)] = this.props.inverse;
	    classes[_utilsBootstrapUtils2['default'].prefix(this.props, _styleMaps.DEFAULT)] = !this.props.inverse;
	
	    var showHeader = (brand || toggleButton || toggleNavKey != null) && !this.hasNavBrandChild();
	
	    return _react2['default'].createElement(
	      ComponentClass,
	      _extends({}, props, { className: _classnames2['default'](className, classes) }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        showHeader ? this.renderBrandHeader() : null,
	        _utilsValidComponentChildren2['default'].map(children, this.renderChild)
	      )
	    );
	  },
	
	  renderBrandHeader: function renderBrandHeader() {
	    var brand = this.props.brand;
	
	    if (brand) {
	      brand = _react2['default'].createElement(
	        _NavBrand2['default'],
	        null,
	        brand
	      );
	    }
	
	    return this.renderHeader(brand);
	  },
	
	  renderHeader: function renderHeader(brand) {
	    var hasToggle = this.props.toggleButton || this.props.toggleNavKey != null;
	    var headerClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'header');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: headerClass },
	      brand,
	      hasToggle ? this.renderToggleButton() : null
	    );
	  },
	
	  renderChild: function renderChild(child, index) {
	    var key = child.key != null ? child.key : index;
	
	    if (child.props.bsRole === 'brand') {
	      return _react2['default'].cloneElement(this.renderHeader(child), { key: key });
	    }
	
	    var toggleNavKey = this.props.toggleNavKey;
	
	    var collapsible = toggleNavKey != null && toggleNavKey === child.props.eventKey;
	
	    return _react2['default'].cloneElement(child, {
	      navbar: true,
	      collapsible: collapsible,
	      expanded: collapsible && this.isNavExpanded(),
	      key: key
	    });
	  },
	
	  renderToggleButton: function renderToggleButton() {
	    var toggleButton = this.props.toggleButton;
	
	    var toggleClass = _utilsBootstrapUtils2['default'].prefix(this.props, 'toggle');
	
	    if (_react2['default'].isValidElement(toggleButton)) {
	      return _react2['default'].cloneElement(toggleButton, {
	        className: _classnames2['default'](toggleButton.props.className, toggleClass),
	        onClick: _utilsCreateChainedFunction2['default'](this.handleToggle, toggleButton.props.onClick)
	      });
	    }
	
	    var children = undefined;
	    if (toggleButton != null) {
	      children = toggleButton;
	    } else {
	      children = [_react2['default'].createElement(
	        'span',
	        { className: 'sr-only', key: 0 },
	        'Toggle navigation'
	      ), _react2['default'].createElement('span', { className: 'icon-bar', key: 1 }), _react2['default'].createElement('span', { className: 'icon-bar', key: 2 }), _react2['default'].createElement('span', { className: 'icon-bar', key: 3 })];
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        onClick: this.handleToggle,
	        className: toggleClass
	      },
	      children
	    );
	  }
	
	});
	
	var NAVBAR_STATES = [_styleMaps.DEFAULT, _styleMaps.INVERSE];
	
	exports['default'] = _utilsBootstrapUtils.bsStyles(NAVBAR_STATES, _styleMaps.DEFAULT, _utilsBootstrapUtils.bsClass('navbar', Navbar));
	module.e = exports['default'];


/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	
	var _reactPropTypesLibCommon = __webpack_require__(315);
	
	var _childrenToArray = __webpack_require__(1598);
	
	var _childrenToArray2 = _interopRequireDefault(_childrenToArray);
	
	exports['default'] = {
	
	  requiredRoles: function requiredRoles() {
	    for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	      roles[_key] = arguments[_key];
	    }
	
	    return _reactPropTypesLibCommon.createChainableTypeChecker(function requiredRolesValidator(props, propName, component) {
	      var missing = undefined;
	      var children = _childrenToArray2['default'](props.children);
	
	      var inRole = function inRole(role, child) {
	        return role === child.props.bsRole;
	      };
	
	      roles.every(function (role) {
	        if (!children.some(function (child) {
	          return inRole(role, child);
	        })) {
	          missing = role;
	          return false;
	        }
	        return true;
	      });
	
	      if (missing) {
	        return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + missing + '. ' + (component + ' must have at least one child of each of the following bsRoles: ' + roles.join(', ')));
	      }
	    });
	  },
	
	  exclusiveRoles: function exclusiveRoles() {
	    for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      roles[_key2] = arguments[_key2];
	    }
	
	    return _reactPropTypesLibCommon.createChainableTypeChecker(function exclusiveRolesValidator(props, propName, component) {
	      var children = _childrenToArray2['default'](props.children);
	      var duplicate = undefined;
	
	      roles.every(function (role) {
	        var childrenWithRole = children.filter(function (child) {
	          return child.props.bsRole === role;
	        });
	
	        if (childrenWithRole.length > 1) {
	          duplicate = role;
	          return false;
	        }
	        return true;
	      });
	
	      if (duplicate) {
	        return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + duplicate + '. ' + ('Only one child each allowed with the following bsRoles: ' + roles.join(', ')));
	      }
	    });
	  }
	};
	module.e = exports['default'];


/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(11)['default'];
	
	exports.__esModule = true;
	exports['default'] = childrenAsArray;
	
	var _ValidComponentChildren = __webpack_require__(47);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function childrenAsArray(children) {
	  var result = [];
	
	  if (children === undefined) {
	    return result;
	  }
	
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    result.push(child);
	  });
	
	  return result;
	}
	
	module.e = exports['default'];


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createSelectedEvent;
	
	function createSelectedEvent(eventKey) {
	  var selectionPrevented = false;
	
	  return {
	    eventKey: eventKey,
	
	    preventSelection: function preventSelection() {
	      selectionPrevented = true;
	    },
	
	    isSelectionPrevented: function isSelectionPrevented() {
	      return selectionPrevented;
	    }
	  };
	}
	
	module.e = exports["default"];


/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderViewDefault = renderViewDefault;
	exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
	exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
	exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
	exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function renderViewDefault(props) {
	    return _react2["default"].createElement('div', props);
	}
	
	function renderTrackHorizontalDefault(_ref) {
	    var style = _ref.style;
	
	    var props = _objectWithoutProperties(_ref, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        left: 2,
	        borderRadius: 3,
	        cursor: 'pointer'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderTrackVerticalDefault(_ref2) {
	    var style = _ref2.style;
	
	    var props = _objectWithoutProperties(_ref2, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        top: 2,
	        borderRadius: 3,
	        cursor: 'pointer'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbHorizontalDefault(_ref3) {
	    var style = _ref3.style;
	
	    var props = _objectWithoutProperties(_ref3, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbVerticalDefault(_ref4) {
	    var style = _ref4.style;
	
	    var props = _objectWithoutProperties(_ref4, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}


/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _raf2 = __webpack_require__(1550);
	
	var _raf3 = _interopRequireDefault(_raf2);
	
	var _domCss = __webpack_require__(518);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getScrollbarWidth = __webpack_require__(1606);
	
	var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);
	
	var _returnFalse = __webpack_require__(1607);
	
	var _returnFalse2 = _interopRequireDefault(_returnFalse);
	
	var _getInnerWidth = __webpack_require__(1605);
	
	var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);
	
	var _getInnerHeight = __webpack_require__(1604);
	
	var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);
	
	var _styles = __webpack_require__(1602);
	
	var _defaultRenderElements = __webpack_require__(1600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports["default"] = (0, _react.createClass)({
	
	    displayName: 'Scrollbars',
	
	    propTypes: {
	        onScroll: _react.PropTypes.func,
	        onScrollFrame: _react.PropTypes.func,
	        onScrollStart: _react.PropTypes.func,
	        onScrollStop: _react.PropTypes.func,
	        onUpdate: _react.PropTypes.func,
	        renderView: _react.PropTypes.func,
	        renderTrackHorizontal: _react.PropTypes.func,
	        renderTrackVertical: _react.PropTypes.func,
	        renderThumbHorizontal: _react.PropTypes.func,
	        renderThumbVertical: _react.PropTypes.func,
	        thumbSize: _react.PropTypes.number,
	        thumbMinSize: _react.PropTypes.number,
	        hideTracksWhenNotNeeded: _react.PropTypes.bool,
	        autoHide: _react.PropTypes.bool,
	        autoHideTimeout: _react.PropTypes.number,
	        autoHideDuration: _react.PropTypes.number,
	        autoHeight: _react.PropTypes.bool,
	        autoHeightMin: _react.PropTypes.number,
	        autoHeightMax: _react.PropTypes.number,
	        universal: _react.PropTypes.bool,
	        style: _react.PropTypes.object,
	        children: _react.PropTypes.node
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            renderView: _defaultRenderElements.renderViewDefault,
	            renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
	            renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
	            renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
	            renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
	            thumbMinSize: 30,
	            hideTracksWhenNotNeeded: false,
	            autoHide: false,
	            autoHideTimeout: 1000,
	            autoHideDuration: 200,
	            autoHeight: false,
	            autoHeightMin: 0,
	            autoHeightMax: 200,
	            universal: false
	        };
	    },
	    getInitialState: function getInitialState() {
	        return {
	            didMountUniversal: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.addListeners();
	        this.update();
	        this.componentDidMountUniversal();
	    },
	    componentDidMountUniversal: function componentDidMountUniversal() {
	        // eslint-disable-line react/sort-comp
	        var universal = this.props.universal;
	
	        if (!universal) return;
	        this.setState({ didMountUniversal: true });
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        this.update();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.removeListeners();
	        (0, _raf2.cancel)(this.requestFrame);
	        clearTimeout(this.hideTracksTimeout);
	        clearInterval(this.detectScrollingInterval);
	    },
	    getScrollLeft: function getScrollLeft() {
	        var view = this.refs.view;
	
	        return view.scrollLeft;
	    },
	    getScrollTop: function getScrollTop() {
	        var view = this.refs.view;
	
	        return view.scrollTop;
	    },
	    getScrollWidth: function getScrollWidth() {
	        var view = this.refs.view;
	
	        return view.scrollWidth;
	    },
	    getScrollHeight: function getScrollHeight() {
	        var view = this.refs.view;
	
	        return view.scrollHeight;
	    },
	    getClientWidth: function getClientWidth() {
	        var view = this.refs.view;
	
	        return view.clientWidth;
	    },
	    getClientHeight: function getClientHeight() {
	        var view = this.refs.view;
	
	        return view.clientHeight;
	    },
	    getValues: function getValues() {
	        var view = this.refs.view;
	        var scrollLeft = view.scrollLeft;
	        var scrollTop = view.scrollTop;
	        var scrollWidth = view.scrollWidth;
	        var scrollHeight = view.scrollHeight;
	        var clientWidth = view.clientWidth;
	        var clientHeight = view.clientHeight;
	
	
	        return {
	            left: scrollLeft / (scrollWidth - clientWidth) || 0,
	            top: scrollTop / (scrollHeight - clientHeight) || 0,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: scrollWidth,
	            scrollHeight: scrollHeight,
	            clientWidth: clientWidth,
	            clientHeight: clientHeight
	        };
	    },
	    getThumbHorizontalWidth: function getThumbHorizontalWidth() {
	        var _props = this.props;
	        var thumbSize = _props.thumbSize;
	        var thumbMinSize = _props.thumbMinSize;
	        var _refs = this.refs;
	        var view = _refs.view;
	        var trackHorizontal = _refs.trackHorizontal;
	        var scrollWidth = view.scrollWidth;
	        var clientWidth = view.clientWidth;
	
	        var trackWidth = (0, _getInnerWidth2["default"])(trackHorizontal);
	        var width = clientWidth / scrollWidth * trackWidth;
	        if (trackWidth === width) return 0;
	        if (thumbSize) return thumbSize;
	        return Math.max(width, thumbMinSize);
	    },
	    getThumbVerticalHeight: function getThumbVerticalHeight() {
	        var _props2 = this.props;
	        var thumbSize = _props2.thumbSize;
	        var thumbMinSize = _props2.thumbMinSize;
	        var _refs2 = this.refs;
	        var view = _refs2.view;
	        var trackVertical = _refs2.trackVertical;
	        var scrollHeight = view.scrollHeight;
	        var clientHeight = view.clientHeight;
	
	        var trackHeight = (0, _getInnerHeight2["default"])(trackVertical);
	        var height = clientHeight / scrollHeight * trackHeight;
	        if (trackHeight === height) return 0;
	        if (thumbSize) return thumbSize;
	        return Math.max(height, thumbMinSize);
	    },
	    getScrollLeftForOffset: function getScrollLeftForOffset(offset) {
	        var _refs3 = this.refs;
	        var view = _refs3.view;
	        var trackHorizontal = _refs3.trackHorizontal;
	        var scrollWidth = view.scrollWidth;
	        var clientWidth = view.clientWidth;
	
	        var trackWidth = (0, _getInnerWidth2["default"])(trackHorizontal);
	        var thumbWidth = this.getThumbHorizontalWidth();
	        return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
	    },
	    getScrollTopForOffset: function getScrollTopForOffset(offset) {
	        var _refs4 = this.refs;
	        var view = _refs4.view;
	        var trackVertical = _refs4.trackVertical;
	        var scrollHeight = view.scrollHeight;
	        var clientHeight = view.clientHeight;
	
	        var trackHeight = (0, _getInnerHeight2["default"])(trackVertical);
	        var thumbHeight = this.getThumbVerticalHeight();
	        return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
	    },
	    scrollLeft: function scrollLeft() {
	        var left = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	        var view = this.refs.view;
	
	        view.scrollLeft = left;
	    },
	    scrollTop: function scrollTop() {
	        var top = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	        var view = this.refs.view;
	
	        view.scrollTop = top;
	    },
	    scrollToLeft: function scrollToLeft() {
	        var view = this.refs.view;
	
	        view.scrollLeft = 0;
	    },
	    scrollToTop: function scrollToTop() {
	        var view = this.refs.view;
	
	        view.scrollTop = 0;
	    },
	    scrollToRight: function scrollToRight() {
	        var view = this.refs.view;
	
	        view.scrollLeft = view.scrollWidth;
	    },
	    scrollToBottom: function scrollToBottom() {
	        var view = this.refs.view;
	
	        view.scrollTop = view.scrollHeight;
	    },
	    addListeners: function addListeners() {
	        /* istanbul ignore if */
	        if (typeof document === 'undefined') return;
	        var _refs5 = this.refs;
	        var view = _refs5.view;
	        var trackHorizontal = _refs5.trackHorizontal;
	        var trackVertical = _refs5.trackVertical;
	        var thumbHorizontal = _refs5.thumbHorizontal;
	        var thumbVertical = _refs5.thumbVertical;
	
	        view.addEventListener('scroll', this.handleScroll);
	        if (!(0, _getScrollbarWidth2["default"])()) return;
	        trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
	        trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
	        trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	        trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
	        trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
	        trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
	        thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	        thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
	        window.addEventListener('resize', this.handleWindowResize);
	    },
	    removeListeners: function removeListeners() {
	        /* istanbul ignore if */
	        if (typeof document === 'undefined') return;
	        var _refs6 = this.refs;
	        var view = _refs6.view;
	        var trackHorizontal = _refs6.trackHorizontal;
	        var trackVertical = _refs6.trackVertical;
	        var thumbHorizontal = _refs6.thumbHorizontal;
	        var thumbVertical = _refs6.thumbVertical;
	
	        view.removeEventListener('scroll', this.handleScroll);
	        if (!(0, _getScrollbarWidth2["default"])()) return;
	        trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	        trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	        trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	        trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	        trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	        trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
	        thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	        thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
	        window.removeEventListener('resize', this.handleWindowResize);
	        // Possibly setup by `handleDragStart`
	        this.teardownDragging();
	    },
	    handleScroll: function handleScroll(event) {
	        var _this = this;
	
	        var _props3 = this.props;
	        var onScroll = _props3.onScroll;
	        var onScrollFrame = _props3.onScrollFrame;
	
	        if (onScroll) onScroll(event);
	        this.update(function (values) {
	            var scrollLeft = values.scrollLeft;
	            var scrollTop = values.scrollTop;
	
	            _this.viewScrollLeft = scrollLeft;
	            _this.viewScrollTop = scrollTop;
	            if (onScrollFrame) onScrollFrame(values);
	        });
	        this.detectScrolling();
	    },
	    handleScrollStart: function handleScrollStart() {
	        var onScrollStart = this.props.onScrollStart;
	
	        if (onScrollStart) onScrollStart();
	        this.handleScrollStartAutoHide();
	    },
	    handleScrollStartAutoHide: function handleScrollStartAutoHide() {
	        var autoHide = this.props.autoHide;
	
	        if (!autoHide) return;
	        this.showTracks();
	    },
	    handleScrollStop: function handleScrollStop() {
	        var onScrollStop = this.props.onScrollStop;
	
	        if (onScrollStop) onScrollStop();
	        this.handleScrollStopAutoHide();
	    },
	    handleScrollStopAutoHide: function handleScrollStopAutoHide() {
	        var autoHide = this.props.autoHide;
	
	        if (!autoHide) return;
	        this.hideTracks();
	    },
	    handleWindowResize: function handleWindowResize() {
	        this.update();
	    },
	    handleHorizontalTrackMouseDown: function handleHorizontalTrackMouseDown() {
	        var view = this.refs.view;
	        var _event = event;
	        var target = _event.target;
	        var clientX = _event.clientX;
	
	        var _target$getBoundingCl = target.getBoundingClientRect();
	
	        var targetLeft = _target$getBoundingCl.left;
	
	        var thumbWidth = this.getThumbHorizontalWidth();
	        var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
	        view.scrollLeft = this.getScrollLeftForOffset(offset);
	    },
	    handleVerticalTrackMouseDown: function handleVerticalTrackMouseDown(event) {
	        var view = this.refs.view;
	        var target = event.target;
	        var clientY = event.clientY;
	
	        var _target$getBoundingCl2 = target.getBoundingClientRect();
	
	        var targetTop = _target$getBoundingCl2.top;
	
	        var thumbHeight = this.getThumbVerticalHeight();
	        var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
	        view.scrollTop = this.getScrollTopForOffset(offset);
	    },
	    handleHorizontalThumbMouseDown: function handleHorizontalThumbMouseDown(event) {
	        this.handleDragStart(event);
	        var target = event.target;
	        var clientX = event.clientX;
	        var offsetWidth = target.offsetWidth;
	
	        var _target$getBoundingCl3 = target.getBoundingClientRect();
	
	        var left = _target$getBoundingCl3.left;
	
	        this.prevPageX = offsetWidth - (clientX - left);
	    },
	    handleVerticalThumbMouseDown: function handleVerticalThumbMouseDown(event) {
	        this.handleDragStart(event);
	        var target = event.target;
	        var clientY = event.clientY;
	        var offsetHeight = target.offsetHeight;
	
	        var _target$getBoundingCl4 = target.getBoundingClientRect();
	
	        var top = _target$getBoundingCl4.top;
	
	        this.prevPageY = offsetHeight - (clientY - top);
	    },
	    setupDragging: function setupDragging() {
	        (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
	        document.addEventListener('mousemove', this.handleDrag);
	        document.addEventListener('mouseup', this.handleDragEnd);
	        document.onselectstart = _returnFalse2["default"];
	    },
	    teardownDragging: function teardownDragging() {
	        (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
	        document.removeEventListener('mousemove', this.handleDrag);
	        document.removeEventListener('mouseup', this.handleDragEnd);
	        document.onselectstart = undefined;
	    },
	    handleDragStart: function handleDragStart(event) {
	        this.dragging = true;
	        event.stopImmediatePropagation();
	        this.setupDragging();
	    },
	    handleDrag: function handleDrag(event) {
	        if (this.prevPageX) {
	            var clientX = event.clientX;
	            var _refs7 = this.refs;
	            var view = _refs7.view;
	            var trackHorizontal = _refs7.trackHorizontal;
	
	            var _trackHorizontal$getB = trackHorizontal.getBoundingClientRect();
	
	            var trackLeft = _trackHorizontal$getB.left;
	
	            var thumbWidth = this.getThumbHorizontalWidth();
	            var clickPosition = thumbWidth - this.prevPageX;
	            var offset = -trackLeft + clientX - clickPosition;
	            view.scrollLeft = this.getScrollLeftForOffset(offset);
	        }
	        if (this.prevPageY) {
	            var clientY = event.clientY;
	            var _refs8 = this.refs;
	            var _view = _refs8.view;
	            var trackVertical = _refs8.trackVertical;
	
	            var _trackVertical$getBou = trackVertical.getBoundingClientRect();
	
	            var trackTop = _trackVertical$getBou.top;
	
	            var thumbHeight = this.getThumbVerticalHeight();
	            var _clickPosition = thumbHeight - this.prevPageY;
	            var _offset = -trackTop + clientY - _clickPosition;
	            _view.scrollTop = this.getScrollTopForOffset(_offset);
	        }
	        return false;
	    },
	    handleDragEnd: function handleDragEnd() {
	        this.dragging = false;
	        this.prevPageX = this.prevPageY = 0;
	        this.teardownDragging();
	        this.handleDragEndAutoHide();
	    },
	    handleDragEndAutoHide: function handleDragEndAutoHide() {
	        var autoHide = this.props.autoHide;
	
	        if (!autoHide) return;
	        this.hideTracks();
	    },
	    handleTrackMouseEnter: function handleTrackMouseEnter() {
	        this.trackMouseOver = true;
	        this.handleTrackMouseEnterAutoHide();
	    },
	    handleTrackMouseEnterAutoHide: function handleTrackMouseEnterAutoHide() {
	        var autoHide = this.props.autoHide;
	
	        if (!autoHide) return;
	        this.showTracks();
	    },
	    handleTrackMouseLeave: function handleTrackMouseLeave() {
	        this.trackMouseOver = false;
	        this.handleTrackMouseLeaveAutoHide();
	    },
	    handleTrackMouseLeaveAutoHide: function handleTrackMouseLeaveAutoHide() {
	        var autoHide = this.props.autoHide;
	
	        if (!autoHide) return;
	        this.hideTracks();
	    },
	    showTracks: function showTracks() {
	        var _refs9 = this.refs;
	        var trackHorizontal = _refs9.trackHorizontal;
	        var trackVertical = _refs9.trackVertical;
	
	        clearTimeout(this.hideTracksTimeout);
	        (0, _domCss2["default"])(trackHorizontal, { opacity: 1 });
	        (0, _domCss2["default"])(trackVertical, { opacity: 1 });
	    },
	    hideTracks: function hideTracks() {
	        if (this.dragging) return;
	        if (this.scrolling) return;
	        if (this.trackMouseOver) return;
	        var autoHideTimeout = this.props.autoHideTimeout;
	        var _refs10 = this.refs;
	        var trackHorizontal = _refs10.trackHorizontal;
	        var trackVertical = _refs10.trackVertical;
	
	        clearTimeout(this.hideTracksTimeout);
	        this.hideTracksTimeout = setTimeout(function () {
	            (0, _domCss2["default"])(trackHorizontal, { opacity: 0 });
	            (0, _domCss2["default"])(trackVertical, { opacity: 0 });
	        }, autoHideTimeout);
	    },
	    detectScrolling: function detectScrolling() {
	        var _this2 = this;
	
	        if (this.scrolling) return;
	        this.scrolling = true;
	        this.handleScrollStart();
	        this.detectScrollingInterval = setInterval(function () {
	            if (_this2.lastViewScrollLeft === _this2.viewScrollLeft && _this2.lastViewScrollTop === _this2.viewScrollTop) {
	                clearInterval(_this2.detectScrollingInterval);
	                _this2.scrolling = false;
	                _this2.handleScrollStop();
	            }
	            _this2.lastViewScrollLeft = _this2.viewScrollLeft;
	            _this2.lastViewScrollTop = _this2.viewScrollTop;
	        }, 100);
	    },
	    raf: function raf(callback) {
	        var _this3 = this;
	
	        if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
	        this.requestFrame = (0, _raf3["default"])(function () {
	            _this3.requestFrame = undefined;
	            callback();
	        });
	    },
	    update: function update(callback) {
	        var _this4 = this;
	
	        this.raf(function () {
	            var _props4 = _this4.props;
	            var onUpdate = _props4.onUpdate;
	            var hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
	
	            var values = _this4.getValues();
	            if ((0, _getScrollbarWidth2["default"])()) {
	                var _refs11 = _this4.refs;
	                var thumbHorizontal = _refs11.thumbHorizontal;
	                var thumbVertical = _refs11.thumbVertical;
	                var trackHorizontal = _refs11.trackHorizontal;
	                var trackVertical = _refs11.trackVertical;
	                var scrollLeft = values.scrollLeft;
	                var clientWidth = values.clientWidth;
	                var scrollWidth = values.scrollWidth;
	
	                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(trackHorizontal);
	                var thumbHorizontalWidth = _this4.getThumbHorizontalWidth();
	                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
	                var thumbHorizontalStyle = {
	                    width: thumbHorizontalWidth,
	                    transform: 'translateX(' + thumbHorizontalX + 'px)'
	                };
	                var scrollTop = values.scrollTop;
	                var clientHeight = values.clientHeight;
	                var scrollHeight = values.scrollHeight;
	
	                var trackVerticalHeight = (0, _getInnerHeight2["default"])(trackVertical);
	                var thumbVerticalHeight = _this4.getThumbVerticalHeight();
	                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
	                var thumbVerticalStyle = {
	                    height: thumbVerticalHeight,
	                    transform: 'translateY(' + thumbVerticalY + 'px)'
	                };
	                if (hideTracksWhenNotNeeded) {
	                    var trackHorizontalStyle = {
	                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
	                    };
	                    var trackVerticalStyle = {
	                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
	                    };
	                    (0, _domCss2["default"])(trackHorizontal, trackHorizontalStyle);
	                    (0, _domCss2["default"])(trackVertical, trackVerticalStyle);
	                }
	                (0, _domCss2["default"])(thumbHorizontal, thumbHorizontalStyle);
	                (0, _domCss2["default"])(thumbVertical, thumbVerticalStyle);
	            }
	            if (onUpdate) onUpdate(values);
	            if (typeof callback !== 'function') return;
	            callback(values);
	        });
	    },
	    render: function render() {
	        var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
	        var _props5 = this.props;
	        var onScroll = _props5.onScroll;
	        var onScrollFrame = _props5.onScrollFrame;
	        var onScrollStart = _props5.onScrollStart;
	        var onScrollStop = _props5.onScrollStop;
	        var renderView = _props5.renderView;
	        var renderTrackHorizontal = _props5.renderTrackHorizontal;
	        var renderTrackVertical = _props5.renderTrackVertical;
	        var renderThumbHorizontal = _props5.renderThumbHorizontal;
	        var renderThumbVertical = _props5.renderThumbVertical;
	        var autoHide = _props5.autoHide;
	        var autoHideTimeout = _props5.autoHideTimeout;
	        var autoHideDuration = _props5.autoHideDuration;
	        var thumbSize = _props5.thumbSize;
	        var thumbMinSize = _props5.thumbMinSize;
	        var universal = _props5.universal;
	        var autoHeight = _props5.autoHeight;
	        var autoHeightMin = _props5.autoHeightMin;
	        var autoHeightMax = _props5.autoHeightMax;
	        var style = _props5.style;
	        var children = _props5.children;
	
	        var props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
	
	        var didMountUniversal = this.state.didMountUniversal;
	
	
	        var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
	            minHeight: autoHeightMin,
	            maxHeight: autoHeightMax
	        }), style);
	
	        var viewStyle = _extends({}, _styles.viewStyleDefault, {
	            // Hide scrollbars by setting a negative margin
	            marginRight: scrollbarWidth ? -scrollbarWidth : 0,
	            marginBottom: scrollbarWidth ? -scrollbarWidth : 0
	        }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
	            minHeight: autoHeightMin + scrollbarWidth,
	            maxHeight: autoHeightMax + scrollbarWidth
	        }), universal && !didMountUniversal && _styles.viewStyleUniversalInitial);
	
	        var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && {
	            transition: 'opacity ' + autoHideDuration + 'ms',
	            opacity: 0
	        }, (!scrollbarWidth || universal) && !didMountUniversal && {
	            display: 'none'
	        });
	
	        var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && {
	            transition: 'opacity ' + autoHideDuration + 'ms',
	            opacity: 0
	        }, (!scrollbarWidth || universal) && !didMountUniversal && {
	            display: 'none'
	        });
	
	        return _react2["default"].createElement(
	            'div',
	            _extends({}, props, { style: containerStyle, ref: 'container' }),
	            (0, _react.cloneElement)(renderView({ style: viewStyle }), { ref: 'view' }, children),
	            (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { ref: 'trackHorizontal' }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: 'thumbHorizontal' })),
	            (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { ref: 'trackVertical' }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: 'thumbVertical' }))
	        );
	    }
	});


/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var containerStyleDefault = exports.containerStyleDefault = {
	    position: 'relative',
	    overflow: 'hidden',
	    width: '100%',
	    height: '100%'
	};
	
	// Overrides containerStyleDefault properties
	var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
	    height: 'auto'
	};
	
	var viewStyleDefault = exports.viewStyleDefault = {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflow: 'scroll',
	    WebkitOverflowScrolling: 'touch'
	};
	
	// Overrides viewStyleDefault properties
	var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
	    position: 'relative',
	    top: undefined,
	    left: undefined,
	    right: undefined,
	    bottom: undefined
	};
	
	var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
	    overflow: 'hidden',
	    marginRight: 0,
	    marginBottom: 0
	};
	
	var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
	    position: 'absolute',
	    height: 6
	};
	
	var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
	    position: 'absolute',
	    width: 6
	};
	
	var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    height: '100%'
	};
	
	var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    width: '100%'
	};
	
	var disableSelectStyle = exports.disableSelectStyle = {
	    userSelect: 'none'
	};
	
	var disableSelectStyleReset = exports.disableSelectStyleReset = {
	    userSelect: ''
	};


/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scrollbars = undefined;
	
	var _Scrollbars = __webpack_require__(1601);
	
	var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Scrollbars2["default"];
	exports.Scrollbars = _Scrollbars2["default"];


/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerHeight;
	function getInnerHeight(el) {
	    var clientHeight = el.clientHeight;
	
	    var _getComputedStyle = getComputedStyle(el);
	
	    var paddingTop = _getComputedStyle.paddingTop;
	    var paddingBottom = _getComputedStyle.paddingBottom;
	
	    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
	}


/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerWidth;
	function getInnerWidth(el) {
	    var clientWidth = el.clientWidth;
	
	    var _getComputedStyle = getComputedStyle(el);
	
	    var paddingLeft = _getComputedStyle.paddingLeft;
	    var paddingRight = _getComputedStyle.paddingRight;
	
	    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
	}


/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getScrollbarWidth;
	
	var _domCss = __webpack_require__(518);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var scrollbarWidth = false;
	
	function getScrollbarWidth() {
	    if (scrollbarWidth !== false) return scrollbarWidth;
	    /* istanbul ignore else */
	    if (typeof document !== 'undefined') {
	        var div = document.createElement('div');
	        (0, _domCss2["default"])(div, {
	            width: 100,
	            height: 100,
	            position: 'absolute',
	            top: -9999,
	            overflow: 'scroll',
	            MsOverflowStyle: 'scrollbar'
	        });
	        document.body.appendChild(div);
	        scrollbarWidth = div.offsetWidth - div.clientWidth;
	        document.body.removeChild(div);
	    } else {
	        scrollbarWidth = 0;
	    }
	    return scrollbarWidth;
	}


/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = returnFalse;
	function returnFalse() {
	    return false;
	}


/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	!function(e,a){ true?module.e=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";var e=[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}];return e});


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	!function(e,a){ true?module.e=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";var e=[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}];return e});


/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	!function(e,a){ true?module.e=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";var e=[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&2>e?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relativeTime:{future:{one:"Dans {0} minute",other:"Dans {0} minutes"},past:{one:"Il y a {0} minute",other:"Il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}];return e});


/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	!function(e,t){ true?module.e=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";var e=[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今すぐ"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}];return e});


/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	!function(e,o){ true?module.e=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.pt=o())}(this,function(){"use strict";var e=[{locale:"pt",pluralRuleFunction:function(e,o){var t=String(e).split("."),a=Number(t[0])==e;return o?"other":a&&e>=0&&2>=e&&2!=e?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"em {0} ano",other:"em {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"em {0} mês",other:"em {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"em {0} dia",other:"em {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relativeTime:{future:{one:"em {0} hora",other:"em {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"em {0} minuto",other:"em {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"em {0} segundo",other:"em {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-AO",parentLocale:"pt-PT"},{locale:"pt-PT",parentLocale:"pt",pluralRuleFunction:function(e,o){var t=String(e).split("."),a=!t[1];return o?"other":1==e&&a?"one":"other"},fields:{year:{displayName:"ano",relative:{0:"este ano",1:"próximo ano","-1":"ano passado"},relativeTime:{future:{one:"dentro de {0} ano",other:"dentro de {0} anos"},past:{one:"há {0} ano",other:"há {0} anos"}}},month:{displayName:"mês",relative:{0:"este mês",1:"próximo mês","-1":"mês passado"},relativeTime:{future:{one:"dentro de {0} mês",other:"dentro de {0} meses"},past:{one:"há {0} mês",other:"há {0} meses"}}},day:{displayName:"dia",relative:{0:"hoje",1:"amanhã",2:"depois de amanhã","-2":"anteontem","-1":"ontem"},relativeTime:{future:{one:"dentro de {0} dia",other:"dentro de {0} dias"},past:{one:"há {0} dia",other:"há {0} dias"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"há {0} hora",other:"há {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"há {0} minuto",other:"há {0} minutos"}}},second:{displayName:"segundo",relative:{0:"agora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"há {0} segundo",other:"há {0} segundos"}}}}},{locale:"pt-CV",parentLocale:"pt-PT"},{locale:"pt-GW",parentLocale:"pt-PT"},{locale:"pt-MO",parentLocale:"pt-PT"},{locale:"pt-MZ",parentLocale:"pt-PT"},{locale:"pt-ST",parentLocale:"pt-PT"},{locale:"pt-TL",parentLocale:"pt-PT"}];return e});


/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*eslint-disable react/prop-types */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(48);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _reactPropTypesLibMountable = __webpack_require__(314);
	
	var _reactPropTypesLibMountable2 = _interopRequireDefault(_reactPropTypesLibMountable);
	
	var _reactPropTypesLibElementType = __webpack_require__(577);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	var _Portal = __webpack_require__(571);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(1614);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _utilsOwnerDocument = __webpack_require__(177);
	
	var _utilsOwnerDocument2 = _interopRequireDefault(_utilsOwnerDocument);
	
	var _utilsAddEventListener = __webpack_require__(574);
	
	var _utilsAddEventListener2 = _interopRequireDefault(_utilsAddEventListener);
	
	var _utilsAddFocusListener = __webpack_require__(1617);
	
	var _utilsAddFocusListener2 = _interopRequireDefault(_utilsAddFocusListener);
	
	var _domHelpersUtilInDOM = __webpack_require__(127);
	
	var _domHelpersUtilInDOM2 = _interopRequireDefault(_domHelpersUtilInDOM);
	
	var _domHelpersActiveElement = __webpack_require__(519);
	
	var _domHelpersActiveElement2 = _interopRequireDefault(_domHelpersActiveElement);
	
	var _domHelpersQueryContains = __webpack_require__(173);
	
	var _domHelpersQueryContains2 = _interopRequireDefault(_domHelpersQueryContains);
	
	var _utilsGetContainer = __webpack_require__(313);
	
	var _utilsGetContainer2 = _interopRequireDefault(_utilsGetContainer);
	
	var modalManager = new _ModalManager2['default']();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2['default'].createClass({
	  displayName: 'Modal',
	
	  propTypes: _extends({}, _Portal2['default'].propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2['default'].PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2['default'].PropTypes.oneOfType([_reactPropTypesLibMountable2['default'], _react2['default'].PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2['default'].PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2['default'].PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.oneOf(['static'])]),
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2['default'].PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2['default'].PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2['default'].PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2['default'].PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2['default'].PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2['default'].PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _reactPropTypesLibElementType2['default'],
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2['default'].PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2['default'].PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2['default'].PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2['default'].PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2['default'].PropTypes.func
	
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      onHide: noop
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var Transition = _props.transition;
	    var backdrop = _props.backdrop;
	    var dialogTransitionTimeout = _props.dialogTransitionTimeout;
	
	    var props = _objectWithoutProperties(_props, ['children', 'transition', 'backdrop', 'dialogTransitionTimeout']);
	
	    var onExit = props.onExit;
	    var onExiting = props.onExiting;
	    var onEnter = props.onEnter;
	    var onEntering = props.onEntering;
	    var onEntered = props.onEntered;
	
	    var show = !!props.show;
	    var dialog = _react2['default'].Children.only(this.props.children);
	
	    var mountModal = show || Transition && !this.state.exited;
	
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props;
	    var role = _dialog$props.role;
	    var tabIndex = _dialog$props.tabIndex;
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = _react.cloneElement(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2['default'].createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2['default'].createElement(
	      _Portal2['default'],
	      {
	        ref: this.setMountNode,
	        container: props.container
	      },
	      _react2['default'].createElement(
	        'div',
	        {
	          ref: 'modal',
	          role: props.role || 'dialog',
	          style: props.style,
	          className: props.className
	        },
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	
	  renderBackdrop: function renderBackdrop() {
	    var _props2 = this.props;
	    var Transition = _props2.transition;
	    var backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	    var backdrop = _react2['default'].createElement('div', { ref: 'backdrop',
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2['default'].createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props;
	    var show = _props3.show;
	    var transition = _props3.transition;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	
	  onShow: function onShow() {
	    var doc = _utilsOwnerDocument2['default'](this);
	    var container = _utilsGetContainer2['default'](this.props.container, doc.body);
	
	    modalManager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = _utilsAddEventListener2['default'](doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = _utilsAddFocusListener2['default'](this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	
	  onHide: function onHide() {
	    modalManager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    this.restoreLastFocus();
	  },
	
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	
	  checkForFocus: function checkForFocus() {
	    if (_domHelpersUtilInDOM2['default']) {
	      this.lastFocus = _domHelpersActiveElement2['default']();
	    }
	  },
	
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = _domHelpersActiveElement2['default'](_utilsOwnerDocument2['default'](this));
	    var focusInModal = current && _domHelpersQueryContains2['default'](modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        _warning2['default'](false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = _domHelpersActiveElement2['default'](_utilsOwnerDocument2['default'](this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !_domHelpersQueryContains2['default'](modal, active)) {
	      modal.focus();
	    }
	  },
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	
	  isTopModal: function isTopModal() {
	    return modalManager.isTopModal(this);
	  }
	
	});
	
	Modal.manager = modalManager;
	
	exports['default'] = Modal;
	module.e = exports['default'];


/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _domHelpersStyle = __webpack_require__(217);
	
	var _domHelpersStyle2 = _interopRequireDefault(_domHelpersStyle);
	
	var _domHelpersClass = __webpack_require__(1369);
	
	var _domHelpersClass2 = _interopRequireDefault(_domHelpersClass);
	
	var _domHelpersUtilScrollbarSize = __webpack_require__(525);
	
	var _domHelpersUtilScrollbarSize2 = _interopRequireDefault(_domHelpersUtilScrollbarSize);
	
	var _utilsIsOverflowing = __webpack_require__(575);
	
	var _utilsIsOverflowing2 = _interopRequireDefault(_utilsIsOverflowing);
	
	var _utilsManageAriaHidden = __webpack_require__(1619);
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = (function () {
	  function ModalManager() {
	    var hideSiblingNodes = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  ModalManager.prototype.add = function add(modal, container, className) {
	    var modalIdx = this.modals.indexOf(modal);
	    var containerIdx = this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = this.modals.length;
	    this.modals.push(modal);
	
	    if (this.hideSiblingNodes) {
	      _utilsManageAriaHidden.hideSiblings(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	      //we are only interested in the actual `style` here becasue we will override it
	      style: {
	        overflow: container.style.overflow,
	        paddingRight: container.style.paddingRight
	      }
	    };
	
	    var style = { overflow: 'hidden' };
	
	    data.overflowing = _utilsIsOverflowing2['default'](container);
	
	    if (data.overflowing) {
	      // use computed style, here to get the real padding
	      // to add our scrollbar width
	      style.paddingRight = parseInt(_domHelpersStyle2['default'](container, 'paddingRight') || 0, 10) + _domHelpersUtilScrollbarSize2['default']() + 'px';
	    }
	
	    _domHelpersStyle2['default'](container, style);
	
	    data.classes.forEach(_domHelpersClass2['default'].addClass.bind(null, container));
	
	    this.containers.push(container);
	    this.data.push(data);
	
	    return modalIdx;
	  };
	
	  ModalManager.prototype.remove = function remove(modal) {
	    var modalIdx = this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(this.data, modal);
	    var data = this.data[containerIdx];
	    var container = this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container stylinhg.
	    if (data.modals.length === 0) {
	      Object.keys(data.style).forEach(function (key) {
	        return container.style[key] = data.style[key];
	      });
	
	      data.classes.forEach(_domHelpersClass2['default'].removeClass.bind(null, container));
	
	      if (this.hideSiblingNodes) {
	        _utilsManageAriaHidden.showSiblings(container, modal.mountNode);
	      }
	      this.containers.splice(containerIdx, 1);
	      this.data.splice(containerIdx, 1);
	    } else if (this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      _utilsManageAriaHidden.ariaHidden(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  ModalManager.prototype.isTopModal = function isTopModal(modal) {
	    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	  };
	
	  return ModalManager;
	})();
	
	exports['default'] = ModalManager;
	module.e = exports['default'];


/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(571);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1616);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(572);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _reactPropTypesLibElementType = __webpack_require__(577);
	
	var _reactPropTypesLibElementType2 = _interopRequireDefault(_reactPropTypesLibElementType);
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	
	var Overlay = (function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    _React$Component.call(this, props, context);
	
	    this.state = { exited: !props.show };
	    this.onHiddenListener = this.handleHidden.bind(this);
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props;
	    var container = _props.container;
	    var containerPadding = _props.containerPadding;
	    var target = _props.target;
	    var placement = _props.placement;
	    var shouldUpdatePosition = _props.shouldUpdatePosition;
	    var rootClose = _props.rootClose;
	    var children = _props.children;
	    var Transition = _props.transition;
	
	    var props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2['default'].createElement(
	      _Position2['default'],
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit;
	      var onExiting = props.onExiting;
	      var onEnter = props.onEnter;
	      var onEntering = props.onEntering;
	      var onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	      child = _react2['default'].createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2['default'].createElement(
	        _RootCloseWrapper2['default'],
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2['default'].createElement(
	      _Portal2['default'],
	      { container: container },
	      child
	    );
	  };
	
	  Overlay.prototype.handleHidden = function handleHidden() {
	    this.setState({ exited: true });
	
	    if (this.props.onExited) {
	      var _props2;
	
	      (_props2 = this.props).onExited.apply(_props2, arguments);
	    }
	  };
	
	  return Overlay;
	})(_react2['default'].Component);
	
	Overlay.propTypes = _extends({}, _Portal2['default'].propTypes, _Position2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props, name, cname) {
	    var pt = _react2['default'].PropTypes.func;
	
	    if (props.rootClose) pt = pt.isRequired;
	    return pt(props, name, cname);
	  },
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _reactPropTypesLibElementType2['default'],
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func
	});
	
	exports['default'] = Overlay;
	module.e = exports['default'];


/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(17);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsOwnerDocument = __webpack_require__(177);
	
	var _utilsOwnerDocument2 = _interopRequireDefault(_utilsOwnerDocument);
	
	var _utilsGetContainer = __webpack_require__(313);
	
	var _utilsGetContainer2 = _interopRequireDefault(_utilsGetContainer);
	
	var _utilsOverlayPositionUtils = __webpack_require__(1620);
	
	var _reactPropTypesLibMountable = __webpack_require__(314);
	
	var _reactPropTypesLibMountable2 = _interopRequireDefault(_reactPropTypesLibMountable);
	
	/**
	 * The Position component calculates the coordinates for its child, to
	 * position it relative to a `target` component or node. Useful for creating callouts and tooltips,
	 * the Position component injects a `style` props with `left` and `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows for giving your components
	 * a sense of directionality.
	 */
	
	var Position = (function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    _React$Component.call(this, props, context);
	
	    this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    this._needsFlush = false;
	    this._lastTarget = null;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition();
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.updatePosition(prevProps.placement !== this.props.placement);
	    }
	  };
	
	  Position.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Probably not necessary, but just in case holding a reference to the
	    // target causes problems somewhere.
	    this._lastTarget = null;
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state;
	    var positionLeft = _state.positionLeft;
	    var positionTop = _state.positionTop;
	
	    var arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	
	    var child = _react2['default'].Children.only(children);
	    return _react.cloneElement(child, _extends({}, props, arrowPosition, {
	      //do we need to also forward positionLeft and positionTop if they are set to style?
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: _classnames2['default'](className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.getTargetSafe = function getTargetSafe() {
	    if (!this.props.target) {
	      return null;
	    }
	
	    var target = this.props.target(this.props);
	    if (!target) {
	      // This is so we can just use === check below on all falsy targets.
	      return null;
	    }
	
	    return target;
	  };
	
	  Position.prototype.updatePosition = function updatePosition(placementChanged) {
	    var target = this.getTargetSafe();
	
	    if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	      return;
	    }
	
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2['default'].findDOMNode(this);
	    var container = _utilsGetContainer2['default'](this.props.container, _utilsOwnerDocument2['default'](this).body);
	
	    this.setState(_utilsOverlayPositionUtils.calcOverlayPosition(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	})(_react2['default'].Component);
	
	Position.propTypes = {
	  /**
	   * Function mapping props to a DOM node the component is positioned next to
	   *
	   */
	  target: _react2['default'].PropTypes.func,
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2['default'].PropTypes.oneOfType([_reactPropTypesLibMountable2['default'], _react2['default'].PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2['default'].PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2['default'].PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports['default'] = Position;
	module.e = exports['default'];


/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = addFocusListener;
	
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = undefined;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function () {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function () {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	
	module.e = exports['default'];


/***/ },
/* 1618 */
59,
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType;
	  var tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}


/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ownerDocument = __webpack_require__(177);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _domHelpersQueryOffset = __webpack_require__(522);
	
	var _domHelpersQueryOffset2 = _interopRequireDefault(_domHelpersQueryOffset);
	
	var _domHelpersQueryPosition = __webpack_require__(1374);
	
	var _domHelpersQueryPosition2 = _interopRequireDefault(_domHelpersQueryPosition);
	
	var _domHelpersQueryScrollTop = __webpack_require__(523);
	
	var _domHelpersQueryScrollTop2 = _interopRequireDefault(_domHelpersQueryScrollTop);
	
	var utils = {
	
	  getContainerDimensions: function getContainerDimensions(containerNode) {
	    var width = undefined,
	        height = undefined,
	        scroll = undefined;
	
	    if (containerNode.tagName === 'BODY') {
	      width = window.innerWidth;
	      height = window.innerHeight;
	
	      scroll = _domHelpersQueryScrollTop2['default'](_ownerDocument2['default'](containerNode).documentElement) || _domHelpersQueryScrollTop2['default'](containerNode);
	    } else {
	      var _getOffset = _domHelpersQueryOffset2['default'](containerNode);
	
	      width = _getOffset.width;
	      height = _getOffset.height;
	
	      scroll = _domHelpersQueryScrollTop2['default'](containerNode);
	    }
	
	    return { width: width, height: height, scroll: scroll };
	  },
	
	  getPosition: function getPosition(target, container) {
	    var offset = container.tagName === 'BODY' ? _domHelpersQueryOffset2['default'](target) : _domHelpersQueryPosition2['default'](target, container);
	
	    return offset;
	  },
	
	  calcOverlayPosition: function calcOverlayPosition(placement, overlayNode, target, container, padding) {
	    var childOffset = utils.getPosition(target, container);
	
	    var _getOffset2 = _domHelpersQueryOffset2['default'](overlayNode);
	
	    var overlayHeight = _getOffset2.height;
	    var overlayWidth = _getOffset2.width;
	
	    var positionLeft = undefined,
	        positionTop = undefined,
	        arrowOffsetLeft = undefined,
	        arrowOffsetTop = undefined;
	
	    if (placement === 'left' || placement === 'right') {
	      positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	      if (placement === 'left') {
	        positionLeft = childOffset.left - overlayWidth;
	      } else {
	        positionLeft = childOffset.left + childOffset.width;
	      }
	
	      var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	      positionTop += topDelta;
	      arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	      arrowOffsetLeft = void 0;
	    } else if (placement === 'top' || placement === 'bottom') {
	      positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	      if (placement === 'top') {
	        positionTop = childOffset.top - overlayHeight;
	      } else {
	        positionTop = childOffset.top + childOffset.height;
	      }
	
	      var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	      positionLeft += leftDelta;
	      arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	      arrowOffsetTop = void 0;
	    } else {
	      throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	    }
	
	    return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	  }
	};
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = utils.getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = utils.getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	exports['default'] = utils;
	module.e = exports['default'];


/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Checks if only one of the listed properties is in use. An error is given
	 * if multiple have a value
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSinglePropFromChecker;
	
	function createSinglePropFromChecker() {
	  for (var _len = arguments.length, arrOfProps = Array(_len), _key = 0; _key < _len; _key++) {
	    arrOfProps[_key] = arguments[_key];
	  }
	
	  function validate(props, propName) {
	    var usedPropCount = arrOfProps.map(function (listedProp) {
	      return props[listedProp];
	    }).reduce(function (acc, curr) {
	      return acc + (curr !== undefined ? 1 : 0);
	    }, 0);
	
	    if (usedPropCount > 1) {
	      var first = arrOfProps[0];
	      var others = arrOfProps.slice(1);
	
	      var message = others.join(', ') + ' and ' + first;
	      return new Error('Invalid prop \'' + propName + '\', only one of the following ' + ('may be provided: ' + message));
	    }
	  }
	  return validate;
	}
	
	module.e = exports['default'];


/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _PropTypes = __webpack_require__(134);
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _PropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? _routerWarning2['default'](false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : undefined;
	    this.history = this.context.history;
	  }
	
	};
	
	exports['default'] = History;
	module.e = exports['default'];


/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(578);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2['default'].createClass({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2['default'].createElement(_Link2['default'], _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	
	});
	
	exports['default'] = IndexLink;
	module.e = exports['default'];


/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(579);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _PropTypes = __webpack_require__(134);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	var IndexRedirect = _react2['default'].createClass({
	  displayName: 'IndexRedirect',
	
	  statics: {
	
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2['default'].createRouteFromReactElement(element);
	      } else {
	         false ? _routerWarning2['default'](false, 'An <IndexRedirect> does not make sense at the root of your route config') : undefined;
	      }
	    }
	
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _PropTypes.falsy,
	    children: _PropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = IndexRedirect;
	module.e = exports['default'];


/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _PropTypes = __webpack_require__(134);
	
	var func = _react2['default'].PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	var IndexRoute = _react2['default'].createClass({
	  displayName: 'IndexRoute',
	
	  statics: {
	
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _RouteUtils.createRouteFromReactElement(element);
	      } else {
	         false ? _routerWarning2['default'](false, 'An <IndexRoute> does not make sense at the root of your route config') : undefined;
	      }
	    }
	
	  },
	
	  propTypes: {
	    path: _PropTypes.falsy,
	    component: _PropTypes.component,
	    components: _PropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<IndexRoute> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = IndexRoute;
	module.e = exports['default'];


/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var object = _react2['default'].PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? _routerWarning2['default'](false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : undefined;
	    !this.routerWillLeave ?  false ? _invariant2['default'](false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : _invariant2['default'](false) : undefined;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? _invariant2['default'](false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : _invariant2['default'](false) : undefined;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	
	};
	
	exports['default'] = Lifecycle;
	module.e = exports['default'];


/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _PropTypes = __webpack_require__(134);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	var Route = _react2['default'].createClass({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _PropTypes.component,
	    components: _PropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<Route> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = Route;
	module.e = exports['default'];


/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var object = _react2['default'].PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? _routerWarning2['default'](false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : undefined;
	  }
	
	};
	
	exports['default'] = RouteContext;
	module.e = exports['default'];


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _historyLibCreateHashHistory = __webpack_require__(528);
	
	var _historyLibCreateHashHistory2 = _interopRequireDefault(_historyLibCreateHashHistory);
	
	var _historyLibUseQueries = __webpack_require__(222);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(319);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _PropTypes = __webpack_require__(134);
	
	var _RouterContext = __webpack_require__(318);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _RouterUtils = __webpack_require__(580);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = _react2['default'].createClass({
	  displayName: 'Router',
	
	  propTypes: {
	    history: object,
	    children: _PropTypes.routes,
	    routes: _PropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2['default'].createElement(_RouterContext2['default'], props);
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? _routerWarning2['default'](!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : undefined;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = _createTransitionManager2['default'](history, _RouteUtils.createRoutes(routes || children));
	    var router = _RouterUtils.createRouterObject(history, transitionManager);
	    var routingHistory = _RouterUtils.createRoutingHistory(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	    var createHistory = undefined;
	    if (history) {
	       false ? _routerWarning2['default'](false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : undefined;
	      createHistory = function () {
	        return history;
	      };
	    } else {
	       false ? _routerWarning2['default'](false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : undefined;
	      createHistory = _historyLibCreateHashHistory2['default'];
	    }
	
	    return _historyLibUseQueries2['default'](createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? _routerWarning2['default'](nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : undefined;
	
	     false ? _routerWarning2['default']((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : undefined;
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	
	});
	
	exports['default'] = Router;
	module.e = exports['default'];


/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(318);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var RoutingContext = _react2['default'].createClass({
	  displayName: 'RoutingContext',
	
	  componentWillMount: function componentWillMount() {
	     false ? _routerWarning2['default'](false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : undefined;
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_RouterContext2['default'], this.props);
	  }
	});
	
	exports['default'] = RoutingContext;
	module.e = exports['default'];


/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _AsyncUtils = __webpack_require__(317);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function createEnterHook(hook, route) {
	  return function (a, b, callback) {
	    hook.apply(route, arguments);
	
	    if (hook.length < 3) {
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createEnterHook(route.onEnter, route));
	
	    return hooks;
	  }, []);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	
	  if (!hooks.length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = undefined;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? _routerWarning2['default'](false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : undefined;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  _AsyncUtils.loopAsync(hooks.length, function (index, next, done) {
	    hooks[index](nextState, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	          next();
	        }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	
	function runLeaveHooks(routes) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i]);
	  }
	}


/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibCreateBrowserHistory = __webpack_require__(1464);
	
	var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(582);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	exports['default'] = _createRouterHistory2['default'](_historyLibCreateBrowserHistory2['default']);
	module.e = exports['default'];


/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(153);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = _PatternUtils.getParamNames(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = undefined,
	      enterRoutes = undefined;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = nextRoutes.filter(function (route) {
	        return prevRoutes.indexOf(route) === -1 || leaveRoutes.indexOf(route) !== -1;
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports['default'] = computeChangedRoutes;
	module.e = exports['default'];


/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(317);
	
	function getComponentsForRoute(location, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	  } else if (route.getComponent) {
	    route.getComponent(location, callback);
	  } else if (route.getComponents) {
	    route.getComponents(location, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  _AsyncUtils.mapAsync(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState.location, route, callback);
	  }, callback);
	}
	
	exports['default'] = getComponents;
	module.e = exports['default'];


/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(153);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  var paramNames = _PatternUtils.getParamNames(route.path);
	
	  for (var p in params) {
	    if (params.hasOwnProperty(p) && paramNames.indexOf(p) !== -1) routeParams[p] = params[p];
	  }return routeParams;
	}
	
	exports['default'] = getRouteParams;
	module.e = exports['default'];


/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibCreateHashHistory = __webpack_require__(528);
	
	var _historyLibCreateHashHistory2 = _interopRequireDefault(_historyLibCreateHashHistory);
	
	var _createRouterHistory = __webpack_require__(582);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	exports['default'] = _createRouterHistory2['default'](_historyLibCreateHashHistory2['default']);
	module.e = exports['default'];


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isActive;
	
	var _PatternUtils = __webpack_require__(153);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if (typeof a === 'object') {
	    for (var p in a) {
	      if (!a.hasOwnProperty(p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!b.hasOwnProperty(p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	function paramsAreActive(paramNames, paramValues, activeParams) {
	  // FIXME: This doesn't work on repeated params in activeParams.
	  return paramNames.every(function (paramName, index) {
	    return String(paramValues[index]) === String(activeParams[paramName]);
	  });
	}
	
	function getMatchingRouteIndex(pathname, activeRoutes, activeParams) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  for (var i = 0, len = activeRoutes.length; i < len; ++i) {
	    var route = activeRoutes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null) {
	      var matched = _PatternUtils.matchPattern(pattern, remainingPathname);
	      remainingPathname = matched.remainingPathname;
	      paramNames = [].concat(paramNames, matched.paramNames);
	      paramValues = [].concat(paramValues, matched.paramValues);
	    }
	
	    if (remainingPathname === '' && route.path && paramsAreActive(paramNames, paramValues, activeParams)) return i;
	  }
	
	  return null;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes
	 * and params.
	 */
	function routeIsActive(pathname, routes, params, indexOnly) {
	  var i = getMatchingRouteIndex(pathname, routes, params);
	
	  if (i === null) {
	    // No match.
	    return false;
	  } else if (!indexOnly) {
	    // Any match is good enough.
	    return true;
	  }
	
	  // If any remaining routes past the match index have paths, then we can't
	  // be on the index route.
	  return routes.slice(i + 1).every(function (route) {
	    return !route.path;
	  });
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  if (!routeIsActive(pathname, routes, params, indexOnly)) return false;
	
	  return queryIsActive(query, currentLocation.query);
	}
	
	module.e = exports['default'];


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(581);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(319);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(109);
	
	var _RouterUtils = __webpack_require__(580);
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? _invariant2['default'](false, 'match needs a history or a location') : _invariant2['default'](false) : undefined;
	
	  history = history ? history : _createMemoryHistory2['default'](options);
	  var transitionManager = _createTransitionManager2['default'](history, _RouteUtils.createRoutes(routes));
	
	  var unlisten = undefined;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = _RouterUtils.createRouterObject(history, transitionManager);
	  history = _RouterUtils.createRoutingHistory(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports['default'] = match;
	module.e = exports['default'];


/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _AsyncUtils = __webpack_require__(317);
	
	var _PatternUtils = __webpack_require__(153);
	
	var _RouteUtils = __webpack_require__(109);
	
	function getChildRoutes(route, location, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = undefined;
	
	  route.getChildRoutes(location, function (error, childRoutes) {
	    childRoutes = !error && _RouteUtils.createRoutes(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    route.getIndexRoute(location, function (error, indexRoute) {
	      callback(error, !error && _RouteUtils.createRoutes(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (obj) {
	        return !obj.hasOwnProperty('path');
	      });
	
	      _AsyncUtils.loopAsync(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  if (remainingPathname !== null) {
	    var matched = _PatternUtils.matchPattern(pattern, remainingPathname);
	    remainingPathname = matched.remainingPathname;
	    paramNames = [].concat(paramNames, matched.paramNames);
	    paramValues = [].concat(paramValues, matched.paramValues);
	
	    if (remainingPathname === '' && route.path) {
	      var _ret2 = (function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? _routerWarning2['default'](indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : undefined;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? _routerWarning2['default'](!indexRoute.path, 'Index routes should not have paths') : undefined;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	        return {
	          v: undefined
	        };
	      })();
	
	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback) {
	  var remainingPathname = arguments.length <= 3 || arguments[3] === undefined ? location.pathname : arguments[3];
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	  return (function () {
	    _AsyncUtils.loopAsync(routes.length, function (index, next, done) {
	      matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	        if (error || match) {
	          done(error, match);
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  })();
	}
	
	exports['default'] = matchRoutes;
	module.e = exports['default'];


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _historyLibUseQueries = __webpack_require__(222);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _createTransitionManager = __webpack_require__(319);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(54);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? _routerWarning2['default'](false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : undefined;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = _historyLibUseQueries2['default'](createHistory)(options);
	    var transitionManager = _createTransitionManager2['default'](history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports['default'] = useRoutes;
	module.e = exports['default'];


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * <TextareaAutosize />
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _calculateNodeHeight = __webpack_require__(1642);
	
	var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);
	
	var emptyFunction = function emptyFunction() {};
	
	var TextareaAutosize = (function (_React$Component) {
	  _inherits(TextareaAutosize, _React$Component);
	
	  _createClass(TextareaAutosize, null, [{
	    key: 'propTypes',
	    value: {
	      /**
	       * Current textarea value.
	       */
	      value: _react2['default'].PropTypes.string,
	
	      /**
	       * Callback on value change.
	       */
	      onChange: _react2['default'].PropTypes.func,
	
	      /**
	       * Callback on height changes.
	       */
	      onHeightChange: _react2['default'].PropTypes.func,
	
	      /**
	       * Try to cache DOM measurements performed by component so that we don't
	       * touch DOM when it's not needed.
	       *
	       * This optimization doesn't work if we dynamically style <textarea />
	       * component.
	       */
	      useCacheForDOMMeasurements: _react2['default'].PropTypes.bool,
	
	      /**
	       * Minimal numbder of rows to show.
	       */
	      rows: _react2['default'].PropTypes.number,
	
	      /**
	       * Alias for `rows`.
	       */
	      minRows: _react2['default'].PropTypes.number,
	
	      /**
	       * Maximum number of rows to show.
	       */
	      maxRows: _react2['default'].PropTypes.number
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      onChange: emptyFunction,
	      onHeightChange: emptyFunction,
	      useCacheForDOMMeasurements: false
	    },
	    enumerable: true
	  }]);
	
	  function TextareaAutosize(props) {
	    _classCallCheck(this, TextareaAutosize);
	
	    _get(Object.getPrototypeOf(TextareaAutosize.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      height: null,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	    this._onNextFrameActionId = null;
	    this._rootDOMNode = null;
	    this._onChange = this._onChange.bind(this);
	    this._resizeComponent = this._resizeComponent.bind(this);
	    this._onRootDOMNode = this._onRootDOMNode.bind(this);
	  }
	
	  _createClass(TextareaAutosize, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var valueLink = _props.valueLink;
	      var onChange = _props.onChange;
	
	      var props = _objectWithoutProperties(_props, ['valueLink', 'onChange']);
	
	      props = _extends({}, props);
	      if (typeof valueLink === 'object') {
	        props.value = this.props.valueLink.value;
	      }
	      props.style = _extends({}, props.style, {
	        height: this.state.height
	      });
	      var maxHeight = Math.max(props.style.maxHeight ? props.style.maxHeight : Infinity, this.state.maxHeight);
	      if (maxHeight < this.state.height) {
	        props.style.overflow = 'hidden';
	      }
	      return _react2['default'].createElement('textarea', _extends({}, props, {
	        onChange: this._onChange,
	        ref: this._onRootDOMNode
	      }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._resizeComponent();
	      window.addEventListener('resize', this._resizeComponent);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      // Re-render with the new content then recalculate the height as required.
	      this._clearNextFrame();
	      this._onNextFrameActionId = onNextFrame(this._resizeComponent);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Invoke callback when old height does not equal to new one.
	      if (this.state.height !== prevState.height) {
	        this.props.onHeightChange(this.state.height);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove any scheduled events to prevent manipulating the node after it's
	      // been unmounted.
	      this._clearNextFrame();
	      window.removeEventListener('resize', this._resizeComponent);
	    }
	  }, {
	    key: '_clearNextFrame',
	    value: function _clearNextFrame() {
	      if (this._onNextFrameActionId) {
	        clearNextFrameAction(this._onNextFrameActionId);
	      }
	    }
	  }, {
	    key: '_onRootDOMNode',
	    value: function _onRootDOMNode(node) {
	      this._rootDOMNode = node;
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(e) {
	      this._resizeComponent();
	      var _props2 = this.props;
	      var valueLink = _props2.valueLink;
	      var onChange = _props2.onChange;
	
	      if (valueLink) {
	        valueLink.requestChange(e.target.value);
	      } else {
	        onChange(e);
	      }
	    }
	  }, {
	    key: '_resizeComponent',
	    value: function _resizeComponent() {
	      var useCacheForDOMMeasurements = this.props.useCacheForDOMMeasurements;
	
	      this.setState((0, _calculateNodeHeight2['default'])(this._rootDOMNode, useCacheForDOMMeasurements, this.props.rows || this.props.minRows, this.props.maxRows));
	    }
	
	    /**
	     * Read the current value of <textarea /> from DOM.
	     */
	  }, {
	    key: 'focus',
	
	    /**
	     * Put focus on a <textarea /> DOM element.
	     */
	    value: function focus() {
	      this._rootDOMNode.focus();
	    }
	
	    /**
	     * Shifts focus away from a <textarea /> DOM element.
	     */
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this._rootDOMNode.blur();
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return this._rootDOMNode.value;
	    },
	
	    /**
	     * Set the current value of <textarea /> DOM node.
	     */
	    set: function set(val) {
	      this._rootDOMNode.value = val;
	    }
	
	    /**
	     * Read the current selectionStart of <textarea /> from DOM.
	     */
	  }, {
	    key: 'selectionStart',
	    get: function get() {
	      return this._rootDOMNode.selectionStart;
	    },
	
	    /**
	     * Set the current selectionStart of <textarea /> DOM node.
	     */
	    set: function set(val) {
	      this._rootDOMNode.selectionStart = val;
	    }
	
	    /**
	     * Read the current selectionEnd of <textarea /> from DOM.
	     */
	  }, {
	    key: 'selectionEnd',
	    get: function get() {
	      return this._rootDOMNode.selectionEnd;
	    },
	
	    /**
	     * Set the current selectionEnd of <textarea /> DOM node.
	     */
	    set: function set(val) {
	      this._rootDOMNode.selectionEnd = val;
	    }
	  }]);
	
	  return TextareaAutosize;
	})(_react2['default'].Component);
	
	exports['default'] = TextareaAutosize;
	
	function onNextFrame(cb) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(cb);
	  }
	  return window.setTimeout(cb, 1);
	}
	
	function clearNextFrameAction(nextFrameId) {
	  if (window.cancelAnimationFrame) {
	    window.cancelAnimationFrame(nextFrameId);
	  } else {
	    window.clearTimeout(nextFrameId);
	  }
	}
	module.e = exports['default'];
	


/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = calculateNodeHeight;
	var HIDDEN_TEXTAREA_STYLE = '\n  min-height:none !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	var computedStyleCache = {};
	var hiddenTextarea = undefined;
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	  var minRows = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	  var maxRows = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache);
	
	  var paddingSize = _calculateNodeStyling.paddingSize;
	  var borderSize = _calculateNodeStyling.borderSize;
	  var boxSizing = _calculateNodeStyling.boxSizing;
	  var sizingStyle = _calculateNodeStyling.sizingStyle;
	
	  // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	  hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = '';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	      height = Math.max(minHeight, height);
	    }
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	      height = Math.min(maxHeight, height);
	    }
	  }
	  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
	}
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	module.e = exports['default'];
	


/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(60);
	
	var findDOMNode = __webpack_require__(328);
	var focusNode = __webpack_require__(615);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.e = AutoFocusUtils;


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventPropagators = __webpack_require__(180);
	var ExecutionEnvironment = __webpack_require__(55);
	var FallbackCompositionState = __webpack_require__(1652);
	var SyntheticCompositionEvent = __webpack_require__(1683);
	var SyntheticInputEvent = __webpack_require__(1686);
	
	var keyOf = __webpack_require__(111);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.e = BeforeInputEventPlugin;


/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(585);
	var ExecutionEnvironment = __webpack_require__(55);
	var ReactPerf = __webpack_require__(78);
	
	var camelizeStyleName = __webpack_require__(1701);
	var dangerousStyleValue = __webpack_require__(1691);
	var hyphenateStyleName = __webpack_require__(1706);
	var memoizeStringOnly = __webpack_require__(1710);
	var warning = __webpack_require__(33);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.e = CSSPropertyOperations;


/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventPluginHub = __webpack_require__(179);
	var EventPropagators = __webpack_require__(180);
	var ExecutionEnvironment = __webpack_require__(55);
	var ReactUpdates = __webpack_require__(79);
	var SyntheticEvent = __webpack_require__(136);
	
	var getEventTarget = __webpack_require__(331);
	var isEventSupported = __webpack_require__(334);
	var isTextInputElement = __webpack_require__(612);
	var keyOf = __webpack_require__(111);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.e = ChangeEventPlugin;


/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.e = ClientReactRootIndex;


/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var createNodesFromMarkup = __webpack_require__(1703);
	var emptyFunction = __webpack_require__(88);
	var getMarkupWrap = __webpack_require__(617);
	var invariant = __webpack_require__(26);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.e = Danger;


/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(111);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.e = DefaultEventPluginOrder;


/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventPropagators = __webpack_require__(180);
	var SyntheticMouseEvent = __webpack_require__(233);
	
	var ReactMount = __webpack_require__(60);
	var keyOf = __webpack_require__(111);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.e = EnterLeaveEventPlugin;


/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var ReactErrorUtils = __webpack_require__(600);
	
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.e = EventPluginUtils;


/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(110);
	
	var assign = __webpack_require__(32);
	var getTextContentAccessor = __webpack_require__(611);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.e = FallbackCompositionState;


/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(154);
	var ExecutionEnvironment = __webpack_require__(55);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.e = HTMLDOMPropertyConfig;


/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(591);
	var ReactDOMServer = __webpack_require__(1665);
	var ReactIsomorphic = __webpack_require__(1670);
	
	var assign = __webpack_require__(32);
	var deprecated = __webpack_require__(1692);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.e = React;


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(181);
	
	var findDOMNode = __webpack_require__(328);
	var warning = __webpack_require__(33);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.e = ReactBrowserComponentMixin;


/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(135);
	
	var instantiateReactComponent = __webpack_require__(333);
	var shouldUpdateReactComponent = __webpack_require__(336);
	var traverseAllChildren = __webpack_require__(337);
	var warning = __webpack_require__(33);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.e = ReactChildReconciler;


/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentWithPureRenderMixin
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(1699);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.e = ReactComponentWithPureRenderMixin;


/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(324);
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactElement = __webpack_require__(67);
	var ReactInstanceMap = __webpack_require__(181);
	var ReactPerf = __webpack_require__(78);
	var ReactPropTypeLocations = __webpack_require__(232);
	var ReactPropTypeLocationNames = __webpack_require__(231);
	var ReactReconciler = __webpack_require__(135);
	var ReactUpdateQueue = __webpack_require__(326);
	
	var assign = __webpack_require__(32);
	var emptyObject = __webpack_require__(183);
	var invariant = __webpack_require__(26);
	var shouldUpdateReactComponent = __webpack_require__(336);
	var warning = __webpack_require__(33);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.e = ReactCompositeComponent;


/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.e = ReactDOMButton;


/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(1643);
	var CSSPropertyOperations = __webpack_require__(1645);
	var DOMProperty = __webpack_require__(154);
	var DOMPropertyOperations = __webpack_require__(321);
	var EventConstants = __webpack_require__(95);
	var ReactBrowserEventEmitter = __webpack_require__(230);
	var ReactComponentBrowserEnvironment = __webpack_require__(323);
	var ReactDOMButton = __webpack_require__(1659);
	var ReactDOMInput = __webpack_require__(1662);
	var ReactDOMOption = __webpack_require__(1663);
	var ReactDOMSelect = __webpack_require__(593);
	var ReactDOMTextarea = __webpack_require__(1666);
	var ReactMount = __webpack_require__(60);
	var ReactMultiChild = __webpack_require__(1671);
	var ReactPerf = __webpack_require__(78);
	var ReactUpdateQueue = __webpack_require__(326);
	
	var assign = __webpack_require__(32);
	var canDefineProperty = __webpack_require__(235);
	var escapeTextContentForBrowser = __webpack_require__(236);
	var invariant = __webpack_require__(26);
	var isEventSupported = __webpack_require__(334);
	var keyOf = __webpack_require__(111);
	var setInnerHTML = __webpack_require__(237);
	var setTextContent = __webpack_require__(335);
	var shallowEqual = __webpack_require__(339);
	var validateDOMNesting = __webpack_require__(338);
	var warning = __webpack_require__(33);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.e = ReactDOMComponent;


/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(67);
	var ReactElementValidator = __webpack_require__(597);
	
	var mapObject = __webpack_require__(1709);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.e = ReactDOMFactories;


/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(325);
	var LinkedValueUtils = __webpack_require__(322);
	var ReactMount = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(79);
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.e = ReactDOMInput;


/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(588);
	var ReactDOMSelect = __webpack_require__(593);
	
	var assign = __webpack_require__(32);
	var warning = __webpack_require__(33);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.e = ReactDOMOption;


/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var getNodeForCharacterOffset = __webpack_require__(1695);
	var getTextContentAccessor = __webpack_require__(611);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.e = ReactDOMSelection;


/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(596);
	var ReactServerRendering = __webpack_require__(1676);
	var ReactVersion = __webpack_require__(327);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.e = ReactDOMServer;


/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(322);
	var ReactDOMIDOperations = __webpack_require__(325);
	var ReactUpdates = __webpack_require__(79);
	
	var assign = __webpack_require__(32);
	var invariant = __webpack_require__(26);
	var warning = __webpack_require__(33);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.e = ReactDOMTextarea;


/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(179);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.e = ReactEventEmitterMixin;


/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(613);
	var ExecutionEnvironment = __webpack_require__(55);
	var PooledClass = __webpack_require__(110);
	var ReactInstanceHandles = __webpack_require__(155);
	var ReactMount = __webpack_require__(60);
	var ReactUpdates = __webpack_require__(79);
	
	var assign = __webpack_require__(32);
	var getEventTarget = __webpack_require__(331);
	var getUnboundedScrollPosition = __webpack_require__(1704);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.e = ReactEventListener;


/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(154);
	var EventPluginHub = __webpack_require__(179);
	var ReactComponentEnvironment = __webpack_require__(324);
	var ReactClass = __webpack_require__(589);
	var ReactEmptyComponent = __webpack_require__(598);
	var ReactBrowserEventEmitter = __webpack_require__(230);
	var ReactNativeComponent = __webpack_require__(604);
	var ReactPerf = __webpack_require__(78);
	var ReactRootIndex = __webpack_require__(607);
	var ReactUpdates = __webpack_require__(79);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.e = ReactInjection;


/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(588);
	var ReactComponent = __webpack_require__(590);
	var ReactClass = __webpack_require__(589);
	var ReactDOMFactories = __webpack_require__(1661);
	var ReactElement = __webpack_require__(67);
	var ReactElementValidator = __webpack_require__(597);
	var ReactPropTypes = __webpack_require__(606);
	var ReactVersion = __webpack_require__(327);
	
	var assign = __webpack_require__(32);
	var onlyChild = __webpack_require__(1696);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.e = React;


/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(324);
	var ReactMultiChildUpdateTypes = __webpack_require__(603);
	
	var ReactCurrentOwner = __webpack_require__(96);
	var ReactReconciler = __webpack_require__(135);
	var ReactChildReconciler = __webpack_require__(1656);
	
	var flattenChildren = __webpack_require__(1693);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.e = ReactMultiChild;


/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.e = ReactOwner;


/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(320);
	var PooledClass = __webpack_require__(110);
	var ReactBrowserEventEmitter = __webpack_require__(230);
	var ReactDOMFeatureFlags = __webpack_require__(592);
	var ReactInputSelection = __webpack_require__(601);
	var Transaction = __webpack_require__(234);
	
	var assign = __webpack_require__(32);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.e = ReactReconcileTransaction;


/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1672);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.e = ReactRef;


/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.e = ReactServerBatchingStrategy;


/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(595);
	var ReactElement = __webpack_require__(67);
	var ReactInstanceHandles = __webpack_require__(155);
	var ReactMarkupChecksum = __webpack_require__(602);
	var ReactServerBatchingStrategy = __webpack_require__(1675);
	var ReactServerRenderingTransaction = __webpack_require__(1677);
	var ReactUpdates = __webpack_require__(79);
	
	var emptyObject = __webpack_require__(183);
	var instantiateReactComponent = __webpack_require__(333);
	var invariant = __webpack_require__(26);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.e = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};


/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(110);
	var CallbackQueue = __webpack_require__(320);
	var Transaction = __webpack_require__(234);
	
	var assign = __webpack_require__(32);
	var emptyFunction = __webpack_require__(88);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.e = ReactServerRenderingTransaction;


/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(154);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.e = SVGDOMPropertyConfig;


/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventPropagators = __webpack_require__(180);
	var ExecutionEnvironment = __webpack_require__(55);
	var ReactInputSelection = __webpack_require__(601);
	var SyntheticEvent = __webpack_require__(136);
	
	var getActiveElement = __webpack_require__(616);
	var isTextInputElement = __webpack_require__(612);
	var keyOf = __webpack_require__(111);
	var shallowEqual = __webpack_require__(339);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.e = SelectEventPlugin;


/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.e = ServerReactRootIndex;


/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(95);
	var EventListener = __webpack_require__(613);
	var EventPropagators = __webpack_require__(180);
	var ReactMount = __webpack_require__(60);
	var SyntheticClipboardEvent = __webpack_require__(1682);
	var SyntheticEvent = __webpack_require__(136);
	var SyntheticFocusEvent = __webpack_require__(1685);
	var SyntheticKeyboardEvent = __webpack_require__(1687);
	var SyntheticMouseEvent = __webpack_require__(233);
	var SyntheticDragEvent = __webpack_require__(1684);
	var SyntheticTouchEvent = __webpack_require__(1688);
	var SyntheticUIEvent = __webpack_require__(182);
	var SyntheticWheelEvent = __webpack_require__(1689);
	
	var emptyFunction = __webpack_require__(88);
	var getEventCharCode = __webpack_require__(329);
	var invariant = __webpack_require__(26);
	var keyOf = __webpack_require__(111);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.e = SimpleEventPlugin;


/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(136);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.e = SyntheticClipboardEvent;


/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(136);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.e = SyntheticCompositionEvent;


/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(233);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.e = SyntheticDragEvent;


/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(182);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.e = SyntheticFocusEvent;


/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(136);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.e = SyntheticInputEvent;


/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(182);
	
	var getEventCharCode = __webpack_require__(329);
	var getEventKey = __webpack_require__(1694);
	var getEventModifierState = __webpack_require__(330);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.e = SyntheticKeyboardEvent;


/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(182);
	
	var getEventModifierState = __webpack_require__(330);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.e = SyntheticTouchEvent;


/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(233);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.e = SyntheticWheelEvent;


/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.e = adler32;


/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(585);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.e = dangerousStyleValue;


/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(32);
	var warning = __webpack_require__(33);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.e = deprecated;


/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(337);
	var warning = __webpack_require__(33);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.e = flattenChildren;


/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(329);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.e = getEventKey;


/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.e = getNodeForCharacterOffset;


/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(67);
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.e = onlyChild;


/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(236);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.e = quoteAttributeValueForBrowser;


/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(60);
	
	module.e = ReactMount.renderSubtreeIntoContainer;


/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule shallowCompare
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(339);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.e = shallowCompare;


/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.e = camelize;


/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1700);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.e = camelizeStyleName;


/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(1711);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.e = createArrayFromMixed;


/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(55);
	
	var createArrayFromMixed = __webpack_require__(1702);
	var getMarkupWrap = __webpack_require__(617);
	var invariant = __webpack_require__(26);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.e = createNodesFromMarkup;


/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.e = getUnboundedScrollPosition;


/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.e = hyphenate;


/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1705);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.e = hyphenateStyleName;


/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.e = isNode;


/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(1707);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.e = isTextNode;


/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.e = mapObject;


/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.e = memoizeStringOnly;


/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(26);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.e = toArray;


/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.e = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};


/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// constants table
	var zl = [
	  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	]
	
	var zr = [
	  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	]
	
	var sl = [
	  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	]
	
	var sr = [
	  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	]
	
	var hl = [0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]
	var hr = [0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]
	
	function bytesToWords (bytes) {
	  var words = []
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32)
	  }
	  return words
	}
	
	function wordsToBytes (words) {
	  var bytes = []
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF)
	  }
	  return bytes
	}
	
	function processBlock (H, M, offset) {
	  // swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i
	    var M_offset_i = M[offset_i]
	
	    // Swap
	    M[offset_i] = (
	      (((M_offset_i << 8) | (M_offset_i >>> 24)) & 0x00ff00ff) |
	      (((M_offset_i << 24) | (M_offset_i >>> 8)) & 0xff00ff00)
	    )
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el
	  var ar, br, cr, dr, er
	
	  ar = al = H[0]
	  br = bl = H[1]
	  cr = cl = H[2]
	  dr = dl = H[3]
	  er = el = H[4]
	
	  // computation
	  var t
	  for (i = 0; i < 80; i += 1) {
	    t = (al + M[offset + zl[i]]) | 0
	    if (i < 16) {
	      t += f1(bl, cl, dl) + hl[0]
	    } else if (i < 32) {
	      t += f2(bl, cl, dl) + hl[1]
	    } else if (i < 48) {
	      t += f3(bl, cl, dl) + hl[2]
	    } else if (i < 64) {
	      t += f4(bl, cl, dl) + hl[3]
	    } else {// if (i<80) {
	      t += f5(bl, cl, dl) + hl[4]
	    }
	    t = t | 0
	    t = rotl(t, sl[i])
	    t = (t + el) | 0
	    al = el
	    el = dl
	    dl = rotl(cl, 10)
	    cl = bl
	    bl = t
	
	    t = (ar + M[offset + zr[i]]) | 0
	    if (i < 16) {
	      t += f5(br, cr, dr) + hr[0]
	    } else if (i < 32) {
	      t += f4(br, cr, dr) + hr[1]
	    } else if (i < 48) {
	      t += f3(br, cr, dr) + hr[2]
	    } else if (i < 64) {
	      t += f2(br, cr, dr) + hr[3]
	    } else {// if (i<80) {
	      t += f1(br, cr, dr) + hr[4]
	    }
	
	    t = t | 0
	    t = rotl(t, sr[i])
	    t = (t + er) | 0
	    ar = er
	    er = dr
	    dr = rotl(cr, 10)
	    cr = br
	    br = t
	  }
	
	  // intermediate hash value
	  t = (H[1] + cl + dr) | 0
	  H[1] = (H[2] + dl + er) | 0
	  H[2] = (H[3] + el + ar) | 0
	  H[3] = (H[4] + al + br) | 0
	  H[4] = (H[0] + bl + cr) | 0
	  H[0] = t
	}
	
	function f1 (x, y, z) {
	  return ((x) ^ (y) ^ (z))
	}
	
	function f2 (x, y, z) {
	  return (((x) & (y)) | ((~x) & (z)))
	}
	
	function f3 (x, y, z) {
	  return (((x) | (~(y))) ^ (z))
	}
	
	function f4 (x, y, z) {
	  return (((x) & (z)) | ((y) & (~(z))))
	}
	
	function f5 (x, y, z) {
	  return ((x) ^ ((y) | (~(z))))
	}
	
	function rotl (x, n) {
	  return (x << n) | (x >>> (32 - n))
	}
	
	function ripemd160 (message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]
	
	  if (typeof message === 'string') {
	    message = new Buffer(message, 'utf8')
	  }
	
	  var m = bytesToWords(message)
	
	  var nBitsLeft = message.length * 8
	  var nBitsTotal = message.length * 8
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32)
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	    (((nBitsTotal << 8) | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	    (((nBitsTotal << 24) | (nBitsTotal >>> 8)) & 0xff00ff00)
	  )
	
	  for (var i = 0; i < m.length; i += 16) {
	    processBlock(H, m, i)
	  }
	
	  // swap endian
	  for (i = 0; i < 5; i++) {
	    // shortcut
	    var H_i = H[i]
	
	    // Swap
	    H[i] = (((H_i << 8) | (H_i >>> 24)) & 0x00ff00ff) |
	      (((H_i << 24) | (H_i >>> 8)) & 0xff00ff00)
	  }
	
	  var digestbytes = wordsToBytes(H)
	  return new Buffer(digestbytes)
	}
	
	module.e = ripemd160
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var exports = module.e = function SHA (algorithm) {
	  algorithm = algorithm.toLowerCase()
	
	  var Algorithm = exports[algorithm]
	  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')
	
	  return new Algorithm()
	}
	
	exports.sha = __webpack_require__(1715)
	exports.sha1 = __webpack_require__(1716)
	exports.sha224 = __webpack_require__(1717)
	exports.sha256 = __webpack_require__(618)
	exports.sha384 = __webpack_require__(1718)
	exports.sha512 = __webpack_require__(619)
	


/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
	 * in FIPS PUB 180-1
	 * This source code is derived from sha1.js of the same repository.
	 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
	 * operation was added.
	 */
	
	var inherits = __webpack_require__(27)
	var Hash = __webpack_require__(156)
	
	var K = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	]
	
	var W = new Array(80)
	
	function Sha () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha, Hash)
	
	Sha.prototype.init = function () {
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	  this._e = 0xc3d2e1f0
	
	  return this
	}
	
	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}
	
	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}
	
	function ft (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}
	
	Sha.prototype._update = function (M) {
	  var W = this._w
	
	  var a = this._a | 0
	  var b = this._b | 0
	  var c = this._c | 0
	  var d = this._d | 0
	  var e = this._e | 0
	
	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
	  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]
	
	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20)
	    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0
	
	    e = d
	    d = c
	    c = rotl30(b)
	    b = a
	    a = t
	  }
	
	  this._a = (a + this._a) | 0
	  this._b = (b + this._b) | 0
	  this._c = (c + this._c) | 0
	  this._d = (d + this._d) | 0
	  this._e = (e + this._e) | 0
	}
	
	Sha.prototype._hash = function () {
	  var H = new Buffer(20)
	
	  H.writeInt32BE(this._a | 0, 0)
	  H.writeInt32BE(this._b | 0, 4)
	  H.writeInt32BE(this._c | 0, 8)
	  H.writeInt32BE(this._d | 0, 12)
	  H.writeInt32BE(this._e | 0, 16)
	
	  return H
	}
	
	module.e = Sha
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(27)
	var Hash = __webpack_require__(156)
	
	var K = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	]
	
	var W = new Array(80)
	
	function Sha1 () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha1, Hash)
	
	Sha1.prototype.init = function () {
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	  this._e = 0xc3d2e1f0
	
	  return this
	}
	
	function rotl1 (num) {
	  return (num << 1) | (num >>> 31)
	}
	
	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}
	
	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}
	
	function ft (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}
	
	Sha1.prototype._update = function (M) {
	  var W = this._w
	
	  var a = this._a | 0
	  var b = this._b | 0
	  var c = this._c | 0
	  var d = this._d | 0
	  var e = this._e | 0
	
	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
	  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])
	
	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20)
	    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0
	
	    e = d
	    d = c
	    c = rotl30(b)
	    b = a
	    a = t
	  }
	
	  this._a = (a + this._a) | 0
	  this._b = (b + this._b) | 0
	  this._c = (c + this._c) | 0
	  this._d = (d + this._d) | 0
	  this._e = (e + this._e) | 0
	}
	
	Sha1.prototype._hash = function () {
	  var H = new Buffer(20)
	
	  H.writeInt32BE(this._a | 0, 0)
	  H.writeInt32BE(this._b | 0, 4)
	  H.writeInt32BE(this._c | 0, 8)
	  H.writeInt32BE(this._d | 0, 12)
	  H.writeInt32BE(this._e | 0, 16)
	
	  return H
	}
	
	module.e = Sha1
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(27)
	var Sha256 = __webpack_require__(618)
	var Hash = __webpack_require__(156)
	
	var W = new Array(64)
	
	function Sha224 () {
	  this.init()
	
	  this._w = W // new Array(64)
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha224, Sha256)
	
	Sha224.prototype.init = function () {
	  this._a = 0xc1059ed8
	  this._b = 0x367cd507
	  this._c = 0x3070dd17
	  this._d = 0xf70e5939
	  this._e = 0xffc00b31
	  this._f = 0x68581511
	  this._g = 0x64f98fa7
	  this._h = 0xbefa4fa4
	
	  return this
	}
	
	Sha224.prototype._hash = function () {
	  var H = new Buffer(28)
	
	  H.writeInt32BE(this._a, 0)
	  H.writeInt32BE(this._b, 4)
	  H.writeInt32BE(this._c, 8)
	  H.writeInt32BE(this._d, 12)
	  H.writeInt32BE(this._e, 16)
	  H.writeInt32BE(this._f, 20)
	  H.writeInt32BE(this._g, 24)
	
	  return H
	}
	
	module.e = Sha224
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var inherits = __webpack_require__(27)
	var SHA512 = __webpack_require__(619)
	var Hash = __webpack_require__(156)
	
	var W = new Array(160)
	
	function Sha384 () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 128, 112)
	}
	
	inherits(Sha384, SHA512)
	
	Sha384.prototype.init = function () {
	  this._ah = 0xcbbb9d5d
	  this._bh = 0x629a292a
	  this._ch = 0x9159015a
	  this._dh = 0x152fecd8
	  this._eh = 0x67332667
	  this._fh = 0x8eb44a87
	  this._gh = 0xdb0c2e0d
	  this._hh = 0x47b5481d
	
	  this._al = 0xc1059ed8
	  this._bl = 0x367cd507
	  this._cl = 0x3070dd17
	  this._dl = 0xf70e5939
	  this._el = 0xffc00b31
	  this._fl = 0x68581511
	  this._gl = 0x64f98fa7
	  this._hl = 0xbefa4fa4
	
	  return this
	}
	
	Sha384.prototype._hash = function () {
	  var H = new Buffer(48)
	
	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset)
	    H.writeInt32BE(l, offset + 4)
	  }
	
	  writeInt64BE(this._ah, this._al, 0)
	  writeInt64BE(this._bh, this._bl, 8)
	  writeInt64BE(this._ch, this._cl, 16)
	  writeInt64BE(this._dh, this._dl, 24)
	  writeInt64BE(this._eh, this._el, 32)
	  writeInt64BE(this._fh, this._fl, 40)
	
	  return H
	}
	
	module.e = Sha384
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ },
/* 1719 */
1309,
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(137)
	


/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(620)
	


/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var Stream = (function (){
	  try {
	    return __webpack_require__(157); // hack to fix a circular dependency issue when used with browserify
	  } catch(_){}
	}());
	exports = module.e = __webpack_require__(621);
	exports.Stream = Stream || exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(341);
	exports.Duplex = __webpack_require__(137);
	exports.Transform = __webpack_require__(340);
	exports.PassThrough = __webpack_require__(620);
	
	if (!process.browser && {"NODE_ENV":"production"}.READABLE_STREAM === 'disable' && Stream) {
	  module.e = Stream;
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(340)
	


/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = __webpack_require__(341)
	


/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	module.e = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};
	


/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(1310);
	var reduce = __webpack_require__(1712);
	var requestBase = __webpack_require__(1727);
	var isObject = __webpack_require__(622);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.e = __webpack_require__(1728).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};
	
	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	


/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(622);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};
	


/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.e = request;
	


/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	var toSpace = __webpack_require__(1731);
	
	
	/**
	 * Expose `toCamelCase`.
	 */
	
	module.e = toCamelCase;
	
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	
	function toCamelCase (string) {
	  return toSpace(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase();
	  });
	}


/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	/**
	 * Expose `toNoCase`.
	 */
	
	module.e = toNoCase;
	
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/;
	var hasCamel = /[a-z][A-Z]/;
	var hasSeparator = /[\W_]/;
	
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase (string) {
	  if (hasSpace.test(string)) return string.toLowerCase();
	
	  if (hasSeparator.test(string)) string = unseparate(string);
	  if (hasCamel.test(string)) string = uncamelize(string);
	  return string.toLowerCase();
	}
	
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g;
	
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate (string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : '';
	  });
	}
	
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g;
	
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize (string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ');
	  });
	}


/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	var clean = __webpack_require__(1730);
	
	
	/**
	 * Expose `toSpaceCase`.
	 */
	
	module.e = toSpaceCase;
	
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	
	function toSpaceCase (string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : '';
	  });
	}


/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var location = global.location || {};
	/*jslint indent: 2, browser: true, bitwise: true, plusplus: true */
	var twemoji = (function (
	  /*! Copyright Twitter Inc. and other contributors. Licensed under MIT *//*
	    https://github.com/twitter/twemoji/blob/gh-pages/LICENSE
	  */
	
	  // WARNING:   this file is generated automatically via
	  //            `node twemoji-generator.js`
	  //            please update its `createTwemoji` function
	  //            at the bottom of the same file instead.
	
	) {
	  'use strict';
	
	  /*jshint maxparams:4 */
	
	  var
	    // the exported module object
	    twemoji = {
	
	
	    /////////////////////////
	    //      properties     //
	    /////////////////////////
	
	      // default assets url, by default will be Twitter Inc. CDN
	      base: 'https://twemoji.maxcdn.com/2/',
	
	      // default assets file extensions, by default '.png'
	      ext: '.png',
	
	      // default assets/folder size, by default "72x72"
	      // available via Twitter CDN: 72
	      size: '72x72',
	
	      // default class name, by default 'emoji'
	      className: 'emoji',
	
	      // basic utilities / helpers to convert code points
	      // to JavaScript surrogates and vice versa
	      convert: {
	
	        /**
	         * Given an HEX codepoint, returns UTF16 surrogate pairs.
	         *
	         * @param   string  generic codepoint, i.e. '1F4A9'
	         * @return  string  codepoint transformed into utf16 surrogates pair,
	         *          i.e. \uD83D\uDCA9
	         *
	         * @example
	         *  twemoji.convert.fromCodePoint('1f1e8');
	         *  // "\ud83c\udde8"
	         *
	         *  '1f1e8-1f1f3'.split('-').map(twemoji.convert.fromCodePoint).join('')
	         *  // "\ud83c\udde8\ud83c\uddf3"
	         */
	        fromCodePoint: fromCodePoint,
	
	        /**
	         * Given UTF16 surrogate pairs, returns the equivalent HEX codepoint.
	         *
	         * @param   string  generic utf16 surrogates pair, i.e. \uD83D\uDCA9
	         * @param   string  optional separator for double code points, default='-'
	         * @return  string  utf16 transformed into codepoint, i.e. '1F4A9'
	         *
	         * @example
	         *  twemoji.convert.toCodePoint('\ud83c\udde8\ud83c\uddf3');
	         *  // "1f1e8-1f1f3"
	         *
	         *  twemoji.convert.toCodePoint('\ud83c\udde8\ud83c\uddf3', '~');
	         *  // "1f1e8~1f1f3"
	         */
	        toCodePoint: toCodePoint
	      },
	
	
	    /////////////////////////
	    //       methods       //
	    /////////////////////////
	
	      /**
	       * User first: used to remove missing images
	       * preserving the original text intent when
	       * a fallback for network problems is desired.
	       * Automatically added to Image nodes via DOM
	       * It could be recycled for string operations via:
	       *  $('img.emoji').on('error', twemoji.onerror)
	       */
	      onerror: function onerror() {
	        if (this.parentNode) {
	          this.parentNode.replaceChild(createText(this.alt), this);
	        }
	      },
	
	      /**
	       * Main method/logic to generate either <img> tags or HTMLImage nodes.
	       *  "emojify" a generic text or DOM Element.
	       *
	       * @overloads
	       *
	       * String replacement for `innerHTML` or server side operations
	       *  twemoji.parse(string);
	       *  twemoji.parse(string, Function);
	       *  twemoji.parse(string, Object);
	       *
	       * HTMLElement tree parsing for safer operations over existing DOM
	       *  twemoji.parse(HTMLElement);
	       *  twemoji.parse(HTMLElement, Function);
	       *  twemoji.parse(HTMLElement, Object);
	       *
	       * @param   string|HTMLElement  the source to parse and enrich with emoji.
	       *
	       *          string              replace emoji matches with <img> tags.
	       *                              Mainly used to inject emoji via `innerHTML`
	       *                              It does **not** parse the string or validate it,
	       *                              it simply replaces found emoji with a tag.
	       *                              NOTE: be sure this won't affect security.
	       *
	       *          HTMLElement         walk through the DOM tree and find emoji
	       *                              that are inside **text node only** (nodeType === 3)
	       *                              Mainly used to put emoji in already generated DOM
	       *                              without compromising surrounding nodes and
	       *                              **avoiding** the usage of `innerHTML`.
	       *                              NOTE: Using DOM elements instead of strings should
	       *                              improve security without compromising too much
	       *                              performance compared with a less safe `innerHTML`.
	       *
	       * @param   Function|Object  [optional]
	       *                              either the callback that will be invoked or an object
	       *                              with all properties to use per each found emoji.
	       *
	       *          Function            if specified, this will be invoked per each emoji
	       *                              that has been found through the RegExp except
	       *                              those follwed by the invariant \uFE0E ("as text").
	       *                              Once invoked, parameters will be:
	       *
	       *                                iconId:string     the lower case HEX code point
	       *                                                  i.e. "1f4a9"
	       *
	       *                                options:Object    all info for this parsing operation
	       *
	       *                                variant:char      the optional \uFE0F ("as image")
	       *                                                  variant, in case this info
	       *                                                  is anyhow meaningful.
	       *                                                  By default this is ignored.
	       *
	       *                              If such callback will return a falsy value instead
	       *                              of a valid `src` to use for the image, nothing will
	       *                              actually change for that specific emoji.
	       *
	       *
	       *          Object              if specified, an object containing the following properties
	       *
	       *            callback   Function  the callback to invoke per each found emoji.
	       *            base       string    the base url, by default twemoji.base
	       *            ext        string    the image extension, by default twemoji.ext
	       *            size       string    the assets size, by default twemoji.size
	       *
	       * @example
	       *
	       *  twemoji.parse("I \u2764\uFE0F emoji!");
	       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/2764.gif"> emoji!
	       *
	       *
	       *  twemoji.parse("I \u2764\uFE0F emoji!", function(iconId, options) {
	       *    return '/assets/' + iconId + '.gif';
	       *  });
	       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/2764.gif"> emoji!
	       *
	       *
	       * twemoji.parse("I \u2764\uFE0F emoji!", {
	       *   size: 72,
	       *   callback: function(iconId, options) {
	       *     return '/assets/' + options.size + '/' + iconId + options.ext;
	       *   }
	       * });
	       *  // I <img class="emoji" draggable="false" alt="❤️" src="/assets/72x72/2764.png"> emoji!
	       *
	       */
	      parse: parse,
	
	      /**
	       * Given a string, invokes the callback argument
	       *  per each emoji found in such string.
	       * This is the most raw version used by
	       *  the .parse(string) method itself.
	       *
	       * @param   string    generic string to parse
	       * @param   Function  a generic callback that will be
	       *                    invoked to replace the content.
	       *                    This calback wil receive standard
	       *                    String.prototype.replace(str, callback)
	       *                    arguments such:
	       *  callback(
	       *    rawText,  // the emoji match
	       *  );
	       *
	       *                    and others commonly received via replace.
	       */
	      replace: replace,
	
	      /**
	       * Simplify string tests against emoji.
	       *
	       * @param   string  some text that might contain emoji
	       * @return  boolean true if any emoji was found, false otherwise.
	       *
	       * @example
	       *
	       *  if (twemoji.test(someContent)) {
	       *    console.log("emoji All The Things!");
	       *  }
	       */
	      test: test
	    },
	
	    // used to escape HTML special chars in attributes
	    escaper = {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      "'": '&#39;',
	      '"': '&quot;'
	    },
	
	    // RegExp based on emoji's official Unicode standards
	    // http://www.unicode.org/Public/UNIDATA/EmojiSources.txt
	    re = /\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc41\u200d\ud83d\udde8|(?:[\u0023\u002a\u0030-\u0039])\ufe0f?\u20e3|(?:(?:[\u261d\u270c])(?:\ufe0f|(?!\ufe0e))|\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca\udfcb]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd75\udd90\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0]|\ud83e\udd18|[\u26f9\u270a\u270b\u270d])(?:\ud83c[\udffb-\udfff]|)|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf21\udf24-\udf84\udf86-\udf93\udf96\udf97\udf99-\udf9b\udf9e-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcc-\udff0\udff3-\udff5\udff7-\udfff]|\ud83d[\udc00-\udc41\udc44\udc45\udc51-\udc65\udc6a-\udc6d\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfd\udcff-\udd3d\udd49-\udd4e\udd50-\udd67\udd6f\udd70\udd73\udd74\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\udecb-\uded0\udee0-\udee5\udee9\udeeb\udeec\udef0\udef3]|\ud83e[\udd10-\udd17\udd80-\udd84\uddc0]|[\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa\u2602-\u2604\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638\u2692\u2694\u2696\u2697\u2699\u269b\u269c\u26b0\u26b1\u26c8\u26ce\u26cf\u26d1\u26d3\u26e9\u26f0\u26f1\u26f4\u26f7\u26f8\u2705\u271d\u2721\u2728\u274c\u274e\u2753-\u2755\u2763\u2795-\u2797\u27b0\u27bf\ue50a]|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37]|[\u00a9\u00ae\u203c\u2049\u2122\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600\u2601\u260e\u2611\u2614\u2615\u2639\u263a\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2693\u26a0\u26a1\u26aa\u26ab\u26bd\u26be\u26c4\u26c5\u26d4\u26ea\u26f2\u26f3\u26f5\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u2733\u2734\u2744\u2747\u2757\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))/g,
	
	    // avoid runtime RegExp creation for not so smart,
	    // not JIT based, and old browsers / engines
	    UFE0Fg = /\uFE0F/g,
	
	    // avoid using a string literal like '\u200D' here because minifiers expand it inline
	    U200D = String.fromCharCode(0x200D),
	
	    // used to find HTML special chars in attributes
	    rescaper = /[&<>'"]/g,
	
	    // nodes with type 1 which should **not** be parsed (including lower case svg)
	    shouldntBeParsed = /IFRAME|NOFRAMES|NOSCRIPT|SCRIPT|SELECT|STYLE|TEXTAREA|[a-z]/,
	
	    // just a private shortcut
	    fromCharCode = String.fromCharCode;
	
	  return twemoji;
	
	
	  /////////////////////////
	  //  private functions  //
	  //     declaration     //
	  /////////////////////////
	
	  /**
	   * Shortcut to create text nodes
	   * @param   string  text used to create DOM text node
	   * @return  Node  a DOM node with that text
	   */
	  function createText(text) {
	    return document.createTextNode(text);
	  }
	
	  /**
	   * Utility function to escape html attribute text
	   * @param   string  text use in HTML attribute
	   * @return  string  text encoded to use in HTML attribute
	   */
	  function escapeHTML(s) {
	    return s.replace(rescaper, replacer);
	  }
	
	  /**
	   * Default callback used to generate emoji src
	   *  based on Twitter CDN
	   * @param   string    the emoji codepoint string
	   * @param   string    the default size to use, i.e. "36x36"
	   * @return  string    the image source to use
	   */
	  function defaultImageSrcGenerator(icon, options) {
	    return ''.concat(options.base, options.size, '/', icon, options.ext);
	  }
	
	  /**
	   * Given a generic DOM nodeType 1, walk through all children
	   * and store every nodeType 3 (#text) found in the tree.
	   * @param   Element a DOM Element with probably some text in it
	   * @param   Array the list of previously discovered text nodes
	   * @return  Array same list with new discovered nodes, if any
	   */
	  function grabAllTextNodes(node, allText) {
	    var
	      childNodes = node.childNodes,
	      length = childNodes.length,
	      subnode,
	      nodeType;
	    while (length--) {
	      subnode = childNodes[length];
	      nodeType = subnode.nodeType;
	      // parse emoji only in text nodes
	      if (nodeType === 3) {
	        // collect them to process emoji later
	        allText.push(subnode);
	      }
	      // ignore all nodes that are not type 1 or that
	      // should not be parsed as script, style, and others
	      else if (nodeType === 1 && !shouldntBeParsed.test(subnode.nodeName)) {
	        grabAllTextNodes(subnode, allText);
	      }
	    }
	    return allText;
	  }
	
	  /**
	   * Used to both remove the possible variant
	   *  and to convert utf16 into code points.
	   *  If there is a zero-width-joiner (U+200D), leave the variants in.
	   * @param   string    the raw text of the emoji match
	   */
	  function grabTheRightIcon(rawText) {
	    // if variant is present as \uFE0F
	    return toCodePoint(rawText.indexOf(U200D) < 0 ?
	      rawText.replace(UFE0Fg, '') :
	      rawText
	    );
	  }
	
	  /**
	   * DOM version of the same logic / parser:
	   *  emojify all found sub-text nodes placing images node instead.
	   * @param   Element   generic DOM node with some text in some child node
	   * @param   Object    options  containing info about how to parse
	    *
	    *            .callback   Function  the callback to invoke per each found emoji.
	    *            .base       string    the base url, by default twemoji.base
	    *            .ext        string    the image extension, by default twemoji.ext
	    *            .size       string    the assets size, by default twemoji.size
	    *
	   * @return  Element same generic node with emoji in place, if any.
	   */
	  function parseNode(node, options) {
	    var
	      allText = grabAllTextNodes(node, []),
	      length = allText.length,
	      attrib,
	      attrname,
	      modified,
	      fragment,
	      subnode,
	      text,
	      match,
	      i,
	      index,
	      img,
	      rawText,
	      iconId,
	      src;
	    while (length--) {
	      modified = false;
	      fragment = document.createDocumentFragment();
	      subnode = allText[length];
	      text = subnode.nodeValue;
	      i = 0;
	      while ((match = re.exec(text))) {
	        index = match.index;
	        if (index !== i) {
	          fragment.appendChild(
	            createText(text.slice(i, index))
	          );
	        }
	        rawText = match[0];
	        iconId = grabTheRightIcon(rawText);
	        i = index + rawText.length;
	        src = options.callback(iconId, options);
	        if (src) {
	          img = new Image();
	          img.onerror = options.onerror;
	          img.setAttribute('draggable', 'false');
	          attrib = options.attributes(rawText, iconId);
	          for (attrname in attrib) {
	            if (
	              attrib.hasOwnProperty(attrname) &&
	              // don't allow any handlers to be set + don't allow overrides
	              attrname.indexOf('on') !== 0 &&
	              !img.hasAttribute(attrname)
	            ) {
	              img.setAttribute(attrname, attrib[attrname]);
	            }
	          }
	          img.className = options.className;
	          img.alt = rawText;
	          img.src = src;
	          modified = true;
	          fragment.appendChild(img);
	        }
	        if (!img) fragment.appendChild(createText(rawText));
	        img = null;
	      }
	      // is there actually anything to replace in here ?
	      if (modified) {
	        // any text left to be added ?
	        if (i < text.length) {
	          fragment.appendChild(
	            createText(text.slice(i))
	          );
	        }
	        // replace the text node only, leave intact
	        // anything else surrounding such text
	        subnode.parentNode.replaceChild(fragment, subnode);
	      }
	    }
	    return node;
	  }
	
	  /**
	   * String/HTML version of the same logic / parser:
	   *  emojify a generic text placing images tags instead of surrogates pair.
	   * @param   string    generic string with possibly some emoji in it
	   * @param   Object    options  containing info about how to parse
	   *
	   *            .callback   Function  the callback to invoke per each found emoji.
	   *            .base       string    the base url, by default twemoji.base
	   *            .ext        string    the image extension, by default twemoji.ext
	   *            .size       string    the assets size, by default twemoji.size
	   *
	   * @return  the string with <img tags> replacing all found and parsed emoji
	   */
	  function parseString(str, options) {
	    return replace(str, function (rawText) {
	      var
	        ret = rawText,
	        iconId = grabTheRightIcon(rawText),
	        src = options.callback(iconId, options),
	        attrib,
	        attrname;
	      if (src) {
	        // recycle the match string replacing the emoji
	        // with its image counter part
	        ret = '<img '.concat(
	          'class="', options.className, '" ',
	          'draggable="false" ',
	          // needs to preserve user original intent
	          // when variants should be copied and pasted too
	          'alt="',
	          rawText,
	          '"',
	          ' src="',
	          src,
	          '"'
	        );
	        attrib = options.attributes(rawText, iconId);
	        for (attrname in attrib) {
	          if (
	            attrib.hasOwnProperty(attrname) &&
	            // don't allow any handlers to be set + don't allow overrides
	            attrname.indexOf('on') !== 0 &&
	            ret.indexOf(' ' + attrname + '=') === -1
	          ) {
	            ret = ret.concat(' ', attrname, '="', escapeHTML(attrib[attrname]), '"');
	          }
	        }
	        ret = ret.concat('>');
	      }
	      return ret;
	    });
	  }
	
	  /**
	   * Function used to actually replace HTML special chars
	   * @param   string  HTML special char
	   * @return  string  encoded HTML special char
	   */
	  function replacer(m) {
	    return escaper[m];
	  }
	
	  /**
	   * Default options.attribute callback
	   * @return  null
	   */
	  function returnNull() {
	    return null;
	  }
	
	  /**
	   * Given a generic value, creates its squared counterpart if it's a number.
	   *  As example, number 36 will return '36x36'.
	   * @param   any     a generic value.
	   * @return  any     a string representing asset size, i.e. "36x36"
	   *                  only in case the value was a number.
	   *                  Returns initial value otherwise.
	   */
	  function toSizeSquaredAsset(value) {
	    return typeof value === 'number' ?
	      value + 'x' + value :
	      value;
	  }
	
	
	  /////////////////////////
	  //  exported functions //
	  //     declaration     //
	  /////////////////////////
	
	  function fromCodePoint(codepoint) {
	    var code = typeof codepoint === 'string' ?
	          parseInt(codepoint, 16) : codepoint;
	    if (code < 0x10000) {
	      return fromCharCode(code);
	    }
	    code -= 0x10000;
	    return fromCharCode(
	      0xD800 + (code >> 10),
	      0xDC00 + (code & 0x3FF)
	    );
	  }
	
	  function parse(what, how) {
	    if (!how || typeof how === 'function') {
	      how = {callback: how};
	    }
	    // if first argument is string, inject html <img> tags
	    // otherwise use the DOM tree and parse text nodes only
	    return (typeof what === 'string' ? parseString : parseNode)(what, {
	      callback:   how.callback || defaultImageSrcGenerator,
	      attributes: typeof how.attributes === 'function' ? how.attributes : returnNull,
	      base:       typeof how.base === 'string' ? how.base : twemoji.base,
	      ext:        how.ext || twemoji.ext,
	      size:       how.folder || toSizeSquaredAsset(how.size || twemoji.size),
	      className:  how.className || twemoji.className,
	      onerror:    how.onerror || twemoji.onerror
	    });
	  }
	
	  function replace(text, callback) {
	    return String(text).replace(re, callback);
	  }
	
	  function test(text) {
	    // IE6 needs a reset before too
	    re.lastIndex = 0;
	    var result = re.test(text);
	    re.lastIndex = 0;
	    return result;
	  }
	
	  function toCodePoint(unicodeSurrogates, sep) {
	    var
	      r = [],
	      c = 0,
	      p = 0,
	      i = 0;
	    while (i < unicodeSurrogates.length) {
	      c = unicodeSurrogates.charCodeAt(i++);
	      if (p) {
	        r.push((0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00)).toString(16));
	        p = 0;
	      } else if (0xD800 <= c && c <= 0xDBFF) {
	        p = c;
	      } else {
	        r.push(c.toString(16));
	      }
	    }
	    return r.join(sep || '-');
	  }
	
	}());
	if (!location.protocol) {
	  twemoji.base = twemoji.base.replace(/^http:/, "");
	}
	module.e = twemoji;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1734);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        propTypes;
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'becasue they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        this._values = utils.transform(keys, function (values, key) {
	          values[key] = props[utils.defaultKey(key)];
	        }, {});
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        var props = this.props,
	            keys = Object.keys(controlledValues);
	
	        keys.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      render: function render() {
	        var _this2 = this;
	
	        var newProps = {};
	        var _props = this.props;
	        var valueLink = _props.valueLink;
	        var checkedLink = _props.checkedLink;
	
	        var props = _objectWithoutProperties(_props, ['valueLink', 'checkedLink']);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this2.props[propName];
	
	          if (linkPropName && !isProp(_this2.props, propName) && isProp(_this2.props, linkPropName)) {
	            prop = _this2.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this2._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this2, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	  }
	}
	module.e = exports['default'];


/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.customPropType = customPropType;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.isReactComponent = isReactComponent;
	exports.has = has;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(52);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function customPropType(handler, propType, name) {
	
	  return function (props, propName) {
	
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	
	      return propType && propType(props, propName, name);
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      var type = basePropTypes[prop];
	
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = customPropType(handler, type, displayName);
	
	      if (type !== undefined) obj[defaultKey(prop)] = type;
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}


/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	
	/**
	 * Module exports.
	 */
	
	module.e = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var indexOf = __webpack_require__(1468);
	
	var Object_keys = function (obj) {
	    if (Object.keys) return Object.keys(obj)
	    else {
	        var res = [];
	        for (var key in obj) res.push(key)
	        return res;
	    }
	};
	
	var forEach = function (xs, fn) {
	    if (xs.forEach) return xs.forEach(fn)
	    else for (var i = 0; i < xs.length; i++) {
	        fn(xs[i], i, xs);
	    }
	};
	
	var defineProp = (function() {
	    try {
	        Object.defineProperty({}, '_', {});
	        return function(obj, name, value) {
	            Object.defineProperty(obj, name, {
	                writable: true,
	                enumerable: false,
	                configurable: true,
	                value: value
	            })
	        };
	    } catch(e) {
	        return function(obj, name, value) {
	            obj[name] = value;
	        };
	    }
	}());
	
	var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
	'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
	'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
	'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
	'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];
	
	function Context() {}
	Context.prototype = {};
	
	var Script = exports.Script = function NodeScript (code) {
	    if (!(this instanceof Script)) return new Script(code);
	    this.code = code;
	};
	
	Script.prototype.runInContext = function (context) {
	    if (!(context instanceof Context)) {
	        throw new TypeError("needs a 'context' argument.");
	    }
	    
	    var iframe = document.createElement('iframe');
	    if (!iframe.style) iframe.style = {};
	    iframe.style.display = 'none';
	    
	    document.body.appendChild(iframe);
	    
	    var win = iframe.contentWindow;
	    var wEval = win.eval, wExecScript = win.execScript;
	
	    if (!wEval && wExecScript) {
	        // win.eval() magically appears when this is called in IE:
	        wExecScript.call(win, 'null');
	        wEval = win.eval;
	    }
	    
	    forEach(Object_keys(context), function (key) {
	        win[key] = context[key];
	    });
	    forEach(globals, function (key) {
	        if (context[key]) {
	            win[key] = context[key];
	        }
	    });
	    
	    var winKeys = Object_keys(win);
	
	    var res = wEval.call(win, this.code);
	    
	    forEach(Object_keys(win), function (key) {
	        // Avoid copying circular objects like `top` and `window` by only
	        // updating existing context properties or new properties in the `win`
	        // that was only introduced after the eval.
	        if (key in context || indexOf(winKeys, key) === -1) {
	            context[key] = win[key];
	        }
	    });
	
	    forEach(globals, function (key) {
	        if (!(key in context)) {
	            defineProp(context, key, win[key]);
	        }
	    });
	    
	    document.body.removeChild(iframe);
	    
	    return res;
	};
	
	Script.prototype.runInThisContext = function () {
	    return eval(this.code); // maybe...
	};
	
	Script.prototype.runInNewContext = function (context) {
	    var ctx = Script.createContext(context);
	    var res = this.runInContext(ctx);
	
	    forEach(Object_keys(ctx), function (key) {
	        context[key] = ctx[key];
	    });
	
	    return res;
	};
	
	forEach(Object_keys(Script.prototype), function (name) {
	    exports[name] = Script[name] = function (code) {
	        var s = Script(code);
	        return s[name].apply(s, [].slice.call(arguments, 1));
	    };
	});
	
	exports.createScript = function (code) {
	    return exports.Script(code);
	};
	
	exports.createContext = Script.createContext = function (context) {
	    var copy = new Context();
	    if(typeof context === 'object') {
	        forEach(Object_keys(context), function (key) {
	            copy[key] = context[key];
	        });
	    }
	    return copy;
	};
	


/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			Object.defineProperty(module, "exports", {
				enumerable: true,
				configurable: false,
				get: function() { return module.e; },
				set: function(v) { return module.e = v; }
			});
			Object.defineProperty(module, "loaded", {
				enumerable: true,
				configurable: false,
				get: function() { return module.l; }
			});
			Object.defineProperty(module, "id", {
				enumerable: true,
				configurable: false,
				get: function() { return module.i; }
			});
			module.webpackPolyfill = 1;
		}
		return module;
	}
	


/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	// 1.0.3
	/*
	The MIT License (MIT)
	
	Copyright (c) 2015 Jan Martin
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	*/
	(function ($) {
	
	    $.fn.dragster = function (options) {
	        var settings = $.extend({
	            enter: $.noop,
	            leave: $.noop,
	            over: $.noop,
	            drop: $.noop
	        }, options);
	
	        return this.each(function () {
	            var first = false,
	                second = false,
	                $this = $(this);
	
	            $this.on({
	                dragenter: function (event) {
	                    if (first) {
	                        second = true;
	                        return;
	                    } else {
	                        first = true;
	                        $this.trigger('dragster:enter', event);
	                    }
	                    event.preventDefault();
	                },
	                dragleave: function (event) {
	                    if (second) {
	                        second = false;
	                    } else if (first) {
	                        first = false;
	                    }
	                    if (!first && !second) {
	                        $this.trigger('dragster:leave', event);
	                    }
	                    event.preventDefault();
	                },
	                dragover: function (event) {
	                    $this.trigger('dragster:over', event);
	                    event.preventDefault();
	                },
	                drop: function (event) {
	                    if (second) {
	                        second = false;
	                    } else if (first) {
	                        first = false;
	                    }
	                    if (!first && !second) {
	                        $this.trigger('dragster:drop', event);
	                    }
	                    event.preventDefault();
	                },
	                'dragster:enter': settings.enter,
	                'dragster:leave': settings.leave,
	                'dragster:over': settings.over,
	                'dragster:drop': settings.drop
	            });
	        });
	    };
	
	}(jQuery));
	


/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint no-console:0 */
	/**
	 * This is the main entry point for KaTeX. Here, we expose functions for
	 * rendering expressions either to DOM nodes or to markup strings.
	 *
	 * We also expose the ParseError class to check if errors thrown from KaTeX are
	 * errors in the expression, or errors in javascript handling.
	 */
	
	var ParseError = __webpack_require__(112);
	var Settings = __webpack_require__(624);
	
	var buildTree = __webpack_require__(1745);
	var parseTree = __webpack_require__(1751);
	var utils = __webpack_require__(97);
	
	/**
	 * Parse and build an expression, and place that expression in the DOM node
	 * given.
	 */
	var render = function(expression, baseNode, options) {
	    utils.clearNode(baseNode);
	
	    var settings = new Settings(options);
	
	    var tree = parseTree(expression, settings);
	    var node = buildTree(tree, expression, settings).toNode();
	
	    baseNode.appendChild(node);
	};
	
	// KaTeX's styles don't work properly in quirks mode. Print out an error, and
	// disable rendering.
	if (typeof document !== "undefined") {
	    if (document.compatMode !== "CSS1Compat") {
	        typeof console !== "undefined" && console.warn(
	            "Warning: KaTeX doesn't work in quirks mode. Make sure your " +
	                "website has a suitable doctype.");
	
	        render = function() {
	            throw new ParseError("KaTeX doesn't work in quirks mode.");
	        };
	    }
	}
	
	/**
	 * Parse and build an expression, and return the markup for that.
	 */
	var renderToString = function(expression, options) {
	    var settings = new Settings(options);
	
	    var tree = parseTree(expression, settings);
	    return buildTree(tree, expression, settings).toMarkup();
	};
	
	/**
	 * Parse an expression and return the parse tree.
	 */
	var generateParseTree = function(expression, options) {
	    var settings = new Settings(options);
	    return parseTree(expression, settings);
	};
	
	module.e = {
	    render: render,
	    renderToString: renderToString,
	    /**
	     * NOTE: This method is not currently recommended for public use.
	     * The internal tree representation is unstable and is very likely
	     * to change. Use at your own risk.
	     */
	    __parse: generateParseTree,
	    ParseError: ParseError,
	};
	


/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * The Lexer class handles tokenizing the input in various ways. Since our
	 * parser expects us to be able to backtrack, the lexer allows lexing from any
	 * given starting point.
	 *
	 * Its main exposed function is the `lex` function, which takes a position to
	 * lex from and a type of token to lex. It defers to the appropriate `_innerLex`
	 * function.
	 *
	 * The various `_innerLex` functions perform the actual lexing of different
	 * kinds.
	 */
	
	var matchAt = __webpack_require__(1525);
	
	var ParseError = __webpack_require__(112);
	
	// The main lexer class
	function Lexer(input) {
	    this._input = input;
	}
	
	// The resulting token returned from `lex`.
	function Token(text, data, position) {
	    this.text = text;
	    this.data = data;
	    this.position = position;
	}
	
	/* The following tokenRegex
	 * - matches typical whitespace (but not NBSP etc.) using its first group
	 * - matches symbol combinations which result in a single output character
	 * - does not match any control character \x00-\x1f except whitespace
	 * - does not match a bare backslash
	 * - matches any ASCII character except those just mentioned
	 * - does not match the BMP private use area \uE000-\uF8FF
	 * - does not match bare surrogate code units
	 * - matches any BMP character except for those just described
	 * - matches any valid Unicode surrogate pair
	 * - matches a backslash followed by one or more letters
	 * - matches a backslash followed by any BMP character, including newline
	 * Just because the Lexer matches something doesn't mean it's valid input:
	 * If there is no matching function or symbol definition, the Parser will
	 * still reject the input.
	 */
	var tokenRegex = new RegExp(
	    "([ \r\n\t]+)|(" +                                // whitespace
	    "---?" +                                          // special combinations
	    "|[!-\\[\\]-\u2027\u202A-\uD7FF\uF900-\uFFFF]" +  // single codepoint
	    "|[\uD800-\uDBFF][\uDC00-\uDFFF]" +               // surrogate pair
	    "|\\\\(?:[a-zA-Z]+|[^\uD800-\uDFFF])" +           // function name
	    ")"
	);
	
	var whitespaceRegex = /\s*/;
	
	/**
	 * This function lexes a single normal token. It takes a position and
	 * whether it should completely ignore whitespace or not.
	 */
	Lexer.prototype._innerLex = function(pos, ignoreWhitespace) {
	    var input = this._input;
	    if (pos === input.length) {
	        return new Token("EOF", null, pos);
	    }
	    var match = matchAt(tokenRegex, input, pos);
	    if (match === null) {
	        throw new ParseError(
	            "Unexpected character: '" + input[pos] + "'",
	            this, pos);
	    } else if (match[2]) { // matched non-whitespace
	        return new Token(match[2], null, pos + match[2].length);
	    } else if (ignoreWhitespace) {
	        return this._innerLex(pos + match[1].length, true);
	    } else { // concatenate whitespace to a single space
	        return new Token(" ", null, pos + match[1].length);
	    }
	};
	
	// A regex to match a CSS color (like #ffffff or BlueViolet)
	var cssColor = /#[a-z0-9]+|[a-z]+/i;
	
	/**
	 * This function lexes a CSS color.
	 */
	Lexer.prototype._innerLexColor = function(pos) {
	    var input = this._input;
	
	    // Ignore whitespace
	    var whitespace = matchAt(whitespaceRegex, input, pos)[0];
	    pos += whitespace.length;
	
	    var match;
	    if ((match = matchAt(cssColor, input, pos))) {
	        // If we look like a color, return a color
	        return new Token(match[0], null, pos + match[0].length);
	    } else {
	        throw new ParseError("Invalid color", this, pos);
	    }
	};
	
	// A regex to match a dimension. Dimensions look like
	// "1.2em" or ".4pt" or "1 ex"
	var sizeRegex = /(-?)\s*(\d+(?:\.\d*)?|\.\d+)\s*([a-z]{2})/;
	
	/**
	 * This function lexes a dimension.
	 */
	Lexer.prototype._innerLexSize = function(pos) {
	    var input = this._input;
	
	    // Ignore whitespace
	    var whitespace = matchAt(whitespaceRegex, input, pos)[0];
	    pos += whitespace.length;
	
	    var match;
	    if ((match = matchAt(sizeRegex, input, pos))) {
	        var unit = match[3];
	        // We only currently handle "em" and "ex" units
	        if (unit !== "em" && unit !== "ex") {
	            throw new ParseError("Invalid unit: '" + unit + "'", this, pos);
	        }
	        return new Token(match[0], {
	            number: +(match[1] + match[2]),
	            unit: unit,
	        }, pos + match[0].length);
	    }
	
	    throw new ParseError("Invalid size", this, pos);
	};
	
	/**
	 * This function lexes a string of whitespace.
	 */
	Lexer.prototype._innerLexWhitespace = function(pos) {
	    var input = this._input;
	
	    var whitespace = matchAt(whitespaceRegex, input, pos)[0];
	    pos += whitespace.length;
	
	    return new Token(whitespace[0], null, pos);
	};
	
	/**
	 * This function lexes a single token starting at `pos` and of the given mode.
	 * Based on the mode, we defer to one of the `_innerLex` functions.
	 */
	Lexer.prototype.lex = function(pos, mode) {
	    if (mode === "math") {
	        return this._innerLex(pos, true);
	    } else if (mode === "text") {
	        return this._innerLex(pos, false);
	    } else if (mode === "color") {
	        return this._innerLexColor(pos);
	    } else if (mode === "size") {
	        return this._innerLexSize(pos);
	    } else if (mode === "whitespace") {
	        return this._innerLexWhitespace(pos);
	    }
	};
	
	module.e = Lexer;
	


/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This file contains information about the options that the Parser carries
	 * around with it while parsing. Data is held in an `Options` object, and when
	 * recursing, a new `Options` object can be created with the `.with*` and
	 * `.reset` functions.
	 */
	
	/**
	 * This is the main options class. It contains the style, size, color, and font
	 * of the current parse level. It also contains the style and size of the parent
	 * parse level, so size changes can be handled efficiently.
	 *
	 * Each of the `.with*` and `.reset` functions passes its current style and size
	 * as the parentStyle and parentSize of the new options class, so parent
	 * handling is taken care of automatically.
	 */
	function Options(data) {
	    this.style = data.style;
	    this.color = data.color;
	    this.size = data.size;
	    this.phantom = data.phantom;
	    this.font = data.font;
	
	    if (data.parentStyle === undefined) {
	        this.parentStyle = data.style;
	    } else {
	        this.parentStyle = data.parentStyle;
	    }
	
	    if (data.parentSize === undefined) {
	        this.parentSize = data.size;
	    } else {
	        this.parentSize = data.parentSize;
	    }
	}
	
	/**
	 * Returns a new options object with the same properties as "this".  Properties
	 * from "extension" will be copied to the new options object.
	 */
	Options.prototype.extend = function(extension) {
	    var data = {
	        style: this.style,
	        size: this.size,
	        color: this.color,
	        parentStyle: this.style,
	        parentSize: this.size,
	        phantom: this.phantom,
	        font: this.font,
	    };
	
	    for (var key in extension) {
	        if (extension.hasOwnProperty(key)) {
	            data[key] = extension[key];
	        }
	    }
	
	    return new Options(data);
	};
	
	/**
	 * Create a new options object with the given style.
	 */
	Options.prototype.withStyle = function(style) {
	    return this.extend({
	        style: style,
	    });
	};
	
	/**
	 * Create a new options object with the given size.
	 */
	Options.prototype.withSize = function(size) {
	    return this.extend({
	        size: size,
	    });
	};
	
	/**
	 * Create a new options object with the given color.
	 */
	Options.prototype.withColor = function(color) {
	    return this.extend({
	        color: color,
	    });
	};
	
	/**
	 * Create a new options object with "phantom" set to true.
	 */
	Options.prototype.withPhantom = function() {
	    return this.extend({
	        phantom: true,
	    });
	};
	
	/**
	 * Create a new options objects with the give font.
	 */
	Options.prototype.withFont = function(font) {
	    return this.extend({
	        font: font,
	    });
	};
	
	/**
	 * Create a new options object with the same style, size, and color. This is
	 * used so that parent style and size changes are handled correctly.
	 */
	Options.prototype.reset = function() {
	    return this.extend({});
	};
	
	/**
	 * A map of color names to CSS colors.
	 * TODO(emily): Remove this when we have real macros
	 */
	var colorMap = {
	    "katex-blue": "#6495ed",
	    "katex-orange": "#ffa500",
	    "katex-pink": "#ff00af",
	    "katex-red": "#df0030",
	    "katex-green": "#28ae7b",
	    "katex-gray": "gray",
	    "katex-purple": "#9d38bd",
	    "katex-blueA": "#c7e9f1",
	    "katex-blueB": "#9cdceb",
	    "katex-blueC": "#58c4dd",
	    "katex-blueD": "#29abca",
	    "katex-blueE": "#1c758a",
	    "katex-tealA": "#acead7",
	    "katex-tealB": "#76ddc0",
	    "katex-tealC": "#5cd0b3",
	    "katex-tealD": "#55c1a7",
	    "katex-tealE": "#49a88f",
	    "katex-greenA": "#c9e2ae",
	    "katex-greenB": "#a6cf8c",
	    "katex-greenC": "#83c167",
	    "katex-greenD": "#77b05d",
	    "katex-greenE": "#699c52",
	    "katex-goldA": "#f7c797",
	    "katex-goldB": "#f9b775",
	    "katex-goldC": "#f0ac5f",
	    "katex-goldD": "#e1a158",
	    "katex-goldE": "#c78d46",
	    "katex-redA": "#f7a1a3",
	    "katex-redB": "#ff8080",
	    "katex-redC": "#fc6255",
	    "katex-redD": "#e65a4c",
	    "katex-redE": "#cf5044",
	    "katex-maroonA": "#ecabc1",
	    "katex-maroonB": "#ec92ab",
	    "katex-maroonC": "#c55f73",
	    "katex-maroonD": "#a24d61",
	    "katex-maroonE": "#94424f",
	    "katex-purpleA": "#caa3e8",
	    "katex-purpleB": "#b189c6",
	    "katex-purpleC": "#9a72ac",
	    "katex-purpleD": "#715582",
	    "katex-purpleE": "#644172",
	    "katex-mintA": "#f5f9e8",
	    "katex-mintB": "#edf2df",
	    "katex-mintC": "#e0e5cc",
	    "katex-grayA": "#fdfdfd",
	    "katex-grayB": "#f7f7f7",
	    "katex-grayC": "#eeeeee",
	    "katex-grayD": "#dddddd",
	    "katex-grayE": "#cccccc",
	    "katex-grayF": "#aaaaaa",
	    "katex-grayG": "#999999",
	    "katex-grayH": "#555555",
	    "katex-grayI": "#333333",
	    "katex-kaBlue": "#314453",
	    "katex-kaGreen": "#639b24",
	};
	
	/**
	 * Gets the CSS color of the current options object, accounting for the
	 * `colorMap`.
	 */
	Options.prototype.getColor = function() {
	    if (this.phantom) {
	        return "transparent";
	    } else {
	        return colorMap[this.color] || this.color;
	    }
	};
	
	module.e = Options;
	


/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint no-constant-condition:0 */
	var functions = __webpack_require__(1749);
	var environments = __webpack_require__(1747);
	var Lexer = __webpack_require__(1740);
	var symbols = __webpack_require__(241);
	var utils = __webpack_require__(97);
	
	var parseData = __webpack_require__(626);
	var ParseError = __webpack_require__(112);
	
	/**
	 * This file contains the parser used to parse out a TeX expression from the
	 * input. Since TeX isn't context-free, standard parsers don't work particularly
	 * well.
	 *
	 * The strategy of this parser is as such:
	 *
	 * The main functions (the `.parse...` ones) take a position in the current
	 * parse string to parse tokens from. The lexer (found in Lexer.js, stored at
	 * this.lexer) also supports pulling out tokens at arbitrary places. When
	 * individual tokens are needed at a position, the lexer is called to pull out a
	 * token, which is then used.
	 *
	 * The parser has a property called "mode" indicating the mode that
	 * the parser is currently in. Currently it has to be one of "math" or
	 * "text", which denotes whether the current environment is a math-y
	 * one or a text-y one (e.g. inside \text). Currently, this serves to
	 * limit the functions which can be used in text mode.
	 *
	 * The main functions then return an object which contains the useful data that
	 * was parsed at its given point, and a new position at the end of the parsed
	 * data. The main functions can call each other and continue the parsing by
	 * using the returned position as a new starting point.
	 *
	 * There are also extra `.handle...` functions, which pull out some reused
	 * functionality into self-contained functions.
	 *
	 * The earlier functions return ParseNodes.
	 * The later functions (which are called deeper in the parse) sometimes return
	 * ParseFuncOrArgument, which contain a ParseNode as well as some data about
	 * whether the parsed object is a function which is missing some arguments, or a
	 * standalone object which can be used as an argument to another function.
	 */
	
	/**
	 * Main Parser class
	 */
	function Parser(input, settings) {
	    // Make a new lexer
	    this.lexer = new Lexer(input);
	    // Store the settings for use in parsing
	    this.settings = settings;
	}
	
	var ParseNode = parseData.ParseNode;
	
	/**
	 * An initial function (without its arguments), or an argument to a function.
	 * The `result` argument should be a ParseNode.
	 */
	function ParseFuncOrArgument(result, isFunction) {
	    this.result = result;
	    // Is this a function (i.e. is it something defined in functions.js)?
	    this.isFunction = isFunction;
	}
	
	/**
	 * Checks a result to make sure it has the right type, and throws an
	 * appropriate error otherwise.
	 *
	 * @param {boolean=} consume whether to consume the expected token,
	 *                           defaults to true
	 */
	Parser.prototype.expect = function(text, consume) {
	    if (this.nextToken.text !== text) {
	        throw new ParseError(
	            "Expected '" + text + "', got '" + this.nextToken.text + "'",
	            this.lexer, this.nextToken.position
	        );
	    }
	    if (consume !== false) {
	        this.consume();
	    }
	};
	
	/**
	 * Considers the current look ahead token as consumed,
	 * and fetches the one after that as the new look ahead.
	 */
	Parser.prototype.consume = function() {
	    this.pos = this.nextToken.position;
	    this.nextToken = this.lexer.lex(this.pos, this.mode);
	};
	
	/**
	 * Main parsing function, which parses an entire input.
	 *
	 * @return {?Array.<ParseNode>}
	 */
	Parser.prototype.parse = function() {
	    // Try to parse the input
	    this.mode = "math";
	    this.pos = 0;
	    this.nextToken = this.lexer.lex(this.pos, this.mode);
	    var parse = this.parseInput();
	    return parse;
	};
	
	/**
	 * Parses an entire input tree.
	 */
	Parser.prototype.parseInput = function() {
	    // Parse an expression
	    var expression = this.parseExpression(false);
	    // If we succeeded, make sure there's an EOF at the end
	    this.expect("EOF", false);
	    return expression;
	};
	
	var endOfExpression = ["}", "\\end", "\\right", "&", "\\\\", "\\cr"];
	
	/**
	 * Parses an "expression", which is a list of atoms.
	 *
	 * @param {boolean} breakOnInfix Should the parsing stop when we hit infix
	 *                  nodes? This happens when functions have higher precendence
	 *                  than infix nodes in implicit parses.
	 *
	 * @param {?string} breakOnToken The token that the expression should end with,
	 *                  or `null` if something else should end the expression.
	 *
	 * @return {ParseNode}
	 */
	Parser.prototype.parseExpression = function(breakOnInfix, breakOnToken) {
	    var body = [];
	    // Keep adding atoms to the body until we can't parse any more atoms (either
	    // we reached the end, a }, or a \right)
	    while (true) {
	        var lex = this.nextToken;
	        var pos = this.pos;
	        if (endOfExpression.indexOf(lex.text) !== -1) {
	            break;
	        }
	        if (breakOnToken && lex.text === breakOnToken) {
	            break;
	        }
	        var atom = this.parseAtom();
	        if (!atom) {
	            if (!this.settings.throwOnError && lex.text[0] === "\\") {
	                var errorNode = this.handleUnsupportedCmd();
	                body.push(errorNode);
	
	                pos = lex.position;
	                continue;
	            }
	
	            break;
	        }
	        if (breakOnInfix && atom.type === "infix") {
	            // rewind so we can parse the infix atom again
	            this.pos = pos;
	            this.nextToken = lex;
	            break;
	        }
	        body.push(atom);
	    }
	    return this.handleInfixNodes(body);
	};
	
	/**
	 * Rewrites infix operators such as \over with corresponding commands such
	 * as \frac.
	 *
	 * There can only be one infix operator per group.  If there's more than one
	 * then the expression is ambiguous.  This can be resolved by adding {}.
	 *
	 * @returns {Array}
	 */
	Parser.prototype.handleInfixNodes = function(body) {
	    var overIndex = -1;
	    var funcName;
	
	    for (var i = 0; i < body.length; i++) {
	        var node = body[i];
	        if (node.type === "infix") {
	            if (overIndex !== -1) {
	                throw new ParseError("only one infix operator per group",
	                    this.lexer, -1);
	            }
	            overIndex = i;
	            funcName = node.value.replaceWith;
	        }
	    }
	
	    if (overIndex !== -1) {
	        var numerNode;
	        var denomNode;
	
	        var numerBody = body.slice(0, overIndex);
	        var denomBody = body.slice(overIndex + 1);
	
	        if (numerBody.length === 1 && numerBody[0].type === "ordgroup") {
	            numerNode = numerBody[0];
	        } else {
	            numerNode = new ParseNode("ordgroup", numerBody, this.mode);
	        }
	
	        if (denomBody.length === 1 && denomBody[0].type === "ordgroup") {
	            denomNode = denomBody[0];
	        } else {
	            denomNode = new ParseNode("ordgroup", denomBody, this.mode);
	        }
	
	        var value = this.callFunction(
	            funcName, [numerNode, denomNode], null);
	        return [new ParseNode(value.type, value, this.mode)];
	    } else {
	        return body;
	    }
	};
	
	// The greediness of a superscript or subscript
	var SUPSUB_GREEDINESS = 1;
	
	/**
	 * Handle a subscript or superscript with nice errors.
	 */
	Parser.prototype.handleSupSubscript = function(name) {
	    var symbol = this.nextToken.text;
	    var symPos = this.pos;
	    this.consume();
	    var group = this.parseGroup();
	
	    if (!group) {
	        if (!this.settings.throwOnError && this.nextToken.text[0] === "\\") {
	            return this.handleUnsupportedCmd();
	        } else {
	            throw new ParseError(
	                "Expected group after '" + symbol + "'",
	                this.lexer,
	                symPos + 1
	            );
	        }
	    } else if (group.isFunction) {
	        // ^ and _ have a greediness, so handle interactions with functions'
	        // greediness
	        var funcGreediness = functions[group.result].greediness;
	        if (funcGreediness > SUPSUB_GREEDINESS) {
	            return this.parseFunction(group);
	        } else {
	            throw new ParseError(
	                "Got function '" + group.result + "' with no arguments " +
	                    "as " + name,
	                this.lexer, symPos + 1);
	        }
	    } else {
	        return group.result;
	    }
	};
	
	/**
	 * Converts the textual input of an unsupported command into a text node
	 * contained within a color node whose color is determined by errorColor
	 */
	Parser.prototype.handleUnsupportedCmd = function() {
	    var text = this.nextToken.text;
	    var textordArray = [];
	
	    for (var i = 0; i < text.length; i++) {
	        textordArray.push(new ParseNode("textord", text[i], "text"));
	    }
	
	    var textNode = new ParseNode(
	        "text",
	        {
	            body: textordArray,
	            type: "text",
	        },
	        this.mode);
	
	    var colorNode = new ParseNode(
	        "color",
	        {
	            color: this.settings.errorColor,
	            value: [textNode],
	            type: "color",
	        },
	        this.mode);
	
	    this.consume();
	    return colorNode;
	};
	
	/**
	 * Parses a group with optional super/subscripts.
	 *
	 * @return {?ParseNode}
	 */
	Parser.prototype.parseAtom = function() {
	    // The body of an atom is an implicit group, so that things like
	    // \left(x\right)^2 work correctly.
	    var base = this.parseImplicitGroup();
	
	    // In text mode, we don't have superscripts or subscripts
	    if (this.mode === "text") {
	        return base;
	    }
	
	    // Note that base may be empty (i.e. null) at this point.
	
	    var superscript;
	    var subscript;
	    while (true) {
	        // Lex the first token
	        var lex = this.nextToken;
	
	        if (lex.text === "\\limits" || lex.text === "\\nolimits") {
	            // We got a limit control
	            if (!base || base.type !== "op") {
	                throw new ParseError(
	                    "Limit controls must follow a math operator",
	                    this.lexer, this.pos);
	            } else {
	                var limits = lex.text === "\\limits";
	                base.value.limits = limits;
	                base.value.alwaysHandleSupSub = true;
	            }
	            this.consume();
	        } else if (lex.text === "^") {
	            // We got a superscript start
	            if (superscript) {
	                throw new ParseError(
	                    "Double superscript", this.lexer, this.pos);
	            }
	            superscript = this.handleSupSubscript("superscript");
	        } else if (lex.text === "_") {
	            // We got a subscript start
	            if (subscript) {
	                throw new ParseError(
	                    "Double subscript", this.lexer, this.pos);
	            }
	            subscript = this.handleSupSubscript("subscript");
	        } else if (lex.text === "'") {
	            // We got a prime
	            var prime = new ParseNode("textord", "\\prime", this.mode);
	
	            // Many primes can be grouped together, so we handle this here
	            var primes = [prime];
	            this.consume();
	            // Keep lexing tokens until we get something that's not a prime
	            while (this.nextToken.text === "'") {
	                // For each one, add another prime to the list
	                primes.push(prime);
	                this.consume();
	            }
	            // Put them into an ordgroup as the superscript
	            superscript = new ParseNode("ordgroup", primes, this.mode);
	        } else {
	            // If it wasn't ^, _, or ', stop parsing super/subscripts
	            break;
	        }
	    }
	
	    if (superscript || subscript) {
	        // If we got either a superscript or subscript, create a supsub
	        return new ParseNode("supsub", {
	            base: base,
	            sup: superscript,
	            sub: subscript,
	        }, this.mode);
	    } else {
	        // Otherwise return the original body
	        return base;
	    }
	};
	
	// A list of the size-changing functions, for use in parseImplicitGroup
	var sizeFuncs = [
	    "\\tiny", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize",
	    "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge",
	];
	
	// A list of the style-changing functions, for use in parseImplicitGroup
	var styleFuncs = [
	    "\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle",
	];
	
	/**
	 * Parses an implicit group, which is a group that starts at the end of a
	 * specified, and ends right before a higher explicit group ends, or at EOL. It
	 * is used for functions that appear to affect the current style, like \Large or
	 * \textrm, where instead of keeping a style we just pretend that there is an
	 * implicit grouping after it until the end of the group. E.g.
	 *   small text {\Large large text} small text again
	 * It is also used for \left and \right to get the correct grouping.
	 *
	 * @return {?ParseNode}
	 */
	Parser.prototype.parseImplicitGroup = function() {
	    var start = this.parseSymbol();
	
	    if (start == null) {
	        // If we didn't get anything we handle, fall back to parseFunction
	        return this.parseFunction();
	    }
	
	    var func = start.result;
	    var body;
	
	    if (func === "\\left") {
	        // If we see a left:
	        // Parse the entire left function (including the delimiter)
	        var left = this.parseFunction(start);
	        // Parse out the implicit body
	        body = this.parseExpression(false);
	        // Check the next token
	        this.expect("\\right", false);
	        var right = this.parseFunction();
	        return new ParseNode("leftright", {
	            body: body,
	            left: left.value.value,
	            right: right.value.value,
	        }, this.mode);
	    } else if (func === "\\begin") {
	        // begin...end is similar to left...right
	        var begin = this.parseFunction(start);
	        var envName = begin.value.name;
	        if (!environments.hasOwnProperty(envName)) {
	            throw new ParseError(
	                "No such environment: " + envName,
	                this.lexer, begin.value.namepos);
	        }
	        // Build the environment object. Arguments and other information will
	        // be made available to the begin and end methods using properties.
	        var env = environments[envName];
	        var args = this.parseArguments("\\begin{" + envName + "}", env);
	        var context = {
	            mode: this.mode,
	            envName: envName,
	            parser: this,
	            lexer: this.lexer,
	            positions: args.pop(),
	        };
	        var result = env.handler(context, args);
	        this.expect("\\end", false);
	        var end = this.parseFunction();
	        if (end.value.name !== envName) {
	            throw new ParseError(
	                "Mismatch: \\begin{" + envName + "} matched " +
	                "by \\end{" + end.value.name + "}",
	                this.lexer /* , end.value.namepos */);
	            // TODO: Add position to the above line and adjust test case,
	            // requires #385 to get merged first
	        }
	        result.position = end.position;
	        return result;
	    } else if (utils.contains(sizeFuncs, func)) {
	        // If we see a sizing function, parse out the implict body
	        body = this.parseExpression(false);
	        return new ParseNode("sizing", {
	            // Figure out what size to use based on the list of functions above
	            size: "size" + (utils.indexOf(sizeFuncs, func) + 1),
	            value: body,
	        }, this.mode);
	    } else if (utils.contains(styleFuncs, func)) {
	        // If we see a styling function, parse out the implict body
	        body = this.parseExpression(true);
	        return new ParseNode("styling", {
	            // Figure out what style to use by pulling out the style from
	            // the function name
	            style: func.slice(1, func.length - 5),
	            value: body,
	        }, this.mode);
	    } else {
	        // Defer to parseFunction if it's not a function we handle
	        return this.parseFunction(start);
	    }
	};
	
	/**
	 * Parses an entire function, including its base and all of its arguments.
	 * The base might either have been parsed already, in which case
	 * it is provided as an argument, or it's the next group in the input.
	 *
	 * @param {ParseFuncOrArgument=} baseGroup optional as described above
	 * @return {?ParseNode}
	 */
	Parser.prototype.parseFunction = function(baseGroup) {
	    if (!baseGroup) {
	        baseGroup = this.parseGroup();
	    }
	
	    if (baseGroup) {
	        if (baseGroup.isFunction) {
	            var func = baseGroup.result;
	            var funcData = functions[func];
	            if (this.mode === "text" && !funcData.allowedInText) {
	                throw new ParseError(
	                    "Can't use function '" + func + "' in text mode",
	                    this.lexer, baseGroup.position);
	            }
	
	            var args = this.parseArguments(func, funcData);
	            var result = this.callFunction(func, args, args.pop());
	            return new ParseNode(result.type, result, this.mode);
	        } else {
	            return baseGroup.result;
	        }
	    } else {
	        return null;
	    }
	};
	
	/**
	 * Call a function handler with a suitable context and arguments.
	 */
	Parser.prototype.callFunction = function(name, args, positions) {
	    var context = {
	        funcName: name,
	        parser: this,
	        lexer: this.lexer,
	        positions: positions,
	    };
	    return functions[name].handler(context, args);
	};
	
	/**
	 * Parses the arguments of a function or environment
	 *
	 * @param {string} func  "\name" or "\begin{name}"
	 * @param {{numArgs:number,numOptionalArgs:number|undefined}} funcData
	 * @return the array of arguments, with the list of positions as last element
	 */
	Parser.prototype.parseArguments = function(func, funcData) {
	    var totalArgs = funcData.numArgs + funcData.numOptionalArgs;
	    if (totalArgs === 0) {
	        return [[this.pos]];
	    }
	
	    var baseGreediness = funcData.greediness;
	    var positions = [this.pos];
	    var args = [];
	
	    for (var i = 0; i < totalArgs; i++) {
	        var argType = funcData.argTypes && funcData.argTypes[i];
	        var arg;
	        if (i < funcData.numOptionalArgs) {
	            if (argType) {
	                arg = this.parseSpecialGroup(argType, true);
	            } else {
	                arg = this.parseOptionalGroup();
	            }
	            if (!arg) {
	                args.push(null);
	                positions.push(this.pos);
	                continue;
	            }
	        } else {
	            if (argType) {
	                arg = this.parseSpecialGroup(argType);
	            } else {
	                arg = this.parseGroup();
	            }
	            if (!arg) {
	                if (!this.settings.throwOnError &&
	                    this.nextToken.text[0] === "\\") {
	                    arg = new ParseFuncOrArgument(
	                        this.handleUnsupportedCmd(this.nextToken.text),
	                        false);
	                } else {
	                    throw new ParseError(
	                        "Expected group after '" + func + "'",
	                        this.lexer, this.pos);
	                }
	            }
	        }
	        var argNode;
	        if (arg.isFunction) {
	            var argGreediness =
	                functions[arg.result].greediness;
	            if (argGreediness > baseGreediness) {
	                argNode = this.parseFunction(arg);
	            } else {
	                throw new ParseError(
	                    "Got function '" + arg.result + "' as " +
	                    "argument to '" + func + "'",
	                    this.lexer, this.pos - 1);
	            }
	        } else {
	            argNode = arg.result;
	        }
	        args.push(argNode);
	        positions.push(this.pos);
	    }
	
	    args.push(positions);
	
	    return args;
	};
	
	
	/**
	 * Parses a group when the mode is changing. Takes a position, a new mode, and
	 * an outer mode that is used to parse the outside.
	 *
	 * @return {?ParseFuncOrArgument}
	 */
	Parser.prototype.parseSpecialGroup = function(innerMode, optional) {
	    var outerMode = this.mode;
	    // Handle `original` argTypes
	    if (innerMode === "original") {
	        innerMode = outerMode;
	    }
	
	    if (innerMode === "color" || innerMode === "size") {
	        // color and size modes are special because they should have braces and
	        // should only lex a single symbol inside
	        var openBrace = this.nextToken;
	        if (optional && openBrace.text !== "[") {
	            // optional arguments should return null if they don't exist
	            return null;
	        }
	        // The call to expect will lex the token after the '{' in inner mode
	        this.mode = innerMode;
	        this.expect(optional ? "[" : "{");
	        var inner = this.nextToken;
	        this.mode = outerMode;
	        var data;
	        if (innerMode === "color") {
	            data = inner.text;
	        } else {
	            data = inner.data;
	        }
	        this.consume(); // consume the token stored in inner
	        this.expect(optional ? "]" : "}");
	        return new ParseFuncOrArgument(
	            new ParseNode(innerMode, data, outerMode),
	            false);
	    } else if (innerMode === "text") {
	        // text mode is special because it should ignore the whitespace before
	        // it
	        var whitespace = this.lexer.lex(this.pos, "whitespace");
	        this.pos = whitespace.position;
	    }
	
	    // By the time we get here, innerMode is one of "text" or "math".
	    // We switch the mode of the parser, recurse, then restore the old mode.
	    this.mode = innerMode;
	    this.nextToken = this.lexer.lex(this.pos, innerMode);
	    var res;
	    if (optional) {
	        res = this.parseOptionalGroup();
	    } else {
	        res = this.parseGroup();
	    }
	    this.mode = outerMode;
	    this.nextToken = this.lexer.lex(this.pos, outerMode);
	    return res;
	};
	
	/**
	 * Parses a group, which is either a single nucleus (like "x") or an expression
	 * in braces (like "{x+y}")
	 *
	 * @return {?ParseFuncOrArgument}
	 */
	Parser.prototype.parseGroup = function() {
	    // Try to parse an open brace
	    if (this.nextToken.text === "{") {
	        // If we get a brace, parse an expression
	        this.consume();
	        var expression = this.parseExpression(false);
	        // Make sure we get a close brace
	        this.expect("}");
	        return new ParseFuncOrArgument(
	            new ParseNode("ordgroup", expression, this.mode),
	            false);
	    } else {
	        // Otherwise, just return a nucleus
	        return this.parseSymbol();
	    }
	};
	
	/**
	 * Parses a group, which is an expression in brackets (like "[x+y]")
	 *
	 * @return {?ParseFuncOrArgument}
	 */
	Parser.prototype.parseOptionalGroup = function() {
	    // Try to parse an open bracket
	    if (this.nextToken.text === "[") {
	        // If we get a brace, parse an expression
	        this.consume();
	        var expression = this.parseExpression(false, "]");
	        // Make sure we get a close bracket
	        this.expect("]");
	        return new ParseFuncOrArgument(
	            new ParseNode("ordgroup", expression, this.mode),
	            false);
	    } else {
	        // Otherwise, return null,
	        return null;
	    }
	};
	
	/**
	 * Parse a single symbol out of the string. Here, we handle both the functions
	 * we have defined, as well as the single character symbols
	 *
	 * @return {?ParseFuncOrArgument}
	 */
	Parser.prototype.parseSymbol = function() {
	    var nucleus = this.nextToken;
	
	    if (functions[nucleus.text]) {
	        this.consume();
	        // If there exists a function with this name, we return the function and
	        // say that it is a function.
	        return new ParseFuncOrArgument(
	            nucleus.text,
	            true);
	    } else if (symbols[this.mode][nucleus.text]) {
	        this.consume();
	        // Otherwise if this is a no-argument function, find the type it
	        // corresponds to in the symbols map
	        return new ParseFuncOrArgument(
	            new ParseNode(symbols[this.mode][nucleus.text].group,
	                          nucleus.text, this.mode),
	            false);
	    } else {
	        return null;
	    }
	};
	
	Parser.prototype.ParseNode = ParseNode;
	
	module.e = Parser;
	


/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint no-console:0 */
	/**
	 * This file does the main work of building a domTree structure from a parse
	 * tree. The entry point is the `buildHTML` function, which takes a parse tree.
	 * Then, the buildExpression, buildGroup, and various groupTypes functions are
	 * called, to produce a final HTML tree.
	 */
	
	var ParseError = __webpack_require__(112);
	var Style = __webpack_require__(239);
	
	var buildCommon = __webpack_require__(240);
	var delimiter = __webpack_require__(1746);
	var domTree = __webpack_require__(625);
	var fontMetrics = __webpack_require__(184);
	var utils = __webpack_require__(97);
	
	var makeSpan = buildCommon.makeSpan;
	
	/**
	 * Take a list of nodes, build them in order, and return a list of the built
	 * nodes. This function handles the `prev` node correctly, and passes the
	 * previous element from the list as the prev of the next element.
	 */
	var buildExpression = function(expression, options, prev) {
	    var groups = [];
	    for (var i = 0; i < expression.length; i++) {
	        var group = expression[i];
	        groups.push(buildGroup(group, options, prev));
	        prev = group;
	    }
	    return groups;
	};
	
	// List of types used by getTypeOfGroup,
	// see https://github.com/Khan/KaTeX/wiki/Examining-TeX#group-types
	var groupToType = {
	    mathord: "mord",
	    textord: "mord",
	    bin: "mbin",
	    rel: "mrel",
	    text: "mord",
	    open: "mopen",
	    close: "mclose",
	    inner: "minner",
	    genfrac: "mord",
	    array: "mord",
	    spacing: "mord",
	    punct: "mpunct",
	    ordgroup: "mord",
	    op: "mop",
	    katex: "mord",
	    overline: "mord",
	    rule: "mord",
	    leftright: "minner",
	    sqrt: "mord",
	    accent: "mord",
	};
	
	/**
	 * Gets the final math type of an expression, given its group type. This type is
	 * used to determine spacing between elements, and affects bin elements by
	 * causing them to change depending on what types are around them. This type
	 * must be attached to the outermost node of an element as a CSS class so that
	 * spacing with its surrounding elements works correctly.
	 *
	 * Some elements can be mapped one-to-one from group type to math type, and
	 * those are listed in the `groupToType` table.
	 *
	 * Others (usually elements that wrap around other elements) often have
	 * recursive definitions, and thus call `getTypeOfGroup` on their inner
	 * elements.
	 */
	var getTypeOfGroup = function(group) {
	    if (group == null) {
	        // Like when typesetting $^3$
	        return groupToType.mathord;
	    } else if (group.type === "supsub") {
	        return getTypeOfGroup(group.value.base);
	    } else if (group.type === "llap" || group.type === "rlap") {
	        return getTypeOfGroup(group.value);
	    } else if (group.type === "color") {
	        return getTypeOfGroup(group.value.value);
	    } else if (group.type === "sizing") {
	        return getTypeOfGroup(group.value.value);
	    } else if (group.type === "styling") {
	        return getTypeOfGroup(group.value.value);
	    } else if (group.type === "delimsizing") {
	        return groupToType[group.value.delimType];
	    } else {
	        return groupToType[group.type];
	    }
	};
	
	/**
	 * Sometimes, groups perform special rules when they have superscripts or
	 * subscripts attached to them. This function lets the `supsub` group know that
	 * its inner element should handle the superscripts and subscripts instead of
	 * handling them itself.
	 */
	var shouldHandleSupSub = function(group, options) {
	    if (!group) {
	        return false;
	    } else if (group.type === "op") {
	        // Operators handle supsubs differently when they have limits
	        // (e.g. `\displaystyle\sum_2^3`)
	        return group.value.limits &&
	            (options.style.size === Style.DISPLAY.size ||
	            group.value.alwaysHandleSupSub);
	    } else if (group.type === "accent") {
	        return isCharacterBox(group.value.base);
	    } else {
	        return null;
	    }
	};
	
	/**
	 * Sometimes we want to pull out the innermost element of a group. In most
	 * cases, this will just be the group itself, but when ordgroups and colors have
	 * a single element, we want to pull that out.
	 */
	var getBaseElem = function(group) {
	    if (!group) {
	        return false;
	    } else if (group.type === "ordgroup") {
	        if (group.value.length === 1) {
	            return getBaseElem(group.value[0]);
	        } else {
	            return group;
	        }
	    } else if (group.type === "color") {
	        if (group.value.value.length === 1) {
	            return getBaseElem(group.value.value[0]);
	        } else {
	            return group;
	        }
	    } else {
	        return group;
	    }
	};
	
	/**
	 * TeXbook algorithms often reference "character boxes", which are simply groups
	 * with a single character in them. To decide if something is a character box,
	 * we find its innermost group, and see if it is a single character.
	 */
	var isCharacterBox = function(group) {
	    var baseElem = getBaseElem(group);
	
	    // These are all they types of groups which hold single characters
	    return baseElem.type === "mathord" ||
	        baseElem.type === "textord" ||
	        baseElem.type === "bin" ||
	        baseElem.type === "rel" ||
	        baseElem.type === "inner" ||
	        baseElem.type === "open" ||
	        baseElem.type === "close" ||
	        baseElem.type === "punct";
	};
	
	var makeNullDelimiter = function(options) {
	    return makeSpan([
	        "sizing", "reset-" + options.size, "size5",
	        options.style.reset(), Style.TEXT.cls(),
	        "nulldelimiter",
	    ]);
	};
	
	/**
	 * This is a map of group types to the function used to handle that type.
	 * Simpler types come at the beginning, while complicated types come afterwards.
	 */
	var groupTypes = {};
	
	groupTypes.mathord = function(group, options, prev) {
	    return buildCommon.makeOrd(group, options, "mathord");
	};
	
	groupTypes.textord = function(group, options, prev) {
	    return buildCommon.makeOrd(group, options, "textord");
	};
	
	groupTypes.bin = function(group, options, prev) {
	    var className = "mbin";
	    // Pull out the most recent element. Do some special handling to find
	    // things at the end of a \color group. Note that we don't use the same
	    // logic for ordgroups (which count as ords).
	    var prevAtom = prev;
	    while (prevAtom && prevAtom.type === "color") {
	        var atoms = prevAtom.value.value;
	        prevAtom = atoms[atoms.length - 1];
	    }
	    // See TeXbook pg. 442-446, Rules 5 and 6, and the text before Rule 19.
	    // Here, we determine whether the bin should turn into an ord. We
	    // currently only apply Rule 5.
	    if (!prev || utils.contains(["mbin", "mopen", "mrel", "mop", "mpunct"],
	            getTypeOfGroup(prevAtom))) {
	        group.type = "textord";
	        className = "mord";
	    }
	
	    return buildCommon.mathsym(
	        group.value, group.mode, options.getColor(), [className]);
	};
	
	groupTypes.rel = function(group, options, prev) {
	    return buildCommon.mathsym(
	        group.value, group.mode, options.getColor(), ["mrel"]);
	};
	
	groupTypes.open = function(group, options, prev) {
	    return buildCommon.mathsym(
	        group.value, group.mode, options.getColor(), ["mopen"]);
	};
	
	groupTypes.close = function(group, options, prev) {
	    return buildCommon.mathsym(
	        group.value, group.mode, options.getColor(), ["mclose"]);
	};
	
	groupTypes.inner = function(group, options, prev) {
	    return buildCommon.mathsym(
	        group.value, group.mode, options.getColor(), ["minner"]);
	};
	
	groupTypes.punct = function(group, options, prev) {
	    return buildCommon.mathsym(
	        group.value, group.mode, options.getColor(), ["mpunct"]);
	};
	
	groupTypes.ordgroup = function(group, options, prev) {
	    return makeSpan(
	        ["mord", options.style.cls()],
	        buildExpression(group.value, options.reset())
	    );
	};
	
	groupTypes.text = function(group, options, prev) {
	    return makeSpan(["text", "mord", options.style.cls()],
	        buildExpression(group.value.body, options.reset()));
	};
	
	groupTypes.color = function(group, options, prev) {
	    var elements = buildExpression(
	        group.value.value,
	        options.withColor(group.value.color),
	        prev
	    );
	
	    // \color isn't supposed to affect the type of the elements it contains.
	    // To accomplish this, we wrap the results in a fragment, so the inner
	    // elements will be able to directly interact with their neighbors. For
	    // example, `\color{red}{2 +} 3` has the same spacing as `2 + 3`
	    return new buildCommon.makeFragment(elements);
	};
	
	groupTypes.supsub = function(group, options, prev) {
	    // Superscript and subscripts are handled in the TeXbook on page
	    // 445-446, rules 18(a-f).
	
	    // Here is where we defer to the inner group if it should handle
	    // superscripts and subscripts itself.
	    if (shouldHandleSupSub(group.value.base, options)) {
	        return groupTypes[group.value.base.type](group, options, prev);
	    }
	
	    var base = buildGroup(group.value.base, options.reset());
	    var supmid;
	    var submid;
	    var sup;
	    var sub;
	
	    if (group.value.sup) {
	        sup = buildGroup(group.value.sup,
	                options.withStyle(options.style.sup()));
	        supmid = makeSpan(
	                [options.style.reset(), options.style.sup().cls()], [sup]);
	    }
	
	    if (group.value.sub) {
	        sub = buildGroup(group.value.sub,
	                options.withStyle(options.style.sub()));
	        submid = makeSpan(
	                [options.style.reset(), options.style.sub().cls()], [sub]);
	    }
	
	    // Rule 18a
	    var supShift;
	    var subShift;
	    if (isCharacterBox(group.value.base)) {
	        supShift = 0;
	        subShift = 0;
	    } else {
	        supShift = base.height - fontMetrics.metrics.supDrop;
	        subShift = base.depth + fontMetrics.metrics.subDrop;
	    }
	
	    // Rule 18c
	    var minSupShift;
	    if (options.style === Style.DISPLAY) {
	        minSupShift = fontMetrics.metrics.sup1;
	    } else if (options.style.cramped) {
	        minSupShift = fontMetrics.metrics.sup3;
	    } else {
	        minSupShift = fontMetrics.metrics.sup2;
	    }
	
	    // scriptspace is a font-size-independent size, so scale it
	    // appropriately
	    var multiplier = Style.TEXT.sizeMultiplier *
	            options.style.sizeMultiplier;
	    var scriptspace =
	        (0.5 / fontMetrics.metrics.ptPerEm) / multiplier + "em";
	
	    var supsub;
	    if (!group.value.sup) {
	        // Rule 18b
	        subShift = Math.max(
	            subShift, fontMetrics.metrics.sub1,
	            sub.height - 0.8 * fontMetrics.metrics.xHeight);
	
	        supsub = buildCommon.makeVList([
	            {type: "elem", elem: submid},
	        ], "shift", subShift, options);
	
	        supsub.children[0].style.marginRight = scriptspace;
	
	        // Subscripts shouldn't be shifted by the base's italic correction.
	        // Account for that by shifting the subscript back the appropriate
	        // amount. Note we only do this when the base is a single symbol.
	        if (base instanceof domTree.symbolNode) {
	            supsub.children[0].style.marginLeft = -base.italic + "em";
	        }
	    } else if (!group.value.sub) {
	        // Rule 18c, d
	        supShift = Math.max(supShift, minSupShift,
	            sup.depth + 0.25 * fontMetrics.metrics.xHeight);
	
	        supsub = buildCommon.makeVList([
	            {type: "elem", elem: supmid},
	        ], "shift", -supShift, options);
	
	        supsub.children[0].style.marginRight = scriptspace;
	    } else {
	        supShift = Math.max(
	            supShift, minSupShift,
	            sup.depth + 0.25 * fontMetrics.metrics.xHeight);
	        subShift = Math.max(subShift, fontMetrics.metrics.sub2);
	
	        var ruleWidth = fontMetrics.metrics.defaultRuleThickness;
	
	        // Rule 18e
	        if ((supShift - sup.depth) - (sub.height - subShift) <
	                4 * ruleWidth) {
	            subShift = 4 * ruleWidth - (supShift - sup.depth) + sub.height;
	            var psi = 0.8 * fontMetrics.metrics.xHeight -
	                (supShift - sup.depth);
	            if (psi > 0) {
	                supShift += psi;
	                subShift -= psi;
	            }
	        }
	
	        supsub = buildCommon.makeVList([
	            {type: "elem", elem: submid, shift: subShift},
	            {type: "elem", elem: supmid, shift: -supShift},
	        ], "individualShift", null, options);
	
	        // See comment above about subscripts not being shifted
	        if (base instanceof domTree.symbolNode) {
	            supsub.children[0].style.marginLeft = -base.italic + "em";
	        }
	
	        supsub.children[0].style.marginRight = scriptspace;
	        supsub.children[1].style.marginRight = scriptspace;
	    }
	
	    return makeSpan([getTypeOfGroup(group.value.base)],
	        [base, supsub]);
	};
	
	groupTypes.genfrac = function(group, options, prev) {
	    // Fractions are handled in the TeXbook on pages 444-445, rules 15(a-e).
	    // Figure out what style this fraction should be in based on the
	    // function used
	    var fstyle = options.style;
	    if (group.value.size === "display") {
	        fstyle = Style.DISPLAY;
	    } else if (group.value.size === "text") {
	        fstyle = Style.TEXT;
	    }
	
	    var nstyle = fstyle.fracNum();
	    var dstyle = fstyle.fracDen();
	
	    var numer = buildGroup(group.value.numer, options.withStyle(nstyle));
	    var numerreset = makeSpan([fstyle.reset(), nstyle.cls()], [numer]);
	
	    var denom = buildGroup(group.value.denom, options.withStyle(dstyle));
	    var denomreset = makeSpan([fstyle.reset(), dstyle.cls()], [denom]);
	
	    var ruleWidth;
	    if (group.value.hasBarLine) {
	        ruleWidth = fontMetrics.metrics.defaultRuleThickness /
	            options.style.sizeMultiplier;
	    } else {
	        ruleWidth = 0;
	    }
	
	    // Rule 15b
	    var numShift;
	    var clearance;
	    var denomShift;
	    if (fstyle.size === Style.DISPLAY.size) {
	        numShift = fontMetrics.metrics.num1;
	        if (ruleWidth > 0) {
	            clearance = 3 * ruleWidth;
	        } else {
	            clearance = 7 * fontMetrics.metrics.defaultRuleThickness;
	        }
	        denomShift = fontMetrics.metrics.denom1;
	    } else {
	        if (ruleWidth > 0) {
	            numShift = fontMetrics.metrics.num2;
	            clearance = ruleWidth;
	        } else {
	            numShift = fontMetrics.metrics.num3;
	            clearance = 3 * fontMetrics.metrics.defaultRuleThickness;
	        }
	        denomShift = fontMetrics.metrics.denom2;
	    }
	
	    var frac;
	    if (ruleWidth === 0) {
	        // Rule 15c
	        var candiateClearance =
	            (numShift - numer.depth) - (denom.height - denomShift);
	        if (candiateClearance < clearance) {
	            numShift += 0.5 * (clearance - candiateClearance);
	            denomShift += 0.5 * (clearance - candiateClearance);
	        }
	
	        frac = buildCommon.makeVList([
	            {type: "elem", elem: denomreset, shift: denomShift},
	            {type: "elem", elem: numerreset, shift: -numShift},
	        ], "individualShift", null, options);
	    } else {
	        // Rule 15d
	        var axisHeight = fontMetrics.metrics.axisHeight;
	
	        if ((numShift - numer.depth) - (axisHeight + 0.5 * ruleWidth) <
	                clearance) {
	            numShift +=
	                clearance - ((numShift - numer.depth) -
	                             (axisHeight + 0.5 * ruleWidth));
	        }
	
	        if ((axisHeight - 0.5 * ruleWidth) - (denom.height - denomShift) <
	                clearance) {
	            denomShift +=
	                clearance - ((axisHeight - 0.5 * ruleWidth) -
	                             (denom.height - denomShift));
	        }
	
	        var mid = makeSpan(
	            [options.style.reset(), Style.TEXT.cls(), "frac-line"]);
	        // Manually set the height of the line because its height is
	        // created in CSS
	        mid.height = ruleWidth;
	
	        var midShift = -(axisHeight - 0.5 * ruleWidth);
	
	        frac = buildCommon.makeVList([
	            {type: "elem", elem: denomreset, shift: denomShift},
	            {type: "elem", elem: mid,        shift: midShift},
	            {type: "elem", elem: numerreset, shift: -numShift},
	        ], "individualShift", null, options);
	    }
	
	    // Since we manually change the style sometimes (with \dfrac or \tfrac),
	    // account for the possible size change here.
	    frac.height *= fstyle.sizeMultiplier / options.style.sizeMultiplier;
	    frac.depth *= fstyle.sizeMultiplier / options.style.sizeMultiplier;
	
	    // Rule 15e
	    var delimSize;
	    if (fstyle.size === Style.DISPLAY.size) {
	        delimSize = fontMetrics.metrics.delim1;
	    } else {
	        delimSize = fontMetrics.metrics.getDelim2(fstyle);
	    }
	
	    var leftDelim;
	    var rightDelim;
	    if (group.value.leftDelim == null) {
	        leftDelim = makeNullDelimiter(options);
	    } else {
	        leftDelim = delimiter.customSizedDelim(
	            group.value.leftDelim, delimSize, true,
	            options.withStyle(fstyle), group.mode);
	    }
	    if (group.value.rightDelim == null) {
	        rightDelim = makeNullDelimiter(options);
	    } else {
	        rightDelim = delimiter.customSizedDelim(
	            group.value.rightDelim, delimSize, true,
	            options.withStyle(fstyle), group.mode);
	    }
	
	    return makeSpan(
	        ["mord", options.style.reset(), fstyle.cls()],
	        [leftDelim, makeSpan(["mfrac"], [frac]), rightDelim],
	        options.getColor());
	};
	
	groupTypes.array = function(group, options, prev) {
	    var r;
	    var c;
	    var nr = group.value.body.length;
	    var nc = 0;
	    var body = new Array(nr);
	
	    // Horizontal spacing
	    var pt = 1 / fontMetrics.metrics.ptPerEm;
	    var arraycolsep = 5 * pt; // \arraycolsep in article.cls
	
	    // Vertical spacing
	    var baselineskip = 12 * pt; // see size10.clo
	    // Default \arraystretch from lttab.dtx
	    // TODO(gagern): may get redefined once we have user-defined macros
	    var arraystretch = utils.deflt(group.value.arraystretch, 1);
	    var arrayskip = arraystretch * baselineskip;
	    var arstrutHeight = 0.7 * arrayskip; // \strutbox in ltfsstrc.dtx and
	    var arstrutDepth = 0.3 * arrayskip;  // \@arstrutbox in lttab.dtx
	
	    var totalHeight = 0;
	    for (r = 0; r < group.value.body.length; ++r) {
	        var inrow = group.value.body[r];
	        var height = arstrutHeight; // \@array adds an \@arstrut
	        var depth = arstrutDepth;   // to each tow (via the template)
	
	        if (nc < inrow.length) {
	            nc = inrow.length;
	        }
	
	        var outrow = new Array(inrow.length);
	        for (c = 0; c < inrow.length; ++c) {
	            var elt = buildGroup(inrow[c], options);
	            if (depth < elt.depth) {
	                depth = elt.depth;
	            }
	            if (height < elt.height) {
	                height = elt.height;
	            }
	            outrow[c] = elt;
	        }
	
	        var gap = 0;
	        if (group.value.rowGaps[r]) {
	            gap = group.value.rowGaps[r].value;
	            switch (gap.unit) {
	                case "em":
	                    gap = gap.number;
	                    break;
	                case "ex":
	                    gap = gap.number * fontMetrics.metrics.emPerEx;
	                    break;
	                default:
	                    console.error("Can't handle unit " + gap.unit);
	                    gap = 0;
	            }
	            if (gap > 0) { // \@argarraycr
	                gap += arstrutDepth;
	                if (depth < gap) {
	                    depth = gap; // \@xargarraycr
	                }
	                gap = 0;
	            }
	        }
	
	        outrow.height = height;
	        outrow.depth = depth;
	        totalHeight += height;
	        outrow.pos = totalHeight;
	        totalHeight += depth + gap; // \@yargarraycr
	        body[r] = outrow;
	    }
	
	    var offset = totalHeight / 2 + fontMetrics.metrics.axisHeight;
	    var colDescriptions = group.value.cols || [];
	    var cols = [];
	    var colSep;
	    var colDescrNum;
	    for (c = 0, colDescrNum = 0;
	         // Continue while either there are more columns or more column
	         // descriptions, so trailing separators don't get lost.
	         c < nc || colDescrNum < colDescriptions.length;
	         ++c, ++colDescrNum) {
	
	        var colDescr = colDescriptions[colDescrNum] || {};
	
	        var firstSeparator = true;
	        while (colDescr.type === "separator") {
	            // If there is more than one separator in a row, add a space
	            // between them.
	            if (!firstSeparator) {
	                colSep = makeSpan(["arraycolsep"], []);
	                colSep.style.width =
	                    fontMetrics.metrics.doubleRuleSep + "em";
	                cols.push(colSep);
	            }
	
	            if (colDescr.separator === "|") {
	                var separator = makeSpan(
	                    ["vertical-separator"],
	                    []);
	                separator.style.height = totalHeight + "em";
	                separator.style.verticalAlign =
	                    -(totalHeight - offset) + "em";
	
	                cols.push(separator);
	            } else {
	                throw new ParseError(
	                    "Invalid separator type: " + colDescr.separator);
	            }
	
	            colDescrNum++;
	            colDescr = colDescriptions[colDescrNum] || {};
	            firstSeparator = false;
	        }
	
	        if (c >= nc) {
	            continue;
	        }
	
	        var sepwidth;
	        if (c > 0 || group.value.hskipBeforeAndAfter) {
	            sepwidth = utils.deflt(colDescr.pregap, arraycolsep);
	            if (sepwidth !== 0) {
	                colSep = makeSpan(["arraycolsep"], []);
	                colSep.style.width = sepwidth + "em";
	                cols.push(colSep);
	            }
	        }
	
	        var col = [];
	        for (r = 0; r < nr; ++r) {
	            var row = body[r];
	            var elem = row[c];
	            if (!elem) {
	                continue;
	            }
	            var shift = row.pos - offset;
	            elem.depth = row.depth;
	            elem.height = row.height;
	            col.push({type: "elem", elem: elem, shift: shift});
	        }
	
	        col = buildCommon.makeVList(col, "individualShift", null, options);
	        col = makeSpan(
	            ["col-align-" + (colDescr.align || "c")],
	            [col]);
	        cols.push(col);
	
	        if (c < nc - 1 || group.value.hskipBeforeAndAfter) {
	            sepwidth = utils.deflt(colDescr.postgap, arraycolsep);
	            if (sepwidth !== 0) {
	                colSep = makeSpan(["arraycolsep"], []);
	                colSep.style.width = sepwidth + "em";
	                cols.push(colSep);
	            }
	        }
	    }
	    body = makeSpan(["mtable"], cols);
	    return makeSpan(["mord"], [body], options.getColor());
	};
	
	groupTypes.spacing = function(group, options, prev) {
	    if (group.value === "\\ " || group.value === "\\space" ||
	        group.value === " " || group.value === "~") {
	        // Spaces are generated by adding an actual space. Each of these
	        // things has an entry in the symbols table, so these will be turned
	        // into appropriate outputs.
	        return makeSpan(
	            ["mord", "mspace"],
	            [buildCommon.mathsym(group.value, group.mode)]
	        );
	    } else {
	        // Other kinds of spaces are of arbitrary width. We use CSS to
	        // generate these.
	        return makeSpan(
	            ["mord", "mspace",
	             buildCommon.spacingFunctions[group.value].className]);
	    }
	};
	
	groupTypes.llap = function(group, options, prev) {
	    var inner = makeSpan(
	        ["inner"], [buildGroup(group.value.body, options.reset())]);
	    var fix = makeSpan(["fix"], []);
	    return makeSpan(
	        ["llap", options.style.cls()], [inner, fix]);
	};
	
	groupTypes.rlap = function(group, options, prev) {
	    var inner = makeSpan(
	        ["inner"], [buildGroup(group.value.body, options.reset())]);
	    var fix = makeSpan(["fix"], []);
	    return makeSpan(
	        ["rlap", options.style.cls()], [inner, fix]);
	};
	
	groupTypes.op = function(group, options, prev) {
	    // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
	    var supGroup;
	    var subGroup;
	    var hasLimits = false;
	    if (group.type === "supsub" ) {
	        // If we have limits, supsub will pass us its group to handle. Pull
	        // out the superscript and subscript and set the group to the op in
	        // its base.
	        supGroup = group.value.sup;
	        subGroup = group.value.sub;
	        group = group.value.base;
	        hasLimits = true;
	    }
	
	    // Most operators have a large successor symbol, but these don't.
	    var noSuccessor = [
	        "\\smallint",
	    ];
	
	    var large = false;
	    if (options.style.size === Style.DISPLAY.size &&
	        group.value.symbol &&
	        !utils.contains(noSuccessor, group.value.body)) {
	
	        // Most symbol operators get larger in displaystyle (rule 13)
	        large = true;
	    }
	
	    var base;
	    var baseShift = 0;
	    var slant = 0;
	    if (group.value.symbol) {
	        // If this is a symbol, create the symbol.
	        var style = large ? "Size2-Regular" : "Size1-Regular";
	        base = buildCommon.makeSymbol(
	            group.value.body, style, "math", options.getColor(),
	            ["op-symbol", large ? "large-op" : "small-op", "mop"]);
	
	        // Shift the symbol so its center lies on the axis (rule 13). It
	        // appears that our fonts have the centers of the symbols already
	        // almost on the axis, so these numbers are very small. Note we
	        // don't actually apply this here, but instead it is used either in
	        // the vlist creation or separately when there are no limits.
	        baseShift = (base.height - base.depth) / 2 -
	            fontMetrics.metrics.axisHeight *
	            options.style.sizeMultiplier;
	
	        // The slant of the symbol is just its italic correction.
	        slant = base.italic;
	    } else {
	        // Otherwise, this is a text operator. Build the text from the
	        // operator's name.
	        // TODO(emily): Add a space in the middle of some of these
	        // operators, like \limsup
	        var output = [];
	        for (var i = 1; i < group.value.body.length; i++) {
	            output.push(buildCommon.mathsym(group.value.body[i], group.mode));
	        }
	        base = makeSpan(["mop"], output, options.getColor());
	    }
	
	    if (hasLimits) {
	        // IE 8 clips \int if it is in a display: inline-block. We wrap it
	        // in a new span so it is an inline, and works.
	        base = makeSpan([], [base]);
	
	        var supmid;
	        var supKern;
	        var submid;
	        var subKern;
	        // We manually have to handle the superscripts and subscripts. This,
	        // aside from the kern calculations, is copied from supsub.
	        if (supGroup) {
	            var sup = buildGroup(
	                supGroup, options.withStyle(options.style.sup()));
	            supmid = makeSpan(
	                [options.style.reset(), options.style.sup().cls()], [sup]);
	
	            supKern = Math.max(
	                fontMetrics.metrics.bigOpSpacing1,
	                fontMetrics.metrics.bigOpSpacing3 - sup.depth);
	        }
	
	        if (subGroup) {
	            var sub = buildGroup(
	                subGroup, options.withStyle(options.style.sub()));
	            submid = makeSpan(
	                [options.style.reset(), options.style.sub().cls()],
	                [sub]);
	
	            subKern = Math.max(
	                fontMetrics.metrics.bigOpSpacing2,
	                fontMetrics.metrics.bigOpSpacing4 - sub.height);
	        }
	
	        // Build the final group as a vlist of the possible subscript, base,
	        // and possible superscript.
	        var finalGroup;
	        var top;
	        var bottom;
	        if (!supGroup) {
	            top = base.height - baseShift;
	
	            finalGroup = buildCommon.makeVList([
	                {type: "kern", size: fontMetrics.metrics.bigOpSpacing5},
	                {type: "elem", elem: submid},
	                {type: "kern", size: subKern},
	                {type: "elem", elem: base},
	            ], "top", top, options);
	
	            // Here, we shift the limits by the slant of the symbol. Note
	            // that we are supposed to shift the limits by 1/2 of the slant,
	            // but since we are centering the limits adding a full slant of
	            // margin will shift by 1/2 that.
	            finalGroup.children[0].style.marginLeft = -slant + "em";
	        } else if (!subGroup) {
	            bottom = base.depth + baseShift;
	
	            finalGroup = buildCommon.makeVList([
	                {type: "elem", elem: base},
	                {type: "kern", size: supKern},
	                {type: "elem", elem: supmid},
	                {type: "kern", size: fontMetrics.metrics.bigOpSpacing5},
	            ], "bottom", bottom, options);
	
	            // See comment above about slants
	            finalGroup.children[1].style.marginLeft = slant + "em";
	        } else if (!supGroup && !subGroup) {
	            // This case probably shouldn't occur (this would mean the
	            // supsub was sending us a group with no superscript or
	            // subscript) but be safe.
	            return base;
	        } else {
	            bottom = fontMetrics.metrics.bigOpSpacing5 +
	                submid.height + submid.depth +
	                subKern +
	                base.depth + baseShift;
	
	            finalGroup = buildCommon.makeVList([
	                {type: "kern", size: fontMetrics.metrics.bigOpSpacing5},
	                {type: "elem", elem: submid},
	                {type: "kern", size: subKern},
	                {type: "elem", elem: base},
	                {type: "kern", size: supKern},
	                {type: "elem", elem: supmid},
	                {type: "kern", size: fontMetrics.metrics.bigOpSpacing5},
	            ], "bottom", bottom, options);
	
	            // See comment above about slants
	            finalGroup.children[0].style.marginLeft = -slant + "em";
	            finalGroup.children[2].style.marginLeft = slant + "em";
	        }
	
	        return makeSpan(["mop", "op-limits"], [finalGroup]);
	    } else {
	        if (group.value.symbol) {
	            base.style.top = baseShift + "em";
	        }
	
	        return base;
	    }
	};
	
	groupTypes.katex = function(group, options, prev) {
	    // The KaTeX logo. The offsets for the K and a were chosen to look
	    // good, but the offsets for the T, E, and X were taken from the
	    // definition of \TeX in TeX (see TeXbook pg. 356)
	    var k = makeSpan(
	        ["k"], [buildCommon.mathsym("K", group.mode)]);
	    var a = makeSpan(
	        ["a"], [buildCommon.mathsym("A", group.mode)]);
	
	    a.height = (a.height + 0.2) * 0.75;
	    a.depth = (a.height - 0.2) * 0.75;
	
	    var t = makeSpan(
	        ["t"], [buildCommon.mathsym("T", group.mode)]);
	    var e = makeSpan(
	        ["e"], [buildCommon.mathsym("E", group.mode)]);
	
	    e.height = (e.height - 0.2155);
	    e.depth = (e.depth + 0.2155);
	
	    var x = makeSpan(
	        ["x"], [buildCommon.mathsym("X", group.mode)]);
	
	    return makeSpan(
	        ["katex-logo", "mord"], [k, a, t, e, x], options.getColor());
	};
	
	groupTypes.overline = function(group, options, prev) {
	    // Overlines are handled in the TeXbook pg 443, Rule 9.
	
	    // Build the inner group in the cramped style.
	    var innerGroup = buildGroup(group.value.body,
	            options.withStyle(options.style.cramp()));
	
	    var ruleWidth = fontMetrics.metrics.defaultRuleThickness /
	        options.style.sizeMultiplier;
	
	    // Create the line above the body
	    var line = makeSpan(
	        [options.style.reset(), Style.TEXT.cls(), "overline-line"]);
	    line.height = ruleWidth;
	    line.maxFontSize = 1.0;
	
	    // Generate the vlist, with the appropriate kerns
	    var vlist = buildCommon.makeVList([
	        {type: "elem", elem: innerGroup},
	        {type: "kern", size: 3 * ruleWidth},
	        {type: "elem", elem: line},
	        {type: "kern", size: ruleWidth},
	    ], "firstBaseline", null, options);
	
	    return makeSpan(["overline", "mord"], [vlist], options.getColor());
	};
	
	groupTypes.sqrt = function(group, options, prev) {
	    // Square roots are handled in the TeXbook pg. 443, Rule 11.
	
	    // First, we do the same steps as in overline to build the inner group
	    // and line
	    var inner = buildGroup(group.value.body,
	            options.withStyle(options.style.cramp()));
	
	    var ruleWidth = fontMetrics.metrics.defaultRuleThickness /
	        options.style.sizeMultiplier;
	
	    var line = makeSpan(
	        [options.style.reset(), Style.TEXT.cls(), "sqrt-line"], [],
	        options.getColor());
	    line.height = ruleWidth;
	    line.maxFontSize = 1.0;
	
	    var phi = ruleWidth;
	    if (options.style.id < Style.TEXT.id) {
	        phi = fontMetrics.metrics.xHeight;
	    }
	
	    // Calculate the clearance between the body and line
	    var lineClearance = ruleWidth + phi / 4;
	
	    var innerHeight =
	        (inner.height + inner.depth) * options.style.sizeMultiplier;
	    var minDelimiterHeight = innerHeight + lineClearance + ruleWidth;
	
	    // Create a \surd delimiter of the required minimum size
	    var delim = makeSpan(["sqrt-sign"], [
	        delimiter.customSizedDelim("\\surd", minDelimiterHeight,
	                                   false, options, group.mode)],
	                         options.getColor());
	
	    var delimDepth = (delim.height + delim.depth) - ruleWidth;
	
	    // Adjust the clearance based on the delimiter size
	    if (delimDepth > inner.height + inner.depth + lineClearance) {
	        lineClearance =
	            (lineClearance + delimDepth - inner.height - inner.depth) / 2;
	    }
	
	    // Shift the delimiter so that its top lines up with the top of the line
	    var delimShift = -(inner.height + lineClearance + ruleWidth) + delim.height;
	    delim.style.top = delimShift + "em";
	    delim.height -= delimShift;
	    delim.depth += delimShift;
	
	    // We add a special case here, because even when `inner` is empty, we
	    // still get a line. So, we use a simple heuristic to decide if we
	    // should omit the body entirely. (note this doesn't work for something
	    // like `\sqrt{\rlap{x}}`, but if someone is doing that they deserve for
	    // it not to work.
	    var body;
	    if (inner.height === 0 && inner.depth === 0) {
	        body = makeSpan();
	    } else {
	        body = buildCommon.makeVList([
	            {type: "elem", elem: inner},
	            {type: "kern", size: lineClearance},
	            {type: "elem", elem: line},
	            {type: "kern", size: ruleWidth},
	        ], "firstBaseline", null, options);
	    }
	
	    if (!group.value.index) {
	        return makeSpan(["sqrt", "mord"], [delim, body]);
	    } else {
	        // Handle the optional root index
	
	        // The index is always in scriptscript style
	        var root = buildGroup(
	            group.value.index,
	            options.withStyle(Style.SCRIPTSCRIPT));
	        var rootWrap = makeSpan(
	            [options.style.reset(), Style.SCRIPTSCRIPT.cls()],
	            [root]);
	
	        // Figure out the height and depth of the inner part
	        var innerRootHeight = Math.max(delim.height, body.height);
	        var innerRootDepth = Math.max(delim.depth, body.depth);
	
	        // The amount the index is shifted by. This is taken from the TeX
	        // source, in the definition of `\r@@t`.
	        var toShift = 0.6 * (innerRootHeight - innerRootDepth);
	
	        // Build a VList with the superscript shifted up correctly
	        var rootVList = buildCommon.makeVList(
	            [{type: "elem", elem: rootWrap}],
	            "shift", -toShift, options);
	        // Add a class surrounding it so we can add on the appropriate
	        // kerning
	        var rootVListWrap = makeSpan(["root"], [rootVList]);
	
	        return makeSpan(["sqrt", "mord"], [rootVListWrap, delim, body]);
	    }
	};
	
	groupTypes.sizing = function(group, options, prev) {
	    // Handle sizing operators like \Huge. Real TeX doesn't actually allow
	    // these functions inside of math expressions, so we do some special
	    // handling.
	    var inner = buildExpression(group.value.value,
	            options.withSize(group.value.size), prev);
	
	    var span = makeSpan(["mord"],
	        [makeSpan(["sizing", "reset-" + options.size, group.value.size,
	                   options.style.cls()],
	                  inner)]);
	
	    // Calculate the correct maxFontSize manually
	    var fontSize = buildCommon.sizingMultiplier[group.value.size];
	    span.maxFontSize = fontSize * options.style.sizeMultiplier;
	
	    return span;
	};
	
	groupTypes.styling = function(group, options, prev) {
	    // Style changes are handled in the TeXbook on pg. 442, Rule 3.
	
	    // Figure out what style we're changing to.
	    var style = {
	        "display": Style.DISPLAY,
	        "text": Style.TEXT,
	        "script": Style.SCRIPT,
	        "scriptscript": Style.SCRIPTSCRIPT,
	    };
	
	    var newStyle = style[group.value.style];
	
	    // Build the inner expression in the new style.
	    var inner = buildExpression(
	        group.value.value, options.withStyle(newStyle), prev);
	
	    return makeSpan([options.style.reset(), newStyle.cls()], inner);
	};
	
	groupTypes.font = function(group, options, prev) {
	    var font = group.value.font;
	    return buildGroup(group.value.body, options.withFont(font), prev);
	};
	
	groupTypes.delimsizing = function(group, options, prev) {
	    var delim = group.value.value;
	
	    if (delim === ".") {
	        // Empty delimiters still count as elements, even though they don't
	        // show anything.
	        return makeSpan([groupToType[group.value.delimType]]);
	    }
	
	    // Use delimiter.sizedDelim to generate the delimiter.
	    return makeSpan(
	        [groupToType[group.value.delimType]],
	        [delimiter.sizedDelim(
	            delim, group.value.size, options, group.mode)]);
	};
	
	groupTypes.leftright = function(group, options, prev) {
	    // Build the inner expression
	    var inner = buildExpression(group.value.body, options.reset());
	
	    var innerHeight = 0;
	    var innerDepth = 0;
	
	    // Calculate its height and depth
	    for (var i = 0; i < inner.length; i++) {
	        innerHeight = Math.max(inner[i].height, innerHeight);
	        innerDepth = Math.max(inner[i].depth, innerDepth);
	    }
	
	    // The size of delimiters is the same, regardless of what style we are
	    // in. Thus, to correctly calculate the size of delimiter we need around
	    // a group, we scale down the inner size based on the size.
	    innerHeight *= options.style.sizeMultiplier;
	    innerDepth *= options.style.sizeMultiplier;
	
	    var leftDelim;
	    if (group.value.left === ".") {
	        // Empty delimiters in \left and \right make null delimiter spaces.
	        leftDelim = makeNullDelimiter(options);
	    } else {
	        // Otherwise, use leftRightDelim to generate the correct sized
	        // delimiter.
	        leftDelim = delimiter.leftRightDelim(
	            group.value.left, innerHeight, innerDepth, options,
	            group.mode);
	    }
	    // Add it to the beginning of the expression
	    inner.unshift(leftDelim);
	
	    var rightDelim;
	    // Same for the right delimiter
	    if (group.value.right === ".") {
	        rightDelim = makeNullDelimiter(options);
	    } else {
	        rightDelim = delimiter.leftRightDelim(
	            group.value.right, innerHeight, innerDepth, options,
	            group.mode);
	    }
	    // Add it to the end of the expression.
	    inner.push(rightDelim);
	
	    return makeSpan(
	        ["minner", options.style.cls()], inner, options.getColor());
	};
	
	groupTypes.rule = function(group, options, prev) {
	    // Make an empty span for the rule
	    var rule = makeSpan(["mord", "rule"], [], options.getColor());
	
	    // Calculate the shift, width, and height of the rule, and account for units
	    var shift = 0;
	    if (group.value.shift) {
	        shift = group.value.shift.number;
	        if (group.value.shift.unit === "ex") {
	            shift *= fontMetrics.metrics.xHeight;
	        }
	    }
	
	    var width = group.value.width.number;
	    if (group.value.width.unit === "ex") {
	        width *= fontMetrics.metrics.xHeight;
	    }
	
	    var height = group.value.height.number;
	    if (group.value.height.unit === "ex") {
	        height *= fontMetrics.metrics.xHeight;
	    }
	
	    // The sizes of rules are absolute, so make it larger if we are in a
	    // smaller style.
	    shift /= options.style.sizeMultiplier;
	    width /= options.style.sizeMultiplier;
	    height /= options.style.sizeMultiplier;
	
	    // Style the rule to the right size
	    rule.style.borderRightWidth = width + "em";
	    rule.style.borderTopWidth = height + "em";
	    rule.style.bottom = shift + "em";
	
	    // Record the height and width
	    rule.width = width;
	    rule.height = height + shift;
	    rule.depth = -shift;
	
	    return rule;
	};
	
	groupTypes.accent = function(group, options, prev) {
	    // Accents are handled in the TeXbook pg. 443, rule 12.
	    var base = group.value.base;
	
	    var supsubGroup;
	    if (group.type === "supsub") {
	        // If our base is a character box, and we have superscripts and
	        // subscripts, the supsub will defer to us. In particular, we want
	        // to attach the superscripts and subscripts to the inner body (so
	        // that the position of the superscripts and subscripts won't be
	        // affected by the height of the accent). We accomplish this by
	        // sticking the base of the accent into the base of the supsub, and
	        // rendering that, while keeping track of where the accent is.
	
	        // The supsub group is the group that was passed in
	        var supsub = group;
	        // The real accent group is the base of the supsub group
	        group = supsub.value.base;
	        // The character box is the base of the accent group
	        base = group.value.base;
	        // Stick the character box into the base of the supsub group
	        supsub.value.base = base;
	
	        // Rerender the supsub group with its new base, and store that
	        // result.
	        supsubGroup = buildGroup(
	            supsub, options.reset(), prev);
	    }
	
	    // Build the base group
	    var body = buildGroup(
	        base, options.withStyle(options.style.cramp()));
	
	    // Calculate the skew of the accent. This is based on the line "If the
	    // nucleus is not a single character, let s = 0; otherwise set s to the
	    // kern amount for the nucleus followed by the \skewchar of its font."
	    // Note that our skew metrics are just the kern between each character
	    // and the skewchar.
	    var skew;
	    if (isCharacterBox(base)) {
	        // If the base is a character box, then we want the skew of the
	        // innermost character. To do that, we find the innermost character:
	        var baseChar = getBaseElem(base);
	        // Then, we render its group to get the symbol inside it
	        var baseGroup = buildGroup(
	            baseChar, options.withStyle(options.style.cramp()));
	        // Finally, we pull the skew off of the symbol.
	        skew = baseGroup.skew;
	        // Note that we now throw away baseGroup, because the layers we
	        // removed with getBaseElem might contain things like \color which
	        // we can't get rid of.
	        // TODO(emily): Find a better way to get the skew
	    } else {
	        skew = 0;
	    }
	
	    // calculate the amount of space between the body and the accent
	    var clearance = Math.min(body.height, fontMetrics.metrics.xHeight);
	
	    // Build the accent
	    var accent = buildCommon.makeSymbol(
	        group.value.accent, "Main-Regular", "math", options.getColor());
	    // Remove the italic correction of the accent, because it only serves to
	    // shift the accent over to a place we don't want.
	    accent.italic = 0;
	
	    // The \vec character that the fonts use is a combining character, and
	    // thus shows up much too far to the left. To account for this, we add a
	    // specific class which shifts the accent over to where we want it.
	    // TODO(emily): Fix this in a better way, like by changing the font
	    var vecClass = group.value.accent === "\\vec" ? "accent-vec" : null;
	
	    var accentBody = makeSpan(["accent-body", vecClass], [
	        makeSpan([], [accent])]);
	
	    accentBody = buildCommon.makeVList([
	        {type: "elem", elem: body},
	        {type: "kern", size: -clearance},
	        {type: "elem", elem: accentBody},
	    ], "firstBaseline", null, options);
	
	    // Shift the accent over by the skew. Note we shift by twice the skew
	    // because we are centering the accent, so by adding 2*skew to the left,
	    // we shift it to the right by 1*skew.
	    accentBody.children[1].style.marginLeft = 2 * skew + "em";
	
	    var accentWrap = makeSpan(["mord", "accent"], [accentBody]);
	
	    if (supsubGroup) {
	        // Here, we replace the "base" child of the supsub with our newly
	        // generated accent.
	        supsubGroup.children[0] = accentWrap;
	
	        // Since we don't rerun the height calculation after replacing the
	        // accent, we manually recalculate height.
	        supsubGroup.height = Math.max(accentWrap.height, supsubGroup.height);
	
	        // Accents should always be ords, even when their innards are not.
	        supsubGroup.classes[0] = "mord";
	
	        return supsubGroup;
	    } else {
	        return accentWrap;
	    }
	};
	
	groupTypes.phantom = function(group, options, prev) {
	    var elements = buildExpression(
	        group.value.value,
	        options.withPhantom(),
	        prev
	    );
	
	    // \phantom isn't supposed to affect the elements it contains.
	    // See "color" for more details.
	    return new buildCommon.makeFragment(elements);
	};
	
	/**
	 * buildGroup is the function that takes a group and calls the correct groupType
	 * function for it. It also handles the interaction of size and style changes
	 * between parents and children.
	 */
	var buildGroup = function(group, options, prev) {
	    if (!group) {
	        return makeSpan();
	    }
	
	    if (groupTypes[group.type]) {
	        // Call the groupTypes function
	        var groupNode = groupTypes[group.type](group, options, prev);
	        var multiplier;
	
	        // If the style changed between the parent and the current group,
	        // account for the size difference
	        if (options.style !== options.parentStyle) {
	            multiplier = options.style.sizeMultiplier /
	                    options.parentStyle.sizeMultiplier;
	
	            groupNode.height *= multiplier;
	            groupNode.depth *= multiplier;
	        }
	
	        // If the size changed between the parent and the current group, account
	        // for that size difference.
	        if (options.size !== options.parentSize) {
	            multiplier = buildCommon.sizingMultiplier[options.size] /
	                    buildCommon.sizingMultiplier[options.parentSize];
	
	            groupNode.height *= multiplier;
	            groupNode.depth *= multiplier;
	        }
	
	        return groupNode;
	    } else {
	        throw new ParseError(
	            "Got group of unknown type: '" + group.type + "'");
	    }
	};
	
	/**
	 * Take an entire parse tree, and build it into an appropriate set of HTML
	 * nodes.
	 */
	var buildHTML = function(tree, options) {
	    // buildExpression is destructive, so we need to make a clone
	    // of the incoming tree so that it isn't accidentally changed
	    tree = JSON.parse(JSON.stringify(tree));
	
	    // Build the expression contained in the tree
	    var expression = buildExpression(tree, options);
	    var body = makeSpan(["base", options.style.cls()], expression);
	
	    // Add struts, which ensure that the top of the HTML element falls at the
	    // height of the expression, and the bottom of the HTML element falls at the
	    // depth of the expression.
	    var topStrut = makeSpan(["strut"]);
	    var bottomStrut = makeSpan(["strut", "bottom"]);
	
	    topStrut.style.height = body.height + "em";
	    bottomStrut.style.height = (body.height + body.depth) + "em";
	    // We'd like to use `vertical-align: top` but in IE 9 this lowers the
	    // baseline of the box to the bottom of this strut (instead staying in the
	    // normal place) so we use an absolute value for vertical-align instead
	    bottomStrut.style.verticalAlign = -body.depth + "em";
	
	    // Wrap the struts and body together
	    var htmlNode = makeSpan(["katex-html"], [topStrut, bottomStrut, body]);
	
	    htmlNode.setAttribute("aria-hidden", "true");
	
	    return htmlNode;
	};
	
	module.e = buildHTML;
	


/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This file converts a parse tree into a cooresponding MathML tree. The main
	 * entry point is the `buildMathML` function, which takes a parse tree from the
	 * parser.
	 */
	
	var buildCommon = __webpack_require__(240);
	var fontMetrics = __webpack_require__(184);
	var mathMLTree = __webpack_require__(1750);
	var ParseError = __webpack_require__(112);
	var symbols = __webpack_require__(241);
	var utils = __webpack_require__(97);
	
	var makeSpan = buildCommon.makeSpan;
	var fontMap = buildCommon.fontMap;
	
	/**
	 * Takes a symbol and converts it into a MathML text node after performing
	 * optional replacement from symbols.js.
	 */
	var makeText = function(text, mode) {
	    if (symbols[mode][text] && symbols[mode][text].replace) {
	        text = symbols[mode][text].replace;
	    }
	
	    return new mathMLTree.TextNode(text);
	};
	
	/**
	 * Returns the math variant as a string or null if none is required.
	 */
	var getVariant = function(group, options) {
	    var font = options.font;
	    if (!font) {
	        return null;
	    }
	
	    var mode = group.mode;
	    if (font === "mathit") {
	        return "italic";
	    }
	
	    var value = group.value;
	    if (utils.contains(["\\imath", "\\jmath"], value)) {
	        return null;
	    }
	
	    if (symbols[mode][value] && symbols[mode][value].replace) {
	        value = symbols[mode][value].replace;
	    }
	
	    var fontName = fontMap[font].fontName;
	    if (fontMetrics.getCharacterMetrics(value, fontName)) {
	        return fontMap[options.font].variant;
	    }
	
	    return null;
	};
	
	/**
	 * Functions for handling the different types of groups found in the parse
	 * tree. Each function should take a parse group and return a MathML node.
	 */
	var groupTypes = {};
	
	groupTypes.mathord = function(group, options) {
	    var node = new mathMLTree.MathNode(
	        "mi",
	        [makeText(group.value, group.mode)]);
	
	    var variant = getVariant(group, options);
	    if (variant) {
	        node.setAttribute("mathvariant", variant);
	    }
	    return node;
	};
	
	groupTypes.textord = function(group, options) {
	    var text = makeText(group.value, group.mode);
	
	    var variant = getVariant(group, options) || "normal";
	
	    var node;
	    if (/[0-9]/.test(group.value)) {
	        // TODO(kevinb) merge adjacent <mn> nodes
	        // do it as a post processing step
	        node = new mathMLTree.MathNode("mn", [text]);
	        if (options.font) {
	            node.setAttribute("mathvariant", variant);
	        }
	    } else {
	        node = new mathMLTree.MathNode("mi", [text]);
	        node.setAttribute("mathvariant", variant);
	    }
	
	    return node;
	};
	
	groupTypes.bin = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mo", [makeText(group.value, group.mode)]);
	
	    return node;
	};
	
	groupTypes.rel = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mo", [makeText(group.value, group.mode)]);
	
	    return node;
	};
	
	groupTypes.open = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mo", [makeText(group.value, group.mode)]);
	
	    return node;
	};
	
	groupTypes.close = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mo", [makeText(group.value, group.mode)]);
	
	    return node;
	};
	
	groupTypes.inner = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mo", [makeText(group.value, group.mode)]);
	
	    return node;
	};
	
	groupTypes.punct = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mo", [makeText(group.value, group.mode)]);
	
	    node.setAttribute("separator", "true");
	
	    return node;
	};
	
	groupTypes.ordgroup = function(group, options) {
	    var inner = buildExpression(group.value, options);
	
	    var node = new mathMLTree.MathNode("mrow", inner);
	
	    return node;
	};
	
	groupTypes.text = function(group, options) {
	    var inner = buildExpression(group.value.body, options);
	
	    var node = new mathMLTree.MathNode("mtext", inner);
	
	    return node;
	};
	
	groupTypes.color = function(group, options) {
	    var inner = buildExpression(group.value.value, options);
	
	    var node = new mathMLTree.MathNode("mstyle", inner);
	
	    node.setAttribute("mathcolor", group.value.color);
	
	    return node;
	};
	
	groupTypes.supsub = function(group, options) {
	    var children = [buildGroup(group.value.base, options)];
	
	    if (group.value.sub) {
	        children.push(buildGroup(group.value.sub, options));
	    }
	
	    if (group.value.sup) {
	        children.push(buildGroup(group.value.sup, options));
	    }
	
	    var nodeType;
	    if (!group.value.sub) {
	        nodeType = "msup";
	    } else if (!group.value.sup) {
	        nodeType = "msub";
	    } else {
	        nodeType = "msubsup";
	    }
	
	    var node = new mathMLTree.MathNode(nodeType, children);
	
	    return node;
	};
	
	groupTypes.genfrac = function(group, options) {
	    var node = new mathMLTree.MathNode(
	        "mfrac",
	        [buildGroup(group.value.numer, options),
	         buildGroup(group.value.denom, options)]);
	
	    if (!group.value.hasBarLine) {
	        node.setAttribute("linethickness", "0px");
	    }
	
	    if (group.value.leftDelim != null || group.value.rightDelim != null) {
	        var withDelims = [];
	
	        if (group.value.leftDelim != null) {
	            var leftOp = new mathMLTree.MathNode(
	                "mo", [new mathMLTree.TextNode(group.value.leftDelim)]);
	
	            leftOp.setAttribute("fence", "true");
	
	            withDelims.push(leftOp);
	        }
	
	        withDelims.push(node);
	
	        if (group.value.rightDelim != null) {
	            var rightOp = new mathMLTree.MathNode(
	                "mo", [new mathMLTree.TextNode(group.value.rightDelim)]);
	
	            rightOp.setAttribute("fence", "true");
	
	            withDelims.push(rightOp);
	        }
	
	        var outerNode = new mathMLTree.MathNode("mrow", withDelims);
	
	        return outerNode;
	    }
	
	    return node;
	};
	
	groupTypes.array = function(group, options) {
	    return new mathMLTree.MathNode(
	        "mtable", group.value.body.map(function(row) {
	            return new mathMLTree.MathNode(
	                "mtr", row.map(function(cell) {
	                    return new mathMLTree.MathNode(
	                        "mtd", [buildGroup(cell, options)]);
	                }));
	        }));
	};
	
	groupTypes.sqrt = function(group, options) {
	    var node;
	    if (group.value.index) {
	        node = new mathMLTree.MathNode(
	            "mroot", [
	                buildGroup(group.value.body, options),
	                buildGroup(group.value.index, options),
	            ]);
	    } else {
	        node = new mathMLTree.MathNode(
	            "msqrt", [buildGroup(group.value.body, options)]);
	    }
	
	    return node;
	};
	
	groupTypes.leftright = function(group, options) {
	    var inner = buildExpression(group.value.body, options);
	
	    if (group.value.left !== ".") {
	        var leftNode = new mathMLTree.MathNode(
	            "mo", [makeText(group.value.left, group.mode)]);
	
	        leftNode.setAttribute("fence", "true");
	
	        inner.unshift(leftNode);
	    }
	
	    if (group.value.right !== ".") {
	        var rightNode = new mathMLTree.MathNode(
	            "mo", [makeText(group.value.right, group.mode)]);
	
	        rightNode.setAttribute("fence", "true");
	
	        inner.push(rightNode);
	    }
	
	    var outerNode = new mathMLTree.MathNode("mrow", inner);
	
	    return outerNode;
	};
	
	groupTypes.accent = function(group, options) {
	    var accentNode = new mathMLTree.MathNode(
	        "mo", [makeText(group.value.accent, group.mode)]);
	
	    var node = new mathMLTree.MathNode(
	        "mover",
	        [buildGroup(group.value.base, options),
	         accentNode]);
	
	    node.setAttribute("accent", "true");
	
	    return node;
	};
	
	groupTypes.spacing = function(group) {
	    var node;
	
	    if (group.value === "\\ " || group.value === "\\space" ||
	        group.value === " " || group.value === "~") {
	        node = new mathMLTree.MathNode(
	            "mtext", [new mathMLTree.TextNode("\u00a0")]);
	    } else {
	        node = new mathMLTree.MathNode("mspace");
	
	        node.setAttribute(
	            "width", buildCommon.spacingFunctions[group.value].size);
	    }
	
	    return node;
	};
	
	groupTypes.op = function(group) {
	    var node;
	
	    // TODO(emily): handle big operators using the `largeop` attribute
	
	    if (group.value.symbol) {
	        // This is a symbol. Just add the symbol.
	        node = new mathMLTree.MathNode(
	            "mo", [makeText(group.value.body, group.mode)]);
	    } else {
	        // This is a text operator. Add all of the characters from the
	        // operator's name.
	        // TODO(emily): Add a space in the middle of some of these
	        // operators, like \limsup.
	        node = new mathMLTree.MathNode(
	            "mi", [new mathMLTree.TextNode(group.value.body.slice(1))]);
	    }
	
	    return node;
	};
	
	groupTypes.katex = function(group) {
	    var node = new mathMLTree.MathNode(
	        "mtext", [new mathMLTree.TextNode("KaTeX")]);
	
	    return node;
	};
	
	groupTypes.font = function(group, options) {
	    var font = group.value.font;
	    return buildGroup(group.value.body, options.withFont(font));
	};
	
	groupTypes.delimsizing = function(group) {
	    var children = [];
	
	    if (group.value.value !== ".") {
	        children.push(makeText(group.value.value, group.mode));
	    }
	
	    var node = new mathMLTree.MathNode("mo", children);
	
	    if (group.value.delimType === "open" ||
	        group.value.delimType === "close") {
	        // Only some of the delimsizing functions act as fences, and they
	        // return "open" or "close" delimTypes.
	        node.setAttribute("fence", "true");
	    } else {
	        // Explicitly disable fencing if it's not a fence, to override the
	        // defaults.
	        node.setAttribute("fence", "false");
	    }
	
	    return node;
	};
	
	groupTypes.styling = function(group, options) {
	    var inner = buildExpression(group.value.value, options);
	
	    var node = new mathMLTree.MathNode("mstyle", inner);
	
	    var styleAttributes = {
	        "display": ["0", "true"],
	        "text": ["0", "false"],
	        "script": ["1", "false"],
	        "scriptscript": ["2", "false"],
	    };
	
	    var attr = styleAttributes[group.value.style];
	
	    node.setAttribute("scriptlevel", attr[0]);
	    node.setAttribute("displaystyle", attr[1]);
	
	    return node;
	};
	
	groupTypes.sizing = function(group, options) {
	    var inner = buildExpression(group.value.value, options);
	
	    var node = new mathMLTree.MathNode("mstyle", inner);
	
	    // TODO(emily): This doesn't produce the correct size for nested size
	    // changes, because we don't keep state of what style we're currently
	    // in, so we can't reset the size to normal before changing it.  Now
	    // that we're passing an options parameter we should be able to fix
	    // this.
	    node.setAttribute(
	        "mathsize", buildCommon.sizingMultiplier[group.value.size] + "em");
	
	    return node;
	};
	
	groupTypes.overline = function(group, options) {
	    var operator = new mathMLTree.MathNode(
	        "mo", [new mathMLTree.TextNode("\u203e")]);
	    operator.setAttribute("stretchy", "true");
	
	    var node = new mathMLTree.MathNode(
	        "mover",
	        [buildGroup(group.value.body, options),
	         operator]);
	    node.setAttribute("accent", "true");
	
	    return node;
	};
	
	groupTypes.rule = function(group) {
	    // TODO(emily): Figure out if there's an actual way to draw black boxes
	    // in MathML.
	    var node = new mathMLTree.MathNode("mrow");
	
	    return node;
	};
	
	groupTypes.llap = function(group, options) {
	    var node = new mathMLTree.MathNode(
	        "mpadded", [buildGroup(group.value.body, options)]);
	
	    node.setAttribute("lspace", "-1width");
	    node.setAttribute("width", "0px");
	
	    return node;
	};
	
	groupTypes.rlap = function(group, options) {
	    var node = new mathMLTree.MathNode(
	        "mpadded", [buildGroup(group.value.body, options)]);
	
	    node.setAttribute("width", "0px");
	
	    return node;
	};
	
	groupTypes.phantom = function(group, options, prev) {
	    var inner = buildExpression(group.value.value, options);
	    return new mathMLTree.MathNode("mphantom", inner);
	};
	
	/**
	 * Takes a list of nodes, builds them, and returns a list of the generated
	 * MathML nodes. A little simpler than the HTML version because we don't do any
	 * previous-node handling.
	 */
	var buildExpression = function(expression, options) {
	    var groups = [];
	    for (var i = 0; i < expression.length; i++) {
	        var group = expression[i];
	        groups.push(buildGroup(group, options));
	    }
	    return groups;
	};
	
	/**
	 * Takes a group from the parser and calls the appropriate groupTypes function
	 * on it to produce a MathML node.
	 */
	var buildGroup = function(group, options) {
	    if (!group) {
	        return new mathMLTree.MathNode("mrow");
	    }
	
	    if (groupTypes[group.type]) {
	        // Call the groupTypes function
	        return groupTypes[group.type](group, options);
	    } else {
	        throw new ParseError(
	            "Got group of unknown type: '" + group.type + "'");
	    }
	};
	
	/**
	 * Takes a full parse tree and settings and builds a MathML representation of
	 * it. In particular, we put the elements from building the parse tree into a
	 * <semantics> tag so we can also include that TeX source as an annotation.
	 *
	 * Note that we actually return a domTree element with a `<math>` inside it so
	 * we can do appropriate styling.
	 */
	var buildMathML = function(tree, texExpression, options) {
	    var expression = buildExpression(tree, options);
	
	    // Wrap up the expression in an mrow so it is presented in the semantics
	    // tag correctly.
	    var wrapper = new mathMLTree.MathNode("mrow", expression);
	
	    // Build a TeX annotation of the source
	    var annotation = new mathMLTree.MathNode(
	        "annotation", [new mathMLTree.TextNode(texExpression)]);
	
	    annotation.setAttribute("encoding", "application/x-tex");
	
	    var semantics = new mathMLTree.MathNode(
	        "semantics", [wrapper, annotation]);
	
	    var math = new mathMLTree.MathNode("math", [semantics]);
	
	    // You can't style <math> nodes, so we wrap the node in a span.
	    return makeSpan(["katex-mathml"], [math]);
	};
	
	module.e = buildMathML;
	


/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var buildHTML = __webpack_require__(1743);
	var buildMathML = __webpack_require__(1744);
	var buildCommon = __webpack_require__(240);
	var Options = __webpack_require__(1741);
	var Settings = __webpack_require__(624);
	var Style = __webpack_require__(239);
	
	var makeSpan = buildCommon.makeSpan;
	
	var buildTree = function(tree, expression, settings) {
	    settings = settings || new Settings({});
	
	    var startStyle = Style.TEXT;
	    if (settings.displayMode) {
	        startStyle = Style.DISPLAY;
	    }
	
	    // Setup the default options
	    var options = new Options({
	        style: startStyle,
	        size: "size5",
	    });
	
	    // `buildHTML` sometimes messes with the parse tree (like turning bins ->
	    // ords), so we build the MathML version first.
	    var mathMLNode = buildMathML(tree, expression, options);
	    var htmlNode = buildHTML(tree, options);
	
	    var katexNode = makeSpan(["katex"], [
	        mathMLNode, htmlNode,
	    ]);
	
	    if (settings.displayMode) {
	        return makeSpan(["katex-display"], [katexNode]);
	    } else {
	        return katexNode;
	    }
	};
	
	module.e = buildTree;
	


/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * This file deals with creating delimiters of various sizes. The TeXbook
	 * discusses these routines on page 441-442, in the "Another subroutine sets box
	 * x to a specified variable delimiter" paragraph.
	 *
	 * There are three main routines here. `makeSmallDelim` makes a delimiter in the
	 * normal font, but in either text, script, or scriptscript style.
	 * `makeLargeDelim` makes a delimiter in textstyle, but in one of the Size1,
	 * Size2, Size3, or Size4 fonts. `makeStackedDelim` makes a delimiter out of
	 * smaller pieces that are stacked on top of one another.
	 *
	 * The functions take a parameter `center`, which determines if the delimiter
	 * should be centered around the axis.
	 *
	 * Then, there are three exposed functions. `sizedDelim` makes a delimiter in
	 * one of the given sizes. This is used for things like `\bigl`.
	 * `customSizedDelim` makes a delimiter with a given total height+depth. It is
	 * called in places like `\sqrt`. `leftRightDelim` makes an appropriate
	 * delimiter which surrounds an expression of a given height an depth. It is
	 * used in `\left` and `\right`.
	 */
	
	var ParseError = __webpack_require__(112);
	var Style = __webpack_require__(239);
	
	var buildCommon = __webpack_require__(240);
	var fontMetrics = __webpack_require__(184);
	var symbols = __webpack_require__(241);
	var utils = __webpack_require__(97);
	
	var makeSpan = buildCommon.makeSpan;
	
	/**
	 * Get the metrics for a given symbol and font, after transformation (i.e.
	 * after following replacement from symbols.js)
	 */
	var getMetrics = function(symbol, font) {
	    if (symbols.math[symbol] && symbols.math[symbol].replace) {
	        return fontMetrics.getCharacterMetrics(
	            symbols.math[symbol].replace, font);
	    } else {
	        return fontMetrics.getCharacterMetrics(
	            symbol, font);
	    }
	};
	
	/**
	 * Builds a symbol in the given font size (note size is an integer)
	 */
	var mathrmSize = function(value, size, mode) {
	    return buildCommon.makeSymbol(value, "Size" + size + "-Regular", mode);
	};
	
	/**
	 * Puts a delimiter span in a given style, and adds appropriate height, depth,
	 * and maxFontSizes.
	 */
	var styleWrap = function(delim, toStyle, options) {
	    var span = makeSpan(
	        ["style-wrap", options.style.reset(), toStyle.cls()], [delim]);
	
	    var multiplier = toStyle.sizeMultiplier / options.style.sizeMultiplier;
	
	    span.height *= multiplier;
	    span.depth *= multiplier;
	    span.maxFontSize = toStyle.sizeMultiplier;
	
	    return span;
	};
	
	/**
	 * Makes a small delimiter. This is a delimiter that comes in the Main-Regular
	 * font, but is restyled to either be in textstyle, scriptstyle, or
	 * scriptscriptstyle.
	 */
	var makeSmallDelim = function(delim, style, center, options, mode) {
	    var text = buildCommon.makeSymbol(delim, "Main-Regular", mode);
	
	    var span = styleWrap(text, style, options);
	
	    if (center) {
	        var shift =
	            (1 - options.style.sizeMultiplier / style.sizeMultiplier) *
	            fontMetrics.metrics.axisHeight;
	
	        span.style.top = shift + "em";
	        span.height -= shift;
	        span.depth += shift;
	    }
	
	    return span;
	};
	
	/**
	 * Makes a large delimiter. This is a delimiter that comes in the Size1, Size2,
	 * Size3, or Size4 fonts. It is always rendered in textstyle.
	 */
	var makeLargeDelim = function(delim, size, center, options, mode) {
	    var inner = mathrmSize(delim, size, mode);
	
	    var span = styleWrap(
	        makeSpan(["delimsizing", "size" + size],
	                 [inner], options.getColor()),
	        Style.TEXT, options);
	
	    if (center) {
	        var shift = (1 - options.style.sizeMultiplier) *
	            fontMetrics.metrics.axisHeight;
	
	        span.style.top = shift + "em";
	        span.height -= shift;
	        span.depth += shift;
	    }
	
	    return span;
	};
	
	/**
	 * Make an inner span with the given offset and in the given font. This is used
	 * in `makeStackedDelim` to make the stacking pieces for the delimiter.
	 */
	var makeInner = function(symbol, font, mode) {
	    var sizeClass;
	    // Apply the correct CSS class to choose the right font.
	    if (font === "Size1-Regular") {
	        sizeClass = "delim-size1";
	    } else if (font === "Size4-Regular") {
	        sizeClass = "delim-size4";
	    }
	
	    var inner = makeSpan(
	        ["delimsizinginner", sizeClass],
	        [makeSpan([], [buildCommon.makeSymbol(symbol, font, mode)])]);
	
	    // Since this will be passed into `makeVList` in the end, wrap the element
	    // in the appropriate tag that VList uses.
	    return {type: "elem", elem: inner};
	};
	
	/**
	 * Make a stacked delimiter out of a given delimiter, with the total height at
	 * least `heightTotal`. This routine is mentioned on page 442 of the TeXbook.
	 */
	var makeStackedDelim = function(delim, heightTotal, center, options, mode) {
	    // There are four parts, the top, an optional middle, a repeated part, and a
	    // bottom.
	    var top;
	    var middle;
	    var repeat;
	    var bottom;
	    top = repeat = bottom = delim;
	    middle = null;
	    // Also keep track of what font the delimiters are in
	    var font = "Size1-Regular";
	
	    // We set the parts and font based on the symbol. Note that we use
	    // '\u23d0' instead of '|' and '\u2016' instead of '\\|' for the
	    // repeats of the arrows
	    if (delim === "\\uparrow") {
	        repeat = bottom = "\u23d0";
	    } else if (delim === "\\Uparrow") {
	        repeat = bottom = "\u2016";
	    } else if (delim === "\\downarrow") {
	        top = repeat = "\u23d0";
	    } else if (delim === "\\Downarrow") {
	        top = repeat = "\u2016";
	    } else if (delim === "\\updownarrow") {
	        top = "\\uparrow";
	        repeat = "\u23d0";
	        bottom = "\\downarrow";
	    } else if (delim === "\\Updownarrow") {
	        top = "\\Uparrow";
	        repeat = "\u2016";
	        bottom = "\\Downarrow";
	    } else if (delim === "[" || delim === "\\lbrack") {
	        top = "\u23a1";
	        repeat = "\u23a2";
	        bottom = "\u23a3";
	        font = "Size4-Regular";
	    } else if (delim === "]" || delim === "\\rbrack") {
	        top = "\u23a4";
	        repeat = "\u23a5";
	        bottom = "\u23a6";
	        font = "Size4-Regular";
	    } else if (delim === "\\lfloor") {
	        repeat = top = "\u23a2";
	        bottom = "\u23a3";
	        font = "Size4-Regular";
	    } else if (delim === "\\lceil") {
	        top = "\u23a1";
	        repeat = bottom = "\u23a2";
	        font = "Size4-Regular";
	    } else if (delim === "\\rfloor") {
	        repeat = top = "\u23a5";
	        bottom = "\u23a6";
	        font = "Size4-Regular";
	    } else if (delim === "\\rceil") {
	        top = "\u23a4";
	        repeat = bottom = "\u23a5";
	        font = "Size4-Regular";
	    } else if (delim === "(") {
	        top = "\u239b";
	        repeat = "\u239c";
	        bottom = "\u239d";
	        font = "Size4-Regular";
	    } else if (delim === ")") {
	        top = "\u239e";
	        repeat = "\u239f";
	        bottom = "\u23a0";
	        font = "Size4-Regular";
	    } else if (delim === "\\{" || delim === "\\lbrace") {
	        top = "\u23a7";
	        middle = "\u23a8";
	        bottom = "\u23a9";
	        repeat = "\u23aa";
	        font = "Size4-Regular";
	    } else if (delim === "\\}" || delim === "\\rbrace") {
	        top = "\u23ab";
	        middle = "\u23ac";
	        bottom = "\u23ad";
	        repeat = "\u23aa";
	        font = "Size4-Regular";
	    } else if (delim === "\\lgroup") {
	        top = "\u23a7";
	        bottom = "\u23a9";
	        repeat = "\u23aa";
	        font = "Size4-Regular";
	    } else if (delim === "\\rgroup") {
	        top = "\u23ab";
	        bottom = "\u23ad";
	        repeat = "\u23aa";
	        font = "Size4-Regular";
	    } else if (delim === "\\lmoustache") {
	        top = "\u23a7";
	        bottom = "\u23ad";
	        repeat = "\u23aa";
	        font = "Size4-Regular";
	    } else if (delim === "\\rmoustache") {
	        top = "\u23ab";
	        bottom = "\u23a9";
	        repeat = "\u23aa";
	        font = "Size4-Regular";
	    } else if (delim === "\\surd") {
	        top = "\ue001";
	        bottom = "\u23b7";
	        repeat = "\ue000";
	        font = "Size4-Regular";
	    }
	
	    // Get the metrics of the four sections
	    var topMetrics = getMetrics(top, font);
	    var topHeightTotal = topMetrics.height + topMetrics.depth;
	    var repeatMetrics = getMetrics(repeat, font);
	    var repeatHeightTotal = repeatMetrics.height + repeatMetrics.depth;
	    var bottomMetrics = getMetrics(bottom, font);
	    var bottomHeightTotal = bottomMetrics.height + bottomMetrics.depth;
	    var middleHeightTotal = 0;
	    var middleFactor = 1;
	    if (middle !== null) {
	        var middleMetrics = getMetrics(middle, font);
	        middleHeightTotal = middleMetrics.height + middleMetrics.depth;
	        middleFactor = 2; // repeat symmetrically above and below middle
	    }
	
	    // Calcuate the minimal height that the delimiter can have.
	    // It is at least the size of the top, bottom, and optional middle combined.
	    var minHeight = topHeightTotal + bottomHeightTotal + middleHeightTotal;
	
	    // Compute the number of copies of the repeat symbol we will need
	    var repeatCount = Math.ceil(
	        (heightTotal - minHeight) / (middleFactor * repeatHeightTotal));
	
	    // Compute the total height of the delimiter including all the symbols
	    var realHeightTotal =
	        minHeight + repeatCount * middleFactor * repeatHeightTotal;
	
	    // The center of the delimiter is placed at the center of the axis. Note
	    // that in this context, "center" means that the delimiter should be
	    // centered around the axis in the current style, while normally it is
	    // centered around the axis in textstyle.
	    var axisHeight = fontMetrics.metrics.axisHeight;
	    if (center) {
	        axisHeight *= options.style.sizeMultiplier;
	    }
	    // Calculate the depth
	    var depth = realHeightTotal / 2 - axisHeight;
	
	    // Now, we start building the pieces that will go into the vlist
	
	    // Keep a list of the inner pieces
	    var inners = [];
	
	    // Add the bottom symbol
	    inners.push(makeInner(bottom, font, mode));
	
	    var i;
	    if (middle === null) {
	        // Add that many symbols
	        for (i = 0; i < repeatCount; i++) {
	            inners.push(makeInner(repeat, font, mode));
	        }
	    } else {
	        // When there is a middle bit, we need the middle part and two repeated
	        // sections
	        for (i = 0; i < repeatCount; i++) {
	            inners.push(makeInner(repeat, font, mode));
	        }
	        inners.push(makeInner(middle, font, mode));
	        for (i = 0; i < repeatCount; i++) {
	            inners.push(makeInner(repeat, font, mode));
	        }
	    }
	
	    // Add the top symbol
	    inners.push(makeInner(top, font, mode));
	
	    // Finally, build the vlist
	    var inner = buildCommon.makeVList(inners, "bottom", depth, options);
	
	    return styleWrap(
	        makeSpan(["delimsizing", "mult"], [inner], options.getColor()),
	        Style.TEXT, options);
	};
	
	// There are three kinds of delimiters, delimiters that stack when they become
	// too large
	var stackLargeDelimiters = [
	    "(", ")", "[", "\\lbrack", "]", "\\rbrack",
	    "\\{", "\\lbrace", "\\}", "\\rbrace",
	    "\\lfloor", "\\rfloor", "\\lceil", "\\rceil",
	    "\\surd",
	];
	
	// delimiters that always stack
	var stackAlwaysDelimiters = [
	    "\\uparrow", "\\downarrow", "\\updownarrow",
	    "\\Uparrow", "\\Downarrow", "\\Updownarrow",
	    "|", "\\|", "\\vert", "\\Vert",
	    "\\lvert", "\\rvert", "\\lVert", "\\rVert",
	    "\\lgroup", "\\rgroup", "\\lmoustache", "\\rmoustache",
	];
	
	// and delimiters that never stack
	var stackNeverDelimiters = [
	    "<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt",
	];
	
	// Metrics of the different sizes. Found by looking at TeX's output of
	// $\bigl| // \Bigl| \biggl| \Biggl| \showlists$
	// Used to create stacked delimiters of appropriate sizes in makeSizedDelim.
	var sizeToMaxHeight = [0, 1.2, 1.8, 2.4, 3.0];
	
	/**
	 * Used to create a delimiter of a specific size, where `size` is 1, 2, 3, or 4.
	 */
	var makeSizedDelim = function(delim, size, options, mode) {
	    // < and > turn into \langle and \rangle in delimiters
	    if (delim === "<" || delim === "\\lt") {
	        delim = "\\langle";
	    } else if (delim === ">" || delim === "\\gt") {
	        delim = "\\rangle";
	    }
	
	    // Sized delimiters are never centered.
	    if (utils.contains(stackLargeDelimiters, delim) ||
	        utils.contains(stackNeverDelimiters, delim)) {
	        return makeLargeDelim(delim, size, false, options, mode);
	    } else if (utils.contains(stackAlwaysDelimiters, delim)) {
	        return makeStackedDelim(
	            delim, sizeToMaxHeight[size], false, options, mode);
	    } else {
	        throw new ParseError("Illegal delimiter: '" + delim + "'");
	    }
	};
	
	/**
	 * There are three different sequences of delimiter sizes that the delimiters
	 * follow depending on the kind of delimiter. This is used when creating custom
	 * sized delimiters to decide whether to create a small, large, or stacked
	 * delimiter.
	 *
	 * In real TeX, these sequences aren't explicitly defined, but are instead
	 * defined inside the font metrics. Since there are only three sequences that
	 * are possible for the delimiters that TeX defines, it is easier to just encode
	 * them explicitly here.
	 */
	
	// Delimiters that never stack try small delimiters and large delimiters only
	var stackNeverDelimiterSequence = [
	    {type: "small", style: Style.SCRIPTSCRIPT},
	    {type: "small", style: Style.SCRIPT},
	    {type: "small", style: Style.TEXT},
	    {type: "large", size: 1},
	    {type: "large", size: 2},
	    {type: "large", size: 3},
	    {type: "large", size: 4},
	];
	
	// Delimiters that always stack try the small delimiters first, then stack
	var stackAlwaysDelimiterSequence = [
	    {type: "small", style: Style.SCRIPTSCRIPT},
	    {type: "small", style: Style.SCRIPT},
	    {type: "small", style: Style.TEXT},
	    {type: "stack"},
	];
	
	// Delimiters that stack when large try the small and then large delimiters, and
	// stack afterwards
	var stackLargeDelimiterSequence = [
	    {type: "small", style: Style.SCRIPTSCRIPT},
	    {type: "small", style: Style.SCRIPT},
	    {type: "small", style: Style.TEXT},
	    {type: "large", size: 1},
	    {type: "large", size: 2},
	    {type: "large", size: 3},
	    {type: "large", size: 4},
	    {type: "stack"},
	];
	
	/**
	 * Get the font used in a delimiter based on what kind of delimiter it is.
	 */
	var delimTypeToFont = function(type) {
	    if (type.type === "small") {
	        return "Main-Regular";
	    } else if (type.type === "large") {
	        return "Size" + type.size + "-Regular";
	    } else if (type.type === "stack") {
	        return "Size4-Regular";
	    }
	};
	
	/**
	 * Traverse a sequence of types of delimiters to decide what kind of delimiter
	 * should be used to create a delimiter of the given height+depth.
	 */
	var traverseSequence = function(delim, height, sequence, options) {
	    // Here, we choose the index we should start at in the sequences. In smaller
	    // sizes (which correspond to larger numbers in style.size) we start earlier
	    // in the sequence. Thus, scriptscript starts at index 3-3=0, script starts
	    // at index 3-2=1, text starts at 3-1=2, and display starts at min(2,3-0)=2
	    var start = Math.min(2, 3 - options.style.size);
	    for (var i = start; i < sequence.length; i++) {
	        if (sequence[i].type === "stack") {
	            // This is always the last delimiter, so we just break the loop now.
	            break;
	        }
	
	        var metrics = getMetrics(delim, delimTypeToFont(sequence[i]));
	        var heightDepth = metrics.height + metrics.depth;
	
	        // Small delimiters are scaled down versions of the same font, so we
	        // account for the style change size.
	
	        if (sequence[i].type === "small") {
	            heightDepth *= sequence[i].style.sizeMultiplier;
	        }
	
	        // Check if the delimiter at this size works for the given height.
	        if (heightDepth > height) {
	            return sequence[i];
	        }
	    }
	
	    // If we reached the end of the sequence, return the last sequence element.
	    return sequence[sequence.length - 1];
	};
	
	/**
	 * Make a delimiter of a given height+depth, with optional centering. Here, we
	 * traverse the sequences, and create a delimiter that the sequence tells us to.
	 */
	var makeCustomSizedDelim = function(delim, height, center, options, mode) {
	    if (delim === "<" || delim === "\\lt") {
	        delim = "\\langle";
	    } else if (delim === ">" || delim === "\\gt") {
	        delim = "\\rangle";
	    }
	
	    // Decide what sequence to use
	    var sequence;
	    if (utils.contains(stackNeverDelimiters, delim)) {
	        sequence = stackNeverDelimiterSequence;
	    } else if (utils.contains(stackLargeDelimiters, delim)) {
	        sequence = stackLargeDelimiterSequence;
	    } else {
	        sequence = stackAlwaysDelimiterSequence;
	    }
	
	    // Look through the sequence
	    var delimType = traverseSequence(delim, height, sequence, options);
	
	    // Depending on the sequence element we decided on, call the appropriate
	    // function.
	    if (delimType.type === "small") {
	        return makeSmallDelim(delim, delimType.style, center, options, mode);
	    } else if (delimType.type === "large") {
	        return makeLargeDelim(delim, delimType.size, center, options, mode);
	    } else if (delimType.type === "stack") {
	        return makeStackedDelim(delim, height, center, options, mode);
	    }
	};
	
	/**
	 * Make a delimiter for use with `\left` and `\right`, given a height and depth
	 * of an expression that the delimiters surround.
	 */
	var makeLeftRightDelim = function(delim, height, depth, options, mode) {
	    // We always center \left/\right delimiters, so the axis is always shifted
	    var axisHeight =
	        fontMetrics.metrics.axisHeight * options.style.sizeMultiplier;
	
	    // Taken from TeX source, tex.web, function make_left_right
	    var delimiterFactor = 901;
	    var delimiterExtend = 5.0 / fontMetrics.metrics.ptPerEm;
	
	    var maxDistFromAxis = Math.max(
	        height - axisHeight, depth + axisHeight);
	
	    var totalHeight = Math.max(
	        // In real TeX, calculations are done using integral values which are
	        // 65536 per pt, or 655360 per em. So, the division here truncates in
	        // TeX but doesn't here, producing different results. If we wanted to
	        // exactly match TeX's calculation, we could do
	        //   Math.floor(655360 * maxDistFromAxis / 500) *
	        //    delimiterFactor / 655360
	        // (To see the difference, compare
	        //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
	        // in TeX and KaTeX)
	        maxDistFromAxis / 500 * delimiterFactor,
	        2 * maxDistFromAxis - delimiterExtend);
	
	    // Finally, we defer to `makeCustomSizedDelim` with our calculated total
	    // height
	    return makeCustomSizedDelim(delim, totalHeight, true, options, mode);
	};
	
	module.e = {
	    sizedDelim: makeSizedDelim,
	    customSizedDelim: makeCustomSizedDelim,
	    leftRightDelim: makeLeftRightDelim,
	};
	


/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* eslint no-constant-condition:0 */
	var fontMetrics = __webpack_require__(184);
	var parseData = __webpack_require__(626);
	var ParseError = __webpack_require__(112);
	
	var ParseNode = parseData.ParseNode;
	
	/**
	 * Parse the body of the environment, with rows delimited by \\ and
	 * columns delimited by &, and create a nested list in row-major order
	 * with one group per cell.
	 */
	function parseArray(parser, result) {
	    var row = [];
	    var body = [row];
	    var rowGaps = [];
	    while (true) {
	        var cell = parser.parseExpression(false, null);
	        row.push(new ParseNode("ordgroup", cell, parser.mode));
	        var next = parser.nextToken.text;
	        if (next === "&") {
	            parser.consume();
	        } else if (next === "\\end") {
	            break;
	        } else if (next === "\\\\" || next === "\\cr") {
	            var cr = parser.parseFunction();
	            rowGaps.push(cr.value.size);
	            row = [];
	            body.push(row);
	        } else {
	            // TODO: Clean up the following hack once #385 got merged
	            var pos = Math.min(parser.pos + 1, parser.lexer._input.length);
	            throw new ParseError("Expected & or \\\\ or \\end",
	                                 parser.lexer, pos);
	        }
	    }
	    result.body = body;
	    result.rowGaps = rowGaps;
	    return new ParseNode(result.type, result, parser.mode);
	}
	
	/*
	 * An environment definition is very similar to a function definition:
	 * it is declared with a name or a list of names, a set of properties
	 * and a handler containing the actual implementation.
	 *
	 * The properties include:
	 *  - numArgs: The number of arguments after the \begin{name} function.
	 *  - argTypes: (optional) Just like for a function
	 *  - allowedInText: (optional) Whether or not the environment is allowed inside
	 *                   text mode (default false) (not enforced yet)
	 *  - numOptionalArgs: (optional) Just like for a function
	 * A bare number instead of that object indicates the numArgs value.
	 *
	 * The handler function will receive two arguments
	 *  - context: information and references provided by the parser
	 *  - args: an array of arguments passed to \begin{name}
	 * The context contains the following properties:
	 *  - envName: the name of the environment, one of the listed names.
	 *  - parser: the parser object
	 *  - lexer: the lexer object
	 *  - positions: the positions associated with these arguments from args.
	 * The handler must return a ParseResult.
	 */
	
	function defineEnvironment(names, props, handler) {
	    if (typeof names === "string") {
	        names = [names];
	    }
	    if (typeof props === "number") {
	        props = { numArgs: props };
	    }
	    // Set default values of environments
	    var data = {
	        numArgs: props.numArgs || 0,
	        argTypes: props.argTypes,
	        greediness: 1,
	        allowedInText: !!props.allowedInText,
	        numOptionalArgs: props.numOptionalArgs || 0,
	        handler: handler,
	    };
	    for (var i = 0; i < names.length; ++i) {
	        module.e[names[i]] = data;
	    }
	}
	
	// Arrays are part of LaTeX, defined in lttab.dtx so its documentation
	// is part of the source2e.pdf file of LaTeX2e source documentation.
	defineEnvironment("array", {
	    numArgs: 1,
	}, function(context, args) {
	    var colalign = args[0];
	    colalign = colalign.value.map ? colalign.value : [colalign];
	    var cols = colalign.map(function(node) {
	        var ca = node.value;
	        if ("lcr".indexOf(ca) !== -1) {
	            return {
	                type: "align",
	                align: ca,
	            };
	        } else if (ca === "|") {
	            return {
	                type: "separator",
	                separator: "|",
	            };
	        }
	        throw new ParseError(
	            "Unknown column alignment: " + node.value,
	            context.lexer, context.positions[1]);
	    });
	    var res = {
	        type: "array",
	        cols: cols,
	        hskipBeforeAndAfter: true, // \@preamble in lttab.dtx
	    };
	    res = parseArray(context.parser, res);
	    return res;
	});
	
	// The matrix environments of amsmath builds on the array environment
	// of LaTeX, which is discussed above.
	defineEnvironment([
	    "matrix",
	    "pmatrix",
	    "bmatrix",
	    "Bmatrix",
	    "vmatrix",
	    "Vmatrix",
	], {
	}, function(context) {
	    var delimiters = {
	        "matrix": null,
	        "pmatrix": ["(", ")"],
	        "bmatrix": ["[", "]"],
	        "Bmatrix": ["\\{", "\\}"],
	        "vmatrix": ["|", "|"],
	        "Vmatrix": ["\\Vert", "\\Vert"],
	    }[context.envName];
	    var res = {
	        type: "array",
	        hskipBeforeAndAfter: false, // \hskip -\arraycolsep in amsmath
	    };
	    res = parseArray(context.parser, res);
	    if (delimiters) {
	        res = new ParseNode("leftright", {
	            body: [res],
	            left: delimiters[0],
	            right: delimiters[1],
	        }, context.mode);
	    }
	    return res;
	});
	
	// A cases environment (in amsmath.sty) is almost equivalent to
	// \def\arraystretch{1.2}%
	// \left\{\begin{array}{@{}l@{\quad}l@{}} … \end{array}\right.
	defineEnvironment("cases", {
	}, function(context) {
	    var res = {
	        type: "array",
	        arraystretch: 1.2,
	        cols: [{
	            type: "align",
	            align: "l",
	            pregap: 0,
	            postgap: fontMetrics.metrics.quad,
	        }, {
	            type: "align",
	            align: "l",
	            pregap: 0,
	            postgap: 0,
	        }],
	    };
	    res = parseArray(context.parser, res);
	    res = new ParseNode("leftright", {
	        body: [res],
	        left: "\\{",
	        right: ".",
	    }, context.mode);
	    return res;
	});
	
	// An aligned environment is like the align* environment
	// except it operates within math mode.
	// Note that we assume \nomallineskiplimit to be zero,
	// so that \strut@ is the same as \strut.
	defineEnvironment("aligned", {
	}, function(context) {
	    var res = {
	        type: "array",
	        cols: [],
	    };
	    res = parseArray(context.parser, res);
	    var emptyGroup = new ParseNode("ordgroup", [], context.mode);
	    var numCols = 0;
	    res.value.body.forEach(function(row) {
	        var i;
	        for (i = 1; i < row.length; i += 2) {
	            row[i].value.unshift(emptyGroup);
	        }
	        if (numCols < row.length) {
	            numCols = row.length;
	        }
	    });
	    for (var i = 0; i < numCols; ++i) {
	        var align = "r";
	        var pregap = 0;
	        if (i % 2 === 1) {
	            align = "l";
	        } else if (i > 0) {
	            pregap = 2; // one \qquad between columns
	        }
	        res.value.cols[i] = {
	            type: "align",
	            align: align,
	            pregap: pregap,
	            postgap: 0,
	        };
	    }
	    return res;
	});
	


/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	module.e = {
	    "AMS-Regular": {
	        "65": [0, 0.68889, 0, 0],
	        "66": [0, 0.68889, 0, 0],
	        "67": [0, 0.68889, 0, 0],
	        "68": [0, 0.68889, 0, 0],
	        "69": [0, 0.68889, 0, 0],
	        "70": [0, 0.68889, 0, 0],
	        "71": [0, 0.68889, 0, 0],
	        "72": [0, 0.68889, 0, 0],
	        "73": [0, 0.68889, 0, 0],
	        "74": [0.16667, 0.68889, 0, 0],
	        "75": [0, 0.68889, 0, 0],
	        "76": [0, 0.68889, 0, 0],
	        "77": [0, 0.68889, 0, 0],
	        "78": [0, 0.68889, 0, 0],
	        "79": [0.16667, 0.68889, 0, 0],
	        "80": [0, 0.68889, 0, 0],
	        "81": [0.16667, 0.68889, 0, 0],
	        "82": [0, 0.68889, 0, 0],
	        "83": [0, 0.68889, 0, 0],
	        "84": [0, 0.68889, 0, 0],
	        "85": [0, 0.68889, 0, 0],
	        "86": [0, 0.68889, 0, 0],
	        "87": [0, 0.68889, 0, 0],
	        "88": [0, 0.68889, 0, 0],
	        "89": [0, 0.68889, 0, 0],
	        "90": [0, 0.68889, 0, 0],
	        "107": [0, 0.68889, 0, 0],
	        "165": [0, 0.675, 0.025, 0],
	        "174": [0.15559, 0.69224, 0, 0],
	        "240": [0, 0.68889, 0, 0],
	        "295": [0, 0.68889, 0, 0],
	        "710": [0, 0.825, 0, 0],
	        "732": [0, 0.9, 0, 0],
	        "770": [0, 0.825, 0, 0],
	        "771": [0, 0.9, 0, 0],
	        "989": [0.08167, 0.58167, 0, 0],
	        "1008": [0, 0.43056, 0.04028, 0],
	        "8245": [0, 0.54986, 0, 0],
	        "8463": [0, 0.68889, 0, 0],
	        "8487": [0, 0.68889, 0, 0],
	        "8498": [0, 0.68889, 0, 0],
	        "8502": [0, 0.68889, 0, 0],
	        "8503": [0, 0.68889, 0, 0],
	        "8504": [0, 0.68889, 0, 0],
	        "8513": [0, 0.68889, 0, 0],
	        "8592": [-0.03598, 0.46402, 0, 0],
	        "8594": [-0.03598, 0.46402, 0, 0],
	        "8602": [-0.13313, 0.36687, 0, 0],
	        "8603": [-0.13313, 0.36687, 0, 0],
	        "8606": [0.01354, 0.52239, 0, 0],
	        "8608": [0.01354, 0.52239, 0, 0],
	        "8610": [0.01354, 0.52239, 0, 0],
	        "8611": [0.01354, 0.52239, 0, 0],
	        "8619": [0, 0.54986, 0, 0],
	        "8620": [0, 0.54986, 0, 0],
	        "8621": [-0.13313, 0.37788, 0, 0],
	        "8622": [-0.13313, 0.36687, 0, 0],
	        "8624": [0, 0.69224, 0, 0],
	        "8625": [0, 0.69224, 0, 0],
	        "8630": [0, 0.43056, 0, 0],
	        "8631": [0, 0.43056, 0, 0],
	        "8634": [0.08198, 0.58198, 0, 0],
	        "8635": [0.08198, 0.58198, 0, 0],
	        "8638": [0.19444, 0.69224, 0, 0],
	        "8639": [0.19444, 0.69224, 0, 0],
	        "8642": [0.19444, 0.69224, 0, 0],
	        "8643": [0.19444, 0.69224, 0, 0],
	        "8644": [0.1808, 0.675, 0, 0],
	        "8646": [0.1808, 0.675, 0, 0],
	        "8647": [0.1808, 0.675, 0, 0],
	        "8648": [0.19444, 0.69224, 0, 0],
	        "8649": [0.1808, 0.675, 0, 0],
	        "8650": [0.19444, 0.69224, 0, 0],
	        "8651": [0.01354, 0.52239, 0, 0],
	        "8652": [0.01354, 0.52239, 0, 0],
	        "8653": [-0.13313, 0.36687, 0, 0],
	        "8654": [-0.13313, 0.36687, 0, 0],
	        "8655": [-0.13313, 0.36687, 0, 0],
	        "8666": [0.13667, 0.63667, 0, 0],
	        "8667": [0.13667, 0.63667, 0, 0],
	        "8669": [-0.13313, 0.37788, 0, 0],
	        "8672": [-0.064, 0.437, 0, 0],
	        "8674": [-0.064, 0.437, 0, 0],
	        "8705": [0, 0.825, 0, 0],
	        "8708": [0, 0.68889, 0, 0],
	        "8709": [0.08167, 0.58167, 0, 0],
	        "8717": [0, 0.43056, 0, 0],
	        "8722": [-0.03598, 0.46402, 0, 0],
	        "8724": [0.08198, 0.69224, 0, 0],
	        "8726": [0.08167, 0.58167, 0, 0],
	        "8733": [0, 0.69224, 0, 0],
	        "8736": [0, 0.69224, 0, 0],
	        "8737": [0, 0.69224, 0, 0],
	        "8738": [0.03517, 0.52239, 0, 0],
	        "8739": [0.08167, 0.58167, 0, 0],
	        "8740": [0.25142, 0.74111, 0, 0],
	        "8741": [0.08167, 0.58167, 0, 0],
	        "8742": [0.25142, 0.74111, 0, 0],
	        "8756": [0, 0.69224, 0, 0],
	        "8757": [0, 0.69224, 0, 0],
	        "8764": [-0.13313, 0.36687, 0, 0],
	        "8765": [-0.13313, 0.37788, 0, 0],
	        "8769": [-0.13313, 0.36687, 0, 0],
	        "8770": [-0.03625, 0.46375, 0, 0],
	        "8774": [0.30274, 0.79383, 0, 0],
	        "8776": [-0.01688, 0.48312, 0, 0],
	        "8778": [0.08167, 0.58167, 0, 0],
	        "8782": [0.06062, 0.54986, 0, 0],
	        "8783": [0.06062, 0.54986, 0, 0],
	        "8785": [0.08198, 0.58198, 0, 0],
	        "8786": [0.08198, 0.58198, 0, 0],
	        "8787": [0.08198, 0.58198, 0, 0],
	        "8790": [0, 0.69224, 0, 0],
	        "8791": [0.22958, 0.72958, 0, 0],
	        "8796": [0.08198, 0.91667, 0, 0],
	        "8806": [0.25583, 0.75583, 0, 0],
	        "8807": [0.25583, 0.75583, 0, 0],
	        "8808": [0.25142, 0.75726, 0, 0],
	        "8809": [0.25142, 0.75726, 0, 0],
	        "8812": [0.25583, 0.75583, 0, 0],
	        "8814": [0.20576, 0.70576, 0, 0],
	        "8815": [0.20576, 0.70576, 0, 0],
	        "8816": [0.30274, 0.79383, 0, 0],
	        "8817": [0.30274, 0.79383, 0, 0],
	        "8818": [0.22958, 0.72958, 0, 0],
	        "8819": [0.22958, 0.72958, 0, 0],
	        "8822": [0.1808, 0.675, 0, 0],
	        "8823": [0.1808, 0.675, 0, 0],
	        "8828": [0.13667, 0.63667, 0, 0],
	        "8829": [0.13667, 0.63667, 0, 0],
	        "8830": [0.22958, 0.72958, 0, 0],
	        "8831": [0.22958, 0.72958, 0, 0],
	        "8832": [0.20576, 0.70576, 0, 0],
	        "8833": [0.20576, 0.70576, 0, 0],
	        "8840": [0.30274, 0.79383, 0, 0],
	        "8841": [0.30274, 0.79383, 0, 0],
	        "8842": [0.13597, 0.63597, 0, 0],
	        "8843": [0.13597, 0.63597, 0, 0],
	        "8847": [0.03517, 0.54986, 0, 0],
	        "8848": [0.03517, 0.54986, 0, 0],
	        "8858": [0.08198, 0.58198, 0, 0],
	        "8859": [0.08198, 0.58198, 0, 0],
	        "8861": [0.08198, 0.58198, 0, 0],
	        "8862": [0, 0.675, 0, 0],
	        "8863": [0, 0.675, 0, 0],
	        "8864": [0, 0.675, 0, 0],
	        "8865": [0, 0.675, 0, 0],
	        "8872": [0, 0.69224, 0, 0],
	        "8873": [0, 0.69224, 0, 0],
	        "8874": [0, 0.69224, 0, 0],
	        "8876": [0, 0.68889, 0, 0],
	        "8877": [0, 0.68889, 0, 0],
	        "8878": [0, 0.68889, 0, 0],
	        "8879": [0, 0.68889, 0, 0],
	        "8882": [0.03517, 0.54986, 0, 0],
	        "8883": [0.03517, 0.54986, 0, 0],
	        "8884": [0.13667, 0.63667, 0, 0],
	        "8885": [0.13667, 0.63667, 0, 0],
	        "8888": [0, 0.54986, 0, 0],
	        "8890": [0.19444, 0.43056, 0, 0],
	        "8891": [0.19444, 0.69224, 0, 0],
	        "8892": [0.19444, 0.69224, 0, 0],
	        "8901": [0, 0.54986, 0, 0],
	        "8903": [0.08167, 0.58167, 0, 0],
	        "8905": [0.08167, 0.58167, 0, 0],
	        "8906": [0.08167, 0.58167, 0, 0],
	        "8907": [0, 0.69224, 0, 0],
	        "8908": [0, 0.69224, 0, 0],
	        "8909": [-0.03598, 0.46402, 0, 0],
	        "8910": [0, 0.54986, 0, 0],
	        "8911": [0, 0.54986, 0, 0],
	        "8912": [0.03517, 0.54986, 0, 0],
	        "8913": [0.03517, 0.54986, 0, 0],
	        "8914": [0, 0.54986, 0, 0],
	        "8915": [0, 0.54986, 0, 0],
	        "8916": [0, 0.69224, 0, 0],
	        "8918": [0.0391, 0.5391, 0, 0],
	        "8919": [0.0391, 0.5391, 0, 0],
	        "8920": [0.03517, 0.54986, 0, 0],
	        "8921": [0.03517, 0.54986, 0, 0],
	        "8922": [0.38569, 0.88569, 0, 0],
	        "8923": [0.38569, 0.88569, 0, 0],
	        "8926": [0.13667, 0.63667, 0, 0],
	        "8927": [0.13667, 0.63667, 0, 0],
	        "8928": [0.30274, 0.79383, 0, 0],
	        "8929": [0.30274, 0.79383, 0, 0],
	        "8934": [0.23222, 0.74111, 0, 0],
	        "8935": [0.23222, 0.74111, 0, 0],
	        "8936": [0.23222, 0.74111, 0, 0],
	        "8937": [0.23222, 0.74111, 0, 0],
	        "8938": [0.20576, 0.70576, 0, 0],
	        "8939": [0.20576, 0.70576, 0, 0],
	        "8940": [0.30274, 0.79383, 0, 0],
	        "8941": [0.30274, 0.79383, 0, 0],
	        "8994": [0.19444, 0.69224, 0, 0],
	        "8995": [0.19444, 0.69224, 0, 0],
	        "9416": [0.15559, 0.69224, 0, 0],
	        "9484": [0, 0.69224, 0, 0],
	        "9488": [0, 0.69224, 0, 0],
	        "9492": [0, 0.37788, 0, 0],
	        "9496": [0, 0.37788, 0, 0],
	        "9585": [0.19444, 0.68889, 0, 0],
	        "9586": [0.19444, 0.74111, 0, 0],
	        "9632": [0, 0.675, 0, 0],
	        "9633": [0, 0.675, 0, 0],
	        "9650": [0, 0.54986, 0, 0],
	        "9651": [0, 0.54986, 0, 0],
	        "9654": [0.03517, 0.54986, 0, 0],
	        "9660": [0, 0.54986, 0, 0],
	        "9661": [0, 0.54986, 0, 0],
	        "9664": [0.03517, 0.54986, 0, 0],
	        "9674": [0.11111, 0.69224, 0, 0],
	        "9733": [0.19444, 0.69224, 0, 0],
	        "10003": [0, 0.69224, 0, 0],
	        "10016": [0, 0.69224, 0, 0],
	        "10731": [0.11111, 0.69224, 0, 0],
	        "10846": [0.19444, 0.75583, 0, 0],
	        "10877": [0.13667, 0.63667, 0, 0],
	        "10878": [0.13667, 0.63667, 0, 0],
	        "10885": [0.25583, 0.75583, 0, 0],
	        "10886": [0.25583, 0.75583, 0, 0],
	        "10887": [0.13597, 0.63597, 0, 0],
	        "10888": [0.13597, 0.63597, 0, 0],
	        "10889": [0.26167, 0.75726, 0, 0],
	        "10890": [0.26167, 0.75726, 0, 0],
	        "10891": [0.48256, 0.98256, 0, 0],
	        "10892": [0.48256, 0.98256, 0, 0],
	        "10901": [0.13667, 0.63667, 0, 0],
	        "10902": [0.13667, 0.63667, 0, 0],
	        "10933": [0.25142, 0.75726, 0, 0],
	        "10934": [0.25142, 0.75726, 0, 0],
	        "10935": [0.26167, 0.75726, 0, 0],
	        "10936": [0.26167, 0.75726, 0, 0],
	        "10937": [0.26167, 0.75726, 0, 0],
	        "10938": [0.26167, 0.75726, 0, 0],
	        "10949": [0.25583, 0.75583, 0, 0],
	        "10950": [0.25583, 0.75583, 0, 0],
	        "10955": [0.28481, 0.79383, 0, 0],
	        "10956": [0.28481, 0.79383, 0, 0],
	        "57350": [0.08167, 0.58167, 0, 0],
	        "57351": [0.08167, 0.58167, 0, 0],
	        "57352": [0.08167, 0.58167, 0, 0],
	        "57353": [0, 0.43056, 0.04028, 0],
	        "57356": [0.25142, 0.75726, 0, 0],
	        "57357": [0.25142, 0.75726, 0, 0],
	        "57358": [0.41951, 0.91951, 0, 0],
	        "57359": [0.30274, 0.79383, 0, 0],
	        "57360": [0.30274, 0.79383, 0, 0],
	        "57361": [0.41951, 0.91951, 0, 0],
	        "57366": [0.25142, 0.75726, 0, 0],
	        "57367": [0.25142, 0.75726, 0, 0],
	        "57368": [0.25142, 0.75726, 0, 0],
	        "57369": [0.25142, 0.75726, 0, 0],
	        "57370": [0.13597, 0.63597, 0, 0],
	        "57371": [0.13597, 0.63597, 0, 0],
	    },
	    "Caligraphic-Regular": {
	        "48": [0, 0.43056, 0, 0],
	        "49": [0, 0.43056, 0, 0],
	        "50": [0, 0.43056, 0, 0],
	        "51": [0.19444, 0.43056, 0, 0],
	        "52": [0.19444, 0.43056, 0, 0],
	        "53": [0.19444, 0.43056, 0, 0],
	        "54": [0, 0.64444, 0, 0],
	        "55": [0.19444, 0.43056, 0, 0],
	        "56": [0, 0.64444, 0, 0],
	        "57": [0.19444, 0.43056, 0, 0],
	        "65": [0, 0.68333, 0, 0.19445],
	        "66": [0, 0.68333, 0.03041, 0.13889],
	        "67": [0, 0.68333, 0.05834, 0.13889],
	        "68": [0, 0.68333, 0.02778, 0.08334],
	        "69": [0, 0.68333, 0.08944, 0.11111],
	        "70": [0, 0.68333, 0.09931, 0.11111],
	        "71": [0.09722, 0.68333, 0.0593, 0.11111],
	        "72": [0, 0.68333, 0.00965, 0.11111],
	        "73": [0, 0.68333, 0.07382, 0],
	        "74": [0.09722, 0.68333, 0.18472, 0.16667],
	        "75": [0, 0.68333, 0.01445, 0.05556],
	        "76": [0, 0.68333, 0, 0.13889],
	        "77": [0, 0.68333, 0, 0.13889],
	        "78": [0, 0.68333, 0.14736, 0.08334],
	        "79": [0, 0.68333, 0.02778, 0.11111],
	        "80": [0, 0.68333, 0.08222, 0.08334],
	        "81": [0.09722, 0.68333, 0, 0.11111],
	        "82": [0, 0.68333, 0, 0.08334],
	        "83": [0, 0.68333, 0.075, 0.13889],
	        "84": [0, 0.68333, 0.25417, 0],
	        "85": [0, 0.68333, 0.09931, 0.08334],
	        "86": [0, 0.68333, 0.08222, 0],
	        "87": [0, 0.68333, 0.08222, 0.08334],
	        "88": [0, 0.68333, 0.14643, 0.13889],
	        "89": [0.09722, 0.68333, 0.08222, 0.08334],
	        "90": [0, 0.68333, 0.07944, 0.13889],
	    },
	    "Fraktur-Regular": {
	        "33": [0, 0.69141, 0, 0],
	        "34": [0, 0.69141, 0, 0],
	        "38": [0, 0.69141, 0, 0],
	        "39": [0, 0.69141, 0, 0],
	        "40": [0.24982, 0.74947, 0, 0],
	        "41": [0.24982, 0.74947, 0, 0],
	        "42": [0, 0.62119, 0, 0],
	        "43": [0.08319, 0.58283, 0, 0],
	        "44": [0, 0.10803, 0, 0],
	        "45": [0.08319, 0.58283, 0, 0],
	        "46": [0, 0.10803, 0, 0],
	        "47": [0.24982, 0.74947, 0, 0],
	        "48": [0, 0.47534, 0, 0],
	        "49": [0, 0.47534, 0, 0],
	        "50": [0, 0.47534, 0, 0],
	        "51": [0.18906, 0.47534, 0, 0],
	        "52": [0.18906, 0.47534, 0, 0],
	        "53": [0.18906, 0.47534, 0, 0],
	        "54": [0, 0.69141, 0, 0],
	        "55": [0.18906, 0.47534, 0, 0],
	        "56": [0, 0.69141, 0, 0],
	        "57": [0.18906, 0.47534, 0, 0],
	        "58": [0, 0.47534, 0, 0],
	        "59": [0.12604, 0.47534, 0, 0],
	        "61": [-0.13099, 0.36866, 0, 0],
	        "63": [0, 0.69141, 0, 0],
	        "65": [0, 0.69141, 0, 0],
	        "66": [0, 0.69141, 0, 0],
	        "67": [0, 0.69141, 0, 0],
	        "68": [0, 0.69141, 0, 0],
	        "69": [0, 0.69141, 0, 0],
	        "70": [0.12604, 0.69141, 0, 0],
	        "71": [0, 0.69141, 0, 0],
	        "72": [0.06302, 0.69141, 0, 0],
	        "73": [0, 0.69141, 0, 0],
	        "74": [0.12604, 0.69141, 0, 0],
	        "75": [0, 0.69141, 0, 0],
	        "76": [0, 0.69141, 0, 0],
	        "77": [0, 0.69141, 0, 0],
	        "78": [0, 0.69141, 0, 0],
	        "79": [0, 0.69141, 0, 0],
	        "80": [0.18906, 0.69141, 0, 0],
	        "81": [0.03781, 0.69141, 0, 0],
	        "82": [0, 0.69141, 0, 0],
	        "83": [0, 0.69141, 0, 0],
	        "84": [0, 0.69141, 0, 0],
	        "85": [0, 0.69141, 0, 0],
	        "86": [0, 0.69141, 0, 0],
	        "87": [0, 0.69141, 0, 0],
	        "88": [0, 0.69141, 0, 0],
	        "89": [0.18906, 0.69141, 0, 0],
	        "90": [0.12604, 0.69141, 0, 0],
	        "91": [0.24982, 0.74947, 0, 0],
	        "93": [0.24982, 0.74947, 0, 0],
	        "94": [0, 0.69141, 0, 0],
	        "97": [0, 0.47534, 0, 0],
	        "98": [0, 0.69141, 0, 0],
	        "99": [0, 0.47534, 0, 0],
	        "100": [0, 0.62119, 0, 0],
	        "101": [0, 0.47534, 0, 0],
	        "102": [0.18906, 0.69141, 0, 0],
	        "103": [0.18906, 0.47534, 0, 0],
	        "104": [0.18906, 0.69141, 0, 0],
	        "105": [0, 0.69141, 0, 0],
	        "106": [0, 0.69141, 0, 0],
	        "107": [0, 0.69141, 0, 0],
	        "108": [0, 0.69141, 0, 0],
	        "109": [0, 0.47534, 0, 0],
	        "110": [0, 0.47534, 0, 0],
	        "111": [0, 0.47534, 0, 0],
	        "112": [0.18906, 0.52396, 0, 0],
	        "113": [0.18906, 0.47534, 0, 0],
	        "114": [0, 0.47534, 0, 0],
	        "115": [0, 0.47534, 0, 0],
	        "116": [0, 0.62119, 0, 0],
	        "117": [0, 0.47534, 0, 0],
	        "118": [0, 0.52396, 0, 0],
	        "119": [0, 0.52396, 0, 0],
	        "120": [0.18906, 0.47534, 0, 0],
	        "121": [0.18906, 0.47534, 0, 0],
	        "122": [0.18906, 0.47534, 0, 0],
	        "8216": [0, 0.69141, 0, 0],
	        "8217": [0, 0.69141, 0, 0],
	        "58112": [0, 0.62119, 0, 0],
	        "58113": [0, 0.62119, 0, 0],
	        "58114": [0.18906, 0.69141, 0, 0],
	        "58115": [0.18906, 0.69141, 0, 0],
	        "58116": [0.18906, 0.47534, 0, 0],
	        "58117": [0, 0.69141, 0, 0],
	        "58118": [0, 0.62119, 0, 0],
	        "58119": [0, 0.47534, 0, 0],
	    },
	    "Main-Bold": {
	        "33": [0, 0.69444, 0, 0],
	        "34": [0, 0.69444, 0, 0],
	        "35": [0.19444, 0.69444, 0, 0],
	        "36": [0.05556, 0.75, 0, 0],
	        "37": [0.05556, 0.75, 0, 0],
	        "38": [0, 0.69444, 0, 0],
	        "39": [0, 0.69444, 0, 0],
	        "40": [0.25, 0.75, 0, 0],
	        "41": [0.25, 0.75, 0, 0],
	        "42": [0, 0.75, 0, 0],
	        "43": [0.13333, 0.63333, 0, 0],
	        "44": [0.19444, 0.15556, 0, 0],
	        "45": [0, 0.44444, 0, 0],
	        "46": [0, 0.15556, 0, 0],
	        "47": [0.25, 0.75, 0, 0],
	        "48": [0, 0.64444, 0, 0],
	        "49": [0, 0.64444, 0, 0],
	        "50": [0, 0.64444, 0, 0],
	        "51": [0, 0.64444, 0, 0],
	        "52": [0, 0.64444, 0, 0],
	        "53": [0, 0.64444, 0, 0],
	        "54": [0, 0.64444, 0, 0],
	        "55": [0, 0.64444, 0, 0],
	        "56": [0, 0.64444, 0, 0],
	        "57": [0, 0.64444, 0, 0],
	        "58": [0, 0.44444, 0, 0],
	        "59": [0.19444, 0.44444, 0, 0],
	        "60": [0.08556, 0.58556, 0, 0],
	        "61": [-0.10889, 0.39111, 0, 0],
	        "62": [0.08556, 0.58556, 0, 0],
	        "63": [0, 0.69444, 0, 0],
	        "64": [0, 0.69444, 0, 0],
	        "65": [0, 0.68611, 0, 0],
	        "66": [0, 0.68611, 0, 0],
	        "67": [0, 0.68611, 0, 0],
	        "68": [0, 0.68611, 0, 0],
	        "69": [0, 0.68611, 0, 0],
	        "70": [0, 0.68611, 0, 0],
	        "71": [0, 0.68611, 0, 0],
	        "72": [0, 0.68611, 0, 0],
	        "73": [0, 0.68611, 0, 0],
	        "74": [0, 0.68611, 0, 0],
	        "75": [0, 0.68611, 0, 0],
	        "76": [0, 0.68611, 0, 0],
	        "77": [0, 0.68611, 0, 0],
	        "78": [0, 0.68611, 0, 0],
	        "79": [0, 0.68611, 0, 0],
	        "80": [0, 0.68611, 0, 0],
	        "81": [0.19444, 0.68611, 0, 0],
	        "82": [0, 0.68611, 0, 0],
	        "83": [0, 0.68611, 0, 0],
	        "84": [0, 0.68611, 0, 0],
	        "85": [0, 0.68611, 0, 0],
	        "86": [0, 0.68611, 0.01597, 0],
	        "87": [0, 0.68611, 0.01597, 0],
	        "88": [0, 0.68611, 0, 0],
	        "89": [0, 0.68611, 0.02875, 0],
	        "90": [0, 0.68611, 0, 0],
	        "91": [0.25, 0.75, 0, 0],
	        "92": [0.25, 0.75, 0, 0],
	        "93": [0.25, 0.75, 0, 0],
	        "94": [0, 0.69444, 0, 0],
	        "95": [0.31, 0.13444, 0.03194, 0],
	        "96": [0, 0.69444, 0, 0],
	        "97": [0, 0.44444, 0, 0],
	        "98": [0, 0.69444, 0, 0],
	        "99": [0, 0.44444, 0, 0],
	        "100": [0, 0.69444, 0, 0],
	        "101": [0, 0.44444, 0, 0],
	        "102": [0, 0.69444, 0.10903, 0],
	        "103": [0.19444, 0.44444, 0.01597, 0],
	        "104": [0, 0.69444, 0, 0],
	        "105": [0, 0.69444, 0, 0],
	        "106": [0.19444, 0.69444, 0, 0],
	        "107": [0, 0.69444, 0, 0],
	        "108": [0, 0.69444, 0, 0],
	        "109": [0, 0.44444, 0, 0],
	        "110": [0, 0.44444, 0, 0],
	        "111": [0, 0.44444, 0, 0],
	        "112": [0.19444, 0.44444, 0, 0],
	        "113": [0.19444, 0.44444, 0, 0],
	        "114": [0, 0.44444, 0, 0],
	        "115": [0, 0.44444, 0, 0],
	        "116": [0, 0.63492, 0, 0],
	        "117": [0, 0.44444, 0, 0],
	        "118": [0, 0.44444, 0.01597, 0],
	        "119": [0, 0.44444, 0.01597, 0],
	        "120": [0, 0.44444, 0, 0],
	        "121": [0.19444, 0.44444, 0.01597, 0],
	        "122": [0, 0.44444, 0, 0],
	        "123": [0.25, 0.75, 0, 0],
	        "124": [0.25, 0.75, 0, 0],
	        "125": [0.25, 0.75, 0, 0],
	        "126": [0.35, 0.34444, 0, 0],
	        "168": [0, 0.69444, 0, 0],
	        "172": [0, 0.44444, 0, 0],
	        "175": [0, 0.59611, 0, 0],
	        "176": [0, 0.69444, 0, 0],
	        "177": [0.13333, 0.63333, 0, 0],
	        "180": [0, 0.69444, 0, 0],
	        "215": [0.13333, 0.63333, 0, 0],
	        "247": [0.13333, 0.63333, 0, 0],
	        "305": [0, 0.44444, 0, 0],
	        "567": [0.19444, 0.44444, 0, 0],
	        "710": [0, 0.69444, 0, 0],
	        "711": [0, 0.63194, 0, 0],
	        "713": [0, 0.59611, 0, 0],
	        "714": [0, 0.69444, 0, 0],
	        "715": [0, 0.69444, 0, 0],
	        "728": [0, 0.69444, 0, 0],
	        "729": [0, 0.69444, 0, 0],
	        "730": [0, 0.69444, 0, 0],
	        "732": [0, 0.69444, 0, 0],
	        "768": [0, 0.69444, 0, 0],
	        "769": [0, 0.69444, 0, 0],
	        "770": [0, 0.69444, 0, 0],
	        "771": [0, 0.69444, 0, 0],
	        "772": [0, 0.59611, 0, 0],
	        "774": [0, 0.69444, 0, 0],
	        "775": [0, 0.69444, 0, 0],
	        "776": [0, 0.69444, 0, 0],
	        "778": [0, 0.69444, 0, 0],
	        "779": [0, 0.69444, 0, 0],
	        "780": [0, 0.63194, 0, 0],
	        "824": [0.19444, 0.69444, 0, 0],
	        "915": [0, 0.68611, 0, 0],
	        "916": [0, 0.68611, 0, 0],
	        "920": [0, 0.68611, 0, 0],
	        "923": [0, 0.68611, 0, 0],
	        "926": [0, 0.68611, 0, 0],
	        "928": [0, 0.68611, 0, 0],
	        "931": [0, 0.68611, 0, 0],
	        "933": [0, 0.68611, 0, 0],
	        "934": [0, 0.68611, 0, 0],
	        "936": [0, 0.68611, 0, 0],
	        "937": [0, 0.68611, 0, 0],
	        "8211": [0, 0.44444, 0.03194, 0],
	        "8212": [0, 0.44444, 0.03194, 0],
	        "8216": [0, 0.69444, 0, 0],
	        "8217": [0, 0.69444, 0, 0],
	        "8220": [0, 0.69444, 0, 0],
	        "8221": [0, 0.69444, 0, 0],
	        "8224": [0.19444, 0.69444, 0, 0],
	        "8225": [0.19444, 0.69444, 0, 0],
	        "8242": [0, 0.55556, 0, 0],
	        "8407": [0, 0.72444, 0.15486, 0],
	        "8463": [0, 0.69444, 0, 0],
	        "8465": [0, 0.69444, 0, 0],
	        "8467": [0, 0.69444, 0, 0],
	        "8472": [0.19444, 0.44444, 0, 0],
	        "8476": [0, 0.69444, 0, 0],
	        "8501": [0, 0.69444, 0, 0],
	        "8592": [-0.10889, 0.39111, 0, 0],
	        "8593": [0.19444, 0.69444, 0, 0],
	        "8594": [-0.10889, 0.39111, 0, 0],
	        "8595": [0.19444, 0.69444, 0, 0],
	        "8596": [-0.10889, 0.39111, 0, 0],
	        "8597": [0.25, 0.75, 0, 0],
	        "8598": [0.19444, 0.69444, 0, 0],
	        "8599": [0.19444, 0.69444, 0, 0],
	        "8600": [0.19444, 0.69444, 0, 0],
	        "8601": [0.19444, 0.69444, 0, 0],
	        "8636": [-0.10889, 0.39111, 0, 0],
	        "8637": [-0.10889, 0.39111, 0, 0],
	        "8640": [-0.10889, 0.39111, 0, 0],
	        "8641": [-0.10889, 0.39111, 0, 0],
	        "8656": [-0.10889, 0.39111, 0, 0],
	        "8657": [0.19444, 0.69444, 0, 0],
	        "8658": [-0.10889, 0.39111, 0, 0],
	        "8659": [0.19444, 0.69444, 0, 0],
	        "8660": [-0.10889, 0.39111, 0, 0],
	        "8661": [0.25, 0.75, 0, 0],
	        "8704": [0, 0.69444, 0, 0],
	        "8706": [0, 0.69444, 0.06389, 0],
	        "8707": [0, 0.69444, 0, 0],
	        "8709": [0.05556, 0.75, 0, 0],
	        "8711": [0, 0.68611, 0, 0],
	        "8712": [0.08556, 0.58556, 0, 0],
	        "8715": [0.08556, 0.58556, 0, 0],
	        "8722": [0.13333, 0.63333, 0, 0],
	        "8723": [0.13333, 0.63333, 0, 0],
	        "8725": [0.25, 0.75, 0, 0],
	        "8726": [0.25, 0.75, 0, 0],
	        "8727": [-0.02778, 0.47222, 0, 0],
	        "8728": [-0.02639, 0.47361, 0, 0],
	        "8729": [-0.02639, 0.47361, 0, 0],
	        "8730": [0.18, 0.82, 0, 0],
	        "8733": [0, 0.44444, 0, 0],
	        "8734": [0, 0.44444, 0, 0],
	        "8736": [0, 0.69224, 0, 0],
	        "8739": [0.25, 0.75, 0, 0],
	        "8741": [0.25, 0.75, 0, 0],
	        "8743": [0, 0.55556, 0, 0],
	        "8744": [0, 0.55556, 0, 0],
	        "8745": [0, 0.55556, 0, 0],
	        "8746": [0, 0.55556, 0, 0],
	        "8747": [0.19444, 0.69444, 0.12778, 0],
	        "8764": [-0.10889, 0.39111, 0, 0],
	        "8768": [0.19444, 0.69444, 0, 0],
	        "8771": [0.00222, 0.50222, 0, 0],
	        "8776": [0.02444, 0.52444, 0, 0],
	        "8781": [0.00222, 0.50222, 0, 0],
	        "8801": [0.00222, 0.50222, 0, 0],
	        "8804": [0.19667, 0.69667, 0, 0],
	        "8805": [0.19667, 0.69667, 0, 0],
	        "8810": [0.08556, 0.58556, 0, 0],
	        "8811": [0.08556, 0.58556, 0, 0],
	        "8826": [0.08556, 0.58556, 0, 0],
	        "8827": [0.08556, 0.58556, 0, 0],
	        "8834": [0.08556, 0.58556, 0, 0],
	        "8835": [0.08556, 0.58556, 0, 0],
	        "8838": [0.19667, 0.69667, 0, 0],
	        "8839": [0.19667, 0.69667, 0, 0],
	        "8846": [0, 0.55556, 0, 0],
	        "8849": [0.19667, 0.69667, 0, 0],
	        "8850": [0.19667, 0.69667, 0, 0],
	        "8851": [0, 0.55556, 0, 0],
	        "8852": [0, 0.55556, 0, 0],
	        "8853": [0.13333, 0.63333, 0, 0],
	        "8854": [0.13333, 0.63333, 0, 0],
	        "8855": [0.13333, 0.63333, 0, 0],
	        "8856": [0.13333, 0.63333, 0, 0],
	        "8857": [0.13333, 0.63333, 0, 0],
	        "8866": [0, 0.69444, 0, 0],
	        "8867": [0, 0.69444, 0, 0],
	        "8868": [0, 0.69444, 0, 0],
	        "8869": [0, 0.69444, 0, 0],
	        "8900": [-0.02639, 0.47361, 0, 0],
	        "8901": [-0.02639, 0.47361, 0, 0],
	        "8902": [-0.02778, 0.47222, 0, 0],
	        "8968": [0.25, 0.75, 0, 0],
	        "8969": [0.25, 0.75, 0, 0],
	        "8970": [0.25, 0.75, 0, 0],
	        "8971": [0.25, 0.75, 0, 0],
	        "8994": [-0.13889, 0.36111, 0, 0],
	        "8995": [-0.13889, 0.36111, 0, 0],
	        "9651": [0.19444, 0.69444, 0, 0],
	        "9657": [-0.02778, 0.47222, 0, 0],
	        "9661": [0.19444, 0.69444, 0, 0],
	        "9667": [-0.02778, 0.47222, 0, 0],
	        "9711": [0.19444, 0.69444, 0, 0],
	        "9824": [0.12963, 0.69444, 0, 0],
	        "9825": [0.12963, 0.69444, 0, 0],
	        "9826": [0.12963, 0.69444, 0, 0],
	        "9827": [0.12963, 0.69444, 0, 0],
	        "9837": [0, 0.75, 0, 0],
	        "9838": [0.19444, 0.69444, 0, 0],
	        "9839": [0.19444, 0.69444, 0, 0],
	        "10216": [0.25, 0.75, 0, 0],
	        "10217": [0.25, 0.75, 0, 0],
	        "10815": [0, 0.68611, 0, 0],
	        "10927": [0.19667, 0.69667, 0, 0],
	        "10928": [0.19667, 0.69667, 0, 0],
	    },
	    "Main-Italic": {
	        "33": [0, 0.69444, 0.12417, 0],
	        "34": [0, 0.69444, 0.06961, 0],
	        "35": [0.19444, 0.69444, 0.06616, 0],
	        "37": [0.05556, 0.75, 0.13639, 0],
	        "38": [0, 0.69444, 0.09694, 0],
	        "39": [0, 0.69444, 0.12417, 0],
	        "40": [0.25, 0.75, 0.16194, 0],
	        "41": [0.25, 0.75, 0.03694, 0],
	        "42": [0, 0.75, 0.14917, 0],
	        "43": [0.05667, 0.56167, 0.03694, 0],
	        "44": [0.19444, 0.10556, 0, 0],
	        "45": [0, 0.43056, 0.02826, 0],
	        "46": [0, 0.10556, 0, 0],
	        "47": [0.25, 0.75, 0.16194, 0],
	        "48": [0, 0.64444, 0.13556, 0],
	        "49": [0, 0.64444, 0.13556, 0],
	        "50": [0, 0.64444, 0.13556, 0],
	        "51": [0, 0.64444, 0.13556, 0],
	        "52": [0.19444, 0.64444, 0.13556, 0],
	        "53": [0, 0.64444, 0.13556, 0],
	        "54": [0, 0.64444, 0.13556, 0],
	        "55": [0.19444, 0.64444, 0.13556, 0],
	        "56": [0, 0.64444, 0.13556, 0],
	        "57": [0, 0.64444, 0.13556, 0],
	        "58": [0, 0.43056, 0.0582, 0],
	        "59": [0.19444, 0.43056, 0.0582, 0],
	        "61": [-0.13313, 0.36687, 0.06616, 0],
	        "63": [0, 0.69444, 0.1225, 0],
	        "64": [0, 0.69444, 0.09597, 0],
	        "65": [0, 0.68333, 0, 0],
	        "66": [0, 0.68333, 0.10257, 0],
	        "67": [0, 0.68333, 0.14528, 0],
	        "68": [0, 0.68333, 0.09403, 0],
	        "69": [0, 0.68333, 0.12028, 0],
	        "70": [0, 0.68333, 0.13305, 0],
	        "71": [0, 0.68333, 0.08722, 0],
	        "72": [0, 0.68333, 0.16389, 0],
	        "73": [0, 0.68333, 0.15806, 0],
	        "74": [0, 0.68333, 0.14028, 0],
	        "75": [0, 0.68333, 0.14528, 0],
	        "76": [0, 0.68333, 0, 0],
	        "77": [0, 0.68333, 0.16389, 0],
	        "78": [0, 0.68333, 0.16389, 0],
	        "79": [0, 0.68333, 0.09403, 0],
	        "80": [0, 0.68333, 0.10257, 0],
	        "81": [0.19444, 0.68333, 0.09403, 0],
	        "82": [0, 0.68333, 0.03868, 0],
	        "83": [0, 0.68333, 0.11972, 0],
	        "84": [0, 0.68333, 0.13305, 0],
	        "85": [0, 0.68333, 0.16389, 0],
	        "86": [0, 0.68333, 0.18361, 0],
	        "87": [0, 0.68333, 0.18361, 0],
	        "88": [0, 0.68333, 0.15806, 0],
	        "89": [0, 0.68333, 0.19383, 0],
	        "90": [0, 0.68333, 0.14528, 0],
	        "91": [0.25, 0.75, 0.1875, 0],
	        "93": [0.25, 0.75, 0.10528, 0],
	        "94": [0, 0.69444, 0.06646, 0],
	        "95": [0.31, 0.12056, 0.09208, 0],
	        "97": [0, 0.43056, 0.07671, 0],
	        "98": [0, 0.69444, 0.06312, 0],
	        "99": [0, 0.43056, 0.05653, 0],
	        "100": [0, 0.69444, 0.10333, 0],
	        "101": [0, 0.43056, 0.07514, 0],
	        "102": [0.19444, 0.69444, 0.21194, 0],
	        "103": [0.19444, 0.43056, 0.08847, 0],
	        "104": [0, 0.69444, 0.07671, 0],
	        "105": [0, 0.65536, 0.1019, 0],
	        "106": [0.19444, 0.65536, 0.14467, 0],
	        "107": [0, 0.69444, 0.10764, 0],
	        "108": [0, 0.69444, 0.10333, 0],
	        "109": [0, 0.43056, 0.07671, 0],
	        "110": [0, 0.43056, 0.07671, 0],
	        "111": [0, 0.43056, 0.06312, 0],
	        "112": [0.19444, 0.43056, 0.06312, 0],
	        "113": [0.19444, 0.43056, 0.08847, 0],
	        "114": [0, 0.43056, 0.10764, 0],
	        "115": [0, 0.43056, 0.08208, 0],
	        "116": [0, 0.61508, 0.09486, 0],
	        "117": [0, 0.43056, 0.07671, 0],
	        "118": [0, 0.43056, 0.10764, 0],
	        "119": [0, 0.43056, 0.10764, 0],
	        "120": [0, 0.43056, 0.12042, 0],
	        "121": [0.19444, 0.43056, 0.08847, 0],
	        "122": [0, 0.43056, 0.12292, 0],
	        "126": [0.35, 0.31786, 0.11585, 0],
	        "163": [0, 0.69444, 0, 0],
	        "305": [0, 0.43056, 0, 0.02778],
	        "567": [0.19444, 0.43056, 0, 0.08334],
	        "768": [0, 0.69444, 0, 0],
	        "769": [0, 0.69444, 0.09694, 0],
	        "770": [0, 0.69444, 0.06646, 0],
	        "771": [0, 0.66786, 0.11585, 0],
	        "772": [0, 0.56167, 0.10333, 0],
	        "774": [0, 0.69444, 0.10806, 0],
	        "775": [0, 0.66786, 0.11752, 0],
	        "776": [0, 0.66786, 0.10474, 0],
	        "778": [0, 0.69444, 0, 0],
	        "779": [0, 0.69444, 0.1225, 0],
	        "780": [0, 0.62847, 0.08295, 0],
	        "915": [0, 0.68333, 0.13305, 0],
	        "916": [0, 0.68333, 0, 0],
	        "920": [0, 0.68333, 0.09403, 0],
	        "923": [0, 0.68333, 0, 0],
	        "926": [0, 0.68333, 0.15294, 0],
	        "928": [0, 0.68333, 0.16389, 0],
	        "931": [0, 0.68333, 0.12028, 0],
	        "933": [0, 0.68333, 0.11111, 0],
	        "934": [0, 0.68333, 0.05986, 0],
	        "936": [0, 0.68333, 0.11111, 0],
	        "937": [0, 0.68333, 0.10257, 0],
	        "8211": [0, 0.43056, 0.09208, 0],
	        "8212": [0, 0.43056, 0.09208, 0],
	        "8216": [0, 0.69444, 0.12417, 0],
	        "8217": [0, 0.69444, 0.12417, 0],
	        "8220": [0, 0.69444, 0.1685, 0],
	        "8221": [0, 0.69444, 0.06961, 0],
	        "8463": [0, 0.68889, 0, 0],
	    },
	    "Main-Regular": {
	        "32": [0, 0, 0, 0],
	        "33": [0, 0.69444, 0, 0],
	        "34": [0, 0.69444, 0, 0],
	        "35": [0.19444, 0.69444, 0, 0],
	        "36": [0.05556, 0.75, 0, 0],
	        "37": [0.05556, 0.75, 0, 0],
	        "38": [0, 0.69444, 0, 0],
	        "39": [0, 0.69444, 0, 0],
	        "40": [0.25, 0.75, 0, 0],
	        "41": [0.25, 0.75, 0, 0],
	        "42": [0, 0.75, 0, 0],
	        "43": [0.08333, 0.58333, 0, 0],
	        "44": [0.19444, 0.10556, 0, 0],
	        "45": [0, 0.43056, 0, 0],
	        "46": [0, 0.10556, 0, 0],
	        "47": [0.25, 0.75, 0, 0],
	        "48": [0, 0.64444, 0, 0],
	        "49": [0, 0.64444, 0, 0],
	        "50": [0, 0.64444, 0, 0],
	        "51": [0, 0.64444, 0, 0],
	        "52": [0, 0.64444, 0, 0],
	        "53": [0, 0.64444, 0, 0],
	        "54": [0, 0.64444, 0, 0],
	        "55": [0, 0.64444, 0, 0],
	        "56": [0, 0.64444, 0, 0],
	        "57": [0, 0.64444, 0, 0],
	        "58": [0, 0.43056, 0, 0],
	        "59": [0.19444, 0.43056, 0, 0],
	        "60": [0.0391, 0.5391, 0, 0],
	        "61": [-0.13313, 0.36687, 0, 0],
	        "62": [0.0391, 0.5391, 0, 0],
	        "63": [0, 0.69444, 0, 0],
	        "64": [0, 0.69444, 0, 0],
	        "65": [0, 0.68333, 0, 0],
	        "66": [0, 0.68333, 0, 0],
	        "67": [0, 0.68333, 0, 0],
	        "68": [0, 0.68333, 0, 0],
	        "69": [0, 0.68333, 0, 0],
	        "70": [0, 0.68333, 0, 0],
	        "71": [0, 0.68333, 0, 0],
	        "72": [0, 0.68333, 0, 0],
	        "73": [0, 0.68333, 0, 0],
	        "74": [0, 0.68333, 0, 0],
	        "75": [0, 0.68333, 0, 0],
	        "76": [0, 0.68333, 0, 0],
	        "77": [0, 0.68333, 0, 0],
	        "78": [0, 0.68333, 0, 0],
	        "79": [0, 0.68333, 0, 0],
	        "80": [0, 0.68333, 0, 0],
	        "81": [0.19444, 0.68333, 0, 0],
	        "82": [0, 0.68333, 0, 0],
	        "83": [0, 0.68333, 0, 0],
	        "84": [0, 0.68333, 0, 0],
	        "85": [0, 0.68333, 0, 0],
	        "86": [0, 0.68333, 0.01389, 0],
	        "87": [0, 0.68333, 0.01389, 0],
	        "88": [0, 0.68333, 0, 0],
	        "89": [0, 0.68333, 0.025, 0],
	        "90": [0, 0.68333, 0, 0],
	        "91": [0.25, 0.75, 0, 0],
	        "92": [0.25, 0.75, 0, 0],
	        "93": [0.25, 0.75, 0, 0],
	        "94": [0, 0.69444, 0, 0],
	        "95": [0.31, 0.12056, 0.02778, 0],
	        "96": [0, 0.69444, 0, 0],
	        "97": [0, 0.43056, 0, 0],
	        "98": [0, 0.69444, 0, 0],
	        "99": [0, 0.43056, 0, 0],
	        "100": [0, 0.69444, 0, 0],
	        "101": [0, 0.43056, 0, 0],
	        "102": [0, 0.69444, 0.07778, 0],
	        "103": [0.19444, 0.43056, 0.01389, 0],
	        "104": [0, 0.69444, 0, 0],
	        "105": [0, 0.66786, 0, 0],
	        "106": [0.19444, 0.66786, 0, 0],
	        "107": [0, 0.69444, 0, 0],
	        "108": [0, 0.69444, 0, 0],
	        "109": [0, 0.43056, 0, 0],
	        "110": [0, 0.43056, 0, 0],
	        "111": [0, 0.43056, 0, 0],
	        "112": [0.19444, 0.43056, 0, 0],
	        "113": [0.19444, 0.43056, 0, 0],
	        "114": [0, 0.43056, 0, 0],
	        "115": [0, 0.43056, 0, 0],
	        "116": [0, 0.61508, 0, 0],
	        "117": [0, 0.43056, 0, 0],
	        "118": [0, 0.43056, 0.01389, 0],
	        "119": [0, 0.43056, 0.01389, 0],
	        "120": [0, 0.43056, 0, 0],
	        "121": [0.19444, 0.43056, 0.01389, 0],
	        "122": [0, 0.43056, 0, 0],
	        "123": [0.25, 0.75, 0, 0],
	        "124": [0.25, 0.75, 0, 0],
	        "125": [0.25, 0.75, 0, 0],
	        "126": [0.35, 0.31786, 0, 0],
	        "160": [0, 0, 0, 0],
	        "168": [0, 0.66786, 0, 0],
	        "172": [0, 0.43056, 0, 0],
	        "175": [0, 0.56778, 0, 0],
	        "176": [0, 0.69444, 0, 0],
	        "177": [0.08333, 0.58333, 0, 0],
	        "180": [0, 0.69444, 0, 0],
	        "215": [0.08333, 0.58333, 0, 0],
	        "247": [0.08333, 0.58333, 0, 0],
	        "305": [0, 0.43056, 0, 0],
	        "567": [0.19444, 0.43056, 0, 0],
	        "710": [0, 0.69444, 0, 0],
	        "711": [0, 0.62847, 0, 0],
	        "713": [0, 0.56778, 0, 0],
	        "714": [0, 0.69444, 0, 0],
	        "715": [0, 0.69444, 0, 0],
	        "728": [0, 0.69444, 0, 0],
	        "729": [0, 0.66786, 0, 0],
	        "730": [0, 0.69444, 0, 0],
	        "732": [0, 0.66786, 0, 0],
	        "768": [0, 0.69444, 0, 0],
	        "769": [0, 0.69444, 0, 0],
	        "770": [0, 0.69444, 0, 0],
	        "771": [0, 0.66786, 0, 0],
	        "772": [0, 0.56778, 0, 0],
	        "774": [0, 0.69444, 0, 0],
	        "775": [0, 0.66786, 0, 0],
	        "776": [0, 0.66786, 0, 0],
	        "778": [0, 0.69444, 0, 0],
	        "779": [0, 0.69444, 0, 0],
	        "780": [0, 0.62847, 0, 0],
	        "824": [0.19444, 0.69444, 0, 0],
	        "915": [0, 0.68333, 0, 0],
	        "916": [0, 0.68333, 0, 0],
	        "920": [0, 0.68333, 0, 0],
	        "923": [0, 0.68333, 0, 0],
	        "926": [0, 0.68333, 0, 0],
	        "928": [0, 0.68333, 0, 0],
	        "931": [0, 0.68333, 0, 0],
	        "933": [0, 0.68333, 0, 0],
	        "934": [0, 0.68333, 0, 0],
	        "936": [0, 0.68333, 0, 0],
	        "937": [0, 0.68333, 0, 0],
	        "8211": [0, 0.43056, 0.02778, 0],
	        "8212": [0, 0.43056, 0.02778, 0],
	        "8216": [0, 0.69444, 0, 0],
	        "8217": [0, 0.69444, 0, 0],
	        "8220": [0, 0.69444, 0, 0],
	        "8221": [0, 0.69444, 0, 0],
	        "8224": [0.19444, 0.69444, 0, 0],
	        "8225": [0.19444, 0.69444, 0, 0],
	        "8230": [0, 0.12, 0, 0],
	        "8242": [0, 0.55556, 0, 0],
	        "8407": [0, 0.71444, 0.15382, 0],
	        "8463": [0, 0.68889, 0, 0],
	        "8465": [0, 0.69444, 0, 0],
	        "8467": [0, 0.69444, 0, 0.11111],
	        "8472": [0.19444, 0.43056, 0, 0.11111],
	        "8476": [0, 0.69444, 0, 0],
	        "8501": [0, 0.69444, 0, 0],
	        "8592": [-0.13313, 0.36687, 0, 0],
	        "8593": [0.19444, 0.69444, 0, 0],
	        "8594": [-0.13313, 0.36687, 0, 0],
	        "8595": [0.19444, 0.69444, 0, 0],
	        "8596": [-0.13313, 0.36687, 0, 0],
	        "8597": [0.25, 0.75, 0, 0],
	        "8598": [0.19444, 0.69444, 0, 0],
	        "8599": [0.19444, 0.69444, 0, 0],
	        "8600": [0.19444, 0.69444, 0, 0],
	        "8601": [0.19444, 0.69444, 0, 0],
	        "8614": [0.011, 0.511, 0, 0],
	        "8617": [0.011, 0.511, 0, 0],
	        "8618": [0.011, 0.511, 0, 0],
	        "8636": [-0.13313, 0.36687, 0, 0],
	        "8637": [-0.13313, 0.36687, 0, 0],
	        "8640": [-0.13313, 0.36687, 0, 0],
	        "8641": [-0.13313, 0.36687, 0, 0],
	        "8652": [0.011, 0.671, 0, 0],
	        "8656": [-0.13313, 0.36687, 0, 0],
	        "8657": [0.19444, 0.69444, 0, 0],
	        "8658": [-0.13313, 0.36687, 0, 0],
	        "8659": [0.19444, 0.69444, 0, 0],
	        "8660": [-0.13313, 0.36687, 0, 0],
	        "8661": [0.25, 0.75, 0, 0],
	        "8704": [0, 0.69444, 0, 0],
	        "8706": [0, 0.69444, 0.05556, 0.08334],
	        "8707": [0, 0.69444, 0, 0],
	        "8709": [0.05556, 0.75, 0, 0],
	        "8711": [0, 0.68333, 0, 0],
	        "8712": [0.0391, 0.5391, 0, 0],
	        "8715": [0.0391, 0.5391, 0, 0],
	        "8722": [0.08333, 0.58333, 0, 0],
	        "8723": [0.08333, 0.58333, 0, 0],
	        "8725": [0.25, 0.75, 0, 0],
	        "8726": [0.25, 0.75, 0, 0],
	        "8727": [-0.03472, 0.46528, 0, 0],
	        "8728": [-0.05555, 0.44445, 0, 0],
	        "8729": [-0.05555, 0.44445, 0, 0],
	        "8730": [0.2, 0.8, 0, 0],
	        "8733": [0, 0.43056, 0, 0],
	        "8734": [0, 0.43056, 0, 0],
	        "8736": [0, 0.69224, 0, 0],
	        "8739": [0.25, 0.75, 0, 0],
	        "8741": [0.25, 0.75, 0, 0],
	        "8743": [0, 0.55556, 0, 0],
	        "8744": [0, 0.55556, 0, 0],
	        "8745": [0, 0.55556, 0, 0],
	        "8746": [0, 0.55556, 0, 0],
	        "8747": [0.19444, 0.69444, 0.11111, 0],
	        "8764": [-0.13313, 0.36687, 0, 0],
	        "8768": [0.19444, 0.69444, 0, 0],
	        "8771": [-0.03625, 0.46375, 0, 0],
	        "8773": [-0.022, 0.589, 0, 0],
	        "8776": [-0.01688, 0.48312, 0, 0],
	        "8781": [-0.03625, 0.46375, 0, 0],
	        "8784": [-0.133, 0.67, 0, 0],
	        "8800": [0.215, 0.716, 0, 0],
	        "8801": [-0.03625, 0.46375, 0, 0],
	        "8804": [0.13597, 0.63597, 0, 0],
	        "8805": [0.13597, 0.63597, 0, 0],
	        "8810": [0.0391, 0.5391, 0, 0],
	        "8811": [0.0391, 0.5391, 0, 0],
	        "8826": [0.0391, 0.5391, 0, 0],
	        "8827": [0.0391, 0.5391, 0, 0],
	        "8834": [0.0391, 0.5391, 0, 0],
	        "8835": [0.0391, 0.5391, 0, 0],
	        "8838": [0.13597, 0.63597, 0, 0],
	        "8839": [0.13597, 0.63597, 0, 0],
	        "8846": [0, 0.55556, 0, 0],
	        "8849": [0.13597, 0.63597, 0, 0],
	        "8850": [0.13597, 0.63597, 0, 0],
	        "8851": [0, 0.55556, 0, 0],
	        "8852": [0, 0.55556, 0, 0],
	        "8853": [0.08333, 0.58333, 0, 0],
	        "8854": [0.08333, 0.58333, 0, 0],
	        "8855": [0.08333, 0.58333, 0, 0],
	        "8856": [0.08333, 0.58333, 0, 0],
	        "8857": [0.08333, 0.58333, 0, 0],
	        "8866": [0, 0.69444, 0, 0],
	        "8867": [0, 0.69444, 0, 0],
	        "8868": [0, 0.69444, 0, 0],
	        "8869": [0, 0.69444, 0, 0],
	        "8872": [0.249, 0.75, 0, 0],
	        "8900": [-0.05555, 0.44445, 0, 0],
	        "8901": [-0.05555, 0.44445, 0, 0],
	        "8902": [-0.03472, 0.46528, 0, 0],
	        "8904": [0.005, 0.505, 0, 0],
	        "8942": [0.03, 0.9, 0, 0],
	        "8943": [-0.19, 0.31, 0, 0],
	        "8945": [-0.1, 0.82, 0, 0],
	        "8968": [0.25, 0.75, 0, 0],
	        "8969": [0.25, 0.75, 0, 0],
	        "8970": [0.25, 0.75, 0, 0],
	        "8971": [0.25, 0.75, 0, 0],
	        "8994": [-0.14236, 0.35764, 0, 0],
	        "8995": [-0.14236, 0.35764, 0, 0],
	        "9136": [0.244, 0.744, 0, 0],
	        "9137": [0.244, 0.744, 0, 0],
	        "9651": [0.19444, 0.69444, 0, 0],
	        "9657": [-0.03472, 0.46528, 0, 0],
	        "9661": [0.19444, 0.69444, 0, 0],
	        "9667": [-0.03472, 0.46528, 0, 0],
	        "9711": [0.19444, 0.69444, 0, 0],
	        "9824": [0.12963, 0.69444, 0, 0],
	        "9825": [0.12963, 0.69444, 0, 0],
	        "9826": [0.12963, 0.69444, 0, 0],
	        "9827": [0.12963, 0.69444, 0, 0],
	        "9837": [0, 0.75, 0, 0],
	        "9838": [0.19444, 0.69444, 0, 0],
	        "9839": [0.19444, 0.69444, 0, 0],
	        "10216": [0.25, 0.75, 0, 0],
	        "10217": [0.25, 0.75, 0, 0],
	        "10222": [0.244, 0.744, 0, 0],
	        "10223": [0.244, 0.744, 0, 0],
	        "10229": [0.011, 0.511, 0, 0],
	        "10230": [0.011, 0.511, 0, 0],
	        "10231": [0.011, 0.511, 0, 0],
	        "10232": [0.024, 0.525, 0, 0],
	        "10233": [0.024, 0.525, 0, 0],
	        "10234": [0.024, 0.525, 0, 0],
	        "10236": [0.011, 0.511, 0, 0],
	        "10815": [0, 0.68333, 0, 0],
	        "10927": [0.13597, 0.63597, 0, 0],
	        "10928": [0.13597, 0.63597, 0, 0],
	    },
	    "Math-BoldItalic": {
	        "47": [0.19444, 0.69444, 0, 0],
	        "65": [0, 0.68611, 0, 0],
	        "66": [0, 0.68611, 0.04835, 0],
	        "67": [0, 0.68611, 0.06979, 0],
	        "68": [0, 0.68611, 0.03194, 0],
	        "69": [0, 0.68611, 0.05451, 0],
	        "70": [0, 0.68611, 0.15972, 0],
	        "71": [0, 0.68611, 0, 0],
	        "72": [0, 0.68611, 0.08229, 0],
	        "73": [0, 0.68611, 0.07778, 0],
	        "74": [0, 0.68611, 0.10069, 0],
	        "75": [0, 0.68611, 0.06979, 0],
	        "76": [0, 0.68611, 0, 0],
	        "77": [0, 0.68611, 0.11424, 0],
	        "78": [0, 0.68611, 0.11424, 0],
	        "79": [0, 0.68611, 0.03194, 0],
	        "80": [0, 0.68611, 0.15972, 0],
	        "81": [0.19444, 0.68611, 0, 0],
	        "82": [0, 0.68611, 0.00421, 0],
	        "83": [0, 0.68611, 0.05382, 0],
	        "84": [0, 0.68611, 0.15972, 0],
	        "85": [0, 0.68611, 0.11424, 0],
	        "86": [0, 0.68611, 0.25555, 0],
	        "87": [0, 0.68611, 0.15972, 0],
	        "88": [0, 0.68611, 0.07778, 0],
	        "89": [0, 0.68611, 0.25555, 0],
	        "90": [0, 0.68611, 0.06979, 0],
	        "97": [0, 0.44444, 0, 0],
	        "98": [0, 0.69444, 0, 0],
	        "99": [0, 0.44444, 0, 0],
	        "100": [0, 0.69444, 0, 0],
	        "101": [0, 0.44444, 0, 0],
	        "102": [0.19444, 0.69444, 0.11042, 0],
	        "103": [0.19444, 0.44444, 0.03704, 0],
	        "104": [0, 0.69444, 0, 0],
	        "105": [0, 0.69326, 0, 0],
	        "106": [0.19444, 0.69326, 0.0622, 0],
	        "107": [0, 0.69444, 0.01852, 0],
	        "108": [0, 0.69444, 0.0088, 0],
	        "109": [0, 0.44444, 0, 0],
	        "110": [0, 0.44444, 0, 0],
	        "111": [0, 0.44444, 0, 0],
	        "112": [0.19444, 0.44444, 0, 0],
	        "113": [0.19444, 0.44444, 0.03704, 0],
	        "114": [0, 0.44444, 0.03194, 0],
	        "115": [0, 0.44444, 0, 0],
	        "116": [0, 0.63492, 0, 0],
	        "117": [0, 0.44444, 0, 0],
	        "118": [0, 0.44444, 0.03704, 0],
	        "119": [0, 0.44444, 0.02778, 0],
	        "120": [0, 0.44444, 0, 0],
	        "121": [0.19444, 0.44444, 0.03704, 0],
	        "122": [0, 0.44444, 0.04213, 0],
	        "915": [0, 0.68611, 0.15972, 0],
	        "916": [0, 0.68611, 0, 0],
	        "920": [0, 0.68611, 0.03194, 0],
	        "923": [0, 0.68611, 0, 0],
	        "926": [0, 0.68611, 0.07458, 0],
	        "928": [0, 0.68611, 0.08229, 0],
	        "931": [0, 0.68611, 0.05451, 0],
	        "933": [0, 0.68611, 0.15972, 0],
	        "934": [0, 0.68611, 0, 0],
	        "936": [0, 0.68611, 0.11653, 0],
	        "937": [0, 0.68611, 0.04835, 0],
	        "945": [0, 0.44444, 0, 0],
	        "946": [0.19444, 0.69444, 0.03403, 0],
	        "947": [0.19444, 0.44444, 0.06389, 0],
	        "948": [0, 0.69444, 0.03819, 0],
	        "949": [0, 0.44444, 0, 0],
	        "950": [0.19444, 0.69444, 0.06215, 0],
	        "951": [0.19444, 0.44444, 0.03704, 0],
	        "952": [0, 0.69444, 0.03194, 0],
	        "953": [0, 0.44444, 0, 0],
	        "954": [0, 0.44444, 0, 0],
	        "955": [0, 0.69444, 0, 0],
	        "956": [0.19444, 0.44444, 0, 0],
	        "957": [0, 0.44444, 0.06898, 0],
	        "958": [0.19444, 0.69444, 0.03021, 0],
	        "959": [0, 0.44444, 0, 0],
	        "960": [0, 0.44444, 0.03704, 0],
	        "961": [0.19444, 0.44444, 0, 0],
	        "962": [0.09722, 0.44444, 0.07917, 0],
	        "963": [0, 0.44444, 0.03704, 0],
	        "964": [0, 0.44444, 0.13472, 0],
	        "965": [0, 0.44444, 0.03704, 0],
	        "966": [0.19444, 0.44444, 0, 0],
	        "967": [0.19444, 0.44444, 0, 0],
	        "968": [0.19444, 0.69444, 0.03704, 0],
	        "969": [0, 0.44444, 0.03704, 0],
	        "977": [0, 0.69444, 0, 0],
	        "981": [0.19444, 0.69444, 0, 0],
	        "982": [0, 0.44444, 0.03194, 0],
	        "1009": [0.19444, 0.44444, 0, 0],
	        "1013": [0, 0.44444, 0, 0],
	    },
	    "Math-Italic": {
	        "47": [0.19444, 0.69444, 0, 0],
	        "65": [0, 0.68333, 0, 0.13889],
	        "66": [0, 0.68333, 0.05017, 0.08334],
	        "67": [0, 0.68333, 0.07153, 0.08334],
	        "68": [0, 0.68333, 0.02778, 0.05556],
	        "69": [0, 0.68333, 0.05764, 0.08334],
	        "70": [0, 0.68333, 0.13889, 0.08334],
	        "71": [0, 0.68333, 0, 0.08334],
	        "72": [0, 0.68333, 0.08125, 0.05556],
	        "73": [0, 0.68333, 0.07847, 0.11111],
	        "74": [0, 0.68333, 0.09618, 0.16667],
	        "75": [0, 0.68333, 0.07153, 0.05556],
	        "76": [0, 0.68333, 0, 0.02778],
	        "77": [0, 0.68333, 0.10903, 0.08334],
	        "78": [0, 0.68333, 0.10903, 0.08334],
	        "79": [0, 0.68333, 0.02778, 0.08334],
	        "80": [0, 0.68333, 0.13889, 0.08334],
	        "81": [0.19444, 0.68333, 0, 0.08334],
	        "82": [0, 0.68333, 0.00773, 0.08334],
	        "83": [0, 0.68333, 0.05764, 0.08334],
	        "84": [0, 0.68333, 0.13889, 0.08334],
	        "85": [0, 0.68333, 0.10903, 0.02778],
	        "86": [0, 0.68333, 0.22222, 0],
	        "87": [0, 0.68333, 0.13889, 0],
	        "88": [0, 0.68333, 0.07847, 0.08334],
	        "89": [0, 0.68333, 0.22222, 0],
	        "90": [0, 0.68333, 0.07153, 0.08334],
	        "97": [0, 0.43056, 0, 0],
	        "98": [0, 0.69444, 0, 0],
	        "99": [0, 0.43056, 0, 0.05556],
	        "100": [0, 0.69444, 0, 0.16667],
	        "101": [0, 0.43056, 0, 0.05556],
	        "102": [0.19444, 0.69444, 0.10764, 0.16667],
	        "103": [0.19444, 0.43056, 0.03588, 0.02778],
	        "104": [0, 0.69444, 0, 0],
	        "105": [0, 0.65952, 0, 0],
	        "106": [0.19444, 0.65952, 0.05724, 0],
	        "107": [0, 0.69444, 0.03148, 0],
	        "108": [0, 0.69444, 0.01968, 0.08334],
	        "109": [0, 0.43056, 0, 0],
	        "110": [0, 0.43056, 0, 0],
	        "111": [0, 0.43056, 0, 0.05556],
	        "112": [0.19444, 0.43056, 0, 0.08334],
	        "113": [0.19444, 0.43056, 0.03588, 0.08334],
	        "114": [0, 0.43056, 0.02778, 0.05556],
	        "115": [0, 0.43056, 0, 0.05556],
	        "116": [0, 0.61508, 0, 0.08334],
	        "117": [0, 0.43056, 0, 0.02778],
	        "118": [0, 0.43056, 0.03588, 0.02778],
	        "119": [0, 0.43056, 0.02691, 0.08334],
	        "120": [0, 0.43056, 0, 0.02778],
	        "121": [0.19444, 0.43056, 0.03588, 0.05556],
	        "122": [0, 0.43056, 0.04398, 0.05556],
	        "915": [0, 0.68333, 0.13889, 0.08334],
	        "916": [0, 0.68333, 0, 0.16667],
	        "920": [0, 0.68333, 0.02778, 0.08334],
	        "923": [0, 0.68333, 0, 0.16667],
	        "926": [0, 0.68333, 0.07569, 0.08334],
	        "928": [0, 0.68333, 0.08125, 0.05556],
	        "931": [0, 0.68333, 0.05764, 0.08334],
	        "933": [0, 0.68333, 0.13889, 0.05556],
	        "934": [0, 0.68333, 0, 0.08334],
	        "936": [0, 0.68333, 0.11, 0.05556],
	        "937": [0, 0.68333, 0.05017, 0.08334],
	        "945": [0, 0.43056, 0.0037, 0.02778],
	        "946": [0.19444, 0.69444, 0.05278, 0.08334],
	        "947": [0.19444, 0.43056, 0.05556, 0],
	        "948": [0, 0.69444, 0.03785, 0.05556],
	        "949": [0, 0.43056, 0, 0.08334],
	        "950": [0.19444, 0.69444, 0.07378, 0.08334],
	        "951": [0.19444, 0.43056, 0.03588, 0.05556],
	        "952": [0, 0.69444, 0.02778, 0.08334],
	        "953": [0, 0.43056, 0, 0.05556],
	        "954": [0, 0.43056, 0, 0],
	        "955": [0, 0.69444, 0, 0],
	        "956": [0.19444, 0.43056, 0, 0.02778],
	        "957": [0, 0.43056, 0.06366, 0.02778],
	        "958": [0.19444, 0.69444, 0.04601, 0.11111],
	        "959": [0, 0.43056, 0, 0.05556],
	        "960": [0, 0.43056, 0.03588, 0],
	        "961": [0.19444, 0.43056, 0, 0.08334],
	        "962": [0.09722, 0.43056, 0.07986, 0.08334],
	        "963": [0, 0.43056, 0.03588, 0],
	        "964": [0, 0.43056, 0.1132, 0.02778],
	        "965": [0, 0.43056, 0.03588, 0.02778],
	        "966": [0.19444, 0.43056, 0, 0.08334],
	        "967": [0.19444, 0.43056, 0, 0.05556],
	        "968": [0.19444, 0.69444, 0.03588, 0.11111],
	        "969": [0, 0.43056, 0.03588, 0],
	        "977": [0, 0.69444, 0, 0.08334],
	        "981": [0.19444, 0.69444, 0, 0.08334],
	        "982": [0, 0.43056, 0.02778, 0],
	        "1009": [0.19444, 0.43056, 0, 0.08334],
	        "1013": [0, 0.43056, 0, 0.05556],
	    },
	    "Math-Regular": {
	        "65": [0, 0.68333, 0, 0.13889],
	        "66": [0, 0.68333, 0.05017, 0.08334],
	        "67": [0, 0.68333, 0.07153, 0.08334],
	        "68": [0, 0.68333, 0.02778, 0.05556],
	        "69": [0, 0.68333, 0.05764, 0.08334],
	        "70": [0, 0.68333, 0.13889, 0.08334],
	        "71": [0, 0.68333, 0, 0.08334],
	        "72": [0, 0.68333, 0.08125, 0.05556],
	        "73": [0, 0.68333, 0.07847, 0.11111],
	        "74": [0, 0.68333, 0.09618, 0.16667],
	        "75": [0, 0.68333, 0.07153, 0.05556],
	        "76": [0, 0.68333, 0, 0.02778],
	        "77": [0, 0.68333, 0.10903, 0.08334],
	        "78": [0, 0.68333, 0.10903, 0.08334],
	        "79": [0, 0.68333, 0.02778, 0.08334],
	        "80": [0, 0.68333, 0.13889, 0.08334],
	        "81": [0.19444, 0.68333, 0, 0.08334],
	        "82": [0, 0.68333, 0.00773, 0.08334],
	        "83": [0, 0.68333, 0.05764, 0.08334],
	        "84": [0, 0.68333, 0.13889, 0.08334],
	        "85": [0, 0.68333, 0.10903, 0.02778],
	        "86": [0, 0.68333, 0.22222, 0],
	        "87": [0, 0.68333, 0.13889, 0],
	        "88": [0, 0.68333, 0.07847, 0.08334],
	        "89": [0, 0.68333, 0.22222, 0],
	        "90": [0, 0.68333, 0.07153, 0.08334],
	        "97": [0, 0.43056, 0, 0],
	        "98": [0, 0.69444, 0, 0],
	        "99": [0, 0.43056, 0, 0.05556],
	        "100": [0, 0.69444, 0, 0.16667],
	        "101": [0, 0.43056, 0, 0.05556],
	        "102": [0.19444, 0.69444, 0.10764, 0.16667],
	        "103": [0.19444, 0.43056, 0.03588, 0.02778],
	        "104": [0, 0.69444, 0, 0],
	        "105": [0, 0.65952, 0, 0],
	        "106": [0.19444, 0.65952, 0.05724, 0],
	        "107": [0, 0.69444, 0.03148, 0],
	        "108": [0, 0.69444, 0.01968, 0.08334],
	        "109": [0, 0.43056, 0, 0],
	        "110": [0, 0.43056, 0, 0],
	        "111": [0, 0.43056, 0, 0.05556],
	        "112": [0.19444, 0.43056, 0, 0.08334],
	        "113": [0.19444, 0.43056, 0.03588, 0.08334],
	        "114": [0, 0.43056, 0.02778, 0.05556],
	        "115": [0, 0.43056, 0, 0.05556],
	        "116": [0, 0.61508, 0, 0.08334],
	        "117": [0, 0.43056, 0, 0.02778],
	        "118": [0, 0.43056, 0.03588, 0.02778],
	        "119": [0, 0.43056, 0.02691, 0.08334],
	        "120": [0, 0.43056, 0, 0.02778],
	        "121": [0.19444, 0.43056, 0.03588, 0.05556],
	        "122": [0, 0.43056, 0.04398, 0.05556],
	        "915": [0, 0.68333, 0.13889, 0.08334],
	        "916": [0, 0.68333, 0, 0.16667],
	        "920": [0, 0.68333, 0.02778, 0.08334],
	        "923": [0, 0.68333, 0, 0.16667],
	        "926": [0, 0.68333, 0.07569, 0.08334],
	        "928": [0, 0.68333, 0.08125, 0.05556],
	        "931": [0, 0.68333, 0.05764, 0.08334],
	        "933": [0, 0.68333, 0.13889, 0.05556],
	        "934": [0, 0.68333, 0, 0.08334],
	        "936": [0, 0.68333, 0.11, 0.05556],
	        "937": [0, 0.68333, 0.05017, 0.08334],
	        "945": [0, 0.43056, 0.0037, 0.02778],
	        "946": [0.19444, 0.69444, 0.05278, 0.08334],
	        "947": [0.19444, 0.43056, 0.05556, 0],
	        "948": [0, 0.69444, 0.03785, 0.05556],
	        "949": [0, 0.43056, 0, 0.08334],
	        "950": [0.19444, 0.69444, 0.07378, 0.08334],
	        "951": [0.19444, 0.43056, 0.03588, 0.05556],
	        "952": [0, 0.69444, 0.02778, 0.08334],
	        "953": [0, 0.43056, 0, 0.05556],
	        "954": [0, 0.43056, 0, 0],
	        "955": [0, 0.69444, 0, 0],
	        "956": [0.19444, 0.43056, 0, 0.02778],
	        "957": [0, 0.43056, 0.06366, 0.02778],
	        "958": [0.19444, 0.69444, 0.04601, 0.11111],
	        "959": [0, 0.43056, 0, 0.05556],
	        "960": [0, 0.43056, 0.03588, 0],
	        "961": [0.19444, 0.43056, 0, 0.08334],
	        "962": [0.09722, 0.43056, 0.07986, 0.08334],
	        "963": [0, 0.43056, 0.03588, 0],
	        "964": [0, 0.43056, 0.1132, 0.02778],
	        "965": [0, 0.43056, 0.03588, 0.02778],
	        "966": [0.19444, 0.43056, 0, 0.08334],
	        "967": [0.19444, 0.43056, 0, 0.05556],
	        "968": [0.19444, 0.69444, 0.03588, 0.11111],
	        "969": [0, 0.43056, 0.03588, 0],
	        "977": [0, 0.69444, 0, 0.08334],
	        "981": [0.19444, 0.69444, 0, 0.08334],
	        "982": [0, 0.43056, 0.02778, 0],
	        "1009": [0.19444, 0.43056, 0, 0.08334],
	        "1013": [0, 0.43056, 0, 0.05556],
	    },
	    "SansSerif-Regular": {
	        "33": [0, 0.69444, 0, 0],
	        "34": [0, 0.69444, 0, 0],
	        "35": [0.19444, 0.69444, 0, 0],
	        "36": [0.05556, 0.75, 0, 0],
	        "37": [0.05556, 0.75, 0, 0],
	        "38": [0, 0.69444, 0, 0],
	        "39": [0, 0.69444, 0, 0],
	        "40": [0.25, 0.75, 0, 0],
	        "41": [0.25, 0.75, 0, 0],
	        "42": [0, 0.75, 0, 0],
	        "43": [0.08333, 0.58333, 0, 0],
	        "44": [0.125, 0.08333, 0, 0],
	        "45": [0, 0.44444, 0, 0],
	        "46": [0, 0.08333, 0, 0],
	        "47": [0.25, 0.75, 0, 0],
	        "48": [0, 0.65556, 0, 0],
	        "49": [0, 0.65556, 0, 0],
	        "50": [0, 0.65556, 0, 0],
	        "51": [0, 0.65556, 0, 0],
	        "52": [0, 0.65556, 0, 0],
	        "53": [0, 0.65556, 0, 0],
	        "54": [0, 0.65556, 0, 0],
	        "55": [0, 0.65556, 0, 0],
	        "56": [0, 0.65556, 0, 0],
	        "57": [0, 0.65556, 0, 0],
	        "58": [0, 0.44444, 0, 0],
	        "59": [0.125, 0.44444, 0, 0],
	        "61": [-0.13, 0.37, 0, 0],
	        "63": [0, 0.69444, 0, 0],
	        "64": [0, 0.69444, 0, 0],
	        "65": [0, 0.69444, 0, 0],
	        "66": [0, 0.69444, 0, 0],
	        "67": [0, 0.69444, 0, 0],
	        "68": [0, 0.69444, 0, 0],
	        "69": [0, 0.69444, 0, 0],
	        "70": [0, 0.69444, 0, 0],
	        "71": [0, 0.69444, 0, 0],
	        "72": [0, 0.69444, 0, 0],
	        "73": [0, 0.69444, 0, 0],
	        "74": [0, 0.69444, 0, 0],
	        "75": [0, 0.69444, 0, 0],
	        "76": [0, 0.69444, 0, 0],
	        "77": [0, 0.69444, 0, 0],
	        "78": [0, 0.69444, 0, 0],
	        "79": [0, 0.69444, 0, 0],
	        "80": [0, 0.69444, 0, 0],
	        "81": [0.125, 0.69444, 0, 0],
	        "82": [0, 0.69444, 0, 0],
	        "83": [0, 0.69444, 0, 0],
	        "84": [0, 0.69444, 0, 0],
	        "85": [0, 0.69444, 0, 0],
	        "86": [0, 0.69444, 0.01389, 0],
	        "87": [0, 0.69444, 0.01389, 0],
	        "88": [0, 0.69444, 0, 0],
	        "89": [0, 0.69444, 0.025, 0],
	        "90": [0, 0.69444, 0, 0],
	        "91": [0.25, 0.75, 0, 0],
	        "93": [0.25, 0.75, 0, 0],
	        "94": [0, 0.69444, 0, 0],
	        "95": [0.35, 0.09444, 0.02778, 0],
	        "97": [0, 0.44444, 0, 0],
	        "98": [0, 0.69444, 0, 0],
	        "99": [0, 0.44444, 0, 0],
	        "100": [0, 0.69444, 0, 0],
	        "101": [0, 0.44444, 0, 0],
	        "102": [0, 0.69444, 0.06944, 0],
	        "103": [0.19444, 0.44444, 0.01389, 0],
	        "104": [0, 0.69444, 0, 0],
	        "105": [0, 0.67937, 0, 0],
	        "106": [0.19444, 0.67937, 0, 0],
	        "107": [0, 0.69444, 0, 0],
	        "108": [0, 0.69444, 0, 0],
	        "109": [0, 0.44444, 0, 0],
	        "110": [0, 0.44444, 0, 0],
	        "111": [0, 0.44444, 0, 0],
	        "112": [0.19444, 0.44444, 0, 0],
	        "113": [0.19444, 0.44444, 0, 0],
	        "114": [0, 0.44444, 0.01389, 0],
	        "115": [0, 0.44444, 0, 0],
	        "116": [0, 0.57143, 0, 0],
	        "117": [0, 0.44444, 0, 0],
	        "118": [0, 0.44444, 0.01389, 0],
	        "119": [0, 0.44444, 0.01389, 0],
	        "120": [0, 0.44444, 0, 0],
	        "121": [0.19444, 0.44444, 0.01389, 0],
	        "122": [0, 0.44444, 0, 0],
	        "126": [0.35, 0.32659, 0, 0],
	        "305": [0, 0.44444, 0, 0],
	        "567": [0.19444, 0.44444, 0, 0],
	        "768": [0, 0.69444, 0, 0],
	        "769": [0, 0.69444, 0, 0],
	        "770": [0, 0.69444, 0, 0],
	        "771": [0, 0.67659, 0, 0],
	        "772": [0, 0.60889, 0, 0],
	        "774": [0, 0.69444, 0, 0],
	        "775": [0, 0.67937, 0, 0],
	        "776": [0, 0.67937, 0, 0],
	        "778": [0, 0.69444, 0, 0],
	        "779": [0, 0.69444, 0, 0],
	        "780": [0, 0.63194, 0, 0],
	        "915": [0, 0.69444, 0, 0],
	        "916": [0, 0.69444, 0, 0],
	        "920": [0, 0.69444, 0, 0],
	        "923": [0, 0.69444, 0, 0],
	        "926": [0, 0.69444, 0, 0],
	        "928": [0, 0.69444, 0, 0],
	        "931": [0, 0.69444, 0, 0],
	        "933": [0, 0.69444, 0, 0],
	        "934": [0, 0.69444, 0, 0],
	        "936": [0, 0.69444, 0, 0],
	        "937": [0, 0.69444, 0, 0],
	        "8211": [0, 0.44444, 0.02778, 0],
	        "8212": [0, 0.44444, 0.02778, 0],
	        "8216": [0, 0.69444, 0, 0],
	        "8217": [0, 0.69444, 0, 0],
	        "8220": [0, 0.69444, 0, 0],
	        "8221": [0, 0.69444, 0, 0],
	    },
	    "Script-Regular": {
	        "65": [0, 0.7, 0.22925, 0],
	        "66": [0, 0.7, 0.04087, 0],
	        "67": [0, 0.7, 0.1689, 0],
	        "68": [0, 0.7, 0.09371, 0],
	        "69": [0, 0.7, 0.18583, 0],
	        "70": [0, 0.7, 0.13634, 0],
	        "71": [0, 0.7, 0.17322, 0],
	        "72": [0, 0.7, 0.29694, 0],
	        "73": [0, 0.7, 0.19189, 0],
	        "74": [0.27778, 0.7, 0.19189, 0],
	        "75": [0, 0.7, 0.31259, 0],
	        "76": [0, 0.7, 0.19189, 0],
	        "77": [0, 0.7, 0.15981, 0],
	        "78": [0, 0.7, 0.3525, 0],
	        "79": [0, 0.7, 0.08078, 0],
	        "80": [0, 0.7, 0.08078, 0],
	        "81": [0, 0.7, 0.03305, 0],
	        "82": [0, 0.7, 0.06259, 0],
	        "83": [0, 0.7, 0.19189, 0],
	        "84": [0, 0.7, 0.29087, 0],
	        "85": [0, 0.7, 0.25815, 0],
	        "86": [0, 0.7, 0.27523, 0],
	        "87": [0, 0.7, 0.27523, 0],
	        "88": [0, 0.7, 0.26006, 0],
	        "89": [0, 0.7, 0.2939, 0],
	        "90": [0, 0.7, 0.24037, 0],
	    },
	    "Size1-Regular": {
	        "40": [0.35001, 0.85, 0, 0],
	        "41": [0.35001, 0.85, 0, 0],
	        "47": [0.35001, 0.85, 0, 0],
	        "91": [0.35001, 0.85, 0, 0],
	        "92": [0.35001, 0.85, 0, 0],
	        "93": [0.35001, 0.85, 0, 0],
	        "123": [0.35001, 0.85, 0, 0],
	        "125": [0.35001, 0.85, 0, 0],
	        "710": [0, 0.72222, 0, 0],
	        "732": [0, 0.72222, 0, 0],
	        "770": [0, 0.72222, 0, 0],
	        "771": [0, 0.72222, 0, 0],
	        "8214": [-0.00099, 0.601, 0, 0],
	        "8593": [1e-05, 0.6, 0, 0],
	        "8595": [1e-05, 0.6, 0, 0],
	        "8657": [1e-05, 0.6, 0, 0],
	        "8659": [1e-05, 0.6, 0, 0],
	        "8719": [0.25001, 0.75, 0, 0],
	        "8720": [0.25001, 0.75, 0, 0],
	        "8721": [0.25001, 0.75, 0, 0],
	        "8730": [0.35001, 0.85, 0, 0],
	        "8739": [-0.00599, 0.606, 0, 0],
	        "8741": [-0.00599, 0.606, 0, 0],
	        "8747": [0.30612, 0.805, 0.19445, 0],
	        "8748": [0.306, 0.805, 0.19445, 0],
	        "8749": [0.306, 0.805, 0.19445, 0],
	        "8750": [0.30612, 0.805, 0.19445, 0],
	        "8896": [0.25001, 0.75, 0, 0],
	        "8897": [0.25001, 0.75, 0, 0],
	        "8898": [0.25001, 0.75, 0, 0],
	        "8899": [0.25001, 0.75, 0, 0],
	        "8968": [0.35001, 0.85, 0, 0],
	        "8969": [0.35001, 0.85, 0, 0],
	        "8970": [0.35001, 0.85, 0, 0],
	        "8971": [0.35001, 0.85, 0, 0],
	        "9168": [-0.00099, 0.601, 0, 0],
	        "10216": [0.35001, 0.85, 0, 0],
	        "10217": [0.35001, 0.85, 0, 0],
	        "10752": [0.25001, 0.75, 0, 0],
	        "10753": [0.25001, 0.75, 0, 0],
	        "10754": [0.25001, 0.75, 0, 0],
	        "10756": [0.25001, 0.75, 0, 0],
	        "10758": [0.25001, 0.75, 0, 0],
	    },
	    "Size2-Regular": {
	        "40": [0.65002, 1.15, 0, 0],
	        "41": [0.65002, 1.15, 0, 0],
	        "47": [0.65002, 1.15, 0, 0],
	        "91": [0.65002, 1.15, 0, 0],
	        "92": [0.65002, 1.15, 0, 0],
	        "93": [0.65002, 1.15, 0, 0],
	        "123": [0.65002, 1.15, 0, 0],
	        "125": [0.65002, 1.15, 0, 0],
	        "710": [0, 0.75, 0, 0],
	        "732": [0, 0.75, 0, 0],
	        "770": [0, 0.75, 0, 0],
	        "771": [0, 0.75, 0, 0],
	        "8719": [0.55001, 1.05, 0, 0],
	        "8720": [0.55001, 1.05, 0, 0],
	        "8721": [0.55001, 1.05, 0, 0],
	        "8730": [0.65002, 1.15, 0, 0],
	        "8747": [0.86225, 1.36, 0.44445, 0],
	        "8748": [0.862, 1.36, 0.44445, 0],
	        "8749": [0.862, 1.36, 0.44445, 0],
	        "8750": [0.86225, 1.36, 0.44445, 0],
	        "8896": [0.55001, 1.05, 0, 0],
	        "8897": [0.55001, 1.05, 0, 0],
	        "8898": [0.55001, 1.05, 0, 0],
	        "8899": [0.55001, 1.05, 0, 0],
	        "8968": [0.65002, 1.15, 0, 0],
	        "8969": [0.65002, 1.15, 0, 0],
	        "8970": [0.65002, 1.15, 0, 0],
	        "8971": [0.65002, 1.15, 0, 0],
	        "10216": [0.65002, 1.15, 0, 0],
	        "10217": [0.65002, 1.15, 0, 0],
	        "10752": [0.55001, 1.05, 0, 0],
	        "10753": [0.55001, 1.05, 0, 0],
	        "10754": [0.55001, 1.05, 0, 0],
	        "10756": [0.55001, 1.05, 0, 0],
	        "10758": [0.55001, 1.05, 0, 0],
	    },
	    "Size3-Regular": {
	        "40": [0.95003, 1.45, 0, 0],
	        "41": [0.95003, 1.45, 0, 0],
	        "47": [0.95003, 1.45, 0, 0],
	        "91": [0.95003, 1.45, 0, 0],
	        "92": [0.95003, 1.45, 0, 0],
	        "93": [0.95003, 1.45, 0, 0],
	        "123": [0.95003, 1.45, 0, 0],
	        "125": [0.95003, 1.45, 0, 0],
	        "710": [0, 0.75, 0, 0],
	        "732": [0, 0.75, 0, 0],
	        "770": [0, 0.75, 0, 0],
	        "771": [0, 0.75, 0, 0],
	        "8730": [0.95003, 1.45, 0, 0],
	        "8968": [0.95003, 1.45, 0, 0],
	        "8969": [0.95003, 1.45, 0, 0],
	        "8970": [0.95003, 1.45, 0, 0],
	        "8971": [0.95003, 1.45, 0, 0],
	        "10216": [0.95003, 1.45, 0, 0],
	        "10217": [0.95003, 1.45, 0, 0],
	    },
	    "Size4-Regular": {
	        "40": [1.25003, 1.75, 0, 0],
	        "41": [1.25003, 1.75, 0, 0],
	        "47": [1.25003, 1.75, 0, 0],
	        "91": [1.25003, 1.75, 0, 0],
	        "92": [1.25003, 1.75, 0, 0],
	        "93": [1.25003, 1.75, 0, 0],
	        "123": [1.25003, 1.75, 0, 0],
	        "125": [1.25003, 1.75, 0, 0],
	        "710": [0, 0.825, 0, 0],
	        "732": [0, 0.825, 0, 0],
	        "770": [0, 0.825, 0, 0],
	        "771": [0, 0.825, 0, 0],
	        "8730": [1.25003, 1.75, 0, 0],
	        "8968": [1.25003, 1.75, 0, 0],
	        "8969": [1.25003, 1.75, 0, 0],
	        "8970": [1.25003, 1.75, 0, 0],
	        "8971": [1.25003, 1.75, 0, 0],
	        "9115": [0.64502, 1.155, 0, 0],
	        "9116": [1e-05, 0.6, 0, 0],
	        "9117": [0.64502, 1.155, 0, 0],
	        "9118": [0.64502, 1.155, 0, 0],
	        "9119": [1e-05, 0.6, 0, 0],
	        "9120": [0.64502, 1.155, 0, 0],
	        "9121": [0.64502, 1.155, 0, 0],
	        "9122": [-0.00099, 0.601, 0, 0],
	        "9123": [0.64502, 1.155, 0, 0],
	        "9124": [0.64502, 1.155, 0, 0],
	        "9125": [-0.00099, 0.601, 0, 0],
	        "9126": [0.64502, 1.155, 0, 0],
	        "9127": [1e-05, 0.9, 0, 0],
	        "9128": [0.65002, 1.15, 0, 0],
	        "9129": [0.90001, 0, 0, 0],
	        "9130": [0, 0.3, 0, 0],
	        "9131": [1e-05, 0.9, 0, 0],
	        "9132": [0.65002, 1.15, 0, 0],
	        "9133": [0.90001, 0, 0, 0],
	        "9143": [0.88502, 0.915, 0, 0],
	        "10216": [1.25003, 1.75, 0, 0],
	        "10217": [1.25003, 1.75, 0, 0],
	        "57344": [-0.00499, 0.605, 0, 0],
	        "57345": [-0.00499, 0.605, 0, 0],
	        "57680": [0, 0.12, 0, 0],
	        "57681": [0, 0.12, 0, 0],
	        "57682": [0, 0.12, 0, 0],
	        "57683": [0, 0.12, 0, 0],
	    },
	    "Typewriter-Regular": {
	        "33": [0, 0.61111, 0, 0],
	        "34": [0, 0.61111, 0, 0],
	        "35": [0, 0.61111, 0, 0],
	        "36": [0.08333, 0.69444, 0, 0],
	        "37": [0.08333, 0.69444, 0, 0],
	        "38": [0, 0.61111, 0, 0],
	        "39": [0, 0.61111, 0, 0],
	        "40": [0.08333, 0.69444, 0, 0],
	        "41": [0.08333, 0.69444, 0, 0],
	        "42": [0, 0.52083, 0, 0],
	        "43": [-0.08056, 0.53055, 0, 0],
	        "44": [0.13889, 0.125, 0, 0],
	        "45": [-0.08056, 0.53055, 0, 0],
	        "46": [0, 0.125, 0, 0],
	        "47": [0.08333, 0.69444, 0, 0],
	        "48": [0, 0.61111, 0, 0],
	        "49": [0, 0.61111, 0, 0],
	        "50": [0, 0.61111, 0, 0],
	        "51": [0, 0.61111, 0, 0],
	        "52": [0, 0.61111, 0, 0],
	        "53": [0, 0.61111, 0, 0],
	        "54": [0, 0.61111, 0, 0],
	        "55": [0, 0.61111, 0, 0],
	        "56": [0, 0.61111, 0, 0],
	        "57": [0, 0.61111, 0, 0],
	        "58": [0, 0.43056, 0, 0],
	        "59": [0.13889, 0.43056, 0, 0],
	        "60": [-0.05556, 0.55556, 0, 0],
	        "61": [-0.19549, 0.41562, 0, 0],
	        "62": [-0.05556, 0.55556, 0, 0],
	        "63": [0, 0.61111, 0, 0],
	        "64": [0, 0.61111, 0, 0],
	        "65": [0, 0.61111, 0, 0],
	        "66": [0, 0.61111, 0, 0],
	        "67": [0, 0.61111, 0, 0],
	        "68": [0, 0.61111, 0, 0],
	        "69": [0, 0.61111, 0, 0],
	        "70": [0, 0.61111, 0, 0],
	        "71": [0, 0.61111, 0, 0],
	        "72": [0, 0.61111, 0, 0],
	        "73": [0, 0.61111, 0, 0],
	        "74": [0, 0.61111, 0, 0],
	        "75": [0, 0.61111, 0, 0],
	        "76": [0, 0.61111, 0, 0],
	        "77": [0, 0.61111, 0, 0],
	        "78": [0, 0.61111, 0, 0],
	        "79": [0, 0.61111, 0, 0],
	        "80": [0, 0.61111, 0, 0],
	        "81": [0.13889, 0.61111, 0, 0],
	        "82": [0, 0.61111, 0, 0],
	        "83": [0, 0.61111, 0, 0],
	        "84": [0, 0.61111, 0, 0],
	        "85": [0, 0.61111, 0, 0],
	        "86": [0, 0.61111, 0, 0],
	        "87": [0, 0.61111, 0, 0],
	        "88": [0, 0.61111, 0, 0],
	        "89": [0, 0.61111, 0, 0],
	        "90": [0, 0.61111, 0, 0],
	        "91": [0.08333, 0.69444, 0, 0],
	        "92": [0.08333, 0.69444, 0, 0],
	        "93": [0.08333, 0.69444, 0, 0],
	        "94": [0, 0.61111, 0, 0],
	        "95": [0.09514, 0, 0, 0],
	        "96": [0, 0.61111, 0, 0],
	        "97": [0, 0.43056, 0, 0],
	        "98": [0, 0.61111, 0, 0],
	        "99": [0, 0.43056, 0, 0],
	        "100": [0, 0.61111, 0, 0],
	        "101": [0, 0.43056, 0, 0],
	        "102": [0, 0.61111, 0, 0],
	        "103": [0.22222, 0.43056, 0, 0],
	        "104": [0, 0.61111, 0, 0],
	        "105": [0, 0.61111, 0, 0],
	        "106": [0.22222, 0.61111, 0, 0],
	        "107": [0, 0.61111, 0, 0],
	        "108": [0, 0.61111, 0, 0],
	        "109": [0, 0.43056, 0, 0],
	        "110": [0, 0.43056, 0, 0],
	        "111": [0, 0.43056, 0, 0],
	        "112": [0.22222, 0.43056, 0, 0],
	        "113": [0.22222, 0.43056, 0, 0],
	        "114": [0, 0.43056, 0, 0],
	        "115": [0, 0.43056, 0, 0],
	        "116": [0, 0.55358, 0, 0],
	        "117": [0, 0.43056, 0, 0],
	        "118": [0, 0.43056, 0, 0],
	        "119": [0, 0.43056, 0, 0],
	        "120": [0, 0.43056, 0, 0],
	        "121": [0.22222, 0.43056, 0, 0],
	        "122": [0, 0.43056, 0, 0],
	        "123": [0.08333, 0.69444, 0, 0],
	        "124": [0.08333, 0.69444, 0, 0],
	        "125": [0.08333, 0.69444, 0, 0],
	        "126": [0, 0.61111, 0, 0],
	        "127": [0, 0.61111, 0, 0],
	        "305": [0, 0.43056, 0, 0],
	        "567": [0.22222, 0.43056, 0, 0],
	        "768": [0, 0.61111, 0, 0],
	        "769": [0, 0.61111, 0, 0],
	        "770": [0, 0.61111, 0, 0],
	        "771": [0, 0.61111, 0, 0],
	        "772": [0, 0.56555, 0, 0],
	        "774": [0, 0.61111, 0, 0],
	        "776": [0, 0.61111, 0, 0],
	        "778": [0, 0.61111, 0, 0],
	        "780": [0, 0.56597, 0, 0],
	        "915": [0, 0.61111, 0, 0],
	        "916": [0, 0.61111, 0, 0],
	        "920": [0, 0.61111, 0, 0],
	        "923": [0, 0.61111, 0, 0],
	        "926": [0, 0.61111, 0, 0],
	        "928": [0, 0.61111, 0, 0],
	        "931": [0, 0.61111, 0, 0],
	        "933": [0, 0.61111, 0, 0],
	        "934": [0, 0.61111, 0, 0],
	        "936": [0, 0.61111, 0, 0],
	        "937": [0, 0.61111, 0, 0],
	        "2018": [0, 0.61111, 0, 0],
	        "2019": [0, 0.61111, 0, 0],
	        "8242": [0, 0.61111, 0, 0],
	    },
	};
	


/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	var utils = __webpack_require__(97);
	var ParseError = __webpack_require__(112);
	
	/* This file contains a list of functions that we parse, identified by
	 * the calls to defineFunction.
	 *
	 * The first argument to defineFunction is a single name or a list of names.
	 * All functions named in such a list will share a single implementation.
	 *
	 * Each declared function can have associated properties, which
	 * include the following:
	 *
	 *  - numArgs: The number of arguments the function takes.
	 *             If this is the only property, it can be passed as a number
	 *             instead of an element of a properties object.
	 *  - argTypes: (optional) An array corresponding to each argument of the
	 *              function, giving the type of argument that should be parsed. Its
	 *              length should be equal to `numArgs + numOptionalArgs`. Valid
	 *              types:
	 *               - "size": A size-like thing, such as "1em" or "5ex"
	 *               - "color": An html color, like "#abc" or "blue"
	 *               - "original": The same type as the environment that the
	 *                             function being parsed is in (e.g. used for the
	 *                             bodies of functions like \color where the first
	 *                             argument is special and the second argument is
	 *                             parsed normally)
	 *              Other possible types (probably shouldn't be used)
	 *               - "text": Text-like (e.g. \text)
	 *               - "math": Normal math
	 *              If undefined, this will be treated as an appropriate length
	 *              array of "original" strings
	 *  - greediness: (optional) The greediness of the function to use ungrouped
	 *                arguments.
	 *
	 *                E.g. if you have an expression
	 *                  \sqrt \frac 1 2
	 *                since \frac has greediness=2 vs \sqrt's greediness=1, \frac
	 *                will use the two arguments '1' and '2' as its two arguments,
	 *                then that whole function will be used as the argument to
	 *                \sqrt. On the other hand, the expressions
	 *                  \frac \frac 1 2 3
	 *                and
	 *                  \frac \sqrt 1 2
	 *                will fail because \frac and \frac have equal greediness
	 *                and \sqrt has a lower greediness than \frac respectively. To
	 *                make these parse, we would have to change them to:
	 *                  \frac {\frac 1 2} 3
	 *                and
	 *                  \frac {\sqrt 1} 2
	 *
	 *                The default value is `1`
	 *  - allowedInText: (optional) Whether or not the function is allowed inside
	 *                   text mode (default false)
	 *  - numOptionalArgs: (optional) The number of optional arguments the function
	 *                     should parse. If the optional arguments aren't found,
	 *                     `null` will be passed to the handler in their place.
	 *                     (default 0)
	 *
	 * The last argument is that implementation, the handler for the function(s).
	 * It is called to handle these functions and their arguments.
	 * It receives two arguments:
	 *  - context contains information and references provided by the parser
	 *  - args is an array of arguments obtained from TeX input
	 * The context contains the following properties:
	 *  - funcName: the text (i.e. name) of the function, including \
	 *  - parser: the parser object
	 *  - lexer: the lexer object
	 *  - positions: the positions in the overall string of the function
	 *               and the arguments.
	 * The latter three should only be used to produce error messages.
	 *
	 * The function should return an object with the following keys:
	 *  - type: The type of element that this is. This is then used in
	 *          buildHTML/buildMathML to determine which function
	 *          should be called to build this node into a DOM node
	 * Any other data can be added to the object, which will be passed
	 * in to the function in buildHTML/buildMathML as `group.value`.
	 */
	
	function defineFunction(names, props, handler) {
	    if (typeof names === "string") {
	        names = [names];
	    }
	    if (typeof props === "number") {
	        props = { numArgs: props };
	    }
	    // Set default values of functions
	    var data = {
	        numArgs: props.numArgs,
	        argTypes: props.argTypes,
	        greediness: (props.greediness === undefined) ? 1 : props.greediness,
	        allowedInText: !!props.allowedInText,
	        numOptionalArgs: props.numOptionalArgs || 0,
	        handler: handler,
	    };
	    for (var i = 0; i < names.length; ++i) {
	        module.e[names[i]] = data;
	    }
	}
	
	// A normal square root
	defineFunction("\\sqrt", {
	    numArgs: 1,
	    numOptionalArgs: 1,
	}, function(context, args) {
	    var index = args[0];
	    var body = args[1];
	    return {
	        type: "sqrt",
	        body: body,
	        index: index,
	    };
	});
	
	// Some non-mathy text
	defineFunction("\\text", {
	    numArgs: 1,
	    argTypes: ["text"],
	    greediness: 2,
	}, function(context, args) {
	    var body = args[0];
	    // Since the corresponding buildHTML/buildMathML function expects a
	    // list of elements, we normalize for different kinds of arguments
	    // TODO(emily): maybe this should be done somewhere else
	    var inner;
	    if (body.type === "ordgroup") {
	        inner = body.value;
	    } else {
	        inner = [body];
	    }
	
	    return {
	        type: "text",
	        body: inner,
	    };
	});
	
	// A two-argument custom color
	defineFunction("\\color", {
	    numArgs: 2,
	    allowedInText: true,
	    greediness: 3,
	    argTypes: ["color", "original"],
	}, function(context, args) {
	    var color = args[0];
	    var body = args[1];
	    // Normalize the different kinds of bodies (see \text above)
	    var inner;
	    if (body.type === "ordgroup") {
	        inner = body.value;
	    } else {
	        inner = [body];
	    }
	
	    return {
	        type: "color",
	        color: color.value,
	        value: inner,
	    };
	});
	
	// An overline
	defineFunction("\\overline", {
	    numArgs: 1,
	}, function(context, args) {
	    var body = args[0];
	    return {
	        type: "overline",
	        body: body,
	    };
	});
	
	// A box of the width and height
	defineFunction("\\rule", {
	    numArgs: 2,
	    numOptionalArgs: 1,
	    argTypes: ["size", "size", "size"],
	}, function(context, args) {
	    var shift = args[0];
	    var width = args[1];
	    var height = args[2];
	    return {
	        type: "rule",
	        shift: shift && shift.value,
	        width: width.value,
	        height: height.value,
	    };
	});
	
	// A KaTeX logo
	defineFunction("\\KaTeX", {
	    numArgs: 0,
	}, function(context) {
	    return {
	        type: "katex",
	    };
	});
	
	defineFunction("\\phantom", {
	    numArgs: 1,
	}, function(context, args) {
	    var body = args[0];
	    var inner;
	    if (body.type === "ordgroup") {
	        inner = body.value;
	    } else {
	        inner = [body];
	    }
	
	    return {
	        type: "phantom",
	        value: inner,
	    };
	});
	
	// Extra data needed for the delimiter handler down below
	var delimiterSizes = {
	    "\\bigl" : {type: "open",    size: 1},
	    "\\Bigl" : {type: "open",    size: 2},
	    "\\biggl": {type: "open",    size: 3},
	    "\\Biggl": {type: "open",    size: 4},
	    "\\bigr" : {type: "close",   size: 1},
	    "\\Bigr" : {type: "close",   size: 2},
	    "\\biggr": {type: "close",   size: 3},
	    "\\Biggr": {type: "close",   size: 4},
	    "\\bigm" : {type: "rel",     size: 1},
	    "\\Bigm" : {type: "rel",     size: 2},
	    "\\biggm": {type: "rel",     size: 3},
	    "\\Biggm": {type: "rel",     size: 4},
	    "\\big"  : {type: "textord", size: 1},
	    "\\Big"  : {type: "textord", size: 2},
	    "\\bigg" : {type: "textord", size: 3},
	    "\\Bigg" : {type: "textord", size: 4},
	};
	
	var delimiters = [
	    "(", ")", "[", "\\lbrack", "]", "\\rbrack",
	    "\\{", "\\lbrace", "\\}", "\\rbrace",
	    "\\lfloor", "\\rfloor", "\\lceil", "\\rceil",
	    "<", ">", "\\langle", "\\rangle", "\\lt", "\\gt",
	    "\\lvert", "\\rvert", "\\lVert", "\\rVert",
	    "\\lgroup", "\\rgroup", "\\lmoustache", "\\rmoustache",
	    "/", "\\backslash",
	    "|", "\\vert", "\\|", "\\Vert",
	    "\\uparrow", "\\Uparrow",
	    "\\downarrow", "\\Downarrow",
	    "\\updownarrow", "\\Updownarrow",
	    ".",
	];
	
	var fontAliases = {
	    "\\Bbb": "\\mathbb",
	    "\\bold": "\\mathbf",
	    "\\frak": "\\mathfrak",
	};
	
	// Single-argument color functions
	defineFunction([
	    "\\blue", "\\orange", "\\pink", "\\red",
	    "\\green", "\\gray", "\\purple",
	    "\\blueA", "\\blueB", "\\blueC", "\\blueD", "\\blueE",
	    "\\tealA", "\\tealB", "\\tealC", "\\tealD", "\\tealE",
	    "\\greenA", "\\greenB", "\\greenC", "\\greenD", "\\greenE",
	    "\\goldA", "\\goldB", "\\goldC", "\\goldD", "\\goldE",
	    "\\redA", "\\redB", "\\redC", "\\redD", "\\redE",
	    "\\maroonA", "\\maroonB", "\\maroonC", "\\maroonD", "\\maroonE",
	    "\\purpleA", "\\purpleB", "\\purpleC", "\\purpleD", "\\purpleE",
	    "\\mintA", "\\mintB", "\\mintC",
	    "\\grayA", "\\grayB", "\\grayC", "\\grayD", "\\grayE",
	    "\\grayF", "\\grayG", "\\grayH", "\\grayI",
	    "\\kaBlue", "\\kaGreen",
	], {
	    numArgs: 1,
	    allowedInText: true,
	    greediness: 3,
	}, function(context, args) {
	    var body = args[0];
	    var atoms;
	    if (body.type === "ordgroup") {
	        atoms = body.value;
	    } else {
	        atoms = [body];
	    }
	
	    return {
	        type: "color",
	        color: "katex-" + context.funcName.slice(1),
	        value: atoms,
	    };
	});
	
	// There are 2 flags for operators; whether they produce limits in
	// displaystyle, and whether they are symbols and should grow in
	// displaystyle. These four groups cover the four possible choices.
	
	// No limits, not symbols
	defineFunction([
	    "\\arcsin", "\\arccos", "\\arctan", "\\arg", "\\cos", "\\cosh",
	    "\\cot", "\\coth", "\\csc", "\\deg", "\\dim", "\\exp", "\\hom",
	    "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh",
	    "\\tan", "\\tanh",
	], {
	    numArgs: 0,
	}, function(context) {
	    return {
	        type: "op",
	        limits: false,
	        symbol: false,
	        body: context.funcName,
	    };
	});
	
	// Limits, not symbols
	defineFunction([
	    "\\det", "\\gcd", "\\inf", "\\lim", "\\liminf", "\\limsup", "\\max",
	    "\\min", "\\Pr", "\\sup",
	], {
	    numArgs: 0,
	}, function(context) {
	    return {
	        type: "op",
	        limits: true,
	        symbol: false,
	        body: context.funcName,
	    };
	});
	
	// No limits, symbols
	defineFunction([
	    "\\int", "\\iint", "\\iiint", "\\oint",
	], {
	    numArgs: 0,
	}, function(context) {
	    return {
	        type: "op",
	        limits: false,
	        symbol: true,
	        body: context.funcName,
	    };
	});
	
	// Limits, symbols
	defineFunction([
	    "\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap",
	    "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes",
	    "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint",
	], {
	    numArgs: 0,
	}, function(context) {
	    return {
	        type: "op",
	        limits: true,
	        symbol: true,
	        body: context.funcName,
	    };
	});
	
	// Fractions
	defineFunction([
	    "\\dfrac", "\\frac", "\\tfrac",
	    "\\dbinom", "\\binom", "\\tbinom",
	], {
	    numArgs: 2,
	    greediness: 2,
	}, function(context, args) {
	    var numer = args[0];
	    var denom = args[1];
	    var hasBarLine;
	    var leftDelim = null;
	    var rightDelim = null;
	    var size = "auto";
	
	    switch (context.funcName) {
	        case "\\dfrac":
	        case "\\frac":
	        case "\\tfrac":
	            hasBarLine = true;
	            break;
	        case "\\dbinom":
	        case "\\binom":
	        case "\\tbinom":
	            hasBarLine = false;
	            leftDelim = "(";
	            rightDelim = ")";
	            break;
	        default:
	            throw new Error("Unrecognized genfrac command");
	    }
	
	    switch (context.funcName) {
	        case "\\dfrac":
	        case "\\dbinom":
	            size = "display";
	            break;
	        case "\\tfrac":
	        case "\\tbinom":
	            size = "text";
	            break;
	    }
	
	    return {
	        type: "genfrac",
	        numer: numer,
	        denom: denom,
	        hasBarLine: hasBarLine,
	        leftDelim: leftDelim,
	        rightDelim: rightDelim,
	        size: size,
	    };
	});
	
	// Left and right overlap functions
	defineFunction(["\\llap", "\\rlap"], {
	    numArgs: 1,
	    allowedInText: true,
	}, function(context, args) {
	    var body = args[0];
	    return {
	        type: context.funcName.slice(1),
	        body: body,
	    };
	});
	
	// Delimiter functions
	defineFunction([
	    "\\bigl", "\\Bigl", "\\biggl", "\\Biggl",
	    "\\bigr", "\\Bigr", "\\biggr", "\\Biggr",
	    "\\bigm", "\\Bigm", "\\biggm", "\\Biggm",
	    "\\big",  "\\Big",  "\\bigg",  "\\Bigg",
	    "\\left", "\\right",
	], {
	    numArgs: 1,
	}, function(context, args) {
	    var delim = args[0];
	    if (!utils.contains(delimiters, delim.value)) {
	        throw new ParseError(
	            "Invalid delimiter: '" + delim.value + "' after '" +
	                context.funcName + "'",
	            context.lexer, context.positions[1]);
	    }
	
	    // \left and \right are caught somewhere in Parser.js, which is
	    // why this data doesn't match what is in buildHTML.
	    if (context.funcName === "\\left" || context.funcName === "\\right") {
	        return {
	            type: "leftright",
	            value: delim.value,
	        };
	    } else {
	        return {
	            type: "delimsizing",
	            size: delimiterSizes[context.funcName].size,
	            delimType: delimiterSizes[context.funcName].type,
	            value: delim.value,
	        };
	    }
	});
	
	// Sizing functions (handled in Parser.js explicitly, hence no handler)
	defineFunction([
	    "\\tiny", "\\scriptsize", "\\footnotesize", "\\small",
	    "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge",
	], 0, null);
	
	// Style changing functions (handled in Parser.js explicitly, hence no
	// handler)
	defineFunction([
	    "\\displaystyle", "\\textstyle", "\\scriptstyle",
	    "\\scriptscriptstyle",
	], 0, null);
	
	defineFunction([
	    // styles
	    "\\mathrm", "\\mathit", "\\mathbf",
	
	    // families
	    "\\mathbb", "\\mathcal", "\\mathfrak", "\\mathscr", "\\mathsf",
	    "\\mathtt",
	
	    // aliases
	    "\\Bbb", "\\bold", "\\frak",
	], {
	    numArgs: 1,
	    greediness: 2,
	}, function(context, args) {
	    var body = args[0];
	    var func = context.funcName;
	    if (func in fontAliases) {
	        func = fontAliases[func];
	    }
	    return {
	        type: "font",
	        font: func.slice(1),
	        body: body,
	    };
	});
	
	// Accents
	defineFunction([
	    "\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve",
	    "\\check", "\\hat", "\\vec", "\\dot",
	    // We don't support expanding accents yet
	    // "\\widetilde", "\\widehat"
	], {
	    numArgs: 1,
	}, function(context, args) {
	    var base = args[0];
	    return {
	        type: "accent",
	        accent: context.funcName,
	        base: base,
	    };
	});
	
	// Infix generalized fractions
	defineFunction(["\\over", "\\choose"], {
	    numArgs: 0,
	}, function(context) {
	    var replaceWith;
	    switch (context.funcName) {
	        case "\\over":
	            replaceWith = "\\frac";
	            break;
	        case "\\choose":
	            replaceWith = "\\binom";
	            break;
	        default:
	            throw new Error("Unrecognized infix genfrac command");
	    }
	    return {
	        type: "infix",
	        replaceWith: replaceWith,
	    };
	});
	
	// Row breaks for aligned data
	defineFunction(["\\\\", "\\cr"], {
	    numArgs: 0,
	    numOptionalArgs: 1,
	    argTypes: ["size"],
	}, function(context, args) {
	    var size = args[0];
	    return {
	        type: "cr",
	        size: size,
	    };
	});
	
	// Environment delimiters
	defineFunction(["\\begin", "\\end"], {
	    numArgs: 1,
	    argTypes: ["text"],
	}, function(context, args) {
	    var nameGroup = args[0];
	    if (nameGroup.type !== "ordgroup") {
	        throw new ParseError(
	            "Invalid environment name",
	            context.lexer, context.positions[1]);
	    }
	    var name = "";
	    for (var i = 0; i < nameGroup.value.length; ++i) {
	        name += nameGroup.value[i].value;
	    }
	    return {
	        type: "environment",
	        name: name,
	        namepos: context.positions[1],
	    };
	});
	


/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * These objects store data about MathML nodes. This is the MathML equivalent
	 * of the types in domTree.js. Since MathML handles its own rendering, and
	 * since we're mainly using MathML to improve accessibility, we don't manage
	 * any of the styling state that the plain DOM nodes do.
	 *
	 * The `toNode` and `toMarkup` functions work simlarly to how they do in
	 * domTree.js, creating namespaced DOM nodes and HTML text markup respectively.
	 */
	
	var utils = __webpack_require__(97);
	
	/**
	 * This node represents a general purpose MathML node of any type. The
	 * constructor requires the type of node to create (for example, `"mo"` or
	 * `"mspace"`, corresponding to `<mo>` and `<mspace>` tags).
	 */
	function MathNode(type, children) {
	    this.type = type;
	    this.attributes = {};
	    this.children = children || [];
	}
	
	/**
	 * Sets an attribute on a MathML node. MathML depends on attributes to convey a
	 * semantic content, so this is used heavily.
	 */
	MathNode.prototype.setAttribute = function(name, value) {
	    this.attributes[name] = value;
	};
	
	/**
	 * Converts the math node into a MathML-namespaced DOM element.
	 */
	MathNode.prototype.toNode = function() {
	    var node = document.createElementNS(
	        "http://www.w3.org/1998/Math/MathML", this.type);
	
	    for (var attr in this.attributes) {
	        if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
	            node.setAttribute(attr, this.attributes[attr]);
	        }
	    }
	
	    for (var i = 0; i < this.children.length; i++) {
	        node.appendChild(this.children[i].toNode());
	    }
	
	    return node;
	};
	
	/**
	 * Converts the math node into an HTML markup string.
	 */
	MathNode.prototype.toMarkup = function() {
	    var markup = "<" + this.type;
	
	    // Add the attributes
	    for (var attr in this.attributes) {
	        if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
	            markup += " " + attr + "=\"";
	            markup += utils.escape(this.attributes[attr]);
	            markup += "\"";
	        }
	    }
	
	    markup += ">";
	
	    for (var i = 0; i < this.children.length; i++) {
	        markup += this.children[i].toMarkup();
	    }
	
	    markup += "</" + this.type + ">";
	
	    return markup;
	};
	
	/**
	 * This node represents a piece of text.
	 */
	function TextNode(text) {
	    this.text = text;
	}
	
	/**
	 * Converts the text node into a DOM text node.
	 */
	TextNode.prototype.toNode = function() {
	    return document.createTextNode(this.text);
	};
	
	/**
	 * Converts the text node into HTML markup (which is just the text itself).
	 */
	TextNode.prototype.toMarkup = function() {
	    return utils.escape(this.text);
	};
	
	module.e = {
	    MathNode: MathNode,
	    TextNode: TextNode,
	};
	


/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/**
	 * Provides a single function for parsing an expression using a Parser
	 * TODO(emily): Remove this
	 */
	
	var Parser = __webpack_require__(1742);
	
	/**
	 * Parses an expression using a Parser, then returns the parsed result.
	 */
	var parseTree = function(toParse, settings) {
	    var parser = new Parser(toParse, settings);
	
	    return parser.parse();
	};
	
	module.e = parseTree;
	


/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	module.e = [
		{
			"patterns": [
				"http://(?:www\\.)?xkcd\\.com/\\d+/?"
			],
			"name": "XKCD",
			"height": 110
		},
		{
			"patterns": [
				"https?://soundcloud.com/.*/.*"
			],
			"name": "SoundCloud",
			"height": 140
		},
		{
			"patterns": [
				"https?://(?:www\\.)?flickr\\.com/.*",
				"https?://flic\\.kr/p/[a-zA-Z0-9]+"
			],
			"name": "Flickr",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.ted\\.com/talks/.+\\.html"
			],
			"name": "TED",
			"height": 110
		},
		{
			"patterns": [
				"http://(?:www\\.)?theverge\\.com/\\d{4}/\\d{1,2}/\\d{1,2}/\\d+/[^/]+/?$"
			],
			"name": "The Verge",
			"height": 110
		},
		{
			"patterns": [
				"http://.*\\.viddler\\.com/.*"
			],
			"name": "Viddler",
			"height": 110
		},
		{
			"patterns": [
				"https?://(?:www\\.)?avclub\\.com/article/[^/]+/?$"
			],
			"name": "The AV Club",
			"height": 110
		},
		{
			"patterns": [
				"https?://(?:www\\.)?wired\\.com/([^/]+/)?\\d+/\\d+/[^/]+/?$"
			],
			"name": "Wired",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.theonion\\.com/articles/[^/]+/?"
			],
			"name": "The Onion",
			"height": 110
		},
		{
			"patterns": [
				"http://yfrog\\.com/[0-9a-zA-Z]+/?$"
			],
			"name": "YFrog",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.duffelblog\\.com/\\d{4}/\\d{1,2}/[^/]+/?$"
			],
			"name": "The Duffel Blog",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.clickhole\\.com/article/[^/]+/?"
			],
			"name": "Clickhole",
			"height": 110
		},
		{
			"patterns": [
				"https?://(?:www.)?skitch.com/([^/]+)/[^/]+/.+",
				"http://skit.ch/[^/]+"
			],
			"name": "Skitch",
			"height": 110
		},
		{
			"patterns": [
				"https?://(alpha|posts|photos)\\.app\\.net/.*"
			],
			"name": "ADN",
			"height": 110
		},
		{
			"patterns": [
				"https?://gist\\.github\\.com/(?:[-0-9a-zA-Z]+/)?([0-9a-fA-f]+)"
			],
			"name": "Gist",
			"height": 110
		},
		{
			"patterns": [
				"https?://www\\.(dropbox\\.com/s/.+\\.(?:jpg|png|gif))",
				"https?://db\\.tt/[a-zA-Z0-9]+"
			],
			"name": "Dropbox",
			"height": 110
		},
		{
			"patterns": [
				"https?://[^\\.]+\\.wikipedia\\.org/wiki/(?!Talk:)[^#]+(?:#(.+))?"
			],
			"name": "Wikipedia",
			"height": 110
		},
		{
			"patterns": [
				"http://www.traileraddict.com/trailer/[^/]+/trailer"
			],
			"name": "TrailerAddict",
			"height": 110
		},
		{
			"patterns": [
				"http://lockerz\\.com/[sd]/\\d+"
			],
			"name": "Lockerz",
			"height": 110
		},
		{
			"patterns": [
				"http://gifuk\\.com/s/[0-9a-f]{16}"
			],
			"name": "GIFUK",
			"height": 110
		},
		{
			"patterns": [
				"http://trailers\\.apple\\.com/trailers/[^/]+/[^/]+"
			],
			"name": "iTunes Movie Trailers",
			"height": 110
		},
		{
			"patterns": [
				"http://gfycat\\.com/([a-zA-Z]+)"
			],
			"name": "Gfycat",
			"height": 110
		},
		{
			"patterns": [
				"http://bash\\.org/\\?(\\d+)"
			],
			"name": "Bash.org",
			"height": 110
		},
		{
			"patterns": [
				"http://arstechnica\\.com/[^/]+/\\d+/\\d+/[^/]+/?$"
			],
			"name": "Ars Technica",
			"height": 110
		},
		{
			"patterns": [
				"http://imgur\\.com/gallery/[0-9a-zA-Z]+"
			],
			"name": "Imgur",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.asciiartfarts\\.com/[0-9]+\\.html"
			],
			"name": "ASCII Art Farts",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.monoprice\\.com/products/product\\.asp\\?.*p_id=\\d+"
			],
			"name": "Monoprice",
			"height": 110
		},
		{
			"patterns": [
				"http://boingboing\\.net/\\d{4}/\\d{2}/\\d{2}/[^/]+\\.html"
			],
			"name": "Boing Boing",
			"height": 110
		},
		{
			"patterns": [
				"https?://github\\.com/([^/]+)/([^/]+)/commit/(.+)",
				"http://git\\.io/[_0-9a-zA-Z]+"
			],
			"name": "Github Commit",
			"height": 110
		},
		{
			"patterns": [
				"https?://open\\.spotify\\.com/(track|album)/([0-9a-zA-Z]{22})"
			],
			"name": "Spotify",
			"height": 110
		},
		{
			"patterns": [
				"https?://path\\.com/p/([0-9a-zA-Z]+)$"
			],
			"name": "Path",
			"height": 110
		},
		{
			"patterns": [
				"http://www.funnyordie.com/videos/[^/]+/.+"
			],
			"name": "Funny or Die",
			"height": 110
		},
		{
			"patterns": [
				"http://(?:www\\.)?twitpic\\.com/([^/]+)"
			],
			"name": "Twitpic",
			"height": 110
		},
		{
			"patterns": [
				"https?://www\\.giantbomb\\.com/videos/[^/]+/\\d+-\\d+/?"
			],
			"name": "GiantBomb",
			"height": 110
		},
		{
			"patterns": [
				"http://(?:www\\.)?beeradvocate\\.com/beer/profile/\\d+/\\d+"
			],
			"name": "Beer Advocate",
			"height": 110
		},
		{
			"patterns": [
				"http://(?:www\\.)?imdb.com/title/(tt\\d+)"
			],
			"name": "IMDB",
			"height": 110
		},
		{
			"patterns": [
				"http://cl\\.ly/(?:image/)?[0-9a-zA-Z]+/?$"
			],
			"name": "CloudApp",
			"height": 110
		},
		{
			"patterns": [
				"http://clyp\\.it/.*"
			],
			"name": "Clyp",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.hulu\\.com/watch/.*"
			],
			"name": "Hulu",
			"height": 110
		},
		{
			"patterns": [
				"https?://(?:www|mobile\\.)?twitter\\.com/(?:#!/)?[^/]+/status(?:es)?/(\\d+)/?$",
				"https?://t\\.co/[a-zA-Z0-9]+"
			],
			"name": "Twitter",
			"height": 110
		},
		{
			"patterns": [
				"https?://(?:www\\.)?vimeo\\.com/.+"
			],
			"name": "Vimeo",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.amazon\\.com/(?:.+/)?[gd]p/(?:product/)?(?:tags-on-product/)?([a-zA-Z0-9]+)",
				"http://amzn\\.com/([^/]+)"
			],
			"name": "Amazon",
			"height": 110
		},
		{
			"patterns": [
				"http://qik\\.com/video/.*"
			],
			"name": "Qik",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.rdio\\.com/artist/[^/]+/album/[^/]+/?",
				"http://www\\.rdio\\.com/artist/[^/]+/album/[^/]+/track/[^/]+/?",
				"http://www\\.rdio\\.com/people/[^/]+/playlists/\\d+/[^/]+"
			],
			"name": "Rdio",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.slideshare\\.net/.*/.*"
			],
			"name": "SlideShare",
			"height": 110
		},
		{
			"patterns": [
				"http://imgur\\.com/([0-9a-zA-Z]+)$"
			],
			"name": "Imgur",
			"height": 110
		},
		{
			"patterns": [
				"https?://instagr(?:\\.am|am\\.com)/p/.+"
			],
			"name": "Instagram",
			"height": 110
		},
		{
			"patterns": [
				"http://www\\.twitlonger\\.com/show/[a-zA-Z0-9]+",
				"http://tl\\.gd/[^/]+"
			],
			"name": "Twitlonger",
			"height": 110
		},
		{
			"patterns": [
				"https?://vine.co/v/[a-zA-Z0-9]+"
			],
			"name": "Vine",
			"height": 490
		},
		{
			"patterns": [
				"http://www\\.urbandictionary\\.com/define\\.php\\?term=.+"
			],
			"name": "Urban Dictionary",
			"height": 110
		},
		{
			"patterns": [
				"http://picplz\\.com/user/[^/]+/pic/[^/]+"
			],
			"name": "Picplz",
			"height": 110
		},
		{
			"patterns": [
				"https?://(?:www\\.)?twitter\\.com/(?:#!/)?[^/]+/status(?:es)?/(\\d+)/photo/\\d+(?:/large|/)?$",
				"https?://pic\\.twitter\\.com/.+"
			],
			"name": "Twitter",
			"height": 110
		}
	];

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	module.e = {
		"about.close": "Close",
		"about.copyright": "Copyright 2016 Mattermost, Inc. All rights reserved",
		"about.date": "Build Date:",
		"about.enterpriseEditionLearn": "Learn more about Enterprise Edition at ",
		"about.enterpriseEditionSt": "Modern enterprise communication from behind your firewall.",
		"about.enterpriseEditione1": "Enterprise Edition",
		"about.hash": "Build Hash:",
		"about.licensed": "Licensed by:",
		"about.number": "Build Number:",
		"about.teamEditionLearn": "Join the Mattermost community at ",
		"about.teamEditionSt": "All your team communication in one place, instantly searchable and accessible anywhere.",
		"about.teamEditiont0": "Team Edition",
		"about.teamEditiont1": "Enterprise Edition",
		"about.title": "About Mattermost",
		"about.version": "Version:",
		"access_history.title": "Access History",
		"activity_log.activeSessions": "Active Sessions",
		"activity_log.browser": "Browser: {browser}",
		"activity_log.firstTime": "First time active: {date}, {time}",
		"activity_log.lastActivity": "Last activity: {date}, {time}",
		"activity_log.logout": "Logout",
		"activity_log.moreInfo": "More info",
		"activity_log.os": "OS: {os}",
		"activity_log.sessionId": "Session ID: {id}",
		"activity_log.sessionsDescription": "Sessions are created when you log in to a new browser on a device. Sessions let you use Mattermost without having to log in again for a time period specified by the System Admin. If you want to log out sooner, use the 'Logout' button below to end a session.",
		"activity_log_modal.android": "Android",
		"activity_log_modal.androidNativeApp": "Android Native App",
		"activity_log_modal.iphoneNativeApp": "iPhone Native App",
		"add_command.autocomplete": "Autocomplete",
		"add_command.autocomplete.help": " Show this command in the autocomplete list.",
		"add_command.autocompleteDescription": "Autocomplete Description",
		"add_command.autocompleteDescription.help": "Optional short description of slash command for the autocomplete list.",
		"add_command.autocompleteDescription.placeholder": "Example: \"Returns search results for patient records\"",
		"add_command.autocompleteHint": "Autocomplete Hint",
		"add_command.autocompleteHint.help": "Optional hint in the autocomplete list about parameters needed for command.",
		"add_command.autocompleteHint.placeholder": "Example: [Patient Name]",
		"add_command.description": "Description",
		"add_command.displayName": "Display Name",
		"add_command.header": "Add",
		"add_command.iconUrl": "Response Icon",
		"add_command.iconUrl.help": "Choose a profile picture override for the post responses to this slash command. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.",
		"add_command.iconUrl.placeholder": "https://www.example.com/myicon.png",
		"add_command.method": "Request Method",
		"add_command.method.get": "GET",
		"add_command.method.help": "The type of command request issued to the Request URL.",
		"add_command.method.post": "POST",
		"add_command.trigger": "Command Trigger Word",
		"add_command.trigger.help1": "Examples: /patient, /client, /employee",
		"add_command.trigger.help2": "Reserved: /echo, /join, /logout, /me, /shrug",
		"add_command.trigger.placeholder": "Command trigger e.g. \"hello\" not including the slash",
		"add_command.triggerRequired": "A trigger word is required",
		"add_command.url": "Request URL",
		"add_command.url.help": "The callback URL to receive the HTTP POST or GET event request when the slash command is run.",
		"add_command.url.placeholder": "Must start with http:// or https://",
		"add_command.urlRequired": "A request URL is required",
		"add_command.username": "Response Username",
		"add_command.username.help": "Choose a username override for responses for this slash command. Usernames can consist of up to 22 characters consisting of lowercase letters, numbers and they symbols \"-\", \"_\", and \".\" .",
		"add_command.username.placeholder": "Username",
		"add_incoming_webhook.cancel": "Cancel",
		"add_incoming_webhook.channel": "Channel",
		"add_incoming_webhook.channelRequired": "A valid channel is required",
		"add_incoming_webhook.description": "Description",
		"add_incoming_webhook.header": "Add",
		"add_incoming_webhook.name": "Name",
		"add_incoming_webhook.save": "Save",
		"add_outgoing_webhook.callbackUrls": "Callback URLs (One Per Line)",
		"add_outgoing_webhook.callbackUrlsRequired": "One or more callback URLs are required",
		"add_outgoing_webhook.cancel": "Cancel",
		"add_outgoing_webhook.channel": "Channel",
		"add_outgoing_webhook.description": "Description",
		"add_outgoing_webhook.header": "Add",
		"add_outgoing_webhook.name": "Name",
		"add_outgoing_webhook.save": "Save",
		"add_outgoing_webhook.triggerWOrds": "Trigger Words (One Per Line)",
		"add_outgoing_webhook.triggerWords": "Trigger Words (One Per Line)",
		"add_outgoing_webhook.triggerWordsOrChannelRequired": "A valid channel or a list of trigger words is required",
		"admin.audits.reload": "Reload User Activity Logs",
		"admin.audits.title": "User Activity Logs",
		"admin.compliance.directoryDescription": "Directory to which compliance reports are written. If blank, will be set to ./data/.",
		"admin.compliance.directoryExample": "Ex \"./data/\"",
		"admin.compliance.directoryTitle": "Compliance Directory Location:",
		"admin.compliance.enableDailyDesc": "When true, Mattermost will generate a daily compliance report.",
		"admin.compliance.enableDailyTitle": "Enable Daily Report:",
		"admin.compliance.enableDesc": "When true, Mattermost allows compliance reporting",
		"admin.compliance.enableTitle": "Enable Compliance:",
		"admin.compliance.false": "false",
		"admin.compliance.noLicense": "<h4 class=\"banner__heading\">Note:</h4><p>Compliance is an enterprise feature. Your current license does not support Compliance. Click <a href=\"http://mattermost.com\"target=\"_blank\">here</a> for information and pricing on enterprise licenses.</p>",
		"admin.compliance.save": "Save",
		"admin.compliance.saving": "Saving Config...",
		"admin.compliance.title": "Compliance Settings",
		"admin.compliance.true": "true",
		"admin.compliance_reports.desc": "Job Name:",
		"admin.compliance_reports.desc_placeholder": "E.g. \"Audit 445 for HR\"",
		"admin.compliance_reports.emails": "Emails:",
		"admin.compliance_reports.emails_placeholder": "E.g. \"bill@example.com, bob@example.com\"",
		"admin.compliance_reports.from": "From:",
		"admin.compliance_reports.from_placeholder": "E.g. \"2016-03-11\"",
		"admin.compliance_reports.keywords": "Keywords:",
		"admin.compliance_reports.keywords_placeholder": "E.g. \"shorting stock\"",
		"admin.compliance_reports.reload": "Reload Completed Compliance Reports",
		"admin.compliance_reports.run": "Run Compliance Report",
		"admin.compliance_reports.title": "Compliance Reports",
		"admin.compliance_reports.to": "To:",
		"admin.compliance_reports.to_placeholder": "E.g. \"2016-03-15\"",
		"admin.compliance_table.desc": "Description",
		"admin.compliance_table.download": "Download",
		"admin.compliance_table.params": "Params",
		"admin.compliance_table.records": "Records",
		"admin.compliance_table.status": "Status",
		"admin.compliance_table.timestamp": "Timestamp",
		"admin.compliance_table.type": "Type",
		"admin.compliance_table.userId": "Requested By",
		"admin.connectionSecurityNone": "None",
		"admin.connectionSecurityNoneDescription": "Mattermost will connect over an unsecure connection.",
		"admin.connectionSecurityStart": "STARTTLS",
		"admin.connectionSecurityStartDescription": "Takes an existing insecure connection and attempts to upgrade it to a secure connection using TLS.",
		"admin.connectionSecurityTest": "Test Connection",
		"admin.connectionSecurityTitle": "Connection Security:",
		"admin.connectionSecurityTls": "TLS",
		"admin.connectionSecurityTlsDescription": "Encrypts the communication between Mattermost and your server.",
		"admin.email.agreeHPNS": " I understand and accept the Mattermost Hosted Push Notification Service <a href=\"https://about.mattermost.com/hpns-terms/\" target=\"_blank\">Terms of Service</a> and <a href=\"https://about.mattermost.com/hpns-privacy/\" target=\"_blank\">Privacy Policy</a>.",
		"admin.email.allowEmailSignInDescription": "When true, Mattermost allows users to sign in using their email and password.",
		"admin.email.allowEmailSignInTitle": "Allow Sign In With Email: ",
		"admin.email.allowSignupDescription": "When true, Mattermost allows team creation and account signup using email and password.  This value should be false only when you want to limit signup to a single-sign-on service like OAuth or LDAP.",
		"admin.email.allowSignupTitle": "Allow Sign Up With Email: ",
		"admin.email.allowUsernameSignInDescription": "When true, Mattermost allows users to sign in using their username and password.  This setting is typically only used when email verification is disabled.",
		"admin.email.allowUsernameSignInTitle": "Allow Sign In With Username: ",
		"admin.email.easHelp": "Learn more about compiling and deploying your own mobile apps from an <a href=\"http://docs.mattermost.com/deployment/push.html#enterprise-app-store-eas\" target=\"_blank\">Enterprise App Store</a>.",
		"admin.email.emailFail": "Connection unsuccessful: {error}",
		"admin.email.emailSettings": "Email Settings",
		"admin.email.emailSuccess": "No errors were reported while sending an email.  Please check your inbox to make sure.",
		"admin.email.false": "false",
		"admin.email.fullPushNotification": "Send full message snippet",
		"admin.email.genericPushNotification": "Send generic description with user and channel names",
		"admin.email.inviteSaltDescription": "32-character salt added to signing of email invites. Randomly generated on install. Click \"Re-Generate\" to create new salt.",
		"admin.email.inviteSaltExample": "Ex \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"",
		"admin.email.inviteSaltTitle": "Invite Salt:",
		"admin.email.mhpns": "Use encrypted, production-quality HPNS connection to iOS and Android apps",
		"admin.email.mhpnsHelp": "Download <a href=\"https://itunes.apple.com/us/app/mattermost/id984966508?mt=8\" target=\"_blank\">Mattermost iOS app</a> from iTunes. Download <a href=\"https://play.google.com/store/apps/details?id=com.mattermost.mattermost&hl=en\" target=\"_blank\">Mattermost Android app</a> from Google Play. Learn more about <a href=\"http://docs.mattermost.com/deployment/push.html#hosted-push-notifications-service-hpns\" target=\"_blank\">HPNS</a>.",
		"admin.email.mtpns": "Use iOS and Android apps on iTunes and Google Play with TPNS",
		"admin.email.mtpnsHelp": "Download <a href=\"https://itunes.apple.com/us/app/mattermost/id984966508?mt=8\" target=\"_blank\">Mattermost iOS app</a> from iTunes. Download <a href=\"https://play.google.com/store/apps/details?id=com.mattermost.mattermost&hl=en\" target=\"_blank\">Mattermost Android app</a> from Google Play. Learn more about <a href=\"http://docs.mattermost.com/deployment/push.html#test-push-notifications-service-tpns\" target=\"_blank\">TPNS</a>.",
		"admin.email.notificationDisplayDescription": "Display name on email account used when sending notification emails from Mattermost.",
		"admin.email.notificationDisplayExample": "Ex: \"Mattermost Notification\", \"System\", \"No-Reply\"",
		"admin.email.notificationDisplayTitle": "Notification Display Name:",
		"admin.email.notificationEmailDescription": "Email address displayed on email account used when sending notification emails from Mattermost.",
		"admin.email.notificationEmailExample": "Ex: \"mattermost@yourcompany.com\", \"admin@yourcompany.com\"",
		"admin.email.notificationEmailTitle": "Notification Email Address:",
		"admin.email.notificationsDescription": "Typically set to true in production. When true, Mattermost attempts to send email notifications. Developers may set this field to false to skip email setup for faster development.<br />Setting this to true removes the Preview Mode banner (requires logging out and logging back in after setting is changed).",
		"admin.email.notificationsTitle": "Send Email Notifications: ",
		"admin.email.passwordSaltDescription": "32-character salt added to signing of password reset emails. Randomly generated on install. Click \"Re-Generate\" to create new salt.",
		"admin.email.passwordSaltExample": "Ex \"bjlSR4QqkXFBr7TP4oDzlfZmcNuH9Yo\"",
		"admin.email.passwordSaltTitle": "Password Reset Salt:",
		"admin.email.pushContentDesc": "Selecting \"Send generic description with user and channel names\" provides push notifications with generic messages, including names of users and channels but no specific details from the message text.<br /><br />Selecting \"Send full message snippet\" sends excerpts from messages triggering notifications with specifics and may include confidential information sent in messages. If your Push Notification Service is outside your firewall, it is HIGHLY RECOMMENDED this option only be used with an \"https\" protocol to encrypt the connection.",
		"admin.email.pushContentTitle": "Push Notification Contents:",
		"admin.email.pushDesc": "Typically set to true in production. When true, Mattermost attempts to send iOS and Android push notifications through the push notification server.",
		"admin.email.pushOff": "Do not send push notifications",
		"admin.email.pushOffHelp": "Please see <a href=\"http://docs.mattermost.com/deployment/push.html#push-notifications-and-mobile-devices\" target=\"_blank\">documentation on push notifications</a> to learn more about setup options.",
		"admin.email.pushServerDesc": "Location of Mattermost push notification service you can set up behind your firewall using https://github.com/mattermost/push-proxy. For testing you can use http://push-test.mattermost.com, which connects to the sample Mattermost iOS app in the public Apple AppStore. Please do not use test service for production deployments.",
		"admin.email.pushServerEx": "E.g.: \"http://push-test.mattermost.com\"",
		"admin.email.pushServerTitle": "Push Notification Server:",
		"admin.email.pushTitle": "Send Push Notifications: ",
		"admin.email.regenerate": "Re-Generate",
		"admin.email.requireVerificationDescription": "Typically set to true in production. When true, Mattermost requires email verification after account creation prior to allowing login. Developers may set this field to false so skip sending verification emails for faster development.",
		"admin.email.requireVerificationTitle": "Require Email Verification: ",
		"admin.email.save": "Save",
		"admin.email.saving": "Saving Config...",
		"admin.email.selfPush": "Manually enter Push Notification Service location",
		"admin.email.smtpPasswordDescription": " Obtain this credential from administrator setting up your email server.",
		"admin.email.smtpPasswordExample": "Ex: \"yourpassword\", \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
		"admin.email.smtpPasswordTitle": "SMTP Password:",
		"admin.email.smtpPortDescription": "Port of SMTP email server.",
		"admin.email.smtpPortExample": "Ex: \"25\", \"465\"",
		"admin.email.smtpPortTitle": "SMTP Port:",
		"admin.email.smtpServerDescription": "Location of SMTP email server.",
		"admin.email.smtpServerExample": "Ex: \"smtp.yourcompany.com\", \"email-smtp.us-east-1.amazonaws.com\"",
		"admin.email.smtpServerTitle": "SMTP Server:",
		"admin.email.smtpUsernameDescription": " Obtain this credential from administrator setting up your email server.",
		"admin.email.smtpUsernameExample": "Ex: \"admin@yourcompany.com\", \"AKIADTOVBGERKLCBV\"",
		"admin.email.smtpUsernameTitle": "SMTP Username:",
		"admin.email.testing": "Testing...",
		"admin.email.true": "true",
		"admin.gitab.clientSecretDescription": "Obtain this value via the instructions above for logging into GitLab.",
		"admin.gitlab.EnableHtmlDesc": "<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs \"<your-mattermost-url>/login/gitlab/complete\" (example: http://localhost:8065/login/gitlab/complete) and \"<your-mattermost-url>/signup/gitlab/complete\". </li><li>Then use \"Secret\" and \"Id\" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>",
		"admin.gitlab.authDescription": "Enter https://<your-gitlab-url>/oauth/authorize (example https://example.com:3000/oauth/authorize).   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
		"admin.gitlab.authExample": "Ex \"\"",
		"admin.gitlab.authTitle": "Auth Endpoint:",
		"admin.gitlab.clientIdDescription": "Obtain this value via the instructions above for logging into GitLab",
		"admin.gitlab.clientIdExample": "Ex \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
		"admin.gitlab.clientIdTitle": "Id:",
		"admin.gitlab.clientSecretExample": "Ex \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
		"admin.gitlab.clientSecretTitle": "Secret:",
		"admin.gitlab.enableDescription": "When true, Mattermost allows team creation and account signup using GitLab OAuth.",
		"admin.gitlab.enableTitle": "Enable Sign Up With GitLab: ",
		"admin.gitlab.false": "false",
		"admin.gitlab.save": "Save",
		"admin.gitlab.saving": "Saving Config...",
		"admin.gitlab.settingsTitle": "GitLab Settings",
		"admin.gitlab.tokenDescription": "Enter https://<your-gitlab-url>/oauth/token.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
		"admin.gitlab.tokenExample": "Ex \"\"",
		"admin.gitlab.tokenTitle": "Token Endpoint:",
		"admin.gitlab.true": "true",
		"admin.gitlab.userDescription": "Enter https://<your-gitlab-url>/api/v3/user.   Make sure you use HTTP or HTTPS in your URL depending on your server configuration.",
		"admin.gitlab.userExample": "Ex \"\"",
		"admin.gitlab.userTitle": "User API Endpoint:",
		"admin.image.amazonS3BucketDescription": "Name you selected for your S3 bucket in AWS.",
		"admin.image.amazonS3BucketExample": "Ex \"mattermost-media\"",
		"admin.image.amazonS3BucketTitle": "Amazon S3 Bucket:",
		"admin.image.amazonS3IdDescription": "Obtain this credential from your Amazon EC2 administrator.",
		"admin.image.amazonS3IdExample": "Ex \"AKIADTOVBGERKLCBV\"",
		"admin.image.amazonS3IdTitle": "Amazon S3 Access Key Id:",
		"admin.image.amazonS3RegionDescription": "AWS region you selected for creating your S3 bucket.",
		"admin.image.amazonS3RegionExample": "Ex \"us-east-1\"",
		"admin.image.amazonS3RegionTitle": "Amazon S3 Region:",
		"admin.image.amazonS3SecretDescription": "Obtain this credential from your Amazon EC2 administrator.",
		"admin.image.amazonS3SecretExample": "Ex \"jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY\"",
		"admin.image.amazonS3SecretTitle": "Amazon S3 Secret Access Key:",
		"admin.image.false": "false",
		"admin.image.fileSettings": "File Settings",
		"admin.image.localDescription": "Directory to which image files are written. If blank, will be set to ./data/.",
		"admin.image.localExample": "Ex \"./data/\"",
		"admin.image.localTitle": "Local Directory Location:",
		"admin.image.previewHeightDescription": "Maximum height of preview image (\"0\": Sets to auto-size). Updating this value changes how preview images render in future, but does not change images created in the past.",
		"admin.image.previewHeightExample": "Ex \"0\"",
		"admin.image.previewHeightTitle": "Preview Height:",
		"admin.image.previewWidthDescription": "Maximum width of preview image. Updating this value changes how preview images render in future, but does not change images created in the past.",
		"admin.image.previewWidthExample": "Ex \"1024\"",
		"admin.image.previewWidthTitle": "Preview Width:",
		"admin.image.profileHeightDescription": "Height of profile picture.",
		"admin.image.profileHeightExample": "Ex \"0\"",
		"admin.image.profileHeightTitle": "Profile Height:",
		"admin.image.profileWidthDescription": "Width of profile picture.",
		"admin.image.profileWidthExample": "Ex \"1024\"",
		"admin.image.profileWidthTitle": "Profile Width:",
		"admin.image.publicLinkDescription": "32-character salt added to signing of public image links. Randomly generated on install. Click \"Re-Generate\" to create new salt.",
		"admin.image.publicLinkExample": "Ex \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"",
		"admin.image.publicLinkTitle": "Public Link Salt:",
		"admin.image.regenerate": "Re-Generate",
		"admin.image.save": "Save",
		"admin.image.saving": "Saving Config...",
		"admin.image.shareDescription": "Allow users to share public links to files and images.",
		"admin.image.shareTitle": "Share Public File Link: ",
		"admin.image.storeAmazonS3": "Amazon S3",
		"admin.image.storeLocal": "Local File System",
		"admin.image.storeTitle": "Store Files In:",
		"admin.image.thumbHeightDescription": "Height of thumbnails generated from uploaded images. Updating this value changes how thumbnail images render in future, but does not change images created in the past.",
		"admin.image.thumbHeightExample": "Ex \"100\"",
		"admin.image.thumbHeightTitle": "Thumbnail Height:",
		"admin.image.thumbWidthDescription": "Width of thumbnails generated from uploaded images. Updating this value changes how thumbnail images render in future, but does not change images created in the past.",
		"admin.image.thumbWidthExample": "Ex \"120\"",
		"admin.image.thumbWidthTitle": "Thumbnail Width:",
		"admin.image.true": "true",
		"admin.ldap.bannerDesc": "If a user attribute changes on the LDAP server it will be updated the next time the user enters their credentials to log in to Mattermost. This includes if a user is made inactive or removed from an LDAP server. Synchronization with LDAP servers is planned in a future release.",
		"admin.ldap.bannerHeading": "Note:",
		"admin.ldap.baseDesc": "The Base DN is the Distinguished Name of the location where Mattermost should start its search for users in the LDAP tree.",
		"admin.ldap.baseEx": "Ex \"ou=Unit Name,dc=corp,dc=example,dc=com\"",
		"admin.ldap.baseTitle": "BaseDN:",
		"admin.ldap.bindPwdDesc": "Password of the user given in \"Bind Username\".",
		"admin.ldap.bindPwdTitle": "Bind Password:",
		"admin.ldap.bindUserDesc": "The username used to perform the LDAP search. This should typically be an account created specifically for use with Mattermost. It should have access limited to read the portion of the LDAP tree specified in the BaseDN field.",
		"admin.ldap.bindUserTitle": "Bind Username:",
		"admin.ldap.emailAttrDesc": "The attribute in the LDAP server that will be used to populate the email addresses of users in Mattermost.",
		"admin.ldap.emailAttrEx": "Ex \"mail\" or \"userPrincipalName\"",
		"admin.ldap.emailAttrTitle": "Email Attribute:",
		"admin.ldap.enableDesc": "When true, Mattermost allows login using LDAP",
		"admin.ldap.enableTitle": "Enable Login With LDAP:",
		"admin.ldap.false": "false",
		"admin.ldap.firstnameAttrDesc": "The attribute in the LDAP server that will be used to populate the first name of users in Mattermost.",
		"admin.ldap.firstnameAttrEx": "Ex \"givenName\"",
		"admin.ldap.firstnameAttrTitle": "First Name Attrubute",
		"admin.ldap.idAttrDesc": "The attribute in the LDAP server that will be used as a unique identifier in Mattermost. It should be an LDAP attribute with a value that does not change, such as username or uid. If a user’s Id Attribute changes, it will create a new Mattermost account unassociated with their old one. This is the value used to log in to Mattermost in the \"LDAP Username\" field on the sign in page. Normally this attribute is the same as the “Username Attribute” field above. If your team typically uses domain\\\\username to sign in to other services with LDAP, you may choose to put domain\\\\username in this field to maintain consistency between sites.",
		"admin.ldap.idAttrEx": "Ex \"sAMAccountName\"",
		"admin.ldap.idAttrTitle": "Id Attribute: ",
		"admin.ldap.lastnameAttrDesc": "The attribute in the LDAP server that will be used to populate the last name of users in Mattermost.",
		"admin.ldap.lastnameAttrEx": "Ex \"sn\"",
		"admin.ldap.lastnameAttrTitle": "Last Name Attribute:",
		"admin.ldap.loginNameDesc": "The placeholder text that appears in the login field on the login page. Defaults to \"LDAP Username\".",
		"admin.ldap.loginNameEx": "Ex \"LDAP Username\"",
		"admin.ldap.loginNameTitle": "Login Field Name:",
		"admin.ldap.nicknameAttrDesc": "(Optional) The attribute in the LDAP server that will be used to populate the nickname of users in Mattermost.",
		"admin.ldap.nicknameAttrEx": "Ex \"nickname\"",
		"admin.ldap.nicknameAttrTitle": "Nickname Attribute:",
		"admin.ldap.noLicense": "<h4 class=\"banner__heading\">Note:</h4><p>LDAP is an enterprise feature. Your current license does not support LDAP. Click <a href=\"http://mattermost.com\"target=\"_blank\">here</a> for information and pricing on enterprise licenses.</p>",
		"admin.ldap.portDesc": "The port Mattermost will use to connect to the LDAP server. Default is 389.",
		"admin.ldap.portEx": "Ex \"389\"",
		"admin.ldap.portTitle": "LDAP Port:",
		"admin.ldap.queryDesc": "The timeout value for queries to the LDAP server. Increase if you are getting timeout errors caused by a slow LDAP server.",
		"admin.ldap.queryEx": "Ex \"60\"",
		"admin.ldap.queryTitle": "Query Timeout (seconds):",
		"admin.ldap.save": "Save",
		"admin.ldap.saving": "Saving Config...",
		"admin.ldap.serverDesc": "The domain or IP address of LDAP server.",
		"admin.ldap.serverEx": "Ex \"10.0.0.23\"",
		"admin.ldap.serverTitle": "LDAP Server:",
		"admin.ldap.skipCertificateVerification": "Skip Certificate Verification",
		"admin.ldap.skipCertificateVerificationDesc": "Skips the certificate verification step for TLS or STARTTLS connections. Not recommended for production environments where TLS is required. For testing only.",
		"admin.ldap.title": "LDAP Settings",
		"admin.ldap.true": "true",
		"admin.ldap.uernameAttrDesc": "The attribute in the LDAP server that will be used to populate the username field in Mattermost. This may be the same as the ID Attribute.",
		"admin.ldap.userFilterDisc": "Optionally enter an LDAP Filter to use when searching for user objects. Only the users selected by the query will be able to access Mattermost. For Active Directory, the query to filter out disabled users is (&(objectCategory=Person)(!(UserAccountControl:1.2.840.113556.1.4.803:=2))).",
		"admin.ldap.userFilterEx": "Ex. \"(objectClass=user)\"",
		"admin.ldap.userFilterTitle": "User Filter:",
		"admin.ldap.usernameAttrEx": "Ex \"sAMAccountName\"",
		"admin.ldap.usernameAttrTitle": "Username Attribute:",
		"admin.license.choose": "Choose File",
		"admin.license.chooseFile": "Choose File",
		"admin.license.edition": "Edition: ",
		"admin.license.key": "License Key: ",
		"admin.license.keyRemove": "Remove Enterprise License and Downgrade Server",
		"admin.license.noFile": "No file uploaded",
		"admin.license.removing": "Removing License...",
		"admin.license.title": "Edition and License",
		"admin.license.type": "License: ",
		"admin.license.upload": "Upload",
		"admin.license.uploadDesc": "Upload a license key for Mattermost Enterprise Edition to upgrade this server. <a href=\"http://mattermost.com\" target=\"_blank\">Visit us online</a> to learn more about the benefits of Enterprise Edition or to purchase a key.",
		"admin.license.uploading": "Uploading License...",
		"admin.log.consoleDescription": "Typically set to false in production. Developers may set this field to true to output log messages to console based on the console level option.  If true, server writes messages to the standard output stream (stdout).",
		"admin.log.consoleTitle": "Log To The Console: ",
		"admin.log.false": "false",
		"admin.log.fileDescription": "Typically set to true in production.  When true, log files are written to the log file specified in file location field below.",
		"admin.log.fileLevelDescription": "This setting determines the level of detail at which log events are written to the log file. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.",
		"admin.log.fileLevelTitle": "File Log Level:",
		"admin.log.fileTitle": "Log To File: ",
		"admin.log.formatDateLong": "Date (2006/01/02)",
		"admin.log.formatDateShort": "Date (01/02/06)",
		"admin.log.formatDescription": "Format of log message output. If blank will be set to \"[%D %T] [%L] %M\", where:",
		"admin.log.formatLevel": "Level (DEBG, INFO, EROR)",
		"admin.log.formatMessage": "Message",
		"admin.log.formatPlaceholder": "Enter your file format",
		"admin.log.formatSource": "Source",
		"admin.log.formatTime": "Time (15:04:05 MST)",
		"admin.log.formatTitle": "File Format:",
		"admin.log.levelDescription": "This setting determines the level of detail at which log events are written to the console. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.",
		"admin.log.levelTitle": "Console Log Level:",
		"admin.log.locationDescription": "File to which log files are written. If blank, will be set to ./logs/mattermost, which writes logs to mattermost.log. Log rotation is enabled and every 10,000 lines of log information is written to new files stored in the same directory, for example mattermost.2015-09-23.001, mattermost.2015-09-23.002, and so forth.",
		"admin.log.locationPlaceholder": "Enter your file location",
		"admin.log.locationTitle": "File Location:",
		"admin.log.logSettings": "Log Settings",
		"admin.log.save": "Save",
		"admin.log.saving": "Saving Config...",
		"admin.log.true": "true",
		"admin.logs.reload": "Reload",
		"admin.logs.title": "Server Logs",
		"admin.nav.help": "Help",
		"admin.nav.logout": "Logout",
		"admin.nav.report": "Report a Problem",
		"admin.nav.switch": "Switch to {display_name}",
		"admin.privacy.false": "false",
		"admin.privacy.save": "Save",
		"admin.privacy.saving": "Saving Config...",
		"admin.privacy.showEmailDescription": "When false, hides email address of users from other users in the user interface, including team owners and team administrators. Used when system is set up for managing teams where some users choose to keep their contact information private.",
		"admin.privacy.showEmailTitle": "Show Email Address: ",
		"admin.privacy.showFullNameDescription": "When false, hides full name of users from other users, including team owners and team administrators. Username is shown in place of full name.",
		"admin.privacy.showFullNameTitle": "Show Full Name: ",
		"admin.privacy.title": "Privacy Settings",
		"admin.privacy.true": "true",
		"admin.rate.enableLimiterDescription": "When true, APIs are throttled at rates specified below.",
		"admin.rate.enableLimiterTitle": "Enable Rate Limiter: ",
		"admin.rate.false": "false",
		"admin.rate.httpHeaderDescription": "When filled in, vary rate limiting by HTTP header field specified (e.g. when configuring NGINX set to \"X-Real-IP\", when configuring AmazonELB set to \"X-Forwarded-For\").",
		"admin.rate.httpHeaderExample": "Ex \"X-Real-IP\", \"X-Forwarded-For\"",
		"admin.rate.httpHeaderTitle": "Vary By HTTP Header:",
		"admin.rate.memoryDescription": "Maximum number of users sessions connected to the system as determined by \"Vary By Remote Address\" and \"Vary By Header\" settings below.",
		"admin.rate.memoryExample": "Ex \"10000\"",
		"admin.rate.memoryTitle": "Memory Store Size:",
		"admin.rate.noteDescription": "Changing properties in this section will require a server restart before taking effect.",
		"admin.rate.noteTitle": "Note:",
		"admin.rate.queriesDescription": "Throttles API at this number of requests per second.",
		"admin.rate.queriesExample": "Ex \"10\"",
		"admin.rate.queriesTitle": "Number Of Queries Per Second:",
		"admin.rate.remoteDescription": "When true, rate limit API access by IP address.",
		"admin.rate.remoteTitle": "Vary By Remote Address: ",
		"admin.rate.save": "Save",
		"admin.rate.saving": "Saving Config...",
		"admin.rate.title": "Rate Limit Settings",
		"admin.rate.true": "true",
		"admin.reset_password.close": "Close",
		"admin.reset_password.newPassword": "New Password",
		"admin.reset_password.select": "Select",
		"admin.reset_password.submit": "Please enter at least {chars} characters.",
		"admin.reset_password.titleReset": "Reset Password",
		"admin.reset_password.titleSwitch": "Switch Account to Email/Password",
		"admin.select_team.close": "Close",
		"admin.select_team.select": "Select",
		"admin.select_team.selectTeam": "Select Team",
		"admin.service.attemptDescription": "Login attempts allowed before user is locked out and required to reset password via email.",
		"admin.service.attemptExample": "Ex \"10\"",
		"admin.service.attemptTitle": "Maximum Login Attempts:",
		"admin.service.cmdsDesc": "When true, user created slash commands will be allowed.",
		"admin.service.cmdsTitle": "Enable Slash Commands: ",
		"admin.service.corsDescription": "Enable HTTP Cross origin request from a specific domain. Use \"*\" if you want to allow CORS from any domain or leave it blank to disable it.",
		"admin.service.corsEx": "http://example.com",
		"admin.service.corsTitle": "Allow Cross-origin Requests from:",
		"admin.service.developerDesc": "(Developer Option) When true, extra information around errors will be displayed in the UI.",
		"admin.service.developerTitle": "Enable Developer Mode: ",
		"admin.service.false": "false",
		"admin.service.googleDescription": "Set this key to enable embedding of YouTube video previews based on hyperlinks appearing in messages or comments. Instructions to obtain a key available at <a href=\"https://www.youtube.com/watch?v=Im69kzhpR3I\" target=\"_blank\">https://www.youtube.com/watch?v=Im69kzhpR3I</a>. Leaving the field blank disables the automatic generation of YouTube video previews from links.",
		"admin.service.googleExample": "Ex \"7rAh6iwQCkV4cA1Gsg3fgGOXJAQ43QV\"",
		"admin.service.googleTitle": "Google Developer Key:",
		"admin.service.iconDescription": "When true, webhooks and slash commands will be allowed to change the icon they post with. Note, combined with allowing username overriding, this could open users up to phishing attacks.",
		"admin.service.iconTitle": "Enable Overriding Icon from Webhooks and Slash Commands: ",
		"admin.service.insecureTlsDesc": "When true, any outgoing HTTPS requests will accept unverified, self-signed certificates. For example, outgoing webhooks to a server with a self-signed TLS certificate, using any domain, will be allowed. Note that this makes these connections susceptible to man-in-the-middle attacks.",
		"admin.service.insecureTlsTitle": "Enable Insecure Outgoing Connections: ",
		"admin.service.integrationAdmin": "Enable Integrations for Admin Only: ",
		"admin.service.integrationAdminDesc": "When true, user created integrations can only be created by admins.",
		"admin.service.listenAddress": "Listen Address:",
		"admin.service.listenDescription": "The address to which to bind and listen. Entering \":8065\" will bind to all interfaces or you can choose one like \"127.0.0.1:8065\".  Changing this will require a server restart before taking effect.",
		"admin.service.listenExample": "Ex \":8065\"",
		"admin.service.mfaDesc": "When true, users will be given the option to add multi-factor authentication to their account. They will need a smartphone and an authenticator app such as Google Authenticator.",
		"admin.service.mfaTitle": "Enable Multi-factor Authentication:",
		"admin.service.mobileSessionDays": "Session Length for Mobile Device in Days:",
		"admin.service.mobileSessionDaysDesc": "The native mobile session will expire after the number of days specified and will require a user to login again.",
		"admin.service.outWebhooksDesc": "When true, outgoing webhooks will be allowed.",
		"admin.service.outWebhooksTitle": "Enable Outgoing Webhooks: ",
		"admin.service.overrideDescription": "When true, webhooks and slash commands will be allowed to change the username they are posting as. Note, combined with allowing icon overriding, this could open users up to phishing attacks.",
		"admin.service.overrideTitle": "Enable Overriding Usernames from Webhooks and Slash Commands: ",
		"admin.service.save": "Save",
		"admin.service.saving": "Saving Config...",
		"admin.service.securityDesc": "When true, System Administrators are notified by email if a relevant security fix alert has been announced in the last 12 hours. Requires email to be enabled.",
		"admin.service.securityTitle": "Enable Security Alerts: ",
		"admin.service.segmentDescription": "For users running a SaaS services, sign up for a key at Segment.com to track metrics.",
		"admin.service.segmentExample": "Ex \"g3fgGOXJAQ43QV7rAh6iwQCkV4cA1Gs\"",
		"admin.service.segmentTitle": "Segment Developer Key:",
		"admin.service.sessionCache": "Session Cache in Minutes:",
		"admin.service.sessionCacheDesc": "The number of minutes to cache a session in memory.",
		"admin.service.sessionDaysEx": "Ex \"30\"",
		"admin.service.ssoSessionDays": "Session Length for SSO in Days:",
		"admin.service.ssoSessionDaysDesc": "The SSO session will expire after the number of days specified and will require a user to login again.",
		"admin.service.testingDescription": "(Developer Option) When true, /loadtest slash command is enabled to load test accounts and test data. Changing this will require a server restart before taking effect.",
		"admin.service.testingTitle": "Enable Testing: ",
		"admin.service.title": "Service Settings",
		"admin.service.true": "true",
		"admin.service.webSessionDays": "Session Length for Web in Days:",
		"admin.service.webSessionDaysDesc": "The web session will expire after the number of days specified and will require a user to login again.",
		"admin.service.webhooksDescription": "When true, incoming webhooks will be allowed. To help combat phishing attacks, all posts from webhooks will be labelled by a BOT tag.",
		"admin.service.webhooksTitle": "Enable Incoming Webhooks: ",
		"admin.sidebar.addTeamSidebar": "Add team from sidebar menu",
		"admin.sidebar.audits": "Compliance and Auditing",
		"admin.sidebar.compliance": "Compliance Settings",
		"admin.sidebar.email": "Email Settings",
		"admin.sidebar.file": "File Settings",
		"admin.sidebar.gitlab": "GitLab Settings",
		"admin.sidebar.ldap": "LDAP Settings",
		"admin.sidebar.license": "Edition and License",
		"admin.sidebar.loading": "Loading",
		"admin.sidebar.log": "Log Settings",
		"admin.sidebar.logs": "Logs",
		"admin.sidebar.other": "OTHER",
		"admin.sidebar.privacy": "Privacy Settings",
		"admin.sidebar.rate_limit": "Rate Limit Settings",
		"admin.sidebar.reports": "SITE REPORTS",
		"admin.sidebar.rmTeamSidebar": "Remove team from sidebar menu",
		"admin.sidebar.service": "Service Settings",
		"admin.sidebar.settings": "SETTINGS",
		"admin.sidebar.sql": "SQL Settings",
		"admin.sidebar.statistics": "- Statistics",
		"admin.sidebar.support": "Legal and Support Settings",
		"admin.sidebar.team": "Team Settings",
		"admin.sidebar.teams": "TEAMS ({count})",
		"admin.sidebar.users": "- Users",
		"admin.sidebar.view_statistics": "View Statistics",
		"admin.sidebarHeader.systemConsole": "System Console",
		"admin.sql.dataSource": "Data Source:",
		"admin.sql.driverName": "Driver Name:",
		"admin.sql.false": "false",
		"admin.sql.keyDescription": "32-character salt available to encrypt and decrypt sensitive fields in database.",
		"admin.sql.keyExample": "Ex \"gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6\"",
		"admin.sql.keyTitle": "At Rest Encrypt Key:",
		"admin.sql.maxConnectionsDescription": "Maximum number of idle connections held open to the database.",
		"admin.sql.maxConnectionsExample": "Ex \"10\"",
		"admin.sql.maxConnectionsTitle": "Maximum Idle Connections:",
		"admin.sql.maxOpenDescription": "Maximum number of open connections held open to the database.",
		"admin.sql.maxOpenExample": "Ex \"10\"",
		"admin.sql.maxOpenTitle": "Maximum Open Connections:",
		"admin.sql.noteDescription": "Changing properties in this section will require a server restart before taking effect.",
		"admin.sql.noteTitle": "Note:",
		"admin.sql.regenerate": "Re-Generate",
		"admin.sql.replicas": "Data Source Replicas:",
		"admin.sql.save": "Save",
		"admin.sql.saving": "Saving Config...",
		"admin.sql.title": "SQL Settings",
		"admin.sql.traceDescription": "(Development Mode) When true, executing SQL statements are written to the log.",
		"admin.sql.traceTitle": "Trace: ",
		"admin.sql.true": "true",
		"admin.sql.warning": "Warning: re-generating this salt may cause some columns in the database to return empty results.",
		"admin.support.aboutDesc": "Link to About page for more information on your Mattermost deployment, for example its purpose and audience within your organization. Defaults to Mattermost information page.",
		"admin.support.aboutTitle": "About link:",
		"admin.support.emailHelp": "Email shown during tutorial for end users to ask support questions.",
		"admin.support.emailTitle": "Support email:",
		"admin.support.helpDesc": "Link to help documentation from team site main menu. Typically not changed unless your organization chooses to create custom documentation.",
		"admin.support.helpTitle": "Help link:",
		"admin.support.noteDescription": "If linking to an external site, URLs should begin with http:// or https://.",
		"admin.support.noteTitle": "Note:",
		"admin.support.privacyDesc": "Link to Privacy Policy available to users on desktop and on mobile. Leaving this blank will hide the option to display a notice.",
		"admin.support.privacyTitle": "Privacy Policy link:",
		"admin.support.problemDesc": "Link to help documentation from team site main menu. By default this points to the peer-to-peer troubleshooting forum where users can search for, find and request help with technical issues.",
		"admin.support.problemTitle": "Report a Problem link:",
		"admin.support.save": "Save",
		"admin.support.saving": "Saving Config...",
		"admin.support.termsDesc": "Link to Terms of Service available to users on desktop and on mobile. Leaving this blank will hide the option to display a notice.",
		"admin.support.termsTitle": "Terms of Service link:",
		"admin.support.title": "Legal and Support Settings",
		"admin.system_analytics.activeUsers": "Active Users With Posts",
		"admin.system_analytics.title": "the System",
		"admin.system_analytics.totalPosts": "Total Posts",
		"admin.team.brandDesc": "Enable custom branding to show an image of your choice, uploaded below, and some help text, written below, on the login page.",
		"admin.team.brandImageTitle": "Custom Brand Image:",
		"admin.team.brandTextDescription": "The custom branding Markdown-formatted text you would like to appear below your custom brand image on your login screen.",
		"admin.team.brandTextTitle": "Custom Brand Text:",
		"admin.team.brandTitle": "Enable Custom Branding: ",
		"admin.team.chooseImage": "Choose New Image",
		"admin.team.dirDesc": "When true, teams that are configured to show in team directory will show on main page inplace of creating a new team.",
		"admin.team.dirTitle": "Enable Team Directory: ",
		"admin.team.false": "false",
		"admin.team.maxUsersDescription": "Maximum total number of users per team, including both active and inactive users.",
		"admin.team.maxUsersExample": "Ex \"25\"",
		"admin.team.maxUsersTitle": "Max Users Per Team:",
		"admin.team.noBrandImage": "No brand image uploaded",
		"admin.team.openServerDescription": "When true, anyone can signup for a user account on this server without the need to be invited.",
		"admin.team.openServerTitle": "Enable Open Server: ",
		"admin.team.restrictDescription": "Teams and user accounts can only be created from a specific domain (e.g. \"mattermost.org\") or list of comma-separated domains (e.g. \"corp.mattermost.com, mattermost.org\").",
		"admin.team.restrictDirectMessage": "Enable users to open Direct Message channels with:",
		"admin.team.restrictDirectMessageDesc": "'Any user on the Mattermost server' enables users to open a Direct Message channel with any user on the server, even if they are not on any teams together. 'Any member of the team' limits the ability to open Direct Message channels to only users who are in the same team.",
		"admin.team.restrictExample": "Ex \"corp.mattermost.com, mattermost.org\"",
		"admin.team.restrictNameDesc": "When true, You cannot create a team name with reserved words like www, admin, support, test, channel, etc",
		"admin.team.restrictNameTitle": "Restrict Team Names: ",
		"admin.team.restrictTitle": "Restrict Creation To Domains:",
		"admin.team.restrict_direct_message_any": "Any user on the Mattermost server",
		"admin.team.restrict_direct_message_team": "Any member of the team",
		"admin.team.save": "Save",
		"admin.team.saving": "Saving Config...",
		"admin.team.siteNameDescription": "Name of service shown in login screens and UI.",
		"admin.team.siteNameExample": "Ex \"Mattermost\"",
		"admin.team.siteNameTitle": "Site Name:",
		"admin.team.teamCreationDescription": "When false, the ability to create teams is disabled. The create team button displays error when pressed.",
		"admin.team.teamCreationTitle": "Enable Team Creation: ",
		"admin.team.title": "Team Settings",
		"admin.team.true": "true",
		"admin.team.upload": "Upload",
		"admin.team.uploadDesc": "Customize your user experience by adding a custom image to your login screen. See examples at <a href='http://docs.mattermost.com/administration/config-settings.html#custom-branding' target='_blank'>docs.mattermost.com/administration/config-settings.html#custom-branding</a>.",
		"admin.team.uploaded": "Uploaded!",
		"admin.team.uploading": "Uploading..",
		"admin.team.userCreationDescription": "When false, the ability to create accounts is disabled. The create account button displays error when pressed.",
		"admin.team.userCreationTitle": "Enable User Creation: ",
		"admin.team_analytics.activeUsers": "Active Users With Posts",
		"admin.team_analytics.totalPosts": "Total Posts",
		"admin.userList.title": "Users for {team}",
		"admin.userList.title2": "Users for {team} ({count})",
		"admin.user_item.authServiceEmail": ", <strong>Sign-in Method:</strong> Email",
		"admin.user_item.authServiceNotEmail": ", <strong>Sign-in Method:</strong> {service}",
		"admin.user_item.confirmDemoteDescription": "If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.",
		"admin.user_item.confirmDemoteRoleTitle": "Confirm demotion from System Admin role",
		"admin.user_item.confirmDemotion": "Confirm Demotion",
		"admin.user_item.confirmDemotionCmd": "platform -assign_role -team_name=\"yourteam\" -email=\"name@yourcompany.com\" -role=\"system_admin\"",
		"admin.user_item.emailTitle": "<strong>Email:</strong> {email}",
		"admin.user_item.inactive": "Inactive",
		"admin.user_item.makeActive": "Make Active",
		"admin.user_item.makeInactive": "Make Inactive",
		"admin.user_item.makeMember": "Make Member",
		"admin.user_item.makeSysAdmin": "Make System Admin",
		"admin.user_item.makeTeamAdmin": "Make Team Admin",
		"admin.user_item.member": "Member",
		"admin.user_item.mfaNo": ", <strong>MFA</strong>: No",
		"admin.user_item.mfaYes": ", <strong>MFA</strong>: Yes",
		"admin.user_item.resetMfa": "Remove MFA",
		"admin.user_item.resetPwd": "Reset Password",
		"admin.user_item.switchToEmail": "Switch to Email/Password",
		"admin.user_item.sysAdmin": "System Admin",
		"admin.user_item.teamAdmin": "Team Admin",
		"analytics.chart.loading": "Loading...",
		"analytics.chart.meaningful": "Not enough data for a meaningful representation.",
		"analytics.system.activeUsers": "Active Users With Posts",
		"analytics.system.channelTypes": "Channel Types",
		"analytics.system.postTypes": "Posts, Files and Hashtags",
		"analytics.system.privateGroups": "Private Groups",
		"analytics.system.publicChannels": "Public Channels",
		"analytics.system.textPosts": "Posts with Text-only",
		"analytics.system.title": "System Statistics",
		"analytics.system.totalChannels": "Total Channels",
		"analytics.system.totalCommands": "Total Commands",
		"analytics.system.totalFilePosts": "Posts with Files",
		"analytics.system.totalHashtagPosts": "Posts with Hashtags",
		"analytics.system.totalIncomingWebhooks": "Incoming Webhooks",
		"analytics.system.totalOutgoingWebhooks": "Outgoing Webhooks",
		"analytics.system.totalPosts": "Total Posts",
		"analytics.system.totalSessions": "Total Sessions",
		"analytics.system.totalTeams": "Total Teams",
		"analytics.system.totalUsers": "Total Users",
		"analytics.team.activeUsers": "Active Users With Posts",
		"analytics.team.newlyCreated": "Newly Created Users",
		"analytics.team.privateGroups": "Private Groups",
		"analytics.team.publicChannels": "Public Channels",
		"analytics.team.recentActive": "Recent Active Users",
		"analytics.team.recentUsers": "Recent Active Users",
		"analytics.team.title": "Team Statistics for {team}",
		"analytics.team.totalPosts": "Total Posts",
		"analytics.team.totalUsers": "Total Users",
		"audit_table.accountActive": "Account made active",
		"audit_table.accountInactive": "Account made inactive",
		"audit_table.action": "Action",
		"audit_table.attemptedAllowOAuthAccess": "Attempted to allow a new OAuth service access",
		"audit_table.attemptedLicenseAdd": "Attempted to add new license",
		"audit_table.attemptedLogin": "Attempted to login",
		"audit_table.attemptedOAuthToken": "Attempted to get an OAuth access token",
		"audit_table.attemptedPassword": "Attempted to change password",
		"audit_table.attemptedRegisterApp": "Attempted to register a new OAuth Application with ID {id}",
		"audit_table.attemptedReset": "Attempted to reset password",
		"audit_table.attemptedWebhookCreate": "Attempted to create a webhook",
		"audit_table.attemptedWebhookDelete": "Attempted to delete a webhook",
		"audit_table.by": " by {username}",
		"audit_table.byAdmin": " by an admin",
		"audit_table.channelCreated": "Created the {channelName} channel/group",
		"audit_table.channelDeleted": "Deleted the channel/group with the URL {url}",
		"audit_table.establishedDM": "Established a direct message channel with {username}",
		"audit_table.failedExpiredLicenseAdd": "Failed to add a new license as it has either expired or not yet been started",
		"audit_table.failedInvalidLicenseAdd": "Failed to add an invalid license",
		"audit_table.failedLogin": "FAILED login attempt",
		"audit_table.failedOAuthAccess": "Failed to allow a new OAuth service access - the redirect URI did not match the previously registered callback",
		"audit_table.failedPassword": "Failed to change password - tried to update user password who was logged in through oauth",
		"audit_table.failedWebhookCreate": "Failed to create a webhook - bad channel permissions",
		"audit_table.failedWebhookDelete": "Failed to delete a webhook - inappropriate conditions",
		"audit_table.headerUpdated": "Updated the {channelName} channel/group header",
		"audit_table.ip": "IP Address",
		"audit_table.licenseRemoved": "Successfully removed a license",
		"audit_table.loginAttempt": " (Login attempt)",
		"audit_table.loginFailure": " (Login failure)",
		"audit_table.logout": "Logged out of your account",
		"audit_table.member": "member",
		"audit_table.nameUpdated": "Updated the {channelName} channel/group name",
		"audit_table.oauthTokenFailed": "Failed to get an OAuth access token - {token}",
		"audit_table.revokedAll": "Revoked all current sessions for the team",
		"audit_table.sentEmail": "Sent an email to {email} to reset your password",
		"audit_table.session": "Session ID",
		"audit_table.sessionRevoked": "The session with id {sessionId} was revoked",
		"audit_table.successfullLicenseAdd": "Successfully added new license",
		"audit_table.successfullLogin": "Successfully logged in",
		"audit_table.successfullOAuthAccess": "Successfully gave a new OAuth service access",
		"audit_table.successfullOAuthToken": "Successfully added a new OAuth service",
		"audit_table.successfullPassword": "Successfully changed password",
		"audit_table.successfullReset": "Successfully reset password",
		"audit_table.successfullWebhookCreate": "Successfully created a webhook",
		"audit_table.successfullWebhookDelete": "Successfully deleted a webhook",
		"audit_table.timestamp": "Timestamp",
		"audit_table.updateGeneral": "Updated the general settings of your account",
		"audit_table.updateGlobalNotifications": "Updated your global notification settings",
		"audit_table.updatePicture": "Updated your profile picture",
		"audit_table.updatedRol": "Updated user role(s) to ",
		"audit_table.userAdded": "Added {username} to the {channelName} channel/group",
		"audit_table.userId": "User ID",
		"audit_table.userRemoved": "Removed {username} to the {channelName} channel/group",
		"audit_table.verified": "Sucessfully verified your email address",
		"authorize.access": "Allow <strong>{appName}</strong> access?",
		"authorize.allow": "Allow",
		"authorize.app": "The app <strong>{appName}</strong> would like the ability to access and modify your basic information.",
		"authorize.deny": "Deny",
		"authorize.title": "An application would like to connect to your {teamName} account",
		"backstage_navbar.backToMattermost": "Back to {siteName}",
		"backstage_sidebar.integrations": "Integrations",
		"backstage_sidebar.integrations.commands": "Slash Commands",
		"backstage_sidebar.integrations.incoming_webhooks": "Incoming Webhooks",
		"backstage_sidebar.integrations.outgoing_webhooks": "Outgoing Webhooks",
		"center_panel.recent": "Click here to jump to recent messages. ",
		"chanel_header.addMembers": "Add Members",
		"change_url.close": "Close",
		"change_url.endWithLetter": "Must end with a letter or number",
		"change_url.invalidUrl": "Invalid URL",
		"change_url.longer": "Must be longer than two characters",
		"change_url.noUnderscore": "Can not contain two underscores in a row.",
		"change_url.startWithLetter": "Must start with a letter or number",
		"channel_flow.alreadyExist": "A channel with that URL already exists",
		"channel_flow.changeUrlDescription": "Some characters are not allowed in URLs and may be removed.",
		"channel_flow.changeUrlTitle": "Change {term} URL",
		"channel_flow.channel": "Channel",
		"channel_flow.create": "Create {term}",
		"channel_flow.group": "Group",
		"channel_flow.invalidName": "Invalid Channel Name",
		"channel_flow.set_url_title": "Set {term} URL",
		"channel_header.channel": "Channel",
		"channel_header.channelHeader": "Set Channel Header...",
		"channel_header.delete": "Delete {term}...",
		"channel_header.group": "Group",
		"channel_header.leave": "Leave {term}",
		"channel_header.manageMembers": "Manage Members",
		"channel_header.notificationPreferences": "Notification Preferences",
		"channel_header.recentMentions": "Recent Mentions",
		"channel_header.rename": "Rename {term}...",
		"channel_header.setHeader": "Set {term} Header...",
		"channel_header.setPurpose": "Set {term} Purpose...",
		"channel_header.viewInfo": "View Info",
		"channel_info.close": "Close",
		"channel_info.id": "Channel ID:",
		"channel_info.name": "Channel Name:",
		"channel_info.notFound": "No Channel Found",
		"channel_info.purpose": "Channel Purpose:",
		"channel_info.url": "Channel URL:",
		"channel_invite.add": " Add",
		"channel_invite.addNewMembers": "Add New Members to ",
		"channel_invite.close": "Close",
		"channel_loader.connection_error": "There appears to be a problem with your internet connection.",
		"channel_loader.posted": "Posted",
		"channel_loader.socketError": "Please check connection, Mattermost unreachable. If issue persists, ask administrator to check WebSocket port.",
		"channel_loader.someone": "Someone",
		"channel_loader.something": " did something new",
		"channel_loader.unknown_error": "We received an unexpected status code from the server.",
		"channel_loader.uploadedFile": " uploaded a file",
		"channel_loader.uploadedImage": " uploaded an image",
		"channel_loader.wrote": " wrote: ",
		"channel_members_modal.addNew": " Add New Members",
		"channel_members_modal.close": "Close",
		"channel_members_modal.remove": "Remove",
		"channel_memebers_modal.members": " Members",
		"channel_modal.cancel": "Cancel",
		"channel_modal.channel": "Channel",
		"channel_modal.createNew": "Create New ",
		"channel_modal.descriptionHelp": "Describe how this {term} should be used.",
		"channel_modal.displayNameError": "This field is required",
		"channel_modal.edit": "Edit",
		"channel_modal.group": "Group",
		"channel_modal.modalTitle": "New ",
		"channel_modal.name": "Name",
		"channel_modal.nameEx": "E.g.: \"Bugs\", \"Marketing\", \"客户支持\"",
		"channel_modal.optional": "(optional)",
		"channel_modal.privateGroup1": "Create a new private group with restricted membership. ",
		"channel_modal.privateGroup2": "Create a private group",
		"channel_modal.publicChannel1": "Create a public channel",
		"channel_modal.publicChannel2": "Create a new public channel anyone can join. ",
		"channel_modal.purpose": "Purpose",
		"channel_notifications.allActivity": "For all activity",
		"channel_notifications.allUnread": "For all unread messages",
		"channel_notifications.globalDefault": "Global default ({notifyLevel})",
		"channel_notifications.markUnread": "Mark Channel Unread",
		"channel_notifications.never": "Never",
		"channel_notifications.onlyMentions": "Only for mentions",
		"channel_notifications.override": "Selecting an option other than \"Default\" will override the global notification settings. Desktop notifications are available on Firefox, Safari, and Chrome.",
		"channel_notifications.preferences": "Notification Preferences for ",
		"channel_notifications.sendDesktop": "Send desktop notifications",
		"channel_notifications.unreadInfo": "The channel name is bolded in the sidebar when there are unread messages. Selecting \"Only for mentions\" will bold the channel only when you are mentioned.",
		"channel_select.placeholder": "--- Select a channel ---",
		"choose_auth_page.emailCreate": "Create new team with email address",
		"choose_auth_page.find": "Find my teams",
		"choose_auth_page.gitlabCreate": "Create new team with GitLab Account",
		"choose_auth_page.googleCreate": "Create new team with Google Apps Account",
		"choose_auth_page.ldapCreate": "Create new team with LDAP Account",
		"choose_auth_page.noSignup": "No sign-up methods configured, please contact your system administrator.",
		"claim.account.noEmail": "No email specified",
		"claim.email_to_ldap.enterLdapPwd": "Enter the ID and password for your LDAP account",
		"claim.email_to_ldap.enterPwd": "Enter the password for your {site} email account",
		"claim.email_to_ldap.ldapId": "LDAP ID",
		"claim.email_to_ldap.ldapIdError": "Please enter your LDAP ID.",
		"claim.email_to_ldap.ldapPasswordError": "Please enter your LDAP password.",
		"claim.email_to_ldap.ldapPwd": "LDAP Password",
		"claim.email_to_ldap.pwd": "Password",
		"claim.email_to_ldap.pwdError": "Please enter your password.",
		"claim.email_to_ldap.ssoNote": "You must already have a valid LDAP account",
		"claim.email_to_ldap.ssoType": "Upon claiming your account, you will only be able to login with LDAP",
		"claim.email_to_ldap.switchTo": "Switch account to LDAP",
		"claim.email_to_ldap.title": "Switch Email/Password Account to LDAP",
		"claim.email_to_oauth.enterPwd": "Enter the password for your {site} account",
		"claim.email_to_oauth.pwd": "Password",
		"claim.email_to_oauth.pwdError": "Please enter your password.",
		"claim.email_to_oauth.ssoNote": "You must already have a valid {type} account",
		"claim.email_to_oauth.ssoType": "Upon claiming your account, you will only be able to login with {type} SSO",
		"claim.email_to_oauth.switchTo": "Switch account to {uiType}",
		"claim.email_to_oauth.title": "Switch Email/Password Account to {uiType}",
		"claim.ldap_to_email.confirm": "Confirm Password",
		"claim.ldap_to_email.email": "You will use the email {email} to login",
		"claim.ldap_to_email.enterLdapPwd": "Enter your {ldapPassword} for your {site} email account",
		"claim.ldap_to_email.enterPwd": "Enter a new password for your email account",
		"claim.ldap_to_email.ldapPasswordError": "Please enter your LDAP password.",
		"claim.ldap_to_email.ldapPwd": "LDAP Password",
		"claim.ldap_to_email.pwd": "Password",
		"claim.ldap_to_email.pwdError": "Please enter your password.",
		"claim.ldap_to_email.pwdNotMatch": "Passwords do not match.",
		"claim.ldap_to_email.ssoType": "Upon claiming your account, you will only be able to login with your email and password",
		"claim.ldap_to_email.switchTo": "Switch account to email/password",
		"claim.ldap_to_email.title": "Switch LDAP Account to Email/Password",
		"claim.oauth_to_email.confirm": "Confirm Password",
		"claim.oauth_to_email.description": "Upon changing your account type, you will only be able to login with your email and password.",
		"claim.oauth_to_email.enterNewPwd": "Enter a new password for your {site} account",
		"claim.oauth_to_email.enterPwd": "Please enter a password.",
		"claim.oauth_to_email.newPwd": "New Password",
		"claim.oauth_to_email.pwdNotMatch": "Password do not match.",
		"claim.oauth_to_email.switchTo": "Switch {type} to email and password",
		"claim.oauth_to_email.title": "Switch {type} Account to Email",
		"confirm_modal.cancel": "Cancel",
		"create_comment.addComment": "Add a comment...",
		"create_comment.comment": "Add Comment",
		"create_comment.commentLength": "Comment length must be less than {max} characters.",
		"create_comment.commentTitle": "Comment",
		"create_comment.file": "File uploading",
		"create_comment.files": "Files uploading",
		"create_post.comment": "Comment",
		"create_post.post": "Post",
		"create_post.tutorialTip": "<h4>Sending Messages</h4><p>Type here to write a message and press <strong>Enter</strong> to post it.</p><p>Click the <strong>Attachment</strong> button to upload an image or a file.</p>",
		"create_post.write": "Write a message...",
		"create_team.agreement": "By proceeding to create your account and use {siteName}, you agree to our <a href='/static/help/terms.html'>Terms of Service</a> and <a href='/static/help/privacy.html'>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.",
		"create_team.display_name.back": "Back to previous step",
		"create_team.display_name.charLength": "Name must be 4 or more characters up to a maximum of 15",
		"create_team.display_name.nameHelp": "Name your team in any language. Your team name shows in menus and headings.",
		"create_team.display_name.next": "Next",
		"create_team.display_name.required": "This field is required",
		"create_team.display_name.teamName": "Team Name",
		"create_team.team_url.back": "Back to previous step",
		"create_team.team_url.charLength": "Name must be 4 or more characters up to a maximum of 15",
		"create_team.team_url.finish": "Finish",
		"create_team.team_url.hint": "<li>Short and memorable is best</li><li>Use lowercase letters, numbers and dashes</li><li>Must start with a letter and can't end in a dash</li>",
		"create_team.team_url.regex": "Use only lower case letters, numbers and dashes. Must start with a letter and can't end in a dash.",
		"create_team.team_url.required": "This field is required",
		"create_team.team_url.taken": "URL is taken or contains a reserved word",
		"create_team.team_url.teamUrl": "Team URL",
		"create_team.team_url.unavailable": "This URL is unavailable. Please try another.",
		"create_team.team_url.webAddress": "Choose the web address of your new team:",
		"delete_channel.cancel": "Cancel",
		"delete_channel.channel": "channel",
		"delete_channel.confirm": "Confirm DELETE Channel",
		"delete_channel.del": "Delete",
		"delete_channel.group": "group",
		"delete_channel.question": "Are you sure you wish to delete the {display_name} {term}?",
		"delete_post.cancel": "Cancel",
		"delete_post.comment": "Comment",
		"delete_post.confirm": "Confirm {term} Delete",
		"delete_post.del": "Delete",
		"delete_post.post": "Post",
		"delete_post.question": "Are you sure you want to delete this {term}?",
		"delete_post.warning": "This post has {count} comment(s) on it.",
		"edit_channel_header_modal.cancel": "Cancel",
		"edit_channel_header_modal.description": "Edit the text appearing next to the channel name in the channel header.",
		"edit_channel_header_modal.error": "This channel header is too long, please enter a shorter one",
		"edit_channel_header_modal.save": "Save",
		"edit_channel_header_modal.title": "Edit Header for {channel}",
		"edit_channel_purpose_modal.body": "Describe how this {type} should be used. This text appears in the channel list in the \"More...\" menu and helps others decide whether to join.",
		"edit_channel_purpose_modal.cancel": "Cancel",
		"edit_channel_purpose_modal.channel": "Channel",
		"edit_channel_purpose_modal.error": "This channel purpose is too long, please enter a shorter one",
		"edit_channel_purpose_modal.group": "Group",
		"edit_channel_purpose_modal.save": "Save",
		"edit_channel_purpose_modal.title1": "Edit Purpose",
		"edit_channel_purpose_modal.title2": "Edit Purpose for ",
		"edit_post.cancel": "Cancel",
		"edit_post.edit": "Edit {title}",
		"edit_post.editPost": "Edit the post...",
		"edit_post.save": "Save",
		"email_signup.address": "Email Address",
		"email_signup.createTeam": "Create Team",
		"email_signup.emailError": "Please enter a valid email address",
		"email_signup.find": "Find my teams",
		"email_verify.almost": "{siteName}: You are almost done",
		"email_verify.failed": " Failed to send verification email.",
		"email_verify.notVerifiedBody": "Please verify your email address. Check your inbox for an email.",
		"email_verify.resend": "Resend Email",
		"email_verify.sent": " Verification email sent.",
		"email_verify.verified": "{siteName} Email Verified",
		"email_verify.verifiedBody": "<p>Your email has been verified! Click <a href={url}>here</a> to log in.</p>",
		"email_verify.verifyFailed": "Failed to verify your email.",
		"error_bar.preview_mode": "Preview Mode: Email notifications have not been configured",
		"file_attachment.download": "Download",
		"file_info_preview.size": "Size ",
		"file_info_preview.type": "File type ",
		"file_upload.fileAbove": "File above {max}MB could not be uploaded: {filename}",
		"file_upload.filesAbove": "Files above {max}MB could not be uploaded: {filenames}",
		"file_upload.limited": "Uploads limited to {count} files maximum. Please use additional posts for more files.",
		"file_upload.pasted": "Image Pasted at ",
		"filtered_user_list.any_team": "All Users",
		"filtered_user_list.count": "{count} {count, plural, =0 {0 members} one {member} other {members}}",
		"filtered_user_list.countTotal": "{count} {count, plural, =0 {0 members} one {member} other {members}} of {total} Total",
		"filtered_user_list.member": "Member",
		"filtered_user_list.search": "Search members",
		"filtered_user_list.show": "Filter:",
		"filtered_user_list.team_only": "Members of this Team",
		"find_team.email": "Email",
		"find_team.findDescription": "An email was sent with links to any teams to which you are a member.",
		"find_team.findTitle": "Find Your Team",
		"find_team.getLinks": "Get an email with links to any teams to which you are a member.",
		"find_team.placeholder": "you@domain.com",
		"find_team.send": "Send",
		"find_team.submitError": "Please enter a valid email address",
		"general_tab.chooseName": "Please choose a new name for your team",
		"general_tab.codeDesc": "Click 'Edit' to regenerate Invite Code.",
		"general_tab.codeLongDesc": "The Invite Code is used as part of the URL in the team invitation link created by **Get Team Invite Link** in the main menu. Regenerating creates a new team invitation link and invalidates the previous link.",
		"general_tab.codeTitle": "Invite Code",
		"general_tab.dirContact": "Contact your system administrator to turn on the team directory on the system home page.",
		"general_tab.dirDisabled": "Team Directory has been disabled.  Please ask a System Admin to enable the Team Directory in the System Console team settings.",
		"general_tab.dirOff": "Team directory is turned off for this system.",
		"general_tab.includeDirDesc": "Including this team will display the team name from the Team Directory section of the Home Page, and provide a link to the sign-in page.",
		"general_tab.includeDirTitle": "Include this team in the Team Directory",
		"general_tab.no": "No",
		"general_tab.openInviteDesc": "When allowed, a link to this team will be including on the landing page allowing anyone with an account to join this team.",
		"general_tab.openInviteTitle": "Allow anyone to join this team",
		"general_tab.regenerate": "Re-Generate",
		"general_tab.required": "This field is required",
		"general_tab.teamName": "Team Name",
		"general_tab.teamNameInfo": "Set the name of the team as it appears on your sign-in screen and at the top of the left-hand sidebar.",
		"general_tab.title": "General Settings",
		"general_tab.yes": "Yes",
		"get_link.clipboard": " Link copied to clipboard.",
		"get_link.close": "Close",
		"get_link.copy": "Copy Link",
		"get_post_link_modal.help": "The link below allows authorized users to see your post.",
		"get_post_link_modal.title": "Copy Permalink",
		"get_team_invite_link_modal.help": "Send teammates the link below for them to sign-up to this team site. The Team Invite Link can be shared with multiple teammates as it does not change unless it's regenerated in Team Settings by a Team Admin.",
		"get_team_invite_link_modal.helpDisabled": "User creation has been disabled for your team. Please ask your team administrator for details.",
		"get_team_invite_link_modal.title": "Team Invite Link",
		"installed_commands.add": "Add Slash Command",
		"installed_commands.empty": "No commands found",
		"installed_commands.header": "Slash Commands",
		"installed_incoming_webhooks.add": "Add Incoming Webhook",
		"installed_incoming_webhooks.empty": "No incoming webhooks found",
		"installed_incoming_webhooks.header": "Incoming Webhooks",
		"installed_integrations.creation": "Created by {creator} on {createAt, date, full}",
		"installed_integrations.delete": "Delete",
		"installed_integrations.regenToken": "Regen Token",
		"installed_integrations.search": "Search Integrations",
		"installed_integrations.token": "Token: {token}",
		"installed_integrations.url": "URL: {url}",
		"installed_outgoing_webhooks.add": "Add Outgoing Webhook",
		"installed_outgoing_webhooks.empty": "No outgoing webhooks found",
		"installed_outgoing_webhooks.header": "Outgoing Webhooks",
		"integrations.command.description": "Slash commands send events to external integrations",
		"integrations.command.title": "Slash Command",
		"integrations.header": "Integrations",
		"integrations.incomingWebhook.description": "Incoming webhooks allow external integrations to send messages",
		"integrations.incomingWebhook.title": "Incoming Webhook",
		"integrations.outgoingWebhook.description": "Outgoing webhooks allow external integrations to receive and respond to messages",
		"integrations.outgoingWebhook.title": "Outgoing Webhook",
		"intro_messages.DM": "This is the start of your direct message history with {teammate}.<br />Direct messages and files shared here are not shown to people outside this area.",
		"intro_messages.anyMember": " Any member can join and read this channel.",
		"intro_messages.beginning": "Beginning of {name}",
		"intro_messages.channel": "channel",
		"intro_messages.creator": "This is the start of the <strong>{name}</strong> {type}, created by <strong>{creator}</strong> on <strong>{date}</strong>",
		"intro_messages.default": "<h4 class='channel-intro__title'>Beginning of {display_name}</h4><p class='channel-intro__content'><strong>Welcome to {display_name}!</strong><br/><br/>This is the first channel teammates see when they sign up - use it for posting updates everyone needs to know.</p>",
		"intro_messages.group": "private group",
		"intro_messages.invite": "Invite others to this {type}",
		"intro_messages.inviteOthers": "Invite others to this team",
		"intro_messages.noCreator": "This is the start of the {name} {type}, created on {date}.",
		"intro_messages.offTopic": "<h4 class=\"channel-intro__title\">Beginning of {display_name}</h4><p class=\"channel-intro__content\">This is the start of {display_name}, a channel for non-work-related conversations.<br/></p>",
		"intro_messages.onlyInvited": " Only invited members can see this private group.",
		"intro_messages.setHeader": "Set a Header",
		"intro_messages.teammate": "This is the start of your direct message history with this teammate. Direct messages and files shared here are not shown to people outside this area.",
		"invite_member.addAnother": "Add another",
		"invite_member.autoJoin": "People invited automatically join the <strong>{channel}</strong> channel.",
		"invite_member.cancel": "Cancel",
		"invite_member.content": "Email is currently disabled for your team, and email invitations cannot be sent. Contact your system administrator to enable email and email invitations.",
		"invite_member.disabled": "User creation has been disabled for your team. Please ask your team administrator for details.",
		"invite_member.emailError": "Please enter a valid email address",
		"invite_member.firstname": "First name",
		"invite_member.inviteLink": "Team Invite Link",
		"invite_member.lastname": "Last name",
		"invite_member.modalButton": "Yes, Discard",
		"invite_member.modalMessage": "You have unsent invitations, are you sure you want to discard them?",
		"invite_member.modalTitle": "Discard Invitations?",
		"invite_member.newMember": "Invite New Member",
		"invite_member.send": "Send Invitation",
		"invite_member.send2": "Send Invitations",
		"invite_member.sending": " Sending",
		"invite_member.teamInviteLink": "You can also invite people using the {link}.",
		"ldap_signup.find": "Find my teams",
		"ldap_signup.ldap": "Create team with LDAP Account",
		"ldap_signup.length_error": "Name must be 3 or more characters up to a maximum of 15",
		"ldap_signup.teamName": "Enter name of new team",
		"ldap_signup.team_error": "Please enter a team name",
		"loading_screen.loading": "Loading",
		"login.changed": " Sign-in method changed successfully",
		"login.create": "Create one now",
		"login.createTeam": "Create a new team",
		"login.email": "Email",
		"login.find": "Find your other teams",
		"login.forgot": "I forgot my password",
		"login.gitlab": "GitLab",
		"login.google": "Google Apps",
		"login.invalidPassword": "Your password is incorrect.",
		"login.ldapUsername": "LDAP Username",
		"login.noAccount": "Don't have an account? ",
		"login.on": "on {siteName}",
		"login.or": "or",
		"login.password": "Password",
		"login.passwordChanged": " Password updated successfully",
		"login.session_expired": " Your session has expired. Please login again.",
		"login.signIn": "Sign in",
		"login.signInWith": "Sign in with:",
		"login.userNotFound": "We couldn't find an account matching your login credentials.",
		"login.username": "Username",
		"login.verified": " Email Verified",
		"login_mfa.enterToken": "To complete the sign in process, please enter a token from your smartphone's authenticator",
		"login_mfa.submit": "Submit",
		"login_mfa.token": "MFA Token",
		"login_mfa.tokenReq": "Please enter an MFA token",
		"member_item.makeAdmin": "Make Admin",
		"member_item.member": "Member",
		"member_list.noUsersAdd": "No users to add.",
		"members_popover.msg": "Message",
		"members_popover.title": "Members",
		"more_channels.close": "Close",
		"more_channels.create": "Create New Channel",
		"more_channels.createClick": "Click 'Create New Channel' to make a new one",
		"more_channels.join": "Join",
		"more_channels.noMore": "No more channels to join",
		"more_channels.title": "More Channels",
		"more_direct_channels.close": "Close",
		"more_direct_channels.message": "Message",
		"more_direct_channels.title": "Direct Messages",
		"msg_typing.areTyping": "{users} and {last} are typing...",
		"msg_typing.isTyping": "{user} is typing...",
		"msg_typing.someone": "Someone",
		"navbar.addMembers": "Add Members",
		"navbar.click": "Click here",
		"navbar.delete": "Delete Channel...",
		"navbar.leave": "Leave Channel",
		"navbar.manageMembers": "Manage Members",
		"navbar.noHeader": "No channel header yet.{newline}{link} to add one.",
		"navbar.preferences": "Notification Preferences",
		"navbar.rename": "Rename Channel...",
		"navbar.setHeader": "Set Channel Header...",
		"navbar.setPurpose": "Set Channel Purpose...",
		"navbar.toggle1": "Toggle sidebar",
		"navbar.toggle2": "Toggle sidebar",
		"navbar.viewInfo": "View Info",
		"navbar_dropdown.about": "About Mattermost",
		"navbar_dropdown.accountSettings": "Account Settings",
		"navbar_dropdown.console": "System Console",
		"navbar_dropdown.create": "Create a New Team",
		"navbar_dropdown.help": "Help",
		"navbar_dropdown.integrations": "Integrations",
		"navbar_dropdown.inviteMember": "Invite New Member",
		"navbar_dropdown.logout": "Logout",
		"navbar_dropdown.manageMembers": "Manage Members",
		"navbar_dropdown.report": "Report a Problem",
		"navbar_dropdown.switchTeam": "Switch to {team}",
		"navbar_dropdown.teamLink": "Get Team Invite Link",
		"navbar_dropdown.teamSettings": "Team Settings",
		"password_form.change": "Change my password",
		"password_form.click": "Click <a href={url}>here</a> to log in.",
		"password_form.enter": "Enter a new password for your {siteName} account.",
		"password_form.error": "Please enter at least {chars} characters.",
		"password_form.pwd": "Password",
		"password_form.title": "Password Reset",
		"password_form.update": "Your password has been updated successfully.",
		"password_send.checkInbox": "Please check your inbox.",
		"password_send.description": "To reset your password, enter the email address you used to sign up",
		"password_send.email": "Email",
		"password_send.error": "Please enter a valid email address.",
		"password_send.link": "<p>A password reset link has been sent to <b>{email}</b></p>",
		"password_send.reset": "Reset my password",
		"password_send.title": "Password Reset",
		"permalink.error.access": "Permalink belongs to a channel you do not have access to",
		"post_attachment.collapse": "▲ collapse text",
		"post_attachment.more": "▼ read more",
		"post_body.commentedOn": "Commented on {name}{apostrophe} message: ",
		"post_body.deleted": "(message deleted)",
		"post_body.plusMore": " plus {count} other files",
		"post_body.plusOne": " plus 1 other file",
		"post_body.retry": "Retry",
		"post_delete.notPosted": "Comment could not be posted",
		"post_delete.okay": "Okay",
		"post_delete.someone": "Someone deleted the message on which you tried to post a comment.",
		"post_focus_view.beginning": "Beginning of Channel Archives",
		"post_info.del": "Delete",
		"post_info.edit": "Edit",
		"post_info.permalink": "Permalink",
		"post_info.reply": "Reply",
		"posts_view.loadMore": "Load more messages",
		"posts_view.newMsg": "New Messages",
		"register_app.callback": "Callback URL",
		"register_app.callbackError": "At least one callback URL must be filled in.",
		"register_app.cancel": "Cancel",
		"register_app.clientId": "Client ID",
		"register_app.clientSecret": "Client Secret",
		"register_app.close": "Close",
		"register_app.credentialsDescription": "Save these somewhere SAFE and SECURE. Treat your Client ID as your app's username and your Client Secret as the app's password.",
		"register_app.credentialsSave": "I have saved both my Client Id and Client Secret somewhere safe",
		"register_app.credentialsTitle": "Your Application Credentials",
		"register_app.description": "Description",
		"register_app.dev": "Developer Applications",
		"register_app.homepage": "Homepage URL",
		"register_app.homepageError": "Homepage must be filled in.",
		"register_app.name": "Application Name",
		"register_app.nameError": "Application name must be filled in.",
		"register_app.optional": "Optional",
		"register_app.register": "Register",
		"register_app.required": "Required",
		"register_app.title": "Register a New Application",
		"removed_channel.channelName": "the channel",
		"removed_channel.from": "Removed from ",
		"removed_channel.okay": "Okay",
		"removed_channel.remover": "{remover} removed you from {channel}",
		"removed_channel.someone": "Someone",
		"rename_channel.cancel": "Cancel",
		"rename_channel.defaultError": " - Cannot be changed for the default channel",
		"rename_channel.displayName": "Display Name",
		"rename_channel.displayNameHolder": "Enter display name",
		"rename_channel.handle": "Handle",
		"rename_channel.handleHolder": "lowercase alphanumeric&#39;s only",
		"rename_channel.lowercase": "Must be lowercase alphanumeric characters",
		"rename_channel.maxLength": "This field must be less than 22 characters",
		"rename_channel.required": "This field is required",
		"rename_channel.save": "Save",
		"rename_channel.title": "Rename Channel",
		"rhs_comment.comment": "Comment",
		"rhs_comment.del": "Delete",
		"rhs_comment.edit": "Edit",
		"rhs_comment.permalink": "Permalink",
		"rhs_comment.retry": "Retry",
		"rhs_header.details": "Message Details",
		"rhs_root.del": "Delete",
		"rhs_root.direct": "Direct Message",
		"rhs_root.edit": "Edit",
		"rhs_root.permalink": "Permalink",
		"search_bar.cancel": "Cancel",
		"search_bar.search": "Search",
		"search_bar.usage": "<h4>Search Options</h4><ul><li><span>Use </span><b>\"quotation marks\"</b><span> to search for phrases</span></li><li><span>Use </span><b>from:</b><span> to find posts from specific users and </span><b>in:</b><span> to find posts in specific channels</span></li></ul>",
		"search_header.results": "Search Results",
		"search_header.title2": "Recent Mentions",
		"search_item.direct": "Direct Message",
		"search_item.jump": "Jump",
		"search_results.because": "<ul><li>If you're searching a partial phrase (ex. searching \"rea\", looking for \"reach\" or \"reaction\"), append a * to your search term</li><li>Due to the volume of results, two letter searches and common words like \"this\", \"a\" and \"is\" won't appear in search results</li></ul>",
		"search_results.noResults": "NO RESULTS",
		"search_results.usage": "<ul><li>Use <b>\"quotation marks\"</b> to search for phrases</li><li>Use <b>from:</b> to find posts from specific users and <b>in:</b> to find posts in specific channels</li></ul>",
		"setting_item_max.cancel": "Cancel",
		"setting_item_max.save": "Save",
		"setting_item_min.edit": "Edit",
		"setting_picture.cancel": "Cancel",
		"setting_picture.help": "Upload a profile picture in either JPG or PNG format, at least {width}px in width and {height}px height.",
		"setting_picture.save": "Save",
		"setting_picture.select": "Select",
		"setting_upload.import": "Import",
		"setting_upload.noFile": "No file selected.",
		"setting_upload.select": "Select file",
		"sidebar.channels": "Channels",
		"sidebar.createChannel": "Create new channel",
		"sidebar.createGroup": "Create new group",
		"sidebar.direct": "Direct Messages",
		"sidebar.more": "More",
		"sidebar.moreElips": "More...",
		"sidebar.otherMembers": "Outside this team",
		"sidebar.pg": "Private Groups",
		"sidebar.removeList": "Remove from list",
		"sidebar.tutorialScreen1": "<h4>Channels</h4><p><strong>Channels</strong> organize conversations across different topics. They’re open to everyone on your team. To send private communications use <strong>Direct Messages</strong> for a single person or <strong>Private Groups</strong> for multiple people.</p>",
		"sidebar.tutorialScreen2": "<h4>\"{townsquare}\" and \"{offtopic}\" channels</h4><p>Here are two public channels to start:</p><p><strong>{townsquare}</strong> is a place for team-wide communication. Everyone in your team is a member of this channel.</p><p><strong>{offtopic}</strong> is a place for fun and humor outside of work-related channels. You and your team can decide what other channels to create.</p>",
		"sidebar.tutorialScreen3": "<h4>Creating and Joining Channels</h4><p>Click <strong>\"More...\"</strong> to create a new channel or join an existing one.</p><p>You can also create a new channel or private group by clicking the <strong>\"+\" symbol</strong> next to the channel or private group header.</p>",
		"sidebar.unreadAbove": "Unread post(s) above",
		"sidebar.unreadBelow": "Unread post(s) below",
		"sidebar_header.tutorial": "<h4>Main Menu</h4><p>The <strong>Main Menu</strong> is where you can <strong>Invite New Members</strong>, access your <strong>Account Settings</strong> and set your <strong>Theme Color</strong>.</p><p>Team administrators can also access their <strong>Team Settings</strong> from this menu.</p><p>System administrators will find a <strong>System Console</strong> option to administrate the entire system.</p>",
		"sidebar_right_menu.accountSettings": "Account Settings",
		"sidebar_right_menu.console": "System Console",
		"sidebar_right_menu.help": "Help",
		"sidebar_right_menu.inviteNew": "Invite New Member",
		"sidebar_right_menu.logout": "Logout",
		"sidebar_right_menu.manageMembers": "Manage Members",
		"sidebar_right_menu.report": "Report a Problem",
		"sidebar_right_menu.switch_team": "Switch Team",
		"sidebar_right_menu.teamLink": "Get Team Invite Link",
		"sidebar_right_menu.teamSettings": "Team Settings",
		"signup_team.choose": "Teams you are a member of: ",
		"signup_team.createTeam": "Or Create a Team",
		"signup_team.disabled": "Team creation has been disabled.  Please contact an administrator for access.",
		"signup_team.join_open": "Open teams you can join: ",
		"signup_team.noTeams": "There are no teams included in the Team Directory and team creation has been disabled.",
		"signup_team.no_teams": "You do not appear to be a member of any team.  Please ask your administrator for an invite, join an open team if one exists or possibly create a new team.",
		"signup_team.none": "No team creation method has been enabled.  Please contact an administrator for access.",
		"signup_team_complete.completed": "You've already completed the signup process for this invitation or this invitation has expired.",
		"signup_team_confirm.checkEmail": "Please check your email: <strong>{email}</strong><br />Your email contains a link to set up your team",
		"signup_team_confirm.title": "Sign up Complete",
		"signup_user_completed.choosePwd": "Choose your password",
		"signup_user_completed.chooseUser": "Choose your username",
		"signup_user_completed.create": "Create Account",
		"signup_user_completed.emailHelp": "Valid email required for sign-up",
		"signup_user_completed.emailIs": "Your email address is <strong>{email}</strong>. You'll use this address to sign in to {siteName}.",
		"signup_user_completed.expired": "You've already completed the signup process for this invitation or this invitation has expired.",
		"signup_user_completed.gitlab": "with GitLab",
		"signup_user_completed.google": "with Google",
		"signup_user_completed.invalid_invite": "The invite link was invalid.  Please speak with your Administrator to receive an invitation.",
		"signup_user_completed.lets": "Let's create your account",
		"signup_user_completed.no_open_server": "This server does not allow open signups.  Please speak with your Administrator to receive an invitation.",
		"signup_user_completed.none": "No user creation method has been enabled.  Please contact an administrator for access.",
		"signup_user_completed.onSite": "on {siteName}",
		"signup_user_completed.or": "or",
		"signup_user_completed.passwordLength": "Please enter at least {min} characters",
		"signup_user_completed.required": "This field is required",
		"signup_user_completed.reserved": "This username is reserved, please choose a new one.",
		"signup_user_completed.userHelp": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-' and '_'",
		"signup_user_completed.usernameLength": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-' and '_'.",
		"signup_user_completed.validEmail": "Please enter a valid email address",
		"signup_user_completed.welcome": "Welcome to:",
		"signup_user_completed.whatis": "What's your email address?",
		"signup_user_completed.withLdap": "With your LDAP credentials",
		"sso_signup.find": "Find my teams",
		"sso_signup.gitlab": "Create team with GitLab Account",
		"sso_signup.google": "Create team with Google Apps Account",
		"sso_signup.length_error": "Name must be 3 or more characters up to a maximum of 15",
		"sso_signup.teamName": "Enter name of new team",
		"sso_signup.team_error": "Please enter a team name",
		"suggestion.mention.all": "Notifies everyone in the team",
		"suggestion.mention.channel": "Notifies everyone in the channel",
		"suggestion.search.private": "Private Groups",
		"suggestion.search.public": "Public Channels",
		"team_export_tab.download": "download",
		"team_export_tab.export": "Export",
		"team_export_tab.exportTeam": "Export your team",
		"team_export_tab.exporting": " Exporting...",
		"team_export_tab.ready": " Ready for ",
		"team_export_tab.unable": " Unable to export: {error}",
		"team_import_tab.failure": " Import failure: ",
		"team_import_tab.import": "Import",
		"team_import_tab.importHelp": "<p>To import a team from Slack go to Slack > Team Settings > Import/Export Data > Export > Start Export. Slack does not allow you to export files, images, private groups or direct messages stored in Slack. Therefore, Slack import to Mattermost only supports importing of text messages in your Slack team's public channels.</p><p>The Slack import to Mattermost is in 'Beta'. Slack bot posts do not yet import and Slack @mentions are not currently supported.</p>",
		"team_import_tab.importSlack": "Import from Slack (Beta)",
		"team_import_tab.importing": " Importing...",
		"team_import_tab.successful": " Import successful: ",
		"team_import_tab.summary": "View Summary",
		"team_member_modal.close": "Close",
		"team_member_modal.members": "{team} Members",
		"team_members_dropdown.confirmDemoteDescription": "If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you'll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.",
		"team_members_dropdown.confirmDemoteRoleTitle": "Confirm demotion from System Admin role",
		"team_members_dropdown.confirmDemotion": "Confirm Demotion",
		"team_members_dropdown.confirmDemotionCmd": "platform -assign_role -team_name=\"yourteam\" -email=\"name@yourcompany.com\" -role=\"system_admin\"",
		"team_members_dropdown.inactive": "Inactive",
		"team_members_dropdown.makeActive": "Make Active",
		"team_members_dropdown.makeAdmin": "Make Team Admin",
		"team_members_dropdown.makeInactive": "Make Inactive",
		"team_members_dropdown.makeMember": "Make Member",
		"team_members_dropdown.member": "Member",
		"team_members_dropdown.systemAdmin": "System Admin",
		"team_members_dropdown.teamAdmin": "Team Admin",
		"team_settings_modal.exportTab": "Export",
		"team_settings_modal.generalTab": "General",
		"team_settings_modal.importTab": "Import",
		"team_settings_modal.title": "Team Settings",
		"textbox.bold": "**bold**",
		"textbox.edit": "Edit message",
		"textbox.help": "Help",
		"textbox.inlinecode": "`inline code`",
		"textbox.italic": "_italic_",
		"textbox.preformatted": "```preformatted```",
		"textbox.preview": "Preview",
		"textbox.quote": ">quote",
		"textbox.strike": "strike",
		"tutorial_intro.allSet": "You’re all set",
		"tutorial_intro.end": "Click “Next” to enter {channel}. This is the first channel teammates see when they sign up. Use it for posting updates everyone needs to know.",
		"tutorial_intro.invite": "Invite teammates",
		"tutorial_intro.next": "Next",
		"tutorial_intro.screenOne": "<h3>Welcome to:</h3><h1>Mattermost</h1><p>Your team communication all in one place, instantly searchable and available anywhere</p><p>Keep your team connected to help them achieve what matters most.</p>",
		"tutorial_intro.screenTwo": "<h3>How Mattermost works:</h3><p>Communication happens in public discussion channels, private groups and direct messages.</p><p>Everything is archived and searchable from any web-enabled desktop, laptop or phone.</p>",
		"tutorial_intro.skip": "Skip tutorial",
		"tutorial_intro.support": "Need anything, just email us at ",
		"tutorial_intro.teamInvite": "Invite teammates",
		"tutorial_intro.whenReady": " when you’re ready.",
		"tutorial_tip.next": "Next",
		"tutorial_tip.ok": "Okay",
		"tutorial_tip.out": "Opt out of these tips.",
		"tutorial_tip.seen": "Seen this before? ",
		"upload_overlay.info": "Drop a file to upload it.",
		"user.settings.advance.embed_preview": "Show preview snippet of links below message",
		"user.settings.advance.embed_toggle": "Show toggle for all embed previews",
		"user.settings.advance.enabled": "enabled",
		"user.settings.advance.feature": " Feature ",
		"user.settings.advance.features": " Features ",
		"user.settings.advance.markdown_preview": "Show markdown preview option in message input box",
		"user.settings.advance.off": "Off",
		"user.settings.advance.on": "On",
		"user.settings.advance.preReleaseDesc": "Check any pre-released features you'd like to preview.  You may also need to refresh the page before the setting will take effect.",
		"user.settings.advance.preReleaseTitle": "Preview pre-release features",
		"user.settings.advance.sendDesc": "If enabled 'Enter' inserts a new line and 'Ctrl + Enter' submits the message.",
		"user.settings.advance.sendTitle": "Send messages on Ctrl + Enter",
		"user.settings.advance.slashCmd_autocmp": "Enable external application to offer slash command autocomplete",
		"user.settings.advance.title": "Advanced Settings",
		"user.settings.custom_theme.awayIndicator": "Away Indicator",
		"user.settings.custom_theme.buttonBg": "Button BG",
		"user.settings.custom_theme.buttonColor": "Button Text",
		"user.settings.custom_theme.centerChannelBg": "Center Channel BG",
		"user.settings.custom_theme.centerChannelColor": "Center Channel Text",
		"user.settings.custom_theme.codeTheme": "Code Theme",
		"user.settings.custom_theme.copyPaste": "Copy and paste to share theme colors:",
		"user.settings.custom_theme.linkColor": "Link Color",
		"user.settings.custom_theme.mentionBj": "Mention Jewel BG",
		"user.settings.custom_theme.mentionColor": "Mention Jewel Text",
		"user.settings.custom_theme.mentionHighlightBg": "Mention Highlight BG",
		"user.settings.custom_theme.mentionHighlightLink": "Mention Highlight Link",
		"user.settings.custom_theme.newMessageSeparator": "New Message Separator",
		"user.settings.custom_theme.onlineIndicator": "Online Indicator",
		"user.settings.custom_theme.sidebarBg": "Sidebar BG",
		"user.settings.custom_theme.sidebarHeaderBg": "Sidebar Header BG",
		"user.settings.custom_theme.sidebarHeaderTextColor": "Sidebar Header Text",
		"user.settings.custom_theme.sidebarText": "Sidebar Text",
		"user.settings.custom_theme.sidebarTextActiveBorder": "Sidebar Text Active Border",
		"user.settings.custom_theme.sidebarTextActiveColor": "Sidebar Text Active Color",
		"user.settings.custom_theme.sidebarTextHoverBg": "Sidebar Text Hover BG",
		"user.settings.custom_theme.sidebarUnreadText": "Sidebar Unread Text",
		"user.settings.developer.applicationsPreview": "Applications (Preview)",
		"user.settings.developer.register": "Register New Application",
		"user.settings.developer.thirdParty": "Open to register a new third-party application",
		"user.settings.developer.title": "Developer Settings",
		"user.settings.display.channelDisplayTitle": "Channel Display Mode",
		"user.settings.display.channeldisplaymode": "Select how text in a channel is displayed.",
		"user.settings.display.clockDisplay": "Clock Display",
		"user.settings.display.fixedWidthCentered": "Fixed width, centered",
		"user.settings.display.fontDesc": "Select the font displayed in the Mattermost user interface.",
		"user.settings.display.fontTitle": "Display Font",
		"user.settings.display.fullScreen": "Full width",
		"user.settings.display.language": "Language",
		"user.settings.display.militaryClock": "24-hour clock (example: 16:00)",
		"user.settings.display.nameOptsDesc": "Set how to display other user's names in posts and the Direct Messages list.",
		"user.settings.display.normalClock": "12-hour clock (example: 4:00 PM)",
		"user.settings.display.preferTime": "Select how you prefer time displayed.",
		"user.settings.display.showFullname": "Show first and last name",
		"user.settings.display.showNickname": "Show nickname if one exists, otherwise show first and last name",
		"user.settings.display.showUsername": "Show username (default)",
		"user.settings.display.teammateDisplay": "Teammate Name Display",
		"user.settings.display.theme.customTheme": "Custom Theme",
		"user.settings.display.theme.describe": "Open to manage your theme",
		"user.settings.display.theme.import": "Import theme colors from Slack",
		"user.settings.display.theme.otherThemes": "See other themes",
		"user.settings.display.theme.themeColors": "Theme Colors",
		"user.settings.display.theme.title": "Theme",
		"user.settings.display.title": "Display Settings",
		"user.settings.general.checkEmail": "Check your email at {email} to verify the address.",
		"user.settings.general.checkEmailNoAddress": "Check your email to verify your new address",
		"user.settings.general.close": "Close",
		"user.settings.general.confirmEmail": "Confirm Email",
		"user.settings.general.email": "Email",
		"user.settings.general.emailGitlabCantUpdate": "Login occurs through GitLab. Email cannot be updated. Email address used for notifications is {email}.",
		"user.settings.general.emailHelp1": "Email is used for sign-in, notifications, and password reset. Email requires verification if changed.",
		"user.settings.general.emailHelp2": "Email has been disabled by your system administrator. No notification emails will be sent until it is enabled.",
		"user.settings.general.emailHelp3": "Email is used for sign-in, notifications, and password reset.",
		"user.settings.general.emailHelp4": "A verification email was sent to {email}.",
		"user.settings.general.emailLdapCantUpdate": "Login occurs through LDAP. Email cannot be updated. Email address used for notifications is {email}.",
		"user.settings.general.emailMatch": "The new emails you entered do not match.",
		"user.settings.general.emptyName": "Click 'Edit' to add your full name",
		"user.settings.general.emptyNickname": "Click 'Edit' to add a nickname",
		"user.settings.general.firstName": "First Name",
		"user.settings.general.fullName": "Full Name",
		"user.settings.general.imageTooLarge": "Unable to upload profile image. File is too large.",
		"user.settings.general.imageUpdated": "Image last updated {date}",
		"user.settings.general.lastName": "Last Name",
		"user.settings.general.loginGitlab": "Login done through GitLab ({email})",
		"user.settings.general.loginLdap": "Login done through LDAP ({email})",
		"user.settings.general.newAddress": "New Address: {email}<br />Check your email to verify the above address.",
		"user.settings.general.nickname": "Nickname",
		"user.settings.general.nicknameExtra": "Use Nickname for a name you might be called that is different from your first name and username. This is most often used when two or more people have similar sounding names and usernames.",
		"user.settings.general.notificationsExtra": "By default, you will receive mention notifications when someone types your first name. Go to {notify} settings to change this default.",
		"user.settings.general.notificationsLink": "Notifications",
		"user.settings.general.primaryEmail": "Primary Email",
		"user.settings.general.profilePicture": "Profile Picture",
		"user.settings.general.title": "General Settings",
		"user.settings.general.uploadImage": "Click 'Edit' to upload an image.",
		"user.settings.general.username": "Username",
		"user.settings.general.usernameInfo": "Pick something easy for teammates to recognize and recall.",
		"user.settings.general.usernameReserved": "This username is reserved, please choose a new one.",
		"user.settings.general.usernameRestrictions": "Username must begin with a letter, and contain between {min} to {max} lowercase characters made up of numbers, letters, and the symbols '.', '-', and '_'.",
		"user.settings.general.validEmail": "Please enter a valid email address",
		"user.settings.general.validImage": "Only JPG or PNG images may be used for profile pictures",
		"user.settings.import_theme.cancel": "Cancel",
		"user.settings.import_theme.importBody": "To import a theme, go to a Slack team and look for “Preferences -> Sidebar Theme”. Open the custom theme option, copy the theme color values and paste them here:",
		"user.settings.import_theme.importHeader": "Import Slack Theme",
		"user.settings.import_theme.submit": "Submit",
		"user.settings.import_theme.submitError": "Invalid format, please try copying and pasting in again.",
		"user.settings.languages.change": "Change interface language",
		"user.settings.mfa.add": "Add MFA to your account",
		"user.settings.mfa.addHelp": "You can require a smartphone-based token, in addition to your password, to sign into Mattermost.<br/><br/>To enable, download Google Authenticator from <a target='_blank' href='https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8'>iTunes</a> or <a target='_blank' href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en'>Google Play</a> for your phone, then<br/><br/>1. Click the <strong>Add MFA to your account</strong> button above.<br/>2. Use Google Authenticator to scan the QR code that appears.<br/>3. Type in the Token generated by Google Authenticator and click <strong>Save</strong>.<br/><br/>When logging in, you will be asked to enter a token from Google Authenticator in addition to your regular credentials.",
		"user.settings.mfa.addHelpQr": "Please scan the bar code with the Google Authenticator app on your smartphone and fill in the token with one provided by the app.",
		"user.settings.mfa.enterToken": "Token (numbers only)",
		"user.settings.mfa.qrCode": "Bar Code",
		"user.settings.mfa.remove": "Remove MFA from your account",
		"user.settings.mfa.removeHelp": "Removing multi-factor authentication means you will no longer require a phone-based passcode to sign-in to your account.",
		"user.settings.modal.advanced": "Advanced",
		"user.settings.modal.confirmBtns": "Yes, Discard",
		"user.settings.modal.confirmMsg": "You have unsaved changes, are you sure you want to discard them?",
		"user.settings.modal.confirmTitle": "Discard Changes?",
		"user.settings.modal.developer": "Developer",
		"user.settings.modal.display": "Display",
		"user.settings.modal.general": "General",
		"user.settings.modal.notifications": "Notifications",
		"user.settings.modal.security": "Security",
		"user.settings.modal.title": "Account Settings",
		"user.settings.notification.allActivity": "For all activity",
		"user.settings.notification.soundConfig": "Please configure notification sounds in your browser settings",
		"user.settings.notifications.channelWide": "Channel-wide mentions \"@channel\"",
		"user.settings.notifications.close": "Close",
		"user.settings.notifications.desktop": "Send desktop notifications",
		"user.settings.notifications.desktopSounds": "Desktop notification sounds",
		"user.settings.notifications.emailInfo": "Email notifications are sent for mentions and direct messages after you’ve been offline for more than 60 seconds or away from {siteName} for more than 5 minutes.",
		"user.settings.notifications.emailNotifications": "Email notifications",
		"user.settings.notifications.header": "Notifications",
		"user.settings.notifications.info": "Desktop notifications are available on Firefox, Safari, Chrome, Internet Explorer, and Edge.",
		"user.settings.notifications.never": "Never",
		"user.settings.notifications.noWords": "No words configured",
		"user.settings.notifications.off": "Off",
		"user.settings.notifications.on": "On",
		"user.settings.notifications.onlyMentions": "Only for mentions and direct messages",
		"user.settings.notifications.sensitiveName": "Your case sensitive first name \"{first_name}\"",
		"user.settings.notifications.sensitiveUsername": "Your non-case sensitive username \"{username}\"",
		"user.settings.notifications.sensitiveWords": "Other non-case sensitive words, separated by commas:",
		"user.settings.notifications.sounds_info": "Desktop notifications sounds are available on Firefox, Safari, Chrome, Internet Explorer, and Edge.",
		"user.settings.notifications.teamWide": "Team-wide mentions \"@all\"",
		"user.settings.notifications.title": "Notification Settings",
		"user.settings.notifications.usernameMention": "Your username mentioned \"@{username}\"",
		"user.settings.notifications.wordsTrigger": "Words that trigger mentions",
		"user.settings.security.close": "Close",
		"user.settings.security.currentPassword": "Current Password",
		"user.settings.security.currentPasswordError": "Please enter your current password",
		"user.settings.security.emailPwd": "Email and Password",
		"user.settings.security.gitlab": "GitLab SSO",
		"user.settings.security.lastUpdated": "Last updated {date} at {time}",
		"user.settings.security.ldap": "LDAP",
		"user.settings.security.loginGitlab": "Login done through Gitlab",
		"user.settings.security.loginLdap": "Login done through LDAP",
		"user.settings.security.logoutActiveSessions": "View and Logout of Active Sessions",
		"user.settings.security.method": "Sign-in Method",
		"user.settings.security.newPassword": "New Password",
		"user.settings.security.oneSignin": "You may only have one sign-in method at a time. Switching sign-in method will send an email notifying you if the change was successful.",
		"user.settings.security.password": "Password",
		"user.settings.security.passwordGitlabCantUpdate": "Login occurs through GitLab. Password cannot be updated.",
		"user.settings.security.passwordLdapCantUpdate": "Login occurs through LDAP. Password cannot be updated.",
		"user.settings.security.passwordLengthError": "New passwords must be at least {chars} characters",
		"user.settings.security.passwordMatchError": "The new passwords you entered do not match",
		"user.settings.security.retypePassword": "Retype New Password",
		"user.settings.security.switchEmail": "Switch to using email and password",
		"user.settings.security.switchGitlab": "Switch to using GitLab SSO",
		"user.settings.security.switchGoogle": "Switch to using Google SSO",
		"user.settings.security.switchLdap": "Switch to using LDAP",
		"user.settings.security.title": "Security Settings",
		"user.settings.security.viewHistory": "View Access History",
		"user_list.notFound": "No users found",
		"user_profile.notShared": "Email not shared",
		"view_image.loading": "Loading ",
		"view_image_popover.download": "Download",
		"view_image_popover.file": "File {count} of {total}",
		"view_image_popover.publicLink": "Get Public Link",
		"web.footer.about": "About",
		"web.footer.help": "Help",
		"web.footer.privacy": "Privacy",
		"web.footer.terms": "Terms",
		"web.header.back": "Back",
		"web.root.singup_info": "All team communication in one place, searchable and accessible anywhere"
	};

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	module.e = {
		"modp1": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
		},
		"modp2": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
		},
		"modp5": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
		},
		"modp14": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
		},
		"modp15": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
		},
		"modp16": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
		},
		"modp17": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
		},
		"modp18": {
			"gen": "02",
			"prime": "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"
		}
	};

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	module.e = {
		"_args": [
			[
				"elliptic@^6.0.0",
				"/var/lib/jenkins/jobs/mattermost-platform-release/workspace/src/github.com/mattermost/platform/webapp/node_modules/browserify-sign"
			]
		],
		"_from": "elliptic@>=6.0.0 <7.0.0",
		"_id": "elliptic@6.2.3",
		"_inCache": true,
		"_installable": true,
		"_location": "/elliptic",
		"_nodeVersion": "5.4.1",
		"_npmUser": {
			"email": "fedor@indutny.com",
			"name": "indutny"
		},
		"_npmVersion": "3.3.12",
		"_phantomChildren": {},
		"_requested": {
			"name": "elliptic",
			"raw": "elliptic@^6.0.0",
			"rawSpec": "^6.0.0",
			"scope": null,
			"spec": ">=6.0.0 <7.0.0",
			"type": "range"
		},
		"_requiredBy": [
			"/browserify-sign",
			"/create-ecdh"
		],
		"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.2.3.tgz",
		"_shasum": "18e46d7306b0951275a2d42063270a14b74ebe99",
		"_shrinkwrap": null,
		"_spec": "elliptic@^6.0.0",
		"_where": "/var/lib/jenkins/jobs/mattermost-platform-release/workspace/src/github.com/mattermost/platform/webapp/node_modules/browserify-sign",
		"author": {
			"email": "fedor@indutny.com",
			"name": "Fedor Indutny"
		},
		"bugs": {
			"url": "https://github.com/indutny/elliptic/issues"
		},
		"dependencies": {
			"bn.js": "^4.0.0",
			"brorand": "^1.0.1",
			"hash.js": "^1.0.0",
			"inherits": "^2.0.1"
		},
		"description": "EC cryptography",
		"devDependencies": {
			"coveralls": "^2.11.3",
			"istanbul": "^0.4.2",
			"jscs": "^2.9.0",
			"jshint": "^2.6.0",
			"mocha": "^2.1.0"
		},
		"directories": {},
		"dist": {
			"shasum": "18e46d7306b0951275a2d42063270a14b74ebe99",
			"tarball": "https://registry.npmjs.org/elliptic/-/elliptic-6.2.3.tgz"
		},
		"files": [
			"lib"
		],
		"gitHead": "c32f20b22b420eb6af3c6dda28963deb7facf823",
		"homepage": "https://github.com/indutny/elliptic",
		"keywords": [
			"EC",
			"Elliptic",
			"curve",
			"Cryptography"
		],
		"license": "MIT",
		"main": "lib/elliptic.js",
		"maintainers": [
			{
				"email": "fedor@indutny.com",
				"name": "indutny"
			}
		],
		"name": "elliptic",
		"optionalDependencies": {},
		"readme": "ERROR: No README data found!",
		"repository": {
			"type": "git",
			"url": "git+ssh://git@github.com/indutny/elliptic.git"
		},
		"scripts": {
			"coverage": "npm run unit --coverage",
			"coveralls": "npm run coverage && cat ./coverage/lcov.info | coveralls",
			"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/*.js",
			"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/*.js",
			"lint": "npm run jscs && npm run jshint",
			"test": "npm run lint && npm run unit",
			"unit": "istanbul test _mocha --reporter=spec test/*-test.js"
		},
		"version": "6.2.3"
	};

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	module.e = {
		"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
		"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
		"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
		"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
		"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
		"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
		"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
		"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
		"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
		"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
		"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
		"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
	};

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	module.e = [
		{
			"emoji": "😄",
			"description": "smiling face with open mouth and smiling eyes",
			"aliases": [
				"smile"
			],
			"tags": [
				"happy",
				"joy",
				"pleased"
			]
		},
		{
			"emoji": "😃",
			"description": "smiling face with open mouth",
			"aliases": [
				"smiley"
			],
			"tags": [
				"happy",
				"joy",
				"haha"
			]
		},
		{
			"emoji": "😀",
			"description": "grinning face",
			"aliases": [
				"grinning"
			],
			"tags": [
				"smile",
				"happy"
			]
		},
		{
			"emoji": "😊",
			"description": "smiling face with smiling eyes",
			"aliases": [
				"blush"
			],
			"tags": [
				"proud"
			]
		},
		{
			"emoji": "☺️",
			"description": "white smiling face",
			"aliases": [
				"relaxed"
			],
			"tags": [
				"blush",
				"pleased"
			]
		},
		{
			"emoji": "😉",
			"description": "winking face",
			"aliases": [
				"wink"
			],
			"tags": [
				"flirt"
			]
		},
		{
			"emoji": "😍",
			"description": "smiling face with heart-shaped eyes",
			"aliases": [
				"heart_eyes"
			],
			"tags": [
				"love",
				"crush"
			]
		},
		{
			"emoji": "😘",
			"description": "face throwing a kiss",
			"aliases": [
				"kissing_heart"
			],
			"tags": [
				"flirt"
			]
		},
		{
			"emoji": "😚",
			"description": "kissing face with closed eyes",
			"aliases": [
				"kissing_closed_eyes"
			],
			"tags": []
		},
		{
			"emoji": "😗",
			"description": "kissing face",
			"aliases": [
				"kissing"
			],
			"tags": []
		},
		{
			"emoji": "😙",
			"description": "kissing face with smiling eyes",
			"aliases": [
				"kissing_smiling_eyes"
			],
			"tags": []
		},
		{
			"emoji": "😜",
			"description": "face with stuck-out tongue and winking eye",
			"aliases": [
				"stuck_out_tongue_winking_eye"
			],
			"tags": [
				"prank",
				"silly"
			]
		},
		{
			"emoji": "😝",
			"description": "face with stuck-out tongue and tightly-closed eyes",
			"aliases": [
				"stuck_out_tongue_closed_eyes"
			],
			"tags": [
				"prank"
			]
		},
		{
			"emoji": "😛",
			"description": "face with stuck-out tongue",
			"aliases": [
				"stuck_out_tongue"
			],
			"tags": []
		},
		{
			"emoji": "😳",
			"description": "flushed face",
			"aliases": [
				"flushed"
			],
			"tags": []
		},
		{
			"emoji": "😁",
			"description": "grinning face with smiling eyes",
			"aliases": [
				"grin"
			],
			"tags": []
		},
		{
			"emoji": "😔",
			"description": "pensive face",
			"aliases": [
				"pensive"
			],
			"tags": []
		},
		{
			"emoji": "😌",
			"description": "relieved face",
			"aliases": [
				"relieved"
			],
			"tags": [
				"whew"
			]
		},
		{
			"emoji": "😒",
			"description": "unamused face",
			"aliases": [
				"unamused"
			],
			"tags": [
				"meh"
			]
		},
		{
			"emoji": "😞",
			"description": "disappointed face",
			"aliases": [
				"disappointed"
			],
			"tags": [
				"sad"
			]
		},
		{
			"emoji": "😣",
			"description": "persevering face",
			"aliases": [
				"persevere"
			],
			"tags": [
				"struggling"
			]
		},
		{
			"emoji": "😢",
			"description": "crying face",
			"aliases": [
				"cry"
			],
			"tags": [
				"sad",
				"tear"
			]
		},
		{
			"emoji": "😂",
			"description": "face with tears of joy",
			"aliases": [
				"joy"
			],
			"tags": [
				"tears"
			]
		},
		{
			"emoji": "😭",
			"description": "loudly crying face",
			"aliases": [
				"sob"
			],
			"tags": [
				"sad",
				"cry",
				"bawling"
			]
		},
		{
			"emoji": "😪",
			"description": "sleepy face",
			"aliases": [
				"sleepy"
			],
			"tags": [
				"tired"
			]
		},
		{
			"emoji": "😥",
			"description": "disappointed but relieved face",
			"aliases": [
				"disappointed_relieved"
			],
			"tags": [
				"phew",
				"sweat",
				"nervous"
			]
		},
		{
			"emoji": "😰",
			"description": "face with open mouth and cold sweat",
			"aliases": [
				"cold_sweat"
			],
			"tags": [
				"nervous"
			]
		},
		{
			"emoji": "😅",
			"description": "smiling face with open mouth and cold sweat",
			"aliases": [
				"sweat_smile"
			],
			"tags": [
				"hot"
			]
		},
		{
			"emoji": "😓",
			"description": "face with cold sweat",
			"aliases": [
				"sweat"
			],
			"tags": []
		},
		{
			"emoji": "😩",
			"description": "weary face",
			"aliases": [
				"weary"
			],
			"tags": [
				"tired"
			]
		},
		{
			"emoji": "😫",
			"description": "tired face",
			"aliases": [
				"tired_face"
			],
			"tags": [
				"upset",
				"whine"
			]
		},
		{
			"emoji": "😨",
			"description": "fearful face",
			"aliases": [
				"fearful"
			],
			"tags": [
				"scared",
				"shocked",
				"oops"
			]
		},
		{
			"emoji": "😱",
			"description": "face screaming in fear",
			"aliases": [
				"scream"
			],
			"tags": [
				"horror",
				"shocked"
			]
		},
		{
			"emoji": "😠",
			"description": "angry face",
			"aliases": [
				"angry"
			],
			"tags": [
				"mad",
				"annoyed"
			]
		},
		{
			"emoji": "😡",
			"description": "pouting face",
			"aliases": [
				"rage",
				"pout"
			],
			"tags": [
				"angry"
			]
		},
		{
			"emoji": "😤",
			"description": "face with look of triumph",
			"aliases": [
				"triumph"
			],
			"tags": [
				"smug"
			]
		},
		{
			"emoji": "😖",
			"description": "confounded face",
			"aliases": [
				"confounded"
			],
			"tags": []
		},
		{
			"emoji": "😆",
			"description": "smiling face with open mouth and tightly-closed eyes",
			"aliases": [
				"laughing",
				"satisfied"
			],
			"tags": [
				"happy",
				"haha"
			]
		},
		{
			"emoji": "😋",
			"description": "face savouring delicious food",
			"aliases": [
				"yum"
			],
			"tags": [
				"tongue",
				"lick"
			]
		},
		{
			"emoji": "😷",
			"description": "face with medical mask",
			"aliases": [
				"mask"
			],
			"tags": [
				"sick",
				"ill"
			]
		},
		{
			"emoji": "😎",
			"description": "smiling face with sunglasses",
			"aliases": [
				"sunglasses"
			],
			"tags": [
				"cool"
			]
		},
		{
			"emoji": "😴",
			"description": "sleeping face",
			"aliases": [
				"sleeping"
			],
			"tags": [
				"zzz"
			]
		},
		{
			"emoji": "😵",
			"description": "dizzy face",
			"aliases": [
				"dizzy_face"
			],
			"tags": []
		},
		{
			"emoji": "😲",
			"description": "astonished face",
			"aliases": [
				"astonished"
			],
			"tags": [
				"amazed",
				"gasp"
			]
		},
		{
			"emoji": "😟",
			"description": "worried face",
			"aliases": [
				"worried"
			],
			"tags": [
				"nervous"
			]
		},
		{
			"emoji": "😦",
			"description": "frowning face with open mouth",
			"aliases": [
				"frowning"
			],
			"tags": []
		},
		{
			"emoji": "😧",
			"description": "anguished face",
			"aliases": [
				"anguished"
			],
			"tags": [
				"stunned"
			]
		},
		{
			"emoji": "😈",
			"description": "smiling face with horns",
			"aliases": [
				"smiling_imp"
			],
			"tags": [
				"devil",
				"evil",
				"horns"
			]
		},
		{
			"emoji": "👿",
			"description": "imp",
			"aliases": [
				"imp"
			],
			"tags": [
				"angry",
				"devil",
				"evil",
				"horns"
			]
		},
		{
			"emoji": "😮",
			"description": "face with open mouth",
			"aliases": [
				"open_mouth"
			],
			"tags": [
				"surprise",
				"impressed",
				"wow"
			]
		},
		{
			"emoji": "😬",
			"description": "grimacing face",
			"aliases": [
				"grimacing"
			],
			"tags": []
		},
		{
			"emoji": "😐",
			"description": "neutral face",
			"aliases": [
				"neutral_face"
			],
			"tags": [
				"meh"
			]
		},
		{
			"emoji": "😕",
			"description": "confused face",
			"aliases": [
				"confused"
			],
			"tags": []
		},
		{
			"emoji": "😯",
			"description": "hushed face",
			"aliases": [
				"hushed"
			],
			"tags": [
				"silence",
				"speechless"
			]
		},
		{
			"emoji": "😶",
			"description": "face without mouth",
			"aliases": [
				"no_mouth"
			],
			"tags": [
				"mute",
				"silence"
			]
		},
		{
			"emoji": "😇",
			"description": "smiling face with halo",
			"aliases": [
				"innocent"
			],
			"tags": [
				"angel"
			]
		},
		{
			"emoji": "😏",
			"description": "smirking face",
			"aliases": [
				"smirk"
			],
			"tags": [
				"smug"
			]
		},
		{
			"emoji": "😑",
			"description": "expressionless face",
			"aliases": [
				"expressionless"
			],
			"tags": []
		},
		{
			"emoji": "👲",
			"description": "man with gua pi mao",
			"aliases": [
				"man_with_gua_pi_mao"
			],
			"tags": []
		},
		{
			"emoji": "👳",
			"description": "man with turban",
			"aliases": [
				"man_with_turban"
			],
			"tags": []
		},
		{
			"emoji": "👮",
			"description": "police officer",
			"aliases": [
				"cop"
			],
			"tags": [
				"police",
				"law"
			]
		},
		{
			"emoji": "👷",
			"description": "construction worker",
			"aliases": [
				"construction_worker"
			],
			"tags": [
				"helmet"
			]
		},
		{
			"emoji": "💂",
			"description": "guardsman",
			"aliases": [
				"guardsman"
			],
			"tags": []
		},
		{
			"emoji": "👶",
			"description": "baby",
			"aliases": [
				"baby"
			],
			"tags": [
				"child",
				"newborn"
			]
		},
		{
			"emoji": "👦",
			"description": "boy",
			"aliases": [
				"boy"
			],
			"tags": [
				"child"
			]
		},
		{
			"emoji": "👧",
			"description": "girl",
			"aliases": [
				"girl"
			],
			"tags": [
				"child"
			]
		},
		{
			"emoji": "👨",
			"description": "man",
			"aliases": [
				"man"
			],
			"tags": [
				"mustache",
				"father",
				"dad"
			]
		},
		{
			"emoji": "👩",
			"description": "woman",
			"aliases": [
				"woman"
			],
			"tags": [
				"girls"
			]
		},
		{
			"emoji": "👴",
			"description": "older man",
			"aliases": [
				"older_man"
			],
			"tags": []
		},
		{
			"emoji": "👵",
			"description": "older woman",
			"aliases": [
				"older_woman"
			],
			"tags": []
		},
		{
			"emoji": "👱",
			"description": "person with blond hair",
			"aliases": [
				"person_with_blond_hair"
			],
			"tags": [
				"boy"
			]
		},
		{
			"emoji": "👼",
			"description": "baby angel",
			"aliases": [
				"angel"
			],
			"tags": []
		},
		{
			"emoji": "👸",
			"description": "princess",
			"aliases": [
				"princess"
			],
			"tags": [
				"blonde",
				"crown",
				"royal"
			]
		},
		{
			"emoji": "😺",
			"description": "smiling cat face with open mouth",
			"aliases": [
				"smiley_cat"
			],
			"tags": []
		},
		{
			"emoji": "😸",
			"description": "grinning cat face with smiling eyes",
			"aliases": [
				"smile_cat"
			],
			"tags": []
		},
		{
			"emoji": "😻",
			"description": "smiling cat face with heart-shaped eyes",
			"aliases": [
				"heart_eyes_cat"
			],
			"tags": []
		},
		{
			"emoji": "😽",
			"description": "kissing cat face with closed eyes",
			"aliases": [
				"kissing_cat"
			],
			"tags": []
		},
		{
			"emoji": "😼",
			"description": "cat face with wry smile",
			"aliases": [
				"smirk_cat"
			],
			"tags": []
		},
		{
			"emoji": "🙀",
			"description": "weary cat face",
			"aliases": [
				"scream_cat"
			],
			"tags": [
				"horror"
			]
		},
		{
			"emoji": "😿",
			"description": "crying cat face",
			"aliases": [
				"crying_cat_face"
			],
			"tags": [
				"sad",
				"tear"
			]
		},
		{
			"emoji": "😹",
			"description": "cat face with tears of joy",
			"aliases": [
				"joy_cat"
			],
			"tags": []
		},
		{
			"emoji": "😾",
			"description": "pouting cat face",
			"aliases": [
				"pouting_cat"
			],
			"tags": []
		},
		{
			"emoji": "👹",
			"description": "japanese ogre",
			"aliases": [
				"japanese_ogre"
			],
			"tags": [
				"monster"
			]
		},
		{
			"emoji": "👺",
			"description": "japanese goblin",
			"aliases": [
				"japanese_goblin"
			],
			"tags": []
		},
		{
			"emoji": "🙈",
			"description": "see-no-evil monkey",
			"aliases": [
				"see_no_evil"
			],
			"tags": [
				"monkey",
				"blind",
				"ignore"
			]
		},
		{
			"emoji": "🙉",
			"description": "hear-no-evil monkey",
			"aliases": [
				"hear_no_evil"
			],
			"tags": [
				"monkey",
				"deaf"
			]
		},
		{
			"emoji": "🙊",
			"description": "speak-no-evil monkey",
			"aliases": [
				"speak_no_evil"
			],
			"tags": [
				"monkey",
				"mute",
				"hush"
			]
		},
		{
			"emoji": "💀",
			"description": "skull",
			"aliases": [
				"skull"
			],
			"tags": [
				"dead",
				"danger",
				"poison"
			]
		},
		{
			"emoji": "👽",
			"description": "extraterrestrial alien",
			"aliases": [
				"alien"
			],
			"tags": [
				"ufo"
			]
		},
		{
			"emoji": "💩",
			"description": "pile of poo",
			"aliases": [
				"hankey",
				"poop",
				"shit"
			],
			"tags": [
				"crap"
			]
		},
		{
			"emoji": "🔥",
			"description": "fire",
			"aliases": [
				"fire"
			],
			"tags": [
				"burn"
			]
		},
		{
			"emoji": "✨",
			"description": "sparkles",
			"aliases": [
				"sparkles"
			],
			"tags": [
				"shiny"
			]
		},
		{
			"emoji": "🌟",
			"description": "glowing star",
			"aliases": [
				"star2"
			],
			"tags": []
		},
		{
			"emoji": "💫",
			"description": "dizzy symbol",
			"aliases": [
				"dizzy"
			],
			"tags": [
				"star"
			]
		},
		{
			"emoji": "💥",
			"description": "collision symbol",
			"aliases": [
				"boom",
				"collision"
			],
			"tags": [
				"explode"
			]
		},
		{
			"emoji": "💢",
			"description": "anger symbol",
			"aliases": [
				"anger"
			],
			"tags": [
				"angry"
			]
		},
		{
			"emoji": "💦",
			"description": "splashing sweat symbol",
			"aliases": [
				"sweat_drops"
			],
			"tags": [
				"water",
				"workout"
			]
		},
		{
			"emoji": "💧",
			"description": "droplet",
			"aliases": [
				"droplet"
			],
			"tags": [
				"water"
			]
		},
		{
			"emoji": "💤",
			"description": "sleeping symbol",
			"aliases": [
				"zzz"
			],
			"tags": [
				"sleeping"
			]
		},
		{
			"emoji": "💨",
			"description": "dash symbol",
			"aliases": [
				"dash"
			],
			"tags": [
				"wind",
				"blow",
				"fast"
			]
		},
		{
			"emoji": "👂",
			"description": "ear",
			"aliases": [
				"ear"
			],
			"tags": [
				"hear",
				"sound",
				"listen"
			]
		},
		{
			"emoji": "👀",
			"description": "eyes",
			"aliases": [
				"eyes"
			],
			"tags": [
				"look",
				"see",
				"watch"
			]
		},
		{
			"emoji": "👃",
			"description": "nose",
			"aliases": [
				"nose"
			],
			"tags": [
				"smell"
			]
		},
		{
			"emoji": "👅",
			"description": "tongue",
			"aliases": [
				"tongue"
			],
			"tags": [
				"taste"
			]
		},
		{
			"emoji": "👄",
			"description": "mouth",
			"aliases": [
				"lips"
			],
			"tags": [
				"kiss"
			]
		},
		{
			"emoji": "👍",
			"description": "thumbs up sign",
			"aliases": [
				"+1",
				"thumbsup"
			],
			"tags": [
				"approve",
				"ok"
			]
		},
		{
			"emoji": "👎",
			"description": "thumbs down sign",
			"aliases": [
				"-1",
				"thumbsdown"
			],
			"tags": [
				"disapprove",
				"bury"
			]
		},
		{
			"emoji": "👌",
			"description": "ok hand sign",
			"aliases": [
				"ok_hand"
			],
			"tags": []
		},
		{
			"emoji": "👊",
			"description": "fisted hand sign",
			"aliases": [
				"facepunch",
				"punch"
			],
			"tags": [
				"attack"
			]
		},
		{
			"emoji": "✊",
			"description": "raised fist",
			"aliases": [
				"fist"
			],
			"tags": [
				"power"
			]
		},
		{
			"emoji": "✌️",
			"description": "victory hand",
			"aliases": [
				"v"
			],
			"tags": [
				"victory",
				"peace"
			]
		},
		{
			"emoji": "👋",
			"description": "waving hand sign",
			"aliases": [
				"wave"
			],
			"tags": [
				"goodbye"
			]
		},
		{
			"emoji": "✋",
			"description": "raised hand",
			"aliases": [
				"hand",
				"raised_hand"
			],
			"tags": [
				"highfive",
				"stop"
			]
		},
		{
			"emoji": "👐",
			"description": "open hands sign",
			"aliases": [
				"open_hands"
			],
			"tags": []
		},
		{
			"emoji": "👆",
			"description": "white up pointing backhand index",
			"aliases": [
				"point_up_2"
			],
			"tags": []
		},
		{
			"emoji": "👇",
			"description": "white down pointing backhand index",
			"aliases": [
				"point_down"
			],
			"tags": []
		},
		{
			"emoji": "👉",
			"description": "white right pointing backhand index",
			"aliases": [
				"point_right"
			],
			"tags": []
		},
		{
			"emoji": "👈",
			"description": "white left pointing backhand index",
			"aliases": [
				"point_left"
			],
			"tags": []
		},
		{
			"emoji": "🙌",
			"description": "person raising both hands in celebration",
			"aliases": [
				"raised_hands"
			],
			"tags": [
				"hooray"
			]
		},
		{
			"emoji": "🙏",
			"description": "person with folded hands",
			"aliases": [
				"pray"
			],
			"tags": [
				"please",
				"hope",
				"wish"
			]
		},
		{
			"emoji": "☝️",
			"description": "white up pointing index",
			"aliases": [
				"point_up"
			],
			"tags": []
		},
		{
			"emoji": "👏",
			"description": "clapping hands sign",
			"aliases": [
				"clap"
			],
			"tags": [
				"praise",
				"applause"
			]
		},
		{
			"emoji": "💪",
			"description": "flexed biceps",
			"aliases": [
				"muscle"
			],
			"tags": [
				"flex",
				"bicep",
				"strong",
				"workout"
			]
		},
		{
			"emoji": "🚶",
			"description": "pedestrian",
			"aliases": [
				"walking"
			],
			"tags": []
		},
		{
			"emoji": "🏃",
			"description": "runner",
			"aliases": [
				"runner",
				"running"
			],
			"tags": [
				"exercise",
				"workout",
				"marathon"
			]
		},
		{
			"emoji": "💃",
			"description": "dancer",
			"aliases": [
				"dancer"
			],
			"tags": [
				"dress"
			]
		},
		{
			"emoji": "👫",
			"description": "man and woman holding hands",
			"aliases": [
				"couple"
			],
			"tags": [
				"date"
			]
		},
		{
			"emoji": "👪",
			"description": "family",
			"aliases": [
				"family"
			],
			"tags": [
				"home",
				"parents",
				"child"
			]
		},
		{
			"emoji": "👬",
			"description": "two men holding hands",
			"aliases": [
				"two_men_holding_hands"
			],
			"tags": [
				"couple",
				"date"
			]
		},
		{
			"emoji": "👭",
			"description": "two women holding hands",
			"aliases": [
				"two_women_holding_hands"
			],
			"tags": [
				"couple",
				"date"
			]
		},
		{
			"emoji": "💏",
			"description": "kiss",
			"aliases": [
				"couplekiss"
			],
			"tags": []
		},
		{
			"emoji": "💑",
			"description": "couple with heart",
			"aliases": [
				"couple_with_heart"
			],
			"tags": []
		},
		{
			"emoji": "👯",
			"description": "woman with bunny ears",
			"aliases": [
				"dancers"
			],
			"tags": [
				"bunny"
			]
		},
		{
			"emoji": "🙆",
			"description": "face with ok gesture",
			"aliases": [
				"ok_woman"
			],
			"tags": []
		},
		{
			"emoji": "🙅",
			"description": "face with no good gesture",
			"aliases": [
				"no_good",
				"ng_woman"
			],
			"tags": [
				"stop",
				"halt"
			]
		},
		{
			"emoji": "💁",
			"description": "information desk person",
			"aliases": [
				"information_desk_person"
			],
			"tags": []
		},
		{
			"emoji": "🙋",
			"description": "happy person raising one hand",
			"aliases": [
				"raising_hand"
			],
			"tags": []
		},
		{
			"emoji": "💆",
			"description": "face massage",
			"aliases": [
				"massage"
			],
			"tags": [
				"spa"
			]
		},
		{
			"emoji": "💇",
			"description": "haircut",
			"aliases": [
				"haircut"
			],
			"tags": [
				"beauty"
			]
		},
		{
			"emoji": "💅",
			"description": "nail polish",
			"aliases": [
				"nail_care"
			],
			"tags": [
				"beauty",
				"manicure"
			]
		},
		{
			"emoji": "👰",
			"description": "bride with veil",
			"aliases": [
				"bride_with_veil"
			],
			"tags": [
				"marriage",
				"wedding"
			]
		},
		{
			"emoji": "🙎",
			"description": "person with pouting face",
			"aliases": [
				"person_with_pouting_face"
			],
			"tags": []
		},
		{
			"emoji": "🙍",
			"description": "person frowning",
			"aliases": [
				"person_frowning"
			],
			"tags": [
				"sad"
			]
		},
		{
			"emoji": "🙇",
			"description": "person bowing deeply",
			"aliases": [
				"bow"
			],
			"tags": [
				"respect",
				"thanks"
			]
		},
		{
			"emoji": "🎩",
			"description": "top hat",
			"aliases": [
				"tophat"
			],
			"tags": [
				"hat",
				"classy"
			]
		},
		{
			"emoji": "👑",
			"description": "crown",
			"aliases": [
				"crown"
			],
			"tags": [
				"king",
				"queen",
				"royal"
			]
		},
		{
			"emoji": "👒",
			"description": "womans hat",
			"aliases": [
				"womans_hat"
			],
			"tags": []
		},
		{
			"emoji": "👟",
			"description": "athletic shoe",
			"aliases": [
				"athletic_shoe"
			],
			"tags": [
				"sneaker",
				"sport",
				"running"
			]
		},
		{
			"emoji": "👞",
			"description": "mans shoe",
			"aliases": [
				"mans_shoe",
				"shoe"
			],
			"tags": []
		},
		{
			"emoji": "👡",
			"description": "womans sandal",
			"aliases": [
				"sandal"
			],
			"tags": [
				"shoe"
			]
		},
		{
			"emoji": "👠",
			"description": "high-heeled shoe",
			"aliases": [
				"high_heel"
			],
			"tags": [
				"shoe"
			]
		},
		{
			"emoji": "👢",
			"description": "womans boots",
			"aliases": [
				"boot"
			],
			"tags": []
		},
		{
			"emoji": "👕",
			"description": "t-shirt",
			"aliases": [
				"shirt",
				"tshirt"
			],
			"tags": []
		},
		{
			"emoji": "👔",
			"description": "necktie",
			"aliases": [
				"necktie"
			],
			"tags": [
				"shirt",
				"formal"
			]
		},
		{
			"emoji": "👚",
			"description": "womans clothes",
			"aliases": [
				"womans_clothes"
			],
			"tags": []
		},
		{
			"emoji": "👗",
			"description": "dress",
			"aliases": [
				"dress"
			],
			"tags": []
		},
		{
			"emoji": "🎽",
			"description": "running shirt with sash",
			"aliases": [
				"running_shirt_with_sash"
			],
			"tags": [
				"marathon"
			]
		},
		{
			"emoji": "👖",
			"description": "jeans",
			"aliases": [
				"jeans"
			],
			"tags": [
				"pants"
			]
		},
		{
			"emoji": "👘",
			"description": "kimono",
			"aliases": [
				"kimono"
			],
			"tags": []
		},
		{
			"emoji": "👙",
			"description": "bikini",
			"aliases": [
				"bikini"
			],
			"tags": [
				"beach"
			]
		},
		{
			"emoji": "💼",
			"description": "briefcase",
			"aliases": [
				"briefcase"
			],
			"tags": [
				"business"
			]
		},
		{
			"emoji": "👜",
			"description": "handbag",
			"aliases": [
				"handbag"
			],
			"tags": [
				"bag"
			]
		},
		{
			"emoji": "👝",
			"description": "pouch",
			"aliases": [
				"pouch"
			],
			"tags": [
				"bag"
			]
		},
		{
			"emoji": "👛",
			"description": "purse",
			"aliases": [
				"purse"
			],
			"tags": []
		},
		{
			"emoji": "👓",
			"description": "eyeglasses",
			"aliases": [
				"eyeglasses"
			],
			"tags": [
				"glasses"
			]
		},
		{
			"emoji": "🎀",
			"description": "ribbon",
			"aliases": [
				"ribbon"
			],
			"tags": []
		},
		{
			"emoji": "🌂",
			"description": "closed umbrella",
			"aliases": [
				"closed_umbrella"
			],
			"tags": [
				"weather",
				"rain"
			]
		},
		{
			"emoji": "💄",
			"description": "lipstick",
			"aliases": [
				"lipstick"
			],
			"tags": [
				"makeup"
			]
		},
		{
			"emoji": "💛",
			"description": "yellow heart",
			"aliases": [
				"yellow_heart"
			],
			"tags": []
		},
		{
			"emoji": "💙",
			"description": "blue heart",
			"aliases": [
				"blue_heart"
			],
			"tags": []
		},
		{
			"emoji": "💜",
			"description": "purple heart",
			"aliases": [
				"purple_heart"
			],
			"tags": []
		},
		{
			"emoji": "💚",
			"description": "green heart",
			"aliases": [
				"green_heart"
			],
			"tags": []
		},
		{
			"emoji": "❤️",
			"description": "heavy black heart",
			"aliases": [
				"heart"
			],
			"tags": [
				"love"
			]
		},
		{
			"emoji": "💔",
			"description": "broken heart",
			"aliases": [
				"broken_heart"
			],
			"tags": []
		},
		{
			"emoji": "💗",
			"description": "growing heart",
			"aliases": [
				"heartpulse"
			],
			"tags": []
		},
		{
			"emoji": "💓",
			"description": "beating heart",
			"aliases": [
				"heartbeat"
			],
			"tags": []
		},
		{
			"emoji": "💕",
			"description": "two hearts",
			"aliases": [
				"two_hearts"
			],
			"tags": []
		},
		{
			"emoji": "💖",
			"description": "sparkling heart",
			"aliases": [
				"sparkling_heart"
			],
			"tags": []
		},
		{
			"emoji": "💞",
			"description": "revolving hearts",
			"aliases": [
				"revolving_hearts"
			],
			"tags": []
		},
		{
			"emoji": "💘",
			"description": "heart with arrow",
			"aliases": [
				"cupid"
			],
			"tags": [
				"love",
				"heart"
			]
		},
		{
			"emoji": "💌",
			"description": "love letter",
			"aliases": [
				"love_letter"
			],
			"tags": [
				"email",
				"envelope"
			]
		},
		{
			"emoji": "💋",
			"description": "kiss mark",
			"aliases": [
				"kiss"
			],
			"tags": [
				"lipstick"
			]
		},
		{
			"emoji": "💍",
			"description": "ring",
			"aliases": [
				"ring"
			],
			"tags": [
				"wedding",
				"marriage",
				"engaged"
			]
		},
		{
			"emoji": "💎",
			"description": "gem stone",
			"aliases": [
				"gem"
			],
			"tags": [
				"diamond"
			]
		},
		{
			"emoji": "👤",
			"description": "bust in silhouette",
			"aliases": [
				"bust_in_silhouette"
			],
			"tags": [
				"user"
			]
		},
		{
			"emoji": "👥",
			"description": "busts in silhouette",
			"aliases": [
				"busts_in_silhouette"
			],
			"tags": [
				"users",
				"group",
				"team"
			]
		},
		{
			"emoji": "💬",
			"description": "speech balloon",
			"aliases": [
				"speech_balloon"
			],
			"tags": [
				"comment"
			]
		},
		{
			"emoji": "👣",
			"description": "footprints",
			"aliases": [
				"footprints"
			],
			"tags": [
				"feet",
				"tracks"
			]
		},
		{
			"emoji": "💭",
			"description": "thought balloon",
			"aliases": [
				"thought_balloon"
			],
			"tags": [
				"thinking"
			]
		},
		{
			"emoji": "🐶",
			"description": "dog face",
			"aliases": [
				"dog"
			],
			"tags": [
				"pet"
			]
		},
		{
			"emoji": "🐺",
			"description": "wolf face",
			"aliases": [
				"wolf"
			],
			"tags": []
		},
		{
			"emoji": "🐱",
			"description": "cat face",
			"aliases": [
				"cat"
			],
			"tags": [
				"pet"
			]
		},
		{
			"emoji": "🐭",
			"description": "mouse face",
			"aliases": [
				"mouse"
			],
			"tags": []
		},
		{
			"emoji": "🐹",
			"description": "hamster face",
			"aliases": [
				"hamster"
			],
			"tags": [
				"pet"
			]
		},
		{
			"emoji": "🐰",
			"description": "rabbit face",
			"aliases": [
				"rabbit"
			],
			"tags": [
				"bunny"
			]
		},
		{
			"emoji": "🐸",
			"description": "frog face",
			"aliases": [
				"frog"
			],
			"tags": []
		},
		{
			"emoji": "🐯",
			"description": "tiger face",
			"aliases": [
				"tiger"
			],
			"tags": []
		},
		{
			"emoji": "🐨",
			"description": "koala",
			"aliases": [
				"koala"
			],
			"tags": []
		},
		{
			"emoji": "🐻",
			"description": "bear face",
			"aliases": [
				"bear"
			],
			"tags": []
		},
		{
			"emoji": "🐷",
			"description": "pig face",
			"aliases": [
				"pig"
			],
			"tags": []
		},
		{
			"emoji": "🐽",
			"description": "pig nose",
			"aliases": [
				"pig_nose"
			],
			"tags": []
		},
		{
			"emoji": "🐮",
			"description": "cow face",
			"aliases": [
				"cow"
			],
			"tags": []
		},
		{
			"emoji": "🐗",
			"description": "boar",
			"aliases": [
				"boar"
			],
			"tags": []
		},
		{
			"emoji": "🐵",
			"description": "monkey face",
			"aliases": [
				"monkey_face"
			],
			"tags": []
		},
		{
			"emoji": "🐒",
			"description": "monkey",
			"aliases": [
				"monkey"
			],
			"tags": []
		},
		{
			"emoji": "🐴",
			"description": "horse face",
			"aliases": [
				"horse"
			],
			"tags": []
		},
		{
			"emoji": "🐑",
			"description": "sheep",
			"aliases": [
				"sheep"
			],
			"tags": []
		},
		{
			"emoji": "🐘",
			"description": "elephant",
			"aliases": [
				"elephant"
			],
			"tags": []
		},
		{
			"emoji": "🐼",
			"description": "panda face",
			"aliases": [
				"panda_face"
			],
			"tags": []
		},
		{
			"emoji": "🐧",
			"description": "penguin",
			"aliases": [
				"penguin"
			],
			"tags": []
		},
		{
			"emoji": "🐦",
			"description": "bird",
			"aliases": [
				"bird"
			],
			"tags": []
		},
		{
			"emoji": "🐤",
			"description": "baby chick",
			"aliases": [
				"baby_chick"
			],
			"tags": []
		},
		{
			"emoji": "🐥",
			"description": "front-facing baby chick",
			"aliases": [
				"hatched_chick"
			],
			"tags": []
		},
		{
			"emoji": "🐣",
			"description": "hatching chick",
			"aliases": [
				"hatching_chick"
			],
			"tags": []
		},
		{
			"emoji": "🐔",
			"description": "chicken",
			"aliases": [
				"chicken"
			],
			"tags": []
		},
		{
			"emoji": "🐍",
			"description": "snake",
			"aliases": [
				"snake"
			],
			"tags": []
		},
		{
			"emoji": "🐢",
			"description": "turtle",
			"aliases": [
				"turtle"
			],
			"tags": [
				"slow"
			]
		},
		{
			"emoji": "🐛",
			"description": "bug",
			"aliases": [
				"bug"
			],
			"tags": []
		},
		{
			"emoji": "🐝",
			"description": "honeybee",
			"aliases": [
				"bee",
				"honeybee"
			],
			"tags": []
		},
		{
			"emoji": "🐜",
			"description": "ant",
			"aliases": [
				"ant"
			],
			"tags": []
		},
		{
			"emoji": "🐞",
			"description": "lady beetle",
			"aliases": [
				"beetle"
			],
			"tags": [
				"bug"
			]
		},
		{
			"emoji": "🐌",
			"description": "snail",
			"aliases": [
				"snail"
			],
			"tags": [
				"slow"
			]
		},
		{
			"emoji": "🐙",
			"description": "octopus",
			"aliases": [
				"octopus"
			],
			"tags": []
		},
		{
			"emoji": "🐚",
			"description": "spiral shell",
			"aliases": [
				"shell"
			],
			"tags": [
				"sea",
				"beach"
			]
		},
		{
			"emoji": "🐠",
			"description": "tropical fish",
			"aliases": [
				"tropical_fish"
			],
			"tags": []
		},
		{
			"emoji": "🐟",
			"description": "fish",
			"aliases": [
				"fish"
			],
			"tags": []
		},
		{
			"emoji": "🐬",
			"description": "dolphin",
			"aliases": [
				"dolphin",
				"flipper"
			],
			"tags": []
		},
		{
			"emoji": "🐳",
			"description": "spouting whale",
			"aliases": [
				"whale"
			],
			"tags": [
				"sea"
			]
		},
		{
			"emoji": "🐋",
			"description": "whale",
			"aliases": [
				"whale2"
			],
			"tags": []
		},
		{
			"emoji": "🐄",
			"description": "cow",
			"aliases": [
				"cow2"
			],
			"tags": []
		},
		{
			"emoji": "🐏",
			"description": "ram",
			"aliases": [
				"ram"
			],
			"tags": []
		},
		{
			"emoji": "🐀",
			"description": "rat",
			"aliases": [
				"rat"
			],
			"tags": []
		},
		{
			"emoji": "🐃",
			"description": "water buffalo",
			"aliases": [
				"water_buffalo"
			],
			"tags": []
		},
		{
			"emoji": "🐅",
			"description": "tiger",
			"aliases": [
				"tiger2"
			],
			"tags": []
		},
		{
			"emoji": "🐇",
			"description": "rabbit",
			"aliases": [
				"rabbit2"
			],
			"tags": []
		},
		{
			"emoji": "🐉",
			"description": "dragon",
			"aliases": [
				"dragon"
			],
			"tags": []
		},
		{
			"emoji": "🐎",
			"description": "horse",
			"aliases": [
				"racehorse"
			],
			"tags": [
				"speed"
			]
		},
		{
			"emoji": "🐐",
			"description": "goat",
			"aliases": [
				"goat"
			],
			"tags": []
		},
		{
			"emoji": "🐓",
			"description": "rooster",
			"aliases": [
				"rooster"
			],
			"tags": []
		},
		{
			"emoji": "🐕",
			"description": "dog",
			"aliases": [
				"dog2"
			],
			"tags": []
		},
		{
			"emoji": "🐖",
			"description": "pig",
			"aliases": [
				"pig2"
			],
			"tags": []
		},
		{
			"emoji": "🐁",
			"description": "mouse",
			"aliases": [
				"mouse2"
			],
			"tags": []
		},
		{
			"emoji": "🐂",
			"description": "ox",
			"aliases": [
				"ox"
			],
			"tags": []
		},
		{
			"emoji": "🐲",
			"description": "dragon face",
			"aliases": [
				"dragon_face"
			],
			"tags": []
		},
		{
			"emoji": "🐡",
			"description": "blowfish",
			"aliases": [
				"blowfish"
			],
			"tags": []
		},
		{
			"emoji": "🐊",
			"description": "crocodile",
			"aliases": [
				"crocodile"
			],
			"tags": []
		},
		{
			"emoji": "🐫",
			"description": "bactrian camel",
			"aliases": [
				"camel"
			],
			"tags": []
		},
		{
			"emoji": "🐪",
			"description": "dromedary camel",
			"aliases": [
				"dromedary_camel"
			],
			"tags": [
				"desert"
			]
		},
		{
			"emoji": "🐆",
			"description": "leopard",
			"aliases": [
				"leopard"
			],
			"tags": []
		},
		{
			"emoji": "🐈",
			"description": "cat",
			"aliases": [
				"cat2"
			],
			"tags": []
		},
		{
			"emoji": "🐩",
			"description": "poodle",
			"aliases": [
				"poodle"
			],
			"tags": [
				"dog"
			]
		},
		{
			"emoji": "🐾",
			"description": "paw prints",
			"aliases": [
				"feet",
				"paw_prints"
			],
			"tags": []
		},
		{
			"emoji": "💐",
			"description": "bouquet",
			"aliases": [
				"bouquet"
			],
			"tags": [
				"flowers"
			]
		},
		{
			"emoji": "🌸",
			"description": "cherry blossom",
			"aliases": [
				"cherry_blossom"
			],
			"tags": [
				"flower",
				"spring"
			]
		},
		{
			"emoji": "🌷",
			"description": "tulip",
			"aliases": [
				"tulip"
			],
			"tags": [
				"flower"
			]
		},
		{
			"emoji": "🍀",
			"description": "four leaf clover",
			"aliases": [
				"four_leaf_clover"
			],
			"tags": [
				"luck"
			]
		},
		{
			"emoji": "🌹",
			"description": "rose",
			"aliases": [
				"rose"
			],
			"tags": [
				"flower"
			]
		},
		{
			"emoji": "🌻",
			"description": "sunflower",
			"aliases": [
				"sunflower"
			],
			"tags": []
		},
		{
			"emoji": "🌺",
			"description": "hibiscus",
			"aliases": [
				"hibiscus"
			],
			"tags": []
		},
		{
			"emoji": "🍁",
			"description": "maple leaf",
			"aliases": [
				"maple_leaf"
			],
			"tags": [
				"canada"
			]
		},
		{
			"emoji": "🍃",
			"description": "leaf fluttering in wind",
			"aliases": [
				"leaves"
			],
			"tags": [
				"leaf"
			]
		},
		{
			"emoji": "🍂",
			"description": "fallen leaf",
			"aliases": [
				"fallen_leaf"
			],
			"tags": [
				"autumn"
			]
		},
		{
			"emoji": "🌿",
			"description": "herb",
			"aliases": [
				"herb"
			],
			"tags": []
		},
		{
			"emoji": "🌾",
			"description": "ear of rice",
			"aliases": [
				"ear_of_rice"
			],
			"tags": []
		},
		{
			"emoji": "🍄",
			"description": "mushroom",
			"aliases": [
				"mushroom"
			],
			"tags": []
		},
		{
			"emoji": "🌵",
			"description": "cactus",
			"aliases": [
				"cactus"
			],
			"tags": []
		},
		{
			"emoji": "🌴",
			"description": "palm tree",
			"aliases": [
				"palm_tree"
			],
			"tags": []
		},
		{
			"emoji": "🌲",
			"description": "evergreen tree",
			"aliases": [
				"evergreen_tree"
			],
			"tags": [
				"wood"
			]
		},
		{
			"emoji": "🌳",
			"description": "deciduous tree",
			"aliases": [
				"deciduous_tree"
			],
			"tags": [
				"wood"
			]
		},
		{
			"emoji": "🌰",
			"description": "chestnut",
			"aliases": [
				"chestnut"
			],
			"tags": []
		},
		{
			"emoji": "🌱",
			"description": "seedling",
			"aliases": [
				"seedling"
			],
			"tags": [
				"plant"
			]
		},
		{
			"emoji": "🌼",
			"description": "blossom",
			"aliases": [
				"blossom"
			],
			"tags": []
		},
		{
			"emoji": "🌐",
			"description": "globe with meridians",
			"aliases": [
				"globe_with_meridians"
			],
			"tags": [
				"world",
				"global",
				"international"
			]
		},
		{
			"emoji": "🌞",
			"description": "sun with face",
			"aliases": [
				"sun_with_face"
			],
			"tags": [
				"summer"
			]
		},
		{
			"emoji": "🌝",
			"description": "full moon with face",
			"aliases": [
				"full_moon_with_face"
			],
			"tags": []
		},
		{
			"emoji": "🌚",
			"description": "new moon with face",
			"aliases": [
				"new_moon_with_face"
			],
			"tags": []
		},
		{
			"emoji": "🌑",
			"description": "new moon symbol",
			"aliases": [
				"new_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌒",
			"description": "waxing crescent moon symbol",
			"aliases": [
				"waxing_crescent_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌓",
			"description": "first quarter moon symbol",
			"aliases": [
				"first_quarter_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌔",
			"description": "waxing gibbous moon symbol",
			"aliases": [
				"moon",
				"waxing_gibbous_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌕",
			"description": "full moon symbol",
			"aliases": [
				"full_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌖",
			"description": "waning gibbous moon symbol",
			"aliases": [
				"waning_gibbous_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌗",
			"description": "last quarter moon symbol",
			"aliases": [
				"last_quarter_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌘",
			"description": "waning crescent moon symbol",
			"aliases": [
				"waning_crescent_moon"
			],
			"tags": []
		},
		{
			"emoji": "🌜",
			"description": "last quarter moon with face",
			"aliases": [
				"last_quarter_moon_with_face"
			],
			"tags": []
		},
		{
			"emoji": "🌛",
			"description": "first quarter moon with face",
			"aliases": [
				"first_quarter_moon_with_face"
			],
			"tags": []
		},
		{
			"emoji": "🌙",
			"description": "crescent moon",
			"aliases": [
				"crescent_moon"
			],
			"tags": [
				"night"
			]
		},
		{
			"emoji": "🌍",
			"description": "earth globe europe-africa",
			"aliases": [
				"earth_africa"
			],
			"tags": [
				"globe",
				"world",
				"international"
			]
		},
		{
			"emoji": "🌎",
			"description": "earth globe americas",
			"aliases": [
				"earth_americas"
			],
			"tags": [
				"globe",
				"world",
				"international"
			]
		},
		{
			"emoji": "🌏",
			"description": "earth globe asia-australia",
			"aliases": [
				"earth_asia"
			],
			"tags": [
				"globe",
				"world",
				"international"
			]
		},
		{
			"emoji": "🌋",
			"description": "volcano",
			"aliases": [
				"volcano"
			],
			"tags": []
		},
		{
			"emoji": "🌌",
			"description": "milky way",
			"aliases": [
				"milky_way"
			],
			"tags": []
		},
		{
			"emoji": "🌠",
			"description": "shooting star",
			"aliases": [
				"stars"
			],
			"tags": []
		},
		{
			"emoji": "⭐",
			"description": "white medium star",
			"aliases": [
				"star"
			],
			"tags": []
		},
		{
			"emoji": "☀️",
			"description": "black sun with rays",
			"aliases": [
				"sunny"
			],
			"tags": [
				"weather"
			]
		},
		{
			"emoji": "⛅",
			"description": "sun behind cloud",
			"aliases": [
				"partly_sunny"
			],
			"tags": [
				"weather",
				"cloud"
			]
		},
		{
			"emoji": "☁️",
			"description": "cloud",
			"aliases": [
				"cloud"
			],
			"tags": []
		},
		{
			"emoji": "⚡",
			"description": "high voltage sign",
			"aliases": [
				"zap"
			],
			"tags": [
				"lightning",
				"thunder"
			]
		},
		{
			"emoji": "☔",
			"description": "umbrella with rain drops",
			"aliases": [
				"umbrella"
			],
			"tags": [
				"rain",
				"weather"
			]
		},
		{
			"emoji": "❄️",
			"description": "snowflake",
			"aliases": [
				"snowflake"
			],
			"tags": [
				"winter",
				"cold",
				"weather"
			]
		},
		{
			"emoji": "⛄",
			"description": "snowman without snow",
			"aliases": [
				"snowman"
			],
			"tags": [
				"winter",
				"christmas"
			]
		},
		{
			"emoji": "🌀",
			"description": "cyclone",
			"aliases": [
				"cyclone"
			],
			"tags": [
				"swirl"
			]
		},
		{
			"emoji": "🌁",
			"description": "foggy",
			"aliases": [
				"foggy"
			],
			"tags": [
				"karl"
			]
		},
		{
			"emoji": "🌈",
			"description": "rainbow",
			"aliases": [
				"rainbow"
			],
			"tags": [
				"pride"
			]
		},
		{
			"emoji": "🌊",
			"description": "water wave",
			"aliases": [
				"ocean"
			],
			"tags": [
				"sea"
			]
		},
		{
			"emoji": "🎍",
			"description": "pine decoration",
			"aliases": [
				"bamboo"
			],
			"tags": []
		},
		{
			"emoji": "💝",
			"description": "heart with ribbon",
			"aliases": [
				"gift_heart"
			],
			"tags": [
				"chocolates"
			]
		},
		{
			"emoji": "🎎",
			"description": "japanese dolls",
			"aliases": [
				"dolls"
			],
			"tags": []
		},
		{
			"emoji": "🎒",
			"description": "school satchel",
			"aliases": [
				"school_satchel"
			],
			"tags": []
		},
		{
			"emoji": "🎓",
			"description": "graduation cap",
			"aliases": [
				"mortar_board"
			],
			"tags": [
				"education",
				"college",
				"university",
				"graduation"
			]
		},
		{
			"emoji": "🎏",
			"description": "carp streamer",
			"aliases": [
				"flags"
			],
			"tags": []
		},
		{
			"emoji": "🎆",
			"description": "fireworks",
			"aliases": [
				"fireworks"
			],
			"tags": [
				"festival",
				"celebration"
			]
		},
		{
			"emoji": "🎇",
			"description": "firework sparkler",
			"aliases": [
				"sparkler"
			],
			"tags": []
		},
		{
			"emoji": "🎐",
			"description": "wind chime",
			"aliases": [
				"wind_chime"
			],
			"tags": []
		},
		{
			"emoji": "🎑",
			"description": "moon viewing ceremony",
			"aliases": [
				"rice_scene"
			],
			"tags": []
		},
		{
			"emoji": "🎃",
			"description": "jack-o-lantern",
			"aliases": [
				"jack_o_lantern"
			],
			"tags": [
				"halloween"
			]
		},
		{
			"emoji": "👻",
			"description": "ghost",
			"aliases": [
				"ghost"
			],
			"tags": [
				"halloween"
			]
		},
		{
			"emoji": "🎅",
			"description": "father christmas",
			"aliases": [
				"santa"
			],
			"tags": [
				"christmas"
			]
		},
		{
			"emoji": "🎄",
			"description": "christmas tree",
			"aliases": [
				"christmas_tree"
			],
			"tags": []
		},
		{
			"emoji": "🎁",
			"description": "wrapped present",
			"aliases": [
				"gift"
			],
			"tags": [
				"present",
				"birthday",
				"christmas"
			]
		},
		{
			"emoji": "🎋",
			"description": "tanabata tree",
			"aliases": [
				"tanabata_tree"
			],
			"tags": []
		},
		{
			"emoji": "🎉",
			"description": "party popper",
			"aliases": [
				"tada"
			],
			"tags": [
				"party"
			]
		},
		{
			"emoji": "🎊",
			"description": "confetti ball",
			"aliases": [
				"confetti_ball"
			],
			"tags": []
		},
		{
			"emoji": "🎈",
			"description": "balloon",
			"aliases": [
				"balloon"
			],
			"tags": [
				"party",
				"birthday"
			]
		},
		{
			"emoji": "🎌",
			"description": "crossed flags",
			"aliases": [
				"crossed_flags"
			],
			"tags": []
		},
		{
			"emoji": "🔮",
			"description": "crystal ball",
			"aliases": [
				"crystal_ball"
			],
			"tags": [
				"fortune"
			]
		},
		{
			"emoji": "🎥",
			"description": "movie camera",
			"aliases": [
				"movie_camera"
			],
			"tags": [
				"film",
				"video"
			]
		},
		{
			"emoji": "📷",
			"description": "camera",
			"aliases": [
				"camera"
			],
			"tags": [
				"photo"
			]
		},
		{
			"emoji": "📹",
			"description": "video camera",
			"aliases": [
				"video_camera"
			],
			"tags": []
		},
		{
			"emoji": "📼",
			"description": "videocassette",
			"aliases": [
				"vhs"
			],
			"tags": []
		},
		{
			"emoji": "💿",
			"description": "optical disc",
			"aliases": [
				"cd"
			],
			"tags": []
		},
		{
			"emoji": "📀",
			"description": "dvd",
			"aliases": [
				"dvd"
			],
			"tags": []
		},
		{
			"emoji": "💽",
			"description": "minidisc",
			"aliases": [
				"minidisc"
			],
			"tags": []
		},
		{
			"emoji": "💾",
			"description": "floppy disk",
			"aliases": [
				"floppy_disk"
			],
			"tags": [
				"save"
			]
		},
		{
			"emoji": "💻",
			"description": "personal computer",
			"aliases": [
				"computer"
			],
			"tags": [
				"desktop",
				"screen"
			]
		},
		{
			"emoji": "📱",
			"description": "mobile phone",
			"aliases": [
				"iphone"
			],
			"tags": [
				"smartphone",
				"mobile"
			]
		},
		{
			"emoji": "☎️",
			"description": "black telephone",
			"aliases": [
				"phone",
				"telephone"
			],
			"tags": []
		},
		{
			"emoji": "📞",
			"description": "telephone receiver",
			"aliases": [
				"telephone_receiver"
			],
			"tags": [
				"phone",
				"call"
			]
		},
		{
			"emoji": "📟",
			"description": "pager",
			"aliases": [
				"pager"
			],
			"tags": []
		},
		{
			"emoji": "📠",
			"description": "fax machine",
			"aliases": [
				"fax"
			],
			"tags": []
		},
		{
			"emoji": "📡",
			"description": "satellite antenna",
			"aliases": [
				"satellite"
			],
			"tags": [
				"signal"
			]
		},
		{
			"emoji": "📺",
			"description": "television",
			"aliases": [
				"tv"
			],
			"tags": []
		},
		{
			"emoji": "📻",
			"description": "radio",
			"aliases": [
				"radio"
			],
			"tags": [
				"podcast"
			]
		},
		{
			"emoji": "🔊",
			"description": "speaker with three sound waves",
			"aliases": [
				"loud_sound"
			],
			"tags": [
				"volume"
			]
		},
		{
			"emoji": "🔉",
			"description": "speaker with one sound wave",
			"aliases": [
				"sound"
			],
			"tags": [
				"volume"
			]
		},
		{
			"emoji": "🔈",
			"description": "speaker",
			"aliases": [
				"speaker"
			],
			"tags": []
		},
		{
			"emoji": "🔇",
			"description": "speaker with cancellation stroke",
			"aliases": [
				"mute"
			],
			"tags": [
				"sound",
				"volume"
			]
		},
		{
			"emoji": "🔔",
			"description": "bell",
			"aliases": [
				"bell"
			],
			"tags": [
				"sound",
				"notification"
			]
		},
		{
			"emoji": "🔕",
			"description": "bell with cancellation stroke",
			"aliases": [
				"no_bell"
			],
			"tags": [
				"volume",
				"off"
			]
		},
		{
			"emoji": "📢",
			"description": "public address loudspeaker",
			"aliases": [
				"loudspeaker"
			],
			"tags": [
				"announcement"
			]
		},
		{
			"emoji": "📣",
			"description": "cheering megaphone",
			"aliases": [
				"mega"
			],
			"tags": []
		},
		{
			"emoji": "⏳",
			"description": "hourglass with flowing sand",
			"aliases": [
				"hourglass_flowing_sand"
			],
			"tags": [
				"time"
			]
		},
		{
			"emoji": "⌛",
			"description": "hourglass",
			"aliases": [
				"hourglass"
			],
			"tags": [
				"time"
			]
		},
		{
			"emoji": "⏰",
			"description": "alarm clock",
			"aliases": [
				"alarm_clock"
			],
			"tags": [
				"morning"
			]
		},
		{
			"emoji": "⌚",
			"description": "watch",
			"aliases": [
				"watch"
			],
			"tags": [
				"time"
			]
		},
		{
			"emoji": "🔓",
			"description": "open lock",
			"aliases": [
				"unlock"
			],
			"tags": [
				"security"
			]
		},
		{
			"emoji": "🔒",
			"description": "lock",
			"aliases": [
				"lock"
			],
			"tags": [
				"security",
				"private"
			]
		},
		{
			"emoji": "🔏",
			"description": "lock with ink pen",
			"aliases": [
				"lock_with_ink_pen"
			],
			"tags": []
		},
		{
			"emoji": "🔐",
			"description": "closed lock with key",
			"aliases": [
				"closed_lock_with_key"
			],
			"tags": [
				"security"
			]
		},
		{
			"emoji": "🔑",
			"description": "key",
			"aliases": [
				"key"
			],
			"tags": [
				"lock",
				"password"
			]
		},
		{
			"emoji": "🔎",
			"description": "right-pointing magnifying glass",
			"aliases": [
				"mag_right"
			],
			"tags": []
		},
		{
			"emoji": "💡",
			"description": "electric light bulb",
			"aliases": [
				"bulb"
			],
			"tags": [
				"idea",
				"light"
			]
		},
		{
			"emoji": "🔦",
			"description": "electric torch",
			"aliases": [
				"flashlight"
			],
			"tags": []
		},
		{
			"emoji": "🔆",
			"description": "high brightness symbol",
			"aliases": [
				"high_brightness"
			],
			"tags": []
		},
		{
			"emoji": "🔅",
			"description": "low brightness symbol",
			"aliases": [
				"low_brightness"
			],
			"tags": []
		},
		{
			"emoji": "🔌",
			"description": "electric plug",
			"aliases": [
				"electric_plug"
			],
			"tags": []
		},
		{
			"emoji": "🔋",
			"description": "battery",
			"aliases": [
				"battery"
			],
			"tags": [
				"power"
			]
		},
		{
			"emoji": "🔍",
			"description": "left-pointing magnifying glass",
			"aliases": [
				"mag"
			],
			"tags": [
				"search",
				"zoom"
			]
		},
		{
			"emoji": "🛁",
			"description": "bathtub",
			"aliases": [
				"bathtub"
			],
			"tags": []
		},
		{
			"emoji": "🛀",
			"description": "bath",
			"aliases": [
				"bath"
			],
			"tags": [
				"shower"
			]
		},
		{
			"emoji": "🚿",
			"description": "shower",
			"aliases": [
				"shower"
			],
			"tags": [
				"bath"
			]
		},
		{
			"emoji": "🚽",
			"description": "toilet",
			"aliases": [
				"toilet"
			],
			"tags": [
				"wc"
			]
		},
		{
			"emoji": "🔧",
			"description": "wrench",
			"aliases": [
				"wrench"
			],
			"tags": [
				"tool"
			]
		},
		{
			"emoji": "🔩",
			"description": "nut and bolt",
			"aliases": [
				"nut_and_bolt"
			],
			"tags": []
		},
		{
			"emoji": "🔨",
			"description": "hammer",
			"aliases": [
				"hammer"
			],
			"tags": [
				"tool"
			]
		},
		{
			"emoji": "🚪",
			"description": "door",
			"aliases": [
				"door"
			],
			"tags": []
		},
		{
			"emoji": "🚬",
			"description": "smoking symbol",
			"aliases": [
				"smoking"
			],
			"tags": [
				"cigarette"
			]
		},
		{
			"emoji": "💣",
			"description": "bomb",
			"aliases": [
				"bomb"
			],
			"tags": [
				"boom"
			]
		},
		{
			"emoji": "🔫",
			"description": "pistol",
			"aliases": [
				"gun"
			],
			"tags": [
				"shoot",
				"weapon"
			]
		},
		{
			"emoji": "🔪",
			"description": "hocho",
			"aliases": [
				"hocho",
				"knife"
			],
			"tags": [
				"cut",
				"chop"
			]
		},
		{
			"emoji": "💊",
			"description": "pill",
			"aliases": [
				"pill"
			],
			"tags": [
				"health",
				"medicine"
			]
		},
		{
			"emoji": "💉",
			"description": "syringe",
			"aliases": [
				"syringe"
			],
			"tags": [
				"health",
				"hospital",
				"needle"
			]
		},
		{
			"emoji": "💰",
			"description": "money bag",
			"aliases": [
				"moneybag"
			],
			"tags": [
				"dollar",
				"cream"
			]
		},
		{
			"emoji": "💴",
			"description": "banknote with yen sign",
			"aliases": [
				"yen"
			],
			"tags": []
		},
		{
			"emoji": "💵",
			"description": "banknote with dollar sign",
			"aliases": [
				"dollar"
			],
			"tags": [
				"money"
			]
		},
		{
			"emoji": "💷",
			"description": "banknote with pound sign",
			"aliases": [
				"pound"
			],
			"tags": []
		},
		{
			"emoji": "💶",
			"description": "banknote with euro sign",
			"aliases": [
				"euro"
			],
			"tags": []
		},
		{
			"emoji": "💳",
			"description": "credit card",
			"aliases": [
				"credit_card"
			],
			"tags": [
				"subscription"
			]
		},
		{
			"emoji": "💸",
			"description": "money with wings",
			"aliases": [
				"money_with_wings"
			],
			"tags": [
				"dollar"
			]
		},
		{
			"emoji": "📲",
			"description": "mobile phone with rightwards arrow at left",
			"aliases": [
				"calling"
			],
			"tags": [
				"call",
				"incoming"
			]
		},
		{
			"emoji": "📧",
			"description": "e-mail symbol",
			"aliases": [
				"e-mail"
			],
			"tags": []
		},
		{
			"emoji": "📥",
			"description": "inbox tray",
			"aliases": [
				"inbox_tray"
			],
			"tags": []
		},
		{
			"emoji": "📤",
			"description": "outbox tray",
			"aliases": [
				"outbox_tray"
			],
			"tags": []
		},
		{
			"emoji": "✉️",
			"description": "envelope",
			"aliases": [
				"email",
				"envelope"
			],
			"tags": [
				"letter"
			]
		},
		{
			"emoji": "📩",
			"description": "envelope with downwards arrow above",
			"aliases": [
				"envelope_with_arrow"
			],
			"tags": []
		},
		{
			"emoji": "📨",
			"description": "incoming envelope",
			"aliases": [
				"incoming_envelope"
			],
			"tags": []
		},
		{
			"emoji": "📯",
			"description": "postal horn",
			"aliases": [
				"postal_horn"
			],
			"tags": []
		},
		{
			"emoji": "📫",
			"description": "closed mailbox with raised flag",
			"aliases": [
				"mailbox"
			],
			"tags": []
		},
		{
			"emoji": "📪",
			"description": "closed mailbox with lowered flag",
			"aliases": [
				"mailbox_closed"
			],
			"tags": []
		},
		{
			"emoji": "📬",
			"description": "open mailbox with raised flag",
			"aliases": [
				"mailbox_with_mail"
			],
			"tags": []
		},
		{
			"emoji": "📭",
			"description": "open mailbox with lowered flag",
			"aliases": [
				"mailbox_with_no_mail"
			],
			"tags": []
		},
		{
			"emoji": "📮",
			"description": "postbox",
			"aliases": [
				"postbox"
			],
			"tags": []
		},
		{
			"emoji": "📦",
			"description": "package",
			"aliases": [
				"package"
			],
			"tags": [
				"shipping"
			]
		},
		{
			"emoji": "📝",
			"description": "memo",
			"aliases": [
				"memo",
				"pencil"
			],
			"tags": [
				"document",
				"note"
			]
		},
		{
			"emoji": "📄",
			"description": "page facing up",
			"aliases": [
				"page_facing_up"
			],
			"tags": [
				"document"
			]
		},
		{
			"emoji": "📃",
			"description": "page with curl",
			"aliases": [
				"page_with_curl"
			],
			"tags": []
		},
		{
			"emoji": "📑",
			"description": "bookmark tabs",
			"aliases": [
				"bookmark_tabs"
			],
			"tags": []
		},
		{
			"emoji": "📊",
			"description": "bar chart",
			"aliases": [
				"bar_chart"
			],
			"tags": [
				"stats",
				"metrics"
			]
		},
		{
			"emoji": "📈",
			"description": "chart with upwards trend",
			"aliases": [
				"chart_with_upwards_trend"
			],
			"tags": [
				"graph",
				"metrics"
			]
		},
		{
			"emoji": "📉",
			"description": "chart with downwards trend",
			"aliases": [
				"chart_with_downwards_trend"
			],
			"tags": [
				"graph",
				"metrics"
			]
		},
		{
			"emoji": "📜",
			"description": "scroll",
			"aliases": [
				"scroll"
			],
			"tags": [
				"document"
			]
		},
		{
			"emoji": "📋",
			"description": "clipboard",
			"aliases": [
				"clipboard"
			],
			"tags": []
		},
		{
			"emoji": "📅",
			"description": "calendar",
			"aliases": [
				"date"
			],
			"tags": [
				"calendar",
				"schedule"
			]
		},
		{
			"emoji": "📆",
			"description": "tear-off calendar",
			"aliases": [
				"calendar"
			],
			"tags": [
				"schedule"
			]
		},
		{
			"emoji": "📇",
			"description": "card index",
			"aliases": [
				"card_index"
			],
			"tags": []
		},
		{
			"emoji": "📁",
			"description": "file folder",
			"aliases": [
				"file_folder"
			],
			"tags": [
				"directory"
			]
		},
		{
			"emoji": "📂",
			"description": "open file folder",
			"aliases": [
				"open_file_folder"
			],
			"tags": []
		},
		{
			"emoji": "✂️",
			"description": "black scissors",
			"aliases": [
				"scissors"
			],
			"tags": [
				"cut"
			]
		},
		{
			"emoji": "📌",
			"description": "pushpin",
			"aliases": [
				"pushpin"
			],
			"tags": [
				"location"
			]
		},
		{
			"emoji": "📎",
			"description": "paperclip",
			"aliases": [
				"paperclip"
			],
			"tags": []
		},
		{
			"emoji": "✒️",
			"description": "black nib",
			"aliases": [
				"black_nib"
			],
			"tags": []
		},
		{
			"emoji": "✏️",
			"description": "pencil",
			"aliases": [
				"pencil2"
			],
			"tags": []
		},
		{
			"emoji": "📏",
			"description": "straight ruler",
			"aliases": [
				"straight_ruler"
			],
			"tags": []
		},
		{
			"emoji": "📐",
			"description": "triangular ruler",
			"aliases": [
				"triangular_ruler"
			],
			"tags": []
		},
		{
			"emoji": "📕",
			"description": "closed book",
			"aliases": [
				"closed_book"
			],
			"tags": []
		},
		{
			"emoji": "📗",
			"description": "green book",
			"aliases": [
				"green_book"
			],
			"tags": []
		},
		{
			"emoji": "📘",
			"description": "blue book",
			"aliases": [
				"blue_book"
			],
			"tags": []
		},
		{
			"emoji": "📙",
			"description": "orange book",
			"aliases": [
				"orange_book"
			],
			"tags": []
		},
		{
			"emoji": "📓",
			"description": "notebook",
			"aliases": [
				"notebook"
			],
			"tags": []
		},
		{
			"emoji": "📔",
			"description": "notebook with decorative cover",
			"aliases": [
				"notebook_with_decorative_cover"
			],
			"tags": []
		},
		{
			"emoji": "📒",
			"description": "ledger",
			"aliases": [
				"ledger"
			],
			"tags": []
		},
		{
			"emoji": "📚",
			"description": "books",
			"aliases": [
				"books"
			],
			"tags": [
				"library"
			]
		},
		{
			"emoji": "📖",
			"description": "open book",
			"aliases": [
				"book",
				"open_book"
			],
			"tags": []
		},
		{
			"emoji": "🔖",
			"description": "bookmark",
			"aliases": [
				"bookmark"
			],
			"tags": []
		},
		{
			"emoji": "📛",
			"description": "name badge",
			"aliases": [
				"name_badge"
			],
			"tags": []
		},
		{
			"emoji": "🔬",
			"description": "microscope",
			"aliases": [
				"microscope"
			],
			"tags": [
				"science",
				"laboratory",
				"investigate"
			]
		},
		{
			"emoji": "🔭",
			"description": "telescope",
			"aliases": [
				"telescope"
			],
			"tags": []
		},
		{
			"emoji": "📰",
			"description": "newspaper",
			"aliases": [
				"newspaper"
			],
			"tags": [
				"press"
			]
		},
		{
			"emoji": "🎨",
			"description": "artist palette",
			"aliases": [
				"art"
			],
			"tags": [
				"design",
				"paint"
			]
		},
		{
			"emoji": "🎬",
			"description": "clapper board",
			"aliases": [
				"clapper"
			],
			"tags": [
				"film"
			]
		},
		{
			"emoji": "🎤",
			"description": "microphone",
			"aliases": [
				"microphone"
			],
			"tags": [
				"sing"
			]
		},
		{
			"emoji": "🎧",
			"description": "headphone",
			"aliases": [
				"headphones"
			],
			"tags": [
				"music",
				"earphones"
			]
		},
		{
			"emoji": "🎼",
			"description": "musical score",
			"aliases": [
				"musical_score"
			],
			"tags": []
		},
		{
			"emoji": "🎵",
			"description": "musical note",
			"aliases": [
				"musical_note"
			],
			"tags": []
		},
		{
			"emoji": "🎶",
			"description": "multiple musical notes",
			"aliases": [
				"notes"
			],
			"tags": [
				"music"
			]
		},
		{
			"emoji": "🎹",
			"description": "musical keyboard",
			"aliases": [
				"musical_keyboard"
			],
			"tags": [
				"piano"
			]
		},
		{
			"emoji": "🎻",
			"description": "violin",
			"aliases": [
				"violin"
			],
			"tags": []
		},
		{
			"emoji": "🎺",
			"description": "trumpet",
			"aliases": [
				"trumpet"
			],
			"tags": []
		},
		{
			"emoji": "🎷",
			"description": "saxophone",
			"aliases": [
				"saxophone"
			],
			"tags": []
		},
		{
			"emoji": "🎸",
			"description": "guitar",
			"aliases": [
				"guitar"
			],
			"tags": [
				"rock"
			]
		},
		{
			"emoji": "👾",
			"description": "alien monster",
			"aliases": [
				"space_invader"
			],
			"tags": [
				"game",
				"retro"
			]
		},
		{
			"emoji": "🎮",
			"description": "video game",
			"aliases": [
				"video_game"
			],
			"tags": [
				"play",
				"controller",
				"console"
			]
		},
		{
			"emoji": "🃏",
			"description": "playing card black joker",
			"aliases": [
				"black_joker"
			],
			"tags": []
		},
		{
			"emoji": "🎴",
			"description": "flower playing cards",
			"aliases": [
				"flower_playing_cards"
			],
			"tags": []
		},
		{
			"emoji": "🀄",
			"description": "mahjong tile red dragon",
			"aliases": [
				"mahjong"
			],
			"tags": []
		},
		{
			"emoji": "🎲",
			"description": "game die",
			"aliases": [
				"game_die"
			],
			"tags": [
				"dice",
				"gambling"
			]
		},
		{
			"emoji": "🎯",
			"description": "direct hit",
			"aliases": [
				"dart"
			],
			"tags": [
				"target"
			]
		},
		{
			"emoji": "🏈",
			"description": "american football",
			"aliases": [
				"football"
			],
			"tags": [
				"sports"
			]
		},
		{
			"emoji": "🏀",
			"description": "basketball and hoop",
			"aliases": [
				"basketball"
			],
			"tags": [
				"sports"
			]
		},
		{
			"emoji": "⚽",
			"description": "soccer ball",
			"aliases": [
				"soccer"
			],
			"tags": [
				"sports"
			]
		},
		{
			"emoji": "⚾️",
			"description": "baseball",
			"aliases": [
				"baseball"
			],
			"tags": [
				"sports"
			]
		},
		{
			"emoji": "🎾",
			"description": "tennis racquet and ball",
			"aliases": [
				"tennis"
			],
			"tags": [
				"sports"
			]
		},
		{
			"emoji": "🎱",
			"description": "billiards",
			"aliases": [
				"8ball"
			],
			"tags": [
				"pool",
				"billiards"
			]
		},
		{
			"emoji": "🏉",
			"description": "rugby football",
			"aliases": [
				"rugby_football"
			],
			"tags": []
		},
		{
			"emoji": "🎳",
			"description": "bowling",
			"aliases": [
				"bowling"
			],
			"tags": []
		},
		{
			"emoji": "⛳",
			"description": "flag in hole",
			"aliases": [
				"golf"
			],
			"tags": []
		},
		{
			"emoji": "🚵",
			"description": "mountain bicyclist",
			"aliases": [
				"mountain_bicyclist"
			],
			"tags": []
		},
		{
			"emoji": "🚴",
			"description": "bicyclist",
			"aliases": [
				"bicyclist"
			],
			"tags": []
		},
		{
			"emoji": "🏁",
			"description": "chequered flag",
			"aliases": [
				"checkered_flag"
			],
			"tags": [
				"milestone",
				"finish"
			]
		},
		{
			"emoji": "🏇",
			"description": "horse racing",
			"aliases": [
				"horse_racing"
			],
			"tags": []
		},
		{
			"emoji": "🏆",
			"description": "trophy",
			"aliases": [
				"trophy"
			],
			"tags": [
				"award",
				"contest",
				"winner"
			]
		},
		{
			"emoji": "🎿",
			"description": "ski and ski boot",
			"aliases": [
				"ski"
			],
			"tags": []
		},
		{
			"emoji": "🏂",
			"description": "snowboarder",
			"aliases": [
				"snowboarder"
			],
			"tags": []
		},
		{
			"emoji": "🏊",
			"description": "swimmer",
			"aliases": [
				"swimmer"
			],
			"tags": []
		},
		{
			"emoji": "🏄",
			"description": "surfer",
			"aliases": [
				"surfer"
			],
			"tags": []
		},
		{
			"emoji": "🎣",
			"description": "fishing pole and fish",
			"aliases": [
				"fishing_pole_and_fish"
			],
			"tags": []
		},
		{
			"emoji": "☕",
			"description": "hot beverage",
			"aliases": [
				"coffee"
			],
			"tags": [
				"cafe",
				"espresso"
			]
		},
		{
			"emoji": "🍵",
			"description": "teacup without handle",
			"aliases": [
				"tea"
			],
			"tags": [
				"green",
				"breakfast"
			]
		},
		{
			"emoji": "🍶",
			"description": "sake bottle and cup",
			"aliases": [
				"sake"
			],
			"tags": []
		},
		{
			"emoji": "🍼",
			"description": "baby bottle",
			"aliases": [
				"baby_bottle"
			],
			"tags": [
				"milk"
			]
		},
		{
			"emoji": "🍺",
			"description": "beer mug",
			"aliases": [
				"beer"
			],
			"tags": [
				"drink"
			]
		},
		{
			"emoji": "🍻",
			"description": "clinking beer mugs",
			"aliases": [
				"beers"
			],
			"tags": [
				"drinks"
			]
		},
		{
			"emoji": "🍸",
			"description": "cocktail glass",
			"aliases": [
				"cocktail"
			],
			"tags": [
				"drink"
			]
		},
		{
			"emoji": "🍹",
			"description": "tropical drink",
			"aliases": [
				"tropical_drink"
			],
			"tags": [
				"summer",
				"vacation"
			]
		},
		{
			"emoji": "🍷",
			"description": "wine glass",
			"aliases": [
				"wine_glass"
			],
			"tags": []
		},
		{
			"emoji": "🍴",
			"description": "fork and knife",
			"aliases": [
				"fork_and_knife"
			],
			"tags": [
				"cutlery"
			]
		},
		{
			"emoji": "🍕",
			"description": "slice of pizza",
			"aliases": [
				"pizza"
			],
			"tags": []
		},
		{
			"emoji": "🍔",
			"description": "hamburger",
			"aliases": [
				"hamburger"
			],
			"tags": [
				"burger"
			]
		},
		{
			"emoji": "🍟",
			"description": "french fries",
			"aliases": [
				"fries"
			],
			"tags": []
		},
		{
			"emoji": "🍗",
			"description": "poultry leg",
			"aliases": [
				"poultry_leg"
			],
			"tags": [
				"meat",
				"chicken"
			]
		},
		{
			"emoji": "🍖",
			"description": "meat on bone",
			"aliases": [
				"meat_on_bone"
			],
			"tags": []
		},
		{
			"emoji": "🍝",
			"description": "spaghetti",
			"aliases": [
				"spaghetti"
			],
			"tags": [
				"pasta"
			]
		},
		{
			"emoji": "🍛",
			"description": "curry and rice",
			"aliases": [
				"curry"
			],
			"tags": []
		},
		{
			"emoji": "🍤",
			"description": "fried shrimp",
			"aliases": [
				"fried_shrimp"
			],
			"tags": [
				"tempura"
			]
		},
		{
			"emoji": "🍱",
			"description": "bento box",
			"aliases": [
				"bento"
			],
			"tags": []
		},
		{
			"emoji": "🍣",
			"description": "sushi",
			"aliases": [
				"sushi"
			],
			"tags": []
		},
		{
			"emoji": "🍥",
			"description": "fish cake with swirl design",
			"aliases": [
				"fish_cake"
			],
			"tags": []
		},
		{
			"emoji": "🍙",
			"description": "rice ball",
			"aliases": [
				"rice_ball"
			],
			"tags": []
		},
		{
			"emoji": "🍘",
			"description": "rice cracker",
			"aliases": [
				"rice_cracker"
			],
			"tags": []
		},
		{
			"emoji": "🍚",
			"description": "cooked rice",
			"aliases": [
				"rice"
			],
			"tags": []
		},
		{
			"emoji": "🍜",
			"description": "steaming bowl",
			"aliases": [
				"ramen"
			],
			"tags": [
				"noodle"
			]
		},
		{
			"emoji": "🍲",
			"description": "pot of food",
			"aliases": [
				"stew"
			],
			"tags": []
		},
		{
			"emoji": "🍢",
			"description": "oden",
			"aliases": [
				"oden"
			],
			"tags": []
		},
		{
			"emoji": "🍡",
			"description": "dango",
			"aliases": [
				"dango"
			],
			"tags": []
		},
		{
			"emoji": "🍳",
			"description": "cooking",
			"aliases": [
				"egg"
			],
			"tags": [
				"breakfast"
			]
		},
		{
			"emoji": "🍞",
			"description": "bread",
			"aliases": [
				"bread"
			],
			"tags": [
				"toast"
			]
		},
		{
			"emoji": "🍩",
			"description": "doughnut",
			"aliases": [
				"doughnut"
			],
			"tags": []
		},
		{
			"emoji": "🍮",
			"description": "custard",
			"aliases": [
				"custard"
			],
			"tags": []
		},
		{
			"emoji": "🍦",
			"description": "soft ice cream",
			"aliases": [
				"icecream"
			],
			"tags": []
		},
		{
			"emoji": "🍨",
			"description": "ice cream",
			"aliases": [
				"ice_cream"
			],
			"tags": []
		},
		{
			"emoji": "🍧",
			"description": "shaved ice",
			"aliases": [
				"shaved_ice"
			],
			"tags": []
		},
		{
			"emoji": "🎂",
			"description": "birthday cake",
			"aliases": [
				"birthday"
			],
			"tags": [
				"party"
			]
		},
		{
			"emoji": "🍰",
			"description": "shortcake",
			"aliases": [
				"cake"
			],
			"tags": [
				"dessert"
			]
		},
		{
			"emoji": "🍪",
			"description": "cookie",
			"aliases": [
				"cookie"
			],
			"tags": []
		},
		{
			"emoji": "🍫",
			"description": "chocolate bar",
			"aliases": [
				"chocolate_bar"
			],
			"tags": []
		},
		{
			"emoji": "🍬",
			"description": "candy",
			"aliases": [
				"candy"
			],
			"tags": [
				"sweet"
			]
		},
		{
			"emoji": "🍭",
			"description": "lollipop",
			"aliases": [
				"lollipop"
			],
			"tags": []
		},
		{
			"emoji": "🍯",
			"description": "honey pot",
			"aliases": [
				"honey_pot"
			],
			"tags": []
		},
		{
			"emoji": "🍎",
			"description": "red apple",
			"aliases": [
				"apple"
			],
			"tags": []
		},
		{
			"emoji": "🍏",
			"description": "green apple",
			"aliases": [
				"green_apple"
			],
			"tags": [
				"fruit"
			]
		},
		{
			"emoji": "🍊",
			"description": "tangerine",
			"aliases": [
				"tangerine",
				"orange",
				"mandarin"
			],
			"tags": []
		},
		{
			"emoji": "🍋",
			"description": "lemon",
			"aliases": [
				"lemon"
			],
			"tags": []
		},
		{
			"emoji": "🍒",
			"description": "cherries",
			"aliases": [
				"cherries"
			],
			"tags": [
				"fruit"
			]
		},
		{
			"emoji": "🍇",
			"description": "grapes",
			"aliases": [
				"grapes"
			],
			"tags": []
		},
		{
			"emoji": "🍉",
			"description": "watermelon",
			"aliases": [
				"watermelon"
			],
			"tags": []
		},
		{
			"emoji": "🍓",
			"description": "strawberry",
			"aliases": [
				"strawberry"
			],
			"tags": [
				"fruit"
			]
		},
		{
			"emoji": "🍑",
			"description": "peach",
			"aliases": [
				"peach"
			],
			"tags": []
		},
		{
			"emoji": "🍈",
			"description": "melon",
			"aliases": [
				"melon"
			],
			"tags": []
		},
		{
			"emoji": "🍌",
			"description": "banana",
			"aliases": [
				"banana"
			],
			"tags": [
				"fruit"
			]
		},
		{
			"emoji": "🍐",
			"description": "pear",
			"aliases": [
				"pear"
			],
			"tags": []
		},
		{
			"emoji": "🍍",
			"description": "pineapple",
			"aliases": [
				"pineapple"
			],
			"tags": []
		},
		{
			"emoji": "🍠",
			"description": "roasted sweet potato",
			"aliases": [
				"sweet_potato"
			],
			"tags": []
		},
		{
			"emoji": "🍆",
			"description": "aubergine",
			"aliases": [
				"eggplant"
			],
			"tags": [
				"aubergine"
			]
		},
		{
			"emoji": "🍅",
			"description": "tomato",
			"aliases": [
				"tomato"
			],
			"tags": []
		},
		{
			"emoji": "🌽",
			"description": "ear of maize",
			"aliases": [
				"corn"
			],
			"tags": []
		},
		{
			"emoji": "🏠",
			"description": "house building",
			"aliases": [
				"house"
			],
			"tags": []
		},
		{
			"emoji": "🏡",
			"description": "house with garden",
			"aliases": [
				"house_with_garden"
			],
			"tags": []
		},
		{
			"emoji": "🏫",
			"description": "school",
			"aliases": [
				"school"
			],
			"tags": []
		},
		{
			"emoji": "🏢",
			"description": "office building",
			"aliases": [
				"office"
			],
			"tags": []
		},
		{
			"emoji": "🏣",
			"description": "japanese post office",
			"aliases": [
				"post_office"
			],
			"tags": []
		},
		{
			"emoji": "🏥",
			"description": "hospital",
			"aliases": [
				"hospital"
			],
			"tags": []
		},
		{
			"emoji": "🏦",
			"description": "bank",
			"aliases": [
				"bank"
			],
			"tags": []
		},
		{
			"emoji": "🏪",
			"description": "convenience store",
			"aliases": [
				"convenience_store"
			],
			"tags": []
		},
		{
			"emoji": "🏩",
			"description": "love hotel",
			"aliases": [
				"love_hotel"
			],
			"tags": []
		},
		{
			"emoji": "🏨",
			"description": "hotel",
			"aliases": [
				"hotel"
			],
			"tags": []
		},
		{
			"emoji": "💒",
			"description": "wedding",
			"aliases": [
				"wedding"
			],
			"tags": [
				"marriage"
			]
		},
		{
			"emoji": "⛪",
			"description": "church",
			"aliases": [
				"church"
			],
			"tags": []
		},
		{
			"emoji": "🏬",
			"description": "department store",
			"aliases": [
				"department_store"
			],
			"tags": []
		},
		{
			"emoji": "🏤",
			"description": "european post office",
			"aliases": [
				"european_post_office"
			],
			"tags": []
		},
		{
			"emoji": "🌇",
			"description": "sunset over buildings",
			"aliases": [
				"city_sunrise"
			],
			"tags": []
		},
		{
			"emoji": "🌆",
			"description": "cityscape at dusk",
			"aliases": [
				"city_sunset"
			],
			"tags": []
		},
		{
			"emoji": "🏯",
			"description": "japanese castle",
			"aliases": [
				"japanese_castle"
			],
			"tags": []
		},
		{
			"emoji": "🏰",
			"description": "european castle",
			"aliases": [
				"european_castle"
			],
			"tags": []
		},
		{
			"emoji": "⛺",
			"description": "tent",
			"aliases": [
				"tent"
			],
			"tags": [
				"camping"
			]
		},
		{
			"emoji": "🏭",
			"description": "factory",
			"aliases": [
				"factory"
			],
			"tags": []
		},
		{
			"emoji": "🗼",
			"description": "tokyo tower",
			"aliases": [
				"tokyo_tower"
			],
			"tags": []
		},
		{
			"emoji": "🗾",
			"description": "silhouette of japan",
			"aliases": [
				"japan"
			],
			"tags": []
		},
		{
			"emoji": "🗻",
			"description": "mount fuji",
			"aliases": [
				"mount_fuji"
			],
			"tags": []
		},
		{
			"emoji": "🌄",
			"description": "sunrise over mountains",
			"aliases": [
				"sunrise_over_mountains"
			],
			"tags": []
		},
		{
			"emoji": "🌅",
			"description": "sunrise",
			"aliases": [
				"sunrise"
			],
			"tags": []
		},
		{
			"emoji": "🌃",
			"description": "night with stars",
			"aliases": [
				"night_with_stars"
			],
			"tags": []
		},
		{
			"emoji": "🗽",
			"description": "statue of liberty",
			"aliases": [
				"statue_of_liberty"
			],
			"tags": []
		},
		{
			"emoji": "🌉",
			"description": "bridge at night",
			"aliases": [
				"bridge_at_night"
			],
			"tags": []
		},
		{
			"emoji": "🎠",
			"description": "carousel horse",
			"aliases": [
				"carousel_horse"
			],
			"tags": []
		},
		{
			"emoji": "🎡",
			"description": "ferris wheel",
			"aliases": [
				"ferris_wheel"
			],
			"tags": []
		},
		{
			"emoji": "⛲",
			"description": "fountain",
			"aliases": [
				"fountain"
			],
			"tags": []
		},
		{
			"emoji": "🎢",
			"description": "roller coaster",
			"aliases": [
				"roller_coaster"
			],
			"tags": []
		},
		{
			"emoji": "🚢",
			"description": "ship",
			"aliases": [
				"ship"
			],
			"tags": []
		},
		{
			"emoji": "⛵",
			"description": "sailboat",
			"aliases": [
				"boat",
				"sailboat"
			],
			"tags": []
		},
		{
			"emoji": "🚤",
			"description": "speedboat",
			"aliases": [
				"speedboat"
			],
			"tags": [
				"ship"
			]
		},
		{
			"emoji": "🚣",
			"description": "rowboat",
			"aliases": [
				"rowboat"
			],
			"tags": []
		},
		{
			"emoji": "⚓",
			"description": "anchor",
			"aliases": [
				"anchor"
			],
			"tags": [
				"ship"
			]
		},
		{
			"emoji": "🚀",
			"description": "rocket",
			"aliases": [
				"rocket"
			],
			"tags": [
				"ship",
				"launch"
			]
		},
		{
			"emoji": "✈️",
			"description": "airplane",
			"aliases": [
				"airplane"
			],
			"tags": [
				"flight"
			]
		},
		{
			"emoji": "💺",
			"description": "seat",
			"aliases": [
				"seat"
			],
			"tags": []
		},
		{
			"emoji": "🚁",
			"description": "helicopter",
			"aliases": [
				"helicopter"
			],
			"tags": []
		},
		{
			"emoji": "🚂",
			"description": "steam locomotive",
			"aliases": [
				"steam_locomotive"
			],
			"tags": [
				"train"
			]
		},
		{
			"emoji": "🚊",
			"description": "tram",
			"aliases": [
				"tram"
			],
			"tags": []
		},
		{
			"emoji": "🚉",
			"description": "station",
			"aliases": [
				"station"
			],
			"tags": []
		},
		{
			"emoji": "🚞",
			"description": "mountain railway",
			"aliases": [
				"mountain_railway"
			],
			"tags": []
		},
		{
			"emoji": "🚆",
			"description": "train",
			"aliases": [
				"train2"
			],
			"tags": []
		},
		{
			"emoji": "🚄",
			"description": "high-speed train",
			"aliases": [
				"bullettrain_side"
			],
			"tags": [
				"train"
			]
		},
		{
			"emoji": "🚅",
			"description": "high-speed train with bullet nose",
			"aliases": [
				"bullettrain_front"
			],
			"tags": [
				"train"
			]
		},
		{
			"emoji": "🚈",
			"description": "light rail",
			"aliases": [
				"light_rail"
			],
			"tags": []
		},
		{
			"emoji": "🚇",
			"description": "metro",
			"aliases": [
				"metro"
			],
			"tags": []
		},
		{
			"emoji": "🚝",
			"description": "monorail",
			"aliases": [
				"monorail"
			],
			"tags": []
		},
		{
			"emoji": "🚋",
			"description": "tram car",
			"aliases": [
				"train"
			],
			"tags": []
		},
		{
			"emoji": "🚃",
			"description": "railway car",
			"aliases": [
				"railway_car"
			],
			"tags": []
		},
		{
			"emoji": "🚎",
			"description": "trolleybus",
			"aliases": [
				"trolleybus"
			],
			"tags": []
		},
		{
			"emoji": "🚌",
			"description": "bus",
			"aliases": [
				"bus"
			],
			"tags": []
		},
		{
			"emoji": "🚍",
			"description": "oncoming bus",
			"aliases": [
				"oncoming_bus"
			],
			"tags": []
		},
		{
			"emoji": "🚙",
			"description": "recreational vehicle",
			"aliases": [
				"blue_car"
			],
			"tags": []
		},
		{
			"emoji": "🚘",
			"description": "oncoming automobile",
			"aliases": [
				"oncoming_automobile"
			],
			"tags": []
		},
		{
			"emoji": "🚗",
			"description": "automobile",
			"aliases": [
				"car",
				"red_car"
			],
			"tags": []
		},
		{
			"emoji": "🚕",
			"description": "taxi",
			"aliases": [
				"taxi"
			],
			"tags": []
		},
		{
			"emoji": "🚖",
			"description": "oncoming taxi",
			"aliases": [
				"oncoming_taxi"
			],
			"tags": []
		},
		{
			"emoji": "🚛",
			"description": "articulated lorry",
			"aliases": [
				"articulated_lorry"
			],
			"tags": []
		},
		{
			"emoji": "🚚",
			"description": "delivery truck",
			"aliases": [
				"truck"
			],
			"tags": []
		},
		{
			"emoji": "🚨",
			"description": "police cars revolving light",
			"aliases": [
				"rotating_light"
			],
			"tags": [
				"911",
				"emergency"
			]
		},
		{
			"emoji": "🚓",
			"description": "police car",
			"aliases": [
				"police_car"
			],
			"tags": []
		},
		{
			"emoji": "🚔",
			"description": "oncoming police car",
			"aliases": [
				"oncoming_police_car"
			],
			"tags": []
		},
		{
			"emoji": "🚒",
			"description": "fire engine",
			"aliases": [
				"fire_engine"
			],
			"tags": []
		},
		{
			"emoji": "🚑",
			"description": "ambulance",
			"aliases": [
				"ambulance"
			],
			"tags": []
		},
		{
			"emoji": "🚐",
			"description": "minibus",
			"aliases": [
				"minibus"
			],
			"tags": []
		},
		{
			"emoji": "🚲",
			"description": "bicycle",
			"aliases": [
				"bike"
			],
			"tags": [
				"bicycle"
			]
		},
		{
			"emoji": "🚡",
			"description": "aerial tramway",
			"aliases": [
				"aerial_tramway"
			],
			"tags": []
		},
		{
			"emoji": "🚟",
			"description": "suspension railway",
			"aliases": [
				"suspension_railway"
			],
			"tags": []
		},
		{
			"emoji": "🚠",
			"description": "mountain cableway",
			"aliases": [
				"mountain_cableway"
			],
			"tags": []
		},
		{
			"emoji": "🚜",
			"description": "tractor",
			"aliases": [
				"tractor"
			],
			"tags": []
		},
		{
			"emoji": "💈",
			"description": "barber pole",
			"aliases": [
				"barber"
			],
			"tags": []
		},
		{
			"emoji": "🚏",
			"description": "bus stop",
			"aliases": [
				"busstop"
			],
			"tags": []
		},
		{
			"emoji": "🎫",
			"description": "ticket",
			"aliases": [
				"ticket"
			],
			"tags": []
		},
		{
			"emoji": "🚦",
			"description": "vertical traffic light",
			"aliases": [
				"vertical_traffic_light"
			],
			"tags": [
				"semaphore"
			]
		},
		{
			"emoji": "🚥",
			"description": "horizontal traffic light",
			"aliases": [
				"traffic_light"
			],
			"tags": []
		},
		{
			"emoji": "⚠️",
			"description": "warning sign",
			"aliases": [
				"warning"
			],
			"tags": [
				"wip"
			]
		},
		{
			"emoji": "🚧",
			"description": "construction sign",
			"aliases": [
				"construction"
			],
			"tags": [
				"wip"
			]
		},
		{
			"emoji": "🔰",
			"description": "japanese symbol for beginner",
			"aliases": [
				"beginner"
			],
			"tags": []
		},
		{
			"emoji": "⛽",
			"description": "fuel pump",
			"aliases": [
				"fuelpump"
			],
			"tags": []
		},
		{
			"emoji": "🏮",
			"description": "izakaya lantern",
			"aliases": [
				"izakaya_lantern",
				"lantern"
			],
			"tags": []
		},
		{
			"emoji": "🎰",
			"description": "slot machine",
			"aliases": [
				"slot_machine"
			],
			"tags": []
		},
		{
			"emoji": "♨️",
			"description": "hot springs",
			"aliases": [
				"hotsprings"
			],
			"tags": []
		},
		{
			"emoji": "🗿",
			"description": "moyai",
			"aliases": [
				"moyai"
			],
			"tags": [
				"stone"
			]
		},
		{
			"emoji": "🎪",
			"description": "circus tent",
			"aliases": [
				"circus_tent"
			],
			"tags": []
		},
		{
			"emoji": "🎭",
			"description": "performing arts",
			"aliases": [
				"performing_arts"
			],
			"tags": [
				"theater",
				"drama"
			]
		},
		{
			"emoji": "📍",
			"description": "round pushpin",
			"aliases": [
				"round_pushpin"
			],
			"tags": [
				"location"
			]
		},
		{
			"emoji": "🚩",
			"description": "triangular flag on post",
			"aliases": [
				"triangular_flag_on_post"
			],
			"tags": []
		},
		{
			"emoji": "🇯🇵",
			"description": "regional indicator symbol letter j + regional indicator symbol letter p",
			"aliases": [
				"jp"
			],
			"tags": [
				"japan"
			]
		},
		{
			"emoji": "🇰🇷",
			"description": "regional indicator symbol letter k + regional indicator symbol letter r",
			"aliases": [
				"kr"
			],
			"tags": [
				"korea"
			]
		},
		{
			"emoji": "🇩🇪",
			"description": "regional indicator symbol letter d + regional indicator symbol letter e",
			"aliases": [
				"de"
			],
			"tags": [
				"flag",
				"germany"
			]
		},
		{
			"emoji": "🇨🇳",
			"description": "regional indicator symbol letter c + regional indicator symbol letter n",
			"aliases": [
				"cn"
			],
			"tags": [
				"china"
			]
		},
		{
			"emoji": "🇺🇸",
			"description": "regional indicator symbol letter u + regional indicator symbol letter s",
			"aliases": [
				"us"
			],
			"tags": [
				"flag",
				"united",
				"america"
			]
		},
		{
			"emoji": "🇫🇷",
			"description": "regional indicator symbol letter f + regional indicator symbol letter r",
			"aliases": [
				"fr"
			],
			"tags": [
				"france",
				"french"
			]
		},
		{
			"emoji": "🇪🇸",
			"description": "regional indicator symbol letter e + regional indicator symbol letter s",
			"aliases": [
				"es"
			],
			"tags": [
				"spain"
			]
		},
		{
			"emoji": "🇮🇹",
			"description": "regional indicator symbol letter i + regional indicator symbol letter t",
			"aliases": [
				"it"
			],
			"tags": [
				"italy"
			]
		},
		{
			"emoji": "🇷🇺",
			"description": "regional indicator symbol letter r + regional indicator symbol letter u",
			"aliases": [
				"ru"
			],
			"tags": [
				"russia"
			]
		},
		{
			"emoji": "🇬🇧",
			"description": "regional indicator symbol letter g + regional indicator symbol letter b",
			"aliases": [
				"gb",
				"uk"
			],
			"tags": [
				"flag",
				"british"
			]
		},
		{
			"emoji": "1️⃣",
			"description": "digit one + combining enclosing keycap",
			"aliases": [
				"one"
			],
			"tags": []
		},
		{
			"emoji": "2️⃣",
			"description": "digit two + combining enclosing keycap",
			"aliases": [
				"two"
			],
			"tags": []
		},
		{
			"emoji": "3️⃣",
			"description": "digit three + combining enclosing keycap",
			"aliases": [
				"three"
			],
			"tags": []
		},
		{
			"emoji": "4️⃣",
			"description": "digit four + combining enclosing keycap",
			"aliases": [
				"four"
			],
			"tags": []
		},
		{
			"emoji": "5️⃣",
			"description": "digit five + combining enclosing keycap",
			"aliases": [
				"five"
			],
			"tags": []
		},
		{
			"emoji": "6️⃣",
			"description": "digit six + combining enclosing keycap",
			"aliases": [
				"six"
			],
			"tags": []
		},
		{
			"emoji": "7️⃣",
			"description": "digit seven + combining enclosing keycap",
			"aliases": [
				"seven"
			],
			"tags": []
		},
		{
			"emoji": "8️⃣",
			"description": "digit eight + combining enclosing keycap",
			"aliases": [
				"eight"
			],
			"tags": []
		},
		{
			"emoji": "9️⃣",
			"description": "digit nine + combining enclosing keycap",
			"aliases": [
				"nine"
			],
			"tags": []
		},
		{
			"emoji": "0️⃣",
			"description": "digit zero + combining enclosing keycap",
			"aliases": [
				"zero"
			],
			"tags": []
		},
		{
			"emoji": "🔟",
			"description": "keycap ten",
			"aliases": [
				"keycap_ten"
			],
			"tags": []
		},
		{
			"emoji": "🔢",
			"description": "input symbol for numbers",
			"aliases": [
				"1234"
			],
			"tags": [
				"numbers"
			]
		},
		{
			"emoji": "#️⃣",
			"description": "number sign + combining enclosing keycap",
			"aliases": [
				"hash"
			],
			"tags": [
				"number"
			]
		},
		{
			"emoji": "🔣",
			"description": "input symbol for symbols",
			"aliases": [
				"symbols"
			],
			"tags": []
		},
		{
			"emoji": "⬆️",
			"description": "upwards black arrow",
			"aliases": [
				"arrow_up"
			],
			"tags": []
		},
		{
			"emoji": "⬇️",
			"description": "downwards black arrow",
			"aliases": [
				"arrow_down"
			],
			"tags": []
		},
		{
			"emoji": "⬅️",
			"description": "leftwards black arrow",
			"aliases": [
				"arrow_left"
			],
			"tags": []
		},
		{
			"emoji": "➡️",
			"description": "black rightwards arrow",
			"aliases": [
				"arrow_right"
			],
			"tags": []
		},
		{
			"emoji": "🔠",
			"description": "input symbol for latin capital letters",
			"aliases": [
				"capital_abcd"
			],
			"tags": [
				"letters"
			]
		},
		{
			"emoji": "🔡",
			"description": "input symbol for latin small letters",
			"aliases": [
				"abcd"
			],
			"tags": []
		},
		{
			"emoji": "🔤",
			"description": "input symbol for latin letters",
			"aliases": [
				"abc"
			],
			"tags": [
				"alphabet"
			]
		},
		{
			"emoji": "↗️",
			"description": "north east arrow",
			"aliases": [
				"arrow_upper_right"
			],
			"tags": []
		},
		{
			"emoji": "↖️",
			"description": "north west arrow",
			"aliases": [
				"arrow_upper_left"
			],
			"tags": []
		},
		{
			"emoji": "↘️",
			"description": "south east arrow",
			"aliases": [
				"arrow_lower_right"
			],
			"tags": []
		},
		{
			"emoji": "↙️",
			"description": "south west arrow",
			"aliases": [
				"arrow_lower_left"
			],
			"tags": []
		},
		{
			"emoji": "↔️",
			"description": "left right arrow",
			"aliases": [
				"left_right_arrow"
			],
			"tags": []
		},
		{
			"emoji": "↕️",
			"description": "up down arrow",
			"aliases": [
				"arrow_up_down"
			],
			"tags": []
		},
		{
			"emoji": "🔄",
			"description": "anticlockwise downwards and upwards open circle arrows",
			"aliases": [
				"arrows_counterclockwise"
			],
			"tags": [
				"sync"
			]
		},
		{
			"emoji": "◀️",
			"description": "black left-pointing triangle",
			"aliases": [
				"arrow_backward"
			],
			"tags": []
		},
		{
			"emoji": "▶️",
			"description": "black right-pointing triangle",
			"aliases": [
				"arrow_forward"
			],
			"tags": []
		},
		{
			"emoji": "🔼",
			"description": "up-pointing small red triangle",
			"aliases": [
				"arrow_up_small"
			],
			"tags": []
		},
		{
			"emoji": "🔽",
			"description": "down-pointing small red triangle",
			"aliases": [
				"arrow_down_small"
			],
			"tags": []
		},
		{
			"emoji": "↩️",
			"description": "leftwards arrow with hook",
			"aliases": [
				"leftwards_arrow_with_hook"
			],
			"tags": [
				"return"
			]
		},
		{
			"emoji": "↪️",
			"description": "rightwards arrow with hook",
			"aliases": [
				"arrow_right_hook"
			],
			"tags": []
		},
		{
			"emoji": "ℹ️",
			"description": "information source",
			"aliases": [
				"information_source"
			],
			"tags": []
		},
		{
			"emoji": "⏪",
			"description": "black left-pointing double triangle",
			"aliases": [
				"rewind"
			],
			"tags": []
		},
		{
			"emoji": "⏩",
			"description": "black right-pointing double triangle",
			"aliases": [
				"fast_forward"
			],
			"tags": []
		},
		{
			"emoji": "⏫",
			"description": "black up-pointing double triangle",
			"aliases": [
				"arrow_double_up"
			],
			"tags": []
		},
		{
			"emoji": "⏬",
			"description": "black down-pointing double triangle",
			"aliases": [
				"arrow_double_down"
			],
			"tags": []
		},
		{
			"emoji": "⤵️",
			"description": "arrow pointing rightwards then curving downwards",
			"aliases": [
				"arrow_heading_down"
			],
			"tags": []
		},
		{
			"emoji": "⤴️",
			"description": "arrow pointing rightwards then curving upwards",
			"aliases": [
				"arrow_heading_up"
			],
			"tags": []
		},
		{
			"emoji": "🆗",
			"description": "squared ok",
			"aliases": [
				"ok"
			],
			"tags": [
				"yes"
			]
		},
		{
			"emoji": "🔀",
			"description": "twisted rightwards arrows",
			"aliases": [
				"twisted_rightwards_arrows"
			],
			"tags": [
				"shuffle"
			]
		},
		{
			"emoji": "🔁",
			"description": "clockwise rightwards and leftwards open circle arrows",
			"aliases": [
				"repeat"
			],
			"tags": [
				"loop"
			]
		},
		{
			"emoji": "🔂",
			"description": "clockwise rightwards and leftwards open circle arrows with circled one overlay",
			"aliases": [
				"repeat_one"
			],
			"tags": []
		},
		{
			"emoji": "🆕",
			"description": "squared new",
			"aliases": [
				"new"
			],
			"tags": [
				"fresh"
			]
		},
		{
			"emoji": "🆙",
			"description": "squared up with exclamation mark",
			"aliases": [
				"up"
			],
			"tags": []
		},
		{
			"emoji": "🆒",
			"description": "squared cool",
			"aliases": [
				"cool"
			],
			"tags": []
		},
		{
			"emoji": "🆓",
			"description": "squared free",
			"aliases": [
				"free"
			],
			"tags": []
		},
		{
			"emoji": "🆖",
			"description": "squared ng",
			"aliases": [
				"ng"
			],
			"tags": []
		},
		{
			"emoji": "📶",
			"description": "antenna with bars",
			"aliases": [
				"signal_strength"
			],
			"tags": [
				"wifi"
			]
		},
		{
			"emoji": "🎦",
			"description": "cinema",
			"aliases": [
				"cinema"
			],
			"tags": [
				"film",
				"movie"
			]
		},
		{
			"emoji": "🈁",
			"description": "squared katakana koko",
			"aliases": [
				"koko"
			],
			"tags": []
		},
		{
			"emoji": "🈯",
			"description": "squared cjk unified ideograph-6307",
			"aliases": [
				"u6307"
			],
			"tags": []
		},
		{
			"emoji": "🈳",
			"description": "squared cjk unified ideograph-7a7a",
			"aliases": [
				"u7a7a"
			],
			"tags": []
		},
		{
			"emoji": "🈵",
			"description": "squared cjk unified ideograph-6e80",
			"aliases": [
				"u6e80"
			],
			"tags": []
		},
		{
			"emoji": "🈴",
			"description": "squared cjk unified ideograph-5408",
			"aliases": [
				"u5408"
			],
			"tags": []
		},
		{
			"emoji": "🈲",
			"description": "squared cjk unified ideograph-7981",
			"aliases": [
				"u7981"
			],
			"tags": []
		},
		{
			"emoji": "🉐",
			"description": "circled ideograph advantage",
			"aliases": [
				"ideograph_advantage"
			],
			"tags": []
		},
		{
			"emoji": "🈹",
			"description": "squared cjk unified ideograph-5272",
			"aliases": [
				"u5272"
			],
			"tags": []
		},
		{
			"emoji": "🈺",
			"description": "squared cjk unified ideograph-55b6",
			"aliases": [
				"u55b6"
			],
			"tags": []
		},
		{
			"emoji": "🈶",
			"description": "squared cjk unified ideograph-6709",
			"aliases": [
				"u6709"
			],
			"tags": []
		},
		{
			"emoji": "🈚",
			"description": "squared cjk unified ideograph-7121",
			"aliases": [
				"u7121"
			],
			"tags": []
		},
		{
			"emoji": "🚻",
			"description": "restroom",
			"aliases": [
				"restroom"
			],
			"tags": [
				"toilet"
			]
		},
		{
			"emoji": "🚹",
			"description": "mens symbol",
			"aliases": [
				"mens"
			],
			"tags": []
		},
		{
			"emoji": "🚺",
			"description": "womens symbol",
			"aliases": [
				"womens"
			],
			"tags": []
		},
		{
			"emoji": "🚼",
			"description": "baby symbol",
			"aliases": [
				"baby_symbol"
			],
			"tags": []
		},
		{
			"emoji": "🚾",
			"description": "water closet",
			"aliases": [
				"wc"
			],
			"tags": [
				"toilet",
				"restroom"
			]
		},
		{
			"emoji": "🚰",
			"description": "potable water symbol",
			"aliases": [
				"potable_water"
			],
			"tags": []
		},
		{
			"emoji": "🚮",
			"description": "put litter in its place symbol",
			"aliases": [
				"put_litter_in_its_place"
			],
			"tags": []
		},
		{
			"emoji": "🅿️",
			"description": "negative squared latin capital letter p",
			"aliases": [
				"parking"
			],
			"tags": []
		},
		{
			"emoji": "♿",
			"description": "wheelchair symbol",
			"aliases": [
				"wheelchair"
			],
			"tags": [
				"accessibility"
			]
		},
		{
			"emoji": "🚭",
			"description": "no smoking symbol",
			"aliases": [
				"no_smoking"
			],
			"tags": []
		},
		{
			"emoji": "🈷️",
			"description": "squared cjk unified ideograph-6708",
			"aliases": [
				"u6708"
			],
			"tags": []
		},
		{
			"emoji": "🈸",
			"description": "squared cjk unified ideograph-7533",
			"aliases": [
				"u7533"
			],
			"tags": []
		},
		{
			"emoji": "🈂️",
			"description": "squared katakana sa",
			"aliases": [
				"sa"
			],
			"tags": []
		},
		{
			"emoji": "Ⓜ️",
			"description": "circled latin capital letter m",
			"aliases": [
				"m"
			],
			"tags": []
		},
		{
			"emoji": "🛂",
			"description": "passport control",
			"aliases": [
				"passport_control"
			],
			"tags": []
		},
		{
			"emoji": "🛄",
			"description": "baggage claim",
			"aliases": [
				"baggage_claim"
			],
			"tags": [
				"airport"
			]
		},
		{
			"emoji": "🛅",
			"description": "left luggage",
			"aliases": [
				"left_luggage"
			],
			"tags": []
		},
		{
			"emoji": "🛃",
			"description": "customs",
			"aliases": [
				"customs"
			],
			"tags": []
		},
		{
			"emoji": "🉑",
			"description": "circled ideograph accept",
			"aliases": [
				"accept"
			],
			"tags": []
		},
		{
			"emoji": "㊙️",
			"description": "circled ideograph secret",
			"aliases": [
				"secret"
			],
			"tags": []
		},
		{
			"emoji": "㊗️",
			"description": "circled ideograph congratulation",
			"aliases": [
				"congratulations"
			],
			"tags": []
		},
		{
			"emoji": "🆑",
			"description": "squared cl",
			"aliases": [
				"cl"
			],
			"tags": []
		},
		{
			"emoji": "🆘",
			"description": "squared sos",
			"aliases": [
				"sos"
			],
			"tags": [
				"help",
				"emergency"
			]
		},
		{
			"emoji": "🆔",
			"description": "squared id",
			"aliases": [
				"id"
			],
			"tags": []
		},
		{
			"emoji": "🚫",
			"description": "no entry sign",
			"aliases": [
				"no_entry_sign"
			],
			"tags": [
				"block",
				"forbidden"
			]
		},
		{
			"emoji": "🔞",
			"description": "no one under eighteen symbol",
			"aliases": [
				"underage"
			],
			"tags": []
		},
		{
			"emoji": "📵",
			"description": "no mobile phones",
			"aliases": [
				"no_mobile_phones"
			],
			"tags": []
		},
		{
			"emoji": "🚯",
			"description": "do not litter symbol",
			"aliases": [
				"do_not_litter"
			],
			"tags": []
		},
		{
			"emoji": "🚱",
			"description": "non-potable water symbol",
			"aliases": [
				"non-potable_water"
			],
			"tags": []
		},
		{
			"emoji": "🚳",
			"description": "no bicycles",
			"aliases": [
				"no_bicycles"
			],
			"tags": []
		},
		{
			"emoji": "🚷",
			"description": "no pedestrians",
			"aliases": [
				"no_pedestrians"
			],
			"tags": []
		},
		{
			"emoji": "🚸",
			"description": "children crossing",
			"aliases": [
				"children_crossing"
			],
			"tags": []
		},
		{
			"emoji": "⛔",
			"description": "no entry",
			"aliases": [
				"no_entry"
			],
			"tags": [
				"limit"
			]
		},
		{
			"emoji": "✳️",
			"description": "eight spoked asterisk",
			"aliases": [
				"eight_spoked_asterisk"
			],
			"tags": []
		},
		{
			"emoji": "❇️",
			"description": "sparkle",
			"aliases": [
				"sparkle"
			],
			"tags": []
		},
		{
			"emoji": "❎",
			"description": "negative squared cross mark",
			"aliases": [
				"negative_squared_cross_mark"
			],
			"tags": []
		},
		{
			"emoji": "✅",
			"description": "white heavy check mark",
			"aliases": [
				"white_check_mark"
			],
			"tags": []
		},
		{
			"emoji": "✴️",
			"description": "eight pointed black star",
			"aliases": [
				"eight_pointed_black_star"
			],
			"tags": []
		},
		{
			"emoji": "💟",
			"description": "heart decoration",
			"aliases": [
				"heart_decoration"
			],
			"tags": []
		},
		{
			"emoji": "🆚",
			"description": "squared vs",
			"aliases": [
				"vs"
			],
			"tags": []
		},
		{
			"emoji": "📳",
			"description": "vibration mode",
			"aliases": [
				"vibration_mode"
			],
			"tags": []
		},
		{
			"emoji": "📴",
			"description": "mobile phone off",
			"aliases": [
				"mobile_phone_off"
			],
			"tags": [
				"mute",
				"off"
			]
		},
		{
			"emoji": "🅰️",
			"description": "negative squared latin capital letter a",
			"aliases": [
				"a"
			],
			"tags": []
		},
		{
			"emoji": "🅱️",
			"description": "negative squared latin capital letter b",
			"aliases": [
				"b"
			],
			"tags": []
		},
		{
			"emoji": "🆎",
			"description": "negative squared ab",
			"aliases": [
				"ab"
			],
			"tags": []
		},
		{
			"emoji": "🅾️",
			"description": "negative squared latin capital letter o",
			"aliases": [
				"o2"
			],
			"tags": []
		},
		{
			"emoji": "💠",
			"description": "diamond shape with a dot inside",
			"aliases": [
				"diamond_shape_with_a_dot_inside"
			],
			"tags": []
		},
		{
			"emoji": "➿",
			"description": "double curly loop",
			"aliases": [
				"loop"
			],
			"tags": []
		},
		{
			"emoji": "♻️",
			"description": "black universal recycling symbol",
			"aliases": [
				"recycle"
			],
			"tags": [
				"environment",
				"green"
			]
		},
		{
			"emoji": "♈",
			"description": "aries",
			"aliases": [
				"aries"
			],
			"tags": []
		},
		{
			"emoji": "♉",
			"description": "taurus",
			"aliases": [
				"taurus"
			],
			"tags": []
		},
		{
			"emoji": "♊",
			"description": "gemini",
			"aliases": [
				"gemini"
			],
			"tags": []
		},
		{
			"emoji": "♋",
			"description": "cancer",
			"aliases": [
				"cancer"
			],
			"tags": []
		},
		{
			"emoji": "♌",
			"description": "leo",
			"aliases": [
				"leo"
			],
			"tags": []
		},
		{
			"emoji": "♍",
			"description": "virgo",
			"aliases": [
				"virgo"
			],
			"tags": []
		},
		{
			"emoji": "♎",
			"description": "libra",
			"aliases": [
				"libra"
			],
			"tags": []
		},
		{
			"emoji": "♏",
			"description": "scorpius",
			"aliases": [
				"scorpius"
			],
			"tags": []
		},
		{
			"emoji": "♐",
			"description": "sagittarius",
			"aliases": [
				"sagittarius"
			],
			"tags": []
		},
		{
			"emoji": "♑",
			"description": "capricorn",
			"aliases": [
				"capricorn"
			],
			"tags": []
		},
		{
			"emoji": "♒",
			"description": "aquarius",
			"aliases": [
				"aquarius"
			],
			"tags": []
		},
		{
			"emoji": "♓",
			"description": "pisces",
			"aliases": [
				"pisces"
			],
			"tags": []
		},
		{
			"emoji": "⛎",
			"description": "ophiuchus",
			"aliases": [
				"ophiuchus"
			],
			"tags": []
		},
		{
			"emoji": "🔯",
			"description": "six pointed star with middle dot",
			"aliases": [
				"six_pointed_star"
			],
			"tags": []
		},
		{
			"emoji": "🏧",
			"description": "automated teller machine",
			"aliases": [
				"atm"
			],
			"tags": []
		},
		{
			"emoji": "💹",
			"description": "chart with upwards trend and yen sign",
			"aliases": [
				"chart"
			],
			"tags": []
		},
		{
			"emoji": "💲",
			"description": "heavy dollar sign",
			"aliases": [
				"heavy_dollar_sign"
			],
			"tags": []
		},
		{
			"emoji": "💱",
			"description": "currency exchange",
			"aliases": [
				"currency_exchange"
			],
			"tags": []
		},
		{
			"emoji": "©️",
			"description": "copyright sign",
			"aliases": [
				"copyright"
			],
			"tags": []
		},
		{
			"emoji": "®️",
			"description": "registered sign",
			"aliases": [
				"registered"
			],
			"tags": []
		},
		{
			"emoji": "™️",
			"description": "trade mark sign",
			"aliases": [
				"tm"
			],
			"tags": [
				"trademark"
			]
		},
		{
			"emoji": "❌",
			"description": "cross mark",
			"aliases": [
				"x"
			],
			"tags": []
		},
		{
			"emoji": "‼️",
			"description": "double exclamation mark",
			"aliases": [
				"bangbang"
			],
			"tags": []
		},
		{
			"emoji": "⁉️",
			"description": "exclamation question mark",
			"aliases": [
				"interrobang"
			],
			"tags": []
		},
		{
			"emoji": "❗",
			"description": "heavy exclamation mark symbol",
			"aliases": [
				"exclamation",
				"heavy_exclamation_mark"
			],
			"tags": [
				"bang"
			]
		},
		{
			"emoji": "❓",
			"description": "black question mark ornament",
			"aliases": [
				"question"
			],
			"tags": [
				"confused"
			]
		},
		{
			"emoji": "❕",
			"description": "white exclamation mark ornament",
			"aliases": [
				"grey_exclamation"
			],
			"tags": []
		},
		{
			"emoji": "❔",
			"description": "white question mark ornament",
			"aliases": [
				"grey_question"
			],
			"tags": []
		},
		{
			"emoji": "⭕",
			"description": "heavy large circle",
			"aliases": [
				"o"
			],
			"tags": []
		},
		{
			"emoji": "🔝",
			"description": "top with upwards arrow above",
			"aliases": [
				"top"
			],
			"tags": []
		},
		{
			"emoji": "🔚",
			"description": "end with leftwards arrow above",
			"aliases": [
				"end"
			],
			"tags": []
		},
		{
			"emoji": "🔙",
			"description": "back with leftwards arrow above",
			"aliases": [
				"back"
			],
			"tags": []
		},
		{
			"emoji": "🔛",
			"description": "on with exclamation mark with left right arrow above",
			"aliases": [
				"on"
			],
			"tags": []
		},
		{
			"emoji": "🔜",
			"description": "soon with rightwards arrow above",
			"aliases": [
				"soon"
			],
			"tags": []
		},
		{
			"emoji": "🔃",
			"description": "clockwise downwards and upwards open circle arrows",
			"aliases": [
				"arrows_clockwise"
			],
			"tags": []
		},
		{
			"emoji": "🕛",
			"description": "clock face twelve oclock",
			"aliases": [
				"clock12"
			],
			"tags": []
		},
		{
			"emoji": "🕧",
			"description": "clock face twelve-thirty",
			"aliases": [
				"clock1230"
			],
			"tags": []
		},
		{
			"emoji": "🕐",
			"description": "clock face one oclock",
			"aliases": [
				"clock1"
			],
			"tags": []
		},
		{
			"emoji": "🕜",
			"description": "clock face one-thirty",
			"aliases": [
				"clock130"
			],
			"tags": []
		},
		{
			"emoji": "🕑",
			"description": "clock face two oclock",
			"aliases": [
				"clock2"
			],
			"tags": []
		},
		{
			"emoji": "🕝",
			"description": "clock face two-thirty",
			"aliases": [
				"clock230"
			],
			"tags": []
		},
		{
			"emoji": "🕒",
			"description": "clock face three oclock",
			"aliases": [
				"clock3"
			],
			"tags": []
		},
		{
			"emoji": "🕞",
			"description": "clock face three-thirty",
			"aliases": [
				"clock330"
			],
			"tags": []
		},
		{
			"emoji": "🕓",
			"description": "clock face four oclock",
			"aliases": [
				"clock4"
			],
			"tags": []
		},
		{
			"emoji": "🕟",
			"description": "clock face four-thirty",
			"aliases": [
				"clock430"
			],
			"tags": []
		},
		{
			"emoji": "🕔",
			"description": "clock face five oclock",
			"aliases": [
				"clock5"
			],
			"tags": []
		},
		{
			"emoji": "🕠",
			"description": "clock face five-thirty",
			"aliases": [
				"clock530"
			],
			"tags": []
		},
		{
			"emoji": "🕕",
			"description": "clock face six oclock",
			"aliases": [
				"clock6"
			],
			"tags": []
		},
		{
			"emoji": "🕖",
			"description": "clock face seven oclock",
			"aliases": [
				"clock7"
			],
			"tags": []
		},
		{
			"emoji": "🕗",
			"description": "clock face eight oclock",
			"aliases": [
				"clock8"
			],
			"tags": []
		},
		{
			"emoji": "🕘",
			"description": "clock face nine oclock",
			"aliases": [
				"clock9"
			],
			"tags": []
		},
		{
			"emoji": "🕙",
			"description": "clock face ten oclock",
			"aliases": [
				"clock10"
			],
			"tags": []
		},
		{
			"emoji": "🕚",
			"description": "clock face eleven oclock",
			"aliases": [
				"clock11"
			],
			"tags": []
		},
		{
			"emoji": "🕡",
			"description": "clock face six-thirty",
			"aliases": [
				"clock630"
			],
			"tags": []
		},
		{
			"emoji": "🕢",
			"description": "clock face seven-thirty",
			"aliases": [
				"clock730"
			],
			"tags": []
		},
		{
			"emoji": "🕣",
			"description": "clock face eight-thirty",
			"aliases": [
				"clock830"
			],
			"tags": []
		},
		{
			"emoji": "🕤",
			"description": "clock face nine-thirty",
			"aliases": [
				"clock930"
			],
			"tags": []
		},
		{
			"emoji": "🕥",
			"description": "clock face ten-thirty",
			"aliases": [
				"clock1030"
			],
			"tags": []
		},
		{
			"emoji": "🕦",
			"description": "clock face eleven-thirty",
			"aliases": [
				"clock1130"
			],
			"tags": []
		},
		{
			"emoji": "✖️",
			"description": "heavy multiplication x",
			"aliases": [
				"heavy_multiplication_x"
			],
			"tags": []
		},
		{
			"emoji": "➕",
			"description": "heavy plus sign",
			"aliases": [
				"heavy_plus_sign"
			],
			"tags": []
		},
		{
			"emoji": "➖",
			"description": "heavy minus sign",
			"aliases": [
				"heavy_minus_sign"
			],
			"tags": []
		},
		{
			"emoji": "➗",
			"description": "heavy division sign",
			"aliases": [
				"heavy_division_sign"
			],
			"tags": []
		},
		{
			"emoji": "♠️",
			"description": "black spade suit",
			"aliases": [
				"spades"
			],
			"tags": []
		},
		{
			"emoji": "♥️",
			"description": "black heart suit",
			"aliases": [
				"hearts"
			],
			"tags": []
		},
		{
			"emoji": "♣️",
			"description": "black club suit",
			"aliases": [
				"clubs"
			],
			"tags": []
		},
		{
			"emoji": "♦️",
			"description": "black diamond suit",
			"aliases": [
				"diamonds"
			],
			"tags": []
		},
		{
			"emoji": "💮",
			"description": "white flower",
			"aliases": [
				"white_flower"
			],
			"tags": []
		},
		{
			"emoji": "💯",
			"description": "hundred points symbol",
			"aliases": [
				"100"
			],
			"tags": [
				"score",
				"perfect"
			]
		},
		{
			"emoji": "✔️",
			"description": "heavy check mark",
			"aliases": [
				"heavy_check_mark"
			],
			"tags": []
		},
		{
			"emoji": "☑️",
			"description": "ballot box with check",
			"aliases": [
				"ballot_box_with_check"
			],
			"tags": []
		},
		{
			"emoji": "🔘",
			"description": "radio button",
			"aliases": [
				"radio_button"
			],
			"tags": []
		},
		{
			"emoji": "🔗",
			"description": "link symbol",
			"aliases": [
				"link"
			],
			"tags": []
		},
		{
			"emoji": "➰",
			"description": "curly loop",
			"aliases": [
				"curly_loop"
			],
			"tags": []
		},
		{
			"emoji": "〰️",
			"description": "wavy dash",
			"aliases": [
				"wavy_dash"
			],
			"tags": []
		},
		{
			"emoji": "〽️",
			"description": "part alternation mark",
			"aliases": [
				"part_alternation_mark"
			],
			"tags": []
		},
		{
			"emoji": "🔱",
			"description": "trident emblem",
			"aliases": [
				"trident"
			],
			"tags": []
		},
		{
			"emoji": "◼️",
			"description": "black medium square",
			"aliases": [
				"black_medium_square"
			],
			"tags": []
		},
		{
			"emoji": "◻️",
			"description": "white medium square",
			"aliases": [
				"white_medium_square"
			],
			"tags": []
		},
		{
			"emoji": "◾",
			"description": "black medium small square",
			"aliases": [
				"black_medium_small_square"
			],
			"tags": []
		},
		{
			"emoji": "◽",
			"description": "white medium small square",
			"aliases": [
				"white_medium_small_square"
			],
			"tags": []
		},
		{
			"emoji": "▪️",
			"description": "black small square",
			"aliases": [
				"black_small_square"
			],
			"tags": []
		},
		{
			"emoji": "▫️",
			"description": "white small square",
			"aliases": [
				"white_small_square"
			],
			"tags": []
		},
		{
			"emoji": "🔺",
			"description": "up-pointing red triangle",
			"aliases": [
				"small_red_triangle"
			],
			"tags": []
		},
		{
			"emoji": "🔲",
			"description": "black square button",
			"aliases": [
				"black_square_button"
			],
			"tags": []
		},
		{
			"emoji": "🔳",
			"description": "white square button",
			"aliases": [
				"white_square_button"
			],
			"tags": []
		},
		{
			"emoji": "⚫",
			"description": "medium black circle",
			"aliases": [
				"black_circle"
			],
			"tags": []
		},
		{
			"emoji": "⚪",
			"description": "medium white circle",
			"aliases": [
				"white_circle"
			],
			"tags": []
		},
		{
			"emoji": "🔴",
			"description": "large red circle",
			"aliases": [
				"red_circle"
			],
			"tags": []
		},
		{
			"emoji": "🔵",
			"description": "large blue circle",
			"aliases": [
				"large_blue_circle"
			],
			"tags": []
		},
		{
			"emoji": "🔻",
			"description": "down-pointing red triangle",
			"aliases": [
				"small_red_triangle_down"
			],
			"tags": []
		},
		{
			"emoji": "⬜",
			"description": "white large square",
			"aliases": [
				"white_large_square"
			],
			"tags": []
		},
		{
			"emoji": "⬛",
			"description": "black large square",
			"aliases": [
				"black_large_square"
			],
			"tags": []
		},
		{
			"emoji": "🔶",
			"description": "large orange diamond",
			"aliases": [
				"large_orange_diamond"
			],
			"tags": []
		},
		{
			"emoji": "🔷",
			"description": "large blue diamond",
			"aliases": [
				"large_blue_diamond"
			],
			"tags": []
		},
		{
			"emoji": "🔸",
			"description": "small orange diamond",
			"aliases": [
				"small_orange_diamond"
			],
			"tags": []
		},
		{
			"emoji": "🔹",
			"description": "small blue diamond",
			"aliases": [
				"small_blue_diamond"
			],
			"tags": []
		},
		{
			"emoji": "🇨🇦",
			"description": "regional indicator symbol letter c + regional indicator symbol letter a",
			"aliases": [
				"ca",
				"eh"
			],
			"tags": [
				"canada"
			]
		},
		{
			"emoji": "🇵🇰",
			"description": "regional indicator symbol letter p + regional indicator symbol letter k",
			"aliases": [
				"pk"
			],
			"tags": [
				"pakistan"
			]
		},
		{
			"emoji": "🇿🇦",
			"description": "regional indicator symbol letter z + regional indicator symbol letter a",
			"aliases": [
				"za"
			],
			"tags": [
				"south_africa"
			]
		},
		{
			"emoji": "🙂",
			"description": "slightly smiling face",
			"aliases": [
				"slightly_smiling_face"
			],
			"tags": []
		},
		{
			"emoji": "🙁",
			"description": "slightly frowning face",
			"aliases": [
				"slightly_frowning_face"
			],
			"tags": []
		},
		{
			"emoji": "🙃",
			"description": "upside-down face",
			"aliases": [
				"upside_down_face"
			],
			"tags": []
		},
		{
			"aliases": [
				"mm",
				"mattermost"
			],
			"tags": []
		},
		{
			"aliases": [
				"basecamp"
			],
			"tags": []
		},
		{
			"aliases": [
				"basecampy"
			],
			"tags": []
		},
		{
			"aliases": [
				"bowtie"
			],
			"tags": []
		},
		{
			"aliases": [
				"feelsgood"
			],
			"tags": []
		},
		{
			"aliases": [
				"finnadie"
			],
			"tags": []
		},
		{
			"aliases": [
				"fu"
			],
			"tags": []
		},
		{
			"aliases": [
				"goberserk"
			],
			"tags": []
		},
		{
			"aliases": [
				"godmode"
			],
			"tags": []
		},
		{
			"aliases": [
				"hurtrealbad"
			],
			"tags": []
		},
		{
			"aliases": [
				"metal"
			],
			"tags": []
		},
		{
			"aliases": [
				"neckbeard"
			],
			"tags": []
		},
		{
			"aliases": [
				"octocat"
			],
			"tags": []
		},
		{
			"aliases": [
				"rage1"
			],
			"tags": []
		},
		{
			"aliases": [
				"rage2"
			],
			"tags": []
		},
		{
			"aliases": [
				"rage3"
			],
			"tags": []
		},
		{
			"aliases": [
				"rage4"
			],
			"tags": []
		},
		{
			"aliases": [
				"shipit",
				"squirrel"
			],
			"tags": []
		},
		{
			"aliases": [
				"suspect"
			],
			"tags": []
		},
		{
			"aliases": [
				"taco"
			],
			"tags": []
		},
		{
			"aliases": [
				"trollface"
			],
			"tags": []
		}
	];

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(378);
	if(typeof content === 'string') content = [[module.i, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(242)(content, {});
	if(content.locals) module.e = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../css-loader/index.js!./bootstrap-colorpicker.css", function() {
				var newContent = require("!!./../../../css-loader/index.js!./bootstrap-colorpicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(795);
	if(typeof content === 'string') content = [[module.i, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(242)(content, {});
	if(content.locals) module.e = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/sass-loader/index.js!./styles.scss", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/sass-loader/index.js!./styles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(796);
	if(typeof content === 'string') content = [[module.i, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(242)(content, {});
	if(content.locals) module.e = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./google-fonts.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./google-fonts.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(797);
	if(typeof content === 'string') content = [[module.i, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(242)(content, {});
	if(content.locals) module.e = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./katex.min.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./katex.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.e = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1763 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1764 */
1763,
/* 1765 */
1763,
/* 1766 */
1763,
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(629);
	__webpack_require__(627);
	module.e = __webpack_require__(628);


/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map


/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/*** IMPORTS FROM imports-loader ***/
	var $ = __webpack_require__(0);
	var jQuery = __webpack_require__(0);
	
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks whether a prop provides a type of element.
	 *
	 * The type of element can be provided in two forms:
	 * - tag name (string)
	 * - a return value of React.createClass(...)
	 *
	 * @param props
	 * @param propName
	 * @param componentName
	 * @returns {Error|undefined}
	 */
	
	function validate(props, propName, componentName) {
	  var errBeginning = _common.errMsg(props, propName, componentName, '. Expected an Element `type`');
	
	  if (typeof props[propName] !== 'function') {
	    if (_react2['default'].isValidElement(props[propName])) {
	      return new Error(errBeginning + ', not an actual Element');
	    }
	
	    if (typeof props[propName] !== 'string') {
	      return new Error(errBeginning + ' such as a tag name or return value of React.createClass(...)');
	    }
	  }
	}
	
	exports['default'] = _common.createChainableTypeChecker(validate);
	module.e = exports['default'];


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.js
 **/